
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fvYEf", function(module, exports) {
$parcel$export(module.exports, "browseIssueEmbedRouteEntry", () => $31d805b679e7032b$export$e275b3ca0c6ccb5e);

var $gEIw2 = parcelRequire("gEIw2");

var $R5dK3 = parcelRequire("R5dK3");


var $7K5Ea = parcelRequire("7K5Ea");

var $grWOk = parcelRequire("grWOk");

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $dk4qA = parcelRequire("dk4qA");

var $lPVME = parcelRequire("lPVME");

var $9NmsS = parcelRequire("9NmsS");

var $cxQGT = parcelRequire("cxQGT");

var $fk6FR = parcelRequire("fk6FR");

var $ePaI2 = parcelRequire("ePaI2");

var $5nfTh = parcelRequire("5nfTh");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $W6cJS = parcelRequire("W6cJS");

var $jIhkm = parcelRequire("jIhkm");

var $dQc7D = parcelRequire("dQc7D");

var $1FbOO = parcelRequire("1FbOO");

var $38U18 = parcelRequire("38U18");
const $31d805b679e7032b$export$e275b3ca0c6ccb5e = (0, $6xToB.createEntry)((0, $fk6FR.browseIssueEmbedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $38U18.IssueEmbedComponent),
        skeleton: (0, $R5dK3.IssueViewSkeleton),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $9NmsS.getModernIssueTransitionResources)(),
            (0, $lPVME.issueGiraDataResource),
            (0, $dk4qA.issueViewRelayResource),
            (0, $ePaI2.workspaceResource),
            (0, $cxQGT.themePreferenceResource),
            ...(0, $5nfTh.getAIContextPanelResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('magma-3869-jsm-issue-view-sla-panel-fixes'), (0, $W6cJS.getJsmIssueViewSlaPanelResource)()),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('clefairy-12-move-knowledge-base-to-ssr'), (0, $W6cJS.getJsmIssueViewRelatedArticlesResource)()),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $jIhkm.issueCollapsibleGroupDataResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ken-3458-jira-hide-empty-field-ssr-fix'), (0, $dQc7D.issueHideEmptyFieldsDataResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jiv-21223_issue_view_remote_data_query_earlier'), (0, $1FbOO.issueViewRemoteDataResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-3p-attachments'), (0, $gEIw2.thirdPartyConnectedDataSourceResource))
        ],
        forPaint: [
            (0, $38U18.LazyIssuePage)
        ],
        ufoName: 'issue-view-embed',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueEmbedRouteEntry.tsx',
                whichExportToUse: 'browseIssueEmbedRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('jfp-magma-issue-view-embed-hydrate-root')
    }));

});
parcelRegister("gEIw2", function(module, exports) {
$parcel$export(module.exports, "thirdPartyConnectedDataSourceResource", () => $dc74d4fb707b5273$export$59d77c416f392aa8);

var $l1VxS = parcelRequire("l1VxS");

const $dc74d4fb707b5273$var$getDataLoader = ()=>(parcelRequire("hnMLz"));
const $dc74d4fb707b5273$export$59d77c416f392aa8 = (0, $l1VxS.createResource)({
    type: 'ISSUE_VIEW_THIRD_PARTY_CONNECTORS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $dc74d4fb707b5273$var$getDataLoader,
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("hnMLz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("12fs0").then(()=>parcelRequire('i0yfM'));

});


parcelRegister("R5dK3", function(module, exports) {
$parcel$export(module.exports, "IssueViewSkeleton", () => $f52809f20d23afc1$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $biWZb = parcelRequire("biWZb");

var $f2JN3 = parcelRequire("f2JN3");

var $cxKOj = parcelRequire("cxKOj");

var $2nmMZ = parcelRequire("2nmMZ");

var $8gkGI = parcelRequire("8gkGI");
const $f52809f20d23afc1$var$fullpageStyles = null;
const $f52809f20d23afc1$var$modalStyles = null;
const $f52809f20d23afc1$var$customSpacingStyles = null;
/**
 * Renders a placeholder for the Issue View that adapts its layout and styling to different contexts such as embedding or modal presentation, ensuring a consistent user experience during content loading.
 */ const $f52809f20d23afc1$var$IssueViewSkeletonWithRightStatus = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $f52809f20d23afc1$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $f52809f20d23afc1$var$fullpageStyles : null,
        isModalView === true ? $f52809f20d23afc1$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2nmMZ))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};
const $f52809f20d23afc1$var$IssueViewSkeletonWithLeftStatus = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $f52809f20d23afc1$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $f52809f20d23afc1$var$fullpageStyles : null,
        isModalView === true ? $f52809f20d23afc1$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8gkGI))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};
const $f52809f20d23afc1$export$49addbcdecb6e6ff = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('move_status_to_summary_ga', 'isEnabled', false), $f52809f20d23afc1$var$IssueViewSkeletonWithLeftStatus, $f52809f20d23afc1$var$IssueViewSkeletonWithRightStatus);

});
parcelRegister("6umqd", function(module, exports) {
$parcel$export(module.exports, "AppSkeletonImage", () => $6fd9b34505fd2b50$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $ft2u5 = parcelRequire("ft2u5");


var $lRq8t = parcelRequire("lRq8t");

var $kGbze = parcelRequire("kGbze");
const $6fd9b34505fd2b50$var$skeletonImageStyles = null;
const $6fd9b34505fd2b50$export$45b107c5dc7b51a5 = /*#__PURE__*/ (0, $eJOHy.memo)(({ src: src, className: className, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6fd9b34505fd2b50$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage((0, $kGbze.default).loading)}...`,
        className: (0, $hcewu.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ft2u5.FallbackIndicator), null));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6fd9b34505fd2b50$var$SkeletonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ft2u5", function(module, exports) {
$parcel$export(module.exports, "FallbackIndicator", () => $4d192dc9d4a49414$export$e975518239643357);

var $4cTDP = parcelRequire("4cTDP");

var $gg9Go = parcelRequire("gg9Go");

var $7IhkX = parcelRequire("7IhkX");
const $4d192dc9d4a49414$export$e975518239643357 = ({ reportToSlackChannel: reportToSlackChannel, fallbackId: fallbackId, displayErrorInStaging: displayErrorInStaging, isCookieCircuitBreakerFailure: isCookieCircuitBreakerFailure, cookieKey: cookieKey })=>{
    if (false) {
        if (!(0, $7IhkX.getIsTrackingEnabled)()) return null;
        if (displayErrorInStaging && (0, $4cTDP.fg)('staging-only-show-ssr-error')) (0, $gg9Go.pushSSRFailureDisplay)({
            reportToSlackChannel: reportToSlackChannel,
            fallbackId: fallbackId,
            displayErrorInStaging: displayErrorInStaging,
            isCookieCircuitBreakerFailure: isCookieCircuitBreakerFailure,
            cookieKey: cookieKey
        });
    }
    return null;
};

});
parcelRegister("gg9Go", function(module, exports) {
$parcel$export(module.exports, "pushSSRFailureDisplay", () => $c6bf4c0d5dc7eb3f$export$b6724ee8b0fffc36);
$parcel$export(module.exports, "useServerEventsSSRFailureDisplays", () => $c6bf4c0d5dc7eb3f$export$bd8e8aad41319c32);

var $eJOHy = parcelRequire("eJOHy");

var $estLL = parcelRequire("estLL");

var $7q7TE = parcelRequire("7q7TE");
const $c6bf4c0d5dc7eb3f$var$SSR_EVENT = 'ssr-failure-display';
const $c6bf4c0d5dc7eb3f$export$b6724ee8b0fffc36 = (failureProps)=>{
    (0, $estLL.registerEvent)({
        id: $c6bf4c0d5dc7eb3f$var$SSR_EVENT,
        name: 'onSSRFailureDisplay',
        args: [
            failureProps
        ]
    });
};
const $c6bf4c0d5dc7eb3f$export$bd8e8aad41319c32 = ()=>{
    const [ssrFailureDisplays, setSSRFailureDisplays] = (0, $eJOHy.useState)(new Map());
    const onSSRFailureDisplay = (0, $eJOHy.useCallback)((failureProps)=>{
        setSSRFailureDisplays((prev)=>{
            if (failureProps.fallbackId) {
                const newMap = new Map(prev);
                newMap.set(failureProps.fallbackId, failureProps);
                return newMap;
            }
            return prev;
        });
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        (0, $7q7TE.getClientDispatcher)().register($c6bf4c0d5dc7eb3f$var$SSR_EVENT, onSSRFailureDisplay);
        return ()=>{
            (0, $7q7TE.getClientDispatcher)().unregister($c6bf4c0d5dc7eb3f$var$SSR_EVENT);
        };
    }, [
        onSSRFailureDisplay
    ]);
    return ssrFailureDisplays;
};

});

parcelRegister("7IhkX", function(module, exports) {
$parcel$export(module.exports, "markSSRFailure", () => $1afac1ddeaf76cb1$export$d4ee68e1ba090b4a);
$parcel$export(module.exports, "getIsTrackingEnabled", () => $1afac1ddeaf76cb1$export$73c31d93d256d52e);

var $SvJbY = parcelRequire("SvJbY");
let $1afac1ddeaf76cb1$var$ssrFailedMarker = false;
let $1afac1ddeaf76cb1$var$failedMarkers = new Set();
let $1afac1ddeaf76cb1$var$isTrackingEnabled = true;
(0, $SvJbY.autoBeforeEachTest)(()=>{
    $1afac1ddeaf76cb1$var$ssrFailedMarker = false;
    $1afac1ddeaf76cb1$var$failedMarkers = new Set();
    $1afac1ddeaf76cb1$var$isTrackingEnabled = true;
});
const $1afac1ddeaf76cb1$export$d4ee68e1ba090b4a = (fallbackId)=>{
    if (!$1afac1ddeaf76cb1$var$isTrackingEnabled) return;
    $1afac1ddeaf76cb1$var$ssrFailedMarker = true;
    if (fallbackId != null) $1afac1ddeaf76cb1$var$failedMarkers.add(fallbackId);
};
const $1afac1ddeaf76cb1$export$cd0770bef9153db4 = ()=>$1afac1ddeaf76cb1$var$ssrFailedMarker;
const $1afac1ddeaf76cb1$export$72a2677536e2f0c1 = ()=>$1afac1ddeaf76cb1$var$failedMarkers;
const $1afac1ddeaf76cb1$export$73c31d93d256d52e = ()=>$1afac1ddeaf76cb1$var$isTrackingEnabled;
async function $1afac1ddeaf76cb1$export$f655f00ef79cf8a9(cb) {
    try {
        $1afac1ddeaf76cb1$var$isTrackingEnabled = false;
        await cb();
    } finally{
        $1afac1ddeaf76cb1$var$isTrackingEnabled = true;
    }
}

});


parcelRegister("kGbze", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c19230ed94f1839$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8c19230ed94f1839$var$messages = (0, $7qGN1.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});
var $8c19230ed94f1839$export$2e2bcd8739ae039 = $8c19230ed94f1839$var$messages;

});


parcelRegister("biWZb", function(module, exports) {
$parcel$export(module.exports, "CompactModeContext", () => $b77d47f9e4eb67f9$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $b77d47f9e4eb67f9$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $b77d47f9e4eb67f9$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $8BpnG = parcelRequire("8BpnG");

var $gCY1z = parcelRequire("gCY1z");

var $coXKe = parcelRequire("coXKe");

var $cZpx8 = parcelRequire("cZpx8");
const $b77d47f9e4eb67f9$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $b77d47f9e4eb67f9$var$Provider, Consumer: $b77d47f9e4eb67f9$var$Consumer } = $b77d47f9e4eb67f9$export$37eeac5cc5245b18;
const $b77d47f9e4eb67f9$export$55a90a8e865a39b5 = 700;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$b77d47f9e4eb67f9$export$55a90a8e865a39b5}px)`;
const $b77d47f9e4eb67f9$export$ddd398a95f85cd75 = 850;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$b77d47f9e4eb67f9$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $b77d47f9e4eb67f9$var$useRouteKey() {
    const [routeState] = (0, $gCY1z.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $b77d47f9e4eb67f9$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $b77d47f9e4eb67f9$var$useRouteKey();
    (0, $cZpx8.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $cZpx8.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4);
        (0, $cZpx8.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $eJOHy.useState)(defaultState);
    const onChange = (0, $eJOHy.useCallback)((state)=>{
        (0, $cZpx8.setCachedIsCompactValue)(state, key);
        setIsCompact(state);
    }, [
        key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BpnG.ContainerQueryObserver), {
        query: query,
        onChange: onChange,
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$Provider, {
        value: isCompact
    }, children));
};
const $b77d47f9e4eb67f9$export$20feb77b5b617e44 = $b77d47f9e4eb67f9$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77d47f9e4eb67f9$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $548198843509795c$export$ee15e0cd1efafcb4 = false;

parcelRegister("8BpnG", function(module, exports) {
$parcel$export(module.exports, "ContainerQueryObserver", () => $b45aeffccc0e4b84$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $EzBXZ = parcelRequire("EzBXZ");

var $4cTDP = parcelRequire("4cTDP");

const $b45aeffccc0e4b84$var$QueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
let $b45aeffccc0e4b84$var$currentIdSeed = 0;
function $b45aeffccc0e4b84$var$generateAttributeValue() {
    return `indicator-span-${$b45aeffccc0e4b84$var$currentIdSeed++}`;
}
function $b45aeffccc0e4b84$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eJOHy.useState)(defaultState);
    const handleQueryStatusChange = (0, $eJOHy.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$QueryContext.Provider, {
        value: active
    }, !(0, $4cTDP.fg)('jfp-magma-nav-and-issue-view-misc-hydration-fixes') && !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), (0, $4cTDP.fg)('jfp-magma-nav-and-issue-view-misc-hydration-fixes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    })), children);
}
function $b45aeffccc0e4b84$export$b66a67697973e01() {
    const currentState = (0, $eJOHy.useContext)($b45aeffccc0e4b84$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $b45aeffccc0e4b84$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eJOHy.useMemo)(()=>$b45aeffccc0e4b84$var$generateAttributeValue(), []);
    const spanRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    const currentState = $b45aeffccc0e4b84$export$b66a67697973e01();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b45aeffccc0e4b84$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("EzBXZ", function(module, exports) {
$parcel$export(module.exports, "RenderOnClient", () => $8d2b8b6c60c3fc0f$export$f7ced6922b75ec11);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");

var $cSOX1 = parcelRequire("cSOX1");
const $8d2b8b6c60c3fc0f$var$RenderOnClientOld = ({ children: children, fg: featureGateName })=>{
    const isClientReady = (0, $cSOX1.useIsClientReady)();
    // eslint-disable-next-line jira/ff/static-feature-flags
    if (featureGateName && !(0, $4cTDP.fg)(featureGateName)) return children;
    if (isClientReady) return children;
    return null;
};
const $8d2b8b6c60c3fc0f$var$RenderWhenReady = ({ children: children })=>{
    const isClientReady = (0, $cSOX1.useIsClientReady)();
    if (isClientReady) return children;
    return null;
};
const $8d2b8b6c60c3fc0f$var$RenderOnClientNew = ({ children: children, fg: featureGateName })=>{
    // eslint-disable-next-line jira/ff/static-feature-flags
    if (featureGateName && !(0, $4cTDP.fg)(featureGateName)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8d2b8b6c60c3fc0f$var$RenderWhenReady, null, children);
};
const $8d2b8b6c60c3fc0f$export$f7ced6922b75ec11 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('fix-render-on-client-remount'), $8d2b8b6c60c3fc0f$var$RenderOnClientNew, $8d2b8b6c60c3fc0f$var$RenderOnClientOld);

});
parcelRegister("cSOX1", function(module, exports) {
$parcel$export(module.exports, "useIsClientReadyNew", () => $ee41adecc45b8369$export$d33e490ee4d9029);
$parcel$export(module.exports, "useIsClientReady", () => $ee41adecc45b8369$export$d2ab98824add97fa);
// eslint-disable-next-line jira/restricted/react-18

var $eJOHy = parcelRequire("eJOHy");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");
const $ee41adecc45b8369$export$53e22d62a7806b64 = ()=>{
    const [ready, setReady] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        (0, $eJOHy.startTransition)(()=>setReady(true));
    }, []);
    return ready;
};
const $ee41adecc45b8369$export$d33e490ee4d9029 = ()=>(0, $eJOHy.useSyncExternalStore)(()=>()=>{
        // empty
        }, ()=>true, ()=>false);
const $ee41adecc45b8369$export$d2ab98824add97fa = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-4013-fix-hydration-edition-awareness'), $ee41adecc45b8369$export$d33e490ee4d9029, $ee41adecc45b8369$export$53e22d62a7806b64);

});



parcelRegister("coXKe", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $pz0Wh = parcelRequire("pz0Wh");

var $kfvK2 = parcelRequire("kfvK2");

var $cxKOj = parcelRequire("cxKOj");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");

var $1M2hR = parcelRequire("1M2hR");


var $bNexr = parcelRequire("bNexr");

var $4cTDP = parcelRequire("4cTDP");

var $FhXEJ = parcelRequire("FhXEJ");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$var$Tabs = {
    Description: 'description',
    WorkItems: 'workItems',
    Resources: 'resources',
    Integrations: 'integrations'
};
const $3b984a26137eed7b$var$defaultActiveTab = $3b984a26137eed7b$var$Tabs.Description;
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ]);
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    const locale = (0, $1M2hR.useLocale)();
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            userPreferredLayout: userPreferredLayout,
            locale: locale,
            isInWideLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        // eslint-disable-next-line react-hooks/react-compiler
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};
/**
 * useRouteToGetQueryParams hook
 * This hook retrieves the current query parameters from the router state.
 * It is used to access the active tab and other query parameters in the issue view layout.
 */ const $3b984a26137eed7b$var$useRouteToGetQueryParams = (0, $kfvK2.createRouterSelector)((state)=>{
    return state.query;
});
const $3b984a26137eed7b$export$b027791af8c9b114 = ()=>{
    const { activeTab: activeTab = $3b984a26137eed7b$var$defaultActiveTab, ...otherQueryParams } = $3b984a26137eed7b$var$useRouteToGetQueryParams();
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const setActiveTab = (0, $eJOHy.useCallback)((tab)=>{
        if (activeTab !== tab) updateQueryParam({
            ...otherQueryParams,
            activeTab: tab
        }, 'replace');
    }, [
        activeTab,
        otherQueryParams,
        updateQueryParam
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            setDescriptionAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Description),
            setWorkItemsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.WorkItems),
            setIntegrationsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Integrations),
            setResourcesAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Resources),
            currentActiveTab: activeTab
        }), [
        activeTab,
        setActiveTab
    ]);
};

});
parcelRegister("pz0Wh", function(module, exports) {
$parcel$export(module.exports, "useEnabledHiddenFields", () => $437c493a8e065bc6$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $i7n3g = parcelRequire("i7n3g");

var $4Swsy = parcelRequire("4Swsy");
const $437c493a8e065bc6$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $4Swsy.useHiddenFields));
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const hiddenFields = (0, $4Swsy.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("i7n3g", function(module, exports) {
$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("4Swsy", function(module, exports) {
$parcel$export(module.exports, "useHiddenFields", () => $8e2f20b0b0e23b91$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $8e2f20b0b0e23b91$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8e2f20b0b0e23b91$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: $8e2f20b0b0e23b91$var$selectHiddenFields
});

});
parcelRegister("ixrOr", function(module, exports) {
$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
parcelRegister("jFHCE", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $2yYrH = parcelRequire("2yYrH");

var $4qFnH = parcelRequire("4qFnH");

var $inlCv = parcelRequire("inlCv");

var $9Zabf = parcelRequire("9Zabf");

var $3w8z0 = parcelRequire("3w8z0");

var $lgI96 = parcelRequire("lgI96");

var $a5UJr = parcelRequire("a5UJr");
/** Used to compose bitmasks for cloning. */ var $e523af2690bc0ff7$var$CLONE_DEEP_FLAG = 1, $e523af2690bc0ff7$var$CLONE_FLAT_FLAG = 2, $e523af2690bc0ff7$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $e523af2690bc0ff7$var$omit = $lgI96(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $lylkU(paths, function(path) {
        path = $inlCv(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $9Zabf(object, $a5UJr(object), result);
    if (isDeep) result = $2yYrH(result, $e523af2690bc0ff7$var$CLONE_DEEP_FLAG | $e523af2690bc0ff7$var$CLONE_FLAT_FLAG | $e523af2690bc0ff7$var$CLONE_SYMBOLS_FLAG, $3w8z0);
    var length = paths.length;
    while(length--)$4qFnH(result, paths[length]);
    return result;
});
module.exports = $e523af2690bc0ff7$var$omit;

});
parcelRegister("4qFnH", function(module, exports) {

var $inlCv = parcelRequire("inlCv");

var $1ilzu = parcelRequire("1ilzu");

var $cbuUm = parcelRequire("cbuUm");

var $9IlW0 = parcelRequire("9IlW0");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3399b090996478d5$var$baseUnset(object, path) {
    path = $inlCv(path, object);
    object = $cbuUm(object, path);
    return object == null || delete object[$9IlW0($1ilzu(path))];
}
module.exports = $3399b090996478d5$var$baseUnset;

});
parcelRegister("cbuUm", function(module, exports) {

var $5BbSa = parcelRequire("5BbSa");

var $1FqKq = parcelRequire("1FqKq");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $8dee7cd279693843$var$parent(object, path) {
    return path.length < 2 ? object : $5BbSa(object, $1FqKq(path, 0, -1));
}
module.exports = $8dee7cd279693843$var$parent;

});


parcelRegister("3w8z0", function(module, exports) {

var $dtLJW = parcelRequire("dtLJW");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $28fb00d591f4ccb5$var$customOmitClone(value) {
    return $dtLJW(value) ? undefined : value;
}
module.exports = $28fb00d591f4ccb5$var$customOmitClone;

});

parcelRegister("lgI96", function(module, exports) {

var $aX8Tx = parcelRequire("aX8Tx");

var $cMrjq = parcelRequire("cMrjq");

var $hC3zk = parcelRequire("hC3zk");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $f7bd5604b58f6516$var$flatRest(func) {
    return $hC3zk($cMrjq(func, undefined, $aX8Tx), func + '');
}
module.exports = $f7bd5604b58f6516$var$flatRest;

});


const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {
$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("hUz0e", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $6PplZ = parcelRequire("6PplZ");

var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2],
                [(0, $7f80bdb4337734ff$export$e10d4d251d909c59)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$e10d4d251d909c59]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $6PplZ.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("6PplZ", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $520d86b9433cc3c6$export$4027d961191df7c3);

var $eGOwo = parcelRequire("eGOwo");
function $520d86b9433cc3c6$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $eGOwo.fg)('ditto_uim_new_attributes_for_uim_use_submit') && fieldsChanges && lastProcessedChange?.changeId === changeId) {
        const fid = lastProcessedChange?.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("81O8J", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);

var $eGOwo = parcelRequire("eGOwo");
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if ((0, $eGOwo.fg)('ditto_uim_error_cb_screen_tabs')) screenTabsFromApp.forEach((tab)=>{
        if (!$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("cxKOj", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $189bfb6907dea0e1$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $189bfb6907dea0e1$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $189bfb6907dea0e1$export$677f9fa2e1ae6fec);
/* eslint-disable max-classes-per-file */ 
var $59rsN = parcelRequire("59rsN");
var $aAoU5 = parcelRequire("aAoU5");

var $4iJGP = parcelRequire("4iJGP");

var $11lp0 = parcelRequire("11lp0");

var $es5G8 = parcelRequire("es5G8");
class $189bfb6907dea0e1$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // 1 - checkIfExperimentExists
            // 2 - a caller
            this.stack = [
                ...stackLines.slice(2)
            ].join('\n');
        }
    }
}
const $189bfb6907dea0e1$var$checkedExperiments = new Set();
const $189bfb6907dea0e1$var$checkIfExperimentExists = (experimentName)=>{
    // perform early exist to minimize performance impact
    if ($189bfb6907dea0e1$var$checkedExperiments.has(experimentName)) return;
    $189bfb6907dea0e1$var$checkedExperiments.add(experimentName);
    if ((0, $59rsN.default).checkGate('jfp_magma_jira-report-incorrect-experiments', {
        fireGateExposure: false
    })) {
        if (!(0, $59rsN.default).isExperimentExists(experimentName)) {
            const error = new $189bfb6907dea0e1$var$ErrorPointingUp(`Experiment ${experimentName} does not exist`);
            (0, $es5G8.captureException)('FeatureGates.isExperimentExists', error);
            // eslint-disable-next-line no-console
            console.error(`Experiment ${experimentName} does not exist`);
        }
    }
};
function $189bfb6907dea0e1$var$readExpVal(experimentName, param, defaultValue) {
    if (false) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const globalVar = typeof window !== 'undefined' ? window : globalThis;
        /**
		 * These overrides are set by the server-side code in jira/src/entry-fs
		 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.configs?.[experimentName]?.[param] !== undefined) {
            const value = globalVar.__SSR_STATSIG_OVERRIDES__.configs[experimentName][param];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return value;
        }
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allExpValTrue) {
            if (param === 'isEnabled' && typeof defaultValue === 'boolean') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return true;
        }
        if (typeof globalVar.__SSR_SYNC_READ_EXP_VAL__ === 'function' && // if global variable is ready, then don't reach out to native
        // API, stay within js runtime is faster
        !globalVar._statsigValuesReady) try {
            const value = globalVar.__SSR_SYNC_READ_EXP_VAL__(experimentName, param, defaultValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return value;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(JSON.stringify({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                message: error.message,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                stack: error.stack
            }));
        }
    }
    // Handle vendorless scripts use of gates
    (0, $11lp0.UNSAFE_initIfNeeded)();
    const value = (0, $59rsN.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $4iJGP.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $189bfb6907dea0e1$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    const experiment = $189bfb6907dea0e1$var$readExpVal(experimentName, param, defaultValue);
    $189bfb6907dea0e1$var$checkIfExperimentExists(experimentName);
    return experiment;
}
function $189bfb6907dea0e1$export$45abdb3f977b5b14(experimentName, param, comparatorValue, defaultValue = null) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (false) {
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allExpValTrue) return defaultValue !== comparatorValue;
    }
    const experiment = $189bfb6907dea0e1$var$readExpVal(experimentName, param, defaultValue);
    $189bfb6907dea0e1$var$checkIfExperimentExists(experimentName);
    return experiment === comparatorValue;
}
class $189bfb6907dea0e1$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
            const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $4iJGP.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, overrideValue);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $4iJGP.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
const $189bfb6907dea0e1$var$cache = new Map();
function $189bfb6907dea0e1$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $189bfb6907dea0e1$var$cache.get(experimentName);
    const fireExposure = ()=>(0, $59rsN.default).manuallyLogExperimentExposure(experimentName);
    if (instance == null) {
        if (false) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const globalVar = typeof window !== 'undefined' ? window : globalThis;
            if (typeof globalVar.__SSR_SYNC_DYNAMIC_CONFIG_VALUE__ === 'function' && // if global variable is ready, then don't reach out to native
            // API, stay within js runtime is faster
            !globalVar._statsigValuesReady) // Handle vendorless scripts use of gates
            try {
                const config = globalVar.__SSR_SYNC_DYNAMIC_CONFIG_VALUE__(experimentName);
                if (typeof config !== 'undefined') {
                    config.get = (key)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        const value = config.value[key];
                        return value;
                    };
                    instance = [
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        new $189bfb6907dea0e1$var$ExperimentConfig(experimentName, (0, $aAoU5.DynamicConfig).fromExperiment(config)),
                        fireExposure
                    ];
                    $189bfb6907dea0e1$var$cache.set(experimentName, instance);
                    return instance;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(JSON.stringify({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    message: error.message,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    stack: error.stack
                }));
            }
        }
        (0, $11lp0.UNSAFE_initIfNeeded)();
        const config = (0, $59rsN.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        instance = [
            new $189bfb6907dea0e1$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $189bfb6907dea0e1$var$cache.set(experimentName, instance);
    }
    return instance;
}

});

parcelRegister("cs58I", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    // As part of an experiment (jiv-21227_dev_panel_collapsibility_exp) we are introducing collapsibility to the dev panel
    // However, we need to iterate on the backend change that would see the userPreference for our collapsed state of the dev panel
    // come through Relay/Agg.
    // This fetchUserPreferenceValue is a temporary measure to be able to run our initial experiment - if successful, we will remove the below and implement the backend change
    // Please don't use this for anything else except this experiment. Reach out to https://atlassian.enterprise.slack.com/archives/C093S7Q436E
    // Please see the JIRA ticket https://jplat.atlassian.net/browse/JIV-21315 for more details.
    const fetchValue = (0, $eJOHy.useCallback)(async ()=>{
        try {
            if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
                const serverValue = await (0, $etbP7.fetchUserPreferenceValue)(userPreferenceKey);
                if (serverValue !== null) {
                    const parsedValue = typeof serverValue === 'string' ? JSON.parse(serverValue) : serverValue;
                    setUserPreferenceValue(userPreferenceKey, parsedValue);
                    return parsedValue;
                }
            }
            return null;
        } catch (error) {
            return null;
        }
    }, [
        userPreferenceKey,
        setUserPreferenceValue
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue,
            fetchValue: fetchValue
        }), [
        setValue,
        deleteValue,
        fetchValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$var$store = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {
$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$var$getUserPreferenceValue = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$var$getUserPreferenceValue
};

});


parcelRegister("etbP7", function(module, exports) {
$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "fetchUserPreferenceValue", () => $a9cf1c440643deff$export$a3e5f8cedb0374ad);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $keOPi = parcelRequire("keOPi");

var $cxKOj = parcelRequire("cxKOj");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    }, 'user-preferences-services/src/utils');
const $a9cf1c440643deff$export$a3e5f8cedb0374ad = async (userPreferenceKey)=>{
    try {
        if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
            const response = await (0, $keOPi.performIssueGetRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');
            return response;
        }
        return null;
    } catch (error) {
        // If the preference doesn't exist, return null
        return null;
    }
};
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $keOPi.performIssueDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');

});
parcelRegister("keOPi", function(module, exports) {
$parcel$export(module.exports, "performIssuePostRequest", () => $1d9dfe6a518cff33$export$f0d7c3d034d5811a);
$parcel$export(module.exports, "performIssuePutRequest", () => $1d9dfe6a518cff33$export$2167f099a5e216f1);
$parcel$export(module.exports, "performIssueDeleteRequest", () => $1d9dfe6a518cff33$export$cf3e603eb3bc78ab);
$parcel$export(module.exports, "performIssueGetRequest", () => $1d9dfe6a518cff33$export$36671e08961872af);
// Stryker disable all

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $biGll = parcelRequire("biGll");
const $1d9dfe6a518cff33$export$f0d7c3d034d5811a = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPostRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPostRequest)(url, options);
};
const $1d9dfe6a518cff33$export$2167f099a5e216f1 = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPutRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPutRequest)(url, options);
};
const $1d9dfe6a518cff33$export$cf3e603eb3bc78ab = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performDeleteRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performDeleteRequest)(url, options);
};
const $1d9dfe6a518cff33$export$36671e08961872af = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performGetRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performGetRequest)(url, options);
};

});
parcelRegister("3ugTQ", function(module, exports) {
$parcel$export(module.exports, "transformValidationErrorFromServer", () => $ad3305255e45a41f$export$8e9baed7697e4959);
$parcel$export(module.exports, "withErrorHandling", () => $ad3305255e45a41f$export$c874c20f7c9f97c);
$parcel$export(module.exports, "handleErrors", () => $ad3305255e45a41f$export$1e36de371b2e3d5a);
$parcel$export(module.exports, "handleNetworkErrors", () => $ad3305255e45a41f$export$b47ad9bdf9122b88);
$parcel$export(module.exports, "applyErrorHandling", () => $ad3305255e45a41f$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $ad3305255e45a41f$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $ad3305255e45a41f$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $ad3305255e45a41f$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $ad3305255e45a41f$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $ad3305255e45a41f$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $ad3305255e45a41f$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $ad3305255e45a41f$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $ad3305255e45a41f$export$a5717cbee13f28b7);
// Stryker disable all


var $7oY9g = parcelRequire("7oY9g");

var $8ZO5s = parcelRequire("8ZO5s");

var $eBhI6 = parcelRequire("eBhI6");

var $14RSn = parcelRequire("14RSn");

var $gUVFX = parcelRequire("gUVFX");

var $kinkG = parcelRequire("kinkG");

var $9lsFL = parcelRequire("9lsFL");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ad3305255e45a41f$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $ad3305255e45a41f$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $ad3305255e45a41f$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $14RSn.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $ad3305255e45a41f$var$putOptions = {
    ...(0, $eBhI6.defaultOptions),
    method: 'PUT'
};
const $ad3305255e45a41f$var$postOptions = {
    ...(0, $eBhI6.defaultOptions),
    method: 'POST'
};
const $ad3305255e45a41f$var$deleteOptions = {
    ...(0, $eBhI6.defaultOptions),
    method: 'DELETE'
};
const $ad3305255e45a41f$var$patchOptions = {
    ...(0, $eBhI6.defaultOptions),
    method: 'PATCH'
};
function $ad3305255e45a41f$export$c874c20f7c9f97c(source) {
    return source.then($ad3305255e45a41f$export$1e36de371b2e3d5a).catch($ad3305255e45a41f$export$b47ad9bdf9122b88);
}
const $ad3305255e45a41f$export$b47ad9bdf9122b88 = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $ad3305255e45a41f$export$1e36de371b2e3d5a = (response)=>{
    const traceId = (0, $9lsFL.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $3a153a61cf6b691b$export$9de493bcd9b1d977) === response.status || (0, $3a153a61cf6b691b$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $ad3305255e45a41f$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $14RSn.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $14RSn.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ad3305255e45a41f$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $3a153a61cf6b691b$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $ad3305255e45a41f$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($ad3305255e45a41f$export$1e36de371b2e3d5a).then($ad3305255e45a41f$var$processResponseFromServer).catch($ad3305255e45a41f$export$b47ad9bdf9122b88);
const $ad3305255e45a41f$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$ad3305255e45a41f$export$e174dc943a170ff(fetch((0, $gUVFX.getReroutableURL)(url), (0, $kinkG.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $7oY9g.default)('platform_fetch_retries')) return executeRequest();
    return (0, $8ZO5s.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $ad3305255e45a41f$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $gUVFX.getReroutableURL)(url), (0, $kinkG.applyObservabilityHeaders)(url, {
        ...(0, $eBhI6.defaultOptions),
        ...options
    })).then($ad3305255e45a41f$export$1e36de371b2e3d5a).then($ad3305255e45a41f$var$processResponseFromServer).catch($ad3305255e45a41f$export$b47ad9bdf9122b88);
const $ad3305255e45a41f$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $gUVFX.getReroutableURL)(url), (0, $kinkG.applyObservabilityHeaders)(url, {
        ...$ad3305255e45a41f$var$putOptions,
        ...options
    })).then($ad3305255e45a41f$export$1e36de371b2e3d5a).then($ad3305255e45a41f$var$processResponseFromServer).catch($ad3305255e45a41f$export$b47ad9bdf9122b88);
const $ad3305255e45a41f$export$692a4d9808143175 = (url, options = {})=>fetch((0, $gUVFX.getReroutableURL)(url), (0, $kinkG.applyObservabilityHeaders)(url, {
        ...$ad3305255e45a41f$var$postOptions,
        ...options
    })).then($ad3305255e45a41f$export$1e36de371b2e3d5a).then($ad3305255e45a41f$var$processResponseFromServer).catch($ad3305255e45a41f$export$b47ad9bdf9122b88);
const $ad3305255e45a41f$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $gUVFX.getReroutableURL)(url), (0, $kinkG.applyObservabilityHeaders)(url, {
        ...$ad3305255e45a41f$var$deleteOptions,
        ...options
    })).then($ad3305255e45a41f$export$1e36de371b2e3d5a).then($ad3305255e45a41f$var$processResponseFromServer).catch($ad3305255e45a41f$export$b47ad9bdf9122b88);
const $ad3305255e45a41f$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $gUVFX.getReroutableURL)(url), (0, $kinkG.applyObservabilityHeaders)(url, {
        ...$ad3305255e45a41f$var$patchOptions,
        ...options
    })).then($ad3305255e45a41f$export$1e36de371b2e3d5a).then($ad3305255e45a41f$var$processResponseFromServer).catch($ad3305255e45a41f$export$b47ad9bdf9122b88);
const $ad3305255e45a41f$export$659b5ee69e6eb976 = (url, options)=>$ad3305255e45a41f$export$22411cbfb09a5c5c(url, {
        ...(0, $eBhI6.defaultOptions),
        ...options
    });
const $ad3305255e45a41f$export$d7b48b2904a5d812 = (url, options)=>$ad3305255e45a41f$export$22411cbfb09a5c5c(url, {
        ...$ad3305255e45a41f$var$putOptions,
        ...options
    });
const $ad3305255e45a41f$export$a5717cbee13f28b7 = (url, options)=>$ad3305255e45a41f$export$22411cbfb09a5c5c(url, {
        ...$ad3305255e45a41f$var$postOptions,
        ...options
    });
const $ad3305255e45a41f$export$6d01bf1146815b9b = (url, options)=>$ad3305255e45a41f$export$22411cbfb09a5c5c(url, {
        ...$ad3305255e45a41f$var$deleteOptions,
        ...options
    });
const $ad3305255e45a41f$export$560989ee94ad2a20 = (url, options)=>$ad3305255e45a41f$export$22411cbfb09a5c5c(url, {
        ...$ad3305255e45a41f$var$patchOptions,
        ...options
    }); /* eslint-enable @typescript-eslint/no-unnecessary-type-constraint */ 

});
const $3a153a61cf6b691b$export$ff39ebd4bb12b718 = 201;
const $3a153a61cf6b691b$export$3288b14b6745c572 = 204;
const $3a153a61cf6b691b$export$9de493bcd9b1d977 = 400;
const $3a153a61cf6b691b$export$67d19e9a991baa07 = 401;
const $3a153a61cf6b691b$export$a3269a3914b007e3 = 403;
const $3a153a61cf6b691b$export$8bca792d963eb0ef = 404;
const $3a153a61cf6b691b$export$4a3cb39801694eee = 407;
const $3a153a61cf6b691b$export$fa405bbf47d510e2 = 408;
const $3a153a61cf6b691b$export$c09e7ea0fc79f34f = 409;
const $3a153a61cf6b691b$export$5244030134e99 = 412;
const $3a153a61cf6b691b$export$f90ac1df0b60853d = 413;
const $3a153a61cf6b691b$export$a447d0a965e16776 = 422;
const $3a153a61cf6b691b$export$3b48aba8957000cd = 426;
const $3a153a61cf6b691b$export$6763168a631449a2 = 429;
const $3a153a61cf6b691b$export$e813cd7045fcc98d = 500;
const $3a153a61cf6b691b$export$2ce38d41a306034e = 502;
const $3a153a61cf6b691b$export$974c37534b0191b1 = 503;
const $3a153a61cf6b691b$export$5400e8dddac3fcf3 = 504;

parcelRegister("gUVFX", function(module, exports) {
$parcel$export(module.exports, "getReroutableURL", () => $459cd67bc62ac941$export$23769875e8eebaf6);

var $3yHSu = parcelRequire("3yHSu");
function $459cd67bc62ac941$export$23769875e8eebaf6(pathOrURL) {
    // For local development environment only, otherwise removed during the bundling process
    if (false ? globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT ?? false : false) try {
        const localUrl = new URL((0, $3yHSu.getLocalUrl)());
        const u = new URL(pathOrURL, localUrl.href);
        u.host = localUrl.host;
        u.protocol = localUrl.protocol;
        return u.href;
    } catch (e) {
        // When the URL constructor has `base` set, and `pathOrUrl` is always a string,
        // no string can trigger this catch block.
        // Just in case, log the error to help with debugging.
        // eslint-disable-next-line no-console
        console.error('Failed to parse URL: ', pathOrURL, e);
    }
    return pathOrURL;
}

});
parcelRegister("3yHSu", function(module, exports) {
$parcel$export(module.exports, "getLocalUrl", () => $a1b3fe14d407baa8$export$e049a61beee18f8c);
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ function $a1b3fe14d407baa8$var$getDevHostname() {
    const envDns = false ? globalThis.localDevContext?.RDE_DNS ?? undefined : undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
}
function $a1b3fe14d407baa8$var$getProxyServerPort() {
    const serverPort = false ? globalThis.localDevContext?.__PILLAR_PROXY_SERVER_PORT ?? undefined : undefined;
    return serverPort ? parseInt(serverPort, 10) : 9000;
}
function $a1b3fe14d407baa8$export$e049a61beee18f8c() {
    if (false) {
        const overridden = globalThis.localDevContext?.LOCAL_URL_OVERRIDE;
        return overridden ?? `${globalThis.localDevContext?.__PILLAR_ENABLE_HTTPS ?? false ? 'https' : 'http'}://${$a1b3fe14d407baa8$var$getDevHostname()}:${$a1b3fe14d407baa8$var$getProxyServerPort()}`;
    }
    return `${'http'}://${$a1b3fe14d407baa8$var$getDevHostname()}:${$a1b3fe14d407baa8$var$getProxyServerPort()}`;
}

});


parcelRegister("9lsFL", function(module, exports) {
$parcel$export(module.exports, "getTraceId", () => $a62779e69168d889$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $a62779e69168d889$export$b569b31eebca952d);

var $iMEaK = parcelRequire("iMEaK");
const $a62779e69168d889$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $iMEaK.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $a62779e69168d889$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $iMEaK.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("iMEaK", function(module, exports) {
$parcel$export(module.exports, "TRACE_ID_HEADER", () => $efa8e9f21a0d7efe$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $efa8e9f21a0d7efe$export$830a89e935012abe);
const $efa8e9f21a0d7efe$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $efa8e9f21a0d7efe$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $efa8e9f21a0d7efe$export$830a89e935012abe = [
    $efa8e9f21a0d7efe$export$4b69438fb7c7b9b2,
    $efa8e9f21a0d7efe$var$TRACE_ID_HEADER_MICROS
];

});



parcelRegister("biGll", function(module, exports) {
$parcel$export(module.exports, "performIssueRequest", () => $00dfaa7a2eaf401f$export$2fba6590b0f30cb2);
// Stryker disable all

var $3ibpe = parcelRequire("3ibpe");

var $14RSn = parcelRequire("14RSn");
const $00dfaa7a2eaf401f$var$isGiraUrl = (url)=>url.startsWith('/rest/gira/1/');
const $00dfaa7a2eaf401f$export$2fba6590b0f30cb2 = async (requestFn, url, options = {}, path = 'unknown')=>{
    const defaultExperienceDescription = {
        experience: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issueGira' : 'issueRest',
        analyticsSource: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issue-gira' : 'issue-rest',
        application: null,
        edition: null
    };
    try {
        const response = await requestFn(url, options);
        return response;
    } catch (error) {
        let traceId;
        let statusCode;
        let errorMessage;
        if (error instanceof Error || error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError) || error instanceof TypeError) errorMessage = error.message;
        if (error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError)) {
            traceId = error.traceId;
            statusCode = error.statusCode;
        }
        const additionalAttributes = {
            statusCode: statusCode || 0,
            errorMessage: errorMessage || 'unknown',
            traceId: traceId || 'unknown',
            path: path
        };
        if (statusCode && statusCode >= 400 && statusCode < 500 || error instanceof Error && error.cause instanceof TypeError) {
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: 'taskAbort',
                additionalAttributes: additionalAttributes
            });
            throw error;
        }
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskFail',
            additionalAttributes: additionalAttributes
        });
        throw error;
    }
};

});
parcelRegister("3ibpe", function(module, exports) {
$parcel$export(module.exports, "sendExperienceAnalytics", () => $b05a2baea0c3ab19$export$4a95ada1b8228562);

var $1O6Yz = parcelRequire("1O6Yz");

var $4iJGP = parcelRequire("4iJGP");

var $mjinE = parcelRequire("mjinE");

var $hWeHP = parcelRequire("hWeHP");
const $b05a2baea0c3ab19$var$isSynthetic = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true';
function $b05a2baea0c3ab19$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $hWeHP.default)('ajs-shard');
    const region = (0, $hWeHP.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $4iJGP.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    const synthetics = {
        additionalAttributes: {
            synthetic: $b05a2baea0c3ab19$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(experienceDescription, synthetics);
    (0, $mjinE.default)(experienceDescription);
}

});
parcelRegister("mjinE", function(module, exports) {
$parcel$export(module.exports, "transformApplication", () => $65ee89f955c9da99$export$3b420a9303671264);
$parcel$export(module.exports, "transformEdition", () => $65ee89f955c9da99$export$ead6d3a398a3f5bd);
$parcel$export(module.exports, "default", () => $65ee89f955c9da99$export$2e2bcd8739ae039);

var $hWeHP = parcelRequire("hWeHP");

var $2Mqjh = parcelRequire("2Mqjh");

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");
const $65ee89f955c9da99$export$3b420a9303671264 = (application)=>{
    switch(application){
        case 0, $lBYgs.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $lBYgs.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $lBYgs.JIRA_CORE:
            return 'jira-core';
        case 0, $lBYgs.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $lBYgs.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $65ee89f955c9da99$export$ead6d3a398a3f5bd = (edition)=>{
    switch(edition){
        case 0, $cblKs.FREE_EDITION:
            return 'jedi';
        case 0, $cblKs.STANDARD_EDITION:
            return 'standard';
        case 0, $cblKs.PREMIUM_EDITION:
            return 'premium';
        case 0, $cblKs.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $65ee89f955c9da99$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $65ee89f955c9da99$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $65ee89f955c9da99$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            ...location ? {
                reason: location
            } : {},
            ...field ? {
                field: field
            } : {},
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $65ee89f955c9da99$export$3b420a9303671264(application),
            edition: $65ee89f955c9da99$export$ead6d3a398a3f5bd(edition),
            ...!false ? {
                shard: (0, $hWeHP.default)('ajs-shard') || '',
                region: (0, $hWeHP.default)('ajs-region') || ''
            } : {}
        }
    });
/**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ const $65ee89f955c9da99$var$sendExperienceAnalytics = (experienceDescription)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $65ee89f955c9da99$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
var $65ee89f955c9da99$export$2e2bcd8739ae039 = $65ee89f955c9da99$var$sendExperienceAnalytics;

});






parcelRegister("bmoS1", function(module, exports) {
$parcel$export(module.exports, "useChildIssuesLimit", () => $7e10397d24adf8a0$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e10397d24adf8a0$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e10397d24adf8a0$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e10397d24adf8a0$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e10397d24adf8a0$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e10397d24adf8a0$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e10397d24adf8a0$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e10397d24adf8a0$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e10397d24adf8a0$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e10397d24adf8a0$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e10397d24adf8a0$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e10397d24adf8a0$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e10397d24adf8a0$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e10397d24adf8a0$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e10397d24adf8a0$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useBoardId", () => $7e10397d24adf8a0$export$b49754504c41149f);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e10397d24adf8a0$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e10397d24adf8a0$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e10397d24adf8a0$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e10397d24adf8a0$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e10397d24adf8a0$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e10397d24adf8a0$export$4596c26005fbb859);
$parcel$export(module.exports, "useGetAiFeaturesOnboarding", () => $7e10397d24adf8a0$export$e998111e82af7f08);
$parcel$export(module.exports, "useIsAiEnabledForIssue", () => $7e10397d24adf8a0$export$db5174c7538abe4b);
$parcel$export(module.exports, "useIsJiraIssue", () => $7e10397d24adf8a0$export$cf5fc815f761fb4b);
$parcel$export(module.exports, "useShouldUseRelayIssueComments", () => $7e10397d24adf8a0$export$48cf678fcbd4605);
$parcel$export(module.exports, "useShouldUseRelayIssueHistory", () => $7e10397d24adf8a0$export$5d1eb8193b85a593);
$parcel$export(module.exports, "useShouldUseRelayIssueAllActivity", () => $7e10397d24adf8a0$export$9db14d7d93db3988);

var $eJOHy = parcelRequire("eJOHy");

var $5KtrL = parcelRequire("5KtrL");


var $FhXEJ = parcelRequire("FhXEJ");

var $aYncF = parcelRequire("aYncF");

var $bNexr = parcelRequire("bNexr");

var $e6s1C = parcelRequire("e6s1C");

var $1Ru5V = parcelRequire("1Ru5V");

var $4cTDP = parcelRequire("4cTDP");

var $U4tkh = parcelRequire("U4tkh");
const $7e10397d24adf8a0$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $U4tkh.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e10397d24adf8a0$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $U4tkh.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e10397d24adf8a0$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e10397d24adf8a0$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e10397d24adf8a0$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $U4tkh.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e10397d24adf8a0$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $U4tkh.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e10397d24adf8a0$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $U4tkh.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e10397d24adf8a0$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $U4tkh.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e10397d24adf8a0$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $U4tkh.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e10397d24adf8a0$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $U4tkh.useIssueContextStoreIssueKey)();
    return issueKey.split('-')[0];
};
const $7e10397d24adf8a0$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $U4tkh.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e10397d24adf8a0$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView, setAiFeaturesOnboardingSpotlight: setAiFeaturesOnboardingSpotlight }] = (0, $U4tkh.useIssueContextStoreActions)() || [
        null,
        {}
    ];
    const actions = (0, $eJOHy.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView,
            setAiFeaturesOnboardingSpotlight: setAiFeaturesOnboardingSpotlight
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView,
        setAiFeaturesOnboardingSpotlight
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e10397d24adf8a0$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $U4tkh.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e10397d24adf8a0$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $U4tkh.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e10397d24adf8a0$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $U4tkh.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e10397d24adf8a0$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $U4tkh.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e10397d24adf8a0$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $U4tkh.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e10397d24adf8a0$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $U4tkh.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e10397d24adf8a0$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $U4tkh.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e10397d24adf8a0$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $U4tkh.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e10397d24adf8a0$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $U4tkh.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e10397d24adf8a0$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $U4tkh.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e10397d24adf8a0$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $U4tkh.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e10397d24adf8a0$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $U4tkh.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e10397d24adf8a0$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $U4tkh.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e10397d24adf8a0$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $U4tkh.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e10397d24adf8a0$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $U4tkh.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e10397d24adf8a0$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const licenseStates = (0, $e6s1C.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $5KtrL.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e10397d24adf8a0$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e10397d24adf8a0$export$aad3917152559b87();
    return analyticsSource === (0, $1791521efc556332$export$b19f949fb9713614);
};
const $7e10397d24adf8a0$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e10397d24adf8a0$export$aad3917152559b87();
    return analyticsSource === (0, $1791521efc556332$export$a5132300c5214280);
};
const $7e10397d24adf8a0$export$e998111e82af7f08 = ()=>{
    const [aiFeaturesOnboardingSpotlight] = (0, $U4tkh.useAiFeaturesOnboarding)();
    return aiFeaturesOnboardingSpotlight;
};
const $7e10397d24adf8a0$export$db5174c7538abe4b = ()=>{
    const [isAiEnabledForIssue] = (0, $U4tkh.useIssueContextIsAiEnabledForIssue)();
    return isAiEnabledForIssue;
};
const $7e10397d24adf8a0$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $7e10397d24adf8a0$export$22108eca27445997();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    return [
        (0, $FhXEJ.SOFTWARE_PROJECT),
        (0, $FhXEJ.CORE_PROJECT)
    ].some((type)=>type === projectType);
};
const $7e10397d24adf8a0$export$48cf678fcbd4605 = ()=>{
    const isJiraIssue = $7e10397d24adf8a0$export$cf5fc815f761fb4b();
    return isJiraIssue && (0, $4cTDP.fg)('relay-migration-issue-comments');
};
const $7e10397d24adf8a0$export$5d1eb8193b85a593 = ()=>{
    const isJiraIssue = $7e10397d24adf8a0$export$cf5fc815f761fb4b();
    return isJiraIssue && (0, $4cTDP.fg)('relay-migration-issue-history');
};
const $7e10397d24adf8a0$export$9db14d7d93db3988 = ()=>{
    const isJiraIssue = $7e10397d24adf8a0$export$cf5fc815f761fb4b();
    return isJiraIssue && (0, $4cTDP.fg)('relay-migration-issue-all-activity');
};

});
const $1791521efc556332$export$53d41ff2666118e1 = 'agility-backlog';
const $1791521efc556332$export$7552fe2669628499 = 'bitbucket-issue';
const $1791521efc556332$export$41a718da0a8636f4 = 'connect-issue';
const $1791521efc556332$export$cebf0bc8b2ccaf57 = 'core-issue';
const $1791521efc556332$export$5e91e17726e54450 = 'jiraCalendar';
const $1791521efc556332$export$2dac1950892123f5 = 'jiraTimeline';
const $1791521efc556332$export$82540942fb014b0a = 'business-calendar';
const $1791521efc556332$export$7ca28938a07e0c33 = 'business-list';
const $1791521efc556332$export$f6cf06aaaeb58a54 = 'business-timeline';
const $1791521efc556332$export$b2c0462ff17aa26e = 'business-board';
const $1791521efc556332$export$a607850ebccd28ac = 'business-approvals';
const $1791521efc556332$export$1da6cede3561048f = 'business-files';
const $1791521efc556332$export$b19f949fb9713614 = 'full-issue';
const $1791521efc556332$export$a5132300c5214280 = 'embed-issue';
const $1791521efc556332$export$710114090a811b37 = 'global-issue-navigator-issue';
const $1791521efc556332$export$ce88447986394f2d = 'mobile-issue';
const $1791521efc556332$export$6a90d9196d330040 = 'project-issue-navigator';
const $1791521efc556332$export$2247c9059c171db1 = 'roadmap-issue';
const $1791521efc556332$export$cd16d39c55c569d0 = 'simple-software-board';
const $1791521efc556332$export$f72626bf0d75dfad = 'software-backlog-issue';
const $1791521efc556332$export$778b4609e784cb27 = 'software-deployments-issue';
const $1791521efc556332$export$5b73d694a6048002 = 'version-detail-issue';
const $1791521efc556332$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $1791521efc556332$export$21b5b7189add7861 = 'software-incidents-issue';
const $1791521efc556332$export$9c5d81b901471b27 = 'software-issue';
const $1791521efc556332$export$1735f6ad917dc411 = 'change-calendar';
const $1791521efc556332$export$7063ee6d0035a982 = 'queues-issue-view';
const $1791521efc556332$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $1791521efc556332$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $1791521efc556332$export$14a8072f422804fd = 'issue-navigator-next';
const $1791521efc556332$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $1791521efc556332$export$5f3c20fe2ff6c0a2 = 'staffing-issue';
const $1791521efc556332$export$9dac02c804d7acd8 = 'classic-software-board';

parcelRegister("FhXEJ", function(module, exports) {
$parcel$export(module.exports, "CORE_PROJECT", () => $4492e175f8940477$export$4b79f735ed858abe);
$parcel$export(module.exports, "SOFTWARE_PROJECT", () => $4492e175f8940477$export$417275bac62d38d2);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT", () => $4492e175f8940477$export$9c9c9eaf8c092006);
$parcel$export(module.exports, "CUSTOMER_SERVICE_PROJECT", () => $4492e175f8940477$export$320625d747692f94);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT_ANALYTICS", () => $4492e175f8940477$export$d579a2a17bd742af);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PROJECT", () => $4492e175f8940477$export$e9fe9a39cc7f5103);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CORE_PROJECT", () => $4492e175f8940477$export$490d3686b662c315);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SOFTWARE_PROJECT", () => $4492e175f8940477$export$1242aa4e670b910e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT", () => $4492e175f8940477$export$bb467c3bc8f8620e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT", () => $4492e175f8940477$export$610dddac4d185bf8);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT", () => $4492e175f8940477$export$76412127fb3089d6);
$parcel$export(module.exports, "JIRA_PROJECT_STATUS_ARCHIVED", () => $4492e175f8940477$export$c02e05d1bee347e5);
$parcel$export(module.exports, "COMPANY_MANAGED_PROJECT", () => $4492e175f8940477$export$6933c64814be01d9);
$parcel$export(module.exports, "TEAM_MANAGED_PROJECT", () => $4492e175f8940477$export$e569d8a168a85f48);
$parcel$export(module.exports, "JIRA_PROJECT_TYPES", () => $4492e175f8940477$export$be0978435d251eb);
$parcel$export(module.exports, "JIRA_PROJECT_STYLES", () => $4492e175f8940477$export$caed6d9b39712cc7);
$parcel$export(module.exports, "ProjectStyle", () => $4492e175f8940477$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectStyleCmpNotation", () => $4492e175f8940477$export$bde8ccac2f23fd0f);
$parcel$export(module.exports, "PROJECT_TYPES", () => $4492e175f8940477$export$9482030bf1904b0);
$parcel$export(module.exports, "toProjectType", () => $4492e175f8940477$export$cfdcd9ead66e4329);
$parcel$export(module.exports, "convertToProjectType", () => $4492e175f8940477$export$aa8444e79de3a8b6);
$parcel$export(module.exports, "convertToJiraProjectType", () => $4492e175f8940477$export$5a8b6164d1baba87);
$parcel$export(module.exports, "toAnalyticsProjectType", () => $4492e175f8940477$export$5afb6f76b5af0167);
$parcel$export(module.exports, "projectTypeToCanonicalId", () => $4492e175f8940477$export$e25a1ee2478a61d6);

var $7mF43 = parcelRequire("7mF43");

var $6NDp7 = parcelRequire("6NDp7");

var $4cTDP = parcelRequire("4cTDP");
const $4492e175f8940477$export$4b79f735ed858abe = 'business';
const $4492e175f8940477$export$417275bac62d38d2 = 'software';
const $4492e175f8940477$export$9c9c9eaf8c092006 = 'service_desk';
const $4492e175f8940477$export$320625d747692f94 = 'customer_service';
const $4492e175f8940477$export$d579a2a17bd742af = 'serviceDesk';
const $4492e175f8940477$export$e9fe9a39cc7f5103 = 'product_discovery';
const $4492e175f8940477$export$490d3686b662c315 = 'BUSINESS';
const $4492e175f8940477$export$1242aa4e670b910e = 'SOFTWARE';
const $4492e175f8940477$export$bb467c3bc8f8620e = 'SERVICE_DESK';
const $4492e175f8940477$export$610dddac4d185bf8 = 'CUSTOMER_SERVICE';
const $4492e175f8940477$export$76412127fb3089d6 = 'PRODUCT_DISCOVERY';
const $4492e175f8940477$export$1b784afd50592d26 = 'ACTIVE';
const $4492e175f8940477$export$c02e05d1bee347e5 = 'ARCHIVED';
const $4492e175f8940477$export$8b2d8efe30253ab3 = 'DELETED';
const $4492e175f8940477$export$6933c64814be01d9 = 'COMPANY_MANAGED_PROJECT';
const $4492e175f8940477$export$e569d8a168a85f48 = 'TEAM_MANAGED_PROJECT';
const $4492e175f8940477$export$be0978435d251eb = {
    [$4492e175f8940477$export$490d3686b662c315]: $4492e175f8940477$export$490d3686b662c315,
    [$4492e175f8940477$export$1242aa4e670b910e]: $4492e175f8940477$export$1242aa4e670b910e,
    [$4492e175f8940477$export$bb467c3bc8f8620e]: $4492e175f8940477$export$bb467c3bc8f8620e,
    [$4492e175f8940477$export$610dddac4d185bf8]: $4492e175f8940477$export$610dddac4d185bf8,
    [$4492e175f8940477$export$76412127fb3089d6]: $4492e175f8940477$export$76412127fb3089d6
};
const $4492e175f8940477$export$caed6d9b39712cc7 = {
    COMPANY_MANAGED_PROJECT: $4492e175f8940477$export$6933c64814be01d9,
    TEAM_MANAGED_PROJECT: $4492e175f8940477$export$e569d8a168a85f48
};
const $4492e175f8940477$export$1f66f9f05afa05a8 = {
    CLASSIC: 'classic',
    NEXT_GEN: 'next-gen'
};
const $4492e175f8940477$export$bde8ccac2f23fd0f = {
    COMPANY_MANAGED: 'companyManaged',
    TEAM_MANAGED: 'teamManaged'
};
const $4492e175f8940477$export$9482030bf1904b0 = [
    $4492e175f8940477$export$4b79f735ed858abe,
    $4492e175f8940477$export$417275bac62d38d2,
    $4492e175f8940477$export$9c9c9eaf8c092006,
    $4492e175f8940477$export$320625d747692f94,
    $4492e175f8940477$export$e9fe9a39cc7f5103
];
const $4492e175f8940477$export$cfdcd9ead66e4329 = (value)=>$4492e175f8940477$export$9482030bf1904b0.find((projectType)=>projectType === value);
function $4492e175f8940477$export$aa8444e79de3a8b6(jiraProjectType) {
    if ((0, $4cTDP.fg)('jcs_project_type_m3')) switch(jiraProjectType){
        case $4492e175f8940477$export$490d3686b662c315:
            return $4492e175f8940477$export$4b79f735ed858abe;
        case $4492e175f8940477$export$1242aa4e670b910e:
            return $4492e175f8940477$export$417275bac62d38d2;
        case $4492e175f8940477$export$bb467c3bc8f8620e:
            return $4492e175f8940477$export$9c9c9eaf8c092006;
        case $4492e175f8940477$export$610dddac4d185bf8:
            return $4492e175f8940477$export$320625d747692f94;
        case $4492e175f8940477$export$76412127fb3089d6:
            return $4492e175f8940477$export$e9fe9a39cc7f5103;
        default:
            throw new Error(`Invalid JiraProjectType: ${jiraProjectType}`);
    }
    switch(jiraProjectType){
        case $4492e175f8940477$export$490d3686b662c315:
            return $4492e175f8940477$export$4b79f735ed858abe;
        case $4492e175f8940477$export$1242aa4e670b910e:
            return $4492e175f8940477$export$417275bac62d38d2;
        case $4492e175f8940477$export$bb467c3bc8f8620e:
            return $4492e175f8940477$export$9c9c9eaf8c092006;
        case $4492e175f8940477$export$610dddac4d185bf8:
            return $4492e175f8940477$export$9c9c9eaf8c092006;
        case $4492e175f8940477$export$76412127fb3089d6:
            return $4492e175f8940477$export$e9fe9a39cc7f5103;
        default:
            throw new Error(`Invalid JiraProjectType: ${jiraProjectType}`);
    }
}
function $4492e175f8940477$export$959e77de8f16519c(jiraProjectType) {
    // At the time of writing, convertToProjectType returned "Service Desk" not "Customer Service"; this is a workaround for that
    // With jcs_project_type_m3, convertToProjectType returns "Customer Service"
    if (jiraProjectType === $4492e175f8940477$export$610dddac4d185bf8 && !(0, $4cTDP.fg)('jcs_project_type_m3')) return (0, (/*@__PURE__*/$parcel$interopDefault($6NDp7)))($4492e175f8940477$export$320625d747692f94);
    const convertedProjectType = $4492e175f8940477$export$aa8444e79de3a8b6(jiraProjectType);
    if (convertedProjectType === $4492e175f8940477$export$9c9c9eaf8c092006) // 'Service Desk' is old branding
    return (0, (/*@__PURE__*/$parcel$interopDefault($6NDp7)))('Service Management');
    return (0, (/*@__PURE__*/$parcel$interopDefault($6NDp7)))(convertedProjectType);
}
const $4492e175f8940477$export$5a8b6164d1baba87 = (projectType)=>{
    switch(projectType){
        case $4492e175f8940477$export$417275bac62d38d2:
            return $4492e175f8940477$export$1242aa4e670b910e;
        case $4492e175f8940477$export$9c9c9eaf8c092006:
            return $4492e175f8940477$export$bb467c3bc8f8620e;
        case $4492e175f8940477$export$320625d747692f94:
            return $4492e175f8940477$export$610dddac4d185bf8;
        case $4492e175f8940477$export$4b79f735ed858abe:
            return $4492e175f8940477$export$490d3686b662c315;
        case $4492e175f8940477$export$e9fe9a39cc7f5103:
            return $4492e175f8940477$export$76412127fb3089d6;
        default:
            throw new Error(`Invalid ProjectType: ${projectType}`);
    }
};
const $4492e175f8940477$export$5afb6f76b5af0167 = (projectType)=>{
    switch(projectType){
        case $4492e175f8940477$export$9c9c9eaf8c092006:
            return $4492e175f8940477$export$d579a2a17bd742af;
        case $4492e175f8940477$export$320625d747692f94:
            return $4492e175f8940477$export$320625d747692f94;
        case $4492e175f8940477$export$417275bac62d38d2:
            return $4492e175f8940477$export$417275bac62d38d2;
        case $4492e175f8940477$export$e9fe9a39cc7f5103:
            return $4492e175f8940477$export$e9fe9a39cc7f5103;
        case $4492e175f8940477$export$4b79f735ed858abe:
            return $4492e175f8940477$export$4b79f735ed858abe;
        default:
            return undefined;
    }
};
const $4492e175f8940477$var$getFullProjectTypeKey = (style, projectType)=>(0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(`${style}_${projectType}`);
const $4492e175f8940477$export$241adb8e9255b93c = $4492e175f8940477$var$getFullProjectTypeKey($4492e175f8940477$export$1f66f9f05afa05a8.CLASSIC, $4492e175f8940477$export$4b79f735ed858abe);
const $4492e175f8940477$export$e932928a4bf564b7 = $4492e175f8940477$var$getFullProjectTypeKey($4492e175f8940477$export$1f66f9f05afa05a8.NEXT_GEN, $4492e175f8940477$export$417275bac62d38d2);
const $4492e175f8940477$export$e25a1ee2478a61d6 = (projectType)=>{
    switch(projectType){
        case $4492e175f8940477$export$4b79f735ed858abe:
            return 'jira-core';
        case $4492e175f8940477$export$417275bac62d38d2:
            return 'jira-software';
        case $4492e175f8940477$export$9c9c9eaf8c092006:
            return 'jira-servicedesk';
        case $4492e175f8940477$export$320625d747692f94:
            return 'jira-customer-service';
        case $4492e175f8940477$export$e9fe9a39cc7f5103:
            return 'jira-product-discovery';
        default:
            return 'jira';
    }
};

});

parcelRegister("bNexr", function(module, exports) {
$parcel$export(module.exports, "useProjectKey", () => $394a54b0d708bbf0$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $394a54b0d708bbf0$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $394a54b0d708bbf0$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $394a54b0d708bbf0$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $394a54b0d708bbf0$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $394a54b0d708bbf0$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "isSimplifiedProject", () => $394a54b0d708bbf0$export$69909c70ce8efefa);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $394a54b0d708bbf0$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $394a54b0d708bbf0$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $394a54b0d708bbf0$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $394a54b0d708bbf0$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $394a54b0d708bbf0$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $394a54b0d708bbf0$export$80bef597b440cf71);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");

var $koAZ4 = parcelRequire("koAZ4");

var $b8rQb = parcelRequire("b8rQb");

var $aAqmd = parcelRequire("aAqmd");
const $394a54b0d708bbf0$export$f87be37f8e8be65 = (issueKey)=>issueKey.split('-')[0];
const $394a54b0d708bbf0$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $b8rQb.useProjectContextActionStore)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $394a54b0d708bbf0$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $b8rQb.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $394a54b0d708bbf0$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $394a54b0d708bbf0$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $394a54b0d708bbf0$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $lBYgs.getApplicationForProject)(projectType);
};
const $394a54b0d708bbf0$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $koAZ4.useTenantContext)();
    const application = $394a54b0d708bbf0$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $cblKs.getEdition)(application, appEditions);
};
const $394a54b0d708bbf0$export$69909c70ce8efefa = (projectStyle)=>{
    return projectStyle === (0, $FhXEJ.TEAM_MANAGED_PROJECT);
};
const $394a54b0d708bbf0$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $394a54b0d708bbf0$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $394a54b0d708bbf0$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $394a54b0d708bbf0$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $394a54b0d708bbf0$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $394a54b0d708bbf0$export$6de29d851c914935(projectKey);
    const isSimplified = $394a54b0d708bbf0$export$524ef4f6102ed540(projectKey);
    return (0, $eJOHy.useMemo)(()=>(0, $aAqmd.getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        }), [
        isSimplified,
        projectType
    ]);
};
const $394a54b0d708bbf0$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $b8rQb.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("b8rQb", function(module, exports) {
$parcel$export(module.exports, "useProjectContextActionStore", () => $9f277dbc5eafd530$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $9f277dbc5eafd530$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $9f277dbc5eafd530$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $9f277dbc5eafd530$export$f73e9904779f6be5);

var $FhXEJ = parcelRequire("FhXEJ");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $6KYi0 = parcelRequire("6KYi0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f277dbc5eafd530$var$initialState = {};
const $9f277dbc5eafd530$var$store = (0, $GtRbT.createStore)({
    name: 'project-context',
    initialState: $9f277dbc5eafd530$var$initialState,
    actions: $6KYi0
});
const $9f277dbc5eafd530$export$9afb89c1fe103bbe = (0, $iJq0l.createHook)($9f277dbc5eafd530$var$store, {
    selector: null
});
const $9f277dbc5eafd530$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $9f277dbc5eafd530$export$8b09478b33186ec = (0, $iJq0l.createHook)($9f277dbc5eafd530$var$store, {
    selector: $9f277dbc5eafd530$var$getProjectContext
});
const $9f277dbc5eafd530$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $9f277dbc5eafd530$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $FhXEJ.TEAM_MANAGED_PROJECT) : (0, $FhXEJ.COMPANY_MANAGED_PROJECT);
};
const $9f277dbc5eafd530$export$f2e1ed3b2b4707cb = (0, $iJq0l.createHook)($9f277dbc5eafd530$var$store, {
    selector: $9f277dbc5eafd530$var$getProjectType
});
const $9f277dbc5eafd530$export$b291cf203d6481a4 = (0, $iJq0l.createHook)($9f277dbc5eafd530$var$store, {
    selector: $9f277dbc5eafd530$var$getJiraProjectStyle
});
const $9f277dbc5eafd530$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $9f277dbc5eafd530$export$9469fde70658518 = (0, $iJq0l.createHook)($9f277dbc5eafd530$var$store, {
    selector: $9f277dbc5eafd530$var$getProjectName
});
const $9f277dbc5eafd530$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $9f277dbc5eafd530$export$f73e9904779f6be5 = (0, $iJq0l.createHook)($9f277dbc5eafd530$var$store, {
    selector: $9f277dbc5eafd530$var$getIssueTypes
});

});
parcelRegister("6KYi0", function(module, exports) {
$parcel$export(module.exports, "setProjectContext", () => $da8fc507538f01dc$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $da8fc507538f01dc$export$78f1c6052937615f);
const $da8fc507538f01dc$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $da8fc507538f01dc$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("aAqmd", function(module, exports) {
$parcel$export(module.exports, "getIssueConfiguration", () => $260acdbd5c3f4032$export$902f6c5cc939598a);

var $hGkL7 = parcelRequire("hGkL7");

var $FhXEJ = parcelRequire("FhXEJ");
// Issue actions
const $260acdbd5c3f4032$var$FLAG_ACTIONS = 'flagActions';
const $260acdbd5c3f4032$var$CARD_COVER_ACTIONS = 'cardCoverActions';
const $260acdbd5c3f4032$var$coreConfiguration = ()=>({
        applicationKey: (0, $hGkL7.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$var$softwareConfiguration = ()=>({
        applicationKey: (0, $hGkL7.default).SOFTWARE_ISSUE,
        issueActions: [
            $260acdbd5c3f4032$var$FLAG_ACTIONS
        ],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$var$simpleSoftwareBoardConfiguration = ()=>({
        applicationKey: (0, $hGkL7.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $260acdbd5c3f4032$var$FLAG_ACTIONS,
            $260acdbd5c3f4032$var$CARD_COVER_ACTIONS
        ],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$var$serviceDeskConfiguration = ()=>({
        applicationKey: (0, $hGkL7.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $FhXEJ.SOFTWARE_PROJECT:
            if (config.isSimplified) return $260acdbd5c3f4032$var$simpleSoftwareBoardConfiguration();
            return $260acdbd5c3f4032$var$softwareConfiguration();
        case 0, $FhXEJ.CORE_PROJECT:
            return $260acdbd5c3f4032$var$coreConfiguration();
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            return $260acdbd5c3f4032$var$serviceDeskConfiguration();
        default:
            // fallback to sofware config
            return $260acdbd5c3f4032$var$softwareConfiguration();
    }
    return $260acdbd5c3f4032$var$softwareConfiguration();
};

});
parcelRegister("hGkL7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5214d18378e693f1$export$2e2bcd8739ae039);
const $5214d18378e693f1$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $5214d18378e693f1$export$2e2bcd8739ae039 = $5214d18378e693f1$var$keys;

});



parcelRegister("e6s1C", function(module, exports) {
$parcel$export(module.exports, "useLicenseStates", () => $9b27dd8e40d83873$export$268651a63abe408a);

var $koAZ4 = parcelRequire("koAZ4");
const $9b27dd8e40d83873$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("1Ru5V", function(module, exports) {
$parcel$export(module.exports, "useLicensedProducts", () => $938c908ad929e8cd$export$54d534cc91e54850);

var $koAZ4 = parcelRequire("koAZ4");
const $938c908ad929e8cd$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("U4tkh", function(module, exports) {
$parcel$export(module.exports, "store", () => $37a5d4913156d800$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useIssueContextStore", () => $37a5d4913156d800$export$f6e0a3ee03299fbc);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $37a5d4913156d800$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $37a5d4913156d800$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $37a5d4913156d800$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $37a5d4913156d800$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $37a5d4913156d800$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $37a5d4913156d800$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $37a5d4913156d800$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $37a5d4913156d800$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $37a5d4913156d800$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $37a5d4913156d800$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $37a5d4913156d800$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $37a5d4913156d800$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $37a5d4913156d800$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $37a5d4913156d800$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $37a5d4913156d800$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $37a5d4913156d800$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $37a5d4913156d800$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $37a5d4913156d800$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $37a5d4913156d800$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $37a5d4913156d800$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $37a5d4913156d800$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $37a5d4913156d800$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $37a5d4913156d800$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", () => $37a5d4913156d800$export$455ae7fd9d68b157);
$parcel$export(module.exports, "useIssueTypeName", () => $37a5d4913156d800$export$ec3ac562fe41f8db);
$parcel$export(module.exports, "useIssueHierarchyLevel", () => $37a5d4913156d800$export$c998d5da56eeedf0);
$parcel$export(module.exports, "useAiFeaturesOnboarding", () => $37a5d4913156d800$export$d11667965b0d260e);
$parcel$export(module.exports, "IssueContextContainer", () => $37a5d4913156d800$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $37a5d4913156d800$export$965360ae27fcae98);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9CRRg = parcelRequire("9CRRg");

var $2ZenB = parcelRequire("2ZenB");

var $bN0Oz = parcelRequire("bN0Oz");

var $c5gcy = parcelRequire("c5gcy");
const $37a5d4913156d800$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: '',
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $c5gcy.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false,
    isAiEnabledForIssue: false,
    issueHierarchyLevel: undefined,
    issueType: undefined,
    aiFeaturesOnboardingSpotlight: {
        currentSpotlightItem: null,
        presentSpotlights: [
            {
                name: (0, $bN0Oz.AiFeaturesOnboardingItemsTypes).DRAFT_PILL,
                flag: false
            },
            {
                name: (0, $bN0Oz.AiFeaturesOnboardingItemsTypes).SMART_RELATED_ISSUES,
                flag: false
            },
            {
                name: (0, $bN0Oz.AiFeaturesOnboardingItemsTypes).SUMMARIZE_COMMENTS,
                flag: false
            },
            {
                name: (0, $bN0Oz.AiFeaturesOnboardingItemsTypes).AI_CONTEXT_PANEL,
                flag: false
            }
        ]
    }
};
const $37a5d4913156d800$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-context',
    initialState: $37a5d4913156d800$export$d4c72bab9d6cc13a,
    actions: $9CRRg.actions
});
const $37a5d4913156d800$var$getIssueContext = (state)=>state;
const $37a5d4913156d800$var$getIsModal = (state)=>state.isModal;
const $37a5d4913156d800$var$getIssueKey = (state)=>state.issueKey;
const $37a5d4913156d800$var$getIsArchived = (state)=>state.isArchived;
const $37a5d4913156d800$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $37a5d4913156d800$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $37a5d4913156d800$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $37a5d4913156d800$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $37a5d4913156d800$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $37a5d4913156d800$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $37a5d4913156d800$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $37a5d4913156d800$var$getIsLoading = (state)=>state.isLoading;
const $37a5d4913156d800$var$getViewMode = (state)=>state.viewMode;
const $37a5d4913156d800$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $37a5d4913156d800$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $37a5d4913156d800$var$getBoardId = (state)=>state.boardId;
const $37a5d4913156d800$var$getBoardType = (state)=>state.boardType;
const $37a5d4913156d800$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $37a5d4913156d800$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $37a5d4913156d800$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $37a5d4913156d800$var$getRapidViewId = (state)=>state.rapidViewId;
const $37a5d4913156d800$var$getViewScreenId = (state)=>state.viewScreenId;
const $37a5d4913156d800$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $37a5d4913156d800$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
const $37a5d4913156d800$var$getIssueTypeName = (state)=>state.issueType;
const $37a5d4913156d800$var$getIssueHierarchyLevel = (state)=>state.issueHierarchyLevel;
const $37a5d4913156d800$var$getAiFeaturesOnboardingSpotlight = (state)=>state.aiFeaturesOnboardingSpotlight;
const $37a5d4913156d800$export$f6e0a3ee03299fbc = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueContext
});
const $37a5d4913156d800$export$abdbea56d86b4aac = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: (0, $2ZenB.getChildIssuesLimit)
});
const $37a5d4913156d800$export$326ff2b963d51c5c = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: (0, $2ZenB.getChildIssuesIssueLimitUrls)
});
const $37a5d4913156d800$export$44bcaaabb74e402b = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueKey
});
const $37a5d4913156d800$export$332dcee0cf9f4e45 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueId
});
const $37a5d4913156d800$export$c940355b1fc6e1c4 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsArchived
});
const $37a5d4913156d800$export$b9eebaa1da421997 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsClassifyEditEnabled
});
const $37a5d4913156d800$export$daa47fd600e43a32 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsModal
});
const $37a5d4913156d800$export$ba2e9546ab5ba6f = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getViewScreenId
});
const $37a5d4913156d800$export$74d38d6c437efc1b = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getAnalyticsSource
});
const $37a5d4913156d800$export$2092528ee170d9e7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getRapidViewMap
});
const $37a5d4913156d800$export$57898374e6239a5a = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getMaxTokenLength
});
const $37a5d4913156d800$export$ff0264ec4c015dc1 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsLoadedWithPage
});
const $37a5d4913156d800$export$6c8b81f6dca8c23d = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getEstimationStatistic
});
const $37a5d4913156d800$export$fe7085456138f0fc = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsLoading
});
const $37a5d4913156d800$export$c339e36468c12443 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getViewMode
});
const $37a5d4913156d800$export$ef3bfa2642bb98cd = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBackButtonUrl
});
const $37a5d4913156d800$export$8accd063c74cd455 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueNavigatorData
});
const $37a5d4913156d800$export$e7edffc2a20027e7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBoardId
});
const $37a5d4913156d800$export$48aaa3a6bc2085d7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBoardType
});
const $37a5d4913156d800$export$4a4b96bcf5166327 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsSpaEnabled
});
const $37a5d4913156d800$export$bbd8ba0180545556 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getLoginRedirectUrl
});
const $37a5d4913156d800$export$aaa89627762c7d00 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getOnIssueKeyChange
});
const $37a5d4913156d800$export$796589b0ec52848a = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getRapidViewId
});
const $37a5d4913156d800$export$7e70ee570119a0a7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsAiOptInEnabled
});
const $37a5d4913156d800$export$455ae7fd9d68b157 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getisAiEnabledForIssue
});
const $37a5d4913156d800$export$ec3ac562fe41f8db = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueTypeName
});
const $37a5d4913156d800$export$c998d5da56eeedf0 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueHierarchyLevel
});
const $37a5d4913156d800$export$d11667965b0d260e = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getAiFeaturesOnboardingSpotlight
});
const $37a5d4913156d800$export$93db6a8f3342dddf = (0, $6E16M.createContainer)($37a5d4913156d800$export$6f57813fe9f31bf9);
const $37a5d4913156d800$export$965360ae27fcae98 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("9CRRg", function(module, exports) {
$parcel$export(module.exports, "setIssueContext", () => $37cf6cc1d4339972$export$784a03c4b74da53e);
$parcel$export(module.exports, "actions", () => $37cf6cc1d4339972$export$e324594224ef24da);

var $axSQB = parcelRequire("axSQB");

var $2ZenB = parcelRequire("2ZenB");

var $c5gcy = parcelRequire("c5gcy");
const $37cf6cc1d4339972$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        const currentState = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || currentState.viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || currentState.viewMode
        });
    };
const $37cf6cc1d4339972$var$mergeIssueContext = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $37cf6cc1d4339972$var$getChildIssuesLimit = ()=>({ getState: getState })=>(0, $2ZenB.getChildIssuesLimit)(getState());
const $37cf6cc1d4339972$var$getMaxTokenLength = ()=>({ getState: getState })=>getState().maxTokenLength;
const $37cf6cc1d4339972$var$getIsLoadedWithPage = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $37cf6cc1d4339972$var$getBackButtonUrl = ()=>({ getState: getState })=>getState().backButtonUrl;
const $37cf6cc1d4339972$var$getIsSpaEnabled = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $37cf6cc1d4339972$var$getIssueKey = ()=>({ getState: getState })=>getState().issueKey;
const $37cf6cc1d4339972$var$getIsArchived = ()=>({ getState: getState })=>getState().isArchived;
const $37cf6cc1d4339972$var$setDetailViewAsModal = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $axSQB.localStorage).set((0, $axSQB.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $37cf6cc1d4339972$var$setDetailViewAsSidebar = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $axSQB.localStorage).set((0, $axSQB.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $37cf6cc1d4339972$var$resetDetailView = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $c5gcy.getViewModeFromLocalStorage)()
        });
    };
const $37cf6cc1d4339972$var$setAiFeaturesOnboardingSpotlight = (state)=>({ setState: setState })=>{
        setState({
            aiFeaturesOnboardingSpotlight: state
        });
    };
/**
 * a special action to "sync" stores
 * @deprecated internal use only
 */ const $37cf6cc1d4339972$var$internalSyncStore = (issueContext)=>({ setState: setState })=>{
        setState(issueContext);
    };
const $37cf6cc1d4339972$export$e324594224ef24da = {
    internalSyncStore: $37cf6cc1d4339972$var$internalSyncStore,
    setIssueContext: $37cf6cc1d4339972$export$784a03c4b74da53e,
    mergeIssueContext: $37cf6cc1d4339972$var$mergeIssueContext,
    getChildIssuesLimit: $37cf6cc1d4339972$var$getChildIssuesLimit,
    getMaxTokenLength: $37cf6cc1d4339972$var$getMaxTokenLength,
    getIsLoadedWithPage: $37cf6cc1d4339972$var$getIsLoadedWithPage,
    getBackButtonUrl: $37cf6cc1d4339972$var$getBackButtonUrl,
    getIsSpaEnabled: $37cf6cc1d4339972$var$getIsSpaEnabled,
    getIssueKey: $37cf6cc1d4339972$var$getIssueKey,
    getIsArchived: $37cf6cc1d4339972$var$getIsArchived,
    setDetailViewAsModal: $37cf6cc1d4339972$var$setDetailViewAsModal,
    setDetailViewAsSidebar: $37cf6cc1d4339972$var$setDetailViewAsSidebar,
    resetDetailView: $37cf6cc1d4339972$var$resetDetailView,
    setAiFeaturesOnboardingSpotlight: $37cf6cc1d4339972$var$setAiFeaturesOnboardingSpotlight
};

});
parcelRegister("axSQB", function(module, exports) {
$parcel$export(module.exports, "LOG_LOCATION", () => $13b297323309c4b3$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $13b297323309c4b3$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $13b297323309c4b3$export$a13f7f627010bccd);

var $3hRxq = parcelRequire("3hRxq");
const $13b297323309c4b3$export$25a759e49d5049db = 'issue.issue-context-service';
const $13b297323309c4b3$export$c2ed3351cac403d1 = (0, $3hRxq.createLocalStorageProvider)('jira_issue_view');
const $13b297323309c4b3$export$a13f7f627010bccd = 'view-mode';

});
parcelRegister("3hRxq", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageProvider", () => $a5f5f865759210ee$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $a5f5f865759210ee$export$59acef2b3ab1df90);

var $5PQOA = parcelRequire("5PQOA");

var $RkQsc = parcelRequire("RkQsc");

var $fwrw4 = parcelRequire("fwrw4");
const $a5f5f865759210ee$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, shouldSerialize = true)=>(0, $RkQsc.createStorageProvider)((0, $RkQsc.WebStorageType).LocalStorage, appPrefix, (0, $fwrw4.makeLocalStore)(), shouldSerialize));
const $a5f5f865759210ee$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix)=>{
    return (0, $RkQsc.createExpirableStorageProvider)((0, $RkQsc.WebStorageType).LocalStorage, appPrefix, (0, $fwrw4.makeLocalExpirableStore)());
});

});
parcelRegister("RkQsc", function(module, exports) {
$parcel$export(module.exports, "plugins", () => $22268541f930cefc$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "WebStorageType", () => $22268541f930cefc$export$259e3a861f28589b);
$parcel$export(module.exports, "createStorageProvider", () => $22268541f930cefc$export$8441605555fbd60c);
$parcel$export(module.exports, "createExpirableStorageProvider", () => $22268541f930cefc$export$b793a81cf479272a);

var $fsdQg = parcelRequire("fsdQg");

var $48TwY = parcelRequire("48TwY");

var $4cTDP = parcelRequire("4cTDP");

var $h7wEC = parcelRequire("h7wEC");
const $22268541f930cefc$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
    (0, $h7wEC.default)
];
const $22268541f930cefc$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};
const $22268541f930cefc$export$8441605555fbd60c = (storageType, appPrefix = '', // eslint-disable-next-line @typescript-eslint/no-explicit-any
store, shouldSerialize = true)=>{
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>appPrefix?.trim().length ? `${appPrefix}.${key}` : key;
    const storageAPI = storageType === $22268541f930cefc$export$259e3a861f28589b.LocalStorage ? (0, $48TwY.AtlBrowserStorageLocal) : (0, $48TwY.AtlBrowserStorageSession);
    const browserStorage = storageType === $22268541f930cefc$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setItem(prefixedKey, storageValue);
                } else namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, storageValue);
                } else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let item;
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    // When the feature flag is enabled
                    if (appPrefix?.trim().length) {
                        // Case 1: App prefix exists (all the existing usages of jira-browser-storage-providers had app prefix)
                        item = storageAPI.getItem(prefixedKey);
                        if (typeof item === 'undefined' || item === null) {
                            // Check old store when data not found in new storage
                            const itemFromOldStore = namespacedStore.get(key);
                            if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                                // Migrate data from old store to new storage
                                const stringValue = JSON.stringify(itemFromOldStore);
                                storageAPI.setItem(prefixedKey, stringValue);
                                return itemFromOldStore;
                            }
                        }
                        if (typeof item === 'string') // If data found in new storage, return it
                        return shouldSerialize ? JSON.parse(item) : item;
                    }
                    // Case 2: No app prefix
                    item = storageAPI.getItem(prefixedKey);
                    if (typeof item === 'undefined' || item === null) {
                        // Check browser's localStorage for the key
                        const itemFromNativeBrowserStorage = browserStorage?.getItem(key);
                        if (typeof itemFromNativeBrowserStorage !== 'undefined' && itemFromNativeBrowserStorage !== null) {
                            // Migrate data to new storage
                            storageAPI.setItem(prefixedKey, itemFromNativeBrowserStorage);
                            return itemFromNativeBrowserStorage;
                        }
                    }
                    if (typeof item === 'string') // If data found in new storage, return it
                    return shouldSerialize ? JSON.parse(item) : item;
                } else return namespacedStore.get(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting item from storage:', err);
            }
        },
        remove: (key)=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey); // remove data from new store
                    namespacedStore.remove(key); // remove data from old store as well
                } else namespacedStore.remove(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error removing item from storage:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access clearStorageValues method.');
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access getNamespaceKeysLength method.');
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};
const $22268541f930cefc$export$b793a81cf479272a = (storageType, appPrefix, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>`${appPrefix}.${key}`;
    const storageAPI = storageType === $22268541f930cefc$export$259e3a861f28589b.LocalStorage ? (0, $48TwY.AtlBrowserStorageLocal) : (0, $48TwY.AtlBrowserStorageSession);
    const browserStorage = storageType === $22268541f930cefc$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const item = {
                        value: value,
                        expiration: expiration
                    };
                    const serializedValue = JSON.stringify(item);
                    storageAPI.setItem(prefixedKey, serializedValue);
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const item = {
                    value: value,
                    expiration: expiration
                };
                const serializedValue = JSON.stringify(item);
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) storageAPI.setStrictlyNecessaryItem(prefixedKey, serializedValue);
                else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let itemStr;
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const item = {
                                value: itemFromOldStore,
                                expiration: namespacedStore.getExpiration(key)
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return itemFromOldStore;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return;
                        }
                        return item.value;
                    }
                } else {
                    itemStr = namespacedStore.get(key);
                    return itemStr;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, error);
            }
        },
        getExpiration: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                let itemStr;
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const expiration = namespacedStore.getExpiration(key);
                            const item = {
                                value: itemFromOldStore,
                                expiration: expiration
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return expiration;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return undefined;
                        }
                        return item.expiration;
                    }
                } else return namespacedStore.getExpiration(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting expiration for item with key=${key}:`, error);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey);
                    namespacedStore.remove(key);
                } else namespacedStore.remove(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error removing item with key=${key}:`, error);
            }
        },
        removeExpiredKeys: ()=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    for(let i = 0; i < storageAPI.length(); i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) {
                            const itemStr = storageAPI.getItem(key);
                            if (itemStr) {
                                const item = JSON.parse(itemStr);
                                if (item.expiration && item.expiration < Date.now()) {
                                    storageAPI.removeItem(key);
                                    i--;
                                }
                            }
                        }
                    }
                    namespacedStore.removeExpiredKeys(); // clean up old keys too
                } else namespacedStore.removeExpiredKeys();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error removing expired keys:', error);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage values:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            try {
                if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};

});
parcelRegister("h7wEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5f83f1989334538$export$2e2bcd8739ae039);

var $9pTd3 = parcelRequire("9pTd3");

var $gNYhm = parcelRequire("gNYhm");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e5f83f1989334538$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $gNYhm.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $gNYhm.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $gNYhm.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $gNYhm.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $gNYhm.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $gNYhm.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $gNYhm.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $gNYhm.ONE_WEEK) >= (0, $gNYhm.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $gNYhm.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $e5f83f1989334538$export$2e2bcd8739ae039 = $e5f83f1989334538$var$cleanUpPlugin;

});
parcelRegister("gNYhm", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE", () => $a09b39dbd3a6795e$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $a09b39dbd3a6795e$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $a09b39dbd3a6795e$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $a09b39dbd3a6795e$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $a09b39dbd3a6795e$export$ea28dfd9333cda2d);
const $a09b39dbd3a6795e$export$6aad947bda0f3f46 = 'timestamps';
const $a09b39dbd3a6795e$export$8187f416f1cc43d8 = 604800000;
const $a09b39dbd3a6795e$export$6e952fa7d47190cf = 4 * $a09b39dbd3a6795e$export$8187f416f1cc43d8;
const $a09b39dbd3a6795e$export$da99ebca8f453abd = 22;
const $a09b39dbd3a6795e$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("fwrw4", function(module, exports) {
$parcel$export(module.exports, "makeLocalStore", () => $1f0d95a625bcb8b2$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $1f0d95a625bcb8b2$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $1f0d95a625bcb8b2$export$cf816b43e73de947);

var $fsdQg = parcelRequire("fsdQg");

var $252Bx = parcelRequire("252Bx");

var $02LWr = parcelRequire("02LWr");

var $jdVjN = parcelRequire("jdVjN");

var $jZWi5 = parcelRequire("jZWi5");

var $RkQsc = parcelRequire("RkQsc");
const $1f0d95a625bcb8b2$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($jdVjN))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], (0, $RkQsc.plugins));
const $1f0d95a625bcb8b2$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $1f0d95a625bcb8b2$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($jdVjN))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
        (0, (/*@__PURE__*/$parcel$interopDefault($252Bx)))
    ]);

});



parcelRegister("2ZenB", function(module, exports) {
$parcel$export(module.exports, "getChildIssuesLimit", () => $f915ff48c2d8f087$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $f915ff48c2d8f087$export$8f43520910e8128c);

var $eSnSE = parcelRequire("eSnSE");

var $axSQB = parcelRequire("axSQB");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $f915ff48c2d8f087$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $f915ff48c2d8f087$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData(`${(0, $axSQB.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $f915ff48c2d8f087$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $f915ff48c2d8f087$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $f915ff48c2d8f087$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $f915ff48c2d8f087$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("c5gcy", function(module, exports) {
$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $44ce6f363203119e$export$cae7c4c591dcc261);

var $axSQB = parcelRequire("axSQB");
const $44ce6f363203119e$export$cae7c4c591dcc261 = ()=>{
    if (false) return 'DEFAULT';
    return (0, $axSQB.localStorage).get((0, $axSQB.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};

});


parcelRegister("bN0Oz", function(module, exports) {
$parcel$export(module.exports, "AiFeaturesOnboardingItemsTypes", () => $4c2a795c7cfef61e$export$22bd1964cf805766);
const $4c2a795c7cfef61e$export$22bd1964cf805766 = {
    DRAFT_PILL: 'DRAFT_PILL',
    SUMMARIZE_COMMENTS: 'SUMMARIZE_COMMENTS',
    SMART_RELATED_ISSUES: 'SMART_RELATED_ISSUES',
    AI_CONTEXT_PANEL: 'AI_CONTEXT_PANEL'
};

});



parcelRegister("1M2hR", function(module, exports) {
$parcel$export(module.exports, "useLocale", () => $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $22bfd94a936ddbb0$export$31652d9c30d7d3f3);

var $eJOHy = parcelRequire("eJOHy");

var $jbr6p = parcelRequire("jbr6p");

var $koAZ4 = parcelRequire("koAZ4");
const $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $jbr6p.defaultLocale);
};
const $22bfd94a936ddbb0$export$31652d9c30d7d3f3 = ()=>{
    const locale = $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eJOHy.useMemo)(()=>(0, $jbr6p.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

const $e8c5fe022e7e442a$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $e8c5fe022e7e442a$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $e8c5fe022e7e442a$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $e8c5fe022e7e442a$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $e8c5fe022e7e442a$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $e8c5fe022e7e442a$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $e8c5fe022e7e442a$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $e8c5fe022e7e442a$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("lpEwy", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
// this is a global state
const $e029db5d7fe89f63$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {
$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {
$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("cZpx8", function(module, exports) {
$parcel$export(module.exports, "getCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $ae6f6bc492f6f5be$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $ae6f6bc492f6f5be$var$cachedIsCompactValues = {};
let $ae6f6bc492f6f5be$var$previousRouteKey;
function $ae6f6bc492f6f5be$export$c47621d55d10906c(key) {
    return $ae6f6bc492f6f5be$var$cachedIsCompactValues[key];
}
function $ae6f6bc492f6f5be$export$568b2dd75c2027b4(isCompactValue, key) {
    $ae6f6bc492f6f5be$var$cachedIsCompactValues[key] = isCompactValue;
}
function $ae6f6bc492f6f5be$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $ae6f6bc492f6f5be$var$previousRouteKey) {
        $ae6f6bc492f6f5be$var$previousRouteKey = currentRouteKey;
        delete $ae6f6bc492f6f5be$var$cachedIsCompactValues[$ae6f6bc492f6f5be$var$previousRouteKey];
    }
}

});


parcelRegister("2nmMZ", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});

parcelRegister("8gkGI", function(module, exports) {
module.exports = new URL("issue-app-skeleton.exp.tpl.4aeaad6d.svg", import.meta.url).toString();

});


const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("7K5Ea", function(module, exports) {
$parcel$export(module.exports, "chromelessLayout", () => $4e04f7c98ccdcac5$export$17e73ed8c35891cb);

var $6dwgv = parcelRequire("6dwgv");
const $4e04f7c98ccdcac5$export$17e73ed8c35891cb = (0, $6dwgv.createLayout)({
    isChromeless: true
});

});
parcelRegister("6dwgv", function(module, exports) {
$parcel$export(module.exports, "coalesce", () => $b345ebe3c14918f6$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $b345ebe3c14918f6$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $b345ebe3c14918f6$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $b345ebe3c14918f6$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $b345ebe3c14918f6$export$e97a7da67a5b8ce4);

var $eJOHy = parcelRequire("eJOHy");

var $2846K = parcelRequire("2846K");

var $eWzpp = parcelRequire("eWzpp");

var $2imLM = parcelRequire("2imLM");

var $4cTDP = parcelRequire("4cTDP");

const $b345ebe3c14918f6$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $b345ebe3c14918f6$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const placeholderName = (0, $4cTDP.fg)('jfp_fix_placeholder_name') ? ($b345ebe3c14918f6$export$6e5538615c060df7(displayName) ?? $b345ebe3c14918f6$export$6e5538615c060df7(name) ?? String(i)).replaceAll('/', '_') : $b345ebe3c14918f6$export$6e5538615c060df7(displayName) ?? $b345ebe3c14918f6$export$6e5538615c060df7(name) ?? i;
        const key = (0, $2846K.uid)(Component);
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
            name: String(placeholderName),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null)));
    });
const $b345ebe3c14918f6$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $b345ebe3c14918f6$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $b345ebe3c14918f6$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $b345ebe3c14918f6$export$3dd437ade36ede40(layout);
};
const $b345ebe3c14918f6$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $b345ebe3c14918f6$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $b345ebe3c14918f6$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $b345ebe3c14918f6$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $b345ebe3c14918f6$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $eWzpp.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null);
    };
    const name = $b345ebe3c14918f6$export$6e5538615c060df7(Component.displayName) ?? $b345ebe3c14918f6$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $b345ebe3c14918f6$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("eWzpp", function(module, exports) {
$parcel$export(module.exports, "useProject", () => $b0e367b82a642155$export$51b1383ef8844a7);

var $eJOHy = parcelRequire("eJOHy");

var $imXGf = parcelRequire("imXGf");

var $dSkLG = parcelRequire("dSkLG");
const $b0e367b82a642155$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useProjectSidebarNavigation)(customContext);
    const project = (0, $eJOHy.useMemo)(()=>data && (0, $imXGf.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("imXGf", function(module, exports) {
$parcel$export(module.exports, "getStyle", () => $6f45f52094bb95b1$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $6f45f52094bb95b1$export$9df5fa0a366163d2);

var $FhXEJ = parcelRequire("FhXEJ");

var $4cTDP = parcelRequire("4cTDP");
const $6f45f52094bb95b1$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $FhXEJ.ProjectStyle).NEXT_GEN : (0, $FhXEJ.ProjectStyle).CLASSIC;
const $6f45f52094bb95b1$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $6f45f52094bb95b1$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey,
        ...typeof project.isLiveTemplate === 'boolean' && (0, $4cTDP.fg)('jira_custom_templates_ux') && {
            isLiveTemplate: project.isLiveTemplate
        }
    });
const $6f45f52094bb95b1$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});

parcelRegister("dSkLG", function(module, exports) {
$parcel$export(module.exports, "useProjectSidebarNavigation", () => $305b347fff7113d4$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $305b347fff7113d4$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $305b347fff7113d4$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $305b347fff7113d4$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $305b347fff7113d4$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $305b347fff7113d4$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $305b347fff7113d4$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $305b347fff7113d4$export$5cf90b625d0e1248);

var $eJOHy = parcelRequire("eJOHy");

var $3qMzf = parcelRequire("3qMzf");

var $6zZVV = parcelRequire("6zZVV");

var $dHUNm = parcelRequire("dHUNm");

var $cY5nO = parcelRequire("cY5nO");

var $9pJMP = parcelRequire("9pJMP");

var $bo7Z6 = parcelRequire("bo7Z6");

var $eJrcF = parcelRequire("eJrcF");

var $9aQsQ = parcelRequire("9aQsQ");
const $305b347fff7113d4$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $9pJMP.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $eJOHy.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $9aQsQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $305b347fff7113d4$export$2bed15cd7d167db5 = ()=>(0, $eJrcF.useResource)((0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$a9d05fc2c1d94895 = ()=>(0, $eJrcF.useResource)((0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$d48e3c3556894533 = ()=>(0, $eJrcF.useResource)((0, $cY5nO.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$24a781cd863077aa = ()=>(0, $eJrcF.useResource)((0, $3qMzf.staticJSMProjectConnectAddonsNavigationResource));
const $305b347fff7113d4$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("3qMzf", function(module, exports) {
$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $7b699886fcf4f1e6$export$fab84295e18e9246);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $7b699886fcf4f1e6$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $7b699886fcf4f1e6$export$fab84295e18e9246 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$7b699886fcf4f1e6$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $7b699886fcf4f1e6$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("bBtQo", function(module, exports) {
$parcel$export(module.exports, "getProjectKeyFromProjectOrIssueKey", () => $0bc483932e4540b9$export$b8279232e05563cb);
$parcel$export(module.exports, "getProjectKey", () => $0bc483932e4540b9$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectIdOrKey", () => $0bc483932e4540b9$export$c072f183553fb7ea);
$parcel$export(module.exports, "getProjectKeyId", () => $0bc483932e4540b9$export$1f7213d0f9054f06);

var $4cTDP = parcelRequire("4cTDP");
const $0bc483932e4540b9$export$89040d072f281f85 = (query)=>query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
const $0bc483932e4540b9$export$b8279232e05563cb = (projectKey, issueKey)=>projectKey || (issueKey || '').split('-')[0];
const $0bc483932e4540b9$export$667f2a0f99c75faa = (match, query)=>$0bc483932e4540b9$export$b8279232e05563cb(match?.params.projectKey || query?.projectKey || query?.['project.key'], (match.params?.issueKey || '').split('-')[0] || ((0, $4cTDP.fg)('handle_context_panel_issue_navigator_path') ? query?.selectedIssue?.split('-')[0] : ''));
const $0bc483932e4540b9$export$c072f183553fb7ea = (match, query)=>$0bc483932e4540b9$export$89040d072f281f85(query) || $0bc483932e4540b9$export$667f2a0f99c75faa(match, query);
const $0bc483932e4540b9$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = $0bc483932e4540b9$export$89040d072f281f85(query);
    const projectKey = $0bc483932e4540b9$export$667f2a0f99c75faa(match, query);
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});

parcelRegister("jfYJb", function(module, exports) {
$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $8ad6472209454f53$export$b15f9f5cf6db359e);

var $3ugTQ = parcelRequire("3ugTQ");
const $8ad6472209454f53$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $3ugTQ.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("6zZVV", function(module, exports) {
$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $36eb967a9a73fcdf$export$b8c6e2666f12f4bb);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $36eb967a9a73fcdf$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $36eb967a9a73fcdf$export$b8c6e2666f12f4bb = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$36eb967a9a73fcdf$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $36eb967a9a73fcdf$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000,
    isCritical: true
});

});

parcelRegister("dHUNm", function(module, exports) {
$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $5245c908f3577c91$export$b662f3f877add30d);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $5245c908f3577c91$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $5245c908f3577c91$export$b662f3f877add30d = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$5245c908f3577c91$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $5245c908f3577c91$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("cY5nO", function(module, exports) {
$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $8255136ae0c43529$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $8255136ae0c43529$export$2d5a704ae6f6b050);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $jfYJb = parcelRequire("jfYJb");
const $8255136ae0c43529$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $8255136ae0c43529$export$e4bf33528101348c = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$8255136ae0c43529$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $8255136ae0c43529$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $8255136ae0c43529$export$2d5a704ae6f6b050 = ()=>(0, $eJrcF.useResource)($8255136ae0c43529$export$e4bf33528101348c);

});

parcelRegister("9pJMP", function(module, exports) {
$parcel$export(module.exports, "getIdentifier", () => $9620e56412c9e007$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $9620e56412c9e007$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $9620e56412c9e007$export$b692cfadccf4e047);

var $4cTDP = parcelRequire("4cTDP");

var $jkKE1 = parcelRequire("jkKE1");

var $2at4v = parcelRequire("2at4v");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $cxKOj = parcelRequire("cxKOj");

var $1JhVO = parcelRequire("1JhVO");
const $9620e56412c9e007$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === 'servicedesk-boards' || routeName === 'servicedesk-calendar' || query['servicedesk.serviceDeskId'] || (routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-custom-calendar' || routeName === 'servicedesk-queues-practice-custom-board' || routeName === 'servicedesk-queues-practice-custom-calendar' || routeName === 'servicedesk-queues-views-config' || routeName === 'servicedesk-practice-views-config') && (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') || routeName === 'servicedesk-list' && (0, $cxKOj.expVal)('jsm_multi_project_list_view_milestone_1', 'isEnabled', false)) {
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return (0, $jkKE1.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    const boardId = (0, $2at4v.getBoardId)(match, query);
    return (0, $jkKE1.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $9620e56412c9e007$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $9620e56412c9e007$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $9620e56412c9e007$export$f2dfc0f7b2d92691 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    getKey: ({ match: match, query: query, route: { name: name } })=>$9620e56412c9e007$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const scopeIdentifier = $9620e56412c9e007$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $1JhVO.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $9620e56412c9e007$export$b692cfadccf4e047 = ()=>(0, $eJrcF.useResource)($9620e56412c9e007$export$f2dfc0f7b2d92691);

});
parcelRegister("jkKE1", function(module, exports) {
$parcel$export(module.exports, "getScopeIdentifier", () => $fd68a0d085bd7604$export$68278f7cf66944f9);

const $fd68a0d085bd7604$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $4a60e80b3610d78a$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $4a60e80b3610d78a$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $4a60e80b3610d78a$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $4a60e80b3610d78a$export$b5a308a17bc991f3 = 'projectKey';
const $4a60e80b3610d78a$export$929d50f83189406c = 'boardId';
const $4a60e80b3610d78a$export$da6f46390e1a426f = 'projectId';


parcelRegister("2at4v", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $68611441a9f8281f$export$557c2f222778cea6);
const $68611441a9f8281f$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("1JhVO", function(module, exports) {
$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $75af829a86061e6c$export$8a51470472777e11);

var $3ugTQ = parcelRequire("3ugTQ");
const $75af829a86061e6c$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $3ugTQ.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("bo7Z6", function(module, exports) {
$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $293b1501ed0e6af1$export$61dad767cf446185);

var $eA736 = parcelRequire("eA736");
var $eJrcF = parcelRequire("eJrcF");

var $8IXJk = parcelRequire("8IXJk");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $293b1501ed0e6af1$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
function $293b1501ed0e6af1$export$61dad767cf446185(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $293b1501ed0e6af1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $eA736.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $eJrcF.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $8IXJk.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}

});
parcelRegister("8IXJk", function(module, exports) {
$parcel$export(module.exports, "usePrefetchableResource", () => $f61fc1df4d840af0$export$99f17ace416cfe75);

var $eJOHy = parcelRequire("eJOHy");
function $f61fc1df4d840af0$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $eJOHy.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("9aQsQ", function(module, exports) {
$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $62cf57129499b564$export$780174995da89d60);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $9pJMP = parcelRequire("9pJMP");

var $eA736 = parcelRequire("eA736");
var $kfvK2 = parcelRequire("kfvK2");
var $eJrcF = parcelRequire("eJrcF");
const $62cf57129499b564$export$90dbde7e33e6e21 = ()=>null;
const $62cf57129499b564$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $eA736.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $62cf57129499b564$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $62cf57129499b564$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource), {
        routerContext: $62cf57129499b564$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $62cf57129499b564$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $eA736.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $62cf57129499b564$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $62cf57129499b564$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource), {
        routerContext: $62cf57129499b564$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $62cf57129499b564$var$useIsOnBoardBasedRoute = (0, $kfvK2.createRouterSelector)(({ route: route, query: query, match: match })=>(0, $9pJMP.getIdentifier)(route.name, match, query)?.identifierType === 'boardId');
const $62cf57129499b564$export$780174995da89d60 = (latestNavInfo)=>{
    const isOnBoardBasedRoute = $62cf57129499b564$var$useIsOnBoardBasedRoute();
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $62cf57129499b564$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $62cf57129499b564$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $eJOHy.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});





parcelRegister("grWOk", function(module, exports) {
$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $82d04be066b2aa57$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $82d04be066b2aa57$export$ad16a91905cefb0a);
const $82d04be066b2aa57$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $82d04be066b2aa57$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $82d04be066b2aa57$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $82d04be066b2aa57$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $82d04be066b2aa57$export$137d6d169f402a59 = [
    $82d04be066b2aa57$var$VENDOR_ASSET_REGEX,
    $82d04be066b2aa57$var$PARCEL_VENDOR_ASSET_REGEX
];
const $82d04be066b2aa57$export$ad16a91905cefb0a = [
    $82d04be066b2aa57$var$VENDOR_ASSET_REGEX,
    $82d04be066b2aa57$var$COMMON_ASSET_REGEX,
    $82d04be066b2aa57$var$PARCEL_VENDOR_ASSET_REGEX,
    $82d04be066b2aa57$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("6xToB", function(module, exports) {
$parcel$export(module.exports, "createEntry", () => $d82625afc3ab60ed$export$344b9c9ab5e66c9a);

var $cZFiO = parcelRequire("cZFiO");
const $d82625afc3ab60ed$export$344b9c9ab5e66c9a = (0, $cZFiO.createRouteEntry);

});
parcelRegister("cZFiO", function(module, exports) {
$parcel$export(module.exports, "createRouteEntry", () => $afe0694b9341fac8$export$136cc45b1cabb43);
/**
 * Create route entry with entrypoint, resources, etc. override
 *
 * @param baseRoute Base route object that contains matching info
 * @param opts Route definition to fill and override
 */ function $afe0694b9341fac8$export$136cc45b1cabb43(baseRoute, opts) {
    // @ts-expect-error Re-using baseRoute to become the full route Object allows us to optimize
    // route transitions as RRR can directly use the route instead of comparing a separate InvariantRoute
    // against the full route list
    // eslint-disable-next-line no-param-reassign
    baseRoute.lazyOpts = opts;
    // @ts-expect-error TODO
    return baseRoute;
}

});


parcelRegister("dk4qA", function(module, exports) {
$parcel$export(module.exports, "issueViewRelayResource", () => $6bf3f1482f81a9c8$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $6bf3f1482f81a9c8$export$252bdba8c8e5f066);
// eslint-disable-next-line jira/import-whitelist

var $e0gCa = parcelRequire("e0gCa");

var $48lPN = parcelRequire("48lPN");

var $dNyY6 = parcelRequire("dNyY6");

var $fspIv = parcelRequire("fspIv");

var $9FYIg = parcelRequire("9FYIg");

var $fEInL = parcelRequire("fEInL");

var $eq3q8 = parcelRequire("eq3q8");

var $5L7qx = parcelRequire("5L7qx");


var $4cTDP = parcelRequire("4cTDP");

var $6NSKd = parcelRequire("6NSKd");
const $6bf3f1482f81a9c8$export$55131006e6699c0a = (0, $5L7qx.browserOnlyResourceWithCondition)(()=>{
    if (0, $9790b8dfe6f31c81$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $4cTDP.fg)('issue-view-ssr-perf-m2');
    return true;
}, (0, $6NSKd.createRelayResourceDeprecated)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: !false,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        const siteAri = (0, $48lPN.JiraSiteAri).create({
            siteId: cloudId
        }).toString();
        const projectKey = issueKey ? (0, $dNyY6.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey || '',
            projectKey: projectKey,
            siteAri: siteAri
        };
        if (issueKey && (0, $4cTDP.fg)('jfp-magma-mainissueaggquery-called-more-detector')) (0, $e0gCa.getAggOverfetchDetector)().setInitialIssueKey(issueKey);
        return {
            parameters: (0, $fEInL.default),
            variables: {
                ...queryVariables,
                ...(0, $fspIv.getMainIssueViewAggQueryVariables)(issueKey)
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $fspIv.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    onFetchComplete: (config)=>{
        if ((0, $4cTDP.fg)('jfp-magma-mainissueaggquery-called-more-detector')) {
            const issueKey = config?.variables?.issueKey;
            if (issueKey) (0, $e0gCa.getAggOverfetchDetector)().onRouterResourceFetchComplete(issueKey);
        }
    }
}));
const $6bf3f1482f81a9c8$export$252bdba8c8e5f066 = (options)=>(0, $9FYIg.useRelayResource)($6bf3f1482f81a9c8$export$55131006e6699c0a, options);

});
parcelRegister("e0gCa", function(module, exports) {
$parcel$export(module.exports, "getAggOverfetchDetector", () => $326f6a3fc6a3fa79$export$5a2305b7a74f6278);

var $9pTd3 = parcelRequire("9pTd3");

var $SvJbY = parcelRequire("SvJbY");
/**
 * This class helps detect if we are making more network requests than we expect for the mainIssueAggQuery query
 */ class $326f6a3fc6a3fa79$var$AggOverfetchDetector {
    /**
	 * This is used for when we initially load the page and don't make additional network requests - eg through ssr
	 * @param issueKey
	 * @param forceSSRFetchSuccess If provided, forces the ssrFetchSuccess value instead of checking the globalThis window variable. This is mainly used for testing
	 */ setInitialIssueKey(issueKey, forceSSRFetchSuccess) {
        if (!this.issueKey) {
            this.issueKey = issueKey;
            if (forceSSRFetchSuccess === undefined) {
                if (globalThis?.window?.SPA_STATE?.['ssr/render_status'] === 'success') this.ssrFetchSuccess = Boolean(globalThis?.window?.SPA_STATE?.['ssr/relay_fetch']?.mainIssueAggQuery);
            } else this.ssrFetchSuccess = forceSSRFetchSuccess;
        }
    }
    reset() {
        if (this.issueKey) this.previousIssueKeys.add(this.issueKey);
        this.issueKey = undefined;
        this.isDisabled = false;
        this.routerResourceFetched = false;
        this.relayFetches = 0;
        this.ssrFetchSuccess = false;
    }
    onRouterResourceFetchComplete(issueKey) {
        /**
		 * We can't correctly tell if we're fetching again if we're navigating to an issue we've previously seen
		 * eg, KAN-1 -> KAN-2 -> KAN-1
		 *
		 * I believe this is because the router resource will grab the data for the issue from the relay store since it already exists
		 * but we then make another fetch outside that to get the correct data
		 *
		 * We end up detecting it as multiple fetches but we only do 1 network request (from non router resource)
		 *
		 * So if we are fetching from router resource for an old issue key, the detector ignores it
		 */ if (this.previousIssueKeys.has(issueKey)) return;
        if (this.issueKey && this.issueKey !== issueKey) this.reset();
        this.issueKey = issueKey;
        if (this.isDisabled) return;
        this.routerResourceFetched = true;
        this.verifyNoOverfetch();
    }
    onRelayFetchComplete(issueKey) {
        if (this.issueKey && this.issueKey !== issueKey) this.reset();
        this.issueKey = issueKey;
        if (this.isDisabled) return;
        this.relayFetches += 1;
        this.verifyNoOverfetch();
    }
    verifyNoOverfetch() {
        if (this.isDisabled || this.hasSentAnalytics) return;
        const { routerResourceFetched: routerResourceFetched, relayFetches: standardFetches, ssrFetchSuccess: ssrFetchSuccess } = this;
        const totalFetches = (routerResourceFetched ? 1 : 0) + standardFetches + (ssrFetchSuccess ? 1 : 0);
        if (totalFetches > 1) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: new Error('AGG query overfetch detected'),
                meta: {
                    id: 'jiraIssueAggOverfetchDetector',
                    packageName: 'jiraIssueFetchOverfetchDetector',
                    teamName: 'Issue View - Kenji'
                },
                attributes: {
                    routerResourceFetched: routerResourceFetched,
                    standardFetches: standardFetches,
                    totalFetches: totalFetches,
                    ssrFetchSuccess: ssrFetchSuccess
                }
            });
            this.hasSentAnalytics = true;
        }
    }
    /**
	 * Disables the overfetch detector for a specific issue key.
	 * This is useful for when we know we will be calling mainIssueAggQuery again intentionally, eg for soft refresh after mutations
	 * @param issueKey The issue key to disable the detector for.
	 */ disableForIssueKey(issueKey) {
        if (this.issueKey === issueKey) this.isDisabled = true;
    }
    constructor(){
        this.previousIssueKeys = new Set();
        this.isDisabled = false;
        this.routerResourceFetched = false;
        this.relayFetches = 0;
        this.ssrFetchSuccess = false;
        this.hasSentAnalytics = false;
    }
}
let $326f6a3fc6a3fa79$var$aggOverfetchDetector = new $326f6a3fc6a3fa79$var$AggOverfetchDetector();
(0, $SvJbY.autoBeforeEachTest)(()=>{
    $326f6a3fc6a3fa79$var$aggOverfetchDetector = new $326f6a3fc6a3fa79$var$AggOverfetchDetector();
});
const $326f6a3fc6a3fa79$export$5a2305b7a74f6278 = ()=>$326f6a3fc6a3fa79$var$aggOverfetchDetector;

});

parcelRegister("48lPN", function(module, exports) {
$parcel$export(module.exports, "JiraSiteAri", () => $3028d8a5865a8fff$export$6c0f81f222d09301);

var $jzuB4 = parcelRequire("jzuB4");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/site/manifest.ts
var $3028d8a5865a8fff$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $jzuB4.JiraSiteAriResourceOwner),
    resourceType: (0, $jzuB4.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $3028d8a5865a8fff$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $3028d8a5865a8fff$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $3028d8a5865a8fff$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("jzuB4", function(module, exports) {
$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $e3f905208997f6cb$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $e3f905208997f6cb$export$886165a991f21644);
// src/jira/site/types.ts
var $e3f905208997f6cb$export$b7d590981b504412 = "jira", $e3f905208997f6cb$export$886165a991f21644 = "site";

});


parcelRegister("dNyY6", function(module, exports) {
$parcel$export(module.exports, "extractProjectKey", () => $d2a27657f5b202f3$export$f1a2e4721b127828);
const $d2a27657f5b202f3$export$f1a2e4721b127828 = (issueKey)=>issueKey.split('-')[0];

});

parcelRegister("fspIv", function(module, exports) {
$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $4a9801c17543db4c$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $4a9801c17543db4c$export$5896c8dc13246fe2);
$parcel$export(module.exports, "getCommentQueriesFromURL", () => $4a9801c17543db4c$export$e2c3bddbfc195841);
/**
 * @fileOverview
 * All variables that get passed in to the mainIssueAggQuery are defined here.
 * The abstraction is necessary because there are multiple call paths to mainIssueAggQuery,
 * so having a single source of truth for the variables eliminates a vector for
 * bugs and inconsistencies when they are invoked.
 *
 * This file will be removed (and therefore the need for the linting exemption) once we reduce
 * the number of discrete call paths for mainIssueAggQuery to one. That work will be done in
 * https://jira.atlassian.com/browse/JIV-19486.
 *
 * Sorry, Tom.
 *
 * <3 Daz
 */ /* eslint-disable jira/ff/inline-usage */ 
var $5KtrL = parcelRequire("5KtrL");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lBYgs = parcelRequire("lBYgs");


var $cblKs = parcelRequire("cblKs");

var $aFPNn = parcelRequire("aFPNn");

var $cDvK0 = parcelRequire("cDvK0");

var $aYncF = parcelRequire("aYncF");

var $hWeHP = parcelRequire("hWeHP");

var $fEInL = parcelRequire("fEInL");

var $fohjD = parcelRequire("fohjD");

var $d60Hm = parcelRequire("d60Hm");
const $4a9801c17543db4c$var$getMainIssueViewAggProvidedVariables = ()=>{
    const providerVariables = (0, $fEInL.default)?.params?.providedVariables ?? {};
    return Object.entries(providerVariables).reduce((acc, [key, provider])=>{
        acc[key] = provider.get();
        return acc;
    }, {});
};
const $4a9801c17543db4c$export$3dd406718c5846c6 = ()=>({
        // eslint-disable-next-line jira/relay/no-hardcoded-agg-params
        jsmSentimentCustomFieldFlag: true,
        issueViewDesignsPanelFlag: (0, $cxKOj.expVal)('collapsed_designs_panel', 'isCollapsedDesignsPanelEnabled', false),
        isFieldsByIdRemoved: (0, $4cTDP.fg)('dfo_remove_fields_by_id'),
        customFieldConfigurationFlag: (0, $4cTDP.fg)('issue_view_field_config_edit'),
        // eslint-disable-next-line jira/relay/no-hardcoded-agg-params
        isPinFieldConfigurabilityEnabled: true,
        jcsFlag: (0, $4cTDP.fg)('jcs_master_flag'),
        // eslint-disable-next-line jira/relay/no-hardcoded-agg-params
        isProactiveCommentSummaryPreferenceEnabled: true,
        // eslint-disable-next-line jira/relay/no-hardcoded-agg-params
        dateFieldsMessageEnabled: true,
        isNavigationMetadataRemoved: (0, $4cTDP.fg)('dfo_remove_navigation_metadata'),
        issueViewCollapsibleSectionsFieldEnabled: (0, $4cTDP.fg)('collapsible-sections-in-issue-view-fg'),
        issueViewUserPreferredLayoutFieldEnabled: (0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate'),
        issueViewDetailsPanelFieldsReorderingEnabled: (0, $cxKOj.expValEquals)('jira-work-item-reordering-fields-v2', 'reorderingBehaviour', 'withDragHandler', 'noReordering') || (0, $cxKOj.expValEquals)('jira-work-item-reordering-fields-v2', 'reorderingBehaviour', 'withoutDragHandler', 'noReordering'),
        isPrioritiesRemoved: (0, $4cTDP.fg)('dfo_remove_priority_field_from_main_query'),
        issueViewRedactionExperience: (0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view'),
        issueViewCoverExperimentEnabled: (0, $4cTDP.fg)('cover_image_issue_view_experiment_kill_switch'),
        isPlaybooksEnabled: (0, $4cTDP.fg)('playbook_in_jsm_ga'),
        isPlaybooksEnabledForSpecificType: (0, $4cTDP.fg)('playbook_visibility_in_service_request'),
        isAutomationDiscoverabilityEnabled: (0, $4cTDP.fg)('automation_discoverability_in_jsm'),
        issueViewRovoDevAgentsPanelEnabled: // These conditions should be included in the conditions for RovodevAgentPanel in content-items-view.tsx
        !(0, $4cTDP.fg)('boysenberry_enable_entitlements_check') && (0, $4cTDP.fg)('devai-issue-view-main-migration') && (!!(0, $aYncF.getLicensedProducts)((0, $hWeHP.default)).devai || (0, $4cTDP.fg)('rovodev_entitlements_user_access_bypass')),
        issueViewRovoDevAgentsPanelEntitlementEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('boysenberry_rovodev_main_release') && (0, $4cTDP.fg)('boysenberry_enable_entitlements_check'),
        mentionedConfluencePageLinksV2PaginationFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4cTDP.fg)('jiv_confluence_remote_link_critical_query'),
        linkedWorkItemsTableEnabled: (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate'),
        issueViewCommentAvatarFlag: (0, $4cTDP.fg)('relay-avatar-iv-llc-comments'),
        issueViewSlackSyncInfoEnabled: (0, $4cTDP.fg)('jira_issue_view_show_slack_sync_info'),
        issueViewNextBestActionsEnabled: (0, $4cTDP.fg)('jira_issue_next_best_actions_fg'),
        isConfigUrlDefer: (0, $4cTDP.fg)('config-url-defer-iv'),
        isDisableConfigUrlDefer: !(0, $4cTDP.fg)('config-url-defer-iv'),
        issueViewGoalsFieldWithShowAllGoalsFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('jira-preview-panel-goals-integration') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel'),
        isSkipParentVisibility: (0, $4cTDP.fg)('remove-parent-visibility-dfo'),
        relayMigrationWebLinksFlag: (0, $4cTDP.fg)('relay-migration-web-links-fetch'),
        relayMigrationIssueFieldAttachments: (0, $4cTDP.fg)('relay_migration_issue_field_attachments'),
        relayMigrationChildrenIssuesSectionEnabled: (0, $4cTDP.fg)('relay_migration_children_issues_section'),
        isSkipIssueLinkTypes: (0, $4cTDP.fg)('remove-issue-link-types-dfo'),
        relayMigrationArchival: (0, $4cTDP.fg)('relay-migration-archival'),
        relayMigrationIssueComments: (0, $4cTDP.fg)('relay-migration-issue-comments'),
        issueViewAtlasProjectFieldEnabled: (0, $cxKOj.expValEquals)('atlassian_projects_-_native_integration', 'cohort', 'variation', 'control'),
        isConnectMultiSelectFieldOptionsRemoved: (0, $4cTDP.fg)('dfo_remove_connect_multi_select_field_options_agg'),
        isConnectSingleSelectFieldOptionsRemoved: (0, $4cTDP.fg)('dfo_remove_connect_single_select_field_options_agg'),
        preloadDevPanelInIssueViewEnabled: (0, $4cTDP.fg)('preload_dev_panel_in_issue_view'),
        shouldIncludeUserFlag: (0, $4cTDP.fg)('remove-user-rest-api'),
        isAssetsFieldAttributesLazyLoadingEnabled: (0, $4cTDP.fg)('assets-field-attributes-lazy-loading-enabled'),
        isAiAgentSessionsPanelEnabled: (0, $4cTDP.fg)('jira_assignable_agents_session_open_beta')
    });
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $4a9801c17543db4c$var$getURLFromWindow = ()=>new URL(window.location.href);
const $4a9801c17543db4c$export$5896c8dc13246fe2 = (issueKey, url = $4a9801c17543db4c$var$getURLFromWindow())=>({
        ...$4a9801c17543db4c$var$getMainIssueViewAggProvidedVariables(),
        ...$4a9801c17543db4c$export$3dd406718c5846c6(),
        ...$4a9801c17543db4c$export$e2c3bddbfc195841(url),
        ...$4a9801c17543db4c$var$getStorageBannerVariables(),
        ...$4a9801c17543db4c$var$getIssueSearchForChildIssueQueryVariables(issueKey),
        ...$4a9801c17543db4c$var$getForgeSpecificVariables(),
        ...$4a9801c17543db4c$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables(),
        ...$4a9801c17543db4c$var$getLinkedIssuesTableQueryVariables(issueKey),
        ...$4a9801c17543db4c$var$getStorageHardLimitVariables()
    });
const $4a9801c17543db4c$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables = ()=>{
    if (typeof window !== 'undefined') {
        const pathname = window.location.pathname;
        const pattern = /^\/jira\/software(?:\/c)?\/projects\/[^/]+\/boards\/\d+\/(calendar|timeline)$/;
        return {
            isInTimelineOrCalendarView: pattern.test(pathname)
        };
    }
    return {
        isInTimelineOrCalendarView: false
    };
};
const $4a9801c17543db4c$export$9f8034ef70f20a00 = ()=>{
    /**
	 * Default fields we're fetching in child issues:
	 * - issuetype: Used to separate base-level and subtasks in epics (see `jira-issue-view-child-issues-panel-merge-subtasks`)
	 */ const childIssuesFieldIds = [
        'issuetype'
    ];
    // If we're not fetching the "Include subtasks" timetracking data through Relay
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4cTDP.fg)('relay-migration-edit-worklog') && !(0, $4cTDP.fg)('jpx-93-unship-legacy-timetracking')) childIssuesFieldIds.push('timetracking');
    // If we're not fetching the progress summary status data through Relay,
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4cTDP.fg)('jira-issue-view-child-issues-panel-realtime-update')) childIssuesFieldIds.push('status');
    return childIssuesFieldIds;
};
const $4a9801c17543db4c$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        childIssuesFieldIds: $4a9801c17543db4c$export$9f8034ef70f20a00()
    });
const $4a9801c17543db4c$var$getLinkedIssuesTableQueryVariables = (issueKey)=>({
        linkedIssuesViewConfigInput: {
            viewInput: {
                namespace: 'LINKED_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        linkedIssuesFieldSetsInput: {
            viewInput: {
                namespace: 'LINKED_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        shouldIncludeRemoteIssues: false,
        isEditableSyncLoadedInIssueLinksTable: (0, $4cTDP.fg)('jira-issue-table-perf-enabled')
    });
const $4a9801c17543db4c$export$e2c3bddbfc195841 = (url)=>{
    const commentTargetId = (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.COMMENTS), url);
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $4a9801c17543db4c$var$getStorageBannerVariables = ()=>({
        issueViewStorageLimitsBannerFlag: (0, $aFPNn.default)((0, $hWeHP.default)).software === (0, $cblKs.FREE_EDITION),
        productKey: (0, $315aedf92e50a945$export$1346c9aa3cbb477d),
        changeOfferingOfferingName: 'standard'
    });
const $4a9801c17543db4c$var$getForgeSpecificVariables = ()=>{
    return {
        forgeTypes: [
            (0, $fohjD.ISSUE_ACTION_MODULE),
            (0, $fohjD.ISSUE_GLANCE_MODULE),
            (0, $fohjD.ISSUE_CONTEXT_MODULE),
            (0, $fohjD.ISSUE_PANEL_MODULE),
            (0, $fohjD.ISSUE_ACTIVITY_MODULE),
            (0, $fohjD.CUSTOM_FIELD_MODULE),
            (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE),
            (0, $fohjD.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, $fohjD.UI_MODIFICATIONS_MODULE)
        ]
    };
};
const $4a9801c17543db4c$var$getStorageHardLimitVariables = ()=>{
    /* ======================================================================================== */ /* To fetch attachmentStorageUsed from JiraQuery, using applicationKey: JIRA_SOFTWARE is appropriate. */ /* The applicationKey is an enum that specifies the application context, and JIRA_SOFTWARE is commonly */ /* used for Jira Software-related queries. */ /* ======================================================================================== */ return {
        applicationKey: (0, $lBYgs.JIRA_SOFTWARE),
        issueViewAddAttachmentFlag: (0, $aFPNn.default)((0, $hWeHP.default)).software === (0, $cblKs.FREE_EDITION) && (0, $cDvK0.default)((0, $hWeHP.default)).software === (0, $5KtrL.LICENSE_STATE_ACTIVE) && (0, $4cTDP.fg)('jira-storage-hard-limit-gate')
    };
};

});
const $315aedf92e50a945$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $315aedf92e50a945$export$e9c56aa3b027d98f = 'jira-customer-service';
const $315aedf92e50a945$export$1346c9aa3cbb477d = 'jira-software';
const $315aedf92e50a945$export$202f50ee62667e32 = 'jira-product-discovery';
const $315aedf92e50a945$export$db515c8cec1e6f79 = 'jira-core';
const $315aedf92e50a945$export$c811f21c9ad05dc2 = 'confluence';
const $315aedf92e50a945$export$961148c98d198270 = 'opsgenie';
const $315aedf92e50a945$export$a310f85340477585 = 'assets';

parcelRegister("fEInL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c51291f3989646ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9543e5d9b1c0d43ecda6ba06a602e480>>
 * @relayHash 644e8734dc0ae71e097d1b816e8e3758
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 614999e68a28a1079b9bad3df5816d1c8c83a27125d89e85f397ea6e2c7cbead

var $3Bt2F = parcelRequire("3Bt2F");

var $aGvfu = parcelRequire("aGvfu");

var $ginDg = parcelRequire("ginDg");

var $cqxuo = parcelRequire("cqxuo");

var $8FjDB = parcelRequire("8FjDB");

var $gAaux = parcelRequire("gAaux");

var $l9xWO = parcelRequire("l9xWO");

var $3jVIX = parcelRequire("3jVIX");

var $kzMwF = parcelRequire("kzMwF");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $1NHqW = parcelRequire("1NHqW");

var $hRj2m = parcelRequire("hRj2m");

var $b5T0d = parcelRequire("b5T0d");

var $lq9ow = parcelRequire("lq9ow");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $5nHY8 = parcelRequire("5nHY8");

var $2HLoK = parcelRequire("2HLoK");

var $ePJhs = parcelRequire("ePJhs");

var $84Nve = parcelRequire("84Nve");

var $j2Uha = parcelRequire("j2Uha");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $jZUJm = parcelRequire("jZUJm");

var $gDQIG = parcelRequire("gDQIG");

var $jLDgo = parcelRequire("jLDgo");

var $2lw0M = parcelRequire("2lw0M");

var $84S8I = parcelRequire("84S8I");

var $8Qoc7 = parcelRequire("8Qoc7");

var $iOvkB = parcelRequire("iOvkB");

var $deyBS = parcelRequire("deyBS");

var $1kOgh = parcelRequire("1kOgh");

var $gODza = parcelRequire("gODza");

var $FU9UR = parcelRequire("FU9UR");

var $2INXH = parcelRequire("2INXH");

var $i3mIO = parcelRequire("i3mIO");

var $gVub6 = parcelRequire("gVub6");

var $8H46l = parcelRequire("8H46l");
const $c51291f3989646ef$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "614999e68a28a1079b9bad3df5816d1c8c83a27125d89e85f397ea6e2c7cbead",
        "metadata": {},
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingrelayprovider": (0, $2lw0M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewredactionexperiencerelayprovider": (0, $84Nve.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcimpedimentflagfragmentfetchrelayprovidertsx": (0, $kzMwF.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraenableclassificationorgdefaultfgrelayprovider": (0, $5nHY8.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $2INXH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcsimplifiedtimetrackingrelayprovider": (0, $8H46l.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud94147hot116492fixattachmentspreviewrelayprovider": (0, $84S8I.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmissueviewaffectedservicesrelayprovider": (0, $deyBS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $1NHqW.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsfieldwithshowallgoalsrelayprovider": (0, $l9xWO.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $8FjDB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": (0, $jLDgo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirarelaymigrationarchivalrelayprovider": (0, $jZUJm.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcremoveissuetypesdforelayprovider": (0, $gVub6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewlayoutepiccolorfgrelayprovider": (0, $b5T0d.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $i3mIO.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconfigurldeferivrelayprovider": (0, $gAaux.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewprogresssummaryschemachangeenabledrelayprovider": (0, $lq9ow.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $ePJhs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcnikedfousehaschildissuesrelayprovider": (0, $gODza.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmagma3191renderchinskeletoninssrrelayprovider": (0, $1kOgh.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcboysenberryissueviewagentspanelrelayprovider": (0, $ginDg.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcboysenberryenableentitlementscheckrelayprovider": (0, $aGvfu.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
        }
    }
};
var $c51291f3989646ef$export$2e2bcd8739ae039 = $c51291f3989646ef$var$node;

});
parcelRegister("3Bt2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ccffb2cac398396$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $2ccffb2cac398396$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expValEquals)('atlassian_projects_-_native_integration', 'cohort', 'variation', 'control');
    }
};

});

parcelRegister("aGvfu", function(module, exports) {
$parcel$export(module.exports, "default", () => $68ddd394b04cbb86$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $68ddd394b04cbb86$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('boysenberry_enable_entitlements_check');
    }
};

});

parcelRegister("ginDg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d37ef2772d46595$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $8d37ef2772d46595$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('bsnbry-rovodev-agents-panel');
    }
};

});

parcelRegister("cqxuo", function(module, exports) {
$parcel$export(module.exports, "default", () => $5da2395408471532$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $5da2395408471532$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
    }
};

});

parcelRegister("8FjDB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c331984c62f9b536$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $c331984c62f9b536$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('conceal_items_in_meatball_menu_ga_fg');
    }
};

});

parcelRegister("gAaux", function(module, exports) {
$parcel$export(module.exports, "default", () => $243b733deddf993e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $243b733deddf993e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('config-url-defer-iv');
    }
};

});

parcelRegister("l9xWO", function(module, exports) {
$parcel$export(module.exports, "default", () => $eba18a144261330b$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $eba18a144261330b$export$2e2bcd8739ae039 = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('jira-preview-panel-goals-integration') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel'));
    }
};

});

parcelRegister("3jVIX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6816ae84318f26ea$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6816ae84318f26ea$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('goals_ssr_smart_card');
    }
};

});

parcelRegister("kzMwF", function(module, exports) {
$parcel$export(module.exports, "default", () => $63f48dff8172d8a9$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $63f48dff8172d8a9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('relay-migration-issue-flag-fetch');
    }
};

});

parcelRegister("l6otE", function(module, exports) {
$parcel$export(module.exports, "default", () => $bebaad44334d69bd$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $bebaad44334d69bd$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store');
    }
};

});

parcelRegister("ad5K7", function(module, exports) {
$parcel$export(module.exports, "default", () => $520683d36ddd8076$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $520683d36ddd8076$var$isIframePreviewPanelInSubtasksEnabled = {
    get () {
        return (0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask');
    }
};
var $520683d36ddd8076$export$2e2bcd8739ae039 = $520683d36ddd8076$var$isIframePreviewPanelInSubtasksEnabled;

});

parcelRegister("hHOEN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e662ece0a0353288$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $e662ece0a0353288$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
    }
};

});

parcelRegister("2Z4v6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f2f02804d9e4b9e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $3f2f02804d9e4b9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_inline_field_config_gate');
    }
};

});

parcelRegister("1NHqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3be344f95049c974$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $3be344f95049c974$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsc_inline_edit_fast_follow_field_types');
    }
};

});

parcelRegister("hRj2m", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c7ac58a937df639$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $1c7ac58a937df639$var$isFieldsByIdRemoved = {
    get () {
        return (0, $4cTDP.fg)('dfo_remove_fields_by_id');
    }
};
var $1c7ac58a937df639$export$2e2bcd8739ae039 = $1c7ac58a937df639$var$isFieldsByIdRemoved;

});

parcelRegister("b5T0d", function(module, exports) {
$parcel$export(module.exports, "default", () => $61b9e36b23873cfb$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $61b9e36b23873cfb$var$isEpicColorFGEnabled = {
    get () {
        return (0, $4cTDP.fg)('issue-view-layout-epic-color-fg');
    }
};
var $61b9e36b23873cfb$export$2e2bcd8739ae039 = $61b9e36b23873cfb$var$isEpicColorFGEnabled;

});

parcelRegister("lq9ow", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a5ef45169b1c977$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6a5ef45169b1c977$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('dfo_consume_child_issues_progress_schema');
    }
};

});

parcelRegister("1PjiU", function(module, exports) {
$parcel$export(module.exports, "default", () => $181ad024341f9175$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $181ad024341f9175$var$JiraAiShowHumanSupervisorAvatarRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jira_ai_show_human_supervisor_avatar');
    }
};
var $181ad024341f9175$export$2e2bcd8739ae039 = $181ad024341f9175$var$JiraAiShowHumanSupervisorAvatarRelayProvider;

});

parcelRegister("jvWSl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4854b286d089865$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $b4854b286d089865$var$isJiraConfluencePageContentEnabled = {
    get () {
        return (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout');
    }
};
var $b4854b286d089865$export$2e2bcd8739ae039 = $b4854b286d089865$var$isJiraConfluencePageContentEnabled;

});

parcelRegister("5nHY8", function(module, exports) {
$parcel$export(module.exports, "default", () => $37d4f595332681c2$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $37d4f595332681c2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('enable_classification_org_default');
    }
};

});

parcelRegister("2HLoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abdea24f5875b44$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $1abdea24f5875b44$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_platform_issue_realtime_updates_used_in_nin');
    }
};

});

parcelRegister("ePJhs", function(module, exports) {
$parcel$export(module.exports, "default", () => $92292d3add361cda$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $92292d3add361cda$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});

parcelRegister("84Nve", function(module, exports) {
$parcel$export(module.exports, "default", () => $f606be28bbc6fb53$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $f606be28bbc6fb53$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view');
    }
};

});

parcelRegister("j2Uha", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8e788cdda2153d8$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $c8e788cdda2153d8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_list_reduce_re_renders');
    }
};

});

parcelRegister("bU8Sj", function(module, exports) {
$parcel$export(module.exports, "default", () => $748aaaa6a5a84440$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $748aaaa6a5a84440$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('frontier-currency-field-d1');
    }
};

});

parcelRegister("g29oX", function(module, exports) {
$parcel$export(module.exports, "default", () => $608f5087ba39dcfa$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $608f5087ba39dcfa$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira-original-estimate-editable-fix');
    }
};

});

parcelRegister("jZUJm", function(module, exports) {
$parcel$export(module.exports, "default", () => $255fc0693787b215$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $255fc0693787b215$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('relay-migration-archival');
    }
};

});

parcelRegister("gDQIG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7655aa3d61c407f$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $d7655aa3d61c407f$var$isJiraTimelineAnalyticsHarmonizationEnabled = {
    get () {
        return (0, $4cTDP.fg)('jira_timeline_analytics_harmonization');
    }
};
var $d7655aa3d61c407f$export$2e2bcd8739ae039 = $d7655aa3d61c407f$var$isJiraTimelineAnalyticsHarmonizationEnabled;

});

parcelRegister("jLDgo", function(module, exports) {
$parcel$export(module.exports, "default", () => $3da0c8b9d8cbd8d6$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $3da0c8b9d8cbd8d6$var$fixDisabledVotingOption = {
    get () {
        return (0, $4cTDP.fg)('jracloud-81233-fix-disabled-voting-option');
    }
};
var $3da0c8b9d8cbd8d6$export$2e2bcd8739ae039 = $3da0c8b9d8cbd8d6$var$fixDisabledVotingOption;

});

parcelRegister("2lw0M", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a8daab1b487e668$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $4a8daab1b487e668$var$fixDisabledVoting = {
    get () {
        return (0, $4cTDP.fg)('jracloud-81233-fix-disabled-voting');
    }
};
var $4a8daab1b487e668$export$2e2bcd8739ae039 = $4a8daab1b487e668$var$fixDisabledVoting;

});

parcelRegister("84S8I", function(module, exports) {
$parcel$export(module.exports, "default", () => $3101d160e40b29c6$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $3101d160e40b29c6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jracloud-94147_hot-116492_fix_attachments_preview');
    }
};

});

parcelRegister("8Qoc7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef773c4214bbea2d$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $ef773c4214bbea2d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor');
    }
};

});

parcelRegister("iOvkB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1076a5ec945e04c$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $f1076a5ec945e04c$var$JscMergedColumnRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jira_list_merged_column_gate');
    }
};
var $f1076a5ec945e04c$export$2e2bcd8739ae039 = $f1076a5ec945e04c$var$JscMergedColumnRelayProvider;

});

parcelRegister("deyBS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e027e166288164b$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $1e027e166288164b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('ssring_affected_services_in_issue_view');
    }
};

});

parcelRegister("1kOgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d3b9eead2d77881$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $2d3b9eead2d77881$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('magma-3191-render-chin-skeleton-in-ssr') && !(0, $4cTDP.fg)('nike_dfo_use_haschildissues_field');
    }
};

});

parcelRegister("gODza", function(module, exports) {
$parcel$export(module.exports, "default", () => $b325427826758166$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $b325427826758166$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('nike_dfo_use_haschildissues_field');
    }
};

});

parcelRegister("FU9UR", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb5963aea9bff0ee$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $eb5963aea9bff0ee$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('nin-strikethrough-resolution-update');
    }
};

});

parcelRegister("2INXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d39c348564f268c0$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $d39c348564f268c0$var$isIssueViewFieldConfigEditEnabled = {
    get () {
        return (0, $4cTDP.fg)('issue_view_field_config_edit');
    }
};
var $d39c348564f268c0$export$2e2bcd8739ae039 = $d39c348564f268c0$var$isIssueViewFieldConfigEditEnabled;

});

parcelRegister("i3mIO", function(module, exports) {
$parcel$export(module.exports, "default", () => $04cfa17728d241ba$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4cTDP = parcelRequire("4cTDP");
var $04cfa17728d241ba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("gVub6", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeea7592427e4f5e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $eeea7592427e4f5e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('remove-issue-types-dfo');
    }
};

});

parcelRegister("8H46l", function(module, exports) {
$parcel$export(module.exports, "default", () => $86bbed3b3012e299$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $86bbed3b3012e299$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jpx-93-simplified-time-tracking');
    }
};

});


parcelRegister("fohjD", function(module, exports) {
$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $21d9ac84d0c10ee4$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $21d9ac84d0c10ee4$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $21d9ac84d0c10ee4$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $21d9ac84d0c10ee4$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $21d9ac84d0c10ee4$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $21d9ac84d0c10ee4$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $21d9ac84d0c10ee4$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $21d9ac84d0c10ee4$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $21d9ac84d0c10ee4$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $21d9ac84d0c10ee4$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $21d9ac84d0c10ee4$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $21d9ac84d0c10ee4$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $21d9ac84d0c10ee4$export$353acf28daa75c79);
$parcel$export(module.exports, "GLOBAL_BACKGROUND_SCRIPT_MODULE", () => $21d9ac84d0c10ee4$export$4384c2fafce7b6f1);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $21d9ac84d0c10ee4$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $21d9ac84d0c10ee4$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $21d9ac84d0c10ee4$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $21d9ac84d0c10ee4$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $21d9ac84d0c10ee4$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $21d9ac84d0c10ee4$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $21d9ac84d0c10ee4$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $21d9ac84d0c10ee4$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $21d9ac84d0c10ee4$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $21d9ac84d0c10ee4$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $21d9ac84d0c10ee4$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $21d9ac84d0c10ee4$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $21d9ac84d0c10ee4$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $21d9ac84d0c10ee4$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $21d9ac84d0c10ee4$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $21d9ac84d0c10ee4$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $21d9ac84d0c10ee4$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $21d9ac84d0c10ee4$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $21d9ac84d0c10ee4$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $21d9ac84d0c10ee4$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $21d9ac84d0c10ee4$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $21d9ac84d0c10ee4$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $21d9ac84d0c10ee4$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $21d9ac84d0c10ee4$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $21d9ac84d0c10ee4$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $21d9ac84d0c10ee4$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $21d9ac84d0c10ee4$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $21d9ac84d0c10ee4$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$51ab2784839ce348);
const $21d9ac84d0c10ee4$export$9af0088c49bdedb = 'PRODUCTION';
const $21d9ac84d0c10ee4$export$71acbd662c478c42 = 'STAGING';
const $21d9ac84d0c10ee4$export$978072fd3fd149 = 'DEVELOPMENT';
const $21d9ac84d0c10ee4$export$ebc15d9cebfd6063 = 'default';
const $21d9ac84d0c10ee4$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $21d9ac84d0c10ee4$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $21d9ac84d0c10ee4$export$cfb15d127f20a01f = 'jira:sprintAction';
const $21d9ac84d0c10ee4$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $21d9ac84d0c10ee4$export$65ebd2e1f63d2992 = 'jira:command';
const $21d9ac84d0c10ee4$export$259bab989b0129d0 = 'jira:issueGlance';
const $21d9ac84d0c10ee4$export$75f224942f595e13 = 'jira:issueContext';
const $21d9ac84d0c10ee4$export$ba0968f9752844 = 'jira:issuePanel';
const $21d9ac84d0c10ee4$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $21d9ac84d0c10ee4$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $21d9ac84d0c10ee4$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $21d9ac84d0c10ee4$export$811b7f067a43b422 = 'jira:uiModifications';
const $21d9ac84d0c10ee4$export$e3887d6bafe8a17 = 'jira:customField';
const $21d9ac84d0c10ee4$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $21d9ac84d0c10ee4$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $21d9ac84d0c10ee4$export$151b03356f566603 = 'jira:projectPage';
const $21d9ac84d0c10ee4$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $21d9ac84d0c10ee4$export$31ac745ab2add7cc = 'jira:globalPage';
const $21d9ac84d0c10ee4$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $21d9ac84d0c10ee4$export$4384c2fafce7b6f1 = 'jira:globalBackgroundScript';
const $21d9ac84d0c10ee4$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $21d9ac84d0c10ee4$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $21d9ac84d0c10ee4$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $21d9ac84d0c10ee4$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $21d9ac84d0c10ee4$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $21d9ac84d0c10ee4$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $21d9ac84d0c10ee4$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $21d9ac84d0c10ee4$export$9b1a91242ce2a1b7 = [
    $21d9ac84d0c10ee4$export$516a8fb49ad5d50e,
    $21d9ac84d0c10ee4$export$65ebd2e1f63d2992,
    $21d9ac84d0c10ee4$export$6cc3a1f2111dee11,
    $21d9ac84d0c10ee4$export$cfb15d127f20a01f,
    $21d9ac84d0c10ee4$export$fcc4a18f46f80f16,
    $21d9ac84d0c10ee4$export$259bab989b0129d0,
    $21d9ac84d0c10ee4$export$75f224942f595e13,
    $21d9ac84d0c10ee4$export$7e2136b4285d29f5,
    $21d9ac84d0c10ee4$export$ba0968f9752844,
    $21d9ac84d0c10ee4$export$cc20a5638825fbb0,
    $21d9ac84d0c10ee4$export$9069d4b945c3d532,
    $21d9ac84d0c10ee4$export$811b7f067a43b422,
    $21d9ac84d0c10ee4$export$e3887d6bafe8a17,
    $21d9ac84d0c10ee4$export$7b7866c04a2ad947,
    $21d9ac84d0c10ee4$export$52e4945e96bd2aa0,
    $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58,
    $21d9ac84d0c10ee4$export$151b03356f566603,
    $21d9ac84d0c10ee4$export$ea0d6ac082b0d636,
    $21d9ac84d0c10ee4$export$31ac745ab2add7cc,
    $21d9ac84d0c10ee4$export$353acf28daa75c79,
    $21d9ac84d0c10ee4$export$25627f012b21b0b9,
    $21d9ac84d0c10ee4$export$8af4cb794979f60d,
    $21d9ac84d0c10ee4$export$5592ab836d562168,
    $21d9ac84d0c10ee4$export$842eb4236828ac9,
    $21d9ac84d0c10ee4$export$42d6a8740fd42e58,
    $21d9ac84d0c10ee4$export$a7186e5a73395db4,
    $21d9ac84d0c10ee4$export$8fbcfe84dc845d17
];
const $21d9ac84d0c10ee4$export$2b8aeda236486576 = 'edit';
const $21d9ac84d0c10ee4$export$c41ce1ec1ea6e73d = 'view';
const $21d9ac84d0c10ee4$export$b37d58c3ed77c139 = 'create';
const $21d9ac84d0c10ee4$export$ab94dbd1d02ac251 = 'contextConfig';
const $21d9ac84d0c10ee4$export$b6a67a3131c6c48d = 'none';
const $21d9ac84d0c10ee4$export$b75dc2bfd20898fe = 5;
const $21d9ac84d0c10ee4$export$8e96118a698216cb = 'native';
const $21d9ac84d0c10ee4$export$9b72a8e9b92658fb = 'basic';
const $21d9ac84d0c10ee4$export$2d6539e7d0553ae7 = 'blank';
const $21d9ac84d0c10ee4$export$ecbd7135d66cb322 = 'unknownSource';
const $21d9ac84d0c10ee4$export$61d882aa7aba51c = 'global-issue-create';
const $21d9ac84d0c10ee4$export$46cb92762d68a048 = 'issue-view';
const $21d9ac84d0c10ee4$export$fe90e46aea58e30b = 'navigation';
const $21d9ac84d0c10ee4$export$c5ccbdb9893f2a6a = 'full-page-app';
const $21d9ac84d0c10ee4$export$eae46a3c13473a8d = 'router';
const $21d9ac84d0c10ee4$export$ac11ee191d09688f = 'legacy';
const $21d9ac84d0c10ee4$export$4346e4e240c84319 = 'organization-panel';
const $21d9ac84d0c10ee4$export$d719bb340dc354e4 = 'assets-import-type';
const $21d9ac84d0c10ee4$export$4b6228758e800433 = 'jira';
const $21d9ac84d0c10ee4$export$70495c8cc141a7a4 = 'jsm';
const $21d9ac84d0c10ee4$export$bc3d408418fdf9d2 = 'cmdb';
const $21d9ac84d0c10ee4$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: [],
    jiraGlobalBackgroundScript: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $21d9ac84d0c10ee4$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$21d9ac84d0c10ee4$export$a48dade1864725a
};
const $21d9ac84d0c10ee4$export$218a328f66b86f7d = ()=>({
        ...$21d9ac84d0c10ee4$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $21d9ac84d0c10ee4$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $21d9ac84d0c10ee4$export$df7774a415710cce = 'com.atlassian.forge:';
const $21d9ac84d0c10ee4$export$51ab2784839ce348 = `${$21d9ac84d0c10ee4$export$df7774a415710cce}${$21d9ac84d0c10ee4$export$3193d714ab54ee26}`;

});

parcelRegister("d60Hm", function(module, exports) {
$parcel$export(module.exports, "COMMENTS", () => $795b06e1e9a5d895$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $795b06e1e9a5d895$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $795b06e1e9a5d895$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $795b06e1e9a5d895$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $795b06e1e9a5d895$export$87557f913748dcff);

var $gRw8I = parcelRequire("gRw8I");

var $eSnSE = parcelRequire("eSnSE");
const $795b06e1e9a5d895$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $795b06e1e9a5d895$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $795b06e1e9a5d895$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $795b06e1e9a5d895$export$dca91ad250f6b082 = ()=>{
    (0, $gRw8I.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $795b06e1e9a5d895$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $795b06e1e9a5d895$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType]];
};
const $795b06e1e9a5d895$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("9FYIg", function(module, exports) {
$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $f6c4de4a04897ac4$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $f6c4de4a04897ac4$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $f6c4de4a04897ac4$export$42ca7b248c7aaee);

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $6uWhG = parcelRequire("6uWhG");

var $7zZ4w = parcelRequire("7zZ4w");

var $g1oKu = parcelRequire("g1oKu");

var $jjfy5 = parcelRequire("jjfy5");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $jHI6h = parcelRequire("jHI6h");
const $f6c4de4a04897ac4$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $f6c4de4a04897ac4$var$getData = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6uWhG.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6uWhG.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $6uWhG.setMark)(endMark);
            (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $jHI6h.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $jjfy5.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6uWhG.setMark)(endMark);
        (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $jHI6h.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $f6c4de4a04897ac4$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false, isCritical: isCritical = false })=>(0, $l1VxS.createResource)({
        type: `${$f6c4de4a04897ac4$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $37Ewn.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            return $f6c4de4a04897ac4$var$getData({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly,
        isCritical: isCritical
    });
const $f6c4de4a04897ac4$export$1cc887c62079ea32 = $f6c4de4a04897ac4$var$createRelayResourceImpl;
const $f6c4de4a04897ac4$export$bbe949b85c06f763 = $f6c4de4a04897ac4$var$createRelayResourceImpl;
const $f6c4de4a04897ac4$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $eJrcF.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});
parcelRegister("7zZ4w", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf162cdbeeb2a572$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $37Ewn = parcelRequire("37Ewn");

var $ecdTx = parcelRequire("ecdTx");

var $j0pwn = parcelRequire("j0pwn");

var $hUl5a = parcelRequire("hUl5a");

var $4cTDP = parcelRequire("4cTDP");

var $hbF3h = parcelRequire("hbF3h");

var $5TDxB = parcelRequire("5TDxB");
let $cf162cdbeeb2a572$var$relayEnvironment;
let $cf162cdbeeb2a572$var$platformRelayEnvironment;
function $cf162cdbeeb2a572$var$getPlatformRelayEnvironment() {
    if (!$cf162cdbeeb2a572$var$platformRelayEnvironment) {
        const sharedRelayEnvironmentConfig = {
            log: (0, $hUl5a.default),
            relayFieldLogger: (0, $hUl5a.requiredFieldLogger),
            networkOptions: (0, $j0pwn.getNetworkOptions)()
        };
        $cf162cdbeeb2a572$var$platformRelayEnvironment = (0, $5TDxB.createRelayEnvironment)(sharedRelayEnvironmentConfig);
    }
    return $cf162cdbeeb2a572$var$platformRelayEnvironment;
}
function $cf162cdbeeb2a572$var$getOriginalRelayEnvironment() {
    if (!$cf162cdbeeb2a572$var$relayEnvironment) {
        const environmentConfig = (0, $ecdTx.getRelayEnvironmentConfig)();
        $cf162cdbeeb2a572$var$relayEnvironment = new (0, $37Ewn.Environment)(environmentConfig);
    }
    return $cf162cdbeeb2a572$var$relayEnvironment;
}
var $cf162cdbeeb2a572$export$2e2bcd8739ae039 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('platform_relay_use_shared_environment_in_jira'), $cf162cdbeeb2a572$var$getPlatformRelayEnvironment, $cf162cdbeeb2a572$var$getOriginalRelayEnvironment);

});
parcelRegister("ecdTx", function(module, exports) {
$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $3a6af9693868c9f1$export$a451c85db2d1cda3);

var $hUl5a = parcelRequire("hUl5a");

var $fFqgB = parcelRequire("fFqgB");

var $lmvVe = parcelRequire("lmvVe");
const $3a6af9693868c9f1$export$a451c85db2d1cda3 = ()=>(0, $lmvVe.getDefaultRelayEnvironmentConfig)({
        network: (0, $fFqgB.getNetwork)(),
        log: (0, $hUl5a.default),
        requiredFieldLogger: $hUl5a.requiredFieldLogger
    });

});
parcelRegister("hUl5a", function(module, exports) {
$parcel$export(module.exports, "requiredFieldLogger", () => $8e53fb941ae19e72$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $8e53fb941ae19e72$export$2e2bcd8739ae039);

var $2QO3b = parcelRequire("2QO3b");

var $eSnSE = parcelRequire("eSnSE");

var $7oY9g = parcelRequire("7oY9g");
const $8e53fb941ae19e72$var$RELAY_CLIENT_ID = 'AGG';
const $8e53fb941ae19e72$var$LOG_NAMESPACE = `relay.${$8e53fb941ae19e72$var$RELAY_CLIENT_ID}.error.graphql`;
const $8e53fb941ae19e72$var$requests = {};
const $8e53fb941ae19e72$var$queries = {};
const $8e53fb941ae19e72$var$resources = {};
const $8e53fb941ae19e72$var$executes = {};
const $8e53fb941ae19e72$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $8e53fb941ae19e72$export$1ab8b98d209afe85 = (event)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData($8e53fb941ae19e72$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $8e53fb941ae19e72$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $8e53fb941ae19e72$export$2e2bcd8739ae039(event) {
    if ((0, $7oY9g.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $8e53fb941ae19e72$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $8e53fb941ae19e72$var$queries[name] = newRequestInfo;
                    $8e53fb941ae19e72$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $8e53fb941ae19e72$var$requests[networkRequestId];
                        delete $8e53fb941ae19e72$var$queries[name];
                    }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $8e53fb941ae19e72$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $2QO3b.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $8e53fb941ae19e72$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $8e53fb941ae19e72$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $8e53fb941ae19e72$var$queries[name] = newRequestInfo;
                        $8e53fb941ae19e72$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $8e53fb941ae19e72$var$queries[node.name];
                        }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $8e53fb941ae19e72$var$resources[event.resourceID];
                    }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $8e53fb941ae19e72$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $8e53fb941ae19e72$var$executes[event.executeId] = {
                name: event.params.name,
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next.start':
            $8e53fb941ae19e72$var$executes[event.executeId].start = performance.now();
            break;
        case 'execute.next.end':
            {
                const now = performance.now();
                const duration = now - $8e53fb941ae19e72$var$executes[event.executeId].start;
                $8e53fb941ae19e72$var$executes[event.executeId].end = now;
                $8e53fb941ae19e72$var$executes[event.executeId].duration = duration;
                break;
            }
        case 'execute.async.module':
            break;
        case 'execute.error':
            delete $8e53fb941ae19e72$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $8e53fb941ae19e72$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $8e53fb941ae19e72$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc.start':
            break;
        case 'store.gc.end':
            break;
        case 'store.gc.interrupted':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("fFqgB", function(module, exports) {
$parcel$export(module.exports, "getNetwork", () => $011c53ed09976f9f$export$7de4970ebfd8206d);

var $37Ewn = parcelRequire("37Ewn");

var $j0pwn = parcelRequire("j0pwn");

var $2yxzK = parcelRequire("2yxzK");

var $lLNFn = parcelRequire("lLNFn");
const $011c53ed09976f9f$export$7de4970ebfd8206d = ()=>{
    if ((0, $lLNFn.isSSR)()) (0, $37Ewn.Network).create((0, $j0pwn.fetch));
    return (0, $37Ewn.Network).create((0, $j0pwn.fetch), (0, $2yxzK.subscribe));
};

});
parcelRegister("j0pwn", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $8376cd7c57be1686$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "getNetworkOptions", () => $8376cd7c57be1686$export$6e239ba29de50840);

var $4cTDP = parcelRequire("4cTDP");

var $14RSn = parcelRequire("14RSn");

var $5ST2i = parcelRequire("5ST2i");

var $3ugTQ = parcelRequire("3ugTQ");

var $gUVFX = parcelRequire("gUVFX");

var $g1oKu = parcelRequire("g1oKu");

var $iFeTU = parcelRequire("iFeTU");

var $cvB0A = parcelRequire("cvB0A");

var $kuzN3 = parcelRequire("kuzN3");

var $jC6NO = parcelRequire("jC6NO");

var $c2hs9 = parcelRequire("c2hs9");

var $kdR84 = parcelRequire("kdR84");

var $ll6Lf = parcelRequire("ll6Lf");
const $8376cd7c57be1686$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    if ((0, $4cTDP.fg)('platform_relay_use_new_multifetch')) return (0, $5ST2i.fetch)(request, variables, cacheConfig, $8376cd7c57be1686$export$6e239ba29de50840());
    return (0, $4cTDP.fg)('jfp-magma-support-defer') ? (0, $kuzN3.fetch)(request, variables, cacheConfig) : (0, $kdR84.fetch)(request, variables, cacheConfig);
};
function $8376cd7c57be1686$var$validateResponse(request, response) {
    const errors = 'errors' in response ? response.errors : undefined;
    if (errors != null) {
        const requestId = response?.extensions?.gateway?.request_id;
        if (!(0, $ll6Lf.blocklist).includes(request.name)) (0, $c2hs9.getLoggingAndMetricsHelper)({
            queryName: request.name,
            operationKind: request.operationKind
        }).logNonBreakingErrors(errors, requestId);
        // @ts-expect-error -- AGGError.path has a type of `string[]`, whereas PayloadError.path has a type of `(string | number)[]`
        (0, $g1oKu.captureErrors)(errors, {
            operationName: request.name,
            requestId: requestId
        });
        // @ts-expect-error -- AGGError.path has a type of `string[]`, whereas PayloadError.path has a type of `(string | number)[]`
        if ((0, $g1oKu.isUnauthenticated)(errors)) return false;
    }
    return true;
}
function $8376cd7c57be1686$var$onInvalidResponse(request, _response) {
    //  Short circuit operation and handle the unauthorized errors.
    (0, $jC6NO.showUnauthenticatedFlag)(request.name);
}
function $8376cd7c57be1686$var$setOptions(endpoint, options) {
    return (0, $ll6Lf.generateOptions)(options, endpoint);
}
const $8376cd7c57be1686$var$earlyScriptPromise = (request, variables)=>!false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
const $8376cd7c57be1686$var$handleAbort = (request, reason)=>{
    // We didn't receive everything!
    const err = new (0, $14RSn.default)(424, `Incomplete handover for relay fetch: ${reason}`);
    err.name = 'ServerToClientError';
    (0, $c2hs9.getLoggingAndMetricsHelper)({
        queryName: request.name,
        operationKind: request.operationKind
    }).logError(err);
};
const $8376cd7c57be1686$export$6e239ba29de50840 = ()=>({
        withErrorHandling: $3ugTQ.withErrorHandling,
        getLoggingAndMetricsHelper: $c2hs9.getLoggingAndMetricsHelper,
        setEndpoint: (0, $gUVFX.getReroutableURL),
        validateResponse: $8376cd7c57be1686$var$validateResponse,
        onInvalidResponse: $8376cd7c57be1686$var$onInvalidResponse,
        setOptions: $8376cd7c57be1686$var$setOptions,
        earlyScriptPromise: $8376cd7c57be1686$var$earlyScriptPromise,
        handleAbort: $8376cd7c57be1686$var$handleAbort,
        queryResponseCache: (0, $iFeTU.getQueryResponseCache)(),
        isServer: false
    });

});
parcelRegister("g1oKu", function(module, exports) {
$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $9437769c7fa7dcb6$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $9437769c7fa7dcb6$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $9437769c7fa7dcb6$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $9437769c7fa7dcb6$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $aXKmr = parcelRequire("aXKmr");
const $9437769c7fa7dcb6$var$errorCollector = new Map();
const $9437769c7fa7dcb6$export$da396ad2a542b095 = 120000; // 2min
const $9437769c7fa7dcb6$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $9437769c7fa7dcb6$var$errorCollector.delete(key);
    }, $9437769c7fa7dcb6$export$da396ad2a542b095);
};
const $9437769c7fa7dcb6$export$c211170518c6d0f6 = (key = (0, $aXKmr.v4)())=>{
    $9437769c7fa7dcb6$var$errorCollector.set(key, []);
    $9437769c7fa7dcb6$var$scheduleCleanup(key);
    return key;
};
const $9437769c7fa7dcb6$export$e0491a0d974dadfa = (key)=>{
    const errors = $9437769c7fa7dcb6$var$errorCollector.get(key);
    $9437769c7fa7dcb6$var$errorCollector.delete(key);
    return errors || [];
};
const $9437769c7fa7dcb6$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $9437769c7fa7dcb6$var$errorCollector.forEach((value, key)=>{
        $9437769c7fa7dcb6$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $9437769c7fa7dcb6$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("iFeTU", function(module, exports) {
$parcel$export(module.exports, "getQueryResponseCache", () => $4724696bda51657e$export$3233e692a93c0cfd);

var $1rzja = parcelRequire("1rzja");

var $9Dhvc = parcelRequire("9Dhvc");

var $LFmXM = parcelRequire("LFmXM");

var $37Ewn = parcelRequire("37Ewn");

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");

var $dJ436 = parcelRequire("dJ436");
function $4724696bda51657e$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $37Ewn.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $4724696bda51657e$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $4724696bda51657e$export$da2711d74cd28aed = [
    'doFetchWithGraphQLErrorsTrackingQuery'
];
class $4724696bda51657e$export$be21c283b097d175 extends (0, $37Ewn.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((_response, key)=>{
            const queryID = $4724696bda51657e$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$4724696bda51657e$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $dJ436.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $14RSn.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $eSnSE.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($1rzja)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $4724696bda51657e$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $4724696bda51657e$export$3233e692a93c0cfd = (0, $LFmXM.default)(()=>{
    return new $4724696bda51657e$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    });
});
const $4724696bda51657e$export$94e535e06b7ade61 = ()=>$4724696bda51657e$export$3233e692a93c0cfd().serialize();

});
parcelRegister("dJ436", function(module, exports) {
$parcel$export(module.exports, "UnusedRelayResponseError", () => $94c71fb7abd30376$export$8431e42d062de453);
class $94c71fb7abd30376$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("cvB0A", function(module, exports) {
$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $87a950ddd1dc6c27$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $87a950ddd1dc6c27$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $87a950ddd1dc6c27$export$e1336d32be02faf4);
const $87a950ddd1dc6c27$export$b5fbc1430cbfd6e1 = (value)=>value;
const $87a950ddd1dc6c27$export$6d670d323806bb37 = new Map();
const $87a950ddd1dc6c27$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $87a950ddd1dc6c27$export$828ac0325bce4536 = (key)=>{
    const result = $87a950ddd1dc6c27$export$6d670d323806bb37.get(key);
    if (result != null) $87a950ddd1dc6c27$export$6d670d323806bb37.delete(key);
    return result;
};
const $87a950ddd1dc6c27$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$87a950ddd1dc6c27$export$6d670d323806bb37.has(key)) $87a950ddd1dc6c27$export$6d670d323806bb37.set(key, promise);
};

});

parcelRegister("kuzN3", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $259e287b96eb4f75$export$e7aa7bc5c1b3cfb3);

var $jPROM = parcelRequire("jPROM");

var $37Ewn = parcelRequire("37Ewn");

var $4cTDP = parcelRequire("4cTDP");

var $8ZO5s = parcelRequire("8ZO5s");

var $g1oKu = parcelRequire("g1oKu");

var $jjfy5 = parcelRequire("jjfy5");

var $iFeTU = parcelRequire("iFeTU");

var $cvB0A = parcelRequire("cvB0A");

var $ePvyd = parcelRequire("ePvyd");

var $icl1h = parcelRequire("icl1h");

var $jHI6h = parcelRequire("jHI6h");

var $estLL = parcelRequire("estLL");

var $7q7TE = parcelRequire("7q7TE");

var $14RSn = parcelRequire("14RSn");

var $gUVFX = parcelRequire("gUVFX");

var $3ugTQ = parcelRequire("3ugTQ");

var $hCAmU = parcelRequire("hCAmU");

var $4Yjc9 = parcelRequire("4Yjc9");

var $jC6NO = parcelRequire("jC6NO");

var $c2hs9 = parcelRequire("c2hs9");

var $ll6Lf = parcelRequire("ll6Lf");
// @ts-expect-error the global is placed there by bifrost SSR. See src/entry-fs/util/render.tsx
const $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $259e287b96eb4f75$var$moduleID = 'relay-fetch';
const $259e287b96eb4f75$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    if (!(0, $4cTDP.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $ll6Lf.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $37Ewn.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $c2hs9.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        (0, $jHI6h.addTraceId)(queryName, (0, $ll6Lf.getTraceIdFromExtensions)(response));
        (0, $ePvyd.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $ll6Lf.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $g1oKu.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $g1oKu.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$259e287b96eb4f75$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            (0, $4cTDP.fg)('switch_relay_fetch_to_post_from_get') ? (0, $4Yjc9.buildGraphqlSmartFetch) : (0, $4Yjc9.buildGraphqlFetch);
            (0, $4cTDP.fg)('platform_relay_use_new_multipart_fetch') ? (0, $hCAmU.buildGraphqlSmartFetch) : (0, $4Yjc9.buildGraphqlFetch);
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $icl1h.getAggEndpoint)(request, cacheConfig);
                const body = (0, $icl1h.getRequestBody)(request, variables);
                let fetchOverNetwork;
                let processMultipartPromiseFn = (0, $4Yjc9.processMultipartPromise);
                if ((0, $4cTDP.fg)('platform_relay_use_new_multipart_fetch')) {
                    fetchOverNetwork = (0, $hCAmU.buildGraphqlSmartFetch)({
                        url: (0, $gUVFX.getReroutableURL)(endpoint),
                        options: (0, $ll6Lf.generateOptions)({
                            body: body
                        }, endpoint),
                        variables: variables,
                        request: request,
                        isServer: false,
                        cacheConfig: cacheConfig
                    });
                    processMultipartPromiseFn = (0, $hCAmU.processMultipartPromise);
                } else fetchOverNetwork = (0, $4cTDP.fg)('switch_relay_fetch_to_post_from_get') ? (0, $4Yjc9.buildGraphqlSmartFetch)({
                    url: endpoint,
                    options: (0, $ll6Lf.generateOptions)({
                        body: body
                    }, endpoint),
                    variables: variables,
                    request: request,
                    logFallback: loggingAndMetrics.logQueryFallbackToPost
                }) : (0, $4Yjc9.buildGraphqlFetch)(endpoint, (0, $ll6Lf.generateOptions)({
                    body: body
                }, endpoint));
                const initialSource = ()=>!false && earlyScriptPromise ? $259e287b96eb4f75$var$withErrorHandling(earlyScriptPromise) : $259e287b96eb4f75$var$withErrorHandling(fetchOverNetwork());
                const responses = processMultipartPromiseFn(()=>(0, $8ZO5s.retryOnError)(initialSource, {
                        retryFunc: ()=>$259e287b96eb4f75$var$withErrorHandling(fetchOverNetwork()),
                        retryPredicate: (0, $ll6Lf.shouldRetry),
                        retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                        onRetry: loggingAndMetrics.logErrorRetry
                    }));
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (false) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $jjfy5.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $jjfy5.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $jjfy5.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (response)=>{
                        if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $estLL.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (!validateResponse(singularResponse)) {
                                //  Short circuit operation and handle the unauthorized errors.
                                (0, $jC6NO.showUnauthenticatedFlag)(queryName);
                                responseShouldHang = true;
                                return;
                            }
                            enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (false && requestID != null) (0, $iFeTU.getQueryResponseCache)().appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = (0, $iFeTU.getQueryResponseCache)().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                    (0, $iFeTU.getQueryResponseCache)().delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $7q7TE.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $7q7TE.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                // We didn't receive everything!
                                const err = new (0, $14RSn.default)(424, `Incomplete handover for relay fetch: ${reason}`);
                                err.name = 'ServerToClientError';
                                loggingAndMetrics.logError(err);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
function $259e287b96eb4f75$var$withErrorHandling(source) {
    return source.then((0, $3ugTQ.handleErrors)).catch((0, $3ugTQ.handleNetworkErrors));
}

});
parcelRegister("4Yjc9", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $c10481344656009f$export$f76505a7f2969e4e);
$parcel$export(module.exports, "buildGraphqlFetch", () => $c10481344656009f$export$744180da2870332e);
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $c10481344656009f$export$33c9c992c7855d86);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $1O6Yz = parcelRequire("1O6Yz");

var $37Ewn = parcelRequire("37Ewn");


var $gUVFX = parcelRequire("gUVFX");

var $kinkG = parcelRequire("kinkG");

var $eBhI6 = parcelRequire("eBhI6");

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $eSnSE = parcelRequire("eSnSE");
function $c10481344656009f$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function $c10481344656009f$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch (error) {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function $c10481344656009f$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $c10481344656009f$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $c10481344656009f$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $c10481344656009f$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $c10481344656009f$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        async function* streamReader() {
            // @ts-expect-error a Response object in Node is streamable
            for await (const chunk of response.body){
                const newText = decoder.decode(chunk, {
                    stream: true
                });
                yield newText;
            }
        }
        $c10481344656009f$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        observer.error(new Error('Failed to read from response body', {
            cause: e
        }));
    }
}
function $c10481344656009f$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>observer.next(data)).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $c10481344656009f$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>{
        observer.error(new Error(`Error while parsing text response (Content-Type: ${response?.headers?.get('content-type')}): ${error instanceof Error ? error.message : String(error)}`));
    });
}
function $c10481344656009f$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $37Ewn.Observable).create((observer)=>{
        result.then((response)=>{
            // Import log at the top of the file if not already imported
            // import log from '@atlassian/jira-common-util-logging/src/log.tsx';
            if (response.status === (0, $3a153a61cf6b691b$export$3288b14b6745c572)) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $c10481344656009f$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $c10481344656009f$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $c10481344656009f$var$handleMultipartResponse(response, observer);
            else {
                if ((0, $4cTDP.fg)('jira-relay-verbose-logging')) {
                    // Log all response headers using Jira's logging system
                    const allHeaders = {};
                    response.headers.forEach((value, key)=>{
                        allHeaders[key] = value;
                    });
                    (0, $eSnSE.default).unsafeErrorWithCustomerData('relay.multipart.response', 'Response headers', {
                        ...allHeaders
                    });
                }
                if ((0, $4cTDP.fg)('jira-relay-text-response-for-default-content-type')) $c10481344656009f$var$handleTextResponse(response, observer);
                else observer.error(new Error(`Unsupported content type: ${contentType}`));
            }
        }).catch((error)=>observer.error(error));
    });
}
function $c10481344656009f$export$c874c20f7c9f97c(source) {
    return source.then((0, $3ugTQ.handleErrors)).catch((0, $3ugTQ.handleNetworkErrors));
}
const $c10481344656009f$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
].join(', ');
function $c10481344656009f$export$744180da2870332e(url, options) {
    const postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: $c10481344656009f$var$relayDeferAcceptableFormats
        }
    };
    const composedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))((0, $eBhI6.getDefaultOptions)(url), options, postOptions);
    const fetchUrl = (0, $gUVFX.getReroutableURL)(url);
    const fetchHeaders = (0, $kinkG.applyObservabilityHeaders)(url, composedOptions);
    return ()=>fetch(fetchUrl, fetchHeaders);
}
const $c10481344656009f$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $c10481344656009f$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $c10481344656009f$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $c10481344656009f$export$5ad31d96a9271d42({ url: url, variables: variables, request: request, headers: headers }) {
    if (false) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const serializedVariables = JSON.stringify(variables);
    const queryLength = url.length + serializedVariables.length;
    const headersSize = $c10481344656009f$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $c10481344656009f$var$MAX_QUERY_LENGTH && headersSize <= $c10481344656009f$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function $c10481344656009f$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, logFallback: logFallback }) {
    const requestOptions = {
        headers: {
            Accept: $c10481344656009f$var$relayDeferAcceptableFormats,
            'Content-Type': 'application/json'
        }
    };
    const composedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))((0, $eBhI6.getDefaultOptions)(url), options, requestOptions);
    let fetchUrl = (0, $gUVFX.getReroutableURL)(url);
    const fetchOptions = (0, $kinkG.applyObservabilityHeaders)(url, composedOptions);
    const { isGetRequest: isGetRequest, reason: reason } = $c10481344656009f$export$5ad31d96a9271d42({
        url: fetchUrl,
        variables: variables,
        request: request,
        headers: fetchOptions.headers
    });
    if (isGetRequest) {
        fetchOptions.method = 'GET';
        const params = new URLSearchParams();
        params.append('variables', JSON.stringify(variables));
        fetchUrl += `${fetchUrl.includes('?') ? '&' : '?'}${params.toString()}`;
        delete fetchOptions.body; // Not needed for GET
        if (fetchOptions.headers && 'Content-Type' in fetchOptions.headers) delete fetchOptions.headers['Content-Type']; // Not needed for GET
    } else {
        fetchOptions.method = 'POST';
        // @ts-expect-error - headers are not typed
        fetchOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
        if (reason) logFallback?.(reason);
    }
    return ()=>fetch(fetchUrl, fetchOptions);
}
function $c10481344656009f$export$2586da7b5f4b5763(url, options) {
    const fetchFn = $c10481344656009f$export$744180da2870332e(url, options);
    return $c10481344656009f$export$f76505a7f2969e4e(()=>$c10481344656009f$export$c874c20f7c9f97c(fetchFn()));
}
function $c10481344656009f$export$53a48697d787fffd(params) {
    const fetchFn = $c10481344656009f$export$33c9c992c7855d86(params);
    return $c10481344656009f$export$f76505a7f2969e4e(()=>$c10481344656009f$export$c874c20f7c9f97c(fetchFn()));
}

});

parcelRegister("jC6NO", function(module, exports) {
$parcel$export(module.exports, "showUnauthenticatedFlag", () => $82aff5bc2beb8971$export$758fcc357484571e);

var $cSXp8 = parcelRequire("cSXp8");

var $2Mqjh = parcelRequire("2Mqjh");

var $eeSEl = parcelRequire("eeSEl");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $82aff5bc2beb8971$var$reloadPage = ()=>window.location.reload();
const $82aff5bc2beb8971$var$sendAnalyticEvent = (operationName)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $82aff5bc2beb8971$var$sendLoginClickEvent = (operationName)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'loginButton',
            attributes: {
                operation: operationName,
                source: globalThis.window?.location?.pathname ?? '',
                referrer: globalThis.document?.referrer ?? '',
                timestamp: new Date().toISOString(),
                userAgent: globalThis.navigator?.userAgent ?? ''
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $82aff5bc2beb8971$export$758fcc357484571e = (operationName)=>{
    (0, $cSXp8.showFlag)({
        type: 'error',
        title: (0, $eeSEl.default).title,
        description: (0, $eeSEl.default).description,
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $eeSEl.default).login,
                onClick: ()=>{
                    $82aff5bc2beb8971$var$sendLoginClickEvent(operationName);
                    $82aff5bc2beb8971$var$reloadPage();
                }
            }
        ]
    });
    $82aff5bc2beb8971$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("cSXp8", function(module, exports) {
$parcel$export(module.exports, "showFlag", () => $a353d834fb3ab07d$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $a353d834fb3ab07d$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $a353d834fb3ab07d$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $a353d834fb3ab07d$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $a353d834fb3ab07d$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $a353d834fb3ab07d$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $a353d834fb3ab07d$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $a353d834fb3ab07d$export$c126d8b307b8ab86);

var $fyI8g = parcelRequire("fyI8g");

var $4LLrs = parcelRequire("4LLrs");

var $iepag = parcelRequire("iepag");

var $jn1Cb = parcelRequire("jn1Cb");
const $a353d834fb3ab07d$export$e12b2cc6b75b006b = (0, $4LLrs.default)((0, $iepag.store).dispatch);
const $a353d834fb3ab07d$export$900a08a292ad23cd = (0, $fyI8g.default)((0, $iepag.store).dispatch);
const $a353d834fb3ab07d$var$dismissFlagById = (id)=>{
    $a353d834fb3ab07d$export$900a08a292ad23cd((0, $fyI8g.dismissFlag)(id));
};
const $a353d834fb3ab07d$var$hasFlag = (id)=>Boolean((0, $iepag.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $a353d834fb3ab07d$export$dbb055af53fd81a0 = {
    showFlag: $a353d834fb3ab07d$export$e12b2cc6b75b006b,
    dismissFlag: $a353d834fb3ab07d$export$900a08a292ad23cd
};
const $a353d834fb3ab07d$export$eee61a1aafe3884 = ()=>({
        showFlag: $a353d834fb3ab07d$export$e12b2cc6b75b006b,
        dismissFlag: $a353d834fb3ab07d$var$dismissFlagById,
        hasFlag: $a353d834fb3ab07d$var$hasFlag
    });
const $a353d834fb3ab07d$export$dc4f8132c3090b32 = ()=>$a353d834fb3ab07d$export$dbb055af53fd81a0;
const $a353d834fb3ab07d$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $jn1Cb.DISMISS_COMMAND);
const $a353d834fb3ab07d$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $a353d834fb3ab07d$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $a353d834fb3ab07d$export$63ffd7d99470afd4 = (flag)=>!$a353d834fb3ab07d$export$14b1864d9cf0809f(flag) && !$a353d834fb3ab07d$export$d84ce5adcee46025(flag) && !$a353d834fb3ab07d$export$cd5f9f2b991b82d9(flag);
const $a353d834fb3ab07d$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("fyI8g", function(module, exports) {
$parcel$export(module.exports, "dismissFlag", () => $e8afa80f456b692c$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $e8afa80f456b692c$export$2e2bcd8739ae039);

var $jQpPN = parcelRequire("jQpPN");

var $jn1Cb = parcelRequire("jn1Cb");
const $e8afa80f456b692c$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $jn1Cb.DISMISS_COMMAND),
        id: flagId
    });
const $e8afa80f456b692c$var$dismissFlagService = (dispatch)=>(action)=>{
        dispatch((0, $jQpPN.dismissFlagAction)(action.id));
    };
var $e8afa80f456b692c$export$2e2bcd8739ae039 = $e8afa80f456b692c$var$dismissFlagService;

});
parcelRegister("jQpPN", function(module, exports) {
$parcel$export(module.exports, "SHOW", () => $339a30169cab61dc$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $339a30169cab61dc$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $339a30169cab61dc$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $339a30169cab61dc$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $339a30169cab61dc$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $339a30169cab61dc$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $339a30169cab61dc$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $339a30169cab61dc$export$aad8462122ac592b);
const $339a30169cab61dc$export$9d04158a25ce4cd = 'state.SHOW';
const $339a30169cab61dc$export$57bf213be019eeb0 = (payload)=>({
        type: $339a30169cab61dc$export$9d04158a25ce4cd,
        payload: payload
    });
const $339a30169cab61dc$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $339a30169cab61dc$export$abf286bbe7073aba = (payload)=>({
        type: $339a30169cab61dc$export$b31a07d2e6382678,
        payload: payload
    });
const $339a30169cab61dc$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $339a30169cab61dc$export$4818b3c52448050d = (payload)=>({
        type: $339a30169cab61dc$export$1eb56620df104bf,
        payload: payload
    });
const $339a30169cab61dc$export$4a991c87e640ef77 = 'state.RESET';
const $339a30169cab61dc$export$aad8462122ac592b = ()=>({
        type: $339a30169cab61dc$export$4a991c87e640ef77
    });

});

parcelRegister("jn1Cb", function(module, exports) {
$parcel$export(module.exports, "DISMISS_COMMAND", () => $894a79958bf49709$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $894a79958bf49709$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $894a79958bf49709$export$188cdb77b72629d7);
const $894a79958bf49709$export$e705274c5e156b93 = 'DISMISS';
const $894a79958bf49709$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $894a79958bf49709$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("4LLrs", function(module, exports) {
$parcel$export(module.exports, "default", () => $e984c94bc642c307$export$2e2bcd8739ae039);

var $aXKmr = parcelRequire("aXKmr");

var $jQpPN = parcelRequire("jQpPN");

var $jn1Cb = parcelRequire("jn1Cb");
const $e984c94bc642c307$var$showFlagService = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $jQpPN.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $jn1Cb.toFlagId)((0, $aXKmr.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $jQpPN.show)(newFlag));
        return flagId;
    };
var $e984c94bc642c307$export$2e2bcd8739ae039 = $e984c94bc642c307$var$showFlagService;

});

parcelRegister("iepag", function(module, exports) {
$parcel$export(module.exports, "store", () => $b6eb1fd49082ba20$export$6f57813fe9f31bf9);

var $3xLQn = parcelRequire("3xLQn");
const $b6eb1fd49082ba20$export$6f57813fe9f31bf9 = (0, $3xLQn.createStore)();

});
parcelRegister("3xLQn", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $1e1d3760ccc29bb4$export$f51a9068ac82ea43);

var $gs6vs = parcelRequire("gs6vs");

var $6LntZ = parcelRequire("6LntZ");
const $1e1d3760ccc29bb4$export$f51a9068ac82ea43 = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'flags',
        rootReducer: $6LntZ.default,
        rootEpic: rootEpic
    });

});
parcelRegister("gs6vs", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5fb2723e7e827ee$export$2e2bcd8739ae039);
/// <reference types="node" />

var $eJOHy = parcelRequire("eJOHy");

var $7HHI1 = parcelRequire("7HHI1");

var $dFg4o = parcelRequire("dFg4o");

var $4tM8k = parcelRequire("4tM8k");

var $abRw5 = parcelRequire("abRw5");

var $kqAfW = parcelRequire("kqAfW");

var $i1nY5 = parcelRequire("i1nY5");

/**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ const $f5fb2723e7e827ee$var$initiateStore = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $i1nY5.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $abRw5.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("f8FDM"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $4tM8k.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $7HHI1.createStore)((0, $dFg4o.enableBatching)(rootReducer), initialState, (0, $kqAfW.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $eJOHy.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $7HHI1.compose)(...enhancers, (0, $7HHI1.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};
var $f5fb2723e7e827ee$export$2e2bcd8739ae039 = $f5fb2723e7e827ee$var$initiateStore;

});
parcelRegister("abRw5", function(module, exports) {
$parcel$export(module.exports, "debugEnabled", () => $bfde42121ad38c1d$export$342c99cc1e9bc5c6);
const $bfde42121ad38c1d$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("kqAfW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0f35d50b3b5f50f$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");
// An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
const $f0f35d50b3b5f50f$var$composeWithDevtools = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $7HHI1.compose;
};
var $f0f35d50b3b5f50f$export$2e2bcd8739ae039 = $f0f35d50b3b5f50f$var$composeWithDevtools;

});

parcelRegister("i1nY5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d528e7f36d931b18$export$2e2bcd8739ae039);
class $d528e7f36d931b18$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("6LntZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6d90b7793efce50$export$2e2bcd8739ae039);

var $a6gy0 = parcelRequire("a6gy0");

var $aXKmr = parcelRequire("aXKmr");

var $jQpPN = parcelRequire("jQpPN");
const $a6d90b7793efce50$var$defaultState = {
    flags: []
};
/**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ const $a6d90b7793efce50$var$rootReducer = (state = $a6d90b7793efce50$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jQpPN.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($a6gy0)))([
                    {
                        id: (0, $aXKmr.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $jQpPN.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $jQpPN.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $jQpPN.RESET:
            return $a6d90b7793efce50$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $a6d90b7793efce50$export$2e2bcd8739ae039 = $a6d90b7793efce50$var$rootReducer;

});




parcelRegister("eeSEl", function(module, exports) {
$parcel$export(module.exports, "default", () => $97602d570e003f87$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $97602d570e003f87$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});
var $97602d570e003f87$export$2e2bcd8739ae039 = $97602d570e003f87$var$messages;

});


parcelRegister("c2hs9", function(module, exports) {
$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $3d28a75f7345d649$export$726e1df8186bb981);

var $1rzja = parcelRequire("1rzja");

var $9Dhvc = parcelRequire("9Dhvc");

var $jPROM = parcelRequire("jPROM");

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");
const $3d28a75f7345d649$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $3d28a75f7345d649$var$LOG_NAMESPACE_INFO = 'relay.AGG.info.logQueryFallbackToPost';
const $3d28a75f7345d649$var$errorLogFn = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_relay_fetch_use_log_unsafe'), (0, $eSnSE.default).unsafeErrorWithCustomerData, (0, $eSnSE.default).safeErrorWithoutCustomerData);
const $3d28a75f7345d649$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    const logErrorRetry = (error, retryAttempt)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
            'statusCode'
        ], null);
        const errorType = error instanceof (0, $14RSn.default) ? 'network' : 'unknown';
        // Log any errors even in SSR
        $3d28a75f7345d649$var$errorLogFn($3d28a75f7345d649$var$LOG_NAMESPACE, `[${errorType} error]`, {
            message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($1rzja)))(errorType)} error]: ${error?.message ?? ''}`,
            errorType: errorType,
            statusCode: statusCode,
            queryName: queryName,
            operationKind: operationKind,
            errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                'name'
            ], null),
            retryAttempt: retryAttempt,
            isGetMethodFeatureOn: (0, $4cTDP.fg)('switch_relay_fetch_to_post_from_get')
        });
    };
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && $3d28a75f7345d649$var$errorLogFn($3d28a75f7345d649$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: logErrorRetry,
        logErrorRetry: logErrorRetry,
        logQueryFallbackToPost: (reason)=>{
            if (false && reason === 'SSR') return;
            (0, $eSnSE.default).safeInfoWithoutCustomerData($3d28a75f7345d649$var$LOG_NAMESPACE_INFO, 'logQueryFallbackToPost', {
                queryName: queryName,
                operationKind: operationKind,
                reason: reason
            });
        }
    };
};

});

parcelRegister("ll6Lf", function(module, exports) {
$parcel$export(module.exports, "checkAuthentication", () => $b1384809f654b8cb$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $b1384809f654b8cb$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $b1384809f654b8cb$export$9dec0f42cc67f6ab);
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $b1384809f654b8cb$export$eefb7f54c3b07211);
$parcel$export(module.exports, "generateOptions", () => $b1384809f654b8cb$export$c21133b4499f5374);
$parcel$export(module.exports, "shouldRetry", () => $b1384809f654b8cb$export$7bfea3c3d460ecd8);

var $jPROM = parcelRequire("jPROM");

var $1O6Yz = parcelRequire("1O6Yz");

var $4cTDP = parcelRequire("4cTDP");

var $8RHPx = parcelRequire("8RHPx");

var $8lcvP = parcelRequire("8lcvP");

var $14RSn = parcelRequire("14RSn");

var $eBhI6 = parcelRequire("eBhI6");

var $8ZO5s = parcelRequire("8ZO5s");

var $kIz4h = parcelRequire("kIz4h");

var $aMkcV = parcelRequire("aMkcV");

var $hWeHP = parcelRequire("hWeHP");
let $b1384809f654b8cb$var$redirecting = false;
const $b1384809f654b8cb$export$ae8f795c4c44d494 = ()=>{
    $b1384809f654b8cb$var$redirecting = false;
};
const $b1384809f654b8cb$var$markAsRedirecting = ()=>{
    $b1384809f654b8cb$var$redirecting = true;
};
if (typeof window !== 'undefined') // Mark as redirecting, when we're unloading the page to prevent double/unwatend redirection.
window.addEventListener('beforeunload', ()=>{
    $b1384809f654b8cb$var$markAsRedirecting();
});
const $b1384809f654b8cb$var$redirect = ()=>{
    const identity = (0, $8RHPx.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $b1384809f654b8cb$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$b1384809f654b8cb$var$redirecting) {
        const heartbeatService = (0, $8lcvP.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            if (!$b1384809f654b8cb$var$redirecting) $b1384809f654b8cb$var$redirect();
            // Set flag to prevent multiple redirects
            $b1384809f654b8cb$var$markAsRedirecting();
        }
    }
    return $b1384809f654b8cb$var$redirecting;
};
const $b1384809f654b8cb$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $b1384809f654b8cb$export$9dec0f42cc67f6ab = (_queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $8ZO5s.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $b1384809f654b8cb$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
const $b1384809f654b8cb$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $kIz4h.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    let atlAttribution = {};
    if ((0, $4cTDP.fg)('pass_extra_headers_to_agg')) {
        const avpWorkspaceId = (0, $hWeHP.default)('ajs-avp-workspace-id');
        const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
        atlAttribution = {
            atlWorkspaceId: avpWorkspaceId,
            tenantId: cloudId,
            product: 'Atlassian Jira',
            service: 'afm-frontend'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $eBhI6.getDefaultOptions)(url),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $aMkcV.RelayExperimentalApis).join(','),
            'atl-attribution': JSON.stringify(atlAttribution),
            ...csrfTokenHeader
        }
    });
};
const $b1384809f654b8cb$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $14RSn.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});


parcelRegister("kdR84", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $4faf0d1ae15fc4dc$export$e7aa7bc5c1b3cfb3);

var $jPROM = parcelRequire("jPROM");

var $37Ewn = parcelRequire("37Ewn");

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $8ZO5s = parcelRequire("8ZO5s");

var $g1oKu = parcelRequire("g1oKu");

var $jjfy5 = parcelRequire("jjfy5");

var $iFeTU = parcelRequire("iFeTU");

var $cvB0A = parcelRequire("cvB0A");

var $ePvyd = parcelRequire("ePvyd");

var $icl1h = parcelRequire("icl1h");

var $jHI6h = parcelRequire("jHI6h");

var $jC6NO = parcelRequire("jC6NO");

var $c2hs9 = parcelRequire("c2hs9");

var $ll6Lf = parcelRequire("ll6Lf");
const $4faf0d1ae15fc4dc$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    if (!(0, $4cTDP.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $ll6Lf.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $37Ewn.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $c2hs9.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $icl1h.getAggEndpoint)(request, cacheConfig);
            const body = (0, $icl1h.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = (0, $iFeTU.getQueryResponseCache)().get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) (0, $iFeTU.getQueryResponseCache)().delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $8ZO5s.retryOnError)(()=>(0, $3ugTQ.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $3ugTQ.performPostRequest)(endpoint, (0, $ll6Lf.generateOptions)({
                        body: body
                    }, endpoint)),
                retryPredicate: (0, $ll6Lf.shouldRetry),
                retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $3ugTQ.performPostRequestWithRetry)(endpoint, {
                ...(0, $ll6Lf.generateOptions)({
                    body: body
                }, endpoint),
                retryPredicate: (0, $ll6Lf.shouldRetry),
                retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $jHI6h.addTraceId)(queryName, (0, $ll6Lf.getTraceIdFromExtensions)(response));
                (0, $ePvyd.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!(0, $ll6Lf.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $g1oKu.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $g1oKu.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $jC6NO.showUnauthenticatedFlag)(queryName);
                        // Surprise behaviour: the observable should hang indefinitely here!
                        // At least, that is the expectation of existing code; see src/packages/issue/issue-view/src/integration-tests/experience-tracking/view.cy-integration.tsx
                        // Which assumes that the operation never completes, so relay never receives a (null) response, so it never complains about the data.
                        // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) (0, $iFeTU.getQueryResponseCache)().setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) // todo: stop sending the value of the promise to QueryPromisesMap. Might happen as part of cleaning up the feature gate for defer support writ large.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $jjfy5.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});


parcelRegister("lLNFn", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $96879960c01891ca$export$48d7c418edadb60c);
const $96879960c01891ca$export$48d7c418edadb60c = ()=>false ?? false;

});





parcelRegister("eq3q8", function(module, exports) {
$parcel$export(module.exports, "getIssueKey", () => $f3a8bc7a8cf56aaa$export$4a030f6192bebe03);
const $f3a8bc7a8cf56aaa$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

parcelRegister("5L7qx", function(module, exports) {
$parcel$export(module.exports, "resourceWithCondition", () => $e024e4a1466467c1$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $e024e4a1466467c1$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $e024e4a1466467c1$export$5284559c6d2f1a7b);

var $cJYBV = parcelRequire("cJYBV");
const $e024e4a1466467c1$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $cJYBV.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, storeContext)=>conditionGetter() ? resourceTrue.getData(routerContext, storeContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        },
        get skipBrowser () {
            return resourceTrue.skipBrowser;
        }
    };
const $e024e4a1466467c1$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $e024e4a1466467c1$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $e024e4a1466467c1$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $e024e4a1466467c1$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("cJYBV", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $36187b280b89d04f$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $36187b280b89d04f$export$5664a170ac5a9781);
const $36187b280b89d04f$export$eb37f5d331ea4de4 = 'NOOP';
const $36187b280b89d04f$export$5664a170ac5a9781 = 5000;

});


// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

parcelRegister("6NSKd", function(module, exports) {
$parcel$export(module.exports, "withResourceEarlyData", () => $551b7a7af70655c3$export$22da5fb8c8200986);
$parcel$export(module.exports, "createRelayResourceDeprecated", () => $551b7a7af70655c3$export$2e279339bedcd427);

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $4cTDP = parcelRequire("4cTDP");

var $6uWhG = parcelRequire("6uWhG");

var $7zZ4w = parcelRequire("7zZ4w");

var $g1oKu = parcelRequire("g1oKu");

var $jjfy5 = parcelRequire("jjfy5");

var $l1VxS = parcelRequire("l1VxS");

var $jHI6h = parcelRequire("jHI6h");
const $551b7a7af70655c3$export$5664a170ac5a9781 = 5000;
const $551b7a7af70655c3$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};
const $551b7a7af70655c3$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $551b7a7af70655c3$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false, isCritical: isCritical = false, onFetchComplete: onFetchComplete })=>(0, $l1VxS.createResource)({
        type: `${$551b7a7af70655c3$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, storeContext)=>{
            const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, storeContext);
            // There are some variables that we don't want to trigger a reload even if they are changed, by default use 'variables', or you can also pass over
            // specific keyVariables that will trigger the reload
            const variables = keyVariables || queryVariables;
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            if ('kind' in preloadableRequest && preloadableRequest.kind === 'PreloadableConcreteRequest') {
                ({ params: params } = preloadableRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $37Ewn.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, storeContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $6uWhG.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, storeContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $6uWhG.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $jjfy5.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $6uWhG.setMark)(endMark);
                (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
                if ((0, $4cTDP.fg)('jfp-magma-mainissueaggquery-called-more-detector')) onFetchComplete?.({
                    parameters: parameters,
                    variables: variables,
                    options: options
                });
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $jHI6h.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly,
        isCritical: isCritical
    });
const $551b7a7af70655c3$export$2e279339bedcd427 = $551b7a7af70655c3$var$createRelayResourceImpl;

});


parcelRegister("lPVME", function(module, exports) {
$parcel$export(module.exports, "issueGiraDataResource", () => $f496a1a0a8f6865a$export$37badecd288c49f4);

var $eq3q8 = parcelRequire("eq3q8");

var $l1VxS = parcelRequire("l1VxS");

var $5L7qx = parcelRequire("5L7qx");


var $4cTDP = parcelRequire("4cTDP");

var $6NSKd = parcelRequire("6NSKd");

var $hM5pD = parcelRequire("hM5pD");
const $f496a1a0a8f6865a$export$37badecd288c49f4 = (0, $5L7qx.browserOnlyResourceWithCondition)(()=>{
    if (0, $9790b8dfe6f31c81$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $4cTDP.fg)('issue-view-ssr-perf-m2');
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $l1VxS.createResource)((0, $6NSKd.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $hM5pD.default)(...args),
    isBrowserOnly: true
})));

});
parcelRegister("hM5pD", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e266f77fd89b5cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $2c68b = parcelRequire("2c68b");

var $7hVvO = parcelRequire("7hVvO");

var $eq3q8 = parcelRequire("eq3q8");
const $2e266f77fd89b5cf$var$getData = async ({ match: match }, _storeContext)=>{
    const issueKey = (0, $eq3q8.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const data = await (0, $2c68b.default)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};
var $2e266f77fd89b5cf$export$2e2bcd8739ae039 = $2e266f77fd89b5cf$var$getData;

});
parcelRegister("2c68b", function(module, exports) {
$parcel$export(module.exports, "default", () => $f746cf123483fdb3$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $4cTDP = parcelRequire("4cTDP");

var $hqYEY = parcelRequire("hqYEY");

var $dNyY6 = parcelRequire("dNyY6");

var $8DQlA = parcelRequire("8DQlA");

var $hWeHP = parcelRequire("hWeHP");

var $6rzJr = parcelRequire("6rzJr");
const $f746cf123483fdb3$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric = (0, $hqYEY.metrics).custom({
    key: $f746cf123483fdb3$var$ISSUE_GIRA_DATA
});
const $f746cf123483fdb3$var$getCloudId = (0, $LFmXM.default)(()=>(0, $4cTDP.fg)('forge-issue-panel-open-by-default') ? (0, $hWeHP.default)('ajs-cloud-id') : null);
const $f746cf123483fdb3$var$fetchIssueGiraData = async (issueKey)=>{
    const cloudId = $f746cf123483fdb3$var$getCloudId();
    const projectKey = (0, $dNyY6.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey,
        ...cloudId ? {
            cloudId: cloudId
        } : {}
    };
    const payload = {
        query: cloudId ? (0, $8DQlA.buildIssueQueryV2)() : (0, $8DQlA.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $8DQlA.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    const isInSample = (sampleRate = 100)=>Math.random() <= 1 / sampleRate;
    if (isInSample()) $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $6rzJr.getClient)('issue-fetch-service/src/services/issue-gira-data/index').query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};
var $f746cf123483fdb3$export$2e2bcd8739ae039 = $f746cf123483fdb3$var$fetchIssueGiraData;

});
parcelRegister("8DQlA", function(module, exports) {
$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $2f4d1124325e51fb$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $2f4d1124325e51fb$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $2f4d1124325e51fb$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $2f4d1124325e51fb$export$222ae9aca08830f0);
$parcel$export(module.exports, "buildIssueQueryV2", () => $2f4d1124325e51fb$export$fd751aee2a193083);
$parcel$export(module.exports, "getGiraRequestOptions", () => $2f4d1124325e51fb$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $4cTDP = parcelRequire("4cTDP");

var $cTI7h = parcelRequire("cTI7h");

var $f8B5B = parcelRequire("f8B5B");

var $c6t82 = parcelRequire("c6t82");

var $lGt35 = parcelRequire("lGt35");

var $l6Jfp = parcelRequire("l6Jfp");

var $avnia = parcelRequire("avnia");

var $efm76 = parcelRequire("efm76");

var $cEdKD = parcelRequire("cEdKD");

var $g6Y30 = parcelRequire("g6Y30");

var $hif4C = parcelRequire("hif4C");

var $7JZFE = parcelRequire("7JZFE");

var $cvLHO = parcelRequire("cvLHO");
const $2f4d1124325e51fb$var$CREATED_ORDER_DESCENDING = '-created';
const $2f4d1124325e51fb$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $2f4d1124325e51fb$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${(0, $cTI7h.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $2f4d1124325e51fb$var$getURLFromWindow = ()=>new URL(window.location.href);
const $2f4d1124325e51fb$export$1a35060253e5a6cb = (url = $2f4d1124325e51fb$var$getURLFromWindow(), includeForgeQuery = true)=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $f8B5B.default)({
        maxResults: (0, $l6Jfp.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $2f4d1124325e51fb$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $l6Jfp.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cvLHO.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $l6Jfp.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $lGt35.getEcosystemQuery)(includeForgeQuery)}
        ${(0, $c6t82.getContentPanelsQuery)()}
        ${(0, $lGt35.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $efm76.getContainersByTypeQuery)()}
        ${(0, $7JZFE.getRemoteLinksQuery)()}
    }
`;
const $2f4d1124325e51fb$var$getForgeQuery = ()=>`
    forge {
        workItemPanels(
            cloudId: $cloudId,
            context: {
                workItemIdOrKey: $issueKey
            }
        ) {
            moduleId
            pinnedTo
            instances {
                id
                pinnedTo
                collapsed
                added
            }
        }
    }
`;
const $2f4d1124325e51fb$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $2f4d1124325e51fb$export$58eaa2ae4a5a410a = (includeForgeQuery = false)=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    	${includeForgeQuery ? $2f4d1124325e51fb$var$getForgeQuery() : ''}
		}
`;
const $2f4d1124325e51fb$export$222ae9aca08830f0 = (url)=>`
query ${$2f4d1124325e51fb$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$2f4d1124325e51fb$export$58eaa2ae4a5a410a()}
        ${(0, $cEdKD.default)()}
        ${$2f4d1124325e51fb$export$1a35060253e5a6cb(url)}
        ${!(0, $4cTDP.fg)('remove-jira-settings-iviq') ? (0, $avnia.getJiraSettingsQuery)() : ''}
        ${(0, $g6Y30.default)()}
        ${(0, $hif4C.default)()}
    }

`;
const $2f4d1124325e51fb$export$fd751aee2a193083 = (url)=>`
query ${$2f4d1124325e51fb$export$1780a132c0453fee}($issueKey: String!, $projectKey: String, $cloudId: ID)  {
        ${$2f4d1124325e51fb$export$58eaa2ae4a5a410a(/* includeForgeQuery */ true)}
        ${(0, $cEdKD.default)()}
        ${$2f4d1124325e51fb$export$1a35060253e5a6cb(url, /* includeForgeQuery */ false)}
        ${!(0, $4cTDP.fg)('remove-jira-settings-iviq') ? (0, $avnia.getJiraSettingsQuery)() : ''}
        ${(0, $g6Y30.default)()}
        ${(0, $hif4C.default)()}
    }
`;
const $2f4d1124325e51fb$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $2f4d1124325e51fb$export$1780a132c0453fee,
        query: $2f4d1124325e51fb$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("cTI7h", function(module, exports) {
$parcel$export(module.exports, "appendOperationQuery", () => $237ed4c9607e5b1c$export$69694c3add0f6058);
const $237ed4c9607e5b1c$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("f8B5B", function(module, exports) {
$parcel$export(module.exports, "default", () => $53da8aef2f05bd3c$export$2e2bcd8739ae039);

var $d60Hm = parcelRequire("d60Hm");
const $53da8aef2f05bd3c$var$createCommentsFragment = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url ? (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.COMMENTS), url) : (0, $d60Hm.getPermalinkId)((0, $d60Hm.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};
var $53da8aef2f05bd3c$export$2e2bcd8739ae039 = $53da8aef2f05bd3c$var$createCommentsFragment;

});

parcelRegister("c6t82", function(module, exports) {
$parcel$export(module.exports, "getContentPanelsQuery", () => $4249a4b796c65712$export$e6f14eac549b679d);
const $4249a4b796c65712$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $4249a4b796c65712$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$4249a4b796c65712$var$getContentPanelNode()}
            }
        }
    }
`;
const $4249a4b796c65712$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$4249a4b796c65712$var$getContentPanelNode()}
            }
        }
    }
`;
const $4249a4b796c65712$export$e6f14eac549b679d = ()=>`
    ${$4249a4b796c65712$var$getContentPanelsConnectionQuery()}
    ${$4249a4b796c65712$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("lGt35", function(module, exports) {
$parcel$export(module.exports, "getEcosystemQuery", () => $5d3bcfb4ca889012$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $5d3bcfb4ca889012$export$92c9a3dc7076af51);
const $5d3bcfb4ca889012$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $5d3bcfb4ca889012$export$edefef8c65e08bd2 = (includeForgeQuery = true)=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${includeForgeQuery ? $5d3bcfb4ca889012$var$getForgeQuery() : ''}
    }
`;
const $5d3bcfb4ca889012$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("l6Jfp", function(module, exports) {
$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $bba965161d9cb764$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $bba965161d9cb764$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $bba965161d9cb764$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $bba965161d9cb764$export$c46d621c29194aa4 = 5;
const $bba965161d9cb764$export$b2e398ce246f55b3 = 5;
const $bba965161d9cb764$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("avnia", function(module, exports) {
$parcel$export(module.exports, "getJiraSettingsQuery", () => $0d65d613f30838ca$export$191f50c0f86b85ec);
// TODO: remove when cleaning up remove-jira-settings-iviq
const $0d65d613f30838ca$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("efm76", function(module, exports) {
$parcel$export(module.exports, "getContainersByTypeQuery", () => $ce3bfce6001e529c$export$63131b2831854cc);

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");
const $ce3bfce6001e529c$var$getContainersByTypeQueryOld = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $ce3bfce6001e529c$var$getContainersByTypeQueryWithCustomerContext = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $ce3bfce6001e529c$export$63131b2831854cc = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jcs_master_flag'), $ce3bfce6001e529c$var$getContainersByTypeQueryWithCustomerContext, $ce3bfce6001e529c$var$getContainersByTypeQueryOld);

});

parcelRegister("cEdKD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8daa13ccb825551d$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");

var $cGVqS = parcelRequire("cGVqS");
const $8daa13ccb825551d$var$createMediaContextFragment = ()=>`mediaContext(issueKey: $issueKey) {
     ${(0, $4cTDP.fg)('dfo_remove_mediacontext_usertoken_from_iviq') ? '' : `userToken {
      token
      id
      issueId
      tokenDurationInMins
    }`}
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $cGVqS.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;
var $8daa13ccb825551d$export$2e2bcd8739ae039 = $8daa13ccb825551d$var$createMediaContextFragment;

});
parcelRegister("cGVqS", function(module, exports) {
$parcel$export(module.exports, "getMaxTokenLength", () => $fda68ad41e642ef5$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $fda68ad41e642ef5$var$nonIE11MaxTokenLength = 2 ** 16;
const $fda68ad41e642ef5$export$e40f2acaf1a50b00 = ()=>$fda68ad41e642ef5$var$nonIE11MaxTokenLength;

});


parcelRegister("g6Y30", function(module, exports) {
$parcel$export(module.exports, "default", () => $58c20a5fb285246a$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $58c20a5fb285246a$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
const $58c20a5fb285246a$var$createPermissionsFragment = ()=>`

    permissions(issueKey:$issueKey, keys:["${$58c20a5fb285246a$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;
var $58c20a5fb285246a$export$2e2bcd8739ae039 = $58c20a5fb285246a$var$createPermissionsFragment;

});

parcelRegister("hif4C", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ce89c5fc46ec8e1$export$2e2bcd8739ae039);
const $7ce89c5fc46ec8e1$var$createProjectFragment = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;
var $7ce89c5fc46ec8e1$export$2e2bcd8739ae039 = $7ce89c5fc46ec8e1$var$createProjectFragment;

});

parcelRegister("7JZFE", function(module, exports) {
$parcel$export(module.exports, "getRemoteLinksQuery", () => $c94d2c74482f6654$export$6bbc6b72b0b57f25);

var $4cTDP = parcelRequire("4cTDP");
const $c94d2c74482f6654$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
		remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $c94d2c74482f6654$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $c94d2c74482f6654$export$6bbc6b72b0b57f25 = ()=>(0, $4cTDP.fg)('jiv_confluence_remote_link_critical_query') ? $c94d2c74482f6654$var$getRemoteLinksQueryNew() : $c94d2c74482f6654$var$getRemoteLinksQueryOld();

});

parcelRegister("cvLHO", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b69391f765eb53b$export$2e2bcd8739ae039);

var $d60Hm = parcelRequire("d60Hm");
const $5b69391f765eb53b$var$createWorklogsFragment = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url ? (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.WORKLOG), url) : (0, $d60Hm.getPermalinkId)((0, $d60Hm.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};
var $5b69391f765eb53b$export$2e2bcd8739ae039 = $5b69391f765eb53b$var$createWorklogsFragment;

});


parcelRegister("6rzJr", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $dc2f954dac87a9b3$export$6bb76d6eba7e258c);

var $4mEPL = parcelRequire("4mEPL");
const $dc2f954dac87a9b3$var$appendOperationQuery = (operation)=>operation ? `?operation=${operation}` : '';
const $dc2f954dac87a9b3$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${$dc2f954dac87a9b3$var$appendOperationQuery(operation)}`;
const $dc2f954dac87a9b3$var$makeFetchClient = (path)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $4mEPL.default)($dc2f954dac87a9b3$export$aefb19023b2eda55(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            }, path)
    });
let $dc2f954dac87a9b3$var$client;
const $dc2f954dac87a9b3$export$6bb76d6eba7e258c = (path)=>{
    if (!$dc2f954dac87a9b3$var$client) $dc2f954dac87a9b3$var$client = $dc2f954dac87a9b3$var$makeFetchClient(path);
    return $dc2f954dac87a9b3$var$client;
};

});
parcelRegister("4mEPL", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d563314f1a32c40$export$2e2bcd8739ae039);
// Stryker disable all

var $3ibpe = parcelRequire("3ibpe");

var $hgi0g = parcelRequire("hgi0g");

var $14RSn = parcelRequire("14RSn");

var $4cTDP = parcelRequire("4cTDP");

var $dxLpE = parcelRequire("dxLpE");
async function $4d563314f1a32c40$export$2e2bcd8739ae039(url, options = {}, path) {
    if (!(0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $hgi0g.default)(url, options);
    const defaultExperienceDescription = {
        experience: (0, $dxLpE.isGiraUrl)(url) ? 'issueGira' : 'issueRest',
        analyticsSource: (0, $dxLpE.isGiraUrl)(url) ? 'issueGira' : 'issueRest',
        application: null,
        edition: null
    };
    try {
        const response = await (0, $hgi0g.default)(url, {
            ...options
        });
        return response;
    } catch (error) {
        if ((0, $14RSn.isFetchError)(error)) {
            const additionalAttributes = {
                statusCode: error.statusCode || 0,
                errorMessage: error.message || 'unknown',
                traceId: error.traceId || 'unknown',
                path: path
            };
            const statusCode = additionalAttributes.statusCode;
            let action = 'taskFail';
            if (statusCode && statusCode >= 400 && statusCode < 500) action = 'taskAbort';
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: action,
                additionalAttributes: additionalAttributes
            });
        }
        throw error;
    }
}

});
parcelRegister("hgi0g", function(module, exports) {
$parcel$export(module.exports, "default", () => $1002539ba2d0c9cc$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $eBhI6 = parcelRequire("eBhI6");

var $14RSn = parcelRequire("14RSn");

var $gUVFX = parcelRequire("gUVFX");

var $kinkG = parcelRequire("kinkG");

var $9lsFL = parcelRequire("9lsFL");
/**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param url - to fetch the JSON from
 * @param options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // the `@typescript-eslint/no-unnecessary-type-constraint` rule is disabled because otherwise syntax highlighting breaks with a trailing comma,
// other rules should be fixed ideally.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
const $1002539ba2d0c9cc$var$fetchJson = (url, options = {})=>fetch((0, $gUVFX.getReroutableURL)(url), (0, $kinkG.applyObservabilityHeaders)(url, (0, $iWqim.merge)((0, $eBhI6.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $9lsFL.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $14RSn.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $14RSn.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });
var $1002539ba2d0c9cc$export$2e2bcd8739ae039 = $1002539ba2d0c9cc$var$fetchJson;

});

parcelRegister("dxLpE", function(module, exports) {
$parcel$export(module.exports, "isGiraUrl", () => $f1c40d25f35e4f9e$export$ea636743f241905c);
const $f1c40d25f35e4f9e$export$ea636743f241905c = (url)=>url.startsWith('/rest/gira/');

});




parcelRegister("7hVvO", function(module, exports) {
$parcel$export(module.exports, "createResourceError", () => $57ba68f5ed9efef2$export$13487d18466bc8a5);

var $eSnSE = parcelRequire("eSnSE");
class $57ba68f5ed9efef2$var$ResourceErrorClass extends Error {
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $57ba68f5ed9efef2$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $57ba68f5ed9efef2$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("9NmsS", function(module, exports) {
$parcel$export(module.exports, "getModernIssueTransitionResources", () => $740db98e3f182ede$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $740db98e3f182ede$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $740db98e3f182ede$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $740db98e3f182ede$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $740db98e3f182ede$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $740db98e3f182ede$export$808691f5a412afa3);
$parcel$export(module.exports, "getNavigationResourcesForWorkItem", () => $740db98e3f182ede$export$6fbb399465b8a47f);

var $kmmPh = parcelRequire("kmmPh");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $hHbzj = parcelRequire("hHbzj");

var $3luhJ = parcelRequire("3luhJ");

var $4HvIf = parcelRequire("4HvIf");

var $cY5nO = parcelRequire("cY5nO");

var $43SpR = parcelRequire("43SpR");

var $6JmRt = parcelRequire("6JmRt");

var $8J0lu = parcelRequire("8J0lu");

var $SPYRa = parcelRequire("SPYRa");

var $9CgFv = parcelRequire("9CgFv");

var $graie = parcelRequire("graie");

var $4VIcO = parcelRequire("4VIcO");


var $7JXbP = parcelRequire("7JXbP");

var $dRfS0 = parcelRequire("dRfS0");

var $5yVUD = parcelRequire("5yVUD");

var $aYBjl = parcelRequire("aYBjl");

var $1gbqq = parcelRequire("1gbqq");

var $enHI7 = parcelRequire("enHI7");

var $dfh4P = parcelRequire("dfh4P");

var $5zQIb = parcelRequire("5zQIb");

var $cqUpU = parcelRequire("cqUpU");

var $dZRaT = parcelRequire("dZRaT");

var $2emAF = parcelRequire("2emAF");

var $giQoM = parcelRequire("giQoM");

var $68g4a = parcelRequire("68g4a");

var $lb6FK = parcelRequire("lb6FK");

var $cxQGT = parcelRequire("cxQGT");

var $aUy7d = parcelRequire("aUy7d");

var $5L7qx = parcelRequire("5L7qx");

var $5fjzQ = parcelRequire("5fjzQ");

var $l1VxS = parcelRequire("l1VxS");

var $hXbwo = parcelRequire("hXbwo");

var $5hYi1 = parcelRequire("5hYi1");

var $gyLjG = parcelRequire("gyLjG");
const $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4Resource = (0, $5L7qx.resourceWithCondition2)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('post_office_ssr_jira_side_nav_enabled') && (0, $4cTDP.fg)('post-office-jira-side-nav-in-nav4'), (0, $5fjzQ.postOfficeJiraSideNavResource));
const $740db98e3f182ede$var$inGrw1672ExperimentCohortExperiment = ()=>{
    // We need to use UNSAFE_noExposureExp to check if experiment is enabled without firing exposure events
    const [config] = (0, $cxKOj.UNSAFE_noExposureExp)('grw-1672_display_targeted_jsm_template_cta_in_nav4');
    return config.get('cohort', 'not-enrolled') === 'variation';
};
const $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('enable_ssr_recommendations_in_nav4') && $740db98e3f182ede$var$inGrw1672ExperimentCohortExperiment(), (0, $5fjzQ.postOfficeNav4ProjectsSectionResource));
const $740db98e3f182ede$var$isModernIssueTransitionSettingEnabled = ()=>{
    return (0, $cxKOj.expVal)('jira_issue_transition_screen_modernisation_toggle', 'value', 'OFF') !== 'OFF';
};
const $740db98e3f182ede$var$conditionalGicOptInStatusResource = (0, $5L7qx.resourceWithCondition)(()=>(0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience'), (0, $dRfS0.gicOptInStatusResources));
const $740db98e3f182ede$var$conditionalIssueTransitionOptInStatusResource = (0, $5L7qx.resourceWithCondition)($740db98e3f182ede$var$isModernIssueTransitionSettingEnabled, (0, $aYBjl.issueTransitionOptInStatusResource));
const $740db98e3f182ede$export$e1afa08027b1e44b = ()=>[
        $740db98e3f182ede$var$conditionalIssueTransitionOptInStatusResource,
        (0, $5yVUD.issueTransitionChangeboardingPreferencesResource)
    ];
const $740db98e3f182ede$var$getConditionalOperationsJiraSideNavResource = ()=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('operations_ssr_jira_side_nav_enabled'), (0, $4VIcO.getConsolidationStateResource)(), (0, $l1VxS.createResource)({
        type: `${(0, $f8747ec2695de8a7$export$25ee35b01de9d734)}_NOOP`,
        getKey: ()=>`${0, $f8747ec2695de8a7$export$25ee35b01de9d734}_NOOP`,
        getData: async ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: false
    }));
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $740db98e3f182ede$var$getDedupableConditionalResources = (isUsingSidebarEntrypoint)=>{
    const resources = [
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('blu-8363-archive-legacy-resource-navigationuistate'), (0, $5hYi1.navigationUIStateRelayResource)),
        (0, $43SpR.sidebarNav4UiStateResource),
        (0, $8J0lu.topNav4UIStateResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('navx-global-side-nav'), (0, $6JmRt.navPlatformSidebarResource)),
        $740db98e3f182ede$var$getConditionalOperationsJiraSideNavResource()
    ];
    if (isUsingSidebarEntrypoint) // We don't want sidebarNav4Resource loaded for entrypoints otherwise we end up with a client side api call
    // when we don't need it as SSR will have loaded the data already.
    return resources;
    resources.push((0, $43SpR.sidebarNav4Resource));
    return resources;
};
const $740db98e3f182ede$export$75cffd1aaecf4a2c = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        ...(0, $gyLjG.getSpaResources)(),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('blu-8363-archive-legacy-resource-navigationuistate'), (0, $dfh4P.navigationUiStateResource)),
        (0, $SPYRa.navigationPlansVisibilityResource),
        (0, $aUy7d.userHomepageResource),
        $740db98e3f182ede$var$conditionalGicOptInStatusResource,
        (0, $graie.consolidationUserStateResource),
        ...$740db98e3f182ede$var$getDedupableConditionalResources(isUsingSidebarEntrypoint),
        (0, $cxQGT.themePreferenceResource),
        ...$740db98e3f182ede$export$e1afa08027b1e44b(),
        (0, $cqUpU.persistentIssueCreateModalViewResource),
        (0, $7JXbP.gicSmartFieldsFeatureResource),
        (0, $lb6FK.rovoEntitlementResource),
        (0, $68g4a.jpdRecommendationDismissedResource),
        (0, $giQoM.fetchSiteUserTraitsResource),
        (0, $2emAF.fetchSiteTraitsResource),
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4Resource,
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource,
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('preview_panel_width_persistance'), (0, $hXbwo.previewPanelStateResource))
    ];
const $740db98e3f182ede$export$c57dc1ea7f76f91f = ()=>[
        (0, $3luhJ.staticJSWUserBoardSidebarNavigationResource)
    ];
const $740db98e3f182ede$export$af2259a87f79645d = ()=>[
        (0, $4HvIf.staticPlanSidebarNavigationResource)
    ];
const $740db98e3f182ede$export$a103e99ad51f7bc3 = ()=>[
        (0, $enHI7.navigationSidebarGlobalResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        (0, $9CgFv.checkApiKeyManagementKeysResource)(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-delegated-custom-onboarding'), (0, $kmmPh.nav4SidebarGlobalProductsSettingsResource))
    ];
const $740db98e3f182ede$export$808691f5a412afa3 = ()=>[
        (0, $5zQIb.newIssueViewTransitionLockInStatusResource),
        (0, $1gbqq.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $hHbzj.forgeProjectSettingsModuleResource),
        (0, $cY5nO.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];
const $740db98e3f182ede$export$6fbb399465b8a47f = ()=>[
        // Checks if the Plans menu should appear in the sidebar
        (0, $SPYRa.navigationPlansVisibilityResource),
        // check if we can render the global issue create modal when clicking the Create button.
        $740db98e3f182ede$var$conditionalGicOptInStatusResource,
        // used in the Nav4 profile menu.
        (0, $cxQGT.themePreferenceResource),
        // ConversationAssistant component on the TopNav
        (0, $lb6FK.rovoEntitlementResource),
        // used in Nav4JiraSideNavRecommendation
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4Resource,
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource,
        // used in glance panel.
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('preview_panel_width_persistance'), (0, $hXbwo.previewPanelStateResource)),
        // issues related resources -> issue-create modal
        (0, $cqUpU.persistentIssueCreateModalViewResource),
        (0, $7JXbP.gicSmartFieldsFeatureResource),
        ...$740db98e3f182ede$export$e1afa08027b1e44b(),
        ...$740db98e3f182ede$var$getDedupableConditionalResources(false)
    ];

});
parcelRegister("kmmPh", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarGlobalProductsSettingsResource", () => $82a42c74d0f4bba1$export$48318c24101869b4);

var $9FYIg = parcelRequire("9FYIg");

var $aYXFw = parcelRequire("aYXFw");

var $4cTDP = parcelRequire("4cTDP");
const $82a42c74d0f4bba1$var$RESOURCE_TYPE_GLOBAL_PRODUCTS_SETTINGS_SIDEBAR = 'GLOBAL_PRODUCTS_SETTINGS_SIDEBAR';
const $82a42c74d0f4bba1$export$48318c24101869b4 = (0, $9FYIg.createRelayResource)({
    type: $82a42c74d0f4bba1$var$RESOURCE_TYPE_GLOBAL_PRODUCTS_SETTINGS_SIDEBAR,
    getQuery: (_, { tenantContext: { cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin } })=>({
            parameters: (0, $aYXFw.default),
            variables: {
                cloudId: cloudId,
                // We can skip the permission check when:
                // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                // 2. Upsell is enabled (because upsell is only available to admins), or
                // 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone), or
                // 4. The delegated admin gate is disabled (because only admins would be able to view the feature)
                skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' && (0, $4cTDP.fg)('restrict-custom-onboarding-to-premium-tier') || !(0, $4cTDP.fg)('jira-onboarding-hub-gate') || !(0, $4cTDP.fg)('jira-delegated-custom-onboarding')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true,
    isCritical: true
});

});
parcelRegister("aYXFw", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbebf3b272efc58f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7166b679704bf44cbae2680551558850>>
 * @relayHash 3776d7755b12b1e91d9b17c5a3915dff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f77087de9d62f3b981bbd1fa090358d49e27008b2b350334b902f0a164bc151a

var $37Ewn = parcelRequire("37Ewn");
const $dbebf3b272efc58f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalProductsSettingsSidebarQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "skipDelegatedAdminCheck",
                            "variableName": "skipDelegatedAdminCheck"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "DelegatedAdminJiraSection"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalProductsSettingsSidebarQuery",
            "selections": [
                {
                    "condition": "skipDelegatedAdminCheck",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canManageCustomOnboarding",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "MANAGE_CUSTOM_ONBOARDING"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPermission"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f77087de9d62f3b981bbd1fa090358d49e27008b2b350334b902f0a164bc151a",
            "metadata": {},
            "name": "GlobalProductsSettingsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dbebf3b272efc58f$var$node.hash = "9fba8d87d361bd5696daedb53c760b9b";
(0, $37Ewn.PreloadableQueryRegistry).set($dbebf3b272efc58f$var$node.params.id, $dbebf3b272efc58f$var$node);
var $dbebf3b272efc58f$export$2e2bcd8739ae039 = $dbebf3b272efc58f$var$node;

});


parcelRegister("hHbzj", function(module, exports) {
$parcel$export(module.exports, "forgeAdminModuleResource", () => $7eeccaa3259d40ce$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $7eeccaa3259d40ce$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $7eeccaa3259d40ce$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $7eeccaa3259d40ce$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $7eeccaa3259d40ce$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $7eeccaa3259d40ce$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $7eeccaa3259d40ce$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $7eeccaa3259d40ce$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $7eeccaa3259d40ce$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $7eeccaa3259d40ce$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $7eeccaa3259d40ce$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $7eeccaa3259d40ce$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $7eeccaa3259d40ce$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $7eeccaa3259d40ce$export$e6be2f0ca0849869);

var $4sqLM = parcelRequire("4sqLM");

var $fohjD = parcelRequire("fohjD");

var $5KBwc = parcelRequire("5KBwc");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $aOcSy = parcelRequire("aOcSy");
const $7eeccaa3259d40ce$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $fohjD.PROJECT_PAGE_MODULE),
        (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $fcQiO.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $7eeccaa3259d40ce$export$b9489d8c5c5e3626 = (0, $l1VxS.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.ADMIN_PAGE_MODULE], (0, $aOcSy.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$dcc98f4b36ce9223 = ()=>[
        $7eeccaa3259d40ce$export$b9489d8c5c5e3626
    ];
const $7eeccaa3259d40ce$export$72db683c2914a65e = (0, $l1VxS.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PROJECT_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $7eeccaa3259d40ce$export$7523db37432ba090 = (0, $l1VxS.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.BACKLOG_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$cfd99f451b423d3a = (0, $l1VxS.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.BOARD_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$7b639f33f086f9f1 = (0, $l1VxS.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.SPRINT_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$8a5aed164e925eb6 = (0, $l1VxS.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$ec3265610584f9ce = ()=>[
        $7eeccaa3259d40ce$export$8a5aed164e925eb6
    ];
const $7eeccaa3259d40ce$export$7a928d209faf75f = (0, $l1VxS.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $7eeccaa3259d40ce$export$e81e11bbc3239153 = ()=>(0, $eJrcF.useResource)($7eeccaa3259d40ce$export$7a928d209faf75f);
const $7eeccaa3259d40ce$export$97b0827022fdafe3 = (0, $l1VxS.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.GLOBAL_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$80b2f91dabb3dd65 = ()=>[
        $7eeccaa3259d40ce$export$97b0827022fdafe3
    ];
const $7eeccaa3259d40ce$export$ebf5369e4dcfad00 = (0, $l1VxS.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$e6be2f0ca0849869 = (0, $l1VxS.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $fohjD.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $7eeccaa3259d40ce$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $4sqLM.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("4sqLM", function(module, exports) {
$parcel$export(module.exports, "alphabeticalSort", () => $b0b7341e5e59d415$export$89a1f01f2a7cb2a1);

var $eSnSE = parcelRequire("eSnSE");
const $b0b7341e5e59d415$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $eSnSE.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("5KBwc", function(module, exports) {
$parcel$export(module.exports, "fetchModules", () => $90fa207631d927ef$export$24d8e11b15325c53);

var $jNLTH = parcelRequire("jNLTH");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $a1pDt = parcelRequire("a1pDt");

var $ayoPl = parcelRequire("ayoPl");

var $9gq2c = parcelRequire("9gq2c");

var $b6ojT = parcelRequire("b6ojT");

var $fohjD = parcelRequire("fohjD");

var $7zZ4w = parcelRequire("7zZ4w");

var $jNLTH = parcelRequire("jNLTH");

var $lB0Td = parcelRequire("lB0Td");

var $TUft0 = parcelRequire("TUft0");

var $aiU3I = parcelRequire("aiU3I");
const $90fa207631d927ef$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, $fohjD.SOURCE_UNKNOWN) } = params;
    if (!(0, $lB0Td.canFetchForgeModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous
    })) return (0, $TUft0.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $ayoPl.measureExecutionTimeMetrics)(()=>$90fa207631d927ef$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $9gq2c.FORGE_SAMPLING_RATE)) (0, $b6ojT.fireInitializationFetchFinishedEvent)(source);
        return (0, $TUft0.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $a1pDt.getErrorType)(error);
        (0, $b6ojT.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($90fa207631d927ef$export$458cbcb6374269d2.includes(errorType)) return (0, $TUft0.toMappedExtensions)(types, []);
        throw error;
    }
};
function $90fa207631d927ef$export$9f9fdbce0829073d(props) {
    // includeScopes is true by default to enable decoupling scopes from forge app
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = true } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $jNLTH.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $aiU3I.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $jNLTH.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes,
            includeModuleId: (0, $4cTDP.fg)('forge-extensions-module-id-for-relay')
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const responseExtensions = response.jira?.forge?.extensions;
                // @ts-expect-error - TODO: new genereated type is incompatible with it
                extensions = responseExtensions?.concat().map((ext)=>({
                        ...ext,
                        moduleId: ext.moduleId ?? null
                    })) || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $90fa207631d927ef$export$458cbcb6374269d2 = [
    (0, $a1pDt.FAILED_TO_FETCH),
    (0, $a1pDt.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $a1pDt.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("jNLTH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d74065d4e27f303$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<463943aee983fc126f5370d765a8751e>>
 * @relayHash 2db705908fb7ae6ea6c5baa7d6869971
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e3998a2b80f7ce45338ea81f0d72cd7081b5a2168e78a5fe88be51536bfd04a8
const $6d74065d4e27f303$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeModuleId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "condition": "includeModuleId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "moduleId"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "concreteType": "JiraUserAppAccess",
                                    "kind": "LinkedField",
                                    "name": "userAccess",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasAccess"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "id": "e3998a2b80f7ce45338ea81f0d72cd7081b5a2168e78a5fe88be51536bfd04a8",
            "metadata": {},
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6d74065d4e27f303$var$node.hash = "ca4e63c9dc9ed48bca68759cbd53c29a";
var $6d74065d4e27f303$export$2e2bcd8739ae039 = $6d74065d4e27f303$var$node;

});

parcelRegister("a1pDt", function(module, exports) {
$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $418aaf9ffa32ce25$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $418aaf9ffa32ce25$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $418aaf9ffa32ce25$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $418aaf9ffa32ce25$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $418aaf9ffa32ce25$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $418aaf9ffa32ce25$export$e19f9f08a6d79fd2);


var $dMM78 = parcelRequire("dMM78");

var $5Z6L0 = parcelRequire("5Z6L0");

var $7Jk3f = parcelRequire("7Jk3f");
const $418aaf9ffa32ce25$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $418aaf9ffa32ce25$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $418aaf9ffa32ce25$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $418aaf9ffa32ce25$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $418aaf9ffa32ce25$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $418aaf9ffa32ce25$export$89a175d4190df42e = 'Invoke value functions failed:';
const $418aaf9ffa32ce25$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $418aaf9ffa32ce25$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $7Jk3f.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $418aaf9ffa32ce25$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $418aaf9ffa32ce25$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    // Tracked GraphQL errors contain useful info about internal errors like status codes
    // We want to categorize them more precisely, because some error types aren't SLO critical.
    if (error instanceof (0, $5Z6L0.TrackedGraphQLError)) {
        if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $418aaf9ffa32ce25$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
        return 'TRACKED_GRAPHQL_ERROR';
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $418aaf9ffa32ce25$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.') || /Extension ".*" could not be invoked as it does not reference a function or an endpoint/i.test(message)) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($418aaf9ffa32ce25$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($418aaf9ffa32ce25$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3a153a61cf6b691b$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3a153a61cf6b691b$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $418aaf9ffa32ce25$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($418aaf9ffa32ce25$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($418aaf9ffa32ce25$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $dMM78.isClientFetchError)(error)) return $418aaf9ffa32ce25$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("5Z6L0", function(module, exports) {
$parcel$export(module.exports, "TrackedGraphQLError", () => $4ea9e19fe27d2302$export$f2062ad173e74c75);
class $4ea9e19fe27d2302$export$f2062ad173e74c75 extends Error {
    constructor(errorMessage, errors, traceIds){
        super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
        this.errors = errors;
        // Get first trace id
        this.traceId = traceIds?.[0];
        // Get first status code
        this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
        // Combine error messages
        this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
    }
}

});


parcelRegister("ayoPl", function(module, exports) {
$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $8f610b55c617371f$export$a859f6866f4653e0);

var $aXKmr = parcelRequire("aXKmr");

var $9gq2c = parcelRequire("9gq2c");

var $lHD3D = parcelRequire("lHD3D");
const $8f610b55c617371f$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $aXKmr.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $9gq2c.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});
parcelRegister("9gq2c", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $27592f25cbe551e4$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $27592f25cbe551e4$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $27592f25cbe551e4$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $27592f25cbe551e4$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $27592f25cbe551e4$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $27592f25cbe551e4$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $27592f25cbe551e4$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $27592f25cbe551e4$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $27592f25cbe551e4$export$f892f621fb508154 = 'jiraForgeUi';
const $27592f25cbe551e4$export$273f5980517336e2 = 'jiraforgeui';
const $27592f25cbe551e4$export$ed63b053e04e26df = 'trigger';
const $27592f25cbe551e4$export$725bacc669333eef = 'extension';
const $27592f25cbe551e4$export$d920cee73ec094d0 = 10;
const $27592f25cbe551e4$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $27592f25cbe551e4$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    PIN_UNPIN_CLICKED: 'pin-unpin clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $27592f25cbe551e4$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    SUCCEEDED: 'succeeded',
    CALLED: 'called',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $27592f25cbe551e4$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("lHD3D", function(module, exports) {
$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $9103e0edbbdf20b7$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $9103e0edbbdf20b7$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $9103e0edbbdf20b7$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $9103e0edbbdf20b7$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $9103e0edbbdf20b7$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $9103e0edbbdf20b7$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $9103e0edbbdf20b7$export$a318f99472db73c8);

var $hqYEY = parcelRequire("hqYEY");

var $gPCSe = parcelRequire("gPCSe");

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $9gq2c = parcelRequire("9gq2c");
const $9103e0edbbdf20b7$export$c3d8833fbea3e976 = (0, $hqYEY.metrics).concurrent.custom({
    key: (0, $9gq2c.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $9103e0edbbdf20b7$export$292f3b557281044f = (0, $hqYEY.metrics).concurrent.custom({
    key: (0, $9gq2c.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $9103e0edbbdf20b7$export$89ace7e2bb7d7685 = new (0, $f39LL.UFOExperience)((0, $9gq2c.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});
async function $9103e0edbbdf20b7$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $gPCSe.default).getEntriesByName(startMark).length > 0 || (0, $gPCSe.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $gPCSe.default).mark(startMark);
    const result = await fn();
    (0, $gPCSe.default).mark(endMark);
    return result;
}
const $9103e0edbbdf20b7$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $gPCSe.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $gPCSe.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $gPCSe.default).clearMarks(name);
    });
};
const $9103e0edbbdf20b7$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $hqYEY.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $9gq2c.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $9gq2c.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $9103e0edbbdf20b7$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $hqYEY.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("b6ojT", function(module, exports) {
$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $b46b77cba3fc4937$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $b46b77cba3fc4937$export$b5ca88b1053f1ad0);

var $5IiZP = parcelRequire("5IiZP");

var $1GZq2 = parcelRequire("1GZq2");
const $b46b77cba3fc4937$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $b46b77cba3fc4937$export$917d0643b0111a02 = (0, $5IiZP.toEventId)('issueViewInitialization');
const $b46b77cba3fc4937$export$43e875fd63e64525 = (0, $5IiZP.toEventId)('fetchModulesInitialization');
const $b46b77cba3fc4937$export$132ca822850e455f = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $b46b77cba3fc4937$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $b46b77cba3fc4937$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$e914f7df1e4ad79b = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $b46b77cba3fc4937$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$b274c658390b491b = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $b46b77cba3fc4937$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("5IiZP", function(module, exports) {
$parcel$export(module.exports, "toEventId", () => $f4ec6f2be36576de$export$75e84ef5a3771f9a);
const $f4ec6f2be36576de$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("1GZq2", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $08a88d513347b1c2$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $08a88d513347b1c2$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $08a88d513347b1c2$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $08a88d513347b1c2$export$390a62413962e4f0);

var $2Mqjh = parcelRequire("2Mqjh");

var $9gq2c = parcelRequire("9gq2c");

var $lHVmb = parcelRequire("lHVmb");

var $e6Fnd = parcelRequire("e6Fnd");

var $esfNg = parcelRequire("esfNg");
const $08a88d513347b1c2$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $9gq2c.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $lHVmb.createAttributes)(attributes),
        source: source,
        action: action
    });
const $08a88d513347b1c2$var$getAnalyticsClient = async ()=>(await (0, $2Mqjh.getAnalyticsWebClientPromise)()).getInstance();
const $08a88d513347b1c2$var$sendOperationalEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendOperationalEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$var$sendUiEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendUIEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$var$sendTrackEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendTrackEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendUiEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendTrackEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $08a88d513347b1c2$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $e6Fnd.logError)((0, $e6Fnd.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $esfNg.isSynthetic)().toString()}, id=${id}, source=${(0, $lHVmb.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("lHVmb", function(module, exports) {
$parcel$export(module.exports, "parseSource", () => $9bd51fd7ce296308$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $9bd51fd7ce296308$export$c7c9603a6b1fd815);

var $3rsPO = parcelRequire("3rsPO");

var $hWeHP = parcelRequire("hWeHP");

var $bor34 = parcelRequire("bor34");

var $a1pDt = parcelRequire("a1pDt");

var $esfNg = parcelRequire("esfNg");
const $9bd51fd7ce296308$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $9bd51fd7ce296308$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $9bd51fd7ce296308$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $esfNg.isSynthetic)(),
        isOverridingFragments: (0, $bor34.isOverridingFragments)(),
        isSSR: false,
        shard: (0, $hWeHP.default)('ajs-shard') || '',
        region: (0, $hWeHP.default)('ajs-region') || ''
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $9bd51fd7ce296308$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $9bd51fd7ce296308$export$78c6267359db7e73(error);
            attributes.errorType = (0, $a1pDt.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3rsPO)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("3rsPO", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $281a42b42026b9fe$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $281a42b42026b9fe$var$isBoolean(value) {
    return value === true || value === false || $7gKgM(value) && $1O9y6(value) == $281a42b42026b9fe$var$boolTag;
}
module.exports = $281a42b42026b9fe$var$isBoolean;

});

parcelRegister("bor34", function(module, exports) {
$parcel$export(module.exports, "isOverridingFragments", () => $67dfabecb1e685f2$export$1d1321d2b374d697);

var $4cTDP = parcelRequire("4cTDP");
const $67dfabecb1e685f2$export$1d1321d2b374d697 = ()=>{
    if ((0, $4cTDP.fg)('is_overriding_fragments_analytics_prop')) {
        const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
        const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
        return buildKey ? re.test(buildKey) : false;
    }
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("esfNg", function(module, exports) {
$parcel$export(module.exports, "isSynthetic", () => $f87e848916480251$export$947749d756ccb0a);

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");
const $f87e848916480251$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $4cTDP.fg)('forge_ui_synthetic_check');

});


parcelRegister("e6Fnd", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_UTIL", () => $f2ad15b7ec81ba1d$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $f2ad15b7ec81ba1d$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $f2ad15b7ec81ba1d$export$58da9968c3170cb1);

var $eSnSE = parcelRequire("eSnSE");

var $9gq2c = parcelRequire("9gq2c");
const $f2ad15b7ec81ba1d$export$e31edcd35abe3bb1 = 'environment-mapping';
const $f2ad15b7ec81ba1d$export$d1e4f308040bb0d5 = 'analytics';
const $f2ad15b7ec81ba1d$export$36f315a5c6daf40b = 'custom-field-object-type';
const $f2ad15b7ec81ba1d$export$6ee8198f29fffdb4 = {
    [$f2ad15b7ec81ba1d$export$d1e4f308040bb0d5]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$f2ad15b7ec81ba1d$export$e31edcd35abe3bb1]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$f2ad15b7ec81ba1d$export$36f315a5c6daf40b]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $f2ad15b7ec81ba1d$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData($f2ad15b7ec81ba1d$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("lB0Td", function(module, exports) {
$parcel$export(module.exports, "canFetchForgeModules", () => $482882859bcd0b72$export$bb3a4a3b8e654c08);
const $482882859bcd0b72$export$bb3a4a3b8e654c08 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    /**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */ if (!false && $482882859bcd0b72$export$489a82a1efc4cd04().endsWith('.atl-test.space')) return false;
    // There is no anonymous access for now
    return !isAnonymous;
};
const $482882859bcd0b72$export$489a82a1efc4cd04 = ()=>window.location.hostname;

});

parcelRegister("TUft0", function(module, exports) {
$parcel$export(module.exports, "toMappedExtensions", () => $e072eb0063339dc0$export$e073e0c0d1c23345);

var $4cTDP = parcelRequire("4cTDP");
function $e072eb0063339dc0$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    const extensions = (0, $4cTDP.fg)('forge-extensions-module-id-for-relay') ? $e072eb0063339dc0$export$acd8ca2c14bd2aa4(returnedExtensions) : returnedExtensions;
    extensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}
function $e072eb0063339dc0$export$acd8ca2c14bd2aa4(extensions) {
    return extensions.map(({ moduleId: moduleId, ...rest })=>({
            ...rest,
            id: moduleId ?? rest.id.replace(/-+\d+$/, ''),
            moduleId: moduleId
        }));
}

});

parcelRegister("aiU3I", function(module, exports) {
$parcel$export(module.exports, "trackGraphQLErrors", () => $0e4de19c3dd7a13b$export$a5c00ff206a4c88b);

var $g1oKu = parcelRequire("g1oKu");

var $5Z6L0 = parcelRequire("5Z6L0");

var $jHI6h = parcelRequire("jHI6h");
function $0e4de19c3dd7a13b$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $g1oKu.startCaptureGraphQlErrors)();
    (0, $jHI6h.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $jHI6h.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$0e4de19c3dd7a13b$var$getGraphQLError(queryId, operationName)
    };
}
function $0e4de19c3dd7a13b$var$getGraphQLError(key, operationName) {
    const errors = (0, $g1oKu.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $5Z6L0.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $jHI6h.getTraceIds)(operationName));
    return undefined;
}

});


parcelRegister("fcQiO", function(module, exports) {
$parcel$export(module.exports, "getProjectKeyOrId", () => $45133b0b69e21626$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $45133b0b69e21626$export$b87af5b274141bd6);

var $bBtQo = parcelRequire("bBtQo");
const $45133b0b69e21626$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $45133b0b69e21626$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});

parcelRegister("aOcSy", function(module, exports) {
$parcel$export(module.exports, "uniqueExtensionsFilter", () => $a0b01b44bfd87d67$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $a0b01b44bfd87d67$export$1eefd1d9cde49fd5);

var $jOCpp = parcelRequire("jOCpp");

var $ePLco = parcelRequire("ePLco");
const $a0b01b44bfd87d67$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $a0b01b44bfd87d67$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("jOCpp", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $1txRh = parcelRequire("1txRh");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $e6d07b03a10f7aee$var$uniqBy(array, iteratee) {
    return array && array.length ? $1txRh(array, $1lM9j(iteratee, 2)) : [];
}
module.exports = $e6d07b03a10f7aee$var$uniqBy;

});

parcelRegister("ePLco", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $763cc49eecef8327$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $763cc49eecef8327$export$a92b17288693d366);
const $763cc49eecef8327$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $763cc49eecef8327$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});



parcelRegister("3luhJ", function(module, exports) {
$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $f503c22a7b6ca0ef$export$5839dd8142de842e);

var $eSnSE = parcelRequire("eSnSE");

var $2at4v = parcelRequire("2at4v");

var $l1VxS = parcelRequire("l1VxS");

var $j3MZT = parcelRequire("j3MZT");
const $f503c22a7b6ca0ef$export$5839dd8142de842e = (0, $l1VxS.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $j3MZT.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("j3MZT", function(module, exports) {
$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $071e1177268b0d4d$export$306fb49fca60b34);

var $3ugTQ = parcelRequire("3ugTQ");
const $071e1177268b0d4d$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $3ugTQ.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("4HvIf", function(module, exports) {
$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $88524b29244ca76c$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $l1VxS = parcelRequire("l1VxS");

var $4q1H4 = parcelRequire("4q1H4");
const $88524b29244ca76c$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $88524b29244ca76c$export$e7e6c1b9d8d5ea7 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$88524b29244ca76c$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $4q1H4.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("4q1H4", function(module, exports) {
$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $9360532f5ab456b0$export$a49729698cfc5310);

var $3ugTQ = parcelRequire("3ugTQ");
const $9360532f5ab456b0$var$requestSideBarInfo = (planId, scenarioId)=>(0, $3ugTQ.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $9360532f5ab456b0$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $9360532f5ab456b0$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("43SpR", function(module, exports) {
$parcel$export(module.exports, "sidebarNav4Resource", () => $dbd1c384f9b07eb1$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $dbd1c384f9b07eb1$export$a46129bd512544d7);

var $h4Bzb = parcelRequire("h4Bzb");

var $kWbWF = parcelRequire("kWbWF");

var $b1DBy = parcelRequire("b1DBy");

var $9FYIg = parcelRequire("9FYIg");

var $bBIDB = parcelRequire("bBIDB");

var $hOoYL = parcelRequire("hOoYL");

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");

var $4cTDP = parcelRequire("4cTDP");
const $dbd1c384f9b07eb1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $dbd1c384f9b07eb1$export$7648dc6f76f4f83d = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${$dbd1c384f9b07eb1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const initialSelectedPath = (0, $kWbWF.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $bBIDB.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_APPS)),
                isFiltersExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $fKh2A.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $7Cu03.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString(),
                isAnonymous: isAnonymous
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});
const $dbd1c384f9b07eb1$export$a46129bd512544d7 = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $hOoYL.default),
            variables: {
                cloudId: cloudId,
                isSkipped: (0, $4cTDP.fg)('blu-8363-archive-legacy-resource-navigationuistate')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("h4Bzb", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $330926e53d81707a$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID_TO_APS_KEY", () => $330926e53d81707a$export$3b4ca8d4d769a311);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $330926e53d81707a$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $330926e53d81707a$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $330926e53d81707a$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $330926e53d81707a$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $330926e53d81707a$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $330926e53d81707a$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_FOR_YOU", () => $330926e53d81707a$export$5115ccb493164b9);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $330926e53d81707a$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $330926e53d81707a$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $330926e53d81707a$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $330926e53d81707a$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $330926e53d81707a$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $330926e53d81707a$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $330926e53d81707a$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $330926e53d81707a$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $330926e53d81707a$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $330926e53d81707a$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $330926e53d81707a$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $330926e53d81707a$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $330926e53d81707a$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $330926e53d81707a$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $330926e53d81707a$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $330926e53d81707a$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $330926e53d81707a$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $330926e53d81707a$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $330926e53d81707a$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $330926e53d81707a$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $330926e53d81707a$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $330926e53d81707a$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $330926e53d81707a$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $330926e53d81707a$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $330926e53d81707a$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $330926e53d81707a$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_CUSTOMERS", () => $330926e53d81707a$export$7ded421b1395251e);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $330926e53d81707a$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_FOR_YOU", () => $330926e53d81707a$export$c68b73f0d8c14f41);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $330926e53d81707a$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $330926e53d81707a$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_COMMUNICATIONS_STAKEHOLDERS", () => $330926e53d81707a$export$784c436fb3f51c19);
$parcel$export(module.exports, "MENU_ID_OPS_STATUS_PAGES", () => $330926e53d81707a$export$151c003f483b38);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_CONFLUENCE", () => $330926e53d81707a$export$c093b87743053085);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_LOOM", () => $330926e53d81707a$export$e316a54b33dbe500);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_PROJECTS", () => $330926e53d81707a$export$8ceb414d866f12fc);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_TEAMS", () => $330926e53d81707a$export$804187987544d0f8);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_OPSGENIE", () => $330926e53d81707a$export$83352ab9064f1723);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $330926e53d81707a$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $330926e53d81707a$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $330926e53d81707a$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $330926e53d81707a$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $330926e53d81707a$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $330926e53d81707a$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $330926e53d81707a$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $330926e53d81707a$export$100a1a639a0db980);
const $330926e53d81707a$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets',
    // Global App Shortcuts for Platform Component
    GLOBAL_APP_CONFLUENCE: 'jira.sidebar.globalApp.confluence',
    GLOBAL_APP_LOOM: 'jira.sidebar.globalApp.loom',
    GLOBAL_APP_PROJECTS: 'jira.sidebar.globalApp.projects',
    GLOBAL_APP_TEAMS: 'jira.sidebar.globalApp.teams',
    GLOBAL_APP_OPSGENIE: 'jira.sidebar.globalApp.opsgenie'
};
const $330926e53d81707a$export$3b4ca8d4d769a311 = {
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_CONFLUENCE]: 'CONFLUENCE',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_LOOM]: 'LOOM',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_GOALS]: 'GOALS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_PROJECTS]: 'PROJECTS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_TEAMS]: 'TEAMS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_OPSGENIE]: 'OPSGENIE'
};
const $330926e53d81707a$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    CUSTOMERS: 'jira.sidebar.customers',
    ...$330926e53d81707a$export$1bb3d16bc95080e3
};
const $330926e53d81707a$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_JCS_GET_STARTED: (projectKey)=>`proj-${projectKey}-jcs-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_DASHBOARDS: (projectKey)=>`proj-${projectKey}-dashboards`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    ARCHIVED_WORK_ITEMS: (id)=>`archived_work_items_${id}`,
    PROJECT_ROVO_AGENT: (projectKey)=>`proj-${projectKey}-rovo-agent`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $330926e53d81707a$export$441cd608ea3204f4 = $330926e53d81707a$export$7838b734e4cd5e8d.APPS;
const $330926e53d81707a$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $330926e53d81707a$export$75c65bfc98b3a6e1 = $330926e53d81707a$export$7838b734e4cd5e8d.ASSETS;
const $330926e53d81707a$export$8a0af92d49f1d13d = 'asst_schm';
const $330926e53d81707a$export$5115ccb493164b9 = 'asst_for_you';
const $330926e53d81707a$export$a09300d15acc958a = 'asst_rprt';
const $330926e53d81707a$export$4d718fbd418eef5c = 'board-view-all';
const $330926e53d81707a$export$dd009509c2dabb5e = $330926e53d81707a$export$7838b734e4cd5e8d.DASHBOARDS;
const $330926e53d81707a$export$d3da0455b4200fb2 = 'dash-view';
const $330926e53d81707a$export$b9dd2b5309d19763 = 'dash-view-starred';
const $330926e53d81707a$export$3d81af172a8e3c57 = $330926e53d81707a$export$7838b734e4cd5e8d.FILTERS;
const $330926e53d81707a$export$1e2599eaf0039a97 = 'filt-search';
const $330926e53d81707a$export$53d274d993c9d5b5 = 'filt-view-all';
const $330926e53d81707a$export$7661ea763be69cfa = 'filt-view-starred';
const $330926e53d81707a$export$47c6ce6a83a59eab = $330926e53d81707a$export$7838b734e4cd5e8d.GOALS;
const $330926e53d81707a$export$ef89639b7d9c162a = $330926e53d81707a$export$7838b734e4cd5e8d.OPERATIONS;
const $330926e53d81707a$export$af4ab6d4e920522a = 'ops-alrt';
const $330926e53d81707a$export$25c40acb2c53a294 = 'ops-over';
const $330926e53d81707a$export$c7d8892f1628b844 = 'ops-rprt';
const $330926e53d81707a$export$bb19a52e3df99541 = 'ops-oncl';
const $330926e53d81707a$export$3bd12c092f8db11b = $330926e53d81707a$export$7838b734e4cd5e8d.OVERVIEWS;
const $330926e53d81707a$export$f2533da33c749933 = $330926e53d81707a$export$7838b734e4cd5e8d.PLANS;
const $330926e53d81707a$export$8468c5b6648f4f1f = 'plan-view-all';
const $330926e53d81707a$export$fed17b4c0866b97d = 'proj-app';
const $330926e53d81707a$export$9c5278bd360a285 = $330926e53d81707a$export$7838b734e4cd5e8d.PROJECTS;
const $330926e53d81707a$export$85389c606bb641dd = 'proj-view-all';
const $330926e53d81707a$export$4a1974b63c858e9c = 'proj-view-starred';
const $330926e53d81707a$export$692b796030a796f3 = $330926e53d81707a$export$7838b734e4cd5e8d.RECENT;
const $330926e53d81707a$export$cdc80d4b5ce0c6a = $330926e53d81707a$export$7838b734e4cd5e8d.ROADMAPS;
const $330926e53d81707a$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $330926e53d81707a$export$5637ca42a4d77f32 = $330926e53d81707a$export$7838b734e4cd5e8d.STARRED;
const $330926e53d81707a$export$d4f6fcf571f9c50 = $330926e53d81707a$export$7838b734e4cd5e8d.TEAMS;
const $330926e53d81707a$export$11fcdf33179ef88e = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $330926e53d81707a$export$1d260f51eeaab73d = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $330926e53d81707a$export$7ded421b1395251e = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMERS;
const $330926e53d81707a$export$80dc576e446bdb6b = 'yrwk';
const $330926e53d81707a$export$c68b73f0d8c14f41 = 'for-you';
const $330926e53d81707a$export$5aa3e4dd37f372d5 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $330926e53d81707a$export$7986b535c183c592 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $330926e53d81707a$export$b3b2df3daae04417 = 'comm';
const $330926e53d81707a$export$784c436fb3f51c19 = 'comm-stkhldr';
const $330926e53d81707a$export$205988f610130417 = 'comm-stkhldr-grp';
const $330926e53d81707a$export$151c003f483b38 = 'ops-status-pages';
const $330926e53d81707a$export$c093b87743053085 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_CONFLUENCE;
const $330926e53d81707a$export$e316a54b33dbe500 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_LOOM;
const $330926e53d81707a$export$8ceb414d866f12fc = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_PROJECTS;
const $330926e53d81707a$export$804187987544d0f8 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_TEAMS;
const $330926e53d81707a$export$83352ab9064f1723 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_OPSGENIE;
const $330926e53d81707a$export$79c15668ed799a1b = 'sd-sett-acc';
const $330926e53d81707a$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $330926e53d81707a$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $330926e53d81707a$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $330926e53d81707a$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $330926e53d81707a$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $330926e53d81707a$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $330926e53d81707a$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("kWbWF", function(module, exports) {
$parcel$export(module.exports, "getInitialSelectedPath", () => $6793867fe071cdbb$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $bx11l = parcelRequire("bx11l");

var $kg9Uh = parcelRequire("kg9Uh");
const $6793867fe071cdbb$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))((0, $kg9Uh.routeToSelectedPath));

});
parcelRegister("kg9Uh", function(module, exports) {
$parcel$export(module.exports, "routeToSelectedPath", () => $b1359280a8973d4c$export$a92474c098a1fd13);
$parcel$export(module.exports, "useRouteToSelectedPath", () => $b1359280a8973d4c$export$a086f1986cac3253);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $4cTDP = parcelRequire("4cTDP");

var $kfvK2 = parcelRequire("kfvK2");

var $K1AKP = parcelRequire("K1AKP");

var $5APJC = parcelRequire("5APJC");

var $bb1Lz = parcelRequire("bb1Lz");

var $hXLQ4 = parcelRequire("hXLQ4");

var $gUBBs = parcelRequire("gUBBs");

var $kyqLB = parcelRequire("kyqLB");

var $3NLYz = parcelRequire("3NLYz");

var $eC071 = parcelRequire("eC071");

var $3233g = parcelRequire("3233g");

var $nPGhK = parcelRequire("nPGhK");

var $7krAP = parcelRequire("7krAP");

var $6ofXP = parcelRequire("6ofXP");
function $b1359280a8973d4c$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $kyqLB.topLevelConverter).routes.has(routeName)) return (0, $kyqLB.topLevelConverter).convert(routeContext);
    if ((0, $K1AKP.appsConverter).routes.has(routeName)) return (0, $K1AKP.appsConverter).convert(routeContext);
    if ((0, $5APJC.assetsConverter).routes.has(routeName)) return (0, $5APJC.assetsConverter).convert(routeContext);
    if ((0, $bb1Lz.dashboardsConverter).routes.has(routeName)) return (0, $bb1Lz.dashboardsConverter).convert(routeContext);
    if ((0, $hXLQ4.filtersConverter).routes.has(routeName)) return (0, $hXLQ4.filtersConverter).convert(routeContext);
    if ((0, $gUBBs.operationsConverter).routes.has(routeName)) return (0, $gUBBs.operationsConverter).convert(routeContext);
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convert(routeContext);
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convert(routeContext);
    if ((0, $eC071.plansConverter).routes.has(routeName)) return (0, $eC071.plansConverter).convert(routeContext);
    if ((0, $3233g.projectsConverter).routes.has(routeName)) return (0, $3233g.projectsConverter).convert(routeContext);
    if ((0, $nPGhK.roadmapsConverter).routes.has(routeName)) return (0, $nPGhK.roadmapsConverter).convert(routeContext);
    if ((0, $7krAP.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $7krAP.serviceManagementProjectSettingsConverter).convert(routeContext);
    if ((0, $4cTDP.fg)('jcs_master_flag')) {
        if ((0, $6ofXP.customerServiceConverter).routes.has(routeName)) return (0, $6ofXP.customerServiceConverter).convert(routeContext);
    }
    return [];
}
function $b1359280a8973d4c$export$216c13b87ae41e0b(state) {
    const routeName = state.route.name;
    const match = state.match;
    const query = state.query;
    if ((0, $kyqLB.topLevelConverter).routes.has(routeName)) return (0, $kyqLB.topLevelConverter).convertNew({
        routeName: routeName
    });
    if ((0, $K1AKP.appsConverter).routes.has(routeName)) return (0, $K1AKP.appsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $5APJC.assetsConverter).routes.has(routeName)) return (0, $5APJC.assetsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $bb1Lz.dashboardsConverter).routes.has(routeName)) return (0, $bb1Lz.dashboardsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $hXLQ4.filtersConverter).routes.has(routeName)) return (0, $hXLQ4.filtersConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $gUBBs.operationsConverter).routes.has(routeName)) return (0, $gUBBs.operationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $eC071.plansConverter).routes.has(routeName)) return (0, $eC071.plansConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $3233g.projectsConverter).routes.has(routeName)) return (0, $3233g.projectsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $nPGhK.roadmapsConverter).routes.has(routeName)) return (0, $nPGhK.roadmapsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $7krAP.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $7krAP.serviceManagementProjectSettingsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $4cTDP.fg)('jcs_master_flag')) {
        if ((0, $6ofXP.customerServiceConverter).routes.has(routeName)) return (0, $6ofXP.customerServiceConverter).convertNew({
            routeName: routeName
        });
    }
    return [];
}
function $b1359280a8973d4c$export$8eb45058a3aef67f() {
    return (0, $eJOHy.useState)(()=>{
        const selectedPath = $b1359280a8973d4c$export$216c13b87ae41e0b((0, $kfvK2.getRouterState)());
        return {
            initialSelectedPath: selectedPath,
            selectedPath: selectedPath
        };
    });
}
function $b1359280a8973d4c$export$a086f1986cac3253() {
    const [selectedPathData, setSelectedPathData] = $b1359280a8973d4c$export$8eb45058a3aef67f();
    (0, $eJOHy.useEffect)(()=>(0, $kfvK2.addRouteListener)((state)=>{
            const nextSelectedPath = $b1359280a8973d4c$export$216c13b87ae41e0b(state);
            const pathIsDifferent = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextSelectedPath, selectedPathData.selectedPath);
            if (pathIsDifferent) setSelectedPathData({
                initialSelectedPath: selectedPathData.initialSelectedPath,
                selectedPath: nextSelectedPath
            });
        }), [
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath,
        setSelectedPathData
    ]);
    return selectedPathData;
}

});
parcelRegister("K1AKP", function(module, exports) {
$parcel$export(module.exports, "appsConverter", () => $e565dec3d2a1a779$export$d017a63045c88c47);

var $h4Bzb = parcelRequire("h4Bzb");
// TODO: verify these routes
const $e565dec3d2a1a779$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'legacy-connect-project',
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ 'connect-general-service-desk-project',
    'connect-project'
];
const $e565dec3d2a1a779$var$CERTAIN_APPS_SECTION_ROUTES = [
    'forge-spa-global',
    'marketplace-index',
    'forge-spa-personal-settings'
];
const $e565dec3d2a1a779$export$66b32f6f30eb4b4 = new Set([
    ...$e565dec3d2a1a779$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$e565dec3d2a1a779$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $e565dec3d2a1a779$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_APPS)
    ];
    return $e565dec3d2a1a779$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e565dec3d2a1a779$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_APPS)
    ];
    return $e565dec3d2a1a779$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e565dec3d2a1a779$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'marketplace-index':
            path.push((0, $h4Bzb.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 'connect-general':
        case 'connect-general-invalid':
        case 'forge-spa-global':
        case 'forge-spa-personal-settings':
        case 'legacy-connect-general':
            path.push((0, $h4Bzb.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 'connect-project':
        case 'legacy-connect-project':
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $h4Bzb.MENU_ID_PROJECTS),
                    (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 'connect-general-service-desk-project':
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $h4Bzb.MENU_ID_PROJECTS),
                    (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $e565dec3d2a1a779$export$d017a63045c88c47 = {
    routes: $e565dec3d2a1a779$export$66b32f6f30eb4b4,
    convert: $e565dec3d2a1a779$var$convert,
    convertNew: $e565dec3d2a1a779$var$convertNew
};

});

parcelRegister("5APJC", function(module, exports) {
$parcel$export(module.exports, "assetsConverter", () => $9795614a2d6fbb83$export$6cfeba0849032a84);

var $h4Bzb = parcelRequire("h4Bzb");
const $9795614a2d6fbb83$var$routes = new Set([
    'assets',
    'assets-configure',
    'assets-data-manager-getting-started',
    'assets-data-manager-object-classes',
    'assets-data-manager-data-source',
    'assets-data-manager-object-class-view',
    'assets-data-manager-object-detail-view',
    'assets-object',
    'assets-schema',
    'assets-for-you',
    'assets-schema-configuration',
    'assets-object-type-configuration',
    'assets-reports',
    'assets-reports-default-redirect',
    'assets-reports-unsubscribe',
    'assets-analytics-data-view-create',
    'assets-analytics-data-view-details',
    'assets-analytics-data-view-list',
    'assets-dashboards',
    'assets-dashboards-detail',
    'servicedesk-cmdb-assets',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-reports',
    'servicedesk-cmdb-assets-reports-default-redirect',
    'servicedesk-cmdb-assets-reports-unsubscribe',
    'servicedesk-cmdb-insight',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-analytics-data-view-create',
    'servicedesk-cmdb-assets-analytics-data-view-details',
    'servicedesk-cmdb-assets-analytics-data-view-list',
    'servicedesk-cmdb-assets-dashboards',
    'servicedesk-cmdb-assets-dashboards-detail'
]);
function $9795614a2d6fbb83$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $h4Bzb.MENU_ID_ASSETS)
    ];
    return $9795614a2d6fbb83$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $9795614a2d6fbb83$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_ASSETS)
    ];
    return $9795614a2d6fbb83$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $9795614a2d6fbb83$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'assets-for-you':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_FOR_YOU));
            break;
        case 'servicedesk-cmdb-assets':
        case 'servicedesk-cmdb-object':
        case 'servicedesk-cmdb-object-schema':
        case 'servicedesk-cmdb-object-schema-configuration':
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        // eslint-disable-next-line no-duplicate-case
        case 'servicedesk-cmdb-object':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema-configuration':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 'servicedesk-cmdb-assets-reports':
        case 'servicedesk-cmdb-assets-reports-default-redirect':
        case 'servicedesk-cmdb-assets-reports-unsubscribe':
        case 'servicedesk-cmdb-assets-analytics-data-view-create':
        case 'servicedesk-cmdb-assets-analytics-data-view-details':
        case 'servicedesk-cmdb-assets-analytics-data-view-list':
        case 'servicedesk-cmdb-assets-dashboards':
        case 'servicedesk-cmdb-assets-dashboards-detail':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $9795614a2d6fbb83$export$6cfeba0849032a84 = {
    routes: $9795614a2d6fbb83$var$routes,
    convert: $9795614a2d6fbb83$var$convert,
    convertNew: $9795614a2d6fbb83$var$convertNew
};

});

parcelRegister("bb1Lz", function(module, exports) {
$parcel$export(module.exports, "dashboardsConverter", () => $6dd0e62f793ca557$export$6468819b4be328b1);

var $h4Bzb = parcelRequire("h4Bzb");
const $6dd0e62f793ca557$var$routes = new Set([
    'dashboards-directory',
    'dashboard-edit',
    'dashboard-view',
    'dashboard-wallboard'
]);
function $6dd0e62f793ca557$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_DASHBOARDS)
    ];
    return $6dd0e62f793ca557$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6dd0e62f793ca557$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_DASHBOARDS)
    ];
    return $6dd0e62f793ca557$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6dd0e62f793ca557$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'dashboards-directory':
            path.push((0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 'dashboard-wallboard':
            query.dashboardId && path.push((0, $h4Bzb.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $h4Bzb.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $6dd0e62f793ca557$export$6468819b4be328b1 = {
    routes: $6dd0e62f793ca557$var$routes,
    convert: $6dd0e62f793ca557$var$convert,
    convertNew: $6dd0e62f793ca557$var$convertNew
};

});

parcelRegister("hXLQ4", function(module, exports) {
$parcel$export(module.exports, "filtersConverter", () => $54344df55ab10983$export$6e91331b5debb7c8);

var $h4Bzb = parcelRequire("h4Bzb");
const $54344df55ab10983$var$routes = new Set([
    'filters-directory',
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect',
    'issue',
    'legacy-gin',
    'legacy-gin-issue',
    'legacy-gin-subscriptions',
    'work-item'
]);
function $54344df55ab10983$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_FILTERS)
    ];
    return $54344df55ab10983$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $54344df55ab10983$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_FILTERS)
    ];
    return $54344df55ab10983$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $54344df55ab10983$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'filters-directory':
            path.push((0, $h4Bzb.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 'work-item':
        case 'issue':
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $h4Bzb.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $h4Bzb.MENU_ID_PROJECTS),
                        (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $h4Bzb.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $h4Bzb.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $54344df55ab10983$export$6e91331b5debb7c8 = {
    routes: $54344df55ab10983$var$routes,
    convert: $54344df55ab10983$var$convert,
    convertNew: $54344df55ab10983$var$convertNew
};

});

parcelRegister("gUBBs", function(module, exports) {
$parcel$export(module.exports, "operationsConverter", () => $8e03b266511d8843$export$7fc92455d5020e1);

var $4cTDP = parcelRequire("4cTDP");

var $h4Bzb = parcelRequire("h4Bzb");
const $8e03b266511d8843$var$routes = new Set([
    'eoc-automations',
    'eoc-custom-roles',
    'eoc-global-alerts',
    'eoc-global-alerts-redirect',
    'eoc-global-alert-detail',
    'eoc-global-group-detail',
    'eoc-global-reports',
    'eoc-global-report-dashboard',
    'eoc-heartbeats',
    'eoc-global-heartbeats',
    'eoc-maintenance',
    'eoc-on-call',
    'eoc-on-call-redirect',
    'eoc-overview',
    'eoc-overview-all-teams',
    'eoc-permissions',
    'eoc-reports',
    'eoc-reports-team',
    'eoc-reports-unsubscribe',
    'eoc-schedules',
    'eoc-team-alerts',
    'eoc-team-alert-detail',
    'eoc-team-alert-issue-syncing',
    'eoc-team-alert-issue-syncing-create',
    'eoc-team-alert-issue-syncing-detail',
    'eoc-team-group-detail',
    'eoc-team-integrations',
    'eoc-team-integration-create',
    'eoc-team-integration-detail',
    'eoc-team-integration-list',
    'eoc-team-integration-log',
    'eoc-team-policies',
    'eoc-who-is-on-call',
    'eoc-global-escalations',
    'communications-status-page',
    'communications-status-page-configuration',
    'communications-status-page-create',
    'communications-status-page-details',
    'communications-status-page-manage',
    'communications-stakeholder-groups',
    'communications-stakeholders',
    'eoc-merge-teams'
]);
function $8e03b266511d8843$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_OPERATIONS)
    ];
    return $8e03b266511d8843$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $8e03b266511d8843$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_OPERATIONS)
    ];
    return $8e03b266511d8843$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $8e03b266511d8843$var$convertRouteToPath(args) {
    const { routeName: routeName, query: query, path: path } = args;
    switch(routeName){
        case 'eoc-who-is-on-call':
            path.push((0, $h4Bzb.MENU_ID_OPS_ON_CALL));
            break;
        case 'eoc-global-alerts':
        case 'eoc-global-alerts-redirect':
        case 'eoc-global-alert-detail':
            {
                path.push((0, $h4Bzb.MENU_ID_OPS_ALERTS));
                if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) {
                    const { query: alarmQueue = '', view: view, filter: savedSearchId } = query;
                    view && path.push((0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchId || alarmQueue));
                    break;
                }
                const { query: alarmQueue = '', view: view } = query;
                view && path.push((0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                break;
            }
        case 'eoc-global-reports':
        case 'eoc-global-report-dashboard':
        case 'eoc-reports-unsubscribe':
            path.push((0, $h4Bzb.MENU_ID_OPS_REPORTS));
            break;
        case 'communications-status-page':
        case 'communications-status-page-configuration':
        case 'communications-status-page-create':
        case 'communications-status-page-details':
        case 'communications-status-page-manage':
            path.push((0, $h4Bzb.MENU_ID_OPS_STATUS_PAGES));
            break;
        case 'eoc-automations':
        case 'eoc-global-group-detail':
        case 'eoc-heartbeats':
        case 'eoc-maintenance':
        case 'eoc-permissions':
        case 'eoc-on-call':
        case 'eoc-on-call-redirect':
        case 'eoc-overview':
        case 'eoc-overview-all-teams':
        case 'eoc-reports':
        case 'eoc-reports-team':
        case 'eoc-schedules':
        case 'eoc-team-group-detail':
        case 'eoc-team-alerts':
        case 'eoc-team-alert-detail':
        case 'eoc-team-policies':
        case 'eoc-team-alert-issue-syncing':
        case 'eoc-team-alert-issue-syncing-create':
        case 'eoc-team-alert-issue-syncing-detail':
        case 'eoc-team-integrations':
        case 'eoc-team-integration-create':
        case 'eoc-team-integration-detail':
        case 'eoc-team-integration-list':
        case 'eoc-team-integration-log':
            path.push((0, $h4Bzb.MENU_ID_OPS_OVERVIEW));
            break;
        case 'communications-stakeholder-groups':
            path.push((0, $h4Bzb.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        case 'communications-stakeholders':
            path.push((0, $h4Bzb.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        default:
            break;
    }
    return path;
}
const $8e03b266511d8843$export$7fc92455d5020e1 = {
    routes: $8e03b266511d8843$var$routes,
    convert: $8e03b266511d8843$var$convert,
    convertNew: $8e03b266511d8843$var$convertNew
};

});

parcelRegister("kyqLB", function(module, exports) {
$parcel$export(module.exports, "topLevelConverter", () => $b77c4adb83be0f6d$export$a33f2d74a674bf8a);

var $h4Bzb = parcelRequire("h4Bzb");
// TODO: Remove your-work when cleaning up blu-7514_update_jira_home_your_work_to_for_you
const $b77c4adb83be0f6d$var$routes = new Set([
    'your-work',
    'for-you',
    'people-index'
]);
function $b77c4adb83be0f6d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $b77c4adb83be0f6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $b77c4adb83be0f6d$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $b77c4adb83be0f6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $b77c4adb83be0f6d$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    // TODO: Remove your-work when cleaning up blu-7514_update_jira_home_your_work_to_for_you
    switch(routeName){
        case 'your-work':
            path.push((0, $h4Bzb.MENU_ID_YOUR_WORK));
            break;
        case 'for-you':
            path.push((0, $h4Bzb.MENU_ID_FOR_YOU));
            break;
        case 'people-index':
            path.push((0, $h4Bzb.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $b77c4adb83be0f6d$export$a33f2d74a674bf8a = {
    routes: $b77c4adb83be0f6d$var$routes,
    convert: $b77c4adb83be0f6d$var$convert,
    convertNew: $b77c4adb83be0f6d$var$convertNew
};

});

parcelRegister("3NLYz", function(module, exports) {
$parcel$export(module.exports, "overviewsConverter", () => $3ffa2483d2986bd3$export$5469f6c6536ca9c5);

var $h4Bzb = parcelRequire("h4Bzb");
const $3ffa2483d2986bd3$var$routes = new Set([
    'classic-business-overview-calendar',
    'classic-business-overview-redirect',
    'classic-business-overview-summary',
    'classic-business-overview-timeline'
]);
function $3ffa2483d2986bd3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_OVERVIEWS)
    ];
    return $3ffa2483d2986bd3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $3ffa2483d2986bd3$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_OVERVIEWS)
    ];
    return $3ffa2483d2986bd3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $3ffa2483d2986bd3$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $h4Bzb.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $3ffa2483d2986bd3$export$5469f6c6536ca9c5 = {
    routes: $3ffa2483d2986bd3$var$routes,
    convert: $3ffa2483d2986bd3$var$convert,
    convertNew: $3ffa2483d2986bd3$var$convertNew
};

});

parcelRegister("eC071", function(module, exports) {
$parcel$export(module.exports, "plansConverter", () => $c10f9c452f3404f9$export$3bde637b58016d1);

var $h4Bzb = parcelRequire("h4Bzb");
const $c10f9c452f3404f9$var$routes = new Set([
    'plans-directory',
    'software-advanced-roadmaps',
    'software-advanced-roadmaps-getting-started-redirect',
    'software-advanced-roadmaps-setup',
    'software-plan-calendar',
    'software-plan-dependencies',
    'software-plan-increment',
    'software-plan-increments',
    'software-plan-releases',
    'software-plan-summary',
    'software-plan-teams',
    'software-plan-timeline',
    'trashed-plan-direct-link',
    'software-plan-upsell'
]);
function $c10f9c452f3404f9$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_PLANS)
    ];
    return $c10f9c452f3404f9$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $c10f9c452f3404f9$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_PLANS)
    ];
    return $c10f9c452f3404f9$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $c10f9c452f3404f9$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'plans-directory':
        case 'software-advanced-roadmaps-getting-started-redirect':
            path.push((0, $h4Bzb.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 'trashed-plan-direct-link':
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $h4Bzb.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $c10f9c452f3404f9$export$3bde637b58016d1 = {
    routes: $c10f9c452f3404f9$var$routes,
    convert: $c10f9c452f3404f9$var$convert,
    convertNew: $c10f9c452f3404f9$var$convertNew
};

});

parcelRegister("3233g", function(module, exports) {
$parcel$export(module.exports, "projectsConverter", () => $9cfe72e927f4264e$export$c41b724886e5872b);

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $h4Bzb = parcelRequire("h4Bzb");
const $9cfe72e927f4264e$var$routes = new Set([
    'browse-project-redirect',
    'legacy-all-reports',
    'projects-directory',
    'issue-navigator',
    'issue-navigator-core',
    'project-components',
    'project-not-found',
    'project-versions',
    'software-version-detail',
    'software-version-detail-no-tab-path',
    'forge-spa-project',
    'forge-spa-project-servicedesk',
    'forge-spa-servicedesk-queue',
    'polaris-ideas',
    'polaris-onboarding',
    'opsgenie-schedule',
    'issue-navigator-classic',
    'project-pages',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'software-backlog',
    'software-boards',
    'software-calendar',
    'software-calendar-classic',
    'software-capacity',
    'software-capacity-embed',
    'software-capacity-custom-embed',
    'software-capacity-classic',
    'software-capacity-classic-embed',
    'software-capacity-classic-custom-embed',
    'classic-software-proforma-issue-forms-direct',
    'software-code',
    'software-code-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-form',
    'software-form-classic',
    'software-form-builder',
    'software-form-builder-classic',
    'software-form-submit',
    'software-form-submit-classic',
    'software-form-submit-embed',
    'software-form-submit-public',
    'software-form-submit-classic-embed',
    'software-form-submit-classic-public',
    'software-goals',
    'software-goals-classic',
    'software-incidents',
    'software-incidents-classic',
    'software-issue-navigator',
    'software-list',
    'software-list-classic',
    'software-periscope',
    'software-periscope-classic',
    'software-reports',
    'software-reports-boardless',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-cycle-time',
    'software-reports-cycle-time-classic',
    'software-reports-deployment-frequency',
    'software-reports-deployment-frequency-classic',
    'software-reports-velocity',
    'software-reports-velocity-cmp',
    'software-security',
    'software-security-classic',
    'software-summary',
    'software-summary-embed',
    'software-summary-classic',
    'software-summary-classic-embed',
    'software-timeline',
    'software-timeline-classic',
    'software-view-not-found',
    'software-view-not-found-classic',
    'software-board-view-not-found',
    'software-board-view-not-found-classic',
    'software-onboarding-get-started',
    'knowledge-hub-all-articles',
    'kb-article-embed-editor',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-all-categories',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-suggested-topics',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'notification-logs',
    'servicedesk-atlassian-analytics',
    'servicedesk-boards',
    'servicedesk-calendar',
    'servicedesk-project-summary',
    'servicedesk-change-calendar',
    'servicedesk-connect-project',
    'servicedesk-customers-v2',
    'servicedesk-customer-details',
    'servicedesk-customer-service-escalations',
    'servicedesk-customer-service-products',
    'servicedesk-getting-started-page',
    'servicedesk-issue',
    'servicedesk-issues',
    'servicedesk-list',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organizations',
    'servicedesk-organization-details',
    'servicedesk-organization_v2',
    'servicedesk-queues-practice-custom-board',
    'servicedesk-queues-practice-custom-calendar',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-manage-view',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-board',
    'servicedesk-queues-custom-calendar',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-queues-edit',
    'servicedesk-practice-views-config',
    'servicedesk-queues-views-config',
    'servicedesk-queues-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-avp-project-dashboards-editable',
    'servicedesk-avp-project-dashboards-list',
    'servicedesk-services',
    'servicedesk-service-details',
    'customer-service-get-started',
    'classic-business-approvals',
    'classic-business-attachments',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-form',
    'classic-business-form-builder',
    'classic-business-form-submit',
    'classic-business-form-submit-public',
    'classic-business-list',
    'classic-business-shortcut',
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-view-not-found',
    'classic-business-redirect',
    'inbox',
    'inbox-classic'
]);
const $9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute = new Set($9cfe72e927f4264e$var$routes);
$9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute.add('archived-issues-directory').add('classic-business-archived-work-items').add('servicedesk-archived-work-items').add('software-archived-work-items-classic').add('software-archived-work-items');
function $9cfe72e927f4264e$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_PROJECTS)
    ];
    return $9cfe72e927f4264e$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $9cfe72e927f4264e$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_PROJECTS)
    ];
    return $9cfe72e927f4264e$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $9cfe72e927f4264e$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'polaris-onboarding':
            break;
        case 'projects-directory':
            path.push((0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 'forge-spa-project':
        case 'forge-spa-project-servicedesk':
        case 'forge-spa-servicedesk-queue':
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $h4Bzb.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $h4Bzb.ENTITY_ID).APP(appId));
                break;
            }
        case 'knowledge-hub-all-articles':
        case 'kb-article-embed-editor':
        case 'knowledge-hub-article-in-category':
        case 'knowledge-hub-browse-all-articles':
        case 'knowledge-hub-browse-all-categories':
        case 'knowledge-hub-browse-view-article':
        case 'knowledge-hub-category':
        case 'knowledge-hub-category-page':
        case 'knowledge-hub-drafts':
        case 'knowledge-hub-suggested-topics':
        case 'knowledge-hub-landing':
        case 'knowledge-hub-search':
        case 'knowledge-hub-setup':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 'servicedesk-getting-started-page':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 'customer-service-get-started':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_JCS_GET_STARTED(projectKey));
                break;
            }
        case 'notification-logs':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 'servicedesk-project-summary':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 'servicedesk-boards':
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $h4Bzb.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 'servicedesk-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-list':
            if ((0, $cxKOj.expVal)('jsm_multi_project_list_view_milestone_1', 'isEnabled', false)) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_VIEWS(projectKey));
            }
            break;
        case 'servicedesk-change-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-organizations':
        case 'servicedesk-organization-details':
        case 'servicedesk-organization_v2':
        case 'servicedesk-customers-v2':
        case 'servicedesk-customer-details':
        case 'servicedesk-customer-service-products':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 'servicedesk-customer-service-escalations':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 'servicedesk-kb-requests-reports':
        case 'servicedesk-kb-requests-reports-time-scale-issue':
        case 'servicedesk-kb-requests-reports-time-scale':
        case 'servicedesk-reports':
        case 'servicedesk-reports-custom':
        case 'servicedesk-reports-custom-create':
        case 'servicedesk-reports-custom-edit':
        case 'servicedesk-reports-custom-time-scale-issue':
        case 'servicedesk-reports-custom-time-scale':
        case 'servicedesk-reports-satisfaction':
        case 'servicedesk-reports-satisfaction-time-scale-issue':
        case 'servicedesk-reports-satisfaction-time-scale':
        case 'servicedesk-reports-type':
        case 'servicedesk-reports-workload':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 'servicedesk-avp-project-dashboards-editable':
        case 'servicedesk-avp-project-dashboards-list':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_DASHBOARDS(projectKey));
                break;
            }
        case 'servicedesk-oncall-schedule':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 'servicedesk-issues':
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $h4Bzb.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 'servicedesk-queues-practice-custom-board':
        case 'servicedesk-queues-practice-custom-calendar':
        case 'servicedesk-practice-custom-and-issue':
        case 'servicedesk-practice-edit':
        case 'servicedesk-practice-issue':
        case 'servicedesk-practice-landing':
        case 'servicedesk-practice-manage-view':
        case 'servicedesk-practice-views-config':
        case 'servicedesk-practice-new':
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-addon':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-custom-calendar':
        case 'servicedesk-queues-custom-view':
        case 'servicedesk-queues-edit':
        case 'servicedesk-queues-issue':
        case 'servicedesk-queues-manage-view':
        case 'servicedesk-queues-views-config':
        case 'servicedesk-queues-new':
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-custom-issue-detail':
            {
                const { projectKey: projectKey, queueId: queueId, issueKey: issueKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                issueKey && path.push((0, $h4Bzb.ENTITY_ID).ISSUE(issueKey));
                break;
            }
        case 'servicedesk-services':
        case 'servicedesk-service-details':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, formId: formId } = match.params;
                let { boardId: boardId } = match.params;
                const rapidViewBoard = query.rapidView ? query.rapidView : null;
                boardId = rapidViewBoard || boardId || null;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $h4Bzb.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $h4Bzb.ENTITY_ID).FORM(formId));
            }
    }
    if ((0, $4cTDP.fg)('fix-operations-menu-item-deselected-bug')) {
        const { projectKey: projectKey } = match.params;
        if ((routeName === 'servicedesk-change-calendar' || routeName === 'servicedesk-services' || routeName === 'servicedesk-service-details') && projectKey) path.push((0, $h4Bzb.ENTITY_ID).PROJECT_OPERATIONS(projectKey));
    }
    return path;
}
const $9cfe72e927f4264e$export$c41b724886e5872b = {
    get routes () {
        return (0, $4cTDP.fg)('ken_1984_archive_route_support_sidebar') ? $9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute : $9cfe72e927f4264e$var$routes;
    },
    convert: $9cfe72e927f4264e$var$convert,
    convertNew: $9cfe72e927f4264e$var$convertNew
};

});

parcelRegister("nPGhK", function(module, exports) {
$parcel$export(module.exports, "roadmapsConverter", () => $dd242add0bed8a4a$export$5761942b1e0c2dd0);

var $h4Bzb = parcelRequire("h4Bzb");
const $dd242add0bed8a4a$var$routes = new Set([
    'polaris-collections'
]);
function $dd242add0bed8a4a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_ROADMAPS)
    ];
    return $dd242add0bed8a4a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $dd242add0bed8a4a$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_ROADMAPS)
    ];
    return $dd242add0bed8a4a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $dd242add0bed8a4a$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'polaris-collections':
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $h4Bzb.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $h4Bzb.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $dd242add0bed8a4a$export$5761942b1e0c2dd0 = {
    routes: $dd242add0bed8a4a$var$routes,
    convert: $dd242add0bed8a4a$var$convert,
    convertNew: $dd242add0bed8a4a$var$convertNew
};

});

parcelRegister("7krAP", function(module, exports) {
$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $7d0a8f331dc5ad04$export$dd307ede503fe0e);

var $7xaze = parcelRequire("7xaze");

var $6WtFe = parcelRequire("6WtFe");

var $iPhgi = parcelRequire("iPhgi");

var $flolB = parcelRequire("flolB");

var $9CHTy = parcelRequire("9CHTy");

var $9zBC5 = parcelRequire("9zBC5");

var $7g1XK = parcelRequire("7g1XK");

var $hCTNK = parcelRequire("hCTNK");

var $kTJYz = parcelRequire("kTJYz");

var $azYhY = parcelRequire("azYhY");

var $cX4Fw = parcelRequire("cX4Fw");

var $eaMHj = parcelRequire("eaMHj");

var $huYm9 = parcelRequire("huYm9");

var $kDkUg = parcelRequire("kDkUg");

var $9Box0 = parcelRequire("9Box0");

var $306id = parcelRequire("306id");

var $2TwJc = parcelRequire("2TwJc");

var $84Gb2 = parcelRequire("84Gb2");

var $499r8 = parcelRequire("499r8");

var $ie5KY = parcelRequire("ie5KY");

var $jUN5r = parcelRequire("jUN5r");

var $buW1x = parcelRequire("buW1x");

var $dOEVM = parcelRequire("dOEVM");

var $7B6GN = parcelRequire("7B6GN");

var $9pooG = parcelRequire("9pooG");

var $ihecD = parcelRequire("ihecD");

var $4XctI = parcelRequire("4XctI");

var $loMl1 = parcelRequire("loMl1");

var $37gZV = parcelRequire("37gZV");

var $azX7D = parcelRequire("azX7D");

var $3EnHO = parcelRequire("3EnHO");

var $cdHCV = parcelRequire("cdHCV");

var $csrcH = parcelRequire("csrcH");

var $idiiX = parcelRequire("idiiX");

var $hsEQN = parcelRequire("hsEQN");

var $jmJlK = parcelRequire("jmJlK");

var $88a5z = parcelRequire("88a5z");

var $jOpgR = parcelRequire("jOpgR");

var $h4Bzb = parcelRequire("h4Bzb");
const $7d0a8f331dc5ad04$var$routes = new Set([
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'project-settings-servicedesk-rovo-service-agent',
    'servicedesk-sla-settings',
    (0, $flolB.projectSettingsServicedeskAutomationSummaryRoute).name,
    (0, $9CHTy.projectSettingsServicedeskAccessRoute).name,
    (0, $kTJYz.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $kDkUg.projectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $2TwJc.projectSettingsServicedeskFeedbackRoute).name,
    (0, $84Gb2.projectSettingsServicedeskFieldsRoute).name,
    (0, $7B6GN.projectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $9pooG.projectSettingsServicedeskItsmTicketTypesConfigRoute).name,
    (0, $eaMHj.projectSettingsServicedeskChatRoute).name,
    (0, $9Box0.projectSettingsServicedeskEmailRoute).name,
    (0, $306id.projectSettingsServicedeskExternalLinksRoute).name,
    (0, $dOEVM.projectSettingsServicedeskPortalSettingsRoute).name,
    (0, $ihecD.projectSettingsServicedeskWidgetRoute).name,
    (0, $7g1XK.projectSettingsServicedeskChangeManagementRoute).name,
    (0, $499r8.projectSettingsServicedeskIncidentManagementRoute).name,
    (0, $huYm9.projectSettingsServicedeskClassicAppsRoute).name,
    (0, $hCTNK.projectSettingsServicedeskChannelsChatRoute).name,
    (0, $cX4Fw.projectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $6WtFe.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $iPhgi.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $buW1x.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $9zBC5.projectSettingsServicedeskAppsFieldsRoute).name,
    (0, $cdHCV.projectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $csrcH.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $idiiX.projectSettingsServicedeskKbRoute).name,
    (0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $88a5z.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $jOpgR.servicedeskWorkflowConfigRoute).name,
    (0, $jUN5r.projectSettingsServicedeskIssuetypesRoute).name,
    (0, $azYhY.projectSettingsServicedeskChannelsPortalRoute).name,
    (0, $7xaze.projectSettingsServicedeskAutomationRoute).name,
    (0, $hsEQN.servicedeskSlaSettingsRoute).name,
    (0, $ie5KY.projectSettingsServicedeskInternalNotificationsNextGenRoute).name,
    (0, $loMl1.landingPageRoute).name,
    (0, $37gZV.browseConversationsRoute).name,
    (0, $azX7D.browseIntentsRoute).name,
    (0, $3EnHO.browseStandardFlowsRoute).name,
    (0, $4XctI.virtualAgentSettingsRoute).name
]);
function $7d0a8f331dc5ad04$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $7d0a8f331dc5ad04$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $7d0a8f331dc5ad04$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $7d0a8f331dc5ad04$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $7d0a8f331dc5ad04$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        // Access Menu
        case 'legacy-project-settings-people':
        case (0, $9CHTy.projectSettingsServicedeskAccessRoute).name:
        case (0, $kDkUg.projectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $kTJYz.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 'legacy-project-settings-permissions':
        case 'legacy-project-settings-issue-security':
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $9pooG.projectSettingsServicedeskItsmTicketTypesConfigRoute).name:
        case (0, $88a5z.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management
        case (0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $7B6GN.projectSettingsServicedeskProformaProjectFormsRoute).name:
        case 'legacy-project-settings-workflows':
        case (0, $jOpgR.servicedeskWorkflowConfigRoute).name:
        case 'legacy-project-settings-workflows-associate':
        case 'servicedesk-sla-settings':
        case (0, $hsEQN.servicedeskSlaSettingsRoute).name:
        case (0, $2TwJc.projectSettingsServicedeskFeedbackRoute).name:
        case 'legacy-project-settings-issue-types':
        case (0, $jUN5r.projectSettingsServicedeskIssuetypesRoute).name:
        case 'legacy-project-settings-fields':
        case (0, $84Gb2.projectSettingsServicedeskFieldsRoute).name:
        case 'legacy-project-settings-screens':
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Automation
        case 'project-settings-automation':
        case (0, $flolB.projectSettingsServicedeskAutomationSummaryRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $dOEVM.projectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $azYhY.projectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $9Box0.projectSettingsServicedeskEmailRoute).name:
        case (0, $eaMHj.projectSettingsServicedeskChatRoute).name:
        case (0, $ihecD.projectSettingsServicedeskWidgetRoute).name:
        case (0, $idiiX.projectSettingsServicedeskKbRoute).name:
        case (0, $306id.projectSettingsServicedeskExternalLinksRoute).name:
        case (0, $hCTNK.projectSettingsServicedeskChannelsChatRoute).name:
        case (0, $cX4Fw.projectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $4XctI.virtualAgentSettingsRoute).name:
        case (0, $loMl1.landingPageRoute).name:
        case (0, $37gZV.browseConversationsRoute).name:
        case (0, $azX7D.browseIntentsRoute).name:
        case (0, $3EnHO.browseStandardFlowsRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $7g1XK.projectSettingsServicedeskChangeManagementRoute).name:
        case (0, $499r8.projectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 'legacy-project-settings-notifications':
        case (0, $cdHCV.projectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $buW1x.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $csrcH.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $6WtFe.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $iPhgi.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $ie5KY.projectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $huYm9.projectSettingsServicedeskClassicAppsRoute).name:
        case (0, $9zBC5.projectSettingsServicedeskAppsFieldsRoute).name:
        case 'project-settings-servicedesk-rovo-service-agent':
            // ADD rest of the apps here
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $7d0a8f331dc5ad04$export$dd307ede503fe0e = {
    routes: $7d0a8f331dc5ad04$var$routes,
    convert: $7d0a8f331dc5ad04$var$convert,
    convertNew: $7d0a8f331dc5ad04$var$convertNew
};

});
parcelRegister("7xaze", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $74c18d3f7e20f44d$export$1a2228d5e07202a0);
const $74c18d3f7e20f44d$export$1a2228d5e07202a0 = {
    name: 'project-settings-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automate'
};

});

parcelRegister("6WtFe", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $dd3281251f67d1d8$export$1f37a1aff4f594af);
const $dd3281251f67d1d8$export$1f37a1aff4f594af = {
    name: 'project-settings-servicedesk-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
    exact: true
};

});

parcelRegister("iPhgi", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $e2d116eeed869549$export$40539cb16771014e);
const $e2d116eeed869549$export$40539cb16771014e = {
    name: 'project-settings-servicedesk-notifications-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("flolB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRoute", () => $e924041ee9cf8148$export$165d82a2618e4d99);
const $e924041ee9cf8148$export$165d82a2618e4d99 = {
    name: 'project-settings-servicedesk-automation-summary',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation'
};

});

parcelRegister("9CHTy", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRoute", () => $494393447df36998$export$6473a81f1ee460ef);
const $494393447df36998$export$6473a81f1ee460ef = {
    name: 'project-settings-servicedesk-access',
    path: '/jira/servicedesk/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("9zBC5", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRoute", () => $7eac910e270d98a7$export$bb46672b3fb14eec);
const $7eac910e270d98a7$export$bb46672b3fb14eec = {
    name: 'project-settings-servicedesk-apps-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("7g1XK", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRoute", () => $852fc1870396df0f$export$1444ee3eb63a2ffc);
const $852fc1870396df0f$export$1444ee3eb63a2ffc = {
    name: 'project-settings-servicedesk-change-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
    exact: true
};

});

parcelRegister("hCTNK", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRoute", () => $cf62c7fefbad1b1f$export$be5ad475040cd044);
const $cf62c7fefbad1b1f$export$be5ad475040cd044 = {
    name: 'project-settings-servicedesk-channels-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
    exact: true
};

});

parcelRegister("kTJYz", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $f1625153a3fc4be1$export$5fb39a9d3820886c);
const $f1625153a3fc4be1$export$5fb39a9d3820886c = {
    name: 'project-settings-servicedesk-channels-permissions-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
    exact: true
};

});

parcelRegister("azYhY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRoute", () => $bf04ae1978c865f7$export$8f4234e4e79e03);
const $bf04ae1978c865f7$export$8f4234e4e79e03 = {
    name: 'project-settings-servicedesk-channels-portal',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
    exact: true
};

});

parcelRegister("cX4Fw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRoute", () => $bbc98215303aabc7$export$c66db54872d3b51c);
const $bbc98215303aabc7$export$c66db54872d3b51c = {
    name: 'project-settings-servicedesk-channels-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
    exact: true
};

});

parcelRegister("eaMHj", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChatRoute", () => $db76c9323340b2b3$export$b22ac188582d1dbd);
const $db76c9323340b2b3$export$b22ac188582d1dbd = {
    name: 'project-settings-servicedesk-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/chat',
    exact: true
};

});

parcelRegister("huYm9", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRoute", () => $9871f373036dc5dd$export$2b65324bb87228c5);
const $9871f373036dc5dd$export$2b65324bb87228c5 = {
    name: 'project-settings-servicedesk-classic-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps',
    exact: true
};

});

parcelRegister("kDkUg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRoute", () => $9ff9cc4235e57156$export$d8ed4a1eb0c01b5a);
const $9ff9cc4235e57156$export$d8ed4a1eb0c01b5a = {
    name: 'project-settings-servicedesk-customer-permissions',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
    exact: true
};

});

parcelRegister("9Box0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskEmailRoute", () => $cc88ee571b3cf336$export$d7d111417bfcd900);
const $cc88ee571b3cf336$export$d7d111417bfcd900 = {
    name: 'project-settings-servicedesk-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/email',
    exact: true
};

});

parcelRegister("306id", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRoute", () => $e5f40259a6056a55$export$2ec1a0d49a1f6ac2);
const $e5f40259a6056a55$export$2ec1a0d49a1f6ac2 = {
    name: 'project-settings-servicedesk-external-links',
    path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
    exact: true
};

});

parcelRegister("2TwJc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRoute", () => $a927b1b6a51288e0$export$f21485e31d7839aa);
const $a927b1b6a51288e0$export$f21485e31d7839aa = {
    name: 'project-settings-servicedesk-feedback',
    path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings'
};

});

parcelRegister("84Gb2", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFieldsRoute", () => $c2df9347b08a45ce$export$44f665a50373c681);
const $c2df9347b08a45ce$export$44f665a50373c681 = {
    name: 'project-settings-servicedesk-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("499r8", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRoute", () => $2fa916512590f19d$export$f91bd0bb0d4783ff);
const $2fa916512590f19d$export$f91bd0bb0d4783ff = {
    name: 'project-settings-servicedesk-incident-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
    exact: true
};

});

parcelRegister("ie5KY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRoute", () => $b1e3a423a8f43b26$export$5db62792327950b4);
const $b1e3a423a8f43b26$export$5db62792327950b4 = {
    name: 'project-settings-servicedesk-internal-notifications-nextGen',
    path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications'
};

});

parcelRegister("jUN5r", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRoute", () => $855f65ce7afe991a$export$2ffcb2e92bb4950b);
const $855f65ce7afe991a$export$2ffcb2e92bb4950b = {
    name: 'project-settings-servicedesk-issuetypes',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("buW1x", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $691e3ad540e16e7f$export$5108e41f558ecf03);
const $691e3ad540e16e7f$export$5108e41f558ecf03 = {
    name: 'project-settings-servicedesk-notifications-internal-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications'
};

});

parcelRegister("dOEVM", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRoute", () => $0a55881c22b9f361$export$7593a7e4a6fc0aaf);
const $0a55881c22b9f361$export$7593a7e4a6fc0aaf = {
    name: 'project-settings-servicedesk-portal-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
    exact: true
};

});

parcelRegister("7B6GN", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRoute", () => $692ad077baa2d08a$export$ee87e5f9754e3600);
const $692ad077baa2d08a$export$ee87e5f9754e3600 = {
    name: 'project-settings-servicedesk-proforma-project-forms',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("9pooG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRoute", () => $360e2c2f6b3ef4cd$export$52596d9b432829c);
const $360e2c2f6b3ef4cd$export$52596d9b432829c = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice'
};

});

parcelRegister("ihecD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskWidgetRoute", () => $ebdcd6c0fa97846d$export$ac674ffd39608325);
const $ebdcd6c0fa97846d$export$ac674ffd39608325 = {
    name: 'project-settings-servicedesk-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/widget',
    exact: true
};

});

parcelRegister("4XctI", function(module, exports) {
$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $10f406c20ca6a562$export$80422a49e17dfd6b);
const $10f406c20ca6a562$export$80422a49e17dfd6b = {
    name: 'project-settings-servicedesk-virtual-agent-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
    exact: true
};

});

parcelRegister("loMl1", function(module, exports) {
$parcel$export(module.exports, "landingPageRoute", () => $a59bf5c45457fa62$export$8c051c399fd812a5);
const $a59bf5c45457fa62$export$8c051c399fd812a5 = {
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: 'project-settings-servicedesk-virtualagentonboarding',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
};

});

parcelRegister("37gZV", function(module, exports) {
$parcel$export(module.exports, "browseConversationsRoute", () => $ceaa8b7bf0ef893e$export$c8ff4cf64e5540ec);
const $ceaa8b7bf0ef893e$export$c8ff4cf64e5540ec = {
    name: 'project-settings-servicedesk-virtualagent-browseconversations',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
};

});

parcelRegister("azX7D", function(module, exports) {
$parcel$export(module.exports, "browseIntentsRoute", () => $2161d9d9dd4bb376$export$3e227412713bc57f);
const $2161d9d9dd4bb376$export$3e227412713bc57f = {
    name: 'project-settings-servicedesk-virtualagent-browse-intents',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
};

});

parcelRegister("3EnHO", function(module, exports) {
$parcel$export(module.exports, "browseStandardFlowsRoute", () => $5947d66ca945bddb$export$fd091ba8fa858397);
const $5947d66ca945bddb$export$fd091ba8fa858397 = {
    name: 'project-settings-servicedesk-virtualagent-standard-flows',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
};

});

parcelRegister("cdHCV", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRoute", () => $3097aecf5b1470cb$export$176d388c5b23978e);
const $3097aecf5b1470cb$export$176d388c5b23978e = {
    name: 'project-settings-servicedesk-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications'
};

});

parcelRegister("csrcH", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $825ea2891dbc89b5$export$6ce57d409e1934f2);
const $825ea2891dbc89b5$export$6ce57d409e1934f2 = {
    name: 'project-settings-servicedesk-notifications-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications'
};

});

parcelRegister("idiiX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskKbRoute", () => $552f05c4b16ed42f$export$725fadff9ae82302);
const $552f05c4b16ed42f$export$725fadff9ae82302 = {
    name: 'project-settings-servicedesk-kb',
    path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
    exact: true
};

});

parcelRegister("hsEQN", function(module, exports) {
$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $e9bc452ea345b3c1$export$bfbf66468910573e);
const $e9bc452ea345b3c1$export$bfbf66468910573e = {
    name: 'servicedesk-sla-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("jmJlK", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRoute", () => $439c11180176b27d$export$31f95ad4356ce017);
const $439c11180176b27d$export$31f95ad4356ce017 = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types'
};

});

parcelRegister("88a5z", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $69c1533799a2149a$export$8c897f53ff36fa6b);
const $69c1533799a2149a$export$8c897f53ff36fa6b = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned'
};

});

parcelRegister("jOpgR", function(module, exports) {
$parcel$export(module.exports, "servicedeskWorkflowConfigRoute", () => $7521baf68ef87a51$export$ecc771c0ee86ccb8);
const $7521baf68ef87a51$export$ecc771c0ee86ccb8 = {
    name: 'project-settings-servicedesk-workflow-scheme-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});


parcelRegister("6ofXP", function(module, exports) {
$parcel$export(module.exports, "customerServiceConverter", () => $2cdb1f0dd4092ebc$export$8e632ccd3e33c9f1);

var $h4Bzb = parcelRequire("h4Bzb");
const $2cdb1f0dd4092ebc$var$routes = new Set([
    'customer-service-helpcenter',
    'customer-service-helpcenter-analytics',
    'customer-service-customers',
    'customer-service-customer-details',
    'customer-service-organizations',
    'customer-service-organization-details',
    'customer-service-products'
]);
function $2cdb1f0dd4092ebc$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $2cdb1f0dd4092ebc$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $2cdb1f0dd4092ebc$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $2cdb1f0dd4092ebc$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $2cdb1f0dd4092ebc$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'customer-service-helpcenter':
            path.push((0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE));
            break;
        case 'customer-service-helpcenter-analytics':
            // Analytics appears nested under dashboards
            path.push((0, $h4Bzb.MENU_ID_DASHBOARDS));
            path.push((0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS));
            break;
        case 'customer-service-customers':
        case 'customer-service-customer-details':
        case 'customer-service-organizations':
        case 'customer-service-organization-details':
        case 'customer-service-products':
            path.push((0, $h4Bzb.MENU_ID_CUSTOMERS));
            break;
        default:
    }
    return path;
}
const $2cdb1f0dd4092ebc$export$8e632ccd3e33c9f1 = {
    routes: $2cdb1f0dd4092ebc$var$routes,
    convert: $2cdb1f0dd4092ebc$var$convert,
    convertNew: $2cdb1f0dd4092ebc$var$convertNew
};

});



parcelRegister("b1DBy", function(module, exports) {
$parcel$export(module.exports, "isSelectedPath", () => $7fd392c392ccabb1$export$cdcd6885320eec31);

var $aLENQ = parcelRequire("aLENQ");
function $7fd392c392ccabb1$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $aLENQ.isMenuIdList)(menuId) ? (0, $aLENQ.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("aLENQ", function(module, exports) {
$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $d932814a3842588f$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $d932814a3842588f$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $d932814a3842588f$export$d8e017f58178e379);
const $d932814a3842588f$var$MENU_ID_DELIM = '   '; // Three spaces
function $d932814a3842588f$export$253323efd0c41e72(menuIds) {
    return menuIds.join($d932814a3842588f$var$MENU_ID_DELIM);
}
function $d932814a3842588f$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($d932814a3842588f$var$MENU_ID_DELIM) !== -1;
}
function $d932814a3842588f$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($d932814a3842588f$var$MENU_ID_DELIM);
}

});


parcelRegister("bBIDB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c207eec2783a5a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d6d6d7cb42221874028c7f83f3e7e94>>
 * @relayHash 25920bf67022fe35c6b58c747625ebb5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 518c9f948e2329afd08e983172f6a44dc03e82b920a5edaca9d268c972f95a23

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $5moL7 = parcelRequire("5moL7");

var $hJ0S2 = parcelRequire("hJ0S2");

var $lhtKZ = parcelRequire("lhtKZ");

var $jhhgp = parcelRequire("jhhgp");

var $eSxxM = parcelRequire("eSxxM");

var $eEnEt = parcelRequire("eEnEt");
const $9c207eec2783a5a9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "label"
    }, v15 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v16 = {
        "kind": "ScalarField",
        "name": "url"
    }, v17 = {
        "order": "DESC"
    }, v18 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v20 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v23 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v27 = [
        v16 /*: any*/ 
    ], v28 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v29 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v27 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v31 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v32 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v33 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v34 = [
        v10 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ 
    ], v35 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v36 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v37 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v34 /*: any*/ 
            }
        ]
    }, v38 = [
        v37 /*: any*/ ,
        v35 /*: any*/ 
    ], v39 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v40 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v42 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v13 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v26 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v27 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v28 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v28 /*: any*/ 
            ]
        }
    ], v43 = [
        v10 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ConfigurableMenuItems"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudID",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "navKey",
                                            "value": "NAV_SIDEBAR"
                                        }
                                    ],
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraConfigurableNavigationItem",
                                            "kind": "LinkedField",
                                            "name": "navItems",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "menuId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVisible"
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isProjectsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsProjectsExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "shouldDisplay",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isFiltersExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsFiltersExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isAppsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "globalAppNavigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appType"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ ,
                                                                                        v16 /*: any*/ ,
                                                                                        v15 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "settingsUrl"
                                                                        },
                                                                        v16 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isPlansExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsPlansExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                                    "kind": "LinkedField",
                                    "name": "advancedRoadmapsNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasEditPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasCreateSamplePlanPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasGlobalPlansAdminPermissions"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraWorkManagementLicensing",
                                            "kind": "LinkedField",
                                            "name": "jwmLicensing",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "currentUserSeatEdition"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "favouriteProjects",
                                                    "args": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "sort": v17 /*: any*/ ,
                                                                "type": "PROJECT"
                                                            }
                                                        },
                                                        v18 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraFavouriteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "favourites",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraFavouriteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v34 /*: any*/ ,
                                                                            "type": "JiraProject"
                                                                        },
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v35 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        v11 /*: any*/ ,
                                                        v36 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "recentProjects",
                                                    "plural": false,
                                                    "selections": v38 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "entityAri",
                                                            "variableName": "entityAriProjects"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "ownerAri",
                                                            "variableName": "ownerAri"
                                                        }
                                                    ],
                                                    "concreteType": "SettingsNavigationCustomisation",
                                                    "kind": "LinkedField",
                                                    "name": "settings_navigationCustomisation",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "SettingsDisplayPropertyConnection",
                                                            "kind": "LinkedField",
                                                            "name": "properties",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SettingsDisplayProperty",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "key"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraProjectsSidebarMenu",
                                            "kind": "LinkedField",
                                            "name": "jira_projectsSidebarMenu",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "mostRecent",
                                                    "plural": false,
                                                    "selections": v34 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "mostRecentFromHistory",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v31 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        v18 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "favourites",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v35 /*: any*/ 
                                                    ],
                                                    "storageKey": "favourites(first:15)"
                                                },
                                                {
                                                    "args": [
                                                        v36 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "recents",
                                                    "plural": false,
                                                    "selections": v38 /*: any*/ ,
                                                    "storageKey": "recents(first:20)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasMore"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouriteLimit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "recentLimit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayMode"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteFilters",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v17 /*: any*/ ,
                                                        "type": "FILTER"
                                                    }
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v41 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v35 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentFilters",
                                            "args": [
                                                v11 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "FILTER"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v24 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v40 /*: any*/ ,
                                                                                v41 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraFilter",
                                                                            "abstractKey": "__isJiraFilter"
                                                                        }
                                                                    ],
                                                                    "type": "JiraCustomFilter"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v35 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraSystemFilterConnection",
                                            "kind": "LinkedField",
                                            "name": "systemFilters",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilterEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSystemFilter",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v41 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouritePlans",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v17 /*: any*/ ,
                                                        "type": "PLAN"
                                                    }
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v42 /*: any*/ 
                                                },
                                                v35 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentPlans",
                                            "args": [
                                                v11 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "PLAN"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v42 /*: any*/ 
                                                },
                                                v35 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isOperationsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieQuery",
                                    "kind": "LinkedField",
                                    "name": "opsgenie",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "OpsgenieSavedSearches",
                                            "kind": "LinkedField",
                                            "name": "savedSearches",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "sharedWithMe",
                                                    "plural": true,
                                                    "selections": v43 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "createdByMe",
                                                    "plural": true,
                                                    "selections": v43 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isOverviewsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                            "kind": "LinkedField",
                                            "name": "jwmOverviews",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraWorkManagementGiraOverview",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "518c9f948e2329afd08e983172f6a44dc03e82b920a5edaca9d268c972f95a23",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider": (0, $hJ0S2.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default)
            }
        }
    };
}();
$9c207eec2783a5a9$var$node.hash = "fffe23a56118d84dd30e01387c939a22";
var $9c207eec2783a5a9$export$2e2bcd8739ae039 = $9c207eec2783a5a9$var$node;

});
parcelRegister("9zQGn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d4cac831a774767$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $4d4cac831a774767$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("dtG0v", function(module, exports) {
$parcel$export(module.exports, "default", () => $63f7d731301be654$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $63f7d731301be654$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false);
    }
};

});

parcelRegister("cli8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4603c488541d3d8$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $d4603c488541d3d8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("5moL7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6adb616ba86c8a9a$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6adb616ba86c8a9a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('blu-8022_refactor_jpd_project_menu_to_common');
    }
};

});

parcelRegister("hJ0S2", function(module, exports) {
$parcel$export(module.exports, "default", () => $26a0668fc1839e3a$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
const $26a0668fc1839e3a$var$grw1672DisplayTargetedJsmTemplateCtaInNav4RelayProvider = {
    get () {
        const [config] = (0, $cxKOj.UNSAFE_noExposureExp)('grw-1672_display_targeted_jsm_template_cta_in_nav4');
        const cohort = config.get('cohort', 'not-enrolled');
        return cohort === 'variation' || cohort === 'control';
    }
};
var $26a0668fc1839e3a$export$2e2bcd8739ae039 = $26a0668fc1839e3a$var$grw1672DisplayTargetedJsmTemplateCtaInNav4RelayProvider;

});

parcelRegister("lhtKZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a53aade22d0a15d3$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $a53aade22d0a15d3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jcs_project_type_m3');
    }
};

});

parcelRegister("jhhgp", function(module, exports) {
$parcel$export(module.exports, "default", () => $27d2e2844d6132da$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $27d2e2844d6132da$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('allow_end_users_to_access_custom_templates');
    }
};

});

parcelRegister("eSxxM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f962c415abaf11a$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6f962c415abaf11a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsm_aiiy_for_nav_item_sidebar');
    }
};

});

parcelRegister("eEnEt", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb512a18f102874$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $7cb512a18f102874$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) || (0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
    }
};

});


parcelRegister("hOoYL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c09a8bcbde12b5a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f732e3796702512c73ca832a7914491>>
 * @relayHash 7a443acd220d539f3cd8c7ec5c956659
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 325aa048001f18db849e4eab37f49af8b128234d4f44f3212d79bc71a67833c7
const $c09a8bcbde12b5a5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSkipped"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "condition": "isSkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "condition": "isSkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "325aa048001f18db849e4eab37f49af8b128234d4f44f3212d79bc71a67833c7",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c09a8bcbde12b5a5$var$node.hash = "08b2edadb724d5a59e6adfbb10f7a3a4";
var $c09a8bcbde12b5a5$export$2e2bcd8739ae039 = $c09a8bcbde12b5a5$var$node;

});

parcelRegister("fKh2A", function(module, exports) {
$parcel$export(module.exports, "JiraNavigationSettingsAri", () => $b7685ed214380de6$export$d53f27b41a9a02bb);

var $02tnb = parcelRequire("02tnb");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/navigation-settings/manifest.ts
var $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $02tnb.JiraNavigationSettingsAriResourceOwner),
    resourceType: (0, $02tnb.JiraNavigationSettingsAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationSettingScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationSettingScope: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/navigation-settings/index.ts
var $b7685ed214380de6$export$d53f27b41a9a02bb = class _JiraNavigationSettingsAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationSettingScope = opts.resourceIdSegmentValues.navigationSettingScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationSettingScope() {
        return this._navigationSettingScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.qualifier,
            platformQualifier: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.resourceOwner,
            resourceType: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationSettingScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationSettingScope: opts.navigationSettingScope
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationSettingScope: this.navigationSettingScope
        };
    }
};

});
parcelRegister("02tnb", function(module, exports) {
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceOwner", () => $0076f8d914be1751$export$a71eb7f052c3a8f1);
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceType", () => $0076f8d914be1751$export$8c9eb6c30d1db6dc);
// src/jira/navigation-settings/types.ts
var $0076f8d914be1751$export$a71eb7f052c3a8f1 = "jira", $0076f8d914be1751$export$8c9eb6c30d1db6dc = "navigation-settings";

});


parcelRegister("7Cu03", function(module, exports) {
$parcel$export(module.exports, "IdentityUserAri", () => $58c35a58a97fa779$export$1e9d09c2be53e55e);

var $6A8mn = parcelRequire("6A8mn");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/identity/user/manifest.ts
var $58c35a58a97fa779$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6A8mn.IdentityUserAriResourceOwner),
    resourceType: (0, $6A8mn.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $58c35a58a97fa779$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._userId = opts.resourceIdSegmentValues.userId;
    }
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $58c35a58a97fa779$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $58c35a58a97fa779$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $58c35a58a97fa779$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $58c35a58a97fa779$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $58c35a58a97fa779$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $58c35a58a97fa779$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
};

});
parcelRegister("6A8mn", function(module, exports) {
$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $4cac96fbba13502a$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $4cac96fbba13502a$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $4cac96fbba13502a$export$b4c14c54282a779d = "identity", $4cac96fbba13502a$export$e9b50e20f4fbfb71 = "user";

});



parcelRegister("6JmRt", function(module, exports) {
$parcel$export(module.exports, "navPlatformSidebarResource", () => $096168d79e374d02$export$b22e51bad3fbae1b);

var $h4Bzb = parcelRequire("h4Bzb");

var $kWbWF = parcelRequire("kWbWF");

var $b1DBy = parcelRequire("b1DBy");

var $9FYIg = parcelRequire("9FYIg");

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");

var $goBB5 = parcelRequire("goBB5");

var $QuA6u = parcelRequire("QuA6u");

var $5j3lw = parcelRequire("5j3lw");
const $096168d79e374d02$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM = 'RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM';
const $096168d79e374d02$export$b22e51bad3fbae1b = (0, $9FYIg.createRelayResource)({
    type: $096168d79e374d02$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId } })=>{
        const initialSelectedPath = (0, $kWbWF.getInitialSelectedPath)(routerContext);
        const siteId = cloudId;
        return {
            parameters: (0, $QuA6u.default),
            variables: {
                cloudId: cloudId,
                entityAriUserSideNavSettings: (0, $goBB5.JiraWorkspaceAri).create({
                    siteId: cloudId,
                    activationId: activationId
                }).toString(),
                isAppsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_APPS)),
                isFiltersExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $fKh2A.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                navPlatMenuDataEntityAri: (0, $5j3lw.buildNavigationAriForMenuData)({
                    activationId: activationId,
                    firstPartyApp: 'jira',
                    siteId: siteId
                }),
                navPlatSidebarDataEntityAri: (0, $5j3lw.buildNavigationAriForSidebarData)({
                    activationId: activationId,
                    firstPartyApp: 'jira',
                    siteId: siteId
                }),
                ownerAri: atlassianAccountId && (0, $7Cu03.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});

});
parcelRegister("QuA6u", function(module, exports) {
$parcel$export(module.exports, "default", () => $765bd4a1f1362765$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57e1632b3812c8d39270032f01851e9d>>
 * @relayHash c287d50f74eaa1bc324ed883fc50b992
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0ad4f1c57fdb45b512c8a9f04e15dd64287d9fc05258fda5b73a81f4e9bc36d

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $5moL7 = parcelRequire("5moL7");

var $hJ0S2 = parcelRequire("hJ0S2");

var $lhtKZ = parcelRequire("lhtKZ");

var $jhhgp = parcelRequire("jhhgp");

var $eSxxM = parcelRequire("eSxxM");

var $eEnEt = parcelRequire("eEnEt");
const $765bd4a1f1362765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriUserSideNavSettings"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navPlatMenuDataEntityAri"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navPlatSidebarDataEntityAri"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v12 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "navPlatMenuDataEntityAri"
        },
        v12 /*: any*/ 
    ], v14 = [
        {
            "kind": "FragmentSpread",
            "name": "useNavSettingsService"
        }
    ], v15 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "navPlatSidebarDataEntityAri"
        },
        v12 /*: any*/ 
    ], v16 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "menuId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        },
        v16 /*: any*/ ,
        v17 /*: any*/ 
    ], v19 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v20 = [
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "label"
    }, v23 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v24 = {
        "kind": "ScalarField",
        "name": "url"
    }, v25 = {
        "order": "DESC"
    }, v26 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v27 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "name"
    }, v30 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v31 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            v17 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v34 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v35 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v36 = [
        v17 /*: any*/ ,
        v29 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ], v37 = [
        v24 /*: any*/ 
    ], v38 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v21 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v17 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v30 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v37 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v33 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v33 /*: any*/ 
            ]
        }
    ], v39 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v40 = {
        "kind": "ScalarField",
        "name": "status"
    }, v41 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v42 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v44 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v37 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v33 /*: any*/ 
        ]
    }, v45 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v46 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v47 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v48 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v49 = [
        v17 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v41 /*: any*/ ,
        v42 /*: any*/ ,
        v29 /*: any*/ ,
        v43 /*: any*/ ,
        v30 /*: any*/ ,
        v44 /*: any*/ ,
        v45 /*: any*/ ,
        v46 /*: any*/ ,
        v47 /*: any*/ ,
        v48 /*: any*/ 
    ], v50 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v49 /*: any*/ 
            }
        ]
    }, v51 = [
        v50 /*: any*/ ,
        v34 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GSNForContentSidebarQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useNetworkSideNavUserData"
                },
                {
                    "alias": "navPlatL1MenuData",
                    "args": v13 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "navPlatSidebarData",
                    "args": v15 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Apps"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Filters"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Operations"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Overviews"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Plans"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Projects"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "GSNForContentSidebarQuery",
            "selections": [
                {
                    "alias": "userSideNavSettings",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriUserSideNavSettings"
                        },
                        v12 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v18 /*: any*/ 
                },
                {
                    "alias": "navPlatL1MenuData",
                    "args": v13 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v18 /*: any*/ 
                },
                {
                    "alias": "navPlatSidebarData",
                    "args": v15 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v18 /*: any*/ 
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v23 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v22 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v23 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v24 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsFiltersExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v20 /*: any*/ ,
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsProjectsExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v19 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsPlansExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v20 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v25 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v26 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v33 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v34 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v19 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v29 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v32 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v33 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v34 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v36 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v36 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOverviewsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverview",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v25 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v26 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v38 /*: any*/ 
                                        },
                                        v34 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v19 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v38 /*: any*/ 
                                        },
                                        v34 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteProjects",
                                            "args": [
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v25 /*: any*/ ,
                                                        "type": "PROJECT"
                                                    }
                                                },
                                                v26 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v49 /*: any*/ ,
                                                                    "type": "JiraProject"
                                                                },
                                                                v33 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v34 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v19 /*: any*/ ,
                                                v35 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recentProjects",
                                            "plural": false,
                                            "selections": v51 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "entityAri",
                                                    "variableName": "entityAriProjects"
                                                },
                                                v12 /*: any*/ 
                                            ],
                                            "concreteType": "SettingsNavigationCustomisation",
                                            "kind": "LinkedField",
                                            "name": "settings_navigationCustomisation",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecent",
                                            "plural": false,
                                            "selections": v49 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecentFromHistory",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v46 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v48 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v26 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v34 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v35 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": v51 /*: any*/ ,
                                            "storageKey": "recents(first:20)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasMore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "favouriteLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "recentLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayMode"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e0ad4f1c57fdb45b512c8a9f04e15dd64287d9fc05258fda5b73a81f4e9bc36d",
            "metadata": {},
            "name": "GSNForContentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider": (0, $hJ0S2.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default)
            }
        }
    };
}();
$765bd4a1f1362765$var$node.hash = "105ccc68c10e80789d437d04e78517f3";
var $765bd4a1f1362765$export$2e2bcd8739ae039 = $765bd4a1f1362765$var$node;

});

parcelRegister("5j3lw", function(module, exports) {
$parcel$export(module.exports, "buildNavigationAriForMenuData", () => $ba979e1b7006fb60$export$edcad403b9bac010);
$parcel$export(module.exports, "buildNavigationAriForSidebarData", () => $ba979e1b7006fb60$export$370c1cceae722446);

var $4u43Z = parcelRequire("4u43Z");
const $ba979e1b7006fb60$var$MENU_DATA_KEY = 'nav-plat-l1-menu-data';
const $ba979e1b7006fb60$var$SIDE_BAR_DATA_KEY = 'nav-plat-sidebar-data';
function $ba979e1b7006fb60$export$edcad403b9bac010(params) {
    return $ba979e1b7006fb60$var$buildNavigationAri({
        ...params,
        settingId: $ba979e1b7006fb60$var$MENU_DATA_KEY
    });
}
function $ba979e1b7006fb60$export$370c1cceae722446(params) {
    return $ba979e1b7006fb60$var$buildNavigationAri({
        ...params,
        settingId: $ba979e1b7006fb60$var$SIDE_BAR_DATA_KEY
    });
}
function $ba979e1b7006fb60$var$buildNavigationAri(params) {
    return $ba979e1b7006fb60$var$homeOverride((0, $4u43Z.NavigationSettingAri).create($ba979e1b7006fb60$var$adjustParams(params)).toString());
}
// For the time being (Sept 2025), Home will be the only townsquare app that stores network settings.
// The other apps (Goals, Teams &Projects) are in the process of being individually commissioned
// (meaning they will have their own siteId and/or activationId). In the meantime, they will NOT
// be using the settings service, so we don't need an override for them.
function $ba979e1b7006fb60$var$adjustParams(params) {
    if (params.firstPartyApp === 'home') return {
        ...params,
        settingId: `${params.settingId}-${params.firstPartyApp}`
    };
    return params;
}
function $ba979e1b7006fb60$var$homeOverride(ari) {
    return ari.replace('/home/', '/townsquare/');
}

});
parcelRegister("4u43Z", function(module, exports) {
$parcel$export(module.exports, "NavigationSettingAri", () => $343d1da7d47f1bc1$export$d9494d14fa8a72a2);

var $JDXPa = parcelRequire("JDXPa");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/navigation/setting/manifest.ts
var $343d1da7d47f1bc1$var$navigationSettingAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $JDXPa.NavigationSettingAriResourceOwner),
    resourceType: (0, $JDXPa.NavigationSettingAriResourceType),
    resourceIdSlug: "{firstPartyApp}/{siteId}/{activationId}/{settingId}",
    resourceIdSegmentFormats: {
        firstPartyApp: /(assets|confluence|goals|home|jira|mercury|people|studio|teams)/,
        // eslint-disable-line no-useless-escape
        siteId: /[a-zA-Z0-9_\-.]{1,255}/,
        // eslint-disable-line no-useless-escape
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        settingId: /[a-z0-9-]{5,100}/
    }
};
// src/navigation/setting/index.ts
var $343d1da7d47f1bc1$export$d9494d14fa8a72a2 = class _NavigationSettingAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._firstPartyApp = opts.resourceIdSegmentValues.firstPartyApp, this._siteId = opts.resourceIdSegmentValues.siteId, this._activationId = opts.resourceIdSegmentValues.activationId, this._settingId = opts.resourceIdSegmentValues.settingId;
    }
    get firstPartyApp() {
        return this._firstPartyApp;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get settingId() {
        return this._settingId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $343d1da7d47f1bc1$var$navigationSettingAriStaticOpts.qualifier,
            platformQualifier: $343d1da7d47f1bc1$var$navigationSettingAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $343d1da7d47f1bc1$var$navigationSettingAriStaticOpts.resourceOwner,
            resourceType: $343d1da7d47f1bc1$var$navigationSettingAriStaticOpts.resourceType,
            resourceId: `${opts.firstPartyApp}/${opts.siteId}/${opts.activationId}/${opts.settingId}`,
            resourceIdSegmentValues: {
                firstPartyApp: opts.firstPartyApp,
                siteId: opts.siteId,
                activationId: opts.activationId,
                settingId: opts.settingId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $343d1da7d47f1bc1$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $343d1da7d47f1bc1$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(opts);
    }
    getVariables() {
        return {
            firstPartyApp: this.firstPartyApp,
            siteId: this.siteId,
            activationId: this.activationId,
            settingId: this.settingId
        };
    }
};

});
parcelRegister("JDXPa", function(module, exports) {
$parcel$export(module.exports, "NavigationSettingAriResourceOwner", () => $0893341556828a4f$export$efad67ea8db3f12e);
$parcel$export(module.exports, "NavigationSettingAriResourceType", () => $0893341556828a4f$export$fd28c74ac3f5b728);
// src/navigation/setting/types.ts
var $0893341556828a4f$export$efad67ea8db3f12e = "navigation", $0893341556828a4f$export$fd28c74ac3f5b728 = "setting";

});




parcelRegister("8J0lu", function(module, exports) {
$parcel$export(module.exports, "topNav4UIStateResource", () => $0edd5604b861f0e1$export$2d81c2e40eea9fba);

var $4cTDP = parcelRequire("4cTDP");

var $9FYIg = parcelRequire("9FYIg");

var $54NUw = parcelRequire("54NUw");
const $0edd5604b861f0e1$var$hasOnlyJSMAndCSMAccess = (appPermissions)=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasSoftwareAccess: hasSoftwareAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = appPermissions;
    return hasServiceDeskAccess && hasCustomerServiceAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess;
};
const $0edd5604b861f0e1$export$2d81c2e40eea9fba = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
    getQuery: ({ match: match, route: route }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId, appPermissions: appPermissions } })=>{
        const issueKey = match.params.issueKey ?? '';
        const projectKey = match.params.projectKey ?? '';
        return {
            parameters: (0, $54NUw.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                atlassianAccountId: atlassianAccountId ?? '',
                isNavStateQuerySkipped: isAnonymous || (0, $4cTDP.fg)('blu-8363-archive-legacy-resource-navigationuistate'),
                issueKey: issueKey ?? '',
                shouldCheckProjectTypeForIssue: route.group === 'issue' && Boolean(issueKey) && $0edd5604b861f0e1$var$hasOnlyJSMAndCSMAccess(appPermissions) && (0, $4cTDP.fg)('team25-eu-jira-logo-updates-csm-jsm'),
                projectKey: projectKey ?? '',
                shouldCheckProjectType: Boolean(projectKey) && $0edd5604b861f0e1$var$hasOnlyJSMAndCSMAccess(appPermissions) && (0, $4cTDP.fg)('team25-eu-jira-logo-updates-csm-jsm')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});

});
parcelRegister("54NUw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d713ab7eb601b870$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<23ef52ec7b99b5384abf9a9ba6492814>>
 * @relayHash 6c680d3ec42f19e13966aee67c8523ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5480932c6541935f702756cf032040f0d3e5ffb40deec865a554e9f96cf86cbd
const $d713ab7eb601b870$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNavStateQuerySkipped"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckProjectType"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckProjectTypeForIssue"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        v11 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AtlassianNavigationNav4Query",
            "selections": [
                {
                    "condition": "isNavStateQuerySkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4Profile"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ProductHomeRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AtlassianNavigationNav4Query",
            "selections": [
                {
                    "condition": "isNavStateQuerySkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "atlassianAccountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "shouldCheckProjectTypeForIssue",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "issueKey"
                                        }
                                    ],
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ 
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldCheckProjectType",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "projectKey"
                                        }
                                    ],
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5480932c6541935f702756cf032040f0d3e5ffb40deec865a554e9f96cf86cbd",
            "metadata": {},
            "name": "AtlassianNavigationNav4Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d713ab7eb601b870$var$node.hash = "186e0df395385882256068db25a15b2e";
var $d713ab7eb601b870$export$2e2bcd8739ae039 = $d713ab7eb601b870$var$node;

});


parcelRegister("SPYRa", function(module, exports) {
$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $fdcc63ef33fd0b8d$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $fdcc63ef33fd0b8d$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $fdcc63ef33fd0b8d$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $fdcc63ef33fd0b8d$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $fdcc63ef33fd0b8d$export$54805a2120a31ad0);

var $eSnSE = parcelRequire("eSnSE");

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $fdcc63ef33fd0b8d$export$fa475a9581133779 = (0, $l1VxS.createResource)({
    type: (0, $19cf35753fa41a8f$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $hgi0g.default)('/rest/jpo/1.0/navigation/simple');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $19cf35753fa41a8f$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity,
    isCritical: true
});
const $fdcc63ef33fd0b8d$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $fdcc63ef33fd0b8d$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $fdcc63ef33fd0b8d$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $fdcc63ef33fd0b8d$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
const $19cf35753fa41a8f$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $19cf35753fa41a8f$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("9CgFv", function(module, exports) {
$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $8298e40e8fde4c1d$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $9ppkU = parcelRequire("9ppkU");

var $dI30d = parcelRequire("dI30d");


var $l1VxS = parcelRequire("l1VxS");

const $8298e40e8fde4c1d$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $9ppkU.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
// eslint-disable-next-line jira/router/no-daisy-chaining-resources
const $8298e40e8fde4c1d$var$resource = (0, $l1VxS.createResource)({
    type: (0, $f417dca27ced17c4$export$5879151f0d972f18),
    getKey: ()=>'check-api-key-management-keys',
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734]?.promise;
        const isTransitioning = (0, $dI30d.checkIsTransitioning)(tenantInfo);
        return $8298e40e8fde4c1d$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
    },
    maxAge: Infinity,
    isBrowserOnly: true,
    depends: [
        (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
    ],
    isCritical: true
});
const $8298e40e8fde4c1d$export$b16eaa5246afc9b6 = ()=>$8298e40e8fde4c1d$var$resource;

});
parcelRegister("9ppkU", function(module, exports) {
$parcel$export(module.exports, "eocFetch", () => $6655053aa9252cd7$export$212b9c60150b5a0a);

var $eGOwo = parcelRequire("eGOwo");

var $fiPhB = parcelRequire("fiPhB");

var $2QO3b = parcelRequire("2QO3b");

var $1boDC = parcelRequire("1boDC");

var $fR4Ty = parcelRequire("fR4Ty");
const $6655053aa9252cd7$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') {
        input = (0, $fR4Ty.withPrefix)(input, init);
        if ((0, $eGOwo.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $fiPhB.getActiveTraceHttpRequestHeaders)(input),
            ...headers
        };
    } else {
        input = {
            ...input,
            url: (0, $fR4Ty.withPrefix)(input.url, init)
        };
        if ((0, $eGOwo.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $fiPhB.getActiveTraceHttpRequestHeaders)(input.url),
            ...headers
        };
    }
    const errorTransformer = init?.errorTransformer ?? (0, $fR4Ty.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $1boDC.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $1boDC.HTTPError)(response);
        const sanitizedUrl = (0, $fR4Ty.sanitizeUrlString)((0, $fR4Ty.getRequestUrl)(input));
        (0, $2QO3b.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $1boDC.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("1boDC", function(module, exports) {
$parcel$export(module.exports, "NetworkError", () => $58266db8ddf521d5$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $58266db8ddf521d5$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $58266db8ddf521d5$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $58266db8ddf521d5$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $58266db8ddf521d5$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $58266db8ddf521d5$export$4f52fcea95c8f97d);

var $h7mJ2 = parcelRequire("h7mJ2");
class $58266db8ddf521d5$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $58266db8ddf521d5$export$aa9d629c530f62a7 extends $58266db8ddf521d5$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $h7mJ2.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $58266db8ddf521d5$export$c30b5b02747d791c extends $58266db8ddf521d5$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $h7mJ2.ERROR_NAMES).StreamedHTTPError;
    }
}
const $58266db8ddf521d5$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $58266db8ddf521d5$export$aa9d629c530f62a7 || [
        (0, $h7mJ2.ERROR_NAMES).HTTPError,
        (0, $h7mJ2.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $58266db8ddf521d5$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $58266db8ddf521d5$export$bae979e68e4dc802 || [
        (0, $h7mJ2.ERROR_NAMES).NetworkError,
        (0, $h7mJ2.ERROR_NAMES).HTTPError,
        (0, $h7mJ2.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $58266db8ddf521d5$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $58266db8ddf521d5$export$c30b5b02747d791c || candidate?.name === (0, $h7mJ2.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("h7mJ2", function(module, exports) {
$parcel$export(module.exports, "ERROR_NAMES", () => $560dfbaa32da471b$export$daceac3b97803ce1);
var $560dfbaa32da471b$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("fR4Ty", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $436864c0a0a0e09b$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $436864c0a0a0e09b$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $436864c0a0a0e09b$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $436864c0a0a0e09b$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $436864c0a0a0e09b$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $436864c0a0a0e09b$export$ceb09b958e605eff);

var $j9wsO = parcelRequire("j9wsO");

var $1boDC = parcelRequire("1boDC");

let $436864c0a0a0e09b$var$metaCloudId;
let $436864c0a0a0e09b$var$isJSMAvailable = true;
function $436864c0a0a0e09b$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $j9wsO.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($436864c0a0a0e09b$var$metaCloudId) return $436864c0a0a0e09b$var$metaCloudId;
    if ($436864c0a0a0e09b$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $436864c0a0a0e09b$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $436864c0a0a0e09b$var$isJSMAvailable = !!$436864c0a0a0e09b$var$metaCloudId;
    }
    return $436864c0a0a0e09b$var$metaCloudId;
}
function $436864c0a0a0e09b$export$5a75f4aeb58ba80f(id) {
    $436864c0a0a0e09b$var$metaCloudId = id;
}
function $436864c0a0a0e09b$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $436864c0a0a0e09b$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $1921e606163d25bf$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $436864c0a0a0e09b$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $436864c0a0a0e09b$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $1boDC.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $436864c0a0a0e09b$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $1boDC.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $1boDC.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $436864c0a0a0e09b$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $1boDC.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $436864c0a0a0e09b$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $1boDC.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $1boDC.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $436864c0a0a0e09b$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $436864c0a0a0e09b$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("j9wsO", function(module, exports) {
$parcel$export(module.exports, "isServer", () => $8da7becb91021908$export$6acf61af03e62db);
const $8da7becb91021908$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $1921e606163d25bf$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("dI30d", function(module, exports) {
$parcel$export(module.exports, "checkShouldUseJSM", () => $18fe81d8bf210fd5$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $18fe81d8bf210fd5$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $18fe81d8bf210fd5$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $18fe81d8bf210fd5$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $18fe81d8bf210fd5$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $18fe81d8bf210fd5$export$cd227238525e8d57);
$parcel$export(module.exports, "checkIsOpsAdmin", () => $18fe81d8bf210fd5$export$66a96ac2f07f6730);

var $htDO2 = parcelRequire("htDO2");

const $18fe81d8bf210fd5$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED;
};
const $18fe81d8bf210fd5$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).TRANSITIONING;
};
const $18fe81d8bf210fd5$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $htDO2.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).CONSOLIDATED;
};
const $18fe81d8bf210fd5$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).TRANSITIONED;
};
const $18fe81d8bf210fd5$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$650f6934db1290c1);
};
const $18fe81d8bf210fd5$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $htDO2.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$a101f3562b5f0742));
};
const $18fe81d8bf210fd5$export$66a96ac2f07f6730 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
};

});
parcelRegister("htDO2", function(module, exports) {
$parcel$export(module.exports, "ConsolidationState", () => $ec93a9f74251e3bc$export$9ef498b0a11fd37d);
const $ec93a9f74251e3bc$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $73b7e0580d88d09b$export$650f6934db1290c1 = 'cohort3';
const $73b7e0580d88d09b$export$a101f3562b5f0742 = 'cohort3.5';


const $f8747ec2695de8a7$export$25ee35b01de9d734 = 'EOC_TENANT';

const $f417dca27ced17c4$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("graie", function(module, exports) {
$parcel$export(module.exports, "consolidationUserStateResource", () => $eafdd622df1b4c6c$export$4b870505c49999ef);

var $9pTd3 = parcelRequire("9pTd3");

var $l1VxS = parcelRequire("l1VxS");

var $6HiIf = parcelRequire("6HiIf");

const $eafdd622df1b4c6c$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $eafdd622df1b4c6c$export$4b870505c49999ef = (0, $l1VxS.createResource)({
    type: $eafdd622df1b4c6c$var$RESOURCE_KEY,
    getKey: ()=>$eafdd622df1b4c6c$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $6HiIf.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity,
    isCritical: true
});

});
parcelRegister("6HiIf", function(module, exports) {
$parcel$export(module.exports, "getOgConsolidationUserState", () => $ee117a4359e29127$export$df7594d56c9ebe57);

var $FppkK = parcelRequire("FppkK");

var $9pTd3 = parcelRequire("9pTd3");

var $14RSn = parcelRequire("14RSn");

var $4I3Mw = parcelRequire("4I3Mw");
const $ee117a4359e29127$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $4I3Mw.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $FppkK.getUserProperty)(accountId, (0, $4I3Mw.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $14RSn.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $14RSn.default) && error.statusCode === 404) return 0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("FppkK", function(module, exports) {
$parcel$export(module.exports, "getUserPropertiesUrl", () => $0d0742b19f86216d$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $0d0742b19f86216d$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $0d0742b19f86216d$export$b3126db2ef6e34ed);

var $14RSn = parcelRequire("14RSn");

var $jV28D = parcelRequire("jV28D");

var $gUVFX = parcelRequire("gUVFX");
const $0d0742b19f86216d$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute = (accountId, propertyKey)=>{
    const path = $0d0742b19f86216d$export$f474e53c8191800a(accountId, propertyKey);
    return (0, $gUVFX.getReroutableURL)(path);
};
const $0d0742b19f86216d$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $jV28D.getDefaultOptions)(url),
        method: 'PUT',
        body: data
    });
};
const $0d0742b19f86216d$export$b3126db2ef6e34ed = (accountId, propertyKey)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, (0, $jV28D.getDefaultOptions)(url)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $14RSn.default)(res.status, errResp);
        });
    }).then((data)=>data.value);
};
const $0d0742b19f86216d$export$4c4183b491dea321 = (accountId, propertyKey)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $jV28D.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});
parcelRegister("jV28D", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $c4f42c946b187a6e$export$430a3269e24b912e);

var $kinkG = parcelRequire("kinkG");

var $w06FR = parcelRequire("w06FR");
function $c4f42c946b187a6e$export$430a3269e24b912e(url) {
    let options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ],
            ...false ? {
                // Needed for call to monolith
                'x-ssr-asap-audience': 'jira'
            } : {}
        }
    };
    options = url ? (0, $kinkG.applyObservabilityHeaders)(url, options) : options;
    if (false) options = (0, $w06FR.applySsrFetchConfigOverrideHeaders)(options);
    return options;
}
const $c4f42c946b187a6e$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ],
        ...false ? {
            // Needed for call to monolith
            'x-ssr-asap-audience': 'jira'
        } : {}
    }
};

});


parcelRegister("4I3Mw", function(module, exports) {
$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $afdd30cff85a4099$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $afdd30cff85a4099$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $afdd30cff85a4099$export$23da4710c3a29eae);
const $afdd30cff85a4099$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $afdd30cff85a4099$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $afdd30cff85a4099$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("4VIcO", function(module, exports) {
$parcel$export(module.exports, "getConsolidationStateResource", () => $f31902774f5ce285$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $9ppkU = parcelRequire("9ppkU");

var $4cTDP = parcelRequire("4cTDP");

var $l1VxS = parcelRequire("l1VxS");

var $htDO2 = parcelRequire("htDO2");

const $f31902774f5ce285$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, isAnonymous, appPermissions)=>{
    let url = (0, $4cTDP.fg)('operations-tenant-info-endpoint-update') ? '/internal/v1/users/ops-user-info' : '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false || isAnonymous) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED,
                ...(0, $4cTDP.fg)('operations-tenant-info-endpoint-update') ? {
                    isAdmin: false
                } : {}
            });
        });
        return promise;
    }
    if ((0, $4cTDP.fg)('operations-tenant-info-endpoint-update')) url = `${url}/${atlassianAccountId}`;
    if (false) promise = (0, $9ppkU.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': (0, $4cTDP.fg)('operations-tenant-info-endpoint-update') ? 'og-apps-user-int-api' : 'og-customer-int-api'
        }
    });
    else {
        const clientUrl = (0, $4cTDP.fg)('operations-tenant-info-endpoint-update') ? '/v1/users/ops-user-info' : '/v1/customers/tenant-info';
        promise = (0, $9ppkU.eocFetch)(clientUrl).then(({ data: data })=>data);
    }
    return promise;
};
const $f31902774f5ce285$var$getConsolidationStateResourceFactory = (forceBrowser = false)=>(0, $l1VxS.createResource)({
        type: (0, $f8747ec2695de8a7$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>$f31902774f5ce285$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, isAnonymous, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser,
        isCritical: true
    });
const $f31902774f5ce285$var$consolidationResourceForceBrowser = $f31902774f5ce285$var$getConsolidationStateResourceFactory(true);
const $f31902774f5ce285$var$consolidationResourceDontForceBrowser = $f31902774f5ce285$var$getConsolidationStateResourceFactory(false);
const $f31902774f5ce285$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>{
    /**
	 * This needs to return the same resource instance each time (based on args) or else we end up with many unnecessary re-renders
	 */ return forceBrowser ? $f31902774f5ce285$var$consolidationResourceForceBrowser : $f31902774f5ce285$var$consolidationResourceDontForceBrowser;
};

});

parcelRegister("7JXbP", function(module, exports) {
$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $be15d6a6239426da$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $be15d6a6239426da$export$3870b1ff1b155c73);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $9DB7T = parcelRequire("9DB7T");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $be15d6a6239426da$export$ee94bb1f59b07e35 = (0, $l1VxS.createResource)({
    type: (0, $a6fb1066b3f16ba9$export$6f0555de4f60e84e),
    getKey: ()=>(0, $a6fb1066b3f16ba9$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $9DB7T.userPreferenceAPI).get((0, $a6fb1066b3f16ba9$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $a6fb1066b3f16ba9$export$b8b9d90f9e5bd72b),
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false,
            hasUserDismissedGicOnboarding: false
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $be15d6a6239426da$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $eJrcF.useResource)($be15d6a6239426da$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const currentDismissedGicOnboarding = typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false;
    const dismissReadMore = (0, $eJOHy.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true,
                ...previousData?.hasUserDismissedGicOnboarding ? {
                    hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                } : {
                    hasUserDismissedGicOnboarding: false
                }
            }));
    }, [
        update
    ]);
    const dismissGicOnboarding = (0, $eJOHy.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                ...previousData?.hasUserDismissedReadMore ? {
                    hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                } : {
                    hasUserDismissedReadMore: false
                },
                hasUserDismissedGicOnboarding: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
        dismissReadMore: dismissReadMore,
        dismissGicOnboarding: dismissGicOnboarding,
        loading: loading
    };
};

});
parcelRegister("9DB7T", function(module, exports) {
$parcel$export(module.exports, "userPreferenceAPI", () => $0f97d523fbd91473$export$4f7929ca6b50a436);


var $3ugTQ = parcelRequire("3ugTQ");
const $0f97d523fbd91473$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $0f97d523fbd91473$var$get = async (key)=>{
    try {
        const result = await (0, $3ugTQ.performGetRequest)($0f97d523fbd91473$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $3a153a61cf6b691b$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $0f97d523fbd91473$var$set = (key, value)=>(0, $3ugTQ.performPutRequest)($0f97d523fbd91473$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $0f97d523fbd91473$var$remove = (key)=>(0, $3ugTQ.performDeleteRequest)($0f97d523fbd91473$var$url(key));
const $0f97d523fbd91473$export$4f7929ca6b50a436 = {
    get: $0f97d523fbd91473$var$get,
    set: $0f97d523fbd91473$var$set,
    remove: $0f97d523fbd91473$var$remove
};

});

const $a6fb1066b3f16ba9$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $a6fb1066b3f16ba9$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $a6fb1066b3f16ba9$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $a6fb1066b3f16ba9$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("dRfS0", function(module, exports) {
$parcel$export(module.exports, "gicOptInStatusResources", () => $30cdb61faaf8fbb9$export$14c89b6b6a261524);

var $eSnSE = parcelRequire("eSnSE");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");


const $30cdb61faaf8fbb9$export$14c89b6b6a261524 = (0, $l1VxS.createResource)({
    type: (0, $3fe8c5f6b0b2dbf8$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            if ((0, $4cTDP.fg)('issue-create-stop-using-preference-api')) gicOptInStatus = {
                isEnabled: true
            };
            else gicOptInStatus = await (0, $3ugTQ.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $eSnSE.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
const $3fe8c5f6b0b2dbf8$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("5yVUD", function(module, exports) {
$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $ac40f8141f9f880e$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $ac40f8141f9f880e$export$e21c345b2538e96e);

var $eJOHy = parcelRequire("eJOHy");

var $exWdq = parcelRequire("exWdq");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $k1FO2 = parcelRequire("k1FO2");
const $ac40f8141f9f880e$export$1b6468a6eb7d9b09 = (0, $l1VxS.createResource)({
    type: (0, $k1FO2.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $3ugTQ.performGetRequest)((0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $4cTDP.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $4cTDP.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    },
    isCritical: true
});
const $ac40f8141f9f880e$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $eJrcF.useResource)($ac40f8141f9f880e$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $eJOHy.useState)(()=>{
        if ((0, $4cTDP.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $k1FO2.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eJOHy.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $eJOHy.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $4cTDP.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $3ugTQ.performPutRequest)((0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $4cTDP.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $4cTDP.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("exWdq", function(module, exports) {

var $1X4n0 = parcelRequire("1X4n0");

var $hnizX = parcelRequire("hnizX");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $a9714e29aa3d67ff$var$has(object, path) {
    return object != null && $hnizX(object, path, $1X4n0);
}
module.exports = $a9714e29aa3d67ff$var$has;

});
parcelRegister("1X4n0", function(module, exports) {
/** Used for built-in method references. */ var $16beb0f0df9137a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $16beb0f0df9137a5$var$hasOwnProperty = $16beb0f0df9137a5$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $16beb0f0df9137a5$var$baseHas(object, key) {
    return object != null && $16beb0f0df9137a5$var$hasOwnProperty.call(object, key);
}
module.exports = $16beb0f0df9137a5$var$baseHas;

});


parcelRegister("k1FO2", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $913722475ca36197$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $913722475ca36197$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $913722475ca36197$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $913722475ca36197$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $913722475ca36197$export$9ccdfd91f2512a27);
const $913722475ca36197$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $913722475ca36197$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $913722475ca36197$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $913722475ca36197$export$91880069e7e73b18 = -1;
const $913722475ca36197$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("aYBjl", function(module, exports) {
$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $85b874e0c5483f16$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $85b874e0c5483f16$export$bc11d4816053db5c);

var $eJOHy = parcelRequire("eJOHy");

var $lopBx = parcelRequire("lopBx");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $804bQ = parcelRequire("804bQ");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $85b874e0c5483f16$var$fetchGetIssueTransitionOptInState = async ()=>(0, $3ugTQ.performGetRequest)((0, $873d221d3411e09a$export$466b1c60da56c8ca));
const $85b874e0c5483f16$export$5fbcf4d7a6d9c477 = (0, $l1VxS.createResource)({
    type: (0, $873d221d3411e09a$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $873d221d3411e09a$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $4cTDP.fg)('issue-transition-customisation-for-srb') || (0, $lopBx.isFedRamp)();
        const isModernITSRenderEnabled = (0, $4cTDP.fg)('render-modern-issue-transition') || (0, $lopBx.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $85b874e0c5483f16$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $804bQ.default)()
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $85b874e0c5483f16$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $3ugTQ.performPutRequest)((0, $873d221d3411e09a$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $85b874e0c5483f16$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $eJrcF.useResource)($85b874e0c5483f16$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $eJOHy.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $804bQ.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eJOHy.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $eJOHy.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $85b874e0c5483f16$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $873d221d3411e09a$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $873d221d3411e09a$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $873d221d3411e09a$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $873d221d3411e09a$export$880a78695d76498e = 8;

parcelRegister("804bQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce05f913d0b3b9bd$export$2e2bcd8739ae039);

var $lopBx = parcelRequire("lopBx");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");
const $ce05f913d0b3b9bd$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $4cTDP.fg)('render-modern-issue-transition') || (0, $lopBx.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $4cTDP.fg)('issue-transition-customisation-for-srb') || (0, $lopBx.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    return (0, $cxKOj.expValEquals)('jira_issue_transition_screen_modernisation_toggle', 'value', 'BY_DEFAULT_USER_OPT_OUT') ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $ce05f913d0b3b9bd$export$2e2bcd8739ae039 = $ce05f913d0b3b9bd$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("1gbqq", function(module, exports) {
$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $bc0dbb530def7b92$export$fa191d7d71460a98);

var $aYncF = parcelRequire("aYncF");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");

const $bc0dbb530def7b92$export$fa191d7d71460a98 = (0, $l1VxS.createResource)({
    type: (0, $bb95cd42467ae698$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $3ugTQ.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity,
    isCritical: true
});

});
const $bb95cd42467ae698$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("enHI7", function(module, exports) {
$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $ef90c1839bc063ef$export$44e7ad3c66a3f25f);

var $i2m1e = parcelRequire("i2m1e");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

const $ef90c1839bc063ef$export$44e7ad3c66a3f25f = (0, $l1VxS.createResource)({
    type: (0, $70d26b9165f63401$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, _storeContext)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $i2m1e.fetchSidebarConfig)(scope);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("i2m1e", function(module, exports) {
$parcel$export(module.exports, "fetchSidebarConfig", () => $fab8a685dab84ca5$export$d1d13c4b972a22f1);

var $hgi0g = parcelRequire("hgi0g");
const $fab8a685dab84ca5$export$94e808b2557f52e = (requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `/rest/navigation/${version}/${path}?${queryString}`;
};
const $fab8a685dab84ca5$export$d1d13c4b972a22f1 = async (requestQuery, queryParams)=>{
    const sidebarUrl = $fab8a685dab84ca5$export$94e808b2557f52e(requestQuery, undefined, queryParams);
    return (0, $hgi0g.default)(sidebarUrl);
};

});

const $70d26b9165f63401$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';


parcelRegister("dfh4P", function(module, exports) {
$parcel$export(module.exports, "navigationUiStateResource", () => $51dec11bee852c78$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $LFmXM = parcelRequire("LFmXM");

var $l1VxS = parcelRequire("l1VxS");

var $9uKgD = parcelRequire("9uKgD");

const $51dec11bee852c78$var$getNavigationUiStateMemoized = (0, $LFmXM.default)((atlassianAccountId)=>(0, $9uKgD.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $51dec11bee852c78$export$14c178691841b423 = (0, $l1VxS.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$51dec11bee852c78$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity,
    isCritical: true
});

});
parcelRegister("9uKgD", function(module, exports) {
$parcel$export(module.exports, "getNavigationUiState", () => $c6be53465a9fed60$export$29999268b070c9bd);

var $FppkK = parcelRequire("FppkK");


var $fwMnB = parcelRequire("fwMnB");
const $c6be53465a9fed60$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $fwMnB.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $FppkK.getUserProperty)(accountId, (0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $fwMnB.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $1ebe0101b6fb87b8$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("fwMnB", function(module, exports) {
$parcel$export(module.exports, "queryLocalStorage", () => $04a476f65e66d73c$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $04a476f65e66d73c$export$ec13c725e067146a);

var $12DRg = parcelRequire("12DRg");

var $4cTDP = parcelRequire("4cTDP");

var $eSnSE = parcelRequire("eSnSE");

var $3hRxq = parcelRequire("3hRxq");

const $04a476f65e66d73c$var$localStorageProvider = (0, $3hRxq.createLocalStorageProvider)('', false);
const $04a476f65e66d73c$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
};
const $04a476f65e66d73c$var$queryLocalStorageSync = ()=>{
    const localStorage = $04a476f65e66d73c$export$e7db3fa51c63bc5c();
    const item = (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $04a476f65e66d73c$var$localStorageProvider.get((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8)) : localStorage.getItem((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $1ebe0101b6fb87b8$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $04a476f65e66d73c$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $04a476f65e66d73c$var$queryLocalStorageSync();
        resolve(item);
    });
const $04a476f65e66d73c$export$ec13c725e067146a = (data)=>{
    const localStorage = $04a476f65e66d73c$export$e7db3fa51c63bc5c();
    (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $04a476f65e66d73c$var$localStorageProvider.set((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(data)) : localStorage.setItem((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});



parcelRegister("5zQIb", function(module, exports) {
$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $26da57008bc6c8b7$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $26da57008bc6c8b7$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $26da57008bc6c8b7$export$3b09097f2a423abd);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $26da57008bc6c8b7$export$babbf5bfbc4d268c = (0, $l1VxS.createResource)({
    type: (0, $04dbca965a7f77be$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("fIBi9")),
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $26da57008bc6c8b7$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $26da57008bc6c8b7$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $26da57008bc6c8b7$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $26da57008bc6c8b7$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $eJrcF.useResource)($26da57008bc6c8b7$export$babbf5bfbc4d268c);

});
const $04dbca965a7f77be$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("fIBi9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5oPus").then(()=>parcelRequire('1YfCq'));

});


parcelRegister("cqUpU", function(module, exports) {
$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $ca7e29547f8b9439$export$266a039a005e8314);

var $l1VxS = parcelRequire("l1VxS");


const $ca7e29547f8b9439$export$266a039a005e8314 = (0, $l1VxS.createResource)({
    type: (0, $0f8f8ea7f8143316$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("cM3lr")),
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
const $0f8f8ea7f8143316$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $0f8f8ea7f8143316$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $0f8f8ea7f8143316$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("cM3lr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3nwDR").then(()=>parcelRequire('9RwzH'));

});


parcelRegister("dZRaT", function(module, exports) {
$parcel$export(module.exports, "projectContextResource", () => $4af98aebc4dee24b$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $4af98aebc4dee24b$export$d75816e37af81473);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");


const $4af98aebc4dee24b$var$getDataLoader = ()=>(parcelRequire("85kc1"));
const $4af98aebc4dee24b$export$27ad0d75c619be68 = (0, $l1VxS.createResource)({
    type: (0, $c8eeacd6960f72dc$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>(0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getDataLoader: $4af98aebc4dee24b$var$getDataLoader,
    maxAge: 1800000,
    isCritical: true
});
const $4af98aebc4dee24b$export$d75816e37af81473 = $4af98aebc4dee24b$export$27ad0d75c619be68;

});
const $c8eeacd6960f72dc$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("85kc1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kXuGX").then(()=>parcelRequire('h0bmE'));

});


parcelRegister("2emAF", function(module, exports) {
$parcel$export(module.exports, "fetchSiteTraitsResource", () => $ef9e2dbc0959350e$export$379923e7c903a55d);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");

var $lctcw = parcelRequire("lctcw");


const $ef9e2dbc0959350e$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const response = false ? (await (0, $3ugTQ.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $lctcw.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: (0, $aa00244bb9a84571$export$7f111648ca05f056),
                packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $ef9e2dbc0959350e$export$379923e7c903a55d = (0, $l1VxS.createResource)({
    type: (0, $aa00244bb9a84571$export$6f0555de4f60e84e),
    getKey: ()=>(0, $aa00244bb9a84571$export$7e7d7930e22ba39f),
    getData: $ef9e2dbc0959350e$var$getData,
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
parcelRegister("lctcw", function(module, exports) {
$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $b8fe630b0608ec20$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $b8fe630b0608ec20$export$58982988039b926f);

var $LFmXM = parcelRequire("LFmXM");

var $eLqdN = parcelRequire("eLqdN");

var $hgi0g = parcelRequire("hgi0g");
const $b8fe630b0608ec20$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $b8fe630b0608ec20$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $hgi0g.default)($b8fe630b0608ec20$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $b8fe630b0608ec20$export$671fb03be30194c3 = (0, $LFmXM.default)($b8fe630b0608ec20$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $b8fe630b0608ec20$export$58982988039b926f = ()=>(0, $eLqdN.useService)($b8fe630b0608ec20$export$671fb03be30194c3);

});
parcelRegister("eLqdN", function(module, exports) {
$parcel$export(module.exports, "useService", () => $983dc73dc7a270a4$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $983dc73dc7a270a4$export$c963713a27525aaf);

var $eJOHy = parcelRequire("eJOHy");
const $983dc73dc7a270a4$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eJOHy.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eJOHy.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $983dc73dc7a270a4$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eJOHy.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $983dc73dc7a270a4$export$6de4685a6c88b4e9(request, initialState);
    (0, $eJOHy.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


const $33cafeed9becac72$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

const $aa00244bb9a84571$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $aa00244bb9a84571$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $aa00244bb9a84571$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';


parcelRegister("giQoM", function(module, exports) {
$parcel$export(module.exports, "fetchSiteUserTraitsResource", () => $32b92b3a80abfa4a$export$2d7b0f7f663da130);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");

var $lFovQ = parcelRequire("lFovQ");


const $32b92b3a80abfa4a$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId ?? '';
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? (await (0, $3ugTQ.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: accountId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: (0, $ae356bea880b592a$export$7f111648ca05f056),
                packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $32b92b3a80abfa4a$export$2d7b0f7f663da130 = (0, $l1VxS.createResource)({
    type: (0, $ae356bea880b592a$export$6f0555de4f60e84e),
    getKey: ()=>(0, $ae356bea880b592a$export$7e7d7930e22ba39f),
    getData: $32b92b3a80abfa4a$var$getData,
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
parcelRegister("lFovQ", function(module, exports) {
$parcel$export(module.exports, "fetchSiteUserPersonalization", () => $14b13fbf5780b414$export$8f40704723ec6690);
$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $14b13fbf5780b414$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $14b13fbf5780b414$export$8dc79ff315095801);

var $LFmXM = parcelRequire("LFmXM");

var $eLqdN = parcelRequire("eLqdN");

var $hgi0g = parcelRequire("hgi0g");
const $14b13fbf5780b414$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $14b13fbf5780b414$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $hgi0g.default)($14b13fbf5780b414$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $14b13fbf5780b414$export$de93ec54b11be450 = (0, $LFmXM.default)($14b13fbf5780b414$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $14b13fbf5780b414$export$8dc79ff315095801 = ()=>(0, $eLqdN.useService)($14b13fbf5780b414$export$de93ec54b11be450);

});

const $ae356bea880b592a$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $ae356bea880b592a$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $ae356bea880b592a$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';


parcelRegister("68g4a", function(module, exports) {
$parcel$export(module.exports, "jpdRecommendationDismissedResource", () => $49b8368db856ef30$export$5db7c4562b672f52);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");


const $49b8368db856ef30$export$5db7c4562b672f52 = (0, $l1VxS.createResource)({
    type: (0, $2600fd317e4ea417$export$6f0555de4f60e84e),
    getKey: ()=>(0, $2600fd317e4ea417$export$7e7d7930e22ba39f),
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return {
                hasDismissed: true
            };
            const accountId = tenantContext.atlassianAccountId;
            const response = await (0, $3ugTQ.performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
            return {
                hasDismissed: response?.value ?? false
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, they have never dismissed.
					 */ return {
                hasDismissed: false
            };
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: (0, $2600fd317e4ea417$export$7f111648ca05f056),
                    packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */ return {
            hasDismissed: true
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
const $2600fd317e4ea417$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $2600fd317e4ea417$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $2600fd317e4ea417$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';


parcelRegister("lb6FK", function(module, exports) {
$parcel$export(module.exports, "rovoEntitlementResource", () => $010e266d7d00b5af$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $010e266d7d00b5af$export$b9cee3799212b85a);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $4cTDP = parcelRequire("4cTDP");

const $010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $010e266d7d00b5af$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $a630de669343b4d7$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldShowRovoLLMEnabled: (0, $4cTDP.fg)('rovo_use_rovo_llm_enabled_check')
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        // defaulting to isRovoEnabled if the feature flag is not enabled
        const isRovoLLMEnabled = (0, $4cTDP.fg)('rovo_use_rovo_llm_enabled_check') ? response.data?.jira_isRovoLLMEnabled ?? null : isRovoEnabled;
        return {
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined
    };
};
const $010e266d7d00b5af$export$a0974cf24d16bc5d = (0, $l1VxS.createResource)({
    type: $010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$010e266d7d00b5af$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity,
    isCritical: true
});
const $010e266d7d00b5af$export$b9cee3799212b85a = ()=>(0, $eJrcF.useResource)($010e266d7d00b5af$export$a0974cf24d16bc5d);

});
const $a630de669343b4d7$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;


parcelRegister("cxQGT", function(module, exports) {
$parcel$export(module.exports, "themePreferenceResource", () => $5f480f6098caae1f$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $5f480f6098caae1f$export$3416635c8aeb5bab);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $fwRwb = parcelRequire("fwRwb");

var $fWIQB = parcelRequire("fWIQB");

var $5nksj = parcelRequire("5nksj");

const $5f480f6098caae1f$var$getDataLoader = ()=>(parcelRequire("utF9E"));
const $5f480f6098caae1f$export$e5a423d1eb1cf1d0 = (0, $l1VxS.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $5f480f6098caae1f$var$getDataLoader,
    maxAge: 300000,
    isCritical: true
});
// TODO (DST): Should be deleted along with shared-user-preferences cleanup
/**
 * Original implementation of useThemePreference (pre shared-user-preferences feature)
 */ const $5f480f6098caae1f$var$useThemePreferenceOld = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $eJrcF.useResource)($5f480f6098caae1f$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $eJOHy.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $fwRwb.THEME_PREFERENCES_ANALYTICS_ACTION),
            actionSubject: (0, $fwRwb.THEME_PREFERENCES_ANALYTICS_SUBJECT)
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eJOHy.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $fWIQB.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};
const $5f480f6098caae1f$export$3416635c8aeb5bab = ()=>{
    // See https://hello.atlassian.net/wiki/spaces/JFP/pages/5033916021/Jira+Playbook+How+can+I+feature+gate+that#From-a-hook for conditional hooks
    return (0, $4cTDP.fg)('shared-user-preferences') ? (0, $5nksj.useThemePreference)($5f480f6098caae1f$export$e5a423d1eb1cf1d0) : $5f480f6098caae1f$var$useThemePreferenceOld();
};

});
parcelRegister("fwRwb", function(module, exports) {
$parcel$export(module.exports, "THEME_PREFERENCE_KEY", () => $256811ed117b45d8$export$40bd77e1c9f49c27);
$parcel$export(module.exports, "THEME_PREFERENCES_ANALYTICS_SUBJECT", () => $256811ed117b45d8$export$9e2cc65718a61846);
$parcel$export(module.exports, "THEME_PREFERENCES_ANALYTICS_ACTION", () => $256811ed117b45d8$export$89c5cf64ad15c3ea);
$parcel$export(module.exports, "themeColorModes", () => $256811ed117b45d8$export$83993de8eb66733);
$parcel$export(module.exports, "DEFAULT_COLOR_MODE", () => $256811ed117b45d8$export$854b45b62d1eb6d4);
const $256811ed117b45d8$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $256811ed117b45d8$export$9e2cc65718a61846 = 'themePreference';
const $256811ed117b45d8$export$89c5cf64ad15c3ea = 'changed';
const $256811ed117b45d8$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $256811ed117b45d8$export$854b45b62d1eb6d4 = 'auto';

});

parcelRegister("fWIQB", function(module, exports) {
$parcel$export(module.exports, "setThemePreference", () => $43e3efe56f96aef4$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $43e3efe56f96aef4$export$2f7a12048d96237);

var $9pTd3 = parcelRequire("9pTd3");

var $9DB7T = parcelRequire("9DB7T");

var $lzW9r = parcelRequire("lzW9r");

var $fwRwb = parcelRequire("fwRwb");
const $43e3efe56f96aef4$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $9DB7T.userPreferenceAPI).set((0, $fwRwb.THEME_PREFERENCE_KEY), theme);
    promise.catch((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $43e3efe56f96aef4$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $9DB7T.userPreferenceAPI).get((0, $fwRwb.THEME_PREFERENCE_KEY));
    promise.catch((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $lzW9r.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $lzW9r.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("lzW9r", function(module, exports) {
$parcel$export(module.exports, "ThemeOptions", () => $b42648c3d8d982a4$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $b42648c3d8d982a4$export$2faeed762aac6741);
// This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $b42648c3d8d982a4$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $b42648c3d8d982a4$export$2faeed762aac6741 = 'light';

});


parcelRegister("5nksj", function(module, exports) {
$parcel$export(module.exports, "useThemePreference", () => $fbca806fbb8d42c9$export$3416635c8aeb5bab);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $eJrcF = parcelRequire("eJrcF");

var $cHtIB = parcelRequire("cHtIB");

var $f2sjT = parcelRequire("f2sjT");

var $e6YEs = parcelRequire("e6YEs");

var $fwRwb = parcelRequire("fwRwb");

var $a75Xi = parcelRequire("a75Xi");
const $fbca806fbb8d42c9$export$3416635c8aeb5bab = (themePreferenceResource)=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $eJrcF.useResource)(themePreferenceResource);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Get tenant context using hooks
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const fireThemeAnalytics = (0, $eJOHy.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $fwRwb.THEME_PREFERENCES_ANALYTICS_ACTION),
            actionSubject: (0, $fwRwb.THEME_PREFERENCES_ANALYTICS_SUBJECT)
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eJOHy.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $a75Xi.setThemePreference)(theme, cloudId, activationId, accountId);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics,
        cloudId,
        activationId,
        accountId
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
parcelRegister("cHtIB", function(module, exports) {
$parcel$export(module.exports, "useCloudId", () => $30aaab688e5ffd84$export$9da0f7c65f28ed16);

var $koAZ4 = parcelRequire("koAZ4");
const $30aaab688e5ffd84$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("f2sjT", function(module, exports) {
$parcel$export(module.exports, "useActivationId", () => $4f250974ed08a42d$export$43686faa787c943);

var $koAZ4 = parcelRequire("koAZ4");
const $4f250974ed08a42d$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("e6YEs", function(module, exports) {
$parcel$export(module.exports, "useAccountId", () => $3d669d40c082629a$export$e72033e0f5baa3e);

var $koAZ4 = parcelRequire("koAZ4");
const $3d669d40c082629a$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("a75Xi", function(module, exports) {
$parcel$export(module.exports, "setThemePreference", () => $e094a5fbd794da36$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $e094a5fbd794da36$export$2f7a12048d96237);

var $goBB5 = parcelRequire("goBB5");

var $9pTd3 = parcelRequire("9pTd3");

var $7zZ4w = parcelRequire("7zZ4w");

var $ckJSY = parcelRequire("ckJSY");

var $fwRwb = parcelRequire("fwRwb");
const $e094a5fbd794da36$var$handleThemePreferenceError = (error, operation, additionalAttributes)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const err = error;
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'ThemePreferenceCRUD',
            packageName: 'jiraRouterResourcesThemePreference'
        },
        error: err,
        attributes: {
            op: operation,
            errName: String(err.name),
            statusCode: err.statusCode,
            ...additionalAttributes
        }
    });
};
const $e094a5fbd794da36$export$a6b84eebd33787e2 = async (colorMode, cloudId, activationId, accountId)=>{
    try {
        // Create workspace ARI only when feature flag is enabled
        const workspaceAri = (0, $goBB5.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        if (!accountId) // Shared theming is supported for logged in users only
        return;
        // Use platform package for GraphQL operations
        await (0, $ckJSY.updateWorkspaceThemePreference)((0, $7zZ4w.default)(), workspaceAri, accountId, {
            colorMode: colorMode
        });
    } catch (error) {
        $e094a5fbd794da36$var$handleThemePreferenceError(error, 'put', {
            param: `to:${colorMode}`
        });
        throw error;
    }
};
const $e094a5fbd794da36$export$2f7a12048d96237 = async (cloudId, activationId, accountId)=>{
    if (!cloudId || !activationId || !accountId) // Shared theming is supported for logged in users only. CloudId and ActicationId should be always present but are left nullable to simplify the caller function
    return 0, $fwRwb.DEFAULT_COLOR_MODE;
    try {
        let colorMode;
        // Create workspace ARI only when feature flag is enabled
        const workspaceAri = (0, $goBB5.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        // Use platform package for GraphQL operations
        const themeState = await (0, $ckJSY.getWorkspaceThemePreference)((0, $7zZ4w.default)(), workspaceAri, accountId);
        colorMode = themeState?.colorMode;
        // Validate theme value
        if (colorMode && !(0, $fwRwb.themeColorModes).includes(colorMode)) {
            // very unlikely but…
            $e094a5fbd794da36$var$handleThemePreferenceError(new Error('Unrecognized theme!'), 'get', {
                theme: colorMode,
                errName: 'unrecognized value!'
            });
            colorMode = (0, $fwRwb.DEFAULT_COLOR_MODE);
        }
        return colorMode ?? (0, $fwRwb.DEFAULT_COLOR_MODE);
    } catch (error) {
        $e094a5fbd794da36$var$handleThemePreferenceError(error, 'get');
        throw error;
    }
};

});


parcelRegister("utF9E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("62I9B")
]).then(()=>parcelRequire('fgD68'));

});


parcelRegister("aUy7d", function(module, exports) {
$parcel$export(module.exports, "userHomepageResource", () => $087598b26d31627a$export$16320dd0d1e6c145);

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");

const $087598b26d31627a$export$16320dd0d1e6c145 = (0, $l1VxS.createResource)({
    type: (0, $3eb5263dc85dae9a$export$2026a6db44b15de7),
    getKey: ()=>'state',
    getData: async (_dataContext, _storeContext)=>{
        const { homepagePreference: homepagePreference } = await (0, $3ugTQ.performGetRequest)('/rest/internal/3/homepage/');
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity,
    isCritical: true
});

});
const $3eb5263dc85dae9a$export$2026a6db44b15de7 = 'USER_HOMEPAGE';


parcelRegister("5fjzQ", function(module, exports) {
$parcel$export(module.exports, "postOfficeJiraSideNavResource", () => $14f67614a8998d75$export$5fd5ab86e70497f7);
$parcel$export(module.exports, "postOfficeJiraYourWorkResource", () => $14f67614a8998d75$export$5969dfe9b3b29cd3);
$parcel$export(module.exports, "postOfficeJiraTopBannerResource", () => $14f67614a8998d75$export$af242b8c8ffaab42);
$parcel$export(module.exports, "conditionalPostOfficeJiraTopBannerResource", () => $14f67614a8998d75$export$d1df0b3b482d298d);
$parcel$export(module.exports, "postOfficeNav4ProjectsSectionResource", () => $14f67614a8998d75$export$3f8e412b85cb402b);
$parcel$export(module.exports, "postOfficeJiraIssueViewTwcSpotlightTourResource", () => $14f67614a8998d75$export$92fea5c50d332295);
// eslint-disable-next-line jira/import-whitelist

var $2xVkf = parcelRequire("2xVkf");

var $l1VxS = parcelRequire("l1VxS");

var $5L7qx = parcelRequire("5L7qx");

var $4cTDP = parcelRequire("4cTDP");
const $14f67614a8998d75$export$fd097948b42db8d3 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__SCREEN_SPACE_FLAGS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('screen-space-flags', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$5fd5ab86e70497f7 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_SIDE_NAV',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-side-nav', tenantContext);
    },
    maxAge: Infinity,
    isCritical: true
});
const $14f67614a8998d75$export$5969dfe9b3b29cd3 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_YOUR_WORK',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-your-work', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$af242b8c8ffaab42 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_TOP_BANNER',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isSiteAdmin) return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-top-banner', tenantContext);
        return null;
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$d1df0b3b482d298d = (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-term-refresh-banner'), $14f67614a8998d75$export$af242b8c8ffaab42);
const $14f67614a8998d75$export$1d4ef0f14729d528 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_SECTION',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('nav-4-section', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$var$nav4ProjectsSectionEnabledGroup = new Set([
    'classic-business',
    'classic-software',
    'home',
    'issue',
    'issue-navigator',
    'legacy',
    'polaris',
    'servicedesk',
    'software',
    'software-reports-boardless'
]);
const $14f67614a8998d75$export$3f8e412b85cb402b = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_PROJECTS_SECTION',
    getKey: ()=>'state',
    getData: async ({ route: { group: group } }, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous, isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isAnonymous || !isAdmin && !isSiteAdmin) return null;
        if (!group || !$14f67614a8998d75$var$nav4ProjectsSectionEnabledGroup.has(group)) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('nav-4-projects-section', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$var$jiraIssueViewTwcSpotlightTourEnabledGroup = new Set([
    'issue',
    'software'
]);
const $14f67614a8998d75$export$92fea5c50d332295 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_ISSUE_VIEW_TWC_SPOTLIGHT_TOUR',
    getKey: ()=>'state',
    getData: async ({ route: { group: group } }, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        if (!group || !$14f67614a8998d75$var$jiraIssueViewTwcSpotlightTourEnabledGroup.has(group)) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-issue-view-twc-spotlight-tour', tenantContext);
    },
    maxAge: Infinity
});

});
parcelRegister("2xVkf", function(module, exports) {
$parcel$export(module.exports, "usePlacementSSRFetch", () => $172104d4dfe494d0$export$420f2f91a928b3b6);
$parcel$export(module.exports, "usePlacementPreloadedData", () => $172104d4dfe494d0$export$17b92961ead3f211);
$parcel$export(module.exports, "preloadPostOfficePlacementWithTenantContext", () => $172104d4dfe494d0$export$65b5eab182e1ca6f);

var $eJOHy = parcelRequire("eJOHy");

var $3ugTQ = parcelRequire("3ugTQ");

var $i0k0q = parcelRequire("i0k0q");

var $7Zq2F = parcelRequire("7Zq2F");

var $eJrcF = parcelRequire("eJrcF");

var $dCq6B = parcelRequire("dCq6B");
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $172104d4dfe494d0$var$preloadPostOfficePlacement = async (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const jiraFetcherWithS2SHeaders = async (url)=>{
        let hostEnv = 'prod';
        if (environment.currentEnv !== 'production') hostEnv = 'staging';
        const fetchHeaders = {
            'x-ssr-service-name': 'post-office',
            'x-ssr-service-env': hostEnv
        };
        return (0, $3ugTQ.performGetRequest)(url.replace('gateway/api/post-office/', ''), {
            headers: fetchHeaders
        });
    };
    return (0, $7Zq2F.requestInitialData)(placementId, postOfficeContext, false ? jiraFetcherWithS2SHeaders : (0, $3ugTQ.performGetRequest), (0, $i0k0q.buildBasePath)(environment.currentEnv, environment.envConfigs));
};
const $172104d4dfe494d0$export$420f2f91a928b3b6 = (resource)=>{
    const { data: data } = (0, $eJrcF.useResource)(resource);
    return (0, $eJOHy.useCallback)(()=>{
        if (data) {
            /**
			 * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
			 * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
			 */ const init = {
                status: 200,
                statusText: 'ok!'
            };
            return Promise.resolve(new Response(JSON.stringify(data), init));
        }
    }, [
        data
    ]);
};
const $172104d4dfe494d0$export$17b92961ead3f211 = (resource)=>{
    const { data: data, clear: clear } = (0, $eJrcF.useResource)(resource);
    return [
        data,
        clear
    ];
};
const $172104d4dfe494d0$export$65b5eab182e1ca6f = async (placementId, preloadedTenantContext)=>{
    return $172104d4dfe494d0$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $dCq6B.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $dCq6B.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});
parcelRegister("i0k0q", function(module, exports) {
$parcel$export(module.exports, "buildBasePath", () => $7e5543bdcbf94fc0$export$e8b30f9c4a80230f);


var $dWans = parcelRequire("dWans");
const $7e5543bdcbf94fc0$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $dWans.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
var $a3af5d93f7abc0d3$exports = {};
$parcel$export($a3af5d93f7abc0d3$exports, "API_ORIGIN_TEST_SERVER", () => $a3af5d93f7abc0d3$export$5ca004be156a127a);
$parcel$export($a3af5d93f7abc0d3$exports, "API_ORIGIN_LOCAL", () => $a3af5d93f7abc0d3$export$1e9fed4c0197724c);
$parcel$export($a3af5d93f7abc0d3$exports, "API_PATHNAME_LOCAL", () => $a3af5d93f7abc0d3$export$919a9569bce66f17);
$parcel$export($a3af5d93f7abc0d3$exports, "API_PATHNAME_STG_PROD", () => $a3af5d93f7abc0d3$export$d4fe3482c88e73a8);
$parcel$export($a3af5d93f7abc0d3$exports, "REMOTE_MODULE_URI_LOCAL", () => $a3af5d93f7abc0d3$export$67be2569ef5d7666);
$parcel$export($a3af5d93f7abc0d3$exports, "REMOTE_MODULE_URI_STG", () => $a3af5d93f7abc0d3$export$b49738b89db261cd);
$parcel$export($a3af5d93f7abc0d3$exports, "REMOTE_MODULE_URI_PROD", () => $a3af5d93f7abc0d3$export$bbd96cd490b0df63);
const $a3af5d93f7abc0d3$export$5ca004be156a127a = 'http://localhost:4224';
const $a3af5d93f7abc0d3$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $a3af5d93f7abc0d3$export$1e9fed4c0197724c = 'http://localhost:8081';
const $a3af5d93f7abc0d3$export$919a9569bce66f17 = '/api/v1/placements/';
const $a3af5d93f7abc0d3$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $a3af5d93f7abc0d3$export$67be2569ef5d7666 = 'http://localhost:9009';
const $a3af5d93f7abc0d3$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $a3af5d93f7abc0d3$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';

parcelRegister("dWans", function(module, exports) {
$parcel$export(module.exports, "defaultEnvironmentValues", () => $656fe8b089a88f92$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $656fe8b089a88f92$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $656fe8b089a88f92$export$877b97169cc75e8b);

var $eJOHy = parcelRequire("eJOHy");

const $656fe8b089a88f92$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        'test-server': {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $a3af5d93f7abc0d3$export$5ca004be156a127a),
                pathname: (0, $a3af5d93f7abc0d3$export$5ca004be156a127a),
                searchParams: undefined
            }
        },
        test: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $a3af5d93f7abc0d3$export$1e9fed4c0197724c),
                pathname: (0, $a3af5d93f7abc0d3$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $a3af5d93f7abc0d3$export$1e9fed4c0197724c),
                pathname: (0, $a3af5d93f7abc0d3$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $a3af5d93f7abc0d3$export$1e9fed4c0197724c),
                pathname: (0, $a3af5d93f7abc0d3$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        }
    }
};
const $656fe8b089a88f92$export$fceca2c399b32565 = (0, $eJOHy.createContext)($656fe8b089a88f92$export$b4ede87479bfcf09);
const $656fe8b089a88f92$export$604607f913ef367c = $656fe8b089a88f92$export$fceca2c399b32565.Provider;
const $656fe8b089a88f92$export$877b97169cc75e8b = ()=>(0, $eJOHy.useContext)($656fe8b089a88f92$export$fceca2c399b32565);

});


parcelRegister("7Zq2F", function(module, exports) {
$parcel$export(module.exports, "requestInitialData", () => $c75006f6f2b46913$export$c4c39037cc4b06ab);
const $c75006f6f2b46913$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $c75006f6f2b46913$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $c75006f6f2b46913$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("dCq6B", function(module, exports) {
$parcel$export(module.exports, "tenantToPostOfficeContext", () => $509e2223bb06925e$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $509e2223bb06925e$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $509e2223bb06925e$export$cfacfecb20987ff1);

var $goBB5 = parcelRequire("goBB5");
const $509e2223bb06925e$var$JIRA_PRODUCT = 'jira';
const $509e2223bb06925e$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $509e2223bb06925e$var$JIRA_PRODUCT,
    locale: 'en'
};
const $509e2223bb06925e$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $goBB5.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $509e2223bb06925e$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale, isAdmin: isAdmin } = tenantData;
    const workspaceAri = $509e2223bb06925e$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$509e2223bb06925e$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        isAdmin: isAdmin,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined
    };
};
const $509e2223bb06925e$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $509e2223bb06925e$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};

});



parcelRegister("hXbwo", function(module, exports) {
$parcel$export(module.exports, "previewPanelStateResource", () => $9c99d47f78a5b0ec$export$c2ef0c3db4ecdea3);

var $9FYIg = parcelRequire("9FYIg");

var $gOhSQ = parcelRequire("gOhSQ");
const $9c99d47f78a5b0ec$export$c2ef0c3db4ecdea3 = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_PREVIEW_PANEL`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $gOhSQ.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true,
    isBrowserOnly: false
});

});
parcelRegister("gOhSQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $67849424e576d32a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7608bc86a22fc5b75aa29f223aaf4d1>>
 * @relayHash b395f613968319e8a511c65e3f1ee5fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2
const $67849424e576d32a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "concreteType": "JiraPreviewPanelState",
        "kind": "LinkedField",
        "name": "previewPanel",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2",
            "metadata": {},
            "name": "PreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$67849424e576d32a$var$node.hash = "7327e4b44435e860a8ce1fbd4e39a463";
var $67849424e576d32a$export$2e2bcd8739ae039 = $67849424e576d32a$var$node;

});


parcelRegister("5hYi1", function(module, exports) {
$parcel$export(module.exports, "navigationUIStateRelayResource", () => $3dc267bfc9a10930$export$2515472a886db684);

var $9FYIg = parcelRequire("9FYIg");

var $ae7y7 = parcelRequire("ae7y7");
const $3dc267bfc9a10930$export$2515472a886db684 = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_NAVIGATION_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $ae7y7.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("ae7y7", function(module, exports) {
$parcel$export(module.exports, "default", () => $a12316a47ce8ebc0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f7b322dc42572fc98d14e39765dd8959>>
 * @relayHash 9e3346230c503c46c2a78d537efee77c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c398c9897bd6b2ad55090a2587b099104efbe0df4f52d54fc62cbd659e13343
const $a12316a47ce8ebc0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "layoutManagerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "layoutManagerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c398c9897bd6b2ad55090a2587b099104efbe0df4f52d54fc62cbd659e13343",
            "metadata": {},
            "name": "layoutManagerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a12316a47ce8ebc0$var$node.hash = "43f1d006cf9c78cb66e90051d5dab554";
var $a12316a47ce8ebc0$export$2e2bcd8739ae039 = $a12316a47ce8ebc0$var$node;

});


parcelRegister("gyLjG", function(module, exports) {
$parcel$export(module.exports, "getSpaResources", () => $cc78698405665531$export$6a47327ecc341f41);

var $02imk = parcelRequire("02imk");

var $5L7qx = parcelRequire("5L7qx");

var $4cTDP = parcelRequire("4cTDP");

var $iDQeR = parcelRequire("iDQeR");
const $cc78698405665531$export$6a47327ecc341f41 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jpx-463-spa-relay-query'), (0, $02imk.jiraSpaPageContainerResource)),
        ...(0, $iDQeR.getBannerResources)()
    ];

});
parcelRegister("02imk", function(module, exports) {
$parcel$export(module.exports, "jiraSpaPageContainerResource", () => $b39032c02f422ae7$export$880427900755c3d5);

var $9FYIg = parcelRequire("9FYIg");

var $63hLx = parcelRequire("63hLx");
const $b39032c02f422ae7$export$880427900755c3d5 = (0, $9FYIg.createRelayResource)({
    type: 'JIRA_SPA_STATE_RELAY',
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>{
        return {
            parameters: (0, $63hLx.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    captureErrors: true,
    isCritical: true
});

});
parcelRegister("63hLx", function(module, exports) {
$parcel$export(module.exports, "default", () => $df822fee62cfcb81$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<12f5653ce8b90646708ce1a81e11d25d>>
 * @relayHash d0a4e0f0d940268315c42b1298fd995e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4a3192b3c21002961787dd23c9769033e3e25dc56663815f63c810152f5b9b69

var $fd67v = parcelRequire("fd67v");

var $37Ewn = parcelRequire("37Ewn");
const $df822fee62cfcb81$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JiraSpaPageContainerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraSpaPageContainer"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "JiraSpaPageContainerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraAnnouncementBanner",
                                    "kind": "LinkedField",
                                    "name": "announcementBanner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDismissible"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "visibility"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4a3192b3c21002961787dd23c9769033e3e25dc56663815f63c810152f5b9b69",
            "metadata": {},
            "name": "JiraSpaPageContainerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider": (0, $fd67v.default)
            }
        }
    };
}();
$df822fee62cfcb81$var$node.hash = "798e2c45197387a6c034abffdd1ad8e1";
(0, $37Ewn.PreloadableQueryRegistry).set($df822fee62cfcb81$var$node.params.id, $df822fee62cfcb81$var$node);
var $df822fee62cfcb81$export$2e2bcd8739ae039 = $df822fee62cfcb81$var$node;

});
parcelRegister("fd67v", function(module, exports) {
$parcel$export(module.exports, "default", () => $949067ace7bef9d8$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $949067ace7bef9d8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jpx-459-announcement-banner-via-spa-query');
    }
};

});



parcelRegister("iDQeR", function(module, exports) {
$parcel$export(module.exports, "getBannerResources", () => $3aab0c5894a96a2c$export$cc6a6a8372f2ef22);
// eslint-disable-next-line jira/import-whitelist

var $8ecGf = parcelRequire("8ecGf");

var $4cTDP = parcelRequire("4cTDP");

var $5MeEd = parcelRequire("5MeEd");

var $7KVqh = parcelRequire("7KVqh");

var $jhUdU = parcelRequire("jhUdU");

var $5L7qx = parcelRequire("5L7qx");
const $3aab0c5894a96a2c$export$cc6a6a8372f2ef22 = ()=>[
        (0, $5MeEd.getConsentBannerUserPreferencesResource)(),
        (0, $8ecGf.announcementBannerSettingsV4Resource),
        (0, $7KVqh.incomingMailServerExpiryStatusResource),
        // Auto Upgrade Not a Trial Banner Resource
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('auto_upgrade_not_a_trial_jira_gate'), (0, $jhUdU.standardTrialTransactionAccountStatusResource))
    ];

});
parcelRegister("8ecGf", function(module, exports) {
$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $13acc6480a40d4f2$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $13acc6480a40d4f2$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $6eeiA = parcelRequire("6eeiA");

var $1gEh1 = parcelRequire("1gEh1");

var $auTva = parcelRequire("auTva");
const $13acc6480a40d4f2$var$announcementBannerSettingsResource = (0, $l1VxS.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $1gEh1.get)(),
            (0, $auTva.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $13acc6480a40d4f2$export$8fbe7f8de07afffd = (0, $l1VxS.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $6eeiA.get)(),
            (0, $auTva.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000,
    isCritical: true
});
const $13acc6480a40d4f2$export$43d4950a3e443fd3 = ()=>(0, $eJrcF.useResource)($13acc6480a40d4f2$var$announcementBannerSettingsResource);
const $13acc6480a40d4f2$export$6fb72f4a0c177494 = ()=>(0, $eJrcF.useResource)($13acc6480a40d4f2$export$8fbe7f8de07afffd);

});
parcelRegister("6eeiA", function(module, exports) {
$parcel$export(module.exports, "get", () => $e02086c6f9ca5ab3$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e02086c6f9ca5ab3$export$adaa4cf7ef1b65be);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $e02086c6f9ca5ab3$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $3ugTQ.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $e02086c6f9ca5ab3$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $3ugTQ.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $e02086c6f9ca5ab3$export$4eb85e00a747e2c7 = {
    get: $e02086c6f9ca5ab3$export$3988ae62b71be9a3,
    set: $e02086c6f9ca5ab3$export$adaa4cf7ef1b65be
};

});

parcelRegister("1gEh1", function(module, exports) {
$parcel$export(module.exports, "get", () => $25b44d532ae29fae$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $25b44d532ae29fae$export$adaa4cf7ef1b65be);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

const $25b44d532ae29fae$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $3ugTQ.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $9pTd3.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $5b0bf32dacc00dd5$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $25b44d532ae29fae$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $3ugTQ.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $5b0bf32dacc00dd5$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $5b0bf32dacc00dd5$export$b8b9d90f9e5bd72b = '@jira/admin-pages__system-announcement-banner-resources';
const $5b0bf32dacc00dd5$export$5e0c0e8c940630f8 = 'private';
const $5b0bf32dacc00dd5$export$1d5a5b6462188eb3 = 'public';


parcelRegister("auTva", function(module, exports) {
$parcel$export(module.exports, "get", () => $268e6836611f2173$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $268e6836611f2173$export$adaa4cf7ef1b65be);

var $9pTd3 = parcelRequire("9pTd3");

var $FppkK = parcelRequire("FppkK");

const $268e6836611f2173$var$key = 'announcementBannerDismissedLast';
const $268e6836611f2173$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $FppkK.getUserProperty)(accoundId, $268e6836611f2173$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $9pTd3.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $5b0bf32dacc00dd5$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $268e6836611f2173$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $FppkK.setUserProperties)(accoundId, $268e6836611f2173$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $5b0bf32dacc00dd5$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $268e6836611f2173$export$acb5b4af626ec776 = {
    get: $268e6836611f2173$export$3988ae62b71be9a3,
    set: $268e6836611f2173$export$adaa4cf7ef1b65be
};

});


parcelRegister("5MeEd", function(module, exports) {
$parcel$export(module.exports, "getConsentBannerUserPreferencesResource", () => $1f6c6844ab578de1$export$a40d52e504d1db7c);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $1f6c6844ab578de1$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $2hz3A = parcelRequire("2hz3A");

var $9YRcI = parcelRequire("9YRcI");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $4cTDP = parcelRequire("4cTDP");

var $aYncF = parcelRequire("aYncF");

const $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceOld = (0, $l1VxS.createResource)({
    type: (0, $e5cddec8694808c6$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $e5cddec8694808c6$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
        };
        const data = await (0, $3ugTQ.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceNew = (0, $l1VxS.createResource)({
    type: (0, $e5cddec8694808c6$export$f0cdd7d2fbfd00ff),
    getKey: ()=>(0, $e5cddec8694808c6$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_COOKIE_KEY), true);
        const fallbackConsentToken = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), true);
        const shouldShowBannerBit = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), true);
        const shouldShowBanner = shouldShowBannerBit !== undefined && shouldShowBannerBit !== null ? !!Number(shouldShowBannerBit) : undefined;
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            shouldShowBanner: shouldShowBanner
        };
        /**
			 * On server we need to request the api using a server to server api (atl-preferences-center-elb)
			 * otherwise the request will not be authenticated correctly.
			 *
			 * However Pillar does not support ASAP, so we need to use the client side api call in local development.
			 *
			 * See https://atlassian.slack.com/archives/C017Y3EPAQ4/p1754626460768439?thread_ts=1754601759.549879&cid=C017Y3EPAQ4
			 */ const isPillarLocalDevelopment = globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT ?? false;
        if (false && !isPillarLocalDevelopment) {
            const hostEnv = (0, $aYncF.getEnvironment)() === 'prod' ? 'prod' : 'staging';
            const userId = (0, $aYncF.getAtlassianAccountId)();
            if (userId) {
                const data = await (0, $3ugTQ.performGetRequest)(`https://atl-preferences-center-elb.${hostEnv}.atl-paas.net/rest/user/${userId}/consents/cookies`, {
                    credentials: 'include',
                    headers: {
                        'x-ssr-service-name': 'atl-preferences-center'
                    }
                });
                return data;
            }
        }
        const data = await (0, $3ugTQ.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: false,
    isCritical: true
});
const $1f6c6844ab578de1$export$a40d52e504d1db7c = ()=>{
    if ((0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) return $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceNew;
    return $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceOld;
};
const $1f6c6844ab578de1$export$5bc7e83e85567fb4 = ()=>(0, $eJrcF.useResource)($1f6c6844ab578de1$export$a40d52e504d1db7c());

});
parcelRegister("9YRcI", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $cab6b0210ca24ec3$export$4be65e66cfa2648a);

var $2p0jb = parcelRequire("2p0jb");

var $8BLAC = parcelRequire("8BLAC");
function $cab6b0210ca24ec3$export$4be65e66cfa2648a(key, ssr) {
    if (false) {
        if (ssr) {
            if ((0, $8BLAC.getSsrStatus)() === 'static') return key ? (0, $2p0jb.getCookie)(key) : undefined;
            // Defined here jira/src/entry-fs/utils/single-spa-route.tsx
            return globalThis?.__GET_COOKIE__?.(key);
        }
        return;
    }
    return key ? (0, $2p0jb.getCookie)(key) : (0, $2p0jb.getCookie)();
}

});
parcelRegister("8BLAC", function(module, exports) {
$parcel$export(module.exports, "getSsrStatus", () => $2b872c5ae5257b7a$export$1de0a071a0f828c6);

var $8fF9y = parcelRequire("8fF9y");

var $etwlG = parcelRequire("etwlG");
function $2b872c5ae5257b7a$export$1de0a071a0f828c6() {
    if (false) {
        if ((0, $8fF9y.getIsModernSsr)()) {
            if ((0, $etwlG.getStaticFallbackContext)()) return 'static';
            return 'modern';
        }
        return 'legacy';
    }
    return 'client';
}

});
parcelRegister("8fF9y", function(module, exports) {
$parcel$export(module.exports, "getIsModernSsr", () => $f1b33be3919218dd$export$6c0348fe79672e74);

function $f1b33be3919218dd$export$6c0348fe79672e74() {
    return 0, $9790b8dfe6f31c81$export$19d68f5aa485d903;
}

});

parcelRegister("etwlG", function(module, exports) {
$parcel$export(module.exports, "getStaticFallbackContext", () => $14ea22ea9a1106f2$export$7b4f4d9a4cd11663);
let $14ea22ea9a1106f2$var$isInStaticFallbackContext = false;
function $14ea22ea9a1106f2$export$1734e2025f0c9ae5(value) {
    $14ea22ea9a1106f2$var$isInStaticFallbackContext = value;
}
function $14ea22ea9a1106f2$export$7b4f4d9a4cd11663() {
    return $14ea22ea9a1106f2$var$isInStaticFallbackContext;
}

});



const $e5cddec8694808c6$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $e5cddec8694808c6$export$f0cdd7d2fbfd00ff = 'CONSENT_BANNER_USER_PREFERENCES_SSR';
const $e5cddec8694808c6$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("7KVqh", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $9ec642d55d80db11$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $9ec642d55d80db11$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $9ec642d55d80db11$export$283aa034b7d4e2a0);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $9ec642d55d80db11$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $3ugTQ.performGetRequest)((0, $8e8a9e94fa1c2865$export$5bf8eb915287f5f4));
const $9ec642d55d80db11$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $9ec642d55d80db11$export$369caf52ed1ad2b1 = (0, $l1VxS.createResource)({
    type: (0, $8e8a9e94fa1c2865$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $8e8a9e94fa1c2865$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $9ec642d55d80db11$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'thor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $9ec642d55d80db11$export$32d9db53927095d3
        };
    },
    maxAge: 3600000,
    isCritical: true
});
const $9ec642d55d80db11$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $eJrcF.useResource)($9ec642d55d80db11$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $eJOHy.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $9ec642d55d80db11$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $8e8a9e94fa1c2865$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $8e8a9e94fa1c2865$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $8e8a9e94fa1c2865$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("jhUdU", function(module, exports) {
$parcel$export(module.exports, "standardTrialTransactionAccountStatusResource", () => $01a10cc6f7b3d435$export$91ec92ab36308d88);

var $l1VxS = parcelRequire("l1VxS");

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $9pTd3 = parcelRequire("9pTd3");

var $aYncF = parcelRequire("aYncF");

var $elGl0 = parcelRequire("elGl0");
const $01a10cc6f7b3d435$export$80fa9a9916d3017 = 'TRANSACTION_ACCOUNT_STATUS_RESOURCE';
const $01a10cc6f7b3d435$export$7e7d7930e22ba39f = 'transactionAccountStatusResource';
const $01a10cc6f7b3d435$var$FETCH_TIMEOUT_MS = 500; // 500ms test attempted fetch timeout
const $01a10cc6f7b3d435$var$fetchTransactionAccountStatus = (transactionAccountId)=>{
    if (false) {
        const hostEnv = (0, $aYncF.getEnvironment)() === 'prod' ? 'prod' : 'staging';
        return (0, $3ugTQ.performGetRequest)(`https://ccp-api-gateway.${hostEnv}.atl-paas.net/api/v1/status`, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'X-transaction-account': transactionAccountId,
                'x-ssr-service-name': 'ccp-api-gateway-v2'
            }
        });
    }
    return (0, $3ugTQ.performGetRequest)('/gateway/api/ccp/api/v1/status', {
        headers: {
            'Content-Type': 'application/json',
            'X-transaction-account': transactionAccountId
        }
    });
};
const $01a10cc6f7b3d435$export$366c21e0c3a113c6 = async (transactionAccountIds)=>{
    try {
        let transactionAccountStatusTimeoutId;
        const timeoutPromise = new Promise((_resolve, reject)=>{
            transactionAccountStatusTimeoutId = setTimeout(()=>reject(new Error(`getAllTransactionAccountStatuses failed to complete within the ${$01a10cc6f7b3d435$var$FETCH_TIMEOUT_MS}ms timeout`)), $01a10cc6f7b3d435$var$FETCH_TIMEOUT_MS);
        });
        const transactionAccountStatusPromises = transactionAccountIds.map($01a10cc6f7b3d435$var$fetchTransactionAccountStatus);
        const transactionAccountStatusArray = await Promise.race([
            Promise.all(transactionAccountStatusPromises).finally(()=>{
                if (transactionAccountStatusTimeoutId) clearTimeout(transactionAccountStatusTimeoutId);
            }),
            timeoutPromise
        ]);
        return transactionAccountStatusArray;
    } catch (err) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getAllTransactionAccountStatuses',
                packageName: 'jiraRouterResourcesTransactionAccountStatus',
                teamName: 'growth-luna'
            },
            error: err instanceof Error ? err : undefined,
            sendToPrivacyUnsafeSplunk: true
        });
        return [];
    }
};
const $01a10cc6f7b3d435$export$91ec92ab36308d88 = (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('auto_upgrade_not_a_trial_jira_gate'), (0, $l1VxS.createResource)({
    type: $01a10cc6f7b3d435$export$80fa9a9916d3017,
    getKey: ()=>$01a10cc6f7b3d435$export$7e7d7930e22ba39f,
    getData: async (_, { tenantContext: tenantContext })=>{
        // using util to get standard trial transaction account ids
        // it limits the util of the resource but separates logic
        const transactionAccountIds = (0, $elGl0.getStandardTrialTransactionIds)(tenantContext);
        const transactionAccountStatusArray = await $01a10cc6f7b3d435$export$366c21e0c3a113c6(transactionAccountIds);
        return {
            transactionAccountDetails: transactionAccountStatusArray
        };
    },
    isBrowserOnly: false
}));

});
parcelRegister("elGl0", function(module, exports) {
$parcel$export(module.exports, "getStandardTrialTransactionIds", () => $bf6052f941e02d9a$export$60b5590349ad9055);

var $cblKs = parcelRequire("cblKs");

var $5BCaC = parcelRequire("5BCaC");
const $bf6052f941e02d9a$export$60b5590349ad9055 = (tenantContext)=>{
    const cloudId = tenantContext.cloudId;
    const appEditions = tenantContext?.appEditions;
    const allEntitlementDetails = tenantContext?.productEntitlementDetails;
    if (!cloudId || !allEntitlementDetails) return [];
    const transactionAccountIds = Object.keys(allEntitlementDetails).filter((productKey)=>{
        const details = allEntitlementDetails[productKey];
        const appEditionKey = (0, $5BCaC.getApplicationKeyFromProduct)(productKey);
        return Boolean(appEditionKey && details.transactionAccountId && details.billingSourceSystem === 'CCP' && appEditions[appEditionKey] === (0, $cblKs.STANDARD_EDITION) && Date.now() < Math.max(details.trialEndTime || 0, details.firstPredunningEndTime || 0));
    }).map((productKey)=>allEntitlementDetails[productKey].transactionAccountId).filter(Boolean);
    const uniqueTransactionAccountIds = Array.from(new Set(transactionAccountIds));
    return uniqueTransactionAccountIds;
};

});
parcelRegister("5BCaC", function(module, exports) {
$parcel$export(module.exports, "getApplicationKeyFromProduct", () => $81e11926dc46c636$export$1c8b5351fe114fd4);
const $81e11926dc46c636$export$1c8b5351fe114fd4 = (productKey)=>{
    switch(productKey){
        case 'jira-core':
            return 'core';
        case 'jira-software':
            return 'software';
        case 'jira-servicedesk':
            return 'serviceDesk';
        case 'jira-customer-service':
            return 'customerService';
        case 'jira-product-discovery':
            return 'productDiscovery';
        default:
            return null;
    }
};

});






parcelRegister("fk6FR", function(module, exports) {
$parcel$export(module.exports, "browseIssueEmbedRoute", () => $973922f52e8ea894$export$240aeec71c480594);
const $973922f52e8ea894$export$240aeec71c480594 = {
    name: 'issue-embed',
    path: '/browse/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("ePaI2", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_WORKSPACE_CONTEXT", () => $e09848882139baa5$export$9b3a4d71d46e5ee7);
$parcel$export(module.exports, "workspaceResource", () => $e09848882139baa5$export$2f02c3f971168d17);

var $l1VxS = parcelRequire("l1VxS");

var $jopyG = parcelRequire("jopyG");
const $e09848882139baa5$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $e09848882139baa5$export$2f02c3f971168d17 = (0, $l1VxS.createResource)({
    type: $e09848882139baa5$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $jopyG.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("jopyG", function(module, exports) {
$parcel$export(module.exports, "getUserJsmLicenceState", () => $f9ae8515d7b2e372$export$65bf73aad2afa39);
$parcel$export(module.exports, "isPremiumInstance", () => $f9ae8515d7b2e372$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $f9ae8515d7b2e372$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $f9ae8515d7b2e372$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $u4YbY = parcelRequire("u4YbY");

var $7cSYk = parcelRequire("7cSYk");

var $cblKs = parcelRequire("cblKs");

const $f9ae8515d7b2e372$export$530f260cc76f04ff = ()=>'/rest/servicedesk/cmdb/latest/workspace';
const $f9ae8515d7b2e372$export$65bf73aad2afa39 = (tenantContext)=>{
    const { licensedProducts: licensedProducts, appPermissions: appPermissions } = tenantContext;
    const hasJsmLicence = licensedProducts && licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61];
    const isJsmLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if (!hasJsmLicence) return {
        siteHasJsmInstalled: false
    };
    return {
        siteHasJsmInstalled: true,
        siteIsPremium: $f9ae8515d7b2e372$export$abb609d3bcbb74f6(tenantContext),
        userLicensed: isJsmLicensedUser
    };
};
const $f9ae8515d7b2e372$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $cblKs.PREMIUM_EDITION);
    return isPremium;
};
const $f9ae8515d7b2e372$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $f9ae8515d7b2e372$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $f9ae8515d7b2e372$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? ids[0].id : null;
};
const $f9ae8515d7b2e372$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    if ($f9ae8515d7b2e372$export$d7b4c32773b1c643(tenantContext) === false || !(0, $7cSYk.isCMDBEnabledInEnvironment)()) return null;
    return (0, $u4YbY.performCmdbGetRequest)($f9ae8515d7b2e372$export$530f260cc76f04ff()).then($f9ae8515d7b2e372$var$transformResponse).catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $f9ae8515d7b2e372$export$2e2bcd8739ae039 = $f9ae8515d7b2e372$export$e1d718dfe6dad973;

});
parcelRegister("u4YbY", function(module, exports) {
$parcel$export(module.exports, "performCmdbGetRequest", () => $97885f5e767a49bb$export$a252413f43ec7247);
$parcel$export(module.exports, "performCmdbPostRequest", () => $97885f5e767a49bb$export$d68a9f67166d25a2);
$parcel$export(module.exports, "performCmdbPutRequest", () => $97885f5e767a49bb$export$326b7407f501f98b);
$parcel$export(module.exports, "performCmdbDeleteRequest", () => $97885f5e767a49bb$export$b198eb14f22c12e6);

var $4cTDP = parcelRequire("4cTDP");

var $eBhI6 = parcelRequire("eBhI6");

var $3ugTQ = parcelRequire("3ugTQ");
const $97885f5e767a49bb$export$d5e211a0106aa636 = {
    'X-Request-Source': 'cmdb-frontend'
};
const $97885f5e767a49bb$export$a252413f43ec7247 = (url, options)=>(0, $3ugTQ.performGetRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$d68a9f67166d25a2 = (url, options)=>(0, $3ugTQ.performPostRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$326b7407f501f98b = (url, options)=>(0, $3ugTQ.performPutRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$b198eb14f22c12e6 = (url, options)=>(0, $3ugTQ.performDeleteRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$235b7fc70b9fc359 = (url, options)=>{
    const defaultOptions = (0, $eBhI6.getDefaultOptions)(url);
    return (0, $4cTDP.fg)('fly-2529-cmdb-client-send-request-source-header') ? {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers,
            ...$97885f5e767a49bb$export$d5e211a0106aa636
        }
    } : options;
};

});

parcelRegister("7cSYk", function(module, exports) {
$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $d8faa2e2692e1ff5$export$6dbfb62369f79a64);

var $lopBx = parcelRequire("lopBx");

var $4cTDP = parcelRequire("4cTDP");
const $d8faa2e2692e1ff5$export$6dbfb62369f79a64 = ()=>!(0, $lopBx.isFedRamp)() || (0, $lopBx.isFedRamp)() && (0, $4cTDP.fg)('jsm-assets-fedramp-ui');

});



parcelRegister("5nfTh", function(module, exports) {
$parcel$export(module.exports, "aiContextPanelResource", () => $beffd628552f984a$export$8f6224974184ed8d);
$parcel$export(module.exports, "aiContextPanelResourceWithDependencies", () => $beffd628552f984a$export$70559c909620e4ed);
$parcel$export(module.exports, "getAIContextPanelResources", () => $beffd628552f984a$export$d5bd1af2f373eac4);

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");


var $iYKap = parcelRequire("iYKap");


var $dAIVP = parcelRequire("dAIVP");

var $2MCmQ = parcelRequire("2MCmQ");

var $iVFol = parcelRequire("iVFol");

var $3yIzr = parcelRequire("3yIzr");

var $fEqOu = parcelRequire("fEqOu");
const $beffd628552f984a$var$SUPPORTED_PRACTICES = new Set([
    (0, $61012e06080c144d$export$a364d86306d4a6d4),
    (0, $61012e06080c144d$export$31ffe79c2b019cf)
]);
const $beffd628552f984a$export$8f6224974184ed8d = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$57128ea4767a7885),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { skipChecks: skipChecks, issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (skipChecks !== '1') {
            // The suggestions panel is available only on service-desk.
            // Hence filtering them out to reduce the number of calls to AGG and features APIs
            if (!(0, $iYKap.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $4cTDP.fg)('jsm_issue_view_ai_context')) return null;
            const issueDetails = await (0, $3yIzr.getIssueDetails)(issueKey, cloudId, (0, $4cTDP.fg)('context_panel_state_in_issue_details'));
            const isAIEnabled = issueDetails.isAIEnabled;
            issueId = issueDetails.issueId;
            projectId = issueDetails.projectId;
            practice = issueDetails.practice;
            if (!isAIEnabled || !$beffd628552f984a$var$SUPPORTED_PRACTICES.has(practice)) return null;
            let isAIContextPanelDisabled;
            if ((0, $4cTDP.fg)('context_panel_state_in_issue_details')) isAIContextPanelDisabled = !issueDetails.isAiContextFeatureEnabled;
            else {
                const featureState = await (0, $fEqOu.getFeatureState)(routerDataContext, resourceStoreContext);
                isAIContextPanelDisabled = featureState?.['jsm-ai-context']?.status === (0, $61012e06080c144d$export$8cd212c10b4124d2);
            }
            if (isAIContextPanelDisabled) return null;
        }
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $61012e06080c144d$export$a364d86306d4a6d4)) return (0, $2MCmQ.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $61012e06080c144d$export$31ffe79c2b019cf) && (0, $4cTDP.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $iVFol.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    isBrowserOnly: true
});
const $beffd628552f984a$export$70559c909620e4ed = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$38f892c32d281e99),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResourceWithDependencies-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (!(0, $iYKap.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $4cTDP.fg)('jsm_issue_view_ai_context')) return null;
        let issueDetails = (0, $dAIVP.getDependencyData)(routerDataContext.dependencies, (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd));
        if (issueDetails instanceof Promise) issueDetails = await issueDetails;
        if (!issueDetails) return null;
        const { isAIEnabled: isAIEnabled, isAiContextFeatureEnabled: isAiContextFeatureEnabled } = issueDetails;
        issueId = issueDetails.issueId;
        projectId = issueDetails.projectId;
        practice = issueDetails.practice;
        if (!isAIEnabled || !$beffd628552f984a$var$SUPPORTED_PRACTICES.has(practice) || !isAiContextFeatureEnabled) return null;
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $61012e06080c144d$export$a364d86306d4a6d4)) return (0, $2MCmQ.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $61012e06080c144d$export$31ffe79c2b019cf) && (0, $4cTDP.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $iVFol.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    depends: [
        (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd)
    ],
    isBrowserOnly: true
});
const $beffd628552f984a$export$d5bd1af2f373eac4 = ()=>{
    return (0, $4cTDP.fg)('ssr_issue_details_for_suggestions_panel') ? [
        (0, $3yIzr.contextPanelIssueDetailsResource),
        $beffd628552f984a$export$70559c909620e4ed
    ] : [
        $beffd628552f984a$export$8f6224974184ed8d
    ];
};

});
const $61012e06080c144d$export$b45a36df7873757 = 'alerts';
const $61012e06080c144d$export$a7952c5a5c371ddd = 'oncall';
const $61012e06080c144d$export$de0bca182bc46c7f = 'services';
const $61012e06080c144d$export$ed849d1eb34423e5 = 'similarIssues';
const $61012e06080c144d$export$d4a1ed8524773042 = 'sentiment-analysis';
const $61012e06080c144d$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $61012e06080c144d$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $61012e06080c144d$export$cae2404f62c0f4d7 = 'change-management';
const $61012e06080c144d$export$31ffe79c2b019cf = 'incident-management';
const $61012e06080c144d$export$3a20074cc38cbf69 = 'problem-management';
const $61012e06080c144d$export$a364d86306d4a6d4 = 'service-request';
const $61012e06080c144d$export$71f1a79e03f525 = 'post-incident-review';
const $61012e06080c144d$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $61012e06080c144d$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $61012e06080c144d$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $61012e06080c144d$export$93b42272f76473c9 = 'jsm-views';
const $61012e06080c144d$export$1eb399d8c2d53748 = 'jsm-board';
const $61012e06080c144d$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $61012e06080c144d$export$c270aafb43a2f7bb = 'jsm-list';
const $61012e06080c144d$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $61012e06080c144d$export$34136c6420474672 = 'journey-builder';
const $61012e06080c144d$export$66ede2c1de447f8f = 'developer-escalation';
const $61012e06080c144d$export$1ee9c534405b9b35 = 'playbooks';
const $61012e06080c144d$export$ac0832132e8992d7 = 'automation-discoverability';
const $61012e06080c144d$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $61012e06080c144d$export$e927a5d1b72f0b68 = 'ENABLED';
const $61012e06080c144d$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("iYKap", function(module, exports) {
$parcel$export(module.exports, "checkLicense", () => $53e7d1c0d26ba27f$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $53e7d1c0d26ba27f$export$944be0b3bf2a6feb);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");
const $53e7d1c0d26ba27f$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $53e7d1c0d26ba27f$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$53e7d1c0d26ba27f$var$appPermissionMapper[type]]);
const $53e7d1c0d26ba27f$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $53e7d1c0d26ba27f$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

const $2ba002e1dfb362f8$export$3e1b459cf14e5bcd = 'CONTEXT_PANEL_ISSUE_DETAILS';
const $2ba002e1dfb362f8$export$57128ea4767a7885 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE';
const $2ba002e1dfb362f8$export$38f892c32d281e99 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE-WITH-DEPENDENCIES';

parcelRegister("dAIVP", function(module, exports) {
$parcel$export(module.exports, "getDependencyData", () => $e40c6d169122cf74$export$c1f67084c4ca42af);

var $5j85B = parcelRequire("5j85B");
const $e40c6d169122cf74$export$c1f67084c4ca42af = (dependencies, key)=>{
    if (dependencies[key]?.loading || dependencies[key]?.error) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $5j85B.consumeDependency)(dependencies, key);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dependencies[key]?.data;
};

});
parcelRegister("5j85B", function(module, exports) {
$parcel$export(module.exports, "consumeDependency", () => $9d19e695d8895e78$export$a973ef9e17a326f);
async function $9d19e695d8895e78$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dependencies[key]?.data;
}

});


parcelRegister("2MCmQ", function(module, exports) {
$parcel$export(module.exports, "getServiceSuggestionData", () => $4dfc8fc8b5116538$export$afab700af9f021de);

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $hH1YR = parcelRequire("hH1YR");

var $3oS2M = parcelRequire("3oS2M");
const $4dfc8fc8b5116538$export$d8192485ee52671b = (issueId)=>`/gateway/api/firebolt/1/context-panel/${issueId}`;
const $4dfc8fc8b5116538$export$afab700af9f021de = (issueId, cloudId)=>{
    if ((0, $4cTDP.fg)('context-panel-graphql-migration')) return (0, $3oS2M.getContextPanelSuggestions)(cloudId, issueId);
    const url = $4dfc8fc8b5116538$export$d8192485ee52671b(issueId);
    return (0, $3ugTQ.performGetRequest)(url).then((0, $hH1YR.transformData));
};

});
parcelRegister("hH1YR", function(module, exports) {
$parcel$export(module.exports, "transformContent", () => $e8ab789f25bfc4bf$export$b7cb80c25ebba28e);
$parcel$export(module.exports, "parseAdf", () => $e8ab789f25bfc4bf$export$5659c60045974de9);
$parcel$export(module.exports, "transformData", () => $e8ab789f25bfc4bf$export$3ceb62baab058c6b);
const $e8ab789f25bfc4bf$export$b7cb80c25ebba28e = (content)=>{
    return {
        title: $e8ab789f25bfc4bf$export$5659c60045974de9(content.title),
        description: $e8ab789f25bfc4bf$export$5659c60045974de9(content.description)
    };
};
const $e8ab789f25bfc4bf$export$3ceb62baab058c6b = (data)=>({
        type: 'ServicePanelSuggestions',
        summary: $e8ab789f25bfc4bf$export$5659c60045974de9(data.summary),
        reporterDetails: $e8ab789f25bfc4bf$export$5659c60045974de9(data.reporterDetails),
        nextSteps: $e8ab789f25bfc4bf$export$5659c60045974de9(data.nextSteps),
        suggestedEscalation: $e8ab789f25bfc4bf$export$5659c60045974de9(data.suggestedEscalation),
        suggestedActions: data.suggestedActions ? data.suggestedActions.map((action)=>{
            switch(action.type){
                case 'priority':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
                case 'comment':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
                case 'assignee':
                default:
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
            }
        }) : []
    });
const $e8ab789f25bfc4bf$export$5659c60045974de9 = (adfString)=>{
    if (!adfString) return null;
    try {
        return JSON.parse(adfString);
    } catch (_error) {
        return null;
    }
};

});

parcelRegister("3oS2M", function(module, exports) {
$parcel$export(module.exports, "getContextPanelSuggestions", () => $adc9a15d05014044$export$715f8fbc08922943);

var $12ByG = parcelRequire("12ByG");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $jHI6h = parcelRequire("jHI6h");

var $8sZMk = parcelRequire("8sZMk");
const $adc9a15d05014044$var$OPERATION_NAME = 'graphqlContextPanelQuery';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
const $adc9a15d05014044$var$contextPanelQuery = (0, $12ByG.default);
const $adc9a15d05014044$export$715f8fbc08922943 = async (cloudId, issueId)=>{
    (0, $jHI6h.startCapturingTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
    const graphQLResponse = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), $adc9a15d05014044$var$contextPanelQuery, {
        cloudId: cloudId,
        issueId: issueId
    }).toPromise().then((data)=>{
        const traceIds = (0, $jHI6h.getTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
        return (0, $8sZMk.handleGraphQLresponse)(data, traceIds);
    }).catch((error)=>{
        const traceIds = (0, $jHI6h.getTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
        return (0, $8sZMk.handleGraphQLError)(error, traceIds);
    }).finally(()=>{
        (0, $jHI6h.stopCapturingTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
    });
    return graphQLResponse;
};

});
parcelRegister("12ByG", function(module, exports) {
$parcel$export(module.exports, "default", () => $48e15bb162ea0470$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c774a8911f438c14fb2c108dc7261b2>>
 * @relayHash 20aa1db3e5dcec5d6322da71b2d44a0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55a6eaf60c07b634226859504fbc2afe9f4b2d83ce39697f662c523cfaea5460
const $48e15bb162ea0470$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "summary"
            },
            {
                "kind": "ScalarField",
                "name": "nextSteps"
            },
            {
                "kind": "ScalarField",
                "name": "reporterDetails"
            },
            {
                "kind": "ScalarField",
                "name": "suggestedEscalation"
            },
            {
                "concreteType": "AgentAISuggestAction",
                "kind": "LinkedField",
                "name": "suggestedActions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContent",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            }
                        ]
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContext",
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "suggestion"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "currentValue"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "AgentAIContextPanelResponse"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "55a6eaf60c07b634226859504fbc2afe9f4b2d83ce39697f662c523cfaea5460",
            "metadata": {},
            "name": "graphqlContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$48e15bb162ea0470$var$node.hash = "566ae9d1c90b40e64ca9be90435ac041";
var $48e15bb162ea0470$export$2e2bcd8739ae039 = $48e15bb162ea0470$var$node;

});

parcelRegister("8sZMk", function(module, exports) {
$parcel$export(module.exports, "handleGraphQLresponse", () => $c54e4deedc3837c9$export$f09fdc2e4ab145a5);
$parcel$export(module.exports, "handleGraphQLError", () => $c54e4deedc3837c9$export$3af48ada790caea5);
/* eslint-disable jira/import-whitelist */ 
var $hr3bU = parcelRequire("hr3bU");

var $hH1YR = parcelRequire("hH1YR");
const $c54e4deedc3837c9$export$716425a07890b235 = (graphQLResponse, traceIds)=>{
    const data = graphQLResponse?.agentAI_contextPanel?.__typename === 'AgentAIContextPanelResponse' ? graphQLResponse?.agentAI_contextPanel : null;
    return {
        type: 'ServicePanelSuggestions',
        traceIds: traceIds,
        summary: (0, $hH1YR.parseAdf)(data?.summary),
        reporterDetails: (0, $hH1YR.parseAdf)(data?.reporterDetails),
        nextSteps: (0, $hH1YR.parseAdf)(data?.nextSteps),
        suggestedEscalation: (0, $hH1YR.parseAdf)(data?.suggestedEscalation),
        suggestedActions: data?.suggestedActions ? data?.suggestedActions?.map((action)=>({
                type: action.type,
                context: {
                    ...action.context,
                    suggestion: action.context?.suggestion
                },
                content: (0, $hH1YR.transformContent)(action?.content)
            })) : []
    };
};
const $c54e4deedc3837c9$export$f09fdc2e4ab145a5 = (graphQLResponse, traceIds)=>{
    const responseType = graphQLResponse?.agentAI_contextPanel?.__typename;
    if (responseType === 'AgentAIContextPanelResponse') return $c54e4deedc3837c9$export$716425a07890b235(graphQLResponse, traceIds);
    if (responseType === 'QueryError') {
        const errorMessage = graphQLResponse?.agentAI_contextPanel?.message ?? 'Unknown error';
        const errorStatus = graphQLResponse?.agentAI_contextPanel?.extensions?.[0]?.statusCode ?? 500;
        throw new (0, $hr3bU.FetchError)(errorStatus, `Error processing graphQL query: ${errorMessage}`, traceIds?.[0]);
    }
    throw new (0, $hr3bU.FetchError)(500, 'Failed to fetch data from AGG', traceIds?.[0]);
};
const $c54e4deedc3837c9$export$3af48ada790caea5 = (error, traceIds)=>{
    throw new (0, $hr3bU.FetchError)(500, `Failed to fetch data from AGG : ${error?.message}`, traceIds?.[0]);
};

});
parcelRegister("hr3bU", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $c3479ad131081be1$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $c3479ad131081be1$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $c3479ad131081be1$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $c3479ad131081be1$export$26e841bcf1aeb894 extends $c3479ad131081be1$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $c3479ad131081be1$export$895e385291c3b753 extends $c3479ad131081be1$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});




parcelRegister("iVFol", function(module, exports) {
$parcel$export(module.exports, "getIncidentSuggestionEndpoint", () => $7e9ce5a2037a7c93$export$32b63803a24bceaa);

var $hgi0g = parcelRequire("hgi0g");

var $1L12E = parcelRequire("1L12E");
const $7e9ce5a2037a7c93$export$db19de3f154d9918 = ({ cloudId: cloudId, issueId: issueId, projectId: projectId, locale: locale })=>`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;
const $7e9ce5a2037a7c93$export$32b63803a24bceaa = (reqParams)=>{
    const url = $7e9ce5a2037a7c93$export$db19de3f154d9918(reqParams);
    return (0, $hgi0g.default)(url, {
        method: 'GET'
    }).then((0, $1L12E.transformResponseV2));
};

});
parcelRegister("1L12E", function(module, exports) {
$parcel$export(module.exports, "transformResponseV2", () => $c4785b8184d8dce8$export$deb8fcf4bacae588);
// Resource doesn't allow imports of getEmptyADF();
const $c4785b8184d8dce8$var$EMPTY_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
const $c4785b8184d8dce8$var$parseToADF = (adfString)=>{
    try {
        return JSON.parse(adfString);
    } catch (error) {
        return $c4785b8184d8dce8$var$EMPTY_DOCUMENT;
    }
};
const $c4785b8184d8dce8$var$transformContent = (content)=>{
    return {
        title: $c4785b8184d8dce8$var$parseToADF(content.title),
        description: $c4785b8184d8dce8$var$parseToADF(content.description)
    };
};
const $c4785b8184d8dce8$var$transformMultipleSectionContent = (content)=>{
    return {
        title: $c4785b8184d8dce8$var$parseToADF(content.title),
        description: $c4785b8184d8dce8$var$parseToADF(content.description),
        descriptionList: content.descriptionList ? content.descriptionList.map((suggestion)=>({
                id: suggestion.id,
                description: $c4785b8184d8dce8$var$parseToADF(suggestion.description)
            })) : []
    };
};
const $c4785b8184d8dce8$var$exhaustiveCheck = (_)=>null;
const $c4785b8184d8dce8$export$deb8fcf4bacae588 = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $c4785b8184d8dce8$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $c4785b8184d8dce8$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'MAJOR_INCIDENT':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'PRIORITY':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'RESPONDERS':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'ASSIGNEE':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                default:
                    return $c4785b8184d8dce8$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};

});


parcelRegister("3yIzr", function(module, exports) {
$parcel$export(module.exports, "getIssueDetails", () => $5e5098c8e0f24a39$export$da0733c355d205d6);
$parcel$export(module.exports, "contextPanelIssueDetailsResource", () => $5e5098c8e0f24a39$export$626ce3b2cb7fb94e);

var $NEgSm = parcelRequire("NEgSm");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $hqYEY = parcelRequire("hqYEY");

var $l1VxS = parcelRequire("l1VxS");

var $iYKap = parcelRequire("iYKap");

const $5e5098c8e0f24a39$var$ISSUE_DETAILS_AGG_METRIC = 'context-panel-issue-details-agg';
const $5e5098c8e0f24a39$var$issueDetailsAggMetric = (0, $hqYEY.metrics).custom({
    key: $5e5098c8e0f24a39$var$ISSUE_DETAILS_AGG_METRIC
});
const $5e5098c8e0f24a39$export$da0733c355d205d6 = async (issueKey, cloudId, includeContextPanelState = false)=>{
    $5e5098c8e0f24a39$var$issueDetailsAggMetric.start();
    const issueDetails = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $NEgSm.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        includeContextPanelState: includeContextPanelState
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((data)=>{
        $5e5098c8e0f24a39$var$issueDetailsAggMetric.stop();
        return data;
    }).catch(()=>{
        $5e5098c8e0f24a39$var$issueDetailsAggMetric.cancel();
        return null; // only returning null instead of throwing error since it polluted overall SSR success rate
    });
    return {
        issueId: issueDetails?.jira?.issueByKey?.issueId ?? undefined,
        practice: issueDetails?.jira?.issueByKey?.fieldByIdOrAlias?.text ?? undefined,
        projectId: issueDetails?.jira?.issueByKey?.projectField?.project?.projectId ?? undefined,
        isAIEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAIEnabled ?? undefined,
        ...includeContextPanelState && {
            isAiContextFeatureEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAiContextFeatureEnabled ?? undefined
        }
    };
};
const $5e5098c8e0f24a39$export$626ce3b2cb7fb94e = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd),
    getKey: ({ match: match, query: query })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        return `contextPanelIssueDetailsResource-${issueKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        const cloudId = tenantContext.cloudId;
        if (!(0, $iYKap.checkLicense)(tenantContext, 'servicedesk')) return null;
        if (!issueKey) /* only returning null instead of throwing error since it polluted overall SSR success rate */ /* until a better is implemented */ return null;
        return $5e5098c8e0f24a39$export$da0733c355d205d6(issueKey, cloudId, true);
    },
    maxAge: 3600000
});

});
parcelRegister("NEgSm", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c8621b016dd1263$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<97b1ac959a33600e23b69a5ece8a9862>>
 * @relayHash f0aba673194e9058619abb300a99e877
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74
const $1c8621b016dd1263$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeContextPanelState"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "idOrAlias",
            "value": "servicedesk-practices"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isAIEnabled"
    }, v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "condition": "includeContextPanelState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAiContextFeatureEnabled"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74",
            "metadata": {},
            "name": "issueDetailsForAIContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1c8621b016dd1263$var$node.hash = "31378fdb45b287b152e0f480c90e621a";
var $1c8621b016dd1263$export$2e2bcd8739ae039 = $1c8621b016dd1263$var$node;

});


parcelRegister("fEqOu", function(module, exports) {
$parcel$export(module.exports, "getFeatureState", () => $06021a236a151e25$export$c8c54cead17ad7fa);
// eslint-disable-next-line jira/import-whitelist

var $hqYEY = parcelRequire("hqYEY");

var $dYpVn = parcelRequire("dYpVn");
const $06021a236a151e25$var$FEATURE_STATE_METRIC = 'context-panel-feature-states';
const $06021a236a151e25$var$featureStateMetric = (0, $hqYEY.metrics).custom({
    key: $06021a236a151e25$var$FEATURE_STATE_METRIC
});
const $06021a236a151e25$export$c8c54cead17ad7fa = (routerDataContext, resourceStoreContext)=>{
    $06021a236a151e25$var$featureStateMetric.start();
    return (0, $dYpVn.featuresResource)(routerDataContext, resourceStoreContext)?.then((data)=>{
        $06021a236a151e25$var$featureStateMetric.stop();
        return data;
    }).catch((e)=>{
        $06021a236a151e25$var$featureStateMetric.cancel();
        throw e;
    });
};

});
parcelRegister("dYpVn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "transformRestData", () => $f8375032ce4d6cb2$export$40da6ae06b8b332e);
$parcel$export(module.exports, "featuresResource", () => $f8375032ce4d6cb2$export$16f81cc9da2c6c47);
$parcel$export(module.exports, "default", () => $f8375032ce4d6cb2$export$2e2bcd8739ae039);

var $9Dhvc = parcelRequire("9Dhvc");

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $2vBmG = parcelRequire("2vBmG");

var $7hVvO = parcelRequire("7hVvO");

var $bBtQo = parcelRequire("bBtQo");

var $aV23b = parcelRequire("aV23b");
const $f8375032ce4d6cb2$export$40da6ae06b8b332e = (data)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.reduce((acc, { feature: feature, status: status, editable: editable })=>Object.assign(acc, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [feature]: {
                status: status,
                editable: editable
            }
        }), {});
const $f8375032ce4d6cb2$var$getFeatures = async (projectKey)=>{
    try {
        const data = await (0, $hgi0g.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/features`);
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiReadyMark));
        return $f8375032ce4d6cb2$export$40da6ae06b8b332e(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraServicedeskPracticeFeaturesResource', error);
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskPracticeFeaturesResource',
                packageName: 'jiraSpa'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $f8375032ce4d6cb2$export$16f81cc9da2c6c47 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    const { params: params } = match;
    if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
        component: 'spa.view.routes.servicedesk.features.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    // projectKey from url path or issueKey
    const projectKey = (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(params, 'issueKey', '')?.split('-')[0];
    if (projectKey == null) return null;
    return $f8375032ce4d6cb2$var$getFeatures(projectKey);
};
var $f8375032ce4d6cb2$export$2e2bcd8739ae039 = $f8375032ce4d6cb2$export$16f81cc9da2c6c47;

});
parcelRegister("2vBmG", function(module, exports) {
$parcel$export(module.exports, "appBundleReadyMark", () => $579400bfeaf912d5$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $579400bfeaf912d5$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $579400bfeaf912d5$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $579400bfeaf912d5$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $579400bfeaf912d5$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $579400bfeaf912d5$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $579400bfeaf912d5$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $579400bfeaf912d5$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $579400bfeaf912d5$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $579400bfeaf912d5$export$4eb8d44ddb14424a);


var $4VDpW = parcelRequire("4VDpW");
const $579400bfeaf912d5$export$7e50945a65dd40e = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$ff834eccc35b9089));
const $579400bfeaf912d5$export$17cbe723d23101d8 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$86b05e34d462ead8));
const $579400bfeaf912d5$export$887fadb22e7c7735 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$d6a604a7d9a390fb));
const $579400bfeaf912d5$export$bd099c0a906f4b3f = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$3ae43cc1782d058f));
const $579400bfeaf912d5$export$d23ef9e7633e30e7 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$363f6703ffa600be));
const $579400bfeaf912d5$export$319da6d901948a6d = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$e87b74567b79c8));
const $579400bfeaf912d5$export$f0b6622cdc5c7e4f = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$99fe642459a8b02));
const $579400bfeaf912d5$export$37e82663aa1e79a8 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$ab1f5705fc8e0571));
const $579400bfeaf912d5$export$21146514eacceb12 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$8c3a9046da692c35));
const $579400bfeaf912d5$export$4eb8d44ddb14424a = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$5aa497d1efdcc5bf));

});
const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("4VDpW", function(module, exports) {
$parcel$export(module.exports, "getPrefixedMarkName", () => $880ea9c96225497a$export$c8f0e9837e7e9425);

const $880ea9c96225497a$export$c8f0e9837e7e9425 = (name)=>`${0, $fcc2379b1f384e36$export$56940a9488e85199}${name}`;

});


parcelRegister("aV23b", function(module, exports) {
$parcel$export(module.exports, "checkAuthentication", () => $1d4b19068776b455$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $1d4b19068776b455$export$e9b9096e887386fe);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");

var $5ya7R = parcelRequire("5ya7R");
const $1d4b19068776b455$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $1d4b19068776b455$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($1d4b19068776b455$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ya7R.RedirectToLoginPage), null);
    });

});
parcelRegister("5ya7R", function(module, exports) {
$parcel$export(module.exports, "RedirectToLoginPage", () => $3692ea1fd0794252$export$938182bd3fddc3a8);

var $eJOHy = parcelRequire("eJOHy");

var $95O7y = parcelRequire("95O7y");
var $gCY1z = parcelRequire("gCY1z");

var $gr8eh = parcelRequire("gr8eh");
const $3692ea1fd0794252$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$3692ea1fd0794252$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $3692ea1fd0794252$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $gCY1z.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $95O7y.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gr8eh.default), {
        url: path
    });
};

});
parcelRegister("gr8eh", function(module, exports) {
$parcel$export(module.exports, "default", () => $afdbf783998da05f$export$2e2bcd8739ae039);

var $gRw8I = parcelRequire("gRw8I");
const $afdbf783998da05f$var$FullPageRedirect = ({ url: url })=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};
var $afdbf783998da05f$export$2e2bcd8739ae039 = $afdbf783998da05f$var$FullPageRedirect;

});






parcelRegister("6zEUu", function(module, exports) {
$parcel$export(module.exports, "projectGlobalComponentsResource", () => $dea084457308c93c$export$d2cb7067a31cf873);

var $l1VxS = parcelRequire("l1VxS");

var $bBtQo = parcelRequire("bBtQo");

var $3Is9n = parcelRequire("3Is9n");
const $dea084457308c93c$export$be79e0677801e96e = 'PROJECT_GLOBAL_COMPONENTS';
const $dea084457308c93c$export$d2cb7067a31cf873 = (0, $l1VxS.createResource)({
    type: $dea084457308c93c$export$be79e0677801e96e,
    getKey: (matchedRoute)=>(0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getData: (...args)=>(0, $3Is9n.getData)(...args)
});

});
parcelRegister("3Is9n", function(module, exports) {
$parcel$export(module.exports, "getData", () => $c5448ba1b9fac404$export$7a171f172be0782e);

var $bBtQo = parcelRequire("bBtQo");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $c5448ba1b9fac404$export$7a171f172be0782e = async (matchedRoute, _storeContext)=>{
    const projectIdOrKey = (0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $c5448ba1b9fac404$export$1db3503600a1638e(projectIdOrKey);
};
const $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $c5448ba1b9fac404$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $c5448ba1b9fac404$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $c5448ba1b9fac404$var$getProjectId = async (projectKey)=>{
    const project = await (0, $3ugTQ.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $c5448ba1b9fac404$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$c5448ba1b9fac404$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $c5448ba1b9fac404$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $c5448ba1b9fac404$var$url(projectId, $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $c5448ba1b9fac404$var$url(projectKey, $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $3ugTQ.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};

});


parcelRegister("W6cJS", function(module, exports) {
$parcel$export(module.exports, "getJsmIssueViewSlaPanelResource", () => $00f5fc4bffd7e9ed$export$31e044b40ecfc470);
$parcel$export(module.exports, "useJsmIssueViewSlaPanelResource", () => $00f5fc4bffd7e9ed$export$cc90b63080792845);
$parcel$export(module.exports, "getJsmIssueViewRelatedArticlesResource", () => $00f5fc4bffd7e9ed$export$ae254d90098bb89b);
$parcel$export(module.exports, "useJsmIssueViewRelatedArticlesResource", () => $00f5fc4bffd7e9ed$export$916df522dc3042e5);

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $eq3q8 = parcelRequire("eq3q8");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");


var $5j85B = parcelRequire("5j85B");
const $00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource = (0, $l1VxS.createResource)({
    type: 'JSM_ISSUE_VIEW_SLA_PANEL_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey && (0, $4cTDP.fg)('update_key_of_sla_panel_resource')) {
            if (query && query.selectedIssue) return query.selectedIssue || '';
        }
        return issueKey || '';
    },
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        // ServiceDesk access check is only enforced when jsm-issue-view-sla-panel-high-load-protection fg is enabled,
        // allowing us to restrict access during high load scenarios
        if (!tenantContext.appEditions.serviceDesk && (0, $4cTDP.fg)('jsm-issue-view-sla-panel-high-load-protection')) return null;
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const url = `/rest/servicedesk/1/servicedesk/sla/issue/${issueKey}`;
            const response = await (0, $hgi0g.default)(url, {
                method: 'GET'
            });
            if (!response.errors) return response;
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error instanceof Error ? error : new Error(String(error)),
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    id: 'jsmIssueViewSlaPanelResource',
                    packageName: 'jiraRouterResourcesJsmIssueView',
                    teamName: 'jsd-shield'
                }
            });
        }
        return null;
    }
});
const $00f5fc4bffd7e9ed$export$31e044b40ecfc470 = ()=>$00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource;
const $00f5fc4bffd7e9ed$export$cc90b63080792845 = ()=>{
    return (0, $eJrcF.useResource)($00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource);
};
// eslint-disable-next-line jira/router/no-daisy-chaining-resources
const $00f5fc4bffd7e9ed$var$jsmIssueViewRelatedArticlesResource = (0, $l1VxS.createResource)({
    type: 'JSM_ISSUE_VIEW_RELATED_ARTICLES_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey && (0, $4cTDP.fg)('update_key_of_sla_panel_resource')) {
            if (query && query.selectedIssue) return query.selectedIssue || '';
        }
        return issueKey || '';
    },
    depends: [
        (0, $c8eeacd6960f72dc$export$80a60a092d9ab81)
    ],
    getData: async ({ match: match, dependencies: dependencies }, { tenantContext: tenantContext })=>{
        if (!tenantContext.appEditions.serviceDesk) return null;
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey) return null;
        const consumedDependency = await (0, $5j85B.consumeDependency)(dependencies, (0, $c8eeacd6960f72dc$export$80a60a092d9ab81));
        if (consumedDependency) {
            const { projectType: projectType } = consumedDependency;
            if (projectType !== 'service_desk') return null;
        }
        if (false) {
            const serverUrl = `/api/issue/${issueKey}/articles`;
            return (0, $hgi0g.default)(serverUrl, {
                method: 'GET',
                headers: {
                    'x-ssr-service-name': 'jsd-apollo',
                    'atl-cloudid': tenantContext.cloudId
                }
            });
        }
        const clientUrl = `/gateway/api/jsd-apollo-stargate/sharded/workspace/${tenantContext.activationId}/api/issue/${issueKey}/articles`;
        return (0, $hgi0g.default)(clientUrl, {
            method: 'GET'
        });
    }
});
const $00f5fc4bffd7e9ed$export$ae254d90098bb89b = ()=>$00f5fc4bffd7e9ed$var$jsmIssueViewRelatedArticlesResource;
const $00f5fc4bffd7e9ed$export$916df522dc3042e5 = ()=>{
    return (0, $eJrcF.useResource)($00f5fc4bffd7e9ed$var$jsmIssueViewRelatedArticlesResource);
};

});

parcelRegister("jIhkm", function(module, exports) {
$parcel$export(module.exports, "issueCollapsibleGroupDataResource", () => $b5513ffcc897291a$export$36e5daae4cc63ce1);
// eslint-disable-next-line jira/import-whitelist


var $l1VxS = parcelRequire("l1VxS");

var $bBtQo = parcelRequire("bBtQo");

var $3ugTQ = parcelRequire("3ugTQ");

var $7hVvO = parcelRequire("7hVvO");
const $b5513ffcc897291a$var$getKey = ({ match: match, query: query })=>{
    const projectKey = (0, $bBtQo.getProjectKey)(match, query);
    return `issue.collapsible-group.${projectKey}`;
};
const $b5513ffcc897291a$export$36e5daae4cc63ce1 = (0, $l1VxS.createResource)({
    type: 'ISSUE_COLLAPSIBLE_GROUP_DATA',
    getKey: $b5513ffcc897291a$var$getKey,
    getData: async ({ match: match, query: query })=>{
        const key = $b5513ffcc897291a$var$getKey({
            match: match,
            query: query
        });
        const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
        try {
            return await (0, $3ugTQ.performGetRequest)(requestUrl);
        } catch (error) {
            if (!!error && typeof error === 'object' && 'statusCode' in error && error.statusCode === (0, $3a153a61cf6b691b$export$8bca792d963eb0ef)) return;
            throw (0, $7hVvO.createResourceError)({
                component: 'spa.view.routes.issue-view.collapsible-group.getData',
                message: 'An error was thrown while prefetching issue collapsible group data'
            }, error);
        }
    }
});

});

parcelRegister("dQc7D", function(module, exports) {
$parcel$export(module.exports, "issueHideEmptyFieldsDataResource", () => $834a2ef505a079d2$export$a4e9191e8975382d);

var $l1VxS = parcelRequire("l1VxS");

var $bBtQo = parcelRequire("bBtQo");

var $3ugTQ = parcelRequire("3ugTQ");
const $834a2ef505a079d2$var$getKey = ({ match: match, query: query })=>{
    const projectKey = (0, $bBtQo.getProjectKey)(match, query);
    return `issue.hide-empty-fields.${projectKey}`;
};
const $834a2ef505a079d2$export$a4e9191e8975382d = (0, $l1VxS.createResource)({
    type: 'ISSUE_HIDE_EMPTY_FIELDS_DATA',
    getKey: $834a2ef505a079d2$var$getKey,
    getData: async ({ match: match, query: query })=>{
        const key = $834a2ef505a079d2$var$getKey({
            match: match,
            query: query
        });
        const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
        return (0, $3ugTQ.performGetRequest)(requestUrl);
    },
    isBrowserOnly: false
});

});

parcelRegister("1FbOO", function(module, exports) {
$parcel$export(module.exports, "issueViewRemoteDataResource", () => $67ef7d8a234ffdb4$export$6942f0cc7b5c5ffd);

var $eq3q8 = parcelRequire("eq3q8");

var $l1VxS = parcelRequire("l1VxS");

var $8BIkE = parcelRequire("8BIkE");
const $67ef7d8a234ffdb4$export$6942f0cc7b5c5ffd = (0, $l1VxS.createResource)({
    type: 'ISSUE_VIEW_REMOTE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $8BIkE.default)(...args),
    isBrowserOnly: true
});

});
parcelRegister("8BIkE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c25e27746856939e$export$2e2bcd8739ae039);

var $eq3q8 = parcelRequire("eq3q8");

var $8myMV = parcelRequire("8myMV");
const $c25e27746856939e$var$getData = async ({ match: match }, _storeContext)=>{
    const issueKey = (0, $eq3q8.getIssueKey)(match);
    if (!issueKey) return null;
    (0, $8myMV.prefetchedRemoteDataManager).prefetch(issueKey);
    return null;
};
var $c25e27746856939e$export$2e2bcd8739ae039 = $c25e27746856939e$var$getData;

});
parcelRegister("8myMV", function(module, exports) {
$parcel$export(module.exports, "prefetchedRemoteDataManager", () => $dfaa457b025a39dd$export$1d81e79fc6260e6d);

var $04Hi3 = parcelRequire("04Hi3");
class $dfaa457b025a39dd$export$b5a5c1dfc61a5193 {
    prefetch(issueKey) {
        const promise = (0, $04Hi3.fetchIssueViewRemoteData)(issueKey);
        this.cache.set(issueKey, promise);
    }
    getOrFetch(issueKey) {
        if (this.cache.has(issueKey)) return this.cache.get(issueKey);
        const promise = (0, $04Hi3.fetchIssueViewRemoteData)(issueKey);
        this.cache.set(issueKey, promise);
        return promise;
    }
    consume(issueKey) {
        const promise = this.getOrFetch(issueKey);
        this.cache.delete(issueKey);
        return promise;
    }
    constructor(){
        this.cache = new Map();
    }
}
const $dfaa457b025a39dd$export$1d81e79fc6260e6d = new $dfaa457b025a39dd$export$b5a5c1dfc61a5193();

});
parcelRegister("04Hi3", function(module, exports) {
$parcel$export(module.exports, "fetchIssueViewRemoteData", () => $5f7d44e5c1171476$export$35db3378e2f116e4);

var $gyozf = parcelRequire("gyozf");

var $fVpjy = parcelRequire("fVpjy");
const $5f7d44e5c1171476$export$35db3378e2f116e4 = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $gyozf.getIssueRemoteDataQuery)(),
        variables: variables,
        operationName: (0, $gyozf.ISSUE_VIEW_REMOTE_DATA_QUERY)
    };
    const response = await (0, $fVpjy.getClient)().query(payload);
    return response;
};

});
parcelRegister("gyozf", function(module, exports) {
$parcel$export(module.exports, "getRemoteDataQueryPrefix", () => $42c1056ef10067ff$export$1a164444721ce2fb);
$parcel$export(module.exports, "ISSUE_VIEW_REMOTE_DATA_QUERY", () => $42c1056ef10067ff$export$2761e7caa26df533);
$parcel$export(module.exports, "getIssueRemoteDataQuery", () => $42c1056ef10067ff$export$65f9808f978ee25);

var $4cTDP = parcelRequire("4cTDP");
const $42c1056ef10067ff$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $42c1056ef10067ff$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
const $42c1056ef10067ff$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$42c1056ef10067ff$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
const $42c1056ef10067ff$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$42c1056ef10067ff$var$getConfluencePagesQueryFragment()}
`;
const $42c1056ef10067ff$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $42c1056ef10067ff$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $42c1056ef10067ff$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$42c1056ef10067ff$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $42c1056ef10067ff$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$42c1056ef10067ff$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$42c1056ef10067ff$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $42c1056ef10067ff$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $42c1056ef10067ff$var$getRemoteDataQueryFragmentOld = ()=>`
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${$42c1056ef10067ff$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$42c1056ef10067ff$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$42c1056ef10067ff$export$761fd517f0dda983()}
        ${(0, $4cTDP.fg)('jiv-21221_iv_remote_links_new_field') ? '' : $42c1056ef10067ff$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $42c1056ef10067ff$var$getRemoteDataQueryFragmentNew = ()=>`
	issueId
	remoteLinks {
		isLinkingEnabled
		${$42c1056ef10067ff$export$761fd517f0dda983()}
        ${(0, $4cTDP.fg)('jiv-21221_iv_remote_links_new_field') ? '' : $42c1056ef10067ff$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $42c1056ef10067ff$var$getRemoteDataQueryFragment = ()=>(0, $4cTDP.fg)('jiv_confluence_remote_link_critical_query') ? $42c1056ef10067ff$var$getRemoteDataQueryFragmentNew() : $42c1056ef10067ff$var$getRemoteDataQueryFragmentOld();
const $42c1056ef10067ff$var$getRemoteIssueLinksFragment = ()=>`
	remoteIssueLinks {
		edges {
			node {
				id
				globalId
				title
				relationship
				href
				content {
					__typename
					... on RemoteJiraIssueLinkResultSuccess {
						issueId
						key
						summary
						statusId
						statusName
						statusCategoryId
						isResolved
						issueTypeName
						issueTypeIconUrl
						priorityName
						priorityIconUrl
						assigneeDisplayName
						assigneeAvatarUrl
					}
					... on RemoteJiraIssueLinkResultError {
						errorType
						repairLink
					}
				}
			}
		}
	}
`;
const $42c1056ef10067ff$export$1a164444721ce2fb = ()=>'_remote_data';
const $42c1056ef10067ff$export$2761e7caa26df533 = 'issueViewRemoteDataQuery';
const $42c1056ef10067ff$export$65f9808f978ee25 = ()=>`
    query ${$42c1056ef10067ff$export$2761e7caa26df533}($issueKey: String!) {
        ${$42c1056ef10067ff$var$VIEW_ISSUE_ALIAS}${$42c1056ef10067ff$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
            ${$42c1056ef10067ff$var$getRemoteDataQueryFragment()}
			${(0, $4cTDP.fg)('jiv-21221_iv_remote_links_new_field') ? $42c1056ef10067ff$var$getRemoteIssueLinksFragment() : ''}
        }
    }
`;

});

parcelRegister("fVpjy", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $ef8531d5e19bae40$export$6bb76d6eba7e258c);

var $hgi0g = parcelRequire("hgi0g");

var $8DQlA = parcelRequire("8DQlA");
const $ef8531d5e19bae40$var$makeFetchClient = ()=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $hgi0g.default)((0, $8DQlA.getGiraUrl)(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $ef8531d5e19bae40$var$client;
const $ef8531d5e19bae40$export$6bb76d6eba7e258c = ()=>{
    if (!$ef8531d5e19bae40$var$client) $ef8531d5e19bae40$var$client = $ef8531d5e19bae40$var$makeFetchClient();
    return $ef8531d5e19bae40$var$client;
};

});





parcelRegister("38U18", function(module, exports) {
$parcel$export(module.exports, "LazyIssuePage", () => $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a);
$parcel$export(module.exports, "IssueComponent", () => $d4115a80200ae1b5$export$c1a868ace2f38803);
$parcel$export(module.exports, "IssueEmbedComponent", () => $d4115a80200ae1b5$export$ef02bcc0eb1d9ded);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $Xckw8 = parcelRequire("Xckw8");

var $bNexr = parcelRequire("bNexr");

var $2aY2d = parcelRequire("2aY2d");

var $kGR8U = parcelRequire("kGR8U");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2mHfh = parcelRequire("2mHfh");
var $2FqDG = parcelRequire("2FqDG");

const $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a = (0, $bQWwW.lazyForPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)(// chunk name here MUST be kept in sync with TempLazyIssuePageWithSsrAlwaysDisabled below
    (parcelRequire("lOoQA"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});
const $d4115a80200ae1b5$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    const pageId = 'spa-issue';
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $d4115a80200ae1b5$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    const projectKey = (0, $bNexr.useProjectKey)(issueKey || '');
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Xckw8.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4115a80200ae1b5$export$c1a868ace2f38803, null));
};

});
parcelRegister("Xckw8", function(module, exports) {
$parcel$export(module.exports, "EmbedModeContext", () => $afaa80f88033d8aa$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $afaa80f88033d8aa$export$9daaf42d62e1c430);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");
const $afaa80f88033d8aa$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $afaa80f88033d8aa$var$Provider } = $afaa80f88033d8aa$export$5eb07b3c7c0b0771;
const $afaa80f88033d8aa$var$handleEmbedLinkClick = (e)=>{
    if ((0, $4cTDP.fg)('jsc_nin_smart_link_fast_follows')) {
        if (e.target instanceof Element) {
            const anchor = e.target.closest('a'); // Find closest parent anchor (including the target itself)
            if (anchor && anchor.target !== '_blank') // link
            anchor.target = '_blank';
        }
    } else {
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
        eventTarget.target = '_blank';
    }
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $afaa80f88033d8aa$var$DarkModeMonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, #FFFFFF)"};
                    }
                `
        }
    });
const $afaa80f88033d8aa$export$9daaf42d62e1c430 = ({ children: children })=>{
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $afaa80f88033d8aa$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $afaa80f88033d8aa$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($afaa80f88033d8aa$var$DarkModeMonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($afaa80f88033d8aa$var$Provider, {
        value: true
    }, children));
};

});

parcelRegister("2aY2d", function(module, exports) {
$parcel$export(module.exports, "useProjectContext", () => $8ba7ca521b299ffc$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $8ba7ca521b299ffc$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $8ba7ca521b299ffc$export$a85f6b5857d2176);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $dZRaT = parcelRequire("dZRaT");
const $8ba7ca521b299ffc$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $dZRaT.projectContextResourceWithCache), customContext);
    const updateCache = (0, $eJOHy.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $8ba7ca521b299ffc$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $8ba7ca521b299ffc$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $8ba7ca521b299ffc$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $8ba7ca521b299ffc$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("kGR8U", function(module, exports) {
$parcel$export(module.exports, "markAsBentoBundleReady", () => $393e398983932379$export$d9ff0b3329728986);

var $75yrv = parcelRequire("75yrv");

var $lOI8W = parcelRequire("lOI8W");
let $393e398983932379$var$reportedBentoBundleReady = false;
const $393e398983932379$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($393e398983932379$var$reportedBentoBundleReady) return;
        $393e398983932379$var$reportedBentoBundleReady = true;
        (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $75yrv.JS_EVAL_START))) {
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});
parcelRegister("lOI8W", function(module, exports) {
$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $9f6d119740c72bee$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $9f6d119740c72bee$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $9f6d119740c72bee$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $9f6d119740c72bee$export$de1b4cf109d9ab65);

var $iKhRZ = parcelRequire("iKhRZ");

var $k04JP = parcelRequire("k04JP");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $9f6d119740c72bee$var$safeMeasure = (name, start, stop)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.measure(name, start, stop);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (_err) {}
};
const $9f6d119740c72bee$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $9f6d119740c72bee$var$safeMeasure(name, start, stop);
    (0, $k04JP.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $iKhRZ.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $9f6d119740c72bee$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $9f6d119740c72bee$var$safeMeasure(name, start, stopMark);
    (0, $k04JP.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $iKhRZ.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $9f6d119740c72bee$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $9f6d119740c72bee$var$safeMeasure(name, startMark, stopMark);
    (0, $k04JP.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $iKhRZ.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $9f6d119740c72bee$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $k04JP.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $iKhRZ.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $9f6d119740c72bee$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $9f6d119740c72bee$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});
parcelRegister("iKhRZ", function(module, exports) {
$parcel$export(module.exports, "addTimingFromPerformanceMark", () => $6cf172453addbdda$export$758b9a33800fa436);
$parcel$export(module.exports, "getTimings", () => $6cf172453addbdda$export$6d488733a547304);
const $6cf172453addbdda$var$timings = [];
function $6cf172453addbdda$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $6cf172453addbdda$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $6cf172453addbdda$export$6d488733a547304() {
    const reportedTimingsObj = {};
    $6cf172453addbdda$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});



parcelRegister("1F9cm", function(module, exports) {
$parcel$export(module.exports, "LazyPage", () => $115917303a5a4975$export$a18c9c3dd309b8e6);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $eSnSE = parcelRequire("eSnSE");

var $2imLM = parcelRequire("2imLM");

var $hih5V = parcelRequire("hih5V");

var $1Mugv = parcelRequire("1Mugv");

var $cH6Qf = parcelRequire("cH6Qf");

var $lq8Ki = parcelRequire("lq8Ki");
const $115917303a5a4975$var$LOCATION = 'lazy-page';
const $115917303a5a4975$export$fb85bbdbfb3e6869 = ()=>null;
const $115917303a5a4975$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $6OSA0.default) : $115917303a5a4975$export$fb85bbdbfb3e6869);
    (0, $eJOHy.useEffect)(()=>{
        if (route.isRedirect) (0, $eSnSE.default).safeWarnWithoutCustomerData($115917303a5a4975$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, route.bifrost?.bifrostGroup !== 'shell-only' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "LazyPage",
        ignoreWhenCircuitOpen: true,
        displayErrorInStaging: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Mugv.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "lazy_page",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null)))));
};

});
parcelRegister("6OSA0", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dece214507286a2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $7ep4S = parcelRequire("7ep4S");
function $9dece214507286a2$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9dece214507286a2$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9dece214507286a2$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large",
        testId: testId
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dece214507286a2$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $9dece214507286a2$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hih5V", function(module, exports) {
$parcel$export(module.exports, "useCurrentRoute", () => $0de85b9e16d59246$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $0de85b9e16d59246$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $0de85b9e16d59246$export$1e5fb68306bd0b92);

var $kfvK2 = parcelRequire("kfvK2");
var $gCY1z = parcelRequire("gCY1z");

var $kQnVX = parcelRequire("kQnVX");

const $0de85b9e16d59246$export$c4b7ea2942f2d0e = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $0de85b9e16d59246$export$d69a946e2d0a1c12 = (0, $kfvK2.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $0de85b9e16d59246$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $0de85b9e16d59246$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $gCY1z.useRouter)();
    return (0, $kQnVX.getPreviousRouterState)();
};

});

parcelRegister("1Mugv", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ad74313ebaa032b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $662Y6 = parcelRequire("662Y6");

var $6uWhG = parcelRequire("6uWhG");

var $5onjV = parcelRequire("5onjV");

var $2HxHL = parcelRequire("2HxHL");

var $9DwQv = parcelRequire("9DwQv");


var $gmwod = parcelRequire("gmwod");

var $4VDpW = parcelRequire("4VDpW");
class $1ad74313ebaa032b$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gmwod.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args), this.customMarks = [], this.onStart = ()=>{
            (0, $662Y6.default)((0, $fcc2379b1f384e36$export$56940a9488e85199));
            (0, $6uWhG.setMark)((0, $fcc2379b1f384e36$export$45c4b6bf7935c69a));
        }, this.onCustomMark = (markName)=>{
            (0, $6uWhG.setMark)((0, $4VDpW.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
        };
    }
}

});
parcelRegister("662Y6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8b8f5b498d09c66$export$2e2bcd8739ae039);

var $gPCSe = parcelRequire("gPCSe");
/*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ const $a8b8f5b498d09c66$var$clearMarksWithPrefix = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $gPCSe.default) && (0, $gPCSe.default).getEntries && (0, $gPCSe.default).clearMarks) return (0, $gPCSe.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $gPCSe.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};
var $a8b8f5b498d09c66$export$2e2bcd8739ae039 = $a8b8f5b498d09c66$var$clearMarksWithPrefix;

});

parcelRegister("5onjV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7adc4a77c4e3fb86$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
// eslint-disable-next-line jira/react/no-class-components
class $7adc4a77c4e3fb86$var$OpTrigger extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $7adc4a77c4e3fb86$export$2e2bcd8739ae039 = $7adc4a77c4e3fb86$var$OpTrigger;

});

parcelRegister("2HxHL", function(module, exports) {
$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $0d6f1ba58ae6ece0$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $0d6f1ba58ae6ece0$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $0d6f1ba58ae6ece0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $662Y6 = parcelRequire("662Y6");

var $6uWhG = parcelRequire("6uWhG");

var $8MHJG = parcelRequire("8MHJG");

var $2Mqjh = parcelRequire("2Mqjh");

var $02OvK = parcelRequire("02OvK");

var $9DwQv = parcelRequire("9DwQv");

const $0d6f1ba58ae6ece0$var$STOP_DELAY_TIMEOUT = 10000;
let $0d6f1ba58ae6ece0$var$stopDelayTimeout;
let $0d6f1ba58ae6ece0$var$lastDelayActionPromise = (0, $2Mqjh.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $0d6f1ba58ae6ece0$export$a928755af449867 = ()=>{
    $0d6f1ba58ae6ece0$var$lastDelayActionPromise = $0d6f1ba58ae6ece0$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $8MHJG.isEventDelayActive)()) return client;
        clearTimeout($0d6f1ba58ae6ece0$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6uWhG.setMark)((0, $f8c82f467f2e47ac$export$2d91d3eed1108e72));
        (0, $8MHJG.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $0d6f1ba58ae6ece0$export$8bb8df5a93e9525 = ()=>{
    $0d6f1ba58ae6ece0$var$lastDelayActionPromise = $0d6f1ba58ae6ece0$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $8MHJG.isEventDelayActive)()) {
            (0, $662Y6.default)((0, $f8c82f467f2e47ac$export$358721a9d6125914));
            (0, $6uWhG.setMark)((0, $f8c82f467f2e47ac$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $8MHJG.setEventDelayActive)(true);
        clearTimeout($0d6f1ba58ae6ece0$var$stopDelayTimeout);
        $0d6f1ba58ae6ece0$var$stopDelayTimeout = setTimeout($0d6f1ba58ae6ece0$export$a928755af449867, $0d6f1ba58ae6ece0$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $0d6f1ba58ae6ece0$export$778ebe2a4fab1ba7 = ()=>$0d6f1ba58ae6ece0$var$lastDelayActionPromise;
const $0d6f1ba58ae6ece0$var$EventDelayController = ()=>{
    const [loadedState] = (0, $02OvK.default)();
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $9DwQv.isAutomaticExposureCollectionEnabled)()) $0d6f1ba58ae6ece0$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $0d6f1ba58ae6ece0$export$2e2bcd8739ae039 = $0d6f1ba58ae6ece0$var$EventDelayController;

});
parcelRegister("8MHJG", function(module, exports) {
$parcel$export(module.exports, "setEventDelayActive", () => $477d32fa9a5520a7$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $477d32fa9a5520a7$export$3536b0184fa98d19);
let $477d32fa9a5520a7$var$eventDelayActive = false;
const $477d32fa9a5520a7$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $477d32fa9a5520a7$var$eventDelayActive = isEventDelayActive;
};
const $477d32fa9a5520a7$export$3536b0184fa98d19 = ()=>$477d32fa9a5520a7$var$eventDelayActive;

});

parcelRegister("02OvK", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fbb0dc2a1310365$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");


var $79p6g = parcelRequire("79p6g");
const $3fbb0dc2a1310365$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $44a1f3ad00fd7f5d$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $44a1f3ad00fd7f5d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $3fbb0dc2a1310365$var$usePageLoadedSubscriber = (0, $iJq0l.createHook)((0, $79p6g.default), {
    selector: $3fbb0dc2a1310365$export$4a361c7505f72f5c
});
var $3fbb0dc2a1310365$export$2e2bcd8739ae039 = $3fbb0dc2a1310365$var$usePageLoadedSubscriber;

});
const $44a1f3ad00fd7f5d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $44a1f3ad00fd7f5d$export$2ee9e5a3556c1e43 = 'SIDEBAR';

parcelRegister("79p6g", function(module, exports) {
$parcel$export(module.exports, "default", () => $956076d2e5b7cbc9$export$2e2bcd8739ae039);

var $aXKmr = parcelRequire("aXKmr");

var $GtRbT = parcelRequire("GtRbT");

var $54BJ2 = parcelRequire("54BJ2");
const $956076d2e5b7cbc9$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, $aXKmr.v4)(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $956076d2e5b7cbc9$var$store = (0, $GtRbT.createStore)({
    name: 'spa-state',
    initialState: $956076d2e5b7cbc9$export$d4c72bab9d6cc13a,
    actions: $54BJ2
});
var $956076d2e5b7cbc9$export$2e2bcd8739ae039 = $956076d2e5b7cbc9$var$store;

});
parcelRegister("54BJ2", function(module, exports) {
$parcel$export(module.exports, "setAppStart", () => (parcelRequire("2Lfl5")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("2Lfl5")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("2Lfl5")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("2Lfl5")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("2Lfl5")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("2Lfl5")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("2Lfl5")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("2Lfl5")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("2Lfl5")).setResourceMetrics);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $2Lfl5 = parcelRequire("2Lfl5");

});
parcelRegister("2Lfl5", function(module, exports) {
$parcel$export(module.exports, "resetCurrentPage", () => $3b47e664c8b4a4ba$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $3b47e664c8b4a4ba$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $3b47e664c8b4a4ba$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $3b47e664c8b4a4ba$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $3b47e664c8b4a4ba$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $3b47e664c8b4a4ba$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $3b47e664c8b4a4ba$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $3b47e664c8b4a4ba$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $3b47e664c8b4a4ba$export$8ad155d489dcf34d);

var $aXKmr = parcelRequire("aXKmr");

var $ehjs8 = parcelRequire("ehjs8");

var $k04JP = parcelRequire("k04JP");

var $kQnVX = parcelRequire("kQnVX");

var $ioEQd = parcelRequire("ioEQd");
const $3b47e664c8b4a4ba$export$7bd623b29ec8e1eb = 10000;
const $3b47e664c8b4a4ba$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $k04JP.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $ehjs8.default)(nextRouteUfoName, nextRouteName);
        (0, $ioEQd.GlobalPageLoadExperience).abort({
            force: true
        });
        (0, $ioEQd.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, $aXKmr.v4)(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $3b47e664c8b4a4ba$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $3b47e664c8b4a4ba$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($3b47e664c8b4a4ba$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $3b47e664c8b4a4ba$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($3b47e664c8b4a4ba$export$8a98548dad2fa97b(appId));
            }, $3b47e664c8b4a4ba$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $kQnVX.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $3b47e664c8b4a4ba$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($3b47e664c8b4a4ba$export$9d528722f2ff2999(appId, startTime));
    };
const $3b47e664c8b4a4ba$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $3b47e664c8b4a4ba$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($3b47e664c8b4a4ba$export$6a25429a42d30f9a(appId, endTime));
    };
const $3b47e664c8b4a4ba$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $3b47e664c8b4a4ba$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});




parcelRegister("9DwQv", function(module, exports) {
$parcel$export(module.exports, "isAutomaticExposureCollectionEnabled", () => $deb32d3e51fbc689$export$cf2aaf3c58e46848);
// code-reaper-ignore - file is referenced as "browser" entry in package.json
const $deb32d3e51fbc689$export$c9c75778ebadb3f1 = ()=>100;
const $deb32d3e51fbc689$export$cf2aaf3c58e46848 = ()=>true;

});

const $f8c82f467f2e47ac$export$358721a9d6125914 = 'event-delay-controller.';
const $f8c82f467f2e47ac$export$b2122dce85a27912 = `${$f8c82f467f2e47ac$export$358721a9d6125914}start`;
const $f8c82f467f2e47ac$export$2d91d3eed1108e72 = `${$f8c82f467f2e47ac$export$358721a9d6125914}end`;


parcelRegister("gmwod", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e8864c72f1b6b21$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $1e8864c72f1b6b21$var$contextName = 'SpaApdexAnalytics';
var $1e8864c72f1b6b21$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.createContext)($1e8864c72f1b6b21$var$contextName);

});


parcelRegister("cH6Qf", function(module, exports) {
$parcel$export(module.exports, "SpaStateContainer", () => $eec9bea1c42e0a0c$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $eec9bea1c42e0a0c$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $eec9bea1c42e0a0c$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $eec9bea1c42e0a0c$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $eec9bea1c42e0a0c$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $eec9bea1c42e0a0c$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $eec9bea1c42e0a0c$export$6e9ab893e97cccef);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $14kUX = parcelRequire("14kUX");

var $912hm = parcelRequire("912hm");

var $79p6g = parcelRequire("79p6g");
const $eec9bea1c42e0a0c$export$e9a92b877fe80e80 = (0, $6E16M.createContainer)((0, $79p6g.default));
const $eec9bea1c42e0a0c$export$d18dd27183a635c = ()=>{
    const startRef = (0, $eJOHy.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $912hm.useSpaState)();
    (0, $eJOHy.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $eec9bea1c42e0a0c$var$useRouterMatchSelector = (0, $kfvK2.createRouterSelector)((state)=>state.match);
const $eec9bea1c42e0a0c$var$useSpaStatePagesCount = (0, $iJq0l.createHook)((0, $79p6g.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $eec9bea1c42e0a0c$export$95a2912d76fb5433 = ()=>{
    const match = $eec9bea1c42e0a0c$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $eec9bea1c42e0a0c$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eec9bea1c42e0a0c$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
function $eec9bea1c42e0a0c$export$c34439f945fccbdf() {
    const { setAppReady: setAppReady } = (0, $912hm.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady
    ]);
    return null;
}
function $eec9bea1c42e0a0c$export$41e70078eeddaddc({ updateKey: updateKey }) {
    const { setAppReady: setAppReady } = (0, $912hm.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady,
        updateKey
    ]);
    return null;
}
function $eec9bea1c42e0a0c$export$2583aa269898885c() {
    const { setAppErrorReady: setAppErrorReady } = (0, $912hm.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppErrorReady();
    }, [
        setAppErrorReady
    ]);
    return null;
}
class $eec9bea1c42e0a0c$export$ada7e0ec445851a2 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $eec9bea1c42e0a0c$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $14kUX.defaultRegistry).getStore((0, $79p6g.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});
parcelRegister("912hm", function(module, exports) {
$parcel$export(module.exports, "useSpaState", () => $23ca96cffdec610f$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $23ca96cffdec610f$export$b134752525935b78);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $79p6g = parcelRequire("79p6g");
const $23ca96cffdec610f$export$a57865516f6345d1 = (0, $iJq0l.createHook)((0, $79p6g.default));
const $23ca96cffdec610f$export$b134752525935b78 = (0, $iJq0l.createActionsHook)((0, $79p6g.default));

});


parcelRegister("lq8Ki", function(module, exports) {
$parcel$export(module.exports, "ReportSSRFailOnUse", () => $3331f614e25114ce$export$daa3f09a96683b19);
$parcel$export(module.exports, "DisableSSRFailDetection", () => $3331f614e25114ce$export$420f5a45dbda6a67);

var $eJOHy = parcelRequire("eJOHy");

var $78v8Z = parcelRequire("78v8Z");

var $kfvK2 = parcelRequire("kfvK2");

var $7IhkX = parcelRequire("7IhkX");

var $ft2u5 = parcelRequire("ft2u5");

var $04sNQ = parcelRequire("04sNQ");
const $3331f614e25114ce$export$c35f8a10548d98f7 = (0, $kfvK2.createRouterSelector)((state)=>state.route?.bifrost?.circuitBreakerConfig);
const $3331f614e25114ce$export$daa3f09a96683b19 = ({ ignoreWhenCircuitOpen: ignoreWhenCircuitOpen, pageId: pageId, UNSAFE__forceReporting: UNSAFE__forceReporting = false, reportToSlackChannel: reportToSlackChannel, fallbackId: fallbackId, displayErrorInStaging: displayErrorInStaging })=>{
    const circuitBreakerConfig = $3331f614e25114ce$export$c35f8a10548d98f7();
    const isCircuitOpenValue = (0, $78v8Z.isCircuitOpen)(circuitBreakerConfig);
    const isCookieCircuitBreakerOpen = ignoreWhenCircuitOpen && isCircuitOpenValue && circuitBreakerConfig?.isBailoutEnabled;
    const isIgnored = !(0, $7IhkX.getIsTrackingEnabled)() || isCookieCircuitBreakerOpen;
    const shouldReport = (0, $eJOHy.useContext)((0, $04sNQ.detectionBoundary)) || UNSAFE__forceReporting;
    (0, $eJOHy.useMemo)(()=>{
        if (!false) // This component only reports in SSR
        return;
        // do not report when cb is open and this failure is to do with the resources not being loaded.
        // However, still show circuit breaker message when appropriate
        if (isIgnored) return;
        if (shouldReport) {
            // eslint-disable-next-line no-console
            console.error({
                error: `SSR ended rendering a fallback (${fallbackId}) on page ${pageId}`,
                message: 'Top level suspense boundary was triggered. This is not expected to happen',
                pageId: pageId
            });
            (0, $7IhkX.markSSRFailure)(fallbackId);
        } else // eslint-disable-next-line no-console
        console.warn(`SSR ended rendering a non-top-level fallback (${fallbackId}) on page ${pageId}`);
    }, [
        isIgnored,
        shouldReport,
        fallbackId,
        pageId
    ]);
    if (isIgnored && !isCookieCircuitBreakerOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ft2u5.FallbackIndicator), {
        reportToSlackChannel: reportToSlackChannel,
        fallbackId: fallbackId,
        displayErrorInStaging: displayErrorInStaging,
        isCookieCircuitBreakerFailure: isCookieCircuitBreakerOpen,
        cookieKey: circuitBreakerConfig?.cookieKey
    });
};
const $3331f614e25114ce$export$420f5a45dbda6a67 = ({ children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04sNQ.detectionBoundary).Provider, {
        value: false
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});
parcelRegister("78v8Z", function(module, exports) {
$parcel$export(module.exports, "isCircuitOpen", () => $ffcc5ff187e41f8d$export$f528a0ba25e4d432);

var $7Gk5a = parcelRequire("7Gk5a");
function $ffcc5ff187e41f8d$export$f528a0ba25e4d432(config) {
    // circuit will never be open if isSetCookieEnabled is false
    if (config?.isSetCookieEnabled) {
        const circuitBreaker = (0, $7Gk5a.getCookieCircuitBreaker)(config);
        return circuitBreaker?.getState().state === 'OPEN';
    }
    return false;
}

});
parcelRegister("7Gk5a", function(module, exports) {
$parcel$export(module.exports, "getCookieCircuitBreaker", () => $6d9b2bad37f895af$export$c696b1ba9d4ab97);

var $1qiFJ = parcelRequire("1qiFJ");
let $6d9b2bad37f895af$var$circuitBreaker;
function $6d9b2bad37f895af$export$c696b1ba9d4ab97(config) {
    if (config?.isSetCookieEnabled) {
        if ($6d9b2bad37f895af$var$circuitBreaker) return $6d9b2bad37f895af$var$circuitBreaker;
        $6d9b2bad37f895af$var$circuitBreaker = new (0, $1qiFJ.CookieCircuitBreaker)(config);
        return $6d9b2bad37f895af$var$circuitBreaker;
    }
}

});
parcelRegister("1qiFJ", function(module, exports) {
$parcel$export(module.exports, "CookieCircuitBreaker", () => $d2456453978d83d0$export$e15350ade5fb9457);

var $aqhop = parcelRequire("aqhop");
var $5Qndl = parcelRequire("5Qndl");

var $9YRcI = parcelRequire("9YRcI");
class $d2456453978d83d0$export$e15350ade5fb9457 {
    constructor({ cookieKey: cookieKey, windowSize: windowSize = 15, threshold: threshold = 0.1, keepOpenCount: keepOpenCount = 100, halfOpenForCount: halfOpenForCount = 10, version: // version is only required when setting the cookie (i.e client side)
    version = 0 }){
        this.cookieKey = cookieKey;
        this.windowSize = windowSize > 29 ? 29 : windowSize;
        // eslint-disable-next-line no-bitwise
        this.windowMask = (1 << this.windowSize) - 1;
        this.threshold = threshold;
        this.halfOpenForCount = halfOpenForCount;
        this.keepOpenCount = keepOpenCount;
        this.version = version;
        const existingCookie = (0, $9YRcI.getCookie)(`cb_${cookieKey}`, true);
        if (existingCookie) this.cookieData = this.parseCookieData(existingCookie);
        else this.cookieData = {
            numberRepresentation: 0,
            counter: 0,
            windowLength: 0,
            version: version
        };
    }
    parseCookieData(cookieValue) {
        try {
            const [encodedWindow, stringWindowLength, stringCount, stringVersion] = cookieValue.split('|');
            const parsedNumberRepresentation = Number.parseInt(encodedWindow ?? '', 36);
            const numberRepresentation = !Number.isNaN(parsedNumberRepresentation) ? parsedNumberRepresentation : 0;
            const parsedCounter = Number.parseInt(stringCount ?? '', 36);
            const counter = !Number.isNaN(parsedCounter) ? parsedCounter : 0;
            const parsedWindowLength = Number.parseInt(stringWindowLength ?? '', 36);
            const windowLength = !Number.isNaN(parsedWindowLength) ? parsedWindowLength : 0;
            const parsedVersion = Number.parseInt(stringVersion ?? '', 36);
            const version = !Number.isNaN(parsedVersion) ? parsedVersion : 0;
            return {
                numberRepresentation: numberRepresentation,
                counter: counter,
                windowLength: windowLength,
                version: version
            };
        } catch (error) {
            // Return default data if parsing fails
            return {
                numberRepresentation: 0,
                counter: 0,
                windowLength: 0,
                version: this.version
            };
        }
    }
    serializeForCookie() {
        const encodedWindow = this.cookieData.numberRepresentation.toString(36);
        const stringCount = this.cookieData.counter.toString(36);
        const windowLength = this.cookieData.windowLength.toString(36);
        const version = this.cookieData.version.toString(36);
        return `${encodedWindow}|${windowLength}|${stringCount}|${version}`;
    }
    saveToCookie() {
        (0, $5Qndl.setStrictlyNecessaryCookie)(`cb_${this.cookieKey}`, this.serializeForCookie(), {
            expires: 14,
            secure: true,
            sameSite: 'strict'
        });
    }
    resetCookieIfVersionMismatch() {
        if (this.cookieData.version !== this.version) {
            (0, $aqhop.deleteCookie)(`cb_${this.cookieKey}`);
            this.cookieData = {
                numberRepresentation: 0,
                counter: 0,
                windowLength: 0,
                version: this.version
            };
            return true;
        }
        return false;
    }
    addResultToWindow(result) {
        // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation <<= 1; // Shift left by 1
        /**
		 * For PASS, we bitwise OR with 1 to "add" 1 to the least-significant bit
		 * For FAIL, we bitwise OR with 0 which will be no-op - the LSB will already be 0 after the shift left above
		 */ // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation |= result === 'PASS' ? 1 : 0;
        /**
		 * Truncate to the window size using bitwise AND
		 *
		 * This is the equivalent operation to this (if it was an array):
		 *
		 * ```
		 * if (numberRepresentationAsArray.length > this.windowSize) {
		 * 	   // in this analogy, the end of the array is the most significant bit.
		 *     numberRepresentationAsArray.pop();
		 * }
		 * ```
		 */ // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation &= this.windowMask;
        /**
		 * Only increase the windowLength if it is under the windowSize
		 *
		 * We don't increase when it is equal because the truncation we just did above
		 * will keep it at windowLength = windowSize.
		 *
		 * We need to keep track of windowLength separately because we cannot derive it
		 * from the numberRepresentation when the oldest value in the window is 0.
		 * i.e the numeric representation of 00000001 is the same as 1 - but they have a different
		 * meaning here.
		 */ if (this.cookieData.windowLength < this.windowSize) this.cookieData.windowLength++;
        else this.cookieData.windowLength = this.windowSize;
    }
    incrementOrResetOpenCounter() {
        if (this.cookieData.counter >= this.keepOpenCount + this.halfOpenForCount) this.cookieData.counter = 0;
        else this.cookieData.counter++;
    }
    recordFailure() {
        return this.recordResult('FAIL');
    }
    recordPass() {
        return this.recordResult('PASS');
    }
    recordResult(result) {
        const state = this.getState();
        switch(state.state){
            case 'CLOSED':
                this.addResultToWindow(result);
                // reset the counter when circuit is closed
                this.cookieData.counter = 0;
                break;
            case 'OPEN':
                this.cookieData.counter++;
                break;
            case 'HALF_OPEN':
                this.incrementOrResetOpenCounter();
                this.addResultToWindow(result);
                break;
            default:
                throw new Error(`Unknown state: ${state}`);
        }
        this.saveToCookie();
        return state;
    }
    getWindowSize() {
        return this.windowSize;
    }
    getKey() {
        return this.cookieKey;
    }
    isAtWindowSize() {
        return this.cookieData.windowLength === this.windowSize;
    }
    getState() {
        /**
		 * To count the number of passes, we convert the number to a base 2 string and count the number of 1s.
		 *
		 * This is a simple way of doing it, and should be pretty quick because it uses a regexp literal
		 * it is only called once per page load regardless.
		 */ const onesAndZeroes = this.cookieData.numberRepresentation.toString(2);
        const pass = onesAndZeroes.match(/1/g)?.length ?? 0;
        const fail = this.cookieData.windowLength - pass;
        const ratio = this.cookieData.windowLength > 0 ? pass / this.cookieData.windowLength : 1;
        let state = 'CLOSED';
        if (this.isAtWindowSize() && ratio < 1 - this.threshold) {
            if (this.cookieData.counter > this.keepOpenCount && this.cookieData.counter <= this.keepOpenCount + this.halfOpenForCount) state = 'HALF_OPEN';
            else state = 'OPEN';
        }
        return {
            state: state,
            pass: pass,
            fail: fail,
            ratio: ratio,
            count: this.cookieData.counter,
            version: this.cookieData.version
        };
    }
}

});
parcelRegister("aqhop", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $0925738c9927a3a5$export$b43e45590305ffaa);

var $5H4WP = parcelRequire("5H4WP");

var $eGOwo = parcelRequire("eGOwo");

var $lgusX = parcelRequire("lgusX");

var $60vYG = parcelRequire("60vYG");
const $0925738c9927a3a5$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).remove(key, attributes);
    else try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).remove(key, attributes);
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});




parcelRegister("04sNQ", function(module, exports) {
$parcel$export(module.exports, "detectionBoundary", () => $4610cbe4d71712b6$export$1b1634ba80d39e40);

var $eJOHy = parcelRequire("eJOHy");
const $4610cbe4d71712b6$export$1b1634ba80d39e40 = /*#__PURE__*/ (0, $eJOHy.createContext)(true);

});



parcelRegister("lOoQA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("kNFvF"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVX56"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("fliVL"),
    $ewTvA("j53wu")
]).then(()=>parcelRequire('5IVSD'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});





parcelRegister("kNuDg", function(module, exports) {
$parcel$export(module.exports, "browseIssueRouteEntry", () => $11c6470f77b6dcac$export$cef770e7c16cfcc);

var $gEIw2 = parcelRequire("gEIw2");

var $gjPI6 = parcelRequire("gjPI6");

var $3MgfG = parcelRequire("3MgfG");

var $R5dK3 = parcelRequire("R5dK3");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $kHlOR = parcelRequire("kHlOR");


var $grWOk = parcelRequire("grWOk");

var $4cTDP = parcelRequire("4cTDP");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");


var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4VIcO = parcelRequire("4VIcO");

var $dk4qA = parcelRequire("dk4qA");

var $lPVME = parcelRequire("lPVME");

var $9NmsS = parcelRequire("9NmsS");

var $5N1SB = parcelRequire("5N1SB");

var $dZRaT = parcelRequire("dZRaT");

var $aGQ56 = parcelRequire("aGQ56");

var $esUDP = parcelRequire("esUDP");

var $iBSnt = parcelRequire("iBSnt");

var $ePaI2 = parcelRequire("ePaI2");

var $5nfTh = parcelRequire("5nfTh");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $W6cJS = parcelRequire("W6cJS");

var $5fjzQ = parcelRequire("5fjzQ");

var $5DQfo = parcelRequire("5DQfo");

var $g8uYY = parcelRequire("g8uYY");

var $gg7cq = parcelRequire("gg7cq");

var $jIhkm = parcelRequire("jIhkm");

var $dQc7D = parcelRequire("dQc7D");

var $1FbOO = parcelRequire("1FbOO");

var $38U18 = parcelRequire("38U18");
const $11c6470f77b6dcac$var$resourcesOld = ()=>[
        ...(0, $9NmsS.getNavigationResources)({
            isUsingSidebarEntrypoint: (0, $4cTDP.fg)('move-issue-view-to-entrypoint')
        }),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dZRaT.projectContextResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $5N1SB.getOfferingCatalogueFeaturesResource)(),
        (0, $lPVME.issueGiraDataResource),
        (0, $dk4qA.issueViewRelayResource),
        (0, $aGQ56.queuesNavigationItems),
        (0, $ePaI2.workspaceResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        ...(0, $5nfTh.getAIContextPanelResources)(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-twc-spotlight-tour-ssr'), (0, $5fjzQ.postOfficeJiraIssueViewTwcSpotlightTourResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('support-getting-customization-using-issue-key'), (0, $esUDP.jsmProjectMenuContentSidebarResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jiv-21223_issue_view_remote_data_query_earlier'), (0, $1FbOO.issueViewRemoteDataResource))
    ];
// jfp-magma-3491-reorder-issue-view-route-resources - These resources have been re-ordered. We have a theory that moving the more expensive ones to be first in the list makes them faster in SSR, there some small overhead that compounds over the 30 odd requests that happens.
// Longest poles at the moment are issueViewRelayResource and issueGiraDataResource, so we have moved them to the top of the list.
const $11c6470f77b6dcac$var$resourcesNew = ()=>[
        (0, $dk4qA.issueViewRelayResource),
        (0, $lPVME.issueGiraDataResource),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        ...(0, $9NmsS.getNavigationResources)({
            isUsingSidebarEntrypoint: (0, $4cTDP.fg)('move-issue-view-to-entrypoint')
        }),
        (0, $dZRaT.projectContextResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        ...(0, $5N1SB.getOfferingCatalogueFeaturesResource)(),
        (0, $aGQ56.queuesNavigationItems),
        (0, $ePaI2.workspaceResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        ...(0, $5nfTh.getAIContextPanelResources)(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('magma-3869-jsm-issue-view-sla-panel-fixes'), (0, $W6cJS.getJsmIssueViewSlaPanelResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('clefairy-12-move-knowledge-base-to-ssr'), (0, $W6cJS.getJsmIssueViewRelatedArticlesResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $jIhkm.issueCollapsibleGroupDataResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ken-3458-jira-hide-empty-field-ssr-fix'), (0, $dQc7D.issueHideEmptyFieldsDataResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-twc-spotlight-tour-ssr'), (0, $5fjzQ.postOfficeJiraIssueViewTwcSpotlightTourResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('support-getting-customization-using-issue-key'), (0, $esUDP.jsmProjectMenuContentSidebarResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jiv-21223_issue_view_remote_data_query_earlier'), (0, $1FbOO.issueViewRemoteDataResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-3p-attachments'), (0, $gEIw2.thirdPartyConnectedDataSourceResource))
    ];
const $11c6470f77b6dcac$var$entrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gg7cq.issueViewEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $11c6470f77b6dcac$export$cef770e7c16cfcc = (0, $6xToB.createEntry)((0, $iBSnt.browseIssueRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        isHydrateRootEnabled: (0, $4cTDP.fg)('jfp-magma-issue-view-full-page-hydrate-root'),
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $4cTDP.fg)('move-issue-view-to-entrypoint') ? undefined : (0, $38U18.IssueComponent),
        skeleton: (0, $R5dK3.IssueViewSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.fullPageIssuePreloadLayout)),
        navigation: {
            sidebar: (0, $aDtWM.genericProjectSidebars),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebarId: (0, $4cTDP.fg)('move-issue-view-to-entrypoint') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined,
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: (0, $4cTDP.fg)('jfp-magma-3491-reorder-issue-view-route-resources') ? $11c6470f77b6dcac$var$resourcesNew() : $11c6470f77b6dcac$var$resourcesOld(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $38U18.LazyIssuePage)
        ],
        ufoName: 'issue-view',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueRouteEntry.tsx',
                whichExportToUse: 'browseIssueRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json',
            circuitBreakerConfig: (0, $gjPI6.getIssueCircuitBreaker)()
        },
        supportsPreviewPanel: true,
        entryPoint: (0, $4cTDP.fg)('move-issue-view-to-entrypoint') ? ()=>$11c6470f77b6dcac$var$entrypoint : undefined,
        entryPointOptions: (0, $4cTDP.fg)('jfp-magma-concurrent-entrypoint-router-metric-fix') ? {
            isSSRPlaceholderEnabled: true
        } : undefined
    }));

});
parcelRegister("gjPI6", function(module, exports) {
$parcel$export(module.exports, "getIssueCircuitBreaker", () => $8c97ff53c8b2531a$export$96348e7c42d52e4a);

var $cxKOj = parcelRequire("cxKOj");

var $7oY9g = parcelRequire("7oY9g");
function $8c97ff53c8b2531a$export$96348e7c42d52e4a() {
    return {
        isSetCookieEnabled: true,
        isMonitoringEnabled: true,
        isBailoutEnabled: !(0, $7oY9g.default)('issue-view-cookie-cb'),
        cookieKey: 'iss',
        windowSize: (0, $cxKOj.expVal)('jfp-magma-ssr-cookie-cb-optimisation', 'windowSize', 5),
        threshold: (0, $cxKOj.expVal)('jfp-magma-ssr-cookie-cb-optimisation', 'threshold', 0.3),
        keepOpenCount: (0, $cxKOj.expVal)('jfp-magma-ssr-cookie-cb-optimisation', 'keepOpenCount', 50),
        halfOpenForCount: (0, $cxKOj.expVal)('jfp-magma-ssr-cookie-cb-optimisation', 'halfOpenForCount', 5)
    };
}

});

parcelRegister("3MgfG", function(module, exports) {
$parcel$export(module.exports, "userSegRedirectEntrypoint", () => $72de4643a6a365ca$export$6d4ea918c982d275);

var $bhnBu = parcelRequire("bhnBu");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $72de4643a6a365ca$var$fetchPolicy = 'store-or-network';

const $72de4643a6a365ca$export$6d4ea918c982d275 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eFV5W")), {
        moduleId: "15389eb1",
        moduleName: "UserSegmentationRedirectEntry",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                userSegQueryRef: {
                    parameters: (0, $bhnBu.default),
                    variables: {
                        accountId: tenantContext.atlassianAccountId || '',
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: $72de4643a6a365ca$var$fetchPolicy
                    }
                }
            }
        })
});

});
parcelRegister("bhnBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $db7724a775c38112$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916730509a2c791ccf785e4193581425>>
 * @relayHash d91677b6bdf2827b223e02fa48634538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134
const $db7724a775c38112$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134",
        "metadata": {},
        "name": "UserSegmentationRedirectEntryQuery",
        "operationKind": "query",
        "text": null
    }
};
var $db7724a775c38112$export$2e2bcd8739ae039 = $db7724a775c38112$var$node;

});

parcelRegister("hu2rE", function(module, exports) {
$parcel$export(module.exports, "JSResourceForUserVisible", () => $da03f6095fd9183e$export$58f934f3d33a84b6);

var $8MX4m = parcelRequire("8MX4m");

var $jkRyu = parcelRequire("jkRyu");

var $dsHGc = parcelRequire("dsHGc");
const $da03f6095fd9183e$var$cache = (0, $8MX4m.createCache)(new Map());
function $da03f6095fd9183e$export$58f934f3d33a84b6(loader, opts) {
    return $da03f6095fd9183e$var$cache.get(opts.moduleId, ()=>(0, $jkRyu.PreloadableJSResource)(()=>(0, $dsHGc.postTask)(loader, {
                priority: 'user-blocking'
            }), opts));
}

});

parcelRegister("eFV5W", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aEZEj").then(()=>parcelRequire('eYFK8'));

});


parcelRegister("lixcc", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarContentCoreEntryPoint", () => $7fe0cfb4720033ae$export$c5a39ebd1638fa7);

var $bBIDB = parcelRequire("bBIDB");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $bBtQo = parcelRequire("bBtQo");

const $7fe0cfb4720033ae$export$c5a39ebd1638fa7 = (0, $3Bzqe.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("iIXZF"))).then(({ SidebarContentForEntryPoint: SidebarContentForEntryPoint })=>SidebarContentForEntryPoint), {
        moduleId: "4c2c284d",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    // Result matches the generics of the async component's EntryPointProps
    // except for TComponentProps which is derived from `root`
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps (params) {
        const { context: context, tenantContext: tenantContext, entryPoints: entryPoints = {}, isAppsExpanded: isAppsExpanded, isFiltersExpanded: isFiltersExpanded, isPlansExpanded: isPlansExpanded, isProjectsExpanded: isProjectsExpanded, isOperationsExpanded: isOperationsExpanded, isOverviewsExpanded: isOverviewsExpanded } = params;
        // The two parameters have been injected by the theme setter, and should
        // not be here. Setting them naively just to be able to use the sidebar entryPoint again.
        const projectAri = '';
        let projectKey = '';
        if (context.match.params?.projectKey) projectKey = context.match.params.projectKey;
        else if (context.match.params?.issueKey && (0, $4cTDP.fg)('move-issue-view-to-entrypoint')) projectKey = (0, $bBtQo.getProjectKey)(context.match, context.query);
        return {
            // Queries your async component uses
            queries: {
                nav4SidebarContentCore: {
                    // generated .graphql
                    parameters: (0, $bBIDB.default),
                    // variables for your query
                    variables: {
                        cloudId: tenantContext.cloudId,
                        isAppsExpanded: isAppsExpanded,
                        isFiltersExpanded: isFiltersExpanded,
                        isPlansExpanded: isPlansExpanded,
                        isProjectsExpanded: isProjectsExpanded,
                        isOperationsExpanded: isOperationsExpanded,
                        isOverviewsExpanded: isOverviewsExpanded,
                        projectAri: projectAri,
                        projectKey: projectKey,
                        entityAriProjects: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/projects`,
                        ownerAri: tenantContext.atlassianAccountId && `ari:cloud:identity::user/${tenantContext.atlassianAccountId}`,
                        isAnonymous: tenantContext.isAnonymous
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: entryPoints
        };
    }
});

});
parcelRegister("iIXZF", function(module, exports) {
$parcel$export(module.exports, "SidebarContent", () => $3a09b90cb30ff0be$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "SidebarContentForEntryPoint", () => $3a09b90cb30ff0be$export$ece6bd06aa8b2350);

var $eJOHy = parcelRequire("eJOHy");

var $7tCmu = parcelRequire("7tCmu");

var $2dvSy = parcelRequire("2dvSy");

var $85fS3 = parcelRequire("85fS3");

var $5vQ2T = parcelRequire("5vQ2T");

var $43SpR = parcelRequire("43SpR");

var $8IuE5 = parcelRequire("8IuE5");

var $hyK5y = parcelRequire("hyK5y");

var $eL2Ux = parcelRequire("eL2Ux");

var $2imLM = parcelRequire("2imLM");

var $9FYIg = parcelRequire("9FYIg");

var $kh7bJ = parcelRequire("kh7bJ");

var $4EKqI = parcelRequire("4EKqI");

var $gCY1z = parcelRequire("gCY1z");

var $24QYf = parcelRequire("24QYf");

var $5IAcG = parcelRequire("5IAcG");
const $3a09b90cb30ff0be$export$49e8f7b58a4df4ea = ()=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $43SpR.sidebarNav4Resource));
    const queryReferenceRef = (0, $eJOHy.useRef)(null);
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a09b90cb30ff0be$export$57e04c8c2365ae3b, null);
    // We don't want to use null query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a09b90cb30ff0be$export$a18798f247d81ed3, {
        queryReference: queryReferenceRef.current
    });
};
function $3a09b90cb30ff0be$export$ece6bd06aa8b2350({ queries: { nav4SidebarContentCore: nav4SidebarContentCore } }) {
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a09b90cb30ff0be$export$57e04c8c2365ae3b, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a09b90cb30ff0be$export$a18798f247d81ed3, {
        queryReference: nav4SidebarContentCore
    });
}
function $3a09b90cb30ff0be$export$a18798f247d81ed3({ queryReference: queryReference }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "l1-nav-menu-items",
        packageName: (0, $24QYf.PACKAGE_NAME),
        teamName: (0, $24QYf.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tCmu.SideNavContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "l1-nav-menu-items",
        fallback: null
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IAcG.L1MenuItems), {
        queryReference: queryReference
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hyK5y.SidebarReady), null)));
}
function $3a09b90cb30ff0be$export$57e04c8c2365ae3b() {
    const { formattedMessage: projectsMessage, icon: projectsIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PROJECTS);
    const { formattedMessage: dashboardsMessage, icon: dashboardsIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).DASHBOARDS);
    const { formattedMessage: filtersMessage, icon: filtersIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).FILTERS);
    // We want to remove useRouter but the anonymous path is not as urgent as the authenticated path
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "l1-nav-menu-items",
        packageName: (0, $24QYf.PACKAGE_NAME),
        teamName: (0, $24QYf.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tCmu.SideNavContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "l1-nav-menu-items",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        elemBefore: projectsIcon,
        href: "/jira/projects",
        isSelected: match.path.startsWith('/jira/projects')
    }, projectsMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        elemBefore: filtersIcon,
        href: "/jira/filters",
        isSelected: match.path === '/jira/filters' || match.path.startsWith('/issues/')
    }, filtersMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        elemBefore: dashboardsIcon,
        href: "/jira/dashboards",
        isSelected: match.path.startsWith('/jira/dashboards')
    }, dashboardsMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hyK5y.SidebarReady), null));
}

});
parcelRegister("7tCmu", function(module, exports) {
$parcel$export(module.exports, "SideNavContent", () => $10bc4bf375dc5af7$export$babe3c784778f3ba);
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gyJTO = parcelRequire("gyJTO");

var $eGOwo = parcelRequire("eGOwo");
const $10bc4bf375dc5af7$export$babe3c784778f3ba = /*#__PURE__*/ (0, $eJOHy.forwardRef)($10bc4bf375dc5af7$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
const $10bc4bf375dc5af7$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp"
};
/**
 * Using CSS scroll-driven animations to apply a scrolled indicator border.
 *
 * This approach is better for SSR, as some apps like Confluence will apply the
 * initial scroll position of the side nav content using JS before hydration.
 *
 * If we applied the border through React state it would only appear after hydration,
 * whereas this CSS approach should show even before hydration.
 */ const $10bc4bf375dc5af7$var$scrolledBorder = null;
const $10bc4bf375dc5af7$var$scrollTimelineVar = '--sNcst';
const $10bc4bf375dc5af7$var$fullHeightSidebarStyles = {
    scrollContainer: "_1un9baqb _21o1gc9s _j7hq98ya"
};
function $10bc4bf375dc5af7$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRef = (0, $eJOHy.useMemo)(()=>(0, $gyJTO.default)([
            internalRef,
            forwardedRef
        ]), [
        forwardedRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: (0, $eGOwo.fg)('navx-full-height-sidebar') ? mergedRef : forwardedRef,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $10bc4bf375dc5af7$var$styles.scrollContainer,
            (0, $eGOwo.fg)('navx-full-height-sidebar') && $10bc4bf375dc5af7$var$fullHeightSidebarStyles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                $10bc4bf375dc5af7$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});

parcelRegister("2dvSy", function(module, exports) {
$parcel$export(module.exports, "LinkMenuItem", () => $8915a16da7f35027$export$d2cad7a1cce7b35f);
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $immLL = parcelRequire("immLL");

var $gyJTO = parcelRequire("gyJTO");

var $4sCzd = parcelRequire("4sCzd");

var $2tKAE = parcelRequire("2tKAE");

var $eekOJ = parcelRequire("eekOJ");
const $8915a16da7f35027$var$listItemStyles = {
    root: "_10m98stt"
};
const $8915a16da7f35027$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $eJOHy.useRef)(null);
    (0, $eekOJ.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $eJOHy.useMemo)(()=>{
        return (0, $gyJTO.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sCzd.ListItem), {
        ref: ref,
        xcss: $8915a16da7f35027$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKAE.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $8915a16da7f35027$export$d2cad7a1cce7b35f = (0, $immLL.default)($8915a16da7f35027$var$LinkMenuItemNoRef);

});
parcelRegister("2tKAE", function(module, exports) {
$parcel$export(module.exports, "MenuItemBase", () => $f3ea94f8b9659885$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $l8fMV = parcelRequire("l8fMV");

var $immLL = parcelRequire("immLL");

var $gyJTO = parcelRequire("gyJTO");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");
var $46R8N = parcelRequire("46R8N");
var $3cMgR = parcelRequire("3cMgR");

var $k71qx = parcelRequire("k71qx");
var $7AseU = parcelRequire("7AseU");


var $yFG6a = parcelRequire("yFG6a");

var $1C3j7 = parcelRequire("1C3j7");

var $kbcF8 = parcelRequire("kbcF8");

// Using `lazy` so that only consumers who want drag and drop
// need to include code for the drag handle.
const $f3ea94f8b9659885$var$LazyDragHandle = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e1A1g")));
const $f3ea94f8b9659885$var$tooltipStyles = {
    root: "_2rko12b0 _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const $f3ea94f8b9659885$var$MenuItemTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7AseU.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $f3ea94f8b9659885$var$tooltipStyles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        children: children
    });
});
function $f3ea94f8b9659885$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $f3ea94f8b9659885$var$defaultAvatarValues = {
    size: 'small'
};
const $f3ea94f8b9659885$var$elemAfterDisplayVar = '--elem-after-display';
const $f3ea94f8b9659885$var$actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
const $f3ea94f8b9659885$var$actionsOnHoverWidthVar = '--actions-on-hover-width';
const $f3ea94f8b9659885$var$actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
const $f3ea94f8b9659885$var$notchColorVar = '--notch-color';
// Note: this is also used in `drag-handle.tsx`
const $f3ea94f8b9659885$var$dragHandleDisplayVar = '--drag-handle-display';
const $f3ea94f8b9659885$var$dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $f3ea94f8b9659885$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $f3ea94f8b9659885$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $f3ea94f8b9659885$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $f3ea94f8b9659885$var$containerStyles = {
    root: "_2rko12b0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syaz1gjq _1yyu3acm _91ju1txw _uomdidpf _pmxpidpf _db80idpf _qxq9kb7n _1rbv1wug _kwq51b66 _1swv108i _irr3108i _t7p8kb7n _g4kikb7n _91nl1wug _ynyi1wug _iy5o1b66 _v4o21b66",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_uomdkb7n _pmxp1wug _db801b66",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _bfhkn7od _irr3n7od _30l31lh4",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
const $f3ea94f8b9659885$var$buttonOrAnchorStyles = {
    root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk18uv _syaz1gjq _4cvr1h6o _y3gnv2br _14iu1ji5",
    selected: "_syazaqb7 _14iu19ru",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _11om6b4r _7psyru3m _1uy01amc _bir2q7pw"
};
const $f3ea94f8b9659885$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $f3ea94f8b9659885$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $f3ea94f8b9659885$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $f3ea94f8b9659885$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _tzy4pnc3 _1bsbty16 _y4tidria _1guo18uv _12s918uv"
};
const $f3ea94f8b9659885$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $f3ea94f8b9659885$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $f3ea94f8b9659885$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const $f3ea94f8b9659885$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $f3ea94f8b9659885$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ const $f3ea94f8b9659885$var$MenuItemBaseNoRef = ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $yFG6a.useLevel)();
    const setFlyoutMenuOpen = (0, $1C3j7.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $1C3j7.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $eJOHy.useRef)(null);
    const descriptionRef = (0, $eJOHy.useRef)(null);
    const tooltipOnClick = (0, $eJOHy.useRef)(null);
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $eJOHy.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $f3ea94f8b9659885$var$isTextClamped(label)) return true;
        return Boolean(description && $f3ea94f8b9659885$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $kbcF8.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            $f3ea94f8b9659885$var$interactiveContentStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                // This extends the clickable area of nested menu items to the width
                // of the root level menu items, while being visually indented.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                style: {
                    insetInlineStart: `calc(-1 * ${level} * ${(0, $51149c97989df8ee$export$d492445a79a49b48)})`
                },
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $f3ea94f8b9659885$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    $f3ea94f8b9659885$var$textStyles.root,
                    !showElemBefore && $f3ea94f8b9659885$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        weight: "medium",
                        maxLines: 1,
                        color: $f3ea94f8b9659885$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: description
                    })
                ]
            }),
            hasDragIndicator ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($f3ea94f8b9659885$var$LazyDragHandle, {})
            }) : null,
            dropIndicator
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l8fMV.AvatarContext).Provider, {
        value: $f3ea94f8b9659885$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $hcewu.default)([
                $f3ea94f8b9659885$var$containerStyles.root,
                isSelected && $f3ea94f8b9659885$var$containerStyles.selected,
                isDragging && $f3ea94f8b9659885$var$containerStyles.dragging,
                description && $f3ea94f8b9659885$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $f3ea94f8b9659885$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $f3ea94f8b9659885$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $f3ea94f8b9659885$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $f3ea94f8b9659885$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    children: children
                                }),
                                description ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    children: description
                                }) : null
                            ]
                        }),
                    position: (0, $eGOwo.fg)('platform_dst_side_nav_remove_custom_tooltip') ? 'right-start' : 'right',
                    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
                    component: (0, $eGOwo.fg)('platform_dst_side_nav_remove_custom_tooltip') ? undefined : $f3ea94f8b9659885$var$MenuItemTooltip,
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $gyJTO.default)([
                                forwardedRef,
                                tooltipProps.ref
                            ]),
                            id: id,
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lc0OY.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $k0ahr.cx)($f3ea94f8b9659885$var$buttonOrAnchorStyles.root, $f3ea94f8b9659885$var$topLevelSiblingStyles.root, isSelected && $f3ea94f8b9659885$var$buttonOrAnchorStyles.selected, hasDragIndicator && $f3ea94f8b9659885$var$buttonOrAnchorStyles.hasDragIndicator),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            /**
           * For anchors we don't want to have the standard drag and drop behaviour.
           *
           * Thinking on the topic:
           *
           * - Anchors look visually similar to buttons in the sidenav
           * - Why should some menu items be natively draggable, while others are not?
           * - A user cannot know which menu items are "natively" draggable (ie anchors)
           * - If you wire up an anchor to be draggable using our standard affordances
           *   it will have a different preview experience to native anchor dragging.
           *
           * To promote consistency, all elements need to use the same visual affordances.
           *
           * Anchor elements will automatically attach URL information
           * to the native data store.
           *
           * When `hasDragIndicator` is `true` we are expecting consumers to register
           * the element as draggable through the `draggable()` Pragmatic drag and drop function.
           * The `draggable()` function will add `draggable="true"` to the element.
           */ draggable: hasDragIndicator ? undefined : false,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $hcewu.default)([
                                        $f3ea94f8b9659885$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $k0ahr.cx)($f3ea94f8b9659885$var$buttonOrAnchorStyles.root, $f3ea94f8b9659885$var$topLevelSiblingStyles.root, isSelected && $f3ea94f8b9659885$var$buttonOrAnchorStyles.selected, hasDragIndicator && $f3ea94f8b9659885$var$buttonOrAnchorStyles.hasDragIndicator),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f3ea94f8b9659885$var$elemBeforeStyles.root,
                        $f3ea94f8b9659885$var$topLevelSiblingStyles.root,
                        $f3ea94f8b9659885$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f3ea94f8b9659885$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f3ea94f8b9659885$var$elemAfterStyles.root,
                        $f3ea94f8b9659885$var$topLevelSiblingStyles.root,
                        $f3ea94f8b9659885$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f3ea94f8b9659885$var$actionStyles.root,
                        $f3ea94f8b9659885$var$topLevelSiblingStyles.root,
                        $f3ea94f8b9659885$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};
const $f3ea94f8b9659885$export$859b390bf71e044e = (0, $immLL.default)($f3ea94f8b9659885$var$MenuItemBaseNoRef);

});
parcelRegister("l8fMV", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $db36d751aea51dd5$export$a20dad690e1279e2);
$parcel$export(module.exports, "useAvatarContext", () => $db36d751aea51dd5$export$b50b87a1c4086b23);
$parcel$export(module.exports, "AvatarContentContext", () => $db36d751aea51dd5$export$b983474ddd0b6d28);
$parcel$export(module.exports, "useAvatarContent", () => $db36d751aea51dd5$export$79d078b69b7e4842);
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $db36d751aea51dd5$export$6b4cbd90d24955ad);
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $db36d751aea51dd5$export$7db5c57474082dd9);

var $eJOHy = parcelRequire("eJOHy");
const $db36d751aea51dd5$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $db36d751aea51dd5$export$b50b87a1c4086b23 = ()=>(0, $eJOHy.useContext)($db36d751aea51dd5$export$a20dad690e1279e2);
const $db36d751aea51dd5$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $db36d751aea51dd5$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $eJOHy.createContext)($db36d751aea51dd5$var$defaultAvatarContentProps);
const $db36d751aea51dd5$export$79d078b69b7e4842 = ()=>(0, $eJOHy.useContext)($db36d751aea51dd5$export$b983474ddd0b6d28);
const $db36d751aea51dd5$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $db36d751aea51dd5$export$7db5c57474082dd9 = ()=>{
    const context = (0, $eJOHy.useContext)($db36d751aea51dd5$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});

/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $51149c97989df8ee$export$d492445a79a49b48 = '12px';

parcelRegister("yFG6a", function(module, exports) {
$parcel$export(module.exports, "AreAllAncestorsExpandedContext", () => $8ec41dd7e18c6b5c$export$9c01e0e6a504d553);
$parcel$export(module.exports, "IsExpandedContext", () => $8ec41dd7e18c6b5c$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $8ec41dd7e18c6b5c$export$48cb11cb8691f597);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $8ec41dd7e18c6b5c$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $8ec41dd7e18c6b5c$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $8ec41dd7e18c6b5c$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $8ec41dd7e18c6b5c$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useOnExpansionToggle", () => $8ec41dd7e18c6b5c$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $8ec41dd7e18c6b5c$export$fdfe9e5e8183d4f2);
$parcel$export(module.exports, "useAreAllAncestorsExpanded", () => $8ec41dd7e18c6b5c$export$57108b5f08ae5194);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $4vXRJ = parcelRequire("4vXRJ");
const $8ec41dd7e18c6b5c$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8ec41dd7e18c6b5c$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8ec41dd7e18c6b5c$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8ec41dd7e18c6b5c$export$572ce188c913ceba = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8ec41dd7e18c6b5c$export$650d12d3c2ddb8fc = (0, $4vXRJ.ExpandableMenuItemLevelContext);
const $8ec41dd7e18c6b5c$export$37e565a09598825e = ()=>{
    const context = (0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$c856e5885cc34d81);
    (0, $8GOss.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $8ec41dd7e18c6b5c$export$c9a171ea8de5861b = ()=>{
    const context = (0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$48cb11cb8691f597);
    (0, $8GOss.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $8ec41dd7e18c6b5c$export$56c8438498b72c7a = ()=>(0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$572ce188c913ceba);
const $8ec41dd7e18c6b5c$export$fdfe9e5e8183d4f2 = ()=>(0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$650d12d3c2ddb8fc);
const $8ec41dd7e18c6b5c$export$57108b5f08ae5194 = ()=>(0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$9c01e0e6a504d553) ?? true;

});
parcelRegister("4vXRJ", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemLevelContext", () => $38818bcdf3089c2e$export$f8d6463f9b5ca897);

var $eJOHy = parcelRequire("eJOHy");
const $38818bcdf3089c2e$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $eJOHy.createContext)(0);

});


parcelRegister("1C3j7", function(module, exports) {
$parcel$export(module.exports, "IsOpenContext", () => $c440e95460a477ac$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $c440e95460a477ac$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $c440e95460a477ac$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $c440e95460a477ac$export$538ac1aa421adb94);

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");
const $c440e95460a477ac$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $c440e95460a477ac$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $3Vuhz.default));
const $c440e95460a477ac$export$6927118f874a49aa = ()=>(0, $eJOHy.useContext)($c440e95460a477ac$export$efa4d9670e96ac31);
const $c440e95460a477ac$export$538ac1aa421adb94 = ()=>(0, $eJOHy.useContext)($c440e95460a477ac$export$4c55b1c61a116b42);

});

parcelRegister("kbcF8", function(module, exports) {
$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $693f3748e4f4c29a$export$f4b8e24fae579c6f);
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $693f3748e4f4c29a$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});

parcelRegister("e1A1g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4PYBD").then(()=>parcelRequire('1hwjy'));

});


parcelRegister("eekOJ", function(module, exports) {
$parcel$export(module.exports, "useScrollMenuItemIntoView", () => $4aac6b18583f3fd8$export$2c52ec851fcc6058);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $yFG6a = parcelRequire("yFG6a");
function $4aac6b18583f3fd8$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ if (typeof element.scrollIntoViewIfNeeded === 'function') {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4aac6b18583f3fd8$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $yFG6a.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $eJOHy.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $eJOHy.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $8GOss.default)(element, 'Element ref must be set');
            $4aac6b18583f3fd8$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});


parcelRegister("85fS3", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $d7024e53a2ac3b55$export$d4c4e98c5044dc8);

var $1CMu6 = parcelRequire("1CMu6");
const $d7024e53a2ac3b55$export$d4c4e98c5044dc8 = (0, $1CMu6.List);

});

parcelRegister("8IuE5", function(module, exports) {
$parcel$export(module.exports, "L1_MENU_ID", () => $63cd73d0cb684b2a$export$918aea3cf024d90b);

var $h4Bzb = parcelRequire("h4Bzb");
const $63cd73d0cb684b2a$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $63cd73d0cb684b2a$export$bb47524d7f3cb1f8 = {
    ...(0, $h4Bzb.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $63cd73d0cb684b2a$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $h4Bzb.CONFIGURABLE_MENU_ID),
    ...$63cd73d0cb684b2a$var$OPERATIONS_MENU_ID
};

});

parcelRegister("hyK5y", function(module, exports) {
$parcel$export(module.exports, "useSidebarExperience", () => $64b27843cfe69100$export$d4fa533dfe4d7583);
$parcel$export(module.exports, "SidebarStart", () => $64b27843cfe69100$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarReady", () => $64b27843cfe69100$export$a06ecbbe5820282);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $hih5V = parcelRequire("hih5V");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $5grHY = parcelRequire("5grHY");

var $eFrz1 = parcelRequire("eFrz1");
const $64b27843cfe69100$export$d4fa533dfe4d7583 = ()=>{
    const pageId = (0, $5grHY.usePageId)();
    return (0, $eJOHy.useMemo)(()=>({
            experience: 'viewSidebarNavigation',
            experienceId: pageId,
            analyticsSource: 'Sidebar',
            attributes: {
                sidebar: 'v4'
            }
        }), [
        pageId
    ]);
};
const $64b27843cfe69100$export$6738d1299dc79710 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $64b27843cfe69100$export$d4fa533dfe4d7583();
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource
    });
    (0, $eJOHy.useEffect)(()=>{
        if (route.isRedirect) return;
        onStartExperience();
    }, [
        onStartExperience,
        route
    ]);
    return null;
};
const $64b27843cfe69100$export$a06ecbbe5820282 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const { experience: experience, attributes: attributes } = $64b27843cfe69100$export$d4fa533dfe4d7583();
    const onSuccessfulExperience = (0, $4ctwv.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const doNotRunEffects = route.isRedirect || false;
    const sidebarId = route.navigation?.sidebarId ?? 'default';
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $kRgKj.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        doNotRunEffects,
        routeName
    ]);
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        onSuccessfulExperience();
    }, [
        doNotRunEffects,
        onSuccessfulExperience,
        route
    ]);
    const customData = (0, $eJOHy.useMemo)(()=>({
            sidebarType: sidebarId
        }), [
        sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
        data: customData
    });
};

});
parcelRegister("2gvG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbfbe10f2ed80f4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $bbfbe10f2ed80f4c$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    (0, $eJOHy.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $2QO3b.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $2QO3b.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("8Uqf3", function(module, exports) {
$parcel$export(module.exports, "useExperienceStart", () => $7363f384519bbd6b$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $7363f384519bbd6b$export$f20b867e738a222c);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $aSmR5 = parcelRequire("aSmR5");
const $7363f384519bbd6b$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $eJOHy.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $eJOHy.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $7363f384519bbd6b$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $7363f384519bbd6b$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $eJOHy.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});
parcelRegister("aSmR5", function(module, exports) {
$parcel$export(module.exports, "useExperienceContext", () => $9e8c86ec8261bcec$export$be8ec22ac9208049);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");
const $9e8c86ec8261bcec$export$be8ec22ac9208049 = ()=>{
    const context = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("4ctwv", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $b1bfd6142c0877bc$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $b1bfd6142c0877bc$export$4962f3898bd5c829);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $hWeHP = parcelRequire("hWeHP");

var $aSmR5 = parcelRequire("aSmR5");
const $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT = {};
const $b1bfd6142c0877bc$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const route = (0, $hih5V.useCurrentRoute)();
    const self = (0, $eJOHy.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $eJOHy.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        const shardAndRegionAttributes = {
            shard: (0, $hWeHP.default)('ajs-shard'),
            region: (0, $hWeHP.default)('ajs-region')
        };
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes
            }
        });
    }, [
        self
    ]);
};
const $b1bfd6142c0877bc$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $b1bfd6142c0877bc$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("5grHY", function(module, exports) {
$parcel$export(module.exports, "usePageId", () => $5b75ab0b351715e5$export$3434ba5eadb360dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $79p6g = parcelRequire("79p6g");
const $5b75ab0b351715e5$var$useSweetStatePageId = (0, $iJq0l.createHook)((0, $79p6g.default), {
    selector: (state)=>state.currentPage.uuid
});
const $5b75ab0b351715e5$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $5b75ab0b351715e5$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("eFrz1", function(module, exports) {
$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $a5e28192b76c8457$export$e44126cd87ea434);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $8GOss = parcelRequire("8GOss");
function $a5e28192b76c8457$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $eJOHy.useRef)(false);
    const depsRef = (0, $eJOHy.useRef)(dependencies);
    (0, $eJOHy.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $8GOss.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("eL2Ux", function(module, exports) {
$parcel$export(module.exports, "useConfigurableMessageAndIconMap", () => $513523b89184a8db$export$783a136280b37c09);
$parcel$export(module.exports, "getConfigurableMessageAndIcon", () => $513523b89184a8db$export$56ffc7f3df8fae03);

var $h4Bzb = parcelRequire("h4Bzb");

var $cxKOj = parcelRequire("cxKOj");

var $5Q9JR = parcelRequire("5Q9JR");

var $2QH3X = parcelRequire("2QH3X");
const $513523b89184a8db$export$783a136280b37c09 = (menuId)=>{
    const { message: message, Icon: Icon } = $513523b89184a8db$export$56ffc7f3df8fae03(menuId);
    return (0, $2QH3X.useFormattedMessageAndIcon)(message, Icon);
};
const $513523b89184a8db$export$56ffc7f3df8fae03 = (menuId)=>{
    const CONFIGURABLE_MESSAGE_AND_ICON_MAP = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Q9JR.CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM) : (0, $5Q9JR.CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM);
    const SPACES_MESSAGE_AND_ICON_MAP = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Q9JR.SPACES_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM) : (0, $5Q9JR.SPACES_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM);
    const { message: message, Icon: Icon } = menuId === (0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS && (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? SPACES_MESSAGE_AND_ICON_MAP : CONFIGURABLE_MESSAGE_AND_ICON_MAP[menuId];
    return {
        message: message,
        Icon: Icon
    };
};

});
parcelRegister("5Q9JR", function(module, exports) {
$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $15777f70405f0cfb$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $15777f70405f0cfb$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $15777f70405f0cfb$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM", () => $15777f70405f0cfb$export$9a6cc3b78524c807);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $15777f70405f0cfb$export$5034ad0032cd499d);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM", () => $15777f70405f0cfb$export$9c99028e1421f69f);
$parcel$export(module.exports, "SPACES_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM", () => $15777f70405f0cfb$export$e0063c8eec18df81);
$parcel$export(module.exports, "SPACES_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM", () => $15777f70405f0cfb$export$dbe1165a572764fa);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $15777f70405f0cfb$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $15777f70405f0cfb$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $15777f70405f0cfb$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $15777f70405f0cfb$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $15777f70405f0cfb$export$89de709e88232646);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $15777f70405f0cfb$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITHOUT_PROJECT_TERM", () => $15777f70405f0cfb$export$4da83c858d129f7f);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITH_PROJECT_TERM", () => $15777f70405f0cfb$export$a9a6fdcb59a8001e);

var $eJOHy = parcelRequire("eJOHy");

var $m9SlP = parcelRequire("m9SlP");

var $bGbhe = parcelRequire("bGbhe");

var $cYbWd = parcelRequire("cYbWd");

var $i5stJ = parcelRequire("i5stJ");

var $5SdQs = parcelRequire("5SdQs");

var $KDB2z = parcelRequire("KDB2z");

var $iBgxn = parcelRequire("iBgxn");

var $9qes7 = parcelRequire("9qes7");

var $3XKBx = parcelRequire("3XKBx");

var $gm7H7 = parcelRequire("gm7H7");

var $lgMTT = parcelRequire("lgMTT");

var $lmJ87 = parcelRequire("lmJ87");

var $3pQT5 = parcelRequire("3pQT5");

var $l5gdO = parcelRequire("l5gdO");

var $aaIe7 = parcelRequire("aaIe7");

var $eALjj = parcelRequire("eALjj");

var $gNUuP = parcelRequire("gNUuP");

var $h0FG3 = parcelRequire("h0FG3");

var $9mydb = parcelRequire("9mydb");

var $h4Bzb = parcelRequire("h4Bzb");

var $hEgdr = parcelRequire("hEgdr");

var $8IuE5 = parcelRequire("8IuE5");
const $15777f70405f0cfb$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $15777f70405f0cfb$export$d57b6b390e78d90f = 'jira-cosmos';
const $15777f70405f0cfb$export$47f3715a07cde7e8 = 250;
const $15777f70405f0cfb$export$421b92818c76ee2d = Object.values((0, $h4Bzb.CONFIGURABLE_MENU_ID));
const $15777f70405f0cfb$export$f5a7bd7eb586e4e8 = $15777f70405f0cfb$export$421b92818c76ee2d;
const $15777f70405f0cfb$export$c52c93cc28495ab0 = Object.values((0, $h4Bzb.GLOBAL_APP_MENU_ID));
const $15777f70405f0cfb$export$de634ec0f98ab74b = $15777f70405f0cfb$export$c52c93cc28495ab0;
const $15777f70405f0cfb$export$9a6cc3b78524c807 = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bGbhe)))
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9qes7)))
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($m9SlP)))
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l5gdO)))
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projectsGalaxia,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lmJ87)))
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z)))
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs)))
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBgxn)))
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9mydb)))
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cYbWd)))
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)))
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ)))
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3XKBx)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($h0FG3)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMERS]: {
        message: (0, $hEgdr.default).customers,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gm7H7)))
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.AssetsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.GoalsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    // App Shortcuts for Platform Component
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ConfluenceIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.LoomIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ProjectsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.TeamsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.OpsgenieIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "small"
            })
    }
};
const $15777f70405f0cfb$export$5034ad0032cd499d = {
    message: (0, $hEgdr.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNUuP)))
};
const $15777f70405f0cfb$export$9c99028e1421f69f = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bGbhe)))
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9qes7)))
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($m9SlP)))
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l5gdO)))
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lmJ87)))
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z)))
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs)))
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBgxn)))
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9mydb)))
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cYbWd)))
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)))
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ)))
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3XKBx)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($h0FG3)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMERS]: {
        message: (0, $hEgdr.default).customers,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gm7H7)))
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.AssetsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.GoalsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    // App Shortcuts for Platform Component
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ConfluenceIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.LoomIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ProjectsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.TeamsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.OpsgenieIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "small"
            })
    }
};
const $15777f70405f0cfb$export$e0063c8eec18df81 = {
    message: (0, $hEgdr.default).projects,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3pQT5)))
};
const $15777f70405f0cfb$export$dbe1165a572764fa = {
    message: (0, $hEgdr.default).projectsGalaxia,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3pQT5)))
};
const $15777f70405f0cfb$export$9fcc53f3b36e0949 = 240; // in pixels
const $15777f70405f0cfb$export$6621cd553335536a = 320; // in pixels
const $15777f70405f0cfb$export$2eb8dda9e83d33ff = false;
const $15777f70405f0cfb$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $15777f70405f0cfb$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $15777f70405f0cfb$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $15777f70405f0cfb$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $15777f70405f0cfb$export$89de709e88232646 = 25;
const $15777f70405f0cfb$export$b66ae8c18ec95bc6 = (0, $hEgdr.default).forYou;
const $15777f70405f0cfb$export$4da83c858d129f7f = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: (0, $hEgdr.default).apps,
    [(0, $8IuE5.L1_MENU_ID).GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: (0, $hEgdr.default).roadmaps,
    [(0, $8IuE5.L1_MENU_ID).PLANS]: (0, $hEgdr.default).plans,
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: (0, $hEgdr.default).projectsGalaxia,
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: (0, $hEgdr.default).filters,
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $hEgdr.default).dashboards,
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: (0, $hEgdr.default).overviews,
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: (0, $hEgdr.default).operations,
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).RECENT]: (0, $hEgdr.default).recent,
    [(0, $8IuE5.L1_MENU_ID).STARRED]: (0, $hEgdr.default).starred,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: (0, $hEgdr.default).customerHubs,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: (0, $hEgdr.default).customerServiceAnalytics,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMERS]: (0, $hEgdr.default).customers,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $hEgdr.default).confluence,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $hEgdr.default).loom,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: (0, $hEgdr.default).projects,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: (0, $hEgdr.default).opsgenie
};
const $15777f70405f0cfb$export$a9a6fdcb59a8001e = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: (0, $hEgdr.default).apps,
    [(0, $8IuE5.L1_MENU_ID).GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: (0, $hEgdr.default).roadmaps,
    [(0, $8IuE5.L1_MENU_ID).PLANS]: (0, $hEgdr.default).plans,
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: (0, $hEgdr.default).projects,
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: (0, $hEgdr.default).filters,
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $hEgdr.default).dashboards,
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: (0, $hEgdr.default).overviews,
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: (0, $hEgdr.default).operations,
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).RECENT]: (0, $hEgdr.default).recent,
    [(0, $8IuE5.L1_MENU_ID).STARRED]: (0, $hEgdr.default).starred,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: (0, $hEgdr.default).customerHubs,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: (0, $hEgdr.default).customerServiceAnalytics,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMERS]: (0, $hEgdr.default).customers,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $hEgdr.default).confluence,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $hEgdr.default).loom,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: (0, $hEgdr.default).projects,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: (0, $hEgdr.default).opsgenie
};

});
parcelRegister("hEgdr", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcc397343fd47548$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bcc397343fd47548$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer experiences"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Customer service overview"
    },
    customers: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-s",
        "defaultMessage": "Customers"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    },
    confluence: {
        "id": "navigation-apps-sidebar-nav4-common.common.confluence",
        "defaultMessage": "Confluence"
    },
    loom: {
        "id": "navigation-apps-sidebar-nav4-common.common.loom",
        "defaultMessage": "Loom"
    },
    opsgenie: {
        "id": "navigation-apps-sidebar-nav4-common.common.opsgenie",
        "defaultMessage": "Opsgenie"
    },
    projectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects-galaxia",
        "defaultMessage": "Spaces"
    }
});

});


parcelRegister("2QH3X", function(module, exports) {
$parcel$export(module.exports, "useFormattedMessageAndIcon", () => $e26c3339fdefd88f$export$efa1c7d3cd2d4f5c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");
const $e26c3339fdefd88f$export$efa1c7d3cd2d4f5c = (message, Icon)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formattedMessage = formatMessage(message);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        spacing: "spacious",
        color: "currentColor",
        "aria-hidden": "true"
    });
    return {
        formattedMessage: formattedMessage,
        icon: icon
    };
};

});


parcelRegister("kh7bJ", function(module, exports) {
$parcel$export(module.exports, "useIsAnonymous", () => $823c6492726fd885$export$bf7b5d502f6d6d3b);

var $koAZ4 = parcelRequire("koAZ4");
const $823c6492726fd885$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("4EKqI", function(module, exports) {
$parcel$export(module.exports, "UFOThirdPartySegment", () => $66849a36181db977$export$5f6fe75c46d0124e);
$parcel$export(module.exports, "UFOSegment", () => $66849a36181db977$export$2c976980ee6932e3);
$parcel$export(module.exports, "default", () => $66849a36181db977$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7aoMz = parcelRequire("7aoMz");

var $2QO3b = parcelRequire("2QO3b");

var $6FOAB = parcelRequire("6FOAB");
var $eFZhA = parcelRequire("eFZhA");

var $lf6Bt = parcelRequire("lf6Bt");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $kEJpL = parcelRequire("kEJpL");

var $2Ddeu = parcelRequire("2Ddeu");
/** A portion of the page we apply measurement to */ function $66849a36181db977$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $7aoMz.useInteractionContext)();
    const relayProfilerContext = (0, $eJOHy.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eJOHy.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $4cTDP.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $2QO3b.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $4cTDP.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $4cTDP.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $2QO3b.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4cTDP.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4cTDP.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Ddeu.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lf6Bt.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
function $66849a36181db977$var$JiraUFOSegment({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FOAB.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66849a36181db977$var$JiraUFOSegmentWrapper, null, children));
}
const $66849a36181db977$var$WrappedUFOSegment = ({ name: segmentName, children: children, mode: mode = 'single' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FOAB.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kEJpL.DEBUGUFOSegmentHighlight), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66849a36181db977$var$JiraUFOSegmentWrapper, null, children)));
};
const $66849a36181db977$var$WrappedThirdPartyUFOSegment = ({ name: segmentName, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kEJpL.DEBUGUFOSegmentHighlight), {
        name: segmentName,
        isThirdPartySegment: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eFZhA.UFOThirdPartySegment), {
        name: segmentName
    }, children));
};
const $66849a36181db977$export$5f6fe75c46d0124e = (0, $bJscI.componentWithFG)('jira_highlight_ufo_segments', $66849a36181db977$var$WrappedThirdPartyUFOSegment, (0, $eFZhA.UFOThirdPartySegment));
const $66849a36181db977$export$2c976980ee6932e3 = (0, $bJscI.componentWithFG)('jira_highlight_ufo_segments', $66849a36181db977$var$WrappedUFOSegment, $66849a36181db977$var$JiraUFOSegment);
var $66849a36181db977$export$2e2bcd8739ae039 = $66849a36181db977$export$2c976980ee6932e3;

});
parcelRegister("kEJpL", function(module, exports) {
$parcel$export(module.exports, "DEBUGUFOSegmentHighlight", () => $355b35a47196a083$export$b40753685e6a8303);
/* DEBUGUFOSegmentHighlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $f3XpU = parcelRequire("f3XpU");
const $355b35a47196a083$export$b40753685e6a8303 = (props)=>{
    const [showUFOSegments] = (0, $f3XpU.useShowUFOSegmentsState)();
    // Do nothing
    if (!showUFOSegments) return props.children;
    if (props.isThirdPartySegment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($355b35a47196a083$var$ThirdPartyUfoSegmentWrapperWithHighlight, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($355b35a47196a083$var$UfoSegmentWrapperWithHighlight, props);
};
/**
 * used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 */ const $355b35a47196a083$var$ThirdPartyUfoSegmentWrapperWithHighlight = ({ children: children, name: name })=>{
    const thirdPartySegmentName = `thirdPartySegment ${name}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $355b35a47196a083$var$borderStylesBlack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            "_kqswh2mm _syaz1fxt _1e0c1txw _1bah1h6o"
        ])
    }, thirdPartySegmentName), children);
};
/**
 * used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 */ const $355b35a47196a083$var$UfoSegmentWrapperWithHighlight = ({ children: children, name: name })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $355b35a47196a083$var$borderStylesBlue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            "_kqswh2mm _syazpnps _1e0c1txw _1bah1h6o"
        ])
    }, name), children);
};
const $355b35a47196a083$var$textStylesBlue = null;
const $355b35a47196a083$var$borderStylesBlue = (0, $1DXK0.xcss)({
    border: '2px solid blue',
    borderRadius: 'radius.small',
    padding: 'space.100'
});
const $355b35a47196a083$var$textStylesBlack = null;
const $355b35a47196a083$var$borderStylesBlack = (0, $1DXK0.xcss)({
    border: '2px solid black',
    borderRadius: 'radius.small',
    padding: 'space.100'
});

});
parcelRegister("f3XpU", function(module, exports) {
$parcel$export(module.exports, "useShowUFOSegmentsState", () => $dae02d3eff17a704$export$99730ac308228c00);

var $eJOHy = parcelRequire("eJOHy");
// Singleton state manager for UFO segments
// This file should never be included in production code, do not add production code here
class $dae02d3eff17a704$var$UFODebugState {
    static getInstance() {
        if (!$dae02d3eff17a704$var$UFODebugState.instance) $dae02d3eff17a704$var$UFODebugState.instance = new $dae02d3eff17a704$var$UFODebugState();
        return $dae02d3eff17a704$var$UFODebugState.instance;
    }
    getState() {
        return this.state;
    }
    setState(newState) {
        if (this.state !== newState) {
            this.state = newState;
            this.notifyListeners();
        }
    }
    subscribe(listener) {
        this.listeners.add(listener);
        // Set up global methods only once
        if (!this.globalMethodsSet) {
            this.setupGlobalMethods();
            this.globalMethodsSet = true;
        }
        // Return unsubscribe function
        return ()=>{
            this.listeners.delete(listener);
        };
    }
    notifyListeners() {
        this.listeners.forEach((listener)=>listener(this.state));
    }
    setupGlobalMethods() {
        // @ts-expect-error This file should never be included in production code so we dont want to type globalThis as it shouldnt know about it
        globalThis.showUfoSegments = ()=>{
            this.setState(true);
            return 'Showing ufo segments';
        };
        // @ts-expect-error This file should never be included in production code so we dont want to type globalThis as it shouldnt know about it
        globalThis.hideUFOSegments = ()=>{
            this.setState(false);
            return 'Hiding ufo segments';
        };
    }
    constructor(){
        this.state = false;
        this.listeners = new Set();
        this.globalMethodsSet = false;
    }
}
function $dae02d3eff17a704$export$99730ac308228c00() {
    const manager = $dae02d3eff17a704$var$UFODebugState.getInstance();
    const [state, setState] = (0, $eJOHy.useState)(manager.getState());
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = manager.subscribe(setState);
        return ()=>{
            unsubscribe();
        };
    }, [
        manager
    ]);
    return [
        state,
        setState
    ];
}

});


parcelRegister("2Ddeu", function(module, exports) {
$parcel$export(module.exports, "default", () => $435fde75284c0635$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2QO3b = parcelRequire("2QO3b");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $435fde75284c0635$var$startTimes = new Map();
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $435fde75284c0635$var$lastActiveInteraction;
function $435fde75284c0635$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $2QO3b.getActiveInteraction)()?.id;
    if (!!$435fde75284c0635$var$lastActiveInteraction && $435fde75284c0635$var$lastActiveInteraction !== activeInteractionId) $435fde75284c0635$var$startTimes.clear();
    $435fde75284c0635$var$lastActiveInteraction = activeInteractionId;
}
const $435fde75284c0635$var$onStartRender = (id)=>{
    if (!$435fde75284c0635$var$startTimes.has(id)) $435fde75284c0635$var$startTimes.set(id, []);
    $435fde75284c0635$var$startTimes.get(id)?.push(performance.now());
};
const $435fde75284c0635$var$ProfilerMarker = ({ onRender: onRender })=>{
    if (false) onRender?.();
    return null;
};
const $435fde75284c0635$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $eJOHy.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    $435fde75284c0635$var$checkActiveInteractionAndResetStartMarksIfSet();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($435fde75284c0635$var$ProfilerMarker, {
        onRender: ()=>$435fde75284c0635$var$onStartRender(reactProfilerId)
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($435fde75284c0635$var$ProfilerMarker, {
        onRender: ()=>{
            const startTimesForId = $435fde75284c0635$var$startTimes.get(reactProfilerId);
            if (startTimesForId?.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', actualDuration, baseDuration, firstStartTime, endTime);
            }
        }
    }));
};
const $435fde75284c0635$var$SsrRenderProfiler = (props)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($435fde75284c0635$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($435fde75284c0635$var$ProfilerMarker, null), props.children);
};
var $435fde75284c0635$export$2e2bcd8739ae039 = $435fde75284c0635$var$SsrRenderProfiler;

});


parcelRegister("24QYf", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $8ca6bb72e2802986$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8ca6bb72e2802986$export$d57b6b390e78d90f);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT", () => $8ca6bb72e2802986$export$6f21b70acbf71216);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_GOALS_TEAMS_SWITCHED", () => $8ca6bb72e2802986$export$6c0b16a0c07be58e);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS", () => $8ca6bb72e2802986$export$c2614ebabc74446e);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS_GOALS_TEAMS_SWITCHED", () => $8ca6bb72e2802986$export$f8e298c478de92d5);

var $8IuE5 = parcelRequire("8IuE5");
const $8ca6bb72e2802986$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4SidebarContent';
const $8ca6bb72e2802986$export$d57b6b390e78d90f = 'jira-cosmos';
const $8ca6bb72e2802986$export$6f21b70acbf71216 = {
    navKey: 'JIRA_SIDEBAR',
    navItems: [
        {
            menuId: (0, $8IuE5.L1_MENU_ID).RECENT,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).STARRED,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).APPS,
            isVisible: true
        },
        // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
        // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
        // Keeping code in comments so it can be easily reintroduced during EAP
        // {
        // 	menuId: L1_MENU_ID.GOALS,
        // 	isVisible: true,
        // },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).ROADMAPS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).PLANS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).DASHBOARDS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).OPERATIONS,
            isVisible: true
        },
        {
            /* remove this on
			 * assets_as_an_app_v2 cleanup &&
			 */ menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).CUSTOMERS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS,
            isVisible: true
        }
    ]
};
const $8ca6bb72e2802986$export$6c0b16a0c07be58e = {
    navKey: 'JIRA_SIDEBAR',
    navItems: [
        {
            menuId: (0, $8IuE5.L1_MENU_ID).RECENT,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).STARRED,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).APPS,
            isVisible: true
        },
        // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
        // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
        // Keeping code in comments so it can be easily reintroduced during EAP
        // {
        // 	menuId: L1_MENU_ID.GOALS,
        // 	isVisible: true,
        // },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).ROADMAPS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).PLANS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).DASHBOARDS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).OPERATIONS,
            isVisible: true
        },
        {
            /* remove this on
				 * assets_as_an_app_v2 cleanup &&
				 */ menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).CUSTOMERS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS,
            isVisible: true
        }
    ]
};
const $8ca6bb72e2802986$export$c2614ebabc74446e = $8ca6bb72e2802986$export$6f21b70acbf71216.navItems.map(({ menuId: menuId })=>menuId);
const $8ca6bb72e2802986$export$f8e298c478de92d5 = $8ca6bb72e2802986$export$6c0b16a0c07be58e.navItems.map(({ menuId: menuId })=>menuId);

});

parcelRegister("5IAcG", function(module, exports) {
$parcel$export(module.exports, "L1MenuItems", () => $183e78c1a23ebd9f$export$a1e3b15bccd7433c);

var $bBIDB = parcelRequire("bBIDB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jYFjy = parcelRequire("jYFjy");

var $7Rifr = parcelRequire("7Rifr");
function $183e78c1a23ebd9f$export$a1e3b15bccd7433c({ queryReference: queryReference }) {
    // We define a query which requires a few variables: $cloudId and others
    // Looking at https://relay.dev/docs/guided-tour/rendering/variables/, we can either:
    // a) pass these query-level variables down to the fragments as arguments, OR,
    // b) allow the fragments to reference the query-level variables directly.
    // We've chosen b) for now, as it would be a hassle to have to specify 8+ variables
    // at every level of the component tree.
    const l1MenuData = (0, $j4oe4.usePreloadedQuery)((0, $bBIDB.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYFjy.YourWork), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Rifr.ConfigurableMenuItems), {
        menuData: l1MenuData
    }));
}

});
parcelRegister("jYFjy", function(module, exports) {
$parcel$export(module.exports, "YourWork", () => $a0a7650eb46c8e76$export$c7da207c25eb3776);

var $eJOHy = parcelRequire("eJOHy");

var $gNUuP = parcelRequire("gNUuP");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $2QH3X = parcelRequire("2QH3X");

var $iIQmy = parcelRequire("iIQmy");

var $fs2Be = parcelRequire("fs2Be");

var $4cTDP = parcelRequire("4cTDP");

var $6HDkS = parcelRequire("6HDkS");
const $a0a7650eb46c8e76$var$JIRA_HOME_PATH = (0, $iIQmy.jiraHomeRoute).path;
const $a0a7650eb46c8e76$var$JIRA_HOME_PATH_OLD = (0, $fs2Be.oldJiraHomeRoute).path;
const $a0a7650eb46c8e76$var$analytics = {
    actionSubjectId: (0, $a9aec.SECTION_ITEM_YOUR_WORK),
    itemId: 'yourWork',
    level: 1,
    // Note: Your work doesn't seem to be configurable via Customise sidebar - More menu
    isInMore: false
};
const $a0a7650eb46c8e76$export$c7da207c25eb3776 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $6HDkS.default).forYou, (0, (/*@__PURE__*/$parcel$interopDefault($gNUuP))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        analytics: $a0a7650eb46c8e76$var$analytics,
        elemBefore: icon,
        href: (0, $4cTDP.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? $a0a7650eb46c8e76$var$JIRA_HOME_PATH : $a0a7650eb46c8e76$var$JIRA_HOME_PATH_OLD,
        menuId: (0, $4cTDP.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? (0, $h4Bzb.MENU_ID_FOR_YOU) : (0, $h4Bzb.MENU_ID_YOUR_WORK)
    }, formattedMessage);
};

});
parcelRegister("a9aec", function(module, exports) {
$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $db3f586753213871$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $db3f586753213871$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $db3f586753213871$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $db3f586753213871$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $db3f586753213871$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $db3f586753213871$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $db3f586753213871$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $db3f586753213871$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $db3f586753213871$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $db3f586753213871$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $db3f586753213871$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $db3f586753213871$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $db3f586753213871$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", () => $db3f586753213871$export$c15c267765b7c087);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $db3f586753213871$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $db3f586753213871$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $db3f586753213871$export$340dfb7166bc7df6);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_CONFLUENCE", () => $db3f586753213871$export$68f5347447985678);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_LOOM", () => $db3f586753213871$export$1d6ac45ce8d48696);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_TEAMS", () => $db3f586753213871$export$73432842fefef2ac);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_PROJECTS", () => $db3f586753213871$export$3023d22f41447712);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_OPSGENIE", () => $db3f586753213871$export$3cc2573a8cf93a99);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $db3f586753213871$export$1a73d7f5e6997c6d);

var $h4Bzb = parcelRequire("h4Bzb");
const $db3f586753213871$export$ed5276b2863990a4 = 'recent';
const $db3f586753213871$export$73b9e2753c0313a = 'starred';
const $db3f586753213871$export$a01a58e0d3083eac = 'yourApps';
const $db3f586753213871$export$a7cdcfc40ede2092 = 'yourWork';
const $db3f586753213871$export$31b95a89c6fecef5 = 'apps';
const $db3f586753213871$export$b8d778ecbc8de386 = 'plans';
const $db3f586753213871$export$31111a67d393221 = 'projects';
const $db3f586753213871$export$15cffe8e769011f4 = 'filters';
const $db3f586753213871$export$573d88e8f19dee53 = 'dashboards';
const $db3f586753213871$export$4d8d544db40ea55b = 'operations';
const $db3f586753213871$export$ee4743a74ca6b2b4 = 'teams';
const $db3f586753213871$export$935694b184853c59 = 'assets';
const $db3f586753213871$export$b0aa6b1b7598bca0 = 'more';
const $db3f586753213871$export$60a8edfaff189e32 = 'customiseSidebar';
const $db3f586753213871$export$c15c267765b7c087 = 'overviews';
const $db3f586753213871$export$61feca79c347b0c7 = 'goals';
const $db3f586753213871$export$1e1623e43a47b758 = 'roadmaps';
const $db3f586753213871$export$c15d65fa4cb522d = 'customerServiceCustomers';
const $db3f586753213871$export$99cd56faa69bbbb6 = 'customerService';
const $db3f586753213871$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $db3f586753213871$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $db3f586753213871$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $db3f586753213871$export$68f5347447985678 = 'confluenceGlobalAppShortcut';
const $db3f586753213871$export$1d6ac45ce8d48696 = 'loomGlobalAppShortcut';
const $db3f586753213871$export$73432842fefef2ac = 'teamsGlobalAppShortcut';
const $db3f586753213871$export$3023d22f41447712 = 'projectsGlobalAppShortcut';
const $db3f586753213871$export$3cc2573a8cf93a99 = 'opsgenieGlobalAppShortcut';
const $db3f586753213871$export$1a73d7f5e6997c6d = {
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).APPS]: $db3f586753213871$export$31b95a89c6fecef5,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).ASSETS]: $db3f586753213871$export$935694b184853c59,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).DASHBOARDS]: $db3f586753213871$export$573d88e8f19dee53,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).FILTERS]: $db3f586753213871$export$15cffe8e769011f4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).OPERATIONS]: $db3f586753213871$export$4d8d544db40ea55b,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).PLANS]: $db3f586753213871$export$b8d778ecbc8de386,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS]: $db3f586753213871$export$31111a67d393221,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).RECENT]: $db3f586753213871$export$ed5276b2863990a4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).STARRED]: $db3f586753213871$export$73b9e2753c0313a,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).TEAMS]: $db3f586753213871$export$ee4743a74ca6b2b4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GOALS]: $db3f586753213871$export$61feca79c347b0c7,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).OVERVIEWS]: $db3f586753213871$export$c15c267765b7c087,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).ROADMAPS]: $db3f586753213871$export$1e1623e43a47b758,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMERS]: $db3f586753213871$export$99cd56faa69bbbb6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $db3f586753213871$export$99cd56faa69bbbb6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $db3f586753213871$export$f780439bdf7412c6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $db3f586753213871$export$340dfb7166bc7df6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $db3f586753213871$export$be1ee97c6c39a7a0,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE]: $db3f586753213871$export$68f5347447985678,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM]: $db3f586753213871$export$1d6ac45ce8d48696,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS]: $db3f586753213871$export$73432842fefef2ac,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS]: $db3f586753213871$export$3023d22f41447712,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE]: $db3f586753213871$export$3cc2573a8cf93a99
};

});

parcelRegister("i0tMD", function(module, exports) {
$parcel$export(module.exports, "Nav4MenuLinkItem", () => $8840a5f52e86652c$export$3253d78f1560490f);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eJOHy = parcelRequire("eJOHy");

var $dpxw4 = parcelRequire("dpxw4");

var $cbCSE = parcelRequire("cbCSE");

var $bo95Y = parcelRequire("bo95Y");

var $azEgq = parcelRequire("azEgq");
const $8840a5f52e86652c$export$3253d78f1560490f = /*#__PURE__*/ (0, $eJOHy.forwardRef)($8840a5f52e86652c$var$Nav4MenuLinkItemContent);
function $8840a5f52e86652c$var$Nav4MenuLinkItemContent(props, ref) {
    const { menuId: menuId } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isControlledPath: isControlledPath } = (0, $cbCSE.useSidebarNav4Controller)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        ref: ref,
        ...props,
        isSelected: isSelectedPath(menuId) || isControlledPath(menuId),
        testId: (0, $azEgq.getTestId)(menuId)
    });
}

});
parcelRegister("dpxw4", function(module, exports) {
$parcel$export(module.exports, "SidebarNav4ContextProvider", () => $9a5158489d715dff$export$ebf7cdfc2e83bcef);
$parcel$export(module.exports, "useSidebarNav4", () => $9a5158489d715dff$export$dc46c14934833db2);

var $eJOHy = parcelRequire("eJOHy");

var $gCY1z = parcelRequire("gCY1z");

var $kWbWF = parcelRequire("kWbWF");

var $b1DBy = parcelRequire("b1DBy");

var $kg9Uh = parcelRequire("kg9Uh");
const $9a5158489d715dff$var$SidebarNav4Context = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $9a5158489d715dff$export$2854101beb9a2d8d(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const [routerContext] = (0, $gCY1z.useRouter)();
    const initialSelectedPath = (0, $kWbWF.getInitialSelectedPath)(routerContext);
    const [selectedPath, setSelectedPath] = (0, $eJOHy.useState)(initialSelectedPath);
    // When the `routerContext` changes, we need to recalculate the selected path.
    // useLayoutEffect, so this happens before render.
    (0, $eJOHy.useLayoutEffect)(()=>{
        setSelectedPath((currentPath)=>{
            const newPath = (0, $kg9Uh.routeToSelectedPath)(routerContext);
            return currentPath.toString() === newPath.toString() ? currentPath : newPath;
        });
    }, [
        routerContext
    ]);
    const sidebarNav4Controller = (0, $eJOHy.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $b1DBy.isSelectedPath)(initialSelectedPath),
            isSelectedPath: (0, $b1DBy.isSelectedPath)(selectedPath)
        }), [
        initialSelectedPath,
        isInitialSelectedPath,
        selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a5158489d715dff$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $9a5158489d715dff$export$ebf7cdfc2e83bcef(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const selectedPathData = (0, $kg9Uh.useRouteToSelectedPath)();
    const sidebarNav4Controller = (0, $eJOHy.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $b1DBy.isSelectedPath)(selectedPathData.initialSelectedPath),
            isSelectedPath: (0, $b1DBy.isSelectedPath)(selectedPathData.selectedPath)
        }), [
        isInitialSelectedPath,
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a5158489d715dff$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $9a5158489d715dff$export$dc46c14934833db2() {
    const context = (0, $eJOHy.useContext)($9a5158489d715dff$var$SidebarNav4Context);
    if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
    return context;
}

});

parcelRegister("cbCSE", function(module, exports) {
$parcel$export(module.exports, "SidebarNav4ControllerProvider", () => $3d5607f673c98260$export$ec25d268893d889d);
$parcel$export(module.exports, "useSidebarNav4Controller", () => $3d5607f673c98260$export$641950c86d73374);

var $eJOHy = parcelRequire("eJOHy");

var $b1DBy = parcelRequire("b1DBy");
const $3d5607f673c98260$var$SidebarNav4ControllerContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $3d5607f673c98260$export$ec25d268893d889d(props) {
    const { children: children, controlledPath: initialControlledPath = null } = props;
    const [controlledPath, setControlledPath] = (0, $eJOHy.useState)(initialControlledPath); // null means "not being controlled"
    const sidebarNav4Controller = (0, $eJOHy.useMemo)(()=>({
            // is any path in Navigation a controlled one
            isControlledNav: controlledPath !== null,
            isControlledPath: (0, $b1DBy.isSelectedPath)(controlledPath ?? []),
            setControlledPath: setControlledPath
        }), [
        controlledPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d5607f673c98260$var$SidebarNav4ControllerContext.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $3d5607f673c98260$export$641950c86d73374() {
    const context = (0, $eJOHy.useContext)($3d5607f673c98260$var$SidebarNav4ControllerContext);
    if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
    return context;
}

});

parcelRegister("bo95Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6e941be7dec1b83$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dvSy = parcelRequire("2dvSy");


var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
function $d6e941be7dec1b83$var$LinkMenuItemWithAnalytics({ analytics: analytics, onClick: onClick, ...rest }, ref) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    }, [
        analytics,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d6e941be7dec1b83$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)($d6e941be7dec1b83$var$LinkMenuItemWithAnalytics);

});
const $bfc89d778f76f56d$export$6dd9406e478a1fe2 = 'navigationItem';
const $bfc89d778f76f56d$export$b887e88d8d0739f6 = 'button';
const $bfc89d778f76f56d$export$64fed82162bd367 = 'dropdownItem';
const $bfc89d778f76f56d$export$b0a8b257f1f878a2 = 'searchInput';


parcelRegister("azEgq", function(module, exports) {
$parcel$export(module.exports, "getTestId", () => $3b1dd61e34a2731a$export$ec17b125bc42c229);
// By giving all of the Nav4-HTMLElements a test-id prefix, we can find them again,
// and even build a path from each leaf to the root. We do this in Storybook to
// simulate link-click-selection, since we are not using a real router in SB.
function $3b1dd61e34a2731a$export$ec17b125bc42c229(suffix) {
    return `NAV4_${suffix}`;
}

});


parcelRegister("iIQmy", function(module, exports) {
$parcel$export(module.exports, "jiraHomeRoute", () => $abbdc0110c11ea7e$export$11ebbd6d4e57759c);
const $abbdc0110c11ea7e$export$11ebbd6d4e57759c = {
    name: 'for-you',
    path: '/jira/for-you'
};

});

parcelRegister("fs2Be", function(module, exports) {
$parcel$export(module.exports, "oldJiraHomeRoute", () => $7c327ca8835982db$export$81e03d85d70e35e);
const $7c327ca8835982db$export$81e03d85d70e35e = {
    name: 'your-work',
    path: '/jira/your-work'
};

});

parcelRegister("6HDkS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b981196e50bfefe9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b981196e50bfefe9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    yourWork: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.your-work",
        "defaultMessage": "Your work"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.for-you",
        "defaultMessage": "For you"
    }
});

});


parcelRegister("7Rifr", function(module, exports) {
$parcel$export(module.exports, "ConfigurableMenuItems", () => $dde6c67e1bdac790$export$4aa1992a31b27e16);

var $aWfR3 = parcelRequire("aWfR3");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $8Pd1v = parcelRequire("8Pd1v");

var $80rA3 = parcelRequire("80rA3");

var $lxTXK = parcelRequire("lxTXK");

var $dKoLB = parcelRequire("dKoLB");

var $9Byj7 = parcelRequire("9Byj7");

var $dx2Xz = parcelRequire("dx2Xz");

var $4cTDP = parcelRequire("4cTDP");

var $a62R3 = parcelRequire("a62R3");

var $mIeXW = parcelRequire("mIeXW");

var $99tvj = parcelRequire("99tvj");

var $efIGC = parcelRequire("efIGC");

var $kRqOw = parcelRequire("kRqOw");

var $g5qtb = parcelRequire("g5qtb");

var $5kDxs = parcelRequire("5kDxs");

var $6CQFr = parcelRequire("6CQFr");
const $dde6c67e1bdac790$export$4aa1992a31b27e16 = /*#__PURE__*/ (0, $eJOHy.memo)($dde6c67e1bdac790$var$ConfigurableMenuItemsInner);
function $dde6c67e1bdac790$var$ConfigurableMenuItemsInner({ menuData: menuData }) {
    const data = (0, $j4oe4.useFragment)((0, $aWfR3.default), menuData);
    // Creates a synced ref to the global app shortcuts to get the response from global app shortcuts component.
    // const getFilteredProductLinks = useRef<fnGetFilteredProductLinks | undefined>(undefined);
    const [getFilteredProductLinks, setGetFilteredProductLinks] = (0, $eJOHy.useState)(undefined);
    const globalAppLicense = (0, $dx2Xz.useGlobalApps)();
    const navItems = (0, $99tvj.useFilterL1MenuItemsByEditionAndLicense)(// Add back any missing menu ids before filtering in case licensing has changed or a new L1 has been created.
    // This also handles when a user has no configuration yet.
    (0, $efIGC.useRefreshL1MenuItems)(data.jira?.userNavigationConfiguration?.navItems));
    const navItemsContext = (0, $eJOHy.useMemo)(()=>({
            navItems: navItems,
            visibleMenuIds: (0, $lxTXK.getConfigurableMenuIds)(navItems, true),
            moreMenuIds: (0, $lxTXK.getConfigurableMenuIds)(navItems, false),
            productItemsData: (0, $dKoLB.getProductItemsData)(navItems)
        }), [
        navItems
    ]);
    const visibleGlobalAppMenuIds = (0, $eJOHy.useMemo)(()=>(0, $dKoLB.getVisibleAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks), [
        globalAppLicense,
        navItems,
        getFilteredProductLinks
    ]);
    const appItemsDataUnstable = (0, $eJOHy.useMemo)(()=>(0, $dKoLB.getAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks), [
        globalAppLicense,
        navItems,
        getFilteredProductLinks
    ]);
    /**
   * Unfortunately appItemsDataUnstable is not stable, as setGetFilteredProductLinks gets called later to update getFilteredProductLinks.
   * However, even when getFilteredProductLinks changes, appItemsData does not always change meaningfully (eg same data but new instantiation).
   * This means that we can use a stable ref to avoid unnecessary re-renders of the GlobalShortcuts component.
   */ const [appItemsDataStable, setAppItemsDataStable] = (0, $eJOHy.useState)(appItemsDataUnstable);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(appItemsDataStable, appItemsDataUnstable)) // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setAppItemsDataStable(appItemsDataUnstable);
    }, [
        appItemsDataStable,
        appItemsDataUnstable
    ]);
    const handleUpdateGetFilteredProductLinks = (0, $eJOHy.useCallback)((fn)=>{
        setGetFilteredProductLinks(()=>fn);
    }, []);
    // Teams App requires the invite modal context provider to be wrapped around it.
    const globalShortcuts = (0, $eJOHy.useMemo)(()=>{
        if ((0, $4cTDP.fg)('nav4_global_links_jira')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Pd1v.TopLevelSpacer), null), (0, $a62R3.isTeamsAppEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CQFr.GlobalShortcutsWithInvitePeopleProvider), {
            appItemsData: appItemsDataStable,
            handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CQFr.GlobalShortcuts), {
            appItemsData: appItemsDataStable,
            handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks
        }));
        return visibleGlobalAppMenuIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Pd1v.TopLevelSpacer), null), visibleGlobalAppMenuIds.map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Byj7.GlobalAppShortcuts), {
                menuId: menuId,
                key: menuId
            }))) : null;
    }, [
        visibleGlobalAppMenuIds,
        appItemsDataStable,
        handleUpdateGetFilteredProductLinks
    ]);
    const getAppShortcutURL = (0, $eJOHy.useCallback)((apsKey)=>{
        if (getFilteredProductLinks) {
            const result = getFilteredProductLinks(apsKey);
            return result.promotedLink?.url;
        }
    }, [
        getFilteredProductLinks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $80rA3.NavItemsContext).Provider, {
        value: navItemsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kDxs.PeekMenuIdContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kRqOw.MoreMenuIsOpenContextProvider), null, navItemsContext.visibleMenuIds.map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $mIeXW.ConfigurableMenuItem), {
            key: menuId,
            menuData: data,
            menuId: menuId
        })), globalShortcuts, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Pd1v.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5qtb.SidebarCustomization), {
        navItems: navItems,
        menuData: data,
        productItemsData: navItemsContext.productItemsData,
        appItemsData: appItemsDataStable,
        getAppShortcutURL: getAppShortcutURL
    }))));
}

});
parcelRegister("aWfR3", function(module, exports) {
$parcel$export(module.exports, "default", () => $41b73aa3f4744a63$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00967a64cef8c686dca07727f080bd28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $41b73aa3f4744a63$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ConfigurableMenuItems",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudID",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "navKey",
                            "value": "NAV_SIDEBAR"
                        }
                    ],
                    "concreteType": "JiraUserNavigationConfiguration",
                    "kind": "LinkedField",
                    "name": "userNavigationConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraConfigurableNavigationItem",
                            "kind": "LinkedField",
                            "name": "navItems",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "menuId"
                                    },
                                    "action": "THROW",
                                    "path": "jira.userNavigationConfiguration.navItems.menuId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "isVisible"
                                    },
                                    "action": "THROW",
                                    "path": "jira.userNavigationConfiguration.navItems.isVisible"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ConfigurableMenuItem"
        }
    ],
    "type": "Query"
};
$41b73aa3f4744a63$var$node.hash = "186fc107bcd2a8ade003841f3137d27b";
var $41b73aa3f4744a63$export$2e2bcd8739ae039 = $41b73aa3f4744a63$var$node;

});

parcelRegister("8Pd1v", function(module, exports) {
$parcel$export(module.exports, "TopLevelSpacer", () => $f9581c9442a7359a$export$5776f68925982056);
/* top-level-spacer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $yFG6a = parcelRequire("yFG6a");
const $f9581c9442a7359a$var$styles = {
    root: "_4t3iutpp"
};
function $f9581c9442a7359a$export$5776f68925982056() {
    const level = (0, $yFG6a.useLevel)();
    (0, $eJOHy.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $f9581c9442a7359a$var$styles.root
        ])
    });
}

});

parcelRegister("80rA3", function(module, exports) {
$parcel$export(module.exports, "NavItemsContext", () => $9e5d0ca501b91cc9$export$a2018da95558f5c);
$parcel$export(module.exports, "PeekMenuIdContext", () => $9e5d0ca501b91cc9$export$390c771b9e3f4124);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $9e5d0ca501b91cc9$export$a2018da95558f5c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    navItems: [],
    visibleMenuIds: [],
    moreMenuIds: []
});
const $9e5d0ca501b91cc9$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    peekMenuId: undefined,
    setPeekMenuId: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});

parcelRegister("lxTXK", function(module, exports) {
$parcel$export(module.exports, "getConfigurableMenuIds", () => $29158faeed9adf5b$export$6071c13fba14d7fa);

var $d5UZJ = parcelRequire("d5UZJ");
const $29158faeed9adf5b$export$6071c13fba14d7fa = (navItems, isVisible)=>navItems.filter((navItem)=>navItem.isVisible === isVisible).map(({ menuId: menuId })=>menuId).filter((0, $d5UZJ.isConfigurableMenuId));

});
parcelRegister("d5UZJ", function(module, exports) {
$parcel$export(module.exports, "isConfigurableMenuId", () => $16e99cf6579db854$export$454094eefbaf1797);

var $5Q9JR = parcelRequire("5Q9JR");
const $16e99cf6579db854$export$454094eefbaf1797 = (value)=>(0, $5Q9JR.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);

});


parcelRegister("dKoLB", function(module, exports) {
$parcel$export(module.exports, "getProductItemsData", () => $b833e60bf4a8b374$export$92d3bf799aea2628);
$parcel$export(module.exports, "getAppItemsData", () => $b833e60bf4a8b374$export$153d0c6accbfb26a);
$parcel$export(module.exports, "getVisibleAppItemsData", () => $b833e60bf4a8b374$export$b7cc8dd7bef58aa3);

var $4cTDP = parcelRequire("4cTDP");

var $h4Bzb = parcelRequire("h4Bzb");

var $aYncF = parcelRequire("aYncF");

var $a62R3 = parcelRequire("a62R3");

var $8IuE5 = parcelRequire("8IuE5");

var $41vqi = parcelRequire("41vqi");

var $dx2Xz = parcelRequire("dx2Xz");
const $b833e60bf4a8b374$export$92d3bf799aea2628 = (navItems)=>(0, $4cTDP.fg)('nav4_global_links_jira') ? navItems.filter((navItem)=>(0, $dx2Xz.isSupportedMenuId)(navItem.menuId)).filter((navItem)=>!(0, $dx2Xz.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>{
        if (!(0, $a62R3.isTeamsAppEnabled)()) return true;
        return navItem.menuId !== (0, $8IuE5.L1_MENU_ID).TEAMS;
    }).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    }) : navItems.filter((navItem)=>!(0, $dx2Xz.isGlobalAppMenuId)(navItem.menuId)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
const $b833e60bf4a8b374$export$153d0c6accbfb26a = (navItems, globalAppLicense, getFilteredProductLinks)=>{
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    return navItems.filter((navItem)=>(0, $dx2Xz.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>{
        // TODO: put this under a feature gate
        if (!(0, $4cTDP.fg)('nav4_global_links_jira')) return true;
        // Metadata app licencing check
        if (!$b833e60bf4a8b374$var$isProductSupportedFromMetadata(navItem.menuId)) return false;
        if (getFilteredProductLinks) {
            if (navItem.menuId in (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)) {
                const apsKey = (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)[navItem.menuId];
                const fallbackUrl = USER_NAVIGATION_ITEM_LINKS[navItem.menuId];
                const filteredProducts = getFilteredProductLinks(apsKey);
                const statusDisabledOrComplete = (0, $4cTDP.fg)('jira-nav4-bugfix-resolve-jira-flicker-gas') ? filteredProducts.status === 'complete' : true;
                if (statusDisabledOrComplete && !fallbackUrl && filteredProducts.links.length === 0) // If there are no filtered links, we don't want to show this item.
                return false;
            }
        }
        return true;
    }).filter((navItem)=>(0, $dx2Xz.hasGlobalAppLicense)(navItem.menuId, globalAppLicense)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
};
const $b833e60bf4a8b374$export$b7cc8dd7bef58aa3 = (navItems, globalAppLicense, getFilteredProductLinks)=>{
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    return navItems.filter((navItem)=>navItem.isVisible).map(({ menuId: menuId })=>menuId).filter((0, $dx2Xz.isGlobalAppMenuId)).filter((navItem)=>{
        if (!(0, $4cTDP.fg)('nav4_global_links_jira')) return true;
        // Metadata app licencing check
        if (!$b833e60bf4a8b374$var$isProductSupportedFromMetadata(navItem)) return false;
        if (getFilteredProductLinks) {
            if (navItem in (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)) {
                const apsKey = (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)[navItem];
                const filteredProducts = getFilteredProductLinks(apsKey);
                const fallbackUrl = USER_NAVIGATION_ITEM_LINKS[navItem];
                const statusDisabledOrComplete = (0, $4cTDP.fg)('jira-nav4-bugfix-resolve-jira-flicker-gas') ? filteredProducts.status === 'complete' : true;
                if (statusDisabledOrComplete && !fallbackUrl && filteredProducts.links.length === 0) // If there are no filtered links, we don't want to show this item.
                return false;
            }
        }
        return true;
    }).filter((menuId)=>(0, $dx2Xz.hasGlobalAppLicense)(menuId, globalAppLicense));
};
const $b833e60bf4a8b374$var$isProductSupportedFromMetadata = (menuId)=>{
    const products = (0, $aYncF.getLicensedProducts)();
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE:
            return !!products[(0, $aYncF.LICENSED_PRODUCTS).CONFLUENCE];
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM:
            return !!products[(0, $aYncF.LICENSED_PRODUCTS).LOOM];
        default:
            return true;
    }
};

});
parcelRegister("a62R3", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => $4bdb55387d231b38$export$520a42ab062954ec);
$parcel$export(module.exports, "getNavigateToTeamsApp", () => $4bdb55387d231b38$export$cfadab73fb247145);
$parcel$export(module.exports, "useTransformToTeamsAppUrl", () => $4bdb55387d231b38$export$dc7e633fb6368a43);
$parcel$export(module.exports, "toTeamsAppURL", () => $4bdb55387d231b38$export$196b2cec97b1c87c);
$parcel$export(module.exports, "isTeamsAppEnabled", () => $4bdb55387d231b38$export$5921b2a93a401547);

var $fvpPO = parcelRequire("fvpPO");

var $j19W0 = parcelRequire("j19W0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $cHtIB = parcelRequire("cHtIB");

var $83DiZ = parcelRequire("83DiZ");

var $6zXPf = parcelRequire("6zXPf");

var $hWeHP = parcelRequire("hWeHP");
const $4bdb55387d231b38$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!orgId && !cloudId) throw new Error('Org ID or Cloud ID is required to navigate to Teams App');
    return (0, $j19W0.navigateToTeamsApp)({
        push: push,
        hostProduct: 'jira',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$cfadab73fb247145 = (navActionPayload, shouldOpenInSameTab)=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.navigateToTeamsApp)({
        hostProduct: 'jira',
        orgId: orgId || '',
        cloudId: cloudId || undefined,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$dc7e633fb6368a43 = (path, search = '')=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId,
        cloudId: cloudId
    });
};
const $4bdb55387d231b38$export$196b2cec97b1c87c = (path, search = '')=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId ?? '',
        cloudId: cloudId ?? ''
    });
};
const $4bdb55387d231b38$export$5921b2a93a401547 = ()=>{
    return (0, $fvpPO.isTeamsAppEnabled)({
        hostProduct: 'jira',
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)()
    });
};

});
parcelRegister("fvpPO", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => $e45f3caa2e661ed2$export$5921b2a93a401547);

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");
function $e45f3caa2e661ed2$export$5921b2a93a401547(config) {
    //  Hard kill switch for isolated cloud until Standalone directory is deployed
    if ((0, $7pw1V.isIsolatedCloud)()) return false;
    // Due to experiment exposures, we need to first check if Nav4 is enabled to see if the user is in the cohort
    // In FedRamp, we are ignoring the Nav4 dependency
    if (!(0, $lopBx.isFedRamp)() && config.userHasNav4Enabled !== undefined && !config.userHasNav4Enabled) return false;
    if ((0, $59rsN.default).initializeCompleted()) {
        // Next we check the experiment value based on the host product
        if (config.hostProduct === 'jira' && (0, $59rsN.default).getExperimentValue('migrate-jira-people-directory-to-teams-app', 'isEnabled', false)) return true;
        if (config.hostProduct === 'confluence' && (0, $59rsN.default).getExperimentValue('migrate-confluence-people-directory-to-teams-app', 'isEnabled', false)) return true;
    }
    // Lastly we check the feature gate which we are using for dogfooding, we won't roll this flag out in production.
    return (0, $eGOwo.fg)('should-redirect-directory-to-teams-app');
}

});

parcelRegister("j19W0", function(module, exports) {
$parcel$export(module.exports, "navigateToTeamsApp", () => $bcd485df6c831087$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $bcd485df6c831087$export$196b2cec97b1c87c);

var $fvpPO = parcelRequire("fvpPO");

var $0FujR = parcelRequire("0FujR");
const $bcd485df6c831087$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $fvpPO.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $0FujR.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $0FujR.getPathAndQuery)(actionWithDefaults);
    const href = (0, $0FujR.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $0FujR.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $bcd485df6c831087$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $0FujR.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("0FujR", function(module, exports) {
$parcel$export(module.exports, "generateTeamsAppPath", () => $a228ae66ede9224c$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $a228ae66ede9224c$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $a228ae66ede9224c$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $a228ae66ede9224c$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $a228ae66ede9224c$export$a792d22ca73cc3ca);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $eGOwo = parcelRequire("eGOwo");

var $chYv1 = parcelRequire("chYv1");

var $fvpPO = parcelRequire("fvpPO");
function $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $lopBx.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$a228ae66ede9224c$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $8RHPx.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $a228ae66ede9224c$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $fvpPO.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $chYv1.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $a228ae66ede9224c$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $fvpPO.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $chYv1.redirect)(href);
                return;
            }
            (0, $chYv1.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $chYv1.redirect)(href);
            return;
        } else {
            (0, $chYv1.openInNewTab)(href);
            return;
        }
    };
function $a228ae66ede9224c$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $a228ae66ede9224c$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$a228ae66ede9224c$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$a228ae66ede9224c$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$a228ae66ede9224c$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            if ((0, $eGOwo.fg)('enable_teams_app_breadcrumb_respect_directories')) return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_PEOPLE'
                })
            };
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $a228ae66ede9224c$export$a9f2c34176fff494() {
    const host = (0, $chYv1.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $a228ae66ede9224c$export$a792d22ca73cc3ca() {
    const path = (0, $chYv1.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $chYv1.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("chYv1", function(module, exports) {
$parcel$export(module.exports, "redirect", () => $c76ad79e98e47bfd$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $c76ad79e98e47bfd$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $c76ad79e98e47bfd$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $c76ad79e98e47bfd$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $c76ad79e98e47bfd$export$7333db99aa99d383);
function $c76ad79e98e47bfd$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $c76ad79e98e47bfd$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $c76ad79e98e47bfd$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $c76ad79e98e47bfd$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $c76ad79e98e47bfd$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});



parcelRegister("6zXPf", function(module, exports) {
$parcel$export(module.exports, "getWillShowNav4", () => $4fadc0024ae24c66$export$f1ce4aa22fe8768a);

var $4cTDP = parcelRequire("4cTDP");

var $fYeTG = parcelRequire("fYeTG");

var $blJDU = parcelRequire("blJDU");

var $6FjcH = parcelRequire("6FjcH");

var $2mYWB = parcelRequire("2mYWB");
const $4fadc0024ae24c66$export$f1ce4aa22fe8768a = ()=>(0, $4cTDP.fg)('jira_nav4') && ((0, $6FjcH.getWillShowNav4ForDogfooding)() || (0, $blJDU.getWillShowNav4ForBeta)() || (0, $2mYWB.getWillShowNav4ForGa)() || (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)());

});
parcelRegister("fYeTG", function(module, exports) {
$parcel$export(module.exports, "isMobileAndInMVPExperiment", () => $dfa94a7b2a1bc00e$export$f29d7974ab92d702);
$parcel$export(module.exports, "isMobileAndInViewPanelIterationExperiment", () => $dfa94a7b2a1bc00e$export$195496e87350b513);
$parcel$export(module.exports, "isMobileAndInMvpOrExistingUsersExperiment", () => $dfa94a7b2a1bc00e$export$571bd36603f36f7);
$parcel$export(module.exports, "isEnabledForMobileMvpOrExistingUsersExperiment", () => $dfa94a7b2a1bc00e$export$41c2a1a8497c2a69);
$parcel$export(module.exports, "MobileWebExperimentExposure", () => $dfa94a7b2a1bc00e$export$b93f740e619fc842);
$parcel$export(module.exports, "MobileWebExperimentViewPanelExistingUserExposure", () => $dfa94a7b2a1bc00e$export$d97ce70c2944c480);
$parcel$export(module.exports, "MobileWebExperimentViewPanelNewTenantsExposure", () => $dfa94a7b2a1bc00e$export$e5aaaaa9d7ed502);

var $l7Alo = parcelRequire("l7Alo");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");
const $dfa94a7b2a1bc00e$var$isMobileUserAgent = ()=>false ? false : (0, $l7Alo.default)();
const $dfa94a7b2a1bc00e$export$f29d7974ab92d702 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [mobileWebConfig] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_mobile_web_mvp_2');
    return(// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jira_mobile_web_mvp_2_feature_gate') && $dfa94a7b2a1bc00e$var$isMobileUserAgent() && mobileWebConfig.get('isEnabled', false));
};
const $dfa94a7b2a1bc00e$var$isMobileAndInViewPanelNewTenantsExperiment = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [newTenantsConfig] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_mobile_web_mvp_view_panel_new_tenants');
    return $dfa94a7b2a1bc00e$var$isMobileUserAgent() && newTenantsConfig.get('isEnabled', false) && (0, $4cTDP.fg)('jira_mobile_web_mvp_view_panel_kill_switch');
};
const $dfa94a7b2a1bc00e$var$isMobileAndInViewPanelExistingUsersExperiment = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [existingUsersMobileWebConfig] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_mobile_web_mvp_view_panel_existing_users');
    return $dfa94a7b2a1bc00e$var$isMobileUserAgent() && existingUsersMobileWebConfig.get('isEnabled', false) && (0, $4cTDP.fg)('jira_mobile_web_mvp_view_panel_kill_switch');
};
const $dfa94a7b2a1bc00e$export$195496e87350b513 = ()=>{
    return $dfa94a7b2a1bc00e$var$isMobileAndInViewPanelNewTenantsExperiment() || $dfa94a7b2a1bc00e$var$isMobileAndInViewPanelExistingUsersExperiment();
};
const $dfa94a7b2a1bc00e$export$571bd36603f36f7 = ()=>{
    return $dfa94a7b2a1bc00e$export$195496e87350b513() || $dfa94a7b2a1bc00e$export$f29d7974ab92d702();
};
const $dfa94a7b2a1bc00e$export$41c2a1a8497c2a69 = ()=>{
    return (0, $cxKOj.expVal)('jira_mobile_web_mvp_view_panel_new_tenants', 'isEnabled', false) || (0, $cxKOj.expVal)('jira_mobile_web_mvp_view_panel_existing_users', 'isEnabled', false) || (0, $cxKOj.expVal)('jira_mobile_web_mvp_2', 'isEnabled', false);
};
const $dfa94a7b2a1bc00e$export$b93f740e619fc842 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [, manuallyFireExposure] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_mobile_web_mvp_2');
    if ($dfa94a7b2a1bc00e$var$isMobileUserAgent()) manuallyFireExposure();
    return null;
};
const $dfa94a7b2a1bc00e$export$d97ce70c2944c480 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [, manuallyFireExposure] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_mobile_web_mvp_view_panel_existing_users');
    if ($dfa94a7b2a1bc00e$var$isMobileUserAgent()) manuallyFireExposure();
    return null;
};
const $dfa94a7b2a1bc00e$export$e5aaaaa9d7ed502 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [, manuallyFireExposure] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_mobile_web_mvp_view_panel_new_tenants');
    if ($dfa94a7b2a1bc00e$var$isMobileUserAgent()) manuallyFireExposure();
    return null;
};

});

parcelRegister("blJDU", function(module, exports) {
$parcel$export(module.exports, "getWillShowNav4ForBeta", () => $6301599c83e7c7ed$export$f4f16573b5c2e67b);

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");
const $6301599c83e7c7ed$export$f4f16573b5c2e67b = ()=>(0, $4cTDP.fg)('jira_nav4_beta_sandboxes') || (0, $cxKOj.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false) || (0, $cxKOj.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false) || (0, $cxKOj.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false);

});

parcelRegister("6FjcH", function(module, exports) {
$parcel$export(module.exports, "getWillShowNav4ForDogfooding", () => $b77caafb223f5236$export$9ca0d92d31816d4f);

var $4cTDP = parcelRequire("4cTDP");

var $nK7ig = parcelRequire("nK7ig");
const $b77caafb223f5236$export$9ca0d92d31816d4f = ()=>{
    if (!(0, $4cTDP.fg)('jira_nav4_dogfooding')) return false;
    // eslint-disable-next-line jira/ff/inline-usage
    const phase1 = (0, $4cTDP.fg)('jira_nav4_dogfooding_phase-1');
    // eslint-disable-next-line jira/ff/inline-usage
    const phase2 = (0, $4cTDP.fg)('jira_nav4_dogfooding_phase-2');
    const phase3 = !(phase1 || phase2);
    return phase3 || phase2 && !(0, $nK7ig.getIsNav4UserOptOut)() || phase1 && !(0, $nK7ig.getIsNav4UserOptOut)();
};

});
parcelRegister("nK7ig", function(module, exports) {
$parcel$export(module.exports, "getMetaBoolean", () => $254cd43c546d737b$export$9683360b0ae70629);
$parcel$export(module.exports, "getIsAdmin", () => $254cd43c546d737b$export$7d046765d192af80);
$parcel$export(module.exports, "getIsNav4TenantOptIn", () => $254cd43c546d737b$export$7db4d9fca9900972);
$parcel$export(module.exports, "getIsNav4TenantOptOut", () => $254cd43c546d737b$export$69ef235f5326800c);
$parcel$export(module.exports, "getIsNav4UserOptIn", () => $254cd43c546d737b$export$ba89637357392be6);
$parcel$export(module.exports, "getIsNav4UserOptOut", () => $254cd43c546d737b$export$3fbfe0fdf05e0f9f);

var $5PQOA = parcelRequire("5PQOA");

var $hWeHP = parcelRequire("hWeHP");

const $254cd43c546d737b$export$9683360b0ae70629 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((name)=>(0, $hWeHP.default)(`ajs-${name}`) === 'true');
const $254cd43c546d737b$export$7d046765d192af80 = ()=>$254cd43c546d737b$export$9683360b0ae70629((0, $7e5fbaca814a6bf2$export$4261d5d429e288ec));
const $254cd43c546d737b$export$7db4d9fca9900972 = ()=>$254cd43c546d737b$export$9683360b0ae70629((0, $7e5fbaca814a6bf2$export$2eca2b4f46ed58e6));
const $254cd43c546d737b$export$69ef235f5326800c = ()=>$254cd43c546d737b$export$9683360b0ae70629((0, $7e5fbaca814a6bf2$export$a4507bf14f4bb764));
const $254cd43c546d737b$export$ba89637357392be6 = ()=>$254cd43c546d737b$export$9683360b0ae70629((0, $7e5fbaca814a6bf2$export$153ded4d539b820d));
const $254cd43c546d737b$export$3fbfe0fdf05e0f9f = ()=>$254cd43c546d737b$export$9683360b0ae70629((0, $7e5fbaca814a6bf2$export$9c962957701a4fe8));

});
const $7e5fbaca814a6bf2$export$4261d5d429e288ec = 'is-admin';
const $7e5fbaca814a6bf2$export$2eca2b4f46ed58e6 = 'is-nav4-tenant-opt-in';
const $7e5fbaca814a6bf2$export$a4507bf14f4bb764 = 'is-nav4-tenant-opt-out';
const $7e5fbaca814a6bf2$export$153ded4d539b820d = 'is-nav4-user-opt-in';
const $7e5fbaca814a6bf2$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';



parcelRegister("2mYWB", function(module, exports) {
$parcel$export(module.exports, "getWillShowNav4ForGa", () => $73513bc4dd1b2e0e$export$daa2ef3003aa7c2a);

var $4cTDP = parcelRequire("4cTDP");

var $nK7ig = parcelRequire("nK7ig");
const $73513bc4dd1b2e0e$export$daa2ef3003aa7c2a = ()=>{
    // Later GA phases eclipse earlier phases.
    // For example, if phase 2 is on and the result is false, that should take precedence over phase 1 with a result of true.
    if ((0, $4cTDP.fg)('jira_nav4_ga_phase-3')) return true;
    if ((0, $4cTDP.fg)('jira_nav4_ga_phase-2')) return !(0, $nK7ig.getIsNav4UserOptOut)();
    if ((0, $4cTDP.fg)('jira_nav4_ga_phase-1-5')) return (0, $nK7ig.getIsAdmin)() ? !(0, $nK7ig.getIsNav4UserOptOut)() : !(0, $nK7ig.getIsNav4TenantOptOut)() && !(0, $nK7ig.getIsNav4UserOptOut)();
    if ((0, $4cTDP.fg)('jira_nav4_ga_phase-1')) return (0, $nK7ig.getIsAdmin)() ? (0, $nK7ig.getIsNav4UserOptIn)() : (0, $nK7ig.getIsNav4TenantOptIn)() && !(0, $nK7ig.getIsNav4UserOptOut)();
    if ((0, $4cTDP.fg)('jira_nav4_ga_sandboxes')) return (0, $nK7ig.getIsNav4UserOptIn)();
    return false;
};

});



parcelRegister("41vqi", function(module, exports) {
$parcel$export(module.exports, "getUserNavigationItemLinks", () => $991ce81a1da95cb9$export$1ed619da1e21182);

var $fuV6j = parcelRequire("fuV6j");

var $8IuE5 = parcelRequire("8IuE5");
const $991ce81a1da95cb9$export$1ed619da1e21182 = ()=>{
    return {
        [(0, $8IuE5.L1_MENU_ID).APPS]: '/jira/marketplace/discover?source=apps-menu',
        [(0, $8IuE5.L1_MENU_ID).GOALS]: '/jira/your-work?goals',
        [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $fuV6j.dashboardsDirectoryRoute).path,
        [(0, $8IuE5.L1_MENU_ID).TEAMS]: '/jira/people/search',
        [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: '/jira/polaris/roadmaps',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: '/jira/assets',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: ''
    };
};

});
parcelRegister("fuV6j", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $f8f2a1120a41a941$export$41bba408475cab16);
const $f8f2a1120a41a941$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("dx2Xz", function(module, exports) {
$parcel$export(module.exports, "useGlobalApps", () => $0cdfec629a7fe95c$export$3a835823210524f1);
$parcel$export(module.exports, "isSupportedMenuId", () => $0cdfec629a7fe95c$export$54d4b2a367e2f9d);
$parcel$export(module.exports, "isGlobalAppMenuId", () => $0cdfec629a7fe95c$export$4c0a3527505b04c5);
$parcel$export(module.exports, "hasGlobalAppLicense", () => $0cdfec629a7fe95c$export$f97a769ad5c10cb4);

var $eJOHy = parcelRequire("eJOHy");

var $7pw1V = parcelRequire("7pw1V");

var $4cTDP = parcelRequire("4cTDP");

var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");

var $7cSYk = parcelRequire("7cSYk");

var $a62R3 = parcelRequire("a62R3");

var $5Q9JR = parcelRequire("5Q9JR");

var $8IuE5 = parcelRequire("8IuE5");
function $0cdfec629a7fe95c$export$3a835823210524f1() {
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const shouldShowGoals = (appEditions.productDiscovery !== (0, $cblKs.UNLICENSED) || appEditions.software !== (0, $cblKs.UNLICENSED) || // JSM comes with a free core license. Goals don't display with JSM-only, so checking for unlicensed JSM
    appEditions.core !== (0, $cblKs.UNLICENSED) && appEditions.serviceDesk === (0, $cblKs.UNLICENSED)) && !(0, $7pw1V.isFedrampModerate)();
    const shouldShowAssets = appEditions.serviceDesk !== (0, $cblKs.UNLICENSED) && (0, $4cTDP.fg)('assets_as_an_app_v2') && (0, $7cSYk.isCMDBEnabledInEnvironment)();
    const shouldShowTeams = (0, $a62R3.isTeamsAppEnabled)();
    const globalAppShortcuts = (0, $eJOHy.useMemo)(()=>{
        if (appEditions.core !== (0, $cblKs.UNLICENSED)) {
            if (appEditions.serviceDesk !== (0, $cblKs.UNLICENSED)) return {
                confluence: true,
                loom: true,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: true
            };
            if (appEditions.productDiscovery !== (0, $cblKs.UNLICENSED)) return {
                confluence: true,
                loom: true,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: false
            };
        } else {
            if (appEditions.serviceDesk !== (0, $cblKs.UNLICENSED)) return {
                confluence: false,
                loom: false,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: true
            };
            if (appEditions.productDiscovery !== (0, $cblKs.UNLICENSED)) return {
                confluence: false,
                loom: false,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: false
            };
        }
        return {
            confluence: true,
            loom: true,
            projects: true,
            teams: shouldShowTeams,
            opsgenie: false
        };
    }, [
        appEditions,
        shouldShowTeams
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if ((0, $4cTDP.fg)('nav4_global_links_jira')) return {
            goals: shouldShowGoals,
            assets: shouldShowAssets,
            ...globalAppShortcuts
        };
        return {
            goals: shouldShowGoals,
            assets: shouldShowAssets,
            confluence: false,
            loom: false,
            projects: false,
            teams: shouldShowTeams,
            opsgenie: false
        };
    }, [
        globalAppShortcuts,
        shouldShowAssets,
        shouldShowGoals,
        shouldShowTeams
    ]);
}
const $0cdfec629a7fe95c$export$54d4b2a367e2f9d = (value)=>(0, $5Q9JR.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);
const $0cdfec629a7fe95c$export$4c0a3527505b04c5 = (value)=>(0, $5Q9JR.GLOBAL_APP_MENU_IDS_AS_STRINGS).includes(value);
const $0cdfec629a7fe95c$export$f97a769ad5c10cb4 = (value, globalAppLicense)=>{
    switch(value){
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS:
            return globalAppLicense.assets;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS:
            return globalAppLicense.goals;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE:
            return globalAppLicense.confluence;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM:
            return globalAppLicense.loom;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS:
            return globalAppLicense.projects;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS:
            return globalAppLicense.teams;
        default:
            return false;
    }
};

});
parcelRegister("1BZ8a", function(module, exports) {
$parcel$export(module.exports, "useAppEditions", () => $a717de8a0b8e8b8b$export$92ed15881fc090d7);

var $koAZ4 = parcelRequire("koAZ4");
const $a717de8a0b8e8b8b$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});



parcelRegister("9Byj7", function(module, exports) {
$parcel$export(module.exports, "GlobalAppShortcuts", () => $a485af5218d0d252$export$69209b4d7b9e00bc);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $95rKK = parcelRequire("95rKK");

const $a485af5218d0d252$export$69209b4d7b9e00bc = ({ menuId: menuId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "global-app-shortcuts-section",
        packageName: (0, $31028703e58eb566$export$b8b9d90f9e5bd72b),
        teamName: (0, $31028703e58eb566$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $95rKK.GlobalAppShortcuts), {
        menuId: menuId
    }));

});
parcelRegister("95rKK", function(module, exports) {
$parcel$export(module.exports, "GlobalAppShortcuts", () => $f7dd192ec4f47404$export$69209b4d7b9e00bc);

var $eJOHy = parcelRequire("eJOHy");

var $h4Bzb = parcelRequire("h4Bzb");

var $qEpp6 = parcelRequire("qEpp6");

var $a9aec = parcelRequire("a9aec");

var $a62R3 = parcelRequire("a62R3");

var $1aakl = parcelRequire("1aakl");

var $5D4AX = parcelRequire("5D4AX");

var $6RXjp = parcelRequire("6RXjp");
function $f7dd192ec4f47404$export$69209b4d7b9e00bc({ menuId: menuId }) {
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            menuId: menuId,
            sectionItem: (0, $a9aec.SECTION_ITEM_MAP)[menuId]
        });
    }, [
        menuId,
        sendSectionItemAnalyticsEvent
    ]);
    switch(menuId){
        case (0, $h4Bzb.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5D4AX.Goals), {
                onClick: onClick
            });
        case (0, $h4Bzb.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1aakl.Assets), {
                onClick: onClick
            });
        case (0, $h4Bzb.GLOBAL_APP_MENU_ID).GLOBAL_APP_TEAMS:
            return (0, $a62R3.isTeamsAppEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6RXjp.Teams), {
                onClick: onClick
            }) : null;
        default:
            return null;
    }
}

});
parcelRegister("qEpp6", function(module, exports) {
$parcel$export(module.exports, "useSectionItemAnalytics", () => $4bdc0dcd80ec4722$export$88869d054e1fb00a);

var $eJOHy = parcelRequire("eJOHy");


var $a9aec = parcelRequire("a9aec");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $80rA3 = parcelRequire("80rA3");
const $4bdc0dcd80ec4722$export$ee0f05907a733e87 = ({ sectionItem: sectionItem, menuId: menuId, moreMenuIds: moreMenuIds })=>{
    if (sectionItem === (0, $a9aec.SECTION_ITEM_CUSTOMIZE_SIDEBAR)) return moreMenuIds.length !== 0;
    if (menuId) return moreMenuIds.includes(menuId);
    return false;
};
function $4bdc0dcd80ec4722$export$88869d054e1fb00a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const sendSectionItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ menuId: menuId, sectionItem: sectionItem })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const isInMore = $4bdc0dcd80ec4722$export$ee0f05907a733e87({
            sectionItem: sectionItem,
            menuId: menuId,
            moreMenuIds: moreMenuIds
        });
        (0, $kRgKj.fireUIAnalytics)(event, sectionItem, {
            isInMore: isInMore
        });
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return sendSectionItemAnalyticsEvent;
}

});

parcelRegister("1aakl", function(module, exports) {
$parcel$export(module.exports, "Assets", () => $636a621f455b216e$export$c8eca95e306f7116);

var $eJOHy = parcelRequire("eJOHy");

var $9itkV = parcelRequire("9itkV");

var $lgMTT = parcelRequire("lgMTT");

var $2dvSy = parcelRequire("2dvSy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $8IuE5 = parcelRequire("8IuE5");

var $1BZ8a = parcelRequire("1BZ8a");

var $6ANkN = parcelRequire("6ANkN");

var $8rGQ0 = parcelRequire("8rGQ0");

var $cblKs = parcelRequire("cblKs");

var $2sjJ8 = parcelRequire("2sjJ8");
function $636a621f455b216e$export$c8eca95e306f7116({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const url = '/jira/assets';
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const isNotJsmPremium = appEditions.serviceDesk !== (0, $cblKs.PREMIUM_EDITION);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    if (isNotJsmPremium) {
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: appEditions.serviceDesk,
            isSiteAdmin: isSiteAdmin
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ANkN.AssetsUpsellButton), {
            configurableMenuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS,
            lozengeText: formatMessage((0, $2sjJ8.default).lozenge)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.AssetsIcon), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.assets.menu-link-item"
    }, formatMessage((0, $2sjJ8.default).assets));
}

});
parcelRegister("9itkV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b603e49d606132e091f78e8fc1c638c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c4c8d17c994b675$var$_react = $6c4c8d17c994b675$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6c4c8d17c994b675$var$_baseNew = $6c4c8d17c994b675$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6c4c8d17c994b675$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c4c8d17c994b675$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $6c4c8d17c994b675$var$_react.default.createElement($6c4c8d17c994b675$var$_baseNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$6c4c8d17c994b675$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $6c4c8d17c994b675$var$_default = module.exports.default = $6c4c8d17c994b675$var$LinkExternalIcon;

});

parcelRegister("6ANkN", function(module, exports) {
$parcel$export(module.exports, "AssetsUpsellButton", () => $225baa7b40f9fb33$export$a04ba1c400e85b23);
$parcel$export(module.exports, "AssetsAppItem", () => $225baa7b40f9fb33$export$5803e5f720bc19ab);

var $eJOHy = parcelRequire("eJOHy");

var $9itkV = parcelRequire("9itkV");

var $jdqdp = parcelRequire("jdqdp");

var $6K9yc = parcelRequire("6K9yc");
var $avQYn = parcelRequire("avQYn");
var $dSmxJ = parcelRequire("dSmxJ");
var $i59Yb = parcelRequire("i59Yb");

var $lRq8t = parcelRequire("lRq8t");

var $2QH3X = parcelRequire("2QH3X");

var $bYOuG = parcelRequire("bYOuG");

var $8IuE5 = parcelRequire("8IuE5");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $iIEpz = parcelRequire("iIEpz");

var $8z6Yy = parcelRequire("8z6Yy");

var $6FAEa = parcelRequire("6FAEa");



var $1Q9Vz = parcelRequire("1Q9Vz");
const $225baa7b40f9fb33$var$actionsOnHover = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
    MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
            menuId: (0, $8IuE5.L1_MENU_ID).ASSETS
        })
});
const $225baa7b40f9fb33$var$linkAnalytics = {
    actionSubjectId: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
    itemId: (0, $h4Bzb.MENU_ID_ASSETS),
    level: 1
};
const $225baa7b40f9fb33$var$upsellButtonAnalytics = {
    ...$225baa7b40f9fb33$var$linkAnalytics,
    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147)
};
const $225baa7b40f9fb33$var$AssetsExternalLink = ()=>{
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).ASSETS);
    const { icon: openExternalLinkIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $1Q9Vz.default).openAssetsApp, (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: (0, $bYOuG.getRootPath)(),
        target: "_blank",
        menuId: (0, $h4Bzb.MENU_ID_ASSETS),
        analytics: $225baa7b40f9fb33$var$linkAnalytics,
        elemBefore: assetsIcon,
        elemAfter: openExternalLinkIcon,
        actionsOnHover: $225baa7b40f9fb33$var$actionsOnHover
    }, assetsMessage);
};
const $225baa7b40f9fb33$export$a04ba1c400e85b23 = ({ configurableMenuId: configurableMenuId, lozengeText: lozengeText })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const configurableMessageIcon = configurableMenuId ?? (0, $8IuE5.L1_MENU_ID).ASSETS;
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)(configurableMessageIcon);
    const upsellText = lozengeText ?? formatMessage((0, $1Q9Vz.default).upsellLozengeText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIEpz.default), {
        elemBefore: assetsIcon,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge",
            appearance: "new"
        }, upsellText),
        analytics: $225baa7b40f9fb33$var$upsellButtonAnalytics,
        onClick: ()=>{
            setIsOpen(true);
        },
        actionsOnHover: configurableMessageIcon === (0, $8IuE5.L1_MENU_ID).ASSETS ? $225baa7b40f9fb33$var$actionsOnHover : null,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.nav-4-menu-button-item"
    }, assetsMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K9yc.Drawer), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        width: "full",
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.drawer",
        label: assetsMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i59Yb.DrawerSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $avQYn.DrawerCloseButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dSmxJ.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FAEa.AsyncCmdbUpsellPage), null))));
};
const $225baa7b40f9fb33$export$5803e5f720bc19ab = ({ showUpsell: showUpsell })=>{
    if (showUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($225baa7b40f9fb33$export$a04ba1c400e85b23, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($225baa7b40f9fb33$var$AssetsExternalLink, null);
};

});
parcelRegister("jdqdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $4edb09ef87c3a639$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $4edb09ef87c3a639$var$stylesOld = {
    container: "_2rko12b0 _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    'text.bold.default': "_syaz15cr",
    'text.bold.inprogress': "_syaz15cr",
    'text.bold.moved': "_syazal3n",
    'text.bold.new': "_syaz15cr",
    'text.bold.removed': "_syaz15cr",
    'text.bold.success': "_syaz15cr",
    'text.subtle.default': "_syazjjyb",
    'text.subtle.inprogress': "_syaz1lpn",
    'text.subtle.moved': "_syaz1tm6",
    'text.subtle.new': "_syaz1mvf",
    'text.subtle.removed': "_syaz1ick",
    'text.subtle.success': "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
const $4edb09ef87c3a639$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
const $4edb09ef87c3a639$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $4edb09ef87c3a639$var$stylesNew = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhk1w7a",
    'bg.subtle.inprogress': "_bfhk1w7a",
    'bg.subtle.moved': "_bfhk1w7a",
    'bg.subtle.new': "_bfhk1w7a",
    'bg.subtle.removed': "_bfhk1w7a",
    'bg.subtle.success': "_bfhk1w7a",
    'border.subtle.default': "_19it13mh",
    'border.subtle.inprogress': "_19itd8v8",
    'border.subtle.moved': "_19it1y5u",
    'border.subtle.new': "_19it1pib",
    'border.subtle.removed': "_19itv8s6",
    'border.subtle.success': "_19itmiw9",
    'outline.subtle.default': "_1a3713mh",
    'outline.subtle.inprogress': "_1a37d8v8",
    'outline.subtle.moved': "_1a371y5u",
    'outline.subtle.new': "_1a371pib",
    'outline.subtle.removed': "_1a37v8s6",
    'outline.subtle.success': "_1a37miw9",
    'text.subtle': "_syaz1fxt",
    'text.bold': "_syazwwip"
};
const $4edb09ef87c3a639$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $4edb09ef87c3a639$var$Lozenge = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $eJOHy.useMemo)(()=>$4edb09ef87c3a639$var$appearanceTypes.includes(appearance) ? appearance : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $eGOwo.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $4edb09ef87c3a639$var$stylesNew.container,
            $4edb09ef87c3a639$var$stylesNew[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && !(0, $eGOwo.fg)('visual-refresh_drop_5') && $4edb09ef87c3a639$var$stylesNew[`border.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $eGOwo.fg)('visual-refresh_drop_5') && $4edb09ef87c3a639$var$stylesNew[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $eGOwo.fg)('visual-refresh_drop_5') && $4edb09ef87c3a639$var$stylesNew.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $hcewu.default)([
                $4edb09ef87c3a639$var$stylesNew.text,
                (0, $eGOwo.fg)('platform-lozenge-custom-letterspacing') && $4edb09ef87c3a639$var$stylesNew.customLetterspacing,
                $4edb09ef87c3a639$var$stylesNew[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        backgroundColor: $4edb09ef87c3a639$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $4edb09ef87c3a639$var$stylesOld.container,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $hcewu.default)([
                $4edb09ef87c3a639$var$stylesOldUnbounded.text,
                (0, $eGOwo.fg)('platform-lozenge-custom-letterspacing') && $4edb09ef87c3a639$var$stylesOldUnbounded.customLetterspacing,
                $4edb09ef87c3a639$var$stylesOld[`text.${appearanceStyle}.${appearanceType}`]
            ]),
            children: children
        })
    });
});
$4edb09ef87c3a639$var$Lozenge.displayName = 'Lozenge';
var $4edb09ef87c3a639$export$2e2bcd8739ae039 = $4edb09ef87c3a639$var$Lozenge;

});

parcelRegister("6K9yc", function(module, exports) {
$parcel$export(module.exports, "Drawer", () => $913b4ac24d56b20e$export$4071300121a182f5);
/// <reference types="node" />
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2PAgW = parcelRequire("2PAgW");

var $jrFnt = parcelRequire("jrFnt");

var $3rigy = parcelRequire("3rigy");
var $edcPh = parcelRequire("edcPh");

var $67YQP = parcelRequire("67YQP");

var $fFA4I = parcelRequire("fFA4I");

var $4Ug2B = parcelRequire("4Ug2B");
// escape close manager for layering
const $913b4ac24d56b20e$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $eJOHy.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $edcPh.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {});
};
const $913b4ac24d56b20e$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $eJOHy.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $2PAgW.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $67YQP.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fFA4I.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Ug2B.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3rigy.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $gt9Am.jsx)($913b4ac24d56b20e$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};

});
parcelRegister("fFA4I", function(module, exports) {
$parcel$export(module.exports, "default", () => $83aec8950234345b$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $5Lo0w = parcelRequire("5Lo0w");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");
const $83aec8950234345b$var$styles = {
    blanket: "_kqswh2mm"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $83aec8950234345b$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2rPSy.default), {
            /*
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: "large",
            /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $83aec8950234345b$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Lo0w.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
var $83aec8950234345b$export$2e2bcd8739ae039 = $83aec8950234345b$var$Blanket;

});

parcelRegister("4Ug2B", function(module, exports) {
$parcel$export(module.exports, "DrawerPanel", () => $ba92eb162f7ff756$export$96114a266f19b4d0);
/* drawer-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ys7jv = parcelRequire("Ys7jv");
var $8UpxG = parcelRequire("8UpxG");

var $5MIC8 = parcelRequire("5MIC8");

var $1eJUb = parcelRequire("1eJUb");
const $ba92eb162f7ff756$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $ba92eb162f7ff756$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect41gqc",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $ba92eb162f7ff756$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8UpxG.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
const $ba92eb162f7ff756$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $eJOHy.useRef)(null);
    const onFinish = (0, $eJOHy.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)($ba92eb162f7ff756$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1eJUb.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $hcewu.default)([
                            $ba92eb162f7ff756$var$styles.root,
                            $ba92eb162f7ff756$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5MIC8.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5MIC8.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};

});
parcelRegister("5MIC8", function(module, exports) {
$parcel$export(module.exports, "OnCloseContext", () => $0ee4a7d4bf886ca0$export$7376ab1fc7707bdd);
$parcel$export(module.exports, "useOnClose", () => $0ee4a7d4bf886ca0$export$c2b12c82f332a6fb);
$parcel$export(module.exports, "EnsureIsInsideDrawerContext", () => $0ee4a7d4bf886ca0$export$e3662b8677049786);
$parcel$export(module.exports, "useEnsureIsInsideDrawer", () => $0ee4a7d4bf886ca0$export$780b9799f6bfecd8);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $0ee4a7d4bf886ca0$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $0ee4a7d4bf886ca0$export$c2b12c82f332a6fb = ()=>(0, $eJOHy.useContext)($0ee4a7d4bf886ca0$export$7376ab1fc7707bdd);
const $0ee4a7d4bf886ca0$export$e3662b8677049786 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $0ee4a7d4bf886ca0$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $eJOHy.useContext)($0ee4a7d4bf886ca0$export$e3662b8677049786);
    (0, $8GOss.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};

});

parcelRegister("1eJUb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e04203bc33d5236f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1Q3jn = parcelRequire("1Q3jn");
/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $e04203bc33d5236f$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1Q3jn.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
var $e04203bc33d5236f$export$2e2bcd8739ae039 = $e04203bc33d5236f$var$FocusLock;

});



parcelRegister("avQYn", function(module, exports) {
$parcel$export(module.exports, "DrawerCloseButton", () => $623d7a54f341f128$export$d0c3a75c17ac0cab);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $lqfmR = parcelRequire("lqfmR");

var $5MIC8 = parcelRequire("5MIC8");
const $623d7a54f341f128$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $5MIC8.useEnsureIsInsideDrawer)();
    const onClose = (0, $5MIC8.useOnClose)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...iconProps,
                size: "large",
                LEGACY_size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($lqfmR))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};

});

parcelRegister("dSmxJ", function(module, exports) {
$parcel$export(module.exports, "DrawerContent", () => $289747ca5067af71$export$57ca055474bc0056);
/* drawer-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ecYd5 = parcelRequire("ecYd5");

var $kmlzw = parcelRequire("kmlzw");

var $5MIC8 = parcelRequire("5MIC8");

var $dfn7e = parcelRequire("dfn7e");
const $289747ca5067af71$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $289747ca5067af71$var$DrawerContentBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $eJOHy.useState)(false);
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $289747ca5067af71$var$styles.default,
            xcss
        ]),
        ref: (0, $kmlzw.mergeRefs)([
            ref,
            scrollableRef
        ]),
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $289747ca5067af71$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $5MIC8.useEnsureIsInsideDrawer)();
    (0, $dfn7e.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ecYd5))), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($289747ca5067af71$var$DrawerContentBase, {
            scrollContentLabel: scrollContentLabel,
            xcss: xcss,
            children: children
        })
    });
};

});
parcelRegister("dfn7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $572fb9a7a11e9679$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $572fb9a7a11e9679$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $572fb9a7a11e9679$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $eJOHy.useState)(0);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setScrollTopOffset($572fb9a7a11e9679$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $eJOHy.useCallback)(()=>{
        if ($572fb9a7a11e9679$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return (0, $4eDgu.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("i59Yb", function(module, exports) {
$parcel$export(module.exports, "DrawerSidebar", () => $e08bb970695056f8$export$25c48648e7980210);
/* drawer-sidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5MIC8 = parcelRequire("5MIC8");
const $e08bb970695056f8$var$styles = {
    default: "_4cvr1h6o _vchhusvi _syaz1gjq _1e0c1txw _1o9zidpf _2lx21bp4 _4t3i1kxc _n3tdpxbi _ca0q1ejb _1bsbxncg"
};
const $e08bb970695056f8$export$25c48648e7980210 = ({ children: children, xcss: xcss })=>{
    (0, $5MIC8.useEnsureIsInsideDrawer)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $e08bb970695056f8$var$styles.default,
            xcss
        ]),
        "data-testid": "drawer-sidebar",
        children: children
    });
};

});

parcelRegister("bYOuG", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $59de792af1bc0730$export$42e57fb76a904fc3);
$parcel$export(module.exports, "ASSETS_APP_OBJECT_ROUTE_PREFIX", () => $59de792af1bc0730$export$aede099f2ae23728);
$parcel$export(module.exports, "isInsightRoute", () => $59de792af1bc0730$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $59de792af1bc0730$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $59de792af1bc0730$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $59de792af1bc0730$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $59de792af1bc0730$export$20fd4a0aec335970);
$parcel$export(module.exports, "getAssetsSettingsUrl", () => $59de792af1bc0730$export$15f6d6ab94d89135);
$parcel$export(module.exports, "getDataManagerUrl", () => $59de792af1bc0730$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerGettingStartedUrl", () => $59de792af1bc0730$export$3d0380185f73b3d);
$parcel$export(module.exports, "getDataManagerObjectClassesUrl", () => $59de792af1bc0730$export$4c9768bc51c7a1a);
$parcel$export(module.exports, "getDataManagerVisualizationUrl", () => $59de792af1bc0730$export$6c3cb6f103b2324);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $59de792af1bc0730$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $59de792af1bc0730$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsDashboardsUrl", () => $59de792af1bc0730$export$da30a4c2eb7e2c58);
$parcel$export(module.exports, "getAssetsReportUrl", () => $59de792af1bc0730$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsForYouUrl", () => $59de792af1bc0730$export$ea8a41c5d5a50829);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $59de792af1bc0730$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $59de792af1bc0730$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $59de792af1bc0730$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $59de792af1bc0730$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $59de792af1bc0730$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $59de792af1bc0730$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $59de792af1bc0730$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $59de792af1bc0730$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $59de792af1bc0730$export$415502b49e27270d);

var $b5RwB = parcelRequire("b5RwB");

var $4cTDP = parcelRequire("4cTDP");

var $9suIz = parcelRequire("9suIz");
const $59de792af1bc0730$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $59de792af1bc0730$export$42e57fb76a904fc3 = '/jira/assets';
const $59de792af1bc0730$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $59de792af1bc0730$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $59de792af1bc0730$export$aede099f2ae23728 = '/jira/assets/object';
const $59de792af1bc0730$export$296d80f3ce129968 = (pathname)=>pathname.includes($59de792af1bc0730$export$6d7574dbda22cf7);
const $59de792af1bc0730$export$1f9b8b558a361aaf = ()=>$59de792af1bc0730$export$ee637ecb2dfa4f6a;
const $59de792af1bc0730$export$5413f45d031c7806 = ()=>(0, $4cTDP.fg)('assets_as_an_app_v2') ? $59de792af1bc0730$export$42e57fb76a904fc3 : $59de792af1bc0730$export$80e512187a5e0d10;
const $59de792af1bc0730$export$9366da5a373815e5 = ()=>$59de792af1bc0730$export$5413f45d031c7806();
const $59de792af1bc0730$export$20fd4a0aec335970 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/global`;
const $59de792af1bc0730$export$15f6d6ab94d89135 = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/configure/global`;
const $59de792af1bc0730$export$c9b27b0d2e19d52f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/data-manager/`;
const $59de792af1bc0730$export$3d0380185f73b3d = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/getting-started`;
const $59de792af1bc0730$export$4c9768bc51c7a1a = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/object-classes`;
const $59de792af1bc0730$export$6c3cb6f103b2324 = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/#/dashboards`;
const $59de792af1bc0730$export$cd6b35373ba077a = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/data-manager/adapters/`;
const $59de792af1bc0730$export$c1909404b7ea317f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/reports`;
const $59de792af1bc0730$export$da30a4c2eb7e2c58 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/dashboards`;
const $59de792af1bc0730$export$771825afb10f956f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/analytics/data-view/create`;
const $59de792af1bc0730$export$272d35cbff1c220e = (reportId)=>`${$59de792af1bc0730$export$c1909404b7ea317f()}/${reportId}`;
const $59de792af1bc0730$export$97bfda8f5f38a121 = (query)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $59de792af1bc0730$export$ea8a41c5d5a50829 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/for-you`;
const $59de792af1bc0730$export$c48ea1282c74411e = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object-schemas`;
const $59de792af1bc0730$export$3a0332e980fe56cf = (objectSchemaId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $59de792af1bc0730$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$59de792af1bc0730$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $9suIz.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $59de792af1bc0730$export$f02479149ce3cac7 = (objectSchemaId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $59de792af1bc0730$export$51e4229f2c7d3866 = (objectId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object/${objectId}`;
const $59de792af1bc0730$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $59de792af1bc0730$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$59de792af1bc0730$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $59de792af1bc0730$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$59de792af1bc0730$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $59de792af1bc0730$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>(0, $4cTDP.fg)('aurum-677-assets-usage-migration') ? '/jira/assets/configure/global?menu=app-usage' : `/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $59de792af1bc0730$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("9suIz", function(module, exports) {
$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $38b78989e1c789e8$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $38b78989e1c789e8$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $38b78989e1c789e8$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $38b78989e1c789e8$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $38b78989e1c789e8$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_COMMON_DATA_MODEL", () => $38b78989e1c789e8$export$b5445f8b5c64a799);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $38b78989e1c789e8$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $38b78989e1c789e8$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $38b78989e1c789e8$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $38b78989e1c789e8$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $38b78989e1c789e8$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $38b78989e1c789e8$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $38b78989e1c789e8$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $38b78989e1c789e8$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $38b78989e1c789e8$export$1927b50f7d074492);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $4ZeQj = parcelRequire("4ZeQj");

var $95O7y = parcelRequire("95O7y");
var $gCY1z = parcelRequire("gCY1z");
var $83DiZ = parcelRequire("83DiZ");
const $38b78989e1c789e8$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $38b78989e1c789e8$export$f7855185bab37329 = 'reference-types';
const $38b78989e1c789e8$export$3739ebbc7c6e87e8 = 'statuses';
const $38b78989e1c789e8$export$2c22dc6c729ae0bd = 'icons';
const $38b78989e1c789e8$export$f37b3a97acf56eaf = 'data-manager';
const $38b78989e1c789e8$export$b5445f8b5c64a799 = 'common-data-model';
const $38b78989e1c789e8$export$12ebb1d5017e1d6d = 'general';
const $38b78989e1c789e8$export$a77734d9ea30fe44 = 'roles';
const $38b78989e1c789e8$export$be37b820df30c947 = 'import';
const $38b78989e1c789e8$export$670faa8ae93e0903 = 'inheritance';
const $38b78989e1c789e8$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const [{ location: location }] = (0, $gCY1z.useRouter)();
    const updateQueryParams = (0, $eJOHy.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $eJOHy.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $38b78989e1c789e8$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $eJOHy.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $4ZeQj.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $4ZeQj.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $4ZeQj.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $38b78989e1c789e8$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $4ZeQj.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $38b78989e1c789e8$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $38b78989e1c789e8$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});
parcelRegister("4ZeQj", function(module, exports) {
$parcel$export(module.exports, "toSchemaId", () => $a31a1cf0aae81680$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $a31a1cf0aae81680$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $a31a1cf0aae81680$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $a31a1cf0aae81680$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $a31a1cf0aae81680$export$cfd92c18cee8add7);
const $a31a1cf0aae81680$export$d577b7f3b832f656 = (id)=>id;
const $a31a1cf0aae81680$export$1ba342595bc7be13 = (id)=>id;
const $a31a1cf0aae81680$export$b46e25afa2bab6a = (id)=>id;
const $a31a1cf0aae81680$export$d002b8d7821b6b59 = (id)=>id;
const $a31a1cf0aae81680$export$ece2917434bb0a8c = (id)=>id;
const $a31a1cf0aae81680$export$cfd92c18cee8add7 = (id)=>id;

});



parcelRegister("59lfa", function(module, exports) {
$parcel$export(module.exports, "HideL1MenuItemSection", () => $87aee0eb86812bcf$export$a6246d2fccf72824);

var $7CMe6 = parcelRequire("7CMe6");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7saMl = parcelRequire("7saMl");
var $6YEko = parcelRequire("6YEko");

var $3cMgR = parcelRequire("3cMgR");

var $8nw3F = parcelRequire("8nw3F");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $kRgKj = parcelRequire("kRgKj");

var $cHtIB = parcelRequire("cHtIB");

var $80rA3 = parcelRequire("80rA3");

var $gJU90 = parcelRequire("gJU90");

var $k3BsH = parcelRequire("k3BsH");

var $i3VM0 = parcelRequire("i3VM0");
const $87aee0eb86812bcf$var$HIDE_ROOT_MENU_ITEM_SUCCESS = 'HIDE_ROOT_MENU_ITEM_SUCCESS';
const $87aee0eb86812bcf$var$RESTORE_ROOT_MENU_ITEM_SUCCESS = 'RESTORE_ROOT_MENU_ITEM_SUCCESS';
function $87aee0eb86812bcf$var$HideL1MenuItemSectionInner(props) {
    const { menuId: menuId } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { navItems: navItems } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $eJOHy.useContext)((0, $80rA3.PeekMenuIdContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudID = (0, $cHtIB.useCloudId)();
    const [isHidden, setIsHidden] = (0, $eJOHy.useState)(false);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $7CMe6.default));
    const onSave = (0, $eJOHy.useCallback)((newNavItems)=>{
        commit({
            variables: {
                input: {
                    cloudID: cloudID,
                    navKey: 'NAV_SIDEBAR',
                    navItems: newNavItems
                }
            }
        });
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarNavItems changed', {
            originalNavItems: navItems,
            updatedNavItems: newNavItems,
            changedFrom: 'hideFromSidebarButton'
        });
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_MAP)[menuId],
                itemId: 'hideFromSidebar'
            }
        });
    }, [
        cloudID,
        commit,
        createAnalyticsEvent,
        menuId,
        navItems
    ]);
    const toggleNavItemVisibility = (0, $eJOHy.useCallback)(({ isVisible: isVisible })=>{
        const newNavItems = navItems.map((item)=>{
            if (item.menuId === menuId) return {
                ...item,
                isVisible: isVisible
            };
            return {
                ...item
            };
        });
        return newNavItems;
    }, [
        menuId,
        navItems
    ]);
    const onRestoreRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: true
            });
            onSave(newNavItems);
            setIsHidden(false);
            showFlag({
                type: 'success',
                id: $87aee0eb86812bcf$var$RESTORE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $i3VM0.getNavItemRestoredFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.restore-root-menu-item-success',
                messageType: 'transactional'
            });
        }
    };
    const onHideRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: false
            });
            onSave(newNavItems);
            setIsHidden(true);
            showFlag({
                type: 'success',
                id: $87aee0eb86812bcf$var$HIDE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $i3VM0.getNavItemHiddenFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.hide-root-menu-item-success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $k3BsH.default).moveBackToSidebar,
                        onClick: ()=>{
                            onRestoreRootMenuItem();
                            dismissFlag($87aee0eb86812bcf$var$HIDE_ROOT_MENU_ITEM_SUCCESS);
                        }
                    }
                ]
            });
        }
    };
    // When the peekend menu id is the same as the menu id, the menu item is disabled because it's not possible
    // to hide an already hidden menu item. Do indicate this we need to both disable the button and set the color
    // of the icon and text appropriately.
    const isDisabled = peekMenuId === menuId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
        message: formatMessage((0, $i3VM0.getA11YAlert)(menuId)),
        shouldAnnounce: isHidden
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        interactionName: "nav4-sidebar-hide-from-sidebar-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gJU90.HideIcon), {
            label: "",
            primaryColor: isDisabled ? 'color.icon.disabled' : 'color.icon'
        }),
        onClick: onHideRootMenuItem,
        isDisabled: isDisabled,
        "aria-label": formatMessage((0, $i3VM0.getA11YLabel)(menuId))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, formatMessage((0, $k3BsH.default).hideFromSidebar))));
}
function $87aee0eb86812bcf$export$a6246d2fccf72824(props) {
    const { hasSeparator: hasSeparator = true, hasSection: hasSection = true } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: (0, $427a1e7fccde0648$export$a3821bc63538b210),
        sourceType: (0, $aa42ce8e355d58fa$export$d1123261ca8831d2),
        containerId: (0, $427a1e7fccde0648$export$3c19576bd92ff564),
        containerType: (0, $427a1e7fccde0648$export$fba7c3adda5094d9)
    }, hasSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: hasSeparator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87aee0eb86812bcf$var$HideL1MenuItemSectionInner, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87aee0eb86812bcf$var$HideL1MenuItemSectionInner, props));
}

});
parcelRegister("7CMe6", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8c48e1cc2de5827$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<051e81191e9528d0339140ee7536941d>>
 * @relayHash 66baa10107c8516c24b8ed85cb97aa27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77
const $c8c48e1cc2de5827$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "JiraConfigurableNavigationItem",
        "kind": "LinkedField",
        "name": "navItems",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "menuId"
            },
            {
                "kind": "ScalarField",
                "name": "isVisible"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77",
            "metadata": {},
            "name": "hideL1MenuItemActionMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c8c48e1cc2de5827$var$node.hash = "1b96ba09e281b673ec1bfa126587621b";
var $c8c48e1cc2de5827$export$2e2bcd8739ae039 = $c8c48e1cc2de5827$var$node;

});

parcelRegister("8nw3F", function(module, exports) {
$parcel$export(module.exports, "AnnouncerV2", () => $d17828002089f92c$export$a43c8a2f4981e0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9cbmy = parcelRequire("9cbmy");
const $d17828002089f92c$var$NON_BREAKING_SPACE = '\u00A0';
const $d17828002089f92c$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $eJOHy.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $eJOHy.useRef)('');
    const setAlternatePolite = (0, $eJOHy.useRef)(false);
    const addSuffix = (0, $eJOHy.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $eJOHy.useState)('');
    const [newMessage, setNewMessage] = (0, $eJOHy.useState)('');
    (0, $eJOHy.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $d17828002089f92c$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $d17828002089f92c$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $9cbmy.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ $eJOHy.createElement((0, $9cbmy.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});
const $d17828002089f92c$var$positionRelative = null;

});
parcelRegister("9cbmy", function(module, exports) {
$parcel$export(module.exports, "visuallyHiddenStyles", () => $f808b80c4ecef983$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $f808b80c4ecef983$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $f808b80c4ecef983$export$200c8e5d652aa9af);
$parcel$export(module.exports, "ScreenReaderLegend", () => $f808b80c4ecef983$export$dabfb48aa98ffd97);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 * Styled copied from @atlaskit/visually-hidden
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f808b80c4ecef983$export$8dd524ceb40e3d16 = {
    width: '1px',
    height: '1px',
    padding: 0,
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $f808b80c4ecef983$export$88fad6aa294f111c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f808b80c4ecef983$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f808b80c4ecef983$export$dabfb48aa98ffd97 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});


const $493796f3bdee881c$export$4165a3d0da3bd147 = 'fixedItem';
const $493796f3bdee881c$export$95b0c331af13d819 = 'fixedItemButton';
const $493796f3bdee881c$export$74712b62056d422e = 'fixedItemAction';
const $493796f3bdee881c$export$3ac911b122986477 = 'customItem';
const $493796f3bdee881c$export$9bd6c21d500ae611 = 'customItemButton';
const $493796f3bdee881c$export$5374c2c2d3ece55e = 'customItemAction';
const $493796f3bdee881c$export$56981f28056f258e = 'customItemDropdownAction';
const $493796f3bdee881c$export$17bca95234dea43b = 'fixedItemDropdownAction';

const $427a1e7fccde0648$export$a3821bc63538b210 = 'customiseSidebar';
const $427a1e7fccde0648$export$fba7c3adda5094d9 = 'sidebar-nav4';
const $427a1e7fccde0648$export$3c19576bd92ff564 = 'sidebar-content';

const $4fdd5d9c1b32dd60$export$265c523d1a8f25cf = '1';
const $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1 = '2';
const $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18 = '3';
const $4fdd5d9c1b32dd60$export$35ac629b8b943d5a = '4';

parcelRegister("2LcvY", function(module, exports) {
$parcel$export(module.exports, "getSideNavToggleButtonAnalyticEventPayload", () => $bc37d0e87c8ee0e1$export$7165a1ebf1926b86);
$parcel$export(module.exports, "MENU_ID_ANALYTIC_EVENT_IDS", () => $bc37d0e87c8ee0e1$export$d70e7a5f39328991);

var $h4Bzb = parcelRequire("h4Bzb");





var $a9aec = parcelRequire("a9aec");
const $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE = 'sidebarToggle';
const $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE = 'collapse';
const $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE_ACTION_EXPAND = 'expand';
const $bc37d0e87c8ee0e1$var$CLICKED = 'clicked';
const $bc37d0e87c8ee0e1$export$7165a1ebf1926b86 = (isSideNavVisible, stage)=>{
    const toggleAction = isSideNavVisible ? $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE : $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE_ACTION_EXPAND;
    const payload = {
        action: $bc37d0e87c8ee0e1$var$CLICKED,
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE,
        attributes: {
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $95eb6070d868c1b7$export$793ed84f5e13fedc),
            stage: stage,
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            toggleAction: toggleAction
        }
    };
    return payload;
};
const $bc37d0e87c8ee0e1$export$d70e7a5f39328991 = {
    [(0, $h4Bzb.MENU_ID_APPS)]: 'appsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_ASSETS)]: 'assetsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_DASHBOARDS)]: 'dashboardsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_FILTERS)]: 'filtersNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_GOALS)]: 'goalsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_OPERATIONS)]: 'operationsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_OVERVIEWS)]: 'overviewsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_PLANS)]: 'plansNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_PROJECTS)]: 'projectsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_RECENT)]: 'recentNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_STARRED)]: 'starredNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_TEAMS)]: 'teamsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_ROADMAPS)]: 'roadmapsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE)]: 'customerServiceMenuItem',
    [(0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS)]: 'customerServiceAnalyticsMenuItem',
    [(0, $h4Bzb.MENU_ID_CUSTOMERS)]: 'customerServiceCustomersMenuItem',
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_ASSETS)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_ASSETS),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_GOALS)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_GOALS),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_CONFLUENCE)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_CONFLUENCE),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_LOOM)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_LOOM),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_TEAMS)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_TEAMS),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_PROJECTS)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_PROJECTS),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_OPSGENIE)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_OPSGENIE)
};

});
const $107c403b1827dc68$export$d2aa6c54a5925f01 = 'v3';
const $107c403b1827dc68$export$2bd315ece9f68967 = 'v4';

const $95eb6070d868c1b7$export$2ee9e5a3556c1e43 = 'sidebar';
const $95eb6070d868c1b7$export$793ed84f5e13fedc = 'top';
const $95eb6070d868c1b7$export$f1c9dd0f5207dd5e = 'tab';
const $95eb6070d868c1b7$export$b83d0ee9325a2d0a = 'projectTitle';

// TopNav or sidebar
const $002870cfa80d64f4$export$17ff3f7e02c6ac22 = 'global';
const $002870cfa80d64f4$export$33d8c916a600c5e9 = 'container';


// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("gJU90", function(module, exports) {
$parcel$export(module.exports, "HideIcon", () => $3fb30821b73211e6$export$3fa055d21925b0d3);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $3fb30821b73211e6$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        id: "icon <icon>"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        id: "Vector",
        d: "M19.2405 10.6209L18.9347 11.3057C18.734 11.7553 18.3679 12.2877 17.8832 12.8226L18.5909 13.5303C18.8838 13.8232 18.8838 14.2981 18.5909 14.591C18.298 14.8839 17.8231 14.8839 17.5302 14.591L16.7926 13.8534C16.6895 13.9372 16.5839 14.0197 16.4761 14.1004C15.998 14.4583 15.4587 14.795 14.8732 15.0696L15.3415 16.0062C15.5267 16.3767 15.3766 16.8272 15.0061 17.0125C14.6356 17.1977 14.1851 17.0475 13.9999 16.677L13.4486 15.5744C12.9819 15.6864 12.4971 15.75 11.9999 15.75C11.5026 15.75 11.0179 15.6864 10.5512 15.5744L9.99986 16.677C9.81462 17.0475 9.36412 17.1977 8.99363 17.0125C8.62315 16.8272 8.47298 16.3767 8.65822 16.0062L9.12653 15.0696C8.54102 14.795 8.00173 14.4583 7.5236 14.1004C7.41582 14.0197 7.31026 13.9372 7.20713 13.8534L6.46955 14.591C6.17666 14.8839 5.70179 14.8839 5.40889 14.591C5.116 14.2981 5.116 13.8232 5.40889 13.5303L6.11656 12.8227C5.63186 12.2877 5.26571 11.7553 5.06502 11.3057L4.75928 10.6209L6.12898 10.0094L6.43472 10.6943C6.66455 11.2091 7.37568 12.1158 8.42257 12.8996C9.45878 13.6754 10.7174 14.25 11.9999 14.25C13.2823 14.25 14.541 13.6754 15.5772 12.8996C16.6241 12.1158 17.3352 11.2091 17.565 10.6943L17.8708 10.0094L19.2405 10.6209Z",
        fill: "currentColor"
    })));
const $3fb30821b73211e6$export$3fa055d21925b0d3 = (props)=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $3fb30821b73211e6$var$CustomGlyph,
        ...props
    });

});

parcelRegister("k3BsH", function(module, exports) {
$parcel$export(module.exports, "default", () => $595afa4abc0c2509$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $595afa4abc0c2509$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    hideFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.hide-from-sidebar",
        "defaultMessage": "Hide from sidebar"
    },
    a11YAlertHideDefaultFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-default-from-sidebar",
        "defaultMessage": "Menu Item have been hidden from the sidebar"
    },
    // apps
    a11YHideAppsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-apps-from-sidebar",
        "defaultMessage": "Hide apps from sidebar"
    },
    a11YAlertHideAppsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-apps-from-sidebar",
        "defaultMessage": "Apps have been hidden from the sidebar"
    },
    // assets
    a11YHideAssetsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-assets-from-sidebar",
        "defaultMessage": "Hide assets from sidebar"
    },
    a11YAlertHideAssetsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-assets-from-sidebar",
        "defaultMessage": "Assets have been hidden from the sidebar"
    },
    // dashboards
    a11YHideDashboardsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-dashboards-from-sidebar",
        "defaultMessage": "Hide dashboards from sidebar"
    },
    a11YAlertHideDashboardsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-dashboards-from-sidebar",
        "defaultMessage": "Dashboards have been hidden from the sidebar"
    },
    // filters
    a11YHideFiltersFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-filters-from-sidebar",
        "defaultMessage": "Hide filters from sidebar"
    },
    a11YAlertHideFiltersFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-filters-from-sidebar",
        "defaultMessage": "Filters have been hidden from the sidebar"
    },
    // goals
    a11YHideGoalsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-goals-from-sidebar",
        "defaultMessage": "Hide goals from sidebar"
    },
    a11YAlertHideGoalsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-goals-from-sidebar",
        "defaultMessage": "Goals have been hidden from the sidebar"
    },
    // operations
    a11YHideOperationsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-operations-from-sidebar",
        "defaultMessage": "Hide operations from sidebar"
    },
    a11YAlertHideOperationsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-operations-from-sidebar",
        "defaultMessage": "Operations have been hidden from the sidebar"
    },
    // overviews
    a11YHideOverviewsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-overviews-from-sidebar",
        "defaultMessage": "Hide overviews from sidebar"
    },
    a11YAlertHideOverviewsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-overviews-from-sidebar",
        "defaultMessage": "Overviews have been hidden from the sidebar"
    },
    // plans
    a11YHidePlansFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-plans-from-sidebar",
        "defaultMessage": "Hide plans from sidebar"
    },
    a11YAlertHidePlansFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-plans-from-sidebar",
        "defaultMessage": "Plans have been hidden from the sidebar"
    },
    // projects
    a11YHideProjectsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar",
        "defaultMessage": "Hide projects from sidebar"
    },
    a11YAlertHideProjectsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar",
        "defaultMessage": "Projects have been hidden from the sidebar"
    },
    // teams
    a11YHideTeamsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-teams-from-sidebar",
        "defaultMessage": "Hide teams from sidebar"
    },
    a11YAlertHideTeamsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-teams-from-sidebar",
        "defaultMessage": "Teams have been hidden from the sidebar"
    },
    // roadmaps
    a11YHideRoadmapsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-roadmaps-from-sidebar",
        "defaultMessage": "Hide roadmaps from sidebar"
    },
    a11YAlertHideRoadmapsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-roadmaps-from-sidebar",
        "defaultMessage": "Roadmaps have been hidden from the sidebar"
    },
    // flags related texts
    moveBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.move-back-to-sidebar",
        "defaultMessage": "Move back to sidebar"
    },
    defaultHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-hidden-from-sidebar",
        "defaultMessage": "Hidden from sidebar"
    },
    appsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-hidden-from-sidebar",
        "defaultMessage": "Apps hidden from sidebar"
    },
    assetsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-hidden-from-sidebar",
        "defaultMessage": "Assets hidden from sidebar"
    },
    dashboardsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-hidden-from-sidebar",
        "defaultMessage": "Dashboards hidden from sidebar"
    },
    filtersHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-hidden-from-sidebar",
        "defaultMessage": "Filters hidden from sidebar"
    },
    goalsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-hidden-from-sidebar",
        "defaultMessage": "Goals hidden from sidebar"
    },
    operationsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-hidden-from-sidebar",
        "defaultMessage": "Operations hidden from sidebar"
    },
    overviewsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-hidden-from-sidebar",
        "defaultMessage": "Overviews hidden from sidebar"
    },
    plansHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-hidden-from-sidebar",
        "defaultMessage": "Plans hidden from sidebar"
    },
    projectsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar",
        "defaultMessage": "Projects hidden from sidebar"
    },
    teamsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-hidden-from-sidebar",
        "defaultMessage": "Teams hidden from sidebar"
    },
    roadmapsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-hidden-from-sidebar",
        "defaultMessage": "Roadmaps hidden from sidebar"
    },
    defaultMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-moved-back-to-sidebar",
        "defaultMessage": "Moved back to sidebar"
    },
    appsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-moved-back-to-sidebar",
        "defaultMessage": "Apps moved back to sidebar"
    },
    assetsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-moved-back-to-sidebar",
        "defaultMessage": "Assets moved back to sidebar"
    },
    dashboardsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-moved-back-to-sidebar",
        "defaultMessage": "Dashboards moved back to sidebar"
    },
    filtersMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-moved-back-to-sidebar",
        "defaultMessage": "Filters moved back to sidebar"
    },
    goalsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-moved-back-to-sidebar",
        "defaultMessage": "Goals moved back to sidebar"
    },
    operationsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-moved-back-to-sidebar",
        "defaultMessage": "Operations moved back to sidebar"
    },
    overviewsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-moved-back-to-sidebar",
        "defaultMessage": "Overviews moved back to sidebar"
    },
    plansMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-moved-back-to-sidebar",
        "defaultMessage": "Plans moved back to sidebar"
    },
    projectsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar",
        "defaultMessage": "Projects moved back to sidebar"
    },
    teamsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-moved-back-to-sidebar",
        "defaultMessage": "Teams moved back to sidebar"
    },
    roadmapsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-moved-back-to-sidebar",
        "defaultMessage": "Roadmaps moved back to sidebar"
    },
    a11YHideProjectsFromSidebarGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar-galaxia",
        "defaultMessage": "Hide spaces from sidebar"
    },
    a11YAlertHideProjectsFromSidebarGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar-galaxia",
        "defaultMessage": "Spaces have been hidden from the sidebar"
    },
    projectsHiddenFromSidebarGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar-galaxia",
        "defaultMessage": "Spaces hidden from sidebar"
    },
    projectsMovedBackToSidebarGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar-galaxia",
        "defaultMessage": "Spaces moved back to sidebar"
    }
});

});

parcelRegister("i3VM0", function(module, exports) {
$parcel$export(module.exports, "getA11YLabel", () => $2de70f079af73e1d$export$fcb002b66b92bf50);
$parcel$export(module.exports, "getA11YAlert", () => $2de70f079af73e1d$export$45edd6abaa8989eb);
$parcel$export(module.exports, "getNavItemHiddenFromSideBarFlagTitle", () => $2de70f079af73e1d$export$95caae642a80ad);
$parcel$export(module.exports, "getNavItemRestoredFromSideBarFlagTitle", () => $2de70f079af73e1d$export$d4ad18508eb0e1ec);

var $cxKOj = parcelRequire("cxKOj");

var $8IuE5 = parcelRequire("8IuE5");

var $k3BsH = parcelRequire("k3BsH");
const $2de70f079af73e1d$export$fcb002b66b92bf50 = (menuId)=>{
    const a11YHideProjectsFromSidebarGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k3BsH.default).a11YHideProjectsFromSidebarGalaxia : (0, $k3BsH.default).a11YHideProjectsFromSidebar;
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return (0, $k3BsH.default).a11YHideAppsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return (0, $k3BsH.default).a11YHideGoalsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return (0, $k3BsH.default).a11YHideRoadmapsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return (0, $k3BsH.default).a11YHidePlansFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return a11YHideProjectsFromSidebarGalaxia;
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return (0, $k3BsH.default).a11YHideFiltersFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return (0, $k3BsH.default).a11YHideDashboardsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return (0, $k3BsH.default).a11YHideOverviewsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return (0, $k3BsH.default).a11YHideOperationsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            return (0, $k3BsH.default).a11YHideAssetsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return (0, $k3BsH.default).a11YHideTeamsFromSidebar;
        default:
            return (0, $k3BsH.default).hideFromSidebar;
    }
};
const $2de70f079af73e1d$export$45edd6abaa8989eb = (menuId)=>{
    const a11YAlertHideProjectsFromSidebarGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k3BsH.default).a11YAlertHideProjectsFromSidebarGalaxia : (0, $k3BsH.default).a11YAlertHideProjectsFromSidebar;
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return (0, $k3BsH.default).a11YAlertHideAppsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return (0, $k3BsH.default).a11YAlertHideGoalsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return (0, $k3BsH.default).a11YAlertHideRoadmapsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return (0, $k3BsH.default).a11YAlertHidePlansFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return a11YAlertHideProjectsFromSidebarGalaxia;
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return (0, $k3BsH.default).a11YAlertHideFiltersFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return (0, $k3BsH.default).a11YAlertHideDashboardsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return (0, $k3BsH.default).a11YAlertHideOverviewsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return (0, $k3BsH.default).a11YAlertHideOperationsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            return (0, $k3BsH.default).a11YAlertHideAssetsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return (0, $k3BsH.default).a11YAlertHideTeamsFromSidebar;
        default:
            return (0, $k3BsH.default).a11YAlertHideDefaultFromSidebar;
    }
};
const $2de70f079af73e1d$export$95caae642a80ad = (menuId)=>{
    const projectsHiddenFromSidebarGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k3BsH.default).projectsHiddenFromSidebarGalaxia : (0, $k3BsH.default).projectsHiddenFromSidebar;
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return (0, $k3BsH.default).appsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return (0, $k3BsH.default).goalsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return (0, $k3BsH.default).roadmapsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return (0, $k3BsH.default).plansHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return projectsHiddenFromSidebarGalaxia;
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return (0, $k3BsH.default).filtersMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return (0, $k3BsH.default).dashboardsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return (0, $k3BsH.default).overviewsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return (0, $k3BsH.default).operationsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            return (0, $k3BsH.default).assetsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return (0, $k3BsH.default).teamsHiddenFromSidebar;
        default:
            return (0, $k3BsH.default).defaultHiddenFromSidebar;
    }
};
const $2de70f079af73e1d$export$d4ad18508eb0e1ec = (menuId)=>{
    const projectsMovedBackToSidebarGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k3BsH.default).projectsMovedBackToSidebarGalaxia : (0, $k3BsH.default).projectsMovedBackToSidebar;
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return (0, $k3BsH.default).appsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return (0, $k3BsH.default).goalsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return (0, $k3BsH.default).roadmapsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return (0, $k3BsH.default).plansMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return projectsMovedBackToSidebarGalaxia;
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return (0, $k3BsH.default).filtersMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return (0, $k3BsH.default).dashboardsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return (0, $k3BsH.default).overviewsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return (0, $k3BsH.default).operationsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            return (0, $k3BsH.default).assetsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return (0, $k3BsH.default).teamsMovedBackToSidebar;
        default:
            return (0, $k3BsH.default).defaultMovedBackToSidebar;
    }
};

});


parcelRegister("iIEpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6444ffd590501f9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kKTZh = parcelRequire("kKTZh");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $hrKgE = parcelRequire("hrKgE");
const $c6444ffd590501f9$var$ButtonMenuItemWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const stableAnalytics = (0, $hrKgE.useShallowStableReference)(analytics);
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!stableAnalytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = stableAnalytics;
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, analyticsAttributes);
    }, [
        stableAnalytics,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKTZh.ButtonMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
var $c6444ffd590501f9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)($c6444ffd590501f9$var$ButtonMenuItemWithAnalytics);

});
parcelRegister("kKTZh", function(module, exports) {
$parcel$export(module.exports, "ButtonMenuItem", () => $50bfa7f4b8f64029$export$6dc09b7c0ec1dfcd);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $2tKAE = parcelRequire("2tKAE");

var $ih05Y = parcelRequire("ih05Y");
const $50bfa7f4b8f64029$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ih05Y.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKAE.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: (0, $eGOwo.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaControls : undefined,
            ariaExpanded: (0, $eGOwo.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaExpanded : undefined,
            ariaHasPopup: (0, $eGOwo.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaHasPopup : undefined,
            isSelected: (0, $eGOwo.fg)('platform-dst-buttonmenuitem-selected-state-support') ? isSelected : undefined,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});

});
parcelRegister("ih05Y", function(module, exports) {
$parcel$export(module.exports, "MenuListItem", () => $8ad28d791afa23ab$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4sCzd = parcelRequire("4sCzd");
const $8ad28d791afa23ab$export$6c2f3257abc4825b = (0, $4sCzd.ListItem);

});


parcelRegister("hrKgE", function(module, exports) {
$parcel$export(module.exports, "useShallowStableReference", () => $06a9fa47a6e96bcb$export$cb8a85c49e39f60);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions */ 
var $eJOHy = parcelRequire("eJOHy");

var $j5V5L = parcelRequire("j5V5L");
const $06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT = Object.freeze({});
const $06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY = Object.freeze([]);
const $06a9fa47a6e96bcb$export$419c5efa1812e327 = ()=>$06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT;
const $06a9fa47a6e96bcb$export$d81919e21b7bcda0 = ()=>$06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY;
const $06a9fa47a6e96bcb$export$abf22ef229d645f7 = (value)=>Object.keys(value).length === 0 ? $06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT : value;
const $06a9fa47a6e96bcb$export$540f03090e93e8f6 = (value)=>value.length === 0 ? $06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY : value;
function $06a9fa47a6e96bcb$export$cb8a85c49e39f60(props, isEnabled = true) {
    const ref = (0, $eJOHy.useRef)(props);
    if (!isEnabled) return props;
    if (!(0, $j5V5L.default)(props, ref.current)) ref.current = props;
    return ref.current;
}

});


parcelRegister("8z6Yy", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButton", () => $9131585cbd63b3e0$export$df3f5812ef8777cb);

var $eJOHy = parcelRequire("eJOHy");

var $8nMzv = parcelRequire("8nMzv");

var $he6m3 = parcelRequire("he6m3");

var $hWhA8 = parcelRequire("hWhA8");

var $uUJju = parcelRequire("uUJju");
const $9131585cbd63b3e0$export$df3f5812ef8777cb = /*#__PURE__*/ (0, $eJOHy.memo)(({ MenuItems: MenuItems, name: name, onOpen: onOpen, onClose: onCloseFlyout })=>{
    const { isOpen: isOpen, onClose: onCloseDropdown, onToggle: onToggle } = (0, $he6m3.useOpenable)();
    const content = (0, $eJOHy.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hWhA8.MoreNavMenuButtonSubmenu), {
            ...contentProps,
            MenuItems: MenuItems
        }), [
        MenuItems
    ]);
    const onClose = (0, $eJOHy.useCallback)((e)=>{
        try {
            onCloseFlyout?.(e);
        } finally{
            onCloseDropdown();
        }
    }, [
        onCloseFlyout,
        onCloseDropdown
    ]);
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>{
        try {
            if (!isOpen) onOpen?.();
        } finally{
            onToggle();
        }
    }, [
        isOpen,
        onOpen,
        onToggle
    ]);
    const trigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $uUJju.MoreNavMenuButtonTrigger), {
            ...triggerProps,
            name: name,
            onClick: onTriggerClick,
            isSelected: isOpen,
            testId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.more-nav-menu-button-trigger"
        }), [
        isOpen,
        name,
        onTriggerClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: true
    });
});

});
parcelRegister("8nMzv", function(module, exports) {
$parcel$export(module.exports, "JiraPopup", () => $1c6892149df42963$export$2da4be1e3f9adef3);

var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $bRMVI = parcelRequire("bRMVI");

var $gIKdF = parcelRequire("gIKdF");
const $1c6892149df42963$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gIKdF.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.Popup), rest);
};

});
parcelRegister("bRMVI", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $66185a54a1126a18$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $66185a54a1126a18$export$e2cf19200849be9e);

var $78ewy = parcelRequire("78ewy");

var $4GudG = parcelRequire("4GudG");
function $66185a54a1126a18$export$a8ba9111c7eec9ac(props) {
    return (0, $4GudG.shouldBeChoreographed)(props);
}
function $66185a54a1126a18$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $78ewy.envType).DEV;
        case 'staging':
            return (0, $78ewy.envType).STAGING;
        case 'prod':
            return (0, $78ewy.envType).PROD;
        default:
            return (0, $78ewy.envType).LOCAL;
    }
}

});
parcelRegister("4GudG", function(module, exports) {
$parcel$export(module.exports, "getPendoPlugin", () => $41ed029854d4c41b$export$3d3a86b2d636214b);
$parcel$export(module.exports, "shouldBeChoreographed", () => $41ed029854d4c41b$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "withChoreographedToggle", () => $41ed029854d4c41b$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $41ed029854d4c41b$export$2cfd68294be82811);
$parcel$export(module.exports, "useDisableInAppMessagesForIframe", () => $41ed029854d4c41b$export$a60a99a250d6a89c);

var $eJOHy = parcelRequire("eJOHy");

var $bdILV = parcelRequire("bdILV");
var $bgcdo = parcelRequire("bgcdo");
var $7Q9YQ = parcelRequire("7Q9YQ");
var $aeXRO = parcelRequire("aeXRO");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $dCptc = parcelRequire("dCptc");

var $6zxfT = parcelRequire("6zxfT");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $41ed029854d4c41b$var$environment = (0, $dCptc.toEnvironment)((0, $hWeHP.default)('ajs-environment')) ?? 'prod';
const $41ed029854d4c41b$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $7Q9YQ.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $7Q9YQ.MessageDeliveryStatus).STOPPED),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component,
        shouldBeChoreographed: (props)=>false
    };
    return (0, $bgcdo.choreographerFactory)((0, $7Q9YQ.ProductIds).JIRA, $41ed029854d4c41b$var$environment);
};
let $41ed029854d4c41b$var$pendoPlugin;
function $41ed029854d4c41b$export$3d3a86b2d636214b(env) {
    if (!$41ed029854d4c41b$var$pendoPlugin) $41ed029854d4c41b$var$pendoPlugin = new (0, $aeXRO.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $7Q9YQ.ProductIds).JIRA
    });
    return $41ed029854d4c41b$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $41ed029854d4c41b$export$9f0e2488ffd90f11, withChoreographedToggle: $41ed029854d4c41b$var$withChoreographedToggleFromFactory, shouldBeChoreographed: $41ed029854d4c41b$export$a8ba9111c7eec9ac } = $41ed029854d4c41b$var$createChoreographerFactory();
const $41ed029854d4c41b$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6zxfT.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $eJOHy.useMemo)(()=>$41ed029854d4c41b$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $4cTDP.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $41ed029854d4c41b$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6zxfT.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $eJOHy.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $41ed029854d4c41b$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};
const $41ed029854d4c41b$export$a60a99a250d6a89c = ()=>{
    const cleanup = (0, $eJOHy.useRef)();
    const disabled = (0, $eJOHy.useRef)(false);
    if (!disabled.current) {
        cleanup.current = (0, $bdILV.Choreographer).getInstance().disableChoreographerForIframe();
        disabled.current = true;
    }
    (0, $eJOHy.useEffect)(()=>()=>cleanup.current?.(), []);
};

});
parcelRegister("6zxfT", function(module, exports) {
$parcel$export(module.exports, "ChoreographerContextProvider", () => $e229c0cbb2674443$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $e229c0cbb2674443$export$2eb1efa814fe4a);

var $eJOHy = parcelRequire("eJOHy");
const $e229c0cbb2674443$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $e229c0cbb2674443$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $e229c0cbb2674443$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e229c0cbb2674443$export$3ff96dbefca6b00d.Provider, {
        value: $e229c0cbb2674443$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $e229c0cbb2674443$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $e229c0cbb2674443$export$2eb1efa814fe4a = ()=>(0, $eJOHy.useContext)($e229c0cbb2674443$export$3ff96dbefca6b00d);

});



parcelRegister("gIKdF", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPopup", () => $a2bd3f4e4529f8c5$export$8ecc19d18d3df807);

var $kJsb4 = parcelRequire("kJsb4");

var $4GudG = parcelRequire("4GudG");
const $a2bd3f4e4529f8c5$export$8ecc19d18d3df807 = (0, $4GudG.withChoreographedToggle)((0, $kJsb4.Popup), 'isOpen', 'content');

});


parcelRegister("he6m3", function(module, exports) {
$parcel$export(module.exports, "useOpenable", () => $40c5fa9f2d8d08c0$export$e07f550759260fd7);

var $eJOHy = parcelRequire("eJOHy");
const $40c5fa9f2d8d08c0$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(initialState);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $eJOHy.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $eJOHy.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("hWhA8", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButtonSubmenu", () => $c9f675a950e90253$export$ac88f3e136748c4a);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $8IeH1 = parcelRequire("8IeH1");

var $5Q9JR = parcelRequire("5Q9JR");
const $c9f675a950e90253$var$stopEventPropagation = (event)=>event.stopPropagation();
const $c9f675a950e90253$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        onMouseEnter: $c9f675a950e90253$var$stopEventPropagation,
        onMouseLeave: $c9f675a950e90253$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuItems, {
        onClose: onClose
    })));

});

parcelRegister("uUJju", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButtonTrigger", () => $dfbe3a7f7d9c0985$export$c1fd214ac7085e79);

var $eJOHy = parcelRequire("eJOHy");

var $NByNW = parcelRequire("NByNW");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $ajqBI = parcelRequire("ajqBI");

var $fo9o5 = parcelRequire("fo9o5");
const $dfbe3a7f7d9c0985$export$c1fd214ac7085e79 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
({ name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                ...iconProps,
                size: "small"
            }),
        label: name ? formatMessage((0, $fo9o5.default).moreActionsFor, {
            name: name
        }) : formatMessage((0, $fo9o5.default).moreActions),
        ref: ref,
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $fo9o5.default).moreActions),
                hideTooltipOnClick: true
            }
        } : {},
        interactionName: "nav4-sidebar-more-actions-button"
    });
});

});
parcelRegister("6XJko", function(module, exports) {
$parcel$export(module.exports, "isVisualRefreshEnabled", () => $ac9280cd0f5c90b2$export$48345cb467db19b6);

var $6zXPf = parcelRequire("6zXPf");
const $ac9280cd0f5c90b2$export$48345cb467db19b6 = ()=>(0, $6zXPf.getWillShowNav4)();

});

parcelRegister("ajqBI", function(module, exports) {
$parcel$export(module.exports, "CommonNavMenuButton", () => $bf8e167060ed7219$export$358f21998d56a71e);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");
const $bf8e167060ed7219$export$358f21998d56a71e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, icon: icon, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ...props,
        icon: icon,
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle"
    });
});

});

parcelRegister("fo9o5", function(module, exports) {
$parcel$export(module.exports, "default", () => $2728ae4146a63f7b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2728ae4146a63f7b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions",
        "defaultMessage": "More actions"
    },
    moreActionsFor: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions-for",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("6FAEa", function(module, exports) {
$parcel$export(module.exports, "AsyncCmdbUpsellPage", () => $cfa7297c4bf19653$export$659eb30d49d6ed87);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cfa7297c4bf19653$var$LazyCmdbUpsellPage = (0, $bQWwW.lazy)(()=>(parcelRequire("l5yzb")).then((module)=>module.UpsellPage), {
    moduleId: "./src/packages/servicedesk/cmdb/cmdb-upsell-page/src/ui/index.tsx"
});
const $cfa7297c4bf19653$export$659eb30d49d6ed87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "cmdb-upsell-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfa7297c4bf19653$var$LazyCmdbUpsellPage, null));

});
parcelRegister("l5yzb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5PRCb").then(()=>parcelRequire('4nbVT'));

});


parcelRegister("1Q9Vz", function(module, exports) {
$parcel$export(module.exports, "default", () => $af43f7ce0ae288e9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $af43f7ce0ae288e9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openAssetsApp: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.open-assets-app",
        "defaultMessage": "Open Assets"
    },
    upsellLozengeText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge-text",
        "defaultMessage": "Premium"
    }
});

});


parcelRegister("8rGQ0", function(module, exports) {
$parcel$export(module.exports, "useIsSiteAdmin", () => $fe10d5eb233fa1c3$export$f9f8a5cdb0c565ef);

var $koAZ4 = parcelRequire("koAZ4");
const $fe10d5eb233fa1c3$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("2sjJ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ae120dd99f263f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $64ae120dd99f263f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    lozenge: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.lozenge",
        "defaultMessage": "Try"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.assets",
        "defaultMessage": "Assets"
    }
});

});


parcelRegister("5D4AX", function(module, exports) {
$parcel$export(module.exports, "Goals", () => $15fbc6925e70260e$export$3c4000465299790);

var $eJOHy = parcelRequire("eJOHy");

var $9itkV = parcelRequire("9itkV");

var $lgMTT = parcelRequire("lgMTT");

var $2dvSy = parcelRequire("2dvSy");

var $lRq8t = parcelRequire("lRq8t");

var $9evOq = parcelRequire("9evOq");
function $15fbc6925e70260e$export$3c4000465299790({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const url = 'https://home.atlassian.com/goals';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.GoalsIcon), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.goals.menu-link-item"
    }, formatMessage((0, $9evOq.default).goals));
}

});
parcelRegister("9evOq", function(module, exports) {
$parcel$export(module.exports, "default", () => $f909fda2a05b8e5e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f909fda2a05b8e5e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    goals: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.goals.goals",
        "defaultMessage": "Goals"
    }
});

});


parcelRegister("6RXjp", function(module, exports) {
$parcel$export(module.exports, "Teams", () => $9f47ebf46614467d$export$b3a34d915d8dd11e);

var $eJOHy = parcelRequire("eJOHy");

var $79KhM = parcelRequire("79KhM");

var $aXbkt = parcelRequire("aXbkt");

var $9itkV = parcelRequire("9itkV");

var $lgMTT = parcelRequire("lgMTT");

var $7saMl = parcelRequire("7saMl");

var $Ay1uj = parcelRequire("Ay1uj");

var $dcLzM = parcelRequire("dcLzM");

var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $2dvSy = parcelRequire("2dvSy");

var $8nMzv = parcelRequire("8nMzv");


var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $a62R3 = parcelRequire("a62R3");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $cFGzN = parcelRequire("cFGzN");

var $2VH7W = parcelRequire("2VH7W");


var $4cTDP = parcelRequire("4cTDP");

var $dIJOd = parcelRequire("dIJOd");

var $lRq8t = parcelRequire("lRq8t");

var $8x4C2 = parcelRequire("8x4C2");
const $9f47ebf46614467d$var$CREATE_A_TEAM = 'createATeam';
const $9f47ebf46614467d$var$INVITE_PEOPLE = 'invitePeople';
const $9f47ebf46614467d$var$PopupContent = ({ openTeamsPopup: openTeamsPopup, createTeamModalTrigger: createTeamModalTrigger })=>{
    const invitePeopleModalTrigger = (0, $2VH7W.useInvitePeopleModal)();
    const actionSubjectId = (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS];
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: $9f47ebf46614467d$var$INVITE_PEOPLE
            }
        });
        invitePeopleModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        invitePeopleModalTrigger,
        openTeamsPopup
    ]);
    const onCreateTeamClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: $9f47ebf46614467d$var$CREATE_A_TEAM
            }
        });
        createTeamModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $9f47ebf46614467d$var$teamsMenuStyle
    }, !(0, $4cTDP.fg)('hot-121631-disable-teams-menu-invite-people') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: onButtonClick
    }, formatMessage((0, $8x4C2.default).invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: onCreateTeamClick
    }, formatMessage((0, $8x4C2.default).createTeam)));
};
function $9f47ebf46614467d$var$TeamsInner({ onClick: onClick }) {
    const [isOpenTeamsPopup, openTeamsPopup] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const label = formatMessage((0, $8x4C2.default).teams);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [createTeamModal, createTeamModalTrigger] = (0, $cFGzN.useCreateTeamModal)();
    const actionSubjectId = (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS];
    const peopleMenuWrapperRef = (0, $79KhM.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$77bc79debbf5c069), (0, $4cTDP.fg)('teams-app-shortcut-nudge')).ref;
    const { href: href } = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const onPlusButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: 'add'
            }
        });
        openTeamsPopup(true);
    }, [
        createAnalyticsEvent,
        actionSubjectId
    ]);
    const renderContent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f47ebf46614467d$var$PopupContent, {
            openTeamsPopup: openTeamsPopup,
            createTeamModalTrigger: createTeamModalTrigger
        });
    }, [
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, createTeamModal, (0, $4cTDP.fg)('teams-app-shortcut-nudge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dIJOd.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        ref: (0, $4cTDP.fg)('teams-app-shortcut-nudge') ? peopleMenuWrapperRef : undefined,
        href: href,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.TeamsIcon), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.menu-link-item",
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            messageId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.popup",
            messageType: "transactional",
            onClose: (0, $eJOHy.useCallback)(()=>openTeamsPopup(false), []),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                    ...triggerProps,
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                            ...iconProps,
                            size: "small"
                        }),
                    appearance: "subtle",
                    spacing: "compact",
                    testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.sidenav-teams-popup-trigger",
                    isSelected: isOpenTeamsPopup,
                    label: label,
                    tooltip: {
                        content: label
                    },
                    isTooltipDisabled: false,
                    onClick: onPlusButtonClick
                }),
            isOpen: isOpenTeamsPopup,
            content: renderContent
        }))
    }, formatMessage((0, $8x4C2.default).teams)));
}
function $9f47ebf46614467d$export$b3a34d915d8dd11e(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aXbkt.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f47ebf46614467d$var$TeamsInner, props));
}
const $9f47ebf46614467d$var$teamsMenuStyle = (0, $1DXK0.xcss)({
    minWidth: '260px',
    paddingBlock: 'space.100'
});

});
parcelRegister("aXbkt", function(module, exports) {
$parcel$export(module.exports, "JiraInvitePeopleModalContextProvider", () => $a9e06cde1da0ade3$export$cdc03757c913ed0);
$parcel$export(module.exports, "useJiraInvitePeopleModalBound", () => $a9e06cde1da0ade3$export$569fef33efef0114);

var $eJOHy = parcelRequire("eJOHy");

var $7uQO8 = parcelRequire("7uQO8");

var $1BZ8a = parcelRequire("1BZ8a");

var $8rGQ0 = parcelRequire("8rGQ0");

var $cHtIB = parcelRequire("cHtIB");
/*
 * We are merging all the changes made in @jira/project-settings__invite-people-modal into @jira/project-settings__invite-people-modal-project
 * so the forked modal can be deprecated and removed
 */ const $a9e06cde1da0ade3$var$noop = ()=>null;
const $a9e06cde1da0ade3$var$JiraInvitePeopleModalContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isOpen: false,
    onOpen: $a9e06cde1da0ade3$var$noop,
    onClose: $a9e06cde1da0ade3$var$noop
});
const $a9e06cde1da0ade3$export$cdc03757c913ed0 = ({ children: children, ...props })=>{
    // new invite people modal requirements
    const cloudId = (0, $cHtIB.useCloudId)();
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const [providerState, setProviderState] = (0, $eJOHy.useState)({
        props: {},
        isOpen: false
    });
    const onClose = (0, $eJOHy.useCallback)(()=>{
        setProviderState({
            props: {},
            isOpen: false
        });
    }, []);
    const onOpen = (0, $eJOHy.useCallback)((state)=>{
        setProviderState({
            props: state ?? {},
            isOpen: true
        });
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            isOpen: providerState.isOpen,
            onOpen: onOpen,
            onClose: onClose
        }), [
        providerState.isOpen,
        onOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9e06cde1da0ade3$var$JiraInvitePeopleModalContext.Provider, {
        value: value
    }, providerState.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uQO8.default), {
        appEdition: appEditions.software,
        cloudId: cloudId,
        isOpen: providerState.isOpen,
        onClose: onClose,
        isSiteAdmin: isSiteAdmin,
        ...props,
        ...providerState.props
    }) : null, children);
};
const $a9e06cde1da0ade3$export$39f09976987c1e17 = ()=>(0, $eJOHy.useContext)($a9e06cde1da0ade3$var$JiraInvitePeopleModalContext);
const $a9e06cde1da0ade3$export$569fef33efef0114 = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $eJOHy.useContext)($a9e06cde1da0ade3$var$JiraInvitePeopleModalContext);
    const openModal = (0, $eJOHy.useCallback)(()=>onOpen(props), [
        onOpen,
        props
    ]);
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: onClose
    };
};

});
parcelRegister("7uQO8", function(module, exports) {
$parcel$export(module.exports, "default", () => $055955c157f1485d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6pJMC = parcelRequire("6pJMC");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $055955c157f1485d$var$LazyComponent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3mG18")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/InvitePeopleWithAnalytics.tsx"
});
const $055955c157f1485d$var$AsyncCoreInvitesProjectDialogComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pJMC.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($055955c157f1485d$var$LazyComponent, props)));
var $055955c157f1485d$export$2e2bcd8739ae039 = $055955c157f1485d$var$AsyncCoreInvitesProjectDialogComponent;

});
parcelRegister("3mG18", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("8r2aB")
]).then(()=>parcelRequire('1Q8Tf'));

});



parcelRegister("cFGzN", function(module, exports) {
$parcel$export(module.exports, "useCreateTeamModal", () => $b040322abcf2ce9b$export$5458b68a653f4bfe);

var $eJOHy = parcelRequire("eJOHy");

var $1n5fh = parcelRequire("1n5fh");

var $cSXp8 = parcelRequire("cSXp8");

var $2ePj6 = parcelRequire("2ePj6");

var $kFis2 = parcelRequire("kFis2");

var $1Gl91 = parcelRequire("1Gl91");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $3MbOI = parcelRequire("3MbOI");

var $g9Vr6 = parcelRequire("g9Vr6");

var $a62R3 = parcelRequire("a62R3");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $hYRYR = parcelRequire("hYRYR");

var $bQWwW = parcelRequire("bQWwW");

var $83DiZ = parcelRequire("83DiZ");

var $4Goo7 = parcelRequire("4Goo7");

// Relay entry point is not applicable here because this component does not live in jira frontend.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b040322abcf2ce9b$var$LazyTeamCreateDialog = (0, $bQWwW.lazy)(()=>(parcelRequire("8PQvE")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $b040322abcf2ce9b$export$5458b68a653f4bfe = ()=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { locale: locale } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { data: { user: user } } = (0, $3MbOI.useCurrentUser)();
    const atlassianAccountId = (0, $e6YEs.useAccountId)() || user.accountId;
    const navigateTo = (0, $eJOHy.useCallback)((url)=>{
        if ((0, $a62R3.isTeamsAppEnabled)()) (0, $4Goo7.openInNewTab)((0, $a62R3.toTeamsAppURL)(url.replace('/jira', '')));
        else push(url);
    }, [
        push
    ]);
    const addFlag = (0, $eJOHy.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $b040322abcf2ce9b$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.use-create-team-modal.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "engagement"
            }));
    }, [
        showFlag
    ]);
    const callback = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    if (!atlassianAccountId) throw new Error('Missing current user id');
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hYRYR.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $1n5fh.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b040322abcf2ce9b$var$LazyTeamCreateDialog, {
            pushRoute: navigateTo,
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId,
            onClose: ()=>setIsOpen(false),
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                nickname: user.userFullname
            } : undefined,
            addFlag: addFlag
        }))) : null,
        callback
    ];
};
const $b040322abcf2ce9b$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $1Gl91.default;
        case 'error':
            return 0, $2ePj6.default;
        case 'success':
        case 'normal':
        default:
            return 0, $kFis2.default;
    }
};

});
parcelRegister("2ePj6", function(module, exports) {
$parcel$export(module.exports, "default", () => $58e340d5c2b8ca16$export$2e2bcd8739ae039);

var $2pgjF = parcelRequire("2pgjF");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$58e340d5c2b8ca16$export$2e2bcd8739ae039 = (0, $2pgjF.ErrorFlag);

});
parcelRegister("2pgjF", function(module, exports) {
$parcel$export(module.exports, "CommonFlag", () => $ad78c13b0c88c3ae$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ad78c13b0c88c3ae$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ad78c13b0c88c3ae$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ad78c13b0c88c3ae$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ad78c13b0c88c3ae$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ad78c13b0c88c3ae$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ad78c13b0c88c3ae$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ad78c13b0c88c3ae$export$a2c3479950310d7d);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad78c13b0c88c3ae$var$ForPaintJiraCommonFlag = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iH5UR")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad78c13b0c88c3ae$var$AfterPaintJiraCommonFlag = (0, $bQWwW.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("iH5UR")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ad78c13b0c88c3ae$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad78c13b0c88c3ae$var$ForPaintFlagGroup = (0, $bQWwW.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("1yBk6")), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad78c13b0c88c3ae$var$AfterPaintFlagGroup = (0, $bQWwW.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("1yBk6")), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ad78c13b0c88c3ae$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$ForPaintFlagGroup, props);
const $ad78c13b0c88c3ae$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, props));
const $ad78c13b0c88c3ae$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ad78c13b0c88c3ae$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ad78c13b0c88c3ae$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ad78c13b0c88c3ae$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ad78c13b0c88c3ae$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ad78c13b0c88c3ae$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ad78c13b0c88c3ae$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$FlagGroupImpl, props));

});
parcelRegister("xvuCV", function(module, exports) {
$parcel$export(module.exports, "FlagsBoundary", () => $04814a5dcc217132$export$8b4a0fffcddd96f4);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $2imLM = parcelRequire("2imLM");
const $04814a5dcc217132$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, children));

});

parcelRegister("iH5UR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("hM1w9")
]).then(()=>parcelRequire('8Q0s6'));

});

parcelRegister("1yBk6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1Rz2I").then(()=>parcelRequire('h9uSI'));

});



parcelRegister("kFis2", function(module, exports) {
$parcel$export(module.exports, "default", () => $36961096ff5b269f$export$2e2bcd8739ae039);

var $2pgjF = parcelRequire("2pgjF");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$36961096ff5b269f$export$2e2bcd8739ae039 = (0, $2pgjF.SuccessFlag);

});

parcelRegister("1Gl91", function(module, exports) {
$parcel$export(module.exports, "default", () => $785dcbe259e0bd70$export$2e2bcd8739ae039);

var $2pgjF = parcelRequire("2pgjF");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$785dcbe259e0bd70$export$2e2bcd8739ae039 = (0, $2pgjF.WarningFlag);

});

parcelRegister("3MbOI", function(module, exports) {
$parcel$export(module.exports, "useCurrentUser", () => $cea734a12424bed3$export$3901076af3749fa9);

var $eJOHy = parcelRequire("eJOHy");

var $jbr6p = parcelRequire("jbr6p");

var $koAZ4 = parcelRequire("koAZ4");

var $c9f6v = parcelRequire("c9f6v");
const $cea734a12424bed3$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $jbr6p.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cea734a12424bed3$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cea734a12424bed3$var$useCurrentUserBasic();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $c9f6v.useUserSubscriber)();
    (0, $eJOHy.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cea734a12424bed3$export$3901076af3749fa9 = ()=>// eslint-disable-next-line react-hooks/react-compiler
    (0, $koAZ4.useTenantContext)().isAnonymous ? $cea734a12424bed3$var$useCurrentUserBasic() : $cea734a12424bed3$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cea734a12424bed3$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cea734a12424bed3$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("c9f6v", function(module, exports) {
$parcel$export(module.exports, "UserContainer", () => $76dd8ceef4c03a1e$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $76dd8ceef4c03a1e$export$4e61bbf568682a96);
$parcel$export(module.exports, "useUserSubscriberActions", () => $76dd8ceef4c03a1e$export$67a426f6cb2e8961);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $immvQ = parcelRequire("immvQ");
const $76dd8ceef4c03a1e$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $76dd8ceef4c03a1e$var$Store = (0, $GtRbT.createStore)({
    name: 'user',
    initialState: $76dd8ceef4c03a1e$var$initialState,
    actions: $immvQ
});
const $76dd8ceef4c03a1e$export$7ff085589970ee0a = (0, $6E16M.createContainer)($76dd8ceef4c03a1e$var$Store);
const $76dd8ceef4c03a1e$export$4e61bbf568682a96 = (0, $iJq0l.createHook)($76dd8ceef4c03a1e$var$Store);
const $76dd8ceef4c03a1e$export$67a426f6cb2e8961 = ()=>{
    const [, userActions] = $76dd8ceef4c03a1e$export$4e61bbf568682a96();
    return [
        undefined,
        userActions
    ];
};

});
parcelRegister("immvQ", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $10ab66dafa4344a0$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "setUser", () => $10ab66dafa4344a0$export$8b6bb3dd62a01be2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1s4Nl = parcelRequire("1s4Nl");
const $10ab66dafa4344a0$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $1s4Nl.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };
const $10ab66dafa4344a0$export$8b6bb3dd62a01be2 = ({ user: user })=>async ({ setState: setState })=>{
        setState({
            data: user,
            loading: false,
            error: null
        });
    };

});
parcelRegister("1s4Nl", function(module, exports) {
$parcel$export(module.exports, "fetchData", () => $58aa135740e671a3$export$8134c072fddab6a5);

var $b5RwB = parcelRequire("b5RwB");

var $LFmXM = parcelRequire("LFmXM");

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $hbF3h = parcelRequire("hbF3h");

var $fsisP = parcelRequire("fsisP");
const $58aa135740e671a3$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $b5RwB.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $3ugTQ.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $58aa135740e671a3$var$fetchDataNew = (0, $LFmXM.default)($58aa135740e671a3$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $fsisP.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $fsisP.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $58aa135740e671a3$export$8134c072fddab6a5 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('user-iv-llc-unnecessary-api'), $58aa135740e671a3$var$fetchDataNew, $58aa135740e671a3$export$5e5a6664039ed1cc);

});




parcelRegister("hYRYR", function(module, exports) {
$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $bfb988a00a6ce36a$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $bfb988a00a6ce36a$export$130340d16a670190);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7GxOn = parcelRequire("7GxOn");

var $1AbSU = parcelRequire("1AbSU");

var $1P5ft = parcelRequire("1P5ft");

var $48783 = parcelRequire("48783");
const $bfb988a00a6ce36a$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $1P5ft.DEFAULT_CONTEXT));
const $bfb988a00a6ce36a$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $48783.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $1AbSU.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($bfb988a00a6ce36a$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $1P5ft.DEFAULT_CONTEXT),
        children: children
    });
};
const $bfb988a00a6ce36a$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7GxOn.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($bfb988a00a6ce36a$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $bfb988a00a6ce36a$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($bfb988a00a6ce36a$export$8a37839ac1e08b25);

});
parcelRegister("7GxOn", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $5986aeeba0f5d97b$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $5986aeeba0f5d97b$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $5986aeeba0f5d97b$export$3b241cde208d2c5e);

var $eJOHy = parcelRequire("eJOHy");

var $9nfpX = parcelRequire("9nfpX");
const $5986aeeba0f5d97b$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    getArtifact: null
});
function $5986aeeba0f5d97b$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return new (0, $9nfpX.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5986aeeba0f5d97b$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $5986aeeba0f5d97b$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($5986aeeba0f5d97b$export$ca1b33377afa620);
function $5986aeeba0f5d97b$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    const { getArtifact: getArtifact } = $5986aeeba0f5d97b$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});

parcelRegister("1AbSU", function(module, exports) {
$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $2d58f302186355c2$export$233293b7afb7b362);

var $eJOHy = parcelRequire("eJOHy");

var $7GxOn = parcelRequire("7GxOn");

var $fMhMm = parcelRequire("fMhMm");
const $2d58f302186355c2$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $2d58f302186355c2$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $eJOHy.useMemo)(()=>({
            ...(0, $fMhMm.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $7GxOn.useFlightDeckArtifact)((0, $fMhMm.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $eJOHy.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $2d58f302186355c2$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("fMhMm", function(module, exports) {
$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $5f619831fb5642c9$export$c270c412a04ff3e6);

var $lopBx = parcelRequire("lopBx");
const $5f619831fb5642c9$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $5f619831fb5642c9$export$71f196808ce40e60 = 'prod';
const $5f619831fb5642c9$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $5f619831fb5642c9$export$e836203c1e95eac3 = 'commercial';
const $5f619831fb5642c9$export$c270c412a04ff3e6 = {
    name: $5f619831fb5642c9$export$953923d576277fd6,
    dimensions: {
        environmentType: $5f619831fb5642c9$export$71f196808ce40e60,
        perimeter: (0, $lopBx.isFedRamp)() ? $5f619831fb5642c9$export$6392ca3738ed1e9 : $5f619831fb5642c9$export$e836203c1e95eac3
    }
};

});


parcelRegister("1P5ft", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $f6c30c7313d1c5e1$export$9c542858adf7dcd0);
const $f6c30c7313d1c5e1$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("48783", function(module, exports) {
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $4ad68028825fec49$export$66d7d96ce076bcd6);

var $6rNFR = parcelRequire("6rNFR");

var $2Kvwp = parcelRequire("2Kvwp");
const $4ad68028825fec49$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $6rNFR.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $2Kvwp.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $2Kvwp.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("6rNFR", function(module, exports) {
$parcel$export(module.exports, "useTeamsPermissionsService", () => $afbccedd81c1ca48$export$b24dcbe1ec677a8);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $g06PH = parcelRequire("g06PH");

var $jnRiM = parcelRequire("jnRiM");

var $j6ZvB = parcelRequire("j6ZvB");
const $afbccedd81c1ca48$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $j6ZvB.useTeamsPermissionsStore)();
    const { fireEvent: fireEvent } = (0, $g06PH.useAnalyticsEvents)();
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>{
                if ((0, $eGOwo.fg)('ptc-enable-teams-common-analytics-refactor')) // @ts-expect-error - hyphenated event names are not supported in the analytics spec
                fireEvent('operational.use-team-permissions.fetched', {
                    userId: attributes?.userId,
                    orgId: orgId,
                    cloudId: cloudId
                });
                else (0, $jnRiM.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'fetched',
                    actionSubject: 'use-team-permissions',
                    attributes: {
                        userId: attributes?.userId,
                        orgId: orgId,
                        cloudId: cloudId
                    }
                });
            }
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        createAnalyticsEvent,
        attributes?.userId,
        fireEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};

});
parcelRegister("g06PH", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $cc09380890b90144$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d01fef63886f2825ffbc3a0ec1ca7534>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $aJB9r = parcelRequire("aJB9r");
const $cc09380890b90144$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $aJB9r.default)(...params));
        event.fire((0, $3ce9cd9f8851a260$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $3ce9cd9f8851a260$export$3f072f06b90c3985 = 'peopleTeams';

parcelRegister("aJB9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $b452049b7ed407af$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::050566410df453c9b1ba071c6805ead2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $b452049b7ed407af$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $b452049b7ed407af$export$2e2bcd8739ae039 = $b452049b7ed407af$var$createEventPayload;

});


parcelRegister("jnRiM", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $5de2faca44bcb637$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $5de2faca44bcb637$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $5de2faca44bcb637$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireUIEvent", () => $5de2faca44bcb637$export$7eca133280843f9e);
$parcel$export(module.exports, "isSeriousError", () => $5de2faca44bcb637$export$91c413c8a5c77e19);
const $5de2faca44bcb637$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $5de2faca44bcb637$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $5de2faca44bcb637$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $5de2faca44bcb637$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($5de2faca44bcb637$var$ANALYTICS_CHANNEL);
        });
    };
const $5de2faca44bcb637$export$a1fb57756f0de62b = $5de2faca44bcb637$var$fireEvent('operational');
const $5de2faca44bcb637$export$59608e0169622110 = $5de2faca44bcb637$var$fireEvent('screen');
const $5de2faca44bcb637$export$574d2f19a52d67ca = $5de2faca44bcb637$var$fireEvent('track');
const $5de2faca44bcb637$export$7eca133280843f9e = $5de2faca44bcb637$var$fireEvent('ui');
const $5de2faca44bcb637$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error?.message?.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error?.message?.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error?.message?.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};

});

parcelRegister("j6ZvB", function(module, exports) {
$parcel$export(module.exports, "useTeamsPermissionsStore", () => $015547c321a97815$export$4e7a1c55cba5a168);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7eAIS = parcelRequire("7eAIS");
var $301JM = parcelRequire("301JM");

var $covdC = parcelRequire("covdC");
const $015547c321a97815$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $301JM.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $301JM.teamsClient).getPermissions();
                dispatch($015547c321a97815$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($015547c321a97815$var$actions.setError(error instanceof (0, $7eAIS.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $covdC.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $015547c321a97815$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $015547c321a97815$var$actions,
    name: 'teams-permissions'
});
const $015547c321a97815$export$4e7a1c55cba5a168 = (0, $iJq0l.createHook)($015547c321a97815$var$Store);

});
parcelRegister("7eAIS", function(module, exports) {
$parcel$export(module.exports, "StatusCode", () => $4ce6a32b1f0ec576$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $4ce6a32b1f0ec576$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $4ce6a32b1f0ec576$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $4ce6a32b1f0ec576$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $4ce6a32b1f0ec576$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $4ce6a32b1f0ec576$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $4ce6a32b1f0ec576$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $4ce6a32b1f0ec576$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $4ce6a32b1f0ec576$export$476aa014e2fd89d5);
var $4ce6a32b1f0ec576$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $4ce6a32b1f0ec576$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $4ce6a32b1f0ec576$export$cde1786a482f9a1c(error) {
    return $4ce6a32b1f0ec576$export$9677d7c364ada66c(401, error) || $4ce6a32b1f0ec576$export$9677d7c364ada66c(403, error);
}
function $4ce6a32b1f0ec576$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $4ce6a32b1f0ec576$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $4ce6a32b1f0ec576$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $4ce6a32b1f0ec576$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $4ce6a32b1f0ec576$export$c73ca302efeda3b4 extends $4ce6a32b1f0ec576$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$c73ca302efeda3b4.prototype);
    }
}
class $4ce6a32b1f0ec576$export$d87f401f8106d7a2 extends $4ce6a32b1f0ec576$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$d87f401f8106d7a2.prototype);
    }
}
class $4ce6a32b1f0ec576$export$65bd6083489bd8bb extends $4ce6a32b1f0ec576$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $4ce6a32b1f0ec576$export$826a3d65b8435adf extends $4ce6a32b1f0ec576$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$826a3d65b8435adf.prototype);
    }
}
class $4ce6a32b1f0ec576$export$92d6ed0888e7cb7f extends $4ce6a32b1f0ec576$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $4ce6a32b1f0ec576$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $4ce6a32b1f0ec576$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("301JM", function(module, exports) {
$parcel$export(module.exports, "teamsClient", () => $a265c137afbb4e9c$export$5ed932c3646b89c6);

var $eGOwo = parcelRequire("eGOwo");

var $4jBhU = parcelRequire("4jBhU");

var $5SB4z = parcelRequire("5SB4z");

var $jWVEO = parcelRequire("jWVEO");

var $kl6VX = parcelRequire("kl6VX");

var $bP17Z = parcelRequire("bP17Z");

var $1Ah8w = parcelRequire("1Ah8w");

var $a6X0K = parcelRequire("a6X0K");

var $lrqlI = parcelRequire("lrqlI");

var $hmfTD = parcelRequire("hmfTD");

var $1qjKt = parcelRequire("1qjKt");

var $3aHkO = parcelRequire("3aHkO");

var $4Xjsv = parcelRequire("4Xjsv");

var $hmv3a = parcelRequire("hmv3a");

var $3vA2C = parcelRequire("3vA2C");

var $6s0GD = parcelRequire("6s0GD");

var $fecpt = parcelRequire("fecpt");
class $a265c137afbb4e9c$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $5SB4z.aggClient);
        this._directoryClient = (0, $kl6VX.directoryClient);
        this._legionClient = (0, $a6X0K.defaultLegionClient);
        this._mutabilityClient = (0, $lrqlI.default);
        this._permsClient = (0, $1qjKt.default);
        this._publicApiClient = (0, $3aHkO.default);
        this._invitationsClient = (0, $1Ah8w.default);
        this._userPreferencesClient = (0, $fecpt.default);
        this._objectResolverClient = (0, $hmfTD.default);
        this._teamsInSlackClient = (0, $6s0GD.default);
        this._collaborationGraphClient = (0, $jWVEO.default);
        this._identityClient = (0, $bP17Z.default);
        this._teamCentralClient = (0, $3vA2C.default);
        this._replinesClient = (0, $4Xjsv.default);
        this._reportingLinesClient = (0, $hmv3a.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $4jBhU.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
        this._replinesClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) {
            if ((0, $eGOwo.fg)('fix_query_settings_context')) {
                const previousContext = this._legionClient.getContext();
                this.setContext({
                    ...previousContext,
                    cloudId: cloudId
                });
            } else this.setContext({
                cloudId: cloudId
            });
        }
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
	 * This will return all of the teams-related permissions that your user has for the org and site in the client context.
	 */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get the agents associated with the team
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryTeamHasAgents(teamId) {
        return this._aggClient.queryTeamHasAgents(teamId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * Get org's eligibility for managed teams
	 */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Add agent to a team
	 */ async addAgentsToTeam(...args) {
        return this.measurePerformance('addAgentToTeam', ()=>this._legionClient.addAgentsToTeam(...args));
    }
    async removeAgentTeamAssociation(...args) {
        return this.measurePerformance('removeAgentTeamAssociation', ()=>this._legionClient.removeAgentTeamAssociation(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * Archive a team
	 */ async archiveTeam(teamId) {
        return this.measurePerformance('archiveTeam', ()=>this._legionClient.archiveTeam(teamId));
    }
    /**
	 * Unarchive a team
	 */ async unarchiveTeam(teamId) {
        return this.measurePerformance('unarchiveTeam', ()=>this._legionClient.unArchiveTeam(teamId));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create containers for a team
	 */ async createTeamContainers(...args) {
        return this.measurePerformance('createTeamContainers', ()=>this._legionClient.createTeamContainers(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 * Get Org scope
	 */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
	 * Restore soft-deleted team and sync to group
	 */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
	 * Get the difference between a team and a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 * @returns {Promise<TeamAndGroupDifference>}
	 */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
	 * Link an existing team to a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Get enabled sites for a team
	 */ async getTeamEnabledSites(...args) {
        return this.measurePerformance('getTeamEnabledSites', ()=>this._legionClient.getTeamEnabledSites(...args));
    }
    /**
	 * Assign teams to sites
	 * @param migrations
	 * @returns {Promise<AssignTeamsToSitesResponse>}
	 */ async assignTeamsToSites(...args) {
        return this.measurePerformance('assignTeamsToSites', ()=>this._legionClient.assignTeamsToSites(...args));
    }
    /**
	 * Get assigned teams
	 * @param orgId
	 * @param cursor
	 * @param displayNameContains
	 * @param count - number of teams to return
	 */ async getAssignedTeams(...args) {
        return this.measurePerformance('getAssignedTeams', ()=>this._legionClient.getAssignedTeams(...args));
    }
    /**
	 * Get unassigned teams
	 * @param orgId
	 * @param count - number of teams to return
	 * @param cursor - cursor to the next page of results
	 * @param query - query to filter teams by
	 */ async getUnassignedTeams(...args) {
        return this.measurePerformance('getUnassignedTeams', ()=>this._legionClient.getUnassignedTeams(...args));
    }
    /**
	 * Set team site assignment permission
	 * @param orgId
	 * @param alignmentPermission - 'ALL_USERS' | 'ORG_ADMIN'
	 */ async setTeamSiteAssignmentPermission(...args) {
        return this.measurePerformance('setTeamSiteAssignmentPermission', ()=>this._legionClient.setTeamSiteAssignmentPermission(...args));
    }
    /**
	 * Get team site assignment org details
	 */ async getTeamSiteAssignmentOrgDetails(...args) {
        return this.measurePerformance('getTeamSiteAssignmentOrgDetails', ()=>this._legionClient.getTeamSiteAssignmentOrgDetails(...args));
    }
    /**
	 * Get teams to be cloned to JSM sites
	 */ async getTeamsToBeClonedToJsmSites(...args) {
        return this.measurePerformance('getTeamsToBeClonedToJsmSites', ()=>this._legionClient.getTeamsToBeClonedToJsmSites(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
	 * Fetch user containers from collboration graph
	 */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
	 * Fetch mutatability of external managed user fields
	 */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
	 * Fetch user avatar uploaded status
	 */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
	 * Delete user avatar
	 */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
	 * Fetch Team link icons
	 */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
	 * Fetch ARI from URL
	 */ async getAriFromUrl(...args) {
        return this.measurePerformance('getAriFromUrl', ()=>this._objectResolverClient.getAriFromUrl(...args));
    }
    /**
	 * Fetch web link title
	 */ async getWebLinkTitle(...args) {
        return this.measurePerformance('getWebLinkTitle', ()=>this._objectResolverClient.getWebLinkTitle(...args));
    }
    /**
	 * Fetch team in slack details
	 */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
	 * Delete team in slack
	 */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
	 * Update team in slack
	 */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
	 * Update user details
	 */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async isTeamWatcher(...args) {
        return this._teamCentralClient.isTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
    async getUserTenure(...args) {
        return this.measurePerformance('getUserTenure', ()=>this._replinesClient.getUserTenure(...args));
    }
    async checkOrgFullAlignmentStatus(...args) {
        return this._legionClient.checkOrgFullAlignmentStatus(...args);
    }
    async getTeamStatesInBulk(...args) {
        return this._legionClient.getTeamStatesInBulk(...args);
    }
    async getReportingLines(...args) {
        return this.measurePerformance('getReportingLines', ()=>this._reportingLinesClient.getReportingLines(...args));
    }
}
const $a265c137afbb4e9c$export$5ed932c3646b89c6 = new $a265c137afbb4e9c$export$db59823f35bf78ce();

});
parcelRegister("4jBhU", function(module, exports) {
$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $54c07f12bcdc1fb3$export$879344107b04120c);

var $aRnO1 = parcelRequire("aRnO1");

var $fGETV = parcelRequire("fGETV");
const $54c07f12bcdc1fb3$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'archiveTeam',
    'unarchiveTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'createTeamContainers',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack',
    'getUserTenure',
    'getAriFromUrl',
    'getWebLinkTitle',
    'addAgentToTeam',
    'getTeamEnabledSites',
    'assignTeamsToSites',
    'removeAgentTeamAssociation',
    'getAssignedTeams',
    'setTeamSiteAssignmentPermission',
    'getUnassignedTeams',
    'getTeamSiteAssignmentOrgDetails',
    'getTeamsToBeClonedToJsmSites',
    'getReportingLines'
];
const $54c07f12bcdc1fb3$export$879344107b04120c = new Map([
    ...$54c07f12bcdc1fb3$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $fGETV.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $aRnO1.ExperienceTypes).Operation,
                performanceType: (0, $aRnO1.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("aRnO1", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $a0f874ab7df0b90c$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $a0f874ab7df0b90c$export$cc26007c03242fff);
var $a0f874ab7df0b90c$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a0f874ab7df0b90c$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("fGETV", function(module, exports) {
$parcel$export(module.exports, "TeamsUFOExperience", () => $6d42ddbd74afe72d$export$9a18529d1e90e81a);

var $2pMzV = parcelRequire("2pMzV");

var $7eAIS = parcelRequire("7eAIS");

var $aanSe = parcelRequire("aanSe");
class $6d42ddbd74afe72d$export$9a18529d1e90e81a extends (0, $2pMzV.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $aanSe.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $7eAIS.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $7eAIS.isErrorStatusCode)((0, $7eAIS.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $aanSe.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $7eAIS.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $aanSe.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("2pMzV", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $eb40b99b73192801$export$c00d22927c60484a);

var $aSYAD = parcelRequire("aSYAD");
class $eb40b99b73192801$export$c00d22927c60484a extends (0, $aSYAD.UFOAbstractExperience) {
}

});
parcelRegister("aSYAD", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $fb5df3e7e01c2259$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");


var $6uX6b = parcelRequire("6uX6b");

var $jJiQE = parcelRequire("jJiQE");

var $5hbWe = parcelRequire("5hbWe");

var $ccWvh = parcelRequire("ccWvh");

var $aP4V0 = parcelRequire("aP4V0");

var $2Ilzg = parcelRequire("2Ilzg");

var $g0oDq = parcelRequire("g0oDq");

var $8OSL8 = parcelRequire("8OSL8");

var $aRnO1 = parcelRequire("aRnO1");
const $fb5df3e7e01c2259$var$getPageVisibleState = ()=>{
    return !(0, $2Ilzg.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ccWvh.PageVisibleState).VISIBLE : (0, $ccWvh.PageVisibleState).HIDDEN;
};
const $fb5df3e7e01c2259$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $aP4V0.roundPerfNow)();
};
class $fb5df3e7e01c2259$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $g0oDq.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $ccWvh.PageVisibleState).MIXED;
            (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $jJiQE.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $8OSL8.canTransition)(this.state, newState)) {
            (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $g0oDq.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $aXKmr.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.unsubscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $jJiQE.ufolog)('this.parent', this.parent);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $jJiQE.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $g0oDq.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
            (0, $5hbWe.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $jJiQE.ufolog)('subscribed', this.id);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.subscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $ccWvh.FMP_MARK) && name !== (0, $ccWvh.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $jJiQE.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $g0oDq.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $ccWvh.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $ccWvh.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $jJiQE.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $jJiQE.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $4e1f4772088a5f3c$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $4e1f4772088a5f3c$export$2295b861f318254a = '0.1.5';

parcelRegister("6uX6b", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $aa71c8960fce0a9f$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $aa71c8960fce0a9f$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $aa71c8960fce0a9f$export$7c957416596ca127);

var $jJiQE = parcelRequire("jJiQE");

var $ccWvh = parcelRequire("ccWvh");
const $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $aa71c8960fce0a9f$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $aa71c8960fce0a9f$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $jJiQE.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $aa71c8960fce0a9f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("jJiQE", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $3c943c12e74b5b78$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $3c943c12e74b5b78$export$d53d07b6034c4560);
class $3c943c12e74b5b78$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $3c943c12e74b5b78$export$4ab84f6f04f6566d = new $3c943c12e74b5b78$var$UFOLogger();
const $3c943c12e74b5b78$export$b4958caff08a0960 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.log(...args);
};
const $3c943c12e74b5b78$export$d53d07b6034c4560 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("ccWvh", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $eeff76e3a75af2a8$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $eeff76e3a75af2a8$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $eeff76e3a75af2a8$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $eeff76e3a75af2a8$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $eeff76e3a75af2a8$export$837e0f79a8056912);
var $eeff76e3a75af2a8$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $eeff76e3a75af2a8$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $eeff76e3a75af2a8$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $eeff76e3a75af2a8$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $eeff76e3a75af2a8$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $eeff76e3a75af2a8$export$9f2bf58999404c75 = 'fmp';
const $eeff76e3a75af2a8$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("5hbWe", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $d460cc96d513760c$export$13e680397ec8f3eb);

var $2Ilzg = parcelRequire("2Ilzg");
class $d460cc96d513760c$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $2Ilzg.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d460cc96d513760c$export$13e680397ec8f3eb = new $d460cc96d513760c$var$VisibilityChangeObserver();

});
parcelRegister("2Ilzg", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $5b8b2c70c6400f35$export$15e172712955e18f);
const $5b8b2c70c6400f35$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("aP4V0", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $53acaf7fbb090f6e$export$5f490af6b2b115cf);
const $53acaf7fbb090f6e$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("g0oDq", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $7c8f0df3a7880bc0$export$81b70111112841a0);
const $7c8f0df3a7880bc0$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("8OSL8", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $ac48b2b50e1c5998$export$178881f329fdb81f);

var $g0oDq = parcelRequire("g0oDq");
const $ac48b2b50e1c5998$var$UFOStateAvailableTransitions = {
    [(0, $g0oDq.UFOExperienceState).NOT_STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).BLOCKED.id]: [
        (0, $g0oDq.UFOExperienceState).RECOVERED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).RECOVERED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).FAILED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).ABORTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ]
};
const $ac48b2b50e1c5998$export$178881f329fdb81f = (state1, state2)=>{
    return $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id] && $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("aanSe", function(module, exports) {
$parcel$export(module.exports, "createErrorMetadata", () => $913e69277c97885c$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $913e69277c97885c$export$a8da197a8bcc7e95);

var $7eAIS = parcelRequire("7eAIS");
const $913e69277c97885c$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $7eAIS.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $7eAIS.HttpError) ? error.status : undefined
        }
    });
const $913e69277c97885c$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $913e69277c97885c$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $913e69277c97885c$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("5SB4z", function(module, exports) {
$parcel$export(module.exports, "aggClient", () => $f9ac644f32b216ad$export$464c991dbf0b2393);

var $b8xXJ = parcelRequire("b8xXJ");

var $hncrn = parcelRequire("hncrn");

var $le4QF = parcelRequire("le4QF");

var $kP1cg = parcelRequire("kP1cg");

var $8ZouZ = parcelRequire("8ZouZ");

var $kFoav = parcelRequire("kFoav");

var $1C7fa = parcelRequire("1C7fa");

var $6qJst = parcelRequire("6qJst");
class $f9ac644f32b216ad$export$b44e5dafe13af7b3 extends (0, $le4QF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $kFoav.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $b8xXJ.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $b8xXJ.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $6qJst.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1C7fa.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
    async queryTeamHasAgents(teamId) {
        const teamAri = (0, $b8xXJ.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $8ZouZ.TeamHasAgentsQuery),
            variables: {
                id: teamAri
            }
        }, {
            operationName: 'TeamHasAgentsQuery'
        });
        return this.processTeamHasAgentsResponse(teamId, response.graphStore);
    }
    processTeamHasAgentsResponse(teamId, response) {
        return response.teamHasAgents.edges.map(({ node: node })=>({
                associationId: {
                    teamId: teamId,
                    accountId: (0, $b8xXJ.toUserId)(node.id)
                },
                agent: {
                    id: node.id,
                    fullName: node.name,
                    avatarUrl: node.picture
                }
            }));
    }
}
const $f9ac644f32b216ad$export$464c991dbf0b2393 = new $f9ac644f32b216ad$export$b44e5dafe13af7b3((0, $hncrn.DEFAULT_CONFIG).stargateRoot, {
    logException: $kP1cg.logException
});

});
parcelRegister("b8xXJ", function(module, exports) {
$parcel$export(module.exports, "toUserId", () => $5a33a4679e11b704$export$1d0eef1d33b05366);
$parcel$export(module.exports, "toUserARI", () => $5a33a4679e11b704$export$fca6a88adb58674a);
$parcel$export(module.exports, "toTeamId", () => $5a33a4679e11b704$export$e78216c959b9f3af);
$parcel$export(module.exports, "toTeamARI", () => $5a33a4679e11b704$export$2bcc6e4924859c6f);

const $5a33a4679e11b704$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $3a6f84ebc0be7810$export$470b0d72e4fdc43a));
const $5a33a4679e11b704$export$1d0eef1d33b05366 = (ari)=>{
    if ($5a33a4679e11b704$export$caac29844ad91f64(ari)) return ari.replace((0, $3a6f84ebc0be7810$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $5a33a4679e11b704$export$fca6a88adb58674a = (userId)=>{
    return $5a33a4679e11b704$export$caac29844ad91f64(userId) ? userId : `${0, $3a6f84ebc0be7810$export$470b0d72e4fdc43a}${userId}`;
};
const $5a33a4679e11b704$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $3a6f84ebc0be7810$export$cfedc369802e0c68));
const $5a33a4679e11b704$export$e78216c959b9f3af = (ari)=>{
    if ($5a33a4679e11b704$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $3a6f84ebc0be7810$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $5a33a4679e11b704$export$2bcc6e4924859c6f = (teamId)=>{
    return $5a33a4679e11b704$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $3a6f84ebc0be7810$export$cfedc369802e0c68}${teamId}`;
};

});
const $3a6f84ebc0be7810$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $3a6f84ebc0be7810$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("hncrn", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CONFIG", () => $43d6e2e0b1d23bff$export$c2f8e0cc249a8d8f);
const $43d6e2e0b1d23bff$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};

});

parcelRegister("le4QF", function(module, exports) {
$parcel$export(module.exports, "BaseGraphQlClient", () => $482516509fd40a68$export$42f6d6baced34b2d);

var $7eAIS = parcelRequire("7eAIS");

var $2k5M1 = parcelRequire("2k5M1");

var $bao60 = parcelRequire("bao60");
class $482516509fd40a68$export$42f6d6baced34b2d extends (0, $2k5M1.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $bao60.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $7eAIS.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $7eAIS.DefaultError)({});
        }
    }
}

});
parcelRegister("2k5M1", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $1bc81acb842a6186$export$4f22f74eddb7716a);

var $kP1cg = parcelRequire("kP1cg");
class $1bc81acb842a6186$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $kP1cg.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("kP1cg", function(module, exports) {
$parcel$export(module.exports, "logException", () => $950c0743f70e539d$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $950c0743f70e539d$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $950c0743f70e539d$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $950c0743f70e539d$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $950c0743f70e539d$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $950c0743f70e539d$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $950c0743f70e539d$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $950c0743f70e539d$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $356Lx = parcelRequire("356Lx");
function $950c0743f70e539d$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $950c0743f70e539d$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $356Lx.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $950c0743f70e539d$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $950c0743f70e539d$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $356Lx.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $950c0743f70e539d$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        // @ts-ignore - TypeScript 5.9.2 upgrade
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $950c0743f70e539d$export$ece28f5cfa04608(message, context = {}) {
    $950c0743f70e539d$var$logMessage('error', message, context).catch(()=>{});
}
function $950c0743f70e539d$export$386587bcf05ee8ea(message, context = {}) {
    $950c0743f70e539d$var$logMessage('info', message, context).catch(()=>{});
}
const $950c0743f70e539d$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $950c0743f70e539d$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $950c0743f70e539d$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$950c0743f70e539d$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $950c0743f70e539d$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $356Lx.getSentryClient)();
    sentryClient.withScope((scope)=>{
        // @ts-ignore - TypeScript 5.9.2 upgrade
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("356Lx", function(module, exports) {
$parcel$export(module.exports, "sentryClient", () => $d6fe0b5616dbf418$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $d6fe0b5616dbf418$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $d6fe0b5616dbf418$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $d6fe0b5616dbf418$export$d8bd0edf6c978788);

var $b0bYt = parcelRequire("b0bYt");

var $6ceSs = parcelRequire("6ceSs");
let $d6fe0b5616dbf418$export$ac71c212168fcd2b;
const $d6fe0b5616dbf418$export$7d446c6f4e54de82 = (client)=>{
    $d6fe0b5616dbf418$export$ac71c212168fcd2b = client;
};
const $d6fe0b5616dbf418$export$f553e8b08ef59d31 = async ()=>{
    if (!$d6fe0b5616dbf418$export$ac71c212168fcd2b) await $d6fe0b5616dbf418$export$d8bd0edf6c978788({});
    return $d6fe0b5616dbf418$export$ac71c212168fcd2b;
};
async function $d6fe0b5616dbf418$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $d6fe0b5616dbf418$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $6ceSs.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $d6fe0b5616dbf418$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $b0bYt.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $d6fe0b5616dbf418$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("afV4X"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
        return undefined;
    }
}
function $d6fe0b5616dbf418$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("b0bYt", function(module, exports) {
$parcel$export(module.exports, "SENTRY_DSN", () => $3bfcaf52858a3244$export$6faa4a850bc4d0ce);

var $lopBx = parcelRequire("lopBx");
const $3bfcaf52858a3244$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $3bfcaf52858a3244$export$68c35ed3898e185a = '5988845';
const $3bfcaf52858a3244$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $3bfcaf52858a3244$export$97db6664a1e55fa6 = '47';
const $3bfcaf52858a3244$var$SENTRY_COMMERCIAL_DSN = `https://${$3bfcaf52858a3244$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$3bfcaf52858a3244$export$68c35ed3898e185a}`;
const $3bfcaf52858a3244$var$SENTRY_FEDRAMP_DSN = `https://${$3bfcaf52858a3244$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$3bfcaf52858a3244$export$97db6664a1e55fa6}`;
const $3bfcaf52858a3244$export$6faa4a850bc4d0ce = (0, $lopBx.isFedRamp)() ? $3bfcaf52858a3244$var$SENTRY_FEDRAMP_DSN : $3bfcaf52858a3244$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("6ceSs", function(module, exports) {
$parcel$export(module.exports, "initialiseSentry", () => $d6feef4366a3b41b$export$357606956af25316);

var $3Cktb = parcelRequire("3Cktb");

var $356Lx = parcelRequire("356Lx");
const $d6feef4366a3b41b$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $d6feef4366a3b41b$export$357606956af25316(client, options) {
    if (0, $356Lx.sentryClient) return;
    if (!client) return;
    (0, $356Lx.setSentryClient)(client);
    const sentryConfig = (0, $3Cktb.getSentryConfig)(options);
    (0, $356Lx.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $d6feef4366a3b41b$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("3Cktb", function(module, exports) {
$parcel$export(module.exports, "getSentryConfig", () => $fd3d2aa688325677$export$5580e6304e95c792);

var $b0bYt = parcelRequire("b0bYt");
const $fd3d2aa688325677$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $b0bYt.SENTRY_DSN),
    attachStacktrace: true
};
function $fd3d2aa688325677$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$fd3d2aa688325677$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("afV4X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("94M02").then(()=>parcelRequire('497YX'));

});




parcelRegister("bao60", function(module, exports) {
$parcel$export(module.exports, "handleGraphQLRequest", () => $2e6b10bf02df85e7$export$7feffc86760ee7ce);

var $7eAIS = parcelRequire("7eAIS");

var $kdyFn = parcelRequire("kdyFn");

var $fmVjq = parcelRequire("fmVjq");
async function $2e6b10bf02df85e7$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $7eAIS.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((_resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $7eAIS.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $2e6b10bf02df85e7$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $kdyFn.withExponentialBackoff)($2e6b10bf02df85e7$export$93d33e3b46bf00e7, {
        initial: (0, $kdyFn.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $kdyFn.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $kdyFn.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $kdyFn.isFetchResponse)(data) && (0, $kdyFn.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $fmVjq.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $7eAIS.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("kdyFn", function(module, exports) {
$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $e284e0beeb1ad5b2$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $e284e0beeb1ad5b2$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $e284e0beeb1ad5b2$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $e284e0beeb1ad5b2$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $e284e0beeb1ad5b2$export$b4c0bf5325504bf3);
const $e284e0beeb1ad5b2$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $e284e0beeb1ad5b2$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $e284e0beeb1ad5b2$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $e284e0beeb1ad5b2$var$defaultRetryIfCallback = (a)=>!a;
const $e284e0beeb1ad5b2$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $e284e0beeb1ad5b2$var$defaultRetryIfCallback
};
function $e284e0beeb1ad5b2$export$20eaa22f2295996f(toTry, hofOptions = $e284e0beeb1ad5b2$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $e284e0beeb1ad5b2$export$b4c0bf5325504bf3 = $e284e0beeb1ad5b2$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $e284e0beeb1ad5b2$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $e284e0beeb1ad5b2$export$8f4286bf21155381.JITTER,
    max: $e284e0beeb1ad5b2$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$e284e0beeb1ad5b2$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("fmVjq", function(module, exports) {
$parcel$export(module.exports, "handleResponse", () => $ea5e8ca0da4c9de0$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $ea5e8ca0da4c9de0$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $ea5e8ca0da4c9de0$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $ea5e8ca0da4c9de0$export$8c005e458e12d501.handlers = handlers;
    }
};
function $ea5e8ca0da4c9de0$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $ea5e8ca0da4c9de0$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("8ZouZ", function(module, exports) {
$parcel$export(module.exports, "TeamHasAgentsQuery", () => $66f44aced11ede5e$export$5a63c9c7b444f1f5);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $66f44aced11ede5e$export$5a63c9c7b444f1f5 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query serviceName_TeamHasAgentsQuery($id: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamHasAgents(id: $id) @optIn(to: "GraphStoreTeamHasAgents") {
				edges {
					node {
						... on AppUser {
							id
							name
							picture
						}
					}
					cursor
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}
`);

});
parcelRegister("6NFTG", function(module, exports) {
$parcel$export(module.exports, "print", () => $4f37d191c0ef7631$export$c2d084dc44961371);

var $9E3xk = parcelRequire("9E3xk");

var $l68uS = parcelRequire("l68uS");
function $4f37d191c0ef7631$export$c2d084dc44961371(ast) {
    return (0, $9E3xk.visit)(ast, {
        leave: $4f37d191c0ef7631$var$printDocASTReducer
    });
}
var $4f37d191c0ef7631$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $4f37d191c0ef7631$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $4f37d191c0ef7631$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(node.variableDefinitions, ', '), ')');
        var directives = $4f37d191c0ef7631$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $4f37d191c0ef7631$var$join([
            op,
            $4f37d191c0ef7631$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $4f37d191c0ef7631$var$wrap(' = ', defaultValue) + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $4f37d191c0ef7631$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $4f37d191c0ef7631$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')');
        if (argsLine.length > $4f37d191c0ef7631$var$MAX_LINE_LENGTH) argsLine = prefix + $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)');
        return $4f37d191c0ef7631$var$join([
            argsLine,
            $4f37d191c0ef7631$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $4f37d191c0ef7631$var$join([
            '...',
            $4f37d191c0ef7631$var$wrap('on ', typeCondition),
            $4f37d191c0ef7631$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($4f37d191c0ef7631$var$wrap('', $4f37d191c0ef7631$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $l68uS.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $4f37d191c0ef7631$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $4f37d191c0ef7631$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $4f37d191c0ef7631$var$join([
            'schema',
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $4f37d191c0ef7631$var$join([
            'scalar',
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $4f37d191c0ef7631$var$join([
            'type',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($4f37d191c0ef7631$var$hasMultilineItems(args) ? $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)') : $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')')) + ': ' + type + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    }),
    InputValueDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $4f37d191c0ef7631$var$join([
            name + ': ' + type,
            $4f37d191c0ef7631$var$wrap('= ', defaultValue),
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $4f37d191c0ef7631$var$join([
            'interface',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $4f37d191c0ef7631$var$join([
            'union',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $4f37d191c0ef7631$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $4f37d191c0ef7631$var$join([
            'enum',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $4f37d191c0ef7631$var$join([
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $4f37d191c0ef7631$var$join([
            'input',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($4f37d191c0ef7631$var$hasMultilineItems(args) ? $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)') : $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $4f37d191c0ef7631$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $4f37d191c0ef7631$var$join([
            'extend schema',
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $4f37d191c0ef7631$var$join([
            'extend scalar',
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $4f37d191c0ef7631$var$join([
            'extend type',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $4f37d191c0ef7631$var$join([
            'extend interface',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $4f37d191c0ef7631$var$join([
            'extend union',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $4f37d191c0ef7631$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $4f37d191c0ef7631$var$join([
            'extend enum',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $4f37d191c0ef7631$var$join([
            'extend input',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }
};
function $4f37d191c0ef7631$var$addDescription(cb) {
    return function(node) {
        return $4f37d191c0ef7631$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $4f37d191c0ef7631$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $4f37d191c0ef7631$var$block(array) {
    return $4f37d191c0ef7631$var$wrap('{\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $4f37d191c0ef7631$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $4f37d191c0ef7631$var$indent(str) {
    return $4f37d191c0ef7631$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $4f37d191c0ef7631$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $4f37d191c0ef7631$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($4f37d191c0ef7631$var$isMultiline);
}

});
parcelRegister("9E3xk", function(module, exports) {
$parcel$export(module.exports, "BREAK", () => $705a97c9b44c8772$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $705a97c9b44c8772$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $705a97c9b44c8772$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $705a97c9b44c8772$export$728beebeea393478);

var $4QE9P = parcelRequire("4QE9P");

var $19BqA = parcelRequire("19BqA");
var $705a97c9b44c8772$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $705a97c9b44c8772$export$a89c95c098ac2a58 = Object.freeze({});
function $705a97c9b44c8772$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $705a97c9b44c8772$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $19BqA.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $4QE9P.default)(node), "."));
            var visitFn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $19BqA.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $705a97c9b44c8772$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) skipping[i] = $705a97c9b44c8772$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) skipping[i] = $705a97c9b44c8772$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $705a97c9b44c8772$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("4QE9P", function(module, exports) {
$parcel$export(module.exports, "default", () => $387b2b38bb5e6d4b$export$2e2bcd8739ae039);

var $e5Dlp = parcelRequire("e5Dlp");
function $387b2b38bb5e6d4b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $387b2b38bb5e6d4b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $387b2b38bb5e6d4b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $387b2b38bb5e6d4b$var$_typeof(obj);
}
var $387b2b38bb5e6d4b$var$MAX_ARRAY_LENGTH = 10;
var $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH = 2;
function $387b2b38bb5e6d4b$export$2e2bcd8739ae039(value) {
    return $387b2b38bb5e6d4b$var$formatValue(value, []);
}
function $387b2b38bb5e6d4b$var$formatValue(value, seenValues) {
    switch($387b2b38bb5e6d4b$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $387b2b38bb5e6d4b$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $387b2b38bb5e6d4b$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $387b2b38bb5e6d4b$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $387b2b38bb5e6d4b$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $387b2b38bb5e6d4b$var$formatArray(value, seenValues);
    return $387b2b38bb5e6d4b$var$formatObject(value, seenValues);
}
function $387b2b38bb5e6d4b$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH) return '[' + $387b2b38bb5e6d4b$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $387b2b38bb5e6d4b$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $387b2b38bb5e6d4b$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($387b2b38bb5e6d4b$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($387b2b38bb5e6d4b$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $387b2b38bb5e6d4b$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $e5Dlp.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $387b2b38bb5e6d4b$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("e5Dlp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4200d41543ce842$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $a4200d41543ce842$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $a4200d41543ce842$export$2e2bcd8739ae039 = $a4200d41543ce842$var$nodejsCustomInspectSymbol;

});


parcelRegister("19BqA", function(module, exports) {
$parcel$export(module.exports, "Location", () => $0d73aa1a6bd3d4cf$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $0d73aa1a6bd3d4cf$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $0d73aa1a6bd3d4cf$export$8ee0fc9ee280b4ee);

var $k3Xa1 = parcelRequire("k3Xa1");
var $0d73aa1a6bd3d4cf$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $k3Xa1.default)($0d73aa1a6bd3d4cf$export$18a2be9195644f38);
var $0d73aa1a6bd3d4cf$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $k3Xa1.default)($0d73aa1a6bd3d4cf$export$50792b0e93539fde);
function $0d73aa1a6bd3d4cf$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("k3Xa1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9b1fa842852583f$export$2e2bcd8739ae039);

var $8oZnC = parcelRequire("8oZnC");

var $e5Dlp = parcelRequire("e5Dlp");
function $e9b1fa842852583f$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $8oZnC.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $e5Dlp.default) classObject.prototype[0, $e5Dlp.default] = fn;
}

});
parcelRegister("8oZnC", function(module, exports) {
$parcel$export(module.exports, "default", () => $61e02d6059f2aabe$export$2e2bcd8739ae039);
function $61e02d6059f2aabe$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("l68uS", function(module, exports) {
$parcel$export(module.exports, "dedentBlockStringValue", () => $f5c0bfd4ee7d8292$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $f5c0bfd4ee7d8292$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $f5c0bfd4ee7d8292$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $f5c0bfd4ee7d8292$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $f5c0bfd4ee7d8292$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $f5c0bfd4ee7d8292$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $f5c0bfd4ee7d8292$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $f5c0bfd4ee7d8292$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $f5c0bfd4ee7d8292$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("kuAvn", function(module, exports) {
$parcel$export(module.exports, "gql", () => $eeb2ed1fa1f7c351$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $eeb2ed1fa1f7c351$export$2e2bcd8739ae039);

var $dnskZ = parcelRequire("dnskZ");

var $f6P3g = parcelRequire("f6P3g");
var $eeb2ed1fa1f7c351$var$docCache = new Map();
var $eeb2ed1fa1f7c351$var$fragmentSourceMap = new Map();
var $eeb2ed1fa1f7c351$var$printFragmentWarnings = true;
var $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = false;
function $eeb2ed1fa1f7c351$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $eeb2ed1fa1f7c351$var$cacheKeyFromLoc(loc) {
    return $eeb2ed1fa1f7c351$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $eeb2ed1fa1f7c351$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $eeb2ed1fa1f7c351$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $eeb2ed1fa1f7c351$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($eeb2ed1fa1f7c351$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $eeb2ed1fa1f7c351$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, ast), {
        definitions: definitions
    });
}
function $eeb2ed1fa1f7c351$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $eeb2ed1fa1f7c351$var$parseDocument(source) {
    var cacheKey = $eeb2ed1fa1f7c351$var$normalize(source);
    if (!$eeb2ed1fa1f7c351$var$docCache.has(cacheKey)) {
        var parsed = (0, $f6P3g.parse)(source, {
            experimentalFragmentVariables: $eeb2ed1fa1f7c351$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $eeb2ed1fa1f7c351$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $eeb2ed1fa1f7c351$var$docCache.set(cacheKey, $eeb2ed1fa1f7c351$var$stripLoc($eeb2ed1fa1f7c351$var$processFragments(parsed)));
    }
    return $eeb2ed1fa1f7c351$var$docCache.get(cacheKey);
}
function $eeb2ed1fa1f7c351$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $eeb2ed1fa1f7c351$var$parseDocument(result);
}
function $eeb2ed1fa1f7c351$export$657554ef4dc7ac2d() {
    $eeb2ed1fa1f7c351$var$docCache.clear();
    $eeb2ed1fa1f7c351$var$fragmentSourceMap.clear();
}
function $eeb2ed1fa1f7c351$export$e4294e638636c6ab() {
    $eeb2ed1fa1f7c351$var$printFragmentWarnings = false;
}
function $eeb2ed1fa1f7c351$export$78cf889af350c840() {
    $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = true;
}
function $eeb2ed1fa1f7c351$export$5290df9bbbd3cfa() {
    $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = false;
}
var $eeb2ed1fa1f7c351$var$extras = {
    gql: $eeb2ed1fa1f7c351$export$72e4926bf8358653,
    resetCaches: $eeb2ed1fa1f7c351$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $eeb2ed1fa1f7c351$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $eeb2ed1fa1f7c351$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $eeb2ed1fa1f7c351$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $eeb2ed1fa1f7c351$var$extras.gql, gql_1.resetCaches = $eeb2ed1fa1f7c351$var$extras.resetCaches, gql_1.disableFragmentWarnings = $eeb2ed1fa1f7c351$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $eeb2ed1fa1f7c351$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $eeb2ed1fa1f7c351$var$extras.disableExperimentalFragmentVariables;
})($eeb2ed1fa1f7c351$export$72e4926bf8358653 || ($eeb2ed1fa1f7c351$export$72e4926bf8358653 = {}));
$eeb2ed1fa1f7c351$export$72e4926bf8358653["default"] = $eeb2ed1fa1f7c351$export$72e4926bf8358653;
var $eeb2ed1fa1f7c351$export$2e2bcd8739ae039 = $eeb2ed1fa1f7c351$export$72e4926bf8358653;

});
parcelRegister("f6P3g", function(module, exports) {
$parcel$export(module.exports, "parse", () => $afff0452d66d5631$export$98e6a39c04603d36);

var $iZFMu = parcelRequire("iZFMu");

var $4oHdA = parcelRequire("4oHdA");

var $19BqA = parcelRequire("19BqA");

var $ePiKI = parcelRequire("ePiKI");

var $6dDiC = parcelRequire("6dDiC");

var $4nWzJ = parcelRequire("4nWzJ");

var $6XgSE = parcelRequire("6XgSE");
function $afff0452d66d5631$export$98e6a39c04603d36(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $afff0452d66d5631$export$5303528d1070ff6f(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ePiKI.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $ePiKI.TokenKind).EOF);
    return value;
}
function $afff0452d66d5631$export$28b8f402ccc88182(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ePiKI.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $ePiKI.TokenKind).EOF);
    return type;
}
var $afff0452d66d5631$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6dDiC.isSource)(source) ? source : new (0, $6dDiC.Source)(source);
        this._lexer = new (0, $6XgSE.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $ePiKI.TokenKind).NAME);
        return {
            kind: (0, $4oHdA.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).DOCUMENT,
            definitions: this.many((0, $ePiKI.TokenKind).SOF, this.parseDefinition, (0, $ePiKI.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $ePiKI.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $ePiKI.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $ePiKI.TokenKind).BRACE_L)) return {
            kind: (0, $4oHdA.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $ePiKI.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $4oHdA.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $ePiKI.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $ePiKI.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).DOLLAR);
        return {
            kind: (0, $4oHdA.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).SELECTION_SET,
            selections: this.many((0, $ePiKI.TokenKind).BRACE_L, this.parseSelection, (0, $ePiKI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $ePiKI.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $4oHdA.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $ePiKI.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, item, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        return {
            kind: (0, $4oHdA.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $ePiKI.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $ePiKI.TokenKind).NAME)) return {
            kind: (0, $4oHdA.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $4oHdA.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $4oHdA.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $4oHdA.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $ePiKI.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $ePiKI.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $ePiKI.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $4oHdA.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ePiKI.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $4oHdA.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ePiKI.TokenKind).STRING:
            case (0, $ePiKI.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $ePiKI.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $4oHdA.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $4oHdA.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $4oHdA.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $4oHdA.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $ePiKI.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $4oHdA.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $ePiKI.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $4oHdA.Kind).LIST,
            values: this.any((0, $ePiKI.TokenKind).BRACKET_L, item, (0, $ePiKI.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $4oHdA.Kind).OBJECT,
            fields: this.any((0, $ePiKI.TokenKind).BRACE_L, item, (0, $ePiKI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        return {
            kind: (0, $4oHdA.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $ePiKI.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).AT);
        return {
            kind: (0, $4oHdA.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $ePiKI.TokenKind).BRACKET_R);
            type = {
                kind: (0, $4oHdA.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).BANG)) return {
            kind: (0, $4oHdA.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $ePiKI.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $ePiKI.TokenKind).STRING) || this.peek((0, $ePiKI.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $ePiKI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $ePiKI.TokenKind).BRACE_R);
        return {
            kind: (0, $4oHdA.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $4oHdA.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $ePiKI.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $ePiKI.TokenKind).AMP) || this.peek((0, $ePiKI.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $ePiKI.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $ePiKI.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $ePiKI.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, this.parseInputValueDef, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $4oHdA.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS) ? this.delimitedMany((0, $ePiKI.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $4oHdA.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseInputValueDef, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $ePiKI.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $ePiKI.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $ePiKI.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $4oHdA.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $ePiKI.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $4nWzJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $19BqA.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Expected ".concat($afff0452d66d5631$var$getTokenKindDesc(kind), ", found ").concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ePiKI.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ePiKI.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $afff0452d66d5631$var$getTokenDesc(token) {
    var value = token.value;
    return $afff0452d66d5631$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $afff0452d66d5631$var$getTokenKindDesc(kind) {
    return (0, $6XgSE.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("iZFMu", function(module, exports) {
$parcel$export(module.exports, "syntaxError", () => $dd3e555a07a61943$export$bbee0c6176c019d4);

var $eXc8C = parcelRequire("eXc8C");
function $dd3e555a07a61943$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $eXc8C.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("eXc8C", function(module, exports) {
$parcel$export(module.exports, "GraphQLError", () => $ae2ffdc10628e3fd$export$92d6ed0888e7cb7f);

var $fjX8u = parcelRequire("fjX8u");

var $j38tO = parcelRequire("j38tO");

var $3iKxr = parcelRequire("3iKxr");

var $hD37S = parcelRequire("hD37S");

var $1TwT7 = parcelRequire("1TwT7");
function $ae2ffdc10628e3fd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ae2ffdc10628e3fd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ae2ffdc10628e3fd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ae2ffdc10628e3fd$var$_typeof(obj);
}
function $ae2ffdc10628e3fd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ae2ffdc10628e3fd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ae2ffdc10628e3fd$var$ownKeys(Object(source), true).forEach(function(key) {
            $ae2ffdc10628e3fd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ae2ffdc10628e3fd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ae2ffdc10628e3fd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae2ffdc10628e3fd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae2ffdc10628e3fd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ae2ffdc10628e3fd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ae2ffdc10628e3fd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ae2ffdc10628e3fd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ae2ffdc10628e3fd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ae2ffdc10628e3fd$var$_setPrototypeOf(subClass, superClass);
}
function $ae2ffdc10628e3fd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ae2ffdc10628e3fd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ae2ffdc10628e3fd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ae2ffdc10628e3fd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ae2ffdc10628e3fd$var$_possibleConstructorReturn(this, result);
    };
}
function $ae2ffdc10628e3fd$var$_possibleConstructorReturn(self, call) {
    if (call && ($ae2ffdc10628e3fd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ae2ffdc10628e3fd$var$_assertThisInitialized(self);
}
function $ae2ffdc10628e3fd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ae2ffdc10628e3fd$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ae2ffdc10628e3fd$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$ae2ffdc10628e3fd$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $ae2ffdc10628e3fd$var$_construct(Class, arguments, $ae2ffdc10628e3fd$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $ae2ffdc10628e3fd$var$_setPrototypeOf(Wrapper, Class);
    };
    return $ae2ffdc10628e3fd$var$_wrapNativeSuper(Class);
}
function $ae2ffdc10628e3fd$var$_construct(Parent, args, Class) {
    if ($ae2ffdc10628e3fd$var$_isNativeReflectConstruct()) $ae2ffdc10628e3fd$var$_construct = Reflect.construct;
    else $ae2ffdc10628e3fd$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $ae2ffdc10628e3fd$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $ae2ffdc10628e3fd$var$_construct.apply(null, arguments);
}
function $ae2ffdc10628e3fd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ae2ffdc10628e3fd$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $ae2ffdc10628e3fd$var$_setPrototypeOf(o, p) {
    $ae2ffdc10628e3fd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae2ffdc10628e3fd$var$_setPrototypeOf(o, p);
}
function $ae2ffdc10628e3fd$var$_getPrototypeOf(o) {
    $ae2ffdc10628e3fd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ae2ffdc10628e3fd$var$_getPrototypeOf(o);
}
var $ae2ffdc10628e3fd$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $ae2ffdc10628e3fd$var$_inherits(GraphQLError, _Error);
    var _super = $ae2ffdc10628e3fd$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $ae2ffdc10628e3fd$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $ae2ffdc10628e3fd$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $ae2ffdc10628e3fd$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $hD37S.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $hD37S.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $j38tO.default)(originalExtensions)) _this.extensions = $ae2ffdc10628e3fd$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $ae2ffdc10628e3fd$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $ae2ffdc10628e3fd$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $ae2ffdc10628e3fd$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $ae2ffdc10628e3fd$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $3iKxr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $ae2ffdc10628e3fd$var$_wrapNativeSuper(Error));
function $ae2ffdc10628e3fd$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $ae2ffdc10628e3fd$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $1TwT7.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $1TwT7.printSourceLocation)(error.source, location);
    }
    return output;
}
function $ae2ffdc10628e3fd$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $fjX8u.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("fjX8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2768086a269b262$export$2e2bcd8739ae039);
function $b2768086a269b262$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("j38tO", function(module, exports) {
$parcel$export(module.exports, "default", () => $dde4e0129ad4f4db$export$2e2bcd8739ae039);
function $dde4e0129ad4f4db$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dde4e0129ad4f4db$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dde4e0129ad4f4db$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dde4e0129ad4f4db$var$_typeof(obj);
}
function $dde4e0129ad4f4db$export$2e2bcd8739ae039(value) {
    return $dde4e0129ad4f4db$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("3iKxr", function(module, exports) {
$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $2677271cc8cb2427$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $2677271cc8cb2427$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2677271cc8cb2427$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $2677271cc8cb2427$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2677271cc8cb2427$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("hD37S", function(module, exports) {
$parcel$export(module.exports, "getLocation", () => $cd5880f6ab51819f$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $cd5880f6ab51819f$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("1TwT7", function(module, exports) {
$parcel$export(module.exports, "printLocation", () => $1614705cd80bb521$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $1614705cd80bb521$export$867940333fd9f869);

var $hD37S = parcelRequire("hD37S");
function $1614705cd80bb521$export$96a9681e539deed(location) {
    return $1614705cd80bb521$export$867940333fd9f869(location.source, (0, $hD37S.getLocation)(location.source, location.start));
}
function $1614705cd80bb521$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $1614705cd80bb521$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $1614705cd80bb521$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $1614705cd80bb521$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $1614705cd80bb521$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $1614705cd80bb521$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $1614705cd80bb521$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $1614705cd80bb521$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $1614705cd80bb521$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $1614705cd80bb521$var$leftPad(len, str) {
    return $1614705cd80bb521$var$whitespace(len - str.length) + str;
}

});



parcelRegister("4oHdA", function(module, exports) {
$parcel$export(module.exports, "Kind", () => $333aed883d7e11f5$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $333aed883d7e11f5$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("ePiKI", function(module, exports) {
$parcel$export(module.exports, "TokenKind", () => $acb45ff744d0f320$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $acb45ff744d0f320$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6dDiC", function(module, exports) {
$parcel$export(module.exports, "Source", () => $487270f96a0f45cd$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $487270f96a0f45cd$export$75135ee9ed6e435b);

var $3iKxr = parcelRequire("3iKxr");

var $4QE9P = parcelRequire("4QE9P");

var $fjX8u = parcelRequire("fjX8u");

var $9kbnx = parcelRequire("9kbnx");
function $487270f96a0f45cd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $487270f96a0f45cd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $487270f96a0f45cd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $487270f96a0f45cd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $487270f96a0f45cd$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fjX8u.default)(0, "Body must be a string. Received: ".concat((0, $4QE9P.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fjX8u.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fjX8u.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $487270f96a0f45cd$var$_createClass(Source, [
        {
            key: (0, $3iKxr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $487270f96a0f45cd$export$75135ee9ed6e435b(source) {
    return (0, $9kbnx.default)(source, $487270f96a0f45cd$export$1d2df86270c81ecb);
}

});
parcelRegister("9kbnx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c9ecedfbfa67ab7$export$2e2bcd8739ae039);

function $6c9ecedfbfa67ab7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6c9ecedfbfa67ab7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6c9ecedfbfa67ab7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6c9ecedfbfa67ab7$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$6c9ecedfbfa67ab7$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("4nWzJ", function(module, exports) {
$parcel$export(module.exports, "DirectiveLocation", () => $3316bf4202cd07db$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $3316bf4202cd07db$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("6XgSE", function(module, exports) {
$parcel$export(module.exports, "Lexer", () => $510558e4af143ea3$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $510558e4af143ea3$export$59ac0f4da287406a);

var $iZFMu = parcelRequire("iZFMu");

var $19BqA = parcelRequire("19BqA");

var $ePiKI = parcelRequire("ePiKI");

var $l68uS = parcelRequire("l68uS");
var $510558e4af143ea3$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $19BqA.Token)((0, $ePiKI.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $ePiKI.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $510558e4af143ea3$var$readToken(this, token);
        }while (token.kind === (0, $ePiKI.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $510558e4af143ea3$export$59ac0f4da287406a(kind) {
    return kind === (0, $ePiKI.TokenKind).BANG || kind === (0, $ePiKI.TokenKind).DOLLAR || kind === (0, $ePiKI.TokenKind).AMP || kind === (0, $ePiKI.TokenKind).PAREN_L || kind === (0, $ePiKI.TokenKind).PAREN_R || kind === (0, $ePiKI.TokenKind).SPREAD || kind === (0, $ePiKI.TokenKind).COLON || kind === (0, $ePiKI.TokenKind).EQUALS || kind === (0, $ePiKI.TokenKind).AT || kind === (0, $ePiKI.TokenKind).BRACKET_L || kind === (0, $ePiKI.TokenKind).BRACKET_R || kind === (0, $ePiKI.TokenKind).BRACE_L || kind === (0, $ePiKI.TokenKind).PIPE || kind === (0, $ePiKI.TokenKind).BRACE_R;
}
function $510558e4af143ea3$var$printCharCode(code) {
    return isNaN(code) ? (0, $ePiKI.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $510558e4af143ea3$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $510558e4af143ea3$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $510558e4af143ea3$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $510558e4af143ea3$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $510558e4af143ea3$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $510558e4af143ea3$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $iZFMu.syntaxError)(source, pos, $510558e4af143ea3$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $510558e4af143ea3$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($510558e4af143ea3$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($510558e4af143ea3$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $510558e4af143ea3$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $510558e4af143ea3$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
    } else {
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $510558e4af143ea3$var$isNameStart(code)) throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
    return new (0, $19BqA.Token)(isFloat ? (0, $ePiKI.TokenKind).FLOAT : (0, $ePiKI.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $510558e4af143ea3$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $510558e4af143ea3$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $iZFMu.syntaxError)(source, position, "Invalid character within String: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $510558e4af143ea3$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $iZFMu.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $iZFMu.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $iZFMu.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $510558e4af143ea3$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $l68uS.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $iZFMu.syntaxError)(source, position, "Invalid character within String: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $iZFMu.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $510558e4af143ea3$var$uniCharCode(a, b, c, d) {
    return $510558e4af143ea3$var$char2hex(a) << 12 | $510558e4af143ea3$var$char2hex(b) << 8 | $510558e4af143ea3$var$char2hex(c) << 4 | $510558e4af143ea3$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $510558e4af143ea3$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $510558e4af143ea3$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $510558e4af143ea3$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("kFoav", function(module, exports) {
$parcel$export(module.exports, "default", () => $b64af9936b3bc705$export$2e2bcd8739ae039);
const $b64af9936b3bc705$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $b64af9936b3bc705$export$2e2bcd8739ae039 = $b64af9936b3bc705$var$TeamMembershipQuery;

});

parcelRegister("1C7fa", function(module, exports) {
$parcel$export(module.exports, "TeamsUserQuery", () => $fb20ed74c9109efd$export$9963ed3cbf7b791c);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $fb20ed74c9109efd$export$9963ed3cbf7b791c = (0, $6NFTG.print)((0, $kuAvn.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});

parcelRegister("6qJst", function(module, exports) {
$parcel$export(module.exports, "toUserType", () => $385aa7799a3d60f2$export$6b53fef091c7e27d);
function $385aa7799a3d60f2$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("jWVEO", function(module, exports) {
$parcel$export(module.exports, "default", () => $3deb5d9180d1d877$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
var $3deb5d9180d1d877$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($3deb5d9180d1d877$var$CONTAINER_TYPE || {});
var $3deb5d9180d1d877$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($3deb5d9180d1d877$var$ENTITY_TYPE || {});
class $3deb5d9180d1d877$export$cd5b4a06db0ea4e2 extends (0, $f4dfy.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
}
var $3deb5d9180d1d877$export$2e2bcd8739ae039 = new $3deb5d9180d1d877$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $hncrn.DEFAULT_CONFIG).collaborationGraphUrl
});

});
parcelRegister("f4dfy", function(module, exports) {
$parcel$export(module.exports, "RestClient", () => $f4b310ea0eea58cd$export$ea8b5b3aea9558ce);

var $bx11l = parcelRequire("bx11l");

var $7eAIS = parcelRequire("7eAIS");

var $kdyFn = parcelRequire("kdyFn");

var $fmVjq = parcelRequire("fmVjq");

var $2k5M1 = parcelRequire("2k5M1");

var $cTA7L = parcelRequire("cTA7L");

var $hT1xa = parcelRequire("hT1xa");

var $fLJk5 = parcelRequire("fLJk5");

var $bZ6Gn = parcelRequire("bZ6Gn");
const $f4b310ea0eea58cd$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $f4b310ea0eea58cd$var$incrementRedirectCount;
let $f4b310ea0eea58cd$var$clearRedirectCount;
$f4b310ea0eea58cd$export$7a0fc52d8c359feb();
function $f4b310ea0eea58cd$export$7a0fc52d8c359feb() {
    $f4b310ea0eea58cd$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(()=>(0, $cTA7L.setCookie)((0, $cTA7L.REDIRECT_COUNT), (0, $cTA7L.getCookieAsInteger)((0, $cTA7L.REDIRECT_COUNT)) + 1));
    $f4b310ea0eea58cd$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(()=>(0, $cTA7L.clearCookie)((0, $cTA7L.REDIRECT_COUNT)));
}
class $f4b310ea0eea58cd$export$ea8b5b3aea9558ce extends (0, $2k5M1.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config), /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $f4b310ea0eea58cd$var$incrementRedirectCount();
            } else $f4b310ea0eea58cd$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$f4b310ea0eea58cd$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $kdyFn.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $fmVjq.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $7eAIS.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $hT1xa.parseErrorMessage)(response);
                const httpError = new (0, $7eAIS.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $bZ6Gn.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
        return additionalFetchOptions.ignoreResponse ? null : (0, $fLJk5.parseResponse)(response);
    }
}

});
parcelRegister("cTA7L", function(module, exports) {
$parcel$export(module.exports, "REDIRECT_COUNT", () => $3804e15c953cc2d8$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $3804e15c953cc2d8$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $3804e15c953cc2d8$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $3804e15c953cc2d8$export$ad3506281d5a5e5d);
const $3804e15c953cc2d8$export$f6101897f0230549 = 'redirectCount';
const $3804e15c953cc2d8$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $3804e15c953cc2d8$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $3804e15c953cc2d8$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $3804e15c953cc2d8$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("hT1xa", function(module, exports) {
$parcel$export(module.exports, "parseErrorMessage", () => $30e2b438421fffae$export$91c32f1b22d29b2d);
async function $30e2b438421fffae$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("fLJk5", function(module, exports) {
$parcel$export(module.exports, "parseResponse", () => $95bfa249eb0301d7$export$ba14d9a5a581e827);
function $95bfa249eb0301d7$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("bZ6Gn", function(module, exports) {
$parcel$export(module.exports, "stripUUIDFromPath", () => $fb47b928702db867$export$6bd073e2c6dda996);
const $fb47b928702db867$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $fb47b928702db867$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($fb47b928702db867$var$UUID_REGEX, '<UUID>');
};

});



parcelRegister("kl6VX", function(module, exports) {
$parcel$export(module.exports, "directoryClient", () => $4f169f0f24afad44$export$ead519165de472de);

var $hncrn = parcelRequire("hncrn");

var $le4QF = parcelRequire("le4QF");

var $kP1cg = parcelRequire("kP1cg");
const $4f169f0f24afad44$export$28456d095a642fd = 'internal.browse-users-allowed';
const $4f169f0f24afad44$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $4f169f0f24afad44$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $4f169f0f24afad44$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $4f169f0f24afad44$export$c8a50bf6c196fc10 extends (0, $le4QF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $4f169f0f24afad44$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4f169f0f24afad44$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $4f169f0f24afad44$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4f169f0f24afad44$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $4f169f0f24afad44$export$ead519165de472de = new $4f169f0f24afad44$export$c8a50bf6c196fc10((0, $hncrn.DEFAULT_CONFIG).stargateRoot, {
    logException: $kP1cg.logException
});

});

parcelRegister("bP17Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd66c970efc6b685$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");

var $a0w2l = parcelRequire("a0w2l");
const $bd66c970efc6b685$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/users`
};
class $bd66c970efc6b685$export$f9c003efee04f318 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$bd66c970efc6b685$var$defaultConfig,
            ...config
        });
    }
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $a0w2l.transformUserManageConfig)(resp);
        });
    }
    /**
	 * @deprecated
	 * User fetchUserAvatarInfo instead
	 */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $a0w2l.toManageAPIInput)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $a0w2l.dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
}
var $bd66c970efc6b685$export$2e2bcd8739ae039 = new $bd66c970efc6b685$export$f9c003efee04f318();

});
parcelRegister("a0w2l", function(module, exports) {
$parcel$export(module.exports, "transformUserManageConfig", () => $cbf9873764e358e5$export$d7725d3d27b80a68);
$parcel$export(module.exports, "toManageAPIInput", () => $cbf9873764e358e5$export$7b103107c889cb67);
$parcel$export(module.exports, "dataURItoFile", () => $cbf9873764e358e5$export$80d19edb7b1ae293);
parcelRequire("7VJg5");
var $7jfLy = parcelRequire("7jfLy");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $cbf9873764e358e5$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $cbf9873764e358e5$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $7jfLy.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($cbf9873764e358e5$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($cbf9873764e358e5$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$cbf9873764e358e5$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $cbf9873764e358e5$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $cbf9873764e358e5$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $cbf9873764e358e5$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $cbf9873764e358e5$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $cbf9873764e358e5$export$2ff7b92b9e1bb4d2[field]) return data[$cbf9873764e358e5$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $cbf9873764e358e5$export$78158d2c2c6998d9 ? $cbf9873764e358e5$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $cbf9873764e358e5$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($cbf9873764e358e5$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $cbf9873764e358e5$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $cbf9873764e358e5$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $cbf9873764e358e5$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $cbf9873764e358e5$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($cbf9873764e358e5$export$78158d2c2c6998d9).map((field)=>$cbf9873764e358e5$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $cbf9873764e358e5$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($cbf9873764e358e5$var$PROFILE_PROPS_MAP.has(key)) output[$cbf9873764e358e5$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $cbf9873764e358e5$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});
parcelRegister("7VJg5", function(module, exports) {
$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("7jfLy")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $7jfLy = parcelRequire("7jfLy");





});
parcelRegister("7jfLy", function(module, exports) {
$parcel$export(module.exports, "default", () => $552689929d984fb3$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $6wcTn = parcelRequire("6wcTn");

var $eGHhJ = parcelRequire("eGHhJ");
function $552689929d984fb3$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $6wcTn.default)((0, $eGHhJ.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("7noXc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55ee09b25d235297$var$cloneObject;

var $55ee09b25d235297$var$_index = $55ee09b25d235297$var$_interopRequireDefault((parcelRequire("kLhoC")));
function $55ee09b25d235297$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $55ee09b25d235297$var$cloneObject(dirtyObject) {
    return (0, $55ee09b25d235297$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("kLhoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1d5b0ef828f96ec$var$assign;
function $f1d5b0ef828f96ec$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("6wcTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4befbb5afdcbfc65$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $5I5AW = parcelRequire("5I5AW");

var $2uu2q = parcelRequire("2uu2q");
var $4befbb5afdcbfc65$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $4befbb5afdcbfc65$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($4befbb5afdcbfc65$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $2uu2q.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $5I5AW.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("47etr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ff30b0f5d6c94be$var$format;

var $2ff30b0f5d6c94be$var$_index = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("9ATkL")));

var $2ff30b0f5d6c94be$var$_index2 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("5Ex2M")));

var $2ff30b0f5d6c94be$var$_index3 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("9e8fk")));

var $2ff30b0f5d6c94be$var$_index4 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("411TS")));

var $2ff30b0f5d6c94be$var$_index5 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("1S5cf")));

var $2ff30b0f5d6c94be$var$_index6 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("3f2WU")));

var $2ff30b0f5d6c94be$var$_index7 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("ejJXr")));

var $7AKXx = parcelRequire("7AKXx");

var $2ff30b0f5d6c94be$var$_index9 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("a04h3")));

var $2ff30b0f5d6c94be$var$_index10 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $2ff30b0f5d6c94be$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $2ff30b0f5d6c94be$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $2ff30b0f5d6c94be$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $2ff30b0f5d6c94be$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $2ff30b0f5d6c94be$var$doubleQuoteRegExp = /''/g;
var $2ff30b0f5d6c94be$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $2ff30b0f5d6c94be$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $2ff30b0f5d6c94be$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $2ff30b0f5d6c94be$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $2ff30b0f5d6c94be$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $2ff30b0f5d6c94be$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $2ff30b0f5d6c94be$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $2ff30b0f5d6c94be$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $2ff30b0f5d6c94be$var$_index4.default)(dirtyDate);
    if (!(0, $2ff30b0f5d6c94be$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $2ff30b0f5d6c94be$var$_index7.default)(originalDate);
    var utcDate = (0, $2ff30b0f5d6c94be$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($2ff30b0f5d6c94be$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $2ff30b0f5d6c94be$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($2ff30b0f5d6c94be$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $2ff30b0f5d6c94be$var$cleanEscapedString(substring);
        var formatter = $2ff30b0f5d6c94be$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $7AKXx.isProtectedWeekYearToken)(substring)) (0, $7AKXx.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $7AKXx.isProtectedDayOfYearToken)(substring)) (0, $7AKXx.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($2ff30b0f5d6c94be$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $2ff30b0f5d6c94be$var$cleanEscapedString(input) {
    return input.match($2ff30b0f5d6c94be$var$escapedStringRegExp)[1].replace($2ff30b0f5d6c94be$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("9ATkL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6fc265fbf88f3fb2$var$isValid;

var $6fc265fbf88f3fb2$var$_index = $6fc265fbf88f3fb2$var$_interopRequireDefault((parcelRequire("411TS")));

var $6fc265fbf88f3fb2$var$_index2 = $6fc265fbf88f3fb2$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $6fc265fbf88f3fb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $6fc265fbf88f3fb2$var$isValid(dirtyDate) {
    (0, $6fc265fbf88f3fb2$var$_index2.default)(1, arguments);
    var date = (0, $6fc265fbf88f3fb2$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("411TS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ec8bac3829b5d77$var$toDate;

var $2ec8bac3829b5d77$var$_index = $2ec8bac3829b5d77$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $2ec8bac3829b5d77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $2ec8bac3829b5d77$var$toDate(argument) {
    (0, $2ec8bac3829b5d77$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("4YZVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a0ccec6969661ab$var$requiredArgs;
function $3a0ccec6969661ab$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("5Ex2M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41da51fb3f7f2e9e$var$_index = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("j0Eie")));

var $41da51fb3f7f2e9e$var$_index2 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("hCaWU")));

var $41da51fb3f7f2e9e$var$_index3 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("grk3U")));

var $41da51fb3f7f2e9e$var$_index4 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("36Npg")));

var $41da51fb3f7f2e9e$var$_index5 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("72ljP")));
function $41da51fb3f7f2e9e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $41da51fb3f7f2e9e$var$locale = {
    code: 'en-US',
    formatDistance: $41da51fb3f7f2e9e$var$_index.default,
    formatLong: $41da51fb3f7f2e9e$var$_index2.default,
    formatRelative: $41da51fb3f7f2e9e$var$_index3.default,
    localize: $41da51fb3f7f2e9e$var$_index4.default,
    match: $41da51fb3f7f2e9e$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $41da51fb3f7f2e9e$var$_default = $41da51fb3f7f2e9e$var$locale;
module.exports.default = $41da51fb3f7f2e9e$var$_default;
module.exports = module.exports.default;

});
parcelRegister("j0Eie", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd6d45c5fb0de521$var$formatDistance;
var $dd6d45c5fb0de521$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $dd6d45c5fb0de521$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $dd6d45c5fb0de521$var$formatDistanceLocale[token] === 'string') result = $dd6d45c5fb0de521$var$formatDistanceLocale[token];
    else if (count === 1) result = $dd6d45c5fb0de521$var$formatDistanceLocale[token].one;
    else result = $dd6d45c5fb0de521$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("hCaWU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd2e7a8b4adafb98$var$_index = $cd2e7a8b4adafb98$var$_interopRequireDefault((parcelRequire("1KaiK")));
function $cd2e7a8b4adafb98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cd2e7a8b4adafb98$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $cd2e7a8b4adafb98$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $cd2e7a8b4adafb98$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cd2e7a8b4adafb98$var$formatLong = {
    date: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cd2e7a8b4adafb98$var$_default = $cd2e7a8b4adafb98$var$formatLong;
module.exports.default = $cd2e7a8b4adafb98$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1KaiK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $145213f5e2256761$var$buildFormatLongFn;
function $145213f5e2256761$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("grk3U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf7ebae278921a82$var$formatRelative;
var $bf7ebae278921a82$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $bf7ebae278921a82$var$formatRelative(token, _date, _baseDate, _options) {
    return $bf7ebae278921a82$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("36Npg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $243841b569f75983$var$_index = $243841b569f75983$var$_interopRequireDefault((parcelRequire("4Oo0u")));
function $243841b569f75983$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $243841b569f75983$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $243841b569f75983$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $243841b569f75983$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $243841b569f75983$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $243841b569f75983$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $243841b569f75983$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $243841b569f75983$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $243841b569f75983$var$localize = {
    ordinalNumber: $243841b569f75983$var$ordinalNumber,
    era: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $243841b569f75983$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $243841b569f75983$var$_default = $243841b569f75983$var$localize;
module.exports.default = $243841b569f75983$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4Oo0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $380e7433bb720b67$var$buildLocalizeFn;
function $380e7433bb720b67$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("72ljP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51f941c45a4dfa75$var$_index = $51f941c45a4dfa75$var$_interopRequireDefault((parcelRequire("04buv")));

var $51f941c45a4dfa75$var$_index2 = $51f941c45a4dfa75$var$_interopRequireDefault((parcelRequire("eVPlb")));
function $51f941c45a4dfa75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $51f941c45a4dfa75$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $51f941c45a4dfa75$var$parseOrdinalNumberPattern = /\d+/i;
var $51f941c45a4dfa75$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $51f941c45a4dfa75$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $51f941c45a4dfa75$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $51f941c45a4dfa75$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $51f941c45a4dfa75$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $51f941c45a4dfa75$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $51f941c45a4dfa75$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $51f941c45a4dfa75$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $51f941c45a4dfa75$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $51f941c45a4dfa75$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $51f941c45a4dfa75$var$match = {
    ordinalNumber: (0, $51f941c45a4dfa75$var$_index.default)({
        matchPattern: $51f941c45a4dfa75$var$matchOrdinalNumberPattern,
        parsePattern: $51f941c45a4dfa75$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $51f941c45a4dfa75$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $51f941c45a4dfa75$var$_default = $51f941c45a4dfa75$var$match;
module.exports.default = $51f941c45a4dfa75$var$_default;
module.exports = module.exports.default;

});
parcelRegister("04buv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00c949bab0549061$var$buildMatchPatternFn;
function $00c949bab0549061$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("eVPlb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adee36c0e746269c$var$buildMatchFn;
function $adee36c0e746269c$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $adee36c0e746269c$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $adee36c0e746269c$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $adee36c0e746269c$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $adee36c0e746269c$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("9e8fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b7bd16a2a6c1a1e$var$subMilliseconds;

var $6b7bd16a2a6c1a1e$var$_index = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("a04h3")));

var $6b7bd16a2a6c1a1e$var$_index2 = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("9ZBzx")));

var $6b7bd16a2a6c1a1e$var$_index3 = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $6b7bd16a2a6c1a1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $6b7bd16a2a6c1a1e$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $6b7bd16a2a6c1a1e$var$_index3.default)(2, arguments);
    var amount = (0, $6b7bd16a2a6c1a1e$var$_index.default)(dirtyAmount);
    return (0, $6b7bd16a2a6c1a1e$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("a04h3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $747d383b4b873594$var$toInteger;
function $747d383b4b873594$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("9ZBzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7466f4a04eca45f4$var$addMilliseconds;

var $7466f4a04eca45f4$var$_index = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("a04h3")));

var $7466f4a04eca45f4$var$_index2 = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("411TS")));

var $7466f4a04eca45f4$var$_index3 = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $7466f4a04eca45f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $7466f4a04eca45f4$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $7466f4a04eca45f4$var$_index3.default)(2, arguments);
    var timestamp = (0, $7466f4a04eca45f4$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $7466f4a04eca45f4$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("1S5cf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15cedd7f8242ee45$var$_index = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("a9DiA")));

var $15cedd7f8242ee45$var$_index2 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("8aeCZ")));

var $15cedd7f8242ee45$var$_index3 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("5sEnr")));

var $15cedd7f8242ee45$var$_index4 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("iA62f")));

var $15cedd7f8242ee45$var$_index5 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("ldYz2")));

var $15cedd7f8242ee45$var$_index6 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("lc9Za")));

var $15cedd7f8242ee45$var$_index7 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("lYG1t")));
function $15cedd7f8242ee45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $15cedd7f8242ee45$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $15cedd7f8242ee45$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $15cedd7f8242ee45$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $15cedd7f8242ee45$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $15cedd7f8242ee45$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $15cedd7f8242ee45$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $15cedd7f8242ee45$var$_index4.default)(date); // Padding
        return (0, $15cedd7f8242ee45$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $15cedd7f8242ee45$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $15cedd7f8242ee45$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $15cedd7f8242ee45$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $15cedd7f8242ee45$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $15cedd7f8242ee45$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $15cedd7f8242ee45$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $15cedd7f8242ee45$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $15cedd7f8242ee45$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $15cedd7f8242ee45$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $15cedd7f8242ee45$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $15cedd7f8242ee45$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $15cedd7f8242ee45$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $15cedd7f8242ee45$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $15cedd7f8242ee45$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $15cedd7f8242ee45$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $15cedd7f8242ee45$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $15cedd7f8242ee45$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $15cedd7f8242ee45$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $15cedd7f8242ee45$var$_index7.default)(timestamp, token.length);
    }
};
function $15cedd7f8242ee45$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $15cedd7f8242ee45$var$_index7.default)(minutes, 2);
}
function $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $15cedd7f8242ee45$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $15cedd7f8242ee45$var$formatTimezone(offset, dirtyDelimiter);
}
function $15cedd7f8242ee45$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $15cedd7f8242ee45$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $15cedd7f8242ee45$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $15cedd7f8242ee45$var$_default = $15cedd7f8242ee45$var$formatters;
module.exports.default = $15cedd7f8242ee45$var$_default;
module.exports = module.exports.default;

});
parcelRegister("a9DiA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76493a941b8ff202$var$_index = $76493a941b8ff202$var$_interopRequireDefault((parcelRequire("lYG1t")));
function $76493a941b8ff202$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $76493a941b8ff202$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $76493a941b8ff202$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $76493a941b8ff202$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $76493a941b8ff202$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $76493a941b8ff202$var$_default = $76493a941b8ff202$var$formatters;
module.exports.default = $76493a941b8ff202$var$_default;
module.exports = module.exports.default;

});
parcelRegister("lYG1t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffffcc6552a18812$var$addLeadingZeros;
function $ffffcc6552a18812$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("8aeCZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f1a9aac6c7c6a94$var$getUTCDayOfYear;

var $5f1a9aac6c7c6a94$var$_index = $5f1a9aac6c7c6a94$var$_interopRequireDefault((parcelRequire("411TS")));

var $5f1a9aac6c7c6a94$var$_index2 = $5f1a9aac6c7c6a94$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $5f1a9aac6c7c6a94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5f1a9aac6c7c6a94$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $5f1a9aac6c7c6a94$var$getUTCDayOfYear(dirtyDate) {
    (0, $5f1a9aac6c7c6a94$var$_index2.default)(1, arguments);
    var date = (0, $5f1a9aac6c7c6a94$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $5f1a9aac6c7c6a94$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("5sEnr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f9ee3540ad931d2$var$getUTCISOWeek;

var $3f9ee3540ad931d2$var$_index = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("411TS")));

var $3f9ee3540ad931d2$var$_index2 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $3f9ee3540ad931d2$var$_index3 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("guQGo")));

var $3f9ee3540ad931d2$var$_index4 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $3f9ee3540ad931d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3f9ee3540ad931d2$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $3f9ee3540ad931d2$var$getUTCISOWeek(dirtyDate) {
    (0, $3f9ee3540ad931d2$var$_index4.default)(1, arguments);
    var date = (0, $3f9ee3540ad931d2$var$_index.default)(dirtyDate);
    var diff = (0, $3f9ee3540ad931d2$var$_index2.default)(date).getTime() - (0, $3f9ee3540ad931d2$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $3f9ee3540ad931d2$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("i0cv4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1b1ec55b955b3ea$var$startOfUTCISOWeek;

var $d1b1ec55b955b3ea$var$_index = $d1b1ec55b955b3ea$var$_interopRequireDefault((parcelRequire("411TS")));

var $d1b1ec55b955b3ea$var$_index2 = $d1b1ec55b955b3ea$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $d1b1ec55b955b3ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $d1b1ec55b955b3ea$var$startOfUTCISOWeek(dirtyDate) {
    (0, $d1b1ec55b955b3ea$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $d1b1ec55b955b3ea$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("guQGo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c028505fe514d6e3$var$startOfUTCISOWeekYear;

var $c028505fe514d6e3$var$_index = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("iA62f")));

var $c028505fe514d6e3$var$_index2 = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $c028505fe514d6e3$var$_index3 = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $c028505fe514d6e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $c028505fe514d6e3$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $c028505fe514d6e3$var$_index3.default)(1, arguments);
    var year = (0, $c028505fe514d6e3$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $c028505fe514d6e3$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("iA62f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d870453ff24bf26d$var$getUTCISOWeekYear;

var $d870453ff24bf26d$var$_index = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("411TS")));

var $d870453ff24bf26d$var$_index2 = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $d870453ff24bf26d$var$_index3 = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $d870453ff24bf26d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $d870453ff24bf26d$var$getUTCISOWeekYear(dirtyDate) {
    (0, $d870453ff24bf26d$var$_index3.default)(1, arguments);
    var date = (0, $d870453ff24bf26d$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $d870453ff24bf26d$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $d870453ff24bf26d$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("ldYz2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f739caa789a1bb9b$var$getUTCWeek;

var $f739caa789a1bb9b$var$_index = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("411TS")));

var $f739caa789a1bb9b$var$_index2 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("geMjG")));

var $f739caa789a1bb9b$var$_index3 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("kpxoI")));

var $f739caa789a1bb9b$var$_index4 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $f739caa789a1bb9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f739caa789a1bb9b$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $f739caa789a1bb9b$var$getUTCWeek(dirtyDate, options) {
    (0, $f739caa789a1bb9b$var$_index4.default)(1, arguments);
    var date = (0, $f739caa789a1bb9b$var$_index.default)(dirtyDate);
    var diff = (0, $f739caa789a1bb9b$var$_index2.default)(date, options).getTime() - (0, $f739caa789a1bb9b$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $f739caa789a1bb9b$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("geMjG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd236ec50df9f54c$var$startOfUTCWeek;

var $bd236ec50df9f54c$var$_index = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("a04h3")));

var $bd236ec50df9f54c$var$_index2 = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("411TS")));

var $bd236ec50df9f54c$var$_index3 = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $bd236ec50df9f54c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $bd236ec50df9f54c$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $bd236ec50df9f54c$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $bd236ec50df9f54c$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $bd236ec50df9f54c$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bd236ec50df9f54c$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("kpxoI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edc00c8c056e63ce$var$startOfUTCWeekYear;

var $edc00c8c056e63ce$var$_index = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("a04h3")));

var $edc00c8c056e63ce$var$_index2 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("lc9Za")));

var $edc00c8c056e63ce$var$_index3 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("geMjG")));

var $edc00c8c056e63ce$var$_index4 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $edc00c8c056e63ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $edc00c8c056e63ce$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $edc00c8c056e63ce$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $edc00c8c056e63ce$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $edc00c8c056e63ce$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $edc00c8c056e63ce$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $edc00c8c056e63ce$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("lc9Za", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6e276e76c61e58d$var$getUTCWeekYear;

var $f6e276e76c61e58d$var$_index = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("a04h3")));

var $f6e276e76c61e58d$var$_index2 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("411TS")));

var $f6e276e76c61e58d$var$_index3 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("geMjG")));

var $f6e276e76c61e58d$var$_index4 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $f6e276e76c61e58d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $f6e276e76c61e58d$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $f6e276e76c61e58d$var$_index4.default)(1, arguments);
    var date = (0, $f6e276e76c61e58d$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $f6e276e76c61e58d$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $f6e276e76c61e58d$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f6e276e76c61e58d$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f6e276e76c61e58d$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("3f2WU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $25c50f6d9939631e$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $25c50f6d9939631e$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $25c50f6d9939631e$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $25c50f6d9939631e$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $25c50f6d9939631e$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $25c50f6d9939631e$var$timeLongFormatter(timePattern, formatLong));
}
var $25c50f6d9939631e$var$longFormatters = {
    p: $25c50f6d9939631e$var$timeLongFormatter,
    P: $25c50f6d9939631e$var$dateTimeLongFormatter
};
var $25c50f6d9939631e$var$_default = $25c50f6d9939631e$var$longFormatters;
module.exports.default = $25c50f6d9939631e$var$_default;
module.exports = module.exports.default;

});

parcelRegister("ejJXr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6c67d4b841f38e8$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a6c67d4b841f38e8$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("7AKXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $58705255ffd27ebc$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $58705255ffd27ebc$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $58705255ffd27ebc$var$throwProtectedError;
var $58705255ffd27ebc$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $58705255ffd27ebc$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $58705255ffd27ebc$var$isProtectedDayOfYearToken(token) {
    return $58705255ffd27ebc$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $58705255ffd27ebc$var$isProtectedWeekYearToken(token) {
    return $58705255ffd27ebc$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $58705255ffd27ebc$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("5I5AW", function(module, exports) {
$parcel$export(module.exports, "default", () => $428566d76e0630b7$export$2e2bcd8739ae039);

var $a4aWD = parcelRequire("a4aWD");

var $a6f0S = parcelRequire("a6f0S");
var $428566d76e0630b7$var$MILLISECONDS_IN_MINUTE = 60000;
var $428566d76e0630b7$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $428566d76e0630b7$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $428566d76e0630b7$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $428566d76e0630b7$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $428566d76e0630b7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $428566d76e0630b7$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $428566d76e0630b7$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $428566d76e0630b7$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $428566d76e0630b7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $428566d76e0630b7$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $428566d76e0630b7$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $428566d76e0630b7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $a4aWD.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $a4aWD.default)('long', date, options);
        }
    }
};
function $428566d76e0630b7$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $a6f0S.default)(timeZone, originalDate, true) / $428566d76e0630b7$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $428566d76e0630b7$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $428566d76e0630b7$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $428566d76e0630b7$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $428566d76e0630b7$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $428566d76e0630b7$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $428566d76e0630b7$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $428566d76e0630b7$var$formatTimezone(offset, dirtyDelimeter);
}
function $428566d76e0630b7$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $428566d76e0630b7$var$addLeadingZeros(minutes, 2);
}
var $428566d76e0630b7$export$2e2bcd8739ae039 = $428566d76e0630b7$var$formatters;

});
parcelRegister("a4aWD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7542c480055dff24$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $7542c480055dff24$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $7542c480055dff24$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $7542c480055dff24$var$partsTimeZone(dtf, date) : $7542c480055dff24$var$hackyTimeZone(dtf, date);
}
function $7542c480055dff24$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $7542c480055dff24$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $7542c480055dff24$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("a6f0S", function(module, exports) {
$parcel$export(module.exports, "default", () => $75a61c39315b6d60$export$2e2bcd8739ae039);

var $4e7pW = parcelRequire("4e7pW");

var $cPmn1 = parcelRequire("cPmn1");
var $75a61c39315b6d60$var$MILLISECONDS_IN_HOUR = 3600000;
var $75a61c39315b6d60$var$MILLISECONDS_IN_MINUTE = 60000;
var $75a61c39315b6d60$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $75a61c39315b6d60$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $75a61c39315b6d60$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $75a61c39315b6d60$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$75a61c39315b6d60$var$validateTimezone(hours)) return NaN;
        return -(hours * $75a61c39315b6d60$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $75a61c39315b6d60$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$75a61c39315b6d60$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $75a61c39315b6d60$var$MILLISECONDS_IN_HOUR + minutes * $75a61c39315b6d60$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($75a61c39315b6d60$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $75a61c39315b6d60$var$toUtcDate(date);
        var offset = $75a61c39315b6d60$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $75a61c39315b6d60$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $75a61c39315b6d60$var$toUtcDate(date) {
    return (0, $cPmn1.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $75a61c39315b6d60$var$calcOffset(date, timezoneString) {
    var tokens = (0, $4e7pW.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $cPmn1.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $75a61c39315b6d60$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $75a61c39315b6d60$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $75a61c39315b6d60$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $75a61c39315b6d60$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $75a61c39315b6d60$var$validIANATimezoneCache = {};
function $75a61c39315b6d60$var$isValidTimezoneIANAString(timeZoneString) {
    if ($75a61c39315b6d60$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $75a61c39315b6d60$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("4e7pW", function(module, exports) {
$parcel$export(module.exports, "default", () => $313e39323cc367ca$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $313e39323cc367ca$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $313e39323cc367ca$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $313e39323cc367ca$var$partsOffset(dtf, date) : $313e39323cc367ca$var$hackyOffset(dtf, date);
}
var $313e39323cc367ca$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $313e39323cc367ca$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $313e39323cc367ca$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $313e39323cc367ca$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $313e39323cc367ca$var$dtfCache = {};
function $313e39323cc367ca$var$getDateTimeFormat(timeZone) {
    if (!$313e39323cc367ca$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $313e39323cc367ca$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $313e39323cc367ca$var$dtfCache[timeZone];
}

});

parcelRegister("cPmn1", function(module, exports) {
$parcel$export(module.exports, "default", () => $956b99c0c86aee93$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $956b99c0c86aee93$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("2uu2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d05af1238005827$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $a6f0S = parcelRequire("a6f0S");

var $6ireg = parcelRequire("6ireg");
var $1d05af1238005827$var$MILLISECONDS_IN_HOUR = 3600000;
var $1d05af1238005827$var$MILLISECONDS_IN_MINUTE = 60000;
var $1d05af1238005827$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $1d05af1238005827$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $6ireg.default)
};
function $1d05af1238005827$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $1d05af1238005827$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1d05af1238005827$var$splitDateString(argument);
    var parseYearResult = $1d05af1238005827$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $1d05af1238005827$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $1d05af1238005827$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $a6f0S.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $1d05af1238005827$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $1d05af1238005827$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $1d05af1238005827$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $1d05af1238005827$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1d05af1238005827$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $1d05af1238005827$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $1d05af1238005827$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $1d05af1238005827$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $1d05af1238005827$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $1d05af1238005827$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $1d05af1238005827$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$1d05af1238005827$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $1d05af1238005827$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$1d05af1238005827$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $1d05af1238005827$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$1d05af1238005827$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $1d05af1238005827$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$1d05af1238005827$var$validateWeekDate(year, week)) return new Date(NaN);
        return $1d05af1238005827$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $1d05af1238005827$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$1d05af1238005827$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1d05af1238005827$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $1d05af1238005827$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $1d05af1238005827$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$1d05af1238005827$var$validateTime(hours)) return NaN;
        return hours % 24 * $1d05af1238005827$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $1d05af1238005827$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$1d05af1238005827$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $1d05af1238005827$var$MILLISECONDS_IN_HOUR + minutes * $1d05af1238005827$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $1d05af1238005827$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$1d05af1238005827$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $1d05af1238005827$var$MILLISECONDS_IN_HOUR + minutes * $1d05af1238005827$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $1d05af1238005827$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $1d05af1238005827$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1d05af1238005827$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1d05af1238005827$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1d05af1238005827$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $1d05af1238005827$var$isLeapYearIndex(year);
        if (isLeapYear && date > $1d05af1238005827$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $1d05af1238005827$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $1d05af1238005827$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $1d05af1238005827$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $1d05af1238005827$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $1d05af1238005827$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("6ireg", function(module, exports) {
$parcel$export(module.exports, "default", () => $49598b9ea35f9461$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $49598b9ea35f9461$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $49598b9ea35f9461$export$2e2bcd8739ae039 = $49598b9ea35f9461$var$tzPattern;

});



parcelRegister("eGHhJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab16907049be4ecb$export$2e2bcd8739ae039);

var $a6f0S = parcelRequire("a6f0S");

var $2uu2q = parcelRequire("2uu2q");
function $ab16907049be4ecb$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $2uu2q.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $a6f0S.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("1Ah8w", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b18fef77162262a$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");

var $kP1cg = parcelRequire("kP1cg");

var $1Ww4G = parcelRequire("1Ww4G");
const $1b18fef77162262a$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $1b18fef77162262a$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $1b18fef77162262a$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $1b18fef77162262a$export$3209eb31343f39d extends (0, $f4dfy.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $1b18fef77162262a$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $1b18fef77162262a$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$1b18fef77162262a$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $1b18fef77162262a$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $1Ww4G.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($1b18fef77162262a$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$1b18fef77162262a$export$2e2bcd8739ae039 = new $1b18fef77162262a$export$3209eb31343f39d((0, $hncrn.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $kP1cg.logException
});

});
parcelRegister("1Ww4G", function(module, exports) {
$parcel$export(module.exports, "removeDuplicateRecommendations", () => $76ec459f68198552$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $76ec459f68198552$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $76ec459f68198552$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $76ec459f68198552$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($76ec459f68198552$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($76ec459f68198552$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($76ec459f68198552$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($76ec459f68198552$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $76ec459f68198552$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $76ec459f68198552$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $76ec459f68198552$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($76ec459f68198552$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($76ec459f68198552$var$toRecommendation)
        }
    };
};

});


parcelRegister("a6X0K", function(module, exports) {
$parcel$export(module.exports, "defaultLegionClient", () => $87dfec5f143ea955$export$95c697fe95d86a77);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $87dfec5f143ea955$var$v3UrlPath = `/v3/teams`;
const $87dfec5f143ea955$var$v4UrlPath = `/v4/teams`;
class $87dfec5f143ea955$export$68a6a391e3cf23be extends (0, $f4dfy.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : allTeamsQuery.sortBy && allTeamsQuery.sortBy.length > 0 ? allTeamsQuery.sortBy : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$87dfec5f143ea955$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$87dfec5f143ea955$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$87dfec5f143ea955$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$87dfec5f143ea955$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async addAgentsToTeam(teamId, agents) {
        if (!agents || agents.length === 0) {
            const missingAgentsError = new Error('Missing agents to add');
            this.logException(missingAgentsError, 'addAgentToTeam');
            throw missingAgentsError;
        }
        try {
            const url = `${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents`;
            return this.postResource(url, {
                agents: agents
            });
        } catch (e) {
            this.logException(e, 'addAgentToTeam');
            throw e;
        }
    }
    async removeAgentTeamAssociation(teamId, agentId) {
        try {
            const url = `${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents/${agentId}`;
            return this.deleteResource(url);
        } catch (e) {
            this.logException(e, 'removeAgentTeamAssociation');
            throw e;
        }
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    async archiveTeam(teamId) {
        const siteId = this.getCloudId();
        return this.postResourceRaw(`${$87dfec5f143ea955$var$v4UrlPath}/archive?siteId=${siteId}`, JSON.stringify([
            this.trimTeamARI(teamId)
        ]));
    }
    async unArchiveTeam(teamId) {
        const siteId = this.getCloudId();
        return this.postResourceRaw(`${$87dfec5f143ea955$var$v4UrlPath}/unarchive?siteId=${siteId}`, JSON.stringify([
            this.trimTeamARI(teamId)
        ]));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$87dfec5f143ea955$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$87dfec5f143ea955$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$87dfec5f143ea955$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId, siteId) {
        const finalSiteId = siteId || this.getCloudId();
        if (!finalSiteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${teamId}/profile?siteId=${finalSiteId}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$87dfec5f143ea955$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async createTeamContainers(payload) {
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/containers`, {
            ...payload
        });
    }
    async getTeamEnabledSites(teamId) {
        const teamEnabledSites = await this.getResourceCached(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope/${teamId}`);
        return teamEnabledSites;
    }
    async assignTeamsToSites(migrations) {
        const assignTeamsToSitesResponse = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope`, {
            originOrgId: this.getContext().orgId,
            migrations: migrations
        });
        return assignTeamsToSitesResponse;
    }
    async getTeamsToBeClonedToJsmSites(teamsToSiteScope) {
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope/review`, {
            orgId: this.getContext().orgId,
            teamsToSiteScope: teamsToSiteScope
        });
    }
    async setTeamSiteAssignmentPermission(orgId, alignmentPermission) {
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope/permissions`, {
            orgId: orgId,
            alignmentPermission: alignmentPermission
        });
    }
    async getAssignedTeams(orgId, count, cursor, displayNameContains) {
        const assignedTeamsResponse = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope/aligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            displayNameContains: displayNameContains
        });
        return assignedTeamsResponse;
    }
    async getUnassignedTeams(orgId, count, cursor, query) {
        const unassignedTeamsResponse = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope/unaligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            query: query
        });
        return unassignedTeamsResponse;
    }
    async getTeamSiteAssignmentOrgDetails() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getTeamSiteAssignmentOrgDetails');
            throw err;
        }
        return this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope/details/${orgId}`);
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified,
            ...teamResponse.externalReference && {
                externalReference: {
                    id: teamResponse.externalReference.id,
                    source: teamResponse.externalReference.source
                }
            }
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
    checkOrgFullAlignmentStatus(orgId) {
        try {
            return this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope/${orgId}/fully-aligned`);
        } catch (e) {
            this.logException(e, 'checkOrgFullAlignmentStatus');
            throw e;
        }
    }
    async getTeamStatesInBulk(orgId, teamIds) {
        try {
            return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/adminhub/states/bulk`, {
                orgId: orgId,
                teamIds: teamIds
            });
        } catch (e) {
            this.logException(e, 'getTeamStatesInBulk');
            throw e;
        }
    }
}
const $87dfec5f143ea955$export$95c697fe95d86a77 = new $87dfec5f143ea955$export$68a6a391e3cf23be((0, $hncrn.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("lrqlI", function(module, exports) {
$parcel$export(module.exports, "default", () => $6eaef6ee7b9efae5$export$2e2bcd8739ae039);

var $7eAIS = parcelRequire("7eAIS");

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $6eaef6ee7b9efae5$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $6eaef6ee7b9efae5$var$NOT_EDITABLE = 'not_editable';
const $6eaef6ee7b9efae5$var$NOT_EDITABLE_FIELD = 'field';
const $6eaef6ee7b9efae5$var$NOT_EDITABLE_REASON = 'reason';
class $6eaef6ee7b9efae5$export$1f387592ab3ca6d0 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$6eaef6ee7b9efae5$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $6eaef6ee7b9efae5$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $6eaef6ee7b9efae5$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$6eaef6ee7b9efae5$var$NOT_EDITABLE] != null) for (const value of json[$6eaef6ee7b9efae5$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$6eaef6ee7b9efae5$var$NOT_EDITABLE_FIELD],
        reason: $6eaef6ee7b9efae5$var$determineReason(value[$6eaef6ee7b9efae5$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $6eaef6ee7b9efae5$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $7eAIS.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$6eaef6ee7b9efae5$export$2e2bcd8739ae039 = new $6eaef6ee7b9efae5$export$1f387592ab3ca6d0();

});

parcelRegister("hmfTD", function(module, exports) {
$parcel$export(module.exports, "default", () => $205abd92f18b8d96$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");

var $HL98v = parcelRequire("HL98v");
const $205abd92f18b8d96$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}`
};
class $205abd92f18b8d96$export$a78b00aedb6cb3e9 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$205abd92f18b8d96$var$defaultConfig,
            ...config
        });
    }
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $HL98v.transformIconData));
    }
    async getAriFromUrl(url) {
        return this.postResourceRaw(`/object-resolver/converter/toAri`, JSON.stringify({
            resourceUrl: url
        })).then((response)=>response?.data?.ari);
    }
    async getWebLinkTitle(webLinkUrl) {
        try {
            const response = await this.postResourceRaw('/object-resolver/resolve', JSON.stringify({
                resourceUrl: webLinkUrl
            }));
            if (response && 'data' in response) {
                if (response.data?.name) return response.data.name;
            }
            if (response && 'meta' in response && (response.meta?.visibility === 'restricted' || response.meta?.visibility === 'unauthorized')) {
                const auth = response.meta.auth?.[0];
                if (auth?.displayName) return auth.displayName;
            }
            return;
        } catch (error) {
            return;
        }
    }
}
var $205abd92f18b8d96$export$2e2bcd8739ae039 = new $205abd92f18b8d96$export$a78b00aedb6cb3e9();

});
parcelRegister("HL98v", function(module, exports) {
$parcel$export(module.exports, "transformIconData", () => $cd95287fec3ab6ab$export$39f4468adf4cb57c);

var $jzBG8 = parcelRequire("jzBG8");
const $cd95287fec3ab6ab$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $jzBG8.ProviderNames).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $cd95287fec3ab6ab$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $jzBG8.ProviderNames).JIRA:
            return {
                linkUrl: url,
                iconUrl: $cd95287fec3ab6ab$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $cd95287fec3ab6ab$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $cd95287fec3ab6ab$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($cd95287fec3ab6ab$var$isIconItemSuccess).map((resp)=>resp.body.data).map($cd95287fec3ab6ab$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $cd95287fec3ab6ab$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $cd95287fec3ab6ab$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});
parcelRegister("jzBG8", function(module, exports) {
$parcel$export(module.exports, "ProviderNames", () => $714ee44137d16d13$export$132d457a8475f4c8);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $714ee44137d16d13$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});

});



parcelRegister("1qjKt", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc76c53f54a183f0$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
class $bc76c53f54a183f0$export$23820d8d740dd467 extends (0, $f4dfy.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$bc76c53f54a183f0$export$2e2bcd8739ae039 = new $bc76c53f54a183f0$export$23820d8d740dd467({
    serviceUrl: (0, $hncrn.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("3aHkO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8e70f5078d5ceec$export$2e2bcd8739ae039);

var $7eAIS = parcelRequire("7eAIS");

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $c8e70f5078d5ceec$var$V1_URL = '/teams/v1';
const $c8e70f5078d5ceec$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $c8e70f5078d5ceec$export$38575d07403d67c extends (0, $f4dfy.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $7eAIS.HttpError) && $c8e70f5078d5ceec$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $7eAIS.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$c8e70f5078d5ceec$export$2e2bcd8739ae039 = new $c8e70f5078d5ceec$export$38575d07403d67c((0, $hncrn.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("4Xjsv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5645769de27b9599$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $5645769de27b9599$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/user-tenure/v1`
};
class $5645769de27b9599$export$e019a6241c871c27 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$5645769de27b9599$var$defaultConfig,
            ...config
        });
    }
    async getUserTenure(userId) {
        const orgId = this.getOrgId();
        return this.getResource(`/${orgId}/${userId}`).then((response)=>({
                ...response,
                userHireDate: new Date(response.userHireDate)
            })).catch((_error)=>{
            throw new Error('Failed to fetch user tenure');
        });
    }
}
var $5645769de27b9599$export$2e2bcd8739ae039 = new $5645769de27b9599$export$e019a6241c871c27();

});

parcelRegister("hmv3a", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bc114b84307ae18$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $le4QF = parcelRequire("le4QF");

var $kP1cg = parcelRequire("kP1cg");

var $cpnSw = parcelRequire("cpnSw");
const $7bc114b84307ae18$var$SERVICE_URL = `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/watermelon/graphql`;
class $7bc114b84307ae18$export$59b34df773148edd extends (0, $le4QF.BaseGraphQlClient) {
    constructor(config){
        super($7bc114b84307ae18$var$SERVICE_URL, config);
    }
    async getReportingLines(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $cpnSw.default),
            variables: {
                aaid: userId
            }
        }, {
            operationName: 'ReportingLines'
        });
        return response;
    }
}
var $7bc114b84307ae18$export$2e2bcd8739ae039 = new $7bc114b84307ae18$export$59b34df773148edd({
    logException: $kP1cg.logException
});

});
parcelRegister("cpnSw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d43ab1d14f45aee$export$2e2bcd8739ae039);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
var $6d43ab1d14f45aee$export$2e2bcd8739ae039 = (0, $6NFTG.print)((0, $kuAvn.default)`
	fragment ReportingLinesUserPII on UserPII {
		name
		picture
		accountStatus
		extendedProfile {
			jobTitle
		}
	}

	fragment ReportingLinesUserFragment on ReportingLinesUser {
		accountIdentifier
		identifierType
		numberOfDirectReports
		numberOfTotalReports
		pii {
			...ReportingLinesUserPII
		}
	}

	query ReportingLines($aaid: String) {
		reportingLines(aaidOrHash: $aaid) {
			lastModifiedDate
			user {
				...ReportingLinesUserFragment
			}
			managers {
				...ReportingLinesUserFragment
			}
			peers {
				...ReportingLinesUserFragment
			}
			reports {
				...ReportingLinesUserFragment
			}
		}
	}
`);

});


parcelRegister("3vA2C", function(module, exports) {
$parcel$export(module.exports, "default", () => $f308d6b289ddc64b$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $le4QF = parcelRequire("le4QF");

var $kP1cg = parcelRequire("kP1cg");

var $aJhpK = parcelRequire("aJhpK");

var $aQp5o = parcelRequire("aQp5o");

var $e5dnX = parcelRequire("e5dnX");

var $74sWx = parcelRequire("74sWx");

var $lh2BF = parcelRequire("lh2BF");

var $1I7W5 = parcelRequire("1I7W5");

var $1GAT2 = parcelRequire("1GAT2");

var $hNS1N = parcelRequire("hNS1N");

var $gQ7HG = parcelRequire("gQ7HG");

var $g7SFw = parcelRequire("g7SFw");
class $f308d6b289ddc64b$export$de0359e19b851166 extends (0, $le4QF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super((0, $g7SFw.getUnshardedTeamCentralGraphqlUrl)(baseUrl), config);
    }
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $g7SFw.getTeamCentralGraphqlUrl)(baseUrl, cloudId) : (0, $g7SFw.getUnshardedTeamCentralGraphqlUrl)(baseUrl));
    }
    async isTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $hNS1N.IsTeamWatcherQuery),
            variables: {
                teamId: teamId.replace('ari:cloud:identity::team/', ''),
                cloudId: cloudId || 'None'
            }
        }, {
            operationName: 'isTeamWatcher'
        });
        return response.isTeamWatcher;
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $aJhpK.AddTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1GAT2.RemoveTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1I7W5.KudosDeleteMutation),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $gQ7HG.TagListQuery),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $aQp5o.CreateTagMutation),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $e5dnX.HelpPointerCreateMutation),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $lh2BF.HelpPointerUpdateMutation),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $74sWx.HelpPointerDeleteMutation),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
}
var $f308d6b289ddc64b$export$2e2bcd8739ae039 = new $f308d6b289ddc64b$export$de0359e19b851166((0, $hncrn.DEFAULT_CONFIG).stargateRoot, {
    logException: $kP1cg.logException
});

});
parcelRegister("aJhpK", function(module, exports) {
$parcel$export(module.exports, "AddTeamWatcherMutation", () => $8b8e757f53dc0b98$export$2af9f827ad8bcf83);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $8b8e757f53dc0b98$export$2af9f827ad8bcf83 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation addTeamWatcher($teamId: String!, $cloudId: String) {
		addTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("aQp5o", function(module, exports) {
$parcel$export(module.exports, "CreateTagMutation", () => $3dfd2b7e4e608497$export$5e59562b4f09e8ef);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $3dfd2b7e4e608497$export$5e59562b4f09e8ef = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation createTagForCloudId($name: String!, $cloudId: String!) {
		createTagForCloudId(input: { name: $name, cloudId: $cloudId }) {
			tag {
				id
				uuid
				name
			}
		}
	}
`);

});

parcelRegister("e5dnX", function(module, exports) {
$parcel$export(module.exports, "HelpPointerCreateMutation", () => $b204e0803c05b46e$export$a563da8c932d52b1);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $b204e0803c05b46e$export$a563da8c932d52b1 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation CreateHelpPointer(
		$cloudId: String!
		$description: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String!
		$name: String!
		$teamId: String!
		$type: HelpPointerType!
	) {
		createHelpPointer(
			input: {
				cloudId: $cloudId
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				name: $name
				teamId: $teamId
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("74sWx", function(module, exports) {
$parcel$export(module.exports, "HelpPointerDeleteMutation", () => $4ff6c1a1f6f975b9$export$558c9434019572a1);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $4ff6c1a1f6f975b9$export$558c9434019572a1 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation DeleteHelpPointer($id: ID!) {
		deleteHelpPointer(input: { id: $id }) {
			success
		}
	}
`);

});

parcelRegister("lh2BF", function(module, exports) {
$parcel$export(module.exports, "HelpPointerUpdateMutation", () => $7790d0a6ce755ece$export$95b572ae48a37250);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $7790d0a6ce755ece$export$95b572ae48a37250 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation UpdateHelpPointer(
		$id: ID!
		$description: String
		$teamId: String
		$newTeamName: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String
		$name: String
		$type: HelpPointerType
	) {
		updateHelpPointer(
			input: {
				id: $id
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				teamId: $teamId
				newTeamName: $newTeamName
				name: $name
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("1I7W5", function(module, exports) {
$parcel$export(module.exports, "KudosDeleteMutation", () => $74ddfa197f970cd5$export$fc4c702e715ad2a4);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $74ddfa197f970cd5$export$fc4c702e715ad2a4 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation DeleteKudos($id: ID!) {
		deleteKudos(input: { id: $id }) {
			success
			kudos {
				id
			}
		}
	}
`);

});

parcelRegister("1GAT2", function(module, exports) {
$parcel$export(module.exports, "RemoveTeamWatcherMutation", () => $f558522719fe1a0b$export$d1957676c49feb6a);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $f558522719fe1a0b$export$d1957676c49feb6a = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation removeTeamWatcher($teamId: String!, $cloudId: String) {
		removeTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("hNS1N", function(module, exports) {
$parcel$export(module.exports, "IsTeamWatcherQuery", () => $60d7c015fb4de27e$export$5deef0b43df462bc);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $60d7c015fb4de27e$export$5deef0b43df462bc = (0, $6NFTG.print)((0, $kuAvn.default)`
	query IsTeamWatcher($teamId: String!, $cloudId: String!) {
		isTeamWatcher: teamByTeamId(teamId: $teamId, cloudId: $cloudId) {
			watching
		}
	}
`);

});

parcelRegister("gQ7HG", function(module, exports) {
$parcel$export(module.exports, "TagListQuery", () => $8b0e4be529e1a6dc$export$2c592b5c06672873);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $8b0e4be529e1a6dc$export$2c592b5c06672873 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query TagListByCloudId($q: String!, $cloudId: String!, $first: Int) {
		tagSearchByCloudId(q: $q, cloudId: $cloudId, first: $first) {
			edges {
				node {
					id
					uuid
					name
					projects {
						count
					}

					goals {
						count
					}

					helpLinks {
						count
					}
				}
			}
		}
	}
`);

});

parcelRegister("g7SFw", function(module, exports) {
$parcel$export(module.exports, "getTeamCentralGraphqlUrl", () => $fbde9dd5796ae376$export$ada1892306a6b676);
$parcel$export(module.exports, "getUnshardedTeamCentralGraphqlUrl", () => $fbde9dd5796ae376$export$71356c4826ea823a);
const $fbde9dd5796ae376$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;
const $fbde9dd5796ae376$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;

});


parcelRegister("6s0GD", function(module, exports) {
$parcel$export(module.exports, "default", () => $43c2332765f70dfe$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $43c2332765f70dfe$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $43c2332765f70dfe$export$9509cbc6b0605446 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$43c2332765f70dfe$var$defaultConfig,
            ...config
        });
    }
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
}
var $43c2332765f70dfe$export$2e2bcd8739ae039 = new $43c2332765f70dfe$export$9509cbc6b0605446();

});

parcelRegister("fecpt", function(module, exports) {
$parcel$export(module.exports, "default", () => $495b63401d2fcee0$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $495b63401d2fcee0$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $495b63401d2fcee0$export$3c27e20d1b94924 extends (0, $f4dfy.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($495b63401d2fcee0$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $495b63401d2fcee0$export$2e2bcd8739ae039 = new $495b63401d2fcee0$export$3c27e20d1b94924({
    serviceUrl: (0, $hncrn.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("covdC", function(module, exports) {
$parcel$export(module.exports, "transformPermissions", () => $ec422b10d4cfd63b$export$7fe0bfa353103198);
const $ec422b10d4cfd63b$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};

});



parcelRegister("2Kvwp", function(module, exports) {
$parcel$export(module.exports, "PeopleMenuOverrides", () => $dfc868c7868cb4d3$export$c6e6fe52d34907dc);
var $dfc868c7868cb4d3$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("4Goo7", function(module, exports) {
$parcel$export(module.exports, "openInNewTab", () => $f97e399efeb29f2c$export$9e52b10d57ddf9e3);
const $f97e399efeb29f2c$export$9e52b10d57ddf9e3 = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(url, '_blank');
};

});

parcelRegister("8PQvE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gf7Uy").then(()=>parcelRequire('lrPpP'));

});


parcelRegister("2VH7W", function(module, exports) {
$parcel$export(module.exports, "useInvitePeopleModal", () => $f30d0544b33f01e8$export$b9ec44715ae5ad99);

var $eJOHy = parcelRequire("eJOHy");

var $jUmLO = parcelRequire("jUmLO");

var $aXbkt = parcelRequire("aXbkt");

var $cSXp8 = parcelRequire("cSXp8");

var $2ePj6 = parcelRequire("2ePj6");

var $kFis2 = parcelRequire("kFis2");

var $1Gl91 = parcelRequire("1Gl91");

var $g32Ua = parcelRequire("g32Ua");

var $dSkLG = parcelRequire("dSkLG");

var $g9Vr6 = parcelRequire("g9Vr6");

var $1BZ8a = parcelRequire("1BZ8a");

var $3MbOI = parcelRequire("3MbOI");

var $2UBs9 = parcelRequire("2UBs9");

var $4cTDP = parcelRequire("4cTDP");

var $60h8A = parcelRequire("60h8A");

var $lRq8t = parcelRequire("lRq8t");

var $k8PfX = parcelRequire("k8PfX");
const $f30d0544b33f01e8$export$b9ec44715ae5ad99 = ()=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { data: projectSidebarNavigationData } = (0, $dSkLG.useProjectSidebarNavigation)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { software: software } = (0, $1BZ8a.useAppEditions)();
    const { data: currentUser } = (0, $3MbOI.useCurrentUser)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let fetchInviteRecommendationsService = (0, $eJOHy.useCallback)((_)=>Promise.resolve([]), []);
    let mapToFeaturedUserService = (0, $eJOHy.useCallback)((_)=>[], []);
    if ((0, $4cTDP.fg)('tepi-3p-core-invites-slack-rec-ux')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        fetchInviteRecommendationsService = (0, $2UBs9.useService)((0, $60h8A.fetch3PInviteRecommendations));
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        mapToFeaturedUserService = (0, $2UBs9.useService)((0, $60h8A.mapToFeaturedUser));
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let continueUrl = window.location.href;
    if (currentUser?.user?.accountId) {
        const url = new URL(continueUrl);
        url.searchParams.append('inviterId', currentUser.user.accountId);
        continueUrl = url.toString();
    }
    const subProduct = (0, $g32Ua.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    if (subProduct === 'software') continueUrl = (0, $jUmLO.getContinueUrlWithWelcomeModal)(continueUrl);
    const fetchInviteRecommendations = (0, $eJOHy.useCallback)(async ()=>{
        if ((0, $4cTDP.fg)('tepi-3p-core-invites-slack-rec-ux')) {
            const inviteRecommendationsFromSlack = await fetchInviteRecommendationsService({
                limit: 10
            }).then((recommendations)=>{
                return mapToFeaturedUserService({
                    userInfo: recommendations,
                    tooltipRenderer: (user)=>formatMessage((0, $k8PfX.default).inviteRecommendationsFromSlack, {
                            email: user.email
                        })
                });
            });
            return inviteRecommendationsFromSlack;
        }
        return [];
    }, [
        fetchInviteRecommendationsService,
        mapToFeaturedUserService,
        formatMessage
    ]);
    const addFlag = (0, $eJOHy.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $f30d0544b33f01e8$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "transactional"
            }));
    }, [
        showFlag
    ]);
    const { openModal: invitePeopleModalTrigger } = (0, $aXbkt.useJiraInvitePeopleModalBound)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        displayInfiSpotlight: true,
        orgId: orgId,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        },
        experimental_featuredUsers: fetchInviteRecommendations
    });
    return invitePeopleModalTrigger;
};
const $f30d0544b33f01e8$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $1Gl91.default;
        case 'error':
            return 0, $2ePj6.default;
        case 'success':
        case 'normal':
        default:
            return 0, $kFis2.default;
    }
};

});
parcelRegister("jUmLO", function(module, exports) {
$parcel$export(module.exports, "isValidNthUserWelcomePath", () => $727f6a1ceaf5725e$export$9d8d745dc961cc24);
$parcel$export(module.exports, "getContinueUrlWithWelcomeModal", () => $727f6a1ceaf5725e$export$30a1130917ef5d13);

var $4cTDP = parcelRequire("4cTDP");
const $727f6a1ceaf5725e$export$dc90482e4ef07afd = ()=>{
    if (typeof window !== 'undefined') return window.location.href;
    return '';
};
const $727f6a1ceaf5725e$export$9d8d745dc961cc24 = (path)=>{
    try {
        const url = new URL(path);
        const pathname = url.pathname;
        const regex = /^(?:\/jira\/[^/]+\/(?:c\/)?projects\/[^/]+\/(board|boards(?:\/[^/]+(?:\/backlog)?)?|board\/[^/]+\/backlog)\/?|\/browse\/[^/]+\/?)$/;
        return regex.test(pathname);
    } catch  {
        return false;
    }
};
const $727f6a1ceaf5725e$export$30a1130917ef5d13 = (path)=>{
    const currentUrl = path || $727f6a1ceaf5725e$export$dc90482e4ef07afd();
    if (!(0, $4cTDP.fg)('jira_nth_user_workitem_recommendation_killswitch') || !$727f6a1ceaf5725e$export$9d8d745dc961cc24(currentUrl)) return currentUrl;
    const url = new URL(currentUrl);
    url.searchParams.append('showNthUserWelcomeModal', 'true');
    return url.toString();
};

});

parcelRegister("g32Ua", function(module, exports) {
$parcel$export(module.exports, "stripUrlToIssueKey", () => $cab6d9604eb8817d$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $cab6d9604eb8817d$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $cab6d9604eb8817d$export$3500077858760067);
$parcel$export(module.exports, "jiraProjectTypeToSubProduct", () => $cab6d9604eb8817d$export$9ce9c3ad0c2c5c71);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");

var $2ePj6 = parcelRequire("2ePj6");

var $1VtCt = parcelRequire("1VtCt");

var $kFis2 = parcelRequire("kFis2");

var $1Gl91 = parcelRequire("1Gl91");
const $cab6d9604eb8817d$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $cab6d9604eb8817d$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($cab6d9604eb8817d$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $cab6d9604eb8817d$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const addFlag = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $1VtCt.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $kFis2.default);
                break;
            case 'warning':
                FlagComponent = (0, $1Gl91.default);
                break;
            case 'error':
                FlagComponent = (0, $2ePj6.default);
                break;
        }
        showFlag((serviceProps)=>{
            const props = {
                ...flagProps,
                ...serviceProps,
                messageId: `invite-people-drawer.ui.content.flag-component.${appearance}.${flagProps.id}`,
                messageType: 'transactional'
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FlagComponent, props);
        });
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $cab6d9604eb8817d$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};
const $cab6d9604eb8817d$export$9ce9c3ad0c2c5c71 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 'software';
        case 'service_desk':
            return 'servicedesk';
        case 'business':
            return 'core';
        case 'product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("1VtCt", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0a1ba1cc6d1b8cd$export$2e2bcd8739ae039);

var $2pgjF = parcelRequire("2pgjF");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$b0a1ba1cc6d1b8cd$export$2e2bcd8739ae039 = (0, $2pgjF.InfoFlag);

});


parcelRegister("2UBs9", function(module, exports) {
$parcel$export(module.exports, "useService", () => $97d3dd764d989814$export$6de4685a6c88b4e9);

var $eJOHy = parcelRequire("eJOHy");

var $cHtIB = parcelRequire("cHtIB");

var $e6YEs = parcelRequire("e6YEs");

var $iHd0I = parcelRequire("iHd0I");

var $9pTd3 = parcelRequire("9pTd3");

var $804Kx = parcelRequire("804Kx");

var $i1bbF = parcelRequire("i1bbF");

var $4HZCb = parcelRequire("4HZCb");
const $97d3dd764d989814$var$useEnvironmentDeps = ()=>{
    // Use product's hooks to build a bag of dependencies
    // that the product environment will provide to the services.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $804Kx.useAnalyticsEvents)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const product = (0, $4HZCb.useJiraCurrentProduct)();
    const atlassianAccountId = (0, $e6YEs.useAccountId)();
    return (0, $eJOHy.useMemo)(()=>({
            createAnalyticsEvent: createAnalyticsEvent,
            fetchJSON: (0, $i1bbF.jiraFetchJson),
            getCurrentCloudId: ()=>cloudId,
            getCurrentProduct: ()=>product,
            getCurrentUserId: ()=>atlassianAccountId,
            fireErrorAnalytics: $9pTd3.fireErrorAnalytics
        }), [
        createAnalyticsEvent,
        cloudId,
        product,
        atlassianAccountId
    ]);
};
const $97d3dd764d989814$export$6de4685a6c88b4e9 = (service, providedDeps)=>{
    const environmentDeps = $97d3dd764d989814$var$useEnvironmentDeps();
    const deps = (0, $eJOHy.useMemo)(()=>({
            ...environmentDeps,
            ...providedDeps
        }), [
        environmentDeps,
        providedDeps
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $iHd0I.useService)(service, deps);
};

});
parcelRegister("iHd0I", function(module, exports) {
$parcel$export(module.exports, "useService", () => $3cf8d2ededcfb03e$export$6de4685a6c88b4e9);

var $eJOHy = parcelRequire("eJOHy");

var $8wPwm = parcelRequire("8wPwm");
const $3cf8d2ededcfb03e$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $eJOHy.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$3cf8d2ededcfb03e$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $8wPwm.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $3cf8d2ededcfb03e$var$DIFFERENT = false;
const $3cf8d2ededcfb03e$var$EQUAL = true;
const $3cf8d2ededcfb03e$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $3cf8d2ededcfb03e$var$EQUAL;
    if (!prevObject || !nextObject) return $3cf8d2ededcfb03e$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $3cf8d2ededcfb03e$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $3cf8d2ededcfb03e$var$DIFFERENT;
        }
        return $3cf8d2ededcfb03e$var$EQUAL;
    }
};

});
parcelRegister("8wPwm", function(module, exports) {
$parcel$export(module.exports, "resolveService", () => $62f2ea1448721402$export$388f24d19a29b0a2);

var $i583N = parcelRequire("i583N");
function $62f2ea1448721402$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $i583N.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $62f2ea1448721402$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $62f2ea1448721402$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $62f2ea1448721402$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }

});
parcelRegister("i583N", function(module, exports) {
$parcel$export(module.exports, "isServiceWithDeps", () => $55b7790d3d3cf328$export$4094c5185600bd73);
$parcel$export(module.exports, "unimplementedAbstractService", () => $55b7790d3d3cf328$export$6e9f7b680f09bab1);
$parcel$export(module.exports, "toError", () => $55b7790d3d3cf328$export$cc3b967c039ed3e7);
const $55b7790d3d3cf328$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $55b7790d3d3cf328$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $55b7790d3d3cf328$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};

});



parcelRegister("804Kx", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $c21c35fb8e0a29fe$export$5bf35293e545f20c);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $c21c35fb8e0a29fe$var$AnalyticsWebClientTypeToJiraEventType = {
    sendTrackEvent: 'TRACK',
    sendUIEvent: 'UI',
    sendScreenEvent: 'SCREEN',
    sendOperationalEvent: 'OPERATIONAL'
};
const $c21c35fb8e0a29fe$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEventNotFireable } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useMemo)(()=>{
        const createAnalyticsEvent = (payload)=>{
            const event = createAnalyticsEventNotFireable(payload);
            // event.fire() coming from `createAnalyticsEvent` does not actually send the event in Jira,
            // so we need to patch it here, ensuring it goes throught the analytics bridge correctly
            event.fire = ()=>{
                const awcType = payload.type;
                const jiraBridgeEventType = $c21c35fb8e0a29fe$var$AnalyticsWebClientTypeToJiraEventType[awcType];
                if (!jiraBridgeEventType) return;
                (0, $kRgKj.fireAnalytics)(event, jiraBridgeEventType, payload.data);
            };
            return event;
        };
        return {
            createAnalyticsEvent: createAnalyticsEvent
        };
    }, [
        createAnalyticsEventNotFireable
    ]);
};

});

parcelRegister("i1bbF", function(module, exports) {
$parcel$export(module.exports, "jiraFetchJson", () => $ed8c3e541183e2e1$export$a1dfe802bc656913);

var $hgi0g = parcelRequire("hgi0g");
const $ed8c3e541183e2e1$export$a1dfe802bc656913 = (input)=>{
    const url = input.url;
    const options = input;
    return (0, $hgi0g.default)(url, options);
};

});

parcelRegister("4HZCb", function(module, exports) {
$parcel$export(module.exports, "useJiraCurrentProduct", () => $4ce1f4f52831212e$export$47a383c930365f5d);

var $7SGrx = parcelRequire("7SGrx");
const $4ce1f4f52831212e$export$47a383c930365f5d = ()=>{
    const productName = (0, $7SGrx.useProductName)();
    switch(productName){
        case 'core':
            return 'jira-core';
        case 'jira':
            return 'jira-software';
        case 'serviceDesk':
            return 'jira-servicedesk';
        case 'product-discovery':
            return 'jira-product-discovery';
        default:
            return 'jira-core';
    }
};

});
parcelRegister("7SGrx", function(module, exports) {
$parcel$export(module.exports, "useProductName", () => $a35983f42c8ecb9b$export$dde400a84de238be);

var $6PAED = parcelRequire("6PAED");

var $b2MNC = parcelRequire("b2MNC");
const $a35983f42c8ecb9b$export$dde400a84de238be = ()=>{
    const appPermissions = (0, $6PAED.useApplicationPermissions)();
    return (0, $b2MNC.getProductName)(appPermissions);
};

});
parcelRegister("6PAED", function(module, exports) {
$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $d35c5b201dbcf053$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $d35c5b201dbcf053$export$4d9cadb4042acc1b);

var $ahm5r = parcelRequire("ahm5r");

var $ht3nQ = parcelRequire("ht3nQ");

var $g9iF5 = parcelRequire("g9iF5");

var $koAZ4 = parcelRequire("koAZ4");
const $d35c5b201dbcf053$var$selector = (0, $ahm5r.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $d35c5b201dbcf053$export$d8c76f7e52d0a856 = (0, $ht3nQ.createSubscriber)((0, $g9iF5.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $d35c5b201dbcf053$var$selector
});
const $d35c5b201dbcf053$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("b2MNC", function(module, exports) {
$parcel$export(module.exports, "getProductName", () => $338f840634b3581f$export$aa3f36fe5dd1f237);

var $4cTDP = parcelRequire("4cTDP");
const $338f840634b3581f$export$aa3f36fe5dd1f237 = (permissions)=>{
    if ((0, $4cTDP.fg)('jcs_master_flag')) {
        const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
        return ([
            {
                condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'software'
            },
            {
                condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'serviceDesk'
            },
            {
                condition: hasServiceDeskAccess && hasCustomerServiceAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess && (0, $4cTDP.fg)('servco-jsm-site-logo'),
                value: 'serviceDesk'
            },
            {
                condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'core'
            },
            {
                condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasCustomerServiceAccess,
                value: 'product-discovery'
            },
            {
                condition: hasCustomerServiceAccess && !hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
                value: 'customer-service'
            }
        ].find((item)=>item.condition) || {
            value: 'jira'
        }).value;
    }
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess, hasCustomerServiceAccess: hasCustomerServiceAccess } = permissions;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
    return ([
        {
            condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'software'
        },
        {
            condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess,
            value: 'serviceDesk'
        },
        {
            condition: hasServiceDeskAccess && hasCustomerServiceAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess && (0, $4cTDP.fg)('servco-jsm-site-logo'),
            value: 'serviceDesk'
        },
        {
            condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'core'
        },
        {
            condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
            value: 'product-discovery'
        }
    ].find((item)=>item.condition) || {
        value: 'jira'
    }).value;
};

});




parcelRegister("60h8A", function(module, exports) {
$parcel$export(module.exports, "fetch3PInviteRecommendations", () => $9de18d757fcc0e5e$export$fe357fea13f62bfe);
$parcel$export(module.exports, "mapToFeaturedUser", () => $9de18d757fcc0e5e$export$44d2a44df9cb01bb);
/**
 * This file defines the recommendations3P() service.
 */ 
var $bfhQ2 = parcelRequire("bfhQ2");

var $dn9SV = parcelRequire("dn9SV");
const $9de18d757fcc0e5e$var$dependencies = {
    fetchJSON: $dn9SV.fetchJSON,
    createAnalyticsEvent: $bfhQ2.createAnalyticsEvent,
    fireErrorAnalytics: $bfhQ2.fireErrorAnalytics,
    getCurrentCloudId: $bfhQ2.getCurrentCloudId,
    getCurrentProduct: $bfhQ2.getCurrentProduct
};
const $9de18d757fcc0e5e$export$fe357fea13f62bfe = Object.assign($9de18d757fcc0e5e$export$828ff91521f41431, {
    dependencies: $9de18d757fcc0e5e$var$dependencies
});
async function $9de18d757fcc0e5e$export$828ff91521f41431(input, context) {
    const deps = context.dependencies();
    const cloudId = input.targetCloudId ?? deps.getCurrentCloudId();
    const limit = input.limit;
    const product = input.targetProduct ?? deps.getCurrentProduct();
    try {
        const response = await deps.fetchJSON({
            url: `/gateway/api/pi-gateway/frontend/api/1/recommend/invite-users?limit=${limit}&targetCloudId=${cloudId}&targetProduct=${product}`,
            method: 'GET'
        });
        return response.recommendations;
    } catch (error) {
        deps.fireErrorAnalytics({
            meta: {
                id: 'fetchInviteRecommendations3P',
                packageName: 'expansion-services',
                teamName: 'Groot'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return [];
    }
}
const $9de18d757fcc0e5e$var$mapToFeaturedUserImpl = (input)=>{
    return input.userInfo.map((user, index)=>({
            email: user.email,
            name: user.displayName,
            avatarUrl: user.avatarUrl,
            source: user.source,
            tooltip: input.tooltipRenderer(user),
            id: user.atlassianAccountId ?? user.thirdPartyUserId
        }));
};
const $9de18d757fcc0e5e$export$44d2a44df9cb01bb = Object.assign($9de18d757fcc0e5e$var$mapToFeaturedUserImpl, {
    dependencies: {}
});

});
parcelRegister("bfhQ2", function(module, exports) {
$parcel$export(module.exports, "getStargateURL", () => $5b76c17b94208e24$export$c7904a8284e43beb);
$parcel$export(module.exports, "getCurrentCloudId", () => $5b76c17b94208e24$export$ddb1688281a3443e);
$parcel$export(module.exports, "getCurrentUserId", () => $5b76c17b94208e24$export$5ebc6cb2748e1881);
$parcel$export(module.exports, "getCurrentProduct", () => $5b76c17b94208e24$export$d01408ed6f850a64);
$parcel$export(module.exports, "createAnalyticsEvent", () => $5b76c17b94208e24$export$a48841c0475a8073);
$parcel$export(module.exports, "fireErrorAnalytics", () => $5b76c17b94208e24$export$a27c21aa3ed8f0f1);
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $i583N = parcelRequire("i583N");
const $5b76c17b94208e24$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $5b76c17b94208e24$export$ddb1688281a3443e = (0, $i583N.unimplementedAbstractService)('getCurrentCloudId');
const $5b76c17b94208e24$export$5ebc6cb2748e1881 = (0, $i583N.unimplementedAbstractService)('getCurrentUserId');
const $5b76c17b94208e24$export$d01408ed6f850a64 = (0, $i583N.unimplementedAbstractService)('getCurrentProduct');
const $5b76c17b94208e24$export$a48841c0475a8073 = (0, $i583N.unimplementedAbstractService)('createAnalyticsEvent');
const $5b76c17b94208e24$export$a27c21aa3ed8f0f1 = (0, $i583N.unimplementedAbstractService)('fireErrorAnalytics');
class $5b76c17b94208e24$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) super(responseJson.message);
        else super(`Received error response during action ${action}: ${response.statusText}`);
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $5b76c17b94208e24$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: err instanceof $5b76c17b94208e24$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });
const $5b76c17b94208e24$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $5b76c17b94208e24$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $5b76c17b94208e24$export$1f2663aaa83f036d = 'Failed to fetch';
const $5b76c17b94208e24$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $5b76c17b94208e24$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $5b76c17b94208e24$export$6827a0909c1bf12f = [
    $5b76c17b94208e24$export$1f2663aaa83f036d,
    $5b76c17b94208e24$export$65e55894e6e38a89,
    $5b76c17b94208e24$export$f25400ad927aa79c
];
const $5b76c17b94208e24$export$e1b6bb1617649e83 = (errorMessage)=>$5b76c17b94208e24$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $5b76c17b94208e24$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $5b76c17b94208e24$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $5b76c17b94208e24$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $5b76c17b94208e24$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $5b76c17b94208e24$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $5b76c17b94208e24$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $5b76c17b94208e24$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $5b76c17b94208e24$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $5b76c17b94208e24$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (e) {
        return false;
    }
};
const $5b76c17b94208e24$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $5b76c17b94208e24$export$80a3c1a1eb6f063 || errorMessage === $5b76c17b94208e24$export$e089e1d2018847da;
const $5b76c17b94208e24$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $5b76c17b94208e24$export$678d91a98f79a24d(message, status) || status === 400 && ($5b76c17b94208e24$export$cb3290253184cb70(message, $5b76c17b94208e24$export$c53f16dd5442ef61) || $5b76c17b94208e24$export$cb3290253184cb70(message, $5b76c17b94208e24$export$e27975535396141b)) || status === 412 && $5b76c17b94208e24$export$395f41a02d6a8be0(key, message);
};
const $5b76c17b94208e24$export$9de493bcd9b1d977 = 'bad-request';
const $5b76c17b94208e24$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $5b76c17b94208e24$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $5b76c17b94208e24$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $5b76c17b94208e24$export$e5254cb9f7678ab9) return false;
    return true;
};

});

parcelRegister("dn9SV", function(module, exports) {
$parcel$export(module.exports, "fetchJSON", () => $c91c443e9923ac68$export$81bec6e38e8b706b);

var $i583N = parcelRequire("i583N");
const $c91c443e9923ac68$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $i583N.unimplementedAbstractService)('fetchJSON');

});


parcelRegister("k8PfX", function(module, exports) {
$parcel$export(module.exports, "default", () => $528ccfb044e31568$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $528ccfb044e31568$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addButton: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.add-button",
        "defaultMessage": "Create or invite"
    },
    createTeam: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.create-team",
        "defaultMessage": "Create a team"
    },
    invitePeople: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.invite-people",
        "defaultMessage": "Invite people"
    },
    inviteRecommendationsFromSlack: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.invite-recommendations-from-slack",
        "defaultMessage": "{email} (Found in slack)"
    }
});

});


// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $2b839a8453de5367$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$baf21119361ffad = 'planCreateMoreWorkItemsNudge';
const $2b839a8453de5367$export$7fac0b950c128b4b = 'planConnectRelatedWorkNudge';
const $2b839a8453de5367$export$9fac41c1d8941795 = 'planShareYourPlanWithTheWorldTeamNudge';
const $2b839a8453de5367$export$994f00a8ff485faf = 'planShareYourPlanWithTheWorldAddPeopleNudge';
const $2b839a8453de5367$export$fc1e19da8853ecdc = 'planBringInTheTeamNudge';
const $2b839a8453de5367$export$d0ece87d6f260877 = 'planConfirmScopeNudge';
const $2b839a8453de5367$export$cc93e7cb8dd884fe = 'planCheckYourSettingsNudge';
const $2b839a8453de5367$export$b579a6f09436e23e = 'asyncPlanOnboardingTourNudge';
const $2b839a8453de5367$export$c7f7837470493c6f = 'planAdjustDetailsFieldsMenuNudge';
const $2b839a8453de5367$export$8909317d0f73beab = 'planAdjustDetailsFieldCellsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

parcelRegister("dIJOd", function(module, exports) {
$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $a0e00efc1118bc6b$export$a4b4061b22dbc897);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");


var $gxP9D = parcelRequire("gxP9D");


var $45qbN = parcelRequire("45qbN");
const $a0e00efc1118bc6b$var$runtimeProps = {};
const $a0e00efc1118bc6b$var$entryPointParams = {};
const $a0e00efc1118bc6b$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $45qbN.inviteTeamNudgeEntryPoint), $a0e00efc1118bc6b$var$entryPointParams);
    const [nudgeStep] = (0, $gxP9D.useNudgeStep)();
    const [hasNudgeActive] = (0, $gxP9D.useHasNudgeActive)();
    const firstLoadRef = (0, $eJOHy.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $2b839a8453de5367$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $44259bc988b99eaa$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: $a0e00efc1118bc6b$var$runtimeProps
    });
};

});
parcelRegister("cBavF", function(module, exports) {
$parcel$export(module.exports, "JiraEntryPointContainer", () => $75ab809c2125a8a7$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $75ab809c2125a8a7$export$54db9e88249c9162);

var $eJOHy = parcelRequire("eJOHy");

var $snbGZ = parcelRequire("snbGZ");

var $5GSFM = parcelRequire("5GSFM");
const $75ab809c2125a8a7$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $snbGZ.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $75ab809c2125a8a7$export$54db9e88249c9162 = (0, $5GSFM.InternalEntryPointContainer);

});
parcelRegister("snbGZ", function(module, exports) {
$parcel$export(module.exports, "useEntryPointSubscription", () => $ad7cb4b936d42fec$export$3cd1c81e13390c49);

var $eJOHy = parcelRequire("eJOHy");
const $ad7cb4b936d42fec$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $eJOHy.useState)(subject.getValue);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed) return null;
    return entryPointReference;
};

});

parcelRegister("5GSFM", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $3534dc73cb841369$export$5d4dc37edd8a3adb);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $4EKqI = parcelRequire("4EKqI");
const $3534dc73cb841369$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("iWvkh", function(module, exports) {
$parcel$export(module.exports, "useEntryPoint", () => $927b502cfec3c33d$export$338256068bc140fb);

var $eJOHy = parcelRequire("eJOHy");

var $hrKgE = parcelRequire("hrKgE");

var $9kThy = parcelRequire("9kThy");

var $3ZGs4 = parcelRequire("3ZGs4");

var $h2t7H = parcelRequire("h2t7H");

var $7mDPN = parcelRequire("7mDPN");
const $927b502cfec3c33d$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $9kThy.DEFAULT_OPTIONS))=>{
    // TODO: break tests on instability (stableEntryPointParams!==entryPointParams)
    // prevents {} from from triggering updates
    const stableEntryPointParams = (0, $hrKgE.useShallowStableReference)(entryPointParams);
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $h2t7H.useEntryPointLoadManager)(entryPoint, stableEntryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $7mDPN.useMetricLogger)(metric);
    const entryPointActions = (0, $3ZGs4.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $eJOHy.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("9kThy", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $3ad93489adcd223e$export$93ca5d3f8675ae4c);
const $3ad93489adcd223e$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("3ZGs4", function(module, exports) {
$parcel$export(module.exports, "useEntryPointActions", () => $1548435b188dd412$export$90681c8c3a56f09a);

var $eJOHy = parcelRequire("eJOHy");

var $7oY9g = parcelRequire("7oY9g");

var $9kThy = parcelRequire("9kThy");
const $1548435b188dd412$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $1548435b188dd412$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $9kThy.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $9kThy.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $eJOHy.useRef)();
    const preloadMaxAgeTimeout = (0, $eJOHy.useRef)();
    const preloadLastRequested = (0, $eJOHy.useRef)(0);
    const cancelPreload = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $7oY9g.default)($1548435b188dd412$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $eJOHy.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7oY9g.default)($1548435b188dd412$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $eJOHy.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("h2t7H", function(module, exports) {
$parcel$export(module.exports, "useEntryPointLoadManager", () => $533c37fcc684590d$export$bfae318f9651db2f);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5HFSX = parcelRequire("5HFSX");

var $48jZc = parcelRequire("48jZc");
const $533c37fcc684590d$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $5HFSX.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $eJOHy.useRef)(true);
    const removeInactiveLoadsIdleCallback = (0, $eJOHy.useRef)(null);
    const entryPointReferenceQueue = (0, $eJOHy.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $48jZc.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $eJOHy.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        $533c37fcc684590d$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
        removeInactiveLoadsIdleCallback.current = $533c37fcc684590d$var$callWhenIdle(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $48jZc.removeAll)(currentQueue) : (0, $48jZc.removeInactiveLoads)(currentQueue);
        });
    }, [
        setEntryPointReference
    ]);
    const load = (0, $eJOHy.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $48jZc.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $eJOHy.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $eJOHy.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $533c37fcc684590d$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $48jZc.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    return {
        entryPointReferenceSubject: (0, $eJOHy.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $533c37fcc684590d$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $533c37fcc684590d$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("5HFSX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ec104d1917a5703$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $2ec104d1917a5703$export$83fb48644dee72f0);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");
function $2ec104d1917a5703$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.RelayEnvironmentProvider), {
        environment: (0, $7zZ4w.default)()
    }, children);
}
function $2ec104d1917a5703$export$83fb48644dee72f0() {
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});

parcelRegister("48jZc", function(module, exports) {
$parcel$export(module.exports, "removeRedundantPreloads", () => $239bc1649b38a10b$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $239bc1649b38a10b$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $239bc1649b38a10b$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $239bc1649b38a10b$export$322c8997d351da6a);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");
const $239bc1649b38a10b$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $239bc1649b38a10b$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $239bc1649b38a10b$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $239bc1649b38a10b$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $eJOHy.useRef)(null);
    const subscribers = (0, $eJOHy.useRef)();
    const unsub = (0, $eJOHy.useRef)(null);
    const subscribe = (0, $eJOHy.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $eJOHy.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $aQK2r.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($239bc1649b38a10b$var$isReactAsyncJSResourceReference(entryPoint?.root)) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $eJOHy.useCallback)(()=>value.current, []);
    (0, $eJOHy.useEffect)(()=>()=>{
            subscribers.current?.clear();
            unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $239bc1649b38a10b$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("7mDPN", function(module, exports) {
$parcel$export(module.exports, "useMetricLogger", () => $fcc14641d7a58547$export$f291ec7cea728e1);

var $eJOHy = parcelRequire("eJOHy");
const $fcc14641d7a58547$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $eJOHy.useRef)(0);
    const loadStartTime = (0, $eJOHy.useRef)(0);
    const startMetric = (0, $eJOHy.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $eJOHy.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("gxP9D", function(module, exports) {
$parcel$export(module.exports, "useJswOnboarding", () => $ef5cbf2537a08e24$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $ef5cbf2537a08e24$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $ef5cbf2537a08e24$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $ef5cbf2537a08e24$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $ef5cbf2537a08e24$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $ef5cbf2537a08e24$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $ef5cbf2537a08e24$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $ef5cbf2537a08e24$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $ef5cbf2537a08e24$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $ef5cbf2537a08e24$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $ef5cbf2537a08e24$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $ef5cbf2537a08e24$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $ef5cbf2537a08e24$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $ef5cbf2537a08e24$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $ef5cbf2537a08e24$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $ef5cbf2537a08e24$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $ef5cbf2537a08e24$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $ef5cbf2537a08e24$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $ef5cbf2537a08e24$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $ef5cbf2537a08e24$export$521909e3dc7ab811);
$parcel$export(module.exports, "useIsOpenedViaButton", () => $ef5cbf2537a08e24$export$2317d3c684b416ec);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("9ycBx")).QUICKSTART_UI_STATUS);

var $f4Iys = parcelRequire("f4Iys");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $9ycBx = parcelRequire("9ycBx");

var $4NsfZ = parcelRequire("4NsfZ");

var $1KmSm = parcelRequire("1KmSm");

var $6R6zv = parcelRequire("6R6zv");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");

const $ef5cbf2537a08e24$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $6R6zv.initialState,
    actions: $4NsfZ.actions
});
const $ef5cbf2537a08e24$export$1cbc60d8dd921852 = (0, $ht3nQ.createSubscriber)($ef5cbf2537a08e24$export$390f32400eaf98c9);
const $ef5cbf2537a08e24$export$7d91c0af4772787a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9);
const $ef5cbf2537a08e24$export$638bfcfce1254bb8 = (0, $6E16M.createContainer)($ef5cbf2537a08e24$export$390f32400eaf98c9, {});
const $ef5cbf2537a08e24$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3XHRA.getQuickstartTypeSelector)(state)] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $ef5cbf2537a08e24$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $ef5cbf2537a08e24$export$594f006fa6a1b2e5 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$ea14030920a5d8e6
});
const $ef5cbf2537a08e24$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $ef5cbf2537a08e24$export$c5e63e44ad178ae8 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$a943afa434e9487a
});
const $ef5cbf2537a08e24$export$2c3cd14fff9d6e43 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: null
});
const $ef5cbf2537a08e24$export$b0db7e46e369e1d9 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$9d731f44f82af09f
});
const $ef5cbf2537a08e24$export$71de79653346a1ea = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $ef5cbf2537a08e24$export$61185a9266f1f57a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN || userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $ef5cbf2537a08e24$export$ef4747ba36826d6a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $ef5cbf2537a08e24$export$522993b46d9f8266 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $uMSsJ.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $ef5cbf2537a08e24$export$aa4ba29241532382 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $ef5cbf2537a08e24$export$ed5c755b733bf2b1 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $ef5cbf2537a08e24$export$35fe0366802512dd = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3XHRA.getQuickstartTypeSelector)(state)];
        return visibility === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $ef5cbf2537a08e24$export$a41ee0d3b6938099 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $ef5cbf2537a08e24$export$4ae7b465b076be9 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $ef5cbf2537a08e24$export$bf6e646c0476acad = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $ef5cbf2537a08e24$export$6b706bff94798d11 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $ef5cbf2537a08e24$export$c98db656edc5b3e1 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $ef5cbf2537a08e24$export$a823278ac9d1112b = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $f4Iys.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN)
});
const $ef5cbf2537a08e24$export$cb9e0e8fe4df8490 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $f4Iys.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $9ycBx.KANBAN_ONBOARDING_TASK)))
});
const $ef5cbf2537a08e24$export$521909e3dc7ab811 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $ef5cbf2537a08e24$export$f4a2be940259bf95 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $ef5cbf2537a08e24$export$6db1f59c8ab54061 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.quickstartButtonRef
});
const $ef5cbf2537a08e24$export$2317d3c684b416ec = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isOpenedViaButton
});
const $ef5cbf2537a08e24$export$a57f80e92714bb45 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.containerType
});

});
parcelRegister("f4Iys", function(module, exports) {
$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $b21c8d0b303bc850$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$17a2f771efabf02f);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $b21c8d0b303bc850$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $b21c8d0b303bc850$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $b21c8d0b303bc850$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $b21c8d0b303bc850$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $b21c8d0b303bc850$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $b21c8d0b303bc850$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$7c567eb725bd36f);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_BLANK_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$b0eec2c6558182ca);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_ROADMAP_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$f9776303073903dd);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PRIORITIZE_TEAM_MANAGED_KEY", () => $b21c8d0b303bc850$export$b7c4ca557ac2074e);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_STRATEGIC_PLANNING_KEY", () => $b21c8d0b303bc850$export$85a50c2a444c8c83);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PORTFOLIO_ROADMAP_KEY", () => $b21c8d0b303bc850$export$52a446cb03181b7);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $b21c8d0b303bc850$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $b21c8d0b303bc850$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $b21c8d0b303bc850$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $b21c8d0b303bc850$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $b21c8d0b303bc850$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $b21c8d0b303bc850$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $b21c8d0b303bc850$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $b21c8d0b303bc850$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $b21c8d0b303bc850$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $b21c8d0b303bc850$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $b21c8d0b303bc850$export$7d9a4e0ef5194fe1 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $b21c8d0b303bc850$export$477ca3550da12e43 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $b21c8d0b303bc850$export$7c0307155b744916 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $b21c8d0b303bc850$export$b5ab111fb8825075 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $b21c8d0b303bc850$export$14139f0ec41d437e = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $b21c8d0b303bc850$export$ebf7af45376deb8b = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $b21c8d0b303bc850$export$7b6945581ccdab4a = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $b21c8d0b303bc850$export$310a9ac5c28d65f6 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $b21c8d0b303bc850$export$136d17feb2f4285d = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $b21c8d0b303bc850$export$e288f4758e94a8cc = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $b21c8d0b303bc850$export$4e9ac1417ba54bba = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $b21c8d0b303bc850$export$560c9f6765bf9af4 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $b21c8d0b303bc850$export$14d4c6dbbb62a127 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $b21c8d0b303bc850$export$1367ee12532c525f = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $b21c8d0b303bc850$export$278632cc7ed9a312 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $b21c8d0b303bc850$export$594d0d4f5ecbf4c7 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $b21c8d0b303bc850$export$dda85c7a8278e495 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $b21c8d0b303bc850$export$b92c431651f9ee91 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $b21c8d0b303bc850$export$d72d75d9d0e071fc = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $b21c8d0b303bc850$export$753322ed1c32ff89 = `${$b21c8d0b303bc850$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $b21c8d0b303bc850$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $b21c8d0b303bc850$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $b21c8d0b303bc850$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $b21c8d0b303bc850$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $b21c8d0b303bc850$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $b21c8d0b303bc850$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $b21c8d0b303bc850$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $b21c8d0b303bc850$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $b21c8d0b303bc850$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $b21c8d0b303bc850$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $b21c8d0b303bc850$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $b21c8d0b303bc850$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $b21c8d0b303bc850$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $b21c8d0b303bc850$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $b21c8d0b303bc850$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $b21c8d0b303bc850$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $b21c8d0b303bc850$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $b21c8d0b303bc850$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $b21c8d0b303bc850$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $b21c8d0b303bc850$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $b21c8d0b303bc850$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $b21c8d0b303bc850$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $b21c8d0b303bc850$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $b21c8d0b303bc850$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $b21c8d0b303bc850$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $b21c8d0b303bc850$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $b21c8d0b303bc850$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $b21c8d0b303bc850$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $b21c8d0b303bc850$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $b21c8d0b303bc850$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $b21c8d0b303bc850$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $b21c8d0b303bc850$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $b21c8d0b303bc850$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $b21c8d0b303bc850$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $b21c8d0b303bc850$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $b21c8d0b303bc850$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $b21c8d0b303bc850$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $b21c8d0b303bc850$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $b21c8d0b303bc850$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $b21c8d0b303bc850$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $b21c8d0b303bc850$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $b21c8d0b303bc850$export$f9776303073903dd = 'jira.polaris:roadmap';
const $b21c8d0b303bc850$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $b21c8d0b303bc850$export$85a50c2a444c8c83 = 'jira.polaris:strategic_planning';
const $b21c8d0b303bc850$export$52a446cb03181b7 = 'jira.polaris:portfolio-roadmap';
const $b21c8d0b303bc850$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $b21c8d0b303bc850$export$e8df553a3f519284 || T4JTemplateKey === $b21c8d0b303bc850$export$8eecdf6acea9494 || T4JTemplateKey === $b21c8d0b303bc850$export$9e38ad41d19608ee;
const $b21c8d0b303bc850$export$a062badd78c9993 = {
    [$b21c8d0b303bc850$export$e82092c4fb277f9b]: $b21c8d0b303bc850$export$b0928b02ffab3875,
    [$b21c8d0b303bc850$export$fd75f6abc7861439]: $b21c8d0b303bc850$export$b0928b02ffab3875,
    [$b21c8d0b303bc850$export$5eddf3b31dd1858f]: $b21c8d0b303bc850$export$50478ee5ecbf7a4d,
    [$b21c8d0b303bc850$export$fb658bddae7f81bb]: $b21c8d0b303bc850$export$50478ee5ecbf7a4d
};

});

parcelRegister("9ycBx", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $9b4ef256583f1ea3$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $9b4ef256583f1ea3$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $9b4ef256583f1ea3$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $9b4ef256583f1ea3$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $9b4ef256583f1ea3$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $9b4ef256583f1ea3$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $9b4ef256583f1ea3$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $9b4ef256583f1ea3$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $9b4ef256583f1ea3$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $9b4ef256583f1ea3$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $9b4ef256583f1ea3$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $9b4ef256583f1ea3$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $9b4ef256583f1ea3$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $9b4ef256583f1ea3$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $9b4ef256583f1ea3$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $9b4ef256583f1ea3$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $9b4ef256583f1ea3$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $9b4ef256583f1ea3$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $9b4ef256583f1ea3$export$d97d31d934dbb194);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $9b4ef256583f1ea3$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $9b4ef256583f1ea3$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $9b4ef256583f1ea3$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $9b4ef256583f1ea3$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $9b4ef256583f1ea3$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "PLAN_CREATE_MORE_WORK_ITEMS_TASK", () => $9b4ef256583f1ea3$export$590dc845c98d57e5);
$parcel$export(module.exports, "PLAN_BRING_IN_THE_TEAM_TASK", () => $9b4ef256583f1ea3$export$833908c980d64374);
$parcel$export(module.exports, "PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK", () => $9b4ef256583f1ea3$export$30049c54ff5e06aa);
$parcel$export(module.exports, "PLAN_CONNECT_RELATED_WORK_TASK", () => $9b4ef256583f1ea3$export$ad20239966e8cce);
$parcel$export(module.exports, "PLAN_ADJUST_DETAILS_TASK", () => $9b4ef256583f1ea3$export$1800599ce91071b4);
$parcel$export(module.exports, "PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK", () => $9b4ef256583f1ea3$export$3ed330408d0583ad);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $9b4ef256583f1ea3$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $9b4ef256583f1ea3$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $9b4ef256583f1ea3$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $9b4ef256583f1ea3$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $9b4ef256583f1ea3$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $9b4ef256583f1ea3$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $9b4ef256583f1ea3$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $9b4ef256583f1ea3$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $9b4ef256583f1ea3$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $9b4ef256583f1ea3$export$3380e677209260fe);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $9b4ef256583f1ea3$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $9b4ef256583f1ea3$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $9b4ef256583f1ea3$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $9b4ef256583f1ea3$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $9b4ef256583f1ea3$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $9b4ef256583f1ea3$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $9b4ef256583f1ea3$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $9b4ef256583f1ea3$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $9b4ef256583f1ea3$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $9b4ef256583f1ea3$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $9b4ef256583f1ea3$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $9b4ef256583f1ea3$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $9b4ef256583f1ea3$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $9b4ef256583f1ea3$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $9b4ef256583f1ea3$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $9b4ef256583f1ea3$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $9b4ef256583f1ea3$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $9b4ef256583f1ea3$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $9b4ef256583f1ea3$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $9b4ef256583f1ea3$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $9b4ef256583f1ea3$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $9b4ef256583f1ea3$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $9b4ef256583f1ea3$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $9b4ef256583f1ea3$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $9b4ef256583f1ea3$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $9b4ef256583f1ea3$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $9b4ef256583f1ea3$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $9b4ef256583f1ea3$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $9b4ef256583f1ea3$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $9b4ef256583f1ea3$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $9b4ef256583f1ea3$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $9b4ef256583f1ea3$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $9b4ef256583f1ea3$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $9b4ef256583f1ea3$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $9b4ef256583f1ea3$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $9b4ef256583f1ea3$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $9b4ef256583f1ea3$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $9b4ef256583f1ea3$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $9b4ef256583f1ea3$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $9b4ef256583f1ea3$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $9b4ef256583f1ea3$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $9b4ef256583f1ea3$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $9b4ef256583f1ea3$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $9b4ef256583f1ea3$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $9b4ef256583f1ea3$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $9b4ef256583f1ea3$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $9b4ef256583f1ea3$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $9b4ef256583f1ea3$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $9b4ef256583f1ea3$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $9b4ef256583f1ea3$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $9b4ef256583f1ea3$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $9b4ef256583f1ea3$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $9b4ef256583f1ea3$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $9b4ef256583f1ea3$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $9b4ef256583f1ea3$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $9b4ef256583f1ea3$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $9b4ef256583f1ea3$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $9b4ef256583f1ea3$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $9b4ef256583f1ea3$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $9b4ef256583f1ea3$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $9b4ef256583f1ea3$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $9b4ef256583f1ea3$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $9b4ef256583f1ea3$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $9b4ef256583f1ea3$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $9b4ef256583f1ea3$export$5980f41aa657f9c7);

var $2QZBX = parcelRequire("2QZBX");
const $9b4ef256583f1ea3$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completePlanTaskName = (taskId)=>`plan-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $9b4ef256583f1ea3$export$2b3151a089bc8780 = 'jlove-makkuro';
const $9b4ef256583f1ea3$export$6826d33e9a2c0119 = 320;
const $9b4ef256583f1ea3$export$b580da85daad7757 = 'root';
const $9b4ef256583f1ea3$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $9b4ef256583f1ea3$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $9b4ef256583f1ea3$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $9b4ef256583f1ea3$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $9b4ef256583f1ea3$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $9b4ef256583f1ea3$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $9b4ef256583f1ea3$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $9b4ef256583f1ea3$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $9b4ef256583f1ea3$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $9b4ef256583f1ea3$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $9b4ef256583f1ea3$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $9b4ef256583f1ea3$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $9b4ef256583f1ea3$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $9b4ef256583f1ea3$export$63b0e55f9c6454ac = $9b4ef256583f1ea3$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $9b4ef256583f1ea3$export$d97d31d934dbb194 = $9b4ef256583f1ea3$var$completeJswTaskName('premium-reverse-trial-task');
const $9b4ef256583f1ea3$export$540b5c3c4b6ce459 = $9b4ef256583f1ea3$var$completeJswTaskName('advanced-roadmaps-task');
const $9b4ef256583f1ea3$export$6f71dff531ff592 = $9b4ef256583f1ea3$var$completeJswTaskName('change-control-task');
const $9b4ef256583f1ea3$export$83255ab79e45f34f = $9b4ef256583f1ea3$var$completeJswTaskName('automations-task');
const $9b4ef256583f1ea3$export$b57d172af9ad7647 = $9b4ef256583f1ea3$var$completeJswTaskName('site-administrations-task');
const $9b4ef256583f1ea3$export$ff4c933c1fe90b68 = $9b4ef256583f1ea3$var$completeJswTaskName('user-management-task');
const $9b4ef256583f1ea3$export$590dc845c98d57e5 = $9b4ef256583f1ea3$var$completePlanTaskName('create-work-items-task');
const $9b4ef256583f1ea3$export$833908c980d64374 = $9b4ef256583f1ea3$var$completePlanTaskName('bring-team-task');
const $9b4ef256583f1ea3$export$30049c54ff5e06aa = $9b4ef256583f1ea3$var$completePlanTaskName('confirm-scope-task');
const $9b4ef256583f1ea3$export$ad20239966e8cce = $9b4ef256583f1ea3$var$completePlanTaskName('connect-related-work-task');
const $9b4ef256583f1ea3$export$1800599ce91071b4 = $9b4ef256583f1ea3$var$completePlanTaskName('adjust-details-task');
const $9b4ef256583f1ea3$export$3ed330408d0583ad = $9b4ef256583f1ea3$var$completePlanTaskName('share-your-plan-task');
const $9b4ef256583f1ea3$export$501166b25f254aab = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-project-summary-task');
const $9b4ef256583f1ea3$export$94ad6507a703f4eb = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-create-sample-project-task');
const $9b4ef256583f1ea3$export$be1c522400a1bd7c = $9b4ef256583f1ea3$var$completeJwmTaskName('background-color-task');
const $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5 = $9b4ef256583f1ea3$var$completeJwmTaskName('calendar-task');
const $9b4ef256583f1ea3$export$f3b53199b07af2a1 = $9b4ef256583f1ea3$var$completeJwmTaskName('timeline-task');
const $9b4ef256583f1ea3$export$d37415ffddcf2142 = $9b4ef256583f1ea3$var$completeJwmTaskName('build-form-task');
const $9b4ef256583f1ea3$export$2ae00586da7cb606 = $9b4ef256583f1ea3$var$completeJwmTaskName('feedback-task');
const $9b4ef256583f1ea3$export$b86266e6594a97bb = $9b4ef256583f1ea3$var$completeJwmTaskName('feedback-sample-project-task');
const $9b4ef256583f1ea3$export$20bc3dc137ac1c38 = $9b4ef256583f1ea3$var$completeJwmTaskName('create-your-own-project-task');
const $9b4ef256583f1ea3$export$77071b77e2801b18 = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-create-project-task');
const $9b4ef256583f1ea3$export$9c89f946f05d884a = $9b4ef256583f1ea3$var$completeJwmTaskName('share-project-task');
const $9b4ef256583f1ea3$export$b52a7c936684cfc5 = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-import');
const $9b4ef256583f1ea3$export$b5555f24061f9fb = $9b4ef256583f1ea3$var$completeJwmTaskName('summary-and-reports-task');
const $9b4ef256583f1ea3$export$ff25449f34b8abf = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $9b4ef256583f1ea3$export$3380e677209260fe = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-key-differences');
const $9b4ef256583f1ea3$export$da23b72d32bfad9e = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $9b4ef256583f1ea3$export$4b064659282e0238 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $9b4ef256583f1ea3$export$3ab51851f6d823e = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $9b4ef256583f1ea3$export$e4a1a37a9a1350ad = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $9b4ef256583f1ea3$export$b7f7da5e795f0327 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $9b4ef256583f1ea3$export$80a401c1aa47a377 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $9b4ef256583f1ea3$export$934ac7a251b26dc7 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $9b4ef256583f1ea3$export$4634f6395df3ebbe = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $9b4ef256583f1ea3$export$768fb41107a1e8d7 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $9b4ef256583f1ea3$export$d797a81bace17184 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $9b4ef256583f1ea3$export$746102c94db9df1f = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $9b4ef256583f1ea3$export$5f1efd797d65e349 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $9b4ef256583f1ea3$export$cccc812ccafbf11f = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $9b4ef256583f1ea3$export$64822db87abd8a47 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $9b4ef256583f1ea3$export$64f764d8be495c82 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $9b4ef256583f1ea3$export$24eae23dc1c68bbd = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $9b4ef256583f1ea3$export$50fa92eba6f82feb = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $9b4ef256583f1ea3$export$4155d22fe3f14cd6 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $9b4ef256583f1ea3$export$76813cbead887191 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $9b4ef256583f1ea3$export$90aab2ff89daf770 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $9b4ef256583f1ea3$export$a2bc0cbad2e6e605 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $9b4ef256583f1ea3$export$f90872a1280728bb = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $9b4ef256583f1ea3$export$bce644e96518cbd2 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $9b4ef256583f1ea3$export$241aaebffac0a3e5 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $9b4ef256583f1ea3$export$79759e9e62fb9312 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $9b4ef256583f1ea3$export$992d1e0dce255d19 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $9b4ef256583f1ea3$export$d28c1b0e5b3e768 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $9b4ef256583f1ea3$export$ca714ee197bed4ec = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $9b4ef256583f1ea3$export$faae55ceea4b6073 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $9b4ef256583f1ea3$export$200bc24cd120667e = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $9b4ef256583f1ea3$export$a0d784a48b4e886c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $9b4ef256583f1ea3$export$baf5bd09b4b33b8a = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $9b4ef256583f1ea3$export$4702007eedbca8ab = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $9b4ef256583f1ea3$export$aa9d2d635ea63898 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $9b4ef256583f1ea3$export$2ea449225c1f6cac = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $9b4ef256583f1ea3$export$deb8b557e735e26a = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $9b4ef256583f1ea3$export$d45754df44e4c309 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $9b4ef256583f1ea3$export$78b2913b550edbb = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $9b4ef256583f1ea3$export$71243272608c58ab = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $9b4ef256583f1ea3$export$39a08f215c33bc39 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $9b4ef256583f1ea3$export$d2377f6a6fa3b49c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $9b4ef256583f1ea3$export$befa8f6533309779 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $9b4ef256583f1ea3$export$736b40db8701ba6c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $9b4ef256583f1ea3$export$11eff6ae2f70b67b = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $9b4ef256583f1ea3$export$fb2d23e5315a67a9 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $9b4ef256583f1ea3$export$32e794bb49d60b6 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $9b4ef256583f1ea3$export$fed256238b27db06 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $9b4ef256583f1ea3$export$132eecb4d35a590d = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $9b4ef256583f1ea3$export$2579c51cadd45eca = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $9b4ef256583f1ea3$export$4b1a0cefa966ea0 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $9b4ef256583f1ea3$export$f6558daacc312a65 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $9b4ef256583f1ea3$export$925efa2e24e86b88 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $9b4ef256583f1ea3$export$40454d3e062dcd44 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $9b4ef256583f1ea3$export$99b0e09ff6f00490 = $9b4ef256583f1ea3$var$completeJsmTaskName('customize-your-request-types-task');
const $9b4ef256583f1ea3$export$2a82344eb273eeff = $9b4ef256583f1ea3$var$completeJsmTaskName('review-your-channels-task');
const $9b4ef256583f1ea3$export$1de5766b7e640d6b = $9b4ef256583f1ea3$var$completeJsmTaskName('invite-your-team-task');
const $9b4ef256583f1ea3$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $9b4ef256583f1ea3$export$c8ab6996f562d0db = (0, $2QZBX.toAccountId)('accountId');
const $9b4ef256583f1ea3$export$2b5f951ad8e70cfe = $9b4ef256583f1ea3$var$completeJswTaskName('kanban-onboarding-task');
const $9b4ef256583f1ea3$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $9b4ef256583f1ea3$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $9b4ef256583f1ea3$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $9b4ef256583f1ea3$export$38fbac7a5bf4aa33 = [
    $9b4ef256583f1ea3$export$2a82344eb273eeff,
    $9b4ef256583f1ea3$export$99b0e09ff6f00490,
    $9b4ef256583f1ea3$export$1de5766b7e640d6b
];
const $9b4ef256583f1ea3$export$7578902c7f420a3 = [
    $9b4ef256583f1ea3$export$63b0e55f9c6454ac,
    $9b4ef256583f1ea3$export$d97d31d934dbb194,
    $9b4ef256583f1ea3$export$540b5c3c4b6ce459,
    $9b4ef256583f1ea3$export$6f71dff531ff592,
    $9b4ef256583f1ea3$export$83255ab79e45f34f,
    $9b4ef256583f1ea3$export$b57d172af9ad7647,
    $9b4ef256583f1ea3$export$ff4c933c1fe90b68,
    $9b4ef256583f1ea3$export$77071b77e2801b18,
    $9b4ef256583f1ea3$export$94ad6507a703f4eb,
    $9b4ef256583f1ea3$export$501166b25f254aab,
    $9b4ef256583f1ea3$export$be1c522400a1bd7c,
    $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5,
    $9b4ef256583f1ea3$export$f3b53199b07af2a1,
    $9b4ef256583f1ea3$export$d37415ffddcf2142,
    $9b4ef256583f1ea3$export$2ae00586da7cb606,
    $9b4ef256583f1ea3$export$9c89f946f05d884a,
    $9b4ef256583f1ea3$export$20bc3dc137ac1c38,
    $9b4ef256583f1ea3$export$b52a7c936684cfc5,
    $9b4ef256583f1ea3$export$b5555f24061f9fb,
    $9b4ef256583f1ea3$export$ff25449f34b8abf,
    $9b4ef256583f1ea3$export$3380e677209260fe,
    $9b4ef256583f1ea3$export$b86266e6594a97bb,
    $9b4ef256583f1ea3$export$2b5f951ad8e70cfe,
    $9b4ef256583f1ea3$export$da23b72d32bfad9e,
    $9b4ef256583f1ea3$export$4b064659282e0238,
    $9b4ef256583f1ea3$export$3ab51851f6d823e,
    $9b4ef256583f1ea3$export$e4a1a37a9a1350ad,
    $9b4ef256583f1ea3$export$b7f7da5e795f0327,
    $9b4ef256583f1ea3$export$80a401c1aa47a377,
    $9b4ef256583f1ea3$export$934ac7a251b26dc7,
    $9b4ef256583f1ea3$export$4634f6395df3ebbe,
    $9b4ef256583f1ea3$export$768fb41107a1e8d7,
    $9b4ef256583f1ea3$export$d797a81bace17184,
    $9b4ef256583f1ea3$export$746102c94db9df1f,
    $9b4ef256583f1ea3$export$5f1efd797d65e349,
    $9b4ef256583f1ea3$export$cccc812ccafbf11f,
    $9b4ef256583f1ea3$export$64822db87abd8a47,
    $9b4ef256583f1ea3$export$64f764d8be495c82,
    $9b4ef256583f1ea3$export$24eae23dc1c68bbd,
    $9b4ef256583f1ea3$export$50fa92eba6f82feb,
    $9b4ef256583f1ea3$export$4155d22fe3f14cd6,
    $9b4ef256583f1ea3$export$76813cbead887191,
    $9b4ef256583f1ea3$export$90aab2ff89daf770,
    $9b4ef256583f1ea3$export$a2bc0cbad2e6e605,
    $9b4ef256583f1ea3$export$f90872a1280728bb,
    $9b4ef256583f1ea3$export$bce644e96518cbd2,
    $9b4ef256583f1ea3$export$241aaebffac0a3e5,
    $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7,
    $9b4ef256583f1ea3$export$79759e9e62fb9312,
    $9b4ef256583f1ea3$export$992d1e0dce255d19,
    $9b4ef256583f1ea3$export$d28c1b0e5b3e768,
    $9b4ef256583f1ea3$export$ca714ee197bed4ec,
    $9b4ef256583f1ea3$export$faae55ceea4b6073,
    $9b4ef256583f1ea3$export$200bc24cd120667e,
    $9b4ef256583f1ea3$export$a0d784a48b4e886c,
    $9b4ef256583f1ea3$export$baf5bd09b4b33b8a,
    $9b4ef256583f1ea3$export$4702007eedbca8ab,
    $9b4ef256583f1ea3$export$aa9d2d635ea63898,
    $9b4ef256583f1ea3$export$2ea449225c1f6cac,
    $9b4ef256583f1ea3$export$deb8b557e735e26a,
    $9b4ef256583f1ea3$export$d45754df44e4c309,
    $9b4ef256583f1ea3$export$78b2913b550edbb,
    $9b4ef256583f1ea3$export$71243272608c58ab,
    $9b4ef256583f1ea3$export$39a08f215c33bc39,
    $9b4ef256583f1ea3$export$d2377f6a6fa3b49c,
    $9b4ef256583f1ea3$export$befa8f6533309779,
    $9b4ef256583f1ea3$export$736b40db8701ba6c,
    // Plan tasks
    $9b4ef256583f1ea3$export$590dc845c98d57e5,
    $9b4ef256583f1ea3$export$833908c980d64374,
    $9b4ef256583f1ea3$export$30049c54ff5e06aa,
    $9b4ef256583f1ea3$export$ad20239966e8cce,
    $9b4ef256583f1ea3$export$1800599ce91071b4,
    $9b4ef256583f1ea3$export$3ed330408d0583ad,
    // Tailored onboarding M3
    $9b4ef256583f1ea3$export$11eff6ae2f70b67b,
    $9b4ef256583f1ea3$export$fb2d23e5315a67a9,
    $9b4ef256583f1ea3$export$32e794bb49d60b6,
    $9b4ef256583f1ea3$export$fed256238b27db06,
    $9b4ef256583f1ea3$export$132eecb4d35a590d,
    $9b4ef256583f1ea3$export$2579c51cadd45eca,
    $9b4ef256583f1ea3$export$4b1a0cefa966ea0,
    $9b4ef256583f1ea3$export$f6558daacc312a65,
    $9b4ef256583f1ea3$export$925efa2e24e86b88,
    $9b4ef256583f1ea3$export$40454d3e062dcd44
];
const $9b4ef256583f1ea3$export$5980f41aa657f9c7 = [
    'SAM1'
];

});

parcelRegister("4NsfZ", function(module, exports) {
$parcel$export(module.exports, "actions", () => $39220db316456429$export$e324594224ef24da);

var $9w2jV = parcelRequire("9w2jV");

var $9jCgU = parcelRequire("9jCgU");

var $bc2a8 = parcelRequire("bc2a8");

var $kpUPF = parcelRequire("kpUPF");

var $b6yo1 = parcelRequire("b6yo1");

var $iTkHr = parcelRequire("iTkHr");

var $VrLd0 = parcelRequire("VrLd0");

var $hc2fd = parcelRequire("hc2fd");

var $7BMTT = parcelRequire("7BMTT");

var $27SP3 = parcelRequire("27SP3");

var $DHvqm = parcelRequire("DHvqm");

var $gWAj1 = parcelRequire("gWAj1");

var $4u1bX = parcelRequire("4u1bX");

var $9Zwvs = parcelRequire("9Zwvs");

var $jIA25 = parcelRequire("jIA25");

var $4RIzA = parcelRequire("4RIzA");

var $1ntUB = parcelRequire("1ntUB");

var $hcEqM = parcelRequire("hcEqM");

var $4AM50 = parcelRequire("4AM50");

var $b1NgJ = parcelRequire("b1NgJ");

var $75ZOj = parcelRequire("75ZOj");

var $4ewzp = parcelRequire("4ewzp");

var $STfOf = parcelRequire("STfOf");

var $6wCHd = parcelRequire("6wCHd");

var $d8p4f = parcelRequire("d8p4f");

var $8n02n = parcelRequire("8n02n");
const $39220db316456429$export$e324594224ef24da = {
    changeTaskGroupParent: $9w2jV.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $9w2jV.nextGoBackToPreviousTaskGroup,
    setIsOpen: $9jCgU.setIsOpen,
    refreshAppState: $bc2a8.refreshAppState,
    setNudgeStep: $kpUPF.setNudgeStep,
    addMountedNudge: $b6yo1.addMountedNudge,
    removeMountedNudge: $b6yo1.removeMountedNudge,
    setShouldRenderComponent: $iTkHr.setShouldRenderComponent,
    setProjectState: $VrLd0.setProjectState,
    setHasNudgeActive: $hc2fd.setHasNudgeActive,
    forceHideNudge: $7BMTT.forceHideNudge,
    setHasEverSeenRoute: $27SP3.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $DHvqm.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $DHvqm.setRoadmapIsListEmpty,
    openNextTask: $gWAj1.openNextTask,
    resetIsQuickstartLoaded: $4u1bX.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $9Zwvs.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $jIA25.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $4RIzA.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $1ntUB.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $hcEqM.nextSetChecklistIsOpen,
    nextOpenTask: $4AM50.nextOpenTask,
    nextAutoExpand: $b1NgJ.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $75ZOj.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $4ewzp.nextGetTasks,
    syncVisibilityWithLocal: $STfOf.syncVisibilityWithLocal,
    universalDispatch: $6wCHd.universalDispatch,
    setContainerType: $d8p4f.setContainerType,
    setQuickstartButtonRef: $8n02n.setQuickstartButtonRef,
    setIsOpenedViaButton: $8n02n.setIsOpenedViaButton,
    focusQuickstartButton: $8n02n.focusQuickstartButton
};

});
parcelRegister("9w2jV", function(module, exports) {
$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $c67ac35b88465cb8$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $c67ac35b88465cb8$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $c67ac35b88465cb8$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $c67ac35b88465cb8$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup));
    };
const $c67ac35b88465cb8$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $4cTDP.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $9ycBx.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $9ycBx.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("6d5N9", function(module, exports) {
$parcel$export(module.exports, "pushToBackend", () => $968fd65112be9cd3$export$583b2d2422a6757f);

var $9pTd3 = parcelRequire("9pTd3");

var $FppkK = parcelRequire("FppkK");

var $aYncF = parcelRequire("aYncF");

var $14RSn = parcelRequire("14RSn");
const $968fd65112be9cd3$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $968fd65112be9cd3$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $FppkK.setUserProperties)($968fd65112be9cd3$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $14RSn.default)(response.status, response.statusText);
    });
const $968fd65112be9cd3$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $968fd65112be9cd3$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $968fd65112be9cd3$export$583b2d2422a6757f = async (props)=>{
    const success = await $968fd65112be9cd3$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $968fd65112be9cd3$var$trySetUserProperties(props, 2);
};

});


parcelRegister("9jCgU", function(module, exports) {
$parcel$export(module.exports, "setIsOpen", () => $d6b89ce939fd1abc$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");
const $d6b89ce939fd1abc$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: isOpen
        });
    };
var $d6b89ce939fd1abc$export$2e2bcd8739ae039 = $d6b89ce939fd1abc$export$dcf23146e0a40195;

});
parcelRegister("3XHRA", function(module, exports) {
$parcel$export(module.exports, "getQuickstartTypeSelector", () => $5e767603cbb6a27b$export$eae834ce0286017a);

var $FhXEJ = parcelRequire("FhXEJ");

var $9ycBx = parcelRequire("9ycBx");
const $5e767603cbb6a27b$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
const $5e767603cbb6a27b$export$eae834ce0286017a = (state)=>{
    if ($5e767603cbb6a27b$export$6f17f2cb816105eb(state)) return (0, $9ycBx.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $9ycBx.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("bc2a8", function(module, exports) {
$parcel$export(module.exports, "refreshAppState", () => $f970723875566945$export$797c35e2e1d0d014);


var $kRgKj = parcelRequire("kRgKj");

var $31GRl = parcelRequire("31GRl");

var $cblKs = parcelRequire("cblKs");

var $4cTDP = parcelRequire("4cTDP");

var $9ycBx = parcelRequire("9ycBx");

var $79a1F = parcelRequire("79a1F");

var $6d5N9 = parcelRequire("6d5N9");

var $dELL6 = parcelRequire("dELL6");

var $8hqW7 = parcelRequire("8hqW7");

var $86LDA = parcelRequire("86LDA");

var $uMSsJ = parcelRequire("uMSsJ");

var $1ntUB = parcelRequire("1ntUB");

var $hcEqM = parcelRequire("hcEqM");

var $jIA25 = parcelRequire("jIA25");

var $9w2jV = parcelRequire("9w2jV");
const $f970723875566945$var$allTasks = [
    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
    ...(0, $9ycBx.JSM_BUSINESS_TASKS)
];
const $f970723875566945$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $9ycBx.convertToHaveSeenItTask)((0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $9ycBx.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $9ycBx.QUICKSTART_TYPE)).map((type)=>(0, $9ycBx.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $9ycBx.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $79a1F.pollBackend)({
            keys: [
                (0, $9ycBx.KEY_OPEN),
                (0, $9ycBx.KEY_DISMISSED),
                (0, $9ycBx.KEY_OPEN_TASK),
                (0, $9ycBx.KEY_TASK_GROUP),
                (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $9ycBx.KEY_JSW_ONBOARDING),
                (0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED),
                ...$f970723875566945$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $9ycBx.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $9ycBx.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $9ycBx.getBackendVisibilityKey)(type)];
                else if ((0, $9ycBx.KEY_DISMISSED) in backendState && backendState[0, $9ycBx.KEY_DISMISSED]) updatedState.visibility[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $9ycBx.KEY_OPEN] ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $uMSsJ.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $9ycBx.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $9ycBx.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $9ycBx.KEY_OPEN];
            if ((0, $9ycBx.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $9ycBx.KEY_OPEN_TASK];
            if ((0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $9ycBx.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $9ycBx.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $9ycBx.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $9ycBx.KEY_JSW_ONBOARDING] !== null && (0, $2b839a8453de5367$export$8a00ecf6498ee2fe) in backendState[0, $9ycBx.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $9ycBx.KEY_JSW_ONBOARDING][0, $2b839a8453de5367$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if (updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK) || updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $cblKs.PREMIUM_EDITION)) {
            dispatch((0, $9w2jV.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $9ycBx.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $86LDA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dELL6.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $8hqW7.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $cblKs.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials) {
            const isOnboardingPremiumTrial = await (0, $31GRl.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!(0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name') && !isReverseTrialForJSW && appEditions.software === (0, $cblKs.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $hcEqM.nextSetChecklistIsOpen)(true));
            dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK) : (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK);
            // Go to advanced roadmaps task
            dispatch((0, $jIA25.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $9w2jV.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $6d5N9.pushToBackend)({
                key: (0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
parcelRegister("31GRl", function(module, exports) {
$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $8ddabc55934459cc$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $8ddabc55934459cc$export$ef676f7f369f74fe);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $iCPdV = parcelRequire("iCPdV");
const $8ddabc55934459cc$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $8ddabc55934459cc$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $iCPdV.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $iCPdV.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $3ugTQ.performGetRequestWithRetry)($8ddabc55934459cc$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $iCPdV.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $iCPdV.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        if ((0, $4cTDP.fg)('jira_handle_undefined_reverse_trial_eligibility')) // Return undefined values instead of throwing error when response data is invalid
        return {
            premiumTrialOnSignup: undefined,
            reverseTrialCohort: undefined
        };
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $8ddabc55934459cc$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $8ddabc55934459cc$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("iCPdV", function(module, exports) {
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $880bf1d3001e9a60$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $880bf1d3001e9a60$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $880bf1d3001e9a60$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $880bf1d3001e9a60$export$f389f8ca168b4a3a);

var $3hRxq = parcelRequire("3hRxq");

var $9pTd3 = parcelRequire("9pTd3");
const $880bf1d3001e9a60$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $880bf1d3001e9a60$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $880bf1d3001e9a60$var$localStorage = (0, $3hRxq.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $880bf1d3001e9a60$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $880bf1d3001e9a60$var$localStorage.get($880bf1d3001e9a60$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $880bf1d3001e9a60$export$c3378895d06b5528 = ()=>{
    try {
        const value = $880bf1d3001e9a60$var$localStorage.get($880bf1d3001e9a60$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $880bf1d3001e9a60$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $880bf1d3001e9a60$var$localStorage.set($880bf1d3001e9a60$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $880bf1d3001e9a60$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $880bf1d3001e9a60$var$localStorage.set($880bf1d3001e9a60$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("79a1F", function(module, exports) {
$parcel$export(module.exports, "pollBackend", () => $a820ac7275a95d77$export$8420ef0cee98de);

var $fnu0d = parcelRequire("fnu0d");

var $9ycBx = parcelRequire("9ycBx");
const $a820ac7275a95d77$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $fnu0d.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $9ycBx.PACKAGE_NAME),
            teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("fnu0d", function(module, exports) {
$parcel$export(module.exports, "get", () => $c086e1f54a79cb95$export$3988ae62b71be9a3);

var $5spib = parcelRequire("5spib");

var $4CEkC = parcelRequire("4CEkC");

var $9pTd3 = parcelRequire("9pTd3");

var $dMM78 = parcelRequire("dMM78");

var $3ugTQ = parcelRequire("3ugTQ");

var $2Mqjh = parcelRequire("2Mqjh");

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
let $c086e1f54a79cb95$var$ufoExperiencesMap = {};
const $c086e1f54a79cb95$var$getUfoExperience = (key)=>{
    if (!$c086e1f54a79cb95$var$ufoExperiencesMap[key]) $c086e1f54a79cb95$var$ufoExperiencesMap[key] = new (0, $f39LL.UFOExperience)(key, {
        type: (0, $2lxLk.ExperienceTypes).Operation,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
    });
    return $c086e1f54a79cb95$var$ufoExperiencesMap[key];
};
const $c086e1f54a79cb95$export$c907f169d33b2e25 = ()=>{
    $c086e1f54a79cb95$var$ufoExperiencesMap = {};
};
const $c086e1f54a79cb95$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c086e1f54a79cb95$var$patchProperties = (response, propertiesPath)=>response && (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $c086e1f54a79cb95$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $c086e1f54a79cb95$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $c086e1f54a79cb95$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $3ugTQ.performGetRequest)(url);
        if (response === null) (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $c086e1f54a79cb95$var$patchProperties(response, 'user');
        $c086e1f54a79cb95$var$patchProperties(response, 'instance');
        $c086e1f54a79cb95$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response || {
            user: {},
            instance: {},
            project: {}
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $dMM78.isClientFetchError)(error) && (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("dELL6", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $c95fada5ff0e59fd$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $c95fada5ff0e59fd$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $c95fada5ff0e59fd$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $c95fada5ff0e59fd$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $c95fada5ff0e59fd$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $c95fada5ff0e59fd$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $c95fada5ff0e59fd$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $c95fada5ff0e59fd$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $c95fada5ff0e59fd$export$6c39ca65ca354e59);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");

var $9ycBx = parcelRequire("9ycBx");

var $46NrI = parcelRequire("46NrI");
const $c95fada5ff0e59fd$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $9ycBx.ACTION_SUBJECT_ID), attributes);
};
const $c95fada5ff0e59fd$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $c95fada5ff0e59fd$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $c95fada5ff0e59fd$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $46NrI.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $c95fada5ff0e59fd$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $9pTd3.fireErrorAnalytics)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $c95fada5ff0e59fd$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("46NrI", function(module, exports) {
$parcel$export(module.exports, "getProductType", () => $220645f5a7e2c3df$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $220645f5a7e2c3df$export$3b914201960fa7a6);

var $7mF43 = parcelRequire("7mF43");

var $FhXEJ = parcelRequire("FhXEJ");
const $220645f5a7e2c3df$export$d64a7dd8c7cd80e0 = {
    [(0, $FhXEJ.CORE_PROJECT)]: 'workManagement',
    [(0, $FhXEJ.SOFTWARE_PROJECT)]: 'software',
    [(0, $FhXEJ.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $220645f5a7e2c3df$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $220645f5a7e2c3df$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(projectType);
    return null;
};
const $220645f5a7e2c3df$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(taskId.split('.').pop());
};

});


parcelRegister("8hqW7", function(module, exports) {
$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $53b23fbdedb29316$export$7f2186c37a3d095d);

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $3ugTQ = parcelRequire("3ugTQ");

var $kRgKj = parcelRequire("kRgKj");

var $9ycBx = parcelRequire("9ycBx");

var $cCGZI = parcelRequire("cCGZI");
const $53b23fbdedb29316$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $53b23fbdedb29316$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $53b23fbdedb29316$var$ONE_DAY = 86400000;
const $53b23fbdedb29316$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$53b23fbdedb29316$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $3ugTQ.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $4cTDP.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $9ycBx.PACKAGE_NAME),
                teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $4cTDP.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $53b23fbdedb29316$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $cCGZI.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $53b23fbdedb29316$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $4cTDP.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $53b23fbdedb29316$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $53b23fbdedb29316$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("cCGZI", function(module, exports) {
$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $c5da128a7c764253$export$99f3e48748c2a8c3);

var $8tIrO = parcelRequire("8tIrO");

const $c5da128a7c764253$var$crossProjectBoardTraitSessionProvider = (0, $8tIrO.createSessionExpirableStorageProvider)((0, $70024ada6ee08235$export$fac14ff24e5b1e7a));
const $c5da128a7c764253$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $c5da128a7c764253$var$crossProjectBoardTraitSessionProvider.set((0, $70024ada6ee08235$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$c5da128a7c764253$var$crossProjectBoardTraitSessionProvider.get((0, $70024ada6ee08235$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
parcelRegister("8tIrO", function(module, exports) {
$parcel$export(module.exports, "createSessionStorageProvider", () => $9f9ecbbc5bffe171$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $9f9ecbbc5bffe171$export$e0a2e9a062c6a695);

var $5PQOA = parcelRequire("5PQOA");

var $RkQsc = parcelRequire("RkQsc");

var $3e8kZ = parcelRequire("3e8kZ");
const $9f9ecbbc5bffe171$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, shouldSerialize = true)=>(0, $RkQsc.createStorageProvider)((0, $RkQsc.WebStorageType).SessionStorage, appPrefix, (0, $3e8kZ.makeSessionStore)(), shouldSerialize));
const $9f9ecbbc5bffe171$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $RkQsc.createExpirableStorageProvider)((0, $RkQsc.WebStorageType).SessionStorage, appPrefix, (0, $3e8kZ.makeSessionExpirableStore)());
});

});
parcelRegister("3e8kZ", function(module, exports) {
$parcel$export(module.exports, "makeSessionStore", () => $5176b34eaab5a2a3$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $5176b34eaab5a2a3$export$a8f626c8ded9a06c);

var $fsdQg = parcelRequire("fsdQg");

var $252Bx = parcelRequire("252Bx");

var $02LWr = parcelRequire("02LWr");

var $jZWi5 = parcelRequire("jZWi5");

var $asupr = parcelRequire("asupr");

var $RkQsc = parcelRequire("RkQsc");
const $5176b34eaab5a2a3$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($asupr))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], (0, $RkQsc.plugins));
const $5176b34eaab5a2a3$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($asupr))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
        (0, (/*@__PURE__*/$parcel$interopDefault($252Bx)))
    ]);

});


const $70024ada6ee08235$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("86LDA", function(module, exports) {
$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $d056ac553c2189c1$export$980c26b6f100081d);

var $3ugTQ = parcelRequire("3ugTQ");
const $d056ac553c2189c1$export$980c26b6f100081d = ()=>(0, $3ugTQ.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("uMSsJ", function(module, exports) {
$parcel$export(module.exports, "getNextNonCompleteTask", () => $d41b9686fb79c7bc$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $d41b9686fb79c7bc$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $d41b9686fb79c7bc$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $d41b9686fb79c7bc$export$93d719890ad66653);

var $3hRxq = parcelRequire("3hRxq");

var $gZkaf = parcelRequire("gZkaf");
const $d41b9686fb79c7bc$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $gZkaf.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $d41b9686fb79c7bc$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $gZkaf.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $d41b9686fb79c7bc$var$store = (0, $3hRxq.createLocalStorageProvider)('quickstart');
const $d41b9686fb79c7bc$export$5aa524d86254b4f = (key, value)=>{
    $d41b9686fb79c7bc$var$store.set(key, value);
};
const $d41b9686fb79c7bc$export$93d719890ad66653 = (key)=>$d41b9686fb79c7bc$var$store.get(key);

});
parcelRegister("gZkaf", function(module, exports) {
$parcel$export(module.exports, "getTaskIndex", () => $e5e0a63f9d11b989$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $e5e0a63f9d11b989$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $e5e0a63f9d11b989$export$995248f3b43d8505);

var $46NrI = parcelRequire("46NrI");







const $e5e0a63f9d11b989$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $e5e0a63f9d11b989$export$9711f11998d5795c = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $e5e0a63f9d11b989$export$995248f3b43d8505 = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $e5e0a63f9d11b989$export$293f6b2affa6ea5a = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("1ntUB", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $90c4f819f308a0de$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $90c4f819f308a0de$export$ca9507f266fdd4e4 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED : (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: false
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_DISMISSED),
            value: isDismissed
        });
    };
const $90c4f819f308a0de$var$nextSetChecklistIsDismissedNew = (isDismissed)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED : (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        await (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
    };
const $90c4f819f308a0de$export$f24c05f83b880547 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_kuro-10551_fix_qs_flash'), $90c4f819f308a0de$var$nextSetChecklistIsDismissedNew, $90c4f819f308a0de$export$ca9507f266fdd4e4);

});

parcelRegister("hcEqM", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $4e92599f1808f020$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $4e92599f1808f020$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("jIA25", function(module, exports) {
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $53dc3dee14098ca0$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6d5N9 = parcelRequire("6d5N9");
const $53dc3dee14098ca0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $6d5N9.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("kpUPF", function(module, exports) {
$parcel$export(module.exports, "setNudgeStep", () => $4ac0db746ee3e19c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ac0db746ee3e19c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $4ac0db746ee3e19c$export$2e2bcd8739ae039 = $4ac0db746ee3e19c$export$4debc323813b6997;

});

parcelRegister("b6yo1", function(module, exports) {
$parcel$export(module.exports, "addMountedNudge", () => $a7896299b4c2538c$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $a7896299b4c2538c$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a7896299b4c2538c$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $a7896299b4c2538c$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("iTkHr", function(module, exports) {
$parcel$export(module.exports, "setShouldRenderComponent", () => $9e529cdb63511cc5$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $9e529cdb63511cc5$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $9e529cdb63511cc5$export$2e2bcd8739ae039 = $9e529cdb63511cc5$export$1f9c6770ed938b6e;

});

parcelRegister("VrLd0", function(module, exports) {
$parcel$export(module.exports, "setProjectState", () => $fb6d4843482b7a21$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $fb6d4843482b7a21$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $fb6d4843482b7a21$export$2e2bcd8739ae039 = $fb6d4843482b7a21$export$1ba498e440c0a1e4;

});

parcelRegister("hc2fd", function(module, exports) {
$parcel$export(module.exports, "setHasNudgeActive", () => $655ce5c27a1ef578$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $655ce5c27a1ef578$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $655ce5c27a1ef578$export$2e2bcd8739ae039 = $655ce5c27a1ef578$export$497c281e6eb0786e;

});

parcelRegister("7BMTT", function(module, exports) {
$parcel$export(module.exports, "forceHideNudge", () => $748cd7120d515b8c$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $748cd7120d515b8c$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("27SP3", function(module, exports) {
$parcel$export(module.exports, "setHasEverSeenRoute", () => $8cdbd8bb590a918c$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $8cdbd8bb590a918c$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $8cdbd8bb590a918c$export$2e2bcd8739ae039 = $8cdbd8bb590a918c$export$28e0a4314a1ce52f;

});

parcelRegister("DHvqm", function(module, exports) {
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f78d96b92dcbe1de$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f78d96b92dcbe1de$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f78d96b92dcbe1de$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f78d96b92dcbe1de$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gWAj1", function(module, exports) {
$parcel$export(module.exports, "openNextTask", () => $163de5e21e24ce13$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $uMSsJ = parcelRequire("uMSsJ");

var $4AM50 = parcelRequire("4AM50");
const $163de5e21e24ce13$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $uMSsJ.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $4AM50.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("4AM50", function(module, exports) {
$parcel$export(module.exports, "nextOpenTask", () => $b3d3db0c7001002a$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $b3d3db0c7001002a$export$cc5f3544a6cb2922);


var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $kpUPF = parcelRequire("kpUPF");

var $hc2fd = parcelRequire("hc2fd");
const $b3d3db0c7001002a$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $b3d3db0c7001002a$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($b3d3db0c7001002a$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $hc2fd.setHasNudgeActive)(false, taskId));
        else dispatch((0, $hc2fd.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // @todo: Cleanup for simplify kanban QS productionisation
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $9ycBx.KANBAN_ONBOARDING_TASK)) dispatch((0, $kpUPF.setNudgeStep)((0, $2b839a8453de5367$export$3366ddefe77d5112)));
        else dispatch((0, $kpUPF.setNudgeStep)(''));
    };
const $b3d3db0c7001002a$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($b3d3db0c7001002a$var$openTask(taskId));
        dispatch((0, $hc2fd.setHasNudgeActive)(false, taskId));
        dispatch((0, $kpUPF.setNudgeStep)(''));
    };

});


parcelRegister("4u1bX", function(module, exports) {
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $01d5b170ba597bd8$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $3XHRA = parcelRequire("3XHRA");
const $01d5b170ba597bd8$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("9Zwvs", function(module, exports) {
$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $865d905b5ed9ce34$export$87fe8079a4ed9766);


var $9ycBx = parcelRequire("9ycBx");

var $79a1F = parcelRequire("79a1F");

var $dELL6 = parcelRequire("dELL6");

var $86LDA = parcelRequire("86LDA");

var $1ntUB = parcelRequire("1ntUB");
const $865d905b5ed9ce34$export$87fe8079a4ed9766 = ({ taskList: taskList, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $9ycBx.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $9ycBx.QUICKSTART_TYPE)).map((type)=>(0, $9ycBx.getBackendVisibilityKey)(type));
        const backendState = await (0, $79a1F.pollBackend)({
            keys: [
                (0, $9ycBx.KEY_OPEN),
                (0, $9ycBx.KEY_DISMISSED),
                (0, $9ycBx.KEY_OPEN_TASK),
                (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $9ycBx.KEY_JSW_ONBOARDING),
                ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $9ycBx.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $9ycBx.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $9ycBx.getBackendVisibilityKey)(type)];
                else if ((0, $9ycBx.KEY_DISMISSED) in backendState && backendState[0, $9ycBx.KEY_DISMISSED]) updatedState.visibility[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $9ycBx.KEY_OPEN] ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $9ycBx.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $9ycBx.KEY_DISMISSED];
            if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $9ycBx.KEY_OPEN];
            if ((0, $9ycBx.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $9ycBx.KEY_OPEN_TASK];
            if ((0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $9ycBx.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $9ycBx.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $9ycBx.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $9ycBx.KEY_JSW_ONBOARDING] !== null && (0, $2b839a8453de5367$export$8a00ecf6498ee2fe) in backendState[0, $9ycBx.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $9ycBx.KEY_JSW_ONBOARDING][0, $2b839a8453de5367$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $9ycBx.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $86LDA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dELL6.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("4RIzA", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $d99f03d4977e428c$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $d99f03d4977e428c$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $9ycBx.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("b1NgJ", function(module, exports) {
$parcel$export(module.exports, "nextAutoExpand", () => $940a31066334aca1$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");

var $9ycBx = parcelRequire("9ycBx");

var $5JVW2 = parcelRequire("5JVW2");

var $uMSsJ = parcelRequire("uMSsJ");

var $4AM50 = parcelRequire("4AM50");
const $940a31066334aca1$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $5JVW2.localStorageProvider)().get({
            accountId: (0, $9ycBx.ACCOUNT_ID),
            key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $uMSsJ.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $4cTDP.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $4AM50.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("5JVW2", function(module, exports) {
$parcel$export(module.exports, "localStorageProvider", () => $8f126aa766b95c06$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $8f126aa766b95c06$export$f2666fae743fa5f);

var $9pTd3 = parcelRequire("9pTd3");

var $8tIrO = parcelRequire("8tIrO");

var $9ycBx = parcelRequire("9ycBx");
const $8f126aa766b95c06$var$DAYS_BEFORE_EXPIRY = 1;
const $8f126aa766b95c06$var$DAY = 86400000;
const $8f126aa766b95c06$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $8f126aa766b95c06$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $8f126aa766b95c06$var$DAYS_BEFORE_EXPIRY * $8f126aa766b95c06$var$DAY;
};
let $8f126aa766b95c06$var$localStorage;
const $8f126aa766b95c06$export$aa821bfb3308a1f5 = ()=>{
    if ($8f126aa766b95c06$var$localStorage) return $8f126aa766b95c06$var$localStorage;
    const provider = (0, $8tIrO.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }), value, $8f126aa766b95c06$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }));
    $8f126aa766b95c06$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $8f126aa766b95c06$var$localStorage;
};
const $8f126aa766b95c06$export$f2666fae743fa5f = (value)=>{
    $8f126aa766b95c06$export$aa821bfb3308a1f5().set({
        accountId: (0, $9ycBx.ACCOUNT_ID),
        key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("75ZOj", function(module, exports) {
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $ef47ceb0db6e67e3$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $5JVW2 = parcelRequire("5JVW2");

var $hc2fd = parcelRequire("hc2fd");
const $ef47ceb0db6e67e3$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $9ycBx.ACCOUNT_ID),
            key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $5JVW2.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $hc2fd.setHasNudgeActive)(true));
            (0, $5JVW2.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("4ewzp", function(module, exports) {
$parcel$export(module.exports, "nextGetTasks", () => $58d7175ee2e35561$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");

var $6P4lT = parcelRequire("6P4lT");

var $4AM50 = parcelRequire("4AM50");
const $58d7175ee2e35561$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { taskList: taskList, completedTaskList: completedTaskList, openTask: openTask, isQuickstartLoaded: isQuickstartLoaded } = getState();
        const tasks = (0, $6P4lT.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
        // Auto-open the first incomplete task if no task is currently open
        // Note: nextGetTasks and refreshAppState can in theory happen in any order
        // Only do this if the quickstart is fully loaded (isQuickstartLoaded = true)
        // This ensures backend state has been restored before we auto-open
        if (tasks?.items && tasks.items.length > 0 && isQuickstartLoaded && (0, $4cTDP.fg)('jira-fix-qs-first-card-opening-on-land')) {
            const firstIncompleteTask = tasks.items.find((taskId)=>!completedTaskList.includes(taskId));
            // If we found a first incomplete task and no task is currently open, open it
            if (firstIncompleteTask && !openTask) dispatch((0, $4AM50.nextOpenTask)(firstIncompleteTask));
        }
    };

});
parcelRegister("6P4lT", function(module, exports) {
$parcel$export(module.exports, "getAllTasks", () => $888e4567977ab846$export$d1f442602a91e7cc);

var $9pTd3 = parcelRequire("9pTd3");

var $cxKOj = parcelRequire("cxKOj");

var $lopBx = parcelRequire("lopBx");

var $4cTDP = parcelRequire("4cTDP");


var $cblKs = parcelRequire("cblKs");

var $LFsl3 = parcelRequire("LFsl3");

var $9ycBx = parcelRequire("9ycBx");

var $dt54n = parcelRequire("dt54n");

var $1KmSm = parcelRequire("1KmSm");

var $koyuo = parcelRequire("koyuo");

var $7y7co = parcelRequire("7y7co");

var $8rJAF = parcelRequire("8rJAF");

var $9228c = parcelRequire("9228c");

var $cYgSg = parcelRequire("cYgSg");

var $emLqf = parcelRequire("emLqf");

var $c4gw9 = parcelRequire("c4gw9");

var $eUvg6 = parcelRequire("eUvg6");

var $feWch = parcelRequire("feWch");

var $7A9H8 = parcelRequire("7A9H8");
const $888e4567977ab846$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $7y7co.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $9ycBx.ROOT_TASK) ? (0, $9ycBx.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $9ycBx.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $cYgSg.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $9ycBx.ROOT_TASK];
    return {
        title: title,
        items: (0, $cYgSg.getTasks)(variants, taskVariants, items)
    };
};
const $888e4567977ab846$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $9ycBx.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $2b839a8453de5367$export$3366ddefe77d5112));
    if ((0, $lopBx.isFedRamp)()) variants.add((0, $7y7co.JSW).experience.fedRamp);
    if (premiumTrialOnSignup) {
        variants.add((0, $7y7co.JSW).experiment.jswReverseTrial);
        (0, $cxKOj.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $7y7co.JSW).experiment.rtQuickstartM1);
    }
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $7y7co.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $7y7co.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $7y7co.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $7y7co.JSW).experience.kanbanOnboarding);
    if (canCreateProject === false) variants.add((0, $7y7co.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $7y7co.JSW).projectStyle.teamManaged);
    else variants.add((0, $7y7co.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $7y7co.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $7y7co.JSW).userRole.jiraAdmin);
        variants.add((0, $7y7co.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $7y7co.JSW).userRole.siteAdmin);
        variants.add((0, $7y7co.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $cblKs.FREE_EDITION)) variants.add((0, $7y7co.JSW).edition.free);
    else if (projectState?.edition === (0, $cblKs.STANDARD_EDITION)) variants.add((0, $7y7co.JSW).edition.standard);
    else if (projectState?.edition === (0, $cblKs.PREMIUM_EDITION)) variants.add((0, $7y7co.JSW).edition.premium);
    if ((0, $dt54n.isRoadmapRoute)(routeName)) variants.add((0, $7y7co.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $7y7co.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $7y7co.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $7y7co.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $7y7co.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $7y7co.JSW).route.issue);
    else variants.add((0, $7y7co.JSW).route.softwareCalendar);
    return $888e4567977ab846$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $7y7co.JSW).taskVariants,
        taskList: (0, $7y7co.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $8rJAF.JWM).experiments.projectTheming);
    // No longer reference isEligibleForTailoredOnboardingM2P5 before showing TO cards
    // isEligibleForTailoredOnboardingM2P5 has checks for trello/site admin and team type but these are now built into the config (admin check is removed)
    if ((0, $4cTDP.fg)('to-cleanup-release-business-cards-to-nth-users')) return $888e4567977ab846$export$568bd601466cd235({
        taskGroupParent: taskGroupParent,
        teamType: teamType,
        projectState: projectState,
        taskList: taskList
    });
    // TODO: Remove below logic when cleaning up to-cleanup-release-business-cards-to-nth-users
    // Old JWM config cards can also be removed
    // We have confirmation to remove old cards https://hello.atlassian.net/wiki/spaces/~620663553/pages/5628213263/Quickstart+cards+to+check
    if (isEligibleForTailoredOnboardingM2P5) return $888e4567977ab846$export$e21b96de210942({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $8rJAF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) variants.push((0, $8rJAF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $8rJAF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $8rJAF.JWM).experiments.isSampleProject);
    else variants.push((0, $8rJAF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $8rJAF.JWM).experiments.trelloCrossflow);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $8rJAF.JWM).taskVariants,
        taskList: taskList ?? (0, $8rJAF.JWM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $koyuo.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $koyuo.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) variants.push((0, $koyuo.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $koyuo.JSM).userRole.siteAdmin);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $koyuo.JSM).taskVariants,
        taskList: (0, $koyuo.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createPlanTasks = (taskGroupParent, features)=>{
    const variants = [];
    if (features?.hasPlanDependencies) variants.push((0, $feWch.Feature).hasPlanDependencies);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $9228c.PLAN).taskVariants,
        taskList: (0, $9228c.PLAN).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $feWch.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $feWch.Feature).hasSprint);
    if (features?.hasSummaryPage && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasSummaryPage);
    if (features?.hasRoadmap && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasRoadmap);
    if (features?.hasList && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasList);
    if (features?.hasCalendar && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasCalendar);
    if (features?.hasCode && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasCode);
    if (features?.hasForms && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasForms);
    if (features?.hasPages && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasPages);
    if (!(0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name') && isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
    if ((0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $eUvg6.FeatureGate).removeInitialProjectTemplateName);
    if (teamType && (0, $LFsl3.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name') ? (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants : (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariantsOld,
        taskList: (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $LFsl3.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $c4gw9.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $c4gw9.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$568bd601466cd235 = ({ taskGroupParent: taskGroupParent, teamType: teamType, projectState: projectState, taskList: taskList })=>{
    const variants = [];
    // When cleaning up M2 and consolidating configs, this team type check should just be updated to include MKT & OPS
    if (teamType && (0, $LFsl3.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if (projectState?.isTrelloCrossflow) variants.push((0, $8rJAF.JWM).experiments.trelloCrossflow);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $8rJAF.JWM).userRole.siteAdmin);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $7A9H8.TAILORED_ONBOARDING_BUSINESS_CONFIG),
        // This should be cleaned up when M2 is cleaned up. Currently it's like this because M2 populates taskList via the BE
        // and then the FE uses it here, ideally M2 cards are in the business config following conventions so they don't get extra priority bypassing other stuff in the config
        // For now there is also an extra check here to show the trello task list for Trello Crossflow users over M2 https://atlassian.slack.com/archives/C082QR7B16Z/p1755066367960509?thread_ts=1755064885.015779&cid=C082QR7B16Z
        taskList: !projectState?.isTrelloCrossflow && taskList ? taskList : (0, $c4gw9.TAILORED_ONBOARDING_BUSINESS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: // can edit any plan
canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features, containerType: containerType })=>{
    if (containerType === 'plan' && (0, $4cTDP.fg)('quickstart_onboarding_in_jira_plans')) return $888e4567977ab846$var$createPlanTasks(taskGroupParent, features);
    if ((0, $emLqf.isJwmProject)(projectState)) return $888e4567977ab846$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $emLqf.isJsmProject)(projectState)) return $888e4567977ab846$var$createJsmTasks(projectState, taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (!(0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) {
        if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $888e4567977ab846$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    }
    if ((0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) {
        const tailoredOnboardingTasks = $888e4567977ab846$export$d9d83c8e96505820(taskGroupParent, teamType, features);
        // TODO: Remove length check on cleanup of to-cleanup-remove-initial-project-template-name
        // It is just a safety fallback if tailored onboarding tasks are empty but this should never happen
        if (tailoredOnboardingTasks.items.length > 0) return tailoredOnboardingTasks;
        // TODO: Remove this error on cleanup of to-cleanup-remove-initial-project-template-name
        // This should never happen
        (0, $9pTd3.fireErrorAnalytics)({
            error: new Error('tailored onboarding tasks are empty'),
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $9ycBx.PACKAGE_NAME),
                teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: 'tailored onboarding tasks are empty',
                teamType: teamType,
                hasBacklog: features?.hasBacklog,
                hasSprint: features?.hasSprint,
                hasSummaryPage: features?.hasSummaryPage,
                hasRoadmap: features?.hasRoadmap,
                hasList: features?.hasList,
                hasCalendar: features?.hasCalendar,
                hasCode: features?.hasCode,
                hasForms: features?.hasForms,
                hasPages: features?.hasPages
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $888e4567977ab846$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("LFsl3", function(module, exports) {
$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $2b571464d35dbda4$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $2b571464d35dbda4$export$26c385918d734203);

var $8IjPx = parcelRequire("8IjPx");
const $2b571464d35dbda4$export$b924c0b3ec4d268e = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8IjPx.tailoredTeamTypes).includes(teamType);
};
const $2b571464d35dbda4$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8IjPx.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("8IjPx", function(module, exports) {
$parcel$export(module.exports, "tailoredTeamTypes", () => $568d03b0884f9ed5$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $568d03b0884f9ed5$export$52c5394d6e6cfcf3);

const $568d03b0884f9ed5$export$a1fbb7d965e15a39 = [
    (0, $2b839a8453de5367$export$e5c438b7501b5a24),
    (0, $2b839a8453de5367$export$d7de553940261eba),
    (0, $2b839a8453de5367$export$e4824f74b9879164),
    (0, $2b839a8453de5367$export$4f3cb0844009af52),
    (0, $2b839a8453de5367$export$cbc0e551d91a692d),
    (0, $2b839a8453de5367$export$4f54a09a24fd1d74),
    (0, $2b839a8453de5367$export$79685802e8ff1098),
    (0, $2b839a8453de5367$export$b8b1ac856ba1434b)
];
const $568d03b0884f9ed5$export$52c5394d6e6cfcf3 = [
    (0, $2b839a8453de5367$export$e5c438b7501b5a24),
    (0, $2b839a8453de5367$export$d7de553940261eba),
    (0, $2b839a8453de5367$export$cbc0e551d91a692d),
    (0, $2b839a8453de5367$export$4f54a09a24fd1d74),
    (0, $2b839a8453de5367$export$79685802e8ff1098),
    (0, $2b839a8453de5367$export$b8b1ac856ba1434b)
];

});


parcelRegister("dt54n", function(module, exports) {
$parcel$export(module.exports, "isRoadmapRoute", () => $dbcd2c9ba5e49677$export$d1fa67c1ffb68871);
const $dbcd2c9ba5e49677$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("1KmSm", function(module, exports) {
$parcel$export(module.exports, "USER_ROLE", () => $2ef1b0f2207fd5ce$export$8eeb199b23203523);
const $2ef1b0f2207fd5ce$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("koyuo", function(module, exports) {
$parcel$export(module.exports, "JSM", () => $2c85504c5ef985eb$export$63f289f2da861d35);

var $dmVCq = parcelRequire("dmVCq");
const $2c85504c5ef985eb$export$63f289f2da861d35 = {
    taskList: (0, $dmVCq.JSM_TASK_LIST),
    taskVariants: (0, $dmVCq.JSM_TASK_VARIANTS),
    userRole: (0, $dmVCq.UserRole),
    experiments: (0, $dmVCq.Experiments)
};

});
parcelRegister("dmVCq", function(module, exports) {
$parcel$export(module.exports, "JSM_TASK_LIST", () => $39979c1b128d3c9a$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $39979c1b128d3c9a$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $39979c1b128d3c9a$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $39979c1b128d3c9a$export$5b68aef408c932d9);

var $9ycBx = parcelRequire("9ycBx");

var $8pEHr = parcelRequire("8pEHr");
const $39979c1b128d3c9a$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $8pEHr.messages).rootTitle,
        items: [
            (0, $9ycBx.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $9ycBx.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $9ycBx.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $39979c1b128d3c9a$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $39979c1b128d3c9a$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $39979c1b128d3c9a$export$5b68aef408c932d9 = {
    [(0, $9ycBx.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("8pEHr", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ffaf571352a2cc1d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ffaf571352a2cc1d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("7y7co", function(module, exports) {
$parcel$export(module.exports, "JSW", () => $69137b6bfd6791a4$export$4cfe6e52f2e72a54);

var $eUvg6 = parcelRequire("eUvg6");
const $69137b6bfd6791a4$export$4cfe6e52f2e72a54 = {
    taskList: (0, $eUvg6.TASK_LIST),
    taskVariants: (0, $eUvg6.TASK_VARIANTS),
    experiment: (0, $eUvg6.Experiment),
    experience: (0, $eUvg6.Experience),
    projectStyle: (0, $eUvg6.ProjectStyle),
    userRole: (0, $eUvg6.UserRole),
    edition: (0, $eUvg6.Edition),
    route: (0, $eUvg6.Route),
    permissions: (0, $eUvg6.Permissions),
    trait: (0, $eUvg6.Trait)
};

});
parcelRegister("eUvg6", function(module, exports) {
$parcel$export(module.exports, "FeatureGate", () => $b0c17d2eb7065ae3$export$d4ba9a3e7000cca8);
$parcel$export(module.exports, "Experiment", () => $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $b0c17d2eb7065ae3$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $b0c17d2eb7065ae3$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "UserRole", () => $b0c17d2eb7065ae3$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $b0c17d2eb7065ae3$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $b0c17d2eb7065ae3$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $b0c17d2eb7065ae3$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $b0c17d2eb7065ae3$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $b0c17d2eb7065ae3$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $b0c17d2eb7065ae3$export$36f4d47dfe11b613);

var $9ycBx = parcelRequire("9ycBx");

var $4J9Xs = parcelRequire("4J9Xs");
const $b0c17d2eb7065ae3$export$d4ba9a3e7000cca8 = {
    removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name'
};
const $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $b0c17d2eb7065ae3$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $b0c17d2eb7065ae3$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $b0c17d2eb7065ae3$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $b0c17d2eb7065ae3$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $b0c17d2eb7065ae3$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $b0c17d2eb7065ae3$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $b0c17d2eb7065ae3$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST = [
    (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)
];
const $b0c17d2eb7065ae3$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $4J9Xs.messages).rootTitle,
        items: $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $4J9Xs.messages).reverseTrialRootTitle,
        items: $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST
    },
    [(0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $4J9Xs.messages).reverseTrialCardTitle,
        items: [
            (0, $9ycBx.ADVANCED_ROADMAPS_TASK),
            (0, $9ycBx.CHANGE_CONTROL_TASK),
            (0, $9ycBx.AUTOMATIONS_TASK),
            (0, $9ycBx.SITE_ADMINISTRATIONS_TASK),
            (0, $9ycBx.USER_MANAGEMENT_TASK)
        ]
    }
});
const $b0c17d2eb7065ae3$var$PLAN_ONBOARDING_TASKS = {
    [(0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $b0c17d2eb7065ae3$export$36f4d47dfe11b613 = $b0c17d2eb7065ae3$var$PLAN_ONBOARDING_TASKS;

});
parcelRegister("4J9Xs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3416e8428d224ccf$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3416e8428d224ccf$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("8rJAF", function(module, exports) {
$parcel$export(module.exports, "JWM", () => $77b9f961c5c24ac0$export$3ff26c80cb588e12);

var $4PmHv = parcelRequire("4PmHv");

var $7BHaP = parcelRequire("7BHaP");

var $5ImmZ = parcelRequire("5ImmZ");
const $77b9f961c5c24ac0$export$3ff26c80cb588e12 = {
    taskList: (0, $4PmHv.TASK_LIST),
    taskVariants: (0, $4PmHv.TASK_VARIANTS),
    userRole: (0, $5ImmZ.UserRole),
    experiments: (0, $7BHaP.Experiments)
};

});
parcelRegister("4PmHv", function(module, exports) {
$parcel$export(module.exports, "TASK_LIST", () => $a08aca66351aa30d$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "OPS_TAILORED_ONBOARDING_TASK_VARIANTS", () => $a08aca66351aa30d$export$db06b8e338ba9c65);
$parcel$export(module.exports, "MKT_TAILORED_ONBOARDING_TASK_VARIANTS", () => $a08aca66351aa30d$export$bda7075f98246874);
$parcel$export(module.exports, "TASK_VARIANTS", () => $a08aca66351aa30d$export$36f4d47dfe11b613);

var $9ycBx = parcelRequire("9ycBx");

var $7BHaP = parcelRequire("7BHaP");

var $dj1vQ = parcelRequire("dj1vQ");

var $5ImmZ = parcelRequire("5ImmZ");
const $a08aca66351aa30d$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $dj1vQ.messages).rootTitle,
        items: [
            (0, $9ycBx.JWM_CREATE_PROJECT_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $9ycBx.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $9ycBx.JWM_PROJECT_SUMMARY_TASK),
            (0, $9ycBx.JWM_CALENDAR_TASK),
            (0, $9ycBx.JWM_TIMELINE_TASK),
            (0, $9ycBx.JWM_BUILD_FORM_TASK),
            (0, $9ycBx.JWM_BACKGROUND_COLOR_TASK),
            (0, $9ycBx.JWM_FEEDBACK_TASK),
            (0, $9ycBx.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $9ycBx.JWM_SHARE_PROJECT_TASK),
            (0, $9ycBx.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $a08aca66351aa30d$export$db06b8e338ba9c65 = {
    [(0, $9ycBx.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $9ycBx.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $9ycBx.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $9ycBx.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $9ycBx.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $9ycBx.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $9ycBx.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $a08aca66351aa30d$export$bda7075f98246874 = {
    [(0, $9ycBx.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $9ycBx.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $9ycBx.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $9ycBx.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $9ycBx.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $9ycBx.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $9ycBx.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $9ycBx.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $9ycBx.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $9ycBx.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $a08aca66351aa30d$export$36f4d47dfe11b613 = {
    ...$a08aca66351aa30d$export$db06b8e338ba9c65,
    ...$a08aca66351aa30d$export$bda7075f98246874,
    [(0, $9ycBx.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("7BHaP", function(module, exports) {
$parcel$export(module.exports, "Experiments", () => $57326be2952b3617$export$c8d6ffd15214553a);
const $57326be2952b3617$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("dj1vQ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6ba3f21c8d7d2fe3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6ba3f21c8d7d2fe3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5ImmZ", function(module, exports) {
$parcel$export(module.exports, "UserRole", () => $0235b2ed52c10505$export$eb3485a690c2f0b8);
const $0235b2ed52c10505$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("9228c", function(module, exports) {
$parcel$export(module.exports, "PLAN", () => $aac3014bd1a505bf$export$c303e491e026ebc6);

var $glBlO = parcelRequire("glBlO");
const $aac3014bd1a505bf$export$c303e491e026ebc6 = {
    taskList: (0, $glBlO.PLAN_TASK_LIST),
    taskVariants: (0, $glBlO.PLAN_TASK_VARIANTS)
};

});
parcelRegister("glBlO", function(module, exports) {
$parcel$export(module.exports, "PLAN_TASK_LIST", () => $745411eac178e4e0$export$6ddf1195a65583de);
$parcel$export(module.exports, "PLAN_TASK_VARIANTS", () => $745411eac178e4e0$export$73c2f09f0994be4f);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");

var $ebg0D = parcelRequire("ebg0D");
const $745411eac178e4e0$export$6ddf1195a65583de = Object.freeze({
    root: {
        title: (0, $ebg0D.messages).rootTitle,
        items: [
            (0, $9ycBx.PLAN_CREATE_MORE_WORK_ITEMS_TASK),
            (0, $9ycBx.PLAN_BRING_IN_THE_TEAM_TASK),
            (0, $9ycBx.PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK),
            (0, $9ycBx.PLAN_CONNECT_RELATED_WORK_TASK),
            (0, $9ycBx.PLAN_ADJUST_DETAILS_TASK),
            (0, $9ycBx.PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK)
        ]
    }
});
const $745411eac178e4e0$export$73c2f09f0994be4f = {
    [(0, $9ycBx.PLAN_CREATE_MORE_WORK_ITEMS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.PLAN_BRING_IN_THE_TEAM_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK)]: {
        position: {
            default: 20
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.PLAN_CONNECT_RELATED_WORK_TASK)]: {
        position: {
            default: 30
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasPlanDependencies
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.PLAN_ADJUST_DETAILS_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("feWch", function(module, exports) {
$parcel$export(module.exports, "TeamType", () => $404e322e3706479c$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $404e322e3706479c$export$6e91cf7616333d5);

const $404e322e3706479c$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $2b839a8453de5367$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $2b839a8453de5367$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $2b839a8453de5367$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $2b839a8453de5367$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $2b839a8453de5367$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $2b839a8453de5367$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $2b839a8453de5367$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $2b839a8453de5367$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $404e322e3706479c$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint',
    hasSummaryPage: 'feature.hasSummaryPage',
    hasRoadmap: 'feature.hasRoadmap',
    hasList: 'feature.hasList',
    hasCalendar: 'feature.hasCalendar',
    hasCode: 'feature.hasCode',
    hasForms: 'feature.hasForms',
    hasPages: 'feature.hasPages',
    hasPlanDependencies: 'feature.hasPlanDependencies'
};

});

parcelRegister("ebg0D", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f0fe29c52499f409$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f0fe29c52499f409$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.plan.root-title",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("cYgSg", function(module, exports) {
$parcel$export(module.exports, "getTasks", () => $298a0d20f3b1d08a$export$20b82b4a32771893);

var $iyRnt = parcelRequire("iyRnt");
const $298a0d20f3b1d08a$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $iyRnt.getConditional)(visibility, variants) : true;
const $298a0d20f3b1d08a$var$getTaskPosition = (variants, position)=>(0, $iyRnt.getConditional)(position, variants);
const $298a0d20f3b1d08a$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$298a0d20f3b1d08a$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$298a0d20f3b1d08a$var$getTaskPosition(variants, taskVariants[taskA].position) - $298a0d20f3b1d08a$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("iyRnt", function(module, exports) {
$parcel$export(module.exports, "getConditional", () => $80dfc494f4751e25$export$fe3161cde0106bba);
const $80dfc494f4751e25$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("emLqf", function(module, exports) {
$parcel$export(module.exports, "isJwmProject", () => $99044a2d2d5f79ec$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $99044a2d2d5f79ec$export$a972ed853ed1d469);

var $FhXEJ = parcelRequire("FhXEJ");
const $99044a2d2d5f79ec$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $FhXEJ.CORE_PROJECT);
const $99044a2d2d5f79ec$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);

});

parcelRegister("c4gw9", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $9c945d174f9c912a$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $9c945d174f9c912a$export$eb17ad7838835d2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS", () => $9c945d174f9c912a$export$fe6b8880a507b306);


var $9ycBx = parcelRequire("9ycBx");

var $iKhBT = parcelRequire("iKhBT");

var $8sWUb = parcelRequire("8sWUb");

var $5shRe = parcelRequire("5shRe");

var $a1b8c = parcelRequire("a1b8c");

var $mLM2w = parcelRequire("mLM2w");

var $i5ttL = parcelRequire("i5ttL");

var $e8Fhw = parcelRequire("e8Fhw");

var $fHbA0 = parcelRequire("fHbA0");

var $ifDp7 = parcelRequire("ifDp7");

var $7OyjZ = parcelRequire("7OyjZ");
const $9c945d174f9c912a$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD),
            (0, $9ycBx.TAILORED_ONBOARDING_BACKLOG),
            (0, $9ycBx.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $9c945d174f9c912a$export$83849aa73c0a20db = {
    taskList: $9c945d174f9c912a$export$2757f7b23d120b9b,
    taskVariants: (0, $ifDp7.TAILORED_ONBOARDING_SINGLE_CONFIG),
    // todo: remove this on `to-cleanup-remove-initial-project-template-name` cleanup
    taskVariantsOld: (0, $7OyjZ.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $9c945d174f9c912a$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $9c945d174f9c912a$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $2b839a8453de5367$export$4f54a09a24fd1d74:
            return 0, $5shRe.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $2b839a8453de5367$export$79685802e8ff1098:
            return 0, $8sWUb.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $2b839a8453de5367$export$e5c438b7501b5a24:
            return 0, $a1b8c.DESIGN_VARIANTS;
        case 0, $2b839a8453de5367$export$d7de553940261eba:
            return 0, $mLM2w.IT_SUPPORT_VARIANTS;
        case 0, $2b839a8453de5367$export$cbc0e551d91a692d:
            return 0, $i5ttL.OTHER_PERSONAL_VARIANTS;
        case 0, $2b839a8453de5367$export$b8b1ac856ba1434b:
            return 0, $fHbA0.SOFTWARE_VARIANTS;
        default:
            return 0, $e8Fhw.EVERYTHING_ELSE_VARIANTS;
    }
};
const $9c945d174f9c912a$export$cb2285c4be67df48 = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            // JWM Trello Crossflow Tasks
            (0, $9ycBx.JWM_CREATE_PROJECT_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $9ycBx.JWM_BUILD_FORM_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            // JSW Tailored Onboarding Tasks
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE)
        ]
    }
});
const $9c945d174f9c912a$export$eb17ad7838835d2a = {
    taskList: $9c945d174f9c912a$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $9c945d174f9c912a$export$3c409334669aec75
};
const $9c945d174f9c912a$export$fe6b8880a507b306 = {
    taskList: $9c945d174f9c912a$export$cb2285c4be67df48
};

});
parcelRegister("iKhBT", function(module, exports) {
$parcel$export(module.exports, "messages", () => $47efb1049993f4e6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $47efb1049993f4e6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("8sWUb", function(module, exports) {
$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $d1467d7397e68eff$export$bdd338c80f8962df);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $d1467d7397e68eff$export$bdd338c80f8962df = {
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("5shRe", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $443b90c91e3360e2$export$b07ea6a2d29f9c08);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $443b90c91e3360e2$export$b07ea6a2d29f9c08 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("a1b8c", function(module, exports) {
$parcel$export(module.exports, "DESIGN_VARIANTS", () => $4acbe4cfde2344f9$export$a3c4cd8e420f13a);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $4acbe4cfde2344f9$export$a3c4cd8e420f13a = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("mLM2w", function(module, exports) {
$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $cf156d50ed1f640d$export$a25e809b52945082);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $cf156d50ed1f640d$export$a25e809b52945082 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("i5ttL", function(module, exports) {
$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $120d7baa5e5f9d4d$export$916be3c140ae8c0);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $120d7baa5e5f9d4d$export$916be3c140ae8c0 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("e8Fhw", function(module, exports) {
$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $7c6363b0cc97119f$export$7a0daeb069f34de3);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $7c6363b0cc97119f$export$7a0daeb069f34de3 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("fHbA0", function(module, exports) {
$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $9fc06aa003a906e0$export$76a143792cc73994);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $9fc06aa003a906e0$export$76a143792cc73994 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("ifDp7", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $e8b95d7a0e5bd991$export$64855550cee11b78);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $e8b95d7a0e5bd991$export$64855550cee11b78 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasList
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasCode
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("7OyjZ", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $a2f5344c5d0d5ba3$export$64855550cee11b78);

var $9ycBx = parcelRequire("9ycBx");

var $eUvg6 = parcelRequire("eUvg6");

var $feWch = parcelRequire("feWch");
const $a2f5344c5d0d5ba3$export$64855550cee11b78 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("7A9H8", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS_CONFIG", () => $e3c54a7acd454a57$export$474323a35aa36586);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");

var $7BHaP = parcelRequire("7BHaP");

var $5ImmZ = parcelRequire("5ImmZ");

var $4PmHv = parcelRequire("4PmHv");
const $e3c54a7acd454a57$export$474323a35aa36586 = {
    ...(0, $4PmHv.OPS_TAILORED_ONBOARDING_TASK_VARIANTS),
    ...(0, $4PmHv.MKT_TAILORED_ONBOARDING_TASK_VARIANTS),
    // Trello Crossflow Cards - These take priority when trelloCrossflow experiment is active
    [(0, $9ycBx.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    // Regular Tailored Onboarding Cards - These are hidden when trelloCrossflow is active
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});



parcelRegister("STfOf", function(module, exports) {
$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f389d77cde532ebe$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $f389d77cde532ebe$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $uMSsJ.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("6wCHd", function(module, exports) {
$parcel$export(module.exports, "universalDispatch", () => $2ed3eacefc81a47a$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2ed3eacefc81a47a$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});

parcelRegister("d8p4f", function(module, exports) {
$parcel$export(module.exports, "setContainerType", () => $5430da7673e540d1$export$24889c6c4e904da4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $5430da7673e540d1$export$24889c6c4e904da4 = (containerType)=>({ getState: getState, setState: setState })=>{
        const { containerType: currentContainerType } = getState();
        if (containerType === currentContainerType) // if state has not been updated we just return
        return;
        setState({
            containerType: containerType
        });
    };
var $5430da7673e540d1$export$2e2bcd8739ae039 = $5430da7673e540d1$export$24889c6c4e904da4;

});

parcelRegister("8n02n", function(module, exports) {
$parcel$export(module.exports, "setQuickstartButtonRef", () => $106f18c55aeeccf9$export$8119a14b79738a24);
$parcel$export(module.exports, "setIsOpenedViaButton", () => $106f18c55aeeccf9$export$8b7fa399fb8c07f);
$parcel$export(module.exports, "focusQuickstartButton", () => $106f18c55aeeccf9$export$8f1aa3f8d2941465);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $106f18c55aeeccf9$export$8119a14b79738a24 = (quickstartButtonRef)=>({ setState: setState })=>{
        setState({
            quickstartButtonRef: quickstartButtonRef
        });
    };
const $106f18c55aeeccf9$export$8b7fa399fb8c07f = (isOpenedViaButton)=>({ setState: setState })=>{
        setState({
            isOpenedViaButton: isOpenedViaButton
        });
    };
// Since the button is visible after 220ms and requestAnimationFrame is called 60 times per second,
// to be safe we can wait for 15 frames (220/1000 * 60)
const $106f18c55aeeccf9$var$MAX_FOCUS_RETRIES = 15;
const $106f18c55aeeccf9$export$8f1aa3f8d2941465 = ()=>({ setState: setState, getState: getState })=>{
        let retryCount = 0;
        const tryFocus = ()=>{
            const { quickstartButtonRef: quickstartButtonRef, isOpenedViaButton: isOpenedViaButton } = getState();
            if (quickstartButtonRef && isOpenedViaButton) {
                quickstartButtonRef.focus({
                    preventScroll: true
                });
                setState({
                    isOpenedViaButton: false
                });
            } else if (!quickstartButtonRef && retryCount < $106f18c55aeeccf9$var$MAX_FOCUS_RETRIES) {
                // If ref not available yet due to button animation delay, try again
                retryCount++;
                requestAnimationFrame(tryFocus);
            }
        };
        // Uses requestAnimationFrame to wait until the ref is available
        requestAnimationFrame(tryFocus);
    };

});


parcelRegister("6R6zv", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $59fafcb385977eac$export$d4c72bab9d6cc13a);

var $9ycBx = parcelRequire("9ycBx");
const $59fafcb385977eac$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $9ycBx.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $9ycBx.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $9ycBx.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED
    },
    quickstartButtonRef: null,
    isOpenedViaButton: false
};

});


const $44259bc988b99eaa$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $44259bc988b99eaa$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $44259bc988b99eaa$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $44259bc988b99eaa$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $44259bc988b99eaa$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $44259bc988b99eaa$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $44259bc988b99eaa$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $44259bc988b99eaa$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $44259bc988b99eaa$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $44259bc988b99eaa$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $44259bc988b99eaa$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $44259bc988b99eaa$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $44259bc988b99eaa$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $44259bc988b99eaa$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $44259bc988b99eaa$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $44259bc988b99eaa$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $44259bc988b99eaa$export$f8bf435a6066832c = 'button clicked';
const $44259bc988b99eaa$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $44259bc988b99eaa$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $44259bc988b99eaa$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $44259bc988b99eaa$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $44259bc988b99eaa$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $44259bc988b99eaa$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $44259bc988b99eaa$export$5908fa8acd2c0739 = 'filterListNudge';
const $44259bc988b99eaa$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $44259bc988b99eaa$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $44259bc988b99eaa$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $44259bc988b99eaa$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $44259bc988b99eaa$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $44259bc988b99eaa$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $44259bc988b99eaa$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $44259bc988b99eaa$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $44259bc988b99eaa$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $44259bc988b99eaa$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $44259bc988b99eaa$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $44259bc988b99eaa$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $44259bc988b99eaa$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $44259bc988b99eaa$export$a1be34032ee24f78 = 'shareProjectNudge';
const $44259bc988b99eaa$export$29fe6611cc093756 = 'summaryTabNudge';
const $44259bc988b99eaa$export$f107c06c0830f09d = 'reportsTabNudge';
const $44259bc988b99eaa$export$9749a972a54ad7ba = 'boardContainerNudge';
const $44259bc988b99eaa$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$b7fd448c62b5fb97 = 'listview';
const $44259bc988b99eaa$export$10c63dc5c09466d2 = 'boardview';
const $44259bc988b99eaa$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $44259bc988b99eaa$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $44259bc988b99eaa$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $44259bc988b99eaa$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $44259bc988b99eaa$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $44259bc988b99eaa$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $44259bc988b99eaa$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $44259bc988b99eaa$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $44259bc988b99eaa$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $44259bc988b99eaa$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $44259bc988b99eaa$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $44259bc988b99eaa$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("45qbN", function(module, exports) {
$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $59baba99bbabf31e$export$ff76bc343b4103b1);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $59baba99bbabf31e$export$ff76bc343b4103b1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("aSwNt")), {
        moduleId: "4ca4d8af",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aSwNt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iyrSY").then(()=>parcelRequire('FRRBu'));

});



parcelRegister("8x4C2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ddbbaeea9c744c6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5ddbbaeea9c744c6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    teams: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.teams",
        "defaultMessage": "Teams"
    },
    invitePeople: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.invite-people",
        "defaultMessage": "Invite people"
    },
    createTeam: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.create-team",
        "defaultMessage": "Create a team"
    },
    createOrInvite: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.create-or-invite",
        "defaultMessage": "Create or invite"
    }
});

});



const $31028703e58eb566$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GlobalAppShortcuts';
const $31028703e58eb566$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("mIeXW", function(module, exports) {
$parcel$export(module.exports, "ConfigurableMenuItem", () => $16fb26002390f463$export$5de02966decf8405);

var $7X4e3 = parcelRequire("7X4e3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $8IuE5 = parcelRequire("8IuE5");

var $41vqi = parcelRequire("41vqi");

var $2wp9U = parcelRequire("2wp9U");

var $4P1EM = parcelRequire("4P1EM");

var $7u7ku = parcelRequire("7u7ku");

var $jUiJS = parcelRequire("jUiJS");

var $gk3Hc = parcelRequire("gk3Hc");

var $5n5Xi = parcelRequire("5n5Xi");

var $49MXG = parcelRequire("49MXG");

var $eJYI8 = parcelRequire("eJYI8");

var $iPxs6 = parcelRequire("iPxs6");

var $2geah = parcelRequire("2geah");

var $cRvJm = parcelRequire("cRvJm");

var $cRLIL = parcelRequire("cRLIL");

var $iFx8E = parcelRequire("iFx8E");

var $g0Ue2 = parcelRequire("g0Ue2");

var $i8N06 = parcelRequire("i8N06");

var $a62R3 = parcelRequire("a62R3");

var $753q2 = parcelRequire("753q2");
const $16fb26002390f463$export$5de02966decf8405 = /*#__PURE__*/ (0, $eJOHy.memo)($16fb26002390f463$var$ConfigurableMenuItemInner);
function $16fb26002390f463$var$ConfigurableMenuItemInner({ isDefaultOpen: isDefaultOpen = false, menuData: menuData, menuId: menuId }) {
    const data = (0, $j4oe4.useFragment)((0, $7X4e3.default), menuData);
    const shouldRenderOverviews = (0, $eJYI8.useShouldRenderOverviews)();
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wp9U.Nav4Apps), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            /* remove this case on
       * assets_as_an_app_v2 cleanup &&
       */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4P1EM.Nav4Assets), {
                isExpanded: isDefaultOpen
            });
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gk3Hc.Nav4Dashboards), {
                isExpanded: isDefaultOpen
            });
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5n5Xi.Nav4Filters), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $753q2.Stub), {
                menuId: (0, $8IuE5.L1_MENU_ID).GOALS,
                href: USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GOALS]
            });
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $49MXG.Nav4Operations), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2geah.Nav4Plans), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return shouldRenderOverviews ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iPxs6.Nav4Overviews), {
                isExpanded: isDefaultOpen,
                queryRef: data
            }) : null;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRvJm.Nav4Projects), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).RECENT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRLIL.Recent), null);
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iFx8E.Nav4Roadmaps), {
                isExpanded: isDefaultOpen
            });
        case (0, $8IuE5.L1_MENU_ID).STARRED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g0Ue2.Starred), null);
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return !(0, $a62R3.isTeamsAppEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8N06.Teams), null) : null;
        case (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE:
            return (0, $4cTDP.fg)('jcs_master_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7u7ku.CustomerService), null) : null;
        case (0, $8IuE5.L1_MENU_ID).CUSTOMERS:
            return (0, $4cTDP.fg)('berry-6285-customers-l1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUiJS.Customers), null) : null;
        default:
            return null;
    }
}

});
parcelRegister("7X4e3", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3da5f33e4d22ad2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<237b885497b658573d984371ca06695a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3da5f33e4d22ad2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfigurableMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Projects"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Filters"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Plans"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Apps"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Operations"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Overviews"
        }
    ],
    "type": "Query"
};
$f3da5f33e4d22ad2$var$node.hash = "5c4da86f47569a65309ccf227624f58f";
var $f3da5f33e4d22ad2$export$2e2bcd8739ae039 = $f3da5f33e4d22ad2$var$node;

});

parcelRegister("2wp9U", function(module, exports) {
$parcel$export(module.exports, "Nav4Apps", () => $fbaf54bbcaffccb8$export$8473036ee9e92881);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $eYuVr = parcelRequire("eYuVr");

var $4EKqI = parcelRequire("4EKqI");


var $669uo = parcelRequire("669uo");
const $fbaf54bbcaffccb8$export$8473036ee9e92881 = (props)=>{
    const getAttributes = (0, $eJOHy.useCallback)((error)=>(0, $669uo.createAttributes)({
            error: error,
            component: 'Nav4Apps'
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-apps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "apps-section",
        attributes: getAttributes,
        packageName: (0, $a9b3358f09bdf564$export$b8b9d90f9e5bd72b),
        teamName: (0, $a9b3358f09bdf564$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eYuVr.Nav4Apps), props)));
};

});
parcelRegister("eYuVr", function(module, exports) {
$parcel$export(module.exports, "Nav4Apps", () => $2fefbbb2634a89d7$export$8473036ee9e92881);

var $4LpT6 = parcelRequire("4LpT6");

var $gFCSI = parcelRequire("gFCSI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $8y6Xv = parcelRequire("8y6Xv");

var $2LOiu = parcelRequire("2LOiu");

var $hAiyG = parcelRequire("hAiyG");

var $dDuGq = parcelRequire("dDuGq");

var $7adq7 = parcelRequire("7adq7");

var $6HiqT = parcelRequire("6HiqT");
function $2fefbbb2634a89d7$export$8473036ee9e92881(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6HiqT.Nav4AppsSpotlightWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fefbbb2634a89d7$var$Nav4AppsInner, props));
}
function $2fefbbb2634a89d7$var$Nav4AppsInner({ isExpanded: isExpanded, queryRef: queryRef }) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const data = (0, $j4oe4.useFragment)((0, $gFCSI.default), queryRef);
    /* eslint-disable @atlassian/relay/unused-fields */ const globalAppNavigationItems = (0, $j4oe4.useFragment)((0, $4LpT6.default), data.jira);
    /* eslint-enable @atlassian/relay/unused-fields */ // $isAppsExpanded (in the query) is based on the same logic as in isInitialSelectedPath(MENU_ID_APPS).
    // However, below we filter out false positives based on extra data we retrieve from GraphQL.
    // We simply can't determine whether the general Connect app is a part of the "Apps" section or not without that extra data.
    // And we would like to avoid situations where the "Apps" section is expanded when it shouldn't be.
    // Keep in mind that global Connect app != general Connect app. Global app is a subset of the general app.
    // General app can be rendered in various contexts, while the global one only under the "Apps" section.
    const isMaybeAppsSectionRoute = isInitialSelectedPath((0, $h4Bzb.MENU_ID_APPS));
    const isGeneralConnectRoute = (0, $8y6Xv.useIsGeneralConnectRoute)();
    const isGlobalConnectAppRoute = (0, $hAiyG.useIsGlobalConnectAppRoute)({
        data: globalAppNavigationItems
    });
    const isAppsSectionExpanded = isMaybeAppsSectionRoute && (isGeneralConnectRoute ? isGlobalConnectAppRoute : true);
    const sectionActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2LOiu.SectionActions), null);
    return isAppsSectionExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7adq7.Nav4AppsForLanding), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded,
        queryRef: data.jira
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dDuGq.Nav4AppsDefault), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded
    });
}

});
parcelRegister("4LpT6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a821507588a0da1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b841eae00c140d0fa10ac87feab52bf9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a821507588a0da1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isAppsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Apps_GlobalAppsFragment",
        "selections": [
            {
                "condition": "isAppsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "globalAppNavigationItems",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraNavigationItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appType"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraAppSection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                "kind": "LinkedField",
                                                                "name": "links",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraAppNavigationItem"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$7a821507588a0da1$var$node.hash = "fcee4331eb5ce6a0f2c7ee593634458d";
var $7a821507588a0da1$export$2e2bcd8739ae039 = $7a821507588a0da1$var$node;

});

parcelRegister("gFCSI", function(module, exports) {
$parcel$export(module.exports, "default", () => $640d0996091eb87b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf10716a4c00972068007e73ef5b1c3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $640d0996091eb87b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isAppsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Apps",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isAppsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsForLanding"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4Apps_GlobalAppsFragment"
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$640d0996091eb87b$var$node.hash = "c3df504da3663fd99ebe67a0d32de67f";
var $640d0996091eb87b$export$2e2bcd8739ae039 = $640d0996091eb87b$var$node;

});

parcelRegister("8y6Xv", function(module, exports) {
$parcel$export(module.exports, "useIsGeneralConnectRoute", () => $d961b38f2598891f$export$db179b21b0be87a1);

var $QaFzq = parcelRequire("QaFzq");
const $d961b38f2598891f$var$GENERAL_CONNECT_ROUTES = new Set([
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'connect-general-service-desk-project'
]);
const $d961b38f2598891f$var$UNCERTAIN_APPS_SECTION_ROUTES = $d961b38f2598891f$var$GENERAL_CONNECT_ROUTES;
const $d961b38f2598891f$var$CERTAIN_APPS_SECTION_ROUTES = new Set([
    'forge-spa-global',
    'marketplace-index'
]);
const $d961b38f2598891f$export$22e210b2ba662e30 = new Set([
    ...$d961b38f2598891f$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$d961b38f2598891f$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $d961b38f2598891f$export$db179b21b0be87a1() {
    const route = (0, $QaFzq.useRoute)();
    return $d961b38f2598891f$var$GENERAL_CONNECT_ROUTES.has(route.name);
}

});
parcelRegister("QaFzq", function(module, exports) {
$parcel$export(module.exports, "useRoute", () => $57ba212b9ebdebd8$export$3f79f0b98112cf57);

var $kfvK2 = parcelRequire("kfvK2");
const $57ba212b9ebdebd8$export$3f79f0b98112cf57 = (0, $kfvK2.createRouterSelector)((state)=>state.route);

});


parcelRegister("2LOiu", function(module, exports) {
$parcel$export(module.exports, "SectionActions", () => $9b4eb16222e1d46d$export$51f8029abf8c56ce);

var $eJOHy = parcelRequire("eJOHy");

var $kcLaf = parcelRequire("kcLaf");

var $4F5bb = parcelRequire("4F5bb");

var $f58rc = parcelRequire("f58rc");
var $6YEko = parcelRequire("6YEko");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $8RHPx = parcelRequire("8RHPx");



var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $6naEG = parcelRequire("6naEG");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $2Clab = parcelRequire("2Clab");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $koAZ4 = parcelRequire("koAZ4");

var $fwwjt = parcelRequire("fwwjt");
function $9b4eb16222e1d46d$export$51f8029abf8c56ce({ onClose: onClose }) {
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const showManageApps = isAdmin || isSiteAdmin;
    const showAppAuditLogs = (0, $4cTDP.fg)('show_app_audit_logs_upm_dep') && (isAdmin || isSiteAdmin);
    const showViewAppRequests = (0, $cxKOj.expVal)('enduser-emcee-discover', 'value', true) && isSiteAdmin;
    const fireOpenEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b4eb16222e1d46d$var$MoreMenuItems, {
                showManageApps: showManageApps,
                showViewAppRequests: showViewAppRequests,
                showAppAuditLogs: showAppAuditLogs,
                ...props
            }),
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}
function $9b4eb16222e1d46d$var$MoreMenuItems({ onClose: onClose, showManageApps: showManageApps, showViewAppRequests: showViewAppRequests, showAppAuditLogs: showAppAuditLogs }) {
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { cloudId: cloudId } = tenantContext;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const adminHubAppRequestsUrl = `https://${(0, $8RHPx.getATLContextDomain)('admin')}/s/${cloudId}/user-connected-apps/tab/requested`;
    const viewAppRequestsLink = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('should_redirect_to_admin-hub_for_app_requests') ? adminHubAppRequestsUrl : (0, $2Clab.getAppRequestsLink)(), [
        adminHubAppRequestsUrl
    ]);
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)(onClose);
    const showTopSection = showManageApps || showViewAppRequests;
    const fireClickEvent = (0, $eJOHy.useCallback)((itemId)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$74712b62056d422e),
                itemId: itemId,
                parentItemId: (0, $a9aec.SECTION_ITEM_APPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showTopSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, showManageApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/plugins/servlet/upm",
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('manageApps');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage((0, $fwwjt.default).manageApps)), showAppAuditLogs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/plugins/servlet/upm/log",
        onClick: (...args)=>{
            onCloseWithStopPropagation(...args);
        },
        target: "_blank"
    }, formatMessage((0, $fwwjt.default).appAuditLogs)), showViewAppRequests && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: viewAppRequestsLink,
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('viewAppRequests');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage((0, $fwwjt.default).viewAppRequests))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).APPS,
        hasSeparator: showTopSection
    }));
}

});
parcelRegister("kcLaf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc410b5a6f105623fd92b95efc5298a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb5983796d13f8e5$var$_react = $eb5983796d13f8e5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $eb5983796d13f8e5$var$_baseNew = $eb5983796d13f8e5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $eb5983796d13f8e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb5983796d13f8e5$var$AppIcon = (props)=>/*#__PURE__*/ $eb5983796d13f8e5$var$_react.default.createElement($eb5983796d13f8e5$var$_baseNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$eb5983796d13f8e5$var$AppIcon.displayName = 'AppIcon';
var $eb5983796d13f8e5$var$_default = module.exports.default = $eb5983796d13f8e5$var$AppIcon;

});

parcelRegister("6naEG", function(module, exports) {
$parcel$export(module.exports, "useStopPropagation", () => $021cd548567896d7$export$f7bb512e68bcecd9);

var $eJOHy = parcelRequire("eJOHy");
const $021cd548567896d7$export$f7bb512e68bcecd9 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
onEvent)=>(0, $eJOHy.useCallback)((e, ...args)=>{
        try {
            onEvent?.(e, ...args);
        } finally{
            e?.stopPropagation();
        }
    }, [
        onEvent
    ]);

});

parcelRegister("2Clab", function(module, exports) {
$parcel$export(module.exports, "getEmceeDiscoverLink", () => $04a896ce17590d9a$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $04a896ce17590d9a$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $04a896ce17590d9a$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $04a896ce17590d9a$export$350ca33eed6a2742);
const $04a896ce17590d9a$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $04a896ce17590d9a$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $04a896ce17590d9a$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $04a896ce17590d9a$export$f26dabf284aefb17 = (params)=>{
    const link = '/jira/marketplace/discover';
    return $04a896ce17590d9a$var$addQueryParamsToLink(params, link);
};
const $04a896ce17590d9a$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams)=>$04a896ce17590d9a$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`);
const $04a896ce17590d9a$export$7ab8c48f9081e976 = (params)=>{
    const link = '/jira/marketplace/manage/app-requests';
    return $04a896ce17590d9a$var$addQueryParamsToLink(params, link);
};
const $04a896ce17590d9a$export$350ca33eed6a2742 = (params)=>{
    const link = '/jira/marketplace/manage/promotions';
    return $04a896ce17590d9a$var$addQueryParamsToLink(params, link);
};

});

parcelRegister("fwwjt", function(module, exports) {
$parcel$export(module.exports, "default", () => $681b6aa609615fc4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $681b6aa609615fc4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    manageApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.manage-apps",
        "defaultMessage": "Manage apps"
    },
    appAuditLogs: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.app-audit-logs",
        "defaultMessage": "App audit logs"
    },
    viewAppRequests: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.view-app-requests",
        "defaultMessage": "View app requests"
    }
});

});


parcelRegister("hAiyG", function(module, exports) {
$parcel$export(module.exports, "useIsGlobalConnectAppRoute", () => $83ce8240ea1dfa36$export$32897ea1251cd6aa);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $8xDPn = parcelRequire("8xDPn");

var $jRu18 = parcelRequire("jRu18");

var $eYtNM = parcelRequire("eYtNM");

var $jJqSP = parcelRequire("jJqSP");
const $83ce8240ea1dfa36$export$32897ea1251cd6aa = ({ data: data })=>{
    const location = (0, $jRu18.useLocation)();
    const query = (0, $eYtNM.useQuery)();
    const locations = (0, $eJOHy.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>edge?.node?.appType === 'CONNECT').flatMap((edge)=>(edge?.node && (0, $jJqSP.canHaveSubpages)(edge?.node) && edge?.node?.sections || [
                {
                    links: [
                        {
                            url: edge?.node?.url
                        }
                    ]
                }
            ]).flatMap((section)=>(section?.links || []).map((link)=>(0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(link?.url || '/', true)))), [
        data
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        const matcher = (0, $8xDPn.matchUrlExact)();
        const currentLocation = {
            ...location,
            query: query
        };
        // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
        return locations.some((loc)=>matcher(currentLocation, loc));
    }, [
        locations,
        location,
        query
    ]);
};

});
parcelRegister("8xDPn", function(module, exports) {
$parcel$export(module.exports, "matchPathname", () => $d5c7bfee55dffd85$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $d5c7bfee55dffd85$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $d5c7bfee55dffd85$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $d5c7bfee55dffd85$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $d5c7bfee55dffd85$export$63fdecce99465869);

var $ee5Jg = parcelRequire("ee5Jg");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $d5c7bfee55dffd85$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $d5c7bfee55dffd85$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$d5c7bfee55dffd85$var$cleanPath(currentUrlPath) === $d5c7bfee55dffd85$var$cleanPath(itemUrlPath);
const $d5c7bfee55dffd85$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$d5c7bfee55dffd85$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $d5c7bfee55dffd85$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $d5c7bfee55dffd85$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$d5c7bfee55dffd85$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($ee5Jg)))(currentLocation.query, itemLocation.query);
const $d5c7bfee55dffd85$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $d5c7bfee55dffd85$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("jRu18", function(module, exports) {
$parcel$export(module.exports, "useLocation", () => $a841cad6e309fab1$export$45d76561a5302f2b);

var $kfvK2 = parcelRequire("kfvK2");
const $a841cad6e309fab1$export$45d76561a5302f2b = (0, $kfvK2.createRouterSelector)((state)=>state.location);

});

parcelRegister("eYtNM", function(module, exports) {
$parcel$export(module.exports, "useQuery", () => $841534f2cec37f8c$export$dd0a697e1782aedd);

var $kfvK2 = parcelRequire("kfvK2");
const $841534f2cec37f8c$export$dd0a697e1782aedd = (0, $kfvK2.createRouterSelector)((state)=>state.query);

});

parcelRegister("jJqSP", function(module, exports) {
$parcel$export(module.exports, "canHaveSubpages", () => $e87c0b6415eacf4c$export$352a285d5cb56873);
/**
 * The magic is copied from jira/src/packages/navigation-apps/sidebar/connect/src/common/utils/find-item-stack/index.tsx
 * No clue what that `s` query param stands for, just keeping the link comparison logic 1:1 to avoid regressions.
 */ 
var $cSmYj = parcelRequire("cSmYj");
// JSPA-1062 remove qs items that might not always be there
const $e87c0b6415eacf4c$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $e87c0b6415eacf4c$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $e87c0b6415eacf4c$var$parseUrl = (url = '')=>{
    const [pathname, qs = ''] = url.split('#')[0].split('?');
    return {
        pathname: pathname,
        query: $e87c0b6415eacf4c$var$splitRelevantQs(qs)
    };
};
function $e87c0b6415eacf4c$export$352a285d5cb56873(data) {
    const sections = data.sections || [];
    const { pathname: rootPagePathname, query: rootPageQuery } = $e87c0b6415eacf4c$var$parseUrl(data.url || '');
    for (const section of sections){
        if ((section?.links || []).some((link)=>{
            const { pathname: pathname, query: query } = $e87c0b6415eacf4c$var$parseUrl(link?.url || '');
            return rootPagePathname === pathname && $e87c0b6415eacf4c$var$isSameQuery(rootPageQuery, query);
        })) return true;
    }
    return false;
}

});


parcelRegister("dDuGq", function(module, exports) {
$parcel$export(module.exports, "Nav4AppsDefault", () => $87eab69501cb8c56$export$3732a771b6ecd66d);

var $eJOHy = parcelRequire("eJOHy");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");


var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $80rA3 = parcelRequire("80rA3");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cHtIB = parcelRequire("cHtIB");

var $hHXEn = parcelRequire("hHXEn");


var $669uo = parcelRequire("669uo");

var $cjf2i = parcelRequire("cjf2i");
function $87eab69501cb8c56$export$3732a771b6ecd66d(props) {
    const { actionsOnHover: actionsOnHover, simulateLoading: simulateLoading = false, isExpanded: isExpanded = simulateLoading } = props;
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $cjf2i.asyncNav4AppsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).APPS);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const getAttributes = (0, $eJOHy.useCallback)((error)=>(0, $669uo.createAttributes)({
            error: error,
            component: 'Nav4AppsDefault'
        }), []);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_APPS);
    const onSystemToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).APPS);
            (0, $kRgKj.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        entryPointActions,
        moreMenuIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: onSystemToggle,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-apps-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-apps-default",
        errorAttributes: getAttributes,
        packageName: (0, $a9b3358f09bdf564$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $a9b3358f09bdf564$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hHXEn.ExploreMoreApps), null)));
}

});
parcelRegister("7Z9EK", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemContent", () => $b0b0a6a7ad4d5986$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $1CMu6 = parcelRequire("1CMu6");

var $yFG6a = parcelRequire("yFG6a");
const $b0b0a6a7ad4d5986$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $b0b0a6a7ad4d5986$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $yFG6a.useIsExpanded)();
    const level = (0, $yFG6a.useLevel)();
    const hasExpanded = (0, $eJOHy.useRef)(false);
    const areAllAncestorsExpanded = (0, $yFG6a.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1CMu6.List), {
                ref: forwardedRef,
                xcss: (0, $k0ahr.cx)($b0b0a6a7ad4d5986$var$styles.content, !isExpanded && $b0b0a6a7ad4d5986$var$styles.collapsedContent),
                children: children
            })
        })
    });
});

});

parcelRegister("fFq5m", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $be2c8cebc5d88fe6$export$fe6fe51056867f4d);
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $1OQKp = parcelRequire("1OQKp");

var $cQxBL = parcelRequire("cQxBL");

var $2tKAE = parcelRequire("2tKAE");

var $eekOJ = parcelRequire("eekOJ");

var $yFG6a = parcelRequire("yFG6a");
// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
const $be2c8cebc5d88fe6$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $be2c8cebc5d88fe6$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $be2c8cebc5d88fe6$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $be2c8cebc5d88fe6$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syaz1qo3"
};
const $be2c8cebc5d88fe6$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))) : (0, (/*@__PURE__*/$parcel$interopDefault($cQxBL)));
    const chevronElem = /*#__PURE__*/ (0, $gt9Am.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $be2c8cebc5d88fe6$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $be2c8cebc5d88fe6$var$iconStyles.providedElemBefore,
                    isSelected && $be2c8cebc5d88fe6$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $be2c8cebc5d88fe6$export$fe6fe51056867f4d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $eJOHy.useId)();
    const onExpansionToggle = (0, $yFG6a.useOnExpansionToggle)();
    const isExpanded = (0, $yFG6a.useIsExpanded)();
    const setIsExpanded = (0, $yFG6a.useSetIsExpanded)();
    const itemRef = (0, $eJOHy.useRef)(null);
    const handleIconClick = (0, $eJOHy.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $eekOJ.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    });
    // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)($be2c8cebc5d88fe6$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // We are labelling the icon button using the containing menu item's content, to provide context to
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // IconButton requires a label prop, however it will not be used by screen readers as we are setting
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($be2c8cebc5d88fe6$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    });
    // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: itemRef,
        className: (0, $hcewu.default)([
            $be2c8cebc5d88fe6$var$wrapperStyles.root,
            providedElemBefore && $be2c8cebc5d88fe6$var$wrapperStyles.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKAE.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});

});

parcelRegister("lvrbL", function(module, exports) {
$parcel$export(module.exports, "Nav4ExpandableMenuItem", () => $c2485168c972a927$export$3c0db18b09c9af3e);

var $eJOHy = parcelRequire("eJOHy");

var $1Bb7G = parcelRequire("1Bb7G");

var $cxKOj = parcelRequire("cxKOj");

var $dpxw4 = parcelRequire("dpxw4");

var $cbCSE = parcelRequire("cbCSE");

var $bzbsd = parcelRequire("bzbsd");
const $c2485168c972a927$export$3c0db18b09c9af3e = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($c2485168c972a927$var$Nav4ExpandableMenuItemView));
function $c2485168c972a927$var$Nav4ExpandableMenuItemView(props, ref) {
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isSelectedPath: isSelectedPath, isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $cbCSE.useSidebarNav4Controller)();
    const { children: children, menuId: menuId, onExpansionToggle: onExpansionToggle, isExpanded: isExpanded = false, onSystemToggle: onSystemToggle, expandedRef: expandedRef, collapsedRef: collapsedRef, dropIndicator: dropIndicator = null, dropTargetRef: dropTargetRef = null, isDragging: isDragging = false } = props;
    // controlled state, `isActuallyExpanded` decides whether the component is expanded or not (based on logic in this component and props.isExpanded)
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const [isActuallyExpanded, setActuallyExpanded] = (0, $eJOHy.useState)(isInitialSelectedPath(menuId) || isExpanded);
    // By default, the expandable component is closed. When we want it to be initially open, we also need to trigger onExpansionToggle().
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $eJOHy.useEffect)(()=>{
        if (isActuallyExpanded === true && isExpanded === false) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        onSystemToggle?.(isActuallyExpanded);
    // We want to run this only once, on init.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If isSelectedPath changes (external change), update our internal state.
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $eJOHy.useEffect)(()=>{
        // Fyi, the following logic causes the component to _collapse_ when the selectedPath changes (preserved here for posterity):
        //   const localIsExpanded = isSelectedPath(menuId);
        // ...but this logic _keeps the component expanded_ (if it is) when the selectedPath changes. We can only auto-expand component, not auto-collapse it though (which is fine, for current UX):
        const localIsExpanded = isSelectedPath(menuId) || isActuallyExpanded;
        // Trigger the callbacks ONLY when the previous state doesn't match the new state.
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isSelectedPath() changes, not when isActuallyExpanded changes.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelectedPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $eJOHy.useEffect)(()=>{
        if (!isControlledNav) return;
        const localIsExpanded = isControlledPath(menuId);
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isControlledPath() changes, not when isActuallyExpanded changes.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isControlledPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const expandableMenuItemRef = (0, $eJOHy.useMemo)(()=>{
        if (isActuallyExpanded) return expandedRef ?? ref;
        return collapsedRef ?? ref;
    }, [
        collapsedRef,
        expandedRef,
        isActuallyExpanded,
        ref
    ]);
    const onExpandableMenuItemToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        // Since we are controlling `isExpanded` state in this component (via `isActuallyExpanded`), we need to change it on onExpansionToggle user-event too.
        setActuallyExpanded(hasExpanded);
        onExpansionToggle?.(hasExpanded);
    }, [
        onExpansionToggle
    ]);
    if ((0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        ref: (0, $bzbsd.mergeRefs)(expandableMenuItemRef, dropTargetRef),
        dropIndicator: dropIndicator,
        isExpanded: isActuallyExpanded && !isDragging,
        onExpansionToggle: onExpandableMenuItemToggle
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        ref: expandableMenuItemRef,
        isExpanded: isActuallyExpanded,
        onExpansionToggle: onExpandableMenuItemToggle
    }, children);
}

});
parcelRegister("1Bb7G", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItem", () => $9e505f6b36dba8ea$export$341dea48c30b36ff);
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7O2l7 = parcelRequire("7O2l7");

var $ih05Y = parcelRequire("ih05Y");

var $yFG6a = parcelRequire("yFG6a");
const $9e505f6b36dba8ea$var$relativeStyles = {
    root: "_kqswh2mm"
};
const $9e505f6b36dba8ea$export$341dea48c30b36ff = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $7O2l7.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ih05Y.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                        className: (0, $hcewu.default)([
                            dropIndicator && $9e505f6b36dba8ea$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});

});

parcelRegister("bzbsd", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $4b2da02d203788de$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $4b2da02d203788de$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $4b2da02d203788de$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $4b2da02d203788de$export$2e2bcd8739ae039(...refs) {
    return (0, $eJOHy.useMemo)(()=>$4b2da02d203788de$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("if69u", function(module, exports) {
$parcel$export(module.exports, "SkeletonNavMenuItems", () => $bf75cc4d36608b74$export$c3a3a246584433d7);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $73M1Y = parcelRequire("73M1Y");

var $ih05Y = parcelRequire("ih05Y");

var $dLR8J = parcelRequire("dLR8J");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
const $bf75cc4d36608b74$var$styles = {
    flyoutWrapper: "_c71lr5sb _ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66",
    menuWrapper: "_ca0q1b66 _n3td1b66 _19bv1b66",
    projectAvatar: "_2rko12b0 _bfhkn82g _1bsb1tcg _4t3i1tcg",
    flyoutMenuItem: "_2rko12b0 _bfhkn82g _4t3izwfg _1bsb1osq _19pk12x7 _otyr12x7",
    menuItem: "_2rko12b0 _bfhkn82g _4t3i1tcg _1bsb1osq",
    flyoutHeading: "_2rko12b0 _bfhkn82g _4t3i7vkz _1bsbckbl _19pku2gc _otyrutpp",
    menuHeading: "_2rko12b0 _bfhkn82g _4t3i7vkz _1bsbckbl _18u01b66 _19pku2gc _otyru2gc",
    bigSearch: "_2rko12b0 _4t3i14no _bfhkn82g _1bsb1osq _19pk1b66 _otyrutpp _2hwx12x7",
    search: "_2rko12b0 _bfhkn82g _4t3izwfg _1bsb1osq _19pk1b66 _otyrutpp _2hwx12x7",
    overflowingSection: "_18m91wug"
};
const $bf75cc4d36608b74$var$Heading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $bf75cc4d36608b74$var$styles.menuHeading
    });
const $bf75cc4d36608b74$var$FlyoutHeading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $bf75cc4d36608b74$var$styles.flyoutHeading
    });
const $bf75cc4d36608b74$export$36e4ba43c9afd7b0 = ({ withSubTitle: withSubTitle = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.050",
        alignItems: "center",
        justifyContent: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $bf75cc4d36608b74$var$styles.projectAvatar
    }), withSubTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $bf75cc4d36608b74$var$styles.flyoutMenuItem
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $bf75cc4d36608b74$var$styles.menuItem
    }));
const $bf75cc4d36608b74$var$L2MenuItemSectionSkeleton = ({ withHeading: withHeading, count: count = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, withHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$Heading, null), (0, (/*@__PURE__*/$parcel$interopDefault($73M1Y)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $bf75cc4d36608b74$var$styles.menuWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$export$36e4ba43c9afd7b0, null)))));
};
const $bf75cc4d36608b74$var$Search = ({ isBig: isBig })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: isBig ? $bf75cc4d36608b74$var$styles.bigSearch : $bf75cc4d36608b74$var$styles.search
    });
const $bf75cc4d36608b74$var$FlyoutSkeleton = ({ withHeading: withHeading, count: count = 5, withSearch: withSearch = false, withSubTitle: withSubTitle = false, withSubHeading: withSubHeading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $bf75cc4d36608b74$var$styles.flyoutWrapper
    }, withHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FlyoutHeading, null), withSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$Search, {
        isBig: withSubTitle
    }), withSubHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FlyoutHeading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        xcss: $bf75cc4d36608b74$var$styles.overflowingSection,
        gap: withSubTitle ? 'space.050' : 'space.100',
        direction: "column",
        justifyContent: "start"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($73M1Y)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$export$36e4ba43c9afd7b0, {
            key: index,
            withSubTitle: withSubTitle
        }))));
};
const $bf75cc4d36608b74$var$FancySkeleton = ({ count: count = 5, withHeading: withHeading, isFlyout: isFlyout, withSearch: withSearch, withSubTitle: withSubTitle, withSubHeading: withSubHeading })=>isFlyout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FlyoutSkeleton, {
        withHeading: withHeading,
        count: count,
        withSearch: withSearch,
        withSubTitle: withSubTitle,
        withSubHeading: withSubHeading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$L2MenuItemSectionSkeleton, {
        withHeading: withHeading,
        count: count
    });
const $bf75cc4d36608b74$export$c3a3a246584433d7 = ({ count: count = 5, withHeading: withHeading, isFlyout: isFlyout, withSearch: withSearch, withSubTitle: withSubTitle, withSubHeading: withSubHeading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "nav4-sidebar-menu-items-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FancySkeleton, {
        count: count,
        withHeading: withHeading,
        isFlyout: isFlyout,
        withSearch: withSearch,
        withSubTitle: withSubTitle,
        withSubHeading: withSubHeading
    }));

});
parcelRegister("73M1Y", function(module, exports) {

var $dyMwB = parcelRequire("dyMwB");

var $523e121d9c22ed5d$var$func = $dyMwB('range', (parcelRequire("tGEEK")));

$523e121d9c22ed5d$var$func.placeholder = (parcelRequire("k1T10"));
module.exports = $523e121d9c22ed5d$var$func;

});
parcelRegister("dyMwB", function(module, exports) {

var $cfbha = parcelRequire("cfbha");

var $dcquX = parcelRequire("dcquX");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $9df4175bd7cbb7da$var$convert(name, func, options) {
    return $cfbha($dcquX, name, func, options);
}
module.exports = $9df4175bd7cbb7da$var$convert;

});
parcelRegister("cfbha", function(module, exports) {

var $gb01y = parcelRequire("gb01y");

var $k1T10 = parcelRequire("k1T10");
/** Built-in value reference. */ var $8e9fa1ed117843de$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $8e9fa1ed117843de$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $8e9fa1ed117843de$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $8e9fa1ed117843de$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $8e9fa1ed117843de$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $8e9fa1ed117843de$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $8e9fa1ed117843de$var$push.apply(otherArgs, array);
        if (start != lastIndex) $8e9fa1ed117843de$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $8e9fa1ed117843de$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $8e9fa1ed117843de$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $k1T10, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($gb01y.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($8e9fa1ed117843de$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $8e9fa1ed117843de$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $8e9fa1ed117843de$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $gb01y.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $gb01y.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$gb01y.skipFixed[name])) {
            var data = $gb01y.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $8e9fa1ed117843de$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$gb01y.skipRearg[name]) ? rearg(func, $gb01y.methodRearg[name] || $gb01y.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $gb01y.aliasToReal[name] || name, methodName = $gb01y.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $8e9fa1ed117843de$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $8e9fa1ed117843de$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $8e9fa1ed117843de$var$baseArity(rearg($8e9fa1ed117843de$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $gb01y.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($gb01y.mutate.array[realName]) wrapped = $8e9fa1ed117843de$var$wrapImmutable(func, $8e9fa1ed117843de$var$cloneArray);
            else if ($gb01y.mutate.object[realName]) wrapped = $8e9fa1ed117843de$var$wrapImmutable(func, $8e9fa1ed117843de$var$createCloner(func));
            else if ($gb01y.mutate.set[realName]) wrapped = $8e9fa1ed117843de$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($gb01y.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $gb01y.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($gb01y.aryMethod[aryKey], function(key) {
            var func = _[$gb01y.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($gb01y.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $8e9fa1ed117843de$var$baseConvert;

});
parcelRegister("gb01y", function(module, exports) {
$parcel$export(module.exports, "aliasToReal", () => $bc6db136e0262c52$export$bd0f5e6e44efa6b4, (v) => $bc6db136e0262c52$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $bc6db136e0262c52$export$85c665b4d7da9cb4, (v) => $bc6db136e0262c52$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $bc6db136e0262c52$export$42564e045b285e32, (v) => $bc6db136e0262c52$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $bc6db136e0262c52$export$81e17196e6a22b07, (v) => $bc6db136e0262c52$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $bc6db136e0262c52$export$30975ceb42167ebd, (v) => $bc6db136e0262c52$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $bc6db136e0262c52$export$8ceb0ad7e94d3801, (v) => $bc6db136e0262c52$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $bc6db136e0262c52$export$fbaeb3f87df3cf26, (v) => $bc6db136e0262c52$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $bc6db136e0262c52$export$57e795267c26e600, (v) => $bc6db136e0262c52$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $bc6db136e0262c52$export$1eb71a7e27943e71, (v) => $bc6db136e0262c52$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $bc6db136e0262c52$export$aee1dbae5de2db9d, (v) => $bc6db136e0262c52$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $bc6db136e0262c52$export$87ffbe4821a5d5e0, (v) => $bc6db136e0262c52$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $bc6db136e0262c52$export$b4d07413ce528c90, (v) => $bc6db136e0262c52$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $bc6db136e0262c52$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $bc6db136e0262c52$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $bc6db136e0262c52$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $bc6db136e0262c52$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $bc6db136e0262c52$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $bc6db136e0262c52$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $bc6db136e0262c52$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $bc6db136e0262c52$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $bc6db136e0262c52$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $bc6db136e0262c52$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $bc6db136e0262c52$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $bc6db136e0262c52$export$b4d07413ce528c90;
$bc6db136e0262c52$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$bc6db136e0262c52$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$bc6db136e0262c52$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$bc6db136e0262c52$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$bc6db136e0262c52$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$bc6db136e0262c52$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$bc6db136e0262c52$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$bc6db136e0262c52$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$bc6db136e0262c52$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $bc6db136e0262c52$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$bc6db136e0262c52$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$bc6db136e0262c52$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$bc6db136e0262c52$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("k1T10", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("dcquX", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("k13ij")),
    'assign': (parcelRequire("aahcv")),
    'clone': (parcelRequire("1LiX8")),
    'curry': (parcelRequire("fLExA")),
    'forEach': (parcelRequire("ez1ap")),
    'isArray': (parcelRequire("4sprp")),
    'isError': (parcelRequire("cvRyD")),
    'isFunction': (parcelRequire("dCU5j")),
    'isWeakMap': (parcelRequire("9CL26")),
    'iteratee': (parcelRequire("c4kBg")),
    'keys': (parcelRequire("jAnCu")),
    'rearg': (parcelRequire("7GIya")),
    'toInteger': (parcelRequire("c9FP3")),
    'toPath': (parcelRequire("lDisb"))
};

});
parcelRegister("k13ij", function(module, exports) {

var $5rOR1 = parcelRequire("5rOR1");
/** Used to compose bitmasks for function metadata. */ var $e92674d98e82f1d7$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $e92674d98e82f1d7$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $5rOR1(func, $e92674d98e82f1d7$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $e92674d98e82f1d7$var$ary;

});
parcelRegister("5rOR1", function(module, exports) {

var $a2rYh = parcelRequire("a2rYh");

var $g2n0U = parcelRequire("g2n0U");

var $c4AZN = parcelRequire("c4AZN");

var $cH1gk = parcelRequire("cH1gk");

var $jvtoE = parcelRequire("jvtoE");

var $2GK2O = parcelRequire("2GK2O");

var $cwwEL = parcelRequire("cwwEL");

var $aaQGq = parcelRequire("aaQGq");

var $9Xy53 = parcelRequire("9Xy53");

var $c9FP3 = parcelRequire("c9FP3");
/** Error message constants. */ var $3f76ebf31bc08fc6$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $3f76ebf31bc08fc6$var$WRAP_BIND_FLAG = 1, $3f76ebf31bc08fc6$var$WRAP_BIND_KEY_FLAG = 2, $3f76ebf31bc08fc6$var$WRAP_CURRY_FLAG = 8, $3f76ebf31bc08fc6$var$WRAP_CURRY_RIGHT_FLAG = 16, $3f76ebf31bc08fc6$var$WRAP_PARTIAL_FLAG = 32, $3f76ebf31bc08fc6$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3f76ebf31bc08fc6$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $3f76ebf31bc08fc6$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $3f76ebf31bc08fc6$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($3f76ebf31bc08fc6$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($3f76ebf31bc08fc6$var$WRAP_PARTIAL_FLAG | $3f76ebf31bc08fc6$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $3f76ebf31bc08fc6$var$nativeMax($c9FP3(ary), 0);
    arity = arity === undefined ? arity : $c9FP3(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $3f76ebf31bc08fc6$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $2GK2O(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $cwwEL(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3f76ebf31bc08fc6$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($3f76ebf31bc08fc6$var$WRAP_CURRY_FLAG | $3f76ebf31bc08fc6$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3f76ebf31bc08fc6$var$WRAP_CURRY_FLAG | $3f76ebf31bc08fc6$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $3f76ebf31bc08fc6$var$WRAP_BIND_FLAG) var result = $g2n0U(func, bitmask, thisArg);
    else if (bitmask == $3f76ebf31bc08fc6$var$WRAP_CURRY_FLAG || bitmask == $3f76ebf31bc08fc6$var$WRAP_CURRY_RIGHT_FLAG) result = $c4AZN(func, bitmask, arity);
    else if ((bitmask == $3f76ebf31bc08fc6$var$WRAP_PARTIAL_FLAG || bitmask == ($3f76ebf31bc08fc6$var$WRAP_BIND_FLAG | $3f76ebf31bc08fc6$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $jvtoE(func, bitmask, thisArg, partials);
    else result = $cH1gk.apply(undefined, newData);
    var setter = data ? $a2rYh : $aaQGq;
    return $9Xy53(setter(result, newData), func, bitmask);
}
module.exports = $3f76ebf31bc08fc6$var$createWrap;

});
parcelRegister("a2rYh", function(module, exports) {

var $d7YnM = parcelRequire("d7YnM");

var $giyy7 = parcelRequire("giyy7");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $74efc9cc506f79cd$var$baseSetData = !$giyy7 ? $d7YnM : function(func, data) {
    $giyy7.set(func, data);
    return func;
};
module.exports = $74efc9cc506f79cd$var$baseSetData;

});
parcelRegister("giyy7", function(module, exports) {

var $hWTvf = parcelRequire("hWTvf");
/** Used to store function metadata. */ var $bdd9209418d26c19$var$metaMap = $hWTvf && new $hWTvf;
module.exports = $bdd9209418d26c19$var$metaMap;

});


parcelRegister("g2n0U", function(module, exports) {

var $9Ynu7 = parcelRequire("9Ynu7");

var $NROo8 = parcelRequire("NROo8");
/** Used to compose bitmasks for function metadata. */ var $baceaf422ce07d2d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $baceaf422ce07d2d$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $baceaf422ce07d2d$var$WRAP_BIND_FLAG, Ctor = $9Ynu7(func);
    function wrapper() {
        var fn = this && this !== $NROo8 && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $baceaf422ce07d2d$var$createBind;

});
parcelRegister("9Ynu7", function(module, exports) {

var $b7PJS = parcelRequire("b7PJS");

var $546O5 = parcelRequire("546O5");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $742bef398141d3e4$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $b7PJS(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $546O5(result) ? result : thisBinding;
    };
}
module.exports = $742bef398141d3e4$var$createCtor;

});


parcelRegister("c4AZN", function(module, exports) {

var $euhRr = parcelRequire("euhRr");

var $9Ynu7 = parcelRequire("9Ynu7");

var $cH1gk = parcelRequire("cH1gk");

var $2Dlwo = parcelRequire("2Dlwo");

var $2Vf2k = parcelRequire("2Vf2k");

var $igl1D = parcelRequire("igl1D");

var $NROo8 = parcelRequire("NROo8");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $8ca28e5b53e280b6$var$createCurry(func, bitmask, arity) {
    var Ctor = $9Ynu7(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $2Vf2k(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $igl1D(args, placeholder);
        length -= holders.length;
        if (length < arity) return $2Dlwo(func, bitmask, $cH1gk, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $NROo8 && this instanceof wrapper ? Ctor : func;
        return $euhRr(fn, this, args);
    }
    return wrapper;
}
module.exports = $8ca28e5b53e280b6$var$createCurry;

});
parcelRegister("cH1gk", function(module, exports) {

var $ezJMS = parcelRequire("ezJMS");

var $4rcUK = parcelRequire("4rcUK");

var $k5Khj = parcelRequire("k5Khj");

var $9Ynu7 = parcelRequire("9Ynu7");

var $2Dlwo = parcelRequire("2Dlwo");

var $2Vf2k = parcelRequire("2Vf2k");

var $a7b4m = parcelRequire("a7b4m");

var $igl1D = parcelRequire("igl1D");

var $NROo8 = parcelRequire("NROo8");
/** Used to compose bitmasks for function metadata. */ var $93da7ad8a7a42da4$var$WRAP_BIND_FLAG = 1, $93da7ad8a7a42da4$var$WRAP_BIND_KEY_FLAG = 2, $93da7ad8a7a42da4$var$WRAP_CURRY_FLAG = 8, $93da7ad8a7a42da4$var$WRAP_CURRY_RIGHT_FLAG = 16, $93da7ad8a7a42da4$var$WRAP_ARY_FLAG = 128, $93da7ad8a7a42da4$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $93da7ad8a7a42da4$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $93da7ad8a7a42da4$var$WRAP_ARY_FLAG, isBind = bitmask & $93da7ad8a7a42da4$var$WRAP_BIND_FLAG, isBindKey = bitmask & $93da7ad8a7a42da4$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($93da7ad8a7a42da4$var$WRAP_CURRY_FLAG | $93da7ad8a7a42da4$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $93da7ad8a7a42da4$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $9Ynu7(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $2Vf2k(wrapper), holdersCount = $k5Khj(args, placeholder);
        if (partials) args = $ezJMS(args, partials, holders, isCurried);
        if (partialsRight) args = $4rcUK(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $igl1D(args, placeholder);
            return $2Dlwo(func, bitmask, $93da7ad8a7a42da4$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $a7b4m(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $NROo8 && this instanceof wrapper) fn = Ctor || $9Ynu7(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $93da7ad8a7a42da4$var$createHybrid;

});
parcelRegister("ezJMS", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a9c7d9f99568bc42$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $a9c7d9f99568bc42$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $a9c7d9f99568bc42$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $a9c7d9f99568bc42$var$composeArgs;

});

parcelRegister("4rcUK", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $33b3b387df37c056$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $33b3b387df37c056$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $33b3b387df37c056$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $33b3b387df37c056$var$composeArgsRight;

});

parcelRegister("k5Khj", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $ea082c2a0ce7847e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $ea082c2a0ce7847e$var$countHolders;

});

parcelRegister("2Dlwo", function(module, exports) {

var $74osV = parcelRequire("74osV");

var $aaQGq = parcelRequire("aaQGq");

var $9Xy53 = parcelRequire("9Xy53");
/** Used to compose bitmasks for function metadata. */ var $1eafeafeb1f19224$var$WRAP_BIND_FLAG = 1, $1eafeafeb1f19224$var$WRAP_BIND_KEY_FLAG = 2, $1eafeafeb1f19224$var$WRAP_CURRY_BOUND_FLAG = 4, $1eafeafeb1f19224$var$WRAP_CURRY_FLAG = 8, $1eafeafeb1f19224$var$WRAP_PARTIAL_FLAG = 32, $1eafeafeb1f19224$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1eafeafeb1f19224$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $1eafeafeb1f19224$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $1eafeafeb1f19224$var$WRAP_PARTIAL_FLAG : $1eafeafeb1f19224$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $1eafeafeb1f19224$var$WRAP_PARTIAL_RIGHT_FLAG : $1eafeafeb1f19224$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $1eafeafeb1f19224$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($1eafeafeb1f19224$var$WRAP_BIND_FLAG | $1eafeafeb1f19224$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($74osV(func)) $aaQGq(result, newData);
    result.placeholder = placeholder;
    return $9Xy53(result, func, bitmask);
}
module.exports = $1eafeafeb1f19224$var$createRecurry;

});
parcelRegister("74osV", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $2GK2O = parcelRequire("2GK2O");

var $asy1v = parcelRequire("asy1v");

var $4ODiF = parcelRequire("4ODiF");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $525be278ce84eab2$var$isLaziable(func) {
    var funcName = $asy1v(func), other = $4ODiF[funcName];
    if (typeof other != 'function' || !(funcName in $ab1mA.prototype)) return false;
    if (func === other) return true;
    var data = $2GK2O(other);
    return !!data && func === data[0];
}
module.exports = $525be278ce84eab2$var$isLaziable;

});
parcelRegister("ab1mA", function(module, exports) {

var $b7PJS = parcelRequire("b7PJS");

var $iSWBo = parcelRequire("iSWBo");
/** Used as references for the maximum length and index of an array. */ var $768bfd3243192c62$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $768bfd3243192c62$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $768bfd3243192c62$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$768bfd3243192c62$var$LazyWrapper.prototype = $b7PJS($iSWBo.prototype);
$768bfd3243192c62$var$LazyWrapper.prototype.constructor = $768bfd3243192c62$var$LazyWrapper;
module.exports = $768bfd3243192c62$var$LazyWrapper;

});
parcelRegister("iSWBo", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $dbfaba4a3b3a815b$var$baseLodash() {
// No operation performed.
}
module.exports = $dbfaba4a3b3a815b$var$baseLodash;

});


parcelRegister("2GK2O", function(module, exports) {

var $giyy7 = parcelRequire("giyy7");

var $12DRg = parcelRequire("12DRg");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $1f533870d3d62e5d$var$getData = !$giyy7 ? $12DRg : function(func) {
    return $giyy7.get(func);
};
module.exports = $1f533870d3d62e5d$var$getData;

});

parcelRegister("asy1v", function(module, exports) {

var $lPnRE = parcelRequire("lPnRE");
/** Used for built-in method references. */ var $79d6e934e9859363$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $79d6e934e9859363$var$hasOwnProperty = $79d6e934e9859363$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $79d6e934e9859363$var$getFuncName(func) {
    var result = func.name + '', array = $lPnRE[result], length = $79d6e934e9859363$var$hasOwnProperty.call($lPnRE, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $79d6e934e9859363$var$getFuncName;

});
parcelRegister("lPnRE", function(module, exports) {
/** Used to lookup unminified function names. */ var $fe40df58a594c3c0$var$realNames = {};
module.exports = $fe40df58a594c3c0$var$realNames;

});


parcelRegister("4ODiF", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $iTpII = parcelRequire("iTpII");

var $iSWBo = parcelRequire("iSWBo");

var $4sprp = parcelRequire("4sprp");

var $7gKgM = parcelRequire("7gKgM");

var $8gTTQ = parcelRequire("8gTTQ");
/** Used for built-in method references. */ var $381a5122a63b198d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $381a5122a63b198d$var$hasOwnProperty = $381a5122a63b198d$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $381a5122a63b198d$var$lodash(value) {
    if ($7gKgM(value) && !$4sprp(value) && !(value instanceof $ab1mA)) {
        if (value instanceof $iTpII) return value;
        if ($381a5122a63b198d$var$hasOwnProperty.call(value, '__wrapped__')) return $8gTTQ(value);
    }
    return new $iTpII(value);
}
// Ensure wrappers are instances of `baseLodash`.
$381a5122a63b198d$var$lodash.prototype = $iSWBo.prototype;
$381a5122a63b198d$var$lodash.prototype.constructor = $381a5122a63b198d$var$lodash;
module.exports = $381a5122a63b198d$var$lodash;

});
parcelRegister("iTpII", function(module, exports) {

var $b7PJS = parcelRequire("b7PJS");

var $iSWBo = parcelRequire("iSWBo");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $dc11508658975546$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$dc11508658975546$var$LodashWrapper.prototype = $b7PJS($iSWBo.prototype);
$dc11508658975546$var$LodashWrapper.prototype.constructor = $dc11508658975546$var$LodashWrapper;
module.exports = $dc11508658975546$var$LodashWrapper;

});

parcelRegister("8gTTQ", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $iTpII = parcelRequire("iTpII");

var $k4ZVz = parcelRequire("k4ZVz");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $605b2de1cde3289a$var$wrapperClone(wrapper) {
    if (wrapper instanceof $ab1mA) return wrapper.clone();
    var result = new $iTpII(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $k4ZVz(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $605b2de1cde3289a$var$wrapperClone;

});



parcelRegister("aaQGq", function(module, exports) {

var $a2rYh = parcelRequire("a2rYh");

var $lwJMm = parcelRequire("lwJMm");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $7683b460bcb9d85a$var$setData = $lwJMm($a2rYh);
module.exports = $7683b460bcb9d85a$var$setData;

});

parcelRegister("9Xy53", function(module, exports) {

var $203bp = parcelRequire("203bp");

var $3MdBK = parcelRequire("3MdBK");

var $hC3zk = parcelRequire("hC3zk");

var $ir5Tb = parcelRequire("ir5Tb");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $74040f7269ff23b2$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $hC3zk(wrapper, $3MdBK(source, $ir5Tb($203bp(source), bitmask)));
}
module.exports = $74040f7269ff23b2$var$setWrapToString;

});
parcelRegister("203bp", function(module, exports) {
/** Used to match wrap detail comments. */ var $174e0cec8eb70bd8$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $174e0cec8eb70bd8$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $174e0cec8eb70bd8$var$getWrapDetails(source) {
    var match = source.match($174e0cec8eb70bd8$var$reWrapDetails);
    return match ? match[1].split($174e0cec8eb70bd8$var$reSplitDetails) : [];
}
module.exports = $174e0cec8eb70bd8$var$getWrapDetails;

});

parcelRegister("3MdBK", function(module, exports) {
/** Used to match wrap detail comments. */ var $2c0069004514128b$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $2c0069004514128b$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($2c0069004514128b$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $2c0069004514128b$var$insertWrapDetails;

});

parcelRegister("ir5Tb", function(module, exports) {

var $ez1ap = parcelRequire("ez1ap");

var $40QQB = parcelRequire("40QQB");
/** Used to compose bitmasks for function metadata. */ var $d6bf510ea94c7fd0$var$WRAP_BIND_FLAG = 1, $d6bf510ea94c7fd0$var$WRAP_BIND_KEY_FLAG = 2, $d6bf510ea94c7fd0$var$WRAP_CURRY_FLAG = 8, $d6bf510ea94c7fd0$var$WRAP_CURRY_RIGHT_FLAG = 16, $d6bf510ea94c7fd0$var$WRAP_PARTIAL_FLAG = 32, $d6bf510ea94c7fd0$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $d6bf510ea94c7fd0$var$WRAP_ARY_FLAG = 128, $d6bf510ea94c7fd0$var$WRAP_REARG_FLAG = 256, $d6bf510ea94c7fd0$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $d6bf510ea94c7fd0$var$wrapFlags = [
    [
        'ary',
        $d6bf510ea94c7fd0$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $d6bf510ea94c7fd0$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $d6bf510ea94c7fd0$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $d6bf510ea94c7fd0$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $d6bf510ea94c7fd0$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $d6bf510ea94c7fd0$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $d6bf510ea94c7fd0$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $d6bf510ea94c7fd0$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $d6bf510ea94c7fd0$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $d6bf510ea94c7fd0$var$updateWrapDetails(details, bitmask) {
    $ez1ap($d6bf510ea94c7fd0$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$40QQB(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $d6bf510ea94c7fd0$var$updateWrapDetails;

});



parcelRegister("2Vf2k", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $220c9196afcdb55f$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $220c9196afcdb55f$var$getHolder;

});

parcelRegister("a7b4m", function(module, exports) {

var $k4ZVz = parcelRequire("k4ZVz");

var $cn6El = parcelRequire("cn6El");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $75d324f3b7911cb9$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $75d324f3b7911cb9$var$reorder(array, indexes) {
    var arrLength = array.length, length = $75d324f3b7911cb9$var$nativeMin(indexes.length, arrLength), oldArray = $k4ZVz(array);
    while(length--){
        var index = indexes[length];
        array[length] = $cn6El(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $75d324f3b7911cb9$var$reorder;

});

parcelRegister("igl1D", function(module, exports) {
/** Used as the internal argument placeholder. */ var $d4ba07cf1f9b78fa$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $d4ba07cf1f9b78fa$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $d4ba07cf1f9b78fa$var$PLACEHOLDER) {
            array[index] = $d4ba07cf1f9b78fa$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $d4ba07cf1f9b78fa$var$replaceHolders;

});



parcelRegister("jvtoE", function(module, exports) {

var $euhRr = parcelRequire("euhRr");

var $9Ynu7 = parcelRequire("9Ynu7");

var $NROo8 = parcelRequire("NROo8");
/** Used to compose bitmasks for function metadata. */ var $e337b71cb44dfaa7$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $e337b71cb44dfaa7$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $e337b71cb44dfaa7$var$WRAP_BIND_FLAG, Ctor = $9Ynu7(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $NROo8 && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $euhRr(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $e337b71cb44dfaa7$var$createPartial;

});

parcelRegister("cwwEL", function(module, exports) {

var $ezJMS = parcelRequire("ezJMS");

var $4rcUK = parcelRequire("4rcUK");

var $igl1D = parcelRequire("igl1D");
/** Used as the internal argument placeholder. */ var $91e1ce1c3a678ca9$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $91e1ce1c3a678ca9$var$WRAP_BIND_FLAG = 1, $91e1ce1c3a678ca9$var$WRAP_BIND_KEY_FLAG = 2, $91e1ce1c3a678ca9$var$WRAP_CURRY_BOUND_FLAG = 4, $91e1ce1c3a678ca9$var$WRAP_CURRY_FLAG = 8, $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG = 128, $91e1ce1c3a678ca9$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $91e1ce1c3a678ca9$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $91e1ce1c3a678ca9$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($91e1ce1c3a678ca9$var$WRAP_BIND_FLAG | $91e1ce1c3a678ca9$var$WRAP_BIND_KEY_FLAG | $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG && bitmask == $91e1ce1c3a678ca9$var$WRAP_CURRY_FLAG || srcBitmask == $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG && bitmask == $91e1ce1c3a678ca9$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($91e1ce1c3a678ca9$var$WRAP_ARY_FLAG | $91e1ce1c3a678ca9$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $91e1ce1c3a678ca9$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $91e1ce1c3a678ca9$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $91e1ce1c3a678ca9$var$WRAP_BIND_FLAG ? 0 : $91e1ce1c3a678ca9$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $ezJMS(partials, value, source[4]) : value;
        data[4] = partials ? $igl1D(data[3], $91e1ce1c3a678ca9$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $4rcUK(partials, value, source[6]) : value;
        data[6] = partials ? $igl1D(data[5], $91e1ce1c3a678ca9$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $91e1ce1c3a678ca9$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $91e1ce1c3a678ca9$var$mergeData;

});



parcelRegister("1LiX8", function(module, exports) {

var $2yYrH = parcelRequire("2yYrH");
/** Used to compose bitmasks for cloning. */ var $1488e1dd9ca91d5e$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $1488e1dd9ca91d5e$var$clone(value) {
    return $2yYrH(value, $1488e1dd9ca91d5e$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $1488e1dd9ca91d5e$var$clone;

});

parcelRegister("fLExA", function(module, exports) {

var $5rOR1 = parcelRequire("5rOR1");
/** Used to compose bitmasks for function metadata. */ var $b7aab1547651f449$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $b7aab1547651f449$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $5rOR1(func, $b7aab1547651f449$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $b7aab1547651f449$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$b7aab1547651f449$var$curry.placeholder = {};
module.exports = $b7aab1547651f449$var$curry;

});

parcelRegister("cvRyD", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");

var $dtLJW = parcelRequire("dtLJW");
/** `Object#toString` result references. */ var $91c1ecb3cf661a45$var$domExcTag = '[object DOMException]', $91c1ecb3cf661a45$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $91c1ecb3cf661a45$var$isError(value) {
    if (!$7gKgM(value)) return false;
    var tag = $1O9y6(value);
    return tag == $91c1ecb3cf661a45$var$errorTag || tag == $91c1ecb3cf661a45$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$dtLJW(value);
}
module.exports = $91c1ecb3cf661a45$var$isError;

});

parcelRegister("9CL26", function(module, exports) {

var $PodIB = parcelRequire("PodIB");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $701c256fde753cf0$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $701c256fde753cf0$var$isWeakMap(value) {
    return $7gKgM(value) && $PodIB(value) == $701c256fde753cf0$var$weakMapTag;
}
module.exports = $701c256fde753cf0$var$isWeakMap;

});

parcelRegister("c4kBg", function(module, exports) {

var $2yYrH = parcelRequire("2yYrH");

var $1lM9j = parcelRequire("1lM9j");
/** Used to compose bitmasks for cloning. */ var $8c95d67d9a1a04e2$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $8c95d67d9a1a04e2$var$iteratee(func) {
    return $1lM9j(typeof func == 'function' ? func : $2yYrH(func, $8c95d67d9a1a04e2$var$CLONE_DEEP_FLAG));
}
module.exports = $8c95d67d9a1a04e2$var$iteratee;

});

parcelRegister("7GIya", function(module, exports) {

var $5rOR1 = parcelRequire("5rOR1");

var $lgI96 = parcelRequire("lgI96");
/** Used to compose bitmasks for function metadata. */ var $598f035cd6aae5ff$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $598f035cd6aae5ff$var$rearg = $lgI96(function(func, indexes) {
    return $5rOR1(func, $598f035cd6aae5ff$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $598f035cd6aae5ff$var$rearg;

});

parcelRegister("lDisb", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $k4ZVz = parcelRequire("k4ZVz");

var $4sprp = parcelRequire("4sprp");

var $9D78T = parcelRequire("9D78T");

var $Kx0EO = parcelRequire("Kx0EO");

var $9IlW0 = parcelRequire("9IlW0");

var $cz1WF = parcelRequire("cz1WF");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $fbfb8df8d599b4dd$var$toPath(value) {
    if ($4sprp(value)) return $lylkU(value, $9IlW0);
    return $9D78T(value) ? [
        value
    ] : $k4ZVz($Kx0EO($cz1WF(value)));
}
module.exports = $fbfb8df8d599b4dd$var$toPath;

});



parcelRegister("tGEEK", function(module, exports) {

var $9aiYx = parcelRequire("9aiYx");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $0593cbe44b472276$var$range = $9aiYx();
module.exports = $0593cbe44b472276$var$range;

});
parcelRegister("9aiYx", function(module, exports) {

var $8diOj = parcelRequire("8diOj");

var $eA1it = parcelRequire("eA1it");

var $dbRic = parcelRequire("dbRic");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $6ac3c455ec7464cf$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $eA1it(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $dbRic(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $dbRic(end);
        step = step === undefined ? start < end ? 1 : -1 : $dbRic(step);
        return $8diOj(start, end, step, fromRight);
    };
}
module.exports = $6ac3c455ec7464cf$var$createRange;

});
parcelRegister("8diOj", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5fae20fab3dfdbe9$var$nativeCeil = Math.ceil, $5fae20fab3dfdbe9$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $5fae20fab3dfdbe9$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $5fae20fab3dfdbe9$var$nativeMax($5fae20fab3dfdbe9$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $5fae20fab3dfdbe9$var$baseRange;

});





parcelRegister("hPlDs", function(module, exports) {
$parcel$export(module.exports, "useExpandableEntryPointTrigger", () => $e9a162c6ea5442b5$export$569294f6ae10bba9);

var $eJOHy = parcelRequire("eJOHy");

var $dZ3jN = parcelRequire("dZ3jN");
const $e9a162c6ea5442b5$export$569294f6ae10bba9 = (actions, isActive = true)=>{
    // We don't want the click-handler, as ExpandableMenuItem handles the entry-point loading itself
    const eventMap = (0, $eJOHy.useMemo)(()=>Object.fromEntries(Object.entries((0, $dZ3jN.getDefaultEntrypointActionEventMap)(actions)).filter(([key])=>key !== 'click')), [
        actions
    ]);
    return (0, $dZ3jN.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});
parcelRegister("dZ3jN", function(module, exports) {
$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $6cf5dc5db2433246$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $6cf5dc5db2433246$export$5f13515bd3a35325);

var $eJOHy = parcelRequire("eJOHy");

var $iWD60 = parcelRequire("iWD60");
const $6cf5dc5db2433246$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $eJOHy.useRef)(null);
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eJOHy.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $6cf5dc5db2433246$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $iWD60.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iWD60.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $6cf5dc5db2433246$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iWD60", function(module, exports) {
$parcel$export(module.exports, "modifyListeners", () => $d7017963ad12f211$export$15257a36a7e3f9d6);
function $d7017963ad12f211$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});



parcelRegister("hHXEn", function(module, exports) {
$parcel$export(module.exports, "ExploreMoreApps", () => $05fadd606d9b1924$export$e3e10d2adcb07330);

var $eJOHy = parcelRequire("eJOHy");

var $bGbhe = parcelRequire("bGbhe");



var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $2QH3X = parcelRequire("2QH3X");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $koAZ4 = parcelRequire("koAZ4");

var $cxKOj = parcelRequire("cxKOj");

var $jTGoK = parcelRequire("jTGoK");
const $05fadd606d9b1924$var$pathToNavigate = '/jira/marketplace/discover';
function $05fadd606d9b1924$export$e3e10d2adcb07330() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $jTGoK.default).exploreMoreApps, (0, (/*@__PURE__*/$parcel$interopDefault($bGbhe))));
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: 'exploreMoreApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const showExploreMoreApps = isAdmin || isSiteAdmin ? (0, $cxKOj.expVal)('emcee-discover', 'value', true) : (0, $cxKOj.expVal)('enduser-emcee-discover', 'value', true);
    if (!showExploreMoreApps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: icon,
        href: $05fadd606d9b1924$var$pathToNavigate,
        menuId: (0, $h4Bzb.MENU_ID_APP_MARKETPLACE_DISCOVER),
        onClick: onClick
    }, formattedMessage);
}

});
parcelRegister("jTGoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $314a228bd353c42e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $314a228bd353c42e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    exploreMoreApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.explore-more-apps.explore-more-apps",
        "defaultMessage": "Explore more apps"
    }
});

});


const $a9b3358f09bdf564$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Apps';
const $a9b3358f09bdf564$export$d57b6b390e78d90f = 'smite';

parcelRegister("669uo", function(module, exports) {
$parcel$export(module.exports, "createAttributes", () => $058f0c753f7617b4$export$c7c9603a6b1fd815);

var $4cTDP = parcelRequire("4cTDP");

var $dMM78 = parcelRequire("dMM78");

var $hWeHP = parcelRequire("hWeHP");
const $058f0c753f7617b4$var$isSynthetic = ()=>// Filter out synthetic tests using all known ways
    (0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $4cTDP.fg)('forge_ui_synthetic_check');
const $058f0c753f7617b4$var$FAILED_TO_FETCH = 'FAILED_TO_FETCH';
const $058f0c753f7617b4$var$getErrorType = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ((0, $dMM78.isClientFetchError)(error)) return $058f0c753f7617b4$var$FAILED_TO_FETCH;
    return 'OTHER';
};
const $058f0c753f7617b4$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $058f0c753f7617b4$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: $058f0c753f7617b4$var$isSynthetic(),
        isSSR: false
    };
    if (rawAttributes) {
        const { error: error } = rawAttributes;
        if (error) {
            attributes.error = $058f0c753f7617b4$export$78c6267359db7e73(error);
            attributes.errorType = $058f0c753f7617b4$var$getErrorType(error);
        }
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});

parcelRegister("cjf2i", function(module, exports) {
$parcel$export(module.exports, "asyncNav4AppsContentViewQuery", () => $957f8b09c88792fa$export$3cc582e017e659a5);

var $1Iuce = parcelRequire("1Iuce");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $957f8b09c88792fa$export$3cc582e017e659a5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7o6Yc")).then(({ Nav4AppsContentViewQuery: Nav4AppsContentViewQuery })=>Nav4AppsContentViewQuery), {
        moduleId: "5e1e3d10",
        moduleName: "Nav4AppsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                apps: {
                    parameters: $1Iuce.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("1Iuce", function(module, exports) {
$parcel$export(module.exports, "default", () => $86bfdbbb9ef5550d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a797f95d565e272b64c867b7e10016a>>
 * @relayHash 3ad9de847a73c165c119877312ac8b41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7e949716a36a3b7276a3e0c3e396a35d07392bc693f41443586e94aec2d3222b
const $86bfdbbb9ef5550d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "label"
    }, v2 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsContent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "globalAppNavigationItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "envLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "iconUrl"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "settingsUrl"
                                                        },
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7e949716a36a3b7276a3e0c3e396a35d07392bc693f41443586e94aec2d3222b",
            "metadata": {},
            "name": "Nav4AppsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$86bfdbbb9ef5550d$var$node.hash = "157a8cfe104b1d671cc09c5f8aee481a";
var $86bfdbbb9ef5550d$export$2e2bcd8739ae039 = $86bfdbbb9ef5550d$var$node;

});

parcelRegister("7o6Yc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1t7P4").then(()=>parcelRequire('5PH0x'));

});



parcelRegister("7adq7", function(module, exports) {
$parcel$export(module.exports, "Nav4AppsForLanding", () => $0c6527fdf5cdadff$export$889c9c34c80104b2);

var $9kXcU = parcelRequire("9kXcU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");


var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $80rA3 = parcelRequire("80rA3");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $eL2Ux = parcelRequire("eL2Ux");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4EKqI = parcelRequire("4EKqI");

var $4cTDP = parcelRequire("4cTDP");

var $hHXEn = parcelRequire("hHXEn");

var $83taL = parcelRequire("83taL");
function $0c6527fdf5cdadff$export$889c9c34c80104b2(props) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).APPS);
    const data = (0, $j4oe4.useFragment)((0, $9kXcU.default), queryRef);
    const menuId = (0, $h4Bzb.MENU_ID_APPS);
    const handleExpansionToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).APPS);
            (0, $kRgKj.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $azEgq.getTestId)(menuId),
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-apps-landing' : undefined
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-apps-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $83taL.Nav4AppsContent), {
        queryRef: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hHXEn.ExploreMoreApps), null))));
}

});
parcelRegister("9kXcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e9bcd8f158b38c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43a8cee8bfdf430e242ac6d6e2f5e807>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e9bcd8f158b38c0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4AppsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppsContent"
        }
    ],
    "type": "JiraQuery"
};
$3e9bcd8f158b38c0$var$node.hash = "9c28cb4a0c92a920a58010f91f4f4f0e";
var $3e9bcd8f158b38c0$export$2e2bcd8739ae039 = $3e9bcd8f158b38c0$var$node;

});

parcelRegister("83taL", function(module, exports) {
$parcel$export(module.exports, "Nav4AppsContent", () => $030ccf9c6a99c297$export$aaf45d195a81792d);

var $fB4IQ = parcelRequire("fB4IQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $aeOhE = parcelRequire("aeOhE");

var $1DW20 = parcelRequire("1DW20");

var $fohjD = parcelRequire("fohjD");

var $lRq8t = parcelRequire("lRq8t");

var $5RW99 = parcelRequire("5RW99");

var $bCMeR = parcelRequire("bCMeR");

var $d51SR = parcelRequire("d51SR");

var $ja8Li = parcelRequire("ja8Li");

var $diXvx = parcelRequire("diXvx");
function $030ccf9c6a99c297$export$aaf45d195a81792d({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $fB4IQ.default), queryRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const menuItemNodes = (0, $eJOHy.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>{
            // Keep only Forge and Connect apps on the list
            if (edge?.node?.appType !== 'CONNECT' && edge?.node?.appType !== 'FORGE') return false;
            // Filter out system apps just like it was done in the old navigation
            return edge?.node?.appId !== (0, $5RW99.ADDON_ID).DISCOVER;
        }).map((edge)=>edge?.node).sort((a, b)=>(a?.label || '').localeCompare(b?.label || '')) || [], [
        data?.globalAppNavigationItems
    ]);
    const renderedMenuItems = (0, $eJOHy.useMemo)(()=>menuItemNodes.map((node)=>{
            switch(node?.appType){
                case 'CONNECT':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d51SR.Nav4ConnectMenuItem), {
                        key: node.id,
                        queryRef: node
                    });
                case 'FORGE':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ja8Li.Nav4ForgeMenuItem), {
                        key: node.id,
                        queryRef: node
                    });
                default:
                    return null;
            }
        }).filter(Boolean), [
        menuItemNodes
    ]);
    const hasForgeApps = (0, $eJOHy.useMemo)(()=>menuItemNodes.some((node)=>node?.appType === 'FORGE'), [
        menuItemNodes
    ]);
    const renderDiscoverAppsSection = ()=>{
        if (!(0, $4cTDP.fg)('jira_nav4_apps_menu_recommend')) return null;
        if ((0, $cxKOj.expVal)('enable_jira_sidenav_2p_app_recommendations', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bCMeR.AsyncDiscoverSectionPostOffice), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bCMeR.AsyncDiscoverSection), null));
    };
    return renderedMenuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($030ccf9c6a99c297$var$ForgeAnalyticsWrapper, {
        shouldReport: hasForgeApps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $diXvx.default).yourApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, renderedMenuItems, hasForgeApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.GLOBAL_PAGE_MODULE)
        }
    })))), renderDiscoverAppsSection()) : null;
}
function $030ccf9c6a99c297$var$ForgeAnalyticsWrapper({ shouldReport: shouldReport, children: children }) {
    return shouldReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1DW20.TriggerAnalyticsWrapper), null, children) : children;
}

});
parcelRegister("fB4IQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5cd2f0149ca9216$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ddb8a1bbce6fff611878abb761dbf404>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d5cd2f0149ca9216$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4AppsContent",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "globalAppNavigationItems",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            "action": "THROW",
                                            "path": "globalAppNavigationItems.edges.node.id"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appType"
                                                }
                                            ],
                                            "type": "JiraAppNavigationItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ConnectMenuItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ForgeMenuItem"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "globalAppNavigationItems.edges.node"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "globalAppNavigationItems.edges"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$d5cd2f0149ca9216$var$node.hash = "6074e52ca012374d836fe32977dd1a14";
var $d5cd2f0149ca9216$export$2e2bcd8739ae039 = $d5cd2f0149ca9216$var$node;

});

parcelRegister("1ejND", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $ab29bba6ec8b0fc6$export$4b1545b4f2016d26);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gl2vi = parcelRequire("gl2vi");

var $ih05Y = parcelRequire("ih05Y");

var $4ymIv = parcelRequire("4ymIv");
const $ab29bba6ec8b0fc6$export$4b1545b4f2016d26 = ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $gl2vi.useId)();
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4ymIv.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`,
            children: children
        })
    });
    if (isMenuListItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ih05Y.MenuListItem), {
        testId: testId,
        children: content
    });
    // Legacy. isMenuListItem should become default.
    return content;
};

});
parcelRegister("4ymIv", function(module, exports) {
$parcel$export(module.exports, "MenuSectionContext", () => $0c2005f77fb11a65$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $0c2005f77fb11a65$export$8100cda602411810);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $0c2005f77fb11a65$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $0c2005f77fb11a65$export$8100cda602411810 = ()=>{
    const context = (0, $eJOHy.useContext)($0c2005f77fb11a65$export$728ac99b9c7eea8a);
    (0, $8GOss.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});


parcelRegister("4REVJ", function(module, exports) {
$parcel$export(module.exports, "MenuSectionHeading", () => $f105840484298cca$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4ymIv = parcelRequire("4ymIv");
const $f105840484298cca$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};
const $f105840484298cca$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $4ymIv.useMenuSectionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        id: `${id}-heading`,
        className: (0, $hcewu.default)([
            $f105840484298cca$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("aeOhE", function(module, exports) {
$parcel$export(module.exports, "ForgeScreenEvent", () => $4abbcb40e7d1f348$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $4abbcb40e7d1f348$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $4abbcb40e7d1f348$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $4abbcb40e7d1f348$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $4abbcb40e7d1f348$export$14e56d7f5d3f917c);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $fohjD = parcelRequire("fohjD");

var $av1az = parcelRequire("av1az");

var $cud6T = parcelRequire("cud6T");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $eS29z = parcelRequire("eS29z");
var $dFqXL = parcelRequire("dFqXL");

var $4cTDP = parcelRequire("4cTDP");

var $9gq2c = parcelRequire("9gq2c");

var $lHVmb = parcelRequire("lHVmb");

var $33OIs = parcelRequire("33OIs");

var $52lsd = parcelRequire("52lsd");

var $ibOCX = parcelRequire("ibOCX");

var $lHD3D = parcelRequire("lHD3D");
const $4abbcb40e7d1f348$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        attributes: (0, $lHVmb.createAttributes)(attributes)
    });
const $4abbcb40e7d1f348$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $33OIs.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $4abbcb40e7d1f348$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $cud6T.useHasForgeAccess)();
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>(0, $lHVmb.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]);
    const fireEvent = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, (0, $ibOCX.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFqXL.MountEvent), {
        onMount: fireEvent
    });
};
const $4abbcb40e7d1f348$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $4abbcb40e7d1f348$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eJOHy.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eJOHy.useCallback)((error)=>(0, $lHVmb.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $9gq2c.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $4abbcb40e7d1f348$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $9gq2c.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $4cTDP.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $ibOCX.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>(0, $lHVmb.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $4abbcb40e7d1f348$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $fohjD.CUSTOM_FIELD_MODULE) || extensionModule === (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $fohjD.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $fohjD.GLOBAL_PAGE_MODULE),
        (0, $fohjD.ISSUE_ACTION_MODULE),
        (0, $fohjD.ISSUE_ACTIVITY_MODULE),
        (0, $fohjD.ISSUE_CONTEXT_MODULE),
        (0, $fohjD.ISSUE_GLANCE_MODULE),
        (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
        (0, $fohjD.ISSUE_PANEL_MODULE),
        (0, $fohjD.CUSTOM_FIELD_MODULE),
        (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE),
        (0, $fohjD.PROJECT_PAGE_MODULE),
        (0, $fohjD.ADMIN_PAGE_MODULE),
        (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE),
        (0, $fohjD.BACKLOG_ACTION_MODULE),
        (0, $fohjD.BOARD_ACTION_MODULE),
        (0, $fohjD.SPRINT_ACTION_MODULE),
        (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $4abbcb40e7d1f348$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $eJOHy.useRef)(performance.now());
        const isCustomUI = (0, $av1az.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eJOHy.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $4cTDP.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $ibOCX.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $4cTDP.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $av1az.getForgeUIType)(extension, entryPoint)
        }) : (0, $ibOCX.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $av1az.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eJOHy.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $52lsd.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $eJOHy.useEffect)(()=>{
            if (!$4abbcb40e7d1f348$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $eJOHy.useCallback)(()=>{
            extensionId && (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eJOHy.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $33OIs.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eJOHy.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("av1az", function(module, exports) {
$parcel$export(module.exports, "getForgeUIType", () => $8a41fb63fc571efc$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $8a41fb63fc571efc$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $8a41fb63fc571efc$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $8a41fb63fc571efc$export$42b85bc9b386c977);

var $8dH3d = parcelRequire("8dH3d");
const $8a41fb63fc571efc$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $8a41fb63fc571efc$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$8a41fb63fc571efc$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $8a41fb63fc571efc$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$8a41fb63fc571efc$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $8a41fb63fc571efc$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(propsToOverride)) return extension;
    const { resource: resource } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("cud6T", function(module, exports) {
$parcel$export(module.exports, "useHasForgeAccess", () => $5053d91b1becffd4$export$fd7f94d3d2bac7f2);

var $kh7bJ = parcelRequire("kh7bJ");
const $5053d91b1becffd4$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("eS29z", function(module, exports) {
$parcel$export(module.exports, "FireUiAnalytics", () => $b4c5cce20e83a7c8$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $b4c5cce20e83a7c8$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $b4c5cce20e83a7c8$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $b4c5cce20e83a7c8$export$2ccf161b817b43b);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");


var $kRgKj = parcelRequire("kRgKj");
// eslint-disable-next-line jira/react/no-class-components
class $b4c5cce20e83a7c8$var$FireComponent extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $kRgKj.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $b4c5cce20e83a7c8$export$64eb47d7b94ba089 = (0, $4J0ad.default)()($b4c5cce20e83a7c8$var$FireComponent);
const $b4c5cce20e83a7c8$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b4c5cce20e83a7c8$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $aa42ce8e355d58fa$export$a1562d08625f5d7e)
    });
const $b4c5cce20e83a7c8$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b4c5cce20e83a7c8$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $aa42ce8e355d58fa$export$947dac6c72b26f81)
    });
const $b4c5cce20e83a7c8$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b4c5cce20e83a7c8$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $aa42ce8e355d58fa$export$12346a674644c156)
    });
const $b4c5cce20e83a7c8$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b4c5cce20e83a7c8$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $aa42ce8e355d58fa$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("dFqXL", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $81e25a6f17368a9e$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");
// eslint-disable-next-line jira/react/no-class-components
class $81e25a6f17368a9e$var$MountEventComponent extends (0, $eJOHy.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $81e25a6f17368a9e$export$2c6963927dbc68f1 = (0, $4J0ad.default)()($81e25a6f17368a9e$var$MountEventComponent);

});

parcelRegister("33OIs", function(module, exports) {
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $e7e060e319be1e54$export$add44f896fb31ba3);

var $9gq2c = parcelRequire("9gq2c");

var $1GZq2 = parcelRequire("1GZq2");
const $e7e060e319be1e54$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("52lsd", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $002703e17238e395$export$5d3b06ab08af139e);

var $av1az = parcelRequire("av1az");

var $ePLco = parcelRequire("ePLco");
const $002703e17238e395$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $av1az.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});

parcelRegister("ibOCX", function(module, exports) {
$parcel$export(module.exports, "getEventId", () => $0853041cadec7561$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $0853041cadec7561$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $0853041cadec7561$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $0853041cadec7561$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $0853041cadec7561$export$644ccb9a67b9a9c1);

var $fohjD = parcelRequire("fohjD");

var $5IiZP = parcelRequire("5IiZP");

var $9gq2c = parcelRequire("9gq2c");
const $0853041cadec7561$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $0853041cadec7561$var$prepareModuleMode = (entryPoint)=>`${$0853041cadec7561$var$capitalizeFirstLetter(entryPoint)}`;
const $0853041cadec7561$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $0853041cadec7561$var$prepareModuleName = (moduleName)=>(0, $fohjD.SUPPORTED_MODULES).includes(moduleName) ? $0853041cadec7561$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $0853041cadec7561$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $9gq2c.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $0853041cadec7561$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $9gq2c.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $0853041cadec7561$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $0853041cadec7561$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $0853041cadec7561$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $9gq2c.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("1DW20", function(module, exports) {
$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $e508c293944e9913$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $e508c293944e9913$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $e508c293944e9913$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.GLOBAL_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $e508c293944e9913$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.GLOBAL_PAGE_MODULE),
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("5RW99", function(module, exports) {
$parcel$export(module.exports, "ADDON_ID", () => $6707b1635af3be3c$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $6707b1635af3be3c$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $6707b1635af3be3c$export$adf978edbdfaf080);
const $6707b1635af3be3c$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $6707b1635af3be3c$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    COMMUNICATIONS: 'COMMUNICATIONS',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    STATUS_PAGE_MANAGE: 'STATUS_PAGE_MANAGE',
    WORK_ITEM: 'WORK_ITEM'
};
const $6707b1635af3be3c$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    CONTENT: 'CONTENT',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS',
    OPERATIONS_GENERAL_CONFIGURATION: 'OPERATIONS_GENERAL_CONFIGURATION'
};

});

parcelRegister("bCMeR", function(module, exports) {
$parcel$export(module.exports, "AsyncDiscoverSection", () => $ba34a7ae9f3d559d$export$45fe6164578a6f29);
$parcel$export(module.exports, "AsyncDiscoverSectionPostOffice", () => $ba34a7ae9f3d559d$export$ab2150bd3d64c3e6);

var $bQWwW = parcelRequire("bQWwW");

const $ba34a7ae9f3d559d$export$45fe6164578a6f29 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dJtFs")).then((module)=>module.DiscoverSection), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/marketplace-recommendations/src/ui/discover-section/DiscoverSection.tsx"
});

const $ba34a7ae9f3d559d$export$ab2150bd3d64c3e6 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("8taSO")).then((module)=>module.DiscoverSectionPostOffice), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/marketplace-recommendations/src/ui/discover-section-post-office/DiscoverSectionPostOffice.tsx"
});

});
parcelRegister("dJtFs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7root").then(()=>parcelRequire('4ftBy'));

});

parcelRegister("8taSO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hbMg4").then(()=>parcelRequire('6l70f'));

});


parcelRegister("d51SR", function(module, exports) {
$parcel$export(module.exports, "Nav4ConnectMenuItem", () => $eb1ed74423963f34$export$d311b4cb0fdc0b92);

var $7A6yc = parcelRequire("7A6yc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jUPZ1 = parcelRequire("jUPZ1");

var $cGvTS = parcelRequire("cGvTS");

var $d9FRf = parcelRequire("d9FRf");

var $jJqSP = parcelRequire("jJqSP");
function $eb1ed74423963f34$export$d311b4cb0fdc0b92({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $7A6yc.default), queryRef);
    const { addNew: addNew } = (0, $jUPZ1.useConnectItemClickHistory)();
    const onClick = (0, $eJOHy.useCallback)((e, target, styleClass, url)=>{
        if (url == null) return;
        addNew(url);
        if (target == null) return;
        (0, $cGvTS.withConnectHost)((connectHost)=>{
            connectHost.triggerWebItem(target, styleClass, url);
        });
        if ((0, $cGvTS.isConnectDialogWebItem)(styleClass)) e.preventDefault();
    }, [
        addNew
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9FRf.Nav4AppMenuItem), {
        queryRef: data,
        onData: $eb1ed74423963f34$var$transformData,
        onClick: onClick
    });
}
/**
 * Data transformer for Connect.
 * We are going to convert multi-page Connect apps into single-page ones in case their subpages don't contain a url that matches the root one.
 * For more details, see {@link canHaveSubpages}.
 */ function $eb1ed74423963f34$var$transformData(data) {
    return (0, $jJqSP.canHaveSubpages)(data) ? data : {
        ...data,
        sections: null
    };
}

});
parcelRegister("7A6yc", function(module, exports) {
$parcel$export(module.exports, "default", () => $42c3c7e893b95b9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f245c96814deb8f505d2b497ec43b86d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $42c3c7e893b95b9e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ConnectMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$42c3c7e893b95b9e$var$node.hash = "76baf08d707245f4a5aadd384fd44056";
var $42c3c7e893b95b9e$export$2e2bcd8739ae039 = $42c3c7e893b95b9e$var$node;

});

parcelRegister("jUPZ1", function(module, exports) {
$parcel$export(module.exports, "useConnectItemClickHistory", () => $ae247c3dbe9b1cab$export$c251e3fda1cce4a3);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
// A single instance for the entire SPA session
const $ae247c3dbe9b1cab$var$history = {
    unique: []
};
const $ae247c3dbe9b1cab$export$c251e3fda1cce4a3 = ()=>{
    (0, $gRw8I.di)(window);
    const addNew = (0, $eJOHy.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $ae247c3dbe9b1cab$var$history.unique.push(historyItem);
    }, []);
    return (0, $eJOHy.useMemo)(()=>({
            history: $ae247c3dbe9b1cab$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $ae247c3dbe9b1cab$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $ae247c3dbe9b1cab$var$history.unique.length = 0;
};

});

parcelRegister("cGvTS", function(module, exports) {
$parcel$export(module.exports, "withConnectHost", () => $48374095cc5f91cb$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $48374095cc5f91cb$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $48374095cc5f91cb$export$920fb4b46d4f2eec);

var $tTBSc = parcelRequire("tTBSc");
const $48374095cc5f91cb$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $tTBSc.setupConnectJs)();
    action(connectHost);
};
const $48374095cc5f91cb$export$186d423c00af146c = ()=>window.connectHost;
const $48374095cc5f91cb$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("tTBSc", function(module, exports) {
$parcel$export(module.exports, "setupConnectJs", () => $c81546dab89b45de$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
var $4T9yL = parcelRequire("4T9yL");

var $4cTDP = parcelRequire("4cTDP");

var $4ayON = parcelRequire("4ayON");

const $c81546dab89b45de$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $4T9yL.waitForHeritage)();
    await (0, $4ayON.waitForJQuery)();
    const loader = await (parcelRequire("5sBPb"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $c81546dab89b45de$var$installConnectJsPromise = null;
const $c81546dab89b45de$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    if ($c81546dab89b45de$var$installConnectJsPromise != null && (0, $4cTDP.fg)('jira_dashboards_optimise_connect_loading')) return $c81546dab89b45de$var$installConnectJsPromise;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($c81546dab89b45de$var$installConnectJsPromise === null) $c81546dab89b45de$var$installConnectJsPromise = $c81546dab89b45de$var$installConnectJs();
        return $c81546dab89b45de$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    $c81546dab89b45de$var$installConnectJsPromise = (0, $gjeS9.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    await $c81546dab89b45de$var$installConnectJsPromise;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("gjeS9", function(module, exports) {
$parcel$export(module.exports, "loadBridge", () => $b5b36a00cf4f19d9$export$df8409da353bde5a);

var $ej5JA = parcelRequire("ej5JA");
var $1HTZw = parcelRequire("1HTZw");
var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");

var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");
var $ligZL = parcelRequire("ligZL");
var $jb3ni = parcelRequire("jb3ni");
const $b5b36a00cf4f19d9$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $ej5JA.MAX_RETRIES), timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $97BGz.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $1HTZw.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $agkbU.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("ej5JA", function(module, exports) {
$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $98246445188fd0a7$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $98246445188fd0a7$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $98246445188fd0a7$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $98246445188fd0a7$export$37f20f0ff732fcd7);

var $eSnSE = parcelRequire("eSnSE");
const { safeErrorWithoutCustomerData: $98246445188fd0a7$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $98246445188fd0a7$export$ea810ce67e3c8eac } = (0, $eSnSE.default);
const $98246445188fd0a7$export$1f86472c1374185a = 40;
const $98246445188fd0a7$export$7bd623b29ec8e1eb = 500;
const $98246445188fd0a7$export$37f20f0ff732fcd7 = true;

});

parcelRegister("1HTZw", function(module, exports) {
$parcel$export(module.exports, "loadBridgeBail", () => $d7bbb28cab06ad5d$export$a036f92c2465504e);

var $hztzA = parcelRequire("hztzA");

var $ej5JA = parcelRequire("ej5JA");
const $d7bbb28cab06ad5d$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $hztzA.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $hztzA.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("hztzA", function(module, exports) {
$parcel$export(module.exports, "safeStringify", () => $2f132eeb0cff0b18$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2f132eeb0cff0b18$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("agkbU", function(module, exports) {
$parcel$export(module.exports, "loadBridgeRace", () => $224e973e4c93da11$export$20c32b4579d78b92);

var $1HTZw = parcelRequire("1HTZw");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $224e973e4c93da11$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $iyT45.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $1HTZw.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("iyT45", function(module, exports) {
$parcel$export(module.exports, "loadBridgeWeak", () => $f6004e9afa2128c3$export$3cefda82396756a1);

var $6M1XZ = parcelRequire("6M1XZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $f6004e9afa2128c3$var$pollingSingleton = null;
const $f6004e9afa2128c3$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $f6004e9afa2128c3$var$pollingSingleton ?? (0, $6M1XZ.createPollingCollection)((v)=>window.require(v), 100);
    $f6004e9afa2128c3$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("6M1XZ", function(module, exports) {
$parcel$export(module.exports, "createPollingCollection", () => $0a667df7ad6c937e$export$f163446a982a8077);

var $gRw8I = parcelRequire("gRw8I");

var $2oJXr = parcelRequire("2oJXr");
const $0a667df7ad6c937e$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gRw8I.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $2oJXr.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $2oJXr.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("2oJXr", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b7015c609345acf$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $3b7015c609345acf$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("97BGz", function(module, exports) {
$parcel$export(module.exports, "loadBridgeStrict", () => $32e00fb40c944769$export$eba600d28decc4ac);

var $es5G8 = parcelRequire("es5G8");

var $4cTDP = parcelRequire("4cTDP");

var $bXaxC = parcelRequire("bXaxC");

var $agkbU = parcelRequire("agkbU");

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");

var $4T9yL = parcelRequire("4T9yL");
const $32e00fb40c944769$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR), isolatedFromHeritage: isolatedFromHeritage = false })=>{
    (0, $bXaxC.saveStats)(name, wrmKeys);
    if (!isolatedFromHeritage && (0, $4cTDP.fg)('jfp_magma_jira-report-early-strict-bridge')) {
        if (!(0, $4T9yL.isWRMHeritageLoaded)()) (0, $es5G8.captureException)(`loadBridgeStrict:${name}`, new Error('Do not call loadBridgeStrict without waitForHeritage'));
    }
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $7rBE0.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $agkbU.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("bXaxC", function(module, exports) {
$parcel$export(module.exports, "saveStats", () => $f1ca263307f66278$export$9ea3ff7978093559);
const $f1ca263307f66278$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $f1ca263307f66278$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $f1ca263307f66278$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $f1ca263307f66278$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $f1ca263307f66278$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f1ca263307f66278$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $f1ca263307f66278$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $f1ca263307f66278$var$initStats();
        // stop accumulating stats at TTI mark
        if ($f1ca263307f66278$var$isPageInteractive()) return;
        stats.requests += 1;
        $f1ca263307f66278$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$f1ca263307f66278$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $f1ca263307f66278$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("7rBE0", function(module, exports) {
$parcel$export(module.exports, "loadWrmResources", () => $09f989d08b38b1cb$export$6cda16b6eff75f59);

var $hztzA = parcelRequire("hztzA");

var $b6X3x = parcelRequire("b6X3x");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $09f989d08b38b1cb$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $iyT45.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $b6X3x.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $hztzA.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("b6X3x", function(module, exports) {
$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $aa5ee41b24db8c96$export$93d9db5fbabad1b0);

var $avFP5 = parcelRequire("avFP5");
let $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = false;
const $aa5ee41b24db8c96$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $aa5ee41b24db8c96$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded || $aa5ee41b24db8c96$var$isOnRapidBoardsPage()) return wrmKeys;
    $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = true;
    return (0, $avFP5.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("avFP5", function(module, exports) {
$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $00f9be664c96bf5d$export$f14a6b583ce9e077);
const $00f9be664c96bf5d$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});



parcelRegister("4T9yL", function(module, exports) {
$parcel$export(module.exports, "isWRMHeritageLoaded", () => $ba1950b07a7f2989$export$1a2b9c2d0a3d83ed);
$parcel$export(module.exports, "waitForHeritage", () => $ba1950b07a7f2989$export$c61060338d026f78);

var $hpZoI = parcelRequire("hpZoI");

var $2oJXr = parcelRequire("2oJXr");
let $ba1950b07a7f2989$var$heritageIsLoaded = false;
const $ba1950b07a7f2989$export$1a2b9c2d0a3d83ed = ()=>$ba1950b07a7f2989$var$heritageIsLoaded;
const $ba1950b07a7f2989$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        $ba1950b07a7f2989$var$heritageIsLoaded = false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $2oJXr.default)();
        (0, $hpZoI.bootstrapWrmClient)().then(()=>{
            $ba1950b07a7f2989$var$heritageIsLoaded = true;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("hpZoI", function(module, exports) {
$parcel$export(module.exports, "bootstrapWrmClient", () => $027e7c56f31b7541$export$d001f71dd306cb0c);

var $hgi0g = parcelRequire("hgi0g");

var $hztzA = parcelRequire("hztzA");

var $9pTd3 = parcelRequire("9pTd3");
const $027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $027e7c56f31b7541$var$fetchSpaWrmContext = async ()=>{
    return (0, $hgi0g.default)($027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $027e7c56f31b7541$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $027e7c56f31b7541$var$hasWrmInitialised;
const $027e7c56f31b7541$var$runBootstrap = ()=>{
    const spaWrmContext = $027e7c56f31b7541$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($027e7c56f31b7541$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                error: new Error((0, $hztzA.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $027e7c56f31b7541$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($027e7c56f31b7541$var$hasWrmInitialised) return $027e7c56f31b7541$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $027e7c56f31b7541$var$hasWrmInitialised = Promise.resolve();
    else $027e7c56f31b7541$var$hasWrmInitialised = $027e7c56f31b7541$var$runBootstrap();
    return $027e7c56f31b7541$var$hasWrmInitialised;
};

});



parcelRegister("ligZL", function(module, exports) {
$parcel$export(module.exports, "wrmRequire", () => $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("jb3ni", function(module, exports) {
$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $4b0178a6bf26b876$export$e53a5db19a39ed2f);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $4b0178a6bf26b876$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("4ayON", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $3de54a49c8727908$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $3de54a49c8727908$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $3de54a49c8727908$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $3de54a49c8727908$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $3de54a49c8727908$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $3de54a49c8727908$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $3de54a49c8727908$export$d690da9bc8146677);

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

const $3de54a49c8727908$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $3de54a49c8727908$export$7232a6dc780f9887 = ()=>AJS.$;
const $3de54a49c8727908$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public @atlassian/atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $3de54a49c8727908$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $3de54a49c8727908$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $3de54a49c8727908$var$FIVE_MINUTES = 300000;
const $3de54a49c8727908$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.AJS?.$ && (0, $4cTDP.fg)('jira_dashboards_optimise_connect_loading')) {
            resolve();
            return;
        }
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $3de54a49c8727908$var$FIVE_MINUTES);
    });
const $3de54a49c8727908$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $3de54a49c8727908$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $3de54a49c8727908$export$d690da9bc8146677 = [
    $3de54a49c8727908$export$cb954c21735b28e4,
    $3de54a49c8727908$export$7315c38dc71bd41f
];

});

parcelRegister("5sBPb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kwvFG").then(()=>parcelRequire('jh0iZ'));

});



parcelRegister("d9FRf", function(module, exports) {
$parcel$export(module.exports, "Nav4AppMenuItem", () => $1ba52292ee1c4fde$export$549160040f86c542);

var $anFKT = parcelRequire("anFKT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8n30H = parcelRequire("8n30H");
var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");
var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $aLENQ = parcelRequire("aLENQ");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $9ziuH = parcelRequire("9ziuH");

var $e5n8k = parcelRequire("e5n8k");

var $4qOre = parcelRequire("4qOre");
function $1ba52292ee1c4fde$export$549160040f86c542({ queryRef: queryRef, onData: onData, onClick: onClick }) {
    const rawData = (0, $j4oe4.useFragment)((0, $anFKT.default), queryRef);
    const data = (0, $eJOHy.useMemo)(()=>onData ? onData($1ba52292ee1c4fde$var$normalizeData(rawData)) : $1ba52292ee1c4fde$var$normalizeData(rawData), [
        onData,
        rawData
    ]);
    const icon = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e5n8k.AppIcon), {
            shouldChangeFillColor: !(0, $4cTDP.fg)('jira-nav-addon-icon-disable-color-filter'),
            iconUrl: data.iconUrl || ''
        }), [
        data.iconUrl
    ]);
    const withSeparators = (0, $eJOHy.useMemo)(()=>$1ba52292ee1c4fde$var$shouldUseSeparators(data), [
        data
    ]);
    const envLozenge = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ziuH.EnvLozenge), {
            label: data.envLabel || ''
        }), [
        data.envLabel
    ]);
    const actionsOnHover = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4qOre.AppActions), {
            settingsUrl: data.settingsUrl || '',
            appId: data.appId || ''
        }), [
        data.settingsUrl,
        data.appId
    ]);
    const expandable = (0, $eJOHy.useMemo)(()=>{
        if ((data.sections || []).length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ba52292ee1c4fde$var$MaybeExpandable, {
            actionsOnHover: actionsOnHover,
            appId: data.appId || '',
            envLozenge: envLozenge,
            icon: icon,
            label: data.label || 'Unknown app',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            menuIds: $1ba52292ee1c4fde$var$toExpandableMenuId(data.sections),
            itemId: data.appId || '',
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf)
        }, (data.sections || []).map((section, sectionIndex)=>(section?.links || []).length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), {
                key: `${sectionIndex}-${section?.label}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, withSeparators && sectionIndex > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8n30H.Divider), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ba52292ee1c4fde$var$MaybeExpandable, {
                appId: data.appId || '',
                label: section?.label || '',
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                menuIds: $1ba52292ee1c4fde$var$toExpandableMenuId([
                    {
                        links: section?.links
                    }
                ]),
                itemId: `section/${sectionIndex}`,
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1)
            }, (section?.links || []).map((link, linkIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ba52292ee1c4fde$var$SimpleItem, {
                    appId: data.appId || '',
                    key: link?.url || '',
                    label: link?.label || '',
                    onClick: onClick,
                    styleClass: link?.styleClass || '',
                    url: link?.url == null ? null : $1ba52292ee1c4fde$var$removeTrailingSlash(link?.url),
                    itemId: `section/${sectionIndex}/link/${linkIndex}`,
                    level: section?.label ? (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18) : (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1)
                })))))) : null));
    }, [
        data.sections,
        data.label,
        data.appId,
        icon,
        envLozenge,
        actionsOnHover,
        withSeparators,
        onClick
    ]);
    if (expandable) return expandable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ba52292ee1c4fde$var$SimpleItem, {
        actionsOnHover: actionsOnHover,
        appId: data.appId || '',
        envLozenge: envLozenge,
        icon: icon,
        label: data.label || 'Unknown app',
        onClick: onClick,
        styleClass: data.styleClass || '',
        url: data.url == null ? null : $1ba52292ee1c4fde$var$removeTrailingSlash(data.url || ''),
        itemId: data.appId || '',
        level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf)
    });
}
function $1ba52292ee1c4fde$var$SimpleItem({ actionsOnHover: actionsOnHover, appId: appId, envLozenge: envLozenge, icon: icon, label: label, onClick: onClick, styleClass: styleClass, url: url, itemId: itemId, level: level }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const anchorElement = (0, $eJOHy.useRef)(null);
    const onItemClick = (0, $eJOHy.useCallback)((e)=>{
        $1ba52292ee1c4fde$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level
        });
        onClick?.(e, anchorElement.current, styleClass || '', url);
    }, [
        url,
        onClick,
        itemId,
        appId,
        level,
        styleClass,
        createAnalyticsEvent
    ]);
    // If a Connect app does NOT have a URL, we should use a MenuButtonItem instead.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $1ba52292ee1c4fde$var$removeTrailingSlash(url ?? ''),
        elemBefore: icon,
        elemAfter: envLozenge,
        actionsOnHover: actionsOnHover,
        menuId: $1ba52292ee1c4fde$export$171d73a56172dba4(url ?? ''),
        ref: anchorElement,
        onClick: onItemClick
    }, label);
}
function $1ba52292ee1c4fde$var$MaybeExpandable(params) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { actionsOnHover: actionsOnHover, children: children, envLozenge: envLozenge, icon: icon, label: label, menuIds: menuIds, itemId: itemId, appId: appId, level: level } = params;
    const menuId = (0, $aLENQ.toMenuIdFromMenuIdList)(menuIds);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        $1ba52292ee1c4fde$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level,
            isExpandable: true
        });
    }, [
        createAnalyticsEvent,
        itemId,
        appId,
        level
    ]);
    const onExpansionToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) onClick();
    }, [
        onClick
    ]);
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: menuId,
        isExpanded: level !== (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        elemAfter: envLozenge,
        testId: (0, $azEgq.getTestId)(menuId),
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-apps' : undefined
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
}
function $1ba52292ee1c4fde$var$fireAppClickEvent(params) {
    const { event: event, itemId: itemId, appId: appId, level: level, isExpandable: isExpandable } = params;
    (0, $kRgKj.fireUIAnalytics)(event, {
        action: 'clicked',
        actionSubject: 'navigationItem',
        actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
        attributes: {
            level: level,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: itemId,
            isExpandable: isExpandable,
            section: 'yourApps',
            ...level === (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf) ? {
                itemType: (0, $6bf6536f83c22cfe$export$c3d83ca6855fa0d0)
            } : {
                itemType: (0, $6bf6536f83c22cfe$export$509e83d3c8d91279),
                parentItemId: appId,
                parentItemType: (0, $6bf6536f83c22cfe$export$c3d83ca6855fa0d0)
            }
        }
    });
}
function $1ba52292ee1c4fde$var$shouldUseSeparators(data) {
    for (const section of data.sections || []){
        if (section?.label) return false;
    }
    return true;
}
/**
 * Common data transformer.
 * Filters out sections with empty links.
 */ function $1ba52292ee1c4fde$var$normalizeData(data) {
    return {
        ...data,
        sections: (data.sections || []).filter((section)=>(section?.links || []).length > 0)
    };
}
const $1ba52292ee1c4fde$var$removeTrailingSlash = (url = '')=>url.replace(/\/$/, '');
const $1ba52292ee1c4fde$var$removeQueryParams = (url)=>url.split('?')[0];
const $1ba52292ee1c4fde$var$removeHash = (url)=>url.split('#')[0];
const $1ba52292ee1c4fde$export$171d73a56172dba4 = (path_ = '')=>{
    let path = path_;
    // This is the format we ask Connect vendors to use: /plugins/servlet/ac/:addonKey/:moduleKey
    // However, there are Connect apps that do not follow our recommendations and add extra path segments.
    // As result they might look like this: /plugins/servlet/ac/:addonKey/:moduleKey/:extraPathSegment
    // Because of that we have issues with menu ids matching since the path created out of current route differs from the actual url.
    // To fix this we remove those extra path segments from the url.
    if (path.startsWith('/plugins/servlet/ac/')) path = path.split('/').slice(0, 6).join('/');
    return (0, $h4Bzb.ENTITY_ID).APP($1ba52292ee1c4fde$var$removeTrailingSlash($1ba52292ee1c4fde$var$removeQueryParams($1ba52292ee1c4fde$var$removeHash(path))));
};
// Because of the apps nature, the parent url may differ from the child url.
// And if we want to make sure the expand state is properly calculated, we must pass down children menu ids.
const $1ba52292ee1c4fde$var$toExpandableMenuId = (sections)=>(sections || []).flatMap(({ links: links })=>(links || []).map((link)=>$1ba52292ee1c4fde$export$171d73a56172dba4(link.url)));

});
parcelRegister("anFKT", function(module, exports) {
$parcel$export(module.exports, "default", () => $633ea1bc46f9ad5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f1dd304f2b2075cf9083f0c067a308e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $633ea1bc46f9ad5a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    }, v1 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4AppMenuItem",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "ScalarField",
                "name": "envLabel"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraAppNavigationItemNestedLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v2 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "settingsUrl"
            },
            v2 /*: any*/ 
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$633ea1bc46f9ad5a$var$node.hash = "fe622bd16e14b11ec5e3f21d8553bac3";
var $633ea1bc46f9ad5a$export$2e2bcd8739ae039 = $633ea1bc46f9ad5a$var$node;

});

parcelRegister("8n30H", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $0a505da4c4c84dd7$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $0a505da4c4c84dd7$var$styles = null;
const $0a505da4c4c84dd7$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("hr", {
        /**
 * The existing usage of these dividers is presentational,
 * so we are removing the separator semantics by default.
 *
 * In the future we may consider allowing opt-in separator semantics,
 * but it probably isn't necessary.
 */ role: "none",
        className: (0, $hcewu.default)([
            "_h7alglyw _179rglyw _mqm27r9e _1bsb1osq"
        ])
    });

});

const $6bf6536f83c22cfe$export$9b8283d5878d2491 = 'board';
const $6bf6536f83c22cfe$export$c3d83ca6855fa0d0 = 'app';
const $6bf6536f83c22cfe$export$c1c49903035a02df = 'filter';
const $6bf6536f83c22cfe$export$6deee0e4f2fb784e = 'defaultFilter';
const $6bf6536f83c22cfe$export$4695c1a423ffe431 = 'dashboard';
const $6bf6536f83c22cfe$export$5828682c822c26e7 = 'queue';
const $6bf6536f83c22cfe$export$fe791c4fa892e400 = 'project';
const $6bf6536f83c22cfe$export$c303e491e026ebc6 = 'plan';
const $6bf6536f83c22cfe$export$509e83d3c8d91279 = 'appSubpage';
const $6bf6536f83c22cfe$export$a2e7d1d0a3d169f4 = 'asset';
const $6bf6536f83c22cfe$export$b56168d831461ce2 = 'operation';
const $6bf6536f83c22cfe$export$499a3e77858b7713 = 'translationGroup';
const $6bf6536f83c22cfe$export$bb8a37ab8d9ba82b = 'roadmap';
const $6bf6536f83c22cfe$export$9a778ca616c24a93 = 'projectRecommendation';
const $6bf6536f83c22cfe$export$9cbb0f231a0ab7ea = 'overview';
const $6bf6536f83c22cfe$export$119dad133da0b4a = 'changeView';

parcelRegister("9ziuH", function(module, exports) {
$parcel$export(module.exports, "EnvLozenge", () => $aa2d3153d967637d$export$61c90f482f9775c6);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");
function $aa2d3153d967637d$export$61c90f482f9775c6({ label: label }) {
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: label === 'Dev' ? 'default' : 'moved'
    }, label) : null;
}

});

parcelRegister("e5n8k", function(module, exports) {
$parcel$export(module.exports, "AppIcon", () => $dede81b109af0626$export$5153830bdfb71453);

var $eJOHy = parcelRequire("eJOHy");

var $kcLaf = parcelRequire("kcLaf");

var $aNxjx = parcelRequire("aNxjx");
function $dede81b109af0626$export$5153830bdfb71453({ iconUrl: iconUrl, shouldChangeFillColor: shouldChangeFillColor }) {
    return iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNxjx.IconCustom), {
        url: iconUrl,
        shouldChangeFillColor: shouldChangeFillColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });
}

});
parcelRegister("aNxjx", function(module, exports) {
$parcel$export(module.exports, "IconCustom", () => $af7800a3ad437605$export$5b6504ec6adf0047);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bnf52 = parcelRequire("bnf52");
// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const $af7800a3ad437605$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
const $af7800a3ad437605$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, ariaLabelledBy: ariaLabelledBy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af7800a3ad437605$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("feColorMatrix", {
        type: "matrix",
        values: $af7800a3ad437605$var$colorMatrixValues
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "20",
        height: "20",
        x: "0",
        y: "0",
        filter: shouldChangeFillColor && (0, $bnf52.checkForSvg)(url) ? 'url(#changeFillColor)' : '',
        "aria-labelledby": ariaLabelledBy
    })));
};
const $af7800a3ad437605$var$styles = (0, $1DXK0.xcss)({
    display: 'inline-block',
    margin: 'space.025',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
});

});
parcelRegister("bnf52", function(module, exports) {
$parcel$export(module.exports, "checkForSvg", () => $92e7a4811c111a7f$export$9a369805b0fabb72);
const $92e7a4811c111a7f$export$9a369805b0fabb72 = (url)=>{
    const fileType = url.split(/#|\?/)[0].split('.').pop();
    // falsey check is for Ts
    return fileType ? fileType.trim() === 'svg' : false;
};

});



parcelRegister("4qOre", function(module, exports) {
$parcel$export(module.exports, "AppActions", () => $faae41806519ec51$export$6b031ef628e5f9c2);

var $eJOHy = parcelRequire("eJOHy");

var $4F5bb = parcelRequire("4F5bb");

var $f58rc = parcelRequire("f58rc");
var $6YEko = parcelRequire("6YEko");

var $lRq8t = parcelRequire("lRq8t");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8z6Yy = parcelRequire("8z6Yy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $03ZmM = parcelRequire("03ZmM");
const $faae41806519ec51$var$NavMenuItems = ({ onClose: onClose, onTrackClick: onTrackClick, settingsUrl: settingsUrl })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        onTrackClick();
        onClose?.(event);
    }, [
        onClose,
        onTrackClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        href: settingsUrl,
        target: "_blank",
        onClick: handleClick
    }, formatMessage((0, $03ZmM.default).appSettings)));
};
function $faae41806519ec51$export$6b031ef628e5f9c2({ settingsUrl: settingsUrl, appId: appId, onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOpenEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
                itemId: 'meatballDropdown',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireClickEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                componentType: (0, $493796f3bdee881c$export$5374c2c2d3ece55e),
                parentItemId: appId,
                parentItemType: (0, $6bf6536f83c22cfe$export$c3d83ca6855fa0d0),
                itemId: 'appSettings',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent,
        appId
    ]);
    const MenuItems = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($faae41806519ec51$var$NavMenuItems, {
            onClose: props.onClose,
            onTrackClick: fireClickEvent,
            settingsUrl: settingsUrl
        }), [
        fireClickEvent,
        settingsUrl
    ]);
    if (!settingsUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: MenuItems,
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}

});
parcelRegister("03ZmM", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b933410087aba60$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0b933410087aba60$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    appSettings: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.app-actions.app-settings",
        "defaultMessage": "App settings"
    }
});

});




parcelRegister("ja8Li", function(module, exports) {
$parcel$export(module.exports, "Nav4ForgeMenuItem", () => $ce65831c25c6979c$export$9d5c2149f38ae387);

var $883ZT = parcelRequire("883ZT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $d9FRf = parcelRequire("d9FRf");
function $ce65831c25c6979c$export$9d5c2149f38ae387({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $883ZT.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9FRf.Nav4AppMenuItem), {
        queryRef: data
    });
}

});
parcelRegister("883ZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $74cb1553dc0c6328$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3988ad3da7c9b5f6abf2f3718a010e31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $74cb1553dc0c6328$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ForgeMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$74cb1553dc0c6328$var$node.hash = "e6f8d3ee567e6cd74addae3ad5622034";
var $74cb1553dc0c6328$export$2e2bcd8739ae039 = $74cb1553dc0c6328$var$node;

});


parcelRegister("diXvx", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdff9f38b459b2b0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cdff9f38b459b2b0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    yourApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.content.your-apps",
        "defaultMessage": "Your apps"
    }
});

});



parcelRegister("6HiqT", function(module, exports) {
$parcel$export(module.exports, "Nav4AppsSpotlightWrapper", () => $7f16a884d0b673ca$export$d148eb6657a374a);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dyM1L = parcelRequire("dyM1L");

var $5Xqpk = parcelRequire("5Xqpk");

var $4cTDP = parcelRequire("4cTDP");
function $7f16a884d0b673ca$export$d148eb6657a374a({ children: children }) {
    const [{ hasOpened: shouldShowNudge }] = (0, $5Xqpk.useHasOpened)();
    if ((0, $4cTDP.fg)('jira_onboarding_experiences_a11y_fixes')) return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7f16a884d0b673ca$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyM1L.NavigationAppsNavItemWrapperNudgeAsync), null, children)) : children;
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyM1L.NavigationAppsNavItemWrapperNudgeAsync), null, children) : children;
}
const $7f16a884d0b673ca$var$fullWidthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("dyM1L", function(module, exports) {
$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", () => $c11b16e6136d5661$export$c143067f544307f);

var $eJOHy = parcelRequire("eJOHy");


var $kMreM = parcelRequire("kMreM");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c11b16e6136d5661$var$NavigationAppsNavItemLazy = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("dPE2F")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-apps/index.tsx"
});
const $c11b16e6136d5661$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $2b839a8453de5367$export$dd63d0099d95ba4f),
        fallback: children,
        attributes: {
            nudgeId: (0, $2b839a8453de5367$export$dd63d0099d95ba4f)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "navigation-apps-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c11b16e6136d5661$var$NavigationAppsNavItemLazy, {
        nudgeId: (0, $2b839a8453de5367$export$dd63d0099d95ba4f),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("kMreM", function(module, exports) {
$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $373b41d996461548$export$3915a8814b99f0b);

var $eJOHy = parcelRequire("eJOHy");

var $hLlIx = parcelRequire("hLlIx");

var $9ycBx = parcelRequire("9ycBx");
const $373b41d996461548$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hLlIx.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $9ycBx.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("hLlIx", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $8e7d43321aea4f70$export$9171acf2e93b7d4d);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $eYe3w = parcelRequire("eYe3w");
const $8e7d43321aea4f70$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $eYe3w.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("eYe3w", function(module, exports) {
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $638881997835b97e$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $638881997835b97e$export$807be5f3f1ea996);

var $eJOHy = parcelRequire("eJOHy");

var $7Jk3f = parcelRequire("7Jk3f");
const $638881997835b97e$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7Jk3f.isLoaderError)(error)
    });
const $638881997835b97e$export$807be5f3f1ea996 = (attributes = {})=>(0, $eJOHy.useCallback)((error)=>({
            ...attributes,
            ...$638881997835b97e$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



parcelRegister("dPE2F", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cuOju").then(()=>parcelRequire('iyJtd'));

});


parcelRegister("5Xqpk", function(module, exports) {
$parcel$export(module.exports, "useHasOpened", () => $4d9973b57b668a8c$export$cbaabcded53b5c1f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $eqSON = parcelRequire("eqSON");
const $4d9973b57b668a8c$var$actions = {
    setHasOpened: $eqSON.setHasOpened
};
const $4d9973b57b668a8c$var$initialState = {
    hasOpened: false
};
const $4d9973b57b668a8c$var$Store = (0, $GtRbT.createStore)({
    initialState: $4d9973b57b668a8c$var$initialState,
    actions: $4d9973b57b668a8c$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $4d9973b57b668a8c$export$cbaabcded53b5c1f = (0, $iJq0l.createHook)($4d9973b57b668a8c$var$Store);

});
parcelRegister("eqSON", function(module, exports) {
$parcel$export(module.exports, "setHasOpened", () => $7ce6edfb96d1ed93$export$c4743c64a7c42294);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $7ce6edfb96d1ed93$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $7ce6edfb96d1ed93$export$2e2bcd8739ae039 = $7ce6edfb96d1ed93$export$c4743c64a7c42294;

});





parcelRegister("4P1EM", function(module, exports) {
$parcel$export(module.exports, "Nav4Assets", () => $d0b0fde800fdbbb7$export$ae278c7655ee6005);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8XHsn = parcelRequire("8XHsn");

var $jopyG = parcelRequire("jopyG");

var $gfvms = parcelRequire("gfvms");

var $koAZ4 = parcelRequire("koAZ4");

var $4cTDP = parcelRequire("4cTDP");

var $b2MSM = parcelRequire("b2MSM");

var $6ANkN = parcelRequire("6ANkN");
function $d0b0fde800fdbbb7$export$ae278c7655ee6005({ isExpanded: isExpanded }) {
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // useInsightVisibility can help fetch WorkspaceId
    const _ = (0, $8XHsn.useInsightVisibility)();
    const isPremiumUser = (0, $jopyG.isLicensedPremiumUser)(tenantContext);
    const { workspaceId: workspaceId } = (0, $8XHsn.useWorkspaceContext)();
    if (!isPremiumUser) {
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
        if ((0, $4cTDP.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ANkN.AssetsAppItem), {
            showUpsell: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2MSM.AssetsSingleMenuItem), {
            showUpsellLozenge: true
        });
    }
    if ((0, $4cTDP.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ANkN.AssetsAppItem), {
        showUpsell: false
    });
    return workspaceId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfvms.InsightGlobalConfigContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        disableOnInit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2MSM.AssetsMenu), {
        isExpanded: isExpanded
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2MSM.AssetsSingleMenuItem), {
        showUpsellLozenge: false
    });
}

});
parcelRegister("8XHsn", function(module, exports) {
$parcel$export(module.exports, "useWorkspaceContext", () => $5dc043f4942dc6a4$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $5dc043f4942dc6a4$export$74ebc9a49f60d38a);

var $eJOHy = parcelRequire("eJOHy");

var $7cSYk = parcelRequire("7cSYk");

var $koAZ4 = parcelRequire("koAZ4");

var $eJrcF = parcelRequire("eJrcF");

var $jopyG = parcelRequire("jopyG");

var $ePaI2 = parcelRequire("ePaI2");
const $5dc043f4942dc6a4$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $5dc043f4942dc6a4$export$122fccf0bbbc9acc = 30000;
const $5dc043f4942dc6a4$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $eJrcF.useResource)((0, $ePaI2.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $5dc043f4942dc6a4$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $eJOHy.useRef)(callback);
    // Remember the latest callback.
    (0, $eJOHy.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $eJOHy.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $5dc043f4942dc6a4$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5dc043f4942dc6a4$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $eJOHy.useState)((0, $7cSYk.isCMDBEnabledInEnvironment)() && (0, $jopyG.isLicensedPremiumUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $eJOHy.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $eJOHy.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $eJOHy.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $eJOHy.useEffect)(()=>{
        if (!hasFetchedWorkspaceId && !workspaceId && (0, $jopyG.isLicensedPremiumUser)(tenantContext) && (0, $7cSYk.isCMDBEnabledInEnvironment)()) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        hasFetchedWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $5dc043f4942dc6a4$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $5dc043f4942dc6a4$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $eJOHy.useEffect)(()=>{
        if (hasFetchedWorkspaceId && !loading) {
            if ((0, $jopyG.isLicensedPremiumUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});

parcelRegister("gfvms", function(module, exports) {
$parcel$export(module.exports, "useInsightGlobalConfig", () => $f3f6dcb6436f3bd8$export$ee996472bb397b41);
$parcel$export(module.exports, "useInsightReferenceTypes", () => $f3f6dcb6436f3bd8$export$efb93af726a65b26);
$parcel$export(module.exports, "useInsightStatusTypes", () => $f3f6dcb6436f3bd8$export$7eefa9cea32e596a);
$parcel$export(module.exports, "useInsightIcons", () => $f3f6dcb6436f3bd8$export$8336b36336c9f3c8);
$parcel$export(module.exports, "useDataManager", () => $f3f6dcb6436f3bd8$export$143bcc72da01e561);
$parcel$export(module.exports, "useCommonDataModel", () => $f3f6dcb6436f3bd8$export$a6f0c60c6d8cb283);
$parcel$export(module.exports, "useNamedInsightIcons", () => $f3f6dcb6436f3bd8$export$979b264266dab4ed);
$parcel$export(module.exports, "useIsRestrictedSchema", () => $f3f6dcb6436f3bd8$export$d07372ba961b2bc5);
$parcel$export(module.exports, "InsightGlobalConfigContainer", () => $f3f6dcb6436f3bd8$export$c4c69c73d422ea06);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

var $1oAOi = parcelRequire("1oAOi");

var $3rcO4 = parcelRequire("3rcO4");
const $f3f6dcb6436f3bd8$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    config: undefined,
    referenceTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    statusTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    icons: {
        data: undefined,
        deleteLoading: false,
        deleteError: undefined,
        addLoading: false,
        addError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    dataManager: {
        rolesData: undefined,
        rolesError: undefined,
        rolesLoading: false,
        rolesUpdateLoading: false,
        rolesUpdateError: undefined,
        tokensLoading: false,
        tokensData: undefined,
        tokensError: undefined,
        tokenRevokeLoading: false,
        tokenRevokeError: undefined,
        isProvisioned: undefined,
        provisioningLoading: false,
        provisioningError: undefined,
        provisioningUpdateLoading: false,
        provisioningUpdateError: undefined,
        myRoles: undefined,
        myRolesError: undefined,
        myRolesLoading: false
    },
    cdm: {
        instantiations: undefined,
        tasks: []
    }
};
const $f3f6dcb6436f3bd8$var$Store = (0, $GtRbT.createStore)({
    initialState: $f3f6dcb6436f3bd8$export$d4c72bab9d6cc13a,
    actions: $1oAOi.actions
});
const $f3f6dcb6436f3bd8$export$ee996472bb397b41 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: (state)=>state
});
const $f3f6dcb6436f3bd8$export$efb93af726a65b26 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ referenceTypes: referenceTypes })=>({
            ...referenceTypes,
            data: referenceTypes.data ? (0, $3rcO4.sortReferenceTypes)(referenceTypes.data) : undefined
        })
});
const $f3f6dcb6436f3bd8$export$7eefa9cea32e596a = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ statusTypes: statusTypes })=>({
            ...statusTypes,
            data: statusTypes.data ? (0, $3rcO4.sortStatusTypes)(statusTypes.data) : undefined
        })
});
const $f3f6dcb6436f3bd8$export$8336b36336c9f3c8 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ icons: icons })=>icons
});
const $f3f6dcb6436f3bd8$export$143bcc72da01e561 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ dataManager: dataManager })=>dataManager
});
const $f3f6dcb6436f3bd8$export$a6f0c60c6d8cb283 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ cdm: cdm })=>cdm
});
const $f3f6dcb6436f3bd8$export$979b264266dab4ed = (0, $iJq0l.createStateHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ icons: icons })=>{
        const map = {};
        (icons.data ?? []).forEach((icon)=>{
            map[icon.name] = icon;
        });
        return map;
    }
});
const $f3f6dcb6436f3bd8$export$9c8eee3abcaa634e = (state, schemaId)=>{
    const restrictedObjectSchemaIds = state.config?.restrictedObjectSchemaIds ?? [];
    return restrictedObjectSchemaIds.includes(parseInt(schemaId, 10));
};
const $f3f6dcb6436f3bd8$export$d07372ba961b2bc5 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: $f3f6dcb6436f3bd8$export$9c8eee3abcaa634e
});
const $f3f6dcb6436f3bd8$var$autoFetchGlobalConfig = ()=>({ dispatch: dispatch, getState: getState }, { disableOnInit: disableOnInit })=>{
        const { loading: loading, error: error, config: config } = getState();
        if (!disableOnInit && !loading && !error && !config) {
            dispatch((0, $1oAOi.actions).fetchGlobalConfig());
            if ((0, $4cTDP.fg)('assets_cdm_ui_flow')) dispatch((0, $1oAOi.actions).fetchCdm());
            if ((0, $4cTDP.fg)('assets_as_an_app_v2')) {
                dispatch((0, $1oAOi.actions).fetchProvisioningStatus());
                dispatch((0, $1oAOi.actions).fetchMyDataManagerRoles());
            }
        }
    };
const $f3f6dcb6436f3bd8$export$c4c69c73d422ea06 = (0, $6E16M.createContainer)($f3f6dcb6436f3bd8$var$Store, {
    onInit: $f3f6dcb6436f3bd8$var$autoFetchGlobalConfig
});

});
parcelRegister("1oAOi", function(module, exports) {
$parcel$export(module.exports, "actions", () => $9296c6c643eaa82b$export$e324594224ef24da);

var $fIoaM = parcelRequire("fIoaM");

var $iJT9U = parcelRequire("iJT9U");

var $2C4Rj = parcelRequire("2C4Rj");

var $h47uz = parcelRequire("h47uz");

var $cV2bE = parcelRequire("cV2bE");

var $iPKXq = parcelRequire("iPKXq");

var $By5DJ = parcelRequire("By5DJ");

var $6Cb8J = parcelRequire("6Cb8J");

var $lGsG0 = parcelRequire("lGsG0");

var $5bX6s = parcelRequire("5bX6s");

var $gZE7d = parcelRequire("gZE7d");

var $4rYWs = parcelRequire("4rYWs");

var $gD7PH = parcelRequire("gD7PH");

var $fiFnI = parcelRequire("fiFnI");

var $fHTJ8 = parcelRequire("fHTJ8");

var $3Zqe3 = parcelRequire("3Zqe3");

var $2La61 = parcelRequire("2La61");

var $gVUS4 = parcelRequire("gVUS4");
const $9296c6c643eaa82b$export$e324594224ef24da = {
    addIcon: $fIoaM.addIcon,
    createReferenceType: $iJT9U.createReferenceType,
    createStatusType: $2C4Rj.createStatusType,
    deleteIcon: $h47uz.deleteIcon,
    deleteReferenceType: $cV2bE.deleteReferenceType,
    deleteStatusType: $iPKXq.deleteStatusType,
    fetchCdm: $4rYWs.fetchCdm,
    fetchDataManagerTokens: $gZE7d.fetchDataManagerTokens,
    fetchGlobalConfig: $By5DJ.fetchGlobalConfig,
    fetchMyDataManagerRoles: $6Cb8J.fetchMyDataManagerRoles,
    fetchPrincipalsForRoles: $lGsG0.fetchPrincipalsForRoles,
    fetchProvisioningStatus: $5bX6s.fetchProvisioningStatus,
    installCdm: $gD7PH.installCdm,
    setIcon: $fHTJ8.setIcon,
    setReferenceType: $2La61.setReferenceType,
    setStatusType: $gVUS4.setStatusType,
    updateDataManagerRole: $fiFnI.updateDataManagerRole,
    updateIcon: $fHTJ8.updateIcon,
    updateProvisioningStatus: $3Zqe3.updateProvisioningStatus,
    updateReferenceType: $2La61.updateReferenceType,
    updateStatusType: $gVUS4.updateStatusType
};

});
parcelRegister("fIoaM", function(module, exports) {
$parcel$export(module.exports, "addIcon", () => $d0ee33600976fc3c$export$3488242433cbedb);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $5HQxN = parcelRequire("5HQxN");

var $6hqfW = parcelRequire("6hqfW");
const $d0ee33600976fc3c$export$3488242433cbedb = (newIcon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                addLoading: true
            }
        });
        try {
            const uploadCredentials = await (0, $6hqfW.mediaInfoForUpload)(workspaceId);
            const uploadMediaResult = await (0, $6hqfW.mediaUploadFile)({
                mediaBaseUrl: (0, $5HQxN.toMediaBaseUrl)(uploadCredentials.mediaBaseUrl),
                collectionId: (0, $5HQxN.toCollectionId)(uploadCredentials.collectionId),
                fileName: (0, $5HQxN.toFileName)(newIcon.fileName),
                clientId: (0, $5HQxN.toMediaClientId)(uploadCredentials.clientId),
                mediaJwtToken: (0, $5HQxN.toMediaJwt)(uploadCredentials.mediaJwtToken),
                blob: newIcon.blob
            });
            const mediaInfoForPullingResult = await (0, $6hqfW.mediaInfoForPulling)(workspaceId, (0, $5HQxN.toMediaFileUuid)(uploadMediaResult.data.id));
            const pollMediaFileReady = ()=>{
                const getMediaFileStatus = ()=>(0, $6hqfW.mediaGetFileInfo)({
                        mediaBaseUrl: (0, $5HQxN.toMediaBaseUrl)(mediaInfoForPullingResult.mediaBaseUrl),
                        mediaFileUuid: (0, $5HQxN.toMediaFileUuid)(uploadMediaResult.data.id),
                        clientId: (0, $5HQxN.toMediaClientId)(uploadCredentials.clientId),
                        mediaJwtToken: (0, $5HQxN.toMediaJwt)(mediaInfoForPullingResult.mediaJwtToken)
                    });
                return new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                reject)=>{
                    const poll = (attempt = 0)=>{
                        const statusPromise = getMediaFileStatus();
                        statusPromise.then((response)=>{
                            const status = response.data.processingStatus;
                            switch(status){
                                default:
                                case (0, $5HQxN.MEDIA_PROCESS_STATUS).PENDING:
                                case (0, $5HQxN.MEDIA_PROCESS_STATUS).RUNNING:
                                    return setTimeout(()=>{
                                        // 20 tries before throwing an error
                                        if (attempt > 20) return reject(new Error('Failed to add icon after 10 tries'));
                                        return poll(attempt + 1);
                                    }, 5000);
                                case (0, $5HQxN.MEDIA_PROCESS_STATUS).SUCCEEDED:
                                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                                    return resolve();
                                case (0, $5HQxN.MEDIA_PROCESS_STATUS).FAILED:
                                    return reject(new Error('Media services failed to process file!'));
                            }
                        }).catch((error)=>reject(new Error(error)));
                    };
                    poll();
                });
            };
            await pollMediaFileReady();
            const savedIconEntry = await (0, $6hqfW.publishNewIcon)(workspaceId, (0, $5HQxN.toIconName)(newIcon.iconName), (0, $5HQxN.toMediaFileUuid)(uploadMediaResult.data.id));
            // Make flow happy
            if (!Array.isArray(state.icons.data)) throw new Error('Invalid state! Icons data is not array!');
            const newIconsData = state.icons.data.slice(0);
            newIconsData.unshift(savedIconEntry);
            const newState = {
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    data: newIconsData
                }
            };
            setState(newState);
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'addIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    addError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'addIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("51aj0", function(module, exports) {
$parcel$export(module.exports, "fireCmdbErrorAnalytics", () => $56baf2f8ac73469d$export$50d4fa14efd248c2);

var $9pTd3 = parcelRequire("9pTd3");
const $56baf2f8ac73469d$export$50d4fa14efd248c2 = (payload)=>{
    return (0, $9pTd3.fireErrorAnalytics)(payload);
};

});

parcelRegister("5HQxN", function(module, exports) {
$parcel$export(module.exports, "MEDIA_PROCESS_STATUS", () => $687072a3a8f399e1$export$a760cae7c12e7f51);
$parcel$export(module.exports, "toMediaBaseUrl", () => $687072a3a8f399e1$export$342e5c2fdd47297c);
$parcel$export(module.exports, "toCollectionId", () => $687072a3a8f399e1$export$59b8a2c37e183bf5);
$parcel$export(module.exports, "toIconName", () => $687072a3a8f399e1$export$41540e96af228b1a);
$parcel$export(module.exports, "toFileName", () => $687072a3a8f399e1$export$249aa0c12095aafd);
$parcel$export(module.exports, "toMediaJwt", () => $687072a3a8f399e1$export$dce78fe68aa68f20);
$parcel$export(module.exports, "toMediaFileUuid", () => $687072a3a8f399e1$export$79083a8ab294d28e);
$parcel$export(module.exports, "toMediaClientId", () => $687072a3a8f399e1$export$b105972f97cb69fa);
const $687072a3a8f399e1$export$a760cae7c12e7f51 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
    RUNNING: 'running'
};
const $687072a3a8f399e1$export$342e5c2fdd47297c = (url)=>url;
const $687072a3a8f399e1$export$59b8a2c37e183bf5 = (uuid)=>uuid;
const $687072a3a8f399e1$export$41540e96af228b1a = (iconName)=>iconName;
const $687072a3a8f399e1$export$249aa0c12095aafd = (fileName)=>fileName;
const $687072a3a8f399e1$export$9dd52a3c923cba73 = (mediaIssuer)=>mediaIssuer;
const $687072a3a8f399e1$export$dce78fe68aa68f20 = (mediaIssuer)=>mediaIssuer;
const $687072a3a8f399e1$export$79083a8ab294d28e = (mediaFileUuid)=>mediaFileUuid;
const $687072a3a8f399e1$export$b105972f97cb69fa = (mediaClientId)=>mediaClientId;

});

parcelRegister("6hqfW", function(module, exports) {
$parcel$export(module.exports, "mediaInfoForUpload", () => $5faeeb81fc4d556d$export$c7944179dc1cb15d);
$parcel$export(module.exports, "mediaUploadFile", () => $5faeeb81fc4d556d$export$6fba374ded90c76b);
$parcel$export(module.exports, "mediaInfoForPulling", () => $5faeeb81fc4d556d$export$4138ca7fa1c5dcbc);
$parcel$export(module.exports, "mediaGetFileInfo", () => $5faeeb81fc4d556d$export$c607c6f99a3a53ca);
$parcel$export(module.exports, "publishNewIcon", () => $5faeeb81fc4d556d$export$a7fc7d8db8ccf9da);

var $3ugTQ = parcelRequire("3ugTQ");

var $u4YbY = parcelRequire("u4YbY");

var $lqJW7 = parcelRequire("lqJW7");
const $5faeeb81fc4d556d$export$336c36f125eba39c = ({ clientId: clientId, mediaJwtToken: mediaJwtToken })=>{
    return {
        'X-Client-Id': clientId,
        Authorization: `Bearer ${mediaJwtToken}`
    };
};
const $5faeeb81fc4d556d$export$c7944179dc1cb15d = (workspaceId)=>(0, $u4YbY.performCmdbGetRequest)((0, $lqJW7.getCmdbIconTokenUploadingUrl)(workspaceId));
const $5faeeb81fc4d556d$export$6fba374ded90c76b = ({ mediaBaseUrl: mediaBaseUrl, collectionId: collectionId, fileName: fileName, mediaJwtToken: mediaJwtToken, blob: blob, clientId: clientId })=>(0, $3ugTQ.performPostRequest)(`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(fileName)}&deletable=true`, {
        headers: {
            ...$5faeeb81fc4d556d$export$336c36f125eba39c({
                clientId: clientId,
                mediaJwtToken: mediaJwtToken
            }),
            'Content-Type': blob.type
        },
        body: blob
    });
const $5faeeb81fc4d556d$export$4138ca7fa1c5dcbc = (workspaceId, fileUuid)=>(0, $u4YbY.performCmdbGetRequest)((0, $lqJW7.getCmdbIconTokenFetchingUrl)(workspaceId, fileUuid));
const $5faeeb81fc4d556d$export$c607c6f99a3a53ca = ({ mediaBaseUrl: mediaBaseUrl, mediaFileUuid: mediaFileUuid, mediaJwtToken: mediaJwtToken, clientId: clientId })=>(0, $3ugTQ.performGetRequest)(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
        headers: $5faeeb81fc4d556d$export$336c36f125eba39c({
            clientId: clientId,
            mediaJwtToken: mediaJwtToken
        })
    });
const $5faeeb81fc4d556d$export$a7fc7d8db8ccf9da = (workspaceId, iconName, mediaFileUuid)=>(0, $u4YbY.performCmdbPostRequest)((0, $lqJW7.getCmdbIconCreateUrl)(workspaceId), {
        body: JSON.stringify({
            name: iconName,
            mediaFileUuid: mediaFileUuid
        })
    });

});
parcelRegister("lqJW7", function(module, exports) {
$parcel$export(module.exports, "getCmdbIconCreateUrl", () => $20ff293724bf60de$export$4c6ff27b48881aba);
$parcel$export(module.exports, "getCmdbIconTokenFetchingUrl", () => $20ff293724bf60de$export$39e83f10cc93fe99);
$parcel$export(module.exports, "getCmdbIconTokenUploadingUrl", () => $20ff293724bf60de$export$7fdc9cd59a492763);
$parcel$export(module.exports, "getCmdbIconByIdUrl", () => $20ff293724bf60de$export$b881a625e1bc4876);

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon
 */ const $20ff293724bf60de$var$getCmdbIconUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/icon`;
const $20ff293724bf60de$export$4c6ff27b48881aba = (workspaceId)=>`${$20ff293724bf60de$var$getCmdbIconUrl(workspaceId)}/create`;
const $20ff293724bf60de$export$39e83f10cc93fe99 = (workspaceId, fileUuid)=>`${$20ff293724bf60de$var$getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
const $20ff293724bf60de$export$7fdc9cd59a492763 = (workspaceId)=>`${$20ff293724bf60de$var$getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
const $20ff293724bf60de$export$b881a625e1bc4876 = (workspaceId, iconId)=>`${$20ff293724bf60de$var$getCmdbIconUrl(workspaceId)}/${iconId}`;

});
parcelRegister("1qZG3", function(module, exports) {
$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $b2cddbf560b62359$export$28b6c003daedf1c2);
const $b2cddbf560b62359$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});




parcelRegister("iJT9U", function(module, exports) {
$parcel$export(module.exports, "createReferenceType", () => $64fa609e4fb44864$export$ac28770630794807);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $64fa609e4fb44864$export$ac28770630794807 = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPostRequest)((0, $fKDKn.getCmdbConfigReferenceTypeUrl)(workspaceId), {
                body: JSON.stringify({
                    ...data,
                    color: data.color.replace('#', '')
                })
            });
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    data: [
                        ...state.referenceTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'createReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("fKDKn", function(module, exports) {
$parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", () => $d87cbbb4189fe650$export$3269d36b59c9d27f);
$parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", () => $d87cbbb4189fe650$export$229964acb6a55e5);
$parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", () => $d87cbbb4189fe650$export$1991fb4d07b18469);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", () => $d87cbbb4189fe650$export$ad07341c88d2bbab);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", () => $d87cbbb4189fe650$export$293e2bfa6752a2aa);
$parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", () => $d87cbbb4189fe650$export$225d5f547cc90d86);
$parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", () => $d87cbbb4189fe650$export$9c1d73050da32aae);
$parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", () => $d87cbbb4189fe650$export$6583ed007df50d2b);
$parcel$export(module.exports, "getCmdbPermsPrincipalUrl", () => $d87cbbb4189fe650$export$a635e2e9382b1621);
$parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", () => $d87cbbb4189fe650$export$b3cb4590859563b0);
$parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", () => $d87cbbb4189fe650$export$8ae00db5fd7218c5);
$parcel$export(module.exports, "getMyDataManagerRolesUrl", () => $d87cbbb4189fe650$export$794aa3ae46133f30);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/config
 */ const $d87cbbb4189fe650$var$getCmdbConfigUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/config`;
const $d87cbbb4189fe650$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $d87cbbb4189fe650$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
const $d87cbbb4189fe650$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $b5RwB.stringify)(queryParams)}`;
const $d87cbbb4189fe650$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $d87cbbb4189fe650$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
const $d87cbbb4189fe650$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
const $d87cbbb4189fe650$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
const $d87cbbb4189fe650$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
const $d87cbbb4189fe650$export$a635e2e9382b1621 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
const $d87cbbb4189fe650$export$b3cb4590859563b0 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
const $d87cbbb4189fe650$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
const $d87cbbb4189fe650$export$794aa3ae46133f30 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;

});


parcelRegister("2C4Rj", function(module, exports) {
$parcel$export(module.exports, "createStatusType", () => $1bd01e2f5ad92599$export$8c874b16a69a1b9d);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $1bd01e2f5ad92599$export$8c874b16a69a1b9d = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPostRequest)((0, $fKDKn.getCmdbConfigStatusTypeUrl)(workspaceId), {
                body: JSON.stringify(data)
            });
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    data: [
                        ...state.statusTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({
                source: 'insightGlobalConfigStatuses',
                action: 'created',
                actionSubject: 'insightGlobalConfigStatuses'
            }), 'insightGlobalConfigStatuses created');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("h47uz", function(module, exports) {
$parcel$export(module.exports, "deleteIcon", () => $58a614888a6e10f0$export$12d45ee5c2161b75);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $lqJW7 = parcelRequire("lqJW7");
const $58a614888a6e10f0$export$12d45ee5c2161b75 = (icon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                deleteLoading: true
            }
        });
        try {
            await (0, $u4YbY.performCmdbDeleteRequest)((0, $lqJW7.getCmdbIconByIdUrl)(workspaceId, icon.id));
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    data: state.icons.data ? state.icons.data.filter(({ id: id })=>id !== icon.id) : undefined
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("cV2bE", function(module, exports) {
$parcel$export(module.exports, "deleteReferenceType", () => $3ce5070dcba7feb3$export$432ee1f3819316e5);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $3ce5070dcba7feb3$export$432ee1f3819316e5 = (referenceType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $u4YbY.performCmdbDeleteRequest)((0, $fKDKn.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceType.id));
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    data: state.referenceTypes.data ? state.referenceTypes.data.filter(({ id: id })=>id !== referenceType.id) : undefined
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("iPKXq", function(module, exports) {
$parcel$export(module.exports, "deleteStatusType", () => $39c0952453d37c81$export$812423dc05f0fc3d);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $39c0952453d37c81$export$812423dc05f0fc3d = (statusType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $u4YbY.performCmdbDeleteRequest)((0, $fKDKn.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusType.id));
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    data: state.statusTypes.data ? state.statusTypes.data.filter(({ id: id })=>id !== statusType.id) : undefined
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("By5DJ", function(module, exports) {
$parcel$export(module.exports, "fetchGlobalConfig", () => $34c4cb0969790d4d$export$14c75ba3f0e48e21);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $9VcRq = parcelRequire("9VcRq");
const $34c4cb0969790d4d$export$14c75ba3f0e48e21 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading || !shouldRefetch && getState().config) return;
        setState({
            loading: true,
            error: undefined
        });
        try {
            const response = await (0, $u4YbY.performCmdbGetRequest)((0, $9VcRq.getCmdbGlobalConfigUrl)(workspaceId));
            const iconListWithServiceOTEntriesRemoved = response ? response.icons.filter((item)=>item.name !== 'Applications' && item.name !== 'Business Services' && item.name !== 'Capabilities' && item.name !== 'Software Services') : undefined;
            setState({
                ...getState(),
                loading: false,
                config: {
                    ...response,
                    restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
                    icons: iconListWithServiceOTEntriesRemoved || []
                },
                referenceTypes: {
                    ...getState().referenceTypes,
                    data: response ? response.referenceTypes : undefined
                },
                statusTypes: {
                    ...getState().statusTypes,
                    data: response ? response.statusTypes : undefined
                },
                icons: {
                    ...getState().icons,
                    data: iconListWithServiceOTEntriesRemoved
                },
                dataManager: {
                    ...getState().dataManager
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchInsightGlobalConfig',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("9VcRq", function(module, exports) {
$parcel$export(module.exports, "getCmdbGlobalConfigUrl", () => $4638d838a8d16ed5$export$50437136a9a5e2d3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", () => $4638d838a8d16ed5$export$73e58b72a1074528);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", () => $4638d838a8d16ed5$export$e2019224257efde3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", () => $4638d838a8d16ed5$export$d1b25f8feb06db8a);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */ const $4638d838a8d16ed5$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/global`;
const $4638d838a8d16ed5$export$50437136a9a5e2d3 = (workspaceId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config`;
const $4638d838a8d16ed5$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $b5RwB.stringify)(queryParams)}`;
const $4638d838a8d16ed5$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
const $4638d838a8d16ed5$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;

});


parcelRegister("6Cb8J", function(module, exports) {
$parcel$export(module.exports, "fetchMyDataManagerRoles", () => $e94c5c24a8debe33$export$2211f294ebd95b92);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $e94c5c24a8debe33$export$2211f294ebd95b92 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.myRolesLoading || !shouldRefetch && getState().dataManager.myRoles) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                myRolesLoading: true,
                myRolesError: undefined
            }
        });
        try {
            const myRoles = await (0, $u4YbY.performCmdbGetRequest)((0, $fKDKn.getMyDataManagerRolesUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRoles: myRoles.results,
                    myRolesLoading: false
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRolesLoading: false,
                    myRolesError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchMyDataManagerRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("lGsG0", function(module, exports) {
$parcel$export(module.exports, "fetchPrincipalsForRoles", () => $a296a821a7b7673f$export$9c5110cfdcb72b5);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $a296a821a7b7673f$export$9c5110cfdcb72b5 = (roleIds)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesLoading: true
            }
        });
        try {
            const requestBody = {
                roleIds: roleIds,
                resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`
            };
            const principalIdsForRoles = await (0, $u4YbY.performCmdbPostRequest)((0, $fKDKn.getCmdbPermsPrincipalUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            setState({
                dataManager: {
                    ...state.dataManager,
                    rolesData: principalIdsForRoles.results,
                    rolesLoading: false
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesLoading: false,
                    rolesError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchPrincipalsForRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("5bX6s", function(module, exports) {
$parcel$export(module.exports, "fetchProvisioningStatus", () => $2e05b752de2d55a4$export$aa3ea988cce42be1);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $5Up1u = parcelRequire("5Up1u");
const $2e05b752de2d55a4$export$aa3ea988cce42be1 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.provisioningLoading || !shouldRefetch && // isProvisioned is a boolean so needs to specifically check undefined
        getState().dataManager.isProvisioned !== undefined) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                provisioningLoading: true,
                provisioningError: undefined
            }
        });
        try {
            const result = await (0, $u4YbY.performCmdbGetRequest)((0, $5Up1u.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: $2e05b752de2d55a4$var$isProvisioned(result.enabled),
                    provisioningLoading: false
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    provisioningLoading: false,
                    provisioningError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };
const $2e05b752de2d55a4$var$isProvisioned = (status)=>status === 'ON';

});
parcelRegister("5Up1u", function(module, exports) {
$parcel$export(module.exports, "getDataManagerGenerateContainerTokenUrl", () => $7015e8b3da3717eb$export$5f42b4e80a66d7c);
$parcel$export(module.exports, "delDataManagerContainerTokenUrl", () => $7015e8b3da3717eb$export$ddc5a4cb751fae27);
$parcel$export(module.exports, "getDataManagerFetchContainerTokenUrl", () => $7015e8b3da3717eb$export$591d877d695dbd95);
$parcel$export(module.exports, "getDataManagerProvisioningStatusUrl", () => $7015e8b3da3717eb$export$1dd01c50c7948938);

var $1qZG3 = parcelRequire("1qZG3");
const $7015e8b3da3717eb$export$5f42b4e80a66d7c = (workspaceId, label, type, duration)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;
const $7015e8b3da3717eb$export$ddc5a4cb751fae27 = (workspaceId, tokenID)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${tokenID}`;
const $7015e8b3da3717eb$export$591d877d695dbd95 = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token`;
const $7015e8b3da3717eb$export$1dd01c50c7948938 = (workspaceId)=>`${$7015e8b3da3717eb$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;
const $7015e8b3da3717eb$var$getAirtrackAppRestBaseUrl = (workspaceId)=>`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;

});


parcelRegister("gZE7d", function(module, exports) {
$parcel$export(module.exports, "fetchDataManagerTokens", () => $c1827c9da32df0ba$export$c6b3de84befa4259);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $5Up1u = parcelRequire("5Up1u");
const $c1827c9da32df0ba$export$c6b3de84befa4259 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.tokensLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                tokensLoading: true
            }
        });
        try {
            const tokenDetails = await (0, $u4YbY.performCmdbGetRequest)((0, $5Up1u.getDataManagerFetchContainerTokenUrl)(workspaceId));
            setState({
                dataManager: {
                    ...state.dataManager,
                    tokensData: tokenDetails.tokens,
                    tokensLoading: false
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    tokensLoading: false,
                    tokensError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchDataManagerTokens',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("4rYWs", function(module, exports) {
$parcel$export(module.exports, "fetchCdm", () => $f04409399df93f85$export$dc14adeb4c2a88f9);

var $u4YbY = parcelRequire("u4YbY");

var $1qZG3 = parcelRequire("1qZG3");

var $51aj0 = parcelRequire("51aj0");
const $f04409399df93f85$export$dc14adeb4c2a88f9 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId })=>{
        // First reset state to undefined to indicate loading
        const initialState = getState();
        setState({
            ...initialState,
            cdm: {
                ...initialState.cdm,
                instantiations: undefined
            }
        });
        let instantiationsResponse;
        try {
            const apiResponse = await (0, $u4YbY.performCmdbGetRequest)(`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/bundle/instantiated/list`);
            instantiationsResponse = apiResponse?.instantiations || [];
        } catch (error) {
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : new Error('Unknown error'),
                meta: {
                    id: 'fetchInstantiations',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                }
            });
            // TODO(KKT-103) : handle error scenario by surfacing it to the user or retrying
            instantiationsResponse = [];
        }
        const state = getState();
        setState({
            ...state,
            cdm: {
                ...state.cdm,
                instantiations: instantiationsResponse
            }
        });
    };

});

parcelRegister("gD7PH", function(module, exports) {
$parcel$export(module.exports, "installCdm", () => $dba6d3d189b95432$export$2f65091e2af212f7);
const $dba6d3d189b95432$export$2f65091e2af212f7 = ()=>async ({ setState: setState, getState: getState })=>{
        // TODO: Implement the actual CDM instantiation logic here
        // submitAsyncCdmBundleInstantiationTask
        // useCmdbAsyncBundleInstantiation
        const state = getState();
        // Fake CDM instantiation task
        setState({
            ...state,
            cdm: {
                ...state.cdm,
                tasks: [
                    ...state.cdm.tasks,
                    'instantiateBundle'
                ]
            }
        });
        // Wait 2 seconds
        await new Promise((resolve)=>setTimeout(resolve, 2000));
        // Remove the task and add mock instantiation
        setState({
            ...getState(),
            cdm: {
                instantiations: [
                    {
                        instantiationId: 'test-instantiation-id',
                        bundleId: 'test-bundle-id',
                        schemas: []
                    }
                ],
                tasks: []
            }
        });
    };

});

parcelRegister("fiFnI", function(module, exports) {
$parcel$export(module.exports, "updateDataManagerRole", () => $3b770298be73ab3a$export$314337b594e79a51);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $3b770298be73ab3a$export$93aad6482f82f57d = 5000;
const $3b770298be73ab3a$export$214f23982cabf5f8 = 1000;
const $3b770298be73ab3a$export$314337b594e79a51 = ({ principalIds: principalIds, roleId: roleId })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                principalIds: principalIds,
                roleId: roleId,
                resourceType: 'workspace'
            };
            const updateRolesResponse = await (0, $u4YbY.performCmdbPutRequest)((0, $fKDKn.getCmdbPermsRoleAssignmentUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const pollTimeoutTime = new Date(Date.now() + $3b770298be73ab3a$export$93aad6482f82f57d).getTime();
            // poll the checking of the token status for 5 seconds as updating of
            // Identity role assignments have eventually consistency
            const tryPollTokenStatus = async (resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            reject)=>{
                if (Date.now() > pollTimeoutTime) {
                    reject(new Error('Some role assignments have failed or is still in progress'));
                    return;
                }
                try {
                    const url = (0, $fKDKn.getCmdbPermsTokenStatusUrl)(workspaceId, updateRolesResponse.tokens[updateRolesResponse.tokens.length - 1]);
                    const updateRoleAssignmentToken = await (0, $u4YbY.performCmdbGetRequest)(url);
                    if (updateRoleAssignmentToken.isSuccessful) {
                        resolve();
                        return;
                    }
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $3b770298be73ab3a$export$214f23982cabf5f8);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // Ignore unexpected network/server error and quickly retry
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $3b770298be73ab3a$export$214f23982cabf5f8);
                }
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            await new Promise((res, rej)=>tryPollTokenStatus(res, rej));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateDataManagerRole succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false,
                    rolesUpdateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateDataManagerRole',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'data-manager'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("fHTJ8", function(module, exports) {
$parcel$export(module.exports, "setIcon", () => $45b1977ec6542cfd$export$33914de34c28be6c);
$parcel$export(module.exports, "updateIcon", () => $45b1977ec6542cfd$export$89ea7ff652eb14dd);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $lqJW7 = parcelRequire("lqJW7");
const $45b1977ec6542cfd$export$33914de34c28be6c = (updatedIcon)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.icons.data?.map((icon)=>icon.id === updatedIcon.id ? updatedIcon : icon);
        setState({
            ...state,
            icons: {
                ...state.icons,
                data: updatedData
            }
        });
    };
const $45b1977ec6542cfd$export$89ea7ff652eb14dd = ({ iconId: iconId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPutRequest)((0, $lqJW7.getCmdbIconByIdUrl)(workspaceId, iconId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.icons.data?.map((icon)=>icon.id === response.id ? response : icon);
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    data: updatedData
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("3Zqe3", function(module, exports) {
$parcel$export(module.exports, "updateProvisioningStatus", () => $606e8565e91a4fc0$export$ae3c5292a85a06f4);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $5Up1u = parcelRequire("5Up1u");
const $606e8565e91a4fc0$export$ae3c5292a85a06f4 = ({ isEnabled: isEnabled })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.provisioningUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                isProvisioned: isEnabled,
                provisioningUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                enabled: isEnabled
            };
            await (0, $u4YbY.performCmdbPutRequest)((0, $5Up1u.getDataManagerProvisioningStatusUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const result = await (0, $u4YbY.performCmdbGetRequest)((0, $5Up1u.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    isProvisioned: result.enabled === 'ON',
                    provisioningUpdateLoading: false
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    provisioningUpdateLoading: false,
                    provisioningUpdateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("2La61", function(module, exports) {
$parcel$export(module.exports, "setReferenceType", () => $343eae8ce4ee1012$export$7c6efce0302318d);
$parcel$export(module.exports, "updateReferenceType", () => $343eae8ce4ee1012$export$f9e29a0f21a33136);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $343eae8ce4ee1012$export$7c6efce0302318d = (updatedReferenceType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.referenceTypes.data?.map((referenceType)=>referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType);
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                data: updatedData
            }
        });
    };
const $343eae8ce4ee1012$export$f9e29a0f21a33136 = ({ referenceTypeId: referenceTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPutRequest)((0, $fKDKn.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceTypeId), {
                body: JSON.stringify({
                    ...updatedProperties,
                    color: updatedProperties.color !== undefined ? updatedProperties.color.replace('#', '') : undefined
                })
            });
            const updatedState = getState();
            const updatedData = updatedState.referenceTypes.data?.map((referenceType)=>referenceType.id === response.id ? response : referenceType);
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("gVUS4", function(module, exports) {
$parcel$export(module.exports, "setStatusType", () => $a16b97a1719c03fb$export$80a24939e43be67c);
$parcel$export(module.exports, "updateStatusType", () => $a16b97a1719c03fb$export$2174575c3f57e8f8);

var $51aj0 = parcelRequire("51aj0");

var $kRgKj = parcelRequire("kRgKj");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $a16b97a1719c03fb$export$80a24939e43be67c = (updatedStatusType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.statusTypes.data?.map((statusType)=>statusType.id === updatedStatusType.id ? updatedStatusType : statusType);
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                data: updatedData
            }
        });
    };
const $a16b97a1719c03fb$export$2174575c3f57e8f8 = ({ statusTypeId: statusTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPutRequest)((0, $fKDKn.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusTypeId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.statusTypes.data?.map((statusType)=>statusType.id === response.id ? response : statusType);
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});


parcelRegister("3rcO4", function(module, exports) {
$parcel$export(module.exports, "sortReferenceTypes", () => $ee8651402384f062$export$7e55dd84e7cc0829);
$parcel$export(module.exports, "sortStatusTypes", () => $ee8651402384f062$export$5f25bb3183b5823d);
const $ee8651402384f062$export$7e55dd84e7cc0829 = (referenceTypes)=>referenceTypes.sort((a, b)=>a.name.localeCompare(b.name)).sort((a, b)=>{
        if (a.removable === b.removable) return 0;
        return a.removable ? 1 : -1;
    });
const $ee8651402384f062$export$5f25bb3183b5823d = (statusTypes)=>statusTypes.sort((a, b)=>a.name.localeCompare(b.name));

});


parcelRegister("b2MSM", function(module, exports) {
$parcel$export(module.exports, "AssetsMenu", () => $2906ec36ee6b82b1$export$a578a9f5b9517a27);
$parcel$export(module.exports, "AssetsSingleMenuItem", () => $2906ec36ee6b82b1$export$252d7ffe38b4e8ef);

var $eJOHy = parcelRequire("eJOHy");

var $dBQvm = parcelRequire("dBQvm");

var $jdqdp = parcelRequire("jdqdp");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $lRq8t = parcelRequire("lRq8t");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $20Nt8 = parcelRequire("20Nt8");

var $gfvms = parcelRequire("gfvms");

var $bYOuG = parcelRequire("bYOuG");

var $8rGQ0 = parcelRequire("8rGQ0");

var $4cTDP = parcelRequire("4cTDP");

var $lvaGv = parcelRequire("lvaGv");

var $khwZc = parcelRequire("khwZc");

var $8GMYA = parcelRequire("8GMYA");

var $iXbCd = parcelRequire("iXbCd");
function $2906ec36ee6b82b1$export$a578a9f5b9517a27({ isExpanded: isExpanded }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).ASSETS);
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const { isByokCustomer: isByokCustomer } = (0, $dBQvm.useByokComplianceSettingWithInitialisation)();
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const [{ config: config, dataManager: dataManager, loading: loading }, { fetchGlobalConfig: fetchGlobalConfig, fetchProvisioningStatus: fetchProvisioningStatus, fetchMyDataManagerRoles: fetchMyDataManagerRoles }] = (0, $gfvms.useInsightGlobalConfig)();
    const fetchAssetsConfig = (0, $eJOHy.useCallback)(async ()=>{
        fetchGlobalConfig(false);
        fetchProvisioningStatus(false);
        fetchMyDataManagerRoles(false);
    }, [
        fetchGlobalConfig,
        fetchMyDataManagerRoles,
        fetchProvisioningStatus
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_ASSETS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
                sectionItem: (0, $a9aec.SECTION_ITEM_ASSETS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iXbCd.SectionActions), {
            isInsightAdministrator: config?.insightAdministrator
        }),
        testId: (0, $azEgq.getTestId)(menuId),
        onClick: (_e, _a, { isExpanded: hasExpanded })=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
                sectionItem: (0, $a9aec.SECTION_ITEM_ASSETS)
            });
        },
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-assets' : undefined
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8GMYA.HeaderSchemasMenuItems), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20Nt8.L1ExpandableMenuItemSubmenu), {
        fetch: fetchAssetsConfig,
        isFetching: loading || dataManager.provisioningLoading || dataManager.myRolesLoading,
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvaGv.AssetsMenuItems), {
                dataManagerIsProvisioned: dataManager.isProvisioned,
                dataManagerMyRoles: dataManager.myRoles,
                isSiteAdmin: isSiteAdmin,
                insightAdministrator: config?.insightAdministrator,
                insightReporting: config?.insightReporting,
                isByokCustomer: isByokCustomer
            }),
        skeletonCount: 2
    })));
}
const $2906ec36ee6b82b1$export$252d7ffe38b4e8ef = ({ showUpsellLozenge: showUpsellLozenge = false })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).ASSETS);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
                sectionItem: (0, $a9aec.SECTION_ITEM_ASSETS)
            });
        },
        menuId: (0, $h4Bzb.MENU_ID_ASSETS),
        elemBefore: icon,
        href: (0, $bYOuG.getLandingPageUrl)(),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iXbCd.SectionActions), {
            isInsightAdministrator: false
        })
    }, `${formattedMessage} `, showUpsellLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-menu.upsell-lozenge",
        appearance: "new"
    }, formatMessage((0, $khwZc.default).upsellLozengeText)));
};

});
parcelRegister("dBQvm", function(module, exports) {
$parcel$export(module.exports, "useByokComplianceSettingData", () => $cb38e3d1887d6eb4$export$1972fcad574711bc);
$parcel$export(module.exports, "useByokComplianceSettingWithInitialisation", () => $cb38e3d1887d6eb4$export$fb68f4844474e7cb);

var $eJOHy = parcelRequire("eJOHy");

var $3ugTQ = parcelRequire("3ugTQ");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $koAZ4 = parcelRequire("koAZ4");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

var $7qGN1 = parcelRequire("7qGN1");
const $cb38e3d1887d6eb4$var$messages = (0, $7qGN1.defineMessages)({
    byokComplianceSettingEnabledSuccessTitle: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-title",
        "defaultMessage": "HIPAA-compliant alert notifications turned on"
    },
    byokComplianceSettingEnabledSuccessDescription: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-description",
        "defaultMessage": "Let your team admins know about the recommended actions they can take."
    },
    flagOk: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-ok",
        "defaultMessage": "Ok"
    },
    flagLearnMore: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-learn-more",
        "defaultMessage": "Learn more"
    }
});
const $cb38e3d1887d6eb4$export$f907f15fb3e7d5a9 = (0, $jn1Cb.toFlagId)('byok-settings-enabled-success-flag-key');
const $cb38e3d1887d6eb4$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/data-managed-with-byok-encryption/24h';
const $cb38e3d1887d6eb4$var$actions = {
    fetchByokComplianceSetting: (cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            setState({
                ...state,
                loading: true
            });
            try {
                const { data: data } = await (0, $3ugTQ.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`);
                setState({
                    ...state,
                    data: data,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        },
    updateByokComplianceSetting: (option, cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
            const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
            setState({
                ...state,
                loading: true
            });
            try {
                await (0, $3ugTQ.performPatchRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`, {
                    body: JSON.stringify({
                        ugcPrimaryLogEnabledForByok: option
                    })
                });
                if (option) showFlag({
                    id: $cb38e3d1887d6eb4$export$f907f15fb3e7d5a9,
                    title: $cb38e3d1887d6eb4$var$messages.byokComplianceSettingEnabledSuccessTitle,
                    type: 'success',
                    description: $cb38e3d1887d6eb4$var$messages.byokComplianceSettingEnabledSuccessDescription,
                    messageId: 'products-jsm-compliance.show-flag.success.byok-compliance-setting',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: $cb38e3d1887d6eb4$var$messages.flagOk,
                            onClick: ()=>{
                                dismissFlag($cb38e3d1887d6eb4$export$f907f15fb3e7d5a9);
                            }
                        },
                        {
                            content: $cb38e3d1887d6eb4$var$messages.flagLearnMore,
                            href: $cb38e3d1887d6eb4$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK,
                            target: '_blank'
                        }
                    ]
                });
                setState({
                    ...state,
                    data: {
                        byokCustomer: state.data?.byokCustomer ?? false,
                        ugcPrimaryLogEnabledForByok: option
                    },
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        }
};
const $cb38e3d1887d6eb4$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        data: null,
        loading: false,
        error: undefined
    },
    actions: $cb38e3d1887d6eb4$var$actions,
    name: 'BYOKComplianceSetting'
});
const $cb38e3d1887d6eb4$export$1972fcad574711bc = (0, $iJq0l.createHook)($cb38e3d1887d6eb4$var$Store);
const $cb38e3d1887d6eb4$export$fb68f4844474e7cb = ()=>{
    const [ByokComplianceSettingState, { fetchByokComplianceSetting: fetchByokComplianceSetting, updateByokComplianceSetting: updateByokComplianceSetting }] = $cb38e3d1887d6eb4$export$1972fcad574711bc();
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (!ByokComplianceSettingState.data && (0, $4cTDP.fg)('audit-logs-byok-encrypted-data')) fetchByokComplianceSetting(cloudId);
    }, [
        ByokComplianceSettingState.data,
        cloudId,
        fetchByokComplianceSetting
    ]);
    return {
        loading: ByokComplianceSettingState.loading,
        error: ByokComplianceSettingState.error,
        data: ByokComplianceSettingState.data,
        isByokComplianceSettingEnabled: ByokComplianceSettingState.data?.ugcPrimaryLogEnabledForByok ?? false,
        isByokCustomer: ByokComplianceSettingState.data?.byokCustomer ?? false,
        enableSetting: ()=>updateByokComplianceSetting(true, cloudId),
        disableSetting: ()=>updateByokComplianceSetting(false, cloudId)
    };
};

});

parcelRegister("20Nt8", function(module, exports) {
$parcel$export(module.exports, "L1ExpandableMenuItemSubmenu", () => $0eaaeada2f8e329b$export$a0d95f81c9ddf0e9);

var $eJOHy = parcelRequire("eJOHy");

var $5dX0w = parcelRequire("5dX0w");
const $0eaaeada2f8e329b$export$a0d95f81c9ddf0e9 = (props)=>{
    const { fetch: fetch, Footer: Footer, isFetching: isFetching, MenuItems: MenuItems, skeletonCount: skeletonCount } = props;
    const expandableMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuItems, null);
    const expandableFooter = Footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5dX0w.ExpandableMenuItemSubmenu), {
        fetch: fetch,
        footer: expandableFooter,
        isFetching: isFetching,
        menuItems: expandableMenuItems,
        skeletonCount: skeletonCount
    });
};

});
parcelRegister("5dX0w", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemSubmenu", () => $a2a3e2e1b2e30e86$export$216998a85b3335a2);

var $eJOHy = parcelRequire("eJOHy");

var $yFG6a = parcelRequire("yFG6a");

var $kxtq7 = parcelRequire("kxtq7");

var $if69u = parcelRequire("if69u");
const $a2a3e2e1b2e30e86$export$216998a85b3335a2 = (props)=>{
    const { fetch: fetchMaybe, footer: footer, isFetching: isFetchingMaybe, menuItems: menuItems, skeletonCount: skeletonCount } = props;
    const { isFetching: isFetching, fetch: fetch } = (0, $kxtq7.useFetchActual)(isFetchingMaybe, fetchMaybe);
    const isExpanded = (0, $yFG6a.useIsExpanded)();
    // Fetch on open to refresh.
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded && !isFetching) fetch();
    }, // Don't include `isFetching` or this effect will go into an endless loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isExpanded,
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: skeletonCount
    }) : menuItems, footer);
};

});
parcelRegister("kxtq7", function(module, exports) {
$parcel$export(module.exports, "useFetchActual", () => $859196bfa2c1b457$export$49f3bd519990bec7);

var $eJOHy = parcelRequire("eJOHy");
const $859196bfa2c1b457$export$49f3bd519990bec7 = (isFetchingMaybe, fetchMaybe)=>{
    const [isFetching, setIsFetching] = (0, $eJOHy.useState)(false);
    const fetch = (0, $eJOHy.useCallback)(async ()=>{
        if (!fetchMaybe) return;
        setIsFetching(true);
        try {
            await fetchMaybe();
        } finally{
            setIsFetching(false);
        }
    }, [
        fetchMaybe,
        setIsFetching
    ]);
    return {
        isFetching: !!isFetchingMaybe || isFetching,
        fetch: fetch
    };
};

});



parcelRegister("lvaGv", function(module, exports) {
$parcel$export(module.exports, "AssetsMenuItems", () => $8f756fb22181b2c2$export$eca9d73b7de13f6a);

var $eJOHy = parcelRequire("eJOHy");

var $17vsL = parcelRequire("17vsL");

var $lopBx = parcelRequire("lopBx");

var $4cTDP = parcelRequire("4cTDP");

var $dMNPP = parcelRequire("dMNPP");

var $kTXsx = parcelRequire("kTXsx");

var $7TbyK = parcelRequire("7TbyK");
const $8f756fb22181b2c2$export$eca9d73b7de13f6a = ({ dataManagerIsProvisioned: dataManagerIsProvisioned, dataManagerMyRoles: dataManagerMyRoles, isSiteAdmin: isSiteAdmin, insightAdministrator: insightAdministrator, insightReporting: insightReporting, isByokCustomer: isByokCustomer })=>{
    const showDataManagerLink = (0, $eJOHy.useCallback)(()=>{
        if (dataManagerIsProvisioned && dataManagerMyRoles) {
            const hasDMRoles = dataManagerMyRoles.some((myRole)=>(0, $17vsL.DATA_MANAGER_ROLES).includes(myRole));
            const hasAdapterRoles = dataManagerMyRoles.some((myRole)=>(0, $17vsL.DATA_MANAGER_ADAPTERS_ROLES).includes(myRole));
            if (hasDMRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kTXsx.DataManagerMenuItems), null);
            if (hasAdapterRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMNPP.DataManagerAdapterMenuItems), null);
        }
    }, [
        dataManagerIsProvisioned,
        dataManagerMyRoles
    ]);
    const isAssetsReportsByokSupported = isByokCustomer ? (0, $4cTDP.fg)('assets_reports_enabled_for_byok_customers') : true;
    const isInsightReportsEnabled = (0, $eJOHy.useCallback)(()=>(isSiteAdmin || insightAdministrator) && isAssetsReportsByokSupported && insightReporting, [
        insightAdministrator,
        insightReporting,
        isSiteAdmin,
        isAssetsReportsByokSupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isInsightReportsEnabled() && !(0, $lopBx.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7TbyK.ReportsMenuItem), null), showDataManagerLink());
};

});
parcelRegister("17vsL", function(module, exports) {
$parcel$export(module.exports, "DATA_MANAGER_ADMIN", () => $ba27e3658ead8687$export$48abe9ccfdd98170);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_VIEWER", () => $ba27e3658ead8687$export$8939b849d295aa4c);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_EDITOR", () => $ba27e3658ead8687$export$4ca2081d195ddbdb);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ADMIN", () => $ba27e3658ead8687$export$4c3d5fe6bdc107f1);
$parcel$export(module.exports, "DATA_MANAGER_ROLES", () => $ba27e3658ead8687$export$48703faa5030b273);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ROLES", () => $ba27e3658ead8687$export$8b2dfd13f5f35ee4);
$parcel$export(module.exports, "ORDERED_ASSETS_DATA_MANAGER_ROLES", () => $ba27e3658ead8687$export$1d276f65230af2e);
const $ba27e3658ead8687$export$48abe9ccfdd98170 = 'ari:cloud:cmdb::role/airtrack/admin';
const $ba27e3658ead8687$export$8939b849d295aa4c = 'ari:cloud:cmdb::role/airtrack/report-viewer';
const $ba27e3658ead8687$export$4ca2081d195ddbdb = 'ari:cloud:cmdb::role/airtrack/report-editor';
const $ba27e3658ead8687$export$4c3d5fe6bdc107f1 = 'ari:cloud:cmdb::role/airtrack-buoy/admin';
const $ba27e3658ead8687$export$48703faa5030b273 = [
    $ba27e3658ead8687$export$48abe9ccfdd98170,
    $ba27e3658ead8687$export$8939b849d295aa4c,
    $ba27e3658ead8687$export$4ca2081d195ddbdb
];
const $ba27e3658ead8687$export$8b2dfd13f5f35ee4 = [
    $ba27e3658ead8687$export$4c3d5fe6bdc107f1
];
const $ba27e3658ead8687$export$1d276f65230af2e = [
    $ba27e3658ead8687$export$48abe9ccfdd98170,
    $ba27e3658ead8687$export$4c3d5fe6bdc107f1,
    $ba27e3658ead8687$export$4ca2081d195ddbdb,
    $ba27e3658ead8687$export$8939b849d295aa4c
];

});

parcelRegister("dMNPP", function(module, exports) {
$parcel$export(module.exports, "DataManagerAdapterMenuItems", () => $301fb1cb4cf3d2af$export$f74d67a8d693b664);

var $eJOHy = parcelRequire("eJOHy");

var $ac080 = parcelRequire("ac080");

var $jdqdp = parcelRequire("jdqdp");

var $6djmC = parcelRequire("6djmC");

var $2dvSy = parcelRequire("2dvSy");

var $lRq8t = parcelRequire("lRq8t");


var $2QH3X = parcelRequire("2QH3X");

var $i79tC = parcelRequire("i79tC");

var $bYOuG = parcelRequire("bYOuG");

var $6FvEx = parcelRequire("6FvEx");

var $6Awzl = parcelRequire("6Awzl");
const $301fb1cb4cf3d2af$export$f74d67a8d693b664 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { icon: formattedAdapterIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $6Awzl.default).jsmAssetsDataManagerAdapters, (0, $i79tC.DataManagerAdaptersGlyph));
    const { icon: formattedOpenIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $6Awzl.default).jsmAssetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($ac080))));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $6FvEx.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        elemBefore: formattedAdapterIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $bYOuG.getDataManagerAdaptersUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $bc40578f06d7846b$export$ee52916f9ebd8000))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage((0, $6Awzl.default).jsmAssetsDataManagerAdapters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $6Awzl.default).assetsDataManagerBeta))));
};

});
parcelRegister("ac080", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2228fa01b7e8b5ee470ffc60df47923d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76bb1fce06e44d9d$var$_react = $76bb1fce06e44d9d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $76bb1fce06e44d9d$var$_baseNew = $76bb1fce06e44d9d$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $76bb1fce06e44d9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76bb1fce06e44d9d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $76bb1fce06e44d9d$var$_react.default.createElement($76bb1fce06e44d9d$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$76bb1fce06e44d9d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $76bb1fce06e44d9d$var$_default = module.exports.default = $76bb1fce06e44d9d$var$ArrowUpRightIcon;

});

const $bc40578f06d7846b$export$f06dfcec5ff912e = 'meatballDropdown';
const $bc40578f06d7846b$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $bc40578f06d7846b$export$78fd0bd637fe1684 = 'addToStarred';
const $bc40578f06d7846b$export$c540230986f848f6 = 'addPeople';
const $bc40578f06d7846b$export$44d67b522cbcce6d = 'projects';
const $bc40578f06d7846b$export$3cc9ab700c406a19 = 'projectSettings';
const $bc40578f06d7846b$export$dc23a793cf9e9de8 = 'archiveProject';
const $bc40578f06d7846b$export$a68d619e7022f2c3 = 'deleteBoard';
const $bc40578f06d7846b$export$22748439827110a4 = 'deleteProject';
const $bc40578f06d7846b$export$192d610b0b7719f4 = 'boardSettings';
const $bc40578f06d7846b$export$a65812b4aab631bb = 'alertSettings';
const $bc40578f06d7846b$export$36b5d4d0cb4e437 = 'moveInSidebar';
const $bc40578f06d7846b$export$ca6db12118be69a1 = 'schemas';
const $bc40578f06d7846b$export$f2eca6cf19c9a973 = 'reports';
const $bc40578f06d7846b$export$147264622218a553 = 'dataManager';
const $bc40578f06d7846b$export$ee52916f9ebd8000 = 'adapters';
const $bc40578f06d7846b$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $bc40578f06d7846b$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $bc40578f06d7846b$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $bc40578f06d7846b$export$27e4092edca7bb97 = 'jwmSampleProject';
const $bc40578f06d7846b$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $bc40578f06d7846b$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $bc40578f06d7846b$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $bc40578f06d7846b$export$f8a73cc0211412ca = 'mostRecentProjectOnly';
const $bc40578f06d7846b$export$3e2efdbdb3eed97e = 'moreProjects';
const $bc40578f06d7846b$export$2de7e56f66635690 = 'viewAllProjects';
const $bc40578f06d7846b$export$e338c40e64df0640 = 'projectsSearch';
const $bc40578f06d7846b$export$5ff59e4f08b9b299 = 'moveToTop';
const $bc40578f06d7846b$export$9964b4a63620a911 = 'moveUp';
const $bc40578f06d7846b$export$2692a384035c5ef7 = 'moveDown';
const $bc40578f06d7846b$export$a5a45050b97fca24 = 'moveToBottom';

parcelRegister("i79tC", function(module, exports) {
$parcel$export(module.exports, "DataManagerAdaptersGlyph", () => $7f477d6058758a60$export$cff497901afe8164);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $fL0In = parcelRequire("fL0In");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jdqdp = parcelRequire("jdqdp");

var $c9uTK = parcelRequire("c9uTK");
const $7f477d6058758a60$export$fb5ad6208dd8d5f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM7.5 17.5C7.5 18.0523 7.05228 18.5 6.5 18.5C5.94772 18.5 5.5 18.0523 5.5 17.5C5.5 16.9477 5.94772 16.5 6.5 16.5C7.05228 16.5 7.5 16.9477 7.5 17.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V12.75V12V11.25V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555Z",
        fill: "#44546F"
    }));
const $7f477d6058758a60$export$cff497901afe8164 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        clipPath: "url(#clip0_2374_102539)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5076 15.8019C10.8212 16.0862 11 16.4898 11 16.913V18.5H13V16.913C13 16.4898 13.1788 16.0862 13.4924 15.8019L16.5 13.0745V9.5H7.5V13.0745L10.5076 15.8019ZM6 13.7391V9C6 8.44771 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9V13.7391L14.5 16.913V19C14.5 19.5523 14.0523 20 13.5 20H10.5C9.94772 20 9.5 19.5523 9.5 19V16.913L6 13.7391Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 9L9 4L10.5 4V9H9Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 9V4L15 4V9H13.5Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("clipPath", {
        id: "clip0_2374_102539"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "currentColor"
    }))));
const $7f477d6058758a60$export$905e681c1cad3de = ({ children: children, onClick: onClick, testId: testId, to: to, app: app })=>{
    const getIcon = ()=>{
        if (app === 'data-manager') // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
            glyph: $7f477d6058758a60$export$fb5ad6208dd8d5f1,
            label: "Data manager icon",
            size: "medium"
        });
        // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
            glyph: $7f477d6058758a60$export$cff497901afe8164,
            label: "Adapters icon",
            size: "medium"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7f477d6058758a60$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        href: to,
        component: (0, $c9uTK.Link),
        appearance: "subtle",
        iconBefore: getIcon(),
        testId: testId,
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        },
        target: "_blank"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7f477d6058758a60$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, "BETA"))));
};
const $7f477d6058758a60$var$lozengeStyles = (0, $1DXK0.xcss)({
    display: 'inline-block',
    marginLeft: 'space.050'
});
const $7f477d6058758a60$var$wrapperStyles = (0, $1DXK0.xcss)({});

});

parcelRegister("6FvEx", function(module, exports) {
$parcel$export(module.exports, "useAssetsUIAnalytics", () => $99fa744738885014$export$2eb4a7a38c92c87f);

var $eJOHy = parcelRequire("eJOHy");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $99fa744738885014$export$2eb4a7a38c92c87f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireUINavigationItemAnalytics = (0, $eJOHy.useCallback)((analyticsItemId)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        }), (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ASSETS], {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: analyticsItemId
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUINavigationItemAnalytics: fireUINavigationItemAnalytics
    };
};

});

parcelRegister("6Awzl", function(module, exports) {
$parcel$export(module.exports, "default", () => $544582b8551893f8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $544582b8551893f8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jsmAssetsDataManagerAdapters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-data-manager-adapters",
        "defaultMessage": "Adapters"
    },
    jsmAssetsOpenDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-open-data-manager",
        "defaultMessage": "Open data manager"
    },
    assetsDataManagerBeta: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.assets-data-manager-beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("kTXsx", function(module, exports) {
$parcel$export(module.exports, "DataManagerMenuItems", () => $27fa01bc6587f493$export$34300598ca712097);

var $eJOHy = parcelRequire("eJOHy");

var $ac080 = parcelRequire("ac080");

var $6djmC = parcelRequire("6djmC");

var $jdqdp = parcelRequire("jdqdp");

var $2dvSy = parcelRequire("2dvSy");

var $964c7 = parcelRequire("964c7");

var $lRq8t = parcelRequire("lRq8t");


var $2QH3X = parcelRequire("2QH3X");

var $bYOuG = parcelRequire("bYOuG");

var $6FvEx = parcelRequire("6FvEx");

var $5vsGO = parcelRequire("5vsGO");
const $27fa01bc6587f493$export$34300598ca712097 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { icon: formattedOpenIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5vsGO.default).assetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($ac080))));
    const { icon: formattedDataManagerIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5vsGO.default).assetsDataManager, (0, $964c7.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $6FvEx.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        elemBefore: formattedDataManagerIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $bYOuG.getDataManagerUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $bc40578f06d7846b$export$147264622218a553))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage((0, $5vsGO.default).assetsDataManager), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $5vsGO.default).assetsDataManagerBeta))));
};

});
parcelRegister("964c7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bcb30f45b8daa78$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $82ayN = parcelRequire("82ayN");

var $bJscI = parcelRequire("bJscI");
const $3bcb30f45b8daa78$var$JSMAssetsDataManagerGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V8.5V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V15.5V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V15.5V12.75V12V11.25V8.5V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555ZM6.5 18.5C7.05228 18.5 7.5 18.0523 7.5 17.5C7.5 16.9477 7.05228 16.5 6.5 16.5C5.94772 16.5 5.5 16.9477 5.5 17.5C5.5 18.0523 5.94772 18.5 6.5 18.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12Z",
        fill: "currentColor"
    }));
const $3bcb30f45b8daa78$var$JSMAssetsDataManagerIcon = (props)=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        ...props,
        glyph: $3bcb30f45b8daa78$var$JSMAssetsDataManagerGlyph
    });
const $3bcb30f45b8daa78$var$icon = (0, $bJscI.componentWithFG)('enghealth-custom-icon-migration', (0, (/*@__PURE__*/$parcel$interopDefault($82ayN))), $3bcb30f45b8daa78$var$JSMAssetsDataManagerIcon);
var $3bcb30f45b8daa78$export$2e2bcd8739ae039 = $3bcb30f45b8daa78$var$icon;

});
parcelRegister("82ayN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e15f1c483c7ba38f6c8ff3b316f468>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d96b3a9c5903988$var$_react = $5d96b3a9c5903988$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5d96b3a9c5903988$var$_baseNew = $5d96b3a9c5903988$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5d96b3a9c5903988$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsDataManager".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d96b3a9c5903988$var$AssetsDataManagerIcon = (props)=>/*#__PURE__*/ $5d96b3a9c5903988$var$_react.default.createElement($5d96b3a9c5903988$var$_baseNew.default, Object.assign({
        name: "AssetsDataManagerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.25 12V4a.5.5 0 0 0-.5-.5h-2V2h2a2 2 0 0 1 2 2v3.25h2.5v1.5h-2.5V12a2 2 0 0 1-2 2h-2v-1.5h2a.5.5 0 0 0 .5-.5"/><path fill="currentcolor" d="M13.25 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-1.5a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5M2.75 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-1.5a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m0 12a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-1.5a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5"/>`
    }, props));
$5d96b3a9c5903988$var$AssetsDataManagerIcon.displayName = 'AssetsDataManagerIcon';
var $5d96b3a9c5903988$var$_default = module.exports.default = $5d96b3a9c5903988$var$AssetsDataManagerIcon;

});


parcelRegister("5vsGO", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5f92d968ddaa577$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a5f92d968ddaa577$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    assetsDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager",
        "defaultMessage": "Data Manager"
    },
    assetsOpenDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-open-data-manager",
        "defaultMessage": "Open Data Manager"
    },
    assetsDataManagerBeta: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager-beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("7TbyK", function(module, exports) {
$parcel$export(module.exports, "ReportsMenuItem", () => $bfca800aee13c0bd$export$156f96ce3bb16879);

var $eJOHy = parcelRequire("eJOHy");

var $amDP4 = parcelRequire("amDP4");

var $lRq8t = parcelRequire("lRq8t");


var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $bYOuG = parcelRequire("bYOuG");

var $6FvEx = parcelRequire("6FvEx");

var $1klfV = parcelRequire("1klfV");
const $bfca800aee13c0bd$export$156f96ce3bb16879 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const reportsLink = (0, $eJOHy.useMemo)(()=>(0, $bYOuG.getAssetsReportsUrl)(), []);
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $6FvEx.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($amDP4))), {
            label: formatMessage((0, $1klfV.default).jsmAssetsReports),
            color: "currentColor",
            spacing: "spacious"
        }),
        href: reportsLink,
        menuId: (0, $h4Bzb.MENU_ID_ASSETS_REPORTS),
        onClick: ()=>fireUINavigationItemAnalytics((0, $bc40578f06d7846b$export$f2eca6cf19c9a973))
    }, formatMessage((0, $1klfV.default).jsmAssetsReports));
};

});
parcelRegister("amDP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c5fc21ffe3de28c11b1ff576772f32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78bad9690aef89d2$var$_react = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78bad9690aef89d2$var$_baseNew = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78bad9690aef89d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78bad9690aef89d2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $78bad9690aef89d2$var$_react.default.createElement($78bad9690aef89d2$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$78bad9690aef89d2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $78bad9690aef89d2$var$_default = module.exports.default = $78bad9690aef89d2$var$ChartBarIcon;

});

parcelRegister("1klfV", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fb32e4afb1e817e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3fb32e4afb1e817e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jsmAssetsReports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.reports.jsm-assets-reports",
        "defaultMessage": "Reports"
    }
});

});



parcelRegister("khwZc", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7d51d281a3494d6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a7d51d281a3494d6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    upsellLozengeText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.upsell-lozenge-text",
        "defaultMessage": "Premium"
    }
});

});

parcelRegister("8GMYA", function(module, exports) {
$parcel$export(module.exports, "HeaderSchemasMenuItems", () => $1c2c24180176eb43$export$7243359973253e5);

var $eJOHy = parcelRequire("eJOHy");

var $4yUIq = parcelRequire("4yUIq");

var $lRq8t = parcelRequire("lRq8t");


var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $2QH3X = parcelRequire("2QH3X");

var $bYOuG = parcelRequire("bYOuG");

var $4cTDP = parcelRequire("4cTDP");

var $6FvEx = parcelRequire("6FvEx");

var $18OH6 = parcelRequire("18OH6");
const $1c2c24180176eb43$export$7243359973253e5 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const schemasLink = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('assets_for_you') ? `${(0, $bYOuG.getLandingPageUrl)()}/schemas` : (0, $bYOuG.getLandingPageUrl)(), []);
    const { icon: formattedSchemasIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $18OH6.default).jsmAssetsSchemas, (0, $4yUIq.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $6FvEx.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        menuId: (0, $h4Bzb.MENU_ID_ASSETS_SCHEMAS),
        elemBefore: formattedSchemasIcon,
        href: schemasLink,
        onClick: ()=>fireUINavigationItemAnalytics((0, $bc40578f06d7846b$export$ca6db12118be69a1))
    }, formatMessage((0, $18OH6.default).jsmAssetsSchemas));
};

});
parcelRegister("4yUIq", function(module, exports) {
$parcel$export(module.exports, "default", () => $174d58feef21d039$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $2z85P = parcelRequire("2z85P");

var $bJscI = parcelRequire("bJscI");
const $174d58feef21d039$var$JSMAssetsSchemasGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 7.5C8.05228 7.5 8.5 7.05228 8.5 6.5C8.5 5.94772 8.05228 5.5 7.5 5.5C6.94772 5.5 6.5 5.94772 6.5 6.5C6.5 7.05228 6.94772 7.5 7.5 7.5ZM10 6.5C10 7.61941 9.26428 8.56698 8.25 8.88555V10.5H14.1145C14.433 9.48572 15.3806 8.75 16.5 8.75C17.8807 8.75 19 9.86929 19 11.25C19 12.6307 17.8807 13.75 16.5 13.75C15.3806 13.75 14.433 13.0143 14.1145 12H8.25V16.25C8.25 16.6642 8.58579 17 9 17H14.05C14.2816 15.8589 15.2905 15 16.5 15C17.8807 15 19 16.1193 19 17.5C19 18.8807 17.8807 20 16.5 20C15.4748 20 14.5938 19.383 14.208 18.5H9C7.75736 18.5 6.75 17.4926 6.75 16.25V12V10.5V8.88555C5.73572 8.56698 5 7.61941 5 6.5C5 5.11929 6.11929 4 7.5 4C8.88071 4 10 5.11929 10 6.5ZM16.5 18.5C17.0523 18.5 17.5 18.0523 17.5 17.5C17.5 16.9477 17.0523 16.5 16.5 16.5C15.9477 16.5 15.5 16.9477 15.5 17.5C15.5 18.0523 15.9477 18.5 16.5 18.5ZM17.5 11.25C17.5 11.8023 17.0523 12.25 16.5 12.25C15.9477 12.25 15.5 11.8023 15.5 11.25C15.5 10.6977 15.9477 10.25 16.5 10.25C17.0523 10.25 17.5 10.6977 17.5 11.25Z",
        fill: "currentColor"
    }));
const $174d58feef21d039$var$JSMAssetsSchemasIcon = (props)=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        ...props,
        glyph: $174d58feef21d039$var$JSMAssetsSchemasGlyph
    });
const $174d58feef21d039$var$icon = (0, $bJscI.componentWithFG)('enghealth-custom-icon-migration', (0, (/*@__PURE__*/$parcel$interopDefault($2z85P))), $174d58feef21d039$var$JSMAssetsSchemasIcon);
var $174d58feef21d039$export$2e2bcd8739ae039 = $174d58feef21d039$var$icon;

});
parcelRegister("2z85P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46a94e1addf026bfebe08b8e272a8c2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1de520c84cbadd21$var$_react = $1de520c84cbadd21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1de520c84cbadd21$var$_baseNew = $1de520c84cbadd21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $1de520c84cbadd21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1de520c84cbadd21$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $1de520c84cbadd21$var$_react.default.createElement($1de520c84cbadd21$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$1de520c84cbadd21$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $1de520c84cbadd21$var$_default = module.exports.default = $1de520c84cbadd21$var$AssetsSchemaIcon;

});


parcelRegister("18OH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14e9f6a98bbe18a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a14e9f6a98bbe18a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jsmAssetsSchemas: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.schemas.jsm-assets-schemas",
        "defaultMessage": "Schemas"
    }
});

});


parcelRegister("iXbCd", function(module, exports) {
$parcel$export(module.exports, "SectionActions", () => $bd7dfdfa6a70aa5f$export$51f8029abf8c56ce);

var $eJOHy = parcelRequire("eJOHy");

var $4F5bb = parcelRequire("4F5bb");

var $f58rc = parcelRequire("f58rc");
var $6YEko = parcelRequire("6YEko");

var $6djmC = parcelRequire("6djmC");

var $lRq8t = parcelRequire("lRq8t");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $6naEG = parcelRequire("6naEG");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $bYOuG = parcelRequire("bYOuG");

var $kaLPl = parcelRequire("kaLPl");
function $bd7dfdfa6a70aa5f$export$51f8029abf8c56ce({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onOpen = ()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ASSETS], {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd7dfdfa6a70aa5f$var$MoreMenuItems, {
                ...props,
                isInsightAdministrator: isInsightAdministrator
            }),
        onClose: onClose,
        onOpen: ()=>onOpen()
    });
}
function $bd7dfdfa6a70aa5f$var$MoreMenuItems({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const configLink = (0, $eJOHy.useMemo)(()=>(0, $bYOuG.getGlobalConfigUrl)(), []);
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)(onClose);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClick = (e)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ASSETS], {
            level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
            componentType: (0, $493796f3bdee881c$export$74712b62056d422e),
            parentItemId: (0, $a9aec.SECTION_ITEM_ASSETS),
            itemId: (0, $bc40578f06d7846b$export$83d40997eb7cc5b7)
        });
        onCloseWithStopPropagation(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isInsightAdministrator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: configLink,
        onClick: (e)=>onClick(e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
        label: formatMessage((0, $kaLPl.default).jsmAssetsSettingsIcon),
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }), formatMessage((0, $kaLPl.default).jsmAssetsGlobalConfiguration)))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).ASSETS
    }));
}

});
parcelRegister("kaLPl", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f4acb85ba46ccfc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2f4acb85ba46ccfc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jsmAssetsGlobalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-global-configuration",
        "defaultMessage": "General configuration"
    },
    jsmAssetsSettingsIcon: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-settings-icon",
        "defaultMessage": "Settings"
    }
});

});




parcelRegister("7u7ku", function(module, exports) {
$parcel$export(module.exports, "CustomerService", () => $357d76dab5b061c6$export$5c26f0ffd7a4820d);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");

var $d47rS = parcelRequire("d47rS");
const $357d76dab5b061c6$export$5c26f0ffd7a4820d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-customer-service"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
        teamName: "Boysenberry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d47rS.CustomerServiceMenuLinkItem), null)));

});
parcelRegister("d47rS", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceMenuLinkItem", () => $963944c3e5e8eb01$export$276375fee74f0f11);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $i0tMD = parcelRequire("i0tMD");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");
const $963944c3e5e8eb01$export$208752a9164e5a6d = '/jira/helpcenter';
const $963944c3e5e8eb01$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE),
        hasSeparator: false
    }));
const $963944c3e5e8eb01$export$276375fee74f0f11 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.ui.sidenav-customer-service",
        href: $963944c3e5e8eb01$export$208752a9164e5a6d,
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
            MenuItems: $963944c3e5e8eb01$var$MenuItems
        })
    }, formattedMessage);
};

});


parcelRegister("jUiJS", function(module, exports) {
$parcel$export(module.exports, "Customers", () => $a88711667a021de2$export$d697df66e097e160);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");

var $fXh6D = parcelRequire("fXh6D");
const $a88711667a021de2$export$d697df66e097e160 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-customers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomers",
        teamName: "Boysenberry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXh6D.CustomersMenuLinkItem), null)));

});
parcelRegister("fXh6D", function(module, exports) {
$parcel$export(module.exports, "CustomersMenuLinkItem", () => $97056da40c53fe48$export$a2f8bc926cb9a0fa);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $02kpm = parcelRequire("02kpm");

var $cMc4W = parcelRequire("cMc4W");
const $97056da40c53fe48$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMERS),
        hasSeparator: false
    }));
const $97056da40c53fe48$export$a2f8bc926cb9a0fa = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $h4Bzb.MENU_ID_CUSTOMERS));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customers.ui.sidenav-customers",
        href: (0, $02kpm.generatePath)((0, $cMc4W.customerServiceCustomersRoute).path),
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMERS),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
            MenuItems: $97056da40c53fe48$var$MenuItems
        })
    }, formattedMessage);
};

});
parcelRegister("cMc4W", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomersRoute", () => $42febb48e4f83522$export$2391fb29392d13ce);
const $42febb48e4f83522$export$2391fb29392d13ce = {
    name: 'customer-service-customers',
    path: '/jira/customer-service/customers',
    exact: true
};

});



parcelRegister("gk3Hc", function(module, exports) {
$parcel$export(module.exports, "Nav4Dashboards", () => $869f94794192c56b$export$14aa7c6c8f362b5b);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");

var $iDV0Y = parcelRequire("iDV0Y");

var $kJJos = parcelRequire("kJJos");

const $869f94794192c56b$export$14aa7c6c8f362b5b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-dashboards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "dashboards-section",
        packageName: (0, $e6bca68b75395543$export$b8b9d90f9e5bd72b),
        teamName: (0, $e6bca68b75395543$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJJos.AnalyticContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iDV0Y.Nav4Dashboards), props))));

});
parcelRegister("iDV0Y", function(module, exports) {
$parcel$export(module.exports, "Nav4Dashboards", () => $b60eeac2b786e888$export$14aa7c6c8f362b5b);

var $eJOHy = parcelRequire("eJOHy");

var $d5muJ = parcelRequire("d5muJ");

var $idh5p = parcelRequire("idh5p");
function $b60eeac2b786e888$export$14aa7c6c8f362b5b({ isExpanded: isExpanded }) {
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d5muJ.ActionButtons), null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idh5p.DashboardsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("d5muJ", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $6611df09e6aa64ec$export$88c65d2d98aab183);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $jUgeq = parcelRequire("jUgeq");

var $k71qx = parcelRequire("k71qx");

var $kO1ht = parcelRequire("kO1ht");

var $7EgC9 = parcelRequire("7EgC9");

var $lRq8t = parcelRequire("lRq8t");

var $8IuE5 = parcelRequire("8IuE5");

var $ajqBI = parcelRequire("ajqBI");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $hih5V = parcelRequire("hih5V");

var $9o3jI = parcelRequire("9o3jI");

var $02kpm = parcelRequire("02kpm");
var $83DiZ = parcelRequire("83DiZ");


var $kJJos = parcelRequire("kJJos");

var $3hxrg = parcelRequire("3hxrg");
function $6611df09e6aa64ec$export$88c65d2d98aab183() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { off: modalClose }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).DASHBOARD_CREATE);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { path: path } = (0, $hih5V.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onSuccess = (0, $eJOHy.useCallback)((_, { id: id })=>{
        path && push((0, $02kpm.generatePath)(path, {
            dashboardId: id
        }));
        setIsOpen(false);
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    const onCancelCreateDashboardModal = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
        modalClose();
    }, [
        modalClose
    ]);
    const onClickCommonNavMenuButton = (0, $eJOHy.useCallback)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $e6bca68b75395543$export$7be02fe416808d26)
        });
        setIsOpen(true);
    }, [
        fireUIAnalyticForFixButton
    ]);
    const onOpenMoreNavMenuButton = (0, $eJOHy.useCallback)(()=>fireUIAnalyticForFixButton({
            itemId: (0, $e6bca68b75395543$export$f06dfcec5ff912e)
        }), [
        fireUIAnalyticForFixButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7EgC9.default), {
        onSuccess: onSuccess,
        onCancel: onCancelCreateDashboardModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $3hxrg.default).createDashboard)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        interactionName: "nav4-sidebar-dashboards-create-button",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $3hxrg.default).createDashboard),
        onClick: onClickCommonNavMenuButton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: onOpenMoreNavMenuButton,
        MenuItems: $6611df09e6aa64ec$var$MenuItems
    }));
}
const $6611df09e6aa64ec$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).DASHBOARDS,
        hasSeparator: false
    }));

});
parcelRegister("kO1ht", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $817604bc75ee0b6b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $817604bc75ee0b6b$export$d57b6b390e78d90f);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $817604bc75ee0b6b$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $817604bc75ee0b6b$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $817604bc75ee0b6b$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $817604bc75ee0b6b$export$286c2faa2103eb9c);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $817604bc75ee0b6b$export$69cbedccc0df48);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $817604bc75ee0b6b$export$cc578bc72d7a7308);
const $817604bc75ee0b6b$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $817604bc75ee0b6b$export$d57b6b390e78d90f = 'navigation';
const $817604bc75ee0b6b$export$ea341e6cc435ed40 = 15;
const $817604bc75ee0b6b$export$cb66c02d110b1531 = 10;
const $817604bc75ee0b6b$export$22ea57e66775a6b2 = 5;
const $817604bc75ee0b6b$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $817604bc75ee0b6b$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PEOPLE: 'people',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    ROADMAPS: 'roadmaps',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
    CONVERSATION_ASSISTANT: 'conversationAssistant',
    ROVO_DEMAND_TESTS: 'rovoDemandTests'
};
const $817604bc75ee0b6b$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $817604bc75ee0b6b$export$6037915bf3452cf3 = 'profile-spotlight';
const $817604bc75ee0b6b$export$286c2faa2103eb9c = 'help-spotlight';
const $817604bc75ee0b6b$export$c0d6ac131d4391b9 = 'search-spotlight';
const $817604bc75ee0b6b$export$8d9442dfaec4086f = 'projects-spotlight';
const $817604bc75ee0b6b$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
const $817604bc75ee0b6b$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $817604bc75ee0b6b$export$1935aad1d702494c = {
    RECENT: 'RECENT',
    BOARDS: 'BOARDS',
    QUEUES: 'QUEUES',
    ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
    ADD_FILTER: 'ADD_FILTER',
    ALERTS: 'ALERTS'
};
const $817604bc75ee0b6b$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;

});

parcelRegister("7EgC9", function(module, exports) {
$parcel$export(module.exports, "default", () => $8304d348e8f763ab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8304d348e8f763ab$var$AsyncCreateDashboardModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("VxnuO")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/create-dashboard-modal/src/index.tsx"
});
const $8304d348e8f763ab$var$AsyncCreateDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "create-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8304d348e8f763ab$var$AsyncCreateDashboardModal, props));
var $8304d348e8f763ab$export$2e2bcd8739ae039 = $8304d348e8f763ab$var$AsyncCreateDashboardModalContainer;

});
parcelRegister("VxnuO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2R8gf").then(()=>parcelRequire('5CafV'));

});


parcelRegister("9o3jI", function(module, exports) {
$parcel$export(module.exports, "useSwitchModals", () => $72b2d0fa90dcdffb$export$5ed4b99cbad4ebd6);

var $dA7TN = parcelRequire("dA7TN");
const { useSwitch: $72b2d0fa90dcdffb$var$useSwitch } = (0, $dA7TN.createSwitchController)('jira-switch-modals');
const $72b2d0fa90dcdffb$export$5ed4b99cbad4ebd6 = $72b2d0fa90dcdffb$var$useSwitch;

});
parcelRegister("dA7TN", function(module, exports) {
$parcel$export(module.exports, "createSwitchController", () => $3d9c3bd86080b366$export$1856548326159ec8);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3d9c3bd86080b366$export$1856548326159ec8 = (name, activeByDefault)=>{
    const actions = {
        on: (active)=>({ setState: setState })=>setState({
                    active: active
                }),
        off: (active)=>({ setState: setState, getState: getState })=>{
                if (getState().active === active || active === undefined) setState({
                    active: undefined
                });
            },
        toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                if (getState().active === active) dispatch(actions.off(active));
                else dispatch(actions.on(active));
            }
    };
    const initialState = {
        active: activeByDefault
    };
    const store = (0, $GtRbT.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    const SwitchContainer = (0, $6E16M.createContainer)(store);
    const selector = (state, key)=>state.active === key;
    const useSwitchInternal = (0, $iJq0l.createHook)(store, {
        selector: selector
    });
    const useSwitch = (active)=>{
        const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
        const on = (0, $eJOHy.useCallback)(()=>onSwitch(active), [
            onSwitch,
            active
        ]);
        const off = (0, $eJOHy.useCallback)(()=>offSwitch(active), [
            active,
            offSwitch
        ]);
        const toggle = (0, $eJOHy.useCallback)(()=>toggleSwitch(active), [
            toggleSwitch,
            active
        ]);
        return [
            isActive,
            {
                on: on,
                off: off,
                toggle: toggle
            }
        ];
    };
    return {
        SwitchContainer: SwitchContainer,
        useSwitch: useSwitch
    };
};

});


const $e6bca68b75395543$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $e6bca68b75395543$export$d57b6b390e78d90f = 'jira-cosmos';
const $e6bca68b75395543$export$65b778215f917c60 = 'viewAllDashboards';
const $e6bca68b75395543$export$7be02fe416808d26 = 'createDashboard';
const $e6bca68b75395543$export$f06dfcec5ff912e = 'meatballDropdown';

parcelRegister("kJJos", function(module, exports) {
$parcel$export(module.exports, "AnalyticContext", () => $235568eca06a9a9f$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $235568eca06a9a9f$export$aea8e3edcdec81e3);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

const $235568eca06a9a9f$export$da0556bf821b3494 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForDashboardItems: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $235568eca06a9a9f$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: (0, $e6bca68b75395543$export$65b778215f917c60)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $eJOHy.useCallback)(({ itemId: itemId })=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $eJOHy.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'dashboard',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForDashboardItems = (0, $eJOHy.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                itemType: (0, $6bf6536f83c22cfe$export$4695c1a423ffe431).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const memoValue = (0, $eJOHy.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems
        }), [
        fireUIAnalyticForDashboardItems,
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($235568eca06a9a9f$export$da0556bf821b3494.Provider, {
        value: memoValue
    }, children);
};

});

parcelRegister("3hxrg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4099873d99178e32$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4099873d99178e32$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createDashboard: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.action-buttons.create-dashboard",
        "defaultMessage": "Create dashboard"
    }
});

});


parcelRegister("idh5p", function(module, exports) {
$parcel$export(module.exports, "DashboardsDefault", () => $9e2134a56ceba433$export$bffc92c7e4f51e0b);

var $eJOHy = parcelRequire("eJOHy");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $iWvkh = parcelRequire("iWvkh");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $cHtIB = parcelRequire("cHtIB");


var $jrulJ = parcelRequire("jrulJ");

var $eApSa = parcelRequire("eApSa");


var $4LPom = parcelRequire("4LPom");

var $hUpHQ = parcelRequire("hUpHQ");
const $9e2134a56ceba433$export$bffc92c7e4f51e0b = /*#__PURE__*/ (0, $eJOHy.memo)($9e2134a56ceba433$var$_DashboardsDefault);
function $9e2134a56ceba433$var$_DashboardsDefault(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components, react-hooks/rules-of-hooks
    const cloudId = (0, $cHtIB.useCloudId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; }; }' but required in type 'EntryPointRouteParams'.ts(2741)
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            }
        }), [
        cloudId
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components, @typescript-eslint/consistent-type-assertions, react-hooks/rules-of-hooks
    const leftSidebarEPRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const dashboardsEPRef = leftSidebarEPRef?.entryPoints?.dashboards;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components, react-hooks/rules-of-hooks
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $hUpHQ.nav4DashboardsContentEntryPoint), entryPointParams);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components, react-hooks/rules-of-hooks
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components, react-hooks/rules-of-hooks
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).DASHBOARDS);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components, react-hooks/rules-of-hooks
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const epContainerProps = (0, $eJOHy.useMemo)(()=>({
            id: 'nav4-sidebar-dashboards-default',
            packageName: (0, $e6bca68b75395543$export$b8b9d90f9e5bd72b),
            teamName: (0, $e6bca68b75395543$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
                withHeading: true
            }),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        }), [
        entryPointParams
    ]);
    // This callback makes sure that the EP is loaded when the _system_ determines that the expandable
    // should be open.
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components, react-hooks/rules-of-hooks
    const onSystemToggleFn = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components, react-hooks/rules-of-hooks
    const onExpansionToggleFn = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).DASHBOARDS,
                sectionItem: (0, $a9aec.SECTION_ITEM_DASHBOARDS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_DASHBOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: onSystemToggleFn,
        onExpansionToggle: onExpansionToggleFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-dashboards-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eApSa.RouteEntryPointContainer), {
        epContainerProps: epContainerProps,
        jiraEPRef: entryPointReferenceSubject,
        nestedEPRef: dashboardsEPRef,
        placeholderEntryPoint: (0, $hUpHQ.nav4DashboardsContentEntryPoint)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4LPom.Footer), null)));
}

});
const $ce4cfb37df77ff19$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $ce4cfb37df77ff19$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $ce4cfb37df77ff19$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $ce4cfb37df77ff19$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $ce4cfb37df77ff19$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
const $ce4cfb37df77ff19$export$5ef29550cd5a8266 = '___pageLayoutRedirect';
const $ce4cfb37df77ff19$export$22ce74854c620e75 = '__pageLayoutSpaContent';

parcelRegister("jrulJ", function(module, exports) {
$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $176e6598597033a8$export$fe1c839e8baf4110);

var $4NOqL = parcelRequire("4NOqL");

var $hih5V = parcelRequire("hih5V");
const $176e6598597033a8$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const entryPointReference = (0, $4NOqL.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("4NOqL", function(module, exports) {
$parcel$export(module.exports, "useRouteEntryPoint", () => $f8a432c8c4e16068$export$c96377f800cdddb4);

var $6ooDe = parcelRequire("6ooDe");
const $f8a432c8c4e16068$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $6ooDe.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});
parcelRegister("6ooDe", function(module, exports) {
$parcel$export(module.exports, "useLastLoadedRoute", () => $58dd46e75972188d$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $58dd46e75972188d$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $58dd46e75972188d$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $58dd46e75972188d$export$7e18f3e3cbd04326);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $14kUX = parcelRequire("14kUX");
const $58dd46e75972188d$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $58dd46e75972188d$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $58dd46e75972188d$var$actions = {
    setLastLoadedRoute: $58dd46e75972188d$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $58dd46e75972188d$export$bb3dc9c55f78173e
};
const $58dd46e75972188d$var$EntryPointsStore = (0, $GtRbT.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $58dd46e75972188d$var$actions,
    name: 'react-resource-router/entry-points'
});
const $58dd46e75972188d$export$895238443fc3eae4 = (0, $iJq0l.createHook)($58dd46e75972188d$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $58dd46e75972188d$export$fe654a734624d17f = ()=>(0, $14kUX.defaultRegistry).getStore($58dd46e75972188d$var$EntryPointsStore);
const $58dd46e75972188d$export$b28ecd0e4705f6b7 = ()=>$58dd46e75972188d$export$fe654a734624d17f().storeState.getState();
const $58dd46e75972188d$export$5763b2305b3056df = ()=>$58dd46e75972188d$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $58dd46e75972188d$export$7e18f3e3cbd04326 = ()=>$58dd46e75972188d$export$b28ecd0e4705f6b7().prefetchingRoute;

});



parcelRegister("eApSa", function(module, exports) {
$parcel$export(module.exports, "RouteEntryPointContainer", () => $3d3c8b1ee7532595$export$3e4cdfb894377bc9);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2dBpR = parcelRequire("2dBpR");

var $cBavF = parcelRequire("cBavF");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");
const $3d3c8b1ee7532595$export$3e4cdfb894377bc9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ epContainerProps: epContainerProps, jiraEPRef: jiraEPRef, nestedEPRef: nestedEPRef, shouldRenderNestedEntryPoint: shouldRenderNestedEntryPoint = true })=>{
    // If the route is an entryPoint, and the initialRoute was an entryPoint, use EntryPointContainer.
    // Otherwise, use the JiraEntryPointContainer.
    return shouldRenderNestedEntryPoint && nestedEPRef ? // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: `${epContainerProps.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        attributes: epContainerProps.errorAttributes,
        fallback: epContainerProps.errorFallback,
        id: epContainerProps.id,
        packageName: epContainerProps.packageName,
        teamName: epContainerProps.teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: `${epContainerProps.id || 'route-entrypoint-adapter'}-entrypoint-placeholder`,
        fallback: epContainerProps.fallback,
        entryPointReference: nestedEPRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: nestedEPRef,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        ...epContainerProps,
        entryPointReferenceSubject: jiraEPRef
    });
});

});
parcelRegister("2dBpR", function(module, exports) {
$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $8022a3e2b790699e$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $8022a3e2b790699e$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointReferencePlaceholder", () => $8022a3e2b790699e$export$35247b69e0cfe74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");
const $8022a3e2b790699e$var$styles = {
    root: "_1e0c1bgi"
};
const $8022a3e2b790699e$var$Placeholder = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-concurrent-fix-entrypoint-placeholder'), (0, $2imLM.PlaceholderWithNativeSuspense), (0, $2imLM.default));
function $8022a3e2b790699e$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $8022a3e2b790699e$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $eJOHy.createContext)(new Map());
function $8022a3e2b790699e$export$35247b69e0cfe74({ children: children, entryPointReference: entryPointReference, fallback: originalFallback, name: name, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled, ...placeholderProps }) {
    const hasMounted = (0, $eJOHy.useRef)(false);
    // using useState to ensure the entryPointReference is loaded synchronously
    // for the initial render (enabling SSR)
    const [component] = (0, $eJOHy.useState)(()=>{
        if (entryPointReference) try {
            return entryPointReference.getComponent();
        } catch (thrown) {
            return undefined;
        }
    });
    const placeholders = (0, $eJOHy.useContext)($8022a3e2b790699e$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $eJOHy.useState)(!ssrFallback || component ? originalFallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name,
        ...isSSRPlaceholderEnabled && {
            'data-vc': name
        },
        ...isSSRPlaceholderEnabled && false && {
            'data-ssr-placeholder': name
        },
        ...isSSRPlaceholderEnabled && !false && {
            'data-ssr-placeholder-replace': name
        },
        className: (0, $hcewu.default)([
            $8022a3e2b790699e$var$styles.root
        ])
    }));
    const lastOriginalFallback = (0, $eJOHy.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    const resetFallback = (0, $eJOHy.useCallback)(()=>{
        if (placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        name,
        placeholders,
        setFallback
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // reset the fallback when the entrypoint reference changes
        if (hasMounted.current) resetFallback();
    }, [
        entryPointReference,
        resetFallback
    ]);
    (0, $eJOHy.useEffect)(()=>{
        hasMounted.current = true;
        // reset fallback on unmount
        return resetFallback;
    }, [
        resetFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8022a3e2b790699e$var$Placeholder, {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-ep-placeholder-id": name,
        ...isSSRPlaceholderEnabled && {
            'data-vc': name
        },
        ...isSSRPlaceholderEnabled && false && {
            'data-ssr-placeholder': name
        },
        ...isSSRPlaceholderEnabled && !false && {
            'data-ssr-placeholder-replace': name
        },
        className: (0, $hcewu.default)([
            $8022a3e2b790699e$var$styles.root
        ])
    }, children));
}

});


parcelRegister("4LPom", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $43066705c12c7d2f$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $fuV6j = parcelRequire("fuV6j");

var $kJJos = parcelRequire("kJJos");

var $1TJWv = parcelRequire("1TJWv");
const $43066705c12c7d2f$var$VIEW_ALL_DASHBOARDS_HREF = (0, $fuV6j.dashboardsDirectoryRoute).path;
const $43066705c12c7d2f$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        href: $43066705c12c7d2f$var$VIEW_ALL_DASHBOARDS_HREF,
        menuId: (0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage((0, $1TJWv.default).viewAllDashboards)))));
};

});
parcelRegister("1Ce3C", function(module, exports) {
$parcel$export(module.exports, "ViewAllEntityMenuItem", () => $6b70189709783932$export$505e81ff2081288b);

var $eJOHy = parcelRequire("eJOHy");

var $bpdtz = parcelRequire("bpdtz");

var $i0tMD = parcelRequire("i0tMD");
function $6b70189709783932$export$505e81ff2081288b(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        ...props,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            color: "currentColor"
        })
    });
}

});
parcelRegister("bpdtz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cec8b305f101f10fbc944cd0b6e15b18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84dc7b8990a272ed$var$_react = $84dc7b8990a272ed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84dc7b8990a272ed$var$_baseNew = $84dc7b8990a272ed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $84dc7b8990a272ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84dc7b8990a272ed$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $84dc7b8990a272ed$var$_react.default.createElement($84dc7b8990a272ed$var$_baseNew.default, Object.assign({
        name: "AlignTextLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$84dc7b8990a272ed$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $84dc7b8990a272ed$var$_default = module.exports.default = $84dc7b8990a272ed$var$AlignTextLeftIcon;

});


parcelRegister("1TJWv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2276efb8df1b227f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2276efb8df1b227f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllDashboards: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.footer.view-all-dashboards",
        "defaultMessage": "View all dashboards"
    }
});

});


parcelRegister("hUpHQ", function(module, exports) {
$parcel$export(module.exports, "nav4DashboardsContentEntryPoint", () => $b7477b456fabc7f8$export$d6e6956d3748383b);

var $hGie9 = parcelRequire("hGie9");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $b7477b456fabc7f8$export$d6e6956d3748383b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eNozx")).then(({ DashboardsContentViewQuery: DashboardsContentViewQuery })=>DashboardsContentViewQuery), {
        moduleId: "d524dcfe",
        moduleName: "DashboardsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        return {
            queries: {
                queryRef: {
                    parameters: $hGie9.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("hGie9", function(module, exports) {
$parcel$export(module.exports, "default", () => $21b0fdb40b894199$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6793555e2dbfaf8db2fe4c7edd9d81f4>>
 * @relayHash 9a58486151638f4e45660f746394b248
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d
const $21b0fdb40b894199$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d",
        "metadata": {},
        "name": "DashboardsContentViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $21b0fdb40b894199$export$2e2bcd8739ae039 = $21b0fdb40b894199$var$node;

});

parcelRegister("eNozx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kvWGt").then(()=>parcelRequire('bwe76'));

});





parcelRegister("5n5Xi", function(module, exports) {
$parcel$export(module.exports, "Nav4Filters", () => $49cceca1658c509f$export$caf6e58bb8560bb2);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $jqMKi = parcelRequire("jqMKi");

var $4EKqI = parcelRequire("4EKqI");

const $49cceca1658c509f$export$caf6e58bb8560bb2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "filters-section",
        packageName: (0, $2ae2c8b27c911905$export$b8b9d90f9e5bd72b),
        teamName: (0, $2ae2c8b27c911905$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqMKi.Nav4Filters), props)));

});
parcelRegister("jqMKi", function(module, exports) {
$parcel$export(module.exports, "Nav4Filters", () => $86fa36ef170147e1$export$caf6e58bb8560bb2);

var $dG4lF = parcelRequire("dG4lF");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $8mGa3 = parcelRequire("8mGa3");

var $fhtBG = parcelRequire("fhtBG");

var $3E5ko = parcelRequire("3E5ko");
function $86fa36ef170147e1$export$caf6e58bb8560bb2({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $dG4lF.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mGa3.ActionButtons), null), []);
    if (!data.jira?.hasIsFiltersExpanded && isInitialSelectedPath((0, $h4Bzb.MENU_ID_FILTERS))) // We need to make sure that we're only passing the conditionalal fragment when it is actually
    // available. Due to a lack of support the @alias Relay directive, we need to use another mechanism
    // and in this case we're using a hardcoded __typename to check if the fragment is available.
    // This is a workaround until we can use the @alias directive in Relay. If the hasIsProjectsExpanded
    // attribute is not available, then the fragment won't be either and we shouldn't pass it.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3E5ko.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
    return isInitialSelectedPath((0, $h4Bzb.MENU_ID_FILTERS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fhtBG.Nav4FiltersForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3E5ko.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("dG4lF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dbff990dd23a4a7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca5697fbb6a29ad933542b5ec3a3de2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dbff990dd23a4a7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isFiltersExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Filters",
    "selections": [
        {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsFiltersExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$4dbff990dd23a4a7$var$node.hash = "3df2d83f4108ed18026f86044ce6e248";
var $4dbff990dd23a4a7$export$2e2bcd8739ae039 = $4dbff990dd23a4a7$var$node;

});

parcelRegister("8mGa3", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $c42e29f2711fde62$export$88c65d2d98aab183);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");





var $8IuE5 = parcelRequire("8IuE5");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $1TzuH = parcelRequire("1TzuH");
const $c42e29f2711fde62$export$88c65d2d98aab183 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onClose: onClose })=>{
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const sendMeatballAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$b887e88d8d0739f6), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: $c42e29f2711fde62$var$MoreMenuItems,
        onClose: onClose
    });
});
function $c42e29f2711fde62$var$MoreMenuItems(_) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
        hasSeparator: false
    }));
}

});
parcelRegister("1TzuH", function(module, exports) {
$parcel$export(module.exports, "useFilterActionsAnalytics", () => $e5be81988b092880$export$97e99df7fbddf9f6);
$parcel$export(module.exports, "getFilterActionAttributes", () => $e5be81988b092880$export$b06742bfd24ebf9f);
$parcel$export(module.exports, "getFilterMeatBallAttributes", () => $e5be81988b092880$export$b8e6b9b84ba340a2);
$parcel$export(module.exports, "getRecentAndFavouriteFilterAttributes", () => $e5be81988b092880$export$2108e20c9691c7e4);
$parcel$export(module.exports, "getDefaulFilterAttributes", () => $e5be81988b092880$export$15e07b997aa6036a);

var $eJOHy = parcelRequire("eJOHy");





var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $e5be81988b092880$export$97e99df7fbddf9f6 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireFilterActionAnalytics = (0, $eJOHy.useCallback)((actionSubject, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_FILTERS], attributes);
    }, [
        createAnalyticsEvent
    ]);
    return fireFilterActionAnalytics;
};
const $e5be81988b092880$var$systemFilterNameMap = [
    {
        name: 'myOpenIssues',
        id: '-1'
    },
    {
        name: 'reportedByMe',
        id: '-2'
    },
    {
        name: 'allIssues',
        id: '-4'
    },
    {
        name: 'openIssues',
        id: '-5'
    },
    {
        name: 'doneIssues',
        id: '-9'
    },
    {
        name: 'viewedRecently',
        id: '-3'
    },
    {
        name: 'resolvedRecently',
        id: '-7'
    },
    {
        name: 'updatedRecently',
        id: '-8'
    },
    {
        name: 'createdRecently',
        id: '-6'
    }
];
const $e5be81988b092880$export$c8c77a62dd73e040 = (id)=>{
    const systemFilter = $e5be81988b092880$var$systemFilterNameMap.find((filter)=>filter.id === id);
    return systemFilter?.name || '';
};
const $e5be81988b092880$var$getSection = (isCustom, isFavourite)=>{
    let section;
    if (!isCustom && !isFavourite) section = 'defaultFilters';
    else if (isFavourite) section = (0, $a9aec.SECTION_ITEM_STARRED);
    else section = (0, $a9aec.SECTION_ITEM_RECENT);
    return section;
};
const $e5be81988b092880$var$getFilterId = (isCustom, filterId)=>{
    if (!filterId) return null;
    return (0, $h4Bzb.ENTITY_ID).FILTER(isCustom ? filterId : $e5be81988b092880$export$c8c77a62dd73e040(filterId));
};
const $e5be81988b092880$export$b06742bfd24ebf9f = ({ itemId: itemId, isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $e5be81988b092880$var$getSection(isCustom, Boolean(isFavourite));
    return {
        itemId: itemId,
        section: section,
        level: section === 'defaultFilters' ? (0, $4fdd5d9c1b32dd60$export$35ac629b8b943d5a) : (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
        componentType: isCustom ? (0, $493796f3bdee881c$export$5374c2c2d3ece55e) : (0, $493796f3bdee881c$export$74712b62056d422e),
        parentItemType: isCustom ? (0, $6bf6536f83c22cfe$export$c1c49903035a02df) : (0, $6bf6536f83c22cfe$export$6deee0e4f2fb784e),
        parentItemId: $e5be81988b092880$var$getFilterId(isCustom, filterId)
    };
};
const $e5be81988b092880$export$b8e6b9b84ba340a2 = ({ isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $e5be81988b092880$var$getSection(isCustom, Boolean(isFavourite));
    return {
        section: section,
        level: section === 'defaultFilters' ? (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18) : (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
        componentType: isCustom ? (0, $493796f3bdee881c$export$9bd6c21d500ae611) : (0, $493796f3bdee881c$export$95b0c331af13d819),
        itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e),
        parentItemType: isCustom ? (0, $6bf6536f83c22cfe$export$c1c49903035a02df) : (0, $6bf6536f83c22cfe$export$6deee0e4f2fb784e),
        parentItemId: $e5be81988b092880$var$getFilterId(isCustom, filterId)
    };
};
const $e5be81988b092880$export$2108e20c9691c7e4 = ({ isCustom: isCustom, filterId: filterId, section: section })=>{
    return {
        level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
        section: section,
        componentType: isCustom ? (0, $493796f3bdee881c$export$3ac911b122986477) : (0, $493796f3bdee881c$export$4165a3d0da3bd147),
        itemId: $e5be81988b092880$var$getFilterId(isCustom, filterId),
        itemType: isCustom ? (0, $6bf6536f83c22cfe$export$c1c49903035a02df) : (0, $6bf6536f83c22cfe$export$6deee0e4f2fb784e)
    };
};
const $e5be81988b092880$export$15e07b997aa6036a = ({ filterId: filterId })=>{
    return {
        level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
        itemId: $e5be81988b092880$var$getFilterId(false, filterId),
        section: 'defaultFilters',
        componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
        itemType: (0, $6bf6536f83c22cfe$export$6deee0e4f2fb784e)
    };
};

});


parcelRegister("fhtBG", function(module, exports) {
$parcel$export(module.exports, "Nav4FiltersForLanding", () => $50bd50e1c8f32fbc$export$90658bd06cecabd4);

var $68RLL = parcelRequire("68RLL");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $5vQ2T = parcelRequire("5vQ2T");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $4EKqI = parcelRequire("4EKqI");

var $4yn0c = parcelRequire("4yn0c");


var $lRTqK = parcelRequire("lRTqK");

var $44iMp = parcelRequire("44iMp");
function $50bd50e1c8f32fbc$export$90658bd06cecabd4(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const data = (0, $j4oe4.useFragment)((0, $68RLL.default), queryRef);
    const menuId = (0, $h4Bzb.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
                sectionItem: (0, $a9aec.SECTION_ITEM_FILTERS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-landing",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $44iMp.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-filters-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "nav4-sidebar-filters-landing",
        packageName: (0, $2ae2c8b27c911905$export$b8b9d90f9e5bd72b),
        teamName: (0, $2ae2c8b27c911905$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4yn0c.Nav4FiltersContent), {
        queryRef: data
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRTqK.Footer), null)));
}

});
parcelRegister("68RLL", function(module, exports) {
$parcel$export(module.exports, "default", () => $982db24ca69b6fc2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3cce317c9d4d64ec51601d1438d8020>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $982db24ca69b6fc2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FiltersForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4FiltersContent"
        }
    ],
    "type": "Query"
};
$982db24ca69b6fc2$var$node.hash = "6171665054b4de86e6a0c40316984aba";
var $982db24ca69b6fc2$export$2e2bcd8739ae039 = $982db24ca69b6fc2$var$node;

});

parcelRegister("4yn0c", function(module, exports) {
$parcel$export(module.exports, "Nav4FiltersContent", () => $94ac381b9a46e100$export$e0cd6afcf36dd0ac);

var $7QKYs = parcelRequire("7QKYs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");
var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $6rSB4 = parcelRequire("6rSB4");

var $lRq8t = parcelRequire("lRq8t");




var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $i0tMD = parcelRequire("i0tMD");

var $h3HFC = parcelRequire("h3HFC");

var $3uQAw = parcelRequire("3uQAw");

var $6z0UB = parcelRequire("6z0UB");

var $cHtIB = parcelRequire("cHtIB");

var $kh7bJ = parcelRequire("kh7bJ");

var $f7RmV = parcelRequire("f7RmV");

var $1TzuH = parcelRequire("1TzuH");

var $8aXvZ = parcelRequire("8aXvZ");
const $94ac381b9a46e100$var$MAX_RECENT_FILTERS = 5;
const $94ac381b9a46e100$export$1f869c99ead9db5f = 15;
const $94ac381b9a46e100$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $94ac381b9a46e100$var$defaultFiltersRequiringLogin = [
    {
        id: '-1'
    },
    {
        id: '-2'
    },
    {
        id: '-3'
    }
];
const $94ac381b9a46e100$var$entityTypenames = [
    'JiraCustomFilter',
    'JiraSystemFilter'
];
function $94ac381b9a46e100$export$e0cd6afcf36dd0ac({ queryRef: queryRef }) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const { getStableItems: getStableItems } = (0, $3uQAw.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    // We intentionally request 15 starred and 20 recent filters.
    // Recent filters should exclude system/default filters.
    // Then, if all 15 starred filters were recently visited, we still show 5 recent filters as well.
    const [fragmentData, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $7QKYs.default), queryRef);
    const { jira: { favouriteFilters: favouriteFilters, recentFilters: recentFilters, systemFilters: systemFilters } } = fragmentData;
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $6z0UB.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_FILTERS)
    });
    const refetchOnChange = (0, $eJOHy.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $h3HFC.useSubscribeAndUpdateFavorites)({
        entityTypename: $94ac381b9a46e100$var$entityTypenames,
        favouriteConnectionId: favouriteFilters.__id,
        recentConnectionId: recentFilters.__id,
        refetch: refetchOnChange
    });
    const { subscribe: subscribe, unsubscribe: unsubscribe } = (0, $6rSB4.useDeleteChangeActions)();
    // allows the sidebar to reflect filter changes when a filter is deleted from the filters directory page
    (0, $eJOHy.useEffect)(()=>{
        subscribe(refetchOnChange);
        return ()=>{
            unsubscribe(refetchOnChange);
        };
    }, [
        refetchOnChange,
        subscribe,
        unsubscribe
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const starred = formatMessage((0, $8aXvZ.default).starred);
    const recent = formatMessage((0, $8aXvZ.default).recent);
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const favorites = (0, $eJOHy.useMemo)(()=>{
        const ids = favouriteFilters.edges?.map((edge)=>edge?.node.filterId).filter(Boolean) ?? [];
        const list = favouriteFilters.edges?.filter(Boolean).map((edge)=>{
            const isCustom = edge.node.__typename === 'JiraCustomFilter';
            const sendFavouriteFilterAnalytics = ()=>sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), (0, $1TzuH.getRecentAndFavouriteFilterAttributes)({
                    isCustom: isCustom,
                    filterId: edge.node.filterId,
                    section: (0, $a9aec.SECTION_ITEM_STARRED)
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7RmV.Nav4FilterMenuItem), {
                key: edge.node.filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: sendFavouriteFilterAnalytics
            });
        }) ?? [];
        return {
            idSet: new Set(ids),
            list: list.slice(0, $94ac381b9a46e100$export$1f869c99ead9db5f),
            hasItems: Boolean(list.length),
            hasMore: favouriteFilters.pageInfo?.hasNextPage || list.length > $94ac381b9a46e100$export$1f869c99ead9db5f
        };
    }, [
        favouriteFilters,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const recentItems = (0, $eJOHy.useMemo)(()=>{
        const nodes = recentFilters.edges?.filter(Boolean).filter((edge)=>edge.node.filterId && !favorites.idSet.has(edge.node.filterId)).map((edge)=>edge.node).slice(0, $94ac381b9a46e100$var$MAX_RECENT_FILTERS) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'filterId'
        });
        const list = stableOrderedNodes.map((node)=>{
            const sendRecentFilterAnalytics = ()=>sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), (0, $1TzuH.getRecentAndFavouriteFilterAttributes)({
                    isCustom: true,
                    filterId: node.filterId,
                    section: (0, $a9aec.SECTION_ITEM_RECENT)
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7RmV.Nav4FilterMenuItem), {
                key: node.filterId,
                queryRef: node,
                onRefetch: refetchOnChange,
                onClick: sendRecentFilterAnalytics
            });
        });
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentFilters.edges,
        getStableItems,
        favorites.idSet,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const defaultItems = (0, $eJOHy.useMemo)(()=>{
        const filterIds = [];
        const list = systemFilters.edges?.filter((edge)=>edge?.node?.filterId && !favorites.idSet.has(edge.node.filterId))?.filter((edge)=>edge?.node?.filterId && (!isAnonymous || !$94ac381b9a46e100$var$defaultFiltersRequiringLogin.find((filter)=>filter.id === edge.node.filterId))).map((edge)=>{
            edge?.node && filterIds.push(edge?.node.filterId);
            return edge;
        }).map((edge)=>{
            if (!edge?.node) return null;
            const sendDefaultFilterAnalytics = ()=>sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), (0, $1TzuH.getDefaulFilterAttributes)({
                    filterId: edge.node.filterId
                }));
            return edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7RmV.Nav4FilterMenuItem), {
                key: edge.node.filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: sendDefaultFilterAnalytics
            }) : null;
        }) || [];
        return {
            list: list,
            hasItems: Boolean(list.length),
            filterIds: filterIds
        };
    }, [
        systemFilters.edges,
        favorites.idSet,
        isAnonymous,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const sendViewAllStarredAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: 'viewAllStarred'
        });
    }, [
        sendFilterAnalytics
    ]);
    const sendDefaultFilterDropdownAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$b887e88d8d0739f6), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: 'defaultFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    const onExpansionToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendDefaultFilterDropdownAnalytics();
    }, [
        sendDefaultFilterDropdownAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, favorites.list))), favouriteFilters.pageInfo?.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $94ac381b9a46e100$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $h4Bzb.MENU_ID_FILTERS_VIEW_ALL_STARRED),
        onClick: sendViewAllStarredAnalytics
    }, formatMessage((0, $8aXvZ.default).viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, recentItems.list))), defaultItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        isDefaultExpanded: true,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-default-filters"
    }, formatMessage((0, $8aXvZ.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, defaultItems.list)));
}

});
parcelRegister("7QKYs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1d57770e701dfe1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffa5b5733326eabb56fcfb6e2f05b1d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $6z0UB = parcelRequire("6z0UB");
const $a1d57770e701dfe1$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v2 = {
        "kind": "FragmentSpread",
        "name": "Nav4FilterMenuItem"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $6z0UB.default)
            }
        },
        "name": "Nav4FiltersContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouriteFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "FILTER"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.favouriteFilters.edges.node"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.favouriteFilters"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "FILTER"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v4 /*: any*/ ,
                                                            "type": "JiraCustomFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.recentFilters.edges.node"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.recentFilters"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    v0 /*: any*/ 
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ 
                                                },
                                                "action": "THROW",
                                                "path": "jira.systemFilters.edges.node"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.systemFilters"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$a1d57770e701dfe1$var$node.hash = "3f2ab01091a0154bb13d2ed1b15e13ef";
var $a1d57770e701dfe1$export$2e2bcd8739ae039 = $a1d57770e701dfe1$var$node;

});
parcelRegister("6z0UB", function(module, exports) {
$parcel$export(module.exports, "default", () => $d11286d5269ae73a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e4100b4266ad9f2bb1c31ed34ee8522f>>
 * @relayHash 99bea4c9d007a836d2f2aee3f9d2e63e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7050d00d8eefcfbd4847d47076260938acf8d0a28ab345db32aaed09d76e8fc5
const $d11286d5269ae73a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v8 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v6 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v11 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7050d00d8eefcfbd4847d47076260938acf8d0a28ab345db32aaed09d76e8fc5",
            "metadata": {},
            "name": "Nav4FiltersContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d11286d5269ae73a$var$node.hash = "3f2ab01091a0154bb13d2ed1b15e13ef";
var $d11286d5269ae73a$export$2e2bcd8739ae039 = $d11286d5269ae73a$var$node;

});


parcelRegister("6rSB4", function(module, exports) {
$parcel$export(module.exports, "useDeleteChangeActions", () => $0a3ddf754bc07ef4$export$ebbca0408972222d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $0a3ddf754bc07ef4$var$initialState = {
    callbacks: []
};
const $0a3ddf754bc07ef4$export$e324594224ef24da = {
    subscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (!getState().callbacks.includes(callback)) setState({
                callbacks: [
                    ...getState().callbacks,
                    callback
                ]
            });
        },
    unsubscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (getState().callbacks.includes(callback)) setState({
                callbacks: getState().callbacks.filter((item)=>item !== callback)
            });
        },
    publish: ()=>({ getState: getState })=>{
            getState().callbacks.forEach((callback)=>callback({
                    onComplete: ()=>undefined
                }));
        }
};
const $0a3ddf754bc07ef4$var$Store = (0, $GtRbT.createStore)({
    initialState: $0a3ddf754bc07ef4$var$initialState,
    actions: $0a3ddf754bc07ef4$export$e324594224ef24da
});
const $0a3ddf754bc07ef4$export$440b46140bc86b64 = (0, $iJq0l.createStateHook)($0a3ddf754bc07ef4$var$Store);
const $0a3ddf754bc07ef4$export$ebbca0408972222d = (0, $iJq0l.createActionsHook)($0a3ddf754bc07ef4$var$Store);

});

parcelRegister("hc6Nm", function(module, exports) {
$parcel$export(module.exports, "useRefetchWhenIsSelected", () => $479f4d04b1a0398e$export$ed209ae428704c56);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $49s4h = parcelRequire("49s4h");
function $479f4d04b1a0398e$export$ed209ae428704c56(params) {
    const { cloudId: cloudId, isSelectedPath: isSelectedPath, menuId: menuId, refetch: refetch, queryVariables: queryVariables, QUERY: QUERY } = params;
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const currentURL = (0, $49s4h.useGetCurrentUrl)();
    const currentURLPath = (0, $49s4h.useGetCurrentUrlPath)();
    (0, $eJOHy.useEffect)(()=>{
        if (isSelectedPath(menuId)) (0, $j4oe4.fetchQuery)(environment, QUERY, {
            cloudId: cloudId,
            currentURL: currentURL,
            currentURLPath: currentURLPath,
            ...queryVariables
        }).subscribe({
            complete: ()=>{
                refetch({
                    cloudId: cloudId,
                    currentURL: currentURL,
                    ...queryVariables
                }, {
                    fetchPolicy: 'store-only'
                });
            }
        });
    }, [
        cloudId,
        isSelectedPath,
        menuId,
        refetch,
        currentURL,
        currentURLPath,
        environment,
        queryVariables,
        QUERY
    ]);
}

});
parcelRegister("49s4h", function(module, exports) {
$parcel$export(module.exports, "useGetCurrentUrl", () => $e46a1c7752182346$export$d758ec3f153761c1);
$parcel$export(module.exports, "useGetCurrentUrlPath", () => $e46a1c7752182346$export$f61d14d754da11cc);

var $kfvK2 = parcelRequire("kfvK2");

var $4cTDP = parcelRequire("4cTDP");

var $eSnSE = parcelRequire("eSnSE");

var $lODoh = parcelRequire("lODoh");

var $eYtNM = parcelRequire("eYtNM");
function $e46a1c7752182346$export$d758ec3f153761c1() {
    const match = (0, $lODoh.useMatch)();
    const query = (0, $eYtNM.useQuery)();
    const searchParams = new URLSearchParams(query ?? {});
    const url = new URL(`http://example.com${match.url}/?${searchParams.toString()}`);
    return url.toString();
}
const $e46a1c7752182346$export$f61d14d754da11cc = (0, $kfvK2.createRouterSelector)((routerContext)=>{
    if ((0, $4cTDP.fg)('chronos-extra-logging-for-url-path')) try {
        const url = new URL(`http://example.com${routerContext.match.url}`);
        return url.toString();
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('navigation-apps.sidebar-nav4.use-get-current-url', 'Failed to construct URL', {
            urlPath: routerContext.match.url
        });
        throw error;
    }
    const url = new URL(`http://example.com${routerContext.match.url}`);
    return url.toString();
});

});
parcelRegister("lODoh", function(module, exports) {
$parcel$export(module.exports, "useMatch", () => $373c1c8ef52d25bc$export$6c330e8992e8a295);

var $kfvK2 = parcelRequire("kfvK2");
const $373c1c8ef52d25bc$export$6c330e8992e8a295 = (0, $kfvK2.createRouterSelector)((state)=>state.match);

});



parcelRegister("h3HFC", function(module, exports) {
$parcel$export(module.exports, "useSubscribeAndUpdateFavorites", () => $abef8e2423cc41df$export$1032774f8dab9cec);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $8Umc4 = parcelRequire("8Umc4");
const $abef8e2423cc41df$export$923c488bb9fac2df = (favouriteConnectionId, recentConnectionId)=>(0, $eJOHy.useCallback)(({ store: store, dataId: dataId, isFavourite: isFavourite })=>{
        const node = store.get(dataId);
        const favorites = store.get(favouriteConnectionId);
        // Exit if we can't find the relevant data to optimistically update
        if (!node || !favorites) return false;
        if (isFavourite) {
            const recentEdges = store.get(recentConnectionId)?.getLinkedRecords('edges') ?? [];
            const existingEdge = recentEdges.find((edge)=>edge.getLinkedRecord('node')?.getDataID() === dataId);
            // Only optimistically insert a new favorite edge if it exists in the recent connection so we know it
            // has required fragment data.
            if (!existingEdge) return false;
            const edge = (0, $37Ewn.ConnectionHandler).createEdge(store, favorites, node, 'JiraFavouriteEdge');
            (0, $37Ewn.ConnectionHandler).insertEdgeBefore(favorites, edge);
        } else (0, $37Ewn.ConnectionHandler).deleteNode(favorites, dataId);
        return true;
    }, [
        favouriteConnectionId,
        recentConnectionId
    ]);
const $abef8e2423cc41df$export$1032774f8dab9cec = ({ entityTypename: entityTypename, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId, refetch: refetch })=>{
    const updateFavoriteConnection = $abef8e2423cc41df$export$923c488bb9fac2df(favouriteConnectionId, recentConnectionId);
    const pendingRefetch = (0, $eJOHy.useRef)(false); // Track in-flight refetch requests
    const trailingRefetch = (0, $eJOHy.useRef)(false); // Track queued refetch requests
    const onRefetch = (0, $eJOHy.useCallback)(()=>{
        // If there is already an in-flight refetch then wait until the request is complete before fetching again
        // Relay will dedupe refetch calls with matching variables. Therefore, we need to wait until any pending request
        // has finished before executing the latest refetch
        if (pendingRefetch.current) {
            trailingRefetch.current = true;
            return;
        }
        pendingRefetch.current = true;
        trailingRefetch.current = false;
        refetch({
            onComplete: ()=>{
                pendingRefetch.current = false;
                // Recursively refetch if it has been queued while a request was in-flight.
                if (trailingRefetch.current) // Wait for Relay to delete the cached request before refetching
                setTimeout(onRefetch, 0);
            }
        });
    }, [
        refetch
    ]);
    const subscriber = (0, $eJOHy.useCallback)((payload)=>{
        if (payload.type === 'MUTATION') {
            // If we successfully updated the connection or it's an optimistic update, exit without further action
            const success = updateFavoriteConnection(payload);
            if (payload.isOptimistic) return;
            if (success) {
                // If un-starring and not optimistic, trigger a refetch to update sidebar content
                if (!payload.isFavourite) onRefetch();
                return;
            }
        }
        // If we can't update the record directly in the Relay store then perform a refetch
        onRefetch();
    }, [
        onRefetch,
        updateFavoriteConnection
    ]);
    (0, $8Umc4.useSubscribeToFavorite)(entityTypename, subscriber);
};

});
parcelRegister("8Umc4", function(module, exports) {
$parcel$export(module.exports, "publishFavorite", () => $f8b4daedecded9d4$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $f8b4daedecded9d4$export$eb04bf805f6b8fb2);

var $eJOHy = parcelRequire("eJOHy");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $f8b4daedecded9d4$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $f8b4daedecded9d4$var$favoritePubSub = new $f8b4daedecded9d4$var$FavoritePubSub();
const $f8b4daedecded9d4$export$229a24253fb568e1 = $f8b4daedecded9d4$var$favoritePubSub.publish;
const $f8b4daedecded9d4$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $eJOHy.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$f8b4daedecded9d4$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});


parcelRegister("3uQAw", function(module, exports) {
$parcel$export(module.exports, "useStableItems", () => $1956bcd4a532a153$export$cb9e0e36b6d0277e);

var $eJOHy = parcelRequire("eJOHy");
const $1956bcd4a532a153$export$cb9e0e36b6d0277e = ()=>{
    const stableIdMapRef = (0, $eJOHy.useRef)(new Map());
    const getStableItems = (0, $eJOHy.useCallback)(({ nodes: nodes, idKey: idKey })=>{
        const getStringId = (node)=>`${node[idKey]}`;
        const intersectedNodes = nodes.filter((node)=>stableIdMapRef.current.has(getStringId(node))).sort((nodeA, nodeB)=>{
            const indexA = stableIdMapRef.current.get(getStringId(nodeA)) ?? 0;
            const indexB = stableIdMapRef.current.get(getStringId(nodeB)) ?? 0;
            return indexA - indexB;
        });
        const hasIntersectedNodes = Boolean(intersectedNodes.length);
        const stableOrderedNodes = hasIntersectedNodes ? nodes.reduceRight((acc, node, index, array)=>{
            if (!stableIdMapRef.current.has(getStringId(node))) {
                const addToStart = index + 1 !== array.length;
                addToStart ? acc.unshift(node) : acc.push(node);
            }
            return acc;
        }, intersectedNodes) : nodes;
        stableIdMapRef.current = new Map(stableOrderedNodes.map((node, index)=>[
                getStringId(node),
                index
            ]));
        return stableOrderedNodes;
    }, []);
    return {
        getStableItems: getStableItems
    };
};

});

parcelRegister("f7RmV", function(module, exports) {
$parcel$export(module.exports, "Nav4FilterMenuItem", () => $30ce7f9cc176a122$export$6c93ee534b1d4d10);

var $eW3g1 = parcelRequire("eW3g1");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kh7bJ = parcelRequire("kh7bJ");

var $6f5GW = parcelRequire("6f5GW");

var $2wv1t = parcelRequire("2wv1t");
function $30ce7f9cc176a122$export$6c93ee534b1d4d10({ queryRef: queryRef, onRefetch: onRefetch, onClick: onClick }) {
    const data = (0, $j4oe4.useFragment)((0, $eW3g1.default), queryRef);
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wv1t.SimpleFilterMenuItem), {
        actionsOnHover: !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6f5GW.Nav4FilterActions), {
            queryRef: data,
            onRefetch: onRefetch
        }),
        filterId: data.filterId,
        name: data.name,
        onClick: onClick
    });
}

});
parcelRegister("eW3g1", function(module, exports) {
$parcel$export(module.exports, "default", () => $83612eb7635e2960$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6139076109a0e91490e1fa3e8272c1fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83612eb7635e2960$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterMenuItem",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4FilterActions"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$83612eb7635e2960$var$node.hash = "db4e5c3fb6fe1fa05a10eea572e428b4";
var $83612eb7635e2960$export$2e2bcd8739ae039 = $83612eb7635e2960$var$node;

});

parcelRegister("6f5GW", function(module, exports) {
$parcel$export(module.exports, "Nav4FilterActions", () => $917ca28248f66d7e$export$7077dee41f8ad33d);

var $ovBfn = parcelRequire("ovBfn");

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $j4oe4 = parcelRequire("j4oe4");

var $lGr6J = parcelRequire("lGr6J");

var $4MicW = parcelRequire("4MicW");

var $gTr6H = parcelRequire("gTr6H");

var $hluWa = parcelRequire("hluWa");

var $gm7H7 = parcelRequire("gm7H7");

var $7saMl = parcelRequire("7saMl");
var $f58rc = parcelRequire("f58rc");
var $6YEko = parcelRequire("6YEko");

var $3cMgR = parcelRequire("3cMgR");

var $fdFXd = parcelRequire("fdFXd");

var $lRq8t = parcelRequire("lRq8t");



var $6Hwhu = parcelRequire("6Hwhu");

var $8z6Yy = parcelRequire("8z6Yy");

var $kIz4h = parcelRequire("kIz4h");

var $7aUkH = parcelRequire("7aUkH");

var $j0saC = parcelRequire("j0saC");

var $e6YEs = parcelRequire("e6YEs");

var $kAwwe = parcelRequire("kAwwe");

var $83DiZ = parcelRequire("83DiZ");

var $4cTDP = parcelRequire("4cTDP");

var $cHtIB = parcelRequire("cHtIB");

var $f2sjT = parcelRequire("f2sjT");

var $8oKDI = parcelRequire("8oKDI");

var $dxcgx = parcelRequire("dxcgx");

var $KwCgo = parcelRequire("KwCgo");

var $dMOn8 = parcelRequire("dMOn8");

var $1TzuH = parcelRequire("1TzuH");

var $8e5rx = parcelRequire("8e5rx");

var $au0VK = parcelRequire("au0VK");

var $dv92c = parcelRequire("dv92c");

var $6hubO = parcelRequire("6hubO");
const $917ca28248f66d7e$export$7077dee41f8ad33d = ({ queryRef: queryRef, onRefetch: onRefetch })=>{
    const { __typename: __typename, isEditable: isEditable, isFavourite: isFavourite, name: name, owner: owner, id: id, filterId: filterId, jql: jql } = (0, $j4oe4.useFragment)((0, $ovBfn.default), queryRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $e6YEs.useAccountId)();
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const { isOpen: isCopyFilterModalOpen, onOpen: openCopyFilterModal, onClose: closeCopyFilterModal } = (0, $6hubO.useModalState)(false);
    const { isOpen: isEditFilterModalOpen, onOpen: openEditFilterModal, onClose: closeEditFilterModal } = (0, $6hubO.useModalState)(false);
    const { isOpen: isChangeOwnerModalOpen, onOpen: openChangeOwnerModal, onClose: closeChangeOwnerModal } = (0, $6hubO.useModalState)(false);
    const { isOpen: isDeleteFilterModalOpen, onOpen: openDeleteFilterModal, onClose: closeDeleteFilterModal } = (0, $6hubO.useModalState)(false);
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onFilterSave = (0, $eJOHy.useCallback)((copiedFilterId)=>{
        push(`/issues/?filter=${copiedFilterId}`);
    }, [
        push
    ]);
    const isCustom = __typename === 'JiraCustomFilter';
    const isOwner = owner?.accountId && owner.accountId === accountId;
    const sendFilterActionAnalytics = (0, $eJOHy.useCallback)((itemId)=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$64fed82162bd367), (0, $1TzuH.getFilterActionAttributes)({
            itemId: itemId,
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    let modalProps;
    let saveFilterEntryPointProps;
    let updateFilterEntryPointProps;
    let entryPointParams;
    if ((0, $4cTDP.fg)('nin-save-filter-dialog-entry-point')) {
        modalProps = {
            width: 'medium',
            shouldScrollInViewport: true
        };
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        saveFilterEntryPointProps = (0, $eJOHy.useMemo)(()=>({
                jql: jql,
                filterId: filterId,
                onFilterSave: onFilterSave,
                title: formatMessage((0, $dv92c.default).copyFilterDialogTitle)
            }), [
            jql,
            filterId,
            onFilterSave,
            formatMessage
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        updateFilterEntryPointProps = (0, $eJOHy.useMemo)(()=>({
                filterId: filterId ?? ''
            }), [
            filterId
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const cloudId = (0, $cHtIB.useCloudId)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const activationId = (0, $f2sjT.useActivationId)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointParams = (0, $eJOHy.useMemo)(()=>({
                filterAri: filterId !== null && filterId !== undefined ? (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }) : undefined
            }), [
            filterId,
            cloudId,
            activationId
        ]);
    }
    const MenuItems = (0, $eJOHy.useCallback)(({ onClose: onClose })=>{
        const getManageSubscriptionsUrl = (actionType)=>{
            const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
                atl_token: (0, $kIz4h.default)(),
                returnUrl: 'ManageFilters.jspa',
                filterId: filterId
            });
            return `/${actionType}!default.jspa?${parsed}`;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Hwhu.FavoriteToggleButton), {
            entityId: id,
            defaultIsStarred: Boolean(isFavourite),
            entityTypeName: (0, $fdFXd.isFavoritableItemTypename)(__typename) ? __typename : 'JiraCustomFilter',
            onClick: ()=>sendFilterActionAnalytics(isFavourite ? (0, $bc40578f06d7846b$export$7ae7abcf2c19d3e5) : (0, $bc40578f06d7846b$export$78fd0bd637fe1684)),
            name: name
        }), isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hluWa))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: getManageSubscriptionsUrl('ViewSubscriptions'),
            "aria-label": formatMessage((0, $dv92c.default).manageSubscriptionWithName, {
                name: name
            }),
            onClick: ()=>sendFilterActionAnalytics('manageSubscription')
        }, formatMessage((0, $dv92c.default).manageSubscription)), (0, $4cTDP.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $KwCgo.saveFilterDialogEntryPoint),
            entryPointProps: saveFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.SaveFilter",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('copyFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lGr6J))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, $dv92c.default).copyFilterWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage((0, $dv92c.default).copyFilter))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            onClick: (e)=>{
                openCopyFilterModal();
                sendFilterActionAnalytics('copyFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lGr6J))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $dv92c.default).copyFilterWithName, {
                name: name
            })
        }, formatMessage((0, $dv92c.default).copyFilter)), isCustom && (isOwner || isEditable) && ((0, $4cTDP.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $dMOn8.updateFilterDialogEntryPoint),
            entryPointProps: updateFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.UpdateFilterDetails",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('editFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, $dv92c.default).editWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage((0, $dv92c.default).edit))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: (e)=>{
                openEditFilterModal();
                sendFilterActionAnalytics('editFilter');
                onClose && onClose(e);
            },
            "aria-label": formatMessage((0, $dv92c.default).editWithName, {
                name: name
            })
        }, formatMessage((0, $dv92c.default).edit))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            onClick: (e)=>{
                openChangeOwnerModal();
                sendFilterActionAnalytics('changeOwner');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $dv92c.default).changeOwnerWithName, {
                name: name
            })
        }, formatMessage((0, $dv92c.default).changeOwner))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            onClick: (e)=>{
                openDeleteFilterModal();
                sendFilterActionAnalytics('deleteFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4MicW))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            "aria-label": formatMessage((0, $dv92c.default).deleteWithName, {
                name: name
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            color: "color.text.danger"
        }, formatMessage((0, $dv92c.default).delete)))));
    }, [
        id,
        isFavourite,
        __typename,
        name,
        isCustom,
        formatMessage,
        isOwner,
        isEditable,
        isAdmin,
        filterId,
        sendFilterActionAnalytics,
        openCopyFilterModal,
        openEditFilterModal,
        openChangeOwnerModal,
        openDeleteFilterModal,
        modalProps,
        saveFilterEntryPointProps,
        updateFilterEntryPointProps,
        entryPointParams
    ]);
    const sendMeatballAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$b887e88d8d0739f6), (0, $1TzuH.getFilterMeatBallAttributes)({
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: MenuItems,
        name: name
    }), !(0, $4cTDP.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aUkH.AsyncSaveFilterDialogContent), {
        isOpen: isCopyFilterModalOpen,
        filterId: filterId,
        jql: jql,
        title: formatMessage((0, $dv92c.default).copyFilterDialogTitle),
        onClose: closeCopyFilterModal,
        onFilterSave: onFilterSave
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j0saC.AsyncUpdateFilterDialog), {
        isOpen: isEditFilterModalOpen,
        filterId: filterId ?? '',
        onClose: closeEditFilterModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8e5rx.ChangeOwnerModal), {
        isOpen: isChangeOwnerModalOpen,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeChangeOwnerModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $au0VK.DeleteFilterModal), {
        isOpen: isDeleteFilterModalOpen,
        name: name,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeDeleteFilterModal
    }));
};

});
parcelRegister("ovBfn", function(module, exports) {
$parcel$export(module.exports, "default", () => $01792db0f3e3a1c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b02630a993ab57f513c5d9a5a5ea9816>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01792db0f3e3a1c3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterActions",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$01792db0f3e3a1c3$var$node.hash = "ceac0ec9e5b4a025e25fe096d35c5d3b";
var $01792db0f3e3a1c3$export$2e2bcd8739ae039 = $01792db0f3e3a1c3$var$node;

});

parcelRegister("lGr6J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46d77f8084efb8562fee77ec5d30fd2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc928c338a001a7a$var$_react = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc928c338a001a7a$var$_baseNew = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fc928c338a001a7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc928c338a001a7a$var$CopyIcon = (props)=>/*#__PURE__*/ $fc928c338a001a7a$var$_react.default.createElement($fc928c338a001a7a$var$_baseNew.default, Object.assign({
        name: "CopyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$fc928c338a001a7a$var$CopyIcon.displayName = 'CopyIcon';
var $fc928c338a001a7a$var$_default = module.exports.default = $fc928c338a001a7a$var$CopyIcon;

});

parcelRegister("4MicW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8e09626672d9215bf80d7cf3a8d93a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37a9c4cf545b6d17$var$_react = $37a9c4cf545b6d17$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $37a9c4cf545b6d17$var$_baseNew = $37a9c4cf545b6d17$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $37a9c4cf545b6d17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37a9c4cf545b6d17$var$DeleteIcon = (props)=>/*#__PURE__*/ $37a9c4cf545b6d17$var$_react.default.createElement($37a9c4cf545b6d17$var$_baseNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$37a9c4cf545b6d17$var$DeleteIcon.displayName = 'DeleteIcon';
var $37a9c4cf545b6d17$var$_default = module.exports.default = $37a9c4cf545b6d17$var$DeleteIcon;

});

parcelRegister("gTr6H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63ac376f9836d1894f72051899adf679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c6cf489c8bf4fc$var$_react = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c4c6cf489c8bf4fc$var$_baseNew = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c4c6cf489c8bf4fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c6cf489c8bf4fc$var$EditIcon = (props)=>/*#__PURE__*/ $c4c6cf489c8bf4fc$var$_react.default.createElement($c4c6cf489c8bf4fc$var$_baseNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$c4c6cf489c8bf4fc$var$EditIcon.displayName = 'EditIcon';
var $c4c6cf489c8bf4fc$var$_default = module.exports.default = $c4c6cf489c8bf4fc$var$EditIcon;

});

parcelRegister("hluWa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11cac724462839f30810a0cf708cc3d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca0c654a3a0a1b61$var$_react = $ca0c654a3a0a1b61$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ca0c654a3a0a1b61$var$_baseNew = $ca0c654a3a0a1b61$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ca0c654a3a0a1b61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca0c654a3a0a1b61$var$EmailIcon = (props)=>/*#__PURE__*/ $ca0c654a3a0a1b61$var$_react.default.createElement($ca0c654a3a0a1b61$var$_baseNew.default, Object.assign({
        name: "EmailIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$ca0c654a3a0a1b61$var$EmailIcon.displayName = 'EmailIcon';
var $ca0c654a3a0a1b61$var$_default = module.exports.default = $ca0c654a3a0a1b61$var$EmailIcon;

});

parcelRegister("fdFXd", function(module, exports) {
$parcel$export(module.exports, "isFavoritableItemTypename", () => $4758998caa92e434$export$2bcd2af12bfc25b5);

var $aMJA4 = parcelRequire("aMJA4");
const $4758998caa92e434$export$2bcd2af12bfc25b5 = (typename)=>(0, $aMJA4.VALID_ITEM_TYPENAMES).some((itemTypename)=>itemTypename === typename);

});
parcelRegister("aMJA4", function(module, exports) {
$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $f0683f65a0acafa7$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $f0683f65a0acafa7$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $f0683f65a0acafa7$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $f0683f65a0acafa7$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $f0683f65a0acafa7$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $f0683f65a0acafa7$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $f0683f65a0acafa7$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $f0683f65a0acafa7$export$2d63a9c2e78633c8);
const $f0683f65a0acafa7$export$aade82542e73ffc8 = 'boards';
const $f0683f65a0acafa7$export$a448ebfa10cebc74 = 'filters';
const $f0683f65a0acafa7$export$f8099f229527572c = 'dashboards';
const $f0683f65a0acafa7$export$8e58083dcbb878d = 'issues';
const $f0683f65a0acafa7$export$2fd44a6cb58b66cb = 'plans';
const $f0683f65a0acafa7$export$8e2cd98172988d7e = 'projects';
const $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9 = 'queues';
const $f0683f65a0acafa7$export$9c8cfad65800ddfb = [
    $f0683f65a0acafa7$export$aade82542e73ffc8,
    $f0683f65a0acafa7$export$f8099f229527572c,
    $f0683f65a0acafa7$export$a448ebfa10cebc74,
    $f0683f65a0acafa7$export$8e58083dcbb878d,
    $f0683f65a0acafa7$export$2fd44a6cb58b66cb,
    $f0683f65a0acafa7$export$8e2cd98172988d7e,
    $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9
];
const $f0683f65a0acafa7$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});


parcelRegister("6Hwhu", function(module, exports) {
$parcel$export(module.exports, "FavoriteToggleButton", () => $a01ae8b753a38de5$export$b01f3062fe4ad89b);

var $eJOHy = parcelRequire("eJOHy");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $7saMl = parcelRequire("7saMl");

var $3cMgR = parcelRequire("3cMgR");

var $dFtHW = parcelRequire("dFtHW");

var $lRq8t = parcelRequire("lRq8t");

var $6naEG = parcelRequire("6naEG");

var $3LdGv = parcelRequire("3LdGv");
const $a01ae8b753a38de5$var$UnstarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
    label: "",
    color: "currentColor",
    spacing: "spacious"
});
const $a01ae8b753a38de5$var$StarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
    label: "",
    color: "var(--ds-icon-accent-yellow, #B38600)",
    spacing: "spacious"
});
const $a01ae8b753a38de5$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isStarred, setIsStarred] = (0, $eJOHy.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $dFtHW.useChangeFavorite)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>!prevIsStarred);
        onClick?.();
    }, [
        onClick
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isStarred !== defaultIsStarred) changeFavoriteMutation({
            id: entityId,
            typename: entityTypeName,
            value: isStarred
        });
    }, [
        entityId,
        entityTypeName,
        isStarred,
        defaultIsStarred,
        changeFavoriteMutation
    ]);
    const handleOnClickWithStopPropagation = (0, $6naEG.useStopPropagation)(handleOnClick);
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        iconBefore: $a01ae8b753a38de5$var$StarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $3LdGv.default).removeFromStarredWithName, {
            name: name
        }) : formatMessage((0, $3LdGv.default).removeFromStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, formatMessage((0, $3LdGv.default).removeFromStarred))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        iconBefore: $a01ae8b753a38de5$var$UnstarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $3LdGv.default).addToStarredWithName, {
            name: name
        }) : formatMessage((0, $3LdGv.default).addToStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, formatMessage((0, $3LdGv.default).addToStarred)));
};

});
parcelRegister("gGgaG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::230a74b5beecd6089e40fb6fd34c20ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c24d1cda47746043$var$_react = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c24d1cda47746043$var$_baseNew = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c24d1cda47746043$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c24d1cda47746043$var$StarStarredIcon = (props)=>/*#__PURE__*/ $c24d1cda47746043$var$_react.default.createElement($c24d1cda47746043$var$_baseNew.default, Object.assign({
        name: "StarStarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$c24d1cda47746043$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $c24d1cda47746043$var$_default = module.exports.default = $c24d1cda47746043$var$StarStarredIcon;

});

parcelRegister("dFtHW", function(module, exports) {
$parcel$export(module.exports, "FavoriteChangeContext", () => $b82a05fff78fa280$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $b82a05fff78fa280$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $b82a05fff78fa280$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $b82a05fff78fa280$export$cfa169f3278459e8);

var $4UKKg = parcelRequire("4UKKg");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $9pTd3 = parcelRequire("9pTd3");

var $8oKDI = parcelRequire("8oKDI");

var $kRgKj = parcelRequire("kRgKj");

var $cHtIB = parcelRequire("cHtIB");

var $kqd31 = parcelRequire("kqd31");

var $5QYf0 = parcelRequire("5QYf0");

var $8Umc4 = parcelRequire("8Umc4");

var $aMJA4 = parcelRequire("aMJA4");

var $ayzwX = parcelRequire("ayzwX");

var $By8f4 = parcelRequire("By8f4");
const $b82a05fff78fa280$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $b82a05fff78fa280$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $b82a05fff78fa280$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $b82a05fff78fa280$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $eJOHy.createContext)($b82a05fff78fa280$export$b212ddc707077772);
// supports project types only for now
const $b82a05fff78fa280$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const commitUpdate = (0, $eJOHy.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $aMJA4.PROJECTS_ITEM_TYPE)) (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $kqd31.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $b82a05fff78fa280$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $b82a05fff78fa280$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $eJOHy.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $eJOHy.useCallback)((item)=>{
        setItems($b82a05fff78fa280$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $eJOHy.useCallback)((item, analyticsEvent)=>{
        setItems($b82a05fff78fa280$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $eJOHy.useCallback)((item, analyticsId, error)=>{
        setItems($b82a05fff78fa280$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $By8f4.errorFlag)());
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $eJOHy.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $ayzwX.default)(item);
                const typename = (0, $5QYf0.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $8Umc4.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $4UKKg.default));
    const changeFavoriteMutation = (0, $eJOHy.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $kqd31.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $5QYf0.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $8Umc4.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $eJOHy.useCallback)((item)=>{
        setItems($b82a05fff78fa280$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $eJOHy.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $5QYf0.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $8Umc4.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $kqd31.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $5QYf0.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $8Umc4.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $eJOHy.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b82a05fff78fa280$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $b82a05fff78fa280$export$f227cdfbb355444a = $b82a05fff78fa280$export$a5d258b9665ce94b.Consumer;
const $b82a05fff78fa280$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b82a05fff78fa280$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $b82a05fff78fa280$export$cfa169f3278459e8 = ()=>(0, $eJOHy.useContext)($b82a05fff78fa280$export$a5d258b9665ce94b);

});
parcelRegister("4UKKg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d82a206cdcfc78f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e6e704e05dd9d4fca90806ff559baf1f>>
 * @relayHash 2cc6fed42463066ce74de984705c8901
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e5acb1b69d72b5f8949c4a0d1b6fd803239e4dc65235c8616787431e319d66f
const $d82a206cdcfc78f1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavoriteChangeConsumerMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavoriteChangeConsumerMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9e5acb1b69d72b5f8949c4a0d1b6fd803239e4dc65235c8616787431e319d66f",
            "metadata": {},
            "name": "FavoriteChangeConsumerMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d82a206cdcfc78f1$var$node.hash = "7a3ceb525a45608774dd6c925108a05f";
var $d82a206cdcfc78f1$export$2e2bcd8739ae039 = $d82a206cdcfc78f1$var$node;

});

parcelRegister("8oKDI", function(module, exports) {
$parcel$export(module.exports, "isAri", () => $250d353c2bab97a6$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $250d353c2bab97a6$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $250d353c2bab97a6$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $250d353c2bab97a6$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $250d353c2bab97a6$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $250d353c2bab97a6$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $250d353c2bab97a6$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $250d353c2bab97a6$export$8e68286aef4c3a8b = (ari)=>$250d353c2bab97a6$var$ARI_REG_EXP.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $250d353c2bab97a6$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $250d353c2bab97a6$export$24b47820a324e614 = (ari)=>{
    if ($250d353c2bab97a6$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $250d353c2bab97a6$export$e2789192113e8b07 = (ari, defaultValue = '')=>$250d353c2bab97a6$export$24b47820a324e614(ari) ?? defaultValue;
const $250d353c2bab97a6$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($250d353c2bab97a6$export$8e68286aef4c3a8b(ari)) {
        const parts = $250d353c2bab97a6$var$ARI_REG_EXP.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $250d353c2bab97a6$export$3d8d7031a11613fd = (ari)=>{
    const config = $250d353c2bab97a6$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("5QYf0", function(module, exports) {
$parcel$export(module.exports, "favoriteTypeToTypename", () => $60086272c670daaa$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $60086272c670daaa$export$717886a1047f1287);

var $2BUDW = parcelRequire("2BUDW");

var $bu8Y7 = parcelRequire("bu8Y7");

var $27lFN = parcelRequire("27lFN");

var $4NoAT = parcelRequire("4NoAT");

var $3mjHQ = parcelRequire("3mjHQ");

var $3osLr = parcelRequire("3osLr");
function $60086272c670daaa$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $60086272c670daaa$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $60086272c670daaa$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $60086272c670daaa$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $60086272c670daaa$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $3osLr.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $4NoAT.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $27lFN.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $3mjHQ.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $bu8Y7.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $2BUDW.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $60086272c670daaa$var$assertUnreachable(typename);
    }
};
const $60086272c670daaa$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $60086272c670daaa$var$assertUnreachable(typename);
    }
};
const $60086272c670daaa$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $60086272c670daaa$var$favoriteAriToId(typename, id),
        type: $60086272c670daaa$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $60086272c670daaa$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $60086272c670daaa$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("2BUDW", function(module, exports) {
$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $1e6af9a211751f7e$export$555c8ae00f64ebff);

var $7OueV = parcelRequire("7OueV");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira-servicedesk/queue/manifest.ts
var $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $7OueV.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $7OueV.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $1e6af9a211751f7e$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("7OueV", function(module, exports) {
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $5b04a8e3ed2a9dde$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $5b04a8e3ed2a9dde$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $5b04a8e3ed2a9dde$export$704112eeb385ceab = "jira-servicedesk", $5b04a8e3ed2a9dde$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("bu8Y7", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $85c9740b1cb0c1f8$export$fcd404066e55a7a8);

var $5SaHf = parcelRequire("5SaHf");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira-software/board/manifest.ts
var $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5SaHf.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $5SaHf.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $85c9740b1cb0c1f8$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("5SaHf", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $011a7d14b4d4d4ec$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $011a7d14b4d4d4ec$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $011a7d14b4d4d4ec$export$d716ba4f5572ec86 = "jira-software", $011a7d14b4d4d4ec$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("27lFN", function(module, exports) {
$parcel$export(module.exports, "JiraDashboardAri", () => $18ad0c083fb9a182$export$b7d4016f0f5da5b8);

var $lScrX = parcelRequire("lScrX");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/dashboard/manifest.ts
var $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $lScrX.JiraDashboardAriResourceOwner),
    resourceType: (0, $lScrX.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $18ad0c083fb9a182$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("lScrX", function(module, exports) {
$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $fec84c706c93f2bd$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $fec84c706c93f2bd$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $fec84c706c93f2bd$export$62c1deae25c41d24 = "jira", $fec84c706c93f2bd$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("3mjHQ", function(module, exports) {
$parcel$export(module.exports, "JiraPlanAri", () => $2722b66e28c1c3b7$export$6d2eb3641569f26);

var $6LPOd = parcelRequire("6LPOd");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/plan/manifest.ts
var $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6LPOd.JiraPlanAriResourceOwner),
    resourceType: (0, $6LPOd.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $2722b66e28c1c3b7$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("6LPOd", function(module, exports) {
$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $4edf520e7fc401d3$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $4edf520e7fc401d3$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $4edf520e7fc401d3$export$bfd26af3c5e1b90d = "jira", $4edf520e7fc401d3$export$d6abe08eb30f433d = "plan";

});


parcelRegister("3osLr", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAri", () => $2789eceef4467cc4$export$75a0a0a7cb0a58ae);

var $fFcpV = parcelRequire("fFcpV");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/project/manifest.ts
var $2789eceef4467cc4$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fFcpV.JiraProjectAriResourceOwner),
    resourceType: (0, $fFcpV.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $2789eceef4467cc4$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $2789eceef4467cc4$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $2789eceef4467cc4$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("fFcpV", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $b674512659b7f55c$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $b674512659b7f55c$export$736763838d3aa22e);
// src/jira/project/types.ts
var $b674512659b7f55c$export$99d538a3b04916b1 = "jira", $b674512659b7f55c$export$736763838d3aa22e = "project";

});



parcelRegister("ayzwX", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb247c6ff9b78be8$export$2e2bcd8739ae039);

var $hz0hv = parcelRequire("hz0hv");
const $cb247c6ff9b78be8$var$updateFavorite1 = async (request)=>(0, $hz0hv.updateFavorite)(request);
var $cb247c6ff9b78be8$export$2e2bcd8739ae039 = $cb247c6ff9b78be8$var$updateFavorite1;

});
parcelRegister("hz0hv", function(module, exports) {
$parcel$export(module.exports, "updateFavorite", () => $8db6e70766c67090$export$8c2f00130cc945dc);

var $3ugTQ = parcelRequire("3ugTQ");
const $8db6e70766c67090$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $3ugTQ.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $3ugTQ.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("By8f4", function(module, exports) {
$parcel$export(module.exports, "errorFlag", () => $f3b3cf3c0fd288e5$export$b9a7f1ebeaa76953);

var $bYxGO = parcelRequire("bYxGO");
const $f3b3cf3c0fd288e5$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $bYxGO.default)
    });

});
parcelRegister("bYxGO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b97d317b0fde95f0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b97d317b0fde95f0$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});
var $b97d317b0fde95f0$export$2e2bcd8739ae039 = $b97d317b0fde95f0$var$messages;

});



parcelRegister("3LdGv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e474b4faf2fbb323$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e474b4faf2fbb323$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
        "defaultMessage": "Add to starred"
    },
    removeFromStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
        "defaultMessage": "Remove from starred"
    },
    addToStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
        "defaultMessage": "Add \"{name}\" to starred"
    },
    removeFromStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
        "defaultMessage": "Remove \"{name}\" from starred"
    }
});

});


parcelRegister("7aUkH", function(module, exports) {
$parcel$export(module.exports, "AsyncSaveFilterDialogContent", () => $1333398ce66ec2b7$export$e0d40cb0f88fa57d);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1333398ce66ec2b7$var$SaveFilterDialogContent = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("6un3X")).then((module)=>({
            default: module.OldSaveFilterDialogContent
        })), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/save-filter-dialog-content/index.tsx"
});
const $1333398ce66ec2b7$export$e0d40cb0f88fa57d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-save-filters-dialog-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1333398ce66ec2b7$var$SaveFilterDialogContent, props));

});
parcelRegister("6un3X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kvrhg").then(()=>parcelRequire('1Dpmk'));

});


parcelRegister("j0saC", function(module, exports) {
$parcel$export(module.exports, "AsyncUpdateFilterDialog", () => $d7076eb3b3592d80$export$8692e2751472dade);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d7076eb3b3592d80$var$UpdateFilterDialog = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("i258T")).then((module)=>({
            default: module.OldUpdateFilterDialog
        })), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/update-filter-dialog/index.tsx"
});
const $d7076eb3b3592d80$export$8692e2751472dade = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-update-filter-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d7076eb3b3592d80$var$UpdateFilterDialog, props));

});
parcelRegister("i258T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hYYP2").then(()=>parcelRequire('f4oZQ'));

});


parcelRegister("kAwwe", function(module, exports) {
$parcel$export(module.exports, "useIsAdmin", () => $af0c22f02c92eb29$export$99a5e4bc80d231ca);

var $koAZ4 = parcelRequire("koAZ4");
const $af0c22f02c92eb29$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("dxcgx", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $6e1a9fb892f137c0$export$defad645fcc21c0a);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2bMVP = parcelRequire("2bMVP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $78OnL = parcelRequire("78OnL");

var $dllpM = parcelRequire("dllpM");

var $lJKII = parcelRequire("lJKII");

var $4B7rn = parcelRequire("4B7rn");

var $5GSFM = parcelRequire("5GSFM");

var $bzbsd = parcelRequire("bzbsd");

var $7lK6t = parcelRequire("7lK6t");

var $5HFSX = parcelRequire("5HFSX");

var $4cTDP = parcelRequire("4cTDP");

var $8yPs2 = parcelRequire("8yPs2");
const $6e1a9fb892f137c0$var$emptyObject = {};
const $6e1a9fb892f137c0$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, hasCloseButton: hasCloseButton })=>{
    const { openModal: openModal } = (0, $eJOHy.useContext)((0, $7lK6t.ModalContext));
    const environmentProvider = (0, $5HFSX.useJiraRelayEnvironmentProvider)();
    const metricName = (0, $eJOHy.useMemo)(()=>{
        if (interactionName) return interactionName;
        // @ts-expect-error Need to fix the types on this
        return entryPoint?.root?.getModuleName() ?? 'unknown';
    }, [
        entryPoint,
        interactionName
    ]);
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $dllpM.default)(metricName);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $6e1a9fb892f137c0$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $eJOHy.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
                hasCloseButton: (0, $4cTDP.fg)('platform_relay_use_hasclosebutton') && hasCloseButton
            }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
                messageId: "modal-entry-point-pressable-trigger.modal.fallback",
                messageType: "transactional",
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $6e1a9fb892f137c0$var$emptyObject,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
                ...modalProps,
                messageId: "modal-entry-point-pressable-trigger.modal",
                messageType: "transactional",
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container)) : container;
        });
    }, [
        openModal,
        title,
        useInternalModal,
        modalProps,
        errorAttributes,
        Fallback,
        metricName,
        entryPointProps,
        hasCloseButton
    ]);
    const triggerRef = (0, $8yPs2.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    if (forwardedRef != null) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = (0, $bzbsd.default)(triggerRef, forwardedRef);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return children({
            ref: ref
        });
    }
    return children({
        ref: triggerRef
    });
};

});
parcelRegister("dllpM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4adf76c7a26850b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");
function $4adf76c7a26850b8$export$2e2bcd8739ae039(name) {
    const context = (0, $eJOHy.useContext)((0, $d0Gew.default));
    const handleClick = (0, $eJOHy.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("lJKII", function(module, exports) {
$parcel$export(module.exports, "JiraModal", () => $6ef567ab65ac3d98$export$3782fcca1f68992e);

var $eJOHy = parcelRequire("eJOHy");

var $gHHv2 = parcelRequire("gHHv2");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $e6Sjx = parcelRequire("e6Sjx");
const $6ef567ab65ac3d98$export$3782fcca1f68992e = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e6Sjx.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHHv2.default), rest);
};
$6ef567ab65ac3d98$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("e6Sjx", function(module, exports) {
$parcel$export(module.exports, "ChoreographerModal", () => $20b3c589f6cfeade$export$3f5d627caa6fc630);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $gHHv2 = parcelRequire("gHHv2");

var $5hQBi = parcelRequire("5hQBi");
const $20b3c589f6cfeade$export$3f5d627caa6fc630 = (0, $5hQBi.withChoreographedRender)((0, $gHHv2.default));

});
parcelRegister("5hQBi", function(module, exports) {
$parcel$export(module.exports, "withChoreographedRender", () => $5b202fbe4a7a7310$export$c1160fdac17030e);

var $eJOHy = parcelRequire("eJOHy");

var $6zxfT = parcelRequire("6zxfT");

var $4GudG = parcelRequire("4GudG");
function $5b202fbe4a7a7310$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $4GudG.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6zxfT.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});



parcelRegister("4B7rn", function(module, exports) {
$parcel$export(module.exports, "ShortcutRegistryContext", () => $a36fe9c49c31d994$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $a36fe9c49c31d994$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d94A4 = parcelRequire("d94A4");
const $a36fe9c49c31d994$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $d94A4.rootRegistry));
const $a36fe9c49c31d994$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eJOHy.useMemo)(()=>new (0, $d94A4.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eJOHy.useContext)($a36fe9c49c31d994$export$ebbb59327adb551a) || (0, $d94A4.rootRegistry);
    (0, $eJOHy.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a36fe9c49c31d994$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $a36fe9c49c31d994$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : $a36fe9c49c31d994$var$ShortcutScope;

});
parcelRegister("d94A4", function(module, exports) {
$parcel$export(module.exports, "ShortcutRegistry", () => $f2cdd23f2ee8847a$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $f2cdd23f2ee8847a$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $5spib = parcelRequire("5spib");

var $exWdq = parcelRequire("exWdq");

var $jPROM = parcelRequire("jPROM");

var $f6sJp = parcelRequire("f6sJp");

var $gPrdS = parcelRequire("gPrdS");
const $f2cdd23f2ee8847a$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $gPrdS.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $gPrdS.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $gPrdS.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $f2cdd23f2ee8847a$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $f2cdd23f2ee8847a$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f6sJp)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f6sJp)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$f2cdd23f2ee8847a$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $f2cdd23f2ee8847a$export$1dd4c61d1ce1fa15 = new $f2cdd23f2ee8847a$export$ca1c75b575abf5ff();

});
parcelRegister("f6sJp", function(module, exports) {

var $l76qh = parcelRequire("l76qh");

var $d3H6Y = parcelRequire("d3H6Y");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $afedb3fdd807fe80$var$pull = $l76qh($d3H6Y);
module.exports = $afedb3fdd807fe80$var$pull;

});
parcelRegister("d3H6Y", function(module, exports) {

var $6zP82 = parcelRequire("6zP82");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $981cff3a37d3b5ca$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $6zP82(array, values) : array;
}
module.exports = $981cff3a37d3b5ca$var$pullAll;

});
parcelRegister("6zP82", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $kEE3x = parcelRequire("kEE3x");

var $8sQvY = parcelRequire("8sQvY");

var $cUaWv = parcelRequire("cUaWv");

var $k4ZVz = parcelRequire("k4ZVz");
/** Used for built-in method references. */ var $4c9dac120c4a59a8$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $4c9dac120c4a59a8$var$splice = $4c9dac120c4a59a8$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $4c9dac120c4a59a8$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $8sQvY : $kEE3x, index = -1, length = values.length, seen = array;
    if (array === values) values = $k4ZVz(values);
    if (iteratee) seen = $lylkU(array, $cUaWv(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $4c9dac120c4a59a8$var$splice.call(seen, fromIndex, 1);
            $4c9dac120c4a59a8$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $4c9dac120c4a59a8$var$basePullAll;

});
parcelRegister("8sQvY", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6299ac99ae510342$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $6299ac99ae510342$var$baseIndexOfWith;

});




parcelRegister("gPrdS", function(module, exports) {
$parcel$export(module.exports, "toKeyWithModifiers", () => $3e1ebf016ecbb97e$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $3e1ebf016ecbb97e$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $3e1ebf016ecbb97e$export$4add9e50cb49d130);

var $4cTDP = parcelRequire("4cTDP");
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+alt+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is now supported in modern browsers by using event.code
 * to extract the base character when alt modifies the character output.
 * On Mac, alt changes the character input (e.g. 'alt+z' displays 'Ω'),
 * but we extract the base character 'z' for consistent keyboard shortcuts.
 * For older browsers without event.code support, alt shortcuts will still
 * have the original limitation where modified characters are used.
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $3e1ebf016ecbb97e$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
// Base modifiers without alt (old behavior)
const $3e1ebf016ecbb97e$var$baseModifiersOld = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $3e1ebf016ecbb97e$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
// Base modifiers with alt support (new behavior)
const $3e1ebf016ecbb97e$var$baseModifiers = [
    {
        name: 'ctrl',
        test: (e)=>e.ctrlKey
    },
    {
        name: 'alt',
        test: (e)=>e.altKey
    },
    {
        name: 'shift',
        test: (e)=>e.shiftKey && $3e1ebf016ecbb97e$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $3e1ebf016ecbb97e$var$toKey = (e)=>{
    if ($3e1ebf016ecbb97e$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Handle alt-modified characters by using the base character (feature gated)
    // On Mac, alt+z produces 'ω' but we want 'z' for consistent shortcuts
    if ((0, $4cTDP.fg)('jira-full-screen')) {
        if (e.altKey && e.code && e.code.startsWith('Key')) {
            // Extract the base character from the code (e.g., 'KeyZ' -> 'z')
            const baseChar = e.code.substring(3).toLowerCase();
            return e.shiftKey ? baseChar.toUpperCase() : baseChar;
        }
    }
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $3e1ebf016ecbb97e$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    if ((0, $4cTDP.fg)('jira-full-screen')) return {
        sequence: $3e1ebf016ecbb97e$var$baseModifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($3e1ebf016ecbb97e$var$toKey(e)).join('+'),
        e: e
    };
    return {
        sequence: $3e1ebf016ecbb97e$var$baseModifiersOld.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($3e1ebf016ecbb97e$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $3e1ebf016ecbb97e$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $3e1ebf016ecbb97e$var$singleShortcutEntry = `(ctrl\\+)?(alt\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$3e1ebf016ecbb97e$var$orSpecialChars}))))?(meta\\+)?(${$3e1ebf016ecbb97e$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $3e1ebf016ecbb97e$var$shortcutRegex = RegExp(`^${$3e1ebf016ecbb97e$var$singleShortcutEntry}( ${$3e1ebf016ecbb97e$var$singleShortcutEntry})*$`);
const $3e1ebf016ecbb97e$export$8e231506c5580162 = (shortcut)=>$3e1ebf016ecbb97e$var$shortcutRegex.test(shortcut);
const $3e1ebf016ecbb97e$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("7lK6t", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $da1586d597fd06a3$export$ab57792b9b6974a6);

var $eJOHy = parcelRequire("eJOHy");
const $da1586d597fd06a3$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});

parcelRegister("8yPs2", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $29a42d023a266ffa$export$1ff47f24e06a5d2d);

var $eJOHy = parcelRequire("eJOHy");
const $29a42d023a266ffa$var$PRELOAD_MAX_AGE = 2000;
const $29a42d023a266ffa$var$TIME_TO_INTENT = 200;
function $29a42d023a266ffa$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $29a42d023a266ffa$var$PRELOAD_MAX_AGE);
            }, $29a42d023a266ffa$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("KwCgo", function(module, exports) {
$parcel$export(module.exports, "saveFilterDialogEntryPoint", () => $9103cab9c638489c$export$7485e0220e11838f);

var $16SHk = parcelRequire("16SHk");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9103cab9c638489c$export$7485e0220e11838f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6un3X")), {
        moduleId: "6b7b6fa9",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $16SHk.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri,
                        // includeJql and corresponding @include directive in SAVE_FILTER_DIALOG_BASE_QUERY should be removed when cleaning up nin-save-filter-dialog-entry-point
                        includeJql: true
                    }
                }
            }
        })
});

});
parcelRegister("16SHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6dfdf4811cfbb5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<859d5d47a2c5fd97dab556bccf43d2f6>>
 * @relayHash 9c75ea8fdeeedc74876715a276898be1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a9131294f7520ff6e6fa2cec7e3807675422ef52957aa4c5c395456e61f0d67b
const $e6dfdf4811cfbb5a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeJql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = {
        "kind": "RequiredField",
        "field": {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v2 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira.filter.shareGrants.edges.node.project.id"
                },
                v3 /*: any*/ ,
                v6 /*: any*/ 
            ]
        },
        "action": "THROW",
        "path": "jira.filter.shareGrants.edges.node.project"
    }, v8 = {
        "kind": "ScalarField",
        "name": "roleId"
    }, v9 = {
        "concreteType": "JiraRole",
        "kind": "LinkedField",
        "name": "role",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v10 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v13 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v3 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v14 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v15 = {
        "kind": "RequiredField",
        "field": v14 /*: any*/ ,
        "action": "THROW",
        "path": "jira.filter.editGrants.edges.node.project"
    }, v16 = {
        "condition": "includeJql",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jql"
            }
        ]
    }, v17 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v3 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v10 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v11 /*: any*/ ,
                                v3 /*: any*/ ,
                                v12 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "saveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v9 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.role"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v10 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.group"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityGroupGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v13 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.user"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityUserGrant"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v15 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v9 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.role"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v10 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.group"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityGroupGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v13 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.user"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityUserGrant"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v16 /*: any*/ 
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "saveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v17 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v17 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v16 /*: any*/ 
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a9131294f7520ff6e6fa2cec7e3807675422ef52957aa4c5c395456e61f0d67b",
            "metadata": {},
            "name": "saveFilterDialogBaseQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e6dfdf4811cfbb5a$var$node.hash = "fb88c153bbc55aa009b87c70f71b97cc";
var $e6dfdf4811cfbb5a$export$2e2bcd8739ae039 = $e6dfdf4811cfbb5a$var$node;

});


parcelRegister("dMOn8", function(module, exports) {
$parcel$export(module.exports, "updateFilterDialogEntryPoint", () => $b90eb94a1ca61cce$export$89f63332d1b5f8db);

var $16SHk = parcelRequire("16SHk");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b90eb94a1ca61cce$export$89f63332d1b5f8db = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("i258T")), {
        moduleId: "a40748cc",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $16SHk.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri,
                        // includeJql and corresponding @include directive in SAVE_FILTER_DIALOG_BASE_QUERY should be removed when cleaning up nin-save-filter-dialog-entry-point
                        includeJql: true
                    }
                }
            }
        })
});

});

parcelRegister("8e5rx", function(module, exports) {
$parcel$export(module.exports, "ChangeOwnerModal", () => $2dd1356b8c93878e$export$fe3f500d38bfe0df);

var $eJOHy = parcelRequire("eJOHy");

var $9hEC7 = parcelRequire("9hEC7");
const $2dd1356b8c93878e$export$fe3f500d38bfe0df = ({ isOpen: isOpen, filterId: filterId, onRefetch: onRefetch, onClose: onClose })=>{
    const onSuccess = (0, $eJOHy.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        onClose();
    }, [
        onRefetch,
        onClose
    ]);
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9hEC7.default), {
        id: filterId,
        onInitiateSuccess: ()=>undefined,
        onSuccess: onSuccess,
        onCancel: onClose,
        onInitiateFailed: ()=>undefined
    });
};

});
parcelRegister("9hEC7", function(module, exports) {
$parcel$export(module.exports, "default", () => $f27077d8818225af$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5Lo0w = parcelRequire("5Lo0w");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f27077d8818225af$var$NoLazyAsyncChangeOwnerFilterModal = (0, $bQWwW.lazy)(()=>(parcelRequire("edCCP")), {
    moduleId: "./src/packages/global-pages/directories/filters-directory-v2/change-owner-filter-modal/src/index.tsx"
});
const $f27077d8818225af$var$AsyncChangeOwnerFilterModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "configure-owner-modal",
        packageName: "filter",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "change-owner-filter-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Lo0w.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f27077d8818225af$var$NoLazyAsyncChangeOwnerFilterModal, props)));
var $f27077d8818225af$export$2e2bcd8739ae039 = $f27077d8818225af$var$AsyncChangeOwnerFilterModal;

});
parcelRegister("edCCP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cSKuM").then(()=>parcelRequire('226GG'));

});



parcelRegister("au0VK", function(module, exports) {
$parcel$export(module.exports, "DeleteFilterModal", () => $4951716b62339191$export$7eeb027d3dbb72df);

var $eJOHy = parcelRequire("eJOHy");

var $7NseJ = parcelRequire("7NseJ");

var $cSXp8 = parcelRequire("cSXp8");

var $95O7y = parcelRequire("95O7y");
var $83DiZ = parcelRequire("83DiZ");

var $6Ibih = parcelRequire("6Ibih");
const $4951716b62339191$export$7eeb027d3dbb72df = ({ isOpen: isOpen, name: name, filterId: filterId, onClose: onClose, onRefetch: onRefetch })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const [filterQueryParam] = (0, $95O7y.useQueryParam)('filter');
    const onSuccess = (0, $eJOHy.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        if (filterQueryParam === filterId) push('/jira/filters');
        onClose();
        showFlag({
            id: 'filter-deleted',
            title: [
                (0, $6Ibih.default).filterDeletedModalTitleSuccessNonFinal,
                {
                    name: name
                }
            ],
            type: 'success',
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        filterId,
        filterQueryParam,
        name,
        onClose,
        onRefetch,
        push,
        showFlag
    ]);
    const onFailure = (0, $eJOHy.useCallback)(()=>{
        onClose();
        showFlag({
            id: 'filter-delete-failed',
            title: (0, $6Ibih.default).filterDeletedModalTitleErrorNonFinal,
            description: (0, $6Ibih.default).filterDeletedModalDescriptionErrorNonFinal,
            type: 'error',
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        onClose,
        showFlag
    ]);
    const filter = {
        name: name,
        id: filterId
    };
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7NseJ.default), {
        filter: filter,
        onFilterDeleted: onSuccess,
        onFilterDeleteFailed: onFailure,
        onFilterInitiateFailed: onFailure,
        onCancel: onClose
    });
};

});
parcelRegister("7NseJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9b2891cb52bc300$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fdpHV = parcelRequire("fdpHV");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $3So8J = parcelRequire("3So8J");


var $1sfij = parcelRequire("1sfij");

var $5w3Ve = parcelRequire("5w3Ve");

var $lDUyj = parcelRequire("lDUyj");

var $iW3eZ = parcelRequire("iW3eZ");

// eslint-disable-next-line jira/react/no-class-components
class $b9b2891cb52bc300$var$DeleteModal extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFilterDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $lDUyj.default)((0, $1sfij.default));
        this.store.dispatch((0, $5w3Ve.setAppProps)(this.props));
        this.store.dispatch((0, $5w3Ve.getAssociatedItems)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
            id: "unhandled",
            packageName: "jiraDeleteFiltersModal",
            teamName: "keystone"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iW3eZ.default), null))));
    }
}
var $b9b2891cb52bc300$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('deleteFilter', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))($b9b2891cb52bc300$var$DeleteModal);

});
parcelRegister("fdpHV", function(module, exports) {
$parcel$export(module.exports, "AnalyticsSource", () => $c4c8dc54a05d07cb$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $c4c8dc54a05d07cb$export$ec9f54bd4341ceb);

var $dUaMU = parcelRequire("dUaMU");
const $c4c8dc54a05d07cb$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $dUaMU.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $c4c8dc54a05d07cb$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $dUaMU.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

parcelRegister("aP411", function(module, exports) {
$parcel$export(module.exports, "default", () => $02914045d75bc0a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $02914045d75bc0a9$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $02914045d75bc0a9$var$appStyles = null;
var $02914045d75bc0a9$export$2e2bcd8739ae039 = $02914045d75bc0a9$var$AppStyle;

});

parcelRegister("1sfij", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ab053264faf65c2$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $id9Ha = parcelRequire("id9Ha");

var $5vAkc = parcelRequire("5vAkc");
var // @ts-expect-error - TS2769 - No overload matches this call.
$2ab053264faf65c2$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $id9Ha.default), (0, $5vAkc.default));

});
parcelRegister("id9Ha", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7137a58c450d3a4$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $3dBDK = parcelRequire("3dBDK");

var $5w3Ve = parcelRequire("5w3Ve");

var $fOU2r = parcelRequire("fOU2r");
const $a7137a58c450d3a4$var$deleteEpic = (action$, store)=>action$.ofType((0, $5w3Ve.DELETE_FILTER)).mergeMap(({ onComplete: onComplete })=>{
        const state = store.getState();
        const filter = (0, $fOU2r.getFilter)(state);
        return (0, $7kixv.Observable).fromPromise((0, $3dBDK.default)(filter.id)).mergeMap(()=>{
            (0, $fOU2r.getOnFilterDeleted)(state)(filter);
            onComplete?.();
            return (0, $7kixv.Observable).of((0, $5w3Ve.filterDeleted)());
        }).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.filters-v2.delete-modal.ops.delete-filter', error.message, error);
            (0, $fOU2r.getOnFilterDeleteFailed)(state)(filter);
            return (0, $7kixv.Observable).of((0, $5w3Ve.deleteFilterFailed)());
        });
    });
var $a7137a58c450d3a4$export$2e2bcd8739ae039 = $a7137a58c450d3a4$var$deleteEpic;

});
parcelRegister("3dBDK", function(module, exports) {
$parcel$export(module.exports, "default", () => $857ba0747d5aea43$export$2e2bcd8739ae039);

var $br11A = parcelRequire("br11A");
const $857ba0747d5aea43$var$deleteFilterService = (filterId)=>(0, $br11A.default)(filterId);
var $857ba0747d5aea43$export$2e2bcd8739ae039 = $857ba0747d5aea43$var$deleteFilterService;

});
parcelRegister("br11A", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d8327b93b7e8d49$export$2e2bcd8739ae039);

var $3ugTQ = parcelRequire("3ugTQ");
const $9d8327b93b7e8d49$export$7138c24907de3954 = (filterId)=>`/rest/api/3/filter/${filterId}`;
const $9d8327b93b7e8d49$var$deleteRest = (filterId)=>(0, $3ugTQ.performDeleteRequest)($9d8327b93b7e8d49$export$7138c24907de3954(filterId));
var $9d8327b93b7e8d49$export$2e2bcd8739ae039 = $9d8327b93b7e8d49$var$deleteRest;

});


parcelRegister("5w3Ve", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $0c5106eda7f98a90$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $0c5106eda7f98a90$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS", () => $0c5106eda7f98a90$export$30d51c320095bdf2);
$parcel$export(module.exports, "getAssociatedItems", () => $0c5106eda7f98a90$export$41e54fd4a1e5f9ba);
$parcel$export(module.exports, "ASSOCIATED_ITEMS_RETRIEVED", () => $0c5106eda7f98a90$export$ba1e7147572f059);
$parcel$export(module.exports, "associatedItemsRetrieved", () => $0c5106eda7f98a90$export$25e9475c64e5eda0);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS_FAILED", () => $0c5106eda7f98a90$export$4c7da338bde02996);
$parcel$export(module.exports, "getAssociatedItemsFailed", () => $0c5106eda7f98a90$export$bc1efa3ceb08db7b);
$parcel$export(module.exports, "DELETE_FILTER", () => $0c5106eda7f98a90$export$c90b00f6f11adca7);
$parcel$export(module.exports, "deleteFilter", () => $0c5106eda7f98a90$export$d80cc0328fcc6685);
$parcel$export(module.exports, "DELETE_FILTER_FAILED", () => $0c5106eda7f98a90$export$d3f2a09b0efe5b07);
$parcel$export(module.exports, "deleteFilterFailed", () => $0c5106eda7f98a90$export$e303ddf5f6d63378);
$parcel$export(module.exports, "FILTER_DELETED", () => $0c5106eda7f98a90$export$c8cf94be5a7baff9);
$parcel$export(module.exports, "filterDeleted", () => $0c5106eda7f98a90$export$9411fafcb56b5a87);
const $0c5106eda7f98a90$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $0c5106eda7f98a90$export$cfda7627848a58cd = (payload)=>({
        type: $0c5106eda7f98a90$export$8aefe701a6f431e0,
        payload: payload
    });
const $0c5106eda7f98a90$export$30d51c320095bdf2 = 'state.GET_ASSOCIATED_ITEMS';
const $0c5106eda7f98a90$export$41e54fd4a1e5f9ba = ()=>({
        type: $0c5106eda7f98a90$export$30d51c320095bdf2
    });
const $0c5106eda7f98a90$export$ba1e7147572f059 = 'state.ASSOCIATED_ITEMS_RETRIEVED';
const $0c5106eda7f98a90$export$25e9475c64e5eda0 = (payload)=>({
        type: $0c5106eda7f98a90$export$ba1e7147572f059,
        payload: payload
    });
const $0c5106eda7f98a90$export$4c7da338bde02996 = 'state.GET_ASSOCIATED_ITEMS_FAILED';
const $0c5106eda7f98a90$export$bc1efa3ceb08db7b = ()=>({
        type: $0c5106eda7f98a90$export$4c7da338bde02996
    });
const $0c5106eda7f98a90$export$c90b00f6f11adca7 = 'state.DELETE_FILTER';
const $0c5106eda7f98a90$export$d80cc0328fcc6685 = (onComplete)=>({
        type: $0c5106eda7f98a90$export$c90b00f6f11adca7,
        onComplete: onComplete
    });
const $0c5106eda7f98a90$export$d3f2a09b0efe5b07 = 'state.DELETE_FILTER_FAILED';
const $0c5106eda7f98a90$export$e303ddf5f6d63378 = ()=>({
        type: $0c5106eda7f98a90$export$d3f2a09b0efe5b07
    });
const $0c5106eda7f98a90$export$c8cf94be5a7baff9 = 'state.FILTER_DELETED';
const $0c5106eda7f98a90$export$9411fafcb56b5a87 = ()=>({
        type: $0c5106eda7f98a90$export$c8cf94be5a7baff9
    });

});

parcelRegister("fOU2r", function(module, exports) {
$parcel$export(module.exports, "getFilter", () => $a3b86ee3a8758336$export$61ec8404f465cd36);
$parcel$export(module.exports, "getFilterName", () => $a3b86ee3a8758336$export$b055b0a980ec5c8b);
$parcel$export(module.exports, "getOnInitialised", () => $a3b86ee3a8758336$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnFilterDeleted", () => $a3b86ee3a8758336$export$f5f4c932a633fd32);
$parcel$export(module.exports, "getOnFilterDeleteFailed", () => $a3b86ee3a8758336$export$eb50a3cf06607a3c);
$parcel$export(module.exports, "getOnFilterInitiateFailed", () => $a3b86ee3a8758336$export$9ef18d2a82ac120);
$parcel$export(module.exports, "getOnCancel", () => $a3b86ee3a8758336$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $a3b86ee3a8758336$export$906c0d65e4ece39d);
$parcel$export(module.exports, "isDataRetrieved", () => $a3b86ee3a8758336$export$a9211cdc0a6969f);
$parcel$export(module.exports, "getAssociatedBoards", () => $a3b86ee3a8758336$export$2de9e9ee805a66);
$parcel$export(module.exports, "getAssociatedUsers", () => $a3b86ee3a8758336$export$4004cc0feaedb1d1);
$parcel$export(module.exports, "getAssociatedGroups", () => $a3b86ee3a8758336$export$4f21761c9913ab49);
$parcel$export(module.exports, "getCanDelete", () => $a3b86ee3a8758336$export$e31d21defdc79bd5);
const $a3b86ee3a8758336$export$61ec8404f465cd36 = (state)=>state.appProps.filter;
const $a3b86ee3a8758336$export$b055b0a980ec5c8b = (state)=>state.appProps.filter.name;
const $a3b86ee3a8758336$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $a3b86ee3a8758336$export$f5f4c932a633fd32 = (state)=>state.appProps.onFilterDeleted;
const $a3b86ee3a8758336$export$eb50a3cf06607a3c = (state)=>state.appProps.onFilterDeleteFailed;
const $a3b86ee3a8758336$export$9ef18d2a82ac120 = (state)=>state.appProps.onFilterInitiateFailed;
const $a3b86ee3a8758336$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $a3b86ee3a8758336$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $a3b86ee3a8758336$export$a9211cdc0a6969f = (state)=>state.isDataRetrieved;
const $a3b86ee3a8758336$export$2de9e9ee805a66 = (state)=>state.boards;
const $a3b86ee3a8758336$export$4004cc0feaedb1d1 = (state)=>state.users;
const $a3b86ee3a8758336$export$4f21761c9913ab49 = (state)=>state.groups;
const $a3b86ee3a8758336$export$e31d21defdc79bd5 = (state)=>Array.isArray(state.boards) && state.boards.length === 0;

});


parcelRegister("5vAkc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0416b34426e91322$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("fu6rs");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $hG5l5 = parcelRequire("hG5l5");

var $j7QHh = parcelRequire("j7QHh");

var $5w3Ve = parcelRequire("5w3Ve");

var $fOU2r = parcelRequire("fOU2r");
const $0416b34426e91322$var$getItems = (action$, store)=>action$.ofType((0, $5w3Ve.GET_ASSOCIATED_ITEMS)).mergeMap(()=>{
        const state = store.getState();
        const filter = (0, $fOU2r.getFilter)(state);
        return (0, $7kixv.Observable).forkJoin((0, $7kixv.Observable).fromPromise((0, $hG5l5.default)(filter.id)), (0, $7kixv.Observable).fromPromise((0, $j7QHh.default)(filter.id))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map(([boards, subscriptions])=>{
            const { users: users, groups: groups } = subscriptions;
            (0, $fOU2r.getOnInitialised)(state)();
            return (0, $5w3Ve.associatedItemsRetrieved)({
                boards: boards,
                users: users,
                groups: groups
            });
        }).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.filters-v2.delete-modal.ops.get-associated-items', error.message, error);
            (0, $fOU2r.getOnFilterInitiateFailed)(state)(filter);
            return (0, $7kixv.Observable).of((0, $5w3Ve.getAssociatedItemsFailed)());
        });
    });
var $0416b34426e91322$export$2e2bcd8739ae039 = $0416b34426e91322$var$getItems;

});
parcelRegister("hG5l5", function(module, exports) {
$parcel$export(module.exports, "default", () => $45baed30f738a43a$export$2e2bcd8739ae039);

var $ik39t = parcelRequire("ik39t");

var $gJXHu = parcelRequire("gJXHu");
const $45baed30f738a43a$var$getBoards = async (filterId)=>{
    const response = await (0, $ik39t.default)(filterId);
    return (0, $gJXHu.transformResponse)(response);
};
var $45baed30f738a43a$export$2e2bcd8739ae039 = $45baed30f738a43a$var$getBoards;

});
parcelRegister("ik39t", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bbce76cac17ef78$export$2e2bcd8739ae039);

var $hgi0g = parcelRequire("hgi0g");
const $7bbce76cac17ef78$export$7138c24907de3954 = (filterId)=>`/rest/agile/1.0/board/filter/${filterId}`;
const $7bbce76cac17ef78$var$getBoards = (filterId)=>(0, $hgi0g.default)($7bbce76cac17ef78$export$7138c24907de3954(filterId));
var $7bbce76cac17ef78$export$2e2bcd8739ae039 = $7bbce76cac17ef78$var$getBoards;

});

parcelRegister("gJXHu", function(module, exports) {
$parcel$export(module.exports, "transformResponse", () => $d296ce64ddb1511c$export$3361e9be8093ddcc);
const $d296ce64ddb1511c$export$b708cb7873d8352c = (id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
const $d296ce64ddb1511c$export$3361e9be8093ddcc = (response)=>{
    const boards = response && response.values || [];
    return boards.map((board)=>{
        const { name: name, id: id } = board;
        const href = $d296ce64ddb1511c$export$b708cb7873d8352c(id);
        return {
            name: name,
            id: id,
            href: href
        };
    });
};

});


parcelRegister("j7QHh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6a0e330f474a56f$export$2e2bcd8739ae039);

var $3GJlE = parcelRequire("3GJlE");

var $3rsCf = parcelRequire("3rsCf");
const $a6a0e330f474a56f$var$getAssociatedSubscriptions = async (filterId)=>{
    const response = await (0, $3GJlE.default)(filterId);
    return (0, $3rsCf.transformResponse)(response);
};
var $a6a0e330f474a56f$export$2e2bcd8739ae039 = $a6a0e330f474a56f$var$getAssociatedSubscriptions;

});
parcelRegister("3GJlE", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bc27b55f2b87a6b$export$2e2bcd8739ae039);

var $hgi0g = parcelRequire("hgi0g");
const $9bc27b55f2b87a6b$export$7138c24907de3954 = (filterId)=>`/rest/api/3/filter/${filterId}?expand=subscriptions`;
const $9bc27b55f2b87a6b$var$getAssociatedSubscription = (filterId)=>(0, $hgi0g.default)($9bc27b55f2b87a6b$export$7138c24907de3954(filterId));
var $9bc27b55f2b87a6b$export$2e2bcd8739ae039 = $9bc27b55f2b87a6b$var$getAssociatedSubscription;

});

parcelRegister("3rsCf", function(module, exports) {
$parcel$export(module.exports, "transformResponse", () => $1b8678ffcc2768c4$export$3361e9be8093ddcc);

var $a62R3 = parcelRequire("a62R3");

var $4cTDP = parcelRequire("4cTDP");
const $1b8678ffcc2768c4$export$d62b55bf0ad74ba2 = (id)=>{
    if ((0, $4cTDP.fg)('jira-adopt-teams-nav-config')) {
        const { href: href } = (0, $a62R3.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: id
            }
        });
        return href;
    }
    return `/jira/people/${id}`;
};
const $1b8678ffcc2768c4$export$3361e9be8093ddcc = (response)=>{
    const subscriptions = response && response.subscriptions && response.subscriptions.items || [];
    const users = [];
    const groups = [];
    subscriptions.forEach((subscription)=>{
        const { user: user, group: group } = subscription;
        if (group) return groups.push({
            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'never'.
            name: group.name
        });
        // @ts-expect-error - TS2339 - Property 'accountId' does not exist on type 'never'.
        const href = $1b8678ffcc2768c4$export$d62b55bf0ad74ba2(user.accountId);
        return user && users.push({
            // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'never'.
            displayName: user.displayName,
            href: href
        });
    });
    return {
        users: users,
        groups: groups
    };
};

});




parcelRegister("lDUyj", function(module, exports) {
$parcel$export(module.exports, "default", () => $278ffdd193870a27$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $geiGp = parcelRequire("geiGp");
const $278ffdd193870a27$var$createStore = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'directories/filters-v2/delete-modal',
        rootReducer: $geiGp.default,
        rootEpic: rootEpic
    });
var $278ffdd193870a27$export$2e2bcd8739ae039 = $278ffdd193870a27$var$createStore;

});
parcelRegister("geiGp", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f1da0e6466ee8eb$export$2e2bcd8739ae039);

var $5w3Ve = parcelRequire("5w3Ve");
const $0f1da0e6466ee8eb$export$49d5fc8cba920a0 = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    boards: [],
    users: [],
    groups: [],
    isDataRetrieved: false,
    isDeleteInProgress: false
};
const $0f1da0e6466ee8eb$var$reducer = (state = $0f1da0e6466ee8eb$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $5w3Ve.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $5w3Ve.DELETE_FILTER:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $5w3Ve.FILTER_DELETED:
        case 0, $5w3Ve.DELETE_FILTER_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $5w3Ve.ASSOCIATED_ITEMS_RETRIEVED:
            {
                const { boards: boards, users: users, groups: groups } = action.payload;
                return {
                    ...state,
                    isDataRetrieved: true,
                    ...boards ? {
                        boards: boards
                    } : undefined,
                    ...users ? {
                        users: users
                    } : undefined,
                    ...groups ? {
                        groups: groups
                    } : undefined
                };
            }
        case 0, $5w3Ve.GET_ASSOCIATED_ITEMS_FAILED:
        case 0, $5w3Ve.GET_ASSOCIATED_ITEMS:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $0f1da0e6466ee8eb$export$2e2bcd8739ae039 = $0f1da0e6466ee8eb$var$reducer;

});


parcelRegister("iW3eZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4321da6e267e1d94$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $fOU2r = parcelRequire("fOU2r");

var $6LbeH = parcelRequire("6LbeH");

var $b9s6a = parcelRequire("b9s6a");

var $969je = parcelRequire("969je");
const $4321da6e267e1d94$var$mapStateToProps = (state)=>({
        Content: $6LbeH.default,
        Footer: $b9s6a.default,
        name: (0, $fOU2r.getFilterName)(state),
        onCancel: (0, $fOU2r.getOnCancel)(state),
        isOpen: (0, $fOU2r.isDataRetrieved)(state)
    });
var $4321da6e267e1d94$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($4321da6e267e1d94$var$mapStateToProps, {})((0, $969je.default));

});
parcelRegister("6LbeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bc62c5a1417fdf7$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $fOU2r = parcelRequire("fOU2r");

var $gsnIW = parcelRequire("gsnIW");
const $3bc62c5a1417fdf7$var$mapStateToProps = (state)=>({
        filter: (0, $fOU2r.getFilter)(state),
        boards: (0, $fOU2r.getAssociatedBoards)(state),
        users: (0, $fOU2r.getAssociatedUsers)(state),
        groups: (0, $fOU2r.getAssociatedGroups)(state)
    });
var $3bc62c5a1417fdf7$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($3bc62c5a1417fdf7$var$mapStateToProps, {})((0, $gsnIW.default));

});
parcelRegister("gsnIW", function(module, exports) {
$parcel$export(module.exports, "default", () => $406b9af348575917$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lRq8t = parcelRequire("lRq8t");

var $2FeHb = parcelRequire("2FeHb");
const $406b9af348575917$var$ContentWithoutBoardsAndSubscriptions = ({ formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).noSubscriptionsAndBoards));
const $406b9af348575917$var$ContentWithAssociatedSubscriptions = ({ formatMessage: formatMessage, groups: groups, users: users })=>users.length === 1 && groups.length === 0 || users.length === 0 && groups.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).singleSubscription), users.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: users[0].href
    }, `${users[0].displayName}.`) : null, groups.length === 1 ? `${groups[0].name}.` : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleBoardsWarning))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleSubscriptions, {
        number: users.length + groups.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, users.map(({ displayName: displayName, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: href
        }, displayName))), groups.map(({ name: name }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: index
        }, name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleSubscriptionsWarning)));
const $406b9af348575917$var$ContentWithAssociatedBoards = ({ boards: boards, formatMessage: formatMessage })=>boards.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).singleBoard), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: boards[0].href
    }, `${boards[0].name}.`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleBoardsWarning))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleBoards, {
        number: boards.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, boards.map(({ name: name, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: href
        }, name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleBoardsWarning)));
const $406b9af348575917$export$7c6e2c02157bb7d2 = ({ boards: boards, groups: groups, users: users })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (users.length === 0 && groups.length === 0 && boards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($406b9af348575917$var$ContentWithoutBoardsAndSubscriptions, {
        formatMessage: formatMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).associatedItems)), boards.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($406b9af348575917$var$ContentWithAssociatedBoards, {
        boards: boards,
        formatMessage: formatMessage
    }) : null, users.length > 0 || groups.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($406b9af348575917$var$ContentWithAssociatedSubscriptions, {
        users: users,
        groups: groups,
        formatMessage: formatMessage
    }) : null);
};
var $406b9af348575917$export$2e2bcd8739ae039 = $406b9af348575917$export$7c6e2c02157bb7d2;

});
parcelRegister("2FeHb", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e11a255e2bc2b8b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4e11a255e2bc2b8b$var$messages = (0, $7qGN1.defineMessages)({
    noSubscriptionsAndBoards: {
        "id": "directories.filters-v2.delete-modal.content.no-subscriptions-and-boards",
        "defaultMessage": "Are you sure you want to delete this filter?"
    },
    associatedItems: {
        "id": "directories.filters-v2.delete-modal.content.associated-items",
        "defaultMessage": "This filter is used elsewhere. Deleting it may impact other people's work."
    },
    multipleSubscriptions: {
        "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions",
        "defaultMessage": "This filter has currently {number} subscriptions:"
    },
    singleSubscription: {
        "id": "directories.filters-v2.delete-modal.content.single-subscription",
        "defaultMessage": "This filter has a subscription for "
    },
    multipleSubscriptionsWarning: {
        "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions-warning",
        "defaultMessage": "Deleting this filter will cause subscription emails for these users and groups to no longer be delivered."
    },
    multipleBoards: {
        "id": "directories.filters-v2.delete-modal.content.multiple-boards",
        "defaultMessage": "This filter is currently being used by {number} boards:"
    },
    singleBoard: {
        "id": "directories.filters-v2.delete-modal.content.single-board",
        "defaultMessage": "This filter is currently being used by "
    },
    multipleBoardsWarning: {
        "id": "directories.filters-v2.delete-modal.content.multiple-boards-warning",
        "defaultMessage": "You'll need to remove this filters associations to the boards before it can be removed."
    }
});
var $4e11a255e2bc2b8b$export$2e2bcd8739ae039 = $4e11a255e2bc2b8b$var$messages;

});



parcelRegister("b9s6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $9efd33015b5c7148$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $6sjW5 = parcelRequire("6sjW5");

var $gnQAk = parcelRequire("gnQAk");

var $5w3Ve = parcelRequire("5w3Ve");

var $fOU2r = parcelRequire("fOU2r");

var $hpOVf = parcelRequire("hpOVf");
const $9efd33015b5c7148$var$mapStateToProps = (state)=>({
        filter: (0, $fOU2r.getFilter)(state),
        canDelete: (0, $fOU2r.getCanDelete)(state),
        deleteInProgress: (0, $fOU2r.isDeleteInProgress)(state),
        onCancel: (0, $fOU2r.getOnCancel)(state)
    });
var $9efd33015b5c7148$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onDelete: 'filterDeleted',
    onCancel: 'filterDeleteCanceled'
}), (0, $gnQAk.connect)($9efd33015b5c7148$var$mapStateToProps, {
    onDelete: (0, $5w3Ve.deleteFilter)
}))((0, $hpOVf.default));

});
parcelRegister("eq3Hf", function(module, exports) {

var $lH6wc = parcelRequire("lH6wc");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $a7f65c72bfe5b7ea$var$flow = $lH6wc();
module.exports = $a7f65c72bfe5b7ea$var$flow;

});
parcelRegister("lH6wc", function(module, exports) {

var $iTpII = parcelRequire("iTpII");

var $lgI96 = parcelRequire("lgI96");

var $2GK2O = parcelRequire("2GK2O");

var $asy1v = parcelRequire("asy1v");

var $4sprp = parcelRequire("4sprp");

var $74osV = parcelRequire("74osV");
/** Error message constants. */ var $fcb2ab89fd3879f0$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $fcb2ab89fd3879f0$var$WRAP_CURRY_FLAG = 8, $fcb2ab89fd3879f0$var$WRAP_PARTIAL_FLAG = 32, $fcb2ab89fd3879f0$var$WRAP_ARY_FLAG = 128, $fcb2ab89fd3879f0$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $fcb2ab89fd3879f0$var$createFlow(fromRight) {
    return $lgI96(function(funcs) {
        var length = funcs.length, index = length, prereq = $iTpII.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($fcb2ab89fd3879f0$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $asy1v(func) == 'wrapper') var wrapper = new $iTpII([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $asy1v(func), data = funcName == 'wrapper' ? $2GK2O(func) : undefined;
            if (data && $74osV(data[0]) && data[1] == ($fcb2ab89fd3879f0$var$WRAP_ARY_FLAG | $fcb2ab89fd3879f0$var$WRAP_CURRY_FLAG | $fcb2ab89fd3879f0$var$WRAP_PARTIAL_FLAG | $fcb2ab89fd3879f0$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$asy1v(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $74osV(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $4sprp(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $fcb2ab89fd3879f0$var$createFlow;

});


parcelRegister("6sjW5", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfc4906c561f5616$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9X75V = parcelRequire("9X75V");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $bfc4906c561f5616$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $9X75V.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $9X75V.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eJOHy.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $bfc4906c561f5616$export$2e2bcd8739ae039 = $bfc4906c561f5616$var$fireWithUIAnalytics;

});

parcelRegister("hpOVf", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e9e4b2ef7f05ae8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $48q59 = parcelRequire("48q59");

var $kseeK = parcelRequire("kseeK");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $idGBm = parcelRequire("idGBm");

var $6rSB4 = parcelRequire("6rSB4");

var $cN96O = parcelRequire("cN96O");
const $3e9e4b2ef7f05ae8$var$Footer = ({ intl: { formatMessage: formatMessage }, canDelete: canDelete, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete })=>{
    const { publish: publish } = (0, $6rSB4.useDeleteChangeActions)();
    const onDeleteWithEvent = (event, analyticsEvent)=>{
        // additional args aside from event & analyticsEvent that you wish to pass down needs to be passed as the first argument
        onDelete(publish, event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e9e4b2ef7f05ae8$var$Container, null, deleteInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3e9e4b2ef7f05ae8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "danger",
        type: "submit",
        isDisabled: !canDelete,
        onClick: onDeleteWithEvent
    }, formatMessage((0, $cN96O.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        isDisabled: deleteInProgress,
        onClick: onCancel
    }, formatMessage((0, $cN96O.default).cancelButtonCaption)))));
};
$3e9e4b2ef7f05ae8$var$Footer.defaultProps = {
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    deleteInProgress: false,
    canDelete: true
};
var $3e9e4b2ef7f05ae8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($3e9e4b2ef7f05ae8$var$Footer);
const $3e9e4b2ef7f05ae8$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3e9e4b2ef7f05ae8$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
});

});
parcelRegister("idGBm", function(module, exports) {
$parcel$export(module.exports, "injectIntlV2", () => $c35e98ccc24112a8$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eJOHy = parcelRequire("eJOHy");

var $cjwij = parcelRequire("cjwij");

var $lRq8t = parcelRequire("lRq8t");
const $c35e98ccc24112a8$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $c35e98ccc24112a8$var$getDisplayName(Component) {
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $c35e98ccc24112a8$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $lRq8t.default)();
        const intlRef = (0, $eJOHy.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$c35e98ccc24112a8$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(WithIntl, WrappedComponent);
};

});

parcelRegister("cN96O", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a2cb6409b3bb641$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9a2cb6409b3bb641$var$messages = (0, $7qGN1.defineMessages)({
    delete: {
        "id": "directories.filters-v2.delete-modal.footer.delete",
        "defaultMessage": "Delete"
    },
    cancelButtonCaption: {
        "id": "directories.filters-v2.delete-modal.footer.cancel-button-caption",
        "defaultMessage": "Cancel"
    }
});
var $9a2cb6409b3bb641$export$2e2bcd8739ae039 = $9a2cb6409b3bb641$var$messages;

});



parcelRegister("969je", function(module, exports) {
$parcel$export(module.exports, "default", () => $163c7a032dd631c0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ik0CA = parcelRequire("ik0CA");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $guWba = parcelRequire("guWba");

var $4B7rn = parcelRequire("4B7rn");

var $idGBm = parcelRequire("idGBm");

var $fgJkD = parcelRequire("fgJkD");

var $4cTDP = parcelRequire("4cTDP");

var $i65VJ = parcelRequire("i65VJ");
const $163c7a032dd631c0$var$DeleteModal = ({ intl: { formatMessage: formatMessage }, isOpen: isOpen, Content: Content, Footer: Footer, onCancel: onCancel, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "delete-filters-modal.modal-dialog",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('enghealth-modal-close-button-prevent-close-modal')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, formatMessage((0, $i65VJ.default).title, {
        name: name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, {
        onClose: onCancel
    }))));
var $163c7a032dd631c0$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($163c7a032dd631c0$var$DeleteModal);

});
parcelRegister("guWba", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3a28975a6f28d74$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $9X75V = parcelRequire("9X75V");
// eslint-disable-next-line jira/react/no-class-components
class $d3a28975a6f28d74$var$ViewTracker extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $d3a28975a6f28d74$var$ViewTrackerWithAnalytics = (0, $dUaMU.default)({
    componentName: 'view-tracker'
})((0, $4J0ad.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $9X75V.PAGE_EVENT_ACTION)
        }).fire()
})($d3a28975a6f28d74$var$ViewTracker));
const $d3a28975a6f28d74$var$ViewTrackerWithNoopOnMount = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d3a28975a6f28d74$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    });
var $d3a28975a6f28d74$export$2e2bcd8739ae039 = $d3a28975a6f28d74$var$ViewTrackerWithNoopOnMount;

});

parcelRegister("fgJkD", function(module, exports) {
$parcel$export(module.exports, "ModalDialog", () => $dfae8fefc4710a7e$export$1fa217be60c2f188);

var $eJOHy = parcelRequire("eJOHy");

var $lJKII = parcelRequire("lJKII");

var $4aSRi = parcelRequire("4aSRi");
const $dfae8fefc4710a7e$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $4aSRi.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    (0, $eJOHy.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});
parcelRegister("4aSRi", function(module, exports) {
$parcel$export(module.exports, "useModalDialogActions", () => $0b2a666031d89d51$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $0b2a666031d89d51$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gnlW1 = parcelRequire("gnlW1");

var $4CmBA = parcelRequire("4CmBA");

var $ik5fE = parcelRequire("ik5fE");
const $0b2a666031d89d51$var$Store = (0, $GtRbT.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $gnlW1.initialState,
    actions: $4CmBA.actions
});
const $0b2a666031d89d51$export$3cf2e4b6d3541465 = (0, $iJq0l.createActionsHook)($0b2a666031d89d51$var$Store);
const $0b2a666031d89d51$export$217308a4ece853b2 = (0, $iJq0l.createStateHook)($0b2a666031d89d51$var$Store, {
    selector: (0, $ik5fE.getReturnFocusTo)
});

});
parcelRegister("gnlW1", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $155a858c98d12eaf$export$d4c72bab9d6cc13a);
const $155a858c98d12eaf$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("4CmBA", function(module, exports) {
$parcel$export(module.exports, "actions", () => $d6a92026239e37f0$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d6a92026239e37f0$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $d6a92026239e37f0$export$e324594224ef24da = {
    setReturnFocusTo: $d6a92026239e37f0$export$b263d1e638b131c2
};

});

parcelRegister("ik5fE", function(module, exports) {
$parcel$export(module.exports, "getReturnFocusTo", () => $c992da1452d2469a$export$d5f8692765ccd209);
const $c992da1452d2469a$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("i65VJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f03eecefd6f88a19$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f03eecefd6f88a19$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.delete-modal.title",
        "defaultMessage": "Delete {name}"
    }
});
var $f03eecefd6f88a19$export$2e2bcd8739ae039 = $f03eecefd6f88a19$var$messages;

});




parcelRegister("6Ibih", function(module, exports) {
$parcel$export(module.exports, "default", () => $d00a29012bc8be70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d00a29012bc8be70$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    filterDeletedModalTitleSuccessNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-success-non-final",
        "defaultMessage": "{name} was deleted"
    },
    filterDeletedModalTitleErrorNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-error-non-final",
        "defaultMessage": "We couldn't delete filter"
    },
    filterDeletedModalDescriptionErrorNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-description-error-non-final",
        "defaultMessage": "There was an error, please try again."
    }
});

});


parcelRegister("dv92c", function(module, exports) {
$parcel$export(module.exports, "default", () => $88d4385cd16397b6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $88d4385cd16397b6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    manageSubscription: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription",
        "defaultMessage": "Manage subscriptions"
    },
    copyFilter: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    },
    edit: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit",
        "defaultMessage": "Edit filter"
    },
    changeOwner: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner",
        "defaultMessage": "Change owner"
    },
    delete: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete",
        "defaultMessage": "Delete filter"
    },
    manageSubscriptionWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription-with-name",
        "defaultMessage": "Manage subscriptions for {name}"
    },
    copyFilterWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-with-name",
        "defaultMessage": "Copy filter {name}"
    },
    editWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit-with-name",
        "defaultMessage": "Edit filter {name}"
    },
    changeOwnerWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner-with-name",
        "defaultMessage": "Change owner for {name}"
    },
    deleteWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete-with-name",
        "defaultMessage": "Delete filter {name}"
    }
});

});

parcelRegister("6hubO", function(module, exports) {
$parcel$export(module.exports, "useModalState", () => $3d7fe49201b62c8d$export$baa48889c42cc6cb);

var $eJOHy = parcelRequire("eJOHy");
const $3d7fe49201b62c8d$export$baa48889c42cc6cb = (defaultOpen = false)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultOpen);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $eJOHy.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen
    };
};

});


parcelRegister("2wv1t", function(module, exports) {
$parcel$export(module.exports, "SimpleFilterMenuItem", () => $0ce274b803741a48$export$608d42ceb4060968);

var $eJOHy = parcelRequire("eJOHy");

var $KDB2z = parcelRequire("KDB2z");

var $iVTd6 = parcelRequire("iVTd6");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");
function $0ce274b803741a48$export$608d42ceb4060968({ actionsOnHover: actionsOnHover, filterId: filterId, name: name, onClick: onClick }) {
    const handlOnClick = (0, $eJOHy.useCallback)((e)=>{
        onClick?.();
        (0, $iVTd6.handleGinSPAClick)(e);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        actionsOnHover: actionsOnHover,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))), {
            label: "",
            color: "currentColor"
        }),
        href: `/issues/?filter=${filterId}`,
        menuId: (0, $h4Bzb.ENTITY_ID).FILTER(filterId),
        onClick: handlOnClick
    }, name);
}

});
parcelRegister("iVTd6", function(module, exports) {
$parcel$export(module.exports, "handleGinSPAClick", () => $79fca746cf96b384$export$f74673b086629362);
const $79fca746cf96b384$export$f74673b086629362 = (e)=>{
    const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'.
    typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
    const openInNewTab = // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'.
    e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button != null && e.button === 1;
    if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA?.Issues?.Application) {
        e.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.JIRA.Issues.Application.execute('navigation:navigateToUrl', href, {
            forceRefresh: true,
            checkPermission: true,
            replace: false,
            reset: true,
            routerEvent: true
        });
    }
};

});



parcelRegister("8aXvZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $50f1db071d06f5a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $50f1db071d06f5a0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.view-all-starred",
        "defaultMessage": "View all starred items"
    },
    defaultFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.default-filters",
        "defaultMessage": "Default filters"
    }
});

});


const $2ae2c8b27c911905$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Filters';
const $2ae2c8b27c911905$export$d57b6b390e78d90f = 'empanada';

parcelRegister("lRTqK", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $ee6fb28b46ca9a53$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");

var $lRq8t = parcelRequire("lRq8t");




var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $bxSuo = parcelRequire("bxSuo");

var $1TzuH = parcelRequire("1TzuH");

var $eltxi = parcelRequire("eltxi");
const $ee6fb28b46ca9a53$var$VIEW_ALL_FILTERS_PATH = (0, $bxSuo.filtersDirectoryRoute).path;
function $ee6fb28b46ca9a53$export$a06f1c675e846f6f() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const sendDefaultFilterDropdownAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: 'viewAllFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        onClick: sendDefaultFilterDropdownAnalytics,
        href: $ee6fb28b46ca9a53$var$VIEW_ALL_FILTERS_PATH,
        menuId: (0, $h4Bzb.MENU_ID_FILTERS_VIEW_ALL)
    }, formatMessage((0, $eltxi.default).viewAllFilters)))));
}

});
parcelRegister("bxSuo", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRoute", () => $6ecabfb97a89b10c$export$6350f52c8b40042d);
const $6ecabfb97a89b10c$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});

parcelRegister("eltxi", function(module, exports) {
$parcel$export(module.exports, "default", () => $be05a80503601f1f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $be05a80503601f1f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("44iMp", function(module, exports) {
$parcel$export(module.exports, "Header", () => $173ede2a30c7ec81$export$8b251419efc915eb);

var $eJOHy = parcelRequire("eJOHy");

var $dt3aG = parcelRequire("dt3aG");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");




var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $1TzuH = parcelRequire("1TzuH");

var $eEz35 = parcelRequire("eEz35");
const $173ede2a30c7ec81$export$8b251419efc915eb = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const handleOnClick = (0, $eJOHy.useCallback)((event)=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: 'searchAllIssues'
        });
        onClose?.(event);
    }, [
        onClose,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: "/issues/?jql=created%20%3E%3D%20-30d%20order%20by%20created%20DESC",
        onClick: handleOnClick,
        menuId: (0, $h4Bzb.MENU_ID_FILTERS_SEARCH),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
            label: "",
            color: "currentColor"
        })
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $eEz35.default).searchAllIssuesIssueTermRefresh : (0, $eEz35.default).searchAllIssues));
};

});
parcelRegister("eEz35", function(module, exports) {
$parcel$export(module.exports, "default", () => $35766b87ba0a44bb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $35766b87ba0a44bb$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    searchAllIssues: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues",
        "defaultMessage": "Search issues"
    },
    searchAllIssuesIssueTermRefresh: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});

});



parcelRegister("3E5ko", function(module, exports) {
$parcel$export(module.exports, "Nav4FiltersDefault", () => $d07e6adb4b7a82c3$export$c9a2a24425c3fa5e);

var $eJOHy = parcelRequire("eJOHy");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $49s4h = parcelRequire("49s4h");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $cHtIB = parcelRequire("cHtIB");


var $lRTqK = parcelRequire("lRTqK");

var $44iMp = parcelRequire("44iMp");

var $aG79I = parcelRequire("aG79I");
function $d07e6adb4b7a82c3$export$c9a2a24425c3fa5e(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $cHtIB.useCloudId)();
    const currentURL = (0, $49s4h.useGetCurrentUrl)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            currentURL: currentURL
        }), [
        cloudId,
        currentURL
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $aG79I.asyncFiltersContentViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        }, [
            entryPointActions
        ]),
        onExpansionToggle: (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
                    sectionItem: (0, $a9aec.SECTION_ITEM_FILTERS)
                });
            }
        }, [
            entryPointActions,
            sendSectionItemAnalyticsEvent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $44iMp.Header), null), simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-filters-default",
        packageName: (0, $2ae2c8b27c911905$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $2ae2c8b27c911905$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRTqK.Footer), null)));
}

});
parcelRegister("aG79I", function(module, exports) {
$parcel$export(module.exports, "asyncFiltersContentViewQuery", () => $2134863cb1748a97$export$fae48e64221e5e6e);

var $87dvF = parcelRequire("87dvF");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $2134863cb1748a97$export$fae48e64221e5e6e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("2LTPY")).then(({ Nav4FiltersContentViewQuery: Nav4FiltersContentViewQuery })=>Nav4FiltersContentViewQuery), {
        moduleId: "efb9eb25",
        moduleName: "Nav4FiltersContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                filters: {
                    parameters: $87dvF.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("87dvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cec722350e78899$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b09b73015f6d4eda410be086a0ec06e>>
 * @relayHash c3bc46f986acdf13f968e5919fcd2d52
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c97505ceda772c1ff0a6ccf4c08e12237f9f7d57f5f99db7c9b61da8af86b7e
const $5cec722350e78899$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v7 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v5 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c97505ceda772c1ff0a6ccf4c08e12237f9f7d57f5f99db7c9b61da8af86b7e",
            "metadata": {},
            "name": "Nav4FiltersContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5cec722350e78899$var$node.hash = "9218fd54b0172bf14bf1082dd5032107";
var $5cec722350e78899$export$2e2bcd8739ae039 = $5cec722350e78899$var$node;

});

parcelRegister("2LTPY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9RUzK").then(()=>parcelRequire('OD8to'));

});





parcelRegister("49MXG", function(module, exports) {
$parcel$export(module.exports, "Nav4Operations", () => $4fe48fbe78cc0860$export$bc4d01c843cee95e);

var $eQU2i = parcelRequire("eQU2i");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $4cTDP = parcelRequire("4cTDP");

var $70xty = parcelRequire("70xty");

var $iUGpu = parcelRequire("iUGpu");

var $ih7sC = parcelRequire("ih7sC");
const $4fe48fbe78cc0860$export$bc4d01c843cee95e = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $eQU2i.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const contents = isInitialSelectedPath((0, $h4Bzb.MENU_ID_OPERATIONS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iUGpu.OperationsMenuForLanding), {
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $70xty.OperationsMenuDefault), {
        isExpanded: isExpanded
    });
    if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih7sC.AlertsPopoutStoreContainer), {
        isGlobal: true
    }, contents);
    return contents;
};

});
parcelRegister("eQU2i", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fee22be20527b6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3902b07ebd67a0b3cbf092c1d6ea3a35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0fee22be20527b6a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isOperationsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Operations",
    "selections": [
        {
            "condition": "isOperationsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "OperationsMenuForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$0fee22be20527b6a$var$node.hash = "1d297012078c362907ac313c8068c25a";
var $0fee22be20527b6a$export$2e2bcd8739ae039 = $0fee22be20527b6a$var$node;

});

parcelRegister("70xty", function(module, exports) {
$parcel$export(module.exports, "OperationsMenuDefault", () => $64a8751d864bf09b$export$ef19d9521d85a60a);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $if69u = parcelRequire("if69u");

var $hPlDs = parcelRequire("hPlDs");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $iS6LA = parcelRequire("iS6LA");

var $5JDqh = parcelRequire("5JDqh");

var $ih7sC = parcelRequire("ih7sC");
function $64a8751d864bf09b$export$ef19d9521d85a60a(props) {
    const { isExpanded: isExpanded } = props;
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $iS6LA.asyncAlertsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { state: { lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $ih7sC.useAlertsPopoutStore)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (lastVisitedSearch && (0, $4cTDP.fg)('operations_nav4_remaining_items')) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: {
                ...entryPointParams,
                location: 'popOutPanel'
            }
        }));
    }, [
        entryPointParams,
        entryPointReferenceSubject,
        lastVisitedSearch,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5JDqh.OperationsExpandableMenuItem), {
        isExpanded: props.isExpanded,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        triggerRef: triggerRef,
        AlertsMenuItemContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
                ...entryPointParams,
                location: 'sidenav'
            } : entryPointParams
        })
    });
}

});
parcelRegister("iS6LA", function(module, exports) {
$parcel$export(module.exports, "asyncAlertsContentViewQuery", () => $aa406a9c2bfab3e5$export$182f7de76119e38a);

var $2Bhdi = parcelRequire("2Bhdi");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $aa406a9c2bfab3e5$export$182f7de76119e38a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hJeSe")).then(({ AlertsContentViewQuery: AlertsContentViewQuery })=>AlertsContentViewQuery), {
        moduleId: "4fcb17ab",
        moduleName: "AlertsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $2Bhdi.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("2Bhdi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3057b2da4cf98574$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8f87fd6efcb3b2793833812a581fd4f>>
 * @relayHash 539d81342bcb3bdab170556f3882c1e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1354395b89d1b40a39f597c3f378eb87813ab2626873be265cad98b57286915d
const $3057b2da4cf98574$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContentNew"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "OpsgenieSavedSearches",
                            "kind": "LinkedField",
                            "name": "savedSearches",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "sharedWithMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "createdByMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1354395b89d1b40a39f597c3f378eb87813ab2626873be265cad98b57286915d",
            "metadata": {},
            "name": "AlertsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3057b2da4cf98574$var$node.hash = "879968e67a244943ed377d7fb5da054d";
var $3057b2da4cf98574$export$2e2bcd8739ae039 = $3057b2da4cf98574$var$node;

});

parcelRegister("hJeSe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i0VeL").then(()=>parcelRequire('24U8y'));

});


parcelRegister("5JDqh", function(module, exports) {
$parcel$export(module.exports, "OperationsExpandableMenuItem", () => $22c563c3801cdcdd$export$a04d9e9cc5ec19d3);

var $eJOHy = parcelRequire("eJOHy");

var $5FM0W = parcelRequire("5FM0W");

var $bpdtz = parcelRequire("bpdtz");

var $amDP4 = parcelRequire("amDP4");

var $dicM4 = parcelRequire("dicM4");

var $gDKBr = parcelRequire("gDKBr");

var $9ltyu = parcelRequire("9ltyu");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $2QH3X = parcelRequire("2QH3X");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $kfvK2 = parcelRequire("kfvK2");

var $4cTDP = parcelRequire("4cTDP");

var $jn07M = parcelRequire("jn07M");

var $igYXn = parcelRequire("igYXn");

var $1Cl4r = parcelRequire("1Cl4r");

var $73hOC = parcelRequire("73hOC");

var $5rZKK = parcelRequire("5rZKK");

var $hbHml = parcelRequire("hbHml");

var $kG8Ic = parcelRequire("kG8Ic");

var $ih7sC = parcelRequire("ih7sC");
function $22c563c3801cdcdd$export$a04d9e9cc5ec19d3(props) {
    const isAlertsRoute = (0, $kfvK2.useIsActiveRoute)(new Set([
        (0, $jn07M.eocGlobalAlertListRoute).name,
        (0, $igYXn.eocTeamAlertDetailRoute).name
    ]));
    const { AlertsMenuItemContent: AlertsMenuItemContent, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, onSystemToggle: onSystemToggle, triggerRef: triggerRef } = props;
    const { hasReports: hasReports, showCommunicationsMenu: showCommunicationsMenu, showStatuspageMenu: showStatuspageMenu } = (0, $73hOC.useFeatures)();
    const { icon: alertsIcon, formattedMessage: alertsMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $1Cl4r.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($5FM0W))));
    const { icon: overviewIcon, formattedMessage: overviewMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).overview, (0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))));
    const { icon: oncallSchedulesIcon, formattedMessage: oncallSchedulesMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).onCallSchedules, (0, (/*@__PURE__*/$parcel$interopDefault($9ltyu))));
    const { icon: reportsIcon, formattedMessage: reportsMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).reports, (0, (/*@__PURE__*/$parcel$interopDefault($amDP4))));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).OPERATIONS);
    const { icon: statusPageIcon, formattedMessage: statusPageMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).statusPages, (0, (/*@__PURE__*/$parcel$interopDefault($dicM4))));
    const { icon: communicationsIcon, formattedMessage: communicationsMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).communications, (0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))));
    const { state: { lastVisitedSearch: lastVisitedSearch }, syncLastVisitedSearch: syncLastVisitedSearch } = (0, $ih7sC.useAlertsPopoutStore)();
    const [isOpsMenuExpanded, setIsOpsMenuExpanded] = (0, $eJOHy.useState)(props.isExpanded);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) syncLastVisitedSearch();
    }, [
        syncLastVisitedSearch
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const menuId = (0, $h4Bzb.MENU_ID_OPERATIONS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const onClickAlerts = (0, $eJOHy.useCallback)((_e, _a, { isExpanded: hasExpanded })=>{
        if (hasExpanded) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: 'alerts'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const alertsChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, lastVisitedSearch && (0, $4cTDP.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kG8Ic.PopoutToggleButton), null),
        elemBefore: alertsIcon,
        href: lastVisitedSearch,
        menuId: (0, $h4Bzb.MENU_ID_OPS_OVERVIEW)
    }, alertsMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-alerts",
        actions: isAlertsRoute && (0, $4cTDP.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kG8Ic.PopoutToggleButton), null) : undefined,
        onClick: onClickAlerts,
        elemBefore: alertsIcon,
        testId: (0, $azEgq.getTestId)((0, $h4Bzb.MENU_ID_OPS_ALERTS))
    }, alertsMessage), !(lastVisitedSearch && (0, $4cTDP.fg)('operations_nav4_remaining_items')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, AlertsMenuItemContent));
    const handleOnExpansionToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $8IuE5.L1_MENU_ID).OPERATIONS,
            sectionItem: (0, $a9aec.SECTION_ITEM_OPERATIONS)
        });
        setIsOpsMenuExpanded(hasExpanded);
        onExpansionToggle?.(hasExpanded);
    }, [
        onExpansionToggle,
        sendSectionItemAnalyticsEvent
    ]);
    const onClickOverview = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: 'overview'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickOnCallSchedules = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: 'onCallSchedules'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickReports = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: 'reports'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const COMMUNICATIONS_STAKEHOLDERS_HREF = '/jira/communications/stakeholders';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleOnExpansionToggle,
        onSystemToggle: onSystemToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations",
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kG8Ic.ActionButtons), null),
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: overviewIcon,
        href: "/jira/ops/overview",
        menuId: (0, $h4Bzb.MENU_ID_OPS_OVERVIEW),
        onClick: onClickOverview
    }, overviewMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: (0, $h4Bzb.MENU_ID_OPS_ALERTS)
    }, alertsChildren), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: oncallSchedulesIcon,
        href: "/jira/ops/who-is-on-call",
        menuId: (0, $h4Bzb.MENU_ID_OPS_ON_CALL),
        onClick: onClickOnCallSchedules
    }, oncallSchedulesMessage), showStatuspageMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: statusPageIcon,
        href: "/jira/communications/status-page",
        menuId: (0, $h4Bzb.MENU_ID_OPS_STATUS_PAGES)
    }, statusPageMessage), showCommunicationsMenu && (0, $4cTDP.fg)('communications_stakeholder_management_platform') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hbHml.CommsChangeboarding), {
        href: COMMUNICATIONS_STAKEHOLDERS_HREF,
        isExpanded: isOpsMenuExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: communicationsIcon,
        href: COMMUNICATIONS_STAKEHOLDERS_HREF,
        menuId: (0, $h4Bzb.MENU_ID_COMMUNICATIONS_STAKEHOLDERS)
    }, communicationsMessage)), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: reportsIcon,
        href: "/jira/ops/reports",
        menuId: (0, $h4Bzb.MENU_ID_OPS_REPORTS),
        onClick: onClickReports
    }, reportsMessage)));
}

});
parcelRegister("5FM0W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b2a78f47edf75d1e9e196917ee7866>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $421606ae12ca393c$var$_react = $421606ae12ca393c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $421606ae12ca393c$var$_baseNew = $421606ae12ca393c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $421606ae12ca393c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $421606ae12ca393c$var$AlertIcon = (props)=>/*#__PURE__*/ $421606ae12ca393c$var$_react.default.createElement($421606ae12ca393c$var$_baseNew.default, Object.assign({
        name: "AlertIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$421606ae12ca393c$var$AlertIcon.displayName = 'AlertIcon';
var $421606ae12ca393c$var$_default = module.exports.default = $421606ae12ca393c$var$AlertIcon;

});

parcelRegister("dicM4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2735c0e48e5c90288be2a1ef4fa17962>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ad6dd83db7a6e1b$var$_react = $9ad6dd83db7a6e1b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9ad6dd83db7a6e1b$var$_baseNew = $9ad6dd83db7a6e1b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9ad6dd83db7a6e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pulse".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: work health in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ad6dd83db7a6e1b$var$PulseIcon = (props)=>/*#__PURE__*/ $9ad6dd83db7a6e1b$var$_react.default.createElement($9ad6dd83db7a6e1b$var$_baseNew.default, Object.assign({
        name: "PulseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 1a.75.75 0 0 1 .722.548l2.778 9.92 1.028-3.67a.75.75 0 0 1 .722-.548H16v1.5h-3.931l-1.597 5.702a.75.75 0 0 1-1.444 0L6.25 4.532l-1.028 3.67a.75.75 0 0 1-.722.548H0v-1.5h3.931l1.597-5.702A.75.75 0 0 1 6.25 1" clip-rule="evenodd"/>`
    }, props));
$9ad6dd83db7a6e1b$var$PulseIcon.displayName = 'PulseIcon';
var $9ad6dd83db7a6e1b$var$_default = module.exports.default = $9ad6dd83db7a6e1b$var$PulseIcon;

});

parcelRegister("gDKBr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33181fb6c3dda951a22e3b4873cc95fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1d470387d991694$var$_react = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c1d470387d991694$var$_baseNew = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c1d470387d991694$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1d470387d991694$var$CommentIcon = (props)=>/*#__PURE__*/ $c1d470387d991694$var$_react.default.createElement($c1d470387d991694$var$_baseNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$c1d470387d991694$var$CommentIcon.displayName = 'CommentIcon';
var $c1d470387d991694$var$_default = module.exports.default = $c1d470387d991694$var$CommentIcon;

});

parcelRegister("9ltyu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9acd068702a8548119ebbf83b3a4add1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cdd0049fbd6c80a$var$_react = $6cdd0049fbd6c80a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6cdd0049fbd6c80a$var$_baseNew = $6cdd0049fbd6c80a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6cdd0049fbd6c80a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6cdd0049fbd6c80a$var$PhoneIcon = (props)=>/*#__PURE__*/ $6cdd0049fbd6c80a$var$_react.default.createElement($6cdd0049fbd6c80a$var$_baseNew.default, Object.assign({
        name: "PhoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$6cdd0049fbd6c80a$var$PhoneIcon.displayName = 'PhoneIcon';
var $6cdd0049fbd6c80a$var$_default = module.exports.default = $6cdd0049fbd6c80a$var$PhoneIcon;

});

parcelRegister("jn07M", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRoute", () => $b4a1382b4bc0e083$export$29721341dde2ed3d);
const $b4a1382b4bc0e083$export$29721341dde2ed3d = {
    name: 'eoc-global-alerts',
    path: '/jira/ops/alerts',
    exact: true
};

});

parcelRegister("igYXn", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertDetailRoute", () => $8561130b2d4adb16$export$ac102dc13a0f4aff);
const $8561130b2d4adb16$export$ac102dc13a0f4aff = {
    name: 'eoc-team-alert-detail',
    path: '/jira/ops/teams/:teamId/alerts/:id',
    exact: true
};

});

parcelRegister("1Cl4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $f32e43648f7339d4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f32e43648f7339d4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    alerts: {
        "id": "navigation-apps-sidebar-nav4-operations.alerts",
        "defaultMessage": "Alerts"
    }
});

});

parcelRegister("73hOC", function(module, exports) {
$parcel$export(module.exports, "useFeatures", () => $0a2af14ce88ae59f$export$4a39035bacc4ed76);

var $dBQvm = parcelRequire("dBQvm");

var $gDXSd = parcelRequire("gDXSd");


var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");

var $kAwwe = parcelRequire("kAwwe");

var $8rGQ0 = parcelRequire("8rGQ0");

var $1Ru5V = parcelRequire("1Ru5V");

var $4cTDP = parcelRequire("4cTDP");

var $bEiQD = parcelRequire("bEiQD");

var $koAZ4 = parcelRequire("koAZ4");

var $7pw1V = parcelRequire("7pw1V");
const $0a2af14ce88ae59f$export$4a39035bacc4ed76 = ()=>{
    const { isByokCustomer: isByokCustomer } = (0, $dBQvm.useByokComplianceSettingWithInitialisation)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const { isOrgAdmin: isOrgAdmin } = (0, $bEiQD.useIsOrgAdmin)();
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const { shouldUseJSM: shouldUseJSM, loading: ogTenantInfoLoading, isOpsAdmin: isOpsAdmin } = (0, $gDXSd.useOgTenantInfo)();
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const hasReports = !ogTenantInfoLoading && (isSiteAdmin || isAdmin) && !isByokCustomer && shouldUseJSM && !!licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $cblKs.FREE_EDITION) && !((0, $4cTDP.fg)('hide_reports_for_oasis') && (0, $7pw1V.isIsolatedCloud)());
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    // Check if user has premium edition
    const isPremium = appEditions?.serviceDesk === (0, $cblKs.PREMIUM_EDITION);
    // Check if user has specific product license
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    const isAdminUser = isOrgAdmin || isAdmin || isOpsAdmin;
    const showCommunicationsMenu = isAdminUser && isPremium && isJSMUser && (0, $4cTDP.fg)('communications_stakeholder_management_platform');
    const showStatuspageMenu = isAdminUser && isPremium && isJSMUser && (0, $4cTDP.fg)('communications_status_page_manage_platform');
    return {
        hasReports: hasReports,
        showCommunicationsMenu: showCommunicationsMenu,
        showStatuspageMenu: showStatuspageMenu
    };
};

});
parcelRegister("gDXSd", function(module, exports) {
$parcel$export(module.exports, "useOgTenantInfo", () => $e758b04b403662eb$export$990ea9ff15ca04f7);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $4VIcO = parcelRequire("4VIcO");

var $6PAED = parcelRequire("6PAED");

var $eJrcF = parcelRequire("eJrcF");

var $dI30d = parcelRequire("dI30d");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $e758b04b403662eb$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    // It is important that this ff should stop any new behaviour except for
    // safe hook calls. That's why we only do very minimal stuff here.
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh
    ]);
};
const $e758b04b403662eb$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $eJrcF.useResource)((0, $4VIcO.getConsolidationStateResource)());
    const applicationPermissions = (0, $6PAED.useApplicationPermissions)();
    $e758b04b403662eb$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    if (// TODO: Remove this check after the feature flag is removed
    // The refresh is handled in useConsolidationStateResourceRefresh
    // and this one is only for the old behaviour.
    !(0, $4cTDP.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $dI30d.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $dI30d.checkIsConsolidated)(tenantInfoResource.data),
        isOpsAdmin: (0, $4cTDP.fg)('operations-tenant-info-endpoint-update') && (0, $dI30d.checkIsOpsAdmin)(tenantInfoResource.data),
        isTransitioning: (0, $dI30d.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $dI30d.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: applicationPermissions.hasServiceDeskAccess && (0, $dI30d.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: applicationPermissions.hasServiceDeskAccess && (0, $dI30d.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});

parcelRegister("bEiQD", function(module, exports) {
$parcel$export(module.exports, "useIsOrgAdmin", () => $0e2a7c03acc2874b$export$8ed42372757d8b2a);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $eLqdN = parcelRequire("eLqdN");

var $3ugTQ = parcelRequire("3ugTQ");

var $g9Vr6 = parcelRequire("g9Vr6");

var $e6YEs = parcelRequire("e6YEs");
const $0e2a7c03acc2874b$var$getUserOrgPermissions = async ({ orgId: orgId, userId: userId })=>(0, $3ugTQ.performPostRequest)('/gateway/api/permissions/permitted', {
        body: JSON.stringify({
            resourceId: `ari:cloud:platform::org/${orgId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage-users'
        })
    }).then((resp)=>!!resp?.permitted);
const $0e2a7c03acc2874b$export$8ed42372757d8b2a = ()=>{
    const userId = (0, $e6YEs.useAccountId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const checkUserIsOrgAdmin = (0, $eJOHy.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        return $0e2a7c03acc2874b$var$getUserOrgPermissions({
            orgId: orgId,
            userId: userId
        });
    }, [
        orgId,
        userId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchIsOrgAdmin } = (0, $eLqdN.useService)(checkUserIsOrgAdmin, {
        data: false
    });
    (0, $eJOHy.useEffect)(()=>{
        fetchIsOrgAdmin();
    }, [
        fetchIsOrgAdmin
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'checkUserIsOrgAdmin',
                packageName: 'jiraBusinessGoalPicker',
                teamName: 'jira-yurree'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: error
        });
    }, [
        error
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error,
        retry: fetchIsOrgAdmin
    };
};

});


parcelRegister("5rZKK", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbeef9b012ab94c7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bbeef9b012ab94c7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    overview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.overview",
        "defaultMessage": "Overview"
    },
    alerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts",
        "defaultMessage": "Alerts"
    },
    onCallSchedules: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.on-call-schedules",
        "defaultMessage": "On-call schedules"
    },
    generalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.general-configuration",
        "defaultMessage": "General configuration"
    },
    reports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.reports",
        "defaultMessage": "Reports"
    },
    defaultFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
        "defaultMessage": "Default filters"
    },
    sharedWithMe: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.shared-with-me",
        "defaultMessage": "Shared with me"
    },
    createdByMe: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.created-by-me",
        "defaultMessage": "Created by me"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.starred",
        "defaultMessage": "Starred"
    },
    allAlerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-alerts",
        "defaultMessage": "All alerts"
    },
    myAlerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.my-alerts",
        "defaultMessage": "My alerts"
    },
    viewAllFiltersPopupMenuButtonText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-popup-menu-button-text",
        "defaultMessage": "View all"
    },
    viewAllFiltersSearchPlaceholder: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-search-placeholder",
        "defaultMessage": "Search"
    },
    viewAllFiltersNoResultsFoundText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-no-results-found-text",
        "defaultMessage": "No search results found"
    },
    allSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-search",
        "defaultMessage": "All"
    },
    openSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.open-search",
        "defaultMessage": "Open"
    },
    closedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.closed-search",
        "defaultMessage": "Closed"
    },
    unackedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.unacked-search",
        "defaultMessage": "Unacknowledged"
    },
    notSeenSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.not-seen-search",
        "defaultMessage": "Not seen"
    },
    assignedToMeSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.assigned-to-me-search",
        "defaultMessage": "Assigned to me"
    },
    statusPages: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.status-pages",
        "defaultMessage": "Status pages"
    },
    communications: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.communications",
        "defaultMessage": "Communications"
    }
});

});

parcelRegister("hbHml", function(module, exports) {
$parcel$export(module.exports, "CommsChangeboarding", () => $6ccb06bf03cf70e3$export$b3c50367aac12931);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $5Fxkp = parcelRequire("5Fxkp");
var $gPZYl = parcelRequire("gPZYl");
var $lpA3D = parcelRequire("lpA3D");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $8wyVH = parcelRequire("8wyVH");

var $6zhpo = parcelRequire("6zhpo");

var $kfvK2 = parcelRequire("kfvK2");
var $83DiZ = parcelRequire("83DiZ");

var $kDaaB = parcelRequire("kDaaB");

var $9cody = parcelRequire("9cody");

var $kRgKj = parcelRequire("kRgKj");

var $3TVlS = parcelRequire("3TVlS");

var $dBEJB = parcelRequire("dBEJB");
const $6ccb06bf03cf70e3$var$styles = {
    spotlightTarget: "_19ith1jr _2rko12b0 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _t9ec1mld",
    spotlightContainer: "_kqswh2mm _152t1j0o",
    spotlightContent: "_2rko1qi0 _kqswstnw _1bsbvixp _ca0qpxbi _n3tdpxbi _bfhk1lri _16qs9g9j",
    spotlightContentHeader: "_19bvpxbi _u5f3pxbi",
    spotlightContentBody: "_bozgpxbi _y4tipxbi",
    spotlightContentFooter: "_bozgpxbi _y4tipxbi"
};
const $6ccb06bf03cf70e3$var$useCurrentPath = (0, $kfvK2.createRouterSelector)((state)=>state.location.pathname);
const $6ccb06bf03cf70e3$export$b3c50367aac12931 = ({ children: children, href: href, isExpanded: isExpanded })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const currentPath = $6ccb06bf03cf70e3$var$useCurrentPath();
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    const [{ isSeen: isSeen }, { markAsSeen: markAsSeen }] = (0, $9cody.useSeenStatus)({
        userPropertyKey: 'communications.stakeholder-management.changeboarding.commsTab.seenStatus',
        isSeenValue: true,
        packageName: 'stakeholder-management',
        teamName: 'iris'
    });
    const [{ isSeen: nextSpotlightSeen, isLoading: nextSpotlightSeenLoading }] = (0, $9cody.useSeenStatus)({
        userPropertyKey: 'communications.stakeholder-management.changeboarding.commsNav.seenStatus',
        isSeenValue: true,
        packageName: 'stakeholder-management',
        teamName: 'iris'
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!isSeen && !nextSpotlightSeen && !nextSpotlightSeenLoading && isExpanded && !currentPath.includes('/jira/communications/stakeholder')) setIsActive(true);
    }, [
        isSeen,
        isExpanded,
        currentPath,
        nextSpotlightSeen,
        nextSpotlightSeenLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPZYl.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lpA3D.PopoverTarget), null, isActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6ccb06bf03cf70e3$var$styles.spotlightTarget
    }, children) : children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Fxkp.PopoverContent), {
        placement: "right-end",
        isVisible: isActive,
        dismiss: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6ccb06bf03cf70e3$var$styles.spotlightContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        xcss: $6ccb06bf03cf70e3$var$styles.spotlightContent,
        direction: "column",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        xcss: $6ccb06bf03cf70e3$var$styles.spotlightContentHeader,
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "medium",
        weight: "bold",
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $dBEJB.messages).commsTabTourHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        onClick: (_, event)=>{
            (0, $kRgKj.fireUIAnalytics)(event, 'changeboardingStep1Dismissed');
            setIsActive(false);
            markAsSeen();
        },
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)"
            }),
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $dBEJB.messages).commsTabTourDismissIconLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3TVlS))),
        alt: "",
        width: 349,
        height: 140
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6ccb06bf03cf70e3$var$styles.spotlightContentBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "medium",
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $dBEJB.messages).commsTabTourBody))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "end",
        xcss: $6ccb06bf03cf70e3$var$styles.spotlightContentFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "discovery",
        spacing: "compact",
        onClick: (_, event)=>{
            (0, $kRgKj.fireUIAnalytics)(event, 'changeboardingStep1CTAClicked');
            setIsActive(false);
            markAsSeen();
            setTimeout(()=>{
                push(href);
            }, 0);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $dBEJB.messages).commsTabTourAction)))))));
};

});
parcelRegister("gPZYl", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $707de8145f4bb848$export$bf694c7c431c162a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6G5P1 = parcelRequire("6G5P1");

var $4GTf2 = parcelRequire("4GTf2");
const $707de8145f4bb848$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GTf2.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6G5P1.Manager), {
            children: children
        })
    });
};

});

parcelRegister("lpA3D", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $eb36d2314a063d4c$export$5ad0c0856b469f13);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $azjc1 = parcelRequire("azjc1");
const $eb36d2314a063d4c$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $azjc1.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};

});

parcelRegister("8wyVH", function(module, exports) {
$parcel$export(module.exports, "default", () => $43ef6b50fdd81ea8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDoP2 = parcelRequire("kDoP2");

var $58yRG = parcelRequire("58yRG");
const $43ef6b50fdd81ea8$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $43ef6b50fdd81ea8$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $eJOHy.useRef)(null);
    const providedColorMode = (0, $kDoP2.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $58yRG.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $eJOHy.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $hcewu.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("kDoP2", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $f201e3ae8b613c49$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $f201e3ae8b613c49$export$2e2bcd8739ae039);
/* theme-provider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $eGOwo = parcelRequire("eGOwo");

var $01wZP = parcelRequire("01wZP");
var $1athg = parcelRequire("1athg");
var $7y92E = parcelRequire("7y92E");
var $7I1UL = parcelRequire("7I1UL");
const $f201e3ae8b613c49$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    });
const $f201e3ae8b613c49$var$ColorModeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $f201e3ae8b613c49$var$SetColorModeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $f201e3ae8b613c49$var$ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $f201e3ae8b613c49$var$SetThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined); /**
                                                                                                  * __UNSAFE_useColorModeForMigration()__
                                                                                                  *
                                                                                                  * Returns the current color mode when inside the app provider.
                                                                                                  * Unlike useColorMode, this utility returns undefined, instead of throwing an error, when the app provider is missing.
                                                                                                  * This allows it to be used by components that need to operate with and without an app provider.
                                                                                                  */ 
function $f201e3ae8b613c49$export$ce91654eb9fea460() {
    const value = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$ColorModeContext);
    return value;
} /**
   * __useColorMode()__
   *
   * Returns the current color mode when inside the app provider.
   */ 
function $f201e3ae8b613c49$export$20f3076712c8dfa() {
    const value = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$ColorModeContext);
    const { colorMode: colorMode } = (0, $01wZP.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $eJOHy.useState)(colorMode || 'light');
    (0, $eJOHy.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $7I1UL.default)((theme)=>{
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $f201e3ae8b613c49$export$e2afe7397c3d11c7() {
    const value = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
} /**
   * __useTheme()__
   *
   * Returns the current theme settings when inside the app provider.
   */ 
function $f201e3ae8b613c49$export$93d4e7f90805808f() {
    const theme = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $eJOHy.useState)(theme || (0, $01wZP.default)());
    (0, $eJOHy.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $7I1UL.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
} /**
   * __useSetTheme()__
   *
   * Returns the theme setter when inside the app provider.
   */ 
function $f201e3ae8b613c49$export$501aa0dcd5527a48() {
    const value = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $f201e3ae8b613c49$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $f201e3ae8b613c49$var$prefersDarkModeMql = $f201e3ae8b613c49$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $f201e3ae8b613c49$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $f201e3ae8b613c49$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $f201e3ae8b613c49$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $f201e3ae8b613c49$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $eJOHy.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $eJOHy.useState)($f201e3ae8b613c49$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $eJOHy.useState)(()=>({
            ...$f201e3ae8b613c49$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $eJOHy.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($f201e3ae8b613c49$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $eJOHy.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        // If fg enabled avoid mounting themes
        if ((0, $eGOwo.fg)('platform-static-theme-loading')) return;
         /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ 
        const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $7y92E.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!$f201e3ae8b613c49$var$prefersDarkModeMql) return;
        const unbindListener = (0, $4eDgu.bind)($f201e3ae8b613c49$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = (0, $1athg.default)({
        ...theme,
        colorMode: reconciledColorMode
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f201e3ae8b613c49$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f201e3ae8b613c49$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($f201e3ae8b613c49$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($f201e3ae8b613c49$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: (0, $eGOwo.fg)('platform-static-theme-loading') ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        "data-theme": attrs['data-theme'],
                        "data-color-mode": attrs['data-color-mode'],
                        className: (0, $hcewu.default)([
                            $f201e3ae8b613c49$var$contentStyles.body
                        ]),
                        children: children
                    }) : children
                })
            })
        })
    });
}
var $f201e3ae8b613c49$export$2e2bcd8739ae039 = $f201e3ae8b613c49$var$ThemeProvider;

});


parcelRegister("9cody", function(module, exports) {
$parcel$export(module.exports, "useSeenStatus", () => $dc9f3e2c8caae723$export$12667e37571b0a02);

var $eJOHy = parcelRequire("eJOHy");


var $FppkK = parcelRequire("FppkK");

var $9pTd3 = parcelRequire("9pTd3");

var $14RSn = parcelRequire("14RSn");

var $dMM78 = parcelRequire("dMM78");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $koAZ4 = parcelRequire("koAZ4");
const $dc9f3e2c8caae723$var$initialState = {
    isSeen: true,
    isLoading: false,
    error: undefined
};
const $dc9f3e2c8caae723$export$f7ab30339d40bcd = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true';
const $dc9f3e2c8caae723$export$12667e37571b0a02 = ({ userPropertyKey: userPropertyKey, isSeenValue: isSeenValue, packageName: packageName, teamName: teamName, skipOnboarding: skipOnboarding })=>{
    const [state, setState] = (0, $eJOHy.useState)($dc9f3e2c8caae723$var$initialState);
    const { atlassianAccountId: accountId } = (0, $koAZ4.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const reportErrorDeps = (0, $eJOHy.useRef)({
        packageName: packageName,
        teamName: teamName
    });
    reportErrorDeps.current = {
        packageName: packageName,
        teamName: teamName
    };
    const reportError = (0, $eJOHy.useCallback)((errorId, error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: errorId,
                ...reportErrorDeps.current
            },
            error: error,
            attributes: {
                isClientFetchError: (0, $dMM78.isClientFetchError)(error)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (accountId && !$dc9f3e2c8caae723$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isLoading: true
                }));
            (0, $FppkK.getUserProperty)(accountId, userPropertyKey).catch((error)=>{
                if (error.statusCode === (0, $3a153a61cf6b691b$export$8bca792d963eb0ef)) // user property has not been set
                return false;
                throw error;
            }).then((value)=>{
                setState((oldState)=>({
                        ...oldState,
                        isSeen: value === isSeenValue,
                        isLoading: false
                    }));
                (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.fetchStatus succeeded', {
                    userPropertyKey: userPropertyKey
                });
            }).catch((error)=>{
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.fetchStatus', error);
            });
        }
    }, [
        userPropertyKey,
        accountId,
        isSeenValue,
        reportError,
        createAnalyticsEvent,
        skipOnboarding
    ]);
    const markAsSeen = (0, $eJOHy.useCallback)(()=>{
        if (accountId && !$dc9f3e2c8caae723$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isSeen: true,
                    isLoading: true
                }));
            (0, $FppkK.setUserProperties)(accountId, userPropertyKey, JSON.stringify(isSeenValue)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $14RSn.default)(res.status, errResp);
                });
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false
                    }));
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.markAsSeen succeeded', {
                    userPropertyKey: userPropertyKey
                });
                return Promise.resolve();
            }).catch((error)=>{
                // leave `isSeen` as true. we don't want to block the user
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.markAsSeen', error);
            });
        }
    }, [
        accountId,
        userPropertyKey,
        isSeenValue,
        createAnalyticsEvent,
        reportError,
        skipOnboarding
    ]);
    return [
        state,
        {
            markAsSeen: markAsSeen
        }
    ];
};

});

parcelRegister("3TVlS", function(module, exports) {
module.exports = new URL("stakeholders.9ba74311.svg", import.meta.url).toString();

});

parcelRegister("dBEJB", function(module, exports) {
$parcel$export(module.exports, "messages", () => $442d1b6a6d6de369$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $442d1b6a6d6de369$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    commsTabTourHeading: {
        "id": "communications-stakeholders.changeboarding.commsTabTour.heading",
        "defaultMessage": "You can now manage your incident communications directly from your site."
    },
    commsTabTourBody: {
        "id": "communications-stakeholders.changeboarding.commsTabTour.body",
        "defaultMessage": "For any incident or maintenance, keep your stakeholders in the loop during every milestone to build lasting trust."
    },
    commsTabTourAction: {
        "id": "communications-stakeholders.changeboarding.commsTabTour.action",
        "defaultMessage": "Next"
    },
    commsTabTourDismissIconLabel: {
        "id": "communications-stakeholders.changeboarding.commsTabTour.dismissIconLabel",
        "defaultMessage": "Close"
    },
    commsTabTourMediaAltText: {
        "id": "communications-stakeholders.changeboarding.commsTabTour.mediaAltText",
        "defaultMessage": "Communications"
    }
});

});


parcelRegister("kG8Ic", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $df8b828fd54e6f26$export$88c65d2d98aab183);
$parcel$export(module.exports, "PopoutToggleButton", () => $df8b828fd54e6f26$export$a9edf85e3b30c33a);

var $eJOHy = parcelRequire("eJOHy");

var $4F5bb = parcelRequire("4F5bb");

var $f58rc = parcelRequire("f58rc");
var $6YEko = parcelRequire("6YEko");

var $k71qx = parcelRequire("k71qx");

var $Ay1uj = parcelRequire("Ay1uj");

var $gDXSd = parcelRequire("gDXSd");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");





var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $koAZ4 = parcelRequire("koAZ4");

var $kfvK2 = parcelRequire("kfvK2");

var $6naEG = parcelRequire("6naEG");

var $5DCnD = parcelRequire("5DCnD");

var $8rgh1 = parcelRequire("8rgh1");

var $ih7sC = parcelRequire("ih7sC");
function $df8b828fd54e6f26$export$88c65d2d98aab183({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: $df8b828fd54e6f26$var$MoreMenuItems,
        onClose: onClose
    });
}
function $df8b828fd54e6f26$var$MoreMenuItems({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)((event)=>{
        onClose?.(event);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                itemId: 'generalConfiguration',
                parentItemId: (0, $a9aec.SECTION_ITEM_OPERATIONS)
            }
        });
    });
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { isOpsAdmin: isOpsAdmin } = (0, $gDXSd.useOgTenantInfo)();
    const shouldShowGeneralConfiguration = (0, $4cTDP.fg)('operations-tenant-info-endpoint-update') ? (tenantContext.isAdmin || isOpsAdmin) && tenantContext.licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] : tenantContext.isAdmin && tenantContext.licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldShowGeneralConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/jira/settings/products/ops/jira-service-management-audit-logs",
        onClick: onCloseWithStopPropagation
    }, formatMessage((0, $8rgh1.default).generalConfiguration))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).OPERATIONS,
        hasSeparator: shouldShowGeneralConfiguration
    }));
}
const $df8b828fd54e6f26$var$usePath = (0, $kfvK2.createRouterSelector)((state)=>`${state.location.pathname}${state.location.search}`);
const $df8b828fd54e6f26$export$a9edf85e3b30c33a = ({ onClick: onClick })=>{
    const { state: { lastVisitedSearch: lastVisitedSearch }, togglePoppedOut: togglePoppedOut } = (0, $ih7sC.useAlertsPopoutStore)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const path = $df8b828fd54e6f26$var$usePath();
    const handleToggle = (_, analyticsEvent)=>{
        onClick?.();
        if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) {
            togglePoppedOut(path);
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'jsmOperationsAlertsPopoutButtonToggle', {
                isPoppedOut: lastVisitedSearch
            });
        }
    };
    const iconButtonLabel = lastVisitedSearch ? formatMessage((0, $8rgh1.default).popInLabel) : formatMessage((0, $8rgh1.default).popOutLabel);
    const tooltipContent = lastVisitedSearch ? formatMessage((0, $8rgh1.default).popInTooltip) : formatMessage((0, $8rgh1.default).popOutTooltip);
    const Icon = lastVisitedSearch ? (0, $5DCnD.PopinIcon) : (0, $5DCnD.PopoutIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            ...tooltipProps,
            label: iconButtonLabel,
            onClick: handleToggle,
            icon: Icon,
            spacing: "compact",
            appearance: "subtle"
        }));
};

});
parcelRegister("5DCnD", function(module, exports) {
$parcel$export(module.exports, "PopoutIcon", () => $93c1416fae8a9416$export$a837275bb5fcc92e);
$parcel$export(module.exports, "PopinIcon", () => $93c1416fae8a9416$export$5b106f296c88ef0);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $5Wzyf = parcelRequire("5Wzyf");

var $LgntM = parcelRequire("LgntM");

var $lRq8t = parcelRequire("lRq8t");

var $bJscI = parcelRequire("bJscI");

var $5O9Jh = parcelRequire("5O9Jh");
const $93c1416fae8a9416$var$PoputGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 4L19.25 4C19.4489 4 19.6397 4.07902 19.7803 4.21967C19.921 4.36032 20 4.55109 20 4.75V9H18.5V6.56066L15.0303 10.0303L13.9697 8.96967L17.4393 5.5L15 5.5V4ZM7 7.5C6.72386 7.5 6.5 7.72386 6.5 8L6.5 10.5H11.5C12.6046 10.5 13.5 11.3954 13.5 12.5L13.5 17.5H16C16.2761 17.5 16.5 17.2761 16.5 17V12H18V17C18 18.1046 17.1046 19 16 19H12.7512C12.7508 19 12.7504 19 12.75 19L7 19C5.89543 19 5 18.1046 5 17L5 11.25C5 11.2498 5 11.2497 5 11.2495L5 8C5 6.89543 5.89543 6 7 6L12 6V7.5L7 7.5ZM7 17.5L12 17.5L12 12.5C12 12.2239 11.7761 12 11.5 12H6.5L6.5 17C6.5 17.2761 6.72386 17.5 7 17.5Z"
    }));
const $93c1416fae8a9416$var$PopinGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 4L18 4C19.1046 4 20 4.89543 20 6V10C20 11.1046 19.1046 12 18 12H14C13.7229 12 13.4589 11.9436 13.2189 11.8417L11.0607 14H13.5V15.5H9.25C8.83579 15.5 8.5 15.1642 8.5 14.75L8.5 10.5H10L10 12.9393L12.1583 10.7811C12.0564 10.5411 12 10.2771 12 10V6C12 4.89543 12.8954 4 14 4ZM18 5.5L14 5.5C13.7239 5.5 13.5 5.72386 13.5 6V10C13.5 10.2761 13.7239 10.5 14 10.5H18C18.2761 10.5 18.5 10.2761 18.5 10V6C18.5 5.72386 18.2761 5.5 18 5.5ZM7 6L10 6V7.5H7C6.72386 7.5 6.5 7.72386 6.5 8L6.5 17C6.5 17.2761 6.72386 17.5 7 17.5L16 17.5C16.2761 17.5 16.5 17.2761 16.5 17V14H18V17C18 18.1046 17.1046 19 16 19L7 19C5.89543 19 5 18.1046 5 17L5 8C5 6.89543 5.89543 6 7 6Z"
    }));
const $93c1416fae8a9416$export$ba4eb6cb12faf707 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $93c1416fae8a9416$var$PoputGlyph,
        label: formatMessage((0, $5O9Jh.messages).popoutIconLabel)
    });
};
const $93c1416fae8a9416$export$b04417c4d71d95a1 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $93c1416fae8a9416$var$PopinGlyph,
        label: formatMessage((0, $5O9Jh.messages).popinIconLabel)
    });
};
const $93c1416fae8a9416$export$a837275bb5fcc92e = (0, $bJscI.componentWithFG)('enghealth-custom-icon-migration', (0, (/*@__PURE__*/$parcel$interopDefault($5Wzyf))), $93c1416fae8a9416$export$ba4eb6cb12faf707);
const $93c1416fae8a9416$export$5b106f296c88ef0 = (0, $bJscI.componentWithFG)('enghealth-custom-icon-migration', (0, (/*@__PURE__*/$parcel$interopDefault($LgntM))), $93c1416fae8a9416$export$b04417c4d71d95a1);

});
parcelRegister("5Wzyf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f508a55979f5b8821e6c17d66c185d99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $453df24ec8fd960c$var$_react = $453df24ec8fd960c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $453df24ec8fd960c$var$_baseNew = $453df24ec8fd960c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $453df24ec8fd960c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QueuePopOut".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for JSM queue navigation to pop out from sidebar
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $453df24ec8fd960c$var$QueuePopOutIcon = (props)=>/*#__PURE__*/ $453df24ec8fd960c$var$_react.default.createElement($453df24ec8fd960c$var$_baseNew.default, Object.assign({
        name: "QueuePopOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h8.5a2 2 0 0 0 2-2V8H12v5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4.5A.5.5 0 0 1 3 4h5V2.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M15 6V1.75a.75.75 0 0 0-.75-.75H10v1.5h2.44L8.97 5.97l1.06 1.06 3.47-3.47V6zM7.5 9v5.25H9V9a2 2 0 0 0-2-2H1.75v1.5H7a.5.5 0 0 1 .5.5" clip-rule="evenodd"/>`
    }, props));
$453df24ec8fd960c$var$QueuePopOutIcon.displayName = 'QueuePopOutIcon';
var $453df24ec8fd960c$var$_default = module.exports.default = $453df24ec8fd960c$var$QueuePopOutIcon;

});

parcelRegister("LgntM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6de731c9e0a863b435735dbe9bec18dc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08e1182bcfb49742$var$_react = $08e1182bcfb49742$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $08e1182bcfb49742$var$_baseNew = $08e1182bcfb49742$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $08e1182bcfb49742$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QueuePopIn".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for JSM queue navigation to move back to sidebar
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08e1182bcfb49742$var$QueuePopInIcon = (props)=>/*#__PURE__*/ $08e1182bcfb49742$var$_react.default.createElement($08e1182bcfb49742$var$_baseNew.default, Object.assign({
        name: "QueuePopInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h8.5a2 2 0 0 0 2-2v-2.75H12V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4.5A.5.5 0 0 1 3 4h3V2.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M6 8.94V6.5H4.5v4.25a.75.75 0 0 0 .75.75H9.5V10H7.06l2.22-2.22-1.06-1.06z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14 8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2zm.5-2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5z" clip-rule="evenodd"/>`
    }, props));
$08e1182bcfb49742$var$QueuePopInIcon.displayName = 'QueuePopInIcon';
var $08e1182bcfb49742$var$_default = module.exports.default = $08e1182bcfb49742$var$QueuePopInIcon;

});

parcelRegister("5O9Jh", function(module, exports) {
$parcel$export(module.exports, "messages", () => $372ba0bd810eef72$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $372ba0bd810eef72$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    popoutIconLabel: {
        "id": "servicedesk-queues-nav4.common.popout-toggle-button.icons.popout-icon-label",
        "defaultMessage": "Pop out icon"
    },
    popinIconLabel: {
        "id": "servicedesk-queues-nav4.common.popout-toggle-button.icons.popin-icon-label",
        "defaultMessage": "Pop in icon"
    }
});

});


parcelRegister("8rgh1", function(module, exports) {
$parcel$export(module.exports, "default", () => $18062289ae5e8932$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $18062289ae5e8932$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    generalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.general-configuration",
        "defaultMessage": "General configuration"
    },
    popOutLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-label",
        "defaultMessage": "Pop out operations alert searches"
    },
    popOutTooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-tooltip",
        "defaultMessage": "Pop out from sidebar"
    },
    popInLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-label",
        "defaultMessage": "Pop in operations alert searches"
    },
    popInTooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-tooltip",
        "defaultMessage": "Move back to sidebar"
    }
});

});

parcelRegister("ih7sC", function(module, exports) {
$parcel$export(module.exports, "AlertsPopoutStoreContainer", () => $a7d00ec95bd37dbc$export$c37792f744809959);
$parcel$export(module.exports, "useAlertsPopoutStore", () => $a7d00ec95bd37dbc$export$f89494880a713101);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $3hRxq = parcelRequire("3hRxq");
const $a7d00ec95bd37dbc$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH = 'jira-ops-alert-filters-last-visited-search';
const $a7d00ec95bd37dbc$var$localStorageProvider = (0, $3hRxq.createLocalStorageProvider)('alert_filters_popout');
const $a7d00ec95bd37dbc$var$setAlertFiltersLastVisitedInLocalStorage = (value)=>{
    try {
        $a7d00ec95bd37dbc$var$localStorageProvider.set($a7d00ec95bd37dbc$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH, value);
    } catch (_) {
        return false;
    }
    return true;
};
const $a7d00ec95bd37dbc$var$getAlertFiltersLastVisitedFromLocalStorage = ()=>{
    let item;
    try {
        item = $a7d00ec95bd37dbc$var$localStorageProvider.get($a7d00ec95bd37dbc$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH);
    } catch (_) {
        return undefined;
    }
    return item;
};
const $a7d00ec95bd37dbc$var$getOnInit = ()=>{
    return {
        lastVisitedSearch: $a7d00ec95bd37dbc$var$getAlertFiltersLastVisitedFromLocalStorage()
    };
};
const $a7d00ec95bd37dbc$var$actions = {
    setLastVisitedSearch: (value)=>({ getState: getState, setState: setState })=>{
            if (getState().lastVisitedSearch) {
                setState({
                    ...getState(),
                    lastVisitedSearch: value
                });
                $a7d00ec95bd37dbc$var$setAlertFiltersLastVisitedInLocalStorage(value);
            }
        },
    togglePoppedOut: (value)=>({ getState: getState, setState: setState })=>{
            if (!getState().lastVisitedSearch) {
                setState({
                    ...getState(),
                    lastVisitedSearch: value
                });
                $a7d00ec95bd37dbc$var$setAlertFiltersLastVisitedInLocalStorage(value);
            } else {
                setState({
                    ...getState(),
                    lastVisitedSearch: null
                });
                $a7d00ec95bd37dbc$var$setAlertFiltersLastVisitedInLocalStorage(null);
            }
        },
    syncLastVisitedSearch: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                lastVisitedSearch: $a7d00ec95bd37dbc$var$getAlertFiltersLastVisitedFromLocalStorage()
            });
        },
    setContent: (content)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                content: content
            });
        }
};
const $a7d00ec95bd37dbc$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        content: null,
        lastVisitedSearch: ' '
    },
    actions: $a7d00ec95bd37dbc$var$actions,
    name: 'AlertsPopoutStore'
});
const $a7d00ec95bd37dbc$export$c37792f744809959 = (0, $6E16M.createContainer)($a7d00ec95bd37dbc$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState($a7d00ec95bd37dbc$var$getOnInit());
        }
});
const $a7d00ec95bd37dbc$var$useHook = (0, $iJq0l.createHook)($a7d00ec95bd37dbc$var$Store);
const $a7d00ec95bd37dbc$export$f89494880a713101 = ()=>{
    const [state, hookActions] = $a7d00ec95bd37dbc$var$useHook();
    return {
        state: state,
        ...hookActions
    };
};

});




parcelRegister("iUGpu", function(module, exports) {
$parcel$export(module.exports, "OperationsMenuForLanding", () => $413ecd110b26d409$export$b37dd5cf3b893940);

var $emr2v = parcelRequire("emr2v");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $4EKqI = parcelRequire("4EKqI");

var $f5a85 = parcelRequire("f5a85");

var $5JDqh = parcelRequire("5JDqh");

var $dzn9I = parcelRequire("dzn9I");

var $ih7sC = parcelRequire("ih7sC");
const $413ecd110b26d409$export$b37dd5cf3b893940 = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $emr2v.default), queryRef);
    const { state: { lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $ih7sC.useAlertsPopoutStore)();
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('operations_nav4_remaining_items') ? lastVisitedSearch : false) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5a85.AlertsMenuItemContent), {
            queryRef: data
        }));
        if (!(0, $4cTDP.fg)('operations_nav4_remaining_items')) return ()=>{
            setContent(null);
        };
    }, [
        data,
        lastVisitedSearch,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-operations-trigger-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5JDqh.OperationsExpandableMenuItem), {
        isExpanded: isExpanded,
        AlertsMenuItemContent: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
            name: "nav4-sidebar-operations-expanded-items"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzn9I.AlertsMenuItemContentNew), {
            queryRef: data
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5a85.AlertsMenuItemContent), {
            queryRef: data
        })
    }));
};

});
parcelRegister("emr2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $411580bc907501fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4581c0468a5d4ef30519c5609a70ff06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $411580bc907501fc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "OperationsMenuForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContentNew"
        },
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContent"
        }
    ],
    "type": "Query"
};
$411580bc907501fc$var$node.hash = "539a9dffb7945e99bc6a650607eca8e4";
var $411580bc907501fc$export$2e2bcd8739ae039 = $411580bc907501fc$var$node;

});

parcelRegister("f5a85", function(module, exports) {
$parcel$export(module.exports, "AlertsMenuItemContent", () => $83e5ea77dd60932b$export$fcbb0679bb6c6da1);

var $bwwrE = parcelRequire("bwwrE");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bjI3S = parcelRequire("bjI3S");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $4cTDP = parcelRequire("4cTDP");

var $dZe0G = parcelRequire("dZe0G");

var $lRq8t = parcelRequire("lRq8t");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $aLENQ = parcelRequire("aLENQ");

var $dpxw4 = parcelRequire("dpxw4");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $2QH3X = parcelRequire("2QH3X");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $4EKqI = parcelRequire("4EKqI");

var $95O7y = parcelRequire("95O7y");

var $c6ZDX = parcelRequire("c6ZDX");

var $1Cl4r = parcelRequire("1Cl4r");

var $5rZKK = parcelRequire("5rZKK");

var $ih7sC = parcelRequire("ih7sC");

var $3y8cO = parcelRequire("3y8cO");
function $83e5ea77dd60932b$export$fcbb0679bb6c6da1({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $bwwrE.default), queryRef);
    const [selectedFilter, setSelectedFilter] = (0, $eJOHy.useState)('');
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data?.opsgenie?.savedSearches || {};
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $e6YEs.useAccountId)();
    const [savedSearchIdFromURL] = (0, $95O7y.useQueryParam)('filter');
    const [viewType] = (0, $95O7y.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $1Cl4r.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($bjI3S))));
    const { setLastVisitedSearch: setLastVisitedSearch } = (0, $ih7sC.useAlertsPopoutStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const defaultFilters = [
        {
            id: 'all',
            name: formatMessage((0, $5rZKK.default).allSearch),
            alertSearchQuery: ''
        },
        {
            id: 'open',
            name: formatMessage((0, $5rZKK.default).openSearch),
            alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_STATUS)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.STRING_LITERAL_STATUS_OPEN)}`
        },
        {
            id: 'closed',
            name: formatMessage((0, $5rZKK.default).closedSearch),
            alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_STATUS)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.STRING_LITERAL_STATUS_CLOSED)}`
        },
        {
            id: 'unacked',
            name: formatMessage((0, $5rZKK.default).unackedSearch),
            alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_STATUS)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.STRING_LITERAL_STATUS_OPEN)} ${(0, $dZe0G.LOGICAL_OPERATOR_AND)} ${(0, $dZe0G.IDENTIFIER_ACKNOWLEDGED)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'notSeen',
            name: formatMessage((0, $5rZKK.default).notSeenSearch),
            alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_IS_SEEN)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'assignedToMe',
            name: formatMessage((0, $5rZKK.default).assignedToMeSearch),
            alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_ASSIGNEE)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
        }
    ];
    const defaultFilterMenuIds = $83e5ea77dd60932b$var$getParentMenuId(defaultFilters);
    const sharedWithMeMenuIds = $83e5ea77dd60932b$var$getParentMenuId(sharedWithMe, savedSearchIdFromURL);
    const createdByMeMenuIds = $83e5ea77dd60932b$var$getParentMenuId(createdByMe, savedSearchIdFromURL);
    (0, $eJOHy.useEffect)(()=>{
        if (!isSelectedPath((0, $h4Bzb.MENU_ID_OPS_ALERTS)) && selectedFilter !== '') setSelectedFilter('');
    }, [
        isSelectedPath,
        selectedFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(defaultFilterMenuIds),
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-operations-alerts' : undefined
    }, formatMessage((0, $5rZKK.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, defaultFilters.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}${item.alertSearchQuery ? `&query=${item.alertSearchQuery}` : ''}`);
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                        level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name)))), sharedWithMe && sharedWithMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: sharedWithMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                    itemId: 'sharedWithMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(sharedWithMeMenuIds),
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-operations-alerts-shared-with-me' : undefined
    }, formatMessage((0, $5rZKK.default).sharedWithMe), sharedWithMe.some((filter)=>isSelectedPath(filter.alertSearchQuery))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, sharedWithMe.map((item)=>{
        if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) {
            const savedSearchId = item.id ? (0, $c6ZDX.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                key: item.id,
                elemBefore: pagesIcon,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`,
                menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter('');
                    if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`);
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            itemType: 'savedSearch',
                            parentItemId: 'sharedWithMe'
                        }
                    });
                }
            }, item.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            key: item.id,
            menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`);
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                        level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'sharedWithMe'
                    }
                });
            }
        }, item.name);
    }))), createdByMe && createdByMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: createdByMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                    itemId: 'createdByMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(createdByMeMenuIds)
    }, formatMessage((0, $5rZKK.default).createdByMe)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, createdByMe.map((item)=>{
        if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) {
            const savedSearchId = item.id ? (0, $c6ZDX.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                key: item.id,
                elemBefore: pagesIcon,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`,
                menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter('');
                    if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`);
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            itemType: 'savedSearch',
                            parentItemId: 'createdByMe'
                        }
                    });
                },
                actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y8cO.SavedSearchActionButtons), {
                    savedSearch: item
                })
            }, item.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            key: item.id,
            menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`);
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                        level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'createdByMe'
                    }
                });
            },
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y8cO.SavedSearchActionButtons), {
                savedSearch: item
            })
        }, item.name);
    }))));
}
function $83e5ea77dd60932b$var$getParentMenuId(arr, savedSearchId) {
    return (0, $aLENQ.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $4cTDP.fg)('operations_nav4_remaining_items') ? (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchId ? (0, $c6ZDX.OpsgenieSavedSearchAri).parse(i.id).savedSearchId : i.alertSearchQuery) : (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}

});
parcelRegister("bwwrE", function(module, exports) {
$parcel$export(module.exports, "default", () => $84745fac6227ed20$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d1bb40d3f14284ac71e150506c3a9894>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $84745fac6227ed20$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "alertSearchQuery"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.sharedWithMe"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "opsgenie.savedSearches.createdByMe"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "opsgenie.savedSearches"
                        }
                    ]
                },
                "action": "LOG",
                "path": "opsgenie"
            }
        ],
        "type": "Query"
    };
}();
$84745fac6227ed20$var$node.hash = "a105f985be669906c4ceff76a45b11bc";
var $84745fac6227ed20$export$2e2bcd8739ae039 = $84745fac6227ed20$var$node;

});

parcelRegister("bjI3S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48827792ad56aec1327e3c5557d624a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83d3a5bd1db8eee7$var$_react = $83d3a5bd1db8eee7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $83d3a5bd1db8eee7$var$_baseNew = $83d3a5bd1db8eee7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $83d3a5bd1db8eee7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83d3a5bd1db8eee7$var$PagesIcon = (props)=>/*#__PURE__*/ $83d3a5bd1db8eee7$var$_react.default.createElement($83d3a5bd1db8eee7$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$83d3a5bd1db8eee7$var$PagesIcon.displayName = 'PagesIcon';
var $83d3a5bd1db8eee7$var$_default = module.exports.default = $83d3a5bd1db8eee7$var$PagesIcon;

});

parcelRegister("dZe0G", function(module, exports) {
$parcel$export(module.exports, "TOKEN_TYPES", () => $d8d80d8186e8ae70$export$e92b897d610f2aba);
$parcel$export(module.exports, "LEFT_PARENTHESIS", () => $d8d80d8186e8ae70$export$9ce7f372949a1546);
$parcel$export(module.exports, "RIGHT_PARENTHESIS", () => $d8d80d8186e8ae70$export$bbbb3f477a9839e0);
$parcel$export(module.exports, "OPERATOR_EQUAL_TO", () => $d8d80d8186e8ae70$export$ea7497008076d6d2);
$parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", () => $d8d80d8186e8ae70$export$e75c84803c67e1f4);
$parcel$export(module.exports, "LOGICAL_OPERATOR_AND", () => $d8d80d8186e8ae70$export$61308b2610174a70);
$parcel$export(module.exports, "LOGICAL_OPERATOR_OR", () => $d8d80d8186e8ae70$export$1de654320eb3e523);
$parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", () => $d8d80d8186e8ae70$export$ff7eed6ac2251302);
$parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", () => $d8d80d8186e8ae70$export$4b436fec6f13b741);
$parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", () => $d8d80d8186e8ae70$export$8cbc171ac4843075);
$parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", () => $d8d80d8186e8ae70$export$347c7cb6285a1d61);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", () => $d8d80d8186e8ae70$export$910131ff5cd3d496);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", () => $d8d80d8186e8ae70$export$2aa0d26cb4549272);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", () => $d8d80d8186e8ae70$export$572cec90aa166025);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", () => $d8d80d8186e8ae70$export$f94109650ec67751);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", () => $d8d80d8186e8ae70$export$3a3a37e9da45a2a4);
$parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", () => $d8d80d8186e8ae70$export$9ef3f42fa10fce44);
$parcel$export(module.exports, "NULL_LITERAL", () => $d8d80d8186e8ae70$export$c2b6d31a7a2d40ba);
$parcel$export(module.exports, "IDENTIFIER_ALIAS", () => $d8d80d8186e8ae70$export$21c480ed86e9d13);
$parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", () => $d8d80d8186e8ae70$export$534c195089710c34);
$parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", () => $d8d80d8186e8ae70$export$4699ad3805947d4d);
$parcel$export(module.exports, "IDENTIFIER_ENTITY", () => $d8d80d8186e8ae70$export$2a30b5099ba66c99);
$parcel$export(module.exports, "IDENTIFIER_IS_SEEN", () => $d8d80d8186e8ae70$export$7926b4c2836db847);
$parcel$export(module.exports, "IDENTIFIER_MESSAGE", () => $d8d80d8186e8ae70$export$5a8895646b1d5248);
$parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", () => $d8d80d8186e8ae70$export$4047502bdab1e205);
$parcel$export(module.exports, "IDENTIFIER_PRIORITY", () => $d8d80d8186e8ae70$export$5922c06b76ebb57d);
$parcel$export(module.exports, "IDENTIFIER_COMPONENTS", () => $d8d80d8186e8ae70$export$1122634b5d555f05);
$parcel$export(module.exports, "IDENTIFIER_SERVICES", () => $d8d80d8186e8ae70$export$ec912454cd7d858a);
$parcel$export(module.exports, "IDENTIFIER_RESPONDERS", () => $d8d80d8186e8ae70$export$44673ddac1790242);
$parcel$export(module.exports, "IDENTIFIER_SOURCE", () => $d8d80d8186e8ae70$export$f250d53474e801dc);
$parcel$export(module.exports, "IDENTIFIER_STATUS", () => $d8d80d8186e8ae70$export$43181828ba8680e4);
$parcel$export(module.exports, "IDENTIFIER_TAG", () => $d8d80d8186e8ae70$export$8242733866920892);
$parcel$export(module.exports, "IDENTIFIER_TINY_ID", () => $d8d80d8186e8ae70$export$c833829cf31052f0);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", () => $d8d80d8186e8ae70$export$5f1e5c89a704810f);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", () => $d8d80d8186e8ae70$export$89d93eb7117999c0);
$parcel$export(module.exports, "IDENTIFIER_TEAMS", () => $d8d80d8186e8ae70$export$a79eb1864dd7b745);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", () => $d8d80d8186e8ae70$export$888a9cda49b5e18c);
$parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", () => $d8d80d8186e8ae70$export$60745b712d37edf9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", () => $d8d80d8186e8ae70$export$b38df7dc61d42293);
$parcel$export(module.exports, "splitToTokensRegex", () => $d8d80d8186e8ae70$export$28041d1d2a85f002);
$parcel$export(module.exports, "isKeywordRegex", () => $d8d80d8186e8ae70$export$290f3472231a2ca1);
$parcel$export(module.exports, "isModifierRegex", () => $d8d80d8186e8ae70$export$56079d3966b6b26c);
$parcel$export(module.exports, "isComplexOperatorRegex", () => $d8d80d8186e8ae70$export$3f6ac43c2355116b);
$parcel$export(module.exports, "isWSRegex", () => $d8d80d8186e8ae70$export$b1b0fc0dc5c83a12);
$parcel$export(module.exports, "isIdentifierRegex", () => $d8d80d8186e8ae70$export$218cf3eb73c65394);
$parcel$export(module.exports, "isLogicalOperatorRegex", () => $d8d80d8186e8ae70$export$a46484930d6fa80f);
$parcel$export(module.exports, "isOperatorRegex", () => $d8d80d8186e8ae70$export$d48805fc5b137dc9);
/**
 * Token types
 */ const $d8d80d8186e8ae70$export$e92b897d610f2aba = [
    'WHITE_SPACE',
    'SEPARATOR',
    'IDENTIFIER',
    'MODIFIER',
    'KEYWORD',
    'LOGICAL_OPERATOR',
    'STRING_LITERAL',
    'NUMBER_LITERAL',
    'BOOLEAN_LITERAL',
    'NULL_LITERAL',
    'OPERATOR'
];
const $d8d80d8186e8ae70$export$9ce7f372949a1546 = '(';
const $d8d80d8186e8ae70$export$bbbb3f477a9839e0 = ')';
const $d8d80d8186e8ae70$export$adbc66edc544fda9 = '=';
const $d8d80d8186e8ae70$export$fbd271ef020db0c = '!=';
const $d8d80d8186e8ae70$export$ea7497008076d6d2 = ':';
const $d8d80d8186e8ae70$export$6d44219c9e0c2567 = '!:';
const $d8d80d8186e8ae70$export$f8636d23c210043c = '<';
const $d8d80d8186e8ae70$export$1892bd0c818db570 = '<=';
const $d8d80d8186e8ae70$export$386b1ae18a32d690 = '>';
const $d8d80d8186e8ae70$export$44a62afa61d82568 = '>=';
const $d8d80d8186e8ae70$export$e75c84803c67e1f4 = [
    $d8d80d8186e8ae70$export$adbc66edc544fda9,
    $d8d80d8186e8ae70$export$f8636d23c210043c,
    $d8d80d8186e8ae70$export$1892bd0c818db570,
    $d8d80d8186e8ae70$export$386b1ae18a32d690,
    $d8d80d8186e8ae70$export$44a62afa61d82568
];
const $d8d80d8186e8ae70$export$61308b2610174a70 = 'AND';
const $d8d80d8186e8ae70$export$1de654320eb3e523 = 'OR';
const $d8d80d8186e8ae70$export$184522872a5410fc = 'not';
const $d8d80d8186e8ae70$export$ff7eed6ac2251302 = 'true';
const $d8d80d8186e8ae70$export$4b436fec6f13b741 = 'false';
const $d8d80d8186e8ae70$export$8cbc171ac4843075 = [
    $d8d80d8186e8ae70$export$ff7eed6ac2251302,
    $d8d80d8186e8ae70$export$4b436fec6f13b741
];
const $d8d80d8186e8ae70$export$347c7cb6285a1d61 = '"';
const $d8d80d8186e8ae70$export$d84ab70dc909b702 = "'";
const $d8d80d8186e8ae70$export$910131ff5cd3d496 = `${$d8d80d8186e8ae70$export$347c7cb6285a1d61}open${$d8d80d8186e8ae70$export$347c7cb6285a1d61}`;
const $d8d80d8186e8ae70$export$2aa0d26cb4549272 = `${$d8d80d8186e8ae70$export$347c7cb6285a1d61}closed${$d8d80d8186e8ae70$export$347c7cb6285a1d61}`;
const $d8d80d8186e8ae70$export$572cec90aa166025 = `${$d8d80d8186e8ae70$export$347c7cb6285a1d61}acknowledged${$d8d80d8186e8ae70$export$347c7cb6285a1d61}`;
const $d8d80d8186e8ae70$export$f94109650ec67751 = `${$d8d80d8186e8ae70$export$347c7cb6285a1d61}snoozed${$d8d80d8186e8ae70$export$347c7cb6285a1d61}`;
const $d8d80d8186e8ae70$export$3a3a37e9da45a2a4 = [
    $d8d80d8186e8ae70$export$910131ff5cd3d496,
    $d8d80d8186e8ae70$export$2aa0d26cb4549272,
    $d8d80d8186e8ae70$export$572cec90aa166025,
    $d8d80d8186e8ae70$export$f94109650ec67751
];
const $d8d80d8186e8ae70$export$928c1edd572e94f0 = 'P1';
const $d8d80d8186e8ae70$export$22202070e5f64c55 = 'P2';
const $d8d80d8186e8ae70$export$537865d58d2072a3 = 'P3';
const $d8d80d8186e8ae70$export$3d5cfea3feefee83 = 'P4';
const $d8d80d8186e8ae70$export$fe945cac89cd21a5 = 'P5';
const $d8d80d8186e8ae70$export$9ef3f42fa10fce44 = [
    $d8d80d8186e8ae70$export$928c1edd572e94f0,
    $d8d80d8186e8ae70$export$22202070e5f64c55,
    $d8d80d8186e8ae70$export$537865d58d2072a3,
    $d8d80d8186e8ae70$export$3d5cfea3feefee83,
    $d8d80d8186e8ae70$export$fe945cac89cd21a5
];
const $d8d80d8186e8ae70$export$c2b6d31a7a2d40ba = 'null';
const $d8d80d8186e8ae70$export$5a484b762b542c13 = 'actions';
const $d8d80d8186e8ae70$export$21c480ed86e9d13 = 'alias';
const $d8d80d8186e8ae70$export$534c195089710c34 = 'closedBy';
const $d8d80d8186e8ae70$export$4699ad3805947d4d = 'count';
const $d8d80d8186e8ae70$export$7c3401d7874d69f5 = 'createdAt';
const $d8d80d8186e8ae70$export$afffcbd5b444e040 = 'description';
const $d8d80d8186e8ae70$export$e1e61c3bf43fff11 = 'details.key';
const $d8d80d8186e8ae70$export$aa35da9746edbfe2 = 'details.value';
const $d8d80d8186e8ae70$export$b620b7163533b409 = 'detailsPair';
const $d8d80d8186e8ae70$export$2a30b5099ba66c99 = 'entity';
const $d8d80d8186e8ae70$export$2bfb49435a331d16 = 'integration.name';
const $d8d80d8186e8ae70$export$feced558810f4b3e = 'integration.type';
const $d8d80d8186e8ae70$export$7926b4c2836db847 = 'isSeen';
const $d8d80d8186e8ae70$export$5a8895646b1d5248 = 'message';
const $d8d80d8186e8ae70$export$4047502bdab1e205 = 'owner';
const $d8d80d8186e8ae70$export$5922c06b76ebb57d = 'priority';
const $d8d80d8186e8ae70$export$1122634b5d555f05 = 'components';
const $d8d80d8186e8ae70$export$ec912454cd7d858a = 'services';
const $d8d80d8186e8ae70$export$44673ddac1790242 = 'responders';
const $d8d80d8186e8ae70$export$f250d53474e801dc = 'source';
const $d8d80d8186e8ae70$export$43181828ba8680e4 = 'status';
const $d8d80d8186e8ae70$export$a1959e1b76e880dd = 'sync.name';
const $d8d80d8186e8ae70$export$8417ff61f7a57db6 = 'sync.type';
const $d8d80d8186e8ae70$export$8242733866920892 = 'tags';
const $d8d80d8186e8ae70$export$c833829cf31052f0 = 'tinyId';
const $d8d80d8186e8ae70$export$78d4faf48faf13c2 = 'updatedAt';
const $d8d80d8186e8ae70$export$5f1e5c89a704810f = 'acknowledged';
const $d8d80d8186e8ae70$export$89d93eb7117999c0 = 'acknowledgedBy';
const $d8d80d8186e8ae70$export$1ee0ad656333fc23 = 'aggregatorIds';
const $d8d80d8186e8ae70$export$d42da2034504d6de = 'alertId';
const $d8d80d8186e8ae70$export$8464a15b62fb09bb = 'alertType';
const $d8d80d8186e8ae70$export$2f7ba2848fc019c6 = 'encrypted';
const $d8d80d8186e8ae70$export$86e4b68c61c8cca5 = 'encryptionId';
const $d8d80d8186e8ae70$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
const $d8d80d8186e8ae70$export$8508b76d4c14d7e = 'notify';
const $d8d80d8186e8ae70$export$e73ddf8d219f28b7 = 'snoozedUntil';
const $d8d80d8186e8ae70$export$a79eb1864dd7b745 = 'teams';
const $d8d80d8186e8ae70$export$888a9cda49b5e18c = [
    $d8d80d8186e8ae70$export$5f1e5c89a704810f,
    $d8d80d8186e8ae70$export$89d93eb7117999c0,
    $d8d80d8186e8ae70$export$1ee0ad656333fc23,
    $d8d80d8186e8ae70$export$d42da2034504d6de,
    $d8d80d8186e8ae70$export$8464a15b62fb09bb,
    $d8d80d8186e8ae70$export$2f7ba2848fc019c6,
    $d8d80d8186e8ae70$export$86e4b68c61c8cca5,
    $d8d80d8186e8ae70$export$cd9dc7ab4d04d11c,
    $d8d80d8186e8ae70$export$8508b76d4c14d7e,
    $d8d80d8186e8ae70$export$e73ddf8d219f28b7,
    $d8d80d8186e8ae70$export$a79eb1864dd7b745,
    $d8d80d8186e8ae70$export$5a484b762b542c13,
    $d8d80d8186e8ae70$export$21c480ed86e9d13,
    $d8d80d8186e8ae70$export$534c195089710c34,
    $d8d80d8186e8ae70$export$4699ad3805947d4d,
    $d8d80d8186e8ae70$export$7c3401d7874d69f5,
    $d8d80d8186e8ae70$export$afffcbd5b444e040,
    $d8d80d8186e8ae70$export$e1e61c3bf43fff11,
    $d8d80d8186e8ae70$export$aa35da9746edbfe2,
    $d8d80d8186e8ae70$export$b620b7163533b409,
    $d8d80d8186e8ae70$export$2a30b5099ba66c99,
    $d8d80d8186e8ae70$export$2bfb49435a331d16,
    $d8d80d8186e8ae70$export$feced558810f4b3e,
    $d8d80d8186e8ae70$export$7926b4c2836db847,
    $d8d80d8186e8ae70$export$5a8895646b1d5248,
    $d8d80d8186e8ae70$export$4047502bdab1e205,
    $d8d80d8186e8ae70$export$5922c06b76ebb57d,
    $d8d80d8186e8ae70$export$44673ddac1790242,
    $d8d80d8186e8ae70$export$1122634b5d555f05,
    $d8d80d8186e8ae70$export$ec912454cd7d858a,
    $d8d80d8186e8ae70$export$f250d53474e801dc,
    $d8d80d8186e8ae70$export$43181828ba8680e4,
    $d8d80d8186e8ae70$export$a1959e1b76e880dd,
    $d8d80d8186e8ae70$export$8417ff61f7a57db6,
    $d8d80d8186e8ae70$export$8242733866920892,
    $d8d80d8186e8ae70$export$c833829cf31052f0,
    $d8d80d8186e8ae70$export$78d4faf48faf13c2
];
const $d8d80d8186e8ae70$export$60745b712d37edf9 = [
    $d8d80d8186e8ae70$export$5f1e5c89a704810f,
    $d8d80d8186e8ae70$export$7926b4c2836db847
];
const $d8d80d8186e8ae70$export$b38df7dc61d42293 = [
    ...$d8d80d8186e8ae70$export$888a9cda49b5e18c
];
/**
 * Regex definitions
 */ // The main regex to split any given query into smaller tokens.
// Please be aware that token order has a meaning here.
const $d8d80d8186e8ae70$var$splitToTokensCases = [
    // 1. Split single and double quotes
    ...[
        $d8d80d8186e8ae70$export$d84ab70dc909b702,
        $d8d80d8186e8ae70$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*?${i})`),
    ...[
        $d8d80d8186e8ae70$export$d84ab70dc909b702,
        $d8d80d8186e8ae70$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*)`),
    // 2. Split operators and separators
    ...[
        $d8d80d8186e8ae70$export$9ce7f372949a1546,
        $d8d80d8186e8ae70$export$bbbb3f477a9839e0,
        $d8d80d8186e8ae70$export$adbc66edc544fda9,
        $d8d80d8186e8ae70$export$fbd271ef020db0c,
        $d8d80d8186e8ae70$export$ea7497008076d6d2,
        $d8d80d8186e8ae70$export$6d44219c9e0c2567,
        $d8d80d8186e8ae70$export$44a62afa61d82568,
        $d8d80d8186e8ae70$export$386b1ae18a32d690,
        $d8d80d8186e8ae70$export$1892bd0c818db570,
        $d8d80d8186e8ae70$export$f8636d23c210043c
    ].map((i)=>`(\\${i})`),
    // 3. Split the exact keywords when it's a known literal
    // Known issue: The word boundary in the beginning does not capture letters except latin chars, digits and underscore, i.e. "+and" results to STRING_LITERAL + BOOLEAN_LITERAL
    ...[
        $d8d80d8186e8ae70$export$61308b2610174a70,
        $d8d80d8186e8ae70$export$1de654320eb3e523,
        $d8d80d8186e8ae70$export$ff7eed6ac2251302,
        $d8d80d8186e8ae70$export$4b436fec6f13b741,
        $d8d80d8186e8ae70$export$184522872a5410fc,
        `is\\s*null`,
        `is\\s*not\\s*null`
    ].map((i)=>`(\\b${i}(?=\\s|$))`),
    // 4. Empty spaces
    '(\\s+)'
];
const $d8d80d8186e8ae70$export$28041d1d2a85f002 = new RegExp($d8d80d8186e8ae70$var$splitToTokensCases.join('|'), 'gi');
const $d8d80d8186e8ae70$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
const $d8d80d8186e8ae70$export$56079d3966b6b26c = /^not$/i;
const $d8d80d8186e8ae70$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
const $d8d80d8186e8ae70$export$b1b0fc0dc5c83a12 = /^\s+$/;
const $d8d80d8186e8ae70$export$218cf3eb73c65394 = new RegExp($d8d80d8186e8ae70$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
const $d8d80d8186e8ae70$export$a46484930d6fa80f = /^and$|^or$/i;
const $d8d80d8186e8ae70$export$d48805fc5b137dc9 = /^[=:<>]$/;

});

parcelRegister("c6ZDX", function(module, exports) {
$parcel$export(module.exports, "OpsgenieSavedSearchAri", () => $8d15dcae9045c8f1$export$1dc7f741fb628a10);

var $1Q6nC = parcelRequire("1Q6nC");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/opsgenie/saved-search/manifest.ts
var $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1Q6nC.OpsgenieSavedSearchAriResourceOwner),
    resourceType: (0, $1Q6nC.OpsgenieSavedSearchAriResourceType),
    resourceIdSlug: "{workspaceId}/{savedSearchId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        savedSearchId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/opsgenie/saved-search/index.ts
var $8d15dcae9045c8f1$export$1dc7f741fb628a10 = class _OpsgenieSavedSearchAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._savedSearchId = opts.resourceIdSegmentValues.savedSearchId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get savedSearchId() {
        return this._savedSearchId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts.qualifier,
            platformQualifier: $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts.resourceOwner,
            resourceType: $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}/${opts.savedSearchId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                savedSearchId: opts.savedSearchId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId,
            savedSearchId: this.savedSearchId
        };
    }
};

});
parcelRegister("1Q6nC", function(module, exports) {
$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceOwner", () => $156f98ac86d14414$export$7416cc1df15f6b85);
$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceType", () => $156f98ac86d14414$export$1db52fe39936618e);
// src/opsgenie/saved-search/types.ts
var $156f98ac86d14414$export$7416cc1df15f6b85 = "opsgenie", $156f98ac86d14414$export$1db52fe39936618e = "saved-search";

});


parcelRegister("3y8cO", function(module, exports) {
$parcel$export(module.exports, "SavedSearchActionButtons", () => $627e034906c9d6ce$export$78ee2939aff842cb);

var $eJOHy = parcelRequire("eJOHy");

var $4MicW = parcelRequire("4MicW");

var $7saMl = parcelRequire("7saMl");
var $6YEko = parcelRequire("6YEko");

var $c6ZDX = parcelRequire("c6ZDX");

var $huP8o = parcelRequire("huP8o");

var $9KL5d = parcelRequire("9KL5d");
var $dSpzu = parcelRequire("dSpzu");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");





var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $6naEG = parcelRequire("6naEG");

var $8z6Yy = parcelRequire("8z6Yy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $5A7zz = parcelRequire("5A7zz");
const $627e034906c9d6ce$var$deleteModalMessageDescriptors = {
    title: (0, $5A7zz.default).confirmTrashHeading,
    description: (0, $5A7zz.default).confirmTrashMessage
};
const $627e034906c9d6ce$export$78ee2939aff842cb = ({ onClose: onClose, savedSearch: savedSearch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                itemId: (0, $bc40578f06d7846b$export$a65812b4aab631bb),
                parentItemType: 'savedSearch',
                parentItemId: savedSearch.id
            }
        });
    }, [
        createAnalyticsEvent,
        savedSearch.id
    ]);
    const MenuItems = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($627e034906c9d6ce$var$MoreMenuItems, {
            onClose: props.onClose,
            savedSearch: savedSearch
        }), [
        savedSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: MenuItems,
        onClose: onClose
    });
};
const $627e034906c9d6ce$var$MoreMenuItems = ({ onClose: onClose, savedSearch: savedSearch })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [modalType, setModalType] = (0, $eJOHy.useState)(undefined);
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)(onClose);
    const { removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe } = (0, $dSpzu.useSavedSearchRelayUtils)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const deleteSavedSearch = (0, $eJOHy.useCallback)((e)=>{
        setIsLoading(true);
        const savedSearchId = (0, $c6ZDX.OpsgenieSavedSearchAri).parse(savedSearch.id).savedSearchId;
        (0, $9KL5d.deleteSearchEndpoint)(savedSearchId).then(()=>{
            removeSavedSearchFromCreatedByMe(savedSearch.id);
        }).catch(()=>{
            showFlag({
                key: (0, $jn1Cb.toFlagId)((0, $a04b23a4cdb2ecf7$export$337d30e19f17af0f)),
                type: 'error',
                title: (0, $5A7zz.default).errorTitle,
                description: (0, $5A7zz.default).errorMessage,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-content-operations.ui.alerts-content.alerts-menu-item.action-button.show-flag.error',
                messageType: 'transactional'
            });
        }).finally(()=>{
            setIsLoading(false);
            if (onClose) onClose(e);
        });
    }, [
        savedSearch,
        onClose,
        removeSavedSearchFromCreatedByMe,
        showFlag
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        setModalType('delete');
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
                level: (0, $4fdd5d9c1b32dd60$export$35ac629b8b943d5a),
                itemId: 'deleteSavedSearch',
                parentItemType: 'savedSearch',
                parentItemId: savedSearch.id
            }
        });
    }, [
        createAnalyticsEvent,
        savedSearch.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4MicW))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }),
        onClick: handleClick
    }, formatMessage((0, $5A7zz.default).deleteSavedSearch))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $huP8o.DeleteModal), {
        messageDescriptors: $627e034906c9d6ce$var$deleteModalMessageDescriptors,
        isDeleteDialogOpen: modalType === 'delete',
        onDeleteAttemptCancel: onCloseWithStopPropagation,
        isLoading: isLoading,
        onDelete: deleteSavedSearch
    }));
};

});
parcelRegister("huP8o", function(module, exports) {
$parcel$export(module.exports, "DeleteModal", () => $c0bd0169b5c236cc$export$73392e09138fecd6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");
var $cA0Y2 = parcelRequire("cA0Y2");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $a42lj = parcelRequire("a42lj");
const $c0bd0169b5c236cc$export$73392e09138fecd6 = ({ isDeleteDialogOpen: isDeleteDialogOpen, onDeleteAttemptCancel: onDeleteAttemptCancel, onDelete: onDelete, isLoading: isLoading, messageDescriptors: messageDescriptors, returnFocusRef: returnFocusRef })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: isDeleteDialogOpen && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gHHv2.default), {
            shouldCloseOnOverlayClick: !isLoading,
            onClose: onDeleteAttemptCancel,
            shouldReturnFocus: returnFocusRef,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                        appearance: "danger",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...messageDescriptors.title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...messageDescriptors.description
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            isDisabled: isLoading,
                            appearance: "subtle",
                            onClick: onDeleteAttemptCancel,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $a42lj.messages).cancelButton
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
                            appearance: "danger",
                            onClick: onDelete,
                            autoFocus: true,
                            isLoading: isLoading,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $a42lj.messages).deleteButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("a42lj", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7c7592c5b0f4421d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $7c7592c5b0f4421d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    cancelButton: {
        id: 'eoc.alert-detail.delete-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the delete modal footer for cancel button.'
    },
    deleteButton: {
        id: 'eoc.alert-detail.extra-property.delete-modal.delete-button.no-translate',
        defaultMessage: 'Delete',
        description: 'The text will be displayed in the delete modal footer for delete button.'
    }
});

});


parcelRegister("9KL5d", function(module, exports) {
$parcel$export(module.exports, "getSavedSearchesEndpoint", () => $52d70852bf4b9dd8$export$3b7b44889eb94cd0);
$parcel$export(module.exports, "createSavedSearchEndpoint", () => $52d70852bf4b9dd8$export$4976332c0ec66407);
$parcel$export(module.exports, "deleteSearchEndpoint", () => $52d70852bf4b9dd8$export$401da4a793944201);

var $9ppkU = parcelRequire("9ppkU");
const $52d70852bf4b9dd8$export$3b7b44889eb94cd0 = ()=>{
    return (0, $9ppkU.eocFetch)('/v1/alerts/saved-searches');
};
const $52d70852bf4b9dd8$export$4976332c0ec66407 = (data)=>{
    return (0, $9ppkU.eocFetch)('/v1/alerts/saved-searches', {
        method: 'POST',
        body: data
    });
};
const $52d70852bf4b9dd8$export$401da4a793944201 = (id)=>{
    return (0, $9ppkU.eocFetch)(`/v1/alerts/saved-searches/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});

parcelRegister("dSpzu", function(module, exports) {
$parcel$export(module.exports, "useSavedSearchRelayUtils", () => $a0f4f9924547d0a1$export$e07c40a7acca4305);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $c6ZDX = parcelRequire("c6ZDX");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $fR4Ty = parcelRequire("fR4Ty");

var $aZHG3 = parcelRequire("aZHG3");
const $a0f4f9924547d0a1$export$e07c40a7acca4305 = ()=>{
    const relayEnvironment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $fR4Ty.getMeta)('ajs-cloud-id') ?? (0, $aZHG3.getCloudIdForDevEnvironment)();
    (0, $cyz90.assert)(!!cloudId, new (0, $gLoFN.AssertionError)('cloudId', 'useSavedSarchRelayUtils: cloudId is undefined'));
    const removeSavedSearch = (0, $eJOHy.useCallback)((savedSearchId, key)=>{
        (0, $j4oe4.commitLocalUpdate)(relayEnvironment, (store)=>{
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const removeItem = savedSearches.getLinkedRecords(key);
                    if (removeItem) {
                        const filteredItems = removeItem.filter((record)=>record.getValue('id') !== savedSearchId);
                        savedSearches.setLinkedRecords(filteredItems, key);
                    }
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearch = (0, $eJOHy.useCallback)((savedSearch, key)=>{
        (0, $j4oe4.commitLocalUpdate)(relayEnvironment, (store)=>{
            const newSavedSearchId = (0, $c6ZDX.OpsgenieSavedSearchAri).create({
                workspaceId: cloudId,
                savedSearchId: savedSearch.id
            }).toString();
            const newSavedSearch = store.create(newSavedSearchId, 'OpsgenieSavedSearch');
            newSavedSearch.setValue(newSavedSearchId, 'id');
            newSavedSearch.setValue(savedSearch.name, 'name');
            newSavedSearch.setValue(savedSearch.query, 'alertSearchQuery');
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const savedSearchesList = savedSearches.getLinkedRecords(key) || [];
                    const updatedSavedSearches = [
                        ...savedSearchesList,
                        newSavedSearch
                    ];
                    savedSearches.setLinkedRecords(updatedSavedSearches, key);
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearchToCreatedByMe = (0, $eJOHy.useCallback)((savedSearch)=>{
        addSavedSearch(savedSearch, 'createdByMe');
    }, [
        addSavedSearch
    ]);
    const removeSavedSearchFromCreatedByMe = (0, $eJOHy.useCallback)((savedSearchId)=>{
        removeSavedSearch(savedSearchId, 'createdByMe');
    }, [
        removeSavedSearch
    ]);
    return {
        addSavedSearchToCreatedByMe: addSavedSearchToCreatedByMe,
        removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe
    };
};

});
parcelRegister("cyz90", function(module, exports) {
$parcel$export(module.exports, "assert", () => $e3449be94a1457b0$export$a7a9523472993e97);

var $gLoFN = parcelRequire("gLoFN");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $e3449be94a1457b0$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("gLoFN", function(module, exports) {
$parcel$export(module.exports, "AssertionError", () => $2218f52c64c5056f$export$7750cdfb4db2c3d);
class $2218f52c64c5056f$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`), this.id = id;
    }
}

});


parcelRegister("aZHG3", function(module, exports) {
$parcel$export(module.exports, "validateTimeInput", () => $e2ec7f84c79657da$export$8880da3ae4274888);
$parcel$export(module.exports, "validateBetweenInput", () => $e2ec7f84c79657da$export$57c3e855fbf300fa);
$parcel$export(module.exports, "isInvalidDateValue", () => $e2ec7f84c79657da$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "removeQuotes", () => $e2ec7f84c79657da$export$dd2bdf5049bf0915);
$parcel$export(module.exports, "withQuote", () => $e2ec7f84c79657da$export$8708814d32e406db);
$parcel$export(module.exports, "calculateTimes", () => $e2ec7f84c79657da$export$b362bc6892126b7a);
$parcel$export(module.exports, "getDefaultFilterQuery", () => $e2ec7f84c79657da$export$16cce822d8159876);
$parcel$export(module.exports, "isResponderAlert", () => $e2ec7f84c79657da$export$78656db4ffc3ccd8);
$parcel$export(module.exports, "isGroupAlert", () => $e2ec7f84c79657da$export$be2243d4df51c704);
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $e2ec7f84c79657da$export$81c70e0016508593);
$parcel$export(module.exports, "getCloudIdForDevEnvironment", () => $e2ec7f84c79657da$export$fc6ce7ac2248d7f5);

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $8XZn3 = parcelRequire("8XZn3");

var $fR4Ty = parcelRequire("fR4Ty");

var $5s9J0 = parcelRequire("5s9J0");
var $dZe0G = parcelRequire("dZe0G");

var $4HEM8 = parcelRequire("4HEM8");

var $lsaPs = parcelRequire("lsaPs");
var $l3cVc = parcelRequire("l3cVc");

var $igDjg = parcelRequire("igDjg");
const $e2ec7f84c79657da$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
    if (!timeDigits) return;
    const timeDigitsNumber = parseInt(timeDigits);
    if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, $4HEM8.default).validNumber);
    if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, $4HEM8.default).hoursNotInRange);
    if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, $4HEM8.default).daysNotInRange);
    if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, $4HEM8.default).weeksNotInRange);
    if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, $4HEM8.default).monthsNotInRange);
    if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, $4HEM8.default).yearsNotInRange);
};
const $e2ec7f84c79657da$export$57c3e855fbf300fa = (intl, value)=>{
    if (value) {
        const { startDate: startDate, endDate: endDate } = value;
        if (!startDate && !endDate) return;
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $4HEM8.default).validationMessageBeforeGreaterThanAfter);
        if (value && (startDate !== '' && !(0, $dBLX0.default)(new Date(startDate)) || endDate !== '' && !(0, $dBLX0.default)(new Date(endDate)))) return intl.formatMessage((0, $4HEM8.default).validationMessageInvalidDateFormat);
    }
    return;
};
const $e2ec7f84c79657da$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $dBLX0.default)((0, $kQ82p.default)(value)) && value !== '';
};
const $e2ec7f84c79657da$export$dd2bdf5049bf0915 = (value)=>{
    return value.replace(/^"(.*)"$/, '$1');
};
const $e2ec7f84c79657da$export$d4aae9ad13afd6c = (data)=>{
    return {
        ...data,
        label: data.name,
        value: data.id
    };
};
const $e2ec7f84c79657da$export$8708814d32e406db = (value)=>{
    if ((0, $5s9J0.hasSpaceRegEx).test(value) || (0, $5s9J0.hasColonRegex).test(value)) return `${0, $dZe0G.STRING_LITERAL_DOUBLE_QUOTE}${value}${0, $dZe0G.STRING_LITERAL_DOUBLE_QUOTE}`;
    else return value;
};
const $e2ec7f84c79657da$export$b362bc6892126b7a = (time)=>{
    if (!time) return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'all') return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'custom') return {
        from: time.from,
        to: time.to
    };
    const now = new Date();
    const subAmount = {
        [time.range]: time.value
    };
    return {
        from: (0, $8XZn3.default)(now, subAmount).getTime(),
        to: now.getTime()
    };
};
const $e2ec7f84c79657da$export$16cce822d8159876 = (query, teamId)=>{
    if (teamId) {
        if (query) return `${0, $dZe0G.IDENTIFIER_RESPONDERS}: ${teamId} ${0, $dZe0G.LOGICAL_OPERATOR_AND} ${query}`;
        return `${0, $dZe0G.IDENTIFIER_RESPONDERS}: ${teamId}`;
    }
    return query;
};
const $e2ec7f84c79657da$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
const $e2ec7f84c79657da$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
const $e2ec7f84c79657da$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $fR4Ty.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
const $e2ec7f84c79657da$var$isDevEnvironment = ()=>{
    return typeof $igDjg !== 'undefined' && ($igDjg?.env?.STORYBOOK === 'true' || $igDjg?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
};
const $e2ec7f84c79657da$export$fc6ce7ac2248d7f5 = ()=>{
    if ($e2ec7f84c79657da$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
    return undefined;
};

});
parcelRegister("5s9J0", function(module, exports) {
$parcel$export(module.exports, "TAB_KEY", () => $61eabb657d066107$export$da8c7facc28740b1);
$parcel$export(module.exports, "ENTER_KEY", () => $61eabb657d066107$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $61eabb657d066107$export$728705b4513abbb5);
$parcel$export(module.exports, "SPACE_KEY", () => $61eabb657d066107$export$a47625ee19580f99);
$parcel$export(module.exports, "LEFT_KEY", () => $61eabb657d066107$export$ba950c21a0561bed);
$parcel$export(module.exports, "UP_KEY", () => $61eabb657d066107$export$16859d5882a95fea);
$parcel$export(module.exports, "RIGHT_KEY", () => $61eabb657d066107$export$4b96cad863d88376);
$parcel$export(module.exports, "DOWN_KEY", () => $61eabb657d066107$export$fc0cf2556509233e);
$parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", () => $61eabb657d066107$export$87b2b08fc4c97f78);
$parcel$export(module.exports, "hasSpaceRegEx", () => $61eabb657d066107$export$a07ca273fbeffcb8);
$parcel$export(module.exports, "hasStartingQuotesRegex", () => $61eabb657d066107$export$a3aaedcec21ac282);
$parcel$export(module.exports, "hasEndingQuotesRegex", () => $61eabb657d066107$export$e5ad519d04ef012a);
$parcel$export(module.exports, "hasNewLinesRegex", () => $61eabb657d066107$export$7645e556e9948ecd);
$parcel$export(module.exports, "EMAIL_REGEX", () => $61eabb657d066107$export$7b7637218245c8a);
$parcel$export(module.exports, "hasColonRegex", () => $61eabb657d066107$export$65a2b373cb60e599);
const $61eabb657d066107$export$da8c7facc28740b1 = 'Tab';
const $61eabb657d066107$export$4162dbd8c730437 = 'Enter';
const $61eabb657d066107$export$728705b4513abbb5 = 'Escape';
const $61eabb657d066107$export$a47625ee19580f99 = ' ';
const $61eabb657d066107$export$ba950c21a0561bed = 'ArrowLeft';
const $61eabb657d066107$export$16859d5882a95fea = 'ArrowUp';
const $61eabb657d066107$export$4b96cad863d88376 = 'ArrowRight';
const $61eabb657d066107$export$fc0cf2556509233e = 'ArrowDown';
const $61eabb657d066107$export$87b2b08fc4c97f78 = 28;
const $61eabb657d066107$export$a07ca273fbeffcb8 = /\s/;
const $61eabb657d066107$export$8866d083cd03ffd7 = /^\s|\s$/;
const $61eabb657d066107$export$a3aaedcec21ac282 = /^('|")/;
const $61eabb657d066107$export$e5ad519d04ef012a = /('|")$/;
const $61eabb657d066107$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
const $61eabb657d066107$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $61eabb657d066107$export$65a2b373cb60e599 = /:/;

});

parcelRegister("4HEM8", function(module, exports) {
$parcel$export(module.exports, "default", () => $437dcbda4a6b0e9a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $437dcbda4a6b0e9a$var$messages = (0, $7qGN1.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validNumber: {
        id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
        defaultMessage: 'Enter a valid number.',
        description: 'The error message that shown when user write different chars other than numeric chars.'
    },
    hoursNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99999.',
        description: 'Message displayed to the user when hours value is not in range'
    },
    daysNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9999.',
        description: 'Message displayed to the user when days value is not in range'
    },
    weeksNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-999.',
        description: 'Message displayed to the user when weeks value is not in range'
    },
    monthsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99.',
        description: 'Message displayed to the user when months value is not in range'
    },
    yearsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9.',
        description: 'Message displayed to the user when years value is not in range'
    }
});
var $437dcbda4a6b0e9a$export$2e2bcd8739ae039 = $437dcbda4a6b0e9a$var$messages;

});

parcelRegister("lsaPs", function(module, exports) {
$parcel$export(module.exports, "useAllActions", () => $3e231a406cfb8dd3$export$acd577492a98befc);

var $eJOHy = parcelRequire("eJOHy");

var $1K3JI = parcelRequire("1K3JI");
const $3e231a406cfb8dd3$export$acd577492a98befc = ({ alertId: alertId, bulkLoadingState: bulkLoadingState, actionsController: actionsController })=>{
    const { processingBulkIds: processingBulkIds, isBulkSnoozeLoading: isBulkSnoozeLoading, isBulkAssignLoading: isBulkAssignLoading, isBulkCloseLoading: isBulkCloseLoading, isBulkDeleteLoading: isBulkDeleteLoading, isBulkUnacknowledgeLoading: isBulkUnacknowledgeLoading, isBulkAckLoading: isBulkAckLoading, isBulkAddResponderLoading: isBulkAddResponderLoading, isBulkTakeOwnershipLoading: isBulkTakeOwnershipLoading } = bulkLoadingState;
    const { handleAck: handleAck, handleClose: handleClose, handleAssign: handleAssign, handleTakeOwnership: handleTakeOwnership, handleEscalate: handleEscalate, handleAddResponder: handleAddResponder, handleSnooze: handleSnooze, handleDelete: handleDelete, handleUnack: handleUnack, isAssigneeUpdateLoading: isAssigneeUpdateLoading, isRespondersUpdateLoading: isRespondersUpdateLoading, isAckLoading: isAckLoading, isUnackLoading: isUnackLoading, isDeleteLoading: isDeleteLoading, isSnoozeLoading: isSnoozeLoading, isCloseLoading: isCloseLoading, isEscalateLoading: isEscalateLoading } = actionsController;
    const isBulkProcessing = (0, $eJOHy.useMemo)(()=>processingBulkIds.includes(alertId), [
        processingBulkIds,
        alertId
    ]);
    const allActions = [
        {
            label: (0, $1K3JI.default).acknowledge,
            onClick: handleAck,
            actionId: 'acknowledge',
            isLoading: isAckLoading || isBulkProcessing && isBulkAckLoading
        },
        {
            label: (0, $1K3JI.default).close,
            onClick: handleClose,
            actionId: 'close',
            isLoading: isCloseLoading || isBulkProcessing && isBulkCloseLoading
        },
        {
            label: (0, $1K3JI.default).assign,
            onClick: handleAssign,
            actionId: 'assign',
            isLoading: isAssigneeUpdateLoading || isBulkProcessing && isBulkAssignLoading
        },
        {
            label: (0, $1K3JI.default).unacknowledge,
            onClick: handleUnack,
            actionId: 'unacknowledge',
            isLoading: isUnackLoading || isBulkProcessing && isBulkUnacknowledgeLoading
        },
        {
            label: (0, $1K3JI.default).takeOwnership,
            onClick: handleTakeOwnership,
            actionId: 'takeOwnership',
            isLoading: isAssigneeUpdateLoading || isBulkProcessing && isBulkTakeOwnershipLoading
        },
        {
            label: (0, $1K3JI.default).escalateToNext,
            onClick: handleEscalate,
            actionId: 'escalateToNext',
            isLoading: isEscalateLoading
        },
        {
            label: (0, $1K3JI.default).addResponder,
            onClick: handleAddResponder,
            actionId: 'addResponder',
            isLoading: isRespondersUpdateLoading || isBulkProcessing && isBulkAddResponderLoading
        },
        {
            label: (0, $1K3JI.default).snooze,
            onClick: handleSnooze,
            actionId: 'snooze',
            isLoading: isSnoozeLoading || isBulkProcessing && isBulkSnoozeLoading
        },
        {
            label: (0, $1K3JI.default).delete,
            onClick: handleDelete,
            actionId: 'delete',
            isLoading: isDeleteLoading || isBulkProcessing && isBulkDeleteLoading
        }
    ];
    return allActions;
};

});
parcelRegister("1K3JI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a45f2b0d5563ccb0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a45f2b0d5563ccb0$var$messages = (0, $7qGN1.defineMessages)({
    errorTitle: {
        id: 'eoc.alert-list.flag.error-title.no-translate',
        defaultMessage: 'Error',
        description: 'Title of error message that will be displayed in the flag'
    },
    successTitle: {
        id: 'eoc.alert-list.flag.success-title.no-translate',
        defaultMessage: 'Success',
        description: 'Title of success message that will be displayed in the flag'
    },
    acknowledge: {
        id: 'eoc.alert-list.actions.acknowledge.no-translate',
        defaultMessage: 'Ack',
        description: 'Acknowledge action button'
    },
    unacknowledge: {
        id: 'eoc.alert-list.actions.unacknowledge.no-translate',
        defaultMessage: 'Open',
        description: 'Unacknowledge(open) action button'
    },
    snooze: {
        id: 'eoc.alert-list.actions.snooze.no-translate',
        defaultMessage: 'Snooze',
        description: 'Snooze action button'
    },
    close: {
        id: 'eoc.alert-list.actions.close.no-translate',
        defaultMessage: 'Close',
        description: 'Close action button'
    },
    delete: {
        id: 'eoc.alert-list.actions.delete.no-translate',
        defaultMessage: ' Delete',
        description: 'Delete action button'
    },
    escalateToNext: {
        id: 'eoc.alert-list.actions.escalateToNext.no-translate',
        defaultMessage: 'Escalate to next',
        description: 'Escalate to next action button'
    },
    assign: {
        id: 'eoc.alert-list.actions.assign.no-translate',
        defaultMessage: 'Assign',
        description: 'Assign action button'
    },
    addResponder: {
        id: 'eoc.alert-list.actions.add-responder.no-translate',
        defaultMessage: 'Add responder',
        description: 'Add responder action button'
    },
    takeOwnership: {
        id: 'eoc.alert-list.actions.takeOwnership.no-translate',
        defaultMessage: 'Assign to me',
        description: 'Assign to me action button'
    },
    addTag: {
        id: 'eoc.alert-list.actions.add-tag.no-translate',
        defaultMessage: 'Add tag',
        description: 'Add tag action button'
    },
    addNote: {
        id: 'eoc.alert-list.actions.add-note.no-translate',
        defaultMessage: 'Add note',
        description: 'Add note action button'
    },
    empty: {
        id: `eoc.alert-list.empty.no-translate`,
        defaultMessage: 'No matching alerts were found.',
        description: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.'
    },
    emptyNew: {
        id: `eoc.alert-list.empty.no-translate`,
        defaultMessage: "We couldn\u2019t find any alerts matching your search",
        description: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert with ff on.'
    },
    noAlerts: {
        id: `eoc.alert-list.no-alerts.no-translate`,
        defaultMessage: "You don\u2019t have any alerts, yet",
        description: 'Message displayed when there is no alerts'
    },
    learnMore: {
        id: `eoc.alert-list.no-alerts.learn-more.no-translate`,
        defaultMessage: 'Read how alerts are created',
        description: 'Message displayed for redirecting user to alert create docs'
    },
    emptyDescription: {
        id: `eoc.alert-list.no-alerts.description.no-translate`,
        defaultMessage: "We couldn\u2019t find any alerts for this search. Change your filters and try again.",
        description: 'Message displayed as description when there is no alerts with given search'
    },
    emptyDescriptionNew: {
        id: `eoc.alert-list.no-alerts.description.no-translate`,
        defaultMessage: 'Adjust your search filters and try again. You can also create an alert to notify your team about anything critical.',
        description: 'Message displayed as description when there is no alerts with given search when ff on'
    },
    noAlertsDescription: {
        id: `eoc.alert-list.no-alerts.description.no-translate`,
        defaultMessage: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.',
        description: 'Message displayed when there is no alerts'
    },
    error: {
        id: `eoc.alert-list.error.no-translate`,
        defaultMessage: "We couldn\u2019t load the alerts",
        description: 'Message displayed when there is an error on fetching alerts'
    },
    errorDescription: {
        id: `eoc.alert-list.error.description.no-translate`,
        defaultMessage: 'Something went wrong while we were loading the alerts. Try searching again.',
        description: 'Message displayed as description when there is an error on fetching alerts'
    },
    pageTitle: {
        id: 'eoc.alert-list.page.title.no-translate',
        defaultMessage: 'Alerts',
        description: 'Title of the page'
    },
    emptyAIViewTitle: {
        id: 'eoc.alert-list.flag.error-title.no-translate',
        defaultMessage: 'Looking for alerts to group',
        description: 'Title ofthe message that will be displayed when no groups are present'
    },
    emptyAIViewDescription: {
        id: 'eoc.alert-list.flag.success-title.no-translate',
        defaultMessage: 'Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
        description: 'Description of the message that will be displayed when no groups are present'
    },
    dareAIViewTitle: {
        id: 'eoc.alert-list.flag.dare-title.no-translate',
        defaultMessage: 'Starting fresh to group alerts',
        description: 'Title of the message that will be displayed when no groups are present because of DaRe'
    },
    dareAIViewDescription: {
        id: 'eoc.alert-list.flag.dare-description.no-translate',
        defaultMessage: 'Since you changed your data residency location, previous alert groups were deleted. Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
        description: 'Description of the message that will be displayed when no groups are present'
    },
    notEnabledAIViewTitle: {
        id: 'eoc.smart-alert-list.flag.not-enabled.no-translate',
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for",
        description: 'Title of the message that will be displayed when AI view is not enabled'
    },
    notEnabledAIViewDescription: {
        id: 'eoc.smart-alert-list.flag.not-enabled.no-translate',
        defaultMessage: "We looked everywhere, but it doesn\u2019t exist.",
        description: 'Description of the message that will be displayed when AI view is not enabled'
    },
    readMoreAlertGrouping: {
        id: 'eoc.alert-list.flag.success-title.no-translate',
        defaultMessage: 'Read more about alert grouping',
        description: 'Message for read more that will be displayed when no groups are present'
    },
    requiredFieldsInformMessage: {
        id: 'eoc.alert-list.modal.required-fields-inform-message.no-translate',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Message to give information to users about required fields'
    },
    ariaLiveMessageFilters: {
        id: `eoc.alert-list.filters.aria-live-message.no-translate`,
        defaultMessage: `{removedValue, select,
      true { Option {label} deselected. {numOfAlerts} matching alerts found. }
      other { Option {label} selected. {numOfAlerts} matching alerts found. }
    }`,
        description: 'The message to be announced when user selects an option from one of the filters.'
    },
    buttonAriaLabelToIndicateTableModification: {
        id: `eoc.alert-list.filters.update-button.no-translate`,
        defaultMessage: '{buttonText}. The table will be modified.',
        description: 'The message to be announced before user press update filter button.'
    },
    acceptAIPrediction: {
        id: 'eoc.alert-list.unified-bulk-actions.accept-ai-prediction.no-translate',
        defaultMessage: 'Accept classification',
        description: 'Button label for accepting AI prediction in bulk actions'
    },
    acknowledgeAll: {
        id: 'eoc.unified-list.actions.acknowledge.no-translate',
        defaultMessage: 'Ack all',
        description: 'Acknowledge action button'
    },
    snoozeAll: {
        id: 'eoc.unified-list.actions.snooze.no-translate',
        defaultMessage: 'Snooze all',
        description: 'Snooze action button'
    },
    closeAll: {
        id: 'eoc.unified-list.actions.close.no-translate',
        defaultMessage: 'Close all',
        description: 'Close action button'
    },
    deleteAll: {
        id: 'eoc.unified-list.actions.delete.no-translate',
        defaultMessage: 'Delete all',
        description: 'Delete action button'
    },
    assignToMe: {
        id: 'eoc.unified-list.actions.assignToMe.no-translate',
        defaultMessage: 'Assign to me',
        description: 'Assign to me action button'
    },
    acceptPrediction: {
        id: 'eoc.unified-list.actions.acceptPrediction.no-translate',
        defaultMessage: 'Accept classification',
        description: 'Accept classification action button'
    },
    moreAriaLabel: {
        id: 'eoc.unified-list.actions.more-aria-label.no-translate',
        defaultMessage: 'More actions for {tinyId}',
        description: 'Description inside delete modal body.'
    },
    summaryMoreAriaLabel: {
        id: 'eoc.alert-list.summary-actions.more-aria-label',
        defaultMessage: 'More actions for alert {tinyId}',
        description: 'Aria label for the more actions button in summary'
    },
    deleteModalTitle: {
        id: 'eoc.alert-list.summary-actions.delete-modal-title',
        defaultMessage: 'Delete alert',
        description: 'Title for the delete confirmation modal'
    },
    deleteModalDescription: {
        id: 'eoc.alert-list.summary-actions.delete-modal-description',
        defaultMessage: 'Are you sure you want to delete this alert? This action cannot be undone.',
        description: 'Description for the delete confirmation modal'
    },
    filterInfo: {
        id: 'eoc.alert-list.header.filter-info.no-translate',
        defaultMessage: "The results include groups that have alerts matching your filter criteria. The group's overall priority may differ.",
        description: 'Filter info in the alert smart table header'
    }
});
var $a45f2b0d5563ccb0$export$2e2bcd8739ae039 = $a45f2b0d5563ccb0$var$messages;

});


parcelRegister("l3cVc", function(module, exports) {
$parcel$export(module.exports, "useAllGroupActions", () => $38dccc49936f8563$export$8df8e9de2e51cb58);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $1K3JI = parcelRequire("1K3JI");
const $38dccc49936f8563$export$8df8e9de2e51cb58 = ({ groupId: groupId, bulkLoadingState: bulkLoadingState, groupActionsController: groupActionsController, snrClassification: snrClassification })=>{
    const { processingBulkIds: processingBulkIds } = bulkLoadingState;
    const { action: action, isCountLoading: isCountLoading, isAckAllLoading: isAckAllLoading, isCloseAllLoading: isCloseAllLoading, isSnoozeAllLoading: isSnoozeAllLoading, isDeleteAllLoading: isDeleteAllLoading, isAssignLoading: isAssignLoading, isAssignToMeLoading: isAssignToMeLoading, isAcceptAIClassificationLoading: isAcceptAIClassificationLoading, initiateAckAll: initiateAckAll, initiateCloseAll: initiateCloseAll, initiateSnoozeAll: initiateSnoozeAll, initiateDeleteAll: initiateDeleteAll, initiateAssign: initiateAssign, initiateAssignToMe: initiateAssignToMe, initiateAcceptAIClassification: initiateAcceptAIClassification, performAckAll: performAckAll, performCloseAll: performCloseAll, performSnoozeAll: performSnoozeAll, performDeleteAll: performDeleteAll, performAssign: performAssign } = groupActionsController;
    const isBulkProcessing = (0, $eJOHy.useMemo)(()=>processingBulkIds.includes(groupId), [
        processingBulkIds,
        groupId
    ]);
    const baseActions = [
        {
            label: (0, $1K3JI.default).acknowledgeAll,
            onClick: initiateAckAll,
            actionId: 'acknowledgeAll',
            requiresAlertCount: true,
            isLoading: action === 'acknowledgeAll' && isCountLoading || isAckAllLoading || isBulkProcessing && bulkLoadingState.isBulkAckLoading,
            onSubmit: performAckAll
        },
        {
            label: (0, $1K3JI.default).closeAll,
            onClick: initiateCloseAll,
            actionId: 'closeAll',
            requiresAlertCount: true,
            isLoading: action === 'closeAll' && isCountLoading || isCloseAllLoading || isBulkProcessing && bulkLoadingState.isBulkCloseLoading,
            onSubmit: performCloseAll
        },
        {
            label: (0, $1K3JI.default).assign,
            onClick: initiateAssign,
            actionId: 'assign',
            requiresAlertCount: false,
            isLoading: isAssignLoading || isBulkProcessing && bulkLoadingState.isBulkAssignLoading,
            onSubmit: performAssign
        },
        {
            label: (0, $1K3JI.default).assignToMe,
            onClick: initiateAssignToMe,
            actionId: 'assignToMe',
            requiresAlertCount: false,
            isLoading: isAssignToMeLoading || isBulkProcessing && bulkLoadingState.isBulkAssignToMeLoading,
            onSubmit: undefined
        },
        {
            label: (0, $1K3JI.default).snoozeAll,
            onClick: initiateSnoozeAll,
            actionId: 'snooze',
            requiresAlertCount: true,
            isLoading: action === 'snooze' && isCountLoading || isSnoozeAllLoading || isBulkProcessing && bulkLoadingState.isBulkSnoozeLoading,
            onSubmit: performSnoozeAll
        },
        {
            label: (0, $1K3JI.default).deleteAll,
            onClick: initiateDeleteAll,
            actionId: 'delete',
            requiresAlertCount: true,
            isLoading: action === 'delete' && isCountLoading || isDeleteAllLoading || isBulkProcessing && bulkLoadingState.isBulkDeleteLoading,
            onSubmit: performDeleteAll
        }
    ];
    // Add AI prediction action if feature flag is enabled
    if ((0, $eGOwo.fg)('aiops-uv-snr')) baseActions.push({
        label: (0, $1K3JI.default).acceptPrediction,
        onClick: ()=>initiateAcceptAIClassification({
                prediction: snrClassification
            }),
        actionId: 'aiPrediction',
        requiresAlertCount: false,
        isLoading: isAcceptAIClassificationLoading || isBulkProcessing && bulkLoadingState.isBulkAcceptAIClassificationLoading,
        onSubmit: undefined
    });
    const allActions = baseActions;
    return allActions;
};

});



const $a04b23a4cdb2ecf7$export$337d30e19f17af0f = 'fetchError';

parcelRegister("5A7zz", function(module, exports) {
$parcel$export(module.exports, "default", () => $515a66b922a4bf80$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $515a66b922a4bf80$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    deleteSavedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.delete-saved-search",
        "defaultMessage": "Delete"
    },
    confirmTrashHeading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-heading",
        "defaultMessage": "Delete saved search"
    },
    confirmTrashMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-message",
        "defaultMessage": "Are you sure you want to delete this saved search?"
    },
    errorTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-title",
        "defaultMessage": "Error"
    },
    errorMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-message",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});



parcelRegister("dzn9I", function(module, exports) {
$parcel$export(module.exports, "AlertsMenuItemContentNew", () => $59dfc06b1c57cbd1$export$f0f13aaf6210507e);

var $ezeWP = parcelRequire("ezeWP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bjI3S = parcelRequire("bjI3S");

var $guChT = parcelRequire("guChT");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $4cTDP = parcelRequire("4cTDP");

var $dZe0G = parcelRequire("dZe0G");

var $lRq8t = parcelRequire("lRq8t");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $aLENQ = parcelRequire("aLENQ");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $2QH3X = parcelRequire("2QH3X");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $4EKqI = parcelRequire("4EKqI");

var $kfvK2 = parcelRequire("kfvK2");
var $95O7y = parcelRequire("95O7y");

var $c6ZDX = parcelRequire("c6ZDX");

var $cQspR = parcelRequire("cQspR");

var $jn07M = parcelRequire("jn07M");

var $igYXn = parcelRequire("igYXn");

var $1Cl4r = parcelRequire("1Cl4r");

var $5rZKK = parcelRequire("5rZKK");

var $ih7sC = parcelRequire("ih7sC");

var $aQAXU = parcelRequire("aQAXU");

var $3y8cO = parcelRequire("3y8cO");
function $59dfc06b1c57cbd1$export$f0f13aaf6210507e({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $ezeWP.default), queryRef);
    const [savedSearchIdFromURL] = (0, $95O7y.useQueryParam)('filter');
    const [alertSearchQueryFromURL] = (0, $95O7y.useQueryParam)('query');
    const [selectedFilter, setSelectedFilter] = (0, $eJOHy.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $e6YEs.useAccountId)();
    const [viewType] = (0, $95O7y.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $1Cl4r.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($bjI3S))));
    const isAlertsRoute = (0, $kfvK2.useIsActiveRoute)(new Set([
        (0, $jn07M.eocGlobalAlertListRoute).name,
        (0, $igYXn.eocTeamAlertDetailRoute).name
    ]));
    const { setLastVisitedSearch: setLastVisitedSearch } = (0, $ih7sC.useAlertsPopoutStore)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data?.opsgenie?.savedSearches || {};
    const defaultFilters = (0, $eJOHy.useMemo)(()=>[
            {
                id: 'all',
                name: formatMessage((0, $5rZKK.default).allSearch),
                alertSearchQuery: ''
            },
            {
                id: 'open',
                name: formatMessage((0, $5rZKK.default).openSearch),
                alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_STATUS)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.STRING_LITERAL_STATUS_OPEN)}`
            },
            {
                id: 'closed',
                name: formatMessage((0, $5rZKK.default).closedSearch),
                alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_STATUS)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.STRING_LITERAL_STATUS_CLOSED)}`
            },
            {
                id: 'unacked',
                name: formatMessage((0, $5rZKK.default).unackedSearch),
                alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_STATUS)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.STRING_LITERAL_STATUS_OPEN)} ${(0, $dZe0G.LOGICAL_OPERATOR_AND)} ${(0, $dZe0G.IDENTIFIER_ACKNOWLEDGED)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'notSeen',
                name: formatMessage((0, $5rZKK.default).notSeenSearch),
                alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_IS_SEEN)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} ${(0, $dZe0G.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'assignedToMe',
                name: formatMessage((0, $5rZKK.default).assignedToMeSearch),
                alertSearchQuery: `${(0, $dZe0G.IDENTIFIER_ASSIGNEE)}${(0, $dZe0G.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
            }
        ], [
        formatMessage,
        accountId
    ]);
    const defaultFilterMenuIds = $59dfc06b1c57cbd1$var$getParentMenuId(defaultFilters);
    const defaultFilterWithComponentList = $59dfc06b1c57cbd1$var$getComponentAddedSearchObjects(defaultFilters, pagesIcon, viewType, 'default', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const sharedWithMeWithComponentList = $59dfc06b1c57cbd1$var$getComponentAddedSearchObjects(sharedWithMe || [], pagesIcon, viewType, 'sharedWithMe', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const createdByMeWithComponentList = $59dfc06b1c57cbd1$var$getComponentAddedSearchObjects(createdByMe || [], pagesIcon, viewType, 'createdByMe', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const allFiltersWithComponentList = (0, $eJOHy.useMemo)(()=>[
            ...defaultFilterWithComponentList,
            ...sharedWithMeWithComponentList,
            ...createdByMeWithComponentList
        ], [
        createdByMeWithComponentList,
        defaultFilterWithComponentList,
        sharedWithMeWithComponentList
    ]);
    const getSelectedFilterComponentIfNotDefault = (0, $eJOHy.useMemo)(()=>(filterId)=>{
            if (defaultFilters.find((item)=>item.id === filterId)) return;
            const foundComponent = [
                ...sharedWithMeWithComponentList,
                ...createdByMeWithComponentList
            ].find((item)=>item.id === filterId)?.component;
            return foundComponent;
        }, [
        createdByMeWithComponentList,
        defaultFilters,
        sharedWithMeWithComponentList
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        {
            if (selectedFilter === '') {
                const customSearches = [
                    ...createdByMeWithComponentList,
                    ...sharedWithMeWithComponentList
                ];
                if (savedSearchIdFromURL) {
                    const matchedItem = customSearches.find((item)=>(0, $c6ZDX.OpsgenieSavedSearchAri).parse(item.id).savedSearchId === savedSearchIdFromURL);
                    if (matchedItem) {
                        setSelectedFilter(matchedItem.id);
                        return;
                    }
                }
                if (alertSearchQueryFromURL) {
                    const matchedItem = customSearches.find((item)=>item.alertSearchQuery === alertSearchQueryFromURL);
                    if (matchedItem) setSelectedFilter(matchedItem.id);
                }
            }
        }
        if (!(0, $4cTDP.fg)('operations_nav4_remaining_items')) // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        {
            if (selectedFilter === '') {
                for (const item of allFiltersWithComponentList)// FIXME: This approach is not ideal. We should somehow use id instead of the alertSearchQuery.
                // https://ifountain.atlassian.net/browse/ALX-9535
                if (item.alertSearchQuery === alertSearchQueryFromURL) {
                    setSelectedFilter(item.id);
                    break;
                }
            }
        }
    }, [
        alertSearchQueryFromURL,
        allFiltersWithComponentList,
        createdByMeWithComponentList,
        savedSearchIdFromURL,
        selectedFilter,
        sharedWithMeWithComponentList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: (0, $cQspR.ALERT_LIST_SPOTLIGHT_TARGETS).sidebar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(defaultFilterMenuIds),
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-operations-alerts' : undefined
    }, formatMessage((0, $5rZKK.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, defaultFilters.map((item)=>{
        const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: href,
            menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                        level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name);
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, getSelectedFilterComponentIfNotDefault(selectedFilter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aQAXU.AlertsFlyoutMenuItem), {
        defaultFilterWithComponentList: defaultFilterWithComponentList,
        sharedWithMeWithComponentList: sharedWithMeWithComponentList,
        createdByMeWithComponentList: createdByMeWithComponentList,
        allFiltersWithComponentList: allFiltersWithComponentList
    }))));
}
function $59dfc06b1c57cbd1$var$getParentMenuId(arr) {
    return (0, $aLENQ.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}
function $59dfc06b1c57cbd1$var$getComponentAddedSearchObjects(arrayList, pagesIcon, viewType, savedSearchType, savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute) {
    return arrayList.map((item)=>{
        if ((0, $4cTDP.fg)('operations_nav4_remaining_items')) {
            const requiresSavedSearchId = item.id && savedSearchType !== 'default';
            const savedSearchId = requiresSavedSearchId ? (0, $c6ZDX.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${requiresSavedSearchId ? `&filter=${savedSearchId}` : ''}`;
            return {
                ...item,
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                    elemBefore: pagesIcon,
                    key: item.id,
                    href: href,
                    menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                    onClick: ()=>{
                        setSelectedFilter(item.id);
                        if (isAlertsRoute && (0, $4cTDP.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                            attributes: {
                                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                                level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                                itemId: item.id,
                                parentItemId: 'defaultFilters',
                                itemType: 'defaultFilter'
                            }
                        });
                    },
                    ...savedSearchType === 'createdByMe' && {
                        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y8cO.SavedSearchActionButtons), {
                            savedSearch: item
                        })
                    }
                }, item.name)
            };
        }
        return {
            ...item,
            component: (()=>{
                const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                    elemBefore: pagesIcon,
                    key: item.id,
                    href: href,
                    menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
                    onClick: ()=>{
                        setSelectedFilter(item.id);
                        if (isAlertsRoute && (0, $4cTDP.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                            attributes: {
                                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                                level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                                itemId: item.id,
                                parentItemId: 'defaultFilters',
                                itemType: 'defaultFilter'
                            }
                        });
                    },
                    ...savedSearchType === 'createdByMe' && {
                        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y8cO.SavedSearchActionButtons), {
                            savedSearch: item
                        })
                    }
                }, item.name);
            })()
        };
    });
}

});
parcelRegister("ezeWP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6b6aa5efb718a3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5396e4ff48992f40c4331cd3bb4c1bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a6b6aa5efb718a3a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "alertSearchQuery"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContentNew",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.sharedWithMe"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.createdByMe"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "opsgenie.savedSearches"
                        }
                    ]
                },
                "action": "LOG",
                "path": "opsgenie"
            }
        ],
        "type": "Query"
    };
}();
$a6b6aa5efb718a3a$var$node.hash = "639a282aa854558238900abb0fd76b71";
var $a6b6aa5efb718a3a$export$2e2bcd8739ae039 = $a6b6aa5efb718a3a$var$node;

});

parcelRegister("cQspR", function(module, exports) {
$parcel$export(module.exports, "QUERY_PARAMETER_QUERY_LABEL", () => $eaa516a20fd94eb0$export$19f7845e9b507cf2);
$parcel$export(module.exports, "QUERY_PARAMETER_VIEW_LABEL", () => $eaa516a20fd94eb0$export$8540b2e79718c77f);
$parcel$export(module.exports, "QUERY_PARAMETER_ONLY_ALERTS_LABEL", () => $eaa516a20fd94eb0$export$d0190736add6775e);
$parcel$export(module.exports, "BASE_URL", () => $eaa516a20fd94eb0$export$ca6dda5263526f75);
$parcel$export(module.exports, "ALERT_LIST_SPOTLIGHT_TARGETS", () => $eaa516a20fd94eb0$export$84fe9cd6ee892532);
const $eaa516a20fd94eb0$export$19f7845e9b507cf2 = 'query';
const $eaa516a20fd94eb0$export$8540b2e79718c77f = 'view';
const $eaa516a20fd94eb0$export$d0190736add6775e = 'onlyAlerts';
const $eaa516a20fd94eb0$export$ca6dda5263526f75 = '/jira/ops';
const $eaa516a20fd94eb0$export$84fe9cd6ee892532 = {
    sidebar: 'operations-alert-sidebar-target',
    alertHeader: 'operations-alert-header-target',
    alertActions: 'operations-alert-actions-target',
    alertSources: 'operations-alert-sources-target',
    alertResponders: 'operations-alert-responders-target'
};

});

parcelRegister("aQAXU", function(module, exports) {
$parcel$export(module.exports, "AlertsFlyoutMenuItem", () => $4286108fe5e6c6ed$export$22af2a033e73b845);

var $eJOHy = parcelRequire("eJOHy");

var $sY9BV = parcelRequire("sY9BV");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $dt3aG = parcelRequire("dt3aG");

var $bpdtz = parcelRequire("bpdtz");

var $806LH = parcelRequire("806LH");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");
var $1ejND = parcelRequire("1ejND");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $5rZKK = parcelRequire("5rZKK");
const $4286108fe5e6c6ed$export$22af2a033e73b845 = ({ defaultFilterWithComponentList: defaultFilterWithComponentList, sharedWithMeWithComponentList: sharedWithMeWithComponentList, createdByMeWithComponentList: createdByMeWithComponentList, allFiltersWithComponentList: allFiltersWithComponentList })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [textFilterValue, setTextFilterValue] = (0, $eJOHy.useState)('');
    const [foundItems, setFoundItems] = (0, $eJOHy.useState)([]);
    const handleChange = (0, $eJOHy.useCallback)((event)=>{
        const value = event.currentTarget.value;
        setTextFilterValue(value);
        const foundItemsList = allFiltersWithComponentList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase()));
        const components = foundItemsList.map((item)=>item.component);
        setFoundItems(components);
    }, [
        allFiltersWithComponentList
    ]);
    const onStopSavedSearch = (0, $eJOHy.useCallback)(()=>{
        const savedSearchesEvent = createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'jsmViewAllSavedSearchesFlyoutSearch'
        });
        (0, $kRgKj.fireUIAnalytics)(savedSearchesEvent, 'stopViewAllQueueSearch');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWy6a.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yLgR2.FlyoutMenuItemTrigger), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        })
    }, formatMessage((0, $5rZKK.default).viewAllFiltersPopupMenuButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duFAq.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, (0, $4cTDP.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4286108fe5e6c6ed$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $5rZKK.default).alerts))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4286108fe5e6c6ed$var$textfieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage((0, $5rZKK.default).viewAllFiltersSearchPlaceholder),
        placeholder: formatMessage((0, $5rZKK.default).viewAllFiltersSearchPlaceholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050",
        xcss: $4286108fe5e6c6ed$var$flyoutContentStyles
    }, !textFilterValue.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).defaultFilters))), defaultFilterWithComponentList.map((item)=>item.component), sharedWithMeWithComponentList && sharedWithMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).sharedWithMe))), sharedWithMeWithComponentList.map((item)=>item.component)), createdByMeWithComponentList && createdByMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).createdByMe))), createdByMeWithComponentList.map((item)=>item.component))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, foundItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        key: "no-item-found",
        paddingBlock: "space.100",
        xcss: $4286108fe5e6c6ed$var$noSearchResultsFoundStyles
    }, formatMessage((0, $5rZKK.default).viewAllFiltersNoResultsFoundText)) : foundItems))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050",
        xcss: $4286108fe5e6c6ed$var$flyoutContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4286108fe5e6c6ed$var$stickyBarOldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $5rZKK.default).alerts))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4286108fe5e6c6ed$var$textfieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage((0, $5rZKK.default).viewAllFiltersSearchPlaceholder),
        placeholder: formatMessage((0, $5rZKK.default).viewAllFiltersSearchPlaceholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }))), !textFilterValue.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).defaultFilters))), defaultFilterWithComponentList.map((item)=>item.component), sharedWithMeWithComponentList && sharedWithMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).sharedWithMe))), sharedWithMeWithComponentList.map((item)=>item.component)), createdByMeWithComponentList && createdByMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).createdByMe))), createdByMeWithComponentList.map((item)=>item.component))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, foundItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        key: "no-item-found",
        paddingBlock: "space.100",
        xcss: $4286108fe5e6c6ed$var$noSearchResultsFoundStyles
    }, formatMessage((0, $5rZKK.default).viewAllFiltersNoResultsFoundText)) : foundItems)))));
};
const $4286108fe5e6c6ed$var$headerStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.150',
    backgroundColor: 'utility.elevation.surface.current'
});
const $4286108fe5e6c6ed$var$stickyBarOldStyles = (0, $1DXK0.xcss)({
    position: 'sticky',
    top: '0',
    backgroundColor: 'utility.elevation.surface.current',
    zIndex: 'navigation'
});
const $4286108fe5e6c6ed$var$textfieldStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.100'
});
const $4286108fe5e6c6ed$var$noSearchResultsFoundStyles = (0, $1DXK0.xcss)({
    fontStyle: 'italic'
});
const $4286108fe5e6c6ed$var$flyoutContentStyles = (0, $1DXK0.xcss)({
    maxHeight: '500px',
    overflowY: 'auto'
});

});
parcelRegister("sY9BV", function(module, exports) {
$parcel$export(module.exports, "default", () => $15a7f7a0f56b84d4$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $eGOwo = parcelRequire("eGOwo");
const $15a7f7a0f56b84d4$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $15a7f7a0f56b84d4$var$inputMediaDisabled = null;
const $15a7f7a0f56b84d4$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $15a7f7a0f56b84d4$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $15a7f7a0f56b84d4$var$invalidStyle = null;
const $15a7f7a0f56b84d4$var$focusWithinStyle = {
    standard: "_1p9x1p6i _qao9r01l _q433q049",
    subtle: "_1p9x1p6i _qao9r01l _q433q049",
    none: "_1p9x3acm _qao918uv _q433nruj"
};
const $15a7f7a0f56b84d4$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $15a7f7a0f56b84d4$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _msj6gir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _msj6gir2"
};
const $15a7f7a0f56b84d4$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $15a7f7a0f56b84d4$var$getMaxWidth = (width)=>!width ? `100%` : width in $15a7f7a0f56b84d4$var$widthMap ? `${$15a7f7a0f56b84d4$var$widthMap[width]}px` : `${+width}px`;
const $15a7f7a0f56b84d4$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $15a7f7a0f56b84d4$var$containerStyles = null;
const $15a7f7a0f56b84d4$var$inputDisabledStyle = null;
const $15a7f7a0f56b84d4$var$inputCompactStyleWithFg = null;
const $15a7f7a0f56b84d4$var$inputCompactStyle = null;
const $15a7f7a0f56b84d4$var$inputMonospacedStyle = null;
const $15a7f7a0f56b84d4$var$inputFontStyleWithFG = null;
const $15a7f7a0f56b84d4$var$inputStyleMonospacedWithFg = null;
const $15a7f7a0f56b84d4$var$inputStyleNotDataCompactWithFG = null;
const $15a7f7a0f56b84d4$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $15a7f7a0f56b84d4$var$Textfield = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eJOHy.useRef)(null);
    const handleOnFocus = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$15a7f7a0f56b84d4$var$analyticsParams
    });
    const handleOnBlur = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$15a7f7a0f56b84d4$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eJOHy.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eJOHy.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$15a7f7a0f56b84d4$var$getMaxWidth(width)}`
        },
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            $15a7f7a0f56b84d4$var$getContainerTextBgAndBorderColor[appearance],
            $15a7f7a0f56b84d4$var$containerStyleAppearance[appearance],
            !isDisabled && $15a7f7a0f56b84d4$var$focusWithinStyle[appearance],
            !isDisabled && $15a7f7a0f56b84d4$var$hoverStyle[appearance],
            isDisabled && $15a7f7a0f56b84d4$var$containerMedia.disabled,
            isDisabled && $15a7f7a0f56b84d4$var$disabledStyle[appearance],
            isInvalid && $15a7f7a0f56b84d4$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $hcewu.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $15a7f7a0f56b84d4$export$2e2bcd8739ae039 = $15a7f7a0f56b84d4$var$Textfield;

});

parcelRegister("gWy6a", function(module, exports) {
$parcel$export(module.exports, "FlyoutMenuItem", () => $94242efad6c55614$export$34e3b4eaa687835);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7O2l7 = parcelRequire("7O2l7");

var $aNllK = parcelRequire("aNllK");

var $7Hwfq = parcelRequire("7Hwfq");

var $ih05Y = parcelRequire("ih05Y");

var $1C3j7 = parcelRequire("1C3j7");
const $94242efad6c55614$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $7O2l7.default)(isOpenControlled, ()=>isDefaultOpen);
    const previousIsOpen = (0, $aNllK.default)(isOpen);
    (0, $eJOHy.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
				 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
				 *
				 * The previous value can be equal to the current one if the component re-renders due to something else changing.
				 *
				 * In both cases the value hasn't changed and we don't want to notify consumers.
				 */ return;
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1C3j7.IsOpenContext).Provider, {
        value: isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1C3j7.SetIsOpenContext).Provider, {
            value: setIsOpen,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ih05Y.MenuListItem), {
                ref: forwardedRef,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Hwfq.Popup), {
                    id: id,
                    isOpen: isOpen,
                    children: children
                })
            })
        })
    });
});

});
parcelRegister("7Hwfq", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $ee16d6a7c83827b8$export$129a32eedafa97c5);
$parcel$export(module.exports, "PopupTrigger", () => $ee16d6a7c83827b8$export$95d4acdbab2fc6ef);
$parcel$export(module.exports, "PopupContent", () => $ee16d6a7c83827b8$export$2a2c7ba12d3231e3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $3rigy = parcelRequire("3rigy");

var $5NYi5 = parcelRequire("5NYi5");

var $eGOwo = parcelRequire("eGOwo");

var $6G5P1 = parcelRequire("6G5P1");
var $azjc1 = parcelRequire("azjc1");

var $67YQP = parcelRequire("67YQP");

var $4gPnR = parcelRequire("4gPnR");

var $3nWTz = parcelRequire("3nWTz");

var $jmQ0q = parcelRequire("jmQ0q");

var $fPiph = parcelRequire("fPiph");
const $ee16d6a7c83827b8$var$IsOpenContext = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $ee16d6a7c83827b8$var$IdContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $ee16d6a7c83827b8$var$TriggerRefContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ee16d6a7c83827b8$var$SetTriggerRefContext = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $3Vuhz.default));
const $ee16d6a7c83827b8$var$EnsureIsInsidePopupContext = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
// Used to ensure popup sub-components are used within a Popup
// and provide a useful error message if not.
const $ee16d6a7c83827b8$var$useEnsureIsInsidePopup = ()=>{
    const context = (0, $eJOHy.useContext)($ee16d6a7c83827b8$var$EnsureIsInsidePopupContext);
    (0, $8GOss.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
const $ee16d6a7c83827b8$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false })=>{
    const [triggerRef, setTriggerRef] = (0, $eJOHy.useState)(null);
    const generatedId = (0, $gl2vi.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ee16d6a7c83827b8$var$EnsureIsInsidePopupContext.Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($ee16d6a7c83827b8$var$IdContext.Provider, {
            value: id,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($ee16d6a7c83827b8$var$TriggerRefContext.Provider, {
                value: triggerRef,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($ee16d6a7c83827b8$var$SetTriggerRefContext.Provider, {
                    value: setTriggerRef,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($ee16d6a7c83827b8$var$IsOpenContext.Provider, {
                        value: isOpen,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6G5P1.Manager), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $ee16d6a7c83827b8$export$95d4acdbab2fc6ef = ({ children: children })=>{
    $ee16d6a7c83827b8$var$useEnsureIsInsidePopup();
    const isOpen = (0, $eJOHy.useContext)($ee16d6a7c83827b8$var$IsOpenContext);
    const id = (0, $eJOHy.useContext)($ee16d6a7c83827b8$var$IdContext);
    const setTriggerRef = (0, $eJOHy.useContext)($ee16d6a7c83827b8$var$SetTriggerRefContext);
    const getMergedTriggerRef = (0, $jmQ0q.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $fPiph.useGetMemoizedMergedTriggerRefNew)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $azjc1.Reference), {
        children: ({ ref: ref })=>children({
                ref: (0, $eGOwo.fg)('platform-dst-popup-compositional-trigger-ref') ? getMergedTriggerRefNew(ref, setTriggerRef) : getMergedTriggerRef(ref, setTriggerRef, isOpen),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': true
            })
    });
};
const $ee16d6a7c83827b8$var$defaultLayer = 400;
/**
 * Disables popper.js GPU acceleration for this popup.
 * This means only positioning will be used, without any transforms.
 *
 * Performance will be degraded if the popup is expected to move.
 */ const $ee16d6a7c83827b8$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $ee16d6a7c83827b8$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $ee16d6a7c83827b8$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false })=>{
    $ee16d6a7c83827b8$var$useEnsureIsInsidePopup();
    const isOpen = (0, $eJOHy.useContext)($ee16d6a7c83827b8$var$IsOpenContext);
    const id = (0, $eJOHy.useContext)($ee16d6a7c83827b8$var$IdContext);
    const triggerRef = (0, $eJOHy.useContext)($ee16d6a7c83827b8$var$TriggerRefContext);
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $3nWTz.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $eJOHy.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $5NYi5.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rigy.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gPnR.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $ee16d6a7c83827b8$var$shouldDisableGpuAccelerationModifiers : undefined
        })
    });
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
        zIndex: zIndex,
        children: popperWrapper
    });
};

});


parcelRegister("duFAq", function(module, exports) {
$parcel$export(module.exports, "FlyoutMenuItemContent", () => $ff48eed0a1a7ead5$export$2ca9a13c57a8839a);
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gyJTO = parcelRequire("gyJTO");

var $eGOwo = parcelRequire("eGOwo");

var $7Hwfq = parcelRequire("7Hwfq");

var $1C3j7 = parcelRequire("1C3j7");
const $ff48eed0a1a7ead5$var$flyoutMenuItemContentStyles = {
    root: "_1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _14b51kdj"
};
const $ff48eed0a1a7ead5$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus }, forwardedRef)=>{
    const setIsOpen = (0, $eJOHy.useContext)((0, $1C3j7.SetIsOpenContext));
    const handleClose = (0, $eJOHy.useCallback)(()=>{
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Hwfq.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        // Using a capture event listener so that we are more resilient against
        // code that stops events. We _really_ want to close the flyout whenever
        // user user clicks outside the flyout content
        shouldUseCaptureOnOutsideClick: true,
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $ff48eed0a1a7ead5$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        /**
   * Disabling GPU acceleration removes the use of `transform` by popper.js for this popup.
   *
   * This allows makers to use popups with `shouldRenderToParent` inside the flyout.
   *
   * Without this, the `transform` makes the flyout the containing element for fixed positioning.
   * Because the flyout is also a scroll container then any nested, layered element is unable to
   * escape the flyout.
   *
   * Disabling the `transform` is the simplest way to resolve this layering issue,
   * and should have negligible performance impacts, because the flyout menus should rarely
   * need to be repositioned.
   */ shouldDisableGpuAcceleration: true,
        shouldRenderToParent: (0, $eGOwo.fg)('platform_dst_nav4_flyoutmenuitem_render_to_parent'),
        children: ({ update: update })=>/*#__PURE__*/ (0, $gt9Am.jsx)($ff48eed0a1a7ead5$var$UpdatePopperOnContentResize, {
                ref: forwardedRef,
                update: update,
                children: children
            })
    });
});
function $ff48eed0a1a7ead5$var$createResizeObserver(update) {
    return new ResizeObserver(update);
}
/**
 * Will call the Popper.js `update()` method to recalculate positioning, when the flyout menu changes size.
 * This is the size of the scroll container, NOT the scroll content.
 *
 * We could potentially bake this into `@atlaskit/popup` or `@atlaskit/popper` but there are a few
 * reasons to keep it scoped to flyout menus for now:
 *
 * 1. It's easier to unwind
 * 2. We've only had bug reports for flyout menus
 * 3. Popup exposes the `update` function so consumers can already do this themselves if necessary
 * 4. Flyout menus are a lot more restricted to other popups, it might not make sense more generally
 */ const $ff48eed0a1a7ead5$var$UpdatePopperOnContentResize = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ update: update, children: children }, forwardedRef)=>{
    /**
   * Storing our `update` function in a ref so that we have a stable reference to it.
   * We need this because our `ResizeObserver` callback cannot be changed after creating it.
   */ const updateRef = (0, $eJOHy.useRef)(update);
    (0, $eJOHy.useEffect)(()=>{
        updateRef.current = update;
    }, [
        update
    ]);
    /**
   * Stable function that calls the latest `update` function by calling it through the stable ref.
   */ const triggerUpdate = (0, $eJOHy.useCallback)(()=>{
        updateRef.current?.();
    }, []);
    const [resizeObserver] = (0, $eJOHy.useState)(()=>$ff48eed0a1a7ead5$var$createResizeObserver(triggerUpdate));
    /**
   * This is a callback ref that will update which `HTMLElement` we are observing,
   * if or when the underlying `HTMLElement` changes or unmounts.
   */ const observeCallbackRef = (0, $eJOHy.useCallback)((element)=>{
        /**
     * Unobserves all observed elements.
     * Allows us to cleanup without needing to store a reference to the previous element.
     */ resizeObserver.disconnect();
        if (!element) return;
        resizeObserver.observe(element);
    }, [
        resizeObserver
    ]);
    /**
   * We need to memoize the ref otherwise `triggerUpdate` is repeatedly called.
   *
   * This stems from ResizeObserver firing once after calling `.observe()` even if there
   * was no resize.
   *
   * Without memoizing the ref, the update causes a rerender, which causes the ref to
   * get recreated, which triggers an update and so on in a loop.
   */ const ref = (0, $eJOHy.useMemo)(()=>{
        return (0, $gyJTO.default)([
            forwardedRef,
            observeCallbackRef
        ]);
    }, [
        forwardedRef,
        observeCallbackRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        children: children
    });
});

});

parcelRegister("yLgR2", function(module, exports) {
$parcel$export(module.exports, "FlyoutMenuItemTrigger", () => $764dc86723559822$export$9f59f399fe37b6ca);
/* flyout-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gyJTO = parcelRequire("gyJTO");

var $cQxBL = parcelRequire("cQxBL");

var $eGOwo = parcelRequire("eGOwo");

var $7Hwfq = parcelRequire("7Hwfq");

var $2tKAE = parcelRequire("2tKAE");
const $764dc86723559822$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $764dc86723559822$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Hwfq.PopupTrigger), {
        children: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKAE.MenuItemBase), {
                testId: testId,
                ref: (0, $gyJTO.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $764dc86723559822$var$elemAfterStyles.root
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                        label: "",
                        color: (0, $eGOwo.fg)('platform_dst_flyout_menu_item_chevron_color') ? 'currentColor' : "var(--ds-icon, #44546F)",
                        size: "small"
                    })
                }),
                onClick: onClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                isDragging: isDragging,
                hasDragIndicator: hasDragIndicator,
                dropIndicator: dropIndicator,
                children: children
            })
    }));

});





parcelRegister("eJYI8", function(module, exports) {
$parcel$export(module.exports, "useShouldRenderOverviews", () => $3b05ddd8a3a311d9$export$4ce95cd18a7f8574);

var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");
const $3b05ddd8a3a311d9$export$4ce95cd18a7f8574 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    // JSW Premium does not have Overviews because it has the newer Plans feature available
    if (appEditions.software === (0, $cblKs.PREMIUM_EDITION)) return false;
    // JWM Premium has Overviews if JSW Premium is not also present
    // Note: This means there are some cases where both the Plans and Overviews menu items will be available;
    // in these cases it's because the user should see the Plans upsell (that logic is taken care of within the Plans menu item)
    if (appEditions.core === (0, $cblKs.PREMIUM_EDITION)) return true;
    // JSM Premium has Overviews if any edition of JWM is also present
    if (appEditions.serviceDesk === (0, $cblKs.PREMIUM_EDITION) && (appEditions.core === (0, $cblKs.FREE_EDITION) || appEditions.core === (0, $cblKs.STANDARD_EDITION))) return true;
    return false;
};

});

parcelRegister("iPxs6", function(module, exports) {
$parcel$export(module.exports, "Nav4Overviews", () => $b6c1a8194153adf9$export$2c62779314f9754a);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");


var $3xLqx = parcelRequire("3xLqx");
function $b6c1a8194153adf9$export$2c62779314f9754a(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-overviews"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "overviews-section",
        packageName: (0, $f060c5ec297fdc54$export$b8b9d90f9e5bd72b),
        teamName: (0, $f060c5ec297fdc54$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3xLqx.Nav4Overviews), props)));
}

});
const $f060c5ec297fdc54$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Overviews';
const $f060c5ec297fdc54$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("3xLqx", function(module, exports) {
$parcel$export(module.exports, "Nav4Overviews", () => $569981bb8bec455b$export$2c62779314f9754a);

var $dRFH5 = parcelRequire("dRFH5");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $jW3GZ = parcelRequire("jW3GZ");

var $4JO6s = parcelRequire("4JO6s");

var $j9mbP = parcelRequire("j9mbP");
function $569981bb8bec455b$export$2c62779314f9754a({ isExpanded: isExpanded, queryRef: queryRef }) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const data = (0, $j4oe4.useFragment)((0, $dRFH5.default), queryRef);
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jW3GZ.SectionActions), {
            totalCount: data?.jira?.jwmOverviews?.totalCount ?? 0
        }), [
        data?.jira?.jwmOverviews?.totalCount
    ]);
    return isInitialSelectedPath((0, $h4Bzb.MENU_ID_OVERVIEWS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j9mbP.Nav4OverviewsForLanding), {
        isExpanded: isExpanded,
        queryRef: data,
        actionsOnHover: actionButtons
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4JO6s.Nav4OverviewsDefault), {
        isExpanded: isExpanded,
        actionsOnHover: actionButtons
    });
}

});
parcelRegister("dRFH5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e63127712a98485$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d103d7389206befab32513e4690206a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e63127712a98485$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isOverviewsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Overviews",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                    "kind": "LinkedField",
                    "name": "jwmOverviews",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isOverviewsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$5e63127712a98485$var$node.hash = "49456eee5b5999aee543e784e4db7323";
var $5e63127712a98485$export$2e2bcd8739ae039 = $5e63127712a98485$var$node;

});

parcelRegister("jW3GZ", function(module, exports) {
$parcel$export(module.exports, "SectionActions", () => $232158f00e33113a$export$51f8029abf8c56ce);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $d8UFE = parcelRequire("d8UFE");

var $956it = parcelRequire("956it");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $k71qx = parcelRequire("k71qx");

var $3KGIw = parcelRequire("3KGIw");

var $lRq8t = parcelRequire("lRq8t");



var $2LcvY = parcelRequire("2LcvY");

var $2raQl = parcelRequire("2raQl");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $ajqBI = parcelRequire("ajqBI");

var $he6m3 = parcelRequire("he6m3");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6bfva = parcelRequire("6bfva");
function $232158f00e33113a$export$51f8029abf8c56ce({ totalCount: totalCount }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, $he6m3.useOpenable)();
    const { sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent } = (0, $2raQl.useOverviewsAnalyticsL1)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOpenEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OVERVIEWS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onCreateOverviewHandler = (0, $eJOHy.useCallback)(()=>{
        sendCreateOverviewAnalyticsEvent({
            overviewLimitReached: false
        });
        onOpen();
    }, [
        onOpen,
        sendCreateOverviewAnalyticsEvent
    ]);
    const onToggleOverviewHandler = (0, $eJOHy.useCallback)(()=>{
        sendCreateOverviewAnalyticsEvent({
            overviewLimitReached: true
        });
        onToggle();
    }, [
        onToggle,
        sendCreateOverviewAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, totalCount < 10 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3KGIw.default), {
        onClose: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $6bfva.default).createOverview)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $6bfva.default).createOverview),
        onClick: onCreateOverviewHandler
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "right",
        messageId: "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.ui.section-actions.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                padding: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                space: "space.200",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
                spacing: "none",
                label: "",
                color: "var(--ds-icon-warning, #E56910)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $6bfva.default).moreThanTenWarning)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: formatMessage((0, $6bfva.default).createOverview)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $6bfva.default).createOverview),
                onClick: onToggleOverviewHandler,
                ...triggerProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: $232158f00e33113a$var$MoreMenuItems,
        onOpen: fireOpenEvent
    }));
}
function $232158f00e33113a$var$MoreMenuItems() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS
    });
}

});
parcelRegister("3KGIw", function(module, exports) {
$parcel$export(module.exports, "default", () => $550c3cd60bca5208$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3JNvy = parcelRequire("3JNvy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $fKhwG = parcelRequire("fKhwG");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $550c3cd60bca5208$var$LazyCreateOverviewModal = (0, $bQWwW.lazy)(()=>(parcelRequire("i2tZj")), {
    ssr: false,
    moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
});
const $550c3cd60bca5208$var$AsyncCreateOverviewModal = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3JNvy.ExperienceErrorBoundary), {
        experience: (0, $fKhwG.CREATE_OVERVIEW_EXPERIENCE),
        fallback: "unmount",
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "overview-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($550c3cd60bca5208$var$LazyCreateOverviewModal, {
        onClose: onClose
    })));
var $550c3cd60bca5208$export$2e2bcd8739ae039 = $550c3cd60bca5208$var$AsyncCreateOverviewModal;

});
parcelRegister("3JNvy", function(module, exports) {
$parcel$export(module.exports, "useExperienceStart", () => $6bb002e078714392$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $6bb002e078714392$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $6bb002e078714392$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $6bb002e078714392$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $6bb002e078714392$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $6bb002e078714392$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $6bb002e078714392$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $6bb002e078714392$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $6bb002e078714392$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceAbort", () => $6bb002e078714392$export$c9b6bcd70239a39c);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $cnosT = parcelRequire("cnosT");

var $hWeHP = parcelRequire("hWeHP");

var $4FduV = parcelRequire("4FduV");

var $5vQ2T = parcelRequire("5vQ2T");

var $bFY6o = parcelRequire("bFY6o");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $14RSn = parcelRequire("14RSn");
const $6bb002e078714392$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $8Uqf3.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $6bb002e078714392$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $bFY6o.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $6bb002e078714392$var$shard = (0, $hWeHP.default)('ajs-shard');
const $6bb002e078714392$var$region = (0, $hWeHP.default)('ajs-region');
const $6bb002e078714392$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $4ctwv.useExperienceSuccess)({
        experience: experience,
        attributes: {
            shard: $6bb002e078714392$var$shard,
            region: $6bb002e078714392$var$region
        }
    });
const $6bb002e078714392$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: experience,
        attributes: {
            shard: $6bb002e078714392$var$shard,
            region: $6bb002e078714392$var$region
        }
    });
    const onFail = (0, $eJOHy.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $14RSn.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $6bb002e078714392$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $eJOHy.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $eJOHy.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $eJOHy.useState)(false);
    const startExperience = $6bb002e078714392$export$675e0d25df38d426(experience);
    const onFail = $6bb002e078714392$export$606da7704d8eaf06(experience);
    const onSuccess = $6bb002e078714392$export$e94f0da4fc0603c6(experience);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, $cnosT.getGraphqlErrorAttributes)(error));
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $6bb002e078714392$export$f20b867e738a222c = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience })=>{
    const start = $6bb002e078714392$export$675e0d25df38d426(experience);
    (0, $eJOHy.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $6bb002e078714392$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $6bb002e078714392$export$606da7704d8eaf06(experience);
    (0, $eJOHy.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $6bb002e078714392$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $4FduV.ErrorPage), children: children })=>{
    const onFail = $6bb002e078714392$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bb002e078714392$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $6bb002e078714392$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));
const $6bb002e078714392$export$c9b6bcd70239a39c = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience, error: error })=>{
    const onAbort = $6bb002e078714392$export$cc92b7ce453f4403(experience);
    (0, $eJOHy.useEffect)(()=>{
        onAbort(experience.experience, {
            error: error.message
        });
    }, [
        error,
        experience,
        onAbort
    ]);
    return null;
});

});
parcelRegister("cnosT", function(module, exports) {
$parcel$export(module.exports, "shouldHandleTheError", () => $37d219879073095e$export$47770c8b6d645cdb);
$parcel$export(module.exports, "getGraphqlErrorAttributes", () => $37d219879073095e$export$b19e649eafc62480);

var $eezJL = parcelRequire("eezJL");
const $37d219879073095e$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE',
    'ISSUE_UNAVAILABLE'
];
const $37d219879073095e$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        const isWhitelisted = $37d219879073095e$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
        return !isWhitelisted;
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};
const $37d219879073095e$export$b19e649eafc62480 = (error)=>{
    const isApolloError = error instanceof (0, $eezJL.ApolloError);
    if (!isApolloError) return {};
    const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
        const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
        return JSON.stringify(errors);
    };
    return {
        statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
        errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
    };
};

});
parcelRegister("eezJL", function(module, exports) {
$parcel$export(module.exports, "NetworkStatus", () => $a5ce1825a60c4eb2$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $a5ce1825a60c4eb2$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $a5ce1825a60c4eb2$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88);

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");
var $hR4hP = parcelRequire("hR4hP");

var $7oe8F = parcelRequire("7oe8F");
var $1ZCcZ = parcelRequire("1ZCcZ");

var $2KZeD = parcelRequire("2KZeD");

var $lDEi6 = parcelRequire("lDEi6");

var $9E3xk = parcelRequire("9E3xk");
var $a5ce1825a60c4eb2$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($a5ce1825a60c4eb2$export$bd096ddbd246c79c || ($a5ce1825a60c4eb2$export$bd096ddbd246c79c = {}));
function $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $a5ce1825a60c4eb2$var$Observable = function(_super) {
    (0, $dnskZ.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $2KZeD.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $1ZCcZ.default));
function $a5ce1825a60c4eb2$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $a5ce1825a60c4eb2$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $a5ce1825a60c4eb2$var$generateErrorMessage = function(err) {
    var message = '';
    if ($a5ce1825a60c4eb2$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $a5ce1825a60c4eb2$export$26a337512320b8c6 = function(_super) {
    (0, $dnskZ.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $a5ce1825a60c4eb2$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $a5ce1825a60c4eb2$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($a5ce1825a60c4eb2$export$160bafb6ac1e0641 || ($a5ce1825a60c4eb2$export$160bafb6ac1e0641 = {}));
var $a5ce1825a60c4eb2$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $a5ce1825a60c4eb2$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $a5ce1825a60c4eb2$export$6c1b56eac59c9584 = function(_super) {
    (0, $dnskZ.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jFDfc.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($a5ce1825a60c4eb2$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading : $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            stale: false
        }));
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $hR4hP.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $lDEi6.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $hR4hP.equal)(this.variables, variables)) this.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.variables), variables);
        if (!(0, $hR4hP.equal)(this.options.variables, this.variables)) this.options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $a5ce1825a60c4eb2$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $lDEi6.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $a5ce1825a60c4eb2$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $hR4hP.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jFDfc.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jFDfc.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $a5ce1825a60c4eb2$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $hR4hP.equal)(previousVariables, variables)) _this.refetch();
                        else $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($a5ce1825a60c4eb2$var$Observable);
function $a5ce1825a60c4eb2$var$defaultSubscriptionObserverErrorCallback(error) {}
function $a5ce1825a60c4eb2$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $lDEi6.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $a5ce1825a60c4eb2$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $a5ce1825a60c4eb2$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $lDEi6.invariant)(!previousQuery || previousQuery.document === query.document || (0, $hR4hP.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading) {
            if (!(0, $hR4hP.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.refetch;
        else networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $a5ce1825a60c4eb2$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $a5ce1825a60c4eb2$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $a5ce1825a60c4eb2$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jFDfc.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jFDfc.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            return (0, $dnskZ.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jFDfc.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jFDfc.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $lDEi6.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            return (0, $dnskZ.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $dnskZ.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $9E3xk.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $9E3xk.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jFDfc.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $dnskZ.__generator)(this, function(_b) {
                mainDefinition = (0, $jFDfc.getMainDefinition)(document);
                fragments = (0, $jFDfc.getFragmentDefinitions)(document);
                fragmentMap = (0, $jFDfc.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $a5ce1825a60c4eb2$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $dnskZ.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $dnskZ.__generator)(this, function(_a) {
                            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jFDfc.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jFDfc.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $lDEi6.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jFDfc.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jFDfc.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jFDfc.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $a5ce1825a60c4eb2$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $a5ce1825a60c4eb2$var$asyncMap(observable, mapFn) {
    return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $a5ce1825a60c4eb2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $a5ce1825a60c4eb2$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $a5ce1825a60c4eb2$var$MutationStore();
        this.queryStore = new $a5ce1825a60c4eb2$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jFDfc.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $a5ce1825a60c4eb2$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $lDEi6.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $lDEi6.invariant)(mutation, 9);
                        (0, $lDEi6.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $a5ce1825a60c4eb2$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jFDfc.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($a5ce1825a60c4eb2$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jFDfc.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jFDfc.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $a5ce1825a60c4eb2$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $a5ce1825a60c4eb2$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($a5ce1825a60c4eb2$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $a5ce1825a60c4eb2$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jFDfc.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jFDfc.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jFDfc.getDefaultValues)((0, $jFDfc.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $lDEi6.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $dnskZ.__assign)({}, options);
        return new $a5ce1825a60c4eb2$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $lDEi6.invariant)(options.query, 12);
        (0, $lDEi6.invariant)(options.query.kind === 'Document', 13);
        (0, $lDEi6.invariant)(!options.returnPartialData, 14);
        (0, $lDEi6.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $lDEi6.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jFDfc.graphQLResultHasError)(result)) throw new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $lDEi6.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jFDfc.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $a5ce1825a60c4eb2$var$multiplex((0, $7oe8F.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $a5ce1825a60c4eb2$var$multiplex((0, $7oe8F.execute)(link, operation));
        } else {
            observable = $a5ce1825a60c4eb2$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $a5ce1825a60c4eb2$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $a5ce1825a60c4eb2$var$isNonEmptyArray(result.errors)) return reject(new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready && query.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $lDEi6.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $a5ce1825a60c4eb2$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $a5ce1825a60c4eb2$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jFDfc.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jFDfc.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jFDfc.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jFDfc.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jFDfc.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jFDfc.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jFDfc.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $a5ce1825a60c4eb2$var$version = "2.6.10";
var $a5ce1825a60c4eb2$var$hasSuggestedDevtools = false;
var $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $7oe8F.ApolloLink).empty();
        if (!link || !cache) throw new (0, $lDEi6.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $a5ce1825a60c4eb2$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $a5ce1825a60c4eb2$var$version;
        this.localState = new $a5ce1825a60c4eb2$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $a5ce1825a60c4eb2$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.query), options);
        (0, $lDEi6.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $7oe8F.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $a5ce1825a60c4eb2$export$2e2bcd8739ae039 = $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88;

});
parcelRegister("jFDfc", function(module, exports) {
$parcel$export(module.exports, "storeKeyNameFromField", () => $e52049bf830e5717$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e52049bf830e5717$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e52049bf830e5717$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e52049bf830e5717$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e52049bf830e5717$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e52049bf830e5717$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e52049bf830e5717$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e52049bf830e5717$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e52049bf830e5717$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e52049bf830e5717$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e52049bf830e5717$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e52049bf830e5717$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e52049bf830e5717$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e52049bf830e5717$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e52049bf830e5717$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e52049bf830e5717$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e52049bf830e5717$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e52049bf830e5717$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e52049bf830e5717$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e52049bf830e5717$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e52049bf830e5717$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e52049bf830e5717$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e52049bf830e5717$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e52049bf830e5717$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e52049bf830e5717$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e52049bf830e5717$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e52049bf830e5717$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e52049bf830e5717$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e52049bf830e5717$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e52049bf830e5717$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e52049bf830e5717$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e52049bf830e5717$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e52049bf830e5717$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e52049bf830e5717$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e52049bf830e5717$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e52049bf830e5717$export$160070228be94b08);

var $9E3xk = parcelRequire("9E3xk");

var $lDEi6 = parcelRequire("lDEi6");

var $dnskZ = parcelRequire("dnskZ");

var $5OKCR = parcelRequire("5OKCR");

var $hR4hP = parcelRequire("hR4hP");

var $igDjg = parcelRequire("igDjg");
function $e52049bf830e5717$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e52049bf830e5717$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e52049bf830e5717$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e52049bf830e5717$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e52049bf830e5717$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e52049bf830e5717$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e52049bf830e5717$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e52049bf830e5717$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e52049bf830e5717$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e52049bf830e5717$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e52049bf830e5717$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e52049bf830e5717$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e52049bf830e5717$var$isIntValue(value) || $e52049bf830e5717$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e52049bf830e5717$var$isBooleanValue(value) || $e52049bf830e5717$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e52049bf830e5717$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e52049bf830e5717$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e52049bf830e5717$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e52049bf830e5717$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e52049bf830e5717$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e52049bf830e5717$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e52049bf830e5717$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $lDEi6.InvariantError)(17);
}
function $e52049bf830e5717$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e52049bf830e5717$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e52049bf830e5717$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e52049bf830e5717$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e52049bf830e5717$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e52049bf830e5717$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($5OKCR)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e52049bf830e5717$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e52049bf830e5717$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e52049bf830e5717$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e52049bf830e5717$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e52049bf830e5717$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e52049bf830e5717$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e52049bf830e5717$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e52049bf830e5717$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $dnskZ.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e52049bf830e5717$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e52049bf830e5717$var$defaultValueFromVariable(node) {
    throw new (0, $lDEi6.InvariantError)(18);
}
function $e52049bf830e5717$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e52049bf830e5717$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e52049bf830e5717$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e52049bf830e5717$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e52049bf830e5717$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e52049bf830e5717$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e52049bf830e5717$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e52049bf830e5717$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $lDEi6.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e52049bf830e5717$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $9E3xk.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e52049bf830e5717$export$2dafb573e282fe8d(names, doc) {
    return $e52049bf830e5717$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e52049bf830e5717$export$8d1e9e5bbfa5d09a(document) {
    return document && $e52049bf830e5717$export$2dafb573e282fe8d([
        'client'
    ], document) && $e52049bf830e5717$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e52049bf830e5717$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e52049bf830e5717$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e52049bf830e5717$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $lDEi6.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $lDEi6.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $lDEi6.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e52049bf830e5717$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $lDEi6.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $lDEi6.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, document), {
        definitions: (0, $dnskZ.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e52049bf830e5717$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e52049bf830e5717$export$a92e7a440b22bdf0(doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $lDEi6.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e52049bf830e5717$export$a7d0d8111d2386df(doc) {
    (0, $lDEi6.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $lDEi6.InvariantError)(3);
        return definition;
    });
    (0, $lDEi6.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e52049bf830e5717$export$7a5b1fa979d2c158(doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e52049bf830e5717$export$78a8e95d8d43ad7f(document) {
    var def = $e52049bf830e5717$export$7a5b1fa979d2c158(document);
    (0, $lDEi6.invariant)(def, 5);
    return def;
}
function $e52049bf830e5717$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e52049bf830e5717$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e52049bf830e5717$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e52049bf830e5717$export$7a5b1fa979d2c158(doc);
    (0, $lDEi6.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e52049bf830e5717$export$772111caef41b3f5(doc) {
    (0, $lDEi6.invariant)(doc.kind === 'Document', 7);
    (0, $lDEi6.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $lDEi6.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e52049bf830e5717$export$f431198736b7f96d(queryDoc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $lDEi6.InvariantError)(10);
}
function $e52049bf830e5717$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e52049bf830e5717$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e52049bf830e5717$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e52049bf830e5717$export$e6e34fd1f2686227.apply(void 0, (0, $dnskZ.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e52049bf830e5717$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e52049bf830e5717$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e52049bf830e5717$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e52049bf830e5717$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e52049bf830e5717$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e52049bf830e5717$var$nullIfDocIsEmpty(doc) {
    return $e52049bf830e5717$var$isEmpty($e52049bf830e5717$export$7a5b1fa979d2c158(doc) || $e52049bf830e5717$export$772111caef41b3f5(doc), $e52049bf830e5717$export$193789b4c8246dd4($e52049bf830e5717$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e52049bf830e5717$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e52049bf830e5717$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e52049bf830e5717$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e52049bf830e5717$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e52049bf830e5717$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e52049bf830e5717$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e52049bf830e5717$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e52049bf830e5717$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e52049bf830e5717$export$43b332f87950a467(doc) {
    return (0, $9E3xk.visit)($e52049bf830e5717$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e52049bf830e5717$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e52049bf830e5717$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    selections: (0, $dnskZ.__spreadArrays)(selections, [
                        $e52049bf830e5717$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e52049bf830e5717$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e52049bf830e5717$export$74985f3324559867(doc) {
    return $e52049bf830e5717$export$e5ae0530da5fe96c([
        $e52049bf830e5717$var$connectionRemoveConfig
    ], $e52049bf830e5717$export$a7d0d8111d2386df(doc));
}
function $e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e52049bf830e5717$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e52049bf830e5717$var$getDirectiveMatcher(directives)) || nestedCheck && $e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e52049bf830e5717$export$deed3420cb5d2e1d(directives, doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e52049bf830e5717$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e52049bf830e5717$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e52049bf830e5717$var$getArgumentMatcher(config);
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e52049bf830e5717$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e52049bf830e5717$export$fb56ad75dd311c12(selection) || $e52049bf830e5717$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e52049bf830e5717$export$57c368c23873f32b(document) {
    var definition = $e52049bf830e5717$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $9E3xk.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e52049bf830e5717$export$8eae69e876ee321e(document) {
    $e52049bf830e5717$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e52049bf830e5717$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $9E3xk.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e52049bf830e5717$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e52049bf830e5717$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e52049bf830e5717$var$toString = Object.prototype.toString;
function $e52049bf830e5717$export$629a2bd3f5a49ecc(value) {
    return $e52049bf830e5717$var$cloneDeepHelper(value, new Map());
}
function $e52049bf830e5717$var$cloneDeepHelper(val, seen) {
    switch($e52049bf830e5717$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e52049bf830e5717$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e52049bf830e5717$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e52049bf830e5717$export$4bd44a2aa29d3d6e() {
    if (typeof $igDjg !== 'undefined' && "production") return "production";
    return 'development';
}
function $e52049bf830e5717$export$f0cb0fda19c18b37(env) {
    return $e52049bf830e5717$export$4bd44a2aa29d3d6e() === env;
}
function $e52049bf830e5717$export$f15d00aa73aafac4() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('production') === true;
}
function $e52049bf830e5717$export$df77466336fe5355() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('development') === true;
}
function $e52049bf830e5717$export$410cbc2864fa25b5() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('test') === true;
}
function $e52049bf830e5717$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e52049bf830e5717$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e52049bf830e5717$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e52049bf830e5717$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e52049bf830e5717$export$7f9c177735b71f18(obj) {
    if ($e52049bf830e5717$export$df77466336fe5355() || $e52049bf830e5717$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e52049bf830e5717$var$deepFreeze(obj);
    }
    return obj;
}
var $e52049bf830e5717$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e52049bf830e5717$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e52049bf830e5717$export$160070228be94b08(sources);
}
function $e52049bf830e5717$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e52049bf830e5717$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e52049bf830e5717$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e52049bf830e5717$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e52049bf830e5717$var$mergeHelper(target, source, pastCopies) {
    if ($e52049bf830e5717$var$isObject(source) && $e52049bf830e5717$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e52049bf830e5717$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e52049bf830e5717$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e52049bf830e5717$var$mergeHelper($e52049bf830e5717$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e52049bf830e5717$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $dnskZ.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e52049bf830e5717$var$haveWarned = Object.create({});
function $e52049bf830e5717$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e52049bf830e5717$export$f15d00aa73aafac4() && !$e52049bf830e5717$var$haveWarned[msg]) {
        if (!$e52049bf830e5717$export$410cbc2864fa25b5()) $e52049bf830e5717$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e52049bf830e5717$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("lDEi6", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $fc0c7e72915b693a$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $fc0c7e72915b693a$export$f5708dca728d7177);

var $dnskZ = parcelRequire("dnskZ");

var $igDjg = parcelRequire("igDjg");
var $fc0c7e72915b693a$var$genericMessage = "Invariant Violation";
var $fc0c7e72915b693a$var$_a = Object.setPrototypeOf, $fc0c7e72915b693a$var$setPrototypeOf = $fc0c7e72915b693a$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $fc0c7e72915b693a$var$_a;
var $fc0c7e72915b693a$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $fc0c7e72915b693a$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $fc0c7e72915b693a$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $fc0c7e72915b693a$var$genericMessage;
        $fc0c7e72915b693a$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $fc0c7e72915b693a$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $fc0c7e72915b693a$export$cea12affaee22fe8(message);
}
function $fc0c7e72915b693a$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $fc0c7e72915b693a$var$wrapConsoleMethod("warn");
    invariant.error = $fc0c7e72915b693a$var$wrapConsoleMethod("error");
})($fc0c7e72915b693a$export$f5708dca728d7177 || ($fc0c7e72915b693a$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $fc0c7e72915b693a$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $igDjg === "object") $fc0c7e72915b693a$export$e54fe5b0f43758f7 = $igDjg;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($fc0c7e72915b693a$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $fc0c7e72915b693a$var$invariant$1 = $fc0c7e72915b693a$export$f5708dca728d7177;
var $fc0c7e72915b693a$export$2e2bcd8739ae039 = $fc0c7e72915b693a$var$invariant$1;

});

parcelRegister("5OKCR", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("hR4hP", function(module, exports) {
$parcel$export(module.exports, "equal", () => $cffab61c3f329eee$export$411ce8e5a71e3069);
var $cffab61c3f329eee$var$_a = Object.prototype, $cffab61c3f329eee$var$toString = $cffab61c3f329eee$var$_a.toString, $cffab61c3f329eee$var$hasOwnProperty = $cffab61c3f329eee$var$_a.hasOwnProperty;
var $cffab61c3f329eee$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $cffab61c3f329eee$export$411ce8e5a71e3069(a, b) {
    try {
        return $cffab61c3f329eee$var$check(a, b);
    } finally{
        $cffab61c3f329eee$var$previousComparisons.clear();
    }
}
function $cffab61c3f329eee$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $cffab61c3f329eee$var$toString.call(a);
    var bTag = $cffab61c3f329eee$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($cffab61c3f329eee$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$cffab61c3f329eee$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$cffab61c3f329eee$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($cffab61c3f329eee$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$cffab61c3f329eee$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $cffab61c3f329eee$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $cffab61c3f329eee$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $cffab61c3f329eee$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $cffab61c3f329eee$export$2e2bcd8739ae039 = $cffab61c3f329eee$export$411ce8e5a71e3069;

});


parcelRegister("7oe8F", function(module, exports) {
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("1ZCcZ")).default);

var $1ZCcZ = parcelRequire("1ZCcZ");

var $lDEi6 = parcelRequire("lDEi6");

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $lDEi6.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $dnskZ.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $1ZCcZ.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $1ZCcZ.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jFDfc.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $dnskZ.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $dnskZ.__assign)({}, context, next(context));
        else context = (0, $dnskZ.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $dnskZ.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $1ZCcZ.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $1ZCcZ.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $1ZCcZ.default).of() : rightLink.request(operation) || (0, $1ZCcZ.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $1ZCcZ.default).of() : rightLink.request(operation, forward) || (0, $1ZCcZ.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $1ZCcZ.default).of();
        }) || (0, $1ZCcZ.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $1ZCcZ.default).of();
        }) || (0, $1ZCcZ.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $lDEi6.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $1ZCcZ.default).of();
}

});
parcelRegister("1ZCcZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1739205cd9dd2c7e$export$2e2bcd8739ae039);

var $f2glY = parcelRequire("f2glY");
var $1739205cd9dd2c7e$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($f2glY)));
var $1739205cd9dd2c7e$export$2e2bcd8739ae039 = $1739205cd9dd2c7e$export$77cea355fa80b5f4;

});
parcelRegister("f2glY", function(module, exports) {

module.exports = (parcelRequire("kWUY2")).Observable;

});
parcelRegister("kWUY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $f40569f3cd93f27d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f40569f3cd93f27d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f40569f3cd93f27d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f40569f3cd93f27d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f40569f3cd93f27d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $f40569f3cd93f27d$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $f40569f3cd93f27d$var$hasSymbol = function(name) {
    return $f40569f3cd93f27d$var$hasSymbols() && Boolean(Symbol[name]);
};
var $f40569f3cd93f27d$var$getSymbol = function(name) {
    return $f40569f3cd93f27d$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($f40569f3cd93f27d$var$hasSymbols() && !$f40569f3cd93f27d$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $f40569f3cd93f27d$var$SymbolIterator = $f40569f3cd93f27d$var$getSymbol('iterator');
var $f40569f3cd93f27d$var$SymbolObservable = $f40569f3cd93f27d$var$getSymbol('observable');
var $f40569f3cd93f27d$var$SymbolSpecies = $f40569f3cd93f27d$var$getSymbol('species'); // === Abstract Operations ===
function $f40569f3cd93f27d$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $f40569f3cd93f27d$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$f40569f3cd93f27d$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $f40569f3cd93f27d$var$Observable;
}
function $f40569f3cd93f27d$var$isObservable(x) {
    return x instanceof $f40569f3cd93f27d$var$Observable; // SPEC: Brand check
}
function $f40569f3cd93f27d$var$hostReportError(e) {
    if ($f40569f3cd93f27d$var$hostReportError.log) $f40569f3cd93f27d$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $f40569f3cd93f27d$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $f40569f3cd93f27d$var$hostReportError(e);
        }
    });
}
function $f40569f3cd93f27d$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $f40569f3cd93f27d$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $f40569f3cd93f27d$var$hostReportError(e);
    }
}
function $f40569f3cd93f27d$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $f40569f3cd93f27d$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $f40569f3cd93f27d$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $f40569f3cd93f27d$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $f40569f3cd93f27d$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $f40569f3cd93f27d$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $f40569f3cd93f27d$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $f40569f3cd93f27d$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $f40569f3cd93f27d$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $f40569f3cd93f27d$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $f40569f3cd93f27d$var$enqueue(function() {
            return $f40569f3cd93f27d$var$flushSubscription(subscription);
        });
        return;
    }
    $f40569f3cd93f27d$var$notifySubscription(subscription, type, value);
}
var $f40569f3cd93f27d$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $f40569f3cd93f27d$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $f40569f3cd93f27d$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $f40569f3cd93f27d$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $f40569f3cd93f27d$var$closeSubscription(this);
                    $f40569f3cd93f27d$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $f40569f3cd93f27d$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $f40569f3cd93f27d$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $f40569f3cd93f27d$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $f40569f3cd93f27d$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $f40569f3cd93f27d$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $f40569f3cd93f27d$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $f40569f3cd93f27d$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $f40569f3cd93f27d$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $f40569f3cd93f27d$var$getMethod(x, $f40569f3cd93f27d$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($f40569f3cd93f27d$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($f40569f3cd93f27d$var$hasSymbol('iterator')) {
                    method = $f40569f3cd93f27d$var$getMethod(x, $f40569f3cd93f27d$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $f40569f3cd93f27d$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $f40569f3cd93f27d$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $f40569f3cd93f27d$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $f40569f3cd93f27d$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $f40569f3cd93f27d$var$Observable;
if ($f40569f3cd93f27d$var$hasSymbols()) Object.defineProperty($f40569f3cd93f27d$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $f40569f3cd93f27d$var$SymbolObservable,
        hostReportError: $f40569f3cd93f27d$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("4FduV", function(module, exports) {
$parcel$export(module.exports, "ErrorPage", () => $5a9f2d684a64d722$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dMpy6 = parcelRequire("dMpy6");
const $5a9f2d684a64d722$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5a9f2d684a64d722$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a9f2d684a64d722$var$ErrorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bFY6o", function(module, exports) {
$parcel$export(module.exports, "useExperienceAbort", () => $668c094dfa849c1f$export$cc92b7ce453f4403);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");

var $4cTDP = parcelRequire("4cTDP");

var $aSmR5 = parcelRequire("aSmR5");
const $668c094dfa849c1f$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const self = (0, $eJOHy.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eJOHy.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        let shardAndRegionAttributes = {};
        if ((0, $4cTDP.fg)('improve_abortable_errors_experience_tracker')) shardAndRegionAttributes = {
            shard: (0, $hWeHP.default)('ajs-shard'),
            region: (0, $hWeHP.default)('ajs-region')
        };
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes
            }
        });
    }, [
        self
    ]);
};

});

parcelRegister("aqnJa", function(module, exports) {
$parcel$export(module.exports, "useExperienceFail", () => $07b7f78d48d39c0c$export$606da7704d8eaf06);

var $eJOHy = parcelRequire("eJOHy");

var $dMM78 = parcelRequire("dMM78");

var $7Jk3f = parcelRequire("7Jk3f");

var $hWeHP = parcelRequire("hWeHP");

var $aSmR5 = parcelRequire("aSmR5");
const $07b7f78d48d39c0c$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const self = (0, $eJOHy.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eJOHy.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $7Jk3f.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $dMM78.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $hWeHP.default)('ajs-shard'),
            region: (0, $hWeHP.default)('ajs-region')
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});


parcelRegister("fKhwG", function(module, exports) {
$parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", () => $553d93db7e345e1e$export$9b5e8e07ff330ef2);
$parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", () => $553d93db7e345e1e$export$a58227116ceb8b81);
$parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", () => $553d93db7e345e1e$export$e17a11e4247a14f7);
$parcel$export(module.exports, "MODAL_WIDTH", () => $553d93db7e345e1e$export$3d931b64f46140b3);
const $553d93db7e345e1e$var$PACKAGE_NAME = 'jiraBusinessEntityOverview';
const $553d93db7e345e1e$export$9b5e8e07ff330ef2 = {
    experience: 'create-overview',
    packageName: $553d93db7e345e1e$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $553d93db7e345e1e$export$a58227116ceb8b81 = {
    experience: 'edit-overview',
    packageName: $553d93db7e345e1e$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $553d93db7e345e1e$export$e17a11e4247a14f7 = {
    experience: 'delete-overview',
    packageName: $553d93db7e345e1e$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $553d93db7e345e1e$export$d03d4e78ea5b909a = 16;
const $553d93db7e345e1e$export$57ee5df6bad94642 = 400;
const $553d93db7e345e1e$export$7c9c92ba6b198ac4 = 24;
const $553d93db7e345e1e$export$c4232794452dc6e3 = 480;
const $553d93db7e345e1e$export$3d931b64f46140b3 = $553d93db7e345e1e$export$c4232794452dc6e3 + $553d93db7e345e1e$export$57ee5df6bad94642 + $553d93db7e345e1e$export$7c9c92ba6b198ac4 * 2 + $553d93db7e345e1e$export$d03d4e78ea5b909a * 2;
const $553d93db7e345e1e$var$MODAL_DIALOG_MARGIN = 120;
const $553d93db7e345e1e$export$68bc124b0fa13de0 = $553d93db7e345e1e$export$3d931b64f46140b3 + $553d93db7e345e1e$var$MODAL_DIALOG_MARGIN;

});

parcelRegister("i2tZj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kaveq")
]).then(()=>parcelRequire('h6nOp'));

});


parcelRegister("2raQl", function(module, exports) {
$parcel$export(module.exports, "useOverviewsAnalyticsL1", () => $b37d66aa4727c27d$export$209953a8bcc0c02c);

var $eJOHy = parcelRequire("eJOHy");



var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");



const $b37d66aa4727c27d$var$OVERVIEWS_NAVIGATION_MENU_ITEM = 'overviewsNavigationMenuItem';
const $b37d66aa4727c27d$export$209953a8bcc0c02c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22)
        }), []);
    // fixed item - create overview (+) button on overviews menu (top level)
    const sendCreateOverviewAnalyticsEvent = (0, $eJOHy.useCallback)(({ overviewLimitReached: overviewLimitReached })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: 'createOverview',
            overviewLimitReached: overviewLimitReached
        };
        (0, $kRgKj.fireUIAnalytics)(event, $b37d66aa4727c27d$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - overview menu item that displays overview name (can be expandable menu or a link)
    const sendOverviewMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ overviewId: overviewId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemType: (0, $6bf6536f83c22cfe$export$9cbb0f231a0ab7ea),
            itemId: overviewId
        };
        (0, $kRgKj.fireUIAnalytics)(event, $b37d66aa4727c27d$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent,
        sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent
    };
};

});

parcelRegister("6bfva", function(module, exports) {
$parcel$export(module.exports, "default", () => $05ea857bacda538a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $05ea857bacda538a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createOverview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.create-overview",
        "defaultMessage": "Create overview"
    },
    moreThanTenWarning: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.more-than-ten-warning",
        "defaultMessage": "You\u2019ve reached the limit of 10 overviews."
    }
});

});


parcelRegister("4JO6s", function(module, exports) {
$parcel$export(module.exports, "Nav4OverviewsDefault", () => $3c6252c72160dfb4$export$b582325fc571fa20);

var $eJOHy = parcelRequire("eJOHy");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $cHtIB = parcelRequire("cHtIB");


var $bHvjm = parcelRequire("bHvjm");
function $3c6252c72160dfb4$export$b582325fc571fa20({ isExpanded: isExpanded, actionsOnHover: actionsOnHover }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).OVERVIEWS);
    const cloudId = (0, $cHtIB.useCloudId)();
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $bHvjm.asyncOverviewsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $h4Bzb.MENU_ID_OVERVIEWS),
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS,
                    sectionItem: (0, $a9aec.SECTION_ITEM_OVERVIEW)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-overviews-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)((0, $h4Bzb.MENU_ID_OVERVIEWS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-overviews-default",
        packageName: (0, $f060c5ec297fdc54$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $f060c5ec297fdc54$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    })));
}

});
parcelRegister("bHvjm", function(module, exports) {
$parcel$export(module.exports, "asyncOverviewsContentViewQuery", () => $27656ec5ceb1cafd$export$355176fbb80f2347);

var $jRrGZ = parcelRequire("jRrGZ");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $27656ec5ceb1cafd$export$355176fbb80f2347 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eUn75")).then(({ OverviewsContentViewQuery: OverviewsContentViewQuery })=>OverviewsContentViewQuery), {
        moduleId: "6f0ac280",
        moduleName: "OverviewsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $jRrGZ.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("jRrGZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b6c34534cc18246$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<560d7e5e0cd70de1d6c924f49a1b8b29>>
 * @relayHash cf2a8f845ae7c967ae307cc40eb4b07f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c
const $4b6c34534cc18246$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OverviewsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OverviewsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c",
            "metadata": {},
            "name": "OverviewsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4b6c34534cc18246$var$node.hash = "5c526a403c104de05313b5b30d6f67e2";
var $4b6c34534cc18246$export$2e2bcd8739ae039 = $4b6c34534cc18246$var$node;

});

parcelRegister("eUn75", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fIPlf").then(()=>parcelRequire('lyW48'));

});



parcelRegister("j9mbP", function(module, exports) {
$parcel$export(module.exports, "Nav4OverviewsForLanding", () => $05487267dc5385dd$export$a2711da4a3d7eaa1);

var $6bM9G = parcelRequire("6bM9G");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $5vQ2T = parcelRequire("5vQ2T");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $4EKqI = parcelRequire("4EKqI");


var $2oZun = parcelRequire("2oZun");
function $05487267dc5385dd$export$a2711da4a3d7eaa1({ isExpanded: isExpanded, queryRef: queryRef, actionsOnHover: actionsOnHover }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).OVERVIEWS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const data = (0, $j4oe4.useFragment)((0, $6bM9G.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS,
                sectionItem: (0, $a9aec.SECTION_ITEM_OVERVIEW)
            });
        },
        isExpanded: isExpanded,
        menuId: (0, $h4Bzb.MENU_ID_OVERVIEWS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-overviews-landing",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        // ref={triggerRef}
        testId: (0, $azEgq.getTestId)((0, $h4Bzb.MENU_ID_OVERVIEWS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-overviews-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "nav4-sidebar-overviews-landing",
        packageName: (0, $f060c5ec297fdc54$export$b8b9d90f9e5bd72b),
        teamName: (0, $f060c5ec297fdc54$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2oZun.Nav4OverviewsContent), {
        queryRef: data
    })))));
}

});
parcelRegister("6bM9G", function(module, exports) {
$parcel$export(module.exports, "default", () => $de48e0be3e8a7658$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24c44c1cc97a0ce676ed07f685505cfc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $de48e0be3e8a7658$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4OverviewsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4OverviewsContent"
        }
    ],
    "type": "Query"
};
$de48e0be3e8a7658$var$node.hash = "dca06bec8549dba3e1ff2c708224de6f";
var $de48e0be3e8a7658$export$2e2bcd8739ae039 = $de48e0be3e8a7658$var$node;

});

parcelRegister("2oZun", function(module, exports) {
$parcel$export(module.exports, "Nav4OverviewsContent", () => $48b6fab1134858a2$export$50145651ea4a827);

var $ifc1S = parcelRequire("ifc1S");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $7qpY8 = parcelRequire("7qpY8");

var $cHtIB = parcelRequire("cHtIB");

var $8MqB9 = parcelRequire("8MqB9");

var $jBdlB = parcelRequire("jBdlB");
function $48b6fab1134858a2$export$50145651ea4a827({ queryRef: queryRef }) {
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const [{ jira: { jwmOverviews: jwmOverviews } }, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $ifc1S.default), queryRef);
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $7qpY8.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_OVERVIEWS)
    });
    const items = (0, $eJOHy.useMemo)(()=>{
        const nodes = jwmOverviews?.edges?.filter(Boolean).map((edge)=>edge.node) || [];
        const list = nodes.filter(Boolean).map((node)=>node.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jBdlB.OverviewsMenuItem), {
                key: node.id,
                id: node.id,
                name: node.name
            }) : null).filter(Boolean) ?? [];
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        jwmOverviews
    ]);
    if (!items.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8MqB9.OverviewsEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, items.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, items.list))));
}

});
parcelRegister("ifc1S", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc1ea2f6b96985ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36e48bbc800f6fcd05f9ae0af54e02a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $7qpY8 = parcelRequire("7qpY8");
const $cc1ea2f6b96985ce$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $7qpY8.default)
        }
    },
    "name": "Nav4OverviewsContent",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                        "kind": "LinkedField",
                        "name": "jwmOverviews",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraWorkManagementGiraOverview",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$cc1ea2f6b96985ce$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
var $cc1ea2f6b96985ce$export$2e2bcd8739ae039 = $cc1ea2f6b96985ce$var$node;

});
parcelRegister("7qpY8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eb1cf2fb88c14cb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<abb8f4cb57d30ce17b791d146f8f5c1e>>
 * @relayHash 89a071a83d7086613e54267a83ad5589
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334
const $1eb1cf2fb88c14cb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4OverviewsContentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4OverviewsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334",
            "metadata": {},
            "name": "Nav4OverviewsContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1eb1cf2fb88c14cb$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
var $1eb1cf2fb88c14cb$export$2e2bcd8739ae039 = $1eb1cf2fb88c14cb$var$node;

});


parcelRegister("8MqB9", function(module, exports) {
$parcel$export(module.exports, "OverviewsEmptyState", () => $0909d7b141b6d4e6$export$84d2991bdf490d9e);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $eLY13 = parcelRequire("eLY13");

var $ddGCu = parcelRequire("ddGCu");
function $0909d7b141b6d4e6$export$84d2991bdf490d9e() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eLY13.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        align: "center",
        color: "color.text.subtlest"
    }, formatMessage((0, $ddGCu.messages).noOverviews)));
}

});
parcelRegister("eLY13", function(module, exports) {
$parcel$export(module.exports, "EmptyContentMenuItem", () => $75c7d02bb13e7406$export$1d5b0e5e21ec7e84);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $ih05Y = parcelRequire("ih05Y");
const $75c7d02bb13e7406$var$styles = {
    box: "_18u01b66"
};
function $75c7d02bb13e7406$export$1d5b0e5e21ec7e84({ children: children }) {
    return /*#__PURE__*/ $eJOHy.createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        paddingInline: "space.050",
        xcss: $75c7d02bb13e7406$var$styles.box
    }, children));
}

});

parcelRegister("ddGCu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $353b77fe11b3d064$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $353b77fe11b3d064$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    noOverviews: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.empty-state.no-overviews",
        "defaultMessage": "Once you create an overview, it'll show up here."
    }
});

});


parcelRegister("jBdlB", function(module, exports) {
$parcel$export(module.exports, "OverviewsMenuItem", () => $15dafb87ae9f2178$export$1110bfd7980f0ad5);

var $eJOHy = parcelRequire("eJOHy");

var $2raQl = parcelRequire("2raQl");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $i0tMD = parcelRequire("i0tMD");

var $eL2Ux = parcelRequire("eL2Ux");
function $15dafb87ae9f2178$export$1110bfd7980f0ad5({ id: id, name: name }) {
    const { icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).OVERVIEWS);
    const { sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent } = (0, $2raQl.useOverviewsAnalyticsL1)();
    const overviewUrl = `/jira/core/overviews/${id}/summary`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendOverviewMenuItemAnalyticsEvent({
                overviewId: id
            });
        },
        href: overviewUrl,
        menuId: (0, $h4Bzb.ENTITY_ID).OVERVIEW(String(id)),
        elemBefore: icon
    }, name);
}

});





parcelRegister("2geah", function(module, exports) {
$parcel$export(module.exports, "Nav4Plans", () => $7b7c333549724e84$export$a9599e1720ee6c82);

var $eJOHy = parcelRequire("eJOHy");

var $j2LFL = parcelRequire("j2LFL");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");


var $b4whf = parcelRequire("b4whf");

var $iiV6w = parcelRequire("iiV6w");
function $7b7c333549724e84$export$a9599e1720ee6c82(props) {
    const isStandardOrFree = (0, $j2LFL.useIsStandardOrFreeJSW)();
    const isUnlicensedJsw = (0, $j2LFL.useIsUnlicensedJSW)();
    if (isUnlicensedJsw) return null;
    if (isStandardOrFree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iiV6w.Nav4PlansPremiumUpsellFeatureGate), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4.sidebar.plans"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "plans-section",
        packageName: (0, $5db379f8ce110c55$export$b8b9d90f9e5bd72b),
        teamName: (0, $5db379f8ce110c55$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b4whf.Nav4Plans), props)));
}

});
parcelRegister("j2LFL", function(module, exports) {
$parcel$export(module.exports, "useIsStandardOrFreeJSW", () => $5529ca801e310c63$export$5edaea31b41b30b);
$parcel$export(module.exports, "useIsPremiumJSW", () => $5529ca801e310c63$export$d245a3118a8b4004);
$parcel$export(module.exports, "useIsUnlicensedJSW", () => $5529ca801e310c63$export$47ec61465121ff53);

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");
const $5529ca801e310c63$export$a2bbf41e67157372 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const jswEdition = appEditions ? (0, $cblKs.getEdition)((0, $lBYgs.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $cblKs.STANDARD_EDITION);
};
const $5529ca801e310c63$export$a55cc88b2381611c = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const jswEdition = appEditions ? (0, $cblKs.getEdition)((0, $lBYgs.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $cblKs.FREE_EDITION);
};
const $5529ca801e310c63$export$5edaea31b41b30b = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const jswEdition = appEditions ? (0, $cblKs.getEdition)((0, $lBYgs.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $cblKs.STANDARD_EDITION) || jswEdition === (0, $cblKs.FREE_EDITION);
};
const $5529ca801e310c63$export$d245a3118a8b4004 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const jswEdition = appEditions ? (0, $cblKs.getEdition)((0, $lBYgs.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $cblKs.PREMIUM_EDITION);
};
const $5529ca801e310c63$export$47ec61465121ff53 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const jswEdition = appEditions ? (0, $cblKs.getEdition)((0, $lBYgs.JIRA_SOFTWARE), appEditions) : undefined;
    return !jswEdition || jswEdition === (0, $cblKs.UNLICENSED);
};

});

const $5db379f8ce110c55$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Plans';
const $5db379f8ce110c55$export$d57b6b390e78d90f = 'jet-chronos-team';

parcelRegister("b4whf", function(module, exports) {
$parcel$export(module.exports, "Nav4Plans", () => $72dd6c0b6b95f0ea$export$a9599e1720ee6c82);

var $cywsi = parcelRequire("cywsi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $j2LFL = parcelRequire("j2LFL");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $SPYRa = parcelRequire("SPYRa");

var $d4Xb7 = parcelRequire("d4Xb7");

var $4cTDP = parcelRequire("4cTDP");

var $5Xqpk = parcelRequire("5Xqpk");

var $dOtq4 = parcelRequire("dOtq4");

var $1F4Iy = parcelRequire("1F4Iy");

var $fCbwo = parcelRequire("fCbwo");

var $iiV6w = parcelRequire("iiV6w");
function $72dd6c0b6b95f0ea$export$a9599e1720ee6c82({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $cywsi.default), queryRef);
    const hasEditPermissions = data.jira?.advancedRoadmapsNavigation?.hasEditPermissions ?? false;
    const hasCreateSamplePlanPermissions = data.jira?.advancedRoadmapsNavigation?.hasCreateSamplePlanPermissions ?? false;
    const hasGlobalPlansAdminPermissions = data.jira?.advancedRoadmapsNavigation?.hasGlobalPlansAdminPermissions ?? false;
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dOtq4.Nav4PlansActionButtons), {
            hasEditPermissions: hasEditPermissions,
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
        }), [
        hasEditPermissions,
        hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions
    ]);
    const [shouldRender] = (0, $SPYRa.useNavigationPlansVisibility)();
    const isPremium = (0, $j2LFL.useIsPremiumJSW)();
    const [{ hasOpened: shouldShowNudge }] = (0, $5Xqpk.useHasOpened)();
    if (!shouldRender) return null;
    if (!isPremium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iiV6w.Nav4PlansPremiumUpsellFeatureGate), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($72dd6c0b6b95f0ea$var$Nav4PlansComponent, {
        actionButtons: actionButtons,
        isExpanded: isExpanded,
        hasFragment: data.jira?.hasIsPlansExpanded === 'JiraQuery',
        data: data,
        shouldShowNudge: shouldShowNudge
    });
}
const $72dd6c0b6b95f0ea$var$Nav4PlansComponent = (props)=>{
    const { actionButtons: actionButtons, isExpanded: isExpanded, data: data, hasFragment: hasFragment, shouldShowNudge: shouldShowNudge = true } = props;
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    if (!false && shouldShowNudge && (0, $4cTDP.fg)('jira_onboarding_experiences_a11y_fixes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $72dd6c0b6b95f0ea$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d4Xb7.NavigationPlansNavItemWrapperNudgeAsync), null, isInitialSelectedPath((0, $h4Bzb.MENU_ID_PLANS)) && hasFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fCbwo.Nav4PlansForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F4Iy.Nav4PlansDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    })));
    return isInitialSelectedPath((0, $h4Bzb.MENU_ID_PLANS)) && hasFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fCbwo.Nav4PlansForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F4Iy.Nav4PlansDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
};
const $72dd6c0b6b95f0ea$var$fullWidthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("cywsi", function(module, exports) {
$parcel$export(module.exports, "default", () => $001a05c2e2503785$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5de776fd06dc4f3b32e6bbfba7f1ef8e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $001a05c2e2503785$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isPlansExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Plans",
    "selections": [
        {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4PlansForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsPlansExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                    "kind": "LinkedField",
                    "name": "advancedRoadmapsNavigation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasEditPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCreateSamplePlanPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalPlansAdminPermissions"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$001a05c2e2503785$var$node.hash = "d94bdd2f938a10104ed5834debf9b43c";
var $001a05c2e2503785$export$2e2bcd8739ae039 = $001a05c2e2503785$var$node;

});

parcelRegister("d4Xb7", function(module, exports) {
$parcel$export(module.exports, "NavigationPlansNavItemWrapperNudgeAsync", () => $4c582040f2cb585b$export$e2e248a8ac2b2891);

var $eJOHy = parcelRequire("eJOHy");


var $kMreM = parcelRequire("kMreM");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4c582040f2cb585b$var$NavigationPlansNavItemLazy = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("236Vr")).then((exportedModule)=>exportedModule.NavigationPlansNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-plans/index.tsx"
});
const $4c582040f2cb585b$export$e2e248a8ac2b2891 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $2b839a8453de5367$export$46d9a3d441dfd22b),
        fallback: children,
        attributes: {
            nudgeId: (0, $2b839a8453de5367$export$46d9a3d441dfd22b)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-navigation-plans-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4c582040f2cb585b$var$NavigationPlansNavItemLazy, {
        nudgeId: (0, $2b839a8453de5367$export$46d9a3d441dfd22b),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("236Vr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gnWSG").then(()=>parcelRequire('4Pup2'));

});


parcelRegister("dOtq4", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansActionButtons", () => $52b359437cc8ffb5$export$a7d6536605f62394);

var $eJOHy = parcelRequire("eJOHy");

var $9J5C2 = parcelRequire("9J5C2");

var $cU43W = parcelRequire("cU43W");
const $52b359437cc8ffb5$export$a7d6536605f62394 = ({ hasEditPermissions: hasEditPermissions, hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasEditPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9J5C2.CreatePlanMenuButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cU43W.MoreMenuButton), {
        hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
    }));
};

});
parcelRegister("9J5C2", function(module, exports) {
$parcel$export(module.exports, "CreatePlanMenuButton", () => $93648edde94420aa$export$fd3582c8dd19f9f6);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");



var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $ajqBI = parcelRequire("ajqBI");

var $6c6vC = parcelRequire("6c6vC");

var $ftN6c = parcelRequire("ftN6c");

var $kRgKj = parcelRequire("kRgKj");

var $jU4e3 = parcelRequire("jU4e3");
const $93648edde94420aa$export$fd3582c8dd19f9f6 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $6c6vC.useCreateNewPlanWizardDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const clickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'createPlan'
            }
        });
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $jU4e3.default).createPlan)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $jU4e3.default).createPlan),
        onClick: clickHandler
    }));
};

});
parcelRegister("6c6vC", function(module, exports) {
$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $e513a240a32c48cc$export$f3e7d3fc94eda89a);

var $eJOHy = parcelRequire("eJOHy");

var $h6i8k = parcelRequire("h6i8k");

var $lRq8t = parcelRequire("lRq8t");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");
const $e513a240a32c48cc$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $e513a240a32c48cc$var$initialState = {
    isOpen: false,
    plan: undefined,
    isPlanCreationComplete: false,
    hasPlanInvitePermission: false
};
const $e513a240a32c48cc$var$Store = (0, $GtRbT.createStore)({
    name: $e513a240a32c48cc$var$CONTROLLER_NAME,
    initialState: $e513a240a32c48cc$var$initialState,
    actions: {
        openDrawer: (plan)=>{
            (0, $h6i8k.default)('arj-create-plan-wizard-drawer');
            return (0, $4cTDP.fg)('ensure_plan_create_ufo_event_fires_successfully') ? ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan,
                    isPlanCreationComplete: false
                }) : ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan
                });
        },
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined
                }),
        setIsPlanCreationComplete: (plan, hasPlanInvitePermission, isPlanCreationComplete = true)=>({ setState: setState })=>(0, $4cTDP.fg)('ensure_plan_create_ufo_event_fires_successfully') ? setState({
                    isPlanCreationComplete: isPlanCreationComplete,
                    plan: plan,
                    hasPlanInvitePermission: hasPlanInvitePermission
                }) : undefined
    }
});
const $e513a240a32c48cc$export$f3e7d3fc94eda89a = (0, $iJq0l.createHook)($e513a240a32c48cc$var$Store);
const $e513a240a32c48cc$export$9ec7b5762fb72de2 = (0, $6E16M.createContainer)($e513a240a32c48cc$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $e513a240a32c48cc$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $e513a240a32c48cc$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
const $e513a240a32c48cc$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $e513a240a32c48cc$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $e513a240a32c48cc$var$FALLBACK_INTL_MESSAGES
    };
    const packageName = 'jira-portfolio-3-plan-wizard';
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await import(`@atlassian/${packageName}/dist/esm/i18n/*.js`);
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/${packageName}/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $e513a240a32c48cc$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $e513a240a32c48cc$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const [state, setState] = (0, $eJOHy.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $eJOHy.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            setState((messageState)=>({
                    ...messageState,
                    loading: true
                }));
            const { default: intlMessages } = await $e513a240a32c48cc$export$19442c17ab279a67(locale);
            if (!mounted) return;
            setState((messageState)=>({
                    ...messageState,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});

parcelRegister("jU4e3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3f41557b11b332a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b3f41557b11b332a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createPlan: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.create-plan-menu-button.create-plan",
        "defaultMessage": "Create plan"
    }
});

});


parcelRegister("cU43W", function(module, exports) {
$parcel$export(module.exports, "MoreMenuButton", () => $e022ee98d829959b$export$b13d6ccdb9a8b0c5);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $4F5bb = parcelRequire("4F5bb");

var $7saMl = parcelRequire("7saMl");
var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $lRq8t = parcelRequire("lRq8t");



var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $5BAEL = parcelRequire("5BAEL");

var $ftN6c = parcelRequire("ftN6c");

var $kRgKj = parcelRequire("kRgKj");

var $6ClQD = parcelRequire("6ClQD");
const $e022ee98d829959b$var$MoreMenuItems = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { open: openCreateSamplePlanModal }] = (0, $5BAEL.useCreateSamplePlan)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const createDemoPlanClickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'createDemoPlan'
            }
        });
        openCreateSamplePlanModal();
    }, [
        openCreateSamplePlanModal,
        createAnalyticsEvent
    ]);
    const adminSettingsClickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'adminSettings'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, (hasCreateSamplePlanPermissions || hasGlobalPlansAdminPermissions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        isList: true
    }, hasCreateSamplePlanPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: createDemoPlanClickHandler
    }, formatMessage((0, $6ClQD.default).createDemoPlan)), hasGlobalPlansAdminPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/jira/plans/settings/permissions",
        onClick: adminSettingsClickHandler
    }, formatMessage((0, $6ClQD.default).adminSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).PLANS
    }));
};
const $e022ee98d829959b$export$b13d6ccdb9a8b0c5 = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const clickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: '1',
                componentType: 'fixedItemButton',
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const MenuItems = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e022ee98d829959b$var$MoreMenuItems, {
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
        }), [
        hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: MenuItems,
        name: formatMessage((0, $6ClQD.default).plansMoreMenu),
        onOpen: clickHandler
    });
};

});
parcelRegister("5BAEL", function(module, exports) {
$parcel$export(module.exports, "useCreateSamplePlan", () => $f8bfe53c17b60173$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $f8bfe53c17b60173$export$88b99aa46c223622);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7woBL = parcelRequire("7woBL");

var $eImml = parcelRequire("eImml");
const $f8bfe53c17b60173$var$CONTROLLER_NAME = 'create-sample-plan';
const $f8bfe53c17b60173$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $f8bfe53c17b60173$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($f8bfe53c17b60173$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $eImml.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $eImml.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($f8bfe53c17b60173$var$actions.close());
                } else {
                    const flagId = (0, $7woBL.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $7woBL.USER_SETTINGS_ERRORS).includes(err.message)) (0, $9pTd3.fireErrorAnalytics)({
                    error: err,
                    meta: {
                        id: `${(0, $7woBL.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $7woBL.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $7woBL.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $7woBL.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $7woBL.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorFlag, props)
                });
                dispatch($f8bfe53c17b60173$var$actions.close());
            }
        }
};
const $f8bfe53c17b60173$var$Store = (0, $GtRbT.createStore)({
    name: $f8bfe53c17b60173$var$CONTROLLER_NAME,
    initialState: $f8bfe53c17b60173$var$initialState,
    actions: $f8bfe53c17b60173$var$actions
});
const $f8bfe53c17b60173$export$53d6fde96f096b86 = (0, $iJq0l.createHook)($f8bfe53c17b60173$var$Store);
const $f8bfe53c17b60173$export$88b99aa46c223622 = (0, $6E16M.createContainer)($f8bfe53c17b60173$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("7woBL", function(module, exports) {
$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $4806c29065fbc432$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $4806c29065fbc432$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $4806c29065fbc432$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $4806c29065fbc432$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $4806c29065fbc432$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $4806c29065fbc432$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $4806c29065fbc432$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $4806c29065fbc432$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $4806c29065fbc432$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_ISSUE_TERM_REFRESH", () => $4806c29065fbc432$export$525cba92c9b435f4);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $4806c29065fbc432$export$2c5a783ab3215ce1);

var $6OQ8o = parcelRequire("6OQ8o");
const $4806c29065fbc432$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $4806c29065fbc432$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $4806c29065fbc432$var$CONTACT_SUPPORT_URL = 'https://support.atlassian.com/contact';
const $4806c29065fbc432$var$LEARN_MORE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $4806c29065fbc432$export$62da4a2465b3b309 = 255;
const $4806c29065fbc432$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $4806c29065fbc432$export$abd17266df221a92 = 'samplePlanError';
const $4806c29065fbc432$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $4806c29065fbc432$var$EMPTY_ISSUE_LINKS = 'EMPTY_ISSUE_LINKS';
const $4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION = 'NO_BROWSE_PROJECTS_PERMISSION';
const $4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION = 'NO_CREATE_ISSUES_PERMISSION';
const $4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION = 'NO_TRANSITION_ISSUES_PERMISSION';
const $4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION = 'NO_EDIT_ISSUES_PERMISSION';
const $4806c29065fbc432$var$WATCHING_DISABLED = 'WATCHING_DISABLED';
const $4806c29065fbc432$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $4806c29065fbc432$export$4a3e779cd3c10125 = [
    $4806c29065fbc432$export$e6515d2009b1dba7,
    $4806c29065fbc432$var$EMPTY_ISSUE_LINKS,
    $4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION,
    $4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION,
    $4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION,
    $4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION,
    $4806c29065fbc432$var$WATCHING_DISABLED
];
const $4806c29065fbc432$export$91ec80863c2c2030 = {
    [$4806c29065fbc432$export$e6515d2009b1dba7]: (0, $6OQ8o.default).configurationErrorTitle,
    [$4806c29065fbc432$var$EMPTY_ISSUE_LINKS]: (0, $6OQ8o.default).configurationErrorTitle,
    [$4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $6OQ8o.default).permissionErrorTitle,
    [$4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION]: (0, $6OQ8o.default).permissionErrorTitle,
    [$4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $6OQ8o.default).permissionErrorTitle,
    [$4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION]: (0, $6OQ8o.default).permissionErrorTitle,
    [$4806c29065fbc432$var$WATCHING_DISABLED]: (0, $6OQ8o.default).configurationErrorTitle,
    [$4806c29065fbc432$export$cfba07bc71f884c1]: (0, $6OQ8o.default).tryAgainErrorTitle
};
const $4806c29065fbc432$export$c43e20911e13ca0 = {
    [$4806c29065fbc432$export$e6515d2009b1dba7]: (0, $6OQ8o.default).requiredFieldsConfiguredOnIssueError,
    [$4806c29065fbc432$var$EMPTY_ISSUE_LINKS]: (0, $6OQ8o.default).emptyIssueLinksError,
    [$4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $6OQ8o.default).noBrowseProjectsPermissionError,
    [$4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION]: (0, $6OQ8o.default).noCreateIssuesPermissionError,
    [$4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $6OQ8o.default).noTransitionIssuesPermissionError,
    [$4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION]: (0, $6OQ8o.default).noEditIssuesPermissionError,
    [$4806c29065fbc432$var$WATCHING_DISABLED]: (0, $6OQ8o.default).watchingDisabledError,
    [$4806c29065fbc432$export$cfba07bc71f884c1]: (0, $6OQ8o.default).unknownExceptionError
};
const $4806c29065fbc432$export$525cba92c9b435f4 = {
    [$4806c29065fbc432$export$e6515d2009b1dba7]: (0, $6OQ8o.default).requiredFieldsConfiguredOnIssueErrorIssueTermRefresh,
    [$4806c29065fbc432$var$EMPTY_ISSUE_LINKS]: (0, $6OQ8o.default).emptyIssueLinksErrorIssueTermRefresh,
    [$4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $6OQ8o.default).noBrowseProjectsPermissionError,
    [$4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION]: (0, $6OQ8o.default).noCreateIssuesPermissionErrorIssueTermRefresh,
    [$4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $6OQ8o.default).noTransitionIssuesPermissionErrorIssueTermRefresh,
    [$4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION]: (0, $6OQ8o.default).noEditIssuesPermissionErrorIssueTermRefresh,
    [$4806c29065fbc432$var$WATCHING_DISABLED]: (0, $6OQ8o.default).watchingDisabledErrorIssueTermRefresh,
    [$4806c29065fbc432$export$cfba07bc71f884c1]: (0, $6OQ8o.default).unknownExceptionError
};
const $4806c29065fbc432$export$2c5a783ab3215ce1 = {
    [$4806c29065fbc432$export$e6515d2009b1dba7]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$EMPTY_ISSUE_LINKS]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$WATCHING_DISABLED]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$export$cfba07bc71f884c1]: {
        text: (0, $6OQ8o.default).contactSupport,
        href: $4806c29065fbc432$var$CONTACT_SUPPORT_URL
    }
};

});
parcelRegister("6OQ8o", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f42e9d3b5d8f745$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9f42e9d3b5d8f745$var$messages = (0, $7qGN1.defineMessages)({
    configurationErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
        "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
    },
    permissionErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title",
        "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
    },
    tryAgainErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
        "defaultMessage": "Try to create your demo plan again"
    },
    requiredFieldsConfiguredOnIssueError: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
        "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksError: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noBrowseProjectsPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledError: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
        "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    unknownExceptionError: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
        "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    learnMore: {
        "id": "portfolio-3-create-sample-plan.common.learn-more",
        "defaultMessage": "Learn more"
    },
    contactSupport: {
        "id": "portfolio-3-create-sample-plan.common.contact-support",
        "defaultMessage": "Contact Atlassian support"
    },
    requiredFieldsConfiguredOnIssueErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-issue-term-refresh",
        "defaultMessage": "Your work items have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error-issue-term-refresh",
        "defaultMessage": "Your site doesn't have work item links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noCreateIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create work items</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition work items</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit work items</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you have work item watching disabled. {readMoreLink}"
    }
});
var $9f42e9d3b5d8f745$export$2e2bcd8739ae039 = $9f42e9d3b5d8f745$var$messages;

});


parcelRegister("eImml", function(module, exports) {
$parcel$export(module.exports, "createSamplePlanAsync", () => $6c1e76ff051f12fd$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $6c1e76ff051f12fd$export$5d240a69af545c0d);
/**
 * Consider moving into service
 */ 
var $9pTd3 = parcelRequire("9pTd3");

var $iMEaK = parcelRequire("iMEaK");

var $14RSn = parcelRequire("14RSn");

var $3ugTQ = parcelRequire("3ugTQ");

var $7woBL = parcelRequire("7woBL");
const $6c1e76ff051f12fd$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $14RSn.default)(response.status, (0, $7woBL.UNKNOWN_EXCEPTION), response.headers.get((0, $iMEaK.TRACE_ID_HEADER)) ?? undefined, response);
};
const $6c1e76ff051f12fd$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $6c1e76ff051f12fd$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $6c1e76ff051f12fd$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $3ugTQ.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $6c1e76ff051f12fd$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $6c1e76ff051f12fd$var$throwIfNotOk(response);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const raw = await response.json();
        $6c1e76ff051f12fd$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $6c1e76ff051f12fd$var$delay();
        return $6c1e76ff051f12fd$export$5d240a69af545c0d(taskId, onUpdate);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $7woBL.USER_SETTINGS_ERRORS).includes(error.message)) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: `${(0, $7woBL.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $7woBL.ERROR_REPORTING_PACKAGE),
                teamName: (0, $7woBL.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: error?.statusCode === 500
        });
        throw error;
    }
};

});


parcelRegister("6ClQD", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb6a4d4e9598542f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fb6a4d4e9598542f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    adminSettings: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.admin-settings",
        "defaultMessage": "Admin configuration"
    },
    plansMoreMenu: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.plans-more-menu",
        "defaultMessage": "Plans"
    },
    createDemoPlan: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.create-demo-plan",
        "defaultMessage": "Create demo plan"
    }
});

});



parcelRegister("1F4Iy", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansDefault", () => $84739ac349d0e6ea$export$8edda76b63bd4bcb);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");


var $cHtIB = parcelRequire("cHtIB");

var $fXko7 = parcelRequire("fXko7");

var $b1Zrw = parcelRequire("b1Zrw");

var $fAZgY = parcelRequire("fAZgY");

var $4cTDP = parcelRequire("4cTDP");

var $fd8kn = parcelRequire("fd8kn");

var $hVzbe = parcelRequire("hVzbe");
const $84739ac349d0e6ea$export$8edda76b63bd4bcb = ({ actionsOnHover: actionsOnHover, isExpanded: isExpanded })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $hVzbe.asyncPlansSectionPlanListViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const menuId = (0, $h4Bzb.MENU_ID_PLANS);
    // remove the entire useEffect when cleaning up nav4-show-plans-when-hidden-by-default
    // we should be using the route based entry point approach instead
    // https://hello.atlassian.net/wiki/spaces/UAF/pages/2754170095/Tutorial+EntryPoints+in+Routing
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        isExpanded,
        entryPointActions
    ]);
    const onSystemToggleCallBack = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggleCallBack = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).PLANS,
                sectionItem: (0, $a9aec.SECTION_ITEM_PLANS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    const premiumLozenge = (0, $fAZgY.useMemoWithCondition)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1Zrw.PaidFeatureAwarenessPremiumLozenge), null), [], ()=>(0, $4cTDP.fg)('jfp-magma-4016-fix-side-nav-ssr-hydration'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        onSystemToggle: onSystemToggleCallBack,
        onExpansionToggle: onExpansionToggleCallBack,
        menuId: menuId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-plans-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.100",
        alignItems: "center"
    }, formattedMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXko7.PaidFeatureAwarenessRenderer), {
        component: premiumLozenge,
        placement: "navigation.plans"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-plans-default",
        packageName: (0, $5db379f8ce110c55$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $5db379f8ce110c55$export$d57b6b390e78d90f),
        // Fallback for Suspense
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
        // Props for the root component
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fd8kn.Nav4PlansFooter), null)));
};

});
parcelRegister("fXko7", function(module, exports) {
$parcel$export(module.exports, "PaidFeatureAwarenessRenderer", () => $f8b6bb4b69798669$export$64aa988820df8e0f);

var $fmj3j = parcelRequire("fmj3j");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2imLM = parcelRequire("2imLM");

var $1BZ8a = parcelRequire("1BZ8a");

var $8Q6yE = parcelRequire("8Q6yE");

var $cblKs = parcelRequire("cblKs");


var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $cHtIB = parcelRequire("cHtIB");

var $5vQ2T = parcelRequire("5vQ2T");

var $286cZ = parcelRequire("286cZ");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
const $f8b6bb4b69798669$export$dc50189dfb775e17 = (props)=>{
    const { component: component } = props;
    const cloudId = (0, $cHtIB.useCloudId)();
    const data = (0, $j4oe4.useLazyLoadQuery)((0, $fmj3j.default), {
        cloudId: cloudId
    });
    const transactionAccounts = data?.tenantContexts?.[0]?.transactionAccounts;
    const hasPaymentDetails = transactionAccounts?.some((account)=>account?.isBillToPresent === true);
    if (hasPaymentDetails !== false) return props.fallback;
    return (0, $cxKOj.expValEquals)('persistent_paid_feature_awareness_ab', 'cohort', 'variation', 'not-enrolled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "paidFeatureAwareness",
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), component) : props.fallback;
};
const $f8b6bb4b69798669$export$43f5a9f3669b7084 = (props)=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const jswEdition = appEditions.software;
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const jswEntitlementDetails = productEntitlementDetails?.[0, $315aedf92e50a945$export$1346c9aa3cbb477d];
    const trialEndTime = jswEntitlementDetails?.trialEndTime;
    const currentDate = (0, $eJOHy.useMemo)(()=>Date.now(), []);
    const isOnJSWTrial = Boolean(trialEndTime && currentDate < trialEndTime);
    /** Eligibility criteria (in order of evaluation)
   * - FG must be on
   * - Must be on JSW Premium Trial
   * - Must not have payment details entered (obtained via query)
   * - Must be in variation for experiment (fire exposure at this point)
   */ const isOnJswPremiumTrial = jswEdition === (0, $cblKs.PREMIUM_EDITION) && isOnJSWTrial;
    return isOnJswPremiumTrial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8b6bb4b69798669$export$dc50189dfb775e17, props) : props.fallback;
};
const $f8b6bb4b69798669$export$64aa988820df8e0f = (0, $286cZ.memoWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-4016-fix-side-nav-ssr-hydration'), (props)=>{
    const { fallback: fallback = null, ...rest } = props;
    return (0, $4cTDP.fg)('persistent_paid_feature_awareness') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "paidFeatureAwarenessBoundary",
        packageName: "@atlassian/jira-paid-feature-awareness-renderer",
        fallback: fallback ? ()=>fallback : 'unmount',
        teamName: "growth-tako",
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "paid-feature-awareness-renderer-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8b6bb4b69798669$export$43f5a9f3669b7084, {
        fallback: fallback,
        ...rest
    }))) : fallback;
});

});
parcelRegister("fmj3j", function(module, exports) {
$parcel$export(module.exports, "default", () => $b85b9c56b603e965$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03f6a14f0601846fec747f8aaf27a569>>
 * @relayHash 911e121fe784c925bbce3b780cefb585
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f285376005cd90c74efc7483ead8ba53771c0511d3184e208894c6c048036c3
const $b85b9c56b603e965$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PaidFeatureAwarenessRendererComponentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "transactionAccounts",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PaidFeatureAwarenessRendererComponentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "transactionAccounts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5f285376005cd90c74efc7483ead8ba53771c0511d3184e208894c6c048036c3",
            "metadata": {},
            "name": "PaidFeatureAwarenessRendererComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b85b9c56b603e965$var$node.hash = "42debe8c6363caadc4350f9048f2d4ef";
var $b85b9c56b603e965$export$2e2bcd8739ae039 = $b85b9c56b603e965$var$node;

});

parcelRegister("8Q6yE", function(module, exports) {
$parcel$export(module.exports, "useProductEntitlementDetails", () => $f5c4fe42661682eb$export$e02d6385b5d47f5d);

var $koAZ4 = parcelRequire("koAZ4");
const $f5c4fe42661682eb$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

parcelRegister("286cZ", function(module, exports) {
$parcel$export(module.exports, "memoWithCondition", () => $cea01c3b12e620fb$export$26f85cb52df6fa94);

var $eJOHy = parcelRequire("eJOHy");

var $f2JN3 = parcelRequire("f2JN3");
const $cea01c3b12e620fb$export$26f85cb52df6fa94 = (condition, Component, propsAreEqual)=>{
    return (0, $f2JN3.componentWithCondition)(condition, /*#__PURE__*/ (0, $eJOHy.memo)(Component, propsAreEqual), Component);
};

});


parcelRegister("b1Zrw", function(module, exports) {
$parcel$export(module.exports, "PaidFeatureAwarenessStandardLozenge", () => $da72e8f8e3012e93$export$7ffe6b10a925635e);
$parcel$export(module.exports, "PaidFeatureAwarenessPremiumLozenge", () => $da72e8f8e3012e93$export$c759caf4220d9852);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $b8Zvn = parcelRequire("b8Zvn");
const $da72e8f8e3012e93$export$7ffe6b10a925635e = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $b8Zvn.default).standardTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $b8Zvn.default).standardLozenge)));
};
const $da72e8f8e3012e93$export$c759caf4220d9852 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $b8Zvn.default).premiumTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $b8Zvn.default).premiumLozenge)));
};

});
parcelRegister("b8Zvn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c5951706de9b4c3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4c5951706de9b4c3$var$messages = (0, $7qGN1.defineMessages)({
    standardLozenge: {
        "id": "paid-feature-awareness.standard-lozenge",
        "defaultMessage": "Standard"
    },
    premiumLozenge: {
        "id": "paid-feature-awareness.premium-lozenge",
        "defaultMessage": "Premium"
    },
    standardGemTooltip: {
        "id": "paid-feature-awareness.standard-gem-tooltip",
        "defaultMessage": "This is a Standard and Premium plan feature"
    },
    standardTooltip: {
        "id": "paid-feature-awareness.standard-lozenge-tooltip",
        "defaultMessage": "This is a Standard plan feature"
    },
    premiumTooltip: {
        "id": "paid-feature-awareness.premium-tooltip",
        "defaultMessage": "This is a Premium plan feature"
    },
    automationTooltip: {
        "id": "paid-feature-awareness.automation-tooltip",
        "defaultMessage": "Automations varies by plan. Free: 100 rule runs/mo; Standard: 1,700 rule runs/mo; Premium: 1000 rule runs per user/mo"
    }
});
var $4c5951706de9b4c3$export$2e2bcd8739ae039 = $4c5951706de9b4c3$var$messages;

});


parcelRegister("fAZgY", function(module, exports) {
$parcel$export(module.exports, "useMemoWithCondition", () => $fad0f5e11c49ca9f$export$ed979cc60a2ab51b);
$parcel$export(module.exports, "useCallbackWithCondition", () => $fad0f5e11c49ca9f$export$a51aeb9e9cb9a97e);

var $eJOHy = parcelRequire("eJOHy");
const $fad0f5e11c49ca9f$export$ed979cc60a2ab51b = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eJOHy.useMemo)(fn, deps);
    return fn();
};
const $fad0f5e11c49ca9f$export$a51aeb9e9cb9a97e = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eJOHy.useCallback)(fn, deps);
    return fn;
};
const $fad0f5e11c49ca9f$export$b4e6dcd5702a052c = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eJOHy.useEffect)(fn, deps);
    return fn;
};

});

parcelRegister("fd8kn", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansFooter", () => $cb07aa13b68a1bb1$export$484b1d8ed55fea0a);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");

var $lRq8t = parcelRequire("lRq8t");



var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $ftN6c = parcelRequire("ftN6c");

var $kRgKj = parcelRequire("kRgKj");

var $fZoD8 = parcelRequire("fZoD8");

var $g42he = parcelRequire("g42he");
const $cb07aa13b68a1bb1$var$VIEW_ALL_PLANS_HREF = (0, $fZoD8.plansDirectoryRoute).path;
const $cb07aa13b68a1bb1$export$484b1d8ed55fea0a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const viewAllPlansClickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: 'viewAllPlans'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        href: $cb07aa13b68a1bb1$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $h4Bzb.MENU_ID_PLANS_VIEW_ALL),
        onClick: viewAllPlansClickHandler
    }, formatMessage((0, $g42he.default).viewAllPlans)))));
};

});
parcelRegister("fZoD8", function(module, exports) {
$parcel$export(module.exports, "plansDirectoryRoute", () => $5e7673d2f94ce53a$export$143b4a1ef2ffc051);
const $5e7673d2f94ce53a$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("g42he", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9bc0b6814d36290$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d9bc0b6814d36290$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllPlans: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.footer.view-all-plans",
        "defaultMessage": "View all plans"
    }
});

});


parcelRegister("hVzbe", function(module, exports) {
$parcel$export(module.exports, "asyncPlansSectionPlanListViewQuery", () => $075e17faa67f98c3$export$c2f76ac2cce77bea);

var $g2qHb = parcelRequire("g2qHb");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $075e17faa67f98c3$export$c2f76ac2cce77bea = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3e9ky")).then((module)=>module.Nav4PlansListViewQuery), {
        moduleId: "90d35cd1",
        moduleName: "Nav4PlansListViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $g2qHb.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("g2qHb", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f2af00999dde6c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<93d8926ce1193d9492d811ae578a60d8>>
 * @relayHash 2fab10c560160e66c9c146c94b56414c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f627cf35f2198f57ba8db16ad1ccb78207462df7062fd3f61aeb4c5a785a8922
const $1f2af00999dde6c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v5 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v4 /*: any*/ 
            ]
        }
    ], v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f627cf35f2198f57ba8db16ad1ccb78207462df7062fd3f61aeb4c5a785a8922",
            "metadata": {},
            "name": "Nav4PlansListViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1f2af00999dde6c4$var$node.hash = "e67bfd2d42ed8352fb6fada08981300c";
var $1f2af00999dde6c4$export$2e2bcd8739ae039 = $1f2af00999dde6c4$var$node;

});

parcelRegister("3e9ky", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6HQMp").then(()=>parcelRequire('040p3'));

});



parcelRegister("fCbwo", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansForLanding", () => $f2fdbac9b082c572$export$5e6b364538aa2f20);

var $549xW = parcelRequire("549xW");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2sLVw = parcelRequire("2sLVw");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $fXko7 = parcelRequire("fXko7");

var $b1Zrw = parcelRequire("b1Zrw");

var $fd8kn = parcelRequire("fd8kn");

var $5GUrh = parcelRequire("5GUrh");
function $f2fdbac9b082c572$export$5e6b364538aa2f20(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const data = (0, $j4oe4.useFragment)((0, $549xW.default), queryRef);
    const menuId = (0, $h4Bzb.MENU_ID_PLANS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).PLANS,
                sectionItem: (0, $a9aec.SECTION_ITEM_PLANS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-plans-landing",
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        testId: (0, $azEgq.getTestId)(menuId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.100",
        alignItems: "center"
    }, formattedMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXko7.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1Zrw.PaidFeatureAwarenessPremiumLozenge), null),
        placement: "navigation.plans"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GUrh.PlansList), {
        fragmentRef: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fd8kn.Nav4PlansFooter), null)));
}

});
parcelRegister("549xW", function(module, exports) {
$parcel$export(module.exports, "default", () => $15115ea609ce9775$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc8f47418a0aaa6d19370311cfed6f24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $15115ea609ce9775$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4PlansForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PlansList"
        }
    ],
    "type": "Query"
};
$15115ea609ce9775$var$node.hash = "4a68bb76768003096c8b0a4da492d88a";
var $15115ea609ce9775$export$2e2bcd8739ae039 = $15115ea609ce9775$var$node;

});

parcelRegister("5GUrh", function(module, exports) {
$parcel$export(module.exports, "PlansList", () => $9ebbc5a5a6019aa3$export$610289543b80d1e7);

var $bRuTL = parcelRequire("bRuTL");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $h3HFC = parcelRequire("h3HFC");

var $3uQAw = parcelRequire("3uQAw");

var $9Vlwp = parcelRequire("9Vlwp");

var $cHtIB = parcelRequire("cHtIB");

var $99ZuM = parcelRequire("99ZuM");

var $9HcBU = parcelRequire("9HcBU");

var $8c9ds = parcelRequire("8c9ds");
const $9ebbc5a5a6019aa3$var$MAX_RECENT_PLANS = 5;
const $9ebbc5a5a6019aa3$export$610289543b80d1e7 = ({ fragmentRef: fragmentRef })=>{
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { getStableItems: getStableItems } = (0, $3uQAw.useStableItems)();
    const [data, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $bRuTL.default), fragmentRef);
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $9Vlwp.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_PLANS)
    });
    const refetchOnChange = (0, $eJOHy.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $h3HFC.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraPlan',
        favouriteConnectionId: data?.jira.favouritePlans.__id || '',
        recentConnectionId: data?.jira.recentPlans.__id || '',
        refetch: refetchOnChange
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const starred = formatMessage((0, $9HcBU.default).starred);
    const recent = formatMessage((0, $9HcBU.default).recent);
    const favorites = (0, $eJOHy.useMemo)(()=>{
        if (!data) return {
            idSet: new Set(),
            list: [],
            hasItems: false
        };
        const ids = data.jira.favouritePlans.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
        const list = data.jira.favouritePlans.edges?.filter(Boolean).map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8c9ds.PlanMenuItem), {
                key: edge.node.planId,
                fragmentRef: edge.node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            })) ?? [];
        return {
            idSet: new Set(ids),
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data
    ]);
    const recentPlans = (0, $eJOHy.useMemo)(()=>{
        if (!data) return {
            list: [],
            hasItems: false
        };
        const nodes = data.jira.recentPlans.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $9ebbc5a5a6019aa3$var$MAX_RECENT_PLANS) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8c9ds.PlanMenuItem), {
                key: node.planId,
                fragmentRef: node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentPlans.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99ZuM.PlansEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, favorites.list))), recentPlans.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, recentPlans.list))));
};

});
parcelRegister("bRuTL", function(module, exports) {
$parcel$export(module.exports, "default", () => $75c592d69bcdcde1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ff8a16a0bcc9abd1a27e939d9b4ea35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $9Vlwp = parcelRequire("9Vlwp");
const $75c592d69bcdcde1$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "planId"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "PlanMenuItem"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURLPath"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $9Vlwp.default)
            }
        },
        "name": "PlansList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouritePlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PLAN"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "LOG",
                                                                    "path": "jira.favouritePlans.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "LOG",
                                                "path": "jira.favouritePlans.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.favouritePlans"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentPlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURLPath"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PLAN"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "LOG",
                                                                    "path": "jira.recentPlans.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "LOG",
                                                "path": "jira.recentPlans.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.recentPlans"
                        }
                    ]
                },
                "action": "LOG",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$75c592d69bcdcde1$var$node.hash = "e819441248aed1e08c25170c0c3e028c";
var $75c592d69bcdcde1$export$2e2bcd8739ae039 = $75c592d69bcdcde1$var$node;

});
parcelRegister("9Vlwp", function(module, exports) {
$parcel$export(module.exports, "default", () => $22648146ace329aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64bf4ac654605737b12d7b087e6fb9b3>>
 * @relayHash eecc443da9da01f9535127750ac236d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3454b9464b520488623119e6651ec1783a9e4c433c78e509cc9dccb4cd715f77
const $22648146ace329aa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURLPath"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v5 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v4 /*: any*/ 
            ]
        }
    ], v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PlanListQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "currentURLPath",
                            "variableName": "currentURLPath"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PlanListQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "currentURL",
                                    "variableName": "currentURLPath"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3454b9464b520488623119e6651ec1783a9e4c433c78e509cc9dccb4cd715f77",
            "metadata": {},
            "name": "PlanListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$22648146ace329aa$var$node.hash = "e819441248aed1e08c25170c0c3e028c";
var $22648146ace329aa$export$2e2bcd8739ae039 = $22648146ace329aa$var$node;

});


parcelRegister("99ZuM", function(module, exports) {
$parcel$export(module.exports, "PlansEmptyContent", () => $dee7b3e3d817c033$export$2b2efe96e6f14be5);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $eLY13 = parcelRequire("eLY13");

var $2pVMc = parcelRequire("2pVMc");
function $dee7b3e3d817c033$export$2b2efe96e6f14be5() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eLY13.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $2pVMc.default).noPlans)));
}

});
parcelRegister("2pVMc", function(module, exports) {
$parcel$export(module.exports, "default", () => $27b44f5ba68d266f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $27b44f5ba68d266f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noPlans: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.empty-content.no-plans",
        "defaultMessage": "Once you open or create plans, they'll show up here."
    }
});

});


parcelRegister("9HcBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc0cdc4787bee15f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bc0cdc4787bee15f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.starred",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("8c9ds", function(module, exports) {
$parcel$export(module.exports, "PlanMenuItem", () => $44ffd312fec5241a$export$5805f023607bba3d);

var $hXxGK = parcelRequire("hXxGK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $l5gdO = parcelRequire("l5gdO");



var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $iArJs = parcelRequire("iArJs");

var $fZoD8 = parcelRequire("fZoD8");

var $02kpm = parcelRequire("02kpm");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $lQ7DI = parcelRequire("lQ7DI");


var $crJvX = parcelRequire("crJvX");
const $44ffd312fec5241a$var$VIEW_ALL_PLANS_HREF = (0, $fZoD8.plansDirectoryRoute).path;
const $44ffd312fec5241a$export$5805f023607bba3d = ({ fragmentRef: fragmentRef, favouriteConnectionId: favouriteConnectionId })=>{
    const data = (0, $j4oe4.useFragment)((0, $hXxGK.default), fragmentRef);
    const planId = data?.planId;
    const isStarred = data?.favouriteValue?.isFavourite ?? false;
    const scenarioId = data.scenario.scenarioId;
    const planTitle = data.title || '';
    const planUrl = data.defaultNavigationItem?.url || (0, $02kpm.generatePath)((0, $iArJs.softwarePlanTimelineRoute).path, {
        planId: planId,
        scenarioId: scenarioId
    });
    const isReadOnly = data.isReadOnly || false;
    const isArchived = data.planStatus === 'ARCHIVED';
    const analytics = (0, $eJOHy.useMemo)(()=>({
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            level: 1,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: (0, $6bf6536f83c22cfe$export$c303e491e026ebc6),
            planId: planId ?? undefined,
            // TODO BLU-5544 send section via a single <ContextualAnalyticsData instead (which wraps the Starred or Recent panel). Use static object or useMemo, not to have rerendering issues.
            section: isStarred ? (0, $a9aec.SECTION_ITEM_STARRED) : (0, $a9aec.SECTION_ITEM_RECENT)
        }), [
        planId,
        isStarred
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            planId: planId,
            scenarioId: scenarioId,
            planTitle: planTitle,
            isReadOnly: isReadOnly,
            isArchived: isArchived,
            isStarred: isStarred,
            isUsedForSidebarNav: true,
            favouriteConnectionId: favouriteConnectionId
        }), [
        planId,
        scenarioId,
        planTitle,
        isReadOnly,
        isArchived,
        isStarred,
        favouriteConnectionId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $crJvX.asyncPlanActionMenu), entryPointParams);
    const triggerRef = (0, $lQ7DI.useHoverEntryPointTrigger)(entryPointActions);
    if (!data) return null;
    return planId && scenarioId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        analytics: analytics,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l5gdO))), {
            label: "",
            color: "currentColor"
        }),
        href: planUrl || $44ffd312fec5241a$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $h4Bzb.ENTITY_ID).PLAN(String(planId)),
        ref: triggerRef,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-plan-action-menu",
            packageName: (0, $5db379f8ce110c55$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $5db379f8ce110c55$export$d57b6b390e78d90f),
            runtimeProps: entryPointParams
        })
    }, planTitle);
};

});
parcelRegister("hXxGK", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b67a7d7bc791adf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6b8325f7e108ead155e56050c8d0ced>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b67a7d7bc791adf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PlanMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "planId"
            },
            "action": "THROW",
            "path": "planId"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "isReadOnly"
        },
        {
            "kind": "ScalarField",
            "name": "planStatus"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraScenario",
                "kind": "LinkedField",
                "name": "scenario",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "scenarioId"
                        },
                        "action": "THROW",
                        "path": "scenario.scenarioId"
                    }
                ]
            },
            "action": "THROW",
            "path": "scenario"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraSoftwareBuiltInNavigationItem"
                }
            ]
        }
    ],
    "type": "JiraPlan"
};
$5b67a7d7bc791adf$var$node.hash = "5ad97e2574c3a67e40c4df744d53456b";
var $5b67a7d7bc791adf$export$2e2bcd8739ae039 = $5b67a7d7bc791adf$var$node;

});

parcelRegister("iArJs", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTimelineRoute", () => $0f106aba29264ba4$export$61abeb6a03d23dd3);
const $0f106aba29264ba4$export$61abeb6a03d23dd3 = {
    name: 'software-plan-timeline',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
};

});

parcelRegister("lQ7DI", function(module, exports) {
$parcel$export(module.exports, "useHoverEntryPointTrigger", () => $0d56f31f523e32ec$export$129b8109f51bc05b);

var $eJOHy = parcelRequire("eJOHy");

var $dZ3jN = parcelRequire("dZ3jN");
const $0d56f31f523e32ec$export$129b8109f51bc05b = (actions, isActive = true)=>{
    const eventMap = (0, $eJOHy.useMemo)(()=>({
            mouseenter: actions.load,
            focusin: actions.load
        }), [
        actions
    ]);
    return (0, $dZ3jN.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});

parcelRegister("crJvX", function(module, exports) {
$parcel$export(module.exports, "asyncPlanActionMenu", () => $1b2b1800722bec48$export$62f1bed3a2f7698);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $1b2b1800722bec48$export$62f1bed3a2f7698 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("conm9")).then(({ AsyncPlanActionMenuContent: AsyncPlanActionMenuContent })=>AsyncPlanActionMenuContent), {
        moduleId: "3038e241",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("conm9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("7K0J5")),
    $ewTvA("kqQjY")
]).then(()=>parcelRequire('8FiQk'));

});
parcelRegister("c5iyL", function(module, exports) {
"use strict";

var $5VrpE = parcelRequire("5VrpE");
module.exports = $5VrpE(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("5VrpE", function(module, exports) {
"use strict";
let $45078a36e59142a3$var$cachedBundles = {};
let $45078a36e59142a3$var$cachedPreloads = {};
let $45078a36e59142a3$var$cachedPrefetches = {};
function $45078a36e59142a3$var$getCache(type) {
    switch(type){
        case 'preload':
            return $45078a36e59142a3$var$cachedPreloads;
        case 'prefetch':
            return $45078a36e59142a3$var$cachedPrefetches;
        default:
            return $45078a36e59142a3$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $45078a36e59142a3$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});







parcelRegister("iiV6w", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansPremiumUpsellFeatureGate", () => $e9197baf79ea0d94$export$87c172423f26b2a0);
/* Nav4PlansPremiumUpsellFeatureGate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");

var $cQxBL = parcelRequire("cQxBL");

var $aJ2YU = parcelRequire("aJ2YU");

var $8IuE5 = parcelRequire("8IuE5");

var $4cTDP = parcelRequire("4cTDP");

var $eL2Ux = parcelRequire("eL2Ux");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $iWvkh = parcelRequire("iWvkh");

var $dZ3jN = parcelRequire("dZ3jN");

var $8QNrG = parcelRequire("8QNrG");

var $8ETQ8 = parcelRequire("8ETQ8");

var $cxKOj = parcelRequire("cxKOj");
const $e9197baf79ea0d94$var$EMPTY_OBJECT = {};
const $e9197baf79ea0d94$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $e9197baf79ea0d94$export$87c172423f26b2a0 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PLANS);
    const { entryPointActions: entryPointActions } = (0, $iWvkh.useEntryPoint)((0, $8QNrG.planUpsellEntryPoint), $e9197baf79ea0d94$var$EMPTY_OBJECT);
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    if ((0, $4cTDP.fg)('supercharge_timelines_with_plans_kill_switch')) {
        const [stwpConfig, fireStwpExposure] = (0, $cxKOj.UNSAFE_noExposureExp)('supercharge_timelines_with_plans_experiment');
        const stwpCohort = stwpConfig.get('cohort', 'not-enrolled');
        if (stwpCohort === 'variation') {
            const { path: path } = (0, $8ETQ8.planUpsellRoute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                menuId: (0, $h4Bzb.MENU_ID_PLANS),
                elemBefore: icon,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    className: (0, $hcewu.default)([
                        $e9197baf79ea0d94$var$elemAfterStyles.root
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)",
                    size: "small"
                })),
                href: path,
                ref: triggerRef,
                onClick: fireStwpExposure
            }, formattedMessage);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWy6a.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yLgR2.FlyoutMenuItemTrigger), {
            interactionName: "nav4-sidebar-plans-premium-upsell",
            elemBefore: icon,
            onClick: fireStwpExposure
        }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duFAq.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJ2YU.default), null)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWy6a.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yLgR2.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-plans-premium-upsell",
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duFAq.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJ2YU.default), null)));
};

});
parcelRegister("aJ2YU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d697aed929871a35$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $abjs4 = parcelRequire("abjs4");

var $806LH = parcelRequire("806LH");

var $gn1zL = parcelRequire("gn1zL");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $58yRG = parcelRequire("58yRG");

var $aZg1w = parcelRequire("aZg1w");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $bTM76 = parcelRequire("bTM76");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $eS29z = parcelRequire("eS29z");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $aH1Gm = parcelRequire("aH1Gm");

var $ggYw9 = parcelRequire("ggYw9");

var $cHtIB = parcelRequire("cHtIB");

var $kO1ht = parcelRequire("kO1ht");

var $8Q8RO = parcelRequire("8Q8RO");

var $2lxyv = parcelRequire("2lxyv");
const $d697aed929871a35$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps'; // Statsig experiment `plans_menu_try_it_free_one_stop_shop_modal`
// the control cohort will be shown the modal, whereas the test cohort will be redirected to the billing page instead.
// if the check errors for whatever reason, we still want to show the modal, hence why it defaults to true
const $d697aed929871a35$var$PremiumFeatureGate = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const { data: { premiumTrialUpgradeLink: premiumTrialUpgradeLink } } = (0, $cxKOj.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? {
        data: {
            premiumTrialUpgradeLink: undefined
        }
    } : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aZg1w.useJswPremiumTrialUpgradeLink)({
        caller: (0, $kO1ht.PACKAGE_NAME)
    });
    const onStartTrialClick = (_, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'tryItFree'
        });
    };
    const onLearnMoreClick = (_, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'readTheGuide'
        });
    };
    // We expect all tenants to be "control" or "not-enrolled" if they see this modal, we are firing exposure (again) and including cohort in analytics for safety
    const stwpCohort = (0, $eJOHy.useMemo)(()=>{
        return (0, $4cTDP.fg)('supercharge_timelines_with_plans_kill_switch') ? (0, $cxKOj.expVal)('supercharge_timelines_with_plans_experiment', 'cohort', 'not-enrolled') : undefined;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (stwpCohort) Promise.all([
            (0, $aH1Gm.getTrialSprintBoardProjectId)(cloudId),
            (0, $ggYw9.getNumProjects)(cloudId)
        ]).then(([trialSprintBoardProjectId, numProjects])=>{
            if (typeof numProjects === 'number') {
                const numProjectsExcludingTrial = trialSprintBoardProjectId ? numProjects - 1 : numProjects;
                (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'plansPremiumFeatureGate rendered', {
                    stwpCohort: stwpCohort,
                    numProjectsExcludingTrial: numProjectsExcludingTrial
                });
            }
        });
    }, [
        stwpCohort,
        cloudId,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "plansPremiumFeatureGate",
        sourceType: "Modal",
        attributes: {
            stwpCohort: stwpCohort
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$MenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$MenuHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Q8RO.FeatureGateLogo), {
        alt: "",
        colorMode: colorMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $2lxyv.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d697aed929871a35$var$contentDescriptionStyles
    }, formatMessage((0, $2lxyv.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$LearnMoreButton, {
        appearance: "link",
        href: $d697aed929871a35$var$LEARN_MORE_LINK,
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage((0, $2lxyv.default).learnMoreLink)), (0, $cxKOj.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$TryPremiumButton, {
        onClick: onStartTrialClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gn1zL))), {
            label: formatMessage((0, $2lxyv.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $2lxyv.default).startTrialButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$TryPremiumButtonDirectLink, {
        href: premiumTrialUpgradeLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gn1zL))), {
            label: formatMessage((0, $2lxyv.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $2lxyv.default).startTrialButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
};
var $d697aed929871a35$export$2e2bcd8739ae039 = $d697aed929871a35$var$PremiumFeatureGate;
const $d697aed929871a35$var$TryPremiumButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bTM76.PremiumUpgradeModalEntryPointButton), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-radius-small, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $d697aed929871a35$var$TryPremiumButtonDirectLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-radius-small, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $d697aed929871a35$var$LearnMoreButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    maxWidth: '250px',
                    marginRight: "var(--ds-space-200, 16px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d697aed929871a35$var$MenuContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _11q717kt _189ee4h9 _1dqonqa1 _1h6d3acm _vchhusvi _qjkjusvi _1y1m18uv _p12f4lgm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d697aed929871a35$var$MenuHeaderContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7gup1 _2rko14xi _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3il1r9 _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d697aed929871a35$var$ContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7vuon _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $d697aed929871a35$var$contentDescriptionStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d697aed929871a35$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7vuon _2rko8p36 _ca0qidpf _u5f31ejb _n3td1ejb _19bv1ejb _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gn1zL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a1236e7c4f5bc3d22979b9f93d47c5b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beb0043b8daf977a$var$_react = $beb0043b8daf977a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $beb0043b8daf977a$var$_baseNew = $beb0043b8daf977a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $beb0043b8daf977a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $beb0043b8daf977a$var$PremiumIcon = (props)=>/*#__PURE__*/ $beb0043b8daf977a$var$_react.default.createElement($beb0043b8daf977a$var$_baseNew.default, Object.assign({
        name: "PremiumIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$beb0043b8daf977a$var$PremiumIcon.displayName = 'PremiumIcon';
var $beb0043b8daf977a$var$_default = module.exports.default = $beb0043b8daf977a$var$PremiumIcon;

});

parcelRegister("aZg1w", function(module, exports) {
$parcel$export(module.exports, "useJswPremiumTrialUpgradeLink", () => $a48f7635d074a309$export$645eda3f5f2163ec);

var $FhXEJ = parcelRequire("FhXEJ");


var $cblKs = parcelRequire("cblKs");

var $koAZ4 = parcelRequire("koAZ4");

var $i66VH = parcelRequire("i66VH");
const $a48f7635d074a309$export$645eda3f5f2163ec = ({ deepLink: deepLink = true, skip: skip = false, caller: caller })=>{
    const { productEntitlementDetails: productEntitlementDetails } = (0, $koAZ4.useTenantContext)();
    const jswEntitlement = productEntitlementDetails?.[0, $315aedf92e50a945$export$1346c9aa3cbb477d];
    const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
    const { data: data, ...rest } = (0, $i66VH.useGetBillingPageUrl)({
        isUsingCcp: isJswUsingCcp,
        editionToUpgradeTo: deepLink ? (0, $cblKs.PREMIUM_EDITION) : undefined,
        caller: caller,
        skip: skip,
        subProduct: (0, $FhXEJ.SOFTWARE_PROJECT)
    });
    return {
        data: {
            premiumTrialUpgradeLink: data.billingPageUrl
        },
        ...rest
    };
};

});
parcelRegister("i66VH", function(module, exports) {
$parcel$export(module.exports, "useGetBillingPageUrl", () => $97dc3778f6a7c40c$export$7b1495b7581dcd01);

var $eJOHy = parcelRequire("eJOHy");

var $kFw1p = parcelRequire("kFw1p");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $g9Vr6 = parcelRequire("g9Vr6");


var $cblKs = parcelRequire("cblKs");

var $figsJ = parcelRequire("figsJ");

var $koAZ4 = parcelRequire("koAZ4");

var $lB9yu = parcelRequire("lB9yu");

var $iVQXn = parcelRequire("iVQXn");

var $ccm7u = parcelRequire("ccm7u");

var $gvwWc = parcelRequire("gvwWc");
const $97dc3778f6a7c40c$export$7b1495b7581dcd01 = ({ isUsingCcp: isUsingCcp, editionToUpgradeTo: editionToUpgradeTo, caller: caller, skip: skip = false, subProduct: subProduct, onError: onError })=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $eJOHy.useState)();
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const contextSubProduct = (0, $figsJ.useSubProduct)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const subProductToUse = subProduct || contextSubProduct;
    (0, $eJOHy.useEffect)(()=>{
        if (skip) return;
        const loadBillingInfo = async ()=>{
            try {
                const explicitlyLicensedProducts = (0, $kFw1p.default)(tenantContext);
                const productKey = (0, $gvwWc.getProductKey)(subProductToUse, explicitlyLicensedProducts);
                const referrerKey = (0, $iVQXn.getProductReferrerKey)(productKey);
                // The product key as used by Commerce.
                // JPD product key as used by Commerce does not include .ondemand
                const commerceProductKey = productKey === (0, $315aedf92e50a945$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
                const entitlementId = productKey ? tenantContext.productEntitlementDetails?.[productKey]?.entitlementId : null;
                if (isUsingCcp) {
                    if (!entitlementId) {
                        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'RetrieveEntitlementId failed', {
                            caller: caller,
                            productKey: productKey,
                            productEntitlementDetails: JSON.stringify(tenantContext.productEntitlementDetails),
                            subProduct: subProductToUse
                        });
                        throw new Error('Empty entitlement ID');
                    }
                    const ccpTransactionAccountId = await (0, $iVQXn.getCcpTransactionAccountId)(entitlementId);
                    // List of valid referrer values
                    // https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan#How-to-use-this-deeplink%3F
                    const ccpBaseUrl = `${(0, $ccm7u.getAdminBaseUrl)()}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}&enableMpucup=true`;
                    switch(editionToUpgradeTo){
                        case 0, $cblKs.STANDARD_EDITION:
                        case 0, $cblKs.PREMIUM_EDITION:
                            setBillingPageUrl(`${ccpBaseUrl}&offeringName=${(0, $lB9yu.EDITION_KEY)[editionToUpgradeTo]}`);
                            break;
                        default:
                            setBillingPageUrl(ccpBaseUrl);
                    }
                } else // HAMS Billing System
                switch(editionToUpgradeTo){
                    case 0, $cblKs.STANDARD_EDITION:
                    case 0, $cblKs.PREMIUM_EDITION:
                        setBillingPageUrl(`${(0, $ccm7u.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${(0, $lB9yu.EDITION_KEY)[editionToUpgradeTo]}`);
                        break;
                    default:
                        setBillingPageUrl(`${(0, $ccm7u.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}`);
                }
            } catch (e) {
                setError(e);
                if (onError && e instanceof Error) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
                onError(e);
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        caller,
        createAnalyticsEvent,
        editionToUpgradeTo,
        isUsingCcp,
        onError,
        orgId,
        skip,
        subProduct,
        subProductToUse,
        tenantContext,
        tenantContext.cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
parcelRegister("kFw1p", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb1246aba5ea09ac$export$2e2bcd8739ae039);

const $bb1246aba5ea09ac$var$getExplicitlyLicensedProducts = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $315aedf92e50a945$export$db515c8cec1e6f79] && result.push((0, $315aedf92e50a945$export$db515c8cec1e6f79));
    licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] && result.push((0, $315aedf92e50a945$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $315aedf92e50a945$export$1346c9aa3cbb477d] && result.push((0, $315aedf92e50a945$export$1346c9aa3cbb477d));
    licensedProducts[0, $315aedf92e50a945$export$202f50ee62667e32] && result.push((0, $315aedf92e50a945$export$202f50ee62667e32));
    return result;
};
var $bb1246aba5ea09ac$export$2e2bcd8739ae039 = $bb1246aba5ea09ac$var$getExplicitlyLicensedProducts;

});

parcelRegister("figsJ", function(module, exports) {
$parcel$export(module.exports, "useSubProduct", () => $eeb1612abd150435$export$16aa2ad52cd8992a);
$parcel$export(module.exports, "subProductFromProjectTypeForAnalytics", () => $eeb1612abd150435$export$9243583e56af95f6);
$parcel$export(module.exports, "useSubProductForAnalytics", () => $eeb1612abd150435$export$cbfa57dd4a0c679e);

var $4cTDP = parcelRequire("4cTDP");

var $6nVJI = parcelRequire("6nVJI");
const $eeb1612abd150435$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        case 'customer_service':
            if ((0, $4cTDP.fg)('berry-6207-csm-analytic-subproduct')) return 'customer-service';
            return 'unknown';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $eeb1612abd150435$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $6nVJI.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $eeb1612abd150435$export$246e1e2a5c86a633(data.project.type);
};
const $eeb1612abd150435$export$9243583e56af95f6 = (projectType)=>{
    if (projectType === 'product_discovery') return 'polaris';
    return $eeb1612abd150435$export$246e1e2a5c86a633(projectType);
};
const $eeb1612abd150435$export$cbfa57dd4a0c679e = ()=>{
    const [{ data: data }] = (0, $6nVJI.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $eeb1612abd150435$export$9243583e56af95f6(data.project.type);
};

});
parcelRegister("6nVJI", function(module, exports) {
$parcel$export(module.exports, "useContainerContext", () => $6342ac67d1a862a1$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $6342ac67d1a862a1$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $3luhJ = parcelRequire("3luhJ");

var $9pJMP = parcelRequire("9pJMP");

var $eJrcF = parcelRequire("eJrcF");

var $kQSJV = parcelRequire("kQSJV");
const $6342ac67d1a862a1$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eJOHy.useMemo)(()=>data && (0, $kQSJV.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $6342ac67d1a862a1$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $3luhJ.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eJOHy.useMemo)(()=>data && (0, $kQSJV.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $6342ac67d1a862a1$export$c7066c2d215990cf = ()=>{
    const projectContext = $6342ac67d1a862a1$var$useProjectContext();
    const userBoardContext = $6342ac67d1a862a1$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $6342ac67d1a862a1$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $6342ac67d1a862a1$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$6342ac67d1a862a1$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("kQSJV", function(module, exports) {
$parcel$export(module.exports, "getUserContext", () => $3546d4ad536b057d$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $3546d4ad536b057d$export$d17fffd59c7b3c60);

var $4cTDP = parcelRequire("4cTDP");

var $FhXEJ = parcelRequire("FhXEJ");

var $imXGf = parcelRequire("imXGf");
const $3546d4ad536b057d$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $3546d4ad536b057d$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $3546d4ad536b057d$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4cTDP.fg)('jcs_project_type_m3')) return 0, $FhXEJ.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $FhXEJ.CORE_PROJECT;
        case 'software':
            return 0, $FhXEJ.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $FhXEJ.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $3546d4ad536b057d$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $imXGf.extractData)(projectNavInfo);
    const scope = $3546d4ad536b057d$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $3546d4ad536b057d$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $imXGf.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("lB9yu", function(module, exports) {
$parcel$export(module.exports, "EDITION_KEY", () => $be8e62b37240bbc2$export$d73720c31c622c1f);

var $cblKs = parcelRequire("cblKs");
const $be8e62b37240bbc2$export$d73720c31c622c1f = {
    STANDARD_EDITION: (0, $cblKs.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $cblKs.PREMIUM_EDITION_KEY)
};

});

parcelRegister("iVQXn", function(module, exports) {
$parcel$export(module.exports, "getProductReferrerKey", () => $15ad553fd61d4764$export$b4fb3304d5d8fc5f);
$parcel$export(module.exports, "getCcpTransactionAccountId", () => $15ad553fd61d4764$export$5186b9d213f626fd);

var $hgi0g = parcelRequire("hgi0g");

const $15ad553fd61d4764$export$b4fb3304d5d8fc5f = (productKey)=>{
    if (productKey === (0, $315aedf92e50a945$export$1346c9aa3cbb477d)) return 'jsw';
    if (productKey === (0, $315aedf92e50a945$export$c8c1c8c3f8ddba61)) return 'jsm';
    if (productKey === (0, $315aedf92e50a945$export$202f50ee62667e32)) return 'jpd';
    if (productKey === (0, $315aedf92e50a945$export$db515c8cec1e6f79)) return 'jwm';
    return null;
};
const $15ad553fd61d4764$export$5186b9d213f626fd = async (entitlementId)=>{
    const entitlementDetails = await (0, $hgi0g.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
    if (!entitlementDetails?.transactionAccountId) // TODO: Handle errors properly
    throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};

});

parcelRegister("ccm7u", function(module, exports) {
$parcel$export(module.exports, "getAdminBaseUrl", () => $ccf3c5523a755393$export$76bb37a926058cca);

var $8RHPx = parcelRequire("8RHPx");
const $ccf3c5523a755393$export$76bb37a926058cca = ()=>`https://${(0, $8RHPx.getATLContextDomain)('admin')}`;

});

parcelRegister("gvwWc", function(module, exports) {
$parcel$export(module.exports, "getProductKey", () => $393097453086ea59$export$d0b7f02493f85477);

const $393097453086ea59$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $315aedf92e50a945$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $315aedf92e50a945$export$c8c1c8c3f8ddba61;
    // useSubProduct currently doesn't support polaris
    // JPD's subproduct currently falls under to 'software'
    // https://hello.atlassian.net/wiki/spaces/STAR/pages/2940457206/Detach+from+JSW+analytics+subproduct
    if (subProduct === 'polaris') return 0, $315aedf92e50a945$export$202f50ee62667e32;
    if (subProduct === 'core') return 0, $315aedf92e50a945$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work".
    // If there is only one licensed product, we can infer what the user is using.
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};

});



parcelRegister("bTM76", function(module, exports) {
$parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", () => $162fa162a8030292$export$9901be7804227da7);

var $eJOHy = parcelRequire("eJOHy");

var $abjs4 = parcelRequire("abjs4");

var $dZ3jN = parcelRequire("dZ3jN");

var $kdtFw = parcelRequire("kdtFw");

var $iWvkh = parcelRequire("iWvkh");

var $jM5Jy = parcelRequire("jM5Jy");
const $162fa162a8030292$var$entryPointParams = {};
const $162fa162a8030292$export$9901be7804227da7 = (buttonProps)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $jM5Jy.entryPointPremiumUpgradeModal), $162fa162a8030292$var$entryPointParams);
    const buttonTrigger = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        ...buttonProps,
        ref: buttonTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kdtFw.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};

});
parcelRegister("kdtFw", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPointContainer", () => $0e1730bc701af4fe$export$4d67c6ee49f3d14d);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $snbGZ = parcelRequire("snbGZ");

var $5GSFM = parcelRequire("5GSFM");
const $0e1730bc701af4fe$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $snbGZ.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("jM5Jy", function(module, exports) {
$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $ff67c1d5e3e2bfd0$export$7116d5b1a93db8d6);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ff67c1d5e3e2bfd0$export$7116d5b1a93db8d6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3idGP")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3idGP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gG9RT")
]).then(()=>parcelRequire('dx6ox'));

});



parcelRegister("aH1Gm", function(module, exports) {
$parcel$export(module.exports, "getTrialSprintBoardProjectId", () => $73e8b5416b2b188d$export$dca4afd9682f517e);

var $lctcw = parcelRequire("lctcw");

var $9pTd3 = parcelRequire("9pTd3");

const $73e8b5416b2b188d$export$dca4afd9682f517e = async (cloudId)=>{
    try {
        const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        const trialSprintBoardTrait = siteTraits.find((traits)=>traits.name === (0, $fc7a5393316802ea$export$cf8de4fabae858f0));
        if (typeof trialSprintBoardTrait?.value !== 'string') return undefined;
        return trialSprintBoardTrait.value;
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'fetchTrialSprintBoardProjectId',
                packageName: (0, $fc7a5393316802ea$export$b8b9d90f9e5bd72b),
                teamName: (0, $fc7a5393316802ea$export$d57b6b390e78d90f)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
const $fc7a5393316802ea$export$b8b9d90f9e5bd72b = 'jira-plans-banners';
const $fc7a5393316802ea$export$d57b6b390e78d90f = 'growth-tako';
const $fc7a5393316802ea$export$cf8de4fabae858f0 = 'jira_premium_sample_project_id';


parcelRegister("ggYw9", function(module, exports) {
$parcel$export(module.exports, "getNumProjects", () => $b6f3b8b23fd6b9e2$export$ec937392490def10);

var $dbBnI = parcelRequire("dbBnI");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $9pTd3 = parcelRequire("9pTd3");

const $b6f3b8b23fd6b9e2$export$ec937392490def10 = async (cloudId)=>{
    try {
        return await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $dbBnI.default), {
            cloudId: cloudId
        }).toPromise().then((data)=>data?.jira?.allJiraProjects?.totalCount);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('getNumProjects failed');
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'fetchNumProjects',
                packageName: (0, $fc7a5393316802ea$export$b8b9d90f9e5bd72b),
                teamName: (0, $fc7a5393316802ea$export$d57b6b390e78d90f)
            },
            sendToPrivacyUnsafeSplunk: true,
            error: typeGuardedError
        });
        return null;
    }
};

});
parcelRegister("dbBnI", function(module, exports) {
$parcel$export(module.exports, "default", () => $abf79b849effcd52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<beeb6eb5abb0dddd6270d6c8fd8e3f6b>>
 * @relayHash dd3946513cb4a6664dfc08bfd9b0ab23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9aaecc14f5181b304672459af4e7026818b4c4d74d26e40adbbe80c967c46288
const $abf79b849effcd52$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {}
                        }
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "allJiraProjects",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getNumProjectsJPBQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getNumProjectsJPBQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9aaecc14f5181b304672459af4e7026818b4c4d74d26e40adbbe80c967c46288",
            "metadata": {},
            "name": "getNumProjectsJPBQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$abf79b849effcd52$var$node.hash = "e6cc3e7bbc5fdfe0dcb1b02c4dd70ebb";
var $abf79b849effcd52$export$2e2bcd8739ae039 = $abf79b849effcd52$var$node;

});


parcelRegister("8Q8RO", function(module, exports) {
$parcel$export(module.exports, "FeatureGateLogo", () => $9df4824909321a97$export$83d4ce06fb8c3c0);

var $eJOHy = parcelRequire("eJOHy");

var $8wyVH = parcelRequire("8wyVH");

var $lA48b = parcelRequire("lA48b");

var $2Vh1e = parcelRequire("2Vh1e");
const $9df4824909321a97$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        src: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($lA48b))) : (0, (/*@__PURE__*/$parcel$interopDefault($2Vh1e))),
        alt: alt
    });

});
parcelRegister("lA48b", function(module, exports) {
module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();

});

parcelRegister("2Vh1e", function(module, exports) {
module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();

});


parcelRegister("2lxyv", function(module, exports) {
$parcel$export(module.exports, "default", () => $548889fe000ec202$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $548889fe000ec202$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.title",
        "defaultMessage": "Unlock advanced planning tools"
    },
    imageAlt: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    description: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.description",
        "defaultMessage": "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
    },
    learnMoreLink: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
        "defaultMessage": "Read the guide"
    },
    startTrialButton: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
        "defaultMessage": "Try it free"
    }
});

});


parcelRegister("8QNrG", function(module, exports) {
$parcel$export(module.exports, "planUpsellEntryPoint", () => $806a1861d52f428e$export$2fc05036b41321cf);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $806a1861d52f428e$export$2fc05036b41321cf = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eWjNh")), {
        moduleId: "8a4ffc36",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: false
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eWjNh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("eea4t")
]).then(()=>parcelRequire('8FBSU'));

});


parcelRegister("8ETQ8", function(module, exports) {
$parcel$export(module.exports, "planUpsellRoute", () => $ec51e5c95e8e72d8$export$bda76e09a8dec9a0);
const $ec51e5c95e8e72d8$export$bda76e09a8dec9a0 = {
    name: 'software-plan-upsell',
    path: '/jira/plans/getting-started'
};

});




parcelRegister("cRvJm", function(module, exports) {
$parcel$export(module.exports, "Nav4Projects", () => $afb39020d8dd9a2c$export$5baf9fa0c4742f3f);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $gOGK2 = parcelRequire("gOGK2");

var $4EKqI = parcelRequire("4EKqI");

const $afb39020d8dd9a2c$export$5baf9fa0c4742f3f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "projects-section",
        packageName: (0, $6764ca6ce23ee75f$export$b8b9d90f9e5bd72b),
        teamName: (0, $6764ca6ce23ee75f$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gOGK2.Nav4Projects), props)));

});
parcelRegister("gOGK2", function(module, exports) {
$parcel$export(module.exports, "Nav4Projects", () => $8f448c55bed481b6$export$5baf9fa0c4742f3f);

var $gtz5l = parcelRequire("gtz5l");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $5DiP6 = parcelRequire("5DiP6");

var $c16ff = parcelRequire("c16ff");

var $cXi8d = parcelRequire("cXi8d");

var $54VT4 = parcelRequire("54VT4");
function $8f448c55bed481b6$export$5baf9fa0c4742f3f({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $gtz5l.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const canCreateProject = !!data?.jira?.canCreateProject;
    const shouldDisplayCreateProject = !!data?.jira?.shouldDisplay;
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c16ff.ActionButtons), {
            canCreateProject: canCreateProject,
            ...(0, $4cTDP.fg)('allow_end_users_to_access_custom_templates') ? {
                shouldDisplayCreateProject: shouldDisplayCreateProject
            } : {}
        }), [
        canCreateProject,
        shouldDisplayCreateProject
    ]);
    (0, $5DiP6.useCreateProjectCheckPermissions)();
    if (!data.jira?.hasIsProjectsExpanded && isInitialSelectedPath((0, $h4Bzb.MENU_ID_PROJECTS))) // We need to make sure that we're only passing the conditionalal fragment when it is actually
    // available. Due to a lack of support the @alias Relay directive, we need to use another mechanism
    // and in this case we're using a hardcoded __typename to check if the fragment is available.
    // This is a workaround until we can use the @alias directive in Relay. If the hasIsProjectsExpanded
    // attribute is not available, then the fragment won't be either and we shouldn't pass it.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cXi8d.Nav4ProjectsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        canCreateProject: canCreateProject
    });
    return isInitialSelectedPath((0, $h4Bzb.MENU_ID_PROJECTS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54VT4.Nav4ProjectsForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data,
        canCreateProject: canCreateProject
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cXi8d.Nav4ProjectsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        canCreateProject: canCreateProject
    });
}

});
parcelRegister("gtz5l", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc58dd7864d72016$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9f941ff862d2764358520de269768f5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc58dd7864d72016$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isProjectsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Projects",
        "selections": [
            {
                "condition": "isProjectsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectsForLanding"
                    }
                ]
            },
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isProjectsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "hasIsProjectsExpanded",
                                "kind": "ScalarField",
                                "name": "__typename"
                            }
                        ]
                    },
                    {
                        "alias": "canCreateProject",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "CREATE_PROJECT"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "canPerform"
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "shouldDisplay",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CREATION_ENTRY"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$fc58dd7864d72016$var$node.hash = "428884bcc8ab2cce6e9121035fe9e8b6";
var $fc58dd7864d72016$export$2e2bcd8739ae039 = $fc58dd7864d72016$var$node;

});

parcelRegister("5DiP6", function(module, exports) {
$parcel$export(module.exports, "useCreateProjectCheckPermissions", () => $64f1d102c2891f57$export$1fb28f66ef08585d);

var $7OGLX = parcelRequire("7OGLX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $3hRxq = parcelRequire("3hRxq");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $kAwwe = parcelRequire("kAwwe");

var $cHtIB = parcelRequire("cHtIB");
const $64f1d102c2891f57$var$localStorageProvider = (0, $3hRxq.createLocalStorageProvider)('analytics-permission-check');
const $64f1d102c2891f57$export$1fb28f66ef08585d = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!$64f1d102c2891f57$var$localStorageProvider.get('complete') && (0, $4cTDP.fg)('groot-create-team-project-permission-check')) {
            (0, $j4oe4.fetchQuery)(environment, (0, $7OGLX.default), {
                cloudId: cloudId
            }).subscribe({
                next: (data)=>{
                    (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'createProject userPermissions', {
                        canCreateProject: !!data?.jira?.canCreateProject,
                        canCreateTeamManagedProject: !!data?.jira?.canCreateTeamManagedProject,
                        canCreateCompanyManagedProject: !!data?.jira?.canCreateCompanyManagedProject,
                        isAdmin: isAdmin
                    });
                }
            });
            $64f1d102c2891f57$var$localStorageProvider.set('complete', true);
        }
    });
};

});
parcelRegister("7OGLX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8bfb7c094c130ee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9adad55e36f5164f9b82f9bc2c20551>>
 * @relayHash 8a6a3d5a2b9486afff07f1a4164dac33
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0588a5a73b3045ab908a63852c6241e0fd7b8aa2d474b73a7143e5228193af90
const $e8bfb7c094c130ee$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                },
                {
                    "alias": "canCreateTeamManagedProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_TEAM_MANAGED_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                },
                {
                    "alias": "canCreateCompanyManagedProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_COMPANY_MANAGED_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreateProjectCheckPermissionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreateProjectCheckPermissionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "0588a5a73b3045ab908a63852c6241e0fd7b8aa2d474b73a7143e5228193af90",
            "metadata": {},
            "name": "useCreateProjectCheckPermissionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e8bfb7c094c130ee$var$node.hash = "26cfc52f838e715229730ac022252212";
var $e8bfb7c094c130ee$export$2e2bcd8739ae039 = $e8bfb7c094c130ee$var$node;

});


parcelRegister("c16ff", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $823a7cf09c8a263e$export$88c65d2d98aab183);

var $eJOHy = parcelRequire("eJOHy");

var $4F5bb = parcelRequire("4F5bb");

var $dcLzM = parcelRequire("dcLzM");

var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $k71qx = parcelRequire("k71qx");

var $kO1ht = parcelRequire("kO1ht");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $33Xtl = parcelRequire("33Xtl");

var $k4qPj = parcelRequire("k4qPj");

var $1pmgP = parcelRequire("1pmgP");

var $dN2O6 = parcelRequire("dN2O6");

var $lHnXI = parcelRequire("lHnXI");

var $1OC2y = parcelRequire("1OC2y");


var $8IuE5 = parcelRequire("8IuE5");

var $ajqBI = parcelRequire("ajqBI");

var $6naEG = parcelRequire("6naEG");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $9o3jI = parcelRequire("9o3jI");

var $4cTDP = parcelRequire("4cTDP");

var $5Ld7K = parcelRequire("5Ld7K");
function $823a7cf09c8a263e$export$88c65d2d98aab183({ onClose: onClose, canCreateProject: canCreateProject, shouldDisplayCreateProject: shouldDisplayCreateProject }) {
    const projectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Ld7K.default).projectsGalaxia : (0, $5Ld7K.default).projects;
    const createProjectGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Ld7K.default).createProjectGalaxia : (0, $5Ld7K.default).createProject;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { on: openProjectCreateDrawer }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).PROJECT_CREATE);
    const { sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent, sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        openProjectCreateDrawer();
        sendCreateProjectAnalyticsEvent();
    }, [
        openProjectCreateDrawer,
        sendCreateProjectAnalyticsEvent
    ]);
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        sendMeatBallDropDownAnalyticsEvent();
    }, [
        sendMeatBallDropDownAnalyticsEvent
    ]);
    const showProjectCreateButton = (0, $4cTDP.fg)('allow_end_users_to_access_custom_templates') ? shouldDisplayCreateProject : canCreateProject;
    if (showProjectCreateButton) (0, $cxKOj.expVal)('jsmgrowth-216_template_gallery_aa_test', 'isEnabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showProjectCreateButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage(createProjectGalaxia)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage(createProjectGalaxia),
        onClick: onClick
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        ...(0, $4cTDP.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            name: formatMessage(projectsGalaxia)
        } : {},
        onOpen: onOpen,
        MenuItems: $823a7cf09c8a263e$var$MoreMenuItems,
        onClose: onClose
    }));
}
function $823a7cf09c8a263e$var$MoreMenuItems({ onClose: onClose }) {
    const manageProjectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Ld7K.default).manageProjectsGalaxia : (0, $5Ld7K.default).manageProjects;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const href = (0, $eJOHy.useMemo)(()=>(0, $33Xtl.getProjectsNavigationPaths)().projectsViewProjects, []);
    const { sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent, sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    const { sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent } = (0, $1OC2y.useProjectsAnalyticsL3)();
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)((e)=>{
        sendMeatBallDropDownManageProjectsAnalyticsEvent();
        onClose?.(e);
    });
    const onChangeViewOptionChange = (0, $eJOHy.useCallback)((viewOptionValue)=>{
        const getItemId = ()=>{
            switch(viewOptionValue){
                case (0, $1pmgP.ViewOptions).STARRED:
                    return 0, $bc40578f06d7846b$export$ed36b1ade72db400;
                case (0, $1pmgP.ViewOptions).STARRED_AND_RECENT:
                    return 0, $bc40578f06d7846b$export$98d08638c2a90c44;
                case (0, $1pmgP.ViewOptions).MOST_RECENT_ONLY:
                    return 0, $bc40578f06d7846b$export$f8a73cc0211412ca;
                default:
                    return 0, $bc40578f06d7846b$export$98d08638c2a90c44;
            }
        };
        sendChangeViewViewOptionAnalyticsEvent({
            itemId: getItemId()
        });
    }, [
        sendChangeViewViewOptionAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: href,
        onClick: onCloseWithStopPropagation
    }, formatMessage(manageProjectsGalaxia))), (0, $cxKOj.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true,
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4qPj.ChangeViewMenuItem), {
        onOpen: sendChangeViewAnalyticsEvent,
        onChange: onChangeViewOptionChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        hasSeparator: false,
        menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
        hasSection: false
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
        hasSection: true
    }));
}

});
parcelRegister("33Xtl", function(module, exports) {
$parcel$export(module.exports, "getProjectsNavigationPaths", () => $bd7b21fc4d3ba3ed$export$5b37488a9fd89879);
const $bd7b21fc4d3ba3ed$export$5b37488a9fd89879 = ()=>({
        projectsViewProjects: '/jira/settings/projects/manage',
        projectsViewCategories: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
        projectsTrashedProjects: '/jira/settings/projects/trash',
        projectsArchivedProjects: '/jira/settings/projects/archive'
    });

});

parcelRegister("k4qPj", function(module, exports) {
$parcel$export(module.exports, "ChangeViewMenuItem", () => $a05c6654b9badc12$export$3bc1c3c28804a19b);

var $eJOHy = parcelRequire("eJOHy");

var $cQxBL = parcelRequire("cQxBL");

var $hJIkn = parcelRequire("hJIkn");

var $7saMl = parcelRequire("7saMl");

var $bzbsd = parcelRequire("bzbsd");

var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $dZ3jN = parcelRequire("dZ3jN");

var $cHtIB = parcelRequire("cHtIB");

var $cxKOj = parcelRequire("cxKOj");

var $f2JN3 = parcelRequire("f2JN3");

var $jMoKX = parcelRequire("jMoKX");

var $1wuuz = parcelRequire("1wuuz");

var $4ivVe = parcelRequire("4ivVe");

var $i0gEO = parcelRequire("i0gEO");

var $k6xks = parcelRequire("k6xks");
const $a05c6654b9badc12$export$3bc1c3c28804a19b = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false), $a05c6654b9badc12$var$ChangeViewMenuItemNew, $a05c6654b9badc12$var$ChangeViewMenuItemOld);
function $a05c6654b9badc12$var$ChangeViewMenuItemOld({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $i0gEO.ViewOptionsMenuPopupContentEntrypoint), {
        scope: (0, $jMoKX.DisplaySettingsScope).PROJECTS,
        onChange: onChange
    });
    const entrypointRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1wuuz.Skeleton), null),
                runtimeProps: {}
            }),
        placement: "right-start",
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
                ...triggerProps,
                ref: (0, $bzbsd.default)(ref, entrypointRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
                    label: formatMessage((0, $4ivVe.default).listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                    label: formatMessage((0, $4ivVe.default).chevronRightIcon),
                    size: "small"
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage((0, $4ivVe.default).changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true"
            }, formatMessage((0, $4ivVe.default).changeViewMenuItemLabel))
    });
}
function $a05c6654b9badc12$var$ChangeViewMenuItemNew({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const cloudId = (0, $cHtIB.useCloudId)();
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $k6xks.ProjectsViewOptionsEntrypoint), {
        cloudId: cloudId,
        onChange: onChange
    });
    const entrypointRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1wuuz.Skeleton), null),
                runtimeProps: {},
                errorFallback: "flag"
            }),
        placement: "right-start",
        // Duplicate messageId due to experiment conditional component
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
                ...triggerProps,
                ref: (0, $bzbsd.default)(ref, entrypointRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
                    label: formatMessage((0, $4ivVe.default).listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                    label: formatMessage((0, $4ivVe.default).chevronRightIcon),
                    size: "small"
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage((0, $4ivVe.default).changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true",
                testId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.button"
            }, formatMessage((0, $4ivVe.default).changeViewMenuItemLabel))
    });
}

});
parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});

parcelRegister("jMoKX", function(module, exports) {
$parcel$export(module.exports, "DisplaySettingsScope", () => $6db3a664fc2e02d9$export$5df97773a9667af8);
$parcel$export(module.exports, "DisplaySettingsPropertyKeys", () => $6db3a664fc2e02d9$export$5d9ca2391194d3c8);
$parcel$export(module.exports, "DisplaySettingsAllowedValuesMap", () => $6db3a664fc2e02d9$export$3938c8b7d6f592c);

var $1pmgP = parcelRequire("1pmgP");
const $6db3a664fc2e02d9$var$PROJECTS = 'projects';
const $6db3a664fc2e02d9$export$5df97773a9667af8 = {
    PROJECTS: $6db3a664fc2e02d9$var$PROJECTS
};
const $6db3a664fc2e02d9$var$VIEW_OPTION = 'VIEW_OPTION';
const $6db3a664fc2e02d9$export$5d9ca2391194d3c8 = {
    VIEW_OPTION: $6db3a664fc2e02d9$var$VIEW_OPTION
};
const $6db3a664fc2e02d9$export$3938c8b7d6f592c = {
    [$6db3a664fc2e02d9$export$5d9ca2391194d3c8.VIEW_OPTION]: Object.values((0, $1pmgP.ViewOptions))
};

});
parcelRegister("1pmgP", function(module, exports) {
$parcel$export(module.exports, "ViewOptions", () => $b7f6e74014e3545d$export$8cd3967b7c246658);
$parcel$export(module.exports, "DefaultViewOption", () => $b7f6e74014e3545d$export$8df870734bca67fa);
const $b7f6e74014e3545d$var$STARRED_AND_RECENT = 'STARRED_AND_RECENT';
const $b7f6e74014e3545d$var$STARRED = 'STARRED';
const $b7f6e74014e3545d$var$MOST_RECENT_ONLY = 'MOST_RECENT_ONLY';
const $b7f6e74014e3545d$export$8cd3967b7c246658 = {
    STARRED_AND_RECENT: $b7f6e74014e3545d$var$STARRED_AND_RECENT,
    STARRED: $b7f6e74014e3545d$var$STARRED,
    MOST_RECENT_ONLY: $b7f6e74014e3545d$var$MOST_RECENT_ONLY
};
const $b7f6e74014e3545d$export$8df870734bca67fa = $b7f6e74014e3545d$export$8cd3967b7c246658.STARRED_AND_RECENT;

});


parcelRegister("1wuuz", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $5012924f9d39438e$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");
var $2bMVP = parcelRequire("2bMVP");

var $5Q9JR = parcelRequire("5Q9JR");

var $cxKOj = parcelRequire("cxKOj");
const $5012924f9d39438e$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null), (0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null)));

});

parcelRegister("4ivVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d94c98e54cebca34$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d94c98e54cebca34$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    changeViewMenuItemLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.change-view-menu-item-label",
        "defaultMessage": "Change view"
    },
    starredAndRecentProjectsLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-and-recent-projects-label",
        "defaultMessage": "Starred and recent projects"
    },
    starredProjectsLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-projects-label",
        "defaultMessage": "Starred projects only"
    },
    mostRecentOnlyLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.most-recent-only-label",
        "defaultMessage": "Most recent project only"
    },
    listBulletedIcon: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.list-bulleted-icon",
        "defaultMessage": "List bulleted icon"
    },
    chevronRightIcon: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.chevron-right-icon",
        "defaultMessage": "Chevron right icon"
    },
    starredAndRecentProjectsLabelGalaxia: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-and-recent-projects-label-galaxia",
        "defaultMessage": "Starred and recent spaces"
    },
    starredProjectsLabelGalaxia: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-projects-label-galaxia",
        "defaultMessage": "Starred spaces only"
    },
    mostRecentOnlyLabelGalaxia: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.most-recent-only-label-galaxia",
        "defaultMessage": "Most recent space only"
    }
});

});

parcelRegister("i0gEO", function(module, exports) {
$parcel$export(module.exports, "ViewOptionsMenuPopupContentEntrypoint", () => $966531b6e1190649$export$ebd1be9f4df3fdb7);

var $3Bzqe = parcelRequire("3Bzqe");

var $gbpNq = parcelRequire("gbpNq");

const $966531b6e1190649$export$ebd1be9f4df3fdb7 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1ccTj")).then(({ ViewOptionsWithDisplaySettings: ViewOptionsWithDisplaySettings })=>ViewOptionsWithDisplaySettings), {
        moduleId: "846bfedf",
        priority: "interaction"
    }),
    getPreloadProps: (extraProps)=>({
            queries: {},
            extraProps: extraProps
        })
});

});
parcelRegister("1ccTj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7ixMy").then(()=>parcelRequire('kUWXo'));

});


parcelRegister("k6xks", function(module, exports) {
$parcel$export(module.exports, "ProjectsViewOptionsEntrypoint", () => $70054cf664938c26$export$cd53b98c3c72dc78);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $508qu = parcelRequire("508qu");

const $70054cf664938c26$export$cd53b98c3c72dc78 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eDJUS")).then(({ ProjectsViewOptions: ProjectsViewOptions })=>ProjectsViewOptions), {
        moduleId: "84ec887d",
        moduleName: "ProjectsViewOptions",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, onChange: onChange })=>({
            queries: {
                projectsViewOptions: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $508qu.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                onChange: onChange
            }
        })
});

});
parcelRegister("508qu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f94c51fb761323a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b44bb2b3856fc3d9f3b17fe8cddcfb7>>
 * @relayHash 0e6b913da3ca80570d2232453a460c1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dcfe9939769b56d8b4a5c327dde03375eb0d9a2639a738ce027c3f4c80b09d70
const $f94c51fb761323a8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "displayMode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dcfe9939769b56d8b4a5c327dde03375eb0d9a2639a738ce027c3f4c80b09d70",
            "metadata": {},
            "name": "ProjectsViewOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f94c51fb761323a8$var$node.hash = "878985a959db09740786f4815e3cda55";
var $f94c51fb761323a8$export$2e2bcd8739ae039 = $f94c51fb761323a8$var$node;

});

parcelRegister("eDJUS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kEIUB").then(()=>parcelRequire('gqAVe'));

});



parcelRegister("dN2O6", function(module, exports) {
$parcel$export(module.exports, "useProjectsAnalyticsL1", () => $8304076209d0ee21$export$7d9a1a79b1bd1338);

var $eJOHy = parcelRequire("eJOHy");




var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");




var $ujg1l = parcelRequire("ujg1l");
const $8304076209d0ee21$export$7d9a1a79b1bd1338 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22)
        }), []);
    // fixed item - view all projects link
    const sendViewAllProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: (0, $bc40578f06d7846b$export$2de7e56f66635690)
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - more projects flyout trigger
    const sendMoreProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            parentItemId: (0, $bc40578f06d7846b$export$44d67b522cbcce6d),
            itemId: (0, $bc40578f06d7846b$export$3e2efdbdb3eed97e)
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - meatball icon button on projects menu (top level)
    const sendMeatBallDropDownAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - create project (+) button on projects menu (top level)
    const sendCreateProjectAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: 'createProject'
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project menu item that displays project name (can be expandable menu or a link)
    const sendProjectMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ starred: starred, recent: recent, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            itemId: projectId,
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendProjectMenuContentAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: 'projectsNavigationMenuItemContent'
        };
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'projectsNavigationMenuItemContent rendered', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMoreProjectsAnalyticsEvent: sendMoreProjectsAnalyticsEvent,
        sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent,
        sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent,
        sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent,
        sendProjectMenuContentAnalyticsEvent: sendProjectMenuContentAnalyticsEvent
    };
};

});
parcelRegister("ujg1l", function(module, exports) {
$parcel$export(module.exports, "getSectionByStarredOrRecent", () => $9ade126550411160$export$542854f16c0127e7);

var $a9aec = parcelRequire("a9aec");
const $9ade126550411160$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
    if (starred) return 0, $a9aec.SECTION_ITEM_STARRED;
    if (recent) return 0, $a9aec.SECTION_ITEM_RECENT;
    return '';
};

});


parcelRegister("lHnXI", function(module, exports) {
$parcel$export(module.exports, "useProjectsAnalyticsL2", () => $2630d05d0f768e9d$export$1e04fadc2cea284c);

var $eJOHy = parcelRequire("eJOHy");






var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $ujg1l = parcelRequire("ujg1l");
const $2630d05d0f768e9d$export$1e04fadc2cea284c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1)
        }), []);
    const sendMeatBallDropDownManageProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            itemId: 'manageProjects',
            parentItemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // board navigation item under each project when project is expandable menu
    const sendBoardNavigationItemInsideProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(({ boardId: boardId, projectId: projectId, recent: recent, starred: starred, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: boardId,
            itemType: (0, $6bf6536f83c22cfe$export$9b8283d5878d2491),
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on projects
    const getMeatBallDropDownOnProjectsAnalytics = (0, $eJOHy.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        return {
            ...commonAttributes,
            actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524),
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e),
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
    }, [
        commonAttributes
    ]);
    /** @deprecated, replace with getMeatBallDropDownOnProjectsAnalytics  */ const sendMeatBallDropDownOnProjectsAnalyticsEvent = (0, $eJOHy.useCallback)((params)=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const { actionSubjectId: actionSubjectId, ...attributes } = getMeatBallDropDownOnProjectsAnalytics(params);
        (0, $kRgKj.fireUIAnalytics)(event, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent,
        getMeatBallDropDownOnProjectsAnalytics
    ]);
    // create board button
    const sendCreateBoardOnBoardMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            itemId: 'createBoard',
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - view all boards link
    const sendViewAllBoardsAnalyticsEvent = (0, $eJOHy.useCallback)(({ projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: 'viewAllBoards',
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - Change View in Meatball Menu on Projects section
    const sendChangeViewAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            parentItemId: (0, $bc40578f06d7846b$export$44d67b522cbcce6d),
            itemId: (0, $6bf6536f83c22cfe$export$119dad133da0b4a)
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - View All Projects in More Projects flyout
    const sendViewAllProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            parentItemId: (0, $bc40578f06d7846b$export$3e2efdbdb3eed97e),
            itemId: (0, $bc40578f06d7846b$export$2de7e56f66635690)
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project in More Projects flyout
    const sendMoreProjectsFlyoutProjectAnalyticsEvent = (0, $eJOHy.useCallback)(({ projectId: projectId, sectionType: sectionType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            parentItemId: (0, $bc40578f06d7846b$export$3e2efdbdb3eed97e),
            itemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            itemId: projectId,
            moreProjectsSection: sectionType
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendProjectMenuContentSectionAnalyticsEvent = (0, $eJOHy.useCallback)(({ projectSection: projectSection, canCreateProject: canCreateProject })=>{
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: projectSection,
            canCreateProject: canCreateProject
        };
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'projectsNavigationContentSection rendered', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'entered',
            actionSubject: (0, $bfc89d778f76f56d$export$b0a8b257f1f878a2)
        });
        const attributes = {
            ...commonAttributes,
            parentItemId: (0, $bc40578f06d7846b$export$3e2efdbdb3eed97e),
            itemId: (0, $bc40578f06d7846b$export$e338c40e64df0640)
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8ebfc84e07851700), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent,
        sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent,
        sendBoardNavigationItemInsideProjectsAnalyticsEvent: sendBoardNavigationItemInsideProjectsAnalyticsEvent,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent,
        sendViewAllBoardsAnalyticsEvent: sendViewAllBoardsAnalyticsEvent,
        sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent,
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMoreProjectsFlyoutProjectAnalyticsEvent: sendMoreProjectsFlyoutProjectAnalyticsEvent,
        sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent,
        sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent: sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent
    };
};

});
const $16a7021d28f78da7$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $16a7021d28f78da7$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
const $16a7021d28f78da7$export$8ebfc84e07851700 = 'moreProjectsSearch';


parcelRegister("1OC2y", function(module, exports) {
$parcel$export(module.exports, "useProjectsAnalyticsL3", () => $2cddfe1614034325$export$619b8904be99ed7c);

var $eJOHy = parcelRequire("eJOHy");




var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");



var $ujg1l = parcelRequire("ujg1l");

const $2cddfe1614034325$export$619b8904be99ed7c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18)
        }), []);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on boards
    const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $eJOHy.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e),
            projectId: projectId,
            parentItemId: boardId,
            parentItemType: (0, $6bf6536f83c22cfe$export$9b8283d5878d2491),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendChangeViewViewOptionAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            itemId: itemId,
            parentItemId: (0, $6bf6536f83c22cfe$export$119dad133da0b4a)
        };
        (0, $kRgKj.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent,
        sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent
    };
};

});

parcelRegister("5Ld7K", function(module, exports) {
$parcel$export(module.exports, "default", () => $38d821cc83ce3ef8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $38d821cc83ce3ef8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createProject: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project",
        "defaultMessage": "Create project"
    },
    manageProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects",
        "defaultMessage": "Manage projects"
    },
    projects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects",
        "defaultMessage": "projects"
    },
    createProjectGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project-galaxia",
        "defaultMessage": "Create space"
    },
    manageProjectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects-galaxia",
        "defaultMessage": "Manage spaces"
    },
    projectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects-galaxia",
        "defaultMessage": "spaces"
    }
});

});


parcelRegister("cXi8d", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsDefault", () => $7e3659a4805a6da9$export$373934ae259d74df);

var $eJOHy = parcelRequire("eJOHy");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $iWvkh = parcelRequire("iWvkh");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $49s4h = parcelRequire("49s4h");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $e6YEs = parcelRequire("e6YEs");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $jrulJ = parcelRequire("jrulJ");


var $eApSa = parcelRequire("eApSa");

var $cxKOj = parcelRequire("cxKOj");


var $bUY1i = parcelRequire("bUY1i");

var $baOTS = parcelRequire("baOTS");
function $7e3659a4805a6da9$export$373934ae259d74df(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false, canCreateProject: canCreateProject } = props;
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const atlassianAccountId = (0, $e6YEs.useAccountId)();
    const currentURL = (0, $49s4h.useGetCurrentUrl)();
    const entryPointParamsOld = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            currentURL: currentURL,
            activationId: activationId,
            atlassianAccountId: atlassianAccountId
        }), [
        cloudId,
        currentURL,
        activationId,
        atlassianAccountId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId,
                activationId: activationId,
                atlassianAccountId: atlassianAccountId
            }
        }), [
        cloudId,
        activationId,
        atlassianAccountId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const projectsEPRef = leftSidebarEPRef?.entryPoints?.projects;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $baOTS.nav4ProjectsContentEntryPoint), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        // We intentionally won't re-evaluate this if the route changes.
        if (!projectsEPRef && isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        projectsEPRef,
        isExpanded
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_PROJECTS);
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    // We set the state this to cater for components that may be an entrypoint so that we don't keep switching between the entryPoint version and the non-entryPoint version
    const [entryPointConfig] = (0, $eJOHy.useState)(()=>{
        const epContainerProps = {
            id: 'nav4-sidebar-projects-default',
            packageName: (0, $6764ca6ce23ee75f$export$b8b9d90f9e5bd72b),
            teamName: (0, $6764ca6ce23ee75f$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
                count: 6,
                withHeading: true
            }),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParamsOld
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eApSa.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: projectsEPRef,
                    placeholderEntryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
                })
        };
    });
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(entryPointConfig.Component, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        }, [
            entryPointActions
        ]),
        onExpansionToggle: (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
                    sectionItem: (0, $a9aec.SECTION_ITEM_PROJECTS)
                });
            }
        }, [
            entryPointActions,
            sendSectionItemAnalyticsEvent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-projects-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 6,
        withHeading: true
    }) : content(), !(0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUY1i.Footer), {
        canCreateProject: canCreateProject
    })));
}

});
const $6764ca6ce23ee75f$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Projects';
const $6764ca6ce23ee75f$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("bUY1i", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $fa9b5b5e50de6182$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $2KtJf = parcelRequire("2KtJf");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");

var $lRq8t = parcelRequire("lRq8t");

var $dN2O6 = parcelRequire("dN2O6");

var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $lWdYg = parcelRequire("lWdYg");

var $cxKOj = parcelRequire("cxKOj");

var $9IxJM = parcelRequire("9IxJM");

var $aGWjt = parcelRequire("aGWjt");

var $gD589 = parcelRequire("gD589");

var $4cTDP = parcelRequire("4cTDP");

var $idwl9 = parcelRequire("idwl9");

var $e09p3 = parcelRequire("e09p3");
const $fa9b5b5e50de6182$var$VIEW_ALL_PROJECTS_HREF = (0, $lWdYg.projectsDirectoryRoute).path;
function $fa9b5b5e50de6182$var$FooterInternal({ hasMore: hasMore = false, canCreateProject: canCreateProject = false }) {
    const moreProjectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $e09p3.default).moreProjectsGalaxia : (0, $e09p3.default).moreProjects;
    const viewAllProjectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $e09p3.default).viewAllProjectsGalaxia : (0, $e09p3.default).viewAllProjects;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent, sendMoreProjectsAnalyticsEvent: sendMoreProjectsAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const { shouldSuppress: shouldSuppress } = (0, $2KtJf.useYbrCrossFlowSuppression)();
    const recommendations = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $4cTDP.fg)('sqa-1995_move_nav4recommendations_into_footer')) return null;
        if (shouldSuppress()) return null;
        if (!!canCreateProject && (0, $cxKOj.expValEquals)('grw-1672_display_targeted_jsm_template_cta_in_nav4', 'cohort', 'variation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gD589.Nav4ProjectsSectionPlacement), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idwl9.Nav4Recommendations), null);
    }, [
        canCreateProject,
        shouldSuppress
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, (0, $cxKOj.expVal)('blu-7465-projects-search-in-sidebar', 'isEnabled', false) || hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9IxJM.MoreProjectsFlyout), {
        onClick: sendMoreProjectsAnalyticsEvent
    }, formatMessage(moreProjectsGalaxia)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        onClick: sendViewAllProjectsAnalyticsEvent,
        href: $fa9b5b5e50de6182$var$VIEW_ALL_PROJECTS_HREF,
        menuId: (0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL)
    }, formatMessage(viewAllProjectsGalaxia)), recommendations, canCreateProject && (0, $cxKOj.expVal)('jsmgrowth-216_template_gallery_in_left_navigation', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aGWjt.BrowseTemplatesMenuItem), null))));
}
const $fa9b5b5e50de6182$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $eJOHy.memo)($fa9b5b5e50de6182$var$FooterInternal);

});
parcelRegister("2KtJf", function(module, exports) {
$parcel$export(module.exports, "useYbrCrossFlowSuppression", () => $5f6a0f0f8349a119$export$346e48c47f93909);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $grVjp = parcelRequire("grVjp");

var $9B25q = parcelRequire("9B25q");
const $5f6a0f0f8349a119$export$346e48c47f93909 = ({ crossFlowProduct: crossFlowProduct = 'jpd' } = {})=>{
    const [userIsNewUser] = (0, $9B25q.useYbrIsNewUserCrossFlow)({
        crossFlowProduct: crossFlowProduct
    });
    const [userIsWithin30Days] = (0, $grVjp.useIsJiraUserFirstActiveWithinXDays)(30);
    const shouldSuppress = (0, $eJOHy.useCallback)(()=>{
        if (false || !userIsNewUser) return false;
        if (crossFlowProduct === 'jpd' && (0, $cxKOj.expVal)('jira_ybr_first_batch_cross_flow', 'isYBREnabled', false)) return userIsWithin30Days;
        if (crossFlowProduct === 'confluence' && (0, $cxKOj.expVal)('jira_ybr_first_batch_cross_flow_confluence', 'isYBREnabled', false)) return userIsWithin30Days;
        return false;
    }, [
        userIsNewUser,
        userIsWithin30Days,
        crossFlowProduct
    ]);
    return {
        shouldSuppress: shouldSuppress
    };
};

});
parcelRegister("grVjp", function(module, exports) {
$parcel$export(module.exports, "useIsJiraUserFirstActiveWithinXDays", () => $35444ee2c525c06b$export$cb5802762e78c9fd);

var $eJOHy = parcelRequire("eJOHy");

var $ea0Pc = parcelRequire("ea0Pc");

var $cHtIB = parcelRequire("cHtIB");

var $e6YEs = parcelRequire("e6YEs");

var $58aKG = parcelRequire("58aKG");

var $4cTDP = parcelRequire("4cTDP");

var $2yivS = parcelRequire("2yivS");
const $35444ee2c525c06b$export$cb5802762e78c9fd = (xDays)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const { fetchTraits: fetchTraits } = (0, $ea0Pc.useTraitsActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('jira_ybr_precondition_check_rollout_cross_flow')) return;
        fetchTraits([
            (0, $58aKG.SITE_USER)
        ], {
            cloudId: cloudId,
            accountId: accountId
        });
    }, [
        cloudId,
        accountId,
        fetchTraits
    ]);
    return (0, $2yivS.useIsJiraUserFirstActiveWithinXDaysTraitSelector)(xDays);
};

});
parcelRegister("ea0Pc", function(module, exports) {
$parcel$export(module.exports, "useTraits", () => $e2b3b7a3a420087e$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $e2b3b7a3a420087e$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $e2b3b7a3a420087e$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $e2b3b7a3a420087e$export$e653f602b87eec56);

var $3ugTQ = parcelRequire("3ugTQ");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $lctcw = parcelRequire("lctcw");

var $lFovQ = parcelRequire("lFovQ");

var $58aKG = parcelRequire("58aKG");

var $19QQ8 = parcelRequire("19QQ8");
const $e2b3b7a3a420087e$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $e2b3b7a3a420087e$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $19QQ8.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $58aKG.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $58aKG.SITE) && cloudId) fetchedTraits = {
                    attributes: await (0, $lctcw.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $58aKG.SITE_USER) && cloudId && accountId) fetchedTraits = {
                    attributes: await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $3ugTQ.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $e2b3b7a3a420087e$var$actions = {
    fetchTraits: $e2b3b7a3a420087e$var$fetchTraits,
    addTrait: $e2b3b7a3a420087e$var$addTrait
};
const $e2b3b7a3a420087e$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $e2b3b7a3a420087e$export$5b11e13f463f4eb = (0, $GtRbT.createStore)({
    initialState: $e2b3b7a3a420087e$var$initialState,
    actions: $e2b3b7a3a420087e$var$actions,
    name: 'TraitsStore'
});
const $e2b3b7a3a420087e$export$243330301a7ccf01 = (0, $iJq0l.createHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb);
const $e2b3b7a3a420087e$export$87f1d888def9d5a0 = (0, $iJq0l.createActionsHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb);
const $e2b3b7a3a420087e$var$defaultSelector = (traitsType, selector)=>(0, $4MchI.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $19QQ8.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $19QQ8.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $19QQ8.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $19QQ8.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $19QQ8.getTraitValue)(state, name) : null
        }), selector);
const $e2b3b7a3a420087e$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $iJq0l.createHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb, {
        selector: $e2b3b7a3a420087e$var$defaultSelector(traitsType, selector)
    });
const $e2b3b7a3a420087e$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("58aKG", function(module, exports) {
$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $6bc297d84ad0ac90$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $6bc297d84ad0ac90$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $6bc297d84ad0ac90$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $6bc297d84ad0ac90$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $6bc297d84ad0ac90$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $6bc297d84ad0ac90$export$ff5c5bd50c21e9a4);
const $6bc297d84ad0ac90$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $6bc297d84ad0ac90$export$1f4740cb59ea887e = 'SITE';
const $6bc297d84ad0ac90$export$2b629adc0b711448 = 'SITE_USER';
const $6bc297d84ad0ac90$export$c7bc89c720838974 = 'ORG';
const $6bc297d84ad0ac90$export$872e93425a929c06 = 'ORG_USER';
const $6bc297d84ad0ac90$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $6bc297d84ad0ac90$export$ab3e7784d2a104d4 = [
    $6bc297d84ad0ac90$export$eac8289d83d13c9e,
    $6bc297d84ad0ac90$export$1f4740cb59ea887e,
    $6bc297d84ad0ac90$export$2b629adc0b711448,
    $6bc297d84ad0ac90$export$c7bc89c720838974,
    $6bc297d84ad0ac90$export$872e93425a929c06
];

});

parcelRegister("19QQ8", function(module, exports) {
$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $487f20fc6a559fdc$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $487f20fc6a559fdc$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $487f20fc6a559fdc$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $487f20fc6a559fdc$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $487f20fc6a559fdc$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $487f20fc6a559fdc$export$da1e8ce191f01409);

var $58aKG = parcelRequire("58aKG");
const $487f20fc6a559fdc$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $487f20fc6a559fdc$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $58aKG.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $58aKG.SITE:
            return `site/${cloudId}`;
        case 0, $58aKG.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $58aKG.ORG:
            return `org/${orgId}`;
        case 0, $58aKG.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $487f20fc6a559fdc$export$252a469687875173(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $487f20fc6a559fdc$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $487f20fc6a559fdc$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $487f20fc6a559fdc$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $487f20fc6a559fdc$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("2yivS", function(module, exports) {
$parcel$export(module.exports, "useIsJiraUserFirstActiveWithinXDaysTraitSelector", () => $1d67cd7fb8cad7e9$export$845fb1e1db406170);

var $ea0Pc = parcelRequire("ea0Pc");

var $4cTDP = parcelRequire("4cTDP");
const $1d67cd7fb8cad7e9$var$isFirstActiveWithinXDays = (firstActiveDate, xDays)=>{
    const date = new Date(firstActiveDate);
    if (Number.isNaN(date.getTime())) return false;
    const xDaysAgo = new Date();
    xDaysAgo.setDate(xDaysAgo.getDate() - xDays);
    // Set milliseconds to the same as the date to avoid timing issues, remove this will fail the unit test
    xDaysAgo.setMilliseconds(date.getMilliseconds());
    return date >= xDaysAgo;
};
const $1d67cd7fb8cad7e9$export$845fb1e1db406170 = (xDays)=>(0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
        if (!(0, $4cTDP.fg)('jira_ybr_precondition_check_rollout_cross_flow')) return false;
        const firstActiveTrait = getTraitByName('jira_first_active');
        if (!firstActiveTrait || !(typeof firstActiveTrait.value === 'string')) return false;
        if ($1d67cd7fb8cad7e9$var$isFirstActiveWithinXDays(firstActiveTrait.value, xDays)) return true;
        return false;
    })();

});


parcelRegister("9B25q", function(module, exports) {
$parcel$export(module.exports, "useYbrIsNewUserCrossFlow", () => $fa944855c3499590$export$367ed70067442cdc);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $ea0Pc = parcelRequire("ea0Pc");

var $4cTDP = parcelRequire("4cTDP");

var $58aKG = parcelRequire("58aKG");

var $cxKOj = parcelRequire("cxKOj");

var $19QQ8 = parcelRequire("19QQ8");

var $6JRQU = parcelRequire("6JRQU");
const $fa944855c3499590$export$367ed70067442cdc = ({ crossFlowProduct: crossFlowProduct = 'jpd' } = {})=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const [traits, { fetchTraits: fetchTraits }] = (0, $ea0Pc.useTraits)();
    const [isJiraNewUser] = (0, $6JRQU.useIsJiraNewUserTraitCrossFlowSelector)({
        crossFlowProduct: crossFlowProduct
    });
    const [isYbrNewUser, setIsYbrNewUser] = (0, $eJOHy.useState)(true);
    (0, $eJOHy.useEffect)(()=>{
        if (!accountId || !cloudId || !(0, $4cTDP.fg)('jira_ybr_precondition_check_rollout_cross_flow')) {
            setIsYbrNewUser(false);
            return;
        }
        fetchTraits([
            (0, $58aKG.SITE_USER)
        ], {
            cloudId: cloudId,
            accountId: accountId
        });
    }, [
        accountId,
        cloudId,
        fetchTraits
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Wait until SITE_USER traits are loaded and jira_first_active trait is loaded before checking if user is actually a new user
        if (!(0, $4cTDP.fg)('jira_ybr_precondition_check_rollout_cross_flow') || !traits[0, $58aKG.SITE_USER]?.loaded || !traits[0, $58aKG.SITE_USER]?.attributes?.length || !(0, $19QQ8.hasTrait)(traits, 'jira_first_active')) return;
        // Only expose event if user is a new user
        if (crossFlowProduct === 'jpd' && (!isJiraNewUser || !(0, $cxKOj.expVal)('jira_ybr_first_batch_cross_flow', 'isYBREnabled', false))) // If user is not a new user or the experiment is not enabled, user is not a YBR new user
        // which mean the message will be show as normal
        setIsYbrNewUser(false);
        if (crossFlowProduct === 'confluence' && (!isJiraNewUser || !(0, $cxKOj.expVal)('jira_ybr_first_batch_cross_flow_confluence', 'isYBREnabled', false))) setIsYbrNewUser(false);
    }, [
        isJiraNewUser,
        traits,
        crossFlowProduct
    ]);
    return [
        isYbrNewUser
    ];
};

});
parcelRegister("6JRQU", function(module, exports) {
$parcel$export(module.exports, "useIsJiraNewUserTraitCrossFlowSelector", () => $0067b37e28d18c05$export$b28e99f67e4a2f80);

var $ibLUB = parcelRequire("ibLUB");

var $ea0Pc = parcelRequire("ea0Pc");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $9pTd3 = parcelRequire("9pTd3");
const $0067b37e28d18c05$export$b28e99f67e4a2f80 = ({ crossFlowProduct: crossFlowProduct = 'jpd' } = {})=>(0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitValue: getTraitValue })=>{
        if (!(0, $4cTDP.fg)('jira_ybr_precondition_check_rollout_cross_flow')) return false;
        try {
            const firstActiveDate = getTraitValue('jira_first_active');
            if (!firstActiveDate || !(typeof firstActiveDate === 'string') || firstActiveDate.trim() === '') return false;
            // This is to get the target new user date from dynamic config jira-ybr-first-batch-new-users-cross-flow and jira-ybr-first-batch-new-users-cross-flow-jpd
            // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/jira-ybr-first-batch-new-users-cross-flow
            // and https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/jira-ybr-first-batch-new-users-cross-flow-jpd
            // We confirm that this is a working way to get the value from the dynamic config
            // Other Jira teams are using this approach as well (filtered target app jira_web on dynamic config and confirmed)
            if (crossFlowProduct === 'confluence') return (0, $ibLUB.default)(new Date(firstActiveDate), new Date((0, $cxKOj.expVal)('jira-ybr-first-batch-new-users-cross-flow', 'value', '2050-12-31T00:00:00Z')));
            return (0, $ibLUB.default)(new Date(firstActiveDate), new Date((0, $cxKOj.expVal)('jira-ybr-first-batch-new-users-cross-flow-jpd', 'value', '2050-12-31T00:00:00Z')));
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'useIsJiraNewUserTraitCrossFlowSelector',
                    packageName: 'yellowBrickRoadUtils',
                    teamName: 'jira-werewolves'
                }
            });
            return false;
        }
    })();

});



parcelRegister("lWdYg", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRoute", () => $80e3307949c1173b$export$74114064f06cd71b);
const $80e3307949c1173b$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true
};

});

parcelRegister("9IxJM", function(module, exports) {
$parcel$export(module.exports, "MoreProjectsFlyout", () => $50e48b93fa2c22db$export$35a66c7368b171ff);

var $eJOHy = parcelRequire("eJOHy");

var $bpdtz = parcelRequire("bpdtz");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $dZ3jN = parcelRequire("dZ3jN");

var $cxKOj = parcelRequire("cxKOj");

var $49s4h = parcelRequire("49s4h");

var $if69u = parcelRequire("if69u");

var $cHtIB = parcelRequire("cHtIB");

var $e1Shq = parcelRequire("e1Shq");

function $50e48b93fa2c22db$export$35a66c7368b171ff(props) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const currentURL = (0, $49s4h.useGetCurrentUrl)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $e1Shq.MoreProjectsEntrypoint), {
        cloudId: cloudId,
        currentURL: currentURL
    });
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWy6a.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yLgR2.FlyoutMenuItemTrigger), {
        ...props,
        ref: triggerRef,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            color: "currentColor"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duFAq.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "sidebar-nav4-more-projects-flyout",
        packageName: (0, $6e43f8f0593b946f$export$b8b9d90f9e5bd72b),
        teamName: (0, $6e43f8f0593b946f$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
            withSearch: true,
            withSubHeading: true,
            isFlyout: true,
            count: (0, $cxKOj.expVal)('blu-7465-projects-search-in-sidebar', 'isEnabled', false) ? 10 : 5
        }),
        runtimeProps: {}
    })));
}

});
parcelRegister("e1Shq", function(module, exports) {
$parcel$export(module.exports, "MoreProjectsEntrypoint", () => $ce34d6191f33c697$export$40b84ce4e7e6a96a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $cxKOj = parcelRequire("cxKOj");

var $aICGH = parcelRequire("aICGH");

const $ce34d6191f33c697$export$40b84ce4e7e6a96a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fimXV")).then(({ MoreProjects: MoreProjects })=>MoreProjects), {
        moduleId: "d4fec86b",
        moduleName: "MoreProjects",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, currentURL: currentURL })=>({
            queries: {
                moreProjects: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $aICGH.default,
                    variables: {
                        cloudId: cloudId,
                        currentURL: currentURL,
                        isProjectsSearchInSidebarEnabled: (0, $cxKOj.expVal)('blu-7465-projects-search-in-sidebar', 'isEnabled', false)
                    }
                }
            },
            extraProps: {}
        })
});

});
parcelRegister("aICGH", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd598ffe9ba2b8d9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e22fccae2dd071e44f7f857a55202a7>>
 * @relayHash da733dd711e8de9cafbe0491586c07de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e510066e0ee04ed0000c02a643b8112ba7e700b1ff47c67a7fd623019609fe1e
const $cd598ffe9ba2b8d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isProjectsSearchInSidebarEnabled"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "alias": "canBrowseProjects",
                "args": [
                    v1 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "BROWSE_PROJECTS"
                    }
                ],
                "concreteType": "JiraPermission",
                "kind": "LinkedField",
                "name": "permission",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    }
                ]
            }
        ]
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
        }
    ], v4 = [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ProjectSection_projectNode"
                }
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        {
                            "alias": "projectKey",
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoreProjectsQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreFavourites",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreRecents",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "condition": "isProjectsSearchInSidebarEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "otherItems",
                                    "plural": false,
                                    "selections": v4 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoreProjectsQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreFavourites",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreRecents",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "condition": "isProjectsSearchInSidebarEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "otherItems",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                }
                            ]
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e510066e0ee04ed0000c02a643b8112ba7e700b1ff47c67a7fd623019609fe1e",
            "metadata": {},
            "name": "MoreProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cd598ffe9ba2b8d9$var$node.hash = "2706305e7b01e5ae823b2256bf00da6b";
var $cd598ffe9ba2b8d9$export$2e2bcd8739ae039 = $cd598ffe9ba2b8d9$var$node;

});

parcelRegister("fimXV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fGvTl").then(()=>parcelRequire('aHUge'));

});


const $6e43f8f0593b946f$export$b8b9d90f9e5bd72b = 'jira-navigation-apps-sidebar-nav4-more-projects';
const $6e43f8f0593b946f$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("aGWjt", function(module, exports) {
$parcel$export(module.exports, "BrowseTemplatesMenuItem", () => $34fc0677555ca22b$export$c26343bcab17172c);

var $eJOHy = parcelRequire("eJOHy");

var $bpdtz = parcelRequire("bpdtz");

var $kDaaB = parcelRequire("kDaaB");

var $iIEpz = parcelRequire("iIEpz");

var $2P2cg = parcelRequire("2P2cg");

var $9o3jI = parcelRequire("9o3jI");

var $kO1ht = parcelRequire("kO1ht");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $fwn5p = parcelRequire("fwn5p");
const $34fc0677555ca22b$export$c26343bcab17172c = ()=>{
    const [, { on: openProjectCreateDrawer }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).PROJECT_CREATE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const browseTemplatesAnalytics = (0, $2P2cg.getProjectMenuItemAnalytics)({
        itemId: 'browseTemplates'
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'browseTemplateButton'
        }));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIEpz.default), {
        onClick: openProjectCreateDrawer,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            color: "currentColor"
        }),
        analytics: browseTemplatesAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $fwn5p.default).browseTemplates));
};

});
parcelRegister("2P2cg", function(module, exports) {
$parcel$export(module.exports, "getProjectMenuItemAnalytics", () => $38f9307daa80d62f$export$acf0bd7d5f3c11ce);


var $tX7ST = parcelRequire("tX7ST");
const $38f9307daa80d62f$export$acf0bd7d5f3c11ce = ({ level: level = 2, ...attrs })=>(0, $tX7ST.getMenuItemAnalytics)({
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524),
        level: level,
        // menuId can't be used as itemId, as it has projectKey in it (so it will be different values for different projects).
        ...attrs
    });

});
parcelRegister("tX7ST", function(module, exports) {
$parcel$export(module.exports, "getMenuItemAnalytics", () => $f5f0043d1c516344$export$2425daf64d04c16b);

const $f5f0043d1c516344$export$2425daf64d04c16b = ({ componentType: componentType = (0, $493796f3bdee881c$export$4165a3d0da3bd147), itemId: itemId, ...restAttrs })=>({
        componentType: componentType,
        itemId: itemId,
        ...restAttrs
    });

});


parcelRegister("fwn5p", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca210639d83f15e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ca210639d83f15e4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    browseTemplates: {
        "id": "jira.navigation.apps.sidebar-nav4.sidebars.content.projects.browse-templates.ui.browse-templates",
        "defaultMessage": "Browse templates"
    }
});

});


parcelRegister("gD589", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsSectionPlacement", () => $1fa846eed4a63b1a$export$1a9d150d05db1e80);

var $eJOHy = parcelRequire("eJOHy");

var $497yS = parcelRequire("497yS");

var $5vQ2T = parcelRequire("5vQ2T");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $1gHmu = parcelRequire("1gHmu");

var $grotr = parcelRequire("grotr");

var $2xVkf = parcelRequire("2xVkf");

var $5fjzQ = parcelRequire("5fjzQ");

var $4EKqI = parcelRequire("4EKqI");
const $1fa846eed4a63b1a$export$fc398e7576350006 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onMessageCountChange: onMessageCountChange })=>{
    // Atlaspack couldn't bundle Post Office placement, so we need to return null here
    // https://atlassian.slack.com/archives/C0288U06PGC/p1755502530582239
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-growth-nav-4-projects-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "growthNav4ProjectsSection",
        packageName: "@atlassian/jira-growth-nav-4-projects-section",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $497yS.Placement), {
        onMessageCountChange: onMessageCountChange
    }))));
});
const $1fa846eed4a63b1a$export$dc892a9b01e35658 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onMessageCountChange: onMessageCountChange })=>{
    const [preloadedInitialData] = (0, $2xVkf.usePlacementPreloadedData)((0, $5fjzQ.postOfficeNav4ProjectsSectionResource));
    const memoizedPlacementProps = (0, $eJOHy.useMemo)(()=>({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            preloadedInitialData: preloadedInitialData
        }), [
        preloadedInitialData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-growth-nav-4-projects-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "growthNav4ProjectsSection",
        packageName: "@atlassian/jira-growth-nav-4-projects-section",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $grotr.PlacementFetchProvider), {
        resource: (0, $5fjzQ.postOfficeNav4ProjectsSectionResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $497yS.Placement), {
        ...memoizedPlacementProps,
        onMessageCountChange: onMessageCountChange
    })))));
});
const $1fa846eed4a63b1a$export$1a9d150d05db1e80 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('enable_ssr_recommendations_in_nav4'), $1fa846eed4a63b1a$export$dc892a9b01e35658, $1fa846eed4a63b1a$export$fc398e7576350006);

});
parcelRegister("497yS", function(module, exports) {
$parcel$export(module.exports, "Placement", () => $70c3994bf336ccd3$export$af2bcbdc04a2d456);

var $63MFS = parcelRequire("63MFS");

var $b5GNq = parcelRequire("b5GNq");

var $5XgUy = parcelRequire("5XgUy");

var $cUvrS = parcelRequire("cUvrS");
const $70c3994bf336ccd3$var$messageBackends = [
    (0, $63MFS.MessageBackend)({
        messageTemplateId: 'nav-4-projects-section-recommendation'
    })
];
const $70c3994bf336ccd3$var$messageFrontends = [
    (0, $63MFS.MessageFrontend)({
        messageTemplateId: 'nav-4-projects-section-recommendation'
    })
];
const $70c3994bf336ccd3$export$fb7710cf8bc72648 = (0, $5XgUy.PlacementBackend).createPlacementBackend({
    messageTemplates: $70c3994bf336ccd3$var$messageBackends
});
const $70c3994bf336ccd3$export$7b621692a0aa2333 = (0, $5XgUy.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: $70c3994bf336ccd3$var$messageFrontends
});
const $70c3994bf336ccd3$export$af2bcbdc04a2d456 = (0, $cUvrS.withI18n)($70c3994bf336ccd3$export$7b621692a0aa2333);
const $70c3994bf336ccd3$export$7d3d92a960f07a28 = $70c3994bf336ccd3$export$7b621692a0aa2333;
const $70c3994bf336ccd3$export$5a7767152ae0305f = $70c3994bf336ccd3$export$fb7710cf8bc72648((0, $b5GNq.productionRuntime));

});
parcelRegister("63MFS", function(module, exports) {
$parcel$export(module.exports, "MessageBackend", () => $cffc18af7983b55a$export$e7843a8f64a8d87c);
$parcel$export(module.exports, "MessageFrontend", () => $cffc18af7983b55a$export$fa9bb46961aca2cc);

var $gt9Am = parcelRequire("gt9Am");

var $9Uh9I = parcelRequire("9Uh9I");

var $5XgUy = parcelRequire("5XgUy");

var $7aZLF = parcelRequire("7aZLF");
const $cffc18af7983b55a$export$e7843a8f64a8d87c = (0, $5XgUy.PlacementBackend).createMessageBackend((0, $9Uh9I.defaultMessageBackend));
const $cffc18af7983b55a$var$render = (0, $5XgUy.PlacementFrontend).createFrontendStage({
    type: 'render',
    validate: (0, $9Uh9I.noValidation)(),
    Component: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7aZLF.Nav4Recommendation), {
            ...props
        })
});
const $cffc18af7983b55a$export$fa9bb46961aca2cc = (0, $5XgUy.PlacementFrontend).createMessageFrontend({
    render: $cffc18af7983b55a$var$render
});

});
parcelRegister("9Uh9I", function(module, exports) {
$parcel$export(module.exports, "defaultMessageBackend", () => $f5f1b9ddc0d2b65b$export$ed649b7c8ee8dc84);
$parcel$export(module.exports, "noValidation", () => $f5f1b9ddc0d2b65b$export$3f7a3f360cb80be4);

var $fXIXZ = parcelRequire("fXIXZ");
const $f5f1b9ddc0d2b65b$export$ed649b7c8ee8dc84 = ()=>({
        transformMetadata: {
            validate: $f5f1b9ddc0d2b65b$export$3f7a3f360cb80be4(),
            stage: (0, $fXIXZ.defaultTransformMetadata)
        }
    });
const $f5f1b9ddc0d2b65b$export$3f7a3f360cb80be4 = (_valueWithType)=>(input)=>input;

});
parcelRegister("fXIXZ", function(module, exports) {
$parcel$export(module.exports, "defaultTransformMetadata", () => $85ac0ba3ceeaa5dd$export$d56f9d28855034df);
const $85ac0ba3ceeaa5dd$export$d56f9d28855034df = ()=>({
        goalMetadata: {
            primaryGoal: {
                goalId: 'clickthrough'
            }
        }
    });

});


parcelRegister("5XgUy", function(module, exports) {
$parcel$export(module.exports, "PlacementBackend", () => $a5fbe2974cc48af4$export$d90b37843c84d1c3);
$parcel$export(module.exports, "PlacementFrontend", () => $a5fbe2974cc48af4$export$55486c2b6964dcf2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kuAvn = parcelRequire("kuAvn");

var $kX7CT = parcelRequire("kX7CT");

var $c7FOL = parcelRequire("c7FOL");

var $fuwhX = parcelRequire("fuwhX");

var $kDaaB = parcelRequire("kDaaB");
const $a5fbe2974cc48af4$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};
const { createFrontend: $a5fbe2974cc48af4$export$81df3aa6753d44e2, createBackend: $a5fbe2974cc48af4$export$da912f58cb37a643 } = (0, $kX7CT.createPlacement)({
    placementId: 'nav-4-projects-section',
    options: {
        choreographer: {
            isDefaultEnabled: false
        }
    }
});
const $a5fbe2974cc48af4$var$getRecommendationsQuery = (0, $kuAvn.gql)`
	query Nav4RecommendationsQuery(
		$cloudId: ID!
		$rerankCandidateList: [GrowthRecRerankCandidate!]!
	) {
		jira {
			canCreateProject: canPerform(type: CREATE_PROJECT, cloudId: $cloudId) @optIn(to: "JiraAction")
		}
		growthRecommendations {
			recommendations(
				context: { useCase: "jiraProjectMenuRecommendations", tenantId: $cloudId, product: "jira" }
				first: 1
				rerank: $rerankCandidateList
			) {
				... on GrowthRecRecommendations {
					data {
						... on GrowthRecJiraTemplateRecommendation {
							entityId
						}
					}
					context {
						sessionId
					}
				}
			}
		}
	}
`;
const $a5fbe2974cc48af4$export$d90b37843c84d1c3 = $a5fbe2974cc48af4$export$da912f58cb37a643({
    customMiddleware: (0, $c7FOL.placementMiddlewareWithCacheControlNav),
    params: {
        sortingMethod: undefined,
        dataRetrivalType: 'implicit-only'
    },
    stages: ({ hydrate: hydrate })=>({
            postInit: async (input)=>{
                const { data: data, request: request } = input;
                // Hydrate the original messages
                const { messages: messages } = await hydrate?.(input) ?? data;
                const nav4ProjectsRecommendationsMessages = messages.filter((message)=>message.messageTemplateId === 'nav-4-projects-section-recommendation');
                const enableXForwardedHostHeader = request.statsig.checkGate({
                    identifiers: {
                        atlassianAccountId: request.orchestrationContext.recipient.userId
                    }
                }, 'post-office_enable_x-forwarded-host-header');
                const { data: recommendation, errors: errors, error: error } = await request.graphqlClients.cachedGraphqlGateway.query({
                    query: $a5fbe2974cc48af4$var$getRecommendationsQuery,
                    variables: {
                        cloudId: request.orchestrationContext.tenantId,
                        // Use the implicit messages from nav-4-projects-section-recommendation as the rerank list
                        rerankCandidateList: nav4ProjectsRecommendationsMessages.map((message)=>({
                                entityId: message.context.entityId
                            }))
                    },
                    context: {
                        headers: {
                            ...enableXForwardedHostHeader && request.headers?.['x-forwarded-host'] ? {
                                'x-forwarded-host': request.headers['x-forwarded-host']
                            } : {}
                        }
                    }
                }, {});
                if (error || errors?.length || !recommendation || !recommendation.jira?.canCreateProject || !recommendation.growthRecommendations?.recommendations?.data?.length || !recommendation.growthRecommendations?.recommendations?.context?.sessionId) {
                    request.logger.error({
                        error: error,
                        errors: errors,
                        recommendation: recommendation
                    }, 'Error fetching recommendations for nav-4-projects-section-recommendation');
                    // Ignore nav-4-projects-section-recommendation if anything wrong with the GRS call
                    return {
                        messages: messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation')
                    };
                }
                const recommendedMessages = nav4ProjectsRecommendationsMessages// We only want the recommended template to be returned
                .filter((message)=>recommendation.growthRecommendations?.recommendations?.data?.some((r)=>r.entityId === message.context.entityId)).map((message)=>({
                        ...message,
                        context: {
                            ...message.context,
                            // Add recommendationSessionId returned from GRS into the message context which is passed into CFFE.
                            recommendationSessionId: recommendation.growthRecommendations?.recommendations?.context?.sessionId ?? ''
                        }
                    }));
                request.logger.info({
                    recommendedMessages: recommendedMessages
                }, 'Recommended messages for nav-4-projects-section-recommendation');
                return {
                    messages: [
                        ...messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation'),
                        ...recommendedMessages
                    ]
                };
            }
        })
});
const $a5fbe2974cc48af4$export$55486c2b6964dcf2 = $a5fbe2974cc48af4$export$81df3aa6753d44e2((Messages)=>({ onMessageCountChange: onMessageCountChange, preloadedInitialData: preloadedInitialData })=>{
        const [{ messages: messages, status: status }, setMessagesState] = (0, $eJOHy.useState)(()=>{
            if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
                status: 'done',
                messages: preloadedInitialData?.messages
            } : {
                messages: undefined,
                status: 'done'
            };
            return {
                messages: undefined,
                status: 'loading'
            };
        });
        const isDone = status === 'done';
        const { data: data, error: error, isLoading: isLoading } = (0, $fuwhX.usePlacementApi)('/', {
            autoRefetch: {
                isEnabled: !isDone,
                updateKey: 'nav-4-projects-section'
            }
        });
        (0, $eJOHy.useEffect)(()=>{
            if (typeof messages === 'undefined') return;
            if (!onMessageCountChange) return;
            onMessageCountChange(messages.length);
        }, [
            messages,
            onMessageCountChange
        ]);
        const handleDismiss = (0, $eJOHy.useCallback)((messageInstanceId)=>{
            setMessagesState(()=>{
                if (!messages) return {
                    messages: undefined,
                    status: 'done'
                };
                const filteredMessages = messages.filter((message)=>messageInstanceId !== message.messageInstanceId);
                return {
                    messages: filteredMessages,
                    status: 'done'
                };
            });
        }, [
            messages
        ]);
        (0, $eJOHy.useEffect)(()=>{
            if (!isLoading && !isDone) setMessagesState({
                messages: data?.messages,
                status: 'done'
            });
        }, [
            isLoading,
            isDone,
            data
        ]);
        if (error) return null;
        if (status === 'loading') return null;
        return Array.isArray(messages) && messages.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            role: "list",
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                role: "group",
                "aria-labelledby": "nav-4-projects-section-menu-section",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("h2", {
                        id: "nav-4-projects-section-menu-section-heading",
                        className: (0, $hcewu.default)([
                            $a5fbe2974cc48af4$var$styles.root
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            id: "post-office.nav-4-projects-recommendations.section-heading",
                            defaultMessage: "Recommended",
                            description: "heading for nav4 projects recommendations section"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        role: "listitem",
                        children: messages?.map((props, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Messages.render, {
                                dismiss: ()=>handleDismiss(props.messageInstanceId),
                                ...props
                            }, `${props.messageInstanceId}-${index}`))
                    })
                ]
            })
        }) : null;
    });

});
parcelRegister("kX7CT", function(module, exports) {
$parcel$export(module.exports, "createPlacement", () => $9a4994a96dadb195$export$a2cfeb566a0f6574);

var $gt9Am = parcelRequire("gt9Am");

var $eOlnh = parcelRequire("eOlnh");

var $lUFNt = parcelRequire("lUFNt");

var $57NEY = parcelRequire("57NEY");

var $eCvse = parcelRequire("eCvse");

var $2KasD = parcelRequire("2KasD");

var $fAwAG = parcelRequire("fAwAG");

var $9Uh9I = parcelRequire("9Uh9I");

var $b80Pk = parcelRequire("b80Pk");

var $aPucE = parcelRequire("aPucE");

var $30pkt = parcelRequire("30pkt");
const $9a4994a96dadb195$export$a2cfeb566a0f6574 = (placementConfig)=>{
    return {
        createFrontend: $9a4994a96dadb195$var$createFrontend(placementConfig),
        createBackend: $9a4994a96dadb195$var$createBackend(placementConfig)
    };
};
/*-- Frontend --*/ const $9a4994a96dadb195$var$createFrontend = (placementConfig)=>(placementRenderer)=>({
            createFrontendStage: (stage)=>stage,
            createMessageFrontend: (stage)=>(config)=>[
                        config.messageTemplateId,
                        stage
                    ],
            createPlacementFrontendComponent: (config)=>{
                const messageTemplateRouter = $9a4994a96dadb195$var$createFrontendPlacementMessageTemplateRouter({
                    ...placementConfig,
                    ...config
                });
                return (0, $eCvse.createPlacementComponentV2)(placementConfig.placementId, placementRenderer(messageTemplateRouter), placementConfig.options);
            }
        });
const $9a4994a96dadb195$var$createFrontendPlacementMessageRunner = ({ messageTemplates: messageTemplates, ...config })=>({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCategory: messageCategory, children: children, ...props })=>{
        const renderableStage = messageTemplates?.[messageTemplateId];
        const placementLocation = {
            messageTemplateId: messageTemplateId,
            messageInstanceId: messageInstanceId,
            placementLevel: 'Message',
            stageName: config?.stageName,
            placementId: config.placementId
        };
        try {
            if (!renderableStage) {
                // eslint-disable-next-line no-console
                console.warn(new (0, $fAwAG.PlacementMessageError)({
                    ...placementLocation,
                    ...config
                }));
                return null;
            }
            renderableStage.validate({
                messageTemplateId: messageTemplateId,
                children: children,
                ...props
            }); // Will throw error if type validation fails
            const { Component: Component } = renderableStage;
            const componentPropsStable = (0, $eOlnh.useStableObject)(props);
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lUFNt.MessageRendererProvider), {
                ...componentPropsStable,
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCategory: messageCategory,
                isUFOEnabled: false,
                componentProps: componentPropsStable,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $57NEY.MessageViewed), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                        ...props,
                        children: children
                    })
                ]
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error((0, $fAwAG.createPlacementMessageError)(error));
            return null;
        }
    };
const $9a4994a96dadb195$var$createFrontendPlacementMessageTemplateRouter = (config)=>{
    const messageTemplateLookup = $9a4994a96dadb195$export$9681465a68237b0(config);
    return Object.entries(messageTemplateLookup).reduce((base, [stageName, messageTemplates])=>({
            ...base,
            [stageName]: $9a4994a96dadb195$var$createFrontendPlacementMessageRunner({
                messageTemplates: messageTemplates,
                stageName: stageName,
                placementId: config.placementId
            })
        }), {});
};
/*-- Backend --*/ const $9a4994a96dadb195$var$createBackend = (placementConfig)=>(placementBackendParams)=>({
            createBackendStage: (stage)=>stage,
            createMessageBackend: (stages)=>(messageBackendConfig)=>{
                    const stagesWithDefaults = $9a4994a96dadb195$var$applyDefaultMessageBackendStages(stages);
                    return [
                        messageBackendConfig.messageTemplateId,
                        stagesWithDefaults
                    ];
                },
            createPlacementBackend: (placementBackendConfig)=>(runtime)=>{
                    const placementBackendStages = placementBackendParams?.stages ?? (0, $aPucE.defaultBackendPlacementStages);
                    const placementId = placementConfig.placementId;
                    const placementStages = $9a4994a96dadb195$var$createBackendPlacementRunners(placementBackendStages);
                    const messagesStages = $9a4994a96dadb195$var$createBackendPlacementMessageTemplateRouter({
                        ...placementConfig,
                        ...placementBackendConfig
                    });
                    const middleware = placementBackendParams?.customMiddleware ?? (0, $2KasD.defaultPlacementMiddleware);
                    const statelessMiddleware = middleware({
                        ...placementConfig,
                        ...placementBackendParams?.params
                    });
                    const statelessMessagesRuntime = runtime({
                        messagesStages: messagesStages,
                        placementStages: placementStages,
                        placementId: placementId
                    });
                    const koaMiddleware = async (ctx, next)=>{
                        const koa = {
                            ctx: ctx,
                            next: next
                        };
                        const request = ctx.state.requestContext.location.tag({
                            placementId: placementConfig.placementId
                        });
                        const messagesRuntime = async (config)=>{
                            const configuredRequest = (config?.request ?? request).location.tag({
                                placementLevel: 'Runtime'
                            });
                            if (!configuredRequest) throw new (0, $fAwAG.PlacementSystemError)({
                                message: 'request context not available at runtime call'
                            });
                            const contexts = {
                                koa: koa,
                                request: configuredRequest
                            };
                            const combinedParams = {
                                ...placementBackendParams?.params,
                                ...config?.params
                            };
                            try {
                                const result = await (0, $b80Pk.placementRuntimeTimedStage)(statelessMessagesRuntime)(contexts)(combinedParams);
                                (0, $b80Pk.logRuntimeResult)(contexts)(result);
                                return result;
                            } catch (error) {
                                throw (0, $fAwAG.handlePlacementRuntimeError)(contexts.request)(error);
                            }
                        };
                        const postOffice = {
                            messagesRuntime: messagesRuntime
                        };
                        try {
                            const middlewareRequest = request.location.tag({
                                placementLevel: 'Middleware'
                            });
                            await statelessMiddleware({
                                koa: koa,
                                postOffice: postOffice,
                                request: middlewareRequest,
                                placement: placementConfig
                            });
                        } catch (error) {
                            throw (0, $fAwAG.handlePlacementMiddlewareError)(request)(error);
                        } finally{
                            const includePlacementMetadata = ctx.header?.['x-include-request-metadata'] === 'true';
                            if (includePlacementMetadata) ctx.body.requestMetadata = {
                                ...describe(),
                                graph: request.location.getGraph()
                            };
                        }
                    };
                    const describe = ()=>{
                        const messageTemplates = placementBackendConfig.messageTemplates.map(([id, stages])=>{
                            return {
                                id: id,
                                stages: Object.keys(stages)
                            };
                        });
                        const placementId = placementConfig.placementId;
                        return {
                            placementId: placementId,
                            messageTemplates: messageTemplates
                        };
                    };
                    return {
                        middleware: koaMiddleware,
                        config: placementConfig,
                        describe: describe
                    };
                }
        });
const $9a4994a96dadb195$var$applyDefaultMessageBackendStages = (stages)=>{
    const validatedDefaultStages = {};
    Object.entries((0, $30pkt.defaultBackendPlacementMessageStages)).forEach(([stageName, stage])=>{
        validatedDefaultStages[stageName] = {
            validate: (0, $9Uh9I.noValidation)(),
            stage: stage
        };
    });
    return {
        ...validatedDefaultStages,
        ...stages()
    };
};
const $9a4994a96dadb195$var$createBackendPlacementRunners = (config)=>{
    return (placementMessageStages)=>{
        const placementStages = config(placementMessageStages);
        const wrappedPlacementStages = {};
        Object.entries(placementStages).forEach(([stageName, stage])=>{
            if (!stage) wrappedPlacementStages[stageName] = undefined;
            wrappedPlacementStages[stageName] = $9a4994a96dadb195$var$createBackendPlacementRunner({
                stageName: stageName,
                stage: stage
            });
        });
        return wrappedPlacementStages;
    };
};
const $9a4994a96dadb195$var$createBackendPlacementRunner = ({ stageName: stageName, stage: stage })=>async (params)=>{
        const request = params.request.location.tag({
            placementLevel: 'Placement',
            stageName: stageName
        });
        if (!stage) return params.data;
        try {
            return (0, $b80Pk.placementTimedStage)(stage)({
                request: request,
                data: params.data
            });
        } catch (error) {
            throw (0, $fAwAG.handlePlacementError)(request)(error);
        }
    };
const $9a4994a96dadb195$var$createBackendPlacementMessageTemplateRouter = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stages])=>Object.entries(stages).forEach(([stageName, stage])=>{
            if (!result[messageTemplateId]) result[messageTemplateId] = {};
            // We can safely use a non-null assertion here as we validate the existance of
            // result[messageTemplateId] above
            result[messageTemplateId][stageName] = $9a4994a96dadb195$var$createBackendPlacementMessageRunner({
                stage: stage,
                stageName: stageName,
                placementId: config.placementId
            });
        }));
    return result;
};
const $9a4994a96dadb195$var$createBackendPlacementMessageRunner = (config)=>{
    return async (input)=>{
        const { message: message } = input;
        const request = input.request.location.tag({
            placementLevel: 'Message',
            messageTemplateId: message?.messageTemplateId,
            messageInstanceId: message?.messageInstanceId,
            triggerId: message?.triggerId,
            stageName: config?.stageName
        });
        try {
            const { validate: validate, stage: stage } = config.stage;
            validate(input.message.context); // Throws if fails validation
            const context = await (0, $b80Pk.messageTimedStage)(stage)({
                request: request,
                message: message
            });
            return {
                ...message,
                context: context
            };
        } catch (error) {
            throw (0, $fAwAG.handlePlacementMessageError)(request)(error);
        }
    };
};
const $9a4994a96dadb195$export$9681465a68237b0 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stage])=>{
        Object.entries(stage).forEach(([stageName, stageExecutable])=>{
            if (!result[stageName]) result[stageName] = {};
            // We can safely use a non-null assertion here as we validate the existance of
            // result[stageName] above
            result[stageName][messageTemplateId] = stageExecutable;
        });
    });
    return result;
};

});
parcelRegister("eOlnh", function(module, exports) {
$parcel$export(module.exports, "useStableObject", () => $b519f9d52be75a96$export$ed02d4adf2068b08);

var $eJOHy = parcelRequire("eJOHy");
function $b519f9d52be75a96$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $b519f9d52be75a96$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>obj, $b519f9d52be75a96$export$cdf98ded28406f69(obj));
}

});

parcelRegister("lUFNt", function(module, exports) {
$parcel$export(module.exports, "MessageRendererProvider", () => $04263d315330cef5$export$5fe06fe68913d493);

var $gt9Am = parcelRequire("gt9Am");

var $bb3PU = parcelRequire("bb3PU");

var $6tbGL = parcelRequire("6tbGL");

var $iCnG4 = parcelRequire("iCnG4");

var $eJOHy = parcelRequire("eJOHy");

var $dOYA4 = parcelRequire("dOYA4");

var $1i76i = parcelRequire("1i76i");

var $45ArU = parcelRequire("45ArU");
const $04263d315330cef5$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $04263d315330cef5$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $eJOHy.Suspense) })=>{
    const loadingComponent = (0, $eJOHy.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bb3PU.UFOv2).UFOLoadHold, {
            name: (0, $bb3PU.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $eJOHy.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            componentProps: componentProps,
            analyticsDetails: postOffice?.analyticsDetails
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps,
        postOffice
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dOYA4.ChoreographerWrapper), {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1i76i.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tbGL.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iCnG4.RecommendationProvider), {
                    value: recommendationSession ?? $04263d315330cef5$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $45ArU.MessageAnalyticsContextProvider), {
                            children: [
                                messageSuccessComponent,
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("bb3PU", function(module, exports) {
$parcel$export(module.exports, "UFOv2", () => $483e03590a358262$export$c91b09caa8ecbab1);

var $dLR8J = parcelRequire("dLR8J");

var $6FOAB = parcelRequire("6FOAB");
const $483e03590a358262$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $dLR8J.default,
    UFOSegment: $6FOAB.default
};

});

parcelRegister("6tbGL", function(module, exports) {
$parcel$export(module.exports, "MessageContextProvider", () => $4789c238ca8930d2$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $4789c238ca8930d2$export$a5b6d14a2e25725a);

var $eJOHy = parcelRequire("eJOHy");
const $4789c238ca8930d2$var$initialValue = {};
const $4789c238ca8930d2$export$b060d577040138d8 = (0, $eJOHy.createContext)($4789c238ca8930d2$var$initialValue);
const $4789c238ca8930d2$export$42de33f7652dc3de = $4789c238ca8930d2$export$b060d577040138d8.Provider;
const $4789c238ca8930d2$export$a5b6d14a2e25725a = ()=>(0, $eJOHy.useContext)($4789c238ca8930d2$export$b060d577040138d8);

});

parcelRegister("iCnG4", function(module, exports) {
$parcel$export(module.exports, "RecommendationProvider", () => $9a4b7018fef95678$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $9a4b7018fef95678$export$3321c0b02f750bcc);

var $gt9Am = parcelRequire("gt9Am");

var $e2B2h = parcelRequire("e2B2h");

var $eJOHy = parcelRequire("eJOHy");
const $9a4b7018fef95678$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $9a4b7018fef95678$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($9a4b7018fef95678$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: value,
            children: children
        })
    });
};
const $9a4b7018fef95678$export$3321c0b02f750bcc = ()=>(0, $eJOHy.useContext)($9a4b7018fef95678$export$ba2f44035effd9c1);

});

parcelRegister("dOYA4", function(module, exports) {
$parcel$export(module.exports, "ChoreographerWrapper", () => $90315149fc76684e$export$8db7ba034addcd65);

var $gt9Am = parcelRequire("gt9Am");

var $59rsN = parcelRequire("59rsN");

var $gr4vM = parcelRequire("gr4vM");

var $eJOHy = parcelRequire("eJOHy");

var $62EJZ = parcelRequire("62EJZ");
const $90315149fc76684e$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return null;
};
const $90315149fc76684e$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $62EJZ.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $59rsN.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $59rsN.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $gt9Am.jsx)($90315149fc76684e$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});
parcelRegister("gr4vM", function(module, exports) {
$parcel$export(module.exports, "EP_ANALYTICS_CHANNEL", () => $c8087ba469b49090$export$33911828b25deac7);
$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $c8087ba469b49090$export$57d19d18d6e255a5);
$parcel$export(module.exports, "useFireEngagementPlatformAnalyticsEvents", () => $c8087ba469b49090$export$f14470c9a12428fc);

var $ftN6c = parcelRequire("ftN6c");

var $eJOHy = parcelRequire("eJOHy");
const $c8087ba469b49090$export$85183a312807388d = 'postOffice';
const $c8087ba469b49090$export$33911828b25deac7 = 'engagementPlatform';
const $c8087ba469b49090$export$54a232c9990f260e = 'jira';
const $c8087ba469b49090$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $eJOHy.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($c8087ba469b49090$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $c8087ba469b49090$export$f14470c9a12428fc = (product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $eJOHy.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire(product);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});

parcelRegister("62EJZ", function(module, exports) {
$parcel$export(module.exports, "StableChoreographerProvider", () => $e4ee03d9c052b887$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $e4ee03d9c052b887$export$cab5a8adbabcee23);

var $gt9Am = parcelRequire("gt9Am");

var $6a4LK = parcelRequire("6a4LK");
var $dWans = parcelRequire("dWans");

var $2tHDh = parcelRequire("2tHDh");

var $eJOHy = parcelRequire("eJOHy");
/**
 * Choreographer-specific debug logger instance
 */ const $e4ee03d9c052b887$var$choreographerLogger = (0, $2tHDh.createInBrowserDebugLogger)('choreographer');
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $e4ee03d9c052b887$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        // CommonJS module
        $e4ee03d9c052b887$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        // ESM module in browser
        $e4ee03d9c052b887$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof mod?.default === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        // ESM module in Node.js
        $e4ee03d9c052b887$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $e4ee03d9c052b887$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $e4ee03d9c052b887$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $e4ee03d9c052b887$var$defaultContext = {
    choreographerEnabled: $e4ee03d9c052b887$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $e4ee03d9c052b887$var$ChoreographerContext = /*#__PURE__*/ (0, $eJOHy.createContext)($e4ee03d9c052b887$var$defaultContext);

const $e4ee03d9c052b887$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $eJOHy.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $eJOHy.useState)(choreographer?.isDefaultEnabled ?? $e4ee03d9c052b887$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $dWans.usePostOfficeEnvironment)();
    const context = (0, $6a4LK.usePostOfficeContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("evcFJ")).then((m)=>{
            // Autoresolve the ChoreographerRegistry class depending on whether the module is an ESM or CommonJS module
            const ChoreographerRegistryClass = $e4ee03d9c052b887$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $e4ee03d9c052b887$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $e4ee03d9c052b887$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $e4ee03d9c052b887$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $e4ee03d9c052b887$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $eJOHy.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    // Log context changes outside of useMemo to avoid performance impact
    (0, $eJOHy.useEffect)(()=>{
        $e4ee03d9c052b887$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        stableChoreographerContext,
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e4ee03d9c052b887$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $e4ee03d9c052b887$export$cab5a8adbabcee23 = ()=>(0, $eJOHy.useContext)($e4ee03d9c052b887$var$ChoreographerContext);

});
parcelRegister("6a4LK", function(module, exports) {
$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $ce18d03b7d5d889b$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $ce18d03b7d5d889b$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $ce18d03b7d5d889b$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $ce18d03b7d5d889b$export$5bd9099e0ae94a43);

var $eJOHy = parcelRequire("eJOHy");
const $ce18d03b7d5d889b$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $ce18d03b7d5d889b$export$a228be81fcb77b42 = (0, $eJOHy.createContext)($ce18d03b7d5d889b$export$da5dc9062cba6715);
const $ce18d03b7d5d889b$export$3a10495c2cd2db0c = $ce18d03b7d5d889b$export$a228be81fcb77b42.Provider;
const $ce18d03b7d5d889b$export$b77983be89bb0a4e = $ce18d03b7d5d889b$export$3a10495c2cd2db0c;
const $ce18d03b7d5d889b$export$5bd9099e0ae94a43 = ()=>(0, $eJOHy.useContext)($ce18d03b7d5d889b$export$a228be81fcb77b42);

});

parcelRegister("2tHDh", function(module, exports) {
$parcel$export(module.exports, "createInBrowserDebugLogger", () => $e5e78ea75b8b1f09$export$806eda59584e395d);
/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components
 *
 * Usage:
 * - Enable: window.postOfficeChoreographerDebug = true
 * - Disable: window.postOfficeChoreographerDebug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $e5e78ea75b8b1f09$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};

});

parcelRegister("evcFJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1bNGv").then(()=>parcelRequire('aD8pc'));

});



parcelRegister("1i76i", function(module, exports) {
$parcel$export(module.exports, "FeatureFlaggedUfoWrapper", () => $2bba0b14bc3b911f$export$8e6fb7035018b3e4);

var $gt9Am = parcelRequire("gt9Am");

var $bb3PU = parcelRequire("bb3PU");
const $2bba0b14bc3b911f$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bb3PU.UFOv2).UFOSegment, {
        name: (0, $bb3PU.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bb3PU.UFOv2).UFOSegment, {
            name: `${(0, $bb3PU.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});

parcelRegister("45ArU", function(module, exports) {
$parcel$export(module.exports, "MessageAnalyticsContextProvider", () => $2fdde5daf76fb4ea$export$1737ab199e83455e);
$parcel$export(module.exports, "useMessageAnalyticsContext", () => $2fdde5daf76fb4ea$export$bb426ba114b64992);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $2fdde5daf76fb4ea$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $2fdde5daf76fb4ea$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $eJOHy.createContext)($2fdde5daf76fb4ea$var$defaultMessageAnalyticsContextValue);
const $2fdde5daf76fb4ea$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $eJOHy.useRef)(false);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2fdde5daf76fb4ea$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $2fdde5daf76fb4ea$export$bb426ba114b64992 = ()=>(0, $eJOHy.useContext)($2fdde5daf76fb4ea$export$c81717973c6c4a90);

});


parcelRegister("57NEY", function(module, exports) {
$parcel$export(module.exports, "ManualMessageViewedEvent", () => $60859bdb115437c4$export$de534803cb07dfcc);
$parcel$export(module.exports, "MessageViewed", () => $60859bdb115437c4$export$14fe1fc3395b6e3f);

var $gt9Am = parcelRequire("gt9Am");

var $k9r6D = parcelRequire("k9r6D");

var $5EHjk = parcelRequire("5EHjk");

var $eJOHy = parcelRequire("eJOHy");

var $6TYxj = parcelRequire("6TYxj");

var $45ArU = parcelRequire("45ArU");

var $02WN6 = parcelRequire("02WN6");
const $60859bdb115437c4$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $45ArU.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $60859bdb115437c4$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $45ArU.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $5EHjk.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $k9r6D.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $eJOHy.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $eJOHy.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $eJOHy.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $02WN6.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $60859bdb115437c4$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $eJOHy.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $k9r6D.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $6TYxj.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $eJOHy.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $eJOHy.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $gt9Am.jsx)($60859bdb115437c4$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};

});
parcelRegister("k9r6D", function(module, exports) {
$parcel$export(module.exports, "useMessageInstanceEvent", () => $0ae6ab88d768dd09$export$39b0f5626e96f41e);

var $6a4LK = parcelRequire("6a4LK");

var $6tbGL = parcelRequire("6tbGL");

var $g9gHI = parcelRequire("g9gHI");

var $iCnG4 = parcelRequire("iCnG4");

var $eJOHy = parcelRequire("eJOHy");

var $32dr4 = parcelRequire("32dr4");

var $h92e3 = parcelRequire("h92e3");
const $0ae6ab88d768dd09$export$39b0f5626e96f41e = ()=>{
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $h92e3.MessageInstanceEventClient)();
    const client = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId = null, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, analyticsDetails: analyticsDetails = null } = (0, $6tbGL.useMessageContext)();
    const { placementId: placementId } = (0, $g9gHI.usePlacementContext)();
    const browserContext = (0, $6a4LK.usePostOfficeContext)();
    const recommendationContext = (0, $iCnG4.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $eJOHy.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $32dr4.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    const messageInstanceViewed = (0, $eJOHy.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $32dr4.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    const messageInstanceClicked = (0, $eJOHy.useCallback)(async (params)=>{
        if (!messageInstanceId && !params.messageInstanceId || !messageTemplateId && !params.messageTemplateId || !placementId || !messageCreationType && !params.messageCreationType || !messageTriggerId && !params.messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $32dr4.MessageInstanceEventContextError)());
            return;
        }
        const clickEventPayload = {
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: params.messageTriggerId ?? messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            ...params,
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...params.additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(clickEventPayload);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};

});
parcelRegister("g9gHI", function(module, exports) {
$parcel$export(module.exports, "PlacementProvider", () => $bdd821e5d322aa36$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $bdd821e5d322aa36$export$4fc0446ee742ad80);

var $gt9Am = parcelRequire("gt9Am");

var $eUaD0 = parcelRequire("eUaD0");

var $h60js = parcelRequire("h60js");

var $eJOHy = parcelRequire("eJOHy");
const $bdd821e5d322aa36$export$6394bf86db095a8 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    placementId: undefined
});
const $bdd821e5d322aa36$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $eJOHy.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $h60js.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($bdd821e5d322aa36$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $bdd821e5d322aa36$export$4fc0446ee742ad80 = ()=>(0, $eJOHy.useContext)($bdd821e5d322aa36$export$6394bf86db095a8);

});
parcelRegister("h60js", function(module, exports) {
$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $f194a8c55e37392a$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $f194a8c55e37392a$export$f51d04a086368016);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ht2r3 = parcelRequire("ht2r3");
const $f194a8c55e37392a$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $f194a8c55e37392a$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    placements: $f194a8c55e37392a$var$initialPlacementState
});
const $f194a8c55e37392a$export$70e19226ddeaf957 = ()=>(0, $eJOHy.useContext)($f194a8c55e37392a$var$PostOfficeScreenContext);
const $f194a8c55e37392a$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $f194a8c55e37392a$export$5d27c0ee02be2a23 = ()=>(0, $eJOHy.useContext)($f194a8c55e37392a$var$PostOfficeScreenUpdateContext);
const $f194a8c55e37392a$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $eJOHy.useState)($f194a8c55e37392a$var$initialPlacementState);
    const placementMount = (0, $eJOHy.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $ht2r3.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $ht2r3.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $eJOHy.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $eJOHy.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $eJOHy.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f194a8c55e37392a$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f194a8c55e37392a$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext,
            children: children
        })
    });
};
const $f194a8c55e37392a$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $f194a8c55e37392a$export$5d27c0ee02be2a23();
    (0, $eJOHy.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("ht2r3", function(module, exports) {
$parcel$export(module.exports, "uniqueArray", () => $e2cc485b6f839fe6$export$bbd17ecb0679edd7);
const $e2cc485b6f839fe6$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});



parcelRegister("32dr4", function(module, exports) {
$parcel$export(module.exports, "MessageInstanceEventContextError", () => $a83030d367cd2f45$export$9ffc53d3edc152da);
class $a83030d367cd2f45$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $a83030d367cd2f45$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}

});

parcelRegister("h92e3", function(module, exports) {
$parcel$export(module.exports, "MessageInstanceEventClient", () => $f238ee4d61788317$export$4564cfc2de39be55);
const $f238ee4d61788317$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $f238ee4d61788317$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $f238ee4d61788317$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("7WsxX"));
class $f238ee4d61788317$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $f238ee4d61788317$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $f238ee4d61788317$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $f238ee4d61788317$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($f238ee4d61788317$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $f238ee4d61788317$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $f238ee4d61788317$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("7WsxX", function(module, exports) {
$parcel$export(module.exports, "Headers", () => $5c8417fc15f82fb3$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $5c8417fc15f82fb3$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $5c8417fc15f82fb3$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $5c8417fc15f82fb3$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $5c8417fc15f82fb3$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $5c8417fc15f82fb3$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $5c8417fc15f82fb3$var$support = {
    searchParams: 'URLSearchParams' in $5c8417fc15f82fb3$var$g,
    iterable: 'Symbol' in $5c8417fc15f82fb3$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $5c8417fc15f82fb3$var$g && 'Blob' in $5c8417fc15f82fb3$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $5c8417fc15f82fb3$var$g,
    arrayBuffer: 'ArrayBuffer' in $5c8417fc15f82fb3$var$g
};
function $5c8417fc15f82fb3$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($5c8417fc15f82fb3$var$support.arrayBuffer) {
    var $5c8417fc15f82fb3$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $5c8417fc15f82fb3$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $5c8417fc15f82fb3$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $5c8417fc15f82fb3$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $5c8417fc15f82fb3$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $5c8417fc15f82fb3$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($5c8417fc15f82fb3$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $5c8417fc15f82fb3$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $5c8417fc15f82fb3$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $5c8417fc15f82fb3$var$normalizeName(name);
    value = $5c8417fc15f82fb3$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$5c8417fc15f82fb3$var$normalizeName(name)];
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $5c8417fc15f82fb3$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($5c8417fc15f82fb3$var$normalizeName(name));
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$5c8417fc15f82fb3$var$normalizeName(name)] = $5c8417fc15f82fb3$var$normalizeValue(value);
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $5c8417fc15f82fb3$var$iteratorFor(items);
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $5c8417fc15f82fb3$var$iteratorFor(items);
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $5c8417fc15f82fb3$var$iteratorFor(items);
};
if ($5c8417fc15f82fb3$var$support.iterable) $5c8417fc15f82fb3$export$79b704688b15c0f4.prototype[Symbol.iterator] = $5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.entries;
function $5c8417fc15f82fb3$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $5c8417fc15f82fb3$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $5c8417fc15f82fb3$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $5c8417fc15f82fb3$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $5c8417fc15f82fb3$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $5c8417fc15f82fb3$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $5c8417fc15f82fb3$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $5c8417fc15f82fb3$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $5c8417fc15f82fb3$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($5c8417fc15f82fb3$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($5c8417fc15f82fb3$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($5c8417fc15f82fb3$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($5c8417fc15f82fb3$var$support.arrayBuffer && $5c8417fc15f82fb3$var$support.blob && $5c8417fc15f82fb3$var$isDataView(body)) {
            this._bodyArrayBuffer = $5c8417fc15f82fb3$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($5c8417fc15f82fb3$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $5c8417fc15f82fb3$var$isArrayBufferView(body))) this._bodyArrayBuffer = $5c8417fc15f82fb3$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($5c8417fc15f82fb3$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($5c8417fc15f82fb3$var$support.blob) this.blob = function() {
        var rejected = $5c8417fc15f82fb3$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $5c8417fc15f82fb3$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($5c8417fc15f82fb3$var$support.blob) return this.blob().then($5c8417fc15f82fb3$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $5c8417fc15f82fb3$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $5c8417fc15f82fb3$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($5c8417fc15f82fb3$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($5c8417fc15f82fb3$var$support.formData) this.formData = function() {
        return this.text().then($5c8417fc15f82fb3$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $5c8417fc15f82fb3$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $5c8417fc15f82fb3$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $5c8417fc15f82fb3$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $5c8417fc15f82fb3$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $5c8417fc15f82fb3$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $5c8417fc15f82fb3$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $5c8417fc15f82fb3$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $5c8417fc15f82fb3$export$79b704688b15c0f4(options.headers);
    this.method = $5c8417fc15f82fb3$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $5c8417fc15f82fb3$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$5c8417fc15f82fb3$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $5c8417fc15f82fb3$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $5c8417fc15f82fb3$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $5c8417fc15f82fb3$var$parseHeaders(rawHeaders) {
    var headers = new $5c8417fc15f82fb3$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$5c8417fc15f82fb3$var$Body.call($5c8417fc15f82fb3$export$7fa6c5b6f8193917.prototype);
function $5c8417fc15f82fb3$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $5c8417fc15f82fb3$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $5c8417fc15f82fb3$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$5c8417fc15f82fb3$var$Body.call($5c8417fc15f82fb3$export$9f633d56d7ec90d3.prototype);
$5c8417fc15f82fb3$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $5c8417fc15f82fb3$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $5c8417fc15f82fb3$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$5c8417fc15f82fb3$export$9f633d56d7ec90d3.error = function() {
    var response = new $5c8417fc15f82fb3$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $5c8417fc15f82fb3$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$5c8417fc15f82fb3$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($5c8417fc15f82fb3$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $5c8417fc15f82fb3$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $5c8417fc15f82fb3$export$fe58bcf938607f6a = $5c8417fc15f82fb3$var$g.DOMException;
try {
    new $5c8417fc15f82fb3$export$fe58bcf938607f6a();
} catch (err) {
    $5c8417fc15f82fb3$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $5c8417fc15f82fb3$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $5c8417fc15f82fb3$export$fe58bcf938607f6a.prototype.constructor = $5c8417fc15f82fb3$export$fe58bcf938607f6a;
}
function $5c8417fc15f82fb3$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $5c8417fc15f82fb3$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $5c8417fc15f82fb3$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $5c8417fc15f82fb3$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $5c8417fc15f82fb3$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $5c8417fc15f82fb3$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $5c8417fc15f82fb3$var$g.location.href ? $5c8417fc15f82fb3$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($5c8417fc15f82fb3$var$support.blob) xhr.responseType = 'blob';
            else if ($5c8417fc15f82fb3$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $5c8417fc15f82fb3$export$79b704688b15c0f4 || $5c8417fc15f82fb3$var$g.Headers && init.headers instanceof $5c8417fc15f82fb3$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($5c8417fc15f82fb3$var$normalizeName(name));
                xhr.setRequestHeader(name, $5c8417fc15f82fb3$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$5c8417fc15f82fb3$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$5c8417fc15f82fb3$var$g.fetch) {
    $5c8417fc15f82fb3$var$g.fetch = $5c8417fc15f82fb3$export$e7aa7bc5c1b3cfb3;
    $5c8417fc15f82fb3$var$g.Headers = $5c8417fc15f82fb3$export$79b704688b15c0f4;
    $5c8417fc15f82fb3$var$g.Request = $5c8417fc15f82fb3$export$7fa6c5b6f8193917;
    $5c8417fc15f82fb3$var$g.Response = $5c8417fc15f82fb3$export$9f633d56d7ec90d3;
}

});



parcelRegister("5EHjk", function(module, exports) {
$parcel$export(module.exports, "useMessageEvent", () => $07ca6f64a6dd8e39$export$3cbbf1e81e2ecb39);

var $iJJ9P = parcelRequire("iJJ9P");
var $6a4LK = parcelRequire("6a4LK");

var $6tbGL = parcelRequire("6tbGL");

var $g9gHI = parcelRequire("g9gHI");

var $iCnG4 = parcelRequire("iCnG4");

var $eJOHy = parcelRequire("eJOHy");

var $cZPtR = parcelRequire("cZPtR");

var $lngA3 = parcelRequire("lngA3");

var $8pLUW = parcelRequire("8pLUW");
const $07ca6f64a6dd8e39$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $lngA3.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $iJJ9P.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $6tbGL.useMessageContext)();
    const { placementId: placementId } = (0, $g9gHI.usePlacementContext)();
    const browserContext = (0, $6a4LK.usePostOfficeContext)();
    const recommendationContext = (0, $iCnG4.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $eJOHy.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $8pLUW.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $cZPtR.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $8pLUW.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $cZPtR.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $8pLUW.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $cZPtR.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $8pLUW.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageClicked = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $8pLUW.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $8pLUW.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $8pLUW.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageDismissed = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $8pLUW.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $eJOHy.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cZPtR.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $8pLUW.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};

});
parcelRegister("iJJ9P", function(module, exports) {
$parcel$export(module.exports, "createMessagePlacementValues", () => $ddad37aad10e9ea7$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $ddad37aad10e9ea7$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $ddad37aad10e9ea7$export$89f8e1f623d8f5ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $ddad37aad10e9ea7$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $ddad37aad10e9ea7$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $ddad37aad10e9ea7$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $ddad37aad10e9ea7$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $ddad37aad10e9ea7$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $ddad37aad10e9ea7$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $ddad37aad10e9ea7$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $ddad37aad10e9ea7$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $eJOHy.createContext)($ddad37aad10e9ea7$export$a28a0c048b24fc5a());
const $ddad37aad10e9ea7$export$c7535f8ebc5b75a9 = $ddad37aad10e9ea7$export$ea58328f3ceee4d4.Provider;
const $ddad37aad10e9ea7$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($ddad37aad10e9ea7$export$c7535f8ebc5b75a9, {
            value: $ddad37aad10e9ea7$export$a28a0c048b24fc5a(),
            children: children
        });
const $ddad37aad10e9ea7$export$89f8e1f623d8f5ac = ()=>(0, $eJOHy.useContext)($ddad37aad10e9ea7$export$ea58328f3ceee4d4);

});

parcelRegister("cZPtR", function(module, exports) {
$parcel$export(module.exports, "MessageLifecycleContextError", () => $9d16496a2cbc9158$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $9d16496a2cbc9158$export$44f397e2afeb89e0);
class $9d16496a2cbc9158$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $9d16496a2cbc9158$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("lngA3", function(module, exports) {
$parcel$export(module.exports, "MessageEventClient", () => $52becd125a35db42$export$ae86a6dabe385178);
const $52becd125a35db42$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $52becd125a35db42$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $52becd125a35db42$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("7WsxX"));
class $52becd125a35db42$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $52becd125a35db42$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $52becd125a35db42$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $52becd125a35db42$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($52becd125a35db42$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $52becd125a35db42$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $52becd125a35db42$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});

parcelRegister("8pLUW", function(module, exports) {
$parcel$export(module.exports, "InAppMessageEventType", () => $2a69e5606fdc96db$export$b31ffc6f7c85f1b);
var $2a69e5606fdc96db$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});

});


parcelRegister("6TYxj", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $5066d660cd389c08$export$6215040b989f9b0f, (v) => $5066d660cd389c08$export$6215040b989f9b0f = v);
var $5066d660cd389c08$export$1e511d4a378977f5;
var $5066d660cd389c08$export$6215040b989f9b0f;
var $5066d660cd389c08$export$436b63fa4855237f;
var $5066d660cd389c08$export$2e2bcd8739ae039;
var $5066d660cd389c08$export$95cef81be5ddcfd4;
"use strict";
$5066d660cd389c08$export$1e511d4a378977f5 = true;
$5066d660cd389c08$export$6215040b989f9b0f = $5066d660cd389c08$export$436b63fa4855237f = $5066d660cd389c08$export$2e2bcd8739ae039 = $5066d660cd389c08$export$95cef81be5ddcfd4 = void 0;

var $5066d660cd389c08$var$_handleViewport = $5066d660cd389c08$var$_interopRequireDefault((parcelRequire("fFVXE")));
$5066d660cd389c08$export$436b63fa4855237f = $5066d660cd389c08$var$_handleViewport.default;

var $5066d660cd389c08$var$_useInViewport = $5066d660cd389c08$var$_interopRequireDefault((parcelRequire("wxg9p")));
$5066d660cd389c08$export$6215040b989f9b0f = $5066d660cd389c08$var$_useInViewport.default;
function $5066d660cd389c08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $5066d660cd389c08$var$customProps = $5066d660cd389c08$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $5066d660cd389c08$var$_default = $5066d660cd389c08$export$2e2bcd8739ae039 = $5066d660cd389c08$var$_handleViewport.default;

});
parcelRegister("fFVXE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $b697a5333b073082$export$1e511d4a378977f5, (v) => $b697a5333b073082$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $b697a5333b073082$export$2e2bcd8739ae039, (v) => $b697a5333b073082$export$2e2bcd8739ae039 = v);
var $b697a5333b073082$export$1e511d4a378977f5;
var $b697a5333b073082$export$2e2bcd8739ae039;
"use strict";
$b697a5333b073082$export$1e511d4a378977f5 = true;
$b697a5333b073082$export$2e2bcd8739ae039 = void 0;

var $eJOHy = parcelRequire("eJOHy");

var $b697a5333b073082$var$_hoistNonReactStatics = $b697a5333b073082$var$_interopRequireDefault((parcelRequire("cjwij")));

var $b697a5333b073082$var$_useInViewport = $b697a5333b073082$var$_interopRequireDefault((parcelRequire("wxg9p")));

var $lDsjs = parcelRequire("lDsjs");

var $gt9Am = parcelRequire("gt9Am");
var $b697a5333b073082$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $b697a5333b073082$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $b697a5333b073082$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $b697a5333b073082$var$_extends() {
    return $b697a5333b073082$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b697a5333b073082$var$_extends.apply(null, arguments);
}
function $b697a5333b073082$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $lDsjs.defaultOptions;
    if (config === void 0) config = $lDsjs.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)(TargetComponent, $b697a5333b073082$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $lDsjs.noop, onLeaveViewport: onLeaveViewport = $lDsjs.noop } = _ref, restProps = $b697a5333b073082$var$_objectWithoutPropertiesLoose(_ref, $b697a5333b073082$var$_excluded);
        var node = (0, $eJOHy.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $b697a5333b073082$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $b697a5333b073082$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ForwardedRefComponent, $b697a5333b073082$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $b697a5333b073082$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $b697a5333b073082$var$_default = $b697a5333b073082$export$2e2bcd8739ae039 = $b697a5333b073082$var$handleViewport;

});
parcelRegister("wxg9p", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $061cc9eaade77258$export$1e511d4a378977f5, (v) => $061cc9eaade77258$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $061cc9eaade77258$export$2e2bcd8739ae039, (v) => $061cc9eaade77258$export$2e2bcd8739ae039 = v);
var $061cc9eaade77258$export$1e511d4a378977f5;
var $061cc9eaade77258$export$2e2bcd8739ae039;
"use strict";
$061cc9eaade77258$export$1e511d4a378977f5 = true;
$061cc9eaade77258$export$2e2bcd8739ae039 = void 0;

var $eJOHy = parcelRequire("eJOHy");

var $lDsjs = parcelRequire("lDsjs");
var $061cc9eaade77258$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $061cc9eaade77258$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $lDsjs.defaultOptions;
    if (config === void 0) config = $lDsjs.defaultConfig;
    if (props === void 0) props = $lDsjs.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $eJOHy.useState)();
    var observer = (0, $eJOHy.useRef)();
    var inViewportRef = (0, $eJOHy.useRef)(false);
    var intersected = (0, $eJOHy.useRef)(false);
    var enterCountRef = (0, $eJOHy.useRef)(0);
    var leaveCountRef = (0, $eJOHy.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $eJOHy.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $eJOHy.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $eJOHy.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $061cc9eaade77258$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $061cc9eaade77258$var$_default = $061cc9eaade77258$export$2e2bcd8739ae039 = $061cc9eaade77258$var$useInViewport;

});
parcelRegister("lDsjs", function(module, exports) {
$parcel$export(module.exports, "noop", () => $fc0333d9692336a6$export$8793edee2d425525, (v) => $fc0333d9692336a6$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $fc0333d9692336a6$export$9c21a3269931e1e6, (v) => $fc0333d9692336a6$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $fc0333d9692336a6$export$ba43bf67f3d48107, (v) => $fc0333d9692336a6$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $fc0333d9692336a6$export$f84bd70098573c5c, (v) => $fc0333d9692336a6$export$f84bd70098573c5c = v);
var $fc0333d9692336a6$export$1e511d4a378977f5;
var $fc0333d9692336a6$export$8793edee2d425525;
var $fc0333d9692336a6$export$9c21a3269931e1e6;
var $fc0333d9692336a6$export$ba43bf67f3d48107;
var $fc0333d9692336a6$export$f84bd70098573c5c;
"use strict";
$fc0333d9692336a6$export$1e511d4a378977f5 = true;
$fc0333d9692336a6$export$8793edee2d425525 = $fc0333d9692336a6$export$9c21a3269931e1e6 = $fc0333d9692336a6$export$ba43bf67f3d48107 = $fc0333d9692336a6$export$f84bd70098573c5c = void 0;
var $fc0333d9692336a6$var$defaultOptions = $fc0333d9692336a6$export$ba43bf67f3d48107 = {};
var $fc0333d9692336a6$var$defaultConfig = $fc0333d9692336a6$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $fc0333d9692336a6$var$noop = ()=>{};
$fc0333d9692336a6$export$8793edee2d425525 = $fc0333d9692336a6$var$noop;
var $fc0333d9692336a6$var$defaultProps = $fc0333d9692336a6$export$9c21a3269931e1e6 = {
    onEnterViewport: $fc0333d9692336a6$var$noop,
    onLeaveViewport: $fc0333d9692336a6$var$noop
};

});




parcelRegister("02WN6", function(module, exports) {
$parcel$export(module.exports, "TrackMount", () => $8fe12980eac1831e$export$21b400a8c8ebc91a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $8fe12980eac1831e$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $eJOHy.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});


parcelRegister("eCvse", function(module, exports) {
$parcel$export(module.exports, "createPlacementComponentV2", () => $5f7a758656eab624$export$baf3e7aff0bbcf43);

var $gt9Am = parcelRequire("gt9Am");

var $6a4LK = parcelRequire("6a4LK");
var $lwEYg = parcelRequire("lwEYg");
var $eOlnh = parcelRequire("eOlnh");

var $i3hRF = parcelRequire("i3hRF");
var $dh2Oy = parcelRequire("dh2Oy");

var $3iYHG = parcelRequire("3iYHG");

var $eJOHy = parcelRequire("eJOHy");
const $5f7a758656eab624$export$71ff7382870ef1b0 = 'create-placement-component';
const $5f7a758656eab624$export$66305c2a07eec241 = (placementId, Component, options)=>(0, $3iYHG.withErrorBoundary)(/*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
        const providedContext = (0, $6a4LK.usePostOfficeContext)();
        const { onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const context = props?.context ?? providedContext;
        const route = (0, $lwEYg.usePostOfficeRoute)();
        const stableContext = (0, $eOlnh.useStableObject)(context);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3hRF.PerformanceTrackingSegment), {
            placementId: placementId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3hRF.PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dh2Oy.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: options?.choreographer,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    }));
const $5f7a758656eab624$export$baf3e7aff0bbcf43 = (placementId, Component, options)=>{
    const placement = $5f7a758656eab624$export$66305c2a07eec241(placementId, Component, options);
    return /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
        return placement({
            ...props,
            fallbackRender: ()=>null
        });
    });
};

});
parcelRegister("lwEYg", function(module, exports) {
$parcel$export(module.exports, "PostOfficeRouteContext", () => $a74afd715372c76c$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $a74afd715372c76c$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $a74afd715372c76c$export$79301b66f7808cd8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g5PZJ = parcelRequire("g5PZJ");

var $eOlnh = parcelRequire("eOlnh");
const $a74afd715372c76c$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $a74afd715372c76c$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $a74afd715372c76c$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $g5PZJ.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $eOlnh.useStableObject)(route);
};
const $a74afd715372c76c$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $a74afd715372c76c$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$a74afd715372c76c$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $a74afd715372c76c$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $eJOHy.createContext)($a74afd715372c76c$var$initialState);
const $a74afd715372c76c$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $eJOHy.useRef)();
    if (!ref.current) ref.current = $a74afd715372c76c$export$98c77e1bd702ed15(props);
    const route = $a74afd715372c76c$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($a74afd715372c76c$export$f7f47a74e8b47b1f.Provider, {
        value: route,
        children: children
    });
};
const $a74afd715372c76c$export$79301b66f7808cd8 = ()=>(0, $eJOHy.useContext)($a74afd715372c76c$export$f7f47a74e8b47b1f); //Route listener

});

parcelRegister("i3hRF", function(module, exports) {
$parcel$export(module.exports, "PerformanceTracking", () => $8ab2507179864548$export$9a335a42ce02bdb8);
$parcel$export(module.exports, "PerformanceTrackingSegment", () => $8ab2507179864548$export$b35129264a401b3c);

var $gt9Am = parcelRequire("gt9Am");

var $59rsN = parcelRequire("59rsN");

var $bb3PU = parcelRequire("bb3PU");

var $eJOHy = parcelRequire("eJOHy");

var $02WN6 = parcelRequire("02WN6");

var $SOoGF = parcelRequire("SOoGF");
const $8ab2507179864548$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $59rsN.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $SOoGF.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bb3PU.UFOv2).UFOLoadHold, {
                name: (0, $bb3PU.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $02WN6.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $8ab2507179864548$export$b35129264a401b3c = /*#__PURE__*/ (0, $eJOHy.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $59rsN.default).checkGate('post_office_update_ufov2_placements');
    /**
		 * If feature gate is not enabled, then we just return the children without the
		 * UFO segments attached.
		 */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bb3PU.UFOv2).UFOSegment, {
        name: (0, $bb3PU.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bb3PU.UFOv2).UFOSegment, {
            name: `${(0, $bb3PU.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});

});
parcelRegister("SOoGF", function(module, exports) {
$parcel$export(module.exports, "usePerformanceTracking", () => $522534a139ba5efd$export$317d52099614f316);

var $eJOHy = parcelRequire("eJOHy");
const $522534a139ba5efd$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    const onMount = (0, $eJOHy.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $eJOHy.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("dh2Oy", function(module, exports) {
$parcel$export(module.exports, "StableProviders", () => $d59294897180a3d4$export$2b6596bcb1383a71);

var $gt9Am = parcelRequire("gt9Am");

var $f2xvu = parcelRequire("f2xvu");

var $8dSfG = parcelRequire("8dSfG");

var $62EJZ = parcelRequire("62EJZ");

var $8KH0U = parcelRequire("8KH0U");

var $h2X1K = parcelRequire("h2X1K");

var $04n0H = parcelRequire("04n0H");

var $i3hRF = parcelRequire("i3hRF");
const $d59294897180a3d4$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8KH0U.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h2X1K.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04n0H.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8dSfG.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $62EJZ.StableChoreographerProvider), {
                        choreographer: choreographer,
                        placementId: placement.placementId,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f2xvu.RenderTrackerProvider), {
                            placementId: placement.placementId,
                            children: children
                        })
                    })
                })
            })
        })
    });

});
parcelRegister("f2xvu", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerProvider", () => $0c6200f6ede9019b$export$2d84fd9af6c9e378);

var $gt9Am = parcelRequire("gt9Am");

var $gr4vM = parcelRequire("gr4vM");

var $eJOHy = parcelRequire("eJOHy");
/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $0c6200f6ede9019b$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $0c6200f6ede9019b$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if ($0c6200f6ede9019b$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement'
        });
    }, [
        fireAnalyticsEvent,
        placementId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});

parcelRegister("8dSfG", function(module, exports) {
$parcel$export(module.exports, "StableAnaltyicsProvider", () => $3d43184b1f83ea22$export$5a66cdc9893b43e);

var $gt9Am = parcelRequire("gt9Am");

var $eUaD0 = parcelRequire("eUaD0");
const $3d43184b1f83ea22$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: undefined,
            b: undefined,
            t: undefined
        }
    }
};
const $3d43184b1f83ea22$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.PostOfficeAnalyticsContext), {
        data: $3d43184b1f83ea22$var$postOfficeAnalyticsContextData,
        children: children
    });
};

});

parcelRegister("8KH0U", function(module, exports) {
$parcel$export(module.exports, "StableContextProvider", () => $e92e248a45bf6aad$export$d4982c0a28b18f63);

var $gt9Am = parcelRequire("gt9Am");

var $6a4LK = parcelRequire("6a4LK");
var $eOlnh = parcelRequire("eOlnh");

var $hceBc = parcelRequire("hceBc");
const $e92e248a45bf6aad$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $eOlnh.useStableObject)({
        ...(0, $hceBc.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6a4LK.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};

});
parcelRegister("hceBc", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $670f32ce57f83166$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $670f32ce57f83166$export$71ff7382870ef1b0);
const $670f32ce57f83166$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $670f32ce57f83166$export$71ff7382870ef1b0 = 'create-placement-component';

});


parcelRegister("h2X1K", function(module, exports) {
$parcel$export(module.exports, "StablePlacementProvider", () => $4cfad1752403cefa$export$e9fd288527498af6);

var $gt9Am = parcelRequire("gt9Am");

var $eOlnh = parcelRequire("eOlnh");

var $g9gHI = parcelRequire("g9gHI");
const $4cfad1752403cefa$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $eOlnh.useStableObject)(placement);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g9gHI.PlacementProvider), {
        value: stableValue,
        children: children
    });
};

});

parcelRegister("04n0H", function(module, exports) {
$parcel$export(module.exports, "StableRouteProvider", () => $13492dee5b5a0525$export$ce13d00e696dfc96);

var $gt9Am = parcelRequire("gt9Am");

var $lwEYg = parcelRequire("lwEYg");
var $eOlnh = parcelRequire("eOlnh");

var $2nRXT = parcelRequire("2nRXT");
const $13492dee5b5a0525$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $2nRXT.useLocationHref)();
    const stableRoute = (0, $eOlnh.useStableObject)(route ?? {
        previous: href,
        current: href
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lwEYg.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};

});
parcelRegister("2nRXT", function(module, exports) {
$parcel$export(module.exports, "useLocationHref", () => $cab160c1fb74c7d8$export$49fc3f3d8c7f99);
const $cab160c1fb74c7d8$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $cab160c1fb74c7d8$export$49fc3f3d8c7f99 = ()=>{
    return $cab160c1fb74c7d8$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("3iYHG", function(module, exports) {
$parcel$export(module.exports, "withErrorBoundary", () => $bbad277f282c8ad4$export$f0c7a449e0cfaec7);

var $gt9Am = parcelRequire("gt9Am");


var $gr4vM = parcelRequire("gr4vM");

var $asf5r = parcelRequire("asf5r");
const $bbad277f282c8ad4$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $gt9Am.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $asf5r.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation
            }, onError),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...data
            })
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

parcelRegister("asf5r", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $79c838d4b5ddaa9a$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
'use client';
const $79c838d4b5ddaa9a$export$b16d9fb1a22de840 = (0, $eJOHy.createContext)(null);
const $79c838d4b5ddaa9a$var$initialState = {
    didCatch: false,
    error: null
};
class $79c838d4b5ddaa9a$export$e926676385687eaf extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $79c838d4b5ddaa9a$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($79c838d4b5ddaa9a$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $79c838d4b5ddaa9a$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($79c838d4b5ddaa9a$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $eJOHy.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $eJOHy.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $eJOHy.createElement)($79c838d4b5ddaa9a$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $79c838d4b5ddaa9a$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $79c838d4b5ddaa9a$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $79c838d4b5ddaa9a$export$c052f6604b7d51fe() {
    const context = (0, $eJOHy.useContext)($79c838d4b5ddaa9a$export$b16d9fb1a22de840);
    $79c838d4b5ddaa9a$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $eJOHy.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $eJOHy.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $79c838d4b5ddaa9a$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $eJOHy.forwardRef)((props, ref)=>(0, $eJOHy.createElement)($79c838d4b5ddaa9a$export$e926676385687eaf, errorBoundaryProps, (0, $eJOHy.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});



parcelRegister("2KasD", function(module, exports) {
$parcel$export(module.exports, "defaultPlacementMiddleware", () => $ca637e366dce2a4b$export$c4652643d257c65);

var $i8g8m = parcelRequire("i8g8m");
const $ca637e366dce2a4b$export$a815601a0de834af = (execute)=>(params)=>async ({ request: request, koa: koa, postOffice: postOffice, placement: placement })=>{
            try {
                const result = await execute({
                    request: request,
                    koa: koa,
                    postOffice: postOffice,
                    placement: placement,
                    params: params
                });
                koa.ctx.body = result;
                koa.ctx.status = 200;
            } catch (error) {
                request.logger.error({
                    error: error
                }, 'placement middleware error');
                koa.ctx.status = 500;
                koa.ctx.body = {
                    message: 'An error occurred'
                };
            }
        };
const $ca637e366dce2a4b$export$c4652643d257c65 = $ca637e366dce2a4b$export$a815601a0de834af(async ({ postOffice: postOffice })=>{
    const result = await postOffice.messagesRuntime();
    $ca637e366dce2a4b$export$af2103662bc91e89(result);
    return {
        ...result.data,
        messages: (0, $i8g8m.flattenMessagesForFrontend)(result.data.messages)
    };
});
const $ca637e366dce2a4b$export$af2103662bc91e89 = ({ errors: errors, data: data })=>{
    const { messages: messages } = data;
    if (!(messages.length > 1)) return;
    const uniqueErrorIds = new Set(errors.map((e)=>e?.messageTemplateId ?? 'unknown'));
    const uniqueMessageIds = new Set(messages.map((e)=>e.messageTemplateId));
    if (uniqueErrorIds.size > 1 && uniqueMessageIds.size / uniqueMessageIds.size > 0.1) // Better error required
    throw new Error('too many message template errors');
};

});
parcelRegister("i8g8m", function(module, exports) {
$parcel$export(module.exports, "flattenMessagesForFrontend", () => $d6fd800fa4e45a01$export$e578dffc38a1382b);
const $d6fd800fa4e45a01$export$45bce7b2197b989e = ({ context: context, ...message })=>({
        ...message,
        ...context
    });
const $d6fd800fa4e45a01$export$e578dffc38a1382b = (messages)=>messages.map($d6fd800fa4e45a01$export$45bce7b2197b989e);

});


parcelRegister("fAwAG", function(module, exports) {
$parcel$export(module.exports, "PlacementSystemError", () => $67c7d728589b0a93$export$3d5f437b74b20d52);
$parcel$export(module.exports, "PlacementMessageError", () => $67c7d728589b0a93$export$8a38dc1cb159944a);
$parcel$export(module.exports, "createPlacementMessageError", () => $67c7d728589b0a93$export$ee31fecb3809975f);
$parcel$export(module.exports, "handlePlacementMessageError", () => $67c7d728589b0a93$export$6536fa2f9f327746);
$parcel$export(module.exports, "handlePlacementError", () => $67c7d728589b0a93$export$fac04fc2e7d95393);
$parcel$export(module.exports, "handlePlacementRuntimeError", () => $67c7d728589b0a93$export$146aabc04248e280);
$parcel$export(module.exports, "handlePlacementMiddlewareError", () => $67c7d728589b0a93$export$e644214358a6da92);

var $bPZKj = parcelRequire("bPZKj");
class $67c7d728589b0a93$export$3d5f437b74b20d52 extends (0, $bPZKj.PostOfficeError) {
    constructor(params){
        const message = params.message ?? params.error?.message ?? 'unknown placement system error';
        const code = params.code ?? (0, $bPZKj.PostOfficeErrorCodes).PlacementSystemError;
        super(message, code);
        this.name = params.error?.name ?? this.constructor.name;
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
}
class $67c7d728589b0a93$export$8a38dc1cb159944a extends $67c7d728589b0a93$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement message error',
            code: (0, $bPZKj.PostOfficeErrorCodes).PlacementMessageError
        });
    }
}
class $67c7d728589b0a93$export$321382f6614c450c extends $67c7d728589b0a93$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement error',
            code: (0, $bPZKj.PostOfficeErrorCodes).PlacementError
        });
    }
}
class $67c7d728589b0a93$export$c8e5ef21fa31d723 extends $67c7d728589b0a93$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement runtime error',
            code: (0, $bPZKj.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
}
class $67c7d728589b0a93$export$20e3e1204742e375 extends $67c7d728589b0a93$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement middleware error',
            code: (0, $bPZKj.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
}
const $67c7d728589b0a93$export$33fc68e75ae0d686 = (errorType)=>(error)=>{
        if (error instanceof errorType) return new errorType({
            ...error,
            error: error
        });
        if (error instanceof Error) return new errorType({
            error: error
        });
        return new errorType({});
    };
const $67c7d728589b0a93$export$ee31fecb3809975f = $67c7d728589b0a93$export$33fc68e75ae0d686($67c7d728589b0a93$export$3d5f437b74b20d52);
const $67c7d728589b0a93$export$6536fa2f9f327746 = (request)=>(error)=>$67c7d728589b0a93$export$795c072ee2f403d0(request)($67c7d728589b0a93$export$ee31fecb3809975f(error));
const $67c7d728589b0a93$export$72b956efef19a76d = $67c7d728589b0a93$export$33fc68e75ae0d686($67c7d728589b0a93$export$3d5f437b74b20d52);
const $67c7d728589b0a93$export$fac04fc2e7d95393 = (request)=>(error)=>$67c7d728589b0a93$export$795c072ee2f403d0(request)($67c7d728589b0a93$export$72b956efef19a76d(error));
const $67c7d728589b0a93$export$8fe51a926669e297 = $67c7d728589b0a93$export$33fc68e75ae0d686($67c7d728589b0a93$export$3d5f437b74b20d52);
const $67c7d728589b0a93$export$76f72ccfbe960ca1 = (request)=>(error)=>$67c7d728589b0a93$export$795c072ee2f403d0(request)($67c7d728589b0a93$export$8fe51a926669e297(error));
const $67c7d728589b0a93$export$149a31b9f5a4a9c2 = $67c7d728589b0a93$export$33fc68e75ae0d686($67c7d728589b0a93$export$c8e5ef21fa31d723);
const $67c7d728589b0a93$export$146aabc04248e280 = (request)=>(error)=>$67c7d728589b0a93$export$795c072ee2f403d0(request)($67c7d728589b0a93$export$149a31b9f5a4a9c2(error));
const $67c7d728589b0a93$export$572d500120860974 = $67c7d728589b0a93$export$33fc68e75ae0d686($67c7d728589b0a93$export$20e3e1204742e375);
const $67c7d728589b0a93$export$e644214358a6da92 = (request)=>(error)=>$67c7d728589b0a93$export$795c072ee2f403d0(request)($67c7d728589b0a93$export$572d500120860974(error));
const $67c7d728589b0a93$export$795c072ee2f403d0 = (request)=>(error)=>{
        request.logger.error({
            message: error.message,
            cause: error.cause,
            name: error.name,
            stack: error.stack,
            placementLevel: error.placementLevel
        });
        return error;
    };

});
parcelRegister("bPZKj", function(module, exports) {
$parcel$export(module.exports, "PostOfficeErrorCodes", () => $f39f3186e505ba8c$export$b9722560029694e7);
$parcel$export(module.exports, "PostOfficeError", () => $f39f3186e505ba8c$export$d145ea5319863172);
$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $f39f3186e505ba8c$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $f39f3186e505ba8c$export$3dfc27a8d3942f4d);
var $f39f3186e505ba8c$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $f39f3186e505ba8c$export$46f86d28cd0a5d38 extends Error {
}
class $f39f3186e505ba8c$export$627bc00a5ef5f6ae extends Error {
}
class $f39f3186e505ba8c$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $f39f3186e505ba8c$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $f39f3186e505ba8c$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $f39f3186e505ba8c$export$ed601cd0dc1a1be7 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(args){
        /**
		 * It is expected that this error message can be not deterministic.
		 * This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		 * Showing the error cause helps them understand what was the problem with their payload.
		 *
		 * On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		 * to distinguish between message makers code errors and platform errors,
		 * but we don't rely on the error message itself.
		 */ const errMessage = args.cause instanceof Error ? args.cause.message : 'Error in message template code';
        super(errMessage, "MessageTemplateError", args.cause);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$2833d4759f81601b extends $f39f3186e505ba8c$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = 'Invalid CSS property could not be processed by Juice';
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$8d39b103586e9fd4 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$f649da38897d27f7 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$c2852c1c4d9aba3e extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$4b7b4e09547e4bb3 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$360a094a97597d87 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$4d068b43eb55165b extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$ac007ee150add337 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$19cb89dd679394cb extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$78651662ad470cc5 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$8a5041670cdd8db2 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Journey not found', "JourneyNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$1240ddc25cf964e6 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$3c4884b7ae7fe517 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$913b8e68dc7ae8fe extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$3dfc27a8d3942f4d extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$e5ccdf8bbfead7a2 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$823733742d803ae6 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$1caa32527f23acd2 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$a6f2aad8fa094b39 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$2f1e27130c2bf271 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$d0dc094613469f2b extends $f39f3186e505ba8c$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$5603eab37ce562f5 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$e0e9aa0e9c6b37ff extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$3ad818f64601e141 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$25470bb6cba4fba0 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$ce14d445679448b6 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $f39f3186e505ba8c$export$c9a26a17db1045c8 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$8ab4fb362168b928 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$2afd69f57fe5285f extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$7635d2b1a281d626 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$9e1c6d00e675bc86 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$6d1a4929f6ff1a32 extends $f39f3186e505ba8c$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $f39f3186e505ba8c$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
const $f39f3186e505ba8c$export$5c9840cf9181ada = 'post-office_enable_ca-ignore-upstream-errors';
const $f39f3186e505ba8c$export$a1f2446abf1cd73 = '1';
class $f39f3186e505ba8c$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.message = message, this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $f39f3186e505ba8c$export$c504492f06c975b5 extends $f39f3186e505ba8c$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$1c932b9d1680ee0b extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$5d5d1885c87ef4bc extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f39f3186e505ba8c$export$f177e7d3a356e715 extends $f39f3186e505ba8c$export$5d5d1885c87ef4bc {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}

});


parcelRegister("b80Pk", function(module, exports) {
$parcel$export(module.exports, "messageTimedStage", () => $6f55ae9cedce7fa0$export$ef814b969fe01b12);
$parcel$export(module.exports, "placementTimedStage", () => $6f55ae9cedce7fa0$export$d1ae1adf079f8144);
$parcel$export(module.exports, "placementRuntimeTimedStage", () => $6f55ae9cedce7fa0$export$1119d982b61d8814);
$parcel$export(module.exports, "logRuntimeResult", () => $6f55ae9cedce7fa0$export$79586cc267015801);
const $6f55ae9cedce7fa0$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS = [
    25,
    50,
    100,
    150,
    200,
    250,
    500,
    1000
];
const $6f55ae9cedce7fa0$var$timerName = 'post-office.placement-v2.stage.execute';
const $6f55ae9cedce7fa0$var$counterName = 'post-office.placement-v2.stage.result';
const $6f55ae9cedce7fa0$var$createTimedStage = (tag)=>(stage)=>async (params)=>{
            params.request.logger.info('Started stage');
            const startTime = performance.now();
            const { stop: stop } = params.request.metrics.histogram($6f55ae9cedce7fa0$var$timerName, $6f55ae9cedce7fa0$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS).measure();
            const result = stage(params);
            let tags;
            try {
                const unwrappedResult = result instanceof Promise ? await result : result;
                try {
                    tags = tag?.({
                        input: params,
                        output: unwrappedResult
                    });
                } catch  {
                    params.request.logger.warn('Unable to apply tags to stage logs');
                }
                params.request.metrics.counter($6f55ae9cedce7fa0$var$counterName, {
                    status: 'success'
                }).incr();
                return unwrappedResult;
            } catch (error) {
                params.request.metrics.counter($6f55ae9cedce7fa0$var$counterName, {
                    status: 'error'
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                // eslint-disable-next-line @atlassian/incredible/safe-logging-practices
                params.request.logger.info({
                    latencyInMs: latencyInMs,
                    ...tags
                }, 'Finished stage');
            }
        };
const $6f55ae9cedce7fa0$var$createTimedSystemStage = (fn)=>(contexts)=>{
        return async (params)=>{
            contexts.request.logger.info('Started stage');
            const startTime = performance.now();
            const { stop: stop } = contexts.request.metrics.histogram($6f55ae9cedce7fa0$var$timerName, $6f55ae9cedce7fa0$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS).measure();
            const result = fn(contexts)(params);
            try {
                const unwrappedResult = await result;
                contexts.request.metrics.counter($6f55ae9cedce7fa0$var$counterName, {
                    status: 'success'
                }).incr();
                return unwrappedResult;
            } catch (error) {
                contexts.request.metrics.counter($6f55ae9cedce7fa0$var$counterName, {
                    status: 'error'
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                // eslint-disable-next-line @atlassian/incredible/safe-logging-practices
                contexts.request.logger.info({
                    latencyInMs: latencyInMs
                }, 'Finished stage');
            }
        };
    };
const $6f55ae9cedce7fa0$export$ef814b969fe01b12 = $6f55ae9cedce7fa0$var$createTimedStage();
const $6f55ae9cedce7fa0$export$d1ae1adf079f8144 = $6f55ae9cedce7fa0$var$createTimedStage(({ input: input, output: output })=>{
    if (!output) return {};
    const inputMessageTemplateIds = Array.from(new Set(input.data.messages.map((message)=>message.messageTemplateId)).values());
    const outputMessageTemplateIds = Array.from(new Set(output.messages.map((message)=>message.messageTemplateId)).values());
    const deltaMessageTemplateIds = inputMessageTemplateIds.filter((id)=>!outputMessageTemplateIds.includes(id));
    const inputMessageInstanceIds = input.data.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId);
    const outputMessageInstanceIds = output.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId);
    const deltaMessageInstanceIds = inputMessageInstanceIds.filter((id)=>!outputMessageInstanceIds.includes(id));
    return {
        input: {
            number: input.data.messages.length,
            messageTemplateIds: inputMessageTemplateIds,
            messageInstanceIds: inputMessageInstanceIds
        },
        output: {
            number: output.messages.length,
            messageTemplateIds: outputMessageTemplateIds,
            messageInstanceIds: outputMessageInstanceIds
        },
        delta: {
            number: output.messages.length - input.data.messages.length,
            messageTemplateIds: deltaMessageTemplateIds,
            messageInstanceIds: deltaMessageInstanceIds
        }
    };
});
const $6f55ae9cedce7fa0$export$1119d982b61d8814 = $6f55ae9cedce7fa0$var$createTimedSystemStage;
const $6f55ae9cedce7fa0$export$79586cc267015801 = ({ request: request })=>(result)=>{
        const errorMessageTemplateIds = Array.from(new Set(result.errors.map((e)=>e.messageTemplateId)).values());
        const messageTemplateIds = Array.from(new Set(result.data.messages.map((e)=>e.messageTemplateId)).values());
        const formattedMessages = result.data.messages.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCreationType: messageCreationType, messageCategory: messageCategory, triggerId: triggerId })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCreationType: messageCreationType,
                messageCategory: messageCategory,
                triggerId: triggerId
            }));
        const formattedErrorDetails = result.errors.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, reason: reason })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                reason: reason
            }));
        request.logger.info({
            errors: {
                number: result.errors.length,
                messageTemplateIds: errorMessageTemplateIds,
                messageDetails: formattedErrorDetails
            },
            messages: {
                number: result.data.messages.length,
                messageTemplateIds: messageTemplateIds,
                messageDetails: formattedMessages
            }
        }, 'Runtime result');
    };

});

parcelRegister("aPucE", function(module, exports) {
$parcel$export(module.exports, "defaultBackendPlacementStages", () => $7750f792e34f8bde$export$fc43c4563ceea5ce);

var $i9VoI = parcelRequire("i9VoI");

var $dfR9y = parcelRequire("dfR9y");
const $7750f792e34f8bde$export$fc43c4563ceea5ce = ({ transformMetadata: transformMetadata, hydrate: hydrate })=>({
        init: (0, $dfR9y.applyTransformMetadata)(transformMetadata),
        postInit: (0, $i9VoI.applyHydrate)(hydrate)
    });

});
parcelRegister("i9VoI", function(module, exports) {
$parcel$export(module.exports, "applyHydrate", () => $58513779c859611e$export$a505170ba4b7665a);

var $hVLGa = parcelRequire("hVLGa");
const $58513779c859611e$export$a505170ba4b7665a = (hydrate)=>(0, $hVLGa.Stages).maybe(hydrate);

});
parcelRegister("hVLGa", function(module, exports) {
$parcel$export(module.exports, "Stages", () => $32eeed9596c2c45e$export$908c35f258f55229);
const $32eeed9596c2c45e$var$maybe = (stage)=>async (params)=>{
        return stage?.(params) ?? params.data;
    };
const $32eeed9596c2c45e$var$mergeMetadata = (fn)=>{
    const applyMerge = (target, source)=>{
        {
            const sourceMap = Object.fromEntries(source.messages.map((message)=>[
                    message.messageInstanceId,
                    message
                ]));
            const messages = target.data.messages.map((message)=>fn(message, sourceMap?.[message.messageInstanceId]?.context));
            return {
                messages: messages
            };
        }
    };
    return applyMerge;
};
const $32eeed9596c2c45e$export$908c35f258f55229 = {
    maybe: /**
	 * The `maybe` function creates a passthrough stage,
	 * which applies no changes, for cases where a stage might be undefined.
	 */ $32eeed9596c2c45e$var$maybe,
    mergeMetadata: /**
	 * the `mergeMetadata` function is used when the result of a stage is
	 * used to modify the message payload outside the message context
	 */ $32eeed9596c2c45e$var$mergeMetadata
};

});


parcelRegister("dfR9y", function(module, exports) {
$parcel$export(module.exports, "applyTransformMetadata", () => $c8d5c413dd821a88$export$e43f344828ec0e3);

var $hVLGa = parcelRequire("hVLGa");
const $c8d5c413dd821a88$export$e43f344828ec0e3 = (transformMetadata)=>async (params)=>{
        const transformedMetadata = await (0, $hVLGa.Stages).maybe(transformMetadata)(params);
        const placementId = params?.request?.orchestrationContext?.placementId ?? 'no-placement-found';
        return (0, $hVLGa.Stages).mergeMetadata((original, metadata)=>({
                ...original,
                enrichedAttributes: {
                    'in-app': {
                        [placementId]: metadata
                    }
                }
            }))(params, transformedMetadata);
    };

});


parcelRegister("30pkt", function(module, exports) {
$parcel$export(module.exports, "defaultBackendPlacementMessageStages", () => $0caf1e3fbcc74c90$export$1c5532bd04c77e4b);
const $0caf1e3fbcc74c90$export$1c5532bd04c77e4b = {
};

});


parcelRegister("c7FOL", function(module, exports) {
$parcel$export(module.exports, "placementMiddlewareWithCacheControlNav", () => $cda816e76fe2e350$export$5379d5ee2ecb6877);
$parcel$export(module.exports, "placementMiddlewareWithCacheControlInteraction", () => $cda816e76fe2e350$export$c499d39834887909);

var $2KasD = parcelRequire("2KasD");
const $cda816e76fe2e350$export$cf9a3fbf9c3c14ce = (headers)=>(config)=>async (opts)=>{
            const isCustomHeadersEnabled = opts.request.orchestrationContext.recipient?.userId && opts.request.statsig.checkGate({
                identifiers: {
                    atlassianAccountId: opts.request.orchestrationContext.recipient.userId
                }
            }, 'post-office-custom-headers-v2');
            const isPostOfficeSynthetic = opts.request.orchestrationContext.recipient?.userId && opts.request.statsig.checkGate({
                identifiers: {
                    atlassianAccountId: opts.request.orchestrationContext.recipient.userId
                }
            }, 'post-office-is-post-office-synthetic');
            if (isCustomHeadersEnabled && !isPostOfficeSynthetic) opts.koa.ctx.set(headers);
            return (0, $2KasD.defaultPlacementMiddleware)(config)(opts);
        };
const $cda816e76fe2e350$export$80d235e32c5248a6 = 'private, max-age=300, stale-while-revalidate=600, stale-if-error=900';
const $cda816e76fe2e350$export$dc0291b7f6e541b = 'private, max-age=120, stale-while-revalidate=300, stale-if-error=900';
const $cda816e76fe2e350$export$c81528d4fcbfbe9f = 'private, max-age=600, stale-while-revalidate=900, stale-if-error=900';
const $cda816e76fe2e350$export$49b0f46a7b9264ff = $cda816e76fe2e350$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $cda816e76fe2e350$export$80d235e32c5248a6
});
const $cda816e76fe2e350$export$f90e17deb35ce39f = $cda816e76fe2e350$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $cda816e76fe2e350$export$80d235e32c5248a6
});
const $cda816e76fe2e350$export$86309966c8dcb8f0 = $cda816e76fe2e350$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $cda816e76fe2e350$export$80d235e32c5248a6
});
const $cda816e76fe2e350$export$d70cd3c2d3a8b23f = $cda816e76fe2e350$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $cda816e76fe2e350$export$dc0291b7f6e541b
});
const $cda816e76fe2e350$export$5379d5ee2ecb6877 = $cda816e76fe2e350$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $cda816e76fe2e350$export$dc0291b7f6e541b
});
const $cda816e76fe2e350$export$c499d39834887909 = $cda816e76fe2e350$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $cda816e76fe2e350$export$c81528d4fcbfbe9f
});

});

parcelRegister("fuwhX", function(module, exports) {
$parcel$export(module.exports, "usePlacementApi", () => $6d988d201c6ab3f5$export$201bbce8187a6e3c);

var $59rsN = parcelRequire("59rsN");

var $6a4LK = parcelRequire("6a4LK");

var $kokXW = parcelRequire("kokXW");

var $g9gHI = parcelRequire("g9gHI");

var $1z1Oa = parcelRequire("1z1Oa");

var $fmgRN = parcelRequire("fmgRN");

var $eJOHy = parcelRequire("eJOHy");
const $6d988d201c6ab3f5$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $g9gHI.usePlacementContext)();
    const context = (0, $6a4LK.usePostOfficeContext)();
    const fetcher = (0, $kokXW.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        if ((0, $59rsN.default).checkGate('post-office-use-placement-with-client')) return (0, $fmgRN.createUsePlacementWithClient)(placementId, fetcher);
        return (0, $1z1Oa.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...context,
        ...queryParams
    };
    const apiDependencies = (0, $eJOHy.useMemo)(()=>{
        return [
            config?.autoRefetch?.updateKey
        ];
    }, [
        config?.autoRefetch?.updateKey
    ]);
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: apiDependencies
    });
};

});
parcelRegister("kokXW", function(module, exports) {
$parcel$export(module.exports, "usePlacementFetchingContext", () => $1049d66f7e7c6bb2$export$e1e2cdb0425a9fa8);
$parcel$export(module.exports, "PlacementFetchingProvider", () => $1049d66f7e7c6bb2$export$5f25a6ddf0324fa8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $1049d66f7e7c6bb2$export$afec669dc416ee7e = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $1049d66f7e7c6bb2$export$e1e2cdb0425a9fa8 = ()=>(0, $eJOHy.useContext)($1049d66f7e7c6bb2$export$afec669dc416ee7e);
const $1049d66f7e7c6bb2$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($1049d66f7e7c6bb2$export$afec669dc416ee7e.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("1z1Oa", function(module, exports) {
$parcel$export(module.exports, "createUsePlacement", () => $79b325154aa81ead$export$ee1d67e435d25cb5);

var $8M8On = parcelRequire("8M8On");

var $eJOHy = parcelRequire("eJOHy");

var $gPaSs = parcelRequire("gPaSs");
const $79b325154aa81ead$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $eJOHy.useRef)();
        const isRunningPromise = (0, $eJOHy.useRef)(false);
        (0, $eJOHy.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $eJOHy.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $gPaSs.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $8M8On.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            config?.deps,
            path
        ]);
        return (0, $gPaSs.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};

});
parcelRegister("8M8On", function(module, exports) {
$parcel$export(module.exports, "fetchPlacementData", () => $f1718a5be3ad565a$export$ce743d02f83ee521);
const $f1718a5be3ad565a$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $f1718a5be3ad565a$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $f1718a5be3ad565a$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$f1718a5be3ad565a$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $f1718a5be3ad565a$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($f1718a5be3ad565a$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$f1718a5be3ad565a$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};

});

parcelRegister("gPaSs", function(module, exports) {
$parcel$export(module.exports, "AlreadyRunningError", () => $435fc625d0ece659$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $435fc625d0ece659$export$c1cf1cf4c5d51937);

var $gr4vM = parcelRequire("gr4vM");

var $7mF43 = parcelRequire("7mF43");

var $eJOHy = parcelRequire("eJOHy");

var $5c6BU = parcelRequire("5c6BU");
class $435fc625d0ece659$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $435fc625d0ece659$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $eJOHy.useState)((0, $5c6BU.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $eJOHy.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $5c6BU.assertResponseIsOk)(res)) {
                const data = await res.json();
                setState((0, $5c6BU.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $435fc625d0ece659$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $5c6BU.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("5c6BU", function(module, exports) {
$parcel$export(module.exports, "assertResponseIsOk", () => $850d1e78e41eadaf$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $850d1e78e41eadaf$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $850d1e78e41eadaf$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $850d1e78e41eadaf$export$24a6b176bdc41ce5);
const $850d1e78e41eadaf$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $850d1e78e41eadaf$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($850d1e78e41eadaf$export$18a0019e5439b209(res));
};
const $850d1e78e41eadaf$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $850d1e78e41eadaf$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $850d1e78e41eadaf$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("fmgRN", function(module, exports) {
$parcel$export(module.exports, "createUsePlacementWithClient", () => $ecd3291615030443$export$7a2a7b6f48ac7d1);

var $iaSfF = parcelRequire("iaSfF");

var $gr4vM = parcelRequire("gr4vM");

var $7mF43 = parcelRequire("7mF43");
const $ecd3291615030443$export$7a2a7b6f48ac7d1 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
        const analyticsSubjectId = placementId;
        const analyticsAttributes = {
            path: path
        };
        const { data: data, error: error } = (0, $iaSfF.useFetchPlacementData)(config?.isEnabled === false ? null : placementId, path, context, fetcher, requestOptions, {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            onSuccess: ()=>{
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            },
            onError: (error)=>{
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: error?.name ?? 'unknown',
                        errorMessage: error?.message ?? 'unknown'
                    }
                });
            }
        });
        if (data) return {
            isLoading: false,
            error: undefined,
            data: data
        };
        if (error) return {
            isLoading: false,
            error: error,
            data: undefined
        };
        return {
            isLoading: true,
            error: undefined,
            data: undefined
        };
    };
};

});
parcelRegister("iaSfF", function(module, exports) {
$parcel$export(module.exports, "useFetchPlacementData", () => $13795d8a5d5fb159$export$ef70136078f15deb);

var $e7Wsy = parcelRequire("e7Wsy");
const $13795d8a5d5fb159$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $13795d8a5d5fb159$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $13795d8a5d5fb159$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$13795d8a5d5fb159$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $13795d8a5d5fb159$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $13795d8a5d5fb159$export$ef70136078f15deb = (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($13795d8a5d5fb159$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$13795d8a5d5fb159$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $e7Wsy.default)(placementId ? url : null, (url)=>fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...$13795d8a5d5fb159$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};

});
parcelRegister("e7Wsy", function(module, exports) {
$parcel$export(module.exports, "SWRConfig", () => $a48f10f61e07960b$export$4c7bbecdacc3ca2c);
$parcel$export(module.exports, "default", () => $a48f10f61e07960b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g5PZJ = parcelRequire("g5PZJ");

var $lCRzQ = parcelRequire("lCRzQ");parcelRequire("5dwQF");
var $lCRzQ = parcelRequire("lCRzQ");
var $5dwQF = parcelRequire("5dwQF");
var $4Lrb4 = parcelRequire("4Lrb4");
// Shared state between server components and client components
const $a48f10f61e07960b$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $a48f10f61e07960b$var$UNDEFINED = /*#__NOINLINE__*/ $a48f10f61e07960b$var$noop();
const $a48f10f61e07960b$var$OBJECT = Object;
const $a48f10f61e07960b$var$isUndefined = (v)=>v === $a48f10f61e07960b$var$UNDEFINED;
const $a48f10f61e07960b$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $a48f10f61e07960b$var$table = new WeakMap();
const $a48f10f61e07960b$var$getTypeName = (value)=>$a48f10f61e07960b$var$OBJECT.prototype.toString.call(value);
const $a48f10f61e07960b$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $a48f10f61e07960b$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $a48f10f61e07960b$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $a48f10f61e07960b$var$getTypeName(arg);
    const isDate = $a48f10f61e07960b$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $a48f10f61e07960b$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $a48f10f61e07960b$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($a48f10f61e07960b$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $a48f10f61e07960b$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$a48f10f61e07960b$var$counter + '~';
        $a48f10f61e07960b$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $a48f10f61e07960b$var$stableHash(arg[index]) + ',';
            $a48f10f61e07960b$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $a48f10f61e07960b$var$OBJECT.keys(arg).sort();
            while(!$a48f10f61e07960b$var$isUndefined(index = keys.pop()))if (!$a48f10f61e07960b$var$isUndefined(arg[index])) result += index + ':' + $a48f10f61e07960b$var$stableHash(arg[index]) + ',';
            $a48f10f61e07960b$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $a48f10f61e07960b$var$serialize = (key)=>{
    if ($a48f10f61e07960b$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $a48f10f61e07960b$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $a48f10f61e07960b$export$dbab534a48e651ef = (key)=>$a48f10f61e07960b$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $a48f10f61e07960b$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $a48f10f61e07960b$var$WITH_DEDUPE = {
    dedupe: true
};
const $a48f10f61e07960b$var$resolvedUndef = Promise.resolve((0, $lCRzQ.U));
const $a48f10f61e07960b$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $lCRzQ.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $lCRzQ.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $eJOHy.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $eJOHy.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $eJOHy.useRef)(key);
    const fetcherRef = (0, $eJOHy.useRef)(fetcher);
    const configRef = (0, $eJOHy.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $lCRzQ.z)(cache, key);
    const stateDependencies = (0, $eJOHy.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $lCRzQ.e)(fallbackData) ? (0, $lCRzQ.e)(config.fallback) ? (0, $lCRzQ.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $lCRzQ.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $eJOHy.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $lCRzQ.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $lCRzQ.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $g5PZJ.useSyncExternalStore)((0, $eJOHy.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $lCRzQ.e)(cachedData) ? fallback && (0, $lCRzQ.B)(fallback) ? $a48f10f61e07960b$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $eJOHy.useRef)(data);
    const returnedData = keepPreviousData ? (0, $lCRzQ.e)(cachedData) ? (0, $lCRzQ.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $lCRzQ.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $lCRzQ.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $lCRzQ.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $lCRzQ.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $lCRzQ.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $lCRzQ.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $eJOHy.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $lCRzQ.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $lCRzQ.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $lCRzQ.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $lCRzQ.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $lCRzQ.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $lCRzQ.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $lCRzQ.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $4Lrb4).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $eJOHy.useCallback)((...args)=>{
        return (0, $lCRzQ.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $lCRzQ.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $lCRzQ.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $lCRzQ.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $lCRzQ.U), $a48f10f61e07960b$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $4Lrb4).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $4Lrb4).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $4Lrb4).MUTATE_EVENT) return revalidate();
            else if (type == (0, $4Lrb4).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $5dwQF.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $lCRzQ.e)(data) || (0, $lCRzQ.r)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $lCRzQ.t)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $lCRzQ.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $lCRzQ.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($a48f10f61e07960b$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $eJOHy.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        const hasKeyButNoData = key && (0, $lCRzQ.e)(data);
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $lCRzQ.I) && (0, $lCRzQ.r) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $lCRzQ.e)(req) && hasKeyButNoData ? boundMutate(req) : $a48f10f61e07960b$var$resolvedUndef;
        $a48f10f61e07960b$var$use(mutateReq);
        if (!(0, $lCRzQ.e)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($a48f10f61e07960b$var$WITH_DEDUPE) : $a48f10f61e07960b$var$resolvedUndef;
        if (!(0, $lCRzQ.e)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $a48f10f61e07960b$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $a48f10f61e07960b$export$4c7bbecdacc3ca2c = (0, $lCRzQ.O).defineProperty((0, $lCRzQ.g), 'defaultValue', {
    value: (0, $lCRzQ.d)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $a48f10f61e07960b$export$2e2bcd8739ae039 = (0, $5dwQF.withArgs)($a48f10f61e07960b$var$useSWRHandler);

});
parcelRegister("lCRzQ", function(module, exports) {
$parcel$export(module.exports, "b", () => $fbe6b4deff9a347f$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "U", () => $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "O", () => $fbe6b4deff9a347f$export$c4ce752e73470fba);
$parcel$export(module.exports, "e", () => $fbe6b4deff9a347f$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $fbe6b4deff9a347f$export$407448d2b89b1813);
$parcel$export(module.exports, "m", () => $fbe6b4deff9a347f$export$953cecd6e717a553);
$parcel$export(module.exports, "B", () => $fbe6b4deff9a347f$export$ef35774e6d314e91);
$parcel$export(module.exports, "i", () => $fbe6b4deff9a347f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "z", () => $fbe6b4deff9a347f$export$df995fae86a55f06);
$parcel$export(module.exports, "I", () => $fbe6b4deff9a347f$export$9bb611d729802a56);
$parcel$export(module.exports, "r", () => $fbe6b4deff9a347f$export$43caf9889c228507);
$parcel$export(module.exports, "t", () => $fbe6b4deff9a347f$export$625550452a3fa3ec);
$parcel$export(module.exports, "u", () => $fbe6b4deff9a347f$export$3b14a55fb2447963);
$parcel$export(module.exports, "s", () => $fbe6b4deff9a347f$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "o", () => $fbe6b4deff9a347f$export$ae1af26003f05816);
$parcel$export(module.exports, "n", () => $fbe6b4deff9a347f$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "c", () => $fbe6b4deff9a347f$export$db3b6bfb95261072);
$parcel$export(module.exports, "d", () => $fbe6b4deff9a347f$export$4368d992c4eafac0);
$parcel$export(module.exports, "f", () => $fbe6b4deff9a347f$export$2d1720544b23b823);
$parcel$export(module.exports, "S", () => $fbe6b4deff9a347f$export$25ce5a424b770e84);
$parcel$export(module.exports, "g", () => $fbe6b4deff9a347f$export$39b482c5e57630a8);

var $eJOHy = parcelRequire("eJOHy");

var $4Lrb4 = parcelRequire("4Lrb4");

var $eeExS = parcelRequire("eeExS");
'use client';
// Global state used to deduplicate requests and store listeners
const $fbe6b4deff9a347f$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $fbe6b4deff9a347f$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $fbe6b4deff9a347f$export$ebd11618f299a286();
const $fbe6b4deff9a347f$export$c4ce752e73470fba = Object;
const $fbe6b4deff9a347f$export$f1e1789686576879 = (v)=>v === $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08;
const $fbe6b4deff9a347f$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $fbe6b4deff9a347f$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $fbe6b4deff9a347f$export$ef35774e6d314e91 = (x)=>$fbe6b4deff9a347f$export$407448d2b89b1813(x.then);
const $fbe6b4deff9a347f$var$EMPTY_CACHE = {};
const $fbe6b4deff9a347f$var$INITIAL_CACHE = {};
const $fbe6b4deff9a347f$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $fbe6b4deff9a347f$export$23f2a1d2818174ef = typeof window != $fbe6b4deff9a347f$var$STR_UNDEFINED;
const $fbe6b4deff9a347f$export$efccba1c4a2ef57b = typeof document != $fbe6b4deff9a347f$var$STR_UNDEFINED;
const $fbe6b4deff9a347f$export$d141bba7fdc215a3 = $fbe6b4deff9a347f$export$23f2a1d2818174ef && 'Deno' in window;
const $fbe6b4deff9a347f$export$4a5767248b18ef41 = ()=>$fbe6b4deff9a347f$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $fbe6b4deff9a347f$var$STR_UNDEFINED;
const $fbe6b4deff9a347f$export$df995fae86a55f06 = (cache, key)=>{
    const state = $fbe6b4deff9a347f$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$fbe6b4deff9a347f$export$f1e1789686576879(key) && cache.get(key) || $fbe6b4deff9a347f$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$fbe6b4deff9a347f$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $fbe6b4deff9a347f$var$INITIAL_CACHE)) $fbe6b4deff9a347f$var$INITIAL_CACHE[key] = prev;
                state[5](key, $fbe6b4deff9a347f$export$953cecd6e717a553(prev, info), prev || $fbe6b4deff9a347f$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$fbe6b4deff9a347f$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $fbe6b4deff9a347f$var$INITIAL_CACHE) return $fbe6b4deff9a347f$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$fbe6b4deff9a347f$export$f1e1789686576879(key) && cache.get(key) || $fbe6b4deff9a347f$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $fbe6b4deff9a347f$var$online = true;
const $fbe6b4deff9a347f$var$isOnline = ()=>$fbe6b4deff9a347f$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$fbe6b4deff9a347f$var$onWindowEvent, $fbe6b4deff9a347f$var$offWindowEvent] = $fbe6b4deff9a347f$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $fbe6b4deff9a347f$export$ebd11618f299a286,
    $fbe6b4deff9a347f$export$ebd11618f299a286
];
const $fbe6b4deff9a347f$var$isVisible = ()=>{
    const visibilityState = $fbe6b4deff9a347f$export$efccba1c4a2ef57b && document.visibilityState;
    return $fbe6b4deff9a347f$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $fbe6b4deff9a347f$var$initFocus = (callback)=>{
    // focus revalidate
    if ($fbe6b4deff9a347f$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $fbe6b4deff9a347f$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($fbe6b4deff9a347f$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $fbe6b4deff9a347f$var$offWindowEvent('focus', callback);
    };
};
const $fbe6b4deff9a347f$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $fbe6b4deff9a347f$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $fbe6b4deff9a347f$var$online = false;
    };
    $fbe6b4deff9a347f$var$onWindowEvent('online', onOnline);
    $fbe6b4deff9a347f$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $fbe6b4deff9a347f$var$offWindowEvent('online', onOnline);
        $fbe6b4deff9a347f$var$offWindowEvent('offline', onOffline);
    };
};
const $fbe6b4deff9a347f$export$ffb5f4729a158638 = {
    isOnline: $fbe6b4deff9a347f$var$isOnline,
    isVisible: $fbe6b4deff9a347f$var$isVisible
};
const $fbe6b4deff9a347f$export$9e5f44173e64f162 = {
    initFocus: $fbe6b4deff9a347f$var$initFocus,
    initReconnect: $fbe6b4deff9a347f$var$initReconnect
};
const $fbe6b4deff9a347f$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useId;
const $fbe6b4deff9a347f$export$43caf9889c228507 = !$fbe6b4deff9a347f$export$23f2a1d2818174ef || $fbe6b4deff9a347f$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $fbe6b4deff9a347f$export$625550452a3fa3ec = (f)=>$fbe6b4deff9a347f$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $fbe6b4deff9a347f$export$3b14a55fb2447963 = $fbe6b4deff9a347f$export$43caf9889c228507 ? (0, $eJOHy.useEffect) : (0, $eJOHy.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $fbe6b4deff9a347f$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $fbe6b4deff9a347f$export$90a7f3efeed30595 = !$fbe6b4deff9a347f$export$43caf9889c228507 && $fbe6b4deff9a347f$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($fbe6b4deff9a347f$var$navigatorConnection.effectiveType) || $fbe6b4deff9a347f$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $fbe6b4deff9a347f$var$table = new WeakMap();
const $fbe6b4deff9a347f$var$getTypeName = (value)=>$fbe6b4deff9a347f$export$c4ce752e73470fba.prototype.toString.call(value);
const $fbe6b4deff9a347f$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $fbe6b4deff9a347f$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $fbe6b4deff9a347f$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $fbe6b4deff9a347f$var$getTypeName(arg);
    const isDate = $fbe6b4deff9a347f$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $fbe6b4deff9a347f$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $fbe6b4deff9a347f$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($fbe6b4deff9a347f$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $fbe6b4deff9a347f$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$fbe6b4deff9a347f$var$counter + '~';
        $fbe6b4deff9a347f$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $fbe6b4deff9a347f$export$882b5998b3b9117c(arg[index]) + ',';
            $fbe6b4deff9a347f$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $fbe6b4deff9a347f$export$c4ce752e73470fba.keys(arg).sort();
            while(!$fbe6b4deff9a347f$export$f1e1789686576879(index = keys.pop()))if (!$fbe6b4deff9a347f$export$f1e1789686576879(arg[index])) result += index + ':' + $fbe6b4deff9a347f$export$882b5998b3b9117c(arg[index]) + ',';
            $fbe6b4deff9a347f$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $fbe6b4deff9a347f$export$2408f22a0fab9ae5 = (key)=>{
    if ($fbe6b4deff9a347f$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $fbe6b4deff9a347f$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $fbe6b4deff9a347f$var$__timestamp = 0;
const $fbe6b4deff9a347f$export$ae1af26003f05816 = ()=>++$fbe6b4deff9a347f$var$__timestamp;
async function $fbe6b4deff9a347f$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $fbe6b4deff9a347f$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($fbe6b4deff9a347f$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $fbe6b4deff9a347f$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $fbe6b4deff9a347f$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $fbe6b4deff9a347f$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $fbe6b4deff9a347f$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($4Lrb4.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $fbe6b4deff9a347f$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$fbe6b4deff9a347f$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $fbe6b4deff9a347f$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $fbe6b4deff9a347f$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($fbe6b4deff9a347f$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $fbe6b4deff9a347f$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($fbe6b4deff9a347f$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08,
                        _c: $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08,
                    _c: $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $fbe6b4deff9a347f$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $fbe6b4deff9a347f$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $fbe6b4deff9a347f$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $fbe6b4deff9a347f$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$fbe6b4deff9a347f$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $fbe6b4deff9a347f$export$953cecd6e717a553($fbe6b4deff9a347f$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $fbe6b4deff9a347f$export$7ccc53e8f1e7dfc5.bind($fbe6b4deff9a347f$export$3a6d5c9ae78a2c08, provider);
        let unmount = $fbe6b4deff9a347f$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$fbe6b4deff9a347f$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $fbe6b4deff9a347f$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$fbe6b4deff9a347f$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($fbe6b4deff9a347f$export$3a6d5c9ae78a2c08, $fbe6b4deff9a347f$var$revalidateAllKeys.bind($fbe6b4deff9a347f$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $4Lrb4.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($fbe6b4deff9a347f$export$3a6d5c9ae78a2c08, $fbe6b4deff9a347f$var$revalidateAllKeys.bind($fbe6b4deff9a347f$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $4Lrb4.RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $fbe6b4deff9a347f$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $fbe6b4deff9a347f$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $fbe6b4deff9a347f$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$fbe6b4deff9a347f$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $fbe6b4deff9a347f$export$342063e11d6c3cad = (0, $eeExS.dequal);
// Default cache provider
const [$fbe6b4deff9a347f$export$db3b6bfb95261072, $fbe6b4deff9a347f$export$35e795649ee09318] = $fbe6b4deff9a347f$export$dda1d9f60106f0e9(new Map());
// Default config
const $fbe6b4deff9a347f$export$4368d992c4eafac0 = $fbe6b4deff9a347f$export$953cecd6e717a553({
    // events
    onLoadingSlow: $fbe6b4deff9a347f$export$ebd11618f299a286,
    onSuccess: $fbe6b4deff9a347f$export$ebd11618f299a286,
    onError: $fbe6b4deff9a347f$export$ebd11618f299a286,
    onErrorRetry: $fbe6b4deff9a347f$var$onErrorRetry,
    onDiscarded: $fbe6b4deff9a347f$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $fbe6b4deff9a347f$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $fbe6b4deff9a347f$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $fbe6b4deff9a347f$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $fbe6b4deff9a347f$export$db3b6bfb95261072,
    mutate: $fbe6b4deff9a347f$export$35e795649ee09318,
    fallback: {}
}, $fbe6b4deff9a347f$export$ffb5f4729a158638);
const $fbe6b4deff9a347f$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $fbe6b4deff9a347f$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $fbe6b4deff9a347f$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $fbe6b4deff9a347f$export$25ce5a424b770e84 = (0, $eJOHy.createContext)({});
const $fbe6b4deff9a347f$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $eJOHy.useContext)($fbe6b4deff9a347f$export$25ce5a424b770e84);
    const isFunctionalConfig = $fbe6b4deff9a347f$export$407448d2b89b1813(value);
    const config = (0, $eJOHy.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $eJOHy.useMemo)(()=>isFunctionalConfig ? config : $fbe6b4deff9a347f$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $eJOHy.useRef)($fbe6b4deff9a347f$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $fbe6b4deff9a347f$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $fbe6b4deff9a347f$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $fbe6b4deff9a347f$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $eJOHy.createElement)($fbe6b4deff9a347f$export$25ce5a424b770e84.Provider, $fbe6b4deff9a347f$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};

});
parcelRegister("4Lrb4", function(module, exports) {
$parcel$export(module.exports, "FOCUS_EVENT", () => $3780a22036c54ca8$export$831c820ad60f9d12);
$parcel$export(module.exports, "RECONNECT_EVENT", () => $3780a22036c54ca8$export$24e9454cb99a11dc);
$parcel$export(module.exports, "MUTATE_EVENT", () => $3780a22036c54ca8$export$75ea288459391154);
$parcel$export(module.exports, "ERROR_REVALIDATE_EVENT", () => $3780a22036c54ca8$export$b019c3839228f243);
const $3780a22036c54ca8$export$831c820ad60f9d12 = 0;
const $3780a22036c54ca8$export$24e9454cb99a11dc = 1;
const $3780a22036c54ca8$export$75ea288459391154 = 2;
const $3780a22036c54ca8$export$b019c3839228f243 = 3;

});

parcelRegister("eeExS", function(module, exports) {
$parcel$export(module.exports, "dequal", () => $a5d1d2f497901cf3$export$de8294bb3be0322f);
var $a5d1d2f497901cf3$var$has = Object.prototype.hasOwnProperty;
function $a5d1d2f497901cf3$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $a5d1d2f497901cf3$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($a5d1d2f497901cf3$var$has.call(foo, ctor) && ++len && !$a5d1d2f497901cf3$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$a5d1d2f497901cf3$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});


parcelRegister("5dwQF", function(module, exports) {
$parcel$export(module.exports, "useSWRConfig", () => $3cc7a5a819bc9de1$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "withArgs", () => $3cc7a5a819bc9de1$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $3cc7a5a819bc9de1$export$e005210ed621746);
$parcel$export(module.exports, "SWRGlobalState", () => (parcelRequire("lCRzQ")).b);
$parcel$export(module.exports, "defaultConfig", () => (parcelRequire("lCRzQ")).d);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("lCRzQ")).a);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("lCRzQ")).e);
$parcel$export(module.exports, "mergeObjects", () => (parcelRequire("lCRzQ")).m);
$parcel$export(module.exports, "serialize", () => (parcelRequire("lCRzQ")).s);

var $lCRzQ = parcelRequire("lCRzQ");

var $4Lrb4 = parcelRequire("4Lrb4");

var $bQjUm = parcelRequire("bQjUm");

var $eJOHy = parcelRequire("eJOHy");

// @ts-expect-error
const $3cc7a5a819bc9de1$var$enableDevtools = (0, $lCRzQ.i) && window.__SWR_DEVTOOLS_USE__;
const $3cc7a5a819bc9de1$var$use = $3cc7a5a819bc9de1$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $3cc7a5a819bc9de1$var$setupDevTools = ()=>{
    if ($3cc7a5a819bc9de1$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
};
const $3cc7a5a819bc9de1$export$a3295358bff77e = (args)=>{
    return (0, $lCRzQ.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $3cc7a5a819bc9de1$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $eJOHy.useContext)((0, $lCRzQ.S));
    const mergedConfig = (0, $eJOHy.useMemo)(()=>(0, $lCRzQ.m)((0, $lCRzQ.d), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $3cc7a5a819bc9de1$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $lCRzQ.s)(key_);
    const [, , , PRELOAD] = (0, $lCRzQ.b).get((0, $lCRzQ.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $3cc7a5a819bc9de1$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $lCRzQ.s)(key_);
            const [, , , PRELOAD] = (0, $lCRzQ.b).get((0, $lCRzQ.c));
            if (key.startsWith((0, $bQjUm.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $lCRzQ.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $3cc7a5a819bc9de1$var$BUILT_IN_MIDDLEWARE = $3cc7a5a819bc9de1$var$use.concat($3cc7a5a819bc9de1$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $3cc7a5a819bc9de1$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $3cc7a5a819bc9de1$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $3cc7a5a819bc9de1$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $lCRzQ.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($3cc7a5a819bc9de1$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $3cc7a5a819bc9de1$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $3cc7a5a819bc9de1$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $3cc7a5a819bc9de1$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$3cc7a5a819bc9de1$var$setupDevTools();

});
parcelRegister("bQjUm", function(module, exports) {
$parcel$export(module.exports, "INFINITE_PREFIX", () => $89f3fe56a8d64506$export$8667f065faedc62c);
const $89f3fe56a8d64506$export$8667f065faedc62c = '$inf$';

});







parcelRegister("7aZLF", function(module, exports) {
$parcel$export(module.exports, "Nav4Recommendation", () => $39a834ba52303aa5$export$7f848320b087945d);

var $gt9Am = parcelRequire("gt9Am");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");

var $6zhpo = parcelRequire("6zhpo");

var $NByNW = parcelRequire("NByNW");

var $jdqdp = parcelRequire("jdqdp");

var $7saMl = parcelRequire("7saMl");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $58yRG = parcelRequire("58yRG");

var $1Yvty = parcelRequire("1Yvty");
parcelRequire("6X7AJ");
var $iE1pm = parcelRequire("iE1pm");
var $cqw6Y = parcelRequire("cqw6Y");parcelRequire("dNnxZ");
var $6UCnr = parcelRequire("6UCnr");

var $k9r6D = parcelRequire("k9r6D");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $e6rMq = parcelRequire("e6rMq");

var $cBBuq = parcelRequire("cBBuq");

var $9ODXx = parcelRequire("9ODXx");

var $geo5r = parcelRequire("geo5r");

var $akOap = parcelRequire("akOap");

var $pbDnR = parcelRequire("pbDnR");
const $39a834ba52303aa5$var$itsmLogoByTheme = (colorMode = 'light')=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ODXx.JsmItsmLightIcon), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBBuq.JsmItsmDarkIcon), {});
};
const $39a834ba52303aa5$var$workRequestLogoByTheme = (colorMode = 'light')=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $akOap.JsmWorkRequestsLightIcon), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $geo5r.JsmWorkRequestsDarkIcon), {});
};
const $39a834ba52303aa5$var$useIcon = ({ productKey: productKey, entityId: entityId })=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    if (productKey === (0, $6UCnr.Targets).JIRA_SERVICE_DESK) {
        if (entityId === 'jsm.general-service-management') return $39a834ba52303aa5$var$workRequestLogoByTheme(colorMode);
        if (entityId === 'jsm.it-service-management-basic') return $39a834ba52303aa5$var$itsmLogoByTheme(colorMode);
    }
    if (productKey === (0, $6UCnr.Targets).JIRA_PRODUCT_DISCOVERY) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e6rMq.JpdRoadmapIcon), {});
    return null;
};
const $39a834ba52303aa5$var$useTemplateName = ({ productKey: productKey, entityId: entityId })=>{
    if (productKey === (0, $6UCnr.Targets).JIRA_SERVICE_DESK) {
        if (entityId === 'jsm.general-service-management') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "cross-flow-work-requests-template.jsm.title",
            defaultMessage: "Collect requests",
            description: "Jira Service Management Work Requests template display name"
        });
        if (entityId === 'jsm.it-service-management-basic') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "cross-flow-itsm-template.jsm.title",
            defaultMessage: "Collect IT requests",
            description: "Jira Service Management ITSM template display name"
        });
    }
    if (productKey === (0, $6UCnr.Targets).JIRA_PRODUCT_DISCOVERY) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "cross-flow-product-roadmap-template.jpd.title",
        defaultMessage: "Create a roadmap",
        description: "Jira Product Discovery product roadmap template display name"
    });
    return null;
};
const $39a834ba52303aa5$export$7f848320b087945d = ({ productKey: productKey, entityId: entityId, recommendationSessionId: recommendationSessionId, dismiss: dismiss })=>{
    const icon = $39a834ba52303aa5$var$useIcon({
        productKey: productKey,
        entityId: entityId
    });
    const templateName = $39a834ba52303aa5$var$useTemplateName({
        productKey: productKey,
        entityId: entityId
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const crossFlow = (0, $cqw6Y.useCrossFlow)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $1Yvty.useFireCrossFlowAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    (0, $eJOHy.useEffect)(()=>{
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            source: 'projectsMenuSection',
            recommendedProductIds: [
                productKey
            ],
            recommendationSession: {
                id: recommendationSessionId,
                type: 'appRec'
            }
        }, {
            sqa1052Enabled: true
        });
    }, [
        fireViewedUIEvent,
        productKey,
        recommendationSessionId
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'recommendation',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'react'
            },
            additionalMetadataFromFrontend: {
                sqa1052Enabled: true
            }
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: productKey,
            recommendationSession: {
                id: recommendationSessionId,
                type: 'appRec'
            },
            recommendedProductIds: [
                productKey
            ]
        }, {
            sqa1052Enabled: true
        });
        if (crossFlow.isEnabled) crossFlow.apiV1.open({
            v1: true,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            targetProduct: productKey,
            journey: (0, $iE1pm.Journeys).GET_STARTED,
            extensions: {
                provisioningPageOptions: {
                    actions: {
                        primary: {
                            behaviour: 'land',
                            prompt: 'next',
                            options: {
                                targetTab: 'same',
                                urlParams: {
                                    templateId: entityId
                                }
                            }
                        }
                    }
                },
                recommendationContext: {
                    recommendationSessionId: recommendationSessionId,
                    entityId: entityId
                }
            }
        });
    }, [
        crossFlow,
        entityId,
        fireInteractedUIEvent,
        messageInstanceClicked,
        productKey,
        recommendationSessionId
    ]);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                sqa1052Enabled: true
            }
        });
        dismiss();
    }, [
        dismiss,
        messageInstanceClicked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $pbDnR.MenuItemBase), {
            elemBefore: icon,
            elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: "new",
                isBold: false,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    id: "post-office.nav-4-projects-recommendations.cta-button-lozenge-try",
                    defaultMessage: "Try",
                    description: "A lozenge to display the try button"
                })
            }),
            href: "",
            onClick: handleClick,
            actionsOnHover: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                shouldRenderToParent: true,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        ref: triggerRef,
                        ...props,
                        spacing: "compact",
                        appearance: "subtle",
                        label: formatMessage({
                            id: 'post-office.nav-4-projects-recommendations.dropdown-menu-open-label',
                            defaultMessage: 'Open',
                            description: 'A label to open the recommendation dropdown menu'
                        }),
                        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                                ...iconProps,
                                size: "small"
                            })
                    }),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUgeq.default), {
                    minWidth: "250px",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
                            onClick: handleDismiss,
                            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                                label: ""
                            }),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                id: "post-office.nav-4-projects-recommendations.cta-button-dimissal",
                                defaultMessage: "Dismiss",
                                description: "A call to action to dismiss the request"
                            })
                        })
                    })
                })
            }),
            children: templateName
        })
    });
};

});
parcelRegister("1Yvty", function(module, exports) {
$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $9069b86f63c36855$export$c2095165ae2bdcda);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $dUrLZ = parcelRequire("dUrLZ");

var $3ryPk = parcelRequire("3ryPk");
function $9069b86f63c36855$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $eJOHy.useRef)();
    const firedViewedUIEventId = (0, $eJOHy.useRef)();
    const mapToCcpProductKeys = (0, $eJOHy.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $dUrLZ.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $dUrLZ.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $eJOHy.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $3ryPk.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $3ryPk.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $eJOHy.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $3ryPk.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $3ryPk.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $eJOHy.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $3ryPk.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $3ryPk.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("dUrLZ", function(module, exports) {
$parcel$export(module.exports, "FIRST_PARTY_CCP_PRODUCT_IDS", () => $9841fbd157f8f9f3$export$6c053e1694ef181c);
$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", () => $9841fbd157f8f9f3$export$54e3fc09a2a3347a);
const $9841fbd157f8f9f3$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $9841fbd157f8f9f3$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $9841fbd157f8f9f3$export$6c053e1694ef181c = {
    prod: $9841fbd157f8f9f3$export$31048cb2a0753b12,
    staging: $9841fbd157f8f9f3$export$9d8f18312db80469
};
const $9841fbd157f8f9f3$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};

});

parcelRegister("3ryPk", function(module, exports) {
$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", () => $020a2f8f0dcb8479$export$c536a7e29a0739b8);
$parcel$export(module.exports, "eventTypes", () => $020a2f8f0dcb8479$export$285f3d0989f9023f);
const $020a2f8f0dcb8479$export$c536a7e29a0739b8 = 'crossFlow';
var $020a2f8f0dcb8479$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});

});


parcelRegister("6X7AJ", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("cqw6Y")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("cqw6Y")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("cqw6Y")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("iE1pm")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("iE1pm")).Reasons);

var $cqw6Y = parcelRequire("cqw6Y");

var $iE1pm = parcelRequire("iE1pm");

});
parcelRegister("cqw6Y", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => $cc23ef3a870d995d$export$c0ddec072762f62a);
$parcel$export(module.exports, "useCrossFlow", () => $cc23ef3a870d995d$export$6e7a10fe635a0dfc);
$parcel$export(module.exports, "withCrossFlow", () => $cc23ef3a870d995d$export$655b6c19a0daddb8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iQWdr = parcelRequire("iQWdr");

var $3bCBM = parcelRequire("3bCBM");

var $iE1pm = parcelRequire("iE1pm");
const $cc23ef3a870d995d$var$LATEST_VERSION = (0, $3bCBM.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $cc23ef3a870d995d$var$CrossFlowContext = /*#__PURE__*/ (0, $eJOHy.createContext)(()=>({
        isEnabled: false,
        reason: (0, $iE1pm.Reasons).NO_PROVIDER
    }));
const $cc23ef3a870d995d$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $3bCBM.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $iQWdr.createAPIv0)(onOpen),
                    apiV1: (0, $3bCBM.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $iE1pm.Reasons).NO_API_SUPPORT
                };
        }
    };
const $cc23ef3a870d995d$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $eJOHy.useMemo)(()=>$cc23ef3a870d995d$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($cc23ef3a870d995d$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $cc23ef3a870d995d$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $eJOHy.useContext)($cc23ef3a870d995d$var$CrossFlowContext);
    return (0, $eJOHy.useMemo)(()=>negotiateApi($cc23ef3a870d995d$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $cc23ef3a870d995d$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $cc23ef3a870d995d$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}

});
parcelRegister("iQWdr", function(module, exports) {
$parcel$export(module.exports, "createAPIv0", () => $307139f42536ff7d$export$9ff7368ac93fcf2d);
const $307139f42536ff7d$export$a4ad2735b021c132 = 0;
const $307139f42536ff7d$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("3bCBM", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $3917842d43091fcb$export$a4ad2735b021c132);
$parcel$export(module.exports, "createAPIv1", () => $3917842d43091fcb$export$8fd5792fc468459f);
const $3917842d43091fcb$export$a4ad2735b021c132 = 1;
const $3917842d43091fcb$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("iE1pm", function(module, exports) {
$parcel$export(module.exports, "Journeys", () => $615ec0f1e10b2796$export$3411873bfd520bb6);
$parcel$export(module.exports, "Reasons", () => $615ec0f1e10b2796$export$da2d4f2f250d6f84);
const $615ec0f1e10b2796$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $615ec0f1e10b2796$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};

});



parcelRegister("dNnxZ", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("gEdNf")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("6UCnr")).Targets);

var $gEdNf = parcelRequire("gEdNf");

var $6UCnr = parcelRequire("6UCnr");

});
parcelRegister("gEdNf", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => $189210fed5957c8b$export$a5e53d1dcbd6eb61);
class $189210fed5957c8b$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}

});

parcelRegister("6UCnr", function(module, exports) {
$parcel$export(module.exports, "Targets", () => $bdee66065c25d038$export$59a8eb9cff113544);
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $bdee66065c25d038$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};

});


parcelRegister("e6rMq", function(module, exports) {
$parcel$export(module.exports, "JpdRoadmapIcon", () => $d573b8130c61a01a$export$570bcb877c8bdf1d);

var $gt9Am = parcelRequire("gt9Am");
const $d573b8130c61a01a$export$570bcb877c8bdf1d = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        x: "2",
                        y: "2",
                        width: "36",
                        height: "36",
                        rx: "4",
                        fill: "#EED7FC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M14.233 12.479h8.575a4.438 4.438 0 0 1 0 8.875h-5.325a2.07 2.07 0 1 0 0 4.142h8.575v2.366h-8.575a4.438 4.438 0 0 1 0-8.875h5.325a2.07 2.07 0 1 0 0-4.141h-8.575z",
                        fill: "#AF59E0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M14.233 17.183a3.55 3.55 0 1 0 0-7.1 3.55 3.55 0 0 0 0 7.1m15.087 6.225h-6.507v6.508h6.508z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M17.588 12.479a3.53 3.53 0 0 1-.025 2.367h-3.33v-2.367z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M17.78 13.629c0 .43-.076.838-.218 1.217h-3.329v-2.367h3.354c.125.363.192.746.192 1.15m7.659 15.779v-1.55h-2.625v-2.367h2.625v-1.55l2.729 2.734z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "40",
                        height: "40",
                        rx: "4",
                        fill: "#fff"
                    })
                })
            })
        ]
    });

});

parcelRegister("cBBuq", function(module, exports) {
$parcel$export(module.exports, "JsmItsmDarkIcon", () => $84f612dc49c5247f$export$cf305ef8885e007f);

var $gt9Am = parcelRequire("gt9Am");
const $84f612dc49c5247f$export$cf305ef8885e007f = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "4",
                fill: "#48245D"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M17.82 7.194H6.18v7.623h11.64z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M15.127 15.86v1.296H8.873V15.86h2.083v-2.325h2.088v2.325z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M13.044 13.535h-2.088v1.284h2.088z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M12 12.815a1.808 1.808 0 1 0 0-3.617 1.808 1.808 0 0 0 0 3.617",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M18.082 7.28c.172-.015 2.48-.563 1.875-.681-.224.061-.399-.001-.511.166-.033-.197-.473.118-.54.13-.031-.15-.721.235-.62.096-.314.004-.703.112-1.108.238-.198-.132.652-1.075.295-.872.025-.053.12-.282.108-.13.113-.13 1.343-2.123.832-1.785-.345.41-.605 1.1-.897 1.44-.284.114-.481 1.101-.798 1.003-.184-.222-.66-2.938-.999-2.697.059.211.005.4.17.502-.201.032.12.464.132.53-.15.029.237.708.098.609.003.192.047.414.11.65-.084-.064-.177-.208-.23-.23-.57-.226-1.002-.746-1.595-1.028-.499.623 3.91 2.196 1.176 2.431-.514.33-1.197.38-1.771.697-.05.686 3.221-1.207 2.277-.12-.146.46-.364.976-.665 1.429-.192 1.727 1.442-2.965 1.374-1.175.225.428.443.943.555 1.474.799 1.15-.292-1.893-.406-2.324.433-.181 2.107 1.875 2.41 1.55.014-.045-.227-.3-.3-.327-.05.025-.074.045-.103 0 .146-.14-.369-.315-.417-.362.108-.106-.608-.45-.435-.444-.134-.184-.339-.37-.572-.556.414-.078.594-.365.556-.216z",
                fill: "#CECFD2"
            })
        ]
    });

});

parcelRegister("9ODXx", function(module, exports) {
$parcel$export(module.exports, "JsmItsmLightIcon", () => $8368c8c8a3c8f282$export$c9a0cb94b7717280);

var $gt9Am = parcelRequire("gt9Am");
const $8368c8c8a3c8f282$export$c9a0cb94b7717280 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "4",
                fill: "#EED7FC"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M17.82 7.194H6.18v7.623h11.64z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M15.127 15.86v1.296H8.873V15.86h2.083v-2.325h2.088v2.325z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M13.044 13.535h-2.088v1.284h2.088z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M12 12.815a1.808 1.808 0 1 0 0-3.617 1.808 1.808 0 0 0 0 3.617",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M18.082 7.28c.172-.015 2.48-.563 1.875-.681-.224.061-.399-.001-.511.166-.033-.197-.473.118-.54.13-.031-.15-.721.235-.62.096-.314.004-.703.112-1.108.238-.198-.132.652-1.075.295-.872.025-.053.12-.282.108-.13.113-.13 1.343-2.123.832-1.785-.345.41-.605 1.1-.897 1.44-.284.114-.481 1.101-.798 1.003-.184-.222-.66-2.938-.999-2.697.059.211.005.4.17.502-.201.032.12.464.132.53-.15.029.237.708.098.609.003.192.047.414.11.65-.084-.064-.177-.208-.23-.23-.57-.226-1.002-.746-1.595-1.028-.499.623 3.91 2.196 1.176 2.431-.514.33-1.197.38-1.771.697-.05.686 3.221-1.207 2.277-.12-.146.46-.364.976-.665 1.429-.192 1.727 1.442-2.965 1.374-1.175.225.428.443.943.555 1.474.799 1.15-.292-1.893-.406-2.324.433-.181 2.107 1.875 2.41 1.55.014-.045-.227-.3-.3-.327-.05.025-.074.045-.103 0 .146-.14-.369-.315-.417-.362.108-.106-.608-.45-.435-.444-.134-.184-.339-.37-.572-.556.414-.078.594-.365.556-.216z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("geo5r", function(module, exports) {
$parcel$export(module.exports, "JsmWorkRequestsDarkIcon", () => $0ec436fe4f1118ca$export$f55a45601bcb44f0);

var $gt9Am = parcelRequire("gt9Am");
const $0ec436fe4f1118ca$export$f55a45601bcb44f0 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "4",
                fill: "#48245D"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M6.59 6.592V15.4h8.808V6.592zm3.775 1.891h3.145v.944h-3.145zm0 2.04h3.145v.944h-3.145zM8.794 8.32c.346 0 .629.283.629.629s-.283.63-.63.63a.63.63 0 0 1 0-1.26m0 2.046a.63.63 0 1 1-.002 1.26.63.63 0 0 1 .002-1.26",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M16.594 12.025v1.46h-6.23v2.97h6.23v1.753l3.09-3.093z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M10.365 13.485V15.4h5.033v-1.915z",
                fill: "#09326C"
            })
        ]
    });

});

parcelRegister("akOap", function(module, exports) {
$parcel$export(module.exports, "JsmWorkRequestsLightIcon", () => $e511898b61929afd$export$1847837dcfca048);

var $gt9Am = parcelRequire("gt9Am");
const $e511898b61929afd$export$1847837dcfca048 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "4",
                fill: "#EED7FC"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M6.59 6.592V15.4h8.808V6.592zm3.775 1.891h3.145v.944h-3.145zm0 2.04h3.145v.944h-3.145zM8.794 8.32c.346 0 .629.283.629.629s-.283.63-.63.63a.63.63 0 0 1 0-1.26m0 2.046a.63.63 0 1 1-.002 1.26.63.63 0 0 1 .002-1.26",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M16.594 12.025v1.46h-6.23v2.97h6.23v1.753l3.09-3.093z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M10.365 13.485V15.4h5.033v-1.915z",
                fill: "#09326C"
            })
        ]
    });

});

parcelRegister("pbDnR", function(module, exports) {
$parcel$export(module.exports, "MenuItemBase", () => $9c62cfeb98eff7f3$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $l8fMV = parcelRequire("l8fMV");

var $gyJTO = parcelRequire("gyJTO");

var $lc0OY = parcelRequire("lc0OY");
var $46R8N = parcelRequire("46R8N");
var $3cMgR = parcelRequire("3cMgR");

var $k71qx = parcelRequire("k71qx");
var $7AseU = parcelRequire("7AseU");

var $k0ahr = parcelRequire("k0ahr");

var $eJOHy = parcelRequire("eJOHy");

var $iusxY = parcelRequire("iusxY");
const $9c62cfeb98eff7f3$var$tooltipStyles = {
    root: "_2rko12b0 _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const $9c62cfeb98eff7f3$var$MenuItemTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7AseU.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            $9c62cfeb98eff7f3$var$tooltipStyles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        children: children
    });
});
function $9c62cfeb98eff7f3$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $9c62cfeb98eff7f3$var$defaultAvatarValues = {
    size: 'small'
};
const $9c62cfeb98eff7f3$var$elemAfterDisplayVar = '--elem-after-display';
const $9c62cfeb98eff7f3$var$actionsOnHoverDisplayVar = '--actions-on-hover-display';
const $9c62cfeb98eff7f3$var$notchColorVar = '--notch-color';
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $9c62cfeb98eff7f3$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $9c62cfeb98eff7f3$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $9c62cfeb98eff7f3$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $9c62cfeb98eff7f3$var$containerStyles = {
    root: "_2rko12b0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3izwfg _4cvr1h6o _uiztglyw _syaz1gjq _ek6gglyw _1yyu3acm _91ju1txw _1swv108i _1ojv1txw _irr3108i _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_ek6g1txw",
    removeElemAfterOnHover: "_1mfcglyw _1sjuglyw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3ickbl"
};
const $9c62cfeb98eff7f3$var$buttonOrAnchorStyles = {
    root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk18uv _syaz1gjq _4cvr1h6o _y3gnv2br _14iu1ji5",
    selected: "_syazaqb7 _14iu19ru"
};
const $9c62cfeb98eff7f3$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $9c62cfeb98eff7f3$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $9c62cfeb98eff7f3$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $9c62cfeb98eff7f3$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _1e0c1c3z _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $9c62cfeb98eff7f3$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $9c62cfeb98eff7f3$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $9c62cfeb98eff7f3$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const $9c62cfeb98eff7f3$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $9c62cfeb98eff7f3$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
const $9c62cfeb98eff7f3$export$859b390bf71e044e = ({ testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: descriptionProp, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef })=>{
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $eJOHy.useRef)(null);
    const descriptionRef = (0, $eJOHy.useRef)(null);
    const tooltipOnClick = (0, $eJOHy.useRef)(null);
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        tooltipOnClick.current?.(event);
    }, [
        onClick
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $eJOHy.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $9c62cfeb98eff7f3$var$isTextClamped(label)) return true;
        return Boolean(description && $9c62cfeb98eff7f3$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $iusxY.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            $9c62cfeb98eff7f3$var$interactiveContentStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $9c62cfeb98eff7f3$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    $9c62cfeb98eff7f3$var$textStyles.root,
                    !showElemBefore && $9c62cfeb98eff7f3$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        weight: "medium",
                        maxLines: 1,
                        color: $9c62cfeb98eff7f3$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    descriptionProp && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: descriptionProp
                    })
                ]
            })
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l8fMV.AvatarContext).Provider, {
        value: $9c62cfeb98eff7f3$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $hcewu.default)([
                $9c62cfeb98eff7f3$var$containerStyles.root,
                isSelected && $9c62cfeb98eff7f3$var$containerStyles.selected,
                descriptionProp && $9c62cfeb98eff7f3$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $9c62cfeb98eff7f3$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $9c62cfeb98eff7f3$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $9c62cfeb98eff7f3$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $9c62cfeb98eff7f3$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    children: children
                                }),
                                descriptionProp ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    children: descriptionProp
                                }) : null
                            ]
                        }),
                    position: "right",
                    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
                    component: $9c62cfeb98eff7f3$var$MenuItemTooltip,
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $gyJTO.default)([
                                tooltipProps.ref
                            ]),
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lc0OY.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $k0ahr.cx)($9c62cfeb98eff7f3$var$buttonOrAnchorStyles.root, $9c62cfeb98eff7f3$var$topLevelSiblingStyles.root, isSelected && $9c62cfeb98eff7f3$var$buttonOrAnchorStyles.selected),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            style: {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $hcewu.default)([
                                        $9c62cfeb98eff7f3$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $k0ahr.cx)($9c62cfeb98eff7f3$var$buttonOrAnchorStyles.root, $9c62cfeb98eff7f3$var$topLevelSiblingStyles.root, isSelected && $9c62cfeb98eff7f3$var$buttonOrAnchorStyles.selected),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $9c62cfeb98eff7f3$var$elemBeforeStyles.root,
                        $9c62cfeb98eff7f3$var$topLevelSiblingStyles.root,
                        $9c62cfeb98eff7f3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $9c62cfeb98eff7f3$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $9c62cfeb98eff7f3$var$elemAfterStyles.root,
                        $9c62cfeb98eff7f3$var$topLevelSiblingStyles.root,
                        $9c62cfeb98eff7f3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $9c62cfeb98eff7f3$var$actionStyles.root,
                        $9c62cfeb98eff7f3$var$topLevelSiblingStyles.root,
                        $9c62cfeb98eff7f3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};

});
parcelRegister("iusxY", function(module, exports) {
$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $9b59f70d2b7554e8$export$f4b8e24fae579c6f);
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $9b59f70d2b7554e8$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});




parcelRegister("b5GNq", function(module, exports) {
$parcel$export(module.exports, "productionRuntime", () => $e56401a186c589cf$export$cbba1ff0a3203010);

var $fAwAG = parcelRequire("fAwAG");

var $i5q4b = parcelRequire("i5q4b");
const $e56401a186c589cf$export$cbba1ff0a3203010 = (config)=>{
    const placementStages = (0, $i5q4b.createPlacementStages)(config);
    const stageProcessors = $e56401a186c589cf$var$placementStagesToStageProcessors(placementStages);
    return ({ koa: koa, request: request })=>{
        const enableBypassBuffer = request.statsig.checkGate({
            identifiers: {
                atlassianAccountId: request?.orchestrationContext?.recipient?.toString()
            }
        }, 'post-office_enable_bypass-data');
        // This is stateful mechanism to allow placement stages to send none message data between them.
        // Examples include grouping data, or other metadata provided by the placement.
        // Orchestration messageSelection only accepts PipelineMessage[] as an input, which means we can't add it to the pipeline payload. >(ভ⤙ ভ ")<
        // Be aware that because this is stateful it is dangerous. Be sure that this only is instantiated per request to prevent metadata
        // cross contamination between requests
        const bypassBuffer = $e56401a186c589cf$var$createBypassBuffer();
        const stages = stageProcessors({
            request: request,
            bypassBuffer: bypassBuffer,
            enableBypassBuffer: enableBypassBuffer
        });
        const orchestrationRequest = request.location.tag({
            placementLevel: 'PostOffice'
        });
        return async (params)=>{
            const messages = await koa.ctx.messageSelection.getEligibleMessages(orchestrationRequest, {
                ...params,
                stages: stages
            });
            if (enableBypassBuffer) {
                const bypassData = bypassBuffer.getOnce();
                return {
                    data: {
                        ...bypassData,
                        messages: messages
                    },
                    // Add error output when compatible with orchestration
                    errors: []
                };
            }
            return {
                data: {
                    messages: messages
                },
                // Add error output when compatible with orchestration
                errors: []
            };
        };
    };
};
const $e56401a186c589cf$var$placementStagesToStageProcessors = (placementStages)=>(contexts)=>{
        const stageProcessors = {};
        Object.entries(placementStages).forEach((stage)=>{
            const [stageName] = stage;
            stageProcessors[stageName] = $e56401a186c589cf$var$placementStageToStageProcessor(contexts)(stage);
        });
        return stageProcessors;
    };
const $e56401a186c589cf$var$placementStageToStageProcessor = (contexts)=>([stageName, placementStage])=>{
        const execute = $e56401a186c589cf$var$placementStageToStageProcessorExecute(placementStage)(contexts);
        return ()=>({
                id: stageName,
                execute: execute
            });
    };
const $e56401a186c589cf$var$createBypassBuffer = ()=>{
    let state = undefined;
    const getOnce = ()=>{
        const once = state;
        flush();
        return once;
    };
    const set = (buffer)=>{
        state = buffer;
    };
    const flush = ()=>{
        state = undefined;
    };
    return {
        getOnce: getOnce,
        set: set,
        flush: flush
    };
};
const $e56401a186c589cf$var$placementStageToStageProcessorExecute = (placementStage = $e56401a186c589cf$var$identityPlacementStage)=>({ request: request, bypassBuffer: bypassBuffer, enableBypassBuffer: enableBypassBuffer })=>async (pipelineMessages)=>{
            const placementMessages = pipelineMessages.map($e56401a186c589cf$var$stripUnserializablePayload);
            const pipelineMessagesByMessageInstanceId = Object.fromEntries(pipelineMessages.map((pipelineMessage)=>[
                    pipelineMessage.messageInstanceId,
                    pipelineMessage
                ]));
            $e56401a186c589cf$var$validateSerializablePayload(placementMessages);
            if (enableBypassBuffer) {
                const bypassInput = bypassBuffer.getOnce();
                const processedData = await placementStage({
                    data: {
                        ...bypassInput,
                        messages: placementMessages
                    },
                    request: request
                });
                const { messages: _, ...bypassOutput } = processedData;
                bypassBuffer.set(bypassOutput);
                const combinedMessages = processedData.messages.map((processedMessage)=>({
                        ...pipelineMessagesByMessageInstanceId[processedMessage.messageInstanceId],
                        ...processedMessage
                    }));
                return combinedMessages;
            }
            const processedData = await placementStage({
                data: {
                    messages: placementMessages
                },
                request: request
            });
            const combinedMessages = processedData.messages.map((processedMessage)=>({
                    ...pipelineMessagesByMessageInstanceId[processedMessage.messageInstanceId],
                    ...processedMessage
                }));
            return combinedMessages;
        };
const $e56401a186c589cf$var$stripUnserializablePayload = (pipelineMessage)=>({
        messageInstanceId: pipelineMessage.messageInstanceId,
        messageTemplateId: pipelineMessage.messageTemplateId,
        messageCategory: pipelineMessage.messageCategory,
        createdAt: pipelineMessage.createdAt,
        eventTime: pipelineMessage.eventTime,
        context: pipelineMessage.context,
        triggerId: pipelineMessage.triggerId,
        messageCreationType: pipelineMessage.messageCreationType,
        recommendationSession: pipelineMessage.recommendationSession,
        readStatus: pipelineMessage.readStatus
    });
const $e56401a186c589cf$var$validateSerializablePayload = (payload)=>{
    try {
        JSON.stringify(payload);
    } catch  {
        throw new (0, $fAwAG.PlacementSystemError)({
            message: 'failed to backend message body, this may mean a non-serializable field has to been added and should be removed'
        });
    }
};
const $e56401a186c589cf$var$identityPlacementStage = async (input)=>input.data;

});
parcelRegister("i5q4b", function(module, exports) {
$parcel$export(module.exports, "createPlacementStages", () => $684d224cca65ac06$export$92374210cfb1952e);

var $fAwAG = parcelRequire("fAwAG");
const $684d224cca65ac06$export$92374210cfb1952e = (config)=>{
    const placementMessagesStages = $684d224cca65ac06$export$a5c10ed60365dc32(config.messagesStages);
    return config.placementStages(placementMessagesStages);
};
const $684d224cca65ac06$export$a5c10ed60365dc32 = (messagesStages)=>{
    const messagesStagesByStageName = $684d224cca65ac06$export$3be438872ca64c45(messagesStages);
    const placementMessageStages = {};
    Object.entries(messagesStagesByStageName).forEach(([stageName, stage])=>{
        const messageStage = $684d224cca65ac06$export$e43344e8c8930b68(stage);
        if (placementMessageStages[stageName]) throw new (0, $fAwAG.PlacementMessageError)({
            message: 'a duplicate stage name was found. Stage names should be unique'
        });
        const placementMessageStage = $684d224cca65ac06$export$64a9f617bf229a12(messageStage);
        $684d224cca65ac06$var$nameFunction(stageName, placementMessageStage);
        placementMessageStages[stageName] = placementMessageStage;
    });
    return placementMessageStages;
};
const $684d224cca65ac06$export$64a9f617bf229a12 = (messageStage)=>async ({ data: data, request: request })=>{
        const result = await $684d224cca65ac06$export$c86138aa03618dd1(messageStage)({
            data: data,
            request: request
        });
        const inputCount = data.messages.length;
        const successCount = result.data.messages.length;
        if (result.errors.length) {
            const uniqueErroredMessageTemplateIds = Array.from(new Set(result.errors.map((error)=>error.messageTemplateId)).values());
            result.errors.forEach((error)=>request.logger.error({
                    messageTemplateId: error.messageTemplateId,
                    messageInstanceId: error.messageInstanceId,
                    reason: error.reason
                }, 'error running message stage in placement'));
            request.logger.error({
                errors: result.errors,
                messageTemplateIds: uniqueErroredMessageTemplateIds,
                inputCount: inputCount,
                successCount: successCount
            }, 'errors running some messages in placement');
        }
        return result.data;
    };
const $684d224cca65ac06$export$3be438872ca64c45 = (messagesStages)=>{
    const messagesStagesByStageName = {};
    Object.entries(messagesStages).forEach(([messageTemplateId, messageStages])=>Object.entries(messageStages).forEach(([stageName, messageStage])=>{
            if (!messagesStagesByStageName?.[stageName]) messagesStagesByStageName[stageName] = {};
            const asAsyncMessageStage = async (params)=>messageStage(params);
            // We can use non null assertion as we initilize above
            messagesStagesByStageName[stageName][messageTemplateId] = asAsyncMessageStage;
        }));
    return messagesStagesByStageName;
};
// This should return a message context
const $684d224cca65ac06$var$identityMessageStage = async ({ message: message })=>message;
const $684d224cca65ac06$export$e43344e8c8930b68 = (stage)=>({ request: request, message: message })=>{
        const stageProcessor = stage?.[message.messageTemplateId] ?? $684d224cca65ac06$var$identityMessageStage;
        return stageProcessor({
            request: request,
            message: message
        });
    };
const $684d224cca65ac06$export$c86138aa03618dd1 = (messageStage)=>async ({ data: data, request: request })=>{
        const processMessage = async (message)=>messageStage({
                request: request,
                message: message
            });
        const promises = data.messages.map(processMessage);
        const results = await Promise.allSettled(promises);
        const messages = results.filter((settledResult)=>{
            return settledResult.status === 'fulfilled';
        }).map((e)=>e.value);
        const errors = results.map((settledResult, index)=>{
            if (settledResult.status === 'rejected') {
                const originalMessage = data.messages?.[index];
                const messageInstanceId = originalMessage?.messageInstanceId;
                const messageTemplateId = originalMessage?.messageTemplateId;
                return {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    ...settledResult
                };
            }
            return settledResult;
        }).filter((e)=>e.status === 'rejected').map(({ status: _status, ...rest })=>rest);
        return {
            data: {
                messages: messages
            },
            errors: errors
        };
    };
const $684d224cca65ac06$var$nameFunction = (name, fn)=>Object.defineProperty(fn, 'name', {
        value: name
    });

});


parcelRegister("cUvrS", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $309d49dc972ab544$export$bfba3ccd9d9038f9);

var $4rvk5 = parcelRequire("4rvk5");

var $eBPSW = parcelRequire("eBPSW");
const $309d49dc972ab544$export$bfba3ccd9d9038f9 = (0, $4rvk5.createWithI18n)((0, $eBPSW.messagesLoader));

});
parcelRegister("4rvk5", function(module, exports) {
$parcel$export(module.exports, "createWithI18n", () => $a87b72e102bfe212$export$d71c6502467fe725);

var $gt9Am = parcelRequire("gt9Am");

var $59rsN = parcelRequire("59rsN");

var $jKarX = parcelRequire("jKarX");
var $buEZY = parcelRequire("buEZY");
const $a87b72e102bfe212$export$920091e3d72d80ee = (loaders)=>{
    const messagesLoader = $a87b72e102bfe212$export$99ce90405b04bcbd(loaders);
    const I18n = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jKarX.IntlProvider), {
            messagesLoader: messagesLoader,
            children: children
        });
    return ({ children: children })=>{
        const isEnabled = (0, $59rsN.default).checkGate('post-office_placement-v2_i18n').valueOf();
        if (!isEnabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: children
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(I18n, {
            children: children
        });
    };
};
const $a87b72e102bfe212$export$d71c6502467fe725 = (config)=>{
    const messagesLoader = $a87b72e102bfe212$export$99ce90405b04bcbd(config);
    return (component)=>{
        const isEnabled = (0, $59rsN.default).checkGate('post-office_placement-v2_i18n');
        if (!isEnabled) return component;
        return (0, $buEZY.withIntlProvider)({
            messagesLoader: messagesLoader
        }, component);
    };
};
const $a87b72e102bfe212$export$99ce90405b04bcbd = (...loaders)=>async (locale)=>{
        const messagePromises = loaders.filter((e)=>!!e).map((loader)=>loader(locale));
        const loadedMessages = await Promise.allSettled(messagePromises);
        const translatedMessages = {
            messages: {},
            errors: []
        };
        loadedMessages.forEach((result)=>{
            if (result.status === 'rejected') {
                translatedMessages.errors.push(`Failed to load translations with ${result.reason}`);
                return;
            }
            translatedMessages.messages = {
                ...translatedMessages.messages,
                ...result.value
            };
        });
        return translatedMessages;
    };

});
parcelRegister("jKarX", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $21e40a5cd35ccaa3$export$480518999dfc4151);

var $gt9Am = parcelRequire("gt9Am");

var $gr4vM = parcelRequire("gr4vM");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $9oUFO = parcelRequire("9oUFO");
function $21e40a5cd35ccaa3$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $lRq8t.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $21e40a5cd35ccaa3$export$480518999dfc4151(props) {
    const { locale: locale } = $21e40a5cd35ccaa3$var$useFetchLocale();
    const messages = (0, $9oUFO.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("9oUFO", function(module, exports) {
$parcel$export(module.exports, "useIntlMessages", () => $6ddc6da8053822d1$export$2641ec9a2025a81f);

var $gr4vM = parcelRequire("gr4vM");

var $eJOHy = parcelRequire("eJOHy");
const $6ddc6da8053822d1$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $eJOHy.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};

});


parcelRegister("buEZY", function(module, exports) {
$parcel$export(module.exports, "withIntlProvider", () => $8d23eb31fbfaa7d5$export$a5d940130f33be3f);

var $gt9Am = parcelRequire("gt9Am");

var $jKarX = parcelRequire("jKarX");
const $8d23eb31fbfaa7d5$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jKarX.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    };

});


parcelRegister("eBPSW", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $574f531e7a92ca7e$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9pNb9 = parcelRequire("9pNb9");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $574f531e7a92ca7e$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $574f531e7a92ca7e$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("g3vnc")));
        case 'da':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("iikRs")));
        case 'de':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("6udAk")));
        case 'en-GB':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("bCZf6")));
        case 'en-US':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("1dx7S")));
        case 'en-XA':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("jwQ2n")));
        case 'en-XB':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("2oRj8")));
        case 'en-ZZ':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("iJ9qw")));
        case 'en':
            return $574f531e7a92ca7e$var$importHelper(await Promise.resolve((parcelRequire("9pNb9"))));
        case 'es':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("3Rauy")));
        case 'et':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("fv2yg")));
        case 'fi':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("dMpkN")));
        case 'fr':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("f0Z7H")));
        case 'hr':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("cwhJ0")));
        case 'hu':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("hsSxP")));
        case 'it':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("eZONt")));
        case 'ja':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("hY9ak")));
        case 'ko':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("fTreh")));
        case 'nb':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("irTMd")));
        case 'nl':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("C2bm3")));
        case 'pl':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("hR5a0")));
        case 'pt-BR':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("30gxY")));
        case 'ro':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("iHZU6")));
        case 'ru':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("3jfad")));
        case 'sl':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("9poBp")));
        case 'sr-RS':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("dvS9X")));
        case 'sr-YR':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("k8MVp")));
        case 'sr':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("jlXnh")));
        case 'sv':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("dH7g4")));
        case 'th':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("izx2E")));
        case 'tr':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("i6jal")));
        case 'uk':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("2sLwU")));
        case 'vi':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("1h3UY")));
        case 'zh-CN':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("057qB")));
        case 'zh-TW':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("jku5y")));
        case 'zh':
            return $574f531e7a92ca7e$var$importHelper(await (parcelRequire("057qB")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9pNb9));
    }
};

});
parcelRegister("9pNb9", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-itsm-template.jsm.title":[{"type":0,"value":"Collect IT requests"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"cross-flow-product-roadmap-template.jpd.title":[{"type":0,"value":"Create a roadmap"}],"cross-flow-work-requests-template.jsm.title":[{"type":0,"value":"Collect requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.admin-hub-recommendation.actions-heading":[{"type":0,"value":"Actions"}],"growth.admin-hub-recommendation.free-plan":[{"type":0,"value":"Free, cancel anytime"}],"growth.admin-hub-recommendation.heading":[{"type":0,"value":"Recommended based on your existing products"}],"growth.admin-hub-recommendation.plan-heading":[{"type":0,"value":"Plan"}],"growth.admin-hub-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluence-nudge-for-jira.action":[{"type":0,"value":"Accept invitation"}],"growth.confluence-nudge-for-jira.description":[{"type":0,"value":"Accept your invitation to make sure you\'re not missing any project updates."}],"growth.confluence-nudge-for-jira.title":[{"type":0,"value":"Your team invited you to Jira"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product":[{"type":0,"value":"TRY"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.page-template-description":[{"type":0,"value":"Draft plans and capture decisions"}],"growth.recommendation-confluence.page-template-title":[{"type":0,"value":"Project documentation"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-dynamic-description.value-proposition":[{"type":0,"value":"Plan, track, and organize any project"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-twc.confluence-apps-description":[{"type":0,"value":"Jira, video, and AI"}],"growth.recommendation-twc.confluence-apps-title":[{"type":0,"value":"Apps that click with Confluence"}],"growth.recommendation-twc.image-alt-text":[{"type":0,"value":"Rovo and Loom"}],"growth.recommendation-twc.jira-apps-description":[{"type":0,"value":"Add video and AI to Jira to work smarter."}],"growth.recommendation-twc.jira-apps-title":[{"type":0,"value":"Transform teamwork"}],"growth.recommendation-twc.twc-apps-description":[{"type":0,"value":"Docs, video, and agents in one place"}],"growth.recommendation-twc.twc-apps-non-tech-description":[{"type":0,"value":"Work 3x faster with connected tools"}],"growth.recommendation-twc.twc-apps-non-tech-lozenge":[{"type":0,"value":"New"}],"growth.recommendation-twc.twc-apps-non-tech-title":[{"type":0,"value":"Tools built for speed"}],"growth.recommendation-twc.twc-apps-tech-description":[{"type":0,"value":"Connect plans and docs using AI"}],"growth.recommendation-twc.twc-apps-tech-title":[{"type":0,"value":"A smarter way to work"}],"growth.recommendation-twc.twc-apps-title":[{"type":0,"value":"Work faster across tools"}],"growth.recommendation-twc.twc-image-alt-text":[{"type":0,"value":"Teamwork Collection"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.example-placement-quick-start.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.growth.jira-activation-project-recommendation.check-jira":[{"type":0,"value":"Check Jira"}],"post-office.growth.jira-activation-project-recommendation.hello-message":[{"type":0,"value":":wave: Hey "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"post-office.growth.jira-activation-project-recommendation.message-text":[{"type":0,"value":"Have you checked Jira lately? You may be missing out on important updates. Take a quick look to see if your team is using it to track any of your projects."}],"post-office.growth.jira-activation-project-recommendation.messages-exist":[{"type":0,"value":"Don\u2019t forget to get caught up on your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"project"}]},"other":{"value":[{"type":0,"value":"projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":" in Jira! Take a quick look to get up-to-date on your teammates\u2019 progress."}],"post-office.growth.jira-activation-project-recommendation.see-projects":[{"type":0,"value":"See all projects"}],"post-office.growth.jira-activation-project-recommendation.you-have-messages":[{"offset":0,"options":{"=0":{"value":[]},"=1":{"value":[]},"=2":{"value":[{"type":0,"value":"You have *two projects*:"}]},"=3":{"value":[{"type":0,"value":"You have *three projects*:"}]},"other":{"value":[{"type":0,"value":"You have *"},{"options":{"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects*. Here are three to get you started:"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects":[{"type":0,"value":":wave: Just a heads up \u2014 you have *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one project"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":"* assigned to you with new work items you haven\'t checked out yet."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items":[{"type":0,"value":":wave: Just a heads up \u2014 you were assigned "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"a work item in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]},"other":{"value":[{"type":0,"value":"some work items in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":" over three days ago."}],"post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message":[{"type":0,"value":"You\'ve got *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one item"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfWorkItems"}]}},"type":5,"value":"numberOfWorkItems"},{"type":0,"value":" items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":"* to check on \u2014 here are three:"}],"post-office.growth.jira-assigned-nudge-digest.plural-cta-message":[{"type":0,"value":"See inactive "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"item"}]},"other":{"value":[{"type":0,"value":"items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"}],"post-office.growth.jira-assigned-nudge-digest.top-projects-message":[{"type":0,"value":"Here are three to get you started:"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-projects-recommendations.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-projects-recommendations.cta-button-lozenge-try":[{"type":0,"value":"Try"}],"post-office.nav-4-projects-recommendations.dropdown-menu-open-label":[{"type":0,"value":"Open"}],"post-office.nav-4-projects-recommendations.section-heading":[{"type":0,"value":"Recommended"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("g3vnc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6NkZD").then(()=>parcelRequire('lvNV3'));

});

parcelRegister("iikRs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g2304").then(()=>parcelRequire('6uQPF'));

});

parcelRegister("6udAk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7hLu6").then(()=>parcelRequire('iPgAq'));

});

parcelRegister("bCZf6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Bzhe").then(()=>parcelRequire('5awd2'));

});

parcelRegister("1dx7S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("znNxD").then(()=>parcelRequire('74zHr'));

});

parcelRegister("jwQ2n", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("XreJj").then(()=>parcelRequire('hb5zJ'));

});

parcelRegister("2oRj8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gcjx2").then(()=>parcelRequire('38Ys8'));

});

parcelRegister("iJ9qw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cb7bI").then(()=>parcelRequire('f2iAx'));

});

parcelRegister("3Rauy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j2ffl").then(()=>parcelRequire('6Hcwg'));

});

parcelRegister("fv2yg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1kDVI").then(()=>parcelRequire('20hKC'));

});

parcelRegister("dMpkN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("0hAWq").then(()=>parcelRequire('yL7Pr'));

});

parcelRegister("f0Z7H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jpjSn").then(()=>parcelRequire('fyBKV'));

});

parcelRegister("cwhJ0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hfUJY").then(()=>parcelRequire('1bJIp'));

});

parcelRegister("hsSxP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("SyZiC").then(()=>parcelRequire('d47cs'));

});

parcelRegister("eZONt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7uNm4").then(()=>parcelRequire('cJQsR'));

});

parcelRegister("hY9ak", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1yyeS").then(()=>parcelRequire('lsY4K'));

});

parcelRegister("fTreh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hC8hF").then(()=>parcelRequire('8vWFf'));

});

parcelRegister("irTMd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("63E9Q").then(()=>parcelRequire('asGYW'));

});

parcelRegister("C2bm3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7YL1p").then(()=>parcelRequire('GquUU'));

});

parcelRegister("hR5a0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("52td4").then(()=>parcelRequire('gUUmV'));

});

parcelRegister("30gxY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7upe4").then(()=>parcelRequire('cHdJi'));

});

parcelRegister("iHZU6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6CboQ").then(()=>parcelRequire('7YG4M'));

});

parcelRegister("3jfad", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eZKm4").then(()=>parcelRequire('cnifX'));

});

parcelRegister("9poBp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aVyUQ").then(()=>parcelRequire('dk3Kn'));

});

parcelRegister("dvS9X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lx14I").then(()=>parcelRequire('1n1NS'));

});

parcelRegister("k8MVp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ieMKQ").then(()=>parcelRequire('aUjws'));

});

parcelRegister("jlXnh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6o8th").then(()=>parcelRequire('78yGu'));

});

parcelRegister("dH7g4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("JJCFM").then(()=>parcelRequire('eI0S6'));

});

parcelRegister("izx2E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1iJco").then(()=>parcelRequire('7e8SU'));

});

parcelRegister("i6jal", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1pXoy").then(()=>parcelRequire('7kXdD'));

});

parcelRegister("2sLwU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3VsAL").then(()=>parcelRequire('e6XZn'));

});

parcelRegister("1h3UY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("UFKY9").then(()=>parcelRequire('7niOW'));

});

parcelRegister("057qB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bu2ao").then(()=>parcelRequire('1L7Vq'));

});

parcelRegister("jku5y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7S32B").then(()=>parcelRequire('2S0Ei'));

});




parcelRegister("1gHmu", function(module, exports) {
$parcel$export(module.exports, "PostOfficeProvider", () => $aa6d0b2a252623bf$export$fb465b6e855c1e85);
$parcel$export(module.exports, "PostOfficeRouterListener", () => $aa6d0b2a252623bf$export$9f8d3084fd3d5fc0);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $4cTDP = parcelRequire("4cTDP");

var $7oY9g = parcelRequire("7oY9g");

var $eWzpp = parcelRequire("eWzpp");

var $g9Vr6 = parcelRequire("g9Vr6");

var $f2sjT = parcelRequire("f2sjT");

var $1BZ8a = parcelRequire("1BZ8a");

var $cHtIB = parcelRequire("cHtIB");

var $kyq27 = parcelRequire("kyq27");

var $8rGQ0 = parcelRequire("8rGQ0");

var $1M2hR = parcelRequire("1M2hR");

var $gxASd = parcelRequire("gxASd");
var $ffYuk = parcelRequire("ffYuk");

var $gCY1z = parcelRequire("gCY1z");

var $kAwwe = parcelRequire("kAwwe");

var $dCq6B = parcelRequire("dCq6B");

var $goNRN = parcelRequire("goNRN");

var $42nVO = parcelRequire("42nVO");
const $aa6d0b2a252623bf$var$JiraPostOfficeProvider = ({ children: children })=>{
    const { data: data } = (0, $eWzpp.useProject)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const locale = (0, $1M2hR.useLocale)();
    const environment = (0, $kyq27.useEnvironment)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const editions = (0, $1BZ8a.useAppEditions)();
    const subproduct = data?.type;
    const edition = (0, $dCq6B.subproductToEdition)(subproduct, editions);
    const additionalContext = (0, $eJOHy.useContext)((0, $goNRN.CrossFlowPostOfficeContext));
    const context = (0, $eJOHy.useMemo)(()=>{
        return {
            current: {
                ...(0, $dCq6B.tenantToPostOfficeContext)({
                    activationId: activationId,
                    cloudId: cloudId,
                    isAdmin: isAdmin,
                    isSiteAdmin: isSiteAdmin,
                    locale: locale
                }),
                orgId: orgId,
                productEdition: edition || undefined,
                subproduct: subproduct,
                ...(0, $4cTDP.fg)('jira_xflow_quick_actions') ? additionalContext : {},
                ...(0, $4cTDP.fg)('jira-onboarding-hub-gate') ? (0, $42nVO.getOnboardingParams)() : {}
            }
        };
    }, [
        cloudId,
        orgId,
        activationId,
        subproduct,
        isSiteAdmin,
        isAdmin,
        locale,
        edition,
        additionalContext
    ]);
    const env = (0, $eJOHy.useMemo)(()=>({
            env: (0, $dCq6B.transformJiraEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gxASd.PostOfficeProvider), {
        context: context,
        environment: env
    }, children);
};
const $aa6d0b2a252623bf$export$fb465b6e855c1e85 = ({ children: children })=>{
    // Using the Feature Gate used for the placement app-switcher-discovery-section because PostOfficeProvider is always needed when the app-switcher-discovery-section is enabled
    const isPostOfficeEnabled = !(0, $7oY9g.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "postOfficeJiraProvider",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa6d0b2a252623bf$var$JiraPostOfficeProvider, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $aa6d0b2a252623bf$var$ReactResourceRouterListener = ({ children: children })=>{
    const [route] = (0, $gCY1z.useRouter)();
    (0, $ffYuk.usePostOfficeRouteUpdate)([
        route.basePath,
        route.location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $aa6d0b2a252623bf$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    const isPostOfficeEnabled = !(0, $7oY9g.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled && (0, $4cTDP.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa6d0b2a252623bf$var$ReactResourceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};

});
parcelRegister("kyq27", function(module, exports) {
$parcel$export(module.exports, "useEnvironment", () => $3308bdf614fc7dbd$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $3308bdf614fc7dbd$export$b0d8f74f433a09c9);

var $koAZ4 = parcelRequire("koAZ4");
const $3308bdf614fc7dbd$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $3308bdf614fc7dbd$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext?.environment || $3308bdf614fc7dbd$var$ENVIRONMENT.PROD;
};
const $3308bdf614fc7dbd$export$b0d8f74f433a09c9 = ()=>{
    const env = $3308bdf614fc7dbd$export$ea7ed2425832167d();
    return env === $3308bdf614fc7dbd$var$ENVIRONMENT.STAGING || env === $3308bdf614fc7dbd$var$ENVIRONMENT.DEV || env === $3308bdf614fc7dbd$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("gxASd", function(module, exports) {
$parcel$export(module.exports, "PostOfficeProvider", () => $f5c06cb092f756ad$export$fb465b6e855c1e85);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e7Wsy = parcelRequire("e7Wsy");

var $8QoO2 = parcelRequire("8QoO2");

var $eGOwo = parcelRequire("eGOwo");

var $6a4LK = parcelRequire("6a4LK");

var $dWans = parcelRequire("dWans");

var $hJWuA = parcelRequire("hJWuA");

var $ffYuk = parcelRequire("ffYuk");

var $h60js = parcelRequire("h60js");

var $5V25X = parcelRequire("5V25X");

var $eOlnh = parcelRequire("eOlnh");

var $iJJ9P = parcelRequire("iJJ9P");

var $buZp4 = parcelRequire("buZp4");

var $PBnxQ = parcelRequire("PBnxQ");
const $f5c06cb092f756ad$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
    const stableEnvironment = (0, $eOlnh.useStableObject)((0, $buZp4.generateEnvironmentConfigWithOverrides)((0, $dWans.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $eOlnh.useStableObject)($f5c06cb092f756ad$var$composeConfig((0, $6a4LK.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $eJOHy.useMemo)(()=>(0, $iJJ9P.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f5c06cb092f756ad$var$MaybePostOfficeCacheProvider, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWans.PostOfficeEnvironmentProvider), {
            value: stableEnvironment,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6a4LK.InternalPostOfficeContextProvider), {
                value: stableContext,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h60js.PostOfficeScreenContextProvider), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iJJ9P.MessagePlacementProvider), {
                        value: memoizedMessagePlacementValues,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ffYuk.RouteListenerProvider), {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5V25X.TriggerContextProvider), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)($f5c06cb092f756ad$var$MaybeAnalyticsListener, {
                                    children: children
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
const $f5c06cb092f756ad$var$swrConfig = {
    provider: (0, $PBnxQ.localStorageCacheProvider),
    use: [
        (0, $PBnxQ.postOfficeCacheMiddleware)
    ]
};
const $f5c06cb092f756ad$var$MaybePostOfficeCacheProvider = ({ children: children })=>{
    if ((0, $eGOwo.fg)('post-office-use-placement-with-client')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e7Wsy.SWRConfig), {
        value: $f5c06cb092f756ad$var$swrConfig,
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $f5c06cb092f756ad$var$MaybeAnalyticsListener = ({ children: children })=>{
    if ((0, $eGOwo.fg)('post-office-analytics-listener-enabled')) {
        const { handleEvent: handleEvent } = (0, $hJWuA.postOfficeGasv3ListenerStore);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
            channel: "*",
            onEvent: handleEvent,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $f5c06cb092f756ad$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });

});
parcelRegister("hJWuA", function(module, exports) {
$parcel$export(module.exports, "postOfficeGasv3ListenerStore", () => $4b1d8d2431ff50f6$export$19b95495a42be187);

var $ee5Jg = parcelRequire("ee5Jg");
const $4b1d8d2431ff50f6$var$createPostOfficeGasv3ListenerStore = ()=>{
    const subscribers = new Map();
    const handleEvent = (event)=>{
        subscribers.forEach((callback, matcher)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ee5Jg)))(event.payload, matcher)) callback();
        });
    };
    const subscribe = (matcher, callback)=>{
        subscribers.set(matcher, callback);
        return ()=>{
            subscribers.delete(matcher);
        };
    };
    return {
        subscribe: subscribe,
        handleEvent: handleEvent
    };
};
const $4b1d8d2431ff50f6$export$19b95495a42be187 = $4b1d8d2431ff50f6$var$createPostOfficeGasv3ListenerStore();

});

parcelRegister("ffYuk", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeRouteUpdate", () => $2f15309894f6978c$export$bb606326acdd1a64);
$parcel$export(module.exports, "RouteListenerProvider", () => $2f15309894f6978c$export$31986273b686f5ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $72OLU = parcelRequire("72OLU");

var $lwEYg = parcelRequire("lwEYg");
const $2f15309894f6978c$var$noop = ()=>{};
const $2f15309894f6978c$var$RouteListenerContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    update: $2f15309894f6978c$var$noop
});
const $2f15309894f6978c$export$7a2084f4baac29a7 = ()=>(0, $72OLU.createSimplePubSub)();
const $2f15309894f6978c$export$72fd8977abf03d60 = ()=>(0, $eJOHy.useContext)($2f15309894f6978c$var$RouteListenerContext);
const $2f15309894f6978c$export$755edb1665399d41 = ()=>{
    const ref = (0, $eJOHy.useRef)();
    if (!ref.current) ref.current = $2f15309894f6978c$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $eJOHy.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $eJOHy.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $2f15309894f6978c$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $2f15309894f6978c$export$72fd8977abf03d60();
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $2f15309894f6978c$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $2f15309894f6978c$export$755edb1665399d41();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2f15309894f6978c$var$RouteListenerContext.Provider, {
        value: routeUpdater,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lwEYg.PostOfficeRouteProvider), {
            ...route,
            children: children
        })
    });
};

});
parcelRegister("72OLU", function(module, exports) {
$parcel$export(module.exports, "createSimplePubSub", () => $2f237bdf10a187ec$export$92469b55607f005b);
const $2f237bdf10a187ec$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});


parcelRegister("buZp4", function(module, exports) {
$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $22cd6bb4e2b01f88$export$ae3dab16eb1fc2cc);
const $22cd6bb4e2b01f88$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});

parcelRegister("PBnxQ", function(module, exports) {
$parcel$export(module.exports, "localStorageCacheProvider", () => $a3fe728865749cb0$export$54eb3e634424b746);
$parcel$export(module.exports, "postOfficeCacheMiddleware", () => $a3fe728865749cb0$export$711c5bb855c82238);

var $eJOHy = parcelRequire("eJOHy");

var $5dwQF = parcelRequire("5dwQF");

var $aOPCi = parcelRequire("aOPCi");
const $a3fe728865749cb0$var$STORAGE_KEY = 'POST_OFFICE__CLIENT_CACHE';
const $a3fe728865749cb0$var$CACHE_KEY = 'placement-api';
const $a3fe728865749cb0$var$CACHE_EXPIRY = 120000; // 2 minutes
const $a3fe728865749cb0$var$storageClient = new (0, $aOPCi.default)($a3fe728865749cb0$var$STORAGE_KEY);
const $a3fe728865749cb0$export$3c979fbaa76beaf9 = (cache)=>{
    if (cache instanceof Map && cache.size > 0) {
        const existingCache = $a3fe728865749cb0$export$54eb3e634424b746();
        const mergedCache = new Map([
            ...existingCache,
            ...cache
        ]);
        const appCache = Array.from(mergedCache.entries());
        // localStorage.getItem("POST_OFFICE__CLIENT_CACHE_placement-api")
        $a3fe728865749cb0$var$storageClient.setItemWithExpiry($a3fe728865749cb0$var$CACHE_KEY, appCache, $a3fe728865749cb0$var$CACHE_EXPIRY);
    }
};
const $a3fe728865749cb0$export$54eb3e634424b746 = ()=>{
    if (typeof window === 'undefined') // Return a dummy storage for server-side rendering
    return new Map();
    // When initializing, we restore the data from `localStorage` into a map.
    const cache = $a3fe728865749cb0$var$storageClient.getItem($a3fe728865749cb0$var$CACHE_KEY) || [];
    return new Map(cache);
};
const $a3fe728865749cb0$export$711c5bb855c82238 = (useSWRNext)=>{
    return (key, fetcher, config)=>{
        const { cache: cache } = (0, $5dwQF.useSWRConfig)();
        const swr = useSWRNext(key, fetcher, config);
        /**
		 * This will execute even when data is pulled from the local storage cache.
		 * This means that the cache will be updated and the CACHE_EXPIRY reset to be a rolling window.
		 *
		 * We may want to change this behaviour in the future to only update the cache when the data is NOT pulled from the local storage cache.
		 */ (0, $eJOHy.useEffect)(()=>{
            if (swr.data !== undefined) $a3fe728865749cb0$export$3c979fbaa76beaf9(cache);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            swr.data
        ]);
        return swr;
    };
};

});


parcelRegister("goNRN", function(module, exports) {
$parcel$export(module.exports, "CrossFlowPostOfficeContext", () => $203de4cdbe788221$export$2e4aec418d6136f);
$parcel$export(module.exports, "CrossFlowPostOfficeProvider", () => $203de4cdbe788221$export$de3f510d70d6c70c);

var $eJOHy = parcelRequire("eJOHy");

var $kAwwe = parcelRequire("kAwwe");

var $bEiQD = parcelRequire("bEiQD");

var $5EgB1 = parcelRequire("5EgB1");

var $dyOHn = parcelRequire("dyOHn");

var $6d9QY = parcelRequire("6d9QY");

var $1Ru5V = parcelRequire("1Ru5V");

var $k3AHU = parcelRequire("k3AHU");

var $8rGQ0 = parcelRequire("8rGQ0");

var $4gH2A = parcelRequire("4gH2A");
const $203de4cdbe788221$export$2e4aec418d6136f = /*#__PURE__*/ (0, $eJOHy.createContext)({
    loomTouchpointVariant: null,
    isAdmin: null,
    isOrgAdmin: null,
    hasActiveJpdLicense: null,
    tenantHasConfluence: null,
    canProvisionConfluenceEndUser: null,
    areProductSuggestionsEnabled: null,
    isAiEligibleAndTriggered: null
});
const $203de4cdbe788221$export$de3f510d70d6c70c = ({ children: children, loomTouchpointVariant: loomTouchpointVariant, isAiEligibleAndTriggered: isAiEligibleAndTriggered })=>{
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const tenantHasConfluence = licensedProducts?.confluence === true;
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const { canProvisionConfluenceEndUser: canProvisionConfluenceEndUser } = (0, $k3AHU.useUserHasAddProductPermissions)({
        skip: isSiteAdmin || tenantHasConfluence
    });
    const areProductSuggestionsEnabled = (0, $4gH2A.useAreProductSuggestionsEnabled)();
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const hasActiveJpdLicense = (0, $dyOHn.useSelector)((0, $5EgB1.tenantHasActiveProductDiscoveryLicenseSelector));
    // isOrgAdmin is fetched from an api call and the initial value of loading is false
    // so it changes from false to true and then back to false
    // we need to wait for the loading to be true and then false again before we can render the children
    // this is to avoid re render of post office placement
    // to achieve this, we use usePrevious hook to check the previous value of isOrgAdminLoading
    // and only render the children when the previous value is true and the current value is false
    const { isOrgAdmin: isOrgAdmin, loading: isOrgAdminLoading } = (0, $bEiQD.useIsOrgAdmin)();
    const previousIsOrgAdminLoading = (0, $6d9QY.usePreviousPersistent)(isOrgAdminLoading);
    const context = (0, $eJOHy.useMemo)(()=>{
        return {
            loomTouchpointVariant: loomTouchpointVariant,
            isAdmin: isAdmin,
            isOrgAdmin: isOrgAdmin,
            hasActiveJpdLicense: hasActiveJpdLicense,
            tenantHasConfluence: tenantHasConfluence,
            canProvisionConfluenceEndUser: canProvisionConfluenceEndUser,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            isAiEligibleAndTriggered: !!isAiEligibleAndTriggered
        };
    }, [
        loomTouchpointVariant,
        isAdmin,
        isOrgAdmin,
        hasActiveJpdLicense,
        tenantHasConfluence,
        canProvisionConfluenceEndUser,
        areProductSuggestionsEnabled,
        isAiEligibleAndTriggered
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($203de4cdbe788221$export$2e4aec418d6136f.Provider, {
        value: context
    }, previousIsOrgAdminLoading && !isOrgAdminLoading && children);
};

});
parcelRegister("5EgB1", function(module, exports) {
$parcel$export(module.exports, "contextSelector", () => $8996f8462702b38d$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $8996f8462702b38d$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $8996f8462702b38d$export$24984a39db14d8);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $8996f8462702b38d$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $8996f8462702b38d$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $8996f8462702b38d$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $8996f8462702b38d$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $8996f8462702b38d$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $8996f8462702b38d$export$b5a643cfff945455);
$parcel$export(module.exports, "issueAriSelector", () => $8996f8462702b38d$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "commentAriSelector", () => $8996f8462702b38d$export$b600fd41c88f35c8);
$parcel$export(module.exports, "isAnonymousSelector", () => $8996f8462702b38d$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $8996f8462702b38d$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $8996f8462702b38d$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $8996f8462702b38d$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $8996f8462702b38d$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $8996f8462702b38d$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $8996f8462702b38d$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $8996f8462702b38d$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $8996f8462702b38d$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $8996f8462702b38d$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $8996f8462702b38d$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $8996f8462702b38d$export$93badd2a066af8bd);
$parcel$export(module.exports, "appPermissionsSelector", () => $8996f8462702b38d$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $8996f8462702b38d$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $8996f8462702b38d$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $8996f8462702b38d$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $8996f8462702b38d$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $8996f8462702b38d$export$96c87532aec3474a);
$parcel$export(module.exports, "tenantHasActiveProductDiscoveryLicenseSelector", () => $8996f8462702b38d$export$f049ad7141428191);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $8996f8462702b38d$export$2b8e6729c89e24f5);
$parcel$export(module.exports, "hasActivatedConfluenceWithinThirtyDaysSelector", () => $8996f8462702b38d$export$2321d15582b8ce8a);

var $ahm5r = parcelRequire("ahm5r");

var $1xngw = parcelRequire("1xngw");
var $lR3AG = parcelRequire("lR3AG");
var $kQ82p = parcelRequire("kQ82p");
var $2InI0 = parcelRequire("2InI0");
var $iux1t = parcelRequire("iux1t");

var $5KtrL = parcelRequire("5KtrL");


var $aYncF = parcelRequire("aYncF");

var $dNyY6 = parcelRequire("dNyY6");

var $8oOr4 = parcelRequire("8oOr4");

var $2QZBX = parcelRequire("2QZBX");

var $8oKDI = parcelRequire("8oKDI");
const $8996f8462702b38d$export$c420c9f40402ab6d = (state)=>state.context;
const $8996f8462702b38d$export$cb29341089829e17 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $8996f8462702b38d$export$24984a39db14d8 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $8996f8462702b38d$export$767583fcce1653ec = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $8996f8462702b38d$export$d22bc6271070f453 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.issueKey);
const $8996f8462702b38d$export$31efbca30077ec1e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.issueId);
const $8996f8462702b38d$export$404de5ac601b84bc = (0, $ahm5r.createSelector)($8996f8462702b38d$export$d22bc6271070f453, (issueKey)=>(0, $dNyY6.extractProjectKey)(issueKey));
const $8996f8462702b38d$export$85a9d212d56669b4 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $8996f8462702b38d$export$b5a643cfff945455 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.cloudId || '');
const $8996f8462702b38d$export$a2cdbba2136e72d3 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$b5a643cfff945455, $8996f8462702b38d$export$31efbca30077ec1e, (cloudId, issueId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    }));
const $8996f8462702b38d$export$b600fd41c88f35c8 = (commentId)=>(0, $ahm5r.createSelector)($8996f8462702b38d$export$b5a643cfff945455, $8996f8462702b38d$export$31efbca30077ec1e, (cloudId, issueId)=>`ari:cloud:jira:${cloudId}:issue-comment/${issueId ?? ''}/${commentId}`);
const $8996f8462702b38d$export$2335b963a9875096 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $2QZBX.toActivationId)(''));
const $8996f8462702b38d$export$a165ec261432d0b8 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $8996f8462702b38d$export$f7b7935883444b11 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.locale);
const $8996f8462702b38d$export$b62cb5286b153905 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $8996f8462702b38d$export$6c7d07328f197de7 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $8996f8462702b38d$export$4cbb8c74e98876a5 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$8996f8462702b38d$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $1791521efc556332$export$ce88447986394f2d));
const $8996f8462702b38d$export$6fbe1dbaf5b67cc5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $8oOr4.standardRoadmapConfiguration)().applicationKey);
const $8996f8462702b38d$export$7479ef2453efd3b4 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.softwareConfiguration)().applicationKey);
const $8996f8462702b38d$export$245e5ba54167b84a = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$8996f8462702b38d$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $1791521efc556332$export$7552fe2669628499));
const $8996f8462702b38d$export$43d733e4b7e8c7d0 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.serviceDeskConfiguration)().applicationKey);
const $8996f8462702b38d$export$9bffc1987c753bd9 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $8996f8462702b38d$export$718e830000b27a0e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $8996f8462702b38d$export$8065de5fbcf23af5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $8996f8462702b38d$export$5af08fd769c0f0 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.boardType);
const $8996f8462702b38d$export$955e7dbf76b61f80 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.boardId);
const $8996f8462702b38d$export$93badd2a066af8bd = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $8996f8462702b38d$export$b468116a08f9183e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $8996f8462702b38d$export$f29192b357e6beca = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $8996f8462702b38d$export$5b71e1eb43056b6c = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $8996f8462702b38d$export$5fa593caa6a15917 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.isModal);
const $8996f8462702b38d$export$631793d49dec78de = (0, $ahm5r.createSelector)($8996f8462702b38d$export$5fa593caa6a15917, $8996f8462702b38d$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $8996f8462702b38d$export$1f11fe78e4f22d45 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $8996f8462702b38d$export$28ca74e18c8f4529 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $8996f8462702b38d$export$beea798086c18f0a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $8996f8462702b38d$export$40487a15195e570e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $5KtrL.LICENSE_STATE_ACTIVE));
const $8996f8462702b38d$export$96c87532aec3474a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$f29192b357e6beca, $8996f8462702b38d$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $8996f8462702b38d$export$2fa17c0746682b0b = (0, $ahm5r.createSelector)($8996f8462702b38d$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.productDiscovery === (0, $5KtrL.LICENSE_STATE_ACTIVE));
const $8996f8462702b38d$export$f049ad7141428191 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$f29192b357e6beca, $8996f8462702b38d$export$2fa17c0746682b0b, (licensedProducts, isProductDiscoveryLicenseActive)=>Boolean(licensedProducts && licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_PRODUCT_DISCOVERY] && isProductDiscoveryLicenseActive));
const $8996f8462702b38d$export$747a61878b414bda = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $8996f8462702b38d$export$2b8e6729c89e24f5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $1xngw.default)(new Date());
        const fourteenDaysAgo = (0, $2InI0.default)((0, $iux1t.default)(today, 14));
        const dateToCheck = (0, $kQ82p.default)(confluenceActivationDate);
        return (0, $lR3AG.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});
const $8996f8462702b38d$export$2321d15582b8ce8a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $1xngw.default)(new Date());
        const thirtyDaysAgo = (0, $2InI0.default)((0, $iux1t.default)(today, 31)); // 31 days to account for the 30 day trial
        const dateToCheck = (0, $kQ82p.default)(confluenceActivationDate);
        return (0, $lR3AG.default)(dateToCheck, {
            start: thirtyDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});

});
parcelRegister("8oOr4", function(module, exports) {
$parcel$export(module.exports, "ISSUE_TYPE", () => $78be9cd6dc1a4416$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $78be9cd6dc1a4416$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $78be9cd6dc1a4416$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $78be9cd6dc1a4416$export$289917d9a7031e1d);
$parcel$export(module.exports, "SECURITY", () => $78be9cd6dc1a4416$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ASSIGNEE", () => $78be9cd6dc1a4416$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $78be9cd6dc1a4416$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $78be9cd6dc1a4416$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $78be9cd6dc1a4416$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $78be9cd6dc1a4416$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $78be9cd6dc1a4416$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $78be9cd6dc1a4416$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $78be9cd6dc1a4416$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $78be9cd6dc1a4416$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $78be9cd6dc1a4416$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $78be9cd6dc1a4416$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $78be9cd6dc1a4416$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $78be9cd6dc1a4416$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $78be9cd6dc1a4416$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $78be9cd6dc1a4416$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $78be9cd6dc1a4416$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $78be9cd6dc1a4416$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $78be9cd6dc1a4416$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $78be9cd6dc1a4416$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $78be9cd6dc1a4416$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $78be9cd6dc1a4416$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $78be9cd6dc1a4416$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $78be9cd6dc1a4416$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $78be9cd6dc1a4416$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $78be9cd6dc1a4416$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $78be9cd6dc1a4416$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $78be9cd6dc1a4416$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $78be9cd6dc1a4416$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $78be9cd6dc1a4416$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $78be9cd6dc1a4416$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $78be9cd6dc1a4416$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $78be9cd6dc1a4416$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $78be9cd6dc1a4416$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $78be9cd6dc1a4416$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $78be9cd6dc1a4416$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $78be9cd6dc1a4416$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $78be9cd6dc1a4416$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $78be9cd6dc1a4416$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $78be9cd6dc1a4416$export$902f6c5cc939598a);

var $hGkL7 = parcelRequire("hGkL7");

var $FhXEJ = parcelRequire("FhXEJ");

var $4cTDP = parcelRequire("4cTDP");

var $3mZMJ = parcelRequire("3mZMJ");
const $78be9cd6dc1a4416$export$ebb48b08205007c5 = 'issuetype';
const $78be9cd6dc1a4416$export$a464614f8f5fe986 = 'summary';
const $78be9cd6dc1a4416$export$a311a3c9b207604e = 'parent';
const $78be9cd6dc1a4416$export$289917d9a7031e1d = 'watches';
const $78be9cd6dc1a4416$export$72a5630aa398d6b4 = 'security';
const $78be9cd6dc1a4416$export$caf1ff54fbdf44bf = 'issuerestriction';
const $78be9cd6dc1a4416$export$f8f7545d2bb78afb = 'assignee';
const $78be9cd6dc1a4416$export$6d7021166edc895c = 'reporter';
const $78be9cd6dc1a4416$export$cf7e173386d30cdd = 'duedate';
const $78be9cd6dc1a4416$export$bb34f3538ba26c7e = 'priority';
const $78be9cd6dc1a4416$export$79b91d4669dcadcb = 'labels';
const $78be9cd6dc1a4416$export$cbedbfe2cd0caec7 = 'components';
const $78be9cd6dc1a4416$export$a316570a0dbfd2b0 = 'sprint';
const $78be9cd6dc1a4416$export$405b6d72f2d243a9 = 'storyPointsField';
const $78be9cd6dc1a4416$export$3cb4a99a332e4186 = 'epic';
const $78be9cd6dc1a4416$export$d7e18f5730074533 = 'fixVersions';
const $78be9cd6dc1a4416$export$c435f0000304e508 = 'versions';
const $78be9cd6dc1a4416$export$ee99ef6ee562a446 = 'timetracking';
const $78be9cd6dc1a4416$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $78be9cd6dc1a4416$export$e50006273435e7d4 = 'status';
const $78be9cd6dc1a4416$export$ff39ebd4bb12b718 = 'created';
const $78be9cd6dc1a4416$export$cd8e68094cb5c3cb = 'updated';
const $78be9cd6dc1a4416$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $78be9cd6dc1a4416$export$913055729e1380b2 = 'summary';
const $78be9cd6dc1a4416$export$d44826c816b5619b = 'description';
const $78be9cd6dc1a4416$export$a29989082612d0d9 = 'comment';
const $78be9cd6dc1a4416$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $78be9cd6dc1a4416$export$3b3d0889022c85b3 = 'children-issues';
const $78be9cd6dc1a4416$export$be46596bc6608f3b = 'environment';
const $78be9cd6dc1a4416$export$f528fadbfdb3c25e = 'subtasks';
const $78be9cd6dc1a4416$export$f10e53e8928b61bd = 'dataclassification';
const $78be9cd6dc1a4416$export$e0dfb65d1047c53c = (0, $3mZMJ.PARENT_CF_TYPE);
const $78be9cd6dc1a4416$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $78be9cd6dc1a4416$export$826d657005bbe54c = (0, $3mZMJ.SELECT_CF_TYPE);
const $78be9cd6dc1a4416$export$cdbd1eb3b05729e0 = 'flagActions';
const $78be9cd6dc1a4416$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78be9cd6dc1a4416$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$78be9cd6dc1a4416$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$78be9cd6dc1a4416$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$78be9cd6dc1a4416$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $3mZMJ.TEAM_CF_TYPE)]: (0, $3mZMJ.TEAM_CF_TYPE),
        [(0, $3mZMJ.PARENT_CF_TYPE)]: (0, $3mZMJ.PARENT_CF_TYPE),
        [(0, $3mZMJ.BASELINE_START_CF_TYPE)]: (0, $3mZMJ.BASELINE_START_CF_TYPE),
        [(0, $3mZMJ.BASELINE_END_CF_TYPE)]: (0, $3mZMJ.BASELINE_END_CF_TYPE),
        [(0, $3mZMJ.COLOR_CF_TYPE)]: (0, $3mZMJ.COLOR_CF_TYPE),
        [(0, $3mZMJ.EPIC_COLOR_TYPE)]: (0, $3mZMJ.EPIC_COLOR_TYPE),
        [(0, $3mZMJ.EPIC_NAME_TYPE)]: (0, $3mZMJ.EPIC_NAME_TYPE)
    };
    return fields;
};
const $78be9cd6dc1a4416$export$87934b3672715c91 = [
    (0, $3mZMJ.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $3mZMJ.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $3mZMJ.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $3mZMJ.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $78be9cd6dc1a4416$var$serviceDeskCustomFields = [
    (0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $3mZMJ.ORGANIZATIONS_CF_TYPE),
    (0, $3mZMJ.REQUEST_LANGUAGE_CF_TYPE),
    (0, $3mZMJ.REQUEST_FEEDBACK_CF_TYPE),
    (0, $3mZMJ.APPROVALS_CF_TYPE),
    (0, $3mZMJ.APPROVERS_LIST_CF_TYPE),
    (0, $3mZMJ.REQUEST_TYPE_CF_TYPE),
    (0, $3mZMJ.CMDB_OBJECT_CF_TYPE),
    (0, $3mZMJ.RESPONDERS_CF_TYPE),
    (0, $3mZMJ.MAJOR_INCIDENT_CF_TYPE),
    (0, $3mZMJ.ENTITLEMENT_CF_TYPE),
    (0, $3mZMJ.SENTIMENT_CF_TYPE),
    (0, $3mZMJ.ORGANIZATION_CF_TYPE)
];
const $78be9cd6dc1a4416$export$efd443bccc4c01ed = ()=>[
        (0, $3mZMJ.LABELS_CF_TYPE),
        (0, $3mZMJ.TEXT_CF_TYPE),
        (0, $3mZMJ.MULTI_USER_CF_TYPE),
        (0, $3mZMJ.PARTICIPANTS_CF_TYPE),
        (0, $3mZMJ.URL_CF_TYPE),
        (0, $3mZMJ.NUMBER_CF_TYPE),
        (0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $3mZMJ.SELECT_CF_TYPE),
        (0, $3mZMJ.MULTI_SELECT_CF_TYPE),
        (0, $3mZMJ.VERSION_CF_TYPE),
        (0, $3mZMJ.TEXT_AREA_CF_TYPE),
        (0, $3mZMJ.MULTI_VERSION_CF_TYPE),
        (0, $3mZMJ.DATE_CF_TYPE),
        (0, $3mZMJ.GROUP_CF_TYPE),
        (0, $3mZMJ.MULTI_GROUP_CF_TYPE),
        (0, $3mZMJ.USER_CF_TYPE),
        (0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE),
        (0, $3mZMJ.RADIO_BUTTONS_CF_TYPE),
        (0, $3mZMJ.DATETIME_CF_TYPE),
        (0, $3mZMJ.ASSETS_CF_TYPE),
        (0, $3mZMJ.SERVICE_ENTITY_CF_TYPE),
        (0, $3mZMJ.PEOPLE_CF_TYPE),
        (0, $3mZMJ.CASCADING_SELECT_CF_TYPE),
        (0, $3mZMJ.PROJECT_PICKER_CF_TYPE),
        (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE),
        (0, $3mZMJ.READ_ONLY_CF_TYPE),
        (0, $3mZMJ.EPIC_STATUS_TYPE),
        (0, $3mZMJ.MESSAGE_VIEW_CF_TYPE),
        (0, $3mZMJ.MESSAGE_EDIT_CF_TYPE),
        (0, $3mZMJ.CATEGORY_TYPE),
        (0, $3mZMJ.GOALS_CF_TYPE),
        (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE),
        ...$78be9cd6dc1a4416$export$87934b3672715c91,
        ...$78be9cd6dc1a4416$var$serviceDeskCustomFields,
        ...(0, $4cTDP.fg)('dfo_remove_connect_single_select_field_options_agg') ? [
            (0, $3mZMJ.CONNECT_SELECT_CF_TYPE)
        ] : []
    ];
const $78be9cd6dc1a4416$export$a18b3a656ee9c709 = {
    [(0, $FhXEJ.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $FhXEJ.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $FhXEJ.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $78be9cd6dc1a4416$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78be9cd6dc1a4416$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $hGkL7.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $hGkL7.default).SOFTWARE_ISSUE,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $hGkL7.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0,
            $78be9cd6dc1a4416$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $hGkL7.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $hGkL7.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78be9cd6dc1a4416$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $hGkL7.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78be9cd6dc1a4416$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $hGkL7.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $hGkL7.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $FhXEJ.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78be9cd6dc1a4416$export$aebf676dfa727a1c();
            return $78be9cd6dc1a4416$export$27e0678365e5dcff();
        case 0, $FhXEJ.CORE_PROJECT:
            return $78be9cd6dc1a4416$export$381ce08838c53afa();
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            return $78be9cd6dc1a4416$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78be9cd6dc1a4416$export$27e0678365e5dcff();
    }
    return $78be9cd6dc1a4416$export$27e0678365e5dcff();
};

});
parcelRegister("3mZMJ", function(module, exports) {
$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $a319cd7774e26f51$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $a319cd7774e26f51$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $a319cd7774e26f51$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $a319cd7774e26f51$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $a319cd7774e26f51$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $a319cd7774e26f51$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $a319cd7774e26f51$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $a319cd7774e26f51$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $a319cd7774e26f51$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $a319cd7774e26f51$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $a319cd7774e26f51$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $a319cd7774e26f51$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $a319cd7774e26f51$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $a319cd7774e26f51$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $a319cd7774e26f51$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $a319cd7774e26f51$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $a319cd7774e26f51$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $a319cd7774e26f51$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $a319cd7774e26f51$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $a319cd7774e26f51$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $a319cd7774e26f51$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $a319cd7774e26f51$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $a319cd7774e26f51$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $a319cd7774e26f51$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $a319cd7774e26f51$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $a319cd7774e26f51$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $a319cd7774e26f51$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $a319cd7774e26f51$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $a319cd7774e26f51$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $a319cd7774e26f51$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $a319cd7774e26f51$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $a319cd7774e26f51$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $a319cd7774e26f51$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $a319cd7774e26f51$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $a319cd7774e26f51$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $a319cd7774e26f51$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $a319cd7774e26f51$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_LINK_GQL_FIELD", () => $a319cd7774e26f51$export$ff2e58d499eebe1d);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $a319cd7774e26f51$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $a319cd7774e26f51$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $a319cd7774e26f51$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $a319cd7774e26f51$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $a319cd7774e26f51$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $a319cd7774e26f51$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $a319cd7774e26f51$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $a319cd7774e26f51$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $a319cd7774e26f51$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $a319cd7774e26f51$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $a319cd7774e26f51$export$31aea7548807c6b5);
$parcel$export(module.exports, "RESPONDERS_GQL_FIELD", () => $a319cd7774e26f51$export$379390890c7515ac);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $a319cd7774e26f51$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $a319cd7774e26f51$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $a319cd7774e26f51$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $a319cd7774e26f51$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $a319cd7774e26f51$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $a319cd7774e26f51$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $a319cd7774e26f51$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $a319cd7774e26f51$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $a319cd7774e26f51$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $a319cd7774e26f51$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $a319cd7774e26f51$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $a319cd7774e26f51$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $a319cd7774e26f51$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $a319cd7774e26f51$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $a319cd7774e26f51$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $a319cd7774e26f51$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $a319cd7774e26f51$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $a319cd7774e26f51$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $a319cd7774e26f51$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $a319cd7774e26f51$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $a319cd7774e26f51$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $a319cd7774e26f51$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $a319cd7774e26f51$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $a319cd7774e26f51$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $a319cd7774e26f51$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $a319cd7774e26f51$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $a319cd7774e26f51$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $a319cd7774e26f51$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $a319cd7774e26f51$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $a319cd7774e26f51$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $a319cd7774e26f51$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $a319cd7774e26f51$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $a319cd7774e26f51$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $a319cd7774e26f51$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $a319cd7774e26f51$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $a319cd7774e26f51$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $a319cd7774e26f51$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $a319cd7774e26f51$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $a319cd7774e26f51$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $a319cd7774e26f51$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $a319cd7774e26f51$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $a319cd7774e26f51$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $a319cd7774e26f51$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $a319cd7774e26f51$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $a319cd7774e26f51$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $a319cd7774e26f51$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $a319cd7774e26f51$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $a319cd7774e26f51$export$bfcb1a91094f113a);
$parcel$export(module.exports, "ATLAS_PROJECT_GQL_FIELD", () => $a319cd7774e26f51$export$29f2606483502142);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $a319cd7774e26f51$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $a319cd7774e26f51$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $a319cd7774e26f51$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $a319cd7774e26f51$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $a319cd7774e26f51$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $a319cd7774e26f51$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $a319cd7774e26f51$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $a319cd7774e26f51$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $a319cd7774e26f51$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $a319cd7774e26f51$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $a319cd7774e26f51$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $a319cd7774e26f51$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $a319cd7774e26f51$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $a319cd7774e26f51$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $a319cd7774e26f51$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $a319cd7774e26f51$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $a319cd7774e26f51$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $a319cd7774e26f51$export$492b0fa4fe201a22);
$parcel$export(module.exports, "FORMULA_NUMBER_CF_TYPE", () => $a319cd7774e26f51$export$45cfbf005b320b9c);
$parcel$export(module.exports, "FORMULA_DATE_CF_TYPE", () => $a319cd7774e26f51$export$983d1a3f0bd33fcf);
$parcel$export(module.exports, "FORMULA_TEXT_CF_TYPE", () => $a319cd7774e26f51$export$ccfd6611015b4827);
$parcel$export(module.exports, "URL_CF_TYPE", () => $a319cd7774e26f51$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $a319cd7774e26f51$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $a319cd7774e26f51$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $a319cd7774e26f51$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $a319cd7774e26f51$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $a319cd7774e26f51$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $a319cd7774e26f51$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $a319cd7774e26f51$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $a319cd7774e26f51$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $a319cd7774e26f51$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $a319cd7774e26f51$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $a319cd7774e26f51$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $a319cd7774e26f51$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $a319cd7774e26f51$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $a319cd7774e26f51$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $a319cd7774e26f51$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $a319cd7774e26f51$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $a319cd7774e26f51$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $a319cd7774e26f51$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $a319cd7774e26f51$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $a319cd7774e26f51$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $a319cd7774e26f51$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $a319cd7774e26f51$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $a319cd7774e26f51$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $a319cd7774e26f51$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $a319cd7774e26f51$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $a319cd7774e26f51$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $a319cd7774e26f51$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $a319cd7774e26f51$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $a319cd7774e26f51$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $a319cd7774e26f51$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $a319cd7774e26f51$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $a319cd7774e26f51$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $a319cd7774e26f51$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $a319cd7774e26f51$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $a319cd7774e26f51$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $a319cd7774e26f51$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $a319cd7774e26f51$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $a319cd7774e26f51$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $a319cd7774e26f51$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $a319cd7774e26f51$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $a319cd7774e26f51$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $a319cd7774e26f51$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "JIM_PLUGIN_IMPORT_ID_LINK_CF_TYPE", () => $a319cd7774e26f51$export$f94696506ee781f9);
$parcel$export(module.exports, "SYSTEM_IMPORT_ID_LINK_CF_TYPE", () => $a319cd7774e26f51$export$8ba6ed64df1ce64a);
$parcel$export(module.exports, "UUID_CF_TYPE", () => $a319cd7774e26f51$export$e90ce947f06b085d);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $a319cd7774e26f51$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $a319cd7774e26f51$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $a319cd7774e26f51$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $a319cd7774e26f51$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $a319cd7774e26f51$export$2d75b47d12efc812);
$parcel$export(module.exports, "ATTACHMENTS_NUMBER_CF_TYPE", () => $a319cd7774e26f51$export$36500b2821f7114f);
$parcel$export(module.exports, "LAST_COMMENT_DATE_CF_TYPE", () => $a319cd7774e26f51$export$37dc91333ba7a96);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $a319cd7774e26f51$export$7b79405842547ccb);
$parcel$export(module.exports, "ASSIGNEE_DOMAIN_CF_TYPE", () => $a319cd7774e26f51$export$ac9f7d2dfc7c6826);
$parcel$export(module.exports, "REPORTER_DOMAIN_CF_TYPE", () => $a319cd7774e26f51$export$a3d9c149d737aa78);
$parcel$export(module.exports, "COMMENTS_NUMBER_CF_TYPE", () => $a319cd7774e26f51$export$4745e551386233a5);
$parcel$export(module.exports, "DAYS_LAST_COMMENTED_CF_TYPE", () => $a319cd7774e26f51$export$5ee213d6fd4c9b2b);
$parcel$export(module.exports, "LAST_USER_COMMENTED_CF_TYPE", () => $a319cd7774e26f51$export$fb0b6a2e098e1fe2);
$parcel$export(module.exports, "SLA_CF_TYPE", () => $a319cd7774e26f51$export$fe1291c40f590f35);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $a319cd7774e26f51$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $a319cd7774e26f51$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $a319cd7774e26f51$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $a319cd7774e26f51$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $a319cd7774e26f51$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ATLAS_PROJECT_CF_TYPE", () => $a319cd7774e26f51$export$bea7cbcd967ef962);
$parcel$export(module.exports, "CONNECT_SELECT_CF_TYPE", () => $a319cd7774e26f51$export$c623b1d2bf7c02eb);
$parcel$export(module.exports, "ANY_CF_TYPE", () => $a319cd7774e26f51$export$8c0f7dd088e5671d);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $a319cd7774e26f51$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $a319cd7774e26f51$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $a319cd7774e26f51$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $a319cd7774e26f51$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $a319cd7774e26f51$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $a319cd7774e26f51$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $a319cd7774e26f51$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $a319cd7774e26f51$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $a319cd7774e26f51$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $a319cd7774e26f51$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $a319cd7774e26f51$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $a319cd7774e26f51$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $a319cd7774e26f51$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $a319cd7774e26f51$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $a319cd7774e26f51$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $a319cd7774e26f51$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $a319cd7774e26f51$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $a319cd7774e26f51$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $a319cd7774e26f51$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $a319cd7774e26f51$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $a319cd7774e26f51$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $a319cd7774e26f51$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $a319cd7774e26f51$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $a319cd7774e26f51$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $a319cd7774e26f51$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $a319cd7774e26f51$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $a319cd7774e26f51$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $a319cd7774e26f51$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $a319cd7774e26f51$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $a319cd7774e26f51$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $a319cd7774e26f51$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $a319cd7774e26f51$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $a319cd7774e26f51$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $a319cd7774e26f51$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $a319cd7774e26f51$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $a319cd7774e26f51$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $a319cd7774e26f51$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $a319cd7774e26f51$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $a319cd7774e26f51$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $a319cd7774e26f51$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $a319cd7774e26f51$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $a319cd7774e26f51$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $a319cd7774e26f51$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $a319cd7774e26f51$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $a319cd7774e26f51$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $a319cd7774e26f51$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $a319cd7774e26f51$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $a319cd7774e26f51$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $a319cd7774e26f51$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $a319cd7774e26f51$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $a319cd7774e26f51$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $a319cd7774e26f51$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $a319cd7774e26f51$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $a319cd7774e26f51$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "WORKLOG", () => $a319cd7774e26f51$export$df36fc05622c402);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $a319cd7774e26f51$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $a319cd7774e26f51$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $a319cd7774e26f51$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ARE_FIELDS_REORDERED", () => $a319cd7774e26f51$export$6159d4eb69c78696);
$parcel$export(module.exports, "HIDE_EMPTY_FIELDS", () => $a319cd7774e26f51$export$962c5b8782b7a233);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $a319cd7774e26f51$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $a319cd7774e26f51$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $a319cd7774e26f51$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $a319cd7774e26f51$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $a319cd7774e26f51$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $a319cd7774e26f51$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $a319cd7774e26f51$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $a319cd7774e26f51$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $a319cd7774e26f51$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $a319cd7774e26f51$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $a319cd7774e26f51$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $a319cd7774e26f51$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $a319cd7774e26f51$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $a319cd7774e26f51$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $a319cd7774e26f51$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $a319cd7774e26f51$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $a319cd7774e26f51$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $a319cd7774e26f51$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $a319cd7774e26f51$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "AGGREGATE_TIME_ORIGINAL_ESTIMATE", () => $a319cd7774e26f51$export$871661506c0a91ea);
$parcel$export(module.exports, "AGGREGATE_TIME_ESTIMATE", () => $a319cd7774e26f51$export$4a7ecfe931ab6c07);
$parcel$export(module.exports, "PROGRESS", () => $a319cd7774e26f51$export$fbc5ebe2e580bf8b);
$parcel$export(module.exports, "AGGREGATE_PROGRESS", () => $a319cd7774e26f51$export$aa3b37e271efd578);
$parcel$export(module.exports, "WORKRATIO", () => $a319cd7774e26f51$export$444bffe6526fb5f2);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $a319cd7774e26f51$export$3c3e26aadbfa2c32);

var $LFmXM = parcelRequire("LFmXM");

var $4cTDP = parcelRequire("4cTDP");
const $a319cd7774e26f51$export$b144116dae474c88 = 'issue-link-search';
const $a319cd7774e26f51$export$bc917bc699b25f75 = 'number';
const $a319cd7774e26f51$export$5f26ca419fdffbe7 = 'string';
const $a319cd7774e26f51$export$ce9bfd823c7e1a6d = 'datetime';
const $a319cd7774e26f51$export$346b72b1f7cd6d5a = 'date';
const $a319cd7774e26f51$export$b20fbcacd7942c2a = 'option2';
const $a319cd7774e26f51$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $a319cd7774e26f51$export$a2e8554bffc61ece = 'any';
const $a319cd7774e26f51$export$f25cd4907cbb25b9 = 'array';
const $a319cd7774e26f51$export$5600354b43577e17 = 'user';
const $a319cd7774e26f51$export$5dbc9917f72d0d2a = 'group';
const $a319cd7774e26f51$export$253649f07fb55948 = 'object';
const $a319cd7774e26f51$export$eb39592ba5247ee7 = 'group-list';
const $a319cd7774e26f51$export$f48a9be226105736 = 'array-string';
const $a319cd7774e26f51$export$42e2e93fc721df5d = 'version';
const $a319cd7774e26f51$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $a319cd7774e26f51$export$7773375e72c953ed = 'approval-panel';
const $a319cd7774e26f51$export$80ad0037098f3919 = 'project';
const $a319cd7774e26f51$export$82db8a26de491dd2 = 'array';
const $a319cd7774e26f51$export$c10d49310c28a01a = 'object';
const $a319cd7774e26f51$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $a319cd7774e26f51$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $a319cd7774e26f51$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $a319cd7774e26f51$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $a319cd7774e26f51$export$c979d9c548c05133 = 'JiraBooleanField';
const $a319cd7774e26f51$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $a319cd7774e26f51$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $a319cd7774e26f51$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $a319cd7774e26f51$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $a319cd7774e26f51$export$b0deb225eed90fbd = 'JiraCMDBField';
const $a319cd7774e26f51$export$add3775cfea8fde3 = 'JiraColorField';
const $a319cd7774e26f51$export$9631d4098abab3eb = 'JiraComponentsField';
const $a319cd7774e26f51$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $a319cd7774e26f51$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $a319cd7774e26f51$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $a319cd7774e26f51$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $a319cd7774e26f51$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $a319cd7774e26f51$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $a319cd7774e26f51$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $a319cd7774e26f51$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $a319cd7774e26f51$export$6d8da4497234455 = 'JiraEpicLinkField';
const $a319cd7774e26f51$export$9bcfac568e4fa59c = 'JiraFlagField';
const $a319cd7774e26f51$export$d2cadc5e6eb21e96 = 'JiraFormulaField';
const $a319cd7774e26f51$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $a319cd7774e26f51$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $a319cd7774e26f51$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $a319cd7774e26f51$export$810709f0c5c2e9db = 'JiraLabelsField';
const $a319cd7774e26f51$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $a319cd7774e26f51$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $a319cd7774e26f51$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $a319cd7774e26f51$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $a319cd7774e26f51$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $a319cd7774e26f51$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $a319cd7774e26f51$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $a319cd7774e26f51$export$31aea7548807c6b5 = 'JiraPeopleField';
const $a319cd7774e26f51$export$379390890c7515ac = 'JiraServiceManagementRespondersField';
const $a319cd7774e26f51$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $a319cd7774e26f51$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $a319cd7774e26f51$export$12f54499c6252188 = 'JiraProjectField';
const $a319cd7774e26f51$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $a319cd7774e26f51$export$c69486dd643dfb69 = 'JiraReporterField';
const $a319cd7774e26f51$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $a319cd7774e26f51$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $a319cd7774e26f51$export$37f4daaa7b409554 = 'JiraRichTextField';
const $a319cd7774e26f51$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $a319cd7774e26f51$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $a319cd7774e26f51$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $a319cd7774e26f51$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $a319cd7774e26f51$export$e40f819979b3881d = 'JiraStatusField';
const $a319cd7774e26f51$export$6c243704a22baffe = 'JiraTeamField';
const $a319cd7774e26f51$export$6c32429bac235203 = 'JiraTeamViewField';
const $a319cd7774e26f51$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $a319cd7774e26f51$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $a319cd7774e26f51$export$37ccd11f08a93ccb = 'JiraUrlField';
const $a319cd7774e26f51$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $a319cd7774e26f51$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $a319cd7774e26f51$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $a319cd7774e26f51$export$aa815aaa741ae18 = 'JiraWatchesField';
const $a319cd7774e26f51$export$e805f89b15d2abf4 = 'JiraAssetField';
const $a319cd7774e26f51$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $a319cd7774e26f51$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $a319cd7774e26f51$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $a319cd7774e26f51$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $a319cd7774e26f51$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $a319cd7774e26f51$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $a319cd7774e26f51$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $a319cd7774e26f51$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $a319cd7774e26f51$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $a319cd7774e26f51$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $a319cd7774e26f51$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $a319cd7774e26f51$export$c48132adab502d6b = 'JiraForgeUsersField';
const $a319cd7774e26f51$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $a319cd7774e26f51$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $a319cd7774e26f51$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $a319cd7774e26f51$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $a319cd7774e26f51$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $a319cd7774e26f51$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $a319cd7774e26f51$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $a319cd7774e26f51$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $a319cd7774e26f51$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $a319cd7774e26f51$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $a319cd7774e26f51$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $a319cd7774e26f51$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $a319cd7774e26f51$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $a319cd7774e26f51$export$bfcb1a91094f113a = 'JiraGoalsField';
const $a319cd7774e26f51$export$29f2606483502142 = 'JiraTownsquareProjectField';
const $a319cd7774e26f51$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $a319cd7774e26f51$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $a319cd7774e26f51$export$798d2f5814884447 = 'forgeCustomField';
const $a319cd7774e26f51$export$1e188101081be3f8 = 'forge/string';
const $a319cd7774e26f51$export$caf3b3f20c0589b9 = 'forge/string-list';
const $a319cd7774e26f51$export$9bdf08a1276e866c = 'forge/number';
const $a319cd7774e26f51$export$996c3d3eb2880229 = 'forge/date';
const $a319cd7774e26f51$export$578c5856bf684e2a = 'forge/datetime';
const $a319cd7774e26f51$export$38791c0fdd0bcce = 'forge/user';
const $a319cd7774e26f51$export$5c209e1debd6c274 = 'forge/user-list';
const $a319cd7774e26f51$export$8646fecba9a8be61 = 'forge/group';
const $a319cd7774e26f51$export$68b91cd2f2e6b810 = 'forge/group-list';
const $a319cd7774e26f51$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $a319cd7774e26f51$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $a319cd7774e26f51$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $a319cd7774e26f51$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $a319cd7774e26f51$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $a319cd7774e26f51$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $a319cd7774e26f51$export$45cfbf005b320b9c = 'com.atlassian.jira.system.formula.fieldtypes:numberformula';
const $a319cd7774e26f51$export$983d1a3f0bd33fcf = 'com.atlassian.jira.system.formula.fieldtypes:dateformula';
const $a319cd7774e26f51$export$ccfd6611015b4827 = 'com.atlassian.jira.system.formula.fieldtypes:textformula';
const $a319cd7774e26f51$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $a319cd7774e26f51$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $a319cd7774e26f51$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $a319cd7774e26f51$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $a319cd7774e26f51$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $a319cd7774e26f51$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $a319cd7774e26f51$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $a319cd7774e26f51$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $a319cd7774e26f51$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $a319cd7774e26f51$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $a319cd7774e26f51$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $a319cd7774e26f51$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $a319cd7774e26f51$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $a319cd7774e26f51$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $a319cd7774e26f51$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $a319cd7774e26f51$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $a319cd7774e26f51$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $a319cd7774e26f51$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $a319cd7774e26f51$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $a319cd7774e26f51$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $a319cd7774e26f51$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $a319cd7774e26f51$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $a319cd7774e26f51$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $a319cd7774e26f51$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $a319cd7774e26f51$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $a319cd7774e26f51$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $a319cd7774e26f51$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $a319cd7774e26f51$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $a319cd7774e26f51$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $a319cd7774e26f51$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $a319cd7774e26f51$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $a319cd7774e26f51$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $a319cd7774e26f51$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $a319cd7774e26f51$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $a319cd7774e26f51$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $a319cd7774e26f51$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $a319cd7774e26f51$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $a319cd7774e26f51$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $a319cd7774e26f51$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $a319cd7774e26f51$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $a319cd7774e26f51$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $a319cd7774e26f51$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $a319cd7774e26f51$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $a319cd7774e26f51$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $a319cd7774e26f51$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $a319cd7774e26f51$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $a319cd7774e26f51$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $a319cd7774e26f51$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $a319cd7774e26f51$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $a319cd7774e26f51$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $a319cd7774e26f51$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $a319cd7774e26f51$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $a319cd7774e26f51$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $a319cd7774e26f51$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $a319cd7774e26f51$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $a319cd7774e26f51$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $a319cd7774e26f51$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $a319cd7774e26f51$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $a319cd7774e26f51$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $a319cd7774e26f51$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $a319cd7774e26f51$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $a319cd7774e26f51$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $a319cd7774e26f51$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $a319cd7774e26f51$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $a319cd7774e26f51$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $a319cd7774e26f51$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $a319cd7774e26f51$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $a319cd7774e26f51$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $a319cd7774e26f51$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $a319cd7774e26f51$export$bea7cbcd967ef962 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlas-project';
const $a319cd7774e26f51$export$c623b1d2bf7c02eb = 'connect-option';
const $a319cd7774e26f51$export$8c0f7dd088e5671d = 'any.custom.field.type';
const $a319cd7774e26f51$export$fba8634fd401ba8b = 'assignee';
const $a319cd7774e26f51$export$a91aea2438afcce8 = 'reporter';
const $a319cd7774e26f51$export$b159f8b8f27aae4c = 'duedate';
const $a319cd7774e26f51$export$34740f8d07d23ac0 = 'priority';
const $a319cd7774e26f51$export$43b6e33ec70f2272 = 'labels';
const $a319cd7774e26f51$export$ff39ebd4bb12b718 = 'created';
const $a319cd7774e26f51$export$cd8e68094cb5c3cb = 'updated';
const $a319cd7774e26f51$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $a319cd7774e26f51$export$37abf56f13f61ec5 = 'components';
const $a319cd7774e26f51$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $a319cd7774e26f51$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $a319cd7774e26f51$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $a319cd7774e26f51$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $a319cd7774e26f51$export$791007408faf42f4 = 'servicedesk-incident-management';
const $a319cd7774e26f51$export$827a1c600bac12a3 = 'devSummary';
const $a319cd7774e26f51$export$e9ba671d077969f8 = 'releases';
const $a319cd7774e26f51$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $a319cd7774e26f51$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $a319cd7774e26f51$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $a319cd7774e26f51$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $a319cd7774e26f51$export$a5c9f63aadcb220 = 'fixVersions';
const $a319cd7774e26f51$export$94009605902e4fe5 = 'versions';
const $a319cd7774e26f51$export$5e7324042f1d6b31 = 'description';
const $a319cd7774e26f51$export$113281d03e6830ef = 'environment';
const $a319cd7774e26f51$export$5ff798870a3dffbf = 'watches';
const $a319cd7774e26f51$export$907219511d14ba3d = 'summary';
const $a319cd7774e26f51$export$d09aa6a4f3538063 = 'proforma-forms';
const $a319cd7774e26f51$export$3aca8c91b58a42e2 = 'resolution';
const $a319cd7774e26f51$export$ccb5ffefbf8b987c = 'timetracking';
const $a319cd7774e26f51$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $a319cd7774e26f51$export$358267065be1e = 'status';
const $a319cd7774e26f51$export$dcaa788c7ada56de = 'statusCategory';
const $a319cd7774e26f51$export$ebb48b08205007c5 = 'issuetype';
const $a319cd7774e26f51$export$5e91047fe9955d0e = 'issuekey';
const $a319cd7774e26f51$export$3b3d0889022c85b3 = 'children-issues';
const $a319cd7774e26f51$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $a319cd7774e26f51$export$8fe3d5be8cb17459 = 'epic-issues';
const $a319cd7774e26f51$export$335851d83a79891 = 'hierarchy-level-below';
const $a319cd7774e26f51$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $a319cd7774e26f51$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $a319cd7774e26f51$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $a319cd7774e26f51$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $a319cd7774e26f51$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $a319cd7774e26f51$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $a319cd7774e26f51$export$7b3d247435a784fa = 'SLA_PANEL';
const $a319cd7774e26f51$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $a319cd7774e26f51$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $a319cd7774e26f51$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $a319cd7774e26f51$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $a319cd7774e26f51$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $a319cd7774e26f51$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $a319cd7774e26f51$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $a319cd7774e26f51$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $a319cd7774e26f51$export$22f61ccc2730431f = 'similar-issues';
const $a319cd7774e26f51$export$8bbb446f57294715 = 'subtasks';
const $a319cd7774e26f51$export$34fcd7cb291a1e4d = 'votes';
const $a319cd7774e26f51$export$5e93f2a57cc4ca3a = 'parent';
const $a319cd7774e26f51$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $a319cd7774e26f51$export$91a9dba2d38d9a6f = 'project';
const $a319cd7774e26f51$export$df36fc05622c402 = 'worklog';
const $a319cd7774e26f51$export$ede0a4c20124ec85 = 'timespent';
const $a319cd7774e26f51$export$3eeb79d48fb5f667 = 'dataclassification';
const $a319cd7774e26f51$export$45e72c9a63ab61ab = 'SENTIMENT';
const $a319cd7774e26f51$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $a319cd7774e26f51$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $a319cd7774e26f51$export$99ad62164189f781 = 'ecosystemGlance';
const $a319cd7774e26f51$export$7719ef6e9283671 = 'forgeGlance';
const $a319cd7774e26f51$export$bfebea5ce2e1887a = 'ecosystemContext';
const $a319cd7774e26f51$export$be8e68fb1aed253e = 'forgeContext';
const $a319cd7774e26f51$export$84e5674890d55030 = 'issuerestriction';
const $a319cd7774e26f51$export$326a5522a485e43d = 'security';
const $a319cd7774e26f51$export$c9f3f01e2c535302 = 'securitylevel';
const $a319cd7774e26f51$export$35e5652f764785bd = 'creator';
const $a319cd7774e26f51$export$66519f3bbff1796a = 'team';
const $a319cd7774e26f51$export$a4ee0bca77cc8463 = 'estimate';
const $a319cd7774e26f51$export$fed53408e89e0497 = 'dueDate';
const $a319cd7774e26f51$export$d53c26f9ce31f56b = 'targetStart';
const $a319cd7774e26f51$export$48f82d653f85e459 = 'targetEnd';
const $a319cd7774e26f51$export$ea5a888f39f722c7 = 'startDate';
const $a319cd7774e26f51$export$f245bbec12cc0e40 = 'color';
const $a319cd7774e26f51$export$aed630b4b7114a59 = 'attachment';
const $a319cd7774e26f51$export$b50c1a8fef07104 = 'issuelinks';
const $a319cd7774e26f51$export$ea3d72f4bb7738ba = 'timeestimate';
const $a319cd7774e26f51$export$a4cab0124760d860 = 'comment';
const $a319cd7774e26f51$export$734929aef118d7e2 = 'worklog';
const $a319cd7774e26f51$export$ffbacacb07c1d46d = 'parent';
const $a319cd7774e26f51$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $a319cd7774e26f51$export$278c072e2f9176ab = 'aggregatetimespent';
const $a319cd7774e26f51$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $a319cd7774e26f51$export$fbc5ebe2e580bf8b = 'progress';
const $a319cd7774e26f51$export$aa3b37e271efd578 = 'aggregateprogress';
const $a319cd7774e26f51$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $a319cd7774e26f51$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $a319cd7774e26f51$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $a319cd7774e26f51$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $a319cd7774e26f51$export$34740f8d07d23ac0,
        REPORTER_TYPE: $a319cd7774e26f51$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $a319cd7774e26f51$export$5e7324042f1d6b31,
        LABELS_TYPE: $a319cd7774e26f51$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $a319cd7774e26f51$export$37abf56f13f61ec5,
        SPRINT_TYPE: $a319cd7774e26f51$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $a319cd7774e26f51$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $a319cd7774e26f51$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $a319cd7774e26f51$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $a319cd7774e26f51$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $a319cd7774e26f51$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $a319cd7774e26f51$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $a319cd7774e26f51$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $a319cd7774e26f51$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $a319cd7774e26f51$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $a319cd7774e26f51$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $a319cd7774e26f51$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $a319cd7774e26f51$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $a319cd7774e26f51$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $a319cd7774e26f51$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $a319cd7774e26f51$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $a319cd7774e26f51$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $a319cd7774e26f51$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $a319cd7774e26f51$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $a319cd7774e26f51$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $a319cd7774e26f51$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $a319cd7774e26f51$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $a319cd7774e26f51$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $a319cd7774e26f51$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $a319cd7774e26f51$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $a319cd7774e26f51$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $a319cd7774e26f51$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $a319cd7774e26f51$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $a319cd7774e26f51$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $a319cd7774e26f51$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $a319cd7774e26f51$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $a319cd7774e26f51$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $a319cd7774e26f51$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $a319cd7774e26f51$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $a319cd7774e26f51$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $a319cd7774e26f51$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $a319cd7774e26f51$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $a319cd7774e26f51$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $a319cd7774e26f51$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $a319cd7774e26f51$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $a319cd7774e26f51$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $a319cd7774e26f51$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $a319cd7774e26f51$export$39866626496bbfc8,
        VERSION_CF_TYPE: $a319cd7774e26f51$export$24382b4e8c58336b,
        DATE_CF_TYPE: $a319cd7774e26f51$export$ff745f432984005d,
        GROUP_CF_TYPE: $a319cd7774e26f51$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $a319cd7774e26f51$export$b600addfa3355c57,
        USER_CF_TYPE: $a319cd7774e26f51$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $a319cd7774e26f51$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $a319cd7774e26f51$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $a319cd7774e26f51$export$65524be5675e57e6,
        TEAM_CF_TYPE: $a319cd7774e26f51$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $a319cd7774e26f51$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $a319cd7774e26f51$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $a319cd7774e26f51$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $a319cd7774e26f51$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $a319cd7774e26f51$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $a319cd7774e26f51$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $a319cd7774e26f51$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $a319cd7774e26f51$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $a319cd7774e26f51$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $a319cd7774e26f51$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $a319cd7774e26f51$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $a319cd7774e26f51$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $a319cd7774e26f51$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $a319cd7774e26f51$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $a319cd7774e26f51$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $a319cd7774e26f51$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $a319cd7774e26f51$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $a319cd7774e26f51$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $a319cd7774e26f51$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $a319cd7774e26f51$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $a319cd7774e26f51$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $a319cd7774e26f51$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $a319cd7774e26f51$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $a319cd7774e26f51$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $a319cd7774e26f51$export$2bbb7f69c97ea279,
        ATLAS_PROJECT_CF_TYPE: $a319cd7774e26f51$export$bea7cbcd967ef962,
        PARENT_TYPE: $a319cd7774e26f51$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $a319cd7774e26f51$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $a319cd7774e26f51$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $a319cd7774e26f51$export$45e72c9a63ab61ab
    });
    if ((0, $4cTDP.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $a319cd7774e26f51$export$d2a475ff30e5bf97
    });
    if ((0, $4cTDP.fg)('dfo_remove_connect_single_select_field_options_agg')) Object.assign(types, {
        CONNECT_SELECT_CF_TYPE: $a319cd7774e26f51$export$c623b1d2bf7c02eb
    });
    return types;
};
const $a319cd7774e26f51$export$3c3e26aadbfa2c32 = (0, $LFmXM.default)($a319cd7774e26f51$var$getLayoutFieldTypesNonMemoized);

});



parcelRegister("6d9QY", function(module, exports) {
$parcel$export(module.exports, "usePrevious", () => $6561b991da312eac$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $6561b991da312eac$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $6561b991da312eac$export$23fbbb2e62c4a911);

var $eJOHy = parcelRequire("eJOHy");
const $6561b991da312eac$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $6561b991da312eac$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $eJOHy.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $6561b991da312eac$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $eJOHy.useRef)(value);
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("k3AHU", function(module, exports) {
$parcel$export(module.exports, "useUserHasAddProductPermissions", () => $111926defb1457f6$export$d223ceb381c5cc91);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $cHtIB = parcelRequire("cHtIB");

var $8Q6yE = parcelRequire("8Q6yE");


var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");

var $1BZ8a = parcelRequire("1BZ8a");

var $cblKs = parcelRequire("cblKs");

var $k6kDZ = parcelRequire("k6kDZ");
const $111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY = 'confluence-add-product-permission';
const $111926defb1457f6$export$8e35886de8a54f45 = ()=>{
    const localStorageProvider = (0, $3hRxq.createLocalExpirableStorageProvider)('placeholderTemplateAddProductPermissionStorage');
    const getLocalStorage = ()=>localStorageProvider.get($111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY);
    const LOCAL_STORAGE_EXPIRY_MS = 86400000; // one day
    const setLocalStorage = (value)=>localStorageProvider.set($111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY, value, Date.now() + LOCAL_STORAGE_EXPIRY_MS);
    return {
        getLocalStorage: getLocalStorage,
        setLocalStorage: setLocalStorage
    };
};
const $111926defb1457f6$export$d223ceb381c5cc91 = ({ skip: skip = false })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const isBillingSystemCcp = productEntitlementDetails?.[0, $315aedf92e50a945$export$1346c9aa3cbb477d]?.billingSourceSystem === 'CCP';
    const { getLocalStorage: getLocalStorage, setLocalStorage: setLocalStorage } = (0, $eJOHy.useMemo)(()=>$111926defb1457f6$export$8e35886de8a54f45(), []);
    const cachedStatus = getLocalStorage();
    const initialStatus = cachedStatus || {
        canProvisionConfluenceEndUser: false,
        fetchStatus: 'pending'
    };
    const [status, setStatus] = (0, $eJOHy.useState)(initialStatus);
    const handleFetchPermissions = (0, $eJOHy.useCallback)(async ()=>{
        try {
            let newStatus;
            if ((0, $4cTDP.fg)('end_user_activate_eligibility_check')) {
                const endUserResponse = await (0, $k6kDZ.fetchEndUserAddProductPermissions)(cloudId, isBillingSystemCcp);
                newStatus = {
                    canProvisionConfluenceEndUser: endUserResponse?.eligible,
                    fetchStatus: 'resolved'
                };
            } else // If the feature flag is not enabled, set default status
            newStatus = {
                canProvisionConfluenceEndUser: appEditions.software === (0, $cblKs.FREE_EDITION),
                fetchStatus: 'resolved'
            };
            setStatus(newStatus);
            setLocalStorage(newStatus);
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: $111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY,
                    packageName: 'jiraIssueViewBase',
                    teamName: 'starburst'
                },
                error: new Error(`Failed to get ${$111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY} status: ${error}`)
            });
            const errorStatus = {
                canProvisionConfluenceEndUser: false,
                fetchStatus: 'failed'
            };
            setStatus(errorStatus);
            setLocalStorage(errorStatus);
        }
    }, [
        cloudId,
        isBillingSystemCcp,
        appEditions.software,
        setLocalStorage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!skip && cloudId && !cachedStatus) handleFetchPermissions();
    }, [
        cloudId,
        skip,
        cachedStatus,
        handleFetchPermissions
    ]);
    return status;
};

});
parcelRegister("k6kDZ", function(module, exports) {
$parcel$export(module.exports, "fetchEndUserAddProductPermissions", () => $6964fed97a21128d$export$e9573be2f5180789);

var $4mEPL = parcelRequire("4mEPL");
const $6964fed97a21128d$var$CONFLUENCE_FREE_OFFERING_KEY = '7547cfd6-a804-4e42-8bed-e656d49ea09e';
const $6964fed97a21128d$export$e9573be2f5180789 = async (cloudId, isBillingSystemCcp)=>{
    const response = await (0, $4mEPL.default)('/gateway/api/bxp/signup/product/end-user-activate-eligible-check', {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            isCCP: isBillingSystemCcp,
            offerings: [
                {
                    offeringId: $6964fed97a21128d$var$CONFLUENCE_FREE_OFFERING_KEY,
                    chargeElement: 'user',
                    pricingType: 'FREE'
                }
            ]
        })
    }, 'confluence-content-placeholder-template/src/services/user-product-permission');
    return response;
};

});


parcelRegister("4gH2A", function(module, exports) {
$parcel$export(module.exports, "useAreProductSuggestionsEnabled", () => $7eefa74ea25bec5c$export$3fb3b8b7f13e1089);

var $koAZ4 = parcelRequire("koAZ4");
const $7eefa74ea25bec5c$export$3fb3b8b7f13e1089 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.areProductSuggestionsEnabled || false;
};

});


parcelRegister("42nVO", function(module, exports) {
$parcel$export(module.exports, "getOnboardingParams", () => $808d76b09bff5815$export$e7ff252d67c56b90);

var $8jEK9 = parcelRequire("8jEK9");
const $808d76b09bff5815$export$296e41ed2dc54bb0 = ()=>{
    const teamType = (0, $8jEK9.get)('teamType');
    if (!teamType || typeof teamType.value !== 'string') return null;
    return teamType.value;
};
const $808d76b09bff5815$export$e7ff252d67c56b90 = ()=>({
        teamType: $808d76b09bff5815$export$296e41ed2dc54bb0()
    });

});
parcelRegister("8jEK9", function(module, exports) {
$parcel$export(module.exports, "set", () => $a85503dea0af7c9b$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "get", () => $a85503dea0af7c9b$export$3988ae62b71be9a3);

var $LFmXM = parcelRequire("LFmXM");

var $8tIrO = parcelRequire("8tIrO");

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");
const $a85503dea0af7c9b$var$getStore = (0, $LFmXM.default)(()=>(0, $4cTDP.fg)('onboarding-hub-nth-user-team-type-session-storage') ? (0, $3hRxq.createLocalExpirableStorageProvider)('onboarding') : (0, $8tIrO.createSessionStorageProvider)('onboarding'));
const $a85503dea0af7c9b$var$ONE_WEEK_IN_MS = 604800000;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a85503dea0af7c9b$var$createStoredItem = (value, accessedAt)=>({
        value: value,
        accessedAt: accessedAt ?? null
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a85503dea0af7c9b$var$isItemValid = (item)=>typeof item === 'object' && !Array.isArray(item) && item !== null && 'value' in item && 'accessedAt' in item;
const $a85503dea0af7c9b$export$adaa4cf7ef1b65be = (key, value)=>{
    const store = $a85503dea0af7c9b$var$getStore();
    const serializedValue = JSON.stringify($a85503dea0af7c9b$var$createStoredItem(value));
    if ((0, $4cTDP.fg)('onboarding-hub-nth-user-team-type-session-storage')) {
        const expirationTime = Date.now() + $a85503dea0af7c9b$var$ONE_WEEK_IN_MS;
        store.set(key, serializedValue, expirationTime);
    } else store.set(key, serializedValue);
};
const $a85503dea0af7c9b$export$3988ae62b71be9a3 = (key)=>{
    const store = $a85503dea0af7c9b$var$getStore();
    const item = store.get(key);
    try {
        const parsed = item && JSON.parse(item);
        if ($a85503dea0af7c9b$var$isItemValid(parsed)) {
            const serializedValue = JSON.stringify($a85503dea0af7c9b$var$createStoredItem(parsed.value, Date.now()));
            if ((0, $4cTDP.fg)('onboarding-hub-nth-user-team-type-session-storage')) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const currentExpiration = store?.getExpiration(key);
                if (currentExpiration) store.set(key, serializedValue, currentExpiration);
                else {
                    const expirationTime = Date.now() + $a85503dea0af7c9b$var$ONE_WEEK_IN_MS;
                    store.set(key, serializedValue, expirationTime);
                }
            } else store.set(key, serializedValue);
            return parsed;
        }
        return null;
    } catch  {
        return null;
    }
};

});



parcelRegister("grotr", function(module, exports) {
$parcel$export(module.exports, "PlacementFetchProvider", () => $796e82ba6da1934d$export$9be10e5cc29463c9);

var $eJOHy = parcelRequire("eJOHy");

var $kokXW = parcelRequire("kokXW");

var $2xVkf = parcelRequire("2xVkf");
const $796e82ba6da1934d$export$9be10e5cc29463c9 = ({ children: children, resource: resource })=>{
    const fetch = (0, $2xVkf.usePlacementSSRFetch)(resource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kokXW.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};

});


parcelRegister("idwl9", function(module, exports) {
$parcel$export(module.exports, "Nav4Recommendations", () => $b84878005942956c$export$dfe7a31b75b5edeb);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");


var $4NICj = parcelRequire("4NICj");
const $b84878005942956c$export$dfe7a31b75b5edeb = /*#__PURE__*/ (0, $eJOHy.memo)($b84878005942956c$var$RecommendationsQuery);
function $b84878005942956c$var$RecommendationsQuery() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "growth-recommendations",
        fallback: "unmount",
        packageName: (0, $f9370b6235f53e1a$export$b8b9d90f9e5bd72b),
        teamName: (0, $f9370b6235f53e1a$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "recommendations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NICj.Nav4Recommendations), null)));
}

});
const $f9370b6235f53e1a$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GrowthRecommendations';
const $f9370b6235f53e1a$export$d57b6b390e78d90f = 'jira-cosmos';
const $f9370b6235f53e1a$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';

parcelRegister("4NICj", function(module, exports) {
$parcel$export(module.exports, "Nav4Recommendations", () => $d8d6394c34d5997c$export$dfe7a31b75b5edeb);

var $fX4ye = parcelRequire("fX4ye");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $fX4ye = parcelRequire("fX4ye");

var $cYX9w = parcelRequire("cYX9w");

var $cHtIB = parcelRequire("cHtIB");

var $e6YEs = parcelRequire("e6YEs");

var $6qOE4 = parcelRequire("6qOE4");
/*
At the moment, growthRecommendations fragment in GQL returns different response each time. This results in a behaviour where recommendation component in UI sometimes appear and disappear
as user interacts with the page.

Further observations were:
1) User clicks on a page. It may causes a change in url. this results in the refetch of Nav4ProjectsContent fragment to keep projects recent section up-to-date.
As part of this refetch, growthRecommendations is also refetched as it is part of the same fragment.

2) On each refetch, backend returns different entity ids for recommendations.
3) As a result, It causes the behavior where a recommendation appears and then disappears on different user interactions.

In order to solve it, a below cache is implemented. The purpose of which is to cache the first response and then use it to render the recommendations component which will also be wrapped
in a memo to avoid further re-renders.
*/ const $d8d6394c34d5997c$var$cache = {
    growthRecommendations: []
};
function $d8d6394c34d5997c$export$dfe7a31b75b5edeb() {
    const [queryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $fX4ye.default));
    const cloudId = (0, $cHtIB.useCloudId)();
    const userId = (0, $e6YEs.useAccountId)();
    (0, $eJOHy.useEffect)(()=>{
        if (cloudId) loadQuery({
            cloudId: cloudId
        });
    }, [
        cloudId,
        loadQuery
    ]);
    if (!queryRef) return null;
    if (!(0, $4cTDP.fg)('optout_all_messages_grw-1467')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d8d6394c34d5997c$var$Nav4RecommendationsInner, {
        queryRef: queryRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYX9w.default), {
        touchpointId: "grw-1467-jpd-recommendation-nav4",
        cloudId: cloudId,
        userId: userId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d8d6394c34d5997c$var$Nav4RecommendationsInner, {
        queryRef: queryRef
    }));
}
const $d8d6394c34d5997c$var$Nav4RecommendationsInner = ({ queryRef: queryRef })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $fX4ye.default), queryRef);
    const canCreateProject = data?.jira?.canCreateProject ?? false;
    const recommendations = (0, $eJOHy.useMemo)(()=>{
        const appRecommendations = data?.growthRecommendations?.recommendations?.data?.map((item)=>item.entityId).filter(Boolean) ?? [];
        if ($d8d6394c34d5997c$var$cache.growthRecommendations.length === 0 && appRecommendations.length > 0) // eslint-disable-next-line react-hooks/react-compiler
        $d8d6394c34d5997c$var$cache.growthRecommendations = appRecommendations;
        /*
    	if user has no permission for creating a project, then we want early return to performance benefit.
    	This is because, currently there are only one recommendations 1) JPD Recommendation
    	Which requires create project permission before user can be considered eligible
    */ return Boolean(canCreateProject) && $d8d6394c34d5997c$var$cache.growthRecommendations.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6qOE4.Recommendations), {
            appRecommendations: $d8d6394c34d5997c$var$cache.growthRecommendations,
            sessionId: data?.growthRecommendations?.recommendations?.context?.sessionId
        });
    }, [
        canCreateProject,
        data
    ]);
    return recommendations;
};

});
parcelRegister("fX4ye", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d8adea202607370$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11def388a247d1d3c608ca39d32e5fd2>>
 * @relayHash 50aff49926920514ba3020db082cce38
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1713f82b1ea505ce5b37f6edc5acf8c734f1c5803d49ce12d4f2f3353d89c981
const $3d8adea202607370$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "alias": "canCreateProject",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_PROJECT"
                    }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ]
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "entityId"
            }
        ],
        "type": "GrowthRecJiraTemplateRecommendation"
    }, v4 = {
        "concreteType": "GrowthRecContextResult",
        "kind": "LinkedField",
        "name": "context",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sessionId"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4RecommendationsQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4RecommendationsQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1713f82b1ea505ce5b37f6edc5acf8c734f1c5803d49ce12d4f2f3353d89c981",
            "metadata": {},
            "name": "Nav4RecommendationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3d8adea202607370$var$node.hash = "8583b77d3fe5ee2fc7422c8b304ac609";
var $3d8adea202607370$export$2e2bcd8739ae039 = $3d8adea202607370$var$node;

});

parcelRegister("cYX9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $26ccb262dfb7ca8d$export$2e2bcd8739ae039);

var $6V3Gv = parcelRequire("6V3Gv");
function $26ccb262dfb7ca8d$export$2e2bcd8739ae039({ touchpointId: touchpointId, cloudId: cloudId, userId: userId, children: children, fallback: fallback, options: options }) {
    const { optoutStatus: optoutStatus } = (0, $6V3Gv.useIsOptoutAllMessages)(touchpointId, cloudId, userId, options);
    if (options?.isDisabled) return children;
    if (optoutStatus !== 'no-opt-out') {
        if (fallback) {
            if (typeof fallback === 'function') return fallback({
                optoutStatus: optoutStatus
            });
            return fallback;
        }
        return null;
    }
    return children;
}

});
parcelRegister("6V3Gv", function(module, exports) {
$parcel$export(module.exports, "useIsOptoutAllMessages", () => $a7b1698780ff1c70$export$7d4c6b519725ba3b);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

const $a7b1698780ff1c70$var$getTraceId = (response)=>{
    const traceIdHeader = [
        'atl-traceid',
        'x-trace-id'
    ].find((header)=>response.headers?.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
class $a7b1698780ff1c70$var$FetchError extends Error {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
const $a7b1698780ff1c70$var$getDevHostname = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
const $a7b1698780ff1c70$var$getProxyServerPort = ()=>{
    return 9000;
};
const $a7b1698780ff1c70$var$LOCAL_URL = new URL(`${'http'}://${$a7b1698780ff1c70$var$getDevHostname()}:${$a7b1698780ff1c70$var$getProxyServerPort()}`);
const $a7b1698780ff1c70$var$getReroutableURL = (pathOrURL)=>{
    var e;
    return pathOrURL;
};
const $a7b1698780ff1c70$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
let $a7b1698780ff1c70$var$cachedFetches = {};
let $a7b1698780ff1c70$var$siteOptoutStatuses = {};
let $a7b1698780ff1c70$var$siteUserOptoutStatuses = {};
let $a7b1698780ff1c70$var$firedAnalyticsEvents = {};
let $a7b1698780ff1c70$var$isAnalyticsDebounceEnabled = true;
const $a7b1698780ff1c70$export$d2adf65b87e47523 = ()=>{
    $a7b1698780ff1c70$var$siteOptoutStatuses = {};
    $a7b1698780ff1c70$var$siteUserOptoutStatuses = {};
    $a7b1698780ff1c70$var$cachedFetches = {};
};
const $a7b1698780ff1c70$var$clearFetchCacheForUrl = (url)=>{
    delete $a7b1698780ff1c70$var$cachedFetches[url];
};
const $a7b1698780ff1c70$var$fetchJsonWithCache = (url, options = {})=>{
    let fetchPromise = $a7b1698780ff1c70$var$cachedFetches[url];
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch($a7b1698780ff1c70$var$getReroutableURL(url), {
        ...$a7b1698780ff1c70$var$defaultOptions,
        ...options
    });
    $a7b1698780ff1c70$var$cachedFetches[url] = fetchPromise;
    return fetchPromise;
};
const $a7b1698780ff1c70$var$fetchJson = (url, options = {})=>$a7b1698780ff1c70$var$fetchJsonWithCache(url, options).then((response)=>{
        if (!response.ok) {
            const traceId = $a7b1698780ff1c70$var$getTraceId(response);
            if (traceId !== undefined && traceId.length > 0) throw new $a7b1698780ff1c70$var$FetchError(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new $a7b1698780ff1c70$var$FetchError(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.clone().json();
    });
const $a7b1698780ff1c70$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $a7b1698780ff1c70$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $a7b1698780ff1c70$var$parseOptoutTraitStatus = (attributes, attributeName)=>{
    const optoutValue = attributes.find(({ name: name })=>name === attributeName)?.value;
    return optoutValue ? 'is-opted-out' : 'no-opt-out';
};
const $a7b1698780ff1c70$var$parseSiteOptoutTraitStatus = (attributes)=>{
    return $a7b1698780ff1c70$var$parseOptoutTraitStatus(attributes, (0, $394a9928c728682e$export$a4c96b4ef1bf8976));
};
const $a7b1698780ff1c70$var$parseSiteUserOptoutTraitStatus = (attributes)=>{
    return $a7b1698780ff1c70$var$parseOptoutTraitStatus(attributes, (0, $394a9928c728682e$export$f64870f8abb59f0b));
};
const $a7b1698780ff1c70$var$fetchSiteTraitData = async (cloudId)=>{
    if (Boolean($a7b1698780ff1c70$var$siteOptoutStatuses[cloudId]) && ($a7b1698780ff1c70$var$siteOptoutStatuses[cloudId] === 'is-opted-out' || $a7b1698780ff1c70$var$siteOptoutStatuses[cloudId] === 'no-opt-out')) return {
        optoutStatus: $a7b1698780ff1c70$var$siteOptoutStatuses[cloudId],
        cached: true
    };
    try {
        const url = $a7b1698780ff1c70$var$getPersonalizationSiteTraitsUrl(cloudId);
        if ($a7b1698780ff1c70$var$siteOptoutStatuses[cloudId] === 'error') $a7b1698780ff1c70$var$clearFetchCacheForUrl(url);
        const { attributes: attributes } = await $a7b1698780ff1c70$var$fetchJson(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $a7b1698780ff1c70$var$siteOptoutStatuses[cloudId] = $a7b1698780ff1c70$var$parseSiteOptoutTraitStatus(attributes);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site personalization:', error);
        $a7b1698780ff1c70$var$siteOptoutStatuses[cloudId] = 'error';
        throw error;
    }
    return {
        optoutStatus: $a7b1698780ff1c70$var$siteOptoutStatuses[cloudId],
        cached: false
    };
};
const $a7b1698780ff1c70$var$fetchSiteUserTraitData = async (cloudId, userId)=>{
    if (Boolean($a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId]?.[userId]) && ($a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'is-opted-out' || $a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'no-opt-out')) return {
        optoutStatus: $a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId]?.[userId],
        cached: true
    };
    try {
        const url = $a7b1698780ff1c70$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId);
        if ($a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'error') $a7b1698780ff1c70$var$clearFetchCacheForUrl(url);
        const { attributes: attributes } = await $a7b1698780ff1c70$var$fetchJson(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId] = {
            ...$a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: $a7b1698780ff1c70$var$parseSiteUserOptoutTraitStatus(attributes)
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site user personalization:', error);
        $a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId] = {
            ...$a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: 'error'
        };
        throw error;
    }
    return {
        optoutStatus: $a7b1698780ff1c70$var$siteUserOptoutStatuses[cloudId][userId],
        cached: false
    };
};
/**
 * | Site / Site user | initial      | is-opted-out | no-opt-out   | error        |
 * |------------------|--------------|--------------|--------------|--------------|
 * | initial          | initial      | is-opted-out | initial      | initial      |
 * | is-opted-out     | is-opted-out | is-opted-out | is-opted-out | is-opted-out |
 * | no-opt-out       | initial      | is-opted-out | no-opt-out   | error        |
 * | error            | initial      | is-opted-out | error        | error        |
 * @param siteOptoutValue
 * @param siteUserOptoutValue
 */ const $a7b1698780ff1c70$var$combineOptoutValue = (siteOptoutValue, siteUserOptoutValue)=>{
    const matrix = {
        initial: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'initial',
            error: 'initial'
        },
        'is-opted-out': {
            initial: 'is-opted-out',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'is-opted-out',
            error: 'is-opted-out'
        },
        'no-opt-out': {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'no-opt-out',
            error: 'error'
        },
        error: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'error',
            error: 'error'
        }
    };
    return matrix[siteOptoutValue][siteUserOptoutValue] || 'initial';
};
const $a7b1698780ff1c70$export$433d05f24f06f81a = (enabled)=>{
    $a7b1698780ff1c70$var$isAnalyticsDebounceEnabled = enabled;
};
const $a7b1698780ff1c70$var$isAnalyticsEventFiredWithinDebounceWindow = (eventName, touchpointId)=>{
    const currentTime = Date.now();
    const lastFiredTime = $a7b1698780ff1c70$var$firedAnalyticsEvents[eventName]?.[touchpointId] ?? 0;
    if (currentTime - lastFiredTime < (0, $394a9928c728682e$export$338a9c38f183f620)) return true;
    $a7b1698780ff1c70$var$firedAnalyticsEvents[eventName] = {
        ...$a7b1698780ff1c70$var$firedAnalyticsEvents[eventName] ?? {},
        [touchpointId]: currentTime
    };
    return false;
};
const $a7b1698780ff1c70$var$fireTrackAnalytics = (analyticsEvent, eventName, attributes)=>{
    if ($a7b1698780ff1c70$var$isAnalyticsDebounceEnabled && attributes.touchpointId && $a7b1698780ff1c70$var$isAnalyticsEventFiredWithinDebounceWindow(eventName, attributes.touchpointId)) return;
    const clonedEvent = analyticsEvent.clone();
    if (clonedEvent) {
        const [actionSubject, action] = eventName.split(' ');
        clonedEvent.update({
            eventType: (0, $394a9928c728682e$export$947dac6c72b26f81),
            actionSubject: actionSubject,
            action: action,
            attributes: {
                ...clonedEvent.payload?.attributes ?? {},
                ...attributes ?? {}
            }
        });
        clonedEvent.fire((0, $394a9928c728682e$export$85183a312807388d));
    }
};
const $a7b1698780ff1c70$export$9af97c6b33df5bae = async (touchpointId, cloudId, analyticsEvent, options)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $a7b1698780ff1c70$var$fetchSiteTraitData(cloudId);
        optoutStatus = fetchResult.optoutStatus;
        if (analyticsEvent) $a7b1698780ff1c70$var$fireTrackAnalytics(analyticsEvent, (0, $394a9928c728682e$export$5ede056addcc7dcf), {
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus,
            cached: fetchResult.cached
        });
    } catch (error) {
        if (analyticsEvent) $a7b1698780ff1c70$var$fireTrackAnalytics(analyticsEvent, (0, $394a9928c728682e$export$a16c0f38ba8f83e8), {
            error: error instanceof $a7b1698780ff1c70$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $a7b1698780ff1c70$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        options?.onError?.(error);
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $a7b1698780ff1c70$export$a9e7c50f402a03d2 = async (touchpointId, cloudId, userId, analyticsEvent, options)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $a7b1698780ff1c70$var$fetchSiteUserTraitData(cloudId, userId);
        optoutStatus = fetchResult.optoutStatus;
        if (analyticsEvent) $a7b1698780ff1c70$var$fireTrackAnalytics(analyticsEvent, (0, $394a9928c728682e$export$2b6f8d7fd154b638), {
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus,
            cached: fetchResult.cached
        });
    } catch (error) {
        if (analyticsEvent) $a7b1698780ff1c70$var$fireTrackAnalytics(analyticsEvent, (0, $394a9928c728682e$export$74a38b22acdaeea2), {
            error: error instanceof $a7b1698780ff1c70$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $a7b1698780ff1c70$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        options?.onError?.(error);
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $a7b1698780ff1c70$export$aa440d3a24a2d79a = async (touchpointId, cloudId, userId, analyticsEvent, options)=>{
    if (userId) {
        const [siteOptoutPayload, siteUserOptoutPayload] = await Promise.all([
            $a7b1698780ff1c70$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent, options),
            $a7b1698780ff1c70$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, analyticsEvent, options)
        ]);
        try {
            return {
                optoutStatus: $a7b1698780ff1c70$var$combineOptoutValue(siteOptoutPayload.optoutStatus, siteUserOptoutPayload.optoutStatus)
            };
        } catch (error) {
            options?.onError?.(error);
            return {
                optoutStatus: 'error'
            };
        }
    }
    return $a7b1698780ff1c70$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent, options);
};
const $a7b1698780ff1c70$export$ef6308b7e747ceec = (touchpointId, cloudId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $eJOHy.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    (0, $eJOHy.useEffect)(()=>{
        if (!isDisabled) $a7b1698780ff1c70$export$9af97c6b33df5bae(touchpointId, cloudId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $a7b1698780ff1c70$export$e5b57ebc3eed2ecb = (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $eJOHy.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    (0, $eJOHy.useEffect)(()=>{
        if (!isDisabled) $a7b1698780ff1c70$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $a7b1698780ff1c70$export$7d4c6b519725ba3b = (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $eJOHy.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    (0, $eJOHy.useEffect)(()=>{
        if (!isDisabled) $a7b1698780ff1c70$export$aa440d3a24a2d79a(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        }).catch((error)=>{
            onError?.(error);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError
    ]);
    return {
        optoutStatus: optoutStatus
    };
};

});
const $394a9928c728682e$export$a4c96b4ef1bf8976 = 'optout_all_messages';
const $394a9928c728682e$export$f64870f8abb59f0b = 'optout_all_messages_user';
const $394a9928c728682e$export$48e1d3fa57b0a2d5 = 'optoutAllMessages';
const $394a9928c728682e$export$5ede056addcc7dcf = `${$394a9928c728682e$export$48e1d3fa57b0a2d5}.fetchSiteOptout succeeded`;
const $394a9928c728682e$export$a16c0f38ba8f83e8 = `${$394a9928c728682e$export$48e1d3fa57b0a2d5}.fetchSiteOptout failed`;
const $394a9928c728682e$export$2b6f8d7fd154b638 = `${$394a9928c728682e$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout succeeded`;
const $394a9928c728682e$export$74a38b22acdaeea2 = `${$394a9928c728682e$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout failed`;
const $394a9928c728682e$export$85183a312807388d = 'postOffice';
const $394a9928c728682e$export$947dac6c72b26f81 = 'track';
const $394a9928c728682e$export$338a9c38f183f620 = 100; // 0.1 second



parcelRegister("6qOE4", function(module, exports) {
$parcel$export(module.exports, "Recommendations", () => $fd064e8a228e9597$export$ebd86fc7badb9a5d);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $4ViLY = parcelRequire("4ViLY");

var $jC4hB = parcelRequire("jC4hB");

var $8UGYZ = parcelRequire("8UGYZ");
const $fd064e8a228e9597$export$ebd86fc7badb9a5d = ({ appRecommendations: appRecommendations, sessionId: sessionId })=>{
    const [isDismissed, setIsDismissed] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedRecommendationState = (0, $4ViLY.useSelectedRecommendation)({
        appRecommendations: appRecommendations
    });
    const onDismissRecommendation = (0, $eJOHy.useCallback)(()=>{
        setIsDismissed(true);
    }, []);
    if (!selectedRecommendationState?.recommendationKey) return null;
    const selectedRecommendation = (0, $8UGYZ.recommendationsList).find((recommendation)=>recommendation.key === selectedRecommendationState.recommendationKey);
    return selectedRecommendation && !isDismissed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $jC4hB.default).sectionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(selectedRecommendation.Component, {
        recommendationKey: selectedRecommendation.key,
        dismissRecommendation: onDismissRecommendation,
        sessionId: sessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        attributes: {
            recommendationType: selectedRecommendation.key
        }
    })))));
};

});
parcelRegister("4ViLY", function(module, exports) {
$parcel$export(module.exports, "useSelectedRecommendation", () => $e4b27151a084729d$export$6a60b75e3f5ce2aa);
// import shuffle from 'lodash/shuffle';

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $8UGYZ = parcelRequire("8UGYZ");

var $83AMS = parcelRequire("83AMS");
const $e4b27151a084729d$export$6a60b75e3f5ce2aa = ({ appRecommendations: appRecommendations })=>{
    const recommendationContext = (0, $83AMS.useRecommendationContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // NOTE: having shufle here will cause different order of data on SSR and client resulting in a UI change after first render
    // which may not seem like a good UX
    // const shuffledRecommendations = shuffle(recommendations);
    /* 	useMemo here prevents running this code each time user navigates a different route which triggers
		re-render of projects which then re-renders Recommendations component.
		memoisation also prevents sending operational analytics on each re-render
	*/ const recommendationStatus = (0, $eJOHy.useMemo)(()=>(0, $8UGYZ.recommendationsList).map((recommendation)=>{
            if (!recommendationContext) return {
                key: recommendation.key,
                isEnabled: false
            };
            const isEnabled = recommendation.shouldRender(recommendationContext, createAnalyticsEvent({}), appRecommendations);
            return {
                key: recommendation.key,
                isEnabled: isEnabled
            };
        }), [
        appRecommendations,
        createAnalyticsEvent,
        recommendationContext
    ]);
    if (!recommendationContext) return {
        recommendationKey: null
    };
    const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
    return {
        recommendationKey: selectedRecommendation?.key || null
    };
};

});
parcelRegister("8UGYZ", function(module, exports) {
$parcel$export(module.exports, "recommendationsList", () => $f089b324e4d1757e$export$2ff783c2bb2ac3b1);

var $61zru = parcelRequire("61zru");
const $f089b324e4d1757e$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $61zru.jpdRecommendation));
    // Add your own templates
    return recommendationsList;
};
const $f089b324e4d1757e$export$2ff783c2bb2ac3b1 = $f089b324e4d1757e$var$createRecommendationsList();

});
parcelRegister("61zru", function(module, exports) {
$parcel$export(module.exports, "jpdRecommendation", () => $2b389bdc8044134d$export$f0837513113a320d);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("izzcG");
var $8gGau = parcelRequire("8gGau");
var $2Lqz3 = parcelRequire("2Lqz3");
parcelRequire("6X7AJ");
var $iE1pm = parcelRequire("iE1pm");
var $cqw6Y = parcelRequire("cqw6Y");parcelRequire("dNnxZ");
var $6UCnr = parcelRequire("6UCnr");

var $goZPP = parcelRequire("goZPP");

var $jdqdp = parcelRequire("jdqdp");

var $3cMgR = parcelRequire("3cMgR");

var $FppkK = parcelRequire("FppkK");

var $9pTd3 = parcelRequire("9pTd3");

var $lRq8t = parcelRequire("lRq8t");







var $i0tMD = parcelRequire("i0tMD");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $kyq27 = parcelRequire("kyq27");

var $1Yvty = parcelRequire("1Yvty");

var $4cTDP = parcelRequire("4cTDP");

var $cblKs = parcelRequire("cblKs");

var $bO0cE = parcelRequire("bO0cE");


var $h1sdf = parcelRequire("h1sdf");

var $9WdeT = parcelRequire("9WdeT");

var $gj96A = parcelRequire("gj96A");

var $8RtfX = parcelRequire("8RtfX");
const $2b389bdc8044134d$export$da956fe610b96f73 = ({ recommendationKey: recommendationKey, dismissRecommendation: dismissRecommendation, sessionId: sessionId })=>{
    const reasonsModalBulletTwoAppify = (0, $4cTDP.fg)('product-terminology-refresh') ? (0, $9WdeT.default).reasonsModalBulletTwoAppify : (0, $9WdeT.default).reasonsModalBulletTwo;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const crossFlow = (0, $cqw6Y.useCrossFlow)();
    const accountId = (0, $e6YEs.useAccountId)();
    const environment = (0, $kyq27.useEnvironment)();
    const jpdCloudCCPProductID = (0, $h1sdf.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $1Yvty.useFireCrossFlowAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection',
            recommendationSession: {
                id: sessionId ?? '',
                type: 'appRec'
            }
        }, {
            navigationVersion: 'v4',
            projectKey: (0, $h1sdf.JPD_ROADMAP_KEY)
        });
        else (0, $9pTd3.fireErrorAnalytics)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID,
        sessionId
    ]);
    const jpdRecommendationContent = (0, $eJOHy.useMemo)(()=>{
        return {
            projectTitle: (0, $9WdeT.default).projectTitleProductRoadmap,
            projectKey: (0, $h1sdf.JPD_ROADMAP_KEY),
            projectAvatar: (0, $8RtfX.default)
        };
    }, []);
    const onLearnMoreClicked = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $16a7021d28f78da7$export$8d155d2412839524), {
            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            parentItemType: (0, $6bf6536f83c22cfe$export$9a778ca616c24a93),
            parentItemId: (0, $bc40578f06d7846b$export$de9ad1ebeca97ec1),
            itemId: (0, $bc40578f06d7846b$export$ce0bea1467165424),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            recommendationSession: {
                id: sessionId ?? '',
                type: 'appRec'
            }
        }, {
            navigationVersion: 'v4'
        });
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        sessionId
    ]);
    const onDismissClicked = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $16a7021d28f78da7$export$8d155d2412839524), {
            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            parentItemType: (0, $6bf6536f83c22cfe$export$9a778ca616c24a93),
            parentItemId: (0, $bc40578f06d7846b$export$de9ad1ebeca97ec1),
            itemId: (0, $bc40578f06d7846b$export$5c09fa42f8d45ed8),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            recommendationSession: {
                id: sessionId ?? '',
                type: 'appRec'
            }
        }, {
            navigationVersion: 'v4'
        });
        dismissRecommendation();
        if (accountId) (0, $FppkK.setUserProperties)(accountId, (0, $h1sdf.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: (0, $f9370b6235f53e1a$export$b8b9d90f9e5bd72b),
                    teamName: 'navigation'
                }
            });
        });
    }, [
        accountId,
        createAnalyticsEvent,
        dismissRecommendation,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        sessionId
    ]);
    const openCrossFlow = (0, $eJOHy.useCallback)(async (templateId)=>{
        const extensions = (0, $2Lqz3.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $8gGau.Behaviours).LAND,
                    prompt: (0, $8gGau.Prompts).NEXT,
                    options: {
                        targetTab: (0, $8gGau.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) // eslint-disable-next-line @atlassian/growth/no-deprecated-apis
        crossFlow.api.open({
            journey: (0, $iE1pm.Journeys).GET_STARTED,
            targetProduct: (0, $6UCnr.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            action: 'clicked'
        }), (0, $16a7021d28f78da7$export$8d155d2412839524), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemType: (0, $6bf6536f83c22cfe$export$9a778ca616c24a93),
            itemId: (0, $bc40578f06d7846b$export$de9ad1ebeca97ec1),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            recommendationSession: {
                id: sessionId ?? '',
                type: 'appRec'
            }
        }, {
            navigationVersion: 'v4'
        });
        openCrossFlow(jpdRecommendationContent.projectKey);
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        jpdRecommendationContent.projectKey,
        openCrossFlow,
        sessionId
    ]);
    const recommendationActionMenuClickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $16a7021d28f78da7$export$8d155d2412839524), {
            level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            parentItemType: (0, $6bf6536f83c22cfe$export$9a778ca616c24a93),
            parentItemId: (0, $bc40578f06d7846b$export$de9ad1ebeca97ec1),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(jpdRecommendationContent.projectAvatar, null),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $9WdeT.default).lozengeText)),
        href: "",
        menuId: recommendationKey,
        onClick: onRecommendationClicked,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bO0cE.RecommendationActionMenu), {
            onClick: recommendationActionMenuClickHandler,
            onLearnMoreClicked: onLearnMoreClicked,
            onDismissClicked: onDismissClicked,
            primaryCta: formatMessage((0, $9WdeT.default).reasonsModalButtonOk),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $9WdeT.default).reasonsModalExplanation, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                        as: "strong"
                    }, chunks)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage((0, $9WdeT.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage(reasonsModalBulletTwoAppify))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                spacing: "none",
                href: (0, $f9370b6235f53e1a$export$aefe1c8741b24a28),
                target: "_blank"
            }, formatMessage((0, $9WdeT.default).privacyPolicy))),
            title: formatMessage((0, $9WdeT.default).reasonsModalTitle)
        })
    }, formatMessage(jpdRecommendationContent.projectTitle)));
};
const $2b389bdc8044134d$var$checkEligibility = (recommendationContext, appRecommendations)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, accountId: accountId, edition: edition, jsmEdition: jsmEdition, coreEdition: coreEdition, customerServiceEdition: customerServiceEdition, jpdRecommendationDismissed: jpdRecommendationDismissed } = recommendationContext;
    if ((0, $4cTDP.fg)('grw-1467_jpd_reco_eligibility_override_gate')) return {
        isEligible: true,
        reason: 'Eligibility override gate is enabled'
    };
    if (!accountId) return {
        isEligible: false,
        reason: 'Account Id is null'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $gj96A.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (jpdRecommendationDismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((entityId)=>entityId === (0, $h1sdf.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    const hasStandardOrPremiumEditions = [
        edition ?? (0, $cblKs.UNLICENSED),
        jsmEdition ?? (0, $cblKs.UNLICENSED),
        coreEdition ?? (0, $cblKs.UNLICENSED),
        customerServiceEdition ?? (0, $cblKs.UNLICENSED)
    ].some((ed)=>ed === (0, $cblKs.STANDARD_EDITION) || ed === (0, $cblKs.PREMIUM_EDITION));
    if (hasStandardOrPremiumEditions && !(0, $4cTDP.fg)('grw-997_-_jpd_recommendation_nav_4_paid_users')) return {
        isEligible: false,
        reason: 'User has paid edition but failed grw-997_-_jpd_recommendation_nav_4_paid_users gate'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
const $2b389bdc8044134d$export$f0837513113a320d = {
    key: (0, $h1sdf.JPD_RECOMMENDATION_KEY),
    shouldRender: (recommendationContext, analyticsEvent, appRecommendations)=>{
        const { isEligible: isEligible, reason: reason } = $2b389bdc8044134d$var$checkEligibility(recommendationContext, appRecommendations);
        if ((0, $4cTDP.fg)('pm_jpd_reco_operational_event_activated')) (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        return isEligible;
    },
    Component: $2b389bdc8044134d$export$da956fe610b96f73
};

});
parcelRegister("izzcG", function(module, exports) {
$parcel$export(module.exports, "Behaviours", () => (parcelRequire("8gGau")).Behaviours);
$parcel$export(module.exports, "TargetTabs", () => (parcelRequire("8gGau")).TargetTabs);
$parcel$export(module.exports, "Prompts", () => (parcelRequire("8gGau")).Prompts);
$parcel$export(module.exports, "createProvisioningPageExtensions", () => (parcelRequire("2Lqz3")).createProvisioningPageExtensions);
$parcel$export(module.exports, "createProvisioningApiExtensions", () => (parcelRequire("eE9QR")).createProvisioningApiExtensions);
$parcel$export(module.exports, "createRecommendationContextExtensions", () => (parcelRequire("k2xeV")).createRecommendationContextExtensions);

var $8gGau = parcelRequire("8gGau");

var $hkOzJ = parcelRequire("hkOzJ");

var $7oRWl = parcelRequire("7oRWl");

var $e8WdV = parcelRequire("e8WdV");

var $2Lqz3 = parcelRequire("2Lqz3");

var $eE9QR = parcelRequire("eE9QR");

var $k2xeV = parcelRequire("k2xeV");

var $bpY2r = parcelRequire("bpY2r");

});
parcelRegister("8gGau", function(module, exports) {
$parcel$export(module.exports, "Behaviours", () => $eacbd6a89b2a2945$export$993d0f36af4bf76f);
$parcel$export(module.exports, "TargetTabs", () => $eacbd6a89b2a2945$export$c57f0d43fd595f43);
$parcel$export(module.exports, "Prompts", () => $eacbd6a89b2a2945$export$d1609d6291f3d60d);
const $eacbd6a89b2a2945$export$696c71818ae3f184 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ESSENTIALS: 'essentials',
    ENTERPRISE: 'enterprise'
};
const $eacbd6a89b2a2945$export$993d0f36af4bf76f = {
    LAND: 'land',
    CLOSE: 'close'
};
const $eacbd6a89b2a2945$export$c57f0d43fd595f43 = {
    SAME: 'same',
    NEW: 'new'
};
const $eacbd6a89b2a2945$export$d1609d6291f3d60d = {
    NEXT: 'next',
    CLOSE: 'close',
    GO_TO_PRODUCT: 'go-to-product',
    RETURN_TO_PRODUCT: 'return-to-product'
};

});

parcelRegister("hkOzJ", function(module, exports) {

var $bpY2r = parcelRequire("bpY2r");

var $8gGau = parcelRequire("8gGau");
const $0d6dbf28c47da868$export$196a138f6d49c2bb = [
    'edition'
];
const $0d6dbf28c47da868$export$28c762e8047316d8 = (0, $bpY2r.createProductExtensions)($0d6dbf28c47da868$export$196a138f6d49c2bb);

});
parcelRegister("bpY2r", function(module, exports) {
$parcel$export(module.exports, "createProductExtensions", () => $97a444e803a87e18$export$42e62ee12e8ced48);
parcelRequire("dNnxZ");
var $gEdNf = parcelRequire("gEdNf");
const $97a444e803a87e18$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
        const value = object[property];
        if (value !== undefined) accumulator[property] = value;
        return accumulator;
    }, {});
const $97a444e803a87e18$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
        const filteredOptions = $97a444e803a87e18$export$9143c254bff9f7b7(options, extensionsWhitelist);
        return new (0, $gEdNf.CrossFlowExtensions)(filteredOptions);
    };
const $97a444e803a87e18$export$86a865d89ef3c690 = (...extensions)=>{
    const combinedOptions = Object.assign({}, ...extensions);
    return new (0, $gEdNf.CrossFlowExtensions)(combinedOptions);
};

});


parcelRegister("7oRWl", function(module, exports) {

var $bpY2r = parcelRequire("bpY2r");

var $8gGau = parcelRequire("8gGau");
const $fd464ec6473abe38$export$390f3b1f433f2095 = [
    'edition',
    'migrationSourceUuid',
    'grantAccessTo'
];
const $fd464ec6473abe38$export$386012fe624cad4 = (0, $bpY2r.createProductExtensions)($fd464ec6473abe38$export$390f3b1f433f2095);

});

parcelRegister("e8WdV", function(module, exports) {

var $bpY2r = parcelRequire("bpY2r");

var $8gGau = parcelRequire("8gGau");
const $7ed35912a8b8e380$export$c41268b4369999ed = [
    'edition',
    'migrationSourceUuid'
];
const $7ed35912a8b8e380$export$a60e4abab2cc3b2b = (0, $bpY2r.createProductExtensions)($7ed35912a8b8e380$export$c41268b4369999ed);

});

parcelRegister("2Lqz3", function(module, exports) {
$parcel$export(module.exports, "createProvisioningPageExtensions", () => $8bd88ec0ead82204$export$f05508383d0ca130);

var $bpY2r = parcelRequire("bpY2r");
const $8bd88ec0ead82204$export$99f81e179e225ceb = [
    'provisioningPageOptions'
];
const $8bd88ec0ead82204$export$f05508383d0ca130 = (options)=>(0, $bpY2r.createProductExtensions)($8bd88ec0ead82204$export$99f81e179e225ceb)({
        provisioningPageOptions: options
    });

});

parcelRegister("eE9QR", function(module, exports) {
$parcel$export(module.exports, "createProvisioningApiExtensions", () => $df60972be036f347$export$530ae557c94159b9);

var $bpY2r = parcelRequire("bpY2r");
const $df60972be036f347$export$bba48927994d7f26 = [
    'provisioningApiParams'
];
const $df60972be036f347$export$530ae557c94159b9 = (options)=>(0, $bpY2r.createProductExtensions)($df60972be036f347$export$bba48927994d7f26)({
        provisioningApiParams: options
    });

});

parcelRegister("k2xeV", function(module, exports) {
$parcel$export(module.exports, "createRecommendationContextExtensions", () => $1b3a206f70765c82$export$d1baeed0bd0517aa);

var $bpY2r = parcelRequire("bpY2r");
const $1b3a206f70765c82$export$4227e3a27cbd377 = [
    'recommendationContext'
];
const $1b3a206f70765c82$export$d1baeed0bd0517aa = (options)=>(0, $bpY2r.createProductExtensions)($1b3a206f70765c82$export$4227e3a27cbd377)({
        recommendationContext: options
    });

});


parcelRegister("bO0cE", function(module, exports) {
$parcel$export(module.exports, "RecommendationActionMenu", () => $b977177bf32101c2$export$ff27431731859712);

var $eJOHy = parcelRequire("eJOHy");

var $NByNW = parcelRequire("NByNW");

var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $dxcgx = parcelRequire("dxcgx");

var $dFdj2 = parcelRequire("dFdj2");

var $i0Ev8 = parcelRequire("i0Ev8");

var $g3C06 = parcelRequire("g3C06");

var $cJEMq = parcelRequire("cJEMq");

var $7WFmW = parcelRequire("7WFmW");
const $b977177bf32101c2$var$MENU_TEST_ID = 'recommendations-common.ui.recommendation-popup-menu.menu-group';
// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $b977177bf32101c2$var$CustomTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        hideTooltipOnClick: true,
        content: formatMessage((0, $7WFmW.default).moreActions),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
            label: formatMessage((0, $7WFmW.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.common.ui.recommendation-action-menu.themed-button"
    }));
});
const $b977177bf32101c2$var$LearnMoreTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onLearnMoreClicked: onLearnMoreClicked }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/anchor-is-valid -- See https://go/a11y-anchor-is-valid for more details
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        ref: ref,
        onClick: onLearnMoreClicked
    }, formatMessage((0, $7WFmW.default).whyAmISeeingThis)));
});
const $b977177bf32101c2$export$ff27431731859712 = ({ onClick: onClick, onLearnMoreClicked: onLearnMoreClicked, onDismissClicked: onDismissClicked, body: body, primaryCta: primaryCta, title: title })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            body: body,
            primaryCta: primaryCta,
            title: title
        }), [
        body,
        primaryCta,
        title
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 400,
            height: 440
        }), []);
    const MenuItems = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
            testId: $b977177bf32101c2$var$MENU_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
            onClick: ()=>onDismissClicked()
        }, formatMessage((0, $7WFmW.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
            entryPoint: (0, $dFdj2.GrowthRecommendationsEntrypoint),
            entryPointProps: entryPointParams,
            modalProps: modalProps,
            useInternalModal: false
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b977177bf32101c2$var$LearnMoreTrigger, {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: ref,
                onLearnMoreClicked: onLearnMoreClicked
            })))), [
        entryPointParams,
        formatMessage,
        modalProps,
        onDismissClicked,
        onLearnMoreClicked
    ]);
    const content = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g3C06.MenuContent), {
            ...contentProps,
            MenuItems: MenuItems
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0Ev8.MenuContainer), {
        content: content,
        onClick: onClick,
        CustomTrigger: $b977177bf32101c2$var$CustomTrigger
    });
};

});
parcelRegister("dFdj2", function(module, exports) {
$parcel$export(module.exports, "GrowthRecommendationsEntrypoint", () => $8809b280bf872a7b$export$f926c2f51211d688);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $8809b280bf872a7b$export$f926c2f51211d688 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lyZM6")).then(({ GrowthRecommendationModal: GrowthRecommendationModal })=>GrowthRecommendationModal), {
        moduleId: "356e09a2",
        moduleName: "GrowthRecommendationModal",
        priority: "interaction"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("lyZM6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ch3xJ").then(()=>parcelRequire('wiDoP'));

});


parcelRegister("i0Ev8", function(module, exports) {
$parcel$export(module.exports, "MenuContainer", () => $3a1ab3ba3bb2ee1c$export$b286f91cddfedb5a);

var $eJOHy = parcelRequire("eJOHy");

var $he6m3 = parcelRequire("he6m3");

var $hih5V = parcelRequire("hih5V");

var $8nMzv = parcelRequire("8nMzv");

var $4cTDP = parcelRequire("4cTDP");

var $6Vosf = parcelRequire("6Vosf");
const $3a1ab3ba3bb2ee1c$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef, shouldRenderToParent: shouldRenderToParent = true, projectName: projectName })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $he6m3.useOpenable)();
    const route = (0, $hih5V.useCurrentRoute)();
    const handleClose = (0, $eJOHy.useCallback)((e)=>{
        try {
            onCloseCustom?.(e);
        } finally{
            onClose();
        }
    }, [
        onCloseCustom,
        onClose
    ]);
    const onClickHandler = (0, $eJOHy.useCallback)(()=>{
        onToggle();
        onClick?.();
    }, [
        onClick,
        onToggle
    ]);
    const trigger = (triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return CustomTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CustomTrigger, {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Vosf.MenuTriggerButton), {
            ...(0, $4cTDP.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                name: projectName
            } : {},
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        messageId: "navigation-project-action-menu.ui.menu-container.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: route.name.includes('legacy') ? false : shouldRenderToParent,
        strategy: "absolute"
    });
};

});
parcelRegister("6Vosf", function(module, exports) {
$parcel$export(module.exports, "MenuTriggerButton", () => $dda383502f47ef3e$export$a24e6f6ddd974e33);

var $eJOHy = parcelRequire("eJOHy");

var $NByNW = parcelRequire("NByNW");

var $Ay1uj = parcelRequire("Ay1uj");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $c5ZPx = parcelRequire("c5ZPx");
const $dda383502f47ef3e$export$a24e6f6ddd974e33 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)",
                size: "small"
            }),
        label: (0, $4cTDP.fg)('jsm_aiiy_for_nav_item_sidebar') ? formatMessage((0, $c5ZPx.default).projectActionsMenuName, {
            name: name
        }) : formatMessage((0, $c5ZPx.default).projectActionsMenu),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle",
        testId: "navigation-project-action-menu.ui.menu-container.themed-button",
        isTooltipDisabled: false,
        tooltip: {
            content: formatMessage((0, $c5ZPx.default).projectActionsMenu),
            hideTooltipOnClick: true
        }
    });
});

});
parcelRegister("c5ZPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c00dd7908288fb54$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c00dd7908288fb54$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectActionsMenu: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu",
        "defaultMessage": "More actions"
    },
    projectActionsMenuName: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu-name",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("g3C06", function(module, exports) {
$parcel$export(module.exports, "MenuContent", () => $d0ffa4011c91f6be$export$479f0f2f71193efe);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $8IeH1 = parcelRequire("8IeH1");

var $5Q9JR = parcelRequire("5Q9JR");
const $d0ffa4011c91f6be$var$stopEventPropagation = (event)=>event.stopPropagation();
const $d0ffa4011c91f6be$export$479f0f2f71193efe = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        onMouseEnter: $d0ffa4011c91f6be$var$stopEventPropagation,
        onMouseLeave: $d0ffa4011c91f6be$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuItems, {
        onClose: onClose
    })));

});

parcelRegister("cJEMq", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $a37d1ebc6d556273$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");
const $a37d1ebc6d556273$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a37d1ebc6d556273$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a37d1ebc6d556273$var$CustomButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $cA0Y2.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7WFmW", function(module, exports) {
$parcel$export(module.exports, "default", () => $732fd70691af7f1b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $732fd70691af7f1b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    whyAmISeeingThis: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.why-am-i-seeing-this",
        "defaultMessage": "Why am I seeing this?"
    },
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.more-actions",
        "defaultMessage": "More actions"
    },
    dismissButtonText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    }
});

});


parcelRegister("h1sdf", function(module, exports) {
$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $d777c06b0a0e69ef$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $d777c06b0a0e69ef$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $d777c06b0a0e69ef$export$52b9dedc0088f8);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $d777c06b0a0e69ef$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $d777c06b0a0e69ef$export$29629758934356a6);

var $dUrLZ = parcelRequire("dUrLZ");
const $d777c06b0a0e69ef$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $d777c06b0a0e69ef$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $d777c06b0a0e69ef$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $d777c06b0a0e69ef$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $d777c06b0a0e69ef$export$909712ccf16883d = 'jira.polaris:discovery';
const $d777c06b0a0e69ef$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("9WdeT", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fd08661f82921fe$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9fd08661f82921fe$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    projectTitleProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
        "defaultMessage": "Create a roadmap"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    },
    reasonsModalBulletTwoAppify: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two-appify",
        "defaultMessage": "the way you use your existing tools and apps"
    },
    projectTitleGalaxia: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-galaxia",
        "defaultMessage": "New discovery space"
    }
});

});

parcelRegister("gj96A", function(module, exports) {
$parcel$export(module.exports, "hasJpdLicense", () => $926e07c6e6e2bfbd$export$2ea69a0925803655);
const $926e07c6e6e2bfbd$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});

parcelRegister("8RtfX", function(module, exports) {
$parcel$export(module.exports, "default", () => $713e113ae3c5e3c6$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $jH2wl = parcelRequire("jH2wl");
const $713e113ae3c5e3c6$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jH2wl)))
    });
};
var $713e113ae3c5e3c6$export$2e2bcd8739ae039 = $713e113ae3c5e3c6$var$ProductRoadmapProjectAvatar;

});
parcelRegister("5DgXR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f07091e9efaebfd0$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ftN6c = parcelRequire("ftN6c");

var $gl2vi = parcelRequire("gl2vi");

var $iwbbq = parcelRequire("iwbbq");

var $l8fMV = parcelRequire("l8fMV");

var $fXN6p = parcelRequire("fXN6p");

var $1vYnd = parcelRequire("1vYnd");

var $bLsBv = parcelRequire("bLsBv");

var $j8kj1 = parcelRequire("j8kj1");
const $f07091e9efaebfd0$var$packageName = "platform-pkg";
const $f07091e9efaebfd0$var$packageVersion = "0.0.0-use.local";
const $f07091e9efaebfd0$var$containerStyles = null; // eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $f07091e9efaebfd0$var$Avatar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', isDecorative: isDecorative = false, imgLoading: imgLoading }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const context = (0, $l8fMV.useAvatarContext)();
    const size = sizeProp || context?.size || 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $eJOHy.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $eJOHy.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $eJOHy.useRef)(analyticsContext);
    const labelId = (0, $gl2vi.useId)();
    (0, $eJOHy.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $eJOHy.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $f07091e9efaebfd0$var$packageName,
                packageVersion: $f07091e9efaebfd0$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $f07091e9efaebfd0$var$packageName,
            packageVersion: $f07091e9efaebfd0$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l8fMV.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l8fMV.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $j8kj1.getCustomElement)(isDisabled, href, onClick),
                        appearance: appearance,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        avatarImage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fXN6p.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iwbbq.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1vYnd.PresenceWrapper), {
                    appearance: appearance,
                    size: size,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bLsBv.StatusWrapper), {
                    appearance: appearance,
                    size: size,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$f07091e9efaebfd0$var$Avatar.displayName = 'Avatar';
var $f07091e9efaebfd0$export$2e2bcd8739ae039 = $f07091e9efaebfd0$var$Avatar;

});
parcelRegister("iwbbq", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $8203d1394f4a7c47$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $l8fMV = parcelRequire("l8fMV");
const $8203d1394f4a7c47$var$boxShadowCssVar = '--avatar-box-shadow';
const $8203d1394f4a7c47$var$bgColorCssVar = '--avatar-bg-color';
const $8203d1394f4a7c47$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $8203d1394f4a7c47$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _bfhk18uv _mkrz1k6g _1o9o1p6i",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $8203d1394f4a7c47$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $8203d1394f4a7c47$var$marginAdjustmentMap = {
    xsmall: "_195gcwjc",
    small: "_195gcwjc",
    medium: "_195gs7t4",
    large: "_195gs7t4",
    xlarge: "_195g8ocb",
    xxlarge: "_195g1ukp"
};
const $8203d1394f4a7c47$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rko12b0 _14mj12b0",
    large: "_2rko12b0 _14mj12b0",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $8203d1394f4a7c47$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>{
    (0, $l8fMV.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex } = (0, $l8fMV.useAvatarContent)();
    const isInteractive = Boolean(onClick || href || isDisabled);
    const renderedContent = /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
        style: {
            [$8203d1394f4a7c47$var$bgColorCssVar]: borderColor,
            [$8203d1394f4a7c47$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $hcewu.default)([
            $8203d1394f4a7c47$var$unboundStyles.root,
            $8203d1394f4a7c47$var$styles.root,
            !(0, $eGOwo.fg)('platform_dst_avatar_tile') && $8203d1394f4a7c47$var$borderRadiusMap[size],
            appearance === 'square' && (0, $eGOwo.fg)('platform_dst_avatar_tile') && $8203d1394f4a7c47$var$styles.square,
            appearance === 'circle' && $8203d1394f4a7c47$var$styles.circle,
            appearance === 'hexagon' && $8203d1394f4a7c47$var$unboundStyles.hexagon,
            $8203d1394f4a7c47$var$widthHeightMap[size],
            stackIndex !== undefined && $8203d1394f4a7c47$var$styles.positionRelative,
            isInteractive && !isDisabled && $8203d1394f4a7c47$var$unboundStyles.interactive,
            isDisabled && $8203d1394f4a7c47$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$8203d1394f4a7c47$var$bgColorCssVar]: borderColor,
            [$8203d1394f4a7c47$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $hcewu.default)([
            $8203d1394f4a7c47$var$unboundStyles.hexagonFocusContainer,
            $8203d1394f4a7c47$var$marginAdjustmentMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $hcewu.default)([
                $8203d1394f4a7c47$var$unboundStyles.hexagonBorderContainer
            ]),
            children: renderedContent
        })
    });
});

});

parcelRegister("fXN6p", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecc568d6eea7f169$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fIzTE = parcelRequire("fIzTE");

var $58frP = parcelRequire("58frP");

var $6aKac = parcelRequire("6aKac");
const $ecc568d6eea7f169$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk1v33",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
const $ecc568d6eea7f169$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const $ecc568d6eea7f169$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $ecc568d6eea7f169$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58frP))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #626F86)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious",
                    LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fIzTE))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #626F86)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6aKac))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #626F86)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious",
                    LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
                });
                break;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                $ecc568d6eea7f169$var$styles.icon,
                $ecc568d6eea7f169$var$nestedSvgStylesMap[size]
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $hcewu.default)([
            $ecc568d6eea7f169$var$styles.image,
            $ecc568d6eea7f169$var$borderRadiusMap[size],
            appearance === 'circle' && $ecc568d6eea7f169$var$styles.circle,
            appearance === 'hexagon' && $ecc568d6eea7f169$var$styles.hexagon
        ])
    });
};
var $ecc568d6eea7f169$export$2e2bcd8739ae039 = $ecc568d6eea7f169$var$AvatarImage;

});
parcelRegister("fIzTE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b716cf63542993f9$var$_react = $b716cf63542993f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b716cf63542993f9$var$_baseNew = $b716cf63542993f9$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b716cf63542993f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b716cf63542993f9$var$AiAgentIcon = (props)=>/*#__PURE__*/ $b716cf63542993f9$var$_react.default.createElement($b716cf63542993f9$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$b716cf63542993f9$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $b716cf63542993f9$var$_default = module.exports.default = $b716cf63542993f9$var$AiAgentIcon;

});

parcelRegister("58frP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29971dcd1e1cc09403d75aea4f4ed622>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc9aebef14ae896$var$_react = $3bc9aebef14ae896$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3bc9aebef14ae896$var$_person = $3bc9aebef14ae896$var$_interopRequireDefault((parcelRequire("gm7H7")));

var $3bc9aebef14ae896$var$_person2 = $3bc9aebef14ae896$var$_interopRequireDefault((parcelRequire("6NCZy")));
function $3bc9aebef14ae896$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc9aebef14ae896$var$PersonIcon = (props)=>/*#__PURE__*/ $3bc9aebef14ae896$var$_react.default.createElement($3bc9aebef14ae896$var$_person.default, Object.assign({
        name: "PersonIcon",
        LEGACY_fallbackIcon: $3bc9aebef14ae896$var$_person2.default
    }, props));
$3bc9aebef14ae896$var$PersonIcon.displayName = 'PersonIconMigration';
var $3bc9aebef14ae896$var$_default = module.exports.default = $3bc9aebef14ae896$var$PersonIcon;

});
parcelRegister("6NCZy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f3590a7e2e97d7f$var$_react = $4f3590a7e2e97d7f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f3590a7e2e97d7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f3590a7e2e97d7f$var$PersonIcon = (props)=>/*#__PURE__*/ $4f3590a7e2e97d7f$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$4f3590a7e2e97d7f$var$PersonIcon.displayName = 'PersonIcon';
var $4f3590a7e2e97d7f$var$_default = module.exports.default = $4f3590a7e2e97d7f$var$PersonIcon;

});


parcelRegister("6aKac", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0234a675d9b1e030b7622cea0db1767>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47e77c5f4a34a646$var$_react = $47e77c5f4a34a646$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $47e77c5f4a34a646$var$_release = $47e77c5f4a34a646$var$_interopRequireDefault((parcelRequire("8Hdu4")));

var $47e77c5f4a34a646$var$_ship = $47e77c5f4a34a646$var$_interopRequireDefault((parcelRequire("01opv")));
function $47e77c5f4a34a646$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47e77c5f4a34a646$var$ReleaseIcon = (props)=>/*#__PURE__*/ $47e77c5f4a34a646$var$_react.default.createElement($47e77c5f4a34a646$var$_release.default, Object.assign({
        name: "ReleaseIcon",
        LEGACY_fallbackIcon: $47e77c5f4a34a646$var$_ship.default
    }, props));
$47e77c5f4a34a646$var$ReleaseIcon.displayName = 'ReleaseIconMigration';
var $47e77c5f4a34a646$var$_default = module.exports.default = $47e77c5f4a34a646$var$ReleaseIcon;

});
parcelRegister("8Hdu4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $654ccc84bbbfd6ed$var$_react = $654ccc84bbbfd6ed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $654ccc84bbbfd6ed$var$_baseNew = $654ccc84bbbfd6ed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $654ccc84bbbfd6ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $654ccc84bbbfd6ed$var$ReleaseIcon = (props)=>/*#__PURE__*/ $654ccc84bbbfd6ed$var$_react.default.createElement($654ccc84bbbfd6ed$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$654ccc84bbbfd6ed$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $654ccc84bbbfd6ed$var$_default = module.exports.default = $654ccc84bbbfd6ed$var$ReleaseIcon;

});

parcelRegister("01opv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $004307881908012c$var$_react = $004307881908012c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $004307881908012c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $004307881908012c$var$ShipIcon = (props)=>/*#__PURE__*/ $004307881908012c$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props));
$004307881908012c$var$ShipIcon.displayName = 'ShipIcon';
var $004307881908012c$var$_default = module.exports.default = $004307881908012c$var$ShipIcon;

});



parcelRegister("1vYnd", function(module, exports) {
$parcel$export(module.exports, "default", () => $f037724b2472c000$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PresenceWrapper", () => $f037724b2472c000$export$972c5e90200fa0ef);
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $25TOm = parcelRequire("25TOm");
const $f037724b2472c000$var$BusyIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $f037724b2472c000$var$FocusIndicator = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
    children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
        fill: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$b48405b95304b5a1)})`,
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $f037724b2472c000$var$OfflineIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`,
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`,
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $f037724b2472c000$var$OnlineIndicator = /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
    fill: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$940e1f69e873f202)})`,
    cx: "4",
    cy: "4",
    r: "4"
});
function $f037724b2472c000$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $f037724b2472c000$var$BusyIndicator;
        case 'focus':
            return $f037724b2472c000$var$FocusIndicator;
        case 'offline':
            return $f037724b2472c000$var$OfflineIndicator;
        case 'online':
            return $f037724b2472c000$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $f037724b2472c000$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $25TOm.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $f037724b2472c000$var$getPresence(presence)
        }) : children
    });
var $f037724b2472c000$export$2e2bcd8739ae039 = $f037724b2472c000$var$AvatarPresence;
const $f037724b2472c000$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $f037724b2472c000$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $f037724b2472c000$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $f037724b2472c000$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const $f037724b2472c000$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
const $f037724b2472c000$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $hcewu.default)([
            $f037724b2472c000$var$styles.root,
            $f037724b2472c000$var$iconSizeMap[size],
            $f037724b2472c000$var$circleIconOffsetMap[size],
            appearance === 'square' && $f037724b2472c000$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $f037724b2472c000$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f037724b2472c000$var$AvatarPresence, {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("25TOm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7047ac8a6cd37baf$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $7047ac8a6cd37baf$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $7047ac8a6cd37baf$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $7047ac8a6cd37baf$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $hcewu.default)([
            $7047ac8a6cd37baf$var$styles.root,
            $7047ac8a6cd37baf$var$unboundStyles.root
        ]),
        children: children
    });
var $7047ac8a6cd37baf$export$2e2bcd8739ae039 = $7047ac8a6cd37baf$var$IconWrapper;

});


parcelRegister("bLsBv", function(module, exports) {
$parcel$export(module.exports, "StatusWrapper", () => $bf1e9e3522c549b8$export$8045894f255f9726);
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $25TOm = parcelRequire("25TOm");
const $bf1e9e3522c549b8$var$styles = {
    root: "_kqswstnw"
};
const $bf1e9e3522c549b8$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $bf1e9e3522c549b8$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const $bf1e9e3522c549b8$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const $bf1e9e3522c549b8$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
const $bf1e9e3522c549b8$var$ApprovedIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
            fill: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$a49394138f7b8e85)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $bf1e9e3522c549b8$var$DeclinedIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $bf1e9e3522c549b8$var$LockedIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
            fill: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
function $bf1e9e3522c549b8$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $bf1e9e3522c549b8$var$ApprovedIndicator;
        case 'declined':
            return $bf1e9e3522c549b8$var$DeclinedIndicator;
        case 'locked':
            return $bf1e9e3522c549b8$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $bf1e9e3522c549b8$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $25TOm.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $bf1e9e3522c549b8$var$getStatus(status)
        }) : children
    });
var $bf1e9e3522c549b8$export$2e2bcd8739ae039 = $bf1e9e3522c549b8$var$AvatarStatus;
const $bf1e9e3522c549b8$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $hcewu.default)([
            $bf1e9e3522c549b8$var$styles.root,
            $bf1e9e3522c549b8$var$iconSizeMap[size],
            $bf1e9e3522c549b8$var$circleIconOffsetMap[size],
            appearance === 'square' && $bf1e9e3522c549b8$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $bf1e9e3522c549b8$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($bf1e9e3522c549b8$var$AvatarStatus, {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};

});

parcelRegister("j8kj1", function(module, exports) {
$parcel$export(module.exports, "getCustomElement", () => $a0d6c3f6d2433409$export$83ee468102cdf04c);
$parcel$export(module.exports, "getAppearanceForAppType", () => $a0d6c3f6d2433409$export$6b45b5bd2259198a);
const $a0d6c3f6d2433409$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};
function $a0d6c3f6d2433409$export$6b45b5bd2259198a(appType) {
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
}

});


parcelRegister("jH2wl", function(module, exports) {
module.exports = new URL("template-roadmap-icon.72864c5e.svg", import.meta.url).toString();

});




parcelRegister("83AMS", function(module, exports) {
$parcel$export(module.exports, "useRecommendationContext", () => $0fabb5ff905086b8$export$3321c0b02f750bcc);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2emAF = parcelRequire("2emAF");

var $giQoM = parcelRequire("giQoM");

var $68g4a = parcelRequire("68g4a");

var $e6YEs = parcelRequire("e6YEs");

var $1BZ8a = parcelRequire("1BZ8a");

var $1M2hR = parcelRequire("1M2hR");

var $koAZ4 = parcelRequire("koAZ4");

var $eJrcF = parcelRequire("eJrcF");
const $0fabb5ff905086b8$export$3321c0b02f750bcc = ()=>{
    const locale = (0, $1M2hR.useLocale)();
    const accountId = (0, $e6YEs.useAccountId)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $koAZ4.useTenantContext)();
    const { software: edition, serviceDesk: jsmEdition, customerService: customerServiceEdition, core: coreEdition } = (0, $1BZ8a.useAppEditions)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const jpdRecommendationDismissedResourceData = (0, $eJrcF.useResource)((0, $68g4a.jpdRecommendationDismissedResource));
    const jpdRecommendationDismissed = jpdRecommendationDismissedResourceData?.data?.hasDismissed ?? false;
    const { data: userTraitsData } = (0, $eJrcF.useResource)((0, $giQoM.fetchSiteUserTraitsResource));
    const { data: siteTraitsData } = (0, $eJrcF.useResource)((0, $2emAF.fetchSiteTraitsResource));
    return (0, $eJOHy.useMemo)(()=>({
            locale: locale,
            cloudId: cloudId,
            accountId: accountId,
            licensedProducts: licensedProducts,
            edition: edition,
            jsmEdition: jsmEdition,
            coreEdition: coreEdition,
            customerServiceEdition: customerServiceEdition,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            environment: environment,
            jpdRecommendationDismissed: jpdRecommendationDismissed,
            userTraitsData: userTraitsData,
            siteTraitsData: siteTraitsData
        }), [
        locale,
        cloudId,
        accountId,
        licensedProducts,
        edition,
        jsmEdition,
        coreEdition,
        customerServiceEdition,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        environment,
        jpdRecommendationDismissed,
        userTraitsData,
        siteTraitsData
    ]);
};

});


parcelRegister("jC4hB", function(module, exports) {
$parcel$export(module.exports, "default", () => $5758fb1ef965254d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5758fb1ef965254d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sectionTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.section-title",
        "defaultMessage": "Recommended"
    }
});

});




parcelRegister("e09p3", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b67c63ac89ee8a7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8b67c63ac89ee8a7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects",
        "defaultMessage": "View all projects"
    },
    moreProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects",
        "defaultMessage": "More projects"
    },
    viewAllProjectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects-galaxia",
        "defaultMessage": "View all spaces"
    },
    moreProjectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects-galaxia",
        "defaultMessage": "More spaces"
    }
});

});


parcelRegister("baOTS", function(module, exports) {
$parcel$export(module.exports, "nav4ProjectsContentEntryPoint", () => $41d3bb508d1a3a61$export$a457f9fdcd1ea5d3);

var $gy8uL = parcelRequire("gy8uL");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");

const $41d3bb508d1a3a61$export$a457f9fdcd1ea5d3 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("c7xyk")).then(({ Nav4ProjectsContentViewQuery: Nav4ProjectsContentViewQuery })=>Nav4ProjectsContentViewQuery), {
        moduleId: "90670c8d",
        moduleName: "Nav4ProjectsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        const activationId = params.tenantContext.activationId;
        const atlassianAccountId = params.tenantContext.atlassianAccountId;
        return {
            queries: {
                projects: {
                    parameters: $gy8uL.default,
                    variables: {
                        cloudId: cloudId,
                        entityAriProjects: (0, $fKh2A.JiraNavigationSettingsAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            navigationSettingScope: 'projects'
                        }).toString(),
                        ownerAri: atlassianAccountId && (0, $7Cu03.IdentityUserAri).create({
                            userId: atlassianAccountId
                        }).toString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("gy8uL", function(module, exports) {
$parcel$export(module.exports, "default", () => $2af61e473b25b8b7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<56825a208b17a2ed4f671bce1036a48d>>
 * @relayHash bc4207612bc76a332a40fd8e584f7773
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c28567f949e642336a7d16ba8948c4caf848ec6d5f8392a0e872f75dc41a6c4

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $5moL7 = parcelRequire("5moL7");

var $hJ0S2 = parcelRequire("hJ0S2");

var $lhtKZ = parcelRequire("lhtKZ");

var $eSxxM = parcelRequire("eSxxM");

var $eEnEt = parcelRequire("eEnEt");

var $37Ewn = parcelRequire("37Ewn");
const $2af61e473b25b8b7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v16 /*: any*/ 
        ]
    }, v18 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v19 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v20 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v21 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v22 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v24 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v25 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v22 /*: any*/ 
            }
        ]
    }, v26 = [
        v25 /*: any*/ ,
        v23 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v22 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v3 /*: any*/ ,
                                        v24 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v26 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v22 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v24 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v26 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4c28567f949e642336a7d16ba8948c4caf848ec6d5f8392a0e872f75dc41a6c4",
            "metadata": {},
            "name": "Nav4ProjectsContentViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider": (0, $hJ0S2.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default)
            }
        }
    };
}();
$2af61e473b25b8b7$var$node.hash = "147c5d1f620c190c7d67a3ae20325c0e";
(0, $37Ewn.PreloadableQueryRegistry).set($2af61e473b25b8b7$var$node.params.id, $2af61e473b25b8b7$var$node);
var $2af61e473b25b8b7$export$2e2bcd8739ae039 = $2af61e473b25b8b7$var$node;

});

parcelRegister("c7xyk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2lDwB").then(()=>parcelRequire('9U2Pr'));

});



parcelRegister("54VT4", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsForLanding", () => $bb1c1df194be44d4$export$8c948b59812f90e9);

var $7p2eI = parcelRequire("7p2eI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $5vQ2T = parcelRequire("5vQ2T");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $4EKqI = parcelRequire("4EKqI");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $DCnR7 = parcelRequire("DCnR7");


var $bUY1i = parcelRequire("bUY1i");
function $bb1c1df194be44d4$export$8c948b59812f90e9(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef, canCreateProject: canCreateProject } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const data = (0, $j4oe4.useFragment)((0, $7p2eI.default), queryRef);
    const menuId = (0, $h4Bzb.MENU_ID_PROJECTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
                sectionItem: (0, $a9aec.SECTION_ITEM_PROJECTS)
            });
        }, [
            sendSectionItemAnalyticsEvent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $azEgq.getTestId)(menuId),
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-projects-landing' : undefined
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-projects-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "nav4-sidebar-projects-landing",
        packageName: (0, $6764ca6ce23ee75f$export$b8b9d90f9e5bd72b),
        teamName: (0, $6764ca6ce23ee75f$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $DCnR7.Nav4ProjectsContent), {
        queryRef: data
    }))), !(0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUY1i.Footer), {
        canCreateProject: canCreateProject
    })));
}

});
parcelRegister("7p2eI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8240088ccf69328$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c21586a3492cb3ed09327f8fd2de9ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e8240088ccf69328$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ProjectsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4ProjectsContent"
        }
    ],
    "type": "Query"
};
$e8240088ccf69328$var$node.hash = "4d3bdf6d5d5d912aac0901d592694d15";
var $e8240088ccf69328$export$2e2bcd8739ae039 = $e8240088ccf69328$var$node;

});

parcelRegister("DCnR7", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsContent", () => $1e642b891e9b9fa0$export$74ce18a8a4837259);

var $gEhIi = parcelRequire("gEhIi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2KtJf = parcelRequire("2KtJf");

var $956it = parcelRequire("956it");

var $cxKOj = parcelRequire("cxKOj");

var $isd83 = parcelRequire("isd83");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $h3HFC = parcelRequire("h3HFC");

var $3uQAw = parcelRequire("3uQAw");

var $9qHMI = parcelRequire("9qHMI");

var $1pmgP = parcelRequire("1pmgP");

var $a8Wkt = parcelRequire("a8Wkt");

var $9N2D6 = parcelRequire("9N2D6");

var $iXgs9 = parcelRequire("iXgs9");

var $cHtIB = parcelRequire("cHtIB");

var $dN2O6 = parcelRequire("dN2O6");

var $idwl9 = parcelRequire("idwl9");

var $gD589 = parcelRequire("gD589");

var $4cTDP = parcelRequire("4cTDP");

var $4g876 = parcelRequire("4g876");

var $lnXOC = parcelRequire("lnXOC");

var $bUY1i = parcelRequire("bUY1i");

var $2VWNN = parcelRequire("2VWNN");

var $jHZN8 = parcelRequire("jHZN8");
const $1e642b891e9b9fa0$var$MAX_RECENT_PROJECTS = 5;
const $1e642b891e9b9fa0$export$4319a8d1db123861 = 15;
function $1e642b891e9b9fa0$var$Nav4ProjectsContentInternal({ queryRef: queryRef }) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const { getStableItems: getStableItems } = (0, $3uQAw.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const [projectToRestore, setProjectToRestore] = (0, $eJOHy.useState)(null);
    const { sendProjectMenuContentAnalyticsEvent: sendProjectMenuContentAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const { shouldSuppress: shouldSuppress } = (0, $2KtJf.useYbrCrossFlowSuppression)();
    (0, $eJOHy.useEffect)(()=>{
        sendProjectMenuContentAnalyticsEvent();
    }, [
        sendProjectMenuContentAnalyticsEvent
    ]);
    // https://jplat.jira.atlassian.cloud/browse/BLU-2719
    // We intentionally request 10 starred and 15 recent projects.
    // Then, if all 10 starred projects were recently visited, we still show 5 recent projects as well.
    const data = (0, $j4oe4.useRefetchableFragment)((0, $gEhIi.default), queryRef);
    const [{ jira: jira, jira_projectsSidebarMenu: projectsSidebarMenu }, refetch] = data;
    const { jwmLicensing: jwmLicensing, canCreateProject: canCreateProject } = jira;
    const favouriteLimit = (0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? projectsSidebarMenu?.favouriteLimit : $1e642b891e9b9fa0$export$4319a8d1db123861;
    const recentLimit = (0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? projectsSidebarMenu?.recentLimit : $1e642b891e9b9fa0$var$MAX_RECENT_PROJECTS;
    const favouriteProjects = $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() ? projectsSidebarMenu?.favourites : jira.favouriteProjects;
    const recentProjects = $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() ? projectsSidebarMenu?.recents : jira.recentProjects;
    // throwing here enforces the mutually exclusive @include/@skip directives which otherwise would be handled by @required
    if (!favouriteProjects || !recentProjects) throw new Error('JiraProjectConnection is missing in Nav4ProjectsContent for favourite or recent projects');
    const mostRecentProject = projectsSidebarMenu?.mostRecent;
    /** Using `mostRecentFromHistory` for the cases where we don't send `currentURL` (see L1MenuItemsQuery)
   * as a temporary fix to correctly display the projects in the sidebar, by checking the `displayMode`
   * and adding `mostRecentFromHistory` to the lists if necessary
   * More info here: https://jplat.atlassian.net/browse/BLU-6987 */ const mostRecentFromHistory = projectsSidebarMenu?.mostRecentFromHistory;
    const displayMode = projectsSidebarMenu?.displayMode;
    const isMostRecentFromHistorySelected = mostRecentFromHistory && isSelectedPath((0, $h4Bzb.ENTITY_ID).PROJECT(mostRecentFromHistory.projectKey));
    const entityAriProjects = (0, $a8Wkt.useSidebarSettingsAri)('projects');
    const ownerAri = (0, $a8Wkt.useOwnerAri)();
    const queryVariables = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            entityAriProjects: entityAriProjects,
            ownerAri: ownerAri
        }), [
        cloudId,
        entityAriProjects,
        ownerAri
    ]);
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $iXgs9.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_PROJECTS),
        queryVariables: queryVariables
    });
    const refetchOnChange = (0, $eJOHy.useCallback)(({ onComplete: onComplete })=>{
        refetch(queryVariables, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        queryVariables,
        refetch
    ]);
    (0, $h3HFC.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraProject',
        favouriteConnectionId: favouriteProjects.__id,
        recentConnectionId: recentProjects.__id,
        refetch: refetchOnChange
    });
    (0, $9qHMI.useSyncChangeFavourites)();
    const favorites = (0, $eJOHy.useMemo)(()=>{
        const favoritesList = favouriteProjects.edges?.filter(Boolean).map((edge)=>edge.node) ?? [];
        const isMostRecentFromHistoryInFavoritesList = favoritesList.some((project)=>project.id === mostRecentFromHistory?.id);
        const shouldShowStarredSection = displayMode === (0, $1pmgP.ViewOptions).STARRED_AND_RECENT || displayMode === (0, $1pmgP.ViewOptions).STARRED;
        const shouldAddMostRecentFromHistoryToFavouritesList = $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() && mostRecentFromHistory && mostRecentFromHistory.isFavourite && shouldShowStarredSection && isMostRecentFromHistorySelected && favoritesList.length > 0 && !isMostRecentFromHistoryInFavoritesList;
        /** `currentURL` is not sent in L1MenuItemsQuery which might re-write projects wrong in the sidebar in some cases
     * i.e. when the user visits Starred project which order # is more than the starred limit
     * so the project should be displayed as the last Starred one
     * With this fix we keep the sidebar in the correct state according to the current route performing
     * the same logic that BE does when it is aware of the `currentURL` */ if (shouldAddMostRecentFromHistoryToFavouritesList) {
            favoritesList.pop();
            favoritesList.push(mostRecentFromHistory);
        }
        const ids = favoritesList.map((project)=>project.id).filter(Boolean) ?? [];
        const list = favoritesList.map((project)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4g876.Nav4ProjectMenuItem), {
                key: project.projectKey,
                queryRef: project,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                setProjectToRestore: setProjectToRestore
            });
        }) ?? [];
        const hasNextPage = favouriteProjects.pageInfo?.hasNextPage || (favouriteLimit ? list.length > favouriteLimit : false);
        return {
            idSet: new Set(ids),
            list: list.slice(0, favouriteLimit ?? Infinity),
            hasItems: Boolean(list.length),
            hasNextPage: hasNextPage
        };
    }, [
        favouriteProjects,
        jwmLicensing,
        favouriteLimit,
        displayMode,
        mostRecentFromHistory,
        isMostRecentFromHistorySelected
    ]);
    const recentItems = (0, $eJOHy.useMemo)(()=>{
        const isStarredOnlyMode = displayMode === (0, $1pmgP.ViewOptions).STARRED;
        const shouldAddMostRecentFromHistoryToRecentList = $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() && mostRecentFromHistory && !mostRecentFromHistory.isFavourite && isStarredOnlyMode && isMostRecentFromHistorySelected && (recentProjects.edges?.length ?? 0) === 0;
        /** `currentURL` is not sent in L1MenuItemsQuery which might re-write projects wrong in the sidebar in some cases
     * i.e. when Display Mode is STARRED only and the user visits a Recent project
     * so the project should be displayed as the only one in the Recent section
     * With this fix we keep the sidebar in the correct state according to the current route performing
     * the same logic that BE does when it is aware of the `currentURL` */ const nodes = shouldAddMostRecentFromHistoryToRecentList ? [
            mostRecentFromHistory
        ] : recentProjects.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, recentLimit ?? Infinity) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4g876.Nav4ProjectMenuItem), {
                key: node.projectKey,
                queryRef: node,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                setProjectToRestore: setProjectToRestore
            });
        });
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentProjects.edges,
        getStableItems,
        favorites.idSet,
        jwmLicensing?.currentUserSeatEdition,
        recentLimit,
        displayMode,
        mostRecentFromHistory,
        isMostRecentFromHistorySelected
    ]);
    const mostRecentProjectItem = (0, $eJOHy.useMemo)(()=>mostRecentProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4g876.Nav4ProjectMenuItem), {
            key: mostRecentProject.projectKey,
            queryRef: mostRecentProject,
            isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
            setProjectToRestore: setProjectToRestore
        }) : null, [
        mostRecentProject,
        jwmLicensing?.currentUserSeatEdition
    ]);
    const restoreProjectModal = (0, $eJOHy.useCallback)(()=>{
        if (projectToRestore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9N2D6.default), {
            ...projectToRestore,
            onProjectRestoreSuccess: ()=>{
                setProjectToRestore(null);
                refetch(queryVariables, {
                    fetchPolicy: 'store-and-network'
                });
            },
            onProjectRestoreFailure: ()=>{
                setProjectToRestore(null);
            },
            onClose: ()=>setProjectToRestore(null)
        }));
    }, [
        queryVariables,
        projectToRestore,
        refetch
    ]);
    const recommendations = (0, $eJOHy.useMemo)(()=>{
        if ((0, $4cTDP.fg)('sqa-1995_move_nav4recommendations_into_footer')) return null;
        if (shouldSuppress()) return null;
        if (!!canCreateProject && (0, $cxKOj.expValEquals)('grw-1672_display_targeted_jsm_template_cta_in_nav4', 'cohort', 'variation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gD589.Nav4ProjectsSectionPlacement), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idwl9.Nav4Recommendations), null);
    }, [
        canCreateProject,
        shouldSuppress
    ]);
    if (!favorites.hasItems && !recentItems.hasItems && !mostRecentProject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lnXOC.Nav4ProjectsEmptyContent), null), recommendations, restoreProjectModal(), (0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUY1i.Footer), {
        hasMore: projectsSidebarMenu?.hasMore,
        canCreateProject: canCreateProject
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $isd83.UpdateProjectsProvider), {
        favouriteConnectionId: favouriteProjects.__id,
        recentConnectionId: recentProjects.__id
    }, !(0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && (0, $cxKOj.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jHZN8.Nav4ProjectsSectionsWithDisplaySettings), {
        favoriteItems: favorites,
        recentItems: recentItems,
        queryRef: data[0],
        canCreateProject: canCreateProject
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2VWNN.Nav4ProjectsSections), {
        favoriteItems: favorites,
        recentItems: recentItems,
        mostRecentProjectItem: mostRecentProjectItem,
        canCreateProject: canCreateProject
    }), recommendations, restoreProjectModal(), (0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUY1i.Footer), {
        hasMore: projectsSidebarMenu?.hasMore,
        canCreateProject: canCreateProject
    }));
}
const $1e642b891e9b9fa0$export$74ce18a8a4837259 = /*#__PURE__*/ (0, $eJOHy.memo)($1e642b891e9b9fa0$var$Nav4ProjectsContentInternal);
function $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() {
    return (0, $cxKOj.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) || (0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
}

});
parcelRegister("gEhIi", function(module, exports) {
$parcel$export(module.exports, "default", () => $145c8e8c89619dfc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a98ae6a012ddc035749985fdb222987b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $iXgs9 = parcelRequire("iXgs9");
const $145c8e8c89619dfc$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v2 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "FragmentSpread",
        "name": "Nav4ProjectMenuItem"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v7 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v8 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            },
            {
                "kind": "RootArgument",
                "name": "entityAriProjects"
            },
            {
                "kind": "RootArgument",
                "name": "ownerAri"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $iXgs9.default)
            }
        },
        "name": "Nav4ProjectsContent",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "entityAri",
                                        "variableName": "entityAriProjects"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "ownerAri",
                                        "variableName": "ownerAri"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "Nav4ProjectsSectionsWithDisplaySettings"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": {
                                                        "order": "DESC"
                                                    },
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v3 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.favouriteProjects.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.favouriteProjects.edges.node.projectKey"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraProject"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.favouriteProjects.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.favouriteProjects"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v0 /*: any*/ ,
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "recentProjects",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentProjects.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentProjects.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.recentProjects.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.recentProjects"
                                }
                            ]
                        },
                        {
                            "args": [
                                v0 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                v0 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecent.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecent.projectKey"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecentFromHistory.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecentFromHistory.projectKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.favourites.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.favourites.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectsSidebarMenu.favourites.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": "favourites(first:15)"
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectsSidebarMenu.favourites"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v8 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "recents",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.recents.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.recents.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectsSidebarMenu.recents.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": "recents(first:20)"
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectsSidebarMenu.recents"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira_projectsSidebarMenu"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$145c8e8c89619dfc$var$node.hash = "d1cc4e0888b23d47e171ad0ce8c7401b";
var $145c8e8c89619dfc$export$2e2bcd8739ae039 = $145c8e8c89619dfc$var$node;

});
parcelRegister("iXgs9", function(module, exports) {
$parcel$export(module.exports, "default", () => $456273f1e51934e1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cfd5beb5d0a961f7a5ef9f7b4d1d670>>
 * @relayHash 122d944db2212870ba0593a888fb9add
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e81426ab9380c131e407f2648d35e61b7423bb91957ee1fa4f630857f835867b

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $5moL7 = parcelRequire("5moL7");

var $hJ0S2 = parcelRequire("hJ0S2");

var $lhtKZ = parcelRequire("lhtKZ");

var $eSxxM = parcelRequire("eSxxM");

var $eEnEt = parcelRequire("eEnEt");
const $456273f1e51934e1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentURL"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "displaySettingsAPart1Enabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "displaySettingsPostGaEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectsSidebarMenuEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "nav4ProjectsSectionRecommendationEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v8 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v17 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v22 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v21 /*: any*/ 
        ]
    }, v23 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v24 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v25 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v26 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v27 = [
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v29 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v30 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v27 /*: any*/ 
            }
        ]
    }, v31 = [
        v30 /*: any*/ ,
        v28 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v10 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v27 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v9 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v29 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v31 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v27 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v10 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v29 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v31 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e81426ab9380c131e407f2648d35e61b7423bb91957ee1fa4f630857f835867b",
            "metadata": {},
            "name": "Nav4ProjectsContentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "displaySettingsAPart1Enabled": (0, $dtG0v.default),
                "displaySettingsPostGaEnabled": (0, $cli8x.default),
                "jiraProjectsSidebarMenuEnabled": (0, $eEnEt.default),
                "nav4ProjectsSectionRecommendationEnabled": (0, $hJ0S2.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider": (0, $hJ0S2.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default)
            }
        }
    };
}();
$456273f1e51934e1$var$node.hash = "d1cc4e0888b23d47e171ad0ce8c7401b";
var $456273f1e51934e1$export$2e2bcd8739ae039 = $456273f1e51934e1$var$node;

});


parcelRegister("isd83", function(module, exports) {
$parcel$export(module.exports, "UpdateProjectsProvider", () => $cac46ec6f320ae76$export$a50917f7cd2aeeda);
$parcel$export(module.exports, "useUpdateProjectsInRelayStoreContext", () => $cac46ec6f320ae76$export$5105901d98bfdbf1);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $cac46ec6f320ae76$var$UpdateProjectsContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $cac46ec6f320ae76$export$c80374615e2c5b2 = ({ environment: environment, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const removeProjectRecord = (projectDataId)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const favorites = store.get(favouriteConnectionId);
            const recents = store.get(recentConnectionId);
            if (favorites && projectDataId) (0, $j4oe4.ConnectionHandler).deleteNode(favorites, projectDataId);
            if (recents && projectDataId) (0, $j4oe4.ConnectionHandler).deleteNode(recents, projectDataId);
        });
    };
    const archiveProject = (projectDataId)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            store.get(projectDataId)?.setValue('ARCHIVED', 'status');
        });
    };
    return {
        deleteProject: removeProjectRecord,
        archiveProject: archiveProject
    };
};
const $cac46ec6f320ae76$export$a50917f7cd2aeeda = ({ children: children, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const updateRelayStore = $cac46ec6f320ae76$export$c80374615e2c5b2({
        environment: environment,
        favouriteConnectionId: favouriteConnectionId,
        recentConnectionId: recentConnectionId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cac46ec6f320ae76$var$UpdateProjectsContext.Provider, {
        value: updateRelayStore
    }, children);
};
const $cac46ec6f320ae76$export$5105901d98bfdbf1 = ()=>(0, $eJOHy.useContext)($cac46ec6f320ae76$var$UpdateProjectsContext);

});

parcelRegister("9qHMI", function(module, exports) {
$parcel$export(module.exports, "useSyncChangeFavourites", () => $b5a0198ffbfcc42e$export$5f8a0bc021135735);

var $gvzYj = parcelRequire("gvzYj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $hbF3h = parcelRequire("hbF3h");

var $cxKOj = parcelRequire("cxKOj");

var $3osLr = parcelRequire("3osLr");

var $8Umc4 = parcelRequire("8Umc4");

var $cHtIB = parcelRequire("cHtIB");
/*
Hook to trigger a mutation to reorder the projects in the sidebar when a project is starred.
This is used to ensure that the newly starred project is placed at the top of the custom order.
*/ function $b5a0198ffbfcc42e$var$useSyncChangeFavouritesConditionally() {
    const cloudId = (0, $cHtIB.useCloudId)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $gvzYj.default));
    const moveFavouriteToTop = (0, $eJOHy.useCallback)((payload)=>{
        // Prevent optimistic updates from triggering setting custom order
        if (payload.type === 'MUTATION' && payload.isOptimistic) return;
        if (payload.isFavourite) {
            const itemId = (0, $3osLr.JiraProjectAri).parse(payload.entityId).projectId;
            commitMutation({
                variables: {
                    input: {
                        cloudId: cloudId,
                        reorderMode: 'MOVE_TO_TOP',
                        menuItem: {
                            itemId: itemId
                        }
                    }
                }
            });
        }
    }, [
        cloudId,
        commitMutation
    ]);
    (0, $8Umc4.useSubscribeToFavorite)('JiraProject', moveFavouriteToTop);
}
const $b5a0198ffbfcc42e$export$5f8a0bc021135735 = (0, $hbF3h.functionWithCondition)(()=>(0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $b5a0198ffbfcc42e$var$useSyncChangeFavouritesConditionally, ()=>null);

});
parcelRegister("gvzYj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f04ec1e04c72888e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f232e2ba01aa359d290b674f281516b8>>
 * @relayHash 8bb4c46a8065d1decbd59d1e5899b67a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 597c1a7fc7545df269fa521e256e421bb794653669fa7ba9199ace8a25a41bb3

var $9zQGn = parcelRequire("9zQGn");

var $5moL7 = parcelRequire("5moL7");

var $lhtKZ = parcelRequire("lhtKZ");

var $eSxxM = parcelRequire("eSxxM");
const $f04ec1e04c72888e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSyncChangeFavouritesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "Nav4ProjectMenuItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useSyncChangeFavouritesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "softwareBoardCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "597c1a7fc7545df269fa521e256e421bb794653669fa7ba9199ace8a25a41bb3",
            "metadata": {},
            "name": "useSyncChangeFavouritesMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default)
            }
        }
    };
}();
$f04ec1e04c72888e$var$node.hash = "0bc215ec8f9afc0553a13bec6bde53dd";
var $f04ec1e04c72888e$export$2e2bcd8739ae039 = $f04ec1e04c72888e$var$node;

});


parcelRegister("a8Wkt", function(module, exports) {
$parcel$export(module.exports, "useSidebarSettingsAri", () => $28d3622341d60d9c$export$c020d957682d50c);
$parcel$export(module.exports, "useOwnerAri", () => $28d3622341d60d9c$export$7eaf80e428ccd5b3);

var $eJOHy = parcelRequire("eJOHy");

var $cHtIB = parcelRequire("cHtIB");

var $e6YEs = parcelRequire("e6YEs");

var $f2sjT = parcelRequire("f2sjT");

var $a2f5K = parcelRequire("a2f5K");
const $28d3622341d60d9c$export$c020d957682d50c = (menuName, parentType, parentId)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    return (0, $eJOHy.useMemo)(()=>(0, $a2f5K.createSidebarSettingsAri)(cloudId, activationId, menuName, parentType, parentId), [
        cloudId,
        activationId,
        menuName,
        parentType,
        parentId
    ]);
};
const $28d3622341d60d9c$export$7eaf80e428ccd5b3 = ()=>{
    const accountId = (0, $e6YEs.useAccountId)() || 'unidentified';
    return (0, $eJOHy.useMemo)(()=>(0, $a2f5K.createIdentityUserAri)(accountId), [
        accountId
    ]);
};

});
parcelRegister("a2f5K", function(module, exports) {
$parcel$export(module.exports, "createSidebarSettingsAri", () => $b66a5747a6ef1c56$export$53e9bd7d6d946a5d);
$parcel$export(module.exports, "createIdentityUserAri", () => $b66a5747a6ef1c56$export$caf08cda0abeee7a);

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");
const $b66a5747a6ef1c56$export$1fd3c0096c24b2bb = (menuName, parentType, parentId)=>{
    if (parentType === undefined !== (parentId === undefined)) throw new Error('Invalid Navigation Setting Scope parentType and parentId must be defined together');
    if (parentType !== undefined && parentId !== undefined) return `${parentType}/${parentId}/${menuName}`;
    return menuName;
};
const $b66a5747a6ef1c56$export$b1bae424ff62eaf3 = (scope)=>{
    const [parentTypeOrMenuName, parentId, menuName] = scope.split('/');
    if (parentTypeOrMenuName && !parentId && !menuName) return {
        menuName: parentTypeOrMenuName
    };
    if (parentTypeOrMenuName && parentId && menuName) return {
        parentType: parentTypeOrMenuName,
        parentId: parentId,
        menuName: menuName
    };
    throw new Error('Invalid Navigation Setting Scope format');
};
const $b66a5747a6ef1c56$export$53e9bd7d6d946a5d = (cloudId, activationId, menuName, parentType, parentId)=>{
    return (0, $fKh2A.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: $b66a5747a6ef1c56$export$1fd3c0096c24b2bb(menuName, parentType, parentId)
    }).toString();
};
const $b66a5747a6ef1c56$export$cc210794adbf70e7 = (ariLikeString)=>{
    const ari = (0, $fKh2A.JiraNavigationSettingsAri).parse(ariLikeString);
    return $b66a5747a6ef1c56$export$b1bae424ff62eaf3(ari.navigationSettingScope);
};
const $b66a5747a6ef1c56$export$caf08cda0abeee7a = (userId)=>{
    return (0, $7Cu03.IdentityUserAri).create({
        userId: userId
    }).toString();
};

});


parcelRegister("9N2D6", function(module, exports) {
$parcel$export(module.exports, "default", () => $53296ce4e01ee7cd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");
var $cA0Y2 = parcelRequire("cA0Y2");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $cxKOj = parcelRequire("cxKOj");

var $4B7rn = parcelRequire("4B7rn");

var $FhXEJ = parcelRequire("FhXEJ");

var $jchga = parcelRequire("jchga");

var $idGBm = parcelRequire("idGBm");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $fgJkD = parcelRequire("fgJkD");

var $3BME1 = parcelRequire("3BME1");

var $dVWFb = parcelRequire("dVWFb");

var $4xqwG = parcelRequire("4xqwG");

var $ci7Vl = parcelRequire("ci7Vl");
const $53296ce4e01ee7cd$export$a43ae427db1e9df7 = 'restore-from-trash';
const $53296ce4e01ee7cd$export$ec2a19e79c04c9d2 = 'restore-from-archive';
const $53296ce4e01ee7cd$export$cee26a329c363b31 = (props)=>{
    const jsmModalHeaderGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).jsmModalHeaderGalaxia : (0, $dVWFb.default).jsmModalHeader;
    const modalHeaderGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).modalHeaderGalaxia : (0, $dVWFb.default).modalHeader;
    const { isProjectSimplified: isProjectSimplified, projectType: projectType, projectName: projectName, projectId: projectId, projectKey: projectKey, projectInactiveDate: projectInactiveDate, intl: { formatMessage: formatMessage }, onClose: onClose, onProjectRestoreSuccess: onProjectRestoreSuccess, onProjectRestoreFailure: onProjectRestoreFailure, flagService: { showFlag: showFlag } } = props;
    const [isRestoring, restoreProject] = (0, $3BME1.useProjectRestoreService)({
        projectId: projectId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const attributes = {
        projectType: projectType,
        isProjectSimplified: isProjectSimplified
    };
    const onSuccess = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'restored'
        });
        (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'project restored', projectId.toString(), {
            ...attributes,
            durationInTrash: projectInactiveDate ? (0, $ci7Vl.getDurationInTrash)(projectInactiveDate) : undefined
        });
        onProjectRestoreSuccess();
        if (projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT)) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-service-desk-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreServiceDeskSuccessMessageTitleGalaxia : (0, $dVWFb.default).restoreServiceDeskSuccessMessageTitle,
            description: (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreServiceDeskSuccessMessageContentGalaxia : (0, $dVWFb.default).restoreServiceDeskSuccessMessageContent,
            testId: 'project-restore-modal.ui.flags.success-flag',
            actions: [
                {
                    content: (0, $dVWFb.default).restoreServiceDeskSuccessMessageActionEmailSettings,
                    href: `/jira/servicedesk/projects/${projectKey}/settings/email`
                }
            ]
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreSuccessMessageTitleGalaxia : (0, $dVWFb.default).restoreSuccessMessageTitle,
            testId: 'project-restore-modal.ui.flags.success-flag'
        });
    };
    const onFailure = (error)=>{
        onProjectRestoreFailure(error);
        if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        error.statusCode?.toString().startsWith('4') && error.message) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error',
            messageType: 'transactional',
            type: 'error',
            title: [
                (0, $dVWFb.default).restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreErrorMessageDescriptionRenderErrorNonFinalGalaxia : (0, $dVWFb.default).restoreErrorMessageDescriptionRenderErrorNonFinal,
                {
                    projectName: projectName,
                    error: error.message,
                    br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null)
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error.1',
            messageType: 'transactional',
            type: 'error',
            title: [
                (0, $dVWFb.default).restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreErrorMessageDescriptionGalaxia : (0, $dVWFb.default).restoreErrorMessageDescription,
                {
                    projectName: projectName
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
    };
    const onRestore = (e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'restoreProjectButton');
        restoreProject({
            onSuccess: onSuccess,
            onFailure: onFailure
        });
    };
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const ModalDialogDescription = ()=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xqwG.ModalMessageContent), {
            projectType: projectType
        }));
    const onCancelOrNoop = !isRestoring ? onClose : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "restoreProject",
        sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa),
        attributes: attributes,
        containerId: `${projectId}`,
        containerType: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "project-restore-modal.ui.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop,
        autoFocus: false,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, formatMessage(projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) ? jsmModalHeaderGalaxia : modalHeaderGalaxia, {
        projectName: projectName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ModalDialogDescription, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: isRestoring,
        testId: "project-restore-modal.ui.close-button-wrapper"
    }, formatMessage((0, $dVWFb.default).cancelRestoreButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        appearance: "primary",
        onClick: onRestore,
        isDisabled: isRestoring,
        isLoading: isRestoring,
        testId: "project-restore-modal.ui.restore-button-wrapper"
    }, formatMessage((0, $dVWFb.default).confirmRestoreButton))))));
};
const $53296ce4e01ee7cd$export$9c21a3269931e1e6 = {
    isRestoring: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $53296ce4e01ee7cd$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)((0, $jchga.default)($53296ce4e01ee7cd$export$cee26a329c363b31));

});
parcelRegister("jchga", function(module, exports) {
$parcel$export(module.exports, "default", () => $252247aaa31f729e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");
const $252247aaa31f729e$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $cSXp8.flagService)
        });
};
var $252247aaa31f729e$export$2e2bcd8739ae039 = $252247aaa31f729e$var$withFlagService;

});

parcelRegister("3BME1", function(module, exports) {
$parcel$export(module.exports, "useProjectRestoreService", () => $4d38ecb8649063f2$export$3726936b35df382d);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $3UU1D = parcelRequire("3UU1D");
const $4d38ecb8649063f2$export$3726936b35df382d = ({ projectId: projectId })=>{
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const restoreProject = ({ onSuccess: onSuccess, onFailure: onFailure })=>{
        const url = (0, $3UU1D.getProjectRestoreUrl)(projectId);
        setLoading(true);
        (0, $3ugTQ.performPostRequest)(url).then(()=>{
            setLoading(false);
            onSuccess();
        }).catch((error)=>{
            if (!(error.statusCode === 409 && (0, $4cTDP.fg)('hix-6266_-_no_error_fired_for_409_project_restore'))) (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'useProjectRestoreService',
                    packageName: 'jiraProjectRestoreModal'
                },
                error: error,
                attributes: {
                    projectId: projectId,
                    errorStatusCode: error.statusCode
                }
            });
            setLoading(false);
            onFailure(error);
        });
    };
    return [
        loading,
        restoreProject
    ];
};

});
parcelRegister("3UU1D", function(module, exports) {
$parcel$export(module.exports, "getProjectRestoreUrl", () => $22968aa618e6a50b$export$f120ca318b319edc);
const $22968aa618e6a50b$export$f120ca318b319edc = (projectId)=>`/rest/api/2/project/${projectId}/restore`;

});


parcelRegister("dVWFb", function(module, exports) {
$parcel$export(module.exports, "default", () => $899d0f26d696eae6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $899d0f26d696eae6$var$messages = (0, $7qGN1.defineMessages)({
    modalHeader: {
        "id": "project-restore-modal.modal-header",
        "defaultMessage": "Restore project?"
    },
    jsmModalHeader: {
        "id": "project-restore-modal.jsm-modal-header",
        "defaultMessage": "Restore this service project?"
    },
    jsmExplainWhatProjectRestoreDoes: {
        "id": "project-restore-modal.jsm-explain-what-project-restore-does",
        "defaultMessage": "Once restored, this service project will work as normal. It will appear in directories and requests will appear in search results."
    },
    confirmRestoreButton: {
        "id": "project-restore-modal.confirm-restore-button",
        "defaultMessage": "Restore"
    },
    cancelRestoreButton: {
        "id": "project-restore-modal.cancel-restore-button",
        "defaultMessage": "Cancel"
    },
    restoreSuccessMessageTitle: {
        "id": "project-restore-modal.restore-success-message-title",
        "defaultMessage": "Project successfully restored"
    },
    restoreServiceDeskSuccessMessageTitle: {
        "id": "project-restore-modal.restore-service-desk-success-message-title",
        "defaultMessage": "Service project restored"
    },
    restoreServiceDeskSuccessMessageContent: {
        "id": "project-restore-modal.restore-service-desk-success-message-content",
        "defaultMessage": "You may need to turn on email support for your service project to work as normal."
    },
    restoreServiceDeskSuccessMessageActionEmailSettings: {
        "id": "project-restore-modal.restore-service-desk-success-message-action-email-settings",
        "defaultMessage": "Go to email settings"
    },
    restoreErrorMessageTitle: {
        "id": "project-restore-modal.restore-error-message-title",
        "defaultMessage": "Something went wrong"
    },
    restoreErrorMessageDescription: {
        "id": "project-restore-modal.restore-error-message-description",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project. Try again."
    },
    restoreErrorMessageDescriptionRenderErrorNonFinal: {
        "id": "project-restore-modal.restore-error-message-description-render-error-non-final",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project.{br}{error}"
    },
    restoreSuccessMessageTitleGalaxia: {
        "id": "project-restore-modal.restore-success-message-title-galaxia",
        "defaultMessage": "Space successfully restored"
    },
    restoreServiceDeskSuccessMessageTitleGalaxia: {
        "id": "project-restore-modal.restore-service-desk-success-message-title-galaxia",
        "defaultMessage": "Service space restored"
    },
    restoreServiceDeskSuccessMessageContentGalaxia: {
        "id": "project-restore-modal.restore-service-desk-success-message-content-galaxia",
        "defaultMessage": "You may need to turn on email support for your service space to work as normal."
    },
    restoreErrorMessageDescriptionGalaxia: {
        "id": "project-restore-modal.restore-error-message-description-galaxia",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D space. Try again."
    },
    restoreErrorMessageDescriptionRenderErrorNonFinalGalaxia: {
        "id": "project-restore-modal.restore-error-message-description-render-error-non-final-galaxia",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D space.{br}{error}"
    },
    modalHeaderGalaxia: {
        "id": "project-restore-modal.modal-header-galaxia",
        "defaultMessage": "Restore space?"
    },
    jsmModalHeaderGalaxia: {
        "id": "project-restore-modal.jsm-modal-header-galaxia",
        "defaultMessage": "Restore this service space?"
    }
});
var $899d0f26d696eae6$export$2e2bcd8739ae039 = $899d0f26d696eae6$var$messages;

});

parcelRegister("4xqwG", function(module, exports) {
$parcel$export(module.exports, "ModalMessageContent", () => $f1396f5a72f0c09b$export$6c33ff8e4ab0adf4);

var $eJOHy = parcelRequire("eJOHy");

var $gYvT9 = parcelRequire("gYvT9");

var $FhXEJ = parcelRequire("FhXEJ");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");


var $fdCYx = parcelRequire("fdCYx");
const $f1396f5a72f0c09b$var$isServiceDesk = (projectType)=>projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
const $f1396f5a72f0c09b$export$49587436f0d2c314 = ({ projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getMessage = ()=>{
        const jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fdCYx.default).jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia : (0, $fdCYx.default).jsmExplainWhatProjectRestoreDoesIssueTermRefresh;
        const explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fdCYx.default).explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia : (0, $fdCYx.default).explainWhatProjectRestoreDoesPart1IssueTermRefresh;
        let message;
        if ((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) message = $f1396f5a72f0c09b$var$isServiceDesk(projectType) ? jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia : explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia;
        else message = $f1396f5a72f0c09b$var$isServiceDesk(projectType) ? (0, $fdCYx.default).jsmExplainWhatProjectRestoreDoes : (0, $fdCYx.default).explainWhatProjectRestoreDoesPart1;
        return message;
    };
    const formattedMessage = formatMessage(getMessage());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, formattedMessage, "\xa0");
};
const $f1396f5a72f0c09b$export$d608ae2ec728a3cf = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gYvT9.default), {
        href: (0, $158f8dea36e8141e$export$367c841df4ac5730),
        target: "_blank"
    }, formatMessage((0, $fdCYx.default).jsmLearnMoreAboutTrashAndRestore));
};
const $f1396f5a72f0c09b$export$6c33ff8e4ab0adf4 = ({ projectType: projectType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1396f5a72f0c09b$export$49587436f0d2c314, {
        projectType: projectType
    }), $f1396f5a72f0c09b$var$isServiceDesk(projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1396f5a72f0c09b$export$d608ae2ec728a3cf, null));

});
parcelRegister("gYvT9", function(module, exports) {
$parcel$export(module.exports, "default", () => $23fbbe8ebd22bf7c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $as6H2 = parcelRequire("as6H2");

var $c9uTK = parcelRequire("c9uTK");
function $23fbbe8ebd22bf7c$var$Link(props) {
    const { children: children, ...rest } = props;
    // eslint-disable-next-line react-hooks/react-compiler
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), rest, children);
}
const $23fbbe8ebd22bf7c$var$LinkWithAnalytics = (0, $as6H2.default)('link', {
    onClick: 'clicked'
})($23fbbe8ebd22bf7c$var$Link);
var $23fbbe8ebd22bf7c$export$2e2bcd8739ae039 = $23fbbe8ebd22bf7c$var$LinkWithAnalytics;

});
parcelRegister("as6H2", function(module, exports) {
$parcel$export(module.exports, "default", () => $958189e604a5261a$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");
const $958189e604a5261a$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $958189e604a5261a$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $dUaMU.default)({
            componentName: componentName
        })((0, $4J0ad.default)($958189e604a5261a$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $958189e604a5261a$export$2e2bcd8739ae039 = $958189e604a5261a$var$componentWithAnalytics;

});


const $158f8dea36e8141e$export$37312a67c3e314c6 = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';
const $158f8dea36e8141e$export$367c841df4ac5730 = 'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';

parcelRegister("fdCYx", function(module, exports) {
$parcel$export(module.exports, "default", () => $03db4a4caab7353a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $03db4a4caab7353a$var$messages = (0, $7qGN1.defineMessages)({
    explainWhatProjectRestoreDoesPart1: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1",
        "defaultMessage": "The project along with its issues, Jira components, attachments, and versions will be restored."
    },
    jsmExplainWhatProjectRestoreDoes: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does",
        "defaultMessage": "Once restored, this service project will appear in directories and its issues will appear in search results. You may need to turn on email support for this service project to work as normal."
    },
    jsmLearnMoreAboutTrashAndRestore: {
        "id": "project-restore-modal.modal-message.jsm-learn-more-about-trash-and-restore",
        "defaultMessage": "Learn more about trash and restore."
    },
    explainWhatProjectRestoreDoesPart1IssueTermRefresh: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh",
        "defaultMessage": "The project along with its work items, Jira components, attachments, and versions will be restored"
    },
    jsmExplainWhatProjectRestoreDoesIssueTermRefresh: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh",
        "defaultMessage": "Once restored, this service project will appear in directories and its work items will appear in search results. You may need to turn on email support for this service project to work as normal."
    },
    explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh-galaxia",
        "defaultMessage": "The space along with its work items, Jira components, attachments, and versions will be restored"
    },
    jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh-galaxia",
        "defaultMessage": "Once restored, this service space will appear in directories and its work items will appear in search results. You may need to turn on email support for this service space to work as normal."
    }
});
var $03db4a4caab7353a$export$2e2bcd8739ae039 = $03db4a4caab7353a$var$messages;

});


parcelRegister("ci7Vl", function(module, exports) {
$parcel$export(module.exports, "getDurationInTrash", () => $e037765542359a31$export$d40938201f7514c5);

var $lw3Pj = parcelRequire("lw3Pj");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");
const $e037765542359a31$export$d40938201f7514c5 = (projectTrashedDate)=>{
    const parsedProjectTrashedDate = (0, $dBLX0.default)((0, $kQ82p.default)(projectTrashedDate)) ? (0, $kQ82p.default)(projectTrashedDate) : new Date(projectTrashedDate);
    return (0, $lw3Pj.default)(new Date(), parsedProjectTrashedDate);
};

});


parcelRegister("4g876", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectMenuItem", () => $061bcf51dedf1b27$export$6a41b9c2eac627cc);

var $d7EDy = parcelRequire("d7EDy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $FhXEJ = parcelRequire("FhXEJ");

var $1kUQ7 = parcelRequire("1kUQ7");

var $4lj4q = parcelRequire("4lj4q");

var $1v9jo = parcelRequire("1v9jo");

var $3VmU5 = parcelRequire("3VmU5");

var $3Nj6K = parcelRequire("3Nj6K");

var $1gN9e = parcelRequire("1gN9e");

var $kOdRG = parcelRequire("kOdRG");
const $061bcf51dedf1b27$export$6a41b9c2eac627cc = /*#__PURE__*/ (0, $eJOHy.memo)(({ queryRef: queryRef, setProjectToRestore: setProjectToRestore, isCorePremiumUserSeat: isCorePremiumUserSeat = false })=>{
    const data = (0, $j4oe4.useFragment)((0, $d7EDy.default), queryRef);
    if (!data) return null;
    if (data.status === 'ARCHIVED') return null;
    const renderMenuItem = ()=>{
        if ((0, $4cTDP.fg)('jcs_project_type_m3')) switch(data.projectType){
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1v9jo.AsyncJsmProjectMenu), {
                    projectData: data
                });
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VmU5.AsyncJcsProjectMenu), {
                    projectData: data
                });
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4lj4q.AsyncJpdProjectMenu), {
                    projectData: data
                });
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Nj6K.JswProjectMenu), {
                    projectData: data
                });
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_CORE_PROJECT:
            default:
                // TODO: One day, we will call this JwmProjectMenu, and subsequently JiraProjectMenu (Spork!)
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kUQ7.JiraBusinessProjectMenu), {
                    projectData: data,
                    isCorePremiumUserSeat: isCorePremiumUserSeat
                });
        }
        switch(data.projectType){
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1v9jo.AsyncJsmProjectMenu), {
                    projectData: data
                });
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4lj4q.AsyncJpdProjectMenu), {
                    projectData: data
                });
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Nj6K.JswProjectMenu), {
                    projectData: data
                });
            case 0, $FhXEJ.JIRA_PROJECT_TYPE_CORE_PROJECT:
            default:
                // TODO: One day, we will call this JwmProjectMenu, and subsequently JiraProjectMenu (Spork!)
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kUQ7.JiraBusinessProjectMenu), {
                    projectData: data,
                    isCorePremiumUserSeat: isCorePremiumUserSeat
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gN9e.ProjectRestoreContext).Provider, {
        value: setProjectToRestore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kOdRG.ContentWithDragAndDrop), null, renderMenuItem()));
});

});
parcelRegister("d7EDy", function(module, exports) {
$parcel$export(module.exports, "default", () => $930054dc6bd68cca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<82f72868142182d7bec84a3af22b9063>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $930054dc6bd68cca$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraBusinessProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JsmProjectMenu"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JpdProjectMenu"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JpdProjectMenuOld"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "JswProjectMenu"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JcsProjectMenu"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$930054dc6bd68cca$var$node.hash = "e5d92308b1343c66a0448432cc4640b4";
var $930054dc6bd68cca$export$2e2bcd8739ae039 = $930054dc6bd68cca$var$node;

});

parcelRegister("1kUQ7", function(module, exports) {
$parcel$export(module.exports, "JiraBusinessProjectMenu", () => $097954739b6f31e0$export$6145b58afae943e6);

var $dw8e4 = parcelRequire("dw8e4");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6l5yN = parcelRequire("6l5yN");

var $4cTDP = parcelRequire("4cTDP");

var $lHnXI = parcelRequire("lHnXI");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $bS07j = parcelRequire("bS07j");

var $cxKOj = parcelRequire("cxKOj");

var $1NfYk = parcelRequire("1NfYk");

var $bzbsd = parcelRequire("bzbsd");
const $097954739b6f31e0$export$6145b58afae943e6 = ({ projectData: projectData, isCorePremiumUserSeat: isCorePremiumUserSeat = false, menuItemAnchorRef: menuItemAnchorRef })=>{
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    const project = (0, $j4oe4.useFragment)((0, $dw8e4.default), projectData);
    let isTargetSameAsCurrentLocation = false;
    if (typeof window !== 'undefined') isTargetSameAsCurrentLocation = window.location.pathname === project.defaultNavigationItem?.url;
    const routerLinkConfig = (0, $eJOHy.useMemo)(()=>({
            to: project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`,
            prefetch: isTargetSameAsCurrentLocation && (0, $4cTDP.fg)('disable_prefetching_if_same_url_path') ? false : 'hover'
        }), [
        isTargetSameAsCurrentLocation,
        project.defaultNavigationItem?.url,
        project.projectKey
    ]);
    const projectActionMenuOnClickHandler = (0, $eJOHy.useCallback)(()=>{
        const isFavourite = project.isFavourite;
        const projectId = project.projectId;
        const projectType = project.projectType;
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            // TODO BLU-5544 send section via <ContextualAnalyticsData instead (which wraps the Starred or Recent panel; and each project). Use static object or useMemo, not to have rerendering issues. Then you can also use static object for meatBallDropDownOnProjectsAnalytics. See Jsm and Wanjel components
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = project;
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $1NfYk.useProjectMenuItemDragAndDrop)({
        projectId: projectId,
        projectKey: projectKey,
        isFavourite: isFavourite,
        name: name,
        avatar: avatar,
        isEnabled: !!isFavourite && (0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        ref: (0, $bzbsd.mergeRefs)(menuItemAnchorRef || null, draggableAnchorRef),
        visualContentRef: dropTargetRef,
        dropIndicator: dropIndicator,
        isDragging: state.type === 'dragging',
        hasDragIndicator: hasDragIndicator,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6l5yN.ContainerAvatar), {
            src: project.avatar.large || ''
        }),
        href: routerLinkConfig,
        menuId: (0, $h4Bzb.ENTITY_ID).PROJECT(project.projectKey),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bS07j.ProjectActionMenu), {
            isProjectMenuReorderingEnabled: Boolean(project.isFavourite) && (0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            onClick: projectActionMenuOnClickHandler
        })
    }, project.name), dragPreview);
};

});
parcelRegister("dw8e4", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ed9376a9395992a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f8261c1d4ea8b98e7cad6afaa53ee9a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9ed9376a9395992a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraBusinessProjectMenu",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$9ed9376a9395992a$var$node.hash = "3aeeb5d636ce6b2eb00fc0375929c8cb";
var $9ed9376a9395992a$export$2e2bcd8739ae039 = $9ed9376a9395992a$var$node;

});

parcelRegister("6l5yN", function(module, exports) {
$parcel$export(module.exports, "ContainerAvatar", () => $8872ad00786981a3$export$f35a2d11bd6ae97);
/* container-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $8872ad00786981a3$var$styles = {
    root: "_2rko12b0 _vchhusvi _4t3igktf _1bsbgktf"
};
const $8872ad00786981a3$export$f35a2d11bd6ae97 = ({ src: src })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: src,
        alt: "",
        className: (0, $hcewu.default)([
            $8872ad00786981a3$var$styles.root
        ])
    });

});

parcelRegister("bS07j", function(module, exports) {
$parcel$export(module.exports, "ProjectActionMenu", () => $38a903ab1d7ae22b$export$b71a0a4e7f29cfd6);

var $eJOHy = parcelRequire("eJOHy");

var $NByNW = parcelRequire("NByNW");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $cJEMq = parcelRequire("cJEMq");

var $4cTDP = parcelRequire("4cTDP");

var $dEoQI = parcelRequire("dEoQI");

var $ce73j = parcelRequire("ce73j");
// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $38a903ab1d7ae22b$var$CustomTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
            label: formatMessage((0, $ce73j.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-project-action-menu.ui.themed-button"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $ce73j.default).moreActions),
        hideTooltipOnClick: true
    }, triggerButton);
});
const $38a903ab1d7ae22b$export$b71a0a4e7f29cfd6 = ({ additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, onClick: onClick, shouldRenderToParent: shouldRenderToParent, projectName: projectName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dEoQI.EntryPointContent), {
        ...(0, $4cTDP.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
        additionalMenuItems: additionalMenuItems,
        onClick: onClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat,
        CustomTrigger: withThemedTrigger ? $38a903ab1d7ae22b$var$CustomTrigger : undefined,
        projectKey: projectKey,
        shouldRenderToParent: shouldRenderToParent,
        source: withThemedTrigger ? 'horizontal-nav' : 'sidebar-nav'
    });
};

});
parcelRegister("dEoQI", function(module, exports) {
$parcel$export(module.exports, "EntryPointContent", () => $fabe5cda70e02c8e$export$912f81dce8d58e46);

var $eJOHy = parcelRequire("eJOHy");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $efhF3 = parcelRequire("efhF3");

var $i0Ev8 = parcelRequire("i0Ev8");

var $gcYED = parcelRequire("gcYED");
const $fabe5cda70e02c8e$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey, shouldRenderToParent: shouldRenderToParent, projectName: projectName, source: source })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $efhF3.projectActionMenuEntryPoint), (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]));
    const buttonTriggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    const content = (0, $eJOHy.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "project-actions-menu-popup-content",
            packageName: "jira-navigation-apps-project-action-menu",
            // eslint-disable-next-line react-hooks/react-compiler
            // eslint-disable-next-line react-hooks/rules-of-hooks
            runtimeProps: (0, $eJOHy.useMemo)(()=>({
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    additionalMenuItems: additionalMenuItems,
                    isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                    contentProps: contentProps,
                    source: source
                }), [
                contentProps
            ]),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gcYED.Skeleton), null)
        }), [
        entryPointReferenceSubject,
        additionalMenuItems,
        isCorePremiumUserSeat,
        isProjectMenuReorderingEnabled,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0Ev8.MenuContainer), {
        ...(0, $4cTDP.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        content: content,
        CustomTrigger: CustomTrigger,
        onClick: onClick,
        buttonTriggerRef: buttonTriggerRef,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("efhF3", function(module, exports) {
$parcel$export(module.exports, "projectActionMenuEntryPoint", () => $f137ce769a6a6e13$export$30ec6de22da54fa0);

var $mAg2Z = parcelRequire("mAg2Z");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $f137ce769a6a6e13$export$30ec6de22da54fa0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("id4BF")).then((module)=>module.AsyncMenuWithQuery), {
        moduleId: "bb21877c",
        moduleName: "AsyncMenuWithQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
        const projectActionMenuQuery = {
            parameters: (0, $mAg2Z.default),
            variables: {
                cloudId: cloudId,
                projectKey: projectKey
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
        return {
            queries: {
                projectActionMenuQuery: projectActionMenuQuery
            }
        };
    }
});

});
parcelRegister("mAg2Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ca325cd70786748$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca0dd0429a03b8a475a1ed6338627a73>>
 * @relayHash 4b89602f9e622ea3a2871167b17a2f2c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cae59ee6f9e6e94700d07064e410118ec9e313798958b7ed0894c8464260e72d
const $6ca325cd70786748$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cae59ee6f9e6e94700d07064e410118ec9e313798958b7ed0894c8464260e72d",
        "metadata": {},
        "name": "AsyncMenuWithQueryQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6ca325cd70786748$export$2e2bcd8739ae039 = $6ca325cd70786748$var$node;

});

parcelRegister("id4BF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2R7Eo")
]).then(()=>parcelRequire('6XTdW'));

});


parcelRegister("gcYED", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $8d45d921416e6533$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");
var $2bMVP = parcelRequire("2bMVP");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $5Q9JR = parcelRequire("5Q9JR");
const $8d45d921416e6533$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8d45d921416e6533$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8d45d921416e6533$var$projectTileSkeleton
    }))));
const $8d45d921416e6533$var$wrapperStyles = (0, $1DXK0.xcss)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $5Q9JR.MENU_GROUP_MIN_WIDTH)}px`
});
const $8d45d921416e6533$var$projectTileSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-600, 48px)",
    flex: 1
});

});


parcelRegister("ce73j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fac621ca9c21a200$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fac621ca9c21a200$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectSettings: {
        "id": "navigation-project-action-menu.project-settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "navigation-project-action-menu.more-actions",
        "defaultMessage": "More actions"
    },
    projectSettingsGalaxia: {
        "id": "navigation-project-action-menu.project-settings-galaxia",
        "defaultMessage": "Space settings"
    }
});

});


parcelRegister("1NfYk", function(module, exports) {
$parcel$export(module.exports, "useProjectMenuItemDragAndDrop", () => $fc6dd0c2bc0ef4cd$export$1496323130e2da11);

var $eJOHy = parcelRequire("eJOHy");

var $V3tNZ = parcelRequire("V3tNZ");

var $6l5yN = parcelRequire("6l5yN");

var $3X9cT = parcelRequire("3X9cT");

var $fpJnI = parcelRequire("fpJnI");
const $fc6dd0c2bc0ef4cd$export$1496323130e2da11 = (props)=>{
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar, isEnabled: isEnabled = false } = props;
    /* isEnabled is used to determine if drag and drop functionality should be enabled – this is used to turn on the feature only for starred projects.
	By using this to pass undefined to draggable and dropTarget the useMenuItemDragAndDrop hook does not run its effects to attach event listeners.
	The drag and drop functionality is effectively disabled, while still setting up the refs which are required for consistent rendering. */ const { state: state, draggableButtonRef: draggableButtonRef, dropTargetRef: dropTargetRef, draggableAnchorRef: draggableAnchorRef, dragPreview: dragPreview, dropIndicator: dropIndicator } = (0, $V3tNZ.useMenuItemDragAndDrop)({
        draggable: isEnabled ? {
            getInitialData: ()=>({
                    id: projectId,
                    key: projectKey,
                    isFavourite: isFavourite,
                    name: name,
                    avatar: avatar.large || '',
                    type: (0, $3X9cT.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
                }),
            getDragPreviewPieces: ()=>({
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6l5yN.ContainerAvatar), {
                        src: avatar.large || ''
                    }),
                    content: name
                })
        } : undefined,
        dropTarget: isEnabled ? {
            getData: ()=>({
                    id: projectId,
                    key: projectKey,
                    isFavourite: isFavourite,
                    name: name,
                    avatar: avatar.large || '',
                    type: (0, $3X9cT.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
                }),
            getOperations: ()=>({
                    'reorder-after': 'available',
                    'reorder-before': 'available'
                }),
            canDrop: ({ source: source })=>source.data.type === (0, $3X9cT.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
        } : undefined
    });
    const { shouldRestoreFocus: shouldRestoreFocus, clearRestoreFocus: clearRestoreFocus } = (0, $eJOHy.useContext)((0, $fpJnI.FocusRestorationContext));
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRestoreFocus && isEnabled) // .focus() seems to be more reliable in the next task when used with VoiceOver
        setTimeout(()=>{
            (draggableButtonRef.current ?? draggableAnchorRef.current)?.focus();
            clearRestoreFocus();
        });
    }, [
        clearRestoreFocus,
        draggableAnchorRef,
        draggableButtonRef,
        isEnabled,
        shouldRestoreFocus
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: isEnabled ? dragPreview : null,
        dropIndicator: isEnabled ? dropIndicator : null,
        hasDragIndicator: isEnabled
    };
};

});
parcelRegister("V3tNZ", function(module, exports) {
$parcel$export(module.exports, "useMenuItemDragAndDrop", () => $e84db801d338b3e1$export$fe281fdb09fbf0c8);
/* use-menu-item-drag-and-drop.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $8GOss = parcelRequire("8GOss");

var $bGx3v = parcelRequire("bGx3v");
parcelRequire("dX4g9");
var $5bXoL = parcelRequire("5bXoL");
parcelRequire("aHiGM");
var $eh3wh = parcelRequire("eh3wh");

var $iSqfo = parcelRequire("iSqfo");

var $2VZV5 = parcelRequire("2VZV5");

var $e3gfr = parcelRequire("e3gfr");
const $e84db801d338b3e1$var$idle = {
    type: 'idle'
};
function $e84db801d338b3e1$export$fe281fdb09fbf0c8({ draggable: draggableArgs, dropTarget: dropTargetArgs }) {
    const draggableAnchorRef = (0, $eJOHy.useRef)(null);
    const draggableButtonRef = (0, $eJOHy.useRef)(null);
    const dropTargetRef = (0, $eJOHy.useRef)(null);
    const [internalState, setInternalState] = (0, $eJOHy.useState)($e84db801d338b3e1$var$idle);
    const getDraggableElement = (0, $eJOHy.useCallback)(()=>{
        return draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
    }, []);
    // Set up draggable
    (0, $eJOHy.useEffect)(()=>{
        // Don't set up a draggable if there are no draggable args
        if (!draggableArgs) return;
        const element = getDraggableElement();
        (0, $8GOss.default)(element, `draggableAnchorRef or draggableButtonRef not set`);
        return (0, $bGx3v.draggable)({
            element: element,
            getInitialData: draggableArgs.getInitialData,
            canDrag: draggableArgs.canDrag,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, source: source, location: location }) {
                (0, $eh3wh.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $5bXoL.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        const args = {
                            dragHandle: source.dragHandle,
                            element: source.element,
                            input: location.current.input
                        };
                        setInternalState({
                            type: 'preview',
                            container: container,
                            ui: draggableArgs.getDragPreviewPieces(args)
                        });
                    }
                });
            },
            onDragStart () {
                setInternalState({
                    type: 'dragging'
                });
            },
            onDrop () {
                setInternalState($e84db801d338b3e1$var$idle);
            }
        });
    }, [
        draggableArgs,
        getDraggableElement
    ]);
    // Set up drop target
    (0, $eJOHy.useEffect)(()=>{
        if (!dropTargetArgs) return;
        // Don't need to provide a draggable element to have a drop target.
        // Using this element in our `canDrop` check
        const draggableElement = getDraggableElement();
        const dropTarget = dropTargetRef.current;
        (0, $8GOss.default)(dropTarget, `dropTargetRef was not set`);
        return (0, $bGx3v.dropTargetForElements)({
            element: dropTarget,
            // cannot drop on self
            canDrop: (args)=>{
                // cannot drop on self
                if (args.source.element === draggableElement) return false;
                if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args);
                return true;
            },
            // menu items are always sticky, and the GroupDropIndicator should clear stickiness
            getIsSticky: ()=>true,
            getData (args) {
                const data = dropTargetArgs.getData?.(args) ?? {};
                const operations = dropTargetArgs.getOperations(args);
                return (0, $e3gfr.attachInstruction)(data, {
                    input: args.input,
                    element: args.element,
                    operations: operations
                });
            },
            onDragStart ({ self: self }) {
                const instruction = (0, $e3gfr.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            },
            onDrag ({ self: self }) {
                const instruction = (0, $e3gfr.extractInstruction)(self.data);
                setInternalState((current)=>{
                    if (current.type === 'is-over' && instruction?.operation === current.instruction?.operation && instruction?.blocked === current.instruction?.blocked) return current;
                    return {
                        type: 'is-over',
                        instruction: instruction
                    };
                });
            },
            onDragLeave () {
                setInternalState($e84db801d338b3e1$var$idle);
            },
            onDrop () {
                setInternalState($e84db801d338b3e1$var$idle);
            },
            onDragEnter ({ self: self }) {
                const instruction = (0, $e3gfr.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            }
        });
    }, [
        dropTargetArgs,
        getDraggableElement
    ]);
    const dragPreview = (()=>{
        if (internalState.type !== 'preview') return null;
        return /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iSqfo.DragPreview), {
            elemBefore: internalState.ui.elemBefore,
            children: internalState.ui.content
        }), internalState.container);
    })();
    const dropIndicator = internalState.type === 'is-over' && internalState.instruction && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2VZV5.DropIndicator), {
        instruction: internalState.instruction
    });
    const state = (0, $eJOHy.useMemo)(()=>{
        if (internalState.type === 'preview') return {
            type: 'preview'
        };
        // returning a new object to avoid modification of our `internalState` object
        return {
            ...internalState
        };
    }, [
        internalState
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: dragPreview,
        dropIndicator: dropIndicator
    };
}

});
parcelRegister("dX4g9", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("5bXoL")).pointerOutsideOfPreview);

var $5bXoL = parcelRequire("5bXoL");

});
parcelRegister("5bXoL", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => $99f0b152501a18af$export$427e20518819fabc);

var $9Hsiy = parcelRequire("9Hsiy");

var $3TrOu = parcelRequire("3TrOu");

var $krDov = parcelRequire("krDov");
function $99f0b152501a18af$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $3TrOu.isSafariOnIOS)() || (0, $9Hsiy.isAndroid)()) return (0, $krDov.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("3TrOu", function(module, exports) {
$parcel$export(module.exports, "isSafariOnIOS", () => $db2d2f1f898037a9$export$52fc40c68fea4952);

var $6Z6g4 = parcelRequire("6Z6g4");

var $72Sl2 = parcelRequire("72Sl2");
const $db2d2f1f898037a9$export$52fc40c68fea4952 = (0, $6Z6g4.once)(function isSafariOnIOS() {
    return (0, $72Sl2.isSafari)() && 'ontouchend' in document;
});

});

parcelRegister("krDov", function(module, exports) {
$parcel$export(module.exports, "centerUnderPointer", () => $8074e1043a67dc41$export$81d8e72a15eef435);
const $8074e1043a67dc41$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};

});



parcelRegister("aHiGM", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("eh3wh")).setCustomNativeDragPreview);

var $eh3wh = parcelRequire("eh3wh");

});
parcelRegister("eh3wh", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => $873d376f67ddeb9b$export$52d889c66db0f96e);

var $lMeHP = parcelRequire("lMeHP");

var $72Sl2 = parcelRequire("72Sl2");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $873d376f67ddeb9b$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $873d376f67ddeb9b$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $873d376f67ddeb9b$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $2ec8d9a2d82c6656$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $72Sl2.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $lMeHP.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $2ec8d9a2d82c6656$export$7d0a15ee70427305 = 2147483647;



parcelRegister("iSqfo", function(module, exports) {
$parcel$export(module.exports, "DragPreview", () => $fbbc1d3e27758aa6$export$905ab40ac2179daa);
/* drag-preview.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4vXRJ = parcelRequire("4vXRJ");

var $2tKAE = parcelRequire("2tKAE");

var $kbcF8 = parcelRequire("kbcF8");
// Using JavaScript for detecting Safari, as I could not find a reliable way to do it with CSS.
function $fbbc1d3e27758aa6$var$isSafari() {
    if (typeof window === 'undefined') return false;
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
}
const $fbbc1d3e27758aa6$var$dragPreviewStyles = {
    root: "_2rko12b0 _189ee4h9 _1h6dmuej _1dqonqa1 _bfhkvuon _y4ti1b66 _p12fgx0z",
    safariFix: "_1ul9uuw1"
};
function $fbbc1d3e27758aa6$export$905ab40ac2179daa({ elemBefore: elemBefore, children: children }) {
    return(// Resetting the expandable menu items to 0.
    // This is to prevent our hidden element from pushing
    // the drag preview further away from the users pointer
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4vXRJ.ExpandableMenuItemLevelContext).Provider, {
        value: 0,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                $fbbc1d3e27758aa6$var$dragPreviewStyles.root,
                $fbbc1d3e27758aa6$var$isSafari() && $fbbc1d3e27758aa6$var$dragPreviewStyles.safariFix
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKAE.MenuItemBase), {
                elemBefore: elemBefore ?? (0, $kbcF8.COLLAPSE_ELEM_BEFORE),
                children: children
            })
        })
    }));
}

});

parcelRegister("2VZV5", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $b07d1edf37d99fe4$export$62ed72bc21f6b8a6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5HaAt = parcelRequire("5HaAt");

var $igtYB = parcelRequire("igtYB");
const $b07d1edf37d99fe4$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom'
    },
    horizontal: {
        start: 'left',
        end: 'right'
    }
};
function $b07d1edf37d99fe4$export$62ed72bc21f6b8a6({ instruction: instruction, lineGap: lineGap, lineType: lineType }) {
    const appearance = instruction.blocked ? 'warning' : 'default';
    const axis = $b07d1edf37d99fe4$var$axisLookup[instruction.axis];
    if (instruction.operation === 'combine') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5HaAt.DropIndicator), {
        appearance: appearance
    });
    if (instruction.operation === 'reorder-before') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
        edge: axis.start,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    if (instruction.operation === 'reorder-after') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
        edge: axis.end,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    return null;
}

});
parcelRegister("5HaAt", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $23ed11adb70c127c$export$62ed72bc21f6b8a6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4EbJC = parcelRequire("4EbJC");

var $kStpA = parcelRequire("kStpA");
function $23ed11adb70c127c$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4EbJC.Border), {
        strokeColor: (0, $kStpA.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$23ed11adb70c127c$export$2e2bcd8739ae039 = $23ed11adb70c127c$export$62ed72bc21f6b8a6;

});
parcelRegister("4EbJC", function(module, exports) {
$parcel$export(module.exports, "Border", () => $00f4a5c271d0d0a5$export$d8e9c9d63e86d41e);
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kStpA = parcelRequire("kStpA");
const $00f4a5c271d0d0a5$var$styles = null;
function $00f4a5c271d0d0a5$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $kStpA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $kStpA.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $hcewu.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
}
var // For React.lazy
$00f4a5c271d0d0a5$export$2e2bcd8739ae039 = $00f4a5c271d0d0a5$export$d8e9c9d63e86d41e;

});
parcelRegister("kStpA", function(module, exports) {
$parcel$export(module.exports, "presetStrokeColors", () => $45c9411149522a1b$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $45c9411149522a1b$export$45db03aa04b685e3);
const $45c9411149522a1b$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $45c9411149522a1b$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";

});



parcelRegister("igtYB", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $1b026ba11abe5d11$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $1b026ba11abe5d11$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $c4cfI = parcelRequire("c4cfI");

var $kStpA = parcelRequire("kStpA");
function $1b026ba11abe5d11$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4cfI.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $kStpA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$1b026ba11abe5d11$export$2e2bcd8739ae039 = $1b026ba11abe5d11$export$62ed72bc21f6b8a6;

});
parcelRegister("c4cfI", function(module, exports) {
$parcel$export(module.exports, "Line", () => $3ab834a64f4d0661$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kStpA = parcelRequire("kStpA");
const $3ab834a64f4d0661$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $3ab834a64f4d0661$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $3ab834a64f4d0661$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $3ab834a64f4d0661$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $3ab834a64f4d0661$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $3ab834a64f4d0661$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $kStpA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $kStpA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $3ab834a64f4d0661$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $3ab834a64f4d0661$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hcewu.default)([
            $3ab834a64f4d0661$var$baseStyles.root,
            $3ab834a64f4d0661$var$orientationStyles[orientation],
            $3ab834a64f4d0661$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$3ab834a64f4d0661$export$2e2bcd8739ae039 = $3ab834a64f4d0661$export$17d680238e50603e;

});



parcelRegister("e3gfr", function(module, exports) {
$parcel$export(module.exports, "attachInstruction", () => $ecaf412ac889a963$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $ecaf412ac889a963$export$c8ffecbe249dc8f8);

var $d2foH = parcelRequire("d2foH");
// using a symbol so we can guarantee a key with a unique value
const $ecaf412ac889a963$var$uniqueKey = Symbol('list-item-instruction');
const $ecaf412ac889a963$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom',
        size: 'height',
        point: 'y'
    },
    horizontal: {
        start: 'left',
        end: 'right',
        size: 'width',
        point: 'x'
    }
};
function $ecaf412ac889a963$var$reorderAndCombine({ client: client, borderBox: borderBox, axis: axis }) {
    const quarterOfSize = borderBox[axis.size] / 4;
    // In the top 1/4: reorder-before
    // On the line: reorder-before to give a slight preference to reordering
    if (client[axis.point] <= borderBox[axis.start] + quarterOfSize) return 'reorder-before';
    // In the bottom 1/4: reorder-after
    // On the line: reorder-after to give a slight preference to reordering
    if (client[axis.point] >= borderBox[axis.end] - quarterOfSize) return 'reorder-after';
    return 'combine';
}
function $ecaf412ac889a963$var$reorder({ client: client, borderBox: borderBox, axis: axis }) {
    const halfSize = borderBox[axis.size] / 2;
    // In the top 1/2: reorder-before
    // On the line: reorder-after to give a slight preference to moving forward
    if (client[axis.point] < borderBox[axis.start] + halfSize) return 'reorder-before';
    return 'reorder-after';
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $ecaf412ac889a963$var$memoizeInstruction = (0, $d2foH.stable)();
function $ecaf412ac889a963$var$isPossible(...values) {
    return values.every((value)=>value === 'available' || value === 'blocked');
}
function $ecaf412ac889a963$var$isNotAvailable(...values) {
    return values.every((value)=>value === 'not-available');
}
function $ecaf412ac889a963$export$267ad49d812c2c7f(userData, { operations: operations, element: element, input: input, axis: axisValue = 'vertical' }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    const axis = $ecaf412ac889a963$var$axisLookup[axisValue];
    const combine = operations.combine ?? 'not-available';
    const reorderAbove = operations['reorder-before'] ?? 'not-available';
    const reorderBelow = operations['reorder-after'] ?? 'not-available';
    const operation = (()=>{
        // Combining not possible
        if (!$ecaf412ac889a963$var$isPossible(combine)) {
            // can reorder above and below
            if ($ecaf412ac889a963$var$isPossible(reorderAbove, reorderBelow)) return $ecaf412ac889a963$var$reorder({
                client: client,
                borderBox: borderBox,
                axis: axis
            });
            // can only reorder above
            if ($ecaf412ac889a963$var$isPossible(reorderAbove)) return 'reorder-before';
            // can only reorder below
            if ($ecaf412ac889a963$var$isPossible(reorderBelow)) return 'reorder-after';
            // no `true` values - no Outcome available.
            return null;
        }
        // combining is available
        const result = $ecaf412ac889a963$var$reorderAndCombine({
            client: client,
            borderBox: borderBox,
            axis: axis
        });
        if (result === 'reorder-after') return $ecaf412ac889a963$var$isNotAvailable(reorderBelow) ? 'combine' : result;
        if (result === 'reorder-before') return $ecaf412ac889a963$var$isNotAvailable(reorderAbove) ? 'combine' : result;
        return result;
    })();
    // We cannot attach an instruction - all values passed where `false` or no values passed
    if (!operation) return userData;
    const instruction = {
        operation: operation,
        blocked: operations[operation] === 'blocked',
        axis: axisValue
    };
    const memoized = $ecaf412ac889a963$var$memoizeInstruction(instruction);
    return {
        ...userData,
        [$ecaf412ac889a963$var$uniqueKey]: memoized
    };
}
function $ecaf412ac889a963$export$c8ffecbe249dc8f8(userData) {
    return userData[$ecaf412ac889a963$var$uniqueKey] ?? null;
}

});
parcelRegister("d2foH", function(module, exports) {
$parcel$export(module.exports, "isShallowEqual", () => $9b80b5f622cdc59f$export$2225b4c39d37f8b3);
$parcel$export(module.exports, "stable", () => $9b80b5f622cdc59f$export$3f55479a3469259f);
function $9b80b5f622cdc59f$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $9b80b5f622cdc59f$export$3f55479a3469259f(isEqual = $9b80b5f622cdc59f$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}

});



parcelRegister("3X9cT", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $7ca8841fadbc0582$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $7ca8841fadbc0582$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTIC_PAYLOAD", () => $7ca8841fadbc0582$export$4a2242445a67aef7);
$parcel$export(module.exports, "NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP", () => $7ca8841fadbc0582$export$e320e335fe38c28a);




var $a9aec = parcelRequire("a9aec");


const $7ca8841fadbc0582$export$b8b9d90f9e5bd72b = 'jira-navigation-apps-sidebar-nav4-projects-customise-order';
const $7ca8841fadbc0582$export$d57b6b390e78d90f = 'jira-cosmos';
const $7ca8841fadbc0582$export$4a2242445a67aef7 = {
    UPDATED_ORDER: {
        action: 'updated',
        actionSubject: 'sidebarNavigationItems',
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    },
    ATTRIBUTES: {
        level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
        componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
        itemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
        section: (0, $a9aec.SECTION_ITEM_STARRED)
    },
    DRAG_STARTED: {
        action: 'dragStarted',
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    },
    DRAG_LEFT: {
        action: 'dragLeft',
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    },
    DRAG_ENTERED: {
        action: 'dragEntered',
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    },
    DRAG_ENDED: {
        action: 'dragEnded',
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    }
};
const $7ca8841fadbc0582$export$e320e335fe38c28a = 'nav4-sidebar-project-menu-item-drag-and-drop';

});

parcelRegister("fpJnI", function(module, exports) {
$parcel$export(module.exports, "FocusRestorationContext", () => $72b8cfa15fa83210$export$ee843363a931c6f7);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $72b8cfa15fa83210$export$ee843363a931c6f7 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    shouldRestoreFocus: false,
    enableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    clearRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});



parcelRegister("4lj4q", function(module, exports) {
$parcel$export(module.exports, "AsyncJpdProjectMenu", () => $9e4adbd9d5aff3a9$export$b446e65eeda5c1fb);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $if69u = parcelRequire("if69u");
const $9e4adbd9d5aff3a9$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 1
    });

const $9e4adbd9d5aff3a9$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4hVS1")).then(({ JpdProjectMenu: JpdProjectMenu })=>JpdProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jpd-project-menu/src/ui/index.tsx"
});
const $9e4adbd9d5aff3a9$export$b446e65eeda5c1fb = /*#__PURE__*/ (0, $eJOHy.memo)(({ projectData: projectData, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jpd-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JPDProjectMenu",
        ufoName: "nav4.sidebar.jpd-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.jpd-project-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9e4adbd9d5aff3a9$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9e4adbd9d5aff3a9$var$LazySidebarContent, {
        projectData: projectData,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("2hZzG", function(module, exports) {
$parcel$export(module.exports, "SidebarBoundary", () => $5ef1da860dc7aac4$export$1edc778464f08256);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $bFY6o = parcelRequire("bFY6o");

var $aqnJa = parcelRequire("aqnJa");

var $kQnVX = parcelRequire("kQnVX");

var $4EKqI = parcelRequire("4EKqI");

var $hyK5y = parcelRequire("hyK5y");

var $gaosd = parcelRequire("gaosd");
const $5ef1da860dc7aac4$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName, ufoName: ufoName = '' })=>{
    const { experience: experience, attributes: attributes } = (0, $hyK5y.useSidebarExperience)();
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const onAbort = (0, $bFY6o.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const userLocation = (0, $kQnVX.getUserLocation)();
    const isNotSSR = !false;
    const extraEventData = (0, $eJOHy.useMemo)(()=>({
            userLocation: userLocation
        }), [
        userLocation
    ]);
    const fallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gaosd.Fallback), {
            error: error
        }), []);
    const handleError = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (location, error)=>{
        const { statusCode: statusCode } = error;
        if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
            error: error
        });
        else onFail(location, error);
    }, [
        onAbort,
        onFail
    ]);
    const UFOSegmentORFragment = ufoName ? (0, $4EKqI.default) : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(UFOSegmentORFragment, {
        name: ufoName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        extraEventData: extraEventData,
        fallback: fallback,
        teamName: teamName,
        onError: handleError
    }, isNotSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hyK5y.SidebarStart), null), children));
};

});
parcelRegister("gaosd", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $f3c22cd43bba1219$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $jLjxj = parcelRequire("jLjxj");

var $igCP5 = parcelRequire("igCP5");

var $lRq8t = parcelRequire("lRq8t");

var $aFnM0 = parcelRequire("aFnM0");
const $f3c22cd43bba1219$var$styles = {
    wrapper: "_zulpu2gc _bfhkm7j4 _syaz1gjq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o",
    error: "_2rkolb4i _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
};
const $f3c22cd43bba1219$export$fb8d7f40caaeea67 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $f3c22cd43bba1219$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igCP5.default), {
        width: "40px",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $aFnM0.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $aFnM0.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $f3c22cd43bba1219$var$styles.error
    }, "ERROR: ", (0, $jLjxj.getErrorHash)(error)));
};

});
parcelRegister("igCP5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ff71d828dd91298$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("esilX")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("4KYMV")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $c4huj = parcelRequire("c4huj");

var $4KYMV = parcelRequire("4KYMV");

var $esilX = parcelRequire("esilX");
const $0ff71d828dd91298$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($esilX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4KYMV))
});
var $0ff71d828dd91298$export$2e2bcd8739ae039 = $0ff71d828dd91298$var$Illustration;
// for advanced use only
const $0ff71d828dd91298$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("c4huj", function(module, exports) {
$parcel$export(module.exports, "Illustration", () => $23ef7a56b51bae71$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $23ef7a56b51bae71$export$4d00e7be716a0093);

var $eJOHy = parcelRequire("eJOHy");

var $7Tdyj = parcelRequire("7Tdyj");
function $23ef7a56b51bae71$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tdyj.AsImg), props);
}
function $23ef7a56b51bae71$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23ef7a56b51bae71$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("7Tdyj", function(module, exports) {
$parcel$export(module.exports, "AsImg", () => $0b0259f6264d72ea$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");
// Moved to src/packages/illustrations/illustration/src/ui/types.tsx to avoid circular dependency
// export interface AsImgProps extends IllustrationProps, ImgHTMLAttributes<HTMLImageElement>
// suggested defaults, the consumer is free to override
const $0b0259f6264d72ea$var$defaultStyles = null;
const $0b0259f6264d72ea$var$fillStyles = null;
const $0b0259f6264d72ea$var$autoDarkModeStyles = null;
function $0b0259f6264d72ea$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $58yRG.default)();
    return /*#__PURE__*/ $eJOHy.createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $hcewu.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("4KYMV", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("esilX", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("aFnM0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4902ad1ceed26b1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b4902ad1ceed26b1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeading: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("4hVS1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("aiCDP")
]).then(()=>parcelRequire('f5jWz'));

});


parcelRegister("1v9jo", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmProjectMenu", () => $df580e6e6daeb9c1$export$bf0d7afec25f82d7);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $2hZzG = parcelRequire("2hZzG");

var $bQWwW = parcelRequire("bQWwW");

var $if69u = parcelRequire("if69u");

var $2FqDG = parcelRequire("2FqDG");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");
const $df580e6e6daeb9c1$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 1
    });

const $df580e6e6daeb9c1$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3ELxN")).then(({ JsmProjectMenu: JsmProjectMenu })=>JsmProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jsm-project-menu/src/ui/project-menu/index.tsx"
});
const $df580e6e6daeb9c1$var$LazySidebarContentWrapperWithProjectKeyCheck = (props)=>{
    const [projectKey] = (0, $2FqDG.usePathParam)('projectKey');
    if ((0, $4cTDP.fg)('support-getting-customization-using-issue-key')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$LazySidebarContentWrapper, props);
    if ((0, $4cTDP.fg)('more-remounting-fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$LazySidebarContent, props);
    if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$LazySidebarContent, props);
    if (typeof false !== 'undefined' && false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$LazySidebarContentWrapper, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$LazySidebarContent, props);
};

const $df580e6e6daeb9c1$var$LazySidebarContentWrapper = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2Z7CB")).then(({ JsmProjectMenuWrapper: JsmProjectMenuWrapper })=>JsmProjectMenuWrapper), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jsm-project-menu/src/ui/project-menu/JsmProjectMenuWrapper.tsx"
});
const $df580e6e6daeb9c1$var$JsmProjectMenuLazy = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('more_for_nav_4_level_3'), $df580e6e6daeb9c1$var$LazySidebarContentWrapperWithProjectKeyCheck, $df580e6e6daeb9c1$var$LazySidebarContent);
const $df580e6e6daeb9c1$export$bf0d7afec25f82d7 = /*#__PURE__*/ (0, $eJOHy.memo)(({ projectData: projectData, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jsm-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JsmProjectMenu",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.jsm-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$JsmProjectMenuLazy, {
        projectData: projectData,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("3ELxN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cnNml").then(()=>parcelRequire('aNYOV'));

});

parcelRegister("2Z7CB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iLSzU").then(()=>parcelRequire('dMwVQ'));

});


parcelRegister("3VmU5", function(module, exports) {
$parcel$export(module.exports, "AsyncJcsProjectMenu", () => $df7bf058fd9c7924$export$30175e6def84a269);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $if69u = parcelRequire("if69u");
const $df7bf058fd9c7924$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 1
    });

const $df7bf058fd9c7924$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("aNrBU")).then(({ JcsProjectMenu: JcsProjectMenu })=>JcsProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jcs-project-menu/src/ui/project-menu/JcsProjectMenu.tsx"
});
const $df7bf058fd9c7924$export$30175e6def84a269 = /*#__PURE__*/ (0, $eJOHy.memo)(({ projectData: projectData, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JcsProjectMenu",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.jcs-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df7bf058fd9c7924$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df7bf058fd9c7924$var$LazySidebarContent, {
        projectData: projectData,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("aNrBU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kjkY9").then(()=>parcelRequire('e5DTv'));

});


parcelRegister("3Nj6K", function(module, exports) {
$parcel$export(module.exports, "JswProjectMenu", () => $4cc1c0fd5218172a$export$6bfce83b67850c4);

var $a7ted = parcelRequire("a7ted");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $FhXEJ = parcelRequire("FhXEJ");

var $3QIey = parcelRequire("3QIey");

var $3yuGT = parcelRequire("3yuGT");

var $gT0jg = parcelRequire("gT0jg");
const $4cc1c0fd5218172a$export$6bfce83b67850c4 = ({ projectData: projectData, menuItemAnchorRef: menuItemAnchorRef, menuItemButtonRef: menuItemButtonRef })=>{
    const project = (0, $j4oe4.useFragment)((0, $a7ted.default), projectData);
    if (project.softwareBoardCount && project.softwareBoardCount > 0 && project.projectStyle === (0, $FhXEJ.COMPANY_MANAGED_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3QIey.WillRedirectOnLoadProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3yuGT.JswExpandableProject), {
        projectData: project,
        menuItemButtonRef: menuItemButtonRef
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gT0jg.JswNonExpandableProject), {
        projectData: project,
        menuItemAnchorRef: menuItemAnchorRef
    });
};

});
parcelRegister("a7ted", function(module, exports) {
$parcel$export(module.exports, "default", () => $deeb8c7e29322855$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebd04d48d90ea3ce2f73465099d87768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $deeb8c7e29322855$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswProjectMenu",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswNonExpandableProject"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswExpandableProject"
        }
    ],
    "type": "JiraProject"
};
$deeb8c7e29322855$var$node.hash = "27f10b420257dabdaa5ad33027d9b82c";
var $deeb8c7e29322855$export$2e2bcd8739ae039 = $deeb8c7e29322855$var$node;

});

parcelRegister("3QIey", function(module, exports) {
$parcel$export(module.exports, "WillRedirectOnLoadProviders", () => $383d28f1363f9e28$export$e5e54b40f58f4bf4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6IMub = parcelRequire("6IMub");
const $383d28f1363f9e28$export$e5e54b40f58f4bf4 = ({ children: children })=>{
    const [willRedirectOnLoad, setWillRedirectOnLoad] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IMub.WillRedirectOnLoadContext).Provider, {
        value: willRedirectOnLoad,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IMub.SetWillRedirectOnLoadContext).Provider, {
            value: setWillRedirectOnLoad,
            children: children
        })
    });
};

});
parcelRegister("6IMub", function(module, exports) {
$parcel$export(module.exports, "WillRedirectOnLoadContext", () => $5f7787f2a96089d5$export$7c9713df22ffd008);
$parcel$export(module.exports, "SetWillRedirectOnLoadContext", () => $5f7787f2a96089d5$export$61b58f7123070fe1);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $5f7787f2a96089d5$export$7c9713df22ffd008 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $5f7787f2a96089d5$export$61b58f7123070fe1 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));

});


parcelRegister("3yuGT", function(module, exports) {
$parcel$export(module.exports, "JswExpandableProject", () => $5988c926da25ecd5$export$a77599e713340697);

var $60YqG = parcelRequire("60YqG");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6l5yN = parcelRequire("6l5yN");
var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");
var $yFG6a = parcelRequire("yFG6a");

var $iWvkh = parcelRequire("iWvkh");

var $762yz = parcelRequire("762yz");

var $dN2O6 = parcelRequire("dN2O6");

var $h4Bzb = parcelRequire("h4Bzb");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $206hf = parcelRequire("206hf");

var $azEgq = parcelRequire("azEgq");

var $hPlDs = parcelRequire("hPlDs");

var $iKXaJ = parcelRequire("iKXaJ");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $eApSa = parcelRequire("eApSa");


var $jrulJ = parcelRequire("jrulJ");

var $2FqDG = parcelRequire("2FqDG");

var $7fbRv = parcelRequire("7fbRv");

var $bzbsd = parcelRequire("bzbsd");

var $1NfYk = parcelRequire("1NfYk");

var $bBtQo = parcelRequire("bBtQo");

var $4lYYK = parcelRequire("4lYYK");
var $drzt5 = parcelRequire("drzt5");


var $5DQfo = parcelRequire("5DQfo");
const $5988c926da25ecd5$export$a77599e713340697 = ({ projectData: projectData, menuItemButtonRef: menuItemButtonRef })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const project = (0, $j4oe4.useFragment)((0, $60YqG.default), projectData);
    const cloudId = (0, $cHtIB.useCloudId)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            },
            context: {
                match: {
                    params: {
                        projectKey: project.projectKey
                    }
                }
            }
        }), [
        cloudId,
        project.projectKey
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const boardsEPRef = leftSidebarEPRef?.entryPoints?.boards;
    const [projectKeyPathParam] = (0, $2FqDG.usePathParam)('projectKey');
    const [issueKeyPathParam] = (0, $2FqDG.usePathParam)('issueKey');
    let projectKey = projectKeyPathParam;
    if (issueKeyPathParam && (0, $4cTDP.fg)('move-issue-view-to-entrypoint')) projectKey = (0, $bBtQo.getProjectKeyFromProjectOrIssueKey)('', issueKeyPathParam);
    const shouldRenderBoardsEntryPoint = project.projectKey === projectKey;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $5DQfo.nav4JSWProjectEntryPoint), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    const [entryPointConfig] = (0, $eJOHy.useState)(()=>{
        const epContainerProps = {
            id: 'jsw-expandable-project',
            packageName: (0, $62baa2e6fd157602$export$b8b9d90f9e5bd72b),
            teamName: (0, $62baa2e6fd157602$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eApSa.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: boardsEPRef,
                    placeholderEntryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint),
                    shouldRenderNestedEntryPoint: shouldRenderBoardsEntryPoint
                })
        };
    });
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(entryPointConfig.Component, null);
    const setWillRedirectOnLoad = (0, $4lYYK.useSetWillRedirectOnLoad)();
    const onSystemToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
        else setWillRedirectOnLoad(false);
    }, [
        entryPointActions,
        setWillRedirectOnLoad
    ]);
    const onExpansionToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        } else setWillRedirectOnLoad(false);
    }, [
        entryPointActions,
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendProjectMenuItemAnalyticsEvent,
        setWillRedirectOnLoad
    ]);
    const onClick = (0, $eJOHy.useCallback)((ev)=>{
        if ((0, $762yz.isNormalClick)(ev)) ev.preventDefault();
    }, []);
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $1NfYk.useProjectMenuItemDragAndDrop)({
        projectId: project.projectId,
        projectKey: project.projectKey,
        isFavourite: project.isFavourite,
        name: project.name,
        avatar: project.avatar,
        isEnabled: !!project.isFavourite && (0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
    });
    if (!project) return null;
    const menuId = (0, $h4Bzb.ENTITY_ID).PROJECT(project.projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: menuId,
        onSystemToggle: onSystemToggle,
        onExpansionToggle: onExpansionToggle,
        dropIndicator: dropIndicator,
        dropTargetRef: dropTargetRef,
        isDragging: state.type === 'dragging'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5988c926da25ecd5$var$ExpandableMenuItemTriggerWithSetWillRedirectOnLoad, {
        ...getLinkProps((0, $iKXaJ.removeBaseUrl)(project.webUrl)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fbRv.ProjectActions), {
            projectFragment: project
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6l5yN.ContainerAvatar), {
            src: project.avatar.large
        }),
        ref: (0, $bzbsd.mergeRefs)(draggableAnchorRef, ...[
            triggerRef,
            menuItemButtonRef
        ].filter(Boolean)),
        onClick: onClick,
        testId: (0, $azEgq.getTestId)(menuId),
        hasDragIndicator: hasDragIndicator,
        isDragging: state.type === 'dragging',
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-jsw-project' : undefined
    }, project.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, content())), dragPreview);
};
// A thin wrapper so we can access `isExpanded` via hook.
// We redirect on load when the label is clicked, so we only do this in `onClick` and not in any of the toggle handlers (which the chevron also uses).
const $5988c926da25ecd5$var$ExpandableMenuItemTriggerWithSetWillRedirectOnLoad = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onClick: onClick, ...props }, ref)=>{
    const isExpanded = (0, $yFG6a.useIsExpanded)();
    // If not currently expanded we want to redirect on load.
    // If currently expanded, the toggle handlers above will set to false.
    const onClickActual = (0, $drzt5.useWithSetWillRedirectOnLoad)(onClick, true, !isExpanded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        onClick: onClickActual,
        ref: ref,
        ...props
    }, children);
});

});
parcelRegister("60YqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee7950a6fbc6db3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd53fccb802d557a4a32e350520478a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ee7950a6fbc6db3a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswExpandableProject",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$ee7950a6fbc6db3a$var$node.hash = "97fa53b11ac066ee14270d6da1ac0254";
var $ee7950a6fbc6db3a$export$2e2bcd8739ae039 = $ee7950a6fbc6db3a$var$node;

});

parcelRegister("762yz", function(module, exports) {
$parcel$export(module.exports, "isNormalClick", () => $79b800b4de890321$export$729f3684d5c2b9b9);
const $79b800b4de890321$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});

parcelRegister("206hf", function(module, exports) {
$parcel$export(module.exports, "useGetLinkProps", () => $2cc0385e8de7b401$export$a3307878c8496d13);

var $eJOHy = parcelRequire("eJOHy");

var $02kpm = parcelRequire("02kpm");

var $jRu18 = parcelRequire("jRu18");
const $2cc0385e8de7b401$export$a3307878c8496d13 = ()=>{
    const location = (0, $jRu18.useLocation)();
    const getLinkProps = (0, $eJOHy.useCallback)((menuItemPath, options)=>$2cc0385e8de7b401$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $eJOHy.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $02kpm.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $2cc0385e8de7b401$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $2cc0385e8de7b401$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$2cc0385e8de7b401$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});

parcelRegister("iKXaJ", function(module, exports) {
$parcel$export(module.exports, "removeBaseUrl", () => $77577f77d57d6c9b$export$d401b6140b158f69);
/**
 * Removes the base URL from the given URL string.
 *
 * @param url - The URL string from which to remove the base URL.
 * @returns The URL string with the base URL removed.
 */ const $77577f77d57d6c9b$export$d401b6140b158f69 = (url)=>url.replace(/https?:\/\/[^/]+/, '');

});

parcelRegister("7fbRv", function(module, exports) {
$parcel$export(module.exports, "ProjectActions", () => $8ba2842cf1fe0c21$export$7f68bfd3564d5c6f);

var $ewTnc = parcelRequire("ewTnc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dcLzM = parcelRequire("dcLzM");

var $2sLVw = parcelRequire("2sLVw");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $lHnXI = parcelRequire("lHnXI");

var $ajqBI = parcelRequire("ajqBI");

var $bS07j = parcelRequire("bS07j");

var $1vZwP = parcelRequire("1vZwP");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $c9EyR = parcelRequire("c9EyR");

var $iBeto = parcelRequire("iBeto");
const $8ba2842cf1fe0c21$var$Trigger = ({ triggerRef: triggerRef, isFavourite: isFavourite, projectId: projectId, projectType: projectType, setCreateBoardButtonRef: setCreateBoardButtonRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    // callback to set button element to local ref.
    // to be used as prop for setting focus back to button after modal close.
    const setRef = (0, $eJOHy.useCallback)((buttonElement)=>{
        setCreateBoardButtonRef(buttonElement);
        if (typeof triggerRef === 'function') triggerRef(buttonElement);
    }, [
        setCreateBoardButtonRef,
        triggerRef
    ]);
    const onCommonNavMenuButtonClick = (0, $eJOHy.useCallback)((event)=>{
        const { onClick: onClick } = props;
        onClick?.(event);
        sendCreateBoardOnBoardMenuItemAnalyticsEvent({
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        isFavourite,
        projectId,
        projectType,
        props,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $iBeto.default).createBoard)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        ...props,
        onClick: onCommonNavMenuButtonClick,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $iBeto.default).createBoard),
        ref: setRef
    }));
};
const $8ba2842cf1fe0c21$export$7f68bfd3564d5c6f = ({ projectFragment: projectFragment, isCorePremiumUserSeat: isCorePremiumUserSeat = false })=>{
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    const createBoardButtonRef = (0, $eJOHy.useRef)(null);
    const project = (0, $j4oe4.useFragment)((0, $ewTnc.default), projectFragment);
    const onProjectActionMenuClick = (0, $eJOHy.useCallback)(()=>{
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            starred: project.isFavourite ?? false,
            recent: !project.isFavourite,
            projectId: project.projectId,
            projectType: project.projectType
        });
    }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const projectActionMenu = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bS07j.ProjectActionMenu), {
            ...(0, $4cTDP.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                projectName: project.name
            } : {},
            onClick: onProjectActionMenuClick,
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            isProjectMenuReorderingEnabled: project?.isFavourite === true && (0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
        });
    }, [
        project.name,
        project.projectKey,
        project.isFavourite,
        onProjectActionMenuClick,
        isCorePremiumUserSeat
    ]);
    const setCreateBoardButtonRef = (0, $eJOHy.useCallback)((instance)=>{
        createBoardButtonRef.current = instance;
    }, [
        createBoardButtonRef
    ]);
    const renderTrigger = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ba2842cf1fe0c21$var$Trigger, {
            ...props,
            isFavourite: project.isFavourite ?? false,
            projectId: project.projectId,
            projectType: project.projectType,
            setCreateBoardButtonRef: setCreateBoardButtonRef
        }), [
        project.isFavourite,
        project.projectId,
        project.projectType,
        setCreateBoardButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.050",
        alignItems: "center"
    }, (0, $c9EyR.isCompanyManagedSoftwareProject)(project.projectStyle, project.projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1vZwP.BoardCreate), {
        projectId: project.projectId,
        projectAvatar: project.avatar?.large || undefined,
        triggerRef: createBoardButtonRef,
        renderTrigger: renderTrigger
    })), projectActionMenu);
};

});
parcelRegister("ewTnc", function(module, exports) {
$parcel$export(module.exports, "default", () => $27697303e42019e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94412159ecf4c6719e0b693430702470>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $27697303e42019e8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectActions",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$27697303e42019e8$var$node.hash = "9dfad03558453fb6e77a8bab64d959e3";
var $27697303e42019e8$export$2e2bcd8739ae039 = $27697303e42019e8$var$node;

});

parcelRegister("1vZwP", function(module, exports) {
$parcel$export(module.exports, "BoardCreate", () => $724aa2c910f9e79e$export$c753ba73bc24874c);

var $eJOHy = parcelRequire("eJOHy");

var $gHO4S = parcelRequire("gHO4S");

var $s6xA3 = parcelRequire("s6xA3");
const $724aa2c910f9e79e$export$c753ba73bc24874c = ({ projectId: projectId, projectAvatar: projectAvatar, renderTrigger: renderTrigger, triggerRef: triggerRef })=>{
    if (!projectId) {
        (0, $gHO4S.fireBoardCreateErrorAnalytics)({
            error: new Error('Failed to load board create flyout menu: projectId undefined'),
            attributes: {
                projectId: projectId
            },
            id: 'loadFlyoutMenu'
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $s6xA3.BoardCreateFlyoutMenu), {
        renderTrigger: renderTrigger,
        projectId: projectId,
        projectAvatar: projectAvatar,
        triggerRef: triggerRef
    });
};

});
parcelRegister("gHO4S", function(module, exports) {
$parcel$export(module.exports, "fireBoardCreateErrorAnalytics", () => $61df6e2e77086e7b$export$77dbc1f87d29b068);
$parcel$export(module.exports, "descriptionMapping", () => $61df6e2e77086e7b$export$56900bfb74887fe8);

var $9pTd3 = parcelRequire("9pTd3");

var $2pys5 = parcelRequire("2pys5");

var $pkfsB = parcelRequire("pkfsB");
const $61df6e2e77086e7b$export$77dbc1f87d29b068 = ({ attributes: attributes, id: id, error: error })=>{
    (0, $9pTd3.fireErrorAnalytics)({
        error: error,
        attributes: attributes,
        meta: {
            id: `jiraSoftwareBoardCreate_${id}`,
            packageName: (0, $2pys5.BOARD_CREATE_PACKAGE_NAME),
            teamName: (0, $2pys5.TEAM_NAME)
        },
        skipSentry: true
    });
};
const $61df6e2e77086e7b$export$56900bfb74887fe8 = {
    [(0, $2pys5.BOARD_TYPES).KANBAN]: (0, $pkfsB.default).kanbanBoardCreationDescription,
    [(0, $2pys5.BOARD_TYPES).SCRUM]: (0, $pkfsB.default).scrumBoardCreationDescription
};

});
parcelRegister("2pys5", function(module, exports) {
$parcel$export(module.exports, "FLYOUT_MENU_CONTENT_ID", () => $8c7271f72bf58c54$export$ff67d81ebedcc801);
$parcel$export(module.exports, "BOARD_CREATE_PACKAGE_NAME", () => $8c7271f72bf58c54$export$3df8123340981894);
$parcel$export(module.exports, "TEAM_NAME", () => $8c7271f72bf58c54$export$d57b6b390e78d90f);
$parcel$export(module.exports, "BOARD_TYPES", () => $8c7271f72bf58c54$export$165dc6fdd115b0c1);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS", () => $8c7271f72bf58c54$export$318250ad9945de5c);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS_JQLTERM", () => $8c7271f72bf58c54$export$9f85086c10bd31f5);
$parcel$export(module.exports, "PICKER_SEARCH_DEBOUNCE_TIME", () => $8c7271f72bf58c54$export$f487cf015ececc3a);
$parcel$export(module.exports, "VALIDATION_ERROR_EMPTY", () => $8c7271f72bf58c54$export$7b060a5763a6e199);
$parcel$export(module.exports, "BOARD_NAME_LIMIT", () => $8c7271f72bf58c54$export$d760e95d248dc3a3);
const $8c7271f72bf58c54$export$edded98b84a6f50f = 'jsw-board-create';
const $8c7271f72bf58c54$export$ff67d81ebedcc801 = 'jsw-board-create-flyout-menu-content';
const $8c7271f72bf58c54$export$3df8123340981894 = 'jiraSoftwareBoardCreate';
const $8c7271f72bf58c54$export$d57b6b390e78d90f = 'a4t-pandora';
const $8c7271f72bf58c54$export$165dc6fdd115b0c1 = {
    KANBAN: 'KANBAN',
    SCRUM: 'SCRUM'
};
const $8c7271f72bf58c54$export$318250ad9945de5c = {
    TEAM: 'team',
    ISSUE_TYPES: 'issueTypes',
    LABELS: 'labels',
    SAVED_FILTER: 'savedFilter'
};
const $8c7271f72bf58c54$export$9f85086c10bd31f5 = {
    [$8c7271f72bf58c54$export$318250ad9945de5c.ISSUE_TYPES]: 'type',
    [$8c7271f72bf58c54$export$318250ad9945de5c.LABELS]: 'labels'
};
const $8c7271f72bf58c54$export$f487cf015ececc3a = 500;
const $8c7271f72bf58c54$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $8c7271f72bf58c54$export$d760e95d248dc3a3 = 155;

});

parcelRegister("pkfsB", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d0bbdf347baf74e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1d0bbdf347baf74e$var$messages = (0, $7qGN1.defineMessages)({
    boardCreationTitle: {
        "id": "software-board-create.common.board-creation-title",
        "defaultMessage": "Create a board"
    },
    scrumBoardCreationHeader: {
        "id": "software-board-create.common.scrum-board-creation-header",
        "defaultMessage": "Scrum"
    },
    scrumBoardCreationDescription: {
        "id": "software-board-create.common.scrum-board-creation-description",
        "defaultMessage": "Sprint towards your team objectives with a board, backlog, and reports."
    },
    kanbanBoardCreationHeader: {
        "id": "software-board-create.common.kanban-board-creation-header",
        "defaultMessage": "Kanban"
    },
    kanbanBoardCreationDescription: {
        "id": "software-board-create.common.kanban-board-creation-description",
        "defaultMessage": "Manage a continuous delivery of work with a kanban board and reports."
    },
    loadSavedFiltersErrorTitle: {
        "id": "software-board-create.common.load-saved-filters-error-title",
        "defaultMessage": "We can\u2019t load saved filters right now"
    },
    loadSavedFiltersErrorDescription: {
        "id": "software-board-create.common.load-saved-filters-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    requiredFieldsHeader: {
        "id": "software-board-create.common.required-fields-header",
        "defaultMessage": "Required fields are marked with an asterisk *"
    }
});
var $1d0bbdf347baf74e$export$2e2bcd8739ae039 = $1d0bbdf347baf74e$var$messages;

});


parcelRegister("s6xA3", function(module, exports) {
$parcel$export(module.exports, "BoardCreateFlyoutMenu", () => $7a6ae5b5b2b1e183$export$6a893f4168172b4e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");

var $dcLzM = parcelRequire("dcLzM");

var $3Xinh = parcelRequire("3Xinh");
const $7a6ae5b5b2b1e183$export$a27652ddcad2c9dc = ({ triggerRef: triggerRef, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ...props,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))),
        label: "create board",
        ref: triggerRef,
        testId: "software-board-create.ui.flyout-menu.trigger"
    });
};
const $7a6ae5b5b2b1e183$export$6a893f4168172b4e = ({ renderTrigger: Trigger = $7a6ae5b5b2b1e183$export$a27652ddcad2c9dc, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: Trigger,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Xinh.AsyncFlyoutMenuContent), props));

});
parcelRegister("3Xinh", function(module, exports) {
$parcel$export(module.exports, "AsyncFlyoutMenuContent", () => $daa7d9cc53a0d5d2$export$3f0e1916911c9d6a);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $2pys5 = parcelRequire("2pys5");

var $c4dwE = parcelRequire("c4dwE");

var $dFmiu = parcelRequire("dFmiu");
const $daa7d9cc53a0d5d2$var$entryPointParams = {};
const $daa7d9cc53a0d5d2$export$3f0e1916911c9d6a = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $c4dwE.flyoutMenuContentEntryPoint), $daa7d9cc53a0d5d2$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $2pys5.FLYOUT_MENU_CONTENT_ID),
        packageName: (0, $2pys5.BOARD_CREATE_PACKAGE_NAME),
        teamName: (0, $2pys5.TEAM_NAME),
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFmiu.FlyoutMenuContentFallback), null),
        errorFallback: "flag",
        runtimeProps: props
    });
};

});
parcelRegister("c4dwE", function(module, exports) {
$parcel$export(module.exports, "flyoutMenuContentEntryPoint", () => $6e0d67a33165eb27$export$e6b36ab0519985d7);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6e0d67a33165eb27$export$e6b36ab0519985d7 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("9KojZ"))), {
        moduleId: "53a3dd04",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9KojZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "FlyoutContentContainer", () => $842059c90f492bbb$export$b7a36d8992ebabdb);
$parcel$export(module.exports, "default", () => $842059c90f492bbb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aLJ1L = parcelRequire("aLJ1L");

var $Wdhjx = parcelRequire("Wdhjx");

var $7Dz47 = parcelRequire("7Dz47");

var $bzmGg = parcelRequire("bzmGg");
var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $2pys5 = parcelRequire("2pys5");

var $pkfsB = parcelRequire("pkfsB");

var $gXjgd = parcelRequire("gXjgd");
const $842059c90f492bbb$export$b7a36d8992ebabdb = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $842059c90f492bbb$var$menuContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $842059c90f492bbb$var$headerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $842059c90f492bbb$var$headerStyles
    }, formatMessage((0, $pkfsB.default).boardCreationTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bzmGg.default), {
        block: "space.050"
    }, children));
};
const $842059c90f492bbb$var$BoardCreateFlyoutMenuContent = ({ props: { projectId: projectId, projectAvatar: projectAvatar, triggerRef: triggerRef } })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const dropdownItems = (0, $eJOHy.useMemo)(()=>{
        const items = [
            {
                boardType: (0, $2pys5.BOARD_TYPES).SCRUM,
                title: formatMessage((0, $pkfsB.default).scrumBoardCreationHeader),
                description: formatMessage((0, $pkfsB.default).scrumBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Dz47))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            },
            {
                boardType: (0, $2pys5.BOARD_TYPES).KANBAN,
                title: formatMessage((0, $pkfsB.default).kanbanBoardCreationHeader),
                description: formatMessage((0, $pkfsB.default).kanbanBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            }
        ];
        return items.map(({ boardType: boardType, ...props }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXjgd.DropdownItemContainer), {
                key: boardType,
                entryPointProps: {
                    boardType: boardType,
                    projectId: projectId,
                    projectAvatar: projectAvatar,
                    triggerRef: triggerRef
                },
                index: index,
                ...props
            }));
    }, [
        formatMessage,
        projectId,
        projectAvatar,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($842059c90f492bbb$export$b7a36d8992ebabdb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, dropdownItems));
};
var $842059c90f492bbb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($842059c90f492bbb$var$BoardCreateFlyoutMenuContent);
const $842059c90f492bbb$var$headerStyles = (0, $1DXK0.xcss)({
    font: 'font.heading.xxsmall',
    color: 'color.text.subtlest'
});
const $842059c90f492bbb$var$menuContainerStyles = (0, $1DXK0.xcss)({
    width: '273px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $842059c90f492bbb$var$headerContainerStyles = (0, $1DXK0.xcss)({
    height: 'space.200',
    padding: 'space.200',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("Wdhjx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::411fb0e87ff78661e4fe4f98c48af3ed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aefb7ae3bc1328f$var$_react = $0aefb7ae3bc1328f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0aefb7ae3bc1328f$var$_baseNew = $0aefb7ae3bc1328f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0aefb7ae3bc1328f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0aefb7ae3bc1328f$var$BoardIcon = (props)=>/*#__PURE__*/ $0aefb7ae3bc1328f$var$_react.default.createElement($0aefb7ae3bc1328f$var$_baseNew.default, Object.assign({
        name: "BoardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$0aefb7ae3bc1328f$var$BoardIcon.displayName = 'BoardIcon';
var $0aefb7ae3bc1328f$var$_default = module.exports.default = $0aefb7ae3bc1328f$var$BoardIcon;

});

parcelRegister("7Dz47", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70764799ff236b3dfa0e86ce34072b58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58f760330ff3639b$var$_react = $58f760330ff3639b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $58f760330ff3639b$var$_baseNew = $58f760330ff3639b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $58f760330ff3639b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58f760330ff3639b$var$SprintIcon = (props)=>/*#__PURE__*/ $58f760330ff3639b$var$_react.default.createElement($58f760330ff3639b$var$_baseNew.default, Object.assign({
        name: "SprintIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$58f760330ff3639b$var$SprintIcon.displayName = 'SprintIcon';
var $58f760330ff3639b$var$_default = module.exports.default = $58f760330ff3639b$var$SprintIcon;

});

parcelRegister("bzmGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fea65e46aacd91d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");
function $1fea65e46aacd91d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1fea65e46aacd91d$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $1fea65e46aacd91d$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $1fea65e46aacd91d$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $1fea65e46aacd91d$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $1fea65e46aacd91d$var$baseStyles,
            (inline || all) && $1fea65e46aacd91d$var$inlineBleedMap[inline || all],
            (block || all) && $1fea65e46aacd91d$var$blockBleedMap[block || all],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
$1fea65e46aacd91d$var$Bleed.displayName = 'Bleed';
var $1fea65e46aacd91d$export$2e2bcd8739ae039 = $1fea65e46aacd91d$var$Bleed;

});

parcelRegister("gXjgd", function(module, exports) {
$parcel$export(module.exports, "DropdownItemContainer", () => $38d7182a72bcfdd6$export$cfb1162696b4c012);

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $d1S9l = parcelRequire("d1S9l");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2pys5 = parcelRequire("2pys5");

var $8zVFR = parcelRequire("8zVFR");

var $lA5Hv = parcelRequire("lA5Hv");

var $8ySo1 = parcelRequire("8ySo1");
const $38d7182a72bcfdd6$export$cfb1162696b4c012 = ({ entryPointProps: entryPointProps, title: title, description: description, icon: icon, index: index })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const triggerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (index === 0 && triggerRef.current) triggerRef.current.focus();
    }, [
        index
    ]);
    const handleOnDropdownItemClick = (0, $eJOHy.useCallback)(()=>{
        const boardTypePascalCase = entryPointProps.boardType === (0, $2pys5.BOARD_TYPES).SCRUM ? 'Scrum' : 'Kanban';
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), `create${boardTypePascalCase}Board`);
    }, [
        createAnalyticsEvent,
        entryPointProps.boardType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        "aria-label": formatMessage((0, $8ySo1.default).createBoardLabel, {
            boardType: entryPointProps.boardType.toLowerCase()
        }),
        forwardedRef: triggerRef,
        entryPoint: (0, $8zVFR.boardCreateModalEntryPoint),
        testId: "software-board-create.ui.flyout-menu.flyout-menu-content.dropdown-item-container.dropdown-item-trigger",
        interactionName: "open-create-board-modal",
        entryPointProps: entryPointProps,
        Fallback: (0, $lA5Hv.BoardCreateModalFallback),
        onClick: handleOnDropdownItemClick,
        useInternalModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $38d7182a72bcfdd6$var$itemIconBackgroundStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h3"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "medium"
    }, description))));
};
const $38d7182a72bcfdd6$var$ICON_BACKGROUND_CONTAINER_SIZE = '32px';
const $38d7182a72bcfdd6$var$itemIconBackgroundStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral',
    width: $38d7182a72bcfdd6$var$ICON_BACKGROUND_CONTAINER_SIZE,
    height: $38d7182a72bcfdd6$var$ICON_BACKGROUND_CONTAINER_SIZE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "2px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-radius-xsmall, 3px)",
    padding: 'space.050',
    flexShrink: 0
});

});
parcelRegister("3Wh6p", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c7d5625940bebea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $lmgo6 = parcelRequire("lmgo6");
const $8c7d5625940bebea$var$flexGrowMap = {
    hug: (0, $1DXK0.xcss)({
        flexGrow: 0
    }),
    fill: (0, $1DXK0.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $8c7d5625940bebea$var$separatorStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $8c7d5625940bebea$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $8c7d5625940bebea$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $8c7d5625940bebea$var$Inline = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $1NIU8.jsx)($8c7d5625940bebea$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $eJOHy.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $8c7d5625940bebea$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lmgo6.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$8c7d5625940bebea$var$Inline.displayName = 'Inline';
var $8c7d5625940bebea$export$2e2bcd8739ae039 = $8c7d5625940bebea$var$Inline;

});

parcelRegister("d1S9l", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPointDropdownItemTrigger", () => $7b82c672bd4705e6$export$82b29db923c97084);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $dxcgx = parcelRequire("dxcgx");
const $7b82c672bd4705e6$export$82b29db923c97084 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, ...dropdownProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        interactionName: interactionName,
        title: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            ref: ref,
            ...dropdownProps
        }, children));
};

});

parcelRegister("8zVFR", function(module, exports) {
$parcel$export(module.exports, "boardCreateModalEntryPoint", () => $6bb36caa19afd500$export$ae34a65266b8e906);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6bb36caa19afd500$export$ae34a65266b8e906 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("lA5Hv"))), {
        moduleId: "6c073853",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lA5Hv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "BoardCreateModalFallback", () => $77703aafca192cbf$export$303db58b19f6b446);
$parcel$export(module.exports, "default", () => $77703aafca192cbf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $4B7rn = parcelRequire("4B7rn");

var $lRq8t = parcelRequire("lRq8t");

var $lJKII = parcelRequire("lJKII");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $pkfsB = parcelRequire("pkfsB");

var $gHO4S = parcelRequire("gHO4S");

var $iunk7 = parcelRequire("iunk7");

var $lQM4J = parcelRequire("lQM4J");

var $62xU6 = parcelRequire("62xU6");
const $77703aafca192cbf$var$MODAL_WIDTH = 1000;
const $77703aafca192cbf$var$MODAL_HEIGHT = 551;
const $77703aafca192cbf$export$303db58b19f6b446 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        height: $77703aafca192cbf$var$MODAL_HEIGHT,
        width: $77703aafca192cbf$var$MODAL_WIDTH,
        label: formatMessage((0, $62xU6.default).loadingLabel),
        messageId: "software-board-create.ui.modal.modal.board-create-modal-fallback",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lQM4J.BoardCreateFormFallback), null));
};
const $77703aafca192cbf$var$BoardCreateModal = ({ boardType: boardType, projectId: projectId, onClose: onClose, triggerRef: triggerRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleOnClose = (_mouseEvent, _analyticEvent, didSubmit)=>{
        const event = createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'modalDialog'
        });
        (0, $kRgKj.fireUIAnalytics)(event, 'createNewBoardModal', {
            didSubmit: !!didSubmit,
            boardType: boardType.toLowerCase()
        });
        onClose?.();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        testId: "software-board-create.ui.modal",
        onClose: handleOnClose,
        width: $77703aafca192cbf$var$MODAL_WIDTH,
        height: $77703aafca192cbf$var$MODAL_HEIGHT,
        messageId: "software-board-create.ui.modal.modal.board-create-modal",
        messageType: "transactional",
        label: `${formatMessage((0, $pkfsB.default).boardCreationTitle)}. ${formatMessage((0, $gHO4S.descriptionMapping)[boardType])}`,
        shouldReturnFocus: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lQM4J.BoardCreateForm), {
        projectId: projectId,
        boardType: boardType,
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        attributes: {
            boardType: boardType.toLowerCase()
        }
    }));
};
const $77703aafca192cbf$var$BoardCreateModalWithContext = ({ props: { projectAvatar: projectAvatar, ...restProps } })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            projectId: restProps.projectId,
            projectAvatar: projectAvatar
        }), [
        restProps.projectId,
        projectAvatar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iunk7.BoardCreateContext).Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "createNewBoard",
        sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77703aafca192cbf$var$BoardCreateModal, restProps))));
};
var $77703aafca192cbf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($77703aafca192cbf$var$BoardCreateModalWithContext);

});
parcelRegister("iunk7", function(module, exports) {
$parcel$export(module.exports, "BoardCreateContext", () => $9b85d2de53abb4dd$export$5169319147995508);
$parcel$export(module.exports, "useBoardCreateContext", () => $9b85d2de53abb4dd$export$768ffccd7d71d6d9);

var $eJOHy = parcelRequire("eJOHy");
const $9b85d2de53abb4dd$var$initialContext = {
    projectId: undefined,
    projectAvatar: undefined
};
const $9b85d2de53abb4dd$export$5169319147995508 = /*#__PURE__*/ (0, $eJOHy.createContext)($9b85d2de53abb4dd$var$initialContext);
const $9b85d2de53abb4dd$export$768ffccd7d71d6d9 = ()=>(0, $eJOHy.useContext)($9b85d2de53abb4dd$export$5169319147995508);

});

parcelRegister("lQM4J", function(module, exports) {
$parcel$export(module.exports, "BoardCreateFormFallback", () => $ab5891a65cb0c148$export$efb232229a99ba7b);
$parcel$export(module.exports, "BoardCreateForm", () => $ab5891a65cb0c148$export$bc90d453a0e513ff);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3L3Os = parcelRequire("3L3Os");
var $eRpdx = parcelRequire("eRpdx");
var $bUGwX = parcelRequire("bUGwX");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $5nydL = parcelRequire("5nydL");

var $a8589 = parcelRequire("a8589");

var $4SlPH = parcelRequire("4SlPH");

var $kHJve = parcelRequire("kHJve");

var $hPEYy = parcelRequire("hPEYy");

var $kaWPn = parcelRequire("kaWPn");

var $bpQ9z = parcelRequire("bpQ9z");

var $6HOlT = parcelRequire("6HOlT");
const $ab5891a65cb0c148$export$efb232229a99ba7b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $ab5891a65cb0c148$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.1000",
        xcss: $ab5891a65cb0c148$var$formContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $ab5891a65cb0c148$var$columnStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "150px",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "100%",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "20%",
        height: "12px",
        borderRadius: "3px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "100px",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "100%",
        height: "30px",
        borderRadius: "3px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "200px",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "100%",
        height: "30px",
        borderRadius: "3px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "70px",
        height: "32px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "70px",
        height: "32px",
        borderRadius: "3px"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $ab5891a65cb0c148$var$columnStyles,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "150px",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "412px",
        height: "307px",
        borderRadius: "16px"
    }))));
};
const $ab5891a65cb0c148$export$bc90d453a0e513ff = ({ boardType: boardType, projectId: projectId, onClose: onClose })=>{
    const { submit: submit } = (0, $5nydL.useBoardCreateController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnSubmit = (0, $eJOHy.useCallback)(async (data)=>{
        const errors = (0, $6HOlT.validateFormData)(data);
        const hasValidationErrors = errors.boardName || errors.sourceType || errors.sourceValue;
        let sourceValueLength = 0;
        if (data.sourceValue != null) sourceValueLength = Array.isArray(data.sourceValue) ? data.sourceValue.length : 1;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $kRgKj.fireUIAnalytics)(event, 'createNewBoard', {
            sourceType: data.sourceType,
            sourceValueLength: sourceValueLength,
            errors: hasValidationErrors && errors
        });
        if (hasValidationErrors) return errors;
        await submit({
            boardType: boardType,
            formValues: data,
            locationProjectId: projectId ?? '',
            onSuccess: ()=>onClose(undefined, undefined, true)
        });
    }, [
        createAnalyticsEvent,
        submit,
        boardType,
        projectId,
        onClose
    ]);
    const resetSourceValue = (0, $eJOHy.useCallback)((setFieldValue)=>()=>setFieldValue((0, $bpQ9z.SOURCE_VALUE_FIELD_NAME), undefined), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $ab5891a65cb0c148$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps, submitting: submitting, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
            ...formProps,
            noValidate: true,
            className: (0, $hcewu.default)([
                "_18m91wug _1bsb1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            gap: "space.1000",
            xcss: $ab5891a65cb0c148$var$formContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
            xcss: $ab5891a65cb0c148$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a8589.ModalHeader), {
            type: boardType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ab5891a65cb0c148$var$formFieldsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUGwX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hPEYy.BoardNameField), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUGwX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kaWPn.SourceTypePicker), {
            resetSourceValue: resetSourceValue(setFieldValue)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bpQ9z.SourceValuePicker), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ab5891a65cb0c148$var$buttonGroupContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRpdx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kHJve.FormActions), {
            submitting: submitting,
            onClose: onClose
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
            xcss: $ab5891a65cb0c148$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4SlPH.ModalIllustration), null))))));
};
const $ab5891a65cb0c148$var$formStyles = null;
const $ab5891a65cb0c148$var$formContentStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%'
});
const $ab5891a65cb0c148$var$columnStyles = (0, $1DXK0.xcss)({
    width: 'calc(50% - 40px)',
    // space.1000 is 80px, thus 40px is the space on each side
    flex: 'none',
    paddingTop: 'space.200'
});
const $ab5891a65cb0c148$var$formFieldsContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1
});
const $ab5891a65cb0c148$var$buttonGroupContainerStyles = (0, $1DXK0.xcss)({
    alignSelf: 'end',
    justifySelf: 'end'
});
const $ab5891a65cb0c148$var$formContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.600',
    paddingLeft: 'space.600',
    paddingRight: 'space.600',
    paddingBottom: 'space.500',
    height: '100%'
});

});
parcelRegister("3L3Os", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $b42d4fbe800f0292$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $b42d4fbe800f0292$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $b42d4fbe800f0292$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kOCbD = parcelRequire("kOCbD");

var $dPWTT = parcelRequire("dPWTT");

var $d3vFW = parcelRequire("d3vFW");

var $immLL = parcelRequire("immLL");

var $gyJTO = parcelRequire("gyJTO");

var $eGOwo = parcelRequire("eGOwo");

var $lcsDn = parcelRequire("lcsDn");
const $b42d4fbe800f0292$export$c24727297075ec6a = /*#__PURE__*/ (0, $eJOHy.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $b42d4fbe800f0292$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $b42d4fbe800f0292$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $eJOHy.useRef)(null);
    const onSubmitRef = (0, $eJOHy.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $eJOHy.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $kOCbD.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(values, name, value);
                    }
                }
            }
        });
        (0, $dPWTT.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $eGOwo.fg)('platform-form-field-error-focus') ? (0, $lcsDn.getFirstErrorField) : undefined)(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eJOHy.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eJOHy.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $eJOHy.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eJOHy.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $gyJTO.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                ...(0, $eGOwo.fg)('platform-form-reset-field-state') && {
                    resetFieldState: form.resetFieldState
                }
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $gt9Am.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b42d4fbe800f0292$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($b42d4fbe800f0292$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $b42d4fbe800f0292$var$Form = (0, $immLL.default)($b42d4fbe800f0292$var$FormBase);
var $b42d4fbe800f0292$export$2e2bcd8739ae039 = $b42d4fbe800f0292$var$Form;

});
parcelRegister("kOCbD", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $f276193df2f288e0$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f276193df2f288e0$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f276193df2f288e0$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f276193df2f288e0$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f276193df2f288e0$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f276193df2f288e0$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f276193df2f288e0$export$f681a8129d2e9d28);

var $fpB9r = parcelRequire("fpB9r");

var $2unhp = parcelRequire("2unhp");
//      
var $f276193df2f288e0$var$charCodeOfDot = ".".charCodeAt(0);
var $f276193df2f288e0$var$reEscapeChar = /\\(\\)?/g;
var $f276193df2f288e0$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f276193df2f288e0$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f276193df2f288e0$var$charCodeOfDot) result.push("");
    string.replace($f276193df2f288e0$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f276193df2f288e0$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f276193df2f288e0$var$keysCache = {};
var $f276193df2f288e0$var$keysRegex = /[.[\]]+/;
var $f276193df2f288e0$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f276193df2f288e0$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f276193df2f288e0$var$keysCache[key] = key.split($f276193df2f288e0$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f276193df2f288e0$var$keysCache[key] = $f276193df2f288e0$var$stringToPath(key);
    }
    return $f276193df2f288e0$var$keysCache[key];
};
//      
var $f276193df2f288e0$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f276193df2f288e0$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f276193df2f288e0$var$_toPropertyKey(arg) {
    var key = $f276193df2f288e0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f276193df2f288e0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f276193df2f288e0$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $2unhp.default)(current, [
                key
            ].map($f276193df2f288e0$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $fpB9r.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f276193df2f288e0$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f276193df2f288e0$var$setInRecursor(state, 0, $f276193df2f288e0$var$toPath(key), value1, destroyArrays);
};
var $f276193df2f288e0$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f276193df2f288e0$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f276193df2f288e0$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f276193df2f288e0$export$c52e5867d5879e24(values, name);
    var error = $f276193df2f288e0$export$c52e5867d5879e24(errors, name);
    if (error && error[$f276193df2f288e0$export$735bebc8ffabf28a]) error = error[$f276193df2f288e0$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f276193df2f288e0$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f276193df2f288e0$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f276193df2f288e0$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f276193df2f288e0$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f276193df2f288e0$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f276193df2f288e0$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f276193df2f288e0$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f276193df2f288e0$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f276193df2f288e0$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f276193df2f288e0$var$subscriptionFilter(result, state, previousState, subscription, $f276193df2f288e0$export$41e855cb628c1b55, $f276193df2f288e0$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f276193df2f288e0$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f276193df2f288e0$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f276193df2f288e0$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f276193df2f288e0$var$subscriptionFilter(result, state, previousState, subscription, $f276193df2f288e0$export$f1ff97b9d1c7a3c3, $f276193df2f288e0$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f276193df2f288e0$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f276193df2f288e0$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f276193df2f288e0$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f276193df2f288e0$export$83d89fbfd8236492 = "4.20.10";
var $f276193df2f288e0$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f276193df2f288e0$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f276193df2f288e0$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f276193df2f288e0$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f276193df2f288e0$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f276193df2f288e0$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f276193df2f288e0$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f276193df2f288e0$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f276193df2f288e0$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f276193df2f288e0$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $fpB9r.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $fpB9r.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $fpB9r.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $fpB9r.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $fpB9r.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f276193df2f288e0$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f276193df2f288e0$export$e6bdf135a54e021b,
                    shallowEqual: $f276193df2f288e0$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $fpB9r.default)({}, state.formState.values)); // clone to avoid writing
            if ($f276193df2f288e0$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f276193df2f288e0$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f276193df2f288e0$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $fpB9r.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f276193df2f288e0$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f276193df2f288e0$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f276193df2f288e0$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f276193df2f288e0$export$735bebc8ffabf28a]) {
                    var existing = $f276193df2f288e0$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f276193df2f288e0$export$735bebc8ffabf28a] = error[$f276193df2f288e0$export$735bebc8ffabf28a];
                    merged = $f276193df2f288e0$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f276193df2f288e0$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f276193df2f288e0$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f276193df2f288e0$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f276193df2f288e0$var$notify(fieldSubscriber, fieldState, lastFieldState, $f276193df2f288e0$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f276193df2f288e0$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f276193df2f288e0$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f276193df2f288e0$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f276193df2f288e0$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f276193df2f288e0$var$notify(state.subscribers, nextFormState, lastFormState, $f276193df2f288e0$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $fpB9r.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f276193df2f288e0$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $fpB9r.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $fpB9r.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f276193df2f288e0$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f276193df2f288e0$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f276193df2f288e0$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name) === $f276193df2f288e0$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f276193df2f288e0$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $fpB9r.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $fpB9r.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $fpB9r.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f276193df2f288e0$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f276193df2f288e0$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $fpB9r.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f276193df2f288e0$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f276193df2f288e0$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f276193df2f288e0$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f276193df2f288e0$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("dPWTT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a12dba3049b97319$export$2e2bcd8739ae039);

var $kOCbD = parcelRequire("kOCbD");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $a12dba3049b97319$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $a12dba3049b97319$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($a12dba3049b97319$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $a12dba3049b97319$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $kOCbD.getIn)(errors, input.name);
    });
};
//      
var $a12dba3049b97319$var$noop = function noop() {};
var $a12dba3049b97319$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $a12dba3049b97319$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $a12dba3049b97319$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $a12dba3049b97319$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $a12dba3049b97319$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($a12dba3049b97319$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$a12dba3049b97319$export$2e2bcd8739ae039 = $a12dba3049b97319$var$createDecorator;

});

parcelRegister("d3vFW", function(module, exports) {

var $j4TC7 = parcelRequire("j4TC7");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $981420477fbe9257$var$set(object, path, value) {
    return object == null ? object : $j4TC7(object, path, value);
}
module.exports = $981420477fbe9257$var$set;

});

parcelRegister("lcsDn", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $f9eb62dae4e2689c$export$fc06342dc8588d3b);

var $kOCbD = parcelRequire("kOCbD");
const $f9eb62dae4e2689c$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $kOCbD.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $kOCbD.getIn)(errors, input.name);
    });
};

});


parcelRegister("eRpdx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6411efa125c19813$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6411efa125c19813$var$formFooterWrapperStyles = null;
const $6411efa125c19813$var$justifyContentStyles = null;
function $6411efa125c19813$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("footer", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("bUGwX", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dc3e6ec1cedfa1c$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $4dc3e6ec1cedfa1c$var$formSectionDescriptionStyles = null;
const $4dc3e6ec1cedfa1c$var$formSectionWrapperStyles = null;
const $4dc3e6ec1cedfa1c$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $4dc3e6ec1cedfa1c$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $4dc3e6ec1cedfa1c$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($4dc3e6ec1cedfa1c$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)($4dc3e6ec1cedfa1c$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $4dc3e6ec1cedfa1c$export$2e2bcd8739ae039 = $4dc3e6ec1cedfa1c$var$FormSection;

});

parcelRegister("5nydL", function(module, exports) {
$parcel$export(module.exports, "useBoardCreateController", () => $7434764e075e537a$export$b1247ee6c4be437f);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3osLr = parcelRequire("3osLr");

var $lRq8t = parcelRequire("lRq8t");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $aqnJa = parcelRequire("aqnJa");

var $5Q9JR = parcelRequire("5Q9JR");

var $fz6nu = parcelRequire("fz6nu");

var $cHtIB = parcelRequire("cHtIB");

var $83DiZ = parcelRequire("83DiZ");

var $kqd31 = parcelRequire("kqd31");

var $4SjAP = parcelRequire("4SjAP");

var $gHO4S = parcelRequire("gHO4S");

var $2pys5 = parcelRequire("2pys5");

var $9eT6w = parcelRequire("9eT6w");

var $3P2eB = parcelRequire("3P2eB");

var $hSFmR = parcelRequire("hSFmR");

var $Vd1v0 = parcelRequire("Vd1v0");
const $7434764e075e537a$var$EXPERIENCE = 'createBoard';
const $7434764e075e537a$export$43cdff4ae424f89f = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $eJOHy.useCallback)(({ id: id, projectId: projectId })=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            try {
                if (!id) throw new Error('Failed to add board to project, missing id');
                if (!projectId) throw new Error('Failed to add board to project, missing projectId');
                const projectRelayDataId = (0, $kqd31.default)({
                    id: (0, $3osLr.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: String(projectId)
                    })
                }, 'JiraProject');
                if (!projectRelayDataId) throw new Error(`Failed to create project relay data id, projectId: ${projectId}`);
                const project = store.get(projectRelayDataId);
                if (!project) throw new Error(`Failed to find the project, projectId: ${projectId}`);
                const projectBoardsConnection = project.getLinkedRecord('boards', {
                    first: (0, $5Q9JR.NO_OF_BOARDS_TO_SHOW)
                });
                if (!projectBoardsConnection) throw new Error('Failed to find the project-boards connection');
                const newNode = store.get(id);
                if (!newNode) throw new Error(`Failed to find the new board, id: ${id}`);
                const newEdge = (0, $j4oe4.ConnectionHandler).createEdge(store, projectBoardsConnection, newNode, 'JiraBoardEdge');
                (0, $j4oe4.ConnectionHandler).insertEdgeBefore(projectBoardsConnection, newEdge);
            } catch (error) {
                (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                    id: 'addBoardToProject',
                    error: error instanceof Error ? error : new Error(`Failed to add board to project: ${error}`)
                });
            }
        });
    }, [
        environment,
        cloudId
    ]);
};
const $7434764e075e537a$export$b1247ee6c4be437f = ()=>{
    const { handleMutation: handleMutation } = (0, $9eT6w.useBoardCreateMutation)();
    const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, $3P2eB.useBoardCreateFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const addBoardToProject = $7434764e075e537a$export$43cdff4ae424f89f();
    const isBacklogRoute = (0, $fz6nu.useIsBacklogRoute)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: $7434764e075e537a$var$EXPERIENCE,
        analyticsSource: (0, $2pys5.BOARD_CREATE_PACKAGE_NAME)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: $7434764e075e537a$var$EXPERIENCE
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: $7434764e075e537a$var$EXPERIENCE
    });
    const submit = (0, $eJOHy.useCallback)(async ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues, onSuccess: onSuccess, onError: onError })=>{
        const input = (0, $Vd1v0.transformInput)({
            boardType: boardType,
            locationProjectId: locationProjectId,
            formValues: formValues
        });
        try {
            onExperienceStart();
            const result = await handleMutation(input);
            if (!result?.jira?.createBoard?.success) throw result?.jira?.createBoard?.errors?.length ? new (0, $4SjAP.MutationError)(result?.jira?.createBoard?.errors?.[0]) : new Error('Failed to create board');
            onSuccess?.(result);
            showSuccessFlag({
                title: formatMessage((0, $hSFmR.default).successTitle)
            });
            addBoardToProject({
                projectId: locationProjectId,
                id: result.jira?.createBoard?.board?.__id
            });
            onExperienceSuccess();
            const resultBoardId = result?.jira?.createBoard?.board?.boardId;
            const resultBoardType = result?.jira?.createBoard?.board?.boardType;
            const boardUrl = (0, $Vd1v0.buildBoardUrl)(result?.jira?.createBoard?.board?.boardUrl, resultBoardType);
            if (!boardUrl) (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                error: new Error('Failed to generate board URL after board creation'),
                attributes: {
                    boardId: resultBoardId,
                    boardType: resultBoardType
                },
                id: 'generateUrl'
            });
            else resultBoardType === 'SCRUM' && isBacklogRoute ? (0, $Vd1v0.redirectToBacklog)(boardUrl) : push(boardUrl);
        } catch (error) {
            let errMsg;
            if (error instanceof (0, $4SjAP.MutationError) && error.message) errMsg = error.message;
            onError?.(errMsg || error);
            showErrorFlag({
                title: formatMessage((0, $hSFmR.default).errorTitle),
                description: errMsg || formatMessage((0, $hSFmR.default).errorDescription)
            });
            (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to create board: ${errMsg || error}`, {
                    cause: error
                }),
                id: 'createBoard'
            });
            onExperienceFail((0, $2pys5.BOARD_CREATE_PACKAGE_NAME), // eslint-disable-next-line no-nested-ternary
            errMsg ? new Error(errMsg) : error instanceof Error ? error : new Error(String(error)));
        }
    }, [
        onExperienceStart,
        handleMutation,
        showSuccessFlag,
        formatMessage,
        addBoardToProject,
        onExperienceSuccess,
        isBacklogRoute,
        push,
        showErrorFlag,
        onExperienceFail
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("fz6nu", function(module, exports) {
$parcel$export(module.exports, "useIsBacklogRoute", () => $9731385da4d79637$export$1894da4846b402db);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");
const $9731385da4d79637$export$1894da4846b402db = ()=>{
    const { name: name } = (0, $hih5V.useCurrentRoute)();
    return (0, $eJOHy.useMemo)(()=>name === 'rapidboard-backlog' || name === 'rapidboard-user-backlog' || name === 'rapidboard-backlog-embed', [
        name
    ]);
};

});

parcelRegister("4SjAP", function(module, exports) {
$parcel$export(module.exports, "MutationError", () => $354f7d6d59497f5a$export$10c788363424e94e);
class $354f7d6d59497f5a$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});

parcelRegister("9eT6w", function(module, exports) {
$parcel$export(module.exports, "useBoardCreateMutation", () => $05321493561a882b$export$99c7414664697f66);

var $emzXy = parcelRequire("emzXy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cHtIB = parcelRequire("cHtIB");
const $05321493561a882b$export$99c7414664697f66 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $emzXy.default));
    const handleMutation = (0, $eJOHy.useCallback)(async (input)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    cloudId: cloudId,
                    input: input
                },
                onCompleted: (result)=>{
                    resolve(result);
                },
                onError: (error)=>{
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit
    ]);
    return {
        handleMutation: handleMutation
    };
};

});
parcelRegister("emzXy", function(module, exports) {
$parcel$export(module.exports, "default", () => $7356c11ac73e5487$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96b4cce51ba6e0ff7c8004e93170ae98>>
 * @relayHash f07c5fbb5fc9fda47c89b1ea4e0b6538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2
const $7356c11ac73e5487$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "JiraBoard",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "boardId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "boardType"
            },
            {
                "kind": "ScalarField",
                "name": "boardUrl"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2",
            "metadata": {},
            "name": "useBoardCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7356c11ac73e5487$var$node.hash = "6559f8aeeafe0e444aad2224af38c3cb";
var $7356c11ac73e5487$export$2e2bcd8739ae039 = $7356c11ac73e5487$var$node;

});


parcelRegister("3P2eB", function(module, exports) {
$parcel$export(module.exports, "useBoardCreateFlag", () => $be4214ea2d2fbd87$export$b93e10fcc9489915);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");
const $be4214ea2d2fbd87$export$b93e10fcc9489915 = ()=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const showSuccessFlag = (0, $eJOHy.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'success',
            title: title,
            description: description,
            isAutoDismiss: true,
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const showErrorFlag = (0, $eJOHy.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'error',
            title: title,
            description: description,
            isAutoDismiss: true,
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};

});

parcelRegister("hSFmR", function(module, exports) {
$parcel$export(module.exports, "default", () => $542f182ab8f7e79d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $542f182ab8f7e79d$var$messages = (0, $7qGN1.defineMessages)({
    successTitle: {
        "id": "software-board-create.controllers.use-board-create-controller.success-title",
        "defaultMessage": "Board successfully created"
    },
    errorTitle: {
        "id": "software-board-create.controllers.use-board-create-controller.error-title",
        "defaultMessage": "We couldn\u2019t create the board"
    },
    errorDescription: {
        "id": "software-board-create.controllers.use-board-create-controller.error-description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var $542f182ab8f7e79d$export$2e2bcd8739ae039 = $542f182ab8f7e79d$var$messages;

});

parcelRegister("Vd1v0", function(module, exports) {
$parcel$export(module.exports, "transformInput", () => $9d0fad3291600b6f$export$28b8f0b21b2796a2);
$parcel$export(module.exports, "buildBoardUrl", () => $9d0fad3291600b6f$export$d807737c3f4eaba6);
$parcel$export(module.exports, "redirectToBacklog", () => $9d0fad3291600b6f$export$594b405ab77720dc);

var $2pys5 = parcelRequire("2pys5");
const $9d0fad3291600b6f$var$formatFieldInput = (input)=>{
    if (!input.sourceType || input.sourceType === (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER || !input.sourceValue) return null;
    const { sourceType: sourceType, sourceValue: sourceValue } = input;
    switch(sourceType){
        case (0, $2pys5.BOARD_SOURCE_FIELDS).TEAM:
            return {
                teams: [
                    {
                        teamId: sourceValue.id
                    }
                ]
            };
        case (0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES:
            return {
                issueTypes: sourceValue.map(({ value: value })=>({
                        issueTypeId: value
                    }))
            };
        case (0, $2pys5.BOARD_SOURCE_FIELDS).LABELS:
            return {
                labels: sourceValue.map(({ value: value })=>({
                        name: value
                    }))
            };
        default:
            {
                const _exhaustiveCheck = sourceType;
                return null;
            }
    }
};
const $9d0fad3291600b6f$var$getCreateBoardSource = (formValues, locationProjectId)=>{
    if (formValues?.sourceType === (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER) return {
        savedFilterId: formValues.sourceValue?.value ? Number(formValues.sourceValue.value) : null
    };
    return {
        fieldInput: {
            projects: [
                {
                    projectId: locationProjectId
                }
            ],
            ...formValues.sourceType && formValues.sourceValue && $9d0fad3291600b6f$var$formatFieldInput(formValues)
        }
    };
};
const $9d0fad3291600b6f$export$28b8f0b21b2796a2 = ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues })=>({
        createBoardSource: $9d0fad3291600b6f$var$getCreateBoardSource(formValues, locationProjectId),
        location: {
            locationId: locationProjectId,
            locationType: 'PROJECT'
        },
        name: formValues.boardName,
        preset: boardType
    });
const $9d0fad3291600b6f$export$d807737c3f4eaba6 = (boardUrl, boardType)=>{
    if (!boardUrl) return null;
    return `${boardUrl}${boardType === 'SCRUM' ? '/backlog' : ''}`;
};
const $9d0fad3291600b6f$export$594b405ab77720dc = (backlogUrl)=>{
    // This is a temporary fix for the redirection issue and will be addressed in BLU-5254
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = backlogUrl;
};

});


parcelRegister("a8589", function(module, exports) {
$parcel$export(module.exports, "ModalHeader", () => $2df745d30354834c$export$f50a68e3694789ee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $pkfsB = parcelRequire("pkfsB");

var $gHO4S = parcelRequire("gHO4S");
const $2df745d30354834c$export$f50a68e3694789ee = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ $eJOHy.createElement("h4", {
        className: (0, $hcewu.default)([
            "_11c8lodh _k48pmoej _syaz1fxt"
        ])
    }, formatMessage((0, $pkfsB.default).boardCreationTitle)), /*#__PURE__*/ $eJOHy.createElement((0, $3cMgR.default), {
        size: "medium",
        color: "color.text.accent.gray.bolder"
    }, (0, $gHO4S.descriptionMapping)[type] && formatMessage((0, $gHO4S.descriptionMapping)[type])), /*#__PURE__*/ $eJOHy.createElement((0, $3cMgR.default), {
        as: "em",
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $pkfsB.default).requiredFieldsHeader)));
};
const $2df745d30354834c$var$modalHeaderStyles = null;

});

parcelRegister("4SlPH", function(module, exports) {
$parcel$export(module.exports, "ModalIllustration", () => $0ce458cdd2e51714$export$dc26d3e21d436b08);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $byJNH = parcelRequire("byJNH");

var $78OnL = parcelRequire("78OnL");

var $3Yo2k = parcelRequire("3Yo2k");

var $lRq8t = parcelRequire("lRq8t");

var $cLQj5 = parcelRequire("cLQj5");
const $0ce458cdd2e51714$export$dc26d3e21d436b08 = ()=>{
    const state = (0, $byJNH.useFormState)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("h5", {
        className: (0, $hcewu.default)([
            "_11c8nbxd _1reo15vq _18m915vq _k48p1pd9 _syaz1gjq _18u01axu _1bto1l2s _o5721q9c _p12fp3fh"
        ])
    }, state?.values.boardName?.trim() || formatMessage((0, $cLQj5.default).illustrationPlaceHolderHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Yo2k.default), {
        alt: formatMessage((0, $cLQj5.default).illustrationAltText),
        height: "334px"
    })));
};
const $0ce458cdd2e51714$var$modalIllustrationHeaderStyles = null;

});
parcelRegister("byJNH", function(module, exports) {
$parcel$export(module.exports, "useFormState", () => $43f7cff3f66357ce$export$606f11b2eb45ecc6);

var $eJOHy = parcelRequire("eJOHy");

var $3L3Os = parcelRequire("3L3Os");
// Constantized to avoid a new object reference built every call
const $43f7cff3f66357ce$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $43f7cff3f66357ce$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $43f7cff3f66357ce$export$606f11b2eb45ecc6 = (subscriptionConfig = $43f7cff3f66357ce$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $eJOHy.useContext)((0, $3L3Os.FormContext));
    const [state, setState] = (0, $eJOHy.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $eJOHy.useMemo)(()=>$43f7cff3f66357ce$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $eJOHy.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("3Yo2k", function(module, exports) {
$parcel$export(module.exports, "default", () => $135b4187d8ccfd88$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $6MTsf = parcelRequire("6MTsf");
const $135b4187d8ccfd88$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6MTsf)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6MTsf))
});
var $135b4187d8ccfd88$export$2e2bcd8739ae039 = $135b4187d8ccfd88$var$Illustration;
const $135b4187d8ccfd88$export$a179c88182cb9d56 = [
    0,
    0,
    448,
    334
];

});
parcelRegister("6MTsf", function(module, exports) {
module.exports = new URL("bug-and-task-cards-in-a-column.455dfa61.svg", import.meta.url).toString();

});


parcelRegister("cLQj5", function(module, exports) {
$parcel$export(module.exports, "default", () => $cae77acd59a2e3e9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cae77acd59a2e3e9$var$messages = (0, $7qGN1.defineMessages)({
    illustrationPlaceHolderHeader: {
        "id": "software-board-create.modal.illustration.illustration-place-holder-header",
        "defaultMessage": "New board"
    },
    illustrationAltText: {
        "id": "software-board-create.modal.illustration.illustration-alt-text",
        "defaultMessage": "Bug and task cards in a board column"
    }
});
var $cae77acd59a2e3e9$export$2e2bcd8739ae039 = $cae77acd59a2e3e9$var$messages;

});


parcelRegister("kHJve", function(module, exports) {
$parcel$export(module.exports, "FormActions", () => $9518fde6d5692310$export$9494d5a5e5299081);

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $loxVz = parcelRequire("loxVz");
const $9518fde6d5692310$export$9494d5a5e5299081 = ({ onClose: onClose, submitting: submitting })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9518fde6d5692310$var$buttonGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        isDisabled: submitting,
        onClick: onClose,
        testId: "software-board-create.ui.modal.form.actions.board-create-cancel-button"
    }, formatMessage((0, $loxVz.default).modalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        type: "submit",
        isLoading: submitting,
        testId: "software-board-create.ui.modal.form.actions.board-create-confirm-button"
    }, formatMessage((0, $loxVz.default).modalConfirmButton))));
};
const $9518fde6d5692310$var$buttonGroupContainerStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.100'
});

});
parcelRegister("loxVz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ede517f5c9e6f3aa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ede517f5c9e6f3aa$var$messages = (0, $7qGN1.defineMessages)({
    modalConfirmButton: {
        "id": "software-board-create.modal.form.actions.modal-confirm-button",
        "defaultMessage": "Create"
    },
    modalCancelButton: {
        "id": "software-board-create.modal.form.actions.modal-cancel-button",
        "defaultMessage": "Cancel"
    }
});
var $ede517f5c9e6f3aa$export$2e2bcd8739ae039 = $ede517f5c9e6f3aa$var$messages;

});


parcelRegister("hPEYy", function(module, exports) {
$parcel$export(module.exports, "BoardNameField", () => $b24858a6d43afd4b$export$f710d048b5529d22);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");
var $byJNH = parcelRequire("byJNH");

var $sY9BV = parcelRequire("sY9BV");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2pys5 = parcelRequire("2pys5");

var $ho2vK = parcelRequire("ho2vK");
const $b24858a6d43afd4b$export$f710d048b5529d22 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formState = (0, $byJNH.useFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [value, setValue] = (0, $eJOHy.useState)('');
    const hasEdited = (0, $eJOHy.useRef)(false);
    const debouncedHandleOnChange = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
        if (!hasEdited.current) {
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'input'
            }), 'boardName');
            hasEdited.current = true;
        }
    }, 300)).current;
    const handleOnChange = (0, $eJOHy.useCallback)((event)=>{
        setValue(event.currentTarget.value);
        const newValue = event.currentTarget.value;
        setValue(newValue);
        debouncedHandleOnChange();
    }, [
        debouncedHandleOnChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        label: formatMessage((0, $ho2vK.default).boardNameFieldLabel),
        name: "boardName",
        isRequired: true
    }, ({ fieldProps: { onChange: onChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            ...rest,
            placeholder: formatMessage((0, $ho2vK.default).boardNameFieldPlaceholder),
            maxLength: (0, $2pys5.BOARD_NAME_LIMIT),
            testId: "software-board-create.ui.modal.form.board-name.board-name-input",
            value: value,
            onChange: (event)=>{
                handleOnChange(event);
                onChange(event);
            }
        }), error === (0, $2pys5.VALIDATION_ERROR_EMPTY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.board-name.board-name-error"
        }, formatMessage((0, $ho2vK.default).boardNameEmptyError)), formState?.values.boardName && formState.values.boardName.length >= (0, $2pys5.BOARD_NAME_LIMIT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, formatMessage((0, $ho2vK.default).boardNameMaxChars, {
            maxLength: (0, $2pys5.BOARD_NAME_LIMIT)
        }))));
};

});
parcelRegister("fKXve", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $d60bc96267cb44d2$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $d60bc96267cb44d2$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $d60bc96267cb44d2$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $d60bc96267cb44d2$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $i9bjW = parcelRequire("i9bjW");

var $eGOwo = parcelRequire("eGOwo");

var $h8JmM = parcelRequire("h8JmM");
const $d60bc96267cb44d2$var$messageStyles = null;
const $d60bc96267cb44d2$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $d60bc96267cb44d2$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $d60bc96267cb44d2$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            $d60bc96267cb44d2$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $d60bc96267cb44d2$var$messageIcons = {
    error: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i9bjW))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
const $d60bc96267cb44d2$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $d60bc96267cb44d2$var$messageIcons[appearance];
    const { isWrapper: isWrapper } = (0, $eJOHy.useContext)($d60bc96267cb44d2$var$MessageWrapperContext);
    const [shouldRenderAfterDelay, setShouldRenderAfterDelay] = (0, $eJOHy.useState)(false);
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    const isDelayRenderEnabled = (0, $eGOwo.fg)('platform_dst_form_screenreader_message_fix') && !isWrapper;
    (0, $eJOHy.useEffect)(()=>{
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            const timer = setTimeout(()=>{
                setShouldRenderAfterDelay(true);
            }, 10);
            return ()=>clearTimeout(timer);
        }
        return;
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        children: children
    });
    const childrenToRender = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            icon && /*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        id: fieldId,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
        "aria-live": !isWrapper ? 'polite' : undefined,
        className: (0, $hcewu.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $d60bc96267cb44d2$var$messageAppearanceStyles[appearance]
        ]),
        children: isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender
    });
};
const $d60bc96267cb44d2$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $d60bc96267cb44d2$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $d60bc96267cb44d2$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $d60bc96267cb44d2$var$MessageWrapperContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isWrapper: false
});
const $d60bc96267cb44d2$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("i9bjW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d361d947cb810d1b$var$_react = $d361d947cb810d1b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d361d947cb810d1b$var$_statusSuccess = $d361d947cb810d1b$var$_interopRequireDefault((parcelRequire("3wl9L")));

var $d361d947cb810d1b$var$_success = $d361d947cb810d1b$var$_interopRequireDefault((parcelRequire("6BeTe")));
function $d361d947cb810d1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d361d947cb810d1b$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $d361d947cb810d1b$var$_react.default.createElement($d361d947cb810d1b$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $d361d947cb810d1b$var$_success.default
    }, props));
$d361d947cb810d1b$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $d361d947cb810d1b$var$_default = module.exports.default = $d361d947cb810d1b$var$StatusSuccessIcon;

});
parcelRegister("6BeTe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ce1bf91d97a4ffd$var$_react = $4ce1bf91d97a4ffd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4ce1bf91d97a4ffd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4ce1bf91d97a4ffd$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $4ce1bf91d97a4ffd$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$4ce1bf91d97a4ffd$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $4ce1bf91d97a4ffd$var$_default = module.exports.default = $4ce1bf91d97a4ffd$var$EditorSuccessIcon;

});


parcelRegister("h8JmM", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $32369bd40dc5a2d5$export$3c4232819458a302);

var $eJOHy = parcelRequire("eJOHy");
const $32369bd40dc5a2d5$export$3c4232819458a302 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);

});


parcelRegister("6svxr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b792a43640ff13ce$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gl2vi = parcelRequire("gl2vi");

var $h8JmM = parcelRequire("h8JmM");

var $3L3Os = parcelRequire("3L3Os");

var $cDJ0f = parcelRequire("cDJ0f");

var $fKXve = parcelRequire("fKXve");

var $lP4Q7 = parcelRequire("lP4Q7");
const $b792a43640ff13ce$var$fieldWrapperStyles = null;
function $b792a43640ff13ce$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $b792a43640ff13ce$var$isFunction(x) {
    return typeof x === 'function';
}
function $b792a43640ff13ce$var$usePreviousRef(current) {
    const ref = (0, $eJOHy.useRef)(current);
    // will be updated on the next render
    (0, $eJOHy.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $b792a43640ff13ce$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $b792a43640ff13ce$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eJOHy.useContext)((0, $3L3Os.FormContext));
    const isDisabled = (0, $eJOHy.useContext)((0, $3L3Os.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $b792a43640ff13ce$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $b792a43640ff13ce$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$b792a43640ff13ce$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eJOHy.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $b792a43640ff13ce$var$usePreviousRef(state);
    (0, $eJOHy.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $b792a43640ff13ce$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($b792a43640ff13ce$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $gl2vi.useId)();
    const fieldId = (0, $eJOHy.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $hcewu.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cDJ0f.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lP4Q7.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fKXve.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("cDJ0f", function(module, exports) {
$parcel$export(module.exports, "Label", () => $ed0e34f34427bb25$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $ed0e34f34427bb25$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ed0e34f34427bb25$var$fieldsetLabelStyles = null;
const $ed0e34f34427bb25$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $ed0e34f34427bb25$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("legend", {
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("lP4Q7", function(module, exports) {
$parcel$export(module.exports, "default", () => $f003b759d66377bb$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f003b759d66377bb$var$requiredIndicatorStyles = null;
function $f003b759d66377bb$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $hcewu.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("ho2vK", function(module, exports) {
$parcel$export(module.exports, "default", () => $f508a9d654a1f3ea$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f508a9d654a1f3ea$var$messages = (0, $7qGN1.defineMessages)({
    boardNameFieldLabel: {
        "id": "software-board-create.modal.form.board-name.board-name-field-label",
        "defaultMessage": "Name this board"
    },
    boardNameFieldPlaceholder: {
        "id": "software-board-create.modal.form.board-name.board-name-field-placeholder",
        "defaultMessage": "Enter a name for this board"
    },
    boardNameEmptyError: {
        "id": "software-board-create.modal.form.board-name.board-name-empty-error",
        "defaultMessage": "Enter a board name"
    },
    boardNameMaxChars: {
        "id": "software-board-create.modal.form.board-name.board-name-max-chars",
        "defaultMessage": "Maximum {maxLength, plural, one {# character} other {# characters}}"
    }
});
var $f508a9d654a1f3ea$export$2e2bcd8739ae039 = $f508a9d654a1f3ea$var$messages;

});


parcelRegister("kaWPn", function(module, exports) {
$parcel$export(module.exports, "SourceTypePicker", () => $21828c79c23c48b5$export$879aac32ab2e56ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $aX8Tx = parcelRequire("aX8Tx");

var $12DRg = parcelRequire("12DRg");

var $5DgXR = parcelRequire("5DgXR");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");

var $f5dwt = parcelRequire("f5dwt");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iunk7 = parcelRequire("iunk7");

var $8EXfh = parcelRequire("8EXfh");

var $2WGTE = parcelRequire("2WGTE");
const $21828c79c23c48b5$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $21828c79c23c48b5$var$formatOptionLabel = (option)=>{
    const { icon: Icon, title: title, description: description } = option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.150",
        xcss: $21828c79c23c48b5$var$optionStyles
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: Icon,
        size: "xsmall",
        appearance: "square",
        borderColor: "transparent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        label: "",
        name: "projectIcon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "UNSAFE_small",
        color: "color.text.subtlest"
    }, description)));
};
const $21828c79c23c48b5$var$SingleValue = (props)=>{
    const { data: { selectedTitle: selectedTitle, icon: Icon } } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.100"
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: Icon,
        size: "xsmall",
        appearance: "square",
        name: "avatar"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage(selectedTitle, {
        strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                as: "strong"
            }, children)
    }))));
};
const $21828c79c23c48b5$export$77e74af9508bfdeb = ()=>(0, $eJOHy.useState)();
const $21828c79c23c48b5$var$controlStyles = {
    focused: "_1u6l142n _4cvx1p6i _1dbzzucj"
};
const $21828c79c23c48b5$var$groupStyles = {
    root: "_1ved1dm9 _fgngnqa1 _1itxmuej"
};
const $21828c79c23c48b5$export$879aac32ab2e56ba = ({ resetSourceValue: resetSourceValue })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [selected, setSelected] = $21828c79c23c48b5$export$77e74af9508bfdeb();
    const { projectAvatar: projectAvatar } = (0, $iunk7.useBoardCreateContext)();
    const optionGroups = (0, $eJOHy.useMemo)(()=>(0, $2WGTE.getOptionGroups)({
            formatMessage: formatMessage,
            projectAvatar: projectAvatar
        }), [
        formatMessage,
        projectAvatar
    ]);
    const flattenedOptions = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(optionGroups.map((group)=>group.options)), [
        optionGroups
    ]);
    const handleChange = (0, $eJOHy.useCallback)((onFieldChange)=>(value)=>{
            const option = value?.value || null;
            resetSourceValue();
            setSelected(option);
            onFieldChange(option);
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'select',
                action: 'changed'
            }), 'boardSourceType', {
                sourceType: option
            });
        }, [
        createAnalyticsEvent,
        resetSourceValue,
        setSelected
    ]);
    const handleOnMenuOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'select',
            action: 'opened'
        }), 'boardSourceType');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: "sourceType",
        label: formatMessage((0, $8EXfh.default).sourceTypeFieldLabel),
        defaultValue: undefined,
        isRequired: true
    }, ({ fieldProps: { onChange: onFieldChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
            onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
            ...rest,
            "aria-label": formatMessage((0, $8EXfh.default).sourceTypePickerAriaLabel),
            options: optionGroups,
            isSearchable: false,
            formatOptionLabel: $21828c79c23c48b5$var$formatOptionLabel,
            components: {
                SingleValue: $21828c79c23c48b5$var$SingleValue,
                Control: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Control, {
                        ...props,
                        xcss: props.isFocused && $21828c79c23c48b5$var$controlStyles.focused
                    }),
                Group: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
                        ...props,
                        xcss: $21828c79c23c48b5$var$groupStyles.root
                    })
            },
            placeholder: formatMessage((0, $8EXfh.default).selectPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-type-picker",
            onChange: handleChange(onFieldChange),
            value: flattenedOptions.find((option)=>option.value === selected),
            styles: {
                control: (base, state)=>({
                        ...base,
                        borderColor: state.isFocused ? "var(--ds-border-focused, #388BFF)" : base.borderColor,
                        ':focus-within': {
                            boxShadow: state.isFocused ? `inset 0px 0px 0px 1px ${"var(--ds-border-focused, #388BFF)"}` : base.boxShadow
                        },
                        ':hover': {
                            borderColor: state.isFocused ? "var(--ds-border-focused, #388BFF)" : base.borderColor,
                            boxShadow: state.isFocused ? 'elevation.shadow.raised' : base.boxShadow
                        }
                    }),
                option: (base)=>({
                        ...base,
                        // padding inside the option so hover covers the element
                        padding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"}`
                    }),
                group: (base)=>({
                        ...base,
                        padding: 0,
                        ':not(:last-of-type)': {
                            borderBottomWidth: "var(--ds-border-width-selected, 2px)",
                            borderBottomStyle: 'solid',
                            borderBottomColor: "var(--ds-border, #091E4224)"
                        }
                    }),
                groupHeading: (base)=>({
                        ...base,
                        margin: 0
                    }),
                menuList: (base)=>({
                        ...base,
                        padding: 0,
                        maxHeight: 325
                    })
            },
            onMenuOpen: handleOnMenuOpen
        })), error === $21828c79c23c48b5$export$7b060a5763a6e199 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-type-picker.error"
        }, formatMessage((0, $8EXfh.default).sourceTypeEmptyError))));
};
const $21828c79c23c48b5$var$optionStyles = (0, $1DXK0.xcss)({
    minHeight: '40px'
});

});
parcelRegister("6XEne", function(module, exports) {
$parcel$export(module.exports, "components", () => $d8405f0ed531ae54$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $d8405f0ed531ae54$export$71abc632aa29e6fe);

var $b9w97 = parcelRequire("b9w97");

var $5g4w5 = parcelRequire("5g4w5");

var $hZvJb = parcelRequire("hZvJb");

var $gbM8i = parcelRequire("gbM8i");

var $lnZHc = parcelRequire("lnZHc");

var $lVGx8 = parcelRequire("lVGx8");

var $kBFBH = parcelRequire("kBFBH");

var $aO7ic = parcelRequire("aO7ic");

var $9QHqW = parcelRequire("9QHqW");

var $7Q7hB = parcelRequire("7Q7hB");
const $d8405f0ed531ae54$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $gbM8i.ClearIndicator),
    Control: (0, $5g4w5.default),
    DropdownIndicator: (0, $gbM8i.DropdownIndicator),
    Group: (0, $hZvJb.default),
    GroupHeading: (0, $hZvJb.GroupHeading),
    IndicatorsContainer: (0, $b9w97.IndicatorsContainer),
    Input: (0, $lnZHc.default),
    LoadingIndicator: (0, $gbM8i.LoadingIndicator),
    Menu: (0, $lVGx8.default),
    MenuList: (0, $lVGx8.MenuList),
    MenuPortal: (0, $lVGx8.MenuPortal),
    LoadingMessage: (0, $lVGx8.LoadingMessage),
    NoOptionsMessage: (0, $lVGx8.NoOptionsMessage),
    MultiValue: (0, $kBFBH.default),
    MultiValueContainer: (0, $kBFBH.MultiValueContainer),
    MultiValueLabel: (0, $kBFBH.MultiValueLabel),
    MultiValueRemove: (0, $kBFBH.MultiValueRemove),
    Option: (0, $aO7ic.default),
    Placeholder: (0, $9QHqW.default),
    SelectContainer: (0, $b9w97.SelectContainer),
    SingleValue: (0, $7Q7hB.default),
    ValueContainer: (0, $b9w97.ValueContainer)
};
const $d8405f0ed531ae54$export$71abc632aa29e6fe = (props)=>({
        ...$d8405f0ed531ae54$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("b9w97", function(module, exports) {
$parcel$export(module.exports, "containerCSS", () => $3073a798dd6e0f6d$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $3073a798dd6e0f6d$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $3073a798dd6e0f6d$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $3073a798dd6e0f6d$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $3073a798dd6e0f6d$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $3073a798dd6e0f6d$export$d0ffd7e649cab6f);
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $eGOwo = parcelRequire("eGOwo");

var $gNnQq = parcelRequire("gNnQq");
const $3073a798dd6e0f6d$export$949392aeaf7d2e3a = ()=>({});
const $3073a798dd6e0f6d$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
const $3073a798dd6e0f6d$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $gNnQq.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $3073a798dd6e0f6d$var$containerStyles.default,
            isRtl && $3073a798dd6e0f6d$var$containerStyles.rtl,
            isDisabled && $3073a798dd6e0f6d$var$containerStyles.disabled,
            (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && $3073a798dd6e0f6d$var$containerStyles.ff_safari_input_fix,
            (0, $k0ahr.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $3073a798dd6e0f6d$export$47aec73c7aa6b9aa = ()=>({});
const $3073a798dd6e0f6d$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
const $3073a798dd6e0f6d$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $3073a798dd6e0f6d$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $3073a798dd6e0f6d$var$valueContainerStyles.flex,
            isCompact && $3073a798dd6e0f6d$var$valueContainerStyles.compact,
            (0, $k0ahr.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $3073a798dd6e0f6d$export$9d74e3c8b5868ad7 = ()=>({});
const $3073a798dd6e0f6d$var$indicatorContainerStyles = null;
const $3073a798dd6e0f6d$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $k0ahr.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("gNnQq", function(module, exports) {
$parcel$export(module.exports, "noop", () => $73759b8c9ef6d15d$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $73759b8c9ef6d15d$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $73759b8c9ef6d15d$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $73759b8c9ef6d15d$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $73759b8c9ef6d15d$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $73759b8c9ef6d15d$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $73759b8c9ef6d15d$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $73759b8c9ef6d15d$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $73759b8c9ef6d15d$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $73759b8c9ef6d15d$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $73759b8c9ef6d15d$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $73759b8c9ef6d15d$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $73759b8c9ef6d15d$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $73759b8c9ef6d15d$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $73759b8c9ef6d15d$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $73759b8c9ef6d15d$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $73759b8c9ef6d15d$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $73759b8c9ef6d15d$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $73759b8c9ef6d15d$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $73759b8c9ef6d15d$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $73759b8c9ef6d15d$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $73759b8c9ef6d15d$export$4213b25a1c4e877);
$parcel$export(module.exports, "filterUnsupportedSelectors", () => $73759b8c9ef6d15d$export$bf2eda47afa5f369);
const $73759b8c9ef6d15d$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $73759b8c9ef6d15d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $73759b8c9ef6d15d$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$73759b8c9ef6d15d$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $73759b8c9ef6d15d$export$33f062f47f21a01 = (value)=>{
    if ($73759b8c9ef6d15d$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $73759b8c9ef6d15d$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $73759b8c9ef6d15d$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $73759b8c9ef6d15d$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $73759b8c9ef6d15d$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $73759b8c9ef6d15d$export$2e0654fad740d2e4(el) {
    if ($73759b8c9ef6d15d$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $73759b8c9ef6d15d$export$c4a223a8ba9e4ea5(el) {
    if ($73759b8c9ef6d15d$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $73759b8c9ef6d15d$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($73759b8c9ef6d15d$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $73759b8c9ef6d15d$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $73759b8c9ef6d15d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $73759b8c9ef6d15d$export$858c30343199f3af(element, to, duration = 200, callback = $73759b8c9ef6d15d$export$8793edee2d425525) {
    const start = $73759b8c9ef6d15d$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $73759b8c9ef6d15d$var$easeOutCubic(currentTime, start, change, duration);
        $73759b8c9ef6d15d$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $73759b8c9ef6d15d$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $73759b8c9ef6d15d$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $73759b8c9ef6d15d$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $73759b8c9ef6d15d$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $73759b8c9ef6d15d$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $73759b8c9ef6d15d$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $73759b8c9ef6d15d$var$passiveOptionAccessed = false;
const $73759b8c9ef6d15d$var$options = {
    get passive () {
        return $73759b8c9ef6d15d$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $73759b8c9ef6d15d$var$w = typeof window !== 'undefined' ? window : {};
if ($73759b8c9ef6d15d$var$w.addEventListener && $73759b8c9ef6d15d$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $73759b8c9ef6d15d$var$w.addEventListener('p', $73759b8c9ef6d15d$export$8793edee2d425525, $73759b8c9ef6d15d$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $73759b8c9ef6d15d$var$w.removeEventListener('p', $73759b8c9ef6d15d$export$8793edee2d425525, false);
}
const $73759b8c9ef6d15d$export$b0622a6911dbeaf5 = $73759b8c9ef6d15d$var$passiveOptionAccessed;
function $73759b8c9ef6d15d$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $73759b8c9ef6d15d$var$isArray(arg) {
    return Array.isArray(arg);
}
function $73759b8c9ef6d15d$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $73759b8c9ef6d15d$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $73759b8c9ef6d15d$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $73759b8c9ef6d15d$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $73759b8c9ef6d15d$export$bf2eda47afa5f369 = (styles)=>{
    const unsupportedSelectors = [
        ':',
        '[',
        '>',
        '+',
        '~',
        ' ',
        '*',
        '#',
        '.',
        '@',
        '&',
        '|',
        '^',
        '$',
        '='
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});


parcelRegister("5g4w5", function(module, exports) {
$parcel$export(module.exports, "css", () => $4bcfb8439cfc2381$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $4bcfb8439cfc2381$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $gNnQq = parcelRequire("gNnQq");
const $4bcfb8439cfc2381$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123b1h4p _d0altlke _irr31d5g _1oglgxqn",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $4bcfb8439cfc2381$export$dbf350e5966cf602 = ()=>({});
const $4bcfb8439cfc2381$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $4bcfb8439cfc2381$var$styles.default,
            isDisabled && $4bcfb8439cfc2381$var$styles.disabled,
            isInvalid && $4bcfb8439cfc2381$var$styles.invalid,
            isCompact && $4bcfb8439cfc2381$var$styles.compact,
            appearance === 'subtle' && $4bcfb8439cfc2381$var$styles.subtle,
            appearance === 'subtle' && isFocused && $4bcfb8439cfc2381$var$styles.subtleFocused,
            isFocused && $4bcfb8439cfc2381$var$styles.focused,
            appearance === 'none' && $4bcfb8439cfc2381$var$styles.none,
            (0, $k0ahr.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bcfb8439cfc2381$export$2e2bcd8739ae039 = $4bcfb8439cfc2381$var$Control;

});

parcelRegister("hZvJb", function(module, exports) {
$parcel$export(module.exports, "groupCSS", () => $eb9133d22ec5c818$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $eb9133d22ec5c818$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $eb9133d22ec5c818$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $eb9133d22ec5c818$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $gNnQq = parcelRequire("gNnQq");
const $eb9133d22ec5c818$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $eb9133d22ec5c818$export$b6794329c1460634 = ()=>({});
const $eb9133d22ec5c818$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $eb9133d22ec5c818$var$styles.root,
            (0, $k0ahr.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                children: children
            })
        ]
    });
};
const $eb9133d22ec5c818$var$headingStyles = null;
const $eb9133d22ec5c818$export$e5a7fbb542efcb7d = ()=>({});
const $eb9133d22ec5c818$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $gNnQq.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $k0ahr.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eb9133d22ec5c818$export$2e2bcd8739ae039 = $eb9133d22ec5c818$var$Group;

});

parcelRegister("gbM8i", function(module, exports) {
$parcel$export(module.exports, "dropdownIndicatorCSS", () => $1bf3edcd4f378d4d$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $1bf3edcd4f378d4d$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $1bf3edcd4f378d4d$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $1bf3edcd4f378d4d$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $1bf3edcd4f378d4d$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $1bf3edcd4f378d4d$export$7c20be4c1d342248);
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $5lAAn = parcelRequire("5lAAn");

var $5pWSu = parcelRequire("5pWSu");

var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");

var $7ep4S = parcelRequire("7ep4S");

var $gNnQq = parcelRequire("gNnQq");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $1bf3edcd4f378d4d$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $1bf3edcd4f378d4d$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
const $1bf3edcd4f378d4d$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
const $1bf3edcd4f378d4d$export$e1687335805e1230 = ()=>({});
const $1bf3edcd4f378d4d$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $1bf3edcd4f378d4d$var$dropdownStyles.default,
            isDisabled && $1bf3edcd4f378d4d$var$dropdownStyles.disabled,
            isCompact && $1bf3edcd4f378d4d$var$dropdownStyles.compact,
            (0, $k0ahr.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "span",
            xcss: $1bf3edcd4f378d4d$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                color: "currentColor",
                label: "open",
                LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
                size: "small"
            })
        })
    });
};
const $1bf3edcd4f378d4d$export$9c0419fd944c1def = ()=>({});
const $1bf3edcd4f378d4d$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
const $1bf3edcd4f378d4d$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $1bf3edcd4f378d4d$var$clearIndicatorStyles.default,
            isCompact && $1bf3edcd4f378d4d$var$clearIndicatorStyles.compact,
            (0, $k0ahr.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            xcss: $1bf3edcd4f378d4d$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5pWSu))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small",
                LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
                size: "small"
            })
        })
    });
};
const $1bf3edcd4f378d4d$export$1d3f24cde248e6b5 = ()=>({});
const $1bf3edcd4f378d4d$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
const $1bf3edcd4f378d4d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $1bf3edcd4f378d4d$var$loadingIndicatorStyles.default,
            isCompact && $1bf3edcd4f378d4d$var$loadingIndicatorStyles.compact,
            (0, $k0ahr.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            size: "small"
        })
    });
};

});

parcelRegister("lnZHc", function(module, exports) {
$parcel$export(module.exports, "inputCSS", () => $af9331f8cd021862$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $af9331f8cd021862$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $eGOwo = parcelRequire("eGOwo");

var $gNnQq = parcelRequire("gNnQq");
const $af9331f8cd021862$export$14a7781d0ca7abea = ()=>({});
const $af9331f8cd021862$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $af9331f8cd021862$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $af9331f8cd021862$var$nativeInputStylesOld = null;
const $af9331f8cd021862$var$nativeInputStyles = null;
const $af9331f8cd021862$var$hidden = null;
const $af9331f8cd021862$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gNnQq.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'input', {
        'input-container': true
    });
    if ((0, $eGOwo.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $af9331f8cd021862$var$inputStyles.root,
            isDisabled && $af9331f8cd021862$var$inputStyles.disabled,
            (0, $k0ahr.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $hcewu.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $af9331f8cd021862$var$inputStylesOld.root,
            isDisabled && $af9331f8cd021862$var$inputStylesOld.disabled,
            (0, $k0ahr.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $hcewu.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$af9331f8cd021862$export$2e2bcd8739ae039 = $af9331f8cd021862$var$Input;

});

parcelRegister("lVGx8", function(module, exports) {
$parcel$export(module.exports, "menuCSS", () => $312e8ec42be14643$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $312e8ec42be14643$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $312e8ec42be14643$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $312e8ec42be14643$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $312e8ec42be14643$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $312e8ec42be14643$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $312e8ec42be14643$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $312e8ec42be14643$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $312e8ec42be14643$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $312e8ec42be14643$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $312e8ec42be14643$export$793392f970497feb);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $28gFV = parcelRequire("28gFV");

var $aQK2r = parcelRequire("aQK2r");

var $dsV8x = parcelRequire("dsV8x");

var $3cMgR = parcelRequire("3cMgR");

var $gNnQq = parcelRequire("gNnQq");
function $312e8ec42be14643$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gNnQq.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gNnQq.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gNnQq.getScrollTop)(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gNnQq.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gNnQq.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gNnQq.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gNnQq.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gNnQq.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $312e8ec42be14643$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $312e8ec42be14643$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs17uf",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
const $312e8ec42be14643$export$a228922d5ca42a79 = ()=>({});
const $312e8ec42be14643$var$PortalPlacementContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $312e8ec42be14643$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $eJOHy.useContext)($312e8ec42be14643$var$PortalPlacementContext) || {};
    const ref = (0, $eJOHy.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $eJOHy.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $eJOHy.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $dsV8x.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $312e8ec42be14643$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $312e8ec42be14643$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $312e8ec42be14643$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $312e8ec42be14643$var$menuStyles.root,
            $312e8ec42be14643$var$menuStyles[placement],
            (0, $k0ahr.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$312e8ec42be14643$export$2e2bcd8739ae039 = $312e8ec42be14643$var$Menu;
const $312e8ec42be14643$export$abafed69cff95d5e = ()=>({});
const $312e8ec42be14643$var$menuListStyles = null;
const $312e8ec42be14643$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $k0ahr.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
// ==============================
// Menu Notices
// ==============================
const $312e8ec42be14643$var$noticeCSS = ()=>({});
const $312e8ec42be14643$var$noticeStyles = null;
const $312e8ec42be14643$export$cf0e22534d8b0074 = $312e8ec42be14643$var$noticeCSS;
const $312e8ec42be14643$export$98ec46397a8cb3cd = $312e8ec42be14643$var$noticeCSS;
const $312e8ec42be14643$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $k0ahr.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $312e8ec42be14643$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $k0ahr.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $312e8ec42be14643$export$1dbbeb9648d1fdc9 = ()=>({});
const $312e8ec42be14643$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
const $312e8ec42be14643$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $eJOHy.useRef)(null);
    const cleanupRef = (0, $eJOHy.useRef)(null);
    const [placement, setPortalPlacement] = (0, $eJOHy.useState)($312e8ec42be14643$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $eJOHy.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $eJOHy.useState)(null);
    const updateComputedPosition = (0, $eJOHy.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gNnQq.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $dsV8x.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $eJOHy.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $28gFV.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $dsV8x.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $eJOHy.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $312e8ec42be14643$var$menuPortalStyles.root,
            (0, $k0ahr.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($312e8ec42be14643$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $aQK2r.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("28gFV", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $18d9437f91783eed$export$deee3a793edee05f);

var $lczCq = parcelRequire("lczCq");
var $5WL31 = parcelRequire("5WL31");

var $5WL31 = parcelRequire("5WL31");

var $3rNIs = parcelRequire("3rNIs");
function $18d9437f91783eed$var$getCssDimensions(element) {
    const css = (0, $3rNIs.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $3rNIs.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $5WL31.round)(width) !== offsetWidth || (0, $5WL31.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $18d9437f91783eed$var$unwrapElement(element) {
    return !(0, $3rNIs.isElement)(element) ? element.contextElement : element;
}
function $18d9437f91783eed$var$getScale(element) {
    const domElement = $18d9437f91783eed$var$unwrapElement(element);
    if (!(0, $3rNIs.isHTMLElement)(domElement)) return (0, $5WL31.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $18d9437f91783eed$var$getCssDimensions(domElement);
    let x = ($ ? (0, $5WL31.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $5WL31.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $18d9437f91783eed$var$noOffsets = /*#__PURE__*/ (0, $5WL31.createCoords)(0);
function $18d9437f91783eed$var$getVisualOffsets(element) {
    const win = (0, $3rNIs.getWindow)(element);
    if (!(0, $3rNIs.isWebKit)() || !win.visualViewport) return $18d9437f91783eed$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $18d9437f91783eed$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $3rNIs.getWindow)(element)) return false;
    return isFixed;
}
function $18d9437f91783eed$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $18d9437f91783eed$var$unwrapElement(element);
    let scale = (0, $5WL31.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $3rNIs.isElement)(offsetParent)) scale = $18d9437f91783eed$var$getScale(offsetParent);
        } else scale = $18d9437f91783eed$var$getScale(element);
    }
    const visualOffsets = $18d9437f91783eed$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $18d9437f91783eed$var$getVisualOffsets(domElement) : (0, $5WL31.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $3rNIs.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $3rNIs.isElement)(offsetParent) ? (0, $3rNIs.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $3rNIs.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $18d9437f91783eed$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $3rNIs.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $3rNIs.getWindow)(currentIFrame);
            currentIFrame = (0, $3rNIs.getFrameElement)(currentWin);
        }
    }
    return (0, $5WL31.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $18d9437f91783eed$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $3rNIs.getNodeScroll)(element).scrollLeft;
    if (!rect) return $18d9437f91783eed$var$getBoundingClientRect((0, $3rNIs.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $18d9437f91783eed$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $18d9437f91783eed$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $18d9437f91783eed$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $3rNIs.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $3rNIs.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $5WL31.createCoords)(1);
    const offsets = (0, $5WL31.createCoords)(0);
    const isOffsetParentAnElement = (0, $3rNIs.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3rNIs.getNodeName)(offsetParent) !== 'body' || (0, $3rNIs.isOverflowElement)(documentElement)) scroll = (0, $3rNIs.getNodeScroll)(offsetParent);
        if ((0, $3rNIs.isHTMLElement)(offsetParent)) {
            const offsetRect = $18d9437f91783eed$var$getBoundingClientRect(offsetParent);
            scale = $18d9437f91783eed$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $18d9437f91783eed$var$getHTMLOffset(documentElement, scroll, true) : (0, $5WL31.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $18d9437f91783eed$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $18d9437f91783eed$var$getDocumentRect(element) {
    const html = (0, $3rNIs.getDocumentElement)(element);
    const scroll = (0, $3rNIs.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $5WL31.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $5WL31.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $18d9437f91783eed$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $3rNIs.getComputedStyle)(body).direction === 'rtl') x += (0, $5WL31.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $18d9437f91783eed$var$getViewportRect(element, strategy) {
    const win = (0, $3rNIs.getWindow)(element);
    const html = (0, $3rNIs.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $3rNIs.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $18d9437f91783eed$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $18d9437f91783eed$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $3rNIs.isHTMLElement)(element) ? $18d9437f91783eed$var$getScale(element) : (0, $5WL31.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $18d9437f91783eed$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $18d9437f91783eed$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $18d9437f91783eed$var$getDocumentRect((0, $3rNIs.getDocumentElement)(element));
    else if ((0, $3rNIs.isElement)(clippingAncestor)) rect = $18d9437f91783eed$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $18d9437f91783eed$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $5WL31.rectToClientRect)(rect);
}
function $18d9437f91783eed$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $3rNIs.getParentNode)(element);
    if (parentNode === stopNode || !(0, $3rNIs.isElement)(parentNode) || (0, $3rNIs.isLastTraversableNode)(parentNode)) return false;
    return (0, $3rNIs.getComputedStyle)(parentNode).position === 'fixed' || $18d9437f91783eed$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $18d9437f91783eed$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $3rNIs.getOverflowAncestors)(element, [], false).filter((el)=>(0, $3rNIs.isElement)(el) && (0, $3rNIs.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $3rNIs.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $3rNIs.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $3rNIs.isElement)(currentNode) && !(0, $3rNIs.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $3rNIs.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $3rNIs.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $3rNIs.isOverflowElement)(currentNode) && !currentNodeIsContaining && $18d9437f91783eed$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $3rNIs.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $18d9437f91783eed$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $3rNIs.isTopLayer)(element) ? [] : $18d9437f91783eed$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $18d9437f91783eed$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $5WL31.max)(rect.top, accRect.top);
        accRect.right = (0, $5WL31.min)(rect.right, accRect.right);
        accRect.bottom = (0, $5WL31.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $5WL31.max)(rect.left, accRect.left);
        return accRect;
    }, $18d9437f91783eed$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $18d9437f91783eed$var$getDimensions(element) {
    const { width: width, height: height } = $18d9437f91783eed$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $18d9437f91783eed$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $3rNIs.isHTMLElement)(offsetParent);
    const documentElement = (0, $3rNIs.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $18d9437f91783eed$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $5WL31.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3rNIs.getNodeName)(offsetParent) !== 'body' || (0, $3rNIs.isOverflowElement)(documentElement)) scroll = (0, $3rNIs.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $18d9437f91783eed$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $18d9437f91783eed$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $18d9437f91783eed$var$getHTMLOffset(documentElement, scroll) : (0, $5WL31.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $18d9437f91783eed$var$isStaticPositioned(element) {
    return (0, $3rNIs.getComputedStyle)(element).position === 'static';
}
function $18d9437f91783eed$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $3rNIs.isHTMLElement)(element) || (0, $3rNIs.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $3rNIs.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $18d9437f91783eed$var$getOffsetParent(element, polyfill) {
    const win = (0, $3rNIs.getWindow)(element);
    if ((0, $3rNIs.isTopLayer)(element)) return win;
    if (!(0, $3rNIs.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $3rNIs.getParentNode)(element);
        while(svgOffsetParent && !(0, $3rNIs.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $3rNIs.isElement)(svgOffsetParent) && !$18d9437f91783eed$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $3rNIs.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $18d9437f91783eed$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $3rNIs.isTableElement)(offsetParent) && $18d9437f91783eed$var$isStaticPositioned(offsetParent))offsetParent = $18d9437f91783eed$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $3rNIs.isLastTraversableNode)(offsetParent) && $18d9437f91783eed$var$isStaticPositioned(offsetParent) && !(0, $3rNIs.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $3rNIs.getContainingBlock)(element) || win;
}
const $18d9437f91783eed$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $18d9437f91783eed$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $18d9437f91783eed$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $18d9437f91783eed$var$isRTL(element) {
    return (0, $3rNIs.getComputedStyle)(element).direction === 'rtl';
}
const $18d9437f91783eed$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $18d9437f91783eed$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $3rNIs.getDocumentElement,
    getClippingRect: $18d9437f91783eed$var$getClippingRect,
    getOffsetParent: $18d9437f91783eed$var$getOffsetParent,
    getElementRects: $18d9437f91783eed$var$getElementRects,
    getClientRects: $18d9437f91783eed$var$getClientRects,
    getDimensions: $18d9437f91783eed$var$getDimensions,
    getScale: $18d9437f91783eed$var$getScale,
    isElement: $3rNIs.isElement,
    isRTL: $18d9437f91783eed$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $18d9437f91783eed$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $3rNIs.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $5WL31.floor)(top);
        const insetRight = (0, $5WL31.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $5WL31.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $5WL31.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $5WL31.max)(0, (0, $5WL31.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $18d9437f91783eed$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $18d9437f91783eed$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $3rNIs.getOverflowAncestors)(referenceEl) : [],
        ...(0, $3rNIs.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $18d9437f91783eed$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $18d9437f91783eed$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $18d9437f91783eed$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $18d9437f91783eed$export$37b6bde19b108ecc = (0, $lczCq.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $18d9437f91783eed$export$cc800923e997bb8 = (0, $lczCq.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $18d9437f91783eed$export$91fb6ecbd551914 = (0, $lczCq.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $18d9437f91783eed$export$fba63a578e423eb = (0, $lczCq.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $18d9437f91783eed$export$8a83211c878a3f1f = (0, $lczCq.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $18d9437f91783eed$export$346677f925de839c = (0, $lczCq.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $18d9437f91783eed$export$fe8985bb6374093c = (0, $lczCq.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $18d9437f91783eed$export$f2120bbfa5450bd2 = (0, $lczCq.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $18d9437f91783eed$export$18c8ad048e32c7d5 = (0, $lczCq.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $18d9437f91783eed$export$7bf07e38f3dc4b69 = (0, $lczCq.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $18d9437f91783eed$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $18d9437f91783eed$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $lczCq.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("lczCq", function(module, exports) {
$parcel$export(module.exports, "computePosition", () => $f6f6591fac2af23d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $f6f6591fac2af23d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $f6f6591fac2af23d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $f6f6591fac2af23d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $f6f6591fac2af23d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $f6f6591fac2af23d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $f6f6591fac2af23d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $f6f6591fac2af23d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $f6f6591fac2af23d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $f6f6591fac2af23d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $f6f6591fac2af23d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("5WL31")).rectToClientRect);

var $5WL31 = parcelRequire("5WL31");
function $f6f6591fac2af23d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $5WL31.getSideAxis)(placement);
    const alignmentAxis = (0, $5WL31.getAlignmentAxis)(placement);
    const alignLength = (0, $5WL31.getAxisLength)(alignmentAxis);
    const side = (0, $5WL31.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $5WL31.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $f6f6591fac2af23d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $f6f6591fac2af23d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $f6f6591fac2af23d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $f6f6591fac2af23d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $5WL31.evaluate)(options, state);
    const paddingObject = (0, $5WL31.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $5WL31.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $5WL31.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f6f6591fac2af23d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $5WL31.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $5WL31.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $5WL31.getAlignmentAxis)(placement);
            const length = (0, $5WL31.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $5WL31.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $5WL31.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $5WL31.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $5WL31.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $f6f6591fac2af23d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $5WL31.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $5WL31.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $5WL31.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $5WL31.getAlignment)(placement) === alignment || (autoAlignment ? (0, $5WL31.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $f6f6591fac2af23d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $5WL31.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $5WL31.placements) ? $f6f6591fac2af23d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $5WL31.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $5WL31.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $5WL31.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $5WL31.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $f6f6591fac2af23d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $5WL31.getSide)(placement);
            const initialSideAxis = (0, $5WL31.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $5WL31.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $5WL31.getOppositePlacement)(initialPlacement)
            ] : (0, $5WL31.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $5WL31.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $5WL31.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $5WL31.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $f6f6591fac2af23d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $f6f6591fac2af23d$var$isAnySideFullyClipped(overflow) {
    return (0, $5WL31.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $f6f6591fac2af23d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $f6f6591fac2af23d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $f6f6591fac2af23d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $f6f6591fac2af23d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $f6f6591fac2af23d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $f6f6591fac2af23d$var$getBoundingRect(rects) {
    const minX = (0, $5WL31.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $5WL31.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $5WL31.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $5WL31.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $f6f6591fac2af23d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $5WL31.rectToClientRect)($f6f6591fac2af23d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $f6f6591fac2af23d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $5WL31.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $f6f6591fac2af23d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $5WL31.rectToClientRect)($f6f6591fac2af23d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $5WL31.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $5WL31.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $5WL31.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $5WL31.getSide)(placement) === 'left';
                    const maxRight = (0, $5WL31.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $5WL31.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $f6f6591fac2af23d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $5WL31.getSide)(placement);
    const alignment = (0, $5WL31.getAlignment)(placement);
    const isVertical = (0, $5WL31.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $5WL31.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $f6f6591fac2af23d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $f6f6591fac2af23d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $f6f6591fac2af23d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $5WL31.getSideAxis)((0, $5WL31.getSide)(placement));
            const mainAxis = (0, $5WL31.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $5WL31.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $5WL31.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $f6f6591fac2af23d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $5WL31.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $5WL31.getSideAxis)(placement);
            const mainAxis = (0, $5WL31.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $5WL31.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $5WL31.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $f6f6591fac2af23d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $5WL31.getSide)(placement);
            const alignment = (0, $5WL31.getAlignment)(placement);
            const isYAxis = (0, $5WL31.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $5WL31.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $5WL31.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $5WL31.max)(overflow.left, 0);
                const xMax = (0, $5WL31.max)(overflow.right, 0);
                const yMin = (0, $5WL31.max)(overflow.top, 0);
                const yMax = (0, $5WL31.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $5WL31.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $5WL31.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("5WL31", function(module, exports) {
$parcel$export(module.exports, "sides", () => $4546dd41d380bd3c$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $4546dd41d380bd3c$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $4546dd41d380bd3c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $4546dd41d380bd3c$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $4546dd41d380bd3c$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $4546dd41d380bd3c$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $4546dd41d380bd3c$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $4546dd41d380bd3c$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $4546dd41d380bd3c$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $4546dd41d380bd3c$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $4546dd41d380bd3c$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $4546dd41d380bd3c$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $4546dd41d380bd3c$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $4546dd41d380bd3c$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $4546dd41d380bd3c$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $4546dd41d380bd3c$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $4546dd41d380bd3c$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $4546dd41d380bd3c$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $4546dd41d380bd3c$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $4546dd41d380bd3c$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $4546dd41d380bd3c$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $4546dd41d380bd3c$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $4546dd41d380bd3c$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $4546dd41d380bd3c$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $4546dd41d380bd3c$export$803cd8101b6c182b = /*#__PURE__*/ $4546dd41d380bd3c$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $4546dd41d380bd3c$export$27b07d8a310ed8b5[0], side + "-" + $4546dd41d380bd3c$export$27b07d8a310ed8b5[1]), []);
const $4546dd41d380bd3c$export$96ec731ed4dcb222 = Math.min;
const $4546dd41d380bd3c$export$8960430cfd85939f = Math.max;
const $4546dd41d380bd3c$export$2077e0241d6afd3c = Math.round;
const $4546dd41d380bd3c$export$a3fe094919f356fd = Math.floor;
const $4546dd41d380bd3c$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $4546dd41d380bd3c$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $4546dd41d380bd3c$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $4546dd41d380bd3c$export$7d15b64cf5a3a4c4(start, value, end) {
    return $4546dd41d380bd3c$export$8960430cfd85939f(start, $4546dd41d380bd3c$export$96ec731ed4dcb222(value, end));
}
function $4546dd41d380bd3c$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $4546dd41d380bd3c$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $4546dd41d380bd3c$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $4546dd41d380bd3c$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $4546dd41d380bd3c$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $4546dd41d380bd3c$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($4546dd41d380bd3c$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $4546dd41d380bd3c$export$2b57e0052a6d6d4c(placement) {
    return $4546dd41d380bd3c$export$8a000a963141ac32($4546dd41d380bd3c$export$f28e8f882010718a(placement));
}
function $4546dd41d380bd3c$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $4546dd41d380bd3c$export$f0989780f32bfcda(placement);
    const alignmentAxis = $4546dd41d380bd3c$export$2b57e0052a6d6d4c(placement);
    const length = $4546dd41d380bd3c$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $4546dd41d380bd3c$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $4546dd41d380bd3c$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $4546dd41d380bd3c$export$496432a3699e50b1(placement) {
    const oppositePlacement = $4546dd41d380bd3c$export$9c5e28bad23365fa(placement);
    return [
        $4546dd41d380bd3c$export$2b182c584985588b(placement),
        oppositePlacement,
        $4546dd41d380bd3c$export$2b182c584985588b(oppositePlacement)
    ];
}
function $4546dd41d380bd3c$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$4546dd41d380bd3c$var$oppositeAlignmentMap[alignment]);
}
function $4546dd41d380bd3c$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $4546dd41d380bd3c$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $4546dd41d380bd3c$export$f0989780f32bfcda(placement);
    let list = $4546dd41d380bd3c$var$getSideList($4546dd41d380bd3c$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($4546dd41d380bd3c$export$2b182c584985588b));
    }
    return list;
}
function $4546dd41d380bd3c$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$4546dd41d380bd3c$var$oppositeSideMap[side]);
}
function $4546dd41d380bd3c$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $4546dd41d380bd3c$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $4546dd41d380bd3c$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $4546dd41d380bd3c$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("3rNIs", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $282a7547e1867a69$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $282a7547e1867a69$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $282a7547e1867a69$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $282a7547e1867a69$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $282a7547e1867a69$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $282a7547e1867a69$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $282a7547e1867a69$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $282a7547e1867a69$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $282a7547e1867a69$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $282a7547e1867a69$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $282a7547e1867a69$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $282a7547e1867a69$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $282a7547e1867a69$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $282a7547e1867a69$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $282a7547e1867a69$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $282a7547e1867a69$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $282a7547e1867a69$export$7bf1f8740e3e34af);
function $282a7547e1867a69$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $282a7547e1867a69$export$651544f548703224(node) {
    if ($282a7547e1867a69$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $282a7547e1867a69$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $282a7547e1867a69$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($282a7547e1867a69$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $282a7547e1867a69$export$8ee0fc9ee280b4ee(value) {
    if (!$282a7547e1867a69$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $282a7547e1867a69$export$38b2d434cce3ea22(value).Node;
}
function $282a7547e1867a69$export$45a5e7f76e0caa8d(value) {
    if (!$282a7547e1867a69$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $282a7547e1867a69$export$38b2d434cce3ea22(value).Element;
}
function $282a7547e1867a69$export$1b3bfaa9684536aa(value) {
    if (!$282a7547e1867a69$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $282a7547e1867a69$export$38b2d434cce3ea22(value).HTMLElement;
}
function $282a7547e1867a69$export$af51f0f06c0f328a(value) {
    if (!$282a7547e1867a69$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $282a7547e1867a69$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $282a7547e1867a69$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $282a7547e1867a69$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $282a7547e1867a69$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($282a7547e1867a69$export$651544f548703224(element));
}
function $282a7547e1867a69$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $282a7547e1867a69$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $282a7547e1867a69$export$78551043582a6a98();
    const css = $282a7547e1867a69$export$45a5e7f76e0caa8d(elementOrCss) ? $282a7547e1867a69$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $282a7547e1867a69$export$940d8225183e1404(element) {
    let currentNode = $282a7547e1867a69$export$4e12058fc4d51d56(element);
    while($282a7547e1867a69$export$1b3bfaa9684536aa(currentNode) && !$282a7547e1867a69$export$d1162fb0b6d4cd51(currentNode)){
        if ($282a7547e1867a69$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($282a7547e1867a69$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $282a7547e1867a69$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $282a7547e1867a69$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $282a7547e1867a69$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($282a7547e1867a69$export$651544f548703224(node));
}
function $282a7547e1867a69$export$3735103072e4a80(element) {
    return $282a7547e1867a69$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $282a7547e1867a69$export$dc8fc79fa2800137(element) {
    if ($282a7547e1867a69$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $282a7547e1867a69$export$4e12058fc4d51d56(node) {
    if ($282a7547e1867a69$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $282a7547e1867a69$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $282a7547e1867a69$export$e495491855dc5418(node);
    return $282a7547e1867a69$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $282a7547e1867a69$export$7cd01a57c8ca906c(node) {
    const parentNode = $282a7547e1867a69$export$4e12058fc4d51d56(node);
    if ($282a7547e1867a69$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($282a7547e1867a69$export$1b3bfaa9684536aa(parentNode) && $282a7547e1867a69$export$989e911fa9af580a(parentNode)) return parentNode;
    return $282a7547e1867a69$export$7cd01a57c8ca906c(parentNode);
}
function $282a7547e1867a69$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $282a7547e1867a69$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $282a7547e1867a69$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $282a7547e1867a69$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $282a7547e1867a69$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $282a7547e1867a69$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $282a7547e1867a69$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $282a7547e1867a69$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("dsV8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cda3605df4de535$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var $9cda3605df4de535$export$2e2bcd8739ae039 = (0, $eJOHy.useLayoutEffect);

});


parcelRegister("kBFBH", function(module, exports) {
$parcel$export(module.exports, "multiValueCSS", () => $cd6b12f92fd4b0e5$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $cd6b12f92fd4b0e5$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $cd6b12f92fd4b0e5$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $cd6b12f92fd4b0e5$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $cd6b12f92fd4b0e5$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $cd6b12f92fd4b0e5$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $cd6b12f92fd4b0e5$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $6zhpo = parcelRequire("6zhpo");

var $3VlSK = parcelRequire("3VlSK");

var $gNnQq = parcelRequire("gNnQq");
const $cd6b12f92fd4b0e5$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs17si _1aewe4h9 _6up53acm _1xdnnqa1"
};
const $cd6b12f92fd4b0e5$export$23c213f7717186af = ()=>({});
const $cd6b12f92fd4b0e5$export$f40612612e0af964 = ()=>({});
const $cd6b12f92fd4b0e5$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c82smr _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s"
};
const $cd6b12f92fd4b0e5$export$283467f6c4ac142b = ()=>({});
const $cd6b12f92fd4b0e5$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu1rrc",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1fxt _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr3166n _13br1jjn _1di61dty _i5f81jjn"
};
const $cd6b12f92fd4b0e5$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $cd6b12f92fd4b0e5$var$multiValueStyles.root,
            isDisabled && $cd6b12f92fd4b0e5$var$multiValueStyles.disabled,
            isFocused && $cd6b12f92fd4b0e5$var$multiValueStyles.focused,
            (0, $k0ahr.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};
const $cd6b12f92fd4b0e5$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $cd6b12f92fd4b0e5$var$multiValueLabelStyles.root,
            isDisabled && $cd6b12f92fd4b0e5$var$multiValueLabelStyles.disabled,
            hasEllipsis && $cd6b12f92fd4b0e5$var$multiValueLabelStyles.ellipsis,
            (0, $k0ahr.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
const $cd6b12f92fd4b0e5$var$disabledStyles = null;
const $cd6b12f92fd4b0e5$var$enabledStyles = null;
function $cd6b12f92fd4b0e5$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $cd6b12f92fd4b0e5$var$multiValueRemoveStyles.root,
            isFocused && $cd6b12f92fd4b0e5$var$multiValueRemoveStyles.focused,
            (0, $k0ahr.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $hcewu.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                label: "",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3VlSK))),
                LEGACY_primaryColor: "transparent",
                LEGACY_secondaryColor: "inherit",
                LEGACY_size: "small",
                size: "small"
            })
        })
    });
}
const $cd6b12f92fd4b0e5$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $gNnQq.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $gNnQq.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $gNnQq.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cd6b12f92fd4b0e5$export$2e2bcd8739ae039 = $cd6b12f92fd4b0e5$var$MultiValue;

});

parcelRegister("aO7ic", function(module, exports) {
$parcel$export(module.exports, "optionCSS", () => $67e4a66ca3e8aeec$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $67e4a66ca3e8aeec$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $gNnQq = parcelRequire("gNnQq");
const $67e4a66ca3e8aeec$export$ef897119b7e920ba = ()=>({});
const $67e4a66ca3e8aeec$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk18uv _16qsglyw _1di618uv _112eglyw",
    focused: "_bfhk166n _16qsu4to _112e126o",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _112e126o",
    focusedSelected: "_bfhki1yw"
};
const $67e4a66ca3e8aeec$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $67e4a66ca3e8aeec$var$optionStyles.root,
            isFocused && $67e4a66ca3e8aeec$var$optionStyles.focused,
            isSelected && $67e4a66ca3e8aeec$var$optionStyles.selected,
            isFocused && isSelected && $67e4a66ca3e8aeec$var$optionStyles.focusedSelected,
            isDisabled && $67e4a66ca3e8aeec$var$optionStyles.disabled,
            (0, $k0ahr.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$67e4a66ca3e8aeec$export$2e2bcd8739ae039 = $67e4a66ca3e8aeec$var$Option;

});

parcelRegister("9QHqW", function(module, exports) {
$parcel$export(module.exports, "placeholderCSS", () => $b212de2a71deba63$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $b212de2a71deba63$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $gNnQq = parcelRequire("gNnQq");
const $b212de2a71deba63$export$5f3ffacd6594d90f = ()=>({});
const $b212de2a71deba63$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
const $b212de2a71deba63$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $b212de2a71deba63$var$placeholderStyles.root,
            isDisabled && $b212de2a71deba63$var$placeholderStyles.disabled,
            (0, $k0ahr.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b212de2a71deba63$export$2e2bcd8739ae039 = $b212de2a71deba63$var$Placeholder;

});

parcelRegister("7Q7hB", function(module, exports) {
$parcel$export(module.exports, "css", () => $993cd80f3d8fc888$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $993cd80f3d8fc888$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $gNnQq = parcelRequire("gNnQq");
const $993cd80f3d8fc888$export$dbf350e5966cf602 = ()=>({});
const $993cd80f3d8fc888$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
const $993cd80f3d8fc888$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gNnQq.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $993cd80f3d8fc888$var$styles.root,
            isDisabled && $993cd80f3d8fc888$var$styles.disalbed,
            (0, $k0ahr.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$993cd80f3d8fc888$export$2e2bcd8739ae039 = $993cd80f3d8fc888$var$SingleValue;

});


parcelRegister("c4OV1", function(module, exports) {
$parcel$export(module.exports, "SelectWithoutAnalytics", () => $7577f3081e58df58$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $7577f3081e58df58$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $g6uAx = parcelRequire("g6uAx");

var $dDv66 = parcelRequire("dDv66");
const $7577f3081e58df58$var$packageName = "platform-pkg";
const $7577f3081e58df58$var$packageVersion = "0.0.0-use.local";
const $7577f3081e58df58$export$d1de3b251ccaa8a3 = (0, $dDv66.default)((0, $g6uAx.default));
const $7577f3081e58df58$var$createAndFireEventOnAtlaskit = (0, $5fWw9.default)('atlaskit');
const $7577f3081e58df58$var$Select = (0, $dUaMU.default)({
    componentName: 'select',
    packageName: $7577f3081e58df58$var$packageName,
    packageVersion: $7577f3081e58df58$var$packageVersion
})((0, $4J0ad.default)({
    onChange: $7577f3081e58df58$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $7577f3081e58df58$var$packageName,
            packageVersion: $7577f3081e58df58$var$packageVersion
        }
    })
})($7577f3081e58df58$export$d1de3b251ccaa8a3));
var $7577f3081e58df58$export$2e2bcd8739ae039 = $7577f3081e58df58$var$Select;

});
parcelRegister("g6uAx", function(module, exports) {
$parcel$export(module.exports, "default", () => $0abf8e2d7b20b35c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("iSKoM")).default);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $iSKoM = parcelRequire("iSKoM");

var $gVVTN = parcelRequire("gVVTN");
const $0abf8e2d7b20b35c$var$AsyncSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $iSKoM.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $gVVTN.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0abf8e2d7b20b35c$export$2e2bcd8739ae039 = $0abf8e2d7b20b35c$var$AsyncSelect;

});
parcelRegister("5tlgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $b147d4bc05a70c9e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8ffYo = parcelRequire("8ffYo");

var $eGOwo = parcelRequire("eGOwo");

var $20dEN = parcelRequire("20dEN");

var $6XEne = parcelRequire("6XEne");

var $eVdYS = parcelRequire("eVdYS");
var $79ZRb = parcelRequire("79ZRb");
var $dRFyw = parcelRequire("dRFyw");

var $3XpWL = parcelRequire("3XpWL");

var $cKRwz = parcelRequire("cKRwz");

var $lVGx8 = parcelRequire("lVGx8");

var $1beam = parcelRequire("1beam");

var $e9zKl = parcelRequire("e9zKl");

var $gNnQq = parcelRequire("gNnQq");
const $b147d4bc05a70c9e$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $gNnQq.isTouchCapable)(),
    captureMenuScroll: !(0, $gNnQq.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $1beam.createFilter)(),
    formatGroupLabel: (0, $20dEN.formatGroupLabel),
    getOptionLabel: (0, $20dEN.getOptionLabel),
    getOptionValue: (0, $20dEN.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $20dEN.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $gNnQq.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $b147d4bc05a70c9e$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $b147d4bc05a70c9e$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $b147d4bc05a70c9e$var$isOptionSelected(props, option, selectValue);
    const label = $b147d4bc05a70c9e$var$getOptionLabel(props, option);
    const value = $b147d4bc05a70c9e$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $b147d4bc05a70c9e$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$b147d4bc05a70c9e$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$b147d4bc05a70c9e$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $b147d4bc05a70c9e$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $b147d4bc05a70c9e$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $gNnQq.notNullish));
}
function $b147d4bc05a70c9e$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $b147d4bc05a70c9e$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $b147d4bc05a70c9e$var$buildFocusableOptions(props, selectValue) {
    return $b147d4bc05a70c9e$var$buildFocusableOptionsFromCategorizedOptions($b147d4bc05a70c9e$var$buildCategorizedOptions(props, selectValue));
}
function $b147d4bc05a70c9e$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$b147d4bc05a70c9e$var$shouldHideSelectedOptions(props) || !isSelected) && $b147d4bc05a70c9e$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $b147d4bc05a70c9e$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $b147d4bc05a70c9e$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $b147d4bc05a70c9e$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $b147d4bc05a70c9e$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $b147d4bc05a70c9e$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $b147d4bc05a70c9e$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $b147d4bc05a70c9e$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $b147d4bc05a70c9e$var$getOptionValue(props, option);
    return selectValue.some((i)=>$b147d4bc05a70c9e$var$getOptionValue(props, i) === candidate);
}
function $b147d4bc05a70c9e$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $b147d4bc05a70c9e$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $b147d4bc05a70c9e$var$instanceId = 1;
class $b147d4bc05a70c9e$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $b147d4bc05a70c9e$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue, shouldKeepInputOnSelect: shouldKeepInputOnSelect } = this.props;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $eGOwo.fg)('platform_do_not_clear_input_for_multiselect')) this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $gNnQq.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $gNnQq.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $gNnQq.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $gNnQq.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $gNnQq.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $gNnQq.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $gNnQq.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $b147d4bc05a70c9e$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $b147d4bc05a70c9e$var$buildFocusableOptionsWithIds($b147d4bc05a70c9e$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $gNnQq.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $b147d4bc05a70c9e$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $b147d4bc05a70c9e$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $e9zKl.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            if (!custom) return base;
            const customStyles = (0, $gNnQq.filterUnsupportedSelectors)(custom(base, props));
            return customStyles;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $6XEne.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$b147d4bc05a70c9e$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$b147d4bc05a70c9e$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $gNnQq.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $eGOwo.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $b147d4bc05a70c9e$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$b147d4bc05a70c9e$var$instanceId);
        this.state.selectValue = (0, $gNnQq.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $b147d4bc05a70c9e$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $gNnQq.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $b147d4bc05a70c9e$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $b147d4bc05a70c9e$var$buildFocusableOptionsWithIds($b147d4bc05a70c9e$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $b147d4bc05a70c9e$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $b147d4bc05a70c9e$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $b147d4bc05a70c9e$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $gNnQq.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $gNnQq.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $gNnQq.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $8ffYo.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $b147d4bc05a70c9e$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $b147d4bc05a70c9e$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $b147d4bc05a70c9e$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription()
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eVdYS.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $gNnQq.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $eJOHy.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $eJOHy.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $gt9Am.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value')
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $eJOHy.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $eJOHy.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $gt9Am.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $gt9Am.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lVGx8.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $gt9Am.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dRFyw.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $gt9Am.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $8ffYo.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $gt9Am.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $79ZRb.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cKRwz.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $gt9Am.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $gt9Am.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $8ffYo.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3XpWL.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("20dEN", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", () => $466f15fb39ddf79d$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $466f15fb39ddf79d$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $466f15fb39ddf79d$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $466f15fb39ddf79d$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $466f15fb39ddf79d$export$f4da216a6ca54656 = (group)=>group.label;
const $466f15fb39ddf79d$export$dac6ace3020563ca = (option)=>option.label;
const $466f15fb39ddf79d$export$40be908210c5a79c = (option)=>option.value;
const $466f15fb39ddf79d$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("eVdYS", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e05b0ed818392e5$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gNnQq = parcelRequire("gNnQq");
const $0e05b0ed818392e5$var$dummyInputStyles = null;
function $0e05b0ed818392e5$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gNnQq.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        ref: innerRef,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("79ZRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $f722501ee257102a$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Vuhz = parcelRequire("3Vuhz");
const $f722501ee257102a$var$styles = null;
const $f722501ee257102a$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $3Vuhz.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f722501ee257102a$export$2e2bcd8739ae039 = $f722501ee257102a$var$RequiredInput;

});

parcelRegister("dRFyw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a417b52227e85a7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jfLOF = parcelRequire("jfLOF");

var $8cFGn = parcelRequire("8cFGn");
const $0a417b52227e85a7$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $0a417b52227e85a7$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $jfLOF.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $8cFGn.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                onClick: $0a417b52227e85a7$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("jfLOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $20ede4f451d080e4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gNnQq = parcelRequire("gNnQq");
const $20ede4f451d080e4$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $20ede4f451d080e4$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $eJOHy.useRef)(false);
    const isTop = (0, $eJOHy.useRef)(false);
    const touchStart = (0, $eJOHy.useRef)(0);
    const scrollTarget = (0, $eJOHy.useRef)(null);
    const handleEventDelta = (0, $eJOHy.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $20ede4f451d080e4$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $eJOHy.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $eJOHy.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $eJOHy.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $eJOHy.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $gNnQq.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $eJOHy.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("8cFGn", function(module, exports) {
$parcel$export(module.exports, "default", () => $f15b4234d1b0a1bb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $f15b4234d1b0a1bb$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $f15b4234d1b0a1bb$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $f15b4234d1b0a1bb$var$preventTouchMove(e) {
    e.preventDefault();
}
function $f15b4234d1b0a1bb$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $f15b4234d1b0a1bb$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $f15b4234d1b0a1bb$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $f15b4234d1b0a1bb$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $f15b4234d1b0a1bb$var$activeScrollLocks = 0;
const $f15b4234d1b0a1bb$var$listenerOptions = {
    capture: false,
    passive: false
};
function $f15b4234d1b0a1bb$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $eJOHy.useRef)({});
    const scrollTarget = (0, $eJOHy.useRef)(null);
    const addScrollLock = (0, $eJOHy.useCallback)((touchScrollTarget)=>{
        if (!$f15b4234d1b0a1bb$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $f15b4234d1b0a1bb$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $f15b4234d1b0a1bb$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($f15b4234d1b0a1bb$var$LOCK_STYLES).forEach((key)=>{
                const val = $f15b4234d1b0a1bb$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $f15b4234d1b0a1bb$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $f15b4234d1b0a1bb$var$preventTouchMove, $f15b4234d1b0a1bb$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $f15b4234d1b0a1bb$var$preventInertiaScroll, $f15b4234d1b0a1bb$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $f15b4234d1b0a1bb$var$allowTouchMove, $f15b4234d1b0a1bb$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $f15b4234d1b0a1bb$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $eJOHy.useCallback)((touchScrollTarget)=>{
        if (!$f15b4234d1b0a1bb$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $f15b4234d1b0a1bb$var$activeScrollLocks = Math.max($f15b4234d1b0a1bb$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $f15b4234d1b0a1bb$var$activeScrollLocks < 1) $f15b4234d1b0a1bb$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $f15b4234d1b0a1bb$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $f15b4234d1b0a1bb$var$preventTouchMove, $f15b4234d1b0a1bb$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $f15b4234d1b0a1bb$var$preventInertiaScroll, $f15b4234d1b0a1bb$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $f15b4234d1b0a1bb$var$allowTouchMove, $f15b4234d1b0a1bb$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("3XpWL", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $0f172fbeaef6b8c4$export$17baa7c95b6ba1b8);

var $5NYi5 = parcelRequire("5NYi5");
function $0f172fbeaef6b8c4$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $5NYi5.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("cKRwz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1da24b5dd31b6c94$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $c06lf = parcelRequire("c06lf");

var $bVz7n = parcelRequire("bVz7n");
const $1da24b5dd31b6c94$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $eJOHy.useMemo)(()=>({
            ...(0, $c06lf.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $eJOHy.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $eJOHy.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bVz7n.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bVz7n.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1da24b5dd31b6c94$export$2e2bcd8739ae039 = $1da24b5dd31b6c94$var$LiveRegion;

});
parcelRegister("c06lf", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", () => $1652ef7826a28101$export$a7265767c78f9bae);
const $1652ef7826a28101$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("bVz7n", function(module, exports) {
$parcel$export(module.exports, "default", () => $396b506ff0669304$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $396b506ff0669304$var$styles = null;
const $396b506ff0669304$var$A11yText = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $396b506ff0669304$export$2e2bcd8739ae039 = $396b506ff0669304$var$A11yText;

});


parcelRegister("1beam", function(module, exports) {
$parcel$export(module.exports, "createFilter", () => $b346b6b9c618259d$export$5d81789ff4aeccdf);

var $LFmXM = parcelRequire("LFmXM");

var $3hTsG = parcelRequire("3hTsG");
const $b346b6b9c618259d$var$memoizedStripDiacriticsForInput = (0, $LFmXM.default)((0, $3hTsG.stripDiacritics));
const $b346b6b9c618259d$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $b346b6b9c618259d$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $b346b6b9c618259d$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $b346b6b9c618259d$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $b346b6b9c618259d$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $b346b6b9c618259d$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $b346b6b9c618259d$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $3hTsG.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("3hTsG", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", () => $26e1e0a9ad646bef$export$b5bee4b27048330b);
const $26e1e0a9ad646bef$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $26e1e0a9ad646bef$var$anyDiacritic = new RegExp('[' + $26e1e0a9ad646bef$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $26e1e0a9ad646bef$var$diacriticToBase = {};
for(let i = 0; i < $26e1e0a9ad646bef$var$diacritics.length; i++){
    let diacritic = $26e1e0a9ad646bef$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$26e1e0a9ad646bef$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $26e1e0a9ad646bef$export$b5bee4b27048330b = (str)=>{
    return str.replace($26e1e0a9ad646bef$var$anyDiacritic, (match)=>$26e1e0a9ad646bef$var$diacriticToBase[match]);
};

});


parcelRegister("e9zKl", function(module, exports) {
$parcel$export(module.exports, "defaultStyles", () => $b6982313dc69f632$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $b6982313dc69f632$export$e618dc39ac9ad607);

var $b9w97 = parcelRequire("b9w97");

var $5g4w5 = parcelRequire("5g4w5");

var $hZvJb = parcelRequire("hZvJb");

var $gbM8i = parcelRequire("gbM8i");

var $lnZHc = parcelRequire("lnZHc");

var $lVGx8 = parcelRequire("lVGx8");

var $kBFBH = parcelRequire("kBFBH");

var $aO7ic = parcelRequire("aO7ic");

var $9QHqW = parcelRequire("9QHqW");

var $7Q7hB = parcelRequire("7Q7hB");
const $b6982313dc69f632$export$214b055320e0bf32 = {
    clearIndicator: (0, $gbM8i.clearIndicatorCSS),
    container: (0, $b9w97.containerCSS),
    control: (0, $5g4w5.css),
    dropdownIndicator: (0, $gbM8i.dropdownIndicatorCSS),
    group: (0, $hZvJb.groupCSS),
    groupHeading: (0, $hZvJb.groupHeadingCSS),
    indicatorsContainer: (0, $b9w97.indicatorsContainerCSS),
    input: (0, $lnZHc.inputCSS),
    loadingIndicator: (0, $gbM8i.loadingIndicatorCSS),
    loadingMessage: (0, $lVGx8.loadingMessageCSS),
    menu: (0, $lVGx8.menuCSS),
    menuList: (0, $lVGx8.menuListCSS),
    menuPortal: (0, $lVGx8.menuPortalCSS),
    multiValue: (0, $kBFBH.multiValueCSS),
    multiValueLabel: (0, $kBFBH.multiValueLabelCSS),
    multiValueRemove: (0, $kBFBH.multiValueRemoveCSS),
    noOptionsMessage: (0, $lVGx8.noOptionsMessageCSS),
    option: (0, $aO7ic.optionCSS),
    placeholder: (0, $9QHqW.placeholderCSS),
    singleValue: (0, $7Q7hB.css),
    valueContainer: (0, $b9w97.valueContainerCSS)
};
function $b6982313dc69f632$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("iSKoM", function(module, exports) {
$parcel$export(module.exports, "default", () => $75c9de820b48c734$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gNnQq = parcelRequire("gNnQq");
function $75c9de820b48c734$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $eJOHy.useRef)(undefined);
    const mounted = (0, $eJOHy.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eJOHy.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $eJOHy.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $eJOHy.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $eJOHy.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $eJOHy.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $eJOHy.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $eJOHy.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $eJOHy.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eJOHy.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $eJOHy.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $gNnQq.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("gVVTN", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1c43429a42bb033$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $f1c43429a42bb033$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $eJOHy.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $eJOHy.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $eJOHy.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $eJOHy.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $eJOHy.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $eJOHy.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $eJOHy.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("dDv66", function(module, exports) {
$parcel$export(module.exports, "default", () => $32bfd0ef6040e92a$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $32bfd0ef6040e92a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eJOHy.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eJOHy.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});


parcelRegister("f5dwt", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ac00be16f50b3ce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6S4l2 = parcelRequire("6S4l2");
class $4ac00be16f50b3ce$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args), this.setRef = (ref)=>{
            this.ref = ref;
        }, this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});
parcelRegister("6S4l2", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});


parcelRegister("8EXfh", function(module, exports) {
$parcel$export(module.exports, "default", () => $6929e4f8ce96994e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6929e4f8ce96994e$var$messages = (0, $7qGN1.defineMessages)({
    selectPlaceholder: {
        "id": "software-board-create.modal.form.source-type-picker.select-placeholder",
        "defaultMessage": "Select"
    },
    sourceTypeFieldLabel: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-field-label",
        "defaultMessage": "Choose what to include in this board"
    },
    teamTitle: {
        "id": "software-board-create.modal.form.source-type-picker.team-title",
        "defaultMessage": "Team"
    },
    teamSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.team-selected-title",
        "defaultMessage": "Issues based on <strong>Team</strong>"
    },
    teamDescription: {
        "id": "software-board-create.modal.form.source-type-picker.team-description",
        "defaultMessage": "Show all issues assigned to a team"
    },
    issueTypesTitle: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-title",
        "defaultMessage": "Issue type"
    },
    issueTypesSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-selected-title",
        "defaultMessage": "Issues based on <strong>Issue type</strong>"
    },
    issueTypesDescription: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-description",
        "defaultMessage": "Show all issues associated with an issue type"
    },
    labelsTitle: {
        "id": "software-board-create.modal.form.source-type-picker.labels-title",
        "defaultMessage": "Label"
    },
    labelsSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.labels-selected-title",
        "defaultMessage": "Issues based on <strong>Label</strong>"
    },
    labelsDescription: {
        "id": "software-board-create.modal.form.source-type-picker.labels-description",
        "defaultMessage": "Show all issues tagged with a specific label"
    },
    allIssuesFromProjectTitle: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title",
        "defaultMessage": "All issues from your project"
    },
    allIssuesFromProjectSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title",
        "defaultMessage": "Issues based on <strong>All issues from your project</strong>"
    },
    savedFilterTitle: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-title",
        "defaultMessage": "Advanced"
    },
    savedFilterSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-selected-title",
        "defaultMessage": "Issues based on a <strong>Saved filter</strong>"
    },
    savedFilterDescription: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-description",
        "defaultMessage": "Show issues from a saved JQL filter"
    },
    sourceTypePickerAriaLabel: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-picker-aria-label",
        "defaultMessage": "Select what to include in this board"
    },
    sourceTypeEmptyError: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-empty-error",
        "defaultMessage": "Select what to include in this board"
    },
    teamSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.team-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>Team</strong>"
    },
    teamDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.team-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items assigned to a team"
    },
    issueTypesTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    },
    issueTypesSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>work type</strong>"
    },
    issueTypesDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items associated with a work type"
    },
    labelsSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.labels-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>label</strong>"
    },
    labelsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.labels-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items tagged with a specific label"
    },
    allIssuesFromProjectTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4",
        "defaultMessage": "All work items from your project"
    },
    allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>All work items from your project</strong>"
    },
    savedFilterSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on a <strong>Saved filter</strong>"
    },
    savedFilterDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show work items from a saved JQL filter"
    },
    allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4-galaxia",
        "defaultMessage": "All work items from your space"
    },
    allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4-galaxia",
        "defaultMessage": "Work items based on <strong>All work items from your space</strong>"
    }
});
var $6929e4f8ce96994e$export$2e2bcd8739ae039 = $6929e4f8ce96994e$var$messages;

});

parcelRegister("2WGTE", function(module, exports) {
$parcel$export(module.exports, "getOptionGroups", () => $caceeacc3effebad$export$eec1253b95a159cc);

var $KDB2z = parcelRequire("KDB2z");

var $9AYOJ = parcelRequire("9AYOJ");

var $787ZT = parcelRequire("787ZT");

var $eALjj = parcelRequire("eALjj");

var $lmJ87 = parcelRequire("lmJ87");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $2pys5 = parcelRequire("2pys5");

var $8EXfh = parcelRequire("8EXfh");
const $caceeacc3effebad$export$eec1253b95a159cc = ({ formatMessage: formatMessage, projectAvatar: projectAvatar })=>{
    const allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Replacement = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8EXfh.default).allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia : (0, $8EXfh.default).allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4;
    const allIssuesFromProjectTitleIssueTerminologyRefreshM4Replacement = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8EXfh.default).allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia : (0, $8EXfh.default).allIssuesFromProjectTitleIssueTerminologyRefreshM4;
    const allIssuesFromProjectTitleMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? allIssuesFromProjectTitleIssueTerminologyRefreshM4Replacement : (0, $8EXfh.default).allIssuesFromProjectTitle;
    const allIssuesFromProjectSelectedTitleMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Replacement : (0, $8EXfh.default).allIssuesFromProjectSelectedTitle;
    const teamSelectedTitleMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).teamSelectedTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).teamSelectedTitle;
    const teamDescriptionMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).teamDescriptionIssueTerminologyRefreshM4 : (0, $8EXfh.default).teamDescription;
    const issueTypesTitleMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).issueTypesTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).issueTypesTitle;
    const issueTypesSelectedTitleMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).issueTypesSelectedTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).issueTypesSelectedTitle;
    const issueTypesDescriptionMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).issueTypesDescriptionIssueTerminologyRefreshM4 : (0, $8EXfh.default).issueTypesDescription;
    const labelsSelectedTitleMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).labelsSelectedTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).labelsSelectedTitle;
    const labelsDescriptionMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).labelsDescriptionIssueTerminologyRefreshM4 : (0, $8EXfh.default).labelsDescription;
    const savedFilterSelectedTitleMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).savedFilterSelectedTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).savedFilterSelectedTitle;
    const savedFilterDescriptionMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).savedFilterDescriptionIssueTerminologyRefreshM4 : (0, $8EXfh.default).savedFilterDescription;
    return [
        {
            options: [
                {
                    label: formatMessage(allIssuesFromProjectTitleMessage),
                    title: formatMessage(allIssuesFromProjectTitleMessage),
                    selectedTitle: allIssuesFromProjectSelectedTitleMessage,
                    value: null,
                    icon: projectAvatar || (0, (/*@__PURE__*/$parcel$interopDefault($lmJ87)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage((0, $8EXfh.default).teamTitle),
                    title: formatMessage((0, $8EXfh.default).teamTitle),
                    selectedTitle: teamSelectedTitleMessage,
                    description: formatMessage(teamDescriptionMessage),
                    value: (0, $2pys5.BOARD_SOURCE_FIELDS).TEAM,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)))
                },
                {
                    label: formatMessage(issueTypesTitleMessage),
                    title: formatMessage(issueTypesTitleMessage),
                    selectedTitle: issueTypesSelectedTitleMessage,
                    description: formatMessage(issueTypesDescriptionMessage),
                    value: (0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ)))
                },
                {
                    label: formatMessage((0, $8EXfh.default).labelsTitle),
                    title: formatMessage((0, $8EXfh.default).labelsTitle),
                    selectedTitle: labelsSelectedTitleMessage,
                    description: formatMessage(labelsDescriptionMessage),
                    value: (0, $2pys5.BOARD_SOURCE_FIELDS).LABELS,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($787ZT)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage((0, $8EXfh.default).savedFilterTitle),
                    title: formatMessage((0, $8EXfh.default).savedFilterTitle),
                    selectedTitle: savedFilterSelectedTitleMessage,
                    description: formatMessage(savedFilterDescriptionMessage),
                    value: (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z)))
                }
            ]
        }
    ];
};

});
parcelRegister("9AYOJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eef8c7bda009f013e8cf54eb12259e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fc6a6e7024121bf$var$_react = $6fc6a6e7024121bf$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6fc6a6e7024121bf$var$_baseNew = $6fc6a6e7024121bf$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6fc6a6e7024121bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fc6a6e7024121bf$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $6fc6a6e7024121bf$var$_react.default.createElement($6fc6a6e7024121bf$var$_baseNew.default, Object.assign({
        name: "WorkItemsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$6fc6a6e7024121bf$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $6fc6a6e7024121bf$var$_default = module.exports.default = $6fc6a6e7024121bf$var$WorkItemsIcon;

});

parcelRegister("787ZT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd85a061670900bca44ad5d1568ae5ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $530f7bdea5458957$var$_react = $530f7bdea5458957$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $530f7bdea5458957$var$_baseNew = $530f7bdea5458957$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $530f7bdea5458957$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $530f7bdea5458957$var$TagIcon = (props)=>/*#__PURE__*/ $530f7bdea5458957$var$_react.default.createElement($530f7bdea5458957$var$_baseNew.default, Object.assign({
        name: "TagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$530f7bdea5458957$var$TagIcon.displayName = 'TagIcon';
var $530f7bdea5458957$var$_default = module.exports.default = $530f7bdea5458957$var$TagIcon;

});



parcelRegister("bpQ9z", function(module, exports) {
$parcel$export(module.exports, "SOURCE_VALUE_FIELD_NAME", () => $58dade0b85ab53a7$export$2acdb7270c211b02);
$parcel$export(module.exports, "SourceValuePicker", () => $58dade0b85ab53a7$export$427e84d70337182b);

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");
var $byJNH = parcelRequire("byJNH");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $gHO4S = parcelRequire("gHO4S");

var $ajbQE = parcelRequire("ajbQE");

var $gHRV5 = parcelRequire("gHRV5");
const $58dade0b85ab53a7$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $58dade0b85ab53a7$export$2acdb7270c211b02 = 'sourceValue';
const $58dade0b85ab53a7$export$427e84d70337182b = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formState = (0, $byJNH.useFormState)();
    const sourceType = formState?.values.sourceType;
    if (!sourceType) return null;
    const boardSource = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $gHRV5.boardSourceFieldComponentMap) : (0, $gHRV5.boardSourceFieldComponentMapOld);
    const mappedSource = boardSource[sourceType];
    if (!mappedSource) {
        (0, $gHO4S.fireBoardCreateErrorAnalytics)({
            error: new Error(`No source field component found for ${sourceType}`),
            id: 'unmappedSourceType'
        });
        return null;
    }
    const { component: PickerComponent, extraProps: extraProps, label: label } = mappedSource;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        key: `sourceValue-${sourceType}`,
        name: $58dade0b85ab53a7$export$2acdb7270c211b02,
        label: formatMessage(label),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PickerComponent, {
            key: `sourceValue-${sourceType}-picker`,
            label: formatMessage(label),
            ...fieldProps,
            ...extraProps
        }), error === $58dade0b85ab53a7$export$7b060a5763a6e199 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-value-picker.error"
        }, formatMessage((0, $ajbQE.default).sourceValueEmptyError))));
};

});
parcelRegister("ajbQE", function(module, exports) {
$parcel$export(module.exports, "default", () => $fab6ecb2cf3f7acb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fab6ecb2cf3f7acb$var$messages = (0, $7qGN1.defineMessages)({
    issueTypeFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.issue-type-field-label",
        "defaultMessage": "Issue type"
    },
    teamFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.team-field-label",
        "defaultMessage": "Team"
    },
    labelsFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.labels-field-label",
        "defaultMessage": "Label"
    },
    savedFilterLabel: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-label",
        "defaultMessage": "Select a saved filter"
    },
    sourceValueEmptyError: {
        "id": "software-board-create.modal.form.source-value-picker.source-value-empty-error",
        "defaultMessage": "Please select a value"
    },
    issueTypeFieldLabelIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-value-picker.issue-type-field-label-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});
var $fab6ecb2cf3f7acb$export$2e2bcd8739ae039 = $fab6ecb2cf3f7acb$var$messages;

});

parcelRegister("gHRV5", function(module, exports) {
$parcel$export(module.exports, "boardSourceFieldComponentMap", () => $5a412a9801090202$export$69996e7483e1a92f);
$parcel$export(module.exports, "boardSourceFieldComponentMapOld", () => $5a412a9801090202$export$c6355b6dd89ea597);

var $2pys5 = parcelRequire("2pys5");

var $kvpRX = parcelRequire("kvpRX");

var $ajbQE = parcelRequire("ajbQE");

var $68asf = parcelRequire("68asf");

var $kfYKF = parcelRequire("kfYKF");
const $5a412a9801090202$export$69996e7483e1a92f = {
    [(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $kvpRX.GenericPicker),
        label: (0, $ajbQE.default).issueTypeFieldLabelIssueTerminologyRefreshM4,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $kfYKF.TeamPicker),
        label: (0, $ajbQE.default).teamFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $kvpRX.GenericPicker),
        label: (0, $ajbQE.default).labelsFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $68asf.SavedFilterPicker),
        label: (0, $ajbQE.default).savedFilterLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};
const $5a412a9801090202$export$c6355b6dd89ea597 = {
    [(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $kvpRX.GenericPicker),
        label: (0, $ajbQE.default).issueTypeFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $kfYKF.TeamPicker),
        label: (0, $ajbQE.default).teamFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $kvpRX.GenericPicker),
        label: (0, $ajbQE.default).labelsFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $68asf.SavedFilterPicker),
        label: (0, $ajbQE.default).savedFilterLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};

});
parcelRegister("kvpRX", function(module, exports) {
$parcel$export(module.exports, "GenericPicker", () => $8d19e9ecef07e669$export$37d6fee5be00e6be);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $5DgXR = parcelRequire("5DgXR");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $gWITR = parcelRequire("gWITR");

var $f5dwt = parcelRequire("f5dwt");

var $lRq8t = parcelRequire("lRq8t");

var $2pys5 = parcelRequire("2pys5");

var $7Clq0 = parcelRequire("7Clq0");

var $huR0u = parcelRequire("huR0u");
const $8d19e9ecef07e669$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center"
    }, option.avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $8d19e9ecef07e669$var$imgStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: option.avatar,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8d19e9ecef07e669$var$optionStyles
    }, option.label));
const $8d19e9ecef07e669$export$37d6fee5be00e6be = ({ onChange: onChange, value: value, jqlTerm: jqlTerm, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $7Clq0.useLoadOptionsController)();
    const [defaultOptions, setDefaultOptions] = (0, $eJOHy.useState)();
    const [menuIsOpen, setMenuIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        loadOptions(jqlTerm)('').then((options)=>setDefaultOptions(options));
    }, [
        jqlTerm,
        loadOptions
    ]);
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((searchString, callback)=>loadOptions(jqlTerm)(searchString).then((options)=>callback(options)), (0, $2pys5.PICKER_SEARCH_DEBOUNCE_TIME));
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (!menuIsOpen && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) setMenuIsOpen(true);
        // close the menu when focusing on multi value to prevent enter key from propagating
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') setMenuIsOpen(false);
        // prevent form submission error
        if (event.key === 'Enter' && !menuIsOpen) event.preventDefault();
    }, [
        menuIsOpen
    ]);
    return /* Prevent ESC press on Select bubbling up to the modal */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWITR.default), {
        "aria-label": label,
        isMulti: true,
        isLoading: isLoading,
        formatOptionLabel: $8d19e9ecef07e669$var$formatOptionLabel,
        defaultOptions: defaultOptions,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage((0, $huR0u.default).genericPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid,
        onFocus: ()=>setMenuIsOpen(true),
        onBlur: ()=>setMenuIsOpen(false),
        menuIsOpen: menuIsOpen,
        blurInputOnSelect: false,
        onKeyDown: handleOnKeyDown
    }));
};
const $8d19e9ecef07e669$var$imgStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.100'
});
const $8d19e9ecef07e669$var$optionStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("gWITR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c00970193ac2e0bb$export$2e2bcd8739ae039);

var $g6uAx = parcelRequire("g6uAx");

var $dDv66 = parcelRequire("dDv66");
const $c00970193ac2e0bb$var$AsyncSelect = (0, $dDv66.default)((0, $g6uAx.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c00970193ac2e0bb$export$2e2bcd8739ae039 = $c00970193ac2e0bb$var$AsyncSelect;

});

parcelRegister("7Clq0", function(module, exports) {
$parcel$export(module.exports, "useLoadOptionsController", () => $32f9bdcaef059b2a$export$50422aa3bb02e176);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2pys5 = parcelRequire("2pys5");

var $gHO4S = parcelRequire("gHO4S");

var $dCPq9 = parcelRequire("dCPq9");

var $iunk7 = parcelRequire("iunk7");

var $3P2eB = parcelRequire("3P2eB");

var $eUw8F = parcelRequire("eUw8F");
const $32f9bdcaef059b2a$var$errorMessageMapOld = {
    [(0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: (0, $eUw8F.default).failedToLoadIssueTypesTitle,
        description: (0, $eUw8F.default).failedToLoadIssueTypesDescription
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: (0, $eUw8F.default).failedToLoadLabelsTitle,
        description: (0, $eUw8F.default).failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: (0, $eUw8F.default).failedToLoadOptionsTitle,
        description: (0, $eUw8F.default).failedToLoadOptionsTitle
    }
};
const $32f9bdcaef059b2a$var$errorMessageMap = {
    [(0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: (0, $eUw8F.default).failedToLoadIssueTypesTitleIssueTerminologyRefreshM4,
        description: (0, $eUw8F.default).failedToLoadIssueTypesDescription
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: (0, $eUw8F.default).failedToLoadLabelsTitle,
        description: (0, $eUw8F.default).failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: (0, $eUw8F.default).failedToLoadOptionsTitle,
        description: (0, $eUw8F.default).failedToLoadOptionsTitle
    }
};
const $32f9bdcaef059b2a$export$4dface15d86304a4 = ()=>(0, $eJOHy.useState)(false);
const $32f9bdcaef059b2a$export$50422aa3bb02e176 = ()=>{
    const { projectId: projectId } = (0, $iunk7.useBoardCreateContext)();
    const jqlBuilderFetch = (0, $dCPq9.useJQLBuilderFetch)({
        projectId: projectId
    });
    const [isLoading, setIsLoading] = $32f9bdcaef059b2a$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $3P2eB.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadOptions = (0, $eJOHy.useCallback)((jqlTerm)=>async (searchString)=>{
            setIsLoading(true);
            const errorMessages = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? $32f9bdcaef059b2a$var$errorMessageMap : $32f9bdcaef059b2a$var$errorMessageMapOld;
            return jqlBuilderFetch(jqlTerm, searchString).catch((error)=>{
                const errorText = errorMessages[jqlTerm] || errorMessages.DEFAULT;
                showErrorFlag({
                    title: formatMessage(errorText.title),
                    description: formatMessage(errorText.description)
                });
                (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                    error: new Error(`Failed to fetch picker options: ${error}`),
                    attributes: {
                        jqlTerm: jqlTerm
                    },
                    id: 'fetchPickerOptions'
                });
                return [];
            }).finally(()=>{
                setIsLoading(false);
            });
        }, [
        formatMessage,
        jqlBuilderFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("dCPq9", function(module, exports) {
$parcel$export(module.exports, "useJQLBuilderFetch", () => $93ff7cde30d073c9$export$a8efb2384cee4751);

var $7Ontj = parcelRequire("7Ontj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cHtIB = parcelRequire("cHtIB");
const $93ff7cde30d073c9$export$a8efb2384cee4751 = ({ projectId: projectId })=>{
    if (projectId === undefined) throw new Error('Project ID is undefined');
    const cloudId = (0, $cHtIB.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)(async (jqlTerm, searchString)=>(0, $j4oe4.fetchQuery)(environment, (0, $7Ontj.default), {
            cloudId: cloudId,
            jqlTerm: jqlTerm,
            jql: `project = ${projectId}`,
            searchString: searchString
        }).toPromise().then((response)=>{
            if (response?.jira?.jqlBuilder?.fieldValues?.edges) {
                const data = response.jira.jqlBuilder.fieldValues.edges.map((edge)=>{
                    if (jqlTerm === 'type') return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.issueTypes && edge?.node?.issueTypes[0]?.issueTypeId || '',
                        avatar: edge?.node?.issueTypes && edge?.node?.issueTypes[0].avatar?.small || ''
                    };
                    return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.displayName || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        }), [
        cloudId,
        environment,
        projectId
    ]);
};

});
parcelRegister("7Ontj", function(module, exports) {
$parcel$export(module.exports, "default", () => $4930c793f6c89516$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<88e6b74d9cd0f6199e352d7287cdc139>>
 * @relayHash 550be86a84988bdbd21f24b80ceb24b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60
const $4930c793f6c89516$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "JiraJqlLabelFieldValue"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useJqlBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useJqlBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60",
            "metadata": {},
            "name": "useJqlBuilderFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4930c793f6c89516$var$node.hash = "f9c373fe0144a8b52692f108c8ed6461";
var $4930c793f6c89516$export$2e2bcd8739ae039 = $4930c793f6c89516$var$node;

});


parcelRegister("eUw8F", function(module, exports) {
$parcel$export(module.exports, "default", () => $32ef22841ea31b57$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $32ef22841ea31b57$var$messages = (0, $7qGN1.defineMessages)({
    failedToLoadIssueTypesTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title",
        "defaultMessage": "We can\u2019t load issue types right now"
    },
    failedToLoadIssueTypesDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadLabelsTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-title",
        "defaultMessage": "We can\u2019t load labels right now"
    },
    failedToLoadLabelsDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadOptionsTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-title",
        "defaultMessage": "Something went wrong"
    },
    failedToLoadOptionsDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadIssueTypesTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t load work types right now"
    }
});
var $32ef22841ea31b57$export$2e2bcd8739ae039 = $32ef22841ea31b57$var$messages;

});


parcelRegister("huR0u", function(module, exports) {
$parcel$export(module.exports, "default", () => $56a7c686b0777e4b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $56a7c686b0777e4b$var$messages = (0, $7qGN1.defineMessages)({
    // Delete genericPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
    genericPickerAriaLabel: {
        "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-aria-label",
        "defaultMessage": "Select an option"
    },
    genericPickerPlaceholder: {
        "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-placeholder",
        "defaultMessage": "Select"
    }
});
var $56a7c686b0777e4b$export$2e2bcd8739ae039 = $56a7c686b0777e4b$var$messages;

});


parcelRegister("68asf", function(module, exports) {
$parcel$export(module.exports, "SavedFilterPicker", () => $bed3cbcdd08188c1$export$7408ad1ebc985020);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $KDB2z = parcelRequire("KDB2z");

var $2sLVw = parcelRequire("2sLVw");

var $gWITR = parcelRequire("gWITR");

var $f5dwt = parcelRequire("f5dwt");

var $lRq8t = parcelRequire("lRq8t");

var $2pys5 = parcelRequire("2pys5");

var $hCtwH = parcelRequire("hCtwH");

var $abTcx = parcelRequire("abTcx");
const $bed3cbcdd08188c1$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))), {
        spacing: "spacious",
        label: option.label
    }), option.label);
const $bed3cbcdd08188c1$export$7408ad1ebc985020 = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $hCtwH.useLoadSavedFiltersController)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((searchString, callback)=>loadOptions(searchString).then((options)=>callback(options)), (0, $2pys5.PICKER_SEARCH_DEBOUNCE_TIME));
    return /* Prevent ESC press on Select bubbling up to the modal */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWITR.default), {
        "aria-label": label,
        isLoading: isLoading,
        formatOptionLabel: $bed3cbcdd08188c1$var$formatOptionLabel,
        defaultOptions: true,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage((0, $abTcx.default).savedFilterPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid
    }));
};

});
parcelRegister("hCtwH", function(module, exports) {
$parcel$export(module.exports, "useLoadSavedFiltersController", () => $c44248c8e05d6a45$export$bb3a63b49faf836c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $pkfsB = parcelRequire("pkfsB");

var $gHO4S = parcelRequire("gHO4S");

var $4dYZT = parcelRequire("4dYZT");

var $3P2eB = parcelRequire("3P2eB");
const $c44248c8e05d6a45$export$4dface15d86304a4 = ()=>(0, $eJOHy.useState)(false);
const $c44248c8e05d6a45$export$bb3a63b49faf836c = ()=>{
    const savedFiltersFetch = (0, $4dYZT.useSavedFiltersFetch)();
    const [isLoading, setIsLoading] = $c44248c8e05d6a45$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $3P2eB.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadOptions = (0, $eJOHy.useCallback)(async (searchString)=>{
        setIsLoading(true);
        return savedFiltersFetch(searchString).catch((error)=>{
            showErrorFlag({
                title: formatMessage((0, $pkfsB.default).loadSavedFiltersErrorTitle),
                description: formatMessage((0, $pkfsB.default).loadSavedFiltersErrorDescription)
            });
            (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to fetch saved filters: ${error}`),
                id: 'fetchSavedFilters'
            });
            return [];
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        formatMessage,
        savedFiltersFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("4dYZT", function(module, exports) {
$parcel$export(module.exports, "useSavedFiltersFetch", () => $123ee8bdfae8ae40$export$919a4c273fb6b0e5);

var $7qlZj = parcelRequire("7qlZj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");
const $123ee8bdfae8ae40$var$UNSUPPORTED_CHARACTERS = /[+\-&|!(){}[\]^~*?\\:]/g;
const $123ee8bdfae8ae40$var$removeUnsupportedCharacters = (text)=>text.replace($123ee8bdfae8ae40$var$UNSUPPORTED_CHARACTERS, ' ').trim();
const $123ee8bdfae8ae40$export$919a4c273fb6b0e5 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)(async (searchString)=>{
        const sanitizedSearchString = (0, $4cTDP.fg)('saved_filter_string_sanitize') ? $123ee8bdfae8ae40$var$removeUnsupportedCharacters(searchString) : searchString;
        return (0, $j4oe4.fetchQuery)(environment, (0, $7qlZj.default), {
            cloudId: cloudId,
            searchString: sanitizedSearchString
        }).toPromise().then((response)=>{
            if (response?.jira?.savedFilters?.edges) {
                const data = response.jira.savedFilters.edges.map((edge)=>{
                    return {
                        label: edge?.node?.name || '',
                        value: edge?.node?.filterId || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        });
    }, [
        cloudId,
        environment
    ]);
};

});
parcelRegister("7qlZj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e3daef4886882d8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7661fff4909318f923a859e991c3f990>>
 * @relayHash 6e5fec99171872e06e6faef5354994ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5
const $9e3daef4886882d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "keyword",
            "variableName": "searchString"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ],
        "type": "JiraCustomFilter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "savedFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.savedFilters.edges.node"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.savedFilters"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "savedFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5",
            "metadata": {},
            "name": "useSavedFiltersFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9e3daef4886882d8$var$node.hash = "69a6cd0661c8d852b37f79d9513a1db0";
var $9e3daef4886882d8$export$2e2bcd8739ae039 = $9e3daef4886882d8$var$node;

});



parcelRegister("abTcx", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcacd017b79250d6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fcacd017b79250d6$var$messages = (0, $7qGN1.defineMessages)({
    // Delete savedFilterPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
    savedFilterPickerAriaLabel: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-aria-label",
        "defaultMessage": "Select an option"
    },
    savedFilterPickerPlaceholder: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-placeholder",
        "defaultMessage": "Select"
    }
});
var $fcacd017b79250d6$export$2e2bcd8739ae039 = $fcacd017b79250d6$var$messages;

});


parcelRegister("kfYKF", function(module, exports) {
$parcel$export(module.exports, "TeamPicker", () => $7a758e3289699058$export$3529dc978be43e9d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $9cbmy = parcelRequire("9cbmy");

var $f5dwt = parcelRequire("f5dwt");

var $h47gY = parcelRequire("h47gY");

var $lRq8t = parcelRequire("lRq8t");

var $2NDyQ = parcelRequire("2NDyQ");

var $7ws3M = parcelRequire("7ws3M");

var $cHtIB = parcelRequire("cHtIB");

var $dId76 = parcelRequire("dId76");
const $7a758e3289699058$var$TEAM_A11Y_LABEL_ID = 'software-board-create.source-value.team';
const $7a758e3289699058$export$3529dc978be43e9d = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const handleOnCreate = (0, $eJOHy.useCallback)((team)=>{
        if (!team) return;
        // wait for the team to be created before updating the value
        setTimeout(()=>{
            onChange(team);
        }, 1000);
    }, [
        onChange
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $2NDyQ.useCreateTeamDialog)({
        onCreate: handleOnCreate
    });
    const handleChange = (team)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange?.(team || null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7a758e3289699058$var$TeamPickerEditWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        id: $7a758e3289699058$var$TEAM_A11Y_LABEL_ID
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ws3M.TeamPickerEdit), {
        siteId: cloudId,
        isCompact: false,
        hasNoTeamOption: false,
        createTeamDialogTrigger: createTeamDialogTrigger,
        placeholder: formatMessage((0, $dId76.default).placeholder),
        onChange: handleChange,
        defaultValue: value,
        isDropdownMenuFixedAndLayered: true,
        isInvalid: isInvalid,
        isClearable: false,
        "aria-labelledby": $7a758e3289699058$var$TEAM_A11Y_LABEL_ID
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "board-create-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
        tabIndex: -1,
        name: "create-team-dialog-form",
        onSubmit: (e)=>{
            e.stopPropagation();
        },
        className: (0, $hcewu.default)([
            "_1e0cglyw"
        ])
    }, createTeamDialog)));
};
const $7a758e3289699058$var$removeFormSpaceStyle = null; // TODO: remove this after select compiled migration
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7a758e3289699058$var$TeamPickerEditWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_b9cj1fu0 _t0z71fu0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2NDyQ", function(module, exports) {
$parcel$export(module.exports, "useCreateTeamDialog", () => $bce71092fd38d67f$export$e8b8170429d616be);

var $eJOHy = parcelRequire("eJOHy");

var $1n5fh = parcelRequire("1n5fh");

var $cSXp8 = parcelRequire("cSXp8");

var $2ePj6 = parcelRequire("2ePj6");

var $kFis2 = parcelRequire("kFis2");

var $1Gl91 = parcelRequire("1Gl91");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $3MbOI = parcelRequire("3MbOI");

var $g9Vr6 = parcelRequire("g9Vr6");

var $koAZ4 = parcelRequire("koAZ4");

var $hYRYR = parcelRequire("hYRYR");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

const $bce71092fd38d67f$export$75096afde50756fd = (0, $bQWwW.lazy)(()=>(parcelRequire("8PQvE")).then((module)=>module.TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $bce71092fd38d67f$export$e8b8170429d616be = (props = {})=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [inputTeamName, setInputTeamName] = (0, $eJOHy.useState)('');
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { data: { user: user } } = (0, $3MbOI.useCurrentUser)();
    if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
    const addFlag = (0, $eJOHy.useCallback)(({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kFis2.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.success-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Gl91.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.warning-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ePj6.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.error-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const { onCancel: onCancel } = {
        onCancel: ()=>null,
        ...props
    };
    const callback = (0, $eJOHy.useCallback)((teamName)=>{
        setInputTeamName(teamName);
        setIsOpen(true);
    }, []);
    const handleOnClose = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleOnCreate = (team)=>{
        const formattedTeam = {
            ...team,
            name: team.displayName
        };
        props.onCreate?.(formattedTeam);
    };
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hYRYR.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $1n5fh.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bce71092fd38d67f$export$75096afde50756fd, {
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId || user.accountId || '',
            onClose: handleOnClose,
            onCreateTeamSuccess: handleOnCreate,
            extraAnalyticsAttrs: props.analyticsCtx,
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                avatarUrl: (0, $4cTDP.fg)('jira_team_experience_improvements_feature_gate') ? 'avatarUrls' in user && user.avatarUrls && user.avatarUrls['48x48'] : // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                user.avatarUrls && user.avatarUrls['48x48'],
                email: 'emailAddress' in user && user.emailAddress && (0, $4cTDP.fg)('jira_team_experience_improvements_feature_gate') ? user.emailAddress : undefined,
                ...user
            } : undefined,
            prepopulatedFields: {
                teamName: inputTeamName
            },
            addFlag: addFlag
        }))) : null,
        callback
    ];
};

});

parcelRegister("7ws3M", function(module, exports) {
$parcel$export(module.exports, "TeamPickerEdit", () => $1d5d6d31869ab81e$export$cb5f622bec189851);
$parcel$export(module.exports, "TeamPickerEditEntryPointContent", () => $1d5d6d31869ab81e$export$93a79bad2594cfb5);

var $eJOHy = parcelRequire("eJOHy");

var $1v8Pz = parcelRequire("1v8Pz");

var $lRq8t = parcelRequire("lRq8t");

var $aUMMA = parcelRequire("aUMMA");

var $g9Vr6 = parcelRequire("g9Vr6");


var $aeZ5Y = parcelRequire("aeZ5Y");

var $eQtse = parcelRequire("eQtse");

var $hVanD = parcelRequire("hVanD");
// FIXME: These are overrides for @atlaskit/select@15.6 -> react-select@4.3.x
//        Once @atlaskit/select@15.6 resolution has been removed from package.json
//        these should be removed as well. See PTC-6238.
const $1d5d6d31869ab81e$var$stylesOverrides = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (base)=>({
            ...base,
            display: 'grid'
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    placeholder: (base)=>({
            ...base,
            position: undefined,
            top: undefined,
            left: undefined,
            transform: undefined
        })
};
const $1d5d6d31869ab81e$export$cb5f622bec189851 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { siteId: siteId, defaultValue: defaultValue, isClearable: isClearable = true, isDisabled: isDisabled = false, isInvalid: isInvalid = false, autoFocus: autoFocus = false, width: width = '100%', debounceTime: debounceTime = 300, onChange: onChange, placeholder: placeholder = formatMessage((0, $aeZ5Y.default).placeholderTeamEditSelector), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, styles: styles, noValueText: noValueText, createTeamDialogTrigger: createTeamDialogTrigger, isCompact: isCompact = true, hasNoTeamOption: hasNoTeamOption = true, description: description, ...fieldProps } = props;
    const [isCreateButtonFocused, setIsCreateButtonFocused] = (0, $eJOHy.useState)(false);
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const [hasTeams, setHasTeams] = (0, $eJOHy.useState)(true);
    const formattedNoValueText = formatMessage((0, $aeZ5Y.default).defaultNoValueText);
    const [updatedPlaceholder, setUpdatedPlaceholder] = (0, $eJOHy.useState)(placeholder);
    const [inputQuery, setInputQuery] = (0, $eJOHy.useState)('');
    const finalStyles = {
        ...(0, $aUMMA.defaultSelectStyles),
        ...styles || {},
        ...$1d5d6d31869ab81e$var$stylesOverrides
    };
    const maybeAddNoTeamOption = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'users' implicitly has an 'any' type.
    (users, query)=>{
        setHasTeams(!(users.length === 0 && query.length === 0));
        if (query === '' && !!defaultValue && hasNoTeamOption) return [
            {
                id: (0, $3ddfbe531e9e128a$export$53782b65600ab96d),
                name: noValueText ?? formattedNoValueText,
                isVerified: false,
                type: 'team'
            }
        ].concat(users);
        setIsCreateButtonFocused(query.length > 0 && users.length === 0);
        return users;
    }, [
        defaultValue,
        noValueText,
        formattedNoValueText,
        hasNoTeamOption
    ]);
    const handleOnChange = (newValue, actionType)=>{
        if (Array.isArray(newValue)) return;
        if (onChange) {
            onChange(newValue?.id === (0, $3ddfbe531e9e128a$export$53782b65600ab96d) || !newValue ? null : newValue, actionType);
            setUpdatedPlaceholder(newValue?.id === (0, $3ddfbe531e9e128a$export$53782b65600ab96d) || !newValue ? formattedNoValueText : placeholder);
        }
    };
    const handleCreateTeam = (0, $eJOHy.useCallback)(()=>{
        createTeamDialogTrigger(inputQuery);
    }, [
        inputQuery,
        createTeamDialogTrigger
    ]);
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (isCreateButtonFocused && event.key === 'Enter') handleCreateTeam();
    }, [
        isCreateButtonFocused,
        handleCreateTeam
    ]);
    const handleOnInputChange = (0, $eJOHy.useCallback)((query)=>{
        setInputQuery(query || '');
    }, [
        setInputQuery
    ]);
    const footer = (0, $eJOHy.useMemo)(()=>hasTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eQtse.CreateTeamOption), {
            isFocused: isCreateButtonFocused,
            onClick: handleCreateTeam
        }), [
        hasTeams,
        handleCreateTeam,
        isCreateButtonFocused
    ]);
    const noOptionsMessage = (0, $eJOHy.useMemo)(()=>!hasTeams ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hVanD.TeamPickerEmptyState), {
                onActionClick: handleCreateTeam
            }) : undefined, [
        hasTeams,
        handleCreateTeam
    ]);
    const menuListStyle = (0, $eJOHy.useMemo)(()=>!hasTeams ? {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuList: (base)=>({
                    ...base,
                    maxHeight: '350px'
                })
        } : {}, [
        hasTeams
    ]);
    const getMenuPosition = ()=>{
        return isDropdownMenuFixedAndLayered ? 'absolute' : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1v8Pz.default), {
        // Setting width=100% will allow dropdown to size correctly
        width: width,
        autoFocus: autoFocus,
        appearance: isCompact ? 'compact' : 'normal',
        debounceTime: debounceTime,
        fieldId: "team",
        filterOptions: maybeAddNoTeamOption,
        footer: footer,
        includeGroups: false,
        includeTeams: true,
        includeUsers: false,
        isClearable: isClearable,
        isMulti: false,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        productKey: "jira",
        siteId: siteId,
        value: defaultValue,
        onChange: handleOnChange,
        orgId: orgId,
        placeholder: updatedPlaceholder,
        menuPosition: getMenuPosition(),
        styles: {
            ...finalStyles,
            ...menuListStyle
        },
        onInputChange: handleOnInputChange,
        onKeyDown: handleOnKeyDown,
        noOptionsMessage: noOptionsMessage,
        ariaLabel: `${updatedPlaceholder} ${description}`,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        placeholderAvatar: "team"
    });
};
const $1d5d6d31869ab81e$export$93a79bad2594cfb5 = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d5d6d31869ab81e$export$cb5f622bec189851, props);
var $1d5d6d31869ab81e$export$2e2bcd8739ae039 = $1d5d6d31869ab81e$export$cb5f622bec189851;

});
parcelRegister("1v8Pz", function(module, exports) {
$parcel$export(module.exports, "default", () => $529368ddc15ccc11$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lW5Jn = parcelRequire("lW5Jn");

var $eeq1r = parcelRequire("eeq1r");

var $5Pgl9 = parcelRequire("5Pgl9");
const $529368ddc15ccc11$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $5Pgl9.useUFOConcurrentExperience)((0, $5Pgl9.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Pgl9.UfoErrorBoundary), {
        id: ufoId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eeq1r.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW5Jn.SmartUserPicker), {
                ...props
            })
        })
    });
};
var $529368ddc15ccc11$export$2e2bcd8739ae039 = $529368ddc15ccc11$var$SmartUserPickerWithIntlProvider;

});
parcelRegister("lW5Jn", function(module, exports) {
$parcel$export(module.exports, "SmartUserPicker", () => $efcf1f45f5488268$export$9eedb6e5d313efdb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $aXKmr = parcelRequire("aXKmr");

var $4J0ad = parcelRequire("4J0ad");

var $LFmXM = parcelRequire("LFmXM");

var $6YFG2 = parcelRequire("6YFG2");

var $g0oDq = parcelRequire("g0oDq");

var $ewHZ5 = parcelRequire("ewHZ5");
var $bp6ad = parcelRequire("bp6ad");
var $2lvD5 = parcelRequire("2lvD5");

var $eGOwo = parcelRequire("eGOwo");

var $3KPN3 = parcelRequire("3KPN3");

var $eeq1r = parcelRequire("eeq1r");

var $3tZlw = parcelRequire("3tZlw");

var $3ROyJ = parcelRequire("3ROyJ");
var $30jJs = parcelRequire("30jJs");

var $5Pgl9 = parcelRequire("5Pgl9");
const $efcf1f45f5488268$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $efcf1f45f5488268$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $efcf1f45f5488268$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $efcf1f45f5488268$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $efcf1f45f5488268$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $efcf1f45f5488268$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $efcf1f45f5488268$var$isEmailQuery = (query)=>{
    return (0, $2lvD5.isValidEmail)(query.trim()) === 'VALID';
};
class $efcf1f45f5488268$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            baseUrl: '',
            includeUsers: true,
            includeGroups: false,
            includeTeams: false,
            includeNonLicensedUsers: false,
            displayEmailInByline: false,
            prefetch: false,
            principalId: 'Context',
            debounceTime: $efcf1f45f5488268$var$DEFAULT_DEBOUNCE_TIME_MS,
            userResolvers: [],
            enableEmailSearch: false,
            allowEmailSelectionWhenEmailMatched: true
        };
    }
    constructor(props){
        super(props), this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        }, // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false, this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $g0oDq.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $3KPN3.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        }, this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users, this.memoizedFilterOptions = (0, $LFmXM.default)(this.filterOptions), this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $efcf1f45f5488268$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                /*
				For email-based searches, we have decided to filter out apps.
				Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
				when filter is empty, they have been added here to maintain consistency.

				Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
			 */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $3KPN3.requestUsersEvent));
                let recommendedUsers;
                if ((0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate')) {
                    const userRecommendationsPromise = (0, $3ROyJ.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $3KPN3.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                } else recommendedUsers = await (0, $3ROyJ.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $bp6ad.isUser)(option) || (0, $bp6ad.isExternalUser)(option) || (0, $bp6ad.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $bp6ad.isUser)(option) || (0, $bp6ad.isExternalUser)(option)) {
                        if (option.userType === (0, $3tZlw.UserEntityType).DEFAULT || option.userType === (0, $3tZlw.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) this.lastEmailSearchFoundMatches = recommendedUsers.length > 0;
                else this.lastEmailSearchFoundMatches = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $3KPN3.successfulRequestUsersEvent), {
                        users: $efcf1f45f5488268$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $efcf1f45f5488268$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        ...(0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate') && {
                            userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                        }
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $efcf1f45f5488268$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($efcf1f45f5488268$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch (error) {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($efcf1f45f5488268$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $3KPN3.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0), this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        }, this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $3KPN3.filterUsersEvent), {
                    filtered: $efcf1f45f5488268$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $efcf1f45f5488268$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$efcf1f45f5488268$var$stringContains(user.name, query));
            this.fireEvent((0, $3KPN3.filterUsersEvent), {
                filtered: $efcf1f45f5488268$var$getUsersForAnalytics(queryFilteredUsers),
                all: $efcf1f45f5488268$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        }, this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $3KPN3.preparedUsersLoadedEvent), {
                users: $efcf1f45f5488268$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        }, this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $5Pgl9.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
    async componentDidMount() {
        try {
            const value = await (0, $30jJs.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId);
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sessionId = (0, $aXKmr.v4)();
            this.fireEvent((0, $3KPN3.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($efcf1f45f5488268$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $g0oDq.UFOExperienceState).FAILED.id,
                (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
                (0, $g0oDq.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($efcf1f45f5488268$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            // Only allow email selection if we're in an email search that found no matches
            const isCurrentQueryEmail = $efcf1f45f5488268$var$isEmailQuery(this.state.query);
            shouldAllowEmail = !isCurrentQueryEmail || !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eeq1r.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewHZ5.UserPicker), {
                ...restProps,
                allowEmail: shouldAllowEmail,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers()
            })
        });
    }
}
const $efcf1f45f5488268$export$9eedb6e5d313efdb = (0, $4J0ad.default)()((0, $6YFG2.default)($efcf1f45f5488268$export$9b9bd453d1d4e4ce));

});
parcelRegister("ewHZ5", function(module, exports) {
$parcel$export(module.exports, "UserPicker", () => $1e85aa7b9e874556$export$83e0c73b09b3a9cd);
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $4J0ad = parcelRequire("4J0ad");

var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $g0oDq = parcelRequire("g0oDq");

var $eJOHy = parcelRequire("eJOHy");

var $1icyy = parcelRequire("1icyy");

var $7Vnqr = parcelRequire("7Vnqr");

var $6jfsf = parcelRequire("6jfsf");

var $lLpLo = parcelRequire("lLpLo");

var $f9tKr = parcelRequire("f9tKr");

var $61zL7 = parcelRequire("61zL7");

var $48bcP = parcelRequire("48bcP");

var $1FdfR = parcelRequire("1FdfR");

var $aXKmr = parcelRequire("aXKmr");

var $eGOwo = parcelRequire("eGOwo");
class $1e85aa7b9e874556$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.ufoId = (0, $aXKmr.v4)();
        const experienceForId = (0, $1FdfR.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
            (0, $g0oDq.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $1FdfR.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
            (0, $g0oDq.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false, showClearIndicator: showClearIndicator = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $kVcjU.default) : (0, $c4OV1.default);
        const creatableProps = suggestEmailsForDomain ? (0, $f9tKr.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $lLpLo.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1FdfR.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $61zL7.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48bcP.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1icyy.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $7Vnqr.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $eGOwo.fg)('platform-component-visual-refresh'), false, (0, $eGOwo.fg)('jifjam_bulk_operations') ? this.props.height : undefined),
                        components: (0, $6jfsf.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $1e85aa7b9e874556$export$83e0c73b09b3a9cd = (0, $4J0ad.default)()($1e85aa7b9e874556$export$164f4d95e5d7e2f5);

});
parcelRegister("kVcjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a77c87292d58cd15$export$2e2bcd8739ae039);

var $dSBuj = parcelRequire("dSBuj");

var $dDv66 = parcelRequire("dDv66");
const $a77c87292d58cd15$var$CreatableSelect = (0, $dDv66.default)((0, $dSBuj.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a77c87292d58cd15$export$2e2bcd8739ae039 = $a77c87292d58cd15$var$CreatableSelect;

});
parcelRegister("dSBuj", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfa75c11ff37aa8b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("9gNEN")).default);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $bfa75c11ff37aa8b$var$CreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const creatableProps = (0, $gVVTN.default)(props);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bfa75c11ff37aa8b$export$2e2bcd8739ae039 = $bfa75c11ff37aa8b$var$CreatableSelect;

});
parcelRegister("9gNEN", function(module, exports) {
$parcel$export(module.exports, "default", () => $59d3993c69e6bf3a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $20dEN = parcelRequire("20dEN");

var $gNnQq = parcelRequire("gNnQq");
const $59d3993c69e6bf3a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $59d3993c69e6bf3a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$59d3993c69e6bf3a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$59d3993c69e6bf3a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $59d3993c69e6bf3a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $59d3993c69e6bf3a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $59d3993c69e6bf3a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $59d3993c69e6bf3a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $20dEN.getOptionValue), getOptionLabel: getOptionLabel = (0, $20dEN.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $eJOHy.useMemo)(()=>isValidNewOption(inputValue, (0, $gNnQq.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $eJOHy.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gNnQq.valueTernary)(isMulti, [
                    ...(0, $gNnQq.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("1icyy", function(module, exports) {
$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $35423b4ef08403b2$export$b4ff48c8d43b18c3);

var $gt9Am = parcelRequire("gt9Am");

var $4J0ad = parcelRequire("4J0ad");

var $g0oDq = parcelRequire("g0oDq");

var $3s8bj = parcelRequire("3s8bj");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $aXKmr = parcelRequire("aXKmr");

var $lyKnh = parcelRequire("lyKnh");

var $4yPQa = parcelRequire("4yPQa");

var $aemwP = parcelRequire("aemwP");

var $bp6ad = parcelRequire("bp6ad");

var $ersOA = parcelRequire("ersOA");

var $1FdfR = parcelRequire("1FdfR");

var $eGOwo = parcelRequire("eGOwo");
const $35423b4ef08403b2$var$loadingMessage = ()=>null;
const $35423b4ef08403b2$var$classNamePrefix = 'fabric-user-picker';
class $35423b4ef08403b2$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $aemwP.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $bp6ad.optionToSelectableOptions)(nextProps.value);
        else if ((0, $bp6ad.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $bp6ad.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $bp6ad.callCallback)(onChange, (0, $bp6ad.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $bp6ad.callCallback)(onSelection, (0, $bp6ad.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $lyKnh.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $lyKnh.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $bp6ad.callCallback)(onClear);
                    this.fireEvent((0, $lyKnh.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $lyKnh.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $lyKnh.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $4yPQa.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $lyKnh.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $bp6ad.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $g0oDq.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $bp6ad.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $bp6ad.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $bp6ad.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $bp6ad.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $bp6ad.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $bp6ad.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $bp6ad.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $bp6ad.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $lyKnh.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $lyKnh.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $lyKnh.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $bp6ad.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $ersOA.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $ersOA.groupOptionsByType)(options, groupByTypeOrder) : options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $1FdfR.userPickerOptionsShownUfoExperience).getInstance((0, $aXKmr.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $lyKnh.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $lyKnh.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $g0oDq.UFOExperienceState).STARTED.id,
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? ariaLabelledBy ?? ariaLabelledByStandard : undefined,
            "aria-labelledby": (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? undefined : ariaLabelledBy,
            descriptionId: (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? ariaDescribedBy ?? ariaDescribedByStandard : undefined,
            "aria-describedby": (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? undefined : ariaDescribedBy,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $35423b4ef08403b2$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $35423b4ef08403b2$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...(0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? restAriaProps : this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $35423b4ef08403b2$export$d099ade7b4f4d2a4 = (0, $4J0ad.default)()($35423b4ef08403b2$export$b4ff48c8d43b18c3);

});
parcelRegister("lyKnh", function(module, exports) {
$parcel$export(module.exports, "startSession", () => $90f09ed730154930$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $90f09ed730154930$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $90f09ed730154930$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $90f09ed730154930$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $90f09ed730154930$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $90f09ed730154930$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $90f09ed730154930$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $90f09ed730154930$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $90f09ed730154930$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $90f09ed730154930$export$f541f04954b0c11e);

var $5fWw9 = parcelRequire("5fWw9");

var $aXKmr = parcelRequire("aXKmr");

var $bp6ad = parcelRequire("bp6ad");
const $90f09ed730154930$var$packageName = "platform-pkg";
const $90f09ed730154930$var$packageVersion = "0.0.0-use.local";
const $90f09ed730154930$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $90f09ed730154930$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $90f09ed730154930$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $90f09ed730154930$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $aXKmr.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $90f09ed730154930$export$53eef0dcd9611650 = (0, $5fWw9.default)('fabric-elements');
const $90f09ed730154930$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $90f09ed730154930$var$packageName,
            packageVersion: $90f09ed730154930$var$packageVersion,
            ...attributes
        }
    });
const $90f09ed730154930$var$checkValidId = (id)=>{
    return $90f09ed730154930$var$UUID_REGEXP_NEW_AAID.test(id) || $90f09ed730154930$var$UUID_REGEXP_OLD_AAID.test(id) || $90f09ed730154930$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $90f09ed730154930$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $90f09ed730154930$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $bp6ad.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $bp6ad.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $90f09ed730154930$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$90f09ed730154930$var$optionData2Analytics(data));
    }
    return [];
};
const $90f09ed730154930$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $90f09ed730154930$var$sessionId(session),
        pickerType: $90f09ed730154930$var$pickerType(props),
        journeyId: journeyId
    });
const $90f09ed730154930$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$90f09ed730154930$var$createEvent('ui', 'focused', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $90f09ed730154930$var$buildValueForAnalytics(state.value)
    });
const $90f09ed730154930$export$7b5800e732182efb = (props, state, session, journeyId)=>$90f09ed730154930$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $90f09ed730154930$var$values(state)
    });
const $90f09ed730154930$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$90f09ed730154930$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $90f09ed730154930$var$sessionId(session),
        journeyId: journeyId,
        value: $90f09ed730154930$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $90f09ed730154930$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$90f09ed730154930$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        queryLength: $90f09ed730154930$var$queryLength(args[0]),
        spaceInQuery: $90f09ed730154930$var$spaceInQuery(args[0]),
        upKeyCount: $90f09ed730154930$var$upKeyCount(session),
        downKeyCount: $90f09ed730154930$var$downKeyCount(session)
    });
const $90f09ed730154930$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $90f09ed730154930$var$createEvent('ui', $90f09ed730154930$var$selectEventType(session), 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        position: $90f09ed730154930$var$position(state, args[0]),
        queryLength: $90f09ed730154930$var$queryLength(state),
        spaceInQuery: $90f09ed730154930$var$spaceInQuery(state),
        upKeyCount: $90f09ed730154930$var$upKeyCount(session),
        downKeyCount: $90f09ed730154930$var$downKeyCount(session),
        result: $90f09ed730154930$var$result(args[0]),
        numberOfResults: $90f09ed730154930$var$numberOfResults(state)
    });
};
const $90f09ed730154930$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $90f09ed730154930$var$results(state);
    return $90f09ed730154930$var$createEvent('operational', 'searched', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        durationSinceInputChange: $90f09ed730154930$var$durationSinceInputChange(session),
        queryLength: $90f09ed730154930$var$queryLength(state),
        isLoading: $90f09ed730154930$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $90f09ed730154930$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$90f09ed730154930$var$createEvent('operational', 'failed', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $90f09ed730154930$export$f541f04954b0c11e = (sources, accountId)=>$90f09ed730154930$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $90f09ed730154930$var$checkValidId(accountId) ? accountId : null
    });
function $90f09ed730154930$var$queryLength(state) {
    return state.inputValue.length;
}
function $90f09ed730154930$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $90f09ed730154930$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $90f09ed730154930$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $90f09ed730154930$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $90f09ed730154930$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $90f09ed730154930$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $90f09ed730154930$var$sessionId(session) {
    return session && session.id;
}
function $90f09ed730154930$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $90f09ed730154930$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $90f09ed730154930$var$result(option) {
    return option ? $90f09ed730154930$var$optionData2Analytics(option.data) : null;
}
function $90f09ed730154930$var$results(state) {
    return (state.options || []).map($90f09ed730154930$var$optionData2Analytics);
}
function $90f09ed730154930$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $90f09ed730154930$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$90f09ed730154930$var$optionData2Analytics(option.data)) : [
        $90f09ed730154930$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $90f09ed730154930$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("bp6ad", function(module, exports) {
$parcel$export(module.exports, "isExternalUser", () => $144d288a5555e012$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $144d288a5555e012$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $144d288a5555e012$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $144d288a5555e012$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $144d288a5555e012$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $144d288a5555e012$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $144d288a5555e012$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $144d288a5555e012$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $144d288a5555e012$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $144d288a5555e012$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $144d288a5555e012$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $144d288a5555e012$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $144d288a5555e012$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $144d288a5555e012$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $144d288a5555e012$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $144d288a5555e012$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $144d288a5555e012$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $144d288a5555e012$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $144d288a5555e012$export$5419897287f5f1c7);

var $LFmXM = parcelRequire("LFmXM");


var $sl8jM = parcelRequire("sl8jM");
const $144d288a5555e012$export$f6058dbcb5980cb = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $144d288a5555e012$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b);
const $144d288a5555e012$export$f8c4277cb588611f = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$26bc40b960693765);
const $144d288a5555e012$export$d7976824e9f55785 = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$d460f747b73abb10);
const $144d288a5555e012$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c);
const $144d288a5555e012$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$eafd0979afa5b224);
const $144d288a5555e012$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $144d288a5555e012$var$isOptionData = (option)=>option.name !== undefined;
const $144d288a5555e012$export$3f993c492bd6c728 = (option)=>{
    if ($144d288a5555e012$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $144d288a5555e012$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $144d288a5555e012$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $144d288a5555e012$export$d2312e68e1f5ad00 = (0, $LFmXM.default)((options)=>options.map($144d288a5555e012$export$3f993c492bd6c728));
const $144d288a5555e012$export$e6fda14a194bcbcc = (0, $LFmXM.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($144d288a5555e012$export$3f993c492bd6c728);
    return $144d288a5555e012$export$3f993c492bd6c728(defaultValue);
});
const $144d288a5555e012$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $144d288a5555e012$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $144d288a5555e012$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $144d288a5555e012$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $144d288a5555e012$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $144d288a5555e012$export$b4f8f1f54acec99b = (optionData)=>{
    if ($144d288a5555e012$export$2e44165f1da65304(optionData) || $144d288a5555e012$export$f8c4277cb588611f(optionData) || $144d288a5555e012$export$d3a8f0b77e9737fc(optionData) || $144d288a5555e012$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $144d288a5555e012$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $sl8jM.default);
const $144d288a5555e012$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $144d288a5555e012$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $f4e041c5b2b1b75c$export$8436e53e45ffe15b = 'user';
const $f4e041c5b2b1b75c$export$50042ec1d2e00e63 = 'external_user';
const $f4e041c5b2b1b75c$export$26bc40b960693765 = 'team';
const $f4e041c5b2b1b75c$export$d460f747b73abb10 = 'group';
const $f4e041c5b2b1b75c$export$6662b3461398ef8c = 'email';
const $f4e041c5b2b1b75c$export$eafd0979afa5b224 = 'custom';

parcelRegister("sl8jM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f040ddaa0ef5501e$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $aQK2r = parcelRequire("aQK2r");

var $1Q3jn = parcelRequire("1Q3jn");

var $7QJq6 = parcelRequire("7QJq6");
var $i0xNm = parcelRequire("i0xNm");
var $lEbH4 = parcelRequire("lEbH4");

var $5yteI = parcelRequire("5yteI");

var $gl2vi = parcelRequire("gl2vi");

var $eGOwo = parcelRequire("eGOwo");

var $e9zKl = parcelRequire("e9zKl");


var $c4OV1 = parcelRequire("c4OV1");

var $5nAXq = parcelRequire("5nAXq");

var $ctyCN = parcelRequire("ctyCN");
/**
 * Are we rendering on the client or server?
 */ const $f040ddaa0ef5501e$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $f040ddaa0ef5501e$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
/**
 * The new defaults match the default modifiers of `@atlaskit/popper`.
 *
 * In the future we should investigate using `@atlaskit/popper` instead of
 * consuming `react-popper` directly.
 *
 * Previously the select popup would slide over the trigger to try to stay visible.
 * This behavior could actually cause it to go offscreen.
 *
 * Now it will stay anchored above / below the trigger and cause the
 * clipping parent to scroll if necessary. This aligns with other popups.
 */ const $f040ddaa0ef5501e$var$newDefaultModifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'document'
        }
    },
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
const $f040ddaa0ef5501e$var$defaultPopperProps = {
    modifiers: $f040ddaa0ef5501e$var$modifiers,
    placement: 'bottom-start'
};
const $f040ddaa0ef5501e$var$newDefaultPopperProps = {
    modifiers: $f040ddaa0ef5501e$var$newDefaultModifiers,
    placement: 'bottom-start'
};
const $f040ddaa0ef5501e$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $f040ddaa0ef5501e$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...(0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $f040ddaa0ef5501e$var$newDefaultPopperProps : $f040ddaa0ef5501e$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $5nAXq.defaultComponents),
            ...props.components
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$f040ddaa0ef5501e$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $4eDgu.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7QJq6.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lEbH4.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ctyCN.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $5nAXq.defaultComponents),
            mergedPopperProps: (0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $f040ddaa0ef5501e$var$newDefaultPopperProps : $f040ddaa0ef5501e$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $f040ddaa0ef5501e$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $5nAXq.DummyControl)
            };
            // @ts-ignore - TS7030: Not all code paths return a value - causing issues for help-center local consumption with TS 5.9.2
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
                return undefined;
            };
            const popper = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i0xNm.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5nAXq.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Q3jn.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $e9zKl.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $aQK2r.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}

});
parcelRegister("7QJq6", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $5b709f3958b336e6$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $5b709f3958b336e6$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $5b709f3958b336e6$export$d0d38e7dec7a1a61);

var $eJOHy = parcelRequire("eJOHy");
var $5b709f3958b336e6$export$3dbd3405086fec7b = $eJOHy.createContext();
var $5b709f3958b336e6$export$cbabb21c2529b130 = $eJOHy.createContext();
function $5b709f3958b336e6$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eJOHy.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eJOHy.useRef(false);
    $eJOHy.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eJOHy.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eJOHy.createElement($5b709f3958b336e6$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eJOHy.createElement($5b709f3958b336e6$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("i0xNm", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $d1c2711317bcdd69$export$badac9ada3a0bdf9);

var $eJOHy = parcelRequire("eJOHy");

var $7QJq6 = parcelRequire("7QJq6");

var $65sWw = parcelRequire("65sWw");

var $8E4Pq = parcelRequire("8E4Pq");
var $d1c2711317bcdd69$var$NOOP = function NOOP() {
    return void 0;
};
var $d1c2711317bcdd69$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $d1c2711317bcdd69$var$EMPTY_MODIFIERS = [];
function $d1c2711317bcdd69$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $d1c2711317bcdd69$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eJOHy.useContext((0, $7QJq6.ManagerReferenceNodeContext));
    var _React$useState = $eJOHy.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eJOHy.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eJOHy.useEffect(function() {
        (0, $65sWw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eJOHy.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $8E4Pq.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eJOHy.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $d1c2711317bcdd69$var$NOOP,
            update: update || $d1c2711317bcdd69$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $65sWw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("65sWw", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $46e9a926da059f7f$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $46e9a926da059f7f$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $46e9a926da059f7f$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $46e9a926da059f7f$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $46e9a926da059f7f$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
var $46e9a926da059f7f$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $46e9a926da059f7f$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $46e9a926da059f7f$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $46e9a926da059f7f$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $46e9a926da059f7f$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $46e9a926da059f7f$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;

});

parcelRegister("8E4Pq", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $64b5cdf5dd511d2b$export$f4d5bf230a36dd6e);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $gnxAv = parcelRequire("gnxAv");

var $aVrYR = parcelRequire("aVrYR");

var $65sWw = parcelRequire("65sWw");
var $64b5cdf5dd511d2b$var$EMPTY_MODIFIERS = [];
var $64b5cdf5dd511d2b$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eJOHy.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $64b5cdf5dd511d2b$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eJOHy.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eJOHy.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aQK2r.flushSync(function() {
                    setState({
                        styles: (0, $65sWw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $65sWw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eJOHy.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVrYR)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eJOHy.useRef();
    (0, $65sWw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $65sWw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $gnxAv.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("gnxAv", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $bec8d928f7873785$export$8f7491d57c8f97a9);

var $heIbG = parcelRequire("heIbG");

var $bMX9T = parcelRequire("bMX9T");

var $3lXAT = parcelRequire("3lXAT");

var $9rdGq = parcelRequire("9rdGq");

var $9HkoV = parcelRequire("9HkoV");

var $f7Vnd = parcelRequire("f7Vnd");

var $6DBHs = parcelRequire("6DBHs");

var $31C6T = parcelRequire("31C6T");

var $a6oPx = parcelRequire("a6oPx");

var $c2Bzy = parcelRequire("c2Bzy");


var $bec8d928f7873785$export$d34966752335dd47 = [
    (0, $bMX9T.default),
    (0, $3lXAT.default),
    (0, $9rdGq.default),
    (0, $9HkoV.default),
    (0, $f7Vnd.default),
    (0, $6DBHs.default),
    (0, $31C6T.default),
    (0, $a6oPx.default),
    (0, $c2Bzy.default)
];
var $bec8d928f7873785$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $heIbG.popperGenerator)({
    defaultModifiers: $bec8d928f7873785$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("heIbG", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $c8c60531711653f3$export$ed5e13716264f202);

var $elLvv = parcelRequire("elLvv");

var $9J30E = parcelRequire("9J30E");

var $kXPOQ = parcelRequire("kXPOQ");

var $5hADZ = parcelRequire("5hADZ");

var $467x6 = parcelRequire("467x6");

var $bQzW7 = parcelRequire("bQzW7");

var $287ko = parcelRequire("287ko");


var $gg6Qu = parcelRequire("gg6Qu");
var $c8c60531711653f3$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $c8c60531711653f3$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $c8c60531711653f3$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c8c60531711653f3$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $c8c60531711653f3$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gg6Qu.isElement)(reference) ? (0, $kXPOQ.default)(reference) : reference.contextElement ? (0, $kXPOQ.default)(reference.contextElement) : [],
                    popper: (0, $kXPOQ.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $467x6.default)((0, $287ko.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c8c60531711653f3$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $elLvv.default)(reference, (0, $5hADZ.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9J30E.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bQzW7.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c8c60531711653f3$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c8c60531711653f3$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c8c60531711653f3$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("elLvv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a727e0cb46add6f0$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");

var $g4m1c = parcelRequire("g4m1c");

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");

var $2uwXd = parcelRequire("2uwXd");

var $7gyBU = parcelRequire("7gyBU");

var $9Uhst = parcelRequire("9Uhst");

var $8amqe = parcelRequire("8amqe");
function $a727e0cb46add6f0$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8amqe.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8amqe.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $a727e0cb46add6f0$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gg6Qu.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gg6Qu.isHTMLElement)(offsetParent) && $a727e0cb46add6f0$var$isElementScaled(offsetParent);
    var documentElement = (0, $7gyBU.default)(offsetParent);
    var rect = (0, $k65dW.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4baem.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9Uhst.default)(documentElement)) scroll = (0, $g4m1c.default)(offsetParent);
        if ((0, $gg6Qu.isHTMLElement)(offsetParent)) {
            offsets = (0, $k65dW.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2uwXd.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("k65dW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea186b851f3316f0$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");

var $8amqe = parcelRequire("8amqe");

var $fWmj3 = parcelRequire("fWmj3");

var $2aPrh = parcelRequire("2aPrh");
function $ea186b851f3316f0$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gg6Qu.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8amqe.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8amqe.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gg6Qu.isElement)(element) ? (0, $fWmj3.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2aPrh.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gg6Qu", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $bd63735f7342e30f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $bd63735f7342e30f$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $bd63735f7342e30f$export$af51f0f06c0f328a);

var $fWmj3 = parcelRequire("fWmj3");
function $bd63735f7342e30f$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWmj3.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bd63735f7342e30f$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWmj3.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bd63735f7342e30f$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fWmj3.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWmj3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ad935b388d902f$export$2e2bcd8739ae039);
function $b9ad935b388d902f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("8amqe", function(module, exports) {
$parcel$export(module.exports, "max", () => $5f20a67c3007211c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $5f20a67c3007211c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $5f20a67c3007211c$export$2077e0241d6afd3c);
var $5f20a67c3007211c$export$8960430cfd85939f = Math.max;
var $5f20a67c3007211c$export$96ec731ed4dcb222 = Math.min;
var $5f20a67c3007211c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2aPrh", function(module, exports) {
$parcel$export(module.exports, "default", () => $19546aaa985cfe85$export$2e2bcd8739ae039);

var $jfbGV = parcelRequire("jfbGV");
function $19546aaa985cfe85$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $jfbGV.default)());
}

});
parcelRegister("jfbGV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0287cade039ed57$export$2e2bcd8739ae039);
function $e0287cade039ed57$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("g4m1c", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb2e196d14a21ebf$export$2e2bcd8739ae039);

var $cOno9 = parcelRequire("cOno9");

var $fWmj3 = parcelRequire("fWmj3");

var $gg6Qu = parcelRequire("gg6Qu");

var $cjw1I = parcelRequire("cjw1I");
function $bb2e196d14a21ebf$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWmj3.default)(node) || !(0, $gg6Qu.isHTMLElement)(node)) return (0, $cOno9.default)(node);
    else return (0, $cjw1I.default)(node);
}

});
parcelRegister("cOno9", function(module, exports) {
$parcel$export(module.exports, "default", () => $953c4c05b181c08e$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
function $953c4c05b181c08e$export$2e2bcd8739ae039(node) {
    var win = (0, $fWmj3.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("cjw1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f701a3aded86182$export$2e2bcd8739ae039);
function $8f701a3aded86182$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("4baem", function(module, exports) {
$parcel$export(module.exports, "default", () => $30b0201497441060$export$2e2bcd8739ae039);
function $30b0201497441060$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2uwXd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d07f21abc9989f4$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");

var $7gyBU = parcelRequire("7gyBU");

var $cOno9 = parcelRequire("cOno9");
function $1d07f21abc9989f4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $k65dW.default)((0, $7gyBU.default)(element)).left + (0, $cOno9.default)(element).scrollLeft;
}

});
parcelRegister("7gyBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a4dfebec89ee7e$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");
function $54a4dfebec89ee7e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gg6Qu.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9Uhst", function(module, exports) {
$parcel$export(module.exports, "default", () => $7366e2de4224a174$export$2e2bcd8739ae039);

var $gJ1QC = parcelRequire("gJ1QC");
function $7366e2de4224a174$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $gJ1QC.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("gJ1QC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2d24838526c2191$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
function $c2d24838526c2191$export$2e2bcd8739ae039(element) {
    return (0, $fWmj3.default)(element).getComputedStyle(element);
}

});



parcelRegister("9J30E", function(module, exports) {
$parcel$export(module.exports, "default", () => $714aa6a5cb9954a0$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");
function $714aa6a5cb9954a0$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $k65dW.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("kXPOQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f431837fa9e8ca57$export$2e2bcd8739ae039);

var $2CQVf = parcelRequire("2CQVf");

var $5ewz1 = parcelRequire("5ewz1");

var $fWmj3 = parcelRequire("fWmj3");

var $9Uhst = parcelRequire("9Uhst");
function $f431837fa9e8ca57$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2CQVf.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWmj3.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9Uhst.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($f431837fa9e8ca57$export$2e2bcd8739ae039((0, $5ewz1.default)(target)));
}

});
parcelRegister("2CQVf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e982ea2e37d1ae0$export$2e2bcd8739ae039);

var $5ewz1 = parcelRequire("5ewz1");

var $9Uhst = parcelRequire("9Uhst");

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");
function $1e982ea2e37d1ae0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4baem.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gg6Qu.isHTMLElement)(node) && (0, $9Uhst.default)(node)) return node;
    return $1e982ea2e37d1ae0$export$2e2bcd8739ae039((0, $5ewz1.default)(node));
}

});
parcelRegister("5ewz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cf7850ed94ba01d$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");

var $7gyBU = parcelRequire("7gyBU");

var $gg6Qu = parcelRequire("gg6Qu");
function $3cf7850ed94ba01d$export$2e2bcd8739ae039(element) {
    if ((0, $4baem.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gg6Qu.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7gyBU.default)(element) // fallback
    );
}

});



parcelRegister("5hADZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d8af70a4a661074$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");

var $4baem = parcelRequire("4baem");

var $gJ1QC = parcelRequire("gJ1QC");

var $gg6Qu = parcelRequire("gg6Qu");

var $fJU2S = parcelRequire("fJU2S");

var $5ewz1 = parcelRequire("5ewz1");

var $jfbGV = parcelRequire("jfbGV");
function $3d8af70a4a661074$var$getTrueOffsetParent(element) {
    if (!(0, $gg6Qu.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $gJ1QC.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3d8af70a4a661074$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $jfbGV.default)());
    var isIE = /Trident/i.test((0, $jfbGV.default)());
    if (isIE && (0, $gg6Qu.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $gJ1QC.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5ewz1.default)(element);
    if ((0, $gg6Qu.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gg6Qu.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4baem.default)(currentNode)) < 0){
        var css = (0, $gJ1QC.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3d8af70a4a661074$export$2e2bcd8739ae039(element) {
    var window = (0, $fWmj3.default)(element);
    var offsetParent = $3d8af70a4a661074$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fJU2S.default)(offsetParent) && (0, $gJ1QC.default)(offsetParent).position === 'static')offsetParent = $3d8af70a4a661074$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4baem.default)(offsetParent) === 'html' || (0, $4baem.default)(offsetParent) === 'body' && (0, $gJ1QC.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $3d8af70a4a661074$var$getContainingBlock(element) || window;
}

});
parcelRegister("fJU2S", function(module, exports) {
$parcel$export(module.exports, "default", () => $b756886c0c925609$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");
function $b756886c0c925609$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4baem.default)(element)) >= 0;
}

});


parcelRegister("467x6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fbd90d3076093ac$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");
function $2fbd90d3076093ac$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2fbd90d3076093ac$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2fbd90d3076093ac$var$order(modifiers); // order based on phase
    return (0, $1LHyG.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1LHyG", function(module, exports) {
$parcel$export(module.exports, "top", () => $149bf80282ae6f0a$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $149bf80282ae6f0a$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $149bf80282ae6f0a$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $149bf80282ae6f0a$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $149bf80282ae6f0a$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $149bf80282ae6f0a$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $149bf80282ae6f0a$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $149bf80282ae6f0a$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $149bf80282ae6f0a$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $149bf80282ae6f0a$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $149bf80282ae6f0a$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $149bf80282ae6f0a$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $149bf80282ae6f0a$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $149bf80282ae6f0a$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $149bf80282ae6f0a$export$d087d3878fdf71d5);
var $149bf80282ae6f0a$export$1e95b668f3b82d = 'top';
var $149bf80282ae6f0a$export$40e543e69a8b3fbb = 'bottom';
var $149bf80282ae6f0a$export$79ffe56a765070d2 = 'right';
var $149bf80282ae6f0a$export$eabcd2c8791e7bf4 = 'left';
var $149bf80282ae6f0a$export$dfb5619354ba860 = 'auto';
var $149bf80282ae6f0a$export$aec2ce47c367b8c3 = [
    $149bf80282ae6f0a$export$1e95b668f3b82d,
    $149bf80282ae6f0a$export$40e543e69a8b3fbb,
    $149bf80282ae6f0a$export$79ffe56a765070d2,
    $149bf80282ae6f0a$export$eabcd2c8791e7bf4
];
var $149bf80282ae6f0a$export$b3571188c770cc5a = 'start';
var $149bf80282ae6f0a$export$bd5df0f255a350f8 = 'end';
var $149bf80282ae6f0a$export$390fd549c5303b4d = 'clippingParents';
var $149bf80282ae6f0a$export$d7b7311ec04a3e8f = 'viewport';
var $149bf80282ae6f0a$export$ae5ab1c730825774 = 'popper';
var $149bf80282ae6f0a$export$ca50aac9f3ba507f = 'reference';
var $149bf80282ae6f0a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $149bf80282ae6f0a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $149bf80282ae6f0a$export$b3571188c770cc5a,
        placement + "-" + $149bf80282ae6f0a$export$bd5df0f255a350f8
    ]);
}, []);
var $149bf80282ae6f0a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($149bf80282ae6f0a$export$aec2ce47c367b8c3, [
    $149bf80282ae6f0a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $149bf80282ae6f0a$export$b3571188c770cc5a,
        placement + "-" + $149bf80282ae6f0a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $149bf80282ae6f0a$export$421679a7c3d56e = 'beforeRead';
var $149bf80282ae6f0a$export$aafa59e2e03f2942 = 'read';
var $149bf80282ae6f0a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $149bf80282ae6f0a$export$c65e99957a05207c = 'beforeMain';
var $149bf80282ae6f0a$export$f22da7240b7add18 = 'main';
var $149bf80282ae6f0a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $149bf80282ae6f0a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $149bf80282ae6f0a$export$68d8715fc104d294 = 'write';
var $149bf80282ae6f0a$export$70a6e5159acce2e6 = 'afterWrite';
var $149bf80282ae6f0a$export$d087d3878fdf71d5 = [
    $149bf80282ae6f0a$export$421679a7c3d56e,
    $149bf80282ae6f0a$export$aafa59e2e03f2942,
    $149bf80282ae6f0a$export$6964f6c886723980,
    $149bf80282ae6f0a$export$c65e99957a05207c,
    $149bf80282ae6f0a$export$f22da7240b7add18,
    $149bf80282ae6f0a$export$bab79516f2d662fe,
    $149bf80282ae6f0a$export$8d4d2d70e7d46032,
    $149bf80282ae6f0a$export$68d8715fc104d294,
    $149bf80282ae6f0a$export$70a6e5159acce2e6
];

});


parcelRegister("bQzW7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a006d460a409cf5$export$2e2bcd8739ae039);
function $8a006d460a409cf5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("287ko", function(module, exports) {
$parcel$export(module.exports, "default", () => $18d203526ff3d300$export$2e2bcd8739ae039);
function $18d203526ff3d300$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("bMX9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $89521114592bb4c0$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
var $89521114592bb4c0$var$passive = {
    passive: true
};
function $89521114592bb4c0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWmj3.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $89521114592bb4c0$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $89521114592bb4c0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $89521114592bb4c0$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $89521114592bb4c0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $89521114592bb4c0$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $89521114592bb4c0$var$effect,
    data: {}
};

});

parcelRegister("3lXAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $27118f602f9fb7ed$export$2e2bcd8739ae039);

var $fl9ah = parcelRequire("fl9ah");
function $27118f602f9fb7ed$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $fl9ah.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $27118f602f9fb7ed$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $27118f602f9fb7ed$var$popperOffsets,
    data: {}
};

});
parcelRegister("fl9ah", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2afed1d882b4807$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $3nitp = parcelRequire("3nitp");

var $aRMwh = parcelRequire("aRMwh");

var $1LHyG = parcelRequire("1LHyG");
function $b2afed1d882b4807$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $ix6Fe.default)(placement) : null;
    var variation = placement ? (0, $3nitp.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1LHyG.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1LHyG.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1LHyG.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1LHyG.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $aRMwh.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1LHyG.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1LHyG.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("ix6Fe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e07a637cd667c6$export$2e2bcd8739ae039);

function $d7e07a637cd667c6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("3nitp", function(module, exports) {
$parcel$export(module.exports, "default", () => $2751d9819e47949e$export$2e2bcd8739ae039);
function $2751d9819e47949e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("aRMwh", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e947d96e10112da$export$2e2bcd8739ae039);
function $7e947d96e10112da$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("9rdGq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6df13fe20ccb3860$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $5hADZ = parcelRequire("5hADZ");

var $fWmj3 = parcelRequire("fWmj3");

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $ix6Fe = parcelRequire("ix6Fe");

var $3nitp = parcelRequire("3nitp");

var $8amqe = parcelRequire("8amqe");
var $6df13fe20ccb3860$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6df13fe20ccb3860$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8amqe.round)(x * dpr) / dpr || 0,
        y: (0, $8amqe.round)(y * dpr) / dpr || 0
    };
}
function $6df13fe20ccb3860$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1LHyG.left);
    var sideY = (0, $1LHyG.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5hADZ.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fWmj3.default)(popper)) {
            offsetParent = (0, $7gyBU.default)(popper);
            if ((0, $gJ1QC.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1LHyG.top) || (placement === (0, $1LHyG.left) || placement === (0, $1LHyG.right)) && variation === (0, $1LHyG.end)) {
            sideY = (0, $1LHyG.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1LHyG.left) || (placement === (0, $1LHyG.top) || placement === (0, $1LHyG.bottom)) && variation === (0, $1LHyG.end)) {
            sideX = (0, $1LHyG.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6df13fe20ccb3860$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6df13fe20ccb3860$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fWmj3.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6df13fe20ccb3860$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $ix6Fe.default)(state.placement),
        variation: (0, $3nitp.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6df13fe20ccb3860$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6df13fe20ccb3860$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6df13fe20ccb3860$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6df13fe20ccb3860$var$computeStyles,
    data: {}
};

});

parcelRegister("9HkoV", function(module, exports) {
$parcel$export(module.exports, "default", () => $70f7f4679a787bbc$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");
// and applies them to the HTMLElements such as popper and arrow
function $70f7f4679a787bbc$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gg6Qu.isHTMLElement)(element) || !(0, $4baem.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $70f7f4679a787bbc$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gg6Qu.isHTMLElement)(element) || !(0, $4baem.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $70f7f4679a787bbc$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $70f7f4679a787bbc$var$applyStyles,
    effect: $70f7f4679a787bbc$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("f7Vnd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b034039cedbbe126$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $1LHyG = parcelRequire("1LHyG");
function $b034039cedbbe126$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $ix6Fe.default)(placement);
    var invertDistance = [
        (0, $1LHyG.left),
        (0, $1LHyG.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1LHyG.left),
        (0, $1LHyG.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $b034039cedbbe126$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1LHyG.placements).reduce(function(acc, placement) {
        acc[placement] = $b034039cedbbe126$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b034039cedbbe126$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $b034039cedbbe126$var$offset
};

});

parcelRegister("6DBHs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d53a105c719d71f$export$2e2bcd8739ae039);

var $jEhSs = parcelRequire("jEhSs");

var $ix6Fe = parcelRequire("ix6Fe");

var $3nM6l = parcelRequire("3nM6l");

var $2L52j = parcelRequire("2L52j");

var $zvQQI = parcelRequire("zvQQI");

var $1LHyG = parcelRequire("1LHyG");

var $3nitp = parcelRequire("3nitp");
function $4d53a105c719d71f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $ix6Fe.default)(placement) === (0, $1LHyG.auto)) return [];
    var oppositePlacement = (0, $jEhSs.default)(placement);
    return [
        (0, $3nM6l.default)(placement),
        oppositePlacement,
        (0, $3nM6l.default)(oppositePlacement)
    ];
}
function $4d53a105c719d71f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $ix6Fe.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jEhSs.default)(preferredPlacement)
    ] : $4d53a105c719d71f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $ix6Fe.default)(placement) === (0, $1LHyG.auto) ? (0, $zvQQI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $ix6Fe.default)(placement);
        var isStartVariation = (0, $3nitp.default)(placement) === (0, $1LHyG.start);
        var isVertical = [
            (0, $1LHyG.top),
            (0, $1LHyG.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $2L52j.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1LHyG.right) : (0, $1LHyG.left) : isStartVariation ? (0, $1LHyG.bottom) : (0, $1LHyG.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jEhSs.default)(mainVariationSide);
        var altVariationSide = (0, $jEhSs.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4d53a105c719d71f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4d53a105c719d71f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jEhSs", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4df9ecf09fd7b98$export$2e2bcd8739ae039);
var $e4df9ecf09fd7b98$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e4df9ecf09fd7b98$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e4df9ecf09fd7b98$var$hash[matched];
    });
}

});

parcelRegister("3nM6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $2768d4fade00acc0$export$2e2bcd8739ae039);
var $2768d4fade00acc0$var$hash = {
    start: 'end',
    end: 'start'
};
function $2768d4fade00acc0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2768d4fade00acc0$var$hash[matched];
    });
}

});

parcelRegister("2L52j", function(module, exports) {
$parcel$export(module.exports, "default", () => $2023e0a84dae9603$export$2e2bcd8739ae039);

var $9x9tN = parcelRequire("9x9tN");

var $7gyBU = parcelRequire("7gyBU");

var $k65dW = parcelRequire("k65dW");

var $fl9ah = parcelRequire("fl9ah");

var $in7or = parcelRequire("in7or");

var $1LHyG = parcelRequire("1LHyG");

var $gg6Qu = parcelRequire("gg6Qu");

var $LmsI1 = parcelRequire("LmsI1");

var $dOabu = parcelRequire("dOabu");
function $2023e0a84dae9603$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1LHyG.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1LHyG.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1LHyG.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $LmsI1.default)(typeof padding !== 'number' ? padding : (0, $dOabu.default)(padding, (0, $1LHyG.basePlacements)));
    var altContext = elementContext === (0, $1LHyG.popper) ? (0, $1LHyG.reference) : (0, $1LHyG.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $9x9tN.default)((0, $gg6Qu.isElement)(element) ? element : element.contextElement || (0, $7gyBU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $k65dW.default)(state.elements.reference);
    var popperOffsets = (0, $fl9ah.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $in7or.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1LHyG.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1LHyG.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1LHyG.right),
                (0, $1LHyG.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1LHyG.top),
                (0, $1LHyG.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("9x9tN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f0e8c9530387084$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $3xt5L = parcelRequire("3xt5L");

var $9oWt3 = parcelRequire("9oWt3");

var $kXPOQ = parcelRequire("kXPOQ");

var $5hADZ = parcelRequire("5hADZ");

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $gg6Qu = parcelRequire("gg6Qu");

var $k65dW = parcelRequire("k65dW");

var $5ewz1 = parcelRequire("5ewz1");

var $96vJk = parcelRequire("96vJk");

var $4baem = parcelRequire("4baem");

var $in7or = parcelRequire("in7or");

var $8amqe = parcelRequire("8amqe");
function $6f0e8c9530387084$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $k65dW.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $6f0e8c9530387084$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1LHyG.viewport) ? (0, $in7or.default)((0, $3xt5L.default)(element, strategy)) : (0, $gg6Qu.isElement)(clippingParent) ? $6f0e8c9530387084$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $in7or.default)((0, $9oWt3.default)((0, $7gyBU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $6f0e8c9530387084$var$getClippingParents(element) {
    var clippingParents = (0, $kXPOQ.default)((0, $5ewz1.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $gJ1QC.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gg6Qu.isHTMLElement)(element) ? (0, $5hADZ.default)(element) : element;
    if (!(0, $gg6Qu.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gg6Qu.isElement)(clippingParent) && (0, $96vJk.default)(clippingParent, clipperElement) && (0, $4baem.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $6f0e8c9530387084$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $6f0e8c9530387084$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $6f0e8c9530387084$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8amqe.max)(rect.top, accRect.top);
        accRect.right = (0, $8amqe.min)(rect.right, accRect.right);
        accRect.bottom = (0, $8amqe.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8amqe.max)(rect.left, accRect.left);
        return accRect;
    }, $6f0e8c9530387084$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3xt5L", function(module, exports) {
$parcel$export(module.exports, "default", () => $293b0537fae813b9$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");

var $7gyBU = parcelRequire("7gyBU");

var $2uwXd = parcelRequire("2uwXd");

var $2aPrh = parcelRequire("2aPrh");
function $293b0537fae813b9$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWmj3.default)(element);
    var html = (0, $7gyBU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2aPrh.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2uwXd.default)(element),
        y: y
    };
}

});

parcelRegister("9oWt3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d83b5603b3586ee$export$2e2bcd8739ae039);

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $2uwXd = parcelRequire("2uwXd");

var $cOno9 = parcelRequire("cOno9");

var $8amqe = parcelRequire("8amqe");
function $6d83b5603b3586ee$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7gyBU.default)(element);
    var winScroll = (0, $cOno9.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8amqe.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8amqe.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2uwXd.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $gJ1QC.default)(body || html).direction === 'rtl') x += (0, $8amqe.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("96vJk", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a0d498ab041b2ae$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");
function $6a0d498ab041b2ae$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gg6Qu.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("in7or", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6001c20f097600c$export$2e2bcd8739ae039);
function $d6001c20f097600c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("LmsI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e5d065659557f4$export$2e2bcd8739ae039);

var $hiKju = parcelRequire("hiKju");
function $08e5d065659557f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $hiKju.default)(), paddingObject);
}

});
parcelRegister("hiKju", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9880af3f66b6790$export$2e2bcd8739ae039);
function $c9880af3f66b6790$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("dOabu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0d7d8467385dc15$export$2e2bcd8739ae039);
function $a0d7d8467385dc15$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("zvQQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $06abfa066cc434b3$export$2e2bcd8739ae039);

var $3nitp = parcelRequire("3nitp");

var $1LHyG = parcelRequire("1LHyG");

var $2L52j = parcelRequire("2L52j");

var $ix6Fe = parcelRequire("ix6Fe");
function $06abfa066cc434b3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1LHyG.placements) : _options$allowedAutoP;
    var variation = (0, $3nitp.default)(placement);
    var placements = variation ? flipVariations ? (0, $1LHyG.variationPlacements) : (0, $1LHyG.variationPlacements).filter(function(placement) {
        return (0, $3nitp.default)(placement) === variation;
    }) : (0, $1LHyG.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $2L52j.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $ix6Fe.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("31C6T", function(module, exports) {
$parcel$export(module.exports, "default", () => $233f06fcebd46aab$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $ix6Fe = parcelRequire("ix6Fe");

var $aRMwh = parcelRequire("aRMwh");

var $52Fp0 = parcelRequire("52Fp0");

var $hPHoq = parcelRequire("hPHoq");

var $9J30E = parcelRequire("9J30E");

var $5hADZ = parcelRequire("5hADZ");

var $2L52j = parcelRequire("2L52j");

var $3nitp = parcelRequire("3nitp");

var $hiKju = parcelRequire("hiKju");

var $8amqe = parcelRequire("8amqe");
function $233f06fcebd46aab$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $2L52j.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $ix6Fe.default)(state.placement);
    var variation = (0, $3nitp.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $aRMwh.default)(basePlacement);
    var altAxis = (0, $52Fp0.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1LHyG.top) : (0, $1LHyG.left);
        var altSide = mainAxis === 'y' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1LHyG.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1LHyG.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9J30E.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $hiKju.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $hPHoq.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5hADZ.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $hPHoq.within)(tether ? (0, $8amqe.min)(min, tetherMin) : min, offset, tether ? (0, $8amqe.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1LHyG.top) : (0, $1LHyG.left);
        var _altSide = mainAxis === 'x' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1LHyG.top),
            (0, $1LHyG.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $hPHoq.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $hPHoq.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $233f06fcebd46aab$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $233f06fcebd46aab$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("52Fp0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3abd4144d8cebe00$export$2e2bcd8739ae039);
function $3abd4144d8cebe00$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("hPHoq", function(module, exports) {
$parcel$export(module.exports, "within", () => $cfb8dc0327546b5f$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $cfb8dc0327546b5f$export$86c8af6d3ef0b4a);

var $8amqe = parcelRequire("8amqe");
function $cfb8dc0327546b5f$export$f28d906d67a997f3(min, value, max) {
    return (0, $8amqe.max)(min, (0, $8amqe.min)(value, max));
}
function $cfb8dc0327546b5f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $cfb8dc0327546b5f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("a6oPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $75adb9ab5729b460$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $9J30E = parcelRequire("9J30E");

var $96vJk = parcelRequire("96vJk");

var $5hADZ = parcelRequire("5hADZ");

var $aRMwh = parcelRequire("aRMwh");

var $hPHoq = parcelRequire("hPHoq");

var $LmsI1 = parcelRequire("LmsI1");

var $dOabu = parcelRequire("dOabu");

var $1LHyG = parcelRequire("1LHyG");
var $75adb9ab5729b460$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $LmsI1.default)(typeof padding !== 'number' ? padding : (0, $dOabu.default)(padding, (0, $1LHyG.basePlacements)));
};
function $75adb9ab5729b460$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $ix6Fe.default)(state.placement);
    var axis = (0, $aRMwh.default)(basePlacement);
    var isVertical = [
        (0, $1LHyG.left),
        (0, $1LHyG.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $75adb9ab5729b460$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9J30E.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1LHyG.top) : (0, $1LHyG.left);
    var maxProp = axis === 'y' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5hADZ.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $hPHoq.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $75adb9ab5729b460$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $96vJk.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $75adb9ab5729b460$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $75adb9ab5729b460$var$arrow,
    effect: $75adb9ab5729b460$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("c2Bzy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c42d10fef006a34$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $2L52j = parcelRequire("2L52j");
function $8c42d10fef006a34$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $8c42d10fef006a34$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1LHyG.top),
        (0, $1LHyG.right),
        (0, $1LHyG.bottom),
        (0, $1LHyG.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $8c42d10fef006a34$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $2L52j.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $2L52j.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $8c42d10fef006a34$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $8c42d10fef006a34$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $8c42d10fef006a34$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $8c42d10fef006a34$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $8c42d10fef006a34$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $8c42d10fef006a34$var$hide
};

});




parcelRegister("lEbH4", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $fc26678a4f3d738c$export$e0be378c32fb70a7);

var $eJOHy = parcelRequire("eJOHy");

var $9Hk5t = parcelRequire("9Hk5t");

var $7QJq6 = parcelRequire("7QJq6");

var $65sWw = parcelRequire("65sWw");
function $fc26678a4f3d738c$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eJOHy.useContext((0, $7QJq6.ManagerReferenceNodeSetterContext));
    var refHandler = $eJOHy.useCallback(function(node) {
        (0, $65sWw.setRef)(innerRef, node);
        (0, $65sWw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eJOHy.useEffect(function() {
        return function() {
            return (0, $65sWw.setRef)(innerRef, null);
        };
    }, []);
    $eJOHy.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9Hk5t)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $65sWw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("5yteI", function(module, exports) {
$parcel$export(module.exports, "shallowEqualObjects", () => $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c);
function $40b6ce70abc0b2ca$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $40b6ce70abc0b2ca$export$967a6b9924a689f7(a, b);
    return $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5nAXq", function(module, exports) {
$parcel$export(module.exports, "MenuDialog", () => $962253e5722485a0$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $962253e5722485a0$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $962253e5722485a0$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dqx2X = parcelRequire("dqx2X");

var $6XEne = parcelRequire("6XEne");

var $6fs4r = parcelRequire("6fs4r");
const $962253e5722485a0$var$menuDialogStyles = null;
const $962253e5722485a0$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $962253e5722485a0$var$dropdownStyles = null;
const $962253e5722485a0$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqx2X))), {
            color: "currentColor",
            label: ""
        })
    });
const $962253e5722485a0$var$controlStyles = null;
const $962253e5722485a0$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: innerRef,
        className: (0, $hcewu.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $962253e5722485a0$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $962253e5722485a0$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $962253e5722485a0$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ClearIndicator, {
        ...props
    });
const $962253e5722485a0$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).MultiValueRemove, {
        ...props
    });
const $962253e5722485a0$export$71abc632aa29e6fe = {
    Control: $962253e5722485a0$var$Control,
    DropdownIndicator: $962253e5722485a0$var$DropdownIndicator,
    Menu: $962253e5722485a0$var$Menu,
    ClearIndicator: $962253e5722485a0$var$ClearIndicator,
    MultiValueRemove: $962253e5722485a0$var$MultiValueRemove
};

});
parcelRegister("dqx2X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2d61a8b9264c17f51d6b1ce92a21fc9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c675677f12a1926$var$_react = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9c675677f12a1926$var$_search = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("dt3aG")));

var $9c675677f12a1926$var$_search2 = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("dPkHp")));
function $9c675677f12a1926$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c675677f12a1926$var$SearchIcon = (props)=>/*#__PURE__*/ $9c675677f12a1926$var$_react.default.createElement($9c675677f12a1926$var$_search.default, Object.assign({
        name: "SearchIcon",
        LEGACY_fallbackIcon: $9c675677f12a1926$var$_search2.default
    }, props));
$9c675677f12a1926$var$SearchIcon.displayName = 'SearchIconMigration';
var $9c675677f12a1926$var$_default = module.exports.default = $9c675677f12a1926$var$SearchIcon;

});
parcelRegister("dPkHp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a110182f06b4ad6b$var$_react = $a110182f06b4ad6b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a110182f06b4ad6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a110182f06b4ad6b$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $a110182f06b4ad6b$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props));
$a110182f06b4ad6b$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $a110182f06b4ad6b$var$_default = module.exports.default = $a110182f06b4ad6b$var$EditorSearchIcon;

});



parcelRegister("ctyCN", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $5efc0b15e3dedaed$export$17baa7c95b6ba1b8);

var $5NYi5 = parcelRequire("5NYi5");
function $5efc0b15e3dedaed$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $5NYi5.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});




parcelRegister("4yPQa", function(module, exports) {
$parcel$export(module.exports, "batchByKey", () => $0defaf7e1ec76e58$export$da86c38211c1c0a8);
function $0defaf7e1ec76e58$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("aemwP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $909cb0f93070a370$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $909cb0f93070a370$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    otherAtlassianSourceAppify: {
        id: 'fabric.elements.user-picker.source.other-atlassian-appify',
        defaultMessage: 'Other Atlassian apps',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    },
    userTypeLabel: {
        id: 'fabric.elements.user-picker.user.type.label',
        defaultMessage: 'People',
        description: 'Label for user type'
    },
    teamTypeLabel: {
        id: 'fabric.elements.user-picker.team.type.label',
        defaultMessage: 'Teams',
        description: 'Label for team type'
    },
    emailTypeLabel: {
        id: 'fabric.elements.user-picker.email.type.label',
        defaultMessage: 'Emails',
        description: 'Label for email type'
    },
    groupTypeLabel: {
        id: 'fabric.elements.user-picker.group.type.label',
        defaultMessage: 'Groups',
        description: 'Label for group type'
    },
    externalUserTypeLabel: {
        id: 'fabric.elements.user-picker.external.user.type.label',
        defaultMessage: 'External Users',
        description: 'Label for external user type'
    },
    customTypeLabel: {
        id: 'fabric.elements.user-picker.custom.type.label',
        defaultMessage: 'Customs',
        description: 'Label for custom type'
    },
    otherTypeLabel: {
        id: 'fabric.elements.user-picker.other.type.label',
        defaultMessage: 'Others',
        description: 'Label for other type'
    }
});

});

parcelRegister("ersOA", function(module, exports) {
$parcel$export(module.exports, "groupOptionsByType", () => $b84ef595e65cee7a$export$393a985f7dd07cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $LFmXM = parcelRequire("LFmXM");

var $aemwP = parcelRequire("aemwP");
const $b84ef595e65cee7a$var$getLabelForType = (type)=>{
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).otherTypeLabel
            });
    }
};
const $b84ef595e65cee7a$export$393a985f7dd07cfe = (0, $LFmXM.default)((options, groupByTypeOrder)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $b84ef595e65cee7a$var$getLabelForType(type),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});

});

parcelRegister("1FdfR", function(module, exports) {
$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $7336f83ae434c834$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $7336f83ae434c834$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $7336f83ae434c834$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $g0oDq = parcelRequire("g0oDq");
const $7336f83ae434c834$export$b49757166e1acfc2 = new (0, $9iIu4.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $7336f83ae434c834$export$135a264e0da507ae = new (0, $9iIu4.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $aRnO1.ExperienceTypes).Operation,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
});
class $7336f83ae434c834$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        const instance = $7336f83ae434c834$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $g0oDq.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("9iIu4", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $a5bd41df052e3fc6$export$ac1cddfee07ba6ac);

var $jJiQE = parcelRequire("jJiQE");

var $2pMzV = parcelRequire("2pMzV");
class $a5bd41df052e3fc6$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $2pMzV.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $jJiQE.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});



parcelRegister("7Vnqr", function(module, exports) {
$parcel$export(module.exports, "getStyles", () => $b204074a529ee29d$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $b204074a529ee29d$export$4e983f376ad8a3af);


var $LFmXM = parcelRequire("LFmXM");

var $e9zKl = parcelRequire("e9zKl");

var $eGOwo = parcelRequire("eGOwo");
const $b204074a529ee29d$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $b204074a529ee29d$export$53937c04f7dfc2ae = 6;
const $b204074a529ee29d$export$2c62ba763e976c54 = 39;
const $b204074a529ee29d$export$ffd58b7f6f099a57 = (0, $LFmXM.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.isInvalid ? `var(--ds-border-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a})` : state.isInvalid ? `var(--ds-border-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $7bb4c1736002a04a$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: height && (0, $eGOwo.fg)('jifjam_bulk_operations') || isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height && (0, $eGOwo.fg)('jifjam_bulk_operations') ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                paddingLeft: isMulti ? $b204074a529ee29d$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$b204074a529ee29d$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $e9zKl.mergeStyles)(styles, overrideStyles) : styles;
});
const $b204074a529ee29d$export$4e983f376ad8a3af = (0, $LFmXM.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$b204074a529ee29d$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));

});

parcelRegister("6jfsf", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $3d7d6756f5b5a2a8$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $3d7d6756f5b5a2a8$export$19205fd341a6bb08);

var $LFmXM = parcelRequire("LFmXM");

var $7voaJ = parcelRequire("7voaJ");

var $1vhOe = parcelRequire("1vhOe");

var $1dESj = parcelRequire("1dESj");

var $bOZ4r = parcelRequire("bOZ4r");

var $dY5oB = parcelRequire("dY5oB");

var $3uumP = parcelRequire("3uumP");

var $bVfPa = parcelRequire("bVfPa");

var $6FUJ9 = parcelRequire("6FUJ9");

var $gIhcD = parcelRequire("gIhcD");

var $75q59 = parcelRequire("75q59");

var $716IA = parcelRequire("716IA");
const $3d7d6756f5b5a2a8$export$4e811121b221213b = (0, $LFmXM.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $bOZ4r.Option
    };
    else return {
        MultiValue: $1vhOe.MultiValue,
        DropdownIndicator: null,
        SingleValue: $dY5oB.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $7voaJ.ClearIndicator) : null,
        Option: $bOZ4r.Option,
        ValueContainer: multi ? (0, $1dESj.MultiValueContainer) : (0, $bVfPa.SingleValueContainer),
        Input: $3uumP.Input,
        Menu: $75q59.Menu,
        Control: $716IA.default,
        ...customComponents ? customComponents : {}
    };
});
const $3d7d6756f5b5a2a8$export$19205fd341a6bb08 = (0, $LFmXM.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $dY5oB.SingleValue,
        ClearIndicator: $7voaJ.ClearIndicator,
        Option: $bOZ4r.Option,
        ValueContainer: (0, $bVfPa.SingleValueContainer),
        Input: (0, $6FUJ9.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $gIhcD.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("7voaJ", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $c06818ca522ce9a4$export$ecf9cf59142dd54a);
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

const $c06818ca522ce9a4$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("kMzLg")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $c06818ca522ce9a4$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $c06818ca522ce9a4$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $c06818ca522ce9a4$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($c06818ca522ce9a4$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("kMzLg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1sNWi").then(()=>parcelRequire('jJiSi'));

});


parcelRegister("1vhOe", function(module, exports) {
$parcel$export(module.exports, "MultiValue", () => $340817c48ea29dd5$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");

var $1NIU8 = parcelRequire("1NIU8");

var $8FxQe = parcelRequire("8FxQe");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $hMpZ8 = parcelRequire("hMpZ8");

var $lXcOw = parcelRequire("lXcOw");
function $340817c48ea29dd5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $340817c48ea29dd5$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $340817c48ea29dd5$var$groupTagContainer = (0, $1DXK0.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $340817c48ea29dd5$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $340817c48ea29dd5$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $bp6ad.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8FxQe.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $bp6ad.isGroup)(data)) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
                xcss: $340817c48ea29dd5$var$groupTagContainer
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: "multi",
                src: (0, $bp6ad.getAvatarUrl)(data),
                type: (0, $bp6ad.isTeam)(data) ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $bp6ad.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lXcOw.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $340817c48ea29dd5$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6XEne.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3Wh6p.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $340817c48ea29dd5$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("8FxQe", function(module, exports) {
$parcel$export(module.exports, "AddOptionAvatar", () => $b392ae2eb4910fe7$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dNLHm = parcelRequire("dNLHm");


var $1NIU8 = parcelRequire("1NIU8");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $b392ae2eb4910fe7$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction && (0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-background-warning, #FFF7D6)" : `var(--ds-background-neutral, ${0, $7bb4c1736002a04a$export$1ce2d1575d444ceb})`;
    return /*#__PURE__*/ (0, $1NIU8.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $b392ae2eb4910fe7$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $b392ae2eb4910fe7$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dNLHm))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: isPendingAction && (0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-text-warning, #A54800)" : `var(--ds-text-subtle, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})`
    })));
};

});
parcelRegister("dNLHm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5776dc85eb34bd4bbf9313d62b1b5459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0c4d9df726ba45c$var$_react = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a0c4d9df726ba45c$var$_email = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("hluWa")));

var $a0c4d9df726ba45c$var$_email2 = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("4ZN93")));
function $a0c4d9df726ba45c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0c4d9df726ba45c$var$EmailIcon = (props)=>/*#__PURE__*/ $a0c4d9df726ba45c$var$_react.default.createElement($a0c4d9df726ba45c$var$_email.default, Object.assign({
        name: "EmailIcon",
        LEGACY_fallbackIcon: $a0c4d9df726ba45c$var$_email2.default
    }, props));
$a0c4d9df726ba45c$var$EmailIcon.displayName = 'EmailIconMigration';
var $a0c4d9df726ba45c$var$_default = module.exports.default = $a0c4d9df726ba45c$var$EmailIcon;

});
parcelRegister("4ZN93", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a32fb20eb7dd93a$var$_react = $3a32fb20eb7dd93a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3a32fb20eb7dd93a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3a32fb20eb7dd93a$var$EmailIcon = (props)=>/*#__PURE__*/ $3a32fb20eb7dd93a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props));
$3a32fb20eb7dd93a$var$EmailIcon.displayName = 'EmailIcon';
var $3a32fb20eb7dd93a$var$_default = module.exports.default = $3a32fb20eb7dd93a$var$EmailIcon;

});



parcelRegister("k7nMY", function(module, exports) {
$parcel$export(module.exports, "SizeableAvatar", () => $d0269580cbf343f0$export$44d81a88129649da);

var $gt9Am = parcelRequire("gt9Am");

var $5DgXR = parcelRequire("5DgXR");

var $6qS8z = parcelRequire("6qS8z");

var $eJOHy = parcelRequire("eJOHy");

var $bp6ad = parcelRequire("bp6ad");
class $d0269580cbf343f0$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const props = {
            size: (0, $bp6ad.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qS8z.default), {
            ...props
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
            ...props
        });
    }
}

});
parcelRegister("6qS8z", function(module, exports) {
$parcel$export(module.exports, "default", () => $502b93618fdc9c00$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");


var $6qfsx = parcelRequire("6qfsx");
const $502b93618fdc9c00$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`;
const $502b93618fdc9c00$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$7c87d337fb91a97d)})`;
function $502b93618fdc9c00$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qfsx.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
}

});
parcelRegister("6qfsx", function(module, exports) {
$parcel$export(module.exports, "TeamAvatarImage", () => $deb06dadb11ac687$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $efgFx = parcelRequire("efgFx");

var $aYBsz = parcelRequire("aYBsz");
const $deb06dadb11ac687$var$boxShadowCssVar = '--avatar-box-shadow';
const $deb06dadb11ac687$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $deb06dadb11ac687$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $deb06dadb11ac687$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $deb06dadb11ac687$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $deb06dadb11ac687$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $deb06dadb11ac687$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $deb06dadb11ac687$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $deb06dadb11ac687$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const avatarSrc = (0, $aYBsz.getTeamAvatarSrc)(src, teamId);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $efgFx.FallbackAvatar), {
        "aria-label": alt,
        width: $deb06dadb11ac687$var$SIZES[size],
        height: $deb06dadb11ac687$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $hcewu.default)([
            $deb06dadb11ac687$var$unboundStyles.root,
            $deb06dadb11ac687$var$containerStyles.root,
            $deb06dadb11ac687$var$borderRadiusMap[size],
            $deb06dadb11ac687$var$widthHeightMap[size],
            compact ? $deb06dadb11ac687$var$containerStyles.compactSpacing : $deb06dadb11ac687$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $hcewu.default)([
                $deb06dadb11ac687$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("efgFx", function(module, exports) {
$parcel$export(module.exports, "FallbackAvatar", () => $9a97cfaf5fcee5b8$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $9a97cfaf5fcee5b8$var$styles = {
    wrapper: "_1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
function $9a97cfaf5fcee5b8$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($9a97cfaf5fcee5b8$var$styles.wrapper, props.compact ? $9a97cfaf5fcee5b8$var$styles.compactWrapperSpacing : $9a97cfaf5fcee5b8$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("aYBsz", function(module, exports) {
$parcel$export(module.exports, "getTeamAvatarSrc", () => $70cc3a7a823af077$export$59ff7d19feb890b6);
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $70cc3a7a823af077$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return undefined;
}

});




parcelRegister("hMpZ8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77421a4093efbe74a1bbe8da5d5c5bff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf1b13700915d1ca$var$_react = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $cf1b13700915d1ca$var$_peopleGroup = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $cf1b13700915d1ca$var$_people = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("9HVF4")));
function $cf1b13700915d1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf1b13700915d1ca$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $cf1b13700915d1ca$var$_react.default.createElement($cf1b13700915d1ca$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $cf1b13700915d1ca$var$_people.default
    }, props));
$cf1b13700915d1ca$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $cf1b13700915d1ca$var$_default = module.exports.default = $cf1b13700915d1ca$var$PeopleGroupIcon;

});
parcelRegister("9HVF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7114db95708449c8$var$_react = $7114db95708449c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7114db95708449c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7114db95708449c8$var$PeopleIcon = (props)=>/*#__PURE__*/ $7114db95708449c8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props));
$7114db95708449c8$var$PeopleIcon.displayName = 'PeopleIcon';
var $7114db95708449c8$var$_default = module.exports.default = $7114db95708449c8$var$PeopleIcon;

});


parcelRegister("lXcOw", function(module, exports) {
$parcel$export(module.exports, "VerifiedTeamIcon", () => $c2242de582b8e66d$export$d7949f68d31e5edd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $acRfo = parcelRequire("acRfo");

var $k71qx = parcelRequire("k71qx");

var $6dApG = parcelRequire("6dApG");
const $c2242de582b8e66d$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $6dApG.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acRfo))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    size: size,
                    label: tooltipContent,
                    spacing: "spacious"
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acRfo))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        size: size,
        spacing: "spacious",
        label: label
    });
};

});
parcelRegister("acRfo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50a6e4dd8b62d7d7bf2cfae0d8c6979>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76e454285004b3dd$var$_react = $76e454285004b3dd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $76e454285004b3dd$var$_baseNew = $76e454285004b3dd$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $76e454285004b3dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76e454285004b3dd$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $76e454285004b3dd$var$_react.default.createElement($76e454285004b3dd$var$_baseNew.default, Object.assign({
        name: "StatusVerifiedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$76e454285004b3dd$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $76e454285004b3dd$var$_default = module.exports.default = $76e454285004b3dd$var$StatusVerifiedIcon;

});

parcelRegister("6dApG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $369d053bcf2cee48$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $369d053bcf2cee48$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("1dESj", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $d3c7ccc28b39ddcc$export$cf9cf2a30a59265c);
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $6XEne = parcelRequire("6XEne");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $aemwP = parcelRequire("aemwP");

var $bp6ad = parcelRequire("bp6ad");

var $bM37l = parcelRequire("bM37l");
const $d3c7ccc28b39ddcc$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
class $d3c7ccc28b39ddcc$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(this.props.children, (child)=>(0, $bp6ad.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bM37l.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ValueContainer, {
                ...props,
                xcss: $d3c7ccc28b39ddcc$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("bM37l", function(module, exports) {
$parcel$export(module.exports, "default", () => $892064a436200311$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $892064a436200311$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $892064a436200311$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $892064a436200311$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $892064a436200311$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $892064a436200311$export$2e2bcd8739ae039 = $892064a436200311$var$ValueContainerWrapper;

});


parcelRegister("bOZ4r", function(module, exports) {
$parcel$export(module.exports, "Option", () => $07ff0c926ef0e179$export$36d18380658d5d20);

var $gt9Am = parcelRequire("gt9Am");

var $8IeH1 = parcelRequire("8IeH1");

var $6XEne = parcelRequire("6XEne");

var $k71qx = parcelRequire("k71qx");

var $eJOHy = parcelRequire("eJOHy");

var $b5om0 = parcelRequire("b5om0");

var $9efgr = parcelRequire("9efgr");

var $k0Plf = parcelRequire("k0Plf");

var $2tKwH = parcelRequire("2tKwH");

var $4A9Tu = parcelRequire("4A9Tu");

var $5wrPY = parcelRequire("5wrPY");

var $bp6ad = parcelRequire("bp6ad");

var $2lvD5 = parcelRequire("2lvD5");
const $07ff0c926ef0e179$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b5om0.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $07ff0c926ef0e179$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $bp6ad.isExternalUser)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9efgr.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isUser)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b5om0.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isEmail)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4A9Tu.default), {
        email: data,
        emailValidity: (0, $2lvD5.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $bp6ad.isTeam)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k0Plf.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isGroup)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKwH.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isCustom)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5wrPY.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $07ff0c926ef0e179$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                ...tooltipProps,
                children: $07ff0c926ef0e179$var$dataOption(props)
            })
    });
    return $07ff0c926ef0e179$var$dataOption(props);
};
const $07ff0c926ef0e179$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: $07ff0c926ef0e179$var$defaultOption(props),
            children: $07ff0c926ef0e179$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("b5om0", function(module, exports) {
$parcel$export(module.exports, "UserOption", () => $0453b1bfd2244edc$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $j8kj1 = parcelRequire("j8kj1");


var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $6pxNU = parcelRequire("6pxNU");

var $55xVv = parcelRequire("55xVv");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $eGOwo = parcelRequire("eGOwo");
class $0453b1bfd2244edc$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6pxNU.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $6pxNU.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $7bb4c1736002a04a$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $55xVv.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $bp6ad.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $6pxNU.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $1NIU8.jsx)((0, $55xVv.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $6pxNU.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType }, status: status } = this.props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: (0, $eGOwo.fg)('platform-component-visual-refresh') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $eGOwo.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $j8kj1.getAppearanceForAppType)(appType) : undefined
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("6pxNU", function(module, exports) {
$parcel$export(module.exports, "textWrapper", () => $8382733eea54494c$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $8382733eea54494c$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $jdqdp = parcelRequire("jdqdp");

var $bp6ad = parcelRequire("bp6ad");
function $8382733eea54494c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $8382733eea54494c$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("kMzLg")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $8382733eea54494c$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $1NIU8.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $8382733eea54494c$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $8382733eea54494c$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $1NIU8.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $8382733eea54494c$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $8382733eea54494c$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $1NIU8.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $8382733eea54494c$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $bp6ad.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
                fallback: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($8382733eea54494c$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $8382733eea54494c$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$optionWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("55xVv", function(module, exports) {
$parcel$export(module.exports, "HighlightText", () => $9cb1b36ba7348cca$export$bb02e7bc6e1a7119);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $9cb1b36ba7348cca$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("9efgr", function(module, exports) {
$parcel$export(module.exports, "default", () => $980dbe247ee3b37d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $980dbe247ee3b37d$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("zvTks")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $980dbe247ee3b37d$export$2e2bcd8739ae039 = $980dbe247ee3b37d$var$AsyncExternalUserOption;

});
parcelRegister("zvTks", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("cm3wZ")
]).then(()=>parcelRequire('4cxzb'));

});


parcelRegister("k0Plf", function(module, exports) {
$parcel$export(module.exports, "default", () => $95d6477fc9cb5ac2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $95d6477fc9cb5ac2$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("ampxd")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $95d6477fc9cb5ac2$export$2e2bcd8739ae039 = $95d6477fc9cb5ac2$var$AsyncTeamOption;

});
parcelRegister("ampxd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dVG7s").then(()=>parcelRequire('1S96L'));

});


parcelRegister("2tKwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aaf40607abeee08$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $0aaf40607abeee08$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("8Gji4")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $0aaf40607abeee08$export$2e2bcd8739ae039 = $0aaf40607abeee08$var$AsyncGroupOption;

});
parcelRegister("8Gji4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bwgIM").then(()=>parcelRequire('kSMc2'));

});


parcelRegister("4A9Tu", function(module, exports) {
$parcel$export(module.exports, "default", () => $eed72ec3262bf21d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $eed72ec3262bf21d$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("dyBmT")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $eed72ec3262bf21d$export$2e2bcd8739ae039 = $eed72ec3262bf21d$var$AsyncEmailOption;

});
parcelRegister("dyBmT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8aLon").then(()=>parcelRequire('hpXeN'));

});


parcelRegister("5wrPY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6711e764ffd94797$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $6711e764ffd94797$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("riO7J")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $6711e764ffd94797$export$2e2bcd8739ae039 = $6711e764ffd94797$var$AsyncCustomOption;

});
parcelRegister("riO7J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4SKbF").then(()=>parcelRequire('hVJCF'));

});


parcelRegister("2lvD5", function(module, exports) {
$parcel$export(module.exports, "isValidEmail", () => $f55e7fe2bf1c50c8$export$371e338370561054);
const $f55e7fe2bf1c50c8$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $f55e7fe2bf1c50c8$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $f55e7fe2bf1c50c8$export$371e338370561054 = (inputText)=>{
    if (inputText.match($f55e7fe2bf1c50c8$var$validRegex)) return 'VALID';
    if (inputText.match($f55e7fe2bf1c50c8$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("dY5oB", function(module, exports) {
$parcel$export(module.exports, "SingleValue", () => $dd81b53dbb8a3847$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $lXcOw = parcelRequire("lXcOw");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
const $dd81b53dbb8a3847$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $dd81b53dbb8a3847$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $bp6ad.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lXcOw.VerifiedTeamIcon), {});
    return null;
};
const $dd81b53dbb8a3847$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
            xcss: $dd81b53dbb8a3847$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7nMY.SizeableAvatar), {
                    src: (0, $bp6ad.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $bp6ad.isTeam)(data) ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $dd81b53dbb8a3847$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $dd81b53dbb8a3847$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $dd81b53dbb8a3847$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $gt9Am.jsx)($dd81b53dbb8a3847$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("3uumP", function(module, exports) {
$parcel$export(module.exports, "Input", () => $52276fbb29701503$export$f5b8910cec6cf069);
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $52276fbb29701503$var$inputStyles = {
    root: "_5ce6131l _1ir3kb7n _h5gq131l"
};
class $52276fbb29701503$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $52276fbb29701503$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("bVfPa", function(module, exports) {
$parcel$export(module.exports, "SingleValueContainer", () => $5b6f667c12b37e80$export$afa5f855316c6a48);
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $k7nMY = parcelRequire("k7nMY");

var $bM37l = parcelRequire("bM37l");
const $5b6f667c12b37e80$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
const $5b6f667c12b37e80$var$placeholderIconContainer = null;
const $5b6f667c12b37e80$var$wrapperStyle = null;
const $5b6f667c12b37e80$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $5b6f667c12b37e80$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bM37l.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6XEne.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $5b6f667c12b37e80$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $5b6f667c12b37e80$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $hcewu.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        };
    }
}

});

parcelRegister("6FUJ9", function(module, exports) {
$parcel$export(module.exports, "PopupInput", () => $cd9d7ed309b03307$export$d8edbfd510a7db82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3uumP = parcelRequire("3uumP");
class $cd9d7ed309b03307$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uumP.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("gIhcD", function(module, exports) {
$parcel$export(module.exports, "PopupControl", () => $d6cc2469d7e5c609$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $716IA = parcelRequire("716IA");
const $d6cc2469d7e5c609$var$controlWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $d6cc2469d7e5c609$var$labelStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $d6cc2469d7e5c609$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $d6cc2469d7e5c609$var$controlWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $d6cc2469d7e5c609$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $716IA.default), this.props));
    }
}

});
parcelRegister("716IA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3518ae22f57ffbfc$export$2e2bcd8739ae039);
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $k0ahr = parcelRequire("k0ahr");
const $3518ae22f57ffbfc$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1p6i _bfhk1j9a _4cvx1p6i _irr31j9a",
    disabled: "_irr3syzs",
    subtle: "_1h6d3acm _bfhk18uv _4cvx3acm _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6d1elr _bfhk1j9a _p12f1osq _14regrf3 _4cvx1elr _irr31d5g _1a98zg3v",
    compact: "_1tke1wug"
};
const $3518ae22f57ffbfc$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
        ...props,
        xcss: (0, $k0ahr.cx)($3518ae22f57ffbfc$var$controlStyles.root, isCompact && $3518ae22f57ffbfc$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $3518ae22f57ffbfc$var$controlStyles.subtle, props.isFocused && $3518ae22f57ffbfc$var$controlStyles.focused, props.isInvalid && $3518ae22f57ffbfc$var$controlStyles.invalid, props.isDisabled && $3518ae22f57ffbfc$var$controlStyles.disabled)
    });
};
var $3518ae22f57ffbfc$export$2e2bcd8739ae039 = $3518ae22f57ffbfc$var$Control;

});


parcelRegister("75q59", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $71e9f791cbbda468$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $1NIU8 = parcelRequire("1NIU8");
const $71e9f791cbbda468$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $71e9f791cbbda468$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6XEne.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $71e9f791cbbda468$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("lLpLo", function(module, exports) {
$parcel$export(module.exports, "getCreatableProps", () => $03d6b2df141c86e7$export$36f97d8afa97203d);

var $LFmXM = parcelRequire("LFmXM");


var $2lvD5 = parcelRequire("2lvD5");

var $bp6ad = parcelRequire("bp6ad");
const $03d6b2df141c86e7$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $03d6b2df141c86e7$var$isValidNewOption = (isValidEmail = (0, $2lvD5.isValidEmail))=>(inputValue)=>inputValue && $03d6b2df141c86e7$var$validOption.includes(isValidEmail(inputValue));
const $03d6b2df141c86e7$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c)
        }
    });
const $03d6b2df141c86e7$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $03d6b2df141c86e7$var$isOptionDisabled = (isValidEmail = (0, $2lvD5.isValidEmail))=>(option)=>{
        if ((0, $bp6ad.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $03d6b2df141c86e7$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $03d6b2df141c86e7$var$isValidNewOption(isValidEmail),
        getNewOptionData: $03d6b2df141c86e7$var$getNewOptionData,
        formatCreateLabel: $03d6b2df141c86e7$var$formatCreateLabel,
        isOptionDisabled: $03d6b2df141c86e7$var$isOptionDisabled(isValidEmail)
    };
}
const $03d6b2df141c86e7$export$36f97d8afa97203d = (0, $LFmXM.default)($03d6b2df141c86e7$var$creatableProps);

});

parcelRegister("f9tKr", function(module, exports) {
$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $dfbcb54d733de433$export$34b9dd2dd6a225e5);

var $LFmXM = parcelRequire("LFmXM");


var $2lvD5 = parcelRequire("2lvD5");

var $bp6ad = parcelRequire("bp6ad");
const $dfbcb54d733de433$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $dfbcb54d733de433$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $dfbcb54d733de433$var$getNewOptionData = (isValidEmail = (0, $2lvD5.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $dfbcb54d733de433$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $dfbcb54d733de433$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $dfbcb54d733de433$var$isOptionDisabled = (isValidEmail = (0, $2lvD5.isValidEmail))=>(option)=>{
        if ((0, $bp6ad.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $dfbcb54d733de433$export$34b9dd2dd6a225e5 = (0, $LFmXM.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $dfbcb54d733de433$var$isValidNewOption,
        getNewOptionData: $dfbcb54d733de433$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $dfbcb54d733de433$var$formatCreateLabel,
        isOptionDisabled: $dfbcb54d733de433$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("61zL7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5315f7e1f1805a55$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $3VTWQ = parcelRequire("3VTWQ");
const $5315f7e1f1805a55$var$EMPTY = {};
const $5315f7e1f1805a55$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($5315f7e1f1805a55$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($5315f7e1f1805a55$var$EMPTY);
        (0, $3VTWQ.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $5315f7e1f1805a55$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $lRq8t.default)();
    const { children: children } = props;
    const messages = $5315f7e1f1805a55$var$useI18n(intl.locale);
    const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $5315f7e1f1805a55$export$2e2bcd8739ae039 = $5315f7e1f1805a55$var$MessagesIntlProvider;

});
parcelRegister("3VTWQ", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $10ce0748906381fc$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $10ce0748906381fc$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("ekiI8")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("fgm4J")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("drBO7")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("33qfR")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("b8fOo")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("bWIrP")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("3sK4f")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("0YUKd")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("cQwBF")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("lAFFG")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("gk7oQ")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("i90HO")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("c2jzR")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5EpIH")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("2AW9v")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("3NUXI")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("fU2cZ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("cpPSG")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("2yNwc")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("9fIis")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("iGZEx")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("35ZX7")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("5V9Ev")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("a3nUu")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("fQJx5")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("5YgKO")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("1WOBW")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("17hu4")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("2nKr7")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("240nm")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $10ce0748906381fc$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("33qfR")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("ekiI8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Rau7").then(()=>parcelRequire('daQ47'));

});

parcelRegister("fgm4J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5088Q").then(()=>parcelRequire('3gwUr'));

});

parcelRegister("drBO7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jYDLH").then(()=>parcelRequire('4TktE'));

});

parcelRegister("33qfR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5cN1A").then(()=>parcelRequire('9UkW6'));

});

parcelRegister("b8fOo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6KBLY").then(()=>parcelRequire('keQOQ'));

});

parcelRegister("bWIrP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("22pZ8").then(()=>parcelRequire('j96ER'));

});

parcelRegister("3sK4f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l8VWt").then(()=>parcelRequire('lJB7m'));

});

parcelRegister("0YUKd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8pdE4").then(()=>parcelRequire('lrhH1'));

});

parcelRegister("cQwBF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cTgaJ").then(()=>parcelRequire('9bXg4'));

});

parcelRegister("lAFFG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fW1As").then(()=>parcelRequire('ghDtB'));

});

parcelRegister("gk7oQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("31wTJ").then(()=>parcelRequire('fBK8V'));

});

parcelRegister("i90HO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8zZ5r").then(()=>parcelRequire('fOaod'));

});

parcelRegister("c2jzR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gB4Se").then(()=>parcelRequire('55LdR'));

});

parcelRegister("5EpIH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6jN77").then(()=>parcelRequire('4Wmwb'));

});

parcelRegister("2AW9v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7uPiT").then(()=>parcelRequire('hHM7Q'));

});

parcelRegister("3NUXI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2BwB1").then(()=>parcelRequire('btRta'));

});

parcelRegister("fU2cZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("joqnM").then(()=>parcelRequire('deJm0'));

});

parcelRegister("cpPSG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("80ngU").then(()=>parcelRequire('eWFII'));

});

parcelRegister("2yNwc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gZaei").then(()=>parcelRequire('73cSD'));

});

parcelRegister("9fIis", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hjmdM").then(()=>parcelRequire('a0Otm'));

});

parcelRegister("iGZEx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jRFFA").then(()=>parcelRequire('hTW3c'));

});

parcelRegister("35ZX7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bngha").then(()=>parcelRequire('bO1y4'));

});

parcelRegister("5V9Ev", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iHx0h").then(()=>parcelRequire('h8Ntk'));

});

parcelRegister("a3nUu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7LPdQ").then(()=>parcelRequire('7UfC0'));

});

parcelRegister("fQJx5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2miED").then(()=>parcelRequire('aHlPd'));

});

parcelRegister("5YgKO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Clan").then(()=>parcelRequire('gEBJz'));

});

parcelRegister("1WOBW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b01pn").then(()=>parcelRequire('js5pv'));

});

parcelRegister("17hu4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fhoQ2").then(()=>parcelRequire('5Pm4u'));

});

parcelRegister("2nKr7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i7U3b").then(()=>parcelRequire('cVDSh'));

});

parcelRegister("240nm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5JnGw").then(()=>parcelRequire('kzp7K'));

});



parcelRegister("48bcP", function(module, exports) {
$parcel$export(module.exports, "ExusUserSourceProvider", () => $8b385761409405b0$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $8b385761409405b0$export$c6c0c1a2bac363f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $8b385761409405b0$var$ExusUserSourceContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $8b385761409405b0$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($8b385761409405b0$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $8b385761409405b0$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $eJOHy.useContext)($8b385761409405b0$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $eJOHy.useState)([]);
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const abortController = (0, $eJOHy.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("3KPN3", function(module, exports) {
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $87a372decffff69d$export$53eef0dcd9611650);
$parcel$export(module.exports, "preparedUsersLoadedEvent", () => $87a372decffff69d$export$185f4c3d9b7ef9bf);
$parcel$export(module.exports, "mountedWithPrefetchEvent", () => $87a372decffff69d$export$9cfb4251e50d7b91);
$parcel$export(module.exports, "filterUsersEvent", () => $87a372decffff69d$export$fbba77127d7cb173);
$parcel$export(module.exports, "requestUsersEvent", () => $87a372decffff69d$export$1762ed8845ff2d9b);
$parcel$export(module.exports, "successfulRequestUsersEvent", () => $87a372decffff69d$export$bfc020018aa738d0);
$parcel$export(module.exports, "failedRequestUsersEvent", () => $87a372decffff69d$export$738aca68b593db8e);
$parcel$export(module.exports, "failedUserResolversEvent", () => $87a372decffff69d$export$b9358131e14a4b0b);

var $5fWw9 = parcelRequire("5fWw9");

var $aXKmr = parcelRequire("aXKmr");
const $87a372decffff69d$var$packageName = "platform-pkg";
const $87a372decffff69d$var$packageVersion = "0.0.0-use.local";
const $87a372decffff69d$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $aXKmr.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $87a372decffff69d$export$53eef0dcd9611650 = (0, $5fWw9.default)('fabric-elements');
const $87a372decffff69d$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $87a372decffff69d$var$packageName,
            packageVersion: $87a372decffff69d$var$packageVersion,
            ...attributes
        }
    });
const $87a372decffff69d$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $87a372decffff69d$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$87a372decffff69d$var$createEvent('operational', action, actionSubect, attributes)
    });
const $87a372decffff69d$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$fbba77127d7cb173 = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('requested', 'users', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$bfc020018aa738d0 = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$738aca68b593db8e = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$b9358131e14a4b0b = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });

});

parcelRegister("eeq1r", function(module, exports) {
$parcel$export(module.exports, "default", () => $23b0a0981d1542b0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $7fN1G = parcelRequire("7fN1G");
const $23b0a0981d1542b0$var$EMPTY = {};
const $23b0a0981d1542b0$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($23b0a0981d1542b0$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($23b0a0981d1542b0$var$EMPTY);
        (0, $7fN1G.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $23b0a0981d1542b0$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $23b0a0981d1542b0$var$useI18n(intl.locale);
    const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $23b0a0981d1542b0$export$2e2bcd8739ae039 = (0, $6YFG2.default)($23b0a0981d1542b0$var$MessagesIntlProvider);

});
parcelRegister("7fN1G", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $854557b06cad8001$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $854557b06cad8001$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("khj3i")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("8iBMO")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("eici8")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("3iD7E")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("iIuUG")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("6N0Tv")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("vgwCL")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("k3EAO")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("kU5ax")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("4p6Fl")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("92eLS")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aQ2fT")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("3rnuY")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("iNZuF")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("gGXh7")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("hMUHg")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("3oecB")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("fOKRP")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("gGFCO")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("hoGou")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("dCtD0")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("SeHZi")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("8EFHH")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("gRy4z")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("a9itp")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("dSqQH")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("aa8ZN")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("3MBIr")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("2FCwZ")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $854557b06cad8001$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("3iD7E")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("khj3i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lqbZ7").then(()=>parcelRequire('6l3q7'));

});

parcelRegister("8iBMO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2o3ud").then(()=>parcelRequire('bGXHO'));

});

parcelRegister("eici8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6IFmc").then(()=>parcelRequire('jOGSG'));

});

parcelRegister("3iD7E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g2azy").then(()=>parcelRequire('3y2l5'));

});

parcelRegister("iIuUG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6xkn1").then(()=>parcelRequire('hLoZh'));

});

parcelRegister("6N0Tv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jTO9r").then(()=>parcelRequire('h7dNX'));

});

parcelRegister("vgwCL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4zF1d").then(()=>parcelRequire('3AMQa'));

});

parcelRegister("k3EAO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1cYf6").then(()=>parcelRequire('27TU8'));

});

parcelRegister("kU5ax", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("T3Eou").then(()=>parcelRequire('43TWg'));

});

parcelRegister("4p6Fl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3UzWf").then(()=>parcelRequire('gicrK'));

});

parcelRegister("92eLS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("goX36").then(()=>parcelRequire('dHHKW'));

});

parcelRegister("aQ2fT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kd2mS").then(()=>parcelRequire('hDyjh'));

});

parcelRegister("3rnuY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hjSai").then(()=>parcelRequire('67Wxi'));

});

parcelRegister("iNZuF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("14Bbk").then(()=>parcelRequire('lXK09'));

});

parcelRegister("gGXh7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7WVoE").then(()=>parcelRequire('gHgDK'));

});

parcelRegister("hMUHg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hqvIQ").then(()=>parcelRequire('2dBQ9'));

});

parcelRegister("3oecB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8GcsS").then(()=>parcelRequire('1ADXg'));

});

parcelRegister("fOKRP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2rOPB").then(()=>parcelRequire('blrZT'));

});

parcelRegister("gGFCO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("68yz2").then(()=>parcelRequire('3KwDQ'));

});

parcelRegister("hoGou", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("63rje").then(()=>parcelRequire('85XJa'));

});

parcelRegister("dCtD0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jdMF4").then(()=>parcelRequire('kPUCC'));

});

parcelRegister("SeHZi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c02Om").then(()=>parcelRequire('gvzWw'));

});

parcelRegister("8EFHH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cnxxZ").then(()=>parcelRequire('awnYY'));

});

parcelRegister("gRy4z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1cRAv").then(()=>parcelRequire('3JjhD'));

});

parcelRegister("a9itp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9ORG4").then(()=>parcelRequire('gSXcf'));

});

parcelRegister("dSqQH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hdhCF").then(()=>parcelRequire('1LTrq'));

});

parcelRegister("aa8ZN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hXbHP").then(()=>parcelRequire('12gCS'));

});

parcelRegister("3MBIr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jtHE4").then(()=>parcelRequire('g8de5'));

});

parcelRegister("2FCwZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9s1QQ").then(()=>parcelRequire('5LINw'));

});



parcelRegister("3tZlw", function(module, exports) {
$parcel$export(module.exports, "EntityType", () => $4a3a3464a4c6b5d9$export$8eda7e02f8f033b2);
$parcel$export(module.exports, "UserEntityType", () => $4a3a3464a4c6b5d9$export$ef0ef29634e52a6b);
var $4a3a3464a4c6b5d9$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $4a3a3464a4c6b5d9$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});

});

parcelRegister("3ROyJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d267c2f51de75c1$export$2e2bcd8739ae039);

var $46EnI = parcelRequire("46EnI");

var $imaWq = parcelRequire("imaWq");
const $3d267c2f51de75c1$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $imaWq.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $46EnI.transformUsers)(response, intl));
};
var $3d267c2f51de75c1$export$2e2bcd8739ae039 = $3d267c2f51de75c1$var$getUserRecommendations;

});
parcelRegister("46EnI", function(module, exports) {
$parcel$export(module.exports, "transformUsers", () => $ba73f811ffd2c3c2$export$fb8c90bfc4beaa59);


var $9ySOS = parcelRequire("9ySOS");

var $3tZlw = parcelRequire("3tZlw");
const $ba73f811ffd2c3c2$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $9ySOS.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $3tZlw.EntityType).GROUP ? (0, $9ySOS.messages).guestGroupLozengeTooltip : (0, $9ySOS.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $9ySOS.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $ba73f811ffd2c3c2$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $3tZlw.EntityType).USER) {
        const user = item;
        const lozenge = $ba73f811ffd2c3c2$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $f4e041c5b2b1b75c$export$50042ec1d2e00e63) : (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $3tZlw.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $f4e041c5b2b1b75c$export$26bc40b960693765),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified
        };
    }
    if (type === (0, $3tZlw.EntityType).GROUP) {
        const group = item;
        const lozenge = $ba73f811ffd2c3c2$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $f4e041c5b2b1b75c$export$d460f747b73abb10),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $ba73f811ffd2c3c2$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$ba73f811ffd2c3c2$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);

});
parcelRegister("9ySOS", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fcb92c9e6b48a947$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fcb92c9e6b48a947$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});


parcelRegister("imaWq", function(module, exports) {
$parcel$export(module.exports, "config", () => $11780213688da020$export$e506a1d27d1eaa20);
const $11780213688da020$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};

});


parcelRegister("30jJs", function(module, exports) {
$parcel$export(module.exports, "default", () => $d286287b961e656e$export$2e2bcd8739ae039);


var $imaWq = parcelRequire("imaWq");

var $jc66e = parcelRequire("jc66e");

var $8FvAU = parcelRequire("8FvAU");

var $B1j5f = parcelRequire("B1j5f");
const $d286287b961e656e$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $imaWq.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $d286287b961e656e$var$transformJiraUsers : $d286287b961e656e$var$transformConfluenceUsers);
};
const $d286287b961e656e$var$transformJiraUsers = (userResponse)=>userResponse.values.map($d286287b961e656e$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $d286287b961e656e$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $d286287b961e656e$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($d286287b961e656e$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $d286287b961e656e$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $d286287b961e656e$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $B1j5f.UNKNOWN)
        };
    });
};
const $d286287b961e656e$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $d286287b961e656e$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $8FvAU.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $d286287b961e656e$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $d286287b961e656e$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $jc66e.default)(baseUrl, accountIds);
};
async function $d286287b961e656e$var$hydrateDefaultValues(baseUrl, value, productKey, siteId) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$d286287b961e656e$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $d286287b961e656e$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$d286287b961e656e$var$isOptionData(val) && val.type === 'user')),
        $d286287b961e656e$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$d286287b961e656e$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$d286287b961e656e$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $d286287b961e656e$var$sortResults(hydratedOptions, values);
}
var $d286287b961e656e$export$2e2bcd8739ae039 = $d286287b961e656e$var$hydrateDefaultValues;

});
parcelRegister("jc66e", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b9f91f3ca057d13$export$2e2bcd8739ae039);

var $B1j5f = parcelRequire("B1j5f");

var $h5Mhk = parcelRequire("h5Mhk");

var $imaWq = parcelRequire("imaWq");
/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $0b9f91f3ca057d13$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $0b9f91f3ca057d13$var$makeRequest = async (url, accountIds)=>{
    const query = $0b9f91f3ca057d13$var$buildUsersQuery(accountIds);
    return await (0, $h5Mhk.graphqlQuery)(url, query);
};
const $0b9f91f3ca057d13$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $0b9f91f3ca057d13$var$getHydratedUsers = (baseUrl, userIds)=>{
    const url = (0, $imaWq.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $0b9f91f3ca057d13$var$makeRequest(url, userIds).then((data)=>{
            resolve($0b9f91f3ca057d13$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $B1j5f.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $0b9f91f3ca057d13$export$2e2bcd8739ae039 = $0b9f91f3ca057d13$var$getHydratedUsers;

});
parcelRegister("B1j5f", function(module, exports) {
$parcel$export(module.exports, "UNKNOWN", () => $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "UNKNOWN_USER", () => $acb7dc57b5f8fcc9$export$d1f5101c0939e3fe);
$parcel$export(module.exports, "UNKNOWN_TEAM", () => $acb7dc57b5f8fcc9$export$8144dcfc9025ca57);
const $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6 = 'Unknown';
const $acb7dc57b5f8fcc9$export$d1f5101c0939e3fe = {
    id: $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6,
    name: $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6,
    type: 'user'
};
const $acb7dc57b5f8fcc9$export$8144dcfc9025ca57 = {
    id: $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6,
    name: $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6,
    type: 'team'
};

});

parcelRegister("h5Mhk", function(module, exports) {
$parcel$export(module.exports, "graphqlQuery", () => $3301920d4c736ea0$export$74eb8d79ae3e02b5);
const $3301920d4c736ea0$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $3301920d4c736ea0$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $3301920d4c736ea0$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("8FvAU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c205bf20b7e525a$export$2e2bcd8739ae039);

var $imaWq = parcelRequire("imaWq");

var $B1j5f = parcelRequire("B1j5f");
const $2c205bf20b7e525a$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl
    };
};
const $2c205bf20b7e525a$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $imaWq.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $2c205bf20b7e525a$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $B1j5f.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $2c205bf20b7e525a$export$2e2bcd8739ae039 = $2c205bf20b7e525a$var$hydrateTeamFromLegion;

});


parcelRegister("5Pgl9", function(module, exports) {
$parcel$export(module.exports, "smartUserPickerRenderedUfoExperience", () => $d29a1946a924977c$export$df77da4c0210f1c1);
$parcel$export(module.exports, "smartUserPickerOptionsShownUfoExperience", () => $d29a1946a924977c$export$a0e7cca3ab9586eb);
$parcel$export(module.exports, "useUFOConcurrentExperience", () => $d29a1946a924977c$export$e5e0512991825310);
$parcel$export(module.exports, "UfoErrorBoundary", () => $d29a1946a924977c$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $g0oDq = parcelRequire("g0oDq");
const $d29a1946a924977c$var$COMPONENT_NAME = 'smart-user-picker';
const $d29a1946a924977c$export$df77da4c0210f1c1 = new (0, $9iIu4.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $d29a1946a924977c$var$COMPONENT_NAME
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $d29a1946a924977c$export$a0e7cca3ab9586eb = new (0, $9iIu4.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $d29a1946a924977c$var$COMPONENT_NAME
    },
    type: (0, $aRnO1.ExperienceTypes).Operation,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
});
const $d29a1946a924977c$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $eJOHy.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $eJOHy.useEffect)(()=>{
        if (experienceForId.state !== (0, $g0oDq.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $g0oDq.UFOExperienceState)['STARTED'],
                (0, $g0oDq.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $d29a1946a924977c$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        $d29a1946a924977c$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("aUMMA", function(module, exports) {
$parcel$export(module.exports, "defaultSelectStyles", () => $a277234cf6edc8cd$export$b12192ea1a215e5f);
$parcel$export(module.exports, "indicatorFixSelectStyles", () => $a277234cf6edc8cd$export$eca30945eaf474dd);

var $1jVV7 = parcelRequire("1jVV7");
const $a277234cf6edc8cd$export$b12192ea1a215e5f = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $1jVV7.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $1jVV7.layers).modal
        })
};
const $a277234cf6edc8cd$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
const $a277234cf6edc8cd$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
const $a277234cf6edc8cd$export$eca30945eaf474dd = {
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: $a277234cf6edc8cd$var$inputIconPaddingLeft,
            paddingRight: $a277234cf6edc8cd$var$inputIconPaddingRight
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: $a277234cf6edc8cd$var$inputIconPaddingLeft,
            paddingRight: $a277234cf6edc8cd$var$inputIconPaddingRight
        })
};
const $a277234cf6edc8cd$export$a9f371909ef7b4d6 = {
    container: (base)=>({
            ...base,
            border: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        })
};

});
parcelRegister("1jVV7", function(module, exports) {
$parcel$export(module.exports, "layers", () => $264a1b9fc0aa8870$export$7be255094ccdc533);
// eslint-disable-next-line jira/restricted/@atlaskit+theme

var $IW7jS = parcelRequire("IW7jS");
const $264a1b9fc0aa8870$var$mobileBannerIndex = 100;
const $264a1b9fc0aa8870$export$7be255094ccdc533 = {
    banner: (0, $IW7jS.layers).navigation(),
    card: (0, $IW7jS.layers).card(),
    dialog: (0, $IW7jS.layers).dialog(),
    navigation: (0, $IW7jS.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $IW7jS.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $IW7jS.layers).navigation() - 1,
    layer: (0, $IW7jS.layers).layer(),
    blanket: (0, $IW7jS.layers).blanket(),
    modal: (0, $IW7jS.layers).modal(),
    flag: (0, $IW7jS.layers).flag(),
    spotlight: (0, $IW7jS.layers).spotlight(),
    tooltip: (0, $IW7jS.layers).tooltip(),
    mobileBanner: $264a1b9fc0aa8870$var$mobileBannerIndex
};

});


const $3ddfbe531e9e128a$export$53782b65600ab96d = '__UNASSIGNED_TEAM__';

parcelRegister("aeZ5Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $8775808672087359$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8775808672087359$var$messages = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "issue-field-team.error-title",
        "defaultMessage": "We couldn't set the team value"
    },
    errorMessage: {
        "id": "issue-field-team.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    teamErrorViewTooltip: {
        "id": "issue-field-team.team-error-view-tooltip",
        "defaultMessage": "This team may have been deleted, or you do not have access"
    },
    teamErrorViewText: {
        "id": "issue-field-team.team-error-view-text",
        "defaultMessage": "Not available"
    },
    placeholderTeamEditSelector: {
        "id": "issue-field-team.placeholder-team-edit-selector",
        "defaultMessage": "Choose a team"
    },
    defaultNoValueText: {
        "id": "issue-field-team.default-no-value-text",
        "defaultMessage": "None"
    },
    noValueTextExperiment: {
        "id": "issue-field-team.no-value-text-experiment",
        "defaultMessage": "Add team"
    },
    createTeamButtonText: {
        "id": "issue-field-team.create-team-button-text",
        "defaultMessage": "Create a team"
    },
    emptyStateDescription: {
        "id": "issue-field-team.empty-state-description",
        "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
    },
    noOptionsMessage: {
        "id": "issue-field-team.no-options-message",
        "defaultMessage": "No options"
    }
});
var $8775808672087359$export$2e2bcd8739ae039 = $8775808672087359$var$messages;

});

parcelRegister("eQtse", function(module, exports) {
$parcel$export(module.exports, "CreateTeamOption", () => $71956e47e75e50a5$export$8920795307e75f7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6eTT8 = parcelRequire("6eTT8");
var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $dcLzM = parcelRequire("dcLzM");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $aeZ5Y = parcelRequire("aeZ5Y");

var $aj4ju = parcelRequire("aj4ju");
const $71956e47e75e50a5$var$styles = {
    iconWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7",
    optionWrapper: "_80omtlke"
};
function $71956e47e75e50a5$export$8920795307e75f7e({ onClick: onClick, isFocused: isFocused }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formattedCreateTeamText = formatMessage((0, $aeZ5Y.default).createTeamButtonText);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleCreateTeamOptionClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: false
        });
        onClick();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const { canCreateTeams: canCreateTeams } = (0, $aj4ju.useTeamPermissions)();
    return canCreateTeams ? // eslint-disable-next-line jira/restricted/react-suspense
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6eTT8.default), {
        inline: "space.200",
        block: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$CreateButtonBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$Container, {
        onClick: handleCreateTeamOptionClick,
        isFocused: isFocused,
        "data-testid": "issue-field-team.ui.edit-mode.create-team-option.create-team-inline-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$OptionDataWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        xcss: $71956e47e75e50a5$var$styles.optionWrapper,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $71956e47e75e50a5$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
        label: "",
        spacing: "spacious"
    })), formattedCreateTeamText))))) : null;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71956e47e75e50a5$var$CreateButtonBorder = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71956e47e75e50a5$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _1bsb1osq _4t3i1osq _irr3166n _1dbzu4to",
            __cmplp.isFocused ? "_bfhk166n" : "_bfhk18uv",
            __cmplp.isFocused ? "_16qsu4to" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $71956e47e75e50a5$var$OptionDataWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6eTT8", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f6b340483a43cc2$export$2e2bcd8739ae039);
/* bleed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $6f6b340483a43cc2$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g4pxn",
    'inline.space.050': "_195ggp71",
    'inline.space.100': "_195gtdkl",
    'inline.space.150': "_195gkqjj",
    'inline.space.200': "_195g1e8l",
    'block.space.025': "_1mou4pxn",
    'block.space.050': "_1mougp71",
    'block.space.100': "_1moutdkl",
    'block.space.150': "_1moukqjj",
    'block.space.200': "_1mou1e8l"
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $6f6b340483a43cc2$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $6f6b340483a43cc2$var$styles.root,
            all && $6f6b340483a43cc2$var$styles[`inline.${all}`],
            inline && $6f6b340483a43cc2$var$styles[`inline.${inline}`],
            all && $6f6b340483a43cc2$var$styles[`block.${all}`],
            block && $6f6b340483a43cc2$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$6f6b340483a43cc2$var$Bleed.displayName = 'Bleed';
var $6f6b340483a43cc2$export$2e2bcd8739ae039 = $6f6b340483a43cc2$var$Bleed;

});

parcelRegister("aj4ju", function(module, exports) {
$parcel$export(module.exports, "useTeamPermissions", () => $03d8176dd2b72f29$export$8cbbe0c59dd60253);

var $g9Vr6 = parcelRequire("g9Vr6");

var $koAZ4 = parcelRequire("koAZ4");

var $6rNFR = parcelRequire("6rNFR");
const $03d8176dd2b72f29$export$8cbbe0c59dd60253 = ()=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const { permissions: permissions } = (0, $6rNFR.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: false
    });
    return permissions;
};

});


parcelRegister("hVanD", function(module, exports) {
$parcel$export(module.exports, "TeamPickerEmptyState", () => $9cad0eefc6b06595$export$f53d61da818dafb4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jsfEw = parcelRequire("jsfEw");

var $kDaaB = parcelRequire("kDaaB");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $aeZ5Y = parcelRequire("aeZ5Y");

var $aj4ju = parcelRequire("aj4ju");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9cad0eefc6b06595$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1fxt _otyr1ejb _19pkze3t",
            __cmplp.className
        ])
    });
});
const $9cad0eefc6b06595$var$imageWrapperStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.200'
});
const $9cad0eefc6b06595$export$f53d61da818dafb4 = ({ onActionClick: onActionClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { canCreateTeams: canCreateTeams } = (0, $aj4ju.useTeamPermissions)();
    const handleCreateTeamOptionClick = ()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: true
        });
        onActionClick();
    };
    return canCreateTeams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.200",
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9cad0eefc6b06595$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsfEw.default), {
        alt: "",
        width: 130,
        height: 122
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9cad0eefc6b06595$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $aeZ5Y.default).emptyStateDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: handleCreateTeamOptionClick,
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button",
        interactionName: "auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $aeZ5Y.default).createTeamButtonText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $aeZ5Y.default).noOptionsMessage);
};

});
parcelRegister("jsfEw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d56532f96b609464$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $kriHC = parcelRequire("kriHC");
const $d56532f96b609464$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($kriHC)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kriHC))
});
var $d56532f96b609464$export$2e2bcd8739ae039 = $d56532f96b609464$var$Illustration;
// for advanced use only
const $d56532f96b609464$export$a179c88182cb9d56 = [
    0,
    0,
    130,
    122
];

});
parcelRegister("kriHC", function(module, exports) {
module.exports = new URL("people-and-tasks.dedc2456.svg", import.meta.url).toString();

});




parcelRegister("dId76", function(module, exports) {
$parcel$export(module.exports, "default", () => $a38883ade94e7992$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a38883ade94e7992$var$messages = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "software-board-create.modal.form.source-value-picker.team-picker.placeholder",
        "defaultMessage": "Select"
    }
});
var $a38883ade94e7992$export$2e2bcd8739ae039 = $a38883ade94e7992$var$messages;

});




parcelRegister("6HOlT", function(module, exports) {
$parcel$export(module.exports, "validateFormData", () => $20ee2345600a4a64$export$cc0ea38c9ab56613);

var $2pys5 = parcelRequire("2pys5");
const $20ee2345600a4a64$var$validateBoardName = (value)=>{
    return !value || value.trim().length === 0 ? (0, $2pys5.VALIDATION_ERROR_EMPTY) : undefined;
};
const $20ee2345600a4a64$var$validateSourceType = (value)=>{
    return value === undefined ? (0, $2pys5.VALIDATION_ERROR_EMPTY) : undefined;
};
const $20ee2345600a4a64$var$validateSourceValue = (value)=>{
    if (Array.isArray(value) && !value.length || !Array.isArray(value) && !value) return 0, $2pys5.VALIDATION_ERROR_EMPTY;
};
const $20ee2345600a4a64$export$cc0ea38c9ab56613 = (data)=>({
        boardName: $20ee2345600a4a64$var$validateBoardName(data.boardName),
        sourceType: $20ee2345600a4a64$var$validateSourceType(data.sourceType),
        sourceValue: data.sourceType ? $20ee2345600a4a64$var$validateSourceValue(data.sourceValue) : undefined
    });

});


parcelRegister("62xU6", function(module, exports) {
$parcel$export(module.exports, "default", () => $daefe98e1819e72e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $daefe98e1819e72e$var$messages = (0, $7qGN1.defineMessages)({
    // Delete createBoardDialogLabel when cleaning up nav4_simplified_board_create_beta
    createBoardDialogLabel: {
        "id": "software-board-create.modal.create-board-dialog-label",
        "defaultMessage": "Create board dialog, {boardDescription}"
    },
    loadingLabel: {
        "id": "software-board-create.modal.loading-label",
        "defaultMessage": "Loading"
    }
});
var $daefe98e1819e72e$export$2e2bcd8739ae039 = $daefe98e1819e72e$var$messages;

});



parcelRegister("8ySo1", function(module, exports) {
$parcel$export(module.exports, "default", () => $7831b220ce74fe3a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7831b220ce74fe3a$var$messages = (0, $7qGN1.defineMessages)({
    createBoardLabel: {
        "id": "software-board-create.flyout-menu.flyout-menu-content.dropdown-item-container.create-board-label",
        "defaultMessage": "Create a {boardType} board"
    }
});
var $7831b220ce74fe3a$export$2e2bcd8739ae039 = $7831b220ce74fe3a$var$messages;

});




parcelRegister("dFmiu", function(module, exports) {
$parcel$export(module.exports, "FlyoutMenuContentFallback", () => $be78f9bf5dc2ec0e$export$aad294dc6c6989e8);

var $eJOHy = parcelRequire("eJOHy");

var $2bMVP = parcelRequire("2bMVP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $9KojZ = parcelRequire("9KojZ");

var $PtTbh = parcelRequire("PtTbh");
const $be78f9bf5dc2ec0e$export$aad294dc6c6989e8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9KojZ.FlyoutContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockStart: "space.100",
        xcss: $be78f9bf5dc2ec0e$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage((0, $PtTbh.default).loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockStart: "space.100",
        xcss: $be78f9bf5dc2ec0e$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage((0, $PtTbh.default).loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        width: "100%"
    })));
};
const $be78f9bf5dc2ec0e$var$skeletonItemContainerStyles = (0, $1DXK0.xcss)({
    height: '56px'
});

});
parcelRegister("PtTbh", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e69595c09d795e3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8e69595c09d795e3$var$messages = (0, $7qGN1.defineMessages)({
    loadingLabel: {
        "id": "software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label",
        "defaultMessage": "Loading"
    }
});
var $8e69595c09d795e3$export$2e2bcd8739ae039 = $8e69595c09d795e3$var$messages;

});





parcelRegister("c9EyR", function(module, exports) {
$parcel$export(module.exports, "isCompanyManagedSoftwareProject", () => $b41834aef3246560$export$531964df831b0883);

var $FhXEJ = parcelRequire("FhXEJ");
const $b41834aef3246560$export$531964df831b0883 = (projectStyle, projectType)=>projectStyle === 'COMPANY_MANAGED_PROJECT' && projectType === (0, $FhXEJ.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT);

});

parcelRegister("iBeto", function(module, exports) {
$parcel$export(module.exports, "default", () => $be8366a143aa7534$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $be8366a143aa7534$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createBoard: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-common.project-actions.create-board",
        "defaultMessage": "Create board"
    }
});

});


parcelRegister("4lYYK", function(module, exports) {
$parcel$export(module.exports, "useSetWillRedirectOnLoad", () => $05c057ee57bb825a$export$61738ae72e3e0690);

var $eJOHy = parcelRequire("eJOHy");

var $6IMub = parcelRequire("6IMub");
const $05c057ee57bb825a$export$61738ae72e3e0690 = ()=>(0, $eJOHy.useContext)((0, $6IMub.SetWillRedirectOnLoadContext));

});

parcelRegister("drzt5", function(module, exports) {
$parcel$export(module.exports, "useWithSetWillRedirectOnLoad", () => $3e434eb08ac544e5$export$6d74e9ac9c6fcd64);

var $eJOHy = parcelRequire("eJOHy");

var $4lYYK = parcelRequire("4lYYK");
const $3e434eb08ac544e5$export$6d74e9ac9c6fcd64 = (f, value, condition = true)=>{
    const setWillRedirectOnLoad = (0, $4lYYK.useSetWillRedirectOnLoad)();
    return (0, $eJOHy.useCallback)((...args)=>{
        if (condition) setWillRedirectOnLoad(value);
        f?.(...args);
    }, [
        condition,
        f,
        setWillRedirectOnLoad,
        value
    ]);
};

});

const $62baa2e6fd157602$export$b8b9d90f9e5bd72b = '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu';
const $62baa2e6fd157602$export$d57b6b390e78d90f = 'jira-cosmos';
const $62baa2e6fd157602$export$420a3ee5deb615a9 = 25;
const $62baa2e6fd157602$export$99240e55cc48c47e = 5;

parcelRegister("5DQfo", function(module, exports) {
$parcel$export(module.exports, "nav4JSWProjectEntryPoint", () => $4c6f2233584e50c1$export$b1c3a10bbf92ce74);

var $gxGDD = parcelRequire("gxGDD");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $bBtQo = parcelRequire("bBtQo");
const $4c6f2233584e50c1$var$NO_OF_BOARDS_TO_FETCH = 25;

const $4c6f2233584e50c1$export$b1c3a10bbf92ce74 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("2g1h4")).then(({ JswExpandableProjectQuery: JswExpandableProjectQuery })=>JswExpandableProjectQuery), {
        moduleId: "69299f40",
        moduleName: "JswExpandableProjectQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId ?? '';
        let projectKey = '';
        if (params.context?.match.params?.projectKey) projectKey = params.context.match.params.projectKey;
        else if (params.context?.match.params?.issueKey && (0, $4cTDP.fg)('move-issue-view-to-entrypoint')) projectKey = (0, $bBtQo.getProjectKey)(params.context.match, params.context.query);
        return {
            queries: {
                projects: {
                    parameters: $gxGDD.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        noOfBoardsToFetch: $4c6f2233584e50c1$var$NO_OF_BOARDS_TO_FETCH
                    }
                }
            }
        };
    }
});

});
parcelRegister("gxGDD", function(module, exports) {
$parcel$export(module.exports, "default", () => $176b9f9eedc9a42f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a698b772eec501666c41efc7ae19c947>>
 * @relayHash c1db498d28981698c0ac4f7f19602c22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c70be67a36ccc18b4e83a11bccda0c6d3d06fbf59f3fc3b1e09e9f9647d3ec7

var $37Ewn = parcelRequire("37Ewn");
const $176b9f9eedc9a42f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "noOfBoardsToFetch",
                                                    "variableName": "noOfBoardsToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "JswBoards"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "noOfBoardsToFetch"
                                        }
                                    ],
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraFavouriteValue",
                                                            "kind": "LinkedField",
                                                            "name": "favouriteValue",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canEdit"
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c70be67a36ccc18b4e83a11bccda0c6d3d06fbf59f3fc3b1e09e9f9647d3ec7",
            "metadata": {},
            "name": "JswExpandableProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$176b9f9eedc9a42f$var$node.hash = "c86c96423726df260003e830175ef141";
(0, $37Ewn.PreloadableQueryRegistry).set($176b9f9eedc9a42f$var$node.params.id, $176b9f9eedc9a42f$var$node);
var $176b9f9eedc9a42f$export$2e2bcd8739ae039 = $176b9f9eedc9a42f$var$node;

});

parcelRegister("2g1h4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9AFkd").then(()=>parcelRequire('f9s7v'));

});



parcelRegister("gT0jg", function(module, exports) {
$parcel$export(module.exports, "JswNonExpandableProject", () => $9e988fcc2af9c12b$export$cbea0eaf70f0156d);

var $1vWHP = parcelRequire("1vWHP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6l5yN = parcelRequire("6l5yN");

var $dN2O6 = parcelRequire("dN2O6");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $7fbRv = parcelRequire("7fbRv");

var $cxKOj = parcelRequire("cxKOj");

var $bzbsd = parcelRequire("bzbsd");

var $1NfYk = parcelRequire("1NfYk");
const $9e988fcc2af9c12b$export$cbea0eaf70f0156d = ({ projectData: projectData, menuItemAnchorRef: menuItemAnchorRef })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const project = (0, $j4oe4.useFragment)((0, $1vWHP.default), projectData);
    const routerLinkConfig = (0, $eJOHy.useMemo)(()=>({
            to: project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`,
            prefetch: 'hover'
        }), [
        project.defaultNavigationItem?.url,
        project.projectKey
    ]);
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = project;
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $1NfYk.useProjectMenuItemDragAndDrop)({
        projectId: projectId,
        projectKey: projectKey,
        isFavourite: isFavourite,
        name: name,
        avatar: avatar,
        isEnabled: !!isFavourite && (0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        ref: (0, $bzbsd.mergeRefs)(menuItemAnchorRef || null, draggableAnchorRef || null),
        visualContentRef: dropTargetRef,
        dropIndicator: dropIndicator,
        isDragging: state.type === 'dragging',
        hasDragIndicator: hasDragIndicator,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6l5yN.ContainerAvatar), {
            src: project.avatar.large || ''
        }),
        href: routerLinkConfig,
        menuId: (0, $h4Bzb.ENTITY_ID).PROJECT(project.projectKey),
        onClick: (0, $eJOHy.useCallback)(()=>{
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        }, [
            project.isFavourite,
            project.projectId,
            project.projectType,
            sendProjectMenuItemAnalyticsEvent
        ]),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fbRv.ProjectActions), {
            projectFragment: project
        })
    }, project.name), dragPreview);
};

});
parcelRegister("1vWHP", function(module, exports) {
$parcel$export(module.exports, "default", () => $af7e71c0db1dc015$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec9c647dc6ce90744c0c4748168b513d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af7e71c0db1dc015$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswNonExpandableProject",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$af7e71c0db1dc015$var$node.hash = "1c2cfe3c81902a2ea33e2fc3b9f6c4bb";
var $af7e71c0db1dc015$export$2e2bcd8739ae039 = $af7e71c0db1dc015$var$node;

});



parcelRegister("1gN9e", function(module, exports) {
$parcel$export(module.exports, "ProjectRestoreContext", () => $d1c79f8e50a8c788$export$bc50e4f0d149dd7c);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $d1c79f8e50a8c788$export$bc50e4f0d149dd7c = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));

});

parcelRegister("kOdRG", function(module, exports) {
$parcel$export(module.exports, "ContentWithDragAndDrop", () => $bb87ea96315e5006$export$97d3213e96ec57ec);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $f2JN3 = parcelRequire("f2JN3");

var $fpJnI = parcelRequire("fpJnI");
// The idea of this component is to provide a focus restoration context for the project menu items.
// The context will be read deep down the tree where the menuItem which supports drag-and-drop is rendered.
function $bb87ea96315e5006$var$ContentWithDragAndDropEnabled({ children: children }) {
    const [shouldRestoreFocus, setShouldRestoreFocus] = (0, $eJOHy.useState)(false);
    const enableRestoreFocus = (0, $eJOHy.useCallback)(()=>{
        setShouldRestoreFocus(true);
    }, []);
    const clearRestoreFocus = (0, $eJOHy.useCallback)(()=>{
        setShouldRestoreFocus(false);
    }, []);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            shouldRestoreFocus: shouldRestoreFocus,
            enableRestoreFocus: enableRestoreFocus,
            clearRestoreFocus: clearRestoreFocus
        }), [
        clearRestoreFocus,
        enableRestoreFocus,
        shouldRestoreFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpJnI.FocusRestorationContext).Provider, {
        value: contextValue
    }, children);
}
const $bb87ea96315e5006$export$97d3213e96ec57ec = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $bb87ea96315e5006$var$ContentWithDragAndDropEnabled, ({ children: children })=>children);

});


parcelRegister("lnXOC", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsEmptyContent", () => $70a70150fb5a67f9$export$7a7cd6cdc84cf8eb);
/* Nav4ProjectsEmptyContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $eLY13 = parcelRequire("eLY13");

var $fGy7n = parcelRequire("fGy7n");
function $70a70150fb5a67f9$export$7a7cd6cdc84cf8eb() {
    const emptyProjectsMessageGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fGy7n.default).emptyProjectsMessageGalaxia : (0, $fGy7n.default).emptyProjectsMessage;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $eLY13.EmptyContentMenuItem), null, /*#__PURE__*/ $eJOHy.createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage(emptyProjectsMessageGalaxia)));
}

});
parcelRegister("fGy7n", function(module, exports) {
$parcel$export(module.exports, "default", () => $29a1b7d01b16a112$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $29a1b7d01b16a112$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyProjectsMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message",
        "defaultMessage": "Once you visit or create projects, they'll show up here."
    },
    emptyProjectsMessageGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message-galaxia",
        "defaultMessage": "Once you visit or create spaces, they'll show up here."
    }
});

});


parcelRegister("2VWNN", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsSections", () => $86a5717ed87aea81$export$f0f2073bdea7c56e);

var $eJOHy = parcelRequire("eJOHy");

var $fXQx2 = parcelRequire("fXQx2");

var $aJgGb = parcelRequire("aJgGb");

var $68QJy = parcelRequire("68QJy");
const $86a5717ed87aea81$var$Nav4ProjectsSectionsInternal = ({ favoriteItems: favoriteItems, recentItems: recentItems, mostRecentProjectItem: mostRecentProjectItem, canCreateProject: canCreateProject })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJgGb.RenderStarredSection), {
        favoriteItems: favoriteItems,
        canCreateProject: canCreateProject
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXQx2.RenderRecentSection), {
        recentItems: recentItems,
        canCreateProject: canCreateProject
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68QJy.RenderMostRecentProjectSection), {
        projectItem: mostRecentProjectItem
    }));
const $86a5717ed87aea81$export$f0f2073bdea7c56e = /*#__PURE__*/ (0, $eJOHy.memo)($86a5717ed87aea81$var$Nav4ProjectsSectionsInternal);

});
parcelRegister("fXQx2", function(module, exports) {
$parcel$export(module.exports, "RenderRecentSection", () => $b5bcadbb40afeb96$export$d2b3549b269002a1);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $lRq8t = parcelRequire("lRq8t");

var $lHnXI = parcelRequire("lHnXI");


var $42Jy1 = parcelRequire("42Jy1");
function $b5bcadbb40afeb96$export$d2b3549b269002a1({ recentItems: recentItems, canCreateProject: canCreateProject }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    (0, $eJOHy.useEffect)(()=>{
        sendProjectMenuContentSectionAnalyticsEvent({
            projectSection: (0, $a2a58ce6d289b621$export$66f42658510ce4ab),
            canCreateProject: canCreateProject
        });
    }, [
        canCreateProject,
        sendProjectMenuContentSectionAnalyticsEvent
    ]);
    return recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.recent-section.recent-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $42Jy1.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, recentItems.list)));
}

});
const $a2a58ce6d289b621$export$3086f5b2b9faf5ae = 'starred';
const $a2a58ce6d289b621$export$66f42658510ce4ab = 'recent';

parcelRegister("42Jy1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebcbff926ef04adf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ebcbff926ef04adf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});


parcelRegister("aJgGb", function(module, exports) {
$parcel$export(module.exports, "RenderStarredSection", () => $b6c933b8e36d38d1$export$e2cc6b3e240d5148);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $f2JN3 = parcelRequire("f2JN3");

var $cxKOj = parcelRequire("cxKOj");

var $98PI1 = parcelRequire("98PI1");

var $lHnXI = parcelRequire("lHnXI");


var $42Jy1 = parcelRequire("42Jy1");
const $b6c933b8e36d38d1$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $b6c933b8e36d38d1$export$e2cc6b3e240d5148 = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $b6c933b8e36d38d1$var$StarredSectionWithFocusRestoration, $b6c933b8e36d38d1$var$StarredSection);
function $b6c933b8e36d38d1$var$StarredSectionWithFocusRestoration({ favoriteItems: favoriteItems, canCreateProject: canCreateProject }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    (0, $eJOHy.useEffect)(()=>{
        sendProjectMenuContentSectionAnalyticsEvent({
            projectSection: (0, $a2a58ce6d289b621$export$3086f5b2b9faf5ae),
            canCreateProject: canCreateProject
        });
    }, [
        canCreateProject,
        sendProjectMenuContentSectionAnalyticsEvent
    ]);
    return favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $98PI1.ProjectsDroppableGroupIndicator), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $42Jy1.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $b6c933b8e36d38d1$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
    }, formatMessage((0, $42Jy1.default).viewAllStarred)));
}
function $b6c933b8e36d38d1$var$StarredSection({ favoriteItems: favoriteItems, canCreateProject: canCreateProject }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    (0, $eJOHy.useEffect)(()=>{
        sendProjectMenuContentSectionAnalyticsEvent({
            projectSection: (0, $a2a58ce6d289b621$export$3086f5b2b9faf5ae),
            canCreateProject: canCreateProject
        });
    }, [
        canCreateProject,
        sendProjectMenuContentSectionAnalyticsEvent
    ]);
    return favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $42Jy1.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $b6c933b8e36d38d1$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
    }, formatMessage((0, $42Jy1.default).viewAllStarred)));
}

});
parcelRegister("98PI1", function(module, exports) {
$parcel$export(module.exports, "ProjectsDroppableGroupIndicator", () => $813c8d28ccd84f19$export$2fb821b6490fad6e);

var $eJOHy = parcelRequire("eJOHy");

var $6MiKU = parcelRequire("6MiKU");

var $fabzX = parcelRequire("fabzX");
const $813c8d28ccd84f19$export$2fb821b6490fad6e = (props)=>{
    const { children: children } = props;
    const dropTarget = (0, $fabzX.useDropTargetForProjects)();
    const { ref: ref, state: state } = dropTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MiKU.GroupDropIndicator), {
        isActive: state === 'is-over',
        ref: ref
    }, children);
};

});
parcelRegister("6MiKU", function(module, exports) {
$parcel$export(module.exports, "GroupDropIndicator", () => $419ec8aeb9a7e301$export$cb7fd016127fc6fc);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $419ec8aeb9a7e301$var$activeStyles = null;
const $419ec8aeb9a7e301$export$cb7fd016127fc6fc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function GroupDropIndicator({ children: children, isActive: isActive, testId: testId }, forwardedRef) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: forwardedRef,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            isActive && "_2rkolb4i _bfhk33gi _1cwg12x7 _12y31dm9 _1qu2nqa1 _12ji1yqz"
        ]),
        children: children
    });
});

});

parcelRegister("fabzX", function(module, exports) {
$parcel$export(module.exports, "useDropTargetForProjects", () => $68abf6fb5fc583f0$export$bf27ec69454698cb);

var $eJOHy = parcelRequire("eJOHy");

var $bGx3v = parcelRequire("bGx3v");

var $exQoy = parcelRequire("exQoy");

var $e3gfr = parcelRequire("e3gfr");

var $cxKOj = parcelRequire("cxKOj");

var $hbF3h = parcelRequire("hbF3h");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $guiPE = parcelRequire("guiPE");


var $4TPTK = parcelRequire("4TPTK");

var $3X9cT = parcelRequire("3X9cT");
const $68abf6fb5fc583f0$var$useDropTargetForProjectsConditionally = ()=>{
    const ref = (0, $eJOHy.useRef)(null);
    const [state, setState] = (0, $eJOHy.useState)();
    const updateFavouriteOrder = (0, $4TPTK.useUpdateFavouriteOrder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    (0, $eJOHy.useEffect)(()=>{
        const element = ref.current;
        // might have no projects
        if (!element) return;
        return (0, $bGx3v.dropTargetForElements)({
            element: element,
            canDrop: ({ source: source })=>{
                return (0, $guiPE.isDraggableProject)(source.data);
            },
            onDragStart ({ source: source }) {
                setState('is-over');
                const dragging = source.data;
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_STARTED,
                    attributes: {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDragEnter ({ source: source }) {
                setState('is-over');
                const dragging = source.data;
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_ENTERED,
                    attributes: {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDragLeave ({ source: source }) {
                setState('idle');
                const dragging = source.data;
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_LEFT,
                    attributes: {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDrop ({ source: source, location: location }) {
                setState('idle');
                let successfulReorder = false;
                const dragging = source.data;
                const [innerMost] = location.current.dropTargets;
                const dropTargetData = innerMost.data;
                if (!(0, $guiPE.isDraggableProject)(dragging) || !(0, $guiPE.isDraggableProject)(dropTargetData)) {
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_ENDED,
                        attributes: {
                            ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                            itemId: dragging.id,
                            successfulReorder: successfulReorder
                        }
                    });
                    return;
                }
                const instruction = (0, $e3gfr.extractInstruction)(dropTargetData);
                const operation = instruction && $68abf6fb5fc583f0$var$instructionToOperation(instruction);
                if (operation) {
                    updateFavouriteOrder(operation, dragging.id, dropTargetData.id);
                    successfulReorder = true;
                    if (!source.element) return;
                    (0, $exQoy.triggerPostMoveFlash)(source.element);
                }
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_ENDED,
                    attributes: {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id,
                        successfulReorder: successfulReorder
                    }
                });
            }
        });
    });
    return {
        ref: ref,
        state: state
    };
};
const $68abf6fb5fc583f0$export$bf27ec69454698cb = (0, $hbF3h.functionWithCondition)(()=>(0, $cxKOj.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $68abf6fb5fc583f0$var$useDropTargetForProjectsConditionally, ()=>({
        ref: {
            current: null
        },
        state: undefined
    }));
const $68abf6fb5fc583f0$var$instructionToOperation = (instruction)=>{
    switch(instruction?.operation){
        case 'reorder-before':
            return 0, $58939448f7663ec8$export$4cff6e48b6cc73b5;
        case 'reorder-after':
            return 0, $58939448f7663ec8$export$e0420f7fed62e74b;
        default:
            return null;
    }
};

});
parcelRegister("exQoy", function(module, exports) {
$parcel$export(module.exports, "triggerPostMoveFlash", () => $654a1f4559471de5$export$f5b5f29328df2633);

var $34ZNB = parcelRequire("34ZNB");
function $654a1f4559471de5$export$f5b5f29328df2633(element) {
    element.animate([
        {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)"
        },
        {}
    ], {
        duration: (0, $34ZNB.durations).large,
        /**
     * This is equivalent to the browser default, but we are making it
     * explicit to avoid relying on implicit behavior.
     *
     * This curve is not part of `@atlaskit/motion` but it was an intentional
     * design decision to use this curve.
     */ easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
        iterations: 1
    });
}

});

parcelRegister("guiPE", function(module, exports) {
$parcel$export(module.exports, "isDraggableProject", () => $f587f4d548e70ca9$export$1338b07381f36262);

var $3X9cT = parcelRequire("3X9cT");
const $f587f4d548e70ca9$export$1338b07381f36262 = (data)=>{
    return Boolean(data.type === (0, $3X9cT.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP));
};

});

const $58939448f7663ec8$export$5ff59e4f08b9b299 = 'MOVE_TO_TOP';
const $58939448f7663ec8$export$9964b4a63620a911 = 'MOVE_UP';
const $58939448f7663ec8$export$2692a384035c5ef7 = 'MOVE_DOWN';
const $58939448f7663ec8$export$a5a45050b97fca24 = 'MOVE_TO_BOTTOM';
const $58939448f7663ec8$export$e0420f7fed62e74b = 'AFTER';
const $58939448f7663ec8$export$4cff6e48b6cc73b5 = 'BEFORE';

parcelRegister("4TPTK", function(module, exports) {
$parcel$export(module.exports, "useUpdateFavouriteOrder", () => $3836013d369af5f4$export$63ac7262a5a1464f);

var $1wgYB = parcelRequire("1wgYB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cHtIB = parcelRequire("cHtIB");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4SjAP = parcelRequire("4SjAP");

var $3X9cT = parcelRequire("3X9cT");

var $kSw1o = parcelRequire("kSw1o");

var $lGgUK = parcelRequire("lGgUK");

var $cBksI = parcelRequire("cBksI");
const $3836013d369af5f4$export$63ac7262a5a1464f = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $1wgYB.default));
    const handleError = (0, $lGgUK.useHandleError)();
    const updateFavouriteOrder = (0, $eJOHy.useCallback)((operation, projectId, relativeProjectId)=>{
        commitMutation({
            variables: {
                input: {
                    cloudId: cloudId,
                    reorderMode: operation,
                    menuItem: {
                        itemId: projectId
                    },
                    // include relative menu item if provided
                    ...relativeProjectId && {
                        relativeMenuItem: {
                            itemId: relativeProjectId
                        }
                    }
                }
            },
            optimisticUpdater: (store)=>{
                (0, $cBksI.optimisticUpdater)(store, operation, projectId, cloudId, relativeProjectId);
            },
            onCompleted: (_, errors)=>{
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    handleError(error);
                } else {
                    const analyticsEvent = createAnalyticsEvent({});
                    (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).UPDATED_ORDER,
                        attributes: {
                            ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                            itemId: projectId,
                            action: (0, $kSw1o.menuItemReorderOperationToAction)(operation)
                        }
                    });
                }
            },
            onError: (error)=>{
                handleError(new (0, $4SjAP.MutationError)(error));
            }
        });
    }, [
        commitMutation,
        cloudId,
        handleError,
        createAnalyticsEvent
    ]);
    return updateFavouriteOrder;
};

});
parcelRegister("1wgYB", function(module, exports) {
$parcel$export(module.exports, "default", () => $92addba617c6e392$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8bb09f83d311836967c93cbe71256c5>>
 * @relayHash 9b827423aee2e52a98bde2436493db41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6d6064d3034388ca464cf98f4f622863dc77a21003fe85bec7d3b5f85837b5a

var $9zQGn = parcelRequire("9zQGn");

var $5moL7 = parcelRequire("5moL7");

var $lhtKZ = parcelRequire("lhtKZ");

var $eSxxM = parcelRequire("eSxxM");
const $92addba617c6e392$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateFavouriteOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "Nav4ProjectMenuItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useUpdateFavouriteOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "softwareBoardCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e6d6064d3034388ca464cf98f4f622863dc77a21003fe85bec7d3b5f85837b5a",
            "metadata": {},
            "name": "useUpdateFavouriteOrderMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default)
            }
        }
    };
}();
$92addba617c6e392$var$node.hash = "66de2e69da219bee3821eec0cafe8fb9";
var $92addba617c6e392$export$2e2bcd8739ae039 = $92addba617c6e392$var$node;

});

parcelRegister("kSw1o", function(module, exports) {
$parcel$export(module.exports, "menuItemReorderOperationToAction", () => $dcdcdec54e56df56$export$8357c82608ac73da);

const $dcdcdec54e56df56$export$8357c82608ac73da = (operation)=>{
    switch(operation){
        case 0, $58939448f7663ec8$export$5ff59e4f08b9b299:
            return 'moveToTop';
        case 0, $58939448f7663ec8$export$9964b4a63620a911:
            return 'moveUp';
        case 0, $58939448f7663ec8$export$2692a384035c5ef7:
            return 'moveDown';
        case 0, $58939448f7663ec8$export$a5a45050b97fca24:
            return 'moveToBottom';
        case 0, $58939448f7663ec8$export$e0420f7fed62e74b:
            return 'dragged';
        case 0, $58939448f7663ec8$export$4cff6e48b6cc73b5:
            return 'dragged';
        default:
            return '';
    }
};

});

parcelRegister("lGgUK", function(module, exports) {
$parcel$export(module.exports, "useHandleError", () => $5fdf767729540de6$export$7ab84fea33af0d21);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");

var $9pTd3 = parcelRequire("9pTd3");

var $3X9cT = parcelRequire("3X9cT");

var $au9J4 = parcelRequire("au9J4");
const $5fdf767729540de6$var$FLAG = {
    type: 'error',
    title: (0, $au9J4.default).defaultErrorTitle,
    description: (0, $au9J4.default).defaultErrorMessage,
    messageId: 'navigation-apps-sidebar-nav4-projects-customise-order.services.update-favourite-order.flag.error',
    messageType: 'transactional'
};
function $5fdf767729540de6$export$7ab84fea33af0d21() {
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'useUpdateFavouriteOrder',
                packageName: (0, $3X9cT.PACKAGE_NAME),
                teamName: (0, $3X9cT.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag($5fdf767729540de6$var$FLAG);
    }, [
        showFlag
    ]);
    return handleError;
}

});
parcelRegister("au9J4", function(module, exports) {
$parcel$export(module.exports, "default", () => $08446bd95fbf50bf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $08446bd95fbf50bf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    defaultErrorMessage: {
        "id": "jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-message",
        "defaultMessage": "Check your connection and try again."
    },
    defaultErrorTitle: {
        "id": "jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-title",
        "defaultMessage": "We couldn't update your view."
    }
});

});


parcelRegister("cBksI", function(module, exports) {
$parcel$export(module.exports, "optimisticUpdater", () => $1a914a13909655a2$export$32fd5c97e0eb451);

var $8Rclc = parcelRequire("8Rclc");
function $1a914a13909655a2$export$32fd5c97e0eb451(store, operation, targetProjectId, cloudId, relativeProjectId) {
    const sidebarMenuRecord = store.getRoot().getLinkedRecord('jira_projectsSidebarMenu', {
        cloudId: cloudId
    });
    const favoriteConnection = sidebarMenuRecord && sidebarMenuRecord.getLinkedRecord('favourites', {
        first: 15
    });
    if (!favoriteConnection) return;
    const edges = favoriteConnection.getLinkedRecords('edges') ?? [];
    if (!edges.length || edges.length <= 1) return;
    const projectIdToEdgeMap = edges.reduce((map, edge)=>{
        const projectId = edge.getLinkedRecord('node')?.getValue('projectId')?.toString();
        return projectId ? map.set(projectId, edge) : map;
    }, new Map());
    const projectIds = Array.from(projectIdToEdgeMap.keys());
    const sortedProjectIds = (0, $8Rclc.reorder)(operation, projectIds, targetProjectId, relativeProjectId);
    const sortedEdges = sortedProjectIds.map((projectId)=>projectIdToEdgeMap.get(projectId) ?? null);
    favoriteConnection.setLinkedRecords(sortedEdges, 'edges');
}

});
parcelRegister("8Rclc", function(module, exports) {
$parcel$export(module.exports, "reorder", () => $46eba235655f55e9$export$fc77a6137e3f91c);

const $46eba235655f55e9$export$f2c5cc4c3f787c3e = (projectsList, projectId)=>{
    const filteredList = projectsList.filter((id)=>id !== projectId);
    return [
        projectId,
        ...filteredList
    ];
};
const $46eba235655f55e9$export$8ff471d483515a76 = (projectsList, projectId)=>{
    const filteredList = projectsList.filter((id)=>id !== projectId);
    return [
        ...filteredList,
        projectId
    ];
};
const $46eba235655f55e9$export$44935f8a884b57b9 = (projectsList, projectId)=>{
    const index = projectsList.indexOf(projectId);
    if (index > 0) {
        const newList = [
            ...projectsList
        ];
        newList.splice(index, 1);
        newList.splice(index - 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $46eba235655f55e9$export$8eba228b343b3599 = (projectsList, projectId)=>{
    const index = projectsList.indexOf(projectId);
    if (index >= 0) {
        const newList = [
            ...projectsList
        ];
        newList.splice(index, 1);
        newList.splice(index + 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $46eba235655f55e9$export$86b68c7dbeb53c22 = (projectsList, projectId, relativeProject)=>{
    const index = projectsList.indexOf(relativeProject);
    if (index >= 0) {
        const filteredList = projectsList.filter((id)=>id !== projectId);
        const newList = [
            ...filteredList
        ];
        newList.splice(filteredList.indexOf(relativeProject), 0, projectId);
        return newList;
    }
    return projectsList;
};
const $46eba235655f55e9$export$c4f94c8b3850a5a9 = (projectsList, projectId, relativeProject)=>{
    const index = projectsList.indexOf(relativeProject);
    if (index >= 0) {
        const filteredList = projectsList.filter((id)=>id !== projectId);
        const newList = [
            ...filteredList
        ];
        newList.splice(filteredList.indexOf(relativeProject) + 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $46eba235655f55e9$export$4583b779aad6d7dc = (projectsList, projectId)=>{
    return [
        projectId,
        ...projectsList
    ];
};
const $46eba235655f55e9$export$a7bc06cf61a60193 = (projectsList, projectId)=>{
    return [
        ...projectsList,
        projectId
    ];
};
const $46eba235655f55e9$export$fc77a6137e3f91c = (operation, projectIds, projectId, relativeId)=>{
    switch(operation){
        case 0, $58939448f7663ec8$export$5ff59e4f08b9b299:
            return $46eba235655f55e9$export$f2c5cc4c3f787c3e(projectIds, projectId);
        case 0, $58939448f7663ec8$export$9964b4a63620a911:
            return $46eba235655f55e9$export$44935f8a884b57b9(projectIds, projectId);
        case 0, $58939448f7663ec8$export$2692a384035c5ef7:
            return $46eba235655f55e9$export$8eba228b343b3599(projectIds, projectId);
        case 0, $58939448f7663ec8$export$a5a45050b97fca24:
            return $46eba235655f55e9$export$8ff471d483515a76(projectIds, projectId);
        case 0, $58939448f7663ec8$export$4cff6e48b6cc73b5:
            return relativeId ? $46eba235655f55e9$export$86b68c7dbeb53c22(projectIds, projectId, relativeId) : projectIds;
        case 0, $58939448f7663ec8$export$e0420f7fed62e74b:
            return relativeId ? $46eba235655f55e9$export$c4f94c8b3850a5a9(projectIds, projectId, relativeId) : projectIds;
        default:
            return projectIds;
    }
};

});






parcelRegister("68QJy", function(module, exports) {
$parcel$export(module.exports, "RenderMostRecentProjectSection", () => $6b2dbc7a24198ca5$export$6269b4a1c127cf98);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
const $6b2dbc7a24198ca5$export$6269b4a1c127cf98 = ({ projectItem: projectItem })=>{
    return !!projectItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.most-recent-project-section.most-recent-project-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, projectItem)));
};

});


parcelRegister("jHZN8", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsSectionsWithDisplaySettings", () => $ce1351e532e3e285$export$f5fa44865e47a204);

var $kwEcQ = parcelRequire("kwEcQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $1pmgP = parcelRequire("1pmgP");

var $dpxw4 = parcelRequire("dpxw4");

var $jMoKX = parcelRequire("jMoKX");

var $aJgGb = parcelRequire("aJgGb");

var $fXQx2 = parcelRequire("fXQx2");
const $ce1351e532e3e285$var$isDisplaySettingsKey = (value)=>{
    const keys = Object.values((0, $jMoKX.DisplaySettingsPropertyKeys));
    return keys.includes(value);
};
const $ce1351e532e3e285$var$getNavigationCustomisation = (nodes, viewOption, defaultValue)=>{
    return nodes?.find((node)=>node?.key && $ce1351e532e3e285$var$isDisplaySettingsKey(node.key) && (0, $jMoKX.DisplaySettingsPropertyKeys)[node.key] === viewOption)?.value || defaultValue;
};
const $ce1351e532e3e285$var$Nav4ProjectsSectionsWithDisplaySettingsInternal = ({ favoriteItems: favoriteItems, recentItems: recentItems, queryRef: queryRef, canCreateProject: canCreateProject })=>{
    const data = (0, $j4oe4.useFragment)((0, $kwEcQ.default), queryRef);
    const selectedViewOption = $ce1351e532e3e285$var$getNavigationCustomisation(data.settings_navigationCustomisation?.properties?.nodes, (0, $jMoKX.DisplaySettingsPropertyKeys).VIEW_OPTION, (0, $1pmgP.DefaultViewOption));
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const isStarredViewOptionSelected = selectedViewOption === (0, $1pmgP.ViewOptions).STARRED;
    const isStarredAndRecentViewOptionSelected = selectedViewOption === (0, $1pmgP.ViewOptions).STARRED_AND_RECENT;
    // If the current project is not starred, display it under the Recent section.
    // Once navigated away from the current non-starred project, it should disappear from the sidebar,
    // along with the Recent section
    const currentRecentItem = recentItems.list.find((item)=>item.key && isSelectedPath((0, $h4Bzb.ENTITY_ID).PROJECT(item.key)));
    const displayedRecentItems = (0, $eJOHy.useMemo)(()=>isStarredViewOptionSelected ? {
            list: currentRecentItem ? [
                currentRecentItem
            ] : [],
            hasItems: Boolean(currentRecentItem)
        } : recentItems, [
        currentRecentItem,
        isStarredViewOptionSelected,
        recentItems
    ]);
    const shouldShowStarredSection = isStarredAndRecentViewOptionSelected || isStarredViewOptionSelected;
    const shouldShowRecentSection = isStarredAndRecentViewOptionSelected || displayedRecentItems.hasItems;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldShowStarredSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJgGb.RenderStarredSection), {
        favoriteItems: favoriteItems,
        canCreateProject: canCreateProject
    }), shouldShowRecentSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXQx2.RenderRecentSection), {
        recentItems: displayedRecentItems,
        canCreateProject: canCreateProject
    }));
};
const $ce1351e532e3e285$export$f5fa44865e47a204 = /*#__PURE__*/ (0, $eJOHy.memo)($ce1351e532e3e285$var$Nav4ProjectsSectionsWithDisplaySettingsInternal);

});
parcelRegister("kwEcQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c832a1769d3b81a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db313e78bd4577e1f34af3f48f590ec2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c832a1769d3b81a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectsSectionsWithDisplaySettings",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$6c832a1769d3b81a$var$node.hash = "e6e0f204dff7282a7c0aeb808efb30c6";
var $6c832a1769d3b81a$export$2e2bcd8739ae039 = $6c832a1769d3b81a$var$node;

});






parcelRegister("cRLIL", function(module, exports) {
$parcel$export(module.exports, "Recent", () => $8f7109c8820f0bf6$export$1147d6e1036afec);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");


var $dk46D = parcelRequire("dk46D");
const $8f7109c8820f0bf6$export$1147d6e1036afec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-recent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "recent",
        packageName: (0, $48cae6cf1c387d08$export$b8b9d90f9e5bd72b),
        teamName: (0, $48cae6cf1c387d08$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dk46D.RecentMenu), null)));

});
const $48cae6cf1c387d08$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Recent';
const $48cae6cf1c387d08$export$d57b6b390e78d90f = 'jira-cosmos';
const $48cae6cf1c387d08$export$56ff071570537731 = 15;
const $48cae6cf1c387d08$export$fe791c4fa892e400 = 'PROJECT';
const $48cae6cf1c387d08$export$c303e491e026ebc6 = 'PLAN';
const $48cae6cf1c387d08$export$c1c49903035a02df = 'FILTER';
const $48cae6cf1c387d08$export$4695c1a423ffe431 = 'DASHBOARD';
const $48cae6cf1c387d08$export$9b8283d5878d2491 = 'BOARD';
const $48cae6cf1c387d08$export$5828682c822c26e7 = 'QUEUE';
const $48cae6cf1c387d08$export$76a449e52fa0e1e8 = 'ISSUE';
const $48cae6cf1c387d08$export$fd6cd74eeb4b51a7 = 'searchRecentItems';
const $48cae6cf1c387d08$export$f91d73dc0ffb6584 = 'viewAllRecentItems';
const $48cae6cf1c387d08$export$ee6bbe0a973ca0e8 = 'today';
const $48cae6cf1c387d08$export$91c1c08ffbb5f1be = 'yesterday';
const $48cae6cf1c387d08$export$4bada75a9cb45bec = 'thisWeek';
const $48cae6cf1c387d08$export$1385d821597ee807 = 'thisMonth';
const $48cae6cf1c387d08$export$d64d14c448d5a065 = 'moreThanAMonth';

parcelRegister("dk46D", function(module, exports) {
$parcel$export(module.exports, "RecentMenu", () => $95e7d3aea52996e1$export$9051cd0d0927b696);

var $eJOHy = parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");


var $a9aec = parcelRequire("a9aec");

var $80rA3 = parcelRequire("80rA3");

var $8IuE5 = parcelRequire("8IuE5");

var $if69u = parcelRequire("if69u");

var $2QH3X = parcelRequire("2QH3X");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cHtIB = parcelRequire("cHtIB");


var $jDnzy = parcelRequire("jDnzy");

var $hX5Oa = parcelRequire("hX5Oa");
const $95e7d3aea52996e1$var$EMPTY_OBJECT = {};
function $95e7d3aea52996e1$export$9051cd0d0927b696() {
    const cloudId = (0, $cHtIB.useCloudId)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $jDnzy.default).recent, (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $hX5Oa.sidebarRecentMenuEntryPoint), (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            count: (0, $48cae6cf1c387d08$export$56ff071570537731)
        }), [
        cloudId
    ]));
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onOpenChange = (0, $eJOHy.useCallback)((isMenuOpen)=>{
        if (isMenuOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).RECENT);
            (0, $kRgKj.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_RECENT), {
                isInMore: isInMore
            });
        }
    }, [
        moreMenuIds,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWy6a.FlyoutMenuItem), {
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yLgR2.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-recent",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duFAq.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "nav4-sidebar-recent-default",
        packageName: (0, $48cae6cf1c387d08$export$b8b9d90f9e5bd72b),
        teamName: (0, $48cae6cf1c387d08$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
            withHeading: true,
            withSearch: true,
            withSubHeading: true,
            withSubTitle: true,
            isFlyout: true
        }),
        runtimeProps: $95e7d3aea52996e1$var$EMPTY_OBJECT
    })));
}

});
parcelRegister("jDnzy", function(module, exports) {
$parcel$export(module.exports, "default", () => $771c13e93e04295b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $771c13e93e04295b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-recent.recent",
        "defaultMessage": "Recent"
    }
});

});

parcelRegister("hX5Oa", function(module, exports) {
$parcel$export(module.exports, "sidebarRecentMenuEntryPoint", () => $a77dfaba95034dd7$export$52be5f9ca0100885);

var $g5q0I = parcelRequire("g5q0I");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a77dfaba95034dd7$export$52be5f9ca0100885 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("2PidP")), {
        moduleId: "d53a244c",
        moduleName: "RecentMenuWithAnalytic",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, count: count })=>({
            queries: {
                recentMenuData: {
                    parameters: $g5q0I.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        keyword: ''
                    }
                }
            }
        })
});

});
parcelRegister("g5q0I", function(module, exports) {
$parcel$export(module.exports, "default", () => $09d4e9981193f8b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<97f8a150b982571b0d24495ab19cdbf3>>
 * @relayHash be9c2b5b24cd64e2751359b852e5d2bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5097e4f4edb21d8cefb52dc6d84472f398ec50d572076021cd2ef099419436fa

var $37Ewn = parcelRequire("37Ewn");
const $09d4e9981193f8b2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "keyword"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "fields": [
            {
                "kind": "Variable",
                "name": "keyword",
                "variableName": "keyword"
            }
        ],
        "kind": "ObjectValue",
        "name": "filter"
    }, v5 = {
        "kind": "Literal",
        "name": "types",
        "value": [
            "PROJECT",
            "FILTER",
            "DASHBOARD",
            "BOARD",
            "QUEUE",
            "ISSUE",
            "PLAN"
        ]
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        v5 /*: any*/ 
    ], v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v5 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": "filterName",
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                }
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentMenuWithAnalyticQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recent",
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.recent.pageInfo"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "RecentMenuWithAnalytic"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentMenuWithAnalyticQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "recent",
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "RecentMenuContent__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5097e4f4edb21d8cefb52dc6d84472f398ec50d572076021cd2ef099419436fa",
            "metadata": {},
            "name": "RecentMenuWithAnalyticQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$09d4e9981193f8b2$var$node.hash = "3d6684756a71fb6c8e93a829f8201fde";
(0, $37Ewn.PreloadableQueryRegistry).set($09d4e9981193f8b2$var$node.params.id, $09d4e9981193f8b2$var$node);
var $09d4e9981193f8b2$export$2e2bcd8739ae039 = $09d4e9981193f8b2$var$node;

});

parcelRegister("2PidP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gUZma").then(()=>parcelRequire('amnp6'));

});




parcelRegister("iFx8E", function(module, exports) {
$parcel$export(module.exports, "Nav4Roadmaps", () => $b89bfd91b699c398$export$257bbde911c73386);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $if69u = parcelRequire("if69u");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $7i4qI = parcelRequire("7i4qI");

var $4bCl7 = parcelRequire("4bCl7");

var $3n4ak = parcelRequire("3n4ak");

var $fqYMs = parcelRequire("fqYMs");

const $b89bfd91b699c398$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("lOxEr")).then(({ Nav4RoadmapsContainer: Nav4RoadmapsContainer })=>Nav4RoadmapsContainer), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/roadmaps/src/ui/roadmaps/index.tsx"
});
const $b89bfd91b699c398$export$257bbde911c73386 = /*#__PURE__*/ (0, $eJOHy.memo)(({ isExpanded: isExpanded })=>{
    const isCollectionSelected = (0, $fqYMs.useIsCollectionSelected)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.roadmaps",
        packageName: (0, $7i4qI.PACKAGE_NAME),
        teamName: (0, $7i4qI.TEAM_NAME),
        ufoName: "nav4-sidebar-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4-sidebar-roadmaps",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4bCl7.RoadmapsStatic), {
            isExpanded: isExpanded,
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3n4ak.ActionButtonsStatic), null)
        }, isCollectionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b89bfd91b699c398$var$LazySidebarContent, {
        isExpanded: isExpanded
    })));
});

});
parcelRegister("7i4qI", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $4d5b43a119b93be9$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $4d5b43a119b93be9$export$d57b6b390e78d90f);
$parcel$export(module.exports, "VIEW_ALL_ROADMAPS", () => $4d5b43a119b93be9$export$3fc15b6d7f7757ac);
$parcel$export(module.exports, "CREATE_ROADMAP", () => $4d5b43a119b93be9$export$862abc666c31a61a);
$parcel$export(module.exports, "MEATBALL_DROPDOWN", () => $4d5b43a119b93be9$export$f06dfcec5ff912e);
$parcel$export(module.exports, "PERMISSIONS_CACHE_TTL", () => $4d5b43a119b93be9$export$5448370085586a5f);
const $4d5b43a119b93be9$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Roadmaps';
const $4d5b43a119b93be9$export$d57b6b390e78d90f = 'jpd-horizon';
const $4d5b43a119b93be9$export$3fc15b6d7f7757ac = 'viewAllRoadmaps';
const $4d5b43a119b93be9$export$862abc666c31a61a = 'createRoadmaps';
const $4d5b43a119b93be9$export$f06dfcec5ff912e = 'meatballDropdown';
const $4d5b43a119b93be9$export$5448370085586a5f = 600000; // 10 minutes

});

parcelRegister("4bCl7", function(module, exports) {
$parcel$export(module.exports, "RoadmapsStatic", () => $a4c37ce13b3d657d$export$4c4071eb62c5e1cf);

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $8lgoE = parcelRequire("8lgoE");

var $gdBMj = parcelRequire("gdBMj");

var $bQoR3 = parcelRequire("bQoR3");

var $9Ku9P = parcelRequire("9Ku9P");

var $fqYMs = parcelRequire("fqYMs");

var $jThqL = parcelRequire("jThqL");
const $a4c37ce13b3d657d$export$4c4071eb62c5e1cf = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, actionsOnHover: actionsOnHover, children: children } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const isJpdProjectView = (0, $fqYMs.useIsJpdProjectView)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $h4Bzb.MENU_ID_ROADMAPS),
        onExpansionToggle: (hasExpanded)=>{
            onExpansionToggle?.(hasExpanded);
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).ROADMAPS,
                sectionItem: (0, $a9aec.SECTION_ITEM_ROADMAPS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-roadmaps-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ku9P.PremiumLozenge), null),
        testId: (0, $azEgq.getTestId)((0, $h4Bzb.MENU_ID_ROADMAPS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jThqL.Footer), null))), isJpdProjectView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gdBMj.RoadmapIntroductionSpotlight), {
        collectionsUrl: (0, $bQoR3.getCollectionsPageUrl)(),
        placement: "right middle"
    }));
});

});
parcelRegister("8lgoE", function(module, exports) {
$parcel$export(module.exports, "GO_TO_PROJECT_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$d4b65c1c7753dab5);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$5ca3ca33630ba93c);
$parcel$export(module.exports, "EXPLORE_SECTION_MESSAGE_DISMISSED", () => $512de23a1d0d4ccd$export$a81698c00c65eb4a);
$parcel$export(module.exports, "SEEN_PULSATING_FIELDS_BUTTON", () => $512de23a1d0d4ccd$export$3085446206860099);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$d32c1bbde6ae670d);
$parcel$export(module.exports, "PROJECT_FIELDS_PAGE_VIEWED", () => $512de23a1d0d4ccd$export$ca2e8a74c8b43637);
$parcel$export(module.exports, "TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED", () => $512de23a1d0d4ccd$export$c6877be73b5f3d5a);
$parcel$export(module.exports, "COLLECTIONS_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$9a1ee3e31621d60);
$parcel$export(module.exports, "PREMIUM_MODAL_DISMISSED", () => $512de23a1d0d4ccd$export$522f4dc72dc494f2);
$parcel$export(module.exports, "PREMIUM_LAST_VISIT", () => $512de23a1d0d4ccd$export$34f7000ddecc0e7f);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$1be797d9a57b42ac);
$parcel$export(module.exports, "CROSS_PROJECT_LIST_VIEW_FIELDS_DISMISSED_KEY", () => $512de23a1d0d4ccd$export$c176277d0ae24685);
$parcel$export(module.exports, "CROSS_PROJECT_TIMELINE_VIEW_FIELDS_DISMISSED_KEY", () => $512de23a1d0d4ccd$export$dc14a417cdf40a4e);
$parcel$export(module.exports, "CROSS_PROJECT_BOARD_VIEW_FIELDS_DISMISSED_KEY", () => $512de23a1d0d4ccd$export$76d94539e8fefb4a);
$parcel$export(module.exports, "CROSS_PROJECT_MATRIX_VIEW_FIELDS_DISMISSED_KEY", () => $512de23a1d0d4ccd$export$c98b8b1065f15440);
$parcel$export(module.exports, "USER_PROPERTY_BY_STATE_KEY", () => $512de23a1d0d4ccd$export$61a0683bfb4060d7);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$34cb8e95f71c5026);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $512de23a1d0d4ccd$export$7f842ac8d21dd77c);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $512de23a1d0d4ccd$export$bd207a2522aeeba4);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $512de23a1d0d4ccd$export$204b6702ab1fae0e);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $512de23a1d0d4ccd$export$14b1ce7029803351);
$parcel$export(module.exports, "GLOBAL_FIELDS_GO_TO_PROJECT_SPOTLIGHT", () => $512de23a1d0d4ccd$export$4aa3d2e1dc759f3c);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$c1ff7f4df78bdbc4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $512de23a1d0d4ccd$export$465e1e9058d0a33e);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $512de23a1d0d4ccd$export$22cb3b19b9a67a4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $512de23a1d0d4ccd$export$639255389f81ee25);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_5", () => $512de23a1d0d4ccd$export$5420b6f468b681cb);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $512de23a1d0d4ccd$export$b51c0dd69192efcd);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT", () => $512de23a1d0d4ccd$export$1e3c409324b9e1c8);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$960902aa280e7c02);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$a2cbd84444b19ad9);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_LAST", () => $512de23a1d0d4ccd$export$1ecd157040cc790b);
$parcel$export(module.exports, "NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$6e3db205cdfcc126);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$2c379250399a65);
$parcel$export(module.exports, "ROADMAP_VIEW_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$6ec637a8d4b52e12);
$parcel$export(module.exports, "ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$4c25160b46095f67);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT", () => $512de23a1d0d4ccd$export$ec0f5ceae1abcc93);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$4aa206dd068119fd);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS", () => $512de23a1d0d4ccd$export$84d5c6b713e2a436);
$parcel$export(module.exports, "PRODUCT_START_TIMESTAMP", () => $512de23a1d0d4ccd$export$810ba1749ac4ea65);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS", () => $512de23a1d0d4ccd$export$979841afe77608d2);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$54f2fcb05cde1625);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS_STEP_2", () => $512de23a1d0d4ccd$export$61b8070a65644ed3);
$parcel$export(module.exports, "IMPORT_BULK_CREATE_SPOTLIGHT", () => $512de23a1d0d4ccd$export$ae0700c970c493ac);
$parcel$export(module.exports, "IMPORT_BULK_CREATE_ONBOARDING", () => $512de23a1d0d4ccd$export$e65d607810623c19);
$parcel$export(module.exports, "CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT", () => $512de23a1d0d4ccd$export$89ec57c839f38d47);
$parcel$export(module.exports, "CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$d39bf566f27a11d7);
$parcel$export(module.exports, "FILTER_INTERVAL_SPOTLIGHT", () => $512de23a1d0d4ccd$export$dd613a8c8409b1c5);
$parcel$export(module.exports, "FILTER_INTERVAL_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$1c221b44bdc0e443);
$parcel$export(module.exports, "QUICKSTART_THESE_ARE_YOUR_VIEWS_SPOTLIGHT", () => $512de23a1d0d4ccd$export$25ad2dda7a78dd99);
$parcel$export(module.exports, "QUICKSTART_THESE_ARE_YOUR_VIEWS_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$ea112f18b360b2fa);
$parcel$export(module.exports, "UNIFIED_SHARE_DIALOG_SPOTLIGHT", () => $512de23a1d0d4ccd$export$dfa04a2f77057fc0);
// User property names
const $512de23a1d0d4ccd$export$d4b65c1c7753dab5 = 'polaris.global-fields.go-to-project-spotlight-dismissed';
const $512de23a1d0d4ccd$export$5ca3ca33630ba93c = 'polaris.global-fields.tour-dismissed';
const $512de23a1d0d4ccd$export$a81698c00c65eb4a = 'polaris.project-fields.explore-section-message-dismissed';
const $512de23a1d0d4ccd$export$3085446206860099 = 'polaris.project-fields.seen-pulsating-fields-button';
const $512de23a1d0d4ccd$export$d32c1bbde6ae670d = 'polaris.project-fields.tour-dismissed';
const $512de23a1d0d4ccd$export$ca2e8a74c8b43637 = 'polaris.project-fields.page-viewed';
const $512de23a1d0d4ccd$export$c6877be73b5f3d5a = 'polaris.timeline.dates-config-section-message-dismissed';
const $512de23a1d0d4ccd$export$9a1ee3e31621d60 = 'polaris.collections.tour-dismissed';
const $512de23a1d0d4ccd$export$522f4dc72dc494f2 = 'polaris.premium.modal-dismissed';
const $512de23a1d0d4ccd$export$34f7000ddecc0e7f = 'polaris.premium.last-visit';
const $512de23a1d0d4ccd$export$1be797d9a57b42ac = 'polaris.cross-project-view.tour-dismissed';
const $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED = 'polaris.cross-project-view.list-fields-dismissed';
const $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED = 'polaris.cross-project-view.timeline-fields-dismissed';
const $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED = 'polaris.cross-project-view.board-fields-dismissed';
const $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED = 'polaris.cross-project-view.matrix-fields-dismissed';
const $512de23a1d0d4ccd$export$c176277d0ae24685 = 'listViewfieldsDismissed';
const $512de23a1d0d4ccd$export$dc14a417cdf40a4e = 'timelineViewfieldsDismissed';
const $512de23a1d0d4ccd$export$76d94539e8fefb4a = 'boardViewfieldsDismissed';
const $512de23a1d0d4ccd$export$c98b8b1065f15440 = 'matrixViewfieldsDismissed';
const $512de23a1d0d4ccd$export$61a0683bfb4060d7 = {
    [$512de23a1d0d4ccd$export$c176277d0ae24685]: $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED,
    [$512de23a1d0d4ccd$export$dc14a417cdf40a4e]: $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED,
    [$512de23a1d0d4ccd$export$76d94539e8fefb4a]: $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED,
    [$512de23a1d0d4ccd$export$c98b8b1065f15440]: $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED
};
const $512de23a1d0d4ccd$export$34cb8e95f71c5026 = 'global-fields.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$7f842ac8d21dd77c = 'global-fields.tour.spotlights.step-2';
const $512de23a1d0d4ccd$export$bd207a2522aeeba4 = 'global-fields.tour.spotlights.step-3';
const $512de23a1d0d4ccd$export$204b6702ab1fae0e = 'global-fields.tour.spotlights.step-4';
const $512de23a1d0d4ccd$export$14b1ce7029803351 = 'global-fields.tour.spotlights.step-last';
const $512de23a1d0d4ccd$export$4aa3d2e1dc759f3c = 'global-fields.go-to-project.spotlight';
const $512de23a1d0d4ccd$export$c1ff7f4df78bdbc4 = 'project-fields.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$465e1e9058d0a33e = 'project-fields.tour.spotlights.step-2';
const $512de23a1d0d4ccd$export$22cb3b19b9a67a4 = 'project-fields.tour.spotlights.step-3';
const $512de23a1d0d4ccd$export$639255389f81ee25 = 'project-fields.tour.spotlights.step-4';
const $512de23a1d0d4ccd$export$5420b6f468b681cb = 'project-fields.tour.spotlights.step-5';
const $512de23a1d0d4ccd$export$b51c0dd69192efcd = 'project-fields.tour.spotlights.step-last';
const $512de23a1d0d4ccd$export$1e3c409324b9e1c8 = 'collections.create-roadmap.spotlight';
const $512de23a1d0d4ccd$export$960902aa280e7c02 = 'collections.create-roadmap.spotlight-dismissed';
const $512de23a1d0d4ccd$export$a2cbd84444b19ad9 = 'cross-project-view.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$1ecd157040cc790b = 'cross-project-view.tour.spotlights.step-last';
const $512de23a1d0d4ccd$export$f0a483c398048551 = 'jpd-nav-views.spotlight';
const $512de23a1d0d4ccd$export$6e3db205cdfcc126 = 'polaris.nav-jpd-views.spotlight-dismissed';
const $512de23a1d0d4ccd$export$6231ca46e95bc736 = 'prioritization-view.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$cd247efd7ec3525c = 'prioritization-view.tour.spotlights.step-last';
const $512de23a1d0d4ccd$export$2c379250399a65 = 'polaris.prioritization-view.tour-dismissed';
const $512de23a1d0d4ccd$export$3134ae340fb4ae39 = 'roadmap-view.spotlight';
const $512de23a1d0d4ccd$export$6ec637a8d4b52e12 = 'polaris.roadmap-view.spotlight-dismissed';
const $512de23a1d0d4ccd$export$10bda8c91e48ff2c = 'roadmap-view.column-config.spotlight';
const $512de23a1d0d4ccd$export$4c25160b46095f67 = 'polaris.roadmap-view.column-config-spotlight-dismissed';
const $512de23a1d0d4ccd$export$ec0f5ceae1abcc93 = 'roadmap.introduction.spotlight';
const $512de23a1d0d4ccd$export$4aa206dd068119fd = 'roadmap.introduction.spotlight.dismissed';
const $512de23a1d0d4ccd$export$ef2e4b0f650c3249 = 'roadmap-view.initial-prompt.spotlight';
const $512de23a1d0d4ccd$export$84d5c6b713e2a436 = [
    $512de23a1d0d4ccd$export$522f4dc72dc494f2,
    $512de23a1d0d4ccd$export$6e3db205cdfcc126
];
const $512de23a1d0d4ccd$export$810ba1749ac4ea65 = 'polaris.product-start-timestamp';
const $512de23a1d0d4ccd$export$979841afe77608d2 = 'polaris.blueprints.tour.spotlights';
const $512de23a1d0d4ccd$export$54f2fcb05cde1625 = `${$512de23a1d0d4ccd$export$979841afe77608d2}.step-1`;
const $512de23a1d0d4ccd$export$61b8070a65644ed3 = `${$512de23a1d0d4ccd$export$979841afe77608d2}.step-2`;
const $512de23a1d0d4ccd$export$ae0700c970c493ac = 'polaris.import.bulk-create.spotlight';
const $512de23a1d0d4ccd$export$e65d607810623c19 = 'polaris.import.bulk-create';
const $512de23a1d0d4ccd$export$89ec57c839f38d47 = 'polaris.custom-dates.customize.spotlight';
const $512de23a1d0d4ccd$export$d39bf566f27a11d7 = 'polaris.custom-dates.customize.spotlight-dismissed';
const $512de23a1d0d4ccd$export$dd613a8c8409b1c5 = 'polaris.filters.interval.spotlight';
const $512de23a1d0d4ccd$export$1c221b44bdc0e443 = 'polaris.filters.interval.spotlight-dismissed';
const $512de23a1d0d4ccd$export$25ad2dda7a78dd99 = 'polaris.quickstart.these-are-your-views.spotlight';
const $512de23a1d0d4ccd$export$ea112f18b360b2fa = 'polaris.quickstart.these-are-your-views.spotlight-dismissed';
const $512de23a1d0d4ccd$export$dfa04a2f77057fc0 = 'polaris.unified-share.spotlight';

});

parcelRegister("gdBMj", function(module, exports) {
$parcel$export(module.exports, "RoadmapIntroductionSpotlight", () => $0da5bb5e44df65a0$export$71e9b7b9d410b300);

var $eJOHy = parcelRequire("eJOHy");

var $d2s5v = parcelRequire("d2s5v");

var $ceCqR = parcelRequire("ceCqR");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iC2Fk = parcelRequire("iC2Fk");

var $83DiZ = parcelRequire("83DiZ");

var $8lgoE = parcelRequire("8lgoE");

var $4l17z = parcelRequire("4l17z");

var $4V76I = parcelRequire("4V76I");

var $a6k1J = parcelRequire("a6k1J");

var $cLtfY = parcelRequire("cLtfY");

var $fU6b0 = parcelRequire("fU6b0");
const $0da5bb5e44df65a0$export$71e9b7b9d410b300 = ({ collectionsUrl: collectionsUrl, placement: placement })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isLicensedUser = (0, $fU6b0.useIsLicensedUser)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const expandSideNav = (0, $ceCqR.useExpandSideNav)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');
    const { loadRoadmapIntroductionDismissed: loadRoadmapIntroductionDismissed, loadRoadmapIntroductionPrerequisiteDismissalsMet: loadRoadmapIntroductionPrerequisiteDismissalsMet, loadProductUsageStartTimestamp: loadProductUsageStartTimestamp, setRoadmapIntroductionDismissed: setRoadmapIntroductionDismissed } = (0, $4l17z.useOnboardingFlowsActions)();
    (0, $eJOHy.useEffect)(()=>{
        // we can prevent unnecessary calls in these cases
        if (isAlreadyInRoadmaps || !isLicensedUser) return;
        loadRoadmapIntroductionDismissed();
        loadRoadmapIntroductionPrerequisiteDismissalsMet();
        loadProductUsageStartTimestamp();
    }, [
        isAlreadyInRoadmaps,
        isLicensedUser,
        loadProductUsageStartTimestamp,
        loadRoadmapIntroductionDismissed,
        loadRoadmapIntroductionPrerequisiteDismissalsMet
    ]);
    const isIntroductionDismissed = (0, $4V76I.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $4V76I.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $a6k1J.useProductUsageStartTimestamp)();
    if (isAlreadyInRoadmaps || !isLicensedUser || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !(0, $fU6b0.checkIfOlderThanNDays)(productUsageStartTimestamp)) return null;
    const dismiss = (analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'dismiss');
        setRoadmapIntroductionDismissed();
    };
    const openRoadmaps = (analyticsEvent)=>{
        if (analyticsEvent) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'openRoadmaps');
        else (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'openRoadmaps');
        setRoadmapIntroductionDismissed();
        push(collectionsUrl);
    };
    expandSideNav();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>dismiss(analyticsEvent),
                text: formatMessage((0, $cLtfY.messages).dismiss),
                testId: 'roadmap-introduction-spotlight-dismiss-button'
            },
            {
                onClick: (_, analyticsEvent)=>openRoadmaps(analyticsEvent),
                text: formatMessage((0, $cLtfY.messages).giveItATry)
            }
        ],
        dialogPlacement: placement,
        dialogWidth: 275,
        target: (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT),
        key: (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT),
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetOnClick: (_event)=>openRoadmaps(),
        messageId: "polaris-lib-onboarding-flows.ui.collections.tour.roadmap-introduction-spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $cLtfY.messages).messageGalaxia : (0, $cLtfY.messages).message)));
};

});
parcelRegister("iC2Fk", function(module, exports) {
$parcel$export(module.exports, "JiraSpotlight", () => $f9606edbb9d6ac2c$export$e209c6be9ab8c4f4);

var $eJOHy = parcelRequire("eJOHy");

var $bdRit = parcelRequire("bdRit");

var $bRMVI = parcelRequire("bRMVI");

var $jhwBn = parcelRequire("jhwBn");
const $f9606edbb9d6ac2c$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jhwBn.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdRit.default), rest);
};

});
parcelRegister("jhwBn", function(module, exports) {
$parcel$export(module.exports, "ChoreographerSpotlight", () => $6b087f16b1648dd4$export$e01943d134357d00);

var $bdRit = parcelRequire("bdRit");

var $5hQBi = parcelRequire("5hQBi");
const $6b087f16b1648dd4$export$e01943d134357d00 = (0, $5hQBi.withChoreographedRender)((0, $bdRit.default));

});


parcelRegister("4l17z", function(module, exports) {
$parcel$export(module.exports, "useOnboardingFlowsActions", () => $8b28f138eeffe50d$export$e3d86ac85365138c);
$parcel$export(module.exports, "createHook", () => $8b28f138eeffe50d$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "OnboardingFlowsContainer", () => $8b28f138eeffe50d$export$214c4fcbf19b9a1d);

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");

var $YvHeB = parcelRequire("YvHeB");

var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

var $keeNI = parcelRequire("keeNI");

var $9dAsI = parcelRequire("9dAsI");
const $8b28f138eeffe50d$export$46c52354b8798e89 = (0, $GtRbT.createStore)({
    name: 'PolarisLibOnboardingFlowsStore',
    initialState: {
        containerProps: {
            accountId: undefined
        },
        productUsageStartTimestamp: undefined,
        globalFields: {
            goToProjectSpotlightDismissed: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        projectFields: {
            exploreSectionMessageDismissed: undefined,
            seenPulsatingFieldsButton: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null,
            pageViewed: undefined
        },
        collections: {
            tourDismissed: undefined,
            tourSpotlightStep: null,
            introductionDismissed: undefined,
            introductionPrerequisiteDismissalsMet: undefined
        },
        crossProjectView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        import: {
            spotlightDismissed: undefined,
            successNotificationViewed: undefined
        },
        timeline: {
            sectionMessageDismissed: undefined
        },
        allViews: {
            spotlightDismissed: undefined
        },
        prioritizationView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        roadmapView: {
            spotlightDismissed: undefined,
            columnConfigSpotlightDismissed: undefined
        },
        blueprints: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        premium: {
            modalDismissed: undefined,
            lastVisit: {
                isPremium: undefined,
                updated: undefined
            },
            promise: (0, $keeNI.createDeferredPromise)()
        },
        customDates: {
            customizeSpotlightDismissed: undefined
        },
        filterInterval: {
            spotlightDismissed: undefined
        },
        quickstart: {
            theseAreYourViewsSpotlightDismissed: undefined
        },
        unifiedShareDialog: {
            spotlightDismissed: undefined
        }
    },
    actions: $9dAsI.default
});
const { Container: $8b28f138eeffe50d$export$2e28a971a45925e3, useActions: $8b28f138eeffe50d$export$e3d86ac85365138c, createHook: $8b28f138eeffe50d$export$e7f733c8fc2b8a24, createHigherLevelHook: $8b28f138eeffe50d$export$757252247e722815 } = (0, $YvHeB.createJpdContainer)($8b28f138eeffe50d$export$46c52354b8798e89);
const $8b28f138eeffe50d$export$214c4fcbf19b9a1d = ({ accountId: accountId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), {
        blanketIsTinted: !(0, $4cTDP.fg)('jpd_quickstart_onboarding-setup')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b28f138eeffe50d$export$2e28a971a45925e3, {
        isGlobal: true,
        accountId: accountId
    }, children));

});
parcelRegister("YvHeB", function(module, exports) {
$parcel$export(module.exports, "createJpdContainer", () => $7499141d40d19115$export$7ed5db99dcc39128);

var $5PQOA = parcelRequire("5PQOA");

var $3degy = parcelRequire("3degy");

var $iJq0l = parcelRequire("iJq0l");

var $9bKio = parcelRequire("9bKio");
const $7499141d40d19115$var$createSelectorHook = (store, selector)=>{
    const innerHook = (0, $iJq0l.createHook)(store, {
        selector: (state)=>selector(state, state.containerProps)
    });
    return ()=>{
        const [val] = innerHook();
        return val;
    };
};
const $7499141d40d19115$export$757252247e722815 = (store, selectorCreator)=>{
    // TODO POL-2195 memoize one is not suitable for this task, as it will only memoize the last invocation. while this
    //               improves subsequent calls with the same argument set, it does not improve calls with different args
    //               this case should be solved with a generic memoization lib, e.g. reselect (4.1+) or moize
    //               discussion: https://hello.atlassian.net/wiki/spaces/TGR/pages/1416371989/Dependency+review+moize
    const memoizedSelectorCreator = (0, $3degy.cacheSelectorCreator)(selectorCreator);
    // TODO POL-2195 in the meantime, we can use lodash/memoize to at least solve the 1-ary case,
    //               which should be 99% of our selector creators anyway
    const monadicSelectorCreatorMemoized = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))(selectorCreator);
    const rssHook = (0, $iJq0l.createHook)(store, {
        selector: (state, args)=>{
            if (args.length <= 1) return monadicSelectorCreatorMemoized(...args)(state, state.containerProps);
            return memoizedSelectorCreator(...args)(state, state.containerProps);
        }
    });
    return (...args)=>{
        // @ts-expect-error - TS2345 - Argument of type 'SelectorCreatorArgs' is not assignable to parameter
        const [val] = rssHook(args);
        return val;
    };
};
const $7499141d40d19115$export$7ed5db99dcc39128 = (store, options)=>{
    const Container = (0, $9bKio.createContainerWithContext)(store, options);
    const useEmptyState = (0, $iJq0l.createHook)(store, {
        selector: null
    });
    const useActions = ()=>{
        const [, actions] = useEmptyState();
        return actions;
    };
    return {
        createHook: (selector)=>$7499141d40d19115$var$createSelectorHook(store, selector),
        createHigherLevelHook: (selectorCreator)=>$7499141d40d19115$export$757252247e722815(store, selectorCreator),
        useActions: useActions,
        Container: Container
    };
};

});
parcelRegister("3degy", function(module, exports) {
$parcel$export(module.exports, "cacheSelectorCreator", () => $5efa69f054078620$export$413433974f0869c3);
$parcel$export(module.exports, "getCacheValue", () => $5efa69f054078620$export$e15acfbd8ab989dd);
let $5efa69f054078620$var$cache = new WeakMap();
let $5efa69f054078620$var$jsonEqualityMap = new WeakMap();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5efa69f054078620$var$getValueFromJsonEqualityCache = (f, value, options)=>{
    if (options?.useJsonEquality !== true) return value;
    if (!$5efa69f054078620$var$jsonEqualityMap.has(f)) $5efa69f054078620$var$jsonEqualityMap.set(f, new Map());
    const storage = $5efa69f054078620$var$jsonEqualityMap.get(f);
    try {
        const key = JSON.stringify(value);
        if (storage.has(key)) return storage.get(key);
        storage.set(key, value);
    } catch  {
    // do nothing
    }
    return value;
};
function $5efa69f054078620$export$413433974f0869c3(f, options) {
    if (f.__isCachedSelectorCreator === true) return f;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cacheFunction = (...args)=>{
        if ($5efa69f054078620$var$cache.has(f)) {
            let lastNode = $5efa69f054078620$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $5efa69f054078620$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) {
                    lastNode = null;
                    break;
                }
                lastNode = lastNode.args.get(value);
            }
            if (lastNode?.selector) return lastNode.selector;
        }
        const maybeSelector = f(...args);
        if (typeof maybeSelector?.resultFunc === 'function' || typeof maybeSelector === 'function') {
            if (!$5efa69f054078620$var$cache.has(f)) $5efa69f054078620$var$cache.set(f, {
                args: new Map(),
                selector: null
            });
            let lastNode = $5efa69f054078620$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $5efa69f054078620$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) lastNode.args.set(value, {
                    args: new Map(),
                    selector: null
                });
                lastNode = lastNode.args.get(value);
            }
            lastNode.selector = maybeSelector;
        }
        return maybeSelector;
    };
    cacheFunction.__isCachedSelectorCreator = true;
    cacheFunction.__origin = f;
    cacheFunction.displayName = f.name || f.displayName;
    return cacheFunction;
}
const $5efa69f054078620$export$e2575ed62a2f107b = ()=>$5efa69f054078620$var$cache;
const $5efa69f054078620$export$e15acfbd8ab989dd = (key)=>$5efa69f054078620$var$cache.get(key);
const $5efa69f054078620$export$6e5dca841bdf93e3 = ()=>{
    $5efa69f054078620$var$cache = new WeakMap();
    $5efa69f054078620$var$jsonEqualityMap = new WeakMap();
};

});

parcelRegister("9bKio", function(module, exports) {
$parcel$export(module.exports, "createContainerWithContext", () => $5c9c76096353f4fd$export$ce6d80db779db7dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");

var $kBbPj = parcelRequire("kBbPj");
const $5c9c76096353f4fd$export$ce6d80db779db7dc = (store, options)=>(0, $6E16M.createContainer)(store, {
        ...options,
        onInit: ()=>(api, containerProps)=>{
                (0, $kBbPj.batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props
                    });
                    options?.onInit && dispatch(options.onInit());
                })(api, containerProps);
            },
        onUpdate: ()=>(api, containerProps)=>{
                (0, $kBbPj.batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                    const prevContainerProps = getState().containerProps;
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props,
                        prevContainerProps: prevContainerProps
                    });
                    options?.onUpdate && dispatch(options.onUpdate());
                })(api, containerProps);
            }
    });

});
parcelRegister("kBbPj", function(module, exports) {
$parcel$export(module.exports, "batchStateUpdates", () => $bb22704e5822629d$export$4f8b20404a906ca3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $bb22704e5822629d$export$4f8b20404a906ca3 = (cb)=>(api, containerProps)=>{
        let finalized = false;
        let localState = api.getState();
        const setState = (newState)=>{
            if (finalized) {
                api.setState(newState);
                return;
            }
            localState = {
                ...localState,
                ...newState
            };
        };
        const getState = ()=>finalized ? api.getState() : localState;
        const dispatch = (action)=>finalized ? action(api, containerProps) : action({
                dispatch: dispatch,
                setState: setState,
                getState: getState
            }, containerProps);
        const patchedApi = {
            setState: setState,
            getState: getState,
            dispatch: dispatch
        };
        cb(patchedApi, containerProps);
        finalized = true;
        api.setState({
            ...localState
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        localState = null;
    };

});



parcelRegister("keeNI", function(module, exports) {
$parcel$export(module.exports, "checkIfActivatedMoreThanFourDays", () => $a0445579fc070562$export$562701f849a0aba7);
$parcel$export(module.exports, "normalizeError", () => $a0445579fc070562$export$e7bd538fb0c5db1a);
$parcel$export(module.exports, "createDeferredPromise", () => $a0445579fc070562$export$87a845ded7190bfc);
$parcel$export(module.exports, "checkPrerequisiteDismissals", () => $a0445579fc070562$export$b20d00c7cb810f65);

var $ltT7m = parcelRequire("ltT7m");

var $FppkK = parcelRequire("FppkK");
const $a0445579fc070562$export$562701f849a0aba7 = (productUsageStartTimestamp)=>{
    const diffInDays = (0, $ltT7m.default)(new Date(), new Date(productUsageStartTimestamp));
    return diffInDays >= 4;
};
const $a0445579fc070562$export$e7bd538fb0c5db1a = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unknown error');
};
function $a0445579fc070562$export$87a845ded7190bfc() {
    // These will be properly initialized in the Promise constructor
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $a0445579fc070562$export$b20d00c7cb810f65 = async (prerequisiteDismissals, accountId)=>{
    if (!accountId) return;
    const prerequisiteDismissalsPromises = prerequisiteDismissals.map((prerequisite)=>{
        return (0, $FppkK.getUserProperty)(accountId, prerequisite);
    });
    return Promise.all(prerequisiteDismissalsPromises);
};

});

parcelRegister("9dAsI", function(module, exports) {
$parcel$export(module.exports, "default", () => $86ee4bbffd878936$export$2e2bcd8739ae039);

var $4cu2f = parcelRequire("4cu2f");

var $4wy8S = parcelRequire("4wy8S");

var $44DL8 = parcelRequire("44DL8");

var $pSAW0 = parcelRequire("pSAW0");

var $eEmTF = parcelRequire("eEmTF");

var $i0Ba0 = parcelRequire("i0Ba0");

var $kGCNw = parcelRequire("kGCNw");

var $5kTW7 = parcelRequire("5kTW7");

var $1E16I = parcelRequire("1E16I");

var $iUnS8 = parcelRequire("iUnS8");

var $1mj6M = parcelRequire("1mj6M");

var $brsgS = parcelRequire("brsgS");

var $2t7P4 = parcelRequire("2t7P4");

var $1BMqo = parcelRequire("1BMqo");

var $k2Yjr = parcelRequire("k2Yjr");

var $88hWw = parcelRequire("88hWw");

var $2atAT = parcelRequire("2atAT");

var $luGqn = parcelRequire("luGqn");

var $efRp8 = parcelRequire("efRp8");

var $80clw = parcelRequire("80clw");

var $2QyGs = parcelRequire("2QyGs");

var $f17in = parcelRequire("f17in");

var $8iz9g = parcelRequire("8iz9g");

var $2Ir1d = parcelRequire("2Ir1d");

var $ZWO1M = parcelRequire("ZWO1M");

var $2ZyJ1 = parcelRequire("2ZyJ1");
const $86ee4bbffd878936$var$actions = {
    loadProductUsageStartTimestamp: $2QyGs.loadProductUsageStartTimestamp,
    loadGoToProjectSpotlightDismissed: $kGCNw.loadGoToProjectSpotlightDismissed,
    setGoToProjectSpotlightDismissed: $kGCNw.setGoToProjectSpotlightDismissed,
    setGlobalFieldsTourSpotlightStep: $5kTW7.setGlobalFieldsTourSpotlightStep,
    loadGlobalFieldsTourDismissed: $1E16I.loadGlobalFieldsTourDismissed,
    setGlobalFieldsTourDismissed: $1E16I.setGlobalFieldsTourDismissed,
    loadExploreSectionMessageDismissed: $iUnS8.loadExploreSectionMessageDismissed,
    setExploreSectionMessageDismissed: $iUnS8.setExploreSectionMessageDismissed,
    loadProjectFieldsPageViewed: $1mj6M.loadProjectFieldsPageViewed,
    setProjectFieldsPageViewed: $1mj6M.setProjectFieldsPageViewed,
    loadSeenPulsatingFieldsButton: $brsgS.loadSeenPulsatingFieldsButton,
    setSeenPulsatingFieldsButton: $brsgS.setSeenPulsatingFieldsButton,
    loadProjectFieldsTourDismissed: $1BMqo.loadProjectFieldsTourDismissed,
    setProjectFieldsTourDismissed: $1BMqo.setProjectFieldsTourDismissed,
    setProjectFieldsTourSpotlightStep: $2t7P4.setProjectFieldsTourSpotlightStep,
    loadCollectionsTourDismissed: $4wy8S.loadCollectionsTourDismissed,
    loadRoadmapIntroductionPrerequisiteDismissalsMet: $i0Ba0.loadRoadmapIntroductionPrerequisiteDismissalsMet,
    setCollectionsTourDismissed: $4wy8S.setCollectionsTourDismissed,
    setCollectionsTourSpotlightStep: $4cu2f.setCollectionsTourSpotlightStep,
    loadRoadmapIntroductionDismissed: $i0Ba0.loadRoadmapIntroductionDismissed,
    setRoadmapIntroductionDismissed: $i0Ba0.setRoadmapIntroductionDismissed,
    loadCrossProjectViewTourDismissed: $eEmTF.loadCrossProjectViewTourDismissed,
    setCrossProjectViewTourDismissed: $eEmTF.setCrossProjectViewTourDismissed,
    setCrossProjectViewTourSpotlightStep: $pSAW0.setCrossProjectViewTourSpotlightStep,
    loadTimelineSectionMessageDismissed: $k2Yjr.loadTimelineSectionMessageDismissed,
    setTimelineSectionMessageDismissed: $k2Yjr.setTimelineSectionMessageDismissed,
    loadCrossProjectViewFieldsDismissed: $44DL8.loadCrossProjectViewFieldsDismissed,
    setCrossProjectViewFieldsDismissed: $44DL8.setCrossProjectViewFieldsDismissed,
    loadAllViewsSpotlightDismissed: $88hWw.loadAllViewsSpotlightDismissed,
    setAllViewsSpotlightDismissed: $88hWw.setAllViewsSpotlightDismissed,
    loadRoadmapViewSpotlightDismissed: $luGqn.loadRoadmapViewSpotlightDismissed,
    setRoadmapViewSpotlightDismissed: $luGqn.setRoadmapViewSpotlightDismissed,
    loadRoadmapColumnConfigSpotlightDismissed: $luGqn.loadRoadmapColumnConfigSpotlightDismissed,
    setRoadmapColumnConfigSpotlightDismissed: $luGqn.setRoadmapColumnConfigSpotlightDismissed,
    loadPrioritizationViewTourDismissed: $2atAT.loadPrioritizationViewTourDismissed,
    setPrioritizationViewTourDismissed: $2atAT.setPrioritizationViewTourDismissed,
    setPrioritizationViewTourSpotlightStep: $2atAT.setPrioritizationViewTourSpotlightStep,
    setBlueprintsTourDismissed: $efRp8.setBlueprintsTourDismissed,
    setBlueprintsTourStep: $efRp8.setBlueprintsTourStep,
    loadBlueprintsState: $efRp8.loadBlueprintsState,
    loadPremiumLastVisit: $80clw.loadPremiumLastVisit,
    loadPremiumModalDismissed: $80clw.loadPremiumModalDismissed,
    setPremiumLastVisit: $80clw.setPremiumLastVisit,
    setPremiumModalDismissed: $80clw.setPremiumModalDismissed,
    loadCustomDatesCustomizeSpotlightDismissed: $8iz9g.loadCustomDatesCustomizeSpotlightDismissed,
    setCustomDatesCustomizeSpotlightDismissed: $8iz9g.setCustomDatesCustomizeSpotlightDismissed,
    unlockOnboardingFlow: $80clw.unlockOnboardingFlow,
    loadImportState: $2Ir1d.loadImportState,
    setImportSpotlightDismissed: $2Ir1d.setImportSpotlightDismissed,
    setSuccessNotificationViewed: $2Ir1d.setSuccessNotificationViewed,
    loadFilterIntervalSpotlightDismissed: $ZWO1M.loadFilterIntervalSpotlightDismissed,
    setFilterIntervalSpotlightDismissed: $ZWO1M.setFilterIntervalSpotlightDismissed,
    loadTheseAreYourViewsSpotlightDismissed: $f17in.loadTheseAreYourViewsSpotlightDismissed,
    setTheseAreYourViewsSpotlightDismissed: $f17in.setTheseAreYourViewsSpotlightDismissed,
    loadUnifiedShareDialogSpotlightState: $2ZyJ1.loadUnifiedShareDialogSpotlightState,
    setUnifiedShareDialogSpotlightDismissed: $2ZyJ1.setUnifiedShareDialogSpotlightDismissed
};
var $86ee4bbffd878936$export$2e2bcd8739ae039 = $86ee4bbffd878936$var$actions;

});
parcelRegister("4cu2f", function(module, exports) {
$parcel$export(module.exports, "setCollectionsTourSpotlightStep", () => $337ddd2af5646587$export$501a98d23141dc4d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $337ddd2af5646587$export$501a98d23141dc4d = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("4wy8S", function(module, exports) {
$parcel$export(module.exports, "loadCollectionsTourDismissed", () => $8bfed876c1634222$export$c7e2395278267e1d);
$parcel$export(module.exports, "setCollectionsTourDismissed", () => $8bfed876c1634222$export$2a7240b702e8d617);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $8bfed876c1634222$export$c7e2395278267e1d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.COLLECTIONS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $8lgoE.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.tourDismissed;
    };
const $8bfed876c1634222$export$2a7240b702e8d617 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.COLLECTIONS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $8lgoE.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});
parcelRegister("6Yd06", function(module, exports) {
$parcel$export(module.exports, "logSafeErrorWithoutCustomerDataWrapper", () => $010050cb32520e49$export$ebd6466ba18b2f3a);

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");




const $010050cb32520e49$export$ebd6466ba18b2f3a = async (location, message, event)=>{
    const modifiedEvent = event;
    if (modifiedEvent instanceof (0, $14RSn.default) && modifiedEvent.originalResponse && // We can't guarantee that response object is always in unread state when we try to log it
    !modifiedEvent.originalResponse?.bodyUsed) {
        const originalResponseText = await modifiedEvent.originalResponse.text();
        modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
        delete modifiedEvent.originalResponse;
    }
    (0, $eSnSE.default).safeErrorWithoutCustomerData(location, message, modifiedEvent);
    // Returning the modified error so the original response text can be used in the error handler
    return modifiedEvent;
};

});

parcelRegister("4y7gv", function(module, exports) {
$parcel$export(module.exports, "maybeWaitForPremiumModal", () => $15fa1fe3cb150362$export$b797d1ff3b371e8a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $15fa1fe3cb150362$export$b797d1ff3b371e8a = async (getState)=>{
    // Await the resolution of the deferred promise associated with the premium modal.
    // This ensures that the premium modal has either never been displayed or has already been closed.
    // This mechanism allows for seamless orchestration of all spotlights within a single package,
    // ensuring they are postponed until the premium modal can be displayed and is dismissed.
    // Treat this similar to the `!accountId`, as every loading action
    // in the `onboarding-flow` package should incorporate this check.
    await getState().premium.promise.promise;
};

});


parcelRegister("44DL8", function(module, exports) {
$parcel$export(module.exports, "loadCrossProjectViewFieldsDismissed", () => $c0a2d5af7a4e4247$export$e6e8b16aaeac983b);
$parcel$export(module.exports, "setCrossProjectViewFieldsDismissed", () => $c0a2d5af7a4e4247$export$2468c71857d0e133);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $c0a2d5af7a4e4247$export$e6e8b16aaeac983b = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView[viewKindStateKey] === 'boolean') return;
        const userProperty = (0, $8lgoE.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            const viewfieldsDismissed = await (0, $FppkK.getUserProperty)(accountId, userProperty);
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    [viewKindStateKey]: viewfieldsDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        [viewKindStateKey]: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to get user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView[viewKindStateKey];
    };
const $c0a2d5af7a4e4247$export$2468c71857d0e133 = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                [viewKindStateKey]: true
            }
        });
        const userProperty = (0, $8lgoE.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            await (0, $FppkK.setUserProperties)(accountId, userProperty, 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to set user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("pSAW0", function(module, exports) {
$parcel$export(module.exports, "setCrossProjectViewTourSpotlightStep", () => $5278fe8d5b2abd77$export$7e29b1ed314f9b12);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $5278fe8d5b2abd77$export$7e29b1ed314f9b12 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("eEmTF", function(module, exports) {
$parcel$export(module.exports, "loadCrossProjectViewTourDismissed", () => $ad3986fdda27241d$export$24c1a2fce44090f2);
$parcel$export(module.exports, "setCrossProjectViewTourDismissed", () => $ad3986fdda27241d$export$d25b2932701a97e6);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $ad3986fdda27241d$export$24c1a2fce44090f2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.CROSS_PROJECT_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $8lgoE.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView.tourDismissed;
    };
const $ad3986fdda27241d$export$d25b2932701a97e6 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.CROSS_PROJECT_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $8lgoE.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("i0Ba0", function(module, exports) {
$parcel$export(module.exports, "loadRoadmapIntroductionDismissed", () => $e751a19bbce1b2fa$export$1a7b263d41622a5b);
$parcel$export(module.exports, "loadRoadmapIntroductionPrerequisiteDismissalsMet", () => $e751a19bbce1b2fa$export$de983a99630cdc7d);
$parcel$export(module.exports, "setRoadmapIntroductionDismissed", () => $e751a19bbce1b2fa$export$19c464c17f9739ab);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");

var $keeNI = parcelRequire("keeNI");
const $e751a19bbce1b2fa$export$1a7b263d41622a5b = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.introductionDismissed === 'boolean') return;
        try {
            const introductionDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    introductionDismissed: introductionDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        introductionDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.introductionDismissed;
    };
const $e751a19bbce1b2fa$export$de983a99630cdc7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        let dismissals = [];
        try {
            dismissals = await (0, $keeNI.checkPrerequisiteDismissals)((0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS), accountId);
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.prerequisites', 'Failed to get user properties for roadmap introduction spotlight prerequisites', error instanceof Error ? error : undefined);
        }
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionPrerequisiteDismissalsMet: dismissals?.every((dismissal)=>dismissal) ?? false
            }
        });
        return getState().collections.introductionPrerequisiteDismissalsMet;
    };
const $e751a19bbce1b2fa$export$19c464c17f9739ab = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to set user property with key: ${(0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("kGCNw", function(module, exports) {
$parcel$export(module.exports, "loadGoToProjectSpotlightDismissed", () => $7e92ee6e9ce54663$export$4c8d16771ecf8930);
$parcel$export(module.exports, "setGoToProjectSpotlightDismissed", () => $7e92ee6e9ce54663$export$3ea7a545c4faccd4);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $7e92ee6e9ce54663$export$4c8d16771ecf8930 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.goToProjectSpotlightDismissed === 'boolean') return;
        try {
            const goToProjectSpotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.GO_TO_PROJECT_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    goToProjectSpotlightDismissed: goToProjectSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        goToProjectSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to get user property with key: ${(0, $8lgoE.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $7e92ee6e9ce54663$export$3ea7a545c4faccd4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                goToProjectSpotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.GO_TO_PROJECT_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to set user property with key: ${(0, $8lgoE.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("5kTW7", function(module, exports) {
$parcel$export(module.exports, "setGlobalFieldsTourSpotlightStep", () => $74e9f8408e6aebf6$export$71a13f0fff467880);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $74e9f8408e6aebf6$export$71a13f0fff467880 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("1E16I", function(module, exports) {
$parcel$export(module.exports, "loadGlobalFieldsTourDismissed", () => $31cd8322bb9c2805$export$6dbef36cf5394497);
$parcel$export(module.exports, "setGlobalFieldsTourDismissed", () => $31cd8322bb9c2805$export$7ddbf8611b7a51e2);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $31cd8322bb9c2805$export$6dbef36cf5394497 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.GLOBAL_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to get user property with key: ${(0, $8lgoE.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $31cd8322bb9c2805$export$7ddbf8611b7a51e2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.GLOBAL_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to set user property with key: ${(0, $8lgoE.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("iUnS8", function(module, exports) {
$parcel$export(module.exports, "loadExploreSectionMessageDismissed", () => $b6ca0042c14d53cf$export$178c75cc028231a2);
$parcel$export(module.exports, "setExploreSectionMessageDismissed", () => $b6ca0042c14d53cf$export$994e754bbe4537c1);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $b6ca0042c14d53cf$export$178c75cc028231a2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.exploreSectionMessageDismissed === 'boolean') return;
        try {
            const exploreSectionMessageDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.EXPLORE_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    exploreSectionMessageDismissed: exploreSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        exploreSectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to get user property with key: ${(0, $8lgoE.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $b6ca0042c14d53cf$export$994e754bbe4537c1 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                exploreSectionMessageDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.EXPLORE_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to set user property with key: ${(0, $8lgoE.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("1mj6M", function(module, exports) {
$parcel$export(module.exports, "loadProjectFieldsPageViewed", () => $92e44813ece466e3$export$2932bbb803f6ab52);
$parcel$export(module.exports, "setProjectFieldsPageViewed", () => $92e44813ece466e3$export$5425efd17972eca4);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $92e44813ece466e3$export$2932bbb803f6ab52 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.pageViewed === 'boolean') return;
        try {
            const pageViewed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PROJECT_FIELDS_PAGE_VIEWED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    pageViewed: pageViewed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        pageViewed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to get user property with key: ${(0, $8lgoE.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };
const $92e44813ece466e3$export$5425efd17972eca4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                pageViewed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PROJECT_FIELDS_PAGE_VIEWED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to set user property with key: ${(0, $8lgoE.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("brsgS", function(module, exports) {
$parcel$export(module.exports, "loadSeenPulsatingFieldsButton", () => $bba4b2cb8118275c$export$4248149cb54f9a58);
$parcel$export(module.exports, "setSeenPulsatingFieldsButton", () => $bba4b2cb8118275c$export$ef1450ffea0c5a63);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $bba4b2cb8118275c$export$4248149cb54f9a58 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.seenPulsatingFieldsButton === 'boolean') return;
        try {
            const seenPulsatingFieldsButton = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.SEEN_PULSATING_FIELDS_BUTTON));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    seenPulsatingFieldsButton: seenPulsatingFieldsButton
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        seenPulsatingFieldsButton: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to get user property with key: ${(0, $8lgoE.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };
const $bba4b2cb8118275c$export$ef1450ffea0c5a63 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                seenPulsatingFieldsButton: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.SEEN_PULSATING_FIELDS_BUTTON), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to set user property with key: ${(0, $8lgoE.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("2t7P4", function(module, exports) {
$parcel$export(module.exports, "setProjectFieldsTourSpotlightStep", () => $ab42590d16599840$export$a6b8eee670a4eb2f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $ab42590d16599840$export$a6b8eee670a4eb2f = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("1BMqo", function(module, exports) {
$parcel$export(module.exports, "loadProjectFieldsTourDismissed", () => $1bbcc7a51fb67314$export$9be5e6fba10e92ef);
$parcel$export(module.exports, "setProjectFieldsTourDismissed", () => $1bbcc7a51fb67314$export$2ad2aec3cf81b681);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $1bbcc7a51fb67314$export$9be5e6fba10e92ef = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PROJECT_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $8lgoE.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $1bbcc7a51fb67314$export$2ad2aec3cf81b681 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PROJECT_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $8lgoE.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("k2Yjr", function(module, exports) {
$parcel$export(module.exports, "loadTimelineSectionMessageDismissed", () => $0de0ee4c7481d644$export$85213c72021b1243);
$parcel$export(module.exports, "setTimelineSectionMessageDismissed", () => $0de0ee4c7481d644$export$f5452ae8fa9e3836);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $0de0ee4c7481d644$export$85213c72021b1243 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().timeline.sectionMessageDismissed === 'boolean') return;
        try {
            const timelineSectionMessageDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                timeline: {
                    sectionMessageDismissed: timelineSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    timeline: {
                        sectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to get user property with key: ${(0, $8lgoE.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $0de0ee4c7481d644$export$f5452ae8fa9e3836 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            timeline: {
                sectionMessageDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to set user property with key: ${(0, $8lgoE.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("88hWw", function(module, exports) {
$parcel$export(module.exports, "loadAllViewsSpotlightDismissed", () => $959017c40970db3b$export$73f482a9822cc952);
$parcel$export(module.exports, "setAllViewsSpotlightDismissed", () => $959017c40970db3b$export$84df3d965709961e);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $959017c40970db3b$export$73f482a9822cc952 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().allViews.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                allViews: {
                    ...state.allViews,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    allViews: {
                        ...state.allViews,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $8lgoE.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $959017c40970db3b$export$84df3d965709961e = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            allViews: {
                ...state.allViews,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to set user property with key: ${(0, $8lgoE.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("2atAT", function(module, exports) {
$parcel$export(module.exports, "loadPrioritizationViewTourDismissed", () => $31e722a54000eaf1$export$f610fdf8823d3e34);
$parcel$export(module.exports, "setPrioritizationViewTourDismissed", () => $31e722a54000eaf1$export$a72bdc987d4b2c7d);
$parcel$export(module.exports, "setPrioritizationViewTourSpotlightStep", () => $31e722a54000eaf1$export$a76ccd1e602a886c);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $31e722a54000eaf1$export$f610fdf8823d3e34 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().prioritizationView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PRIORITIZATION_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                prioritizationView: {
                    ...state.prioritizationView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    prioritizationView: {
                        ...state.prioritizationView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to get user property with key: ${(0, $8lgoE.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $31e722a54000eaf1$export$a72bdc987d4b2c7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PRIORITIZATION_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to set user property with key: ${(0, $8lgoE.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $31e722a54000eaf1$export$a76ccd1e602a886c = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("luGqn", function(module, exports) {
$parcel$export(module.exports, "loadRoadmapViewSpotlightDismissed", () => $c53ea0c719db929a$export$7efa8325e0de15f);
$parcel$export(module.exports, "setRoadmapViewSpotlightDismissed", () => $c53ea0c719db929a$export$b55083c189662aa5);
$parcel$export(module.exports, "loadRoadmapColumnConfigSpotlightDismissed", () => $c53ea0c719db929a$export$9e6f136ba325b100);
$parcel$export(module.exports, "setRoadmapColumnConfigSpotlightDismissed", () => $c53ea0c719db929a$export$866ee7083694a75f);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $c53ea0c719db929a$export$7efa8325e0de15f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().roadmapView.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.ROADMAP_VIEW_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to get user property with key: ${(0, $8lgoE.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c53ea0c719db929a$export$b55083c189662aa5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.ROADMAP_VIEW_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to set user property with key: ${(0, $8lgoE.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c53ea0c719db929a$export$9e6f136ba325b100 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().roadmapView.columnConfigSpotlightDismissed === 'boolean') return;
        try {
            const columnConfigSpotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    columnConfigSpotlightDismissed: columnConfigSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        columnConfigSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $8lgoE.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c53ea0c719db929a$export$866ee7083694a75f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                columnConfigSpotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-column-config-spotlight', `Failed to set user property with key: ${(0, $8lgoE.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("efRp8", function(module, exports) {
$parcel$export(module.exports, "loadBlueprintsState", () => $ad220cbfca68d842$export$104ee4f3e9ddc3c4);
$parcel$export(module.exports, "setBlueprintsTourStep", () => $ad220cbfca68d842$export$1b9ba94b448264d2);
$parcel$export(module.exports, "setBlueprintsTourDismissed", () => $ad220cbfca68d842$export$13d121276e063a92);

var $k4x9q = parcelRequire("k4x9q");

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $9pTd3 = parcelRequire("9pTd3");

var $7e8wG = parcelRequire("7e8wG");

var $4y7gv = parcelRequire("4y7gv");

var $8lgoE = parcelRequire("8lgoE");

var $keeNI = parcelRequire("keeNI");
const $ad220cbfca68d842$export$104ee4f3e9ddc3c4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().blueprints.tourDismissed === 'boolean') return;
        try {
            const remoteState = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.BLUEPRINTS_TOUR_SPOTLIGHTS));
            const state = getState();
            setState({
                ...state,
                blueprints: {
                    ...state.blueprints,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(remoteState, {
                        tourSpotlightStep: null,
                        tourDismissed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    blueprints: {
                        ...state.blueprints,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.blueprints-spotlight', `Failed to get user property with key: ${(0, $8lgoE.BLUEPRINTS_TOUR_SPOTLIGHTS)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $ad220cbfca68d842$export$1b9ba94b448264d2 = (step)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newBlueprintsState = {
            ...state.blueprints,
            tourSpotlightStep: step
        };
        setState({
            ...state,
            blueprints: newBlueprintsState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.BLUEPRINTS_TOUR_SPOTLIGHTS), JSON.stringify(newBlueprintsState));
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.blueprints-spotlight', (0, $keeNI.normalizeError)(error)));
        }
    };
const $ad220cbfca68d842$export$13d121276e063a92 = (tourDismissed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newBlueprintsState = {
            ...state.blueprints,
            tourDismissed: tourDismissed
        };
        setState({
            ...state,
            blueprints: newBlueprintsState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.BLUEPRINTS_TOUR_SPOTLIGHTS), JSON.stringify(newBlueprintsState));
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.blueprints-spotlight', (0, $keeNI.normalizeError)(error)));
        }
    };

});
parcelRegister("k4x9q", function(module, exports) {

var $euhRr = parcelRequire("euhRr");

var $l76qh = parcelRequire("l76qh");

var $1sE4t = parcelRequire("1sE4t");

var $16aVR = parcelRequire("16aVR");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $e9cde5728a228935$var$defaultsDeep = $l76qh(function(args) {
    args.push(undefined, $1sE4t);
    return $euhRr($16aVR, undefined, args);
});
module.exports = $e9cde5728a228935$var$defaultsDeep;

});
parcelRegister("1sE4t", function(module, exports) {

var $9AWD2 = parcelRequire("9AWD2");

var $546O5 = parcelRequire("546O5");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $11077d499fdbf4a3$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($546O5(objValue) && $546O5(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $9AWD2(objValue, srcValue, undefined, $11077d499fdbf4a3$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $11077d499fdbf4a3$var$customDefaultsMerge;

});

parcelRegister("16aVR", function(module, exports) {

var $9AWD2 = parcelRequire("9AWD2");

var $kBNXn = parcelRequire("kBNXn");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $0cced4e66601137e$var$mergeWith = $kBNXn(function(object, source, srcIndex, customizer) {
    $9AWD2(object, source, srcIndex, customizer);
});
module.exports = $0cced4e66601137e$var$mergeWith;

});


parcelRegister("7e8wG", function(module, exports) {
$parcel$export(module.exports, "createErrorAnalytics", () => $85bd9b8631bfa06e$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $85bd9b8631bfa06e$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $85bd9b8631bfa06e$export$4e01d30cacaf82b8);

var $eJOHy = parcelRequire("eJOHy");

var $80DPg = parcelRequire("80DPg");

var $jdqdp = parcelRequire("jdqdp");

var $cxKOj = parcelRequire("cxKOj");

var $9pTd3 = parcelRequire("9pTd3");

var $lRq8t = parcelRequire("lRq8t");

var $6x8n3 = parcelRequire("6x8n3");

var $fljS9 = parcelRequire("fljS9");

var $95Ew5 = parcelRequire("95Ew5");

var $fVlmn = parcelRequire("fVlmn");
const $85bd9b8631bfa06e$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $85bd9b8631bfa06e$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $fVlmn.getMetadata)(errorObject));
};
const $85bd9b8631bfa06e$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).serverLoadFailedDescription)
        });
        (0, $9pTd3.fireErrorAnalytics)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        (0, $9pTd3.fireErrorAnalytics)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $fljS9.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $fljS9.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage((0, $95Ew5.default).entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $fVlmn.isPermissionError)(errorObject)) return error({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).permissionErrorDescription)
        });
        if ((0, $fVlmn.isConfigError)(errorObject)) return error({
            title: formatMessage((0, $95Ew5.default).configErrorTitle),
            description: formatMessage((0, $95Ew5.default).configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).errorDescription)
        });
        (0, $9pTd3.fireErrorAnalytics)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $95Ew5.default).errorPossibleAccessLossGalaxia : (0, $95Ew5.default).errorPossibleAccessLoss)
        });
        (0, $9pTd3.fireErrorAnalytics)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $85bd9b8631bfa06e$var$usePossibleAccessLossError();
    const generalActionFailedError = $85bd9b8631bfa06e$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $85bd9b8631bfa06e$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $85bd9b8631bfa06e$var$useGeneralDataLoadingFailedHandling();
    return (0, $eJOHy.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $85bd9b8631bfa06e$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { error: error } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $9pTd3.fireErrorAnalytics)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("6x8n3", function(module, exports) {
$parcel$export(module.exports, "useNotifications", () => $3e2a0a021f792948$export$53d5ca6c3f53e109);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $3wl9L = parcelRequire("3wl9L");

var $80DPg = parcelRequire("80DPg");

var $6baZD = parcelRequire("6baZD");
var $ymEZt = parcelRequire("ymEZt");
var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");
const $3e2a0a021f792948$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $aXKmr.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $3e2a0a021f792948$var$customFlag = (notification, onDismiss)=>$3e2a0a021f792948$var$customFlagCommon(notification, onDismiss, (0, $ymEZt.default));
const $3e2a0a021f792948$var$customAutoDismissFlag = (notification, onDismiss)=>$3e2a0a021f792948$var$customFlagCommon(notification, onDismiss, (0, $6baZD.default));
const $3e2a0a021f792948$var$success = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$var$errorWithRefresh = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$var$error = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    return (0, $eJOHy.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$customFlag(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$success(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$errorWithRefresh(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$error(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $jn1Cb.toFlagId)((0, $aXKmr.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $jn1Cb.toFlagId)((0, $aXKmr.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("6baZD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9a60bbb18d8a09b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $2pgjF = parcelRequire("2pgjF");
const $d9a60bbb18d8a09b$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $d9a60bbb18d8a09b$export$2e2bcd8739ae039 = $d9a60bbb18d8a09b$var$AkAutoDismissFlag;

});

parcelRegister("ymEZt", function(module, exports) {
$parcel$export(module.exports, "default", () => $5acf2223bd5cfd1e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $2pgjF = parcelRequire("2pgjF");
const $5acf2223bd5cfd1e$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $5acf2223bd5cfd1e$export$2e2bcd8739ae039 = $5acf2223bd5cfd1e$var$AkFlag;

});


parcelRegister("fljS9", function(module, exports) {
$parcel$export(module.exports, "EntityLimitError", () => $0eae3c589bda6c5f$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $0eae3c589bda6c5f$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $0eae3c589bda6c5f$export$cf58cbb2768ea4f);

var $eezJL = parcelRequire("eezJL");

var $fJuTR = parcelRequire("fJuTR");

var $cxKOj = parcelRequire("cxKOj");

var $ivX8j = parcelRequire("ivX8j");

var $aqxDR = parcelRequire("aqxDR");
class $0eae3c589bda6c5f$export$c4e01b2c2ba95919 extends (0, $fJuTR.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
const $0eae3c589bda6c5f$export$13f6f9a6b905ebbd = (error)=>{
    // If already an EntityLimitError, return it
    if (error instanceof $0eae3c589bda6c5f$export$c4e01b2c2ba95919) return error;
    // If not an ApolloError, return null as we can't handle it
    if (!(error instanceof (0, $eezJL.ApolloError))) return null;
    // Get first entity limit error
    const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
    // If no entity limit error or no extensions, return null
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entityLimitErrorType = (0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $0eae3c589bda6c5f$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $0eae3c589bda6c5f$export$cf58cbb2768ea4f = (error)=>{
    if (error.type === (0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT && (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false)) return (0, $ivX8j.default)[`${error.type}Galaxia`];
    return (0, $ivX8j.default)[error.type] || null;
};

});
parcelRegister("ivX8j", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fb7ce4790658e33$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");

var $aqxDR = parcelRequire("aqxDR");
const $6fb7ce4790658e33$var$messages = (0, $7qGN1.defineMessages)({
    /* eslint-disable jira/i18n/id-named-by-package */ [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
        "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
        "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
        "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    },
    [`${(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT}Galaxia`]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project-galaxia",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>space</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    }
});
var $6fb7ce4790658e33$export$2e2bcd8739ae039 = $6fb7ce4790658e33$var$messages;

});
parcelRegister("aqxDR", function(module, exports) {
$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $ef36341caf3b8cc4$export$a197d88688faa32c);
const $ef36341caf3b8cc4$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};

});



parcelRegister("95Ew5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7342b98ba959b1d3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7342b98ba959b1d3$var$messages = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "polaris-lib-errors.controllers.error-title",
        "defaultMessage": "Something went wrong."
    },
    permissionErrorDescription: {
        "id": "polaris-lib-errors.controllers.permission-error-description",
        "defaultMessage": "You may not have the permissions required to perform this operation."
    },
    configErrorTitle: {
        "id": "polaris-lib-errors.controllers.config-error-title",
        "defaultMessage": "We couldn't save that."
    },
    configErrorDescription: {
        "id": "polaris-lib-errors.controllers.config-error-description",
        "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
    },
    serverLoadFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-load-failed-description",
        "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
    },
    serverUpdateFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-update-failed-description",
        "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
    },
    errorDescription: {
        "id": "polaris-lib-errors.controllers.error-description",
        "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
    },
    workflowLoadingFailedDescription: {
        "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
        "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
    },
    errorPossibleAccessLoss: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss",
        "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
    },
    cyclicFormulaFieldDescription: {
        "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
        "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
    },
    entityLimitErrorTitle: {
        "id": "polaris-lib-errors.controllers.entity-limit-error-title",
        "defaultMessage": "You\u2019ve hit a limit"
    },
    errorPossibleAccessLossGalaxia: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss-galaxia",
        "defaultMessage": "You may have lost access to the space or site. Please refresh the page."
    }
});
var $7342b98ba959b1d3$export$2e2bcd8739ae039 = $7342b98ba959b1d3$var$messages;

});

parcelRegister("fVlmn", function(module, exports) {
$parcel$export(module.exports, "isPermissionError", () => $bff2287ffa2d3eb9$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $bff2287ffa2d3eb9$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $bff2287ffa2d3eb9$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $bff2287ffa2d3eb9$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isClientClosedError", () => $bff2287ffa2d3eb9$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $bff2287ffa2d3eb9$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConflictError", () => $bff2287ffa2d3eb9$export$b43c7b888ac6458);
$parcel$export(module.exports, "isConfigError", () => $bff2287ffa2d3eb9$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $bff2287ffa2d3eb9$export$8548546c0aa631e6);

var $exWdq = parcelRequire("exWdq");

var $4sprp = parcelRequire("4sprp");

var $jUVzX = parcelRequire("jUVzX");
const $bff2287ffa2d3eb9$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || // that's probably obsolete
        safeMessage.includes('status code 403') // that's probably obsolete
        ;
    });
    return false;
};
const $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $bff2287ffa2d3eb9$export$a8908c3867f6f20b = (errorObject)=>{
    return $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(error)) || false;
};
const $bff2287ffa2d3eb9$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $bff2287ffa2d3eb9$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $bff2287ffa2d3eb9$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $bff2287ffa2d3eb9$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $bff2287ffa2d3eb9$export$b43c7b888ac6458 = (errorObject)=>errorObject.statusCode === 409;
const $bff2287ffa2d3eb9$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $bff2287ffa2d3eb9$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});
parcelRegister("jUVzX", function(module, exports) {

var $202ak = parcelRequire("202ak");

var $1lM9j = parcelRequire("1lM9j");

var $2DwDI = parcelRequire("2DwDI");

var $4sprp = parcelRequire("4sprp");

var $eA1it = parcelRequire("eA1it");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $e7ffe9447e10a1ca$var$some(collection, predicate, guard) {
    var func = $4sprp(collection) ? $202ak : $2DwDI;
    if (guard && $eA1it(collection, predicate, guard)) predicate = undefined;
    return func(collection, $1lM9j(predicate, 3));
}
module.exports = $e7ffe9447e10a1ca$var$some;

});
parcelRegister("2DwDI", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $1eb88ace25f55b0d$var$baseSome(collection, predicate) {
    var result;
    $c3u3c(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $1eb88ace25f55b0d$var$baseSome;

});





parcelRegister("80clw", function(module, exports) {
$parcel$export(module.exports, "loadPremiumModalDismissed", () => $72d34c3285be8d90$export$f4ca311cb4b4350f);
$parcel$export(module.exports, "setPremiumModalDismissed", () => $72d34c3285be8d90$export$99d8813bb6724f28);
$parcel$export(module.exports, "loadPremiumLastVisit", () => $72d34c3285be8d90$export$6825e78fd5bc05f5);
$parcel$export(module.exports, "setPremiumLastVisit", () => $72d34c3285be8d90$export$c2d4fef533f3196c);
$parcel$export(module.exports, "unlockOnboardingFlow", () => $72d34c3285be8d90$export$f92cc7ff16154919);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");
const $72d34c3285be8d90$export$f4ca311cb4b4350f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.modalDismissed === 'boolean') return;
        try {
            const modalDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PREMIUM_MODAL_DISMISSED));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    modalDismissed: modalDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        modalDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to get user property with key: ${(0, $8lgoE.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $72d34c3285be8d90$export$99d8813bb6724f28 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        // we need to pass isPremium to the lastVisit object to ensure that the modal is dismissed
        // when the user is on the premium edition and the last visit was on the free edition
        setState({
            premium: {
                ...state.premium,
                modalDismissed: true,
                lastVisit: {
                    ...state.premium.lastVisit,
                    isPremium: true
                }
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PREMIUM_MODAL_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to set user property with key: ${(0, $8lgoE.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $72d34c3285be8d90$export$6825e78fd5bc05f5 = (isPremiumEdition)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.lastVisit.isPremium === 'boolean') return;
        try {
            const lastVisitOnPremium = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PREMIUM_LAST_VISIT));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        isPremium: lastVisitOnPremium
                    }
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        lastVisit: {
                            ...state.premium.lastVisit,
                            isPremium: isPremiumEdition
                        }
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to get user property with key: ${(0, $8lgoE.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $72d34c3285be8d90$export$c2d4fef533f3196c = (isPremium)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if (getState().premium.lastVisit.updated) // If lastVisit has been updated already
        // then don't do it again
        return;
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PREMIUM_LAST_VISIT), String(isPremium));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        updated: true
                    }
                }
            });
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to set user property with key: ${(0, $8lgoE.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
    };
const $72d34c3285be8d90$export$f92cc7ff16154919 = ()=>async ({ getState: getState })=>{
        getState().premium.promise.resolve();
    };

});

parcelRegister("2QyGs", function(module, exports) {
$parcel$export(module.exports, "loadProductUsageStartTimestamp", () => $771f783e12ff8fa1$export$7cb2c6cd0d7c32c0);

var $FppkK = parcelRequire("FppkK");

var $6Yd06 = parcelRequire("6Yd06");

var $dMM78 = parcelRequire("dMM78");

var $14RSn = parcelRequire("14RSn");

var $8lgoE = parcelRequire("8lgoE");
const $771f783e12ff8fa1$export$7cb2c6cd0d7c32c0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // usage timestamp already loaded
        if (getState().productUsageStartTimestamp) return;
        try {
            const { isoDateString: productUsageStartTimestamp } = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PRODUCT_START_TIMESTAMP));
            const state = getState();
            setState({
                ...state,
                productUsageStartTimestamp: productUsageStartTimestamp
            });
        } catch (error) {
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404 || (0, $dMM78.isClientFetchError)(error)) return;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $8lgoE.PRODUCT_START_TIMESTAMP)}`, error instanceof Error ? error : undefined);
        }
        return getState().productUsageStartTimestamp;
    };

});

parcelRegister("f17in", function(module, exports) {
$parcel$export(module.exports, "loadTheseAreYourViewsSpotlightDismissed", () => $62ebb9812541e8ce$export$9bb395719b77053b);
$parcel$export(module.exports, "setTheseAreYourViewsSpotlightDismissed", () => $62ebb9812541e8ce$export$874f0051eb7f18f7);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $hThlN = parcelRequire("hThlN");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $62ebb9812541e8ce$export$9bb395719b77053b = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().quickstart.theseAreYourViewsSpotlightDismissed === 'boolean') return;
        try {
            const theseAreYourViewsSpotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.QUICKSTART_THESE_ARE_YOUR_VIEWS_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                quickstart: {
                    ...state.quickstart,
                    theseAreYourViewsSpotlightDismissed: theseAreYourViewsSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                setState({
                    quickstart: {
                        theseAreYourViewsSpotlightDismissed: false
                    }
                });
                return;
            }
            const errorMessage = `Failed to get user property with key: ${(0, $8lgoE.QUICKSTART_THESE_ARE_YOUR_VIEWS_SPOTLIGHT_DISMISSED)}`;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.quickstart.these-are-your-views.spotlight', errorMessage, error instanceof Error ? error : new (0, $hThlN.UnknownError)(errorMessage, error));
        }
    };
const $62ebb9812541e8ce$export$874f0051eb7f18f7 = ()=>async ({ setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        setState({
            quickstart: {
                theseAreYourViewsSpotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.QUICKSTART_THESE_ARE_YOUR_VIEWS_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            const errorMessage = `Failed to set user property with key: ${(0, $8lgoE.QUICKSTART_THESE_ARE_YOUR_VIEWS_SPOTLIGHT_DISMISSED)}`;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.quickstart.these-are-your-views.spotlight', errorMessage, error instanceof Error ? error : new (0, $hThlN.UnknownError)(errorMessage, error));
        }
    };

});
parcelRegister("hThlN", function(module, exports) {
$parcel$export(module.exports, "UnknownError", () => $df1b5008c9f3614d$export$ff4405149dbd0c5c);

var $fJuTR = parcelRequire("fJuTR");
class $df1b5008c9f3614d$export$ff4405149dbd0c5c extends (0, $fJuTR.default) {
    constructor(message, details){
        super(message), this.name = 'UnknownError';
        this.details = details;
    }
}

});


parcelRegister("8iz9g", function(module, exports) {
$parcel$export(module.exports, "loadCustomDatesCustomizeSpotlightDismissed", () => $a57880881c55e1bd$export$4a8766eb957669c8);
$parcel$export(module.exports, "setCustomDatesCustomizeSpotlightDismissed", () => $a57880881c55e1bd$export$82bd3ea030c97bbd);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $hThlN = parcelRequire("hThlN");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $a57880881c55e1bd$export$4a8766eb957669c8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().customDates.customizeSpotlightDismissed === 'boolean') return;
        try {
            const customizeSpotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                customDates: {
                    ...state.customDates,
                    customizeSpotlightDismissed: customizeSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    customDates: {
                        customizeSpotlightDismissed: false
                    }
                });
                return;
            }
            const errorMessage = `Failed to get user property with key: ${(0, $8lgoE.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED)}`;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.custom-dates.customize.spotlight', errorMessage, error instanceof Error ? error : new (0, $hThlN.UnknownError)(errorMessage, error));
        }
    };
const $a57880881c55e1bd$export$82bd3ea030c97bbd = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            customDates: {
                customizeSpotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            const errorMessage = `Failed to set user property with key: ${(0, $8lgoE.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED)}`;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.custom-dates.customize.spotlight', errorMessage, error instanceof Error ? error : new (0, $hThlN.UnknownError)(errorMessage, error));
        }
    };

});

parcelRegister("2Ir1d", function(module, exports) {
$parcel$export(module.exports, "loadImportState", () => $2fae3ed0475f4cde$export$32a519c7542a933);
$parcel$export(module.exports, "setImportSpotlightDismissed", () => $2fae3ed0475f4cde$export$2e25f2bad16928e3);
$parcel$export(module.exports, "setSuccessNotificationViewed", () => $2fae3ed0475f4cde$export$c4970fff383b7bfb);

var $k4x9q = parcelRequire("k4x9q");

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $9pTd3 = parcelRequire("9pTd3");

var $7e8wG = parcelRequire("7e8wG");

var $4y7gv = parcelRequire("4y7gv");

var $8lgoE = parcelRequire("8lgoE");

var $keeNI = parcelRequire("keeNI");
const $2fae3ed0475f4cde$export$32a519c7542a933 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (getState().import.spotlightDismissed !== undefined) return;
        try {
            const remoteState = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.IMPORT_BULK_CREATE_ONBOARDING));
            const state = getState();
            setState({
                ...state,
                import: {
                    ...state.import,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(remoteState, {
                        spotlightDismissed: false,
                        successNotificationViewed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    import: {
                        ...state.import,
                        spotlightDismissed: false,
                        successNotificationViewed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.import-spotlight', `Failed to get user property with key: ${(0, $8lgoE.IMPORT_BULK_CREATE_ONBOARDING)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $2fae3ed0475f4cde$export$2e25f2bad16928e3 = (spotlightDismissed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newImportState = {
            ...state.import,
            spotlightDismissed: spotlightDismissed
        };
        setState({
            ...state,
            import: newImportState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.IMPORT_BULK_CREATE_ONBOARDING), JSON.stringify(newImportState));
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.imports-spotlight', (0, $keeNI.normalizeError)(error)));
        }
    };
const $2fae3ed0475f4cde$export$c4970fff383b7bfb = (successNotificationViewed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newImportState = {
            ...state.import,
            successNotificationViewed: successNotificationViewed
        };
        setState({
            ...state,
            import: newImportState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.IMPORT_BULK_CREATE_ONBOARDING), JSON.stringify(newImportState));
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.imports-notification', (0, $keeNI.normalizeError)(error)));
        }
    };

});

parcelRegister("ZWO1M", function(module, exports) {
$parcel$export(module.exports, "loadFilterIntervalSpotlightDismissed", () => $f337113a47c9d1bd$export$ecca477de6afa3d1);
$parcel$export(module.exports, "setFilterIntervalSpotlightDismissed", () => $f337113a47c9d1bd$export$a8128eb6d37a2c46);

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $hThlN = parcelRequire("hThlN");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $f337113a47c9d1bd$export$ecca477de6afa3d1 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().filterInterval.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.FILTER_INTERVAL_SPOTLIGHT_DISMISSED));
            setState({
                filterInterval: {
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                setState({
                    filterInterval: {
                        spotlightDismissed: false
                    }
                });
                return;
            }
            const errorMessage = `Failed to get user property with key: ${(0, $8lgoE.FILTER_INTERVAL_SPOTLIGHT_DISMISSED)}`;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.filter-interval-spotlight', errorMessage, error instanceof Error ? error : new (0, $hThlN.UnknownError)(errorMessage, error));
        }
    };
const $f337113a47c9d1bd$export$a8128eb6d37a2c46 = ()=>async ({ setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        setState({
            filterInterval: {
                spotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.FILTER_INTERVAL_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            const errorMessage = `Failed to set user property with key: ${(0, $8lgoE.FILTER_INTERVAL_SPOTLIGHT_DISMISSED)}`;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.filter-interval-spotlight', errorMessage, error instanceof Error ? error : new (0, $hThlN.UnknownError)(errorMessage, error));
        }
    };

});

parcelRegister("2ZyJ1", function(module, exports) {
$parcel$export(module.exports, "loadUnifiedShareDialogSpotlightState", () => $daa589f6ff004ace$export$6bcae6c74c588cf);
$parcel$export(module.exports, "setUnifiedShareDialogSpotlightDismissed", () => $daa589f6ff004ace$export$3f7f2ce2f5c73fe1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $6Yd06 = parcelRequire("6Yd06");

var $4y7gv = parcelRequire("4y7gv");

var $8lgoE = parcelRequire("8lgoE");
const $daa589f6ff004ace$export$6bcae6c74c588cf = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().unifiedShareDialog.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.UNIFIED_SHARE_DIALOG_SPOTLIGHT));
            const state = getState();
            setState({
                ...state,
                unifiedShareDialog: {
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    unifiedShareDialog: {
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.unified-share-dialog-spotlight', `Failed to get user property with key: ${(0, $8lgoE.UNIFIED_SHARE_DIALOG_SPOTLIGHT)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $daa589f6ff004ace$export$3f7f2ce2f5c73fe1 = (spotlightDismissed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newUnifiedShareDialogState = {
            spotlightDismissed: spotlightDismissed
        };
        setState({
            ...state,
            unifiedShareDialog: newUnifiedShareDialogState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.UNIFIED_SHARE_DIALOG_SPOTLIGHT), JSON.stringify(spotlightDismissed));
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.unified-share-dialog-spotlight', `Failed to set user property with key: ${(0, $8lgoE.UNIFIED_SHARE_DIALOG_SPOTLIGHT)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});



parcelRegister("4V76I", function(module, exports) {
$parcel$export(module.exports, "useCollectionsTourDismissed", () => $08618d4951c750a7$export$17de768881ff6446);
$parcel$export(module.exports, "useTourSpotlightStep", () => $08618d4951c750a7$export$152b14ddbe17966d);
$parcel$export(module.exports, "useCollectionsIntroductionDismissed", () => $08618d4951c750a7$export$2c88e8fbdc79e33c);
$parcel$export(module.exports, "useCollectionsIntroductionPrerequisiteDismissalsMet", () => $08618d4951c750a7$export$45df47b92137b673);

var $4l17z = parcelRequire("4l17z");

var $chGrv = parcelRequire("chGrv");
const $08618d4951c750a7$export$17de768881ff6446 = (0, $4l17z.createHook)((0, $chGrv.getCollectionsTourDismissed));
const $08618d4951c750a7$export$152b14ddbe17966d = (0, $4l17z.createHook)((0, $chGrv.getTourSpotlightStep));
const $08618d4951c750a7$export$2c88e8fbdc79e33c = (0, $4l17z.createHook)((0, $chGrv.getCollectionsIntroductionDismissed));
const $08618d4951c750a7$export$45df47b92137b673 = (0, $4l17z.createHook)((0, $chGrv.getCollectionsIntroductionPrerequisiteDismissalsMet));

});
parcelRegister("chGrv", function(module, exports) {
$parcel$export(module.exports, "getCollectionsTourDismissed", () => $8ff670eac2e8d400$export$2f4e8052c0c8cc36);
$parcel$export(module.exports, "getTourSpotlightStep", () => $8ff670eac2e8d400$export$c0777ba57d86bcd1);
$parcel$export(module.exports, "getCollectionsIntroductionDismissed", () => $8ff670eac2e8d400$export$df23a375f28a4c0f);
$parcel$export(module.exports, "getCollectionsIntroductionPrerequisiteDismissalsMet", () => $8ff670eac2e8d400$export$e6b937f1096fabf9);

var $ahm5r = parcelRequire("ahm5r");
const $8ff670eac2e8d400$export$9bc19dcd1978ec48 = (state)=>state.collections;
const $8ff670eac2e8d400$export$2f4e8052c0c8cc36 = (0, $ahm5r.createSelector)($8ff670eac2e8d400$export$9bc19dcd1978ec48, (collections)=>collections.tourDismissed);
const $8ff670eac2e8d400$export$c0777ba57d86bcd1 = (0, $ahm5r.createSelector)($8ff670eac2e8d400$export$9bc19dcd1978ec48, (collections)=>collections.tourSpotlightStep);
const $8ff670eac2e8d400$export$df23a375f28a4c0f = (0, $ahm5r.createSelector)($8ff670eac2e8d400$export$9bc19dcd1978ec48, (collections)=>collections.introductionDismissed);
const $8ff670eac2e8d400$export$e6b937f1096fabf9 = (0, $ahm5r.createSelector)($8ff670eac2e8d400$export$9bc19dcd1978ec48, (collections)=>collections.introductionPrerequisiteDismissalsMet);

});


parcelRegister("a6k1J", function(module, exports) {
$parcel$export(module.exports, "useProductUsageStartTimestamp", () => $b5a88aacba1d43e8$export$935abb673611c138);

var $4l17z = parcelRequire("4l17z");

var $5KTPX = parcelRequire("5KTPX");
const $b5a88aacba1d43e8$export$935abb673611c138 = (0, $4l17z.createHook)((0, $5KTPX.getProductUsageStartTimestamp));

});
parcelRegister("5KTPX", function(module, exports) {
$parcel$export(module.exports, "getProductUsageStartTimestamp", () => $7f2e26bc2498b485$export$e96fba6f475323c2);
const $7f2e26bc2498b485$export$e96fba6f475323c2 = (state)=>state.productUsageStartTimestamp;

});


parcelRegister("cLtfY", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2cc9f4c86de84e90$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2cc9f4c86de84e90$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    dismiss: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.dismiss",
        "defaultMessage": "Dismiss"
    },
    giveItATry: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.give-it-a-try",
        "defaultMessage": "Give it a try!"
    },
    message: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.message",
        "defaultMessage": "Create a roadmap tailored to the information your stakeholders care about the most by selecting which projects and ideas to include."
    },
    messageGalaxia: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.message-galaxia",
        "defaultMessage": "Create a roadmap tailored to the information your stakeholders care about the most by selecting which spaces and ideas to include."
    }
});

});

parcelRegister("fU6b0", function(module, exports) {
$parcel$export(module.exports, "useIsLicensedUser", () => $0a15724f2ec22a78$export$8130629f6db139c2);
$parcel$export(module.exports, "checkIfOlderThanNDays", () => $0a15724f2ec22a78$export$cbcf9869d63af9cf);
$parcel$export(module.exports, "useShouldShowRoadmapsIntroductionSpotlight", () => $0a15724f2ec22a78$export$d3d8da452c4b6372);

var $6PAED = parcelRequire("6PAED");

var $4V76I = parcelRequire("4V76I");

var $a6k1J = parcelRequire("a6k1J");
const $0a15724f2ec22a78$export$8130629f6db139c2 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $6PAED.useApplicationPermissions)() ?? {};
    return Boolean(hasProductDiscoveryAccess);
};
const $0a15724f2ec22a78$export$cbcf9869d63af9cf = (productStartTimestamp, days = 7)=>{
    if (!productStartTimestamp) return false;
    const daysInMs = days * 86400000;
    const currentDate = new Date();
    const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
    return productAge > daysInMs;
};
const $0a15724f2ec22a78$export$d3d8da452c4b6372 = ()=>{
    const isLicensedUser = $0a15724f2ec22a78$export$8130629f6db139c2();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');
    const isIntroductionDismissed = (0, $4V76I.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $4V76I.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $a6k1J.useProductUsageStartTimestamp)();
    // Determine if should show the spotlight
    return !(isAlreadyInRoadmaps || !isLicensedUser || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !$0a15724f2ec22a78$export$cbcf9869d63af9cf(productUsageStartTimestamp));
};

});


parcelRegister("bQoR3", function(module, exports) {
$parcel$export(module.exports, "getCollectionDetailsPageUrl", () => $ffa01029ecad820d$export$6d4e7a90e74e9b12);
$parcel$export(module.exports, "getCollectionViewPageUrl", () => $ffa01029ecad820d$export$32ac8841347e1f79);
$parcel$export(module.exports, "getCollectionsPageUrl", () => $ffa01029ecad820d$export$d15219b9c6a3e2f7);
$parcel$export(module.exports, "useCollectionIdeasCount", () => $ffa01029ecad820d$export$28cc502c982e0868);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $dFdvS = parcelRequire("dFdvS");

var $gtzis = parcelRequire("gtzis");
const $ffa01029ecad820d$var$withQueryParams = (path, queryParams)=>{
    if (queryParams) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParams).forEach((key)=>{
            if (queryParams[key]) searchParams.set(key, queryParams[key]);
        });
        if (searchParams.size > 0) return `${path}?${searchParams.toString()}`;
    }
    return path;
};
const $ffa01029ecad820d$export$6d4e7a90e74e9b12 = (collectionUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view`;
const $ffa01029ecad820d$export$32ac8841347e1f79 = (collectionUUID, viewUUID, queryParams)=>$ffa01029ecad820d$var$withQueryParams(`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`, queryParams);
const $ffa01029ecad820d$export$d15219b9c6a3e2f7 = (queryParams)=>$ffa01029ecad820d$var$withQueryParams('/jira/polaris/roadmaps', queryParams);
const $ffa01029ecad820d$var$debouncedGetIdeasCountWithJQL = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((jql, setRequest, res, rej)=>{
    const request = (0, $dFdvS.getIdeasCountForCollection)(jql);
    setRequest(request);
    request.then(res, rej).finally(()=>setRequest(undefined));
}, 500);
const $ffa01029ecad820d$export$28cc502c982e0868 = (projectKeys, filtersJql)=>{
    const jql = (0, $gtzis.getJQLForCollection)(projectKeys, filtersJql);
    const [ideasCount, setIdeasCount] = (0, $eJOHy.useState)(undefined);
    const [isLoading, setLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [request, setRequest] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (jql && projectKeys.length) {
            setLoading(true);
            $ffa01029ecad820d$var$debouncedGetIdeasCountWithJQL(jql, setRequest, (newCount)=>{
                setIdeasCount(newCount);
                setLoading(false);
                setError(null);
            }, (err)=>{
                setIdeasCount(undefined);
                setLoading(false);
                setError(err);
            });
        } else setIdeasCount(undefined);
    }, [
        jql,
        projectKeys.length
    ]);
    return [
        ideasCount,
        isLoading,
        error,
        request
    ];
};

});
parcelRegister("dFdvS", function(module, exports) {
$parcel$export(module.exports, "createCollection", () => $b3fa99eb812b8349$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "fetchCollection", () => $b3fa99eb812b8349$export$efeb96fc7f2aeaf9);
$parcel$export(module.exports, "fetchAllCollections", () => $b3fa99eb812b8349$export$fb62ec897a9d1e05);
$parcel$export(module.exports, "deleteCollection", () => $b3fa99eb812b8349$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $b3fa99eb812b8349$export$c0683150b517c317);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $b3fa99eb812b8349$export$4ead91e2f6058f41);
$parcel$export(module.exports, "fetchCollectionDescription", () => $b3fa99eb812b8349$export$8cd86b5346d1e786);
$parcel$export(module.exports, "cloneCollection", () => $b3fa99eb812b8349$export$d753eba18153f51e);
$parcel$export(module.exports, "getIdeasCountForCollection", () => $b3fa99eb812b8349$export$d355ccab36abee74);

var $hgi0g = parcelRequire("hgi0g");

var $3ugTQ = parcelRequire("3ugTQ");

var $jbIuO = parcelRequire("jbIuO");

var $9pTd3 = parcelRequire("9pTd3");

var $7e8wG = parcelRequire("7e8wG");

var $gtzis = parcelRequire("gtzis");

var $5AElp = parcelRequire("5AElp");
const $b3fa99eb812b8349$var$generateProjectKeys = (jql)=>{
    return (0, $gtzis.extractProjectKeysFromJql)(jql);
};
const $b3fa99eb812b8349$export$c74125a8e3af6bb2 = (collectionToCreate)=>(0, $3ugTQ.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections`, {
        body: JSON.stringify(collectionToCreate)
    }).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(response.jql),
            filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(response.jql)
        }));
const $b3fa99eb812b8349$export$efeb96fc7f2aeaf9 = (collectionUUID, shouldIncludeViews = false)=>(0, $hgi0g.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}${shouldIncludeViews ? '?expand=views' : ''}`).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            views: response.views?.map((0, $5AElp.transformView)),
            projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(response.jql),
            filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(response.jql)
        }));
const $b3fa99eb812b8349$export$fb62ec897a9d1e05 = ()=>(0, $hgi0g.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections`).then(({ collections: collections })=>collections.map((collection)=>({
                uuid: collection.uuid,
                name: collection.name,
                emoji: collection.emoji,
                color: collection.color,
                jql: collection.jql,
                ownerId: collection.owner,
                projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(collection.jql),
                filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(collection.jql)
            })));
const $b3fa99eb812b8349$export$3d16e031f6551662 = async (collectionUUID)=>{
    await (0, $3ugTQ.performDeleteRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`);
};
const $b3fa99eb812b8349$export$c0683150b517c317 = async (collectionUUID, collectionToUpdate)=>{
    await (0, $3ugTQ.performPutRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`, {
        body: JSON.stringify(collectionToUpdate)
    });
};
const $b3fa99eb812b8349$export$4ead91e2f6058f41 = (collectionsUUIDs)=>(0, $3ugTQ.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/views-count`, {
        body: JSON.stringify({
            uuids: collectionsUUIDs
        })
    });
const $b3fa99eb812b8349$export$8cd86b5346d1e786 = (collectionUUID)=>(0, $hgi0g.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/description`);
const $b3fa99eb812b8349$export$d753eba18153f51e = (collectionUUID, newCollectionName)=>(0, $3ugTQ.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/clone`, {
        body: JSON.stringify({
            name: newCollectionName
        })
    });
const $b3fa99eb812b8349$export$d355ccab36abee74 = (jql)=>(0, $3ugTQ.performPostRequest)('/rest/polaris/issues/searchCountForJql', {
        body: JSON.stringify({
            jql: jql,
            archived: 'ACTIVE_ONLY'
        })
    }).then((response)=>response.count).catch((error)=>{
        (0, $9pTd3.fireErrorAnalytics)((0, $7e8wG.createErrorAnalytics)('polaris.error.getIdeasCountForCollectionFailed', error));
        throw error;
    });

});
parcelRegister("jbIuO", function(module, exports) {
$parcel$export(module.exports, "getJpdViewsServicePathPrefix", () => $f413c7737786871c$export$1d2754f769c8a3c6);
const $f413c7737786871c$export$1d2754f769c8a3c6 = ()=>{
    return '/gateway/api/jpd';
};

});

parcelRegister("gtzis", function(module, exports) {
$parcel$export(module.exports, "getJQLForCollection", () => $818429028dabd958$export$8d4a8272ec8d3589);
$parcel$export(module.exports, "extractProjectKeysFromJql", () => $818429028dabd958$export$35840c54e03d7673);
$parcel$export(module.exports, "extractFiltersJqlFromJql", () => $818429028dabd958$export$bcd3615366d8d128);
$parcel$export(module.exports, "getFieldsFromJql", () => $818429028dabd958$export$54e99094db1a28af);

var $f26C8 = parcelRequire("f26C8");
var $9qsUT = parcelRequire("9qsUT");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");
const $818429028dabd958$var$quoteProjectKey = (projectKey)=>`"${projectKey}"`;
const $818429028dabd958$var$PROJECT_FIELD_KEY = 'project';
const $818429028dabd958$export$8d4a8272ec8d3589 = (projectsKeys = [], filtersJql = '')=>{
    const jast = new (0, $9qsUT.JastBuilder)().build(filtersJql);
    projectsKeys.length && jast.query?.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field($818429028dabd958$var$PROJECT_FIELD_KEY), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN)), (0, $f26C8.default).listOperand(projectsKeys.map($818429028dabd958$var$quoteProjectKey).map((0, $f26C8.default).byText.valueOperand))), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
    if (jast.query?.orderBy) jast.query.removeOrderBy();
    return (0, $1jiqw.print)(jast);
};
const $818429028dabd958$var$projectInRegex = /project\s+in\s+\((.*?)\)/;
const $818429028dabd958$var$projectKeyRegex = /"(.*?)"/g;
const $818429028dabd958$export$35840c54e03d7673 = (jql)=>{
    // Extract the part of the JQL related to `project in (...)`
    const projectInMatch = $818429028dabd958$var$projectInRegex.exec(jql);
    const projectKeys = [];
    if (projectInMatch) {
        const projectInClause = projectInMatch[1];
        let match;
        // Extract all project keys inside the quotes within the `project in (...)` clause
        // eslint-disable-next-line no-cond-assign
        while((match = $818429028dabd958$var$projectKeyRegex.exec(projectInClause)) !== null)projectKeys.push(match[1]);
    }
    return projectKeys;
};
const $818429028dabd958$export$bcd3615366d8d128 = (jql)=>{
    const jast = new (0, $9qsUT.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return '';
    const clauses = where.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    const projectKeysClause = clauses.find((c)=>c.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) && c.field.value === $818429028dabd958$var$PROJECT_FIELD_KEY);
    if (projectKeysClause) projectKeysClause.remove();
    return (0, $1jiqw.print)(jast);
};
const $818429028dabd958$var$getFieldsFromClauses = ([clause, ...rest])=>{
    if (!clause) return [];
    if (clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) return [
        clause.field.value,
        ...$818429028dabd958$var$getFieldsFromClauses(rest)
    ];
    if (clause.clauseType === (0, $2a3824620e125bfd$export$e356b89f8c8d2fcb)) return $818429028dabd958$var$getFieldsFromClauses([
        clause.clause,
        ...rest
    ]);
    return $818429028dabd958$var$getFieldsFromClauses([
        ...clause.clauses,
        ...rest
    ]);
};
const $818429028dabd958$var$getFieldKeyFromFieldName = (fieldKeys)=>(fieldName)=>fieldKeys[fieldName.replace(/\[.+\]$/, '').toLowerCase()];
const $818429028dabd958$export$54e99094db1a28af = (jql, fieldKeys)=>{
    const jast = new (0, $9qsUT.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return [];
    const clauses = where.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    return $818429028dabd958$var$getFieldsFromClauses(clauses).map($818429028dabd958$var$getFieldKeyFromFieldName(fieldKeys)).filter((field)=>!!field);
};

});
const $2a3824620e125bfd$export$7a58b23488ea076b = 'compound';
const $2a3824620e125bfd$export$ae56b4ef248a2b6a = 'terminal';
const $2a3824620e125bfd$export$e356b89f8c8d2fcb = 'not';

const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';

parcelRegister("f26C8", function(module, exports) {
$parcel$export(module.exports, "internalCreators", () => $54a2df64babed64e$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $54a2df64babed64e$export$2e2bcd8739ae039);

var $8gbOL = parcelRequire("8gbOL");

var $lmH0l = parcelRequire("lmH0l");

var $2caal = parcelRequire("2caal");

var $6LAlr = parcelRequire("6LAlr");

var $NDSAF = parcelRequire("NDSAF");

var $1d8p9 = parcelRequire("1d8p9");

var $72SeG = parcelRequire("72SeG");

var $5qiTO = parcelRequire("5qiTO");

var $q681h = parcelRequire("q681h");

var $5WHbI = parcelRequire("5WHbI");

var $5pxYG = parcelRequire("5pxYG");

var $i8g3z = parcelRequire("i8g3z");

var $hE0gi = parcelRequire("hE0gi");

var $83AJ4 = parcelRequire("83AJ4");

var $d0MpM = parcelRequire("d0MpM");

var $lDhFj = parcelRequire("lDhFj");

var $6Dx67 = parcelRequire("6Dx67");

var $hbAhR = parcelRequire("hbAhR");

var $89aGW = parcelRequire("89aGW");

var $8XEos = parcelRequire("8XEos");

var $52A7I = parcelRequire("52A7I");

var $jArsO = parcelRequire("jArsO");
const $54a2df64babed64e$export$64d991963cfb5532 = {
    query: (0, $8XEos.queryInternal),
    compoundClause: (0, $lmH0l.compoundClauseInternal),
    compoundOperator: (0, $2caal.compoundOperatorInternal),
    terminalClause: (0, $52A7I.terminalClauseInternal),
    notClause: (0, $5WHbI.notClauseInternal),
    notClauseOperator: (0, $5pxYG.notClauseOperatorInternal),
    predicate: (0, $6Dx67.predicateInternal),
    predicateOperator: (0, $hbAhR.predicateOperatorInternal),
    field: (0, $6LAlr.fieldInternal),
    property: (0, $89aGW.propertyInternal),
    operator: (0, $i8g3z.operatorInternal),
    valueOperand: (0, $jArsO.valueOperandInternal),
    keywordOperand: (0, $5qiTO.keywordOperandInternal),
    functionOperand: (0, $NDSAF.functionOperandInternal),
    functionString: (0, $1d8p9.functionStringInternal),
    argument: (0, $8gbOL.argumentInternal),
    listOperand: (0, $q681h.listOperandInternal),
    orderBy: (0, $hE0gi.orderByInternal),
    orderByOperator: (0, $lDhFj.orderByOperatorInternal),
    orderByField: (0, $d0MpM.orderByFieldInternal),
    orderByDirection: (0, $83AJ4.orderByDirectionInternal)
};
var $54a2df64babed64e$export$2e2bcd8739ae039 = {
    jast: $72SeG.jast,
    query: $8XEos.query,
    compoundClause: $lmH0l.compoundClause,
    compoundOperator: $2caal.compoundOperator,
    terminalClause: $52A7I.terminalClause,
    notClause: $5WHbI.notClause,
    notClauseOperator: $5pxYG.notClauseOperator,
    predicate: $6Dx67.predicate,
    predicateOperator: $hbAhR.predicateOperator,
    field: $6LAlr.field,
    property: $89aGW.property,
    operator: $i8g3z.operator,
    valueOperand: $jArsO.valueOperand,
    keywordOperand: $5qiTO.keywordOperand,
    functionOperand: $NDSAF.functionOperand,
    functionString: $1d8p9.functionString,
    argument: $8gbOL.argument,
    listOperand: $q681h.listOperand,
    orderBy: $hE0gi.orderBy,
    orderByOperator: $lDhFj.orderByOperator,
    orderByField: $d0MpM.orderByField,
    orderByDirection: $83AJ4.orderByDirection,
    byText: {
        argument: (0, $8gbOL.argumentByText),
        valueOperand: (0, $jArsO.valueOperandByText)
    }
};

});
parcelRegister("8gbOL", function(module, exports) {
$parcel$export(module.exports, "argument", () => $9899f3160c8155c6$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $9899f3160c8155c6$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $9899f3160c8155c6$export$84c43d23f51170cb);

var $h8zsn = parcelRequire("h8zsn");
var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $9899f3160c8155c6$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $9899f3160c8155c6$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $9899f3160c8155c6$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $9899f3160c8155c6$export$6ea29ee575e3f5ff = (value)=>$9899f3160c8155c6$export$5b341d50fa5bcdd5(value, (0, $ykU4x.sanitiseJqlString)(value));
const $9899f3160c8155c6$export$84c43d23f51170cb = (text)=>$9899f3160c8155c6$export$5b341d50fa5bcdd5((0, $h8zsn.normaliseJqlString)(text), text);
const $9899f3160c8155c6$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $9899f3160c8155c6$var$acceptArgument,
        enterNode: $9899f3160c8155c6$var$enterNode,
        exitNode: $9899f3160c8155c6$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
parcelRegister("h8zsn", function(module, exports) {
$parcel$export(module.exports, "normaliseJqlString", () => $e879e944a9dd4709$export$cecf78a779acc0ff);
const $e879e944a9dd4709$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $e879e944a9dd4709$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $e879e944a9dd4709$export$b86601123607fee5 = (maybeQuotedString)=>$e879e944a9dd4709$export$7a0b99b892e0dda8(maybeQuotedString) || $e879e944a9dd4709$export$d5efd6512db694fd(maybeQuotedString);
const $e879e944a9dd4709$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($e879e944a9dd4709$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("ykU4x", function(module, exports) {
$parcel$export(module.exports, "sanitiseJqlString", () => $c0a3cffda0853f39$export$3eb9033c48208278);

var $6PCNA = parcelRequire("6PCNA");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $c0a3cffda0853f39$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $c0a3cffda0853f39$export$3eb9033c48208278 = (jqlString)=>{
    if ($c0a3cffda0853f39$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("6PCNA", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4f959a1cf3d02dc6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $4f959a1cf3d02dc6$var$reHasRegExpChar = RegExp($4f959a1cf3d02dc6$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $4f959a1cf3d02dc6$var$escapeRegExp(string) {
    string = $cz1WF(string);
    return string && $4f959a1cf3d02dc6$var$reHasRegExpChar.test(string) ? string.replace($4f959a1cf3d02dc6$var$reRegExpChar, '\\$&') : string;
}
module.exports = $4f959a1cf3d02dc6$var$escapeRegExp;

});


parcelRegister("fa1eE", function(module, exports) {
$parcel$export(module.exports, "noChildren", () => $b71c996bd5b4efee$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $b71c996bd5b4efee$export$a4685923af2913a);
const $b71c996bd5b4efee$export$470bef71e654b804 = ()=>[];
const $b71c996bd5b4efee$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("lmH0l", function(module, exports) {
$parcel$export(module.exports, "compoundClause", () => $7990dc2160e1df04$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $7990dc2160e1df04$export$cd65eed8c10b0911);


var $569g0 = parcelRequire("569g0");

var $fa1eE = parcelRequire("fa1eE");
function $7990dc2160e1df04$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $7990dc2160e1df04$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $7990dc2160e1df04$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $7990dc2160e1df04$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $7990dc2160e1df04$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $7990dc2160e1df04$export$cd65eed8c10b0911(operator, clauses);
};
const $7990dc2160e1df04$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $7990dc2160e1df04$var$acceptCompoundClause,
        enterNode: $7990dc2160e1df04$var$enterNode,
        exitNode: $7990dc2160e1df04$var$exitNode,
        getChildren: $7990dc2160e1df04$var$getChildren,
        parent: null,
        appendClause: $569g0.appendClause,
        remove: $569g0.remove,
        removeClause: $569g0.removeClause,
        replace: $569g0.replace,
        replaceClause: $569g0.replaceClause
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
const $07f17d613ee96ad1$export$98dda21ec825792 = 'query';
const $07f17d613ee96ad1$export$2d205682cc545947 = 'clause';
const $07f17d613ee96ad1$export$d2f212d8ddbc8d1d = 'operand';
const $07f17d613ee96ad1$export$da0f73edded4a63d = 'order_by';

parcelRegister("569g0", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $fa1eE = parcelRequire("fa1eE");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $fa1eE.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $fa1eE.assignParent)(this);
}

});


parcelRegister("2caal", function(module, exports) {
$parcel$export(module.exports, "compoundOperator", () => $b3ac9a1079c049ae$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $b3ac9a1079c049ae$export$63c33bc3fe74fee6);

var $fa1eE = parcelRequire("fa1eE");
function $b3ac9a1079c049ae$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $b3ac9a1079c049ae$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $b3ac9a1079c049ae$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $b3ac9a1079c049ae$export$84bb3ebbba491aee = (value)=>$b3ac9a1079c049ae$export$63c33bc3fe74fee6(value, []);
const $b3ac9a1079c049ae$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $b3ac9a1079c049ae$var$acceptCompoundOperator,
        enterNode: $b3ac9a1079c049ae$var$enterNode,
        exitNode: $b3ac9a1079c049ae$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("6LAlr", function(module, exports) {
$parcel$export(module.exports, "field", () => $40455f5cc088ebfe$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $40455f5cc088ebfe$export$2193f8c541622b6);

var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $40455f5cc088ebfe$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $40455f5cc088ebfe$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $40455f5cc088ebfe$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $40455f5cc088ebfe$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $40455f5cc088ebfe$export$e0f35d825088c098 = (value, properties)=>{
    return $40455f5cc088ebfe$export$2193f8c541622b6(value, (0, $ykU4x.sanitiseJqlString)(value), properties);
};
const $40455f5cc088ebfe$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $40455f5cc088ebfe$var$acceptField,
        enterNode: $40455f5cc088ebfe$var$enterNode,
        exitNode: $40455f5cc088ebfe$var$exitNode,
        getChildren: $40455f5cc088ebfe$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("NDSAF", function(module, exports) {
$parcel$export(module.exports, "functionOperand", () => $3d621d62a26d18dc$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $3d621d62a26d18dc$export$c1f2ce91dc05872a);


var $fa1eE = parcelRequire("fa1eE");
function $3d621d62a26d18dc$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $3d621d62a26d18dc$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $3d621d62a26d18dc$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $3d621d62a26d18dc$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $3d621d62a26d18dc$export$4f981b0e83488ce = (functionString, args = [])=>$3d621d62a26d18dc$export$c1f2ce91dc05872a(functionString, args);
const $3d621d62a26d18dc$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $3d621d62a26d18dc$var$acceptFunctionOperand,
        enterNode: $3d621d62a26d18dc$var$enterNode,
        exitNode: $3d621d62a26d18dc$var$exitNode,
        getChildren: $3d621d62a26d18dc$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
const $862dfd240457f00b$export$38accfc5a5d1c113 = 'value';
const $862dfd240457f00b$export$f6049126fd97001f = 'keyword';
const $862dfd240457f00b$export$19c7c729db381f9d = 'function';
const $862dfd240457f00b$export$fabec4aebba3f4df = 'list';
const $862dfd240457f00b$export$1c46dca02aac24dd = 'empty';


parcelRegister("1d8p9", function(module, exports) {
$parcel$export(module.exports, "functionString", () => $0c094943ece8f752$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $0c094943ece8f752$export$7aa9944588b7a69f);

var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $0c094943ece8f752$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $0c094943ece8f752$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $0c094943ece8f752$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $0c094943ece8f752$export$4e1bb9a7ff8d0ef9 = (value)=>$0c094943ece8f752$export$7aa9944588b7a69f(value, (0, $ykU4x.sanitiseJqlString)(value));
const $0c094943ece8f752$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $0c094943ece8f752$var$acceptFunctionString,
        enterNode: $0c094943ece8f752$var$enterNode,
        exitNode: $0c094943ece8f752$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("72SeG", function(module, exports) {
$parcel$export(module.exports, "jast", () => $a25d6c4a0f00f5da$export$b9e70a00f479ff43);
const $a25d6c4a0f00f5da$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("5qiTO", function(module, exports) {
$parcel$export(module.exports, "keywordOperand", () => $152e52666e87d978$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $152e52666e87d978$export$7cc55480b054047b);


var $fa1eE = parcelRequire("fa1eE");
function $152e52666e87d978$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $152e52666e87d978$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $152e52666e87d978$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $152e52666e87d978$export$2edd4971ed69f2ce = ()=>$152e52666e87d978$export$7cc55480b054047b((0, $862dfd240457f00b$export$1c46dca02aac24dd));
const $152e52666e87d978$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $152e52666e87d978$var$acceptKeywordOperand,
        enterNode: $152e52666e87d978$var$enterNode,
        exitNode: $152e52666e87d978$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("q681h", function(module, exports) {
$parcel$export(module.exports, "listOperand", () => $da0279a594b64f69$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $da0279a594b64f69$export$663c7831528c984b);


var $a9ys9 = parcelRequire("a9ys9");

var $fa1eE = parcelRequire("fa1eE");
function $da0279a594b64f69$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $da0279a594b64f69$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $da0279a594b64f69$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $da0279a594b64f69$var$getChildren() {
    return [
        ...this.values
    ];
}
const $da0279a594b64f69$export$769866c3e9d41d50 = (values)=>$da0279a594b64f69$export$663c7831528c984b(values);
const $da0279a594b64f69$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $da0279a594b64f69$var$acceptListOperand,
        enterNode: $da0279a594b64f69$var$enterNode,
        exitNode: $da0279a594b64f69$var$exitNode,
        getChildren: $da0279a594b64f69$var$getChildren,
        parent: null,
        appendOperand: $a9ys9.appendOperand
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("a9ys9", function(module, exports) {
$parcel$export(module.exports, "appendOperand", () => $8339039101fa111c$export$d94c54f1aee177c4);


var $fa1eE = parcelRequire("fa1eE");
function $8339039101fa111c$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $fa1eE.assignParent)(this);
}

});


parcelRegister("5WHbI", function(module, exports) {
$parcel$export(module.exports, "notClause", () => $cf05e1bf306c2cdd$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $cf05e1bf306c2cdd$export$b25621824fea4548);


var $lmKuC = parcelRequire("lmKuC");

var $fa1eE = parcelRequire("fa1eE");

var $5pxYG = parcelRequire("5pxYG");
function $cf05e1bf306c2cdd$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $cf05e1bf306c2cdd$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $cf05e1bf306c2cdd$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $cf05e1bf306c2cdd$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $cf05e1bf306c2cdd$export$b4734a9fedb4d44e = (clause)=>{
    return $cf05e1bf306c2cdd$export$b25621824fea4548(clause, (0, $5pxYG.notClauseOperator)());
};
const $cf05e1bf306c2cdd$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $cf05e1bf306c2cdd$var$acceptNotClause,
        enterNode: $cf05e1bf306c2cdd$var$enterNode,
        exitNode: $cf05e1bf306c2cdd$var$exitNode,
        getChildren: $cf05e1bf306c2cdd$var$getChildren,
        parent: null,
        remove: $lmKuC.remove,
        removeClause: $lmKuC.removeClause,
        replace: $lmKuC.replace,
        replaceClause: $lmKuC.replaceClause
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("lmKuC", function(module, exports) {
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $fa1eE = parcelRequire("fa1eE");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $fa1eE.assignParent)(this);
    }
}

});

parcelRegister("5pxYG", function(module, exports) {
$parcel$export(module.exports, "notClauseOperator", () => $1b4f1909e547322d$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $1b4f1909e547322d$export$1b15a32bb57b9020);

var $jPlb3 = parcelRequire("jPlb3");

var $fa1eE = parcelRequire("fa1eE");
function $1b4f1909e547322d$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $1b4f1909e547322d$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $1b4f1909e547322d$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $1b4f1909e547322d$export$d2cd8239f99c13d3 = ()=>$1b4f1909e547322d$export$1b15a32bb57b9020();
const $1b4f1909e547322d$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $jPlb3.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $1b4f1909e547322d$var$acceptNotClauseOperator,
        enterNode: $1b4f1909e547322d$var$enterNode,
        exitNode: $1b4f1909e547322d$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
parcelRegister("jPlb3", function(module, exports) {
$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $cee78cdd174c9cda$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $cee78cdd174c9cda$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $cee78cdd174c9cda$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $cee78cdd174c9cda$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $cee78cdd174c9cda$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $cee78cdd174c9cda$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $cee78cdd174c9cda$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $cee78cdd174c9cda$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $cee78cdd174c9cda$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $cee78cdd174c9cda$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $cee78cdd174c9cda$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $cee78cdd174c9cda$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $cee78cdd174c9cda$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $cee78cdd174c9cda$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $cee78cdd174c9cda$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $cee78cdd174c9cda$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $cee78cdd174c9cda$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $cee78cdd174c9cda$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $cee78cdd174c9cda$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $cee78cdd174c9cda$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $cee78cdd174c9cda$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $cee78cdd174c9cda$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $cee78cdd174c9cda$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $cee78cdd174c9cda$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $cee78cdd174c9cda$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $cee78cdd174c9cda$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $cee78cdd174c9cda$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $cee78cdd174c9cda$export$77c793736847e030);
const $cee78cdd174c9cda$export$c6c71ceedb15cda9 = 'not';
const $cee78cdd174c9cda$export$466517a888d00195 = '=';
const $cee78cdd174c9cda$export$6d0d8810623974a5 = '!=';
const $cee78cdd174c9cda$export$bcbb090ab3c498b3 = '>';
const $cee78cdd174c9cda$export$4bf1a4aa659c6ea4 = '<';
const $cee78cdd174c9cda$export$83ce674214a54b2a = '>=';
const $cee78cdd174c9cda$export$9629fd1727ef62ee = '<=';
const $cee78cdd174c9cda$export$c4e3fb55e320e979 = 'in';
const $cee78cdd174c9cda$export$f9857532eaa24ddc = 'not in';
const $cee78cdd174c9cda$export$221595834b8766ab = '~';
const $cee78cdd174c9cda$export$fcefabf94a9bffbf = '!~';
const $cee78cdd174c9cda$export$4feeb3f4ff56bcef = 'is';
const $cee78cdd174c9cda$export$d08d969a0da27188 = 'is not';
const $cee78cdd174c9cda$export$8f907e179985256d = 'was';
const $cee78cdd174c9cda$export$cc7b9d0b3ee23193 = 'was in';
const $cee78cdd174c9cda$export$585d3c004af078bb = 'was not in';
const $cee78cdd174c9cda$export$123eaa9ccc2d9445 = 'was not';
const $cee78cdd174c9cda$export$15f5b446ba8c941e = 'changed';
const $cee78cdd174c9cda$export$643c6101f3fc8547 = [
    $cee78cdd174c9cda$export$466517a888d00195,
    $cee78cdd174c9cda$export$6d0d8810623974a5
];
const $cee78cdd174c9cda$export$329664c9cf18cca6 = [
    $cee78cdd174c9cda$export$221595834b8766ab,
    $cee78cdd174c9cda$export$fcefabf94a9bffbf
];
const $cee78cdd174c9cda$export$1b167a3705885a8b = [
    $cee78cdd174c9cda$export$4bf1a4aa659c6ea4,
    $cee78cdd174c9cda$export$bcbb090ab3c498b3,
    $cee78cdd174c9cda$export$9629fd1727ef62ee,
    $cee78cdd174c9cda$export$83ce674214a54b2a
];
const $cee78cdd174c9cda$export$f25cf16c2270312f = [
    $cee78cdd174c9cda$export$c4e3fb55e320e979,
    $cee78cdd174c9cda$export$f9857532eaa24ddc
];
const $cee78cdd174c9cda$export$eb58cfffe4a6b805 = [
    $cee78cdd174c9cda$export$4feeb3f4ff56bcef,
    $cee78cdd174c9cda$export$d08d969a0da27188
];
const $cee78cdd174c9cda$export$c22a981f581de218 = [
    $cee78cdd174c9cda$export$8f907e179985256d,
    $cee78cdd174c9cda$export$123eaa9ccc2d9445
];
const $cee78cdd174c9cda$export$6d08c4699bb75284 = [
    $cee78cdd174c9cda$export$cc7b9d0b3ee23193,
    $cee78cdd174c9cda$export$585d3c004af078bb
];
const $cee78cdd174c9cda$export$b7dc214eef214c1c = [
    $cee78cdd174c9cda$export$15f5b446ba8c941e
];
const $cee78cdd174c9cda$export$184799fc79ccac89 = [
    ...$cee78cdd174c9cda$export$643c6101f3fc8547,
    ...$cee78cdd174c9cda$export$329664c9cf18cca6,
    ...$cee78cdd174c9cda$export$1b167a3705885a8b,
    ...$cee78cdd174c9cda$export$f25cf16c2270312f,
    ...$cee78cdd174c9cda$export$eb58cfffe4a6b805,
    ...$cee78cdd174c9cda$export$c22a981f581de218,
    ...$cee78cdd174c9cda$export$6d08c4699bb75284,
    ...$cee78cdd174c9cda$export$b7dc214eef214c1c
];
const $cee78cdd174c9cda$export$77c793736847e030 = [
    $cee78cdd174c9cda$export$c4e3fb55e320e979,
    $cee78cdd174c9cda$export$f9857532eaa24ddc,
    $cee78cdd174c9cda$export$cc7b9d0b3ee23193,
    $cee78cdd174c9cda$export$585d3c004af078bb
];

});



parcelRegister("i8g3z", function(module, exports) {
$parcel$export(module.exports, "operator", () => $43a4abca705ed742$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $43a4abca705ed742$export$649025bc60ab9c3b);

var $fa1eE = parcelRequire("fa1eE");
function $43a4abca705ed742$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $43a4abca705ed742$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $43a4abca705ed742$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $43a4abca705ed742$export$dbd72860f701d4f3 = (value)=>$43a4abca705ed742$export$649025bc60ab9c3b(value, value);
const $43a4abca705ed742$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $43a4abca705ed742$var$acceptOperator,
        enterNode: $43a4abca705ed742$var$enterNode,
        exitNode: $43a4abca705ed742$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("hE0gi", function(module, exports) {
$parcel$export(module.exports, "orderBy", () => $c0a3843a9e7de571$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $c0a3843a9e7de571$export$e4eb1fa6bc8465c1);


var $ekRIJ = parcelRequire("ekRIJ");

var $fa1eE = parcelRequire("fa1eE");

var $lDhFj = parcelRequire("lDhFj");
function $c0a3843a9e7de571$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $c0a3843a9e7de571$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $c0a3843a9e7de571$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $c0a3843a9e7de571$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $c0a3843a9e7de571$export$f18af21d6f4dafd8 = (fields)=>{
    return $c0a3843a9e7de571$export$e4eb1fa6bc8465c1(fields, (0, $lDhFj.orderByOperator)());
};
const $c0a3843a9e7de571$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $c0a3843a9e7de571$var$acceptOrderBy,
        enterNode: $c0a3843a9e7de571$var$enterNode,
        exitNode: $c0a3843a9e7de571$var$exitNode,
        getChildren: $c0a3843a9e7de571$var$getChildren,
        parent: null,
        prependOrderField: $ekRIJ.prependOrderField,
        setOrderDirection: $ekRIJ.setOrderDirection,
        replace: $ekRIJ.replace,
        replaceOrderField: $ekRIJ.replaceOrderField,
        remove: $ekRIJ.remove,
        removeOrderField: $ekRIJ.removeOrderField
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("ekRIJ", function(module, exports) {
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $fa1eE = parcelRequire("fa1eE");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $fa1eE.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $fa1eE.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("lDhFj", function(module, exports) {
$parcel$export(module.exports, "orderByOperator", () => $3dd1a82964518ff4$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $3dd1a82964518ff4$export$739e30af23a08da0);


var $fa1eE = parcelRequire("fa1eE");
function $3dd1a82964518ff4$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $3dd1a82964518ff4$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $3dd1a82964518ff4$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $3dd1a82964518ff4$export$c7307b67924c61ea = ()=>$3dd1a82964518ff4$export$739e30af23a08da0();
const $3dd1a82964518ff4$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $adec16a85d57f51f$export$ca51f5fd60a74517),
        position: position,
        accept: $3dd1a82964518ff4$var$acceptOrderByOperator,
        enterNode: $3dd1a82964518ff4$var$enterNode,
        exitNode: $3dd1a82964518ff4$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
const $adec16a85d57f51f$export$ca51f5fd60a74517 = 'ORDER BY';
const $adec16a85d57f51f$export$6d60017b9e092e73 = 'ASC';
const $adec16a85d57f51f$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("83AJ4", function(module, exports) {
$parcel$export(module.exports, "orderByDirection", () => $c704c2d23a3fd91f$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $c704c2d23a3fd91f$export$8c65cac1a7852d1f);

var $fa1eE = parcelRequire("fa1eE");
function $c704c2d23a3fd91f$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $c704c2d23a3fd91f$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $c704c2d23a3fd91f$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $c704c2d23a3fd91f$export$864d934efed3ccaa = (value)=>$c704c2d23a3fd91f$export$8c65cac1a7852d1f(value);
const $c704c2d23a3fd91f$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $c704c2d23a3fd91f$var$acceptOrderByDirection,
        enterNode: $c704c2d23a3fd91f$var$enterNode,
        exitNode: $c704c2d23a3fd91f$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("d0MpM", function(module, exports) {
$parcel$export(module.exports, "orderByField", () => $38c966c2448f3b7a$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $38c966c2448f3b7a$export$661a7786e3d15926);

var $hKUyp = parcelRequire("hKUyp");

var $fa1eE = parcelRequire("fa1eE");
function $38c966c2448f3b7a$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $38c966c2448f3b7a$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $38c966c2448f3b7a$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $38c966c2448f3b7a$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $38c966c2448f3b7a$export$942df63e5e3d3899 = (field, direction)=>$38c966c2448f3b7a$export$661a7786e3d15926(field, direction);
const $38c966c2448f3b7a$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $38c966c2448f3b7a$var$acceptOrderByField,
        enterNode: $38c966c2448f3b7a$var$enterNode,
        exitNode: $38c966c2448f3b7a$var$exitNode,
        getChildren: $38c966c2448f3b7a$var$getChildren,
        parent: null,
        setOrderDirection: $hKUyp.setOrderDirection,
        replace: $hKUyp.replace,
        remove: $hKUyp.remove
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("hKUyp", function(module, exports) {
$parcel$export(module.exports, "setOrderDirection", () => $e6633080911e1e18$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $e6633080911e1e18$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $e6633080911e1e18$export$cd7f480d6b8286c3);

var $fa1eE = parcelRequire("fa1eE");
function $e6633080911e1e18$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $fa1eE.assignParent)(this);
}
function $e6633080911e1e18$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $e6633080911e1e18$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("6Dx67", function(module, exports) {
$parcel$export(module.exports, "predicate", () => $425b3c9785c66bdc$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $425b3c9785c66bdc$export$a767a27ad05a38a2);

var $fa1eE = parcelRequire("fa1eE");
function $425b3c9785c66bdc$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $425b3c9785c66bdc$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $425b3c9785c66bdc$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $425b3c9785c66bdc$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $425b3c9785c66bdc$export$5fc51e445ce24faf = (operator, operand)=>$425b3c9785c66bdc$export$a767a27ad05a38a2(operator, operand);
const $425b3c9785c66bdc$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $425b3c9785c66bdc$var$acceptPredicate,
        enterNode: $425b3c9785c66bdc$var$enterNode,
        exitNode: $425b3c9785c66bdc$var$exitNode,
        getChildren: $425b3c9785c66bdc$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("hbAhR", function(module, exports) {
$parcel$export(module.exports, "predicateOperator", () => $48cdeafcf75d3a91$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $48cdeafcf75d3a91$export$c69d893689716768);

var $fa1eE = parcelRequire("fa1eE");
function $48cdeafcf75d3a91$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $48cdeafcf75d3a91$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $48cdeafcf75d3a91$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $48cdeafcf75d3a91$export$5419b7f16910ea62 = (value)=>$48cdeafcf75d3a91$export$c69d893689716768(value, value);
const $48cdeafcf75d3a91$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $48cdeafcf75d3a91$var$acceptPredicateOperator,
        enterNode: $48cdeafcf75d3a91$var$enterNode,
        exitNode: $48cdeafcf75d3a91$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("89aGW", function(module, exports) {
$parcel$export(module.exports, "property", () => $1ed758994e0eb78c$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $1ed758994e0eb78c$export$1cbd90994fef1fad);

var $fa1eE = parcelRequire("fa1eE");
function $1ed758994e0eb78c$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $1ed758994e0eb78c$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $1ed758994e0eb78c$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $1ed758994e0eb78c$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $1ed758994e0eb78c$export$d541bacb2bda4494 = (key, path = [])=>$1ed758994e0eb78c$export$1cbd90994fef1fad(key, path);
const $1ed758994e0eb78c$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $1ed758994e0eb78c$var$acceptProperty,
        enterNode: $1ed758994e0eb78c$var$enterNode,
        exitNode: $1ed758994e0eb78c$var$exitNode,
        getChildren: $1ed758994e0eb78c$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("8XEos", function(module, exports) {
$parcel$export(module.exports, "query", () => $d6ce43aac43752fe$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $d6ce43aac43752fe$export$bc2d6e2e1fd9014);


var $qZ8nR = parcelRequire("qZ8nR");

var $fa1eE = parcelRequire("fa1eE");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $d6ce43aac43752fe$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $d6ce43aac43752fe$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $d6ce43aac43752fe$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $d6ce43aac43752fe$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $d6ce43aac43752fe$export$2fa187e846a241c4 = (where, orderBy)=>$d6ce43aac43752fe$export$bc2d6e2e1fd9014(where, orderBy);
const $d6ce43aac43752fe$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $d6ce43aac43752fe$var$acceptQuery,
        enterNode: $d6ce43aac43752fe$var$enterNode,
        exitNode: $d6ce43aac43752fe$var$exitNode,
        getChildren: $d6ce43aac43752fe$var$getChildren,
        parent: null,
        appendClause: $qZ8nR.appendClause,
        prependOrderField: $qZ8nR.prependOrderField,
        setOrderDirection: $qZ8nR.setOrderDirection,
        removeClause: $qZ8nR.removeClause,
        replaceClause: $qZ8nR.replaceClause,
        replaceOrderBy: $qZ8nR.replaceOrderBy,
        removeOrderBy: $qZ8nR.removeOrderBy
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("qZ8nR", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $f26C8 = parcelRequire("f26C8");

var $fa1eE = parcelRequire("fa1eE");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $f26C8.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $f26C8.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $fa1eE.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $f26C8.default).orderBy([
            orderField
        ]);
        (0, $fa1eE.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $fa1eE.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $fa1eE.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("52A7I", function(module, exports) {
$parcel$export(module.exports, "terminalClause", () => $c357857da31d9c1c$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $c357857da31d9c1c$export$cc08e43598d091fc);


var $2mQsQ = parcelRequire("2mQsQ");

var $fa1eE = parcelRequire("fa1eE");
function $c357857da31d9c1c$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $c357857da31d9c1c$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $c357857da31d9c1c$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $c357857da31d9c1c$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $c357857da31d9c1c$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $c357857da31d9c1c$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $c357857da31d9c1c$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $c357857da31d9c1c$var$acceptTerminalClause,
        enterNode: $c357857da31d9c1c$var$enterNode,
        exitNode: $c357857da31d9c1c$var$exitNode,
        getChildren: $c357857da31d9c1c$var$getChildren,
        parent: null,
        setOperator: $2mQsQ.setOperator,
        setOperand: $2mQsQ.setOperand,
        appendOperand: $2mQsQ.appendOperand,
        remove: $2mQsQ.remove,
        replace: $2mQsQ.replace
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("2mQsQ", function(module, exports) {
$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $f26C8 = parcelRequire("f26C8");

var $fa1eE = parcelRequire("fa1eE");
function setOperator(operator) {
    this.operator = operator;
    (0, $fa1eE.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $fa1eE.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $f26C8.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("jArsO", function(module, exports) {
$parcel$export(module.exports, "valueOperand", () => $19d73696559a6b33$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $19d73696559a6b33$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $19d73696559a6b33$export$3ac9155bde56a45f);


var $h8zsn = parcelRequire("h8zsn");
var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $19d73696559a6b33$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $19d73696559a6b33$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $19d73696559a6b33$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $19d73696559a6b33$export$2b6e4d2ed8d53bf3 = (value)=>$19d73696559a6b33$export$79c37d97caac8627(value, (0, $ykU4x.sanitiseJqlString)(value));
const $19d73696559a6b33$export$3ac9155bde56a45f = (text)=>$19d73696559a6b33$export$79c37d97caac8627((0, $h8zsn.normaliseJqlString)(text), text);
const $19d73696559a6b33$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $19d73696559a6b33$var$acceptValueOperand,
        enterNode: $19d73696559a6b33$var$enterNode,
        exitNode: $19d73696559a6b33$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});


parcelRegister("9qsUT", function(module, exports) {
$parcel$export(module.exports, "JastBuilder", () => $f7e455d2ca709d45$export$99cae18a5a6ba8cf);

var $jz1xX = parcelRequire("jz1xX");

var $LFmXM = parcelRequire("LFmXM");

var $bFJ48 = parcelRequire("bFJ48");
var $41LBU = parcelRequire("41LBU");

var $f26C8 = parcelRequire("f26C8");

var $cWGfC = parcelRequire("cWGfC");
var $ax34Q = parcelRequire("ax34Q");

var $cjb70 = parcelRequire("cjb70");
class $f7e455d2ca709d45$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $cWGfC.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $cjb70.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $f26C8.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $f26C8.default).jast(undefined, value, [
                new (0, $ax34Q.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $LFmXM.default)((value)=>{
            const chars = (0, $jz1xX.CharStreams).fromString(value);
            const lexer = new (0, $bFJ48.JQLLexer)(chars);
            return new (0, $jz1xX.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $LFmXM.default)((tokens)=>new (0, $41LBU.JQLParser)(tokens));
    }
}

});
parcelRegister("jz1xX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e3e27c5f9836a7a6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3e27c5f9836a7a6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3e27c5f9836a7a6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gZZg5")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("86N5m")), module.exports);

// export * from "./ANTLRFileStream";
$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7ERej")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("jY97w")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("h5rBk")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("cBsOS")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d0TlQ")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("3wxwf")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("lXg5i")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8Mk1Z")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("arOt9")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("1y11S")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("b6VR9")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("cNbax")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6gsRs")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("4Allj")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d7mTm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6iuj6")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("2iaul")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d4sFB")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gTQRB")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8I7Eq")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6Npyx")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8tp3s")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("4qcTm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("dDGsq")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("bvca3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("djIaX")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5NlfZ")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("adfkv")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("ct3k0")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("lWPhg")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("24a4y")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("1uFvm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gBCh3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("9moap")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("iB1aK")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("2G93d")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5fKqt")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("dAoWy")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("kKHPj")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("3sjft")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7twhW")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5t4I3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7kyUa")), module.exports);

});
parcelRegister("gZZg5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("86N5m", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7ERej", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $59358f274fb6c10c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $esDFm = parcelRequire("esDFm");

var $d4sFB = parcelRequire("d4sFB");
const $59358f274fb6c10c$var$READ_BUFFER_SIZE = 1024;
const $59358f274fb6c10c$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $59358f274fb6c10c$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $gwEr2(this.LA(1) === $d4sFB.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $d4sFB.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $d4sFB.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "consume", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "LA", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "index", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "size", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "mark", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "release", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "seek", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "getText", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "sourceName", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $59358f274fb6c10c$var$ANTLRInputStream;

});
parcelRegister("gwEr2", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $igDjg = parcelRequire("igDjg");
'use strict';
function $c07f0014105f4d3c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c07f0014105f4d3c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c07f0014105f4d3c$var$_typeof(o);
}
function $c07f0014105f4d3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c07f0014105f4d3c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c07f0014105f4d3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c07f0014105f4d3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c07f0014105f4d3c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c07f0014105f4d3c$var$_toPropertyKey(arg) {
    var key = $c07f0014105f4d3c$var$_toPrimitive(arg, "string");
    return $c07f0014105f4d3c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c07f0014105f4d3c$var$_toPrimitive(input, hint) {
    if ($c07f0014105f4d3c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c07f0014105f4d3c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c07f0014105f4d3c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $9Ej6r = parcelRequire("9Ej6r");
var $c07f0014105f4d3c$var$_require$codes = $9Ej6r.codes, $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT = $c07f0014105f4d3c$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_ARG_TYPE, $c07f0014105f4d3c$var$ERR_INVALID_ARG_VALUE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_ARG_VALUE, $c07f0014105f4d3c$var$ERR_INVALID_RETURN_VALUE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_RETURN_VALUE, $c07f0014105f4d3c$var$ERR_MISSING_ARGS = $c07f0014105f4d3c$var$_require$codes.ERR_MISSING_ARGS;

var $jc4ou = parcelRequire("jc4ou");

var $7WF8Y = parcelRequire("7WF8Y");
var $c07f0014105f4d3c$var$inspect = $7WF8Y.inspect;

var $7WF8Y = parcelRequire("7WF8Y");
var $c07f0014105f4d3c$require$_require$types = $7WF8Y.types;
var $c07f0014105f4d3c$var$isPromise = $c07f0014105f4d3c$require$_require$types.isPromise, $c07f0014105f4d3c$var$isRegExp = $c07f0014105f4d3c$require$_require$types.isRegExp;

var $c07f0014105f4d3c$var$objectAssign = (parcelRequire("10hUt"))();

var $c07f0014105f4d3c$var$objectIs = (parcelRequire("4LgTG"))();

var $c07f0014105f4d3c$var$RegExpPrototypeTest = (parcelRequire("2TUjA"))('RegExp.prototype.test');
var $c07f0014105f4d3c$var$errorCache = new Map();
var $c07f0014105f4d3c$var$isDeepEqual;
var $c07f0014105f4d3c$var$isDeepStrictEqual;
var $c07f0014105f4d3c$var$parseExpressionAt;
var $c07f0014105f4d3c$var$findNodeAround;
var $c07f0014105f4d3c$var$decoder;

function $c07f0014105f4d3c$var$lazyLoadComparison() {
    var comparison = (parcelRequire("lV95c"));
    $c07f0014105f4d3c$var$isDeepEqual = comparison.isDeepEqual;
    $c07f0014105f4d3c$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $c07f0014105f4d3c$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $c07f0014105f4d3c$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $c07f0014105f4d3c$var$escapeFn = function escapeFn(str) {
    return $c07f0014105f4d3c$var$meta[str.charCodeAt(0)];
};
var $c07f0014105f4d3c$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $c07f0014105f4d3c$var$assert = module.exports = $c07f0014105f4d3c$var$ok;
var $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $c07f0014105f4d3c$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $jc4ou(obj);
}
function $c07f0014105f4d3c$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($c07f0014105f4d3c$var$warned === false) {
            $c07f0014105f4d3c$var$warned = true;
            var warn = $igDjg.emitWarning ? $igDjg.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $c07f0014105f4d3c$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $jc4ou(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$c07f0014105f4d3c$var$assert.fail = $c07f0014105f4d3c$var$fail;
// The AssertionError is defined in internal/error.
$c07f0014105f4d3c$var$assert.AssertionError = $jc4ou;
function $c07f0014105f4d3c$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $jc4ou({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $c07f0014105f4d3c$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $c07f0014105f4d3c$var$innerOk.apply(void 0, [
        $c07f0014105f4d3c$var$ok,
        args.length
    ].concat(args));
}
$c07f0014105f4d3c$var$assert.ok = $c07f0014105f4d3c$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $c07f0014105f4d3c$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$c07f0014105f4d3c$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$c07f0014105f4d3c$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if (!$c07f0014105f4d3c$var$isDeepEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$c07f0014105f4d3c$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if ($c07f0014105f4d3c$var$isDeepEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $c07f0014105f4d3c$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if (!$c07f0014105f4d3c$var$isDeepStrictEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$c07f0014105f4d3c$var$assert.notDeepStrictEqual = $c07f0014105f4d3c$var$notDeepStrictEqual;
function $c07f0014105f4d3c$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if ($c07f0014105f4d3c$var$isDeepStrictEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $c07f0014105f4d3c$var$notDeepStrictEqual
    });
}
$c07f0014105f4d3c$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$c07f0014105f4d3c$var$objectIs(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$c07f0014105f4d3c$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$objectIs(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $c07f0014105f4d3c$var$Comparison = /*#__PURE__*/ $c07f0014105f4d3c$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $c07f0014105f4d3c$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $c07f0014105f4d3c$var$isRegExp(obj[key]) && $c07f0014105f4d3c$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $c07f0014105f4d3c$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$c07f0014105f4d3c$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $c07f0014105f4d3c$var$Comparison(actual, keys);
            var b = new $c07f0014105f4d3c$var$Comparison(expected, keys, actual);
            var err = new $jc4ou({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $c07f0014105f4d3c$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $c07f0014105f4d3c$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($c07f0014105f4d3c$var$isRegExp(expected)) return $c07f0014105f4d3c$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($c07f0014105f4d3c$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $jc4ou({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $c07f0014105f4d3c$var$isRegExp(expected[key]) && $c07f0014105f4d3c$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $c07f0014105f4d3c$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $c07f0014105f4d3c$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL;
}
function $c07f0014105f4d3c$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $c07f0014105f4d3c$var$isPromise(obj) || obj !== null && $c07f0014105f4d3c$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $c07f0014105f4d3c$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$c07f0014105f4d3c$var$checkIsPromise(resultPromise)) throw new $c07f0014105f4d3c$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($c07f0014105f4d3c$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $c07f0014105f4d3c$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($c07f0014105f4d3c$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $c07f0014105f4d3c$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $c07f0014105f4d3c$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$c07f0014105f4d3c$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $c07f0014105f4d3c$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $c07f0014105f4d3c$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $c07f0014105f4d3c$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$c07f0014105f4d3c$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $c07f0014105f4d3c$var$expectsError.apply(void 0, [
        throws,
        $c07f0014105f4d3c$var$getActual(promiseFn)
    ].concat(args));
};
$c07f0014105f4d3c$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $c07f0014105f4d3c$var$waitForActual(promiseFn).then(function(result) {
        return $c07f0014105f4d3c$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$c07f0014105f4d3c$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $c07f0014105f4d3c$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $c07f0014105f4d3c$var$getActual(fn)
    ].concat(args));
};
$c07f0014105f4d3c$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $c07f0014105f4d3c$var$waitForActual(fn).then(function(result) {
        return $c07f0014105f4d3c$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$c07f0014105f4d3c$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($c07f0014105f4d3c$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $c07f0014105f4d3c$var$inspect(err);
        var newErr = new $jc4ou({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $c07f0014105f4d3c$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$c07f0014105f4d3c$var$isRegExp(regexp)) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $c07f0014105f4d3c$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($c07f0014105f4d3c$var$_typeof(string), " (").concat($c07f0014105f4d3c$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($c07f0014105f4d3c$var$inspect(regexp), ". Input:\n\n").concat($c07f0014105f4d3c$var$inspect(string), "\n"));
        var err = new $jc4ou({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$c07f0014105f4d3c$var$assert.match = function match(string, regexp, message) {
    $c07f0014105f4d3c$var$internalMatch(string, regexp, message, match, 'match');
};
$c07f0014105f4d3c$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $c07f0014105f4d3c$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $c07f0014105f4d3c$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $c07f0014105f4d3c$var$innerOk.apply(void 0, [
        $c07f0014105f4d3c$var$strict,
        args.length
    ].concat(args));
}
$c07f0014105f4d3c$var$assert.strict = $c07f0014105f4d3c$var$objectAssign($c07f0014105f4d3c$var$strict, $c07f0014105f4d3c$var$assert, {
    equal: $c07f0014105f4d3c$var$assert.strictEqual,
    deepEqual: $c07f0014105f4d3c$var$assert.deepStrictEqual,
    notEqual: $c07f0014105f4d3c$var$assert.notStrictEqual,
    notDeepEqual: $c07f0014105f4d3c$var$assert.notDeepStrictEqual
});
$c07f0014105f4d3c$var$assert.strict.strict = $c07f0014105f4d3c$var$assert.strict;

});
parcelRegister("9Ej6r", function(module, exports) {
$parcel$export(module.exports, "codes", () => $7066aaed797d201d$export$e45cb6485273080e, (v) => $7066aaed797d201d$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $7066aaed797d201d$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $7066aaed797d201d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7066aaed797d201d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7066aaed797d201d$var$_typeof(o);
}
function $7066aaed797d201d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7066aaed797d201d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7066aaed797d201d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7066aaed797d201d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7066aaed797d201d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7066aaed797d201d$var$_toPropertyKey(arg) {
    var key = $7066aaed797d201d$var$_toPrimitive(arg, "string");
    return $7066aaed797d201d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7066aaed797d201d$var$_toPrimitive(input, hint) {
    if ($7066aaed797d201d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7066aaed797d201d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7066aaed797d201d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7066aaed797d201d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7066aaed797d201d$var$_setPrototypeOf(subClass, superClass);
}
function $7066aaed797d201d$var$_setPrototypeOf(o, p) {
    $7066aaed797d201d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7066aaed797d201d$var$_setPrototypeOf(o, p);
}
function $7066aaed797d201d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7066aaed797d201d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7066aaed797d201d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7066aaed797d201d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7066aaed797d201d$var$_possibleConstructorReturn(this, result);
    };
}
function $7066aaed797d201d$var$_possibleConstructorReturn(self, call) {
    if (call && ($7066aaed797d201d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7066aaed797d201d$var$_assertThisInitialized(self);
}
function $7066aaed797d201d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7066aaed797d201d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7066aaed797d201d$var$_getPrototypeOf(o) {
    $7066aaed797d201d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7066aaed797d201d$var$_getPrototypeOf(o);
}
var $7066aaed797d201d$var$codes = {};
// Lazy loaded
var $7066aaed797d201d$var$assert;
var $7066aaed797d201d$var$util;
function $7066aaed797d201d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $7066aaed797d201d$var$_inherits(NodeError, _Base);
        var _super = $7066aaed797d201d$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $7066aaed797d201d$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $7066aaed797d201d$var$_createClass(NodeError);
    }(Base);
    $7066aaed797d201d$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $7066aaed797d201d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $7066aaed797d201d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7066aaed797d201d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $7066aaed797d201d$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$7066aaed797d201d$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$7066aaed797d201d$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($7066aaed797d201d$var$assert === undefined) $7066aaed797d201d$var$assert = (parcelRequire("gwEr2"));
    $7066aaed797d201d$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $7066aaed797d201d$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($7066aaed797d201d$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($7066aaed797d201d$var$oneOf(expected, 'type'));
    else {
        var type = $7066aaed797d201d$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($7066aaed797d201d$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($7066aaed797d201d$var$_typeof(actual));
    return msg;
}, TypeError);

$7066aaed797d201d$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($7066aaed797d201d$var$util === undefined) $7066aaed797d201d$var$util = (parcelRequire("7WF8Y"));
    var inspected = $7066aaed797d201d$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$7066aaed797d201d$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($7066aaed797d201d$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$7066aaed797d201d$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($7066aaed797d201d$var$assert === undefined) $7066aaed797d201d$var$assert = (parcelRequire("gwEr2"));
    $7066aaed797d201d$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$7066aaed797d201d$export$e45cb6485273080e = $7066aaed797d201d$var$codes;

});
parcelRegister("7WF8Y", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $igDjg = parcelRequire("igDjg");
var $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $5c8ddd78d1eb5694$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$5c8ddd78d1eb5694$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($5c8ddd78d1eb5694$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($5c8ddd78d1eb5694$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($5c8ddd78d1eb5694$var$isNull(x) || !$5c8ddd78d1eb5694$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $5c8ddd78d1eb5694$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $igDjg !== 'undefined' && $igDjg.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $igDjg === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($igDjg.throwDeprecation) throw new Error(msg);
            else if ($igDjg.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $5c8ddd78d1eb5694$var$debugs = {};
var $5c8ddd78d1eb5694$var$debugEnvRegex = /^$/;
var $5c8ddd78d1eb5694$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$5c8ddd78d1eb5694$var$debugs[set]) {
        if ($5c8ddd78d1eb5694$var$debugEnvRegex.test(set)) {
            var pid = $igDjg.pid;
            $5c8ddd78d1eb5694$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $5c8ddd78d1eb5694$var$debugs[set] = function() {};
    }
    return $5c8ddd78d1eb5694$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $5c8ddd78d1eb5694$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $5c8ddd78d1eb5694$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($5c8ddd78d1eb5694$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $5c8ddd78d1eb5694$var$stylizeWithColor;
    return $5c8ddd78d1eb5694$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $5c8ddd78d1eb5694$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$5c8ddd78d1eb5694$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$5c8ddd78d1eb5694$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $5c8ddd78d1eb5694$var$stylizeWithColor(str, styleType) {
    var style = $5c8ddd78d1eb5694$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $5c8ddd78d1eb5694$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $5c8ddd78d1eb5694$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $5c8ddd78d1eb5694$var$stylizeNoColor(str, styleType) {
    return str;
}
function $5c8ddd78d1eb5694$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $5c8ddd78d1eb5694$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $5c8ddd78d1eb5694$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$5c8ddd78d1eb5694$var$isString(ret)) ret = $5c8ddd78d1eb5694$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $5c8ddd78d1eb5694$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $5c8ddd78d1eb5694$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($5c8ddd78d1eb5694$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $5c8ddd78d1eb5694$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($5c8ddd78d1eb5694$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($5c8ddd78d1eb5694$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($5c8ddd78d1eb5694$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($5c8ddd78d1eb5694$var$isError(value)) return $5c8ddd78d1eb5694$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($5c8ddd78d1eb5694$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($5c8ddd78d1eb5694$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($5c8ddd78d1eb5694$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($5c8ddd78d1eb5694$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($5c8ddd78d1eb5694$var$isError(value)) base = ' ' + $5c8ddd78d1eb5694$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($5c8ddd78d1eb5694$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $5c8ddd78d1eb5694$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $5c8ddd78d1eb5694$var$reduceToSingleString(output, base, braces);
}
function $5c8ddd78d1eb5694$var$formatPrimitive(ctx, value) {
    if ($5c8ddd78d1eb5694$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($5c8ddd78d1eb5694$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($5c8ddd78d1eb5694$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($5c8ddd78d1eb5694$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($5c8ddd78d1eb5694$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $5c8ddd78d1eb5694$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $5c8ddd78d1eb5694$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($5c8ddd78d1eb5694$var$hasOwnProperty(value, String(i))) output.push($5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$5c8ddd78d1eb5694$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($5c8ddd78d1eb5694$var$isNull(recurseTimes)) str = $5c8ddd78d1eb5694$var$formatValue(ctx, desc.value, null);
            else str = $5c8ddd78d1eb5694$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($5c8ddd78d1eb5694$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $5c8ddd78d1eb5694$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("eQQyY"));
function $5c8ddd78d1eb5694$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $5c8ddd78d1eb5694$var$isArray;
function $5c8ddd78d1eb5694$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $5c8ddd78d1eb5694$var$isBoolean;
function $5c8ddd78d1eb5694$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $5c8ddd78d1eb5694$var$isNull;
function $5c8ddd78d1eb5694$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $5c8ddd78d1eb5694$var$isNullOrUndefined;
function $5c8ddd78d1eb5694$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $5c8ddd78d1eb5694$var$isNumber;
function $5c8ddd78d1eb5694$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $5c8ddd78d1eb5694$var$isString;
function $5c8ddd78d1eb5694$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $5c8ddd78d1eb5694$var$isSymbol;
function $5c8ddd78d1eb5694$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $5c8ddd78d1eb5694$var$isUndefined;
function $5c8ddd78d1eb5694$var$isRegExp(re) {
    return $5c8ddd78d1eb5694$var$isObject(re) && $5c8ddd78d1eb5694$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $5c8ddd78d1eb5694$var$isRegExp;
module.exports.types.isRegExp = $5c8ddd78d1eb5694$var$isRegExp;
function $5c8ddd78d1eb5694$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $5c8ddd78d1eb5694$var$isObject;
function $5c8ddd78d1eb5694$var$isDate(d) {
    return $5c8ddd78d1eb5694$var$isObject(d) && $5c8ddd78d1eb5694$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $5c8ddd78d1eb5694$var$isDate;
module.exports.types.isDate = $5c8ddd78d1eb5694$var$isDate;
function $5c8ddd78d1eb5694$var$isError(e) {
    return $5c8ddd78d1eb5694$var$isObject(e) && ($5c8ddd78d1eb5694$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $5c8ddd78d1eb5694$var$isError;
module.exports.types.isNativeError = $5c8ddd78d1eb5694$var$isError;
function $5c8ddd78d1eb5694$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $5c8ddd78d1eb5694$var$isFunction;
function $5c8ddd78d1eb5694$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $5c8ddd78d1eb5694$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("fMvDf"));
function $5c8ddd78d1eb5694$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $5c8ddd78d1eb5694$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $5c8ddd78d1eb5694$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $5c8ddd78d1eb5694$var$timestamp() {
    var d = new Date();
    var time = [
        $5c8ddd78d1eb5694$var$pad(d.getHours()),
        $5c8ddd78d1eb5694$var$pad(d.getMinutes()),
        $5c8ddd78d1eb5694$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $5c8ddd78d1eb5694$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $5c8ddd78d1eb5694$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lpcNn"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$5c8ddd78d1eb5694$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $5c8ddd78d1eb5694$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol && original[$5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol]) {
        var fn = original[$5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol;
function $5c8ddd78d1eb5694$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $5c8ddd78d1eb5694$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $igDjg.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $igDjg.nextTick($5c8ddd78d1eb5694$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $5c8ddd78d1eb5694$var$callbackify;

});
parcelRegister("eQQyY", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $8NKMi = parcelRequire("8NKMi");

var $7qnIS = parcelRequire("7qnIS");

var $3eoyd = parcelRequire("3eoyd");

var $cC7Tq = parcelRequire("cC7Tq");
function $acfeb1ef2847c7f3$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $acfeb1ef2847c7f3$var$BigIntSupported = typeof BigInt !== 'undefined';
var $acfeb1ef2847c7f3$var$SymbolSupported = typeof Symbol !== 'undefined';
var $acfeb1ef2847c7f3$var$ObjectToString = $acfeb1ef2847c7f3$var$uncurryThis(Object.prototype.toString);
var $acfeb1ef2847c7f3$var$numberValue = $acfeb1ef2847c7f3$var$uncurryThis(Number.prototype.valueOf);
var $acfeb1ef2847c7f3$var$stringValue = $acfeb1ef2847c7f3$var$uncurryThis(String.prototype.valueOf);
var $acfeb1ef2847c7f3$var$booleanValue = $acfeb1ef2847c7f3$var$uncurryThis(Boolean.prototype.valueOf);
if ($acfeb1ef2847c7f3$var$BigIntSupported) var $acfeb1ef2847c7f3$var$bigIntValue = $acfeb1ef2847c7f3$var$uncurryThis(BigInt.prototype.valueOf);
if ($acfeb1ef2847c7f3$var$SymbolSupported) var $acfeb1ef2847c7f3$var$symbolValue = $acfeb1ef2847c7f3$var$uncurryThis(Symbol.prototype.valueOf);
function $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $8NKMi;
module.exports.isGeneratorFunction = $7qnIS;
module.exports.isTypedArray = $cC7Tq;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $acfeb1ef2847c7f3$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $acfeb1ef2847c7f3$var$isPromise;
function $acfeb1ef2847c7f3$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $cC7Tq(value) || $acfeb1ef2847c7f3$var$isDataView(value);
}
module.exports.isArrayBufferView = $acfeb1ef2847c7f3$var$isArrayBufferView;
function $acfeb1ef2847c7f3$var$isUint8Array(value) {
    return $3eoyd(value) === 'Uint8Array';
}
module.exports.isUint8Array = $acfeb1ef2847c7f3$var$isUint8Array;
function $acfeb1ef2847c7f3$var$isUint8ClampedArray(value) {
    return $3eoyd(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $acfeb1ef2847c7f3$var$isUint8ClampedArray;
function $acfeb1ef2847c7f3$var$isUint16Array(value) {
    return $3eoyd(value) === 'Uint16Array';
}
module.exports.isUint16Array = $acfeb1ef2847c7f3$var$isUint16Array;
function $acfeb1ef2847c7f3$var$isUint32Array(value) {
    return $3eoyd(value) === 'Uint32Array';
}
module.exports.isUint32Array = $acfeb1ef2847c7f3$var$isUint32Array;
function $acfeb1ef2847c7f3$var$isInt8Array(value) {
    return $3eoyd(value) === 'Int8Array';
}
module.exports.isInt8Array = $acfeb1ef2847c7f3$var$isInt8Array;
function $acfeb1ef2847c7f3$var$isInt16Array(value) {
    return $3eoyd(value) === 'Int16Array';
}
module.exports.isInt16Array = $acfeb1ef2847c7f3$var$isInt16Array;
function $acfeb1ef2847c7f3$var$isInt32Array(value) {
    return $3eoyd(value) === 'Int32Array';
}
module.exports.isInt32Array = $acfeb1ef2847c7f3$var$isInt32Array;
function $acfeb1ef2847c7f3$var$isFloat32Array(value) {
    return $3eoyd(value) === 'Float32Array';
}
module.exports.isFloat32Array = $acfeb1ef2847c7f3$var$isFloat32Array;
function $acfeb1ef2847c7f3$var$isFloat64Array(value) {
    return $3eoyd(value) === 'Float64Array';
}
module.exports.isFloat64Array = $acfeb1ef2847c7f3$var$isFloat64Array;
function $acfeb1ef2847c7f3$var$isBigInt64Array(value) {
    return $3eoyd(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $acfeb1ef2847c7f3$var$isBigInt64Array;
function $acfeb1ef2847c7f3$var$isBigUint64Array(value) {
    return $3eoyd(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $acfeb1ef2847c7f3$var$isBigUint64Array;
function $acfeb1ef2847c7f3$var$isMapToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Map]';
}
$acfeb1ef2847c7f3$var$isMapToString.working = typeof Map !== 'undefined' && $acfeb1ef2847c7f3$var$isMapToString(new Map());
function $acfeb1ef2847c7f3$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isMapToString.working ? $acfeb1ef2847c7f3$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $acfeb1ef2847c7f3$var$isMap;
function $acfeb1ef2847c7f3$var$isSetToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Set]';
}
$acfeb1ef2847c7f3$var$isSetToString.working = typeof Set !== 'undefined' && $acfeb1ef2847c7f3$var$isSetToString(new Set());
function $acfeb1ef2847c7f3$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isSetToString.working ? $acfeb1ef2847c7f3$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $acfeb1ef2847c7f3$var$isSet;
function $acfeb1ef2847c7f3$var$isWeakMapToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WeakMap]';
}
$acfeb1ef2847c7f3$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $acfeb1ef2847c7f3$var$isWeakMapToString(new WeakMap());
function $acfeb1ef2847c7f3$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isWeakMapToString.working ? $acfeb1ef2847c7f3$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $acfeb1ef2847c7f3$var$isWeakMap;
function $acfeb1ef2847c7f3$var$isWeakSetToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WeakSet]';
}
$acfeb1ef2847c7f3$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $acfeb1ef2847c7f3$var$isWeakSetToString(new WeakSet());
function $acfeb1ef2847c7f3$var$isWeakSet(value) {
    return $acfeb1ef2847c7f3$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $acfeb1ef2847c7f3$var$isWeakSet;
function $acfeb1ef2847c7f3$var$isArrayBufferToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$acfeb1ef2847c7f3$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $acfeb1ef2847c7f3$var$isArrayBufferToString(new ArrayBuffer());
function $acfeb1ef2847c7f3$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isArrayBufferToString.working ? $acfeb1ef2847c7f3$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $acfeb1ef2847c7f3$var$isArrayBuffer;
function $acfeb1ef2847c7f3$var$isDataViewToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object DataView]';
}
$acfeb1ef2847c7f3$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $acfeb1ef2847c7f3$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $acfeb1ef2847c7f3$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isDataViewToString.working ? $acfeb1ef2847c7f3$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $acfeb1ef2847c7f3$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $acfeb1ef2847c7f3$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $acfeb1ef2847c7f3$var$isSharedArrayBuffer(value) {
    if (typeof $acfeb1ef2847c7f3$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working === 'undefined') $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working = $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(new $acfeb1ef2847c7f3$var$SharedArrayBufferCopy());
    return $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working ? $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(value) : value instanceof $acfeb1ef2847c7f3$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $acfeb1ef2847c7f3$var$isSharedArrayBuffer;
function $acfeb1ef2847c7f3$var$isAsyncFunction(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $acfeb1ef2847c7f3$var$isAsyncFunction;
function $acfeb1ef2847c7f3$var$isMapIterator(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $acfeb1ef2847c7f3$var$isMapIterator;
function $acfeb1ef2847c7f3$var$isSetIterator(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $acfeb1ef2847c7f3$var$isSetIterator;
function $acfeb1ef2847c7f3$var$isGeneratorObject(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $acfeb1ef2847c7f3$var$isGeneratorObject;
function $acfeb1ef2847c7f3$var$isWebAssemblyCompiledModule(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $acfeb1ef2847c7f3$var$isWebAssemblyCompiledModule;
function $acfeb1ef2847c7f3$var$isNumberObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$numberValue);
}
module.exports.isNumberObject = $acfeb1ef2847c7f3$var$isNumberObject;
function $acfeb1ef2847c7f3$var$isStringObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$stringValue);
}
module.exports.isStringObject = $acfeb1ef2847c7f3$var$isStringObject;
function $acfeb1ef2847c7f3$var$isBooleanObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$booleanValue);
}
module.exports.isBooleanObject = $acfeb1ef2847c7f3$var$isBooleanObject;
function $acfeb1ef2847c7f3$var$isBigIntObject(value) {
    return $acfeb1ef2847c7f3$var$BigIntSupported && $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$bigIntValue);
}
module.exports.isBigIntObject = $acfeb1ef2847c7f3$var$isBigIntObject;
function $acfeb1ef2847c7f3$var$isSymbolObject(value) {
    return $acfeb1ef2847c7f3$var$SymbolSupported && $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$symbolValue);
}
module.exports.isSymbolObject = $acfeb1ef2847c7f3$var$isSymbolObject;
function $acfeb1ef2847c7f3$var$isBoxedPrimitive(value) {
    return $acfeb1ef2847c7f3$var$isNumberObject(value) || $acfeb1ef2847c7f3$var$isStringObject(value) || $acfeb1ef2847c7f3$var$isBooleanObject(value) || $acfeb1ef2847c7f3$var$isBigIntObject(value) || $acfeb1ef2847c7f3$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $acfeb1ef2847c7f3$var$isBoxedPrimitive;
function $acfeb1ef2847c7f3$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($acfeb1ef2847c7f3$var$isArrayBuffer(value) || $acfeb1ef2847c7f3$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $acfeb1ef2847c7f3$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("8NKMi", function(module, exports) {
'use strict';

var $66872f7ca248cb6e$var$hasToStringTag = (parcelRequire("5nSZG"))();

var $2TUjA = parcelRequire("2TUjA");
var $66872f7ca248cb6e$var$$toString = $2TUjA('Object.prototype.toString');
var $66872f7ca248cb6e$var$isStandardArguments = function isArguments(value) {
    if ($66872f7ca248cb6e$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $66872f7ca248cb6e$var$$toString(value) === '[object Arguments]';
};
var $66872f7ca248cb6e$var$isLegacyArguments = function isArguments(value) {
    if ($66872f7ca248cb6e$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $66872f7ca248cb6e$var$$toString(value) !== '[object Array]' && $66872f7ca248cb6e$var$$toString(value.callee) === '[object Function]';
};
var $66872f7ca248cb6e$var$supportsStandardArguments = function() {
    return $66872f7ca248cb6e$var$isStandardArguments(arguments);
}();
$66872f7ca248cb6e$var$isStandardArguments.isLegacyArguments = $66872f7ca248cb6e$var$isLegacyArguments; // for tests
module.exports = $66872f7ca248cb6e$var$supportsStandardArguments ? $66872f7ca248cb6e$var$isStandardArguments : $66872f7ca248cb6e$var$isLegacyArguments;

});
parcelRegister("5nSZG", function(module, exports) {
'use strict';

var $cwWvF = parcelRequire("cwWvF");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $cwWvF() && !!Symbol.toStringTag;
};

});

parcelRegister("2TUjA", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $6zl1T = parcelRequire("6zl1T");
var $21cc66c4c492aea4$var$$indexOf = $6zl1T($1b3Ts('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1b3Ts(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $21cc66c4c492aea4$var$$indexOf(name, '.prototype.') > -1) return $6zl1T(intrinsic);
    return intrinsic;
};

});
parcelRegister("6zl1T", function(module, exports) {
'use strict';

var $fSty5 = parcelRequire("fSty5");

var $1Yj66 = parcelRequire("1Yj66");

var $giui0 = parcelRequire("giui0");

var $1w5ZU = parcelRequire("1w5ZU");
module.exports = function callBind(originalFunction) {
    var func = $giui0(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $fSty5(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($1Yj66) $1Yj66(module.exports, 'apply', {
    value: $1w5ZU
});
else module.exports.apply = $1w5ZU;

});
parcelRegister("fSty5", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $gAEXI = parcelRequire("gAEXI");

var $b8f2d1ef0d4df03e$var$hasDescriptors = (parcelRequire("9ndBI"))();

var $kwOoE = parcelRequire("kwOoE");

var $imbfI = parcelRequire("imbfI");
var $b8f2d1ef0d4df03e$var$$floor = $1b3Ts('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $imbfI('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $b8f2d1ef0d4df03e$var$$floor(length) !== length) throw new $imbfI('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $kwOoE) {
        var desc = $kwOoE(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b8f2d1ef0d4df03e$var$hasDescriptors) $gAEXI(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $gAEXI(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("gAEXI", function(module, exports) {
'use strict';

var $1Yj66 = parcelRequire("1Yj66");

var $bqoCM = parcelRequire("bqoCM");

var $imbfI = parcelRequire("imbfI");

var $kwOoE = parcelRequire("kwOoE");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $imbfI('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $imbfI('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $imbfI('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $imbfI('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $imbfI('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $imbfI('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$kwOoE && $kwOoE(obj, property);
    if ($1Yj66) $1Yj66(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $bqoCM('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9ndBI", function(module, exports) {
'use strict';

var $1Yj66 = parcelRequire("1Yj66");
var $6d30d12bc8205bd1$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$1Yj66;
};
$6d30d12bc8205bd1$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$1Yj66) return null;
    try {
        return $1Yj66([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6d30d12bc8205bd1$var$hasPropertyDescriptors;

});


parcelRegister("1w5ZU", function(module, exports) {
'use strict';

var $inBv6 = parcelRequire("inBv6");

var $gJ8ML = parcelRequire("gJ8ML");

var $9xm9a = parcelRequire("9xm9a");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $9xm9a($inBv6, $gJ8ML, arguments);
};

});




parcelRegister("7qnIS", function(module, exports) {
'use strict';
var $567d5cfb22b1b184$var$toStr = Object.prototype.toString;
var $567d5cfb22b1b184$var$fnToStr = Function.prototype.toString;
var $567d5cfb22b1b184$var$isFnRegex = /^\s*(?:function)?\*/;

var $567d5cfb22b1b184$var$hasToStringTag = (parcelRequire("5nSZG"))();
var $567d5cfb22b1b184$var$getProto = Object.getPrototypeOf;
var $567d5cfb22b1b184$var$getGeneratorFunc = function() {
    if (!$567d5cfb22b1b184$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $567d5cfb22b1b184$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($567d5cfb22b1b184$var$isFnRegex.test($567d5cfb22b1b184$var$fnToStr.call(fn))) return true;
    if (!$567d5cfb22b1b184$var$hasToStringTag) {
        var str = $567d5cfb22b1b184$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$567d5cfb22b1b184$var$getProto) return false;
    if (typeof $567d5cfb22b1b184$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $567d5cfb22b1b184$var$getGeneratorFunc();
        $567d5cfb22b1b184$var$GeneratorFunction = generatorFunc ? $567d5cfb22b1b184$var$getProto(generatorFunc) : false;
    }
    return $567d5cfb22b1b184$var$getProto(fn) === $567d5cfb22b1b184$var$GeneratorFunction;
};

});

parcelRegister("3eoyd", function(module, exports) {
'use strict';

var $9xfpK = parcelRequire("9xfpK");

var $4DPeP = parcelRequire("4DPeP");

var $6zl1T = parcelRequire("6zl1T");

var $f8M6V = parcelRequire("f8M6V");

var $kwOoE = parcelRequire("kwOoE");

var $9SzeH = parcelRequire("9SzeH");
var $25a5b9308bd94906$var$$toString = $f8M6V('Object.prototype.toString');

var $25a5b9308bd94906$var$hasToStringTag = (parcelRequire("5nSZG"))();
var $25a5b9308bd94906$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $25a5b9308bd94906$var$typedArrays = $4DPeP();
var $25a5b9308bd94906$var$$slice = $f8M6V('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $25a5b9308bd94906$var$$indexOf = $f8M6V('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $25a5b9308bd94906$var$cache = {
    __proto__: null
};
if ($25a5b9308bd94906$var$hasToStringTag && $kwOoE && $9SzeH) $9xfpK($25a5b9308bd94906$var$typedArrays, function(typedArray) {
    var arr = new $25a5b9308bd94906$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $9SzeH) {
        var proto = $9SzeH(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $kwOoE(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $9SzeH(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $kwOoE(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $25a5b9308bd94906$var$cache['$' + typedArray] = $6zl1T(descriptor.get);
    }
});
else $9xfpK($25a5b9308bd94906$var$typedArrays, function(typedArray) {
    var arr = new $25a5b9308bd94906$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $25a5b9308bd94906$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $6zl1T(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $25a5b9308bd94906$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $9xfpK(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $25a5b9308bd94906$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $25a5b9308bd94906$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $25a5b9308bd94906$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $9xfpK(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $25a5b9308bd94906$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $25a5b9308bd94906$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$25a5b9308bd94906$var$hasToStringTag) {
        /** @type {string} */ var tag = $25a5b9308bd94906$var$$slice($25a5b9308bd94906$var$$toString(value), 8, -1);
        if ($25a5b9308bd94906$var$$indexOf($25a5b9308bd94906$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $25a5b9308bd94906$var$trySlices(value);
    }
    if (!$kwOoE) return null;
     // unknown engine
    return $25a5b9308bd94906$var$tryTypedArrays(value);
};

});
parcelRegister("9xfpK", function(module, exports) {
'use strict';

var $81Pfa = parcelRequire("81Pfa");
var $6f1327188da2d457$var$toStr = Object.prototype.toString;
var $6f1327188da2d457$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($6f1327188da2d457$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($6f1327188da2d457$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $6f1327188da2d457$var$isArray(x) {
    return $6f1327188da2d457$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$81Pfa(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($6f1327188da2d457$var$isArray(list)) $6f1327188da2d457$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $6f1327188da2d457$var$forEachString(list, iterator, receiver);
    else $6f1327188da2d457$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("81Pfa", function(module, exports) {
'use strict';
var $5d862aa4803ed1a0$var$fnToStr = Function.prototype.toString;
var $5d862aa4803ed1a0$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $5d862aa4803ed1a0$var$badArrayLike;
var $5d862aa4803ed1a0$var$isCallableMarker;
if (typeof $5d862aa4803ed1a0$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $5d862aa4803ed1a0$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $5d862aa4803ed1a0$var$isCallableMarker;
        }
    });
    $5d862aa4803ed1a0$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $5d862aa4803ed1a0$var$reflectApply(function() {
        throw 42;
    }, null, $5d862aa4803ed1a0$var$badArrayLike);
} catch (_) {
    if (_ !== $5d862aa4803ed1a0$var$isCallableMarker) $5d862aa4803ed1a0$var$reflectApply = null;
}
else $5d862aa4803ed1a0$var$reflectApply = null;
var $5d862aa4803ed1a0$var$constructorRegex = /^\s*class\b/;
var $5d862aa4803ed1a0$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $5d862aa4803ed1a0$var$fnToStr.call(value);
        return $5d862aa4803ed1a0$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $5d862aa4803ed1a0$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($5d862aa4803ed1a0$var$isES6ClassFn(value)) return false;
        $5d862aa4803ed1a0$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $5d862aa4803ed1a0$var$toStr = Object.prototype.toString;
var $5d862aa4803ed1a0$var$objectClass = '[object Object]';
var $5d862aa4803ed1a0$var$fnClass = '[object Function]';
var $5d862aa4803ed1a0$var$genClass = '[object GeneratorFunction]';
var $5d862aa4803ed1a0$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $5d862aa4803ed1a0$var$ddaClass2 = '[object HTML document.all class]';
var $5d862aa4803ed1a0$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $5d862aa4803ed1a0$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $5d862aa4803ed1a0$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $5d862aa4803ed1a0$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $5d862aa4803ed1a0$var$all = document.all;
    if ($5d862aa4803ed1a0$var$toStr.call($5d862aa4803ed1a0$var$all) === $5d862aa4803ed1a0$var$toStr.call(document.all)) $5d862aa4803ed1a0$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($5d862aa4803ed1a0$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $5d862aa4803ed1a0$var$toStr.call(value);
            return (str === $5d862aa4803ed1a0$var$ddaClass || str === $5d862aa4803ed1a0$var$ddaClass2 || str === $5d862aa4803ed1a0$var$ddaClass3 // opera 12.16
             || str === $5d862aa4803ed1a0$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $5d862aa4803ed1a0$var$reflectApply ? function isCallable(value) {
    if ($5d862aa4803ed1a0$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $5d862aa4803ed1a0$var$reflectApply(value, null, $5d862aa4803ed1a0$var$badArrayLike);
    } catch (e) {
        if (e !== $5d862aa4803ed1a0$var$isCallableMarker) return false;
    }
    return !$5d862aa4803ed1a0$var$isES6ClassFn(value) && $5d862aa4803ed1a0$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($5d862aa4803ed1a0$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($5d862aa4803ed1a0$var$hasToStringTag) return $5d862aa4803ed1a0$var$tryFunctionObject(value);
    if ($5d862aa4803ed1a0$var$isES6ClassFn(value)) return false;
    var strClass = $5d862aa4803ed1a0$var$toStr.call(value);
    if (strClass !== $5d862aa4803ed1a0$var$fnClass && strClass !== $5d862aa4803ed1a0$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $5d862aa4803ed1a0$var$tryFunctionObject(value);
};

});


parcelRegister("4DPeP", function(module, exports) {
'use strict';

var $fCSU3 = parcelRequire("fCSU3");
var $36128cca598aa228$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $fCSU3.length; i++)if (typeof $36128cca598aa228$var$g[$fCSU3[i]] === 'function') // @ts-expect-error
    out[out.length] = $fCSU3[i];
    return out;
};

});
parcelRegister("fCSU3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("cC7Tq", function(module, exports) {
'use strict';

var $3eoyd = parcelRequire("3eoyd");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$3eoyd(value);
};

});


parcelRegister("fMvDf", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lpcNn", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("jc4ou", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $igDjg = parcelRequire("igDjg");
'use strict';
function $df928be34e98853c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df928be34e98853c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df928be34e98853c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $df928be34e98853c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df928be34e98853c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df928be34e98853c$var$_defineProperty(obj, key, value) {
    key = $df928be34e98853c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $df928be34e98853c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $df928be34e98853c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $df928be34e98853c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $df928be34e98853c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $df928be34e98853c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $df928be34e98853c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $df928be34e98853c$var$_toPropertyKey(arg) {
    var key = $df928be34e98853c$var$_toPrimitive(arg, "string");
    return $df928be34e98853c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $df928be34e98853c$var$_toPrimitive(input, hint) {
    if ($df928be34e98853c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($df928be34e98853c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $df928be34e98853c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $df928be34e98853c$var$_setPrototypeOf(subClass, superClass);
}
function $df928be34e98853c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $df928be34e98853c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $df928be34e98853c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $df928be34e98853c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $df928be34e98853c$var$_possibleConstructorReturn(this, result);
    };
}
function $df928be34e98853c$var$_possibleConstructorReturn(self, call) {
    if (call && ($df928be34e98853c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $df928be34e98853c$var$_assertThisInitialized(self);
}
function $df928be34e98853c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $df928be34e98853c$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $df928be34e98853c$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$df928be34e98853c$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $df928be34e98853c$var$_construct(Class, arguments, $df928be34e98853c$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $df928be34e98853c$var$_setPrototypeOf(Wrapper, Class);
    };
    return $df928be34e98853c$var$_wrapNativeSuper(Class);
}
function $df928be34e98853c$var$_construct(Parent, args, Class) {
    if ($df928be34e98853c$var$_isNativeReflectConstruct()) $df928be34e98853c$var$_construct = Reflect.construct.bind();
    else $df928be34e98853c$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $df928be34e98853c$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $df928be34e98853c$var$_construct.apply(null, arguments);
}
function $df928be34e98853c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $df928be34e98853c$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $df928be34e98853c$var$_setPrototypeOf(o, p) {
    $df928be34e98853c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $df928be34e98853c$var$_setPrototypeOf(o, p);
}
function $df928be34e98853c$var$_getPrototypeOf(o) {
    $df928be34e98853c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $df928be34e98853c$var$_getPrototypeOf(o);
}
function $df928be34e98853c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $df928be34e98853c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $df928be34e98853c$var$_typeof(o);
}

var $7WF8Y = parcelRequire("7WF8Y");
var $df928be34e98853c$var$inspect = $7WF8Y.inspect;

var $9Ej6r = parcelRequire("9Ej6r");
var $df928be34e98853c$var$ERR_INVALID_ARG_TYPE = $9Ej6r.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $df928be34e98853c$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $df928be34e98853c$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $df928be34e98853c$var$blue = '';
var $df928be34e98853c$var$green = '';
var $df928be34e98853c$var$red = '';
var $df928be34e98853c$var$white = '';
var $df928be34e98853c$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $df928be34e98853c$var$kMaxShortLength = 10;
function $df928be34e98853c$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $df928be34e98853c$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $df928be34e98853c$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $df928be34e98853c$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $df928be34e98853c$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $df928be34e98853c$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $df928be34e98853c$var$_typeof(actual) === 'object' && $df928be34e98853c$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $df928be34e98853c$var$kMaxShortLength) {
            if (($df928be34e98853c$var$_typeof(actual) !== 'object' || actual === null) && ($df928be34e98853c$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($df928be34e98853c$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $igDjg.stderr && $igDjg.stderr.isTTY ? $igDjg.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($df928be34e98853c$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($df928be34e98853c$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $df928be34e98853c$var$kReadableOperator[operator] + "\n".concat($df928be34e98853c$var$green, "+ actual").concat($df928be34e98853c$var$white, " ").concat($df928be34e98853c$var$red, "- expected").concat($df928be34e98853c$var$white);
    var skippedMsg = " ".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($df928be34e98853c$var$red, "-").concat($df928be34e98853c$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($df928be34e98853c$var$green, "+").concat($df928be34e98853c$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$df928be34e98853c$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $df928be34e98853c$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($df928be34e98853c$var$green, "+").concat($df928be34e98853c$var$white, " ").concat(actualLine);
                other += "\n".concat($df928be34e98853c$var$red, "-").concat($df928be34e98853c$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white).concat(other, "\n") + "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $df928be34e98853c$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $df928be34e98853c$var$_inherits(AssertionError, _Error);
    var _super = $df928be34e98853c$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $df928be34e98853c$var$_classCallCheck(this, AssertionError);
        if ($df928be34e98853c$var$_typeof(options) !== 'object' || options === null) throw new $df928be34e98853c$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($igDjg.stderr && $igDjg.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($igDjg.stderr && $igDjg.stderr.getColorDepth && $igDjg.stderr.getColorDepth() !== 1) {
                    $df928be34e98853c$var$blue = "\x1B[34m";
                    $df928be34e98853c$var$green = "\x1B[32m";
                    $df928be34e98853c$var$white = "\x1B[39m";
                    $df928be34e98853c$var$red = "\x1B[31m";
                } else {
                    $df928be34e98853c$var$blue = '';
                    $df928be34e98853c$var$green = '';
                    $df928be34e98853c$var$white = '';
                    $df928be34e98853c$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($df928be34e98853c$var$_typeof(actual) === 'object' && actual !== null && $df928be34e98853c$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $df928be34e98853c$var$copyError(actual);
                expected = $df928be34e98853c$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $df928be34e98853c$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $df928be34e98853c$var$kReadableOperator[operator];
                var res = $df928be34e98853c$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $df928be34e98853c$var$_typeof(actual) === 'object' && actual !== null) base = $df928be34e98853c$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $df928be34e98853c$var$inspectValue(actual);
                var other = '';
                var knownOperators = $df928be34e98853c$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($df928be34e98853c$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($df928be34e98853c$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($df928be34e98853c$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($df928be34e98853c$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $df928be34e98853c$var$_possibleConstructorReturn(_this);
    }
    $df928be34e98853c$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $df928be34e98853c$var$inspect(this, $df928be34e98853c$var$_objectSpread($df928be34e98853c$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $df928be34e98853c$var$_wrapNativeSuper(Error), $df928be34e98853c$var$inspect.custom);
module.exports = $df928be34e98853c$var$AssertionError;

});

parcelRegister("10hUt", function(module, exports) {
'use strict';

var $9CbYT = parcelRequire("9CbYT");
var $0bb3af0d2c3ea2e8$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $0bb3af0d2c3ea2e8$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $9CbYT;
    if ($0bb3af0d2c3ea2e8$var$lacksProperEnumerationOrder()) return $9CbYT;
    if ($0bb3af0d2c3ea2e8$var$assignHasPendingExceptions()) return $9CbYT;
    return Object.assign;
};

});
parcelRegister("9CbYT", function(module, exports) {
'use strict';

var $iJBzN = parcelRequire("iJBzN");

var $7000f4db814cc860$var$hasSymbols = (parcelRequire("cwWvF"))();

var $f8M6V = parcelRequire("f8M6V");

var $cAzwJ = parcelRequire("cAzwJ");
var $7000f4db814cc860$var$$push = $f8M6V('Array.prototype.push');
var $7000f4db814cc860$var$$propIsEnumerable = $f8M6V('Object.prototype.propertyIsEnumerable');
var $7000f4db814cc860$var$originalGetSymbols = $7000f4db814cc860$var$hasSymbols ? $cAzwJ.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $cAzwJ(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $cAzwJ(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $iJBzN(from);
        var getSymbols = $7000f4db814cc860$var$hasSymbols && ($cAzwJ.getOwnPropertySymbols || $7000f4db814cc860$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($7000f4db814cc860$var$$propIsEnumerable(from, key)) $7000f4db814cc860$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($7000f4db814cc860$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("iJBzN", function(module, exports) {
'use strict';
var $da3993d5c090e106$var$slice = Array.prototype.slice;

var $dwUql = parcelRequire("dwUql");
var $da3993d5c090e106$var$origKeys = Object.keys;

var $da3993d5c090e106$var$keysShim = $da3993d5c090e106$var$origKeys ? function keys(o) {
    return $da3993d5c090e106$var$origKeys(o);
} : (parcelRequire("2xgn7"));
var $da3993d5c090e106$var$originalKeys = Object.keys;
$da3993d5c090e106$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($dwUql(object)) return $da3993d5c090e106$var$originalKeys($da3993d5c090e106$var$slice.call(object));
            return $da3993d5c090e106$var$originalKeys(object);
        };
    } else Object.keys = $da3993d5c090e106$var$keysShim;
    return Object.keys || $da3993d5c090e106$var$keysShim;
};
module.exports = $da3993d5c090e106$var$keysShim;

});
parcelRegister("dwUql", function(module, exports) {
'use strict';
var $9d9a082105a3d623$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $9d9a082105a3d623$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $9d9a082105a3d623$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("2xgn7", function(module, exports) {
'use strict';
var $1d8b5cf8e4b6d4ac$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $1d8b5cf8e4b6d4ac$var$has = Object.prototype.hasOwnProperty;
    var $1d8b5cf8e4b6d4ac$var$toStr = Object.prototype.toString;
    var $1d8b5cf8e4b6d4ac$var$isArgs = (parcelRequire("dwUql")); // eslint-disable-line global-require
    var $1d8b5cf8e4b6d4ac$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $1d8b5cf8e4b6d4ac$var$hasDontEnumBug = !$1d8b5cf8e4b6d4ac$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $1d8b5cf8e4b6d4ac$var$hasProtoEnumBug = $1d8b5cf8e4b6d4ac$var$isEnumerable.call(function() {}, 'prototype');
    var $1d8b5cf8e4b6d4ac$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $1d8b5cf8e4b6d4ac$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $1d8b5cf8e4b6d4ac$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$1d8b5cf8e4b6d4ac$var$excludedKeys['$' + k] && $1d8b5cf8e4b6d4ac$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$1d8b5cf8e4b6d4ac$var$hasAutomationEqualityBug) return $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(o);
        try {
            return $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $1d8b5cf8e4b6d4ac$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $1d8b5cf8e4b6d4ac$var$toStr.call(object) === '[object Function]';
        var isArguments = $1d8b5cf8e4b6d4ac$var$isArgs(object);
        var isString = isObject && $1d8b5cf8e4b6d4ac$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $1d8b5cf8e4b6d4ac$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$1d8b5cf8e4b6d4ac$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $1d8b5cf8e4b6d4ac$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($1d8b5cf8e4b6d4ac$var$hasDontEnumBug) {
            var skipConstructor = $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $1d8b5cf8e4b6d4ac$var$dontEnums.length; ++k)if (!(skipConstructor && $1d8b5cf8e4b6d4ac$var$dontEnums[k] === 'constructor') && $1d8b5cf8e4b6d4ac$var$has.call(object, $1d8b5cf8e4b6d4ac$var$dontEnums[k])) theKeys.push($1d8b5cf8e4b6d4ac$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $1d8b5cf8e4b6d4ac$var$keysShim;

});




parcelRegister("4LgTG", function(module, exports) {
'use strict';

var $6Mteo = parcelRequire("6Mteo");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $6Mteo;
};

});
parcelRegister("6Mteo", function(module, exports) {
'use strict';
var $4efde67e20b2f54e$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4efde67e20b2f54e$var$numberIsNaN(a) && $4efde67e20b2f54e$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("lV95c", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $ff55f7860a99da96$var$_slicedToArray(arr, i) {
    return $ff55f7860a99da96$var$_arrayWithHoles(arr) || $ff55f7860a99da96$var$_iterableToArrayLimit(arr, i) || $ff55f7860a99da96$var$_unsupportedIterableToArray(arr, i) || $ff55f7860a99da96$var$_nonIterableRest();
}
function $ff55f7860a99da96$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ff55f7860a99da96$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ff55f7860a99da96$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ff55f7860a99da96$var$_arrayLikeToArray(o, minLen);
}
function $ff55f7860a99da96$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ff55f7860a99da96$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ff55f7860a99da96$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ff55f7860a99da96$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ff55f7860a99da96$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ff55f7860a99da96$var$_typeof(o);
}
var $ff55f7860a99da96$var$regexFlagsSupported = /a/g.flags !== undefined;
var $ff55f7860a99da96$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $ff55f7860a99da96$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $ff55f7860a99da96$var$objectIs = Object.is ? Object.is : (parcelRequire("gh4Iw"));
var $ff55f7860a99da96$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $ff55f7860a99da96$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("fLjZy"));
function $ff55f7860a99da96$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $ff55f7860a99da96$var$hasOwnProperty = $ff55f7860a99da96$var$uncurryThis(Object.prototype.hasOwnProperty);
var $ff55f7860a99da96$var$propertyIsEnumerable = $ff55f7860a99da96$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $ff55f7860a99da96$var$objectToString = $ff55f7860a99da96$var$uncurryThis(Object.prototype.toString);

var $7WF8Y = parcelRequire("7WF8Y");
var $ff55f7860a99da96$require$_require$types = $7WF8Y.types;
var $ff55f7860a99da96$var$isAnyArrayBuffer = $ff55f7860a99da96$require$_require$types.isAnyArrayBuffer, $ff55f7860a99da96$var$isArrayBufferView = $ff55f7860a99da96$require$_require$types.isArrayBufferView, $ff55f7860a99da96$var$isDate = $ff55f7860a99da96$require$_require$types.isDate, $ff55f7860a99da96$var$isMap = $ff55f7860a99da96$require$_require$types.isMap, $ff55f7860a99da96$var$isRegExp = $ff55f7860a99da96$require$_require$types.isRegExp, $ff55f7860a99da96$var$isSet = $ff55f7860a99da96$require$_require$types.isSet, $ff55f7860a99da96$var$isNativeError = $ff55f7860a99da96$require$_require$types.isNativeError, $ff55f7860a99da96$var$isBoxedPrimitive = $ff55f7860a99da96$require$_require$types.isBoxedPrimitive, $ff55f7860a99da96$var$isNumberObject = $ff55f7860a99da96$require$_require$types.isNumberObject, $ff55f7860a99da96$var$isStringObject = $ff55f7860a99da96$require$_require$types.isStringObject, $ff55f7860a99da96$var$isBooleanObject = $ff55f7860a99da96$require$_require$types.isBooleanObject, $ff55f7860a99da96$var$isBigIntObject = $ff55f7860a99da96$require$_require$types.isBigIntObject, $ff55f7860a99da96$var$isSymbolObject = $ff55f7860a99da96$require$_require$types.isSymbolObject, $ff55f7860a99da96$var$isFloat32Array = $ff55f7860a99da96$require$_require$types.isFloat32Array, $ff55f7860a99da96$var$isFloat64Array = $ff55f7860a99da96$require$_require$types.isFloat64Array;
function $ff55f7860a99da96$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $ff55f7860a99da96$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($ff55f7860a99da96$var$isNonIndex).concat($ff55f7860a99da96$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $ff55f7860a99da96$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $ff55f7860a99da96$var$ONLY_ENUMERABLE = undefined;
var $ff55f7860a99da96$var$kStrict = true;
var $ff55f7860a99da96$var$kLoose = false;
var $ff55f7860a99da96$var$kNoIterator = 0;
var $ff55f7860a99da96$var$kIsArray = 1;
var $ff55f7860a99da96$var$kIsSet = 2;
var $ff55f7860a99da96$var$kIsMap = 3;
// Check if they have the same source and flags
function $ff55f7860a99da96$var$areSimilarRegExps(a, b) {
    return $ff55f7860a99da96$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $ff55f7860a99da96$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $ff55f7860a99da96$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $ff55f7860a99da96$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $ff55f7860a99da96$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $ff55f7860a99da96$var$isEqualBoxedPrimitive(val1, val2) {
    if ($ff55f7860a99da96$var$isNumberObject(val1)) return $ff55f7860a99da96$var$isNumberObject(val2) && $ff55f7860a99da96$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($ff55f7860a99da96$var$isStringObject(val1)) return $ff55f7860a99da96$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($ff55f7860a99da96$var$isBooleanObject(val1)) return $ff55f7860a99da96$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($ff55f7860a99da96$var$isBigIntObject(val1)) return $ff55f7860a99da96$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $ff55f7860a99da96$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $ff55f7860a99da96$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $ff55f7860a99da96$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($ff55f7860a99da96$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $ff55f7860a99da96$var$numberIsNaN(val1) && $ff55f7860a99da96$var$numberIsNaN(val2);
        if ($ff55f7860a99da96$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $ff55f7860a99da96$var$_typeof(val1) !== 'object') {
            if (val2 === null || $ff55f7860a99da96$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $ff55f7860a99da96$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $ff55f7860a99da96$var$objectToString(val1);
    var val2Tag = $ff55f7860a99da96$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val1, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        var keys2 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val2, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$ff55f7860a99da96$var$isMap(val1) && $ff55f7860a99da96$var$isMap(val2) || !$ff55f7860a99da96$var$isSet(val1) && $ff55f7860a99da96$var$isSet(val2)) return false;
    }
    if ($ff55f7860a99da96$var$isDate(val1)) {
        if (!$ff55f7860a99da96$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($ff55f7860a99da96$var$isRegExp(val1)) {
        if (!$ff55f7860a99da96$var$isRegExp(val2) || !$ff55f7860a99da96$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($ff55f7860a99da96$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($ff55f7860a99da96$var$isArrayBufferView(val1)) {
        if (!strict && ($ff55f7860a99da96$var$isFloat32Array(val1) || $ff55f7860a99da96$var$isFloat64Array(val1))) {
            if (!$ff55f7860a99da96$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$ff55f7860a99da96$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $ff55f7860a99da96$var$getOwnNonIndexProperties(val1, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        var _keys2 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val2, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kNoIterator, _keys);
    } else if ($ff55f7860a99da96$var$isSet(val1)) {
        if (!$ff55f7860a99da96$var$isSet(val2) || val1.size !== val2.size) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsSet);
    } else if ($ff55f7860a99da96$var$isMap(val1)) {
        if (!$ff55f7860a99da96$var$isMap(val2) || val1.size !== val2.size) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsMap);
    } else if ($ff55f7860a99da96$var$isAnyArrayBuffer(val1)) {
        if (!$ff55f7860a99da96$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($ff55f7860a99da96$var$isBoxedPrimitive(val1) && !$ff55f7860a99da96$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kNoIterator);
}
function $ff55f7860a99da96$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $ff55f7860a99da96$var$propertyIsEnumerable(val, k);
    });
}
function $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$ff55f7860a99da96$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($ff55f7860a99da96$var$propertyIsEnumerable(val1, key)) {
                    if (!$ff55f7860a99da96$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($ff55f7860a99da96$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $ff55f7860a99da96$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $ff55f7860a99da96$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $ff55f7860a99da96$var$kNoIterator || iterationType === $ff55f7860a99da96$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $ff55f7860a99da96$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $ff55f7860a99da96$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $ff55f7860a99da96$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($ff55f7860a99da96$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim) {
    switch($ff55f7860a99da96$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($ff55f7860a99da96$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $ff55f7860a99da96$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$ff55f7860a99da96$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $ff55f7860a99da96$var$innerDeepEqual(item, curB, false, memo);
}
function $ff55f7860a99da96$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $ff55f7860a99da96$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($ff55f7860a99da96$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$ff55f7860a99da96$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $ff55f7860a99da96$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($ff55f7860a99da96$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$ff55f7860a99da96$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$ff55f7860a99da96$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $ff55f7860a99da96$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $ff55f7860a99da96$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($ff55f7860a99da96$var$innerDeepEqual(key1, key2, strict, memo) && $ff55f7860a99da96$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $ff55f7860a99da96$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $ff55f7860a99da96$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $ff55f7860a99da96$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($ff55f7860a99da96$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$ff55f7860a99da96$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$ff55f7860a99da96$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $ff55f7860a99da96$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $ff55f7860a99da96$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($ff55f7860a99da96$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$ff55f7860a99da96$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$ff55f7860a99da96$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$ff55f7860a99da96$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $ff55f7860a99da96$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $ff55f7860a99da96$var$kIsSet) {
        if (!$ff55f7860a99da96$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $ff55f7860a99da96$var$kIsMap) {
        if (!$ff55f7860a99da96$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $ff55f7860a99da96$var$kIsArray) for(; i < a.length; i++){
        if ($ff55f7860a99da96$var$hasOwnProperty(a, i)) {
            if (!$ff55f7860a99da96$var$hasOwnProperty(b, i) || !$ff55f7860a99da96$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($ff55f7860a99da96$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$ff55f7860a99da96$var$hasOwnProperty(b, key) || !$ff55f7860a99da96$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$ff55f7860a99da96$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$isDeepEqual(val1, val2) {
    return $ff55f7860a99da96$var$innerDeepEqual(val1, val2, $ff55f7860a99da96$var$kLoose);
}
function $ff55f7860a99da96$var$isDeepStrictEqual(val1, val2) {
    return $ff55f7860a99da96$var$innerDeepEqual(val1, val2, $ff55f7860a99da96$var$kStrict);
}
module.exports = {
    isDeepEqual: $ff55f7860a99da96$var$isDeepEqual,
    isDeepStrictEqual: $ff55f7860a99da96$var$isDeepStrictEqual
};

});
parcelRegister("gh4Iw", function(module, exports) {
'use strict';

var $hSIPK = parcelRequire("hSIPK");

var $6zl1T = parcelRequire("6zl1T");

var $6Mteo = parcelRequire("6Mteo");

var $4LgTG = parcelRequire("4LgTG");

var $2fKtp = parcelRequire("2fKtp");
var $bd91e494441fd9ab$var$polyfill = $6zl1T($4LgTG(), Object);
$hSIPK($bd91e494441fd9ab$var$polyfill, {
    getPolyfill: $4LgTG,
    implementation: $6Mteo,
    shim: $2fKtp
});
module.exports = $bd91e494441fd9ab$var$polyfill;

});
parcelRegister("hSIPK", function(module, exports) {
'use strict';

var $iJBzN = parcelRequire("iJBzN");
var $d04a41db78b5c12d$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $d04a41db78b5c12d$var$toStr = Object.prototype.toString;
var $d04a41db78b5c12d$var$concat = Array.prototype.concat;

var $gAEXI = parcelRequire("gAEXI");
var $d04a41db78b5c12d$var$isFunction = function(fn) {
    return typeof fn === 'function' && $d04a41db78b5c12d$var$toStr.call(fn) === '[object Function]';
};

var $d04a41db78b5c12d$var$supportsDescriptors = (parcelRequire("9ndBI"))();
var $d04a41db78b5c12d$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$d04a41db78b5c12d$var$isFunction(predicate) || !predicate()) return;
    }
    if ($d04a41db78b5c12d$var$supportsDescriptors) $gAEXI(object, name, value, true);
    else $gAEXI(object, name, value);
};
var $d04a41db78b5c12d$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $iJBzN(map);
    if ($d04a41db78b5c12d$var$hasSymbols) props = $d04a41db78b5c12d$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$d04a41db78b5c12d$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$d04a41db78b5c12d$var$defineProperties.supportsDescriptors = !!$d04a41db78b5c12d$var$supportsDescriptors;
module.exports = $d04a41db78b5c12d$var$defineProperties;

});

parcelRegister("2fKtp", function(module, exports) {
'use strict';

var $4LgTG = parcelRequire("4LgTG");

var $hSIPK = parcelRequire("hSIPK");
module.exports = function shimObjectIs() {
    var polyfill = $4LgTG();
    $hSIPK(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("fLjZy", function(module, exports) {
'use strict';

var $6zl1T = parcelRequire("6zl1T");

var $hSIPK = parcelRequire("hSIPK");

var $4ehKb = parcelRequire("4ehKb");

var $eh0Ub = parcelRequire("eh0Ub");

var $c4AUD = parcelRequire("c4AUD");
var $b79ac0c428ccfd21$var$polyfill = $6zl1T($eh0Ub(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $hSIPK($b79ac0c428ccfd21$var$polyfill, {
    getPolyfill: $eh0Ub,
    implementation: $4ehKb,
    shim: $c4AUD
});
module.exports = $b79ac0c428ccfd21$var$polyfill;

});
parcelRegister("4ehKb", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("eh0Ub", function(module, exports) {
'use strict';

var $4ehKb = parcelRequire("4ehKb");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $4ehKb;
};

});

parcelRegister("c4AUD", function(module, exports) {
'use strict';

var $hSIPK = parcelRequire("hSIPK");

var $eh0Ub = parcelRequire("eh0Ub");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $eh0Ub();
    $hSIPK(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("esDFm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $a872730e1966eaf0$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $a872730e1966eaf0$var$NotNull;
function $a872730e1966eaf0$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $a872730e1966eaf0$var$Nullable;
function $a872730e1966eaf0$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $a872730e1966eaf0$var$Override;
function $a872730e1966eaf0$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $a872730e1966eaf0$var$SuppressWarnings;

});

parcelRegister("d4sFB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $9841e360291f6c03$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($9841e360291f6c03$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("jY97w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e89ab20be58c2533$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $cNbax = parcelRequire("cNbax");

var $6iuj6 = parcelRequire("6iuj6");

var $esDFm = parcelRequire("esDFm");

var $5EAbA = parcelRequire("5EAbA");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $e89ab20be58c2533$var$BailErrorStrategy extends $cNbax.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $5EAbA.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $6iuj6.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $5EAbA.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "recover", null);
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "recoverInline", null);
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $e89ab20be58c2533$var$BailErrorStrategy;

});
parcelRegister("cNbax", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9502b98abfaa9eda$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9502b98abfaa9eda$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $d7mTm = parcelRequire("d7mTm");

var $6iuj6 = parcelRequire("6iuj6");

var $6og9T = parcelRequire("6og9T");

var $4qcTm = parcelRequire("4qcTm");

var $haz8F = parcelRequire("haz8F");

var $2G93d = parcelRequire("2G93d");

var $esDFm = parcelRequire("esDFm");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $9502b98abfaa9eda$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $17Oz4.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $4qcTm.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $6iuj6.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $d7mTm.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $6og9T.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $17Oz4.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($2G93d.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $9TBHo.ATNStateType.BLOCK_START:
            case $9TBHo.ATNStateType.STAR_BLOCK_START:
            case $9TBHo.ATNStateType.PLUS_BLOCK_START:
            case $9TBHo.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $6iuj6.InputMismatchException(recognizer);
            case $9TBHo.ATNStateType.PLUS_LOOP_BACK:
            case $9TBHo.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $2G93d.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $6iuj6.InputMismatchException(recognizer);
        else throw new $6iuj6.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $haz8F.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $2G93d.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $2G93d.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $2G93d.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $2G93d.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $6og9T.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($2G93d.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $2G93d.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reset", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportError", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "recover", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "sync", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $9502b98abfaa9eda$var$DefaultErrorStrategy;

});
parcelRegister("17Oz4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0d1dab0077cad626$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $esDFm = parcelRequire("esDFm");
const $0d1dab0077cad626$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $0d1dab0077cad626$var$ATNState {
    constructor(){
        this.stateNumber = $0d1dab0077cad626$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $0d1dab0077cad626$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "hashCode", null);
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "equals", null);
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $0d1dab0077cad626$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($0d1dab0077cad626$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("9TBHo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $73467e5304f76889$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($73467e5304f76889$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("d7mTm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $98cdafa8e98c4b36$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $98cdafa8e98c4b36$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");

var $dlxNc = parcelRequire("dlxNc");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $98cdafa8e98c4b36$var$FailedPredicateException = class FailedPredicateException extends $lWPhg.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $dlxNc.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$98cdafa8e98c4b36$var$__decorate([
    $esDFm.NotNull
], $98cdafa8e98c4b36$var$FailedPredicateException, "formatMessage", null);
$98cdafa8e98c4b36$var$FailedPredicateException = $98cdafa8e98c4b36$var$__decorate([
    $98cdafa8e98c4b36$var$__param(0, $esDFm.NotNull)
], $98cdafa8e98c4b36$var$FailedPredicateException);
module.exports.FailedPredicateException = $98cdafa8e98c4b36$var$FailedPredicateException;

});
parcelRegister("lWPhg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $ffa6ca695057706e$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $ffa6ca695057706e$var$RecognitionException;

});

parcelRegister("dlxNc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9b77730a2147488d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9b77730a2147488d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $esDFm = parcelRequire("esDFm");

var $8DW9a = parcelRequire("8DW9a");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $9b77730a2147488d$var$PredicateTransition = class PredicateTransition extends $5sT1a.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $8DW9a.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "serializationType", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "isEpsilon", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "matches", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $9b77730a2147488d$var$PredicateTransition.prototype, "toString", null);
$9b77730a2147488d$var$PredicateTransition = $9b77730a2147488d$var$__decorate([
    $9b77730a2147488d$var$__param(0, $esDFm.NotNull)
], $9b77730a2147488d$var$PredicateTransition);
module.exports.PredicateTransition = $9b77730a2147488d$var$PredicateTransition;

});
parcelRegister("5sT1a", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $i2NOt = parcelRequire("i2NOt");
/**
 *
 * @author Sam Harwell
 */ class $3faa3ead218da507$var$AbstractPredicateTransition extends $i2NOt.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $3faa3ead218da507$var$AbstractPredicateTransition;

});
parcelRegister("i2NOt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d22f0dc3629a2b33$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d22f0dc3629a2b33$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $esDFm = parcelRequire("esDFm");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $d22f0dc3629a2b33$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$d22f0dc3629a2b33$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$d22f0dc3629a2b33$var$__decorate([
    $esDFm.NotNull
], $d22f0dc3629a2b33$var$Transition.prototype, "target", void 0);
$d22f0dc3629a2b33$var$Transition = $d22f0dc3629a2b33$var$__decorate([
    $d22f0dc3629a2b33$var$__param(0, $esDFm.NotNull)
], $d22f0dc3629a2b33$var$Transition);
module.exports.Transition = $d22f0dc3629a2b33$var$Transition;

});


parcelRegister("8DW9a", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $64af120133c02755$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $64af120133c02755$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $fJumX = parcelRequire("fJumX");

var $crbOk = parcelRequire("crbOk");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $g4Hat = parcelRequire("g4Hat");
function $64af120133c02755$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $64af120133c02755$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $64af120133c02755$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($64af120133c02755$var$SemanticContext._NONE === undefined) $64af120133c02755$var$SemanticContext._NONE = new $64af120133c02755$var$SemanticContext.Predicate();
        return $64af120133c02755$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $64af120133c02755$var$SemanticContext.NONE) return b;
        if (b === $64af120133c02755$var$SemanticContext.NONE) return a;
        let result = new $64af120133c02755$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $64af120133c02755$var$SemanticContext.NONE || b === $64af120133c02755$var$SemanticContext.NONE) return $64af120133c02755$var$SemanticContext.NONE;
        let result = new $64af120133c02755$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $64af120133c02755$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $i99P2.MurmurHash.initialize();
            hashCode = $i99P2.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $i99P2.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $i99P2.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $i99P2.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $64af120133c02755$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $i99P2.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $g4Hat.join(this.opnds, "&&");
        }
    };
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "operands", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "toString", null);
    AND = $64af120133c02755$var$__decorate([
        $64af120133c02755$var$__param(0, $esDFm.NotNull),
        $64af120133c02755$var$__param(1, $esDFm.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $64af120133c02755$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $i99P2.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $g4Hat.join(this.opnds, "||");
        }
    };
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "operands", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "toString", null);
    OR = $64af120133c02755$var$__decorate([
        $64af120133c02755$var$__param(0, $esDFm.NotNull),
        $64af120133c02755$var$__param(1, $esDFm.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($64af120133c02755$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("fJumX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b7429dac6dd82255$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b7429dac6dd82255$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $ikPYR = parcelRequire("ikPYR");

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $b7429dac6dd82255$var$INITAL_CAPACITY = 16; // must be power of 2
const $b7429dac6dd82255$var$LOAD_FACTOR = 0.75;
class $b7429dac6dd82255$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $b7429dac6dd82255$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($b7429dac6dd82255$var$INITAL_CAPACITY * $b7429dac6dd82255$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $b7429dac6dd82255$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $ikPYR.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $i99P2.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $i99P2.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $b7429dac6dd82255$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $b7429dac6dd82255$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $gwEr2(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $b7429dac6dd82255$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($b7429dac6dd82255$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($b7429dac6dd82255$var$INITAL_CAPACITY * $b7429dac6dd82255$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$b7429dac6dd82255$var$__decorate([
    $esDFm.NotNull
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "comparator", void 0);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "hashCode", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "equals", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "add", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "size", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "isEmpty", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "contains", null);
$b7429dac6dd82255$var$__decorate([
    $b7429dac6dd82255$var$__param(0, $esDFm.Nullable)
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "containsFast", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, Symbol.iterator, null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "toArray", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "containsAll", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "addAll", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "clear", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "toString", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.SuppressWarnings("unchecked")
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "asElementType", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.SuppressWarnings("unchecked")
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $b7429dac6dd82255$var$Array2DHashSet;

});
parcelRegister("ikPYR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d5926a811e8c9536$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");

var $73sQO = parcelRequire("73sQO");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $d5926a811e8c9536$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $i99P2.MurmurHash.hashCode([
            obj
        ]);
        else return $73sQO.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $73sQO.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$d5926a811e8c9536$var$DefaultEqualityComparator.INSTANCE = new $d5926a811e8c9536$var$DefaultEqualityComparator();
$d5926a811e8c9536$var$__decorate([
    $esDFm.Override
], $d5926a811e8c9536$var$DefaultEqualityComparator.prototype, "hashCode", null);
$d5926a811e8c9536$var$__decorate([
    $esDFm.Override
], $d5926a811e8c9536$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $d5926a811e8c9536$var$DefaultEqualityComparator;

});
parcelRegister("i99P2", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $d360afbc1084b137$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($d360afbc1084b137$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("73sQO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $522f31675a8ff093$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $522f31675a8ff093$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$522f31675a8ff093$var$ObjectEqualityComparator.INSTANCE = new $522f31675a8ff093$var$ObjectEqualityComparator();
$522f31675a8ff093$var$__decorate([
    $esDFm.Override
], $522f31675a8ff093$var$ObjectEqualityComparator.prototype, "hashCode", null);
$522f31675a8ff093$var$__decorate([
    $esDFm.Override
], $522f31675a8ff093$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $522f31675a8ff093$var$ObjectEqualityComparator;

});



parcelRegister("crbOk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $90e12b08060db581$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");

var $73sQO = parcelRequire("73sQO");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $90e12b08060db581$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $i99P2.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$73sQO.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$90e12b08060db581$var$ArrayEqualityComparator.INSTANCE = new $90e12b08060db581$var$ArrayEqualityComparator();
$90e12b08060db581$var$__decorate([
    $esDFm.Override
], $90e12b08060db581$var$ArrayEqualityComparator.prototype, "hashCode", null);
$90e12b08060db581$var$__decorate([
    $esDFm.Override
], $90e12b08060db581$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $90e12b08060db581$var$ArrayEqualityComparator;

});

parcelRegister("g4Hat", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $bb3e8152647e0789$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $bb3e8152647e0789$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $bb3e8152647e0789$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $bb3e8152647e0789$var$join;
function $bb3e8152647e0789$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $bb3e8152647e0789$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $bb3e8152647e0789$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $bb3e8152647e0789$var$toMap;
function $bb3e8152647e0789$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $bb3e8152647e0789$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("6iuj6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $495beedc9f8e5b02$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $495beedc9f8e5b02$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $495beedc9f8e5b02$var$InputMismatchException = class InputMismatchException extends $lWPhg.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$495beedc9f8e5b02$var$InputMismatchException = $495beedc9f8e5b02$var$__decorate([
    $495beedc9f8e5b02$var$__param(0, $esDFm.NotNull)
], $495beedc9f8e5b02$var$InputMismatchException);
module.exports.InputMismatchException = $495beedc9f8e5b02$var$InputMismatchException;

});

parcelRegister("6og9T", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4a7184b7a0008122$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4a7184b7a0008122$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $crbOk = parcelRequire("crbOk");

var $eOyS9 = parcelRequire("eOyS9");

var $4Q2DM = parcelRequire("4Q2DM");

var $gTQRB = parcelRequire("gTQRB");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $4a7184b7a0008122$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET = $4a7184b7a0008122$var$IntervalSet.of($gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE);
            $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($4a7184b7a0008122$var$IntervalSet._EMPTY_SET == null) {
            $4a7184b7a0008122$var$IntervalSet._EMPTY_SET = new $4a7184b7a0008122$var$IntervalSet();
            $4a7184b7a0008122$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $4a7184b7a0008122$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $4a7184b7a0008122$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($4Q2DM.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $4a7184b7a0008122$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $4a7184b7a0008122$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($4a7184b7a0008122$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $4a7184b7a0008122$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $4a7184b7a0008122$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $4a7184b7a0008122$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $4a7184b7a0008122$var$IntervalSet(this._intervals);
        if (a instanceof $4a7184b7a0008122$var$IntervalSet) return $4a7184b7a0008122$var$IntervalSet.subtract(this, a);
        let other = new $4a7184b7a0008122$var$IntervalSet();
        other.addAll(a);
        return $4a7184b7a0008122$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $4a7184b7a0008122$var$IntervalSet();
        let result = new $4a7184b7a0008122$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $4Q2DM.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $4Q2DM.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $4a7184b7a0008122$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $4a7184b7a0008122$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $4a7184b7a0008122$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $i99P2.MurmurHash.update(hash, I.a);
            hash = $i99P2.MurmurHash.update(hash, I.b);
        }
        hash = $i99P2.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $4a7184b7a0008122$var$IntervalSet)) return false;
        return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $2G93d.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $2G93d.Token.EOF) return "<EOF>";
        else if (a === $2G93d.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $eOyS9.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $4Q2DM.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $4Q2DM.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $4Q2DM.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "addAll", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "complement", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "subtract", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "or", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "and", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "contains", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "isNil", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "hashCode", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "equals", null);
$4a7184b7a0008122$var$__decorate([
    $4a7184b7a0008122$var$__param(0, $esDFm.NotNull)
], $4a7184b7a0008122$var$IntervalSet.prototype, "toStringVocabulary", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull,
    $4a7184b7a0008122$var$__param(0, $esDFm.NotNull)
], $4a7184b7a0008122$var$IntervalSet.prototype, "elementName", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "size", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "remove", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull
], $4a7184b7a0008122$var$IntervalSet, "of", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull
], $4a7184b7a0008122$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $4a7184b7a0008122$var$IntervalSet;

});
parcelRegister("eOyS9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ac90c92821ee5cb0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $yEtb9 = parcelRequire("yEtb9");

var $esDFm = parcelRequire("esDFm");
const $ac90c92821ee5cb0$var$EMPTY_DATA = new Int32Array(0);
const $ac90c92821ee5cb0$var$INITIAL_SIZE = 4;
const $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $ac90c92821ee5cb0$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $ac90c92821ee5cb0$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $ac90c92821ee5cb0$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $ac90c92821ee5cb0$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $yEtb9.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $ac90c92821ee5cb0$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE) newLength = $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.NotNull
], $ac90c92821ee5cb0$var$IntegerList.prototype, "_data", void 0);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "equals", null);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "hashCode", null);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $ac90c92821ee5cb0$var$IntegerList;

});
parcelRegister("yEtb9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $06829183f5129d07$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($06829183f5129d07$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("4Q2DM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $385e111c1c7cf931$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $esDFm = parcelRequire("esDFm");
const $385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $385e111c1c7cf931$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $385e111c1c7cf931$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE) return new $385e111c1c7cf931$var$Interval(a, b);
        if ($385e111c1c7cf931$var$Interval.cache[a] == null) $385e111c1c7cf931$var$Interval.cache[a] = new $385e111c1c7cf931$var$Interval(a, a);
        return $385e111c1c7cf931$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $385e111c1c7cf931$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $385e111c1c7cf931$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $385e111c1c7cf931$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $385e111c1c7cf931$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $385e111c1c7cf931$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$385e111c1c7cf931$var$Interval._INVALID = new $385e111c1c7cf931$var$Interval(-1, -2);
$385e111c1c7cf931$var$Interval.cache = new Array($385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE + 1);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "equals", null);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "hashCode", null);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "toString", null);
module.exports.Interval = $385e111c1c7cf931$var$Interval;

});

parcelRegister("gTQRB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c4daca03ecd98d11$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $arOt9 = parcelRequire("arOt9");

var $9AKkH = parcelRequire("9AKkH");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $kkkg9 = parcelRequire("kkkg9");

var $6Npyx = parcelRequire("6Npyx");

var $esDFm = parcelRequire("esDFm");

var $24a4y = parcelRequire("24a4y");

var $2G93d = parcelRequire("2G93d");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $c4daca03ecd98d11$var$Lexer extends $24a4y.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $arOt9.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $9AKkH.IntegerStack();
        this._mode = $c4daca03ecd98d11$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $2G93d.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $2G93d.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $2G93d.Token.INVALID_TYPE;
        this._channel = $2G93d.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $c4daca03ecd98d11$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $2G93d.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $2G93d.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $6Npyx.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $c4daca03ecd98d11$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $d4sFB.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $2G93d.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $c4daca03ecd98d11$var$Lexer.SKIP) continue outer;
                }while (this._type === $c4daca03ecd98d11$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $c4daca03ecd98d11$var$Lexer.SKIP;
    }
    more() {
        this._type = $c4daca03ecd98d11$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($kkkg9.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($kkkg9.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $2G93d.Token.EOF, undefined, $2G93d.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $2G93d.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($4Q2DM.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $2G93d.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $6Npyx.LexerNoViableAltException) {
            if (this._input.LA(1) !== $d4sFB.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$c4daca03ecd98d11$var$Lexer.DEFAULT_MODE = 0;
$c4daca03ecd98d11$var$Lexer.MORE = -2;
$c4daca03ecd98d11$var$Lexer.SKIP = -3;
$c4daca03ecd98d11$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$c4daca03ecd98d11$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "nextToken", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "tokenFactory", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "inputStream", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "sourceName", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "line", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $c4daca03ecd98d11$var$Lexer;

});
parcelRegister("arOt9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $79b3931d4343143e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $8Mk1Z = parcelRequire("8Mk1Z");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $79b3931d4343143e$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $8Mk1Z.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($4Q2DM.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $8Mk1Z.CommonToken(type, text);
    }
}
$79b3931d4343143e$var$__decorate([
    $esDFm.Override
], $79b3931d4343143e$var$CommonTokenFactory.prototype, "create", null);
$79b3931d4343143e$var$__decorate([
    $esDFm.Override
], $79b3931d4343143e$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $79b3931d4343143e$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($79b3931d4343143e$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("8Mk1Z", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6642582fa895ffd2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6642582fa895ffd2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
let $6642582fa895ffd2$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2G93d.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $2G93d.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($4Q2DM.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $6642582fa895ffd2$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$6642582fa895ffd2$var$__decorate([
    $esDFm.NotNull
], $6642582fa895ffd2$var$CommonToken.prototype, "source", void 0);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "type", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "line", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "text", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "charPositionInLine", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "channel", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "startIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "stopIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "tokenIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "tokenSource", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "inputStream", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "toString", null);
$6642582fa895ffd2$var$__decorate([
    $6642582fa895ffd2$var$__param(0, $esDFm.NotNull)
], $6642582fa895ffd2$var$CommonToken, "fromToken", null);
$6642582fa895ffd2$var$CommonToken = $6642582fa895ffd2$var$__decorate([
    $6642582fa895ffd2$var$__param(2, $esDFm.NotNull)
], $6642582fa895ffd2$var$CommonToken);
module.exports.CommonToken = $6642582fa895ffd2$var$CommonToken;

});
parcelRegister("2G93d", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $d4sFB = parcelRequire("d4sFB");
var $1f3686587010d661$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $d4sFB.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($1f3686587010d661$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("9AKkH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $eOyS9 = parcelRequire("eOyS9");
/**
 *
 * @author Sam Harwell
 */ class $6fbb6a9751bc0f5e$var$IntegerStack extends $eOyS9.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $6fbb6a9751bc0f5e$var$IntegerStack;

});

parcelRegister("kkkg9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ecc564042155c9fa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ecc564042155c9fa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $dg39p = parcelRequire("dg39p");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $6co2U = parcelRequire("6co2U");

var $lbAqv = parcelRequire("lbAqv");

var $5jw7S = parcelRequire("5jw7S");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $gTQRB = parcelRequire("gTQRB");

var $khqMx = parcelRequire("khqMx");

var $6Npyx = parcelRequire("6Npyx");

var $esDFm = parcelRequire("esDFm");

var $jjTpW = parcelRequire("jjTpW");

var $haz8F = parcelRequire("haz8F");

var $U6v4o = parcelRequire("U6v4o");

var $2G93d = parcelRequire("2G93d");

var $gwEr2 = parcelRequire("gwEr2");
/** "dup" of ParserInterpreter */ let $ecc564042155c9fa$var$LexerATNSimulator = class LexerATNSimulator extends $lbAqv.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $gTQRB.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $gTQRB.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $lbAqv.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $d4sFB.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $d4sFB.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $jjTpW.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $lbAqv.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $lbAqv.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $d4sFB.IntStream.EOF && input.index === this.startIndex) return $2G93d.Token.EOF;
            throw new $6Npyx.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $gwEr2(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $d4sFB.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $haz8F.PredictionContext.EMPTY_FULL;
        let configs = new $jjTpW.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $9qlOq.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $U6v4o.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $haz8F.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $khqMx.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($d4sFB.IntStream.EOF, $gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $6co2U.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $gwEr2(!configs.hasSemanticContext);
        let proposed = new $5jw7S.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $5jw7S.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $U6v4o.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $dg39p.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($4Q2DM.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "copyState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "match", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.Override
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "reset", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "matchATN", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "execATN", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "computeTargetState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "accept", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "computeStartState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "closure", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(3, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "captureSimState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "addDFAState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getDFA", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getText", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "consume", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getTokenName", null);
$ecc564042155c9fa$var$LexerATNSimulator = $ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $ecc564042155c9fa$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($ecc564042155c9fa$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $ecc564042155c9fa$var$LexerATNSimulator;

});
parcelRegister("dg39p", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $9a6f36ab46ef5323$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $9a6f36ab46ef5323$var$AcceptStateInfo;

});

parcelRegister("lDQMG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fc162f50821f0f08$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fc162f50821f0f08$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $dkveu = parcelRequire("dkveu");

var $dLpRd = parcelRequire("dLpRd");

var $6og9T = parcelRequire("6og9T");

var $2xNwj = parcelRequire("2xNwj");

var $en89P = parcelRequire("en89P");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $2G93d = parcelRequire("2G93d");

var $gwEr2 = parcelRequire("gwEr2");
/** */ let $fc162f50821f0f08$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $dLpRd.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $dLpRd.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $haz8F.PredictionContext.getCachedContext(context, this.contextCache, new $haz8F.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $gwEr2(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $en89P.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $haz8F.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $2xNwj.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $dLpRd.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $dLpRd.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($2G93d.Token.EPSILON)) return following;
        let expected = new $6og9T.IntervalSet();
        expected.addAll(following);
        expected.remove($2G93d.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2G93d.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($2G93d.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($2G93d.Token.EPSILON)) expected.add($2G93d.Token.EOF);
        return expected;
    }
};
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "states", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "decisionToState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeNameToStartState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeToStartState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "decisionToDFA", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeToDFA", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "nextTokens", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "removeState", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull),
    $fc162f50821f0f08$var$__param(1, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "defineMode", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "defineDecisionState", null);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "getExpectedTokens", null);
$fc162f50821f0f08$var$ATN = $fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN);
module.exports.ATN = $fc162f50821f0f08$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($fc162f50821f0f08$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $fc162f50821f0f08$var$ATN;

});
parcelRegister("dkveu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $fJumX = parcelRequire("fJumX");
class $9b455ecf1c961528$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $9b455ecf1c961528$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $9b455ecf1c961528$var$Array2DHashMap) this.backingStore = new $fJumX.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $fJumX.Array2DHashSet(new $9b455ecf1c961528$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $9b455ecf1c961528$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $9b455ecf1c961528$var$Array2DHashMap;

});

parcelRegister("dLpRd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a053b8dbd76d12f6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a053b8dbd76d12f6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $fJumX = parcelRequire("fJumX");

var $6co2U = parcelRequire("6co2U");

var $cXSly = parcelRequire("cXSly");

var $5jw7S = parcelRequire("5jw7S");

var $hZ9cR = parcelRequire("hZ9cR");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $izkyd = parcelRequire("izkyd");

var $5t4I3 = parcelRequire("5t4I3");
let $a053b8dbd76d12f6$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $izkyd.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
                this.s0full = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $cXSly.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $cXSly.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $hZ9cR.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "states", void 0);
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "atnStartState", void 0);
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "atn", void 0);
$a053b8dbd76d12f6$var$DFA = $a053b8dbd76d12f6$var$__decorate([
    $a053b8dbd76d12f6$var$__param(0, $esDFm.NotNull)
], $a053b8dbd76d12f6$var$DFA);
module.exports.DFA = $a053b8dbd76d12f6$var$DFA;

});
parcelRegister("6co2U", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $48368415f2c032d4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $dkveu = parcelRequire("dkveu");

var $fJumX = parcelRequire("fJumX");

var $crbOk = parcelRequire("crbOk");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $lVdCV = parcelRequire("lVdCV");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $8Uwhy = parcelRequire("8Uwhy");

var $8DW9a = parcelRequire("8DW9a");

var $gwEr2 = parcelRequire("gwEr2");

var $g4Hat = parcelRequire("g4Hat");
class $48368415f2c032d4$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$48368415f2c032d4$var$KeyTypeEqualityComparer.INSTANCE = new $48368415f2c032d4$var$KeyTypeEqualityComparer();
function $48368415f2c032d4$var$NewKeyedConfigMap(map) {
    if (map) return new $dkveu.Array2DHashMap(map);
    else return new $dkveu.Array2DHashMap($48368415f2c032d4$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $48368415f2c032d4$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $lVdCV.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $gwEr2(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $48368415f2c032d4$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $9qlOq.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $gwEr2(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $8Uwhy.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $haz8F.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $haz8F.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $gwEr2(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$8DW9a.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $gwEr2(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $9qlOq.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $48368415f2c032d4$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $g4Hat.equals(this._conflictInfo, obj._conflictInfo) && $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $crbOk.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$48368415f2c032d4$var$__decorate([
    $esDFm.NotNull
], $48368415f2c032d4$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "size", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "isEmpty", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "contains", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, Symbol.iterator, null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "toArray", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "containsAll", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "clear", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "equals", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $48368415f2c032d4$var$ATNConfigSet;

});
parcelRegister("9qlOq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6dc7763ca4711224$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6dc7763ca4711224$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $dkveu = parcelRequire("dkveu");

var $axZym = parcelRequire("axZym");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $8DW9a = parcelRequire("8DW9a");

var $gwEr2 = parcelRequire("gwEr2");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $6dc7763ca4711224$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $gwEr2((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $8DW9a.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $8DW9a.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $6dc7763ca4711224$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $6dc7763ca4711224$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $6dc7763ca4711224$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $gwEr2(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $8DW9a.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $haz8F.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $8DW9a.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $8DW9a.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $6dc7763ca4711224$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $6dc7763ca4711224$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $6dc7763ca4711224$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $axZym.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $73sQO.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $i99P2.MurmurHash.initialize(7);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.alt);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.context);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $i99P2.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $dkveu.Array2DHashMap($haz8F.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $8DW9a.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "_state", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "_context", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "state", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull,
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig.prototype, "context", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "semanticContext", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "clone", null);
$6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig.prototype, "transformImpl", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "equals", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "hashCode", null);
$6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(3, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig, "create", null);
$6dc7763ca4711224$var$ATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig);
module.exports.ATNConfig = $6dc7763ca4711224$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $6dc7763ca4711224$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$6dc7763ca4711224$var$SemanticContextATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$ActionATNConfig = class ActionATNConfig extends $6dc7763ca4711224$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $8DW9a.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$6dc7763ca4711224$var$ActionATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $6dc7763ca4711224$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$6dc7763ca4711224$var$ActionSemanticContextATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig);

});
parcelRegister("axZym", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $17Oz4 = parcelRequire("17Oz4");
class $7adcbba0a09e732a$var$DecisionState extends $17Oz4.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $7adcbba0a09e732a$var$DecisionState;

});

parcelRegister("haz8F", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c7fea0a7ff7ccaf2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c7fea0a7ff7ccaf2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $dkveu = parcelRequire("dkveu");

var $fJumX = parcelRequire("fJumX");

var $yEtb9 = parcelRequire("yEtb9");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $8Uwhy = parcelRequire("8Uwhy");

var $gwEr2 = parcelRequire("gwEr2");
const $c7fea0a7ff7ccaf2$var$INITIAL_HASH = 1;
class $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        hash = $i99P2.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        hash = $i99P2.MurmurHash.update(hash, parent);
        hash = $i99P2.MurmurHash.update(hash, returnState);
        hash = $i99P2.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        for (let parent of parents)hash = $i99P2.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $i99P2.MurmurHash.update(hash, returnState);
        hash = $i99P2.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL : $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $c7fea0a7ff7ccaf2$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL : $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $8Uwhy.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(context0) ? context0 : $c7fea0a7ff7ccaf2$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(context1) ? context1 : $c7fea0a7ff7ccaf2$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $gwEr2(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $c7fea0a7ff7ccaf2$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$PredictionContext.prototype, "hashCode", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(1, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(2, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$PredictionContext, "join", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(1, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(2, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $c7fea0a7ff7ccaf2$var$PredictionContext;
class $c7fea0a7ff7ccaf2$var$EmptyPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(fullContext){
        super($c7fea0a7ff7ccaf2$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "toStrings", null);
let $c7fea0a7ff7ccaf2$var$ArrayPredictionContext = class ArrayPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $c7fea0a7ff7ccaf2$var$PredictionContext.calculateHashCode(parents, returnStates));
        $gwEr2(parents.length === returnStates.length);
        $gwEr2(returnStates.length > 1 || returnStates[0] !== $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $yEtb9.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $c7fea0a7ff7ccaf2$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $gwEr2(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $c7fea0a7ff7ccaf2$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $fJumX.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $8Uwhy.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "parents", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$ArrayPredictionContext = $c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext);
let $c7fea0a7ff7ccaf2$var$SingletonPredictionContext = class SingletonPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(parent, returnState){
        super($c7fea0a7ff7ccaf2$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "parent", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$SingletonPredictionContext = $c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $c7fea0a7ff7ccaf2$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $c7fea0a7ff7ccaf2$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $c7fea0a7ff7ccaf2$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $dkveu.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $c7fea0a7ff7ccaf2$var$__decorate([
        $esDFm.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $c7fea0a7ff7ccaf2$var$__decorate([
        $esDFm.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($c7fea0a7ff7ccaf2$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("8Uwhy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $67cc983af147926c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $dkveu = parcelRequire("dkveu");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $gwEr2 = parcelRequire("gwEr2");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $67cc983af147926c$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $67cc983af147926c$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $haz8F.PredictionContext.join(x, y, this);
        let operands = new $67cc983af147926c$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $haz8F.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $67cc983af147926c$var$PredictionContextCache;
$67cc983af147926c$var$PredictionContextCache.UNCACHED = new $67cc983af147926c$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $gwEr2(x != null);
            $gwEr2(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($67cc983af147926c$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("lVdCV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $7WF8Y = parcelRequire("7WF8Y");

var $i99P2 = parcelRequire("i99P2");
/**
 * Private empty array used to construct empty BitSets
 */ const $ff597dd62e8c3e1d$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $ff597dd62e8c3e1d$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $ff597dd62e8c3e1d$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $ff597dd62e8c3e1d$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $ff597dd62e8c3e1d$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $ff597dd62e8c3e1d$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $ff597dd62e8c3e1d$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $ff597dd62e8c3e1d$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $ff597dd62e8c3e1d$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $ff597dd62e8c3e1d$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($ff597dd62e8c3e1d$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $ff597dd62e8c3e1d$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($ff597dd62e8c3e1d$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $ff597dd62e8c3e1d$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        const lastWord = $ff597dd62e8c3e1d$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $ff597dd62e8c3e1d$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $ff597dd62e8c3e1d$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$ff597dd62e8c3e1d$var$getIndex(fromIndex)] & $ff597dd62e8c3e1d$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $ff597dd62e8c3e1d$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $ff597dd62e8c3e1d$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($ff597dd62e8c3e1d$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $ff597dd62e8c3e1d$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $ff597dd62e8c3e1d$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        let lastWord = $ff597dd62e8c3e1d$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $ff597dd62e8c3e1d$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $ff597dd62e8c3e1d$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $i99P2.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $ff597dd62e8c3e1d$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $ff597dd62e8c3e1d$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $ff597dd62e8c3e1d$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $ff597dd62e8c3e1d$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$7WF8Y.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $ff597dd62e8c3e1d$var$BitSet;
class $ff597dd62e8c3e1d$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $ff597dd62e8c3e1d$var$unIndex(this.index) + $ff597dd62e8c3e1d$var$findLSBSet(bits);
                this.mask = $ff597dd62e8c3e1d$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("cXSly", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $970526d2c9830e83$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $lbAqv = parcelRequire("lbAqv");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");

var $24a4y = parcelRequire("24a4y");

var $5t4I3 = parcelRequire("5t4I3");
/** A DFA walker that knows how to dump them to serialized strings. */ class $970526d2c9830e83$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $24a4y.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $lbAqv.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $lbAqv.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $haz8F.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $lbAqv.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$970526d2c9830e83$var$__decorate([
    $esDFm.NotNull
], $970526d2c9830e83$var$DFASerializer.prototype, "dfa", void 0);
$970526d2c9830e83$var$__decorate([
    $esDFm.NotNull
], $970526d2c9830e83$var$DFASerializer.prototype, "vocabulary", void 0);
$970526d2c9830e83$var$__decorate([
    $esDFm.Override
], $970526d2c9830e83$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $970526d2c9830e83$var$DFASerializer;

});
parcelRegister("lbAqv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f6c6e19f6a67273a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f6c6e19f6a67273a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $6co2U = parcelRequire("6co2U");

var $5jw7S = parcelRequire("5jw7S");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");
let $f6c6e19f6a67273a$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$f6c6e19f6a67273a$var$__decorate([
    $esDFm.NotNull
], $f6c6e19f6a67273a$var$ATNSimulator.prototype, "atn", void 0);
$f6c6e19f6a67273a$var$__decorate([
    $esDFm.NotNull
], $f6c6e19f6a67273a$var$ATNSimulator, "ERROR", null);
$f6c6e19f6a67273a$var$ATNSimulator = $f6c6e19f6a67273a$var$__decorate([
    $f6c6e19f6a67273a$var$__param(0, $esDFm.NotNull)
], $f6c6e19f6a67273a$var$ATNSimulator);
module.exports.ATNSimulator = $f6c6e19f6a67273a$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($f6c6e19f6a67273a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $f6c6e19f6a67273a$var$ATNSimulator;

});
parcelRegister("5jw7S", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3de7a5a6cf99484b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3de7a5a6cf99484b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $lVdCV = parcelRequire("lVdCV");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");

var $gwEr2 = parcelRequire("gwEr2");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $3de7a5a6cf99484b$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $gwEr2(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $gwEr2(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $lVdCV.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $lDQMG.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize(7);
        hash = $i99P2.MurmurHash.update(hash, this.configs.hashCode());
        hash = $i99P2.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $3de7a5a6cf99484b$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "configs", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "edges", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "contextEdges", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "hashCode", null);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "equals", null);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $3de7a5a6cf99484b$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $3de7a5a6cf99484b$var$__decorate([
        $esDFm.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $3de7a5a6cf99484b$var$__decorate([
        $esDFm.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $3de7a5a6cf99484b$var$__decorate([
        $3de7a5a6cf99484b$var$__param(0, $esDFm.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($3de7a5a6cf99484b$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("24a4y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1813c4a7a7427bce$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1813c4a7a7427bce$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $b6VR9 = parcelRequire("b6VR9");

var $adfkv = parcelRequire("adfkv");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");

var $g4Hat = parcelRequire("g4Hat");
class $1813c4a7a7427bce$var$Recognizer {
    constructor(){
        this._listeners = [
            $b6VR9.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $2G93d.Token.EOF);
            result = intermediateResult;
            $1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $g4Hat.toMap(ruleNames);
            $1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $2G93d.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $adfkv.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$1813c4a7a7427bce$var$Recognizer.EOF = -1;
$1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache = new WeakMap();
$1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache = new WeakMap();
$1813c4a7a7427bce$var$__decorate([
    $esDFm.SuppressWarnings("serial"),
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "_listeners", void 0);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getTokenTypeMap", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getRuleIndexMap", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "serializedATN", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "atn", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull,
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "interpreter", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull,
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "getErrorHeader", null);
$1813c4a7a7427bce$var$__decorate([
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "addErrorListener", null);
$1813c4a7a7427bce$var$__decorate([
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "removeErrorListener", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $1813c4a7a7427bce$var$Recognizer;

});
parcelRegister("b6VR9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $816d225174e7b521$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $816d225174e7b521$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $816d225174e7b521$var$ConsoleErrorListener.INSTANCE = new $816d225174e7b521$var$ConsoleErrorListener();

});

parcelRegister("adfkv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $76f7027510cb365c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $76f7027510cb365c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $76f7027510cb365c$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$76f7027510cb365c$var$__decorate([
    $esDFm.Override,
    $76f7027510cb365c$var$__param(0, $esDFm.NotNull),
    $76f7027510cb365c$var$__param(4, $esDFm.NotNull)
], $76f7027510cb365c$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $76f7027510cb365c$var$ProxyErrorListener;

});


parcelRegister("5t4I3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3fb35060e4517eb3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $3fb35060e4517eb3$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $2G93d.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $3fb35060e4517eb3$var$VocabularyImpl.EMPTY_VOCABULARY = new $3fb35060e4517eb3$var$VocabularyImpl([], [], []);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "literalNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "displayNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "maxTokenType", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getLiteralName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getSymbolicName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getDisplayName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $3fb35060e4517eb3$var$VocabularyImpl;

});


parcelRegister("hZ9cR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d17f465c3764290d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d17f465c3764290d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $cXSly = parcelRequire("cXSly");

var $esDFm = parcelRequire("esDFm");

var $5t4I3 = parcelRequire("5t4I3");
let $d17f465c3764290d$var$LexerDFASerializer = class LexerDFASerializer extends $cXSly.DFASerializer {
    constructor(dfa){
        super(dfa, $5t4I3.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$d17f465c3764290d$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $d17f465c3764290d$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$d17f465c3764290d$var$LexerDFASerializer = $d17f465c3764290d$var$__decorate([
    $d17f465c3764290d$var$__param(0, $esDFm.NotNull)
], $d17f465c3764290d$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $d17f465c3764290d$var$LexerDFASerializer;

});

parcelRegister("izkyd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d84b6fdbd708b59b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $lVdCV = parcelRequire("lVdCV");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
class $d84b6fdbd708b59b$var$StarLoopEntryState extends $axZym.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $lVdCV.BitSet();
    }
    get stateType() {
        return $9TBHo.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$d84b6fdbd708b59b$var$__decorate([
    $esDFm.Override
], $d84b6fdbd708b59b$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $d84b6fdbd708b59b$var$StarLoopEntryState;

});


parcelRegister("2xNwj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1da51385954c77a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $aTslC = parcelRequire("aTslC");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $1da51385954c77a9$var$InvalidState extends $aTslC.BasicState {
    get stateType() {
        return $9TBHo.ATNStateType.INVALID_TYPE;
    }
}
$1da51385954c77a9$var$__decorate([
    $esDFm.Override
], $1da51385954c77a9$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $1da51385954c77a9$var$InvalidState;

});
parcelRegister("aTslC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ee507addbdfb9ca$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $7ee507addbdfb9ca$var$BasicState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.BASIC;
    }
}
$7ee507addbdfb9ca$var$__decorate([
    $esDFm.Override
], $7ee507addbdfb9ca$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $7ee507addbdfb9ca$var$BasicState;

});


parcelRegister("en89P", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a7698a95bc07b861$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a7698a95bc07b861$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $fJumX = parcelRequire("fJumX");

var $9qlOq = parcelRequire("9qlOq");

var $lVdCV = parcelRequire("lVdCV");

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $2G93d = parcelRequire("2G93d");

var $4EBHJ = parcelRequire("4EBHJ");
let $a7698a95bc07b861$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $6og9T.IntervalSet();
            look[alt] = current;
            let lookBusy = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $haz8F.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $lVdCV.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $6og9T.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $fJumX.Array2DHashSet(), new $lVdCV.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $9qlOq.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($haz8F.PredictionContext.isEmptyLocal(ctx)) {
                look.add($2G93d.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($2G93d.Token.EOF);
                return;
            }
        }
        if (s instanceof $U6v4o.RuleStopState) {
            if (ctx.isEmpty && !$haz8F.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($2G93d.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $acKOx.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $5sT1a.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $4EBHJ.WildcardTransition) look.addAll($6og9T.IntervalSet.of($2G93d.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $grncH.NotSetTransition) set = set.complement($6og9T.IntervalSet.of($2G93d.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $a7698a95bc07b861$var$LL1Analyzer.HIT_PRED = $2G93d.Token.INVALID_TYPE;
$a7698a95bc07b861$var$__decorate([
    $esDFm.NotNull
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "atn", void 0);
$a7698a95bc07b861$var$__decorate([
    $esDFm.NotNull,
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(1, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "LOOK", null);
$a7698a95bc07b861$var$__decorate([
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(2, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(3, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(4, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(5, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "_LOOK", null);
$a7698a95bc07b861$var$LL1Analyzer = $a7698a95bc07b861$var$__decorate([
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer);
module.exports.LL1Analyzer = $a7698a95bc07b861$var$LL1Analyzer;

});
parcelRegister("grncH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bf812ac15f890a0f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bf812ac15f890a0f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $4mzjd = parcelRequire("4mzjd");
let $bf812ac15f890a0f$var$NotSetTransition = class NotSetTransition extends $4mzjd.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "serializationType", null);
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "matches", null);
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "toString", null);
$bf812ac15f890a0f$var$NotSetTransition = $bf812ac15f890a0f$var$__decorate([
    $bf812ac15f890a0f$var$__param(0, $esDFm.NotNull),
    $bf812ac15f890a0f$var$__param(1, $esDFm.Nullable)
], $bf812ac15f890a0f$var$NotSetTransition);
module.exports.NotSetTransition = $bf812ac15f890a0f$var$NotSetTransition;

});
parcelRegister("4mzjd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $32d49b192b3581d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $32d49b192b3581d1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");

var $i2NOt = parcelRequire("i2NOt");
/** A transition containing a set of values. */ let $32d49b192b3581d1$var$SetTransition = class SetTransition extends $i2NOt.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $6og9T.IntervalSet.of($2G93d.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$32d49b192b3581d1$var$__decorate([
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "set", void 0);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override
], $32d49b192b3581d1$var$SetTransition.prototype, "serializationType", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "label", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override
], $32d49b192b3581d1$var$SetTransition.prototype, "matches", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "toString", null);
$32d49b192b3581d1$var$SetTransition = $32d49b192b3581d1$var$__decorate([
    $32d49b192b3581d1$var$__param(0, $esDFm.NotNull),
    $32d49b192b3581d1$var$__param(1, $esDFm.Nullable)
], $32d49b192b3581d1$var$SetTransition);
module.exports.SetTransition = $32d49b192b3581d1$var$SetTransition;

});


parcelRegister("U6v4o", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a8a45ddfa7016cf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $0a8a45ddfa7016cf$var$RuleStopState extends $17Oz4.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $9TBHo.ATNStateType.RULE_STOP;
    }
}
$0a8a45ddfa7016cf$var$__decorate([
    $esDFm.Override
], $0a8a45ddfa7016cf$var$RuleStopState.prototype, "nonStopStateNumber", null);
$0a8a45ddfa7016cf$var$__decorate([
    $esDFm.Override
], $0a8a45ddfa7016cf$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $0a8a45ddfa7016cf$var$RuleStopState;

});

parcelRegister("acKOx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $76df56aac7091e8d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $76df56aac7091e8d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
/** */ let $76df56aac7091e8d$var$RuleTransition = class RuleTransition extends $i2NOt.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$76df56aac7091e8d$var$__decorate([
    $esDFm.NotNull
], $76df56aac7091e8d$var$RuleTransition.prototype, "followState", void 0);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "serializationType", null);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "isEpsilon", null);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "matches", null);
$76df56aac7091e8d$var$RuleTransition = $76df56aac7091e8d$var$__decorate([
    $76df56aac7091e8d$var$__param(0, $esDFm.NotNull),
    $76df56aac7091e8d$var$__param(3, $esDFm.NotNull)
], $76df56aac7091e8d$var$RuleTransition);
module.exports.RuleTransition = $76df56aac7091e8d$var$RuleTransition;

});

parcelRegister("4EBHJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $36382520b7b8202f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $36382520b7b8202f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $36382520b7b8202f$var$WildcardTransition = class WildcardTransition extends $i2NOt.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$36382520b7b8202f$var$__decorate([
    $esDFm.Override
], $36382520b7b8202f$var$WildcardTransition.prototype, "serializationType", null);
$36382520b7b8202f$var$__decorate([
    $esDFm.Override
], $36382520b7b8202f$var$WildcardTransition.prototype, "matches", null);
$36382520b7b8202f$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $36382520b7b8202f$var$WildcardTransition.prototype, "toString", null);
$36382520b7b8202f$var$WildcardTransition = $36382520b7b8202f$var$__decorate([
    $36382520b7b8202f$var$__param(0, $esDFm.NotNull)
], $36382520b7b8202f$var$WildcardTransition);
module.exports.WildcardTransition = $36382520b7b8202f$var$WildcardTransition;

});



parcelRegister("khqMx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ec3a2b803d986844$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ec3a2b803d986844$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $crbOk = parcelRequire("crbOk");

var $hv3tp = parcelRequire("hv3tp");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $ec3a2b803d986844$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $i99P2.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $i99P2.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $i99P2.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $hv3tp.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $hv3tp.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $hv3tp.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $crbOk.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "lexerActions", null);
$ec3a2b803d986844$var$__decorate([
    $ec3a2b803d986844$var$__param(0, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "execute", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.Override
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "hashCode", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.Override
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "equals", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull,
    $ec3a2b803d986844$var$__param(1, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor, "append", null);
$ec3a2b803d986844$var$LexerActionExecutor = $ec3a2b803d986844$var$__decorate([
    $ec3a2b803d986844$var$__param(0, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $ec3a2b803d986844$var$LexerActionExecutor;

});
parcelRegister("hv3tp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cbd806a78853c705$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cbd806a78853c705$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $cbd806a78853c705$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this._offset);
        hash = $i99P2.MurmurHash.update(hash, this._action);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$cbd806a78853c705$var$__decorate([
    $esDFm.NotNull
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "action", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "actionType", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "execute", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "equals", null);
$cbd806a78853c705$var$LexerIndexedCustomAction = $cbd806a78853c705$var$__decorate([
    $cbd806a78853c705$var$__param(1, $esDFm.NotNull)
], $cbd806a78853c705$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $cbd806a78853c705$var$LexerIndexedCustomAction;

});


parcelRegister("6Npyx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4f2b24917d98a0c1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4f2b24917d98a0c1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");

var $4Q2DM = parcelRequire("4Q2DM");

var $g4Hat = parcelRequire("g4Hat");
let $4f2b24917d98a0c1$var$LexerNoViableAltException = class LexerNoViableAltException extends $lWPhg.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($4Q2DM.Interval.of(this._startIndex, this._startIndex));
            symbol = $g4Hat.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$4f2b24917d98a0c1$var$__decorate([
    $esDFm.Override
], $4f2b24917d98a0c1$var$LexerNoViableAltException.prototype, "inputStream", null);
$4f2b24917d98a0c1$var$__decorate([
    $esDFm.Override
], $4f2b24917d98a0c1$var$LexerNoViableAltException.prototype, "toString", null);
$4f2b24917d98a0c1$var$LexerNoViableAltException = $4f2b24917d98a0c1$var$__decorate([
    $4f2b24917d98a0c1$var$__param(1, $esDFm.NotNull)
], $4f2b24917d98a0c1$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $4f2b24917d98a0c1$var$LexerNoViableAltException;

});

parcelRegister("jjTpW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e10ac7679ae3108e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $6co2U = parcelRequire("6co2U");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $e10ac7679ae3108e$var$OrderedATNConfigSet extends $6co2U.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $e10ac7679ae3108e$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "clone", null);
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "getKey", null);
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $e10ac7679ae3108e$var$OrderedATNConfigSet;

});




parcelRegister("4qcTm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3383972d3ce7c61d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $dDGsq = parcelRequire("dDGsq");

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $3383972d3ce7c61d$var$NoViableAltException extends $lWPhg.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $dDGsq.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$3383972d3ce7c61d$var$__decorate([
    $esDFm.NotNull
], $3383972d3ce7c61d$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $3383972d3ce7c61d$var$NoViableAltException;

});
parcelRegister("dDGsq", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9edfda115552908e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9edfda115552908e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $9edfda115552908e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $g4Hat = parcelRequire("g4Hat");

var $cYBtK = parcelRequire("cYBtK");

var $es7AZ = parcelRequire("es7AZ");

var $cNbax = parcelRequire("cNbax");

var $5zuwY = parcelRequire("5zuwY");

var $9AKkH = parcelRequire("9AKkH");

var $gTQRB = parcelRequire("gTQRB");

var $esDFm = parcelRequire("esDFm");

var $bYNsJ = parcelRequire("bYNsJ");

var $l4uOS = parcelRequire("l4uOS");

var $ct3k0 = parcelRequire("ct3k0");

var $24a4y = parcelRequire("24a4y");

var $6JC52 = parcelRequire("6JC52");

var $2G93d = parcelRequire("2G93d");
class $9edfda115552908e$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "enterEveryRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "exitEveryRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "visitErrorNode", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $9edfda115552908e$var$Parser extends $24a4y.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $cNbax.DefaultErrorStrategy();
        this._precedenceStack = new $9AKkH.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $2G93d.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $9edfda115552908e$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $cYBtK.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $es7AZ.ATNDeserializer(deserializationOptions).deserialize($g4Hat.toCharArray(serializedAtn));
            $9edfda115552908e$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $9edfda115552908e$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $gTQRB.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("7fVpz")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $9edfda115552908e$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $6JC52.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $5zuwY.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $ct3k0.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($2G93d.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2G93d.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($2G93d.Token.EPSILON) && symbol === $2G93d.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $igDjg.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("Qf7nS"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $bYNsJ.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $9edfda115552908e$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("Qf7nS")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $l4uOS.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $9edfda115552908e$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $9edfda115552908e$var$Parser.bypassAltsAtnCache = new Map();
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "_errHandler", void 0);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "match", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "matchWildcard", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getParseListeners", null);
$9edfda115552908e$var$__decorate([
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "addParseListener", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getATNWithBypassAlts", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull,
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "errorHandler", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "inputStream", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "currentToken", null);
$9edfda115552908e$var$__decorate([
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "enterRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override,
    $9edfda115552908e$var$__param(0, $esDFm.Nullable)
], $9edfda115552908e$var$Parser.prototype, "precpred", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "getErrorListenerDispatch", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getExpectedTokens", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $9edfda115552908e$var$Parser;

});
parcelRegister("cYBtK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9728292026f6087a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $9728292026f6087a$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($9728292026f6087a$var$ATNDeserializationOptions._defaultOptions == null) {
            $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions = new $9728292026f6087a$var$ATNDeserializationOptions();
            $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$9728292026f6087a$var$__decorate([
    $esDFm.NotNull
], $9728292026f6087a$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $9728292026f6087a$var$ATNDeserializationOptions;

});

parcelRegister("es7AZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a85992867d098ad4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a85992867d098ad4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $9elhd = parcelRequire("9elhd");

var $fJumX = parcelRequire("fJumX");

var $lDQMG = parcelRequire("lDQMG");

var $cYBtK = parcelRequire("cYBtK");

var $9TBHo = parcelRequire("9TBHo");

var $elgsv = parcelRequire("elgsv");

var $6Wwgi = parcelRequire("6Wwgi");

var $aTslC = parcelRequire("aTslC");

var $lVdCV = parcelRequire("lVdCV");

var $h0Oxm = parcelRequire("h0Oxm");

var $fqwBK = parcelRequire("fqwBK");

var $axZym = parcelRequire("axZym");

var $dLpRd = parcelRequire("dLpRd");

var $4t2Am = parcelRequire("4t2Am");

var $6og9T = parcelRequire("6og9T");

var $2xNwj = parcelRequire("2xNwj");

var $lAw71 = parcelRequire("lAw71");

var $hinaj = parcelRequire("hinaj");

var $jWb5l = parcelRequire("jWb5l");

var $ermyP = parcelRequire("ermyP");

var $lPekc = parcelRequire("lPekc");

var $i50Cm = parcelRequire("i50Cm");

var $8OGST = parcelRequire("8OGST");

var $j6qbp = parcelRequire("j6qbp");

var $3fYXW = parcelRequire("3fYXW");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $l4uOS = parcelRequire("l4uOS");

var $j2EBs = parcelRequire("j2EBs");

var $6U6Db = parcelRequire("6U6Db");

var $l5c3t = parcelRequire("l5c3t");

var $dlxNc = parcelRequire("dlxNc");

var $evTXr = parcelRequire("evTXr");

var $54SKF = parcelRequire("54SKF");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $4mzjd = parcelRequire("4mzjd");

var $aj3zV = parcelRequire("aj3zV");

var $cLQen = parcelRequire("cLQen");

var $izkyd = parcelRequire("izkyd");

var $2G93d = parcelRequire("2G93d");

var $c0QqZ = parcelRequire("c0QqZ");

var $lkdkr = parcelRequire("lkdkr");

var $4EBHJ = parcelRequire("4EBHJ");
var $a85992867d098ad4$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($a85992867d098ad4$var$UnicodeDeserializingMode || ($a85992867d098ad4$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $a85992867d098ad4$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $cYBtK.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $a85992867d098ad4$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $a85992867d098ad4$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$a85992867d098ad4$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $a85992867d098ad4$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$a85992867d098ad4$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $lDQMG.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $9TBHo.ATNStateType.INVALID_TYPE) {
                atn.addState(new $2xNwj.InvalidState());
                continue;
            }
            let ruleIndex = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $9TBHo.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $fqwBK.BlockStartState) {
                let endStateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $2G93d.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $U6v4o.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $dLpRd.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $a85992867d098ad4$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $a85992867d098ad4$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            let trg = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $fJumX.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $acKOx.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $4t2Am.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $fqwBK.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $6U6Db.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $j2EBs.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $cLQen.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $izkyd.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $9elhd.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $hinaj.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $9elhd.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $dLpRd.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $6Wwgi.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $h0Oxm.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $3fYXW.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $U6v4o.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $4t2Am.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $4t2Am.EpsilonTransition(endState));
                let matchState = new $aTslC.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $elgsv.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $4t2Am.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $a85992867d098ad4$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $6og9T.IntervalSet();
            sets.push(set);
            let containsEof = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $3fYXW.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $U6v4o.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $lVdCV.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $9TBHo.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $j2EBs.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $izkyd.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $aj3zV.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $3fYXW.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $3fYXW.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $aj3zV.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $cLQen.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $izkyd.StarLoopEntryState);
            }
            if (state instanceof $3fYXW.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $54SKF.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $fqwBK.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $h0Oxm.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $axZym.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $U6v4o.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $U6v4o.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $aTslC.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $4t2Am.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $elgsv.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $evTXr.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $4mzjd.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $U6v4o.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $9TBHo.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $4t2Am.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $6og9T.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $4t2Am.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $h0Oxm.BlockEndState)) continue;
                if (transition instanceof $grncH.NotSetTransition) continue;
                if (transition instanceof $elgsv.AtomTransition || transition instanceof $evTXr.RangeTransition || transition instanceof $4mzjd.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $6og9T.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $grncH.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $elgsv.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $evTXr.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $4mzjd.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $aTslC.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $4t2Am.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $lVdCV.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $U6v4o.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $lkdkr.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $4t2Am.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $evTXr.RangeTransition(target, $2G93d.Token.EOF, arg2);
                else return new $evTXr.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $acKOx.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $dlxNc.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $l5c3t.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $elgsv.AtomTransition(target, $2G93d.Token.EOF);
                else return new $elgsv.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $9elhd.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $4mzjd.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $grncH.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $4EBHJ.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $9TBHo.ATNStateType.INVALID_TYPE:
                return new $2xNwj.InvalidState();
            case $9TBHo.ATNStateType.BASIC:
                s = new $aTslC.BasicState();
                break;
            case $9TBHo.ATNStateType.RULE_START:
                s = new $54SKF.RuleStartState();
                break;
            case $9TBHo.ATNStateType.BLOCK_START:
                s = new $6Wwgi.BasicBlockStartState();
                break;
            case $9TBHo.ATNStateType.PLUS_BLOCK_START:
                s = new $j2EBs.PlusBlockStartState();
                break;
            case $9TBHo.ATNStateType.STAR_BLOCK_START:
                s = new $aj3zV.StarBlockStartState();
                break;
            case $9TBHo.ATNStateType.TOKEN_START:
                s = new $c0QqZ.TokensStartState();
                break;
            case $9TBHo.ATNStateType.RULE_STOP:
                s = new $U6v4o.RuleStopState();
                break;
            case $9TBHo.ATNStateType.BLOCK_END:
                s = new $h0Oxm.BlockEndState();
                break;
            case $9TBHo.ATNStateType.STAR_LOOP_BACK:
                s = new $cLQen.StarLoopbackState();
                break;
            case $9TBHo.ATNStateType.STAR_LOOP_ENTRY:
                s = new $izkyd.StarLoopEntryState();
                break;
            case $9TBHo.ATNStateType.PLUS_LOOP_BACK:
                s = new $6U6Db.PlusLoopbackState();
                break;
            case $9TBHo.ATNStateType.LOOP_END:
                s = new $3fYXW.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $lAw71.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $hinaj.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $jWb5l.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $ermyP.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $lPekc.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $i50Cm.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $8OGST.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $j6qbp.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $a85992867d098ad4$var$ATNDeserializer.BASE_SERIALIZED_UUID = $lkdkr.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $lkdkr.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP = $lkdkr.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $a85992867d098ad4$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $a85992867d098ad4$var$ATNDeserializer.SERIALIZED_UUID = $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP;
$a85992867d098ad4$var$__decorate([
    $esDFm.NotNull
], $a85992867d098ad4$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$a85992867d098ad4$var$__decorate([
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "deserialize", null);
$a85992867d098ad4$var$__decorate([
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$a85992867d098ad4$var$__decorate([
    $esDFm.NotNull,
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $a85992867d098ad4$var$ATNDeserializer;

});
parcelRegister("9elhd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6b85ecfc8f932b00$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6b85ecfc8f932b00$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $6b85ecfc8f932b00$var$ActionTransition = class ActionTransition extends $i2NOt.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "serializationType", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "isEpsilon", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "matches", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "toString", null);
$6b85ecfc8f932b00$var$ActionTransition = $6b85ecfc8f932b00$var$__decorate([
    $6b85ecfc8f932b00$var$__param(0, $esDFm.NotNull)
], $6b85ecfc8f932b00$var$ActionTransition);
module.exports.ActionTransition = $6b85ecfc8f932b00$var$ActionTransition;

});

parcelRegister("elgsv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a70fcb33cb62f153$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a70fcb33cb62f153$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
/** TODO: make all transitions sets? no, should remove set edges */ let $a70fcb33cb62f153$var$AtomTransition = class AtomTransition extends $i2NOt.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $6og9T.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override
], $a70fcb33cb62f153$var$AtomTransition.prototype, "serializationType", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a70fcb33cb62f153$var$AtomTransition.prototype, "label", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override
], $a70fcb33cb62f153$var$AtomTransition.prototype, "matches", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a70fcb33cb62f153$var$AtomTransition.prototype, "toString", null);
$a70fcb33cb62f153$var$AtomTransition = $a70fcb33cb62f153$var$__decorate([
    $a70fcb33cb62f153$var$__param(0, $esDFm.NotNull)
], $a70fcb33cb62f153$var$AtomTransition);
module.exports.AtomTransition = $a70fcb33cb62f153$var$AtomTransition;

});

parcelRegister("6Wwgi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $50e12f5dabf960d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $50e12f5dabf960d1$var$BasicBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.BLOCK_START;
    }
}
$50e12f5dabf960d1$var$__decorate([
    $esDFm.Override
], $50e12f5dabf960d1$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $50e12f5dabf960d1$var$BasicBlockStartState;

});
parcelRegister("fqwBK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $axZym = parcelRequire("axZym");
/**  The start of a regular `(...)` block. */ class $b3b293f71aea38f4$var$BlockStartState extends $axZym.DecisionState {
}
module.exports.BlockStartState = $b3b293f71aea38f4$var$BlockStartState;

});


parcelRegister("h0Oxm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c629a360f3a068ca$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** Terminal node of a simple `(a|b|c)` block. */ class $c629a360f3a068ca$var$BlockEndState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.BLOCK_END;
    }
}
$c629a360f3a068ca$var$__decorate([
    $esDFm.Override
], $c629a360f3a068ca$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $c629a360f3a068ca$var$BlockEndState;

});

parcelRegister("4t2Am", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $340be0435f71aac4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $340be0435f71aac4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $340be0435f71aac4$var$EpsilonTransition = class EpsilonTransition extends $i2NOt.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "serializationType", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "isEpsilon", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "matches", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $340be0435f71aac4$var$EpsilonTransition.prototype, "toString", null);
$340be0435f71aac4$var$EpsilonTransition = $340be0435f71aac4$var$__decorate([
    $340be0435f71aac4$var$__param(0, $esDFm.NotNull)
], $340be0435f71aac4$var$EpsilonTransition);
module.exports.EpsilonTransition = $340be0435f71aac4$var$EpsilonTransition;

});

parcelRegister("lAw71", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fb75de970db175c7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fb75de970db175c7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $fb75de970db175c7$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._channel);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $fb75de970db175c7$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "actionType", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "isPositionDependent", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override,
    $fb75de970db175c7$var$__param(0, $esDFm.NotNull)
], $fb75de970db175c7$var$LexerChannelAction.prototype, "execute", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "hashCode", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "equals", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $fb75de970db175c7$var$LexerChannelAction;

});

parcelRegister("hinaj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c976164228d63343$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c976164228d63343$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $c976164228d63343$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._ruleIndex);
        hash = $i99P2.MurmurHash.update(hash, this._actionIndex);
        return $i99P2.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $c976164228d63343$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "actionType", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "isPositionDependent", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override,
    $c976164228d63343$var$__param(0, $esDFm.NotNull)
], $c976164228d63343$var$LexerCustomAction.prototype, "execute", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "hashCode", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $c976164228d63343$var$LexerCustomAction;

});

parcelRegister("jWb5l", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e83c08696b675ccd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e83c08696b675ccd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $e83c08696b675ccd$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._mode);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $e83c08696b675ccd$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "actionType", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "isPositionDependent", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override,
    $e83c08696b675ccd$var$__param(0, $esDFm.NotNull)
], $e83c08696b675ccd$var$LexerModeAction.prototype, "execute", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "hashCode", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "equals", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $e83c08696b675ccd$var$LexerModeAction;

});

parcelRegister("ermyP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a835166398566135$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a835166398566135$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a835166398566135$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "actionType", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "isPositionDependent", null);
$a835166398566135$var$__decorate([
    $esDFm.Override,
    $a835166398566135$var$__param(0, $esDFm.NotNull)
], $a835166398566135$var$LexerMoreAction.prototype, "execute", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "hashCode", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "equals", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $a835166398566135$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($a835166398566135$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("lPekc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fe397901d0b681ed$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fe397901d0b681ed$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $fe397901d0b681ed$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "actionType", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override,
    $fe397901d0b681ed$var$__param(0, $esDFm.NotNull)
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "execute", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "hashCode", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "equals", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $fe397901d0b681ed$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($fe397901d0b681ed$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("i50Cm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d2992c51027ada37$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d2992c51027ada37$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $d2992c51027ada37$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._mode);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $d2992c51027ada37$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "actionType", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override,
    $d2992c51027ada37$var$__param(0, $esDFm.NotNull)
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "execute", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "hashCode", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "equals", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $d2992c51027ada37$var$LexerPushModeAction;

});

parcelRegister("8OGST", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $66b4422a2a20edad$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $66b4422a2a20edad$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $66b4422a2a20edad$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "actionType", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "isPositionDependent", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override,
    $66b4422a2a20edad$var$__param(0, $esDFm.NotNull)
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "execute", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "hashCode", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "equals", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $66b4422a2a20edad$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($66b4422a2a20edad$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("j6qbp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de82e34741a62417$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de82e34741a62417$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $de82e34741a62417$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._type);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $de82e34741a62417$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "actionType", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "isPositionDependent", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override,
    $de82e34741a62417$var$__param(0, $esDFm.NotNull)
], $de82e34741a62417$var$LexerTypeAction.prototype, "execute", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "hashCode", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "equals", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $de82e34741a62417$var$LexerTypeAction;

});

parcelRegister("3fYXW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $25f2105603fe5855$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** Mark the end of a * or + loop. */ class $25f2105603fe5855$var$LoopEndState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.LOOP_END;
    }
}
$25f2105603fe5855$var$__decorate([
    $esDFm.Override
], $25f2105603fe5855$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $25f2105603fe5855$var$LoopEndState;

});

parcelRegister("l4uOS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f571e0d4afb01ff2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f571e0d4afb01ff2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $dg39p = parcelRequire("dg39p");

var $9elhd = parcelRequire("9elhd");

var $fJumX = parcelRequire("fJumX");

var $yEtb9 = parcelRequire("yEtb9");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $6co2U = parcelRequire("6co2U");

var $lbAqv = parcelRequire("lbAqv");

var $9TBHo = parcelRequire("9TBHo");

var $elgsv = parcelRequire("elgsv");

var $lVdCV = parcelRequire("lVdCV");

var $3AFtK = parcelRequire("3AFtK");

var $axZym = parcelRequire("axZym");

var $5jw7S = parcelRequire("5jw7S");

var $eOyS9 = parcelRequire("eOyS9");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $4qcTm = parcelRequire("4qcTm");

var $73sQO = parcelRequire("73sQO");

var $5NlfZ = parcelRequire("5NlfZ");

var $haz8F = parcelRequire("haz8F");

var $8Uwhy = parcelRequire("8Uwhy");

var $2cmeG = parcelRequire("2cmeG");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $8DW9a = parcelRequire("8DW9a");

var $4mzjd = parcelRequire("4mzjd");

var $fO6gt = parcelRequire("fO6gt");

var $2G93d = parcelRequire("2G93d");

var $5t4I3 = parcelRequire("5t4I3");

var $gwEr2 = parcelRequire("gwEr2");
const $f571e0d4afb01ff2$var$MAX_SHORT_VALUE = 0xFFFF;
const $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $f571e0d4afb01ff2$var$ParserATNSimulator = class ParserATNSimulator extends $lbAqv.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $2cmeG.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $gwEr2(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $2cmeG.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $5NlfZ.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $5NlfZ.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $fO6gt.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $fO6gt.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $gwEr2(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $gwEr2(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $fO6gt.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $fO6gt.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $gwEr2(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $gwEr2(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $4Q2DM.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $lbAqv.ATNSimulator.ERROR) {
                let errorState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $d4sFB.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $axZym.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $gwEr2(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $2cmeG.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $2cmeG.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $8Uwhy.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $lbAqv.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $gwEr2(D.isAcceptState || D.prediction === $lDQMG.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $gwEr2(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $lDQMG.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $f571e0d4afb01ff2$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $gwEr2(!useContext);
                    $gwEr2(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $d4sFB.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $lVdCV.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $U6v4o.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $6co2U.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $U6v4o.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $gwEr2(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $gwEr2(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $fO6gt.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $lbAqv.ATNSimulator.ERROR) return undefined;
        $gwEr2(!useContext || !target.configs.dipsIntoOuterContext);
        return new $fO6gt.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $6co2U.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $6co2U.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $U6v4o.RuleStopState) {
                    $gwEr2(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $d4sFB.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $2G93d.Token.EOF && reachIntermediate.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $2G93d.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $d4sFB.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$2cmeG.PredictionMode.hasConfigInRuleStopState(reach))) {
                $gwEr2(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $eOyS9.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $lbAqv.ATNSimulator.ERROR);
            return [
                $lbAqv.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($2cmeG.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $6co2U.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $U6v4o.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $fO6gt.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $haz8F.PredictionContext.EMPTY_FULL : $haz8F.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $8Uwhy.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $fO6gt.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $6co2U.ATNConfigSet();
        while(true){
            let reachIntermediate = new $6co2U.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($9qlOq.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $fO6gt.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $6co2U.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $8DW9a.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $8DW9a.SemanticContext.NONE;
            else if (altToPred[i] !== $8DW9a.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $yEtb9.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $gwEr2(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $8DW9a.SemanticContext.NONE) pairs.push(new $5jw7S.DFAState.PredPrediction(pred, i));
            else if (pred !== $8DW9a.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $5jw7S.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $lVdCV.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $8DW9a.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $8Uwhy.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $6co2U.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $U6v4o.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $9qlOq.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $gwEr2(depth > $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $haz8F.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $haz8F.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $haz8F.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $haz8F.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $9TBHo.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $9elhd.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $acKOx.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $U6v4o.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $gwEr2(newDepth > $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $acKOx.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$haz8F.PredictionContext.isEmptyLocal(config.context))) {
                        $gwEr2(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $haz8F.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($2G93d.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $8DW9a.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $8DW9a.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$haz8F.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $lVdCV.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $lVdCV.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $3AFtK.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $lVdCV.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $2G93d.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $elgsv.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $4mzjd.SetTransition) {
                    let not = t instanceof $grncH.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $4qcTm.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $lDQMG.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $lDQMG.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $U6v4o.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $gwEr2(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $gwEr2(context !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $5t4I3.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $6co2U.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $gwEr2(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $dg39p.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $dg39p.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $5jw7S.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $gwEr2(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$f571e0d4afb01ff2$var$ParserATNSimulator.debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.dfa_debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.retry_debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Override
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reset", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getStartState", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "execDFA", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "execATN", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "computeTargetState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "computeStartState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(4, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "closure", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(6, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "closureImpl", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getRuleName", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "actionTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Nullable,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Nullable,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "predTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "ruleTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "isConflicted", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getTokenName", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "noViableAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(4, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.Nullable),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "createDFAState", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(5, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(6, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$f571e0d4afb01ff2$var$ParserATNSimulator = $f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $f571e0d4afb01ff2$var$ParserATNSimulator;

});
parcelRegister("3AFtK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $29d4e8b3dd9d0c91$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $esDFm = parcelRequire("esDFm");

var $g4Hat = parcelRequire("g4Hat");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $29d4e8b3dd9d0c91$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $29d4e8b3dd9d0c91$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $g4Hat.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$29d4e8b3dd9d0c91$var$__decorate([
    $esDFm.Override
], $29d4e8b3dd9d0c91$var$ConflictInfo.prototype, "equals", null);
$29d4e8b3dd9d0c91$var$__decorate([
    $esDFm.Override
], $29d4e8b3dd9d0c91$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $29d4e8b3dd9d0c91$var$ConflictInfo;

});

parcelRegister("5NlfZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $43820489bf2012b7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $5zuwY = parcelRequire("5zuwY");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $1uFvm = parcelRequire("1uFvm");

var $6JC52 = parcelRequire("6JC52");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $43820489bf2012b7$var$ParserRuleContext extends $1uFvm.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $43820489bf2012b7$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $5zuwY.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $6JC52.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $1uFvm.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $6JC52.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $5zuwY.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $5zuwY.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $43820489bf2012b7$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $6JC52.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $6JC52.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $4Q2DM.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $4Q2DM.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $4Q2DM.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$43820489bf2012b7$var$ParserRuleContext.EMPTY = new $43820489bf2012b7$var$ParserRuleContext();
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "parent", null);
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "childCount", null);
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $43820489bf2012b7$var$ParserRuleContext;

});
parcelRegister("5zuwY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $40e7e769cc652e20$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $esDFm = parcelRequire("esDFm");

var $6JC52 = parcelRequire("6JC52");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $40e7e769cc652e20$var$ErrorNode extends $6JC52.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$40e7e769cc652e20$var$__decorate([
    $esDFm.Override
], $40e7e769cc652e20$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $40e7e769cc652e20$var$ErrorNode;

});
parcelRegister("6JC52", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4e747c0024dd6c45$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
class $4e747c0024dd6c45$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $4Q2DM.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $2G93d.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "getChild", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "parent", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "setParent", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "payload", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "sourceInterval", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "childCount", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "accept", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "text", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "toStringTree", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $4e747c0024dd6c45$var$TerminalNode;

});


parcelRegister("1uFvm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1168c9c90534f342$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $24a4y = parcelRequire("24a4y");

var $8FZwR = parcelRequire("8FZwR");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $hLP94 = parcelRequire("hLP94");

var $5NlfZ = parcelRequire("5NlfZ");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $1168c9c90534f342$var$RuleContext extends $8FZwR.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $1168c9c90534f342$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $4Q2DM.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $lDQMG.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $hLP94.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $24a4y.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $5NlfZ.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "sourceInterval", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "ruleContext", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "parent", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "setParent", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "payload", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "text", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "getChild", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "childCount", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "accept", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $1168c9c90534f342$var$RuleContext;

});
parcelRegister("8FZwR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $6511e1766b7044d6$var$RuleNode {
}
module.exports.RuleNode = $6511e1766b7044d6$var$RuleNode;

});

parcelRegister("hLP94", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cefe7fdd17d6991a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cefe7fdd17d6991a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $8Mk1Z = parcelRequire("8Mk1Z");

var $5zuwY = parcelRequire("5zuwY");

var $esDFm = parcelRequire("esDFm");

var $dDGsq = parcelRequire("dDGsq");

var $5NlfZ = parcelRequire("5NlfZ");

var $8FZwR = parcelRequire("8FZwR");

var $6JC52 = parcelRequire("6JC52");

var $2G93d = parcelRequire("2G93d");

var $g4Hat = parcelRequire("g4Hat");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $cefe7fdd17d6991a$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $dDGsq.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $g4Hat.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $g4Hat.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $dDGsq.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $8FZwR.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $lDQMG.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $5zuwY.ErrorNode) return t.toString();
        else if (t instanceof $6JC52.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $cefe7fdd17d6991a$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $cefe7fdd17d6991a$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $cefe7fdd17d6991a$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $6JC52.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $5NlfZ.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$cefe7fdd17d6991a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $cefe7fdd17d6991a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $5NlfZ.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $5NlfZ.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($cefe7fdd17d6991a$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $8Mk1Z.CommonToken($2G93d.Token.INVALID_TYPE, "...");
                    t.children[i] = new $6JC52.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $cefe7fdd17d6991a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$cefe7fdd17d6991a$var$__decorate([
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "toStringTree", null);
$cefe7fdd17d6991a$var$__decorate([
    $esDFm.NotNull,
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "getAncestors", null);
$cefe7fdd17d6991a$var$__decorate([
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $cefe7fdd17d6991a$var$Trees;

});



parcelRegister("2cmeG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $199df35814bac0d8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $dkveu = parcelRequire("dkveu");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $U6v4o = parcelRequire("U6v4o");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $199df35814bac0d8$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($199df35814bac0d8$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $dkveu.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $i99P2.MurmurHash.initialize(7);
            hashCode = $i99P2.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $i99P2.MurmurHash.update(hashCode, o.context);
            hashCode = $i99P2.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $199df35814bac0d8$var$__decorate([
        $esDFm.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $199df35814bac0d8$var$__decorate([
        $esDFm.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $U6v4o.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $U6v4o.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($199df35814bac0d8$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("fO6gt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b8206294aba6be67$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b8206294aba6be67$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/**
 *
 * @author Sam Harwell
 */ let $b8206294aba6be67$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $5NlfZ.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$b8206294aba6be67$var$SimulatorState = $b8206294aba6be67$var$__decorate([
    $b8206294aba6be67$var$__param(1, $esDFm.NotNull)
], $b8206294aba6be67$var$SimulatorState);
module.exports.SimulatorState = $b8206294aba6be67$var$SimulatorState;

});


parcelRegister("j2EBs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ddcdb33017a842a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $ddcdb33017a842a9$var$PlusBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.PLUS_BLOCK_START;
    }
}
$ddcdb33017a842a9$var$__decorate([
    $esDFm.Override
], $ddcdb33017a842a9$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $ddcdb33017a842a9$var$PlusBlockStartState;

});

parcelRegister("6U6Db", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $506d1dd5405be440$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $506d1dd5405be440$var$PlusLoopbackState extends $axZym.DecisionState {
    get stateType() {
        return $9TBHo.ATNStateType.PLUS_LOOP_BACK;
    }
}
$506d1dd5405be440$var$__decorate([
    $esDFm.Override
], $506d1dd5405be440$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $506d1dd5405be440$var$PlusLoopbackState;

});

parcelRegister("l5c3t", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f5936a7914ccad6f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f5936a7914ccad6f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $esDFm = parcelRequire("esDFm");

var $8DW9a = parcelRequire("8DW9a");
/**
 *
 * @author Sam Harwell
 */ let $f5936a7914ccad6f$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $5sT1a.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $8DW9a.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "matches", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "toString", null);
$f5936a7914ccad6f$var$PrecedencePredicateTransition = $f5936a7914ccad6f$var$__decorate([
    $f5936a7914ccad6f$var$__param(0, $esDFm.NotNull)
], $f5936a7914ccad6f$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $f5936a7914ccad6f$var$PrecedencePredicateTransition;

});

parcelRegister("evTXr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a90f5dfe3a55f17e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a90f5dfe3a55f17e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $a90f5dfe3a55f17e$var$RangeTransition = class RangeTransition extends $i2NOt.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $6og9T.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "serializationType", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "label", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "matches", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "toString", null);
$a90f5dfe3a55f17e$var$RangeTransition = $a90f5dfe3a55f17e$var$__decorate([
    $a90f5dfe3a55f17e$var$__param(0, $esDFm.NotNull)
], $a90f5dfe3a55f17e$var$RangeTransition);
module.exports.RangeTransition = $a90f5dfe3a55f17e$var$RangeTransition;

});

parcelRegister("54SKF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3b27cc07a8f55191$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
class $3b27cc07a8f55191$var$RuleStartState extends $17Oz4.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $9TBHo.ATNStateType.RULE_START;
    }
}
$3b27cc07a8f55191$var$__decorate([
    $esDFm.Override
], $3b27cc07a8f55191$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $3b27cc07a8f55191$var$RuleStartState;

});

parcelRegister("aj3zV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $780e745635507ed4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/** The block that begins a closure loop. */ class $780e745635507ed4$var$StarBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.STAR_BLOCK_START;
    }
}
$780e745635507ed4$var$__decorate([
    $esDFm.Override
], $780e745635507ed4$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $780e745635507ed4$var$StarBlockStartState;

});

parcelRegister("cLQen", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $94c263cb0220bf37$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
class $94c263cb0220bf37$var$StarLoopbackState extends $17Oz4.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $9TBHo.ATNStateType.STAR_LOOP_BACK;
    }
}
$94c263cb0220bf37$var$__decorate([
    $esDFm.Override
], $94c263cb0220bf37$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $94c263cb0220bf37$var$StarLoopbackState;

});

parcelRegister("c0QqZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8bee2881bedcfb48$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
/** The Tokens rule start state linking to each lexer rule start state */ class $8bee2881bedcfb48$var$TokensStartState extends $axZym.DecisionState {
    get stateType() {
        return $9TBHo.ATNStateType.TOKEN_START;
    }
}
$8bee2881bedcfb48$var$__decorate([
    $esDFm.Override
], $8bee2881bedcfb48$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $8bee2881bedcfb48$var$TokensStartState;

});

parcelRegister("lkdkr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $i99P2 = parcelRequire("i99P2");
class $f865ce06460c5d56$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $f865ce06460c5d56$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $i99P2.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $f865ce06460c5d56$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $f865ce06460c5d56$var$UUID;

});


parcelRegister("bYNsJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8b8baa7f19328023$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8b8baa7f19328023$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $8b8baa7f19328023$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$8b8baa7f19328023$var$__decorate([
    $esDFm.NotNull
], $8b8baa7f19328023$var$ParseInfo.prototype, "getDecisionInfo", null);
$8b8baa7f19328023$var$__decorate([
    $esDFm.NotNull
], $8b8baa7f19328023$var$ParseInfo.prototype, "getLLDecisions", null);
$8b8baa7f19328023$var$ParseInfo = $8b8baa7f19328023$var$__decorate([
    $8b8baa7f19328023$var$__param(0, $esDFm.NotNull)
], $8b8baa7f19328023$var$ParseInfo);
module.exports.ParseInfo = $8b8baa7f19328023$var$ParseInfo;

});

parcelRegister("ct3k0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $913ac514b76a37df$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $adfkv = parcelRequire("adfkv");

var $esDFm = parcelRequire("esDFm");
/**
 * @author Sam Harwell
 */ class $913ac514b76a37df$var$ProxyParserErrorListener extends $adfkv.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $913ac514b76a37df$var$ProxyParserErrorListener;

});

parcelRegister("7fVpz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("39h9p").then(()=>parcelRequire('3i2SZ'));

});

parcelRegister("Qf7nS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2mTYh").then(()=>parcelRequire('8rjeX'));

});




parcelRegister("5EAbA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $41dcc1f37efdf89f$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $41dcc1f37efdf89f$var$ParseCancellationException;

});


parcelRegister("h5rBk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c708504646673e71$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c708504646673e71$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $8Mk1Z = parcelRequire("8Mk1Z");

var $4Q2DM = parcelRequire("4Q2DM");

var $gTQRB = parcelRequire("gTQRB");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $c708504646673e71$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $2G93d.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $gwEr2(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $2G93d.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2G93d.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $2G93d.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $gwEr2(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $2G93d.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $2G93d.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $4Q2DM.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $4Q2DM.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2G93d.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($4Q2DM.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $8Mk1Z.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $8Mk1Z.CommonToken;
    }
};
$c708504646673e71$var$__decorate([
    $esDFm.NotNull
], $c708504646673e71$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "tokenSource", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "index", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "mark", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "release", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "seek", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "size", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "consume", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "get", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "LA", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "LT", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "sourceName", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "getText", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$c708504646673e71$var$BufferedTokenStream = $c708504646673e71$var$__decorate([
    $c708504646673e71$var$__param(0, $esDFm.NotNull)
], $c708504646673e71$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $c708504646673e71$var$BufferedTokenStream;

});

parcelRegister("cBsOS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("d0TlQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $3wxwf = parcelRequire("3wxwf");

var $lXg5i = parcelRequire("lXg5i");

var $d4sFB = parcelRequire("d4sFB");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $9796360e323bb25a$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $3wxwf.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $lXg5i.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($9796360e323bb25a$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("3wxwf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $eIoqK = parcelRequire("eIoqK");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $290e5c7608340dee$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $290e5c7608340dee$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $290e5c7608340dee$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $290e5c7608340dee$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $gwEr2(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$eIoqK.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $gwEr2(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$eIoqK.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($eIoqK.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($eIoqK.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($eIoqK.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($290e5c7608340dee$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("eIoqK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $ab682023343875fe$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $ab682023343875fe$var$isHighSurrogate;
function $ab682023343875fe$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $ab682023343875fe$var$isLowSurrogate;
function $ab682023343875fe$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $ab682023343875fe$var$isSupplementaryCodePoint;

});


parcelRegister("lXg5i", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ffbb95ad08ca6a0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $d4sFB = parcelRequire("d4sFB");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $ffbb95ad08ca6a0e$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $gwEr2(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $ffbb95ad08ca6a0e$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $gwEr2(this.LA(1) === $d4sFB.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($4Q2DM.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $d4sFB.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $d4sFB.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "consume", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "index", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "size", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "mark", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "release", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "seek", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "sourceName", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "toString", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "LA", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $ffbb95ad08ca6a0e$var$CodePointCharStream;

});


parcelRegister("1y11S", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1209c3d1bc2cac22$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1209c3d1bc2cac22$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $h5rBk = parcelRequire("h5rBk");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $1209c3d1bc2cac22$var$CommonTokenStream = class CommonTokenStream extends $h5rBk.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $2G93d.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $2G93d.Token.EOF) break;
        }
        return n;
    }
};
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "tryLB", null);
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "tryLT", null);
$1209c3d1bc2cac22$var$CommonTokenStream = $1209c3d1bc2cac22$var$__decorate([
    $1209c3d1bc2cac22$var$__param(0, $esDFm.NotNull)
], $1209c3d1bc2cac22$var$CommonTokenStream);
module.exports.CommonTokenStream = $1209c3d1bc2cac22$var$CommonTokenStream;

});

parcelRegister("6gsRs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $48fa9fed976e4bf6$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($48fa9fed976e4bf6$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("4Allj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $356b147161a3df5a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $356b147161a3df5a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $lVdCV = parcelRequire("lVdCV");

var $esDFm = parcelRequire("esDFm");

var $4Q2DM = parcelRequire("4Q2DM");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $356b147161a3df5a$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $lVdCV.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$356b147161a3df5a$var$__decorate([
    $esDFm.Override
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(6, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(5, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(5, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$356b147161a3df5a$var$__decorate([
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.NotNull,
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $356b147161a3df5a$var$DiagnosticErrorListener;

});

parcelRegister("2iaul", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1ab565ff78924252$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $1ab565ff78924252$var$InterpreterRuleContext extends $5NlfZ.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$1ab565ff78924252$var$__decorate([
    $esDFm.Override
], $1ab565ff78924252$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $1ab565ff78924252$var$InterpreterRuleContext;

});

parcelRegister("8I7Eq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $65785e22623bca95$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $65785e22623bca95$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $gTQRB = parcelRequire("gTQRB");

var $kkkg9 = parcelRequire("kkkg9");

var $esDFm = parcelRequire("esDFm");

var $esDFm = parcelRequire("esDFm");
let $65785e22623bca95$var$LexerInterpreter = class LexerInterpreter extends $gTQRB.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $kkkg9.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$65785e22623bca95$var$__decorate([
    $esDFm.NotNull
], $65785e22623bca95$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "atn", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "grammarFileName", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "ruleNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "channelNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "modeNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "vocabulary", null);
$65785e22623bca95$var$LexerInterpreter = $65785e22623bca95$var$__decorate([
    $65785e22623bca95$var$__param(1, $esDFm.NotNull)
], $65785e22623bca95$var$LexerInterpreter);
module.exports.LexerInterpreter = $65785e22623bca95$var$LexerInterpreter;

});

parcelRegister("8tp3s", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $62b4778561d490bb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $62b4778561d490bb$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $arOt9 = parcelRequire("arOt9");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $62b4778561d490bb$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $arOt9.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $2G93d.Token.EOF, "EOF", $2G93d.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $2G93d.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "charPositionInLine", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "nextToken", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "line", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "inputStream", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "sourceName", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull,
    $62b4778561d490bb$var$__param(0, $esDFm.NotNull)
], $62b4778561d490bb$var$ListTokenSource.prototype, "tokenFactory", null);
$62b4778561d490bb$var$ListTokenSource = $62b4778561d490bb$var$__decorate([
    $62b4778561d490bb$var$__param(0, $esDFm.NotNull)
], $62b4778561d490bb$var$ListTokenSource);
module.exports.ListTokenSource = $62b4778561d490bb$var$ListTokenSource;

});

parcelRegister("bvca3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("djIaX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9b1f511704f60b2d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9b1f511704f60b2d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $lVdCV = parcelRequire("lVdCV");

var $d7mTm = parcelRequire("d7mTm");

var $6iuj6 = parcelRequire("6iuj6");

var $2iaul = parcelRequire("2iaul");

var $3fYXW = parcelRequire("3fYXW");

var $esDFm = parcelRequire("esDFm");

var $esDFm = parcelRequire("esDFm");

var $dDGsq = parcelRequire("dDGsq");

var $l4uOS = parcelRequire("l4uOS");

var $lWPhg = parcelRequire("lWPhg");

var $izkyd = parcelRequire("izkyd");

var $2G93d = parcelRequire("2G93d");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $9b1f511704f60b2d$var$ParserInterpreter = class ParserInterpreter extends $dDGsq.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $l4uOS.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $lVdCV.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $l4uOS.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $17Oz4.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $9TBHo.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $lWPhg.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $3fYXW.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $2G93d.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $d7mTm.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $d7mTm.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $2iaul.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $6iuj6.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $2G93d.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $2G93d.Token.INVALID_TYPE, tok.text, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$9b1f511704f60b2d$var$__decorate([
    $esDFm.NotNull
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "reset", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "atn", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "vocabulary", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "ruleNames", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "grammarFileName", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$9b1f511704f60b2d$var$ParserInterpreter = $9b1f511704f60b2d$var$__decorate([
    $9b1f511704f60b2d$var$__param(1, $esDFm.NotNull)
], $9b1f511704f60b2d$var$ParserInterpreter);
module.exports.ParserInterpreter = $9b1f511704f60b2d$var$ParserInterpreter;

});

parcelRegister("gBCh3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c16dca7b4f738f44$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $c16dca7b4f738f44$var$RuleContextWithAltNum extends $5NlfZ.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $lDQMG.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$c16dca7b4f738f44$var$__decorate([
    $esDFm.Override
], $c16dca7b4f738f44$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $c16dca7b4f738f44$var$RuleContextWithAltNum;

});

parcelRegister("9moap", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $6d08ea266c6ae7f4$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $6d08ea266c6ae7f4$var$RuleDependency;

});

parcelRegister("iB1aK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $d89c977dc44fdf68$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $d89c977dc44fdf68$var$RuleVersion;

});

parcelRegister("5fKqt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dAoWy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kKHPj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3sjft", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2842eafbba1c332c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $2842eafbba1c332c$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $4Q2DM.Interval) interval = intervalOrProgram;
        else interval = $4Q2DM.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $2G93d.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $2842eafbba1c332c$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $2842eafbba1c332c$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $2842eafbba1c332c$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $2842eafbba1c332c$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $2842eafbba1c332c$var$TokenStreamRewriter;
$2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$2842eafbba1c332c$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $2842eafbba1c332c$var$RewriteOperation;
class $2842eafbba1c332c$var$InsertBeforeOp extends $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $2G93d.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $2842eafbba1c332c$var$InsertAfterOp extends $2842eafbba1c332c$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $2842eafbba1c332c$var$ReplaceOp extends $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$ReplaceOp.prototype, "execute", null);
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("7twhW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7kyUa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("bFJ48", function(module, exports) {
$parcel$export(module.exports, "JQLLexer", () => $9bd1437ae34b6680$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $es7AZ = parcelRequire("es7AZ");

var $gTQRB = parcelRequire("gTQRB");

var $kkkg9 = parcelRequire("kkkg9");

var $5t4I3 = parcelRequire("5t4I3");

var $g4Hat = parcelRequire("g4Hat");
class $9bd1437ae34b6680$export$375c79404cc64c7f extends (0, $gTQRB.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $5t4I3.VocabularyImpl)($9bd1437ae34b6680$export$375c79404cc64c7f._LITERAL_NAMES, $9bd1437ae34b6680$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $kkkg9.LexerATNSimulator)($9bd1437ae34b6680$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $g4Hat.join([
            $9bd1437ae34b6680$export$375c79404cc64c7f._serializedATNSegment0,
            $9bd1437ae34b6680$export$375c79404cc64c7f._serializedATNSegment1,
            $9bd1437ae34b6680$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$9bd1437ae34b6680$export$375c79404cc64c7f.__ATN) $9bd1437ae34b6680$export$375c79404cc64c7f.__ATN = new (0, $es7AZ.ATNDeserializer)().deserialize($g4Hat.toCharArray($9bd1437ae34b6680$export$375c79404cc64c7f._serializedATN));
        return $9bd1437ae34b6680$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("41LBU", function(module, exports) {
$parcel$export(module.exports, "JQLParser", () => $3bedfc54d1944a38$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $es7AZ = parcelRequire("es7AZ");

var $4qcTm = parcelRequire("4qcTm");

var $dDGsq = parcelRequire("dDGsq");

var $5NlfZ = parcelRequire("5NlfZ");

var $l4uOS = parcelRequire("l4uOS");

var $lWPhg = parcelRequire("lWPhg");

var $2G93d = parcelRequire("2G93d");

var $5t4I3 = parcelRequire("5t4I3");

var $g4Hat = parcelRequire("g4Hat");
class $3bedfc54d1944a38$export$9c4772e191bdb810 extends (0, $dDGsq.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $5t4I3.VocabularyImpl)($3bedfc54d1944a38$export$9c4772e191bdb810._LITERAL_NAMES, $3bedfc54d1944a38$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $l4uOS.ParserATNSimulator)($3bedfc54d1944a38$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $3bedfc54d1944a38$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BANG | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $3bedfc54d1944a38$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $3bedfc54d1944a38$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $3bedfc54d1944a38$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $3bedfc54d1944a38$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $3bedfc54d1944a38$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BANG:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.BANG || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $3bedfc54d1944a38$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $3bedfc54d1944a38$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $3bedfc54d1944a38$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $3bedfc54d1944a38$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $3bedfc54d1944a38$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $3bedfc54d1944a38$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $3bedfc54d1944a38$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $3bedfc54d1944a38$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $3bedfc54d1944a38$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.ON | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.DURING | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $3bedfc54d1944a38$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.ON | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.DURING | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $3bedfc54d1944a38$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.FROM | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.TO | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.ON | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.DURING | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $3bedfc54d1944a38$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.EQUALS || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $3bedfc54d1944a38$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.LIKE || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $3bedfc54d1944a38$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.LT | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.GT | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.GTEQ | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $3bedfc54d1944a38$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IN);
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $3bedfc54d1944a38$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $3bedfc54d1944a38$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $3bedfc54d1944a38$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $3bedfc54d1944a38$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $3bedfc54d1944a38$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $3bedfc54d1944a38$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $3bedfc54d1944a38$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $3bedfc54d1944a38$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $3bedfc54d1944a38$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $3bedfc54d1944a38$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.STRING - 37 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $3bedfc54d1944a38$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $3bedfc54d1944a38$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $3bedfc54d1944a38$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $3bedfc54d1944a38$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $3bedfc54d1944a38$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $3bedfc54d1944a38$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $3bedfc54d1944a38$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $3bedfc54d1944a38$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $3bedfc54d1944a38$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $3bedfc54d1944a38$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $3bedfc54d1944a38$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $3bedfc54d1944a38$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $3bedfc54d1944a38$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $3bedfc54d1944a38$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.FROM:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $3bedfc54d1944a38$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $3bedfc54d1944a38$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $3bedfc54d1944a38$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $3bedfc54d1944a38$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.FROM || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $3bedfc54d1944a38$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $3bedfc54d1944a38$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $3bedfc54d1944a38$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $3bedfc54d1944a38$export$9c4772e191bdb810.ASC || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.ASC || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$3bedfc54d1944a38$export$9c4772e191bdb810.__ATN) $3bedfc54d1944a38$export$9c4772e191bdb810.__ATN = new (0, $es7AZ.ATNDeserializer)().deserialize($g4Hat.toCharArray($3bedfc54d1944a38$export$9c4772e191bdb810._serializedATN));
        return $3bedfc54d1944a38$export$9c4772e191bdb810.__ATN;
    }
}
class $3bedfc54d1944a38$export$ff413535b9575c8 extends (0, $5NlfZ.ParserRuleContext) {
    EOF() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$4148a879cab28017 extends (0, $5NlfZ.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$d69831d387793480 extends (0, $5NlfZ.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$f16819001158b9e);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.OR);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$f16819001158b9e extends (0, $5NlfZ.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.AND);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$5e9146f8d5cf1330 extends (0, $5NlfZ.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$a136a0e9655bfb04 extends (0, $5NlfZ.ParserRuleContext) {
    LPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$23486a2f2ddd5bcd extends (0, $5NlfZ.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$93924a205c12d32c extends (0, $5NlfZ.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $3bedfc54d1944a38$export$c428f709a58396e5 extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$1b131204ef9fa33d extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$d83706ee80a9852a extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$2934b8ff22fddd2d extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$8b84310182afcf93 extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$5df295dc7a2cac7c extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$9ac3367aee261b32 extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$7a7defca8628a13c extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$e77e479a48133015);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$41e475fc1988e413 extends (0, $5NlfZ.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b76fe5387fdd7efd extends (0, $5NlfZ.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$d821da0716b3ec95 extends (0, $5NlfZ.ParserRuleContext) {
    LT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$178478bfa8292f72 extends (0, $5NlfZ.ParserRuleContext) {
    IN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$e64c31d2830b66e4 extends (0, $5NlfZ.ParserRuleContext) {
    IS() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$7e283636700e4a6c extends (0, $5NlfZ.ParserRuleContext) {
    WAS() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b9118b1ed9a78d66 extends (0, $5NlfZ.ParserRuleContext) {
    WAS() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$493d626ed78ca66 extends (0, $5NlfZ.ParserRuleContext) {
    CHANGED() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b33300c3d916229a extends (0, $5NlfZ.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $3bedfc54d1944a38$export$11fec15307d2e17b extends $3bedfc54d1944a38$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b8b24f99f985ebb3 extends $3bedfc54d1944a38$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b02d0b6637ce0593 extends (0, $5NlfZ.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$401a038855cc5b15 extends (0, $5NlfZ.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$bde73d8ad7c8b71e extends (0, $5NlfZ.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$8737d94a1880e8b3 extends (0, $5NlfZ.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$2eaac5a9828bf647 extends (0, $5NlfZ.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$d85a062f90025e5c extends (0, $5NlfZ.ParserRuleContext) {
    EMPTY() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$2e17d457b0933bec extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$ebf0cc785e9ee41a extends (0, $5NlfZ.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$1f5f7ac816788f44 extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$83d7c13849b931c3 extends (0, $5NlfZ.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$a95583953c237f88);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$9cb97a63f2be4864 extends (0, $5NlfZ.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$c419f717bfc46a5d extends (0, $5NlfZ.ParserRuleContext) {
    LPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$f6cd3e372f5ab120 extends (0, $5NlfZ.ParserRuleContext) {
    RPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$e20ce4a2ed16372c extends (0, $5NlfZ.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$a95583953c237f88 extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$9fa1e4d63f31b911 extends (0, $5NlfZ.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$e77e479a48133015 extends (0, $5NlfZ.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$dc01290aee731418 extends (0, $5NlfZ.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$75412b8b6a6442e1 extends (0, $5NlfZ.ParserRuleContext) {
    DURING() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$ad402332075c8656 extends (0, $5NlfZ.ParserRuleContext) {
    BY() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$4239d7c0fbafd3f1 extends (0, $5NlfZ.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$6b796c5a4b8c18e extends (0, $5NlfZ.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$534469b9c8f44139 extends (0, $5NlfZ.ParserRuleContext) {
    ORDER() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$c7d8f03f36952a46 extends (0, $5NlfZ.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("cWGfC", function(module, exports) {
$parcel$export(module.exports, "JastBuilderErrorListener", () => $8ed05ca5be2fe9a4$export$d0857f60ff1f385);

var $ax34Q = parcelRequire("ax34Q");

var $cic90 = parcelRequire("cic90");
class $8ed05ca5be2fe9a4$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (_recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $ax34Q.JQLParseError)(msg));
            else this.errors.push(new (0, $cic90.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("ax34Q", function(module, exports) {
$parcel$export(module.exports, "JQLParseError", () => $9e9c710caa518509$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $9e9c710caa518509$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("cic90", function(module, exports) {
$parcel$export(module.exports, "JQLSyntaxError", () => $c6a39dd8b4312990$export$3276184116160c41);

var $ax34Q = parcelRequire("ax34Q");
class $c6a39dd8b4312990$export$3276184116160c41 extends (0, $ax34Q.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("cjb70", function(module, exports) {
$parcel$export(module.exports, "QueryVisitor", () => $2a1afdbc2890cabf$export$418003b930734805);

var $f26C8 = parcelRequire("f26C8");

var $hGsJJ = parcelRequire("hGsJJ");

var $15Hkp = parcelRequire("15Hkp");

var $9J9F3 = parcelRequire("9J9F3");
class $2a1afdbc2890cabf$export$418003b930734805 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.whereVisitor = new (0, $9J9F3.WhereVisitor)(this.tokens), this.orderByVisitor = new (0, $15Hkp.OrderByVisitor)(this.tokens), this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $f26C8.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("hGsJJ", function(module, exports) {
$parcel$export(module.exports, "JastBuildingVisitor", () => $fd8c709f2549b18d$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $fd8c709f2549b18d$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $fd8c709f2549b18d$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $fd8c709f2549b18d$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $fd8c709f2549b18d$export$7c2714a5250b9239);
class $fd8c709f2549b18d$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(_tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(_node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(_node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(_node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $fd8c709f2549b18d$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $fd8c709f2549b18d$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $fd8c709f2549b18d$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$fd8c709f2549b18d$export$85a4e6d858dbc6fb(node.payload));
const $fd8c709f2549b18d$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("15Hkp", function(module, exports) {
$parcel$export(module.exports, "OrderByVisitor", () => $597e371973c3cf34$export$2774b71b99734811);


var $f26C8 = parcelRequire("f26C8");

var $dlsVE = parcelRequire("dlsVE");

var $hGsJJ = parcelRequire("hGsJJ");

var $8Iahr = parcelRequire("8Iahr");
class $597e371973c3cf34$export$2774b71b99734811 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.searchSortVisitor = new $597e371973c3cf34$var$SearchSortVisitor(this.tokens), this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $f26C8.internalCreators).orderByOperator((0, $hGsJJ.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $dlsVE.notUndefined));
            return (0, $f26C8.internalCreators).orderBy(fields, operator, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $597e371973c3cf34$var$SearchSortVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $8Iahr.FieldVisitor)(this.tokens), this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $f26C8.internalCreators).orderByDirection((0, $adec16a85d57f51f$export$2ea27ea5f2121899), (0, $hGsJJ.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $f26C8.internalCreators).orderByDirection((0, $adec16a85d57f51f$export$6d60017b9e092e73), (0, $hGsJJ.getPositionFromToken)(asc.payload));
            return (0, $f26C8.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("dlsVE", function(module, exports) {
$parcel$export(module.exports, "notUndefined", () => $66fcbe4c481eea3d$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $66fcbe4c481eea3d$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("8Iahr", function(module, exports) {
$parcel$export(module.exports, "FieldVisitor", () => $30d306b6cc02da67$export$c6a85c4c3bf2317d);

var $f26C8 = parcelRequire("f26C8");

var $6BLGV = parcelRequire("6BLGV");

var $hGsJJ = parcelRequire("hGsJJ");

var $3wodm = parcelRequire("3wodm");
class $30d306b6cc02da67$export$c6a85c4c3bf2317d extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $3wodm.StringVisitor)(this.tokens), this.fieldPropertyVisitor = new $30d306b6cc02da67$var$FieldPropertyVisitor(this.tokens), this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $f26C8.internalCreators).field(text, text, undefined, (0, $hGsJJ.getPositionFromContext)(ctx));
        }, this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $f26C8.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $f26C8.internalCreators).field(text, text, properties, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $30d306b6cc02da67$var$FieldPropertyVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $6BLGV.ArgumentVisitor)(this.tokens), this.propertyArgumentVisitor = new $30d306b6cc02da67$var$PropertyArgumentVisitor(this.tokens), this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $f26C8.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $30d306b6cc02da67$var$PropertyArgumentVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $6BLGV.ArgumentVisitor)(this.tokens), this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("6BLGV", function(module, exports) {
$parcel$export(module.exports, "ArgumentVisitor", () => $6751b6f00c118d3b$export$46b5a1f6d962d533);

var $f26C8 = parcelRequire("f26C8");

var $hGsJJ = parcelRequire("hGsJJ");

var $3wodm = parcelRequire("3wodm");
class $6751b6f00c118d3b$export$46b5a1f6d962d533 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $3wodm.StringVisitor)(this.tokens), this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $f26C8.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $f26C8.internalCreators).argument(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("3wodm", function(module, exports) {
$parcel$export(module.exports, "StringVisitor", () => $d977c104e06c125d$export$617850cb96304515);

var $hGsJJ = parcelRequire("hGsJJ");
class $d977c104e06c125d$export$617850cb96304515 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $hGsJJ.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("9J9F3", function(module, exports) {
$parcel$export(module.exports, "WhereVisitor", () => $1f45af89f25f3114$export$c573472f1d20e15d);


var $f26C8 = parcelRequire("f26C8");

var $dlsVE = parcelRequire("dlsVE");

var $hGsJJ = parcelRequire("hGsJJ");

var $715r8 = parcelRequire("715r8");
class $1f45af89f25f3114$export$c573472f1d20e15d extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.terminalClauseVisitor = new (0, $715r8.TerminalClauseVisitor)(this.tokens), this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        }, this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $dlsVE.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $f26C8.internalCreators).compoundOperator((0, $f6415dda43b7f459$export$7b8f0a728d79a753), (0, $hGsJJ.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $f26C8.internalCreators).compoundClause(operator, clauses, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $dlsVE.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $f26C8.internalCreators).compoundOperator((0, $f6415dda43b7f459$export$6d6d48d210d3ca97), (0, $hGsJJ.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $f26C8.internalCreators).compoundClause(operator, clauses, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $f26C8.internalCreators).notClause(clause, (0, $f26C8.internalCreators).notClauseOperator((0, $hGsJJ.getPositionFromToken)(notToken.payload)), (0, $hGsJJ.getPositionFromContext)(ctx));
            return clause;
        }, this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
parcelRegister("715r8", function(module, exports) {
$parcel$export(module.exports, "TerminalClauseVisitor", () => $663e4a591a2538f3$export$14576ae5bd1874a9);

var $f26C8 = parcelRequire("f26C8");

var $dlsVE = parcelRequire("dlsVE");

var $hGsJJ = parcelRequire("hGsJJ");

var $8Iahr = parcelRequire("8Iahr");

var $gXyzc = parcelRequire("gXyzc");

var $izFrb = parcelRequire("izFrb");

var $8oPHJ = parcelRequire("8oPHJ");
class $663e4a591a2538f3$export$14576ae5bd1874a9 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $8Iahr.FieldVisitor)(this.tokens), this.terminalClauseRhsVisitor = new $663e4a591a2538f3$var$TerminalClauseRhsVisitor(this.tokens), this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $hGsJJ.getPositionFromContext)(ctx);
            return (0, $f26C8.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $663e4a591a2538f3$var$TerminalClauseRhsVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operatorVisitor = new (0, $izFrb.OperatorVisitor)(this.tokens), this.terminalClauseOperandVisitor = new $663e4a591a2538f3$var$TerminalClauseOperandVisitor(this.tokens), this.predicateVisitor = new (0, $8oPHJ.PredicateVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $dlsVE.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $dlsVE.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $dlsVE.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        }, // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $663e4a591a2538f3$var$TerminalClauseOperandVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $gXyzc.OperandVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        }, this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $dlsVE.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("gXyzc", function(module, exports) {
$parcel$export(module.exports, "OperandVisitor", () => $5b99f195f57794e4$export$ef8ae1aa15d9c9af);


var $f26C8 = parcelRequire("f26C8");

var $dlsVE = parcelRequire("dlsVE");

var $6BLGV = parcelRequire("6BLGV");

var $hGsJJ = parcelRequire("hGsJJ");

var $lkyYt = parcelRequire("lkyYt");

var $3wodm = parcelRequire("3wodm");
class $5b99f195f57794e4$export$ef8ae1aa15d9c9af extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $3wodm.StringVisitor)(this.tokens), this.numberVisitor = new (0, $lkyYt.NumberVisitor)(this.tokens), this.functionNameVisitor = new $5b99f195f57794e4$var$FunctionNameVisitor(this.tokens), this.argumentListVisitor = new $5b99f195f57794e4$var$ArgumentListVisitor(this.tokens), this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $dlsVE.notUndefined));
            return operandContext?.accept(this);
        }, this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $f26C8.internalCreators).keywordOperand((0, $862dfd240457f00b$export$1c46dca02aac24dd), (0, $hGsJJ.getPositionFromToken)(ctx.EMPTY().payload));
        }, this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $f26C8.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        }, this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $dlsVE.notUndefined));
            return (0, $f26C8.internalCreators).listOperand(values, (0, $hGsJJ.getPositionFromContext)(ctx));
        }, this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $f26C8.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $5b99f195f57794e4$var$FunctionNameVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $3wodm.StringVisitor)(this.tokens), this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $f26C8.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $f26C8.internalCreators).functionString(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
        };
    }
}
class $5b99f195f57794e4$var$ArgumentListVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $6BLGV.ArgumentVisitor)(this.tokens), this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("lkyYt", function(module, exports) {
$parcel$export(module.exports, "NumberVisitor", () => $13b9a4d8a58447ff$export$a55432f0884633e4);

var $f26C8 = parcelRequire("f26C8");

var $hGsJJ = parcelRequire("hGsJJ");
class $13b9a4d8a58447ff$export$a55432f0884633e4 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $f26C8.internalCreators).valueOperand(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("izFrb", function(module, exports) {
$parcel$export(module.exports, "OperatorVisitor", () => $a4639125907d4fdb$export$e56f89ba95b51d2a);

var $f26C8 = parcelRequire("f26C8");

var $8okjU = parcelRequire("8okjU");

var $hGsJJ = parcelRequire("hGsJJ");
class $a4639125907d4fdb$export$e56f89ba95b51d2a extends (0, $hGsJJ.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $8okjU.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $f26C8.internalCreators).operator(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $8okjU.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $f26C8.internalCreators).operator(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $8okjU.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $f26C8.internalCreators).operator(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args), // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $hGsJJ.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $hGsJJ.getPositionFromToken)(startToken, stopToken);
                if ((0, $8okjU.isOperator)(value)) return (0, $f26C8.internalCreators).operator(value, text, position);
            }
            return undefined;
        };
    }
}

});
parcelRegister("8okjU", function(module, exports) {
$parcel$export(module.exports, "isOperator", () => $b8349c898e9c75d9$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $b8349c898e9c75d9$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $b8349c898e9c75d9$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $b8349c898e9c75d9$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $b8349c898e9c75d9$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $b8349c898e9c75d9$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $b8349c898e9c75d9$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $b8349c898e9c75d9$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $b8349c898e9c75d9$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $b8349c898e9c75d9$export$b09522e4061bbdd6);

var $jPlb3 = parcelRequire("jPlb3");
const $b8349c898e9c75d9$export$4e40859592ee7ac2 = (operator)=>(0, $jPlb3.OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$6d0fc196fa8a1673 = (operator)=>(0, $jPlb3.EQUALS_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$ad91b6d6a89cb64e = (operator)=>(0, $jPlb3.LIKE_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$4477c442bd5c2a6d = (operator)=>(0, $jPlb3.COMPARISON_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$c5e1cdef30e30bff = (operator)=>(0, $jPlb3.IN_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$ccc3334744e395c7 = (operator)=>(0, $jPlb3.IS_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$2b1c5d7e7856f91d = (operator)=>(0, $jPlb3.WAS_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$55d8c9b20d99509f = (operator)=>(0, $jPlb3.WAS_IN_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$b65d23d23ade534b = (operator)=>(0, $jPlb3.CHANGED_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$b09522e4061bbdd6 = (operator)=>(0, $jPlb3.LIST_OPERATORS).includes(operator);

});


parcelRegister("8oPHJ", function(module, exports) {
$parcel$export(module.exports, "PredicateVisitor", () => $420de384afcf5c4a$export$33bb52a35c693109);

var $f26C8 = parcelRequire("f26C8");

var $3uowR = parcelRequire("3uowR");

var $dlsVE = parcelRequire("dlsVE");

var $hGsJJ = parcelRequire("hGsJJ");

var $gXyzc = parcelRequire("gXyzc");
class $420de384afcf5c4a$export$33bb52a35c693109 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.predicateOperatorVisitor = new $420de384afcf5c4a$var$PredicateOperatorVisitor(this.tokens), this.predicateOperandVisitor = new $420de384afcf5c4a$var$PredicateOperandVisitor(this.tokens), this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $hGsJJ.getPositionFromContext)(ctx);
            return (0, $f26C8.internalCreators).predicate(operator, operand, position);
        }, this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $hGsJJ.getPositionFromContext)(ctx);
            return (0, $f26C8.internalCreators).predicate(operator, operand, position);
        }, this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $dlsVE.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $420de384afcf5c4a$var$PredicateOperatorVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $3uowR.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $f26C8.internalCreators).predicateOperator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $420de384afcf5c4a$var$PredicateOperandVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $gXyzc.OperandVisitor)(this.tokens), this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("3uowR", function(module, exports) {
$parcel$export(module.exports, "isPredicateOperator", () => $577d846c3e6a050f$export$188978ad94919403);

var $cd96m = parcelRequire("cd96m");
const $577d846c3e6a050f$export$188978ad94919403 = (operator)=>(0, $cd96m.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("cd96m", function(module, exports) {
$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $6fe28dbc2f8a0a99$export$e200440af9f1d9f);
const $6fe28dbc2f8a0a99$export$3d56e2ae1b4bbbf9 = 'after';
const $6fe28dbc2f8a0a99$export$f0a816341603bb63 = 'before';
const $6fe28dbc2f8a0a99$export$cdc81c84f768d513 = 'by';
const $6fe28dbc2f8a0a99$export$8a5280c65e704c3d = 'during';
const $6fe28dbc2f8a0a99$export$71f882dcac65f97a = 'from';
const $6fe28dbc2f8a0a99$export$5685a35c6b0a7ee8 = 'on';
const $6fe28dbc2f8a0a99$export$5a83c4789e531a = 'to';
const $6fe28dbc2f8a0a99$export$e200440af9f1d9f = [
    $6fe28dbc2f8a0a99$export$3d56e2ae1b4bbbf9,
    $6fe28dbc2f8a0a99$export$f0a816341603bb63,
    $6fe28dbc2f8a0a99$export$cdc81c84f768d513,
    $6fe28dbc2f8a0a99$export$8a5280c65e704c3d,
    $6fe28dbc2f8a0a99$export$71f882dcac65f97a,
    $6fe28dbc2f8a0a99$export$5685a35c6b0a7ee8,
    $6fe28dbc2f8a0a99$export$5a83c4789e531a
];

});







parcelRegister("1jiqw", function(module, exports) {
$parcel$export(module.exports, "print", () => $c24354720bbe7250$export$c2d084dc44961371);

var $8sbs2 = parcelRequire("8sbs2");

var $9xrcu = parcelRequire("9xrcu");

var $gWLgz = parcelRequire("gWLgz");
const $c24354720bbe7250$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gWLgz.printDocToString)((0, $9xrcu.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("8sbs2", function(module, exports) {

var $d3Wo8 = parcelRequire("d3Wo8");

var $lgI96 = parcelRequire("lgI96");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $01969c2a577eb827$var$pick = $lgI96(function(object, paths) {
    return object == null ? {} : $d3Wo8(object, paths);
});
module.exports = $01969c2a577eb827$var$pick;

});
parcelRegister("d3Wo8", function(module, exports) {

var $8WT03 = parcelRequire("8WT03");

var $4tuSC = parcelRequire("4tuSC");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $9828d8da72c16145$var$basePick(object, paths) {
    return $8WT03(object, paths, function(value, path) {
        return $4tuSC(object, path);
    });
}
module.exports = $9828d8da72c16145$var$basePick;

});


parcelRegister("9xrcu", function(module, exports) {
$parcel$export(module.exports, "printAstToDoc", () => $4d18f5eec7d6c329$export$f0ef38932978952);


var $dl9fK = parcelRequire("dl9fK");

var $b8gMN = parcelRequire("b8gMN");
const $4d18f5eec7d6c329$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $4d18f5eec7d6c329$export$27a275559a5c8102 extends (0, $dl9fK.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $b8gMN.ifBreak)((0, $b8gMN.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $b8gMN.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $b8gMN.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $b8gMN.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $b8gMN.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $4d18f5eec7d6c329$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $b8gMN.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $b8gMN.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $b8gMN.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $b8gMN.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $b8gMN.group)([
            query.where.accept(this),
            (0, $b8gMN.ifBreak)((0, $b8gMN.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $b8gMN.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $b8gMN.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $4d18f5eec7d6c329$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $4d18f5eec7d6c329$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("dl9fK", function(module, exports) {
$parcel$export(module.exports, "AbstractJastVisitor", () => $eca78231bf7c6646$export$51be62b46ee668fd);
class $eca78231bf7c6646$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param _aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(_aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param _node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param _currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(_node, _currentResult) {
        return true;
    }
}

});

parcelRegister("b8gMN", function(module, exports) {
$parcel$export(module.exports, "group", () => $5fbb607da15f7724$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $5fbb607da15f7724$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $5fbb607da15f7724$export$dc84f6841f96b7da);
const $5fbb607da15f7724$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $5fbb607da15f7724$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $5fbb607da15f7724$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gWLgz", function(module, exports) {
$parcel$export(module.exports, "printDocToString", () => $ae252d48f146c7f1$export$316fc7e94b95b118);
const $ae252d48f146c7f1$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $ae252d48f146c7f1$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $ae252d48f146c7f1$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $ae252d48f146c7f1$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $ae252d48f146c7f1$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $ae252d48f146c7f1$var$printGroup(doc, context);
        case 'if-break':
            return $ae252d48f146c7f1$var$printIfBreak(doc, context);
        case 'new-line':
            return $ae252d48f146c7f1$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $ae252d48f146c7f1$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $ae252d48f146c7f1$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $ae252d48f146c7f1$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $ae252d48f146c7f1$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $ae252d48f146c7f1$var$printDoc(doc.breakContents, context);
    return $ae252d48f146c7f1$var$printDoc(doc.flatContents, context);
};
const $ae252d48f146c7f1$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $ae252d48f146c7f1$var$defaultPrintWidth = 100;
const $ae252d48f146c7f1$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $ae252d48f146c7f1$var$defaultPrintWidth } = options;
    const output = $ae252d48f146c7f1$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});



parcelRegister("5AElp", function(module, exports) {
$parcel$export(module.exports, "transformView", () => $8a756033577bb028$export$601ea8be46c5c28c);
const $8a756033577bb028$export$601ea8be46c5c28c = (view)=>({
        uuid: view.uuid,
        ownerId: view.owner,
        kind: view.visualizationType,
        title: view.name,
        emoji: view.emoji,
        description: view.description,
        apiResponse: view
    });

});



parcelRegister("9Ku9P", function(module, exports) {
$parcel$export(module.exports, "PremiumLozenge", () => $41cd091e8fa03364$export$b37ef9640eaa3746);

var $eJOHy = parcelRequire("eJOHy");

var $b1Zrw = parcelRequire("b1Zrw");

var $eKt3l = parcelRequire("eKt3l");
const $41cd091e8fa03364$export$b37ef9640eaa3746 = ({ children: children })=>{
    const isVisible = (0, $eKt3l.useIsPremiumLozengeVisible)();
    return isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1Zrw.PaidFeatureAwarenessPremiumLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};

});
parcelRegister("eKt3l", function(module, exports) {
$parcel$export(module.exports, "useIsPremiumLozengeVisible", () => $12cb4a293a4e170d$export$894065ae16e309f2);

var $eJOHy = parcelRequire("eJOHy");

var $fRXNt = parcelRequire("fRXNt");

var $8Q6yE = parcelRequire("8Q6yE");

const $12cb4a293a4e170d$export$894065ae16e309f2 = ()=>{
    const isPremium = (0, $fRXNt.useIsPremiumEdition)();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const trialEndDate = productEntitlementDetails?.[0, $c67afc22d109ff7f$export$9062e724eddb8377]?.trialEndTime;
    return (0, $eJOHy.useMemo)(()=>{
        return isPremium && trialEndDate && trialEndDate - Date.now() > 0;
    }, [
        trialEndDate,
        isPremium
    ]);
};

});
parcelRegister("fRXNt", function(module, exports) {
$parcel$export(module.exports, "useIsPremiumEdition", () => $b0ffb33e1d479a9f$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $b0ffb33e1d479a9f$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $b0ffb33e1d479a9f$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $b0ffb33e1d479a9f$export$304793dd2c5f4db0);

var $4cTDP = parcelRequire("4cTDP");

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");
const $b0ffb33e1d479a9f$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const jpdEdition = (0, $cblKs.getEdition)((0, $lBYgs.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $cblKs.toEdition)((0, $cblKs.PREMIUM_EDITION));
};
const $b0ffb33e1d479a9f$export$642bac71144485ad = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const jpdEdition = (0, $cblKs.getEdition)((0, $lBYgs.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $cblKs.toEdition)((0, $cblKs.STANDARD_EDITION));
};
const $b0ffb33e1d479a9f$export$a94405ffcb20c356 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    return isPremium;
};
const $b0ffb33e1d479a9f$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    return isPremium;
};
const $b0ffb33e1d479a9f$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    const isStandard = $b0ffb33e1d479a9f$export$642bac71144485ad();
    if (!(0, $4cTDP.fg)('jpd_itr-beta-removal-release')) {
        if (isStandard && (0, $4cTDP.fg)('jpd_issues_relationships_eap_lighthouse_customer')) return true;
    }
    return isPremium;
};

});

const $c67afc22d109ff7f$export$9062e724eddb8377 = 'jira-product-discovery';



parcelRegister("fqYMs", function(module, exports) {
$parcel$export(module.exports, "useCollectionSelectedMatch", () => $4f734d559e0a282b$export$f8678ffe77a81702);
$parcel$export(module.exports, "useIsCollectionsSelected", () => $4f734d559e0a282b$export$bff956e91a23208e);
$parcel$export(module.exports, "useIsJpdProjectView", () => $4f734d559e0a282b$export$dbf8a4da34593bdd);
$parcel$export(module.exports, "useIsCollectionSelected", () => $4f734d559e0a282b$export$d1d2d8dc13ec1cf);
$parcel$export(module.exports, "getViewUrl", () => $4f734d559e0a282b$export$bdccd6a672e4a607);

var $kfvK2 = parcelRequire("kfvK2");

var $bQoR3 = parcelRequire("bQoR3");
const $4f734d559e0a282b$export$f8678ffe77a81702 = (0, $kfvK2.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    const isCollectionSelected = route.name === 'polaris-collections' && collectionUUID !== undefined && viewUUID !== undefined;
    return isCollectionSelected ? {
        collectionUUID: collectionUUID,
        viewUUID: viewUUID
    } : undefined;
});
const $4f734d559e0a282b$export$bff956e91a23208e = (0, $kfvK2.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    return route.name === 'polaris-collections' && viewUUID === undefined && collectionUUID === undefined;
});
const $4f734d559e0a282b$export$dbf8a4da34593bdd = (0, $kfvK2.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    return route.name === 'polaris-ideas' && viewUUID !== undefined;
});
const $4f734d559e0a282b$export$d1d2d8dc13ec1cf = (options)=>{
    const collectionMatched = $4f734d559e0a282b$export$f8678ffe77a81702();
    if (options?.collectionUUID) return collectionMatched && collectionMatched.collectionUUID === options.collectionUUID;
    return Boolean(collectionMatched);
};
const $4f734d559e0a282b$export$bdccd6a672e4a607 = ({ container: container, view: view })=>{
    // In collections we don't use `view.polarisId` like we do in jpd-project-menu
    // but instead we use `view.id` that contains UUID
    return (0, $bQoR3.getCollectionViewPageUrl)(container.collectionUUID, view.id);
};

});

parcelRegister("jThqL", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $a3d4770c7341a93a$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $bQoR3 = parcelRequire("bQoR3");

var $jQm53 = parcelRequire("jQm53");

var $92oWt = parcelRequire("92oWt");
const $a3d4770c7341a93a$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $eJOHy.useContext)((0, $jQm53.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        href: (0, $bQoR3.getCollectionsPageUrl)(),
        menuId: (0, $h4Bzb.MENU_ID_ROADMAPS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage((0, $92oWt.default).viewAllRoadmaps)))));
};

});
parcelRegister("jQm53", function(module, exports) {
$parcel$export(module.exports, "AnalyticContext", () => $ec48c897812e3adc$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $ec48c897812e3adc$export$aea8e3edcdec81e3);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $7i4qI = parcelRequire("7i4qI");
const $ec48c897812e3adc$export$da0556bf821b3494 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForRoadmapsItems: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $ec48c897812e3adc$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: (0, $7i4qI.VIEW_ALL_ROADMAPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $eJOHy.useCallback)(({ itemId: itemId })=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $eJOHy.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'roadmap',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForRoadmapsItems = (0, $eJOHy.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                itemType: (0, $6bf6536f83c22cfe$export$bb8a37ab8d9ba82b).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForRoadmapsItems: fireUIAnalyticForRoadmapsItems
        }), [
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem,
        fireUIAnalyticForRoadmapsItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec48c897812e3adc$export$da0556bf821b3494.Provider, {
        value: value
    }, children);
};

});

parcelRegister("92oWt", function(module, exports) {
$parcel$export(module.exports, "default", () => $f847c23bf792aa3c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f847c23bf792aa3c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllRoadmaps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.footer.view-all-roadmaps",
        "defaultMessage": "View all roadmaps"
    }
});

});



parcelRegister("3n4ak", function(module, exports) {
$parcel$export(module.exports, "ActionButtonsStatic", () => $e387fffe39d8e230$export$d29fef02bcf1ee7);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $jUgeq = parcelRequire("jUgeq");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $8IuE5 = parcelRequire("8IuE5");

var $ajqBI = parcelRequire("ajqBI");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $jQm53 = parcelRequire("jQm53");

var $7i4qI = parcelRequire("7i4qI");

var $dfwn8 = parcelRequire("dfwn8");
const $e387fffe39d8e230$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).ROADMAPS,
        hasSeparator: false
    }));
const $e387fffe39d8e230$export$d29fef02bcf1ee7 = /*#__PURE__*/ (0, $eJOHy.memo)(({ isReadOnly: isReadOnly, isCreadRoadmapLoading: isCreadRoadmapLoading, isCreateRoadmapDisabled: isCreateRoadmapDisabled, createRoadmapTooltipContent: createRoadmapTooltipContent, onCreateRoadmapClick: onCreateRoadmapClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $eJOHy.useContext)((0, $jQm53.AnalyticContext));
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $7i4qI.MEATBALL_DROPDOWN)
        });
    }, [
        fireUIAnalyticForFixButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: createRoadmapTooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $dfwn8.messages).createRoadmap),
        isLoading: isCreadRoadmapLoading,
        isDisabled: isCreateRoadmapDisabled,
        onClick: onCreateRoadmapClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: $e387fffe39d8e230$var$MenuItems
    }));
});

});
parcelRegister("dfwn8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fbcd7e20c99885e9$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fbcd7e20c99885e9$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    createRoadmap: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons-static.create-roadmap",
        "defaultMessage": "Create roadmap"
    }
});

});


parcelRegister("lOxEr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iaViG").then(()=>parcelRequire('7h3zr'));

});


parcelRegister("g0Ue2", function(module, exports) {
$parcel$export(module.exports, "Starred", () => $9ed8831c729c8fd6$export$8cd2a0520fb55072);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");

var $fTYy4 = parcelRequire("fTYy4");

var $fllrh = parcelRequire("fllrh");
const $9ed8831c729c8fd6$export$8cd2a0520fb55072 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-starred"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "starred",
        packageName: (0, $fTYy4.PACKAGE_NAME),
        teamName: (0, $fTYy4.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fllrh.StarredFlyoutMenuItem), null)));

});
parcelRegister("fTYy4", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $992ebd70482a7abb$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $992ebd70482a7abb$export$d57b6b390e78d90f);
$parcel$export(module.exports, "FAVOURITE_QUERY_LIMIT", () => $992ebd70482a7abb$export$77881eca52f4f5a6);
$parcel$export(module.exports, "FAVORITE_TYPE_MAP", () => $992ebd70482a7abb$export$c2849e00cccc2078);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MAP", () => $992ebd70482a7abb$export$531e43cc63c1e036);
$parcel$export(module.exports, "VALID_FAVORITE_TYPES", () => $992ebd70482a7abb$export$336e25f77ad481a9);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM", () => $992ebd70482a7abb$export$85266ed7d25f274d);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE", () => $992ebd70482a7abb$export$de9a288dad6f35f1);
$parcel$export(module.exports, "SEARCH_STARRED_ITEMS", () => $992ebd70482a7abb$export$6b181848cd9c8308);
$parcel$export(module.exports, "FILTER", () => $992ebd70482a7abb$export$c1c49903035a02df);

var $liZWd = parcelRequire("liZWd");
const $992ebd70482a7abb$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Starred';
const $992ebd70482a7abb$export$d57b6b390e78d90f = 'jira-cosmos';
const $992ebd70482a7abb$export$77881eca52f4f5a6 = 15;
const $992ebd70482a7abb$export$c2849e00cccc2078 = {
    PROJECT: 'PROJECT',
    FILTER: 'FILTER',
    DASHBOARD: 'DASHBOARD',
    PLAN: 'PLAN',
    BOARD: 'BOARD',
    QUEUE: 'QUEUE'
};
const $992ebd70482a7abb$export$531e43cc63c1e036 = {
    ...$992ebd70482a7abb$export$c2849e00cccc2078,
    ALL: 'ALL'
};
const $992ebd70482a7abb$export$336e25f77ad481a9 = Object.values($992ebd70482a7abb$export$c2849e00cccc2078);
const $992ebd70482a7abb$export$85266ed7d25f274d = {
    [$992ebd70482a7abb$export$531e43cc63c1e036.PROJECT]: (0, $liZWd.messages).projects,
    [$992ebd70482a7abb$export$531e43cc63c1e036.FILTER]: (0, $liZWd.messages).filters,
    [$992ebd70482a7abb$export$531e43cc63c1e036.DASHBOARD]: (0, $liZWd.messages).dashboards,
    [$992ebd70482a7abb$export$531e43cc63c1e036.PLAN]: (0, $liZWd.messages).plans,
    [$992ebd70482a7abb$export$531e43cc63c1e036.BOARD]: (0, $liZWd.messages).boards,
    [$992ebd70482a7abb$export$531e43cc63c1e036.QUEUE]: (0, $liZWd.messages).queues,
    [$992ebd70482a7abb$export$531e43cc63c1e036.ALL]: (0, $liZWd.messages).all
};
const $992ebd70482a7abb$export$de9a288dad6f35f1 = {
    [$992ebd70482a7abb$export$531e43cc63c1e036.PROJECT]: (0, $liZWd.messages).projectsGalaxia,
    [$992ebd70482a7abb$export$531e43cc63c1e036.FILTER]: (0, $liZWd.messages).filters,
    [$992ebd70482a7abb$export$531e43cc63c1e036.DASHBOARD]: (0, $liZWd.messages).dashboards,
    [$992ebd70482a7abb$export$531e43cc63c1e036.PLAN]: (0, $liZWd.messages).plans,
    [$992ebd70482a7abb$export$531e43cc63c1e036.BOARD]: (0, $liZWd.messages).boards,
    [$992ebd70482a7abb$export$531e43cc63c1e036.QUEUE]: (0, $liZWd.messages).queues,
    [$992ebd70482a7abb$export$531e43cc63c1e036.ALL]: (0, $liZWd.messages).all
};
const $992ebd70482a7abb$export$6b181848cd9c8308 = 'searchStarredItems';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $992ebd70482a7abb$var$VIEW_ALL_STARRED_ITEMS = 'viewAllStarredItems';
const $992ebd70482a7abb$export$c1c49903035a02df = 'filter';

});
parcelRegister("liZWd", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6104af8dee8eec40$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6104af8dee8eec40$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-starred.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-starred.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-starred.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-starred.common.plans",
        "defaultMessage": "Plans"
    },
    boards: {
        "id": "navigation-apps-sidebar-nav4-starred.common.boards",
        "defaultMessage": "Boards"
    },
    queues: {
        "id": "navigation-apps-sidebar-nav4-starred.common.queues",
        "defaultMessage": "Queues"
    },
    all: {
        "id": "navigation-apps-sidebar-nav4-starred.common.all",
        "defaultMessage": "All"
    },
    projectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-starred.common.projects-galaxia",
        "defaultMessage": "Spaces"
    }
});

});


parcelRegister("fllrh", function(module, exports) {
$parcel$export(module.exports, "StarredFlyoutMenuItem", () => $f51d7f6f962004e1$export$b5a36b539503145d);

var $eJOHy = parcelRequire("eJOHy");

var $aaIe7 = parcelRequire("aaIe7");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");


var $a9aec = parcelRequire("a9aec");

var $80rA3 = parcelRequire("80rA3");

var $8IuE5 = parcelRequire("8IuE5");

var $if69u = parcelRequire("if69u");

var $2QH3X = parcelRequire("2QH3X");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cHtIB = parcelRequire("cHtIB");

var $fTYy4 = parcelRequire("fTYy4");

var $57LT2 = parcelRequire("57LT2");

var $hjIwz = parcelRequire("hjIwz");
const $f51d7f6f962004e1$var$EMPTY_OBJECT = {};
function $f51d7f6f962004e1$export$b5a36b539503145d() {
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $hjIwz.sidebarStarredMenuEntryPoint), (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            filter: {
                types: (0, $fTYy4.VALID_FAVORITE_TYPES),
                sort: {
                    order: 'DESC'
                }
            },
            count: (0, $fTYy4.FAVOURITE_QUERY_LIMIT)
        }), [
        cloudId
    ]));
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $57LT2.default).starred, (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))));
    const onOpenChangeHandler = (0, $eJOHy.useCallback)(async (isOpen)=>{
        if (isOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).STARRED);
            (0, $kRgKj.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_STARRED), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWy6a.FlyoutMenuItem), {
        onOpenChange: onOpenChangeHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yLgR2.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-starred",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duFAq.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-starred-default",
        packageName: (0, $fTYy4.PACKAGE_NAME),
        teamName: (0, $fTYy4.TEAM_NAME),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
            isFlyout: true,
            withHeading: true,
            withSearch: true
        }),
        // Props for the root component.
        runtimeProps: $f51d7f6f962004e1$var$EMPTY_OBJECT
    })));
}

});
parcelRegister("57LT2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c8e62a3a86ce682$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5c8e62a3a86ce682$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    starred: {
        "id": "navigation-apps-sidebar-nav4-starred.starred",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("hjIwz", function(module, exports) {
$parcel$export(module.exports, "sidebarStarredMenuEntryPoint", () => $afba6c50f7224e36$export$72aec40208131d);

var $8pFhm = parcelRequire("8pFhm");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $afba6c50f7224e36$export$72aec40208131d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8PVuI")), {
        moduleId: "104016cb",
        moduleName: "StarredMenu",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, filter: filter, count: count })=>({
            queries: {
                starredMenuData: {
                    parameters: $8pFhm.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        filter: filter
                    }
                }
            }
        })
});

});
parcelRegister("8pFhm", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ebff236f720c9ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad71ee086d6c9b9878534a3c1d5a5952>>
 * @relayHash 97dd204f6b2b4594e98fd72f5ba64666
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71dde27bf7f87fb36e4855eeaf3e8212e6070af4f5c67b3f28ac3961927adc01

var $37Ewn = parcelRequire("37Ewn");
const $4ebff236f720c9ac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v7 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isNode"
    }, v13 = [
        v9 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                },
                v12 /*: any*/ 
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StarredMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "allFavourites",
                                "args": v5 /*: any*/ ,
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.allFavourites.pageInfo"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "StarredMenu"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StarredMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "allFavourites",
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "StarredMenuListContent_starredItems",
                            "kind": "LinkedHandle",
                            "name": "favourites"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71dde27bf7f87fb36e4855eeaf3e8212e6070af4f5c67b3f28ac3961927adc01",
            "metadata": {},
            "name": "StarredMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4ebff236f720c9ac$var$node.hash = "fe54dd259a64768769310002e3616b4c";
(0, $37Ewn.PreloadableQueryRegistry).set($4ebff236f720c9ac$var$node.params.id, $4ebff236f720c9ac$var$node);
var $4ebff236f720c9ac$export$2e2bcd8739ae039 = $4ebff236f720c9ac$var$node;

});

parcelRegister("8PVuI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4uhlL").then(()=>parcelRequire('ior5s'));

});




parcelRegister("i8N06", function(module, exports) {
$parcel$export(module.exports, "Teams", () => $a66e8fcb2eff0bac$export$b3a34d915d8dd11e);

var $eJOHy = parcelRequire("eJOHy");

var $aXbkt = parcelRequire("aXbkt");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");


var $lCuJx = parcelRequire("lCuJx");
const $a66e8fcb2eff0bac$export$b3a34d915d8dd11e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4-sidebar-teams"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "teams",
        packageName: (0, $fc0de1b8d7119b0d$export$b8b9d90f9e5bd72b),
        teamName: (0, $fc0de1b8d7119b0d$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aXbkt.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lCuJx.TeamsMenu), null))));

});
const $fc0de1b8d7119b0d$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Teams';
const $fc0de1b8d7119b0d$export$d57b6b390e78d90f = 'People and Teams Collective';
const $fc0de1b8d7119b0d$export$f17fc93a893ec45c = 'add';
const $fc0de1b8d7119b0d$export$6ee8a54637c51e7d = 'createATeam';
const $fc0de1b8d7119b0d$export$b3dcfa0224e0289c = 'invitePeople';
const $fc0de1b8d7119b0d$export$f06dfcec5ff912e = 'meatballDropdown';
const $fc0de1b8d7119b0d$export$1245c8aac7dab260 = '/jira/people/search';

parcelRegister("lCuJx", function(module, exports) {
$parcel$export(module.exports, "TeamsMenu", () => $4ab3ba2b2051f6c9$export$deb84fb5c6bff4b0);

var $eJOHy = parcelRequire("eJOHy");

var $79KhM = parcelRequire("79KhM");

var $dcLzM = parcelRequire("dcLzM");

var $Ay1uj = parcelRequire("Ay1uj");

var $7saMl = parcelRequire("7saMl");
var $jUgeq = parcelRequire("jUgeq");

var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $2dvSy = parcelRequire("2dvSy");

var $8nMzv = parcelRequire("8nMzv");

var $lRq8t = parcelRequire("lRq8t");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jRu18 = parcelRequire("jRu18");


var $j6opr = parcelRequire("j6opr");

var $dIJOd = parcelRequire("dIJOd");

var $4cTDP = parcelRequire("4cTDP");


var $k8PfX = parcelRequire("k8PfX");

var $cFGzN = parcelRequire("cFGzN");

var $2VH7W = parcelRequire("2VH7W");
const $4ab3ba2b2051f6c9$var$PopupContent = ({ openTeamsPopup: openTeamsPopup, createTeamModalTrigger: createTeamModalTrigger })=>{
    const invitePeopleModalTrigger = (0, $2VH7W.useInvitePeopleModal)();
    const actionSubjectId = (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS];
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: (0, $fc0de1b8d7119b0d$export$b3dcfa0224e0289c)
            }
        });
        invitePeopleModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        invitePeopleModalTrigger,
        openTeamsPopup
    ]);
    const onCreateTeamClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: (0, $fc0de1b8d7119b0d$export$6ee8a54637c51e7d)
            }
        });
        createTeamModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $4ab3ba2b2051f6c9$var$teamsMenuStyle
    }, !(0, $4cTDP.fg)('hot-121631-disable-teams-menu-invite-people') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: onButtonClick
    }, formatMessage((0, $k8PfX.default).invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: onCreateTeamClick
    }, formatMessage((0, $k8PfX.default).createTeam)));
};
const $4ab3ba2b2051f6c9$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $h4Bzb.MENU_ID_TEAMS),
        hasSeparator: false
    }));
const $4ab3ba2b2051f6c9$export$deb84fb5c6bff4b0 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const [isOpenTeamsPopup, openTeamsPopup] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).TEAMS);
    const location = (0, $jRu18.useLocation)();
    const path = location.pathname + location.search;
    const isSelected = path === (0, $fc0de1b8d7119b0d$export$1245c8aac7dab260);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const actionSubjectId = (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS];
    const label = formatMessage((0, $k8PfX.default).addButton);
    const [createTeamModal, createTeamModalTrigger] = (0, $cFGzN.useCreateTeamModal)();
    const onLinkClick = (0, $eJOHy.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            menuId: (0, $8IuE5.L1_MENU_ID).TEAMS,
            sectionItem: (0, $a9aec.SECTION_ITEM_TEAMS)
        });
    }, [
        sendSectionItemAnalyticsEvent
    ]);
    const onPlusButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: (0, $fc0de1b8d7119b0d$export$f17fc93a893ec45c)
            }
        });
        openTeamsPopup(true);
    }, [
        createAnalyticsEvent,
        actionSubjectId
    ]);
    const isTailoredOnboarding = (0, $j6opr.isTailoredOnboardingEnabled)();
    const peopleMenuWrapperRef = (0, $79KhM.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$77bc79debbf5c069), isTailoredOnboarding || (0, $4cTDP.fg)('tailored_onboarding_m2p5_gate')).ref;
    const renderContent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ab3ba2b2051f6c9$var$PopupContent, {
            openTeamsPopup: openTeamsPopup,
            createTeamModalTrigger: createTeamModalTrigger
        });
    }, [
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    const onMoreNavMenuButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: (0, $fc0de1b8d7119b0d$export$f06dfcec5ff912e)
            }
        });
    }, [
        actionSubjectId,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, createTeamModal, (isTailoredOnboarding || (0, $4cTDP.fg)('tailored_onboarding_m2p5_gate')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dIJOd.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        ref: isTailoredOnboarding || (0, $4cTDP.fg)('tailored_onboarding_m2p5_gate') ? peopleMenuWrapperRef : undefined,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams",
        href: (0, $fc0de1b8d7119b0d$export$1245c8aac7dab260),
        isSelected: isSelected,
        elemBefore: icon,
        onClick: onLinkClick,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            messageId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.popup",
            messageType: "transactional",
            onClose: (0, $eJOHy.useCallback)(()=>openTeamsPopup(false), []),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                    ...triggerProps,
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                            ...iconProps,
                            size: "small"
                        }),
                    appearance: "subtle",
                    spacing: "compact",
                    testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams-popup-trigger",
                    isSelected: isOpenTeamsPopup,
                    label: label,
                    tooltip: {
                        content: label
                    },
                    isTooltipDisabled: false,
                    onClick: onPlusButtonClick
                }),
            isOpen: isOpenTeamsPopup,
            content: renderContent
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
            onOpen: onMoreNavMenuButtonClick,
            MenuItems: $4ab3ba2b2051f6c9$var$MenuItems
        }))
    }, formattedMessage));
});
const $4ab3ba2b2051f6c9$var$teamsMenuStyle = (0, $1DXK0.xcss)({
    minWidth: '260px',
    paddingBlock: 'space.100'
});

});
parcelRegister("j6opr", function(module, exports) {
$parcel$export(module.exports, "isTailoredOnboardingScrumAndSoftwareKanbanEnabled", () => $65f12fd0230d3118$export$5dd90adc2e8ee137);
$parcel$export(module.exports, "isTailoredOnboardingEnabled", () => $65f12fd0230d3118$export$8eec918bc6d2ab67);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingScrumAndSoftwareKanban", () => $65f12fd0230d3118$export$713219ba4b63fe78);
$parcel$export(module.exports, "useIsTailoredOnboardingEnabledAndEligible", () => $65f12fd0230d3118$export$46047e5fecf4cae5);
$parcel$export(module.exports, "isTailoredOnboardingEnabledWithExposure", () => $65f12fd0230d3118$export$142e2425d224298f);
$parcel$export(module.exports, "useIsTailoredOnboardingM2p5EligibleWithExposure", () => $65f12fd0230d3118$export$fd0589feb622f26b);
$parcel$export(module.exports, "useIsScrumProject", () => $65f12fd0230d3118$export$f9373c9ef51fa1f4);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $iaU5H = parcelRequire("iaU5H");

var $lMSWJ = parcelRequire("lMSWJ");

var $2aY2d = parcelRequire("2aY2d");

var $f4Iys = parcelRequire("f4Iys");


var $8rGQ0 = parcelRequire("8rGQ0");

var $kRgKj = parcelRequire("kRgKj");

var $ftN6c = parcelRequire("ftN6c");

var $3wPiD = parcelRequire("3wPiD");
const $65f12fd0230d3118$export$7889b94f54c2d416 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $cxKOj.UNSAFE_noExposureExp)('tailored_onboarding_m3');
    return (0, $4cTDP.fg)('tailored_onboarding_m3_gate') && expConfig.get('isEnabled', false);
};
const $65f12fd0230d3118$export$5dd90adc2e8ee137 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $cxKOj.UNSAFE_noExposureExp)('tailored_onboarding_scrum_and_software_kanban');
    return expConfig.get('isEnabled', false);
};
const $65f12fd0230d3118$export$8eec918bc6d2ab67 = ()=>{
    return $65f12fd0230d3118$export$7889b94f54c2d416() || $65f12fd0230d3118$export$5dd90adc2e8ee137();
};
const $65f12fd0230d3118$export$54c132e77bb6d105 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $2b839a8453de5367$export$b8b1ac856ba1434b);
    const isKanbanTemplate = templateKey?.startsWith((0, $f4Iys.KANBAN_TEAM_MANAGED_KEY));
    if (isKanbanTemplate && !isSoftwareTeamType && $65f12fd0230d3118$export$7889b94f54c2d416()) return true;
    return false;
};
const $65f12fd0230d3118$export$713219ba4b63fe78 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin, fireExposure: fireExposure = false, analyticEvent: analyticEvent })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $2b839a8453de5367$export$b8b1ac856ba1434b);
    const isScrumTemplate = templateKey?.startsWith((0, $f4Iys.SCRUM_TEAM_MANAGED_KEY));
    const isKanbanTemplate = templateKey?.startsWith((0, $f4Iys.KANBAN_TEAM_MANAGED_KEY));
    // Software Kanban or Scrum all Team Types
    if (isKanbanTemplate && isSoftwareTeamType || isScrumTemplate) {
        // User is eligible for experiment. Fires exposure for those in control too here
        if (fireExposure) {
            analyticEvent && (0, $kRgKj.fireTrackAnalytics)(analyticEvent, 'tailoredOnboardingWithScrumAndSoftwareKanban personalised', {
                teamType: teamType,
                templateKey: templateKey,
                isEnabled: (0, $cxKOj.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false)
            });
            return (0, $cxKOj.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false);
        }
        if ($65f12fd0230d3118$export$5dd90adc2e8ee137()) return true;
    }
    return false;
};
const $65f12fd0230d3118$export$5188e1ffa34f6a91 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    return $65f12fd0230d3118$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    }) || $65f12fd0230d3118$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
};
const $65f12fd0230d3118$export$46047e5fecf4cae5 = ()=>{
    const isEnabled = $65f12fd0230d3118$export$8eec918bc6d2ab67();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    const projectType = projectData?.projectType;
    const isSoftwareProject = projectType === 'software';
    const shouldFetch = isEnabled && isSiteAdmin && isSoftwareProject && !(0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name');
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $iaU5H.useTeamTypeShortHand)({
        shouldFetch: shouldFetch
    });
    const { loading: projectContextLoading, data: projectContext } = (0, $2aY2d.useProjectContext)();
    const { isReady: templateKeyIsReady, data: templateKey } = (0, $lMSWJ.useFetchInitialProjectTemplateName)({
        shouldFetch: shouldFetch,
        projectId: projectContext?.projectId
    });
    if ((0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    if (!isEnabled) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    const isTailoredOnboardingM3EnabledAndEligible = $65f12fd0230d3118$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    const isTailoredOnboardingEnabledWithScrumAndSoftware = $65f12fd0230d3118$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    return {
        isReady: teamTypeIsReady && templateKeyIsReady && !projectContextLoading,
        isTailoredOnboardingM3EnabledAndEligible: isEnabled && isTailoredOnboardingM3EnabledAndEligible,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: isEnabled && isTailoredOnboardingEnabledWithScrumAndSoftware,
        teamType: teamType
    };
};
const $65f12fd0230d3118$export$142e2425d224298f = ({ isSiteAdmin: isSiteAdmin, analyticEvent: analyticEvent, teamType: teamType, templateKey: templateKey })=>{
    if ($65f12fd0230d3118$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    })) {
        (0, $kRgKj.fireTrackAnalytics)(analyticEvent, 'tailoredM3Redirect personalised', {
            teamType: teamType,
            templateKey: templateKey,
            isEnabled: (0, $cxKOj.expVal)('tailored_onboarding_m3', 'isEnabled', false)
        });
        return (0, $cxKOj.expVal)('tailored_onboarding_m3', 'isEnabled', false);
    }
    return $65f12fd0230d3118$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin,
        fireExposure: true,
        analyticEvent: analyticEvent
    });
};
const $65f12fd0230d3118$export$fd0589feb622f26b = ({ isBusinessProject: isBusinessProject, isTrelloCrossflow: isTrelloCrossflow, isOnboarding: isOnboarding })=>{
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const isBasicEligible = isSiteAdmin && isBusinessProject && !isTrelloCrossflow;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $iaU5H.useTeamTypeShortHand)({
        shouldFetch: isBasicEligible
    });
    const isTargettedTeamType = ![
        (0, $2b839a8453de5367$export$4f3cb0844009af52),
        (0, $2b839a8453de5367$export$e4824f74b9879164)
    ].includes(teamType ?? '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOnce = (0, $eJOHy.useRef)(false);
    if (!isBasicEligible) return {
        isEligible: false,
        isReady: true
    };
    if (!teamTypeIsReady) return {
        isEligible: undefined,
        isReady: false
    };
    if (isBusinessProject && isSiteAdmin && isTargettedTeamType) {
        if (!fireOnce.current) {
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'tailoredM2p5 exposed', {
                teamType: teamType,
                isOnboarding: isOnboarding,
                isEnabled: (0, $cxKOj.expVal)('tailored_onboarding_m2p5', 'isEnabled', false)
            });
            fireOnce.current = true;
        }
        return {
            isEligible: (0, $cxKOj.expVal)('tailored_onboarding_m2p5', 'isEnabled', false),
            isReady: true,
            teamType: teamType
        };
    }
    return {
        isEligible: false,
        isReady: true,
        teamType: teamType
    };
};
const $65f12fd0230d3118$export$f9373c9ef51fa1f4 = ()=>{
    if (!$65f12fd0230d3118$export$5dd90adc2e8ee137()) return false;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: data } = (0, $3wPiD.useFeatures)();
    return (data?.hasSprint && data?.hasBacklog) ?? false;
};

});
parcelRegister("iaU5H", function(module, exports) {
$parcel$export(module.exports, "useUserEmailDomain", () => $a6df81812f31a424$export$f95c1c6f997ec47f);
$parcel$export(module.exports, "useAtlassianAccount", () => $a6df81812f31a424$export$19d38f479bd18098);
$parcel$export(module.exports, "useTeamTypeShortHand", () => $a6df81812f31a424$export$1a086dfae472ccfe);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $bonXV = parcelRequire("bonXV");


var $afhdY = parcelRequire("afhdY");

var $LT9wJ = parcelRequire("LT9wJ");
const $a6df81812f31a424$export$d4c72bab9d6cc13a = {
    isFetching: false,
    wasFetchedOnce: false,
    fetchError: null
};
const $a6df81812f31a424$var$Store = (0, $GtRbT.createStore)({
    initialState: $a6df81812f31a424$export$d4c72bab9d6cc13a,
    actions: $LT9wJ.actions,
    name: 'atlassian-account'
});
const $a6df81812f31a424$var$loggedInEmailDomainSelector = (0, $4MchI.createSelector)((state)=>state.data, (accountInfo)=>{
    if (!accountInfo) return null;
    const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];
    return loggedInEmailDomain;
});
const $a6df81812f31a424$export$2a9b22328f7b68fa = (0, $iJq0l.createHook)($a6df81812f31a424$var$Store, {
    selector: $a6df81812f31a424$var$loggedInEmailDomainSelector
});
const $a6df81812f31a424$export$f95c1c6f997ec47f = (isEligibleToCall = true)=>{
    const [loggedInEmailDomain, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $a6df81812f31a424$export$2a9b22328f7b68fa();
    (0, $eJOHy.useEffect)(()=>{
        if (isEligibleToCall && !loggedInEmailDomain) fetchAtlassianAccountData();
    }, [
        fetchAtlassianAccountData,
        isEligibleToCall,
        loggedInEmailDomain
    ]);
    return {
        data: loggedInEmailDomain
    };
};
const $a6df81812f31a424$export$19d38f479bd18098 = (0, $iJq0l.createHook)($a6df81812f31a424$var$Store);
const $a6df81812f31a424$export$1a086dfae472ccfe = ({ shouldFetch: shouldFetch })=>{
    const [{ data: atlassianAccountData, isFetching: isFetching, wasFetchedOnce: wasFetchedOnce, fetchError: fetchError }, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $a6df81812f31a424$export$19d38f479bd18098();
    const localStorageTeamTypeShorthand = (0, $bonXV.localStorageProvider).get((0, $2b839a8453de5367$export$c06666264cd35603));
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFetch && !localStorageTeamTypeShorthand && !isFetching && !wasFetchedOnce) fetchAtlassianAccountData({
            source: 'useTeamTypeShortHand'
        });
    }, [
        fetchAtlassianAccountData,
        isFetching,
        localStorageTeamTypeShorthand,
        shouldFetch,
        wasFetchedOnce
    ]);
    if (localStorageTeamTypeShorthand) return {
        isReady: true,
        teamType: localStorageTeamTypeShorthand,
        fetchError: fetchError
    };
    if (!shouldFetch) return {
        isReady: true,
        teamType: (0, $afhdY.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType),
        fetchError: fetchError
    };
    if (atlassianAccountData?.extendedProfile.teamType && !localStorageTeamTypeShorthand) (0, $bonXV.localStorageProvider).set((0, $2b839a8453de5367$export$c06666264cd35603), (0, $afhdY.mapUserSegmentationFullToShorthand)(atlassianAccountData.extendedProfile.teamType));
    return {
        isReady: !isFetching && wasFetchedOnce,
        teamType: (0, $afhdY.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType),
        fetchError: fetchError
    };
};

});
parcelRegister("bonXV", function(module, exports) {
$parcel$export(module.exports, "sessionStorageProvider", () => $d3902f951848120d$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorageProvider", () => $d3902f951848120d$export$aa821bfb3308a1f5);

var $3hRxq = parcelRequire("3hRxq");

var $8tIrO = parcelRequire("8tIrO");




const $d3902f951848120d$export$5a24cb3021127ff7 = (0, $8tIrO.createSessionExpirableStorageProvider)('onboarding-core');
const $d3902f951848120d$export$aa821bfb3308a1f5 = (0, $3hRxq.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("afhdY", function(module, exports) {
$parcel$export(module.exports, "mapUserSegmentationFullToShorthand", () => $42441bb11ea9f3be$export$8897f7082e20c8df);

const $42441bb11ea9f3be$export$8897f7082e20c8df = (teamTypeFromMe)=>{
    switch(teamTypeFromMe){
        case 0, $2b839a8453de5367$export$e07d1fa2da8ed874:
            return 0, $2b839a8453de5367$export$572242e58bd07594;
        case 0, $2b839a8453de5367$export$76dcec3f438d9e56:
            return 0, $2b839a8453de5367$export$d7de553940261eba;
        case 0, $2b839a8453de5367$export$9a574c301f67ba30:
            return 0, $2b839a8453de5367$export$4c29d0d04c15e55d;
        case 0, $2b839a8453de5367$export$363ec144a94029c8:
            return 0, $2b839a8453de5367$export$3950f7f841bf94b6;
        case 0, $2b839a8453de5367$export$df0fb32d68ae1e78:
            return 0, $2b839a8453de5367$export$881249b988b6030f;
        case 0, $2b839a8453de5367$export$d9c0e3e59442fb4:
            return 0, $2b839a8453de5367$export$e4824f74b9879164;
        case 0, $2b839a8453de5367$export$27dbc7d7ce66e6e3:
            return 0, $2b839a8453de5367$export$4f3cb0844009af52;
        case 0, $2b839a8453de5367$export$a5dce388adf922bd:
            return 0, $2b839a8453de5367$export$1a65d50c4a641bb4;
        case 0, $2b839a8453de5367$export$e1473b31a257caff:
            return 0, $2b839a8453de5367$export$9ee64e8fbd8b03a2;
        case 0, $2b839a8453de5367$export$699265ec8ad9a740:
            return 0, $2b839a8453de5367$export$b8b1ac856ba1434b;
        case 0, $2b839a8453de5367$export$85657457db93c2c2:
            return 0, $2b839a8453de5367$export$4f54a09a24fd1d74;
        case 0, $2b839a8453de5367$export$c0c2d1dfaeba89dd:
            return 0, $2b839a8453de5367$export$79685802e8ff1098;
        case 0, $2b839a8453de5367$export$2e6a7ad3ab9c82a3:
            return 0, $2b839a8453de5367$export$e5c438b7501b5a24;
        case 0, $2b839a8453de5367$export$7b60378c3b4372e9:
            return 0, $2b839a8453de5367$export$cbc0e551d91a692d;
        default:
            return teamTypeFromMe;
    }
};

});

parcelRegister("LT9wJ", function(module, exports) {
$parcel$export(module.exports, "actions", () => $bbe4751bb62a1916$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $lbLuD = parcelRequire("lbLuD");
const $bbe4751bb62a1916$export$e324594224ef24da = {
    fetchAtlassianAccountData: ({ source: source } = {})=>async ({ setState: setState, getState: getState })=>{
            const { isFetching: isFetching, wasFetchedOnce: wasFetchedOnce } = getState();
            if (isFetching || wasFetchedOnce) return;
            setState({
                isFetching: true
            });
            try {
                const data = await (0, $lbLuD.getAtlassianAccountWithRethrow)({
                    source: source
                });
                if (data !== null) setState({
                    data: data
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    wasFetchedOnce: true
                });
            }
        }
};

});
parcelRegister("lbLuD", function(module, exports) {
$parcel$export(module.exports, "getAtlassianAccountWithRethrow", () => $6409e4d9657598fd$export$1f20b0741dc598bc);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

const $6409e4d9657598fd$export$1f20b0741dc598bc = async ({ source: source } = {})=>{
    try {
        const { extended_profile: { job_title: jobTitle, team_type: teamType }, email: email, account_id: accountId } = await (0, $3ugTQ.performGetRequestWithRetry)((0, $c72c3757ca9ad677$export$80945eb3738bcee8));
        return {
            extendedProfile: {
                jobTitle: jobTitle,
                teamType: teamType
            },
            email: email,
            accountId: accountId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getAtlassianAccountWithRethrow',
                packageName: 'jiraAtlassianAccount',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                source: source
            },
            error: error
        });
        throw error;
    }
};

});
const $c72c3757ca9ad677$export$80945eb3738bcee8 = '/gateway/api/me';




parcelRegister("lMSWJ", function(module, exports) {
$parcel$export(module.exports, "useFetchInitialProjectTemplateName", () => $dea82e0ab71f0e3d$export$b11629f839f2f12a);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $2kg86 = parcelRequire("2kg86");
const $dea82e0ab71f0e3d$export$d4c72bab9d6cc13a = {};
const $dea82e0ab71f0e3d$var$store = (0, $GtRbT.createStore)({
    name: 'jira-initial-project-template-name',
    initialState: $dea82e0ab71f0e3d$export$d4c72bab9d6cc13a,
    actions: $2kg86.actions
});
const $dea82e0ab71f0e3d$export$ee6e247e51917971 = (0, $iJq0l.createHook)($dea82e0ab71f0e3d$var$store);
const $dea82e0ab71f0e3d$export$b11629f839f2f12a = ({ shouldFetch: shouldFetch, projectId: projectId })=>{
    const [state, { fetchInitialProjectTemplateName: fetchInitialProjectTemplateName }] = $dea82e0ab71f0e3d$export$ee6e247e51917971();
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFetch && projectId) fetchInitialProjectTemplateName(`${projectId}`);
    }, [
        fetchInitialProjectTemplateName,
        projectId,
        shouldFetch
    ]);
    if (!projectId) return {
        data: undefined,
        isReady: true
    };
    if (!shouldFetch) return {
        // Still return the data if it's already fetched
        // leave it to consumer to decide what to do with it
        data: state[`${projectId}`]?.templateKey,
        isReady: true
    };
    return {
        data: state[`${projectId}`]?.templateKey,
        isReady: state[`${projectId}`]?.fetchStatus === 'fetched'
    };
};

});
parcelRegister("2kg86", function(module, exports) {
$parcel$export(module.exports, "actions", () => $7dff126411e88521$export$e324594224ef24da);

var $bE631 = parcelRequire("bE631");
const $7dff126411e88521$export$e324594224ef24da = {
    fetchInitialProjectTemplateName: (0, $bE631.fetchInitialProjectTemplateNameWithRethrow)
};

});
parcelRegister("bE631", function(module, exports) {
$parcel$export(module.exports, "fetchInitialProjectTemplateNameWithRethrow", () => $b22ec6ff9089c7a6$export$c837cab65def4654);

var $9pTd3 = parcelRequire("9pTd3");

var $fnu0d = parcelRequire("fnu0d");

var $bPTb5 = parcelRequire("bPTb5");
const $b22ec6ff9089c7a6$export$c837cab65def4654 = (projectId)=>async ({ getState: getState, setState: setState })=>{
        try {
            const currentState = getState();
            const currentStateForProjectId = currentState[projectId];
            if (currentStateForProjectId?.fetchStatus === 'fetched' || currentStateForProjectId?.fetchStatus === 'fetching') return;
            const localStorageInitialProjectTemplateName = (0, $bPTb5.getLocalStorageInitialProjectTemplateName)({
                projectId: projectId
            });
            if (localStorageInitialProjectTemplateName) {
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: localStorageInitialProjectTemplateName
                    }
                });
                return;
            }
            setState({
                [projectId]: {
                    ...currentStateForProjectId,
                    fetchStatus: 'fetching'
                }
            });
            const response = await (0, $fnu0d.get)({
                consumerMeta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: '@atlassian/jira-onboarding-core',
                    teamName: 'Jlove-Makkuro'
                },
                projectId: projectId,
                projectProperties: [
                    'initial.project.template.name'
                ]
            });
            const templateKey = response?.project?.['initial.project.template.name'];
            if (templateKey) {
                (0, $bPTb5.setLocalStorageInitialProjectTemplateName)({
                    projectId: projectId,
                    templateKey: templateKey
                });
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: templateKey
                    }
                });
            } else setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                }
            });
            setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        }
    };

});
parcelRegister("bPTb5", function(module, exports) {
$parcel$export(module.exports, "getLocalStorageInitialProjectTemplateName", () => $7c91abb4b04bea95$export$82cce58d3eca5268);
$parcel$export(module.exports, "setLocalStorageInitialProjectTemplateName", () => $7c91abb4b04bea95$export$8767e71370b25cc2);

var $9pTd3 = parcelRequire("9pTd3");

var $3hRxq = parcelRequire("3hRxq");
const $7c91abb4b04bea95$var$localStorageProvider = (0, $3hRxq.createLocalStorageProvider)('jira-initial-project-template-name');
const $7c91abb4b04bea95$export$82cce58d3eca5268 = ({ projectId: projectId })=>{
    try {
        return $7c91abb4b04bea95$var$localStorageProvider.get(projectId);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('getLocalStorageInitialProjectTemplateName');
        (0, $9pTd3.fireErrorAnalytics)({
            error: typeGuardedError,
            meta: {
                id: 'getLocalStorageInitialProjectTemplateName',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
        return undefined;
    }
};
const $7c91abb4b04bea95$export$8767e71370b25cc2 = ({ projectId: projectId, templateKey: templateKey })=>{
    try {
        $7c91abb4b04bea95$var$localStorageProvider.set(projectId, templateKey);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('localStorageSetOnboardingPersonalisationResponse');
        (0, $9pTd3.fireErrorAnalytics)({
            error: typeGuardedError,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
    }
};

});




parcelRegister("3wPiD", function(module, exports) {
$parcel$export(module.exports, "useFeatures", () => $429849cdadbc9a3e$export$4a39035bacc4ed76);

var $eJOHy = parcelRequire("eJOHy");

var $dSkLG = parcelRequire("dSkLG");

var $1WzGp = parcelRequire("1WzGp");

var $cZfeH = parcelRequire("cZfeH");

var $fsjYk = parcelRequire("fsjYk");

var $jphFu = parcelRequire("jphFu");
const $429849cdadbc9a3e$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $fsjYk.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $1WzGp.useSidebarFeatureToggled)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $jphFu.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $eJOHy.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $cZfeH.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("1WzGp", function(module, exports) {
$parcel$export(module.exports, "useFeature", () => $2c23860c2dfc0b9e$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $2c23860c2dfc0b9e$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $2c23860c2dfc0b9e$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gpE3r = parcelRequire("gpE3r");
const $2c23860c2dfc0b9e$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $2c23860c2dfc0b9e$var$store = (0, $GtRbT.createStore)({
    name: 'feature-toggle',
    initialState: $2c23860c2dfc0b9e$var$initialState,
    actions: $gpE3r.actions
});
const $2c23860c2dfc0b9e$export$fc97652867e5867e = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store);
const $2c23860c2dfc0b9e$export$207b461610a7fca6 = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $2c23860c2dfc0b9e$export$e7699ed698eeb9ec = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $2c23860c2dfc0b9e$export$9eef668f94562feb = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("gpE3r", function(module, exports) {
$parcel$export(module.exports, "actions", () => $e143742cb7786e84$export$e324594224ef24da);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");

var $2DEdX = parcelRequire("2DEdX");

var $75UwL = parcelRequire("75UwL");

var $dFKLJ = parcelRequire("dFKLJ");

var $5ekEZ = parcelRequire("5ekEZ");
const $e143742cb7786e84$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $e143742cb7786e84$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $dFKLJ.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $75UwL.filterAndSort)(data);
                (0, $75UwL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    ...(0, $2DEdX.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $e143742cb7786e84$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $2DEdX.getFeatureMap)();
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $e143742cb7786e84$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        const featureMap = (0, $2DEdX.getFeatureMap)();
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $75UwL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $5ekEZ.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    ...(0, $2DEdX.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $e143742cb7786e84$export$e324594224ef24da = {
    fetchFeatures: $e143742cb7786e84$var$fetchFeatures,
    updateFeature: $e143742cb7786e84$var$updateFeature,
    syncFeatures: $e143742cb7786e84$var$syncFeatures,
    clearSiderbarFeatureToggled: $e143742cb7786e84$var$clearSiderbarFeatureToggled
};

});
parcelRegister("2DEdX", function(module, exports) {
$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $5997e650472e24c4$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $5997e650472e24c4$export$143e1d685830adbe);
$parcel$export(module.exports, "getFeatureMap", () => $5997e650472e24c4$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $5997e650472e24c4$export$f5e4c120ac01b615);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $LFmXM = parcelRequire("LFmXM");

var $jtFRs = parcelRequire("jtFRs");

var $Wdhjx = parcelRequire("Wdhjx");

var $hJIkn = parcelRequire("hJIkn");

var $9AYOJ = parcelRequire("9AYOJ");

var $DtmfJ = parcelRequire("DtmfJ");

var $l5gdO = parcelRequire("l5gdO");
const $5997e650472e24c4$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $5997e650472e24c4$export$143e1d685830adbe = 'manage-feature-menu-item';
const $5997e650472e24c4$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l5gdO))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jtFRs))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $5997e650472e24c4$export$6ac50cf33852adb5 = (0, $LFmXM.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l5gdO))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jtFRs))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        'jsw.agility.list_view': {
            descriptionKey: 'listDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasList',
            order: 35,
            redirectOn: [
                'software-list'
            ]
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $5997e650472e24c4$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("jtFRs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::24fd7cabe9c66ca335b5a26e49b2a9b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2e13280cb3fa5ae$var$_react = $e2e13280cb3fa5ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e2e13280cb3fa5ae$var$_baseNew = $e2e13280cb3fa5ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e2e13280cb3fa5ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2e13280cb3fa5ae$var$BacklogIcon = (props)=>/*#__PURE__*/ $e2e13280cb3fa5ae$var$_react.default.createElement($e2e13280cb3fa5ae$var$_baseNew.default, Object.assign({
        name: "BacklogIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$e2e13280cb3fa5ae$var$BacklogIcon.displayName = 'BacklogIcon';
var $e2e13280cb3fa5ae$var$_default = module.exports.default = $e2e13280cb3fa5ae$var$BacklogIcon;

});

parcelRegister("DtmfJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $076a6a80fa08401a$var$_react = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $076a6a80fa08401a$var$_baseNew = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $076a6a80fa08401a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $076a6a80fa08401a$var$PageIcon = (props)=>/*#__PURE__*/ $076a6a80fa08401a$var$_react.default.createElement($076a6a80fa08401a$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$076a6a80fa08401a$var$PageIcon.displayName = 'PageIcon';
var $076a6a80fa08401a$var$_default = module.exports.default = $076a6a80fa08401a$var$PageIcon;

});


parcelRegister("75UwL", function(module, exports) {
$parcel$export(module.exports, "filterAndSort", () => $df1cc586f514efec$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $df1cc586f514efec$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $df1cc586f514efec$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $df1cc586f514efec$export$5da1e8c5ba5c0dc2);

var $3l9kN = parcelRequire("3l9kN");

var $9pTd3 = parcelRequire("9pTd3");

var $2DEdX = parcelRequire("2DEdX");
const $df1cc586f514efec$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $df1cc586f514efec$export$d0e0de50c701304c = (features)=>{
    const featureMap = (0, $2DEdX.getFeatureMap)();
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $df1cc586f514efec$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $df1cc586f514efec$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $df1cc586f514efec$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const featureMap = (0, $2DEdX.getFeatureMap)();
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $9pTd3.fireErrorAnalytics)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $2DEdX.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});
parcelRegister("3l9kN", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $26ea92e191963c80$var$without = $l76qh(function(array, values) {
    return $d1ShJ(array) ? $leN9Q(array, values) : [];
});
module.exports = $26ea92e191963c80$var$without;

});
parcelRegister("leN9Q", function(module, exports) {

var $4hmxn = parcelRequire("4hmxn");

var $40QQB = parcelRequire("40QQB");

var $e2REr = parcelRequire("e2REr");

var $lylkU = parcelRequire("lylkU");

var $cUaWv = parcelRequire("cUaWv");

var $fAWNe = parcelRequire("fAWNe");
/** Used as the size to enable large array optimizations. */ var $f761097be90b00fc$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $f761097be90b00fc$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $40QQB, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $lylkU(values, $cUaWv(iteratee));
    if (comparator) {
        includes = $e2REr;
        isCommon = false;
    } else if (values.length >= $f761097be90b00fc$var$LARGE_ARRAY_SIZE) {
        includes = $fAWNe;
        isCommon = false;
        values = new $4hmxn(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $f761097be90b00fc$var$baseDifference;

});



parcelRegister("dFKLJ", function(module, exports) {
$parcel$export(module.exports, "getBoardFeatures", () => $5482b7a0e862d1ce$export$c20100b185d41ab0);

var $3ugTQ = parcelRequire("3ugTQ");

var $8ZH3C = parcelRequire("8ZH3C");
const $5482b7a0e862d1ce$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $3ugTQ.performGetRequest)((0, $8ZH3C.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8ZH3C", function(module, exports) {
$parcel$export(module.exports, "getBoardFeaturesUrl", () => $a432628e74c040a5$export$3f9939d302766b52);
const $a432628e74c040a5$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("5ekEZ", function(module, exports) {
$parcel$export(module.exports, "updateBoardFeature", () => $daf54280ff8482fb$export$61f6bbb745b3a3);

var $3ugTQ = parcelRequire("3ugTQ");

var $8ZH3C = parcelRequire("8ZH3C");
const $daf54280ff8482fb$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $3ugTQ.performPutRequest)((0, $8ZH3C.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("cZfeH", function(module, exports) {
$parcel$export(module.exports, "useClearSidebarToggled", () => $ab83a592c4668936$export$2946f555c6f48127);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $dSkLG = parcelRequire("dSkLG");

var $6d9QY = parcelRequire("6d9QY");

var $1WzGp = parcelRequire("1WzGp");

var $fsjYk = parcelRequire("fsjYk");
const $ab83a592c4668936$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $1WzGp.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $fsjYk.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $eJOHy.useRef)(false);
    const previousData = (0, $6d9QY.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $eJOHy.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $eJOHy.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("fsjYk", function(module, exports) {
$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $fa56f9341174283f$export$7deca16ba2d9eb74);

var $FhXEJ = parcelRequire("FhXEJ");

var $2aY2d = parcelRequire("2aY2d");

var $bf3Zm = parcelRequire("bf3Zm");
const $fa56f9341174283f$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const firstActivationDateMs = (0, $bf3Zm.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("bf3Zm", function(module, exports) {
$parcel$export(module.exports, "useFirstActivationDateMs", () => $edc1c49564ffc778$export$9df3a539e50a284b);

var $koAZ4 = parcelRequire("koAZ4");
const $edc1c49564ffc778$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});



parcelRegister("jphFu", function(module, exports) {
$parcel$export(module.exports, "extractData", () => $e9a39bce412d9671$export$9df5fa0a366163d2);

var $cxKOj = parcelRequire("cxKOj");
const $e9a39bce412d9671$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: hasList,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $cxKOj.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage
    };
};

});





parcelRegister("753q2", function(module, exports) {
$parcel$export(module.exports, "Stub", () => $ed0f9f17541d7429$export$1ab0b9ce3cf276f8);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $2dvSy = parcelRequire("2dvSy");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $8IuE5 = parcelRequire("8IuE5");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");


var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jRu18 = parcelRequire("jRu18");
const $ed0f9f17541d7429$export$1ab0b9ce3cf276f8 = ({ menuId: menuId, href: href })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)(menuId);
    const location = (0, $jRu18.useLocation)();
    const path = location.pathname + location.search;
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        elemBefore: icon,
        href: href,
        isSelected: path === href,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed0f9f17541d7429$var$ActionButtons, {
            menuId: menuId
        }),
        onClick: ()=>{
            if (menuId === (0, $8IuE5.L1_MENU_ID).TEAMS) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).TEAMS,
                sectionItem: (0, $a9aec.SECTION_ITEM_TEAMS)
            });
        }
    }, formattedMessage);
};
function $ed0f9f17541d7429$var$ActionButtons({ menuId: menuId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: (0, $e6bca68b75395543$export$f06dfcec5ff912e)
            }
        });
    }, [
        createAnalyticsEvent,
        menuId
    ]);
    const MenuItems = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
            menuId: menuId,
            hasSeparator: false
        })), [
        menuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: MenuItems
    });
}

});


parcelRegister("99tvj", function(module, exports) {
$parcel$export(module.exports, "useFilterL1MenuItemsByEditionAndLicense", () => $d21ef2b7ff9a2f2a$export$bf04108d78a3abbe);

var $eJOHy = parcelRequire("eJOHy");

var $gDXSd = parcelRequire("gDXSd");

var $4cTDP = parcelRequire("4cTDP");

var $8IuE5 = parcelRequire("8IuE5");

var $lJ0uX = parcelRequire("lJ0uX");

var $eJYI8 = parcelRequire("eJYI8");

var $SPYRa = parcelRequire("SPYRa");

var $fRXNt = parcelRequire("fRXNt");

var $1JbRu = parcelRequire("1JbRu");

var $abuln = parcelRequire("abuln");

var $dx2Xz = parcelRequire("dx2Xz");

var $7pw1V = parcelRequire("7pw1V");
const $d21ef2b7ff9a2f2a$export$bf04108d78a3abbe = (navItems)=>{
    const showAssets = (0, $lJ0uX.useShowAssets)();
    const { shouldUseJSM: shouldUseJSM } = (0, $gDXSd.useOgTenantInfo)();
    const shouldShowRoadmaps = (0, $fRXNt.useIsCrossProjectViewsEnabled)();
    const shouldRenderOverviews = (0, $eJYI8.useShouldRenderOverviews)();
    const [shouldRenderPlans] = (0, $SPYRa.useNavigationPlansVisibility)();
    const showCustomerService = (0, $1JbRu.useShowCustomerService)();
    const showCustomers = (0, $abuln.useShowCustomers)();
    const { goals: goals, assets: assets, confluence: confluence, projects: projects, loom: loom, teams: teams, opsgenie: opsgenie } = (0, $dx2Xz.useGlobalApps)();
    const shouldRenderApps = !((0, $4cTDP.fg)('jira-hide-apps-in-isolated-cloud') && (0, $7pw1V.isIsolatedCloud)());
    return (0, $eJOHy.useMemo)(()=>navItems.filter(({ menuId: menuId })=>{
            if (menuId === (0, $8IuE5.L1_MENU_ID).OPERATIONS) return shouldUseJSM;
            if (menuId === (0, $8IuE5.L1_MENU_ID).ASSETS) /* remove this on
					 * assets_as_an_app_v2 cleanup &&
					 *
					 * Should hide the L1 Assets menu item when the asset shortcut is present
					 */ return showAssets && !assets;
            if (menuId === (0, $8IuE5.L1_MENU_ID).ROADMAPS) return shouldShowRoadmaps;
            if (menuId === (0, $8IuE5.L1_MENU_ID).OVERVIEWS) return shouldRenderOverviews;
            if (menuId === (0, $8IuE5.L1_MENU_ID).PLANS) return shouldRenderPlans;
            if (menuId === (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS) // Filter out Customer Service Analytics.
            // It is always nested under Dashboards, but may exist in legacy user configurations from before this change.
            return false;
            // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
            // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
            // This if block should be removed when we work on https://jplat.jira.atlassian.cloud/browse/BLU-3261
            // as we will know the correct URL for the Goals menu item at that point.
            if (menuId === (0, $8IuE5.L1_MENU_ID).GOALS) return false;
            if (menuId === (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE) return showCustomerService;
            if (menuId === (0, $8IuE5.L1_MENU_ID).CUSTOMERS) return showCustomers;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS) return assets;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS) return goals;
            // App Shortcuts for Platform Component, feature gated in useGlobalApps
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE) return confluence;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS) return projects;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM) return loom;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS) return teams;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE) return opsgenie;
            if (menuId === (0, $8IuE5.L1_MENU_ID).APPS) return shouldRenderApps;
            return true;
        }), [
        navItems,
        shouldUseJSM,
        showAssets,
        shouldShowRoadmaps,
        shouldRenderOverviews,
        shouldRenderPlans,
        showCustomerService,
        goals,
        assets,
        confluence,
        projects,
        loom,
        teams,
        opsgenie,
        shouldRenderApps,
        showCustomers
    ]);
};

});
parcelRegister("lJ0uX", function(module, exports) {
$parcel$export(module.exports, "useShowAssets", () => $a4b173902015b922$export$6d1797fe1bb33b7a);

var $7cSYk = parcelRequire("7cSYk");

var $koAZ4 = parcelRequire("koAZ4");
function $a4b173902015b922$export$6d1797fe1bb33b7a() {
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $7cSYk.isCMDBEnabledInEnvironment)() && isJSMUser) return true;
    return false;
}

});

parcelRegister("1JbRu", function(module, exports) {
$parcel$export(module.exports, "useShowCustomerService", () => $01ba127d60db9986$export$e760a809f2958bc7);

var $4cTDP = parcelRequire("4cTDP");

var $hbF3h = parcelRequire("hbF3h");

var $kAwwe = parcelRequire("kAwwe");

var $6PAED = parcelRequire("6PAED");

var $1BZ8a = parcelRequire("1BZ8a");

var $cblKs = parcelRequire("cblKs");
const $01ba127d60db9986$export$c4885f1dde7a76dc = ()=>{
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $6PAED.useApplicationPermissions)();
    return (0, $4cTDP.fg)('jcs_master_flag') && (isAdmin || hasServiceDeskAccess);
};
const $01ba127d60db9986$export$888d99f9044122c4 = ()=>{
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $6PAED.useApplicationPermissions)();
    const { customerService: customerService } = (0, $1BZ8a.useAppEditions)();
    if (!(0, $4cTDP.fg)('jcs_master_flag') || customerService === (0, $cblKs.UNLICENSED)) return false;
    return hasCustomerServiceAccess;
};
const $01ba127d60db9986$export$e760a809f2958bc7 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jcs_project_type_m3'), $01ba127d60db9986$export$888d99f9044122c4, $01ba127d60db9986$export$c4885f1dde7a76dc);

});

parcelRegister("abuln", function(module, exports) {
$parcel$export(module.exports, "useShowCustomers", () => $c1625a60ea58118c$export$95344e90e3525854);

var $4cTDP = parcelRequire("4cTDP");

var $6PAED = parcelRequire("6PAED");

var $1BZ8a = parcelRequire("1BZ8a");

var $cblKs = parcelRequire("cblKs");
const $c1625a60ea58118c$export$95344e90e3525854 = ()=>{
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $6PAED.useApplicationPermissions)();
    const { customerService: customerService } = (0, $1BZ8a.useAppEditions)();
    if (!(0, $4cTDP.fg)('berry-6285-customers-l1') || customerService === (0, $cblKs.UNLICENSED)) return false;
    return hasCustomerServiceAccess;
};

});


parcelRegister("efIGC", function(module, exports) {
$parcel$export(module.exports, "useRefreshL1MenuItems", () => $11175ae5b197dd63$export$6f30ce19c2e3e4c0);

var $eJOHy = parcelRequire("eJOHy");

var $2zs80 = parcelRequire("2zs80");

var $cxKOj = parcelRequire("cxKOj");

var $24QYf = parcelRequire("24QYf");
const $11175ae5b197dd63$export$6f30ce19c2e3e4c0 = (navItems = [])=>(0, $eJOHy.useMemo)(()=>{
        const missingMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))((0, $cxKOj.expVal)('navx-1982-change-order-of-teams-and-goals', 'isEnabled', false) ? (0, $24QYf.USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS_GOALS_TEAMS_SWITCHED) : (0, $24QYf.USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS), navItems.map(({ menuId: menuId })=>menuId));
        return [
            ...navItems,
            ...missingMenuIds.map((menuId)=>({
                    menuId: menuId,
                    isVisible: true
                }))
        ];
    }, [
        navItems
    ]);

});
parcelRegister("2zs80", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $72Qfa = parcelRequire("72Qfa");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $1df4ab4b3ebd7a42$var$difference = $l76qh(function(array, values) {
    return $d1ShJ(array) ? $leN9Q(array, $72Qfa(values, 1, $d1ShJ, true)) : [];
});
module.exports = $1df4ab4b3ebd7a42$var$difference;

});


parcelRegister("kRqOw", function(module, exports) {
$parcel$export(module.exports, "MoreMenuIsOpenContextProvider", () => $346ab3a8e11009e0$export$d11e004ed91611ce);

var $eJOHy = parcelRequire("eJOHy");

var $eO1d3 = parcelRequire("eO1d3");
const $346ab3a8e11009e0$export$d11e004ed91611ce = ({ children: children })=>{
    const [moreMenuIsOpen, setMoreMenuIsOpen] = (0, $eJOHy.useState)(false);
    const moreMenuIsOpenContext = (0, $eJOHy.useMemo)(()=>({
            moreMenuIsOpen: moreMenuIsOpen,
            setMoreMenuIsOpen: setMoreMenuIsOpen
        }), [
        moreMenuIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eO1d3.MoreMenuIsOpenContext).Provider, {
        value: moreMenuIsOpenContext
    }, children);
};

});
parcelRegister("eO1d3", function(module, exports) {
$parcel$export(module.exports, "MoreMenuIsOpenContext", () => $f9cd06b886a023d5$export$8888ac4b19e27f70);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $f9cd06b886a023d5$export$8888ac4b19e27f70 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    moreMenuIsOpen: false,
    setMoreMenuIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});


parcelRegister("g5qtb", function(module, exports) {
$parcel$export(module.exports, "SidebarCustomization", () => $49cac2c6568bcfd7$export$64f537f23c5bcad6);

var $eJOHy = parcelRequire("eJOHy");

var $dllpM = parcelRequire("dllpM");

var $a9aec = parcelRequire("a9aec");

var $80rA3 = parcelRequire("80rA3");

var $qEpp6 = parcelRequire("qEpp6");

var $8LmbL = parcelRequire("8LmbL");

var $lRq8t = parcelRequire("lRq8t");

var $9WyX8 = parcelRequire("9WyX8");

var $4exVH = parcelRequire("4exVH");

var $aKwXy = parcelRequire("aKwXy");

var $2ng07 = parcelRequire("2ng07");
function $49cac2c6568bcfd7$export$64f537f23c5bcad6({ menuData: menuData, productItemsData: productItemsData, appItemsData: appItemsData, getAppShortcutURL: getAppShortcutURL }) {
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $eJOHy.useContext)((0, $80rA3.PeekMenuIdContext));
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const pressTracing = (0, $dllpM.default)('nav4-sidebar-more');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClickMoreMenuTrigger = (0, $eJOHy.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $a9aec.SECTION_ITEM_MORE)
        });
        pressTracing();
    }, [
        pressTracing,
        sendSectionItemAnalyticsEvent
    ]);
    return moreMenuIds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ng07.CustomizeSidebar), {
        productItemsData: productItemsData,
        appItemsData: appItemsData
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4exVH.PeekMenuItem), {
        menuData: menuData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8LmbL.GlobalMoreMenu), {
        productItemsData: productItemsData,
        appItemsData: appItemsData,
        menuItemComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9WyX8.MoreMenuItem), {
                ...props,
                getAppShortcutURL: getAppShortcutURL
            }),
        customizeSidebarMenuItem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ng07.CustomizeSidebar), {
            productItemsData: productItemsData,
            appItemsData: appItemsData
        }),
        moreMenuItemLabel: formatMessage((0, $aKwXy.default).more),
        peekingMenuIds: peekMenuId ? [
            peekMenuId
        ] : undefined,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger
    }));
}

});
parcelRegister("8LmbL", function(module, exports) {
$parcel$export(module.exports, "GlobalMoreMenu", () => $20da8eefc1bcf7d3$export$6741e824c68e9927);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9yoau = parcelRequire("9yoau");

var $cQBgt = parcelRequire("cQBgt");
function $20da8eefc1bcf7d3$export$6741e824c68e9927({ productItemsData: productItemsData, appItemsData: appItemsData = [], menuItemComponent: menuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, peekingMenuIds: peekingMenuIds = [], onClickMoreMenuTrigger: onClickMoreMenuTrigger, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef, dropIndicator: dropIndicator }) {
    const { hiddenProductItemsData: hiddenProductItemsData, hiddenAppItemsData: hiddenAppItemsData, shouldShowMoreMenu: shouldShowMoreMenu } = (0, $cQBgt.getHiddenItems)(productItemsData, appItemsData, peekingMenuIds);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9yoau.MoreMenuPopup), {
        productItemsData: hiddenProductItemsData,
        appItemsData: hiddenAppItemsData,
        menuItemComponent: menuItemComponent,
        customizeSidebarMenuItem: customizeSidebarMenuItem,
        moreMenuItemLabel: moreMenuItemLabel,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger,
        showMoreMenu: shouldShowMoreMenu,
        testId: testId,
        triggerRef: triggerRef,
        triggerVisualContentRef: triggerVisualContentRef,
        dropIndicator: dropIndicator
    });
}

});
parcelRegister("9yoau", function(module, exports) {
$parcel$export(module.exports, "MoreMenuPopup", () => $43c3ff472c716587$export$b426d2e536b00785);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gyJTO = parcelRequire("gyJTO");

var $NByNW = parcelRequire("NByNW");

var $85fS3 = parcelRequire("85fS3");

var $kKTZh = parcelRequire("kKTZh");

var $eGOwo = parcelRequire("eGOwo");

var $7Hwfq = parcelRequire("7Hwfq");

var $8IeH1 = parcelRequire("8IeH1");

var $aCmvH = parcelRequire("aCmvH");

var $lWhv4 = parcelRequire("lWhv4");
const $43c3ff472c716587$var$styles = {
    popupContentContainerStyles: "_195gr5cr _kqswh2mm",
    popupContentStyles: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $43c3ff472c716587$export$b426d2e536b00785({ productItemsData: productItemsData, appItemsData: appItemsData, menuItemComponent: menuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger, showMoreMenu: showMoreMenu = true, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef, dropIndicator: dropIndicator }) {
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const closeMenu = ()=>setIsOpen(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(!isOpen), onClickMoreMenuTrigger && onClickMoreMenuTrigger();
    }, [
        onClickMoreMenuTrigger,
        isOpen
    ]);
    // This ref is ultimately passed to the Modal, which should cause the modal dialog to
    // return focus to the element. This component is "tricky" because it must change the
    // visible-menuitem based on whether the more menu needs to show or not.
    const returnFocusRef = (0, $eJOHy.useRef)(null);
    // This clonedMenuItem allows the customizeSidebarMenuItem to be passed a ref (to allow focussing)
    // and a returnFocusRef, which is passed to the Modal. It doesn't make sense for the caller to
    // define the ref.
    const clonedMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(customizeSidebarMenuItem) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(customizeSidebarMenuItem, {
        returnFocusRef: returnFocusRef,
        ref: returnFocusRef
    }) : customizeSidebarMenuItem;
    if (!showMoreMenu) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: clonedMenuItem
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Hwfq.Popup), {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Hwfq.PopupTrigger), {
                children: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
                        ...triggerProps,
                        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                            label: "",
                            color: "currentColor",
                            spacing: "spacious"
                        }),
                        onClick: onClick,
                        testId: testId,
                        ref: (0, $gyJTO.default)(triggerRef ? [
                            triggerRef,
                            triggerProps.ref,
                            returnFocusRef
                        ] : [
                            triggerProps.ref,
                            returnFocusRef
                        ]),
                        visualContentRef: triggerVisualContentRef,
                        dropIndicator: dropIndicator,
                        isSelected: (0, $eGOwo.fg)('platform-dst-buttonmenuitem-selected-state-support') ? triggerProps['aria-expanded'] : undefined,
                        children: moreMenuItemLabel ?? formatMessage((0, $aCmvH.default).moreMenuTriggerLabel)
                    })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $43c3ff472c716587$var$styles.popupContentContainerStyles,
                role: "listitem",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Hwfq.PopupContent), {
                    testId: `${testId}-content`,
                    shouldFitContainer: true,
                    placement: "bottom-start",
                    // Offset the top margin of the menu section.
                    // This will keep an even spacing of menu items between those inside the dropdown and those above,
                    // and keep the icons aligned
                    offset: [
                        -4,
                        4
                    ],
                    onClose: ()=>setIsOpen(false),
                    shouldRenderToParent: true,
                    strategy: "absolute",
                    children: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $43c3ff472c716587$var$styles.popupContentStyles,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $85fS3.MenuList), {
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lWhv4.MoreMenuSection), {
                                        itemsData: productItemsData,
                                        moreMenuItemComponent: menuItemComponent,
                                        closeMenu: closeMenu
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lWhv4.MoreMenuSection), {
                                        itemsData: appItemsData ?? [],
                                        moreMenuItemComponent: menuItemComponent,
                                        closeMenu: closeMenu
                                    }),
                                    clonedMenuItem
                                ]
                            })
                        })
                })
            })
        ]
    });
}

});
parcelRegister("aCmvH", function(module, exports) {
$parcel$export(module.exports, "default", () => $e987b1efca20ae39$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e987b1efca20ae39$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    moreMenuTriggerLabel: {
        id: 'navigation.global-more-menu.trigger-label',
        defaultMessage: 'More',
        description: 'Default label text for the global more menu trigger button'
    }
});

});

parcelRegister("lWhv4", function(module, exports) {
$parcel$export(module.exports, "MoreMenuSection", () => $aff2f794a6a830a7$export$e69b6dd1756fb519);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");

var $8n30H = parcelRequire("8n30H");
var $1ejND = parcelRequire("1ejND");
function $aff2f794a6a830a7$export$e69b6dd1756fb519({ itemsData: itemsData, moreMenuItemComponent: moreMenuItemComponent, closeMenu: closeMenu }) {
    if (itemsData.length === 0) return null;
    const MenuItemComponent = moreMenuItemComponent;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1ejND.MenuSection), {
        isMenuListItem: true,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $85fS3.MenuList), {
                children: itemsData.map(({ menuId: menuId })=>/*#__PURE__*/ (0, $gt9Am.jsx)(MenuItemComponent, {
                        menuId: menuId,
                        closeMenu: closeMenu
                    }, menuId))
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8n30H.Divider), {})
        ]
    });
}

});


parcelRegister("cQBgt", function(module, exports) {
$parcel$export(module.exports, "getHiddenItems", () => $5ec5371881861e67$export$89456cd3628213b2);
function $5ec5371881861e67$export$89456cd3628213b2(productItemsData, appItemsData, peekingMenuIds) {
    const checkIsHiddenMenuItem = ({ menuId: menuId, visible: visible })=>!visible && !peekingMenuIds.includes(menuId);
    const hiddenProductItemsData = productItemsData.filter(checkIsHiddenMenuItem);
    const hiddenAppItemsData = appItemsData.filter(checkIsHiddenMenuItem);
    return {
        hiddenProductItemsData: hiddenProductItemsData,
        hiddenAppItemsData: hiddenAppItemsData,
        shouldShowMoreMenu: hiddenProductItemsData.length !== 0 || hiddenAppItemsData.length !== 0
    };
}

});


parcelRegister("9WyX8", function(module, exports) {
$parcel$export(module.exports, "MoreMenuItem", () => $2b90a1c096c82754$export$e967513bbeba0537);

var $eJOHy = parcelRequire("eJOHy");

var $2dvSy = parcelRequire("2dvSy");

var $kKTZh = parcelRequire("kKTZh");

var $eL2Ux = parcelRequire("eL2Ux");

var $80rA3 = parcelRequire("80rA3");

var $ig45T = parcelRequire("ig45T");

var $qEpp6 = parcelRequire("qEpp6");

var $a9aec = parcelRequire("a9aec");

var $dx2Xz = parcelRequire("dx2Xz");

var $h4Bzb = parcelRequire("h4Bzb");

var $4cTDP = parcelRequire("4cTDP");

var $41vqi = parcelRequire("41vqi");
function $2b90a1c096c82754$export$e967513bbeba0537({ menuId: menuId, closeMenu: closeMenu, key: key, getAppShortcutURL: getAppShortcutURL }) {
    const { setPeekMenuId: setPeekMenuId } = (0, $eJOHy.useContext)((0, $80rA3.PeekMenuIdContext));
    const configurableId = (0, $ig45T.convertToConfigurableMenuId)(menuId);
    const isGlobalApp = (0, $dx2Xz.isGlobalAppMenuId)(menuId);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)(configurableId);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const getProductUrl = (0, $eJOHy.useCallback)(()=>{
        if (!isGlobalApp || !getAppShortcutURL) return;
        if ((0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)[menuId]) {
            const apsKey = (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)[menuId];
            return getAppShortcutURL(apsKey);
        }
    }, [
        isGlobalApp,
        getAppShortcutURL,
        menuId
    ]);
    // This is part of an intermediate state workaround where links are accounted for;
    // we don't expect links to be in the More menu at the end state,
    // at which point this and the MenuLinkItem below can be removed.
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    const url = (0, $4cTDP.fg)('nav4_global_links_jira') ? getProductUrl() || USER_NAVIGATION_ITEM_LINKS[menuId] : USER_NAVIGATION_ITEM_LINKS[menuId];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        closeMenu();
        if (!isGlobalApp) // Global apps open in a new tab onClick so they don't need to be a peek-item
        setPeekMenuId(configurableId);
        sendSectionItemAnalyticsEvent({
            menuId: configurableId,
            sectionItem: (0, $a9aec.SECTION_ITEM_MAP)[configurableId]
        });
    }, [
        closeMenu,
        configurableId,
        isGlobalApp,
        sendSectionItemAnalyticsEvent,
        setPeekMenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        elemBefore: icon,
        href: url,
        onClick: onClick,
        key: key,
        target: isGlobalApp ? '_blank' : undefined
    }, formattedMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKTZh.ButtonMenuItem), {
        elemBefore: icon,
        onClick: onClick,
        key: key
    }, formattedMessage));
}

});
parcelRegister("ig45T", function(module, exports) {
$parcel$export(module.exports, "convertToConfigurableMenuId", () => $7b296a666ec05c45$export$c54090f9034b2d83);

var $h4Bzb = parcelRequire("h4Bzb");
const $7b296a666ec05c45$export$c54090f9034b2d83 = (menuId)=>{
    switch(menuId){
        case 'jira.sidebar.apps':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).APPS;
        case 'jira.sidebar.assets':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).ASSETS;
        case 'jira.sidebar.dashboards':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).DASHBOARDS;
        case 'jira.sidebar.filters':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).FILTERS;
        case 'jira.sidebar.goals':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GOALS;
        case 'jira.sidebar.operations':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).OPERATIONS;
        case 'jira.sidebar.overviews':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).OVERVIEWS;
        case 'jira.sidebar.plans':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).PLANS;
        case 'jira.sidebar.projects':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS;
        case 'jira.sidebar.recent':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).RECENT;
        case 'jira.sidebar.starred':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).STARRED;
        case 'jira.sidebar.teams':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).TEAMS;
        case 'jira.sidebar.roadmaps':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).ROADMAPS;
        case 'jira.sidebar.customerService':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE;
        case 'jira.sidebar.customerServiceAnalytics':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS;
        case 'jira.sidebar.customers':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMERS;
        case 'jira.sidebar.globalApp.assets':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS;
        case 'jira.sidebar.globalApp.goals':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS;
        case 'jira.sidebar.globalApp.confluence':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE;
        case 'jira.sidebar.globalApp.teams':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS;
        case 'jira.sidebar.globalApp.projects':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS;
        case 'jira.sidebar.globalApp.loom':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM;
        case 'jira.sidebar.globalApp.opsgenie':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE;
        default:
            throw new Error(`Invalid menuId: ${menuId}`);
    }
};

});


parcelRegister("4exVH", function(module, exports) {
$parcel$export(module.exports, "PeekMenuItem", () => $e747ac1126b30647$export$4287f527b7969caa);

var $eJOHy = parcelRequire("eJOHy");

var $80rA3 = parcelRequire("80rA3");

var $mIeXW = parcelRequire("mIeXW");
const $e747ac1126b30647$export$4287f527b7969caa = ({ menuData: menuData })=>{
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $eJOHy.useContext)((0, $80rA3.PeekMenuIdContext));
    return !!peekMenuId && moreMenuIds.includes(peekMenuId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $mIeXW.ConfigurableMenuItem), {
        isDefaultOpen: true,
        menuData: menuData,
        menuId: peekMenuId
    });
};

});

parcelRegister("aKwXy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a39c89199cef8dab$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a39c89199cef8dab$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    more: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("2ng07", function(module, exports) {
$parcel$export(module.exports, "CustomizeSidebar", () => $3f83028505e53196$export$bfa967364825ce72);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $dxcgx = parcelRequire("dxcgx");

var $hOTKA = parcelRequire("hOTKA");

var $haSyH = parcelRequire("haSyH");

var $d6Pnu = parcelRequire("d6Pnu");
const $3f83028505e53196$export$bfa967364825ce72 = /*#__PURE__*/ (0, $eJOHy.forwardRef)($3f83028505e53196$export$efb28913c0269ef5);
function $3f83028505e53196$export$efb28913c0269ef5({ productItemsData: productItemsData, appItemsData: appItemsData }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
buttonRef) {
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            productItemsData: productItemsData,
            appItemsData: appItemsData
        }), [
        productItemsData,
        appItemsData
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $hOTKA.CustomisableSidebarModalEntrypoint),
        entryPointProps: entryPointParams,
        title: formatMessage((0, $d6Pnu.default).customizeSidebar),
        useInternalModal: false
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $haSyH.CustomizeSidebarMenuItem), {
            ref: ref || buttonRef
        }));
}

});
parcelRegister("hOTKA", function(module, exports) {
$parcel$export(module.exports, "CustomisableSidebarModalEntrypoint", () => $6a1af2b46614ca1c$export$420f0b14c9bb574e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6a1af2b46614ca1c$export$420f0b14c9bb574e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("g173U")).then(({ JiraCustomizationModal: JiraCustomizationModal })=>JiraCustomizationModal), {
        moduleId: "b022a6c4",
        moduleName: "JiraCustomizationModal",
        priority: "interaction"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("g173U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("yv6XD").then(()=>parcelRequire('1I9qh'));

});


parcelRegister("haSyH", function(module, exports) {
$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $d410af64a035c01d$export$b7fa0daee00ba08b);

var $eJOHy = parcelRequire("eJOHy");

var $iiRWr = parcelRequire("iiRWr");

var $kKTZh = parcelRequire("kKTZh");

var $2QH3X = parcelRequire("2QH3X");

var $qEpp6 = parcelRequire("qEpp6");

var $a9aec = parcelRequire("a9aec");

var $d6Pnu = parcelRequire("d6Pnu");
const $d410af64a035c01d$export$b7fa0daee00ba08b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick }, ref)=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $d6Pnu.default).customizeSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($iiRWr))));
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const onClickHandler = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $a9aec.SECTION_ITEM_CUSTOMIZE_SIDEBAR)
        });
        onClick?.(event, analyticsEvent);
    }, [
        onClick,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKTZh.ButtonMenuItem), {
        interactionName: "nav4-sidebar-customise-modal",
        elemBefore: icon,
        onClick: onClickHandler,
        ref: ref
    }, formattedMessage);
});

});
parcelRegister("iiRWr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3a6b9bc7cd562874d0d59c11159dd71>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d533c021bfcfd692$var$_react = $d533c021bfcfd692$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d533c021bfcfd692$var$_baseNew = $d533c021bfcfd692$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d533c021bfcfd692$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d533c021bfcfd692$var$CustomizeIcon = (props)=>/*#__PURE__*/ $d533c021bfcfd692$var$_react.default.createElement($d533c021bfcfd692$var$_baseNew.default, Object.assign({
        name: "CustomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$d533c021bfcfd692$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $d533c021bfcfd692$var$_default = module.exports.default = $d533c021bfcfd692$var$CustomizeIcon;

});

parcelRegister("d6Pnu", function(module, exports) {
$parcel$export(module.exports, "default", () => $772c2deb33dad986$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $772c2deb33dad986$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    customizeSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar",
        "defaultMessage": "Customize sidebar"
    }
});

});




parcelRegister("5kDxs", function(module, exports) {
$parcel$export(module.exports, "PeekMenuIdContextProvider", () => $0be1425064f115cc$export$b7d1a20f5a877f18);

var $eJOHy = parcelRequire("eJOHy");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $cbCSE = parcelRequire("cbCSE");

var $80rA3 = parcelRequire("80rA3");
// Eventually this will be all configurable menu ids and can be removed at that point.
// TODO: Adam, I think we've reached that point.
const $0be1425064f115cc$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT = [
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).ASSETS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).APPS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).DASHBOARDS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).FILTERS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).OPERATIONS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).PLANS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS
];
const $0be1425064f115cc$export$b7d1a20f5a877f18 = ({ children: children })=>{
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $cbCSE.useSidebarNav4Controller)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const [peekMenuId, setPeekMenuId] = (0, $eJOHy.useState)(()=>$0be1425064f115cc$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds));
    // This effect automatically overrides the manual value of peek menu id (set when clicking in the more menu item).
    // This effect is only triggered when controlled, selected, or more menu ids change.
    // Use layout effect so peek menu id is set before render.
    // An alternative to any effect would be to set peek menu id when setting selected path.
    // However, that may require elevating this context.
    (0, $eJOHy.useLayoutEffect)(()=>setPeekMenuId((currentPeekMenuId)=>$0be1425064f115cc$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, currentPeekMenuId)), [
        isControlledNav,
        isControlledPath,
        isSelectedPath,
        moreMenuIds
    ]);
    const peekMenuIdContext = (0, $eJOHy.useMemo)(()=>({
            peekMenuId: peekMenuId,
            setPeekMenuId: setPeekMenuId
        }), [
        peekMenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $80rA3.PeekMenuIdContext).Provider, {
        value: peekMenuIdContext
    }, children);
};
const $0be1425064f115cc$var$getAutoPeekMenuId = (isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, peekMenuId)=>{
    // When controlled...
    if (isControlledNav) return moreMenuIds.find(isControlledPath);
    // Otherwise selected...
    const autoPeekMenuId = moreMenuIds.find(isSelectedPath);
    // Once all configurable menu ids are using sidebar context we can just return `autoPeekMenuId`.
    if (autoPeekMenuId) return autoPeekMenuId;
    // Unpeek if peek menu id is no longer selected.
    // Only do this for menu ids using the sidebar context for now.
    // Legacy menu ids set peek menu id manually.
    if (peekMenuId && $0be1425064f115cc$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT.includes(peekMenuId)) return undefined;
    // Otherwise unchanged.
    return peekMenuId;
};

});

parcelRegister("6CQFr", function(module, exports) {
$parcel$export(module.exports, "GlobalShortcutsWithInvitePeopleProvider", () => $0cc1fe580ce46bdc$export$19459237290a4ec4);
$parcel$export(module.exports, "GlobalShortcuts", () => $0cc1fe580ce46bdc$export$bae2da217bf9db6);

var $eJOHy = parcelRequire("eJOHy");

var $aXbkt = parcelRequire("aXbkt");

var $cHtIB = parcelRequire("cHtIB");

var $6z6fG = parcelRequire("6z6fG");
var $1RKdF = parcelRequire("1RKdF");

var $g9Vr6 = parcelRequire("g9Vr6");

var $9qvK9 = parcelRequire("9qvK9");

var $huZVT = parcelRequire("huZVT");

var $g7Dyb = parcelRequire("g7Dyb");
const $0cc1fe580ce46bdc$var$GlobalShortcutsComponent = /*#__PURE__*/ (0, $eJOHy.memo)(({ appItemsData: appItemsData, teamsAppConfig: teamsAppConfig, handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const licenceFilterMap = (0, $g7Dyb.useLicenseFilterMap)(teamsAppConfig);
    // sort filtered products based on order of appItemsData
    const orderedShortcuts = (0, $9qvK9.useOrderedAppShortcuts)(licenceFilterMap, appItemsData);
    // sync updated shortcut items across the other atomic components
    const onUpdateGetFilteredProductLinks = (getFilteredProductLinks)=>{
        if (onUpdateGetFilteredProductLinks && handleUpdateGetFilteredProductLinks) handleUpdateGetFilteredProductLinks(getFilteredProductLinks);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6z6fG.GlobalShortcuts), {
        cloudId: cloudId,
        orgId: orgId,
        promoteSite: true,
        shortcutItems: orderedShortcuts,
        product: "jira",
        productLinksFilter: cloudId ? (0, $1RKdF.productLinksWorkspaceCloudIdFilter)(cloudId) : undefined,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
});
// Wrapper required to use teams app shortcut hook
const $0cc1fe580ce46bdc$var$GlobalShortcutsInvitePeopleWrapper = (props)=>{
    const { component: teamsAppComponent, config: teamsAppConfig } = (0, $huZVT.useTeamsAppShortcut)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, teamsAppComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc1fe580ce46bdc$var$GlobalShortcutsComponent, {
        ...props,
        teamsAppConfig: teamsAppConfig
    }));
};
const $0cc1fe580ce46bdc$export$19459237290a4ec4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aXbkt.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc1fe580ce46bdc$var$GlobalShortcutsInvitePeopleWrapper, props));
};
const $0cc1fe580ce46bdc$export$bae2da217bf9db6 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc1fe580ce46bdc$var$GlobalShortcutsComponent, props);
};

});
parcelRegister("6z6fG", function(module, exports) {
$parcel$export(module.exports, "GlobalShortcuts", () => $b36f31022cca6928$export$bae2da217bf9db6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $eUaD0 = parcelRequire("eUaD0");

var $ftN6c = parcelRequire("ftN6c");

var $85fS3 = parcelRequire("85fS3");

var $78OnL = parcelRequire("78OnL");

var $dLR8J = parcelRequire("dLR8J");

var $6FOAB = parcelRequire("6FOAB");

var $iJSFh = parcelRequire("iJSFh");
var $9tH93 = parcelRequire("9tH93");
var $1w126 = parcelRequire("1w126");

var $ks23B = parcelRequire("ks23B");

var $l8bWr = parcelRequire("l8bWr");

var $1MaXL = parcelRequire("1MaXL");


var $bLper = parcelRequire("bLper");

var $l0gTa = parcelRequire("l0gTa");

var $77bbV = parcelRequire("77bbV");

var $3uTOZ = parcelRequire("3uTOZ");
function $b36f31022cca6928$export$bae2da217bf9db6(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FOAB.default), {
        name: (0, $1f5444826c4f04af$export$fe240e33002221f),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9tH93.BFFProvider), {
            consumer: (0, $iJSFh.BFFConsumerEnum).GLOBAL_SHORTCUTS,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1MaXL.GlobalShortcutsWithIntlProvider), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.NavigationAnalyticsContext), {
                    data: {
                        product: props?.product
                    },
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($b36f31022cca6928$var$Menu, {
                        ...props
                    })
                })
            })
        })
    });
}
function $b36f31022cca6928$var$Menu({ testId: testId, shortcutItems: shortcutItems = [], forceStatic: forceStatic, cloudId: cloudId, orgId: orgId, userId: userId, useSkeleton: useSkeleton, promoteSite: promoteSite, productLinksFilter: productLinksFilter, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, enableDragAndDrop: enableDragAndDrop, openInSameTab: openInSameTab }) {
    // Update Ref
    const onUpdateGetFilteredProductLinksRef = (0, $eJOHy.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    // Filter Ref
    const productLinksFilterRef = (0, $eJOHy.useRef)(productLinksFilter);
    productLinksFilterRef.current = productLinksFilter;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks } = (0, $1w126.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId,
        userId: userId,
        forceStatic: forceStatic,
        product: product
    });
    const getFilteredProductLinks = (0, $eJOHy.useCallback)((apsKey)=>{
        let filteredProductLinks = productLinks[apsKey] ?? [];
        if (productLinksFilterRef.current) filteredProductLinks = filteredProductLinks.filter(productLinksFilterRef.current);
        return {
            promotedLink: filteredProductLinks.find((item, _i, arr)=>arr.length === 1 || promoteSite && item.isCurrentSite),
            links: filteredProductLinks.filter((item, _i, arr)=>arr.length === 1 || !(promoteSite && item.isCurrentSite)),
            status: status
        };
    }, [
        productLinks,
        promoteSite,
        status
    ]);
    const mappedShortcutItems = (0, $eJOHy.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            const key = item.type === 'link' && item.apsKey || `shortcut-${index}`;
            // Render nested items if the dynamic data is available and we are not forcing static rendering
            if (!forceStatic && status?.toLowerCase() === (0, $iJSFh.RequestStatus).COMPLETE && item.type === 'link' && item.apsKey && productLinks?.[item.apsKey]) {
                const { links: filteredProductLinks, promotedLink: promotedLink } = getFilteredProductLinks(item.apsKey);
                const siteName = filteredProductLinks?.[0]?.displayName;
                // Determine whether shortcut is a single site and is current site and return link instead of flyout
                if (filteredProductLinks.length === 1 && !item.url) return {
                    ...item,
                    key: key,
                    url: filteredProductLinks[0].url
                };
                if (filteredProductLinks.length > 1) return {
                    ...item,
                    siteName: siteName,
                    key: key,
                    type: 'expand',
                    promoted: promotedLink ? {
                        type: 'link',
                        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l0gTa.ImageFromUrl), {
                            src: promotedLink.avatar,
                            alt: "",
                            fallback: item.icon
                        }),
                        label: promotedLink.displayName,
                        url: promotedLink.url
                    } : undefined,
                    items: filteredProductLinks.map((link)=>({
                            type: 'link',
                            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l0gTa.ImageFromUrl), {
                                src: link.avatar,
                                alt: "",
                                fallback: item.icon
                            }),
                            label: link.displayName,
                            displayName: link.displayName,
                            url: link.url
                        }))
                };
            }
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems,
        productLinks,
        forceStatic,
        status,
        getFilteredProductLinks
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (onUpdateGetFilteredProductLinksRef.current) onUpdateGetFilteredProductLinksRef.current(getFilteredProductLinks);
    }, [
        getFilteredProductLinks
    ]);
    const apsKeys = (0, $eJOHy.useMemo)(()=>{
        return shortcutItems.map((item)=>item.type === 'link' && item.apsKey || '').filter((item)=>!!item);
    }, [
        shortcutItems
    ]);
    const mountedRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (forceStatic || status?.toLowerCase() !== (0, $iJSFh.RequestStatus).COMPLETE || productLinks && !Object.keys(productLinks).length || mountedRef.current === true) return;
        mountedRef.current = true;
        const missingShortcuts = shortcutItems.filter((item)=>item.type === 'link').filter((item)=>{
            // todo: Should we also include links with missing APS keys? Currently a link could be missing an APS key and not be included in this list.
            return !(0, $l8bWr.getUrlMaybe)(item) && item.apsKey && !productLinks?.[item.apsKey];
        });
        const intended = shortcutItems.length;
        const rendered = intended - missingShortcuts.length;
        createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            action: 'cls',
            actionSubject: 'menu',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: product,
                intended: intended,
                rendered: rendered,
                missingAPSKeys: missingShortcuts.map((item)=>item.apsKey).filter(Boolean)
            }
        }).fire((0, $ks23B.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        shortcutItems,
        productLinks,
        product,
        forceStatic,
        status
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!forceStatic) buildURLAndFetchData();
    }, [
        apsKeys,
        buildURLAndFetchData,
        forceStatic
    ]);
    const createLinkItem = (0, $eJOHy.useCallback)((shortcut)=>{
        if (status?.toLowerCase() === (0, $iJSFh.RequestStatus).COMPLETE) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uTOZ.ShortcutMenuItem), {
            shortcut: shortcut,
            openInSameTab: openInSameTab,
            status: status,
            expandItems: shortcut.type === 'expand' && (shortcut.items?.length ?? false) ? shortcut.items : undefined,
            promotedItem: shortcut.type === 'expand' ? shortcut.promoted : undefined,
            siteName: shortcut.type === 'expand' ? shortcut.siteName : undefined,
            product: product
        }, shortcut.key);
        // Show skeleton while BFF is loading
        if (useSkeleton && (status === (0, $iJSFh.RequestStatus).LOADING || status === (0, $iJSFh.RequestStatus).INIT)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $77bbV.MenuSkeletonItem), {}, shortcut.key);
        // We only want to allow static menu expand item if we are forcing static,
        // otherwise it should be showing the singular item as a disabled link until the
        // data is loaded.
        if (forceStatic && shortcut.type === 'expand' && shortcut.items) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uTOZ.ShortcutMenuItem), {
            shortcut: shortcut,
            expandItems: shortcut.items,
            forceStatic: forceStatic,
            product: product,
            openInSameTab: openInSameTab
        }, shortcut.key);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uTOZ.ShortcutMenuItem), {
            shortcut: shortcut,
            status: status,
            forceStatic: forceStatic,
            product: product,
            openInSameTab: openInSameTab
        }, shortcut.key);
    }, [
        forceStatic,
        product,
        status,
        useSkeleton,
        openInSameTab
    ]);
    const shortcutList = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $85fS3.MenuList), {
        children: mappedShortcutItems?.map(createLinkItem)
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        testId: testId,
        children: [
            enableDragAndDrop ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bLper.DragAndDropOptionsProvider), {
                enabled: enableDragAndDrop,
                children: shortcutList
            }) : shortcutList,
            !forceStatic && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: (0, $1f5444826c4f04af$export$2158b6d23c9689f5),
                hold: status === (0, $iJSFh.RequestStatus).INIT || status === (0, $iJSFh.RequestStatus).LOADING
            })
        ]
    });
}

});
parcelRegister("iJSFh", function(module, exports) {
$parcel$export(module.exports, "BFFConsumerEnum", () => $6e79eecdba5a58dc$export$9a146e025690327e);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $6e79eecdba5a58dc$export$45e63649edff1e2a);
$parcel$export(module.exports, "MAX_ATTEMPTS_DEFAULT", () => $6e79eecdba5a58dc$export$45c80c6b98d65f36);
$parcel$export(module.exports, "RETRY_INTERVAL_DEFAULT", () => $6e79eecdba5a58dc$export$7b4183e5f0de390a);
$parcel$export(module.exports, "DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW", () => $6e79eecdba5a58dc$export$891dc7068a3d5e65);
$parcel$export(module.exports, "DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW", () => $6e79eecdba5a58dc$export$6e594fe130dbe3b);
$parcel$export(module.exports, "RequestStatus", () => $6e79eecdba5a58dc$export$600e7c1f9e0414e1);
$parcel$export(module.exports, "BFF_REQUEST_STATUS_KEY", () => $6e79eecdba5a58dc$export$c889532d47d74e9c);
$parcel$export(module.exports, "FLIGHTDECK_REQUEST_STATUS_KEY", () => $6e79eecdba5a58dc$export$123b1b8742c0ac6a);
var $6e79eecdba5a58dc$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $6e79eecdba5a58dc$export$45e63649edff1e2a = 'ASSETS';
const $6e79eecdba5a58dc$export$45c80c6b98d65f36 = 3;
const $6e79eecdba5a58dc$export$7b4183e5f0de390a = 1000;
const $6e79eecdba5a58dc$export$891dc7068a3d5e65 = 14;
const $6e79eecdba5a58dc$export$6e594fe130dbe3b = 14;
var $6e79eecdba5a58dc$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $6e79eecdba5a58dc$export$c889532d47d74e9c = 'bff';
const $6e79eecdba5a58dc$export$123b1b8742c0ac6a = 'flightdeck';
const $6e79eecdba5a58dc$export$95d80cce92acae9 = 'uc-suggestions';
const $6e79eecdba5a58dc$export$1631e8a201b50246 = 'uc-menu-items';

});

parcelRegister("9tH93", function(module, exports) {
$parcel$export(module.exports, "BFFContext", () => $ed8f2aa53d822734$export$873dcaf380a86d6b);
$parcel$export(module.exports, "useBFFContext", () => $ed8f2aa53d822734$export$63342c357ecccda2);
$parcel$export(module.exports, "BFFProvider", () => $ed8f2aa53d822734$export$71a938590b6955cc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iJSFh = parcelRequire("iJSFh");
const $ed8f2aa53d822734$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $ed8f2aa53d822734$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    value: $ed8f2aa53d822734$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: (name, status)=>{}
});
function $ed8f2aa53d822734$export$63342c357ecccda2() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($ed8f2aa53d822734$export$873dcaf380a86d6b);
}
function $ed8f2aa53d822734$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $iJSFh.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState([]);
    const updateCurrentLoadingRequests = (0, $eJOHy.useCallback)((name, status)=>{
        switch(status){
            case (0, $iJSFh.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $iJSFh.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $iJSFh.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ed8f2aa53d822734$export$873dcaf380a86d6b.Provider, {
        value: {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        },
        children: children
    });
}
const $ed8f2aa53d822734$var$defaultUserControls = {
    user: undefined
};
const $ed8f2aa53d822734$export$38ee920e59704589 = /*#__PURE__*/ (0, $eJOHy.createContext)($ed8f2aa53d822734$var$defaultUserControls);
function $ed8f2aa53d822734$export$87c54b525b914dab() {
    return (0, $eJOHy.useContext)($ed8f2aa53d822734$export$38ee920e59704589);
}

});

parcelRegister("1w126", function(module, exports) {
$parcel$export(module.exports, "useBFFDataProvider", () => $23a0ab99a136261f$export$a00b492c9c3c66db);

var $eJOHy = parcelRequire("eJOHy");

var $iJSFh = parcelRequire("iJSFh");

var $gh36O = parcelRequire("gh36O");

var $1KRhQ = parcelRequire("1KRhQ");

var $4A2Cp = parcelRequire("4A2Cp");

var $jiuUu = parcelRequire("jiuUu");

var $jjxsC = parcelRequire("jjxsC");
async function $23a0ab99a136261f$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $23a0ab99a136261f$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, product: product, userId: userId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $1KRhQ.useCache)();
    const { setStatus: setStatus, status: status } = (0, $jiuUu.useStatus)();
    const { productLinks: productLinks } = (0, $4A2Cp.useProductLinks)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $jjxsC.useURLBuilder)({
        cloudId: cloudId,
        userId: userId,
        product: product
    });
    const currentRequest = (0, $eJOHy.useRef)(null);
    const fetchData = (0, $eJOHy.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        setStatus((0, $iJSFh.RequestStatus).LOADING, (0, $iJSFh.BFF_REQUEST_STATUS_KEY));
        try {
            const response = await (0, $gh36O.fetchJSON)(url, {});
            switch(response.status){
                case (0, $iJSFh.RequestStatus).ERROR:
                    throw response.error;
                case (0, $iJSFh.RequestStatus).COMPLETE:
                    if (!successCheck || successCheck(response.data)) {
                        setStatus((0, $iJSFh.RequestStatus).COMPLETE, (0, $iJSFh.BFF_REQUEST_STATUS_KEY));
                        currentRequest.current = null;
                        return response.data;
                    } else throw new Error('BFF success check failed');
            }
        } catch (e) {
            const maxAttempts = request?.maxAttempts ?? (0, $iJSFh.MAX_ATTEMPTS_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                // Introduce longer wait times for each retry attempt
                await $23a0ab99a136261f$var$wait((request?.attemptInterval ?? (0, $iJSFh.RETRY_INTERVAL_DEFAULT)) * attemptCount);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $iJSFh.RequestStatus).ERROR);
                throw new Error('Max attempts reached');
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $eJOHy.useCallback)(async ()=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({});
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, (result)=>{
                return result.sites && result.sites.length > 0;
            });
            const fetchedData = await currentRequest.current;
            if (fetchedData.sites && fetchedData.sites.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}

});
parcelRegister("gh36O", function(module, exports) {
$parcel$export(module.exports, "isLocalHost", () => $7a154820a49f008b$export$f931afb2c5ecf7c7);
$parcel$export(module.exports, "fetchJSON", () => $7a154820a49f008b$export$81bec6e38e8b706b);

var $iJSFh = parcelRequire("iJSFh");

var $2U5u8 = parcelRequire("2U5u8");
function $7a154820a49f008b$export$23da1d24a38b0bde() {
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('jira-dev.com');
}
function $7a154820a49f008b$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $7a154820a49f008b$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $2U5u8.default).packageVersion,
                ...init?.headers
            }
        });
        const jsonResponse = await response.json();
        return {
            status: (0, $iJSFh.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $iJSFh.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}

});
parcelRegister("2U5u8", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd4356f7eafdbe62$export$2e2bcd8739ae039);
const $dd4356f7eafdbe62$var$packageName = "platform-pkg";
const $dd4356f7eafdbe62$var$packageVersion = "0.0.0-use.local";
var $dd4356f7eafdbe62$export$2e2bcd8739ae039 = {
    packageName: $dd4356f7eafdbe62$var$packageName,
    packageVersion: $dd4356f7eafdbe62$var$packageVersion
};

});


parcelRegister("1KRhQ", function(module, exports) {
$parcel$export(module.exports, "useCache", () => $483b5ff4c54e7a31$export$c6e89b6bb9436bc0);

var $eJOHy = parcelRequire("eJOHy");

var $9tH93 = parcelRequire("9tH93");
function $483b5ff4c54e7a31$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $eJOHy.useContext)((0, $9tH93.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $eJOHy.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $eJOHy.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $eJOHy.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $eJOHy.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        updateCacheKey: updateCacheKey,
        cacheKey: cacheKey,
        items: items
    };
}

});

parcelRegister("4A2Cp", function(module, exports) {
$parcel$export(module.exports, "useProductLinks", () => $62cb060baf7be75c$export$79322ba781a26ce1);

var $eJOHy = parcelRequire("eJOHy");

var $9nfpX = parcelRequire("9nfpX");

var $lopBx = parcelRequire("lopBx");

var $iJSFh = parcelRequire("iJSFh");

var $5XI89 = parcelRequire("5XI89");

var $9KvWa = parcelRequire("9KvWa");

var $5JLWZ = parcelRequire("5JLWZ");

var $1KRhQ = parcelRequire("1KRhQ");

var $jiuUu = parcelRequire("jiuUu");
function $62cb060baf7be75c$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) {
    const parsedEndUserActivationDate = Date.parse(endUserActivationDate || '');
    if (!endUserActivationDate || isNaN(parsedEndUserActivationDate) || ![
        'CONFLUENCE',
        'JIRA_SERVICE_DESK',
        'JIRA_PRODUCT_DISCOVERY'
    ].includes(productType)) return false;
    const days = (0, $5XI89.daysBetween)(new Date(parsedEndUserActivationDate), new Date());
    return days >= 0 && days <= (0, $iJSFh.DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW);
}
function $62cb060baf7be75c$var$checkIsNewlyAutoProvisioned(autoProvisionDate) {
    let isConsideredNew = false;
    if (autoProvisionDate) {
        const days = (0, $5XI89.daysBetween)(new Date(autoProvisionDate), new Date());
        isConsideredNew = days >= 0 && days <= (0, $iJSFh.DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW);
    }
    return isConsideredNew;
}
function $62cb060baf7be75c$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $62cb060baf7be75c$var$flightdeckClient = new (0, $9nfpX.default)('atlassian-navigagtion-bff-data-provider');
function $62cb060baf7be75c$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $1KRhQ.useCache)();
    const { setStatus: setStatus } = (0, $jiuUu.useStatus)();
    const [fdResponse, setFdResponse] = (0, $eJOHy.useState)(null);
    const [productConfig, setProductConfig] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $iJSFh.RequestStatus).LOADING, (0, $iJSFh.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $62cb060baf7be75c$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $lopBx.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $iJSFh.RequestStatus).COMPLETE, (0, $iJSFh.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch (e) {
                setStatus((0, $iJSFh.RequestStatus).ERROR, (0, $iJSFh.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $5JLWZ.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $5JLWZ.formatText)(rebrandedDisplayName),
                description: (0, $5JLWZ.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $iJSFh.ASSETS_APP_KEY]) config[0, $iJSFh.ASSETS_APP_KEY] = {
                key: (0, $iJSFh.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $5JLWZ.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $eJOHy.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $eJOHy.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$62cb060baf7be75c$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { autoProvisionDate: autoProvisionDate, companyHubName: companyHubName, isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium, endUserActivationDate: endUserActivationDate, url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    product: product,
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium,
                    companyHubName: companyHubName,
                    shouldShowNewLozenge: $62cb060baf7be75c$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) || productType !== 'CONFLUENCE' && $62cb060baf7be75c$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    shouldShowTryLozenge: productType === 'CONFLUENCE' && $62cb060baf7be75c$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    autoProvisionDate: autoProvisionDate,
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $9KvWa.sortArraysInObject)(products, (a, b)=>{
            return (0, $5JLWZ.sortAlphabetically)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}

});
parcelRegister("5XI89", function(module, exports) {
$parcel$export(module.exports, "daysBetween", () => $5efa2473d7d3de21$export$416492d1a5f46c79);
const $5efa2473d7d3de21$var$MILLISECONDS_IN_A_DAY = 86400000;
function $5efa2473d7d3de21$export$416492d1a5f46c79(firstDate, secondDate) {
    if (!$5efa2473d7d3de21$var$isValidDate(firstDate) || !$5efa2473d7d3de21$var$isValidDate(secondDate)) return -1;
    const first = firstDate.getTime();
    const second = secondDate.getTime();
    const millisecondsBetween = Math.abs(second - first);
    return Math.round(millisecondsBetween / $5efa2473d7d3de21$var$MILLISECONDS_IN_A_DAY);
}
// https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date/44198641#44198641
function $5efa2473d7d3de21$var$isValidDate(date) {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}

});

parcelRegister("9KvWa", function(module, exports) {
$parcel$export(module.exports, "sortArraysInObject", () => $c8d0494efb5cfae9$export$3e8bbf689f8e6cad);
function $c8d0494efb5cfae9$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}

});

parcelRegister("5JLWZ", function(module, exports) {
$parcel$export(module.exports, "formatText", () => $875730b52f65ef3f$export$905fe28a7c283e1d);
$parcel$export(module.exports, "sortAlphabetically", () => $875730b52f65ef3f$export$60f5d4abb43a14b3);
$parcel$export(module.exports, "atiArrayToParams", () => $875730b52f65ef3f$export$e57a6793604f15ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
const $875730b52f65ef3f$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...text
    });
};
const $875730b52f65ef3f$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
const $875730b52f65ef3f$export$e57a6793604f15ac = (atiArray)=>{
    return atiArray && atiArray.length > 0 ? atiArray.join(',') : undefined;
};

});

parcelRegister("jiuUu", function(module, exports) {
$parcel$export(module.exports, "useStatus", () => $57f0656b79d7cf88$export$53cc6abb6942ce72);

var $eJOHy = parcelRequire("eJOHy");

var $iJSFh = parcelRequire("iJSFh");

var $9tH93 = parcelRequire("9tH93");
function $57f0656b79d7cf88$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $9tH93.useBFFContext)();
    const isInitializing = (0, $eJOHy.useMemo)(()=>status === (0, $iJSFh.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $eJOHy.useMemo)(()=>status === (0, $iJSFh.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $eJOHy.useMemo)(()=>status === (0, $iJSFh.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $eJOHy.useMemo)(()=>status === (0, $iJSFh.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $eJOHy.useMemo)(()=>status !== (0, $iJSFh.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $eJOHy.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $iJSFh.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $iJSFh.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $iJSFh.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $eJOHy.useCallback)((newStatus, integratingComponent)=>{
        if (newStatus === (0, $iJSFh.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $iJSFh.RequestStatus).LOADING);
        if (newStatus === (0, $iJSFh.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $iJSFh.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $iJSFh.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $iJSFh.RequestStatus).ERROR);
        }
        // Don't allow the status to be marked as anything other than ERROR
        // if an error is pre-existing
        setValue((prev)=>{
            if (prev.status === (0, $iJSFh.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: newStatus === (0, $iJSFh.RequestStatus).ERROR ? (0, $iJSFh.RequestStatus).ERROR : (0, $iJSFh.RequestStatus).LOADING
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        status: status,
        isInitializing: isInitializing,
        isComplete: isComplete,
        isError: isError,
        isLoading: isLoading,
        isLoaded: isLoaded,
        setStatus: setStatus
    };
}

});


parcelRegister("jjxsC", function(module, exports) {
$parcel$export(module.exports, "useURLBuilder", () => $7ad6b8bf86874bde$export$3748aab334e7d372);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $iJSFh = parcelRequire("iJSFh");

var $gh36O = parcelRequire("gh36O");

var $5JLWZ = parcelRequire("5JLWZ");

var $1KRhQ = parcelRequire("1KRhQ");

var $9c98N = parcelRequire("9c98N");
var $7ad6b8bf86874bde$export$92af951f33a9009c = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["SUGGESTIONS"] = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
    BFFEndpointsEnum["MENU_ITEMS_V2"] = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
    return BFFEndpointsEnum;
}({});
function $7ad6b8bf86874bde$export$3748aab334e7d372({ cloudId: cloudId, userId: userId, product: product }) {
    const { consumer: consumer } = (0, $9c98N.useConsumer)();
    const { items: cachedItems } = (0, $1KRhQ.useCache)();
    const buildUCRecommendationURL = (0, $eJOHy.useCallback)(({ product: product, orgId: orgId, userId: userId, locale: locale, subProduct: subProduct, nativeAtis: nativeAtis, excludeAtis: excludeAtis, preferredAtis: preferredAtis })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
        const url = new URL(`${getHomeUrl()}${baseUrl}`);
        const searchParams = new URLSearchParams();
        const queryParams = {
            tenantid: cloudId,
            product: product,
            orgid: orgId,
            userid: userId,
            source: consumer,
            locale: locale,
            subproduct: subProduct,
            nativeatis: (0, $5JLWZ.atiArrayToParams)(nativeAtis),
            excludeatis: (0, $5JLWZ.atiArrayToParams)(excludeAtis),
            preferredatis: (0, $5JLWZ.atiArrayToParams)(preferredAtis)
        };
        Object.entries(queryParams).forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        consumer,
        cloudId
    ]);
    const buildUCMenuItemsURL = (0, $eJOHy.useCallback)(({ product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
        const url = new URL(`${getHomeUrl()}${baseUrl}`);
        const searchParams = new URLSearchParams();
        // Maintain specific order: tenantid, product, orgid, userid, source, then other params
        const queryParams = [
            [
                'tenantid',
                cloudId
            ],
            [
                'product',
                productParam || product
            ],
            [
                'orgid',
                orgId
            ],
            [
                'userid',
                userIdParam || userId
            ],
            [
                'source',
                consumer
            ],
            [
                'locale',
                locale
            ],
            [
                'subproduct',
                subProduct
            ],
            [
                'd',
                d
            ],
            [
                'ro',
                ro
            ],
            [
                'rt',
                rt
            ],
            [
                'ap',
                ap
            ]
        ];
        queryParams.forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        cloudId,
        product,
        userId,
        consumer
    ]);
    const buildProductShortcutURL = (0, $eJOHy.useCallback)(({ baseUrl: baseUrl })=>{
        baseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (cachedItems.length > 0) return '';
        const queryValues = '';
        return `${getHomeUrl()}${baseUrl}?${queryValues}`;
    }, [
        cachedItems
    ]);
    const buildURL = (0, $eJOHy.useCallback)(({ baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${getHomeUrl()}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $iJSFh.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({});
                break;
            case (0, $iJSFh.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url = buildProductShortcutURL({});
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        const formattedUrl = new URL(url);
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        if (userId) updatedParams.append('userid', userId);
        if (product && (0, $eGOwo.fg)('nav4-1960-support-product-in-bff-data-provider')) updatedParams.append('product', product);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId,
        userId,
        product
    ]);
    const getHomeUrl = ()=>{
        if ((0, $gh36O.isLocalHost)()) return 'https://home.stg.atlassian.com';
        return new URL(window.location.href).origin;
    };
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCRecommendationURL: buildUCRecommendationURL,
        buildUCMenuItemsURL: buildUCMenuItemsURL
    };
}

});
parcelRegister("9c98N", function(module, exports) {
$parcel$export(module.exports, "useConsumer", () => $473d3ba715bbb2b8$export$33062d550933de6f);

var $eJOHy = parcelRequire("eJOHy");

var $9tH93 = parcelRequire("9tH93");
function $473d3ba715bbb2b8$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $eJOHy.useContext)((0, $9tH93.BFFContext));
    return {
        consumer: consumer
    };
}

});



parcelRegister("ks23B", function(module, exports) {
$parcel$export(module.exports, "Products", () => $e80fae2ee14c05fc$export$92e44ea1079b9ec6);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $e80fae2ee14c05fc$export$85183a312807388d);
/**
 * Product keys as defined in flight-deck.
 * https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/
 */ var $e80fae2ee14c05fc$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_ALIGN"] = "ALIGN";
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["CUSTOMER_SERVICE_MANAGEMENT"] = "JIRA_CUSTOMER_SERVICE";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    return Products;
}({});
const $e80fae2ee14c05fc$export$85183a312807388d = 'navigation';

});

parcelRegister("l8bWr", function(module, exports) {
$parcel$export(module.exports, "getUrlMaybe", () => $fcbebda53a59339c$export$ac51fdc0c7ed862d);

var $fEtyx = parcelRequire("fEtyx");
const $fcbebda53a59339c$export$ac51fdc0c7ed862d = (options)=>options.url || (0, $fEtyx.getFallbackUrlMaybe)(options.fallbackUrl);

});
parcelRegister("fEtyx", function(module, exports) {
$parcel$export(module.exports, "getFallbackUrlMaybe", () => $a548b3d4da315d14$export$1f32ba41e2b31f39);

var $cFGyR = parcelRequire("cFGyR");
const $a548b3d4da315d14$export$1f32ba41e2b31f39 = (fallbackUrl)=>{
    if (fallbackUrl === undefined) return undefined;
    return (0, $cFGyR.getFallbackUrl)(fallbackUrl);
};

});
parcelRegister("cFGyR", function(module, exports) {
$parcel$export(module.exports, "getFallbackUrl", () => $6f41812038f0bc19$export$739b3f561aa47bc9);
const $6f41812038f0bc19$export$739b3f561aa47bc9 = (fallbackUrl)=>{
    if (typeof fallbackUrl === 'function') return fallbackUrl();
    // `fallbackUrl` is a string, return it directly
    return fallbackUrl;
};

});



parcelRegister("1MaXL", function(module, exports) {
$parcel$export(module.exports, "GlobalShortcutsWithIntlProvider", () => $1edac4810c5eb68f$export$6b89dea1a4334953);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3JwXA = parcelRequire("3JwXA");

var $66rG5 = parcelRequire("66rG5");

var $kDF2F = parcelRequire("kDF2F");
const $1edac4810c5eb68f$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $kDF2F.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $kDF2F.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $66rG5.default);
    } catch (e) {
    // ignore
    }
    return 0, $66rG5.default;
};
const $1edac4810c5eb68f$export$6b89dea1a4334953 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JwXA.default), {
        defaultMessages: (0, $66rG5.default),
        loaderFn: $1edac4810c5eb68f$var$fetchMessagesForLocale,
        children: children
    });
};

});
parcelRegister("66rG5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $34c8309b3c4076aa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lbyQ5 = parcelRequire("lbyQ5");
var $34c8309b3c4076aa$export$2e2bcd8739ae039 = (0, $lbyQ5.default);

});
parcelRegister("lbyQ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f945bb9a6162f02$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2f945bb9a6162f02$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'All sites',
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.projects-galaxia': 'Spaces',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Close',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} site',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.sites': '{productName} sites'
};

});


parcelRegister("kDF2F", function(module, exports) {
$parcel$export(module.exports, "asyncLanguages", () => $866aad5d65e2fe9f$export$3770c7a7737d463c);

























const $866aad5d65e2fe9f$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("emfbH")),
    da: ()=>(parcelRequire("k4iFQ")),
    de: ()=>(parcelRequire("4pjXd")),
    'en-GB': ()=>(parcelRequire("8Iqid")),
    'en-ZZ': ()=>(parcelRequire("f2cyl")),
    en: ()=>Promise.resolve((parcelRequire("66rG5"))),
    es: ()=>(parcelRequire("dHoaY")),
    fi: ()=>(parcelRequire("1hhrJ")),
    fr: ()=>(parcelRequire("8WWVu")),
    hu: ()=>(parcelRequire("eDdLK")),
    it: ()=>(parcelRequire("jmU2H")),
    ja: ()=>(parcelRequire("k8NsC")),
    ko: ()=>(parcelRequire("Yjlky")),
    nb: ()=>(parcelRequire("fK8qa")),
    nl: ()=>(parcelRequire("fgppr")),
    pl: ()=>(parcelRequire("dU0OL")),
    'pt-BR': ()=>(parcelRequire("1ey1n")),
    ru: ()=>(parcelRequire("6HTTo")),
    sv: ()=>(parcelRequire("8sL4H")),
    th: ()=>(parcelRequire("50roP")),
    tr: ()=>(parcelRequire("6DR2u")),
    uk: ()=>(parcelRequire("gJqS9")),
    vi: ()=>(parcelRequire("8eoGa")),
    zh_TW: ()=>(parcelRequire("gGdNi")),
    zh: ()=>(parcelRequire("gBUHF"))
};

});
parcelRegister("emfbH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aaDxK").then(()=>parcelRequire('e6Gy7'));

});

parcelRegister("k4iFQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9iwYS").then(()=>parcelRequire('cz6WI'));

});

parcelRegister("4pjXd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5E05A").then(()=>parcelRequire('dmhsc'));

});

parcelRegister("8Iqid", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("38IH5").then(()=>parcelRequire('21yAX'));

});

parcelRegister("f2cyl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4z9Sd").then(()=>parcelRequire('gOhSj'));

});

parcelRegister("dHoaY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iGQiJ").then(()=>parcelRequire('gyipB'));

});

parcelRegister("1hhrJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a5Tjc").then(()=>parcelRequire('9zMo7'));

});

parcelRegister("8WWVu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gURfF").then(()=>parcelRequire('fgEX0'));

});

parcelRegister("eDdLK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ds3ow").then(()=>parcelRequire('hYsef'));

});

parcelRegister("jmU2H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2zLjK").then(()=>parcelRequire('3UB4H'));

});

parcelRegister("k8NsC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1WUzB").then(()=>parcelRequire('2bDPW'));

});

parcelRegister("Yjlky", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("60iMu").then(()=>parcelRequire('367TJ'));

});

parcelRegister("fK8qa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8NjfR").then(()=>parcelRequire('43rrr'));

});

parcelRegister("fgppr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gxMbD").then(()=>parcelRequire('9FW7J'));

});

parcelRegister("dU0OL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9J7yq").then(()=>parcelRequire('9d11S'));

});

parcelRegister("1ey1n", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3RG3j").then(()=>parcelRequire('k9nal'));

});

parcelRegister("6HTTo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7v2o1").then(()=>parcelRequire('60Z0d'));

});

parcelRegister("8sL4H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Prkl").then(()=>parcelRequire('kelPQ'));

});

parcelRegister("50roP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2hKLN").then(()=>parcelRequire('4wFIg'));

});

parcelRegister("6DR2u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5gZ24").then(()=>parcelRequire('3jQNk'));

});

parcelRegister("gJqS9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ikYvP").then(()=>parcelRequire('520sz'));

});

parcelRegister("8eoGa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5lkC8").then(()=>parcelRequire('eVoO9'));

});

parcelRegister("gGdNi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("amrH3").then(()=>parcelRequire('8CC07'));

});

parcelRegister("gBUHF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3gboP").then(()=>parcelRequire('gmmTO'));

});



const $1f5444826c4f04af$export$fe240e33002221f = 'global-shortcuts-platform-component';
const $1f5444826c4f04af$export$2158b6d23c9689f5 = 'global-shortcuts-data-loading';

parcelRegister("bLper", function(module, exports) {
$parcel$export(module.exports, "DragAndDropOptionsContext", () => $773cfe1dbbc17d3f$export$c69308b19dea1022);
$parcel$export(module.exports, "DragAndDropOptionsProvider", () => $773cfe1dbbc17d3f$export$b40e2d2385213009);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $773cfe1dbbc17d3f$export$c69308b19dea1022 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    enabled: false
});
const $773cfe1dbbc17d3f$export$b40e2d2385213009 = ({ children: children, enabled: enabled = false })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($773cfe1dbbc17d3f$export$c69308b19dea1022.Provider, {
        value: {
            enabled: enabled
        },
        children: children
    });
};

});

parcelRegister("l0gTa", function(module, exports) {
$parcel$export(module.exports, "ImageFromUrl", () => $ea6e1bc7b9a8b025$export$8ce0ddc4c9a614d4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8wyVH = parcelRequire("8wyVH");
const $ea6e1bc7b9a8b025$export$8ce0ddc4c9a614d4 = ({ src: src, alt: alt, fallback: fallback, testId: testId })=>{
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    if (!src || hasError) return fallback;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
        src: src,
        alt: alt,
        onError: ()=>{
            setHasError(true);
        },
        testId: testId
    });
};

});

parcelRegister("77bbV", function(module, exports) {
$parcel$export(module.exports, "MenuSkeletonItem", () => $4e2bb25945f4547f$export$cde35cc9e1359709);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");

var $jjS5D = parcelRequire("jjS5D");
const $4e2bb25945f4547f$var$DEFAULT_MENU_SKELETON_HEIGHT = 32;
const $4e2bb25945f4547f$var$DEFAULT_AVATAR_HEIGHT = 20;
const $4e2bb25945f4547f$var$DEFAULT_CONTENT_HEIGHT = 12;
const $4e2bb25945f4547f$var$DEFAULT_BORDER_RADIUS = 4;
const $4e2bb25945f4547f$var$styles = {
    root: "_4t3izwfg _1bsb1osq _ca0qze3t _n3tdze3t _19bv1b66 _u5f31b66",
    avatar: "_19bvv77o"
};
const $4e2bb25945f4547f$export$cde35cc9e1359709 = ({ avatarHeight: avatarHeight = $4e2bb25945f4547f$var$DEFAULT_AVATAR_HEIGHT, contentHeight: contentHeight = $4e2bb25945f4547f$var$DEFAULT_CONTENT_HEIGHT })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dW738.default), {
        xcss: (0, $6qaBj.cx)($4e2bb25945f4547f$var$styles.root),
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
            alignItems: "center",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    xcss: (0, $6qaBj.cx)($4e2bb25945f4547f$var$styles.avatar),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: avatarHeight,
                        height: avatarHeight,
                        borderRadius: $4e2bb25945f4547f$var$DEFAULT_BORDER_RADIUS
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                    width: "100%",
                    height: contentHeight,
                    borderRadius: "0"
                })
            ]
        })
    });
};

});

parcelRegister("3uTOZ", function(module, exports) {
$parcel$export(module.exports, "ShortcutMenuItem", () => $bf65ac4b1997ba9c$export$af94fce1535255cc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");


var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $iJSFh = parcelRequire("iJSFh");

var $ks23B = parcelRequire("ks23B");

var $fEtyx = parcelRequire("fEtyx");

var $l8bWr = parcelRequire("l8bWr");

var $ljCBF = parcelRequire("ljCBF");

var $2epTy = parcelRequire("2epTy");

var $fNxSh = parcelRequire("fNxSh");
function $bf65ac4b1997ba9c$export$af94fce1535255cc({ shortcut: shortcut, status: status, expandItems: expandItems, forceStatic: forceStatic, promotedItem: promotedItem, siteName: siteName, product: product, openInSameTab: openInSameTab }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsName = shortcut.analyticsName || `unknown_${shortcut.label}`;
    const siteNameAriaLabel = siteName ? ` (${siteName})` : '';
    /**
	 * If the data provider is being initialised or loading, we want to display a placeholder item with a spinner.
	 */ const loading = (0, $eJOHy.useMemo)(()=>!!(!forceStatic && status && (status === (0, $iJSFh.RequestStatus).INIT || status === (0, $iJSFh.RequestStatus).LOADING)), [
        status,
        forceStatic
    ]);
    /**
	 * Set disabled state based on what we know at this point
	 * from whether we are forcing static rendering and the status of the BFF request.
	 * If we have more conditions received from the BFF in the future (such as permissions), we can account for those here too.
	 */ const disabled = (0, $eJOHy.useMemo)(()=>{
        // If forceStatic is explicitly set to true, do not disable the item
        if (forceStatic) return false;
        // Do not explicitly disable links that have empty URLs, because we don't want to display them at all
        // todo: Should we include undefined URLs and fallback URLs?
        if (shortcut.type === 'link') {
            if ((0, $eGOwo.fg)('navx-2531-disabled-shortcuts-on-request-error') ? (0, $fEtyx.getFallbackUrlMaybe)(shortcut.fallbackUrl) !== undefined : (0, $fEtyx.getFallbackUrlMaybe)(shortcut.fallbackUrl) === '') return false;
        }
        // Only show disabled state when the BFF request is complete and fails
        if (status === (0, $iJSFh.RequestStatus).ERROR) return true;
        if (forceStatic === undefined) return false;
        return !forceStatic;
    }, [
        forceStatic,
        shortcut,
        status
    ]);
    /**
	 * An event to pass down to the inner menu item component (MenuLinkItem or MenuExpandItem) to be called when the item is disabled.
	 * This allows the inner components to handle further disabling conditions within themselves if applicable,
	 * and optionally pass up a reason for the disabled state determined within itself.
	 * If no reason is passed, we check against what we know here from the data received from the BFF.
	 */ const onDisable = (0, $eJOHy.useCallback)((reason)=>{
        // Do not fire analytics event until loading is complete
        if (!status || status === (0, $iJSFh.RequestStatus).INIT || status === (0, $iJSFh.RequestStatus).LOADING) return;
        // This currently covers reasons like request errors.
        // If the BFF gives us more information in the future (such as permissions), that should be accounted for here too.
        const bffReason = status !== (0, $iJSFh.RequestStatus).COMPLETE ? status : undefined;
        createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            action: 'disabled',
            actionSubject: 'button',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: analyticsName,
                reason: reason ?? bffReason
            }
        }).fire((0, $ks23B.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsName,
        status
    ]);
    if (shortcut.type === 'component') {
        const Component = shortcut.component;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            onClick: ()=>{
                (0, $2epTy.fireMenuLinkItemClickAnalyticsEvent)(createAnalyticsEvent, analyticsName);
                shortcut.onClick?.();
            }
        });
    }
    if (shortcut.type === 'expand') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ljCBF.MenuExpandItem), {
        optionalRef: shortcut.ref,
        analyticsName: analyticsName,
        icon: shortcut.icon,
        label: shortcut.label,
        labelElem: shortcut.labelElem,
        items: expandItems,
        disabled: disabled,
        onDisable: onDisable,
        promotedItem: promotedItem,
        loading: loading,
        onClick: shortcut.onClick,
        onRightClick: shortcut.onRightClick,
        product: product
    }, shortcut.key);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2epTy.MenuLinkItem), {
        optionalRef: shortcut.ref,
        analyticsName: analyticsName,
        disabled: disabled,
        apsKey: shortcut.apsKey,
        icon: shortcut.icon,
        url: (0, $l8bWr.getUrlMaybe)(shortcut),
        label: shortcut.label,
        labelElem: shortcut.labelElem,
        onDisable: onDisable,
        loading: loading,
        actions: shortcut.actions,
        ariaLabel: formatMessage((0, $fNxSh.messages).menuLinkItemAriaLabel, {
            appName: shortcut.label,
            siteName: siteNameAriaLabel
        }),
        onClick: shortcut.onClick,
        isReorderable: shortcut.isReorderable,
        onRightClick: shortcut.onRightClick,
        menuItemId: shortcut.menuItemId,
        product: product,
        openInSameTab: openInSameTab
    }, shortcut.key);
}

});
parcelRegister("ljCBF", function(module, exports) {
$parcel$export(module.exports, "MenuExpandItem", () => $129f970b915a20a5$export$3b6395e687b929ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");


var $ftN6c = parcelRequire("ftN6c");

var $5CSKW = parcelRequire("5CSKW");

var $6qaBj = parcelRequire("6qaBj");

var $gyJTO = parcelRequire("gyJTO");

var $kKTZh = parcelRequire("kKTZh");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");

var $85fS3 = parcelRequire("85fS3");

var $8IeH1 = parcelRequire("8IeH1");

var $ks23B = parcelRequire("ks23B");

var $l8bWr = parcelRequire("l8bWr");

var $7pk8Q = parcelRequire("7pk8Q");

var $2epTy = parcelRequire("2epTy");

var $a4rLu = parcelRequire("a4rLu");

var $kZN3R = parcelRequire("kZN3R");

var $aBv90 = parcelRequire("aBv90");
const $129f970b915a20a5$var$styles = {
    root: "_otyr1b66"
};
const $129f970b915a20a5$export$3b6395e687b929ba = ({ icon: icon, label: label, labelElem: labelElem, analyticsName: analyticsName, items: items, disabled: disabled, onDisable: onDisable, promotedItem: promotedItem, loading: loading, onClick: onClick, optionalRef: optionalRef, product: product })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const mergedRefs = (0, $gyJTO.default)(optionalRef ? [
        optionalRef
    ] : []);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const closeFlyout = (0, $eJOHy.useCallback)(()=>setIsOpen(false), []);
    const toggleFlyout = (0, $eJOHy.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'globalNavigation',
            actionSubjectId: 'navigationItem',
            attributes: {
                name: analyticsName,
                isExpanding: !isOpen
            }
        }).fire((0, $ks23B.ANALYTICS_CHANNEL));
        setIsOpen((prev)=>!prev);
        onClick?.();
    }, [
        createAnalyticsEvent,
        analyticsName,
        isOpen,
        onClick
    ]);
    const createLinkItem = (0, $eJOHy.useCallback)((shortcut, index)=>{
        if (shortcut.type === 'expand') return /*#__PURE__*/ (0, $gt9Am.jsx)($129f970b915a20a5$export$3b6395e687b929ba, {
            icon: shortcut.icon,
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            items: shortcut.items,
            disabled: disabled,
            analyticsName: analyticsName,
            onClick: shortcut.onClick,
            onRightClick: shortcut.onRightClick,
            product: product
        }, `shortcut-${index}`);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2epTy.MenuLinkItem), {
            apsKey: shortcut.apsKey,
            icon: shortcut.icon,
            url: (0, $l8bWr.getUrlMaybe)(shortcut),
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            disabled: disabled,
            ariaLabel: formatMessage((0, $aBv90.messages).siteAriaLabel, {
                name: shortcut.label
            }),
            analyticsName: analyticsName,
            onClick: shortcut.onClick,
            onRightClick: shortcut.onRightClick,
            product: product
        }, shortcut?.apsKey ?? `shortcut-${index}`);
    }, [
        analyticsName,
        disabled,
        formatMessage,
        product
    ]);
    // If loading state then show loading placeholder
    if (loading === true) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a4rLu.MenuLoadingItem), {
        icon: icon,
        label: labelElem ?? label
    });
    if (disabled) {
        onDisable?.();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: labelElem ?? label
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gWy6a.FlyoutMenuItem), {
        isOpen: isOpen,
        onOpenChange: setIsOpen,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yLgR2.FlyoutMenuItemTrigger), {
                ref: mergedRefs,
                elemBefore: icon,
                onClick: toggleFlyout,
                children: labelElem ?? label
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $duFAq.FlyoutMenuItemContent), {
                onClose: closeFlyout,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7pk8Q.MenuContent), {
                    heading: labelElem ?? label,
                    children: [
                        promotedItem && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZN3R.MenuSection), {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $85fS3.MenuList), {
                                children: createLinkItem(promotedItem, 1)
                            }, "gas-promoted-sites")
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZN3R.MenuSection), {
                            label: formatMessage((0, $aBv90.messages).allSites),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $85fS3.MenuList), {
                                children: items?.map(createLinkItem)
                            }, "gas-all-sites")
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: (0, $6qaBj.cx)($129f970b915a20a5$var$styles.root),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                                shouldFitContainer: true,
                                appearance: "default",
                                onClick: closeFlyout,
                                children: formatMessage((0, $aBv90.messages).closeButtonAriaLabel)
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("7pk8Q", function(module, exports) {
$parcel$export(module.exports, "MenuContent", () => $ca7e7b59dc752395$export$479f0f2f71193efe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6qaBj = parcelRequire("6qaBj");

var $806LH = parcelRequire("806LH");

var $bzmGg = parcelRequire("bzmGg");
var $8nu6j = parcelRequire("8nu6j");

var $4XXAY = parcelRequire("4XXAY");
const $ca7e7b59dc752395$var$styles = {
    root: "_1e0c1txw _2lx21bp4 _c71l1x4w _18m91wug _19bvu2gc _u5f3u2gc",
    heading: "_1rjc12x7 _19bv12x7 _1e0c1txw _4cvr1h6o"
};
const $ca7e7b59dc752395$export$479f0f2f71193efe = ({ children: children, heading: heading })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bzmGg.default), {
        xcss: (0, $6qaBj.cx)($ca7e7b59dc752395$var$styles.root),
        inline: "space.100",
        children: [
            heading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: (0, $6qaBj.cx)($ca7e7b59dc752395$var$styles.heading),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: "xsmall",
                    as: "h2",
                    children: formatMessage((0, $4XXAY.messages).sites, {
                        productName: heading
                    })
                })
            }),
            children
        ]
    });
};

});
parcelRegister("4XXAY", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d9a0f558699cea48$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d9a0f558699cea48$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    sites: {
        id: 'navigation.global-shortcuts.sites',
        defaultMessage: '{productName} sites',
        description: 'The label that appends the product name in the expand menu'
    }
});

});


parcelRegister("2epTy", function(module, exports) {
$parcel$export(module.exports, "fireMenuLinkItemClickAnalyticsEvent", () => $c76496faeb8ad2c8$export$18a13ecc162cd5c2);
$parcel$export(module.exports, "MenuLinkItem", () => $c76496faeb8ad2c8$export$68ef190193a37bc2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2SSuc = parcelRequire("2SSuc");

var $lRq8t = parcelRequire("lRq8t");


var $ftN6c = parcelRequire("ftN6c");

var $6qaBj = parcelRequire("6qaBj");

var $gyJTO = parcelRequire("gyJTO");

var $9itkV = parcelRequire("9itkV");

var $kKTZh = parcelRequire("kKTZh");

var $2dvSy = parcelRequire("2dvSy");

var $8IeH1 = parcelRequire("8IeH1");

var $clIFu = parcelRequire("clIFu");

var $2LGhB = parcelRequire("2LGhB");

var $ks23B = parcelRequire("ks23B");

var $7PH2o = parcelRequire("7PH2o");

var $kQxh3 = parcelRequire("kQxh3");

var $a4rLu = parcelRequire("a4rLu");

var $2N8PD = parcelRequire("2N8PD");

var $1U2nM = parcelRequire("1U2nM");
const $c76496faeb8ad2c8$export$18a13ecc162cd5c2 = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $ks23B.ANALYTICS_CHANNEL));
};
const $c76496faeb8ad2c8$var$styles = {
    iconsBlock: "_18zr12x7"
};
const $c76496faeb8ad2c8$var$MenuLinkItemComponent = ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, optionalRef: optionalRef, openInSameTab: openInSameTab })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const mergedRefs = (0, $gyJTO.default)(optionalRef ? [
        optionalRef
    ] : []);
    // Only render link item if url is defined
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2dvSy.LinkMenuItem), {
        actionsOnHover: actions && actions.length && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2N8PD.ShortcutActionMenu), {
            actions: actions
        }),
        elemBefore: icon,
        // TODO: Add spacing="spacious" to LinkExternalIcon, and we can remove the parent Box
        elemAfter: openInSameTab ? undefined : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $6qaBj.cx)($c76496faeb8ad2c8$var$styles.iconsBlock),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                label: formatMessage((0, $1U2nM.messages).linkExternalIconLabel),
                size: "small"
            })
        }),
        href: url || '',
        target: openInSameTab ? '_self' : '_blank',
        onClick: onClick,
        ref: mergedRefs,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "aria-label": ariaLabel,
            children: labelElem ?? label
        })
    });
};
const $c76496faeb8ad2c8$var$MenuLinkItemDraggableComponent = ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, isReorderable: isReorderable, optionalRef: optionalRef, menuItemId: menuItemId, openInSameTab: openInSameTab })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { enabled: enabled } = (0, $kQxh3.useDragAndDropOptions)();
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $2LGhB.useItemDragAndDrop)({
        id: menuItemId,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        l1DragAndDropEnabled: enabled,
        onExpandFlyoutToggle: ()=>{},
        peek: false,
        item: {
            type: 'link',
            elemBefore: icon,
            label: label,
            labelElem: labelElem,
            href: url || '',
            isReorderable: isReorderable
        },
        group: (0, $clIFu.L1_MENU_GROUPS).SHORTCUTS
    });
    // Can possibly be undefined
    const draggableRefCollection = draggableRef ? [
        draggableRef
    ] : [];
    const mergedRefs = (0, $gyJTO.default)(optionalRef ? [
        optionalRef,
        ...draggableRefCollection
    ] : [
        ...draggableRefCollection
    ]);
    // Only render link item if url is defined
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2dvSy.LinkMenuItem), {
                isDragging: isDragging,
                hasDragIndicator: true,
                ref: mergedRefs,
                dropIndicator: dropIndicator,
                visualContentRef: dropTargetRef,
                actionsOnHover: actions && actions.length && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2N8PD.ShortcutActionMenu), {
                    actions: actions
                }),
                elemBefore: icon,
                elemAfter: openInSameTab ? undefined : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $6qaBj.cx)($c76496faeb8ad2c8$var$styles.iconsBlock),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                        label: formatMessage((0, $1U2nM.messages).linkExternalIconLabel),
                        size: "small"
                    })
                }),
                href: url || '',
                target: openInSameTab ? '_self' : '_blank',
                onClick: onClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    "aria-label": ariaLabel,
                    children: labelElem ?? label
                })
            }),
            maybeDragPreview
        ]
    });
};
const $c76496faeb8ad2c8$export$68ef190193a37bc2 = ({ analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, disabled: disabled, onDisable: onDisable, ariaLabel: ariaLabel, loading: loading, actions: actions, onClick: onClick, onRightClick: onRightClick, optionalRef: optionalRef, isReorderable: isReorderable, menuItemId: menuItemId, product: product = 'globalNavigation', openInSameTab: openInSameTab })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { enabled: enabled } = (0, $kQxh3.useDragAndDropOptions)();
    const analyticsUrlWrapper = (0, $2SSuc.default)({
        bridge: 'globalShortcuts',
        product: product
    });
    const getTargetUrl = (0, $eJOHy.useCallback)((url)=>{
        // For SPA links, we don't want to wrap the URL
        if (!$c76496faeb8ad2c8$var$isValidUrl(url)) return url;
        try {
            const parsedUrl = new URL(url);
            const continueParam = parsedUrl.searchParams.get('continue');
            if (!continueParam) // If there is no continue param, we just wrap the whole URL
            return analyticsUrlWrapper(url);
            // Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
            const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
            // Reconstruct the original URL with the wrapped continue param
            parsedUrl.searchParams.set('continue', wrappedContinueUrl);
            return parsedUrl.toString();
        } catch (e) {
            // Gracefully handle any URL parsing errors by returning the original URL
            // TODO: Log error to Sentry
            return url;
        }
    }, [
        analyticsUrlWrapper
    ]);
    const onClickMenuLinkItem = (0, $eJOHy.useCallback)(()=>{
        $c76496faeb8ad2c8$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
        onClick?.();
    }, [
        createAnalyticsEvent,
        analyticsName,
        onClick
    ]);
    // If loading is true, we want to render a representation of the button
    if (loading === true) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a4rLu.MenuLoadingItem), {
        icon: icon,
        label: labelElem ?? label,
        showLinkIcon: true
    });
    // Don't render anything if url is undefined or empty, and disabled is not explicitly set to true
    if ((!url || url === '') && !disabled) return null;
    // Render disabled items if no url and/or disabled is true
    if (!url || disabled) {
        if (!url || url === '') onDisable?.('Invalid URL');
        else onDisable?.();
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kKTZh.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: [
                labelElem ?? label,
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    "aria-label": formatMessage((0, $1U2nM.messages).disabledItemAriaLabel)
                })
            ]
        });
    }
    const targetUrl = getTargetUrl(url);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7PH2o.ElementEventListener), {
        handler: onRightClick,
        children: enabled && menuItemId ? /*#__PURE__*/ (0, $gt9Am.jsx)($c76496faeb8ad2c8$var$MenuLinkItemDraggableComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            menuItemId: menuItemId,
            openInSameTab: openInSameTab
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)($c76496faeb8ad2c8$var$MenuLinkItemComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            openInSameTab: openInSameTab
        })
    });
};
const $c76496faeb8ad2c8$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});
parcelRegister("2SSuc", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d01871180411970$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $7pw1V = parcelRequire("7pw1V");

var $eGOwo = parcelRequire("eGOwo");

var $dD14M = parcelRequire("dD14M");

var $hp1uj = parcelRequire("hp1uj");

var $jrk8A = parcelRequire("jrk8A");
function $8d01871180411970$export$2e2bcd8739ae039(options) {
    const [interactionSessionId, setInteractionSessionId] = (0, $eJOHy.useState)('');
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const isEnabled = (0, $eGOwo.fg)('analytics_cross_product_interaction_tracking') && !(0, $7pw1V.isFedrampModerate)();
    // Client does not change on re-render - cache with useMemo
    const interactionSessionClient = (0, $eJOHy.useMemo)(()=>{
        if (isEnabled) return new (0, $dD14M.default)();
        else return null;
    }, [
        isEnabled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // Fetch any initial interaction session ID
            const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
            currentSessionId && setInteractionSessionId(currentSessionId);
            // Add event listener that subscribes to any future interaction session ID updates
            const unbind = (0, $4eDgu.bind)(document, {
                type: (0, $jrk8A.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    if (!isEnabled) return (url)=>url;
    return (url)=>(0, $hp1uj.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
}

});

parcelRegister("clIFu", function(module, exports) {
$parcel$export(module.exports, "L1_MENU_GROUPS", () => $e7513fb68ccdddb3$export$72b069d0875dccc);
const $e7513fb68ccdddb3$export$72b069d0875dccc = {
    MENU: 'L1MenuGroup',
    SHORTCUTS: 'L1ShortcutsGroup'
};

});

parcelRegister("2LGhB", function(module, exports) {
$parcel$export(module.exports, "useItemDragAndDrop", () => $020753cd43eaa970$export$4696d1da23170d9a);

var $eJOHy = parcelRequire("eJOHy");

var $V3tNZ = parcelRequire("V3tNZ");

var $i5aGq = parcelRequire("i5aGq");

var $dHlZd = parcelRequire("dHlZd");

var $4XlHe = parcelRequire("4XlHe");
function $020753cd43eaa970$export$4696d1da23170d9a({ item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek, l1DragAndDropEnabled: l1DragAndDropEnabled, group: group }) {
    const isItemDraggable = !!l1DragAndDropEnabled && !peek && (item.isHideable !== false || item.isReorderable !== false) && // Custom items must explicitly opt-in to being draggable since they need to consume the refs for it to work
    (item.type !== 'custom' || !!item.isDraggable);
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $V3tNZ.useMenuItemDragAndDrop)({
        ...isItemDraggable && {
            draggable: {
                getInitialData: ()=>(0, $dHlZd.getL1ItemData)({
                        menuItemId: id,
                        label: item.label,
                        isHidden: false,
                        isHideable: item.isHideable !== false,
                        isReorderable: item.isReorderable !== false,
                        group: group
                    }),
                getDragPreviewPieces: ()=>({
                        elemBefore: (0, $4XlHe.getElemBeforeForItem)(item),
                        content: (0, $4XlHe.getDragPreviewContentForItem)(item)
                    })
            },
            dropTarget: {
                getData: (args)=>{
                    const { source: source } = args;
                    return (0, $dHlZd.getL1ItemData)({
                        menuItemId: id,
                        label: item.label,
                        isHidden: false,
                        isHideable: item.isHideable !== false,
                        isReorderable: item.isReorderable !== false,
                        group: source?.data?.group
                    });
                },
                getOperations: ()=>({
                        'reorder-before': 'available',
                        'reorder-after': 'available'
                    }),
                canDrop: (args)=>{
                    const { source: source } = args;
                    return (0, $dHlZd.isL1ItemData)(source.data) && source.data.menuItemId !== id && source.data.isReorderable === true && (0, $dHlZd.isL1ItemDataInGroup)(source.data, group);
                }
            }
        }
    });
    const registry = (0, $i5aGq.useElementRegistry)();
    const registrationRef = (0, $eJOHy.useRef)(null);
    const draggableRef = (0, $eJOHy.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            draggableAnchorRef.current = null;
            draggableButtonRef.current = null;
            return;
        }
        // Set to appropriate ref from the drag and drop hook
        if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
        else draggableButtonRef.current = element;
        // Unregister the previous element if it exists
        if (registrationRef.current) registrationRef.current();
        // Register the element with the registry
        registrationRef.current = registry.registerL1Item({
            id: id,
            element: element
        });
    }, [
        id,
        registry,
        draggableAnchorRef,
        draggableButtonRef,
        registrationRef
    ]);
    const isDragging = !!isItemDraggable && dragState.type === 'dragging';
    const expandableClosedForDrag = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!isExpandable || !isItemDraggable) return;
        if (isDragging && isExpandOrFlyoutOpen) {
            // Close the expandable when dragging starts
            onExpandFlyoutToggle(false);
            // Keep track of whether we closed the expandable for drag
            expandableClosedForDrag.current = true;
        } else if (!isDragging && expandableClosedForDrag.current) {
            // If we were dragging and now we're not, reopen the expandable if it was closed
            onExpandFlyoutToggle(true);
            expandableClosedForDrag.current = false;
        }
    }, [
        isDragging,
        isExpandable,
        isExpandOrFlyoutOpen,
        isItemDraggable,
        expandableClosedForDrag,
        onExpandFlyoutToggle
    ]);
    return {
        draggableRef: isItemDraggable ? draggableRef : undefined,
        isItemDraggable: isItemDraggable,
        isDragging: isDragging,
        dropTargetRef: isItemDraggable ? dropTargetRef : undefined,
        dropIndicator: isItemDraggable ? dropIndicator : undefined,
        maybeDragPreview: isItemDraggable ? dragPreview : null
    };
}

});
parcelRegister("i5aGq", function(module, exports) {
$parcel$export(module.exports, "createElementRegistry", () => $678719da2e5c9a6c$export$b8d30beb0c187a7);
$parcel$export(module.exports, "ElementRegistryProvider", () => $678719da2e5c9a6c$export$ce0cc6a5e9b6a71a);
$parcel$export(module.exports, "useElementRegistry", () => $678719da2e5c9a6c$export$9a176103b34f9da9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
// When a user drags & drops a navigation item, ADS recommends that we flash the item visually, and if the move was
// triggered by keyboard, also set focus to the moved item. This element registry allows GSN to keep track of the
// actual HTML elements of the L1 items, so that we can flash and focus them after the drag & drop action is performed.
// This pattern is recommended by AtlasKit in the side nav drag & drop documentation:
// https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#on-drop
const $678719da2e5c9a6c$var$MORE_MENU_ID = Symbol('moreMenuId');
function $678719da2e5c9a6c$export$b8d30beb0c187a7() {
    const registry = new Map();
    function registerL1Item({ id: id, element: element }) {
        registry.set(id, element);
        return function cleanup() {
            registry.delete(id);
        };
    }
    function getL1ItemElement(id) {
        return registry.get(id);
    }
    function registerMoreMenuItem(element) {
        return registerL1Item({
            id: $678719da2e5c9a6c$var$MORE_MENU_ID,
            element: element
        });
    }
    function getMoreMenuElement() {
        return getL1ItemElement($678719da2e5c9a6c$var$MORE_MENU_ID);
    }
    return {
        registerL1Item: registerL1Item,
        getL1ItemElement: getL1ItemElement,
        registerMoreMenuItem: registerMoreMenuItem,
        getMoreMenuElement: getMoreMenuElement
    };
}
const $678719da2e5c9a6c$var$ElementRegistryContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $678719da2e5c9a6c$export$ce0cc6a5e9b6a71a({ children: children, registry: registry }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($678719da2e5c9a6c$var$ElementRegistryContext.Provider, {
        value: registry,
        children: children
    });
}
function $678719da2e5c9a6c$export$9a176103b34f9da9() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($678719da2e5c9a6c$var$ElementRegistryContext);
    (0, $8GOss.default)(elementRegistry, 'useElementRegistry must be used within an ElementRegistryProvider');
    return elementRegistry;
}

});

parcelRegister("dHlZd", function(module, exports) {
$parcel$export(module.exports, "getL1ItemData", () => $80de873fe2e8c0ec$export$e9f7c92759d0f281);
$parcel$export(module.exports, "isL1ItemData", () => $80de873fe2e8c0ec$export$e52c346726a16591);
$parcel$export(module.exports, "isL1ItemDataInGroup", () => $80de873fe2e8c0ec$export$9d9fcc463b545806);
$parcel$export(module.exports, "getMoreMenuData", () => $80de873fe2e8c0ec$export$e74f096ffe08821d);
$parcel$export(module.exports, "isMoreMenuData", () => $80de873fe2e8c0ec$export$e37de48254c6595e);

var $clIFu = parcelRequire("clIFu");
const $80de873fe2e8c0ec$var$l1ItemKey = Symbol('l1ItemKey');
const $80de873fe2e8c0ec$var$moreMenuKey = Symbol('moreMenuKey');
function $80de873fe2e8c0ec$export$e9f7c92759d0f281({ menuItemId: menuItemId, label: label, isHidden: isHidden, isHideable: isHideable, isReorderable: isReorderable, group: group = (0, $clIFu.L1_MENU_GROUPS).MENU }) {
    return {
        menuItemId: menuItemId,
        label: label,
        isHidden: isHidden,
        isHideable: isHideable,
        isReorderable: isReorderable,
        [$80de873fe2e8c0ec$var$l1ItemKey]: true,
        group: group
    };
}
function $80de873fe2e8c0ec$export$e52c346726a16591(data) {
    return data[$80de873fe2e8c0ec$var$l1ItemKey] === true;
}
function $80de873fe2e8c0ec$export$9d9fcc463b545806(data, groups) {
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
}
const $80de873fe2e8c0ec$export$7960450fbf5a0a72 = Symbol('moreMenuId');
function $80de873fe2e8c0ec$export$e74f096ffe08821d() {
    return {
        menuItemId: $80de873fe2e8c0ec$export$7960450fbf5a0a72,
        [$80de873fe2e8c0ec$var$moreMenuKey]: true
    };
}
function $80de873fe2e8c0ec$export$e37de48254c6595e(data) {
    return data[$80de873fe2e8c0ec$var$moreMenuKey] === true;
}

});

parcelRegister("4XlHe", function(module, exports) {
$parcel$export(module.exports, "getElemBeforeForItem", () => $ab58396da40dd6e6$export$9d7e63760538f47f);
$parcel$export(module.exports, "getDragPreviewContentForItem", () => $ab58396da40dd6e6$export$d5d05b25e1604a8f);
function $ab58396da40dd6e6$export$9d7e63760538f47f(item) {
    if (item.type === 'custom' && item.dragPreviewContent) // If the custom item has a drag preview content, we should assume it contains the icon already
    return undefined;
    return item.elemBefore;
}
function $ab58396da40dd6e6$export$d5d05b25e1604a8f(item) {
    if (item.type === 'custom' && item.dragPreviewContent) // Custom items may return their drag preview content as a React node
    return item.dragPreviewContent;
    // If not custom or drag preview content not present, use the label
    return item.labelElem ?? item.label;
}

});


parcelRegister("7PH2o", function(module, exports) {
$parcel$export(module.exports, "ElementEventListener", () => $9afd151ce7a5be8d$export$8209b3c2d1620841);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");
const $9afd151ce7a5be8d$export$8209b3c2d1620841 = ({ handler: handler, children: children })=>{
    const wrapperRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (!wrapperRef.current || !handler) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) handler();
        };
        const unbind = (0, $4eDgu.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        handler
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ref: wrapperRef,
        children: children
    });
};

});

parcelRegister("kQxh3", function(module, exports) {
$parcel$export(module.exports, "useDragAndDropOptions", () => $f2d6827f57bfb551$export$eae7963fc47ca0d0);

var $eJOHy = parcelRequire("eJOHy");

var $bLper = parcelRequire("bLper");
const $f2d6827f57bfb551$export$eae7963fc47ca0d0 = ()=>{
    const context = (0, $eJOHy.useContext)((0, $bLper.DragAndDropOptionsContext));
    if (!context) return {
        enabled: false
    };
    return {
        enabled: context.enabled
    };
};

});

parcelRegister("a4rLu", function(module, exports) {
$parcel$export(module.exports, "MenuLoadingItem", () => $e94bec13aafe9ebd$export$6c62e509491f8f00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6qaBj = parcelRequire("6qaBj");

var $9itkV = parcelRequire("9itkV");

var $kKTZh = parcelRequire("kKTZh");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $71ScO = parcelRequire("71ScO");
const $e94bec13aafe9ebd$var$styles = {
    iconsBlock: "_18zr12x7"
};
const $e94bec13aafe9ebd$export$6c62e509491f8f00 = ({ icon: icon, label: label, showLinkIcon: showLinkIcon })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kKTZh.ButtonMenuItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $6qaBj.cx)($e94bec13aafe9ebd$var$styles.iconsBlock),
            children: showLinkIcon ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                label: formatMessage((0, $71ScO.messages).loadingItemAriaLabel),
                size: "small"
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: "small"
            })
        }),
        testId: "menu-button-loading",
        children: [
            label,
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                "aria-label": formatMessage((0, $71ScO.messages).loadingItemAriaLabel)
            })
        ]
    });
};

});
parcelRegister("71ScO", function(module, exports) {
$parcel$export(module.exports, "messages", () => $056f5a2409babf8a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $056f5a2409babf8a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    loadingItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is loading',
        defaultMessage: '(loading)'
    }
});

});


parcelRegister("2N8PD", function(module, exports) {
$parcel$export(module.exports, "ShortcutActionMenu", () => $71d2b3f89d4dae3e$export$7e648395389e18b0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $dcLzM = parcelRequire("dcLzM");

var $7saMl = parcelRequire("7saMl");
var $jUgeq = parcelRequire("jUgeq");

var $kJsb4 = parcelRequire("kJsb4");

var $ihGuW = parcelRequire("ihGuW");
const $71d2b3f89d4dae3e$export$7e648395389e18b0 = ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUgeq.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
                        onClick: (e)=>{
                            e.preventDefault();
                            action.onClick?.();
                            setIsOpen(false);
                        },
                        children: action.component
                    }, index))
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $ihGuW.messages).shortcutActionOpenMenuLabel),
                onClick: ()=>setIsOpen(true)
            })
    });
};

});
parcelRegister("ihGuW", function(module, exports) {
$parcel$export(module.exports, "messages", () => $38038bbd3d560a01$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $38038bbd3d560a01$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: 'navigation.global-shortcuts.shortcut-action.open-menu-label',
        description: 'Label for shortcut action items button',
        defaultMessage: 'open menu'
    }
});

});


parcelRegister("1U2nM", function(module, exports) {
$parcel$export(module.exports, "messages", () => $de4eab4a40e0df3d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $de4eab4a40e0df3d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    disabledItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is disabled',
        defaultMessage: '(currently unavailable)'
    },
    loadingItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.loading-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is loading',
        defaultMessage: '(loading)'
    },
    linkExternalIconLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.link-external-item-label',
        description: 'Label for the link external icon',
        defaultMessage: 'Open external link icon'
    }
});

});


parcelRegister("kZN3R", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $bd4e3e496d0699e2$export$4b1545b4f2016d26);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
const $bd4e3e496d0699e2$var$styles = {
    heading: "_11c82smr _1rjcu2gc _19bv12x7 _ca0qu2gc _n3tdu2gc _syaz1gjq _k48p1pd9 _1e0c1txw _4cvr1h6o"
};
const $bd4e3e496d0699e2$export$4b1545b4f2016d26 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
        direction: "column",
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: (0, $6qaBj.cx)($bd4e3e496d0699e2$var$styles.heading),
                children: label
            }),
            children
        ]
    });
};

});

parcelRegister("aBv90", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f62e26d88b96832d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f62e26d88b96832d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    allSites: {
        id: 'navigation.global-shortcuts.all-sites',
        defaultMessage: 'All sites',
        description: 'The "all sites" menu label in expand menu'
    },
    closeButtonAriaLabel: {
        id: 'navigation.global-shortcuts.menu-expand-item.close-button-aria-label',
        description: 'Close button for menu expand item content',
        defaultMessage: 'Close'
    },
    siteAriaLabel: {
        id: 'navigation.global-shortcuts.menu-expand-item.site-aria-label',
        description: 'Aria label for sites',
        defaultMessage: '{name} site'
    }
});

});


parcelRegister("fNxSh", function(module, exports) {
$parcel$export(module.exports, "messages", () => $afb4ecfa2a55c21b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $afb4ecfa2a55c21b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    menuLinkItemAriaLabel: {
        id: 'navigation.global-shortcuts.shortcut-link-item.aria-label',
        description: 'Aria label for menu link item',
        defaultMessage: '{appName}{siteName}'
    }
});

});



parcelRegister("1RKdF", function(module, exports) {
$parcel$export(module.exports, "productLinksWorkspaceCloudIdFilter", () => $a5752e36ad58c0e2$export$54a1da5292674ec8);
const $a5752e36ad58c0e2$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };

});

parcelRegister("9qvK9", function(module, exports) {
$parcel$export(module.exports, "useOrderedAppShortcuts", () => $5045ab6151543f3b$export$4bb4a114d280c175);

var $eJOHy = parcelRequire("eJOHy");
const $5045ab6151543f3b$export$4bb4a114d280c175 = (shortcuts, appItemsData)=>{
    const orderedShortcuts = (0, $eJOHy.useMemo)(()=>{
        if (!appItemsData || appItemsData.length === 0) return Object.values(shortcuts);
        return appItemsData.reduce((acc, value)=>{
            const config = shortcuts[value.menuId];
            if (config && value.visible) acc.push(config);
            return acc;
        }, []);
    }, [
        appItemsData,
        shortcuts
    ]);
    return orderedShortcuts;
};

});

parcelRegister("huZVT", function(module, exports) {
$parcel$export(module.exports, "useTeamsAppShortcut", () => $f3c7d9176e76ca2a$export$68b2e4594fafcb97);

var $eJOHy = parcelRequire("eJOHy");

var $79KhM = parcelRequire("79KhM");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $csD9i = parcelRequire("csD9i");

var $cFGzN = parcelRequire("cFGzN");

var $2VH7W = parcelRequire("2VH7W");

var $k8PfX = parcelRequire("k8PfX");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");



var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $41vqi = parcelRequire("41vqi");


var $4cTDP = parcelRequire("4cTDP");

var $dIJOd = parcelRequire("dIJOd");
const $f3c7d9176e76ca2a$var$CREATE_A_TEAM = 'createATeam';
const $f3c7d9176e76ca2a$var$INVITE_PEOPLE = 'invitePeople';
const $f3c7d9176e76ca2a$export$68b2e4594fafcb97 = ()=>{
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    const peopleMenuWrapperRef = (0, $79KhM.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$77bc79debbf5c069), (0, $4cTDP.fg)('teams-app-shortcut-nudge')).ref;
    const teamsConfig = (0, $csD9i.useTeams)(USER_NAVIGATION_ITEM_LINKS[0, $h4Bzb.MENU_ID_TEAMS], {
        ref: peopleMenuWrapperRef
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const invitePeopleModalTrigger = (0, $2VH7W.useInvitePeopleModal)();
    const [createTeamModal, createTeamModalTrigger] = (0, $cFGzN.useCreateTeamModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const component = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $4cTDP.fg)('teams-app-shortcut-nudge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dIJOd.InviteTeamNudgeAsync), null), createTeamModal);
    }, [
        createTeamModal
    ]);
    const config = (0, $eJOHy.useMemo)(()=>{
        const invitePeopleAction = (0, $4cTDP.fg)('hot-121631-disable-teams-menu-invite-people') ? [] : [
            {
                onClick: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: 'dropdownItem',
                        actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS],
                        attributes: {
                            level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                            parentItemId: (0, $a9aec.GLOBAL_APP_SHORTCUT_TEAMS),
                            itemId: $f3c7d9176e76ca2a$var$INVITE_PEOPLE
                        }
                    });
                    invitePeopleModalTrigger();
                },
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $k8PfX.default).invitePeople))
            }
        ];
        return {
            ...teamsConfig,
            actions: [
                ...invitePeopleAction,
                {
                    onClick: ()=>{
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS],
                            attributes: {
                                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                                parentItemId: (0, $a9aec.GLOBAL_APP_SHORTCUT_TEAMS),
                                itemId: $f3c7d9176e76ca2a$var$CREATE_A_TEAM
                            }
                        });
                        createTeamModalTrigger();
                    },
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $k8PfX.default).createTeam))
                }
            ]
        };
    }, [
        teamsConfig,
        createTeamModalTrigger,
        invitePeopleModalTrigger,
        formatMessage,
        createAnalyticsEvent
    ]);
    return {
        config: config,
        component: component
    };
};

});
parcelRegister("csD9i", function(module, exports) {
$parcel$export(module.exports, "useTeams", () => $c1ae354b6a1e11dc$export$6fe02dcc2001dcb0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $ks23B = parcelRequire("ks23B");

var $eJ1Bz = parcelRequire("eJ1Bz");

var $cti2O = parcelRequire("cti2O");
const $c1ae354b6a1e11dc$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.TeamsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $c1ae354b6a1e11dc$export$6fe02dcc2001dcb0 = (fallbackUrl, options = {})=>(0, $eJ1Bz.useAppGlobalShortcutLinkItem)($c1ae354b6a1e11dc$var$icon, (0, $cti2O.messages).label, fallbackUrl, {
        apsKey: (0, $ks23B.Products).ATLAS_TEAMS,
        analyticsName: (0, $ks23B.Products).ATLAS_TEAMS,
        ...options
    });

});
parcelRegister("eJ1Bz", function(module, exports) {
$parcel$export(module.exports, "useAppGlobalShortcutLinkItem", () => $fb3a3916da05b2f4$export$7613f0bd7ffe380c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");
const $fb3a3916da05b2f4$export$7613f0bd7ffe380c = (icon, label, fallbackUrl, options)=>{
    const { labelElem: labelElem, apsKey: apsKey, ref: ref, analyticsName: analyticsName, menuItemId: menuItemId } = options ?? {};
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useMemo)(()=>({
            type: 'link',
            icon: icon,
            label: formatMessage(label),
            labelElem: labelElem,
            apsKey: apsKey,
            fallbackUrl: fallbackUrl,
            ref: ref,
            analyticsName: analyticsName,
            ...(0, $eGOwo.fg)('navx-515-l1-dnd-support') ? {
                menuItemId: menuItemId
            } : {}
        }), [
        apsKey,
        fallbackUrl,
        formatMessage,
        icon,
        label,
        labelElem,
        ref,
        analyticsName,
        menuItemId
    ]);
};

});

parcelRegister("cti2O", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e3e7861ea80572f6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e3e7861ea80572f6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.teams',
        defaultMessage: 'Teams',
        description: 'The link label for Teams'
    }
});

});



parcelRegister("g7Dyb", function(module, exports) {
$parcel$export(module.exports, "useLicenseFilterMap", () => $641cf0eae92bc890$export$bb19044ea3485639);

var $eJOHy = parcelRequire("eJOHy");

var $8Aapz = parcelRequire("8Aapz");

var $dDX87 = parcelRequire("dDX87");

var $kjVYD = parcelRequire("kjVYD");

var $3s8Zc = parcelRequire("3s8Zc");

var $5Byhs = parcelRequire("5Byhs");

var $e0m9Z = parcelRequire("e0m9Z");

var $8IuE5 = parcelRequire("8IuE5");

var $41vqi = parcelRequire("41vqi");

var $9Byj7 = parcelRequire("9Byj7");

var $aYncF = parcelRequire("aYncF");

var $e6s1C = parcelRequire("e6s1C");
const $641cf0eae92bc890$export$bb19044ea3485639 = (teamsAppConfig)=>{
    const licenceStates = (0, $e6s1C.useLicenseStates)();
    const products = (0, $aYncF.getLicensedProducts)();
    const hasConfluence = products[(0, $aYncF.LICENSED_PRODUCTS).CONFLUENCE];
    const hasLoom = products[(0, $aYncF.LICENSED_PRODUCTS).LOOM];
    let hasProject = true;
    let hasGoal = true;
    // The metadata used in getLicensedProducts() has changed from townsquare to project and goal.
    // Experiment cleaned up: always use PROJECT/GOAL metadata with TOWNSQUARE fallback
    hasProject = !!products[(0, $aYncF.LICENSED_PRODUCTS).PROJECT] || !!products[(0, $aYncF.LICENSED_PRODUCTS).TOWNSQUARE];
    hasGoal = !!products[(0, $aYncF.LICENSED_PRODUCTS).GOAL] || !!products[(0, $aYncF.LICENSED_PRODUCTS).TOWNSQUARE];
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    const confluenceItem = (0, $dDX87.useConfluence)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]);
    const loomItem = (0, $kjVYD.useLoom)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]);
    const assetsItem = (0, $8Aapz.useAssets)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]);
    const opsgenieItem = (0, $5Byhs.useOpsgenie)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]);
    const goalsItem = (0, $3s8Zc.useGoals)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]);
    const projectsItem = (0, $e0m9Z.useProjects)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]);
    return (0, $eJOHy.useMemo)(()=>{
        const assetsItemWithComponent = {
            ...assetsItem,
            component: $641cf0eae92bc890$var$AssetsComponent
        };
        if (licenceStates.core === 'ACTIVE') {
            if (licenceStates.serviceDesk === 'ACTIVE') return {
                ...hasConfluence ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: confluenceItem
                } : {},
                ...hasLoom ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: loomItem
                } : {},
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: assetsItemWithComponent,
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: opsgenieItem,
                ...teamsAppConfig ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                ...hasGoal ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
                } : {}
            };
            if (licenceStates.productDiscovery === 'ACTIVE') return {
                ...hasConfluence ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: confluenceItem
                } : {},
                ...hasLoom ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: loomItem
                } : {},
                ...teamsAppConfig ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                ...hasGoal ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
                } : {}
            };
        } else {
            if (licenceStates.serviceDesk === 'ACTIVE') return {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: assetsItemWithComponent,
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: opsgenieItem,
                ...teamsAppConfig ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                ...hasGoal ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
                } : {}
            };
            if (licenceStates.productDiscovery === 'ACTIVE') return {
                ...teamsAppConfig ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                ...hasGoal ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
                } : {}
            };
        }
        return {
            ...hasConfluence ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: confluenceItem
            } : {},
            ...hasLoom ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: loomItem
            } : {},
            ...teamsAppConfig ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
            } : {},
            ...hasGoal ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
            } : {},
            ...hasProject ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: projectsItem
            } : {}
        };
    }, [
        assetsItem,
        confluenceItem,
        goalsItem,
        hasConfluence,
        hasLoom,
        hasGoal,
        hasProject,
        licenceStates.core,
        licenceStates.productDiscovery,
        licenceStates.serviceDesk,
        loomItem,
        opsgenieItem,
        projectsItem,
        teamsAppConfig
    ]);
};
const $641cf0eae92bc890$var$AssetsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Byj7.GlobalAppShortcuts), {
        menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS
    });

});
parcelRegister("8Aapz", function(module, exports) {
$parcel$export(module.exports, "useAssets", () => $7edee544880bcbc0$export$bd973f06e9aaec8c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $ks23B = parcelRequire("ks23B");

var $eJ1Bz = parcelRequire("eJ1Bz");

var $46kmn = parcelRequire("46kmn");
const $7edee544880bcbc0$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.AssetsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $7edee544880bcbc0$export$bd973f06e9aaec8c = (fallbackUrl, options = {})=>(0, $eJ1Bz.useAppGlobalShortcutLinkItem)($7edee544880bcbc0$var$icon, (0, $46kmn.messages).label, fallbackUrl, {
        apsKey: (0, $ks23B.Products).ASSETS,
        analyticsName: (0, $ks23B.Products).ASSETS,
        ...options
    });

});
parcelRegister("46kmn", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b40dc3593fab329b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b40dc3593fab329b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.assets',
        defaultMessage: 'Assets',
        description: 'The link label for Assets'
    }
});

});


parcelRegister("dDX87", function(module, exports) {
$parcel$export(module.exports, "useConfluence", () => $aeda2376b042d2c6$export$4f925a926283ab5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $ks23B = parcelRequire("ks23B");

var $eJ1Bz = parcelRequire("eJ1Bz");

var $cu4Rp = parcelRequire("cu4Rp");
const $aeda2376b042d2c6$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $aeda2376b042d2c6$export$4f925a926283ab5 = (fallbackUrl, options = {})=>(0, $eJ1Bz.useAppGlobalShortcutLinkItem)($aeda2376b042d2c6$var$icon, (0, $cu4Rp.messages).label, fallbackUrl, {
        apsKey: (0, $ks23B.Products).CONFLUENCE,
        analyticsName: (0, $ks23B.Products).CONFLUENCE,
        ...options
    });

});
parcelRegister("cu4Rp", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0330660345846a42$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $0330660345846a42$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.confluence',
        defaultMessage: 'Confluence',
        description: 'The link label for Confluence'
    }
});

});


parcelRegister("kjVYD", function(module, exports) {
$parcel$export(module.exports, "useLoom", () => $d48c7fdfc988b616$export$ef6b4021b8157342);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $ks23B = parcelRequire("ks23B");

var $eJ1Bz = parcelRequire("eJ1Bz");

var $5RohZ = parcelRequire("5RohZ");
const $d48c7fdfc988b616$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.LoomIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $d48c7fdfc988b616$export$ef6b4021b8157342 = (fallbackUrl, options = {})=>(0, $eJ1Bz.useAppGlobalShortcutLinkItem)($d48c7fdfc988b616$var$icon, (0, $5RohZ.messages).label, fallbackUrl, {
        apsKey: (0, $ks23B.Products).LOOM,
        analyticsName: (0, $ks23B.Products).LOOM,
        ...options
    });

});
parcelRegister("5RohZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c2596b363babe427$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c2596b363babe427$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.loom',
        defaultMessage: 'Loom',
        description: 'The link label for Loom'
    }
});

});


parcelRegister("3s8Zc", function(module, exports) {
$parcel$export(module.exports, "useGoals", () => $e18b61ac40b38645$export$1b288bd6ab893e8f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $ks23B = parcelRequire("ks23B");

var $eJ1Bz = parcelRequire("eJ1Bz");

var $fnFIb = parcelRequire("fnFIb");
const $e18b61ac40b38645$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.GoalsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $e18b61ac40b38645$export$1b288bd6ab893e8f = (fallbackUrl, options = {})=>(0, $eJ1Bz.useAppGlobalShortcutLinkItem)($e18b61ac40b38645$var$icon, (0, $fnFIb.messages).label, fallbackUrl, {
        apsKey: (0, $ks23B.Products).ATLAS_GOALS,
        analyticsName: (0, $ks23B.Products).ATLAS_GOALS,
        ...options
    });

});
parcelRegister("fnFIb", function(module, exports) {
$parcel$export(module.exports, "messages", () => $bd7865579238185c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $bd7865579238185c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.goals',
        defaultMessage: 'Goals',
        description: 'The link label for Goals'
    }
});

});


parcelRegister("5Byhs", function(module, exports) {
$parcel$export(module.exports, "useOpsgenie", () => $ca6e79127e344bff$export$1a89b17f91671267);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $ks23B = parcelRequire("ks23B");

var $eJ1Bz = parcelRequire("eJ1Bz");

var $1Y2HI = parcelRequire("1Y2HI");
const $ca6e79127e344bff$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.OpsgenieIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $ca6e79127e344bff$export$1a89b17f91671267 = (fallbackUrl, options = {})=>(0, $eJ1Bz.useAppGlobalShortcutLinkItem)($ca6e79127e344bff$var$icon, (0, $1Y2HI.messages).label, fallbackUrl, {
        apsKey: (0, $ks23B.Products).OPSGENIE,
        analyticsName: (0, $ks23B.Products).OPSGENIE,
        ...options
    });

});
parcelRegister("1Y2HI", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f5cceff2e783b528$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f5cceff2e783b528$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.opsgenie',
        defaultMessage: 'Opsgenie',
        description: 'The link label for Opsgenie'
    }
});

});


parcelRegister("e0m9Z", function(module, exports) {
$parcel$export(module.exports, "useProjects", () => $0521979b5e83f90a$export$39d4f31fc4866d70);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $ks23B = parcelRequire("ks23B");

var $eJ1Bz = parcelRequire("eJ1Bz");

var $g1bQ7 = parcelRequire("g1bQ7");
const $0521979b5e83f90a$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ProjectsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $0521979b5e83f90a$export$39d4f31fc4866d70 = (fallbackUrl, options = {})=>{
    return (0, $eJ1Bz.useAppGlobalShortcutLinkItem)($0521979b5e83f90a$var$icon, (0, $g1bQ7.messages).label, fallbackUrl, {
        apsKey: (0, $ks23B.Products).PROJECTS,
        analyticsName: (0, $ks23B.Products).PROJECTS,
        ...options
    });
};

});
parcelRegister("g1bQ7", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d8a051bffcf1753a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d8a051bffcf1753a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.projects',
        defaultMessage: 'Projects',
        description: 'The link label for Projects'
    },
    labelGalaxia: {
        id: 'navigation.global-shortcuts.apps.projects-galaxia',
        defaultMessage: 'Spaces',
        description: 'The link label for Projects'
    }
});

});








parcelRegister("kHlOR", function(module, exports) {
$parcel$export(module.exports, "LazyAtlassianNavigation", () => $484a81aa80a53037$export$4caed23aa0274abb);

var $75yrv = parcelRequire("75yrv");

var $lOI8W = parcelRequire("lOI8W");

var $bQWwW = parcelRequire("bQWwW");

const $484a81aa80a53037$export$4caed23aa0274abb = (0, $bQWwW.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("96SSt"))).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation);
    if (!false) bundleReady.then(()=>{
        (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $75yrv.JS_EVAL_START))) {
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/index.tsx"
});

});

parcelRegister("ioHIu", function(module, exports) {
$parcel$export(module.exports, "genericProjectLayout", () => $b45ef5b2a7af08eb$export$85dad8e9886563f6);

var $cEBDW = parcelRequire("cEBDW");

var $6dwgv = parcelRequire("6dwgv");

var $aQoXd = parcelRequire("aQoXd");

var $8FCAy = parcelRequire("8FCAy");

var $dkgBy = parcelRequire("dkgBy");
const $b45ef5b2a7af08eb$export$85dad8e9886563f6 = (0, $6dwgv.composeLayouts)((0, $8FCAy.classicSoftwareProjectLayout), (0, $cEBDW.coreProjectLayout), (0, $aQoXd.serviceProjectLayout), (0, $8FCAy.softwareProjectLayout), (0, $dkgBy.userBoardLayout));

});
parcelRegister("cEBDW", function(module, exports) {
$parcel$export(module.exports, "coreProjectLayout", () => $208365a70ac26c02$export$3c06ced9943ca671);

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");
const $208365a70ac26c02$export$3c06ced9943ca671 = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout));

});
parcelRegister("jbfEb", function(module, exports) {
$parcel$export(module.exports, "projectLayout", () => $ca707d874a48fc97$export$204149bac601d20c);

var $h6Od4 = parcelRequire("h6Od4");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ca707d874a48fc97$var$withAnyProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ca707d874a48fc97$var$ProjectTrackers = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hzNDk")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $ca707d874a48fc97$var$rightSidebars = ()=>[];
const $ca707d874a48fc97$var$globalComponents = [
    $ca707d874a48fc97$var$withAnyProjectContext($ca707d874a48fc97$var$ProjectTrackers),
    $ca707d874a48fc97$var$withAnyProjectContext((0, $h6Od4.ProjectRouteListener))
];
const $ca707d874a48fc97$export$204149bac601d20c = (0, $6dwgv.createLayout)({
    globalComponents: $ca707d874a48fc97$var$globalComponents,
    rightSidebars: $ca707d874a48fc97$var$rightSidebars()
});

});
parcelRegister("h6Od4", function(module, exports) {
$parcel$export(module.exports, "ProjectRouteListener", () => $759f7c84282a636f$export$159f09d701320911);

var $eJOHy = parcelRequire("eJOHy");

var $dZRaT = parcelRequire("dZRaT");

var $kAwwe = parcelRequire("kAwwe");

var $eJrcF = parcelRequire("eJrcF");

var $7A5g5 = parcelRequire("7A5g5");
const $759f7c84282a636f$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $kAwwe.useIsAdmin)();
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    (0, $eJOHy.useEffect)(()=>{
        if (isSiteAdmin) (0, $7A5g5.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $7A5g5.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $7A5g5.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $eJOHy.useEffect)(()=>()=>(0, $7A5g5.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});
parcelRegister("7A5g5", function(module, exports) {
$parcel$export(module.exports, "getIsProjectAdmin", () => $f0c7b3bdfa17e57f$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $f0c7b3bdfa17e57f$export$d53e6d79d3fa5f31);
let $f0c7b3bdfa17e57f$var$projectAdmin = null;
const $f0c7b3bdfa17e57f$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($f0c7b3bdfa17e57f$var$projectAdmin == null || !$f0c7b3bdfa17e57f$var$projectAdmin.loading && $f0c7b3bdfa17e57f$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($f0c7b3bdfa17e57f$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($f0c7b3bdfa17e57f$var$projectAdmin.isProjectAdmin);
};
const $f0c7b3bdfa17e57f$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $f0c7b3bdfa17e57f$var$projectAdmin = projectAdminState;
};

});


parcelRegister("hzNDk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gOuNw").then(()=>parcelRequire('lu6uO'));

});



parcelRegister("aQoXd", function(module, exports) {
$parcel$export(module.exports, "serviceProjectLayout", () => $1fa61a55f28068ec$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $1fa61a55f28068ec$export$820f9bb834280408);

var $FhXEJ = parcelRequire("FhXEJ");

var $7h3uc = parcelRequire("7h3uc");

var $f61QS = parcelRequire("f61QS");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $bwUbt = parcelRequire("bwUbt");

var $bQWwW = parcelRequire("bQWwW");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1fa61a55f28068ec$var$withServiceProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $FhXEJ.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$ProjectBuilder = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aBN5p")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("89aDa")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hvgnR")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $1fa61a55f28068ec$export$e321cb31c875d1ba = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {
    globalComponents: [
        $1fa61a55f28068ec$var$withServiceProjectContext($1fa61a55f28068ec$var$Onboarding),
        ...(0, $bwUbt.serviceProjectFirstImpressionsLayout).globalComponents.map($1fa61a55f28068ec$var$withServiceProjectContext),
        $1fa61a55f28068ec$var$withServiceProjectContext((0, $f61QS.AsyncJsmCustomDomainChangeBoardingFlag)),
        $1fa61a55f28068ec$var$ProjectBuilder
    ],
    rightSidebars: [
        $1fa61a55f28068ec$var$withServiceProjectContext($1fa61a55f28068ec$var$RightSidebars),
        ...(0, $bwUbt.serviceProjectFirstImpressionsLayout).rightSidebars.map($1fa61a55f28068ec$var$withServiceProjectContext)
    ]
});
const $1fa61a55f28068ec$export$820f9bb834280408 = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), {
    rightSidebars: [
        $1fa61a55f28068ec$var$RightSidebars
    ]
});

});
parcelRegister("7h3uc", function(module, exports) {
$parcel$export(module.exports, "globalLayout", () => $9f25df309d0ec2b8$export$929cb72e7acb7fd9);

var $6dwgv = parcelRequire("6dwgv");
const $9f25df309d0ec2b8$var$rightSidebars = ()=>[];
const $9f25df309d0ec2b8$export$929cb72e7acb7fd9 = (0, $6dwgv.createLayout)({
    rightSidebars: $9f25df309d0ec2b8$var$rightSidebars()
});

});

parcelRegister("f61QS", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $1961db39384c0e0d$export$b1ef5e3da6e1959d);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $1961db39384c0e0d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hOgCp")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $1961db39384c0e0d$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1961db39384c0e0d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("hOgCp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jRam1").then(()=>parcelRequire('lKRQ7'));

});


parcelRegister("bwUbt", function(module, exports) {
$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $b899726b5c2e771b$export$2562b2d784eadc10);

var $eJOHy = parcelRequire("eJOHy");

var $jmQek = parcelRequire("jmQek");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");
const $b899726b5c2e771b$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmQek.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null));
    const name = (0, $6dwgv.coalesce)(Component.displayName) ?? (0, $6dwgv.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b899726b5c2e771b$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aKdgA")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b899726b5c2e771b$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("kxU5R")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $b899726b5c2e771b$export$2562b2d784eadc10 = (0, $6dwgv.createLayout)({
    globalComponents: [
        $b899726b5c2e771b$var$withServiceProjectAccess($b899726b5c2e771b$var$Onboarding)
    ],
    rightSidebars: [
        $b899726b5c2e771b$var$withServiceProjectAccess($b899726b5c2e771b$var$RightSidebars)
    ]
});

});
parcelRegister("jmQek", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7838320445e919b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");

var $5aeix = parcelRequire("5aeix");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $e7838320445e919b$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $5aeix.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    }
    return null;
};
$e7838320445e919b$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $e7838320445e919b$export$2e2bcd8739ae039 = $e7838320445e919b$var$AppPermissionsCheck;

});
parcelRegister("5aeix", function(module, exports) {
$parcel$export(module.exports, "isDevelopmentEnv", () => $b42edb9e31c9a622$export$48e5fb80244b95c5);
const $b42edb9e31c9a622$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("aKdgA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("jD0ep")
]).then(()=>parcelRequire('R6Cjs'));

});

parcelRegister("kxU5R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("7rAm2")
]).then(()=>parcelRequire('dHOBZ'));

});


parcelRegister("aBN5p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("9qY9x")
]).then(()=>parcelRequire('dQKu6'));

});

parcelRegister("89aDa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("dHHIn")
]).then(()=>parcelRequire('dln7i'));

});

parcelRegister("hvgnR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("azviO")
]).then(()=>parcelRequire('byH1L'));

});


parcelRegister("8FCAy", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $2e2774c38c3e21fa$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $2e2774c38c3e21fa$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $2e2774c38c3e21fa$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $2e2774c38c3e21fa$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $2e2774c38c3e21fa$export$ab7e607e8441dc61);

var $FhXEJ = parcelRequire("FhXEJ");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2e2774c38c3e21fa$var$withAnySoftwareProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $FhXEJ.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("8R8if")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});
$2e2774c38c3e21fa$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$OnboardingCode = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("kLVya")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aw5Vg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
$2e2774c38c3e21fa$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebarsCode = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aaPbu")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $2e2774c38c3e21fa$var$SoftWareOnboarding = $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$Onboarding);
const $2e2774c38c3e21fa$var$SoftWareOnboardingCode = $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$OnboardingCode);
const $2e2774c38c3e21fa$var$nonSettingsRightSidebars = [
    $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$RightSidebars)
];
const $2e2774c38c3e21fa$var$nonSettingsRightSidebarsCode = [
    $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$RightSidebarsCode)
];
const $2e2774c38c3e21fa$var$sharedSoftwareProjectLayout = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {});
const $2e2774c38c3e21fa$export$3791efdd32024063 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebars,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboarding
    ]
});
const $2e2774c38c3e21fa$export$9a918616afa3328c = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebars,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboarding
    ]
});
const $2e2774c38c3e21fa$export$ada52b1309832862 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout);
const $2e2774c38c3e21fa$export$6c1958653c44ba37 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout);
const $2e2774c38c3e21fa$export$ab7e607e8441dc61 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("8R8if", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("22QMa")
]).then(()=>parcelRequire('jhc67'));

});

parcelRegister("kLVya", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("k3KUo")
]).then(()=>parcelRequire('fpUIa'));

});

parcelRegister("aw5Vg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("bRZBc")
]).then(()=>parcelRequire('4mkSU'));

});

parcelRegister("aaPbu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("bXt8b")
]).then(()=>parcelRequire('8XVCp'));

});


parcelRegister("dkgBy", function(module, exports) {
$parcel$export(module.exports, "userBoardLayout", () => $cf45c653fc1d9878$export$7092b4ee86ae0b71);

var $6dwgv = parcelRequire("6dwgv");
const $cf45c653fc1d9878$export$7092b4ee86ae0b71 = (0, $6dwgv.createLayout)();

});


parcelRegister("iIsIs", function(module, exports) {
$parcel$export(module.exports, "fullPageIssuePreloadLayout", () => $5a7a9947a97daa9e$export$98e337c40eb151da);
$parcel$export(module.exports, "embeddedIssuePreloadLayoutBuilder", () => $5a7a9947a97daa9e$export$7b113174a456921a);
$parcel$export(module.exports, "pageLoadIssuePreloadLayoutBuilder", () => $5a7a9947a97daa9e$export$682dcbf7cc80ba11);

var $6dwgv = parcelRequire("6dwgv");

var $kGR8U = parcelRequire("kGR8U");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");
var $fKdol = parcelRequire("fKdol");

var $1VofM = parcelRequire("1VofM");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$LazyIssuePage = (0, $bQWwW.lazyAfterPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)((parcelRequire("lOoQA"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$AsyncIssueAppComponent = (0, $bQWwW.lazyAfterPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)((parcelRequire("5pAUa"))), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$IssueModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kwulP")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$IssueModalContents = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("ll1lB")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-view.tsx"
});
const $5a7a9947a97daa9e$var$imports = {
    fullPage: ()=>$5a7a9947a97daa9e$var$LazyIssuePage.preload(),
    embedded: ()=>$5a7a9947a97daa9e$var$AsyncIssueAppComponent.preload(),
    pageLoad: (viewModeToPreload)=>{
        // issue view that opens as a modal
        if (viewModeToPreload === 'MODAL' || viewModeToPreload === 'DEFAULT') {
            $5a7a9947a97daa9e$var$IssueModal.preload();
            $5a7a9947a97daa9e$var$IssueModalContents.preload();
        }
        // issue view that opens as a side panel
        if (viewModeToPreload === 'SIDEBAR') $5a7a9947a97daa9e$var$AsyncIssueAppComponent.preload();
    }
};

const $5a7a9947a97daa9e$var$PrefetchCBBResourcesComponent = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aoTjy")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const importSupplier = $5a7a9947a97daa9e$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $5a7a9947a97daa9e$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $5a7a9947a97daa9e$var$useParamsSelector = (0, $kfvK2.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $5a7a9947a97daa9e$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, $fKdol.default)(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) (0, $1VofM.setServerEvaluatedIssuePreload)(identifier);
            else performance.mark($5a7a9947a97daa9e$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
const $5a7a9947a97daa9e$var$FullPageIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('fullPage', $5a7a9947a97daa9e$var$imports.fullPage);
$5a7a9947a97daa9e$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $5a7a9947a97daa9e$export$98e337c40eb151da = (0, $6dwgv.createLayout)({
    globalComponents: [
        $5a7a9947a97daa9e$var$FullPageIssuePreloadComponent,
        $5a7a9947a97daa9e$var$PrefetchCBBResourcesComponent
    ]
});
const $5a7a9947a97daa9e$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('embedded', $5a7a9947a97daa9e$var$imports.embedded, preloadContract);
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $6dwgv.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};
const $5a7a9947a97daa9e$export$682dcbf7cc80ba11 = (preloadContract, viewModeToPreload)=>{
    const PageLoadIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('pageLoad', ()=>$5a7a9947a97daa9e$var$imports.pageLoad(viewModeToPreload || 'DEFAULT'), preloadContract);
    PageLoadIssuePreloadComponent.displayName = 'PageLoadIssuePreloadComponent';
    return (0, $6dwgv.createLayout)({
        globalComponents: [
            PageLoadIssuePreloadComponent
        ]
    });
};

});
parcelRegister("1VofM", function(module, exports) {
$parcel$export(module.exports, "setServerEvaluatedIssuePreload", () => $7af7e490b4f39bb6$export$d2077b3b0eac1c19);
/* eslint-disable jira/filename-case */ // We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $7af7e490b4f39bb6$var$serverIssuePreloadIdentifier = '';
const $7af7e490b4f39bb6$export$d2077b3b0eac1c19 = (identifier)=>{
    $7af7e490b4f39bb6$var$serverIssuePreloadIdentifier = identifier;
};
const $7af7e490b4f39bb6$export$f55e6973062dc859 = ()=>$7af7e490b4f39bb6$var$serverIssuePreloadIdentifier;

});

parcelRegister("5pAUa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("fliVL"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("lDuOD")
]).then(()=>parcelRequire('kq6nk'));

});

parcelRegister("kwulP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");



module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("77kn1")
]).then(()=>parcelRequire('igA3X'));

});

parcelRegister("ll1lB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");










module.exports = Promise.all([
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kL3jN")
]).then(()=>parcelRequire('hSwWh'));

});

parcelRegister("aoTjy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ajKPE").then(()=>parcelRequire('3Eb0P'));

});


/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $aa97a50ba70be130$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $aa97a50ba70be130$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("5ddA0", function(module, exports) {
$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $83fdf796383be00f$export$4847c29b4786b3b4);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $24e7X = parcelRequire("24e7X");
const $83fdf796383be00f$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $83fdf796383be00f$export$4847c29b4786b3b4 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$83fdf796383be00f$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $83fdf796383be00f$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $24e7X.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("24e7X", function(module, exports) {
$parcel$export(module.exports, "fetchShortcuts", () => $59a57dc5b45b5a5a$export$49d696bf2525d700);

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");
const $59a57dc5b45b5a5a$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $hgi0g.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("aDtWM", function(module, exports) {
$parcel$export(module.exports, "genericProjectSidebars", () => $2441c7e576639e68$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $2441c7e576639e68$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $2441c7e576639e68$export$844d342b575ead35);

var $7zL9d = parcelRequire("7zL9d");

var $hiOwQ = parcelRequire("hiOwQ");

var $gKFn0 = parcelRequire("gKFn0");

var $2nHUF = parcelRequire("2nHUF");

var $gHEJe = parcelRequire("gHEJe");

var $1f2LE = parcelRequire("1f2LE");

var $k6duF = parcelRequire("k6duF");

var $3V6se = parcelRequire("3V6se");
const $2441c7e576639e68$export$d88d2d25355bc89a = [
    // delete when cleaning up getWillShowNav4
    (0, $hiOwQ.default),
    (0, $gHEJe.default),
    (0, $1f2LE.default),
    (0, $k6duF.default),
    (0, $3V6se.default)
];
const $2441c7e576639e68$export$c04daf123cec1f1e = [
    (0, $k6duF.default),
    (0, $3V6se.default)
];
const $2441c7e576639e68$export$844d342b575ead35 = [
    ...$2441c7e576639e68$export$d88d2d25355bc89a,
    (0, $7zL9d.default),
    (0, $gKFn0.default),
    (0, $2nHUF.default)
];

});
parcelRegister("7zL9d", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5ca43a7cc265a55$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $d5ca43a7cc265a55$var$LazyConnectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("drZbH")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
const $d5ca43a7cc265a55$var$ConnectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5ca43a7cc265a55$var$LazyConnectSidebar, null)));
$d5ca43a7cc265a55$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $d5ca43a7cc265a55$export$2e2bcd8739ae039 = $d5ca43a7cc265a55$var$ConnectSidebar;

});
parcelRegister("8Dw1w", function(module, exports) {
$parcel$export(module.exports, "SidebarBoundary", () => $b66ffc7f89ff7516$export$1edc778464f08256);

var $eJOHy = parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $2imLM = parcelRequire("2imLM");

var $4EKqI = parcelRequire("4EKqI");

var $dysGT = parcelRequire("dysGT");

var $8Q9Ns = parcelRequire("8Q9Ns");

var $gpE1B = parcelRequire("gpE1B");
const $b66ffc7f89ff7516$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $8Q9Ns.useSidebarFail)();
    const onSuccess = (0, $8Q9Ns.useSidebarSuccess)();
    const onError = (0, $eJOHy.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysGT.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "nav-sidebar-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
            isFull: true
        }))
    }, children)));
};

});
parcelRegister("hOBHo", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $f058582c63bdf80a$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $f058582c63bdf80a$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $f058582c63bdf80a$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $f058582c63bdf80a$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $f058582c63bdf80a$export$1d10ee0c85c3cb21);
const $f058582c63bdf80a$export$6635720e40ea7a7a = 'navigation.top';
const $f058582c63bdf80a$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $f058582c63bdf80a$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $f058582c63bdf80a$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $f058582c63bdf80a$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});

parcelRegister("03pp6", function(module, exports) {
$parcel$export(module.exports, "pageSegmentStore", () => $9b842795409a6159$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $9b842795409a6159$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $9b842795409a6159$export$a018e347341b3640);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $hqYEY = parcelRequire("hqYEY");

var $kQnVX = parcelRequire("kQnVX");

var $6dnL8 = parcelRequire("6dnL8");

var $hOBHo = parcelRequire("hOBHo");

const $9b842795409a6159$var$createTopNavPageSegment = ()=>(0, $hqYEY.metrics).pageSegmentLoad({
        key: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $9b842795409a6159$export$8df02628d98cae7e = {
    ADDONS: (0, $hqYEY.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $9b842795409a6159$var$createSidebarPageSegment = ()=>(0, $hqYEY.metrics).pageSegmentLoad({
        key: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $9b842795409a6159$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)]: $9b842795409a6159$var$createTopNavPageSegment,
        [(0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $9b842795409a6159$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $9b842795409a6159$export$906025848d54198d = (segmentKey = (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $eJOHy.useRef)(false);
    const segment = (0, $eJOHy.useRef)($9b842795409a6159$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $eJOHy.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $hOBHo.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))((0, $6dnL8.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $9b842795409a6159$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $9b842795409a6159$export$906025848d54198d(segmentKey);
    (0, $eJOHy.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $9b842795409a6159$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $9b842795409a6159$export$906025848d54198d(segmentKey);
    (0, $eJOHy.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $kQnVX.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $9b842795409a6159$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $9b842795409a6159$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $9b842795409a6159$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $9b842795409a6159$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("6dnL8", function(module, exports) {
$parcel$export(module.exports, "RenderTracerMark", () => $399d856a9213313b$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $399d856a9213313b$export$345f21b0287f67e5);

var $eJOHy = parcelRequire("eJOHy");

var $Xz6kS = parcelRequire("Xz6kS");

var $9Dhvc = parcelRequire("9Dhvc");

var $QRiTH = parcelRequire("QRiTH");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

const $399d856a9213313b$var$initialState = {
    start: undefined,
    traces: {}
};
let $399d856a9213313b$var$currentTraces = {};
const $399d856a9213313b$export$2365ecd8218e21c7 = ()=>$399d856a9213313b$var$currentTraces;
const $399d856a9213313b$export$5c757eaa1990d0d7 = (key)=>{
    if ($399d856a9213313b$var$currentTraces[key]) return;
    $399d856a9213313b$var$currentTraces[key] = {
        startTime: (0, $QRiTH.performance).now()
    };
};
const $399d856a9213313b$export$16854dc18f8d976 = (key)=>{
    if (!$399d856a9213313b$var$currentTraces[key] || $399d856a9213313b$var$currentTraces[key].duration != null) return;
    $399d856a9213313b$var$currentTraces[key].duration = (0, $QRiTH.performance).now() - $399d856a9213313b$var$currentTraces[key].startTime;
};
const $399d856a9213313b$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $399d856a9213313b$var$currentTraces = Object.assign($399d856a9213313b$var$currentTraces, getState().traces);
        }
};
const $399d856a9213313b$var$Store = (0, $GtRbT.createStore)({
    name: 'jira-render-tracer',
    initialState: $399d856a9213313b$var$initialState,
    actions: $399d856a9213313b$var$actions
});
const $399d856a9213313b$var$RenderTracerActions = (0, $ht3nQ.createSubscriber)($399d856a9213313b$var$Store, {
    selector: null
});
const $399d856a9213313b$export$719a95758870be58 = (0, $iJq0l.createHook)($399d856a9213313b$var$Store, {
    selector: null
});
const $399d856a9213313b$var$RenderTracerContainerBase = (0, $6E16M.createContainer)($399d856a9213313b$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $QRiTH.performance).now()
                    }
                }
            });
        }
});
const $399d856a9213313b$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $399d856a9213313b$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $QRiTH.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $QRiTH.performance).now());
        return null;
    });
const $399d856a9213313b$export$cba8addc8743389c = (appName = 'unknown', traces = $399d856a9213313b$var$currentTraces)=>({
        [(0, $6df4e20a5531d5f2$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $399d856a9213313b$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $6df4e20a5531d5f2$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("Xz6kS", function(module, exports) {

var $7Nmeo = parcelRequire("7Nmeo");

var $9Zabf = parcelRequire("9Zabf");

var $kBNXn = parcelRequire("kBNXn");

var $7H30b = parcelRequire("7H30b");

var $goEEn = parcelRequire("goEEn");

var $4c94y = parcelRequire("4c94y");
/** Used for built-in method references. */ var $0b30bd2af0ca49b8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0b30bd2af0ca49b8$var$hasOwnProperty = $0b30bd2af0ca49b8$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $0b30bd2af0ca49b8$var$assign = $kBNXn(function(object, source) {
    if ($goEEn(source) || $7H30b(source)) {
        $9Zabf(source, $4c94y(source), object);
        return;
    }
    for(var key in source)if ($0b30bd2af0ca49b8$var$hasOwnProperty.call(source, key)) $7Nmeo(object, key, source[key]);
});
module.exports = $0b30bd2af0ca49b8$var$assign;

});

parcelRegister("QRiTH", function(module, exports) {
$parcel$export(module.exports, "performance", () => $be16f2b3d59cb675$export$f2d2284f5fec51f8);
const $be16f2b3d59cb675$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $be16f2b3d59cb675$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $be16f2b3d59cb675$var$now();
    }
    now() {
        if (false) return $be16f2b3d59cb675$var$now() - this.startAt;
        return $be16f2b3d59cb675$var$now();
    }
    constructor(){
        this.startAt = $be16f2b3d59cb675$var$now();
    }
}
const $be16f2b3d59cb675$export$f2d2284f5fec51f8 = new $be16f2b3d59cb675$export$9a0dbed22cbf63be();

});

const $6df4e20a5531d5f2$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';



parcelRegister("dysGT", function(module, exports) {
$parcel$export(module.exports, "SidebarErrorBoundary", () => $c7f6dd1cac39f594$export$62853c5766dad0c4);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $kQnVX = parcelRequire("kQnVX");

var $ea4Iz = parcelRequire("ea4Iz");
const $c7f6dd1cac39f594$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $kQnVX.getUserLocation)();
    const extraEventData = (0, $eJOHy.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ea4Iz.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("ea4Iz", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $9b4051d45e6e7b1f$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $jLjxj = parcelRequire("jLjxj");

var $lRq8t = parcelRequire("lRq8t");

var $lh7Oqf = parcelRequire("lh7Oqf");

var $6aoQW = parcelRequire("6aoQW");
const $9b4051d45e6e7b1f$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rkowr30 _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $9b4051d45e6e7b1f$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lh7Oqf))),
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $6aoQW.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $6aoQW.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("code", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.error
        ])
    }, "ERROR: ", (0, $jLjxj.getErrorHash)(error)));
};

});
parcelRegister("lh7Oqf", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("6aoQW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f850c5d954b638cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f850c5d954b638cc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("8Q9Ns", function(module, exports) {
$parcel$export(module.exports, "SidebarRenderStart", () => $b1d0fa6e8dcb9f72$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b1d0fa6e8dcb9f72$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b1d0fa6e8dcb9f72$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b1d0fa6e8dcb9f72$export$ddb17534fdfb7dc6);

var $eJOHy = parcelRequire("eJOHy");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $XQ5wK = parcelRequire("XQ5wK");

var $hih5V = parcelRequire("hih5V");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $5grHY = parcelRequire("5grHY");

var $gCY1z = parcelRequire("gCY1z");

var $eES78 = parcelRequire("eES78");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b1d0fa6e8dcb9f72$var$useSidebarId } = (0, $XQ5wK.createValueController)('sidebar-id');
const $b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $eES78.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b1d0fa6e8dcb9f72$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $gCY1z.useRouter)();
    const pageId = (0, $5grHY.usePageId)();
    const startRef = (0, $eJOHy.useRef)(Date.now());
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $eES78.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $eJOHy.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b1d0fa6e8dcb9f72$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b1d0fa6e8dcb9f72$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b1d0fa6e8dcb9f72$var$useSidebarId();
    const route = (0, $hih5V.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $4ctwv.useExperienceSuccess)($b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $eJOHy.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $kRgKj.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $eJOHy.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b1d0fa6e8dcb9f72$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $eES78.SIDEBAR_EXPERIENCE)
    });
    return (0, $eJOHy.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b1d0fa6e8dcb9f72$export$ddb17534fdfb7dc6 = ()=>(0, $4ctwv.useExperienceSuccess)($b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("XQ5wK", function(module, exports) {
$parcel$export(module.exports, "createValueController", () => $a097180df6b282dc$export$ff0ab9dd4ceb4a93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $a097180df6b282dc$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $GtRbT.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $6E16M.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $iJq0l.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("eES78", function(module, exports) {
$parcel$export(module.exports, "REPO_TYPE", () => $52e041f2c33cd742$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $52e041f2c33cd742$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $52e041f2c33cd742$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $52e041f2c33cd742$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $52e041f2c33cd742$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $52e041f2c33cd742$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $52e041f2c33cd742$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $52e041f2c33cd742$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $52e041f2c33cd742$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $52e041f2c33cd742$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $52e041f2c33cd742$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $52e041f2c33cd742$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $52e041f2c33cd742$export$f57650e6e7be03dc);
const $52e041f2c33cd742$export$399c7e6858236b4 = 'source.code.link';
const $52e041f2c33cd742$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $52e041f2c33cd742$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $52e041f2c33cd742$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $52e041f2c33cd742$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $52e041f2c33cd742$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $52e041f2c33cd742$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $52e041f2c33cd742$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $52e041f2c33cd742$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $52e041f2c33cd742$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $52e041f2c33cd742$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $52e041f2c33cd742$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $52e041f2c33cd742$export$dde074e512e80dff = 'global-create-spotlight';
const $52e041f2c33cd742$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $52e041f2c33cd742$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $52e041f2c33cd742$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
];

});


parcelRegister("gpE1B", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $65e95951f2fce7be$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");
const $65e95951f2fce7be$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65e95951f2fce7be$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65e95951f2fce7be$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $65e95951f2fce7be$var$BackgroundedWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tem _ca0qidpf _u5f31ejb _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $65e95951f2fce7be$var$HeadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1f4h _u5f3idpf _n3tdpxbi _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("diNYL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c44efaa9252dc1d8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YEko = parcelRequire("6YEko");

var $2eOKX = parcelRequire("2eOKX");
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c44efaa9252dc1d8$var$Section = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $c44efaa9252dc1d8$export$2e2bcd8739ae039 = $c44efaa9252dc1d8$var$Section;

});

parcelRegister("6seod", function(module, exports) {
$parcel$export(module.exports, "default", () => $982e2949d673f589$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2bMVP = parcelRequire("2bMVP");

var $2eOKX = parcelRequire("2eOKX");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $982e2949d673f589$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {
        isSideNavSkeleton: true,
        ...props
    });
};
var $982e2949d673f589$export$2e2bcd8739ae039 = $982e2949d673f589$var$SkeletonItem;

});



parcelRegister("7DXwW", function(module, exports) {
$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $2ebdd972899a51f4$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $2ebdd972899a51f4$export$edbd543f308bbef5);

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");
const $2ebdd972899a51f4$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $03pp6.pageSegmentStore).getSegment((0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $2ebdd972899a51f4$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $03pp6.pageSegmentStore).getSegment((0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("drZbH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dPMOS").then(()=>parcelRequire('9zsf7'));

});


parcelRegister("hiOwQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c48a3c7fb40f9811$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $c48a3c7fb40f9811$var$LazyCoreProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("bUOXs")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
// delete when cleaning up getWillShowNav4
const $c48a3c7fb40f9811$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c48a3c7fb40f9811$var$LazyCoreProjectSidebar, null));
var $c48a3c7fb40f9811$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($c48a3c7fb40f9811$var$CoreProjectSidebar);

});
parcelRegister("bUOXs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("knnJv")
]).then(()=>parcelRequire('2ZlQu'));

});


parcelRegister("gKFn0", function(module, exports) {
$parcel$export(module.exports, "default", () => $09413d0f48517527$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $09413d0f48517527$var$LazyGlobalAppsSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("hbC0m")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
const $09413d0f48517527$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09413d0f48517527$var$LazyGlobalAppsSettingsSidebar, null)));
$09413d0f48517527$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $09413d0f48517527$export$2e2bcd8739ae039 = $09413d0f48517527$var$GlobalAppsSettingsSidebar;

});
parcelRegister("hbC0m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ju8d5")
]).then(()=>parcelRequire('a6XIl'));

});


parcelRegister("2nHUF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c03066d31b31d1d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $7c03066d31b31d1d$var$LazyGlobalSystemSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("lQtJb")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
const $7c03066d31b31d1d$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c03066d31b31d1d$var$LazyGlobalSystemSettingsSidebar, null)));
$7c03066d31b31d1d$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $7c03066d31b31d1d$export$2e2bcd8739ae039 = $7c03066d31b31d1d$var$GlobalSystemSettingsSidebar;

});
parcelRegister("lQtJb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ilGII")
]).then(()=>parcelRequire('cuk8p'));

});


parcelRegister("gHEJe", function(module, exports) {
$parcel$export(module.exports, "ForPaintSoftwareProjectSidebar", () => $7ef94f935654f247$export$16261c6a2217f29d);
$parcel$export(module.exports, "default", () => $7ef94f935654f247$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

const $7ef94f935654f247$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("1t7yC")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});

const $7ef94f935654f247$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("1t7yC")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
const $7ef94f935654f247$var$AfterPaintSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $7ef94f935654f247$export$16261c6a2217f29d = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $7ef94f935654f247$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isIssueRoute = (0, $kfvK2.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$export$16261c6a2217f29d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$AfterPaintSoftwareProjectSidebar, null);
});
$7ef94f935654f247$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
$7ef94f935654f247$export$16261c6a2217f29d.displayName = 'SoftwareProjectSidebar';
var $7ef94f935654f247$export$2e2bcd8739ae039 = $7ef94f935654f247$var$SoftwareProjectSidebar;

});
parcelRegister("1t7yC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4yp4h")
]).then(()=>parcelRequire('9WRBf'));

});


parcelRegister("1f2LE", function(module, exports) {
$parcel$export(module.exports, "ForPaintServicedeskSidebar", () => $34d9b7a65dd1d6b8$export$c72ea37d21335def);
$parcel$export(module.exports, "default", () => $34d9b7a65dd1d6b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

var $4cTDP = parcelRequire("4cTDP");

var $i67QL = parcelRequire("i67QL");
const $34d9b7a65dd1d6b8$var$routesUsingLazyForPaint = new Set([
    'servicedesk-queues-custom-view',
    'servicedesk-practice-custom-view',
    'issue'
]);

const $34d9b7a65dd1d6b8$export$4553575c70a669bf = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("butUa")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $34d9b7a65dd1d6b8$var$AfterPaintServicedeskSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$export$4553575c70a669bf, null)));
const $34d9b7a65dd1d6b8$export$c72ea37d21335def = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i67QL.LazyForPaintServicedeskSidebar), null)));
const $34d9b7a65dd1d6b8$var$ServicedeskSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isLazyForPaintRoute = (0, $kfvK2.useIsActiveRoute)((0, $4cTDP.fg)('queues_sidebar_lazyafterpaint_to_lazyforpaint') ? $34d9b7a65dd1d6b8$var$routesUsingLazyForPaint : 'issue');
    return isLazyForPaintRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$export$c72ea37d21335def, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$var$AfterPaintServicedeskSidebar, null);
});
$34d9b7a65dd1d6b8$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
$34d9b7a65dd1d6b8$export$c72ea37d21335def.displayName = 'ServicedeskSidebar';
var $34d9b7a65dd1d6b8$export$2e2bcd8739ae039 = $34d9b7a65dd1d6b8$var$ServicedeskSidebar;

});
parcelRegister("i67QL", function(module, exports) {
$parcel$export(module.exports, "LazyForPaintServicedeskSidebar", () => $d27c58e19a795fc8$export$15e3805736f2222d);

var $bQWwW = parcelRequire("bQWwW");

var $7DXwW = parcelRequire("7DXwW");

const $d27c58e19a795fc8$export$15e3805736f2222d = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("butUa")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});

});
parcelRegister("butUa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("f861S")
]).then(()=>parcelRequire('eQ0q2'));

});



parcelRegister("k6duF", function(module, exports) {
$parcel$export(module.exports, "ForPaintClassicSoftwareProjectSidebar", () => $919301427081454d$export$a70fda37b3fc5365);
$parcel$export(module.exports, "default", () => $919301427081454d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

const $919301427081454d$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("3Eaha")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});

const $919301427081454d$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("3Eaha")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
const $919301427081454d$var$AfterPaintClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $919301427081454d$export$a70fda37b3fc5365 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $919301427081454d$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isIssueRoute = (0, $kfvK2.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$export$a70fda37b3fc5365, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$AfterPaintClassicSoftwareProjectSidebar, null);
});
$919301427081454d$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
$919301427081454d$export$a70fda37b3fc5365.displayName = 'ClassicSoftwareProjectSidebar';
var $919301427081454d$export$2e2bcd8739ae039 = $919301427081454d$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("3Eaha", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("1WCUI")
]).then(()=>parcelRequire('h8X2Q'));

});


parcelRegister("3V6se", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3a532df6c151ee1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $a3a532df6c151ee1$var$LazyUserSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("iZKOz")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
const $a3a532df6c151ee1$var$UserSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3a532df6c151ee1$var$LazyUserSidebar, null)));
$a3a532df6c151ee1$var$UserSidebar.displayName = 'UserSidebar';
var $a3a532df6c151ee1$export$2e2bcd8739ae039 = $a3a532df6c151ee1$var$UserSidebar;

});
parcelRegister("iZKOz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("8aAWx")
]).then(()=>parcelRequire('2uIzr'));

});



parcelRegister("5N1SB", function(module, exports) {
$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $5c6a39299c71dc02$export$d08a9fee651d30b2);

var $l1VxS = parcelRequire("l1VxS");


const $5c6a39299c71dc02$var$getDataLoader = ()=>(parcelRequire("7NR9p"));
const $5c6a39299c71dc02$export$ec991c565cf31550 = (0, $l1VxS.createResource)({
    type: (0, $b9e6117892e37693$export$23978b67a6b2068f),
    getKey: ()=>'state',
    getDataLoader: $5c6a39299c71dc02$var$getDataLoader,
    maxAge: 1800000
});
const $5c6a39299c71dc02$export$d08a9fee651d30b2 = ()=>[];

});
const $b9e6117892e37693$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

parcelRegister("7NR9p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lRIym").then(()=>parcelRequire('AFoLQ'));

});


parcelRegister("aGQ56", function(module, exports) {
$parcel$export(module.exports, "queuesNavigationItems", () => $afd2eec712bd1e40$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $afd2eec712bd1e40$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $afd2eec712bd1e40$export$b55fde45b61f13f4);
$parcel$export(module.exports, "priorityGroupCrossProjectResource", () => $afd2eec712bd1e40$export$ce17a222de842d7c);
$parcel$export(module.exports, "issueListSsrResource", () => $afd2eec712bd1e40$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueSidebarViewAllQueuesResource", () => $afd2eec712bd1e40$export$5b6f88b653545aa1);
$parcel$export(module.exports, "queueNav4SidebarSelectionResource", () => $afd2eec712bd1e40$export$dead630ba04fdfe4);
$parcel$export(module.exports, "queueSidebarQueuesCategoryStateResource", () => $afd2eec712bd1e40$export$9e9033d678058efa);
$parcel$export(module.exports, "triageButtonPermissionResource", () => $afd2eec712bd1e40$export$11d6dc3c9b9c69ec);

var $9Dhvc = parcelRequire("9Dhvc");

var $9pTd3 = parcelRequire("9pTd3");


var $5j85B = parcelRequire("5j85B");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $FppkK = parcelRequire("FppkK");

var $4cTDP = parcelRequire("4cTDP");

var $l9f4K = parcelRequire("l9f4K");

var $dhGgY = parcelRequire("dhGgY");

var $6zqFp = parcelRequire("6zqFp");

const $afd2eec712bd1e40$var$getDataLoader = ()=>(parcelRequire("lfDzB"));

const $afd2eec712bd1e40$var$getPriorityGroupDataLoader = ()=>(parcelRequire("fTcCJ"));

const $afd2eec712bd1e40$var$fetchIssueListDataLoader = ()=>(parcelRequire("7dZQL"));
const $afd2eec712bd1e40$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.queueId', '')}`;
const $afd2eec712bd1e40$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0]}`;
const $afd2eec712bd1e40$export$4fed8be571897bef = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getDataLoader: $afd2eec712bd1e40$var$getDataLoader,
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$1f9ab301771fe42e = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getDataLoader: $afd2eec712bd1e40$var$getPriorityGroupDataLoader,
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $afd2eec712bd1e40$var$priorityGroupCrossProjectResourcePayload = {
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const projectKey = (0, $bBtQo.getProjectKeyId)(match, query).projectKey;
        try {
            const projectId = match.params.projectId ? +match.params.projectId : undefined;
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'priorityGroupCrossProjectNoProjectId',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    depends: []
};
const $afd2eec712bd1e40$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdStart',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (!projectKey) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectKey',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        if (!cloudId) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoCloudId',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        if ((0, $4cTDP.fg)('switch-queue-groups-read-to-jira')) return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        let data;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data = await (0, $5j85B.consumeDependency)(dependencies, (0, $c8eeacd6960f72dc$export$80a60a092d9ab81));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'priorityGroupByProjectIdProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (!data) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectContextData',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const projectId = data?.projectId;
        if (!projectId) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectContextProjectId',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        try {
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'priorityGroupByProjectIdGettingPriorityGroupsDataError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    depends: [
        (0, $c8eeacd6960f72dc$export$80a60a092d9ab81)
    ]
};
const $afd2eec712bd1e40$export$b55fde45b61f13f4 = (0, $l1VxS.createResource)($afd2eec712bd1e40$var$priorityGroupByProjectIdResourcePayload);
const $afd2eec712bd1e40$export$ce17a222de842d7c = (0, $l1VxS.createResource)({
    ...$afd2eec712bd1e40$var$priorityGroupCrossProjectResourcePayload,
    isBrowserOnly: true
});
const $afd2eec712bd1e40$export$3d03cbaac8581e65 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $afd2eec712bd1e40$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $afd2eec712bd1e40$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $afd2eec712bd1e40$export$5b6f88b653545aa1 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $afd2eec712bd1e40$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$dead630ba04fdfe4 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, (0, $l9f4K.LOCAL_STORAGE_KEY_NAV_LOCATION));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'fetchQueueNav4SidebarSelectionResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$9e9033d678058efa = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, (0, $l9f4K.LOCAL_STORAGE_KEY_CATEGORY));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'fetchJsmQueueSidebarQueuesCategoryStateResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$11d6dc3c9b9c69ec = (0, $l1VxS.createResource)({
    type: (0, $6zqFp.RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION),
    getKey: ()=>(0, $6zqFp.RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION),
    getData: async ()=>{
        return (0, $6zqFp.getTriageButtonPermission)();
    },
    maxAge: (0, $l9f4K.ONE_HOUR_IN_MILLIS)
});

});
parcelRegister("l9f4K", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $3365e8184adaa319$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $3365e8184adaa319$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $3365e8184adaa319$export$2733615da5b906f0);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE", () => $3365e8184adaa319$export$f510a6e9fec0630a);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $3365e8184adaa319$export$94bda82b7db2173c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION", () => $3365e8184adaa319$export$7e07da72de89b61c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY", () => $3365e8184adaa319$export$5b3a0c7c3b3456f);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $3365e8184adaa319$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $3365e8184adaa319$export$9b99689db482a6bb);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $3365e8184adaa319$export$5a00268156ea5027);
$parcel$export(module.exports, "ONE_HOUR_IN_MILLIS", () => $3365e8184adaa319$export$86e172ab3db1a556);
const $3365e8184adaa319$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $3365e8184adaa319$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $3365e8184adaa319$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $3365e8184adaa319$export$f510a6e9fec0630a = 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';
const $3365e8184adaa319$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $3365e8184adaa319$export$7e07da72de89b61c = 'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';
const $3365e8184adaa319$export$5b3a0c7c3b3456f = 'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';
const $3365e8184adaa319$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $3365e8184adaa319$export$9b99689db482a6bb = 'queues-category-state';
const $3365e8184adaa319$export$5a00268156ea5027 = 86400000;
const $3365e8184adaa319$export$86e172ab3db1a556 = 3600000;

});

parcelRegister("dhGgY", function(module, exports) {
$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $3c68df8ab7c5fa41$export$cf2bd2ec601ed920);

var $llUmI = parcelRequire("llUmI");

var $6Abnv = parcelRequire("6Abnv");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $4cTDP = parcelRequire("4cTDP");
const $3c68df8ab7c5fa41$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $hgi0g.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}&operation=fetchPriorityGroups`);
};
const $3c68df8ab7c5fa41$var$fetchGroupByKeyViaJira = async (projectKey, projectId)=>{
    const queryParams = projectId ? `projectId=${projectId}` : `projectKey=${projectKey}`;
    return (0, $hgi0g.default)(`/rest/servicedesk/latest/servicedesk/queue-group/groups?${queryParams}&operation=fetchPriorityGroups`);
};
const $3c68df8ab7c5fa41$var$fetchGroupsByIdGraphql = async (projectId, cloudId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const result = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $llUmI.default), {
        projectAri: projectAri
    }).toPromise();
    if (!result?.queuesprioritygroups_priorityGroups?.results) (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'priorityGroupByProjectIdNoPriorityGroupsGraphql',
            packageName: 'jiraRouterResourcesServiceDeskQueues',
            teamName: 'jsm-flash'
        },
        sendToPrivacyUnsafeSplunk: true
    });
    return {
        results: result?.queuesprioritygroups_priorityGroups?.results?.reduce((priorityGroups, priorityGroup)=>{
            // this mapping function is to make types happy
            if (priorityGroup && priorityGroup.id && priorityGroup.name && priorityGroup.category && priorityGroup.queueIds) priorityGroups.push({
                id: priorityGroup.id,
                name: priorityGroup.name,
                category: priorityGroup.category,
                queueIds: priorityGroup.queueIds.reduce((queueIds, queueId)=>{
                    if (queueId !== null && queueId !== undefined) queueIds.push(queueId);
                    return queueIds;
                // we need the below, otherwise reduce things the type is never[]
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                }, []),
                ...priorityGroup.version ? {
                    version: priorityGroup.version
                } : {},
                ...priorityGroup.creationMethod ? {
                    creationMethod: priorityGroup.creationMethod
                } : {}
            });
            return priorityGroups;
        }, // we need the below, otherwise reduce things the type is never[]
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []) ?? []
    };
};
const $3c68df8ab7c5fa41$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    let data;
    if ((0, $4cTDP.fg)('switch-queue-groups-read-to-jira')) data = await $3c68df8ab7c5fa41$var$fetchGroupByKeyViaJira(projectKey, projectId);
    else if (projectId) data = await $3c68df8ab7c5fa41$var$fetchGroupsByIdGraphql(projectId, cloudId);
    else {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $3c68df8ab7c5fa41$var$fetchGroupsByKey(projectKey, cloudId);
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("llUmI", function(module, exports) {
$parcel$export(module.exports, "default", () => $49a175edfdfe7540$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<509a54dc797b22dc5439dcc947ec5646>>
 * @relayHash aa856b961b835b1f9323042c281fa03b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530
const $49a175edfdfe7540$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectId",
                    "variableName": "projectAri"
                }
            ],
            "concreteType": "QueuesPriorityGroupsResults",
            "kind": "LinkedField",
            "name": "queuesprioritygroups_priorityGroups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "QueuesPriorityGroupsResultsGroup",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "queueIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationMethod"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530",
            "metadata": {},
            "name": "getPriorityGroupDataByProjectIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$49a175edfdfe7540$var$node.hash = "e99dcef5a507344c549819dcfbf09d31";
var $49a175edfdfe7540$export$2e2bcd8739ae039 = $49a175edfdfe7540$var$node;

});

parcelRegister("6Abnv", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/** Used for built-in method references. */ var $4caeee4f6c048b0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caeee4f6c048b0e$var$hasOwnProperty = $4caeee4f6c048b0e$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $4caeee4f6c048b0e$var$groupBy = $a9KaZ(function(result, value, key) {
    if ($4caeee4f6c048b0e$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $iBJlb(result, key, [
        value
    ]);
});
module.exports = $4caeee4f6c048b0e$var$groupBy;

});


parcelRegister("6zqFp", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION", () => $04c4f19ce515c68b$export$e79aee80d521b352);
$parcel$export(module.exports, "getTriageButtonPermission", () => $04c4f19ce515c68b$export$6a9c765d370d71c8);

var $3ugTQ = parcelRequire("3ugTQ");

var $dMM78 = parcelRequire("dMM78");

var $9pTd3 = parcelRequire("9pTd3");
const $04c4f19ce515c68b$export$e79aee80d521b352 = 'triage-button-permission';
const $04c4f19ce515c68b$export$6a9c765d370d71c8 = async ()=>{
    const permissionsUrl = '/rest/api/3/mypermissions?permissions=MOVE_ISSUES%2CEDIT_ISSUES%2CBULK_CHANGE';
    const aiStatusUrl = '/rest/latest/aiconfig/optin/jira-servicedesk';
    try {
        const [permissions, aiStatus] = await Promise.all([
            (0, $3ugTQ.performGetRequest)(permissionsUrl),
            (0, $3ugTQ.performGetRequest)(aiStatusUrl)
        ]);
        return {
            hasPermission: permissions.permissions.MOVE_ISSUES?.havePermission && permissions.permissions.EDIT_ISSUES?.havePermission && permissions.permissions.BULK_CHANGE?.havePermission,
            hasAiEnabled: aiStatus.isEnabled
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $dMM78.isHttpClientErrorResponse)(error)) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'fetchTriageButtonPermissionError',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        // Return default values on error
        return {
            hasPermission: false,
            hasAiEnabled: false
        };
    }
};

});

parcelRegister("lfDzB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("gGEaT")
]).then(()=>parcelRequire('fIAjW'));

});

parcelRegister("fTcCJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aQC4s").then(()=>parcelRequire('9Uve2'));

});

parcelRegister("7dZQL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dgQcw").then(()=>parcelRequire('22Hs1'));

});


parcelRegister("esUDP", function(module, exports) {
$parcel$export(module.exports, "jsmProjectMenuContentSidebarResource", () => $5c2c15eb6f3db6bb$export$c7d29d5f00e667f5);

var $9FYIg = parcelRequire("9FYIg");

var $bBtQo = parcelRequire("bBtQo");

var $73XfD = parcelRequire("73XfD");

var $hBje1 = parcelRequire("hBje1");
const $5c2c15eb6f3db6bb$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    let { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $73XfD.default),
        variables: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
};
const $5c2c15eb6f3db6bb$export$c7d29d5f00e667f5 = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'JSM_PROJECT_MENU_CONTENT_SIDEBAR_QUERY',
    getQuery: $5c2c15eb6f3db6bb$export$71eec30d9db46a56
}));

});
parcelRegister("73XfD", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8c7cb456a86a586$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32df6e83baaf72977e3e095da2daeeef>>
 * @relayHash d32c91de1a0c938d346ccddd080ca54d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 558440f5dc1d01ea96ee5362ed3db743ce602559ebd97a47035ce2ee9f71acde
const $a8c7cb456a86a586$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
        "kind": "LinkedField",
        "name": "hiddenMenuItems",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProjectLevelSidebarMenuItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "itemId"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jira_projectLevelSidebarMenuCustomization",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ 
                            ],
                            "type": "JiraProjectLevelSidebarMenuCustomization"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jira_projectLevelSidebarMenuCustomization",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ],
                            "type": "JiraProjectLevelSidebarMenuCustomization"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "558440f5dc1d01ea96ee5362ed3db743ce602559ebd97a47035ce2ee9f71acde",
            "metadata": {},
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a8c7cb456a86a586$var$node.hash = "0ce17ff55164386bf24d619856f960f5";
var $a8c7cb456a86a586$export$2e2bcd8739ae039 = $a8c7cb456a86a586$var$node;

});

parcelRegister("hBje1", function(module, exports) {
$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $0507489b8f939505$export$f4b29e78f4c0a526);
const $0507489b8f939505$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});


parcelRegister("iBSnt", function(module, exports) {
$parcel$export(module.exports, "browseIssueRoute", () => $c940aca0110ccf9d$export$2c9c7e50a88e588b);
const $c940aca0110ccf9d$export$2c9c7e50a88e588b = {
    name: 'issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ]
};

});

parcelRegister("g8uYY", function(module, exports) {
$parcel$export(module.exports, "createChromelessEntryPoint", () => $d4128f4ca41a15cd$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $d4128f4ca41a15cd$export$955a7619d2679b4c);

var $8xgJ5 = parcelRequire("8xgJ5");

var $4X53L = parcelRequire("4X53L");


var $6zXPf = parcelRequire("6zXPf");

var $4cTDP = parcelRequire("4cTDP");
const $d4128f4ca41a15cd$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $ce4cfb37df77ff19$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $d4128f4ca41a15cd$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    ...(0, $4cTDP.fg)('jpx-463-spa-relay-query') ? {
                        [(0, $ce4cfb37df77ff19$export$22ce74854c620e75)]: {
                            entryPoint: (0, $4X53L.spaEntryPoint),
                            entryPointParams: entryPointParams
                        }
                    } : undefined,
                    [(0, $ce4cfb37df77ff19$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $ce4cfb37df77ff19$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $8xgJ5.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.leftSidebar ? {
                        [(0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $d4128f4ca41a15cd$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false,
                                isOverviewsExpanded: page.leftSidebar.isOverviewsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.horizontalNavigation && (0, $6zXPf.getWillShowNav4)() ? {
                        [(0, $ce4cfb37df77ff19$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $ce4cfb37df77ff19$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined,
                    ...page.redirect && (0, $4cTDP.fg)('redirect_all_new_jira_users_to_user_segmentation') ? {
                        [(0, $ce4cfb37df77ff19$export$5ef29550cd5a8266)]: {
                            entryPoint: page.redirect,
                            entryPointParams: entryPointParams
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $d4128f4ca41a15cd$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
parcelRegister("8xgJ5", function(module, exports) {
$parcel$export(module.exports, "topNavigationEntryPoint", () => $bd208b44eaab6db9$export$f780be9e138f456f);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $bd208b44eaab6db9$export$f780be9e138f456f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("96SSt"))).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation), {
        moduleId: "1f1265b4",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});

parcelRegister("4X53L", function(module, exports) {
$parcel$export(module.exports, "spaEntryPoint", () => $862949b0ffd12cba$export$e280f2842b7ca512);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $63hLx = parcelRequire("63hLx");

const $862949b0ffd12cba$export$e280f2842b7ca512 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("1bE4f"))).then(({ JiraSpaPageContainerEntry: JiraSpaPageContainerEntry })=>JiraSpaPageContainerEntry), {
        moduleId: "5dbbd9e1",
        moduleName: "JiraSpaPageContainer",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (props)=>({
            queries: {
                queryReference: {
                    parameters: (0, $63hLx.default),
                    variables: {
                        cloudId: props?.tenantContext?.cloudId
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        })
});

});


parcelRegister("gg7cq", function(module, exports) {
$parcel$export(module.exports, "issueViewEntryPoint", () => $1de729576f8b4bee$export$c9f081604fc01386);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $1de729576f8b4bee$export$c9f081604fc01386 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("exCPM")), {
        moduleId: "babc18a5",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("exCPM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("kNFvF"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("kmTsB")
]).then(()=>parcelRequire('c3cIq'));

});



parcelRegister("ihfrS", function(module, exports) {
$parcel$export(module.exports, "legacyRedirectRouteEntry", () => $e033d289cffb5bf4$export$27f123cb9320355);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $bSgdP = parcelRequire("bSgdP");

var $7Z2hn = parcelRequire("7Z2hn");
// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const $e033d289cffb5bf4$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z2hn.default), null);
const $e033d289cffb5bf4$export$27f123cb9320355 = (0, $6xToB.createEntry)((0, $bSgdP.legacyRedirectRoute), ()=>({
        component: $e033d289cffb5bf4$var$RedirectComponent,
        layout: (0, $7h3uc.globalLayout),
        resources: [],
        isRedirect: true,
        canTransitionIn: ()=>false,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-legacy-redirect-entries/src/legacyRedirectRouteEntry.tsx',
                whichExportToUse: 'legacyRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bSgdP", function(module, exports) {
$parcel$export(module.exports, "legacyRedirectRoute", () => $7bcdedfe9f3abeaa$export$176ff76c3ba7c4ce);
const $7bcdedfe9f3abeaa$export$176ff76c3ba7c4ce = {
    path: '',
    name: 'legacy-redirect',
    exact: false
};

});

parcelRegister("7Z2hn", function(module, exports) {
$parcel$export(module.exports, "default", () => $058bd651131efa09$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $2fNLP = parcelRequire("2fNLP");

var $eSnSE = parcelRequire("eSnSE");

var $jchga = parcelRequire("jchga");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");

var $jJaSe = parcelRequire("jJaSe");

var $8tIrO = parcelRequire("8tIrO");

var $4cTDP = parcelRequire("4cTDP");

var $6JCFc = parcelRequire("6JCFc");
const $058bd651131efa09$var$THRESHOLD = 30000;
const $058bd651131efa09$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
const $058bd651131efa09$var$sessionStorageProvider = (0, $8tIrO.createSessionStorageProvider)('', false);
class $058bd651131efa09$export$836fe1ef2cfde075 extends (0, $eJOHy.Component) {
    componentDidMount() {
        // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
        (0, $gRw8I.di)(sessionStorage, $058bd651131efa09$var$sessionStorageProvider, window);
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? Number($058bd651131efa09$var$sessionStorageProvider.get(redirectPathname)) : Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.set(redirectPathname, Date.now().toString()) : sessionStorage.setItem(redirectPathname, Date.now().toString());
        else if (Date.now() - lastRedirectTime < $058bd651131efa09$var$THRESHOLD) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const scopeData = (0, $2fNLP.default)(window.location.href, (0, $hWeHP.default));
            const scope = $058bd651131efa09$var$getScopeType(scopeData);
            (0, $eSnSE.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $6JCFc.errorFlag)());
            (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
            return;
        } else (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'ForwardRefExoticComponent<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>>' is not assignable to parameter of type 'ComponentType<{ flagService: FlagService; }>'. | TS2345 - Argument of type 'typeof RedirectToLegacyRouting' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof RedirectToLegacyRouting) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof RedirectToLegacyRouting)'.
$058bd651131efa09$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)((0, $jchga.default)((0, $4J0ad.default)()($058bd651131efa09$export$836fe1ef2cfde075)));

});
parcelRegister("2fNLP", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $87bb57fd652d51da$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $87bb57fd652d51da$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");

var $jkKE1 = parcelRequire("jkKE1");

var $8L5FN = parcelRequire("8L5FN");

var $6zxj7 = parcelRequire("6zxj7");

var $kgGWj = parcelRequire("kgGWj");
const $87bb57fd652d51da$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $87bb57fd652d51da$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $87bb57fd652d51da$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $87bb57fd652d51da$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $87bb57fd652d51da$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $87bb57fd652d51da$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $87bb57fd652d51da$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $8L5FN.default).some((regex)=>regex.test(url)) || (0, $6zxj7.default).some((regex)=>regex.test(url));
const $87bb57fd652d51da$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $87bb57fd652d51da$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $87bb57fd652d51da$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $kgGWj.default).some((route)=>url.match(route)) || $87bb57fd652d51da$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $87bb57fd652d51da$var$getProjectPageType = (getMeta, url)=>{
    if ($87bb57fd652d51da$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
const $87bb57fd652d51da$var$getScopeData = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $87bb57fd652d51da$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $87bb57fd652d51da$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $87bb57fd652d51da$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $87bb57fd652d51da$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $87bb57fd652d51da$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $jkKE1.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};
var $87bb57fd652d51da$export$2e2bcd8739ae039 = $87bb57fd652d51da$var$getScopeData;

});
parcelRegister("8L5FN", function(module, exports) {
$parcel$export(module.exports, "default", () => $9991dc7a3b0c4326$export$2e2bcd8739ae039);
const $9991dc7a3b0c4326$var$connectRoutes = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];
var $9991dc7a3b0c4326$export$2e2bcd8739ae039 = $9991dc7a3b0c4326$var$connectRoutes;

});

parcelRegister("6zxj7", function(module, exports) {
$parcel$export(module.exports, "default", () => $85420e92e692d947$export$2e2bcd8739ae039);
const $85420e92e692d947$var$projectSettingsConnectRoutes = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];
var $85420e92e692d947$export$2e2bcd8739ae039 = $85420e92e692d947$var$projectSettingsConnectRoutes;

});

parcelRegister("kgGWj", function(module, exports) {
$parcel$export(module.exports, "default", () => $270dbf4ef727859d$export$2e2bcd8739ae039);

var $6zxj7 = parcelRequire("6zxj7");
const $270dbf4ef727859d$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
const $270dbf4ef727859d$var$projectSettingsRoutes = [
    ...$270dbf4ef727859d$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $6zxj7.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];
var $270dbf4ef727859d$export$2e2bcd8739ae039 = $270dbf4ef727859d$var$projectSettingsRoutes;

});


parcelRegister("6JCFc", function(module, exports) {
$parcel$export(module.exports, "errorFlag", () => $c0c08f8506304cea$export$b9a7f1ebeaa76953);

var $7uOn8 = parcelRequire("7uOn8");
const $c0c08f8506304cea$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: (0, $7uOn8.messages).title,
        description: (0, $7uOn8.messages).description,
        messageId: 'spa-apps-common.redirect.legacy-routing.flags.flag.error.error-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $7uOn8.messages).goHome,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign('/')
            }
        ]
    });

});
parcelRegister("7uOn8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4dbc780177456e55$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4dbc780177456e55$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "redirect.legacy-routing.flags.error.title",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "redirect.legacy-routing.flags.error.description",
        "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    goHome: {
        "id": "redirect.legacy-routing.flags.error.go-home",
        "defaultMessage": "Go to the homepage"
    }
});

});




parcelRegister("ckYTZ", function(module, exports) {
$parcel$export(module.exports, "workItemRouteEntry", () => $5504bb4056a8d605$export$2fea809b4007e17d);

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $5H8cn = parcelRequire("5H8cn");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $lPVME = parcelRequire("lPVME");

var $9xJ2e = parcelRequire("9xJ2e");

var $gmPbY = parcelRequire("gmPbY");
const $5504bb4056a8d605$export$2fea809b4007e17d = (0, $6xToB.createEntry)((0, $5H8cn.workItemRoute), ()=>({
        group: 'work-item',
        navigation: {
            sidebar: (0, $aDtWM.genericProjectSidebars),
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        // bifrost property is set up, which is required for Bifrost SSR onboarding
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-work-items-entries/src/workItemRouteEntry.tsx',
                whichExportToUse: 'workItemRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        meta: {
            capability: 'WORK_ITEM_VIEW'
        },
        resources: [
            (0, $lPVME.issueGiraDataResource),
            ...(0, $9NmsS.getNavigationResourcesForWorkItem)(),
            // List view resources (loaded when ?hasList=true)
            (0, $9xJ2e.workItemConditionalListResources).conditionalIssueNavigatorResource,
            (0, $9xJ2e.workItemConditionalListResources).conditionalFieldsResource,
            (0, $9xJ2e.workItemConditionalListResources).conditionalProjectContextResource
        ],
        entryPoint: ()=>(0, $gmPbY.workItemPageEntrypoint),
        ufoName: 'work-item',
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('work-item-hydrate-root')
    }));

});
parcelRegister("5H8cn", function(module, exports) {
$parcel$export(module.exports, "workItemRoute", () => $ecc9b08418ae3378$export$cdf7747c91065c7f);
const $ecc9b08418ae3378$export$cdf7747c91065c7f = {
    name: 'work-item',
    exact: true,
    path: '/browse/work-item/:issueKey(\\w+-\\d+)(.*)?'
};

});

parcelRegister("9xJ2e", function(module, exports) {
$parcel$export(module.exports, "workItemConditionalListResources", () => $e66e70449f393ebb$export$b1102804bd8952da);

var $l1VxS = parcelRequire("l1VxS");

var $8k1uC = parcelRequire("8k1uC");

var $ebWJz = parcelRequire("ebWJz");

var $dZRaT = parcelRequire("dZRaT");
/**
 * Extract project key from issue key (e.g., "ABC-123" → "ABC")
 */ const $e66e70449f393ebb$var$extractProjectKeyFromIssueKey = (issueKey)=>{
    if (!issueKey) return null;
    const parts = issueKey.split('-');
    return parts.length >= 2 ? parts[0] : null;
};
/**
 * Creates a conditional resource wrapper that only loads when hasList query param is true.
 * This allows SSR to conditionally load list view resources without impacting default work item performance.
 *
 * For work-item routes, this also extracts projectKey from the issueKey param to ensure proper JQL scoping.
 */ function $e66e70449f393ebb$var$createConditionalListResource(baseResource, resourceName) {
    return (0, $l1VxS.createResource)({
        type: `work-item-list-${resourceName}`,
        getKey: ()=>`work-item-list-${resourceName}`,
        getData: async (routerContext, resourceContext)=>{
            // Only load if hasList query param is explicitly set to 'true'
            if (routerContext.query?.hasList === 'true') {
                // Extract projectKey from issueKey for work-item routes
                const issueKey = routerContext.match.params.issueKey;
                const projectKey = issueKey ? $e66e70449f393ebb$var$extractProjectKeyFromIssueKey(issueKey) : null;
                // Create a modified context with projectKey for resources that need it
                const modifiedContext = {
                    ...routerContext,
                    match: {
                        ...routerContext.match,
                        params: {
                            ...routerContext.match.params,
                            ...projectKey && {
                                projectKey: projectKey
                            }
                        }
                    }
                };
                return baseResource.getData(modifiedContext, resourceContext);
            }
            // Return null to skip loading when not needed
            return null;
        },
        maxAge: baseResource.maxAge || 0
    });
}
/**
 * issue navigator relay resource.
 */ const $e66e70449f393ebb$var$conditionalIssueNavigatorResource = $e66e70449f393ebb$var$createConditionalListResource((0, $8k1uC.issueNavigatorRelayResource), 'issue-navigator');
/**
 * fields resource.
 */ const $e66e70449f393ebb$var$conditionalFieldsResource = $e66e70449f393ebb$var$createConditionalListResource((0, $ebWJz.fieldsResource), 'fields');
/**
 * project context resource.
 */ const $e66e70449f393ebb$var$conditionalProjectContextResource = $e66e70449f393ebb$var$createConditionalListResource((0, $dZRaT.projectContextResource), 'project-context');
const $e66e70449f393ebb$export$b1102804bd8952da = {
    conditionalProjectContextResource: $e66e70449f393ebb$var$conditionalProjectContextResource,
    conditionalFieldsResource: $e66e70449f393ebb$var$conditionalFieldsResource,
    conditionalIssueNavigatorResource: $e66e70449f393ebb$var$conditionalIssueNavigatorResource
};

});
parcelRegister("8k1uC", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorRelayResource", () => $ed0a4483fb669c9c$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $ed0a4483fb669c9c$export$44ca3a0b25f38d83);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResource", () => $ed0a4483fb669c9c$export$967ef0cfbd1cc946);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResourceBrowserOnly", () => $ed0a4483fb669c9c$export$2c98f9cf5d4c493e);
$parcel$export(module.exports, "issueNavigatorFilterRefinementRelayResource", () => $ed0a4483fb669c9c$export$b963a9a8713e35f3);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $4NoAT = parcelRequire("4NoAT");

var $cxKOj = parcelRequire("cxKOj");

var $82cqT = parcelRequire("82cqT");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $awWeA = parcelRequire("awWeA");

var $8oKDI = parcelRequire("8oKDI");

var $7zZ4w = parcelRequire("7zZ4w");

var $jjfy5 = parcelRequire("jjfy5");

var $9FYIg = parcelRequire("9FYIg");

var $3w0Dj = parcelRequire("3w0Dj");

var $4mFQO = parcelRequire("4mFQO");

var $93W2w = parcelRequire("93W2w");

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");

var $9S9Cb = parcelRequire("9S9Cb");

var $kjRvu = parcelRequire("kjRvu");

var $2HIMw = parcelRequire("2HIMw");

var $lzktc = parcelRequire("lzktc");
const $ed0a4483fb669c9c$export$b4096f516fb93159 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: ({ match: { params: { projectKey: projectKey } }, query: { filter: filter } })=>{
        if (projectKey) return `issue-navigator-relay-${projectKey}`;
        if (!(0, $4cTDP.fg)('nin_prevent_route_refresh_on_filter_change')) {
            const filterId = Boolean(filter) && (0, $82cqT.isFilterId)(filter) ? filter : null;
            if (filterId) return `issue-navigator-relay-${filterId}`;
        }
        return 'issue-navigator-relay';
    },
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter, groupBy: groupBy, hideDone: hideDone } = (0, $lzktc.getParams)(routerContext);
        const issueSearchInput = (0, $4cTDP.fg)('jira_nin_last_used_jql') ? (0, $lzktc.getIssueSearchInput)(defaultJql, jqlParam, filter, projectKey) : (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $iRahl.getMaxIssuesPerPage)();
        const chromelessRoute = (0, $lzktc.isChromelessRoute)(routerContext);
        let viewId;
        let shouldQueryConditionalFormatting = Boolean(projectKey);
        let isIFCEnabled = Boolean(projectKey);
        const filterId = Boolean(filter) && (0, $82cqT.isCustomFilter)(filter) ? filter : null;
        if (chromelessRoute) {
            // Disable conditional formatting for chromeless (i.e. embed) routes when saved views is disabled
            shouldQueryConditionalFormatting = (0, $4cTDP.fg)('saved_list_view_technical_changes');
            // Disable IFC for chromeless (i.e. embed) routes
            isIFCEnabled = false;
            // Explicitly load list view for chromeless (i.e. embed) routes
            viewId = filterId ? (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId) : 'list_default';
        }
        let staticViewInput;
        if (projectKey === undefined || projectKey === null) staticViewInput = {
            isHierarchyEnabled: false,
            isGroupingEnabled: false,
            isHideDoneEnabled: false
        };
        else if (hideDone != null) staticViewInput = {
            isHideDoneEnabled: hideDone
        };
        const viewConfigInput = staticViewInput ? {
            staticViewInput: staticViewInput
        } : {
            viewInput: {
                namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE)
            }
        };
        let viewQueryInput;
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support')) {
            const itemIdSlug = routerContext.match.params.navigationItemId;
            const itemId = itemIdSlug ? `list/${itemIdSlug}` : 'list';
            viewQueryInput = projectKey == null ? {
                viewAri: (0, $9S9Cb.createViewAri)({
                    activationId: tenantContext.activationId,
                    cloudId: tenantContext.cloudId
                })
            } : {
                projectKeyAndItemIdQuery: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    itemId: itemId
                }
            };
        }
        let operationScope;
        if (isIFCEnabled && (0, $cxKOj.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) operationScope = (0, $awWeA.getOperationScope)(projectKey);
        else if (projectKey) operationScope = (0, $iRahl.NIN_PROJECT_OPERATION_SCOPE);
        else operationScope = (0, $iRahl.NIN_GLOBAL_OPERATION_SCOPE);
        const scope = {
            operationScope: operationScope
        };
        // Behavioural change from IFC. Previously we omitted the project key in embed view - which
        // means default global field sets would be loaded. Now we load field sets configured to the
        // project in both project and embed routes
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) scope.projectKey = projectKey ?? null;
        else if (isIFCEnabled && (0, $cxKOj.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) scope.projectKey = projectKey;
        let fieldSetsScope = null;
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) fieldSetsScope = {
            operationScope: operationScope,
            projectKey: projectKey ?? null
        };
        else if (isIFCEnabled && (0, $cxKOj.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) fieldSetsScope = {
            operationScope: operationScope,
            projectKey: projectKey
        };
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: issueSearchInput,
            namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE),
            fieldSetsInput: {
                viewInput: {
                    namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE),
                    filterId: filterId,
                    viewId: viewId
                }
            },
            after: null,
            options: {
                issueKey: issueKey
            },
            filterId: filterId,
            amountOfColumns: (0, $iRahl.MAX_AMOUNT_OF_COLUMNS),
            shouldQueryHasChildren: projectKey !== null && projectKey !== undefined && (0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
            ...(0, $4cTDP.fg)('jsc_nin_operation_scope_fe') && {
                scope: scope
            },
            ...((0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) || (0, $4cTDP.fg)('jsc_hide_done_view_config_fix')) && {
                viewConfigInput: viewConfigInput
            },
            staticViewInput: staticViewInput,
            ...((0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support')) && {
                viewQueryInput: viewQueryInput,
                settings: {
                    groupBy: groupBy,
                    hideDone: hideDone,
                    jql: jqlParam
                }
            },
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $iRahl.NATURAL_LANGUAGE_TO_JQL),
            projectKey: projectKey ?? '',
            shouldQueryProject: Boolean(projectKey),
            shouldQueryConditionalFormatting: shouldQueryConditionalFormatting && (0, $4cTDP.fg)('jira_list_conditional_formatting'),
            shouldQueryConditionalFormattingFromSavedView: // eslint-disable-next-line jira/ff/no-preconditioning
            shouldQueryConditionalFormatting && (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $4cTDP.fg)('saved_list_view_technical_changes'),
            groupBy: groupBy ?? null,
            fieldSetsScope: fieldSetsScope,
            viewId: viewId
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $93W2w.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$44ca3a0b25f38d83 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $lzktc.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $82cqT.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $4mFQO.default), variables, options);
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$967ef0cfbd1cc946 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
    getKey: ()=>'issue-navigator-hydration-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $lzktc.getParams)(routerContext);
        const isProjectNIN = Boolean(projectKey);
        if (isProjectNIN && (0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false)) return null;
        let variables;
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) {
            const hydrateJqlInput = (0, $lzktc.getHydrateJqlInput)({
                activationId: tenantContext.activationId,
                cloudId: tenantContext.cloudId,
                defaultJql: defaultJql,
                jqlParam: jqlParam,
                filter: filter,
                projectKey: projectKey
            });
            variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: false,
                jql: '',
                filterAri: '',
                viewContext: null,
                input: hydrateJqlInput,
                isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
            };
        } else {
            const jqlOrFilterId = (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: 'filterId' in jqlOrFilterId,
                jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
                filterAri: 'filterId' in jqlOrFilterId && (0, $4NoAT.JiraFilterAri).create({
                    siteId: tenantContext.cloudId,
                    filterId: filter,
                    activationId: tenantContext.activationId
                }).toString() || '',
                viewContext: null,
                input: null,
                isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
            };
        }
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $3w0Dj.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$2c98f9cf5d4c493e = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}_BROWSER_ONLY`,
    getKey: ()=>'issue-navigator-hydration-relay-browser-only',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $lzktc.getParams)(routerContext);
        let variables;
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) {
            const hydrateJqlInput = (0, $lzktc.getHydrateJqlInput)({
                activationId: tenantContext.activationId,
                cloudId: tenantContext.cloudId,
                defaultJql: defaultJql,
                jqlParam: jqlParam,
                filter: filter,
                projectKey: projectKey
            });
            variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                // Remove argument and query variable on jira_nin_last_used_jql cleanup
                isFilter: false,
                // Remove argument and query variable on jira_nin_last_used_jql cleanup
                jql: '',
                // Remove argument and query variable on jira_nin_last_used_jql cleanup
                filterAri: '',
                viewContext: null,
                input: hydrateJqlInput,
                isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
            };
        } else {
            const jqlOrFilterId = (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: 'filterId' in jqlOrFilterId,
                jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
                filterAri: 'filterId' in jqlOrFilterId && (0, $4NoAT.JiraFilterAri).create({
                    siteId: tenantContext.cloudId,
                    filterId: filter,
                    activationId: tenantContext.activationId
                }).toString() || '',
                viewContext: null,
                input: null,
                isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
            };
        }
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $3w0Dj.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0,
    isBrowserOnly: true
});
const $ed0a4483fb669c9c$export$b963a9a8713e35f3 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-refinement-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey } = (0, $lzktc.getParams)(routerContext);
        const isProjectNIN = Boolean(projectKey);
        if (!isProjectNIN || !(0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false)) return null;
        const variables = {
            cloudId: tenantContext.cloudId,
            isFilterRefinementEnabled: true
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $kjRvu.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("82cqT", function(module, exports) {
$parcel$export(module.exports, "isCustomFilter", () => $210cb11189693860$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $210cb11189693860$export$23be85030bd58047);
const $210cb11189693860$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $210cb11189693860$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $210cb11189693860$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("iRahl", function(module, exports) {
$parcel$export(module.exports, "sortDirections", () => $44bd204fdd3c598a$export$73034536b9adc928);
$parcel$export(module.exports, "FilterTypes", () => $44bd204fdd3c598a$export$ad2e3f13451a5d44);
$parcel$export(module.exports, "SearchInputTypes", () => $44bd204fdd3c598a$export$75a31bc7c097ba4b);
$parcel$export(module.exports, "views", () => $44bd204fdd3c598a$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $44bd204fdd3c598a$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $44bd204fdd3c598a$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $44bd204fdd3c598a$export$393cb330f31d305c);
$parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", () => $44bd204fdd3c598a$export$8ea18fa9e35fdf25);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $44bd204fdd3c598a$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $44bd204fdd3c598a$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $44bd204fdd3c598a$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $44bd204fdd3c598a$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $44bd204fdd3c598a$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $44bd204fdd3c598a$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $44bd204fdd3c598a$export$52919046b94109dc);
$parcel$export(module.exports, "GROUPED_LIST_EXPERIENCE_ID", () => $44bd204fdd3c598a$export$88890124f795113d);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $44bd204fdd3c598a$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $44bd204fdd3c598a$export$524ae4278a57eea2);
$parcel$export(module.exports, "LIST_VIEW_ID", () => $44bd204fdd3c598a$export$af225181779390f4);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $44bd204fdd3c598a$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $44bd204fdd3c598a$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $44bd204fdd3c598a$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $44bd204fdd3c598a$export$55628b4c44d1522a);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$39ec48f092f3ea90);
$parcel$export(module.exports, "NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$2c213b805a8379cf);
$parcel$export(module.exports, "NIN_SIDEBAR_SCOPE", () => $44bd204fdd3c598a$export$adc96a79a4445d56);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_SIDEBAR_ID", () => $44bd204fdd3c598a$export$6c35abbca3056365);
$parcel$export(module.exports, "ALL_COLUMNS_ID", () => $44bd204fdd3c598a$export$eb85a4c9b5d9ce7b);
$parcel$export(module.exports, "supportedOrderFields", () => $44bd204fdd3c598a$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $44bd204fdd3c598a$export$eaadab3243bf458);
$parcel$export(module.exports, "isJiraIssueSearchViewMetadata", () => $44bd204fdd3c598a$export$f40fffea1f8469ac);
$parcel$export(module.exports, "isJiraSpreadsheetView", () => $44bd204fdd3c598a$export$2627fa464eafde69);

var $8jOO7 = parcelRequire("8jOO7");
const $44bd204fdd3c598a$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $44bd204fdd3c598a$export$ad2e3f13451a5d44 = {
    ID: 'filterId',
    JQL: 'filterJql'
};
const $44bd204fdd3c598a$export$75a31bc7c097ba4b = {
    JQL: 'jql',
    FILTER: 'filter',
    FILTER_AND_JQL: 'filterAndJql'
};
const $44bd204fdd3c598a$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $44bd204fdd3c598a$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $44bd204fdd3c598a$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $44bd204fdd3c598a$export$393cb330f31d305c = $44bd204fdd3c598a$export$2bd49f8f262d7cbb.created;
const $44bd204fdd3c598a$export$8ea18fa9e35fdf25 = $44bd204fdd3c598a$export$73034536b9adc928.DESC;
const $44bd204fdd3c598a$export$500b5c379b5c7f2e = 'list_default';
const $44bd204fdd3c598a$export$f88f58d1a4b2078b = 50;
const $44bd204fdd3c598a$export$8c67ad1f64ab5a9c = ()=>$44bd204fdd3c598a$export$f88f58d1a4b2078b;
const $44bd204fdd3c598a$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $44bd204fdd3c598a$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $44bd204fdd3c598a$export$d57b6b390e78d90f = 'empanada';
const $44bd204fdd3c598a$export$52919046b94109dc = 'showPinIssueList';
const $44bd204fdd3c598a$export$88890124f795113d = 'groupedList';
const $44bd204fdd3c598a$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $44bd204fdd3c598a$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $44bd204fdd3c598a$export$af225181779390f4 = 'list_default';
const $44bd204fdd3c598a$export$608eeb3a32afef02 = (0, $8jOO7.MAX_COLUMNS);
const $44bd204fdd3c598a$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $44bd204fdd3c598a$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $44bd204fdd3c598a$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $44bd204fdd3c598a$export$fae6afe554014a45 = 'NIN_PROJECT';
const $44bd204fdd3c598a$export$39ec48f092f3ea90 = 'NIN_GLOBAL';
const $44bd204fdd3c598a$export$2c213b805a8379cf = 'NIN_PROJECT_SHADOW_REQUEST';
const $44bd204fdd3c598a$export$adc96a79a4445d56 = 'NIN_SIDEBAR';
const $44bd204fdd3c598a$export$6c35abbca3056365 = 'IssueNavigator';
const $44bd204fdd3c598a$export$eb85a4c9b5d9ce7b = 'all-columns';
const $44bd204fdd3c598a$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $44bd204fdd3c598a$export$eaadab3243bf458 = (alias)=>Object.keys($44bd204fdd3c598a$export$3630aa1c4c69277f).find((key)=>$44bd204fdd3c598a$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
const $44bd204fdd3c598a$export$f40fffea1f8469ac = (data)=>[
        'JiraIssueSearchView',
        'JiraDetailedView',
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);
const $44bd204fdd3c598a$export$2627fa464eafde69 = (data)=>[
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);

});
parcelRegister("8jOO7", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $235707a6a613803b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $235707a6a613803b$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $235707a6a613803b$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $235707a6a613803b$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $235707a6a613803b$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $235707a6a613803b$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $235707a6a613803b$export$83371d6c41a974aa);
$parcel$export(module.exports, "RESTORE_COLUMNS", () => $235707a6a613803b$export$3bfe53b79fc4f6ed);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $235707a6a613803b$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $235707a6a613803b$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $235707a6a613803b$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $235707a6a613803b$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $235707a6a613803b$export$e2bd4c1faded7921);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $235707a6a613803b$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $235707a6a613803b$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $235707a6a613803b$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $235707a6a613803b$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $235707a6a613803b$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $235707a6a613803b$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "COLUMN_ID_TIMELINE", () => $235707a6a613803b$export$244401c8eb936efd);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $235707a6a613803b$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $235707a6a613803b$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $235707a6a613803b$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $235707a6a613803b$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $235707a6a613803b$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $235707a6a613803b$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $235707a6a613803b$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $235707a6a613803b$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $235707a6a613803b$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $235707a6a613803b$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$54fb99171fb48426);
$parcel$export(module.exports, "MINIMUM_MERGED_CELL_COLUMN_WIDTH", () => $235707a6a613803b$export$787e40d1c5baf821);
$parcel$export(module.exports, "MINIMUM_MERGED_CELL_COLUMN_WIDTH_TIMELINE", () => $235707a6a613803b$export$62288d0140c46137);
$parcel$export(module.exports, "COLUMN_WIDTH_ASSIGNEE", () => $235707a6a613803b$export$49f5d64369d40b04);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $235707a6a613803b$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $235707a6a613803b$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $235707a6a613803b$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $235707a6a613803b$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $235707a6a613803b$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $235707a6a613803b$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $235707a6a613803b$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $235707a6a613803b$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $235707a6a613803b$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $235707a6a613803b$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $235707a6a613803b$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $235707a6a613803b$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $235707a6a613803b$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $235707a6a613803b$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $235707a6a613803b$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $235707a6a613803b$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $235707a6a613803b$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $235707a6a613803b$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $235707a6a613803b$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $235707a6a613803b$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $235707a6a613803b$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $235707a6a613803b$export$118b06a03e2c672f);
$parcel$export(module.exports, "INSTRUCTION_BLOCKED", () => $235707a6a613803b$export$71b8539e20744dab);
$parcel$export(module.exports, "COMBINE", () => $235707a6a613803b$export$a259161040977848);
$parcel$export(module.exports, "REORDER_BEFORE", () => $235707a6a613803b$export$15f7f11d631a78c1);
$parcel$export(module.exports, "REORDER_AFTER", () => $235707a6a613803b$export$3a8d6fe24ed2320f);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $235707a6a613803b$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $235707a6a613803b$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $235707a6a613803b$export$f92486d03c064eac);
$parcel$export(module.exports, "MAX_LINE_WRAP_OLD", () => $235707a6a613803b$export$139bffb2a576e8c0);
$parcel$export(module.exports, "MAX_LINE_WRAP_NEW", () => $235707a6a613803b$export$3b696b0ac06c2cc4);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $235707a6a613803b$export$6ba5aaedfd1b5319);
$parcel$export(module.exports, "SORT_A_TO_Z", () => $235707a6a613803b$export$1bc2edb2aa5e8282);
$parcel$export(module.exports, "SORT_Z_TO_A", () => $235707a6a613803b$export$c7b524b6c48f8273);
$parcel$export(module.exports, "SORT_LOWEST_TO_HIGHEST", () => $235707a6a613803b$export$9c60c93d5e95e80f);
$parcel$export(module.exports, "SORT_HIGHEST_TO_LOWEST", () => $235707a6a613803b$export$476f4bdd6eba4fb2);
$parcel$export(module.exports, "SORT_OLDEST_TO_NEWEST", () => $235707a6a613803b$export$fbcac9f513cf13f4);
$parcel$export(module.exports, "SORT_NEWEST_TO_OLDEST", () => $235707a6a613803b$export$d3c0241ce8ae9a73);
$parcel$export(module.exports, "DUPLICATE_FIELD_EDIT_WIDTH", () => $235707a6a613803b$export$de4b89eec2f02226);
$parcel$export(module.exports, "GRID_NAVIGATION_ONBOARDING_TRIGGERS", () => $235707a6a613803b$export$61885878ee8ed2ff);
$parcel$export(module.exports, "KEYBOARD_SHORTCUTS_HELP_ARTICLE_ID", () => $235707a6a613803b$export$6fb1d4dbf61e0523);
$parcel$export(module.exports, "Z_INDEX_STICKY_COLUMN", () => $235707a6a613803b$export$52078a2fcd02af21);
$parcel$export(module.exports, "SMALL_TABLE_WIDTH", () => $235707a6a613803b$export$f3c2ffd039fcc10c);
$parcel$export(module.exports, "SMALL_SCREEN_WIDTH", () => $235707a6a613803b$export$1c20094c5869d61e);
$parcel$export(module.exports, "EXTRA_SPACE_PER_LEVEL", () => $235707a6a613803b$export$107c825dc66c95b7);
$parcel$export(module.exports, "FIXED_POSITION_COLUMN_TYPES", () => $235707a6a613803b$export$a77fc985659ff0d1);

var $j8Km1 = parcelRequire("j8Km1");
const $235707a6a613803b$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $235707a6a613803b$export$d57b6b390e78d90f = 'empanada';
const $235707a6a613803b$export$88956207daf9a17e = 'ASC';
const $235707a6a613803b$export$bc14f97913aaf2a = 'DESC';
const $235707a6a613803b$export$9c424bf3e8ffe64e = 'NONE';
const $235707a6a613803b$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $235707a6a613803b$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $235707a6a613803b$export$3bfe53b79fc4f6ed = 'RESTORE_COLUMNS';
const $235707a6a613803b$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $235707a6a613803b$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $235707a6a613803b$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $235707a6a613803b$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $235707a6a613803b$export$e2bd4c1faded7921 = '1px';
const $235707a6a613803b$export$cdb7fd9d999c7168 = 40;
const $235707a6a613803b$export$88e6c5bab2ff80e8 = 40;
const $235707a6a613803b$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $235707a6a613803b$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $235707a6a613803b$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $235707a6a613803b$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $235707a6a613803b$export$244401c8eb936efd = 'timeline';
const $235707a6a613803b$export$3dbdc5c16825be4d = [
    $235707a6a613803b$export$c3266da279aa6b84,
    $235707a6a613803b$export$de4c02b525d877fa,
    $235707a6a613803b$export$66b2a4a5f67468ac,
    (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)
];
const $235707a6a613803b$export$a1c171a82c45d53f = 24;
const $235707a6a613803b$export$43ff8c492b8a2e1b = 24;
const $235707a6a613803b$export$9c5dd6078b37aac2 = 16;
const $235707a6a613803b$export$a8273d7d48e89fce = 24;
const $235707a6a613803b$export$7ec4af037f372df4 = 500;
const $235707a6a613803b$export$d2372dfbd4e91a11 = 50;
const $235707a6a613803b$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $235707a6a613803b$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $235707a6a613803b$export$c1d348661674e922 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $235707a6a613803b$export$67082d449d5ec91 = 'com.atlassian.servicedesk:sd-request-feedback';
const $235707a6a613803b$export$145a4a20f394acf9 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $235707a6a613803b$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $235707a6a613803b$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $235707a6a613803b$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $235707a6a613803b$export$7c3f559e2ca95fa = 170;
const $235707a6a613803b$export$e1a42c2fefb5af25 = 999;
const $235707a6a613803b$export$54fb99171fb48426 = 80;
const $235707a6a613803b$export$a194aa0e243a27f9 = 156;
const $235707a6a613803b$export$87a3548b97ce2540 = 136;
const $235707a6a613803b$export$d182a35496b19fb4 = 112;
const $235707a6a613803b$export$4fd6711c21931f5b = 116;
const $235707a6a613803b$export$9b72110b9a7c0a39 = 102;
const $235707a6a613803b$export$54c15048528650a8 = 84;
const $235707a6a613803b$export$7ed05c26fe24a805 = 200;
const $235707a6a613803b$export$787e40d1c5baf821 = 180;
const $235707a6a613803b$export$62288d0140c46137 = 240;
const $235707a6a613803b$export$49f5d64369d40b04 = 204;
const $235707a6a613803b$export$bfe09a9186b98f8f = 400;
const $235707a6a613803b$export$f2540f34b796306d = 300;
const $235707a6a613803b$export$954afb0fcf5a326 = 450;
const $235707a6a613803b$export$93758649595b2d58 = 'reorder';
const $235707a6a613803b$export$cad8c6a0b6e78898 = 'resize';
const $235707a6a613803b$export$5252387dc65db584 = -16;
const $235707a6a613803b$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $235707a6a613803b$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $235707a6a613803b$export$4e8abe16cd1126dd = 'rowReorder';
const $235707a6a613803b$export$6c0a5a77457ca62 = 'COMPACT';
const $235707a6a613803b$export$119d8ab9a5bc4b2 = 'FULL';
const $235707a6a613803b$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $235707a6a613803b$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $235707a6a613803b$export$e03155205bf92428 = 'loadChildItems';
const $235707a6a613803b$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $235707a6a613803b$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $235707a6a613803b$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $235707a6a613803b$export$70f80a241e016093 = 'createIssue';
const $235707a6a613803b$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $235707a6a613803b$export$5eb61e3ff74a4f58 = 'make-child';
const $235707a6a613803b$export$9213b5774112217f = 'reorder-above';
const $235707a6a613803b$export$118b06a03e2c672f = 'reorder-below';
const $235707a6a613803b$export$71b8539e20744dab = 'instruction-blocked';
const $235707a6a613803b$export$a259161040977848 = 'combine';
const $235707a6a613803b$export$15f7f11d631a78c1 = 'reorder-before';
const $235707a6a613803b$export$3a8d6fe24ed2320f = 'reorder-after';
const $235707a6a613803b$export$5b388ccfa29be01 = -1;
const $235707a6a613803b$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $235707a6a613803b$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $235707a6a613803b$export$139bffb2a576e8c0 = 2;
const $235707a6a613803b$export$3b696b0ac06c2cc4 = 1;
const $235707a6a613803b$export$6ba5aaedfd1b5319 = 2000;
const $235707a6a613803b$export$1bc2edb2aa5e8282 = 'a_to_z';
const $235707a6a613803b$export$c7b524b6c48f8273 = 'z_to_a';
const $235707a6a613803b$export$9c60c93d5e95e80f = 'lowest_to_highest';
const $235707a6a613803b$export$476f4bdd6eba4fb2 = 'highest_to_lowest';
const $235707a6a613803b$export$fbcac9f513cf13f4 = 'oldest_to_newest';
const $235707a6a613803b$export$d3c0241ce8ae9a73 = 'newest_to_oldest';
const $235707a6a613803b$export$de4b89eec2f02226 = 270;
const $235707a6a613803b$export$61885878ee8ed2ff = {
    MORE_SHORTCUTS_CLICKED: 'jira-grid-navigation-onboarding-more-shortcuts-clicked',
    OK_CLICKED: 'jira-grid-navigation-onboarding-ok-clicked'
};
const $235707a6a613803b$export$6fb1d4dbf61e0523 = '6yfW2wFuTcluCiX8ghrxWj';
const $235707a6a613803b$export$52078a2fcd02af21 = 7;
const $235707a6a613803b$export$8de1f7a70e87463c = 8;
const $235707a6a613803b$export$f3c2ffd039fcc10c = 960;
const $235707a6a613803b$export$1c20094c5869d61e = 1024;
const $235707a6a613803b$export$107c825dc66c95b7 = 4;
const $235707a6a613803b$export$a77fc985659ff0d1 = [
    $235707a6a613803b$export$244401c8eb936efd,
    $235707a6a613803b$export$de4c02b525d877fa
];

});
parcelRegister("j8Km1", function(module, exports) {
$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $e5b9ff271db028f7$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $e5b9ff271db028f7$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $e5b9ff271db028f7$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_MERGED_COLUMN", () => $e5b9ff271db028f7$export$3237751348c4f1b);
$parcel$export(module.exports, "MERGED_COLUMN_TYPES", () => $e5b9ff271db028f7$export$72f66561203b705c);
$parcel$export(module.exports, "MERGED_COLUMN_IDS", () => $e5b9ff271db028f7$export$70f30e260ec270f2);
$parcel$export(module.exports, "MERGED_COLUMN_DEFAULT_WIDTH", () => $e5b9ff271db028f7$export$6aa1d347deb86ef3);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $e5b9ff271db028f7$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $e5b9ff271db028f7$export$39ec48f092f3ea90);
const $e5b9ff271db028f7$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    TIMELINE: 'timeline',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    MERGED_COLUMN: '__issuetable_internal_merged_column',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
    ATLAS_PROJECT: 'com.atlassian.jira.plugin.system.customfieldtypes:atlas-project',
    RELATIONSHIP: 'issueLinkRelationshipType'
};
const $e5b9ff271db028f7$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $e5b9ff271db028f7$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $e5b9ff271db028f7$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $e5b9ff271db028f7$export$3237751348c4f1b = '__issuetable_internal_merged_column';
const $e5b9ff271db028f7$export$72f66561203b705c = [
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.ISSUE_TYPE,
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.ISSUE_KEY,
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.SUMMARY
];
const $e5b9ff271db028f7$export$70f30e260ec270f2 = [
    'issuetype',
    'issuekey',
    'summary'
];
const $e5b9ff271db028f7$export$6aa1d347deb86ef3 = 64; // 24 * 2 (two icons) + 8*2 (horizontal padding)
const $e5b9ff271db028f7$export$fae6afe554014a45 = 'NIN_PROJECT';
const $e5b9ff271db028f7$export$39ec48f092f3ea90 = 'NIN_GLOBAL';

});



parcelRegister("eibCx", function(module, exports) {
$parcel$export(module.exports, "createRememoizeSelector", () => $0e7c4003c6219e66$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $0e7c4003c6219e66$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $0e7c4003c6219e66$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $0e7c4003c6219e66$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $0e7c4003c6219e66$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $0e7c4003c6219e66$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $0e7c4003c6219e66$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $0e7c4003c6219e66$export$ec4f6e9ea23bb55d);
$parcel$export(module.exports, "exclusiveGroupResultsOrIssueResultsFragment", () => $0e7c4003c6219e66$export$1dde85fc919cd8db);

var $ahm5r = parcelRequire("ahm5r");

var $iRahl = parcelRequire("iRahl");
const $0e7c4003c6219e66$export$982d75deeca693ef = (0, $ahm5r.createSelectorCreator)((0, $ahm5r.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $0e7c4003c6219e66$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $0e7c4003c6219e66$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $0e7c4003c6219e66$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($0e7c4003c6219e66$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $0e7c4003c6219e66$export$6256478a5735e738 = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $0e7c4003c6219e66$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $iRahl.views).detail : (0, $iRahl.views).list;
const $0e7c4003c6219e66$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $iRahl.views).detail ? 'detail' : 'list_default';
const $0e7c4003c6219e66$export$5786a571e562003d = (viewMode)=>viewMode === (0, $iRahl.views).detail ? 'DETAIL' : 'LIST';
function $0e7c4003c6219e66$export$70573498ee17fe1d(value) {
    return value != null;
}
const $0e7c4003c6219e66$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($0e7c4003c6219e66$export$194f1a1e890054c9(viewId)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $0e7c4003c6219e66$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $0e7c4003c6219e66$export$6ce707b3eccb341d = (view)=>view === (0, $iRahl.views).detail ? 'detail' : 'list_default';
const $0e7c4003c6219e66$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $iRahl.views).detail : (0, $iRahl.views).list;
const $0e7c4003c6219e66$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};
function $0e7c4003c6219e66$export$1dde85fc919cd8db({ groupResults: groupResults, issueResults: issueResults }) {
    if (issueResults) return {
        groupResults: null,
        issueResults: issueResults
    };
    if (groupResults) return {
        groupResults: groupResults,
        issueResults: null
    };
    return null;
}

});

parcelRegister("awWeA", function(module, exports) {
$parcel$export(module.exports, "getOperationScope", () => $5af88e3fbe2eb6ab$export$93ef6e0525bce59d);

var $j8Km1 = parcelRequire("j8Km1");
const $5af88e3fbe2eb6ab$export$93ef6e0525bce59d = (projectKey)=>{
    let operationScope;
    if (projectKey != null) operationScope = (0, $j8Km1.NIN_PROJECT_OPERATION_SCOPE);
    else operationScope = (0, $j8Km1.NIN_GLOBAL_OPERATION_SCOPE);
    return operationScope;
};

});

parcelRegister("3w0Dj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce1d0959192768f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5c77cbf7b99305f1107223511d2df8e>>
 * @relayHash 272c213df6b547b7dbc897ac9a46b41c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b3d13de30733668c0c47d689dc01a8178cfb463b102989d04df3e8b4c631f10
const $ce1d0959192768f4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeJira"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUser"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isFilter"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPlanReleaseFeatureToggleEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v12 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v13 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v14 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v17 = [
        v15 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v16 /*: any*/ 
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ], v18 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        },
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = [
        v15 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v19 /*: any*/ 
            ]
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v26 = [
        v15 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v16 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "condition": "isPlanReleaseFeatureToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v12 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "shouldExcludeInScope"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v24 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v24 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v20 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useHydrationQueryLoaderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JQLBuilderUI"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "JQLEditorUIWithErrorBoundary"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "QuerySupportedContainerOld"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValuesUtils"
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v14 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v17 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v18 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v17 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useHydrationQueryLoaderQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v20 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v14 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v18 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3b3d13de30733668c0c47d689dc01a8178cfb463b102989d04df3e8b4c631f10",
            "metadata": {},
            "name": "useHydrationQueryLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ce1d0959192768f4$var$node.hash = "0275d35c12602c6ecd64ce8d4e362f29";
var $ce1d0959192768f4$export$2e2bcd8739ae039 = $ce1d0959192768f4$var$node;

});

parcelRegister("4mFQO", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad68114cb1dd8f51$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<210c03b356af3558094d2187351cd5c9>>
 * @relayHash 9f8f716e33f0a3f70ec04be69edc8a8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 358acf927b5804a881bf1d24cc18e315f32b18ad94e0f7c7dcf94aa639b52072
const $ad68114cb1dd8f51$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "358acf927b5804a881bf1d24cc18e315f32b18ad94e0f7c7dcf94aa639b52072",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ad68114cb1dd8f51$var$node.hash = "181bb07a6bafd05a2033750384a06766";
var $ad68114cb1dd8f51$export$2e2bcd8739ae039 = $ad68114cb1dd8f51$var$node;

});

parcelRegister("93W2w", function(module, exports) {
$parcel$export(module.exports, "default", () => $04e26ee18435d3dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44665226622db541fb1314d4fa891ae8>>
 * @relayHash 41bf20c4597e3adf64a4c4736ce5a5d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e73736f4d089f300e51fcce41aa1ce667886fad0ce2a28d5a87862ecdb84675b

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $dexoz = parcelRequire("dexoz");

var $3jVIX = parcelRequire("3jVIX");

var $4GS9O = parcelRequire("4GS9O");

var $l6otE = parcelRequire("l6otE");

var $lcRgI = parcelRequire("lcRgI");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $axWOK = parcelRequire("axWOK");

var $2Z4v6 = parcelRequire("2Z4v6");

var $alrjx = parcelRequire("alrjx");

var $eylLg = parcelRequire("eylLg");

var $86KXU = parcelRequire("86KXU");

var $iiQfx = parcelRequire("iiQfx");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $hA9n6 = parcelRequire("hA9n6");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $8Qoc7 = parcelRequire("8Qoc7");

var $cqnj8 = parcelRequire("cqnj8");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $04e26ee18435d3dd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryConditionalFormatting"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryConditionalFormattingFromSavedView"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryProject"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewQueryInput"
    }, v27 = {
        "kind": "Variable",
        "name": "isConditionalFormattingEnabled",
        "variableName": "shouldQueryConditionalFormatting"
    }, v28 = {
        "kind": "Variable",
        "name": "isSavedViewConditionalFormattingEnabled",
        "variableName": "shouldQueryConditionalFormattingFromSavedView"
    }, v29 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v30 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v31 = [
        v30 /*: any*/ 
    ], v32 = [
        v30 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v33 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v34 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v35 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v36 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v37 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v38 = {
        "kind": "ScalarField",
        "name": "message"
    }, v39 = [
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v37 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        },
        v38 /*: any*/ 
    ], v40 = {
        "kind": "ScalarField",
        "name": "id"
    }, v41 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v42 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v41 /*: any*/ 
    ], v43 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v44 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v45 = {
        "kind": "ScalarField",
        "name": "savedViewId"
    }, v46 = {
        "args": [
            v36 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "isViewConfigModified"
    }, v47 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v48 = [
        v47 /*: any*/ ,
        v34 /*: any*/ ,
        v36 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v49 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v50 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v49 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v52 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v53 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v54 = {
        "kind": "ClientExtension",
        "selections": [
            v53 /*: any*/ 
        ]
    }, v55 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v56 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v57 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v58 = {
        "kind": "ScalarField",
        "name": "type"
    }, v59 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v60 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v61 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "aliases"
            }
        ]
    }, v62 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v63 = {
        "kind": "ScalarField",
        "name": "value"
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            v49 /*: any*/ ,
            {
                "alias": "singleValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            },
            v63 /*: any*/ 
        ],
        "type": "JiraFormattingSingleValueOperand"
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            v49 /*: any*/ ,
            {
                "alias": "multipleValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            },
            {
                "kind": "ScalarField",
                "name": "values"
            }
        ],
        "type": "JiraFormattingMultipleValueOperand"
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            v49 /*: any*/ ,
            {
                "alias": "noValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            }
        ],
        "type": "JiraFormattingNoValueOperand"
    }, v67 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v64 /*: any*/ ,
            v65 /*: any*/ ,
            v66 /*: any*/ 
        ]
    }, v68 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v69 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v70 = [
        {
            "concreteType": "JiraFormattingRuleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraFormattingRule",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v67 /*: any*/ ,
                        v68 /*: any*/ ,
                        {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                                v40 /*: any*/ ,
                                v69 /*: any*/ 
                            ]
                        },
                        v40 /*: any*/ 
                    ]
                }
            ]
        }
    ], v71 = {
        "kind": "ScalarField",
        "name": "name"
    }, v72 = [
        v69 /*: any*/ ,
        v40 /*: any*/ 
    ], v73 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "formattingColor",
        "plural": false,
        "selections": v72 /*: any*/ 
    }, v74 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v75 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v76 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v77 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v78 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v79 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v80 = {
        "kind": "Variable",
        "name": "saveJQLToUserHistory",
        "variableName": "saveJQLToUserHistory"
    }, v81 = [
        v74 /*: any*/ ,
        v75 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ ,
        v34 /*: any*/ ,
        v78 /*: any*/ ,
        v79 /*: any*/ ,
        v80 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v82 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v83 = {
        "kind": "ScalarField",
        "name": "key"
    }, v84 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v85 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v86 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v85 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            },
            v40 /*: any*/ 
        ]
    }, v87 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v88 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v89 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v88 /*: any*/ ,
            v40 /*: any*/ 
        ]
    }, v90 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v89 /*: any*/ ,
            v40 /*: any*/ 
        ]
    }, v91 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v90 /*: any*/ ,
            v40 /*: any*/ 
        ]
    }, v92 = [
        v71 /*: any*/ 
    ], v93 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": v92 /*: any*/ 
                    }
                ]
            }
        ]
    }, v94 = {
        "kind": "ClientExtension",
        "selections": [
            v53 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v95 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v96 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v97 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v40 /*: any*/ ,
            v83 /*: any*/ ,
            v84 /*: any*/ ,
            v86 /*: any*/ ,
            v87 /*: any*/ ,
            v91 /*: any*/ ,
            v93 /*: any*/ ,
            v94 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v95 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v96 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": v92 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v98 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v99 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v100 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v71 /*: any*/ ,
                                    v40 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v101 = [
        v63 /*: any*/ ,
        v40 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v102 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v103 = {
        "kind": "ClientExtension",
        "selections": [
            v102 /*: any*/ 
        ]
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v101 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v101 /*: any*/ 
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v105 = [
        v38 /*: any*/ 
    ], v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": v105 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v107 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v108 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v109 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v110 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v108 /*: any*/ ,
                                    v109 /*: any*/ ,
                                    v40 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v103 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v111 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v112 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v71 /*: any*/ ,
            v111 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v113 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v114 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v83 /*: any*/ ,
                    v95 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v115 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v116 = {
        "kind": "ScalarField",
        "name": "text"
    }, v117 = {
        "kind": "InlineFragment",
        "selections": [
            v116 /*: any*/ ,
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v118 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v88 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v119 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v89 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v120 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": v72 /*: any*/ 
    }, v121 = [
        v71 /*: any*/ ,
        v120 /*: any*/ 
    ], v122 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v121 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v123 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v96 /*: any*/ ,
                    v71 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v124 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v125 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v126 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v127 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v88 /*: any*/ 
        ]
    }, v128 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v83 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v120 /*: any*/ ,
                            v40 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v124 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v40 /*: any*/ 
                                ]
                            },
                            v40 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v116 /*: any*/ ,
                            v40 /*: any*/ 
                        ]
                    },
                    v40 /*: any*/ ,
                    v84 /*: any*/ ,
                    v125 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "issuetype",
                                            "project",
                                            "summary",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v37 /*: any*/ ,
                                                    v40 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49 /*: any*/ ,
                                                            v116 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v40 /*: any*/ ,
                                                                    v126 /*: any*/ ,
                                                                    v71 /*: any*/ ,
                                                                    v124 /*: any*/ ,
                                                                    v85 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    v40 /*: any*/ ,
                                                                    v127 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    v49 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            v126 /*: any*/ ,
                                            v85 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraSingleLineTextField",
                                "kind": "LinkedField",
                                "name": "summaryField",
                                "plural": false,
                                "selections": [
                                    v49 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v90 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraParentIssueField"
    }, v129 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v130 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v129 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v131 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v83 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v132 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraResolutionField"
    }, v133 = [
        v40 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v71 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v134 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v133 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v135 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v136 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v137 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v138 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v71 /*: any*/ ,
                    v135 /*: any*/ ,
                    v136 /*: any*/ ,
                    v40 /*: any*/ ,
                    v137 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "appType"
                                    }
                                ]
                            }
                        ],
                        "type": "AppUser"
                    }
                ]
            },
            v111 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v139 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v140 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v124 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v141 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v125 /*: any*/ ,
                                            v83 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v37 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v89 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v40 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    v87 /*: any*/ 
                                                ]
                                            },
                                            v40 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v40 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v142 = {
        "kind": "ScalarField",
        "name": "number"
    }, v143 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v142 /*: any*/ ,
            v71 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraNumberFieldFormatConfig",
                        "kind": "LinkedField",
                        "name": "formatConfig",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "formatStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formatUnit"
                            }
                        ]
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v144 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v57 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v145 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v103 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v146 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v147 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    v120 /*: any*/ ,
                    v40 /*: any*/ ,
                    v146 /*: any*/ 
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v148 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v63 /*: any*/ ,
                                    v146 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v149 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v63 /*: any*/ 
        ]
    }, v150 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v37 /*: any*/ ,
                                    v137 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v135 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v136 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v151 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v152 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v153 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v154 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v152 /*: any*/ ,
                                    v153 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v58 /*: any*/ ,
                                    v103 /*: any*/ 
                                ]
                            },
                            v40 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            }
        ]
    }, v155 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v152 /*: any*/ ,
                                    v153 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v58 /*: any*/ 
                                ]
                            },
                            v40 /*: any*/ 
                        ]
                    },
                    v103 /*: any*/ 
                ],
                "type": "JiraOriginalTimeEstimateField"
            }
        ]
    }, v156 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v40 /*: any*/ ,
                    v108 /*: any*/ 
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v157 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v158 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v108 /*: any*/ ,
                                    v109 /*: any*/ ,
                                    v157 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v103 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v159 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            v40 /*: any*/ 
        ]
    }, v160 = {
        "kind": "ScalarField",
        "name": "status"
    }, v161 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            v159 /*: any*/ ,
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v83 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            v71 /*: any*/ ,
                                            v160 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v54 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v53 /*: any*/ ,
                    v102 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v162 = {
        "kind": "ScalarField",
        "name": "privateProject"
    }, v163 = {
        "kind": "ScalarField",
        "name": "hasPermission"
    }, v164 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v71 /*: any*/ ,
                    v159 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isLinkEditable"
                    },
                    {
                        "concreteType": "JiraTownsquareProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            {
                                "alias": "atlasProjectName",
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "alias": "atlasProjectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            v162 /*: any*/ ,
                            v163 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "isWorkspaceActive"
                            }
                        ]
                    },
                    v103 /*: any*/ 
                ],
                "type": "JiraTownsquareProjectField"
            }
        ]
    }, v165 = {
        "kind": "ScalarField",
        "name": "href"
    }, v166 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v165 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    v37 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v165 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v57 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v103 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v167 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v168 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v167 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraMultipleGroupPickerField"
    }, v169 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraFlag",
                "kind": "LinkedField",
                "name": "flag",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFlagged"
                    }
                ]
            }
        ],
        "type": "JiraFlagField"
    }, v170 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraWatch",
                "kind": "LinkedField",
                "name": "watch",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWatching"
                    }
                ]
            }
        ],
        "type": "JiraWatchesField"
    }, v171 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v172 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v173 = [
        v37 /*: any*/ ,
        v40 /*: any*/ 
    ], v174 = {
        "args": v98 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v58 /*: any*/ ,
                            v43 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    v57 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v40 /*: any*/ ,
                                                    v37 /*: any*/ ,
                                                    v49 /*: any*/ ,
                                                    v58 /*: any*/ ,
                                                    v99 /*: any*/ ,
                                                    v100 /*: any*/ ,
                                                    v104 /*: any*/ ,
                                                    v106 /*: any*/ ,
                                                    v110 /*: any*/ ,
                                                    v112 /*: any*/ ,
                                                    v113 /*: any*/ ,
                                                    v114 /*: any*/ ,
                                                    v115 /*: any*/ ,
                                                    v117 /*: any*/ ,
                                                    v118 /*: any*/ ,
                                                    v119 /*: any*/ ,
                                                    v122 /*: any*/ ,
                                                    v123 /*: any*/ ,
                                                    v128 /*: any*/ ,
                                                    v130 /*: any*/ ,
                                                    v131 /*: any*/ ,
                                                    v132 /*: any*/ ,
                                                    v134 /*: any*/ ,
                                                    v138 /*: any*/ ,
                                                    v139 /*: any*/ ,
                                                    v140 /*: any*/ ,
                                                    v141 /*: any*/ ,
                                                    v143 /*: any*/ ,
                                                    v144 /*: any*/ ,
                                                    v145 /*: any*/ ,
                                                    v147 /*: any*/ ,
                                                    v148 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v71 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v149 /*: any*/ ,
                                                                            v54 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v103 /*: any*/ 
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    v150 /*: any*/ ,
                                                    v151 /*: any*/ ,
                                                    v154 /*: any*/ ,
                                                    v155 /*: any*/ ,
                                                    v156 /*: any*/ ,
                                                    v158 /*: any*/ ,
                                                    v161 /*: any*/ ,
                                                    v164 /*: any*/ ,
                                                    v166 /*: any*/ ,
                                                    v168 /*: any*/ ,
                                                    v169 /*: any*/ ,
                                                    v170 /*: any*/ ,
                                                    v54 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v54 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "shouldQueryConditionalFormatting",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v107 /*: any*/ ,
                                                                        "concreteType": "JiraComponentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedComponentsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponent",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "componentId"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v171 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraPriorityField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v172 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraProjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "version",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v157 /*: any*/ ,
                                                                            v40 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v126 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValue",
                                                                        "plural": false,
                                                                        "selections": v173 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSelectableValueEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v173 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v175 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v176 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v177 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v175 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v176 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v178 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v179 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v180 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v181 = [
        v179 /*: any*/ ,
        v82 /*: any*/ ,
        v180 /*: any*/ 
    ], v182 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v181 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v181 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v82 /*: any*/ ,
                    v179 /*: any*/ ,
                    v180 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v183 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v184 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v38 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": v105 /*: any*/ ,
                "type": "JiraServerError"
            }
        ]
    }, v185 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v186 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v95 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v187 = {
        "args": v81 /*: any*/ ,
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v82 /*: any*/ ,
                    v97 /*: any*/ ,
                    v37 /*: any*/ ,
                    v174 /*: any*/ ,
                    v54 /*: any*/ 
                ]
            },
            v177 /*: any*/ ,
            v178 /*: any*/ ,
            v182 /*: any*/ ,
            v183 /*: any*/ ,
            v184 /*: any*/ ,
            v44 /*: any*/ ,
            v185 /*: any*/ ,
            v54 /*: any*/ ,
            v186 /*: any*/ 
        ]
    }, v188 = [
        "scope"
    ], v189 = [
        "issueSearchInput"
    ], v190 = [
        v74 /*: any*/ ,
        v75 /*: any*/ ,
        v77 /*: any*/ ,
        v47 /*: any*/ ,
        v34 /*: any*/ ,
        v78 /*: any*/ ,
        v80 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v191 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v192 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v60 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v171 /*: any*/ ,
                            v71 /*: any*/ ,
                            v129 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v37 /*: any*/ ,
                            v40 /*: any*/ ,
                            v137 /*: any*/ ,
                            v71 /*: any*/ ,
                            v135 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v71 /*: any*/ ,
                            v127 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ ,
                    v89 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v142 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v146 /*: any*/ ,
                            v63 /*: any*/ ,
                            v120 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v133 /*: any*/ 
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": v121 /*: any*/ 
                    }
                ],
                "type": "JiraJqlLabelFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v167 /*: any*/ ,
                            v71 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlGroupFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v157 /*: any*/ ,
                            v71 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlVersionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v59 /*: any*/ ,
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v160 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            },
                            v40 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlGoalsFieldValue"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraTownsquareProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v83 /*: any*/ ,
                                    v162 /*: any*/ ,
                                    v163 /*: any*/ ,
                                    v71 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlTownsquareProjectFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueTypes",
                        "plural": true,
                        "selections": [
                            v71 /*: any*/ ,
                            v96 /*: any*/ ,
                            v40 /*: any*/ ,
                            v126 /*: any*/ ,
                            v85 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlIssueTypeFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v59 /*: any*/ ,
                    {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "resolution",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v71 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlResolutionFieldValue"
            }
        ]
    }, v193 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v194 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v195 = [
        v76 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        v41 /*: any*/ ,
        v36 /*: any*/ ,
        v194 /*: any*/ 
    ], v196 = {
        "args": v190 /*: any*/ ,
        "concreteType": "JiraSpreadsheetGroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v82 /*: any*/ ,
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v37 /*: any*/ ,
                            v40 /*: any*/ ,
                            v44 /*: any*/ ,
                            v49 /*: any*/ ,
                            v191 /*: any*/ ,
                            v43 /*: any*/ ,
                            v192 /*: any*/ ,
                            v193 /*: any*/ 
                        ]
                    },
                    v37 /*: any*/ 
                ]
            },
            v177 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "groupByField"
            },
            v44 /*: any*/ ,
            {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": v39 /*: any*/ 
            },
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            {
                                "args": v195 /*: any*/ ,
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v37 /*: any*/ ,
                                            v82 /*: any*/ ,
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v37 /*: any*/ ,
                                                    v40 /*: any*/ ,
                                                    v84 /*: any*/ ,
                                                    v83 /*: any*/ ,
                                                    v86 /*: any*/ ,
                                                    v87 /*: any*/ ,
                                                    v91 /*: any*/ ,
                                                    v93 /*: any*/ ,
                                                    v94 /*: any*/ 
                                                ]
                                            },
                                            {
                                                "args": v98 /*: any*/ ,
                                                "concreteType": "JiraIssueFieldSetConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldSets",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldSetEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldSet",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v58 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fields",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v57 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v40 /*: any*/ ,
                                                                                            v37 /*: any*/ ,
                                                                                            v49 /*: any*/ ,
                                                                                            v58 /*: any*/ ,
                                                                                            v99 /*: any*/ ,
                                                                                            v100 /*: any*/ ,
                                                                                            v104 /*: any*/ ,
                                                                                            v106 /*: any*/ ,
                                                                                            v110 /*: any*/ ,
                                                                                            v112 /*: any*/ ,
                                                                                            v113 /*: any*/ ,
                                                                                            v114 /*: any*/ ,
                                                                                            v115 /*: any*/ ,
                                                                                            v117 /*: any*/ ,
                                                                                            v118 /*: any*/ ,
                                                                                            v119 /*: any*/ ,
                                                                                            v122 /*: any*/ ,
                                                                                            v123 /*: any*/ ,
                                                                                            v128 /*: any*/ ,
                                                                                            v130 /*: any*/ ,
                                                                                            v131 /*: any*/ ,
                                                                                            v132 /*: any*/ ,
                                                                                            v134 /*: any*/ ,
                                                                                            v138 /*: any*/ ,
                                                                                            v139 /*: any*/ ,
                                                                                            v140 /*: any*/ ,
                                                                                            v141 /*: any*/ ,
                                                                                            v143 /*: any*/ ,
                                                                                            v144 /*: any*/ ,
                                                                                            v145 /*: any*/ ,
                                                                                            v147 /*: any*/ ,
                                                                                            v148 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v71 /*: any*/ ,
                                                                                                    {
                                                                                                        "concreteType": "JiraOptionConnection",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "selectedOptions",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "edges",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v149 /*: any*/ 
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v103 /*: any*/ 
                                                                                                ],
                                                                                                "type": "JiraCheckboxesField"
                                                                                            },
                                                                                            v150 /*: any*/ ,
                                                                                            v151 /*: any*/ ,
                                                                                            v154 /*: any*/ ,
                                                                                            v155 /*: any*/ ,
                                                                                            v156 /*: any*/ ,
                                                                                            v158 /*: any*/ ,
                                                                                            v161 /*: any*/ ,
                                                                                            v164 /*: any*/ ,
                                                                                            v166 /*: any*/ ,
                                                                                            v168 /*: any*/ ,
                                                                                            v169 /*: any*/ ,
                                                                                            v170 /*: any*/ ,
                                                                                            v54 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldSets(first:500)"
                                            },
                                            v54 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            v175 /*: any*/ ,
                                            v176 /*: any*/ 
                                        ]
                                    },
                                    v183 /*: any*/ ,
                                    v185 /*: any*/ ,
                                    v54 /*: any*/ 
                                ]
                            },
                            {
                                "args": v195 /*: any*/ ,
                                "filters": [
                                    "viewConfigInput",
                                    "fieldSetsInput",
                                    "scope",
                                    "settings"
                                ],
                                "handle": "connection",
                                "key": "firstGroupSection_nativeIssueTable__issues",
                                "kind": "LinkedHandle",
                                "name": "issues"
                            },
                            v44 /*: any*/ ,
                            v49 /*: any*/ ,
                            v191 /*: any*/ ,
                            v43 /*: any*/ ,
                            v192 /*: any*/ ,
                            v193 /*: any*/ 
                        ]
                    }
                ]
            },
            v54 /*: any*/ 
        ]
    }, v197 = [
        v74 /*: any*/ ,
        v75 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ ,
        v34 /*: any*/ ,
        v78 /*: any*/ ,
        v79 /*: any*/ ,
        v80 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v194 /*: any*/ 
    ], v198 = {
        "args": v197 /*: any*/ ,
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v82 /*: any*/ ,
                    v97 /*: any*/ ,
                    v37 /*: any*/ ,
                    v174 /*: any*/ ,
                    {
                        "condition": "shouldQueryHasChildren",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "items": [
                                            {
                                                "kind": "Variable",
                                                "name": "filterByProjectKeys.0",
                                                "variableName": "projectKey"
                                            }
                                        ],
                                        "kind": "ListValue",
                                        "name": "filterByProjectKeys"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "hasChildren"
                            },
                            {
                                "args": [
                                    v29 /*: any*/ 
                                ],
                                "kind": "ScalarField",
                                "name": "canHaveChildIssues"
                            }
                        ]
                    },
                    v54 /*: any*/ 
                ]
            },
            v177 /*: any*/ ,
            v178 /*: any*/ ,
            v182 /*: any*/ ,
            v183 /*: any*/ ,
            v184 /*: any*/ ,
            v44 /*: any*/ ,
            v185 /*: any*/ ,
            v54 /*: any*/ ,
            v186 /*: any*/ 
        ]
    }, v199 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v30 /*: any*/ 
    ], v200 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "args": [
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        v29 /*: any*/ ,
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys.0",
                                    "variableName": "projectKey"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v31 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jira"
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v32 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "main_issueNavigator_IssueNavigatorUI_project"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueSearch_issueNavigatorProject"
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "kind": "FragmentSpread",
                                                            "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ConditionalFormattingSidebarContainer_project"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v12 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ ,
                v25 /*: any*/ ,
                v14 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v15 /*: any*/ ,
                v22 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v10 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v17 /*: any*/ ,
                v9 /*: any*/ ,
                v21 /*: any*/ ,
                v6 /*: any*/ ,
                v26 /*: any*/ ,
                v18 /*: any*/ ,
                v16 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v30 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v34 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "viewConfigInput",
                                    "variableName": "staticViewInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewQueryInput",
                                    "variableName": "viewQueryInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "jiraIssueSearchView",
                            "plural": false,
                            "selections": [
                                v37 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraView"
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": v39 /*: any*/ 
                                },
                                v40 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v42 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isFrozen"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v44 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPublishViewConfig"
                                                },
                                                v45 /*: any*/ ,
                                                v46 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v48 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v50 /*: any*/ ,
                                                                v51 /*: any*/ ,
                                                                v52 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v54 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v45 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v48 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                v55 /*: any*/ ,
                                                v56 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v52 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": [
                                                        v41 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v42 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v57 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v58 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v59 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v61 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        v49 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v54 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v46 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v48 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v52 /*: any*/ ,
                                                                v62 /*: any*/ ,
                                                                v55 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                v51 /*: any*/ ,
                                                                v50 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEnableReranking"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraFormattingRuleConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "conditionalFormattingRules",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v70 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v54 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v44 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "filterId"
                                                        },
                                                        {
                                                            "args": v48 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v71 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "typeKey"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ],
                                            "type": "JiraView",
                                            "abstractKey": "__isJiraView"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v48 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                    "kind": "LinkedField",
                                                    "name": "viewSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        v62 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v45 /*: any*/ ,
                                                {
                                                    "args": v33 /*: any*/ ,
                                                    "concreteType": "JiraFormattingRuleConnection",
                                                    "kind": "LinkedField",
                                                    "name": "conditionalFormattingRules",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRuleEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "expression",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                v65 /*: any*/ ,
                                                                                v64 /*: any*/ ,
                                                                                v66 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v73 /*: any*/ ,
                                                                        v68 /*: any*/ 
                                                                    ]
                                                                },
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        v54 /*: any*/ 
                                                    ],
                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                },
                                                v54 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v187 /*: any*/ ,
                                                {
                                                    "args": v81 /*: any*/ ,
                                                    "filters": v188 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v187 /*: any*/ ,
                                                {
                                                    "args": v81 /*: any*/ ,
                                                    "filters": v189 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraDetailedView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v196 /*: any*/ ,
                                                {
                                                    "args": v190 /*: any*/ ,
                                                    "filters": v188 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                                                    "kind": "LinkedHandle",
                                                    "name": "groups"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v196 /*: any*/ ,
                                                {
                                                    "args": v190 /*: any*/ ,
                                                    "filters": v189 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                                    "kind": "LinkedHandle",
                                                    "name": "groups"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGroupedListView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v198 /*: any*/ ,
                                                {
                                                    "args": v197 /*: any*/ ,
                                                    "filters": v188 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraListViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v198 /*: any*/ ,
                                                {
                                                    "args": v197 /*: any*/ ,
                                                    "filters": v189 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorListViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraListView"
                                }
                            ]
                        },
                        {
                            "args": v31 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                },
                                v54 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isNaturalLanguageSpotlightTourEnabled"
                                }
                            ]
                        },
                        {
                            "args": v199 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v199 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v37 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v31 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldWithAliases",
                                    "kind": "LinkedField",
                                    "name": "rankField",
                                    "plural": false,
                                    "selections": [
                                        v49 /*: any*/ ,
                                        v60 /*: any*/ ,
                                        v61 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v32 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v83 /*: any*/ ,
                                        v172 /*: any*/ ,
                                        {
                                            "alias": "createIssues",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "CREATE_ISSUES"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": v200 /*: any*/ ,
                                            "storageKey": "action(type:\"CREATE_ISSUES\")"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        v40 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "editIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v200 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraFormattingRuleConnection",
                                                            "kind": "LinkedField",
                                                            "name": "conditionalFormattingRules",
                                                            "plural": false,
                                                            "selections": v70 /*: any*/ ,
                                                            "storageKey": "conditionalFormattingRules(first:20)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraFormattingRuleConnection",
                                                            "kind": "LinkedField",
                                                            "name": "conditionalFormattingRules",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRuleEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFormattingRule",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                v68 /*: any*/ ,
                                                                                v67 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "conditionalFormattingRules(first:20)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": v92 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e73736f4d089f300e51fcce41aa1ce667886fad0ce2a28d5a87862ecdb84675b",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider": (0, $hA9n6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $iiQfx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": (0, $lcRgI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": (0, $eylLg.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": (0, $cqnj8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $alrjx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": (0, $dexoz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": (0, $4GS9O.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": (0, $axWOK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider": (0, $86KXU.default)
            }
        }
    };
}();
$04e26ee18435d3dd$var$node.hash = "e08a14af4b25b6ce0f995ff259a909bf";
var $04e26ee18435d3dd$export$2e2bcd8739ae039 = $04e26ee18435d3dd$var$node;

});
parcelRegister("dexoz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1454966b1f1ab0d9$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $1454966b1f1ab0d9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('frontier-formula-field-d1');
    }
};

});

parcelRegister("4GS9O", function(module, exports) {
$parcel$export(module.exports, "default", () => $00c181c86ac97317$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $00c181c86ac97317$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('group_by_projects');
    }
};

});

parcelRegister("lcRgI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5044a43d32ddc421$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $5044a43d32ddc421$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('issue_table_frozen_columns');
    }
};

});

parcelRegister("axWOK", function(module, exports) {
$parcel$export(module.exports, "default", () => $17a374daabff4b4a$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $17a374daabff4b4a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_paid_list_nin_merge_onboarding_modal');
    }
};

});

parcelRegister("alrjx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5866ee686638771$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $f5866ee686638771$export$2e2bcd8739ae039 = {
    get () {
        // eslint-disable-next-line jira/ff/no-preconditioning
        return (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $4cTDP.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("eylLg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5026bc93a9dbae2$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $f5026bc93a9dbae2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('saved_list_view', 'isEnabled', false);
    }
};

});

parcelRegister("86KXU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6138f9d02c978367$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6138f9d02c978367$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support');
    }
};

});

parcelRegister("iiQfx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2f41d418b65dd3d$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $f2f41d418b65dd3d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("kmr3r", function(module, exports) {
$parcel$export(module.exports, "default", () => $828374d45db0f539$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $828374d45db0f539$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsc_list_reparenting');
    }
};

});

parcelRegister("hA9n6", function(module, exports) {
$parcel$export(module.exports, "default", () => $66bdfe38c73f6115$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $66bdfe38c73f6115$var$lastUsedJql = {
    get () {
        return (0, $4cTDP.fg)('jira_nin_last_used_jql');
    }
};
var $66bdfe38c73f6115$export$2e2bcd8739ae039 = $66bdfe38c73f6115$var$lastUsedJql;

});

parcelRegister("cqnj8", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dc2689c4189780e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $0dc2689c4189780e$var$JscIssueRankingRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jsc_list_reranking_gate');
    }
};
var $0dc2689c4189780e$export$2e2bcd8739ae039 = $0dc2689c4189780e$var$JscIssueRankingRelayProvider;

});


parcelRegister("9S9Cb", function(module, exports) {
$parcel$export(module.exports, "createViewAri", () => $6c29cdb9d8abd803$export$8e9e81ca81fb9409);

var $496yH = parcelRequire("496yH");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $kfvK2 = parcelRequire("kfvK2");
const $6c29cdb9d8abd803$var$useNavigationItemId = (0, $kfvK2.createRouterSelector)((state)=>state.match?.params?.navigationItemId);
const $6c29cdb9d8abd803$export$8e9e81ca81fb9409 = ({ activationId: activationId, cloudId: cloudId, layout: layout, projectId: projectId, viewItemId: viewItemId })=>{
    const layoutPart = layout ? `/layout/${layout}` : '';
    if (projectId) {
        const viewItemIdPart = viewItemId ? `/${viewItemId}` : '';
        return (0, $496yH.JiraViewAri).create({
            activationId: activationId,
            scopeId: `${projectId}/list${viewItemIdPart}${layoutPart}`,
            scopeType: 'project',
            siteId: cloudId
        }).toString();
    }
    return (0, $496yH.JiraViewAri).create({
        activationId: activationId,
        scopeId: `issue-navigator${layoutPart}`,
        scopeType: 'global',
        siteId: cloudId
    }).toString();
};
const $6c29cdb9d8abd803$export$b6b78fb187396ce9 = ({ layout: layout, projectId: projectId })=>{
    const activationId = (0, $f2sjT.useActivationId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const viewItemId = $6c29cdb9d8abd803$var$useNavigationItemId();
    return $6c29cdb9d8abd803$export$8e9e81ca81fb9409({
        activationId: activationId,
        cloudId: cloudId,
        layout: layout,
        projectId: projectId,
        viewItemId: viewItemId
    });
};

});
parcelRegister("496yH", function(module, exports) {
$parcel$export(module.exports, "JiraViewAri", () => $304d171cb4c80fb0$export$259cce321cdbcc);

var $l6thc = parcelRequire("l6thc");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/view/manifest.ts
var $304d171cb4c80fb0$var$jiraViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $l6thc.JiraViewAriResourceOwner),
    resourceType: (0, $l6thc.JiraViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{scopeType}/{scopeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        scopeType: /(global|project|board)/,
        // eslint-disable-line no-useless-escape
        scopeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/view/index.ts
var $304d171cb4c80fb0$export$259cce321cdbcc = class _JiraViewAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._scopeType = opts.resourceIdSegmentValues.scopeType, this._scopeId = opts.resourceIdSegmentValues.scopeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get scopeType() {
        return this._scopeType;
    }
    get scopeId() {
        return this._scopeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.qualifier,
            platformQualifier: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.resourceOwner,
            resourceType: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.scopeType}/${opts.scopeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                scopeType: opts.scopeType,
                scopeId: opts.scopeId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $304d171cb4c80fb0$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $304d171cb4c80fb0$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            scopeType: this.scopeType,
            scopeId: this.scopeId
        };
    }
};

});
parcelRegister("l6thc", function(module, exports) {
$parcel$export(module.exports, "JiraViewAriResourceOwner", () => $f5d0de35c3dbae2a$export$c63cbf12e88f62b6);
$parcel$export(module.exports, "JiraViewAriResourceType", () => $f5d0de35c3dbae2a$export$4b456bf9436bd47e);
// src/jira/view/types.ts
var $f5d0de35c3dbae2a$export$c63cbf12e88f62b6 = "jira", $f5d0de35c3dbae2a$export$4b456bf9436bd47e = "view";

});



parcelRegister("kjRvu", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc3470762a0a247$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f8e6bff17c97922d5fdccd4453b1ac4>>
 * @relayHash 00de152e369f714ec9b678e593c3a3b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eac3ae0c1af4c562b2f8c4ef87c13e9380d10a9063b7f3c57dfc05d73706bb4a
const $7fc3470762a0a247$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilterRefinementEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isFilterRefinementEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "FragmentSpread",
                                    "name": "FilterRefinement"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isFilterRefinementEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 100
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "jqlTerm",
                                                    "value": "assignee"
                                                }
                                            ],
                                            "concreteType": "JiraJqlFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldValues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlFieldValueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "id"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlUserFieldValue"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldValues(first:100,jqlTerm:\"assignee\")"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "eac3ae0c1af4c562b2f8c4ef87c13e9380d10a9063b7f3c57dfc05d73706bb4a",
            "metadata": {},
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7fc3470762a0a247$var$node.hash = "0143d483589ea0ca8646e9717dc2ce36";
var $7fc3470762a0a247$export$2e2bcd8739ae039 = $7fc3470762a0a247$var$node;

});

parcelRegister("2HIMw", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $bdc751863d77333a$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $bdc751863d77333a$export$b99d8b4e19091835);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", () => $bdc751863d77333a$export$1b65799bbeba8a33);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY", () => $bdc751863d77333a$export$2609791ed67e6247);
$parcel$export(module.exports, "defaultOrderFields", () => $bdc751863d77333a$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "sortDirections", () => $bdc751863d77333a$export$73034536b9adc928);
const $bdc751863d77333a$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $bdc751863d77333a$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $bdc751863d77333a$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
const $bdc751863d77333a$export$2609791ed67e6247 = 'ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY';
const $bdc751863d77333a$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $bdc751863d77333a$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});

parcelRegister("lzktc", function(module, exports) {
$parcel$export(module.exports, "getDefaultJqlGin", () => $cc65a5b5e9f5208f$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $cc65a5b5e9f5208f$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $cc65a5b5e9f5208f$export$b968a035fc2aa57b);
$parcel$export(module.exports, "getIssueSearchInput", () => $cc65a5b5e9f5208f$export$7d76295e85a90b29);
$parcel$export(module.exports, "getHydrateJqlInput", () => $cc65a5b5e9f5208f$export$248650a7f669b084);
$parcel$export(module.exports, "isChromelessRoute", () => $cc65a5b5e9f5208f$export$cc6019019381b4fd);
/* eslint-disable jira/import-whitelist */ 
var $82cqT = parcelRequire("82cqT");

var $2QZBX = parcelRequire("2QZBX");

var $hLPih = parcelRequire("hLPih");

var $iRahl = parcelRequire("iRahl");

var $4NoAT = parcelRequire("4NoAT");

var $2HIMw = parcelRequire("2HIMw");
const $cc65a5b5e9f5208f$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $2HIMw.defaultOrderFields).created} ${(0, $2HIMw.sortDirections).DESC}`;
const $cc65a5b5e9f5208f$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey } = params;
    const { filter: filter, jql: jql, selectedIssue: selectedIssue, groupBy: groupBy, hideDone: hideDone } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $hLPih.getDefaultJql)((0, $2QZBX.toProjectKey)(projectKey)) : $cc65a5b5e9f5208f$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: selectedIssue,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql,
        groupBy: groupBy,
        hideDone: hideDone === 'true' || hideDone === 'false' ? hideDone === 'true' : undefined
    };
};
const $cc65a5b5e9f5208f$var$getJqlOrFilterIdOrNull = (jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $82cqT.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $hLPih.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    return null;
};
const $cc65a5b5e9f5208f$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return $cc65a5b5e9f5208f$var$getJqlOrFilterIdOrNull(jqlParam, filter, projectKey) ?? {
        jql: defaultJql
    };
};
const $cc65a5b5e9f5208f$export$7d76295e85a90b29 = (defaultJql, jqlParam, filter, projectKey)=>{
    // When in project scope fallback to searching by last used JQL, otherwise fallback to default JQL.
    const fallback = projectKey ? {
        searchWithLastUsedJql: true
    } : {
        jql: defaultJql
    };
    // Fallback if neither JQL or valid filter parameters have been provided.
    return $cc65a5b5e9f5208f$var$getJqlOrFilterIdOrNull(jqlParam, filter, projectKey) ?? fallback;
};
const $cc65a5b5e9f5208f$export$248650a7f669b084 = ({ activationId: activationId, cloudId: cloudId, defaultJql: defaultJql, jqlParam: jqlParam, filter: filter, projectKey: projectKey })=>{
    // When in project scope fallback to searching by last used JQL, otherwise fallback to default JQL.
    const fallback = projectKey ? {
        lastUsedJqlForIssueNavigator: {
            list: {
                operationScope: (0, $iRahl.NIN_PROJECT_OPERATION_SCOPE),
                projectKey: projectKey
            }
        }
    } : {
        jql: defaultJql
    };
    // Fallback if neither JQL or valid filter parameters have been provided.
    const result = $cc65a5b5e9f5208f$var$getJqlOrFilterIdOrNull(jqlParam, filter, projectKey) ?? fallback;
    // Hydration API expects filterId in ARI format
    if ('filterId' in result) return {
        filterId: (0, $4NoAT.JiraFilterAri).create({
            siteId: cloudId,
            filterId: result.filterId,
            activationId: activationId
        }).toString()
    };
    return result;
};
const $cc65a5b5e9f5208f$export$cc6019019381b4fd = ({ route: route })=>{
    return route.layout?.isChromeless ?? false;
};

});
parcelRegister("hLPih", function(module, exports) {
$parcel$export(module.exports, "isFilterKey", () => $c803067837d15823$export$2cad587bb603edda);
$parcel$export(module.exports, "mapFilterToJql", () => $c803067837d15823$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $c803067837d15823$export$346d50fe8350b1d0);
$parcel$export(module.exports, "getUrlPrefix", () => $c803067837d15823$export$821d4141d135e0d0);

var $b5RwB = parcelRequire("b5RwB");

var $iRahl = parcelRequire("iRahl");

var $64ivx = parcelRequire("64ivx");
const $c803067837d15823$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, $64ivx.Filters);
const $c803067837d15823$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$c803067837d15823$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = (0, $iRahl.DEFAULT_ORDER_FIELD);
    const direction = (0, $iRahl.DEFAULT_SORT_DIRECTION);
    switch((0, $64ivx.Filters)[filter]){
        case (0, $64ivx.Filters).myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${(0, $64ivx.StatusCategoryValues).TO_DO}, ${(0, $64ivx.StatusCategoryValues).IN_PROGRESS})`);
            break;
        case (0, $64ivx.Filters).reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case (0, $64ivx.Filters).allopenissues:
            clauses.push(`statusCategory IN (${(0, $64ivx.StatusCategoryValues).TO_DO}, ${(0, $64ivx.StatusCategoryValues).IN_PROGRESS})`);
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).doneissues:
            clauses.push(`statusCategory = ${(0, $64ivx.StatusCategoryValues).DONE}`);
            break;
        case (0, $64ivx.Filters).recentlyviewed:
            order = (0, $iRahl.defaultOrderFields).lastviewed;
            break;
        case (0, $64ivx.Filters).resolvedrecently:
            clauses.push('resolved >= -1w');
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).updatedrecently:
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).allissues:
            order = (0, $iRahl.defaultOrderFields).created;
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $c803067837d15823$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, $iRahl.DEFAULT_ORDER_FIELD} ${0, $iRahl.DEFAULT_SORT_DIRECTION}`;
const $c803067837d15823$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $b5RwB.parse)(search),
        ...match && match.params
    });
const $c803067837d15823$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});
parcelRegister("64ivx", function(module, exports) {
$parcel$export(module.exports, "Filters", () => $c7fcd0af44be8211$export$92a576f896a9bf72);
$parcel$export(module.exports, "StatusCategoryValues", () => $c7fcd0af44be8211$export$72d6e2acce8f36fd);
const $c7fcd0af44be8211$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $c7fcd0af44be8211$export$72d6e2acce8f36fd = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};

});




parcelRegister("ebWJz", function(module, exports) {
$parcel$export(module.exports, "fieldsResource", () => $f772abfaa17ccd63$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $f772abfaa17ccd63$export$c0cd85886917fe89);

var $cwZUV = parcelRequire("cwZUV");

var $942wy = parcelRequire("942wy");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $9bD5G = parcelRequire("9bD5G");

var $7cmPk = parcelRequire("7cmPk");
const $f772abfaa17ccd63$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f772abfaa17ccd63$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $942wy.GraphQLErrors)(response.errors);
    return (0, $7cmPk.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f772abfaa17ccd63$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $942wy.GraphQLErrors)(response.errors);
    return (0, $7cmPk.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $f772abfaa17ccd63$export$8bca6c1954ae9308 = (0, $l1VxS.createResource)({
    type: $f772abfaa17ccd63$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$f772abfaa17ccd63$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$f772abfaa17ccd63$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $9bD5G.fetchFields)((0, $d414d4047a262b56$export$c378ca4a0e2c9fec), $f772abfaa17ccd63$var$handleOverviewResponse, {
            overviewAri: (0, $cwZUV.JiraProjectOverviewAri).create({
                siteId: cloudId,
                activationId: activationId,
                overviewId: match.params.overviewId
            }).toString()
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $9bD5G.fetchFields)((0, $d414d4047a262b56$export$4d41378da3f70f0f), $f772abfaa17ccd63$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $f772abfaa17ccd63$export$c0cd85886917fe89 = ()=>(0, $eJrcF.useResource)($f772abfaa17ccd63$export$8bca6c1954ae9308);

});
parcelRegister("cwZUV", function(module, exports) {
$parcel$export(module.exports, "JiraProjectOverviewAri", () => $91f880a532f2531d$export$714879003922a622);

var $cTkpI = parcelRequire("cTkpI");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/project-overview/manifest.ts
var $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $cTkpI.JiraProjectOverviewAriResourceOwner),
    resourceType: (0, $cTkpI.JiraProjectOverviewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{overviewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        overviewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/project-overview/index.ts
var $91f880a532f2531d$export$714879003922a622 = class _JiraProjectOverviewAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._overviewId = opts.resourceIdSegmentValues.overviewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get overviewId() {
        return this._overviewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.qualifier,
            platformQualifier: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.resourceOwner,
            resourceType: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.overviewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                overviewId: opts.overviewId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            overviewId: this.overviewId
        };
    }
};

});
parcelRegister("cTkpI", function(module, exports) {
$parcel$export(module.exports, "JiraProjectOverviewAriResourceOwner", () => $962a74da2f17354b$export$d68ef32d028cea3e);
$parcel$export(module.exports, "JiraProjectOverviewAriResourceType", () => $962a74da2f17354b$export$491d1b3b0151dbc4);
// src/jira/project-overview/types.ts
var $962a74da2f17354b$export$d68ef32d028cea3e = "jira", $962a74da2f17354b$export$491d1b3b0151dbc4 = "project-overview";

});


parcelRegister("942wy", function(module, exports) {
$parcel$export(module.exports, "GraphQLErrors", () => $3577b4c37e9af666$export$89c202e66b2de2b6);

var $buoPQ = parcelRequire("buoPQ");

var $4sprp = parcelRequire("4sprp");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $3577b4c37e9af666$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $3577b4c37e9af666$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(graphQLErrors) : [];
        this.message = $3577b4c37e9af666$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("buoPQ", function(module, exports) {

var $4sprp = parcelRequire("4sprp");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $85d5c2cbe671e6d1$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $4sprp(value) ? value : [
        value
    ];
}
module.exports = $85d5c2cbe671e6d1$var$castArray;

});


const $d414d4047a262b56$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $d414d4047a262b56$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("9bD5G", function(module, exports) {
$parcel$export(module.exports, "fetchFields", () => $d910ddfedea9b5ee$export$f3ddd735c360919);

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $d910ddfedea9b5ee$var$PAGE_SIZE = 100;
const $d910ddfedea9b5ee$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $d910ddfedea9b5ee$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("7cmPk", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $532ac776c238882e$export$3ceb62baab058c6b);
const $532ac776c238882e$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});



parcelRegister("gmPbY", function(module, exports) {
$parcel$export(module.exports, "workItemPageEntrypoint", () => $15c6244449723ce2$export$16cd62cd4baaf460);

var $3MgfG = parcelRequire("3MgfG");

var $k46A3 = parcelRequire("k46A3");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");
const $15c6244449723ce2$export$16cd62cd4baaf460 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $k46A3.workItemEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).WORK_ITEM,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("k46A3", function(module, exports) {
$parcel$export(module.exports, "workItemEntrypoint", () => $db2e192c7fe6ed75$export$7776ba0e0fd82365);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $5cBwY = parcelRequire("5cBwY");
const $db2e192c7fe6ed75$var$getIssueKey = (match)=>{
    return match?.params?.issueKey?.length ? match.params.issueKey : null;
};
const $db2e192c7fe6ed75$var$extractProjectKey = (issueKey)=>issueKey.split('-')[0];

const $db2e192c7fe6ed75$export$7776ba0e0fd82365 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("icccT")), {
        moduleId: "d3baaed3",
        moduleName: "WorkItemSanitisedEntrypoint",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = context;
        const issueKey = $db2e192c7fe6ed75$var$getIssueKey(match);
        const projectKey = issueKey ? $db2e192c7fe6ed75$var$extractProjectKey(issueKey) : '';
        // Construct JQL to search for issues in this project
        const jql = projectKey ? `project = "${projectKey}"` : '';
        const queryVariables = {
            cloudId: cloudId || '',
            issueKey: issueKey || '',
            projectKey: projectKey,
            jql: jql
        };
        return {
            queries: {
                workItemQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        ...queryVariables
                    },
                    parameters: $5cBwY.default
                }
            }
        };
    }
});

});
parcelRegister("5cBwY", function(module, exports) {
$parcel$export(module.exports, "default", () => $541e14cccb5a6122$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<72a800b1c75c8eb5d171aa6c7dfc1aa8>>
 * @relayHash e73759bc41c74035fd9f794c71281255
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID df8175abc930f5870aee692a621f62c86ee043f5d288d4dce04e21da6f7e7a6f

var $1NHqW = parcelRequire("1NHqW");

var $1PjiU = parcelRequire("1PjiU");

var $bU8Sj = parcelRequire("bU8Sj");

var $jLDgo = parcelRequire("jLDgo");

var $2INXH = parcelRequire("2INXH");

var $gVub6 = parcelRequire("gVub6");

var $8H46l = parcelRequire("8H46l");
const $541e14cccb5a6122$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "df8175abc930f5870aee692a621f62c86ee043f5d288d4dce04e21da6f7e7a6f",
        "metadata": {},
        "name": "WorkItemEntrypointUiQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": (0, $jLDgo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcremoveissuetypesdforelayprovider": (0, $gVub6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $2INXH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $1NHqW.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcsimplifiedtimetrackingrelayprovider": (0, $8H46l.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default)
        }
    }
};
var $541e14cccb5a6122$export$2e2bcd8739ae039 = $541e14cccb5a6122$var$node;

});

parcelRegister("icccT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("9NARI")
]).then(()=>parcelRequire('25xkK'));

});




parcelRegister("3KT5V", function(module, exports) {
$parcel$export(module.exports, "bootstrapSingleSpaRoute", () => $45972146babe5ea7$export$47472b2829a7e33b);

var $6uWhG = parcelRequire("6uWhG");

var $dVYsb = parcelRequire("dVYsb");
(0, $6uWhG.setMark)('JIRA_SPA_ENTRY_LOADED');

const $45972146babe5ea7$export$47472b2829a7e33b = (getInitialRoutes)=>{
    const loadLazyRoutes = async ()=>new Promise((resolve, reject)=>{
            const cb = ()=>{
                (parcelRequire("cy0H9")).then((mod)=>{
                    resolve(mod.default);
                }).catch((err)=>{
                    reject(err);
                });
            };
            // requestIdleCallback is not supported in Safari, so we need a workaround - won't be ideal for Safari
            // users but better than nothing.
            if (typeof window !== 'undefined' && typeof window.requestIdleCallback !== 'undefined') window.requestIdleCallback(cb);
            else // arbitrary non-zero timeout to push the start of the lazy route load further down the path, but not _too_ far
            setTimeout(cb, 500);
        });
    (0, $dVYsb.startJiraSpa)(getInitialRoutes, loadLazyRoutes);
};

});
parcelRegister("dVYsb", function(module, exports) {
$parcel$export(module.exports, "startJiraSpa", () => $67aea0c62c200796$export$f71867a5b2484020);

var $eJOHy = parcelRequire("eJOHy");

var $jFHCE = parcelRequire("jFHCE");

var $8sbs2 = parcelRequire("8sbs2");

var $88sFB = parcelRequire("88sFB");

var $7vj7p = parcelRequire("7vj7p");

var $36eMW = parcelRequire("36eMW");

var $ceLri = parcelRequire("ceLri");

var $ehjs8 = parcelRequire("ehjs8");

var $4dl6T = parcelRequire("4dl6T");

var $k04JP = parcelRequire("k04JP");

var $f0nBN = parcelRequire("f0nBN");

var $1Q1XT = parcelRequire("1Q1XT");


var $k8mcw = parcelRequire("k8mcw");
parcelRequire("lXp9u");

var $6uWhG = parcelRequire("6uWhG");

var $aYncF = parcelRequire("aYncF");

var $2dBpR = parcelRequire("2dBpR");

var $5vQ2T = parcelRequire("5vQ2T");

var $cxKOj = parcelRequire("cxKOj");

var $3KIqP = parcelRequire("3KIqP");

var $4cTDP = parcelRequire("4cTDP");

var $3Zulo = parcelRequire("3Zulo");

var $hW27F = parcelRequire("hW27F");

var $kQnVX = parcelRequire("kQnVX");

var $hih5V = parcelRequire("hih5V");

var $1PSAp = parcelRequire("1PSAp");

var $e8u2a = parcelRequire("e8u2a");

var $lmqkh = parcelRequire("lmqkh");

var $7grfV = parcelRequire("7grfV");

var $lOI8W = parcelRequire("lOI8W");

var $59viY = parcelRequire("59viY");

var $gNSxk = parcelRequire("gNSxk");

var $ccydf = parcelRequire("ccydf");

var $lZMpx = parcelRequire("lZMpx");

var $aqRAv = parcelRequire("aqRAv");

var $4EKqI = parcelRequire("4EKqI");

var $7kieS = parcelRequire("7kieS");

var $9aXOX = parcelRequire("9aXOX");

var $gOhgJ = parcelRequire("gOhgJ");
var $cV3mH = parcelRequire("cV3mH");

var $MBWwk = parcelRequire("MBWwk");

var $30bwc = parcelRequire("30bwc");
var $83DiZ = parcelRequire("83DiZ");

var $jqynJ = parcelRequire("jqynJ");

var $kfvK2 = parcelRequire("kfvK2");

var $ioEQd = parcelRequire("ioEQd");

var $a0zLT = parcelRequire("a0zLT");

var $9Szlh = parcelRequire("9Szlh");

var $ceCro = parcelRequire("ceCro");

var $5eRs1 = parcelRequire("5eRs1");
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;
(0, $gOhgJ.LooselyLazy).init({
    mode: (0, $5eRs1.getIsSsrHydrationEnabled)() ? (0, $cV3mH.MODE).HYDRATE : (0, $cV3mH.MODE).RENDER,
    crossOrigin: 'anonymous',
    // hide fg access from eslint, we can do it on "pure client
    react18: true,
    usePostTaskPhases: (()=>(0, $4cTDP.fg)('jfp-jira-remove-rll-subscriptions'))(),
    trackDuplicateLazyIds: (()=>(0, $4cTDP.fg)('jfp-magma-rll-track-duplicated-lazy-ids'))(),
    htmlPlaceholders: (()=>(0, $4cTDP.fg)('jfp_magma_jira-rll-html-placeholder'))(),
    markedForPreload: (()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        (0, $4cTDP.fg)('jfp_magma_jira-rll-client-preload') ? window.SPA_STATE?.rll_preload : undefined)()
});

const $67aea0c62c200796$var$getMessages = ()=>{
    (0, $6uWhG.setMark)('jira-spa/language-pack.start');
    const messages = (parcelRequire("hXmA9"));
    (0, $6uWhG.setMark)('jira-spa/language-pack.end');
    return messages;
};
const $67aea0c62c200796$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    if ((0, $4cTDP.fg)('remove_deferred_class_remove')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    {
        if (document.body?.classList.contains('deferred')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.remove('deferred');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body && document.body.classList.remove('deferred');
};
const $67aea0c62c200796$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $67aea0c62c200796$var$InstallGlobalComponentsOnce = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('remove_priority_ranking_for_global_spa')) (0, $9Szlh.default).installLowPrioritySPAApps();
        else (0, $9Szlh.default).installLowPriorityAppsOld(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))($67aea0c62c200796$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $6uWhG.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
// this will move low priority apps to after TTAI (currently just the async-profilecard (legacy profilecard, only used on legacy experiences like GIN and legacy GIC))
const $67aea0c62c200796$var$LoadPhaseSwitcher = ()=>{
    if ((0, $4cTDP.fg)('remove_priority_ranking_for_global_spa')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MBWwk.BackgroundPriority), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$InstallGlobalComponentsOnce, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zulo.NonCritical), {
        id: "spa-main.client-router.non-critical",
        teamName: "delorean-spa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$InstallGlobalComponentsOnce, null));
};
const $67aea0c62c200796$var$updateCapability = (capability)=>{
    (0, $k8mcw.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $652f5f63189f3e2a$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $652f5f63189f3e2a$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $652f5f63189f3e2a$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $67aea0c62c200796$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $83DiZ.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search, '');
        $67aea0c62c200796$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $hih5V.useCurrentRoute)();
    $67aea0c62c200796$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $67aea0c62c200796$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
    (0, $36eMW.collectSSRPlaceholderDimensions)(document, window, true);
    (0, $aqRAv.default)();
    (0, $1Q1XT.initBrowserMetrics3)();
    (0, $3KIqP.initPlatformFeatureFlags)((0, $9aXOX.visualRefreshResolverOverride));
    (0, $a0zLT.initEntryPointConfig)();
    (0, $7kieS.getClientReceiver)();
    (0, $59viY.addInitialPageLoadTimings)();
    (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $6uWhG.setMark)('jira-spa/setup.start');
    const routes = (0, $lOI8W.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
    const history = (0, $lOI8W.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $ccydf.default)(routes));
    const initRoute = (0, $lOI8W.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $30bwc.default)(routes, window.location.pathname, window.location.search);
        (0, $kQnVX.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $7vj7p.default)(initRoute.route);
        (0, $ceLri.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $hih5V.useCurrentRoute)();
        (0, $k04JP.browserMetrics).setRoute(route.name);
        (0, $ehjs8.useUFOTransitionCompleter)();
        (0, $ioEQd.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    (0, $ioEQd.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    const messages = $67aea0c62c200796$var$getMessages();
    const tenantContext = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { locale: locale } = tenantContext;
    const routerProps = {
        history: history,
        routes: routes,
        basePath: '',
        initialRoute: initRoute?.route,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resourceData: window.SPA_STATE,
        resourceContext: (0, $lZMpx.getSpaRouterContext)({
            tenantContext: tenantContext
        }),
        onPrefetch: ({ route: route, match: match })=>{
            (0, $gNSxk.setPrefetchStartMark)(match);
            if (!route.forPaint) return;
            route.forPaint.map((component)=>component.preload && component.preload());
        },
        isLazyRoutes: typeof loadLazyRoutes === 'function'
    };
    const SpaClientRouterTemplate = ({ children: children, trackedRoutes: trackedRoutes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmqkh.SpaRouter), {
            routerProps: routerProps,
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqynJ.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$CapabilityTrackerConnector, {
                routes: trackedRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7grfV.default), null)),
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$LoadPhaseSwitcher, null)
        }, children);
    let SpaClientRouter;
    if (typeof loadLazyRoutes === 'function') {
        const useRouterRoutes = (0, $kfvK2.createRouterSelector)((state)=>state.routes);
        SpaClientRouter = ({ children: children })=>{
            const actions = (0, $kfvK2.useRouterStoreActions)();
            const currentRoutes = useRouterRoutes();
            (0, $eJOHy.useEffect)(()=>{
                let isCancelled = false;
                const loadRoutes = async ()=>{
                    if (!isCancelled) {
                        const getLazyRoutes = await loadLazyRoutes();
                        await actions.setRoutes(getLazyRoutes());
                    }
                };
                loadRoutes();
                return ()=>{
                    isCancelled = true;
                };
            }, [
                actions
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpaClientRouterTemplate, {
                trackedRoutes: currentRoutes
            }, children);
        };
    } else SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpaClientRouterTemplate, {
            trackedRoutes: routes
        }, children);
    const AppWithoutPlaceholders = ({ entryPointPlaceholders: entryPointPlaceholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointPlaceholderContext).Provider, {
            value: entryPointPlaceholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hW27F.Spa), {
            locale: locale,
            messages: messages,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $e8u2a.JiraRouterLinkConfiguration)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $6uWhG.setMark)('_jira-spa/spa-shell.start');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('jira-frontend');
    if (container) {
        (0, $4dl6T.getVCObserver)().setSSRElement(container);
        (0, $4dl6T.getVCObserver)().setReactRootRenderStart();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                (0, $4dl6T.getVCObserver)().setReactRootRenderStop();
            });
        });
        const entryPointPlaceholders = (0, $2dBpR.getPlaceholdersFromHTML)();
        (0, $5eRs1.renderReactApp)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AppWithoutPlaceholders, {
            entryPointPlaceholders: entryPointPlaceholders
        }), {
            isSsrHydrationEnabled: (0, $5eRs1.getIsSsrHydrationEnabled)(),
            container: container
        });
    }
    (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
    (0, $6uWhG.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
    setTimeout(()=>{
        (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
    });
    if ((0, $cxKOj.expVal)('uip_preprod_slow', 'value', 0) > 0) {
        (0, $6uWhG.setMark)('slow-start');
        const end = performance.now() + (0, $cxKOj.expVal)('uip_preprod_slow', 'value', 0);
        while(performance.now() < end);
        (0, $6uWhG.setMark)('slow-stop');
    }
    if ((0, $4cTDP.fg)('remove_priority_ranking_for_global_spa')) (0, $9Szlh.default).installHighPrioritySPAApps();
    else (0, $9Szlh.default).installHighPriorityAppsOld(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
    (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))($67aea0c62c200796$var$globalSettingsArgs, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
    if (initRoute?.route?.bifrost?.circuitBreakerConfig) (0, $88sFB.setCircuitBreakerOnIdle)(initRoute.route.bifrost.circuitBreakerConfig);
    $67aea0c62c200796$var$superbatchInit();
    return null;
};
const $67aea0c62c200796$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
    // In React 18: 500ms is the default value internally in react-dom
    // In React 19: 300ms is the default value
    // In React 19.2: This value becomes dynamic https://react.dev/blog/2025/10/01/react-19-2
    //
    // Based of our experiment (`jfp-magma-initial-react-fallback-throttle-ms`), 100ms appears to be the optimal value for Jira *at this point in time*
    // It can and should be removed or tweaked when we upgrade React
    globalThis.REACT_FALLBACK_THROTTLE_MS = 100;
    return $67aea0c62c200796$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>(0, $f0nBN.reportBootstrapError)(reason)).finally(()=>{
        (0, $ceCro.reportUnreportedStatsigInitialisationError)();
    });
};

});
parcelRegister("88sFB", function(module, exports) {
$parcel$export(module.exports, "setCircuitBreakerOnIdle", () => $a53225ed6e432827$export$811391ccc8baa1bb);

var $6XSXq = parcelRequire("6XSXq");

var $gOhYy = parcelRequire("gOhYy");

var $1qiFJ = parcelRequire("1qiFJ");

var $ihUH3 = parcelRequire("ihUH3");

var $3swLF = parcelRequire("3swLF");
function $a53225ed6e432827$export$811391ccc8baa1bb({ isSetCookieEnabled: isSetCookieEnabled, cookieKey: cookieKey, windowSize: windowSize, threshold: threshold, keepOpenCount: keepOpenCount, halfOpenForCount: halfOpenForCount }) {
    if (isSetCookieEnabled) (0, $6XSXq.callWhenIdle)(async ()=>{
        await (0, $gOhYy.initControlsOnce)();
        const circuitBreaker = new (0, $1qiFJ.CookieCircuitBreaker)({
            cookieKey: cookieKey,
            windowSize: windowSize,
            threshold: threshold,
            keepOpenCount: keepOpenCount,
            halfOpenForCount: halfOpenForCount,
            version: (0, $3swLF.getCookieCircuitBreakerKillswitch)() ?? 0
        });
        const didVersionMismatch = circuitBreaker.resetCookieIfVersionMismatch();
        // Do not record a pass/fail if we just reset the cookie incase it failed due
        // to the circuit breaker being OPEN
        if (!didVersionMismatch) {
            if ((0, $ihUH3.didSSRSucceed)()) circuitBreaker.recordPass();
            else circuitBreaker.recordFailure();
        }
    }, 1000);
}

});
parcelRegister("6XSXq", function(module, exports) {
$parcel$export(module.exports, "callWhenIdle", () => $8638770e300a4099$export$d2542992df1e054);
const $8638770e300a4099$export$d2542992df1e054 = (callback, timeout = 200)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const callbackId = window.requestIdleCallback(callback);
        return ()=>cancelIdleCallback(callbackId);
    }
    const timer = setTimeout(callback, timeout);
    return ()=>{
        clearTimeout(timer);
    };
};

});

parcelRegister("gOhYy", function(module, exports) {
$parcel$export(module.exports, "initControlsOnce", () => $d1edc620a3250b22$export$1120113854b04415);

var $foP3h = parcelRequire("foP3h");

var $4cTDP = parcelRequire("4cTDP");

var $lopBx = parcelRequire("lopBx");

var $SvJbY = parcelRequire("SvJbY");
let $d1edc620a3250b22$var$initializeControlsPromise = null;
function $d1edc620a3250b22$export$1120113854b04415() {
    if (!$d1edc620a3250b22$var$initializeControlsPromise) {
        if ((0, $4cTDP.fg)('fedramp-cookies-controls')) $d1edc620a3250b22$var$initializeControlsPromise = (0, $foP3h.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration'),
            perimeter: (0, $lopBx.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        });
        else $d1edc620a3250b22$var$initializeControlsPromise = (0, $foP3h.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')
        });
    }
    return $d1edc620a3250b22$var$initializeControlsPromise;
}
(0, $SvJbY.autoBeforeEachTest)(()=>{
    $d1edc620a3250b22$var$initializeControlsPromise = null;
});

});
parcelRegister("foP3h", function(module, exports) {
$parcel$export(module.exports, "initializeControls", () => $168cc5db941182c4$export$919040c32a62c7db);

var $eGOwo = parcelRequire("eGOwo");

var $lgusX = parcelRequire("lgusX");
var $cnsbg = parcelRequire("cnsbg");
var $60vYG = parcelRequire("60vYG");

var $9SIye = parcelRequire("9SIye");

var $48TwY = parcelRequire("48TwY");

var $j1fM9 = parcelRequire("j1fM9");

var $BwKrm = parcelRequire("BwKrm");
const $168cc5db941182c4$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch')) // Exit if the master killswitch is enabled
    return;
    try {
        (0, $60vYG.Logger).debug('initializeControls invoked');
        (0, $9SIye.initializeGlobalState)(args);
        // Exit silently if in SSR context
        if ((0, $cnsbg.isSSR)()) return;
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $lgusX.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $j1fM9.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $9SIye.getBscGlobalState)().webStorageEnabled;
        if (!isWebStorageControlsEnabled) return;
        await (0, $BwKrm.createWebStoragePassthrough)((0, $48TwY.WebStorageType).LocalStorage);
        await (0, $BwKrm.createWebStoragePassthrough)((0, $48TwY.WebStorageType).SessionStorage);
        (0, $60vYG.Logger).debug('initiizeControls finished');
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
};

});
parcelRegister("j1fM9", function(module, exports) {
$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $541abd0651a2b5d0$export$45a5573b04db016c);

var $60vYG = parcelRequire("60vYG");

var $3vEqp = parcelRequire("3vEqp");
const $541abd0651a2b5d0$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $60vYG.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $3vEqp.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

});
parcelRegister("3vEqp", function(module, exports) {
$parcel$export(module.exports, "getSetCookieOverride", () => $4ef4c414d4228396$export$b7364c41ddbfdb0a);

var $9SIye = parcelRequire("9SIye");
var $lgusX = parcelRequire("lgusX");

var $15Ffx = parcelRequire("15Ffx");

var $60vYG = parcelRequire("60vYG");

var $6T1aH = parcelRequire("6T1aH");
const $4ef4c414d4228396$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $lgusX.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $9SIye.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, $15Ffx.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $9SIye.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else return;
                    },
                    storageType: (0, $6T1aH.CategoryStorageType).Cookies,
                    productName: productName
                });
            } catch (e) {
                (0, $60vYG.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

});


parcelRegister("BwKrm", function(module, exports) {
$parcel$export(module.exports, "createWebStoragePassthrough", () => $baadcedace958be2$export$619fe705922e5d61);

var $60vYG = parcelRequire("60vYG");

var $9lTmU = parcelRequire("9lTmU");

var $48TwY = parcelRequire("48TwY");

var $cNZBN = parcelRequire("cNZBN");
const $baadcedace958be2$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $48TwY.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $60vYG.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $9lTmU.BSCIndexedDB).isAvailable) {
        (0, $60vYG.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $9lTmU.BSCIndexedDB).isBooted) // If we've yet to invoke booting of the IDB service, ensure we do it here.
    await (0, $9lTmU.BSCIndexedDB).boot();
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $cNZBN.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, $48TwY.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

});
parcelRegister("cNZBN", function(module, exports) {
$parcel$export(module.exports, "setItemOverride", () => $95d8570d242f6eee$export$b4469df6294ea6aa);

var $9SIye = parcelRequire("9SIye");
var $lgusX = parcelRequire("lgusX");

var $15Ffx = parcelRequire("15Ffx");

var $60vYG = parcelRequire("60vYG");

var $48TwY = parcelRequire("48TwY");

var $6T1aH = parcelRequire("6T1aH");
const $95d8570d242f6eee$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        bscStorage.checkIfSetByPackage({
            itemKey: originalItemKey,
            isSetCallback: ()=>{
                itemSetByPackage = true;
            },
            isNotSetCallback: ()=>{
                // Note: This is async and could fail, but if the call errors out in IDB,
                // it will forcibly resolve to false here, so we're not catching the error again here ✅
                itemSetByPackage = false;
            }
        });
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                }
            });
        }
        try {
            (0, $lgusX.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType
                }
            });
            try {
                const productName = (0, $9SIye.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, $15Ffx.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ()=>{
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $9SIye.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else return;
                    },
                    storageType: storageType === (0, $48TwY.WebStorageType).LocalStorage ? (0, $6T1aH.CategoryStorageType).LocalStorage : (0, $6T1aH.CategoryStorageType).SessionStorage,
                    productName: productName
                });
            } catch (e) {
                (0, $60vYG.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType
                    }
                });
            }
        } catch (e) {
            (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`
            });
        }
    };

});




parcelRegister("ihUH3", function(module, exports) {
$parcel$export(module.exports, "didSSRSucceed", () => $d2ead6a58acfc1b9$export$581f5d7058f82eac);
function $d2ead6a58acfc1b9$export$581f5d7058f82eac() {
    const traceData = globalThis.window?.SPA_STATE?.['ssr/detail_request_trace']?.data;
    if (!traceData) return false;
    const prefetchTimedOut = Object.values(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    traceData).some((x)=>x.failureReason === 'timeout');
    return !prefetchTimedOut && // Static fallback is returned when there is the 2.7s timeout of SSR
    !globalThis.window.__SSR_FALLBACK__;
}

});

parcelRegister("3swLF", function(module, exports) {
$parcel$export(module.exports, "getCookieCircuitBreakerKillswitch", () => $30d59d2b2dcb503a$export$10bf444f24046dfd);

var $59rsN = parcelRequire("59rsN");

var $11lp0 = parcelRequire("11lp0");
function $30d59d2b2dcb503a$export$10bf444f24046dfd() {
    // This function is not called on SSR.
    if (false) return null;
    (0, $11lp0.UNSAFE_initIfNeeded)();
    /*
	 * not using the util because:
	 * - this is a dynamic config
	 * - only evaluated once per full page load, so cache is not needed
	 * - never evaluated on SSR, so no need for deferring __SSR_SYNC_READ_EXP_VAL__
	 *   instead of initing flags
	 */ // eslint-disable-next-line jira/ff/use-recommended-utils
    const value = (0, $59rsN.default).getExperimentValue('cookie-cb-reset', 'value', 0, {
        fireExperimentExposure: false
    });
    if (value && Number.isFinite(value)) return value;
    return null;
}

});


parcelRegister("7vj7p", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbba9e9eb041b2da$export$2e2bcd8739ae039);
function $fbba9e9eb041b2da$var$getUFORouteName(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}
var $fbba9e9eb041b2da$export$2e2bcd8739ae039 = $fbba9e9eb041b2da$var$getUFORouteName;

});

parcelRegister("36eMW", function(module, exports) {
$parcel$export(module.exports, "collectSSRPlaceholderDimensions", () => $51fe57b9f110559d$export$aee7516e57289027);
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $51fe57b9f110559d$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = $51fe57b9f110559d$var$getEffectiveBoundingRect(elem, window);
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = $51fe57b9f110559d$var$getEffectiveBoundingRect(pageLayoutRoot, window);
        }
    }
}
/**
 * Gets the effective bounding rectangle for an element, handling display: contents elements
 * by collecting dimensions from their children instead
 */ function $51fe57b9f110559d$var$getEffectiveBoundingRect(elem, window) {
    const computedStyle = window.getComputedStyle(elem);
    // If element has display: contents, collect bounding rect from children
    if (computedStyle.display === 'contents') {
        const children = Array.from(elem.children);
        if (children.length === 0) // No children, return zero rect
        return new DOMRect(0, 0, 0, 0);
        // Calculate union of all children's bounding rects
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        children.forEach((child)=>{
            const childRect = child.getBoundingClientRect();
            // Skip children with zero dimensions (likely also display: contents)
            if (childRect.width > 0 || childRect.height > 0) {
                minX = Math.min(minX, childRect.left);
                minY = Math.min(minY, childRect.top);
                maxX = Math.max(maxX, childRect.right);
                maxY = Math.max(maxY, childRect.bottom);
            }
        });
        // If no children with dimensions found, return zero rect
        if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
        return new DOMRect(minX, minY, maxX - minX, maxY - minY);
    }
    // Normal element, return its bounding rect
    return elem.getBoundingClientRect();
}

});

parcelRegister("ceLri", function(module, exports) {
$parcel$export(module.exports, "default", () => $d22cc26ef17eca28$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updatePageloadName", () => $d22cc26ef17eca28$export$d0f99433cd4f4028);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $fiPhB = parcelRequire("fiPhB");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $kTRgU = parcelRequire("kTRgU");
const $d22cc26ef17eca28$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $d22cc26ef17eca28$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $2QO3b.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $kTRgU.default).current = routeName || null;
    const rate = ufoName ? (0, $jcIvM.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $2oAAJ.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $aXKmr.v4)();
        (0, $kVpZx.DefaultInteractionID).current = newId;
        (0, $2QO3b.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $fiPhB.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $2QO3b.addHoldByID)(newId, [], $d22cc26ef17eca28$var$AWAITING_PAGELOAD_NAME, $d22cc26ef17eca28$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $2QO3b.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $2QO3b.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $2QO3b.removeHoldByID)(activeInteraction.id, $d22cc26ef17eca28$var$AWAITING_PAGELOAD_NAME);
    }
}
var $d22cc26ef17eca28$export$2e2bcd8739ae039 = $d22cc26ef17eca28$var$traceUFOPageLoad;
function $d22cc26ef17eca28$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $2QO3b.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $jcIvM.getInteractionRate)(ufoName, 'page_load');
        (0, $2QO3b.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $2oAAJ.default)(rate)) (0, $kTRgU.default).current = ufoName;
        else (0, $2QO3b.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $2QO3b.removeHoldByID)(interaction.id, $d22cc26ef17eca28$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("f0nBN", function(module, exports) {
$parcel$export(module.exports, "reportBootstrapError", () => $58510e6dcc5284d7$export$a5c16644a2d3c205);

var $9pTd3 = parcelRequire("9pTd3");

var $exfGR = parcelRequire("exfGR");

var $mjinE = parcelRequire("mjinE");

var $lpMrC = parcelRequire("lpMrC");

var $aYncF = parcelRequire("aYncF");


var $fEmyV = parcelRequire("fEmyV");
const $58510e6dcc5284d7$export$649804097de83b3b = [
    // https://jplat.jira.atlassian.cloud/browse/MAGMA-2440
    {
        browser: 'Chrome',
        browserVersion: '116.0.0',
        errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
    }
];
const $58510e6dcc5284d7$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $lpMrC.getBrowser)().name === filterCriteria.browser : true;
const $58510e6dcc5284d7$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $lpMrC.getBrowser)().version === filterCriteria.browserVersion : true;
const $58510e6dcc5284d7$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
const $58510e6dcc5284d7$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
    try {
        // condition checkers must return true if they don't apply, so an empty filterCriteria will match (and block) ALL errors
        const conditionCheckers = [
            $58510e6dcc5284d7$var$checkBrowserCondition,
            $58510e6dcc5284d7$var$checkBrowserVersionCondition,
            $58510e6dcc5284d7$var$checkErrorMessageCondition
        ];
        // Should send analytics if no filtering conditions are met
        return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
    } catch (e) {
        // If any error occurs during filtering, experience analytics should still be sent
        return true;
    }
};
const $58510e6dcc5284d7$export$a5c16644a2d3c205 = async (error)=>{
    const tenantContextData = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // We probably already have analytics initialised but we could have failed earlier than it
    (0, $exfGR.default)(tenantContextData);
    // Experience analytics should only be sent if it is not filtered
    if ($58510e6dcc5284d7$export$a66ce4bea8340820(error, $58510e6dcc5284d7$export$649804097de83b3b)) (0, $mjinE.default)({
        analyticsSource: (0, $60d311439a302207$export$c9e16a15d65437),
        experience: (0, $60d311439a302207$export$b1534bc11f201efd),
        wasExperienceSuccesful: false,
        location: (0, $60d311439a302207$export$7dfef0177e883b05),
        application: (0, $60d311439a302207$export$aa6008fe0169b864),
        edition: (0, $60d311439a302207$export$39418a21fbb51487),
        additionalAttributes: (0, $fEmyV.routeAnalyticsAttributes)
    });
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            packageName: 'jiraBootstrapSlaReporter',
            id: 'bootstrap-failure',
            teamName: 'nike'
        },
        error: error,
        attributes: (0, $fEmyV.routeAnalyticsAttributes)
    });
    throw error;
};

});
const $60d311439a302207$export$c9e16a15d65437 = 'navigationNext';
const $60d311439a302207$export$b1534bc11f201efd = 'jiraPageContainer';
const $60d311439a302207$export$fa4bbc89fd1f1a7 = null;
const $60d311439a302207$export$aa6008fe0169b864 = null;
const $60d311439a302207$export$39418a21fbb51487 = null;
const $60d311439a302207$export$7dfef0177e883b05 = 'entry.jira-spa';
const $60d311439a302207$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $60d311439a302207$export$7114284ca03133ee = `_${$60d311439a302207$var$PAGE_CONTAINER_MARK}.end`;
const $60d311439a302207$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $60d311439a302207$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $60d311439a302207$export$e2bc63118050de32 = `_${$60d311439a302207$export$898b6208220685b0}.start`;
const $60d311439a302207$export$59f83d43fe209319 = `_${$60d311439a302207$export$898b6208220685b0}.end`;
const $60d311439a302207$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $60d311439a302207$export$c20831be6f780cb5 = `_${$60d311439a302207$export$fb9876ab4228d985}.start`;
const $60d311439a302207$export$398df1bca49f9884 = `_${$60d311439a302207$export$fb9876ab4228d985}.end`;
const $60d311439a302207$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $60d311439a302207$export$3c2d8af5c7577fe7 = `_${$60d311439a302207$export$7048c99f32c60b34}.start`;
const $60d311439a302207$export$aac77afee74c49d0 = `_${$60d311439a302207$export$7048c99f32c60b34}.end`;
const $60d311439a302207$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $60d311439a302207$export$16e7ead3a8b5c366 = `_${$60d311439a302207$export$4f341d86a3c214}.start`;
const $60d311439a302207$export$c389f0b50840d5ca = `_${$60d311439a302207$export$4f341d86a3c214}.end`;

parcelRegister("fEmyV", function(module, exports) {
$parcel$export(module.exports, "routeAnalyticsAttributes", () => $4b8de68fd53e342b$export$c71778b3a4356b04);

var $kQnVX = parcelRequire("kQnVX");

var $7A5g5 = parcelRequire("7A5g5");
const $4b8de68fd53e342b$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $kQnVX.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $kQnVX.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $kQnVX.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $7A5g5.getIsProjectAdmin)
    },
    bifrostGroup: {
        enumerable: true,
        get: (0, $kQnVX.getBifrostGroup)
    },
    ufoName: {
        enumerable: true,
        get: (0, $kQnVX.getUfoName)
    }
});

});


parcelRegister("lXp9u", function(module, exports) {
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $awqaz = parcelRequire("awqaz");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("3avtZ"));
    const isDevMode = false;
    (0, $awqaz.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $awqaz.default).batchUpdates = !false;
    Object.freeze((0, $awqaz.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("3avtZ", function(module, exports) {
const $24eaba0df287b1ab$var$style = document.createElement('style');
$24eaba0df287b1ab$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-focused,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-focused,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ul style:first-child~*+ul,ol ul:not(:first-child),ol style:first-child~*+ul,ul ol:not(:first-child),ul style:first-child~*+ol,ol ol:not(:first-child),ol style:first-child~*+ol{margin-top:var(--ds-space-050,4px)}p:first-child,style:first-child+p,ul:first-child,style:first-child+ul,ol:first-child,style:first-child+ol,dl:first-child,style:first-child+dl,h1:first-child,style:first-child+h1,h2:first-child,style:first-child+h2,h3:first-child,style:first-child+h3,h4:first-child,style:first-child+h4,h5:first-child,style:first-child+h5,h6:first-child,style:first-child+h6,blockquote:first-child,style:first-child+blockquote,pre:first-child,style:first-child+pre,form:first-child,style:first-child+form,table:first-child,style:first-child+table{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,ui-monospace,Menlo,"Segoe UI Mono","Ubuntu Mono",monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:var(--ds-border-width,1px)var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{color-scheme:light}[data-color-mode=dark]{color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:var(--ds-border-width-selected,2px)solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,style:first-child+td,th:first-child,style:first-child+th{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($24eaba0df287b1ab$var$style);

});


parcelRegister("3KIqP", function(module, exports) {
$parcel$export(module.exports, "initPlatformFeatureFlags", () => $ed64a16fdeb4cbad$export$2d291317456ada16);

var $eGOwo = parcelRequire("eGOwo");

var $4cTDP = parcelRequire("4cTDP");

var $bi9FK = parcelRequire("bi9FK");
const $ed64a16fdeb4cbad$export$2d291317456ada16 = ([isOverride, resolver])=>{
    (0, $eGOwo.setBooleanFeatureFlagResolver)((flagKey)=>// disable existence check as platform feature >flags< might not be gates
        (0, $4cTDP.withoutFeatureExistenceCheck)(()=>isOverride(flagKey) ? resolver(flagKey) : (0, $4cTDP.fg)(flagKey) || (0, $bi9FK.ff)(flagKey)));
};

});
parcelRegister("bi9FK", function(module, exports) {
$parcel$export(module.exports, "ff", () => $af7a0b2e539364ac$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $af7a0b2e539364ac$export$757bc67afadef4a0);
$parcel$export(module.exports, "getFeatureFlagValue", () => $af7a0b2e539364ac$export$7064bb599f663d7e);

var $4iJGP = parcelRequire("4iJGP");

var $6eHOp = parcelRequire("6eHOp");

var $9DwQv = parcelRequire("9DwQv");

var $4ajKf = parcelRequire("4ajKf");
function $af7a0b2e539364ac$export$a6dcfcb59016e126(featureFlagName, defaultValue) {
    const client = (0, $4ajKf.getFeatureFlagClient)();
    const flag = client.getFlagEvaluation(featureFlagName, {
        default: defaultValue
    });
    if (!flag) return defaultValue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flag.value;
}
const $af7a0b2e539364ac$var$getBooleanFeatureFlagUsingClient = (featureFlagName, defaultValue)=>{
    const client = (0, $4ajKf.getFeatureFlagClient)();
    return client.getBooleanValue(featureFlagName, {
        default: defaultValue,
        shouldTrackExposureEvent: false
    });
};
const $af7a0b2e539364ac$var$getMultivariateFeatureFlagUsingClient = (featureFlagName, defaultValue, possibleValues)=>{
    const client = (0, $4ajKf.getFeatureFlagClient)();
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'T'.
    return client.getVariantValue(featureFlagName, {
        default: defaultValue,
        // @ts-expect-error - TS2322 - Type 'T[]' is not assignable to type 'string[]'.
        oneOf: possibleValues,
        shouldTrackExposureEvent: false
    });
};
/**
 * The feature flag client can be configured to fire automatic exposure events when evaluating
 * feature flag values. For the Track All Changes project, we need all flag evaluations to go
 * through this client so that we can collect these events for all feature flags.
 * See https://hello.atlassian.net/browse/FD-18145 for more information.
 */ const $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations = ()=>(0, $9DwQv.isAutomaticExposureCollectionEnabled)();
const $af7a0b2e539364ac$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$var$getBooleanFeatureFlagUsingClient : (0, $6eHOp.ff);
    const value = impl(featureFlagName, defaultValue);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
};
function $af7a0b2e539364ac$export$757bc67afadef4a0(featureFlagName, defaultValue, possibleValues) {
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$var$getMultivariateFeatureFlagUsingClient : (0, $6eHOp.getMultivariateFeatureFlag);
    const value = impl(featureFlagName, defaultValue, possibleValues);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
}
function $af7a0b2e539364ac$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$export$a6dcfcb59016e126 : (0, $6eHOp.getFeatureFlagValue);
    const value = impl(featureFlagName, defaultValue);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return impl(featureFlagName, defaultValue);
}

});
parcelRegister("6eHOp", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagValue", () => $da6d0b5f6a4027e4$export$7064bb599f663d7e);
$parcel$export(module.exports, "ff", () => $da6d0b5f6a4027e4$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $da6d0b5f6a4027e4$export$757bc67afadef4a0);
function $da6d0b5f6a4027e4$export$7064bb599f663d7e(_featureFlagName, defaultValue) {
    return defaultValue;
}
const $da6d0b5f6a4027e4$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const flagValue = $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, defaultValue);
    const isValid = typeof flagValue === 'boolean';
    return isValid ? flagValue : defaultValue;
};
const $da6d0b5f6a4027e4$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues)=>{
    const flagValue = $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    defaultValue);
    const isValid = typeof flagValue === 'string' && possibleValues.includes(flagValue);
    return isValid ? flagValue : defaultValue;
};

});

parcelRegister("4ajKf", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagClient", () => $236e6674104348c2$export$43a6e0552eef5ca9);

var $LFmXM = parcelRequire("LFmXM");
parcelRequire("3HGde");
var $luZJ4 = parcelRequire("luZJ4");

var $j500r = parcelRequire("j500r");

var $2Mqjh = parcelRequire("2Mqjh");
const $236e6674104348c2$var$getAnalyticsClientInstance = ()=>(0, $2Mqjh.getAnalyticsWebClientPromise)().then((analyticsClient)=>analyticsClient.getInstance());
const $236e6674104348c2$var$createFeatureFlagClient = ()=>{
    const client = new (0, $luZJ4.default)({
        analyticsHandler: {
            sendOperationalEvent: async (event)=>{
                if (!false) $236e6674104348c2$var$getAnalyticsClientInstance().then((analyticsClient)=>{
                    // SSR doesn't have an analytics client
                    if (!analyticsClient) return;
                    // customize event data here if needed
                    analyticsClient.sendOperationalEvent(event);
                });
            }
        },
        flags: undefined
    });
    return client;
};
const $236e6674104348c2$var$featureFlagClient = $236e6674104348c2$var$createFeatureFlagClient();
const $236e6674104348c2$var$getFeatureFlags = ()=>{
    const flags = (0, $j500r.default)();
    if (Object.keys(flags).length === 0) {
        if (false) {
            const err = new Error("Feature flags are not available yet. The feature flag client can't be initialized");
            // print out the stack trace for SSR, so we can have better understanding on
            // which module is using the client too early.
            // in SSR, we use bunyan to replace the console.error, so we can use the standard
            // log format for apps.
            // eslint-disable-next-line no-console
            console.error({
                err: err
            });
        } else // eslint-disable-next-line no-console
        console.error("Feature flags are not available yet. The feature flag client can't be initialized");
    }
    return flags;
};
const $236e6674104348c2$var$configureFeatureFlagClient = ()=>{
    const flags = $236e6674104348c2$var$getFeatureFlags();
    // @ts-expect-error - TS2345 - Argument of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/utils/feature-flagging-using-meta/src/common/types").Flags' is not assignable to parameter of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/feature-flag-client/dist/types/types").Flags'.
    $236e6674104348c2$var$featureFlagClient.setFlags(flags);
    if (!false) $236e6674104348c2$var$featureFlagClient.setIsAutomaticExposuresEnabled(true);
    return $236e6674104348c2$var$featureFlagClient;
};
// NOTE: `memoizeOne` is doing unnecessary checks, what we need in this file is
// a simple local variable implementation, if local variable doesn't exist then
// create it.
const $236e6674104348c2$var$getMemoizedFeatureFlagClient = (0, $LFmXM.default)($236e6674104348c2$var$configureFeatureFlagClient);
let $236e6674104348c2$var$builtFeatureFlagClient;
const $236e6674104348c2$export$43a6e0552eef5ca9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled === true) {
        if (typeof $236e6674104348c2$var$builtFeatureFlagClient === 'undefined' || globalVar.invalidateFeatureFlagsClient_DO_NOT_USE === true) {
            globalVar.invalidateFeatureFlagsClient_DO_NOT_USE = false;
            $236e6674104348c2$var$builtFeatureFlagClient = (0, $LFmXM.default)($236e6674104348c2$var$configureFeatureFlagClient);
        }
        return $236e6674104348c2$var$builtFeatureFlagClient();
    }
    return $236e6674104348c2$var$getMemoizedFeatureFlagClient();
};

});
parcelRegister("3HGde", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("luZJ4")).default);

var $luZJ4 = parcelRequire("luZJ4");

var $l27Vv = parcelRequire("l27Vv");

});
parcelRegister("luZJ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcf7b7e4d681358f$export$2e2bcd8739ae039);

var $l27Vv = parcelRequire("l27Vv");

var $bLeeC = parcelRequire("bLeeC");

var $dfMe6 = parcelRequire("dfMe6");

var $51ACz = parcelRequire("51ACz");
class $bcf7b7e4d681358f$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $bLeeC.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $bLeeC.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $51ACz.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $dfMe6.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $l27Vv.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $l27Vv.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $l27Vv.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $bLeeC.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $bLeeC.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $l27Vv.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $bLeeC.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $l27Vv.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("l27Vv", function(module, exports) {
$parcel$export(module.exports, "ExposureTriggerReason", () => $525fe1842dde9869$export$2c20ffeba7dbc068);
var $525fe1842dde9869$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("bLeeC", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $22c42206e3495b7d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $22c42206e3495b7d$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $22c42206e3495b7d$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $22c42206e3495b7d$export$891630e169ca14a4);
const $22c42206e3495b7d$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $22c42206e3495b7d$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $22c42206e3495b7d$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $22c42206e3495b7d$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $22c42206e3495b7d$var$validateFlag = (flagKey, flag)=>{
    if ($22c42206e3495b7d$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $22c42206e3495b7d$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$22c42206e3495b7d$var$validateFlag(key, flags[key]));
};

});

parcelRegister("dfMe6", function(module, exports) {
$parcel$export(module.exports, "default", () => $97cdc47b760aea4d$export$2e2bcd8739ae039);
const $97cdc47b760aea4d$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $97cdc47b760aea4d$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $97cdc47b760aea4d$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("51ACz", function(module, exports) {
$parcel$export(module.exports, "default", () => $4565132a6dc98d6b$export$2e2bcd8739ae039);

var $l27Vv = parcelRequire("l27Vv");
class $4565132a6dc98d6b$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $l27Vv.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $l27Vv.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});






parcelRegister("3Zulo", function(module, exports) {
$parcel$export(module.exports, "NonCritical", () => $35e7d40f521eb281$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $35e7d40f521eb281$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $kZIBu = parcelRequire("kZIBu");
const $35e7d40f521eb281$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $kZIBu.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eJOHy.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    }
    return null;
};
const $35e7d40f521eb281$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35e7d40f521eb281$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $35e7d40f521eb281$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $kZIBu.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eJOHy.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    }
    return null;
};
const $35e7d40f521eb281$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35e7d40f521eb281$var$NonCriticalComponent, props));
var $35e7d40f521eb281$export$2e2bcd8739ae039 = $35e7d40f521eb281$var$NonCriticalComponent;

});
parcelRegister("kZIBu", function(module, exports) {
$parcel$export(module.exports, "useSpaStatePageReady", () => $235527b084d97c5b$export$ea2491906b753456);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $79p6g = parcelRequire("79p6g");
const $235527b084d97c5b$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $235527b084d97c5b$export$ea2491906b753456 = (0, $iJq0l.createHook)((0, $79p6g.default), {
    selector: $235527b084d97c5b$export$e6897aa59ee7aee5
});

});


parcelRegister("hW27F", function(module, exports) {
$parcel$export(module.exports, "Spa", () => $293e894cae72421f$export$6d4069f4b64f7492);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");


var $lOI8W = parcelRequire("lOI8W");

var $4cTDP = parcelRequire("4cTDP");

var $drMaP = parcelRequire("drMaP");

var $7QIoR = parcelRequire("7QIoR");

var $ieHpw = parcelRequire("ieHpw");

var $kUiAZ = parcelRequire("kUiAZ");

var $aQwf0 = parcelRequire("aQwf0");

var $dvkro = parcelRequire("dvkro");

var $k80Nq = parcelRequire("k80Nq");

var $6X5Gm = parcelRequire("6X5Gm");
const $293e894cae72421f$var$FaviconService = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    (0, $drMaP.useFaviconService)();
    return null;
});
const $293e894cae72421f$export$6d4069f4b64f7492 = ({ locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
    const pageContainerPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$21473105c510aacc), (0, $60d311439a302207$export$59f83d43fe209319), (0, $60d311439a302207$export$7114284ca03133ee), true, true);
    }, []);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ieHpw.PageContainer), {
        id: false ? 'jira.entry.ssr' : 'spa',
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, (0, $4cTDP.fg)('jira_frontend_memory_monitor') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aQwf0.MemoryMonitor), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dvkro.ReadinessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($293e894cae72421f$var$FaviconService, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$7114284ca03133ee),
        onSet: pageContainerPerformanceTiming
    }), isPrewarming !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kUiAZ.Content), {
        initRoute: initRoute,
        routes: routes
    }), (0, $4cTDP.fg)('magma-hotfix-testing') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k80Nq.HotfixTesting), null), (0, $4cTDP.fg)('ditto_fcf_jira_globalbackgroundscript') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7QIoR.ForgeUiGlobalExtensionsAsync), null));
    if ((0, $4cTDP.fg)('jfp-magma-hydration-advisory')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6X5Gm.HydrationAdvisory), null));
    return content;
};

});
parcelRegister("eK5AI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c5afae322a0f6fe$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6uWhG = parcelRequire("6uWhG");
const $7c5afae322a0f6fe$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $eJOHy.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $6uWhG.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $7c5afae322a0f6fe$export$2e2bcd8739ae039 = $7c5afae322a0f6fe$var$PerformanceMark;

});

parcelRegister("drMaP", function(module, exports) {
$parcel$export(module.exports, "useFaviconService", () => $bb123c007f6169ba$export$c5544731c404c896);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $7SGrx = parcelRequire("7SGrx");

var $eWzpp = parcelRequire("eWzpp");

var $kfvK2 = parcelRequire("kfvK2");

var $5jyLi = parcelRequire("5jyLi");

var $aNpqK = parcelRequire("aNpqK");

var $itOGz = parcelRequire("itOGz");

var $3heJi = parcelRequire("3heJi");

var $1xAx8 = parcelRequire("1xAx8");

var $dQlEC = parcelRequire("dQlEC");
const $bb123c007f6169ba$export$f948ae143e35cfaf = 'ajs-fspage-favicon-prefixed';
const $bb123c007f6169ba$export$c9e8acb6bea47122 = 'ajs-fspage-favicon';
const $bb123c007f6169ba$export$7ef9895286e10387 = 'ajs-favicon-use-projecticon';
const $bb123c007f6169ba$var$useRouteGroup = (0, $kfvK2.createRouterSelector)((state)=>state.route.group);
const $bb123c007f6169ba$var$getCustomFavicon = ()=>{
    // Some instances might not have the prefixed metadata key, so we fallback to the original key
    const faviconPath = (0, $hWeHP.default)($bb123c007f6169ba$export$f948ae143e35cfaf) || (0, $hWeHP.default)($bb123c007f6169ba$export$c9e8acb6bea47122);
    // Check if favicon is default or custom by matching the image path with pattern "favicon.*.ico"
    if (faviconPath) {
        const imagePath = faviconPath.split('/').at(-1);
        const defaultFaviconPattern = /^favicon.*\.ico$/;
        if (imagePath && !defaultFaviconPattern.test(imagePath)) return faviconPath;
    }
    return null;
};
const $bb123c007f6169ba$export$c5544731c404c896 = false ? ()=>undefined : ()=>{
    const routeGroup = $bb123c007f6169ba$var$useRouteGroup();
    const { data: project } = (0, $eWzpp.useProject)();
    const isProjectFaviconEnabled = (0, $hWeHP.default)($bb123c007f6169ba$export$7ef9895286e10387) === 'true';
    const productName = (0, $7SGrx.useProductName)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $eJOHy.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const customFavicon = $bb123c007f6169ba$var$getCustomFavicon();
    (0, $eJOHy.useEffect)(()=>{
        let faviconPath = defaultFavicon;
        if (routeGroup === 'assets' && (0, $4cTDP.fg)('assets_as_an_app_v2')) {
            // Assets is currently a specific set of routes, and doesn't exist as a separate "product" as per `productName`.
            // Assets is moving towards being a platform outside of Jira (rendering its own Bifrost app etc), so it doesn't
            // make sense to register it as a Jira sub-product.
            if (customFavicon && (0, $4cTDP.fg)('assets_nav_customisation_fix')) faviconPath = customFavicon;
            else if ((0, $4cTDP.fg)('assets-platform-branding')) faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($aNpqK)));
            else faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($5jyLi)));
        } else if (isProjectFaviconEnabled && project) faviconPath = project.avatarUrl;
        else if (customFavicon) faviconPath = customFavicon;
        else if (productName === 'serviceDesk') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($1xAx8)));
        else if (productName === 'product-discovery') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($3heJi)));
        else if (productName === 'customer-service') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($dQlEC)));
        else if (productName === 'jira' || productName === 'core' || productName === 'software') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($itOGz)));
        if (iconEle instanceof HTMLLinkElement) iconEle.href = faviconPath;
        // Cleanup: Restore default favicon when component unmounts
        return ()=>{
            if (iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
        };
    }, [
        routeGroup,
        productName,
        defaultFavicon,
        iconEle,
        customFavicon,
        isProjectFaviconEnabled,
        project
    ]);
};

});
parcelRegister("5jyLi", function(module, exports) {
module.exports = new URL("favicon-temp-assets.32f0aa73.png", import.meta.url).toString();

});

parcelRegister("aNpqK", function(module, exports) {
module.exports = new URL("favicon-temp-assets-platform.b96df0c9.png", import.meta.url).toString();

});

parcelRegister("itOGz", function(module, exports) {
module.exports = new URL("favicon-temp-family.9e1adb01.png", import.meta.url).toString();

});

parcelRegister("3heJi", function(module, exports) {
module.exports = new URL("favicon-temp-jpd.d360a2a3.png", import.meta.url).toString();

});

parcelRegister("1xAx8", function(module, exports) {
module.exports = new URL("favicon-temp-jsm.a82c490c.png", import.meta.url).toString();

});

parcelRegister("dQlEC", function(module, exports) {
module.exports = new URL("favicon-temp-csm.7aac7873.png", import.meta.url).toString();

});


parcelRegister("7QIoR", function(module, exports) {
$parcel$export(module.exports, "ForgeUiGlobalExtensionsAsync", () => $aee9c3989a4e3de6$export$49ab642f30b953dd);

var $eJOHy = parcelRequire("eJOHy");

var $fNnFH = parcelRequire("fNnFH");

const $aee9c3989a4e3de6$var$forgeUiGlobalResource = (0, $fNnFH.JSResourceForBackground)(()=>(parcelRequire("2iYvp")).then((m)=>m.default), {
    moduleId: "2e38c0c3",
    priority: "background"
});
const $aee9c3989a4e3de6$export$49ab642f30b953dd = ()=>{
    const [LoadedComponent, setLoadedComponent] = (0, $eJOHy.useState)(null);
    const mounted = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        mounted.current = true;
        if (!LoadedComponent) $aee9c3989a4e3de6$var$forgeUiGlobalResource.load().then((resource)=>{
            if (!mounted.current) return;
            const Comp = resource;
            if (Comp) setLoadedComponent(()=>Comp);
        });
        return ()=>{
            mounted.current = false;
        };
    }, [
        LoadedComponent
    ]);
    return LoadedComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LoadedComponent, null);
};

});
parcelRegister("fNnFH", function(module, exports) {
$parcel$export(module.exports, "JSResourceForBackground", () => $ae5defe1f3ba6ec4$export$1f734e6fd513727a);

var $8MX4m = parcelRequire("8MX4m");

var $jkRyu = parcelRequire("jkRyu");

var $dsHGc = parcelRequire("dsHGc");
const $ae5defe1f3ba6ec4$var$cache = (0, $8MX4m.createCache)(new Map());
function $ae5defe1f3ba6ec4$export$1f734e6fd513727a(loader, opts) {
    return $ae5defe1f3ba6ec4$var$cache.get(opts.moduleId, ()=>(0, $jkRyu.PreloadableJSResource)(()=>(0, $dsHGc.postTask)(loader, {
                priority: 'background'
            }), opts));
}

});

parcelRegister("2iYvp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lmYHw")
]).then(()=>parcelRequire('gwKxc'));

});


parcelRegister("ieHpw", function(module, exports) {
$parcel$export(module.exports, "PageContainer", () => $054f27dea2055bd3$export$5f86df0ee0a255b5);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8aMsX = parcelRequire("8aMsX");

var $4EKqI = parcelRequire("4EKqI");

var $eK5AI = parcelRequire("eK5AI");

var $5vQ2T = parcelRequire("5vQ2T");

var $i0Aal = parcelRequire("i0Aal");

var $5bzWA = parcelRequire("5bzWA");

var $1DCdi = parcelRequire("1DCdi");

var $fvzyF = parcelRequire("fvzyF");

var $EzBXZ = parcelRequire("EzBXZ");

var $dzLcO = parcelRequire("dzLcO");


var $bv6dN = parcelRequire("bv6dN");

var $3pkO9 = parcelRequire("3pkO9");

var $kGj4V = parcelRequire("kGj4V");

var $2PrU6 = parcelRequire("2PrU6");

var $djhHt = parcelRequire("djhHt");

var $lOI8W = parcelRequire("lOI8W");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $kfvK2 = parcelRequire("kfvK2");

var $gp9Js = parcelRequire("gp9Js");

var $k2tOc = parcelRequire("k2tOc");

var $8hKqe = parcelRequire("8hKqe");

var $jjTNC = parcelRequire("jjTNC");

var $1302Y = parcelRequire("1302Y");

var $3ipHb = parcelRequire("3ipHb");

var $hCNjJ = parcelRequire("hCNjJ");

var $hbF3h = parcelRequire("hbF3h");

var $eAwT1 = parcelRequire("eAwT1");

var $ltfhl = parcelRequire("ltfhl");

var $DrDtQ = parcelRequire("DrDtQ");

var $gSyZa = parcelRequire("gSyZa");

var $m9A8V = parcelRequire("m9A8V");

var $eTZyL = parcelRequire("eTZyL");

var $dtNAy = parcelRequire("dtNAy");

var $iypv0 = parcelRequire("iypv0");

var $5Wq2G = parcelRequire("5Wq2G");

var $1bE4f = parcelRequire("1bE4f");

var $3sFnL = parcelRequire("3sFnL");

var $hOLtL = parcelRequire("hOLtL");

var $d9aSP = parcelRequire("d9aSP");
const $054f27dea2055bd3$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "page-container-v2-main-wrapper"
    }, children), (0, $eJOHy.Fragment));
const $054f27dea2055bd3$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themedOld: "_11q7mmei _11q31r52",
    themed: "_11q7mmei _11q3ne5i"
};
/**
 * These test IDs are used in pollinator tests. Do not change lightly.
 */ const $054f27dea2055bd3$var$ROOT_TEST_ID = 'page-layout.root';
const $054f27dea2055bd3$var$MAIN_TEST_ID = 'page-layout.main';
const $054f27dea2055bd3$var$DefaultLayout = ({ children: children })=>{
    const [isChromeless] = (0, $i0Aal.useIsChromeless)();
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    const showBanner = !isChromeless && !isFullscreen;
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen;
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Wq2G.JiraPageLayout), {
        skipLinksLabel: "",
        testId: $054f27dea2055bd3$var$ROOT_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjTNC.IntegrationsWhichRequireNavigationRoot), null)), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eAwT1.Banner), null)), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dtNAy.TopNav), null)), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eTZyL.Sidebar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$MainWrapper, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gSyZa.HorizontalNav), null), children), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $m9A8V.RightSidebar), null)), (0, $4cTDP.fg)('jira-glance-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "preview-panel",
        packageName: "jiraPageContainerV2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ipHb.PreviewPanel), null)), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1DCdi.LayoutRemoteStateUpdater), null)));
};
function $054f27dea2055bd3$var$MainWrapper(props) {
    const { hasTheming: hasTheming } = (0, $2PrU6.useProjectTheme)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $bv6dN.useJsmGracePeriodBanner)();
    const currentRoute = $054f27dea2055bd3$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $gp9Js.isSystemNavPath)(currentRoute.path) || (0, $k2tOc.isIssuesNavPath)(currentRoute.path);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Main), {
        isFixed: true,
        testId: $054f27dea2055bd3$var$MAIN_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-vc": "page-container-v2-main-wrapper",
        className: (0, $hcewu.default)([
            $054f27dea2055bd3$var$mainWrapperStyles.root,
            hasTheming && !(0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() && $054f27dea2055bd3$var$mainWrapperStyles.themedOld,
            hasTheming && (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() && $054f27dea2055bd3$var$mainWrapperStyles.themed
        ])
    }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3pkO9.JSMGracePeriodBannerAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8hKqe.JiraTopBannerPlacement), null), props.children)));
}
const $054f27dea2055bd3$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $054f27dea2055bd3$var$Layout = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $054f27dea2055bd3$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$DefaultLayout, props);
};
const $054f27dea2055bd3$var$PageContainerNoQuery = (props)=>{
    const { id: id, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent } = props;
    const pageContainerPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$898b6208220685b0), (0, $60d311439a302207$export$e2bc63118050de32), (0, $60d311439a302207$export$59f83d43fe209319), true, false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $DrDtQ.GlobalContainers), {
        id: id,
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, (0, $4cTDP.fg)('redirect_all_new_jira_users_to_user_segmentation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iypv0.RedirectEntrypointContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3sFnL.GlobalThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOLtL.ProjectThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$Layout, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ltfhl.GlobalComponents), {
        sharedGlobalComponents: (0, $djhHt.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvzyF.GlobalBottomRightCornerContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9aSP.PageContainerSuccessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8aMsX.HydrationStatsReporter), null), (0, $4cTDP.fg)('jfp-magma-4013-fix-hydration-edition-awareness') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hCNjJ.HydrationFinishedSetter), null))));
};
const $054f27dea2055bd3$export$5f86df0ee0a255b5 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jpx-463-spa-relay-query'), (0, $1bE4f.JiraSpaPageContainer), $054f27dea2055bd3$var$PageContainerNoQuery);

});
parcelRegister("8aMsX", function(module, exports) {
$parcel$export(module.exports, "HydrationStatsReporter", () => $1008a912b4257ecd$export$9fda4732f2f0c3db);
$parcel$export(module.exports, "getReactHydrationStats", () => $1008a912b4257ecd$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "enableHydrationStatReporting", () => $1008a912b4257ecd$export$6e74f32ea46916a6);
$parcel$export(module.exports, "addErrorForHydrationStats", () => $1008a912b4257ecd$export$14e23415a0e3da58);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XSXq = parcelRequire("6XSXq");

var $eSnSE = parcelRequire("eSnSE");

var $2MtPi = parcelRequire("2MtPi");

var $4cTDP = parcelRequire("4cTDP");
const $1008a912b4257ecd$var$HYDRATION_STATS = {
    enabled: false,
    hasFatalError: false,
    warningCount: 0,
    minErrorComponentDepth: null,
    maxErrorComponentDepth: null
};
const $1008a912b4257ecd$var$useRouteName = (0, $kfvK2.createRouterSelector)((state)=>state.route.name);
// Wait until React hydration is done. This is a bit crude, but we chain together a few idle callbacks with some space
// in case React pauses work for a bit, in which case we would incorrectly capture metrics before hydration is complete.
// Ideally would use <RenderAfterHydrationCompletion /> alone, but want to be absolutely sure this doesn't fire too
// early and report false success.
const $1008a912b4257ecd$var$delayUntilHydrationCompleted = (callback)=>{
    (0, $6XSXq.callWhenIdle)(()=>{
        setTimeout(()=>{
            (0, $6XSXq.callWhenIdle)(()=>{
                setTimeout(()=>{
                    (0, $6XSXq.callWhenIdle)(callback);
                }, 2500);
            });
        }, 2500);
    });
};
const $1008a912b4257ecd$var$ReportOnce = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const initialRouteName = $1008a912b4257ecd$var$useRouteName();
    // Using state here because we want to capture the route name on initial render, and not have it change when the effect runs
    const [routeName] = (0, $eJOHy.useState)(initialRouteName);
    const reported = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!$1008a912b4257ecd$var$HYDRATION_STATS.enabled || reported.current) return;
        reported.current = true;
        let cancelled = false;
        $1008a912b4257ecd$var$delayUntilHydrationCompleted(()=>{
            if (cancelled) return;
            const { hasFatalError: hasFatalError, warningCount: warningCount, minErrorComponentDepth: minErrorComponentDepth, maxErrorComponentDepth: maxErrorComponentDepth } = $1008a912b4257ecd$var$HYDRATION_STATS;
            const successful = !hasFatalError;
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), successful ? 'reactHydrate success' : 'reactHydrate failure', {
                warningCount: $1008a912b4257ecd$export$3bf82299f486a7ff(warningCount),
                routeName: routeName
            });
            // When cleaning up, replace with @atlassian/jira-coinflip depending on the desired rate, or remove
            // completely if no longer needed and the analytics event above can be used instead
            if ((0, $4cTDP.fg)('jfp-magma-hydration-report-to-splunk')) (0, $eSnSE.default).safeInfoWithoutCustomerData('react-hydration-reporting', successful ? 'Hydration success' : 'Hydration failure', {
                warningCount: warningCount,
                routeName: routeName,
                minErrorComponentDepth: minErrorComponentDepth,
                maxErrorComponentDepth: maxErrorComponentDepth
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    return null;
};
const $1008a912b4257ecd$export$9fda4732f2f0c3db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2MtPi.RenderAfterHydrationCompletion), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1008a912b4257ecd$var$ReportOnce, null));
const $1008a912b4257ecd$export$2d8f8d64dc343d7b = ()=>{
    if (!$1008a912b4257ecd$var$HYDRATION_STATS.enabled) return undefined;
    return {
        successful: !$1008a912b4257ecd$var$HYDRATION_STATS.hasFatalError,
        warningCount: $1008a912b4257ecd$var$HYDRATION_STATS.warningCount,
        minWarningComponentDepth: $1008a912b4257ecd$var$HYDRATION_STATS.minErrorComponentDepth ?? undefined,
        maxWarningComponentDepth: $1008a912b4257ecd$var$HYDRATION_STATS.maxErrorComponentDepth ?? undefined
    };
};
const $1008a912b4257ecd$export$3bf82299f486a7ff = (warningCount)=>{
    if (warningCount <= 9) return warningCount.toString();
    return '10+';
};
const $1008a912b4257ecd$export$6e74f32ea46916a6 = ()=>{
    $1008a912b4257ecd$var$HYDRATION_STATS.enabled = true;
};
const $1008a912b4257ecd$export$14e23415a0e3da58 = (error, errorInfo)=>{
    switch($1008a912b4257ecd$export$e577dd64062c400a(error)){
        case $1008a912b4257ecd$var$HYDRATION_FATAL_ERROR:
            $1008a912b4257ecd$var$HYDRATION_STATS.hasFatalError = true;
            $1008a912b4257ecd$var$recordComponentDepthStats(errorInfo);
            break;
        case $1008a912b4257ecd$var$HYDRATION_WARNING:
            $1008a912b4257ecd$var$HYDRATION_STATS.warningCount++;
            $1008a912b4257ecd$var$recordComponentDepthStats(errorInfo);
            break;
        default:
            break;
    }
};
const $1008a912b4257ecd$var$HYDRATION_FATAL_ERROR = 'fatal';
const $1008a912b4257ecd$var$HYDRATION_WARNING = 'warning';
const $1008a912b4257ecd$export$e577dd64062c400a = ({ message: message })=>{
    var fatal, warning;
    if ($1008a912b4257ecd$var$PROD_FATAL_MESSAGES.some((fatal)=>message.includes(fatal))) return $1008a912b4257ecd$var$HYDRATION_FATAL_ERROR;
    if ($1008a912b4257ecd$var$PROD_WARNING_MESSAGES.some((warning)=>message.includes(warning))) return $1008a912b4257ecd$var$HYDRATION_WARNING;
    return null;
};
const $1008a912b4257ecd$var$PROD_FATAL_MESSAGES = [
    407,
    419,
    421,
    422,
    423,
    424
].map((code)=>`Minified React error #${code}`);
const $1008a912b4257ecd$var$PROD_WARNING_MESSAGES = [
    418,
    425
].map((code)=>`Minified React error #${code}`);
const $1008a912b4257ecd$var$DEV_FATAL_MESSAGES = [
    'to client rendering'
];
const $1008a912b4257ecd$var$DEV_WARNING_MESSAGES = [
    'Hydration failed because the initial UI does not match what was rendered on the server',
    'Text content does not match server-rendered HTML'
];
const $1008a912b4257ecd$var$recordComponentDepthStats = ({ componentStack: componentStack })=>{
    if (!componentStack) return;
    // Number of components = number of lines after the error message
    const componentStackDepth = componentStack.match(/\n/g)?.length ?? 1;
    $1008a912b4257ecd$var$HYDRATION_STATS.minErrorComponentDepth = Math.min(componentStackDepth, $1008a912b4257ecd$var$HYDRATION_STATS.minErrorComponentDepth ?? Number.MAX_SAFE_INTEGER);
    $1008a912b4257ecd$var$HYDRATION_STATS.maxErrorComponentDepth = Math.max(componentStackDepth, $1008a912b4257ecd$var$HYDRATION_STATS.maxErrorComponentDepth ?? 0);
};

});
parcelRegister("2MtPi", function(module, exports) {
$parcel$export(module.exports, "RenderAfterHydrationCompletion", () => $e91143a91d4e6603$export$44609ba20f8a073f);

var $MBWwk = parcelRequire("MBWwk");
const $e91143a91d4e6603$export$44609ba20f8a073f = (0, $MBWwk.BackgroundPriority);

});
parcelRegister("MBWwk", function(module, exports) {
$parcel$export(module.exports, "BackgroundPriority", () => $728e2a9794674636$export$ae957da140356154);
$parcel$export(module.exports, "renderInBackgroundPriority", () => $728e2a9794674636$export$92ab163f92594a98);

var $eJOHy = parcelRequire("eJOHy");

var $86XkI = parcelRequire("86XkI");
const $728e2a9794674636$export$ae957da140356154 = ({ children: children, forceRender: forceRender })=>{
    const tier = (0, $86XkI.useCurrentPriority)();
    if (!forceRender && tier < (0, $86XkI.loadingPriority).background) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $728e2a9794674636$export$92ab163f92594a98 = (Component, bypassCondition)=>{
    const wrappedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($728e2a9794674636$export$ae957da140356154, {
            forceRender: bypassCondition ? bypassCondition() : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null));
    wrappedComponent.displayName = `BackgroundPriority(${Component.displayName || Component.name})`;
    return wrappedComponent;
};

});
parcelRegister("86XkI", function(module, exports) {
$parcel$export(module.exports, "useCurrentPriority", () => $fa905a6dfa088034$export$ea2f0151c2177b4c);
$parcel$export(module.exports, "loadingPriority", () => $fa905a6dfa088034$export$9d1e6d89fa244199);
$parcel$export(module.exports, "PriorityManager", () => $fa905a6dfa088034$export$7099b16a7996ef6c);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $kZIBu = parcelRequire("kZIBu");
const $fa905a6dfa088034$var$store = (0, $GtRbT.createStore)({
    name: 'priority-manager',
    initialState: {
        tier: 1
    },
    actions: {
        setTier: (tier)=>({ setState: setState, getState: getState })=>setState({
                    tier: Math.max(getState().tier, tier)
                })
    }
});
const $fa905a6dfa088034$export$5761757a15d758a = (0, $iJq0l.createActionsHook)($fa905a6dfa088034$var$store);
const $fa905a6dfa088034$export$ea2f0151c2177b4c = (0, $iJq0l.createStateHook)($fa905a6dfa088034$var$store, {
    selector: (state)=>state.tier
});
// allow max 5 seconds between tier 2(app ready) and tier 3(work is done)
const $fa905a6dfa088034$var$MAX_TIME_IN_TIER_2 = 5000;
const $fa905a6dfa088034$export$9d1e6d89fa244199 = {
    // tier 0 - "early scripts" is outside of this component reach and responsibility
    /**
	 * Tier 1 - initial loading phase, everything is critical
	 */ critical: 1,
    /**
	 * Tier 2 - app is ready, but some work is still in progress
	 * This is the phase where we can start loading non-critical resources
	 */ nonCritical: 2,
    /**
	 * Tier 3 - background phase, all work is done, we can load background resources
	 * This is the phase where we can start loading background resources
	 */ background: 3
};
function $fa905a6dfa088034$export$7099b16a7996ef6c() {
    const [{ isReady: isReady }] = (0, $kZIBu.useSpaStatePageReady)();
    const { setTier: setTier } = $fa905a6dfa088034$export$5761757a15d758a();
    (0, $eJOHy.useEffect)(()=>{
        if (isReady) {
            performance.mark('priority:non-critical-phase');
            setTier($fa905a6dfa088034$export$9d1e6d89fa244199.nonCritical);
            // ensure we are advancing in no later than MAX_TIME_IN_TIER_2
            const tm = setTimeout(()=>setTier($fa905a6dfa088034$export$9d1e6d89fa244199.background), $fa905a6dfa088034$var$MAX_TIME_IN_TIER_2);
            return ()=>{
                clearTimeout(tm);
            };
        }
    }, [
        isReady,
        setTier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            const onPageReady = ()=>{
                performance.mark('priority:background-phase');
                setTier($fa905a6dfa088034$export$9d1e6d89fa244199.background);
            };
            window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
            return ()=>{
                window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
            };
        }
    }, [
        setTier
    ]);
    return null;
}

});




parcelRegister("i0Aal", function(module, exports) {
$parcel$export(module.exports, "useIsChromeless", () => $5b596af44974a488$export$c88b74884f5222ba);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $5b596af44974a488$export$c88b74884f5222ba = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.isChromeless
});

});
parcelRegister("fZsy4", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $00171a4137f359c3$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $00171a4137f359c3$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $00171a4137f359c3$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $00171a4137f359c3$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $00171a4137f359c3$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4BzWx = parcelRequire("4BzWx");
const $00171a4137f359c3$export$539e68c09584883a = 240;
const $00171a4137f359c3$export$b92df8810d2fcd01 = 0;
const $00171a4137f359c3$export$47a4b4760f306fb9 = 400;
const $00171a4137f359c3$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $00171a4137f359c3$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false,
            hasUserPreference: false
        },
        rightSidebar: {
            stackState: []
        },
        previewPanel: {
            width: $00171a4137f359c3$export$47a4b4760f306fb9
        }
    }
};
const $00171a4137f359c3$export$b8cdfd44cddaf07 = (0, $GtRbT.createStore)({
    initialState: $00171a4137f359c3$var$initialState,
    actions: $4BzWx.actions,
    name: 'JiraLayoutStore'
});
const $00171a4137f359c3$export$6136bc3b9858cff4 = (0, $iJq0l.createHook)($00171a4137f359c3$export$b8cdfd44cddaf07, {
    selector: null
});
const $00171a4137f359c3$var$detailPanelWidthStore = (0, $GtRbT.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $00171a4137f359c3$export$95fd7b6da3b9bbb0 = (0, $iJq0l.createHook)($00171a4137f359c3$var$detailPanelWidthStore);
const $00171a4137f359c3$export$99e05a60cac05e86 = (0, $iJq0l.createActionsHook)($00171a4137f359c3$var$detailPanelWidthStore);

});
parcelRegister("4BzWx", function(module, exports) {
$parcel$export(module.exports, "actions", () => $106bfd5c0a8dc2d4$export$e324594224ef24da);

var $iK07n = parcelRequire("iK07n");

var $iCv0U = parcelRequire("iCv0U");

var $71bAj = parcelRequire("71bAj");

var $5BHLU = parcelRequire("5BHLU");

var $kF3cb = parcelRequire("kF3cb");

var $3rHRj = parcelRequire("3rHRj");

var $eFmzH = parcelRequire("eFmzH");
const $106bfd5c0a8dc2d4$export$e324594224ef24da = {
    setIsChromeless: // global
    $71bAj.setIsChromeless,
    setIsFullscreen: $5BHLU.setIsFullscreen,
    showBanner: // banner
    $iK07n.showBanner,
    dismissCurrentBanner: $iK07n.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $kF3cb.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $3rHRj.setRightSidebarState,
    openRightSidebar: $3rHRj.openRightSidebar,
    closeRightSidebar: $3rHRj.closeRightSidebar,
    closeAllRightSidebar: $3rHRj.closeAllRightSidebar,
    closeCurrentRightSidebar: $3rHRj.closeCurrentRightSidebar,
    minimiseRightSidebar: $3rHRj.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $iCv0U.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $iCv0U.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $iCv0U.removeBottomRightCornerPortal,
    setPreviewPanelState: // preview panel
    $eFmzH.setPreviewPanelState
};

});
parcelRegister("iK07n", function(module, exports) {
$parcel$export(module.exports, "showBanner", () => $f576dda57f9ab932$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $f576dda57f9ab932$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f576dda57f9ab932$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $f576dda57f9ab932$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($f576dda57f9ab932$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("iCv0U", function(module, exports) {
$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $d6992d5ac6ea80d0$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $d6992d5ac6ea80d0$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $d6992d5ac6ea80d0$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d6992d5ac6ea80d0$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $d6992d5ac6ea80d0$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $d6992d5ac6ea80d0$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("71bAj", function(module, exports) {
$parcel$export(module.exports, "setIsChromeless", () => $3013b300b3f3be1a$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3013b300b3f3be1a$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("5BHLU", function(module, exports) {
$parcel$export(module.exports, "setIsFullscreen", () => $49bc45ba37aeb566$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $49bc45ba37aeb566$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("kF3cb", function(module, exports) {
$parcel$export(module.exports, "setLeftSidebarState", () => $03b023977e84cb41$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $03b023977e84cb41$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("3rHRj", function(module, exports) {
$parcel$export(module.exports, "selectCurrentRightSidebar", () => $38d64587782ceabb$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $38d64587782ceabb$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $38d64587782ceabb$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $38d64587782ceabb$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $38d64587782ceabb$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $38d64587782ceabb$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $38d64587782ceabb$export$c8dafe074328c4ca);

var $cSmYj = parcelRequire("cSmYj");
const $38d64587782ceabb$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $38d64587782ceabb$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $38d64587782ceabb$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $38d64587782ceabb$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $38d64587782ceabb$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $38d64587782ceabb$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $38d64587782ceabb$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $38d64587782ceabb$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $38d64587782ceabb$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $38d64587782ceabb$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $38d64587782ceabb$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $38d64587782ceabb$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("eFmzH", function(module, exports) {
$parcel$export(module.exports, "setPreviewPanelState", () => $64e9612ff0fed2ac$export$ba6353031892dd17);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $64e9612ff0fed2ac$export$ba6353031892dd17 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                previewPanel: {
                    ...content.previewPanel,
                    ...newState
                }
            }
        });
    };

});




parcelRegister("5bzWA", function(module, exports) {
$parcel$export(module.exports, "useIsFullscreen", () => $c5e933a3117521b9$export$d397eccea5f37b0a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $c5e933a3117521b9$export$d397eccea5f37b0a = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});

parcelRegister("1DCdi", function(module, exports) {
$parcel$export(module.exports, "LayoutRemoteStateUpdater", () => $b1ab69780e7853e9$export$b9f3a70460995c32);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $9pTd3 = parcelRequire("9pTd3");

var $FppkK = parcelRequire("FppkK");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");

var $dzLcO = parcelRequire("dzLcO");


var $dfh4P = parcelRequire("dfh4P");

var $e6YEs = parcelRequire("e6YEs");

var $eJrcF = parcelRequire("eJrcF");

var $4cTDP = parcelRequire("4cTDP");

var $fZsy4 = parcelRequire("fZsy4");

var $cUxaS = parcelRequire("cUxaS");

var $dfP3D = parcelRequire("dfP3D");

var $85mYL = parcelRequire("85mYL");

var $g3dwt = parcelRequire("g3dwt");
const $b1ab69780e7853e9$var$LayoutRemoteStateUpdaterOld = ()=>{
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $eJOHy.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $eJOHy.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $eJOHy.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $eJOHy.useState)();
    const [localPreviewPanelState, setLocalPreviewPanelState] = (0, $eJOHy.useState)();
    // left-sidebar
    const { leftSidebarState: leftSidebarState } = (0, $dzLcO.usePageLayoutResize)();
    const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
    const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $fZsy4.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $fZsy4.useLayoutStoreActions)();
    const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
    // right-sidebar
    const rightSidebarState = (0, $dfP3D.useRightSidebarState)();
    const accountId = (0, $e6YEs.useAccountId)();
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $dfh4P.navigationUiStateResource));
    const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
    // preview panel
    const previewPanelState = (0, $85mYL.usePreviewPanelState)();
    // compares local vs external state coming via chain of callbacks
    // to determine if we really need to send an update of layout state
    const sideBarChanged = (0, $eJOHy.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState, externalPreviewPanelState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalPreviewPanelState, localPreviewPanelState)) {
            setLocalPreviewPanelState(externalPreviewPanelState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState,
        localPreviewPanelState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isLayoutStateReady) return;
        if (error) return;
        setLeftSidebarState({
            width: resolvedLeftSidebarWidth,
            isCollapsed: isCollapsed,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            isFlyoutOpen: isFlyoutOpen,
            isVisible: true
        });
    }, [
        error,
        isCollapsed,
        isFlyoutOpen,
        isLayoutStateReady,
        resolvedLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const updateData = (0, $eJOHy.useCallback)(async ()=>{
        if (loading) return;
        if (error) return;
        if (!isLayoutStateReady) return;
        if (!sideBarChanged(resolvedLeftSidebarWidth, isLeftSidebarCollapsed, rightSidebarState, previewPanelState)) return;
        const remoteData = {
            ...data,
            leftSidebar: {
                width: resolvedLeftSidebarWidth,
                isCollapsed: isLeftSidebarCollapsed
            },
            rightSidebar: rightSidebarState,
            ...(0, $4cTDP.fg)('jira-glance-panel') && {
                previewPanel: previewPanelState
            }
        };
        if (accountId) try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'magma'
                }
            });
        }
    }, [
        accountId,
        data,
        error,
        isLayoutStateReady,
        isLeftSidebarCollapsed,
        loading,
        resolvedLeftSidebarWidth,
        rightSidebarState,
        previewPanelState,
        sideBarChanged
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(resolvedLeftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebarState);
        } else updateData();
    }, [
        isLeftSidebarCollapsed,
        resolvedLeftSidebarWidth,
        updateData,
        rightSidebarState,
        initialLoad
    ]);
    return null;
};
const $b1ab69780e7853e9$var$LayoutRemoteStateUpdaterNew = ()=>{
    const accountId = (0, $e6YEs.useAccountId)();
    const leftSidebar = (0, $cUxaS.useLeftSidebarState)();
    const rightSidebar = (0, $dfP3D.useRightSidebarState)();
    const previewPanel = (0, $85mYL.usePreviewPanelState)();
    const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
    const leftSidebarWidth = leftSidebar.width;
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $eJOHy.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $eJOHy.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $eJOHy.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $eJOHy.useState)();
    const [localPreviewPanelState, setLocalPreviewPanelState] = (0, $eJOHy.useState)();
    // compares local vs external state coming via chain of callbacks
    // to determine if we really need to send an update of layout state
    const sideBarChanged = (0, $eJOHy.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState, externalPreviewPanelState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalPreviewPanelState, localPreviewPanelState)) {
            setLocalPreviewPanelState(externalPreviewPanelState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState,
        localPreviewPanelState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!accountId) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(leftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebar);
            setLocalPreviewPanelState(previewPanel);
            return;
        }
        if (!sideBarChanged(leftSidebarWidth, isLeftSidebarCollapsed, rightSidebar, previewPanel)) return;
        (0, $g3dwt.setRemoteLayoutState)({
            accountId: accountId,
            state: {
                rightSidebar: rightSidebar,
                leftSidebar: {
                    isCollapsed: isLeftSidebarCollapsed,
                    width: leftSidebarWidth
                },
                ...(0, $4cTDP.fg)('jira-glance-panel') && {
                    previewPanel: previewPanel
                }
            }
        });
    }, [
        accountId,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        rightSidebar,
        initialLoad,
        previewPanel,
        sideBarChanged
    ]);
    return null;
};
const $b1ab69780e7853e9$export$b9f3a70460995c32 = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $b1ab69780e7853e9$var$LayoutRemoteStateUpdaterNew, $b1ab69780e7853e9$var$LayoutRemoteStateUpdaterOld);

});
parcelRegister("dzLcO", function(module, exports) {
$parcel$export(module.exports, "PageLayout", () => $599f2c8065b963c5$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $599f2c8065b963c5$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $599f2c8065b963c5$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftSidebar", () => $599f2c8065b963c5$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $599f2c8065b963c5$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $599f2c8065b963c5$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $599f2c8065b963c5$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $599f2c8065b963c5$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $599f2c8065b963c5$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $599f2c8065b963c5$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $599f2c8065b963c5$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $599f2c8065b963c5$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $599f2c8065b963c5$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $599f2c8065b963c5$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $599f2c8065b963c5$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dwrVI = parcelRequire("dwrVI");
var $MH11l = parcelRequire("MH11l");
var $4ETgJ = parcelRequire("4ETgJ");
var $57Dtq = parcelRequire("57Dtq");
var $dCyxH = parcelRequire("dCyxH");
var $d4u9R = parcelRequire("d4u9R");
var $gL49i = parcelRequire("gL49i");
var $kqCKo = parcelRequire("kqCKo");
var $016Wa = parcelRequire("016Wa");
var $c4lEJ = parcelRequire("c4lEJ");
var $gm5Vk = parcelRequire("gm5Vk");
var $8Qi2K = parcelRequire("8Qi2K");

var $1AIob = parcelRequire("1AIob");
var $cQCzs = parcelRequire("cQCzs");
var $dh7KV = parcelRequire("dh7KV");
var $lQuPF = parcelRequire("lQuPF");
var $4ZYlE = parcelRequire("4ZYlE");
var $9Qwez = parcelRequire("9Qwez");
var $7zHjm = parcelRequire("7zHjm");

var $6zXPf = parcelRequire("6zXPf");

var $4cTDP = parcelRequire("4cTDP");
function $599f2c8065b963c5$export$6d1402fb58384e4f({ defaultSideNavCollapsed: defaultSideNavCollapsed, isSideNavShortcutEnabled: isSideNavShortcutEnabled, ...props }) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ZYlE.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId,
        defaultSideNavCollapsed: (0, $4cTDP.fg)('navx-full-height-sidebar') ? defaultSideNavCollapsed : undefined,
        isSideNavShortcutEnabled: isSideNavShortcutEnabled
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gL49i.default), props);
}
function $599f2c8065b963c5$export$3b4e64e77073e307(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cQCzs.Banner), {
        height: props.height,
        testId: props.testId,
        id: props.id
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dwrVI.default), props);
}
function $599f2c8065b963c5$export$8a421bddecb2bf5b(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7zHjm.TopNav), {
        height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4lEJ.default), props);
}
function $599f2c8065b963c5$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $6zXPf.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ETgJ.default), props);
}
function $599f2c8065b963c5$export$43ae342508cf8cc9(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Qwez.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dCyxH.default), props);
}
function $599f2c8065b963c5$export$3cabf771c4f2de(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Qwez.SideNav), {
        defaultCollapsed: (0, $4cTDP.fg)('navx-full-height-sidebar') ? undefined : props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57Dtq.default), props);
}
function $599f2c8065b963c5$export$861edd1ccea2f746(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dh7KV.Main), {
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d4u9R.default), props);
}
function $599f2c8065b963c5$export$7c6e2c02157bb7d2(props) {
    return (0, $6zXPf.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MH11l.default), props);
}
function $599f2c8065b963c5$export$84d58c19c21f637f(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AIob.Aside), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $016Wa.default), props);
}
function $599f2c8065b963c5$export$364a989a35814102(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lQuPF.Panel), {
        xcss: $599f2c8065b963c5$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kqCKo.default), props);
}
const $599f2c8065b963c5$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $6zXPf.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gm5Vk.useCustomSkipLink)(id, title, index);
const $599f2c8065b963c5$export$94561f6055639ef7 = ()=>(0, $6zXPf.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8Qi2K.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $599f2c8065b963c5$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $599f2c8065b963c5$export$10c7104037a7af62 = ()=>(0, $6zXPf.getWillShowNav4)() ? $599f2c8065b963c5$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8Qi2K.usePageLayoutResize)();
const $599f2c8065b963c5$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $599f2c8065b963c5$export$991ef8098f87814a = (0, $7326b3b2ac0b6dee$export$ed7cc0d417ee89e);
const $599f2c8065b963c5$export$7eaf986ecb4d5cac = (0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd);
const $599f2c8065b963c5$export$e95b388ca8c92019 = (0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251);
const $599f2c8065b963c5$export$2ab8b83eed76656c = (0, $7326b3b2ac0b6dee$export$750459958906793);
const $599f2c8065b963c5$export$ac017575d43f5da = (0, $7326b3b2ac0b6dee$export$b44ab66843c05a69);
const $599f2c8065b963c5$export$d697087c06fd5e25 = (0, $7326b3b2ac0b6dee$export$aeff86a16f13529);

});
// dimension vars
const $7326b3b2ac0b6dee$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $7326b3b2ac0b6dee$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $7326b3b2ac0b6dee$export$c103b605cd368aed = 'rightSidebarWidth';
const $7326b3b2ac0b6dee$export$fa34f417972d6341 = 'rightPanelWidth';
const $7326b3b2ac0b6dee$export$3a6a779d9181047c = 'topNavigationHeight';
const $7326b3b2ac0b6dee$export$bcd94a6a792e7f96 = 'bannerHeight';
const $7326b3b2ac0b6dee$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $7326b3b2ac0b6dee$export$344062f7cfc9528e = 'left-panel';
const $7326b3b2ac0b6dee$export$c7139cc2d6110b5f = 'right-panel';
const $7326b3b2ac0b6dee$export$238d30785c4bca84 = 'banner';
const $7326b3b2ac0b6dee$export$bec6dca2e63de4ae = 'top-navigation';
const $7326b3b2ac0b6dee$export$d1213e82613ff4df = 'content';
const $7326b3b2ac0b6dee$export$be83e7118304b28e = 56;
const $7326b3b2ac0b6dee$export$4a98ee0bd1ae362 = 56;
const $7326b3b2ac0b6dee$export$539e68c09584883a = 240;
const $7326b3b2ac0b6dee$export$b92df8810d2fcd01 = 280;
const $7326b3b2ac0b6dee$export$c3e41153b9288bcf = 368;
const $7326b3b2ac0b6dee$export$c4d6152f86ea28f6 = 368;
const $7326b3b2ac0b6dee$export$46acf8758e9e2636 = 20;
const $7326b3b2ac0b6dee$export$70740f5ad8360a78 = 16;
const $7326b3b2ac0b6dee$export$991d5285ad765a3d = 240;
const $7326b3b2ac0b6dee$export$6949d4f32b161684 = 200;
const $7326b3b2ac0b6dee$export$d6e7e8af042815bb = 350;
const $7326b3b2ac0b6dee$export$3749e1104328fde4 = 300;
const $7326b3b2ac0b6dee$export$1074d925b0b82be5 = 200;
const $7326b3b2ac0b6dee$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $7326b3b2ac0b6dee$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $7326b3b2ac0b6dee$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $7326b3b2ac0b6dee$export$70c702a8c5895f03 = 'data-grab-area-line';
const $7326b3b2ac0b6dee$export$48a43f91e4becf4e = 'data-grab-area';
const $7326b3b2ac0b6dee$export$dac2fb31a9f6844d = 'data-resize-button';
const $7326b3b2ac0b6dee$export$9ecd22db14e6c70e = 'data-resize-control';
const $7326b3b2ac0b6dee$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $7326b3b2ac0b6dee$export$206a08f7f8beb554 = 'Skip to:';
const $7326b3b2ac0b6dee$export$659ee746b31b360d = 'data-layout-container';
const $7326b3b2ac0b6dee$export$f963aecf2d4465bd = `var(--${$7326b3b2ac0b6dee$export$cbfb0f5b2869b17b}, 0px)`;
const $7326b3b2ac0b6dee$export$750459958906793 = `var(--${$7326b3b2ac0b6dee$export$fa34f417972d6341}, 0px)`;
const $7326b3b2ac0b6dee$export$f897e1ed9f8ed251 = `var(--${$7326b3b2ac0b6dee$export$a30f2e00489a8957}, 0px)`;
const $7326b3b2ac0b6dee$export$b44ab66843c05a69 = `var(--${$7326b3b2ac0b6dee$export$c103b605cd368aed}, 0px)`;
const $7326b3b2ac0b6dee$export$aeff86a16f13529 = `var(--${$7326b3b2ac0b6dee$export$3a6a779d9181047c}, 0px)`;
const $7326b3b2ac0b6dee$export$ed7cc0d417ee89e = `var(--${$7326b3b2ac0b6dee$export$bcd94a6a792e7f96}, 0px)`;
const $7326b3b2ac0b6dee$export$d2fa14f05b61e66 = `var(--${$7326b3b2ac0b6dee$export$b6744d31294864fd}, ${$7326b3b2ac0b6dee$export$991d5285ad765a3d}px)`;


parcelRegister("cUxaS", function(module, exports) {
$parcel$export(module.exports, "useLeftSidebarState", () => $2ce27f19e394981e$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $2ce27f19e394981e$export$900f29014a48fb23);

var $eJOHy = parcelRequire("eJOHy");

var $dzLcO = parcelRequire("dzLcO");

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $2ce27f19e394981e$var$useSweetStateLeftSidebarState = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $2ce27f19e394981e$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $2ce27f19e394981e$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $2ce27f19e394981e$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $dzLcO.usePageLayoutResize)();
    return (0, $eJOHy.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});

parcelRegister("dfP3D", function(module, exports) {
$parcel$export(module.exports, "useActiveRightSidebarState", () => $8534d9cb529d5738$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $8534d9cb529d5738$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $8534d9cb529d5738$export$ebe5e907fb0bb63a);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");

var $95O7y = parcelRequire("95O7y");

var $jZ41J = parcelRequire("jZ41J");
var $fcue4 = parcelRequire("fcue4");

var $4cTDP = parcelRequire("4cTDP");

var $3rHRj = parcelRequire("3rHRj");

var $fZsy4 = parcelRequire("fZsy4");
const $8534d9cb529d5738$var$useActiveRightSidebar = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $3rHRj.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $8534d9cb529d5738$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $8534d9cb529d5738$var$useActiveRightSidebar();
    return rightSidebar;
};
const $8534d9cb529d5738$var$useRightSidebar = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $8534d9cb529d5738$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $8534d9cb529d5738$var$useRightSidebar();
    return rightSidebarState;
};
const $8534d9cb529d5738$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebarAction, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $fZsy4.useLayoutStoreActions)();
    let closePreviewPanel;
    let isIssuePreviewPanelOpen = false;
    let setSelectedIssue;
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('jira-glance-panel') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [, setSelectedIssueHook] = (0, $95O7y.useQueryParam)('selectedIssue');
        setSelectedIssue = setSelectedIssueHook;
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { close: close } = (0, $fcue4.usePreviewPanelsActions)();
        closePreviewPanel = close;
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const panel = (0, $jZ41J.useCurrentPreviewPanel)();
        isIssuePreviewPanelOpen = panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
    }
    const openRightSidebar = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('right-sidebar-preview-panel') && (0, $4cTDP.fg)('jira-glance-panel') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('issue_view_gpp_killswitch') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)((panelId, width, isMinimised = false, toTop = false)=>{
        if (panelId !== 'jsw-nux-onboarding-checklist') {
            openRightSidebarAction(panelId, width, isMinimised, toTop);
            if (isIssuePreviewPanelOpen) setSelectedIssue?.(undefined);
            closePreviewPanel?.();
        } else if (!isIssuePreviewPanelOpen) openRightSidebarAction(panelId, width, isMinimised, toTop);
    }, [
        closePreviewPanel,
        isIssuePreviewPanelOpen,
        openRightSidebarAction,
        setSelectedIssue
    ]) : openRightSidebarAction;
    return (0, $eJOHy.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});

parcelRegister("85mYL", function(module, exports) {
$parcel$export(module.exports, "usePreviewPanelState", () => $414cfbe9209d0c3f$export$69e98a9119b24908);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $414cfbe9209d0c3f$export$69e98a9119b24908 = (0, $iJq0l.createStateHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>({
            ...state.content.previewPanel
        })
});

});

parcelRegister("g3dwt", function(module, exports) {
$parcel$export(module.exports, "setRemoteLayoutState", () => $ccc52bab2bfda316$export$ad53b565e6cd4261);

var $9pTd3 = parcelRequire("9pTd3");

var $FppkK = parcelRequire("FppkK");

async function $ccc52bab2bfda316$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
    try {
        await (0, $FppkK.setUserProperties)(accountId, (0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(state));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: e,
            meta: {
                id: 'updateServerLayoutState',
                packageName: 'jiraLayoutController',
                teamName: 'jfp-team'
            }
        });
    }
}

});


parcelRegister("fvzyF", function(module, exports) {
$parcel$export(module.exports, "GlobalBottomRightCornerContainer", () => $84994e06d9fdcaa4$export$715c8d5890c054bb);
$parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", () => $84994e06d9fdcaa4$export$1e86e3484191597c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h47gY = parcelRequire("h47gY");

var $4EKqI = parcelRequire("4EKqI");

var $jZ41J = parcelRequire("jZ41J");

var $4cTDP = parcelRequire("4cTDP");

var $fqYrC = parcelRequire("fqYrC");

var $dfP3D = parcelRequire("dfP3D");

var $fZsy4 = parcelRequire("fZsy4");
function $84994e06d9fdcaa4$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
    const [{ width: width }] = (0, $fZsy4.useDetailPanelWidth)();
    const rightSidebar = (0, $dfP3D.useActiveRightSidebarState)();
    const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $fqYrC.useBottomRightCornerActions)();
    const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
    const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
    const rightSidebarOffset = isSidebarOpen ? rightSidebarWidth : 0;
    let distanceFromRightSidebar = width + rightOffset + rightSidebarOffset;
    /**
   * Preview panel also opens inside RightPanel and is resizable. And it has default width of 400px,
   * which is more than width of RightSidebar (386px)
   */ // Preview panel takes precedence over sidebar when open
    if ((0, $4cTDP.fg)('jira-glance-panel')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const panel = (0, $jZ41J.useCurrentPreviewPanel)();
        if (panel) distanceFromRightSidebar = panel.width + rightOffset;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84994e06d9fdcaa4$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${distanceFromRightSidebar}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    });
}
const $84994e06d9fdcaa4$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "bottom-right-corner-container",
        packageName: "jira-bottom-right-corner-controller"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84994e06d9fdcaa4$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }));
const $84994e06d9fdcaa4$export$1e86e3484191597c = ({ children: children })=>{
    const container = (0, $fqYrC.useBottomRightCornerContainer)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "global-bottom-right-corner"
    }, container && children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84994e06d9fdcaa4$export$715c8d5890c054bb, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84994e06d9fdcaa4$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl _kqsw1n9t _1e0c1txw _1pbyfjpv _4cvresu3 _lcxvglyw",
            __cmplp.className
        ])
    });
});
$84994e06d9fdcaa4$var$StyledContainer.displayName = 'StyledContainer';

});
parcelRegister("fqYrC", function(module, exports) {
$parcel$export(module.exports, "useBottomRightCornerContainer", () => $0e623b1898935128$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $0e623b1898935128$export$de496fd0e0151c81);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $0e623b1898935128$export$84542488b6b6c309 = (0, $iJq0l.createStateHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $0e623b1898935128$export$de496fd0e0151c81 = (0, $iJq0l.createActionsHook)((0, $fZsy4.layoutStore));

});


parcelRegister("bv6dN", function(module, exports) {
$parcel$export(module.exports, "useJsmGracePeriodBanner", () => $511fa62b6da1a92e$export$cb2cdbdc1bcc9ace);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $4cTDP = parcelRequire("4cTDP");

var $hih5V = parcelRequire("hih5V");

var $2aY2d = parcelRequire("2aY2d");

var $lhG7N = parcelRequire("lhG7N");
const $511fa62b6da1a92e$export$cb2cdbdc1bcc9ace = ()=>{
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const isServiceProject = project?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $eJOHy.useMemo)(()=>(0, $lhG7N.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isInJsmBoundary && (0, $4cTDP.fg)('jsm_gp_announcements_banner')
        }), [
        isInJsmBoundary
    ]);
};

});
parcelRegister("lhG7N", function(module, exports) {
$parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", () => $fe9eb9c81551c0a4$export$c28a66ae6d31a34b);
const $fe9eb9c81551c0a4$var$jsmGlobalSettingsPages = [
    '/jira/settings/products/jira-service-management-configuration',
    '/jira/settings/products/jira-service-management-email-requests',
    '/jira/settings/products/servicedesk/customer-access',
    '/jira/settings/products/servicedesk/authentication',
    '/jira/settings/products/servicedesk/organizations',
    '/jira/settings/products/jira-service-management-incident-management-tools',
    '/jira/settings/products/jira-service-management-compliance',
    '/jira/settings/products/servicedesk/feature-usage'
];
const $fe9eb9c81551c0a4$var$eocGlobalSettingsPages = [
    '/jira/settings/products/ops/roles',
    '/jira/settings/products/ops/role-assignment',
    '/jira/settings/products/ops/role-based-notifications',
    '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    '/jira/settings/products/ops/integrations',
    '/jira/settings/products/ops/heartbeats',
    '/jira/settings/products/ops/syncs',
    '/jira/settings/products/ops/policies',
    '/jira/settings/products/ops/maintenance',
    '/jira/settings/products/ops/escalation-policies',
    '/jira/settings/products/ops/incoming-call',
    '/jira/settings/products/ops/jira-service-management-audit-logs',
    '/jira/settings/products/ops/reports'
];
const $fe9eb9c81551c0a4$var$isJsmGlobalSettingsPage = (route)=>$fe9eb9c81551c0a4$var$jsmGlobalSettingsPages.includes(route);
const $fe9eb9c81551c0a4$var$isEocGlobalSettingsPage = (route)=>$fe9eb9c81551c0a4$var$eocGlobalSettingsPages.includes(route);
const $fe9eb9c81551c0a4$export$c28a66ae6d31a34b = (route)=>$fe9eb9c81551c0a4$var$isJsmGlobalSettingsPage(route) || $fe9eb9c81551c0a4$var$isEocGlobalSettingsPage(route);

});


parcelRegister("3pkO9", function(module, exports) {
$parcel$export(module.exports, "JSMGracePeriodBannerAsync", () => $dd4967033b8f5eaa$export$5f656c66df6dad60);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $5vQ2T = parcelRequire("5vQ2T");

var $bQWwW = parcelRequire("bQWwW");

const $dd4967033b8f5eaa$var$JSMGracePeriodBannerLazy = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("4Cqvs")).then((module)=>module.JSMGracePeriodBanner), {
    moduleId: "./src/packages/servicedesk/jsm-grace-period-banner/src/ui/index.tsx"
});
const $dd4967033b8f5eaa$export$5f656c66df6dad60 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "async.jsm-grace-period-banner",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-jsm-grace-period-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dd4967033b8f5eaa$var$JSMGracePeriodBannerLazy, null)));
};

});
parcelRegister("4Cqvs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("R3bvP").then(()=>parcelRequire('d8ZiM'));

});


parcelRegister("2PrU6", function(module, exports) {
$parcel$export(module.exports, "useProjectTheme", () => $bde3db500fc78c9b$export$18084206b9430153);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $gYW18 = parcelRequire("gYW18");

var $hS1gr = parcelRequire("hS1gr");

var $cxKOj = parcelRequire("cxKOj");

var $9R5AI = parcelRequire("9R5AI");

var $6nQNr = parcelRequire("6nQNr");

var $6zXPf = parcelRequire("6zXPf");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $5OvV4 = parcelRequire("5OvV4");
const $bde3db500fc78c9b$export$94f987aa4379ed89 = (0, $kfvK2.createRouterSelector)((state)=>state.route.name);
const $bde3db500fc78c9b$export$89f90ea8776fdb88 = (0, $kfvK2.createRouterSelector)((state)=>state.route.group);
const $bde3db500fc78c9b$export$4747cad4fc91185 = (0, $kfvK2.createRouterSelector)((state)=>state.match.params);
const $bde3db500fc78c9b$var$defaultProjectTheme = {
    hasTheming: false,
    hasProjectViewNavigation: false,
    isInset: false
};
const $bde3db500fc78c9b$export$25cf5728a2514195 = ()=>{
    const routeName = $bde3db500fc78c9b$export$94f987aa4379ed89();
    const routeGroup = $bde3db500fc78c9b$export$89f90ea8776fdb88();
    const HorizontalNavComponent = (0, $6nQNr.useHorizontalNavComponent)();
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming, isSoftwareProject: isSoftwareProject } = (0, $1302Y.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    const isBusinessRouteGroup = routeGroup === 'classic-business';
    const hasProjectViewNavigation = (0, $6zXPf.getWillShowNav4)() ? HorizontalNavComponent != null : HorizontalNavComponent === (0, $hS1gr.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $gYW18.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $9R5AI.AsyncHorizontalNavPlans);
    let hasTheming;
    if ((0, $6zXPf.getWillShowNav4)()) {
        const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
        if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) // remove this condition completely on m2 exp cleanup
        hasTheming = false;
        else if (isSoftwareProject) hasTheming = hasSoftwareTheming;
        else hasTheming = HorizontalNavComponent === (0, $hS1gr.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $gYW18.AsyncHorizontalOverviewNav) || routeName === 'issue';
    } else hasTheming = hasProjectViewNavigation;
    // Routes showing a themed inset layout are:
    // - all routes with the business project view navigation
    // - select software routes with contoured theming
    // - except for the routes with business group (as they already cater for the theme)
    const isInset = hasTheming && !isBusinessRouteGroup && !isSoftwareFullTheming;
    return {
        isInset: (0, $4cTDP.fg)('jira_list_nin_merge') ? isInset || (0, $5OvV4.getBusinessProjectForcedInsetRoutes)().has(routeName) : isInset,
        hasTheming: hasTheming,
        hasProjectViewNavigation: hasProjectViewNavigation
    };
};
const $bde3db500fc78c9b$var$useProjectThemeSimplified = ()=>{
    const routeName = $bde3db500fc78c9b$export$94f987aa4379ed89();
    const routeGroup = $bde3db500fc78c9b$export$89f90ea8776fdb88();
    const isBusinessProject = (0, $5OvV4.BUSINESS_PROJECT_THEMED_ROUTES).has(routeName);
    const { allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes } = (0, $kUoGK.getSoftwareThemedRoutes)();
    const isSoftwareProject = allThemedSoftwareProjectRoutes.has(routeName);
    const isIssueView = routeName === 'issue';
    const isBusinessRouteGroup = routeGroup === 'classic-business';
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming } = (0, $1302Y.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false
    };
    return (0, $eJOHy.useMemo)(()=>{
        if (isIssueView) return {
            hasTheming: true,
            hasProjectViewNavigation: false,
            isInset: true
        };
        if (!isBusinessProject && !isSoftwareProject) return $bde3db500fc78c9b$var$defaultProjectTheme;
        // Remove this if clause once when cleaning up getIsSoftwareThemingEnabled
        // Will would get contoured theming on project pages if we don't have this check
        if ((0, $5OvV4.SHARED_THEMED_ROUTES).has(routeName)) {
            if (routeName === 'project-pages') return {
                hasTheming: true,
                hasProjectViewNavigation: true,
                isInset: false
            };
            return {
                hasTheming: true,
                hasProjectViewNavigation: true,
                isInset: true
            };
        }
        if (isSoftwareProject) {
            if (!(0, $1302Y.getIsSoftwareThemingEnabled)()) return $bde3db500fc78c9b$var$defaultProjectTheme;
            const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
            if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
                hasTheming: false,
                hasProjectViewNavigation: true,
                isInset: false
            };
            return {
                hasTheming: hasSoftwareTheming,
                hasProjectViewNavigation: true,
                isInset: hasSoftwareTheming && !isSoftwareFullTheming
            };
        }
        if (isBusinessProject) {
            const hasProjectViewNavigation = (0, $5OvV4.BUSINESS_PROJECT_THEMED_ROUTES).has(routeName);
            const hasTheming = hasProjectViewNavigation;
            const isInset = hasTheming && !isBusinessRouteGroup || (0, $5OvV4.getBusinessProjectForcedInsetRoutes)().has(routeName);
            return {
                hasTheming: hasTheming,
                hasProjectViewNavigation: hasProjectViewNavigation,
                isInset: isInset
            };
        }
        return $bde3db500fc78c9b$var$defaultProjectTheme;
    }, [
        isIssueView,
        isBusinessProject,
        isSoftwareProject,
        routeName,
        isBusinessRouteGroup,
        hasSoftwareTheming,
        isSoftwareFullTheming
    ]);
};
const $bde3db500fc78c9b$export$18084206b9430153 = (0, $hbF3h.functionWithCondition)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $cxKOj.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false), $bde3db500fc78c9b$var$useProjectThemeSimplified, $bde3db500fc78c9b$export$25cf5728a2514195);

});
parcelRegister("gYW18", function(module, exports) {
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $31220cfbb4b000f2$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $31220cfbb4b000f2$var$LazyHorizontalProjectNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("ibpGO")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/MemoProjectNavigation.tsx"
});
const $31220cfbb4b000f2$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31220cfbb4b000f2$var$LazyHorizontalProjectNav, null));

const $31220cfbb4b000f2$var$LazyHorizontalOverviewNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3kd6i")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
});
const $31220cfbb4b000f2$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31220cfbb4b000f2$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("ibpGO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("3IK2q")
]).then(()=>parcelRequire('4WTXa'));

});

parcelRegister("3kd6i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("aaqI6")
]).then(()=>parcelRequire('l3jRL'));

});


parcelRegister("hS1gr", function(module, exports) {
$parcel$export(module.exports, "AsyncHorizontalNavJira", () => $b3848baadec66a18$export$ea83697d960a1a23);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");

var $iX5t3 = parcelRequire("iX5t3");

var $2imLM = parcelRequire("2imLM");

const $b3848baadec66a18$var$LazyHorizontalNavJira = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fI1XL")).then((HorizontalNavJira)=>HorizontalNavJira), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jira/src/ui/HorizontalNavJira.tsx"
});
const $b3848baadec66a18$var$AsyncHorizontalNav = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-nav-jira",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iX5t3.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b3848baadec66a18$var$LazyHorizontalNavJira, null));
const $b3848baadec66a18$export$ea83697d960a1a23 = $b3848baadec66a18$var$AsyncHorizontalNav;

});
parcelRegister("iX5t3", function(module, exports) {
$parcel$export(module.exports, "TabsSkeleton", () => $9a24d46adbe633a2$export$807fef2beb9debc2);
$parcel$export(module.exports, "HorizontalNavSkeleton", () => $9a24d46adbe633a2$export$e29d51df5420bf39);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");
const $9a24d46adbe633a2$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            $9a24d46adbe633a2$var$tabsWrapperSkeletonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }));
const $9a24d46adbe633a2$export$e29d51df5420bf39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050",
        alignBlock: "end",
        xcss: $9a24d46adbe633a2$var$horizontalNavWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$breadcrumbStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between",
        xcss: $9a24d46adbe633a2$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$projectTitleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.150",
        xcss: $9a24d46adbe633a2$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a24d46adbe633a2$export$807fef2beb9debc2, null));
const $9a24d46adbe633a2$var$tabsWrapperSkeletonStyles = (0, $1DXK0.xcss)({
    gap: 'space.150',
    height: '32px',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockEnd: 'space.150',
    marginBlockStart: 'space.100',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $9a24d46adbe633a2$var$tabSkeletonStyles = (0, $1DXK0.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $9a24d46adbe633a2$var$horizontalNavWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.150',
    blockSize: '104px'
});
const $9a24d46adbe633a2$var$baseSkeletonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small'
});
const $9a24d46adbe633a2$var$breadcrumbStyles = (0, $1DXK0.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '60px',
    marginInlineStart: 'space.300',
    marginBlockEnd: 'space.025'
});
const $9a24d46adbe633a2$var$primaryContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $9a24d46adbe633a2$var$squareStyles = (0, $1DXK0.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $9a24d46adbe633a2$var$headerWrapperStyles = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.050'
});
const $9a24d46adbe633a2$var$projectTitleStyles = (0, $1DXK0.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $9a24d46adbe633a2$var$actionStyles = (0, $1DXK0.xcss)({
    marginInlineEnd: 'space.300'
});

});

parcelRegister("fI1XL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira_amplitude_sr_phase_2', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("iG8Rc")
]).then(()=>parcelRequire('3nLhB'));

});


parcelRegister("9R5AI", function(module, exports) {
$parcel$export(module.exports, "AsyncHorizontalNavPlans", () => $37bd3dfaad7af547$export$84e1a5f003939496);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $37bd3dfaad7af547$var$LazyHorizontalPlansNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("27mPd")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
});
const $37bd3dfaad7af547$export$84e1a5f003939496 = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-software-plans-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37bd3dfaad7af547$var$LazyHorizontalPlansNav, {
        store: store
    }));

});
parcelRegister("27mPd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("cE4JZ")),
    $ewTvA("3yAl4"),
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("1jMTE")
]).then(()=>parcelRequire('6UdDE'));

});


parcelRegister("6nQNr", function(module, exports) {
$parcel$export(module.exports, "useHorizontalNavComponent", () => $fad07f088ee1c47d$export$205771a0e64e4c7c);

var $hS1gr = parcelRequire("hS1gr");

var $FhXEJ = parcelRequire("FhXEJ");

var $hih5V = parcelRequire("hih5V");

var $2aY2d = parcelRequire("2aY2d");

var $iZ2Qf = parcelRequire("iZ2Qf");

var $kfvK2 = parcelRequire("kfvK2");

const $fad07f088ee1c47d$export$965942f8308cd740 = (0, $kfvK2.createRouterSelector)((state)=>(0, $iZ2Qf.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
const $fad07f088ee1c47d$export$205771a0e64e4c7c = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    const hasBoardSettingsPageQueryParam = $fad07f088ee1c47d$export$965942f8308cd740();
    if (route.navigation?.horizontal == null) return null;
    // Shared horizontal navigation routes that currently live in business projects on prod
    // but we want to remove horizontal navigation on with the navigation redesign
    if (route.navigation.horizontal === (0, $aa97a50ba70be130$export$712453ef44fd2eba)) return null;
    // Board settings pages should not show the horizontal nav.
    // This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
    // as the board settings pages. This code should be removed once the board settings pages have
    // their own dedicated route names.
    if (route.group === 'classic-software' && hasBoardSettingsPageQueryParam) return null;
    if (route.navigation.horizontal === (0, $aa97a50ba70be130$export$9ab1d1d726b36319)) switch(projectData?.projectType){
        case 0, $FhXEJ.CORE_PROJECT:
            return 0, $hS1gr.AsyncHorizontalNavJira;
        case 0, $FhXEJ.SOFTWARE_PROJECT:
            return 0, $hS1gr.AsyncHorizontalNavJira;
        default:
            return null;
    }
    return route.navigation.horizontal;
};

});
parcelRegister("iZ2Qf", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", () => $06745e3d238ee19b$export$128e24da52662cdd);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", () => $06745e3d238ee19b$export$efdecbe4c9f1cd2c);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION", () => $06745e3d238ee19b$export$1154ed64d0d99951);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", () => $06745e3d238ee19b$export$7cadd2a48a9ff918);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", () => $06745e3d238ee19b$export$a546b6d48878ce6f);
$parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", () => $06745e3d238ee19b$export$8cc83ae2b6885e0);
$parcel$export(module.exports, "boardSettingsQueryConfigParamValues", () => $06745e3d238ee19b$export$a9ebdab56bd9c0c3);
$parcel$export(module.exports, "SETTINGS_CONFIG", () => $06745e3d238ee19b$export$2a56ee2f9c41b5a7);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $06745e3d238ee19b$export$b893894941c14e43);
$parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", () => $06745e3d238ee19b$export$d14d5a7c294329c5);
$parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", () => $06745e3d238ee19b$export$1e63b013f0e45de0);
$parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", () => $06745e3d238ee19b$export$68030ac1ea4abd4c);
$parcel$export(module.exports, "BACKLOG_FEATURE_KEY", () => $06745e3d238ee19b$export$e1671d3447ddd5ad);
$parcel$export(module.exports, "SPRINTS_FEATURE_KEY", () => $06745e3d238ee19b$export$46efc2c8d8106cff);
const $06745e3d238ee19b$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
const $06745e3d238ee19b$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
const $06745e3d238ee19b$export$1154ed64d0d99951 = 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
const $06745e3d238ee19b$export$7cadd2a48a9ff918 = `${$06745e3d238ee19b$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
const $06745e3d238ee19b$export$a546b6d48878ce6f = 'Epic';
const $06745e3d238ee19b$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
    'cardColors',
    'cardLayout',
    'columns',
    'default',
    'estimation',
    'filter',
    'swimlanes',
    'time',
    'timelineConfig',
    'quickFilters',
    'dateFields'
];
const $06745e3d238ee19b$export$8cc83ae2b6885e0 = new Set($06745e3d238ee19b$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
const $06745e3d238ee19b$export$a9ebdab56bd9c0c3 = Object.fromEntries($06745e3d238ee19b$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
        key,
        key
    ]));
const $06745e3d238ee19b$export$2a56ee2f9c41b5a7 = {
    default: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    filter: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    columns: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.columns,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    swimlanes: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.swimlanes,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    quickFilters: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.quickFilters,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardColors: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.cardColors,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardLayout: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.cardLayout,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    estimation: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.estimation,
        userLocatedBoardAllowed: true,
        kanbanAllowed: false,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    time: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.time,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    timelineConfig: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.timelineConfig,
        userLocatedBoardAllowed: false,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    dateFields: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.dateFields,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled })=>isCalendarEnabled,
        jswAllowed: false
    }
};
const $06745e3d238ee19b$export$773ca4f5fb67778b = 60000;
const $06745e3d238ee19b$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $06745e3d238ee19b$export$d14d5a7c294329c5 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'ADMINISTER_PARENT_PROJECT';
const $06745e3d238ee19b$export$1e63b013f0e45de0 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'USER_PICKER';
const $06745e3d238ee19b$export$68030ac1ea4abd4c = 'ADMINISTER';
const $06745e3d238ee19b$export$e1671d3447ddd5ad = 'BACKLOG';
const $06745e3d238ee19b$export$46efc2c8d8106cff = 'SPRINTS';
const $06745e3d238ee19b$export$a1046f102eae498 = 'ENABLED';

});


parcelRegister("kUoGK", function(module, exports) {
$parcel$export(module.exports, "getSoftwareThemedRoutes", () => $792c5cf1d308dd5d$export$8b0967e3892c7b59);
$parcel$export(module.exports, "useSoftwareProjectTheming", () => $792c5cf1d308dd5d$export$4c26676caf6bb553);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $2aY2d = parcelRequire("2aY2d");

var $FhXEJ = parcelRequire("FhXEJ");

var $1302Y = parcelRequire("1302Y");

var $cxKOj = parcelRequire("cxKOj");

var $hbF3h = parcelRequire("hbF3h");

var $i7yNt = parcelRequire("i7yNt");
const $792c5cf1d308dd5d$var$defaultValues = {
    hasSoftwareTheming: false,
    isSoftwareFullTheming: false,
    isSoftwareProject: false
};
const $792c5cf1d308dd5d$export$c4b7ea2942f2d0e = (0, $kfvK2.createRouterSelector)((state)=>state.route.name);
const $792c5cf1d308dd5d$export$8838ccecebb0c319 = (0, $kfvK2.createRouterSelector)((state)=>state.match.url);
const $792c5cf1d308dd5d$export$52b606e2ebcbaae2 = ()=>{
    if (!(0, $1302Y.getIsSoftwareThemingEnabled)()) return $792c5cf1d308dd5d$var$defaultValues;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRoute = $792c5cf1d308dd5d$export$c4b7ea2942f2d0e();
    const isSoftwareProject = projectData?.projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
    if (!isSoftwareProject) return $792c5cf1d308dd5d$var$defaultValues;
    // temporarily disable theming for calendar
    // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: isSoftwareProject
    };
    const isM2Enabled = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)();
    const hasSoftwareTheming = isM2Enabled ? isSoftwareProject && (0, $i7yNt.getSoftwareThemeRoutesM2)().has(currentRoute) && (0, $1302Y.getIsSoftwareThemingM2Enabled)() // Only fire exposure if we are on a themed route
     : isSoftwareProject && (0, $i7yNt.getSoftwareThemeRoutes)().has(currentRoute) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = isM2Enabled ? hasSoftwareTheming && (0, $i7yNt.getSoftwareFullThemeRoutesM2)().has(currentRoute) : hasSoftwareTheming && (0, $i7yNt.getSoftwareFullThemeRoutes)().has(currentRoute);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $792c5cf1d308dd5d$export$8b0967e3892c7b59 = ()=>{
    const allThemedSoftwareProjectRoutes = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() ? (0, $i7yNt.getSoftwareThemeRoutesM2)() : (0, $i7yNt.getSoftwareThemeRoutes)();
    const fullThemedSoftwareProjectRoutes = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() ? (0, $i7yNt.getSoftwareFullThemeRoutesM2)() : (0, $i7yNt.getSoftwareFullThemeRoutes)();
    // Enable theming for the shared routes no matter which milestone we are in
    allThemedSoftwareProjectRoutes.add('project-pages');
    allThemedSoftwareProjectRoutes.add('project-components');
    fullThemedSoftwareProjectRoutes.add('project-pages');
    return {
        allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes,
        fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes
    };
};
const $792c5cf1d308dd5d$var$useSoftwareProjectThemingSimplified = ()=>{
    const currentRoute = $792c5cf1d308dd5d$export$c4b7ea2942f2d0e();
    const currentUrl = $792c5cf1d308dd5d$export$8838ccecebb0c319();
    const { allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes, fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes } = $792c5cf1d308dd5d$export$8b0967e3892c7b59();
    const isSoftwareProject = allThemedSoftwareProjectRoutes.has(currentRoute) && (currentUrl.includes('/jira/software/projects/') || currentUrl.includes('/jira/software/c/projects/') || currentRoute === 'issue');
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    return (0, $eJOHy.useMemo)(()=>{
        if (!isSoftwareProject || !(0, $1302Y.getIsSoftwareThemingEnabled)()) return $792c5cf1d308dd5d$var$defaultValues;
        // temporarily disable theming for calendar
        // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
        if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
            hasSoftwareTheming: false,
            isSoftwareFullTheming: false,
            isSoftwareProject: isSoftwareProject
        };
        return {
            hasSoftwareTheming: allThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareFullTheming: fullThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareProject: isSoftwareProject
        };
    }, [
        isSoftwareProject,
        isSoftwareCalendarRoute,
        allThemedSoftwareProjectRoutes,
        currentRoute,
        fullThemedSoftwareProjectRoutes
    ]);
};
const $792c5cf1d308dd5d$export$4c26676caf6bb553 = (0, $hbF3h.functionWithCondition)(()=>(0, $cxKOj.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false), $792c5cf1d308dd5d$var$useSoftwareProjectThemingSimplified, $792c5cf1d308dd5d$export$52b606e2ebcbaae2);

});
parcelRegister("1302Y", function(module, exports) {
$parcel$export(module.exports, "getIsSoftwareThemingEnabled", () => $02571dfd61e26a65$export$a505f57c5130832f);
$parcel$export(module.exports, "getIsSoftwareThemingM2Enabled", () => $02571dfd61e26a65$export$4fa2eaefe7d59f41);
$parcel$export(module.exports, "getIsSoftwareThemingM2EnabledNoExposure", () => $02571dfd61e26a65$export$8a1bc0266a614408);

var $6zXPf = parcelRequire("6zXPf");

var $cxKOj = parcelRequire("cxKOj");
const $02571dfd61e26a65$export$a505f57c5130832f = ()=>(0, $6zXPf.getWillShowNav4)() && (0, $cxKOj.expVal)('jira_theming_milestone_1', 'isEnabled', false);
const $02571dfd61e26a65$export$4fa2eaefe7d59f41 = ()=>$02571dfd61e26a65$export$a505f57c5130832f() && (0, $cxKOj.expVal)('jira_theming_milestone_2', 'isEnabled', false);
const $02571dfd61e26a65$export$8a1bc0266a614408 = ()=>{
    if (!$02571dfd61e26a65$export$a505f57c5130832f()) return false;
    const [expConfig] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_theming_milestone_2');
    return expConfig.get('isEnabled', false);
};

});

parcelRegister("i7yNt", function(module, exports) {
$parcel$export(module.exports, "getSoftwareFullThemeRoutes", () => $686f9881c0e0ac79$export$2763881c45550362);
$parcel$export(module.exports, "getSoftwareFullThemeRoutesM2", () => $686f9881c0e0ac79$export$b8224211dbf2b52);
$parcel$export(module.exports, "getSoftwareThemeRoutes", () => $686f9881c0e0ac79$export$89c22b5407a942a4);
$parcel$export(module.exports, "getSoftwareThemeRoutesM2", () => $686f9881c0e0ac79$export$1801e4f1cddaf84b);
// consolidate the software themed routes to src/packages/platform/project-theme/page-container/src/controllers/project-theme/constants.tsx
// when we migrate the software project theming to business

var $4cTDP = parcelRequire("4cTDP");
const $686f9881c0e0ac79$export$3c8d79af57f2246c = ()=>{
    if ((0, $4cTDP.fg)('jira_list_nin_merge')) return new Set([
        'issue',
        'software-backlog',
        'rapidboard-backlog',
        'software-timeline',
        'software-timeline-classic',
        'software-issue-navigator',
        'software-list',
        'software-list-classic',
        'issue-navigator-classic'
    ]);
    return new Set([
        'issue',
        'software-backlog',
        'rapidboard-backlog',
        'software-timeline',
        'software-timeline-classic',
        'software-issue-navigator',
        'issue-navigator-classic'
    ]);
};
const $686f9881c0e0ac79$export$2763881c45550362 = ()=>{
    if ((0, $4cTDP.fg)('jira_list_nin_merge')) return new Set([
        'software-boards',
        'rapidboard-board',
        'software-calendar',
        'software-calendar-classic',
        'software-summary',
        'software-summary-classic'
    ]);
    return new Set([
        'software-boards',
        'rapidboard-board',
        'software-calendar',
        'software-calendar-classic',
        'software-list',
        'software-list-classic',
        'software-summary',
        'software-summary-classic'
    ]);
};
const $686f9881c0e0ac79$export$3d9f5dde05195378 = ()=>{
    if ((0, $4cTDP.fg)('jira_list_nin_merge')) return new Set([
        'issue',
        'software-timeline',
        'software-timeline-classic',
        'software-issue-navigator',
        'software-list',
        'software-list-classic',
        'issue-navigator-classic'
    ]);
    return new Set([
        'issue',
        'software-timeline',
        'software-timeline-classic',
        'software-issue-navigator',
        'issue-navigator-classic'
    ]);
};
const $686f9881c0e0ac79$export$b8224211dbf2b52 = ()=>{
    if ((0, $4cTDP.fg)('jira_list_nin_merge')) return new Set([
        'software-boards',
        'rapidboard-board',
        'software-calendar',
        'software-calendar-classic',
        'software-summary',
        'software-summary-classic',
        'software-backlog',
        'rapidboard-backlog',
        'project-pages',
        'software-form-classic',
        'software-form',
        'software-form-builder-classic',
        'software-form-builder'
    ]);
    return new Set([
        'software-boards',
        'rapidboard-board',
        'software-calendar',
        'software-calendar-classic',
        'software-list',
        'software-list-classic',
        'software-summary',
        'software-summary-classic',
        'software-backlog',
        'rapidboard-backlog',
        'project-pages',
        'software-form-classic',
        'software-form',
        'software-form-builder-classic',
        'software-form-builder'
    ]);
};
const $686f9881c0e0ac79$export$89c22b5407a942a4 = ()=>new Set([
        ...$686f9881c0e0ac79$export$3c8d79af57f2246c(),
        ...$686f9881c0e0ac79$export$2763881c45550362()
    ]);
const $686f9881c0e0ac79$export$1801e4f1cddaf84b = ()=>new Set([
        ...$686f9881c0e0ac79$export$3d9f5dde05195378(),
        ...$686f9881c0e0ac79$export$b8224211dbf2b52()
    ]);

});


parcelRegister("5OvV4", function(module, exports) {
$parcel$export(module.exports, "SHARED_THEMED_ROUTES", () => $5c8700be19e573c2$export$6e841237e4270ee5);
$parcel$export(module.exports, "getBusinessProjectForcedInsetRoutes", () => $5c8700be19e573c2$export$2648e960168c60eb);
$parcel$export(module.exports, "BUSINESS_PROJECT_THEMED_ROUTES", () => $5c8700be19e573c2$export$92da73f6b515b9da);

var $4cTDP = parcelRequire("4cTDP");
const $5c8700be19e573c2$export$6e841237e4270ee5 = new Set([
    'project-components',
    'project-pages'
]);
const $5c8700be19e573c2$export$2648e960168c60eb = ()=>{
    if ((0, $4cTDP.fg)('jira_list_nin_merge')) return new Set([
        'classic-business-list'
    ]);
    return new Set([]);
};
const $5c8700be19e573c2$export$92da73f6b515b9da = new Set([
    'classic-business-approvals',
    'classic-business-overview-calendar',
    'classic-business-sample-onboarding',
    'classic-business-form-submit',
    'classic-business-reports-overview',
    'classic-business-overview-summary',
    'classic-business-view-not-found',
    'classic-business-form-submit-public',
    'classic-business-shortcut',
    'classic-business-form-builder',
    'classic-business-form',
    'classic-business-timeline',
    'classic-business-attachments',
    'classic-business-overview-redirect',
    'classic-business-redirect',
    'classic-business-list',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-overview-timeline',
    'classic-business-summary',
    'issue-navigator-core',
    'classic-business-archived-work-items',
    ...$5c8700be19e573c2$export$6e841237e4270ee5
]);

});


parcelRegister("djhHt", function(module, exports) {
$parcel$export(module.exports, "sharedLayout", () => $dfa1b1acb991d626$export$5f4dc7c98070d93e);

var $eJOHy = parcelRequire("eJOHy");

var $eaQii = parcelRequire("eaQii");

var $j5EMD = parcelRequire("j5EMD");

var $4KUH1 = parcelRequire("4KUH1");

var $FhXEJ = parcelRequire("FhXEJ");

var $8R3rZ = parcelRequire("8R3rZ");

var $71DNl = parcelRequire("71DNl");

var $56K43 = parcelRequire("56K43");

var $cKuba = parcelRequire("cKuba");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $2HxHL = parcelRequire("2HxHL");

var $bJscI = parcelRequire("bJscI");

var $86XkI = parcelRequire("86XkI");

var $MBWwk = parcelRequire("MBWwk");

var $4cTDP = parcelRequire("4cTDP");

var $28GDA = parcelRequire("28GDA");

var $aY5Xx = parcelRequire("aY5Xx");

var $cosWN = parcelRequire("cosWN");

var $hWQJk = parcelRequire("hWQJk");

var $eWzpp = parcelRequire("eWzpp");

var $imyEu = parcelRequire("imyEu");

var $e5yn1 = parcelRequire("e5yn1");

var $38W5l = parcelRequire("38W5l");

var $6u6pq = parcelRequire("6u6pq");

var $3Kq2h = parcelRequire("3Kq2h");

var $6dwgv = parcelRequire("6dwgv");

var $fp9AW = parcelRequire("fp9AW");

var $hMGR1 = parcelRequire("hMGR1");

var $cHtIB = parcelRequire("cHtIB");

var $b4mGA = parcelRequire("b4mGA");

var $bwRvc = parcelRequire("bwRvc");

var $bQWwW = parcelRequire("bQWwW");

var $bGKoK = parcelRequire("bGKoK");

var $gsuME = parcelRequire("gsuME");

var $koAZ4 = parcelRequire("koAZ4");

var $HPMxS = parcelRequire("HPMxS");

var $lb6FK = parcelRequire("lb6FK");

var $lHlwJ = parcelRequire("lHlwJ");

var $41vjk = parcelRequire("41vjk");

var $cYjM0 = parcelRequire("cYjM0");

var $6Yzhs = parcelRequire("6Yzhs");

var $ajCkH = parcelRequire("ajCkH");

var $7cv6Z = parcelRequire("7cv6Z");

var $jjTNC = parcelRequire("jjTNC");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$Global = (0, $bQWwW.lazy)(()=>(parcelRequire("NtyAW")), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$Navigation = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("2Bg5R")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$Trackers = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("iSvWF")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$RemoteActions = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("4AwVD")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
});

// No need for a whole chunk for a single component
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$AfterPaintIssuePreEval = (0, $bQWwW.lazyAfterPaint)(/* eslint-disable-next-line jira/import/webpack-magic-comment-entries */ ()=>(parcelRequire("l3kjz")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/AfterPaintIssuePreEval.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$AsyncBrowserStorageControlsInit = (0, $bQWwW.lazy)(()=>(parcelRequire("98vBV")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
});
const $dfa1b1acb991d626$var$runtimeProps = {};
const $dfa1b1acb991d626$var$entryPointParams = {};
const $dfa1b1acb991d626$export$3859d35c5447350b = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $fp9AW.rovoVideoModalEntryPoint), $dfa1b1acb991d626$var$entryPointParams);
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, isAnonymous: isAnonymous } = (0, $koAZ4.useTenantContext)();
    const { loading: loadingProject, data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const { start: messageStarted } = (0, $HPMxS.useCoordinationClient)();
    const rovoEntitlement = (0, $lb6FK.useRovoEntitlementResource)();
    const isRovoLLMEnabled = !!rovoEntitlement?.data?.isRovoLLMEnabled;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        const shouldShowRovoVideoModal = async ()=>{
            const hasSeenRovoOnboarding = await (0, $gsuME.getRovoVideoOnboardingHash)(atlassianAccountId);
            if (// eslint-disable-next-line jira/ff/no-preconditioning
            !loadingProject && (0, $bGKoK.isJiraSoftware)(projectType) && (0, $4cTDP.fg)('rovo_video_player_gate') && !hasSeenRovoOnboarding && !isAnonymous && isRovoLLMEnabled) {
                const hasMessageStarted = await messageStarted();
                if (hasMessageStarted) entryPointActions.load();
            }
        };
        shouldShowRovoVideoModal();
    }, [
        atlassianAccountId,
        cloudId,
        entryPointActions,
        isAnonymous,
        loadingProject,
        messageStarted,
        projectType,
        isRovoLLMEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.rovoVideoPlayer",
        packageName: "rovo-video-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $dfa1b1acb991d626$var$runtimeProps
    });
};
const $dfa1b1acb991d626$export$bb0d8fff645668ce = ()=>{
    const cloudID = (0, $cHtIB.useCloudId)();
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type) || null;
    const productKey = (0, $FhXEJ.projectTypeToCanonicalId)(projectType);
    const deferEditionModalEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudID,
            productKey: productKey
        }), [
        cloudID,
        productKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $56K43.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
    const onComplete = (0, $eJOHy.useCallback)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $71DNl.AsyncDeferEditionEPCheckWrapper), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $dfa1b1acb991d626$var$runtimeProps
    }));
};
const $dfa1b1acb991d626$var$EndOfTrialModalEntryPoint = ()=>{
    const hasLoaded = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $cKuba.endOfTrialExtensionEntryPoint), {});
    if (!hasLoaded.current) {
        hasLoaded.current = true;
        entryPointActions.load();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.endOfTrialExtension",
        packageName: "jira-end-of-trial-extension",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $dfa1b1acb991d626$var$runtimeProps
    });
};
const $dfa1b1acb991d626$var$DeferRovoVideoModal = (0, $bJscI.componentWithFG)('rovo_video_player_gate', $dfa1b1acb991d626$export$3859d35c5447350b, ()=>null);
const $dfa1b1acb991d626$var$ConditionalEndOfTrialExtensionModal = (0, $bJscI.componentWithFG)('end_of_trial_extension_kill_switch', $dfa1b1acb991d626$var$EndOfTrialModalEntryPoint, ()=>null);
const $dfa1b1acb991d626$var$ConditionalGlobalAiRovoButton = (0, $bJscI.componentWithFG)('global_rovo_button_in_jira', (0, $eaQii.GlobalAiRovoButtonWithBoundary), ()=>null);
const $dfa1b1acb991d626$var$ConditionalAiRovoCurrentRouteConfigurationProvider = (0, $bJscI.componentWithFG)('global_rovo_button_in_jira', (0, $j5EMD.AiRovoCurrentRouteConfigurationProviderWithBoundary), ()=>null);
const $dfa1b1acb991d626$var$ConditionalJiraTrialAssistantWelcomeAutoPopup = (0, $bJscI.componentWithFG)('custom_rovo_onboarding_agent_gate', (0, $cYjM0.JiraTrialAssistantWelcomeAutoPopup), ()=>null);
$dfa1b1acb991d626$export$bb0d8fff645668ce.displayName = 'DeferEditionModal';
$dfa1b1acb991d626$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
$dfa1b1acb991d626$var$ConditionalEndOfTrialExtensionModal.displayName = 'ConditionalEndOfTrialExtensionModal';
$dfa1b1acb991d626$var$ConditionalGlobalAiRovoButton.displayName = 'ConditionalGlobalAiRovoButton';
$dfa1b1acb991d626$var$ConditionalAiRovoCurrentRouteConfigurationProvider.displayName = 'ConditionalAiRovoCurrentRouteConfigurationProvider';
$dfa1b1acb991d626$var$ConditionalJiraTrialAssistantWelcomeAutoPopup.displayName = 'ConditionalJiraTrialAssistantWelcomeAutoPopup';
const $dfa1b1acb991d626$var$sharedGlobalComponents = [
    ...false ? [] : [
        (0, $86XkI.PriorityManager),
        (0, $e5yn1.MatchedRouteListener),
        (0, $38W5l.PreviousRouterStateListener),
        (0, $ajCkH.LoadingPhaseManager),
        (0, $28GDA.LoadingBarUIController),
        (0, $4KUH1.default),
        (0, $6Yzhs.BreadcrumbAdapter),
        (0, $6u6pq.default),
        (0, $imyEu.PageDwellAnalyticsListener),
        (0, $hWQJk.ImperativeAPI),
        (0, $7cv6Z.TrackClicksBeforeTTI),
        (0, $hMGR1.default),
        (0, $b4mGA.AsyncUpflowIframeComponent),
        (0, $bwRvc.JiraHeritageLoader),
        $dfa1b1acb991d626$var$AsyncBrowserStorageControlsInit,
        (0, $lHlwJ.CrossJoinNudges),
        (0, $2HxHL.default),
        $dfa1b1acb991d626$var$RemoteActions,
        $dfa1b1acb991d626$export$bb0d8fff645668ce,
        $dfa1b1acb991d626$var$DeferRovoVideoModal,
        (0, $3Kq2h.AsyncRecommendPremiumToStandardModalWrapper),
        $dfa1b1acb991d626$var$ConditionalEndOfTrialExtensionModal,
        (0, $41vjk.AsyncSSRFailureDisplay),
        $dfa1b1acb991d626$var$ConditionalJiraTrialAssistantWelcomeAutoPopup,
        // Integrations - Issue View Modal, Create Project Drawer & Create dashboard modal
        (0, $jjTNC.Integrations)
    ],
    $dfa1b1acb991d626$var$Global,
    $dfa1b1acb991d626$var$Navigation,
    $dfa1b1acb991d626$var$Trackers,
    (0, $MBWwk.renderInBackgroundPriority)($dfa1b1acb991d626$var$AfterPaintIssuePreEval),
    $dfa1b1acb991d626$var$ConditionalGlobalAiRovoButton,
    $dfa1b1acb991d626$var$ConditionalAiRovoCurrentRouteConfigurationProvider
];
const $dfa1b1acb991d626$export$5f4dc7c98070d93e = (0, $6dwgv.createLayout)({
    rightSidebars: [
        (0, $aY5Xx.SafeHelpPanel),
        (0, $8R3rZ.SafeConversationAssistantPanel),
        (0, $cosWN.SafeEmbeddedConfluencePanel)
    ],
    globalComponents: $dfa1b1acb991d626$var$sharedGlobalComponents
});

});
parcelRegister("eaQii", function(module, exports) {
$parcel$export(module.exports, "GlobalAiRovoButtonWithBoundary", () => $3b93d4d4482b9a5c$export$1548f340e8b33131);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $6n4Fq = parcelRequire("6n4Fq");
const $3b93d4d4482b9a5c$export$1548f340e8b33131 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "global-ai-rovo-button",
        packageName: "ai-rovo-button",
        teamName: "reverie"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6n4Fq.GlobalAiRovoButton), null));
};

});
parcelRegister("6n4Fq", function(module, exports) {
$parcel$export(module.exports, "GlobalAiRovoButton", () => $0d573ad94004a932$export$c202888b376a61ca);

var $eJOHy = parcelRequire("eJOHy");

var $5KtrL = parcelRequire("5KtrL");

var $4cTDP = parcelRequire("4cTDP");

var $elL9D = parcelRequire("elL9D");

var $lb6FK = parcelRequire("lb6FK");

var $e6s1C = parcelRequire("e6s1C");

var $6PAED = parcelRequire("6PAED");

var $cZI7k = parcelRequire("cZI7k");

var $5XGSn = parcelRequire("5XGSn");
const $0d573ad94004a932$export$c202888b376a61ca = ()=>{
    const isRovoAvailableForRoute = (0, $5XGSn.useIsRovoAvailableForRoute)();
    const { data: rovoEntitlementData } = (0, $lb6FK.useRovoEntitlementResource)();
    const showRovoButton = rovoEntitlementData?.isRovoLLMEnabled ?? false;
    const licenseState = (0, $e6s1C.useLicenseStates)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $6PAED.useApplicationPermissions)();
    const softwareAccessEnabled = licenseState.software === (0, $5KtrL.LICENSE_STATE_ACTIVE) && hasSoftwareAccess;
    if (!isRovoAvailableForRoute || !showRovoButton) return null;
    if (!softwareAccessEnabled && (0, $4cTDP.fg)('global_rovo_button_in_jira')) return null;
    /*
		This is a hybrid solution that allow us to do eager fetching of the panel modules on button hover,
		without having to props drill the panel placeholder component down the tree.
		https://hello.atlassian.net/wiki/spaces/AM3/pages/5585113512/LDR+Loading+Strategy+for+Rovo+Side+Panel+using+Entrypoints
	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $elL9D.JiraBottomRightCornerOutlet), {
        orderFromRight: 0,
        id: "floating-element-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZI7k.AiRovoButtonWrapperRefresh), null));
};

});
parcelRegister("elL9D", function(module, exports) {
$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $ef1c857e9098bbfe$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aQK2r = parcelRequire("aQK2r");

var $fceQU = parcelRequire("fceQU");

var $h47gY = parcelRequire("h47gY");

var $fqYrC = parcelRequire("fqYrC");
const $ef1c857e9098bbfe$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id, testId: testId })=>{
    const [portalWrapper, setPortalWrapper] = (0, $eJOHy.useState)(null);
    const container = (0, $fqYrC.useBottomRightCornerContainer)();
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $fqYrC.useBottomRightCornerActions)();
    (0, $eJOHy.useEffect)(()=>{
        // Portal wrapper creation deferred to after hydration is completed
        const document = (0, $fceQU.getDocument)();
        if (document != null) {
            const portalEl = document.createElement('div');
            if (testId) portalEl.setAttribute('data-testid', testId);
            setPortalWrapper(portalEl);
        }
    }, [
        testId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!portalWrapper) return;
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            container.insertBefore(portalWrapper, container.children[indexToRender]);
        }
        return ()=>{
            container?.removeChild(portalWrapper);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal,
        portalWrapper
    ]);
    if (portalWrapper != null) return /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef1c857e9098bbfe$var$StyledOutlet, null, children), portalWrapper);
    return null;
};
const $ef1c857e9098bbfe$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef1c857e9098bbfe$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef1c857e9098bbfe$var$StyledOutlet = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cZI7k", function(module, exports) {
$parcel$export(module.exports, "AiRovoButtonWrapperRefresh", () => $d80752da65ec8e7e$export$777dceacf2f74fc1);

var $eJOHy = parcelRequire("eJOHy");

var $34EqU = parcelRequire("34EqU");

var $cVYIs = parcelRequire("cVYIs");

var $cHtIB = parcelRequire("cHtIB");

var $g9Vr6 = parcelRequire("g9Vr6");

var $gxC9D = parcelRequire("gxC9D");

var $icfHo = parcelRequire("icfHo");
const $d80752da65ec8e7e$export$777dceacf2f74fc1 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const configuration = (0, $34EqU.useAiRovoCurrentRouteConfiguration)();
    const sidebarApi = (0, $gxC9D.useConversationAssistantSidebarApi)({});
    const { setNudges: setNudges } = (0, $icfHo.useSourceAIActions)('jira-ai-rovo-button');
    (0, $eJOHy.useEffect)(()=>{
        setNudges(configuration.nudges ?? []);
    }, [
        configuration.nudges,
        setNudges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVYIs.AISmartButtonRefresh), {
        product: "jira",
        cloudId: cloudId,
        orgId: orgId,
        isNav4Enabled: true,
        sidebarApi: sidebarApi,
        productPage: "jira",
        getActions: configuration.getActions
    });
};

});
parcelRegister("34EqU", function(module, exports) {
$parcel$export(module.exports, "useAiRovoCurrentRouteConfiguration", () => $975e6592988389a3$export$bdd203042abc94ea);

var $lPvn5 = parcelRequire("lPvn5");
const $975e6592988389a3$export$bdd203042abc94ea = ()=>{
    const configuration = (0, $lPvn5.useAiRovoCurrentRouteConfigurationStore)((state)=>state.configuration);
    return configuration;
};

});
parcelRegister("lPvn5", function(module, exports) {
$parcel$export(module.exports, "useAiRovoCurrentRouteConfigurationStoreActions", () => $5a39a006163e7c04$export$9dbea1cf0c57eec9);
$parcel$export(module.exports, "useAiRovoCurrentRouteConfigurationStore", () => $5a39a006163e7c04$export$fe720c8ec7da3856);

var $iJq0l = parcelRequire("iJq0l");

var $GtRbT = parcelRequire("GtRbT");
const $5a39a006163e7c04$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $5a39a006163e7c04$var$initialState = {
    configuration: $5a39a006163e7c04$var$noopConfiguration
};
const $5a39a006163e7c04$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $5a39a006163e7c04$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $5a39a006163e7c04$export$89f578e0312f4574 = (0, $GtRbT.createStore)({
    initialState: $5a39a006163e7c04$var$initialState,
    actions: $5a39a006163e7c04$var$actions
});
const $5a39a006163e7c04$export$9dbea1cf0c57eec9 = (0, $iJq0l.createActionsHook)($5a39a006163e7c04$export$89f578e0312f4574);
const $5a39a006163e7c04$export$fe720c8ec7da3856 = (0, $iJq0l.createSelectorHook)($5a39a006163e7c04$export$89f578e0312f4574);

});


parcelRegister("cVYIs", function(module, exports) {
$parcel$export(module.exports, "AISmartButtonRefresh", () => $4113a73656343166$export$bdf1977621b5251d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $6qaBj = parcelRequire("6qaBj");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $isfIV = parcelRequire("isfIV");

var $dsB7O = parcelRequire("dsB7O");

var $1s9qD = parcelRequire("1s9qD");

var $3CuD0 = parcelRequire("3CuD0");

var $ihZdh = parcelRequire("ihZdh");

var $aioom = parcelRequire("aioom");

var $4GItf = parcelRequire("4GItf");
const $4113a73656343166$var$ANIMATION_DURATION = 150;
const $4113a73656343166$var$styles = {
    wrapper: "_kqswh2mm",
    animatedMiniModalBefore: "_v564gsou _8hrz1x0m _3um015vq _tzy42wxo _t9ec1u4m _kdam1pry _m6k413u5 _sedt6rww",
    animatedMiniModalAfter: "_tzy4kb7n _t9ec1h7a _3um0ewfl _kdam1ogz"
};
const $4113a73656343166$export$bdf1977621b5251d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ product: product, cloudId: cloudId, isNav4Enabled: isNav4Enabled, sidebarApi: sidebarApi, productPage: productPage, orgId: orgId, getActions: getActions, analyticsAttributes: analyticsAttributes, topOffset: topOffset, isDisabled: isDisabled = false, conversationAssistantConfig: conversationAssistantConfig, overrideMiniModalWrapper: overrideMiniModalWrapper }, forwardedRef)=>{
    const hoverTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $dsB7O.useRovoButtonEventsInstrumentation)();
    const { mode: mode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable } = (0, $isfIV.useRovoExperienceAPIStore)();
    const [rovoButtonCanRender, setRovoButtonCanRender] = (0, $eJOHy.useState)(mode !== 'mini-modal');
    const [hasStartedPreloading, setHasStartedPreloading] = (0, $eJOHy.useState)(false);
    (0, $3CuD0.useDebugNudgeTriggers)();
    // 48px = nav header height, 8px = object sidebar bottom padding, 16px = AI smart button bottom margin, 8px = extra margin so it doesn't align with nav header
    const defaultTopOffset = 80;
    (0, $eJOHy.useEffect)(()=>{
        setIsMiniModalAvailable(true);
        if (!(0, $ihZdh.isBrowser)()) return;
        // Start preloading when mouse is within the bottom-right box (300px from bottom, 300px from right)
        const handleMouseMove = (event)=>{
            if ((0, $ihZdh.isBrowser)() && !hasStartedPreloading) {
                const viewportHeight = window.innerHeight;
                const viewportWidth = window.innerWidth;
                const mouseY = event.clientY;
                const mouseX = event.clientX;
                const distanceFromBottom = viewportHeight - mouseY;
                const distanceFromRight = viewportWidth - mouseX;
                if (distanceFromBottom <= 300 && distanceFromRight <= 300) {
                    (0, $1s9qD.preloadAIMiniModal)();
                    setHasStartedPreloading(true);
                }
            }
        };
        const unbind = (0, $4eDgu.bindAll)(window, [
            {
                type: 'mousemove',
                listener: handleMouseMove
            }
        ]);
        return ()=>{
            setIsMiniModalAvailable(false);
            (0, $ihZdh.isBrowser)() && unbind();
        };
    }, [
        setIsMiniModalAvailable,
        hasStartedPreloading
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'rendered',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                version: 'refresh',
                legacy: false
            },
            product: product
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Wait for the closing animation of modal to complete before showing the rovo button
        if (mode !== 'mini-modal') {
            setTimeout(()=>{
                setRovoButtonCanRender(true);
            }, $4113a73656343166$var$ANIMATION_DURATION);
            return;
        }
        setRovoButtonCanRender(false);
    }, [
        mode,
        setRovoButtonCanRender
    ]);
    const onAISmartButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((e)=>{
        toggleConversationAssistantUIMode({
            targetMode: 'mini-modal',
            sidebarApi: sidebarApi
        });
        const selectionAttributes = {};
        if ((0, $eGOwo.fg)('platform_editor_ai_aifc_analytics')) {
            const counts = (0, $aioom.selectionCountsInMainEditor)(e.currentTarget);
            if (counts != null) {
                selectionAttributes.totalSelectedWords = counts.words;
                selectionAttributes.totalSelectedChars = counts.chars;
            }
        }
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'clicked',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                ...selectionAttributes,
                version: 'refresh'
            },
            product: product
        });
        setRovoButtonCanRender(false);
    }, [
        product,
        productPage,
        analyticsAttributes,
        fireRovoButtonUIEvent,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const onAISmartButtonEnter = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        hoverTimerRef.current = setTimeout(()=>{
            fireRovoButtonUIEvent({
                source: productPage,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiSmartButton',
                attributes: {
                    product: product,
                    productPage: productPage,
                    ...analyticsAttributes,
                    version: 'refresh'
                },
                product: product
            });
        }, 1000);
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage,
        analyticsAttributes
    ]);
    const onAISmartButtonLeave = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        xcss: $4113a73656343166$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $6qaBj.cx)($4113a73656343166$var$styles.animatedMiniModalBefore, mode === 'mini-modal' && $4113a73656343166$var$styles.animatedMiniModalAfter),
                children: !sidebarApi.isSidebarOpen() && !rovoButtonCanRender && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1s9qD.AIMiniModal), {
                    product: product,
                    cloudId: cloudId,
                    orgId: orgId,
                    isNav4Enabled: isNav4Enabled,
                    sidebarApi: sidebarApi,
                    getActions: getActions,
                    topOffset: topOffset ?? defaultTopOffset,
                    conversationAssistantConfig: conversationAssistantConfig,
                    overrideMiniModalWrapper: overrideMiniModalWrapper
                })
            }),
            !sidebarApi.isSidebarOpen() && rovoButtonCanRender && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GItf.AISmartButtonUI), {
                ref: forwardedRef,
                onClick: onAISmartButtonClick,
                isDisabled: isDisabled,
                onMouseEnter: onAISmartButtonEnter,
                onMouseLeave: onAISmartButtonLeave,
                sidebarApi: sidebarApi,
                isRefreshed: true,
                product: product
            })
        ]
    });
});

});
parcelRegister("dsB7O", function(module, exports) {
$parcel$export(module.exports, "useRovoButtonEventsInstrumentation", () => $aef34e78a8759a50$export$8a94e432ef80d839);

var $eJOHy = parcelRequire("eJOHy");

var $3VCQy = parcelRequire("3VCQy");

var $ftN6c = parcelRequire("ftN6c");
const $aef34e78a8759a50$var$ANALYTICS_CHANNEL = (0, $3VCQy.FabricChannel).aiMate;
const $aef34e78a8759a50$export$8a94e432ef80d839 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEventWithOptionalChannel = (0, $eJOHy.useCallback)((event, product)=>{
        const analyticsEvent = createAnalyticsEvent(event);
        if (product === 'confluence') {
            analyticsEvent.fire();
            return;
        }
        // it goes thru the aiMate analytics listener to avoid validation per product listener
        // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
        analyticsEvent.fire($aef34e78a8759a50$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const createEventPayload = (0, $eJOHy.useCallback)((payload)=>{
        if (payload.product === 'confluence') // confluence event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
        return {
            type: 'sendUIEvent',
            data: payload
        };
        if (payload.product === 'jira') // jira event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
        // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
        return {
            actionSubject: payload.actionSubject,
            action: payload.action,
            actionSubjectId: payload.actionSubjectId,
            attributes: payload.attributes
        };
        // for any other product type we should use the default event shape
        // also if there is a custom event channel, we also should use the default event shape
        return {
            eventType: 'ui',
            ...payload
        };
    }, []);
    const fireRovoButtonUIEvent = (0, $eJOHy.useCallback)((eventData)=>{
        // Only fire the event if product is defined
        if (!eventData.product) return;
        const event = createEventPayload(eventData);
        fireEventWithOptionalChannel(event, eventData.product);
    }, [
        fireEventWithOptionalChannel,
        createEventPayload
    ]);
    return {
        fireRovoButtonUIEvent: fireRovoButtonUIEvent
    };
};

});

parcelRegister("1s9qD", function(module, exports) {
$parcel$export(module.exports, "preloadAIMiniModal", () => $27c7218efa662110$export$1f1f17d801cbb952);
$parcel$export(module.exports, "AIMiniModal", () => $27c7218efa662110$export$f36d8da28b18d2c1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lxoon = parcelRequire("lxoon");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");

var $bSJma = parcelRequire("bSJma");

var $gyQtw = parcelRequire("gyQtw");
// TODO: Remove this once we clean up the FG for mini modal static positioning
const $27c7218efa662110$var$styles = {
    miniModalStyles: "_kqswstnw _1pby9y44 _1xi2idpf _94n51osq"
};

const $27c7218efa662110$var$LazyAIMiniModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("asPwk")).then((module)=>({
            default: module.AIMiniModal
        })));

const $27c7218efa662110$export$1f1f17d801cbb952 = ()=>{
    (parcelRequire("asPwk")).then((module)=>({
            default: module.AIMiniModal
        }));
};
const $27c7218efa662110$export$f36d8da28b18d2c1 = (props)=>{
    const { isMiniModalStaticPositioningEnabled: isMiniModalStaticPositioningEnabled } = (0, $gyQtw.getChatRefreshV2DynamicConfig)();
    const mousetrapRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const setContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        mousetrapRef.current?.reset();
        if (!node) return;
        mousetrapRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($lxoon)))(node);
    }, []);
    const suppressKeyPress = (event)=>{
        mousetrapRef.current?.bind(event.key.toLocaleLowerCase(), (e)=>e.stopPropagation());
    };
    const miniModal = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bSJma.MiniModalLoadingFallbackComponent), {
                topOffset: props.topOffset || 0,
                isNav4Enabled: props.isNav4Enabled
            }),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($27c7218efa662110$var$LazyAIMiniModal, {
                ...props
            })
        });
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        ref: setContainerRef,
        onKeyDown: suppressKeyPress,
        xcss: (0, $6qaBj.cx)(isMiniModalStaticPositioningEnabled ? undefined : $27c7218efa662110$var$styles.miniModalStyles),
        testId: "ai-smart-button-mini-modal-wrapper",
        children: isMiniModalStaticPositioningEnabled && props.overrideMiniModalWrapper ? props.overrideMiniModalWrapper(miniModal) : miniModal
    });
};

});
parcelRegister("lxoon", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.1
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (0, module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("bSJma", function(module, exports) {
$parcel$export(module.exports, "MiniModalLoadingFallbackComponent", () => $bbe86bd90b9c5c14$export$a33efecb32878e39);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8wyVH = parcelRequire("8wyVH");

var $8IeH1 = parcelRequire("8IeH1");

var $5YRDd = parcelRequire("5YRDd");

var $3e2oV = parcelRequire("3e2oV");
const $bbe86bd90b9c5c14$var$styles = {
    miniModalMainContainer: "_2rko12b0 _1bsb1kdj _bfhkhp5a _16qs1cd0 _1e0c1txw _4cvr1h6o _1bah1h6o",
    rovoIcon: "_1bsbckbl _4t3ickbl"
};
const $bbe86bd90b9c5c14$export$a33efecb32878e39 = ({ topOffset: topOffset, isNav4Enabled: isNav4Enabled })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3e2oV.MainWrapper), {
        mode: "mini-modal",
        isNav4Enabled: isNav4Enabled,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            testId: "conversation-assistant-mini-modal-main-container",
            xcss: $bbe86bd90b9c5c14$var$styles.miniModalMainContainer,
            style: {
                height: `min(320px, calc(100vh - ${topOffset}px))`
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $bbe86bd90b9c5c14$var$styles.rovoIcon,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5YRDd))),
                    alt: "",
                    testId: "rovo-loading-animation"
                })
            })
        })
    });
};

});
parcelRegister("5YRDd", function(module, exports) {
module.exports = new URL("Rovo-loadingV2.b5f1b3c5.gif", import.meta.url).toString();

});

parcelRegister("3e2oV", function(module, exports) {
$parcel$export(module.exports, "MainWrapper", () => $fb9707ab0d77b742$export$6661021c36f0a701);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $67YQP = parcelRequire("67YQP");

var $lhkaL = parcelRequire("lhkaL");

var $gqJLx = parcelRequire("gqJLx");

var $lsErf = parcelRequire("lsErf");
const $fb9707ab0d77b742$var$styles = {
    wrapper: "_vchhusvi _1bsb1ina _19pkpxbi _4t3inau3 _bfhkvuon _1e0c1txw _2lx21bp4 _ae4v1fhb _4cvr1fhb",
    wrapperNav4: "_vchhusvi _1bsb1osq _4t3i1osq _bfhkvuon _1e0c1txw _2lx21bp4 _ae4v1fhb _4cvr1fhb",
    wrapperHeight: "_1tke1edt",
    externalEmbed: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq",
    fullscreenDebug: "_1r04ze3t _kqsw1n9t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4t3in7od _1bsbn7od",
    halfWidth: "_1bsb1ssb"
};
const $fb9707ab0d77b742$var$stylesBorder = {
    borderNavV3: "_1h6dmuej _189ee4h9 _1dqonqa1 _13li1mok _qrwq1mok",
    borderNavV4: "",
    borderFullScreenDebug: "_2rko1mok _1dqonqa1 _1h6d15qp _189e1mok",
    borderExternalEmbed: "",
    borderStagingArea: "_2rkopb1k _16qszucj"
};
const $fb9707ab0d77b742$var$miniModalWrapperStyles = null;
const $fb9707ab0d77b742$export$6661021c36f0a701 = ({ testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode })=>{
    const isMiniModal = mode === (0, $lsErf.ConversationAssistantUIModes).MINI_MODAL;
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements } = (0, $gqJLx.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $lhkaL.useStagingAreaState)();
    const shouldShowStagingArea = stagingAreaMode === 'inline';
    // Purely for FE team testing fullscreen where branch deploys are accessible
    // The use of localStorage and a private FF should make this safe, and it's our
    // best bet to improve dev velocity at the moment. Once Atlas has local consumption
    // we can remove this
    const fullscreenDebugEnabled = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $eGOwo.fg)('rovo_chat_show_local_frontend_components');
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
        zIndex: 500,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": testId,
            className: (0, $hcewu.default)([
                shouldUseWrapperNav4Styles ? $fb9707ab0d77b742$var$styles.wrapperNav4 : $fb9707ab0d77b742$var$styles.wrapper,
                isMiniModal ? "_2rko1j6v _1reo15vq _18m915vq _v5641kxi _16qs1cd0" : $fb9707ab0d77b742$var$styles.wrapperHeight,
                externalEmbed && $fb9707ab0d77b742$var$styles.externalEmbed,
                $fb9707ab0d77b742$var$styles.fullscreenDebug,
                $fb9707ab0d77b742$var$stylesBorder.borderFullScreenDebug
            ]),
            children: children
        })
    });
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return 'borderStagingArea';
        if (externalEmbed) return 'borderExternalEmbed';
        if (fullscreenDebugEnabled) // this is not possible because if condition above, but adding it here for completeness
        return 'borderFullScreenDebug';
        if (shouldUseWrapperNav4Styles) return 'borderNavV4';
        return 'borderNavV3';
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            shouldUseWrapperNav4Styles ? $fb9707ab0d77b742$var$styles.wrapperNav4 : $fb9707ab0d77b742$var$styles.wrapper,
            isMiniModal ? "_2rko1j6v _1reo15vq _18m915vq _v5641kxi _16qs1cd0" : $fb9707ab0d77b742$var$styles.wrapperHeight,
            externalEmbed && $fb9707ab0d77b742$var$styles.externalEmbed,
            $fb9707ab0d77b742$var$stylesBorder[getBorderStyle()],
            fullScreen && shouldShowStagingArea && $fb9707ab0d77b742$var$styles.halfWidth
        ]),
        children: children
    });
};

});
parcelRegister("lhkaL", function(module, exports) {
$parcel$export(module.exports, "useStagingArea", () => $b9f9e0bf042e7091$export$916334da9df8d04);
$parcel$export(module.exports, "useStagingAreaActions", () => $b9f9e0bf042e7091$export$8f9a13b17bec42d5);
$parcel$export(module.exports, "useStagingAreaState", () => $b9f9e0bf042e7091$export$5a57f796673aabea);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $b9f9e0bf042e7091$var$initialState = {
    messageIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: ''
};
const $b9f9e0bf042e7091$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        }
};
const $b9f9e0bf042e7091$var$store = (0, $GtRbT.createStore)({
    initialState: $b9f9e0bf042e7091$var$initialState,
    actions: $b9f9e0bf042e7091$var$actions
});
const $b9f9e0bf042e7091$export$a2795b51ce92008f = (0, $iJq0l.createHook)($b9f9e0bf042e7091$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $b9f9e0bf042e7091$export$916334da9df8d04 = (0, $iJq0l.createHook)($b9f9e0bf042e7091$var$store);
const $b9f9e0bf042e7091$export$8f9a13b17bec42d5 = (0, $iJq0l.createActionsHook)($b9f9e0bf042e7091$var$store);
const $b9f9e0bf042e7091$export$5a57f796673aabea = (0, $iJq0l.createStateHook)($b9f9e0bf042e7091$var$store);

});

parcelRegister("gqJLx", function(module, exports) {
$parcel$export(module.exports, "UIConfigProvider", () => $7e4f9929b0635875$export$3063519296e335bf);
$parcel$export(module.exports, "useUIConfig", () => $7e4f9929b0635875$export$e83755c3ab7a4493);
$parcel$export(module.exports, "createUIConfig", () => $7e4f9929b0635875$export$3e623b13d2da727a);

var $eJOHy = parcelRequire("eJOHy");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");

var $4OA5E = parcelRequire("4OA5E");
const $7e4f9929b0635875$var$initialState = {
    fullScreen: false,
    externalEmbed: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false
    },
    // ChatRefreshV1Exp
    isRenderRefreshEnabled: false,
    isNewInputEnabled: false,
    isNewNavigationEnabled: false,
    isNewEmptyScreenEnabled: false,
    dynamicConfig: {
        rovoChatRefreshV2Config: (0, $4OA5E.initialState)
    }
};
const $7e4f9929b0635875$export$ab340e857ee89c62 = $7e4f9929b0635875$var$initialState;
const $7e4f9929b0635875$var$uiConfig = /*#__PURE__*/ (0, $eJOHy.createContext)($7e4f9929b0635875$var$initialState);
const $7e4f9929b0635875$export$3063519296e335bf = $7e4f9929b0635875$var$uiConfig.Provider;
const $7e4f9929b0635875$export$e83755c3ab7a4493 = ()=>(0, $eJOHy.useContext)($7e4f9929b0635875$var$uiConfig);
const $7e4f9929b0635875$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $eGOwo.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    const isRolloutInJiraEnabled = (0, $59rsN.default).getExperimentValue('jira_ai_rovo_button', 'treatment', 'A') === 'B';
    const rovoChatRefreshV2Config = (0, $4OA5E.getChatRefreshV2DynamicConfig)({
        isRolloutInJiraEnabled: isRolloutInJiraEnabled
    });
    // Evaluate feature flag for browser context banner at conversation-assistant level
    const enableBrowserContextBanner = processedConfig?.enableBrowserContextBanner ?? (0, $59rsN.default).getExperimentValue('rovo_extension_dom_improvement', 'rovo_extension_dom_context_improvement_enabled', false, {
        fireExperimentExposure: false
    });
    return {
        ...{
            ...$7e4f9929b0635875$var$initialState,
            ...processedConfig,
            enableBrowserContextBanner: enableBrowserContextBanner,
            elements: {
                ...$7e4f9929b0635875$var$initialState.elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        },
        isRenderRefreshEnabled: isRolloutInJiraEnabled || (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isRenderRefreshEnabled', false),
        isNewInputEnabled: isRolloutInJiraEnabled || (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isNewInputEnabled', false),
        isNewNavigationEnabled: isRolloutInJiraEnabled || (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isNewNavigationEnabled', false),
        isNewEmptyScreenEnabled: isRolloutInJiraEnabled || (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isNewEmptyScreenEnabled', false),
        dynamicConfig: {
            ...$7e4f9929b0635875$var$initialState.dynamicConfig,
            rovoChatRefreshV2Config: {
                ...rovoChatRefreshV2Config
            }
        }
    };
};

});
parcelRegister("4OA5E", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $e62feef508022953$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "getChatRefreshV2DynamicConfig", () => $e62feef508022953$export$6ae9a55e1ff15aba);

var $59rsN = parcelRequire("59rsN");
const $e62feef508022953$export$d4c72bab9d6cc13a = {
    isMinimodalHeightAnimationEnabled: false,
    isThinkDeeperMessagesEnabled: false,
    isExplicitThinkDeeperEnabled: false,
    isDeepResearchEnabled: false,
    isNewMessagesEnabled: false,
    isNewMessagesActionsEnabled: false,
    isNewAllConversationScreenEnabled: false,
    isNewInputPromptTypeaheadEnabled: false,
    isReasoningOptionsV2Enabled: false,
    isReasoningStickyOptionEnabled: false,
    isPromptLibraryEnabled: false,
    isNewLoadingStateEnabled: false,
    isUpdatedAgentMenuDropdownEnabled: false,
    isSpinnerOverlayConversationIconEnabled: false
};
const $e62feef508022953$export$6ae9a55e1ff15aba = ({ isRolloutInJiraEnabled: isRolloutInJiraEnabled })=>{
    const rovoChatRefreshV2Config = isRolloutInJiraEnabled || (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isRenderRefreshEnabled', false) ? $e62feef508022953$var$getChatRefreshV2ConfigFromExperimentParameters() : $e62feef508022953$export$d4c72bab9d6cc13a;
    return rovoChatRefreshV2Config;
};
const $e62feef508022953$var$getChatRefreshV2ConfigFromExperimentParameters = ()=>{
    return {
        isMinimodalHeightAnimationEnabled: false,
        isThinkDeeperMessagesEnabled: (0, $59rsN.default).getExperimentValue('rovo_chat_thinking_deeper_messages_experiment', 'enabled', false),
        isExplicitThinkDeeperEnabled: (0, $59rsN.default).getExperimentValue('rovo_chat_explicit_thinking_deeper_experiment', 'isThinkDeeperEnabled', false),
        isDeepResearchEnabled: (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isDeepResearchEnabled', false),
        isNewMessagesEnabled: (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewMessagesEnabled', false),
        isNewMessagesActionsEnabled: (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewMessagesActionsEnabled', false),
        isNewAllConversationScreenEnabled: false,
        isNewInputPromptTypeaheadEnabled: false,
        isDynamicStartersAPIEnabled: false,
        isReasoningOptionsV2Enabled: false,
        isReasoningStickyOptionEnabled: false,
        isPromptLibraryEnabled: (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isPromptLibraryEnabled', false),
        isNewLoadingStateEnabled: (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewLoadingStateEnabled', false),
        isUpdatedAgentMenuDropdownEnabled: (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isUpdatedAgentMenuDropdownEnabled', false),
        isSpinnerOverlayConversationIconEnabled: false
    };
};

});




parcelRegister("gyQtw", function(module, exports) {
$parcel$export(module.exports, "getChatRefreshV2DynamicConfig", () => $2fb9dd3a23e4fc18$export$6ae9a55e1ff15aba);

var $59rsN = parcelRequire("59rsN");
const $2fb9dd3a23e4fc18$export$d4c72bab9d6cc13a = {
    isMiniModalStaticPositioningEnabled: false
};
const $2fb9dd3a23e4fc18$var$rovoChatRefreshV2ConfigDefaultValues = JSON.stringify($2fb9dd3a23e4fc18$export$d4c72bab9d6cc13a);
const $2fb9dd3a23e4fc18$export$6ae9a55e1ff15aba = ()=>{
    const isRolloutInJiraEnabled = (0, $59rsN.default).getExperimentValue('jira_ai_rovo_button', 'treatment', 'A') === 'B';
    const rovoChatRefreshV2ConfigResponse = isRolloutInJiraEnabled || (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isRenderRefreshEnabled', false) ? (0, $59rsN.default).getExperimentValue('rovo_chat_refresh_v2_config', 'value', $2fb9dd3a23e4fc18$var$rovoChatRefreshV2ConfigDefaultValues) : $2fb9dd3a23e4fc18$var$rovoChatRefreshV2ConfigDefaultValues;
    let rovoChatRefreshV2Config = $2fb9dd3a23e4fc18$export$d4c72bab9d6cc13a;
    try {
        rovoChatRefreshV2Config = JSON.parse(rovoChatRefreshV2ConfigResponse);
    } catch (error) {
    // fail silently
    }
    return rovoChatRefreshV2Config;
};

});

parcelRegister("asPwk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l1pR0").then(()=>parcelRequire('jNMlH'));

});


parcelRegister("3CuD0", function(module, exports) {
$parcel$export(module.exports, "useDebugNudgeTriggers", () => $f9c186f6a43e1323$export$a8ab20a5170c41b3);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $ihZdh = parcelRequire("ihZdh");

var $i2qsb = parcelRequire("i2qsb");
const $f9c186f6a43e1323$export$a8ab20a5170c41b3 = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $ihZdh.isBrowser)()) return;
        if (!(0, $eGOwo.fg)('aix_nudge_recommendation_migration_enabled')) return;
        if (!window?.AIX_DEBUG_NUDGE_TRIGGERS) window.AIX_DEBUG_NUDGE_TRIGGERS = new (0, $i2qsb.DebugTriggers)();
        return ()=>{
            if (window.AIX_DEBUG_NUDGE_TRIGGERS) delete window.AIX_DEBUG_NUDGE_TRIGGERS;
        };
    }, []);
};

});
parcelRegister("ihZdh", function(module, exports) {
$parcel$export(module.exports, "isBrowser", () => $be27b58db56244a6$export$4e09c449d6c407f7);
/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */ const $be27b58db56244a6$export$4e09c449d6c407f7 = ()=>{
    try {
        return typeof window !== 'undefined';
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
};

});

parcelRegister("i2qsb", function(module, exports) {
$parcel$export(module.exports, "DebugTriggers", () => $56a45973c394f7b5$export$f4380d3820d95f34);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $8KLBw = parcelRequire("8KLBw");
class $56a45973c394f7b5$export$f4380d3820d95f34 {
    get hasTriggers() {
        return Boolean(this.triggerQueue.length);
    }
    addTrigger(featureId, featureName, featureDescription) {
        this.triggerQueue.push({
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            nudge_id: (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))(),
            feature_details: {
                feature_id: featureId,
                feature_name: featureName || 'Debug Nudge',
                feature_description: featureDescription || 'A nudge added for debugging'
            }
        });
    }
    clear() {
        this.triggerQueue = [];
    }
    useNextTrigger() {
        return this.triggerQueue.shift();
    }
    constructor(){
        this.triggerQueue = [];
    }
}

});


parcelRegister("aioom", function(module, exports) {
$parcel$export(module.exports, "selectionCountsInMainEditor", () => $7cbdb519459b7ca3$export$f18468c773f95821);
function $7cbdb519459b7ca3$var$safeIsPointInRange(range, node, offset) {
    try {
        return range.isPointInRange(node, offset);
    } catch  {
        // some node types can throw, treat as "outside"
        return false;
    }
}
function $7cbdb519459b7ca3$var$fullyInside(r, container) {
    return $7cbdb519459b7ca3$var$safeIsPointInRange(container, r.startContainer, r.startOffset) && $7cbdb519459b7ca3$var$safeIsPointInRange(container, r.endContainer, r.endOffset);
}
/**
 * Find the "main" ProseMirror for a given sidebar container:
 * Walk up from the sidebar to the nearest .ak-editor-content-area. Return its direct
 * child .ProseMirror (even if other editors exist deeper in the subtree).
 */ function $7cbdb519459b7ca3$var$getMainProseMirrorForSidebar(sidebar) {
    const sidebarEl = typeof sidebar === 'string' && typeof document !== 'undefined' ? document.querySelector(sidebar) : sidebar;
    if (!sidebarEl) return null;
    const contentArea = sidebarEl.closest('.ak-editor-content-area');
    if (!contentArea) return null;
    for (const child of Array.from(contentArea.children)){
        if (child instanceof HTMLElement && child.classList.contains('ProseMirror')) return child;
    }
    return null;
}
function $7cbdb519459b7ca3$var$countWords(text) {
    const t = text.trim();
    if (!t) return 0;
    try {
        const Segmenter = Intl?.Segmenter;
        if (Segmenter) {
            const seg = new Segmenter(undefined, {
                granularity: 'word'
            });
            let c = 0;
            for (const { isWordLike: isWordLike } of seg.segment(t))if (isWordLike) c++;
            return c;
        }
    } catch  {}
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return t.split(/\s+/u).filter(Boolean).length;
}
function $7cbdb519459b7ca3$export$f18468c773f95821(sidebar) {
    try {
        const editor = $7cbdb519459b7ca3$var$getMainProseMirrorForSidebar(sidebar);
        if (!editor) return null;
        const doc = editor.ownerDocument ?? (typeof document !== 'undefined' ? document : null);
        if (!doc) return null;
        const sel = doc.getSelection?.();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null;
        // range covering just the editor's contents to test containment
        const container = doc.createRange();
        container.selectNodeContents(editor);
        // snapshot rangeCount up-front to avoid races if selection changes
        const rangeCount = sel.rangeCount;
        // require every selection range to be fully inside
        let text = '';
        for(let i = 0; i < rangeCount; i++){
            const r = sel.getRangeAt(i);
            if (!$7cbdb519459b7ca3$var$fullyInside(r, container)) return null;
            const part = r.toString();
            text += text ? `\n${part}` : part;
        }
        return {
            text: text,
            words: $7cbdb519459b7ca3$var$countWords(text),
            chars: text.length
        };
    } catch (err) {
        return null;
    }
}

});

parcelRegister("4GItf", function(module, exports) {
$parcel$export(module.exports, "AISmartButtonUI", () => $9260fa01d616444e$export$21695acdb18697b9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $6djmC = parcelRequire("6djmC");

var $k71qx = parcelRequire("k71qx");

var $7plT4 = parcelRequire("7plT4");

var $4Oykn = parcelRequire("4Oykn");
var $ctcNX = parcelRequire("ctcNX");
const $9260fa01d616444e$var$i18n = (0, $7qGN1.defineMessages)({
    tooltipLabel: {
        id: 'ai-smart-button.tooltip.label',
        defaultMessage: 'Ask Rovo AI',
        description: 'Label for the AI smart button tooltip'
    }
});
const $9260fa01d616444e$var$styles = {
    buttonWrapper: "_kqswh2mm"
};
const $9260fa01d616444e$export$21695acdb18697b9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isDisabled: isDisabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, sidebarApi: sidebarApi, isRefreshed: isRefreshed, product: product }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [showButtonAnimation, setShowButtonAnimation] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $9260fa01d616444e$var$styles.buttonWrapper,
        children: [
            isRefreshed && sidebarApi ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ctcNX.AIProactiveNudgeRefreshed), {
                sidebarApi: sidebarApi,
                product: product,
                setShowButtonAnimation: setShowButtonAnimation
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Oykn.AIProactiveNudge), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                position: "left",
                content: formatMessage($9260fa01d616444e$var$i18n.tooltipLabel),
                hideTooltipOnClick: true,
                ignoreTooltipPointerEvents: true,
                children: isRefreshed ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7plT4.AIButtonRefreshed), {
                    onClick: onClick,
                    isDisabled: isDisabled,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    ref: ref,
                    showAnimation: showButtonAnimation
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7plT4.AIButton), {
                    onClick: onClick,
                    isDisabled: isDisabled,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    ref: ref
                })
            })
        ]
    });
});

});
parcelRegister("7plT4", function(module, exports) {
$parcel$export(module.exports, "AIButton", () => $b3c9c7c581bc5c1a$export$a51986b9c6d9ac89);
$parcel$export(module.exports, "AIButtonRefreshed", () => $b3c9c7c581bc5c1a$export$c645d585c7f17c83);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");

var $58yRG = parcelRequire("58yRG");

var $6fs4r = parcelRequire("6fs4r");

var $5A1ES = parcelRequire("5A1ES");

var $lDvuR = parcelRequire("lDvuR");

var $iHJOq = parcelRequire("iHJOq");

var $4A8oh = parcelRequire("4A8oh");
const $b3c9c7c581bc5c1a$var$ANIMATION_DURATION = 0.65;
const $b3c9c7c581bc5c1a$var$buttonAnimation = null;
const $b3c9c7c581bc5c1a$var$atlaskitCssStyles = {
    pressableStyles: "_2rkopb1k _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _4t3i1a70 _1bsb1a70 _bfhk18uv",
    pressableStylesRefreshed: "_2rko7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _4t3ickbl _1bsbckbl _bfhk18uv",
    boxStyles: "_2rkopb1k _p12f1a70 _kqswh2mm _pdyk1y4g _rfx3pb1k _1cs8stnw _1kt9b3bt _txdon80n _kfgt1a70 _1mp41a70 _1rus15mt _qc5os58n _14mj1ahh _uoe3t94y _1rect94y _70xrt94y _1k96t94y _18postnw _3p6m17h5 _aetrb3bt _1bqq1mrw _z0ai1osq _1qdg1osq _15l21n1a _19do1n1a _1b1b120f _19si120f _1xqc1uwk",
    boxStylesRefreshedLightMode: "_2rko7vkz _v564s58n _1bsbckbl _4t3ickbl _1o9zidpf _kqswh2mm _bfhkqlpt _16qs5pg2 _o7ksf4ca _1llw1mwg _d0altlke _1q8wws4j",
    boxStylesRefreshedDarkMode: "_2rko7vkz _v564s58n _1bsbckbl _4t3ickbl _1o9zidpf _kqswh2mm _bfhku67f _16qs5pg2 _o7ksf4ca _1llw1mwg _d0altlke _1q8wws4j",
    wrapperStylesDynamic: "_5sagf71h _tip8kb7n _1pglp3kn _j7hq16y3"
};
const $b3c9c7c581bc5c1a$export$a51986b9c6d9ac89 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isDisabled: isDisabled = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $b3c9c7c581bc5c1a$var$atlaskitCssStyles.boxStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
            testId: "platform-ai-button",
            xcss: $b3c9c7c581bc5c1a$var$atlaskitCssStyles.pressableStyles,
            onClick: onClick,
            isDisabled: isDisabled,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: ref,
            interactionName: "rovo-button-click",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                    children: " Rovo Button "
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5A1ES.RovoLogo), {})
            ]
        })
    });
});
const $b3c9c7c581bc5c1a$export$c645d585c7f17c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isDisabled: isDisabled = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, showAnimation: showAnimation = false }, ref)=>{
    const { colorMode: nonSSRSafeTheme } = (0, $58yRG.default)();
    const ssrSafeTheme = (0, $4A8oh.useSSRSafeThemeObserver)(); //To prevent flashing on load, we use the local storage theme if SSR is enabled, and the theme observer theme if SSR is not enabled
    const theme = nonSSRSafeTheme; // If we are in SSR, we want to use the fallback logo if there is no theme resolved from local storage
    const useFallbackLogo = theme === 'fallback'; //If we use the fallback logo, automatically use the light mode styles
    const isDarkMode = useFallbackLogo ? false : theme === 'dark';
    const [animationKey, setAnimationKey] = (0, $eJOHy.useState)(0);
    const prevShowAnimation = (0, $eJOHy.useRef)(false); // Restart animation every time showAnimation becomes true
    (0, $eJOHy.useEffect)(()=>{
        if (showAnimation && !prevShowAnimation.current) setAnimationKey((prev)=>prev + 1);
        prevShowAnimation.current = showAnimation;
    }, [
        showAnimation
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            isDarkMode && $b3c9c7c581bc5c1a$var$atlaskitCssStyles.boxStylesRefreshedDarkMode,
            !isDarkMode && $b3c9c7c581bc5c1a$var$atlaskitCssStyles.boxStylesRefreshedLightMode,
            showAnimation && $b3c9c7c581bc5c1a$var$atlaskitCssStyles.wrapperStylesDynamic
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
            testId: "platform-ai-button",
            xcss: $b3c9c7c581bc5c1a$var$atlaskitCssStyles.pressableStylesRefreshed,
            onClick: onClick,
            isDisabled: isDisabled,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: ref,
            interactionName: "rovo-button-click",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                    children: " Rovo Button "
                }),
                useFallbackLogo ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHJOq.RovoLogoRefreshedFallback), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lDvuR.RovoLogoRefreshed), {})
            ]
        })
    }, showAnimation ? `animation-${animationKey}` : 'static');
});

});
parcelRegister("5A1ES", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", () => $380b9627119fbdda$export$a0f6cb8061290bbb);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $380b9627119fbdda$export$a0f6cb8061290bbb = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 17 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7.74328 1.00957C8.3818 0.65712 9.16114 0.663595 9.79449 1.02899L15.9562 4.5864C16.601 4.95844 17.0002 5.64868 17.0002 6.39226V13.5072C17.0002 14.2537 16.6035 14.9409 15.9567 15.3128L11.3249 17.9869C11.335 17.9584 11.3447 17.9297 11.3539 17.9008C11.4399 17.6343 11.4855 17.3526 11.4855 17.0646V9.94972C11.4855 8.97229 10.9656 8.07094 10.1176 7.58334L6.66492 5.59083V2.8348C6.66492 2.61763 6.69849 2.40549 6.76203 2.20466C6.91822 1.71863 7.25043 1.29786 7.70491 1.0352L7.70629 1.0344C7.71932 1.02688 7.73171 1.01854 7.74328 1.00957Z",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M6.17528 1.91943L1.54352 4.59356C0.896734 4.9654 0.5 5.6526 0.5 6.39913V13.5141C0.5 14.2576 0.899073 14.9478 1.54394 15.3199L7.70569 18.8773C8.33903 19.2427 9.11841 19.2492 9.7569 18.8968C9.76847 18.8878 9.78078 18.8795 9.79381 18.872C10.2488 18.6095 10.5815 18.1886 10.7379 17.7023C10.8016 17.5013 10.8353 17.2889 10.8353 17.0715V14.3155L7.38278 12.3231C6.53497 11.8355 6.01472 10.9339 6.01472 9.95659V2.84167C6.01472 2.55414 6.06017 2.27283 6.14592 2.00659C6.15522 1.97735 6.16501 1.94829 6.17528 1.91943Z",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            })
        ]
    });

});

parcelRegister("lDvuR", function(module, exports) {
$parcel$export(module.exports, "RovoLogoRefreshed", () => $7936a8cae00718b9$export$9f3f45ad2aec3ab1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $7936a8cae00718b9$export$9f3f45ad2aec3ab1 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.4352 0.363775C12.6088 -0.112663 11.592 -0.121106 10.7588 0.338447C10.7437 0.350143 10.7258 0.362058 10.7088 0.371866C10.1158 0.714353 9.68229 1.26299 9.47849 1.89674C9.39559 2.15859 9.35178 2.43521 9.35178 2.71837V6.31195L12.7406 8.26623L13.8592 8.91009C14.9656 9.54587 15.6439 10.7211 15.6439 11.9956V21.2728C15.6439 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4344 22.4753L21.4779 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35705C22.8395 6.38749 22.3187 5.48749 21.4773 5.00239L19.9351 4.11389L13.4352 0.363775Z",
                fill: "var(--ds-surface, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.66999 18.9977L4.10278 19.8244L10.7097 23.6363C11.5361 24.1126 12.553 24.1211 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.287 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7931 21.5651 14.7931 21.2817V17.6881L11.2961 15.6713L10.2885 15.0902C9.18226 14.4544 8.50344 13.2789 8.50344 12.0045V2.7274C8.50344 2.35249 8.56274 1.9857 8.67462 1.63854C8.68676 1.60041 8.69954 1.56253 8.71294 1.5249L2.66944 5.01169C1.82552 5.49653 1.30786 6.39257 1.30786 7.36597V16.6431C1.30786 17.6127 1.82857 18.5126 2.66999 18.9977Z",
                fill: "var(--ds-surface, #FFFFFF)"
            })
        ]
    });

});

parcelRegister("iHJOq", function(module, exports) {
$parcel$export(module.exports, "RovoLogoRefreshedFallback", () => $4c1be957b0d33733$export$4ea0ad68d3b9cb71);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $4c1be957b0d33733$export$4ea0ad68d3b9cb71 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.4352 0.363775C12.6088 -0.112663 11.592 -0.121106 10.7588 0.338447C10.7437 0.350143 10.7258 0.362058 10.7088 0.371866C10.1158 0.714353 9.68229 1.26299 9.47849 1.89674C9.39559 2.15859 9.35178 2.43521 9.35178 2.71837V6.31195L12.7406 8.26623L13.8592 8.91009C14.9656 9.54587 15.6439 10.7211 15.6439 11.9956V21.2728C15.6439 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4344 22.4753L21.4779 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35705C22.8395 6.38749 22.3187 5.48749 21.4773 5.00239L19.9351 4.11389L13.4352 0.363775Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.66999 18.9977L4.10278 19.8244L10.7097 23.6363C11.5361 24.1126 12.553 24.1211 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.287 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7931 21.5651 14.7931 21.2817V17.6881L11.2961 15.6713L10.2885 15.0902C9.18226 14.4544 8.50344 13.2789 8.50344 12.0045V2.7274C8.50344 2.35249 8.56274 1.9857 8.67462 1.63854C8.68676 1.60041 8.69954 1.56253 8.71294 1.5249L2.66944 5.01169C1.82552 5.49653 1.30786 6.39257 1.30786 7.36597V16.6431C1.30786 17.6127 1.82857 18.5126 2.66999 18.9977Z",
                fill: "#fff"
            })
        ]
    });

});

parcelRegister("4A8oh", function(module, exports) {
$parcel$export(module.exports, "useSSRSafeThemeObserver", () => $ed63db102af069cc$export$4df533da0c4d0ef1);
const $ed63db102af069cc$var$COLOR_MODE_PREFERENCE_KEY = 'ADS-COLOR-MODE';
const $ed63db102af069cc$export$4df533da0c4d0ef1 = ()=>{
    try {
        const storedTheme = localStorage.getItem($ed63db102af069cc$var$COLOR_MODE_PREFERENCE_KEY);
        if (storedTheme && [
            'light',
            'dark'
        ].includes(storedTheme)) return storedTheme;
    } catch (e) {}
    // Return fallback if no preference is found or local storage is unavailable
    return 'fallback';
};

});


parcelRegister("4Oykn", function(module, exports) {
$parcel$export(module.exports, "AIProactiveNudge", () => $41e17eb6ac8a212d$export$50a342ac0fc7ff57);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $cL4Z3 = parcelRequire("cL4Z3");

var $jvhj0 = parcelRequire("jvhj0");
const $41e17eb6ac8a212d$export$50a342ac0fc7ff57 = ()=>(0, $eGOwo.fg)('aix_nudge_recommendation_migration_enabled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jvhj0.AIProactiveNudge), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cL4Z3.AIProactiveNudge), {});

});
parcelRegister("cL4Z3", function(module, exports) {
$parcel$export(module.exports, "AIProactiveNudge", () => $dd85a79dfe8f37c0$export$50a342ac0fc7ff57);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8KLBw = parcelRequire("8KLBw");

var $f1SBE = parcelRequire("f1SBE");
var $4j3Y4 = parcelRequire("4j3Y4");

var $dsB7O = parcelRequire("dsB7O");

var $dJqkg = parcelRequire("dJqkg");

var $68hwE = parcelRequire("68hwE");
const $dd85a79dfe8f37c0$var$NUDGE_DISMISS_TIMEOUT = 30000;
const $dd85a79dfe8f37c0$var$ANIMATION_DURATION = 200;
const $dd85a79dfe8f37c0$export$50a342ac0fc7ff57 = ()=>{
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $dsB7O.useRovoButtonEventsInstrumentation)();
    const { changeView: changeView } = (0, $4j3Y4.useViewAIActions)();
    const surfaceMetadata = (0, $f1SBE.useAISurfaceMetadata)();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [triggerId] = (0, $eJOHy.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    const [isNudgeVisible, setIsNudgeVisible] = (0, $eJOHy.useState)(false);
    const [dismissedIds, setDismissedIds] = (0, $eJOHy.useState)([]);
    const selectedNudges = (0, $f1SBE.useAINudges)();
    const [acceptedIds, setAcceptedIds] = (0, $eJOHy.useState)([]);
    const [prevNudge, setPrevNudge] = (0, $eJOHy.useState)(null);
    const [isMouseHovering, setIsMouseHovering] = (0, $eJOHy.useState)(false);
    const hoverTimerRef = (0, $eJOHy.useRef)(null);
    const potentialActiveNudge = (0, $eJOHy.useMemo)(()=>{
        /**
     * Nudge must not be previously dismissed or accepted
     * to be considered active.
     */ return selectedNudges.find((nudge)=>!dismissedIds.includes(nudge.id) && !acceptedIds.includes(nudge.id));
    }, [
        selectedNudges,
        dismissedIds,
        acceptedIds
    ]);
    const { isNudgeThrottled: isNudgeThrottled, isLoading: isNudgeThrottlingStateLoading } = (0, $dJqkg.useFetchNudgeThrottlingState)({
        triggerId: triggerId,
        hasNudgeToShow: !!potentialActiveNudge
    });
    const activeNudge = (0, $eJOHy.useMemo)(()=>{
        if (isNudgeThrottlingStateLoading || !potentialActiveNudge) return null;
        if (isNudgeThrottled) {
            setDismissedIds((ids)=>[
                    ...ids,
                    potentialActiveNudge.id
                ]);
            const nudgeId = `${potentialActiveNudge.title} - ${potentialActiveNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'throttled',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: potentialActiveNudge.id,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
            return null;
        }
        return potentialActiveNudge;
    }, [
        potentialActiveNudge,
        isNudgeThrottlingStateLoading,
        isNudgeThrottled,
        fireRovoButtonUIEvent,
        surfaceMetadata
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (activeNudge !== prevNudge) {
            setPrevNudge(activeNudge);
            if (activeNudge && activeNudge?.id !== prevNudge?.id) {
                const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
                fireRovoButtonUIEvent({
                    source: surfaceMetadata.contentType,
                    action: 'rendered',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoProactiveNudge',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode,
                        id: activeNudge.id,
                        nudgeId: nudgeId
                    },
                    product: surfaceMetadata.product
                });
                window.requestAnimationFrame(()=>{
                    /**
           * Needs to be set to visible in next tick, otherwise
           * it will not animate
           */ setIsNudgeVisible(true);
                });
            }
        }
    }, [
        activeNudge,
        prevNudge,
        fireRovoButtonUIEvent,
        surfaceMetadata
    ]);
    const onDismissClick = (0, $eJOHy.useCallback)(()=>{
        if (activeNudge) {
            setDismissedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'dismissed',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    dismissedMethod: 'manual',
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        surfaceMetadata
    ]);
    const onNudgeClick = (0, $eJOHy.useCallback)(()=>{
        if (activeNudge) {
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            if (activeNudge.viewConfig) changeView(activeNudge);
            activeNudge.onClick?.();
            setAcceptedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            setDismissedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'clicked',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }
    }, [
        activeNudge,
        changeView,
        fireRovoButtonUIEvent,
        surfaceMetadata
    ]);
    const onWrapperMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsMouseHovering(true);
        const nudgeId = activeNudge ? `${activeNudge.title} - ${activeNudge.id}` : '';
        hoverTimerRef.current = setTimeout(()=>{
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    product: surfaceMetadata.product,
                    productPage: surfaceMetadata.contentType,
                    pageMode: surfaceMetadata.pageMode,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }, 1000);
    }, [
        fireRovoButtonUIEvent,
        surfaceMetadata,
        activeNudge
    ]);
    const onWrapperMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsMouseHovering(false);
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        let timeoutId;
        let slideoutTimeoutId;
        if (activeNudge && !isMouseHovering) {
            timeoutId = setTimeout(()=>{
                setDismissedIds((ids)=>[
                        ...ids,
                        activeNudge.id
                    ]);
                fireRovoButtonUIEvent({
                    source: surfaceMetadata.contentType,
                    action: 'dismissed',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoProactiveNudge',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode,
                        id: activeNudge.id,
                        timerDuration: $dd85a79dfe8f37c0$var$NUDGE_DISMISS_TIMEOUT,
                        dismissedMethod: 'timer_expired'
                    },
                    product: surfaceMetadata.product
                });
            }, $dd85a79dfe8f37c0$var$NUDGE_DISMISS_TIMEOUT);
            slideoutTimeoutId = setTimeout(()=>{
                setIsNudgeVisible(false);
            }, $dd85a79dfe8f37c0$var$NUDGE_DISMISS_TIMEOUT - $dd85a79dfe8f37c0$var$ANIMATION_DURATION);
        }
        /**
     * On mouse enter, isMouseHovering is set to true, will trigger
     *  cleanup function to clear timeout.
     */ return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
            if (slideoutTimeoutId) clearTimeout(slideoutTimeoutId);
        };
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        isMouseHovering,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    if (!activeNudge) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $68hwE.NudgeContent), {
        activeNudge: activeNudge,
        isNudgeVisible: isNudgeVisible,
        onWrapperMouseEnter: onWrapperMouseEnter,
        onWrapperMouseLeave: onWrapperMouseLeave,
        onNudgeClick: onNudgeClick,
        onDismissClick: onDismissClick
    });
};

});
parcelRegister("f1SBE", function(module, exports) {
$parcel$export(module.exports, "useAINudges", () => $2cac12b82760d5af$export$b854997b7299d67f);
$parcel$export(module.exports, "useAINudgesRefreshed", () => $2cac12b82760d5af$export$3d91f71a604904dd);
$parcel$export(module.exports, "useAISurfaceMetadata", () => $2cac12b82760d5af$export$e4b00dbb0b70f9c2);

var $iJq0l = parcelRequire("iJq0l");

var $kVM4h = parcelRequire("kVM4h");
const $2cac12b82760d5af$export$69b8f052247c1626 = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>state.context
});
const $2cac12b82760d5af$export$b854997b7299d67f = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>{
        const { nudges: nudges, selectors: selectors, context: context } = state;
        if (selectors?.nudgesSelector) return selectors.nudgesSelector(nudges, context);
        return nudges;
    }
});
const $2cac12b82760d5af$export$3d91f71a604904dd = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>state.nudgesRefreshed
});
const $2cac12b82760d5af$export$a916dc6bee947aa3 = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>{
        const { actions: actions, selectors: selectors, context: context } = state;
        if (selectors?.actionsSelector) return selectors.actionsSelector(actions, context);
        return actions;
    }
});
const $2cac12b82760d5af$export$e4b00dbb0b70f9c2 = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>state.surfaceMetadata
});
const $2cac12b82760d5af$export$b068b01d46d2f61d = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>state.currentView
});
const $2cac12b82760d5af$export$22514df787c8eb15 = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>state.profileData
});
const $2cac12b82760d5af$export$f23908d838fcc66a = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>state.automationsConfig
});
const $2cac12b82760d5af$export$49ad96840690a3bf = (0, $iJq0l.createStateHook)((0, $kVM4h.AISmartButtonStore), {
    selector: (state)=>state.showConvoStarters
});

});
parcelRegister("kVM4h", function(module, exports) {
$parcel$export(module.exports, "AISmartButtonStore", () => $6f46a3a0323b981a$export$72552b26ebb37b2);
$parcel$export(module.exports, "useAISmartButtonActions", () => $6f46a3a0323b981a$export$af36d029992e7a8c);

var $cSmYj = parcelRequire("cSmYj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $6f46a3a0323b981a$export$a9180caf96fd3fe = /*#__PURE__*/ function(DynamicSurfaceView) {
    DynamicSurfaceView["Default"] = "default";
    return DynamicSurfaceView;
}({});
const $6f46a3a0323b981a$export$d4c72bab9d6cc13a = {
    suggestedActions: [],
    actions: [],
    nudges: [],
    currentView: "default",
    surfaceMetadata: {
        siteId: '',
        product: '',
        contentType: ''
    },
    profileData: {
        name: '',
        displayName: '',
        avatarUrl: ''
    }
};
/**
 * Adds source ID to each action in the array recursively.
 */ const $6f46a3a0323b981a$var$addSource = (actions, sourceId)=>actions.map((action)=>({
            ...action,
            sourceId: sourceId,
            children: action.children ? $6f46a3a0323b981a$var$addSource(action.children, sourceId) : undefined
        }));
/**
 * Updates state only if the new state is different from the current state.
 */ const $6f46a3a0323b981a$var$updateStateIfChanged = (newPartialState, getState, setState)=>{
    const currentState = getState();
    const stateChanged = Object.entries(newPartialState).some(([key, value])=>!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(currentState[key], value));
    if (stateChanged) setState(newPartialState);
};
/**
 * Updates a collection of items (actions, nudges, or suggestedActions) for a specific source.
 * Only updates if the items have changed to avoid unnecessary re-renders.
 */ const $6f46a3a0323b981a$var$updateItemsForSource = (sourceId, newItems, stateKey, getState, setState)=>{
    const currentItems = getState()[stateKey];
    const currentSourceItems = currentItems.filter((item)=>item.sourceId === sourceId);
    const itemsMatch = currentSourceItems.length === newItems.length && currentSourceItems.every((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(item, newItems[index]));
    if (itemsMatch) return;
    // Filter out items from this source and add new ones.
    const otherItems = currentItems.filter((item)=>item.sourceId !== sourceId);
    const updatedItems = [
        ...otherItems,
        ...$6f46a3a0323b981a$var$addSource(newItems, sourceId)
    ];
    setState({
        [stateKey]: updatedItems
    });
};
const $6f46a3a0323b981a$export$e324594224ef24da = {
    setActions: (sourceId, actions)=>({ getState: getState, setState: setState })=>{
            $6f46a3a0323b981a$var$updateItemsForSource(sourceId, actions, 'actions', getState, setState);
        },
    setNudges: (sourceId, nudges)=>({ getState: getState, setState: setState })=>{
            $6f46a3a0323b981a$var$updateItemsForSource(sourceId, nudges, 'nudges', getState, setState);
        },
    setNudgesRefreshed: (nudgesRefreshed)=>({ setState: setState })=>{
            setState({
                nudgesRefreshed: nudgesRefreshed
            });
        },
    setSuggestedActions: (sourceId, suggestedActions)=>({ getState: getState, setState: setState })=>{
            $6f46a3a0323b981a$var$updateItemsForSource(sourceId, suggestedActions, 'suggestedActions', getState, setState);
        },
    removeAll: (sourceId)=>({ getState: getState, setState: setState })=>{
            const { actions: actions, nudges: nudges, suggestedActions: suggestedActions } = getState();
            if (sourceId) {
                const newState = {
                    suggestedActions: suggestedActions.filter((action)=>action.sourceId !== sourceId),
                    actions: actions.filter((action)=>action.sourceId !== sourceId),
                    nudges: nudges.filter((nudge)=>nudge.sourceId !== sourceId)
                };
                $6f46a3a0323b981a$var$updateStateIfChanged(newState, getState, setState);
            } else {
                const newState = {
                    suggestedActions: [],
                    actions: [],
                    nudges: []
                };
                $6f46a3a0323b981a$var$updateStateIfChanged(newState, getState, setState);
            }
        },
    changeView: (view)=>({ getState: getState, setState: setState })=>{
            $6f46a3a0323b981a$var$updateStateIfChanged({
                currentView: view
            }, getState, setState);
        },
    setSelectors: (selectors)=>({ getState: getState, setState: setState })=>{
            const existingSelectors = getState().selectors;
            const newSelectors = {
                selectors: {
                    actionsSelector: 'actionsSelector' in selectors ? selectors.actionsSelector : existingSelectors?.actionsSelector,
                    suggestedActionsSelector: 'suggestedActionsSelector' in selectors ? selectors.suggestedActionsSelector : existingSelectors?.suggestedActionsSelector,
                    nudgesSelector: 'nudgesSelector' in selectors ? selectors.nudgesSelector : existingSelectors?.nudgesSelector
                }
            };
            $6f46a3a0323b981a$var$updateStateIfChanged(newSelectors, getState, setState);
        },
    setContext: (context)=>({ getState: getState, setState: setState })=>{
            $6f46a3a0323b981a$var$updateStateIfChanged({
                context: context
            }, getState, setState);
        },
    removeContext: (sourceId)=>({ getState: getState, setState: setState })=>{
            const { context: context } = getState();
            if (context?.sourceId === sourceId) $6f46a3a0323b981a$var$updateStateIfChanged({
                context: undefined
            }, getState, setState);
        },
    setSurfaceMetadata: (surfaceMetadata)=>({ getState: getState, setState: setState })=>{
            $6f46a3a0323b981a$var$updateStateIfChanged({
                surfaceMetadata: surfaceMetadata
            }, getState, setState);
        },
    setProfileData: (profileData)=>({ setState: setState })=>{
            setState({
                profileData: profileData
            });
        },
    setAutomationsConfig: (automationsConfig)=>({ getState: getState, setState: setState })=>{
            $6f46a3a0323b981a$var$updateStateIfChanged({
                automationsConfig: automationsConfig
            }, getState, setState);
        },
    removeAutomationsConfig: (sourceId)=>({ getState: getState, setState: setState })=>{
            const { automationsConfig: automationsConfig } = getState();
            if (automationsConfig?.sourceId === sourceId) $6f46a3a0323b981a$var$updateStateIfChanged({
                automationsConfig: undefined
            }, getState, setState);
        },
    setShowConvoStarters: (showConvoStarters)=>({ setState: setState })=>{
            setState({
                showConvoStarters: showConvoStarters
            });
        }
};
const $6f46a3a0323b981a$export$72552b26ebb37b2 = (0, $GtRbT.createStore)({
    initialState: $6f46a3a0323b981a$export$d4c72bab9d6cc13a,
    actions: $6f46a3a0323b981a$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $6f46a3a0323b981a$export$af36d029992e7a8c = (0, $iJq0l.createActionsHook)($6f46a3a0323b981a$export$72552b26ebb37b2);

});


parcelRegister("4j3Y4", function(module, exports) {
$parcel$export(module.exports, "useViewAIActions", () => $5c104d578bd6a5c2$export$7c7acaa418085cd7);

var $eJOHy = parcelRequire("eJOHy");

var $kVM4h = parcelRequire("kVM4h");
const $5c104d578bd6a5c2$export$7c7acaa418085cd7 = ()=>{
    const { changeView: changeView, setProfileData: setProfileData, setShowConvoStarters: setShowConvoStarters } = (0, $kVM4h.useAISmartButtonActions)();
    return (0, $eJOHy.useMemo)(()=>({
            changeView: /**
			 * Change the view of the ai actions.
			 */ changeView,
            setProfileData: /**
			 * Set the prefetched name for the ai actions.
			 */ setProfileData,
            setShowConvoStarters: /**
			 * Toggle convo starters on or off within ai actions.
			 */ setShowConvoStarters
        }), [
        changeView,
        setProfileData,
        setShowConvoStarters
    ]);
};

});

parcelRegister("dJqkg", function(module, exports) {
$parcel$export(module.exports, "useFetchNudgeThrottlingState", () => $bdd21a5e2fea6ca6$export$63678417eaa09de8);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $cW3Qj = parcelRequire("cW3Qj");
const $bdd21a5e2fea6ca6$export$63678417eaa09de8 = ({ triggerId: triggerId, hasNudgeToShow: hasNudgeToShow })=>{
    const [isNudgeThrottled, setIsNudgeThrottled] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const makeNudgeThrottlingStateRequest = (0, $eJOHy.useCallback)(async ()=>{
        try {
            const nudgeThrottlingState = await (0, $cW3Qj.fetchNudgeThrottlingState)({
                triggerId: triggerId
            });
            setIsNudgeThrottled(nudgeThrottlingState.triggers[0].recommendations[0].recommendation_details.nudge_throttled);
        } catch (error) {
            setError(error);
        } finally{
            setIsLoading(false);
        }
    }, [
        triggerId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasNudgeToShow) return;
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
        const isNudgeThrottlingEnabled = (0, $eGOwo.fg)('rovo_button_nudge_throttling_enabled');
        const isNudgeRecommendationMigrationEnabled = (0, $eGOwo.fg)('aix_nudge_recommendation_migration_enabled');
        if (isNudgeThrottlingEnabled && !isNudgeRecommendationMigrationEnabled) {
            makeNudgeThrottlingStateRequest();
            return;
        }
        setIsLoading(false);
    }, [
        makeNudgeThrottlingStateRequest,
        hasNudgeToShow
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        const getNudgeThrottlingState = ()=>{
            if (error || !isNudgeThrottled) return false;
            return isNudgeThrottled;
        };
        return {
            isNudgeThrottled: getNudgeThrottlingState(),
            isLoading: isLoading,
            error: error
        };
    }, [
        isNudgeThrottled,
        isLoading,
        error
    ]);
};

});
parcelRegister("cW3Qj", function(module, exports) {
$parcel$export(module.exports, "fetchNudgeThrottlingState", () => $18b5515522f6ca3c$export$7f1fbc078e6eb4f0);

var $eGOwo = parcelRequire("eGOwo");
const $18b5515522f6ca3c$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';
const $18b5515522f6ca3c$var$ROVO_BUTTON_NUDGE_LIMITER_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_LIMITER';
const $18b5515522f6ca3c$export$7f1fbc078e6eb4f0 = async ({ triggerId: triggerId })=>{
    const request = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_details: {},
                    trigger_type: $18b5515522f6ca3c$var$ROVO_BUTTON_NUDGE_LIMITER_TRIGGER_TYPE
                }
            ]
        }
    };
    const response = await fetch($18b5515522f6ca3c$var$CONVO_AI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': 'confluence',
            'X-Experience-Id': (0, $eGOwo.fg)('rovo_button_experience_id_enabled') ? 'proactive-ai-rovo-button' : 'ai-mate'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Error fetching nudge throttling state, status code: ${response.status}`);
    const { ai_feature_output: ai_feature_output } = await response.json() ?? {};
    if (!ai_feature_output) throw new Error('No nudge throttling state returned from API');
    return ai_feature_output;
};

});


parcelRegister("68hwE", function(module, exports) {
$parcel$export(module.exports, "NudgeContent", () => $d03d0ae0d2b4c1f1$export$9b98f181754d0f50);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $6zhpo = parcelRequire("6zhpo");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");
const $d03d0ae0d2b4c1f1$export$a7357cdd1f0b0168 = (0, $7qGN1.defineMessages)({
    aiProactiveNudgeDismiss: {
        id: 'ai-smart-button.ai-proactive-nudge.dismiss',
        defaultMessage: 'Dismiss',
        description: 'The label text for the dismiss button on the AI Proactive nudge'
    }
});
const $d03d0ae0d2b4c1f1$var$ANIMATION_DURATION = 200;
const $d03d0ae0d2b4c1f1$var$NUDGE_WIDTH = '350px';
const $d03d0ae0d2b4c1f1$var$styles = {
    wrapperStyles: "_1reo15vq _18m915vq _2rko1mok _v5644nwb _kqswstnw _1ltvidpf _o5721q9c _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1e0c1o8l _16qs1cd0 _bfhk1bsc _4cvr1h6o _1bah1h6o _ta6yglyw",
    wrapperStylesUpdated: "_1reoewfl _18m9ewfl _2rko1mok _v5644nwb _kqswstnw _1ltvidpf _o5724jg8 _4t3i1wug _1bsb1edt _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1e0c1o8l _16qs1cd0 _bfhk1bsc _4cvr1e5h _1bah1e5h _ta6yglyw",
    newNudgeIconStyles: "_syaz5w2r",
    invisibleNudge: "_tzy4idpf _t9ecjq3t",
    visibleNudge: "_t9eci6v2 _tzy4kb7n",
    textStyle: "_1i4q1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm _slp31hna",
    buttonOverride: "_11y51b66 _f7xt1wug _1unr1wug"
};
const $d03d0ae0d2b4c1f1$export$9b98f181754d0f50 = /*#__PURE__*/ (0, $eJOHy.memo)(({ activeNudge: activeNudge, isNudgeVisible: isNudgeVisible, onWrapperMouseEnter: onWrapperMouseEnter, onWrapperMouseLeave: onWrapperMouseLeave, onNudgeClick: onNudgeClick, onDismissClick: onDismissClick })=>{
    const intl = (0, $lRq8t.default)();
    const isTextWrapEnabled = (0, $eGOwo.fg)('aix_convo_starters_nudge_text_wrap_enabled');
    const NudgeIcon = activeNudge.nudgeIcon ?? activeNudge.icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": "platform-ai-proactive-nudge",
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onWrapperMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onWrapperMouseLeave,
        className: (0, $hcewu.default)([
            isTextWrapEnabled ? $d03d0ae0d2b4c1f1$var$styles.wrapperStylesUpdated : $d03d0ae0d2b4c1f1$var$styles.wrapperStyles,
            isNudgeVisible ? $d03d0ae0d2b4c1f1$var$styles.visibleNudge : $d03d0ae0d2b4c1f1$var$styles.invisibleNudge
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                grow: "fill",
                space: "space.025",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
                        children: isTextWrapEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $d03d0ae0d2b4c1f1$var$styles.buttonOverride,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                                appearance: "subtle",
                                onClick: onNudgeClick,
                                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                    space: "space.075",
                                    alignBlock: "start",
                                    children: [
                                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                            className: (0, $hcewu.default)([
                                                $d03d0ae0d2b4c1f1$var$styles.newNudgeIconStyles
                                            ]),
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)(NudgeIcon, {
                                                label: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                            xcss: (0, $6qaBj.cx)($d03d0ae0d2b4c1f1$var$styles.textStyle, $d03d0ae0d2b4c1f1$var$styles.whiteSpacePreWrap),
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                                color: 'color.text.inverse',
                                                children: activeNudge.title
                                            })
                                        })
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                            appearance: "subtle",
                            onClick: onNudgeClick,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                space: "space.075",
                                alignBlock: "end",
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                        className: (0, $hcewu.default)([
                                            $d03d0ae0d2b4c1f1$var$styles.newNudgeIconStyles
                                        ]),
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)(NudgeIcon, {
                                            label: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                        color: 'color.text.inverse',
                                        children: activeNudge.title
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        testId: "platform-ai-proactive-nudge-dismiss",
                        appearance: "subtle",
                        label: intl.formatMessage($d03d0ae0d2b4c1f1$export$a7357cdd1f0b0168.aiProactiveNudgeDismiss),
                        isTooltipDisabled: false,
                        tooltip: {
                            position: 'top'
                        },
                        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                                ...iconProps,
                                size: "small",
                                color: "var(--ds-icon-inverse, #FFFFFF)"
                            }),
                        onClick: onDismissClick
                    })
                ]
            })
        })
    });
});

});


parcelRegister("jvhj0", function(module, exports) {
$parcel$export(module.exports, "AIProactiveNudge", () => $bb49400fdc6a2372$export$50a342ac0fc7ff57);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8KLBw = parcelRequire("8KLBw");

var $f1SBE = parcelRequire("f1SBE");
var $4j3Y4 = parcelRequire("4j3Y4");

var $dsB7O = parcelRequire("dsB7O");

var $ihZdh = parcelRequire("ihZdh");

var $gSqcA = parcelRequire("gSqcA");

var $68hwE = parcelRequire("68hwE");
const $bb49400fdc6a2372$var$NUDGE_DISMISS_TIMEOUT = 30000;
const $bb49400fdc6a2372$var$ANIMATION_DURATION = 200;
const $bb49400fdc6a2372$export$50a342ac0fc7ff57 = ()=>{
    const [dismissedIds, setDismissedIds] = (0, $eJOHy.useState)({});
    const [acceptedIds, setAcceptedIds] = (0, $eJOHy.useState)({});
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [triggerId] = (0, $eJOHy.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    const [isNudgeVisible, setIsNudgeVisible] = (0, $eJOHy.useState)(false);
    const [prevNudgeId, setPrevNudgeId] = (0, $eJOHy.useState)(null);
    const [isMouseHovering, setIsMouseHovering] = (0, $eJOHy.useState)(false);
    const hoverTimerRef = (0, $eJOHy.useRef)(null);
    const registeredNudges = (0, $f1SBE.useAINudges)();
    const surfaceMetadata = (0, $f1SBE.useAISurfaceMetadata)();
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $dsB7O.useRovoButtonEventsInstrumentation)();
    const { changeView: changeView } = (0, $4j3Y4.useViewAIActions)();
    const { recommendations: recommendations, loading: loading, error: error } = (0, $gSqcA.useFetchNudgeRecommendations)(triggerId, (0, $ihZdh.isBrowser)() ? window.location.href : '', surfaceMetadata?.product);
    const recommendation = (0, $eJOHy.useMemo)(()=>recommendations?.[0], [
        recommendations
    ]);
    const activeNudge = (0, $eJOHy.useMemo)(()=>{
        if (loading || error || !recommendation) return null;
        /**
     * Nudge must not be previously dismissed or accepted
     * to be considered active.
     */ if (dismissedIds[recommendation.nudge_id] || acceptedIds[recommendation.nudge_id]) return null;
        return registeredNudges.find((nudge)=>nudge.id === recommendation.feature_details.feature_id) || null;
    }, [
        loading,
        error,
        recommendation,
        dismissedIds,
        acceptedIds,
        registeredNudges
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (activeNudge && recommendation && recommendation.nudge_id !== prevNudgeId) {
            setPrevNudgeId(recommendation.nudge_id);
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'rendered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
            window.requestAnimationFrame(()=>{
                /**
         * Needs to be set to visible in next tick, otherwise
         * it will not animate
         */ setIsNudgeVisible(true);
            });
        }
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        prevNudgeId,
        recommendation,
        surfaceMetadata
    ]);
    const onDismissClick = (0, $eJOHy.useCallback)(()=>{
        if (activeNudge && recommendation) {
            setDismissedIds((prevIds)=>({
                    ...prevIds,
                    [recommendation.nudge_id]: true
                }));
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'dismissed',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    dismissedMethod: 'manual',
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        recommendation,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    const onNudgeClick = (0, $eJOHy.useCallback)(()=>{
        if (activeNudge && recommendation) {
            setAcceptedIds((prevIds)=>({
                    ...prevIds,
                    [recommendation.nudge_id]: true
                }));
            if (activeNudge.viewConfig) changeView(activeNudge);
            activeNudge.onClick?.();
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'clicked',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    eventNudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }
    }, [
        activeNudge,
        changeView,
        fireRovoButtonUIEvent,
        recommendation,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    const onWrapperMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsMouseHovering(true);
        hoverTimerRef.current = setTimeout(()=>{
            const nudgeId = activeNudge ? `${activeNudge.title} - ${activeNudge.id}` : '';
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    product: surfaceMetadata.product,
                    productPage: surfaceMetadata.contentType,
                    pageMode: surfaceMetadata.pageMode,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }, 1000);
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    const onWrapperMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsMouseHovering(false);
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        let timeoutId;
        let slideoutTimeoutId;
        if (activeNudge && recommendation && !isMouseHovering) {
            timeoutId = setTimeout(()=>{
                setDismissedIds((prevIds)=>({
                        ...prevIds,
                        [recommendation.nudge_id]: true
                    }));
                fireRovoButtonUIEvent({
                    source: surfaceMetadata.contentType,
                    action: 'dismissed',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoProactiveNudge',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode,
                        id: activeNudge.id,
                        timerDuration: $bb49400fdc6a2372$var$NUDGE_DISMISS_TIMEOUT,
                        dismissedMethod: 'timer_expired'
                    },
                    product: surfaceMetadata.product
                });
            }, $bb49400fdc6a2372$var$NUDGE_DISMISS_TIMEOUT);
            slideoutTimeoutId = setTimeout(()=>{
                setIsNudgeVisible(false);
            }, $bb49400fdc6a2372$var$NUDGE_DISMISS_TIMEOUT - $bb49400fdc6a2372$var$ANIMATION_DURATION);
        }
        /**
     * On mouse enter, isMouseHovering is set to true, will trigger
     *  cleanup function to clear timeout.
     */ return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
            if (slideoutTimeoutId) clearTimeout(slideoutTimeoutId);
        };
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        isMouseHovering,
        recommendation,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    if (!activeNudge) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $68hwE.NudgeContent), {
        activeNudge: activeNudge,
        isNudgeVisible: isNudgeVisible,
        onWrapperMouseEnter: onWrapperMouseEnter,
        onWrapperMouseLeave: onWrapperMouseLeave,
        onNudgeClick: onNudgeClick,
        onDismissClick: onDismissClick
    });
};

});
parcelRegister("gSqcA", function(module, exports) {
$parcel$export(module.exports, "useFetchNudgeRecommendations", () => $8f4972def65b1e17$export$dbee8b6a491a53c);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $ihZdh = parcelRequire("ihZdh");

var $a2Z0K = parcelRequire("a2Z0K");
const $8f4972def65b1e17$export$dbee8b6a491a53c = (triggerId, pageUrl, product)=>{
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [recommendations, setRecommendations] = (0, $eJOHy.useState)(undefined);
    const pageUrlRef = (0, $eJOHy.useRef)(pageUrl);
    // Mark the first page, as location == window.location.pathname but we still want to run makeNudgeRecommendationsRequest in this case
    const [landed, setLanded] = (0, $eJOHy.useState)(()=>{
        return true;
    });
    const [location, setLocation] = (0, $eJOHy.useState)((0, $ihZdh.isBrowser)() ? window.location.pathname : undefined);
    const makeNudgeRecommendationsRequest = (0, $eJOHy.useCallback)(async ()=>{
        if (!(0, $eGOwo.fg)('aix_nudge_recommendation_migration_enabled')) {
            setLoading(false);
            return;
        }
        // TODO: remove temporary hack when Confluence blog 500 bug is fixed
        const isBlog = pageUrl.includes('/blog/');
        if (isBlog) {
            setLoading(false);
            return;
        }
        if (!product) {
            setLoading(false);
            return;
        }
        try {
            const response = await (0, $a2Z0K.fetchNudgeRecommendations)({
                triggerId: triggerId,
                pageUrl: pageUrl,
                product: product
            });
            setRecommendations(response?.triggers.flatMap((trigger)=>trigger.recommendations.map((recommendation)=>recommendation.recommendation_details)));
            setError(undefined);
        } catch (error) {
            setRecommendations(undefined);
            setError(error);
        } finally{
            setLoading(false);
        }
    }, [
        triggerId,
        pageUrl,
        product
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Prevents makeNudgeRecommendationsRequest duplicate calls on the same pageUrl
        if (landed || location !== window.location.pathname) {
            setLocation(window.location.pathname);
            setLanded(false);
            makeNudgeRecommendationsRequest();
        }
    }, [
        makeNudgeRecommendationsRequest,
        location,
        landed
    ]);
    // Reset state immediately when pageUrl changes to prevent stale recommendations
    (0, $eJOHy.useEffect)(()=>{
        if (pageUrlRef.current !== pageUrl) {
            pageUrlRef.current = pageUrl;
            setRecommendations(undefined);
            setError(undefined);
            setLoading(true);
        }
    }, [
        pageUrl
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            recommendations: loading ? undefined : recommendations,
            loading: loading,
            error: error
        }), [
        loading,
        error,
        recommendations
    ]);
};

});
parcelRegister("a2Z0K", function(module, exports) {
$parcel$export(module.exports, "fetchNudgeRecommendations", () => $86ce3fbbecdab161$export$921bdedcb199d207);

var $eGOwo = parcelRequire("eGOwo");

var $ihZdh = parcelRequire("ihZdh");
// TODO: Extract and use factory pattern for different trigger types.
const $86ce3fbbecdab161$var$ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_PAGE_LOAD';
const $86ce3fbbecdab161$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';
const $86ce3fbbecdab161$export$921bdedcb199d207 = async ({ triggerId: triggerId, pageUrl: pageUrl, product: product })=>{
    if ((0, $ihZdh.isBrowser)() && window.AIX_DEBUG_NUDGE_TRIGGERS?.hasTriggers) return {
        triggers: [
            {
                recommendations: [
                    {
                        recommendation_details: window.AIX_DEBUG_NUDGE_TRIGGERS?.useNextTrigger()
                    }
                ]
            }
        ]
    };
    const request = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_details: {
                        page_url: pageUrl
                    },
                    trigger_type: $86ce3fbbecdab161$var$ROVO_BUTTON_TRIGGER_TYPE
                }
            ]
        }
    };
    const response = await fetch($86ce3fbbecdab161$var$CONVO_AI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': product,
            'X-Experience-Id': (0, $eGOwo.fg)('rovo_button_experience_id_enabled') ? 'proactive-ai-rovo-button' : 'ai-mate'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Error fetching agent recommendations and convo starters, status code: ${response.status}`);
    // Allow error to raise if response is not valid JSON
    // Allow undefined to be returned if ai_feature_output is not present
    return (await response.json())?.ai_feature_output;
};

});




parcelRegister("ctcNX", function(module, exports) {
$parcel$export(module.exports, "AIProactiveNudgeRefreshed", () => $97672c3446c808f2$export$f46d440bb7a501f5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $f1SBE = parcelRequire("f1SBE");

var $ihZdh = parcelRequire("ihZdh");

var $gSqcA = parcelRequire("gSqcA");

var $eQoVm = parcelRequire("eQoVm");

var $bukUp = parcelRequire("bukUp");

// Lazy load to avoid loading useRovoActionTrigger when there's no active nudge
const $97672c3446c808f2$var$LazyAIProactiveNudgeRefreshed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("iynrk")).then((module)=>({
            default: module.AIProactiveNudgeRefreshed
        })));
const $97672c3446c808f2$export$f46d440bb7a501f5 = ({ sidebarApi: sidebarApi, product: product, setShowButtonAnimation: setShowButtonAnimation })=>{
    const surfaceMetadata = (0, $f1SBE.useAISurfaceMetadata)();
    const [triggerId] = (0, $eJOHy.useState)(()=>crypto.randomUUID());
    const pageUrl = window.location.href;
    const { recommendations: recommendations, loading: loading, error: error } = (0, $gSqcA.useFetchNudgeRecommendations)(triggerId, (0, $ihZdh.isBrowser)() ? pageUrl : '', surfaceMetadata?.product);
    const { acceptedNudges: acceptedNudges, dismissedNudges: dismissedNudges, addAcceptedNudge: addAcceptedNudge, addDismissedNudge: addDismissedNudge } = (0, $bukUp.useNudgeSessionState)();
    const selectedNudges = (0, $f1SBE.useAINudgesRefreshed)();
    const potentialActiveNudgeLegacy = (0, $eJOHy.useMemo)(()=>{
        if ((0, $eGOwo.fg)('aix_nudge_recommendation_migration_enabled')) return null;
        /**
     * ConversationAction must not be previously dismissed or accepted
     * to be considered active.
     */ return selectedNudges?.find((nudge)=>!dismissedNudges.includes(nudge.id) && !acceptedNudges.includes(nudge.id)) ?? null;
    }, [
        selectedNudges,
        dismissedNudges,
        acceptedNudges
    ]);
    const potentialActiveNudge = (0, $eJOHy.useMemo)(()=>{
        if (potentialActiveNudgeLegacy) return potentialActiveNudgeLegacy;
        if (loading || error || !recommendations?.length || !selectedNudges?.length) return null;
        // TODO: dismiss/accept nudge by its nudgeContext.id so we only need to check recommendations
        // Remove conversation starter if dismissed or accepted
        const availableRecommendations = recommendations.filter((recommendation)=>!dismissedNudges.includes(recommendation.feature_details.feature_id) && !acceptedNudges.includes(recommendation.feature_details.feature_id));
        // Remove actions if dismissed or accepted
        const availableNudges = selectedNudges.filter((nudge)=>!dismissedNudges.includes(nudge.id) && !acceptedNudges.includes(nudge.id));
        return (0, $eQoVm.findActiveNudge)(availableRecommendations, availableNudges) ?? null;
    }, [
        acceptedNudges,
        dismissedNudges,
        error,
        loading,
        potentialActiveNudgeLegacy,
        recommendations,
        selectedNudges
    ]);
    // Early exit if no nudge to show
    if (!potentialActiveNudge) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($97672c3446c808f2$var$LazyAIProactiveNudgeRefreshed, {
            sidebarApi: sidebarApi,
            product: product,
            setShowButtonAnimation: setShowButtonAnimation,
            potentialActiveNudge: potentialActiveNudge,
            addAcceptedNudge: addAcceptedNudge,
            addDismissedNudge: addDismissedNudge
        })
    });
};

});
parcelRegister("eQoVm", function(module, exports) {
$parcel$export(module.exports, "findActiveNudge", () => $b612daf6f683b260$export$6c62f9c964ed3ae0);

var $eGOwo = parcelRequire("eGOwo");

var $lJeh3 = parcelRequire("lJeh3");
const $b612daf6f683b260$export$6c62f9c964ed3ae0 = (recommendations, availableNudges)=>{
    for (let recommendation of recommendations){
        if (recommendation.cta.cta_action === 'CHAT' && (0, $eGOwo.fg)('aix_convo_starter_nudge_enabled')) return {
            ...(0, $lJeh3.buildConversationStarter)(recommendation),
            recommendationNudgeId: recommendation.nudge_id
        };
        const matchedNudge = availableNudges.find((nudge)=>nudge.id === recommendation.feature_details.feature_id);
        const matchedNudgeByContextId = availableNudges.find((action)=>action.nudgeContext?.id === recommendation.feature_details.feature_id);
        if (matchedNudge) return {
            ...matchedNudge,
            recommendationNudgeId: recommendation.nudge_id
        };
        if (matchedNudgeByContextId) return {
            ...matchedNudgeByContextId,
            recommendationNudgeId: recommendation.nudge_id
        };
    }
    return undefined;
};

});
parcelRegister("lJeh3", function(module, exports) {
$parcel$export(module.exports, "buildConversationStarter", () => $700ab43ea73f30a2$export$854f6e3aeade3572);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lWfml = parcelRequire("lWfml");

var $a5iqo = parcelRequire("a5iqo");
const $700ab43ea73f30a2$export$854f6e3aeade3572 = (recommendation)=>({
        id: 'convo-starters',
        title: recommendation.cta.cta_label ?? '',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lWfml))), {
                label: ""
            }),
        description: undefined,
        type: 'convo-starter-action',
        onClick: ()=>{},
        staticPrompt: recommendation.cta.cta_label ?? '',
        starterType: 'static',
        handleType: (0, $a5iqo.HandleActionType).Chat
    });

});
parcelRegister("lWfml", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbcf1d1b12cba221f9c450106ed39371>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff8aedd45aa19647$var$_react = $ff8aedd45aa19647$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ff8aedd45aa19647$var$_baseNew = $ff8aedd45aa19647$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ff8aedd45aa19647$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff8aedd45aa19647$var$AiChatIcon = (props)=>/*#__PURE__*/ $ff8aedd45aa19647$var$_react.default.createElement($ff8aedd45aa19647$var$_baseNew.default, Object.assign({
        name: "AiChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$ff8aedd45aa19647$var$AiChatIcon.displayName = 'AiChatIcon';
var $ff8aedd45aa19647$var$_default = module.exports.default = $ff8aedd45aa19647$var$AiChatIcon;

});

parcelRegister("a5iqo", function(module, exports) {
$parcel$export(module.exports, "HandleActionType", () => $d756621a1c0860b2$export$87497e63e164f4b3);
$parcel$export(module.exports, "PageContextType", () => $d756621a1c0860b2$export$7f7a6f1c2ab5127);
var $d756621a1c0860b2$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    return HandleActionType;
}({});
var $d756621a1c0860b2$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});

});



parcelRegister("bukUp", function(module, exports) {
$parcel$export(module.exports, "useNudgeSessionState", () => $8ffcd01775f978f0$export$2bad233bdabe73c4);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $kVM4h = parcelRequire("kVM4h");

var $ihZdh = parcelRequire("ihZdh");
/**
 * The state only resets when:
 * - Location Changes: User navigates to a different page
 * - Page Refresh: Browser refreshes the page (global variables reset)
 * What Doesn't Reset the State
 * - Component Re-renders: State persists
 * - Component Unmount/Remount: State persists (this is what you want)
 * - Button Disappears/Reappears: State persists
 */ let $8ffcd01775f978f0$var$globalAcceptedNudges = [];
let $8ffcd01775f978f0$var$globalDismissedNudges = [];
const $8ffcd01775f978f0$export$2dd8f6b7dbe1b931 = ()=>{
    $8ffcd01775f978f0$var$globalAcceptedNudges = [];
    $8ffcd01775f978f0$var$globalDismissedNudges = [];
};
const $8ffcd01775f978f0$export$2bad233bdabe73c4 = ()=>{
    const { setNudgesRefreshed: setNudgesRefreshed } = (0, $kVM4h.useAISmartButtonActions)();
    const [location, setLocation] = (0, $eJOHy.useState)((0, $ihZdh.isBrowser)() ? window.location.pathname : undefined);
    const [acceptedNudges, setAcceptedNudges] = (0, $eJOHy.useState)($8ffcd01775f978f0$var$globalAcceptedNudges);
    const [dismissedNudges, setDismissedNudges] = (0, $eJOHy.useState)($8ffcd01775f978f0$var$globalDismissedNudges);
    // Helper functions
    const addAcceptedNudge = (0, $eJOHy.useCallback)((id)=>{
        setAcceptedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $8ffcd01775f978f0$var$globalAcceptedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const addDismissedNudge = (0, $eJOHy.useCallback)((id)=>{
        setDismissedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $8ffcd01775f978f0$var$globalDismissedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const clearState = (0, $eJOHy.useCallback)(()=>{
        setNudgesRefreshed([]);
        setAcceptedNudges([]);
        setDismissedNudges([]);
        $8ffcd01775f978f0$var$globalAcceptedNudges = [];
        $8ffcd01775f978f0$var$globalDismissedNudges = [];
    }, [
        setNudgesRefreshed
    ]);
    const handleLocationChange = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $ihZdh.isBrowser)()) return;
        if (location !== window.location.pathname) {
            setLocation(window.location.pathname);
            clearState();
        }
    }, [
        clearState,
        location,
        setLocation
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $ihZdh.isBrowser)()) return;
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $4eDgu.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            if (!(0, $ihZdh.isBrowser)()) return;
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return {
        acceptedNudges: acceptedNudges,
        dismissedNudges: dismissedNudges,
        addAcceptedNudge: addAcceptedNudge,
        addDismissedNudge: addDismissedNudge,
        clearState: clearState
    };
};

});

parcelRegister("iynrk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hdq8d").then(()=>parcelRequire('hP3MQ'));

});




parcelRegister("gxC9D", function(module, exports) {
$parcel$export(module.exports, "useConversationAssistantSidebarApi", () => $192a91fdede5ea98$export$b7bc690143f733fd);

var $eJOHy = parcelRequire("eJOHy");

var $dfP3D = parcelRequire("dfP3D");

const $192a91fdede5ea98$export$b7bc690143f733fd = ({ width: width = (0, $0b41093501185867$export$64aee74ba59709e5), isMinimised: isMinimised, toTop: toTop })=>{
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const isActive = panelId === (0, $0b41093501185867$export$dffb4ed44e20ea9a) && !isCollapsed;
    const isOtherPanelActive = panelId !== (0, $0b41093501185867$export$dffb4ed44e20ea9a) && !isCollapsed;
    const openSidebar = (0, $eJOHy.useCallback)((newWidth)=>{
        isOtherPanelActive && closeCurrentRightSidebar();
        openRightSidebar((0, $0b41093501185867$export$dffb4ed44e20ea9a), newWidth ?? width, isMinimised, toTop);
    }, [
        closeCurrentRightSidebar,
        isOtherPanelActive,
        openRightSidebar,
        width,
        isMinimised,
        toTop
    ]);
    const closeSidebar = (0, $eJOHy.useCallback)(()=>{
        closeRightSidebar((0, $0b41093501185867$export$dffb4ed44e20ea9a));
    }, [
        closeRightSidebar
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isSidebarOpen: ()=>isActive,
            openSidebar: openSidebar,
            closeSidebar: closeSidebar
        }), [
        isActive,
        openSidebar,
        closeSidebar
    ]);
};

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $0b41093501185867$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $0b41093501185867$export$64aee74ba59709e5 = 439; // px
const $0b41093501185867$export$1c07393c5bb1bc27 = 439; // px
const $0b41093501185867$export$aa3478deee7adbeb = 350; // px
const $0b41093501185867$export$21e515a86cd1733b = 'Chat';
const $0b41093501185867$export$e942bf04e23ff966 = 'Rovo';


parcelRegister("icfHo", function(module, exports) {
$parcel$export(module.exports, "useSourceAIActions", () => $9f11c9a811803a26$export$65d3ca67d6e65cf4);

var $eJOHy = parcelRequire("eJOHy");

var $jtwAV = parcelRequire("jtwAV");

var $kVM4h = parcelRequire("kVM4h");

var $8qkMT = parcelRequire("8qkMT");
const $9f11c9a811803a26$export$65d3ca67d6e65cf4 = (sourceId)=>{
    const { removeContext: removeContext, removeAll: removeAll, removeAutomationsConfig: removeAutomationsConfig, setActions: setActions, setNudges: setNudges, setNudgesRefreshed: setNudgesRefreshed, setSuggestedActions: setSuggestedActions, setContext: setContext, setAutomationsConfig: setAutomationsConfig } = (0, $kVM4h.useAISmartButtonActions)();
    const { setConversationActions: setConversationActions } = (0, $jtwAV.useConversationActionsStoreActions)();
    (0, $eJOHy.useEffect)(()=>{
        // Cleanup on unmount.
        return ()=>{
            removeAll(sourceId);
            removeContext(sourceId);
            removeAutomationsConfig(sourceId);
        };
    }, [
        sourceId,
        removeAll,
        removeContext,
        removeAutomationsConfig
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            /**
			 * Replaces all actions for this source with new ones.
			 */ setActions: (actions)=>{
                setActions(sourceId, actions);
                // TODO: delete this once we migrate consumers to new way of setting actions
                if (sourceId !== 'view-page' && sourceId !== 'editor') setConversationActions((0, $8qkMT.mapActionsToConversationActions)(actions));
            },
            /*
			 * Replaces all nudges for this source with new ones.
			 */ setNudges: (nudges)=>{
                setNudges(sourceId, nudges);
                // TODO: delete this once we migrate consumers to new way of setting nudges
                if (sourceId === 'jira-ai-rovo-button') setNudgesRefreshed((0, $8qkMT.mapActionsToConversationActions)(nudges));
            },
            /*
			 * Replaces all nudges for this source with new ones.
			 */ setNudgesRefreshed: (nudges)=>{
                setNudgesRefreshed(nudges);
            },
            /**
			 * Replaces all suggested actions for this source with new ones.
			 */ setSuggestedActions: (suggestedActions)=>{
                setSuggestedActions(sourceId, suggestedActions);
            },
            /**
			 * Sets context for this source.
			 */ setContext: (context)=>setContext({
                    ...context,
                    sourceId: sourceId
                }),
            /**
			 * Sets automations config for this source.
			 */ setAutomationsConfig: (automationsConfig)=>setAutomationsConfig({
                    ...automationsConfig,
                    sourceId: sourceId
                }),
            /**
			 * Removes context for this source.
			 */ removeContext: ()=>removeContext(sourceId),
            /**
			 * Removes automations config for this source.
			 */ removeAutomationsConfig: ()=>removeAutomationsConfig(sourceId),
            /**
			 * Removes all actions for this source.
			 */ removeAll: ()=>removeAll(sourceId)
        }), [
        sourceId,
        removeAll,
        removeContext,
        removeAutomationsConfig,
        setActions,
        setNudges,
        setNudgesRefreshed,
        setSuggestedActions,
        setContext,
        setAutomationsConfig,
        setConversationActions
    ]);
};

});
parcelRegister("jtwAV", function(module, exports) {
$parcel$export(module.exports, "useConversationActionsStore", () => $5d88f84f76025400$export$83a8985e8d377ba1);
$parcel$export(module.exports, "useConversationActionsStoreActions", () => $5d88f84f76025400$export$74d7aed167e24a67);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $5d88f84f76025400$var$store = (0, $GtRbT.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        input: '',
        activeAction: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
		 * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
		 */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            }
    }
});
const $5d88f84f76025400$export$83a8985e8d377ba1 = (0, $iJq0l.createHook)($5d88f84f76025400$var$store);
const $5d88f84f76025400$export$74d7aed167e24a67 = (0, $iJq0l.createActionsHook)($5d88f84f76025400$var$store);

});

parcelRegister("8qkMT", function(module, exports) {
$parcel$export(module.exports, "mapActionsToConversationActions", () => $28cf6e28e19cd77c$export$ed24f115d57335da);

var $a5iqo = parcelRequire("a5iqo");
const $28cf6e28e19cd77c$export$ed24f115d57335da = (baseActions)=>{
    return baseActions.map((action)=>({
            id: action.id,
            title: action.title,
            icon: (iconProps)=>action.icon,
            description: typeof action.description === 'string' ? action.description : undefined,
            onClick: action.onClick ?? undefined,
            viewConfig: action.viewConfig ?? undefined,
            children: action.children ? $28cf6e28e19cd77c$export$ed24f115d57335da(action.children) : undefined,
            closePanelOnSelection: action.closePanelOnSelection ?? undefined,
            ref: action.ref ?? undefined,
            type: action.type ?? undefined,
            handleType: $28cf6e28e19cd77c$var$getHandleType(action),
            customFollowUpContext: action.customFollowUpContext ?? undefined
        }));
};
const $28cf6e28e19cd77c$var$getHandleType = (action)=>{
    if (action.children) return (0, $a5iqo.HandleActionType).Nested;
    else if (action.type === 'convo-starter-action') return (0, $a5iqo.HandleActionType).Chat;
    else return (0, $a5iqo.HandleActionType).Base;
};

});



parcelRegister("5XGSn", function(module, exports) {
$parcel$export(module.exports, "useIsRovoAvailableForRoute", () => $fcebad7b396d9a43$export$a321b4e70b873404);

var $kfvK2 = parcelRequire("kfvK2");

var $4cTDP = parcelRequire("4cTDP");
/*
 * Controls whether specific routes can see the Rovo button.
 * Consult with the team in #global-rovo-button-roll-out in Slack if you have any questions.
 *
 * Add your routes here to control it using an experiment, feature gate, or static false value
 * Returning true will enable the Rovo button for the route if the global_rovo_button_in_jira feature gate is also enabled
 * Returning false will disable the Rovo button for the route
 */ const $fcebad7b396d9a43$var$blacklistedJiraRoutes = {};
/*
 * Controls whether specific route groups can see the Rovo button.
 * Consult with the team in #global-rovo-button-roll-out in Slack if you have any questions.
 *
 * Add your routes groups here to control it using an experiment, feature gate, or static false value
 * Returning true will enable the Rovo button for the route group if the global_rovo_button_in_jira feature gate is also enabled
 * Returning false will disable the Rovo button for the route group
 */ const $fcebad7b396d9a43$var$blacklistedJiraRouteGroups = {
    polaris: ()=>false,
    servicedesk: ()=>false
};
const $fcebad7b396d9a43$export$a321b4e70b873404 = (0, $kfvK2.createRouterSelector)((state)=>{
    const routeName = state.route.name;
    const routeGroup = state.route.group;
    // all routes blocked until global_rovo_button_in_jira is turned on
    if ((0, $4cTDP.fg)('global_rovo_button_in_jira')) {
        // Group-level takes precedence
        if (routeGroup && $fcebad7b396d9a43$var$blacklistedJiraRouteGroups[routeGroup]) return $fcebad7b396d9a43$var$blacklistedJiraRouteGroups[routeGroup]() ?? false;
        // Exclude embedded routes
        if (routeName.endsWith('-embed')) return false;
        if ($fcebad7b396d9a43$var$blacklistedJiraRoutes[routeName]) return $fcebad7b396d9a43$var$blacklistedJiraRoutes[routeName]() ?? false;
        return true;
    }
    return false;
});

});



parcelRegister("j5EMD", function(module, exports) {
$parcel$export(module.exports, "AiRovoCurrentRouteConfigurationProviderWithBoundary", () => $b0c65870991cc492$export$6d32a7294394ca5f);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $9TX3P = parcelRequire("9TX3P");
const $b0c65870991cc492$export$6d32a7294394ca5f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "rovo-current-route-configuration-provider",
        packageName: "ai-rovo-actions-route-provider",
        teamName: "reverie"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9TX3P.AiRovoCurrentRouteConfigurationProvider), null));
};

});
parcelRegister("9TX3P", function(module, exports) {
$parcel$export(module.exports, "AiRovoCurrentRouteConfigurationProvider", () => $e217415aaedaa985$export$aa2be06b613a2bcf);

var $eJOHy = parcelRequire("eJOHy");

var $lPvn5 = parcelRequire("lPvn5");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $isfIV = parcelRequire("isfIV");


var $dfP3D = parcelRequire("dfP3D");

var $iylKK = parcelRequire("iylKK");
const $e217415aaedaa985$var$entryPointParams = {};
const $e217415aaedaa985$export$aa2be06b613a2bcf = ()=>{
    const { resetConfiguration: resetConfiguration } = (0, $lPvn5.useAiRovoCurrentRouteConfigurationStoreActions)();
    const configuration = (0, $iylKK.useAiRovoActiveConfiguration)();
    (0, $eJOHy.useEffect)(()=>{
        if (!configuration?.entrypoint) resetConfiguration();
    }, [
        resetConfiguration,
        configuration
    ]);
    if (!configuration) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e217415aaedaa985$var$RovoEntryPointContainer, {
        entrypoint: configuration.entrypoint
    }), configuration.nudges && configuration.nudges());
};
const $e217415aaedaa985$var$RovoEntryPointContainer = ({ entrypoint: entrypoint })=>{
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)(entrypoint, $e217415aaedaa985$var$entryPointParams);
    const { setConfiguration: setConfiguration } = (0, $lPvn5.useAiRovoCurrentRouteConfigurationStoreActions)();
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            setConfiguration: setConfiguration
        }), [
        setConfiguration
    ]);
    const { mode: mode } = (0, $isfIV.useRovoExperienceAPIStore)();
    // TODO this shouldn't be needed since mode should be set to 'sidebar' when the sidebar is open,
    // but it isn't working right now. We should fix this in the rovo experience api store.
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const isActive = panelId === (0, $0b41093501185867$export$dffb4ed44e20ea9a) && !isCollapsed;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (mode === 'mini-modal' || mode === 'sidebar' || isActive) entryPointActions.load();
    }, [
        entryPointActions,
        mode,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.rovo.current-route-configuration",
        packageName: "jiraAiRovoActionsRouteProvider",
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("iylKK", function(module, exports) {
$parcel$export(module.exports, "useAiRovoActiveConfiguration", () => $0da5e866819bcf34$export$9e6d4fc03eb3d2f1);

var $eJOHy = parcelRequire("eJOHy");

var $jbgrT = parcelRequire("jbgrT");

var $hy4u9 = parcelRequire("hy4u9");

var $4bCwN = parcelRequire("4bCwN");

var $hS78B = parcelRequire("hS78B");

var $6cnWM = parcelRequire("6cnWM");

var $kfvK2 = parcelRequire("kfvK2");

var $jHRfo = parcelRequire("jHRfo");

var $bRozu = parcelRequire("bRozu");
const $0da5e866819bcf34$export$62040963369eb126 = {
    'software-backlog': {
        entrypoint: (0, $jbgrT.softwareBacklogConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bRozu.AiRovoSoftwareBacklogNudgesProvider), null)
    },
    'software-version-detail': {
        entrypoint: (0, $hy4u9.softwareVersionDetailConfigProviderEntrypoint)
    },
    'project-versions': {
        entrypoint: (0, $4bCwN.projectVersionsConfigProviderEntrypoint)
    },
    issue: {
        entrypoint: (0, $hS78B.issueConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jHRfo.AiRovoIssueViewNudgesProvider), null)
    },
    'software-plan-timeline': {
        entrypoint: (0, $6cnWM.planTimelineConfigProviderEntrypoint)
    }
};
const $0da5e866819bcf34$export$9e6d4fc03eb3d2f1 = ()=>{
    const [configuration, setConfiguration] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = (0, $kfvK2.addRouteListener)((route)=>{
            let configurationKey = route.route.name;
            /**
			 * Issue view has special case handling because it can be either a standalone issue view or an embed.
			 * Handling the query parameter in case embded is not set.
			 */ if (route.route.name === 'issue' || route.route.name === 'issue-embed' || route.location.search.includes('selectedIssue=')) configurationKey = 'issue';
            if (configurationKey in $0da5e866819bcf34$export$62040963369eb126 && $0da5e866819bcf34$export$62040963369eb126[configurationKey]) setConfiguration($0da5e866819bcf34$export$62040963369eb126[configurationKey] ?? null);
            else if (configuration !== null) setConfiguration(null);
        });
        return ()=>unsubscribe();
    }, [
        configuration
    ]);
    return configuration;
};

});
parcelRegister("jbgrT", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogConfigProviderEntrypoint", () => $33702c91d9b68f4d$export$58058f0aad5fa200);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $33702c91d9b68f4d$export$58058f0aad5fa200 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6mcQF")).then((module)=>module.SoftwareBacklogConfigProviderEntry), {
        moduleId: "5e405385",
        moduleName: "SoftwareBacklogConfigProvider",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6mcQF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8S3lD").then(()=>parcelRequire('2sxFh'));

});


parcelRegister("hy4u9", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailConfigProviderEntrypoint", () => $7ad168adff92956f$export$9928528a76670b31);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7ad168adff92956f$export$9928528a76670b31 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kL1AP")).then((module)=>module.SoftwareVersionDetailConfigProviderEntry), {
        moduleId: "ff7ec128",
        moduleName: "SoftwareVersionDetailConfigProvider",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kL1AP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g1Ytb").then(()=>parcelRequire('9QCmd'));

});


parcelRegister("4bCwN", function(module, exports) {
$parcel$export(module.exports, "projectVersionsConfigProviderEntrypoint", () => $afd5acfd8d4c0064$export$b714206f307b4f46);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $afd5acfd8d4c0064$export$b714206f307b4f46 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dIpAJ")).then((module)=>module.ProjectVersionsConfigProviderEntry), {
        moduleId: "82773f9e",
        moduleName: "ProjectVersionsConfigProvider",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dIpAJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gDg0T").then(()=>parcelRequire('4cbUQ'));

});


parcelRegister("hS78B", function(module, exports) {
$parcel$export(module.exports, "issueConfigProviderEntrypoint", () => $4b473b00e991485e$export$95bb315e7380f48d);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4b473b00e991485e$export$95bb315e7380f48d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bl5YZ")).then((module)=>module.IssueConfigProviderEntry), {
        moduleId: "254fe4be",
        moduleName: "IssueConfigProvider",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bl5YZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("BtsK2").then(()=>parcelRequire('7b8i9'));

});


parcelRegister("6cnWM", function(module, exports) {
$parcel$export(module.exports, "planTimelineConfigProviderEntrypoint", () => $dcd733c722308d9b$export$e5b98c2a5d0fe07b);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $dcd733c722308d9b$export$e5b98c2a5d0fe07b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8LUeO")).then((module)=>module.PlanTimelineConfigProviderEntry), {
        moduleId: "ce350e64",
        moduleName: "PlanTimelineConfigProvider",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8LUeO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lPS3O").then(()=>parcelRequire('9QPix'));

});


parcelRegister("jHRfo", function(module, exports) {
$parcel$export(module.exports, "AiRovoIssueViewNudgesProvider", () => $06d9be84eab0f7cc$export$c3f013efb90a1104);
// import { useEffect } from 'react';
// import { useAiRovoCurrentRouteConfigurationStoreActions } from '@jira/ai-rovo_actions-store/src/aiRovoCurrentRouteConfigurationStore.tsx';
// import { usePublish } from '@atlaskit/rovo-triggers';
/**
 * Example of a nudge for the issue view route.
 */ const $06d9be84eab0f7cc$export$c3f013efb90a1104 = ()=>{
    // const { updateConfiguration } = useAiRovoCurrentRouteConfigurationStoreActions();
    // const publish = usePublish('ai-mate');
    /**
	 * 	useEffect(() => {
		updateConfiguration({
			nudges: [
				{
					id: 'issue-view-rovo-nudge',
					title: 'Add a comment',
					description: 'Add a comment to the issue',
					icon: <CommentIcon label="Add a comment" size="medium" />,
					nudgeIcon: () => <CommentIcon label="Add a comment" size="medium" />,
					onClick: () => {
						publish({
							type: 'chat-new',
							product: 'jira',
							source: 'issue-view-rovo-nudge',
							data: {
								name: 'Add a comment',
								dialogues: [],
								prompt: 'Add a comment to the issue',
							},
						});
					},
					sourceId: 'jira-ai-rovo-button',
					status: 'beta',
				},
			],
		});
	}, [updateConfiguration, publish]);
	 */ return null;
};

});

parcelRegister("bRozu", function(module, exports) {
$parcel$export(module.exports, "AiRovoSoftwareBacklogNudgesProvider", () => $5f43313e6bc9f53d$export$bec24019a34c182c);
/**
 * Example of a nudge for the software backlog route.
 */ const $5f43313e6bc9f53d$export$bec24019a34c182c = ()=>{
    return null;
};

});




parcelRegister("4KUH1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3362ce20eb584ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $8q284 = parcelRequire("8q284");
const $e3362ce20eb584ae$var$CacheRegistry = ()=>{
    const accountIdLoggedInUser = (0, $e6YEs.useAccountId)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $8q284.default).set(accountIdLoggedInUser ?? 'anonymous');
    }, [
        accountIdLoggedInUser
    ]);
    return null;
};
var $e3362ce20eb584ae$export$2e2bcd8739ae039 = $e3362ce20eb584ae$var$CacheRegistry;

});
parcelRegister("8q284", function(module, exports) {
$parcel$export(module.exports, "CACHE_PREFIX", () => $1db56ef9394d1163$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $1db56ef9394d1163$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $1db56ef9394d1163$export$2e2bcd8739ae039);

var $3hRxq = parcelRequire("3hRxq");
let $1db56ef9394d1163$var$resolveCachePromise;
const $1db56ef9394d1163$var$cachePromise = new Promise((resolve)=>{
    $1db56ef9394d1163$var$resolveCachePromise = resolve;
});
const $1db56ef9394d1163$export$27be962d708928a = '__scope_key__';
const $1db56ef9394d1163$export$69ca515e4489d790 = 'cache_prefix';
const $1db56ef9394d1163$var$TIMEOUT = 10000;
const $1db56ef9394d1163$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $3hRxq.createLocalStorageProvider)($1db56ef9394d1163$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$1db56ef9394d1163$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $1db56ef9394d1163$export$653cd03438bb0386 = ()=>$1db56ef9394d1163$var$promiseWithMaxExecutionTime($1db56ef9394d1163$var$TIMEOUT, $1db56ef9394d1163$var$cachePromise);
const $1db56ef9394d1163$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $3hRxq.createLocalStorageProvider)($1db56ef9394d1163$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($1db56ef9394d1163$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($1db56ef9394d1163$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $1db56ef9394d1163$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $1db56ef9394d1163$export$2e2bcd8739ae039 = $1db56ef9394d1163$var$config;

});


parcelRegister("8R3rZ", function(module, exports) {
$parcel$export(module.exports, "SafeConversationAssistantPanel", () => $3cc317a76d5032d1$export$453401d0b697d2db);

var $eJOHy = parcelRequire("eJOHy");

var $3VCQy = parcelRequire("3VCQy");

var $2bY1m = parcelRequire("2bY1m");


var $5vQ2T = parcelRequire("5vQ2T");

var $dfP3D = parcelRequire("dfP3D");

var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $isfIV = parcelRequire("isfIV");

var $lsErf = parcelRequire("lsErf");

var $cxKOj = parcelRequire("cxKOj");

var $3S9KP = parcelRequire("3S9KP");

var $8xKig = parcelRequire("8xKig");

var $gxC9D = parcelRequire("gxC9D");
const $3cc317a76d5032d1$var$PanelInLayout = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eJOHy.useState)();
    const prevPanelIdRef = (0, $eJOHy.useRef)();
    const delayRef = (0, $eJOHy.useRef)(null);
    const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const panelId = rightSidebarCurrentState?.panelId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $isfIV.useRovoExperienceAPIStore)();
    const sidebarApi = (0, $gxC9D.useConversationAssistantSidebarApi)({});
    const toggleSidebar = (0, $eJOHy.useCallback)(()=>{
        toggleConversationAssistantUIMode({
            targetMode: (0, $lsErf.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const handleResizeComplete = (0, $eJOHy.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel',
            tags: [
                'atlaskit',
                'aiMate'
            ]
        }).fire((0, $3VCQy.FabricChannel).aiMate);
    }, [
        createAnalyticsEvent
    ]);
    /**
   * This use effect is used to add (when is necessary) a delay
   * in the panelId => localPanelId syncing
   */ (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $0b41093501185867$export$dffb4ed44e20ea9a)) {
            /**
       * The right-sidebar is showing the conversation assistant...
       */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
         * and is open, not collapsed and we want to show a panel
         * with an ID !== CONVERSATION_ASSISTANT_CONTAINER_ID
         */ setLocalPanelId(panelId);
            else /**
         * and we want to close it
         */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
                createAnalyticsEvent({
                    action: 'closed',
                    actionSubject: 'aiMatePanel',
                    source: 'AIMate',
                    tags: [
                        'atlaskit',
                        'aiMate'
                    ]
                }).fire((0, $3VCQy.FabricChannel).aiMate);
            }, 310);
        } else /**
       * If the right sidebar is not showing the conversation assistant,
       * we just keep localPanelId in sync with panelId
       */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        createAnalyticsEvent,
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $0b41093501185867$export$dffb4ed44e20ea9a)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bY1m.PanelSplitter), {
        label: formatMessage((0, $8xKig.default).panelSplitter),
        onResizeEnd: handleResizeComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3S9KP.JiraConversationAssistant), {
        onClosePanel: (0, $cxKOj.expValEquals)('jira_ai_rovo_button', 'treatment', 'B', 'A') ? toggleSidebar : closeCurrentRightSidebar
    }));
};
const $3cc317a76d5032d1$export$453401d0b697d2db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-conversation-assistant-panel",
        packageName: "jiraConversationAssistant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3cc317a76d5032d1$var$PanelInLayout, null));

});
parcelRegister("3S9KP", function(module, exports) {
$parcel$export(module.exports, "JiraConversationAssistant", () => $63db3c7564c5518e$export$da8473714271a41d);

var $eJOHy = parcelRequire("eJOHy");

var $34EqU = parcelRequire("34EqU");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lsErf = parcelRequire("lsErf");
var $3M3Tj = parcelRequire("3M3Tj");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $g9Vr6 = parcelRequire("g9Vr6");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $isfIV = parcelRequire("isfIV");

var $cxKOj = parcelRequire("cxKOj");

var $gxC9D = parcelRequire("gxC9D");
const $63db3c7564c5518e$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
const $63db3c7564c5518e$var$noopConfiguration = {};
const $63db3c7564c5518e$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, isMiniModalAvailable: isMiniModalAvailable } = (0, $isfIV.useRovoExperienceAPIStore)();
    const sidebarApi = (0, $gxC9D.useConversationAssistantSidebarApi)({});
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const configuration = (0, $4cTDP.fg)('global_rovo_button_in_jira_shared_layout_technical') ? (0, $34EqU.useAiRovoCurrentRouteConfiguration)() : $63db3c7564c5518e$var$noopConfiguration;
    const isSyntheticTenant = (0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $4cTDP.fg)('is_synthetic_tenant');
    const config = (0, $eJOHy.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            activationId: activationId,
            product: 'jira',
            orgId: orgId,
            experienceId: 'ai-mate',
            assistanceServiceConfig: {
                // TODO: type `AssistanceServiceConfig` should be decoupled from headers to prevent the need for other required keys which shouldn't need to be defined here (`product` and `experienceId`)
                headers: isSyntheticTenant ? {
                    [$63db3c7564c5518e$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                } : {},
                // Rename to `urlPrefix` in the package; baseUrl is a deprecated concept
                baseUrl: '/gateway/api/assist'
            }
        }), [
        cloudId,
        activationId,
        orgId,
        isSyntheticTenant
    ]);
    const modeConfig = (0, $eJOHy.useMemo)(()=>({
            mode: (0, $lsErf.ConversationAssistantUIModes).SIDEBAR,
            isMiniModalAvailable: isMiniModalAvailable,
            switchToMode: (mode)=>{
                toggleConversationAssistantUIMode({
                    targetMode: mode,
                    sidebarApi: sidebarApi
                });
            }
        }), [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const handleCloseChat = (0, $eJOHy.useCallback)(()=>{
        onClosePanel();
        toggleConversationAssistantUIMode({
            targetMode: undefined,
            sidebarApi: sidebarApi
        });
    }, [
        onClosePanel,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    // ROVOFE-76 - No resize wrapper for nav4 as it uses PanelSplitter now
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $63db3c7564c5518e$var$conversationAssistantWrapperNav4Styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3M3Tj.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: handleCloseChat,
        config: config,
        isNav4Enabled: true,
        ...(0, $cxKOj.expValEquals)('jira_ai_rovo_button', 'treatment', 'B', 'A') && {
            modeConfig: modeConfig
        },
        ...configuration
    }));
};
const $63db3c7564c5518e$var$conversationAssistantWrapperNav4Styles = (0, $1DXK0.xcss)({
    width: '100%',
    height: '100%'
});

});
parcelRegister("3M3Tj", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a81cf323a54e0c0$export$2e2bcd8739ae039);

var $joSn0 = parcelRequire("joSn0");

var $dLR8J = parcelRequire("dLR8J");
const $6a81cf323a54e0c0$var$createLoadingComponent = ()=>{
    return (0, $dLR8J.default)({
        name: 'LoadingConversationAssistantBundle'
    });
};

var $6a81cf323a54e0c0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("gfF9Z")).then((m)=>m.default || m),
    loading: $6a81cf323a54e0c0$var$createLoadingComponent
});

});
parcelRegister("gfF9Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("78HDH")
]).then(()=>parcelRequire('fI1ny'));

});



parcelRegister("8xKig", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b781c538b551238$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7b781c538b551238$var$messages = (0, $7qGN1.defineMessages)({
    panelSplitter: {
        "id": "platform-conversation-assistant.panelSplitter.label",
        "defaultMessage": "Resize panel"
    }
});
var $7b781c538b551238$export$2e2bcd8739ae039 = $7b781c538b551238$var$messages;

});


parcelRegister("71DNl", function(module, exports) {
$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", () => $bbc5703f5246e31a$export$4fa5b26bccc7e3df);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $3So8J = parcelRequire("3So8J");

var $bQWwW = parcelRequire("bQWwW");


// We are using an async here in addition to the jiraDeferEditionModalEntryPoint in ./entrypoint.tsx since
// we want to avoid unnecessarily preloading the expensive graphql query on each page load. Instead
// we load an async component that checks engagement-platform first if we are to show the modal or not.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bbc5703f5246e31a$var$AsyncDeferEditionEPCheck = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("6wdDm")).then(({ EPCheck: EPCheck })=>EPCheck), {
    ssr: false,
    moduleId: "./src/packages/growth/defer-edition-modal/src/EPCheck.tsx"
});
const $bbc5703f5246e31a$export$4fa5b26bccc7e3df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $94ac5b9dc076858e$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
        teamName: (0, $94ac5b9dc076858e$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $94ac5b9dc076858e$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bbc5703f5246e31a$var$AsyncDeferEditionEPCheck, props)));

});
const $94ac5b9dc076858e$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $94ac5b9dc076858e$export$d57b6b390e78d90f = 'transmuters-growth';
const $94ac5b9dc076858e$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $94ac5b9dc076858e$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $94ac5b9dc076858e$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $94ac5b9dc076858e$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $94ac5b9dc076858e$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $94ac5b9dc076858e$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $94ac5b9dc076858e$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $94ac5b9dc076858e$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
const $94ac5b9dc076858e$export$d62ac9eaaf8c4436 = 'COLLECTION';

parcelRegister("6wdDm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("rYVJw").then(()=>parcelRequire('lstlq'));

});


parcelRegister("56K43", function(module, exports) {
$parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", () => $89b0b4353885eda5$export$51f384a783f47807);

var $dZVRZ = parcelRequire("dZVRZ");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $89b0b4353885eda5$export$51f384a783f47807 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(async ()=>(parcelRequire("b8Y7a")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent), {
        moduleId: "d8076fb2",
        moduleName: "DeferEditionModalComponent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
            queries: {
                deferEditionModal: {
                    parameters: (0, $dZVRZ.default),
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey
                    }
                }
            }
        })
});

});
parcelRegister("dZVRZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb659c3aa5c4ea9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc717e646787b45b83219f95accf5320>>
 * @relayHash 34a74ac66eca635c747712defb7a1657
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6802548f0450f01e61d3b291ad1d282e613f75cd3e5162911e8aa80457820733
const $cb659c3aa5c4ea9c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6802548f0450f01e61d3b291ad1d282e613f75cd3e5162911e8aa80457820733",
        "metadata": {},
        "name": "DeferEditionModalComponentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $cb659c3aa5c4ea9c$export$2e2bcd8739ae039 = $cb659c3aa5c4ea9c$var$node;

});

parcelRegister("b8Y7a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bL0cp").then(()=>parcelRequire('fXTZj'));

});


parcelRegister("cKuba", function(module, exports) {
$parcel$export(module.exports, "endOfTrialExtensionEntryPoint", () => $6e2b158e89dfab56$export$dd41abc64eb3ea80);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6e2b158e89dfab56$export$dd41abc64eb3ea80 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3QOnF")), {
        moduleId: "13487943",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3QOnF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ipYdy").then(()=>parcelRequire('2Wlt9'));

});


parcelRegister("28GDA", function(module, exports) {
$parcel$export(module.exports, "LoadingBarUIController", () => $73dce8556544b0ee$export$39bdf67fc71ce8c8);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $fqbMu = parcelRequire("fqbMu");

var $02OvK = parcelRequire("02OvK");

var $3lhVL = parcelRequire("3lhVL");

var $gCY1z = parcelRequire("gCY1z");

var $1fv87 = parcelRequire("1fv87");

var $2G3oS = parcelRequire("2G3oS");
const $73dce8556544b0ee$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
    const [loadedState] = (0, $02OvK.default)();
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
    (0, $eJOHy.useEffect)(()=>{
        startLoading();
        return ()=>{
            resetLoading();
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (loadedState.hasLoaded) finishLoading();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
/**
 * Sets up the loading bar stylesheet and controller purely in the client
 * This is a fallback if SSR fails
 *
 */ const $73dce8556544b0ee$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
    const [actions, setActions] = (0, $eJOHy.useState)({});
    const sheetRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLStyleElement | null'.
        const loadingBarActions = (0, $fqbMu.createLoadingBarActionController)(sheetRef.current);
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
        setActions(loadingBarActions || {});
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLStyleElement> | undefined'.
        ref: sheetRef,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    ${(0, $1fv87.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $2G3oS.generateLoadingBarStyles)(0, (0, $1fv87.getLoadingBarColor)())}
                    }
                `
        }
    }), shouldRender && actions.START && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73dce8556544b0ee$export$54128ad8de32b897, {
        key: routeIdentifier,
        // @ts-expect-error - TS2339 - Property 'START' does not exist on type '{}'.
        startLoading: actions.START,
        // @ts-expect-error - TS2339 - Property 'RESET' does not exist on type '{}'.
        resetLoading: actions.RESET,
        // @ts-expect-error - TS2339 - Property 'FINISH' does not exist on type '{}'.
        finishLoading: actions.FINISH
    }));
};
const $73dce8556544b0ee$export$e068deb20d61b035 = ()=>{
    let currentTransitionsCount = 0;
    let currentRouteIdentifier = '';
    let currentRouteMatch = '';
    let hasTransitioned = false;
    let key = 0;
    return (transitionsCount, routeIdentifier, routeMatch)=>{
        if (transitionsCount !== currentTransitionsCount) {
            currentTransitionsCount = transitionsCount;
            hasTransitioned = true;
        }
        if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
            currentRouteIdentifier = routeIdentifier;
            currentRouteMatch = routeMatch;
            if (hasTransitioned) {
                hasTransitioned = false;
                key = currentTransitionsCount;
            }
        }
        return key;
    };
};
const $73dce8556544b0ee$var$getUniqueTransitionKey = $73dce8556544b0ee$export$e068deb20d61b035();
/**
 * Determines if the <LoadingBarController> should render or re-render
 * Injects dependencies into <LoadingBarController />
 *
 */ const $73dce8556544b0ee$export$39bdf67fc71ce8c8 = ()=>{
    const [routerState] = (0, $gCY1z.useRouter)();
    const [{ transitionsCount: transitionsCount }] = (0, $3lhVL.useSpaStateTransition)();
    const currentRoute = routerState.route && routerState.route.name;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
    const shouldRender = (0, $1fv87.getAllowedRoutes)().includes(currentRoute);
    // we generate a unique route identifier each time a transition happens
    // we use this key to force re-render of the <LoadingBarController />
    const routeIdentifier = (0, $eJOHy.useMemo)(()=>$73dce8556544b0ee$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
        transitionsCount,
        currentRoute,
        routerState.match
    ]);
    // We always expect the loading bar to be initialised in SSR for any route in ALLOWED_ROUTES
    // If this doesn't happen, it means SSR failed or the loading bar code in SSR failed
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRender && loaderFailedInSSR) (0, $eSnSE.default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loaderFailedInSSR
    ]);
    // If the loading bar fails to setup in SSR, we set up the action controller AND stylesheet in the client
    // We also do this if SSR renders a page that does not have the loading bar enabled (eg !shouldRender)
    if (loaderFailedInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73dce8556544b0ee$var$LoadingBarUI, {
        shouldRender: shouldRender,
        routeIdentifier: routeIdentifier
    });
    // if the loading bar is succesfully setup in SSR, all the client needs to do is dispatch loading actions
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (shouldRender && window.JIRA_LOADING_BAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73dce8556544b0ee$export$54128ad8de32b897, {
        key: routeIdentifier,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        startLoading: window.JIRA_LOADING_BAR.START,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resetLoading: window.JIRA_LOADING_BAR.RESET,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        finishLoading: window.JIRA_LOADING_BAR.FINISH
    });
    return null;
};

});
parcelRegister("fqbMu", function(module, exports) {
$parcel$export(module.exports, "createLoadingBarActionController", () => $dcb56f90df5e9022$export$55d67d61d9d2ad3b);
// BE VERY CAREFUL IMPORTING ANY PACKAGES IN THIS FILE
// THIS CODE IS AN INLINE FRAGMENT AND RUNS BEFORE POLYFILLS AND MAY BREAK IE

var $aKnYw = parcelRequire("aKnYw");
const $dcb56f90df5e9022$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $dcb56f90df5e9022$export$899393f3e23f724b = 15000;
const $dcb56f90df5e9022$export$7868b416d8929c55 = 40000;
const $dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
const $dcb56f90df5e9022$var$EXIT_ANIMATION_SPEED = 300;
const $dcb56f90df5e9022$export$99d4e8974a739853 = ()=>(0, $aKnYw.getMeta)('ajs-lf-navigation-highlightcolour') || $dcb56f90df5e9022$export$53d51cc6d57e44da;
const $dcb56f90df5e9022$export$4fb8742b05de9693 = (duration)=>`
    ${$dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
const $dcb56f90df5e9022$export$5a43e0f09174e553 = ()=>`
    ${$dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$dcb56f90df5e9022$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
const $dcb56f90df5e9022$export$6beef8c645a63156 = ()=>`
    ${$dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
const $dcb56f90df5e9022$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
const $dcb56f90df5e9022$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
const $dcb56f90df5e9022$var$browserFocusCheck = (action)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document && document.hidden) action();
    else requestAnimationFrame(()=>{
        action();
    });
};
const $dcb56f90df5e9022$export$55d67d61d9d2ad3b = (stylesheet)=>{
    const { sheet: sheet } = stylesheet || {};
    if (!sheet) return undefined;
    let isRunning = false;
    let isDelayed = false;
    let exitAnimationTimer;
    let delayedAnimationTimer;
    let timeoutTimer;
    return {
        START: (duration = $dcb56f90df5e9022$export$899393f3e23f724b)=>{
            if (isRunning) return;
            isRunning = true;
            // requestAnimationFrame will not run until the browser tab is focused
            // if a user opens a new tab the start animation will not begin until the tab is focused
            // this can cause the loading bar css to be applied in the incorrect order
            // to solve this we remove requestAnimationFrame if the tab is not focused
            $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                sheet.insertRule($dcb56f90df5e9022$export$4fb8742b05de9693(duration), sheet.cssRules.length);
            });
            // Set a new delayed animation if loader hasn't finished after `${duration}` ms
            delayedAnimationTimer = setTimeout(()=>{
                if (!isRunning) return;
                isDelayed = true;
                $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                    sheet.insertRule($dcb56f90df5e9022$export$610cb442736abf53(), sheet.cssRules.length);
                    sheet.insertRule($dcb56f90df5e9022$export$959e9e99fba397f1($dcb56f90df5e9022$export$99d4e8974a739853()), sheet.cssRules.length);
                });
            }, $dcb56f90df5e9022$export$899393f3e23f724b);
            // Remove the loader if it hasn't finished after `${TIMEOUT_TIMER}` ms
            timeoutTimer = setTimeout(()=>{
                if (!isRunning) return;
                isRunning = false;
                isDelayed = false;
                $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                    sheet.insertRule($dcb56f90df5e9022$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
            }, $dcb56f90df5e9022$export$7868b416d8929c55);
        },
        FINISH: ()=>{
            if (!isRunning) return;
            isRunning = false;
            if (isDelayed) {
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                    sheet.insertRule($dcb56f90df5e9022$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                return;
            }
            $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                sheet.insertRule($dcb56f90df5e9022$export$5a43e0f09174e553(), sheet.cssRules.length);
            });
            exitAnimationTimer = setTimeout(()=>{
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                    sheet.insertRule($dcb56f90df5e9022$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }, $dcb56f90df5e9022$var$EXIT_ANIMATION_SPEED + 500);
        },
        RESET: ()=>{
            isRunning = false;
            isDelayed = false;
            clearTimeout(exitAnimationTimer);
            clearTimeout(delayedAnimationTimer);
            clearTimeout(timeoutTimer);
            $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                sheet.insertRule($dcb56f90df5e9022$export$6beef8c645a63156(), sheet.cssRules.length);
            });
        }
    };
};
const $dcb56f90df5e9022$var$setupLoadingBarActionController = ()=>{
    const LOADER_STYLESHEET_ID = 'loaderStylesheet';
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'HTMLStyleElement | null'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
    // SSR will not attach the stylesheet for routes not included in ALLOWED_ROUTES
    if (!styleSheet || !styleSheet.sheet) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR = $dcb56f90df5e9022$export$55d67d61d9d2ad3b(styleSheet);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR.START();
};
$dcb56f90df5e9022$var$setupLoadingBarActionController();

});
parcelRegister("aKnYw", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $da448b1af413b2fc$export$c47913ca32a5c6f7);
const $da448b1af413b2fc$export$c47913ca32a5c6f7 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};

});


parcelRegister("3lhVL", function(module, exports) {
$parcel$export(module.exports, "useSpaStateTransition", () => $e4c186ffcf9d61e7$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $e4c186ffcf9d61e7$export$2e2bcd8739ae039);

var $gPCSe = parcelRequire("gPCSe");

var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $79p6g = parcelRequire("79p6g");
const $e4c186ffcf9d61e7$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $gPCSe.default) && (0, $gPCSe.default).timing && (0, $gPCSe.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $e4c186ffcf9d61e7$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $e4c186ffcf9d61e7$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $e4c186ffcf9d61e7$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $e4c186ffcf9d61e7$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $e4c186ffcf9d61e7$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $e4c186ffcf9d61e7$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/spa-state-controller/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $e4c186ffcf9d61e7$var$SpaStateTransitionStateSubscriber = (0, $ht3nQ.createSubscriber)((0, $79p6g.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $e4c186ffcf9d61e7$export$aea217a45095ce11
});
const $e4c186ffcf9d61e7$export$4d1974344641a2c9 = (0, $iJq0l.createHook)((0, $79p6g.default), {
    selector: $e4c186ffcf9d61e7$export$aea217a45095ce11
});
var $e4c186ffcf9d61e7$export$2e2bcd8739ae039 = $e4c186ffcf9d61e7$var$SpaStateTransitionStateSubscriber;

});

parcelRegister("1fv87", function(module, exports) {
$parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", () => $edb941f6bee7be00$export$2a3dd4ccb7b0a764);
$parcel$export(module.exports, "LOADER_STYLESHEET_ID", () => $edb941f6bee7be00$export$79456f717d4431da);
$parcel$export(module.exports, "getAllowedRoutes", () => $edb941f6bee7be00$export$c82eb262b97a76f1);
$parcel$export(module.exports, "getLoadingBarColor", () => $edb941f6bee7be00$export$cf3a5ed89e041425);

var $LFmXM = parcelRequire("LFmXM");

var $hWeHP = parcelRequire("hWeHP");

var $4cTDP = parcelRequire("4cTDP");
const $edb941f6bee7be00$var$FIRST_RELEASE_ROUTES_WITHOUT_LIST = [
    'issue',
    'issue-embed',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'your-work',
    'projects-directory',
    'boards-directory',
    'filters-directory',
    'dashboards-directory',
    'dashboards-directory-secure',
    'project-components',
    'project-pages',
    'project-versions',
    'software-deployments',
    'software-deployments-classic',
    'software-boards',
    'software-backlog',
    'software-periscope',
    'software-periscope-classic',
    'software-timeline',
    'software-roadmap',
    'software-roadmap-classic',
    'software-timeline-classic',
    'software-code',
    'software-code-classic',
    'software-reports',
    'software-reports-burnup',
    'software-reports-burndown',
    'software-reports-cumulative',
    'software-reports-velocity',
    'software-security',
    'software-security-classic',
    'issue-navigator',
    'global-issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'software-issue-navigator',
    'system-dashboard-edit'
];
const $edb941f6bee7be00$var$FIRST_RELEASE_ROUTES = [
    ...$edb941f6bee7be00$var$FIRST_RELEASE_ROUTES_WITHOUT_LIST,
    'software-list-classic',
    'software-list',
    'classic-business-list'
];
const $edb941f6bee7be00$export$2a3dd4ccb7b0a764 = 'body::before';
const $edb941f6bee7be00$export$79456f717d4431da = 'loaderStylesheet';
const $edb941f6bee7be00$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $edb941f6bee7be00$export$c82eb262b97a76f1 = (0, $LFmXM.default)(()=>{
    const ALLOWED_ROUTES = (0, $4cTDP.fg)('jira_list_nin_merge') ? $edb941f6bee7be00$var$FIRST_RELEASE_ROUTES : $edb941f6bee7be00$var$FIRST_RELEASE_ROUTES_WITHOUT_LIST;
    return ALLOWED_ROUTES;
});
const $edb941f6bee7be00$export$cf3a5ed89e041425 = (0, $LFmXM.default)(()=>(0, $hWeHP.default)('ajs-lf-navigation-highlightcolour') || $edb941f6bee7be00$export$53d51cc6d57e44da);

});

parcelRegister("2G3oS", function(module, exports) {
$parcel$export(module.exports, "generateLoadingBarStyles", () => $2240c5c719a7d109$export$3036104bc81246b1);

var $1jVV7 = parcelRequire("1jVV7");

var $1fv87 = parcelRequire("1fv87");
const $2240c5c719a7d109$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, $1jVV7.layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
const $2240c5c719a7d109$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, $1fv87.LOADER_STYLESHEET_ID}>
            ${0, $1fv87.LOADER_STYLES_CSS_SELECTOR} {${$2240c5c719a7d109$export$3036104bc81246b1(initialProgressValue, (0, $1fv87.getLoadingBarColor)())}}
        </style>`;

});


parcelRegister("aY5Xx", function(module, exports) {
$parcel$export(module.exports, "SafeHelpPanel", () => $eab455e5758ae8ec$export$cd2ada2fb14048fc);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $5vQ2T = parcelRequire("5vQ2T");


var $3VPsL = parcelRequire("3VPsL");


var $5bQ7z = parcelRequire("5bQ7z");

var $29oTB = parcelRequire("29oTB");

var $dfP3D = parcelRequire("dfP3D");

var $e6YEs = parcelRequire("e6YEs");
const $eab455e5758ae8ec$var$HelpPanel = ()=>{
    const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $3VPsL.useHelpPanel)();
    const { closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const accountId = (0, $e6YEs.useAccountId)();
    (0, $eJOHy.useEffect)(()=>{
        const restoreReleaseNotesNotifications = async ()=>{
            if (accountId) try {
                // @ts-expect-error - Property 'helpPanel' does not exist on type 'unknown'.
                const { helpPanel: userPropertiesHelpPanelValue } = await (0, $FppkK.getUserProperty)(accountId, (0, $efba850e54af37c8$export$783d7c02e3a0cbf));
                setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
            } catch (err) {
                /* getUserProperty throws if not found */ setReleaseNotesNotifications(0);
            }
            else setReleaseNotesNotifications(0);
        };
        restoreReleaseNotesNotifications();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bQ7z.RemoteStateUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $29oTB.LazyHelpPanel), {
        isOpen: !rightSidebarCurrentState?.isCollapsed,
        navigationData: navigationData,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        releaseNotesNotificationsSetter: setReleaseNotesNotifications,
        hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
        onCloseHelpPanel: closeRightSidebar
    }));
};
const $eab455e5758ae8ec$var$HelpPanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eJOHy.useState)();
    const prevPanelIdRef = (0, $eJOHy.useRef)();
    const delayRef = (0, $eJOHy.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $60b564818f0d5fed$export$e99efa3985fa3c26)) {
            /**
			 * The right-sidebar is showing the help-panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== HELP_PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the help-panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $60b564818f0d5fed$export$e99efa3985fa3c26)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eab455e5758ae8ec$var$HelpPanel, null);
};
const $eab455e5758ae8ec$export$cd2ada2fb14048fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-help-panel",
        packageName: "@atlassian/jira-help-panel-right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eab455e5758ae8ec$var$HelpPanelInLayout, null));

});
const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = 368;

parcelRegister("3VPsL", function(module, exports) {
$parcel$export(module.exports, "useHelpPanel", () => $39739d0e1c6f9274$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $39739d0e1c6f9274$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $6wZ6K = parcelRequire("6wZ6K");
const $39739d0e1c6f9274$export$3fe94d66377a53b8 = (0, $iJq0l.createHook)((0, $6wZ6K.default));
const $39739d0e1c6f9274$export$c61f56f4797e22db = (0, $iJq0l.createHook)((0, $6wZ6K.default), {
    selector: null
});
const $39739d0e1c6f9274$export$513717a84f55db1a = (0, $ht3nQ.createSubscriber)((0, $6wZ6K.default), {
    displayName: 'HelpPanelSubscriber'
});
const $39739d0e1c6f9274$export$5f4de38bd79f4446 = (0, $ht3nQ.createSubscriber)((0, $6wZ6K.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("6wZ6K", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0401c126f56172a$export$2e2bcd8739ae039);

var $8tIrO = parcelRequire("8tIrO");

var $GtRbT = parcelRequire("GtRbT");

var $efQxP = parcelRequire("efQxP");
let $e0401c126f56172a$var$iphStorage;
const $e0401c126f56172a$var$createStorage = ()=>{
    if ($e0401c126f56172a$var$iphStorage) return $e0401c126f56172a$var$iphStorage;
    $e0401c126f56172a$var$iphStorage = (0, $8tIrO.createSessionStorageProvider)('iph');
    return $e0401c126f56172a$var$iphStorage;
};
const $e0401c126f56172a$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $e0401c126f56172a$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $e0401c126f56172a$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'help-panel',
    initialState: $e0401c126f56172a$var$initialState,
    actions: $efQxP
});

});
parcelRegister("efQxP", function(module, exports) {
$parcel$export(module.exports, "setNavigationData", () => $b1de94cedbb71714$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $b1de94cedbb71714$export$cdabe01d01a8da1e);

var $8tIrO = parcelRequire("8tIrO");
const $b1de94cedbb71714$var$iphStorage = (0, $8tIrO.createSessionStorageProvider)('iph');
const $b1de94cedbb71714$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $b1de94cedbb71714$var$iphStorage.set('history', []);
    };
const $b1de94cedbb71714$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



const $efba850e54af37c8$export$783d7c02e3a0cbf = 'help_panel_ui_state';

parcelRegister("5bQ7z", function(module, exports) {
$parcel$export(module.exports, "RemoteStateUpdater", () => $5652fb65b99633f4$export$3db011870dd4330f);

var $eJOHy = parcelRequire("eJOHy");

var $1kTCl = parcelRequire("1kTCl");

var $9pTd3 = parcelRequire("9pTd3");

var $FppkK = parcelRequire("FppkK");

var $e6YEs = parcelRequire("e6YEs");

var $3VPsL = parcelRequire("3VPsL");

const $5652fb65b99633f4$var$DEBOUNCE_TIME = 1000;
const $5652fb65b99633f4$export$3db011870dd4330f = ()=>{
    // right-sidebar
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $3VPsL.useHelpPanel)();
    const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $eJOHy.useState)(releaseNotesNotifications);
    const accountId = (0, $e6YEs.useAccountId)();
    const [debouncedUpdateData] = (0, $1kTCl.default)(async (newReleaseNotesNotifications)=>{
        const remoteData = {
            helpPanel: {
                releaseNotesNotifications: newReleaseNotesNotifications
            }
        };
        if (accountId) try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $efba850e54af37c8$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'updateServerHelpPanelState',
                    packageName: 'jiraHelpPanelServices',
                    teamName: 'self-help-experiences'
                }
            });
        }
    }, $5652fb65b99633f4$var$DEBOUNCE_TIME);
    (0, $eJOHy.useEffect)(()=>{
        if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setReleaseNotesNotificationsTemp(releaseNotesNotifications);
            debouncedUpdateData(releaseNotesNotifications);
        }
    }, [
        debouncedUpdateData,
        releaseNotesNotifications,
        releaseNotesNotificationsTemp
    ]);
    return null;
};

});

parcelRegister("29oTB", function(module, exports) {
$parcel$export(module.exports, "LazyHelpPanel", () => $3b7f9896b69ebb12$export$51c79455aef7d178);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $3So8J = parcelRequire("3So8J");

var $2imLM = parcelRequire("2imLM");

var $3MbOI = parcelRequire("3MbOI");

var $kGj4V = parcelRequire("kGj4V");

var $fathc = parcelRequire("fathc");

var $2iwcU = parcelRequire("2iwcU");

var $e8WdG = parcelRequire("e8WdG");

var $iPI5r = parcelRequire("iPI5r");
const $3b7f9896b69ebb12$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
    const user = (0, $3MbOI.useCurrentUser)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "help-panel",
        packageName: "jiraHelpPanel",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2iwcU.default), {
                loadingArticle: articleId.id !== ''
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
        id: "root",
        packageName: "jiraHelpPanel",
        teamName: "self-help-experiences"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e8WdG.SearchContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        tags: [
            'iph'
        ],
        sourceName: "jiraHelpPanel",
        sourceType: (0, $aa42ce8e355d58fa$export$9d2de6eebf7462b5),
        attributes: {
            searchService: 'help-aggregator',
            routeGroup: routeGroup,
            routeName: routeName,
            userId: user?.data?.user?.accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fathc.LazyWait), {
        until: hasBeenRendered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-lazy-help-panel",
        fallback: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2iwcU.default), {
            loadingArticle: articleId.id !== ''
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iPI5r.AsyncLazyHelpPanel), {
        navigationData: {
            articleId: articleId,
            history: history
        },
        releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        isOpen: isOpen,
        onCloseHelpPanel: onCloseHelpPanel,
        routeGroup: routeGroup,
        routeName: routeName
    })))))));
};

});
parcelRegister("2iwcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $8125c878b5cd420f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $66x0e = parcelRequire("66x0e");
const $8125c878b5cd420f$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $66x0e.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        role: "img",
        "aria-label": "help panel loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-250, 20px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "90%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "70%"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $66x0e.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-500, 40px)",
        marginTop: "var(--ds-space-100, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadignArticleList, {
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })))));
var $8125c878b5cd420f$export$2e2bcd8739ae039 = $8125c878b5cd420f$var$HelpPanelLoading;
/**
 * Header
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8125c878b5cd420f$var$LoadingContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $8125c878b5cd420f$var$HeaderLoading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zlnq84 _4t3ixncg _bfhkfg4m _1bah1yb4 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $8125c878b5cd420f$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8125c878b5cd420f$var$LoadingRectangle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_l7mdyr": (0, $awdRS.default)(__cmplp.contentHeight),
            "--_1fj4wta": (0, $awdRS.default)(__cmplp.marginTop),
            "--_7n1eiw": (0, $awdRS.default)(__cmplp.contentWidth)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _kqswh2mm _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk1v33 _1itkaioo _12vemgnk",
            __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
            __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
            __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8125c878b5cd420f$var$LoadignArticleList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _vchhusvi",
            __cmplp.className
        ])
    });
});
const $8125c878b5cd420f$var$LoadignArticleListItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule _1bsb1osq _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("66x0e", function(module, exports) {
$parcel$export(module.exports, "HelpPanelContainer", () => $e7337023f734e957$export$37cd645d7678f7d4);
$parcel$export(module.exports, "HelpPanelContainerV2", () => $e7337023f734e957$export$1df7e3ebfc4c9b06);
$parcel$export(module.exports, "HelpPanelSectionMessageContainer", () => $e7337023f734e957$export$9f6251c714594f23);
$parcel$export(module.exports, "HelpPanelContentContainer", () => $e7337023f734e957$export$1cdb922eed7271d1);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6zXPf = parcelRequire("6zXPf");
const $e7337023f734e957$export$37cd645d7678f7d4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _vchhusvi _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
            !(0, $6zXPf.getWillShowNav4)() && "_1kl7pu5c",
            __cmplp.className
        ])
    });
});
const $e7337023f734e957$export$1df7e3ebfc4c9b06 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $e7337023f734e957$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1i8v _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $e7337023f734e957$export$9f6251c714594f23 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _ca0qpxbi _u5f3pxbi _n3tdidpf _19bvpxbi _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $e7337023f734e957$export$1cdb922eed7271d1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});


parcelRegister("e8WdG", function(module, exports) {
$parcel$export(module.exports, "useSearchContext", () => $566b0e2b04e0ed5d$export$67b98b1b880a048b);
$parcel$export(module.exports, "SearchContextProvider", () => $566b0e2b04e0ed5d$export$6bd70292443463a4);

var $eJOHy = parcelRequire("eJOHy");

var $iITas = parcelRequire("iITas");
const [$566b0e2b04e0ed5d$export$67b98b1b880a048b, $566b0e2b04e0ed5d$export$70af50e847ce290a] = (0, $iITas.createCtx)();
const $566b0e2b04e0ed5d$export$6bd70292443463a4 = ({ children: children })=>{
    const [searchContext, setSearchContext] = (0, $eJOHy.useState)({});
    const addClickedArticleIds = (0, $eJOHy.useCallback)((query, clickedArticleId)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    clickedArticleIds: prev[query]?.clickedArticleIds ? [
                        ...prev[query].clickedArticleIds,
                        clickedArticleId
                    ] : [
                        clickedArticleId
                    ]
                }
            }));
    }, []);
    const addFetchedArticleIds = (0, $eJOHy.useCallback)((query, fetchedArticles)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    fetchedArticleIds: fetchedArticles
                }
            }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($566b0e2b04e0ed5d$export$70af50e847ce290a, {
        value: {
            searchContext: searchContext,
            addClickedArticleIds: addClickedArticleIds,
            addFetchedArticleIds: addFetchedArticleIds
        }
    }, children);
};

});
parcelRegister("iITas", function(module, exports) {
$parcel$export(module.exports, "createCtx", () => $2159147717cc56e1$export$d653a1a643c9a98c);

var $eJOHy = parcelRequire("eJOHy");
function $2159147717cc56e1$export$d653a1a643c9a98c() {
    const ctx = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
    function useCtx() {
        const c = (0, $eJOHy.useContext)(ctx);
        if (!c) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [
        useCtx,
        ctx.Provider
    ];
}

});


parcelRegister("iPI5r", function(module, exports) {
$parcel$export(module.exports, "AsyncLazyHelpPanel", () => $aa0bb30697b38a66$export$7ff46d33d0f13518);

var $bQWwW = parcelRequire("bQWwW");

const $aa0bb30697b38a66$export$7ff46d33d0f13518 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gCrt9")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
});

});
parcelRegister("gCrt9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("fDVhN")
]).then(()=>parcelRequire('8be30'));

});




parcelRegister("cosWN", function(module, exports) {
$parcel$export(module.exports, "SafeEmbeddedConfluencePanel", () => $5af1d35198948c0c$export$2d901a489872dd0d);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7qNGi = parcelRequire("7qNGi");

var $vztq1 = parcelRequire("vztq1");

var $5vQ2T = parcelRequire("5vQ2T");

var $dfP3D = parcelRequire("dfP3D");

var $80rW8 = parcelRequire("80rW8");
const $5af1d35198948c0c$var$DELAY = 310;
const $5af1d35198948c0c$var$PanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const [{ panel: isOpen }] = (0, $vztq1.useEmbeddedConfluenceSidePanel)();
    const [localPanelId, setLocalPanelId] = (0, $eJOHy.useState)();
    const prevPanelIdRef = (0, $eJOHy.useRef)();
    const delayRef = (0, $eJOHy.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, $80rW8.useEmbeddedPanelEntryPoint)();
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen) entryPointActions?.load();
    }, [
        isOpen,
        entryPointActions,
        localPanelId
    ]);
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
            /**
			 * The right-sidebar is showing the embedded confluence content...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            // TODO: trigger close analytics event
            }, $5af1d35198948c0c$var$DELAY);
        } else /**
			 * If the right sidebar is not showing the embedded confluence content,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5af1d35198948c0c$var$panelStyles
    }, entryPoint);
};
const $5af1d35198948c0c$export$2d901a489872dd0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-embedded-confluence-panel",
        packageName: "jiraIssueCreateConfluenceContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $vztq1.EmbeddedConfluenceSidepanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5af1d35198948c0c$var$PanelInLayout, null)));
const $5af1d35198948c0c$var$panelStyles = (0, $1DXK0.xcss)({
    padding: 'space.100',
    height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
});

});
parcelRegister("7qNGi", function(module, exports) {
$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $0226e4fb226e1b22$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $0226e4fb226e1b22$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $0226e4fb226e1b22$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $0226e4fb226e1b22$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $0226e4fb226e1b22$export$8d0c4a26241944b8);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", () => $0226e4fb226e1b22$export$a497288e64e9a343);
const $0226e4fb226e1b22$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $0226e4fb226e1b22$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $0226e4fb226e1b22$export$e34c4c923d934e7a = 'user-confluence-access';
const $0226e4fb226e1b22$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $0226e4fb226e1b22$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
const $0226e4fb226e1b22$export$a497288e64e9a343 = 'embedded-confluence-panel-container';

});

parcelRegister("vztq1", function(module, exports) {
$parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", () => $c7edbeb9f475152a$export$a5c1c168018f0f16);
$parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", () => $c7edbeb9f475152a$export$518aeea31a00450e);

var $eJOHy = parcelRequire("eJOHy");

var $bmoS1 = parcelRequire("bmoS1");

var $dfP3D = parcelRequire("dfP3D");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7qNGi = parcelRequire("7qNGi");

var $4Ip8A = parcelRequire("4Ip8A");

var $ajyyy = parcelRequire("ajyyy");

var $lYAmh = parcelRequire("lYAmh");
/**
 * Container for {@link useEmbeddedConfluenceSidePanel}. Any component that uses this hook
 * must be wrapped in this container.
 */ const $c7edbeb9f475152a$var$Container = (0, $6E16M.createContainer)();
const $c7edbeb9f475152a$var$DefaultStore = (0, $GtRbT.createStore)({
    actions: $4Ip8A.actions,
    containedBy: $c7edbeb9f475152a$var$Container,
    initialState: $4Ip8A.initialState,
    name: (0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $c7edbeb9f475152a$export$a5c1c168018f0f16 = ({ children: children })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    /*
	In order for each usage of the store to manage the same state irregardless of
	their location in the component tree, we need to wrap components in a container
	with the same scope value. This is why we use the issueKey in the scope value.
	see https://atlassian.github.io/react-sweet-state/#/advanced/container?id=scoped-data-sharing
	for more information about scoped data sharing.

	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7edbeb9f475152a$var$Container, {
        scope: `embedded-confluence-sidepanel-${issueKey}`
    }, children);
};
const $c7edbeb9f475152a$var$defaultStoreHook = (0, $iJq0l.createHook)($c7edbeb9f475152a$var$DefaultStore);
const $c7edbeb9f475152a$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
    const [state, { closeSidePanel: closeSidePanelAction, openSidePanel: openSidePanelAction, setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceData: setDeferredSpaceData, toggleExpandedState: toggleExpandedState, setIsDraftState: setIsDraftState, setConfluenceData: setConfluenceData }] = $c7edbeb9f475152a$var$defaultStoreHook();
    const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const openSidePanel = (0, $eJOHy.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
        const { initialWidth: initialWidth, displayType: displayType } = (0, $lYAmh.getDisplayInformation)();
        const shouldOpenPanel = displayType === (0, $ajyyy.DisplayTypes).PANEL;
        if (shouldOpenPanel) {
            openSidePanelAction({
                contentId: contentId,
                contentType: contentType,
                embeddedConfluenceSource: embeddedConfluenceSource,
                data: data,
                displayType: displayType,
                initialWidth: initialWidth,
                hostname: hostname,
                isDraft: isDraft,
                isLive: isLive,
                mode: mode,
                onLinkPage: onLinkPage,
                onPublish: onPublish,
                shouldOpenModal: !shouldOpenPanel,
                url: url,
                title: title
            });
            openRightSidebar((0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
        } else openInModal();
    }, [
        embeddedConfluenceSource,
        openRightSidebar,
        openSidePanelAction
    ]);
    const closeSidePanel = (0, $eJOHy.useCallback)(()=>{
        closeRightSidebar((0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
        closeSidePanelAction();
    }, [
        closeRightSidebar,
        closeSidePanelAction
    ]);
    return [
        state,
        {
            openSidePanel: openSidePanel,
            closeSidePanel: closeSidePanel,
            setDeferredSpaceData: setDeferredSpaceData,
            setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection,
            toggleExpandedState: toggleExpandedState,
            setIsDraftState: setIsDraftState,
            setConfluenceData: setConfluenceData
        }
    ];
};

});
parcelRegister("4Ip8A", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $03f714671d0d2aa4$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $03f714671d0d2aa4$export$e324594224ef24da);

var $6DF4T = parcelRequire("6DF4T");
var $9fAcm = parcelRequire("9fAcm");

var $ajyyy = parcelRequire("ajyyy");
const $03f714671d0d2aa4$export$d4c72bab9d6cc13a = {
    confluenceData: {
        contentId: '',
        contentUrl: '',
        contentData: null,
        mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        isDraft: false,
        isLive: false
    },
    contentActions: {},
    contentType: (0, $ajyyy.ConfluenceContentTypes).PAGE,
    embeddedConfluenceSource: '',
    displayType: (0, $ajyyy.DisplayTypes).PANEL,
    panel: {
        initialWidth: 0,
        isOpen: false,
        isLoading: false,
        isExpanded: false
    },
    modal: {
        isOpen: false
    }
};
const $03f714671d0d2aa4$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, isExpanded: isExpanded, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
        setState({
            confluenceData: {
                contentId: contentId,
                contentUrl: url,
                contentData: data,
                hostname: hostname,
                mode: mode,
                isDraft: isDraft,
                isLive: isLive,
                title: title,
                spaceKey: (0, $9fAcm.parseUrl)(url)?.spaceKey
            },
            contentActions: {
                onLinkPage: onLinkPage,
                onPublish: onPublish
            },
            embeddedConfluenceSource: embeddedConfluenceSource,
            contentType: contentType,
            displayType: displayType,
            panel: {
                initialWidth: initialWidth,
                isOpen: !shouldOpenModal,
                isExpanded: isExpanded
            },
            modal: {
                isOpen: shouldOpenModal
            }
        });
    };
const $03f714671d0d2aa4$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
        setState($03f714671d0d2aa4$export$d4c72bab9d6cc13a);
    };
const $03f714671d0d2aa4$export$473e6cac57a0d506 = (deferredSpaceName, deferredSpaceKey)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                deferredSpaceName: deferredSpaceName,
                spaceKey: deferredSpaceKey || confluenceData.spaceKey
            },
            ...prevState
        });
    };
const $03f714671d0d2aa4$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        setState({
            ...prevState,
            isDeferSpaceSelection: isDeferSpaceSelection,
            panel: {
                ...panel,
                isLoading: isLoading
            }
        });
    };
const $03f714671d0d2aa4$export$b29d56f843007f2b = ()=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        const isCurrentlyExpanded = panel.isExpanded;
        setState({
            panel: {
                ...panel,
                isExpanded: !isCurrentlyExpanded
            },
            ...prevState
        });
    };
const $03f714671d0d2aa4$export$5d0561abb73760f = ({ newIsDraftState: newIsDraftState })=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                isDraft: newIsDraftState
            },
            ...prevState
        });
    };
const $03f714671d0d2aa4$export$1a8782a287467f35 = (newData)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...newData
            },
            ...prevState
        });
    };
const $03f714671d0d2aa4$export$e324594224ef24da = {
    closeSidePanel: $03f714671d0d2aa4$export$e81b26ab493ca52a,
    openSidePanel: $03f714671d0d2aa4$export$aa5d06fef96639ba,
    setDeferredSpaceData: $03f714671d0d2aa4$export$473e6cac57a0d506,
    setIsDraftState: $03f714671d0d2aa4$export$5d0561abb73760f,
    setIsLoadingForDeferSpaceSelection: $03f714671d0d2aa4$export$db9852cd4946540a,
    toggleExpandedState: $03f714671d0d2aa4$export$b29d56f843007f2b,
    setConfluenceData: $03f714671d0d2aa4$export$1a8782a287467f35
};

});
parcelRegister("6DF4T", function(module, exports) {
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $0203ec221428541d$export$816ef638e478449a);
var $0203ec221428541d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});

parcelRegister("9fAcm", function(module, exports) {
$parcel$export(module.exports, "parsePageProps", () => $e9b8e0d00fbd3627$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $e9b8e0d00fbd3627$export$7a5253c0f62e0150);
parcelRequire("dtqUA");
var $ddbcJ = parcelRequire("ddbcJ");

var $4CCpn = parcelRequire("4CCpn");

var $8HgDC = parcelRequire("8HgDC");

var $6DF4T = parcelRequire("6DF4T");

var $3V5nR = parcelRequire("3V5nR");
function $e9b8e0d00fbd3627$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $e9b8e0d00fbd3627$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $e9b8e0d00fbd3627$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $4CCpn.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    const previewPanels = $e9b8e0d00fbd3627$var$parseQueryParam(parsedProps.query, 'previewPanels');
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $3V5nR.VIEW_PAGE).name:
        case (0, $3V5nR.VIEW_BLOG).name:
        case (0, $3V5nR.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $3V5nR.EDIT_PAGE_EMBED).name:
        case (0, $3V5nR.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $3V5nR.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $3V5nR.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        previewPanels: previewPanels,
        ...passThroughProps
    };
}
function $e9b8e0d00fbd3627$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $e9b8e0d00fbd3627$var$findAndMatchRoute((0, $3V5nR.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $3V5nR.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $e9b8e0d00fbd3627$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $e9b8e0d00fbd3627$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $e9b8e0d00fbd3627$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $e9b8e0d00fbd3627$var$matchUrl(pattern, url) {
    if (!$e9b8e0d00fbd3627$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $ddbcJ.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $ddbcJ.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $e9b8e0d00fbd3627$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $8HgDC.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}
function $e9b8e0d00fbd3627$var$parseQueryParam(query, keyName) {
    for (const [key, value] of Object.entries(query)){
        if (key === keyName) return Array.isArray(value) ? value.join(',') : value;
    }
    return undefined;
}

});
parcelRegister("dtqUA", function(module, exports) {
$parcel$export(module.exports, "matchPath", () => (parcelRequire("ddbcJ")).matchPath);
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ddbcJ = parcelRequire("ddbcJ");
function $9cf2dbeb7d470256$var$_extends() {
    $9cf2dbeb7d470256$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9cf2dbeb7d470256$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $9cf2dbeb7d470256$export$3add0d5dce533e2e = /*#__PURE__*/ $eJOHy.createContext(null);
const $9cf2dbeb7d470256$export$145dfa71566a64dc = /*#__PURE__*/ $eJOHy.createContext(null);
const $9cf2dbeb7d470256$var$AwaitContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $9cf2dbeb7d470256$export$26749e8557646306 = /*#__PURE__*/ $eJOHy.createContext(null);
const $9cf2dbeb7d470256$export$c7914228fb69b0f5 = /*#__PURE__*/ $eJOHy.createContext(null);
const $9cf2dbeb7d470256$export$9072aa6dd1f93057 = /*#__PURE__*/ $eJOHy.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $9cf2dbeb7d470256$var$RouteErrorContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $9cf2dbeb7d470256$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $9cf2dbeb7d470256$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $ddbcJ.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $9cf2dbeb7d470256$export$9c954a9d03d32f4a() {
    return $eJOHy.useContext($9cf2dbeb7d470256$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $9cf2dbeb7d470256$export$45d76561a5302f2b() {
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    return $eJOHy.useContext($9cf2dbeb7d470256$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $9cf2dbeb7d470256$export$1b3f31771c5d07c() {
    return $eJOHy.useContext($9cf2dbeb7d470256$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $9cf2dbeb7d470256$export$6c330e8992e8a295(pattern) {
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { pathname: pathname } = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    return $eJOHy.useMemo(()=>(0, $ddbcJ.matchPath)(pattern, (0, $ddbcJ.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $9cf2dbeb7d470256$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9cf2dbeb7d470256$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eJOHy.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $9cf2dbeb7d470256$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9cf2dbeb7d470256$var$useNavigateStable() : $9cf2dbeb7d470256$var$useNavigateUnstable();
}
function $9cf2dbeb7d470256$var$useNavigateUnstable() {
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let dataRouterContext = $eJOHy.useContext($9cf2dbeb7d470256$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $eJOHy.useRef(false);
    $9cf2dbeb7d470256$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eJOHy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $ddbcJ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ddbcJ.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $9cf2dbeb7d470256$var$OutletContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $9cf2dbeb7d470256$export$4138103a3ae699cc() {
    return $eJOHy.useContext($9cf2dbeb7d470256$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $9cf2dbeb7d470256$export$a3be3530d8e40d0b(context) {
    let outlet = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $9cf2dbeb7d470256$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $9cf2dbeb7d470256$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eJOHy.useMemo(()=>(0, $ddbcJ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $9cf2dbeb7d470256$export$5d3fca4a98652595(routes, locationArg) {
    return $9cf2dbeb7d470256$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9cf2dbeb7d470256$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { matches: parentMatches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $ddbcJ.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $ddbcJ.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $ddbcJ.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $9cf2dbeb7d470256$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $ddbcJ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $ddbcJ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9cf2dbeb7d470256$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $ddbcJ.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9cf2dbeb7d470256$var$DefaultErrorComponent() {
    let error = $9cf2dbeb7d470256$export$ed527bf60f6e05f2();
    let message = (0, $ddbcJ.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eJOHy.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eJOHy.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $9cf2dbeb7d470256$var$defaultErrorElement = /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$DefaultErrorComponent, null);
class $9cf2dbeb7d470256$var$RenderErrorBoundary extends $eJOHy.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $9cf2dbeb7d470256$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eJOHy.useContext($9cf2dbeb7d470256$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9cf2dbeb7d470256$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $ddbcJ.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $9cf2dbeb7d470256$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9cf2dbeb7d470256$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eJOHy.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9cf2dbeb7d470256$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9cf2dbeb7d470256$var$DataRouterHook || {});
var $9cf2dbeb7d470256$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9cf2dbeb7d470256$var$DataRouterStateHook || {});
function $9cf2dbeb7d470256$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $9cf2dbeb7d470256$var$useDataRouterContext(hookName) {
    let ctx = $eJOHy.useContext($9cf2dbeb7d470256$export$3add0d5dce533e2e);
    !ctx && (0, $ddbcJ.UNSAFE_invariant)(false);
    return ctx;
}
function $9cf2dbeb7d470256$var$useDataRouterState(hookName) {
    let state = $eJOHy.useContext($9cf2dbeb7d470256$export$145dfa71566a64dc);
    !state && (0, $ddbcJ.UNSAFE_invariant)(false);
    return state;
}
function $9cf2dbeb7d470256$var$useRouteContext(hookName) {
    let route = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    !route && (0, $ddbcJ.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9cf2dbeb7d470256$var$useCurrentRouteId(hookName) {
    let route = $9cf2dbeb7d470256$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $ddbcJ.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9cf2dbeb7d470256$export$5fc8298006ad9e58() {
    return $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9cf2dbeb7d470256$export$d0fd4b7106de2769() {
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9cf2dbeb7d470256$export$600dc272ed516c15() {
    let dataRouterContext = $9cf2dbeb7d470256$var$useDataRouterContext($9cf2dbeb7d470256$var$DataRouterHook.UseRevalidator);
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseRevalidator);
    return $eJOHy.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9cf2dbeb7d470256$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseMatches);
    return $eJOHy.useMemo(()=>matches.map((m)=>(0, $ddbcJ.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9cf2dbeb7d470256$export$1448a5050d252c4d() {
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseLoaderData);
    let routeId = $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9cf2dbeb7d470256$export$fd5d37484eab868d(routeId) {
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9cf2dbeb7d470256$export$fdc00f3f26066d5e() {
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseActionData);
    let routeId = $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9cf2dbeb7d470256$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eJOHy.useContext($9cf2dbeb7d470256$var$RouteErrorContext);
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseRouteError);
    let routeId = $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9cf2dbeb7d470256$export$78a72ddb39bdd145() {
    let value = $eJOHy.useContext($9cf2dbeb7d470256$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9cf2dbeb7d470256$export$17f53340677d5831() {
    let value = $eJOHy.useContext($9cf2dbeb7d470256$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $9cf2dbeb7d470256$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9cf2dbeb7d470256$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $9cf2dbeb7d470256$var$useDataRouterContext($9cf2dbeb7d470256$var$DataRouterHook.UseBlocker);
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eJOHy.useState("");
    let blockerFunction = $eJOHy.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $9cf2dbeb7d470256$var$_extends({}, currentLocation, {
                pathname: (0, $ddbcJ.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9cf2dbeb7d470256$var$_extends({}, nextLocation, {
                pathname: (0, $ddbcJ.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eJOHy.useEffect(()=>{
        let key = String(++$9cf2dbeb7d470256$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eJOHy.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $ddbcJ.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9cf2dbeb7d470256$var$useNavigateStable() {
    let { router: router } = $9cf2dbeb7d470256$var$useDataRouterContext($9cf2dbeb7d470256$var$DataRouterHook.UseNavigateStable);
    let id = $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eJOHy.useRef(false);
    $9cf2dbeb7d470256$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eJOHy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9cf2dbeb7d470256$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $9cf2dbeb7d470256$var$alreadyWarned$1 = {};
function $9cf2dbeb7d470256$var$warningOnce(key, cond, message) {
    if (!cond && !$9cf2dbeb7d470256$var$alreadyWarned$1[key]) $9cf2dbeb7d470256$var$alreadyWarned$1[key] = true;
}
const $9cf2dbeb7d470256$var$alreadyWarned = {};
function $9cf2dbeb7d470256$var$warnOnce(key, message) {
    if (!$9cf2dbeb7d470256$var$alreadyWarned[message]) {
        $9cf2dbeb7d470256$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $9cf2dbeb7d470256$var$logDeprecation = (flag, msg, link)=>$9cf2dbeb7d470256$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $9cf2dbeb7d470256$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $9cf2dbeb7d470256$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $9cf2dbeb7d470256$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $9cf2dbeb7d470256$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $9cf2dbeb7d470256$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $9cf2dbeb7d470256$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $9cf2dbeb7d470256$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $9cf2dbeb7d470256$var$START_TRANSITION = "startTransition";
const $9cf2dbeb7d470256$var$startTransitionImpl = $eJOHy[$9cf2dbeb7d470256$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9cf2dbeb7d470256$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eJOHy.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eJOHy.useCallback((newState)=>{
        if (v7_startTransition && $9cf2dbeb7d470256$var$startTransitionImpl) $9cf2dbeb7d470256$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eJOHy.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eJOHy.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eJOHy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eJOHy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $eJOHy.useEffect(()=>$9cf2dbeb7d470256$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $9cf2dbeb7d470256$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $9cf2dbeb7d470256$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $9cf2dbeb7d470256$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eJOHy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ddbcJ.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eJOHy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eJOHy.useCallback((newState)=>{
        v7_startTransition && $9cf2dbeb7d470256$var$startTransitionImpl ? $9cf2dbeb7d470256$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eJOHy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eJOHy.useEffect(()=>$9cf2dbeb7d470256$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $9cf2dbeb7d470256$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    let navigate = $9cf2dbeb7d470256$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $ddbcJ.resolveTo)(to, (0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eJOHy.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $9cf2dbeb7d470256$export$910ae8079b2c2852(props) {
    return $9cf2dbeb7d470256$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $9cf2dbeb7d470256$export$e7b0ac011bb776c6(_props) {
    (0, $ddbcJ.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $9cf2dbeb7d470256$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $ddbcJ.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eJOHy.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $9cf2dbeb7d470256$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $ddbcJ.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eJOHy.useMemo(()=>{
        let trailingPathname = (0, $ddbcJ.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $9cf2dbeb7d470256$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $9cf2dbeb7d470256$export$5d3fca4a98652595($9cf2dbeb7d470256$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9cf2dbeb7d470256$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$ResolveAwait, null, children));
}
var $9cf2dbeb7d470256$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9cf2dbeb7d470256$var$AwaitRenderStatus || {});
const $9cf2dbeb7d470256$var$neverSettledPromise = new Promise(()=>{});
class $9cf2dbeb7d470256$var$AwaitErrorBoundary extends $eJOHy.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $9cf2dbeb7d470256$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $9cf2dbeb7d470256$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $9cf2dbeb7d470256$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $9cf2dbeb7d470256$var$AwaitRenderStatus.error : "_data" in promise ? $9cf2dbeb7d470256$var$AwaitRenderStatus.success : $9cf2dbeb7d470256$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $9cf2dbeb7d470256$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $9cf2dbeb7d470256$var$AwaitRenderStatus.error && promise._error instanceof (0, $ddbcJ.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $9cf2dbeb7d470256$var$neverSettledPromise;
        if (status === $9cf2dbeb7d470256$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $9cf2dbeb7d470256$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $9cf2dbeb7d470256$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9cf2dbeb7d470256$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $9cf2dbeb7d470256$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $9cf2dbeb7d470256$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eJOHy.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eJOHy.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eJOHy.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9cf2dbeb7d470256$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9cf2dbeb7d470256$export$e7b0ac011bb776c6) && (0, $ddbcJ.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $ddbcJ.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9cf2dbeb7d470256$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9cf2dbeb7d470256$export$daf73786167a7f72(matches) {
    return $9cf2dbeb7d470256$var$_renderMatches(matches);
}
function $9cf2dbeb7d470256$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eJOHy.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eJOHy.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eJOHy.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9cf2dbeb7d470256$export$f30f7e456d254e83(routes, opts) {
    return (0, $ddbcJ.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9cf2dbeb7d470256$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ddbcJ.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9cf2dbeb7d470256$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("ddbcJ", function(module, exports) {
$parcel$export(module.exports, "Action", () => $99e52e32e89932ac$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $99e52e32e89932ac$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $99e52e32e89932ac$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $99e52e32e89932ac$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "UNSAFE_invariant", () => $99e52e32e89932ac$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $99e52e32e89932ac$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $99e52e32e89932ac$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $99e52e32e89932ac$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $99e52e32e89932ac$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $99e52e32e89932ac$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $99e52e32e89932ac$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $99e52e32e89932ac$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $99e52e32e89932ac$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $99e52e32e89932ac$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "isRouteErrorResponse", () => $99e52e32e89932ac$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $99e52e32e89932ac$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $99e52e32e89932ac$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $99e52e32e89932ac$var$_extends() {
    $99e52e32e89932ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $99e52e32e89932ac$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $99e52e32e89932ac$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($99e52e32e89932ac$export$e19cd5f9376f8cee || ($99e52e32e89932ac$export$e19cd5f9376f8cee = {}));
const $99e52e32e89932ac$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $99e52e32e89932ac$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $99e52e32e89932ac$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $99e52e32e89932ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $99e52e32e89932ac$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $99e52e32e89932ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
    }
    return $99e52e32e89932ac$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $99e52e32e89932ac$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $99e52e32e89932ac$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $99e52e32e89932ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $99e52e32e89932ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $99e52e32e89932ac$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $99e52e32e89932ac$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $99e52e32e89932ac$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $99e52e32e89932ac$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $99e52e32e89932ac$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $99e52e32e89932ac$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $99e52e32e89932ac$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $99e52e32e89932ac$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $99e52e32e89932ac$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $99e52e32e89932ac$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $99e52e32e89932ac$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($99e52e32e89932ac$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        let location = $99e52e32e89932ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $99e52e32e89932ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        let location = $99e52e32e89932ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $99e52e32e89932ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $99e52e32e89932ac$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($99e52e32e89932ac$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($99e52e32e89932ac$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $99e52e32e89932ac$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($99e52e32e89932ac$var$ResultType || ($99e52e32e89932ac$var$ResultType = {}));
const $99e52e32e89932ac$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $99e52e32e89932ac$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $99e52e32e89932ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $99e52e32e89932ac$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $99e52e32e89932ac$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($99e52e32e89932ac$var$isIndexRoute(route)) {
            let indexRoute = $99e52e32e89932ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $99e52e32e89932ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $99e52e32e89932ac$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $99e52e32e89932ac$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $99e52e32e89932ac$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $99e52e32e89932ac$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $99e52e32e89932ac$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $99e52e32e89932ac$var$flattenRoutes(routes);
    $99e52e32e89932ac$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $99e52e32e89932ac$export$30d21fd6d7295f52(pathname);
        matches = $99e52e32e89932ac$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $99e52e32e89932ac$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $99e52e32e89932ac$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $99e52e32e89932ac$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $99e52e32e89932ac$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $99e52e32e89932ac$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $99e52e32e89932ac$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $99e52e32e89932ac$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $99e52e32e89932ac$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $99e52e32e89932ac$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $99e52e32e89932ac$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $99e52e32e89932ac$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $99e52e32e89932ac$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $99e52e32e89932ac$var$paramRe = /^:[\w-]+$/;
const $99e52e32e89932ac$var$dynamicSegmentValue = 3;
const $99e52e32e89932ac$var$indexRouteValue = 2;
const $99e52e32e89932ac$var$emptySegmentValue = 1;
const $99e52e32e89932ac$var$staticSegmentValue = 10;
const $99e52e32e89932ac$var$splatPenalty = -2;
const $99e52e32e89932ac$var$isSplat = (s)=>s === "*";
function $99e52e32e89932ac$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($99e52e32e89932ac$var$isSplat)) initialScore += $99e52e32e89932ac$var$splatPenalty;
    if (index) initialScore += $99e52e32e89932ac$var$indexRouteValue;
    return segments.filter((s)=>!$99e52e32e89932ac$var$isSplat(s)).reduce((score, segment)=>score + ($99e52e32e89932ac$var$paramRe.test(segment) ? $99e52e32e89932ac$var$dynamicSegmentValue : segment === "" ? $99e52e32e89932ac$var$emptySegmentValue : $99e52e32e89932ac$var$staticSegmentValue), initialScore);
}
function $99e52e32e89932ac$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $99e52e32e89932ac$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $99e52e32e89932ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $99e52e32e89932ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $99e52e32e89932ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $99e52e32e89932ac$export$a5c6d149b50c1d86($99e52e32e89932ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $99e52e32e89932ac$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $99e52e32e89932ac$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $99e52e32e89932ac$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $99e52e32e89932ac$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $99e52e32e89932ac$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $99e52e32e89932ac$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $99e52e32e89932ac$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $99e52e32e89932ac$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $99e52e32e89932ac$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $99e52e32e89932ac$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $99e52e32e89932ac$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $99e52e32e89932ac$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $99e52e32e89932ac$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $99e52e32e89932ac$var$normalizeSearch(search),
        hash: $99e52e32e89932ac$var$normalizeHash(hash)
    };
}
function $99e52e32e89932ac$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $99e52e32e89932ac$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $99e52e32e89932ac$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $99e52e32e89932ac$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $99e52e32e89932ac$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $99e52e32e89932ac$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $99e52e32e89932ac$export$8ccf933b0513f8d0(toArg);
    else {
        to = $99e52e32e89932ac$var$_extends({}, toArg);
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $99e52e32e89932ac$var$getInvalidPathError("?", "pathname", "search", to));
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $99e52e32e89932ac$var$getInvalidPathError("#", "pathname", "hash", to));
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $99e52e32e89932ac$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $99e52e32e89932ac$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $99e52e32e89932ac$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $99e52e32e89932ac$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $99e52e32e89932ac$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $99e52e32e89932ac$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $99e52e32e89932ac$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $99e52e32e89932ac$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $99e52e32e89932ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $99e52e32e89932ac$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $99e52e32e89932ac$export$4051a07651545597(data, init) {
    return new $99e52e32e89932ac$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $99e52e32e89932ac$export$42a99a7a4bc0e76a extends Error {
}
class $99e52e32e89932ac$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $99e52e32e89932ac$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $99e52e32e89932ac$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $99e52e32e89932ac$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $99e52e32e89932ac$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $99e52e32e89932ac$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $99e52e32e89932ac$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $99e52e32e89932ac$var$unwrapTrackedPromise(value) {
    if (!$99e52e32e89932ac$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $99e52e32e89932ac$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $99e52e32e89932ac$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $99e52e32e89932ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $99e52e32e89932ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $99e52e32e89932ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $99e52e32e89932ac$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $99e52e32e89932ac$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $99e52e32e89932ac$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $99e52e32e89932ac$var$validMutationMethods = new Set($99e52e32e89932ac$var$validMutationMethodsArr);
const $99e52e32e89932ac$var$validRequestMethodsArr = [
    "get",
    ...$99e52e32e89932ac$var$validMutationMethodsArr
];
const $99e52e32e89932ac$var$validRequestMethods = new Set($99e52e32e89932ac$var$validRequestMethodsArr);
const $99e52e32e89932ac$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $99e52e32e89932ac$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $99e52e32e89932ac$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $99e52e32e89932ac$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $99e52e32e89932ac$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $99e52e32e89932ac$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $99e52e32e89932ac$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $99e52e32e89932ac$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $99e52e32e89932ac$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $99e52e32e89932ac$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $99e52e32e89932ac$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $99e52e32e89932ac$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$99e52e32e89932ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$99e52e32e89932ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $99e52e32e89932ac$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $99e52e32e89932ac$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $99e52e32e89932ac$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $99e52e32e89932ac$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$99e52e32e89932ac$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($99e52e32e89932ac$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $99e52e32e89932ac$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $99e52e32e89932ac$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $99e52e32e89932ac$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $99e52e32e89932ac$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $99e52e32e89932ac$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($99e52e32e89932ac$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $99e52e32e89932ac$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $99e52e32e89932ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $99e52e32e89932ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $99e52e32e89932ac$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $99e52e32e89932ac$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $99e52e32e89932ac$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $99e52e32e89932ac$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $99e52e32e89932ac$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $99e52e32e89932ac$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $99e52e32e89932ac$var$findNearestBoundary(matches).route.id,
            {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $99e52e32e89932ac$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($99e52e32e89932ac$var$isErrorResult(result) && $99e52e32e89932ac$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $99e52e32e89932ac$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $99e52e32e89932ac$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $99e52e32e89932ac$var$_extends({
            matches: updatedMatches || matches
        }, $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $99e52e32e89932ac$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $99e52e32e89932ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $99e52e32e89932ac$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $99e52e32e89932ac$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $99e52e32e89932ac$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($99e52e32e89932ac$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $99e52e32e89932ac$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($99e52e32e89932ac$var$isDeferredResult(result)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $99e52e32e89932ac$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $99e52e32e89932ac$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($99e52e32e89932ac$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $99e52e32e89932ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $99e52e32e89932ac$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $99e52e32e89932ac$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $99e52e32e89932ac$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $99e52e32e89932ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $99e52e32e89932ac$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $99e52e32e89932ac$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$99e52e32e89932ac$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $99e52e32e89932ac$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $99e52e32e89932ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $99e52e32e89932ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $99e52e32e89932ac$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $99e52e32e89932ac$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $99e52e32e89932ac$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($99e52e32e89932ac$var$isRedirectResult(actionResult) || $99e52e32e89932ac$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($99e52e32e89932ac$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $99e52e32e89932ac$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($99e52e32e89932ac$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($99e52e32e89932ac$var$isDeferredResult(actionResult)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $99e52e32e89932ac$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $99e52e32e89932ac$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $99e52e32e89932ac$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $99e52e32e89932ac$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $99e52e32e89932ac$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $99e52e32e89932ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $99e52e32e89932ac$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $99e52e32e89932ac$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $99e52e32e89932ac$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $99e52e32e89932ac$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($99e52e32e89932ac$var$isDeferredResult(result)) result = await $99e52e32e89932ac$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($99e52e32e89932ac$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $99e52e32e89932ac$export$3e9cee6b33872309(!$99e52e32e89932ac$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $99e52e32e89932ac$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $99e52e32e89932ac$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $99e52e32e89932ac$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $99e52e32e89932ac$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace : $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $99e52e32e89932ac$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($99e52e32e89932ac$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $99e52e32e89932ac$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $99e52e32e89932ac$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $99e52e32e89932ac$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $99e52e32e89932ac$var$ResultType.redirect,
                response: $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $99e52e32e89932ac$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: $99e52e32e89932ac$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $99e52e32e89932ac$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $99e52e32e89932ac$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $99e52e32e89932ac$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $99e52e32e89932ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $99e52e32e89932ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $99e52e32e89932ac$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $99e52e32e89932ac$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $99e52e32e89932ac$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $99e52e32e89932ac$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $99e52e32e89932ac$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$99e52e32e89932ac$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $99e52e32e89932ac$export$4d0306f8f6a4585b = Symbol("deferred");
function $99e52e32e89932ac$export$3336b097a6fbc59a(routes, opts) {
    $99e52e32e89932ac$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $99e52e32e89932ac$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $99e52e32e89932ac$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $99e52e32e89932ac$var$createLocation("", $99e52e32e89932ac$export$fe53371bee54353d(url), null, "default");
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$99e52e32e89932ac$var$isValidMethod(method) && method !== "HEAD") {
            let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($99e52e32e89932ac$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $99e52e32e89932ac$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $99e52e32e89932ac$var$createLocation("", $99e52e32e89932ac$export$fe53371bee54353d(url), null, "default");
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$99e52e32e89932ac$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $99e52e32e89932ac$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $99e52e32e89932ac$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $99e52e32e89932ac$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($99e52e32e89932ac$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$99e52e32e89932ac$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $99e52e32e89932ac$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($99e52e32e89932ac$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $99e52e32e89932ac$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $99e52e32e89932ac$var$isResponse(result) ? result : $99e52e32e89932ac$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($99e52e32e89932ac$var$isDataStrategyResult(e) && $99e52e32e89932ac$var$isResponse(e.result)) {
                if (e.type === $99e52e32e89932ac$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($99e52e32e89932ac$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($99e52e32e89932ac$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($99e52e32e89932ac$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $99e52e32e89932ac$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $99e52e32e89932ac$var$_extends({}, context, {
                statusCode: $99e52e32e89932ac$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $99e52e32e89932ac$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $99e52e32e89932ac$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $99e52e32e89932ac$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategy || $99e52e32e89932ac$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($99e52e32e89932ac$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $99e52e32e89932ac$export$fec11da027c70692(routes, context, error) {
    let newContext = $99e52e32e89932ac$var$_extends({}, context, {
        statusCode: $99e52e32e89932ac$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $99e52e32e89932ac$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $99e52e32e89932ac$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $99e52e32e89932ac$export$cae722b0cc860f13(to ? to : ".", $99e52e32e89932ac$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $99e52e32e89932ac$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $99e52e32e89932ac$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $99e52e32e89932ac$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $99e52e32e89932ac$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $99e52e32e89932ac$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$99e52e32e89932ac$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$99e52e32e89932ac$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $99e52e32e89932ac$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $99e52e32e89932ac$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $99e52e32e89932ac$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$99e52e32e89932ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$99e52e32e89932ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $99e52e32e89932ac$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $99e52e32e89932ac$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $99e52e32e89932ac$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $99e52e32e89932ac$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $99e52e32e89932ac$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $99e52e32e89932ac$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $99e52e32e89932ac$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $99e52e32e89932ac$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($99e52e32e89932ac$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $99e52e32e89932ac$var$shouldRevalidateLoader(match, $99e52e32e89932ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $99e52e32e89932ac$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $99e52e32e89932ac$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $99e52e32e89932ac$var$shouldRevalidateLoader(fetcherMatch, $99e52e32e89932ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $99e52e32e89932ac$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $99e52e32e89932ac$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $99e52e32e89932ac$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $99e52e32e89932ac$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $99e52e32e89932ac$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$99e52e32e89932ac$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $99e52e32e89932ac$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$99e52e32e89932ac$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $99e52e32e89932ac$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $99e52e32e89932ac$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $99e52e32e89932ac$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$99e52e32e89932ac$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $99e52e32e89932ac$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $99e52e32e89932ac$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $99e52e32e89932ac$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $99e52e32e89932ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $99e52e32e89932ac$var$ResultType.data,
                result: undefined
            });
        };
        return $99e52e32e89932ac$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $99e52e32e89932ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $99e52e32e89932ac$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $99e52e32e89932ac$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $99e52e32e89932ac$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($99e52e32e89932ac$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: e
            };
        }
        if (type === $99e52e32e89932ac$var$ResultType.error) return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: new $99e52e32e89932ac$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $99e52e32e89932ac$var$ResultType.error) {
        if ($99e52e32e89932ac$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $99e52e32e89932ac$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: result,
            statusCode: $99e52e32e89932ac$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($99e52e32e89932ac$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $99e52e32e89932ac$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($99e52e32e89932ac$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $99e52e32e89932ac$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $99e52e32e89932ac$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $99e52e32e89932ac$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $99e52e32e89932ac$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $99e52e32e89932ac$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $99e52e32e89932ac$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($99e52e32e89932ac$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $99e52e32e89932ac$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $99e52e32e89932ac$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $99e52e32e89932ac$export$3e9cee6b33872309(!$99e52e32e89932ac$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $99e52e32e89932ac$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $99e52e32e89932ac$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $99e52e32e89932ac$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($99e52e32e89932ac$var$isErrorResult(result)) {
            let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $99e52e32e89932ac$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($99e52e32e89932ac$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $99e52e32e89932ac$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($99e52e32e89932ac$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $99e52e32e89932ac$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $99e52e32e89932ac$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $99e52e32e89932ac$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $99e52e32e89932ac$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $99e52e32e89932ac$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $99e52e32e89932ac$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $99e52e32e89932ac$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $99e52e32e89932ac$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($99e52e32e89932ac$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $99e52e32e89932ac$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(path) : path;
    return $99e52e32e89932ac$export$fe53371bee54353d($99e52e32e89932ac$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $99e52e32e89932ac$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $99e52e32e89932ac$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $99e52e32e89932ac$var$ResultType.data || result.type === $99e52e32e89932ac$var$ResultType.error);
}
function $99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result) {
    return $99e52e32e89932ac$var$isResponse(result.result) && $99e52e32e89932ac$var$redirectStatusCodes.has(result.result.status);
}
function $99e52e32e89932ac$var$isDeferredResult(result) {
    return result.type === $99e52e32e89932ac$var$ResultType.deferred;
}
function $99e52e32e89932ac$var$isErrorResult(result) {
    return result.type === $99e52e32e89932ac$var$ResultType.error;
}
function $99e52e32e89932ac$var$isRedirectResult(result) {
    return (result && result.type) === $99e52e32e89932ac$var$ResultType.redirect;
}
function $99e52e32e89932ac$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $99e52e32e89932ac$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $99e52e32e89932ac$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $99e52e32e89932ac$var$isRedirectResponse(result) {
    if (!$99e52e32e89932ac$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $99e52e32e89932ac$var$isValidMethod(method) {
    return $99e52e32e89932ac$var$validRequestMethods.has(method.toLowerCase());
}
function $99e52e32e89932ac$var$isMutationMethod(method) {
    return $99e52e32e89932ac$var$validMutationMethods.has(method.toLowerCase());
}
async function $99e52e32e89932ac$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$99e52e32e89932ac$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($99e52e32e89932ac$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $99e52e32e89932ac$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $99e52e32e89932ac$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $99e52e32e89932ac$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $99e52e32e89932ac$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $99e52e32e89932ac$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $99e52e32e89932ac$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $99e52e32e89932ac$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $99e52e32e89932ac$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $99e52e32e89932ac$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $99e52e32e89932ac$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $99e52e32e89932ac$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $99e52e32e89932ac$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $99e52e32e89932ac$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $99e52e32e89932ac$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $99e52e32e89932ac$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $99e52e32e89932ac$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $99e52e32e89932ac$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $99e52e32e89932ac$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $99e52e32e89932ac$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("8HgDC", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $d50d7663dcde671e$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $d50d7663dcde671e$export$3207c60940c4a9b0);

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");
var $d50d7663dcde671e$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $d50d7663dcde671e$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments',
        'disable-publish-close-buttons',
        'loom-external-open'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $d50d7663dcde671e$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $d50d7663dcde671e$var$pageAllowedFeatures = {
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.edit,
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.view
};
const $d50d7663dcde671e$var$blogPostAllowedFeatures = {
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.edit,
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.view
};
const $d50d7663dcde671e$var$whiteboardAllowedFeatures = {
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.whiteboard
};
const $d50d7663dcde671e$var$contentTypeAllowedFeatures = {
    [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $d50d7663dcde671e$var$pageAllowedFeatures,
    [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $d50d7663dcde671e$var$blogPostAllowedFeatures,
    [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $d50d7663dcde671e$var$whiteboardAllowedFeatures
};
const $d50d7663dcde671e$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$d50d7663dcde671e$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("fzBRQ", function(module, exports) {
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $35899afc70d2fea8$export$942a5fac9b8c9dc2);
var $35899afc70d2fea8$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});


parcelRegister("3V5nR", function(module, exports) {
$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $38df13a66e61ed85$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $38df13a66e61ed85$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $38df13a66e61ed85$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $38df13a66e61ed85$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $38df13a66e61ed85$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "WHITEBOARD", () => $38df13a66e61ed85$export$fbefbcc1445e8d74);
$parcel$export(module.exports, "namedRoutes", () => $38df13a66e61ed85$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $38df13a66e61ed85$export$5c59aa0922e65f1a);
const $38df13a66e61ed85$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $38df13a66e61ed85$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $38df13a66e61ed85$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $38df13a66e61ed85$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $38df13a66e61ed85$export$65b723bb995d4fb6,
    VIEW_PAGE: $38df13a66e61ed85$export$9257b5b55c8e2555,
    VIEW_BLOG: $38df13a66e61ed85$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $38df13a66e61ed85$export$bd2c9bb170b3681d,
    WHITEBOARD: $38df13a66e61ed85$export$fbefbcc1445e8d74
};
const $38df13a66e61ed85$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("ajyyy", function(module, exports) {
$parcel$export(module.exports, "ConfluenceContentTypes", () => $7b8095db702ea031$export$b39616d00ee96d40);
$parcel$export(module.exports, "DisplayTypes", () => $7b8095db702ea031$export$c294d3f3727c1a0);
const $7b8095db702ea031$export$b39616d00ee96d40 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};
const $7b8095db702ea031$export$c294d3f3727c1a0 = {
    MODAL: 'modal',
    PANEL: 'panel'
};

});


parcelRegister("lYAmh", function(module, exports) {
$parcel$export(module.exports, "getDisplayInformation", () => $123b26f4f0abb32c$export$ee79869f97207574);
$parcel$export(module.exports, "convertUrlByContentState", () => $123b26f4f0abb32c$export$d41c9cdfa202e9a7);

var $6DF4T = parcelRequire("6DF4T");

var $ajyyy = parcelRequire("ajyyy");
const $123b26f4f0abb32c$export$37e31995727dc8d7 = 0.5;
const $123b26f4f0abb32c$export$ee79869f97207574 = ()=>{
    /*
	We set the screen width to 50% of the screen width if the screen
	width is larger than 1024px because we want the Embedded Confluence in the side panel to
	take up half the screen width. The max of the side panel is 50% of the screen width and
	we are not able to set it wider. Jira Issue details panel will be forced down around 1875px
	screen width.
	If the screen width is less than 1024px, we'll set the panel width to 0 because we will be
	opening the EmbeddedContentModal instead and set displayType to Modal.
	This also assumes that we are currently on the full page version of a Jira Issue.
	*/ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) return {
        initialWidth: screenWidth * $123b26f4f0abb32c$export$37e31995727dc8d7,
        displayType: (0, $ajyyy.DisplayTypes).PANEL
    };
    return {
        initialWidth: 0,
        displayType: (0, $ajyyy.DisplayTypes).MODAL
    };
};
const $123b26f4f0abb32c$export$d41c9cdfa202e9a7 = ({ mode: mode, isDraft: isDraft, contentUrl: contentUrl, spaceKey: spaceKey })=>{
    // update spaceKey
    let newUrl = contentUrl.replace(/\/spaces\/.*?\/pages\//, `/spaces/${spaceKey}/pages/`);
    if (!isDraft) {
        // remove `draftShareId={id}` and the preceding `&` if it exists
        newUrl = newUrl.replace(/[&]*draftShareId=[^&]*/, '');
        if (mode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) {
            if (!newUrl.includes('edit-embed')) newUrl = newUrl.replace('/pages/', '/pages/edit-embed/');
        } else if (mode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) // Replaces /pages/edit-v2/ or /pages/edit-embed/ with /pages/
        newUrl = newUrl.replace(/\/pages\/edit[^/]*\//, '/pages/');
    }
    return newUrl;
};

});


parcelRegister("80rW8", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedPanelEntryPoint", () => $8712743e7c4b6c83$export$75ef2f025ecbf1de);

var $eJOHy = parcelRequire("eJOHy");

var $58yRG = parcelRequire("58yRG");

var $6DF4T = parcelRequire("6DF4T");
var $9fAcm = parcelRequire("9fAcm");

var $vztq1 = parcelRequire("vztq1");

var $lYAmh = parcelRequire("lYAmh");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $lRq8t = parcelRequire("lRq8t");

var $iIbix = parcelRequire("iIbix");

var $4NvcV = parcelRequire("4NvcV");

var $2khbo = parcelRequire("2khbo");

var $7UlSU = parcelRequire("7UlSU");

var $cBx21 = parcelRequire("cBx21");

var $fBOqJ = parcelRequire("fBOqJ");

var $1u0iy = parcelRequire("1u0iy");

var $1VTE7 = parcelRequire("1VTE7");

var $iiTqV = parcelRequire("iiTqV");
const $8712743e7c4b6c83$var$entryPointParams = {};
const $8712743e7c4b6c83$export$12346a674644c156 = 'operational';
const $8712743e7c4b6c83$export$b81d6f4511cb89a5 = (action, eventName, params)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, setConfluenceData: setConfluenceData, contentUrl: contentUrl, embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel, isOpen: isOpen, mode: mode } = params;
    fireAnalyticsEvent({
        action: action,
        eventName: eventName,
        embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
        eventType: $8712743e7c4b6c83$export$12346a674644c156
    });
    if (isOpen) {
        if (eventName === 'edit-page/close') setConfluenceData({
            contentUrl: contentUrl,
            mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
        });
        if (eventName === 'edit-page/load' && action === 'taskSuccess') {
            if (mode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) setConfluenceData({
                contentUrl: contentUrl,
                mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
            });
        }
        if (eventName === 'edit-page/publish' && action === 'taskSuccess') {
            if (mode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) setConfluenceData({
                isDraft: false,
                contentUrl: contentUrl,
                mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
        }
    }
};
const $8712743e7c4b6c83$export$75ef2f025ecbf1de = ()=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const [state, actions] = (0, $vztq1.useEmbeddedConfluenceSidePanel)();
    const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen, isExpanded: isExpanded }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
    const isPageDraft = isDraft && contentType === (0, $4NvcV.CONTENT_TYPE).PAGE;
    const parentProduct = (0, $1VTE7.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $7UlSU.embeddedPanelEntrypoint), $8712743e7c4b6c83$var$entryPointParams);
    const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
    const fireAnalyticsEvent = (0, $1u0iy.useEmbeddedPageTracking)();
    const themeState = (0, $58yRG.default)();
    /*
  	If the user is on a custom domain, we need to update the
  	hostname to reflect the parentProduct's hostname. By providing the hostname
  	prop we will force EP to use the parentProduct's hostname instead of the content's hostname
  	when on a custom domain (see EP code here https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/confluence/embedded-confluence-common/src/page/parsePageProps.ts#75).
  */ const contentHostname = (0, $cBx21.setHostnameForContent)(contentUrl, hostname);
    const onContentAction = (0, $eJOHy.useCallback)((action, eventName)=>{
        $8712743e7c4b6c83$export$b81d6f4511cb89a5(action, eventName, {
            fireAnalyticsEvent: fireAnalyticsEvent,
            setConfluenceData: actions.setConfluenceData,
            contentUrl: contentUrl,
            embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel,
            isOpen: isOpen,
            mode: mode
        });
    }, [
        actions,
        contentUrl,
        fireAnalyticsEvent,
        embeddedConfluenceSourceForPanel,
        isOpen,
        mode
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeEmbeddedConfluencePanel',
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
        entryPointActions.unload();
        actions.closeSidePanel();
    }, [
        actions,
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSourceForPanel
    ]);
    const editAllowedFeatures = (0, $eJOHy.useMemo)(()=>[
            ...isDeferSpaceSelection ? [
                'publish-modal'
            ] : [],
            'template-browser'
        ], [
        isDeferSpaceSelection
    ]);
    const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
    const shouldOpenPanel = isOpen && contentUrl;
    const { entryPointActions: epDraftModalActions, entryPointReferenceSubject: epDraftModalSubject } = (0, $iWvkh.useEntryPoint)((0, $2khbo.draftEmbeddedPageModalEntrypoint), {});
    const { entryPointActions: epModalActions, entryPointReferenceSubject: epModalSubject } = (0, $iWvkh.useEntryPoint)((0, $iIbix.embeddedConfluencePageModalEntrypoint), {});
    const { entryPointActions: whiteboardModalActions, entryPointReferenceSubject: whiteboardModalSubject } = (0, $iWvkh.useEntryPoint)((0, $iiTqV.embeddedWhiteboardModalEntrypoint), {});
    const { openContinueDraftModal: openContinueDraftModal, handleEmbeddedContentAction: handleDraftContentAction, epMode: epMode } = (0, $fBOqJ.useEmbeddedPageDraft)({
        url: contentUrl,
        isLive: isLive,
        embeddedConfluenceSource: embeddedConfluenceSource,
        onEmbeddedContentAction: onContentAction,
        onClose: onClose,
        linkConfluencePage: onLinkPage
    });
    const handleOnModalClose = (0, $eJOHy.useCallback)(()=>{
        actions.closeSidePanel();
        if (contentType === 'whiteboard') whiteboardModalActions.unload();
        else if (contentType === 'page') isPageDraft ? epDraftModalActions.unload() : epModalActions.unload();
    }, [
        actions,
        isPageDraft,
        epDraftModalActions,
        epModalActions,
        whiteboardModalActions,
        contentType
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isLive: isLive,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            onClose: onClose,
            onContentAction: onContentAction,
            parentProduct: parentProduct,
            spaceKey: (0, $9fAcm.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: (0, $lYAmh.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $9fAcm.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId,
            contentType: contentType,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage
        }), [
        actions.setDeferredSpaceData,
        contentId,
        contentUrl,
        editAllowedFeatures,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        isDraft,
        isLive,
        locale,
        title,
        mode,
        epMode,
        onClose,
        onContentAction,
        onLinkPage,
        parentProduct,
        themeState,
        shouldApplyEditFeatures,
        isPageDraft,
        contentType
    ]);
    const whiteboardModalRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            isOpen: true,
            locale: locale,
            hasFooterLogo: false,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            enableContract: true,
            onClose: onClose,
            onEmbeddedContentAction: onContentAction,
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            spaceKey: (0, $9fAcm.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: contentUrl,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId || (0, $9fAcm.parseUrl)(contentUrl)?.contentId || '',
            contentType: contentType
        }), [
        contentId,
        contentType,
        contentUrl,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        locale,
        title,
        onClose,
        onContentAction,
        parentProduct,
        themeState,
        actions.toggleExpandedState
    ]);
    const epModalRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isOpen: true,
            enableContract: true,
            onClose: ()=>{
                isPageDraft ? openContinueDraftModal() : handleOnModalClose();
            },
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            url: (0, $lYAmh.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $9fAcm.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            isLive: isLive,
            embeddedConfluenceSource: embeddedConfluenceSource,
            spaceKey: (0, $9fAcm.parseUrl)(contentUrl)?.spaceKey,
            contentId: (0, $9fAcm.parseUrl)(contentUrl)?.contentId,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage,
            themeState: themeState,
            onPageAction: isPageDraft ? handleDraftContentAction : onContentAction,
            navigationPolicy: undefined,
            hostname: contentHostname,
            isFullScreenEmbedView: true
        }), [
        locale,
        isDraft,
        actions.toggleExpandedState,
        actions.setDeferredSpaceData,
        parentProduct,
        isPageDraft,
        mode,
        epMode,
        contentUrl,
        isLive,
        embeddedConfluenceSource,
        themeState,
        handleDraftContentAction,
        onContentAction,
        contentHostname,
        openContinueDraftModal,
        handleOnModalClose,
        onLinkPage,
        editAllowedFeatures,
        shouldApplyEditFeatures
    ]);
    const setEntrypointActions = ()=>{
        if (!isExpanded) return entryPointActions;
        if (contentType === 'whiteboard') return whiteboardModalActions;
        if (contentType === 'page') return isDraft ? epDraftModalActions : epModalActions;
    };
    const setExpandedEntryPointData = ()=>{
        if (contentType === 'page') {
            if (isDraft) return {
                id: 'epDraftModalEntrypointContainer',
                entryPointReferenceSubject: epDraftModalSubject,
                runtimeProps: epModalRuntimeProps
            };
            return {
                id: 'epModalEntrypointContainer',
                entryPointReferenceSubject: epModalSubject,
                runtimeProps: epModalRuntimeProps
            };
        }
        if (contentType === 'whiteboard') return {
            id: 'embeddedWhiteboardModalEntrypointContainer',
            entryPointReferenceSubject: whiteboardModalSubject,
            runtimeProps: whiteboardModalRuntimeProps
        };
    };
    const entryPointData = setExpandedEntryPointData();
    const expandedEntryPointContainer = ()=>{
        if (contentType === 'page') {
            if (isDraft) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: epDraftModalSubject,
                id: "epDraftModalEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: epModalRuntimeProps
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: epModalSubject,
                id: "epModalEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: epModalRuntimeProps
            });
        }
        if (contentType === 'whiteboard') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: whiteboardModalSubject,
            id: "embeddedWhiteboardModalEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: whiteboardModalRuntimeProps
        });
        return null;
    };
    return shouldOpenPanel && entryPointData ? {
        entryPointActions: setEntrypointActions(),
        entryPoint: isExpanded ? expandedEntryPointContainer() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epPanelEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        ref: undefined,
        entryPoint: null
    };
};

});
parcelRegister("iIbix", function(module, exports) {
$parcel$export(module.exports, "embeddedConfluencePageModalEntrypoint", () => $b5642349ee0495da$export$2798102ac94287d0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b5642349ee0495da$export$2798102ac94287d0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bICoC")), {
        moduleId: "73170883",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bICoC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cFLtL").then(()=>parcelRequire('avGlQ'));

});


parcelRegister("4NvcV", function(module, exports) {
$parcel$export(module.exports, "LINK_CREATE_DRAFT_STATUS", () => $8de3213391b5815c$export$b86d51ea0323efca);
$parcel$export(module.exports, "CONTENT_TYPE", () => $8de3213391b5815c$export$a982aaff75f1c348);
$parcel$export(module.exports, "CONTENT_TYPE_TO_ENTITY_KEYS", () => $8de3213391b5815c$export$de75e0e058bd457c);

var $hpqCn = parcelRequire("hpqCn");
const $8de3213391b5815c$export$b86d51ea0323efca = 'draft';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $8de3213391b5815c$var$LINK_CREATE_PUBLISH_STATUS = 'current';
const $8de3213391b5815c$export$a982aaff75f1c348 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $8de3213391b5815c$export$de75e0e058bd457c = {
    [$8de3213391b5815c$export$a982aaff75f1c348.PAGE]: (0, $hpqCn.entityKeys).confluencePage,
    [$8de3213391b5815c$export$a982aaff75f1c348.WHITEBOARD]: (0, $hpqCn.entityKeys).confluenceWhiteboard
};

});
parcelRegister("hpqCn", function(module, exports) {
$parcel$export(module.exports, "entityKeys", () => $04c2fecf53cd4bac$export$be0551febfd6121e);
$parcel$export(module.exports, "ContentTypes", () => $04c2fecf53cd4bac$export$b9e669a853ca2f38);
$parcel$export(module.exports, "Fields", () => $04c2fecf53cd4bac$export$833b3e5a19fb8939);
$parcel$export(module.exports, "testIds", () => $04c2fecf53cd4bac$export$800daf5fbbe96aff);
$parcel$export(module.exports, "CONFLUENCE_EVENT_NAME", () => $04c2fecf53cd4bac$export$c312550dc4e28902);
const $04c2fecf53cd4bac$export$be0551febfd6121e = {
    confluencePage: 'confluence-page',
    confluenceWhiteboard: 'confluence-whiteboard'
};
const $04c2fecf53cd4bac$export$b9e669a853ca2f38 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
var $04c2fecf53cd4bac$export$833b3e5a19fb8939 = /*#__PURE__*/ function(Fields) {
    Fields["Title"] = "title";
    Fields["Site"] = "site";
    Fields["SpacePage"] = "space_or_page";
    return Fields;
}({});
const $04c2fecf53cd4bac$export$800daf5fbbe96aff = {
    form: 'link-create-confluence-form',
    title: 'link-create-confluence-title',
    site: 'link-create-confluence-site-picker',
    space: 'link-create-confluence-space-picker',
    error: 'link-create-confluence-form-error'
};
const $04c2fecf53cd4bac$export$c312550dc4e28902 = {
    EDIT_PAGE: 'edit-page',
    EDIT_PAGE_LOAD: 'edit-page/load',
    EDIT_PAGE_PUBLISH: 'edit-page/publish',
    EDIT_PAGE_CLOSE: 'edit-page/close'
};

});


parcelRegister("2khbo", function(module, exports) {
$parcel$export(module.exports, "draftEmbeddedPageModalEntrypoint", () => $064c0a03614f0cdf$export$11fd8fc5a8657f8);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $064c0a03614f0cdf$export$11fd8fc5a8657f8 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jWpKn")), {
        moduleId: "a0941f4e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jWpKn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k22Fv").then(()=>parcelRequire('ay6y4'));

});


parcelRegister("7UlSU", function(module, exports) {
$parcel$export(module.exports, "embeddedPanelEntrypoint", () => $dd9a0baadba26f74$export$32561f984de7bece);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $dd9a0baadba26f74$export$32561f984de7bece = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("e4fzb")), {
        moduleId: "293c24d0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("e4fzb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("40LPU").then(()=>parcelRequire('2SBvi'));

});


parcelRegister("cBx21", function(module, exports) {
$parcel$export(module.exports, "createActivePageUrl", () => $cb0bb56c18e3edd5$export$83c6318baef117fe);
$parcel$export(module.exports, "getURLFromConfluencePageResponse", () => $cb0bb56c18e3edd5$export$e87b28852220b5cd);
$parcel$export(module.exports, "setHostnameForContent", () => $cb0bb56c18e3edd5$export$8ccd4cc378896990);
$parcel$export(module.exports, "constructUrlIfCustomDomain", () => $cb0bb56c18e3edd5$export$a63ef4c6a1286e2a);
$parcel$export(module.exports, "createLinkCreatePayload", () => $cb0bb56c18e3edd5$export$af98278c506da0f4);

var $gRw8I = parcelRequire("gRw8I");

var $2Z8x4 = parcelRequire("2Z8x4");

var $jaAj7 = parcelRequire("jaAj7");
const $cb0bb56c18e3edd5$export$f31b9480a5e4fdcf = (uri)=>{
    if (!uri || uri === '') return '';
    const matches = uri.match(/draftShareId=([^&])*/g);
    return matches ? matches[0].split('=')[1] : '';
};
const $cb0bb56c18e3edd5$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
    if (!(url && spaceId && spaceKey)) return '';
    return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};
const $cb0bb56c18e3edd5$export$83c6318baef117fe = (createPayload)=>{
    const { data: data, url: url } = createPayload;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const links = data?.links;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceKey = data?.spaceKey;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceId = data?.spaceId;
    const linkableUrl = $cb0bb56c18e3edd5$export$be3b1ed3560ef0e6({
        url: url,
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    if (data?.subType === 'live') return `${linkableUrl}`;
    return `${linkableUrl}?draftShareId=${$cb0bb56c18e3edd5$export$f31b9480a5e4fdcf(links?.editui)}`;
};
const $cb0bb56c18e3edd5$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
const $cb0bb56c18e3edd5$var$isUrlCustomDomain = (parentHost, url)=>{
    const hostname = (0, $2Z8x4.getHostnameFromUrl)(url);
    return (0, $jaAj7.isCustomDomain)(parentHost) || hostname && (0, $jaAj7.isCustomDomain)(hostname);
};
const $cb0bb56c18e3edd5$export$8ccd4cc378896990 = (url, hostname)=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const parentHost = window?.location?.origin || '';
    const contentHost = hostname ?? (0, $2Z8x4.getHostnameFromUrl)(url);
    return $cb0bb56c18e3edd5$var$isUrlCustomDomain(parentHost, url) ? (0, $2Z8x4.getHostnameFromUrl)(parentHost) : contentHost;
};
const $cb0bb56c18e3edd5$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = window?.location?.origin || '';
    const hostnameFromUrl = (0, $2Z8x4.getHostnameFromUrl)(originalDomain);
    const systemHostName = (0, $2Z8x4.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    /*
		If content is not on the same tenant, and custom domain is enabled, we need to update the hostname
		to reflect the parentProduct's hostname
	*/ if (systemHostName !== hostnameFromUrl && $cb0bb56c18e3edd5$var$isUrlCustomDomain(currentHostname, originalDomain)) return $cb0bb56c18e3edd5$export$e87b28852220b5cd({
        id: id,
        spaceKey: spaceKey,
        hostname: currentHostname
    });
    return originalUrl;
};
const $cb0bb56c18e3edd5$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
        url: url,
        ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
        objectId: createResponse.id,
        objectType: 'page',
        data: {
            spaceId: space.spaceId,
            spaceKey: space.spaceKey,
            spaceName: space.spaceName,
            status: createResponse.status,
            subType: createResponse.subtype,
            links: createResponse._links
        }
    });

});
parcelRegister("2Z8x4", function(module, exports) {
$parcel$export(module.exports, "getHostnameFromUrl", () => $f54eb56cec144daa$export$280e79c794cf814e);

var $5Zp9R = parcelRequire("5Zp9R");
const $f54eb56cec144daa$export$280e79c794cf814e = (url)=>(0, $5Zp9R.isValidUrl)(url) ? new URL(url)?.hostname : '';

});
parcelRegister("5Zp9R", function(module, exports) {
$parcel$export(module.exports, "isValidUrl", () => $be8dc3f2b7c2d95b$export$bef94a5618bf18bf);
const $be8dc3f2b7c2d95b$export$bef94a5618bf18bf = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});


parcelRegister("jaAj7", function(module, exports) {
$parcel$export(module.exports, "isCustomDomain", () => $d8c7d440b951ac72$export$97f4c254b641e719);
const $d8c7d440b951ac72$var$atlassianDomains = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $d8c7d440b951ac72$export$97f4c254b641e719 = (hostname)=>!$d8c7d440b951ac72$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));

});


parcelRegister("fBOqJ", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedPageDraft", () => $d606de9c6c8551af$export$8df6d110f6d46988);

var $eJOHy = parcelRequire("eJOHy");

var $6DF4T = parcelRequire("6DF4T");

var $vztq1 = parcelRequire("vztq1");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");


var $ZosAp = parcelRequire("ZosAp");

var $1u0iy = parcelRequire("1u0iy");

var $dNEIK = parcelRequire("dNEIK");
const $d606de9c6c8551af$export$f0ebd8c41d592251 = 'success';
const $d606de9c6c8551af$export$12346a674644c156 = 'operational';
const $d606de9c6c8551af$export$8df6d110f6d46988 = ({ isLive: isLive, embeddedConfluenceSource: embeddedConfluenceSource, onClose: onClose, url: url, onEmbeddedContentAction: onEmbeddedContentAction, linkConfluencePage: linkConfluencePage })=>{
    const [{ panel: { isOpen: isOpen } }, actions] = (0, $vztq1.useEmbeddedConfluenceSidePanel)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isContinueDraftOpen, setIsContinueDraftOpen] = (0, $eJOHy.useState)(false);
    const [isPublished, setIsPublished] = (0, $eJOHy.useState)(false);
    const [epMode, setEpMode] = (0, $eJOHy.useState)(isLive ? (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const fireAnalyticsEvent = (0, $1u0iy.useEmbeddedPageTracking)();
    const handledLiveDocUrls = (0, $eJOHy.useRef)(new Set());
    const openContinueDraftModal = (0, $eJOHy.useCallback)(()=>{
        if (!isPublished) {
            setIsContinueDraftOpen(true);
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: isLive ? 'closeLiveDoc' : 'closeUnpublishedDraft',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
        } else onClose && onClose();
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        isLive,
        isPublished,
        onClose
    ]);
    const closeContinueDraftModal = ()=>{
        setIsContinueDraftOpen(false);
    };
    const closeAll = ()=>{
        closeContinueDraftModal();
        onClose && onClose();
    };
    const handleEmbeddedContentAction = (0, $eJOHy.useCallback)((action, name)=>{
        const linkingSuccessDescriptionMessage = ()=>{
            if ((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3')) return isLive ? (0, $dNEIK.default).linkLiveDocSuccessDescriptionIssueTermRefresh : (0, $dNEIK.default).publishAndLinkPageSuccessDescriptionIssueTermRefresh;
            return isLive ? (0, $dNEIK.default).linkLiveDocSuccessDescription : (0, $dNEIK.default).publishAndLinkPageSuccessDescription;
        };
        if (name === 'edit-page/close') {
            if (isPublished) {
                setEpMode((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
                });
            } else openContinueDraftModal();
        }
        if (name === 'edit-page/load' && action === 'taskSuccess') {
            if (epMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) {
                setEpMode((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
                });
            }
        }
        if (name === 'edit-page/publish' && action === 'taskSuccess') {
            if (isOpen) actions.setConfluenceData({
                contentUrl: url,
                isDraft: false,
                mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
            fireAnalyticsEvent({
                action: $d606de9c6c8551af$export$f0ebd8c41d592251,
                eventName: isLive ? 'createLiveDoc' : 'publishDraftPage',
                embeddedConfluenceSource: embeddedConfluenceSource,
                eventType: $d606de9c6c8551af$export$12346a674644c156
            });
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            if (isPublished && !isLive) showFlag({
                key: (0, $jn1Cb.toFlagId)((0, $1976977ff3d9f14f$export$e80a06e24863c775)),
                type: 'success',
                title: formatMessage((0, $dNEIK.default).publishPageSuccessTitle),
                description: formatMessage((0, $dNEIK.default).publishPageSuccessDescription),
                messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.publish-draft-success-flag',
                messageType: 'transactional'
            });
            else {
                setIsPublished(true);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    isDraft: false
                });
                // TODO this is a temporary solution, remove when https://hello.atlassian.net/jira/software/projects/CBT/boards/4465?selectedIssue=CBT-2895 is complete
                setTimeout(()=>{
                    try {
                        if (linkConfluencePage) {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            linkConfluencePage((0, $ZosAp.convertToViewPageUrl)(url), analyticsEvent);
                            fireAnalyticsEvent({
                                action: $d606de9c6c8551af$export$f0ebd8c41d592251,
                                eventName: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                embeddedConfluenceSource: embeddedConfluenceSource,
                                eventType: $d606de9c6c8551af$export$12346a674644c156
                            });
                            showFlag({
                                key: (0, $jn1Cb.toFlagId)((0, $1976977ff3d9f14f$export$26c0043b48580bae)),
                                type: 'success',
                                title: formatMessage(isLive ? (0, $dNEIK.default).linkLiveDocSuccessTitle : (0, $dNEIK.default).publishAndLinkPageSuccessTitle),
                                description: formatMessage(linkingSuccessDescriptionMessage()),
                                messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.link-page-success-flag',
                                messageType: 'transactional'
                            });
                        }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $9pTd3.fireErrorAnalytics)({
                            meta: {
                                id: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                teamName: 'confluence-better-together'
                            },
                            attributes: {
                                embeddedConfluenceSource: embeddedConfluenceSource
                            },
                            error: error
                        });
                        showFlag({
                            key: (0, $jn1Cb.toFlagId)((0, $1976977ff3d9f14f$export$4164631cfaaf3681)),
                            type: 'error',
                            title: formatMessage((0, $dNEIK.default).linkPageFailedTitle),
                            description: formatMessage((0, $dNEIK.default).linkPageFailedDescription),
                            messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.error.link-page-failed-flag',
                            messageType: 'transactional'
                        });
                    }
                }, 3500);
            }
        }
        if (name === 'edit-page/publish' && action === 'taskFail') (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: isLive ? 'createLiveDoc' : 'publishDraftPage',
                teamName: 'confluence-better-together'
            },
            attributes: {
                embeddedConfluenceSource: embeddedConfluenceSource
            },
            error: new Error(`Error publishing draft page: {name: ${name}, action: ${action}}`)
        });
        onEmbeddedContentAction && onEmbeddedContentAction(action, name);
    }, [
        createAnalyticsEvent,
        embeddedConfluenceSource,
        epMode,
        fireAnalyticsEvent,
        formatMessage,
        isPublished,
        linkConfluencePage,
        onEmbeddedContentAction,
        openContinueDraftModal,
        showFlag,
        url,
        actions,
        isOpen,
        isLive
    ]);
    // This is a little weird, but to avoid duplicating the code above, if the page is live and state local state is !isPublished,
    // we simulate the action of publishing from inside the ep modal. This in turn displays the view page, link the page to the issue
    // and show the flag about the page being published and linked.
    (0, $eJOHy.useEffect)(()=>{
        if (isLive && embeddedConfluenceSource?.endsWith('Panel') && !handledLiveDocUrls.current.has(url)) {
            handledLiveDocUrls.current.add(url);
            if (handledLiveDocUrls.current.has(url)) handleEmbeddedContentAction('taskSuccess', 'edit-page/publish');
            else handleEmbeddedContentAction('taskFail', 'edit-page/publish');
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLive,
        url
    ]);
    // in the case that the user creates a live doc and then wants to create a page, we must ensure we open the draft for the page in edit mode
    (0, $eJOHy.useEffect)(()=>{
        setEpMode(isLive ? (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    }, [
        isLive
    ]);
    return {
        isContinueDraftOpen: isContinueDraftOpen,
        openContinueDraftModal: openContinueDraftModal,
        closeContinueDraftModal: closeContinueDraftModal,
        closeAll: closeAll,
        handleEmbeddedContentAction: handleEmbeddedContentAction,
        fireAnalyticsEvent: fireAnalyticsEvent,
        epMode: epMode
    };
};

});
const $1976977ff3d9f14f$export$e80a06e24863c775 = 'publishDraftSuccess';
const $1976977ff3d9f14f$export$26c0043b48580bae = 'linkPageSuccess';
const $1976977ff3d9f14f$export$4164631cfaaf3681 = 'linkPageFailed';

parcelRegister("ZosAp", function(module, exports) {
$parcel$export(module.exports, "convertToViewPageUrl", () => $498314633327a16f$export$fbd50b21ccd324a6);
const $498314633327a16f$export$fbd50b21ccd324a6 = (url)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    url.split('/').filter((part)=>part !== 'edit-v2').join('/');

});

parcelRegister("1u0iy", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedPageTracking", () => $0b8aa5d46ca9b666$export$9fcd107e4ed1de75);

var $eJOHy = parcelRequire("eJOHy");

var $bmoS1 = parcelRequire("bmoS1");

var $ftN6c = parcelRequire("ftN6c");

var $koAZ4 = parcelRequire("koAZ4");

var $iVGww = parcelRequire("iVGww");

var $jRzGn = parcelRequire("jRzGn");
const $0b8aa5d46ca9b666$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const source = (0, $bmoS1.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $eJOHy.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, contentType: contentType, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', flow: flow, userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, isLivePage: isLivePage, linkObjectType: linkObjectType, confluenceContentId: confluenceContentId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: (0, $jRzGn.getParentProduct)(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            flow: flow,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct,
            isLivePage: isLivePage,
            isSiteAdmin: tenantContext?.isSiteAdmin,
            linkObjectType: linkObjectType,
            confluenceContentId: confluenceContentId,
            contentType: contentType
        };
        (0, $iVGww.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("iVGww", function(module, exports) {
$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $fe1a92e0c124c21f$export$864bc2da9014e8e9);

var $kRgKj = parcelRequire("kRgKj");
const $fe1a92e0c124c21f$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});

parcelRegister("jRzGn", function(module, exports) {
$parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", () => $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5);
$parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", () => $9a2cffb8cd0a43d3$export$bf1e31028b579014);
$parcel$export(module.exports, "ACCESS_DENIED_STATUSES", () => $9a2cffb8cd0a43d3$export$2fe5bb2d968b01fc);
$parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", () => $9a2cffb8cd0a43d3$export$56360b096b4b4439);
$parcel$export(module.exports, "getParentProduct", () => $9a2cffb8cd0a43d3$export$e873edb2560a07ef);

var $FhXEJ = parcelRequire("FhXEJ");


var $5Zp9R = parcelRequire("5Zp9R");


const $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5 = {
    ACCESS_GRANTED: 'ACCESS_GRANTED',
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
const $9a2cffb8cd0a43d3$export$bf1e31028b579014 = [
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.ACCESS_EXISTS,
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.ACCESS_GRANTED,
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
];
const $9a2cffb8cd0a43d3$export$2fe5bb2d968b01fc = [
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.FORBIDDEN,
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
];
const $9a2cffb8cd0a43d3$export$56360b096b4b4439 = 'licence-exceeded';
const $9a2cffb8cd0a43d3$export$e873edb2560a07ef = (projectType)=>{
    switch(projectType){
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $FhXEJ.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $FhXEJ.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};

});


parcelRegister("dNEIK", function(module, exports) {
$parcel$export(module.exports, "default", () => $6991b9cb99d4b8bc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6991b9cb99d4b8bc$var$messages = (0, $7qGN1.defineMessages)({
    publishPageSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-title",
        "defaultMessage": "Published!"
    },
    publishPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-description",
        "defaultMessage": "Successfully published page"
    },
    deferSpacePublishPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.defer-space-publish-page-success-description",
        "defaultMessage": "Your page was successfully published in the {spaceName} space"
    },
    publishPageFailedTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-title",
        "defaultMessage": "Something went wrong"
    },
    publishPageFailedDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-description",
        "defaultMessage": "We are unable to publish your page at this time"
    },
    linkPageFailedTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-title",
        "defaultMessage": "Something went wrong."
    },
    linkPageFailedDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-description",
        "defaultMessage": "We are unable to link your page at this time"
    },
    publishAndLinkPageSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-title",
        "defaultMessage": "Published!"
    },
    publishAndLinkPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description",
        "defaultMessage": "Your page has been published and linked to your Jira issue."
    },
    publishAndLinkPageSuccessDescriptionIssueTermRefresh: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description-issue-term-refresh",
        "defaultMessage": "Your page has been published and linked to your Jira work item."
    },
    linkLiveDocSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-title",
        "defaultMessage": "Live doc created"
    },
    linkLiveDocSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description",
        "defaultMessage": "A live doc was created and linked to your Jira issue."
    },
    linkLiveDocSuccessDescriptionIssueTermRefresh: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description-issue-term-refresh",
        "defaultMessage": "A live doc was created and linked to your Jira work item."
    }
});
var $6991b9cb99d4b8bc$export$2e2bcd8739ae039 = $6991b9cb99d4b8bc$var$messages;

});


parcelRegister("1VTE7", function(module, exports) {
$parcel$export(module.exports, "useParentProduct", () => $9e4c426c0a6578b5$export$1b09c6e3737c8eb7);

var $2aY2d = parcelRequire("2aY2d");

var $jRzGn = parcelRequire("jRzGn");
const $9e4c426c0a6578b5$export$1b09c6e3737c8eb7 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const projectType = data?.projectType;
    return (0, $jRzGn.getParentProduct)(projectType);
};

});

parcelRegister("iiTqV", function(module, exports) {
$parcel$export(module.exports, "embeddedWhiteboardModalEntrypoint", () => $48c35621d2e08c98$export$652b3f11839af9e6);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $48c35621d2e08c98$export$652b3f11839af9e6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fLWpA")), {
        moduleId: "d273fc0f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fLWpA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4a7Nq").then(()=>parcelRequire('8XGHT'));

});




parcelRegister("hWQJk", function(module, exports) {
$parcel$export(module.exports, "ImperativeAPI", () => $dc9d639c7b80dafe$export$e2ad0ff52e7f8c84);

var $eJOHy = parcelRequire("eJOHy");

var $jCQk5 = parcelRequire("jCQk5");

var $8MGwS = parcelRequire("8MGwS");
const $dc9d639c7b80dafe$export$e2ad0ff52e7f8c84 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jCQk5.Consumer), null, ({ getManager: getManager })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8MGwS.ImperativeAPI), {
            getItemManager: getManager
        }));

});
parcelRegister("jCQk5", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $3f9151ab3ad2c0bf$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $3f9151ab3ad2c0bf$export$b3bffd4bb7da6b8f);

var $eJOHy = parcelRequire("eJOHy");

var $jFHCE = parcelRequire("jFHCE");

var $b1B2B = parcelRequire("b1B2B");

var $aRKGc = parcelRequire("aRKGc");
const $3f9151ab3ad2c0bf$var$Context = (0, $b1B2B.default)('ItemManagers');
const $3f9151ab3ad2c0bf$export$275138de3066e8b3 = 30000;
class $3f9151ab3ad2c0bf$export$2881499e37b75b9a extends (0, $eJOHy.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f9151ab3ad2c0bf$var$Context.Provider, {
            value: this.manager
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            managers: {}
        }, this.getManager = (managerKey)=>{
            const { managers: managers } = this.state;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const manager = managers[managerKey];
            if (manager) return manager;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject)=>{
                const message = `Timeout. "${(0, $aRKGc.fromManagerKey)(managerKey)}" wasn't registered after ${$3f9151ab3ad2c0bf$export$275138de3066e8b3}ms`;
                const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $3f9151ab3ad2c0bf$export$275138de3066e8b3);
                const { pendingManagers: pendingManagers } = this;
                pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                pendingManagers[managerKey].push((methods)=>{
                    clearTimeout(rejectTimeoutId);
                    resolve(methods);
                });
            });
        }, this.registerManager = (managerKey, methods)=>{
            this.setState((previousState)=>{
                if (methods == null) return {
                    managers: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(previousState.managers, managerKey)
                };
                const managerResolvers = this.pendingManagers[managerKey];
                if (managerResolvers && managerResolvers.length) {
                    managerResolvers.forEach((resolve)=>resolve(methods));
                    managerResolvers.length = 0;
                }
                return {
                    managers: {
                        ...previousState.managers,
                        [managerKey]: Promise.resolve(methods)
                    }
                };
            });
        }, this.pendingManagers = {}, this.manager = {
            getManager: this.getManager,
            registerManager: this.registerManager
        };
    }
}
const { Consumer: $3f9151ab3ad2c0bf$export$b3bffd4bb7da6b8f } = $3f9151ab3ad2c0bf$var$Context;

});
parcelRegister("b1B2B", function(module, exports) {
$parcel$export(module.exports, "default", () => $a91f7719f34a5690$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $a91f7719f34a5690$var$createSafeContext = (name)=>{
    const contextObjName = name || '';
    const defaultGetter = ()=>{
        throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
    };
    const Context = /*#__PURE__*/ (0, $eJOHy.createContext)(defaultGetter);
    const ContextConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Context.Consumer, null, (getValue)=>{
            const value = getValue();
            return props.children(value);
        });
    const ContextProvider = ({ value: value, children: children })=>{
        const getValue = ()=>value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Context.Provider, {
            value: getValue
        }, children);
    };
    ContextProvider.displayName = `${contextObjName}SafeProvider`;
    ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
    // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
    return {
        Provider: ContextProvider,
        Consumer: ContextConsumer
    };
};
var $a91f7719f34a5690$export$2e2bcd8739ae039 = $a91f7719f34a5690$var$createSafeContext;

});

parcelRegister("aRKGc", function(module, exports) {
$parcel$export(module.exports, "fromManagerKey", () => $c188336fc6742526$export$fef172a673b3ef47);
const $c188336fc6742526$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
const $c188336fc6742526$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);

});


parcelRegister("8MGwS", function(module, exports) {
$parcel$export(module.exports, "ImperativeAPI", () => $36dc8c660a943928$export$e2ad0ff52e7f8c84);

var $eJOHy = parcelRequire("eJOHy");

var $iyT45 = parcelRequire("iyT45");

var $eSnSE = parcelRequire("eSnSE");

var $i6rzz = parcelRequire("i6rzz");

var $4FEgv = parcelRequire("4FEgv");

var $cUxaS = parcelRequire("cUxaS");

var $dSkLG = parcelRequire("dSkLG");

var $7pRCV = parcelRequire("7pRCV");

var $aRKGc = parcelRequire("aRKGc");

var $83DiZ = parcelRequire("83DiZ");

var $hBVia = parcelRequire("hBVia");
const $36dc8c660a943928$var$ERROR_LOCATION = 'legacy.imperative-api';
const $36dc8c660a943928$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $cUxaS.useLeftSidebarController)();
    const { refresh: refresh } = (0, $dSkLG.useProjectSidebarNavigation)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const sidebarState = (0, $cUxaS.useLeftSidebarState)();
    const sidebarRef = (0, $eJOHy.useRef)(sidebarState);
    const refreshSidebarRef = (0, $eJOHy.useRef)(refresh);
    const imperativeAPIRef = (0, $eJOHy.useRef)({
        viewIds: $hBVia.viewIds,
        itemIds: $hBVia.itemIds,
        expand: expandLeftSidebar,
        collapse: collapseLeftSidebar,
        isCollapsed: ()=>sidebarRef.current.isCollapsed,
        onCollapse: ()=>undefined,
        onCollapseStart: ()=>undefined,
        onCollapseEnd: ()=>undefined,
        onExpand: ()=>undefined,
        onExpandStart: ()=>undefined,
        onExpandEnd: ()=>undefined,
        onItemClick: ()=>undefined,
        setView: ()=>undefined,
        updateActiveView: ()=>undefined,
        setProjectRootView: ()=>undefined,
        getActiveViewItems: ()=>[],
        isInProjectContext: ()=>false,
        updateContext: ()=>undefined,
        updateData: ()=>{
            refreshSidebarRef.current();
        },
        getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                (0, $eSnSE.default).safeErrorWithoutCustomerData($36dc8c660a943928$var$ERROR_LOCATION, `There was a problem getting "${(0, $aRKGc.fromManagerKey)(itemManagerKey)}" item manager`, e);
                throw e;
            }),
        createBoard: ()=>{
            (0, $4FEgv.default)();
        },
        modalOpen: ()=>undefined,
        modalClose: ()=>undefined,
        navigate: (url)=>push(url)
    });
    sidebarRef.current = sidebarState;
    refreshSidebarRef.current = refresh;
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $iyT45.loadBridgeWeak)({
            name: 'jira/navigation/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(imperativeAPIRef.current);
        });
        (0, $i6rzz.provideNavigationApi)({
            navigate: push
        });
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7pRCV.NavigationUIContainer), {
        isGlobal: true
    });
};

});
parcelRegister("i6rzz", function(module, exports) {
$parcel$export(module.exports, "provideNavigationApi", () => $8e042d89b6822ab4$export$26d28e8849b2805f);
$parcel$export(module.exports, "isInIframe", () => $8e042d89b6822ab4$export$9f140ed41af5108c);
$parcel$export(module.exports, "canSpaTransition", () => $8e042d89b6822ab4$export$59e771495885068f);
$parcel$export(module.exports, "getContainerApi", () => $8e042d89b6822ab4$export$91ed870fd8df2bcb);
$parcel$export(module.exports, "getNavigationApi", () => $8e042d89b6822ab4$export$da4e5a44286a0dd0);
// Old AMD key: `ac/spa-context`
// TODO: we will improve the type later when we know the code better.
let $8e042d89b6822ab4$var$containerApi = null;
let $8e042d89b6822ab4$var$navigationApi = null;
const $8e042d89b6822ab4$export$3927fb5df700a968 = (api)=>{
    $8e042d89b6822ab4$var$containerApi = api;
};
const $8e042d89b6822ab4$export$26d28e8849b2805f = (api)=>{
    $8e042d89b6822ab4$var$navigationApi = api;
};
const $8e042d89b6822ab4$export$9f140ed41af5108c = ()=>$8e042d89b6822ab4$var$containerApi !== null;
const $8e042d89b6822ab4$export$59e771495885068f = ()=>$8e042d89b6822ab4$var$navigationApi !== null;
const $8e042d89b6822ab4$export$91ed870fd8df2bcb = ()=>$8e042d89b6822ab4$var$containerApi;
const $8e042d89b6822ab4$export$da4e5a44286a0dd0 = ()=>$8e042d89b6822ab4$var$navigationApi;
const $8e042d89b6822ab4$export$6ba42130b045ede1 = ()=>{
    $8e042d89b6822ab4$var$containerApi = null;
    $8e042d89b6822ab4$var$navigationApi = null;
};

});

parcelRegister("4FEgv", function(module, exports) {
$parcel$export(module.exports, "default", () => $299bc7b5e43caf95$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
const $299bc7b5e43caf95$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
const $299bc7b5e43caf95$var$createBoardLegacy = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $97BGz.loadBridgeStrict)({
        name: $299bc7b5e43caf95$var$amdModuleName,
        wrmKeys: [
            'wrc!com.pyxis.greenhopper.jira:gh-create-board'
        ]
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};
var $299bc7b5e43caf95$export$2e2bcd8739ae039 = $299bc7b5e43caf95$var$createBoardLegacy;

});

parcelRegister("7pRCV", function(module, exports) {
$parcel$export(module.exports, "NavigationUISubscriber", () => $a02d5a296098bc51$export$d3dc1c18cfde5ddd);
$parcel$export(module.exports, "NavigationUIContainer", () => $a02d5a296098bc51$export$339ec9ca159ad81f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $ht3nQ = parcelRequire("ht3nQ");

var $fCjE9 = parcelRequire("fCjE9");
const $a02d5a296098bc51$export$d3dc1c18cfde5ddd = (0, $ht3nQ.createSubscriber)((0, $fCjE9.default), {
    displayName: 'NavigationUISubscriber',
    selector: null
});
const $a02d5a296098bc51$export$339ec9ca159ad81f = (0, $6E16M.createContainer)((0, $fCjE9.default));

});
parcelRegister("fCjE9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7179e181487f7eb$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $li6to = parcelRequire("li6to");
const $e7179e181487f7eb$var$initialState = {
    collapseStart: new Set(),
    collapseEnd: new Set(),
    expandStart: new Set(),
    expandEnd: new Set()
};
var $e7179e181487f7eb$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'navigation-ui',
    initialState: $e7179e181487f7eb$var$initialState,
    actions: $li6to.default
});

});
parcelRegister("li6to", function(module, exports) {
$parcel$export(module.exports, "default", () => $a55c108ac4cff354$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-wildcard-imports

var $6NVJW = parcelRequire("6NVJW");
var $8NPrV = parcelRequire("8NPrV");
var $9bD9v = parcelRequire("9bD9v");
var $l2B85 = parcelRequire("l2B85");
const $a55c108ac4cff354$var$actions = {
    collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($6NVJW.default('collapseStart', cb)),
    collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($9bD9v.default('collapseStart', cb)),
    collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($8NPrV.default('collapseStart')),
    collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($l2B85.default('collapseStart')),
    collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($6NVJW.default('collapseEnd', cb)),
    collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($9bD9v.default('collapseEnd', cb)),
    collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($8NPrV.default('collapseEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    collapseEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($l2B85.default('collapseEnd', cb)),
    expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($6NVJW.default('expandStart', cb)),
    expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($9bD9v.default('expandStart', cb)),
    expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($8NPrV.default('expandStart')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandStartRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($l2B85.default('expandStart', cb)),
    expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($6NVJW.default('expandEnd', cb)),
    expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($9bD9v.default('expandEnd', cb)),
    expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($8NPrV.default('expandEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($l2B85.default('expandEnd', cb)),
    clearAll: ()=>({ dispatch: dispatch })=>{
            dispatch($a55c108ac4cff354$var$actions.collapseStartClear());
            dispatch($a55c108ac4cff354$var$actions.collapseEndClear());
            dispatch($a55c108ac4cff354$var$actions.expandStartClear());
            dispatch($a55c108ac4cff354$var$actions.expandEndClear());
        }
};
var $a55c108ac4cff354$export$2e2bcd8739ae039 = $a55c108ac4cff354$var$actions;

});
parcelRegister("6NVJW", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ba6f709bab4053f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9bD9v = parcelRequire("9bD9v");
const $5ba6f709bab4053f$var$add = (key, callback)=>// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set(getState()[key]).add(callback)
        });
        return ()=>dispatch((0, $9bD9v.default)(key, callback));
    };
var $5ba6f709bab4053f$export$2e2bcd8739ae039 = $5ba6f709bab4053f$var$add;

});
parcelRegister("9bD9v", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbb71e6449a8af52$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $fbb71e6449a8af52$var$remove = (key, callback)=>({ setState: setState, getState: getState })=>{
        if (!getState()[key]) return;
        const slice = new Set(getState()[key]);
        slice.delete(callback);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: slice
        });
    };
var $fbb71e6449a8af52$export$2e2bcd8739ae039 = $fbb71e6449a8af52$var$remove;

});


parcelRegister("8NPrV", function(module, exports) {
$parcel$export(module.exports, "default", () => $06fac9eb9330eb50$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $06fac9eb9330eb50$var$clear = (key)=>({ setState: setState })=>// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set()
        });
var $06fac9eb9330eb50$export$2e2bcd8739ae039 = $06fac9eb9330eb50$var$clear;

});

parcelRegister("l2B85", function(module, exports) {
$parcel$export(module.exports, "default", () => $979342ca5d7efa1f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $979342ca5d7efa1f$var$run = (key, ...args)=>({ getState: getState })=>// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
        (getState()[key] || new Set()).forEach((cb)=>cb(...args));
var $979342ca5d7efa1f$export$2e2bcd8739ae039 = $979342ca5d7efa1f$var$run;

});




parcelRegister("hBVia", function(module, exports) {
$parcel$export(module.exports, "itemIds", () => $915933f8c524e7d3$export$443ec49e59de3663);
$parcel$export(module.exports, "viewIds", () => $915933f8c524e7d3$export$8ee2fd038785d9dc);

var $hEw7G = parcelRequire("hEw7G");
const $915933f8c524e7d3$var$ROOT = 'root/index';
const $915933f8c524e7d3$var$ISSUES = 'root/issues';
const $915933f8c524e7d3$var$DASHBOARDS = 'root/dashboards';
const $915933f8c524e7d3$var$PORTFOLIO = 'root/portfolio';
const $915933f8c524e7d3$var$WORK_SCRUM = 'work-scrum';
const $915933f8c524e7d3$var$PLAN_SCRUM = 'plan-scrum';
const $915933f8c524e7d3$var$WORK_KANBAN = 'work-kanban';
const $915933f8c524e7d3$var$PLAN_KANBAN = 'plan-kanban';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
const $915933f8c524e7d3$var$AGILITY = 'project/agility/index';
const $915933f8c524e7d3$var$BUSINESS = 'project/business/index';
const $915933f8c524e7d3$var$OPS = 'project/ops/index';
const $915933f8c524e7d3$var$SOFTWARE = 'project/software/index';
const $915933f8c524e7d3$var$SOFTWARE_ISSUES = 'project/software/issues';
const $915933f8c524e7d3$var$SOFTWARE_REPORTS = 'project/software/reports';
const $915933f8c524e7d3$var$USER = 'user/index';
const $915933f8c524e7d3$var$USER_REPORTS = 'user/reports';
const $915933f8c524e7d3$var$rootProjectViewIds = {
    AGILITY: $915933f8c524e7d3$var$AGILITY,
    SERVICE_DESK: $hEw7G.SERVICE_DESK,
    OPS: $915933f8c524e7d3$var$OPS,
    BUSINESS: $915933f8c524e7d3$var$BUSINESS,
    SOFTWARE: $915933f8c524e7d3$var$SOFTWARE
};
const $915933f8c524e7d3$var$rootViewIds = {
    ROOT: $915933f8c524e7d3$var$ROOT,
    ISSUES: $915933f8c524e7d3$var$ISSUES,
    DASHBOARDS: $915933f8c524e7d3$var$DASHBOARDS,
    PORTFOLIO: $915933f8c524e7d3$var$PORTFOLIO
};
const $915933f8c524e7d3$export$443ec49e59de3663 = {
    WORK_SCRUM: $915933f8c524e7d3$var$WORK_SCRUM,
    PLAN_SCRUM: $915933f8c524e7d3$var$PLAN_SCRUM,
    WORK_KANBAN: $915933f8c524e7d3$var$WORK_KANBAN,
    PLAN_KANBAN: $915933f8c524e7d3$var$PLAN_KANBAN,
    PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
    ...(0, $hEw7G.SERVICE_DESK_ITEMS)
};
const $915933f8c524e7d3$export$8ee2fd038785d9dc = {
    ...$915933f8c524e7d3$var$rootViewIds,
    ...$915933f8c524e7d3$var$rootProjectViewIds,
    SOFTWARE_ISSUES: $915933f8c524e7d3$var$SOFTWARE_ISSUES,
    SOFTWARE_REPORTS: $915933f8c524e7d3$var$SOFTWARE_REPORTS,
    SERVICE_DESK_ISSUES: $hEw7G.SERVICE_DESK_ISSUES,
    SERVICE_DESK_QUEUES: $hEw7G.SERVICE_DESK_QUEUES,
    SERVICE_DESK_REPORTS: $hEw7G.SERVICE_DESK_REPORTS,
    SERVICE_DESK_SETTINGS: $hEw7G.SERVICE_DESK_SETTINGS,
    SERVICE_DESK_LANGUAGES: $hEw7G.SERVICE_DESK_LANGUAGES,
    SERVICE_DESK_LEGACY_TICKET_TYPES: $hEw7G.SERVICE_DESK_LEGACY_TICKET_TYPES,
    SERVICE_DESK_TRANSLATIONS: $hEw7G.SERVICE_DESK_TRANSLATIONS,
    SERVICE_DESK_AUTOMATION_SUB_NAV: $hEw7G.SERVICE_DESK_AUTOMATION_SUB_NAV,
    SERVICE_DESK_KNOWLEDGE_HUB: $hEw7G.SERVICE_DESK_KNOWLEDGE_HUB,
    USER: $915933f8c524e7d3$var$USER,
    USER_REPORTS: $915933f8c524e7d3$var$USER_REPORTS
};

});
parcelRegister("hEw7G", function(module, exports) {
$parcel$export(module.exports, "REPORTS_IDS", () => $67699a75a06dd97b$export$1f70a76cb421b107);
$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $67699a75a06dd97b$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "PRACTICES_IDS", () => $67699a75a06dd97b$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $67699a75a06dd97b$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $67699a75a06dd97b$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", () => $67699a75a06dd97b$export$e2d46b728fe0a15a);
$parcel$export(module.exports, "SERVICE_DESK", () => $67699a75a06dd97b$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $67699a75a06dd97b$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $67699a75a06dd97b$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $67699a75a06dd97b$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $67699a75a06dd97b$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $67699a75a06dd97b$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $67699a75a06dd97b$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $67699a75a06dd97b$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $67699a75a06dd97b$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $67699a75a06dd97b$export$9a6deaa9c1af559f);
const $67699a75a06dd97b$var$HOME_QUEUES = 'queues';
const $67699a75a06dd97b$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $67699a75a06dd97b$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $67699a75a06dd97b$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $67699a75a06dd97b$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $67699a75a06dd97b$var$HOME_INCIDENTS = 'incidents';
const $67699a75a06dd97b$var$HOME_CHANGES = 'changes';
const $67699a75a06dd97b$var$HOME_PROBLEMS = 'problems';
const $67699a75a06dd97b$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $67699a75a06dd97b$var$HOME_CUSTOMERS = 'customers';
const $67699a75a06dd97b$var$HOME_REPORTS = 'reports';
const $67699a75a06dd97b$var$HOME_RAISE_REQUEST = 'raise-request';
const $67699a75a06dd97b$var$HOME_ISSUES = 'issues';
const $67699a75a06dd97b$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $67699a75a06dd97b$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $67699a75a06dd97b$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $67699a75a06dd97b$var$HOME_INVITE_TEAM = 'invite-team';
const $67699a75a06dd97b$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $67699a75a06dd97b$var$HOME_SERVICES = 'services';
const $67699a75a06dd97b$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $67699a75a06dd97b$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $67699a75a06dd97b$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $67699a75a06dd97b$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $67699a75a06dd97b$export$9afbea2cbd37e16d = {
    QUEUES: $67699a75a06dd97b$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $67699a75a06dd97b$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $67699a75a06dd97b$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $67699a75a06dd97b$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $67699a75a06dd97b$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $67699a75a06dd97b$var$HOME_INCIDENTS,
    CHANGES: $67699a75a06dd97b$var$HOME_CHANGES,
    PROBLEMS: $67699a75a06dd97b$var$HOME_PROBLEMS,
    CUSTOMERS: $67699a75a06dd97b$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $67699a75a06dd97b$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $67699a75a06dd97b$var$HOME_REPORTS,
    RAISE_REQUEST: $67699a75a06dd97b$var$HOME_RAISE_REQUEST,
    ISSUES: $67699a75a06dd97b$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $67699a75a06dd97b$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $67699a75a06dd97b$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $67699a75a06dd97b$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $67699a75a06dd97b$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $67699a75a06dd97b$var$HOME_GIVE_FEEDBACK,
    SERVICES: $67699a75a06dd97b$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $67699a75a06dd97b$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $67699a75a06dd97b$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $67699a75a06dd97b$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $67699a75a06dd97b$var$KNOWLEDGE_BASE_IDS = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $67699a75a06dd97b$var$SETTINGS_IDS = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $67699a75a06dd97b$var$QUEUES_IDS = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $67699a75a06dd97b$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $67699a75a06dd97b$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $67699a75a06dd97b$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $67699a75a06dd97b$var$KNOWLEDGE_BASE_IDS,
        SETTINGS: $67699a75a06dd97b$var$SETTINGS_IDS,
        QUEUES: $67699a75a06dd97b$var$QUEUES_IDS,
        REPORTS: $67699a75a06dd97b$export$1f70a76cb421b107
    }
};
const $67699a75a06dd97b$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $67699a75a06dd97b$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $67699a75a06dd97b$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $67699a75a06dd97b$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $67699a75a06dd97b$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $67699a75a06dd97b$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $67699a75a06dd97b$export$707771f2f7e60575 = 'project/service-desk/reports';
const $67699a75a06dd97b$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $67699a75a06dd97b$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $67699a75a06dd97b$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $67699a75a06dd97b$export$d70ba5c124463035 = 'project/service-desk/translations';
const $67699a75a06dd97b$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});




parcelRegister("imyEu", function(module, exports) {
$parcel$export(module.exports, "PageDwellAnalyticsListener", () => $9d12160bc6dda165$export$6cf89f098b551dad);

var $eJOHy = parcelRequire("eJOHy");

var $cUxaS = parcelRequire("cUxaS");

var $hih5V = parcelRequire("hih5V");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $kZIBu = parcelRequire("kZIBu");

var $4VR5y = parcelRequire("4VR5y");
const $9d12160bc6dda165$var$WAIT_DURATION = 5000;
/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */ const $9d12160bc6dda165$export$6cf89f098b551dad = ()=>{
    const [hasFired, setHasFired] = (0, $eJOHy.useState)(false);
    const route = (0, $hih5V.useCurrentRoute)();
    const routeName = route.name;
    const [{ isReady: isReady }] = (0, $kZIBu.useSpaStatePageReady)();
    const isVisible = (0, $4VR5y.usePageVisibility)();
    const interval = (0, $eJOHy.useRef)(null);
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $cUxaS.useLeftSidebarState)();
    (0, $eJOHy.useEffect)(()=>{
        setHasFired(false);
    }, [
        routeName
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isReady) {
            interval.current = null;
            return;
        }
        // If the page is visible, set the analytics event to run after the specified duration
        if (isVisible && !hasFired) interval.current = setTimeout(()=>{
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                containerId: projectData?.projectId,
                containerType: projectData?.projectType,
                isLeftSidebarCollapsed: isLeftSidebarCollapsed
            });
            setHasFired(true);
        }, $9d12160bc6dda165$var$WAIT_DURATION);
        return ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            interval.current = clearTimeout(interval.current);
        };
    }, [
        createAnalyticsEvent,
        hasFired,
        isReady,
        isVisible,
        routeName,
        projectData?.projectId,
        projectData?.projectType,
        isLeftSidebarCollapsed
    ]);
    return null;
};

});
parcelRegister("4VR5y", function(module, exports) {
$parcel$export(module.exports, "usePageVisibility", () => $e67041c651799768$export$6c98eb2f12f4ec61);

var $eJOHy = parcelRequire("eJOHy");

var $jzYet = parcelRequire("jzYet");
const $e67041c651799768$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $eJOHy.useState)((0, $jzYet.isPageVisible)());
    (0, $eJOHy.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $jzYet.isPageVisible)());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("jzYet", function(module, exports) {
$parcel$export(module.exports, "supportedVisiblityEvent", () => $e5424949077e4f69$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $e5424949077e4f69$export$ae4f9b990bc70f70);
const $e5424949077e4f69$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $e5424949077e4f69$var$supportedHiddenKey = Object.keys($e5424949077e4f69$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $e5424949077e4f69$export$f7132cb36c80dad = $e5424949077e4f69$var$visibilityMap[$e5424949077e4f69$var$supportedHiddenKey];
const $e5424949077e4f69$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$e5424949077e4f69$var$supportedHiddenKey];

});



parcelRegister("e5yn1", function(module, exports) {
$parcel$export(module.exports, "MatchedRouteListener", () => $6a5c3e88966e65c9$export$c6d9204abc182c3b);

var $eJOHy = parcelRequire("eJOHy");

var $kQnVX = parcelRequire("kQnVX");

var $gCY1z = parcelRequire("gCY1z");
const $6a5c3e88966e65c9$export$c6d9204abc182c3b = ()=>{
    const [{ route: route, match: match }] = (0, $gCY1z.useRouter)();
    (0, $eJOHy.useMemo)(()=>(0, $kQnVX.setMatchedRoute)(route, match), [
        route,
        match
    ]);
    return null;
};

});

parcelRegister("38W5l", function(module, exports) {
$parcel$export(module.exports, "PreviousRouterStateListener", () => $6dbb6c87215e8abb$export$49e28489f2124002);

var $eJOHy = parcelRequire("eJOHy");

var $6d9QY = parcelRequire("6d9QY");

var $kQnVX = parcelRequire("kQnVX");

var $ivzXw = parcelRequire("ivzXw");
const $6dbb6c87215e8abb$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
    const previousRouterState = (0, $6d9QY.usePrevious)(routerState);
    (0, $eJOHy.useEffect)(()=>{
        (0, $kQnVX.setPreviousRouterState)(previousRouterState ?? null);
    }, [
        previousRouterState
    ]);
    return null;
};
const $6dbb6c87215e8abb$export$49e28489f2124002 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, (routerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dbb6c87215e8abb$export$3fd5ddd6b8e9a200, {
            routerState: routerState
        })));
$6dbb6c87215e8abb$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';

});

parcelRegister("6u6pq", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6b786fc3210ac1a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $3aa9n = parcelRequire("3aa9n");

var $2gZNc = parcelRequire("2gZNc");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $lcB5K = parcelRequire("lcB5K");
var $ivzXw = parcelRequire("ivzXw");

var $cxKOj = parcelRequire("cxKOj");

var $jLNSr = parcelRequire("jLNSr");
/**
 * Defines the component for the `querystring-notifier` module.
 */ const $d6b786fc3210ac1a$var$QueryStringNotifier = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa),
        sourceName: "querystringNotifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gZNc.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, ({ location: { search: search } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ replace: replace })=>{
                const { showFlag: showFlag, ...query } = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search);
                if (!showFlag) return null;
                const notificationMessages = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $jLNSr.notificationMessagesWithoutProjectTerm) : (0, $jLNSr.notificationMessagesWithProjectTerm);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, notificationMessages[showFlag] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireOperationalAnalytics), {
                    eventName: "querystringNotification shown",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireOperationalAnalytics), {
                    eventName: "querystringNotification notFound",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
                    op: ()=>{
                        if (notificationMessages[showFlag]) flagService.showFlag(notificationMessages[showFlag]);
                        replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query)}`);
                    }
                }));
            }))));
var $d6b786fc3210ac1a$export$2e2bcd8739ae039 = $d6b786fc3210ac1a$var$QueryStringNotifier;

});
parcelRegister("3aa9n", function(module, exports) {
$parcel$export(module.exports, "default", () => $8027defe1b946cc9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
// eslint-disable-next-line jira/react/no-class-components
class $8027defe1b946cc9$var$OpTrigger extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $8027defe1b946cc9$export$2e2bcd8739ae039 = $8027defe1b946cc9$var$OpTrigger;

});

parcelRegister("2gZNc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8b9477dac21cb05$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");
const $e8b9477dac21cb05$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children((0, $cSXp8.flagService)));
var $e8b9477dac21cb05$export$2e2bcd8739ae039 = $e8b9477dac21cb05$var$FlagServiceSubscriber;

});

parcelRegister("jLNSr", function(module, exports) {
$parcel$export(module.exports, "notificationMessagesWithProjectTerm", () => $7906ae57d76a25b2$export$29d79c6c9f4a7eec);
$parcel$export(module.exports, "notificationMessagesWithoutProjectTerm", () => $7906ae57d76a25b2$export$c8ca2015225638f9);

var $jn1Cb = parcelRequire("jn1Cb");

var $9f84N = parcelRequire("9f84N");
const $7906ae57d76a25b2$export$29d79c6c9f4a7eec = {
    'jsw.board-not-found': {
        id: (0, $jn1Cb.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $9f84N.default).boardNotFound,
        description: (0, $9f84N.default).boardNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found',
        messageType: 'transactional'
    },
    'jsw.project-not-found': {
        id: (0, $jn1Cb.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $9f84N.default).projectNotFound,
        description: (0, $9f84N.default).projectNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found',
        messageType: 'transactional'
    }
};
const $7906ae57d76a25b2$export$c8ca2015225638f9 = {
    'jsw.board-not-found': {
        id: (0, $jn1Cb.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $9f84N.default).boardNotFound,
        description: (0, $9f84N.default).boardNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found.1',
        messageType: 'transactional'
    },
    'jsw.project-not-found': {
        id: (0, $jn1Cb.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $9f84N.default).projectNotFoundGalaxia,
        description: (0, $9f84N.default).projectNotFoundDescriptionGalaxia,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found.1',
        messageType: 'transactional'
    }
};

});
parcelRegister("9f84N", function(module, exports) {
$parcel$export(module.exports, "default", () => $34589732b7bc6c73$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
// Don't confuse Intl messages with `Flag`s
const $34589732b7bc6c73$var$messages = (0, $7qGN1.defineMessages)({
    boardNotFound: {
        "id": "query-string-notifier.common.board-not-found",
        "defaultMessage": "Board not found"
    },
    boardNotFoundDescription: {
        "id": "query-string-notifier.common.board-not-found-description",
        "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
    },
    projectNotFound: {
        "id": "query-string-notifier.common.project-not-found",
        "defaultMessage": "Project not found"
    },
    projectNotFoundDescription: {
        "id": "query-string-notifier.common.project-not-found-description",
        "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
    },
    projectNotFoundDescriptionGalaxia: {
        "id": "query-string-notifier.common.project-not-found-description-galaxia",
        "defaultMessage": "You tried to access a space that doesn't exist or that you don't have permission to see."
    },
    projectNotFoundGalaxia: {
        "id": "query-string-notifier.common.project-not-found-galaxia",
        "defaultMessage": "Space not found."
    }
});
var $34589732b7bc6c73$export$2e2bcd8739ae039 = $34589732b7bc6c73$var$messages;

});



parcelRegister("3Kq2h", function(module, exports) {
$parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", () => $b881d19f08db553c$export$2a43717c77dd3a56);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $3So8J = parcelRequire("3So8J");

var $bQWwW = parcelRequire("bQWwW");

var $5Ej1c = parcelRequire("5Ej1c");

const $b881d19f08db553c$var$AsyncRecommendPremiumToStandardModalComponent = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("9HXrj")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
    moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
});
const $b881d19f08db553c$export$2a43717c77dd3a56 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $5Ej1c.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
        teamName: (0, $5Ej1c.TEAM_NAME),
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $5Ej1c.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b881d19f08db553c$var$AsyncRecommendPremiumToStandardModalComponent, null)));
};

});
parcelRegister("5Ej1c", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $cada512a9167af5d$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $cada512a9167af5d$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", () => $cada512a9167af5d$export$48e1d3fa57b0a2d5);
$parcel$export(module.exports, "STARGATE_URL", () => $cada512a9167af5d$export$c7e6a6b283196232);
$parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", () => $cada512a9167af5d$export$de9f5b160db96e26);
const $cada512a9167af5d$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
const $cada512a9167af5d$export$d57b6b390e78d90f = 'growth-tako';
const $cada512a9167af5d$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
const $cada512a9167af5d$export$c7e6a6b283196232 = '/gateway/api';
const $cada512a9167af5d$export$de9f5b160db96e26 = new Map([
    [
        5,
        'prj-grace-period-recc-standard-msg-1'
    ],
    [
        3,
        'prj-grace-period-recc-standard-msg-2'
    ],
    [
        1,
        'prj-grace-period-recc-standard-msg-3'
    ]
]);

});

parcelRegister("9HXrj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9YYIE").then(()=>parcelRequire('1uyZT'));

});


parcelRegister("fp9AW", function(module, exports) {
$parcel$export(module.exports, "rovoVideoModalEntryPoint", () => $e0979c685e92cfe9$export$2f67fedc6d5555a5);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $e0979c685e92cfe9$export$2f67fedc6d5555a5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(async ()=>(parcelRequire("linUs")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
        moduleId: "3a307b00",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("linUs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cCK4e").then(()=>parcelRequire('5R9cq'));

});


parcelRegister("hMGR1", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3eaab86218c0fb0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $eS29z = parcelRequire("eS29z");

var $dZRaT = parcelRequire("dZRaT");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
/**
 * Ensures users are redirected to the correct project URL when there's a mismatch in the project key.
 * It preserves query parameters during redirection and logs the event for analytics.
 */ const $a3eaab86218c0fb0$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $eS29z.FireOperationalAnalytics), Redirect: Redirect = (0, $2mHfh.Redirect), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter) })=>{
    const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
    const projectKey = params.projectKey ?? query.projectKey;
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: projectContext } = useResource((0, $dZRaT.projectContextResource));
    if (!projectKey || !projectContext?.projectKey) return null;
    if (projectKey === projectContext.projectKey) return null;
    const search = {
        ...query,
        ...query.projectKey ? {
            projectKey: projectContext.projectKey
        } : {}
    };
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const queryString = (0, $3Q6BV.qs).stringify(search, Object.entries(search).length > 0);
    // Just a slight risk mitigation - only do the string replace if the match param is there
    const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
    const to = `${path}${queryString}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FireOperationalAnalytics, {
        eventName: "ProjectKeyRedirect loaded",
        componentName: "ProjectKeyRedirect",
        attributes: {
            location: location,
            projectContext: projectContext
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: to
    }));
};
var $a3eaab86218c0fb0$export$2e2bcd8739ae039 = $a3eaab86218c0fb0$var$ProjectKeyRedirect;

});

parcelRegister("b4mGA", function(module, exports) {
$parcel$export(module.exports, "AsyncUpflowIframeComponent", () => $d07fd6705d6948df$export$7f34679273a30171);

var $eJOHy = parcelRequire("eJOHy");

var $iWvkh = parcelRequire("iWvkh");

var $cBavF = parcelRequire("cBavF");

var $gGLWS = parcelRequire("gGLWS");

var $8PILw = parcelRequire("8PILw");
const $d07fd6705d6948df$var$entryPointParams = {};
const $d07fd6705d6948df$var$props = {};
const $d07fd6705d6948df$export$7f34679273a30171 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $gGLWS.upflowIframeComponentEntrypoint), $d07fd6705d6948df$var$entryPointParams);
    const [{ renderUpflowModal: renderUpflowModal }] = (0, $8PILw.useUpflowModal)();
    // Violating react-entrypoint/no-load-in-hooks so we can experiment faster: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (renderUpflowModal) entryPointActions.load();
    }, [
        entryPointActions,
        renderUpflowModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "issue-onboarding-modal-lazy",
        packageName: "AsyncUpflowIframeComponent",
        placeholderName: "async-upflow-iframe-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $d07fd6705d6948df$var$props
    });
};

});
parcelRegister("gGLWS", function(module, exports) {
$parcel$export(module.exports, "upflowIframeComponentEntrypoint", () => $25257faefdcca7e8$export$92c53bb1afc6d332);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $25257faefdcca7e8$export$92c53bb1afc6d332 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("27KRK")).then(({ UpflowIframeComponent: UpflowIframeComponent })=>UpflowIframeComponent), {
        moduleId: "caf60ffd",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("27KRK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jh5pY").then(()=>parcelRequire('fAnet'));

});


parcelRegister("8PILw", function(module, exports) {
$parcel$export(module.exports, "useUpflowModal", () => $6e82c436675b8525$export$7025cc2729b71e44);

var $cblKs = parcelRequire("cblKs");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

const $6e82c436675b8525$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $cblKs.FREE_EDITION)
};
const $6e82c436675b8525$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $6e82c436675b8525$var$Store = (0, $GtRbT.createStore)({
    name: (0, $9b7b66af426873ce$export$675a4427bf3750a2),
    initialState: $6e82c436675b8525$var$initialState,
    actions: $6e82c436675b8525$var$actions
});
const $6e82c436675b8525$export$6d73384be122c2dd = (0, $ht3nQ.createSubscriber)($6e82c436675b8525$var$Store);
const $6e82c436675b8525$export$e672be732bd57171 = (0, $6E16M.createContainer)($6e82c436675b8525$var$Store);
const $6e82c436675b8525$export$7025cc2729b71e44 = (0, $iJq0l.createHook)($6e82c436675b8525$var$Store);

});
const $9b7b66af426873ce$export$675a4427bf3750a2 = 'upflow-modal-store';



parcelRegister("bwRvc", function(module, exports) {
$parcel$export(module.exports, "JiraHeritageLoader", () => $5bf9aa1d151b028a$export$9499deca9933db5b);

var $eJOHy = parcelRequire("eJOHy");

var $4T9yL = parcelRequire("4T9yL");

var $avFP5 = parcelRequire("avFP5");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $hih5V = parcelRequire("hih5V");

var $kZIBu = parcelRequire("kZIBu");

var $a8PVz = parcelRequire("a8PVz");

var $6zKhT = parcelRequire("6zKhT");

var $bKAVn = parcelRequire("bKAVn");
const $5bf9aa1d151b028a$var$JiraHeritageLoaderOld = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const [{ isReady: isReady }] = (0, $kZIBu.useSpaStatePageReady)();
    const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $eJOHy.useState)(false);
    (0, $bKAVn.useWrmStatsEffects)();
    /* eslint-disable jira/wrm/no-load-bridge */ const loadJiraHeritageDependencies = (0, $eJOHy.useCallback)(()=>{
        setHasHeritageDownloaded(true);
        (0, $a8PVz.asyncWrmRequire)([
            ...(0, $avFP5.jiraSuperBatchDependencies),
            ...(0, $6zKhT.getJiraHeritageDependencies)()
        ]).then(()=>(0, $4T9yL.waitForHeritage)()?.resolve?.());
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
    }, [
        hasHeritageDownloaded,
        isReady,
        loadJiraHeritageDependencies,
        route
    ]);
    return null;
};
const $5bf9aa1d151b028a$var$JiraHeritageLoaderNew = (0, $eJOHy.Fragment);
const $5bf9aa1d151b028a$export$9499deca9933db5b = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('no-wrm-heritage-loader'), $5bf9aa1d151b028a$var$JiraHeritageLoaderNew, $5bf9aa1d151b028a$var$JiraHeritageLoaderOld);
$5bf9aa1d151b028a$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';

});
parcelRegister("a8PVz", function(module, exports) {
$parcel$export(module.exports, "asyncWrmRequire", () => $9aefac71b25b50c0$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $9aefac71b25b50c0$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $ligZL = parcelRequire("ligZL");
var $jb3ni = parcelRequire("jb3ni");
const $9aefac71b25b50c0$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $ligZL.wrmRequire)(resourcesToRequire);
const $9aefac71b25b50c0$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $jb3ni.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});

parcelRegister("6zKhT", function(module, exports) {
$parcel$export(module.exports, "getJiraHeritageDependencies", () => $539a5051f395af45$export$e8f6d7acd5817fa2);
const $539a5051f395af45$export$e8f6d7acd5817fa2 = ()=>[
        // superbatch resources
        // analytics
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        // dependencies from HeaderFooterRendering
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        // . dialog
        'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
        // overrides for AUI, styles and bridge apis
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!jira.webresources:global-static',
        // browser metrics
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        // repository shortcuts from navigation
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
        // issue view resources
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
        // create board dialog
        'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
        // old analytics library
        'wrc!com.atlassian.analytics.analytics-client:js-events',
        // frontend cache
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
        // impersonation flag (logged as someone)
        'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
        // flag displayed when there are too many emails on the instance
        'wrc!jira.webresources:spam-protection-flags',
        // in-product announcements (displayed e.g. if there is an incident)
        'wrc!com.atlassian.pas:pas-everypage-static',
        // Bento resources
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
        'wrc!com.atlassian.auiplugin:dialog2',
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
        'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
    ];

});

parcelRegister("bKAVn", function(module, exports) {
$parcel$export(module.exports, "useWrmStatsEffects", () => $948bb977c99e63f3$export$7ff53723d9d2886d);

var $eJOHy = parcelRequire("eJOHy");

var $kZIBu = parcelRequire("kZIBu");

var $3lhVL = parcelRequire("3lhVL");
const $948bb977c99e63f3$export$7ff53723d9d2886d = ()=>{
    const [{ isReady: isReady }] = (0, $kZIBu.useSpaStatePageReady)();
    const [{ transitionsCount: transitionsCount }] = (0, $3lhVL.useSpaStateTransition)();
    (0, $eJOHy.useEffect)(()=>{
        if (isReady && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        !window.__WRM_INTERNAL_STATS__.isPageInteractive) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
    }, [
        isReady
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (transitionsCount > 0) // clear stats on transition
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ = {};
    }, [
        transitionsCount
    ]);
};

});


parcelRegister("bGKoK", function(module, exports) {
$parcel$export(module.exports, "isJiraSoftware", () => $d2b6d95a40bb4ce2$export$1810b10f6a208e90);

var $FhXEJ = parcelRequire("FhXEJ");
const $d2b6d95a40bb4ce2$export$1810b10f6a208e90 = (projectType)=>projectType && projectType === (0, $FhXEJ.SOFTWARE_PROJECT);

});

parcelRegister("gsuME", function(module, exports) {
$parcel$export(module.exports, "getRovoVideoOnboardingHash", () => $3c47356d01f894fe$export$7ed5123ac12331e6);
$parcel$export(module.exports, "setRovoVideoOnboardingSeen", () => $3c47356d01f894fe$export$88c0db0edebd3404);

var $FppkK = parcelRequire("FppkK");

var $9pTd3 = parcelRequire("9pTd3");
const $3c47356d01f894fe$export$9e35978d27ff337f = 'rovoVideoPlayerSeen';
const $3c47356d01f894fe$export$7ed5123ac12331e6 = async (accountId)=>{
    try {
        return accountId != null ? (await (0, $FppkK.getUserProperty)(accountId, $3c47356d01f894fe$export$9e35978d27ff337f)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $9pTd3.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissGet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};
const $3c47356d01f894fe$export$88c0db0edebd3404 = async (accountId, hashId)=>{
    try {
        if (accountId != null) return await (0, $FppkK.setUserProperties)(accountId, $3c47356d01f894fe$export$9e35978d27ff337f, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissSet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};

});

parcelRegister("HPMxS", function(module, exports) {
$parcel$export(module.exports, "useCoordinationClient", () => $1247038ceb4cff5e$export$ddc368dc94a41e62);

var $eJOHy = parcelRequire("eJOHy");

var $9zZj0 = parcelRequire("9zZj0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $koAZ4 = parcelRequire("koAZ4");
const $1247038ceb4cff5e$export$ddc368dc94a41e62 = ()=>{
    const epMessageId = 'jira_rovo_video_modal_ga';
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const start = (0, $eJOHy.useCallback)(async ()=>{
        if (!epMessageId) return false;
        return coordinationClient.start(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    const stop = (0, $eJOHy.useCallback)(()=>{
        if (!epMessageId) return false;
        return coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        coordinationClient: coordinationClient,
        start: start,
        stop: stop
    };
};

});
parcelRegister("9zZj0", function(module, exports) {
$parcel$export(module.exports, "CoordinationClient", () => $14e1efc63586f987$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $14e1efc63586f987$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PostOfficeCoordinationComponent", () => $14e1efc63586f987$export$e7cab3fed3596222);

var $eJOHy = parcelRequire("eJOHy");

var $bx11l = parcelRequire("bx11l");

var $78ewy = parcelRequire("78ewy");

var $343k9 = parcelRequire("343k9");
var $aPN1a = parcelRequire("aPN1a");

var $5V25X = parcelRequire("5V25X");

var $7Q9YQ = parcelRequire("7Q9YQ");

var $6zxfT = parcelRequire("6zxfT");

var $bRMVI = parcelRequire("bRMVI");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $g9Vr6 = parcelRequire("g9Vr6");

var $dCptc = parcelRequire("dCptc");

var $cHtIB = parcelRequire("cHtIB");
const $14e1efc63586f987$var$isSyntheticTenant = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true';
const $14e1efc63586f987$var$getEnvironmentType = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(()=>{
    const env = (0, $dCptc.toEnvironment)((0, $hWeHP.default)('ajs-environment'));
    if (env === 'prod') return (0, $78ewy.envType).PROD;
    if (env === 'staging') return (0, $78ewy.envType).STAGING;
    return (0, $78ewy.envType).DEV;
});
class $14e1efc63586f987$export$580a2294c917898c extends (0, $aPN1a.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $bRMVI.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: $14e1efc63586f987$var$getEnvironmentType(),
            additionalData: {
                sourceProductId: (0, $7Q9YQ.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $14e1efc63586f987$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $4cTDP.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (false) // coordination clients are inactive on the server
        return false;
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $7Q9YQ.MessageDeliveryStatus).STARTED : (0, $7Q9YQ.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $7Q9YQ.MessageDeliveryStatus).STOPPED : (0, $7Q9YQ.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $7Q9YQ.MessageDeliveryStatus).STARTED : (0, $7Q9YQ.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        if (false) // coordination clients are inactive on the server
        return false;
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $7Q9YQ.MessageDeliveryStatus).STOPPED : (0, $7Q9YQ.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
/**
 * This Component passes a "stop" prop to it's children which you can call as a function in order to
 * declare that you are done with showing your message.
 * Please refer to playbook/coordination-service.md for more details.
 */ function $14e1efc63586f987$var$ClientOnlyCoordinationClientComponent(props) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6zxfT.useChoreographedStatusContext)();
    const client = (0, $eJOHy.useMemo)(()=>new $14e1efc63586f987$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor), [
        cloudId,
        isAlreadyChoreographedAtAncestor,
        orgId,
        props.messageType,
        props.onMessageDisposition,
        props.shouldAllowOnSynthetic
    ]);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $343k9.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}
function $14e1efc63586f987$export$2e2bcd8739ae039(props) {
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.fallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($14e1efc63586f987$var$ClientOnlyCoordinationClientComponent, props);
}
function $14e1efc63586f987$export$e7cab3fed3596222(props) {
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.fallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($14e1efc63586f987$export$71ce99b52dfc7610, props);
}
function $14e1efc63586f987$export$71ce99b52dfc7610({ fallback: fallback = null, children: children, messageId: messageId }) {
    const { hasMessageStarted: hasMessageStarted, requestMessageStart: requestMessageStart, dismissMessage: dismissMessage } = (0, $5V25X.usePostOfficeExernalMessageProxy)(messageId);
    (0, $eJOHy.useEffect)(()=>{
        requestMessageStart();
    }, [
        requestMessageStart,
        messageId
    ]);
    const stop = (0, $eJOHy.useCallback)(()=>{
        dismissMessage();
    }, [
        dismissMessage
    ]);
    return hasMessageStarted ? /*#__PURE__*/ (0, $eJOHy.cloneElement)(children, {
        stop: stop
    }) : fallback;
}

});


parcelRegister("lHlwJ", function(module, exports) {
$parcel$export(module.exports, "CrossJoinNudges", () => $39900d9eaea5ee9b$export$40390e43fcc876d);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $ljWHg = parcelRequire("ljWHg");

var $4mlPC = parcelRequire("4mlPC");

var $8rm4G = parcelRequire("8rm4G");

var $aL0ae = parcelRequire("aL0ae");

var $lvTzp = parcelRequire("lvTzp");

var $efQhD = parcelRequire("efQhD");

var $e1MDs = parcelRequire("e1MDs");

var $lnwEo = parcelRequire("lnwEo");

var $cGeZ5 = parcelRequire("cGeZ5");

var $b66qx = parcelRequire("b66qx");
const $39900d9eaea5ee9b$export$40390e43fcc876d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "JiraCrossJoinNudges",
        teamName: "groot",
        packageName: "jiraCrossJoinNudges"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($39900d9eaea5ee9b$var$CrossJoinNudgesWithoutErrorBoundary, null));
};
const $39900d9eaea5ee9b$export$b73ba4b3997f9abe = (execNudge = true)=>{
    const getJpdCrossJoinNudgeEligibility = (0, $aL0ae.useJpdCrossJoinNudgeEligibility)();
    const getLoomCrossJoinNudgeEligibility = (0, $b66qx.useLoomCrossJoinNudgeEligibility)();
    const getConfluenceCrossJoinNudgeEligibility = (0, $lvTzp.useConfluenceCrossJoinNudgeEligibility)();
    const showJpdNudge = (0, $efQhD.useJpdCrossJoinNudge)();
    const showLoomNudge = (0, $e1MDs.useLoomCrossJoinNudge)();
    const showConfluenceNudge = (0, $lnwEo.useConfluenceCrossJoinNudge)();
    const getLlmConfEligibility = (0, $lvTzp.useLlmConfluenceCrossJoinNudgeEligibility)();
    const getHasSeenConfLlm = (0, $lvTzp.useHasSeenConfLlm)();
    const getHasSeenNudgesBefore = (0, $b66qx.useHasSeenNudgesBefore)();
    const { fireMsrFeatureExposedEventOnce: fireMsrFeatureExposedEventOnce } = (0, $8rm4G.useMsrAnalytics)();
    const executeMSRNudge = (0, $4mlPC.useExecuteMSRNudge)();
    (0, $eJOHy.useEffect)(()=>{
        async function executeNudges({ allowLoom: allowLoom = true, allowLlm: allowLlm = true }) {
            if (allowLoom) {
                if ((0, $4cTDP.fg)('enable_puma_155_cjn_jira_loom')) {
                    const loomEligibilityResult = await getLoomCrossJoinNudgeEligibility();
                    if (loomEligibilityResult.isEligible) {
                        showLoomNudge();
                        return;
                    }
                }
            }
            const jpdEligibilityResult = await getJpdCrossJoinNudgeEligibility();
            if (jpdEligibilityResult.isEligible) {
                showJpdNudge();
                return;
            }
            const confluenceEligibilityResult = await getConfluenceCrossJoinNudgeEligibility();
            if (confluenceEligibilityResult.isEligible) showConfluenceNudge(confluenceEligibilityResult.data, allowLlm);
        }
        async function executeNudgesWithMsr() {
            if ((0, $cxKOj.expValEquals)('twcg-437-cjn-msr-m1', 'cohort', 'variation', 'not-enrolled')) {
                await (0, $cGeZ5.setEnrolledInMsr)();
                fireMsrFeatureExposedEventOnce({
                    cohort: (0, $cxKOj.expVal)('twcg-437-cjn-msr-m1', 'cohort', 'not-enrolled')
                });
                executeMSRNudge();
            } else if ((0, $cxKOj.expValEquals)('twcg-437-cjn-msr-m1', 'cohort', 'control', 'not-enrolled')) {
                await (0, $cGeZ5.setEnrolledInMsr)();
                fireMsrFeatureExposedEventOnce({
                    cohort: (0, $cxKOj.expVal)('twcg-437-cjn-msr-m1', 'cohort', 'not-enrolled')
                });
                executeNudges({
                    allowLoom: false,
                    allowLlm: false
                });
            } else executeNudges({
                allowLoom: false,
                allowLlm: false
            });
        }
        async function orchestrateNudges() {
            if ((0, $4cTDP.fg)('puma-296-cjn-orchestrator')) {
                const hasLocalStorage = await (0, $ljWHg.isLocalStorageEnabled)();
                if (!hasLocalStorage) return;
                const enrolledInMsr = await (0, $cGeZ5.getHasBeenEnrolledInMsr)();
                // User already belongs to MSR control/variation
                if (enrolledInMsr) {
                    executeNudgesWithMsr();
                    return;
                }
                const hasSeenLlm = await getHasSeenConfLlm();
                // User already has seen LLM variation
                if (hasSeenLlm) {
                    executeNudges({
                        allowLoom: false,
                        allowLlm: true
                    });
                    return;
                }
                // kill switch to prevent new users or LLM control users from being sent to LLM
                if ((0, $4cTDP.fg)('puma-296-cjn-orchestrator-llm')) {
                    const isLLMEligible = await getLlmConfEligibility();
                    // User would belong to LLM control
                    if (isLLMEligible.isEligible) {
                        executeNudges({
                            allowLoom: false,
                            allowLlm: true
                        });
                        return;
                    }
                }
                // User has seen any other nudge so they should not be part of MSR
                // User might be part of Loom variation, so they should not be part of LLM
                const isLoomGroup = await getHasSeenNudgesBefore();
                if (isLoomGroup) {
                    executeNudges({
                        allowLoom: true,
                        allowLlm: false
                    });
                    return;
                }
                // User doesn't belong in any other experiment so they should be sent to MSR control/variation
                executeNudgesWithMsr();
            } else // Default control for non-MSR experiments
            executeNudges({
                allowLlm: true,
                allowLoom: false
            });
        }
        if (execNudge) orchestrateNudges();
    }, [
        execNudge,
        getConfluenceCrossJoinNudgeEligibility,
        getHasSeenConfLlm,
        getHasSeenNudgesBefore,
        getJpdCrossJoinNudgeEligibility,
        getLlmConfEligibility,
        getLoomCrossJoinNudgeEligibility,
        showConfluenceNudge,
        showJpdNudge,
        showLoomNudge,
        executeMSRNudge,
        fireMsrFeatureExposedEventOnce
    ]);
};
const $39900d9eaea5ee9b$var$CrossJoinNudgesWithoutErrorBoundary = ()=>{
    $39900d9eaea5ee9b$export$b73ba4b3997f9abe(true);
    return null;
};
var $39900d9eaea5ee9b$export$2e2bcd8739ae039 = $39900d9eaea5ee9b$export$40390e43fcc876d;

});
parcelRegister("ljWHg", function(module, exports) {
$parcel$export(module.exports, "crossJoinNudgeVisitedCache", () => $85f3c48b465caa03$export$9e1407fde36d61e4);
$parcel$export(module.exports, "cjnEventEligibilityCache", () => $85f3c48b465caa03$export$f1ba010aac231272);
$parcel$export(module.exports, "cjnEligibilityCacheHandler", () => $85f3c48b465caa03$export$beb12117dd89482e);
$parcel$export(module.exports, "withEligibilityCache", () => $85f3c48b465caa03$export$86938f072bd79cac);
$parcel$export(module.exports, "isLocalStorageEnabled", () => $85f3c48b465caa03$export$6515f7b9b46b3e7a);
$parcel$export(module.exports, "getOrUpdateFeatureVisited", () => $85f3c48b465caa03$export$fd94e26348dead8f);
$parcel$export(module.exports, "getFeatureVisited", () => $85f3c48b465caa03$export$ee4ac5fe77f8084a);
$parcel$export(module.exports, "setFeatureVisited", () => $85f3c48b465caa03$export$7c52d8e39da481c4);
$parcel$export(module.exports, "removeFeatureVisited", () => $85f3c48b465caa03$export$fcf4f05929d7c90b);
$parcel$export(module.exports, "snoozeFeatureFor30Days", () => $85f3c48b465caa03$export$788659dbff920e5f);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $85f3c48b465caa03$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $85f3c48b465caa03$export$41554dcbb74e65ef);
$parcel$export(module.exports, "getCountCacheKey", () => $85f3c48b465caa03$export$1577cce2b8cadf);
$parcel$export(module.exports, "useSnooze", () => $85f3c48b465caa03$export$26ba987533188b38);
$parcel$export(module.exports, "setHasSeenNudgeInLast7Days", () => $85f3c48b465caa03$export$d172f6d49154a44b);
$parcel$export(module.exports, "getHasSeenNudgeInLast7Days", () => $85f3c48b465caa03$export$f03b4069dddacff6);

var $eJOHy = parcelRequire("eJOHy");

var $3hRxq = parcelRequire("3hRxq");

var $9pTd3 = parcelRequire("9pTd3");

var $e6YEs = parcelRequire("e6YEs");

var $gB3jQ = parcelRequire("gB3jQ");

var $kwi6w = parcelRequire("kwi6w");
const $85f3c48b465caa03$var$VISITED_COUNT_KEY = 'CROSS_JOIN_NUDGE_CONFLUENCE_VISITED_COUNT';
const $85f3c48b465caa03$export$afe713ceb95e80be = 'CROSS_JOIN_NUDGE_CONFLUENCE_LLM_VISITED_COUNT';
const $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $85f3c48b465caa03$export$9e1407fde36d61e4 = (0, $3hRxq.createLocalStorageProvider)('cross-join-nudge-visited');
const $85f3c48b465caa03$var$visitedKeys = {
    crossJoinNudgesConfluence: 'cross.join.nudges.confluence.visited',
    crossJoinNudgesJiraToJpd: 'cross.join.nudges.jpd.visited',
    crossJoinNudgesJiraToLoom: 'cross.join.nudges.loom.visited',
    crossJoinNudgesYourWork: 'cross.join.nudges.your.work',
    crossJoinNudgesLLMAA: 'cross.join.nudges.llm.aa',
    crossJoinNudgesMsr: 'cross.join.nudges.msr'
};
const $85f3c48b465caa03$export$f1ba010aac231272 = (0, $gB3jQ.default)({
    size: 30,
    cacheKey: 'cjn-event-eligibility-cache',
    storageType: (0, $08db7ac9f9f525e1$export$2670cb7d5d4f7184)
});
const $85f3c48b465caa03$export$ab87107a670964ea = (0, $gB3jQ.default)({
    size: 30,
    cacheKey: 'cjn-eligibility-cache',
    storageType: (0, $08db7ac9f9f525e1$export$2670cb7d5d4f7184)
});
const $85f3c48b465caa03$export$beb12117dd89482e = {
    get: (key)=>$85f3c48b465caa03$export$ab87107a670964ea.get(key),
    set: (key, value)=>$85f3c48b465caa03$export$ab87107a670964ea.set(key, value),
    remove: (key)=>$85f3c48b465caa03$export$ab87107a670964ea.remove(key)
};
function $85f3c48b465caa03$export$86938f072bd79cac(key, eligibilityCheck, daysToLive) {
    return async (...args)=>{
        try {
            const cachedValue = await $85f3c48b465caa03$export$beb12117dd89482e.get(key);
            if (cachedValue !== null && cachedValue !== undefined) {
                if (!cachedValue.ttl || cachedValue.ttl > Date.now()) return cachedValue.value;
            }
        } catch (e) {
        // cache get fail, do nothing
        }
        const result = await eligibilityCheck(...args);
        try {
            const ttlTimestamp = daysToLive !== undefined ? new Date().getTime() + $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS * daysToLive : undefined;
            await $85f3c48b465caa03$export$beb12117dd89482e.set(key, {
                value: result,
                ttl: ttlTimestamp
            });
        } catch (e) {
        // cache set fail, do nothing
        }
        return result;
    };
}
const $85f3c48b465caa03$export$6515f7b9b46b3e7a = async ()=>{
    await $85f3c48b465caa03$export$ab87107a670964ea.set('local_storage_enabled', {
        value: true
    });
    const value = await $85f3c48b465caa03$export$ab87107a670964ea.get('local_storage_enabled');
    return value?.value === true;
};
const $85f3c48b465caa03$export$fd94e26348dead8f = (keyName, snoozeForDays)=>{
    try {
        if ($85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)) return true;
        $85f3c48b465caa03$export$7c52d8e39da481c4(keyName, snoozeForDays);
        // A small cohort of users have local storage completely disabled.
        // This code detects that and always returns visited=true for those users
        if (!$85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinNudges'
                }
            });
            return true;
        }
        return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $85f3c48b465caa03$export$fcf4f05929d7c90b = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    $85f3c48b465caa03$export$9e1407fde36d61e4.remove(key);
};
const $85f3c48b465caa03$export$7c52d8e39da481c4 = (keyName, numOfDaysSnoozed)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    $85f3c48b465caa03$export$9e1407fde36d61e4.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $85f3c48b465caa03$export$7a91674e4b755c4b = (keyName)=>{
    $85f3c48b465caa03$export$7c52d8e39da481c4(keyName, 7);
};
const $85f3c48b465caa03$export$788659dbff920e5f = (keyName)=>{
    $85f3c48b465caa03$export$7c52d8e39da481c4(keyName, 30);
};
const $85f3c48b465caa03$export$ee4ac5fe77f8084a = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    const snoozeUntilTimestampString = $85f3c48b465caa03$export$9e1407fde36d61e4.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $85f3c48b465caa03$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $85f3c48b465caa03$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $kwi6w.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $85f3c48b465caa03$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $85f3c48b465caa03$var$VISITED_COUNT_KEY)=>{
    await (0, $kwi6w.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};
const $85f3c48b465caa03$export$1577cce2b8cadf = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    return `${key}.count`;
};
const $85f3c48b465caa03$export$26ba987533188b38 = (keyName)=>{
    const accountId = (0, $e6YEs.useAccountId)() || '';
    const countKey = $85f3c48b465caa03$export$1577cce2b8cadf(keyName);
    return (0, $eJOHy.useMemo)(()=>({
            snoozeFor7Days: ()=>$85f3c48b465caa03$export$7a91674e4b755c4b(keyName),
            snoozeFor30Days: ()=>$85f3c48b465caa03$export$788659dbff920e5f(keyName),
            getVisitedCount: ()=>$85f3c48b465caa03$export$64c6861c3bbd89a2(accountId, countKey),
            increaseVisitedCount: (incrementedCount)=>$85f3c48b465caa03$export$41554dcbb74e65ef(accountId, incrementedCount, countKey),
            isVisited: ()=>$85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)
        }), [
        accountId,
        countKey,
        keyName
    ]);
};
const $85f3c48b465caa03$export$d172f6d49154a44b = async ()=>{
    const DAYS_TO_CHECK = 7;
    try {
        // overwrite the key even if it exists
        await $85f3c48b465caa03$export$beb12117dd89482e.set('has_seen_nudge_in_last_7_days', {
            value: true,
            ttl: $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS * DAYS_TO_CHECK + Date.now()
        });
    } catch (e) {
    // cache set fail, do nothing
    }
};
const $85f3c48b465caa03$export$f03b4069dddacff6 = async ()=>{
    try {
        const result = await $85f3c48b465caa03$export$beb12117dd89482e.get('has_seen_nudge_in_last_7_days');
        if (result?.ttl && result.ttl > Date.now()) return true;
    } catch (e) {
    // cache get fail, return false
    }
    return false;
};

});
parcelRegister("gB3jQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $39c8bd176d4f6fa0$export$2e2bcd8739ae039);

var $h8nQy = parcelRequire("h8nQy");
const $39c8bd176d4f6fa0$var$pNothing = ()=>Promise.resolve();
const $39c8bd176d4f6fa0$var$createEntry = (config)=>{
    if (!false) {
        const Cache = (0, $h8nQy.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $39c8bd176d4f6fa0$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $39c8bd176d4f6fa0$var$pNothing,
        update: $39c8bd176d4f6fa0$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $39c8bd176d4f6fa0$var$pNothing
    };
};
var $39c8bd176d4f6fa0$export$2e2bcd8739ae039 = $39c8bd176d4f6fa0$var$createEntry;

});
parcelRegister("h8nQy", function(module, exports) {
$parcel$export(module.exports, "default", () => $286bca84ae595801$export$2e2bcd8739ae039);

var $3hRxq = parcelRequire("3hRxq");

var $8tIrO = parcelRequire("8tIrO");

var $eSnSE = parcelRequire("eSnSE");


var $8q284 = parcelRequire("8q284");
const $286bca84ae595801$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $286bca84ae595801$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $8q284.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $286bca84ae595801$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $08db7ac9f9f525e1$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $286bca84ae595801$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $08db7ac9f9f525e1$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $08db7ac9f9f525e1$export$2670cb7d5d4f7184)) storage = (0, $3hRxq.createLocalStorageProvider)((0, $8q284.CACHE_PREFIX));
        else storage = (0, $8tIrO.createSessionStorageProvider)((0, $8q284.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $08db7ac9f9f525e1$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $08db7ac9f9f525e1$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $08db7ac9f9f525e1$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $08db7ac9f9f525e1$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $eSnSE.default).safeWarnWithoutCustomerData((0, $08db7ac9f9f525e1$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $08db7ac9f9f525e1$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $08db7ac9f9f525e1$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $08db7ac9f9f525e1$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $08db7ac9f9f525e1$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $08db7ac9f9f525e1$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $08db7ac9f9f525e1$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $08db7ac9f9f525e1$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $8q284.default).scopes.current !== (0, $8q284.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $286bca84ae595801$var$cacheMap = {};
const $286bca84ae595801$var$getCache = async (props)=>{
    await (0, $8q284.scopeGuard)().catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $286bca84ae595801$var$cacheMap[cacheKey] = $286bca84ae595801$var$cacheMap[cacheKey] || new $286bca84ae595801$export$94affb487e701bf2(props);
    return $286bca84ae595801$var$cacheMap[cacheKey];
};
const $286bca84ae595801$export$710d301bf26d9700 = ()=>{
    Object.values($286bca84ae595801$var$cacheMap).forEach((cache)=>cache.clear());
};
var $286bca84ae595801$export$2e2bcd8739ae039 = $286bca84ae595801$var$getCache;

});
const $08db7ac9f9f525e1$export$7271276960377470 = 'common-cache';
const $08db7ac9f9f525e1$export$a61768fefd33fcb1 = 'capacity exceeded';
const $08db7ac9f9f525e1$export$6c4d37c7f376a1de = 'clear';
const $08db7ac9f9f525e1$export$e271b26eefe41db8 = 'update';
const $08db7ac9f9f525e1$export$4bd2facc4a3e6aa1 = 'delete';
const $08db7ac9f9f525e1$export$26d12233004a7a60 = 'delete stale entry';
const $08db7ac9f9f525e1$export$1bb358554aac31c1 = 'get';
const $08db7ac9f9f525e1$export$61f74127e2b53cbe = 'hydrate';
const $08db7ac9f9f525e1$export$5e8f180ef0142226 = 'set';
const $08db7ac9f9f525e1$export$9eb68924983e00fb = 'get entries';
const $08db7ac9f9f525e1$export$bf340b99118a1511 = 'memory';
const $08db7ac9f9f525e1$export$2670cb7d5d4f7184 = 'local';
const $08db7ac9f9f525e1$export$b796061ff0c82e1a = 'session';



parcelRegister("kwi6w", function(module, exports) {
$parcel$export(module.exports, "setUserProperty", () => $729b1eda9f96bbc5$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $729b1eda9f96bbc5$export$b3126db2ef6e34ed);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $729b1eda9f96bbc5$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $729b1eda9f96bbc5$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $729b1eda9f96bbc5$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $3ugTQ.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinNudges'
            },
            error: error
        });
    }
};
const $729b1eda9f96bbc5$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $729b1eda9f96bbc5$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $3ugTQ.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("4mlPC", function(module, exports) {
$parcel$export(module.exports, "useExecuteMSRNudge", () => $cac686abe28163b1$export$1ae8ed46ebb1741f);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $cHtIB = parcelRequire("cHtIB");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $j28Oc = parcelRequire("j28Oc");

var $d2DJQ = parcelRequire("d2DJQ");

var $ljWHg = parcelRequire("ljWHg");

var $8Ujbi = parcelRequire("8Ujbi");

var $hOhO7 = parcelRequire("hOhO7");

var $dhnSG = parcelRequire("dhnSG");

var $3gS0H = parcelRequire("3gS0H");

var $awEIK = parcelRequire("awEIK");

var $9nFEq = parcelRequire("9nFEq");

var $gEsbZ = parcelRequire("gEsbZ");

var $8rm4G = parcelRequire("8rm4G");
const $cac686abe28163b1$export$1ae8ed46ebb1741f = ()=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const cloudId = (0, $cHtIB.useCloudId)();
    const getMSRNudgeRecommendations = (0, $d2DJQ.useMSRNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const getMsrJpdCrossJoinNudgeEligibility = (0, $awEIK.useMsrJpdCrossJoinNudgeEligibility)();
    const getMsrConfluenceCrossJoinNudgeEligibility = (0, $9nFEq.useMsrConfluenceCrossJoinNudgeEligibility)();
    const { blockEligibilityUntilTomorrow: blockEligibilityUntilTomorrow, blockEligibilityToPreventRace: blockEligibilityToPreventRace, snooze: snooze } = (0, $gEsbZ.useMsrSnoozeHandler)();
    const showJpdMsrCrossJoinNudge = (0, $hOhO7.useJpdMsrCrossJoinNudge)({
        sessionId: sessionId.current
    });
    const showMsrConfluenceCrossJoinNudge = (0, $3gS0H.useMsrConfluenceCrossJoinNudge)({
        sessionId: sessionId.current
    });
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_msr_overrides');
    const { fireOnlyNewEvent: fireOnlyNewEvent } = (0, $8rm4G.useMsrAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            if (withOverrides('feature_visited_too_recently', (0, $ljWHg.getFeatureVisited)('crossJoinNudgesMsr'))) return;
            blockEligibilityToPreventRace();
            const [jpdResult, confluenceResult] = await Promise.all([
                getMsrJpdCrossJoinNudgeEligibility(),
                getMsrConfluenceCrossJoinNudgeEligibility()
            ]);
            await Promise.all([
                await fireOnlyNewEvent({
                    value: confluenceResult,
                    eventName: 'msrCjnEligibility checked',
                    key: (0, $d2DJQ.RECOMMENDATION_PRODUCT_KEYS).CONFLUENCE
                }),
                await fireOnlyNewEvent({
                    value: jpdResult,
                    eventName: 'msrCjnEligibility checked',
                    key: (0, $d2DJQ.RECOMMENDATION_PRODUCT_KEYS).JPD
                })
            ]);
            if (!confluenceResult.isEligible && !jpdResult.isEligible) return;
            const recommendations = await getMSRNudgeRecommendations();
            const nudgeKeys = [
                (0, $d2DJQ.RECOMMENDATION_PRODUCT_KEYS).CONFLUENCE,
                (0, $d2DJQ.RECOMMENDATION_PRODUCT_KEYS).JPD
            ];
            if (recommendations.filter((rec)=>nudgeKeys.includes(rec)).length <= 0) {
                blockEligibilityUntilTomorrow();
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'msrCjnEligibility blocked', {
                    reason: 'no recommendations'
                });
                return;
            }
            for (const recommendation of recommendations)switch(recommendation){
                case (0, $d2DJQ.RECOMMENDATION_PRODUCT_KEYS).JPD:
                    if (jpdResult.isEligible) {
                        snooze();
                        return showJpdMsrCrossJoinNudge({
                            recommendations: recommendations
                        });
                    }
                    break;
                case (0, $d2DJQ.RECOMMENDATION_PRODUCT_KEYS).CONFLUENCE:
                    if (confluenceResult.isEligible) {
                        snooze();
                        return showMsrConfluenceCrossJoinNudge({
                            recommendations: recommendations
                        });
                    }
                    break;
                default:
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof (0, $j28Oc.RecommendationError)) (0, $8Ujbi.fireErrorAnalytics)('recommendationMsrFetchFailed', error.options.cause, {
                cloudId: cloudId
            });
            else (0, $8Ujbi.fireErrorAnalytics)('executeMSRNudge', error, {
                cloudId: cloudId
            });
            blockEligibilityUntilTomorrow();
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'msrCjnEligibility blocked', {
                reason: 'unexpected error'
            });
        }
    }, [
        cloudId,
        getMsrJpdCrossJoinNudgeEligibility,
        getMsrConfluenceCrossJoinNudgeEligibility,
        getMSRNudgeRecommendations,
        blockEligibilityToPreventRace,
        blockEligibilityUntilTomorrow,
        showJpdMsrCrossJoinNudge,
        showMsrConfluenceCrossJoinNudge,
        withOverrides,
        snooze,
        fireOnlyNewEvent,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("j28Oc", function(module, exports) {
$parcel$export(module.exports, "RecommendationError", () => $7a992d06b8c894bc$export$f6f4711ce6617505);

var $eJOHy = parcelRequire("eJOHy");

var $hHVGs = parcelRequire("hHVGs");
const $7a992d06b8c894bc$var$SNOOZE_INTERVALS = {
    0: 7,
    1: 14,
    2: 30,
    3: 90
};
const $7a992d06b8c894bc$export$929578679169c83e = ({ setFeatureVisited: setFeatureVisited, getFeatureVisitedCount: getFeatureVisitedCount, setFeatureVisitedCount: setFeatureVisitedCount })=>{
    const blockEligibilityToPreventRace = (0, $eJOHy.useCallback)(()=>{
        setFeatureVisited(0.1);
    }, [
        setFeatureVisited
    ]);
    const blockEligibilityUntilTomorrow = (0, $eJOHy.useCallback)(()=>{
        setFeatureVisited(1);
    }, [
        setFeatureVisited
    ]);
    const snooze = (0, $eJOHy.useCallback)(()=>{
        const visitedCount = getFeatureVisitedCount();
        // We are going to loop the last nudge indefinitely
        const loopedVisitedCount = Math.min(visitedCount, Object.keys($7a992d06b8c894bc$var$SNOOZE_INTERVALS).length - 1);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const snoozeInterval = $7a992d06b8c894bc$var$SNOOZE_INTERVALS[loopedVisitedCount];
        setFeatureVisited(snoozeInterval);
        setFeatureVisitedCount(visitedCount + 1);
    }, [
        setFeatureVisited,
        setFeatureVisitedCount,
        getFeatureVisitedCount
    ]);
    return {
        snooze: snooze,
        blockEligibilityUntilTomorrow: blockEligibilityUntilTomorrow,
        blockEligibilityToPreventRace: blockEligibilityToPreventRace
    };
};
const $7a992d06b8c894bc$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudgeFlags';
class $7a992d06b8c894bc$export$f6f4711ce6617505 extends Error {
    constructor(message, options){
        super(message);
        this.name = 'RecommendationError';
        this.options = options;
    }
}
function $7a992d06b8c894bc$export$e87e269d0f71e3a3({ product: product, sessionId: sessionId, cloudId: cloudId, subProduct: subProduct }) {
    const contextResolver = (0, $eJOHy.useCallback)(()=>({
            product: product,
            useCase: $7a992d06b8c894bc$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        product,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $hHVGs.default)({
        contextResolver: contextResolver
    });
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const result = await getRecommendations({
                first: 4,
                config: {
                    cacheConfig: {
                        ttl: 86400
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            const recommendedEntities = (data ?? []).map((e)=>e.entityId);
            return recommendedEntities;
        } catch (error) {
            let cause;
            if (error instanceof Error) cause = error;
            else if (error && error.reason) cause = new Error(error.reason);
            else cause = new Error(String(error));
            throw new $7a992d06b8c894bc$export$f6f4711ce6617505('Get MSR nudge recommendations error', {
                cause: cause
            });
        }
    }, [
        getRecommendations
    ]);
}

});
parcelRegister("hHVGs", function(module, exports) {
$parcel$export(module.exports, "default", () => $405b3c6526c7594e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $1PLEg = parcelRequire("1PLEg");

var $9F0Vk = parcelRequire("9F0Vk");

var $7AM4Y = parcelRequire("7AM4Y");

var $8C3HN = parcelRequire("8C3HN");
const $405b3c6526c7594e$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
	 * Fetch recommendations for a given context
	 */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $9F0Vk.default)(endpoint);
        const requester = new (0, $8C3HN.default)(new (0, $7AM4Y.RecommendationsRequestBroker)());
        const context = (0, $1PLEg.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $c3708eaddcf34d7d$export$14b7e2c312f27acd),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $405b3c6526c7594e$export$2e2bcd8739ae039 = $405b3c6526c7594e$var$useRecommendations;

});
// Events
const $c3708eaddcf34d7d$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $c3708eaddcf34d7d$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $c3708eaddcf34d7d$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $c3708eaddcf34d7d$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $c3708eaddcf34d7d$export$14b7e2c312f27acd = 'atlassian-growth-recos';

parcelRegister("1PLEg", function(module, exports) {
$parcel$export(module.exports, "isNotEmpty", () => $4c80191cf3e6dc8f$export$a079a83b07f794bf);
$parcel$export(module.exports, "getContext", () => $4c80191cf3e6dc8f$export$31553aaa555c1514);
function $4c80191cf3e6dc8f$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $4c80191cf3e6dc8f$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}

});

parcelRegister("9F0Vk", function(module, exports) {
$parcel$export(module.exports, "default", () => $10f2734089221f6c$export$2e2bcd8739ae039);

var $9wJFl = parcelRequire("9wJFl");
class $10f2734089221f6c$export$2e2bcd8739ae039 extends (0, $9wJFl.default) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $10f2734089221f6c$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
const $10f2734089221f6c$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;

});
parcelRegister("9wJFl", function(module, exports) {
$parcel$export(module.exports, "default", () => $64bcb20502bd499f$export$2e2bcd8739ae039);

var $1PLEg = parcelRequire("1PLEg");
class $64bcb20502bd499f$export$2e2bcd8739ae039 {
    constructor(endpoint){
        this.endpoint = endpoint;
    }
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $1PLEg.getContext)(contextResolver);
    }
}

});


parcelRegister("7AM4Y", function(module, exports) {
$parcel$export(module.exports, "RecommendationsRequestBroker", () => $1c4f57337f3932fd$export$7f19312509e0d2c0);

var $ggERV = parcelRequire("ggERV");
class $1c4f57337f3932fd$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $ggERV.RecommendationSuccessResultCreator)(response, result);
    }
}

});
parcelRegister("ggERV", function(module, exports) {
$parcel$export(module.exports, "RecommendationSuccessResultCreator", () => $1625660651dd0899$export$c02f0b31b3b527a3);

var $4M58U = parcelRequire("4M58U");
class $1625660651dd0899$export$c02f0b31b3b527a3 extends (0, $4M58U.QuerySuccessResultCreator) {
    constructor(response, data){
        super(response, data), this.response = response;
    }
    makeQueryResult() {
        return new (0, $4M58U.GraphQlQueryResult)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
}

});
parcelRegister("4M58U", function(module, exports) {
$parcel$export(module.exports, "GraphQlQueryResult", () => $cc060a79151a39e1$export$d0a1abfd57dc5018);
$parcel$export(module.exports, "NonOkQueryResultCreator", () => $cc060a79151a39e1$export$ad7cb7f4450dd7c4);
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", () => $cc060a79151a39e1$export$553722ecbbe27276);
$parcel$export(module.exports, "MissingQueryDataResultCreator", () => $cc060a79151a39e1$export$ff264bfdc9a404eb);
$parcel$export(module.exports, "QuerySuccessResultCreator", () => $cc060a79151a39e1$export$6b16771e962990ff);
class $cc060a79151a39e1$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $cc060a79151a39e1$var$QueryResultCreator {
}
class $cc060a79151a39e1$export$ad7cb7f4450dd7c4 extends $cc060a79151a39e1$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $cc060a79151a39e1$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
}
class $cc060a79151a39e1$export$553722ecbbe27276 extends $cc060a79151a39e1$var$QueryResultCreator {
    constructor(errors){
        super(), this.errors = errors;
    }
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $cc060a79151a39e1$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
}
class $cc060a79151a39e1$export$ff264bfdc9a404eb extends $cc060a79151a39e1$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $cc060a79151a39e1$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
}
class $cc060a79151a39e1$export$6b16771e962990ff extends $cc060a79151a39e1$var$QueryResultCreator {
    constructor(response, data){
        super(), this.response = response, this.data = data;
    }
}

});



parcelRegister("8C3HN", function(module, exports) {
$parcel$export(module.exports, "default", () => $61fe69f3ee0709ae$export$2e2bcd8739ae039);

var $4M58U = parcelRequire("4M58U");

var $1nHnU = parcelRequire("1nHnU");
class $61fe69f3ee0709ae$export$2e2bcd8739ae039 {
    constructor(broker){
        this.broker = broker;
    }
    /**
	 * Fetches the response by the given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The query result
	 */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $4M58U.NonOkQueryResultCreator)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $4M58U.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $4M58U.MissingQueryDataResultCreator)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
	 * Fetches the response by tha given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The response from the request
	 */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $1nHnU.default).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
}

});
parcelRegister("1nHnU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1666126abcaa1a03$export$2e2bcd8739ae039);

var $drdt6 = parcelRequire("drdt6");

var $6f9Ri = parcelRequire("6f9Ri");
class $1666126abcaa1a03$export$2e2bcd8739ae039 {
    /**
	 * Returns the cache provider based on the given cache configuration
	 *
	 * @param cacheConfig The cache configuration to use
	 * @returns The cache provider
	 */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $6f9Ri.default)(cacheConfig);
        return new (0, $drdt6.default)();
    }
}

});
parcelRegister("drdt6", function(module, exports) {
$parcel$export(module.exports, "default", () => $60050371afd45aa8$export$2e2bcd8739ae039);
class $60050371afd45aa8$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}

});

parcelRegister("6f9Ri", function(module, exports) {
$parcel$export(module.exports, "default", () => $e402bd553ca90c06$export$2e2bcd8739ae039);

var $e0GN8 = parcelRequire("e0GN8");

var $fJj8V = parcelRequire("fJj8V");
class $e402bd553ca90c06$export$2e2bcd8739ae039 {
    /**
	 * Initialise the WebCacheStorage
	 * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
	 * @param onError a callback when any error occurs
	 */ constructor(cacheProviderConfig){
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $e0GN8.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $fJj8V.default)(this.cacheConfig);
    }
    /**
	 * Get cached response
	 */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Put response in cache
	 */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Delete cached response
	 */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
	 * Check if the cached response is expired
	 */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
	 * Compose the URL and the use case as the search params to cache the response
	 */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
	 * Get the key to store the response
	 * Interally, it hashes the request body to get a unique key
	 */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
}

});
parcelRegister("e0GN8", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec8dc52d6f940f42$export$2e2bcd8739ae039);
const $ec8dc52d6f940f42$var$DEFAULT_TTL = 60;
class $ec8dc52d6f940f42$export$2e2bcd8739ae039 {
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $ec8dc52d6f940f42$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
}

});

parcelRegister("fJj8V", function(module, exports) {
$parcel$export(module.exports, "default", () => $e058fb0a0acac364$export$2e2bcd8739ae039);
class $e058fb0a0acac364$export$2e2bcd8739ae039 {
    /**
	 * Initialise the ExpiryStorage
	 */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
    /**
	 * Set the expiry date of the cached response
	 */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Get the expiry date of the cached response
	 */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Initialise the IndexedDB
	 */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
	 * Get the object store from the IndexedDB
	 */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
}

});






parcelRegister("d2DJQ", function(module, exports) {
$parcel$export(module.exports, "RECOMMENDATION_PRODUCT_KEYS", () => $8279b568d170b0bc$export$251abdbabfa5e180);
$parcel$export(module.exports, "useNudgeRecommendations", () => $8279b568d170b0bc$export$20e6812ba5f3fc39);
$parcel$export(module.exports, "useMSRNudgeRecommendations", () => $8279b568d170b0bc$export$e87e269d0f71e3a3);

var $eJOHy = parcelRequire("eJOHy");

var $hHVGs = parcelRequire("hHVGs");

var $9pTd3 = parcelRequire("9pTd3");

var $figsJ = parcelRequire("figsJ");

var $cHtIB = parcelRequire("cHtIB");

var $j28Oc = parcelRequire("j28Oc");

var $5QB52 = parcelRequire("5QB52");
const $8279b568d170b0bc$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudge';
const $8279b568d170b0bc$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudgeFlags';
const $8279b568d170b0bc$export$251abdbabfa5e180 = {
    JPD: 'cjn-jira-jpd',
    CONFLUENCE: 'cjn-jira-conf-v2'
};
function $8279b568d170b0bc$export$20e6812ba5f3fc39({ sessionId: sessionId }) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const contextResolver = (0, $eJOHy.useCallback)(()=>({
            product: 'jira',
            useCase: $8279b568d170b0bc$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $hHVGs.default)({
        contextResolver: contextResolver
    });
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const result = await getRecommendations(1, $8279b568d170b0bc$var$asEntityIdList((0, $5QB52.EntityList)));
            const { response: { data: data } = {} } = result;
            // This type assertion is necessary because useRecommendations don't support generic entityId
            const recommendedEntityId = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data && data.length > 0 && data[0].entityId || undefined;
            return recommendedEntityId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'recommendationFetchFailed',
                    packageName: 'jiraCrossJoinNudges',
                    teamName: 'groot-growth'
                },
                error: error
            });
            throw new Error('Get nudge recommendations error');
        }
    }, [
        getRecommendations
    ]);
}
function $8279b568d170b0bc$export$e87e269d0f71e3a3({ sessionId: sessionId }) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const contextResolver = (0, $eJOHy.useCallback)(()=>({
            product: 'jira',
            useCase: $8279b568d170b0bc$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $hHVGs.default)({
        contextResolver: contextResolver
    });
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const result = await getRecommendations({
                first: 4,
                config: {
                    cacheConfig: {
                        ttl: 86400
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            const recommendedEntities = (data ?? []).map((e)=>e.entityId);
            return recommendedEntities;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            let cause;
            if (error instanceof Error) cause = error;
            else if (error && error.reason) cause = new Error(error.reason);
            else cause = new Error(String(error));
            throw new (0, $j28Oc.RecommendationError)('Get MSR nudge recommendations error', {
                cause: cause
            });
        }
    }, [
        getRecommendations
    ]);
}
const $8279b568d170b0bc$var$asEntityIdList = (entities)=>entities.map((entity)=>({
            entityId: entity
        }));

});
parcelRegister("5QB52", function(module, exports) {
$parcel$export(module.exports, "EntityList", () => $b173ac9c27d8f86f$export$8bb466c13870163e);
$parcel$export(module.exports, "getDynamicMessages", () => $b173ac9c27d8f86f$export$b916a1b5c615f6eb);

var $cxKOj = parcelRequire("cxKOj");

var $6Jmsm = parcelRequire("6Jmsm");
const $b173ac9c27d8f86f$export$8bb466c13870163e = [
    'nudgeCandidate01',
    'nudgeCandidate02',
    'nudgeCandidate03',
    'nudgeCandidate04',
    'nudgeCandidate05',
    'nudgeCandidate06',
    'nudgeCandidate07'
];
const $b173ac9c27d8f86f$var$messageVariantsKeyMap = {
    default: {
        title: 'title',
        description: 'description',
        joinButton: 'joinButton'
    },
    nudgeCandidate01: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04: {
        title: 'titleNudgeCandidate04',
        description: 'descriptionNudgeCandidate04',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05: {
        title: 'titleNudgeCandidate05',
        description: 'descriptionNudgeCandidate05',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07',
        joinButton: 'joinButtonNudgeCandidate07'
    },
    defaultGalaxia: {
        title: 'title',
        description: 'descriptionGalaxia',
        joinButton: 'joinButton'
    },
    nudgeCandidate01Galaxia: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01Galaxia',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02Galaxia: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03Galaxia: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03Galaxia',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04Galaxia: {
        title: 'titleNudgeCandidate04Galaxia',
        description: 'descriptionNudgeCandidate04Galaxia',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05Galaxia: {
        title: 'titleNudgeCandidate05Galaxia',
        description: 'descriptionNudgeCandidate05Galaxia',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06Galaxia: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07Galaxia: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07Galaxia',
        joinButton: 'joinButtonNudgeCandidate07'
    }
};
const $b173ac9c27d8f86f$export$b916a1b5c615f6eb = (isContextualBandit, entityId)=>{
    // Handle case when entityId is unexpected
    if (!(entityId in $b173ac9c27d8f86f$var$messageVariantsKeyMap)) return undefined;
    // If v2B is not enabled we just passthrough default message keys
    const usedEntityId = isContextualBandit ? entityId : 'default';
    // if experiment is enabled and usedEntityIdGalaxia exists then use it
    // else use the usedEntityId
    const entityIdToUse = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? `${usedEntityId}Galaxia` : usedEntityId;
    const titleKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[entityIdToUse].title;
    const descriptionKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[entityIdToUse].description;
    const joinButtonKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[entityIdToUse].joinButton;
    return {
        title: (0, $6Jmsm.messages)[titleKey],
        description: (0, $6Jmsm.messages)[descriptionKey],
        joinButton: (0, $6Jmsm.messages)[joinButtonKey]
    };
};

});
parcelRegister("6Jmsm", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2515efbbf3bb8f39$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2515efbbf3bb8f39$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title",
        "defaultMessage": "Your team is now using Confluence"
    },
    titleNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01",
        "defaultMessage": "Join your teammates in Confluence"
    },
    titleNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02",
        "defaultMessage": "Collaborate together in Confluence"
    },
    titleNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03",
        "defaultMessage": "Your team is working in Confluence"
    },
    titleNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04",
        "defaultMessage": "Unify your projects in Confluence"
    },
    titleNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05",
        "defaultMessage": "Bring projects together in Confluence"
    },
    titleNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06",
        "defaultMessage": "Create a single source of truth"
    },
    titleNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07",
        "defaultMessage": "Create a single source of truth"
    },
    description: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    descriptionNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01",
        "defaultMessage": "Create a single source of truth for project decisions and software documentation."
    },
    descriptionNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02",
        "defaultMessage": "Capture, consolidate, and share team knowledge, in one centralized place."
    },
    descriptionNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03",
        "defaultMessage": "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04",
        "defaultMessage": "Organize project information and sync it to Jira tasks to track and hit your goals faster."
    },
    descriptionNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05",
        "defaultMessage": "Capture information in project pages and sync to Jira tasks to track your milestones."
    },
    descriptionNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06",
        "defaultMessage": "Consolidate information in one place and sync to Jira tasks for automatic updates."
    },
    descriptionNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07",
        "defaultMessage": "Join your team in Confluence to consolidate project information in one place."
    },
    joinButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button",
        "defaultMessage": "Join your team"
    },
    joinButtonLlmGeneratedV2: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-llm-generated-v2",
        "defaultMessage": "Join your team in Confluence"
    },
    remindMeLaterButtonLlmGeneratedV2: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button-llm-generated-v2",
        "defaultMessage": "Later"
    },
    joinButtonNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07",
        "defaultMessage": "Join Confluence"
    },
    remindMeLaterButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button",
        "defaultMessage": "Remind me later"
    },
    notInterestedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.not-interested-button",
        "defaultMessage": "Not interested"
    },
    urgencyTitle: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.urgency-title",
        "defaultMessage": "{viewCount, select, 0 {Your team is now using Confluence} 1 {Your team is working in Confluence} other {Your team is waiting for you in Confluence}}"
    },
    titleJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-jpd-nudge",
        "defaultMessage": "Join your team in using Jira Product Discovery"
    },
    descriptionJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-jpd-nudge",
        "defaultMessage": "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
    },
    titleLoomNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-loom-nudge",
        "defaultMessage": "Join your team on Loom"
    },
    descriptionLoomNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge",
        "defaultMessage": "Use Loom videos to record your screen, demos, and reviews."
    },
    descriptionLoomNudgeWithOneCollaborator: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-one-collaborators",
        "defaultMessage": "{collaboratorOne} is using Loom videos to record their screen, demos, and reviews."
    },
    descriptionLoomNudgeWithTwoCollaborators: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-two-collaborators",
        "defaultMessage": "{collaboratorOne} and {collaboratorTwo} are using Loom videos to record their screen, demos, and reviews."
    },
    descriptionLoomNudgeWithMoreThanTwoCollaborators: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-more-than-two-collaborators",
        "defaultMessage": "{collaboratorOne} and {collaboratorCount} others are using Loom videos to record their screen, demos, and reviews."
    },
    getStartedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.get-started-button",
        "defaultMessage": "Get started"
    },
    doNotShowAgainButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.do-not-show-again-button",
        "defaultMessage": "Don't show again"
    },
    titleNudgeCandidate04Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04-galaxia",
        "defaultMessage": "Unify your Jira spaces in Confluence"
    },
    titleNudgeCandidate05Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05-galaxia",
        "defaultMessage": "Bring Jira spaces together in Confluence"
    },
    descriptionGalaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-galaxia",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira spaces."
    },
    descriptionNudgeCandidate01Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01-galaxia",
        "defaultMessage": "Create a single source of truth for decisions and documentation."
    },
    descriptionNudgeCandidate03Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03-galaxia",
        "defaultMessage": "Create pages to build a shared understanding for better decision-making."
    },
    descriptionNudgeCandidate04Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04-galaxia",
        "defaultMessage": "Organize information and sync it to Jira work items to track and hit your goals faster."
    },
    descriptionNudgeCandidate05Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05-galaxia",
        "defaultMessage": "Capture information in pages and sync to Jira work items to track your milestones."
    },
    descriptionNudgeCandidate07Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07-galaxia",
        "defaultMessage": "Join your team in Confluence to consolidate information in one place."
    }
});

});



parcelRegister("8Ujbi", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $499c57cf6f6c3e89$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "fireSiteOptedOutAnalytics", () => $499c57cf6f6c3e89$export$b6a30d1aef42926f);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");
const $499c57cf6f6c3e89$export$a27c21aa3ed8f0f1 = (id, error, attributes = {})=>(0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: id,
            packageName: 'jiraCrossJoinNudges',
            teamName: 'puma'
        },
        attributes: attributes,
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
const $499c57cf6f6c3e89$export$b6a30d1aef42926f = (createAnalyticsEvent, integration)=>{
    (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
        flagKey: 'NON_CONTEXTUAL_CJNS',
        ineligibilityReason: 'SITE_OPTED_OUT',
        integration: integration
    });
};

});

parcelRegister("hOhO7", function(module, exports) {
$parcel$export(module.exports, "useJpdMsrCrossJoinNudge", () => $aabff5965eb19c36$export$2c32fd73409bafb7);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $83DiZ = parcelRequire("83DiZ");

var $2zVtv = parcelRequire("2zVtv");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $cYLBX = parcelRequire("cYLBX");

var $ct7dg = parcelRequire("ct7dg");

var $hgSiz = parcelRequire("hgSiz");

var $1p1B7 = parcelRequire("1p1B7");

var $ljWHg = parcelRequire("ljWHg");

var $d2DJQ = parcelRequire("d2DJQ");
const $aabff5965eb19c36$var$MAX_NUMBER_OF_JPD_COLLABORATORS = 10;
const $aabff5965eb19c36$var$CROSS_JOIN_NUDGES_JIRA_TO_JPD_INTEGRATION = 'crossJoinNudgesJiraToJpd';
const $aabff5965eb19c36$export$2c32fd73409bafb7 = ({ sessionId: sessionId })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const currentProduct = (0, $2zVtv.useCurrentProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'jira-product-discovery', $aabff5965eb19c36$var$MAX_NUMBER_OF_JPD_COLLABORATORS);
    const showMsrRequestAccessPromptFlag = (0, $1p1B7.useMsrRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $hgSiz.useMsrRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $ct7dg.useMsrRequestAccessErrorFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    return (0, $eJOHy.useCallback)(async ({ recommendations: recommendations })=>{
        try {
            const collaboratorsOnJpd = await getFilteredCollaborators();
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $iaIqW.requestAccess)('jira-product-discovery', currentProduct, cloudId, userId, 'crossJoinNudgesJiraToJpd', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/jira/projects');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('jira-product-discovery');
                } catch  {
                    showErrorFlag('jira-product-discovery');
                }
            };
            showMsrRequestAccessPromptFlag({
                users: collaboratorsOnJpd,
                onSubmit: onSubmit,
                targetProduct: 'jira-product-discovery',
                integration: $aabff5965eb19c36$var$CROSS_JOIN_NUDGES_JIRA_TO_JPD_INTEGRATION,
                eventAttributes: (0, $1p1B7.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnJpd,
                    integration: $aabff5965eb19c36$var$CROSS_JOIN_NUDGES_JIRA_TO_JPD_INTEGRATION,
                    recommendationSessionId: sessionId,
                    nudgeId: (0, $d2DJQ.RECOMMENDATION_PRODUCT_KEYS).JPD,
                    recommendations: recommendations
                })
            });
            // this is used in the eligibility check for loom nudge
            await (0, $ljWHg.setHasSeenNudgeInLast7Days)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('showMsrNudge', error, {
                cloudId: cloudId,
                targetProduct: 'jira-product-discovery',
                integration: $aabff5965eb19c36$var$CROSS_JOIN_NUDGES_JIRA_TO_JPD_INTEGRATION
            });
        }
    }, [
        cloudId,
        currentProduct,
        createAnalyticsEvent,
        getFilteredCollaborators,
        push,
        showErrorFlag,
        showMsrRequestAccessPromptFlag,
        showSuccessFlag,
        userId,
        sessionId
    ]);
};

});
parcelRegister("2zVtv", function(module, exports) {
$parcel$export(module.exports, "isConfluenceLink", () => $1daf1eedbdaa21d6$export$313baaa1c3261c49);
$parcel$export(module.exports, "getAllLinks", () => $1daf1eedbdaa21d6$export$776644da31ab517e);
$parcel$export(module.exports, "getAllProductLinks", () => $1daf1eedbdaa21d6$export$577f918d7821fd77);
$parcel$export(module.exports, "generateId", () => $1daf1eedbdaa21d6$export$567fc7097e064344);
$parcel$export(module.exports, "clampString", () => $1daf1eedbdaa21d6$export$96ce25bdd1856c70);
$parcel$export(module.exports, "getProductDisplayName", () => $1daf1eedbdaa21d6$export$44fea6589b7ddc92);
$parcel$export(module.exports, "getSiteAri", () => $1daf1eedbdaa21d6$export$792aeacb7990bc6);
$parcel$export(module.exports, "useCurrentProduct", () => $1daf1eedbdaa21d6$export$495654df2a5da4a0);

var $0mclG = parcelRequire("0mclG");


var $gtr2v = parcelRequire("gtr2v");

var $2aY2d = parcelRequire("2aY2d");
const $1daf1eedbdaa21d6$export$69caceff42c0da80 = {
    [(0, $315aedf92e50a945$export$c811f21c9ad05dc2)]: 'Confluence'
};
const $1daf1eedbdaa21d6$export$fadb677f87088e11 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 0, $315aedf92e50a945$export$1346c9aa3cbb477d;
        case 'service_desk':
            return 0, $315aedf92e50a945$export$c8c1c8c3f8ddba61;
        case 'business':
            return 0, $315aedf92e50a945$export$db515c8cec1e6f79;
        case 'product_discovery':
            return 0, $315aedf92e50a945$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $1daf1eedbdaa21d6$var$getProductFromSubproduct = (subproduct)=>{
    switch(subproduct){
        case 'software':
        case 'jira_software':
            return 0, $315aedf92e50a945$export$1346c9aa3cbb477d;
        case 'servicedesk':
        case 'jira_service_management':
            return 0, $315aedf92e50a945$export$c8c1c8c3f8ddba61;
        case 'core':
        case 'jira_work_management':
            return 0, $315aedf92e50a945$export$db515c8cec1e6f79;
        case 'polaris':
        case 'jira_product_discovery':
            return 0, $315aedf92e50a945$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $1daf1eedbdaa21d6$export$313baaa1c3261c49 = (url, cloudName)=>{
    if (!url || !cloudName) return false;
    const regex = new RegExp(`^https?://${cloudName}.atlassian.net/wiki(?!/external)`);
    return regex.test(url);
};
const $1daf1eedbdaa21d6$export$776644da31ab517e = (doc)=>{
    const links = new Set();
    const handleLink = (link)=>{
        link && links.add(link);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>handleLink(node.attrs?.url);
    (0, $0mclG.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
const $1daf1eedbdaa21d6$var$getSmartLinkData = (cloudId, details)=>{
    if (!details) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { name: name } = details.data;
    const { tenantId: tenantId, subproduct: subproduct } = details.meta;
    let { product: product } = details.meta;
    if (tenantId !== cloudId) return;
    product = product === 'jira' ? $1daf1eedbdaa21d6$var$getProductFromSubproduct(subproduct) : product;
    if (!Object.keys($1daf1eedbdaa21d6$export$69caceff42c0da80).includes(product)) return;
    return {
        name: name,
        tenantId: tenantId,
        product: product
    };
};
const $1daf1eedbdaa21d6$export$577f918d7821fd77 = (doc, store, cloudId, cloudName)=>{
    const links = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>{
        // Check URL is on the ADF node
        const { url: url } = node?.attrs;
        if (!url) return;
        // Check URL is in the Smart Links Store
        const details = store.getState()[url]?.details;
        const data = $1daf1eedbdaa21d6$var$getSmartLinkData(cloudId, details);
        if (data) links[url] = data;
    };
    const handleRawConfluenceLink = (url)=>{
        if ($1daf1eedbdaa21d6$export$313baaa1c3261c49(url, cloudName)) links[url] = {
            tenantId: cloudId,
            product: (0, $315aedf92e50a945$export$c811f21c9ad05dc2)
        };
    };
    (0, $0mclG.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleRawConfluenceLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
let $1daf1eedbdaa21d6$var$id = 0;
const $1daf1eedbdaa21d6$export$567fc7097e064344 = ()=>{
    $1daf1eedbdaa21d6$var$id += 1;
    return String($1daf1eedbdaa21d6$var$id);
};
const $1daf1eedbdaa21d6$export$96ce25bdd1856c70 = (string, maxLength)=>{
    if (string.length > maxLength) return string.slice(0, maxLength).concat('...');
    return string;
};
const $1daf1eedbdaa21d6$export$44fea6589b7ddc92 = (product)=>$1daf1eedbdaa21d6$export$69caceff42c0da80[product];
const $1daf1eedbdaa21d6$export$792aeacb7990bc6 = (tenantId, product)=>(0, $gtr2v.AnyAri).create({
        resourceOwner: product,
        resourceType: 'site',
        resourceId: tenantId
    }).toString();
const $1daf1eedbdaa21d6$export$495654df2a5da4a0 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return $1daf1eedbdaa21d6$export$fadb677f87088e11(data?.projectType) || (0, $315aedf92e50a945$export$1346c9aa3cbb477d);
};

});
parcelRegister("0mclG", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $9495d7eb76b80944$export$df3f009e3d155b20);
function $9495d7eb76b80944$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $9495d7eb76b80944$export$df3f009e3d155b20(adf, visitors) {
    if (!$9495d7eb76b80944$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $9495d7eb76b80944$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $9495d7eb76b80944$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $9495d7eb76b80944$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("iaIqW", function(module, exports) {
$parcel$export(module.exports, "requestAccess", () => $63e38b087ccad084$export$cd9e5995821603e1);

var $hgi0g = parcelRequire("hgi0g");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");

var $8Ujbi = parcelRequire("8Ujbi");
const $63e38b087ccad084$var$URL = '/gateway/api/invitations/v1/access-requests/request';
const $63e38b087ccad084$export$cd9e5995821603e1 = async (product, sourceProduct, cloudId, userId, integration, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    try {
        const response = await (0, $hgi0g.default)($63e38b087ccad084$var$URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...(0, $4cTDP.fg)('cross-join-touchpoint-metadata') && {
                    metadata: {
                        touchpoint: 'Crossjoin Nudge',
                        sourceProduct: sourceProduct
                    }
                }
            })
        });
        const { results: results } = response;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration
        };
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $8Ujbi.fireErrorAnalytics)(integration, error);
        throw new Error(`${integration} request access error`);
    }
};

});

parcelRegister("cYLBX", function(module, exports) {
$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $92c00d70753dc437$export$b05786e1a14be004);
$parcel$export(module.exports, "useFilteredUsersFromCollaborationGraph", () => $92c00d70753dc437$export$4509f086e4a8422);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $koAZ4 = parcelRequire("koAZ4");

var $8NEWZ = parcelRequire("8NEWZ");
const $92c00d70753dc437$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $92c00d70753dc437$export$b05786e1a14be004 = (cloudId)=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $koAZ4.useTenantContext)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $92c00d70753dc437$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $3ugTQ.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined && en.userProfile?.account_type !== 'app' && en.userProfile?.account_status !== 'deactivated' && en.userProfile?.account_status !== 'deleted').map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};
const $92c00d70753dc437$export$4509f086e4a8422 = (cloudId, targetProduct, maxCollaborators)=>{
    const getCollaborators = $92c00d70753dc437$export$b05786e1a14be004(cloudId);
    return (0, $eJOHy.useCallback)(async ()=>{
        const collaborators = await getCollaborators();
        let collaboratorsOnTargetProduct;
        if (targetProduct === 'confluence') collaboratorsOnTargetProduct = await (0, $8NEWZ.getConfluenceUsers)(collaborators, cloudId);
        else collaboratorsOnTargetProduct = await (0, $8NEWZ.getUsersWithProductAccess)(cloudId, targetProduct, collaborators);
        return collaboratorsOnTargetProduct.slice(0, maxCollaborators);
    }, [
        cloudId,
        getCollaborators,
        targetProduct,
        maxCollaborators
    ]);
};

});
parcelRegister("8NEWZ", function(module, exports) {
$parcel$export(module.exports, "getConfluenceUsers", () => $81b2981c4970f883$export$71bcfe5bb11155f7);
$parcel$export(module.exports, "getUsersWithProductAccess", () => $81b2981c4970f883$export$a68fadaa3a8b5e25);

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");
const $81b2981c4970f883$var$URL = '/gateway/api/growth/cross-join-nudges-confluence/get-permitted-confluence-users';
const $81b2981c4970f883$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        if (!collaborators || collaborators.length === 0) return [];
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $hgi0g.default)($81b2981c4970f883$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $81b2981c4970f883$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Get Confluence users error');
    }
};
const $81b2981c4970f883$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};
const $81b2981c4970f883$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $81b2981c4970f883$export$a68fadaa3a8b5e25 = async (cloudId, product, collaborators)=>{
    const accountIds = collaborators.map((u)=>u.id);
    const lackingAccess = await (0, $hgi0g.default)($81b2981c4970f883$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });
    return collaborators.filter((c)=>!lackingAccess.includes(c.id));
};

});


parcelRegister("ct7dg", function(module, exports) {
$parcel$export(module.exports, "useMsrRequestAccessErrorFlag", () => $9f56cc675bf711b9$export$cf482a46968d8cd8);

var $eJOHy = parcelRequire("eJOHy");

var $fyI8g = parcelRequire("fyI8g");
var $2pgjF = parcelRequire("2pgjF");
var $cSXp8 = parcelRequire("cSXp8");

var $ijbqT = parcelRequire("ijbqT");

var $csiXm = parcelRequire("csiXm");
const $9f56cc675bf711b9$export$cf482a46968d8cd8 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagService)();
    return (0, $eJOHy.useCallback)((product)=>{
        const id = `error-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fyI8g.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ijbqT.RequestAccessErrorFlag), {
                    ...props,
                    id: id,
                    targetProduct: product,
                    onDismiss: dismiss,
                    flagComponent: (0, $2pgjF.ErrorFlag)
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};

});
parcelRegister("ijbqT", function(module, exports) {
$parcel$export(module.exports, "RequestAccessErrorFlag", () => $e5b9b8555341c185$export$e1d0d64874873c8b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $h0TP6 = parcelRequire("h0TP6");

var $1NG86 = parcelRequire("1NG86");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");


var $7mBYN = parcelRequire("7mBYN");

var $jzSQs = parcelRequire("jzSQs");

var $jEQSA = parcelRequire("jEQSA");
const $e5b9b8555341c185$var$SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $e5b9b8555341c185$export$e1d0d64874873c8b = (0, $jzSQs.withLocalIntl)(({ onDismiss: onDismiss, targetProduct: targetProduct, flagComponent: FlagComponent = (0, $h0TP6.default), ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)(FlagComponent, {
        ...props,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
            spacing: "spacious",
            label: "Error",
            color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $jEQSA.messages).title, {
            product: (0, $7mBYN.getProductDisplayName)(targetProduct)
        }),
        description: formatMessage((0, $jEQSA.messages).description, {
            a: (chunks)=>(0, $eGOwo.fg)('dst-a11y__replace-anchor-with-link__growth-groot') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: $e5b9b8555341c185$var$SUPPORT_LINK,
                    children: chunks
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                    href: $e5b9b8555341c185$var$SUPPORT_LINK,
                    children: chunks
                })
        })
    });
});

});
parcelRegister("7mBYN", function(module, exports) {
$parcel$export(module.exports, "getProductDisplayName", () => $8fa5de49d03ac386$export$44fea6589b7ddc92);
const $8fa5de49d03ac386$export$2a1baa97ca79d572 = {
    confluence: 'Confluence',
    jira: 'Jira',
    'jira-software': 'Jira',
    'jira-product-discovery': 'Jira Product Discovery',
    loom: 'Loom'
};
const $8fa5de49d03ac386$export$44fea6589b7ddc92 = (product)=>$8fa5de49d03ac386$export$2a1baa97ca79d572[product];

});

parcelRegister("jzSQs", function(module, exports) {
$parcel$export(module.exports, "withLocalIntl", () => $a0f458948c7788c5$export$2a4cd3780f93f2ef);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $d4MmX = parcelRequire("d4MmX");
const $a0f458948c7788c5$export$2a4cd3780f93f2ef = (ComponentToWrap)=>(props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($a0f458948c7788c5$export$9deb723ab5a74946, {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentToWrap, {
                ...props
            })
        });
const $a0f458948c7788c5$export$9deb723ab5a74946 = ({ children: children })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const { messages: messages } = (0, $d4MmX.useFetchMessagesByLocale)(locale);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        messages: messages,
        locale: locale,
        children: children
    }, locale);
};

});
parcelRegister("d4MmX", function(module, exports) {
$parcel$export(module.exports, "useFetchMessagesByLocale", () => $705a74307bdd6523$export$5ac26fa9b941854e);
/* eslint-disable import/dynamic-import-chunkname */ 
var $eJOHy = parcelRequire("eJOHy");
function $705a74307bdd6523$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $eJOHy.useState)({});
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                setIsLoading(true);
                const module = await $705a74307bdd6523$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                if (isMounted) setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}

























function $705a74307bdd6523$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("jmMV1"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("hDGif"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("fySfH"));
        case 'en-GB':
            return (parcelRequire("eDW7j"));
        case 'en-US':
        case 'en':
            return (parcelRequire("L4CSH"));
        case 'en-ZZ':
            return (parcelRequire("dz2Y6"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("21gbl"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("d7a4R"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("5SnDD"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("260uZ"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("hmHL3"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("1TSDC"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("iJYcv"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("9XIfH"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("ig5Tn"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("hptQ0"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("3gPUV"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("1M0Sx"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("1arA8"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("ePFE5"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("68MjC"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("1B3Sh"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("c4CAP"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("itw4d"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("ixvSu"));
    }
    return Promise.resolve({
        default: {}
    });
}

});
parcelRegister("jmMV1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eEASY").then(()=>parcelRequire('jV3BF'));

});

parcelRegister("hDGif", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fUfhy").then(()=>parcelRequire('8lbWa'));

});

parcelRegister("fySfH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5RQc9").then(()=>parcelRequire('5YjjN'));

});

parcelRegister("eDW7j", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3MZvl").then(()=>parcelRequire('67RNw'));

});

parcelRegister("L4CSH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4vOhV").then(()=>parcelRequire('hsEq1'));

});

parcelRegister("dz2Y6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9cOwI").then(()=>parcelRequire('gMjb0'));

});

parcelRegister("21gbl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h36CF").then(()=>parcelRequire('30DRG'));

});

parcelRegister("d7a4R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cnH73").then(()=>parcelRequire('15Wmh'));

});

parcelRegister("5SnDD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7CHu2").then(()=>parcelRequire('7UEtA'));

});

parcelRegister("260uZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k9F5O").then(()=>parcelRequire('1a6OS'));

});

parcelRegister("hmHL3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eUtjm").then(()=>parcelRequire('cA9qS'));

});

parcelRegister("1TSDC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6fRhy").then(()=>parcelRequire('cH7nJ'));

});

parcelRegister("iJYcv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2ttaJ").then(()=>parcelRequire('7tXIZ'));

});

parcelRegister("9XIfH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3UHw6").then(()=>parcelRequire('bZnkC'));

});

parcelRegister("ig5Tn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Ldtt").then(()=>parcelRequire('2ePj5'));

});

parcelRegister("hptQ0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("blHiK").then(()=>parcelRequire('x3ONS'));

});

parcelRegister("3gPUV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9kt1f").then(()=>parcelRequire('8CPhJ'));

});

parcelRegister("1M0Sx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5wtJS").then(()=>parcelRequire('dL6Om'));

});

parcelRegister("1arA8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("av1tZ").then(()=>parcelRequire('fXmRq'));

});

parcelRegister("ePFE5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8ZJp6").then(()=>parcelRequire('kMyu3'));

});

parcelRegister("68MjC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iyupp").then(()=>parcelRequire('j4GZv'));

});

parcelRegister("1B3Sh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hTQcB").then(()=>parcelRequire('gJmPi'));

});

parcelRegister("c4CAP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3blSL").then(()=>parcelRequire('2wduP'));

});

parcelRegister("itw4d", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kTA8k").then(()=>parcelRequire('axpF6'));

});

parcelRegister("ixvSu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Q3IF8").then(()=>parcelRequire('1n59s'));

});



parcelRegister("jEQSA", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2dc27ec0b9319228$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2dc27ec0b9319228$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        id: 'cross-join-nudges.request-access-error-flag.title',
        defaultMessage: "We couldn't add you to {product}",
        description: 'Title of invite error flag'
    },
    description: {
        id: 'cross-join-nudges.request-access-error-flag.description-support-link',
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
        description: 'Description informing the user that request to join was not successfully sent'
    }
});

});


parcelRegister("csiXm", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $28da6ed710c628f5$export$567fc7097e064344);
let $28da6ed710c628f5$var$id = 0;
const $28da6ed710c628f5$export$567fc7097e064344 = ()=>{
    $28da6ed710c628f5$var$id += 1;
    return String($28da6ed710c628f5$var$id);
};
function $28da6ed710c628f5$export$e86e19342bc4850e(operation, ms) {
    const startTime = Date.now();
    const timeoutPromise = new Promise((resolve)=>{
        setTimeout(()=>{
            resolve({
                timedOut: true,
                result: null,
                elapsedMs: Date.now() - startTime
            });
        }, ms);
    });
    const operationPromise = operation().then((result)=>({
            timedOut: false,
            result: result,
            elapsedMs: Date.now() - startTime
        }));
    return Promise.race([
        operationPromise,
        timeoutPromise
    ]);
}

});


parcelRegister("hgSiz", function(module, exports) {
$parcel$export(module.exports, "useMsrRequestAccessSuccessFlag", () => $272d37bddfc24429$export$aad2705851f163f9);

var $eJOHy = parcelRequire("eJOHy");

var $fyI8g = parcelRequire("fyI8g");
var $2pgjF = parcelRequire("2pgjF");
var $cSXp8 = parcelRequire("cSXp8");

var $jiXrE = parcelRequire("jiXrE");

var $csiXm = parcelRequire("csiXm");
const $272d37bddfc24429$export$aad2705851f163f9 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagService)();
    return (0, $eJOHy.useCallback)(()=>{
        const id = `success-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fyI8g.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jiXrE.RequestAccessSuccessFlag), {
                    ...props,
                    id: id,
                    onDismiss: dismiss,
                    flagComponent: (0, $2pgjF.SuccessFlag)
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};

});
parcelRegister("jiXrE", function(module, exports) {
$parcel$export(module.exports, "RequestAccessSuccessFlag", () => $f8624184ebc4e6a2$export$567128fc1024c9cf);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $h0TP6 = parcelRequire("h0TP6");

var $3TFuO = parcelRequire("3TFuO");

var $jzSQs = parcelRequire("jzSQs");

var $fNKBE = parcelRequire("fNKBE");
const $f8624184ebc4e6a2$export$567128fc1024c9cf = (0, $jzSQs.withLocalIntl)(({ onDismiss: onDismiss, flagComponent: FlagComponent = (0, $h0TP6.default), ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)(FlagComponent, {
        ...props,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
            spacing: "spacious",
            label: "Success",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $fNKBE.messages).title),
        description: formatMessage((0, $fNKBE.messages).description)
    });
});

});
parcelRegister("fNKBE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $02eff95eecac2197$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $02eff95eecac2197$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        id: 'cross-join-nudges.request-access-success-flag.title',
        defaultMessage: 'A request was sent to your admins',
        description: 'Title of invite success flag after user has requested to join Confluence'
    },
    description: {
        id: 'cross-join-nudges.request-access-success-flag.description',
        defaultMessage: "You'll receive an email once they've reviewed it.",
        description: 'Description informing the user their request has been successfully sent'
    }
});

});



parcelRegister("1p1B7", function(module, exports) {
$parcel$export(module.exports, "useMsrRequestAccessPromptFlag", () => $754557b51f68548a$export$2a55db9aab2015e8);
$parcel$export(module.exports, "getAnalyticsAttributes", () => $754557b51f68548a$export$e748b6351ba5f204);

var $eJOHy = parcelRequire("eJOHy");

var $fyI8g = parcelRequire("fyI8g");
var $2pgjF = parcelRequire("2pgjF");
var $cSXp8 = parcelRequire("cSXp8");

var $kIvec = parcelRequire("kIvec");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $csiXm = parcelRequire("csiXm");

var $eTZwC = parcelRequire("eTZwC");
const $754557b51f68548a$export$2a55db9aab2015e8 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)(async ({ users: users, onSubmit: onSubmit, targetProduct: targetProduct, integration: integration, eventAttributes: eventAttributes })=>{
        const id = `request-access-${(0, $csiXm.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $fyI8g.dismissFlag)(id));
        const featureVisitedCount = (0, $eTZwC.getMsrFeatureVisitedCount)();
        const submit = async ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'msrNudge', {
                ...eventAttributes,
                featureVisitedCount: featureVisitedCount
            });
            dismissTheFlag();
            await onSubmit();
        };
        const dismiss = ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'msrNudge', {
                ...eventAttributes,
                featureVisitedCount: featureVisitedCount
            });
            dismissTheFlag();
        };
        const dismissAndSnooze = ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', 'msrNudge', {
                ...eventAttributes,
                featureVisitedCount: featureVisitedCount
            });
            dismissTheFlag();
        };
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', 'msrNudge', {
            ...eventAttributes,
            featureVisitedCount: featureVisitedCount
        });
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kIvec.RequestAccessPromptFlag), {
                    ...props,
                    id: id,
                    collaborators: users,
                    onDismiss: dismiss,
                    onSnoozeAndDismiss: dismissAndSnooze,
                    onOptoutAndDismiss: dismissAndSnooze,
                    onSubmit: submit,
                    integration: integration,
                    targetProduct: targetProduct,
                    viewCount: featureVisitedCount,
                    flagComponent: (0, $2pgjF.InfoFlag)
                })
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
const $754557b51f68548a$export$e748b6351ba5f204 = ({ users: users, userId: userId, recommendationSessionId: recommendationSessionId, integration: integration, nudgeId: nudgeId, recommendations: recommendations })=>{
    return {
        collaborators: users.length,
        userId: userId,
        recommendationSessionId: recommendationSessionId,
        integration: integration,
        nudgeId: nudgeId,
        recommendedNudges: recommendations.join(',')
    };
};

});
parcelRegister("kIvec", function(module, exports) {
$parcel$export(module.exports, "RequestAccessPromptFlag", () => $a1f744dc7a32655e$export$9b8813c3601640da);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $lRq8t = parcelRequire("lRq8t");

var $59rsN = parcelRequire("59rsN");

var $h0TP6 = parcelRequire("h0TP6");

var $i4Iw4 = parcelRequire("i4Iw4");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");


var $aYd40 = parcelRequire("aYd40");

var $7mBYN = parcelRequire("7mBYN");

var $jzSQs = parcelRequire("jzSQs");

var $caCdT = parcelRequire("caCdT");

var $iYKxl = parcelRequire("iYKxl");
const $a1f744dc7a32655e$var$messageLibrary = (()=>({
        crossJoinNudgesV3: {
            ctaButton: (0, $iYKxl.messages).joinButton,
            remindMeLaterButton: (0, $iYKxl.messages).remindMeLaterButton,
            optOutButton: (0, $iYKxl.messages).notInterestedButton,
            descriptionWithCollaborators: (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $iYKxl.messages).descriptionJiraGalaxia : (0, $iYKxl.messages).descriptionJira,
            descriptionWithoutCollaborators: (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $iYKxl.messages).descriptionJiraGalaxia : (0, $iYKxl.messages).descriptionJira,
            title: (0, $iYKxl.messages).title,
            titleReminder: (0, $iYKxl.messages).titleReminder,
            titleNotInterested: (0, $iYKxl.messages).titleNotInterested
        },
        crossJoinNudgesConfluenceToJpd: {
            ctaButton: (0, $iYKxl.messages).getStartedButton,
            remindMeLaterButton: (0, $iYKxl.messages).remindMeLaterButton,
            optOutButton: (0, $iYKxl.messages).doNotShowAgainButton,
            descriptionWithCollaborators: (0, $iYKxl.messages).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $iYKxl.messages).descriptionJpdNudge,
            title: (0, $iYKxl.messages).titleJpdNudge,
            titleReminder: (0, $iYKxl.messages).titleJpdNudge,
            titleNotInterested: (0, $iYKxl.messages).titleJpdNudge
        },
        crossJoinNudgesJiraToConfluence: {
            ctaButton: (0, $iYKxl.messages).getStartedButton,
            optOutButton: (0, $iYKxl.messages).remindMeLaterButton,
            descriptionWithCollaborators: (0, $iYKxl.messages).descriptionJiraConfluenceMsrNudgeWithCollaborators,
            descriptionWithoutCollaborators: (0, $iYKxl.messages).descriptionJiraConfluenceMsrNudgeNoCollaborators,
            title: (0, $iYKxl.messages).titleJiraConfluenceMsrNudge,
            titleReminder: (0, $iYKxl.messages).titleJiraConfluenceMsrNudge,
            titleNotInterested: (0, $iYKxl.messages).titleJiraConfluenceMsrNudge
        },
        crossJoinNudgesJiraToJpd: {
            ctaButton: (0, $iYKxl.messages).getStartedButton,
            optOutButton: (0, $iYKxl.messages).remindMeLaterButton,
            descriptionWithCollaborators: (0, $iYKxl.messages).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $iYKxl.messages).descriptionJpdNudge,
            title: (0, $iYKxl.messages).titleJpdNudge,
            titleReminder: (0, $iYKxl.messages).titleJpdNudge,
            titleNotInterested: (0, $iYKxl.messages).titleJpdNudge
        },
        crossJoinNudgesConfluenceToJiraMsr: {
            ctaButton: (0, $iYKxl.messages).getStartedButton,
            optOutButton: (0, $iYKxl.messages).remindMeLaterButton,
            descriptionWithCollaborators: (0, $iYKxl.messages).descriptionJira,
            descriptionWithoutCollaborators: (0, $iYKxl.messages).descriptionJira,
            title: (0, $iYKxl.messages).titleJiraNudgeMsr,
            titleReminder: (0, $iYKxl.messages).titleJiraNudgeMsr,
            titleNotInterested: (0, $iYKxl.messages).titleJiraNudgeMsr
        },
        crossJoinNudgesConfluenceToJpdMsr: {
            ctaButton: (0, $iYKxl.messages).getStartedButton,
            optOutButton: (0, $iYKxl.messages).doNotShowAgainButton,
            descriptionWithCollaborators: (0, $iYKxl.messages).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $iYKxl.messages).descriptionJpdNudge,
            title: (0, $iYKxl.messages).titleJpdNudge,
            titleReminder: (0, $iYKxl.messages).titleJpdNudge,
            titleNotInterested: (0, $iYKxl.messages).titleJpdNudge
        },
        crossJoinNudgesConfluenceToLoom: {
            ctaButton: (0, $iYKxl.messages).getStartedButton,
            remindMeLaterButton: (0, $iYKxl.messages).remindMeLaterButton,
            optOutButton: (0, $iYKxl.messages).notInterestedButton,
            descriptionWithCollaborators: (0, $iYKxl.messages).descriptionLoomNudge,
            descriptionWithoutCollaborators: (0, $iYKxl.messages).descriptionLoomNudge,
            title: (0, $iYKxl.messages).titleLoomNudge,
            titleReminder: (0, $iYKxl.messages).titleLoomNudge,
            titleNotInterested: (0, $iYKxl.messages).titleLoomNudge
        }
    }))();
const $a1f744dc7a32655e$var$MAX_NUMBER_OF_COLLABORATORS = 10;
const $a1f744dc7a32655e$var$styles = {
    descriptionWrapper: "_1reoewfl _18m9ewfl _195gze3t _19pkze3t _otyru2gc"
};
const $a1f744dc7a32655e$export$5a4ad4945410eb2c = ({ integration: integration, collaborators: collaborators, descriptionWithCollaborators: descriptionWithCollaborators = null, targetProduct: // Can be supplied to override the description when there are multiple collaborators
targetProduct, viewCount: viewCount, onSubmit: onSubmit, onDismiss: onDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, onOptoutAndDismiss: onOptoutAndDismiss, flagComponent: FlagComponent = (0, $h0TP6.default), ...props })=>{
    const handleOnSubmit = (0, $eJOHy.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const messages = $a1f744dc7a32655e$var$messageLibrary[integration];
    const customFlagFooterProps = (0, $eJOHy.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
                }
            ],
            linkComponent: ()=>{
                let secondCTA = null;
                if (viewCount === 1 && messages['remindMeLaterButton']) secondCTA = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $caCdT.LinkButton), {
                    onClick: onSnoozeAndDismiss,
                    children: formatMessage(messages['remindMeLaterButton'])
                });
                else if (viewCount > 1) secondCTA = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $caCdT.LinkButton), {
                    onClick: onOptoutAndDismiss,
                    children: formatMessage(messages['optOutButton'])
                });
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center",
                    separator: "\xb7",
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $caCdT.LinkButton), {
                            onClick: handleOnSubmit,
                            children: formatMessage(messages['ctaButton'])
                        }),
                        secondCTA
                    ]
                });
            }
        }), [
        viewCount,
        handleOnSubmit,
        formatMessage,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $eJOHy.useMemo)(()=>{
        return collaborators.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aYd40.FlagCompatibleAvatarGroup), {
            position: "top",
            data: collaborators.slice(0, $a1f744dc7a32655e$var$MAX_NUMBER_OF_COLLABORATORS).map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            boundariesElement: "scrollParent",
            size: "small"
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
            color: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`,
            label: ""
        });
    }, [
        collaborators
    ]);
    const title = viewCount === 0 ? messages['title'] : viewCount === 1 ? messages['titleReminder'] : messages['titleNotInterested'];
    const infoFlagTitle = formatMessage(title, {
        product: (0, $7mBYN.getProductDisplayName)(targetProduct)
    });
    const description = collaborators.length === 0 ? formatMessage(messages['descriptionWithoutCollaborators']) : descriptionWithCollaborators || formatMessage(messages['descriptionWithCollaborators']);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(FlagComponent, {
        ...props,
        ...customFlagFooterProps,
        onDismissed: viewCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: infoFlagTitle,
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $a1f744dc7a32655e$var$styles.descriptionWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                as: "p",
                maxLines: 3,
                children: description
            })
        }),
        icon: customIcon
    });
};
const $a1f744dc7a32655e$export$9b8813c3601640da = (0, $jzSQs.withLocalIntl)($a1f744dc7a32655e$export$5a4ad4945410eb2c);

});
parcelRegister("aYd40", function(module, exports) {
$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $d9f7292ba6f1ec84$export$29beada2d5f93289);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $gqBnP = parcelRequire("gqBnP");

var $k71qx = parcelRequire("k71qx");
const $d9f7292ba6f1ec84$var$MAX_AVATARS_FEATURED_BOTTOM = 4;
const $d9f7292ba6f1ec84$var$MAX_AVATARS_FEATURED_TOP = 2;
const $d9f7292ba6f1ec84$export$29beada2d5f93289 = ({ position: position = 'bottom', data: data, ...props })=>{
    const maxAvatarCount = position === 'top' ? $d9f7292ba6f1ec84$var$MAX_AVATARS_FEATURED_TOP : $d9f7292ba6f1ec84$var$MAX_AVATARS_FEATURED_BOTTOM;
    const tooltipPosition = position;
    const { data: customData, overrides: customOverrides } = (0, $eJOHy.useMemo)(()=>$d9f7292ba6f1ec84$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        ...props
    });
    return avatarGroup;
};
const $d9f7292ba6f1ec84$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount = $d9f7292ba6f1ec84$var$MAX_AVATARS_FEATURED_BOTTOM })=>{
    const lastFeaturedUser = maxAvatarCount - 1;
    const overflowUsers = users.slice(lastFeaturedUser);
    const overrides = {
        MoreIndicator: {
            render: (Component, componentProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: overflowUsers.map((u)=>u.name).join(', '),
                    position: "top",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                        ...componentProps,
                        borderColor: "none",
                        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
                    })
                })
        }
    };
    return {
        overrides: overrides,
        data: users
    };
};

});
parcelRegister("gqBnP", function(module, exports) {
$parcel$export(module.exports, "default", () => $36ee9480fc7b69c2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $5DgXR = parcelRequire("5DgXR");


var $3Vuhz = parcelRequire("3Vuhz");

var $llBnk = parcelRequire("llBnk");

var $gl2vi = parcelRequire("gl2vi");

var $6YEko = parcelRequire("6YEko");

var $kJsb4 = parcelRequire("kJsb4");

var $k71qx = parcelRequire("k71qx");

var $8nCcr = parcelRequire("8nCcr");

var $1ld2P = parcelRequire("1ld2P");

var $e8NdE = parcelRequire("e8NdE");

var $8Au2G = parcelRequire("8Au2G");

var $8PScB = parcelRequire("8PScB");

var $9YB82 = parcelRequire("9YB82");

var $aeH98 = parcelRequire("aeH98");
const $36ee9480fc7b69c2$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $36ee9480fc7b69c2$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                    ...props,
                    key: (0, $aeH98.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                    ...props,
                    key: (0, $aeH98.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $36ee9480fc7b69c2$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $5DgXR.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eJOHy.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $llBnk.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eJOHy.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $3Vuhz.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $3Vuhz.default;
        (0, $4eDgu.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $9f42f4c07a71299e$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $9f42f4c07a71299e$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$36ee9480fc7b69c2$var$getOverrides(overrides).MoreIndicator.render((0, $8PScB.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e8NdE.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Au2G.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatar, index)=>$36ee9480fc7b69c2$var$getOverrides(overrides).AvatarGroupItem.render((0, $8nCcr.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $36ee9480fc7b69c2$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const groupId = (0, $gl2vi.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9YB82.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $36ee9480fc7b69c2$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $aeH98.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1ld2P.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $36ee9480fc7b69c2$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $aeH98.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    });
};
var $36ee9480fc7b69c2$export$2e2bcd8739ae039 = $36ee9480fc7b69c2$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $9f42f4c07a71299e$export$390330c10ff2b9a1 = 'ArrowUp';
const $9f42f4c07a71299e$export$a80636c6f41931fe = 'ArrowDown';
const $9f42f4c07a71299e$export$4af703091671bc = 'Home';
const $9f42f4c07a71299e$export$e2bc30913faa5db7 = 'End';
const $9f42f4c07a71299e$export$10f6869ed0a7d75b = 'Tab';
const $9f42f4c07a71299e$export$8152f929a25a0ff4 = 'Enter';
const $9f42f4c07a71299e$export$e51a3576c045c8d5 = 'Space';
const $9f42f4c07a71299e$export$2bb790b9008907b4 = 'Escape';

parcelRegister("8nCcr", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcb063c80fc7ca53$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $gyJTO = parcelRequire("gyJTO");

var $7saMl = parcelRequire("7saMl");
var $1PYwQ = parcelRequire("1PYwQ");
var $f58rc = parcelRequire("f58rc");

var $b65Ea = parcelRequire("b65Ea");
const $dcb063c80fc7ca53$var$AvatarGroupItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $b65Ea.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
        ref: (0, $gyJTO.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
        ref: (0, $gyJTO.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1PYwQ.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dcb063c80fc7ca53$export$2e2bcd8739ae039 = $dcb063c80fc7ca53$var$AvatarGroupItem;

});
parcelRegister("b65Ea", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5c0c66be19727b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $e8NdE = parcelRequire("e8NdE");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $d5c0c66be19727b1$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eJOHy.useContext)((0, $e8NdE.FocusManagerContext));
    const itemRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $d5c0c66be19727b1$export$2e2bcd8739ae039 = $d5c0c66be19727b1$var$useRegisterItemWithFocusManager;

});
parcelRegister("e8NdE", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $d28720e9617ae246$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $d28720e9617ae246$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $3Vuhz = parcelRequire("3Vuhz");

var $a8nPO = parcelRequire("a8nPO");
const $d28720e9617ae246$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    menuItemRefs: [],
    registerRef: (0, $3Vuhz.default)
});
/**
 * Focus manager logic
 */ const $d28720e9617ae246$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eJOHy.useRef)([]);
    const registerRef = (0, $eJOHy.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eJOHy.useEffect)(()=>{
        (0, $4eDgu.bind)(window, {
            type: 'keydown',
            listener: (0, $a8nPO.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: (0, $a8nPO.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d28720e9617ae246$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $d28720e9617ae246$export$2e2bcd8739ae039 = $d28720e9617ae246$var$FocusManager;

});
parcelRegister("a8nPO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f88bdf832caa6c34$export$2e2bcd8739ae039);

const $f88bdf832caa6c34$var$actionMap = {
    [(0, $9f42f4c07a71299e$export$a80636c6f41931fe)]: 'next',
    [(0, $9f42f4c07a71299e$export$390330c10ff2b9a1)]: 'prev',
    [(0, $9f42f4c07a71299e$export$4af703091671bc)]: 'first',
    [(0, $9f42f4c07a71299e$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $f88bdf832caa6c34$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $f88bdf832caa6c34$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $f88bdf832caa6c34$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $f88bdf832caa6c34$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $f88bdf832caa6c34$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $f88bdf832caa6c34$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $f88bdf832caa6c34$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $f88bdf832caa6c34$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("1ld2P", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e7ac3d16cd9447d$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $5e7ac3d16cd9447d$var$gutter = "var(--ds-space-negative-050, -4px)";
const $5e7ac3d16cd9447d$var$listStyles = null;
const $5e7ac3d16cd9447d$var$listStylesFlagged = null;
const $5e7ac3d16cd9447d$var$listItemStyles = null;
const $5e7ac3d16cd9447d$var$Grid = ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $eGOwo.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]),
        children: (0, $eJOHy.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                className: (0, $hcewu.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e7ac3d16cd9447d$export$2e2bcd8739ae039 = $5e7ac3d16cd9447d$var$Grid;

});

parcelRegister("8Au2G", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d2b5b7b41d11fa6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $e8NdE = parcelRequire("e8NdE");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $1d2b5b7b41d11fa6$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eJOHy.useContext)((0, $e8NdE.FocusManagerContext));
    (0, $eJOHy.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUgeq.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $1d2b5b7b41d11fa6$export$2e2bcd8739ae039 = $1d2b5b7b41d11fa6$var$PopupAvatarGroup;

});

parcelRegister("8PScB", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdf80f821318091d$export$2e2bcd8739ae039);
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $cdf80f821318091d$var$boxShadowCssVar = '--avatar-box-shadow';
const $cdf80f821318091d$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh18uv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhkm7j4 _syaz1fxt _16qs1nhn _t9ec1aqe _1ejjglyw _mizu194a _ra3xnqa1 _1ah3yh40 _128myh40 _irr315ej _30l31fxt _1di6ip91 _9h8h1fxt _1q8w1np6 _jlxit94y",
    circle: "_2rko1qll",
    active: "_bfhkfg4m _16qs1gf0 _syazaqb7 _t9ec1np6 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    disabled: "_80om13gf _1peqs237 _1hfkvuon"
};
const $cdf80f821318091d$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $cdf80f821318091d$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $cdf80f821318091d$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $cdf80f821318091d$var$MAX_DISPLAY_COUNT = 99;
const $cdf80f821318091d$var$MoreIndicator = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $cdf80f821318091d$var$MAX_DISPLAY_COUNT ? $cdf80f821318091d$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$cdf80f821318091d$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $hcewu.default)([
            $cdf80f821318091d$var$styles.root,
            $cdf80f821318091d$var$borderRadiusMap[size],
            appearance === 'circle' && $cdf80f821318091d$var$styles.circle,
            $cdf80f821318091d$var$widthHeightMap[size],
            $cdf80f821318091d$var$fontMap[size],
            isActive && $cdf80f821318091d$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$cdf80f821318091d$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cdf80f821318091d$export$2e2bcd8739ae039 = $cdf80f821318091d$var$MoreIndicator;

});

parcelRegister("9YB82", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3bb26966f739c04$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $d3bb26966f739c04$var$listStyles = null;
const $d3bb26966f739c04$var$listSmallStyles = null;
const $d3bb26966f739c04$var$listItemStyles = null;
const $d3bb26966f739c04$var$listItemSmallStyles = null;
const $d3bb26966f739c04$var$Stack = ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $eGOwo.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ]),
        children: (0, $eJOHy.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                className: (0, $hcewu.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === 'small' && (0, $eGOwo.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3bb26966f739c04$export$2e2bcd8739ae039 = $d3bb26966f739c04$var$Stack;

});

parcelRegister("aeH98", function(module, exports) {
$parcel$export(module.exports, "composeUniqueKey", () => $871dcdf2e893338b$export$b067756944994c79);
const $871dcdf2e893338b$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});



parcelRegister("caCdT", function(module, exports) {
$parcel$export(module.exports, "LinkButton", () => $cce73196917b7db4$export$29d11c0fe2fc51d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");
const $cce73196917b7db4$var$styles = {
    button: "_11c81oud _1reo15vq _18m915vq _1rjcze3t _18zrze3t _bfhk1w7a _syaz14q2 _k48p1wq8 _p12f1w81 _9oik18uv _1bnx8stv _jf4cnqa1"
};
const $cce73196917b7db4$export$29d11c0fe2fc51d8 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: onClick,
        xcss: $cce73196917b7db4$var$styles.button,
        children: children
    });
};

});

parcelRegister("iYKxl", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a02e93ac0316f76e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a02e93ac0316f76e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        id: 'cross-join-nudges.request-access-prompt-flag.title',
        defaultMessage: 'Your team is now using {product}',
        description: 'Title of invite prompt flag to join Confluence or Jira'
    },
    titleReminder: {
        id: 'cross-join-nudges.request-access-prompt-flag.title-reminder',
        defaultMessage: 'Your team is working in {product}',
        description: 'Title of invite prompt flag to join Confluence or Jira'
    },
    titleNotInterested: {
        id: 'cross-join-nudges.request-access-prompt-flag.title-not-interested',
        defaultMessage: 'Your team is waiting for you in {product}',
        description: 'Title of invite prompt flag to join Confluence or Jira'
    },
    descriptionJira: {
        id: 'cross-join-nudges.request-access-prompt-flag.description-jira',
        defaultMessage: 'Stay on top of your tasks, unify your project workflow and track your team progress in Jira.',
        description: 'Description of how Jira can be used to assist with Confluence projects'
    },
    joinButton: {
        id: 'cross-join-nudges.request-access-prompt-flag.join-button',
        defaultMessage: 'Join your team',
        description: 'Action to direct access or request access to Confluence or Jira'
    },
    remindMeLaterButton: {
        id: 'cross-join-nudges.request-access-prompt-flag.remind-me-later-button',
        defaultMessage: 'Remind me later',
        description: 'Title of the dismiss button in the request access prompt flag'
    },
    notInterestedButton: {
        id: 'cross-join-nudges.request-access-prompt-flag.not-interested-button',
        defaultMessage: 'Not interested',
        description: 'Title of the dismiss button with a stronger tone in the request access prompt flag'
    },
    titleJpdNudge: {
        id: 'cross-join-nudges.request-access-prompt-flag.title-jpd-nudge',
        defaultMessage: 'Join your team in using Jira Product Discovery',
        description: 'Title of invite prompt flag to join Jira Product Discovery'
    },
    titleJiraNudgeMsr: {
        id: 'cross-join-nudges.request-access-prompt-flag.title-jira-nudge',
        defaultMessage: 'Join your team in using Jira',
        description: 'Title of invite prompt flag to join Jira'
    },
    descriptionJpdNudge: {
        id: 'cross-join-nudges.request-access-prompt-flag.description-jpd-nudge',
        defaultMessage: 'Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery.',
        description: 'Description of how Jira Product Discovery can be used to assist with Jira projects'
    },
    getStartedButton: {
        id: 'cross-join-nudges.request-access-prompt-flag.get-started-button',
        defaultMessage: 'Get started',
        description: 'Action to direct access or request access to a product'
    },
    doNotShowAgainButton: {
        id: 'cross-join-nudges.request-access-prompt-flag.do-not-show-again-button',
        defaultMessage: "Don't show again",
        description: 'Title of the dismiss button with a stronger tone in the request access prompt flag'
    },
    descriptionJiraGalaxia: {
        id: 'cross-join-nudges.request-access-prompt-flag.description-jira-galaxia',
        defaultMessage: 'Stay on top of your tasks, unify your space workflow and track your team progress in Jira.',
        description: 'Description of how Jira can be used to assist with Confluence projects'
    },
    titleJiraConfluenceMsrNudge: {
        id: 'cross-join-nudges.common.request-access-prompt-flag.title-jira-confluence-msr-nudge',
        defaultMessage: 'Join your team in using Confluence',
        description: 'Title of invite prompt flag to join Confluence - MSR Nudge'
    },
    descriptionJiraConfluenceMsrNudgeNoCollaborators: {
        id: 'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-no-collaborators',
        defaultMessage: 'Create project pages to build a shared understanding for better decision-making.',
        description: 'Description of how Confluence can be used to assist with Jira projects without collaborators'
    },
    descriptionJiraConfluenceMsrNudgeWithCollaborators: {
        id: 'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-with-collaborators',
        defaultMessage: 'Organize team knowledge, capture ideas, and share requirements for your Jira projects. ',
        description: 'Description of how Confluence can be used to assist with Jira projects with collaborators'
    },
    titleLoomNudge: {
        id: 'cross-join-nudges.request-access-prompt-flag.title-loom-nudge',
        defaultMessage: 'Join your team on Loom',
        description: 'Title of invite prompt flag to join Loom'
    },
    descriptionLoomNudge: {
        id: 'cross-join-nudges.request-access-prompt-flag.description-loom-nudge',
        defaultMessage: 'Use Loom videos to summarize pages and share information.',
        description: 'Description of how Loom can be used to assist with Confluence'
    }
});

});


parcelRegister("eTZwC", function(module, exports) {
$parcel$export(module.exports, "getMsrFeatureVisitedCount", () => $401eabcd2734e32c$export$f2efafc0691e783);
$parcel$export(module.exports, "incrementMsrFeatureVisitedCount", () => $401eabcd2734e32c$export$bd1fff62f54dc22e);

var $ljWHg = parcelRequire("ljWHg");
const $401eabcd2734e32c$var$MSR_COUNT_CACHE_KEY = 'CROSS_JOIN_NUDGE_MSR_VISITED_COUNT';
const $401eabcd2734e32c$export$f2efafc0691e783 = ()=>{
    const val = Number((0, $ljWHg.crossJoinNudgeVisitedCache).get($401eabcd2734e32c$var$MSR_COUNT_CACHE_KEY));
    if (Number.isNaN(val)) return 0;
    return val;
};
const $401eabcd2734e32c$export$bd1fff62f54dc22e = ()=>{
    const currentCount = $401eabcd2734e32c$export$f2efafc0691e783();
    const newCount = currentCount + 1;
    (0, $ljWHg.crossJoinNudgeVisitedCache).set($401eabcd2734e32c$var$MSR_COUNT_CACHE_KEY, newCount);
    return newCount;
};

});



parcelRegister("dhnSG", function(module, exports) {
$parcel$export(module.exports, "useOverrides", () => $b043d097f992b8a9$export$ab0d8295b09da679);

var $95O7y = parcelRequire("95O7y");
const $b043d097f992b8a9$export$ab0d8295b09da679 = (queryKey)=>{
    const [value] = (0, $95O7y.useQueryParam)(queryKey);
    let overrides = {};
    if (value) overrides = JSON.parse(value);
    return $b043d097f992b8a9$export$583909077c804932(overrides);
};
function $b043d097f992b8a9$export$583909077c804932(overrides) {
    return (key, val)=>{
        if (Object.prototype.hasOwnProperty.call(overrides, key)) {
            const overrideVal = overrides[key];
            if (typeof overrideVal === 'boolean') return overrideVal;
        }
        return val;
    };
}

});

parcelRegister("3gS0H", function(module, exports) {
$parcel$export(module.exports, "useMsrConfluenceCrossJoinNudge", () => $95f3ad384849b2c7$export$b83779e1eaa5d4de);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $83DiZ = parcelRequire("83DiZ");

var $2UBs9 = parcelRequire("2UBs9");

var $2zVtv = parcelRequire("2zVtv");

var $9yo90 = parcelRequire("9yo90");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $cYLBX = parcelRequire("cYLBX");

var $ct7dg = parcelRequire("ct7dg");

var $hgSiz = parcelRequire("hgSiz");

var $1p1B7 = parcelRequire("1p1B7");

var $ljWHg = parcelRequire("ljWHg");

var $d2DJQ = parcelRequire("d2DJQ");
const $95f3ad384849b2c7$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $95f3ad384849b2c7$var$CROSS_JOIN_NUDGES_JIRA_TO_CONFLUENCE_INTEGRATION = 'crossJoinNudgesJiraToConfluence';
const $95f3ad384849b2c7$export$b83779e1eaa5d4de = ({ sessionId: sessionId })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const currentProduct = (0, $2zVtv.useCurrentProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $95f3ad384849b2c7$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const showMsrRequestAccessPromptFlag = (0, $1p1B7.useMsrRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $hgSiz.useMsrRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $ct7dg.useMsrRequestAccessErrorFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const requestAccessService = (0, $4cTDP.fg)('expansion_services_in_cjn') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2UBs9.useService)((0, $9yo90.requestAccess)) : null;
    return (0, $eJOHy.useCallback)(async ({ recommendations: recommendations })=>{
        try {
            const collaboratorsOnConfluence = await getFilteredCollaborators();
            async function onSubmit() {
                try {
                    try {
                        let accessStatus;
                        if (requestAccessService && (0, $4cTDP.fg)('expansion_services_in_cjn')) {
                            const serviceResult = await requestAccessService({
                                product: 'confluence',
                                integration: 'crossJoinNudgesConfluence'
                            });
                            if (serviceResult.error) {
                                (0, $8Ujbi.fireErrorAnalytics)('confluenceRequestAccess', serviceResult.error);
                                throw serviceResult.error;
                            }
                            accessStatus = serviceResult.result;
                        } else accessStatus = await (0, $iaIqW.requestAccess)('confluence', currentProduct, cloudId, userId, 'crossJoinNudgesConfluence', createAnalyticsEvent);
                        if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                        else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                        else showErrorFlag('confluence');
                    } catch  {
                        showErrorFlag('confluence');
                    }
                } catch  {
                    showErrorFlag('confluence');
                }
            }
            showMsrRequestAccessPromptFlag({
                users: collaboratorsOnConfluence,
                onSubmit: onSubmit,
                targetProduct: 'confluence',
                integration: $95f3ad384849b2c7$var$CROSS_JOIN_NUDGES_JIRA_TO_CONFLUENCE_INTEGRATION,
                eventAttributes: (0, $1p1B7.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnConfluence,
                    integration: $95f3ad384849b2c7$var$CROSS_JOIN_NUDGES_JIRA_TO_CONFLUENCE_INTEGRATION,
                    recommendationSessionId: sessionId,
                    nudgeId: (0, $d2DJQ.RECOMMENDATION_PRODUCT_KEYS).CONFLUENCE,
                    recommendations: recommendations
                })
            });
            // this is used in the eligibility check for loom nudge
            await (0, $ljWHg.setHasSeenNudgeInLast7Days)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('showMsrNudge', error, {
                cloudId: cloudId,
                targetProduct: 'confluence',
                integration: $95f3ad384849b2c7$var$CROSS_JOIN_NUDGES_JIRA_TO_CONFLUENCE_INTEGRATION
            });
        }
    }, [
        cloudId,
        userId,
        currentProduct,
        createAnalyticsEvent,
        getFilteredCollaborators,
        push,
        requestAccessService,
        showErrorFlag,
        showSuccessFlag,
        showMsrRequestAccessPromptFlag,
        sessionId
    ]);
};

});
parcelRegister("9yo90", function(module, exports) {
$parcel$export(module.exports, "requestAccess", () => $e322d6a717699e5d$export$cd9e5995821603e1);
/**
 * This file defines the requestAccess() service.
 */ 
var $i583N = parcelRequire("i583N");

var $bfhQ2 = parcelRequire("bfhQ2");

var $dn9SV = parcelRequire("dn9SV");
// Dependencies - generally common to all RA's/joins:
const $e322d6a717699e5d$var$dependencies = {
    fetchJSON: $dn9SV.fetchJSON,
    createAnalyticsEvent: $bfhQ2.createAnalyticsEvent,
    getStargateURL: $bfhQ2.getStargateURL,
    getCurrentUserId: $bfhQ2.getCurrentUserId,
    getCurrentCloudId: $bfhQ2.getCurrentCloudId,
    getCurrentProduct: $bfhQ2.getCurrentProduct
};
const $e322d6a717699e5d$export$cd9e5995821603e1 = Object.assign($e322d6a717699e5d$var$requestAccessImpl, {
    dependencies: $e322d6a717699e5d$var$dependencies
});
async function $e322d6a717699e5d$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = `ari:cloud:${input.product}::site/${cloudId}`;
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const response = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource
            })
        });
        result = $e322d6a717699e5d$var$mapRequestAccessResponse(response, {
            resource: resource,
            userId: userId,
            ...input
        });
    } catch (error) {
        result = {
            error: (0, $i583N.toError)(error),
            ...input,
            result: null,
            resource: resource,
            userId: userId
        };
    }
    $e322d6a717699e5d$var$fireRequestAccessAnalytics({
        ...input,
        ...result
    }, context);
    return result;
}
function $e322d6a717699e5d$var$mapRequestAccessResponse(response, input) {
    return {
        error: null,
        result: response.results[input.resource],
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $e322d6a717699e5d$var$fireRequestAccessAnalytics({ error: error, product: product, result: result }, context) {
    if (!error) {
        const currentUserId = context.dependencies().getCurrentUserId();
        const attributes = {
            userAaid: currentUserId,
            actorAaid: currentUserId,
            roleName: 'product/member',
            inviteStatus: result,
            sourceProduct: context.dependencies().getCurrentProduct(),
            sourceTenantId: context.dependencies().getCurrentCloudId(),
            product: product
        };
        if (result === 'ACCESS_GRANTED') $e322d6a717699e5d$var$fireProductJoined(attributes, context);
        else $e322d6a717699e5d$var$fireProductAccessRequested(attributes, context);
    }
}
function $e322d6a717699e5d$var$fireProductAccessRequested(input, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSujectId: input.userAaid,
            attributes: input
        }
    }).fire();
}
function $e322d6a717699e5d$var$fireProductJoined({ userUuid: userUuid, userAaid: userAaid, roleName: roleName, sourceTenantId: sourceTenantId, sourceProduct: sourceProduct, recommendationSources: recommendationSources, product: product }, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSujectId: product,
            attributes: {
                userUuid: userUuid,
                userAaid: userAaid,
                roleName: roleName,
                sourceTenantId: sourceTenantId,
                sourceProduct: sourceProduct,
                recommendationSources: recommendationSources,
                product: product
            }
        }
    }).fire();
}

});


parcelRegister("awEIK", function(module, exports) {
$parcel$export(module.exports, "useMsrJpdCrossJoinNudgeEligibility", () => $f4adfa384d732d13$export$58cb5e32a1c0739);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $1Ru5V = parcelRequire("1Ru5V");

var $ftN6c = parcelRequire("ftN6c");

var $kfvK2 = parcelRequire("kfvK2");

var $8Ujbi = parcelRequire("8Ujbi");

var $dWhgU = parcelRequire("dWhgU");

var $fWKBM = parcelRequire("fWKBM");

var $gnRyQ = parcelRequire("gnRyQ");

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $dhnSG = parcelRequire("dhnSG");

var $ljWHg = parcelRequire("ljWHg");
const $f4adfa384d732d13$export$58cb5e32a1c0739 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const isJpdRoute = (0, $kfvK2.useIsActiveRoute)('polaris-ideas');
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_jpd_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            // TODO: PUMA-423 replace with smart caching to further optimize calls
            const cachedIsSiteOptedOut = (0, $ljWHg.withEligibilityCache)('site_is_opted_out', (0, $dWhgU.isSiteOptedOut), 0.2);
            const cachedHasProductAccess = (0, $ljWHg.withEligibilityCache)('user_already_has_jpd', (0, $hQEY6.hasProductAccess), 30);
            const cachedUserCanRequestAccess = (0, $ljWHg.withEligibilityCache)('user_cannot_request_jpd_access', (0, $lUO6r.fetchIsRequestAccessCapable), 7);
            // TODO: PUMA-423 replace with smart caching to further optimize calls
            const cachedJpdTooNew = (0, $ljWHg.withEligibilityCache)('jpd_is_too_new', async ()=>!await (0, $fWKBM.isSite7DaysOld)('jira-product-discovery', cloudId), 7);
            // TODO: PUMA-423 replace with smart caching to further optimize calls
            const cachedUserTooNew = (0, $ljWHg.withEligibilityCache)('user_is_too_new', (0, $gnRyQ.isNewActiveUser), 7);
            if (withOverrides('is_jpd_route', isJpdRoute)) return {
                isEligible: false,
                reason: 'is_jpd_route'
            };
            if (withOverrides('site_has_no_licensed_jpd', !licensedProducts['jira-product-discovery'])) return {
                isEligible: false,
                reason: 'site_has_no_licensed_jpd'
            };
            if (withOverrides('user_already_has_jpd', await cachedHasProductAccess('jira-product-discovery', cloudId))) return {
                isEligible: false,
                reason: 'user_already_has_jpd'
            };
            const userCanRequestAccessToJpd = await cachedUserCanRequestAccess('jira-product-discovery', cloudId);
            if (withOverrides('user_cannot_request_jpd_access', !userCanRequestAccessToJpd)) return {
                isEligible: false,
                reason: 'user_cannot_request_jpd_access'
            };
            if (withOverrides('site_is_opted_out', await cachedIsSiteOptedOut(cloudId))) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd');
                return {
                    isEligible: false,
                    reason: 'site_is_opted_out'
                };
            }
            if (withOverrides('jpd_is_too_new', await cachedJpdTooNew())) return {
                isEligible: false,
                reason: 'jpd_is_too_new'
            };
            if (withOverrides('user_is_too_new', await cachedUserTooNew(cloudId, userId))) return {
                isEligible: false,
                reason: 'user_is_too_new'
            };
            return {
                isEligible: true,
                reason: ''
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('eligibilityCheck', error, {
                cloudId: cloudId,
                targetProduct: 'jira-product-discovery'
            });
            return {
                isEligible: false,
                reason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        userId,
        createAnalyticsEvent,
        isJpdRoute,
        licensedProducts,
        withOverrides
    ]);
};

});
parcelRegister("dWhgU", function(module, exports) {
$parcel$export(module.exports, "isSiteOptedOut", () => $7e925e1d07159dc3$export$3475487c10c1ac17);

var $lctcw = parcelRequire("lctcw");
const $7e925e1d07159dc3$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};

});

parcelRegister("fWKBM", function(module, exports) {
$parcel$export(module.exports, "isSite7DaysOld", () => $a9d6cb12118148cb$export$23b7746c9e6ae406);
$parcel$export(module.exports, "isLoomSite7DaysOld", () => $a9d6cb12118148cb$export$e7b898c6b427cf14);

var $lctcw = parcelRequire("lctcw");
const $a9d6cb12118148cb$var$ACTIVATION_TRAITS = {
    confluence: 'confluence.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate',
    loom: 'loom.activationDate'
};
const $a9d6cb12118148cb$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    return $a9d6cb12118148cb$var$findAndCheckActivationDate(product, siteTraits);
};
const $a9d6cb12118148cb$var$findAndCheckActivationDate = (product, traits)=>{
    const traitName = $a9d6cb12118148cb$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const activationTrait = traits.find((trait)=>trait.name === traitName);
    if (activationTrait?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(activationTrait?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};
const $a9d6cb12118148cb$export$e7b898c6b427cf14 = async (cloudId)=>{
    const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    return $a9d6cb12118148cb$var$findAndCheckLoomActivationDate(siteTraits);
};
// The loom.activationDate trait is registered on 23rd Aug 2025, any values that are not found within this trait means the site is older than 7 days
// The trait is registered when a new loom site is provisioned
// See https://data-portal.internal.atlassian.com/targeting/traits/63974e01-9d13-4587-8b23-235087258799
const $a9d6cb12118148cb$var$findAndCheckLoomActivationDate = (traits)=>{
    const traitName = $a9d6cb12118148cb$var$ACTIVATION_TRAITS.loom;
    if (!traitName) throw Error('Unknown activation trait key for loom site');
    const activationTrait = traits.find((trait)=>trait.name === traitName);
    if (activationTrait?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(activationTrait?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return true;
};

});

parcelRegister("gnRyQ", function(module, exports) {
$parcel$export(module.exports, "isNewActiveUser", () => $63575b3cc2f8f421$export$b4712e67f435e1dc);

var $lFovQ = parcelRequire("lFovQ");
const $63575b3cc2f8f421$export$b4712e67f435e1dc = async (cloudId, userId, newActiveDays = 14)=>{
    const userTraits = await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
        cloudId: cloudId,
        userId: userId
    });
    return $63575b3cc2f8f421$var$findAndCheckActiveDate(userTraits, newActiveDays);
};
const $63575b3cc2f8f421$var$findAndCheckActiveDate = (traits, newActiveDays)=>{
    const traitName = 'jira_first_active';
    const firstActiveTrait = traits.find((trait)=>trait.name === traitName);
    if (firstActiveTrait?.value) {
        const oneWeekActive = new Date(firstActiveTrait?.value.toString());
        oneWeekActive.setDate(oneWeekActive.getDate() + newActiveDays);
        const today = new Date();
        return today <= oneWeekActive;
    }
    return true;
};

});

parcelRegister("hQEY6", function(module, exports) {
$parcel$export(module.exports, "hasProductAccess", () => $720d3c5dda9fece8$export$61073fd69a83a1e3);
$parcel$export(module.exports, "fetchCachedAccessCheck", () => $720d3c5dda9fece8$export$cd2f9bc003d00b45);

var $3hRxq = parcelRequire("3hRxq");

var $hgi0g = parcelRequire("hgi0g");

var $kRgKj = parcelRequire("kRgKj");
const $720d3c5dda9fece8$var$URL = '/gateway/api/permissions/permitted';
const $720d3c5dda9fece8$export$61073fd69a83a1e3 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await (0, $hgi0g.default)($720d3c5dda9fece8$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
// Purposefully set this to 7 days as it's unlikely user can be kicked out of Confluence when they already have access
const $720d3c5dda9fece8$var$PERMISSION_CACHE_KEY_EXPIRY_MS = 604800000;
const $720d3c5dda9fece8$var$crossJoinApiCache = (0, $3hRxq.createLocalExpirableStorageProvider)('cross-join-nudge-conf-perms-api-cache');
const $720d3c5dda9fece8$export$cd2f9bc003d00b45 = async (createAnalyticsEvent, product, cloudId, touchpoint)=>{
    const cacheKey = `cross.join.${product}.cache.key`;
    let permissionResponse = $720d3c5dda9fece8$var$crossJoinApiCache.get(cacheKey);
    if (permissionResponse === undefined) {
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheMiss', {
            touchpoint: touchpoint,
            product: product
        });
        try {
            permissionResponse = await $720d3c5dda9fece8$export$61073fd69a83a1e3(product, cloudId);
        } catch (err) {
            // No PII from identity exception so fire operational analytics consistently
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck fetchError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        try {
            $720d3c5dda9fece8$var$crossJoinApiCache.set(cacheKey, permissionResponse, Date.now() + $720d3c5dda9fece8$var$PERMISSION_CACHE_KEY_EXPIRY_MS);
        } catch (err) {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck setError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                skipSentry: true
            });
            return permissionResponse;
        }
        return permissionResponse;
    }
    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheHit', {
        touchpoint: touchpoint,
        product: product
    });
    return permissionResponse;
};

});

parcelRegister("lUO6r", function(module, exports) {
$parcel$export(module.exports, "fetchIsRequestAccessCapable", () => $22792cce0cce9606$export$c75518284e8dee24);
$parcel$export(module.exports, "fetchCachedIsConfluenceRACapable", () => $22792cce0cce9606$export$f5767c68446c14cb);
$parcel$export(module.exports, "resetRACapableCache", () => $22792cce0cce9606$export$5191fc85eb825b4b);

var $3hRxq = parcelRequire("3hRxq");

var $14RSn = parcelRequire("14RSn");

var $hgi0g = parcelRequire("hgi0g");

var $kRgKj = parcelRequire("kRgKj");
const $22792cce0cce9606$export$c75518284e8dee24 = async (product, cloudId, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    try {
        const response = await (0, $hgi0g.default)(URL, {
            credentials: 'include'
        });
        const requestCapabilities = response.results[resource];
        return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
    } catch (err) {
        if (createAnalyticsEvent) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
            err: err,
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
        if (product === 'loom' && err instanceof (0, $14RSn.default)) return false;
        throw err;
    }
};
const $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY = 'cross.join.confluence-capabilities.cache.key';
// This is set to 1 day only as capabilties has many more states e.g PENDING_REQUEST_EXISTS, APPROVED_REQUEST_EXISTS etc
// We expect capabilities to change more often than product access
const $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS = 86400000;
const $22792cce0cce9606$var$crossJoinApiCache = (0, $3hRxq.createLocalExpirableStorageProvider)('cross-join-nudge-conf-capabilities-api-cache');
const $22792cce0cce9606$export$f5767c68446c14cb = async (createAnalyticsEvent, cloudId, touchpoint)=>{
    let isRACapable = $22792cce0cce9606$var$crossJoinApiCache.get($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
    if (isRACapable === undefined) {
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheMiss', {
            touchpoint: touchpoint
        });
        try {
            isRACapable = await $22792cce0cce9606$export$c75518284e8dee24('confluence', cloudId);
        } catch (err) {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
                touchpoint: touchpoint,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        $22792cce0cce9606$export$a901680cf5ecfb6c(createAnalyticsEvent, isRACapable, touchpoint);
        return isRACapable;
    }
    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheHit', {
        touchpoint: touchpoint
    });
    return isRACapable;
};
const $22792cce0cce9606$export$a901680cf5ecfb6c = (createAnalyticsEvent, value, touchpoint)=>{
    try {
        $22792cce0cce9606$var$crossJoinApiCache.set($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY, value, Date.now() + $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS);
    } catch (err) {
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck setError', {
            touchpoint: touchpoint,
            err: err,
            skipSentry: true
        });
    }
};
const $22792cce0cce9606$export$5191fc85eb825b4b = ()=>{
    $22792cce0cce9606$var$crossJoinApiCache.remove($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
};

});


parcelRegister("9nFEq", function(module, exports) {
$parcel$export(module.exports, "useMsrConfluenceCrossJoinNudgeEligibility", () => $a860566d09d380cb$export$2d12472ad22403f3);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $1Ru5V = parcelRequire("1Ru5V");

var $kfvK2 = parcelRequire("kfvK2");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $gnRyQ = parcelRequire("gnRyQ");

var $dhnSG = parcelRequire("dhnSG");
const $a860566d09d380cb$export$2d12472ad22403f3 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const isYourWorkRoute = (0, $kfvK2.useIsActiveRoute)('your-work');
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_conf_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            // TODO: PUMA-423 replace with smart caching to further optimize calls
            const cachedIsSiteOptedOut = (0, $ljWHg.withEligibilityCache)('site_is_opted_out', (0, $dWhgU.isSiteOptedOut), 0.2);
            const cachedHasProductAccess = (0, $ljWHg.withEligibilityCache)('user_already_has_confluence', (0, $hQEY6.hasProductAccess), 30);
            const cachedUserCanRequestAccess = (0, $ljWHg.withEligibilityCache)('user_cannot_request_confluence_access', (0, $lUO6r.fetchIsRequestAccessCapable), 7);
            // TODO: PUMA-423 replace with smart caching to further optimize calls
            const cachedConfluenceTooNew = (0, $ljWHg.withEligibilityCache)('confluence_is_too_new', async ()=>!await (0, $fWKBM.isSite7DaysOld)('confluence', cloudId), 7);
            // TODO: PUMA-423 replace with smart caching to further optimize calls
            const cachedUserTooNew = (0, $ljWHg.withEligibilityCache)('user_is_too_new', (0, $gnRyQ.isNewActiveUser), 7);
            if (withOverrides('is_your_work_route', isYourWorkRoute)) return {
                isEligible: false,
                reason: 'is_your_work_route'
            };
            if (withOverrides('site_has_no_licensed_confluence', !licensedProducts.confluence)) return {
                isEligible: false,
                reason: 'site_has_no_licensed_confluence'
            };
            const userHasProductAccess = await cachedHasProductAccess('confluence', cloudId);
            if (withOverrides('user_already_has_confluence', userHasProductAccess)) return {
                isEligible: false,
                reason: 'user_already_has_confluence'
            };
            const userCanRequestAccessToConfluence = await cachedUserCanRequestAccess('confluence', cloudId);
            if (withOverrides('user_cannot_request_confluence_access', !userCanRequestAccessToConfluence)) return {
                isEligible: false,
                reason: 'user_cannot_request_confluence_access'
            };
            if (withOverrides('site_is_opted_out', await cachedIsSiteOptedOut(cloudId))) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return {
                    isEligible: false,
                    reason: 'site_is_opted_out'
                };
            }
            if (withOverrides('confluence_is_too_new', await cachedConfluenceTooNew())) return {
                isEligible: false,
                reason: 'confluence_is_too_new'
            };
            if (withOverrides('user_is_too_new', await cachedUserTooNew(cloudId, userId))) return {
                isEligible: false,
                reason: 'user_is_too_new'
            };
            return {
                isEligible: true,
                reason: ''
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('eligibilityCheck', error, {
                cloudId: cloudId,
                targetProduct: 'confluence'
            });
            return {
                isEligible: false,
                reason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        isYourWorkRoute,
        licensedProducts.confluence,
        userId,
        withOverrides
    ]);
};

});

parcelRegister("gEsbZ", function(module, exports) {
$parcel$export(module.exports, "useMsrSnoozeHandler", () => $246fc9a736d8f9cf$export$929578679169c83e);

var $eJOHy = parcelRequire("eJOHy");

var $ljWHg = parcelRequire("ljWHg");

var $eTZwC = parcelRequire("eTZwC");
const $246fc9a736d8f9cf$var$SNOOZE_INTERVALS = {
    0: 7,
    1: 14,
    2: 30,
    3: 90
};
const $246fc9a736d8f9cf$export$929578679169c83e = ()=>{
    const blockEligibilityToPreventRace = (0, $eJOHy.useCallback)(()=>{
        (0, $ljWHg.setFeatureVisited)('crossJoinNudgesMsr', 0.1);
    }, []);
    const blockEligibilityUntilTomorrow = (0, $eJOHy.useCallback)(()=>{
        (0, $ljWHg.setFeatureVisited)('crossJoinNudgesMsr', 1);
    }, []);
    const snooze = (0, $eJOHy.useCallback)(()=>{
        const visitedCount = (0, $eTZwC.getMsrFeatureVisitedCount)();
        // We are going to loop the last nudge indefinitely
        const loopedVisitedCount = Math.min(visitedCount, Object.keys($246fc9a736d8f9cf$var$SNOOZE_INTERVALS).length - 1);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const snoozeInterval = $246fc9a736d8f9cf$var$SNOOZE_INTERVALS[loopedVisitedCount];
        (0, $ljWHg.setFeatureVisited)('crossJoinNudgesMsr', snoozeInterval);
        (0, $eTZwC.incrementMsrFeatureVisitedCount)();
    }, []);
    return {
        snooze: snooze,
        blockEligibilityUntilTomorrow: blockEligibilityUntilTomorrow,
        blockEligibilityToPreventRace: blockEligibilityToPreventRace
    };
};

});

parcelRegister("8rm4G", function(module, exports) {
$parcel$export(module.exports, "useMsrAnalytics", () => $c2e03d82769ca5b3$export$21cc3c34a4f38e9e);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $ljWHg = parcelRequire("ljWHg");
const $c2e03d82769ca5b3$export$21cc3c34a4f38e9e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const eventIsFiredRef = (0, $eJOHy.useRef)(false);
    /**
	 * Fire customer feature exposed event only once
	 */ const fireMsrFeatureExposedEventOnce = (0, $eJOHy.useCallback)(({ cohort: cohort })=>{
        if (eventIsFiredRef.current) return;
        if (cohort === 'not-enrolled') return;
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'msrCjnExperiment exposed', {
            cohort: cohort
        });
        eventIsFiredRef.current = true;
    }, [
        createAnalyticsEvent
    ]);
    /**
	 * Fire event only in case the event value has not been cached or cached value is different
	 * to prevent excessive number of analytics calls.
	 */ const fireOnlyNewEvent = (0, $eJOHy.useCallback)(async ({ value: value, eventName: eventName, key: key })=>{
        try {
            const cachedValue = await (0, $ljWHg.cjnEventEligibilityCache).get(key);
            if (!cachedValue || cachedValue && cachedValue?.isEligible !== value.isEligible && cachedValue?.reason !== value.reason) {
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), eventName, {
                    ...value,
                    key: key
                });
                await (0, $ljWHg.cjnEventEligibilityCache).set(key, value);
            }
        } catch (e) {
        // cache get fail, do nothing
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireMsrFeatureExposedEventOnce: fireMsrFeatureExposedEventOnce,
        fireOnlyNewEvent: fireOnlyNewEvent
    };
};

});


parcelRegister("aL0ae", function(module, exports) {
$parcel$export(module.exports, "useJpdCrossJoinNudgeEligibility", () => $b68a717b2bd198f7$export$cf17b7d2f952c993);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $1Ru5V = parcelRequire("1Ru5V");

var $kfvK2 = parcelRequire("kfvK2");

var $4cTDP = parcelRequire("4cTDP");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $lIThU = parcelRequire("lIThU");
const $b68a717b2bd198f7$export$cf17b7d2f952c993 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const isJpdRoute = (0, $kfvK2.useIsActiveRoute)('polaris-ideas');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            let snoozeFor = 30;
            if ((0, $4cTDP.fg)('twcg-1201-cjn-pacing-eligibility-calibration')) snoozeFor = 7;
            if ((0, $ljWHg.getOrUpdateFeatureVisited)('crossJoinNudgesJiraToJpd', snoozeFor)) return {
                isEligible: false,
                ineligibleReason: 'feature visited too recently'
            };
            if (isJpdRoute) return {
                isEligible: false,
                ineligibleReason: 'jpd route'
            };
            const eligibilityResponse = await (0, $lIThU.checkJpdCrossJoinNudgeEligibility)({
                cloudId: cloudId,
                userId: userId,
                licensedProducts: licensedProducts
            });
            if (!eligibilityResponse.eligible) {
                if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd');
                return {
                    isEligible: false,
                    ineligibleReason: eligibilityResponse.ineligibilityReason
                };
            }
            return {
                isEligible: true,
                data: {}
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                ineligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        userId,
        createAnalyticsEvent,
        isJpdRoute,
        licensedProducts
    ]);
};

});
parcelRegister("lIThU", function(module, exports) {
$parcel$export(module.exports, "checkJpdCrossJoinNudgeEligibility", () => $d5febf352f541134$export$db3bc6af881f6bd0);

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $gnRyQ = parcelRequire("gnRyQ");
const $d5febf352f541134$export$db3bc6af881f6bd0 = async ({ cloudId: cloudId, userId: userId, licensedProducts: licensedProducts })=>{
    if (!licensedProducts['jira-product-discovery']) return {
        eligible: false,
        ineligibilityReason: 'NO_JPD_LICENCE'
    };
    if (await (0, $dWhgU.isSiteOptedOut)(cloudId)) return {
        eligible: false,
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (!await (0, $fWKBM.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if (await (0, $gnRyQ.isNewActiveUser)(cloudId, userId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_ACTIVE_USER'
    };
    if (await (0, $hQEY6.hasProductAccess)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (!await (0, $lUO6r.fetchIsRequestAccessCapable)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    return {
        eligible: true
    };
};

});


parcelRegister("lvTzp", function(module, exports) {
$parcel$export(module.exports, "useConfluenceCrossJoinNudgeEligibility", () => $dcb33797a02a8fc9$export$a3f7303bbd08ef0d);
$parcel$export(module.exports, "useLlmConfluenceCrossJoinNudgeEligibility", () => $dcb33797a02a8fc9$export$3bcfe3104ff90dce);
$parcel$export(module.exports, "useHasSeenConfLlm", () => $dcb33797a02a8fc9$export$269024ef75d7c956);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $1Ru5V = parcelRequire("1Ru5V");

var $kfvK2 = parcelRequire("kfvK2");

var $1M2hR = parcelRequire("1M2hR");

var $4cTDP = parcelRequire("4cTDP");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $cYLBX = parcelRequire("cYLBX");

var $2G4e8 = parcelRequire("2G4e8");

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $gnRyQ = parcelRequire("gnRyQ");


var $dhnSG = parcelRequire("dhnSG");
const $dcb33797a02a8fc9$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $dcb33797a02a8fc9$export$a3f7303bbd08ef0d = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { getNudgeState: getNudgeStateV2a } = (0, $2G4e8.useNudgeStateV2a)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const isYourWorkRoute = (0, $kfvK2.useIsActiveRoute)('your-work');
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_conf_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const cachedIsSiteOptedOut = (0, $ljWHg.withEligibilityCache)('site_is_opted_out', (0, $dWhgU.isSiteOptedOut), 0.2);
            const cachedHasProductAccess = (0, $ljWHg.withEligibilityCache)('user_already_has_confluence', (0, $hQEY6.hasProductAccess), 0.2);
            const cachedUserCanRequestAccess = (0, $ljWHg.withEligibilityCache)('user_cannot_request_confluence_access', (0, $lUO6r.fetchIsRequestAccessCapable), 0.2);
            if (withOverrides('is_your_work_route', isYourWorkRoute)) return {
                isEligible: false,
                ineligibleReason: 'is_your_work_route'
            };
            if (withOverrides('site_has_no_licensed_confluence', !licensedProducts.confluence)) return {
                isEligible: false,
                ineligibleReason: 'site_has_no_licensed_confluence'
            };
            let snoozeFor = 30;
            if ((0, $4cTDP.fg)('twcg-1201-cjn-pacing-eligibility-calibration')) snoozeFor = 7;
            if (withOverrides('feature_visited_too_recently', (0, $ljWHg.getOrUpdateFeatureVisited)('crossJoinNudgesConfluence', snoozeFor))) return {
                isEligible: false,
                ineligibleReason: 'feature_visited_too_recently'
            };
            if (withOverrides('site_is_opted_out', await cachedIsSiteOptedOut(cloudId))) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return {
                    isEligible: false,
                    ineligibleReason: 'site_is_opted_out'
                };
            }
            const userHasProductAccess = await cachedHasProductAccess('confluence', cloudId);
            if (withOverrides('user_already_has_confluence', userHasProductAccess)) return {
                isEligible: false,
                ineligibleReason: 'user_already_has_confluence'
            };
            const userCanRequestAccessToConfluence = await cachedUserCanRequestAccess('confluence', cloudId);
            if (withOverrides('user_cannot_request_confluence_access', !userCanRequestAccessToConfluence)) return {
                isEligible: false,
                ineligibleReason: 'user_cannot_request_confluence_access'
            };
            if (withOverrides('confluence_is_too_new', !await (0, $fWKBM.isSite7DaysOld)('confluence', cloudId))) return {
                isEligible: false,
                ineligibleReason: 'confluence_is_too_new'
            };
            if (withOverrides('user_is_too_new', await (0, $gnRyQ.isNewActiveUser)(cloudId, userId))) return {
                isEligible: false,
                ineligibleReason: 'user_is_too_new'
            };
            // Since V2A Rollout to 100%, all nudge will use V2A Logic
            if (withOverrides('nudge_already_dismissed', await getNudgeStateV2a() === 'DISMISSED')) return {
                isEligible: false,
                ineligibleReason: 'nudge_already_dismissed'
            };
            const featureVisitedCount = await (0, $ljWHg.getFeatureVisitedCount)(userId);
            // TODO: move to the top
            if (withOverrides('nudge_seen_too_many_times', featureVisitedCount >= (0, $c7deaa9431a15ff8$export$a4b45159adbcc3d7))) return {
                isEligible: false,
                ineligibleReason: 'nudge_seen_too_many_times'
            };
            return {
                isEligible: true,
                data: {
                    featureVisitedCount: featureVisitedCount
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                ineligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getNudgeStateV2a,
        isYourWorkRoute,
        licensedProducts.confluence,
        userId,
        withOverrides
    ]);
};
const $dcb33797a02a8fc9$export$3bcfe3104ff90dce = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $dcb33797a02a8fc9$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const locale = (0, $1M2hR.useLocale)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_conf_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const cachedIsSiteOptedOut = (0, $ljWHg.withEligibilityCache)('site_is_opted_out', (0, $dWhgU.isSiteOptedOut), 0.2);
            const cachedHasProductAccess = (0, $ljWHg.withEligibilityCache)('user_already_has_confluence', (0, $hQEY6.hasProductAccess), 0.2);
            const cachedUserCanRequestAccess = (0, $ljWHg.withEligibilityCache)('user_cannot_request_confluence_access', (0, $lUO6r.fetchIsRequestAccessCapable), 0.2);
            async function hasCollaborators() {
                const collaborators = (await getFilteredCollaborators()).length ?? 0;
                return collaborators > 0;
            }
            const hasCollaboratorsWithCache = (0, $ljWHg.withEligibilityCache)('has_collaborators', hasCollaborators, 7);
            const isEnglishLocale = locale && locale.startsWith('en');
            if (!isEnglishLocale) return {
                isEligible: false,
                ineligibleReason: 'not_english_locale'
            };
            if (withOverrides('site_has_no_licensed_confluence', !licensedProducts.confluence)) return {
                isEligible: false,
                ineligibleReason: 'site_has_no_licensed_confluence'
            };
            if (withOverrides('site_is_opted_out', await cachedIsSiteOptedOut(cloudId))) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return {
                    isEligible: false,
                    ineligibleReason: 'site_is_opted_out'
                };
            }
            const userHasProductAccess = await cachedHasProductAccess('confluence', cloudId);
            if (withOverrides('user_already_has_confluence', userHasProductAccess)) return {
                isEligible: false,
                ineligibleReason: 'user_already_has_confluence'
            };
            const userCanRequestAccessToConfluence = await cachedUserCanRequestAccess('confluence', cloudId);
            if (withOverrides('user_cannot_request_confluence_access', !userCanRequestAccessToConfluence)) return {
                isEligible: false,
                ineligibleReason: 'user_cannot_request_confluence_access'
            };
            if (await hasCollaboratorsWithCache()) return {
                isEligible: false,
                ineligibleReason: 'has_collaborators'
            };
            return {
                isEligible: true,
                data: {}
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                ineligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        getFilteredCollaborators,
        locale,
        createAnalyticsEvent,
        licensedProducts.confluence,
        withOverrides
    ]);
};
const $dcb33797a02a8fc9$export$269024ef75d7c956 = ()=>{
    return (0, $eJOHy.useCallback)(()=>{
        return (0, $ljWHg.cjnEligibilityCacheHandler).get('has_seen_conf_llm');
    }, []);
};

});
parcelRegister("2G4e8", function(module, exports) {
$parcel$export(module.exports, "useNudgeStateV2a", () => $51c7f399587b4997$export$1721ab60f4854021);
$parcel$export(module.exports, "useNudgeStateYourWork", () => $51c7f399587b4997$export$766742495b6411cb);
$parcel$export(module.exports, "useNudgeStateJiraToJpd", () => $51c7f399587b4997$export$13bdd3f195e673d5);
$parcel$export(module.exports, "useNudgeStateJiraToLoom", () => $51c7f399587b4997$export$8536e84a1114567e);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $kwi6w = parcelRequire("kwi6w");
const $51c7f399587b4997$var$getNudgeState = async (key, accountId)=>{
    if (!accountId) return 'NONE';
    const nudgeState = await (0, $kwi6w.getUserProperty)({
        accountId: accountId,
        propertyKey: key,
        defaultValue: 'NONE'
    });
    return nudgeState.value;
};
const $51c7f399587b4997$var$setNudgeDismissState = async (key, accountId)=>{
    if (!accountId) return;
    await (0, $kwi6w.setUserProperty)({
        accountId: accountId,
        propertyKey: key,
        propertyValue: 'DISMISSED'
    });
};
const $51c7f399587b4997$var$useNudgeState = (key)=>{
    const accountId = (0, $e6YEs.useAccountId)();
    return (0, $eJOHy.useMemo)(()=>({
            getNudgeState: ()=>$51c7f399587b4997$var$getNudgeState(key, accountId),
            setNudgeDismissed: ()=>$51c7f399587b4997$var$setNudgeDismissState(key, accountId)
        }), [
        accountId,
        key
    ]);
};
const $51c7f399587b4997$export$1721ab60f4854021 = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_CONFLUENCE_V2A');
const $51c7f399587b4997$export$766742495b6411cb = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_YOUR_WORK');
const $51c7f399587b4997$export$13bdd3f195e673d5 = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_JIRA_TO_JPD');
const $51c7f399587b4997$export$8536e84a1114567e = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_JIRA_TO_LOOM');

});

const $c7deaa9431a15ff8$export$a4b45159adbcc3d7 = 3;


parcelRegister("efQhD", function(module, exports) {
$parcel$export(module.exports, "useJpdCrossJoinNudge", () => $0ff9578fdc96521c$export$b59148260d6e0135);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $83DiZ = parcelRequire("83DiZ");

var $2zVtv = parcelRequire("2zVtv");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $cYLBX = parcelRequire("cYLBX");

var $2G4e8 = parcelRequire("2G4e8");

var $aruII = parcelRequire("aruII");

var $blDud = parcelRequire("blDud");

var $5Ilbg = parcelRequire("5Ilbg");

const $0ff9578fdc96521c$var$MAX_NUMBER_OF_JPD_COLLABORATORS = 10;
const $0ff9578fdc96521c$export$b59148260d6e0135 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const currentProduct = (0, $2zVtv.useCurrentProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'jira-product-discovery', $0ff9578fdc96521c$var$MAX_NUMBER_OF_JPD_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $blDud.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $5Ilbg.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $aruII.useRequestAccessErrorFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { snoozeFor30Days: snoozeFor30Days, getVisitedCount: getVisitedCount, increaseVisitedCount: increaseVisitedCount } = (0, $ljWHg.useSnooze)('crossJoinNudgesJiraToJpd');
    const { getNudgeState: getNudgeState, setNudgeDismissed: setNudgeDismissed } = (0, $2G4e8.useNudgeStateJiraToJpd)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const startTimestamp = Date.now();
            const collaboratorsOnJpd = await getFilteredCollaborators();
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $iaIqW.requestAccess)('jira-product-discovery', currentProduct, cloudId, userId, 'crossJoinNudgesJiraToJpd', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/jira/projects');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('jira-product-discovery');
                } catch  {
                    showErrorFlag('jira-product-discovery');
                }
            };
            const isUserOptOut = await getNudgeState() === 'DISMISSED';
            const featureVisitedCount = await getVisitedCount();
            if (isUserOptOut || featureVisitedCount >= (0, $c7deaa9431a15ff8$export$a4b45159adbcc3d7)) return;
            showRequestAccessPromptFlag({
                users: collaboratorsOnJpd,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissed,
                snoozeFor30Days: snoozeFor30Days,
                integration: 'crossJoinNudgesJiraToJpd',
                featureVisitedCount: featureVisitedCount,
                messageParser: (0, $blDud.getJPDCJNMessageStrings),
                eventAttributes: (0, $blDud.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnJpd,
                    featureVisitedCount: featureVisitedCount,
                    startTimestamp: startTimestamp
                })
            });
            await Promise.all([
                increaseVisitedCount(featureVisitedCount + 1),
                (0, $ljWHg.cjnEligibilityCacheHandler).set('has_seen_jpd', {
                    value: true
                }),
                (0, $ljWHg.setHasSeenNudgeInLast7Days)()
            ]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        currentProduct,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeState,
        getVisitedCount,
        increaseVisitedCount,
        push,
        setNudgeDismissed,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        snoozeFor30Days,
        userId
    ]);
};

});
parcelRegister("aruII", function(module, exports) {
$parcel$export(module.exports, "useRequestAccessErrorFlag", () => $cd3ee887d4b607ed$export$d8e2d94eec4efe85);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $4cTDP = parcelRequire("4cTDP");

var $fyI8g = parcelRequire("fyI8g");
var $2pgjF = parcelRequire("2pgjF");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $fnw8E = parcelRequire("fnw8E");

var $csiXm = parcelRequire("csiXm");

var $iOI0S = parcelRequire("iOI0S");
const $cd3ee887d4b607ed$export$d8e2d94eec4efe85 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagService)();
    return (0, $eJOHy.useCallback)((product)=>{
        const id = `error-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fyI8g.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd3ee887d4b607ed$export$e1d0d64874873c8b, {
                    ...props,
                    id: id,
                    product: product,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $cd3ee887d4b607ed$export$e1d0d64874873c8b = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $iOI0S.messages).title, {
            productDisplayName: (0, $fnw8E.ProductDisplayNames)[props.product]
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $iOI0S.messages).description), (0, $4cTDP.fg)('replace-anchor-with-link__groot-growth') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $iOI0S.messages).action)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $iOI0S.messages).action)), "."))
    });
};

});
parcelRegister("fnw8E", function(module, exports) {
$parcel$export(module.exports, "ProductDisplayNames", () => $234d97a33b81d80d$export$46d857911d19ac95);
const $234d97a33b81d80d$export$46d857911d19ac95 = {
    confluence: 'Confluence',
    'jira-product-discovery': 'Jira Product Discovery',
    loom: 'Loom'
};

});

parcelRegister("iOI0S", function(module, exports) {
$parcel$export(module.exports, "messages", () => $66d518c3cbacea68$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $66d518c3cbacea68$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-error-flag.title",
        "defaultMessage": "We couldn't add you to {productDisplayName}"
    },
    description: {
        "id": "cross-join-nudges.request-access-error-flag.description",
        "defaultMessage": "Try again in a few minutes. If you still aren't able to join, "
    },
    action: {
        "id": "cross-join-nudges.request-access-error-flag.action",
        "defaultMessage": "contact support"
    }
});

});


parcelRegister("blDud", function(module, exports) {
$parcel$export(module.exports, "useRequestAccessPromptFlag", () => $b205f495b5e2eb08$export$233a6a0aca8c9091);
$parcel$export(module.exports, "getAnalyticsAttributes", () => $b205f495b5e2eb08$export$e748b6351ba5f204);
$parcel$export(module.exports, "getContextualBanditAnalyticsAttributes", () => $b205f495b5e2eb08$export$53c813e9a54d378a);
$parcel$export(module.exports, "getLLMAnalyticsAttributes", () => $b205f495b5e2eb08$export$882b0d75f031b08b);
$parcel$export(module.exports, "getContextualBanditCJNMessageParser", () => $b205f495b5e2eb08$export$7e2ad46880c00991);
$parcel$export(module.exports, "getJPDCJNMessageStrings", () => $b205f495b5e2eb08$export$77b0d0ed99f701d0);
$parcel$export(module.exports, "getLoomCJNMessageStrings", () => $b205f495b5e2eb08$export$6c15cf35e6ded22d);
$parcel$export(module.exports, "getLLMCJNMessageParser", () => $b205f495b5e2eb08$export$d9d7a49d4bfff37f);

var $eJOHy = parcelRequire("eJOHy");

var $fyI8g = parcelRequire("fyI8g");
var $cSXp8 = parcelRequire("cSXp8");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $5QB52 = parcelRequire("5QB52");

var $csiXm = parcelRequire("csiXm");

var $6Jmsm = parcelRequire("6Jmsm");

var $b6Mjq = parcelRequire("b6Mjq");
const $b205f495b5e2eb08$export$233a6a0aca8c9091 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)(({ users: users, onOptout: onOptout, onSubmit: onSubmit, snoozeFor30Days: snoozeFor30Days, snoozeFor7Days: snoozeFor7Days, integration: integration, eventAttributes: eventAttributes, messageParser: messageParser, featureVisitedCount: featureVisitedCount = 0 })=>{
        const id = `request-access-${(0, $csiXm.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $fyI8g.dismissFlag)(id));
        const submit = async ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', integration, eventAttributes);
            dismissTheFlag();
            await onSubmit();
        };
        const dismissAndOptout = ()=>{
            dismissTheFlag();
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'flag optedOut', integration, eventAttributes);
            onOptout();
        };
        const dismissAndSnooze = ()=>{
            dismissTheFlag();
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', integration, {
                ...eventAttributes,
                snoozeDays: 30
            });
            snoozeFor30Days();
        };
        const dismiss = ()=>{
            const isFirstVisit = featureVisitedCount === 0;
            // Snooze for 7 days if dismissFor7Days is enabled and snoozeFor7Days function is provided
            if (isFirstVisit) {
                if (snoozeFor7Days) {
                    dismissTheFlag();
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', integration, {
                        ...eventAttributes,
                        snoozeDays: 7
                    });
                    snoozeFor7Days();
                } else {
                    dismissTheFlag();
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', integration, eventAttributes);
                }
            } else dismissAndSnooze();
        };
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', integration, eventAttributes);
        const cjnMessages = messageParser(formatMessage);
        const avatarOrientation = integration === 'crossJoinNudgesJiraToJpd' || integration === 'crossJoinNudgesJiraToLoom' ? 'horizontal' : 'vertical';
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b6Mjq.RequestAccessPromptFlag), {
                    ...props,
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    onSnoozeAndDismiss: dismissAndSnooze,
                    onOptoutAndDismiss: dismissAndOptout,
                    onSubmit: submit,
                    avatarOrientation: avatarOrientation,
                    messages: cjnMessages,
                    featureVisitedCount: featureVisitedCount
                })
        });
    }, [
        formatMessage,
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
function $b205f495b5e2eb08$export$af59011edc35e856(timestampInMs) {
    const currentTime = Date.now();
    return ((currentTime - timestampInMs) / 1000).toFixed(3);
}
const $b205f495b5e2eb08$export$e748b6351ba5f204 = ({ users: users, userId: userId, sessionId: sessionId, featureVisitedCount: featureVisitedCount, startTimestamp: startTimestamp, snoozeDays: snoozeDays })=>{
    return {
        collaborators: users.length,
        userId: userId,
        sessionId: sessionId,
        featureVisitedCount: featureVisitedCount,
        eligibilityLatencySeconds: $b205f495b5e2eb08$export$af59011edc35e856(startTimestamp),
        snoozeDays: snoozeDays
    };
};
const $b205f495b5e2eb08$export$53c813e9a54d378a = ({ entityId: entityId, isContextualBandit: isContextualBandit, ...args })=>{
    return {
        ...$b205f495b5e2eb08$export$e748b6351ba5f204(args),
        isContextualBandit: isContextualBandit,
        entityId: entityId
    };
};
const $b205f495b5e2eb08$export$882b0d75f031b08b = ({ firstName: firstName, companyName: companyName, generatedTitle: generatedTitle, generatedBody: generatedBody, ...rest })=>{
    function normalize(content) {
        return content.replaceAll(/[\W\d_]/g, '').toLowerCase();
    }
    function hasMatchingValue(value) {
        const r = new RegExp(normalize(value));
        return Boolean(value && (r.test(normalize(generatedTitle)) || r.test(normalize(generatedBody))));
    }
    return {
        ...$b205f495b5e2eb08$export$e748b6351ba5f204(rest),
        contentHasFirstName: hasMatchingValue(firstName),
        contentHasCompanyName: hasMatchingValue(companyName),
        isLLMv2: true
    };
};
const $b205f495b5e2eb08$export$7e2ad46880c00991 = ({ isContextualBandit: isContextualBandit, entityId: entityId, featureVisitedCount: featureVisitedCount })=>{
    return (formatMessage)=>{
        const dynamicMessages = (0, $5QB52.getDynamicMessages)(isContextualBandit, entityId) || (0, $6Jmsm.messages);
        const infoFlagTitle = isContextualBandit ? formatMessage((0, $6Jmsm.messages).title) : formatMessage((0, $6Jmsm.messages).urgencyTitle, {
            viewCount: featureVisitedCount
        });
        return {
            title: infoFlagTitle,
            description: formatMessage(dynamicMessages.description),
            joinButton: formatMessage(dynamicMessages.joinButton),
            remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
            notInterestedButton: formatMessage((0, $6Jmsm.messages).notInterestedButton)
        };
    };
};
const $b205f495b5e2eb08$export$77b0d0ed99f701d0 = (formatMessage)=>{
    return {
        title: formatMessage((0, $6Jmsm.messages).titleJpdNudge),
        description: formatMessage((0, $6Jmsm.messages).descriptionJpdNudge),
        joinButton: formatMessage((0, $6Jmsm.messages).getStartedButton),
        remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
        notInterestedButton: formatMessage((0, $6Jmsm.messages).doNotShowAgainButton)
    };
};
const $b205f495b5e2eb08$export$6c15cf35e6ded22d = ({ collaborators: collaborators })=>{
    return (formatMessage)=>{
        const getDescription = ()=>{
            if (collaborators.length === 0) return formatMessage((0, $6Jmsm.messages).descriptionLoomNudge);
            const [first, second] = collaborators;
            let description;
            if (collaborators.length === 1) description = formatMessage((0, $6Jmsm.messages).descriptionLoomNudgeWithOneCollaborator, {
                collaboratorOne: first.name
            });
            else if (collaborators.length === 2) description = formatMessage((0, $6Jmsm.messages).descriptionLoomNudgeWithTwoCollaborators, {
                collaboratorOne: first.name,
                collaboratorTwo: second.name
            });
            else description = formatMessage((0, $6Jmsm.messages).descriptionLoomNudgeWithMoreThanTwoCollaborators, {
                collaboratorOne: first.name,
                collaboratorCount: collaborators.length - 1
            });
            return description;
        };
        return {
            title: formatMessage((0, $6Jmsm.messages).titleLoomNudge),
            description: getDescription(),
            joinButton: formatMessage((0, $6Jmsm.messages).getStartedButton),
            remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
            notInterestedButton: formatMessage((0, $6Jmsm.messages).notInterestedButton)
        };
    };
};
const $b205f495b5e2eb08$export$d9d7a49d4bfff37f = ({ title: title, description: description })=>{
    return (formatMessage)=>{
        return {
            title: title,
            description: description,
            joinButton: formatMessage((0, $6Jmsm.messages).joinButtonLlmGeneratedV2),
            remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButtonLlmGeneratedV2),
            notInterestedButton: formatMessage((0, $6Jmsm.messages).notInterestedButton)
        };
    };
};

});
parcelRegister("b6Mjq", function(module, exports) {
$parcel$export(module.exports, "RequestAccessPromptFlag", () => $06b71c6e3e5de02d$export$9b8813c3601640da);
/* flag-common.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $3Wh6p = parcelRequire("3Wh6p");
var $bQP4O = parcelRequire("bQP4O");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $2pgjF = parcelRequire("2pgjF");

var $3SOCn = parcelRequire("3SOCn");

var $hUlSA = parcelRequire("hUlSA");
const $06b71c6e3e5de02d$export$9b8813c3601640da = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptoutAndDismiss: onOptoutAndDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, messages: messages, avatarOrientation: avatarOrientation, featureVisitedCount: featureVisitedCount, ...props })=>{
    const handleOnSubmit = (0, $eJOHy.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const customFlagFooterProps = (0, $eJOHy.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, $3SOCn.noop)
                }
            ],
            linkComponent: ()=>{
                let secondETA = null;
                if (featureVisitedCount === 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: onSnoozeAndDismiss
                }, messages.remindMeLaterButton);
                else if (featureVisitedCount > 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: onOptoutAndDismiss
                }, messages.notInterestedButton);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: handleOnSubmit
                }, messages.joinButton), !!secondETA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                    className: (0, $hcewu.default)([
                        "_1kt95qml _fntnutpp _eid3utpp"
                    ])
                }), secondETA);
            }
        }), [
        featureVisitedCount,
        handleOnSubmit,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $eJOHy.useMemo)(()=>{
        return users.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hUlSA.FlagCompatibleAvatarGroup), {
            alignment: avatarOrientation,
            maxAvatarCount: 2,
            tooltipPosition: "bottom",
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            size: "small",
            boundariesElement: "scrollParent"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #1D7AFC)",
            label: ""
        });
    }, [
        users,
        avatarOrientation
    ]);
    const FLAG_MESSAGE_TYPE = 'marketing';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: messages.title,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
            className: (0, $hcewu.default)([
                "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0ccj1k _sudp1e54 _otyru2gc"
            ])
        }, messages.description)),
        icon: customIcon,
        messageType: FLAG_MESSAGE_TYPE,
        messageId: "cross-join-nudges.ui.request-access-prompt-flag.info-flag.request-access-prompt-flag"
    });
};
const $06b71c6e3e5de02d$var$linkButtonStyles = (0, $1DXK0.xcss)({
    maxWidth: '150',
    maxHeight: '3lh',
    overflow: 'hidden',
    color: 'color.link',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: '0',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    cursor: 'pointer',
    padding: '0',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $06b71c6e3e5de02d$var$linkButtonSeparatorStyles = null;
const $06b71c6e3e5de02d$var$mainContentContainerStyles = null;

});
parcelRegister("3SOCn", function(module, exports) {
$parcel$export(module.exports, "noop", () => $4339374a2a8f4e6a$export$8793edee2d425525);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $4339374a2a8f4e6a$export$8793edee2d425525 = ()=>{};

});

parcelRegister("hUlSA", function(module, exports) {
$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $a339e7e80c202910$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $iwbbq = parcelRequire("iwbbq");

var $gqBnP = parcelRequire("gqBnP");

var $3SOCn = parcelRequire("3SOCn");
const $a339e7e80c202910$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $a339e7e80c202910$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $a339e7e80c202910$export$29beada2d5f93289 = ({ alignment: alignment, maxAvatarCount: maxAvatarCount, tooltipPosition: tooltipPosition, data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $eJOHy.useMemo)(()=>$a339e7e80c202910$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ // @ts-ignore
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, $3SOCn.noop),
        ...props
    });
    if (alignment === 'vertical') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a339e7e80c202910$var$VerticalAvatarGroupContainer, null, avatarGroup);
    return avatarGroup;
};
const $a339e7e80c202910$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount })=>{
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $a339e7e80c202910$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $a339e7e80c202910$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $a339e7e80c202910$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $a339e7e80c202910$var$OVERFLOW_USER_MARKER
    });
const $a339e7e80c202910$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iwbbq.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a339e7e80c202910$var$AvatarOverflowCountContainer, null, `+${Math.min(overflowCount, $a339e7e80c202910$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a339e7e80c202910$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb1osq _4t3i1osq _1e0c11p5 _bfhkm7j4 _syaz1fxt _y3gn1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $a339e7e80c202910$var$VerticalAvatarGroupContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ogvv1bp4 _3mc9idpf _1hlaidpf _1qu0x0bf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("5Ilbg", function(module, exports) {
$parcel$export(module.exports, "useRequestAccessSuccessFlag", () => $d17f1500a13d668e$export$184b02cbba392fc0);

var $eJOHy = parcelRequire("eJOHy");

var $fyI8g = parcelRequire("fyI8g");
var $2pgjF = parcelRequire("2pgjF");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $csiXm = parcelRequire("csiXm");

var $b4yA6 = parcelRequire("b4yA6");
const $d17f1500a13d668e$export$184b02cbba392fc0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagService)();
    return (0, $eJOHy.useCallback)(()=>{
        const id = `success-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fyI8g.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d17f1500a13d668e$export$567128fc1024c9cf, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $d17f1500a13d668e$export$567128fc1024c9cf = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.SuccessFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $b4yA6.messages).title),
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $b4yA6.messages).description))
    });
};

});
parcelRegister("b4yA6", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1a8ff2ae59932fa6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1a8ff2ae59932fa6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-success-flag.title",
        "defaultMessage": "A request was sent to your admins"
    },
    description: {
        "id": "cross-join-nudges.request-access-success-flag.description",
        "defaultMessage": "You'll receive an email once they've reviewed it."
    }
});

});



parcelRegister("e1MDs", function(module, exports) {
$parcel$export(module.exports, "useLoomCrossJoinNudge", () => $84797a39bfdf70c3$export$8614cf5ece273d5b);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $2zVtv = parcelRequire("2zVtv");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $cYLBX = parcelRequire("cYLBX");

var $2G4e8 = parcelRequire("2G4e8");

var $aruII = parcelRequire("aruII");

var $blDud = parcelRequire("blDud");

var $5Ilbg = parcelRequire("5Ilbg");

var $b66qx = parcelRequire("b66qx");

const $84797a39bfdf70c3$var$MAX_NUMBER_OF_LOOM_COLLABORATORS = 10;
const $84797a39bfdf70c3$var$openLoomInANewTab = ()=>{
    if (typeof globalThis === 'undefined') return;
    const newTab = globalThis.window?.open('https://www.loom.com/spaces', '_blank');
    if (newTab) newTab.focus();
};
const $84797a39bfdf70c3$export$8614cf5ece273d5b = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const currentProduct = (0, $2zVtv.useCurrentProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'loom', $84797a39bfdf70c3$var$MAX_NUMBER_OF_LOOM_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $blDud.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $5Ilbg.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $aruII.useRequestAccessErrorFlag)();
    const fireLoomCjnFeatureExposedEventOnce = (0, $b66qx.useFireLoomCjnFeatureExposedEventOnce)();
    const { snoozeFor7Days: snoozeFor7Days, snoozeFor30Days: snoozeFor30Days, getVisitedCount: getVisitedCount, increaseVisitedCount: increaseVisitedCount } = (0, $ljWHg.useSnooze)('crossJoinNudgesJiraToLoom');
    const { getNudgeState: getNudgeState, setNudgeDismissed: setNudgeDismissed } = (0, $2G4e8.useNudgeStateJiraToLoom)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const startTimestamp = Date.now();
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $iaIqW.requestAccess)('loom', currentProduct, cloudId, userId, 'crossJoinNudgesJiraToLoom', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') // This is an exception as the eligibilty check fails when user has access to loom
                    $84797a39bfdf70c3$var$openLoomInANewTab();
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('loom');
                } catch  {
                    showErrorFlag('loom');
                }
            };
            const isUserOptOut = await getNudgeState() === 'DISMISSED';
            const featureVisitedCount = await getVisitedCount();
            if (isUserOptOut || featureVisitedCount >= (0, $c7deaa9431a15ff8$export$a4b45159adbcc3d7)) return;
            fireLoomCjnFeatureExposedEventOnce({
                cohort: (0, $cxKOj.expVal)('twcg-442-cjn-jira-loom', 'cohort', 'not-enrolled'),
                flagKey: 'twcg-442-cjn-jira-loom'
            });
            // These snooze functions are for the case when user does not interact with the nudge
            if (featureVisitedCount === 0) snoozeFor7Days();
            else if (featureVisitedCount > 0) snoozeFor30Days();
            const collaboratorsOnLoom = await getFilteredCollaborators();
            if ((0, $cxKOj.expValEquals)('twcg-442-cjn-jira-loom', 'cohort', 'variation', 'not-enrolled')) {
                showRequestAccessPromptFlag({
                    users: collaboratorsOnLoom,
                    onSubmit: onSubmit,
                    onOptout: setNudgeDismissed,
                    snoozeFor7Days: snoozeFor7Days,
                    snoozeFor30Days: snoozeFor30Days,
                    integration: 'crossJoinNudgesJiraToLoom',
                    featureVisitedCount: featureVisitedCount,
                    messageParser: (0, $blDud.getLoomCJNMessageStrings)({
                        collaborators: collaboratorsOnLoom
                    }),
                    eventAttributes: (0, $blDud.getAnalyticsAttributes)({
                        userId: userId,
                        users: collaboratorsOnLoom,
                        featureVisitedCount: featureVisitedCount,
                        startTimestamp: startTimestamp
                    })
                });
                increaseVisitedCount(featureVisitedCount + 1);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToLoom', error, {
                cloudId: cloudId,
                jiraToLoomCrossJoinNudgesErrorType: 'nudgeViewedFailed'
            });
        }
    }, [
        cloudId,
        currentProduct,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeState,
        getVisitedCount,
        increaseVisitedCount,
        setNudgeDismissed,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        snoozeFor7Days,
        snoozeFor30Days,
        userId,
        fireLoomCjnFeatureExposedEventOnce
    ]);
};

});
parcelRegister("b66qx", function(module, exports) {
$parcel$export(module.exports, "useHasSeenNudgesBefore", () => $1b4c7c805d728733$export$550b3148800324ae);
$parcel$export(module.exports, "useFireLoomCjnFeatureExposedEventOnce", () => $1b4c7c805d728733$export$93d9fa9d1d3cd3fe);
$parcel$export(module.exports, "useLoomCrossJoinNudgeEligibility", () => $1b4c7c805d728733$export$6caa1b1b8b98e855);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cHtIB = parcelRequire("cHtIB");

var $8Ujbi = parcelRequire("8Ujbi");

var $fZulj = parcelRequire("fZulj");

var $ljWHg = parcelRequire("ljWHg");
const $1b4c7c805d728733$export$550b3148800324ae = ()=>{
    const userId = (0, $e6YEs.useAccountId)() || '';
    return (0, $eJOHy.useCallback)(async ()=>{
        function hasSeenJpdNudge() {
            const cachedHasSeenJpd = (0, $ljWHg.withEligibilityCache)('has_seen_jpd', async ()=>{
                const count = await (0, $ljWHg.getFeatureVisitedCount)(userId, (0, $ljWHg.getCountCacheKey)('crossJoinNudgesJiraToJpd'));
                return count > 0;
            });
            return cachedHasSeenJpd();
        }
        function hasSeenConfluenceNudge() {
            const cachedHasSeenConf = (0, $ljWHg.withEligibilityCache)('has_seen_conf', async ()=>{
                const count = await (0, $ljWHg.getFeatureVisitedCount)(userId, (0, $ljWHg.getCountCacheKey)('crossJoinNudgesConfluence'));
                return count > 0;
            });
            return cachedHasSeenConf();
        }
        const hasSeenConfluence = hasSeenConfluenceNudge();
        const hasSeenJpd = hasSeenJpdNudge();
        const hasSeenOtherNudges = await Promise.all([
            hasSeenConfluence,
            hasSeenJpd
        ]);
        return hasSeenOtherNudges.some((check)=>check);
    }, [
        userId
    ]);
};
const $1b4c7c805d728733$export$93d9fa9d1d3cd3fe = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const eventIsFiredRef = (0, $eJOHy.useRef)(false);
    return (0, $eJOHy.useCallback)(({ cohort: cohort, flagKey: flagKey })=>{
        if (eventIsFiredRef.current) return;
        if (cohort === 'not-enrolled') return;
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'crossJoinNudgesJiraToLoomFeature exposed', {
            flagKey: flagKey,
            cohort: cohort
        });
        eventIsFiredRef.current = true;
    }, [
        createAnalyticsEvent
    ]);
};
const $1b4c7c805d728733$export$6caa1b1b8b98e855 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const checkLoomCrossJoinNudgeEligibility = (0, $fZulj.useCheckLoomCrossJoinNudgeEligibility)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const eligibilityResponse = await checkLoomCrossJoinNudgeEligibility();
            if (!eligibilityResponse.eligible) {
                if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToLoom');
                return {
                    isEligible: false,
                    ineligibleReason: eligibilityResponse.ineligibilityReason
                };
            }
            return {
                isEligible: true,
                data: {}
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToLoom', error, {
                cloudId: cloudId,
                jiraToLoomCrossJoinNudgesErrorType: 'eligibilityCheckFailed'
            });
            return {
                isEligible: false,
                ineligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        checkLoomCrossJoinNudgeEligibility
    ]);
};

});
parcelRegister("fZulj", function(module, exports) {
$parcel$export(module.exports, "useCheckLoomCrossJoinNudgeEligibility", () => $43a9f807f197e9ff$export$3ff9ff4e66b3e110);

var $eJOHy = parcelRequire("eJOHy");

var $cHtIB = parcelRequire("cHtIB");

var $1Ru5V = parcelRequire("1Ru5V");

var $e6YEs = parcelRequire("e6YEs");

var $ftN6c = parcelRequire("ftN6c");

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $gnRyQ = parcelRequire("gnRyQ");

var $ljWHg = parcelRequire("ljWHg");
const $43a9f807f197e9ff$export$3ff9ff4e66b3e110 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)(async ()=>{
        const cachedIsSiteOptedOut = (0, $ljWHg.withEligibilityCache)('site_is_opted_out', (0, $dWhgU.isSiteOptedOut), 0.2);
        const cachedIsSite7DaysOld = (0, $ljWHg.withEligibilityCache)('loom_site_is_more_than_7_days_old', (0, $fWKBM.isLoomSite7DaysOld), 1);
        const cachedIsNewActiveUser = (0, $ljWHg.withEligibilityCache)('user_is_too_new_for_loom', (0, $gnRyQ.isNewActiveUser), 1);
        const cachedHasProductAccess = (0, $ljWHg.withEligibilityCache)('user_already_has_loom_access', (0, $hQEY6.hasProductAccess), 0.2);
        const cachedIsRequestAccessCapable = (0, $ljWHg.withEligibilityCache)('user_can_request_loom_access', (0, $lUO6r.fetchIsRequestAccessCapable), 0.2);
        // if the snooze is still active, return false
        if (await (0, $ljWHg.getHasSeenNudgeInLast7Days)()) return {
            eligible: false,
            ineligibilityReason: 'RECENTLY_SEEN_CROSS_JOIN_NUDGE'
        };
        if ((0, $ljWHg.getFeatureVisited)('crossJoinNudgesJiraToLoom')) return {
            eligible: false,
            ineligibilityReason: 'STILL_ON_SNOOZE'
        };
        // loom is installed on this site
        if (!licensedProducts.loom) return {
            eligible: false,
            ineligibilityReason: 'NO_LOOM_LICENCE'
        };
        if (await cachedIsSiteOptedOut(cloudId)) return {
            eligible: false,
            ineligibilityReason: 'SITE_OPTED_OUT'
        };
        if (!await cachedIsSite7DaysOld(cloudId)) return {
            eligible: false,
            ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
        };
        if (await cachedIsNewActiveUser(cloudId, userId, 14)) return {
            eligible: false,
            ineligibilityReason: 'NEW_ACTIVE_USER'
        };
        // has access to loom on this site
        if (await cachedHasProductAccess('loom', cloudId)) return {
            eligible: false,
            ineligibilityReason: 'ALREADY_HAVE_ACCESS'
        };
        if (!await cachedIsRequestAccessCapable('loom', cloudId, createAnalyticsEvent)) return {
            eligible: false,
            ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
        };
        return {
            eligible: true
        };
    }, [
        cloudId,
        createAnalyticsEvent,
        licensedProducts.loom,
        userId
    ]);
};

});



parcelRegister("lnwEo", function(module, exports) {
$parcel$export(module.exports, "useConfluenceCrossJoinNudge", () => $b19d5fb78027e87b$export$83876d794dc56d4f);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $83DiZ = parcelRequire("83DiZ");

var $2zVtv = parcelRequire("2zVtv");

var $cxKOj = parcelRequire("cxKOj");

var $2UBs9 = parcelRequire("2UBs9");

var $9yo90 = parcelRequire("9yo90");

var $1M2hR = parcelRequire("1M2hR");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $cYLBX = parcelRequire("cYLBX");

var $2G4e8 = parcelRequire("2G4e8");

var $d2DJQ = parcelRequire("d2DJQ");

var $dK92f = parcelRequire("dK92f");

var $aruII = parcelRequire("aruII");

var $blDud = parcelRequire("blDud");

var $5Ilbg = parcelRequire("5Ilbg");
const $b19d5fb78027e87b$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $b19d5fb78027e87b$export$83876d794dc56d4f = ()=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const currentProduct = (0, $2zVtv.useCurrentProduct)();
    const getNudgeRecommendations = (0, $d2DJQ.useNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const cloudId = (0, $cHtIB.useCloudId)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $b19d5fb78027e87b$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $blDud.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $5Ilbg.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $aruII.useRequestAccessErrorFlag)();
    const { setNudgeDismissed: setNudgeDismissedV2a } = (0, $2G4e8.useNudgeStateV2a)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const userId = (0, $e6YEs.useAccountId)() || '';
    const locale = (0, $1M2hR.useLocale)();
    const requestAccessService = (0, $4cTDP.fg)('expansion_services_in_cjn') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2UBs9.useService)((0, $9yo90.requestAccess)) : null;
    return (0, $eJOHy.useCallback)(async ({ featureVisitedCount: featureVisitedCount }, allowLlm = true)=>{
        const startTimestamp = Date.now();
        try {
            async function onSubmit() {
                try {
                    try {
                        let accessStatus;
                        if (requestAccessService && (0, $4cTDP.fg)('expansion_services_in_cjn')) {
                            const serviceResult = await requestAccessService({
                                product: 'confluence',
                                integration: 'crossJoinNudgesConfluence'
                            });
                            if (serviceResult.error) {
                                (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesConfluence', serviceResult.error);
                                throw serviceResult.error;
                            }
                            accessStatus = serviceResult.result;
                        } else accessStatus = await (0, $iaIqW.requestAccess)('confluence', currentProduct, cloudId, userId, 'crossJoinNudgesConfluence', createAnalyticsEvent);
                        if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                        else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                        else showErrorFlag('confluence');
                    } catch  {
                        showErrorFlag('confluence');
                    }
                } catch  {
                    showErrorFlag('confluence');
                }
            }
            const isEnglishLocale = locale && locale.startsWith('en');
            const collaborators = await getFilteredCollaborators();
            const hasNoCollaborators = collaborators.length === 0;
            const cachedLlmNewUser = (0, $ljWHg.withEligibilityCache)('user_new_for_llm_exp_v2', ()=>Promise.resolve(featureVisitedCount === 0));
            const userNeverSawConfNudgeBeforeLlmExp = await cachedLlmNewUser();
            if ((0, $4cTDP.fg)('twcg-915-growth-exp-jira-cjn-llm-gate')) {
                if (allowLlm && isEnglishLocale && hasNoCollaborators && userNeverSawConfNudgeBeforeLlmExp === true) {
                    /**
						 * In order to avoid an experiment bias for twcg-915-growth-exp-jira-cjn-llm we need to
						 * pregenerate content and return early for all cohorts if content isn't available
						 * https://atlassian.slack.com/archives/C08RDQB03EJ/p1755151418360249?thread_ts=1755147153.025819&cid=C08RDQB03EJ
						 */ const result = await (0, $dK92f.generateCJNContent)();
                    if (!result.ready) {
                        (0, $ljWHg.removeFeatureVisited)('crossJoinNudgesConfluence');
                        return;
                    }
                    (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
                        flagKey: 'twcg-915-growth-exp-jira-cjn-llm',
                        enrolment: (0, $cxKOj.expVal)('twcg-915-growth-exp-jira-cjn-llm', 'cohort', 'not_enrolled')
                    });
                    if ((0, $cxKOj.expValEquals)('twcg-915-growth-exp-jira-cjn-llm', 'cohort', 'Variation')) {
                        showRequestAccessPromptFlag({
                            users: collaborators,
                            onSubmit: onSubmit,
                            onOptout: setNudgeDismissedV2a,
                            snoozeFor30Days: ()=>(0, $ljWHg.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                            integration: 'crossJoinNudgesConfluence',
                            featureVisitedCount: featureVisitedCount,
                            messageParser: (0, $blDud.getLLMCJNMessageParser)({
                                title: result.title,
                                description: result.body
                            }),
                            eventAttributes: (0, $blDud.getLLMAnalyticsAttributes)({
                                users: collaborators,
                                userId: userId,
                                sessionId: sessionId.current,
                                featureVisitedCount: featureVisitedCount,
                                startTimestamp: startTimestamp,
                                companyName: result.metadata.companyName,
                                firstName: result.metadata.firstName,
                                generatedBody: result.body,
                                generatedTitle: result.title
                            })
                        });
                        await Promise.all([
                            (0, $ljWHg.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1),
                            (0, $ljWHg.cjnEligibilityCacheHandler).set('has_seen_conf', {
                                value: true
                            }),
                            (0, $ljWHg.cjnEligibilityCacheHandler).set('has_seen_conf_llm', {
                                value: true
                            })
                        ]);
                        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
                        return;
                    }
                }
            }
            const entityId = hasNoCollaborators ? await getNudgeRecommendations() : undefined;
            showRequestAccessPromptFlag({
                users: collaborators,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissedV2a,
                snoozeFor30Days: ()=>(0, $ljWHg.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                integration: 'crossJoinNudgesConfluence',
                featureVisitedCount: featureVisitedCount,
                messageParser: (0, $blDud.getContextualBanditCJNMessageParser)({
                    isContextualBandit: hasNoCollaborators,
                    entityId: entityId || 'default',
                    featureVisitedCount: featureVisitedCount
                }),
                eventAttributes: (0, $blDud.getContextualBanditAnalyticsAttributes)({
                    users: collaborators,
                    userId: userId,
                    entityId: entityId || 'default',
                    sessionId: sessionId.current,
                    isContextualBandit: hasNoCollaborators,
                    featureVisitedCount: featureVisitedCount,
                    startTimestamp: startTimestamp
                })
            });
            await Promise.all([
                (0, $ljWHg.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1),
                (0, $ljWHg.cjnEligibilityCacheHandler).set('has_seen_conf', {
                    value: true
                }),
                (0, $ljWHg.setHasSeenNudgeInLast7Days)()
            ]);
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        currentProduct,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeRecommendations,
        locale,
        push,
        requestAccessService,
        setNudgeDismissedV2a,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        userId
    ]);
};

});
parcelRegister("dK92f", function(module, exports) {
$parcel$export(module.exports, "generateCJNContent", () => $5cbb915e5e1affc3$export$8f35cea1f9221030);

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");
const $5cbb915e5e1affc3$var$GCGS_JIRA_SPOTLIGHT_URL = '/gateway/api/gcg/api/v1/generate/team_growth/cross_join_nudge/jira_spotlight';
const $5cbb915e5e1affc3$var$ATLASSIAN_ACCOUNT_URL = '/gateway/api/me';
const $5cbb915e5e1affc3$export$8f35cea1f9221030 = async ()=>{
    try {
        const me = await (0, $hgi0g.default)($5cbb915e5e1affc3$var$ATLASSIAN_ACCOUNT_URL);
        const response = await (0, $hgi0g.default)($5cbb915e5e1affc3$var$GCGS_JIRA_SPOTLIGHT_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                contact_name: me.nickname || me.name,
                domain: me.email.split('@')[1],
                product: 'confluence',
                job_title: me.extended_profile.job_title,
                department: me.extended_profile.department,
                team_type: me.extended_profile.team_type
            })
        });
        return {
            title: response.title,
            body: response.body,
            metadata: {
                companyName: response.metadata.company_name,
                firstName: response.metadata.first_name
            },
            // TODO: GROOT-1944 we should remove special handling for this scenario and just throw when we have better overall handling in place that doesn't cause a snooze
            ready: response.status !== 'PROCESSING'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'generateCJNContentFetchFailed',
                packageName: 'jiraCrossJoinNudges',
                teamName: 'groot-growth'
            },
            error: error
        });
        throw new Error('Failed to generate nudge content');
    }
};

});


parcelRegister("cGeZ5", function(module, exports) {
$parcel$export(module.exports, "getHasBeenEnrolledInMsr", () => $a6ece8b7d2b0cc00$export$a03fea1e8104a2a4);
$parcel$export(module.exports, "setEnrolledInMsr", () => $a6ece8b7d2b0cc00$export$31ce9592444f963b);

var $ljWHg = parcelRequire("ljWHg");
const $a6ece8b7d2b0cc00$export$a03fea1e8104a2a4 = ()=>{
    const cachedHasEnrolledMsr = (0, $ljWHg.withEligibilityCache)('has_enrolled_msr_v1', async ()=>{
        // The first time this is accessed without being set, it will be set false
        return false;
    });
    return cachedHasEnrolledMsr();
};
const $a6ece8b7d2b0cc00$export$31ce9592444f963b = ()=>{
    return (0, $ljWHg.cjnEligibilityCacheHandler).set('has_enrolled_msr_v1', {
        value: true
    });
};

});


parcelRegister("41vjk", function(module, exports) {
$parcel$export(module.exports, "AsyncSSRFailureDisplay", () => $7d4b7128b78443ac$export$ce3da1faaf6198d1);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $iWvkh = parcelRequire("iWvkh");

var $cBavF = parcelRequire("cBavF");

var $2JDwW = parcelRequire("2JDwW");
const $7d4b7128b78443ac$var$EMPTY_OBJECT = {};
const $7d4b7128b78443ac$var$LoadEntryPoint = ()=>{
    const hasLoadedEntryPoint = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $2JDwW.ssrFailureDisplayEntryPoint), $7d4b7128b78443ac$var$EMPTY_OBJECT);
    // Docs say to do this not in an effect :/ https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138515/Deprecated+Tutorial+How+to+render+your+EntryPoint+for+async+components#Option-3%3A-Using-useRef-without-user-interaction
    // And they have eslint rules to enforce it
    if (!hasLoadedEntryPoint.current) {
        hasLoadedEntryPoint.current = true;
        entryPointActions.load();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "ssr-failure-display",
        packageName: "@atlassian/jira-ssr-render-guard",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $7d4b7128b78443ac$var$EMPTY_OBJECT
    });
};
const $7d4b7128b78443ac$export$ce3da1faaf6198d1 = ()=>{
    if (!(0, $4cTDP.fg)('staging-only-show-ssr-error')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7d4b7128b78443ac$var$LoadEntryPoint, null);
};
$7d4b7128b78443ac$export$ce3da1faaf6198d1.displayName = 'AsyncSSRFailureDisplay';

});
parcelRegister("2JDwW", function(module, exports) {
$parcel$export(module.exports, "ssrFailureDisplayEntryPoint", () => $0c786d303caf8346$export$3e34e661c7d77f3e);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $0c786d303caf8346$export$3e34e661c7d77f3e = (0, $3Bzqe.createEntryPoint)({
    // eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("cSFr1")).then((module)=>module.SSRFailureDisplay), {
        moduleId: "3b05423d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cSFr1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("avYuq").then(()=>parcelRequire('jqi1P'));

});



parcelRegister("cYjM0", function(module, exports) {
$parcel$export(module.exports, "JiraTrialAssistantWelcomeAutoPopup", () => $d2fbeff18b134a41$export$da72c146398c86d0);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $cxKOj = parcelRequire("cxKOj");

var $2imLM = parcelRequire("2imLM");

var $4EKqI = parcelRequire("4EKqI");

var $bQWwW = parcelRequire("bQWwW");


var $c9MEq = parcelRequire("c9MEq");

const $d2fbeff18b134a41$var$AsyncWelcomeModal = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("1CSpk")).then((module)=>module.WelcomeModalWrapper), {
    moduleId: "./src/packages/growth/jira-trial-assistant/src/ui/welcome-modal/index.tsx"
});
const $d2fbeff18b134a41$var$JiraTrialAssistantWelcomeModal = ()=>{
    const isEligible = (0, $c9MEq.useIsEligibleForTrialAssistantWelcome)() && (0, $cxKOj.expValEquals)('custom_rovo_onboarding_agent', 'cohort', 'variation', 'not-enrolled');
    const triggerRovo = ()=>{
    // TODO: LUNA-648 Configure OOTB Rovo Trigger
    };
    if (!isEligible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "JiraTrialAssistantWelcomeModal",
        packageName: (0, $cd72c585cfe8318c$export$b8b9d90f9e5bd72b),
        teamName: (0, $cd72c585cfe8318c$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-trial-assistant-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-trial-assistant-welcome-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d2fbeff18b134a41$var$AsyncWelcomeModal, {
        onPrimaryCta: triggerRovo
    }))));
};
const $d2fbeff18b134a41$export$da72c146398c86d0 = $d2fbeff18b134a41$var$JiraTrialAssistantWelcomeModal;

});
const $cd72c585cfe8318c$export$d57b6b390e78d90f = 'growth-artemis';
const $cd72c585cfe8318c$export$b8b9d90f9e5bd72b = 'jiraTrialAssistant';
const $cd72c585cfe8318c$export$48e1d3fa57b0a2d5 = 'jiraTrialAssistant';

parcelRegister("c9MEq", function(module, exports) {
$parcel$export(module.exports, "useIsEligibleForTrialAssistantWelcome", () => $b932743944f942a9$export$458c3ff6ba3787df);
$parcel$export(module.exports, "useIsEligibleForTrialAssistantReminder", () => $b932743944f942a9$export$a2e9430012cc0149);

var $eJOHy = parcelRequire("eJOHy");


var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");

var $8Q6yE = parcelRequire("8Q6yE");

var $5tQVZ = parcelRequire("5tQVZ");

var $AJbrA = parcelRequire("AJbrA");

var $kLfcJ = parcelRequire("kLfcJ");

var $4pPqA = parcelRequire("4pPqA");

var $bAlCu = parcelRequire("bAlCu");
const $b932743944f942a9$var$useIsEligibleForJiraTrialAssistant = ()=>{
    const { currentProduct: currentProduct, jiraEdition: jiraEdition } = (0, $bAlCu.useJiraProductAndEdition)();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const currentTimestamp = (0, $eJOHy.useRef)(Date.now());
    const trialEndTime = productEntitlementDetails?.[0, $315aedf92e50a945$export$1346c9aa3cbb477d]?.trialEndTime;
    const billingSourceSystem = productEntitlementDetails?.[0, $315aedf92e50a945$export$1346c9aa3cbb477d]?.billingSourceSystem || 'HAMS';
    return (currentProduct === (0, $lBYgs.JIRA_SOFTWARE) || currentProduct === undefined) && jiraEdition === (0, $cblKs.PREMIUM_EDITION) && billingSourceSystem === 'CCP' && !!trialEndTime && currentTimestamp.current < trialEndTime;
};
const $b932743944f942a9$export$458c3ff6ba3787df = ()=>{
    const isEligibleForExperiment = $b932743944f942a9$var$useIsEligibleForJiraTrialAssistant();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const modalHasBeenSeen = (0, $kLfcJ.getWelcomeModalLastSeen)();
    const trialEndTime = productEntitlementDetails?.[0, $315aedf92e50a945$export$1346c9aa3cbb477d]?.trialEndTime;
    const trialDaysRemaining = (0, $5tQVZ.useMemoizedTrialDaysLeftFromTrialEndTime)(trialEndTime) ?? 0;
    const newToTrial = trialDaysRemaining > 15;
    // Trial assistant welcome modal is shown if:
    // - eligible for experiment
    // - hasn't been on trial for more than N days
    // - and modal hasn't already been shown
    return isEligibleForExperiment && newToTrial && modalHasBeenSeen === undefined;
};
const $b932743944f942a9$export$a2e9430012cc0149 = ()=>{
    const isEligibleForExperiment = $b932743944f942a9$var$useIsEligibleForJiraTrialAssistant();
    const modalWasLastSeen = (0, $kLfcJ.getWelcomeModalLastSeen)() ?? 0;
    const nudgeWasLastSeen = (0, $kLfcJ.getReminderNudgeLastSeen)();
    const hasUsedPremiumFeaturesRecently = (0, $4pPqA.useHasUsedPremiumFeaturesRecently)(3);
    const modalHasBeenSeenRecently = (0, $AJbrA.useIsTimestampWithinXDays)(modalWasLastSeen, 3);
    // Trial assistant nudge is shown if:
    // - eligible for experiment
    // - hasn't used premium features in N days
    // - welcome modal has been shown before but not within N days
    // - and nudge hasn't already been shown
    return isEligibleForExperiment && hasUsedPremiumFeaturesRecently === false && !!modalWasLastSeen && !modalHasBeenSeenRecently && !nudgeWasLastSeen;
};

});
parcelRegister("AJbrA", function(module, exports) {
$parcel$export(module.exports, "useIsTimestampWithinXDays", () => $4c20352bff32449b$export$4ed35e23da6649c7);
$parcel$export(module.exports, "parseAsTimestamp", () => $4c20352bff32449b$export$1188a182880d8193);

var $eJOHy = parcelRequire("eJOHy");

var $lw3Pj = parcelRequire("lw3Pj");
const $4c20352bff32449b$export$4ed35e23da6649c7 = (timestamp, maxDays)=>{
    const now = (0, $eJOHy.useRef)(Date.now());
    if (!timestamp) return false;
    return (0, $lw3Pj.default)(now.current, timestamp) < maxDays;
};
const $4c20352bff32449b$export$1188a182880d8193 = (dateStr)=>{
    if (typeof dateStr !== 'string') return undefined;
    const date = new Date(dateStr);
    const dateTimestamp = date.getTime();
    return !Number.isNaN(dateTimestamp) ? dateTimestamp : undefined;
};

});

parcelRegister("kLfcJ", function(module, exports) {
$parcel$export(module.exports, "getWelcomeModalLastSeen", () => $1e582ea049ab0230$export$56f2f2094d564b60);
$parcel$export(module.exports, "getReminderNudgeLastSeen", () => $1e582ea049ab0230$export$a642b61799c11565);
$parcel$export(module.exports, "setWelcomeModalLastSeen", () => $1e582ea049ab0230$export$f2445c9f730396f1);
$parcel$export(module.exports, "setReminderNudgeLastSeen", () => $1e582ea049ab0230$export$784d00fbd50ebafd);

var $3hRxq = parcelRequire("3hRxq");
const $1e582ea049ab0230$var$CACHE_PREFIX = 'jira_trial_assistant';
const $1e582ea049ab0230$var$WELCOME_MODAL_STORE_KEY = 'welcome_modal_last_time';
const $1e582ea049ab0230$var$REMINDER_NUDGE_STORE_KEY = 'reminder_nudge_last_time';
const $1e582ea049ab0230$var$cache = (0, $3hRxq.createLocalExpirableStorageProvider)($1e582ea049ab0230$var$CACHE_PREFIX);
const $1e582ea049ab0230$var$TIME_TO_LIVE = 7776000000;
const $1e582ea049ab0230$export$56f2f2094d564b60 = ()=>{
    const val = $1e582ea049ab0230$var$cache.get($1e582ea049ab0230$var$WELCOME_MODAL_STORE_KEY);
    return typeof val === 'number' && !Number.isNaN(val) ? val : undefined;
};
const $1e582ea049ab0230$export$a642b61799c11565 = ()=>{
    const val = $1e582ea049ab0230$var$cache.get($1e582ea049ab0230$var$REMINDER_NUDGE_STORE_KEY);
    return typeof val === 'number' && !Number.isNaN(val) ? val : undefined;
};
const $1e582ea049ab0230$export$f2445c9f730396f1 = (now)=>{
    $1e582ea049ab0230$var$cache.set($1e582ea049ab0230$var$WELCOME_MODAL_STORE_KEY, now, now + $1e582ea049ab0230$var$TIME_TO_LIVE);
};
const $1e582ea049ab0230$export$784d00fbd50ebafd = (now)=>{
    $1e582ea049ab0230$var$cache.set($1e582ea049ab0230$var$REMINDER_NUDGE_STORE_KEY, now, now + $1e582ea049ab0230$var$TIME_TO_LIVE);
};

});

parcelRegister("4pPqA", function(module, exports) {
$parcel$export(module.exports, "useHasUsedPremiumFeaturesRecently", () => $c73414d36aba3f3f$export$831601ba32ba977e);

var $eJOHy = parcelRequire("eJOHy");

var $lw3Pj = parcelRequire("lw3Pj");

var $giQoM = parcelRequire("giQoM");

var $eJrcF = parcelRequire("eJrcF");

var $AJbrA = parcelRequire("AJbrA");
const $c73414d36aba3f3f$export$f6b955c72035f5f5 = 'jira_trial_standard_feature_last_used';
const $c73414d36aba3f3f$export$636c29211aff0141 = 'jira_trial_premium_feature_last_used';
const $c73414d36aba3f3f$export$831601ba32ba977e = (days)=>{
    const { data: traits, loading: loading } = (0, $eJrcF.useResource)((0, $giQoM.fetchSiteUserTraitsResource));
    const now = (0, $eJOHy.useRef)(Date.now());
    return (0, $eJOHy.useMemo)(()=>{
        if (!traits || loading) return undefined;
        const featureLastUsageTrait = traits.find((trait)=>trait?.name === $c73414d36aba3f3f$export$636c29211aff0141)?.value;
        const featureLastUsedTimestamp = (0, $AJbrA.parseAsTimestamp)(featureLastUsageTrait);
        return typeof featureLastUsedTimestamp === 'number' ? (0, $lw3Pj.default)(now.current, featureLastUsedTimestamp) < days : false;
    }, [
        traits,
        days,
        loading
    ]);
};

});

parcelRegister("bAlCu", function(module, exports) {
$parcel$export(module.exports, "useJiraProductAndEdition", () => $ee1c1f8c9326341f$export$7ee036deafbf1b57);

var $eJOHy = parcelRequire("eJOHy");

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");

var $FhXEJ = parcelRequire("FhXEJ");

var $8JLU7 = parcelRequire("8JLU7");

var $eWzpp = parcelRequire("eWzpp");

var $1BZ8a = parcelRequire("1BZ8a");
const $ee1c1f8c9326341f$export$7ee036deafbf1b57 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const { loading: loading, data: project } = (0, $eWzpp.useProject)();
    const siteHasOnlyJira = (0, $8JLU7.useSiteHasOnlyJira)();
    return (0, $eJOHy.useMemo)(()=>{
        if (loading) return {};
        const projectType = (0, $FhXEJ.toProjectType)(project?.type);
        if (projectType === (0, $FhXEJ.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        if (siteHasOnlyJira) {
            const jiraEdition = (0, $cblKs.getEditionForProject)((0, $FhXEJ.SOFTWARE_PROJECT), appEditions);
            return {
                currentProduct: (0, $lBYgs.getApplicationForProject)((0, $FhXEJ.SOFTWARE_PROJECT)),
                currentEdition: jiraEdition,
                jiraEdition: jiraEdition
            };
        }
        return {
            currentProduct: projectType && (0, $lBYgs.getApplicationForProject)(projectType),
            currentEdition: projectType && (0, $cblKs.getEditionForProject)(projectType, appEditions),
            jiraEdition: (0, $cblKs.getEditionForProject)((0, $FhXEJ.SOFTWARE_PROJECT), appEditions)
        };
    }, [
        appEditions,
        loading,
        project?.type,
        siteHasOnlyJira
    ]);
};

});
parcelRegister("8JLU7", function(module, exports) {
$parcel$export(module.exports, "useSiteHasOnlyJira", () => $62dd0a3ee4d4593e$export$8ce0db5ac54a6136);

var $kFw1p = parcelRequire("kFw1p");


var $koAZ4 = parcelRequire("koAZ4");
function $62dd0a3ee4d4593e$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $koAZ4.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $kFw1p.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $315aedf92e50a945$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});



parcelRegister("1CSpk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2Bd6A").then(()=>parcelRequire('hOQud'));

});


parcelRegister("6Yzhs", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbAdapter", () => $5c0bddfcda9f792c$export$2255367d5c9162b3);

var $eJOHy = parcelRequire("eJOHy");

var $aD6E2 = parcelRequire("aD6E2");
function $5c0bddfcda9f792c$export$2255367d5c9162b3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aD6E2.default), null);
}

});
parcelRegister("aD6E2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2abfbd012269b86$export$2e2bcd8739ae039);

var $2QUmO = parcelRequire("2QUmO");

var $2lb3i = parcelRequire("2lb3i");

var $ad5bB = parcelRequire("ad5bB");

var $iiaiu = parcelRequire("iiaiu");

var $cpZiR = parcelRequire("cpZiR");

var $9CWi2 = parcelRequire("9CWi2");
var $f2abfbd012269b86$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $2lb3i.default), {
    LegacyApiBridge: // @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
    $ad5bB.default,
    LegacyBreadcrumbConnector: $iiaiu.default,
    LegacyBreadcrumbState: // @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
    $9CWi2.default,
    LegacyBreadcrumbRenderer: $cpZiR.default
});

});
parcelRegister("2QUmO", function(module, exports) {
$parcel$export(module.exports, "getDisplayName", () => $602ff2c1b8bdf3ea$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $602ff2c1b8bdf3ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $602ff2c1b8bdf3ea$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $602ff2c1b8bdf3ea$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$602ff2c1b8bdf3ea$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $602ff2c1b8bdf3ea$export$2e2bcd8739ae039 = $602ff2c1b8bdf3ea$var$withInjectedProps;

});

parcelRegister("2lb3i", function(module, exports) {
$parcel$export(module.exports, "default", () => $258e6bab6cebbb40$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fdpHV = parcelRequire("fdpHV");

var $h47gY = parcelRequire("h47gY");

const $258e6bab6cebbb40$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LegacyApiBridge, {
            onInsertItem: api.insertItem,
            onRemoveItem: api.removeItem,
            onSetRenderTarget: api.setTargetElement
        }), // Only activate the breadcrumb connector if there is a breadcrumb render target
        state.targetElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
            id: "legacy-breadcrumb-adapter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LegacyBreadcrumbConnector, {
            legacyTrail: state.trail
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LegacyBreadcrumbRenderer, {
            targetElement: state.targetElement
        }))));
var $258e6bab6cebbb40$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('legacyBreadcrumbs', (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a))($258e6bab6cebbb40$var$LegacyBreadcrumbAdapter);

});

parcelRegister("ad5bB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a2a6224131035ea$export$2e2bcd8739ae039);

var $jJW1V = parcelRequire("jJW1V");

var $2QUmO = parcelRequire("2QUmO");

var $lPFaz = parcelRequire("lPFaz");
const $7a2a6224131035ea$var$analyticsEvents = {
    onInsertItemFired: (analyticsEvent)=>(0, $jJW1V.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'insertItem'
            }
        }),
    onRemoveItemFired: (analyticsEvent)=>(0, $jJW1V.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'removeItem'
            }
        }),
    onSetRenderTargetFired: (analyticsEvent)=>(0, $jJW1V.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'render'
            }
        }),
    onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $jJW1V.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'onBreadCrumbsUpdate'
            }
        })
};
var $7a2a6224131035ea$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $lPFaz.default), $7a2a6224131035ea$var$analyticsEvents);

});
parcelRegister("jJW1V", function(module, exports) {
$parcel$export(module.exports, "fireOperationalAnalytics", () => $0669841d79d83d4d$export$79f423cc3fd39762);

var $9pL9Y = parcelRequire("9pL9Y");

var $9pTd3 = parcelRequire("9pTd3");

var $9X75V = parcelRequire("9X75V");

var $qQaal = parcelRequire("qQaal");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $0669841d79d83d4d$var$isNotUndefined = (a)=>a !== undefined;
const $0669841d79d83d4d$var$mapPayload = (payload)=>{
    const context = (0, $qQaal.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $0669841d79d83d4d$var$isNotUndefined);
};
const $0669841d79d83d4d$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$0669841d79d83d4d$var$mapPayload(payload),
            analyticsType: (0, $9X75V.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $9pTd3.fireErrorAnalytics)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});
parcelRegister("qQaal", function(module, exports) {
$parcel$export(module.exports, "default", () => $4366ce8ef40616d1$export$2e2bcd8739ae039);

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");
// AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
const $4366ce8ef40616d1$var$mapPayload = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
};
var $4366ce8ef40616d1$export$2e2bcd8739ae039 = $4366ce8ef40616d1$var$mapPayload;

});


parcelRegister("lPFaz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c8270f6571ddd31$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");

var $as6H2 = parcelRequire("as6H2");

var $9GRvA = parcelRequire("9GRvA");
// eslint-disable-next-line jira/react/no-class-components
class $9c8270f6571ddd31$var$LegacyApiBridge extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
        (0, $9GRvA.default)({
            insertItem: onInsertItem,
            removeItem: onRemoveItem,
            render: onSetRenderTarget,
            onBreadCrumbsUpdate: onBreadCrumbsUpdate
        });
    }
    /* eslint-enable jira/react-no-unneeded-arrow-function-properties */ render() {
        return null;
    }
    constructor(...args){
        super(...args), /* eslint-disable jira/react-no-unneeded-arrow-function-properties */ this.onInsertItem = (item)=>{
            const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
            onInsertItemFired();
            onInsertItem(item);
        }, this.onRemoveItem = (itemId)=>{
            const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
            onRemoveItemFired();
            onRemoveItem(itemId);
        }, this.onSetRenderTarget = (element)=>{
            const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
            onSetRenderTargetFired();
            onSetRenderTarget(element);
        }, this.onBreadCrumbsUpdate = ()=>{
            const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
            onOnBreadCrumbsUpdateFired();
            return (0, $7kixv.Observable).empty();
        };
    }
}
var $9c8270f6571ddd31$export$2e2bcd8739ae039 = (0, $as6H2.default)('legacyApiBridge', {
    onInsertItemFired: 'apiMethodCalled',
    onRemoveItemFired: 'apiMethodCalled',
    onSetRenderTargetFired: 'apiMethodCalled',
    onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
})($9c8270f6571ddd31$var$LegacyApiBridge);

});
parcelRegister("9GRvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f05a97f8287ffc0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");

var $eSnSE = parcelRequire("eSnSE");

var $4cTDP = parcelRequire("4cTDP");
const $5f05a97f8287ffc0$var$registerBridge = (legacyAPI)=>{
    if ((0, $4cTDP.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $4T9yL.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $97BGz.loadBridgeStrict)({
            name: 'jira/globalnavigator/breadcrumbs/bridge',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:breadcrumbs'
            ]
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(legacyAPI);
        }).catch((err)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString())));
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $iyT45.loadBridgeWeak)({
        name: 'jira/globalnavigator/breadcrumbs/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(legacyAPI);
    }).catch((err)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
};
var $5f05a97f8287ffc0$export$2e2bcd8739ae039 = $5f05a97f8287ffc0$var$registerBridge;

});



parcelRegister("iiaiu", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a462245b40551ea$export$2e2bcd8739ae039);

var $2QUmO = parcelRequire("2QUmO");

var $6T1wD = parcelRequire("6T1wD");

var $jATfF = parcelRequire("jATfF");

var $gFB4g = parcelRequire("gFB4g");

var $4nWs2 = parcelRequire("4nWs2");

var $dnzxN = parcelRequire("dnzxN");

var $h0N9h = parcelRequire("h0N9h");
var $1a462245b40551ea$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $dnzxN.default), {
    Breadcrumb: $6T1wD.default,
    ProjectBreadcrumb: $gFB4g.default,
    BoardBreadcrumb: // @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
    $jATfF.default,
    UserBreadcrumb: $4nWs2.default,
    ContextProvider: $h0N9h.default
});

});
parcelRegister("6T1wD", function(module, exports) {
$parcel$export(module.exports, "default", () => $6260e98de9a16198$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $aXKmr = parcelRequire("aXKmr");

var $ifPW4 = parcelRequire("ifPW4");
// eslint-disable-next-line jira/react/no-class-components
class $6260e98de9a16198$var$BreadcrumbOps extends (0, $eJOHy.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.id = '';
        this.id = (0, $aXKmr.v4)();
        if (false) this.onPushBreadcrumb();
    }
    componentDidMount() {
        this.onPushBreadcrumb();
    }
    componentDidUpdate(prevProps) {
        const { breadcrumb: prevBreadcrumb } = prevProps;
        const { api: api, breadcrumb: breadcrumb } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    componentWillUnmount() {
        const { api: api } = this.props;
        api.popBreadcrumb();
    }
    onPushBreadcrumb() {
        const { api: api, breadcrumb: breadcrumb } = this.props;
        api.pushBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    render() {
        return null;
    }
}
const $6260e98de9a16198$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ifPW4.BreadcrumbActions), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6260e98de9a16198$var$BreadcrumbOps, {
            api: actions,
            breadcrumb: breadcrumb
        }), children));
$6260e98de9a16198$var$Breadcrumb.defaultProps = {
    children: null
};
var $6260e98de9a16198$export$2e2bcd8739ae039 = $6260e98de9a16198$var$Breadcrumb;

});
parcelRegister("ifPW4", function(module, exports) {
$parcel$export(module.exports, "useBreadcrumbs", () => $8a41e5f96d7bfaa5$export$8cefe241bd876ca0);
$parcel$export(module.exports, "BreadcrumbActions", () => $8a41e5f96d7bfaa5$export$9862c338ec0a6884);
$parcel$export(module.exports, "BreadcrumbContainer", () => $8a41e5f96d7bfaa5$export$c7432936d9c50db7);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $8a41e5f96d7bfaa5$var$initialState = {
    trail: []
};
const $8a41e5f96d7bfaa5$export$e324594224ef24da = {
    pushBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: [
                    ...getState().trail,
                    breadcrumb
                ]
            });
        },
    popBreadcrumb: ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: getState().trail.slice(0, -1)
            });
        },
    updateBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
            setState({
                trail: newTrail
            });
        }
};
const $8a41e5f96d7bfaa5$var$Store = (0, $GtRbT.createStore)({
    initialState: $8a41e5f96d7bfaa5$var$initialState,
    actions: $8a41e5f96d7bfaa5$export$e324594224ef24da,
    name: 'BreadcrumbSweetState'
});
const $8a41e5f96d7bfaa5$var$_BreadcrumbSubscriber = (0, $ht3nQ.createSubscriber)($8a41e5f96d7bfaa5$var$Store);
const $8a41e5f96d7bfaa5$export$8cefe241bd876ca0 = (0, $iJq0l.createHook)($8a41e5f96d7bfaa5$var$Store);
const $8a41e5f96d7bfaa5$export$9862c338ec0a6884 = (0, $ht3nQ.createSubscriber)($8a41e5f96d7bfaa5$var$Store, {
    selector: null
});
const $8a41e5f96d7bfaa5$export$c7432936d9c50db7 = (0, $6E16M.createContainer)($8a41e5f96d7bfaa5$var$Store);

});


parcelRegister("jATfF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f3af3d5c1409945$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6T1wD = parcelRequire("6T1wD");

var $cqjwJ = parcelRequire("cqjwJ");
const $4f3af3d5c1409945$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
    const breadcrumb = {
        href: (0, $cqjwJ.createBoardUrl)(boardId),
        text: boardName,
        type: 'boardName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToSubProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: breadcrumb
    }, children);
};
$4f3af3d5c1409945$var$BoardBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined
};
var $4f3af3d5c1409945$export$2e2bcd8739ae039 = $4f3af3d5c1409945$var$BoardBreadcrumb;

});
parcelRegister("cqjwJ", function(module, exports) {
$parcel$export(module.exports, "createProjectUrl", () => $811fe0c2dfc0e0a8$export$1bdb1f038c5a2a90);
$parcel$export(module.exports, "createProjectSettingsUrl", () => $811fe0c2dfc0e0a8$export$c435fcb42a65af32);
$parcel$export(module.exports, "createBoardUrl", () => $811fe0c2dfc0e0a8$export$7037e05c8c7af6dc);

var $7lJUT = parcelRequire("7lJUT");
const $811fe0c2dfc0e0a8$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $811fe0c2dfc0e0a8$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
    if (isSimplified) return (0, $7lJUT.getNextgenSettingsUrl)(projectType, projectKey);
    return `/projects/${projectKey}/settings`;
};
const $811fe0c2dfc0e0a8$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;

});
parcelRegister("7lJUT", function(module, exports) {
$parcel$export(module.exports, "getNextgenSettingsUrl", () => $0ae631bb3c848ee5$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $0ae631bb3c848ee5$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $0ae631bb3c848ee5$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $0ae631bb3c848ee5$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $0ae631bb3c848ee5$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $0ae631bb3c848ee5$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $0ae631bb3c848ee5$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $0ae631bb3c848ee5$export$dad567762dae162e);

var $FhXEJ = parcelRequire("FhXEJ");

var $leHbU = parcelRequire("leHbU");

var $lfZNE = parcelRequire("lfZNE");

var $4cTDP = parcelRequire("4cTDP");
const $0ae631bb3c848ee5$var$serializeBackLink = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $0ae631bb3c848ee5$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $FhXEJ.CORE_PROJECT)]: 'core',
        [(0, $FhXEJ.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $FhXEJ.CUSTOMER_SERVICE_PROJECT)]: (0, $4cTDP.fg)('jcs_project_type_m3') ? 'servicedesk' : 'customerservice',
        [(0, $FhXEJ.SOFTWARE_PROJECT)]: 'software',
        [(0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $lfZNE.logError)((0, $leHbU.PACKAGE_NAME), 'urls', `Can't build default project settings url for project type: ${projectType}`, new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $0ae631bb3c848ee5$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return `${$0ae631bb3c848ee5$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$0ae631bb3c848ee5$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$0ae631bb3c848ee5$var$serializeBackLink(backLink)}`;
};
const $0ae631bb3c848ee5$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return `${$0ae631bb3c848ee5$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$0ae631bb3c848ee5$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $0ae631bb3c848ee5$export$b0d20d18e0230e83 = (projectKey)=>`${$0ae631bb3c848ee5$export$26432406821aa7bf((0, $FhXEJ.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $0ae631bb3c848ee5$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $0ae631bb3c848ee5$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) && !isSimplified ? $0ae631bb3c848ee5$export$ff0a17aa36a000df(projectKey) : $0ae631bb3c848ee5$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $0ae631bb3c848ee5$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$0ae631bb3c848ee5$var$serializeBackLink(backLink)}`;
const $0ae631bb3c848ee5$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$0ae631bb3c848ee5$var$serializeBackLink(backLink)}`;

});
parcelRegister("leHbU", function(module, exports) {
$parcel$export(module.exports, "TASK", () => $77f116bb7c734217$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $77f116bb7c734217$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $77f116bb7c734217$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $77f116bb7c734217$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $77f116bb7c734217$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $77f116bb7c734217$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $77f116bb7c734217$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $77f116bb7c734217$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $77f116bb7c734217$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $77f116bb7c734217$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $77f116bb7c734217$export$a11dccbf88784c62);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $77f116bb7c734217$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $77f116bb7c734217$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "PACKAGE_NAME", () => $77f116bb7c734217$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $77f116bb7c734217$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $77f116bb7c734217$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $77f116bb7c734217$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $77f116bb7c734217$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $77f116bb7c734217$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $77f116bb7c734217$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $77f116bb7c734217$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $77f116bb7c734217$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $77f116bb7c734217$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $77f116bb7c734217$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $77f116bb7c734217$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $77f116bb7c734217$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $77f116bb7c734217$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $77f116bb7c734217$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $77f116bb7c734217$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $77f116bb7c734217$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $77f116bb7c734217$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $77f116bb7c734217$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $77f116bb7c734217$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $77f116bb7c734217$export$33dbe2a903610aa1);
/* eslint-disable jira/filename-case */ // Issue Type Templates

var $3mZMJ = parcelRequire("3mZMJ");
const $77f116bb7c734217$export$9355e489ad16f98e = 'task';
const $77f116bb7c734217$export$bcf558c186108044 = 'bug';
const $77f116bb7c734217$export$1ea39a3ae330045 = 'story';
const $77f116bb7c734217$export$3cb4a99a332e4186 = 'epic';
const $77f116bb7c734217$export$a06f889861f6537d = 'subtask';
const $77f116bb7c734217$export$952581bc40160893 = 'custom';
const $77f116bb7c734217$export$dff1da4a9bab6d3e = [
    $77f116bb7c734217$export$9355e489ad16f98e,
    $77f116bb7c734217$export$bcf558c186108044,
    $77f116bb7c734217$export$1ea39a3ae330045,
    $77f116bb7c734217$export$3cb4a99a332e4186
];
const $77f116bb7c734217$export$39cd48613b53ce2f = (0, $3mZMJ.TEXT_AREA_CF_TYPE);
const $77f116bb7c734217$export$56eae1056efd4899 = (0, $3mZMJ.DESCRIPTION_TYPE);
const $77f116bb7c734217$export$ca61f05d869b2ea3 = (0, $3mZMJ.ENVIRONMENT_TYPE);
const $77f116bb7c734217$export$a11dccbf88784c62 = 'Jira Service Management';
const $77f116bb7c734217$export$2ec42920a0df6b9a = 'Story point estimate';
const $77f116bb7c734217$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $77f116bb7c734217$export$b8b9d90f9e5bd72b = 'jiraProjectSettingsAppsCommon';
const $77f116bb7c734217$export$a2231d79966e0ccc = 'NEW_';
const $77f116bb7c734217$export$28a4bdf7d9b6f9 = 'radio';
const $77f116bb7c734217$export$9d758b3e8c6e0ed1 = 'userpicker';
const $77f116bb7c734217$export$b0e37d421e006913 = 'multiuserpicker';
const $77f116bb7c734217$export$d77765147749db6b = 'select';
const $77f116bb7c734217$export$42ef68d6bd555a8d = 'cascadingselect';
const $77f116bb7c734217$export$4db6eb15b3c529cf = 'multiselect';
const $77f116bb7c734217$export$ee975373b7797e8a = 'checkbox';
const $77f116bb7c734217$export$aa99342cc6a8ced5 = 'text';
const $77f116bb7c734217$export$6f327bf99e20320 = 'number';
const $77f116bb7c734217$export$dc64bdfdf9660a05 = 'datetime';
const $77f116bb7c734217$export$e6d73ed745b9a04 = 'projectpicker';
const $77f116bb7c734217$export$d8b50f59220c7580 = 'date';
const $77f116bb7c734217$export$3a6f0a44478f1d2 = 'assetspicker';
const $77f116bb7c734217$export$68b76ef93df5a880 = 'labelpicker';
const $77f116bb7c734217$export$e7773fccbeec45e6 = 'grouppicker';
const $77f116bb7c734217$export$b45487b145c52a37 = 'multigrouppicker';
const $77f116bb7c734217$export$48548129a6d117f5 = 'version';
const $77f116bb7c734217$export$722c271a9e11cb94 = 'multiversion';
const $77f116bb7c734217$export$33dbe2a903610aa1 = 'textarea';

});

parcelRegister("lfZNE", function(module, exports) {
$parcel$export(module.exports, "logError", () => $86d51a3b837bc619$export$58da9968c3170cb1);

var $9pTd3 = parcelRequire("9pTd3");

var $eSnSE = parcelRequire("eSnSE");
const $86d51a3b837bc619$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $eSnSE.default).unsafeErrorWithCustomerData(location, message, error);
};

});




parcelRegister("gFB4g", function(module, exports) {
$parcel$export(module.exports, "default", () => $3452bb6d3c06ed91$export$2e2bcd8739ae039);

var $idGBm = parcelRequire("idGBm");

var $42mMa = parcelRequire("42mMa");
var $3452bb6d3c06ed91$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)((0, $42mMa.default));

});
parcelRegister("42mMa", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbbdb57854bad193$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $6T1wD = parcelRequire("6T1wD");

var $cqjwJ = parcelRequire("cqjwJ");

var $an84N = parcelRequire("an84N");
const $bbbdb57854bad193$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
    const ProjectsBreadcrumb = {
        href: '/jira/projects',
        text: formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $an84N.default).projectsTitleGalaxia : (0, $an84N.default).projectsTitle),
        type: 'projectsDirectory',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProjectsList'
        }
    };
    if (projectKey != null && projectName != null) {
        const breadcrumb = {
            href: (0, $cqjwJ.createProjectUrl)(projectKey),
            text: projectName,
            type: 'projectName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        const ProjectNameBreadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
            breadcrumb: breadcrumb
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
            breadcrumb: ProjectsBreadcrumb
        }, ProjectNameBreadcrumb);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: ProjectsBreadcrumb
    }, children);
};
$bbbdb57854bad193$var$ProjectBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined,
    projectKey: undefined,
    projectName: undefined
};
var $bbbdb57854bad193$export$2e2bcd8739ae039 = $bbbdb57854bad193$var$ProjectBreadcrumb;

});
parcelRegister("an84N", function(module, exports) {
$parcel$export(module.exports, "default", () => $24bfd47e3e5279c7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $24bfd47e3e5279c7$var$messages = (0, $7qGN1.defineMessages)({
    projectsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
        "defaultMessage": "Projects"
    },
    projectsTitleGalaxia: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title-galaxia",
        "defaultMessage": "Spaces"
    }
});
var $24bfd47e3e5279c7$export$2e2bcd8739ae039 = $24bfd47e3e5279c7$var$messages;

});



parcelRegister("4nWs2", function(module, exports) {
$parcel$export(module.exports, "default", () => $244a424f0e6a95b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6T1wD = parcelRequire("6T1wD");
const $244a424f0e6a95b7$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
    const breadcrumb = {
        href: profileUrl,
        text: name,
        type: 'userName'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: breadcrumb
    }, children);
};
var $244a424f0e6a95b7$export$2e2bcd8739ae039 = $244a424f0e6a95b7$var$UserBreadcrumb;

});

parcelRegister("dnzxN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7509a3f9880b0955$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $7509a3f9880b0955$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
        ...legacyCrumb,
        legacyId: id,
        type: 'legacy'
    });
const $7509a3f9880b0955$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContextProvider, null, ({ data: data })=>{
        if (!data) return children;
        const boardBreadcrumb = data.scope ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BoardBreadcrumb, {
            boardId: data.scope.id,
            boardName: data.scope.name || 'Board'
        }, children) : children;
        return data.contextType === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(UserBreadcrumb, {
            profileUrl: data.user.profileUrl,
            name: data.user.name
        }, boardBreadcrumb) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProjectBreadcrumb, {
            projectKey: data.project.key,
            projectName: data.project.name,
            projectId: data.project.id,
            isSimplifiedProject: data.project.isSimplified
        }, boardBreadcrumb);
    });
const $7509a3f9880b0955$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
    const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Breadcrumb, {
            breadcrumb: currentCrumb
        }, accumulatedCrumbs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7509a3f9880b0955$var$ContextBreadcrumbs, {
        BoardBreadcrumb: BoardBreadcrumb,
        ProjectBreadcrumb: ProjectBreadcrumb,
        UserBreadcrumb: UserBreadcrumb,
        ContextProvider: ContextProvider
    }, legacyTrail.map($7509a3f9880b0955$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
};
var $7509a3f9880b0955$export$2e2bcd8739ae039 = $7509a3f9880b0955$var$LegacyBreadcrumbConnector;

});

parcelRegister("h0N9h", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc21dcf75aeeb73e$export$2e2bcd8739ae039);

var $jFHCE = parcelRequire("jFHCE");

var $6nVJI = parcelRequire("6nVJI");

var $2FqDG = parcelRequire("2FqDG");
var $95O7y = parcelRequire("95O7y");
const $dc21dcf75aeeb73e$export$9f27bc3417b4524d = ({ children: children })=>{
    const [boardId] = (0, $2FqDG.usePathParam)('boardId');
    const [rapidView] = (0, $95O7y.useQueryParam)('rapidView');
    const [{ data: ctxData, loading: loading, error: error }] = (0, $6nVJI.useContainerContext)();
    /* Don't provide scope data if boardId does not exist in the URL as
	 * we don't want to show the board breadcrumb in this case since it
	 * indicates that we aren't in a scope context even though one may
	 * exist. */ const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(ctxData, 'scope');
    // @ts-expect-error - TS2322 - Type 'Pick<ProjectContext | UserContext, "contextType"> | null' is not assignable to type 'ContainerContext | null'. | TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return children({
        data: data,
        loading: loading,
        error: error
    });
};
var $dc21dcf75aeeb73e$export$2e2bcd8739ae039 = $dc21dcf75aeeb73e$export$9f27bc3417b4524d;

});


parcelRegister("cpZiR", function(module, exports) {
$parcel$export(module.exports, "default", () => $effa889623729e5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $eSnSE = parcelRequire("eSnSE");

var $h6slU = parcelRequire("h6slU");
const $effa889623729e5e$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
class $effa889623729e5e$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    componentDidCatch(error) {
        /*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */ const { targetElement: targetElement } = this.props;
        const targetId = targetElement ? targetElement.id : 'not-found';
        (0, $eSnSE.default).safeErrorWithoutCustomerData($effa889623729e5e$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
    }
    render() {
        const { targetElement: targetElement } = this.props;
        return /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null), targetElement);
    }
}

});
parcelRegister("h6slU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6676a876f48d07e8$export$2e2bcd8739ae039);

var $jJW1V = parcelRequire("jJW1V");

var $2QUmO = parcelRequire("2QUmO");

var $koAZ4 = parcelRequire("koAZ4");

var $7KRE0 = parcelRequire("7KRE0");
const $6676a876f48d07e8$var$fireAnalytics = (analyticsEvent)=>(0, $jJW1V.fireOperationalAnalytics)(analyticsEvent, {
        name: 'breadcrumbRendererMounted'
    });
var $6676a876f48d07e8$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $7KRE0.default), {
    onMount: $6676a876f48d07e8$var$fireAnalytics,
    TenantContextSubscriber: $koAZ4.TenantContextSubscriber
});

});
parcelRegister("7KRE0", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbcac1f9f03b3741$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $as6H2 = parcelRequire("as6H2");

var $7wjKL = parcelRequire("7wjKL");

var $ifPW4 = parcelRequire("ifPW4");
// Adapt to prop type from breadcrumbs app
const $cbcac1f9f03b3741$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
            ...crumb,
            target: crumb.target || '_self'
        }));
const $cbcac1f9f03b3741$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
    const [{ trail: trail }] = (0, $ifPW4.useBreadcrumbs)();
    const items = (0, $eJOHy.useMemo)(()=>$cbcac1f9f03b3741$var$mapTrailToBreadcrumbItems(trail), [
        trail
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(onMount, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1tke1tcg"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wjKL.default), {
        isVisible: true,
        items: items
    }));
};
var $cbcac1f9f03b3741$export$2e2bcd8739ae039 = (0, $as6H2.default)('breadcrumbsRenderer', {
    onMount: 'mounted'
})($cbcac1f9f03b3741$var$BreadcrumbRenderer);
const $cbcac1f9f03b3741$var$breadcrumbsWrapperStyles = null;

});
parcelRegister("7wjKL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec7e757ad8d6637b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7iHUq = parcelRequire("7iHUq");

var $bX4vO = parcelRequire("bX4vO");
function $ec7e757ad8d6637b$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bX4vO.default), {
        isVisible: isVisible,
        items: items
    }));
}

});
parcelRegister("bX4vO", function(module, exports) {
$parcel$export(module.exports, "default", () => $27d452b5bc0f0d47$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $12DRg = parcelRequire("12DRg");

var $fE5VD = parcelRequire("fE5VD");
var $16YBi = parcelRequire("16YBi");

var $lRq8t = parcelRequire("lRq8t");

var $c9uTK = parcelRequire("c9uTK");

var $jdVvc = parcelRequire("jdVvc");

var $24Eev = parcelRequire("24Eev");
const $27d452b5bc0f0d47$export$67abef37aa2929b0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
(props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ...props,
        ref: ref,
        type: "a"
    }));
function $27d452b5bc0f0d47$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const totalItems = items.length;
    return isVisible ? // onExpand is required prop in atlaskit's breadcrumbitem component
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16YBi.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(items) ? // This is needed in order to render an empty breadcrumb for SSR, to avoid visual jumping when javascript kicks in.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE5VD.default), {
        text: "",
        "aria-label": formatMessage((0, $24Eev.default).breadcrumbsLabel)
    }) : items.map((breadcrumb, index)=>{
        const breadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdVvc.default), {
            key: index,
            index: index,
            ariaCurrent: index + 1 === totalItems ? 'page' : undefined,
            hasSeparator: true,
            text: breadcrumb.text,
            target: __SPA__ ? undefined : breadcrumb.target,
            href: breadcrumb.href,
            component: __SPA__ ? $27d452b5bc0f0d47$export$67abef37aa2929b0 : undefined,
            legacyId: breadcrumb.legacyId,
            type: breadcrumb.type,
            analyticsAttributes: breadcrumb.analyticsAttributes,
            analyticsFields: breadcrumb.analyticsFields
        });
        return breadcrumbItem;
    }))) : null;
}

});
parcelRegister("fE5VD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7b72a7004145e65$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $gGiEK = parcelRequire("gGiEK");

var $feyLt = parcelRequire("feyLt");

var $3hIIz = parcelRequire("3hIIz");
const $e7b72a7004145e65$var$itemWrapperStyles = null;
const $e7b72a7004145e65$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $e7b72a7004145e65$var$ICON_WIDTH_ESTIMATE = 24;
const $e7b72a7004145e65$var$staticItemStyles = null;
const $e7b72a7004145e65$var$staticItemWithTruncationStyles = null;
const $e7b72a7004145e65$var$staticItemWithoutTruncationStyles = null;
const $e7b72a7004145e65$var$BreadcrumbsItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const stepTextRef = (0, $eJOHy.useRef)(null);
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $e7b72a7004145e65$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $e7b72a7004145e65$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $3hIIz.default)(truncationWidth, stepTextRef.current, iconWidthAllowance);
    // This should be a part of staticItemStyles but it requires the !important flag to prevent the padding from being overridden by the button styles
    // compiled treats `${token(xxx)} !important` differently when concat !important in es2019 and esm built files
    // the padding and font weight were not sourced correctly in the esm build
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$e7b72a7004145e65$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component && (0, $eGOwo.fg)('platform_dst_breadcrumbs_step_conversion') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gGiEK.default), {
        ref: stepTextRef,
        analyticsContext: analyticsContext,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        target: target,
        testId: testId,
        truncationWidth: truncationWidth,
        children: text
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $feyLt.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: stepTextRef,
        target: target,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        className: (0, $hcewu.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect41gqc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e7b72a7004145e65$export$2e2bcd8739ae039 = $e7b72a7004145e65$var$BreadcrumbsItem;

});
parcelRegister("gGiEK", function(module, exports) {
$parcel$export(module.exports, "default", () => $59c2c146912d95f1$export$2e2bcd8739ae039);
/* step.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $6qaBj = parcelRequire("6qaBj");

var $3Vuhz = parcelRequire("3Vuhz");

var $lc0OY = parcelRequire("lc0OY");
var $46R8N = parcelRequire("46R8N");
const $59c2c146912d95f1$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $59c2c146912d95f1$var$noop = (0, $3Vuhz.default);
const $59c2c146912d95f1$var$styles = {
    root: "_11c82smr _19itglyw _zulp1b66 _2rko12b0 _4bfu18uv _1hmsglyw _ajmmnqa1 _1rjcv77o _18zrze3t _bfhk1w7a _syaz131l _1e0c116y _4cvr1h6o _1a3b18uv _4fprglyw _5goinqa1 _f8pj131l _9oik18uv _1bnx8stv _jf4cnqa1 _30l3131l _9h8h1fxt",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $59c2c146912d95f1$var$Step = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $59c2c146912d95f1$var$noop, target: target, testId: testId, children: children, truncationWidth: truncationWidth }, ref)=>{
    const handleClick = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$59c2c146912d95f1$var$analyticsAttributes
    });
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            iconBefore,
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ref: ref,
                className: (0, $hcewu.default)([
                    $59c2c146912d95f1$var$styles.text
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
        href: href,
        onClick: handleClick,
        target: target,
        testId: testId,
        xcss: (0, $6qaBj.cx)($59c2c146912d95f1$var$styles.root, !truncationWidth && $59c2c146912d95f1$var$styles.withoutTruncation),
        style: {
            maxWidth: truncationWidth
        },
        children: content
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: handleClick,
        testId: testId,
        xcss: (0, $6qaBj.cx)($59c2c146912d95f1$var$styles.root, !truncationWidth && $59c2c146912d95f1$var$styles.withoutTruncation),
        style: {
            maxWidth: truncationWidth
        },
        children: content
    });
});
var $59c2c146912d95f1$export$2e2bcd8739ae039 = $59c2c146912d95f1$var$Step;

});

parcelRegister("feyLt", function(module, exports) {
$parcel$export(module.exports, "default", () => $62ceffbbdae962a0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $goZPP = parcelRequire("goZPP");

var $3Vuhz = parcelRequire("3Vuhz");
const $62ceffbbdae962a0$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $62ceffbbdae962a0$var$noop = (0, $3Vuhz.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $62ceffbbdae962a0$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $62ceffbbdae962a0$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$62ceffbbdae962a0$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $62ceffbbdae962a0$export$2e2bcd8739ae039 = $62ceffbbdae962a0$var$StepOld;

});

parcelRegister("3hIIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $12abc2621123c61b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $12abc2621123c61b$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $eJOHy.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $eJOHy.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $eJOHy.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("16YBi", function(module, exports) {
$parcel$export(module.exports, "default", () => $a75e9d112109680f$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $3Vuhz = parcelRequire("3Vuhz");

var $eGOwo = parcelRequire("eGOwo");

var $5zaE1 = parcelRequire("5zaE1");

var $lK2OT = parcelRequire("lK2OT");
const $a75e9d112109680f$var$defaultMaxItems = 8;
const $a75e9d112109680f$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $a75e9d112109680f$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $a75e9d112109680f$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children;
const $a75e9d112109680f$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $a75e9d112109680f$var$noop = (0, $3Vuhz.default);
const $a75e9d112109680f$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $a75e9d112109680f$var$breadcrumbStyles = null;
const $a75e9d112109680f$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $a75e9d112109680f$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $a75e9d112109680f$var$noop, analyticsContext: analyticsContext, label: label = $a75e9d112109680f$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $a75e9d112109680f$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $eJOHy.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $eJOHy.useState)(false);
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $a75e9d112109680f$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($a75e9d112109680f$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    const focusFirstRevealedMemoized = (0, $eJOHy.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($a75e9d112109680f$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $lK2OT.useOnRevealed)((0, $eGOwo.fg)('jfp-magma-stability-platform-3') ? focusFirstRevealedMemoized : focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$a75e9d112109680f$var$analyticsAttributes
    });
    const childrenArray = $a75e9d112109680f$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5zaE1.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("nav", {
        "aria-label": label,
        ref: (0, $gyJTO.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
            "data-testid": testId,
            className: (0, $hcewu.default)([
                "_1e0c1txw _1n261g80 _syaz1wmz _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $a75e9d112109680f$var$Breadcrumbs = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)($a75e9d112109680f$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $a75e9d112109680f$export$2e2bcd8739ae039 = $a75e9d112109680f$var$Breadcrumbs;

});
parcelRegister("5zaE1", function(module, exports) {
$parcel$export(module.exports, "default", () => $6688da12dd77b66c$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $3Vuhz = parcelRequire("3Vuhz");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");
const $6688da12dd77b66c$var$noop = (0, $3Vuhz.default);
const $6688da12dd77b66c$var$itemWrapperStyles = null;
const $6688da12dd77b66c$var$staticItemStyles = null;
const $6688da12dd77b66c$var$styles = {
    root: "_11c82smr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk1w7a _syaz131l _1e0c116y _4cvr1h6o _1a3b18uv _4fprglyw _5goinqa1 _f8pj131l _9oik18uv _1bnx8stv _jf4cnqa1 _30l3131l _9h8h1fxt"
};
const $6688da12dd77b66c$var$EllipsisItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, onClick: onClick = $6688da12dd77b66c$var$noop, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: (0, $eGOwo.fg)('platform_dst_breadcrumbs_step_conversion') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            "aria-label": label,
            onClick: onClick,
            xcss: $6688da12dd77b66c$var$styles.root,
            testId: testId,
            children: "\u2026"
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, $hcewu.default)([
                "_1rjc1tvq _k48p1hhk _vwz41txs"
            ]),
            children: "\u2026"
        })
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6688da12dd77b66c$export$2e2bcd8739ae039 = $6688da12dd77b66c$var$EllipsisItem;

});

parcelRegister("lK2OT", function(module, exports) {
$parcel$export(module.exports, "useOnRevealed", () => $25cf5f56d1847350$export$e9c4922b2ecf808a);

var $eJOHy = parcelRequire("eJOHy");

var $aNllK = parcelRequire("aNllK");
function $25cf5f56d1847350$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $aNllK.default)(isExpanded);
    (0, $eJOHy.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("jdVvc", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddd4b61d0ffad6f1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fE5VD = parcelRequire("fE5VD");

var $xlfPl = parcelRequire("xlfPl");
class $ddd4b61d0ffad6f1$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            href: undefined,
            legacyId: undefined,
            type: 'unspecified',
            analyticsAttributes: {},
            analyticsFields: {},
            ariaCurrent: undefined
        };
    }
    render() {
        const { index: index, text: text, target: target, href: href, component: component, ariaCurrent: ariaCurrent } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE5VD.default), {
            key: index,
            text: text,
            // @ts-expect-error - TS2322 - Type '(event: Event, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'.
            onClick: this.onBreadCrumbClick,
            target: target,
            href: href,
            component: component,
            "aria-current": ariaCurrent
        });
    }
    constructor(...args){
        super(...args), this.onBreadCrumbClick = (event, analyticsEvent)=>{
            const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
            (0, $xlfPl.fireUiAnalytics)(analyticsEvent, {
                name: '',
                attributes: {
                    legacyId: legacyId,
                    // change this depth value to be zero based, once Jira home crumb is added
                    depth: index + 1,
                    type: type,
                    ...analyticsAttributes
                },
                ...analyticsFields
            });
        };
    }
}

});
parcelRegister("xlfPl", function(module, exports) {
$parcel$export(module.exports, "fireUiAnalytics", () => $96b3037b79e6119e$export$4909253b5bf1eed7);

var $9pL9Y = parcelRequire("9pL9Y");

var $9X75V = parcelRequire("9X75V");

var $qQaal = parcelRequire("qQaal");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $96b3037b79e6119e$var$isNotUndefined = (a)=>a !== undefined;
const $96b3037b79e6119e$var$mapPayload = (payload)=>{
    const context = (0, $qQaal.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $96b3037b79e6119e$var$isNotUndefined);
};
const $96b3037b79e6119e$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$96b3037b79e6119e$var$mapPayload(payload),
        analyticsType: (0, $9X75V.UI_EVENT_TYPE)
    }).fire();
};

});


parcelRegister("24Eev", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd0c10b6a62c0885$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bd0c10b6a62c0885$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    breadcrumbsLabel: {
        "id": "navigation-apps.breadcrumbs.aria-label",
        "defaultMessage": "Empty Breadcrumbs item"
    }
});

});






parcelRegister("9CWi2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a78872c21791ffa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $8a78872c21791ffa$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
const $8a78872c21791ffa$var$defaultInitialState = {
    trail: [],
    targetElement: null
};
class $8a78872c21791ffa$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            initialState: $8a78872c21791ffa$var$defaultInitialState
        };
    }
    constructor(props){
        super(props), this.onInsertItem = (item)=>{
            this.setState((state)=>({
                    trail: [
                        ...state.trail,
                        item
                    ].sort($8a78872c21791ffa$var$compareBreadcrumbs)
                }));
        }, this.onRemoveItem = (id)=>{
            this.setState((state)=>({
                    trail: state.trail.filter((b)=>b.id !== id)
                }));
        }, /* eslint-disable react/no-unused-state */ this.onTargetSet = (targetElement)=>{
            this.setState({
                targetElement: targetElement
            });
        }, /* eslint-enable react/no-unused-state */ this.api = {
            setTargetElement: this.onTargetSet,
            insertItem: this.onInsertItem,
            removeItem: this.onRemoveItem
        };
        this.state = props.initialState;
    }
    render() {
        const { children: children } = this.props;
        return children({
            state: this.state,
            api: this.api
        });
    }
}

});



parcelRegister("ajCkH", function(module, exports) {
$parcel$export(module.exports, "LoadingPhaseManager", () => $b198b00a4924b5f8$export$6e4bfef9e80c7eb0);

var $eJOHy = parcelRequire("eJOHy");

var $02OvK = parcelRequire("02OvK");

var $8CQpJ = parcelRequire("8CQpJ");

var $4cTDP = parcelRequire("4cTDP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b198b00a4924b5f8$export$6e4bfef9e80c7eb0 = ()=>{
    const [{ hasLoaded: hasLoaded }] = (0, $02OvK.default)();
    const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $8CQpJ.useLazyPhase)();
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('iv_load_after_paint_phase_on_page_early')) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else if (hasLoaded) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else resetPhase();
    }, [
        hasLoaded,
        resetPhase,
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("7cv6Z", function(module, exports) {
$parcel$export(module.exports, "TrackClicksBeforeTTI", () => $1629e14fab0142f6$export$2846c12b8c092470);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $kZIBu = parcelRequire("kZIBu");

var $8tIrO = parcelRequire("8tIrO");

var $4cTDP = parcelRequire("4cTDP");
const $1629e14fab0142f6$var$cleanUrl = (pathname)=>{
    let url = pathname.replace(/\/$/, '');
    // /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(url)) url = 'browse';
    // replaces any occurrence of two or more capital letters,
    // or one capital letter followed by a number and also
    // two or more capital letters followed by a dash and any amount of numbers
    // (should catch all project and issue keys)
    if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
    return url;
};
const $1629e14fab0142f6$var$sessionStorageProvider = (0, $8tIrO.createSessionStorageProvider)('', false);
/**
 * Handles the collection and processing of user interactions that occur before the page becomes fully interactive. This enhances the understanding of user behavior during the initial loading phase.
 */ const $1629e14fab0142f6$export$2846c12b8c092470 = ()=>{
    const [{ isReady: isReady }] = (0, $kZIBu.useSpaStatePageReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!isReady) return;
        try {
            const sessionStorageItems = (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $1629e14fab0142f6$var$sessionStorageProvider.get('clicks-before-tti') : sessionStorage.getItem('clicks-before-tti');
            if (sessionStorageItems == null || sessionStorageItems === '') return;
            const items = JSON.parse(sessionStorageItems);
            items.forEach((item)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let extras = {
                    elementId: item.dataId,
                    currentUrl: $1629e14fab0142f6$var$cleanUrl(item.currentUrl),
                    bundleId: item.bundleId,
                    time: item.time
                };
                if (item.redirectUrl !== '') extras = {
                    ...extras,
                    redirectUrl: $1629e14fab0142f6$var$cleanUrl(item.redirectUrl)
                };
                (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'clicked'
                }), 'nonInteractiveElement clicked', '', extras);
            });
            (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $1629e14fab0142f6$var$sessionStorageProvider.remove('clicks-before-tti') : sessionStorage.removeItem('clicks-before-tti');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        createAnalyticsEvent,
        isReady
    ]);
    return null;
};

});

parcelRegister("jjTNC", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $8f85ccb8e16b890f$export$99d02219d259eb94);
$parcel$export(module.exports, "IntegrationsWhichRequireNavigationRoot", () => $8f85ccb8e16b890f$export$26605c981d761e9d);

var $eJOHy = parcelRequire("eJOHy");

var $2Mg44 = parcelRequire("2Mg44");

var $hH1AY = parcelRequire("hH1AY");

var $3Fjdk = parcelRequire("3Fjdk");

var $1TFt8 = parcelRequire("1TFt8");
function $8f85ccb8e16b890f$export$99d02219d259eb94() {
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hH1AY.IssueViewModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1TFt8.Projects), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Mg44.Dashboards), null));
    return null;
}
$8f85ccb8e16b890f$export$99d02219d259eb94.displayName = 'Integrations'; // This is needed to pass the test.tsx's uniqueness-test. Without it, the component appears as 'ComponentWithCondition[]', which already exists in the list.
function $8f85ccb8e16b890f$export$26605c981d761e9d() {
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Fjdk.KeyboardShortcuts), null);
    return null;
}

});
parcelRegister("2Mg44", function(module, exports) {
$parcel$export(module.exports, "Dashboards", () => $5f666e9c6a9fda8c$export$dd47e695f88fad71);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7EgC9 = parcelRequire("7EgC9");

var $hih5V = parcelRequire("hih5V");

var $9o3jI = parcelRequire("9o3jI");

var $kh7bJ = parcelRequire("kh7bJ");

var $02kpm = parcelRequire("02kpm");
var $83DiZ = parcelRequire("83DiZ");

var $kO1ht = parcelRequire("kO1ht");
const $5f666e9c6a9fda8c$var$styles = (0, $1DXK0.xcss)({
    position: 'absolute'
});
const $5f666e9c6a9fda8c$export$dd47e695f88fad71 = ()=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const [isOpen, { off: modalClose }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).DASHBOARD_CREATE);
    const { path: path } = (0, $hih5V.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onSuccess = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
    (_, { id: id })=>{
        path && push((0, $02kpm.generatePath)(path, {
            dashboardId: id
        }));
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    if (isAnonymous) return null;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5f666e9c6a9fda8c$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7EgC9.default), {
        onSuccess: onSuccess,
        onCancel: modalClose
    })) : null;
};

});

parcelRegister("hH1AY", function(module, exports) {
$parcel$export(module.exports, "IssueViewModal", () => $830b1428deefed01$export$e6a284da53c503a6);

var $eJOHy = parcelRequire("eJOHy");

var $3W2wI = parcelRequire("3W2wI");

var $lbDFC = parcelRequire("lbDFC");

var $2imLM = parcelRequire("2imLM");

var $2QZBX = parcelRequire("2QZBX");

var $bQWwW = parcelRequire("bQWwW");

const $830b1428deefed01$export$b61e79ae300e872f = (0, $bQWwW.lazy)(()=>(parcelRequire("kwulP")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $830b1428deefed01$export$e6a284da53c503a6 = ()=>{
    const [{ isModalOpen: isModalOpen, issueKey: issueKey, onClose: onClose, packageName: packageName, analyticsSource: analyticsSource }] = (0, $lbDFC.useTriggerIssueViewModal)();
    return isModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3W2wI.ModalBoundary), {
        packageName: packageName,
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($830b1428deefed01$export$b61e79ae300e872f, {
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'AnalyticsSource'.
        analyticsSource: analyticsSource,
        issueKey: (0, $2QZBX.toIssueKey)(issueKey),
        onClose: onClose
    }))) : null;
};

});
parcelRegister("3W2wI", function(module, exports) {
$parcel$export(module.exports, "ModalBoundary", () => $e3dc360056e1228a$export$c3f500e812fb1bb3);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $1qbKn = parcelRequire("1qbKn");

var $h47gY = parcelRequire("h47gY");

var $2imLM = parcelRequire("2imLM");
const $e3dc360056e1228a$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eJOHy.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("lbDFC", function(module, exports) {
$parcel$export(module.exports, "useTriggerIssueViewModal", () => $68046280a2fbb8d9$export$fb8fdfbeb70f910c);

var $12DRg = parcelRequire("12DRg");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $68046280a2fbb8d9$var$initialState = {
    isModalOpen: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    issueKey: '',
    packageName: '',
    analyticsSource: '',
    issueCreateSessionId: undefined
};
const $68046280a2fbb8d9$export$e324594224ef24da = {
    openIssueViewModal: (nextState)=>({ setState: setState })=>{
            setState({
                ...$68046280a2fbb8d9$var$initialState,
                ...nextState,
                isModalOpen: true
            });
        },
    closeIssueViewModal: ()=>({ setState: setState })=>{
            setState({
                ...$68046280a2fbb8d9$var$initialState,
                isModalOpen: false
            });
        },
    setIssueCreateSessionId: (issueCreateSessionId)=>({ setState: setState })=>{
            setState({
                issueCreateSessionId: issueCreateSessionId
            });
        }
};
const $68046280a2fbb8d9$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view.controllers.open-issue-view-modal',
    initialState: $68046280a2fbb8d9$var$initialState,
    actions: $68046280a2fbb8d9$export$e324594224ef24da
});
const $68046280a2fbb8d9$export$fb8fdfbeb70f910c = (0, $iJq0l.createHook)($68046280a2fbb8d9$var$store);

});


parcelRegister("3Fjdk", function(module, exports) {
$parcel$export(module.exports, "KeyboardShortcuts", () => $39af270327288b6c$export$5176144edf2bef2b);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $5qPoO = parcelRequire("5qPoO");

var $ixiAQ = parcelRequire("ixiAQ");


var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");


var $frzkV = parcelRequire("frzkV");

var $dfP3D = parcelRequire("dfP3D");

var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $2imLM = parcelRequire("2imLM");

var $dRfS0 = parcelRequire("dRfS0");

var $eJrcF = parcelRequire("eJrcF");
// Retaining the old name to avoid breaking any dashboards that may break due to this refactor
const $39af270327288b6c$var$PACKAGE_NAME = '@atlassian/jira-atlassian-navigation';
const $39af270327288b6c$var$KeyboardShortcuts = ()=>{
    const [, { on: on }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).SEARCH);
    const [, { off: closeAllMenus }] = (0, $gOfBc.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const rightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const [{ isInitialLoad: isInitialLoad }, actions] = (0, $5qPoO.useIsInitialLoadLegacyIssueCreate)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const isInitialLoadRef = (0, $eJOHy.useRef)(false);
    isInitialLoadRef.current = isInitialLoad;
    const openSearch = (0, $eJOHy.useCallback)(()=>requestAnimationFrame(()=>{
            on();
        }), [
        on
    ]);
    let currentIssueCreateVisibility = null;
    // TODO: delete when cleaning issue-create-stop-using-gicoptinstatusresources
    if ((0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const openIssueCreate = (0, $eJOHy.useCallback)(()=>{
        if ((0, $4cTDP.fg)('issue-create-stop-using-gicoptinstatusresources')) {
            openIssueCreateModal({
                triggerPointKey: (0, $84DOT.GENERIC_KEYBOARD_SHORTCUT)
            });
            return;
        }
        // TODO: delete when cleaning issue-create-stop-using-gicoptinstatusresources
        if ((0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) openIssueCreateModal({
                    triggerPointKey: (0, $84DOT.GENERIC_KEYBOARD_SHORTCUT)
                });
                else {
                    (0, $ixiAQ.default)({
                        isInitialLoad: isInitialLoadRef.current,
                        triggerSource: (0, $8b9f565bf0bbac99$export$7e22286cafe320a7)
                    });
                    if (isInitialLoadRef.current) actions.clearInitialLoaded();
                }
            } else (0, $eSnSE.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            (0, $ixiAQ.default)({
                isInitialLoad: isInitialLoadRef.current,
                triggerSource: (0, $8b9f565bf0bbac99$export$7e22286cafe320a7)
            });
            if (isInitialLoadRef.current) actions.clearInitialLoaded();
        }
    }, [
        actions,
        currentIssueCreateVisibility,
        openIssueCreateModal
    ]);
    const toggleHelpPanel = (0, $eJOHy.useCallback)(()=>{
        closeAllMenus();
        if (!rightSidebarState?.isCollapsed && rightSidebarState?.panelId === (0, $60b564818f0d5fed$export$e99efa3985fa3c26)) closeCurrentRightSidebar();
        else openRightSidebar((0, $60b564818f0d5fed$export$e99efa3985fa3c26), (0, $60b564818f0d5fed$export$23aa6670f346c214));
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        rightSidebarState?.isCollapsed,
        rightSidebarState?.panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts",
        packageName: $39af270327288b6c$var$PACKAGE_NAME,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "lazy-shortcuts",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $frzkV.KeyboardShortcuts), {
        showIssueCreate: openIssueCreate,
        showSearch: openSearch,
        toggleHelpPanel: toggleHelpPanel,
        shouldUseHelpShortcut: true
    })));
};
const $39af270327288b6c$var$DummyComponent = ()=>null;
// https://jplat.atlassian.net/browse/JFP-3418
// This component currently crashes the page during Hot Module Replacement. So
// we're disabling this component when HMR is enabled (i.e. the --hmr flag is
// present). This a temporary measure until we find a proper fix. This will not
// affect regular development or the customer experience.
const $39af270327288b6c$export$5176144edf2bef2b = $39af270327288b6c$var$KeyboardShortcuts;

});
parcelRegister("5qPoO", function(module, exports) {
$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $62891830fba96f35$export$8a73e89ffc4b9342);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $62891830fba96f35$var$initialState = {
    isInitialLoad: true
};
const $62891830fba96f35$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $62891830fba96f35$var$store = (0, $GtRbT.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $62891830fba96f35$var$initialState,
    actions: $62891830fba96f35$export$e324594224ef24da
});
const $62891830fba96f35$export$8a73e89ffc4b9342 = (0, $iJq0l.createHook)($62891830fba96f35$var$store);

});

parcelRegister("ixiAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d65f09fde2c4e2e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");

var $4cTDP = parcelRequire("4cTDP");

var $kxCpN = parcelRequire("kxCpN");
const $8d65f09fde2c4e2e$var$onCreateClick = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $kxCpN.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $gjeS9.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api?.showCreateDialog({});
        (0, $kxCpN.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};
var $8d65f09fde2c4e2e$export$2e2bcd8739ae039 = $8d65f09fde2c4e2e$var$onCreateClick;

});
parcelRegister("kxCpN", function(module, exports) {
$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $4bd568bdda78fab3$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $4bd568bdda78fab3$export$b5c5d408bb7fd104);

var $2QTvK = parcelRequire("2QTvK");

var $cKx4P = parcelRequire("cKx4P");
const $4bd568bdda78fab3$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $cKx4P.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $cKx4P.legacyIssueCreateTransitionInteraction).start();
        (0, $cKx4P.legacyIssueCreateCombinedInteraction).start();
    }
};
const $4bd568bdda78fab3$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $2QTvK.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $cKx4P.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $cKx4P.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $cKx4P.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("2QTvK", function(module, exports) {
$parcel$export(module.exports, "apiReady", () => $8b17da24b9e1b1f2$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
let $8b17da24b9e1b1f2$var$currentBridge;
const $8b17da24b9e1b1f2$export$330fb1a04c974aad = async ()=>{
    if ($8b17da24b9e1b1f2$var$currentBridge) return $8b17da24b9e1b1f2$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $gjeS9.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $8b17da24b9e1b1f2$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("cKx4P", function(module, exports) {
$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $b0beec06c3c56c69$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $b0beec06c3c56c69$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $b0beec06c3c56c69$export$52353a8848646ccd);

var $hqYEY = parcelRequire("hqYEY");
const $b0beec06c3c56c69$export$2bc24132dfd54487 = (0, $hqYEY.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $b0beec06c3c56c69$export$ba0054dee3105c90 = (0, $hqYEY.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $b0beec06c3c56c69$export$52353a8848646ccd = (0, $hqYEY.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



const $8b9f565bf0bbac99$export$d983e94cf86f65d = 'global-create-button';
const $8b9f565bf0bbac99$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("frzkV", function(module, exports) {
$parcel$export(module.exports, "KeyboardShortcuts", () => $4a70226b9a3bb88c$export$5176144edf2bef2b);

var $bQWwW = parcelRequire("bQWwW");

const $4a70226b9a3bb88c$export$5176144edf2bef2b = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("ckoEf")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/keyboard-shortcuts/src/view/index.tsx"
});

});
parcelRegister("ckoEf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5atoJ").then(()=>parcelRequire('ksNs6'));

});


parcelRegister("gOfBc", function(module, exports) {
$parcel$export(module.exports, "useTopMenus", () => $2279d013e3a03311$export$6591d6b6c4546423);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $dA7TN = parcelRequire("dA7TN");
const { SwitchContainer: $2279d013e3a03311$var$SwitchContainer, useSwitch: $2279d013e3a03311$var$useSwitch } = (0, $dA7TN.createSwitchController)('atlassian-navigation-top-menus');
const $2279d013e3a03311$export$45ccf7b2695bac19 = $2279d013e3a03311$var$SwitchContainer;
const $2279d013e3a03311$var$useTopMenusBase = $2279d013e3a03311$var$useSwitch;
const $2279d013e3a03311$export$6591d6b6c4546423 = (props)=>{
    const switcher = $2279d013e3a03311$var$useTopMenusBase(props);
    const [{ isOpen: isCommandPaletteOpen }] = (0, $g51Bg.useCommandPaletteIsOpen)();
    const [isSwitchOpen, { off: off }] = switcher;
    (0, $eJOHy.useEffect)(()=>{
        if (isSwitchOpen && isCommandPaletteOpen) off();
    }, [
        isCommandPaletteOpen,
        isSwitchOpen,
        off
    ]);
    return switcher;
};

});
parcelRegister("g51Bg", function(module, exports) {
$parcel$export(module.exports, "useCommandPalette", () => $b0966e39df9c724a$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $b0966e39df9c724a$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $b0966e39df9c724a$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $b0966e39df9c724a$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $b0966e39df9c724a$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $b0966e39df9c724a$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $b0966e39df9c724a$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $b0966e39df9c724a$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $b0966e39df9c724a$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $b0966e39df9c724a$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $b0966e39df9c724a$export$bbc05723eb144e03);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $2OtIa = parcelRequire("2OtIa");

var $1kl5C = parcelRequire("1kl5C");
const $b0966e39df9c724a$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $b0966e39df9c724a$var$store = (0, $GtRbT.createStore)({
    initialState: $b0966e39df9c724a$var$initialState,
    actions: $1kl5C.actions,
    name: 'commandPalette'
});
const $b0966e39df9c724a$export$6b58f9610017fbb7 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store);
const $b0966e39df9c724a$export$72aa7bc7c6a83c36 = (0, $iJq0l.createActionsHook)($b0966e39df9c724a$var$store);
const $b0966e39df9c724a$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $b0966e39df9c724a$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $b0966e39df9c724a$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $2OtIa.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $2OtIa.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $2OtIa.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $b0966e39df9c724a$export$1f90c8f89f98110e = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: $b0966e39df9c724a$export$56f06313122d0aac
});
const $b0966e39df9c724a$export$cc979be9b69236df = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $b0966e39df9c724a$export$a18633b655403b12 = (0, $iJq0l.createStateHook)($b0966e39df9c724a$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $b0966e39df9c724a$export$af8fd8cd4b048315 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $b0966e39df9c724a$export$4372697329bd9cbe = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $b0966e39df9c724a$export$7422170a403e909 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $b0966e39df9c724a$export$282aa48e4a3afada = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $b0966e39df9c724a$export$96819dfb22ad05d3 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $b0966e39df9c724a$export$a40e8ae3e53feab0 = (0, $4MchI.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $2OtIa.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $b0966e39df9c724a$export$f893891deedab3c6 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: $b0966e39df9c724a$export$a40e8ae3e53feab0
});
const $b0966e39df9c724a$export$bbc05723eb144e03 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("2OtIa", function(module, exports) {
$parcel$export(module.exports, "getRegistryData", () => $94a7203ed38fd013$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $94a7203ed38fd013$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $94a7203ed38fd013$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $94a7203ed38fd013$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $94a7203ed38fd013$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $94a7203ed38fd013$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $94a7203ed38fd013$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $94a7203ed38fd013$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $94a7203ed38fd013$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $94a7203ed38fd013$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $94a7203ed38fd013$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $94a7203ed38fd013$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $94a7203ed38fd013$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $94a7203ed38fd013$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $94a7203ed38fd013$export$c3d20e8c1e93a572);

var $eJOHy = parcelRequire("eJOHy");

var $jhs3c = parcelRequire("jhs3c");

var $58ssj = parcelRequire("58ssj");

var $cMTOh = parcelRequire("cMTOh");

var $hf4h9 = parcelRequire("hf4h9");
const $94a7203ed38fd013$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $94a7203ed38fd013$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$94a7203ed38fd013$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $94a7203ed38fd013$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $94a7203ed38fd013$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $94a7203ed38fd013$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $94a7203ed38fd013$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $94a7203ed38fd013$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $94a7203ed38fd013$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $94a7203ed38fd013$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $94a7203ed38fd013$export$389b0273703d5c48(sections)
    };
};
const $94a7203ed38fd013$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $94a7203ed38fd013$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$94a7203ed38fd013$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$94a7203ed38fd013$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$94a7203ed38fd013$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $94a7203ed38fd013$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $94a7203ed38fd013$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $94a7203ed38fd013$export$daa5beabdf8d9fc3 = (event)=>(0, $58ssj.isMacOs)() ? event.metaKey : event.ctrlKey;
const $94a7203ed38fd013$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $94a7203ed38fd013$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $94a7203ed38fd013$export$fa1c95a5ffa92036 = (str)=>(0, $jhs3c.createHash)().update(str).digest('hex');
const $94a7203ed38fd013$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $94a7203ed38fd013$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $94a7203ed38fd013$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $94a7203ed38fd013$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("58ssj", function(module, exports) {
$parcel$export(module.exports, "isMacOs", () => $fb97470616ba47a5$export$c5e71f489eb3970b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $fb97470616ba47a5$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);

});

parcelRegister("cMTOh", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $8120698a127d7ee3$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $8120698a127d7ee3$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $8120698a127d7ee3$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $8120698a127d7ee3$export$894e19fc96687503);
// EVENT TYPES
const $8120698a127d7ee3$export$a1562d08625f5d7e = 'UI';
const $8120698a127d7ee3$export$947dac6c72b26f81 = 'TRACK';
const $8120698a127d7ee3$export$f1d537d508d2945a = 'SCREEN';
const $8120698a127d7ee3$export$12346a674644c156 = 'OPERATIONAL';
var $8120698a127d7ee3$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $8120698a127d7ee3$export$894e19fc96687503 = 250;

});

parcelRegister("hf4h9", function(module, exports) {
$parcel$export(module.exports, "CommandActionType", () => $1ef2266e5ff751a8$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $1ef2266e5ff751a8$export$904b2a0e38a1bef3);
var $1ef2266e5ff751a8$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $1ef2266e5ff751a8$export$3e448fd53031e13c = Object.values($1ef2266e5ff751a8$export$f041b1b117ab382f);
const $1ef2266e5ff751a8$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("1kl5C", function(module, exports) {
$parcel$export(module.exports, "actions", () => $fa5d3433a241f524$export$e324594224ef24da);

var $jvwCK = parcelRequire("jvwCK");

var $aXKmr = parcelRequire("aXKmr");

var $58ssj = parcelRequire("58ssj");

var $bpkMB = parcelRequire("bpkMB");

var $h6i8k = parcelRequire("h6i8k");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $cMTOh = parcelRequire("cMTOh");

var $hf4h9 = parcelRequire("hf4h9");

var $2OtIa = parcelRequire("2OtIa");

var $1tIH1 = parcelRequire("1tIH1");

var $aJbE4 = parcelRequire("aJbE4");

var $7RhQ7 = parcelRequire("7RhQ7");
const $fa5d3433a241f524$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $fa5d3433a241f524$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        if (!getState().isOpen) (0, $h6i8k.default)('command-palette-opened');
        setState({
            commandPaletteSessionId: (0, $aXKmr.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $fa5d3433a241f524$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$fa5d3433a241f524$var$rootCommands
        });
    };
const $fa5d3433a241f524$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $aXKmr.v4)() : '',
            ...!isOpen ? $fa5d3433a241f524$var$rootCommands : {}
        });
    };
const $fa5d3433a241f524$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $fa5d3433a241f524$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $fa5d3433a241f524$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $fa5d3433a241f524$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $fa5d3433a241f524$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $fa5d3433a241f524$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $fa5d3433a241f524$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $cMTOh.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $fa5d3433a241f524$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $fa5d3433a241f524$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $fa5d3433a241f524$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $2OtIa.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $fa5d3433a241f524$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $h6i8k.default)('command-palette-executed');
                    if ((0, $4cTDP.fg)('jjj_ask_rovo_compal_v1')) {
                        const performContext = {
                            search: onClosePendingCommandAction.context?.search
                        };
                        onClosePendingCommandAction.perform(performContext);
                    } else onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $9pTd3.fireErrorAnalytics)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $bpkMB.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $fa5d3433a241f524$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $1tIH1.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $2OtIa.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        (0, $7RhQ7.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $2OtIa.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $2OtIa.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $hf4h9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $h6i8k.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $aJbE4.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $cMTOh.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $58ssj.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $h6i8k.default)('command-palette-executed');
                if ((0, $4cTDP.fg)('jjj_ask_rovo_compal_v1')) {
                    const performContext = {
                        search: currentState.search
                    };
                    currentCommandAction.perform(performContext);
                } else currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $9pTd3.fireErrorAnalytics)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $bpkMB.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent,
                    ...(0, $4cTDP.fg)('jjj_ask_rovo_compal_v1') && {
                        context: {
                            search: currentState.search
                        }
                    }
                }
            });
        }
    };
const $fa5d3433a241f524$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $fa5d3433a241f524$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $fa5d3433a241f524$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $fa5d3433a241f524$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $fa5d3433a241f524$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $fa5d3433a241f524$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $fa5d3433a241f524$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $fa5d3433a241f524$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $fa5d3433a241f524$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $fa5d3433a241f524$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $fa5d3433a241f524$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $fa5d3433a241f524$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $fa5d3433a241f524$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $fa5d3433a241f524$export$e324594224ef24da = {
    open: $fa5d3433a241f524$var$open,
    toggle: $fa5d3433a241f524$var$toggle,
    close: $fa5d3433a241f524$var$close,
    addCommands: $fa5d3433a241f524$var$addCommands,
    removeCommands: $fa5d3433a241f524$var$removeCommands,
    handleSearch: $fa5d3433a241f524$var$handleSearch,
    forceFocusSearch: $fa5d3433a241f524$var$forceFocusSearch,
    setActiveIndex: $fa5d3433a241f524$var$setActiveIndex,
    executeCommand: $fa5d3433a241f524$var$executeCommand,
    goBackLevel: $fa5d3433a241f524$var$goBackLevel,
    setChildCommands: $fa5d3433a241f524$var$setChildCommands,
    setLoadingList: $fa5d3433a241f524$var$setLoadingList,
    setFocusInput: $fa5d3433a241f524$var$setFocusInput,
    registerSections: $fa5d3433a241f524$var$registerSections,
    unregisterSections: $fa5d3433a241f524$var$unregisterSections,
    markAsLoaded: $fa5d3433a241f524$var$markAsLoaded,
    getAnalyticsAttributes: $fa5d3433a241f524$var$getAnalyticsAttributes,
    setIsDisabled: $fa5d3433a241f524$var$setIsDisabled,
    setRegistry: $fa5d3433a241f524$var$setRegistry,
    updateActiveRegistry: $fa5d3433a241f524$var$updateActiveRegistry,
    removeCommandsById: $fa5d3433a241f524$var$removeCommandsById,
    removeFromActiveRegistry: $fa5d3433a241f524$var$removeFromActiveRegistry,
    performDialogCloseCommand: $fa5d3433a241f524$var$performDialogCloseCommand,
    setAnalytics: $fa5d3433a241f524$var$setAnalytics,
    setFallbackOverride: $fa5d3433a241f524$var$setFallbackOverride,
    setHasPopupOverlay: $fa5d3433a241f524$var$setHasPopupOverlay,
    forceSearchValue: $fa5d3433a241f524$var$forceSearchValue,
    resetShouldForceSearchValue: $fa5d3433a241f524$var$resetShouldForceSearchValue
};

});
parcelRegister("1tIH1", function(module, exports) {
$parcel$export(module.exports, "getActiveCommandList", () => $494c53c0493f50d3$export$639b7f41b0b47a01);

var $hf4h9 = parcelRequire("hf4h9");
const $494c53c0493f50d3$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("aJbE4", function(module, exports) {
$parcel$export(module.exports, "isSearchableChildrenAction", () => $8d0720613ed3e2cc$export$d75616d77443fe4e);

var $hf4h9 = parcelRequire("hf4h9");
const $8d0720613ed3e2cc$export$d75616d77443fe4e = (action)=>action?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("7RhQ7", function(module, exports) {
$parcel$export(module.exports, "setEventAttribute", () => $45c284350ab5fd95$export$7c0a9f4caaf7cfce);

var $3mZMJ = parcelRequire("3mZMJ");

var $d2AGn = parcelRequire("d2AGn");
const $45c284350ab5fd95$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $45c284350ab5fd95$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $45c284350ab5fd95$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setAttributes((0, $3mZMJ.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("d2AGn", function(module, exports) {
$parcel$export(module.exports, "eventFlowManager", () => $84369507dcd887ed$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $84369507dcd887ed$export$f3b2b77402b2631f);

var $aXKmr = parcelRequire("aXKmr");

var $eSnSE = parcelRequire("eSnSE");

var $kRgKj = parcelRequire("kRgKj");

var $3bSs8 = parcelRequire("3bSs8");

var $aW71L = parcelRequire("aW71L");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $84369507dcd887ed$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $aXKmr.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $84369507dcd887ed$export$87846400a9b428fc = new $84369507dcd887ed$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $84369507dcd887ed$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const fieldType = fieldTypeValue && (0, $3bSs8.FIELD_TYPE_MAP)[fieldTypeValue] ? (0, $3bSs8.FIELD_TYPE_MAP)[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $3bSs8.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $84369507dcd887ed$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $84369507dcd887ed$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $aW71L.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes,
                assigneeId: assigneeId
            });
            const sessionid = $84369507dcd887ed$export$87846400a9b428fc.push(fieldKey);
            const attributes = $84369507dcd887ed$var$concatAttributes(fieldKey, sessionid, params.attributes);
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $kRgKj.fireUIAnalytics)(params.analytics, `${(0, $3bSs8.START_ACTION_SUBJECT)} ${(0, $3bSs8.START_ACTION)}`, (0, $3bSs8.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $84369507dcd887ed$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $aW71L.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $84369507dcd887ed$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $3bSs8.UNKNOWN_FIELD_IDS).includes(fieldKey);
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $84369507dcd887ed$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $kRgKj.fireTrackAnalytics)(params.analytics, `${(0, $3bSs8.END_ACTION_SUBJECT)} ${(0, $3bSs8.END_ACTION)}`, (0, $3bSs8.END_ACTION_SUBJECT_ID), {
                ...attributes,
                is_new_1event: true
            });
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $84369507dcd887ed$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        const currentAttributes = $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.get(fieldKey);
        $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
            ...currentAttributes,
            ...attributes
        });
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $aW71L.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $84369507dcd887ed$export$87846400a9b428fc.pull(fieldKey);
        $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $84369507dcd887ed$export$87846400a9b428fc.reset();
    }
};
const $84369507dcd887ed$export$f3b2b77402b2631f = ()=>$84369507dcd887ed$var$updateAnalyticsFlowHelper;

});
parcelRegister("3bSs8", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $0694d3ffaf31cb5e$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $0694d3ffaf31cb5e$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $0694d3ffaf31cb5e$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $0694d3ffaf31cb5e$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $0694d3ffaf31cb5e$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $0694d3ffaf31cb5e$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $0694d3ffaf31cb5e$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $0694d3ffaf31cb5e$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $0694d3ffaf31cb5e$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $0694d3ffaf31cb5e$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $0694d3ffaf31cb5e$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $0694d3ffaf31cb5e$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $0694d3ffaf31cb5e$export$7d9dd31e187cb2db);

var $3mZMJ = parcelRequire("3mZMJ");
const $0694d3ffaf31cb5e$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $0694d3ffaf31cb5e$export$c0a4673e0c78e972 = 'clicked';
const $0694d3ffaf31cb5e$export$34a5ae354a38cc7e = 'item';
const $0694d3ffaf31cb5e$export$bc373f59492dc6e2 = 'issue';
const $0694d3ffaf31cb5e$export$b19686c1fe99f85a = 'updated';
const $0694d3ffaf31cb5e$export$4ce67e80878d47ed = 'issue';
const $0694d3ffaf31cb5e$export$e3d957ccc2d46469 = 'ended';
const $0694d3ffaf31cb5e$export$3b3e3ac6d7f6e219 = 'add';
const $0694d3ffaf31cb5e$export$6137e1b2fcde2333 = 'remove';
const $0694d3ffaf31cb5e$export$6d8c364f9d389764 = 'unknown';
const $0694d3ffaf31cb5e$export$7d1d20ff891eeb26 = [
    $0694d3ffaf31cb5e$export$6d8c364f9d389764
];
const $0694d3ffaf31cb5e$export$d8ccf495ccc97a69 = {
    [(0, $3mZMJ.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $3mZMJ.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $3mZMJ.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $3mZMJ.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $3mZMJ.COMPONENTS_TYPE)]: 'components',
    [(0, $3mZMJ.DATE_CF_TYPE)]: 'date',
    [(0, $3mZMJ.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $3mZMJ.DESCRIPTION_TYPE)]: 'richText',
    [(0, $3mZMJ.DUE_DATE_TYPE)]: 'date',
    [(0, $3mZMJ.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $3mZMJ.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $3mZMJ.GOALS_CF_TYPE)]: 'goals',
    [(0, $3mZMJ.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $3mZMJ.ISSUE_TYPE)]: 'issuetype',
    [(0, $3mZMJ.LABELS_CF_TYPE)]: 'labels',
    [(0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $3mZMJ.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $3mZMJ.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $3mZMJ.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $3mZMJ.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $3mZMJ.NUMBER_CF_TYPE)]: 'float',
    [(0, $3mZMJ.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $3mZMJ.PARENT_TYPE)]: 'parent',
    [(0, $3mZMJ.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $3mZMJ.PRIORITY_TYPE)]: 'priority',
    [(0, $3mZMJ.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $3mZMJ.RANK_CF_TYPE)]: 'rank',
    [(0, $3mZMJ.START_DATE_TYPE)]: 'date',
    [(0, $3mZMJ.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $3mZMJ.SPRINT_TYPE)]: 'sprint',
    [(0, $3mZMJ.STATUS_TYPE)]: 'status',
    [(0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $3mZMJ.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $3mZMJ.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $3mZMJ.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $3mZMJ.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $3mZMJ.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $3mZMJ.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $3mZMJ.URL_CF_TYPE)]: 'url',
    [(0, $3mZMJ.USER_CF_TYPE)]: 'singleUser',
    [(0, $3mZMJ.VERSION_CF_TYPE)]: 'version',
    [(0, $3mZMJ.VOTES_TYPE)]: 'votes',
    [(0, $3mZMJ.WATCHES_TYPE)]: 'watchers'
};
const $0694d3ffaf31cb5e$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("aW71L", function(module, exports) {
$parcel$export(module.exports, "getActionTaken", () => $56306893bffbb0cd$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $56306893bffbb0cd$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $56306893bffbb0cd$export$4cb0aa9574634a48);

var $3bSs8 = parcelRequire("3bSs8");
const $56306893bffbb0cd$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $3bSs8.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $3bSs8.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $56306893bffbb0cd$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $56306893bffbb0cd$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});






parcelRegister("84DOT", function(module, exports) {
$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $0cf751b242c962b3$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $0cf751b242c962b3$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $0cf751b242c962b3$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $0cf751b242c962b3$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $0cf751b242c962b3$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $0cf751b242c962b3$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $0cf751b242c962b3$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $0cf751b242c962b3$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $0cf751b242c962b3$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $0cf751b242c962b3$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $0cf751b242c962b3$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $0cf751b242c962b3$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $0cf751b242c962b3$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $0cf751b242c962b3$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $0cf751b242c962b3$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $0cf751b242c962b3$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $0cf751b242c962b3$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $0cf751b242c962b3$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $0cf751b242c962b3$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $0cf751b242c962b3$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $0cf751b242c962b3$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $0cf751b242c962b3$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $0cf751b242c962b3$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $0cf751b242c962b3$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $0cf751b242c962b3$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $0cf751b242c962b3$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $0cf751b242c962b3$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $0cf751b242c962b3$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $0cf751b242c962b3$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $0cf751b242c962b3$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $0cf751b242c962b3$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $0cf751b242c962b3$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $0cf751b242c962b3$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $0cf751b242c962b3$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $0cf751b242c962b3$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_ISSUE_COMMENT", () => $0cf751b242c962b3$export$220cd7b39e0b57a);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $0cf751b242c962b3$export$ab926dced0f69c1e);
$parcel$export(module.exports, "UC_ATLASSIAN_HOME_CREATE_ISSUE", () => $0cf751b242c962b3$export$d3df6a0ce4e0bc8b);
$parcel$export(module.exports, "JIRA_ISSUE_TABLE_TRIGGER", () => $0cf751b242c962b3$export$99b5cdc74c6071b4);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $0cf751b242c962b3$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $0cf751b242c962b3$export$7a8328e1f8bd992b);
const $0cf751b242c962b3$export$a05673a22505d5ee = 'forge-open-issue-create';
const $0cf751b242c962b3$export$c78d329777576aa0 = 'global-create-button';
const $0cf751b242c962b3$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $0cf751b242c962b3$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $0cf751b242c962b3$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $0cf751b242c962b3$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $0cf751b242c962b3$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $0cf751b242c962b3$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $0cf751b242c962b3$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $0cf751b242c962b3$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $0cf751b242c962b3$export$9bc326812a93707 = 'jsw-security-create-issue';
const $0cf751b242c962b3$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $0cf751b242c962b3$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $0cf751b242c962b3$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $0cf751b242c962b3$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $0cf751b242c962b3$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $0cf751b242c962b3$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $0cf751b242c962b3$export$235b856f54db8916 = 'jwm-board-create-issue';
const $0cf751b242c962b3$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $0cf751b242c962b3$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $0cf751b242c962b3$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $0cf751b242c962b3$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $0cf751b242c962b3$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $0cf751b242c962b3$export$aa348159181703a0 = 'software-create-issue-dialog';
const $0cf751b242c962b3$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $0cf751b242c962b3$export$718822a309bffada = 'create-linked-issue-command-palette';
const $0cf751b242c962b3$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $0cf751b242c962b3$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $0cf751b242c962b3$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $0cf751b242c962b3$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $0cf751b242c962b3$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $0cf751b242c962b3$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $0cf751b242c962b3$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $0cf751b242c962b3$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $0cf751b242c962b3$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $0cf751b242c962b3$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $0cf751b242c962b3$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $0cf751b242c962b3$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $0cf751b242c962b3$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $0cf751b242c962b3$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $0cf751b242c962b3$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $0cf751b242c962b3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $0cf751b242c962b3$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $0cf751b242c962b3$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $0cf751b242c962b3$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $0cf751b242c962b3$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $0cf751b242c962b3$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $0cf751b242c962b3$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $0cf751b242c962b3$export$145eb8935a34e85e = 'jwm-inline-create';
const $0cf751b242c962b3$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $0cf751b242c962b3$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $0cf751b242c962b3$export$220cd7b39e0b57a = 'jira-issue-comment';
const $0cf751b242c962b3$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $0cf751b242c962b3$export$d3df6a0ce4e0bc8b = 'uc-atlassian-home-create-issue';
const $0cf751b242c962b3$export$99b5cdc74c6071b4 = 'jira-issue-table-trigger';
const $0cf751b242c962b3$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $0cf751b242c962b3$export$7a8328e1f8bd992b = [
    $0cf751b242c962b3$export$7e9cfd1f59e60910,
    $0cf751b242c962b3$export$708499dcd016e5e9,
    $0cf751b242c962b3$export$e1c8789144c4c810,
    $0cf751b242c962b3$export$c5afabb7a17e802
];

});

parcelRegister("jipjz", function(module, exports) {
$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $fd6d975a09a2a8e6$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $fd6d975a09a2a8e6$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $fd6d975a09a2a8e6$export$558a195c5bfe3787);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $iIqFO = parcelRequire("iIqFO");

var $3UrQk = parcelRequire("3UrQk");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dRfS0 = parcelRequire("dRfS0");

var $eJrcF = parcelRequire("eJrcF");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $4cTDP = parcelRequire("4cTDP");

var $84DOT = parcelRequire("84DOT");

var $bitlK = parcelRequire("bitlK");

var $hBHUL = parcelRequire("hBHUL");
const $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $3UrQk.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $84DOT.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null,
    // reference to the element to focus when the modal is closed
    returnFocusRef: undefined
};
const $fd6d975a09a2a8e6$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $hBHUL.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $hBHUL.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $hBHUL.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $hBHUL.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                if ((0, $4cTDP.fg)('fix-gryf-a11y-issues')) {
                    /*
					 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
					 * so that we can store the reference of this
					 * and use that to re-focus the button whenever the modal is closed
					 */ let triggerButton;
                    const handleButtonClick = (event)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const triggerButtonTarget = event.target;
                        triggerButton = triggerButtonTarget?.closest('button');
                        triggerButton?.focus();
                    };
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.addEventListener('click', handleButtonClick);
                    setTimeout(()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        document.removeEventListener('click', handleButtonClick);
                    }, 0);
                    setTimeout(()=>{
                        setState({
                            ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                            ...isDiscoverabilityPushEnabled && {
                                minimizableModalView: nextModalView,
                                persistentModalView: currentState.persistentModalView,
                                ...(0, $hBHUL.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                            },
                            inProgressIssueID: (0, $aXKmr.v4)(),
                            isSubsequentLoad: currentState.isSubsequentLoad,
                            isModalOpen: true,
                            wasModalRetriggered: currentState.isModalOpen,
                            ...(0, $4cTDP.fg)('quick_actions_with_hotkeys_ga') ? {
                                triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                            } : {},
                            ...nextState,
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
                            triggerButtonRef: triggerButton || document.activeElement
                        });
                    }, 0);
                } else setState({
                    ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $hBHUL.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, $aXKmr.v4)(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...(0, $4cTDP.fg)('quick_actions_with_hotkeys_ga') ? {
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                    } : {},
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $hBHUL.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $iIqFO.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $hBHUL.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $fd6d975a09a2a8e6$var$store = (0, $GtRbT.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
    actions: $fd6d975a09a2a8e6$export$e324594224ef24da
});
const $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalState = (0, $iJq0l.createStateHook)($fd6d975a09a2a8e6$var$store);
const $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions = (0, $iJq0l.createActionsHook)($fd6d975a09a2a8e6$var$store);
const $fd6d975a09a2a8e6$export$71e0eb7b8a91a156 = ()=>{
    const createState = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalState();
    const createActions = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eJOHy.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {},
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $kRgKj.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $fd6d975a09a2a8e6$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $bitlK.useSitePickerContext)();
    return (0, $eJOHy.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {},
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {}
        };
        (0, $kRgKj.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $fd6d975a09a2a8e6$export$4c674fe824b8f278 = (0, $ht3nQ.createSubscriber)($fd6d975a09a2a8e6$var$store);
function $fd6d975a09a2a8e6$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $fd6d975a09a2a8e6$export$71e0eb7b8a91a156();
        const { data: data } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: (0, $4cTDP.fg)('gic-user-pref-true') ? true : currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("iIqFO", function(module, exports) {
$parcel$export(module.exports, "CreateIssueUFOExperience", () => $e524612cc2a761dc$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $e524612cc2a761dc$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $e524612cc2a761dc$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $e524612cc2a761dc$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $e524612cc2a761dc$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $e524612cc2a761dc$export$b2d8f8edec75f571);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $e524612cc2a761dc$export$cd75c112ac11a83b = new (0, $f39LL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $e524612cc2a761dc$export$7d25d25bed94d6e2 = new (0, $f39LL.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
});
const $e524612cc2a761dc$export$fda88e8e14acb615 = new (0, $f39LL.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
});
const $e524612cc2a761dc$export$e890e797a25e655c = new (0, $f39LL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e524612cc2a761dc$export$70208657c8d471a7 = new (0, $f39LL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $e524612cc2a761dc$export$b2d8f8edec75f571 = new (0, $f39LL.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("3UrQk", function(module, exports) {
$parcel$export(module.exports, "REQUIRED", () => $7fffaa4718e25dbf$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $7fffaa4718e25dbf$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $7fffaa4718e25dbf$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $7fffaa4718e25dbf$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $7fffaa4718e25dbf$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $7fffaa4718e25dbf$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $7fffaa4718e25dbf$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $7fffaa4718e25dbf$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $7fffaa4718e25dbf$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $7fffaa4718e25dbf$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $7fffaa4718e25dbf$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $7fffaa4718e25dbf$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $7fffaa4718e25dbf$export$17bcab948893a9ba = 'worklog';
const $7fffaa4718e25dbf$export$b1c05b34d317c074 = 'REQUIRED';
const $7fffaa4718e25dbf$export$f10b32dfda12e96e = 'unknown';
const $7fffaa4718e25dbf$export$e5e4b8c32e68dd0b = 'networkError';
const $7fffaa4718e25dbf$export$2d06efb8146cd043 = 'graphQLError';
const $7fffaa4718e25dbf$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $7fffaa4718e25dbf$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $7fffaa4718e25dbf$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $7fffaa4718e25dbf$export$aac4661200ba4104 = 'worklog_startDate';
const $7fffaa4718e25dbf$export$a23c32d5cf54cba0 = 'worklog_description';
const $7fffaa4718e25dbf$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $7fffaa4718e25dbf$export$63fd567c1d0aca19 = [
    ...$7fffaa4718e25dbf$export$74ab3898ae683660,
    $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f,
    $7fffaa4718e25dbf$export$cf70f9220e6a2f50,
    $7fffaa4718e25dbf$export$aac4661200ba4104,
    $7fffaa4718e25dbf$export$a23c32d5cf54cba0
];
const $7fffaa4718e25dbf$export$983715bb9b0f9b2c = {
    [$7fffaa4718e25dbf$export$17bcab948893a9ba]: $7fffaa4718e25dbf$export$63fd567c1d0aca19
};
const $7fffaa4718e25dbf$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $7fffaa4718e25dbf$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $7fffaa4718e25dbf$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $7fffaa4718e25dbf$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("bitlK", function(module, exports) {
$parcel$export(module.exports, "useSitePickerContext", () => $c532dbef0009ad59$export$f8b5aae013e4cf77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $c532dbef0009ad59$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $c532dbef0009ad59$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $c532dbef0009ad59$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $c532dbef0009ad59$export$d4c72bab9d6cc13a,
    actions: $c532dbef0009ad59$export$e324594224ef24da
});
const $c532dbef0009ad59$export$f8b5aae013e4cf77 = (0, $iJq0l.createHook)($c532dbef0009ad59$export$6f57813fe9f31bf9);

});

parcelRegister("hBHUL", function(module, exports) {
$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $ead5ae5f9543822b$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $ead5ae5f9543822b$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $ead5ae5f9543822b$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $ead5ae5f9543822b$export$720579602bb055a2);

var $h6i8k = parcelRequire("h6i8k");

var $iIqFO = parcelRequire("iIqFO");

var $bVObd = parcelRequire("bVObd");

var $Gb6hR = parcelRequire("Gb6hR");
const $ead5ae5f9543822b$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $iIqFO.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $bVObd.globalIssueCreateModalLoadSubsequent) : (0, $bVObd.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $h6i8k.default)('global-issue.create-modal-subsequent');
    else (0, $h6i8k.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $Gb6hR.startGlobalIssueCreateTTIWithAdjustments)();
};
const $ead5ae5f9543822b$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $ead5ae5f9543822b$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $ead5ae5f9543822b$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("bVObd", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $4372308d4d36906f$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $4372308d4d36906f$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $4372308d4d36906f$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $4372308d4d36906f$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $4372308d4d36906f$export$c1592e4d8d98963e);

var $hqYEY = parcelRequire("hqYEY");
const $4372308d4d36906f$export$5a01a7fa84b239c8 = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $4372308d4d36906f$export$c50ad3c31b6fcfc6 = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $4372308d4d36906f$export$4b2382574525bb0f = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $4372308d4d36906f$export$7839bdaa2f6a2385 = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $4372308d4d36906f$export$c1592e4d8d98963e = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("Gb6hR", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $4ce0298162374e06$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $4ce0298162374e06$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $4ce0298162374e06$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $4ce0298162374e06$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $4ce0298162374e06$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $4ce0298162374e06$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $4ce0298162374e06$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $4ce0298162374e06$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @atlassian/jira-packages-controllers-use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @atlassian/jira-packages-controllers-use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $hqYEY = parcelRequire("hqYEY");
const $4ce0298162374e06$export$9f3d6f17e1da7874 = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $4ce0298162374e06$export$457c9fb71ad5b3a9 = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.start();
};
const $4ce0298162374e06$export$ef664dac649a716c = ()=>$4ce0298162374e06$export$9f3d6f17e1da7874.mark('gic-tti');
const $4ce0298162374e06$export$30ca4c461fab486c = (customData)=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $4ce0298162374e06$export$27f2445288b528c = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.cancel();
};
const $4ce0298162374e06$export$7a2709fc1e33401a = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $4ce0298162374e06$export$cf3893335c93e33b = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $4ce0298162374e06$export$d86f4868694f2aa7 = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});




parcelRegister("1TFt8", function(module, exports) {
$parcel$export(module.exports, "Projects", () => $9ed00373928c2d2a$export$ca6fbb51b35e375c);

var $eJOHy = parcelRequire("eJOHy");

var $8dKc6 = parcelRequire("8dKc6");

var $9pWNg = parcelRequire("9pWNg");

var $9o3jI = parcelRequire("9o3jI");

var $kO1ht = parcelRequire("kO1ht");
const $9ed00373928c2d2a$export$90cfe4f15bb50f58 = ({ open: open, close: close, setOnCloseCallback: setOnCloseCallback })=>{
    const [{ canCreateClassicProject: canCreateClassicProject }] = (0, $8dKc6.useCreateProjectPermission)();
    (0, $eJOHy.useEffect)(()=>{
        open && // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        open({
            source: 'navigationNext',
            isNextGen: !canCreateClassicProject
        });
        setOnCloseCallback && setOnCloseCallback(close);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    return null;
};
const $9ed00373928c2d2a$export$ca6fbb51b35e375c = ()=>{
    const [isProjectCreateDrawerOpen, { off: closeProjectCreateDrawer }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).PROJECT_CREATE);
    if (!isProjectCreateDrawerOpen) return null;
    // ProjectCreateDrawerProvider is in page container/navigaiton
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9pWNg.ProjectCreateDrawerConsumer), null, ({ methods: { open: open, setOnCloseCallback: setOnCloseCallback } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ed00373928c2d2a$export$90cfe4f15bb50f58, {
            open: open,
            close: closeProjectCreateDrawer,
            setOnCloseCallback: setOnCloseCallback
        }));
};

});
parcelRegister("8dKc6", function(module, exports) {
$parcel$export(module.exports, "useCreateProjectPermission", () => $9fccc9c30225a879$export$c92733e8f8c1640f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4TumU = parcelRequire("4TumU");
const $9fccc9c30225a879$var$Store = (0, $GtRbT.createStore)({
    name: 'create-project-permissions',
    initialState: {
        canCreateProject: false,
        shouldDisplayCreateProject: false,
        canCreateClassicProject: false,
        canCreateNextGenProject: false,
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $4TumU.actions
});
const $9fccc9c30225a879$export$5a47fbae725b8f2 = (0, $6E16M.createContainer)($9fccc9c30225a879$var$Store);
const $9fccc9c30225a879$export$c92733e8f8c1640f = (0, $iJq0l.createHook)($9fccc9c30225a879$var$Store);
const $9fccc9c30225a879$export$d2b8d6f60fe99e2a = (0, $iJq0l.createHook)($9fccc9c30225a879$var$Store, {
    selector: null
});

});
parcelRegister("4TumU", function(module, exports) {
$parcel$export(module.exports, "actions", () => $652d08a3c7ccaa32$export$e324594224ef24da);

var $hgi0g = parcelRequire("hgi0g");
const $652d08a3c7ccaa32$export$963556ef97965f0b = async ()=>{
    const url = '/rest/internal/2/projectpermissions';
    const result = await (0, $hgi0g.default)(url);
    return result;
};
const $652d08a3c7ccaa32$var$handleFetch = ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            const result = await $652d08a3c7ccaa32$export$963556ef97965f0b();
            setState({
                ...result,
                isFetching: false,
                fetchError: null,
                hasFetchedOnce: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                canCreateProject: false,
                canCreateClassicProject: false,
                canCreateNextGenProject: false,
                isFetching: false,
                fetchError: error,
                hasFetchedOnce: true
            });
        }
    };
const $652d08a3c7ccaa32$export$e324594224ef24da = {
    fetchCreateProjectPermission: ()=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($652d08a3c7ccaa32$var$handleFetch());
            setState({
                isFetching: true,
                promise: // @ts-expect-error - TS2322 - Type 'Promise<void>' is not assignable to type 'Promise<undefined>'.
                promise
            });
        }
};

});


parcelRegister("9pWNg", function(module, exports) {
$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $57e246fe6ba8231d$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $57e246fe6ba8231d$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $57e246fe6ba8231d$export$8172ff4ed0f75a1e);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $f4Iys = parcelRequire("f4Iys");

var $3KcCl = parcelRequire("3KcCl");

var $83DiZ = parcelRequire("83DiZ");

var $4cTDP = parcelRequire("4cTDP");

var $g27SL = parcelRequire("g27SL");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $57e246fe6ba8231d$var$Context = /*#__PURE__*/ (0, $eJOHy.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        setOnCreatedCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        clearOnCreatedCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }
});
const $57e246fe6ba8231d$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $eJOHy.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57e246fe6ba8231d$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    ...(0, $4cTDP.fg)('jira_project_create_drawer_support_onboarding') && {
                        isOnboarding: this.state.isOnboarding
                    },
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback,
                    setOnCreatedCallback: this.setOnCreatedCallback,
                    clearOnCreatedCallback: this.clearOnCreatedCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            ...(0, $4cTDP.fg)('jira_project_create_drawer_support_onboarding') && {
                isOnboarding: false
            },
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCreatedCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, this.onSuccess = (project)=>{
            if (project) {
                this.props.setLocation(project.returnUrl);
                this.close(true);
                this.state.onCreatedCallback(project);
            } else this.close(false);
        }, // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        }, this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
            });
        }, // Callback that is called once when a project is successfully created.
        this.setOnCreatedCallback = (callback)=>{
            this.setState({
                onCreatedCallback: callback
            });
        }, this.clearOnCreatedCallback = ()=>{
            this.setState({
                onCreatedCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
            });
        }, this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        }, this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                ...(0, $4cTDP.fg)('jira_project_create_drawer_support_onboarding') && {
                    isOnboarding: false
                },
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        }, this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                ...(0, $4cTDP.fg)('jira_project_create_drawer_support_onboarding') && {
                    isOnboarding: false
                },
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        }, this.onCreateStarted = (projectKey, templateKey)=>{
            if ((0, $f4Iys.getIsJsmBlankProjectTemplate)(templateKey)) (0, $3KcCl.LazyComponent).preload();
            (0, $g27SL.clearResourcesAssociatedWithProjectKey)(projectKey);
        };
    }
};
const $57e246fe6ba8231d$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57e246fe6ba8231d$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $57e246fe6ba8231d$export$9a8662cd60931de1 } = $57e246fe6ba8231d$var$Context;
$57e246fe6ba8231d$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $57e246fe6ba8231d$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $eJOHy.useContext)($57e246fe6ba8231d$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("3KcCl", function(module, exports) {
$parcel$export(module.exports, "LazyComponent", () => $fc3d1cf7a1b986e8$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $fc3d1cf7a1b986e8$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $fc3d1cf7a1b986e8$export$ff317c5d87147a19);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $2wyE1 = parcelRequire("2wyE1");

var $bQWwW = parcelRequire("bQWwW");

const $fc3d1cf7a1b986e8$export$31f1740ae531af94 = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("480sL")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
});
const $fc3d1cf7a1b986e8$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wyE1.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc3d1cf7a1b986e8$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $fc3d1cf7a1b986e8$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("2wyE1", function(module, exports) {
$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $8f31292a89ad467e$export$ac31f8f3368d6881);

var $eJOHy = parcelRequire("eJOHy");

var $kGj4V = parcelRequire("kGj4V");

var $6nVJI = parcelRequire("6nVJI");

var $cu1g7 = parcelRequire("cu1g7");
const $8f31292a89ad467e$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eJOHy.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
$8f31292a89ad467e$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $cu1g7.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $6nVJI.useContainerContext)
};

});
parcelRegister("cu1g7", function(module, exports) {
$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $ad4e7c5cdb1bb62b$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $ad4e7c5cdb1bb62b$export$bc2de1c42df30b10);

var $eJOHy = parcelRequire("eJOHy");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $ad4e7c5cdb1bb62b$var$getDataLoader = ()=>(parcelRequire("iQrUz"));
const $ad4e7c5cdb1bb62b$var$ONE_DAY_IN_MILLIS = 86400000;
const $ad4e7c5cdb1bb62b$export$d6f4f0483916919f = (0, $l1VxS.createResource)({
    type: (0, $72fb76455039ad7c$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $ad4e7c5cdb1bb62b$var$getDataLoader,
    maxAge: $ad4e7c5cdb1bb62b$var$ONE_DAY_IN_MILLIS
});
const $ad4e7c5cdb1bb62b$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($ad4e7c5cdb1bb62b$export$d6f4f0483916919f);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $72fb76455039ad7c$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("iQrUz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("d2yCb")
]).then(()=>parcelRequire('icgY0'));

});



parcelRegister("480sL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("cFHpU")
]).then(()=>parcelRequire('3Kug5'));

});


parcelRegister("g27SL", function(module, exports) {
$parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", () => $ec92c92c2fa09fd5$export$c0c81c1828c7638c);

var $9pTd3 = parcelRequire("9pTd3");

var $uCHeL = parcelRequire("uCHeL");
const $ec92c92c2fa09fd5$export$c0c81c1828c7638c = (projectKey)=>{
    try {
        const { storeState: storeState } = (0, $uCHeL.getResourceStore)();
        const prevState = storeState.getState();
        storeState.setState({
            ...prevState,
            data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                // This will not clear resources that are keyed with project key as a subset of the key,
                // e.g. `projectKey-${projectKey}` or similar, so those resources may still have stale data.
                const { [projectKey]: _, ...rest } = value;
                return [
                    resourceType,
                    rest
                ];
            }))
        });
    } catch (e) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'clearResourcesAssociatedWithProjectKey',
                packageName: 'jiraProjectCreateDrawerContext',
                teamName: 'helix'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
        });
    }
};

});




parcelRegister("NtyAW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jiv-after-paint-issue-create-trigger-bundle', function() {
        return Promise.all([
            $ewTvA("1OALc")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("bkDf1")
        ]);
    }),
    $ewTvA("c2ZoG")
]).then(()=>parcelRequire('5Uzk2'));

});

parcelRegister("2Bg5R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aiKfZ").then(()=>parcelRequire('eRtVx'));

});

parcelRegister("iSvWF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hg8mR").then(()=>parcelRequire('61Hor'));

});

parcelRegister("4AwVD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("czNnV").then(()=>parcelRequire('fRcce'));

});

parcelRegister("l3kjz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9UUoJ").then(()=>parcelRequire('aL23w'));

});

parcelRegister("98vBV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1uh4z").then(()=>parcelRequire('3g0Pk'));

});


parcelRegister("gp9Js", function(module, exports) {
$parcel$export(module.exports, "getSystemNavigationPaths", () => $95f097573d74b3f1$export$76c5f80c8d9bdb0e);
$parcel$export(module.exports, "isSystemNavPath", () => $95f097573d74b3f1$export$3e53a29d6e499ec4);

var $4cTDP = parcelRequire("4cTDP");
const $95f097573d74b3f1$export$76c5f80c8d9bdb0e = ()=>({
        generalConfiguration: '/jira/settings/system/general-configuration',
        darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
        issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
        globalAutomation: '/jira/settings/automation',
        // troubleshooting
        troubleshootingAuditLog: '/auditing/view',
        troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
        troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
        troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
        troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
        troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
        troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
        troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
        // security
        securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
        securityGlobalPermissions: (0, $4cTDP.fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
        // user interface
        userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
        userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
        userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
        userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
        userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
        // import and export
        importSectionBackupManager: '/secure/admin/CloudExport.jspa',
        importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
        importSectionExternalImportNew: '/jira/settings/system/external-import',
        importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
        importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
        // mail
        mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
        mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
        mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
        mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
        // admin
        adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
        adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
        // shared
        sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
        sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
        // advanced
        advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
        advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
        advancedSectionWebHooks: '/plugins/servlet/webhooks',
        advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
        advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
    });
const $95f097573d74b3f1$var$getSystemNavPaths = ()=>{
    return [
        '/jira/settings/system/general-configuration',
        '/secure/admin/SiteDarkFeatures',
        '/secure/admin/ViewGlobalCollectors',
        '/jira/settings/automation',
        '/auditing/view',
        '/secure/project/ViewProjectRoles',
        '/secure/admin/global-permissions',
        '/secure/admin/GlobalPermissions',
        '/secure/admin/ViewUserDefaultSettings',
        '/secure/admin/EditDefaultDashboard',
        '/secure/admin/LookAndFeel',
        '/jira/settings/system/ui/announcement-banner',
        '/secure/admin/CloudExport',
        '/jira/settings/system/external-import',
        '/secure/admin/CloudImport',
        '/secure/admin/GlobalMailSettings',
        '/secure/admin/global-mail-settings',
        '/secure/admin/OutgoingMailServers',
        '/secure/admin/IncomingMailServers',
        '/secure/admin/SendBulkMail',
        '/secure/admin/PermissionHelperAdmin',
        '/jira/settings/system/notification-logs',
        '/secure/admin/filters/ViewSharedFilters',
        '/secure/admin/dashboards/ViewSharedDashboards',
        '/secure/admin/ViewAttachmentSettings',
        '/secure/admin/ListEventTypes',
        '/plugins/servlet/webhooks',
        '/secure/GHLexoRankManage'
    ];
};
const $95f097573d74b3f1$export$3e53a29d6e499ec4 = (path)=>{
    const paths = $95f097573d74b3f1$var$getSystemNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("k2tOc", function(module, exports) {
$parcel$export(module.exports, "getIssuesNavigationPaths", () => $33bfc194c14bada1$export$a33a4d7b083ee85);
$parcel$export(module.exports, "isIssuesNavPath", () => $33bfc194c14bada1$export$f38c22a081278057);
const $33bfc194c14bada1$export$a33a4d7b083ee85 = ()=>({
        // Features
        newIssueSearchTransition: '/jira/settings/issues/new-issue-search-transition',
        timeTrackingItem: '/secure/admin/TimeTrackingAdmin.jspa',
        issueLinkingItem: '/secure/admin/ViewLinkTypes!default.jspa',
        // IssueTypes
        issueTypesHierarchyItem: '/jira/settings/issues/issue-hierarchy',
        issueTypesItem: '/jira/settings/issues/issue-types',
        issueTypeSchemesItem: '/jira/settings/issues/issue-type-schemes',
        issueTypesSubTasksItem: '/secure/admin/subtasks/ManageSubTasks.jspa',
        // Workflows
        workflowsItem: '/jira/settings/issues/workflows',
        workflowSchemesItem: '/secure/admin/ViewWorkflowSchemes.jspa',
        // Screens
        screensItem: '/jira/settings/issues/screens',
        screenSchemesItem: '/jira/settings/issues/screen-schemes',
        screensIssueTypeScreenSchemesMenu: '/jira/settings/issues/issue-type-screen-schemes',
        // Fields
        fieldsManagement: '/jira/settings/issues/fields',
        customFieldsItem: '/secure/admin/ViewCustomFields.jspa',
        fieldConfigurationsItem: '/secure/admin/ViewFieldLayouts.jspa',
        fieldConfigurationSchemes: '/secure/admin/ViewFieldLayoutSchemes.jspa',
        fieldSchemes: '/jira/settings/issues/field-schemes',
        // Priorities
        prioritiesItem: '/jira/settings/issues/priorities',
        prioritySchemesItem: '/jira/settings/issues/priority-schemes',
        // Forms
        dataConnectionsItem: '/jira/settings/forms/data-connections',
        // IssueAttributes
        statusesItem: '/secure/admin/ViewStatuses.jspa',
        resolutionsItem: '/secure/admin/ViewResolutions.jspa',
        issueSecuritySchemesItem: '/secure/admin/ViewIssueSecuritySchemes.jspa',
        notificationSchemesItem: '/secure/admin/ViewNotificationSchemes.jspa',
        permissionSchemesItem: '/secure/admin/ViewPermissionSchemes.jspa'
    });
const $33bfc194c14bada1$var$getIssuesNavPaths = ()=>{
    return [
        '/jira/settings/issues/new-issue-search-transition',
        '/secure/admin/TimeTrackingAdmin',
        '/secure/admin/ViewLinkTypes',
        '/jira/settings/issues/issue-hierarchy',
        '/jira/settings/issues/issue-types',
        '/jira/settings/issues/issue-type-schemes',
        '/secure/admin/subtasks/ManageSubTasks',
        '/jira/settings/issues/workflows',
        '/secure/admin/ViewWorkflowSchemes',
        '/jira/settings/issues/screens',
        '/jira/settings/issues/screen-schemes',
        '/jira/settings/issues/issue-type-screen-schemes',
        '/jira/settings/issues/fields',
        '/jira/settings/issues/field-schemes',
        '/secure/admin/ViewCustomFields',
        '/secure/admin/ViewFieldLayouts',
        '/secure/admin/ViewFieldLayoutSchemes',
        '/jira/settings/issues/priorities',
        '/jira/settings/issues/priority-schemes',
        '/secure/admin/ViewStatuses',
        '/secure/admin/ViewResolutions',
        '/secure/admin/ViewIssueSecuritySchemes',
        '/secure/admin/ViewNotificationSchemes',
        '/secure/admin/ViewPermissionSchemes'
    ];
};
const $33bfc194c14bada1$export$f38c22a081278057 = (path)=>{
    const paths = $33bfc194c14bada1$var$getIssuesNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("8hKqe", function(module, exports) {
$parcel$export(module.exports, "JiraTopBannerPlacement", () => $49990ce1545b6c59$export$2a9156f5c2a2410e);

var $eJOHy = parcelRequire("eJOHy");

var $2SC3b = parcelRequire("2SC3b");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $1gHmu = parcelRequire("1gHmu");

var $grotr = parcelRequire("grotr");

var $7oY9g = parcelRequire("7oY9g");

var $5fjzQ = parcelRequire("5fjzQ");

var $lauxv = parcelRequire("lauxv");

var $eJrcF = parcelRequire("eJrcF");
const $49990ce1545b6c59$var$PLACEMENT_ID = 'jira-top-banner';
const $49990ce1545b6c59$var$TopBannerPlacement = ()=>{
    if (false) // do not remove server check before MAGMA-4227 is resolved: https://atlassian.slack.com/archives/C0288U06PGC/p1758676723058979?thread_ts=1755502530.582239&cid=C0288U06PGC
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "topBannerPlacement",
        packageName: "top-banner-placement",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "top-banner-placement.jira-top-banner-placement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $grotr.PlacementFetchProvider), {
        resource: (0, $5fjzQ.postOfficeJiraTopBannerResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lauxv.default), {
        placementId: $49990ce1545b6c59$var$PLACEMENT_ID,
        // Post Office and Jira uses different versions of react-error-boundary - https://atlassian.slack.com/archives/CL6HC337Z/p1741218999095929
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $2SC3b.default)
    })))));
};
const $49990ce1545b6c59$export$2a9156f5c2a2410e = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    if (false) // do not remove server check before MAGMA-4227 is resolved: https://atlassian.slack.com/archives/C0288U06PGC/p1758676723058979?thread_ts=1755502530.582239&cid=C0288U06PGC
    return (0, $4cTDP.fg)('jira-issue-term-refresh-banner') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($49990ce1545b6c59$var$ServerPlacementAPIFetchEnabled, null) : null;
    if (!(0, $7oY9g.default)('killswitch_post_office_in_jira') && (0, $4cTDP.fg)('jira-issue-term-refresh-banner')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($49990ce1545b6c59$var$TopBannerPlacement, null);
    return null;
});
const $49990ce1545b6c59$var$ServerPlacementAPIFetchEnabled = ()=>{
    // FIXME: this isn't how useResource works... this can just be removed - comment below preserved for history
    // Use resource to make the shadow API call to Post Office.
    // Don't do anything with the result, we just want to mock the traffic for now.
    (0, $eJrcF.useResource)((0, $5fjzQ.postOfficeJiraTopBannerResource));
    return null;
};

});
parcelRegister("2SC3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $cef0a0cc851c550f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $iJJ9P = parcelRequire("iJJ9P");

var $fT7M2 = parcelRequire("fT7M2");

var $cVnXt = parcelRequire("cVnXt");

var $eJOHy = parcelRequire("eJOHy");

var $b9rZY = parcelRequire("b9rZY");


var $fm9qF = parcelRequire("fm9qF");
const $cef0a0cc851c550f$export$a4ee24848b29490b = (0, $fm9qF.withJiraTopBannerIntlProvider)((0, $fT7M2.createPlacementComponent)((0, $fc475ea7cbe0ca92$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
    const { data: data, isLoading: isLoading } = (0, $cVnXt.useInitialData)(initialData);
    const [{ message: message, status: status }, setMessageState] = (0, $eJOHy.useState)({
        message: undefined,
        status: 'loading'
    });
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $iJJ9P.useMessagePlacementHooks)();
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
    }, []);
    (0, $eJOHy.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss,
        handleDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked,
        handleDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze,
        handleDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoading) {
            const newMessage = data?.messages[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
        }
    }, [
        data,
        isLoading
    ]);
    if (isLoading || status === 'loading') return null;
    return message && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b9rZY.MessageRenderer), {
        ...message,
        messageInstanceId: message.messageInstanceId
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
var $cef0a0cc851c550f$export$2e2bcd8739ae039 = $cef0a0cc851c550f$export$a4ee24848b29490b;

});
parcelRegister("fT7M2", function(module, exports) {
$parcel$export(module.exports, "createPlacementComponent", () => $c334eea7060cfa2b$export$8a57effc6307f916);

var $kEJaa = parcelRequire("kEJaa");
const $c334eea7060cfa2b$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $kEJaa.createPlacementComponent)(placementId, Component, placementConfigurationOptions);

});
parcelRegister("kEJaa", function(module, exports) {
$parcel$export(module.exports, "createPlacementComponent", () => $9745f1212b0ddc2d$export$8a57effc6307f916);

var $gt9Am = parcelRequire("gt9Am");

var $eOlnh = parcelRequire("eOlnh");

var $hceBc = parcelRequire("hceBc");

var $aLq3c = parcelRequire("aLq3c");

var $i3hRF = parcelRequire("i3hRF");
var $dh2Oy = parcelRequire("dh2Oy");

var $3iYHG = parcelRequire("3iYHG");
const $9745f1212b0ddc2d$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $3iYHG.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $eOlnh.useStableObject)(context);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3hRF.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dh2Oy.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                choreographer: placementConfigurationOptions?.choreographer,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $9745f1212b0ddc2d$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $9745f1212b0ddc2d$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $aLq3c.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $hceBc.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("aLq3c", function(module, exports) {
$parcel$export(module.exports, "useComponentErrorHandling", () => $0e7ed3e8e9334f7f$export$3d127465d22fe4e5);

var $eJOHy = parcelRequire("eJOHy");
const $0e7ed3e8e9334f7f$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $eJOHy.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});



parcelRegister("cVnXt", function(module, exports) {
$parcel$export(module.exports, "useInitialData", () => $6fcd2d54b2f3cb2b$export$5523c5f3222291d0);

var $eJOHy = parcelRequire("eJOHy");

var $gPaSs = parcelRequire("gPaSs");
const $6fcd2d54b2f3cb2b$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $eJOHy.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gPaSs.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});

parcelRegister("b9rZY", function(module, exports) {
$parcel$export(module.exports, "MessageRenderer", () => $0c51110b72f46541$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $iRBaU = parcelRequire("iRBaU");

var $99XdX = parcelRequire("99XdX");

var $kC49J = parcelRequire("kC49J");
const $0c51110b72f46541$export$e30378e28ad3e6ab = {
    ...(0, $99XdX.default),
    ...(0, $kC49J.default)
};
const { initializeMessageRenderer: $0c51110b72f46541$export$bce4e5106d86e473, MessageRenderer: $0c51110b72f46541$export$2df1250b8f917a59 } = (0, $iRBaU.asMessageRenderer)($0c51110b72f46541$export$e30378e28ad3e6ab);

});
parcelRegister("iRBaU", function(module, exports) {
$parcel$export(module.exports, "MaybeSuspenseBoundary", () => $e71e395121611dac$export$9750eb54d7c7e789);
$parcel$export(module.exports, "asMessageRenderer", () => $e71e395121611dac$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $gt9Am = parcelRequire("gt9Am");

var $59rsN = parcelRequire("59rsN");

var $eOlnh = parcelRequire("eOlnh");

var $UK12V = parcelRequire("UK12V");
var $bb3PU = parcelRequire("bb3PU");

var $bPZKj = parcelRequire("bPZKj");

var $6tbGL = parcelRequire("6tbGL");

var $45ArU = parcelRequire("45ArU");

var $lUFNt = parcelRequire("lUFNt");

var $1i76i = parcelRequire("1i76i");

var $02WN6 = parcelRequire("02WN6");

var $3iYHG = parcelRequire("3iYHG");

var $iCnG4 = parcelRequire("iCnG4");

var $eJOHy = parcelRequire("eJOHy");

var $akghy = parcelRequire("akghy");
const $e71e395121611dac$var$STABLE_EMPTY_OBJECT = {};
const $e71e395121611dac$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        ...props,
        children: children
    });
};
const $e71e395121611dac$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $eJOHy.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, SuspenseBoundary: SuspenseBoundary = (0, $eJOHy.Suspense), ...data })=>{
            const isUFOEnabled = (0, $59rsN.default).checkGate('enable_ufo_tracking_in_post_office');
            const recommendationSessionStable = (0, $eOlnh.useStableObject)(recommendationSession ?? $e71e395121611dac$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $eOlnh.useStableObject)(postOffice ?? $e71e395121611dac$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $eJOHy.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $UK12V.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $02WN6.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $eJOHy.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $bPZKj.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $bPZKj.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $eJOHy.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bb3PU.UFOv2).UFOLoadHold, {
                        name: (0, $bb3PU.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $eOlnh.useStableObject)(componentProps);
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return (0, $59rsN.default).checkGate('po-refactor-message-renderer-provider') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lUFNt.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $e71e395121611dac$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                        onError: onError,
                        ...componentProps
                    })
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $akghy.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1i76i.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tbGL.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                triggerId: triggerId,
                                messageCreationType: messageCreationType,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails,
                                journeyId: journeyId,
                                journeyTriggerId: journeyTriggerId
                            },
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iCnG4.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $45ArU.MessageAnalyticsContextProvider), {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                                onError: onError,
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $3iYHG.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};

});
parcelRegister("UK12V", function(module, exports) {
$parcel$export(module.exports, "UFOv1", () => $8dedd0870366123d$export$96236906ebaa7f87);

var $8NMoX = parcelRequire("8NMoX");

var $hvjhI = parcelRequire("hvjhI");
const $8dedd0870366123d$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $8NMoX.MessagePerformanceTracker,
    PlacementPerformanceTracker: $hvjhI.PlacementPerformanceTracker
};

});
parcelRegister("8NMoX", function(module, exports) {
$parcel$export(module.exports, "MessagePerformanceTracker", () => $9b15dbad14ccc805$export$ae5c73c7c4f454e6);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $dYPL9 = parcelRequire("dYPL9");
class $9b15dbad14ccc805$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $f39LL.UFOExperience)((0, $dYPL9.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $2lxLk.ExperienceTypes).Load,
            platform: {
                component: (0, $dYPL9.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $f39LL.UFOExperience)(`${(0, $dYPL9.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $2lxLk.ExperienceTypes).Load,
            platform: {
                component: (0, $dYPL9.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("dYPL9", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceNames", () => $5f0a97cc6dea523a$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $5f0a97cc6dea523a$export$6d482cfa20c9d220);
const $5f0a97cc6dea523a$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $5f0a97cc6dea523a$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("hvjhI", function(module, exports) {
$parcel$export(module.exports, "PlacementPerformanceTracker", () => $e613212a37e42fe4$export$8b48c2105ba0b35a);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $dYPL9 = parcelRequire("dYPL9");
const $e613212a37e42fe4$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $e613212a37e42fe4$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $2lxLk.ExperienceTypes).Load,
    platform: {
        component: (0, $dYPL9.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$e613212a37e42fe4$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$e613212a37e42fe4$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$e613212a37e42fe4$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$e613212a37e42fe4$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$e613212a37e42fe4$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$e613212a37e42fe4$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$e613212a37e42fe4$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$e613212a37e42fe4$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $e613212a37e42fe4$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e613212a37e42fe4$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e613212a37e42fe4$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e613212a37e42fe4$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e613212a37e42fe4$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e613212a37e42fe4$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e613212a37e42fe4$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e613212a37e42fe4$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $f39LL.UFOExperience)((0, $dYPL9.UFOExperienceNames).PLACEMENT, $e613212a37e42fe4$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $f39LL.UFOExperience)(`${(0, $dYPL9.UFOExperienceNames).PLACEMENT}.${placementId}`, $e613212a37e42fe4$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("akghy", function(module, exports) {
$parcel$export(module.exports, "ChoreographerWrapper", () => $d3db38593bdd698b$export$8db7ba034addcd65);

var $gt9Am = parcelRequire("gt9Am");

var $59rsN = parcelRequire("59rsN");

var $gr4vM = parcelRequire("gr4vM");

var $62EJZ = parcelRequire("62EJZ");

var $eJOHy = parcelRequire("eJOHy");
const $d3db38593bdd698b$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return null;
};
const $d3db38593bdd698b$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $62EJZ.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $59rsN.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $59rsN.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $gt9Am.jsx)($d3db38593bdd698b$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});


parcelRegister("99XdX", function(module, exports) {
$parcel$export(module.exports, "default", () => $41dd5b5291d946a8$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $csFzh = parcelRequire("csFzh");
var $41dd5b5291d946a8$export$2e2bcd8739ae039 = {
    'jira-ipm-issue-to-work-top-banner': (0, $csFzh.default)
};

});
parcelRegister("csFzh", function(module, exports) {
$parcel$export(module.exports, "default", () => $23c14f495e9ea653$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $lV1DJ = parcelRequire("lV1DJ");

var $80mPX = parcelRequire("80mPX");
const $23c14f495e9ea653$export$b3890eb0ae9dca99 = (0, $80mPX.createRender)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lV1DJ.TopBannerMessage), {}));
var $23c14f495e9ea653$export$2e2bcd8739ae039 = $23c14f495e9ea653$export$b3890eb0ae9dca99;

});
parcelRegister("lV1DJ", function(module, exports) {
$parcel$export(module.exports, "TopBannerMessage", () => $ec29c798cd9b19c3$export$71f678cc6412ce95);
/* top-banner-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $6zhpo = parcelRequire("6zhpo");

var $lc0OY = parcelRequire("lc0OY");
var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");
var $3cMgR = parcelRequire("3cMgR");

var $k9r6D = parcelRequire("k9r6D");

var $5EHjk = parcelRequire("5EHjk");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
const $ec29c798cd9b19c3$var$styles = {
    pressable: "_4bfu18uv _1hms8stv _ajmmnqa1 _syaz15cr _80omtlke _9oik18uv _1bnx8stv _jf4cnqa1 _30l315cr _1nrm18uv _c2waglyw _1iohnqa1",
    onClickBackgroundColor: "_bfhkcdhy"
};
const $ec29c798cd9b19c3$var$ComingSoonMessage = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "post-office.placement.jira-top-banner.primary-message",
        description: "Coming soon message for the Jira top banner",
        defaultMessage: "As we roll out 'work' as the new term for items tracked in Jira, you may still see 'issue' in some areas."
    });
const $ec29c798cd9b19c3$var$ReadMoreLink = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
        href: "https://community.atlassian.com/t5/Jira-articles/It-s-here-Work-is-the-new-collective-term-for-all-items-you/ba-p/2954892",
        rel: "noopener noreferrer",
        target: "_blank",
        xcss: $ec29c798cd9b19c3$var$styles.pressable,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "st-office.placement.jira-top-banner.primary-cta-text",
            description: "Read more link for the Jira top banner",
            defaultMessage: "Read about this terminology change"
        })
    });
const $ec29c798cd9b19c3$export$71f678cc6412ce95 = ()=>{
    const { messageDismissed: messageDismissed } = (0, $5EHjk.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const onClickDismiss = (0, $eJOHy.useCallback)(()=>{
        messageDismissed();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
    }, [
        messageDismissed,
        messageInstanceClicked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: "color.background.neutral.bold",
        padding: "space.200",
        testId: "jira-top-banner",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
                    color: "color.text.inverse",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)($ec29c798cd9b19c3$var$ComingSoonMessage, {}),
                        "\xa0",
                        /*#__PURE__*/ (0, $gt9Am.jsx)($ec29c798cd9b19c3$var$ReadMoreLink, {})
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                    xcss: $ec29c798cd9b19c3$var$styles.onClickBackgroundColor,
                    onClick: onClickDismiss,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                        color: "var(--ds-text-inverse, #FFFFFF)",
                        label: "Dismiss"
                    })
                })
            ]
        })
    });
};

});

parcelRegister("80mPX", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $58004c9c44942b66$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $58004c9c44942b66$export$78c758434c34d601, createValidate: $58004c9c44942b66$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $58004c9c44942b66$export$c905bc718befd59b, createHydrateExample: $58004c9c44942b66$export$1f41223e5b0a6622, createTransformMetadata: $58004c9c44942b66$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});
parcelRegister("eMVZo", function(module, exports) {
$parcel$export(module.exports, "createServerPipeline", () => $c00f89dcf8180362$export$b8fedcd4634de5cd);
$parcel$export(module.exports, "createClientPipeline", () => $c00f89dcf8180362$export$7d57dbe7f7617174);

var $gt9Am = parcelRequire("gt9Am");

var $57NEY = parcelRequire("57NEY");
const $c00f89dcf8180362$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            if (rendered === null) return null;
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $57NEY.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $c00f89dcf8180362$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $c00f89dcf8180362$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $c00f89dcf8180362$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $c00f89dcf8180362$export$803c53721d530406 = ()=>(hydrateExample, config)=>$c00f89dcf8180362$var$exampleHydrator(hydrateExample, config);
const $c00f89dcf8180362$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $c00f89dcf8180362$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $c00f89dcf8180362$export$62864968b8b09cdf(),
        createHydrateExample: $c00f89dcf8180362$export$803c53721d530406(),
        createTransformMetadata: $c00f89dcf8180362$export$b4a84c754a962eee()
    });
const $c00f89dcf8180362$export$7d57dbe7f7617174 = ()=>({
        createValidate: $c00f89dcf8180362$var$initializeValidate(),
        createRender: $c00f89dcf8180362$export$7693b71d48f1bf7e()
    });

});




parcelRegister("kC49J", function(module, exports) {
$parcel$export(module.exports, "default", () => $616d1474d44d6893$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $h8JDP = parcelRequire("h8JDP");
var $616d1474d44d6893$export$2e2bcd8739ae039 = {
    'message-template-template': (0, $h8JDP.default)
};

});
parcelRegister("h8JDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $df8e6e56b5a4eb4c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $lV1DJ = parcelRequire("lV1DJ");
parcelRequire("eJOHy");

var $25WVF = parcelRequire("25WVF");
const $df8e6e56b5a4eb4c$export$b3890eb0ae9dca99 = (0, $25WVF.createRender)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lV1DJ.TopBannerMessage), {}));
var $df8e6e56b5a4eb4c$export$2e2bcd8739ae039 = $df8e6e56b5a4eb4c$export$b3890eb0ae9dca99;

});
parcelRegister("25WVF", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $aa383de5c6940095$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $aa383de5c6940095$export$78c758434c34d601, createValidate: $aa383de5c6940095$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $aa383de5c6940095$export$c905bc718befd59b, createHydrateExample: $aa383de5c6940095$export$1f41223e5b0a6622, createTransformMetadata: $aa383de5c6940095$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});




/* GeneratedContentHash: 90a7d45c313eaf24d28f3e71b65ecf55df9e4f5806226e92484289f49713e5bf */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $fc475ea7cbe0ca92$export$a5cfae247d8360ef = 'jira-top-banner';

parcelRegister("fm9qF", function(module, exports) {
$parcel$export(module.exports, "withJiraTopBannerIntlProvider", () => $31771fe54aadabb0$export$2a49ebed7015cea4);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $buEZY = parcelRequire("buEZY");

var $7R4Wz = parcelRequire("7R4Wz");

var $5eiiO = parcelRequire("5eiiO");
const $31771fe54aadabb0$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $7R4Wz.messagesLoader)(locale),
        (0, $5eiiO.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $31771fe54aadabb0$export$2a49ebed7015cea4 = (Component)=>{
    return (0, $buEZY.withIntlProvider)({
        messagesLoader: $31771fe54aadabb0$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("7R4Wz", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $a31f756da786b80c$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aVfuo = parcelRequire("aVfuo");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a31f756da786b80c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a31f756da786b80c$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("5aSMt")));
        case 'da':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("4coDn")));
        case 'de':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("iWWnd")));
        case 'en-GB':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("7tHuU")));
        case 'en-US':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("cHuCq")));
        case 'en-XA':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("84Vzi")));
        case 'en-XB':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("96WJI")));
        case 'en-ZZ':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("dw5SQ")));
        case 'en':
            return $a31f756da786b80c$var$importHelper(await Promise.resolve((parcelRequire("aVfuo"))));
        case 'es':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("eA0oM")));
        case 'et':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("60frN")));
        case 'fi':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("3kVCK")));
        case 'fr':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("6AWfG")));
        case 'hr':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("2s1KH")));
        case 'hu':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("gxNqf")));
        case 'it':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("dUM71")));
        case 'ja':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("5kga3")));
        case 'ko':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("k1Yah")));
        case 'nb':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("j8Hdt")));
        case 'nl':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("goNc4")));
        case 'pl':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("kUfKj")));
        case 'pt-BR':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("5OuK1")));
        case 'ro':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("8io5G")));
        case 'ru':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("2Lkue")));
        case 'sl':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("jlW2E")));
        case 'sr-RS':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("kOlns")));
        case 'sr-YR':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("eO41y")));
        case 'sr':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("4xgKz")));
        case 'sv':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("ipfas")));
        case 'th':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("eEjPk")));
        case 'tr':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("3HEtp")));
        case 'uk':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("eQZqX")));
        case 'vi':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("hBhyg")));
        case 'zh-CN':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("lY5vq")));
        case 'zh-TW':
            return $a31f756da786b80c$var$importHelper(await (parcelRequire("bzu7x")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aVfuo));
    }
};

});
parcelRegister("aVfuo", function(module, exports) {
module.exports = JSON.parse('{"jira-issueview-quickactions.src.ui.index.recommended-for-you":[{"type":0,"value":"Recommended for you"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.now":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.soon":[{"type":0,"value":"Jira \'projects\' will soon be renamed \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.learn-more":[{"type":0,"value":"Read more about this change"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.now":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.soon":[{"type":0,"value":"Coming soon"}],"jira-pulsar.common.components.cross-flow.dismiss":[{"type":0,"value":"Dismiss"}],"jira-pulsar.common.components.issue-view-description-ad.close":[{"type":0,"value":"Close"}],"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.html.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.add-comment":[{"type":0,"value":"Add comment"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page":[{"type":0,"value":"Page"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Record a comment"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription":[{"type":0,"value":"Use video to explain the work"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription":[{"type":0,"value":"Record your screen"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video":[{"type":0,"value":"Video"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.footer.custom.message":[{"type":1,"value":"footerText"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.get.apps.new":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"a1"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"a2"},{"type":0,"value":"."}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"\\/"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.email.body.closed":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.original.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueKey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"mentioned you"}],"type":8,"value":"strong"},{"type":0,"value":" on a work item"}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.email.body.reopened":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"reopened a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.shared-with":[{"type":0,"value":" Also shared with "}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-deletion-reminder.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"},{"type":0,"value":" "}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.common.reply-button":[{"type":0,"value":"Reply"}],"postoffice.jira.issue.common.visibility-level":[{"type":0,"value":"Restricted to "},{"children":[{"type":1,"value":"name"}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"type"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.share-search.shared-with.no-translate":[{"type":0,"value":"sharedWithUser"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.body":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.learn-more":[{"type":0,"value":"Learn more"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.title":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template..project-deletion-reminder.restore-link.multiple-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.restore-link.single-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.trash-link.multiple-project":[{"type":0,"value":" Trash"}],"template.project-deletion-reminder.generic-message.mutiple-projects":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" project"}]},"other":{"value":[{"type":7},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"projectCount"},{"type":0,"value":" will be permanently deleted in 7 days "}],"template.project-deletion-reminder.generic-message.single-project":[{"type":0,"value":"The project will be permanently deleted in 7 days "}],"template.project-deletion-reminder.view-more-projects-message":[{"type":0,"value":"+ "},{"type":1,"value":"remainingProjectCount"},{"type":0,"value":" other projects currently in "}],"template.project-event-user-invited.invited-custom-message":[{"type":1,"value":"customMessage"}],"template.project-event-user-invited.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"projectName"},{"type":0,"value":" "}],"type":8,"value":"b"}],"template.project.archived.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.deleted.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this project on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This project and its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" archive "}],"type":8,"value":"a"},{"type":0,"value":" forever"}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"The project, including all its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" trash "}],"type":8,"value":"a"},{"type":0,"value":" for 60 days after which it will be permanently deleted."}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "},{"children":[{"type":0,"value":" Go to trash "}],"type":8,"value":"a"},{"type":0,"value":" and try again. If it persists, please contact support."}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" matched work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" matched work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":". "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "},{"children":[{"type":0,"value":" here "}],"type":8,"value":"a"},{"type":0,"value":" "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data. "},{"children":[{"type":0,"value":" View the filter "}],"type":8,"value":"a"},{"type":0,"value":" in Jira"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("5aSMt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2JFf7").then(()=>parcelRequire('1mXm0'));

});

parcelRegister("4coDn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("PnSMA").then(()=>parcelRequire('6lUKc'));

});

parcelRegister("iWWnd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6941t").then(()=>parcelRequire('hppmr'));

});

parcelRegister("7tHuU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hiAIo").then(()=>parcelRequire('2TsLa'));

});

parcelRegister("cHuCq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eBwLI").then(()=>parcelRequire('7OnHY'));

});

parcelRegister("84Vzi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Vadv").then(()=>parcelRequire('9jIg7'));

});

parcelRegister("96WJI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6RsmN").then(()=>parcelRequire('341F6'));

});

parcelRegister("dw5SQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5gcab").then(()=>parcelRequire('8ee8O'));

});

parcelRegister("eA0oM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f0bAg").then(()=>parcelRequire('7drfK'));

});

parcelRegister("60frN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1dYfC").then(()=>parcelRequire('jlooF'));

});

parcelRegister("3kVCK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lmguf").then(()=>parcelRequire('jGHO9'));

});

parcelRegister("6AWfG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e1rTc").then(()=>parcelRequire('gYlnG'));

});

parcelRegister("2s1KH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kNWVn").then(()=>parcelRequire('cZaLN'));

});

parcelRegister("gxNqf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ed18o").then(()=>parcelRequire('5szht'));

});

parcelRegister("dUM71", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gniXe").then(()=>parcelRequire('abTGe'));

});

parcelRegister("5kga3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("elHYe").then(()=>parcelRequire('7Kbkn'));

});

parcelRegister("k1Yah", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lusqx").then(()=>parcelRequire('1lpWv'));

});

parcelRegister("j8Hdt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5IN5I").then(()=>parcelRequire('7x2bx'));

});

parcelRegister("goNc4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8NAeQ").then(()=>parcelRequire('ivjgq'));

});

parcelRegister("kUfKj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("40dNe").then(()=>parcelRequire('kriQH'));

});

parcelRegister("5OuK1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h5BdS").then(()=>parcelRequire('fqEd0'));

});

parcelRegister("8io5G", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2XK1P").then(()=>parcelRequire('3yjQJ'));

});

parcelRegister("2Lkue", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("abYVj").then(()=>parcelRequire('4USHK'));

});

parcelRegister("jlW2E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aRyFL").then(()=>parcelRequire('5SAHQ'));

});

parcelRegister("kOlns", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7TdEl").then(()=>parcelRequire('dTxpY'));

});

parcelRegister("eO41y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gz08i").then(()=>parcelRequire('5UqdW'));

});

parcelRegister("4xgKz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2qbUV").then(()=>parcelRequire('3NGoY'));

});

parcelRegister("ipfas", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k6PwY").then(()=>parcelRequire('ZNoty'));

});

parcelRegister("eEjPk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("66kwt").then(()=>parcelRequire('6x6fb'));

});

parcelRegister("3HEtp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4tT2p").then(()=>parcelRequire('3HyEO'));

});

parcelRegister("eQZqX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iTUSr").then(()=>parcelRequire('jG2JK'));

});

parcelRegister("hBhyg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1pBzI").then(()=>parcelRequire('cqUbR'));

});

parcelRegister("lY5vq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5R7ig").then(()=>parcelRequire('3hP61'));

});

parcelRegister("bzu7x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8lXXu").then(()=>parcelRequire('cTX1C'));

});


parcelRegister("5eiiO", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $bc2bf37053c54b59$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fOnna = parcelRequire("fOnna");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc2bf37053c54b59$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $bc2bf37053c54b59$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("hH2h8")));
        case 'da':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("kOnAA")));
        case 'de':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("awtbG")));
        case 'en-GB':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("7HCYv")));
        case 'en-US':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("ldyat")));
        case 'en-XA':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("eeyQJ")));
        case 'en-XB':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("bxppG")));
        case 'en-ZZ':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("04Z04")));
        case 'en':
            return $bc2bf37053c54b59$var$importHelper(await Promise.resolve((parcelRequire("fOnna"))));
        case 'es':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("cZJLy")));
        case 'et':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("eYUGK")));
        case 'fi':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("9Q0ZS")));
        case 'fr':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("1fPeP")));
        case 'hr':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("3V3me")));
        case 'hu':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("l32sd")));
        case 'it':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("7qf5e")));
        case 'ja':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("kzrPS")));
        case 'ko':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("8fAn5")));
        case 'nb':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("5rAAW")));
        case 'nl':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("f2Nwh")));
        case 'pl':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("3I8gN")));
        case 'pt-BR':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("2AVPg")));
        case 'ro':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("BLDQg")));
        case 'ru':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("c9lCS")));
        case 'sl':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("6wjy5")));
        case 'sr-RS':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("haByI")));
        case 'sr-YR':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("dP53o")));
        case 'sr':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("8UyNn")));
        case 'sv':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("aurSA")));
        case 'th':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("jRvL8")));
        case 'tr':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("3jh1f")));
        case 'uk':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("dOPMJ")));
        case 'vi':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("2mfBc")));
        case 'zh-CN':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("jbXvq")));
        case 'zh-TW':
            return $bc2bf37053c54b59$var$importHelper(await (parcelRequire("lT6VF")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fOnna));
    }
};

});
parcelRegister("fOnna", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.browser-push-body.no-translate\":[{\"type\":0,\"value\":\"You are a lovely\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("hH2h8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("49MQd").then(()=>parcelRequire('5V0di'));

});

parcelRegister("kOnAA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gxjpT").then(()=>parcelRequire('g7f5D'));

});

parcelRegister("awtbG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kU163").then(()=>parcelRequire('5PwWf'));

});

parcelRegister("7HCYv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ilkdv").then(()=>parcelRequire('kaifB'));

});

parcelRegister("ldyat", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lf96V").then(()=>parcelRequire('5XVuz'));

});

parcelRegister("eeyQJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2oek8").then(()=>parcelRequire('6Tp14'));

});

parcelRegister("bxppG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gqxrq").then(()=>parcelRequire('iGvW0'));

});

parcelRegister("04Z04", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i0zNK").then(()=>parcelRequire('fK2A4'));

});

parcelRegister("cZJLy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gJymL").then(()=>parcelRequire('lw4D1'));

});

parcelRegister("eYUGK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1LwIn").then(()=>parcelRequire('alXtQ'));

});

parcelRegister("9Q0ZS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jE56l").then(()=>parcelRequire('33O9R'));

});

parcelRegister("1fPeP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1br2a").then(()=>parcelRequire('lQFmB'));

});

parcelRegister("3V3me", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hVLrV").then(()=>parcelRequire('6nw6j'));

});

parcelRegister("l32sd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l8SJb").then(()=>parcelRequire('d3G6V'));

});

parcelRegister("7qf5e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2iXBu").then(()=>parcelRequire('eWVNZ'));

});

parcelRegister("kzrPS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5XZOC").then(()=>parcelRequire('3Cy6F'));

});

parcelRegister("8fAn5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f59bk").then(()=>parcelRequire('1z9k6'));

});

parcelRegister("5rAAW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1VKrd").then(()=>parcelRequire('6rnVg'));

});

parcelRegister("f2Nwh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lY0zh").then(()=>parcelRequire('bvNzF'));

});

parcelRegister("3I8gN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ezlyr").then(()=>parcelRequire('6uEie'));

});

parcelRegister("2AVPg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dHQJ1").then(()=>parcelRequire('1t3Es'));

});

parcelRegister("BLDQg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("43XOI").then(()=>parcelRequire('95Fn6'));

});

parcelRegister("c9lCS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cl6aX").then(()=>parcelRequire('bTxKJ'));

});

parcelRegister("6wjy5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6rsQT").then(()=>parcelRequire('9PFaq'));

});

parcelRegister("haByI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6uGrd").then(()=>parcelRequire('3Um2C'));

});

parcelRegister("dP53o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9OAhR").then(()=>parcelRequire('nKO3E'));

});

parcelRegister("8UyNn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4TfUE").then(()=>parcelRequire('9A3Xd'));

});

parcelRegister("aurSA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h2cME").then(()=>parcelRequire('hH986'));

});

parcelRegister("jRvL8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4hQ2L").then(()=>parcelRequire('fqDvU'));

});

parcelRegister("3jh1f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gqSrT").then(()=>parcelRequire('iaF1N'));

});

parcelRegister("dOPMJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7bHKQ").then(()=>parcelRequire('8B3dR'));

});

parcelRegister("2mfBc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jnGGh").then(()=>parcelRequire('kS58d'));

});

parcelRegister("jbXvq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fYPBk").then(()=>parcelRequire('7A4UJ'));

});

parcelRegister("lT6VF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("koL5r").then(()=>parcelRequire('kxR7V'));

});




parcelRegister("lauxv", function(module, exports) {
$parcel$export(module.exports, "default", () => $71de7c776fe6b9e8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eOlnh = parcelRequire("eOlnh");

var $cCsnS = parcelRequire("cCsnS");

var $fT7M2 = parcelRequire("fT7M2");

var $i3hRF = parcelRequire("i3hRF");

var $eJOHy = parcelRequire("eJOHy");

var $gJ8Mn = parcelRequire("gJ8Mn");

const $71de7c776fe6b9e8$var$STABLE_OBJECT = {};
const $71de7c776fe6b9e8$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $eJOHy.useMemo)(()=>(0, $fT7M2.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $eOlnh.useStableObject)(placementProps ?? $71de7c776fe6b9e8$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3hRF.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cCsnS.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gJ8Mn.default), {
                    analyticsChannel: (0, $29d03adbc636330b$export$85183a312807388d),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
var $71de7c776fe6b9e8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($71de7c776fe6b9e8$var$Placement);

});
parcelRegister("cCsnS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b382de610d60a80f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eUaD0 = parcelRequire("eUaD0");

var $6a4LK = parcelRequire("6a4LK");
var $lwEYg = parcelRequire("lwEYg");
var $eOlnh = parcelRequire("eOlnh");

var $UK12V = parcelRequire("UK12V");

var $kokXW = parcelRequire("kokXW");

var $eJOHy = parcelRequire("eJOHy");

var $2QO3b = parcelRequire("2QO3b");


var $7Zq2F = parcelRequire("7Zq2F");

var $dmRMl = parcelRequire("dmRMl");

var $kVpZx = parcelRequire("kVpZx");

var $7aoMz = parcelRequire("7aoMz");

var $eGOwo = parcelRequire("eGOwo");
const $b382de610d60a80f$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $kokXW.usePlacementFetchingContext)();
    return (0, $eJOHy.useMemo)(()=>disableInitialData ? undefined : (0, $7Zq2F.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $b382de610d60a80f$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $b382de610d60a80f$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $b382de610d60a80f$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $2QO3b.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $2QO3b.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $b382de610d60a80f$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $lwEYg.usePostOfficeRoute)();
    const context = (0, $6a4LK.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dmRMl.useBuildBasePath)();
    const stableContextWithRoute = (0, $eOlnh.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $eJOHy.useMemo)(()=>isUFOEnabled ? new (0, $UK12V.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $eJOHy.useContext)((0, $kVpZx.default));
    const ufoV2InteractionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const stableUfoV2Interaction = (0, $eOlnh.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $eJOHy.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    if ((0, $eGOwo.fg)('post-office_enable_ufo-v2-add-error')) $b382de610d60a80f$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($b382de610d60a80f$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($b382de610d60a80f$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($b382de610d60a80f$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($b382de610d60a80f$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $b382de610d60a80f$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $eJOHy.useMemo)(()=>({
            source: (0, $e04b81fcc62d5d5f$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext,
        children: children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: componentOnEvent
        })
    });
};
var $b382de610d60a80f$export$2e2bcd8739ae039 = $b382de610d60a80f$var$Placement;

});
const $e04b81fcc62d5d5f$export$85183a312807388d = 'postOffice';
const $e04b81fcc62d5d5f$export$f7109619a5e9e0d6 = 'post-office-frontend';

parcelRegister("dmRMl", function(module, exports) {
$parcel$export(module.exports, "useBuildBasePath", () => $a5b3c9d99f06d43a$export$83d6c58b7ab7ae67);

var $i0k0q = parcelRequire("i0k0q");
var $dWans = parcelRequire("dWans");

var $eJOHy = parcelRequire("eJOHy");
const $a5b3c9d99f06d43a$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $dWans.usePostOfficeEnvironment)();
    return (0, $eJOHy.useMemo)(()=>(0, $i0k0q.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});


parcelRegister("gJ8Mn", function(module, exports) {
$parcel$export(module.exports, "default", () => $93722e68ffa5e8ca$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $4J0ad = parcelRequire("4J0ad");

var $eJOHy = parcelRequire("eJOHy");
class $93722e68ffa5e8ca$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
var $93722e68ffa5e8ca$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($93722e68ffa5e8ca$var$ErrorBoundary);

});

const $29d03adbc636330b$export$85183a312807388d = 'postOffice';



parcelRegister("3ipHb", function(module, exports) {
$parcel$export(module.exports, "PreviewPanel", () => $b0ae65c56f2d002e$export$9520f072db304aa0);

var $gOhSQ = parcelRequire("gOhSQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2bY1m = parcelRequire("2bY1m");

var $4cTDP = parcelRequire("4cTDP");

var $dzLcO = parcelRequire("dzLcO");

var $jZ41J = parcelRequire("jZ41J");

var $dTocu = parcelRequire("dTocu");

var $9FYIg = parcelRequire("9FYIg");

var $hXbwo = parcelRequire("hXbwo");

var $fZsy4 = parcelRequire("fZsy4");

var $ehizH = parcelRequire("ehizH");
const $b0ae65c56f2d002e$var$PreviewPanelInternal = ({ queryReference: queryReference })=>{
    const panel = (0, $jZ41J.useCurrentPreviewPanel)();
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const [, { setPreviewPanelState: setPreviewPanelState }] = (0, $fZsy4.useLayoutStoreActions)();
    const [useLocalWidth, setUseLocalWidth] = (0, $eJOHy.useState)(false);
    const onResizeEnd = (0, $eJOHy.useCallback)(({ finalWidth: finalWidth })=>{
        panel?.setWidth?.(finalWidth);
        setPreviewPanelState({
            width: finalWidth
        });
        setUseLocalWidth(true);
    }, [
        panel,
        setPreviewPanelState
    ]);
    const data = (0, $j4oe4.usePreloadedQuery)((0, $gOhSQ.default), queryReference);
    if (panel === null) return null;
    const { content: PanelContent } = panel;
    const previewPanelWidth = useLocalWidth ? panel?.width : data?.jira?.navigationUIState?.previewPanel?.width ?? panel?.width;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.RightPanel), {
        width: previewPanelWidth,
        testId: "preview-panels.preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PanelContent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bY1m.PanelSplitter), {
        label: formatMessage((0, $ehizH.messages).previewPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "preview-panels.panel-splitter"
    }));
};
const $b0ae65c56f2d002e$var$PreviewPanelWithoutWidthPersistance = ()=>{
    const panel = (0, $jZ41J.useCurrentPreviewPanel)();
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const [, { setPreviewPanelState: setPreviewPanelState }] = (0, $fZsy4.useLayoutStoreActions)();
    const onResizeEnd = (0, $eJOHy.useCallback)(({ finalWidth: finalWidth })=>{
        panel?.setWidth?.(finalWidth);
        setPreviewPanelState({
            width: finalWidth
        });
    }, [
        panel,
        setPreviewPanelState
    ]);
    if (panel === null) return null;
    const { content: PanelContent } = panel;
    const previewPanelWidth = panel?.width;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.RightPanel), {
        width: previewPanelWidth,
        testId: "preview-panels.preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PanelContent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bY1m.PanelSplitter), {
        label: formatMessage((0, $ehizH.messages).previewPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "preview-panels.panel-splitter"
    }));
};
const $b0ae65c56f2d002e$export$9520f072db304aa0 = ()=>{
    if ((0, $4cTDP.fg)('preview_panel_width_persistance')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $hXbwo.previewPanelStateResource));
        if (!queryReference) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b0ae65c56f2d002e$var$PreviewPanelInternal, {
            queryReference: queryReference
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b0ae65c56f2d002e$var$PreviewPanelWithoutWidthPersistance, null);
};

});
parcelRegister("dTocu", function(module, exports) {
$parcel$export(module.exports, "useIntlV2", () => $3e10afa6ddf4542a$export$d82607073b68786);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");
const $3e10afa6ddf4542a$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $lRq8t.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $eJOHy.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("ehizH", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2cddfb84b2ec9e3c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2cddfb84b2ec9e3c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    previewPanelSplitterLabel: {
        "id": "page-container-v2.common.preview-panel.preview-panel-splitter-label",
        "defaultMessage": "Resize preview panel"
    }
});

});


parcelRegister("hCNjJ", function(module, exports) {
$parcel$export(module.exports, "HydrationFinishedSetter", () => $555a8e92bf44d2ef$export$b98d99a762f5a086);

var $eJOHy = parcelRequire("eJOHy");

var $9RE4U = parcelRequire("9RE4U");

var $2MtPi = parcelRequire("2MtPi");
const $555a8e92bf44d2ef$var$Setter = ()=>{
    (0, $9RE4U.reportHydrationEnd)();
    return null;
};
const $555a8e92bf44d2ef$export$b98d99a762f5a086 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2MtPi.RenderAfterHydrationCompletion), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($555a8e92bf44d2ef$var$Setter, null));

});

parcelRegister("eAwT1", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $c0bc063a19dc8ff6$export$3b4e64e77073e307);

var $eJOHy = parcelRequire("eJOHy");


var $dJSyP = parcelRequire("dJSyP");
function $c0bc063a19dc8ff6$export$3b4e64e77073e307() {
    if (!false || (0, $9790b8dfe6f31c81$export$19d68f5aa485d903)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJSyP.Banner), null);
    return null;
}

});
parcelRegister("dJSyP", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $91521b72f2da56fc$export$3b4e64e77073e307);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");


var $dnZnj = parcelRequire("dnZnj");

var $4cTDP = parcelRequire("4cTDP");


var $hRIa5 = parcelRequire("hRIa5");

var $dzLcO = parcelRequire("dzLcO");

var $5zoYi = parcelRequire("5zoYi");


var $7mXaF = parcelRequire("7mXaF");


var $35T6Y = parcelRequire("35T6Y");


var $2UuhW = parcelRequire("2UuhW");

var $010oY = parcelRequire("010oY");

var $jMu4X = parcelRequire("jMu4X");

var $4EKqI = parcelRequire("4EKqI");


var $95ud4 = parcelRequire("95ud4");


var $lxKFg = parcelRequire("lxKFg");


var $khNDs = parcelRequire("khNDs");


var $g5l4t = parcelRequire("g5l4t");
/**
 * This ID is used in pollinator tests and by JPD. Do not change lightly.
 */ const $91521b72f2da56fc$var$BANNER_ID = 'page-layout.banner';
const $91521b72f2da56fc$export$3b4e64e77073e307 = ()=>{
    const banner = (0, $5zoYi.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Banner), {
        height: banner.height,
        testId: $91521b72f2da56fc$var$BANNER_ID,
        id: $91521b72f2da56fc$var$BANNER_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91521b72f2da56fc$var$BannerContent, {
        bannerName: banner.name
    }))) : null;
};
/*
 * ALL COMPONENTS MUST BE PACKAGES THAT ARE LOCATED IN:
 * jira/src/packages/platform/ui/banners
 *
 * Create new packages in this workspace. There is a ratchet rule that depends on this.
 *
 * Please make sure that entryFsSsrLiftImportToModule is set to true for any async banners
 */ const $91521b72f2da56fc$var$BannerContent = ({ bannerName: bannerName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, bannerName === (0, $69f60eadef6768b2$export$3c5e605ca7ade9f2) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mXaF.BannerAnnouncementAsync), null), bannerName === (0, $5eaeff4aff080d2f$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRIa5.IPBlocklistingBannerAsync), null), bannerName === (0, $010oY.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMu4X.ReturnToMobileBanner), null), bannerName === (0, $5dc1b04ccd518917$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dnZnj.CookieConsentBannerAsync), null), bannerName === (0, $d9444cff34d1ab64$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $35T6Y.BannerTransitionAsync), null), bannerName === (0, $b469e0c8d9aee89c$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UuhW.MailExpiryBannerAsync), null), bannerName === (0, $b3867ac518e371e9$export$41956b146268af93) && (0, $4cTDP.fg)('jpd-view-templates-feedback-banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $95ud4.AsyncJpdBlueprintsFeedbackBanner), null), bannerName === (0, $27294eb882c7c50f$export$41956b146268af93) && (0, $4cTDP.fg)('upsell_jira_global_automations_limit_banner_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxKFg.AutomationLimitAwarenessBannerAsync), null), bannerName === (0, $225b7a1fbba60a47$export$7b746a9f691e0529) && (0, $4cTDP.fg)('eoc_consolidation_cohort_3_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khNDs.Cohort3BannerAsync), null), bannerName === (0, $4c332600cf5974c6$export$41956b146268af93) && (0, $4cTDP.fg)('auto_upgrade_not_a_trial_jira_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5l4t.AsyncAutoUpgradeAvoidDeactivationBanner), null));

});
const $5dc1b04ccd518917$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $5dc1b04ccd518917$export$ed7cc0d417ee89e = 74;
const $5dc1b04ccd518917$export$ff6e18f7d82b549c = 320;

parcelRegister("dnZnj", function(module, exports) {
$parcel$export(module.exports, "CookieConsentBannerAsync", () => $1fce724c9fba4e10$export$f110a9cbbbd3fa3a);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fce724c9fba4e10$var$LazyCookieConsentBanner = (0, $bQWwW.lazy)(()=>// chunk name is async-ccb to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("1yia8")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx"
});

const $1fce724c9fba4e10$var$LazyForPaintCookieConsentBanner = (0, $bQWwW.lazyForPaint)(()=>// chunk name is async-cc-banner to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("1yia8")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx"
});
const $1fce724c9fba4e10$export$f110a9cbbbd3fa3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1fce724c9fba4e10$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "async-cookie-consent-banner",
        packageName: "jiraCookieConsentBanner",
        teamName: "Magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-cookie-consent-banner",
        fallback: null
    }, (0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1fce724c9fba4e10$var$LazyForPaintCookieConsentBanner, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1fce724c9fba4e10$var$LazyCookieConsentBanner, null))));
const $1fce724c9fba4e10$var$boxStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    height: '100%'
});

});
parcelRegister("1yia8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kZAVi").then(()=>parcelRequire('aMyAY'));

});


const $5eaeff4aff080d2f$export$86047f02632f9f5b = 56;
const $5eaeff4aff080d2f$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';

parcelRegister("hRIa5", function(module, exports) {
$parcel$export(module.exports, "IPBlocklistingBannerAsync", () => $090474c8a4a63807$export$fafc306b802ab39d);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $090474c8a4a63807$var$IPBlocklistingBannerComp = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("9MiEP")).then((m)=>m.IPBlocklistingBanner), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
});
const $090474c8a4a63807$export$fafc306b802ab39d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-ip-block-listing-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($090474c8a4a63807$var$IPBlocklistingBannerComp, null));

});
parcelRegister("9MiEP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("62CNd").then(()=>parcelRequire('bv20m'));

});


parcelRegister("5zoYi", function(module, exports) {
$parcel$export(module.exports, "useBanner", () => $106b08f2e31362e2$export$de40f69ba30f2376);

var $eJOHy = parcelRequire("eJOHy");

var $h8CZV = parcelRequire("h8CZV");

var $1avbn = parcelRequire("1avbn");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $a1Ug2 = parcelRequire("a1Ug2");

var $i0Aal = parcelRequire("i0Aal");

var $c6HIQ = parcelRequire("c6HIQ");

var $gsCE0 = parcelRequire("gsCE0");

var $gcHrf = parcelRequire("gcHrf");

var $5k2IH = parcelRequire("5k2IH");

var $dms9U = parcelRequire("dms9U");

var $f3QKI = parcelRequire("f3QKI");

var $jZ7Bs = parcelRequire("jZ7Bs");
const $106b08f2e31362e2$var$noBanner = {
    name: null,
    height: 0,
    isEnabled: false
};
const $106b08f2e31362e2$var$useJpdBannerFeedback = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jpd-view-templates-sample-project'), ()=>(0, $dms9U.useBannerJpdBlueprintsFeedback)(), ()=>$106b08f2e31362e2$var$noBanner);
const $106b08f2e31362e2$var$useAutoUpgradeBanner = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('auto_upgrade_not_a_trial_jira_gate'), ()=>(0, $h8CZV.useBannerAutoUpgradeNotATrial)(), ()=>$106b08f2e31362e2$var$noBanner);
const $106b08f2e31362e2$export$de40f69ba30f2376 = ({ ignoreChromeless: ignoreChromeless = false } = {})=>{
    const [isChromeless] = (0, $i0Aal.useIsChromeless)();
    const announcement = (0, $c6HIQ.useBannerAnnouncement)();
    const transition = (0, $gcHrf.useBannerEocTransition)();
    const returnToMobile = (0, $f3QKI.useBannerReturnToMobile)();
    const IPBlocklisting = (0, $a1Ug2.useBannerIPBlocklisting)();
    // eslint-disable-next-line react-hooks/react-compiler
    const cohort3CustomersBanner = (0, $4cTDP.fg)('eoc_consolidation_cohort_3_banner') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $gsCE0.useCohort3CustomersBanner)() : undefined;
    const cookieConsent = (0, $1avbn.useBannerCookieConsent)();
    // we have added this check to return banner data for assets routes as all the routes in assets are chromeless
    // but we want to show the announcement banner in assets routes
    const isChromelessCheck = ignoreChromeless && (0, $4cTDP.fg)('show_announcement_banner_in_assets') ? false : isChromeless;
    const mailExpiry = (0, $5k2IH.useBannerMailExpiry)();
    const jpdBlueprintsFeedback = $106b08f2e31362e2$var$useJpdBannerFeedback();
    // eslint-disable-next-line react-hooks/react-compiler
    const automationLimitAwareness = (0, $4cTDP.fg)('upsell_jira_global_automations_limit_banner_fg') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $jZ7Bs.useBannerAutomationLimitAwareness)() : undefined;
    const autoUpgradeNotATrial = $106b08f2e31362e2$var$useAutoUpgradeBanner();
    return (0, $eJOHy.useMemo)(()=>{
        // cookie consent banner has the highest priority
        if (cookieConsent?.isEnabled) return cookieConsent;
        if (isChromelessCheck) return $106b08f2e31362e2$var$noBanner;
        if (IPBlocklisting.isEnabled) return IPBlocklisting;
        if (returnToMobile.isEnabled) return returnToMobile;
        if (announcement.isEnabled) return announcement;
        if (transition?.isEnabled) return transition;
        if (mailExpiry?.isEnabled) return mailExpiry;
        if (jpdBlueprintsFeedback.isEnabled) return jpdBlueprintsFeedback;
        if (automationLimitAwareness?.isEnabled) return automationLimitAwareness;
        if (cohort3CustomersBanner?.isEnabled) return cohort3CustomersBanner;
        if (autoUpgradeNotATrial?.isEnabled) return autoUpgradeNotATrial;
        return $106b08f2e31362e2$var$noBanner;
    }, [
        cookieConsent,
        IPBlocklisting,
        returnToMobile,
        announcement,
        transition,
        mailExpiry,
        jpdBlueprintsFeedback,
        automationLimitAwareness,
        cohort3CustomersBanner,
        isChromelessCheck,
        autoUpgradeNotATrial
    ]);
};

});
parcelRegister("h8CZV", function(module, exports) {
$parcel$export(module.exports, "useBannerAutoUpgradeNotATrial", () => $560a8a9100c3a5fe$export$d1ecc5f131ee1cdb);

var $1IFsa = parcelRequire("1IFsa");


var $8rHTt = parcelRequire("8rHTt");
const $560a8a9100c3a5fe$export$d1ecc5f131ee1cdb = ()=>{
    const { isEnabled: isEnabled } = (0, $8rHTt.useEnabledCriteria)();
    return {
        isEnabled: isEnabled,
        name: (0, $4c332600cf5974c6$export$41956b146268af93),
        height: isEnabled ? (0, $1IFsa.AVOID_DEACTIVATION_BANNER_HEIGHT) : 0
    };
};

});
parcelRegister("1IFsa", function(module, exports) {
$parcel$export(module.exports, "AUNT_STATSIG_EXPERIMENT_KEY", () => $d5d5317a7cf5231a$export$7af15fb4b1ef8bf2);
$parcel$export(module.exports, "STANDARD_TRIAL_DAYS_TO_DEACTIVATION", () => $d5d5317a7cf5231a$export$31c76e063a58551f);
$parcel$export(module.exports, "AVOID_DEACTIVATION_MODAL_TEST_ID", () => $d5d5317a7cf5231a$export$e25ee5e8d56c9434);
$parcel$export(module.exports, "AVOID_DEACTIVATION_MODAL_ACTION_SUBJECT_ID", () => $d5d5317a7cf5231a$export$4c68c8f979e7c34e);
$parcel$export(module.exports, "AVOID_DEACTIVATION_BANNER_SUBJECT_ID", () => $d5d5317a7cf5231a$export$e1dd560345bb2391);
$parcel$export(module.exports, "AVOID_DEACTIVATION_BANNER_TEST_ID", () => $d5d5317a7cf5231a$export$fb4037ac52e8f2af);
$parcel$export(module.exports, "ADD_PAYMENT_AVOID_DEACTIVATION_ACTION_SUBJECT_ID", () => $d5d5317a7cf5231a$export$617971661581b89a);
$parcel$export(module.exports, "REMOVE_USERS_AVOID_DEACTIVATION_ACTION_SUBJECT_ID", () => $d5d5317a7cf5231a$export$6b183dcf8256b901);
$parcel$export(module.exports, "TAKE_ACTION_AVOID_DEACTIVATION_ACTION_SUBJECT_ID", () => $d5d5317a7cf5231a$export$88ddc07ee0185a0);
$parcel$export(module.exports, "TAKE_ACTION_SOURCE_ID", () => $d5d5317a7cf5231a$export$4bdf96a244b85ff6);
$parcel$export(module.exports, "AVOID_DEACTIVATION_BANNER_HEIGHT", () => $d5d5317a7cf5231a$export$6be2b9eb165d621f);
$parcel$export(module.exports, "MAX_USERS_ON_FREE_PLAN", () => $d5d5317a7cf5231a$export$51039dd19c9a3762);
$parcel$export(module.exports, "PRODUCT_TO_CHARGE_ELEMENT", () => $d5d5317a7cf5231a$export$466cbff150b55117);
$parcel$export(module.exports, "PRODUCT_TO_ORIGIN", () => $d5d5317a7cf5231a$export$5a01ec5e3068630c);
$parcel$export(module.exports, "ProductKeyToHAMSMap", () => $d5d5317a7cf5231a$export$c17ca73287ae9119);
const $d5d5317a7cf5231a$export$7af15fb4b1ef8bf2 = 'auto_upgrade_not_a_trial';
const $d5d5317a7cf5231a$export$31c76e063a58551f = 14;
const $d5d5317a7cf5231a$export$e25ee5e8d56c9434 = 'auto-upgrade-avoid-deactivation-modal';
const $d5d5317a7cf5231a$export$4c68c8f979e7c34e = 'autoUpgradeAvoidDeactivationModal';
const $d5d5317a7cf5231a$export$e1dd560345bb2391 = 'autoUpgradeAvoidDeactivationBanner';
const $d5d5317a7cf5231a$export$fb4037ac52e8f2af = 'auto-upgrade-avoid-deactivation-banner';
const $d5d5317a7cf5231a$export$605e10c7fb710fe8 = 'auto-upgrade-avoid-deactivation-flag';
const $d5d5317a7cf5231a$export$617971661581b89a = 'addPaymentAvoidDeactivation';
const $d5d5317a7cf5231a$export$6b183dcf8256b901 = 'removeUsersAvoidDeactivation';
const $d5d5317a7cf5231a$export$88ddc07ee0185a0 = 'autoUpgradeNotATrial';
const $d5d5317a7cf5231a$export$4bdf96a244b85ff6 = 'autoUpgradeNotATrial';
const $d5d5317a7cf5231a$export$6be2b9eb165d621f = 44;
const $d5d5317a7cf5231a$export$51039dd19c9a3762 = {
    confluence: 10,
    'jira-product-discovery': 3,
    'jira-service-management': 3,
    jira: 10
};
const $d5d5317a7cf5231a$export$466cbff150b55117 = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'creator',
    ['jira-service-management']: 'agent'
};
const $d5d5317a7cf5231a$export$5a01ec5e3068630c = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
const $d5d5317a7cf5231a$export$c17ca73287ae9119 = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};

});

const $4c332600cf5974c6$export$41956b146268af93 = 'BANNER_NAME_AUTO_UPGRADE_NOT_A_TRIAL';
const $4c332600cf5974c6$export$ed7cc0d417ee89e = 44;
const $4c332600cf5974c6$export$a9066c48870ddcc5 = 'auto_upgrade_not_a_trial_experiment';
const $4c332600cf5974c6$export$63dbdc1ad1f5eac2 = 'auto-upgrade-not-a-trial-error-boundary';
const $4c332600cf5974c6$export$31c76e063a58551f = 14;

parcelRegister("8rHTt", function(module, exports) {
$parcel$export(module.exports, "useEnabledCriteria", () => $cee159a88ac8d87d$export$bd472f3d1255b11);

var $eJOHy = parcelRequire("eJOHy");

var $8RQlO = parcelRequire("8RQlO");
var $cngED = parcelRequire("cngED");

var $8rGQ0 = parcelRequire("8rGQ0");

var $8Q6yE = parcelRequire("8Q6yE");

var $eJrcF = parcelRequire("eJrcF");

var $jhUdU = parcelRequire("jhUdU");

var $cxKOj = parcelRequire("cxKOj");


var $3b8fD = parcelRequire("3b8fD");

var $ihoWG = parcelRequire("ihoWG");
const $cee159a88ac8d87d$export$bd472f3d1255b11 = ()=>{
    const { product: product, productKey: productKey, projectType: projectType, isStandardEdition: isStandardEdition } = (0, $3b8fD.useProductAndEdition)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const entitlementDetails = productKey && productEntitlementDetails && productEntitlementDetails[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS';
    const trialEndTime = entitlementDetails?.trialEndTime;
    const firstPredunningEndTime = entitlementDetails?.firstPredunningEndTime;
    const deactivationDate = (0, $eJOHy.useMemo)(()=>{
        if (!trialEndTime && !firstPredunningEndTime) return;
        // use firstPredunningEndTime if it's in the future since this will not be removed once the trial ends
        if (firstPredunningEndTime && (0, $cngED.default)(firstPredunningEndTime)) return new Date(firstPredunningEndTime);
        // use trialEndTime if it exists as a backup
        if (trialEndTime) return (0, $8RQlO.default)(new Date(trialEndTime), (0, $4c332600cf5974c6$export$31c76e063a58551f));
    }, [
        trialEndTime,
        firstPredunningEndTime
    ]);
    const trialEndDate = (0, $eJOHy.useMemo)(()=>trialEndTime ? new Date(trialEndTime) : undefined, [
        trialEndTime
    ]);
    const isInTrialOrPreDunning = entitlementDetails && !!deactivationDate && (0, $cngED.default)(deactivationDate);
    const { data: productTrait, loading: loadingTrait, error: errorTrait } = (0, $ihoWG.useAutoUpgradeTrait)({
        projectType: projectType
    });
    const { data: transactionData, loading: loadingTransaction, error: errorTransaction } = (0, $eJrcF.useResource)((0, $jhUdU.standardTrialTransactionAccountStatusResource));
    const loading = loadingTrait || loadingTransaction;
    const error = errorTrait || errorTransaction;
    // only display the banner if NO billToPresent is available on any of the transaction accounts
    const isBillToPresent = transactionData && transactionData?.transactionAccountDetails && transactionData?.transactionAccountDetails.some((account)=>account.billToPresent === true);
    // all criteria to show the banner
    const isEnabled = Boolean(isStandardEdition && product && isSiteAdmin && billingSourceSystem === 'CCP' && isInTrialOrPreDunning && productTrait?.value && !error && !loading && !isBillToPresent && (0, $cxKOj.expValEquals)('auto_upgrade_not_a_trial', 'cohort', 'treatment', 'not-enrolled'));
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isEnabled,
            deactivationDate: deactivationDate,
            product: product,
            projectType: projectType,
            trialEndDate: trialEndDate
        }), [
        isEnabled,
        deactivationDate,
        product,
        trialEndDate,
        projectType
    ]);
};

});
parcelRegister("3b8fD", function(module, exports) {
$parcel$export(module.exports, "useProductAndEdition", () => $9b6ec49215c20c40$export$b0f1c0403c557678);

var $eJOHy = parcelRequire("eJOHy");

var $1BZ8a = parcelRequire("1BZ8a");

var $cblKs = parcelRequire("cblKs");

var $FhXEJ = parcelRequire("FhXEJ");

var $eWzpp = parcelRequire("eWzpp");
const $9b6ec49215c20c40$var$getPlatformProduct = (p)=>{
    if (p === (0, $FhXEJ.SOFTWARE_PROJECT)) return 'jira';
    if (p === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return 'jira-product-discovery';
    if (p === (0, $FhXEJ.SERVICE_DESK_PROJECT)) return 'jira-service-management';
    if (p === (0, $FhXEJ.CORE_PROJECT)) return 'jira';
};
const $9b6ec49215c20c40$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const { loading: loading, data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $eJOHy.useMemo)(()=>{
        if (loading) return;
        const type = (0, $FhXEJ.toProjectType)(project?.type);
        if (type) return type;
    }, [
        loading,
        project?.type
    ]);
    const localEdition = (0, $eJOHy.useMemo)(()=>{
        if (!projectType) return;
        return (0, $cblKs.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType
    ]);
    const isStandardEdition = localEdition === (0, $cblKs.STANDARD_EDITION);
    const productKey = projectType && (0, $FhXEJ.projectTypeToCanonicalId)(projectType);
    const product = $9b6ec49215c20c40$var$getPlatformProduct(projectType);
    return (0, $eJOHy.useMemo)(()=>({
            product: product,
            productKey: productKey,
            projectType: projectType,
            isStandardEdition: isStandardEdition
        }), [
        product,
        productKey,
        projectType,
        isStandardEdition
    ]);
};

});

parcelRegister("ihoWG", function(module, exports) {
$parcel$export(module.exports, "useAutoUpgradeTrait", () => $c70545cdd4f180ba$export$80f64645e47397e6);

var $2emAF = parcelRequire("2emAF");

var $eJrcF = parcelRequire("eJrcF");
const $c70545cdd4f180ba$export$41d278cebca36080 = 'jsw_ccp_auto_upgraded_trialing_and_predunning_sites';
const $c70545cdd4f180ba$export$d4f4f4f5f4a2bb83 = 'jsm_ccp_auto_upgraded_trialing_and_predunning_sites';
const $c70545cdd4f180ba$export$569832978b5e7157 = 'jpd_ccp_auto_upgraded_trialing_and_predunning_sites';
const $c70545cdd4f180ba$var$getProductSpecificTrait = (siteTraitsData, productType)=>{
    return siteTraitsData && productType ? siteTraitsData.find((trait)=>{
        if (!trait) return;
        switch(productType){
            case 'software':
                return trait.name === $c70545cdd4f180ba$export$41d278cebca36080;
            case 'service_desk':
                return trait.name === $c70545cdd4f180ba$export$d4f4f4f5f4a2bb83;
            case 'product_discovery':
                return trait.name === $c70545cdd4f180ba$export$569832978b5e7157;
            default:
                return false;
        }
    }) : undefined;
};
const $c70545cdd4f180ba$export$80f64645e47397e6 = ({ projectType: projectType })=>{
    const { data: siteTraitsData, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $2emAF.fetchSiteTraitsResource));
    const productTrait = $c70545cdd4f180ba$var$getProductSpecificTrait(siteTraitsData, projectType);
    return {
        data: productTrait,
        loading: loading,
        error: error
    };
};

});



parcelRegister("1avbn", function(module, exports) {
$parcel$export(module.exports, "useBannerCookieConsent", () => $1c2cfc50aff7eb61$export$c7a51b5ee06f5794);

var $eJOHy = parcelRequire("eJOHy");

var $4P5ei = parcelRequire("4P5ei");

var $4cTDP = parcelRequire("4cTDP");

var $5MeEd = parcelRequire("5MeEd");

var $hbF3h = parcelRequire("hbF3h");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $lwlmQ = parcelRequire("lwlmQ");
const $1c2cfc50aff7eb61$export$5503c67b1001ec45 = (data)=>{
    if (false && !(0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) return false;
    try {
        if ((0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) {
            /**
			 * If we are using the cookie data to verify if we show the banner, and we don't use ATLASSIAN_SHOW_BANNER_COOKIE_KEY
			 * we end up in a situation where the banner is shown,
			 * then the client renders ConsentBanner from '@atlassian/browser-storage-controls'
			 * which then checks that cookie and if it's false
			 * and then we dismiss the banner anyway
			 *
			 * This is because the cookie consent logic does not set the 'fallback' cookie when we prefetch the data
			 * Because of this, shouldRenderBannerPrefetched will always end up returning true if we prefetch
			 *
			 * If we look at the getShowBanner code platform/packages/policy-platform/browser-storage-controls/src/ui/consent-banner/use-banner-visibility/index.ts
			 * We can see that it will use this show banner cookie to determine if the banner should be shown
			 * as long as we aren't in localConsentMode (which we aren't since we do not pass localConsentMode=true to ConsentBanner
			 * in jira/src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx)
			 *
			 * So we can use the ATLASSIAN_SHOW_BANNER_COOKIE_KEY to determine if the banner should be shown instead if it is set
			 */ if (data?.shouldShowBanner !== undefined) return data.shouldShowBanner;
        }
        if ((0, $4cTDP.fg)('fedramp-jira-banner-fix')) return data === null || (0, $4P5ei.shouldRenderBannerPrefetched)(data);
        return data && (0, $4P5ei.shouldRenderBannerPrefetched)(data);
    } catch (e) {
        return true;
    }
};
const $1c2cfc50aff7eb61$var$useBannerCookieConsentOld = ()=>{
    const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, $lwlmQ.useCookieConsentBannerSettings)();
    const { data: data } = (0, $5MeEd.useConsentBannerUserPreferencesResource)();
    (0, $eJOHy.useEffect)(()=>{
        const shouldRender = $1c2cfc50aff7eb61$export$5503c67b1001ec45(data);
        // only show banner if banner should be shown and not in iframe
        if (shouldRender && !(0, $lwlmQ.isInIframe)()) // the initial state of banner is "Dismissed" so we need to show it if we "think" it should be shown
        // in case we are making a mistake and CookieBanner will not display
        // it will inform us via `onConsentBannerBailOut` and we will dismiss the banner again.
        onShow();
    }, [
        data,
        onShow
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $5dc1b04ccd518917$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};
const $1c2cfc50aff7eb61$var$useBannerCookieConsentNew = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isDismissed: isDismissed, height: height, hasInit: hasInit }, { onShow: onShow, init: init }] = (0, $lwlmQ.useCookieConsentBannerSettings)();
    const { data: data, loading: loading, error: error } = (0, $5MeEd.useConsentBannerUserPreferencesResource)();
    // This is the initial state of the banner esp in ssr land
    const [initialShouldShow] = (0, $eJOHy.useState)(()=>{
        if (loading) return false;
        if (error) return true;
        return Boolean($1c2cfc50aff7eb61$export$5503c67b1001ec45(data) && !(0, $lwlmQ.isInIframe)());
    });
    const shouldShow = (0, $eJOHy.useMemo)(()=>hasInit ? !isDismissed : initialShouldShow, [
        hasInit,
        initialShouldShow,
        isDismissed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasInit || loading) return;
        // Now that we're in the client render, let's re-verify if we should show the banner
        // Eg to verify if we are in an iframe
        const shouldRender = Boolean(error || $1c2cfc50aff7eb61$export$5503c67b1001ec45(data) && !(0, $lwlmQ.isInIframe)());
        init(!shouldRender);
        // We should verify how often we end up having a mismatch between the initial render (probably ssr) and init render (client)
        if (!(0, $4cTDP.fg)('killswitch-analytics-ssr-cookie-consent-banner')) {
            if (initialShouldShow !== shouldRender) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'cookieConsentBanner showBannerMismatch', {
                isInIframe: (0, $lwlmQ.isInIframe)(),
                initialShouldShow: initialShouldShow,
                initShouldShow: shouldRender
            });
        }
    }, [
        createAnalyticsEvent,
        data,
        error,
        hasInit,
        init,
        initialShouldShow,
        loading,
        onShow
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: shouldShow,
            name: (0, $5dc1b04ccd518917$export$41956b146268af93),
            height: height
        }), [
        shouldShow,
        height
    ]);
};
const $1c2cfc50aff7eb61$export$c7a51b5ee06f5794 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner'), $1c2cfc50aff7eb61$var$useBannerCookieConsentNew, $1c2cfc50aff7eb61$var$useBannerCookieConsentOld);

});
parcelRegister("4P5ei", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $a02533041c167aed$export$6406464aa126433e);

var $eGOwo = parcelRequire("eGOwo");

var $a3JoR = parcelRequire("a3JoR");

var $eCCyA = parcelRequire("eCCyA");

var $hvH66 = parcelRequire("hvH66");
const $a02533041c167aed$export$6406464aa126433e = (prefetchedPreferencesData)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $eCCyA.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $hvH66.getBannerVisibility)(prefetchedPreferencesData) : true;
    }
    // We've been given ConsentHub response data, format it appropriately
    const consentPrefsData = (0, $a3JoR.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $hvH66.getBannerVisibility)(consentPrefsData);
};

});

parcelRegister("lwlmQ", function(module, exports) {
$parcel$export(module.exports, "isInIframe", () => $f6f060ec33615eca$export$9f140ed41af5108c);
$parcel$export(module.exports, "useCookieConsentBannerSettings", () => $f6f060ec33615eca$export$ae97931560f092a4);
$parcel$export(module.exports, "useCookieConsentBannerSettingsActions", () => $f6f060ec33615eca$export$ecbab4dc5f9ad844);

var $gRw8I = parcelRequire("gRw8I");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

const $f6f060ec33615eca$export$9f140ed41af5108c = ()=>{
    (0, $gRw8I.di)(window);
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
const $f6f060ec33615eca$export$d4c72bab9d6cc13a = {
    get isDismissed () {
        return true;
    },
    get height () {
        return (0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? (0, $5dc1b04ccd518917$export$ed7cc0d417ee89e) : 0;
    },
    hasInit: false
};
const $f6f060ec33615eca$export$e324594224ef24da = {
    onShow: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...(0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState(),
                isDismissed: false
            });
        },
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...(0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState(),
                isDismissed: true
            });
        },
    setHeight: (height)=>({ getState: getState, setState: setState })=>{
            setState({
                ...(0, $4cTDP.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState(),
                height: height
            });
        },
    init: (isDismissed)=>({ setState: setState })=>{
            setState({
                isDismissed: isDismissed,
                hasInit: true
            });
        }
};
const $f6f060ec33615eca$var$Store = (0, $GtRbT.createStore)({
    name: 'cookie-consent-banner',
    initialState: $f6f060ec33615eca$export$d4c72bab9d6cc13a,
    actions: $f6f060ec33615eca$export$e324594224ef24da
});
const $f6f060ec33615eca$export$ae97931560f092a4 = (0, $iJq0l.createHook)($f6f060ec33615eca$var$Store);
const $f6f060ec33615eca$export$ecbab4dc5f9ad844 = (0, $iJq0l.createActionsHook)($f6f060ec33615eca$var$Store);

});


parcelRegister("a1Ug2", function(module, exports) {
$parcel$export(module.exports, "useBannerIPBlocklisting", () => $91f5fab890bd5376$export$564412c1d9cd4ccc);

var $eJOHy = parcelRequire("eJOHy");

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");

var $4cTDP = parcelRequire("4cTDP");

const $91f5fab890bd5376$export$564412c1d9cd4ccc = ()=>{
    const [shouldShowBanner, setBannerState] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $4T9yL.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $97BGz.loadBridgeStrict)({
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-atlaskit-plugin:ipblocklisting'
                ],
                name: 'jira/global-components/ipblocklisting/bridge'
            }).then((bridge)=>{
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                bridge({
                    showIPBlocklistBanner: ()=>setBannerState(true),
                    hideIPBlocklistBanner: ()=>setBannerState(false)
                });
            }));
        else // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $iyT45.loadBridgeWeak)({
            name: 'jira/global-components/ipblocklisting/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge({
                showIPBlocklistBanner: ()=>setBannerState(true),
                hideIPBlocklistBanner: ()=>setBannerState(false)
            });
        });
    }, []);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: shouldShowBanner,
            name: (0, $5eaeff4aff080d2f$export$41956b146268af93),
            height: (0, $5eaeff4aff080d2f$export$86047f02632f9f5b)
        }), [
        shouldShowBanner
    ]);
};

});

parcelRegister("c6HIQ", function(module, exports) {
$parcel$export(module.exports, "useBannerAnnouncement", () => $03910aaf8b8451fd$export$1e775b1ab04f2888);

var $eJOHy = parcelRequire("eJOHy");

var $8ecGf = parcelRequire("8ecGf");

var $kh7bJ = parcelRequire("kh7bJ");

const $03910aaf8b8451fd$export$1e775b1ab04f2888 = ()=>{
    const { data: data } = (0, $8ecGf.useAnnouncementBannerSettingsV4Resource)();
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
            name: (0, $69f60eadef6768b2$export$3c5e605ca7ade9f2),
            height: (0, $69f60eadef6768b2$export$809d2b099693a9a8)
        }), [
        data?.isDismissed,
        data?.isEnabled,
        data?.visibility,
        isAnonymous
    ]);
};

});
const $69f60eadef6768b2$export$809d2b099693a9a8 = 64;
const $69f60eadef6768b2$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';


parcelRegister("gsCE0", function(module, exports) {
$parcel$export(module.exports, "useCohort3CustomersBanner", () => $b50c7cca26c0f4af$export$9dd28ddfa301aa73);

var $eJOHy = parcelRequire("eJOHy");

var $8rGQ0 = parcelRequire("8rGQ0");

var $kAwwe = parcelRequire("kAwwe");

var $e6YEs = parcelRequire("e6YEs");


var $5bM57 = parcelRequire("5bM57");
const $b50c7cca26c0f4af$export$9dd28ddfa301aa73 = ()=>{
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const accountId = (0, $e6YEs.useAccountId)();
    const { isDismissed: isDismissed, height: height } = (0, $5bM57.useCohort3CustomerBannerState)();
    const { fetchBannerVisibility: fetchBannerVisibility } = (0, $5bM57.useCohort3CustomerBannerActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (!accountId) return;
        fetchBannerVisibility(accountId);
    }, [
        accountId,
        fetchBannerVisibility
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: Boolean((isAdmin || isSiteAdmin) && !isDismissed),
            name: (0, $225b7a1fbba60a47$export$7b746a9f691e0529),
            height: height
        }), [
        isAdmin,
        isSiteAdmin,
        isDismissed,
        height
    ]);
};

});
const $225b7a1fbba60a47$export$7b746a9f691e0529 = 'EOC-COHORT3-CONSOLIDATION-BANNER';
const $225b7a1fbba60a47$export$ed7cc0d417ee89e = 50;

parcelRegister("5bM57", function(module, exports) {
$parcel$export(module.exports, "useCohort3CustomerBannerState", () => $b6e4bc4e636e41a0$export$5c26fb28abd3eaaf);
$parcel$export(module.exports, "useCohort3CustomerBannerActions", () => $b6e4bc4e636e41a0$export$1935eaf1458de3aa);
/* eslint-disable jira/restricted/@atlassian/react-sweet-state */ 
var $9pTd3 = parcelRequire("9pTd3");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

const $b6e4bc4e636e41a0$export$d4c72bab9d6cc13a = {
    isDismissed: false,
    height: (0, $225b7a1fbba60a47$export$ed7cc0d417ee89e),
    isLoading: true
};
const $b6e4bc4e636e41a0$export$e324594224ef24da = {
    onDismiss: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) {
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'onDismiss',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: new Error('Account id is not available'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            try {
                await (0, $FppkK.setUserProperties)(accountId, (0, $225b7a1fbba60a47$export$7b746a9f691e0529), 'true');
                setState({
                    isDismissed: true
                });
            } catch (error) {
                setState({
                    isDismissed: true
                });
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'useCohort3CustomersBanner',
                        packageName: 'Cohort3CustomerBanner',
                        teamName: 'alexstrasza'
                    },
                    error: error instanceof Error ? error : new Error(String(error)),
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        },
    fetchBannerVisibility: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) {
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'fetchBannerVisibility',
                        packageName: 'Cohort3CustomerBanner',
                        teamName: 'alexstrasza'
                    },
                    error: new Error('Account id is not available'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            try {
                const value = await (0, $FppkK.getUserProperty)(accountId, (0, $225b7a1fbba60a47$export$7b746a9f691e0529));
                setState({
                    isDismissed: Boolean(value),
                    isLoading: false
                });
            } catch (error) {
                if (error instanceof (0, $14RSn.default) && (error.statusCode === 404 || error.statusCode === 403)) setState({
                    isLoading: false,
                    isDismissed: false
                });
            }
        }
};
const $b6e4bc4e636e41a0$var$Store = (0, $GtRbT.createStore)({
    name: 'Cohort3CustomerBannerStore',
    initialState: $b6e4bc4e636e41a0$export$d4c72bab9d6cc13a,
    actions: $b6e4bc4e636e41a0$export$e324594224ef24da
});
const $b6e4bc4e636e41a0$export$5c26fb28abd3eaaf = (0, $iJq0l.createStateHook)($b6e4bc4e636e41a0$var$Store);
const $b6e4bc4e636e41a0$export$1935eaf1458de3aa = (0, $iJq0l.createActionsHook)($b6e4bc4e636e41a0$var$Store);

});


parcelRegister("gcHrf", function(module, exports) {
$parcel$export(module.exports, "useBannerEocTransition", () => $4fb08c6d42c0025d$export$b6539a8209f95b48);

var $eJOHy = parcelRequire("eJOHy");

var $5bYCj = parcelRequire("5bYCj");

var $ltvrD = parcelRequire("ltvrD");

var $gDXSd = parcelRequire("gDXSd");

var $kAwwe = parcelRequire("kAwwe");

var $8rGQ0 = parcelRequire("8rGQ0");

const $4fb08c6d42c0025d$export$b6539a8209f95b48 = ()=>{
    const { data: data, error: error } = (0, $5bYCj.useOgConsolidationUserState)();
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $gDXSd.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && (!data.isTransitionBannerDismissed || (0, $ltvrD.shouldRenderBenefitModal)({
        bannerDismissedAt: data.transitionBannerDismissedAt,
        isDismissed: data.isBenefitModalDismissed
    })));
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $d9444cff34d1ab64$export$41956b146268af93),
            height: data && (0, $ltvrD.shouldRenderBenefitModal)({
                bannerDismissedAt: data.transitionBannerDismissedAt
            }) ? 0 : (0, $d9444cff34d1ab64$export$809d2b099693a9a8)
        }), [
        data,
        isEnabled
    ]);
};

});
parcelRegister("5bYCj", function(module, exports) {
$parcel$export(module.exports, "useOgConsolidationUserState", () => $0219b617ddf086fe$export$c35632c02599163f);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $4I3Mw = parcelRequire("4I3Mw");

var $graie = parcelRequire("graie");

var $koAZ4 = parcelRequire("koAZ4");

var $eJrcF = parcelRequire("eJrcF");

var $bZ2Xv = parcelRequire("bZ2Xv");
const $0219b617ddf086fe$export$c35632c02599163f = ()=>{
    const errorRef = (0, $eJOHy.useRef)();
    const loadingRef = (0, $eJOHy.useRef)(false);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $eJrcF.useResource)((0, $graie.consolidationUserStateResource));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eJOHy.useState)();
    errorRef.current = userPropertiesError || transitionResourceError;
    const { atlassianAccountId: accountId } = (0, $koAZ4.useTenantContext)();
    const update = (0, $eJOHy.useCallback)((newState)=>{
        if (errorRef.current) // If there is an error on resource or update, we don't want to update the state
        return Promise.reject(errorRef.current);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let updatedData = {};
        updateTransitionResource((oldState)=>{
            updatedData = {
                ...oldState,
                ...newState
            };
            return updatedData;
        });
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $FppkK.setUserProperties)(accountId, (0, $4I3Mw.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: formatMessage((0, $bZ2Xv.default).errorFlagTitle),
                    messageId: 'eoc-changeboarding.controllers.use-og-consolidation-user-state.show-flag.error.jira-modal',
                    messageType: 'transactional'
                });
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
        return Promise.resolve();
    }, [
        updateTransitionResource,
        accountId,
        formatMessage,
        showFlag
    ]);
    const reopenTransitionLozenge = (0, $eJOHy.useCallback)(()=>{
        update({
            isTransitionHomeHidden: false
        });
    }, [
        update
    ]);
    return {
        data: data,
        update: update,
        error: errorRef.current,
        reopenTransitionLozenge: reopenTransitionLozenge
    };
};

});
parcelRegister("bZ2Xv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d01a20d87d825d5b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d01a20d87d825d5b$var$messages = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
        "defaultMessage": "Something went wrong while updating user properties."
    }
});
var $d01a20d87d825d5b$export$2e2bcd8739ae039 = $d01a20d87d825d5b$var$messages;

});


parcelRegister("ltvrD", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBenefitModal", () => $e7555031055c9d59$export$25a52eb2dc74e2f9);
const $e7555031055c9d59$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
    if (!bannerDismissedAt || isDismissed) return false;
    return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};

});

const $d9444cff34d1ab64$export$809d2b099693a9a8 = 48;
const $d9444cff34d1ab64$export$41956b146268af93 = 'EOC_TRANSITION';


parcelRegister("5k2IH", function(module, exports) {
$parcel$export(module.exports, "useBannerMailExpiry", () => $2d1be9dfb49d960c$export$3906461ac9b87d2);

var $eJOHy = parcelRequire("eJOHy");

var $7KVqh = parcelRequire("7KVqh");


var $kTerl = parcelRequire("kTerl");
const $2d1be9dfb49d960c$export$3906461ac9b87d2 = ()=>{
    const { responseStatus: responseStatus, state: state } = (0, $7KVqh.useIncomingMailExpiryStatus)();
    const { onStateFetch: onStateFetch } = (0, $kTerl.useBannerActions)();
    const { isBannerShown: isBannerShown } = (0, $kTerl.useBannerState)();
    (0, $eJOHy.useEffect)(()=>{
        if (responseStatus === 'error') {
            onStateFetch((0, $7KVqh.DEFAULT_RESPONSE));
            return;
        }
        if (responseStatus === 'success') onStateFetch(state);
    }, [
        onStateFetch,
        responseStatus,
        state
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isBannerShown,
            name: (0, $b469e0c8d9aee89c$export$41956b146268af93),
            height: (0, $b469e0c8d9aee89c$export$809d2b099693a9a8)
        }), [
        isBannerShown
    ]);
};

});
const $b469e0c8d9aee89c$export$809d2b099693a9a8 = 48;
const $b469e0c8d9aee89c$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';

parcelRegister("kTerl", function(module, exports) {
$parcel$export(module.exports, "useBannerActions", () => $900e5237903630fd$export$664f3e2467f0f5af);
$parcel$export(module.exports, "useBannerState", () => $900e5237903630fd$export$fa4ffa872ee90bd0);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $900e5237903630fd$export$d4c72bab9d6cc13a = {
    isBannerShown: false,
    isAdmin: false,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $900e5237903630fd$export$e324594224ef24da = {
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: false
            });
        },
    onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
        'GMAIL_OAUTH'
    ] })=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: showBanner && isAdmin,
                isAdmin: isAdmin,
                OauthTypes: OauthTypes
            });
        }
};
const $900e5237903630fd$var$Store = (0, $GtRbT.createStore)({
    name: 'mail-expiry-banner',
    initialState: $900e5237903630fd$export$d4c72bab9d6cc13a,
    actions: $900e5237903630fd$export$e324594224ef24da
});
const $900e5237903630fd$export$664f3e2467f0f5af = (0, $iJq0l.createActionsHook)($900e5237903630fd$var$Store);
const $900e5237903630fd$export$fa4ffa872ee90bd0 = (0, $iJq0l.createStateHook)($900e5237903630fd$var$Store);

});


parcelRegister("dms9U", function(module, exports) {
$parcel$export(module.exports, "useBannerJpdBlueprintsFeedback", () => $efa267fc89f6b5ee$export$c8506c2c91f4725a);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $4cTDP = parcelRequire("4cTDP");

var $2aY2d = parcelRequire("2aY2d");

var $e6YEs = parcelRequire("e6YEs");

var $eFrz1 = parcelRequire("eFrz1");


var $kdh7O = parcelRequire("kdh7O");

var $e2cVF = parcelRequire("e2cVF");
const $efa267fc89f6b5ee$export$c8506c2c91f4725a = ()=>{
    const hasPolarisInPath = (0, $e2cVF.useHasPolarisInPath)();
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const accountId = (0, $e6YEs.useAccountId)();
    const { isDismissed: isDismissed, height: height, shouldShow: shouldShow, isLoading: isLoading } = (0, $kdh7O.useJpdBlueprintsFeedbackBannerState)();
    const { fetchBannerVisibility: fetchBannerVisibility } = (0, $kdh7O.useJpdBlueprintsFeedbackBannerActions)();
    const isDiscoveryProject = project?.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT);
    const isInJpdBoundary = (0, $eJOHy.useMemo)(()=>hasPolarisInPath || isDiscoveryProject, [
        isDiscoveryProject,
        hasPolarisInPath
    ]);
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        if (!(0, $4cTDP.fg)('jpd-view-templates-feedback-banner')) return;
        if (!accountId) return;
        // Fetch only if we are in JPD boundary
        if (isInJpdBoundary) fetchBannerVisibility(accountId, project?.projectId);
    }, [
        accountId,
        fetchBannerVisibility,
        project,
        isInJpdBoundary
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isInJpdBoundary && shouldShow && !isDismissed && !isLoading && (0, $4cTDP.fg)('jpd-view-templates-feedback-banner'),
            name: (0, $b3867ac518e371e9$export$41956b146268af93),
            height: height
        }), [
        isInJpdBoundary,
        shouldShow,
        isDismissed,
        height,
        isLoading
    ]);
};

});
const $b3867ac518e371e9$export$41956b146268af93 = 'polaris.blueprints-feedback-banner';
const $b3867ac518e371e9$export$ed7cc0d417ee89e = 48;
const $b3867ac518e371e9$export$ff6e18f7d82b549c = 320;
const $b3867ac518e371e9$export$a07dab5608229ea3 = 'jira.polaris.blueprints-feedback-banner';
const $b3867ac518e371e9$export$b8b9d90f9e5bd72b = 'jiraPolarisComponentBlueprintsFeedbackBanner';

parcelRegister("kdh7O", function(module, exports) {
$parcel$export(module.exports, "useJpdBlueprintsFeedbackBannerState", () => $fdedef892ac2a54a$export$19a6160e3b75cbb4);
$parcel$export(module.exports, "useJpdBlueprintsFeedbackBannerActions", () => $fdedef892ac2a54a$export$dcb98dcb6a6fffba);

var $9pTd3 = parcelRequire("9pTd3");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $FppkK = parcelRequire("FppkK");

var $7e8wG = parcelRequire("7e8wG");

var $hThlN = parcelRequire("hThlN");

var $dMM78 = parcelRequire("dMM78");

var $14RSn = parcelRequire("14RSn");

var $3bR23 = parcelRequire("3bR23");

var $eu0ZO = parcelRequire("eu0ZO");

function $fdedef892ac2a54a$var$getError(error) {
    if (error instanceof Error) return error;
    return new (0, $hThlN.UnknownError)('Retrieved non-standard error', error);
}
const $fdedef892ac2a54a$export$d4c72bab9d6cc13a = {
    isDismissed: false,
    height: (0, $b3867ac518e371e9$export$ed7cc0d417ee89e),
    shouldShow: false,
    isLoading: true
};
const $fdedef892ac2a54a$export$e324594224ef24da = {
    onDismiss: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) return;
            // Update UI immediately - optimistic dismissal
            setState({
                isDismissed: true
            });
            try {
                await (0, $FppkK.setUserProperties)(accountId, (0, $b3867ac518e371e9$export$41956b146268af93), 'false');
            } catch (error) {
                (0, $9pTd3.fireErrorAnalytics)((0, $7e8wG.createErrorAnalytics)('polaris.jpd-blueprints-feedback.banner-dismissed', $fdedef892ac2a54a$var$getError(error)));
            }
        },
    fetchBannerVisibility: (accountId, projectId)=>async ({ setState: setState, getState: getState })=>{
            if (!accountId) return;
            // Don't show the banner if projectId is not provided
            if (!projectId) {
                setState({
                    shouldShow: false
                });
                return;
            }
            try {
                const onboardingInformation = await (0, $3bR23.getOnboardingInformation)(String(projectId));
                // Show the banner only for BLUEPRINTS project
                if (onboardingInformation.initialProjectTemplate !== (0, $eu0ZO.ProjectTemplateEnum).BLUEPRINTS) {
                    setState({
                        shouldShow: false,
                        isLoading: false
                    });
                    return;
                }
                const shouldShow = await (0, $FppkK.getUserProperty)(accountId, (0, $b3867ac518e371e9$export$41956b146268af93));
                setState({
                    shouldShow: shouldShow,
                    isLoading: false
                });
            } catch (error) {
                const { isDismissed: isDismissed } = getState();
                // Show the banner only if it has not been dismissed
                setState({
                    shouldShow: !isDismissed,
                    isLoading: false
                });
                if (error instanceof (0, $14RSn.default) && error.statusCode === 404 || (0, $dMM78.isClientFetchError)(error)) return;
                (0, $9pTd3.fireErrorAnalytics)((0, $7e8wG.createErrorAnalytics)('polaris.jpd-blueprints-feedback.banner-dismissed', $fdedef892ac2a54a$var$getError(error)));
            }
        }
};
const $fdedef892ac2a54a$var$Store = (0, $GtRbT.createStore)({
    name: 'PolarisBlueprintsFeedbackBanner',
    initialState: $fdedef892ac2a54a$export$d4c72bab9d6cc13a,
    actions: $fdedef892ac2a54a$export$e324594224ef24da
});
const $fdedef892ac2a54a$export$19a6160e3b75cbb4 = (0, $iJq0l.createStateHook)($fdedef892ac2a54a$var$Store);
const $fdedef892ac2a54a$export$dcb98dcb6a6fffba = (0, $iJq0l.createActionsHook)($fdedef892ac2a54a$var$Store);

});
parcelRegister("3bR23", function(module, exports) {
$parcel$export(module.exports, "getOnboardingInformation", () => $def5aa5d0b3024e0$export$4a5126f584ac4502);

var $hgi0g = parcelRequire("hgi0g");
const $def5aa5d0b3024e0$export$4a5126f584ac4502 = (projectId)=>(0, $hgi0g.default)(`/rest/polaris/project-template/onboarding-information/${projectId}?operation=getJpdOnboardingInformation`);

});

parcelRegister("eu0ZO", function(module, exports) {
$parcel$export(module.exports, "ProjectOnboardingStatusEnum", () => $a14d6f9733483dfd$export$d589b6154fdcf1ba);
$parcel$export(module.exports, "ProjectTemplateEnum", () => $a14d6f9733483dfd$export$58f839397dbcfc56);
$parcel$export(module.exports, "ProjectTemplateEnumAsync", () => $a14d6f9733483dfd$export$5b03685812930de3);
const $a14d6f9733483dfd$export$d589b6154fdcf1ba = {
    UNKNOWN: 'UNKNOWN',
    TASK_CREATION_FAILED: 'TASK_CREATION_FAILED',
    QUEUEING_FAILED: 'QUEUEING_FAILED',
    QUEUED: 'QUEUED',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE',
    FAILED: 'FAILED'
};
const $a14d6f9733483dfd$export$58f839397dbcfc56 = {
    DISCOVERY: 'jira.polaris:discovery',
    BLANK: 'jira.polaris:blank-project',
    ROADMAP: 'jira.polaris:roadmap',
    PRIORITIZATION: 'jira.polaris:prioritization',
    PORTFOLIO_MANAGEMENT: 'jira.polaris:portfolio',
    BLUEPRINTS: 'jira.polaris:blueprints',
    FROM_EXISTING_PROJECT: 'jira:template-generated-from-existing-project',
    STRATEGIC_PLANNING: 'jira.polaris:strategic_planning',
    PORTFOLIO_ROADMAP: 'jira.polaris:portfolio-roadmap'
};
const $a14d6f9733483dfd$export$5b03685812930de3 = {
    BLANK: 'jira.polaris:blank-project'
};

});


parcelRegister("e2cVF", function(module, exports) {
$parcel$export(module.exports, "useHasPolarisInPath", () => $5e77ed9c4d4800a8$export$b9f1d0d4eba42cdb);

var $kfvK2 = parcelRequire("kfvK2");
const $5e77ed9c4d4800a8$export$b9f1d0d4eba42cdb = (0, $kfvK2.createRouterSelector)(({ location: location })=>{
    return location.pathname.includes('/jira/polaris');
});

});


parcelRegister("f3QKI", function(module, exports) {
$parcel$export(module.exports, "useBannerReturnToMobileState", () => $e57df8779bd25ced$export$571311559507e90);
$parcel$export(module.exports, "useBannerReturnToMobile", () => $e57df8779bd25ced$export$a898dd7b7ec9917a);

var $eJOHy = parcelRequire("eJOHy");

var $l7Alo = parcelRequire("l7Alo");

var $fYeTG = parcelRequire("fYeTG");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $010oY = parcelRequire("010oY");
const $e57df8779bd25ced$var$initialState = ()=>({
        // reads FG early
        isEnabled: (0, $l7Alo.shouldShowReturnToMobileBanner)()
    });
const $e57df8779bd25ced$var$actions = {
    disable: ()=>({ setState: setState })=>{
            setState({
                isEnabled: false
            });
        }
};
const $e57df8779bd25ced$var$store = (0, $GtRbT.createStore)({
    initialState: $e57df8779bd25ced$var$initialState,
    actions: $e57df8779bd25ced$var$actions
});
const $e57df8779bd25ced$export$571311559507e90 = (0, $iJq0l.createHook)($e57df8779bd25ced$var$store);
const $e57df8779bd25ced$export$a898dd7b7ec9917a = ()=>{
    const [{ isEnabled: isEnabledOriginal }] = $e57df8779bd25ced$export$571311559507e90();
    const isEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)() ? isEnabledOriginal && (0, $l7Alo.shouldShowReturnToMobileBannerMobileMvp)() : isEnabledOriginal;
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $010oY.BANNER_NAME),
            height: (0, $010oY.mobileBannerHeight)
        }), [
        isEnabled
    ]);
};

});
parcelRegister("010oY", function(module, exports) {
$parcel$export(module.exports, "mobileBannerHeight", () => $68c768b7bbc0a026$export$aa875602f5712b77);
$parcel$export(module.exports, "BANNER_NAME", () => $68c768b7bbc0a026$export$41956b146268af93);
$parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", () => $68c768b7bbc0a026$export$698c82a2c8445300);
const $68c768b7bbc0a026$export$aa875602f5712b77 = 48;
const $68c768b7bbc0a026$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
const $68c768b7bbc0a026$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');

});


parcelRegister("jZ7Bs", function(module, exports) {
$parcel$export(module.exports, "useBannerAutomationLimitAwareness", () => $b67017d020386fbf$export$721b128dc6e2747d);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ 
var $eJOHy = parcelRequire("eJOHy");

var $3QMHH = parcelRequire("3QMHH");


var $aofWR = parcelRequire("aofWR");
const $b67017d020386fbf$export$721b128dc6e2747d = ()=>{
    const state = (0, $3QMHH.useAutomationLimitBannerState)();
    const { isEligible: isEligible, cohort: cohort, projectType: projectType, bannerType: bannerType } = (0, $aofWR.useStandardAutomationLimitAwarenessExperiment)();
    const isEnabled = Boolean(isEligible && projectType && bannerType && cohort !== 'not-enrolled' && !state[projectType].isDismissed && !state[projectType].isLoading);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $27294eb882c7c50f$export$41956b146268af93),
            height: isEnabled && projectType && cohort === 'treatment' ? state[projectType].height : 0
        }), [
        isEnabled,
        cohort,
        state,
        projectType
    ]);
};

});
parcelRegister("3QMHH", function(module, exports) {
$parcel$export(module.exports, "useAutomationLimitBannerState", () => $58ad8e28c2bf9311$export$90e145919b624840);
$parcel$export(module.exports, "useAutomationLimitBannerActions", () => $58ad8e28c2bf9311$export$602681b371abcfed);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $3hRxq = parcelRequire("3hRxq");

const $58ad8e28c2bf9311$export$d4c72bab9d6cc13a = {
    software: {
        isDismissed: false,
        height: 0,
        isLoading: false
    },
    service_desk: {
        isDismissed: false,
        height: 0,
        isLoading: false
    }
};
const $58ad8e28c2bf9311$export$5b435f40f36f752b = (prefix)=>(0, $3hRxq.createLocalStorageProvider)(`${prefix}-${(0, $27294eb882c7c50f$export$a9066c48870ddcc5)}`);
const $58ad8e28c2bf9311$var$getCurrentMonth = ()=>new Date().getMonth();
const $58ad8e28c2bf9311$export$bce50709089bc65b = {
    software: {
        month: $58ad8e28c2bf9311$var$getCurrentMonth(),
        '80_90': false,
        '90_100': false,
        gte100: false
    },
    service_desk: {
        month: $58ad8e28c2bf9311$var$getCurrentMonth(),
        '80_90': false,
        '90_100': false,
        gte100: false
    }
};
const $58ad8e28c2bf9311$export$e324594224ef24da = {
    dismissBanner: (cloudId, projectType, bannerType)=>async ({ setState: setState })=>{
            if (!cloudId || bannerType !== '80_90' && bannerType !== '90_100' && bannerType !== 'gte100') return;
            try {
                const localStorageProvider = $58ad8e28c2bf9311$export$5b435f40f36f752b(cloudId);
                const currentData = localStorageProvider.get((0, $27294eb882c7c50f$export$a9066c48870ddcc5)) || {
                    ...$58ad8e28c2bf9311$export$bce50709089bc65b
                };
                currentData[projectType][bannerType] = true;
                localStorageProvider.set((0, $27294eb882c7c50f$export$a9066c48870ddcc5), currentData);
                setState({
                    [projectType]: {
                        isDismissed: true,
                        height: 0
                    }
                });
            } catch (error) {
                setState({
                    [projectType]: {
                        isDismissed: true,
                        height: 0
                    }
                });
            }
        },
    checkDismissalState: (cloudId, projectType, bannerType)=>async ({ setState: setState })=>{
            setState({
                [projectType]: {
                    isLoading: true
                }
            });
            if (!cloudId || !bannerType || projectType !== 'software' && projectType !== 'service_desk') {
                setState({
                    [projectType]: {
                        isDismissed: true,
                        isLoading: false,
                        height: 0
                    }
                });
                return;
            }
            try {
                const localStorageProvider = $58ad8e28c2bf9311$export$5b435f40f36f752b(cloudId);
                const localStorageData = localStorageProvider.get((0, $27294eb882c7c50f$export$a9066c48870ddcc5));
                let productBannerDismissedStates;
                // reset state if it doesn't exist or it's expired
                if (!localStorageData || localStorageData[projectType]?.month !== $58ad8e28c2bf9311$var$getCurrentMonth()) {
                    productBannerDismissedStates = $58ad8e28c2bf9311$export$bce50709089bc65b[projectType];
                    localStorageProvider.set((0, $27294eb882c7c50f$export$a9066c48870ddcc5), {
                        ...$58ad8e28c2bf9311$export$bce50709089bc65b
                    });
                } else productBannerDismissedStates = localStorageData[projectType];
                const isDismissed = productBannerDismissedStates[bannerType] === true;
                setState({
                    [projectType]: {
                        isDismissed: isDismissed,
                        isLoading: false,
                        height: isDismissed ? 0 : (0, $27294eb882c7c50f$export$ed7cc0d417ee89e)
                    }
                });
            } catch (error) {
                setState({
                    [projectType]: {
                        isDismissed: false,
                        isLoading: false,
                        height: 0
                    }
                });
            }
        }
};
const $58ad8e28c2bf9311$var$Store = (0, $GtRbT.createStore)({
    name: 'AutomationLimitAwarenessBanner',
    initialState: $58ad8e28c2bf9311$export$d4c72bab9d6cc13a,
    actions: $58ad8e28c2bf9311$export$e324594224ef24da
});
const $58ad8e28c2bf9311$export$90e145919b624840 = (0, $iJq0l.createStateHook)($58ad8e28c2bf9311$var$Store);
const $58ad8e28c2bf9311$export$602681b371abcfed = (0, $iJq0l.createActionsHook)($58ad8e28c2bf9311$var$Store);

});
const $27294eb882c7c50f$export$a9066c48870ddcc5 = 'upsell_jira_global_automations_limit_banner';
const $27294eb882c7c50f$export$41956b146268af93 = 'AUTOMATION_LIMIT_AWARENESS';
const $27294eb882c7c50f$export$ed7cc0d417ee89e = 56;


parcelRegister("aofWR", function(module, exports) {
$parcel$export(module.exports, "convertTraitsToBannerType", () => $0ba425f43b8581f3$export$a8802aa133ba235b);
$parcel$export(module.exports, "useStandardAutomationLimitAwarenessExperiment", () => $0ba425f43b8581f3$export$e3859be76d81263c);
/* eslint-disable jira/ff/unsafe-no-exposure */ 
var $cxKOj = parcelRequire("cxKOj");

var $2emAF = parcelRequire("2emAF");

var $eJrcF = parcelRequire("eJrcF");

var $1L5N6 = parcelRequire("1L5N6");
const $0ba425f43b8581f3$var$jiraTrait = 'upsell_jsw_tenants_gte_80_percent_automation_usage';
const $0ba425f43b8581f3$var$jsmTrait = 'upsell_jsm_tenants_gte_80_percent_automation_usage';
const $0ba425f43b8581f3$var$jiraLimit = 1700;
const $0ba425f43b8581f3$var$jsmLimit = 5000;
const $0ba425f43b8581f3$var$getProductSpecificTrait = (siteTraitsData, productType)=>{
    return siteTraitsData && productType ? siteTraitsData.find((trait)=>{
        if (!trait) return;
        switch(productType){
            case 'software':
                return trait.name === $0ba425f43b8581f3$var$jiraTrait;
            case 'service_desk':
                return trait.name === $0ba425f43b8581f3$var$jsmTrait;
            default:
                return false;
        }
    }) : undefined;
};
const $0ba425f43b8581f3$export$a8802aa133ba235b = (limit, automationCount)=>{
    if (automationCount) {
        const percentage = automationCount / limit * 100;
        if (percentage >= 80 && percentage < 90) return '80_90';
        if (percentage >= 90 && percentage < 100) return '90_100';
        if (percentage >= 100) return 'gte100';
    }
    return undefined;
};
const $0ba425f43b8581f3$export$e3859be76d81263c = ()=>{
    const { isEligible: isEligible, projectType: projectType } = (0, $1L5N6.useBasicEligibilityCriteriaCheck)();
    const { data: siteTraitsData } = (0, $eJrcF.useResource)((0, $2emAF.fetchSiteTraitsResource));
    const [expConfig, fireStatsigExposure] = (0, $cxKOj.UNSAFE_noExposureExp)('upsell_jira_global_automations_limit_banner');
    const productTrait = $0ba425f43b8581f3$var$getProductSpecificTrait(siteTraitsData, projectType);
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const automationsLimit = projectType === 'software' ? $0ba425f43b8581f3$var$jiraLimit : $0ba425f43b8581f3$var$jsmLimit;
    const automationsUsedCount = productTrait?.value ? Number(productTrait?.value) : undefined;
    const bannerType = productTrait?.value ? $0ba425f43b8581f3$export$a8802aa133ba235b(automationsLimit, automationsUsedCount) : undefined;
    return {
        isEligible: isEligible,
        cohort: cohort,
        projectType: projectType,
        bannerType: bannerType,
        automationsUsedCount: automationsUsedCount,
        automationsLimit: automationsLimit,
        fireStatsigExposure: fireStatsigExposure
    };
};

});
parcelRegister("1L5N6", function(module, exports) {
$parcel$export(module.exports, "useBasicEligibilityCriteriaCheck", () => $c6807effd0a03872$export$1e8e626d62656418);

var $2aY2d = parcelRequire("2aY2d");

var $1BZ8a = parcelRequire("1BZ8a");

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");

var $FhXEJ = parcelRequire("FhXEJ");

var $8rGQ0 = parcelRequire("8rGQ0");

var $8Q6yE = parcelRequire("8Q6yE");
const $c6807effd0a03872$export$1e8e626d62656418 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const projectType = data?.projectType;
    const isEligibleProduct = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
    const application = projectType ? (0, $lBYgs.getApplicationForProject)(projectType) : null;
    const edition = application ? (0, $cblKs.getEdition)(application, appEditions) : null;
    const isStandard = edition === (0, $cblKs.STANDARD_EDITION);
    const productKey = projectType && (0, $FhXEJ.projectTypeToCanonicalId)(projectType);
    const isNotInTrial = productKey && productEntitlementDetails && productEntitlementDetails[productKey]?.trialEndTime === undefined;
    const isEligible = Boolean(isSiteAdmin && isEligibleProduct && isStandard && isNotInTrial);
    const validProjectType = projectType && [
        'software',
        'service_desk'
    ].includes(projectType) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
     ? projectType : undefined;
    return {
        isEligible: isEligible,
        projectType: validProjectType
    };
};

});




parcelRegister("7mXaF", function(module, exports) {
$parcel$export(module.exports, "BannerAnnouncementAsync", () => $579735ab5635c514$export$aa03f7909e0828ec);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $579735ab5635c514$var$BannerAnnouncement = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("5trik")).then((module)=>module.BannerAnnouncement), // eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
{
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/BannerAnnouncement.tsx"
});
const $579735ab5635c514$export$aa03f7909e0828ec = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-platform-ui-banners-announcement",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($579735ab5635c514$var$BannerAnnouncement, props));

});
parcelRegister("5trik", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g5Dm0").then(()=>parcelRequire('gBJum'));

});


parcelRegister("35T6Y", function(module, exports) {
$parcel$export(module.exports, "BannerTransitionAsync", () => $837d4f5a5fc37164$export$8bf182764b9d2eb8);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $837d4f5a5fc37164$var$BannerTransition = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("rlU5m")).then((module)=>module.BannerTransition), {
    moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
});
const $837d4f5a5fc37164$export$8bf182764b9d2eb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-banner-eoc-transition",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($837d4f5a5fc37164$var$BannerTransition, null));

});
parcelRegister("rlU5m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aGdjj").then(()=>parcelRequire('cgNt3'));

});


parcelRegister("2UuhW", function(module, exports) {
$parcel$export(module.exports, "MailExpiryBannerAsync", () => $1c954177add9c7b4$export$11a26ffa2d1b48ed);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $1c954177add9c7b4$var$LazyMailExpiryBanner = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("bZLEC")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
    moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
});
const $1c954177add9c7b4$export$11a26ffa2d1b48ed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "async-mail-expiry-banner",
        packageName: "jiraPlatformUiMailExpiryReminder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-mail-expiry-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c954177add9c7b4$var$LazyMailExpiryBanner, null)));

});
parcelRegister("bZLEC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e7iBs").then(()=>parcelRequire('8LFOm'));

});


parcelRegister("jMu4X", function(module, exports) {
$parcel$export(module.exports, "ReturnToMobileBanner", () => $8bba80be16bd93ae$export$81c4f1e869d5a87);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8bba80be16bd93ae$var$LazyReturnToMobileBanner = (0, $bQWwW.lazy)(()=>(parcelRequire("9wFQM")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
    moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/ReturnToMobileBanner.tsx"
});
const $8bba80be16bd93ae$export$81c4f1e869d5a87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-return-to-mobile-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bba80be16bd93ae$var$LazyReturnToMobileBanner, null));

});
parcelRegister("9wFQM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jTSmJ").then(()=>parcelRequire('1neYb'));

});


parcelRegister("95ud4", function(module, exports) {
$parcel$export(module.exports, "AsyncJpdBlueprintsFeedbackBanner", () => $6a449bfa810cea88$export$c5e759eda8f8f2da);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $7S3IX = parcelRequire("7S3IX");

const $6a449bfa810cea88$var$useEntrypoint = ()=>{
    const entryPointParams = (0, $eJOHy.useMemo)(()=>{
        return {};
    }, []);
    const hasLoadedEntrypoint = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $7S3IX.jpdBlueprintsFeedbackBannerEntryPoint), entryPointParams);
    if (!hasLoadedEntrypoint.current) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};
const $6a449bfa810cea88$export$c5e759eda8f8f2da = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $6a449bfa810cea88$var$useEntrypoint();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $b3867ac518e371e9$export$a07dab5608229ea3),
        packageName: (0, $b3867ac518e371e9$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {}
    });
};

});
parcelRegister("7S3IX", function(module, exports) {
$parcel$export(module.exports, "jpdBlueprintsFeedbackBannerEntryPoint", () => $0a60482e75f1a034$export$5774847a04bf514);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0a60482e75f1a034$export$5774847a04bf514 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("ih4eo")), {
        moduleId: "d580f53f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ih4eo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7lvtF").then(()=>parcelRequire('7C5UV'));

});



parcelRegister("lxKFg", function(module, exports) {
$parcel$export(module.exports, "AutomationLimitAwarenessBannerAsync", () => $a2ee9750c044f1f5$export$4e92366fe348a487);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

const $a2ee9750c044f1f5$export$7fb60303fc5d9ba5 = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("j0II6")).then((module)=>module.AutomationLimitAwarenessBanner), // eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
{
    ssr: true,
    moduleId: "./src/packages/growth/jira-standard-automation-limit-awareness-modal/src/ui/banner/banner.tsx"
});
const $a2ee9750c044f1f5$export$4e92366fe348a487 = ()=>{
    if ((0, $4cTDP.fg)('upsell_jira_global_automations_limit_banner_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-automation-limit-awareness-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a2ee9750c044f1f5$export$7fb60303fc5d9ba5, null));
};

});
parcelRegister("j0II6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bTVim").then(()=>parcelRequire('k7UXO'));

});


parcelRegister("khNDs", function(module, exports) {
$parcel$export(module.exports, "Cohort3BannerAsync", () => $544212cb5e12a371$export$c596c0a1bde2cc92);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $544212cb5e12a371$var$Cohort3Banner = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("1f5WO")).then((module)=>module.Cohort3CustomerBanner), // eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
{
    moduleId: "./src/packages/platform/ui/banners/eoc-cohort3-customers-banner/src/ui/banner/index.tsx"
});
const $544212cb5e12a371$export$c596c0a1bde2cc92 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-banner-eoc-cohort3-customers",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($544212cb5e12a371$var$Cohort3Banner, null));

});
parcelRegister("1f5WO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8YFnR").then(()=>parcelRequire('5ACVQ'));

});


parcelRegister("g5l4t", function(module, exports) {
$parcel$export(module.exports, "AsyncAutoUpgradeAvoidDeactivationBanner", () => $776a165e3e17c9da$export$660b98eca8147b9a);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");

var $2imLM = parcelRequire("2imLM");

var $4cTDP = parcelRequire("4cTDP");

const $776a165e3e17c9da$export$365ac904962ea58f = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jynet")).then((module)=>module.AutoUpgradeNotATrialBanner), // eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
{
    ssr: true,
    moduleId: "./src/packages/growth/jira-auto-upgrade-not-a-trial/src/ui/avoid-deactivation-banner/banner.tsx"
});
const $776a165e3e17c9da$export$660b98eca8147b9a = ()=>{
    if ((0, $4cTDP.fg)('auto_upgrade_not_a_trial_jira_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-auto-upgrade-not-a-trial-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($776a165e3e17c9da$export$365ac904962ea58f, null));
};
var $776a165e3e17c9da$export$2e2bcd8739ae039 = $776a165e3e17c9da$export$660b98eca8147b9a;

});
parcelRegister("jynet", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3di40").then(()=>parcelRequire('d2HAI'));

});




parcelRegister("ltfhl", function(module, exports) {
$parcel$export(module.exports, "GlobalComponents", () => $f67b539b3f61d14e$export$461c2ed3163c74ff);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $5vQ2T = parcelRequire("5vQ2T");

var $EzBXZ = parcelRequire("EzBXZ");


var $hih5V = parcelRequire("hih5V");

var $6dwgv = parcelRequire("6dwgv");

var $lOI8W = parcelRequire("lOI8W");

var $4Oene = parcelRequire("4Oene");
const $f67b539b3f61d14e$var$routeComponents = [];
const $f67b539b3f61d14e$var$RouteGlobalComponents = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6dwgv.renderGlobalComponents)(route.layout?.globalComponents || $f67b539b3f61d14e$var$routeComponents));
};
// This component is necessary to ensure that the error boundary picks up errors in the renderGlobalComponents function
const $f67b539b3f61d14e$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6dwgv.renderGlobalComponents)(sharedGlobalComponents));
const $f67b539b3f61d14e$export$461c2ed3163c74ff = /*#__PURE__*/ (0, $eJOHy.memo)(({ sharedGlobalComponents: sharedGlobalComponents })=>{
    const globalComponentsPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$fb9876ab4228d985), (0, $60d311439a302207$export$c20831be6f780cb5), (0, $60d311439a302207$export$398df1bca49f9884), true, true);
    }, []);
    /**
	 * !!! DO NOT ADD INDIVIDUAL COMPONENTS TO THIS FILE !!!
	 *
	 * They should be defined as part of the `sharedGlobalComponents` constant, or defined on the route
	 * definition `layout` key.
	 *
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/jira-shared-layout/README.md
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/README.md
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$c20831be6f780cb5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "shared-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f67b539b3f61d14e$var$SharedGlobalComponents, {
        sharedGlobalComponents: sharedGlobalComponents
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "route-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "route-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f67b539b3f61d14e$var$RouteGlobalComponents, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$398df1bca49f9884),
        onSet: globalComponentsPerformanceTiming
    }));
});

});
parcelRegister("4Oene", function(module, exports) {
$parcel$export(module.exports, "default", () => $18f4020e0393d087$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7aoMz = parcelRequire("7aoMz");

var $lfkxd = parcelRequire("lfkxd");

var $4cTDP = parcelRequire("4cTDP");

var $lf6Bt = parcelRequire("lf6Bt");
const $18f4020e0393d087$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $18f4020e0393d087$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $18f4020e0393d087$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $18f4020e0393d087$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $7aoMz.useInteractionContext)();
    const rllProfilerContext = (0, $eJOHy.useContext)((0, $lf6Bt.ProfilerContext));
    const relayProfilerContext = (0, $eJOHy.useContext)((0, $j4oe4.ProfilerContext));
    const newRllProfilerContext = (0, $eJOHy.useMemo)(()=>({
            current: $18f4020e0393d087$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $eJOHy.useMemo)(()=>$18f4020e0393d087$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $18f4020e0393d087$var$flowRight([
        $18f4020e0393d087$var$renderContextProviderIfNonNull((0, $j4oe4.ProfilerContext), newRelayProfilerContext),
        $18f4020e0393d087$var$renderContextProviderIfNonNull((0, $lf6Bt.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
}
function $18f4020e0393d087$export$2e2bcd8739ae039({ name: name, children: children }) {
    const nameWithUnderscores = (0, $4cTDP.fg)('jfp_fix_placeholder_name') ? name.replaceAll('/', '_') : name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfkxd.default), {
        name: nameWithUnderscores
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18f4020e0393d087$var$JiraUFOLabelWrapper, null, children));
}

});
parcelRegister("lfkxd", function(module, exports) {
$parcel$export(module.exports, "default", () => $59bcdab4948f2926$export$2e2bcd8739ae039);

var $dxAg1 = parcelRequire("dxAg1");
var $59bcdab4948f2926$export$2e2bcd8739ae039 = (0, $dxAg1.default);

});
parcelRegister("dxAg1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9e1cf510df590c5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");
function $e9e1cf510df590c5$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $7aoMz.useInteractionContext)();
    const newContext = (0, $eJOHy.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7aoMz.default).Provider, {
        value: newContext,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
}

});




parcelRegister("DrDtQ", function(module, exports) {
$parcel$export(module.exports, "GlobalContainers", () => $5db94805500b593d$export$3b677a7048d7ae0);

var $eJOHy = parcelRequire("eJOHy");

var $7PPRh = parcelRequire("7PPRh");

var $2I68T = parcelRequire("2I68T");

var $fakPW = parcelRequire("fakPW");

var $eK5AI = parcelRequire("eK5AI");

var $7lk3V = parcelRequire("7lk3V");

var $hWeHP = parcelRequire("hWeHP");

var $cbCSE = parcelRequire("cbCSE");


var $fEmyV = parcelRequire("fEmyV");

var $1gHmu = parcelRequire("1gHmu");

var $7lboZ = parcelRequire("7lboZ");

var $5HFSX = parcelRequire("5HFSX");

var $g9Vr6 = parcelRequire("g9Vr6");

var $lOI8W = parcelRequire("lOI8W");

var $koAZ4 = parcelRequire("koAZ4");

var $6bLlX = parcelRequire("6bLlX");

var $bJscI = parcelRequire("bJscI");

var $bskNA = parcelRequire("bskNA");

var $gzwmK = parcelRequire("gzwmK");

var $5PTRS = parcelRequire("5PTRS");

var $bea4o = parcelRequire("bea4o");

var $jFTjK = parcelRequire("jFTjK");

var $bDTmj = parcelRequire("bDTmj");

var $hxAu9 = parcelRequire("hxAu9");

var $2pOx9 = parcelRequire("2pOx9");

var $gOC9D = parcelRequire("gOC9D");
const $5db94805500b593d$var$MaybePreviewPanelsProvider = (0, $bJscI.componentWithFG)('jira-glance-panel', (0, $6bLlX.PreviewPanelsProvider), (0, $eJOHy.Fragment));
const $5db94805500b593d$var$EventHorizon = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
const $5db94805500b593d$export$3b677a7048d7ae0 = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, children: children, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const globalContainersPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$4f341d86a3c214), (0, $60d311439a302207$export$16e7ead3a8b5c366), (0, $60d311439a302207$export$c389f0b50840d5ca), true, true);
        (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$7048c99f32c60b34), (0, $60d311439a302207$export$3c2d8af5c7577fe7), (0, $60d311439a302207$export$aac77afee74c49d0), true, true);
    }, []);
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, #FFFFFF)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5PTRS.IntlProviders), {
        messages: messages,
        locale: locale
    }, __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $hWeHP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2I68T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lk3V.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fakPW.ViewExperienceTrackingProvider), {
        analyticsSource: (0, $60d311439a302207$export$c9e16a15d65437),
        experience: (0, $60d311439a302207$export$b1534bc11f201efd),
        experienceId: (0, $60d311439a302207$export$fa4bbc89fd1f1a7),
        application: (0, $60d311439a302207$export$aa6008fe0169b864),
        edition: (0, $60d311439a302207$export$39418a21fbb51487),
        additionalAttributes: (0, $fEmyV.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gzwmK.ErrorBoundary), {
        id: id,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$16e7ead3a8b5c366)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Router, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PPRh.default), {
        UNSAFE_isThemingDisabled: true,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$c389f0b50840d5ca)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bDTmj.PageConfigContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bea4o.MetricsContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HFSX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jFTjK.NavigationContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pOx9.UserContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hxAu9.UiManagers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$3c2d8af5c7577fe7)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeRouterListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5db94805500b593d$var$MaybePreviewPanelsProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gOC9D.LinkingProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bskNA.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$aac77afee74c49d0),
        onSet: globalContainersPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cbCSE.SidebarNav4ControllerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5db94805500b593d$var$EventHorizon, null, children)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lboZ.ScreenSpaceFlagsPlacement), null)))))))))))))));
});

});
parcelRegister("7PPRh", function(module, exports) {
$parcel$export(module.exports, "default", () => $861e7b4d52197f47$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iPpzL = parcelRequire("iPpzL");

var $kDoP2 = parcelRequire("kDoP2");
const $861e7b4d52197f47$var$InsideAppProviderContext = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $861e7b4d52197f47$var$AppProvider({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $eJOHy.useContext)($861e7b4d52197f47$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iPpzL.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($861e7b4d52197f47$var$InsideAppProviderContext.Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDoP2.default), {
            defaultColorMode: defaultColorMode,
            defaultTheme: defaultTheme,
            children: routerLinkProvider
        })
    });
}
var $861e7b4d52197f47$export$2e2bcd8739ae039 = $861e7b4d52197f47$var$AppProvider;

});

parcelRegister("fakPW", function(module, exports) {
$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $60f4a864d45647c7$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $60f4a864d45647c7$export$e0241c84ce5db240);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $6DllT = parcelRequire("6DllT");

var $1cD2y = parcelRequire("1cD2y");

var $04GBe = parcelRequire("04GBe");
const $60f4a864d45647c7$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04GBe.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$60f4a864d45647c7$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $60f4a864d45647c7$export$2e2bcd8739ae039 = $60f4a864d45647c7$export$a5efa46877be148f;
const $60f4a864d45647c7$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DllT.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04GBe.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$60f4a864d45647c7$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("04GBe", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fd0a0af92633c2f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $mjinE = parcelRequire("mjinE");


var $6DllT = parcelRequire("6DllT");
class $1fd0a0af92633c2f$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props), this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        }, this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        }, this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $f17fa9e5c82da056$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name,
                ...this.props?.additionalAttributes
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $mjinE.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DllT.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
const $f17fa9e5c82da056$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $f17fa9e5c82da056$export$b48b3d1872522384 = 'taskFail';
const $f17fa9e5c82da056$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("7lboZ", function(module, exports) {
$parcel$export(module.exports, "ScreenSpaceFlagsPlacement", () => $97dcf5616e9373e4$export$f6564e60882bdf90);

var $eJOHy = parcelRequire("eJOHy");

var $lphSw = parcelRequire("lphSw");

var $4cTDP = parcelRequire("4cTDP");

var $cSXp8 = parcelRequire("cSXp8");

var $7oY9g = parcelRequire("7oY9g");

var $lauxv = parcelRequire("lauxv");

var $jR9w7 = parcelRequire("jR9w7");


var $g321J = parcelRequire("g321J");
const $97dcf5616e9373e4$var$PLACEMENT_ID = 'screen-space-flags';
const $97dcf5616e9373e4$export$f6564e60882bdf90 = ()=>{
    const isRestrictedSynthetic = (0, $g321J.isRestrictedFromPostOfficeSynthetic)();
    const flagsService = (0, $cSXp8.useFlagsService)();
    const stablePlacementProps = (0, $eJOHy.useMemo)(()=>({
            jiraFlagsService: {
                dismissFlag: flagsService.dismissFlag,
                hasFlag: flagsService.hasFlag,
                showFlag: flagsService.showFlag
            }
        }), [
        flagsService?.dismissFlag,
        flagsService?.hasFlag,
        flagsService?.showFlag
    ]);
    if (false || (0, $7oY9g.default)((0, $c335d71b7e366e9d$export$37d4bb5bc0e315db)) || isRestrictedSynthetic) return null;
    return (0, $4cTDP.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jR9w7.ScreenSpaceFlagPlacementPreviewSwitcher), {
        // https://switcheroo.atlassian.com/ui/gates/8fe500fb-6c32-48c7-be3f-caf511e97a8e/key/post-office_enable_screen-space-preview_jfe
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lauxv.default), {
        placementId: $97dcf5616e9373e4$var$PLACEMENT_ID,
        PlacementComponent: (0, $lphSw.default),
        disableInitialData: true,
        placementProps: stablePlacementProps
    })) : null;
};

});
parcelRegister("lphSw", function(module, exports) {
$parcel$export(module.exports, "ScreenSpaceFlagsPlacementComponent", () => $22b0b6fb01ad6283$export$c60b43809441c5b0);
$parcel$export(module.exports, "default", () => $22b0b6fb01ad6283$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $59rsN = parcelRequire("59rsN");

var $bfNi1 = parcelRequire("bfNi1");
var $iJJ9P = parcelRequire("iJJ9P");
var $5V25X = parcelRequire("5V25X");

var $gr4vM = parcelRequire("gr4vM");

var $fT7M2 = parcelRequire("fT7M2");

var $iRBaU = parcelRequire("iRBaU");

var $cVnXt = parcelRequire("cVnXt");

var $fuwhX = parcelRequire("fuwhX");

var $dKDsR = parcelRequire("dKDsR");

var $hv66L = parcelRequire("hv66L");


var $fe9s6 = parcelRequire("fe9s6");
const $22b0b6fb01ad6283$export$c32237a999261c49 = (input)=>(0, $bfNi1.createMatchScopes)({
        scopes: $dKDsR.scopes
    })(input);
const $22b0b6fb01ad6283$export$963cdca6c7580c53 = [
    {
        messageTemplateId: 'confluence-nudge-for-jira',
        statsigExperiment: 'post-office_expt_confluence-nudge-for-jira',
        statsigAAExperiment: 'post-office_expt_confluence-nudge-for-jira_aa',
        statsigParameterName: 'cohort',
        statsigTestCohort: 'variation'
    },
    {
        messageTemplateId: 'confluence-inline-reactions-mcu-nudge',
        statsigExperiment: 'cc-engagement-convert-dwell-only-mcu-to-react-exp',
        statsigAAExperiment: 'cc-engagement-convert-dwell-only-mcu-exp_aa',
        statsigParameterName: 'cohort',
        statsigTestCohort: 'experiment'
    }
];
const $22b0b6fb01ad6283$export$c60b43809441c5b0 = (0, $fe9s6.withScreenSpaceFlagsIntlProvider)((0, $fT7M2.createPlacementComponent)((0, $4d026fb8097e5915$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $eJOHy.memo)(({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const [localMessageState, setLocalMessageState] = (0, $eJOHy.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? preloadedInitialData?.messages : undefined;
        return undefined;
    });
    const [localExternalMessageState, setLocalExternalMessageState] = (0, $eJOHy.useState)(undefined);
    (0, $cVnXt.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $iJJ9P.useMessagePlacementHooks)();
    const handleDismiss = (0, $eJOHy.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        setLocalMessageState((current)=>{
            if (current) {
                const newState = current.filter((e)=>e.messageInstanceId !== messageInstanceId);
                if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
                    messages: newState
                });
                return newState;
            }
            return undefined;
        });
    }, [
        setPreloadedInitialData
    ]);
    const onDismissed = (0, $eJOHy.useCallback)(()=>{
        setLocalMessageState([]);
        if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
            messages: []
        });
    }, [
        setPreloadedInitialData
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    const activeScopes = (0, $bfNi1.usePostOfficeContextScope)({
        scopes: $dKDsR.scopes,
        treatIntersectionAsSame: (0, $59rsN.default).checkGate('post-office-ssf-treat-intersection-as-same')
    });
    const messagesState = (0, $fuwhX.usePlacementApi)('/update-messages', {
        queryParams: {
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: (0, $59rsN.default).checkGate('post-office-ssf-enable-continuous-auto-refetch') ? !!activeScopes.updateKey && !localMessageState?.length : !!activeScopes.updateKey && typeof localMessageState === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) {
            const messages = messagesState.data.messages;
            let selectedMessage;
            // New experiments in the screen-space-flags placement must be added to the EXPERIMENTAL_MESSAGES list
            for (const message of messages){
                const experimentalMessage = $22b0b6fb01ad6283$export$963cdca6c7580c53.find((p)=>p.messageTemplateId === message.messageTemplateId);
                if (experimentalMessage) {
                    const cohort = (0, $59rsN.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                        fireExperimentExposure: true
                    });
                    if (experimentalMessage?.statsigAAExperiment) (0, $59rsN.default).getExperimentValue(experimentalMessage.statsigAAExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                        fireExperimentExposure: true
                    });
                    if (cohort === experimentalMessage.statsigTestCohort) {
                        selectedMessage = message;
                        break;
                    }
                } else {
                    selectedMessage = message;
                    break;
                }
            }
            setLocalMessageState(selectedMessage ? [
                selectedMessage
            ] : []);
        }
        if ((0, $59rsN.default).checkGate('post-office_enable_ep_external_message_proxy') && messagesState.data?.externalMessages?.length) setLocalExternalMessageState(messagesState.data.externalMessages);
    }, [
        messagesState.data
    ]);
    const isEPExternalMessageProxyEnabled = (0, $59rsN.default).checkGate('post-office_enable_ep_external_message_proxy');
    const { triggerStates: epTriggerStates, EpTriggerWrapper: EpTriggerWrapper } = $22b0b6fb01ad6283$var$useEpMigrationTriggers(isEPExternalMessageProxyEnabled ? localExternalMessageState : undefined);
    // find if an EP message has been triggered
    const activeEpMessageInstanceId = isEPExternalMessageProxyEnabled ? Object.keys(epTriggerStates).find((messageInstanceId)=>epTriggerStates[messageInstanceId] === true) : undefined;
    // Check for EP External messages first because they are not rendered until triggered from the front-end
    // and they will not be rendered if a non-ep message is currently rendered due to the choreographer
    const [currentLocalMessage] = localMessageState ?? [];
    const currentExternalMessage = localExternalMessageState?.find((msg)=>msg.messageInstanceId === activeEpMessageInstanceId);
    const activeExternalMessage = isEPExternalMessageProxyEnabled && activeEpMessageInstanceId ? currentExternalMessage : currentLocalMessage;
    const messageToRender = currentLocalMessage ?? activeExternalMessage;
    const content = (0, $59rsN.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $gt9Am.jsx)($22b0b6fb01ad6283$var$SuppressIfModalIsPresent, {
        children: messageToRender ? /*#__PURE__*/ (0, $eJOHy.createElement)((0, $hv66L.MessageRenderer), {
            ...messageToRender,
            key: messageToRender.messageInstanceId,
            id: messageToRender.messageInstanceId,
            messageInstanceId: messageToRender.messageInstanceId,
            onDismissed: onDismissed,
            SuspenseBoundary: (0, $iRBaU.MaybeSuspenseBoundary),
            jiraFlagsService: jiraFlagsService,
            onError: reportUnexpectedError,
            reportExpectedError: reportExpectedError
        }) : null
    }) : null;
    // Wrap content with trigger tracker components if feature gate is enabled
    return isEPExternalMessageProxyEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)(EpTriggerWrapper, {
        children: content
    }) : content;
}), {
    choreographer: {
        isDefaultEnabled: true
    }
}));
var $22b0b6fb01ad6283$export$2e2bcd8739ae039 = $22b0b6fb01ad6283$export$c60b43809441c5b0;
const $22b0b6fb01ad6283$var$SuppressIfModalIsPresent = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $eJOHy.useState)(true);
    const handleVisibilityChange = (0, $eJOHy.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $59rsN.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
// Component to track individual trigger states
// Each instance calls useTrigger independently, avoiding rules of hooks violations
const $22b0b6fb01ad6283$var$EpTriggerTracker = ({ messageInstanceId: messageInstanceId, epMessageId: epMessageId, onTriggerChange: onTriggerChange })=>{
    const { isActive: isActive } = (0, $5V25X.useTrigger)(epMessageId + '-start');
    const isActiveValue = isActive || false;
    (0, $eJOHy.useEffect)(()=>{
        onTriggerChange(messageInstanceId, isActiveValue);
    }, [
        messageInstanceId,
        isActiveValue,
        onTriggerChange
    ]);
    return null; // This component doesn't render anything
};
// This hook is used to track the state of EP External Message Triggers
// It returns an object with the message instance id as the key and the trigger state as the value
// The trigger state is true if the trigger is active, false otherwise
// The trigger state will only change to true when the trigger is set to active from the product front-end
const $22b0b6fb01ad6283$var$useEpMigrationTriggers = (messages)=>{
    const [triggerStates, setTriggerStates] = (0, $eJOHy.useState)({});
    // Get all ep-migration messages
    const epMessages = (0, $eJOHy.useMemo)(()=>messages?.filter((message)=>message.messageTemplateId === 'ep-migration-external-messages') || [], [
        messages
    ]);
    const handleTriggerChange = (0, $eJOHy.useCallback)((messageInstanceId, isActive)=>{
        setTriggerStates((prev)=>{
            // Only update if the value actually changed
            if (prev[messageInstanceId] === isActive) return prev;
            return {
                ...prev,
                [messageInstanceId]: isActive
            };
        });
    }, []);
    const EpTriggerWrapper = (0, $eJOHy.useMemo)(()=>({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    epMessages.map((message)=>{
                        const epMessageId = message.context?.epMessageId;
                        return epMessageId && typeof epMessageId === 'string' ? /*#__PURE__*/ (0, $gt9Am.jsx)($22b0b6fb01ad6283$var$EpTriggerTracker, {
                            messageInstanceId: message.messageInstanceId,
                            epMessageId: epMessageId,
                            onTriggerChange: handleTriggerChange
                        }, message.messageInstanceId) : null;
                    }),
                    children
                ]
            }), [
        epMessages,
        handleTriggerChange
    ]);
    return {
        triggerStates: triggerStates,
        EpTriggerWrapper: EpTriggerWrapper
    };
};

});
parcelRegister("bfNi1", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeContextScope", () => $87c8947e45ebc9a4$export$daf66a67c26dc848);
$parcel$export(module.exports, "createMatchScopes", () => $87c8947e45ebc9a4$export$ec890b48cae4cc1c);

var $eJOHy = parcelRequire("eJOHy");

var $bruOW = parcelRequire("bruOW");

var $b0rqo = parcelRequire("b0rqo");

var $eGOwo = parcelRequire("eGOwo");

var $6a4LK = parcelRequire("6a4LK");

var $lwEYg = parcelRequire("lwEYg");

var $72OLU = parcelRequire("72OLU");
const $87c8947e45ebc9a4$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $87c8947e45ebc9a4$export$daf66a67c26dc848 = (config)=>{
    const currentScopeNames = $87c8947e45ebc9a4$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $eJOHy.useCallback)((input)=>$87c8947e45ebc9a4$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentScopeNames
    ]);
    const [state, setState] = (0, $eJOHy.useState)($87c8947e45ebc9a4$var$initialState);
    const route = (0, $lwEYg.usePostOfficeRoute)();
    const context = (0, $6a4LK.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    const nextScopeNames = $87c8947e45ebc9a4$var$scopesNamesAsString(next);
    const updateKey = `${currentScopeNames}-${nextScopeNames}`;
    $87c8947e45ebc9a4$var$usePostOfficeScopeSpy(state, config);
    (0, $eJOHy.useEffect)(()=>{
        if ($87c8947e45ebc9a4$export$fcc046cb16c47539({
            next: next,
            state: state,
            treatIntersectionAsSame: config.treatIntersectionAsSame
        })) setState(({ current: current })=>({
                updateKey: (0, $eGOwo.fg)('po-scopes-update-use-simple-hash') ? (0, $b0rqo.simpleHash)(updateKey) : Math.random().toString(36).substring(2),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updateKey
    ]);
    return state;
};
const $87c8947e45ebc9a4$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $87c8947e45ebc9a4$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $87c8947e45ebc9a4$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $87c8947e45ebc9a4$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $87c8947e45ebc9a4$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname, search: search } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname,
        search: search
    };
};
const $87c8947e45ebc9a4$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($bruOW)))(contextMatch, inputMatch, (contextValue, inputValue)=>$87c8947e45ebc9a4$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $87c8947e45ebc9a4$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $87c8947e45ebc9a4$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $87c8947e45ebc9a4$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $87c8947e45ebc9a4$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $87c8947e45ebc9a4$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($87c8947e45ebc9a4$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $87c8947e45ebc9a4$export$fcc046cb16c47539 = ({ next: next, state: state, treatIntersectionAsSame: treatIntersectionAsSame })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (treatIntersectionAsSame) {
        if (currentSet.length !== 0 && nextSet.length === 0) return true;
    } else {
        if (currentSet.length !== nextSet.length) return true;
    }
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $87c8947e45ebc9a4$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $72OLU.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $eJOHy.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $87c8947e45ebc9a4$var$scopesNamesAsString(state.current)
    ]);
};

});
parcelRegister("bruOW", function(module, exports) {

var $8KEeP = parcelRequire("8KEeP");

var $kMuiR = parcelRequire("kMuiR");
/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $854a1facb4ffc478$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $8KEeP(object, source, $kMuiR(source), customizer);
}
module.exports = $854a1facb4ffc478$var$isMatchWith;

});

parcelRegister("b0rqo", function(module, exports) {
$parcel$export(module.exports, "simpleHash", () => $df62f53575625e35$export$b211ce59c0ea1cfb);
const $df62f53575625e35$export$b211ce59c0ea1cfb = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("dKDsR", function(module, exports) {
$parcel$export(module.exports, "scopes", () => $e6c3dbbdcf63b48e$export$54a06e3f4a159ad8);
const $e6c3dbbdcf63b48e$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'atlassian-apps'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'shadow-it-apps'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'app-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/pages',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-content',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/*/.*'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-space-settings',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.+?/settings(/.*)?$'
                }
            }
        }
    },
    {
        name: 'confluence/blogs',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/(?!.*/edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'list'
                }
            }
        }
    },
    {
        name: 'jira/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/global-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '/issues'
                },
                search: {
                    matches: '.*filter.*'
                }
            }
        }
    },
    {
        name: 'jira/issues-full-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        // Jira Plans timeline/list view
        name: 'jira/plan/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/timeline'
                }
            }
        }
    },
    {
        // Jira Plans calendar view
        name: 'jira/plan/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/calendar'
                }
            }
        }
    },
    {
        // Jira Plans program board
        name: 'jira/plan/program',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/program'
                }
            }
        }
    },
    {
        // Any pages within Jira Plan
        name: 'jira/plan',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'for-you'
                }
            }
        }
    },
    {
        name: 'jira/ops/alerts',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/integration',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/integrations/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/group-detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/group-detail'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/integration',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/integrations/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/heartbeats',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/heartbeats'
                }
            }
        }
    },
    {
        name: 'jira/for-you',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/for-you'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/list-detail-view',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*list.*'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/software/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        // Any project route in JSW
        name: 'jira/software/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JSW
        name: 'jira/software/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Any project route in JWM
        name: 'jira/business/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JWM
        name: 'jira/business/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Project directory
        name: 'jira/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/projects'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/.+?/list'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/project-summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        name: 'jira/software/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/[^/]+)?/projects/[^/]+/boards'
                }
            }
        }
    },
    {
        name: 'loom/all',
        when: {
            context: {
                product: 'loom'
            }
        }
    },
    {
        name: 'loom/home',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'home'
                }
            }
        }
    },
    {
        name: 'loom/looms/videos',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'looms/videos'
                }
            }
        }
    },
    {
        name: 'loom/meetings',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'meetings'
                }
            }
        }
    },
    {
        name: 'loom/notifications/all',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'notifications/all'
                }
            }
        }
    },
    {
        name: 'loom/watch-later',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'watch-later'
                }
            }
        }
    },
    {
        name: 'loom/history',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'history'
                }
            }
        }
    },
    {
        name: 'loom/settings/account',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/account'
                }
            }
        }
    },
    {
        name: 'loom/settings/workspace',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/workspace'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/cmp/project-settings/project-config/issuelayout',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/issuelayout'
                }
            }
        }
    },
    {
        name: 'studio/rovo-agents',
        when: {
            context: {
                product: 'studio'
            }
        }
    }
];

});

parcelRegister("hv66L", function(module, exports) {
$parcel$export(module.exports, "MessageRenderer", () => $070015c36a32a74d$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $iRBaU = parcelRequire("iRBaU");

var $h9SZm = parcelRequire("h9SZm");

var $kSp0d = parcelRequire("kSp0d");

var $cXrQl = parcelRequire("cXrQl");

var $7prhj = parcelRequire("7prhj");

var $1cZoY = parcelRequire("1cZoY");

var $a3qEe = parcelRequire("a3qEe");

var $7F1Vt = parcelRequire("7F1Vt");

var $iBbx6 = parcelRequire("iBbx6");

var $49F9o = parcelRequire("49F9o");

var $itrPh = parcelRequire("itrPh");

var $59yh3 = parcelRequire("59yh3");

var $7QCtw = parcelRequire("7QCtw");

var $9XXKW = parcelRequire("9XXKW");

var $2adcf = parcelRequire("2adcf");

var $8GBBH = parcelRequire("8GBBH");

var $4My6Z = parcelRequire("4My6Z");

var $hQa1j = parcelRequire("hQa1j");

var $1zLoR = parcelRequire("1zLoR");

var $6Db57 = parcelRequire("6Db57");

var $iucNR = parcelRequire("iucNR");

var $25FdX = parcelRequire("25FdX");

var $eFLsG = parcelRequire("eFLsG");

var $1HVho = parcelRequire("1HVho");

var $eVncn = parcelRequire("eVncn");

var $eYE53 = parcelRequire("eYE53");

var $dIFvg = parcelRequire("dIFvg");
const $070015c36a32a74d$export$e30378e28ad3e6ab = {
    ...(0, $h9SZm.default),
    ...(0, $kSp0d.default),
    ...(0, $cXrQl.default),
    ...(0, $7prhj.default),
    ...(0, $1cZoY.default),
    ...(0, $a3qEe.default),
    ...(0, $7F1Vt.default),
    ...(0, $iBbx6.default),
    ...(0, $49F9o.default),
    ...(0, $itrPh.default),
    ...(0, $59yh3.default),
    ...(0, $7QCtw.default),
    ...(0, $9XXKW.default),
    ...(0, $2adcf.default),
    ...(0, $8GBBH.default),
    ...(0, $4My6Z.default),
    ...(0, $hQa1j.default),
    ...(0, $1zLoR.default),
    ...(0, $6Db57.default),
    ...(0, $iucNR.default),
    ...(0, $25FdX.default),
    ...(0, $eFLsG.default),
    ...(0, $1HVho.default),
    ...(0, $eVncn.default),
    ...(0, $eYE53.default),
    ...(0, $dIFvg.default)
};
const { initializeMessageRenderer: $070015c36a32a74d$export$bce4e5106d86e473, MessageRenderer: $070015c36a32a74d$export$2df1250b8f917a59 } = (0, $iRBaU.asMessageRenderer)($070015c36a32a74d$export$e30378e28ad3e6ab);

});
parcelRegister("h9SZm", function(module, exports) {
$parcel$export(module.exports, "default", () => $617691417cfc4799$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $617691417cfc4799$export$2e2bcd8739ae039 = {
    'jira-ops-unified-view-revamp': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("au28N")))
};

});
parcelRegister("au28N", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bSqLh").then(()=>parcelRequire('8brzZ'));

});


parcelRegister("kSp0d", function(module, exports) {
$parcel$export(module.exports, "default", () => $287a434b8846d957$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $287a434b8846d957$export$2e2bcd8739ae039 = {
    'confluence-fast-and-snappy-survey': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("alCvG"))),
    'confluence-lovability-survey': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("b5qHf")))
};

});
parcelRegister("alCvG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("biyCl").then(()=>parcelRequire('84Vza'));

});

parcelRegister("b5qHf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("502QZ").then(()=>parcelRequire('cudcu'));

});


parcelRegister("cXrQl", function(module, exports) {
$parcel$export(module.exports, "default", () => $de5de75853af0244$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $de5de75853af0244$export$2e2bcd8739ae039 = {
    'confluence-inline-reactions-mau-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("is2eh"))),
    'confluence-inline-reactions-mcu-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("40OHE")))
};

});
parcelRegister("is2eh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9KCot").then(()=>parcelRequire('lfW1S'));

});

parcelRegister("40OHE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("chudj").then(()=>parcelRequire('8hlOJ'));

});


parcelRegister("7prhj", function(module, exports) {
$parcel$export(module.exports, "default", () => $43b0a4a998039c64$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $43b0a4a998039c64$export$2e2bcd8739ae039 = {
    'rovo-awareness-survey': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j1WCg")))
};

});
parcelRegister("j1WCg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("JdgC1").then(()=>parcelRequire('cdusb'));

});


parcelRegister("1cZoY", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6cb409d24e7d00a$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $b6cb409d24e7d00a$export$2e2bcd8739ae039 = {
    'commerce-subscription-auto-upgrade-no-payment-method-ccp': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f7j4o")))
};

});
parcelRegister("f7j4o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gOTEJ").then(()=>parcelRequire('jbgs6'));

});


parcelRegister("a3qEe", function(module, exports) {
$parcel$export(module.exports, "default", () => $892686208adac89d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $892686208adac89d$export$2e2bcd8739ae039 = {
    'cpq-user-feedback': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8ShCY")))
};

});
parcelRegister("8ShCY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9o7xf").then(()=>parcelRequire('aLW4m'));

});


parcelRegister("7F1Vt", function(module, exports) {
$parcel$export(module.exports, "default", () => $d57b0a66bcfea4d9$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");






var $d57b0a66bcfea4d9$export$2e2bcd8739ae039 = {
    'confluence-commented-on-page-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4tQmJ"))),
    'confluence-continue-reading-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cgk3r"))),
    'confluence-inline-reactions-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("auUpR"))),
    'confluence-mentioned-in-comment-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bxUMR"))),
    'confluence-mentioned-on-page-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5Bdk2"))),
    'confluence-nudge-for-jira': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5lqJE")))
};

});
parcelRegister("4tQmJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aBYqD").then(()=>parcelRequire('dgxSt'));

});

parcelRegister("cgk3r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("44HfO").then(()=>parcelRequire('b9lqV'));

});

parcelRegister("auUpR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ccEOP").then(()=>parcelRequire('786IU'));

});

parcelRegister("bxUMR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iB3nT").then(()=>parcelRequire('3toEu'));

});

parcelRegister("5Bdk2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a4ATO").then(()=>parcelRequire('i6a9a'));

});

parcelRegister("5lqJE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aTdlO").then(()=>parcelRequire('3Id2s'));

});


parcelRegister("iBbx6", function(module, exports) {
$parcel$export(module.exports, "default", () => $41c34413e734e3c0$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");







var $41c34413e734e3c0$export$2e2bcd8739ae039 = {
    'ep-migration-inapp-2131': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5vUPv"))),
    'ep-migration-inapp-2270': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("d5Ck5"))),
    'ep-migration-inapp-2271': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9oKoh"))),
    'ep-migration-inapp-3280': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kmtL0"))),
    'ep-migration-inapp-3282': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7I1w9"))),
    'starburst-screen-space-flags-twc-welcome-modal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dnMLF"))),
    'twc-xflow-modal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kuOzQ")))
};

});
parcelRegister("5vUPv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2d8bz").then(()=>parcelRequire('cztee'));

});

parcelRegister("d5Ck5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aWLQL").then(()=>parcelRequire('CgSs1'));

});

parcelRegister("9oKoh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iH1oz").then(()=>parcelRequire('lti6p'));

});

parcelRegister("kmtL0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c72S8").then(()=>parcelRequire('74Yv6'));

});

parcelRegister("7I1w9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hTXkx").then(()=>parcelRequire('dtCyq'));

});

parcelRegister("dnMLF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("edF8y").then(()=>parcelRequire('i6OLs'));

});

parcelRegister("kuOzQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("433Iu").then(()=>parcelRequire('6NfPG'));

});


parcelRegister("49F9o", function(module, exports) {
$parcel$export(module.exports, "default", () => $81ae9a8d7d86bad5$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $81ae9a8d7d86bad5$export$2e2bcd8739ae039 = {
    'jira-plan-add-user-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cVcVD"))),
    'jira-plans-efa-change-boarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9lsjA")))
};

});
parcelRegister("cVcVD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ojnt").then(()=>parcelRequire('eU1pr'));

});

parcelRegister("9lsjA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5DNSd").then(()=>parcelRequire('74wMe'));

});


parcelRegister("itrPh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1769f72303914123$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $1769f72303914123$export$2e2bcd8739ae039 = {
    'jira-board-inline-editing-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1G5Qs")))
};

});
parcelRegister("1G5Qs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("793gC").then(()=>parcelRequire('lXlqf'));

});


parcelRegister("59yh3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b9341d670b39992$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $6b9341d670b39992$export$2e2bcd8739ae039 = {
    'jira-issueview-status': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8Rzlo")))
};

});
parcelRegister("8Rzlo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("VyTfa").then(()=>parcelRequire('9t16h'));

});


parcelRegister("7QCtw", function(module, exports) {
$parcel$export(module.exports, "default", () => $29b2fcceae6cba09$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $29b2fcceae6cba09$export$2e2bcd8739ae039 = {
    'jira-list-conditional-formatting': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eMLAm"))),
    'jira-nin-grid-navigation-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iZGBB")))
};

});
parcelRegister("eMLAm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("idTe8").then(()=>parcelRequire('fO9ZU'));

});

parcelRegister("iZGBB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("68ZMC").then(()=>parcelRequire('3qBAn'));

});


parcelRegister("9XXKW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec8129afcdd83ad0$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $ec8129afcdd83ad0$export$2e2bcd8739ae039 = {
    'jira-access-page-contact-sales-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hAVD5"))),
    'jira-onboarding-hub-welcome-modal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fhP8l")))
};

});
parcelRegister("hAVD5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fp083").then(()=>parcelRequire('61OeS'));

});

parcelRegister("fhP8l", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("8DPN8")
]).then(()=>parcelRequire('9FliJ'));

});


parcelRegister("2adcf", function(module, exports) {
$parcel$export(module.exports, "default", () => $d18a9b3ffeb8f24e$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $d18a9b3ffeb8f24e$export$2e2bcd8739ae039 = {
    'jira-project-term-refresh-changeboarding-flag': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lKx2t"))),
    'ptr-changeboarding-space-navigation-spotlight': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7fkKc")))
};

});
parcelRegister("lKx2t", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ktWpd").then(()=>parcelRequire('1W0jl'));

});

parcelRegister("7fkKc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8Npl5").then(()=>parcelRequire('9V8Ld'));

});


parcelRegister("8GBBH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cac576ac96bafe3$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");





var $3cac576ac96bafe3$export$2e2bcd8739ae039 = {
    'jira-forms-conditional-fields-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4WimW"))),
    'jira-forms-public-forms-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("Kmuy1"))),
    'jira-forms-public-forms-changeboarding-flag': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dWuBM"))),
    'jira-in-context-config-sidebar-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("drKlJ"))),
    'jira-software-cmp-currency-field-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4A0ha")))
};

});
parcelRegister("4WimW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7LHhn").then(()=>parcelRequire('iDj6c'));

});

parcelRegister("Kmuy1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("19CSn").then(()=>parcelRequire('d9LED'));

});

parcelRegister("dWuBM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("72vCF").then(()=>parcelRequire('g4C2O'));

});

parcelRegister("drKlJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aR0eP").then(()=>parcelRequire('4DSvP'));

});

parcelRegister("4A0ha", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gXaoF").then(()=>parcelRequire('56WVQ'));

});


parcelRegister("4My6Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc405a9b9a7b2879$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $fc405a9b9a7b2879$export$2e2bcd8739ae039 = {
    'jira-issueview-layouts': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hI0Bq")))
};

});
parcelRegister("hI0Bq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ZA5z").then(()=>parcelRequire('lhFAg'));

});


parcelRegister("hQa1j", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cff040c9e28f105$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $2cff040c9e28f105$export$2e2bcd8739ae039 = {
    'frozen-columns-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aYAXI"))),
    'jira-nin-group-by-any-field-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("18wqM")))
};

});
parcelRegister("aYAXI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("p2kB9").then(()=>parcelRequire('3ttPY'));

});

parcelRegister("18wqM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5rqCJ").then(()=>parcelRequire('5TzXI'));

});


parcelRegister("1zLoR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7519b0e161f3cde9$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $7519b0e161f3cde9$export$2e2bcd8739ae039 = {
    'jsm-project-summary-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("idv5x")))
};

});
parcelRegister("idv5x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5nn7A").then(()=>parcelRequire('g9psZ'));

});


parcelRegister("6Db57", function(module, exports) {
$parcel$export(module.exports, "default", () => $f18255a83e56db80$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $f18255a83e56db80$export$2e2bcd8739ae039 = {
    'welcome-to-premium-flag': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("h0cJ7")))
};

});
parcelRegister("h0cJ7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iKYLW").then(()=>parcelRequire('4kZpc'));

});


parcelRegister("iucNR", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dc191ae8448ab07$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $9dc191ae8448ab07$export$2e2bcd8739ae039 = {
    'marketing-screen-space-flag-contentful-usecase': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c0Znd")))
};

});
parcelRegister("c0Znd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("64e3x").then(()=>parcelRequire('lsAsU'));

});


parcelRegister("25FdX", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d4db4d89c853901$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $0d4db4d89c853901$export$2e2bcd8739ae039 = {
    'mercury-edit-hierarchy-spotlight': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ivrXy")))
};

});
parcelRegister("ivrXy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jq2kJ").then(()=>parcelRequire('bn4UH'));

});


parcelRegister("eFLsG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f2b2848ad89820d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $5f2b2848ad89820d$export$2e2bcd8739ae039 = {
    'end-of-trial-extension': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2gz4p")))
};

});
parcelRegister("2gz4p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2xU5R").then(()=>parcelRequire('2OSP3'));

});


parcelRegister("1HVho", function(module, exports) {
$parcel$export(module.exports, "default", () => $5185b87a5ec6e592$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");




var $5185b87a5ec6e592$export$2e2bcd8739ae039 = {
    'confluence-3p-connector-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jMFC5"))),
    'ep-migration-external-messages': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6flzk"))),
    'jira-messaging-research-recruitment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hMqxn"))),
    'test-screen-space-flags-message': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2n9Dq")))
};

});
parcelRegister("jMFC5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9iEVE").then(()=>parcelRequire('jrESL'));

});

parcelRegister("6flzk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1eks3").then(()=>parcelRequire('69093'));

});

parcelRegister("hMqxn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bcujh").then(()=>parcelRequire('4QkEr'));

});

parcelRegister("2n9Dq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("45D2k").then(()=>parcelRequire('eWraG'));

});


parcelRegister("eVncn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d0f9f36509ba91a$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $1d0f9f36509ba91a$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jcZ2T")))
};

});
parcelRegister("jcZ2T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gHixD").then(()=>parcelRequire('6rSut'));

});


parcelRegister("eYE53", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4d3e9a68f30ddbf$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $d4d3e9a68f30ddbf$export$2e2bcd8739ae039 = {
    'rovo-agents-scenario-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5GQXE")))
};

});
parcelRegister("5GQXE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hAY2w").then(()=>parcelRequire('6rUpt'));

});


parcelRegister("dIFvg", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8d30cbfb2de1d27$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");




var $b8d30cbfb2de1d27$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("llSJq"))),
    'test-message-inapp-ep-modal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dnw3u"))),
    'test-message-inapp-implicit-pendo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jbcm2"))),
    'test-message-tap-ingestion-trigger-subscription': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2fBG3")))
};

});
parcelRegister("llSJq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1lhzn").then(()=>parcelRequire('gxLxy'));

});

parcelRegister("dnw3u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g5le5").then(()=>parcelRequire('ateGE'));

});

parcelRegister("jbcm2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1g0NO").then(()=>parcelRequire('6Q31y'));

});

parcelRegister("2fBG3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2BYQO").then(()=>parcelRequire('d0tEQ'));

});



/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $4d026fb8097e5915$export$a5cfae247d8360ef = 'screen-space-flags';

parcelRegister("fe9s6", function(module, exports) {
$parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", () => $71919df795329130$export$b0eee5de066b2bf5);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $buEZY = parcelRequire("buEZY");

var $8pUTW = parcelRequire("8pUTW");

var $e05rQ = parcelRequire("e05rQ");

var $tbjMW = parcelRequire("tbjMW");

var $bkMlG = parcelRequire("bkMlG");

var $8awEZ = parcelRequire("8awEZ");

var $3z44W = parcelRequire("3z44W");

var $eBPSW = parcelRequire("eBPSW");

var $bhgoe = parcelRequire("bhgoe");

var $cOVNc = parcelRequire("cOVNc");

var $41DG5 = parcelRequire("41DG5");

var $5w6rh = parcelRequire("5w6rh");

var $ekS74 = parcelRequire("ekS74");

var $ePSan = parcelRequire("ePSan");

var $7R4Wz = parcelRequire("7R4Wz");

var $cf3Ol = parcelRequire("cf3Ol");

var $ap0QV = parcelRequire("ap0QV");

var $cW2FJ = parcelRequire("cW2FJ");

var $9msAs = parcelRequire("9msAs");

var $lkbzt = parcelRequire("lkbzt");

var $dwK7W = parcelRequire("dwK7W");

var $a79Tq = parcelRequire("a79Tq");

var $3AZmi = parcelRequire("3AZmi");

var $g4GMj = parcelRequire("g4GMj");

var $5eiiO = parcelRequire("5eiiO");

var $eecBW = parcelRequire("eecBW");

var $7xVLr = parcelRequire("7xVLr");
const $71919df795329130$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $8pUTW.messagesLoader)(locale),
        (0, $e05rQ.messagesLoader)(locale),
        (0, $tbjMW.messagesLoader)(locale),
        (0, $bkMlG.messagesLoader)(locale),
        (0, $8awEZ.messagesLoader)(locale),
        (0, $3z44W.messagesLoader)(locale),
        (0, $eBPSW.messagesLoader)(locale),
        (0, $bhgoe.messagesLoader)(locale),
        (0, $cOVNc.messagesLoader)(locale),
        (0, $41DG5.messagesLoader)(locale),
        (0, $5w6rh.messagesLoader)(locale),
        (0, $ekS74.messagesLoader)(locale),
        (0, $ePSan.messagesLoader)(locale),
        (0, $7R4Wz.messagesLoader)(locale),
        (0, $cf3Ol.messagesLoader)(locale),
        (0, $ap0QV.messagesLoader)(locale),
        (0, $cW2FJ.messagesLoader)(locale),
        (0, $9msAs.messagesLoader)(locale),
        (0, $lkbzt.messagesLoader)(locale),
        (0, $dwK7W.messagesLoader)(locale),
        (0, $a79Tq.messagesLoader)(locale),
        (0, $3AZmi.messagesLoader)(locale),
        (0, $g4GMj.messagesLoader)(locale),
        (0, $5eiiO.messagesLoader)(locale),
        (0, $eecBW.messagesLoader)(locale),
        (0, $7xVLr.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $71919df795329130$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $buEZY.withIntlProvider)({
        messagesLoader: $71919df795329130$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("8pUTW", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $7f9c3df450cd3438$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jUaZY = parcelRequire("jUaZY");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7f9c3df450cd3438$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7f9c3df450cd3438$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("fpfEP")));
        case 'da':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("2I6LD")));
        case 'de':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("69h4L")));
        case 'en-GB':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("fp4mH")));
        case 'en-US':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("9ZhRW")));
        case 'en-XA':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("fUxxz")));
        case 'en-XB':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("5jAKY")));
        case 'en-ZZ':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("4mSo5")));
        case 'en':
            return $7f9c3df450cd3438$var$importHelper(await Promise.resolve((parcelRequire("jUaZY"))));
        case 'es':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("OyPc2")));
        case 'et':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("bHjXe")));
        case 'fi':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("evqGe")));
        case 'fr':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("8YtEb")));
        case 'hr':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("hJAk1")));
        case 'hu':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("6Zzf3")));
        case 'it':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("944Z9")));
        case 'ja':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("7kQI3")));
        case 'ko':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("kECh9")));
        case 'nb':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("nmqOK")));
        case 'nl':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("5BJu3")));
        case 'pl':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("kyAiS")));
        case 'pt-BR':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("7I7RI")));
        case 'ro':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("mtugJ")));
        case 'ru':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("6CHeQ")));
        case 'sl':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("29BWS")));
        case 'sr-RS':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("7OWgc")));
        case 'sr-YR':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("dtQ3Y")));
        case 'sr':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("6lqdW")));
        case 'sv':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("hMZMt")));
        case 'th':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("bmXuW")));
        case 'tr':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("6GyfB")));
        case 'uk':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("epIVP")));
        case 'vi':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("8ygYz")));
        case 'zh-CN':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("j3uF8")));
        case 'zh-TW':
            return $7f9c3df450cd3438$var$importHelper(await (parcelRequire("1VNcD")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jUaZY));
    }
};

});
parcelRegister("jUaZY", function(module, exports) {
module.exports = JSON.parse("{\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.body\":[{\"type\":0,\"value\":\"Expand to quickly view all alerts in the group.\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.title\":[{\"type\":0,\"value\":\"View grouped alerts\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.body\":[{\"type\":0,\"value\":\"Rovo helps you classify your alerts as signal or noise so you can focus on what matters most.\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.title\":[{\"type\":0,\"value\":\"Triage alerts faster\"}],\"jira-ops-unified-view-revamp.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-ops-unified-view-revamp.spotlight.go-back\":[{\"type\":0,\"value\":\"Go back\"}],\"jira-ops-unified-view-revamp.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-ops-unified-view-revamp.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}]}");

});

parcelRegister("fpfEP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1TgGg").then(()=>parcelRequire('ePHA7'));

});

parcelRegister("2I6LD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8viSX").then(()=>parcelRequire('1vNAm'));

});

parcelRegister("69h4L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a3bTr").then(()=>parcelRequire('3GVQ5'));

});

parcelRegister("fp4mH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jPCc0").then(()=>parcelRequire('i5pZi'));

});

parcelRegister("9ZhRW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bEmJF").then(()=>parcelRequire('aShTy'));

});

parcelRegister("fUxxz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cy8kO").then(()=>parcelRequire('448Uu'));

});

parcelRegister("5jAKY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e7Cip").then(()=>parcelRequire('2lNkg'));

});

parcelRegister("4mSo5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8P3og").then(()=>parcelRequire('95d5o'));

});

parcelRegister("OyPc2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gsmU3").then(()=>parcelRequire('c6YuO'));

});

parcelRegister("bHjXe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("am034").then(()=>parcelRequire('370nS'));

});

parcelRegister("evqGe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4D4MJ").then(()=>parcelRequire('bucBf'));

});

parcelRegister("8YtEb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aUfX6").then(()=>parcelRequire('4TUmR'));

});

parcelRegister("hJAk1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("40PSN").then(()=>parcelRequire('fdrDa'));

});

parcelRegister("6Zzf3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2lGDt").then(()=>parcelRequire('4DVzy'));

});

parcelRegister("944Z9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6xFYf").then(()=>parcelRequire('cLrRd'));

});

parcelRegister("7kQI3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("65zpK").then(()=>parcelRequire('ltcar'));

});

parcelRegister("kECh9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2wrfo").then(()=>parcelRequire('dqjML'));

});

parcelRegister("nmqOK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5gBLO").then(()=>parcelRequire('IcBtj'));

});

parcelRegister("5BJu3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kzUky").then(()=>parcelRequire('1rMo0'));

});

parcelRegister("kyAiS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aEIRL").then(()=>parcelRequire('5DcAn'));

});

parcelRegister("7I7RI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1aY8e").then(()=>parcelRequire('8gkVf'));

});

parcelRegister("mtugJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5oQdF").then(()=>parcelRequire('2YfJN'));

});

parcelRegister("6CHeQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("46F9y").then(()=>parcelRequire('gpPTi'));

});

parcelRegister("29BWS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6JmR4").then(()=>parcelRequire('9rynJ'));

});

parcelRegister("7OWgc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6vjCL").then(()=>parcelRequire('dPV1h'));

});

parcelRegister("dtQ3Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aKPRl").then(()=>parcelRequire('lahHp'));

});

parcelRegister("6lqdW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8aCmK").then(()=>parcelRequire('lLQGg'));

});

parcelRegister("hMZMt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jjxum").then(()=>parcelRequire('b0xxc'));

});

parcelRegister("bmXuW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("tafv0").then(()=>parcelRequire('izRDD'));

});

parcelRegister("6GyfB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fbEZS").then(()=>parcelRequire('5vD7r'));

});

parcelRegister("epIVP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4hEoh").then(()=>parcelRequire('6zTTo'));

});

parcelRegister("8ygYz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6yhOI").then(()=>parcelRequire('9ubgT'));

});

parcelRegister("j3uF8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hJ4H6").then(()=>parcelRequire('2BECp'));

});

parcelRegister("1VNcD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4VBdX").then(()=>parcelRequire('1u2wJ'));

});


parcelRegister("e05rQ", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $76692ab878ff92a1$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $tmN8t = parcelRequire("tmN8t");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $76692ab878ff92a1$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $76692ab878ff92a1$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("HC7RB")));
        case 'da':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("25rkF")));
        case 'de':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("ibtyi")));
        case 'en-GB':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("QSaJ6")));
        case 'en-US':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("iwnTR")));
        case 'en-XA':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("19El8")));
        case 'en-XB':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("j8YJK")));
        case 'en-ZZ':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("4szyj")));
        case 'en':
            return $76692ab878ff92a1$var$importHelper(await Promise.resolve((parcelRequire("tmN8t"))));
        case 'es':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("4qs7U")));
        case 'et':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("4WhEH")));
        case 'fi':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("id8eb")));
        case 'fr':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("bKO1p")));
        case 'hr':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("dUArY")));
        case 'hu':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("7sfD6")));
        case 'it':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("3fm14")));
        case 'ja':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("bznB3")));
        case 'ko':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("2COiK")));
        case 'nb':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("9aRqh")));
        case 'nl':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("4jEZ6")));
        case 'pl':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("i6Et8")));
        case 'pt-BR':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("caeMk")));
        case 'ro':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("2IFmX")));
        case 'ru':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("4Eh3a")));
        case 'sl':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("c5z61")));
        case 'sr-RS':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("kZDqN")));
        case 'sr-YR':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("4nwpp")));
        case 'sr':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("6eCg1")));
        case 'sv':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("b6CFN")));
        case 'th':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("eFDqO")));
        case 'tr':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("jqWZv")));
        case 'uk':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("1ry1q")));
        case 'vi':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("l7YSY")));
        case 'zh-CN':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("dt7Oq")));
        case 'zh-TW':
            return $76692ab878ff92a1$var$importHelper(await (parcelRequire("9MYXY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($tmN8t));
    }
};

});
parcelRegister("tmN8t", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.button-text":[{"type":0,"value":"Create meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.description":[{"type":0,"value":"Share goals, set context, and save time with a meeting notes template."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header":[{"type":0,"value":"Keep meetings aligned and actionable"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header-image.alt-text":[{"type":0,"value":"Atlassian Confluence logo"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.main-image.alt-text":[{"type":0,"value":"Meeting notes illustration showing document with highlighted content"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-image.alt-text":[{"type":0,"value":"Meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-text":[{"type":0,"value":"Meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.unsubscribe-link-text":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or unsubscribe "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"a"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.message-template.email.subject":[{"type":0,"value":"Save time with a Confluence meeting notes template"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part1":[{"type":0,"value":"Your teammates are using Confluence to share project context, capture decisions, and more in "},{"type":1,"value":"projectName"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part2":[{"type":0,"value":"Here\'s what they\'ve recently linked to your Jira project:"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.email.subject":[{"type":0,"value":"Your team in "},{"type":1,"value":"projectName"},{"type":0,"value":" is using Confluence for project docs--see what they\u2019ve added"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.button-cta":[{"type":0,"value":"Open Confluence"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.signoff":[{"type":0,"value":"See what else is happening across your company:"}],"confluence-reminder.cta.button":[{"type":0,"value":"Accept invite"}],"confluence-reminder.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"confluence-reminder.email.subject":[{"type":0,"value":"Reminder: "},{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to collaborate in Confluence"}],"confluence-reminder.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"confluence-reminder.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"confluence-reminder.inviter.avatar.alt":[{"type":0,"value":"Profile photo of "},{"type":1,"value":"inviterName"}],"confluence-reminder.main.heading":[{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to join Confluence"}],"confluence-reminder.product.description":[{"type":0,"value":"Plan projects, run meetings, and brainstorm ideas with your team\u2014all in one place."}],"confluence-reminder.redacted.heading":[{"type":0,"value":"Reminder: Join your team in Confluence"}],"confluence-reminder.redacted.subject":[{"type":0,"value":"Reminder: Join your team in Confluence"}],"confluence-reminder.social-proof.text":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":" customers use "},{"type":1,"value":"productName"},{"type":0,"value":" to move work forward"}],"confluence.fastAndSnappy.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.fastAndSnappy.survey.statement":[{"type":0,"value":"Confluence feels fast and snappy."}],"confluence.lovability.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.lovability.survey.statement":[{"type":0,"value":"Confluence is a product I love using."}],"post-office-team.confluence-reactivate-inactive-link-paste-in-jira-email.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}]}');

});

parcelRegister("HC7RB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7EvFz").then(()=>parcelRequire('9IgL1'));

});

parcelRegister("25rkF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cS2Qc").then(()=>parcelRequire('hqUeA'));

});

parcelRegister("ibtyi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l5mfE").then(()=>parcelRequire('43zeb'));

});

parcelRegister("QSaJ6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7AOpi").then(()=>parcelRequire('f2H9Y'));

});

parcelRegister("iwnTR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("etDR2").then(()=>parcelRequire('lAzw2'));

});

parcelRegister("19El8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("59WAv").then(()=>parcelRequire('cwu9F'));

});

parcelRegister("j8YJK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2EH1Q").then(()=>parcelRequire('aVc4f'));

});

parcelRegister("4szyj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dU1a8").then(()=>parcelRequire('1twF2'));

});

parcelRegister("4qs7U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bsnnn").then(()=>parcelRequire('eKy3s'));

});

parcelRegister("4WhEH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gz4V7").then(()=>parcelRequire('lQ0xm'));

});

parcelRegister("id8eb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3k7Xl").then(()=>parcelRequire('7TyPQ'));

});

parcelRegister("bKO1p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6vQht").then(()=>parcelRequire('5xGJU'));

});

parcelRegister("dUArY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d7nnt").then(()=>parcelRequire('brSVh'));

});

parcelRegister("7sfD6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5VPlL").then(()=>parcelRequire('f5xPm'));

});

parcelRegister("3fm14", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jk8fF").then(()=>parcelRequire('dh5hf'));

});

parcelRegister("bznB3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g6jVO").then(()=>parcelRequire('b5vXe'));

});

parcelRegister("2COiK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5jTsN").then(()=>parcelRequire('iI2wy'));

});

parcelRegister("9aRqh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b50pw").then(()=>parcelRequire('bMv8t'));

});

parcelRegister("4jEZ6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8kDgw").then(()=>parcelRequire('ai6mL'));

});

parcelRegister("i6Et8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fPSoZ").then(()=>parcelRequire('j32SQ'));

});

parcelRegister("caeMk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9SALx").then(()=>parcelRequire('fSTyW'));

});

parcelRegister("2IFmX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8f19I").then(()=>parcelRequire('bVxF3'));

});

parcelRegister("4Eh3a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iIJzF").then(()=>parcelRequire('lbe7B'));

});

parcelRegister("c5z61", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4zd0L").then(()=>parcelRequire('9CXkG'));

});

parcelRegister("kZDqN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lqpfq").then(()=>parcelRequire('iXgCK'));

});

parcelRegister("4nwpp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4QCvQ").then(()=>parcelRequire('2KBQE'));

});

parcelRegister("6eCg1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gKrx9").then(()=>parcelRequire('1oOVg'));

});

parcelRegister("b6CFN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9TQXS").then(()=>parcelRequire('ftRur'));

});

parcelRegister("eFDqO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5p8Up").then(()=>parcelRequire('iYtwG'));

});

parcelRegister("jqWZv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iJhxv").then(()=>parcelRequire('iHGW7'));

});

parcelRegister("1ry1q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1i2PA").then(()=>parcelRequire('ba1jU'));

});

parcelRegister("l7YSY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ketVE").then(()=>parcelRequire('kotdS'));

});

parcelRegister("dt7Oq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7HO6c").then(()=>parcelRequire('3JAdQ'));

});

parcelRegister("9MYXY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fz6If").then(()=>parcelRequire('gSLfa'));

});


parcelRegister("tbjMW", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $3cbe050fdda00a0c$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2qINc = parcelRequire("2qINc");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3cbe050fdda00a0c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3cbe050fdda00a0c$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("26TpO")));
        case 'da':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("1NVIu")));
        case 'de':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("cAwrd")));
        case 'en-GB':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("aVa9h")));
        case 'en-US':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("7z6sg")));
        case 'en-XA':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("4bcdk")));
        case 'en-XB':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("lKjDh")));
        case 'en-ZZ':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("4pafy")));
        case 'en':
            return $3cbe050fdda00a0c$var$importHelper(await Promise.resolve((parcelRequire("2qINc"))));
        case 'es':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("1mF0P")));
        case 'et':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("eHHRR")));
        case 'fi':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("1SnAW")));
        case 'fr':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("cKwcL")));
        case 'hr':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("gdqFY")));
        case 'hu':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("i6bjR")));
        case 'it':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("jchIs")));
        case 'ja':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("49bxY")));
        case 'ko':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("a6K0q")));
        case 'nb':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("cCvt8")));
        case 'nl':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("iFiFQ")));
        case 'pl':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("lTMgx")));
        case 'pt-BR':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("9EmNn")));
        case 'ro':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("7JUn7")));
        case 'ru':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("18oP2")));
        case 'sl':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("6ZtXy")));
        case 'sr-RS':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("1DYVj")));
        case 'sr-YR':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("i7vsI")));
        case 'sr':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("bDRur")));
        case 'sv':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("bd9Sv")));
        case 'th':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("dLaQf")));
        case 'tr':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("2bRVB")));
        case 'uk':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("guvtZ")));
        case 'vi':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("fsENw")));
        case 'zh-CN':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("939EJ")));
        case 'zh-TW':
            return $3cbe050fdda00a0c$var$importHelper(await (parcelRequire("kArhr")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2qINc));
    }
};

});
parcelRegister("2qINc", function(module, exports) {
module.exports = JSON.parse("{\"confluence-inline-reactions-mcu-nudge.description.many-reactions\":[{\"type\":1,\"value\":\"user1\"},{\"type\":0,\"value\":\", \"},{\"type\":1,\"value\":\"user2\"},{\"type\":0,\"value\":\" and \"},{\"type\":1,\"value\":\"count\"},{\"type\":0,\"value\":\" other\"},{\"offset\":0,\"options\":{\"one\":{\"value\":[]},\"other\":{\"value\":[{\"type\":0,\"value\":\"s\"}]}},\"pluralType\":\"cardinal\",\"type\":6,\"value\":\"count\"},{\"type\":0,\"value\":\" reacted to this page\"}],\"confluence-inline-reactions-mcu-nudge.description.no-reactions\":[{\"type\":0,\"value\":\"Be the first one to react\"}],\"confluence-inline-reactions-mcu-nudge.description.one-reaction\":[{\"type\":1,\"value\":\"user\"},{\"type\":0,\"value\":\" reacted to this page\"}],\"confluence-inline-reactions-mcu-nudge.description.two-reactions\":[{\"type\":1,\"value\":\"user1\"},{\"type\":0,\"value\":\" and \"},{\"type\":1,\"value\":\"user2\"},{\"type\":0,\"value\":\" reacted to this page\"}],\"confluence-inline-reactions-mcu-nudge.title\":[{\"type\":0,\"value\":\"Love this page? Let \"},{\"type\":1,\"value\":\"authorName\"},{\"type\":0,\"value\":\" know\"}],\"post-office.confluence-resurrected-user-welcome-back.body\":[{\"type\":0,\"value\":\"Jump into the top discussions and pages you might have missed.\"}],\"post-office.confluence-resurrected-user-welcome-back.close\":[{\"type\":0,\"value\":\"Close\"}],\"post-office.confluence-resurrected-user-welcome-back.cta\":[{\"type\":0,\"value\":\"See what's popular\"}],\"post-office.confluence-resurrected-user-welcome-back.image-alt\":[{\"type\":0,\"value\":\"Two hearts overlapped with each other\"}],\"post-office.confluence-resurrected-user-welcome-back.next-best-action.header\":[{\"type\":0,\"value\":\"Welcome back!\"}]}");

});

parcelRegister("26TpO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4TInl").then(()=>parcelRequire('cu1WA'));

});

parcelRegister("1NVIu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hqBP4").then(()=>parcelRequire('7QpWr'));

});

parcelRegister("cAwrd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hFqnt").then(()=>parcelRequire('j7fW8'));

});

parcelRegister("aVa9h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("A7G4D").then(()=>parcelRequire('1uYpX'));

});

parcelRegister("7z6sg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3KLJ8").then(()=>parcelRequire('7kJWk'));

});

parcelRegister("4bcdk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3dm3D").then(()=>parcelRequire('8Q5sE'));

});

parcelRegister("lKjDh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iI0Na").then(()=>parcelRequire('3kI8N'));

});

parcelRegister("4pafy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("btg2k").then(()=>parcelRequire('8reN2'));

});

parcelRegister("1mF0P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7PL1Y").then(()=>parcelRequire('79Syx'));

});

parcelRegister("eHHRR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g10ml").then(()=>parcelRequire('bmf4G'));

});

parcelRegister("1SnAW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6haI7").then(()=>parcelRequire('3d3w6'));

});

parcelRegister("cKwcL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Wy9u").then(()=>parcelRequire('i2i8e'));

});

parcelRegister("gdqFY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h6nSo").then(()=>parcelRequire('dKYWq'));

});

parcelRegister("i6bjR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1XUYR").then(()=>parcelRequire('9JK3x'));

});

parcelRegister("jchIs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dQgxL").then(()=>parcelRequire('5Bs06'));

});

parcelRegister("49bxY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ikegb").then(()=>parcelRequire('6Gbpp'));

});

parcelRegister("a6K0q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hulpS").then(()=>parcelRequire('aqH5R'));

});

parcelRegister("cCvt8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3KJm3").then(()=>parcelRequire('6ceyn'));

});

parcelRegister("iFiFQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cBn9x").then(()=>parcelRequire('8sGfb'));

});

parcelRegister("lTMgx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dARjk").then(()=>parcelRequire('kk2pa'));

});

parcelRegister("9EmNn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5u3kg").then(()=>parcelRequire('5OaW1'));

});

parcelRegister("7JUn7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("caOJN").then(()=>parcelRequire('fwtiz'));

});

parcelRegister("18oP2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l4jQI").then(()=>parcelRequire('3x1Hb'));

});

parcelRegister("6ZtXy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kB6mR").then(()=>parcelRequire('hRQZD'));

});

parcelRegister("1DYVj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2k0sZ").then(()=>parcelRequire('bGQ0c'));

});

parcelRegister("i7vsI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aR3Ej").then(()=>parcelRequire('kS00n'));

});

parcelRegister("bDRur", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iWQjq").then(()=>parcelRequire('8dtnj'));

});

parcelRegister("bd9Sv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gqA0p").then(()=>parcelRequire('3Q5Dp'));

});

parcelRegister("dLaQf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ehB5U").then(()=>parcelRequire('g9gwQ'));

});

parcelRegister("2bRVB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9mbK9").then(()=>parcelRequire('aBEEJ'));

});

parcelRegister("guvtZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cL4vz").then(()=>parcelRequire('3R1Ez'));

});

parcelRegister("fsENw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dgcws").then(()=>parcelRequire('5IP1I'));

});

parcelRegister("939EJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bX8u3").then(()=>parcelRequire('5pWl8'));

});

parcelRegister("kArhr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("30cOr").then(()=>parcelRequire('9JYSt'));

});


parcelRegister("bkMlG", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $b6766af11b735a50$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4Dn1F = parcelRequire("4Dn1F");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b6766af11b735a50$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b6766af11b735a50$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("lsT5Z")));
        case 'da':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("6upmz")));
        case 'de':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("lXj3m")));
        case 'en-GB':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("eRU5D")));
        case 'en-US':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("9taML")));
        case 'en-XA':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("1H5Un")));
        case 'en-XB':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("4i1s2")));
        case 'en-ZZ':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("6ZjYC")));
        case 'en':
            return $b6766af11b735a50$var$importHelper(await Promise.resolve((parcelRequire("4Dn1F"))));
        case 'es':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("cPi9s")));
        case 'et':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("4Pxgs")));
        case 'fi':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("ebzOA")));
        case 'fr':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("86TpW")));
        case 'hr':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("g5ObM")));
        case 'hu':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("lPL1e")));
        case 'it':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("hh1T6")));
        case 'ja':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("g1j8X")));
        case 'ko':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("65e6S")));
        case 'nb':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("6cAvc")));
        case 'nl':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("7I953")));
        case 'pl':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("gdPt1")));
        case 'pt-BR':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("eOz57")));
        case 'ro':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("9SbTC")));
        case 'ru':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("bPgyd")));
        case 'sl':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("4LRAd")));
        case 'sr-RS':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("2MUrd")));
        case 'sr-YR':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("g5R3x")));
        case 'sr':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("lIDdX")));
        case 'sv':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("3t62Z")));
        case 'th':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("apNyG")));
        case 'tr':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("dQC7U")));
        case 'uk':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("1eXmL")));
        case 'vi':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("kJuXP")));
        case 'zh-CN':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("8EOdZ")));
        case 'zh-TW':
            return $b6766af11b735a50$var$importHelper(await (parcelRequire("ggX7h")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4Dn1F));
    }
};

});
parcelRegister("4Dn1F", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.primary":[{"type":0,"value":"Try Rovo now"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.secondary":[{"type":0,"value":"Try Rovo now"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.subtitle":[{"type":0,"value":"Jump into Confluence to discover what\'s possible."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.title":[{"type":0,"value":"Ready to get started?"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.description":[{"type":0,"value":"Prompt Rovo to start creating for you. Use anything across Confluence as input."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.link":[{"type":0,"value":"Create with Rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.title":[{"type":0,"value":"Create any content with Rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.description":[{"type":0,"value":"Utilize Rovo in any doc or page by highlighting any text. Edit your writing or start drafting."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.link":[{"type":0,"value":"Edit with Rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.title":[{"type":0,"value":"Edit with Rovo in docs and pages"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.description":[{"type":0,"value":"Save time by using summaries and audio briefings to get the context you need."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.link":[{"type":0,"value":"Try audio briefings"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.title":[{"type":0,"value":"Get information faster"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.features.title":[{"type":0,"value":"Use Rovo in a number of ways:"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.hero.alt":[{"type":0,"value":"Atlassian Intelligence"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.rovo":[{"type":0,"value":"Rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.subtitle":[{"type":0,"value":"Looks like you used "},{"type":1,"value":"featureName"},{"type":0,"value":" \u2014 here are more ways to use Rovo in Confluence."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.subtitle.video.variant":[{"type":0,"value":"Looks like you used "},{"type":1,"value":"featureName"},{"type":0,"value":". Here are a few more ideas for using Rovo."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome":[{"type":0,"value":"Welcome, "},{"type":1,"value":"firstName"},{"type":0,"value":"!"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome-rovo":[{"type":0,"value":"Let\'s look at "},{"type":1,"value":"rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject":[{"type":0,"value":"Rovo is here for whatever you need"}],"cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiAudioBriefings":[{"type":0,"value":"Listen to what else Rovo can do"}],"cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiChat":[{"type":0,"value":"Use Rovo in a lot more ways than just chat"}],"cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiDefinitions":[{"type":0,"value":"Rovo can do more than just define"}],"cc-flywheel-feature-discovery.rovo-awareness-survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"cc-flywheel-feature-discovery.rovo-awareness-survey.statement":[{"type":0,"value":"I\'m aware of Atlassian Rovo and its functionalities."}],"post-office.confluence-create-with-rovo-side-nav-nudge.body":[{"type":0,"value":"With a simple prompt, Rovo can draft a page or whiteboard."}],"post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action":[{"type":0,"value":"Show me how"}],"post-office.confluence-create-with-rovo-side-nav-nudge.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-create-with-rovo-side-nav-nudge.heading":[{"type":0,"value":"You describe, Rovo creates"}]}');

});

parcelRegister("lsT5Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("JKhSS").then(()=>parcelRequire('cg5Rj'));

});

parcelRegister("6upmz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cmuoB").then(()=>parcelRequire('ff3ab'));

});

parcelRegister("lXj3m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("huG6o").then(()=>parcelRequire('39Yji'));

});

parcelRegister("eRU5D", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("75QNi").then(()=>parcelRequire('amZ6g'));

});

parcelRegister("9taML", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fpIkZ").then(()=>parcelRequire('24CIW'));

});

parcelRegister("1H5Un", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("beQsL").then(()=>parcelRequire('3C0kZ'));

});

parcelRegister("4i1s2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3sQiw").then(()=>parcelRequire('7Apec'));

});

parcelRegister("6ZjYC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8dFbw").then(()=>parcelRequire('hJzxL'));

});

parcelRegister("cPi9s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gwvAa").then(()=>parcelRequire('fryIH'));

});

parcelRegister("4Pxgs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ectNf").then(()=>parcelRequire('8p9AR'));

});

parcelRegister("ebzOA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fdx3T").then(()=>parcelRequire('la7BD'));

});

parcelRegister("86TpW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aS39q").then(()=>parcelRequire('juT6D'));

});

parcelRegister("g5ObM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Rr8O").then(()=>parcelRequire('kL67x'));

});

parcelRegister("lPL1e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7CPHs").then(()=>parcelRequire('Hcrta'));

});

parcelRegister("hh1T6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2DYnJ").then(()=>parcelRequire('SedUr'));

});

parcelRegister("g1j8X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gyriF").then(()=>parcelRequire('lmRyW'));

});

parcelRegister("65e6S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hYFVW").then(()=>parcelRequire('42xmY'));

});

parcelRegister("6cAvc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2x8Qv").then(()=>parcelRequire('aaxri'));

});

parcelRegister("7I953", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9d87N").then(()=>parcelRequire('7ygbc'));

});

parcelRegister("gdPt1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i0qlB").then(()=>parcelRequire('IARrZ'));

});

parcelRegister("eOz57", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fjKKq").then(()=>parcelRequire('cZDij'));

});

parcelRegister("9SbTC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bR3YN").then(()=>parcelRequire('chviU'));

});

parcelRegister("bPgyd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2h4rq").then(()=>parcelRequire('3EuZR'));

});

parcelRegister("4LRAd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f8iIg").then(()=>parcelRequire('5cuMq'));

});

parcelRegister("2MUrd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5zFT3").then(()=>parcelRequire('2DhQP'));

});

parcelRegister("g5R3x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2DGin").then(()=>parcelRequire('gfJUJ'));

});

parcelRegister("lIDdX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jEyjc").then(()=>parcelRequire('dxii2'));

});

parcelRegister("3t62Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9YR2a").then(()=>parcelRequire('iPNwG'));

});

parcelRegister("apNyG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ei5me").then(()=>parcelRequire('gCwEt'));

});

parcelRegister("dQC7U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6iJa4").then(()=>parcelRequire('fGqec'));

});

parcelRegister("1eXmL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Tx9y").then(()=>parcelRequire('4sMWb'));

});

parcelRegister("kJuXP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7oEN8").then(()=>parcelRequire('btcGb'));

});

parcelRegister("8EOdZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cDrmL").then(()=>parcelRequire('j7DuR'));

});

parcelRegister("ggX7h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ewJpS").then(()=>parcelRequire('89hBd'));

});


parcelRegister("8awEZ", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $59079b0fda55ec2a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $76lTO = parcelRequire("76lTO");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $59079b0fda55ec2a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $59079b0fda55ec2a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("9qjfC")));
        case 'da':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("1YPtK")));
        case 'de':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("1pDv3")));
        case 'en-GB':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("kZq1q")));
        case 'en-US':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("5hsKw")));
        case 'en-XA':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("bC3ZH")));
        case 'en-XB':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("8iNEf")));
        case 'en-ZZ':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("2yKW6")));
        case 'en':
            return $59079b0fda55ec2a$var$importHelper(await Promise.resolve((parcelRequire("76lTO"))));
        case 'es':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("74Iyp")));
        case 'et':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("g1iaV")));
        case 'fi':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("g8fnF")));
        case 'fr':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("5meYG")));
        case 'hr':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("ajHp8")));
        case 'hu':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("1XOUx")));
        case 'it':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("chm69")));
        case 'ja-JP':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("jQY9V")));
        case 'ja':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("4RzjC")));
        case 'ko':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("gkUNp")));
        case 'nb':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("4GFF9")));
        case 'nl':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("hVk0g")));
        case 'pl':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("45apl")));
        case 'pt-BR':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("fLUAH")));
        case 'ro':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("cvoUC")));
        case 'ru':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("foXuY")));
        case 'sl':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("4ytfG")));
        case 'sr-RS':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("fIipl")));
        case 'sr-YR':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("9cwx4")));
        case 'sr':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("fBBHk")));
        case 'sv':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("djau3")));
        case 'th':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("fsSH7")));
        case 'tr':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("5OV2w")));
        case 'uk':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("k0g6E")));
        case 'vi':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("dg5jx")));
        case 'zh-CN':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("g4RAh")));
        case 'zh-TW':
            return $59079b0fda55ec2a$var$importHelper(await (parcelRequire("3CyGm")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($76lTO));
    }
};

});
parcelRegister("76lTO", function(module, exports) {
module.exports = JSON.parse('{"ccommerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-dispute":[{"type":0,"value":"Action required: ACH Direct debit payment failed"}],"commerce-access-invalid-payment-ccp.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-access-invalid-payment-hams.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch":[{"type":0,"value":"To understand more on why we couldn\'t generate your invoice, please "},{"type":1,"value":"getInTouchLink"},{"type":0,"value":" with us."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch-link":[{"type":0,"value":"get in touch"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.no-invoice-generation":[{"type":0,"value":"We couldn\'t generate an invoice for your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") as we don\'t have\\n\\t\\t\\t\\tyour complete billing information. As a result, your subscription has been canceled."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-1":[{"type":0,"value":"Once you\u2019ve updated the billing details, reactivate your subscription by going to "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-5":[{"type":0,"value":". If you reactivate your subscription within 60 days of cancellation, your data and preferences will remain the same."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-partner-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.wrong-details":[{"type":0,"value":"It could be because you\u2019ve entered the wrong details, or that the information you\u2019ve provided us is\\n\\t\\t\\t\\tincomplete. Don\'t worry, you can reactivate your subscription after updating your billing information."}],"commerce-credit-account-deactivation-ccp.clear-unpaid-invoices":[{"type":0,"value":"Clear any unpaid invoices associated with your account."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.help-message":[{"type":0,"value":"We understand that managing payments can sometimes be challenging, and we\'re here to help."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.learn-reasons":[{"type":0,"value":"Learn about possible reasons"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.message":[{"type":0,"value":"You can no longer use Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms to place your orders as your billing account\u2019s eligibility has been suspended. "},{"type":1,"value":"learnReason"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.title":[{"type":0,"value":"You\u2019re no longer eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" terms"}],"commerce-credit-account-deactivation-ccp.reach-out":[{"type":0,"value":"Reach out to us so we can review your eligibility."}],"commerce-credit-account-deactivation-ccp.reconsider-eligibility":[{"type":0,"value":"If you\u2019d like us to reconsider your eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms, we suggest you to:"}],"commerce-credit-account-deactivation-ccp.view-unpaid-invoices-link":[{"type":0,"value":"View unpaid invoices"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.couldn\'t-approve-request":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your request because you\u2019ve reached the maximum credit limit that we can offer at this time. You can check back in a few months to see if your eligibility has changed."}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Unable to offer a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.rejected.title":[{"type":0,"value":"We\u2019re unable to offer you a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.thank-you.submitting":[{"type":0,"value":"Thank you for submitting your application for increasing your Atlassian Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit."}],"commerce-credit-account-limit-increase-request-rejection-ccp.move-forward":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce-credit-account-reactivation-ccp.message-template.good-news.restored.billing.account":[{"type":0,"value":"Good news! We\u2019ve restored your billing account\u2019s eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details:"}],"commerce-credit-account-reactivation-ccp.message-template.restored.title":[{"type":0,"value":"Your eligibility has been restored"}],"commerce-invoice-generated-ccp-g.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp-g.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-generated-ccp.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-terms-payment-pending-ccp.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-updated-ccp-g.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp-g.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-invoice-updated-ccp.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-marketing-multiple-product-upgrade-ccp.subtext":[{"type":0,"value":"Atlassian Administration"}],"commerce-on-account-approval-partner.email.attached-instructions":[{"type":0,"value":"We\'ve attached instructions outlining how to read your statement."}],"commerce-on-account-approval-partner.email.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Pay on account with terms of Net-\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from statement date."}],"commerce-on-account-approval-partner.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-approval-partner.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-approval-partner.email.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce-on-account-approval-partner.email.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the statement date"}],"commerce-on-account-approval-partner.email.statement-info":[{"type":0,"value":"As Pay on account Partner, you will now receive a statement twice a month (on the 1st and 16th) covering\\n\\t\\t\\t\\tinvoices for the periods 16th to last day and 1st to 15th respectively."}],"commerce-on-account-approval-partner.email.subject":[{"type":0,"value":"Your Pay on account request is approved"}],"commerce-on-account-approval-partner.email.title":[{"type":0,"value":"Your Pay on account request has been approved"}],"commerce-on-account-deactivation-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-deactivation-partner-ccp.email.apply-again":[{"type":0,"value":"You may apply again for Pay on account option after 6 months. Don\u2019t worry, you can still place new orders using a credit card. "}],"commerce-on-account-deactivation-partner-ccp.email.contact-us":[{"type":0,"value":"Should you have questions or wish to discuss ways to reactivate your pay on account option, please contact us at "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-deactivation-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-deactivation-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-deactivation-partner-ccp.email.on-account-being-deactivated":[{"type":0,"value":"Your Pay on account option with Atlassian is being deactivated effective immediately, due to overdue balances and failure to meet the agreed payment terms. "}],"commerce-on-account-deactivation-partner-ccp.email.reach-us":[{"type":0,"value":"You can reach out to us if you need further help in placing your order."}],"commerce-on-account-deactivation-partner-ccp.email.subject":[{"type":0,"value":"Pay on account deactivation notice"}],"commerce-on-account-deactivation-partner-ccp.email.title":[{"type":0,"value":"Pay on account is deactivated"}],"commerce-on-account-rejection-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.apply-again":[{"type":0,"value":"You can resubmit your application after 6 months to be considered again.  "}],"commerce-on-account-rejection-partner-ccp.email.contact-us":[{"type":0,"value":"You can still go ahead with your purchase. We suggest using a credit card to pay for your order. If you still need help placing an order contact us at  "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-rejection-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-rejection-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-rejection-partner-ccp.email.on-account-application-rejected":[{"type":0,"value":"Thank you for submitting your application for Pay on account. Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements. "}],"commerce-on-account-rejection-partner-ccp.email.sales-op-support.no-translate":[{"type":0,"value":"sales-ops-support@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.subject":[{"type":0,"value":"Pay on account application rejection notice"}],"commerce-on-account-rejection-partner-ccp.email.title":[{"type":0,"value":"We\u2019re unable to approve your Pay on account request"}],"commerce-payment-failure-ccp.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"FAQ"}],"commerce-payment-failure-hams.email.not-trial.without-cc.add-payment-details":[{"type":0,"value":"We noticed you haven\'t added payment details for "},{"type":1,"value":"allProductListString"},{"type":0,"value":". Add payment details today so your team can keep working without interruption."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.subject":[{"type":1,"value":"subject"}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or alternatively contact your bank.Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for Atlassian Cloud "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-1":[{"type":0,"value":"We\'re unable to process your payment for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":":"}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-2":[{"type":0,"value":"This is due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.not-processed":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"allProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.additional-actions":[{"type":0,"value":"If you\u2019re unable to make payments or you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details.submit":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request":[{"type":0,"value":"For more information about what happens when you\u2019re unsubscribed from Atlassian Access, "},{"type":1,"value":"submitRequestLink"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"see our FAQ"}],"commerce-payment-failure-hams.email.trial.without-cc.2-4.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-1":[{"type":0,"value":"It\u2019s okay, we all get busy! Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but you can still add your payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-1":[{"type":0,"value":"Your Standard plan trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-2":[{"type":0,"value":"But it\u2019s not too late! You can still add payment details and keep the work you\u2019ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested.cancel-subscription":[{"type":0,"value":"cancel your subscription"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-1":[{"type":0,"value":"Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but this could just be the beginning! Add payment details to keep working\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\twith your dream team."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more.support":[{"type":0,"value":"support.atlassian.com"}],"commerce-payment-failure-hams.email.trial.without-cc.org.2-4.expiration":[{"type":0,"value":"It\'s okay, we all get busy! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.org.4more.expiration.expiration":[{"type":0,"value":"It\'s not too late! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tdetails and keep the work you\'ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.org.less2.expiration":[{"type":0,"value":"Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but this could just be the beginning. Add payment details to keep working with your dream team"}],"commerce-payment-failure-hams.email.trial.without-cc.without-cc.org.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can unsubscribe at any time within the Manage Subscriptions area\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tof your organization administration."}],"commerce-payment-failure-hams.email.update-payment-details":[{"type":0,"value":"Update Payment Detail"}],"commerce-payment-failure-trials.add-payment":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.add-payment-without-access":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.billing-cycle-label.no-translate":[{"type":0,"value":" | "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.billing-cycle-text-label.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.card-details":[{"type":0,"value":"Card: "},{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"lastFourDigits"}],"commerce-payment-failure-trials.contact-your-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue.\\n                        Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.contact_us":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation. We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access.contact_us_link":[{"type":0,"value":"Contact us"}],"commerce-payment-failure-trials.contact_us_access.data_storage_link":[{"type":0,"value":"Data Storage FAQs"}],"commerce-payment-failure-trials.contact_us_access.downgrade_link":[{"type":0,"value":"downgrade to a free plan"}],"commerce-payment-failure-trials.couldnt-charge-card":[{"type":0,"value":"We\'re reaching out as we couldn\'t charge your card for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.couldnt-charge-paypal":[{"type":0,"value":"We couldn\'t charge your PayPal account for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" because there was a problem with your account settings or the payment method selected from your PayPal wallet."}],"commerce-payment-failure-trials.ent-org-name-with-space-label.no-translate":[{"type":1,"value":"separator"},{"type":0,"value":" "},{"type":1,"value":"entOrgName"},{"type":0,"value":" "}],"commerce-payment-failure-trials.entitlement-number-label.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.entitlement-number-text.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.has_payment_method.add-payment-caption":[{"type":0,"value":"Add payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.caption":[{"type":0,"value":"Action required: Your payment was declined"}],"commerce-payment-failure-trials.has_payment_method.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment, based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.has_company_name.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"companyName"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.no_retries.partners.caption":[{"type":0,"value":"Action required: Update payment details by "},{"type":1,"value":"dueDate"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.payment-declined-title":[{"type":0,"value":"Action required: Payment declined for #"},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access":[{"type":0,"value":"Update your credit card details, or add a different credit card. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual":[{"type":0,"value":"Update your payment details or add a different payment method to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-monthly-subscriptions":[{"type":0,"value":"For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-payment-caption":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.update-paypal":[{"type":0,"value":"Log in to your PayPal account and go to your automatic payment settings. Select a different payment method for your Atlassian payment. You should also check that your account isn\'t restricted and allows international payments."}],"commerce-payment-failure-trials.has_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.invoice-number":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.invoice-number-label":[{"type":0,"value":"Invoice Number:"}],"commerce-payment-failure-trials.invoice_pdf_attachment":[{"type":0,"value":"For your records, the invoice with payment due is attached as a PDF."}],"commerce-payment-failure-trials.item-description-label.no-translate":[{"type":1,"value":"description"}],"commerce-payment-failure-trials.item-description.no-translate":[{"type":0,"value":" "},{"type":1,"value":"description"}],"commerce-payment-failure-trials.log-in-paypal":[{"type":0,"value":"Log in to PayPal"}],"commerce-payment-failure-trials.no_payment_method.partners.add_your_payment_details":[{"type":0,"value":"Add payment details today to avoid interruptions."}],"commerce-payment-failure-trials.no_payment_method.partners.caption":[{"type":0,"value":"Add payment details to avoid interruptions"}],"commerce-payment-failure-trials.no_payment_method.partners.title.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.partners.title.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.title":[{"type":0,"value":"Action required: Add your payment details"}],"commerce-payment-failure-trials.no_payment_method.unable_to_process_your_payment":[{"type":0,"value":"We were unable to process your payment since we haven\'t received your payment details for your subscription."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process your payment for Atlassian products as you haven\'t provided us with payment details yet."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process-access":[{"type":0,"value":"We\'re reaching out as we couldn\'t process your recent payment for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" due to an issue with your account\'s payment details."}],"commerce-payment-failure-trials.payment":[{"type":0,"value":"This payment was for:"}],"commerce-payment-failure-trials.paypal-details":[{"type":0,"value":"PayPal account: "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.sold-to-details.address":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"address"}],"commerce-payment-failure-trials.sold-to-details.address-message":[{"type":0,"value":"Address:"}],"commerce-payment-failure-trials.sold-to-details.company":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"companyName"}],"commerce-payment-failure-trials.sold-to-details.company-label":[{"type":0,"value":"Company:"}],"commerce-payment-failure-trials.sold-to-details.customer-contact":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"customerContact"}],"commerce-payment-failure-trials.sold-to-details.customer-contact-label":[{"type":0,"value":"Customer contact:"}],"commerce-payment-failure-trials.total-bill":[{"type":0,"value":"Your total bill is "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce-payment-failure-trials.update-credit-card":[{"type":0,"value":"Update your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-without-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.we_will_try_to_process_again":[{"type":0,"value":"We\u2019ll try to process your payment again on "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-payment-failure-trials.what-to-do":[{"type":0,"value":"What you need to do:"}],"commerce-payment-failure-trials.without-payment-faq-product-access-lost":[{"type":0,"value":"Without this payment, product access will be lost, and product data will be permanently deleted soon after. See our "},{"type":1,"value":"element"}],"commerce-permission-request-add-payment-ccp.email.add-payment-request-text":[{"type":0,"value":"There is an add payment request from "},{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") for the subscription: "}],"commerce-permission-request-add-payment-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce-permission-request-add-payment-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce-permission-request-add-payment-ccp.email.personal-note.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"commerce-permission-request-add-payment-ccp.email.subtext-for-personal-note":[{"type":0,"value":"To help you with more details, here\u2019s a note from the requester: "}],"commerce-permission-request-add-payment-ccp.email.title":[{"type":0,"value":"Request from "},{"type":1,"value":"name"},{"type":0,"value":" to add payment details"}],"commerce-permission-request-add-payment-ccp.email.whats-next-subtext":[{"type":0,"value":"If you approve the request, continue with adding payment details for the subscription and we\u2019ll notify the requester. Ignore this email to deny. "}],"commerce-permission-request-add-payment-response-ccp.email.add-payment-request-text":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"commerce-permission-request-add-payment-response-ccp.email.benefits-text":[{"type":0,"value":"You can now enjoy the benefits of:"}],"commerce-permission-request-add-payment-response-ccp.email.go-to-site":[{"type":0,"value":"Go to site"}],"commerce-permission-request-add-payment-response-ccp.email.title":[{"type":0,"value":"Your request is complete"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-count":[{"type":0,"value":"Units: "},{"type":1,"value":"count"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-entitlement-number":[{"type":1,"value":"entitlementNumber"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.free-entitlement.no-action":[{"type":0,"value":"You don\u2019t need to do anything, and your monthly Statuspage payments will remain the same."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.merged-addon":[{"type":0,"value":"Over the next few days, we\u2019ll simplify things for you by merging these "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on subscriptions into one:"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.multiple-addons":[{"type":0,"value":"We noticed your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" for "},{"type":1,"value":"site"},{"type":0,"value":" has more than one "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on: "}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.merged-add-on":[{"type":0,"value":"You\u2019ll only see one Subscribers add-on listed on your next invoice."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-change":[{"type":0,"value":"There\u2019s no change to what you\u2019ll pay each month."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-setup":[{"type":0,"value":"You won\u2019t need to set up or configure anything."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.title":[{"type":0,"value":"We\u2019re merging your "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-ons for Statuspage"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.what-this-means":[{"type":0,"value":"What this means for you"}],"commerce-pre-dunning-ccp.email.paid-entitlement.add-payment-text.retryThree":[{"type":0,"value":"You can prevent being deactivated by reducing your user count, purchasing a paid plan, or "},{"type":1,"value":"contactingUs"},{"type":0,"value":"."}],"commerce-pre-dunning-ccp.email.paid-entitlement.add-payment.retryOne":[{"type":0,"value":"You\u2019ll be downgraded to the Free plan if you haven\u2019t added payment details and you have fewer than 10 users."}],"commerce-pre-dunning-ccp.email.paid-entitlement.add-payment.retryThree":[{"type":0,"value":"You\u2019ll be downgraded to the Free plan if you haven\u2019t added payment details and you have fewer than 10 users. Otherwise, your site will be deactivated. "}],"commerce-pre-dunning-ccp.email.paid-entitlement.curr-plan":[{"type":0,"value":"To choose a different plan, "}],"commerce-pre-dunning-ccp.email.pick-a-plan.retryOne":[{"type":0,"value":"Add your payment details to keep your team\u2019s progress going with the advanced features they need."}],"commerce-pre-dunning-ccp.email.pick-a-plan.retryTwo":[{"type":0,"value":"To keep access to advanced "},{"type":1,"value":"productName"},{"type":0,"value":" features, you now have until "},{"type":1,"value":"gracePeriodEndDate"},{"type":0,"value":" to add your payment details and keep your team going with the Premium plan."}],"commerce-pre-dunning-ccp.email.title.retryOne":[{"type":0,"value":"Last day to make a choice"}],"commerce-pre-dunning-ccp.email.title.retryThree":[{"type":0,"value":"This doesn\u2019t have to be goodbye"}],"commerce-pre-dunning-ccp.email.title.retryTwo":[{"type":0,"value":"We\'ve given you more time to choose"}],"commerce-pre-dunning-ccp.email.trial-ended.retryOne":[{"type":1,"value":"firstName"},{"type":0,"value":", that\'s a wrap\u2014your "},{"type":1,"value":"productName"},{"type":0,"value":" trial "},{"children":[{"type":0,"value":"has ended."}],"type":8,"value":"strong"}],"commerce-pre-dunning-ccp.email.trial-ended.retryThree":[{"type":1,"value":"firstName"},{"type":0,"value":", this is your "},{"children":[{"type":0,"value":"last chance"}],"type":8,"value":"strong"},{"type":0,"value":" to keep the "},{"type":1,"value":"productName"},{"type":0,"value":" Premium plan, and keep your team going with advanced "},{"type":1,"value":"productName"},{"type":0,"value":" features."}],"commerce-pre-dunning-ccp.email.trial-ended.retryTwo":[{"type":1,"value":"firstName"},{"type":0,"value":", it\'s OK we all get busy."}],"commerce-reactivation-order-to-paid-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-cancellation-ecc.email.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" canceled"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-reactivation-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-reactivation-trial-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce-subscription-skip-trial-ccp.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.estimated-bill":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excluding tax)"},{"type":1,"value":"content"}],"commerce-subscription-skip-trial-ccp.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" subscription "}],"commerce-subscription-systematic-downgrade-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" subscription "}],"commerce.bill-estimate-common.key":[{"type":0,"value":"Estimated bill:"}],"commerce.bill-estimate-common.value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excludes tax)"}],"commerce.billing-cycle-common.key":[{"type":0,"value":"Billing cycle:"}],"commerce.billing-cycle-common.value":[{"type":1,"value":"billingCycle"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.cancellation-reason":[{"type":0,"value":"It could be because the information provided to us is incorrect or incomplete. Don\'t worry,\\n                            the subscription can be reactivated after you update your billing information."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.reactive-within":[{"type":1,"value":"content"},{"type":0,"value":" If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.subscription-cancellation-message":[{"type":0,"value":"We couldn\'t generate an invoice for the following subscription as we don\'t have your complete billing information.\\n                            As a result, the subscription has been canceled."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription canceled - update billing details"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.subject":[{"type":1,"value":"title"},{"type":0,"value":" canceled"}],"commerce.commerce-credit-account-approval-ccp.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-approval-ccp.message-template.approved.title":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application has been approved"}],"commerce.commerce-credit-account-approval-ccp.message-template.email.subject":[{"type":0,"value":"Approved for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-approval-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details: "}],"commerce.commerce-credit-account-deactivation-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your account is now ineligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-limit-update-ccp.email.list.new-credit-limit":[{"type":0,"value":"New Credit limit: "},{"type":1,"value":"newCreditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-limit-update-ccp.email.possible-reasons":[{"type":0,"value":"Learn about possible reasons."}],"commerce.commerce-credit-account-limit-update-ccp.email.statement-info":[{"type":0,"value":"We\u2019ve decreased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". "},{"type":1,"value":"possibleReasons"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.decrease.title":[{"type":0,"value":"We\u2019ve decreased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.decrease.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been decreased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.increase.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been increased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve increased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". Here are the details: "}],"commerce.commerce-credit-account-limit-update-ccp.message-template.increase.title":[{"type":0,"value":"We\u2019ve increased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-reactivation-ccp.message-template.email.subject":[{"type":0,"value":"Your account is now re-eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.bad-news":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements."}],"commerce.commerce-credit-account-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Couldn\u2019t approve your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application"}],"commerce.commerce-credit-account-rejection-ccp.message-template.other-option":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce.commerce-credit-account-rejection-ccp.message-template.rejection.title":[{"type":0,"value":"We\u2019re unable to approve you for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.thanks":[{"type":0,"value":"Thank you for submitting your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.card-expiry-warning-message":[{"type":0,"value":"Heads up \u2014 your credit card expires in "},{"type":1,"value":"expiryMonthAndYear"},{"type":0,"value":". To make sure your next payment is made on time so you can continue using your subscriptions without interruption, you\u2019ll need to update your payment details before "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action":[{"type":0,"value":"What happens if I don\u2019t update my details?"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action-warning":[{"type":0,"value":"Your next payment attempt will fail \u2013 this means your subscription could be deactivated and you could lose product access and data."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.select":[{"type":0,"value":"Select "}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your credit card expires soon"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.time-to-update-credit-card-details":[{"type":0,"value":"Time to update your credit card details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details":[{"type":0,"value":"Update payment details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details-note":[{"type":0,"value":" below to edit your saved card."}],"commerce.commerce-customer-contact-remove-digest.email.body.removed-contact":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":")"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.caption":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.contact-removed":[{"type":0,"value":"Contact removed: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.impacted-subscriptions":[{"type":0,"value":"Impacted subscriptions:"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.intro":[{"type":0,"value":"We\'ve removed a key customer contact from a billing profile."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.questions":[{"type":0,"value":"If you have any questions, please reach out to your Atlassian billing partner."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.removed-by":[{"type":0,"value":"Removed by: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes":[{"type":0,"value":"You can view the changes at "},{"type":1,"value":"url"},{"type":0,"value":" page."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes-link":[{"type":0,"value":"partner managed subscriptions"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" subscriptions."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.subject":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customers-deactivation-eve.email.body-p1":[{"type":0,"value":"U.S. law prohibits Atlassian, an Australian corporation with offices in the United States, from providing you with access to our products and services. After analyzing the applicable lists of restricted parties maintained by the U.S. Government, we were unable to confirm that your name was not affiliated with a restricted party."}],"commerce.commerce-customers-deactivation-eve.email.body-p2":[{"type":0,"value":"If this is a case of misidentification, please reply with two different copies of official documentation to verify your identity."}],"commerce.commerce-customers-deactivation-eve.email.body-p3":[{"type":0,"value":"Official documentation includes, but is not limited to, a government-issued driver\'s license or identification card, passport, utility bill, mortgage or bank statement, etc. Please make sure your full name and address are clearly visible."}],"commerce.commerce-customers-deactivation-eve.email.body-p4":[{"type":0,"value":"You may check out these resources for more information: U.S. export controls ("},{"type":1,"value":"exportControl"},{"type":0,"value":") | Consolidated Screening List ("},{"type":1,"value":"csl"},{"type":0,"value":")"}],"commerce.commerce-customers-deactivation-eve.email.body-p5":[{"type":0,"value":"Please reply directly via email with any further questions and the identification requested."}],"commerce.commerce-customers-deactivation-eve.email.body-p6":[{"type":0,"value":"We look forward to your reply."}],"commerce.commerce-customers-deactivation-eve.email.body.csl":[{"type":0,"value":"https:\\/\\/www.trade.gov\\/consolidated-screening-list"}],"commerce.commerce-customers-deactivation-eve.email.body.exportControl":[{"type":0,"value":"https:\\/\\/www.trade.gov\\/us-export-controls"}],"commerce.commerce-customers-deactivation-eve.email.caption":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-customers-deactivation-eve.email.salutation":[{"type":0,"value":"Dear Atlassian user,"}],"commerce.commerce-customers-deactivation-eve.email.subject":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.custom":[{"type":1,"value":"greetingText"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.default":[{"type":0,"value":"Dear "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-dynamic-content-test-cns.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"message"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-generated-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"businessKey"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-generated-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.offer-message":[{"type":0,"value":"When you use the two together, you can centralize your docs, connect work across teams and more. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-congratulations-message":[{"type":0,"value":"Did you know that "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Confluence?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-product-caption":[{"type":0,"value":"Build a single source of truth for all your team\u2019s important info"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.cta.try-now":[{"type":0,"value":"Try now"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.offer-message":[{"type":0,"value":"Together, the products help you capture ideas and prioritize work, so you\u2019re always organized. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-congratulations-message":[{"type":0,"value":"Did you know "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Jira Product Discovery?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-product-caption":[{"type":0,"value":"Say goodbye to messy backlogs"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.offer-message":[{"type":0,"value":"With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-congratulations-message":[{"type":0,"value":"People who use Jira Service Management say that work is more visible for all teams involved, from request to resolution."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-product-caption":[{"type":0,"value":"Bring developers, IT, and operations onto the same platform"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.offer-message":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-congratulations-message":[{"type":0,"value":"Jira and "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" can help you visualize and deliver work, fast."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-product-caption":[{"type":0,"value":"Break down silos and connect the dots between teams"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-congratulations-message":[{"type":0,"value":"Congrats on purchasing "},{"type":1,"value":"purchasedProductTitle"},{"type":0,"value":"! Get free trials of these products and unlock these advanced features:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-product-caption":[{"type":0,"value":"Get free trials of "},{"type":1,"value":"productName1"},{"type":0,"value":" & "},{"type":1,"value":"productName2"},{"type":0,"value":" Standard with your "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" purchase"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.trial-length-message":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement-with-trial-length.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.single-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-space-permissions":[{"type":0,"value":"Advanced user & space permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.higher-automation-limit":[{"type":0,"value":"Higher automation limit"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.insights-into-page-views":[{"type":0,"value":"Get insights into page views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.on-call-management":[{"type":0,"value":"On-call management"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.published-views":[{"type":0,"value":"Published views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.trial-length":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents":[{"type":0,"value":"Unlimited agents"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents-storage":[{"type":0,"value":"Unlocked agent & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creator-storage":[{"type":0,"value":"Unlocked creator & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-user-storage":[{"type":0,"value":"Unlocked user & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-users":[{"type":0,"value":"Unlimited users"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-archive.alt-text":[{"type":0,"value":"Icon - Archive"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-graph.alt-text":[{"type":0,"value":"Icon - Graph"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-lightning.alt-text":[{"type":0,"value":"Icon - Lightning"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-link.alt-text":[{"type":0,"value":"Icon - Link"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-people.alt-text":[{"type":0,"value":"Icon - People"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-phone.alt-text":[{"type":0,"value":"Icon - Phone"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-unlock.alt-text":[{"type":0,"value":"Icon - Unlock"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.billing":[{"type":1,"value":"billingUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.faq":[{"type":0,"value":"FAQs"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.migrate":[{"type":0,"value":"You have been successfully migrated from Jira Work Management to Jira, within "},{"type":1,"value":"site"},{"type":0,"value":"."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.options":[{"type":0,"value":"To view pricing, auto-renewal, and cancellation options, go to "},{"type":1,"value":"billing"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.site":[{"type":1,"value":"siteUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.subsciption":[{"type":0,"value":"The current price of your subscription has not changed. However, pricing may vary if changes are made to your user tier, plan, and\\/or licensing. See "},{"type":1,"value":"faq"},{"type":0,"value":" for more details."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.caption":[{"type":0,"value":"You\u2019ve been successfully migrated to Jira"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.subject":[{"type":0,"value":"Your migration was successful"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.encryption-policy-info":[{"type":0,"value":"CMK policy enrollment is required for activation. "},{"type":1,"value":"supportInfo"},{"type":0,"value":" to self-enroll before provisioning Atlassian app instances. For step-by-step instructions, refer to the support "},{"type":1,"value":"CMKSupportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.manage-subscription":[{"type":0,"value":"Please click \u2018Manage Subscription\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.partner-managed-subscription":[{"type":0,"value":"Please visit your partner-managed subscriptions page"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.view-subscription":[{"type":0,"value":"Please click \u2018View all Subscriptions\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration. You can view a detailed breakdown of your team\u2019s usage in your billing account."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.cbp-details":[{"type":0,"value":"Your plan includes:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"You can visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":" to learn more about how billing works."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"We\u2019ll send the final invoice within 24 hours, which will include all the details and payment options for your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" details from your "},{"type":1,"value":"hostingDetails"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.non-cloud.billing-info":[{"type":0,"value":"Go to your billing account to set up your new subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated-with-date.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription from its start date"}]},"other":{"value":[{"type":0,"value":"subscriptions from their start dates"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-reseller":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.give-admin-permission":[{"type":0,"value":"Setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian billing partner. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian reseller. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-reseller":[{"type":0,"value":"You can view or cancel your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time by going to "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" and following the steps."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"the subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.setup-your-site":[{"type":0,"value":"Get started straight away by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":":"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-url":[{"children":[{"type":1,"value":"siteURL"}],"type":8,"value":"a"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.ecc-reseller-managed-subscription.url":[{"type":0,"value":"your Subscription overview"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body-ecc.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.subject":[{"type":1,"value":"billToPartyName"},{"type":0,"value":": Atlassian product order confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.auto_prov_notification":[{"type":0,"value":"The products will be added to your customer\u2019s account shortly."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.cbp-details":[{"type":0,"value":"The plan also includes the following:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.customer_contact_info":[{"type":0,"value":"Your customer contact can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.get-started":[{"type":0,"value":"You can get started straight away by setting up the subscriptions. We\u2019ve also sent a notification to your customer with a setup link to get started. "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from our "},{"type":1,"value":"ppcHomePage"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_invoice_info":[{"type":0,"value":"We\u2019ll email the invoice with all the details within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_notification":[{"type":0,"value":"We\u2019ll also send a notification to your customer with a link to set up their new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and get started."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-details":[{"type":0,"value":"We\u2019ll send you an invoice with all the details within 24 hours. We\u2019ll also send an email to your customer with a link to set up and get started with their new subscription. You can get started straight away by setting up the subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order, and the products will be ready to use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\'ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscriptions from their start dates. We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.with.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscription\\/s on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"For more information on how to manage your subscriptions and billing, visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"Expect the final invoice within 24 hours, which will include all the necessary details and payment options for your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your cloud site for your new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your Atlassian order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-date.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-manage-subscriptions":[{"type":0,"value":"You can view the subscription from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.next_steps":[{"type":0,"value":"Get started by setting up your customer\u2019s cloud site for the new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.ppc_homepage":[{"type":0,"value":" You can also view and manage the subscription details from our Partner Purchasing Center. "},{"type":1,"value":"viewQuoteUrl"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.processing":[{"type":0,"value":"We\u2019re processing the payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-date.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.subject":[{"type":0,"value":"We\u2019ve received your order for "},{"type":1,"value":"customerCompanyName"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message-template.email.subject":[{"type":0,"value":"This template has been deprecated"}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message.email.body.no-translate":[{"type":0,"value":"This template has been deprecated as it has been merged along with \'commerce-quote-order-fulfilled-ccp\' template with dynamic content added to differentiate between pull\\/push payment method."}],"commerce.commerce-partner-cancellation-personal-data-deletion-link":[{"type":0,"value":"personal data deletion request form"}],"commerce.commerce-partner-personal-data-deletion":[{"type":0,"value":"If your customer would like to place a request for immediate deletion of personal data after cancellation, they can submit a "},{"type":1,"value":"formLink"},{"type":0,"value":". Otherwise, the data will be deleted in accordance with Atlassian\u2019s standard "},{"type":1,"value":"policyLink"},{"type":0,"value":"."}],"commerce.commerce-payment-method-manage-ccp.account-ending-key":[{"type":0,"value":"Account ending: "}],"commerce.commerce-payment-method-manage-ccp.account-ending-value":[{"type":1,"value":"last4"}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-key":[{"type":0,"value":"Account holder name: "}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-value":[{"type":1,"value":"accountHolder"}],"commerce.commerce-payment-method-manage-ccp.authorization-date-key":[{"type":0,"value":"Authorization date: "}],"commerce.commerce-payment-method-manage-ccp.authorization-date-value":[{"type":1,"value":"authorizationDate"}],"commerce.commerce-payment-method-manage-ccp.authorization-details":[{"type":0,"value":"Authorization details"}],"commerce.commerce-payment-method-manage-ccp.bank-name-key":[{"type":0,"value":"Bank name: "}],"commerce.commerce-payment-method-manage-ccp.bank-name-value":[{"type":1,"value":"bankName"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-authorization":[{"type":0,"value":"Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-dispute":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce.commerce-payment-method-manage-ccp.could-not-process-payment":[{"type":0,"value":"We couldn\'t process your recent payment due to a dispute raised with your bank."}],"commerce.commerce-payment-method-manage-ccp.direct-debit-legal-terms":[{"type":0,"value":"You have authorized Atlassian to debit the bank account specified above for any amount owed for charges arising from your use of Atlassian\u2019 services and\\/or purchase of products from Atlassian, pursuant to Atlassian\u2019 website and terms, until this authorization is revoked. You have authorized Atlassian to debit your bank account periodically if and when you use Atlassian\u2019 services or purchase more than one of Atlassian\u2019 products periodically pursuant to Atlassian terms. Payments that fall outside the regular debits authorized above will only be debited after your authorization is obtained."}],"commerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-mandate":[{"type":0,"value":"Confirmation: Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.how-to-cancel-direct-debit":[{"type":0,"value":"You can cancel this direct debit at any time by deleting the linked bank account from your "},{"type":1,"value":"paymentMethods"},{"type":0,"value":" page"}],"commerce.commerce-payment-method-manage-ccp.payment-methods":[{"type":0,"value":"Payment methods"}],"commerce.commerce-payment-method-manage-ccp.received-authorization":[{"type":0,"value":"We\u2019ve received your authorization for direct debit."}],"commerce.commerce-payment-method-manage-ccp.routing-number-key":[{"type":0,"value":"Routing number: "}],"commerce.commerce-payment-method-manage-ccp.routing-number-value":[{"type":1,"value":"routingNumber"}],"commerce.commerce-payment-method-manage-ccp.update-bank-details":[{"type":0,"value":"Update your bank account details, or link a different bank account. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce.commerce-permission-request-add-payment-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: You have an add payment request"}],"commerce.commerce-permission-request-add-payment-response-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Request complete: Payment details added by billing admin "}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.cta.accept-billing-admin-request":[{"type":0,"value":"Review billing admin request"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.ba-request-text":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") is requesting billing admin permission for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.personal-note.no-translate":[{"type":1,"value":"customMessage"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.subtext-for-personal-note":[{"type":0,"value":"The request was sent with the following note: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.title":[{"type":1,"value":"name"},{"type":0,"value":" is requesting billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.what-they-can-do":[{"type":0,"value":"If you approve, they\'ll be able to:"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.whats-next-subtext":[{"type":0,"value":"If you accept the request, we\'ll notify the requester. If you don\'t want to grant billing admin access, you can decline the request."}],"commerce.commerce-permission-request-grant-ba-role-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: "},{"type":1,"value":"requesterName"},{"type":0,"value":" is requesting Billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.cta.manageSubscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails-for-changes":[{"type":0,"value":"Receive emails about any changes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.request-billing-admin":[{"type":0,"value":"Request billing admins to make changes to subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-site":[{"type":0,"value":"View, upgrade, downgrade and cancel subscriptions in your site"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-approved-text":[{"type":0,"value":"Great news - your billing admin request has been approved for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-declined-text":[{"type":0,"value":"Your request to become a billing admin on the following account has been declined."}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-approved":[{"type":0,"value":"You\'re now a billing admin"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get":[{"type":0,"value":"You\'ll now be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get-without-access":[{"type":0,"value":"You\'ll still be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.approved":[{"type":0,"value":"Your billing admin request has been approved"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-pre-comms-sp-add-on-merge-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Important information about your Statuspage add-ons"}],"commerce.commerce-pre-dunning-ccp.message-template.email.subject.first-reminder":[{"type":0,"value":"Your trial ends today! Keep your "},{"type":1,"value":"productName"},{"type":0,"value":" plan"}],"commerce.commerce-pre-dunning-ccp.message-template.email.subject.second-reminder":[{"type":0,"value":"You\u2019ve got extra time to keep your plan"}],"commerce.commerce-pre-dunning-ccp.message-template.email.subject.third-reminder":[{"type":0,"value":"Last chance to keep your plan!"}],"commerce.commerce-quote-expired-ccp.email.caption":[{"type":0,"value":"Your quote has expired"}],"commerce.commerce-quote-expired-ccp.email.contact-us":[{"type":0,"value":"Contact us"}],"commerce.commerce-quote-expired-ccp.email.ready-to-order":[{"type":0,"value":"If you\u2019d like to try Atlassian products, opt for a free trial."}],"commerce.commerce-quote-expired-ccp.email.reminder-before-expiry":[{"type":0,"value":"Your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired. You\u2019ll no longer be able to pay for it."}],"commerce.commerce-quote-expired-ccp.email.view-quote":[{"type":0,"value":"You can always create a new quote by reaching out to us."}],"commerce.commerce-quote-expired-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"It\u2019s time to renew your subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.request-quote-to-avoid-losing-access":[{"type":0,"value":"To avoid losing access to your products, request a quote that is valid until the end of your billing cycle. When you are ready to pay, simply review the quote and place your order. "}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.list-subscriptions":[{"type":0,"value":"Subscriptions list:"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.caption":[{"type":0,"value":"It\u2019s time to renew"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.reach-out-to-create-quote":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.request-quote-to-avoid-customer-losing-access":[{"type":0,"value":"To avoid losing access to the products, request a quote valid until the end of your billing cycle. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring":[{"type":0,"value":"Just a heads up that you have subscriptions that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring-for-customer-company":[{"type":0,"value":"Just a heads up that you have subscriptions for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.caption":[{"type":0,"value":"It\u2019s time to renew "}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.get-in-touch":[{"type":0,"value":"Get in touch with your Atlassian Billing Partner to get started on your renewal. They\u2019ll be able to help you with your quote and any next steps."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.let-you-know":[{"type":0,"value":"We hope you\u2019ve been enjoying your Atlassian products. We wanted to let you know that your subscription\\/s expire soon, so it\u2019s time to renew."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-quote-open-auto-renewal-ccp.message-template.email.ecc.subject":[{"type":0,"value":"Contact your Atlassian Billing Partner to renew "}],"commerce.commerce-quote-open-ccp.email.contract-type-generic":[{"type":0,"value":"When you\'re ready to convert the quote to an order, contact your customer advocate."}],"commerce.commerce-quote-open-ccp.email.contract-type-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, go to the quote in your billing account and proceed to create an order."}],"commerce.commerce-quote-open-ccp.email.direct-customer-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":1,"value":"billingUrlText"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open-reminder":[{"type":0,"value":"Keep in mind, if you have product trials in the quote, we recommend placing your order before the trial ends. If you need more time, "},{"children":[{"type":0,"value":"reach out to us"}],"type":8,"value":"RawLink"},{"type":0,"value":" to extend your quote validity."}],"commerce.commerce-quote-open-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is here!"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.partner-or-reseller":[{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is ready"}],"commerce.commerce-quote-reminder-expiry-ccp.email.administration":[{"type":0,"value":"Administration"}],"commerce.commerce-quote-reminder-expiry-ccp.email.caption":[{"type":0,"value":"Your quote will expire soon"}],"commerce.commerce-quote-reminder-expiry-ccp.email.order-in-bac":[{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":" and create an order."}],"commerce.commerce-quote-reminder-expiry-ccp.email.ready-to-order":[{"type":0,"value":"When you\u2019re ready to convert your quote to an order, go to your site\'s "}],"commerce.commerce-quote-reminder-expiry-ccp.email.reminder-before-expiry":[{"type":0,"value":"This is a friendly reminder that your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire on "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". Once expired, the quote will be canceled and you have to create a new one."}],"commerce.commerce-quote-reminder-expiry-ccp.email.view-quote":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-reminder-expiry-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire soon"}],"commerce.commerce-quote-stale-ccp.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"commerce.commerce-quote-stale-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-quote-stale-ccp.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-quote-stale-ccp.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.commerce-quote-stale-ccp.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"commerce.commerce-quote-stale-ccp.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"commerce.commerce-quote-stale-ccp.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.caption":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been successfully reactivated"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.we-will-charge":[{"type":0,"value":"We\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entNumber"},{"type":0,"value":")"}],"commerce.commerce-reactivation-order-to-paid-ccp.personal-information":[{"type":0,"value":"Since you reactivated your subscription within 60 days of cancellation, your data and preferences\\n                    are as you left them. You can jump right in and get started!"}],"commerce.commerce-refund-internal-ccp.message-template.email.adc-refund.body":[{"type":0,"value":"Advocate Central REFUND LINK - "},{"type":1,"value":"advocateCentralUrl"},{"type":0,"value":"\\/refunds\\/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-bank-transfer.subject":[{"type":0,"value":"Bank Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-onAccount.subject":[{"type":0,"value":"Expert Account Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund.body":[{"type":0,"value":"CASSI REFUND LINK - "},{"type":1,"value":"cassiUrl"},{"type":0,"value":"\\/ui\\/refunds\\/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":1,"value":"productName"},{"type":0,"value":" credit allocation used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allocation running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allocation of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allocation of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-rde-caption":[{"type":0,"value":"Upgrade to Rovo Dev Standard to get more Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"Rovo Dev credit allocation used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allocation running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-monitor":[{"type":0,"value":"You can monitor usage in your billing account to see which users have used their allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-ugrade-to-standard":[{"type":0,"value":"To increase Rovo Dev credits and allow extra usage, organization admins can upgrade to Rovo Dev Standard."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-user-cannot-use-extra":[{"type":0,"value":"Users who are at their credit limit won\'t be able to use any Rovo Dev features until the next billing cycle."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done anytime in Atlassian Administration to keep costs predictable. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-extra-usage-charges":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trialsneed-to-know-list-function-disabled":[{"type":0,"value":"Rovo Dev functionality is disabled for users who reach their allocation, and usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allocation of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done at any time in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-will-be-disabled":[{"type":0,"value":"Once users use up their Rovo Dev credits, Rovo Dev functionality will be disabled until usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-rde-info-message":[{"type":0,"value":"At least one of your users has used up their free Rovo Dev credit allocation in Jira."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allocation."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allocation of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-ship-to-party-archival-ccp.body.initimation":[{"type":0,"value":"Please note that this sold-to address is no longer available for billing."}],"commerce.commerce-ship-to-party-archival-ccp.body.partner.p3":[{"type":0,"value":"To view the changes, head to "},{"type":1,"value":"ppcHomePageLink"},{"type":0,"value":"."}],"commerce.commerce-ship-to-party-archival-ccp.email.body.disclaimer":[{"type":0,"value":"We\'ve deactivated the below sold-to address:"}],"commerce.commerce-ship-to-party-archival-ccp.message-template.email.subject":[{"type":1,"value":"name"},{"type":0,"value":" Sold to address deactivated"}],"commerce.commerce-soft-limit-breach-ccp.email.automatic-upgrade":[{"type":0,"value":"Automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.email.manage-users":[{"type":0,"value":"Manage "},{"type":1,"value":"product"}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade":[{"type":0,"value":"Don\'t want to upgrade? "}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade-text":[{"type":0,"value":"We recommend removing "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users before your upgrade date. You can do this by selecting Manage users in your "},{"type":1,"value":"product"},{"type":0,"value":" subscription"}],"commerce.commerce-soft-limit-breach-ccp.email.note1":[{"type":0,"value":"If no changes are made, you\'ll be upgraded and we\'ll send you an invoice of prorated costs for the remainder of your billing period."}],"commerce.commerce-soft-limit-breach-ccp.email.note2":[{"type":0,"value":"You don\'t need to take any action. We\'ll automatically upgrade your account and the new charges will be applied."}],"commerce.commerce-soft-limit-breach-ccp.email.product-limit-exceeded":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" user limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" has exceeded by "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder":[{"type":0,"value":"In a few days you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder-caption":[{"type":0,"value":"You\u2019re about to be upgraded"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder":[{"type":0,"value":"Soon you\'ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder-caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder":[{"type":0,"value":"In the next week, you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count. "}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder-caption":[{"type":0,"value":"You\u2019ll be upgraded soon"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.final-reminder":[{"type":0,"value":"Last chance: manage users before automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.reminder":[{"type":0,"value":"Action required before automatic upgrade"}],"commerce.commerce-subscription-activation-ccp.message-template.ecc.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.setup-site":[{"type":0,"value":"Setting up the site means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.with-site":[{"type":0,"value":"Your products are ready for use "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.without-site":[{"type":0,"value":"Set up your subscription and get started"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian partner had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.site-info":[{"type":0,"value":"They\'ll be added to your site shortly."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian reseller had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage these subscriptions from our "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.subscriptions-active":[{"type":0,"value":"Great news \u2014 the subscriptions that you ordered for your customer on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are now active and ready to use. We\u2019ve also informed your customer that they can get started."}],"commerce.commerce-subscription-activation-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to your "},{"type":1,"value":"managedSubscriptionUrl"},{"type":0,"value":" page and following the steps."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.partner-managed-subscription.url":[{"type":0,"value":"Subscription overview"}],"commerce.commerce-subscription-activation-ccp.message-template.email.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.ecc":[{"type":0,"value":"It\u2019s time to set up your subscription"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.partner":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": it\u2019s time to set up subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.singular":[{"type":0,"value":"It\'s time to set up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subscriptions-active":[{"type":0,"value":"Great news \u2014 the "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" is"}]},"other":{"value":[{"type":0,"value":"subscriptions that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active."}],"commerce.commerce-subscription-activation-ccp.message-template.email.time-to-get-set-up":[{"type":0,"value":"It\'s time to get set up"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.add-on.cta":[{"type":0,"value":"Increase usage limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.add-on.cta":[{"type":0,"value":"Get quote for higher limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-auto-downgrade-ccp.email.partner.subject.with.company.name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.limted.features.info":[{"type":0,"value":"This way, your customer can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uncollectible":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uninvoiceable":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we don\u2019t have your customer\u2019s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.explore-plans":[{"type":0,"value":"Explore plans"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.how-to-get-back-to-original-plan":[{"type":0,"value":"If you\'d like to get back to your original plan, go to "},{"children":[{"type":0,"value":"Subscriptions"}],"type":8,"value":"b"},{"type":0,"value":" and select "},{"children":[{"type":0,"value":"Manage"}],"type":8,"value":"b"},{"type":0,"value":" for your product. In "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":", select "},{"children":[{"type":0,"value":"Change plan"}],"type":8,"value":"b"},{"type":0,"value":" to upgrade."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.request-deletion-of-personal-data-link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"). As a result, we\'ve moved your subscription to the Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"You may also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"You are now on the Free plan of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption-v2":[{"type":1,"value":"firstName"},{"type":0,"value":", you\u2019re now on the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" subscription downgraded to a Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.subject-v2":[{"type":0,"value":"We\u2019ve switched you to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.summary-v2":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":", as of today, you\'ve been switched to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.upgrade-your-subscription":[{"type":0,"value":"You can also choose to upgrade to go back to your original plan."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.go-back-original-plan":[{"type":0,"value":"Want to go back on the original plan?"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.review-and-manage-subscription":[{"type":0,"value":"Review the customer\u2019s billing details from our Partner Purchasing Center and change the subscription."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for this subscription. As a result, we\'ve moved the subscription to the Free plan. This way, "},{"type":1,"value":"productName"},{"type":0,"value":" can still be used, but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"Your customer can also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" moved to Free plan due to payment issue"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.partner.email.body.personal-data-retention-summary.link":[{"type":0,"value":"request for deletion of their personal data."}],"commerce.commerce-subscription-auto-upgrade-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Your customer can now enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, with instructions."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.email.icon-warning.alt-text":[{"type":0,"value":"Icon - Warning"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Important things to know about "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions2":[{"type":0,"value":"Cancel your subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you\u2019ll just need to make sure your Atlassian billing partner has the correct billing details. We\u2019ve also sent them an email with instructions."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been upgraded to the "},{"type":1,"value":"planName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject2":[{"type":0,"value":"Action required to prevent deactivation"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.add-payment-details":[{"type":0,"value":"Add payment details before the trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", otherwise the subscription will be deactivated."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access":[{"type":0,"value":"You\u2019ll lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" if you don\u2019t take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.caption.take-action-avoid-site-deactivation":[{"type":0,"value":"Take action, avoid site deactivation"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019ve already added your payment details, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject2":[{"type":0,"value":"Action required to prevent deactivation"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-admin-partner.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or have your customer\u2019s admin remove users so you can switch back to Free in the "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.add-payment-or-remove-users":[{"type":0,"value":"To keep unlimited and users stay on Standard, ensure your Atlassian billing partner updates your billing details. We\u2019ve also sent them instructions. To switch back to Free, "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.take-action":[{"type":0,"value":"Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation. For help, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.direct-customer.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":" to switch back to the Free plan. Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.over-free-limit-moved-to-standard":[{"type":0,"value":"You\'re over the Free user limit, so we moved you to Standard, which includes unlimited users."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.partner-purchasing-center":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.remove-users":[{"type":0,"value":"remove users"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link2.no-translate":[{"type":1,"value":"envPrefix"},{"type":0,"value":"atlassian.com\\/partner-managed-subscriptions"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.caption":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.closing-line":[{"type":0,"value":"Your new bill date will be in effect from the next billing cycle. To transition you to the new\\n\\t\\t\\t\\t\\t  bill date, pro-rated adjustments will be applied to your next invoice."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.first-line":[{"type":0,"value":"We\u2019ve processed your request to change the bill date for your "},{"type":1,"value":"productName"},{"type":0,"value":"\\n\\t\\t\\t\\t\\t\\t("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription to "},{"type":1,"value":"requestedNextBillingDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.second-line":[{"type":0,"value":"If you have any other product and subscriptions on the same site that belong to the same product family,\\n            they need to be billed together. That means we\u2019ve changed the bill date for those subscriptions too."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template.email.subject":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-cancellation-ecc.email.body.billing-partner":[{"type":0,"value":"Atlassian billing partner"}],"commerce.commerce-subscription-cancellation-ecc.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" subscription is canceled"}],"commerce.commerce-subscription-cancellation-ecc.email.body.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-ecc.email.body.data-will-be-deleted":[{"type":0,"value":"Data will be deleted within 60 days from the date of cancellation. If you\u2019d like to request deletion of the data earlier, "}],"commerce.commerce-subscription-cancellation-ecc.email.body.reactivate":[{"type":0,"value":"Your Atlassian billing partner can ask us to reactivate the subscription if needed. If you weren\u2019t expecting this email, you can contact us."}],"commerce.commerce-subscription-cancellation-ecc.email.body.this-is-to-let-you-know":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption.twc":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.body.sub-cancel-note.twc":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.received-request":[{"type":0,"value":"We\u2019ve received your request to cancel your subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.sub-cancel-note":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.billing-partner-details.twc":[{"type":0,"value":"Your billing partner details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.data-deletion-note":[{"type":0,"value":"Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you\u2019d like to request deletion of personal data, "},{"type":1,"value":"contactSupport"},{"type":0,"value":". Learn about "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request.twc":[{"type":0,"value":"We\'ve received your request to cancel your subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.ul.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.ul.siteURL":[{"type":0,"value":"("},{"type":1,"value":"siteURL"},{"type":0,"value":")"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject.twc":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-user.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.customer-details.twc":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy":[{"type":0,"value":"Atlassian\u2019s Privacy Policy"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-billing-partner":[{"type":0,"value":"You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription":[{"type":0,"value":"Keeping the subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription.twc":[{"type":0,"value":"Your customer contact can undo the cancellation at any time from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner-managed-subscriptions-link":[{"type":1,"value":"partnerManagedSubscriptionsLink"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link":[{"type":0,"value":"Learn how to undo a cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request":[{"type":0,"value":"We\u2019ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request.twc":[{"type":0,"value":"We\u2019ve received your customer\u2019s request to cancel their subscription."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note.twc":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". Until then, the subscription can still be used. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.subscription-details.twc":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ul.subscription":[{"type":0,"value":"Subscription: "}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name.twc":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name.twc":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.body.could-not-process-payment":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription since we were unable to process your payment. "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for the following subscription.As a result, the subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject.no-customer-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.cta-direct-customer.reactivate-subscription":[{"type":0,"value":"Don\u2019t worry, all\u2019s not lost! You can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days, we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription-button":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.product-list-item":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"},{"type":0,"value":")"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.update-payment-details":[{"type":0,"value":"We recommend updating your payment details to ensure this doesn\'t happen again."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.payment-details-up-to-date":[{"type":0,"value":"To avoid this in the future, ensure your payment details are up to date."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes canceled"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-view-cancel-subscription":[{"type":0,"value":"You can view or cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.managed-subscriptions-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-manage-subscription":[{"type":0,"value":"You can manage the subscription from the "},{"type":1,"value":"partnerPurchaseCentralUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, your customer\u2019s subscriptions are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-view-cancel-subscription":[{"type":0,"value":"Your customer contact can view and cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"Based on a quote that you\u2019ve already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-view-cancel-subscription":[{"type":0,"value":"You can view and manage your subscription from your billing account. "}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":" We\u2019ll charge your chosen payment details annually, and your subscription will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":"We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.auto-renewal":[{"type":0,"value":"As requested, your subscription has now been moved to the annual (auto-renewal) plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.termed":[{"type":0,"value":"As requested, your subscription has now been moved to the annual plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.caption":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":"We\u2019ll charge your chosen payment details annually for this subscription, and it will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":" We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.auto-renewal":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n\\t\\t\\t\\tAs requested, your subscription has been moved to an annual (auto-renewal) plan, which will start after\\n\\t\\t\\t\\tyour trial period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.termed":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n                As requested, your subscription has been moved to an annual plan, which will start after your trial\\n                period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.subject":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.charge-quantities-added-message":[{"type":0,"value":"You added new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to your subscription. Based on these changes, we\u2019ve adjusted your billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and prorated the cost for new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for the remaining time in your billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.estimated-bill":[{"type":0,"value":"Your estimated bill for the next billing cycle is "},{"children":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"type":8,"value":"b"},{"type":0,"value":" (excluding tax)."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.final-invoice-details":[{"type":0,"value":"Your final invoice will reflect all "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of your current billing period and the subsequent prorated charges."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.to-view-bill":[{"type":0,"value":"To view your bill breakdown and usage details, visit your "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":" page."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.charge-quantities-added-message":[{"type":0,"value":"More "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been added to the following subscription:"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.final-invoice-details":[{"type":0,"value":"The final invoice will reflect the total number of "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of the current billing cycle."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.p2-billing-adjusted":[{"type":0,"value":"The billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been adjusted to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and the cost for the new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" has been prorated for the remaining time in the billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.ppc":[{"type":0,"value":"You can view the usage details from our "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your customer\u2019s team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.app-retiring":[{"type":0,"value":"We wanted to let you know that we\u2019re no longer offering "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". "}],"commerce.commerce-subscription-offering-cancellation-ccp.email.atlassian-suite":[{"type":0,"value":"Atlassian suite"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-at-end-of-billing-cycle":[{"type":0,"value":"This means your subscription will be canceled at the end of your current billing cycle."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-immediately":[{"type":0,"value":"This means your subscription will be canceled 30 days from the date of this email."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-on-offering-expiry-date":[{"type":0,"value":"This means your subscription will be canceled on "},{"type":1,"value":"expiryDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.caption":[{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is being retired"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.marketplace-apps":[{"type":0,"value":"Marketplace apps"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.other-plans-available":[{"type":0,"value":"There may still be other "},{"type":1,"value":"appName"},{"type":0,"value":" plans available \u2014 you can check out our "},{"type":1,"value":"atlassianSuite"},{"type":0,"value":" of products or "},{"type":1,"value":"marketplaceApps"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription will be canceled"}],"commerce.commerce-subscription-offering-movement-ccp.email.app-getting-replaced":[{"type":0,"value":" The developers of "},{"type":1,"value":"appName"},{"type":0,"value":" are retiring this app and replacing it with a free version. Your paid\\n                subscription will transition to "},{"type":1,"value":"freeAppName"},{"type":0,"value":". At the end of your current billing cycle, you\u2019ll no\\n                longer be charged to use this app."}],"commerce.commerce-subscription-offering-movement-ccp.email.caption":[{"type":0,"value":"Your paid subscription for this app will convert to a free subscription"}],"commerce.commerce-subscription-offering-movement-ccp.message-template.email.subject":[{"type":1,"value":"appName"},{"type":0,"value":" is being retired."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp-g.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and billing details on your "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.manage-url":[{"type":0,"value":"Manage Subscriptions"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.ba-when-the-trial-ends":[{"type":0,"value":"Your subscription will be canceled, unless you place an order for the paid plan before the trial end date. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.bu-when-the-trial-ends":[{"type":0,"value":"When you\'re ready to start paid subscription, your billing admin will need to use the quote we send them to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-partner-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p2.partner":[{"type":0,"value":"When trial ends, the subscription will be deactivated. To extend the trial "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3":[{"type":0,"value":"We\'ve sent a quote to your billing admin. When you\'re ready to start your paid subscription, your billing admin will need to use the quote to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3-admin":[{"type":0,"value":"During your trial, we\'ll send you a quote. When you\'re ready to start your paid subscription, you can use the quote to place the order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.reach-out-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.ba.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to the included amount for each quota. If they want extra usage straight away you can contact us. Otherwise, they\u2019ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-details":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-cbp-details":[{"type":0,"value":"Your new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.upgraded-cbp-details":[{"type":0,"value":"The new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-cc.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allowance for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.caption-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.cbps-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to the included amount for each quota type. If they want extra usage straight away you can contact us. Otherwise, they\u2019ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":". You won\'t be charged if you switch before the trial ends."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.rovo-dev-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-on":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.twc-as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends"},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.twc-good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-description":[{"type":0,"value":", and you\u2019ll continue to be charged for your existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new.partners":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin":[{"type":0,"value":"For a seamless transition when your trial ends, you\'ll need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin-button":[{"type":0,"value":"Add payment details"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-user":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.twc.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption.grouped":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans.grouped":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences.grouped":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject.grouped":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details.grouped":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption.grouped":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans.grouped":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details.grouped":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-ccp-g.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you left them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.email.body.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you \\n\\t\\t\\t\\t\\t\\t\\t\\tleft them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information-next":[{"type":0,"value":"If you\u2019ve already settled the outstanding amount, you\u2019re all set. If not, settling it immediately will ensure uninterrupted service and prevent any future deactivations."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information.partner":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your customer\u2019s data and preferences will be as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.what\'s-next":[{"type":0,"value":"What\u2019s next"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription trial successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription trial."}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.subject.customerCompanyName":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.trial.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information":[{"type":0,"value":"When your trial ends, we\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information.partner":[{"type":0,"value":"When the trial ends, we\u2019ll charge the chosen payment method and send an invoice within 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.caption":[{"type":0,"value":"We\'ve reactivated your subscriptions"}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.details":[{"type":0,"value":"Your data and preferences are just as you left them, so your team can jump back in straight away."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.intro":[{"type":0,"value":"As requested, we\'ve reactivated "},{"type":1,"value":"numOfReactivatedSubscriptions"},{"type":0,"value":" subscriptions in the last 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.subject":[{"type":0,"value":"Your daily reactivations"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure your service continues smoothly, we\'ve moved you back on your previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription-change-plan":[{"type":0,"value":"Go to Manage subscription, then Change plan. "}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.payment-details-up-to-date":[{"type":0,"value":"Make sure your payment details are up to date."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users you have exceeds the user limit allowed on your updated plan. You can do this by heading to your Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure service continues smoothly, we\'ve changed the subscription back to its previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users exceeds the user limit allowed on the updated plan. You can do this from the Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.manage-subscription":[{"type":0,"value":"Ensure the payment details are up to date then manage the subscription in Partner Purchasing Center."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription changed"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-key":[{"type":0,"value":"Users:"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-value":[{"type":1,"value":"users"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.direct-customer-whats-next":[{"type":0,"value":"You can use your current plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.nonpause-billing-accepted-request":[{"type":0,"value":"We\'ve accepted your request to move your subscription from monthly to annual (auto-renewal) plan, which will start at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.nonpause-billing-caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-accepted-request":[{"type":0,"value":"You can use the current plan, but your partner would need to contact us for any modifications. "}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details":[{"children":[{"type":0,"value":"Subscription:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details-billing-partner":[{"children":[{"type":0,"value":"Atlassian billing partner:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"billingPartner"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.nonpause-billing-current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-accepted-request":[{"type":0,"value":"The customer can continue with the existing plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"The billing cycle for one of your customer\u2019s subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ve also informed your customer about the change."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-wont-billed":[{"type":0,"value":"Your customer won\'t be billed between the end of the current monthly billing cycle and the start of the annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.wont-billed.direct-customer-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.caption":[{"type":0,"value":"Your billing frequency will soon be changed"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.contact-us":[{"type":0,"value":"If you have any questions concerning this change, please contact us."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.request-to-change-bill-freq":[{"type":0,"value":"We received a request to change the billing frequency for your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.when-will-cycle-change":[{"type":0,"value":"We\u2019ll change your "},{"type":1,"value":"oldBillingCycleName"},{"type":0,"value":" subscription to "},{"type":1,"value":"newBillingCycleName"},{"type":0,"value":" subscription at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.message-template.email.subject":[{"type":0,"value":"Your request to change your billing frequency"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.caption":[{"type":0,"value":"Welcome to the "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.charge-chosen-payment-method":[{"type":0,"value":"We\'ll charge your chosen payment method within 24 hours and send you a payment confirmation along with your invoice"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.caption":[{"type":0,"value":"Welcome to your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision":[{"type":0,"value":"If you decide that this isn\u2019t for you, "},{"type":1,"value":"content"},{"type":0,"value":" "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-multiple-offering":[{"type":0,"value":"you can change your plan from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-single-offering":[{"type":0,"value":"you can cancel anytime from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.great-news":[{"type":0,"value":"Great news \u2014 your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.how-addon-billed":[{"type":0,"value":"Find out more about "},{"type":1,"value":"manageAddonLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.manage-addon-link":[{"type":0,"value":"how add-ons are billed"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.on-pricing-plan":[{"type":0,"value":" on "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com\\/partner-managed-subscriptions"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.caption":[{"type":0,"value":"Welcome to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision":[{"type":0,"value":"If your customer decides this isn\u2019t for them, they can "},{"type":1,"value":"content"},{"type":0,"value":" at any time from "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-multiple-offering":[{"type":0,"value":"change their plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-single-offering":[{"type":0,"value":"cancel the subscription"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.great-news":[{"type":0,"value":"Great news \u2014 "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription"},{"type":1,"value":"companyName"},{"type":0,"value":" is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.personal-information":[{"type":0,"value":"Remember - your invoice contains personal information such as your address and other billing admin details, so you should only share it with trusted sources."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan":[{"type":0,"value":"Change plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan-and-upgrade":[{"type":0,"value":" and upgrade your subscription. Don\u2019t forget to add your payment details so you can use "},{"type":1,"value":"productName"},{"type":0,"value":" without any interruptions."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.manage-subscription-button":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.no-payment-info":[{"type":0,"value":"Since we dont have your complete billing information, we moved you to the Free plan. You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" but with limited features."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.product-info":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is now on the Free plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.to-get-back-go-to":[{"type":0,"value":"Want to go back on the "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" plan? Select "}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.trial-has-ended":[{"type":0,"value":"Your "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" has ended. We hope you enjoyed it!"}],"commerce.commerce-subscription-transferred-ccp-g.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.can-now-manage":[{"type":0,"value":"You can now manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.uninterrupted-service":[{"type":0,"value":"To ensure uninterrupted access to your subscriptions, add your payment details before your bill end date."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can view and cancel the subscription by going to "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-from-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-to-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-from-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-to-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.can-not-manage":[{"type":0,"value":"You can no longer manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":". However, all the invoices up to the date of transfer are still available."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.caption":[{"type":0,"value":"Subscription removed from billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.product-transferred-info":[{"type":0,"value":"If you had any other product and subscriptions on the same site that belonged to the same product family,\\n\\t\\t\\tthey need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription from your Billing Account, "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.caption":[{"type":0,"value":"Subscription added to your billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.product-transferred-info":[{"type":0,"value":"If the billing account "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":" had any other product and subscriptions on the same site that belonged to the same product family, they need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\u2019ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-customer-billing-account.caption":[{"type":0,"value":"Subscription transferred to your billing account"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.trial-ended-message":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". Your paid plan has now started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.trial-ended-message":[{"type":0,"value":"The free "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended, and the paid period has started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge the chosen payment method and send you an invoice soon, along with the payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject.without-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.moved-back-old-plan":[{"type":0,"value":"The subscription will be moved back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan. You don\'t have to pay any additional charges for the trial period used as we continued your billing per your "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan while on trial. If you were initially on the Free plan, you won\'t be charged anything. "}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.subscription-opted-out-from-to":[{"type":0,"value":"As requested, we\'ve ended the no-cost "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial of the following product:"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"If needed, you can always restart the trial from our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial ended on request"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.trial-ended-message":[{"type":0,"value":"The no-cost "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.upgrade-offering-message":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" paid plan:"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"To view the subscription, visit our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.we-will-charge-message":[{"type":0,"value":"We\u2019ll charge you for a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with the payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan has started"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": No cost "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" trial period has ended"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.ba-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.bu-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.cancel":[{"type":0,"value":"If you decide this isn\u2019t for you, you can cancel your subscription before your trial ends by logging in to your account."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.on-trial":[{"type":0,"value":"Good news \u2014 you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.trial-auto-convert":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.lets-make-it-official":[{"type":0,"value":"Let\u2019s make it official"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-flies":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is coming to an end"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-to-make-a-choice":[{"type":1,"value":"firstName"},{"type":0,"value":", it\u2019s time to make a choice"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.add-payment":[{"type":0,"value":"If you want to continue with the paid plan, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion":[{"type":0,"value":"If you want to continue, you don\u2019t need to do anything. When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off":[{"type":0,"value":"Your subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"You\u2019ll be moved back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan":[{"type":0,"value":"You can change or cancel your subscription before your trial ends by going to "},{"type":1,"value":"changePlanLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan.3-days-left":[{"type":0,"value":"You\u2019ll be downgraded to the Free plan if you haven\u2019t added payment details and you have fewer than 10 users."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, we\u2019ll move you to the Free plan \u2014 as long as you meet the user limit requirements. If not, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.extend-trial":[{"type":0,"value":"If you\u2019d like to extend your trial, you\u2019ll need to contact us at "},{"type":1,"value":"salesOpsSupportEmail"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.proceed-add-payment.3-days-left":[{"type":0,"value":"To choose a different plan, "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending.3-days-left":[{"type":0,"value":"Add your payment details to keep your team going strong with the features that work best for them."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.scheduled-for-cancellation":[{"type":0,"value":"You can undo the cancellation by "},{"type":1,"value":"contactingUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end-twc":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial and your team\'s making the most of the increased collaboration."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end.3-days-left":[{"type":0,"value":"There are "},{"children":[{"type":0,"value":"3 days left"}],"type":8,"value":"strong"},{"type":0,"value":" in your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial, but you\u2019ve got options."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.features.your-features-include":[{"children":[{"type":0,"value":"Your features include:"}],"type":8,"value":"b"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.end-of-trial-with-pde":[{"type":0,"value":"Your subscription begins on "},{"type":1,"value":"subscriptionStartDate"},{"type":0,"value":". Learn about your plan\u2019s features and see what they can do for you."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.end-of-trial-with-pde":[{"type":0,"value":"Ready for your next chapter?"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off":[{"type":0,"value":"When the trial ends, the subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-upgrade-trial":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, the subscription will be moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and charged on the next bill date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.deactivate-if-payment-not-added":[{"type":0,"value":"To continue, add payment details (if you haven\u2019t already) before your trial ends to avoid deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"To continue with the paid plan, add payment details (if you haven\u2019t already) before your trial ends to avoid downgrading to the Free plan or deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.extend-trial":[{"type":0,"value":"To extend the trial, "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your customer\'s "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.scheduled-for-cancellation":[{"type":0,"value":"The trial is scheduled for cancellation. If your customer wants to undo the cancellation, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.add-payment":[{"type":0,"value":"Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.end-of-trial-with-pde":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.keep-plan":[{"type":0,"value":"Keep your "},{"type":1,"value":"productName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.add-payment":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.trial-ends-soon":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.trial-ends-soon":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.add-payment-details":[{"type":0,"value":"We noticed that we don\'t have your payment details on file. Add payment details before the renewal date to avoid any disruptions to your subscription."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.caption":[{"type":0,"value":"Your upcoming renewal"}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.payment-method-charged":[{"type":0,"value":"We\u2019ll charge your chosen payment method at this time. If you want to use a different payment method, update your details before the renewal date."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.renewal-reminder":[{"type":0,"value":"This is a friendly reminder that your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will renew on "},{"type":1,"value":"renewalDate"},{"type":0,"value":". Here are the details:"}],"commerce.commerce-subscription-upcoming-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription renews soon"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-trial-extension-ad.created-date-bold.key":[{"type":0,"value":"Created date: "}],"commerce.commerce-trial-extension-ad.created-date-value":[{"type":1,"value":"createdDate"}],"commerce.commerce-trial-extension-ad.created-date.key":[{"type":1,"value":"createdDateKey"}],"commerce.commerce-trial-extension-ad.email.approved":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has approved the request."}],"commerce.commerce-trial-extension-ad.email.caption":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.email.declined":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has declined the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.default":[{"type":0,"value":"Your request for a trial extension has been received and is being processed."}],"commerce.commerce-trial-extension-ad.email.in-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" is the assignee of the approval request."}],"commerce.commerce-trial-extension-ad.email.reasons-provided":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has provided supporting reasons."}],"commerce.commerce-trial-extension-ad.email.reasons-requested":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has requested supporting reasons."}],"commerce.commerce-trial-extension-ad.email.request-cancelled":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has cancelled the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.waiting-for-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has submitted a new Trial Extension request."}],"commerce.commerce-trial-extension-ad.initiator-id-bold.key":[{"type":0,"value":"Initiator: "}],"commerce.commerce-trial-extension-ad.initiator-id-value":[{"type":1,"value":"initiator"}],"commerce.commerce-trial-extension-ad.initiator-id.key":[{"type":1,"value":"initiatorKey"}],"commerce.commerce-trial-extension-ad.message-template.email.subject":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id-bold.key":[{"type":0,"value":"Request ID: "}],"commerce.commerce-trial-extension-ad.request-id-value":[{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id.key":[{"type":1,"value":"requestIdKey"}],"commerce.commerce-trial-extension-ad.status-bold.key":[{"type":0,"value":"Status: "}],"commerce.commerce-trial-extension-ad.status-value":[{"type":1,"value":"status"}],"commerce.commerce-trial-extension-ad.status.key":[{"type":1,"value":"statusKey"}],"commerce.commerce-trial-extension-ad.subscription-bold.key":[{"type":0,"value":"Subscription: "}],"commerce.commerce-trial-extension-ad.subscription-value":[{"type":1,"value":"entitlementNumber"}],"commerce.commerce-trial-extension-ad.subscription.key":[{"type":1,"value":"subscriptionKey"}],"commerce.commerce-trial-extension-ad.support-ticket-id-bold.key":[{"type":0,"value":"Support Ticket: "}],"commerce.commerce-trial-extension-ad.support-ticket-id-value":[{"type":1,"value":"supportTicket"}],"commerce.commerce-trial-extension-ad.support-ticket-id.key":[{"type":1,"value":"supportTicketKey"}],"commerce.commerce-trial-extension-ad.total-trial-length-bold.key":[{"type":0,"value":"Total days on trial so far: "}],"commerce.commerce-trial-extension-ad.total-trial-length-value":[{"type":1,"value":"currentTotalTrialLength"}],"commerce.commerce-trial-extension-ad.total-trial-length.key":[{"type":1,"value":"totalTrialLengthKey"}],"commerce.commerce-trial-extension-ad.trial-length-bold.key":[{"type":0,"value":"Request: "}],"commerce.commerce-trial-extension-ad.trial-length-value":[{"type":0,"value":"Extend trial for "},{"type":1,"value":"netTrialDays"},{"type":0,"value":" days"}],"commerce.commerce-trial-extension-ad.trial-length.key":[{"type":1,"value":"requestKey"}],"commerce.commerce.commerce-ship-to-party-archival-ccp.email.body.caption":[{"type":1,"value":"name"},{"type":0,"value":": Sold to address deactivated"}],"commerce.common-ui.manage-subscription-from-ppc-homepage":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":"."}],"commerce.common-ui.ppc":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.common.atlassian-privacy-policy":[{"type":0,"value":"Atlassian Privacy Policy"}],"commerce.common.contact-us-to-talk-or-downgrade-to-free":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce.common.contact-your-bank-for-more-info":[{"type":0,"value":"Contact your bank if you need more information about the issue."}],"commerce.common.contacting-our-support-team":[{"type":0,"value":"contacting our support team"}],"commerce.common.contacting-us":[{"type":0,"value":"contacting us"}],"commerce.common.data-retention-and-backup-policy":[{"type":0,"value":"data retention and backup policies"}],"commerce.common.data-storage-faqs":[{"type":0,"value":"Data Storage FAQs"}],"commerce.common.downgrade-to-a-free-plan":[{"type":0,"value":"downgrade to a free plan"}],"commerce.common.email.atl-logo.alt-text":[{"type":0,"value":"Atlassian logo"}],"commerce.common.email.billing-url":[{"type":1,"value":"url"}],"commerce.common.email.bitbucket-logo.alt-text":[{"type":0,"value":"Bitbucket logo"}],"commerce.common.email.compass-logo.alt-text":[{"type":0,"value":"Compass logo"}],"commerce.common.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.common.email.csm-logo.alt-text":[{"type":0,"value":"Customer Service Management logo"}],"commerce.common.email.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"commerce.common.email.guard-logo.alt-text":[{"type":0,"value":"Guard logo"}],"commerce.common.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.common.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.common.email.loom-logo.alt-text":[{"type":0,"value":"Loom logo"}],"commerce.common.email.rovo-dev-logo.alt-text":[{"type":0,"value":"Rovo Dev logo"}],"commerce.common.email.rovo-logo.alt-text":[{"type":0,"value":"Rovo logo"}],"commerce.common.email.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.common.email.talent-logo.alt-text":[{"type":0,"value":"Talent logo"}],"commerce.common.if-you-are-unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce.common.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.common.manage-subscription-document-link":[{"type":0,"value":"Manage your subscription for Standard and Premium plans"}],"commerce.common.subscriptiom-reactivation-link":[{"type":0,"value":"reactivate your subscription"}],"commerce.common.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.email.body.what-happens-if-your-customer-uses-extra":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.email.changed-your-mind":[{"type":0,"value":"Changed your mind?"}],"commerce.email.cms.learn-more":[{"type":0,"value":"Pay later by invoice."}],"commerce.email.dont-want-continue":[{"type":0,"value":"Don\'t want to continue with the subscription?"}],"commerce.email.dont-want-to-cancel":[{"type":0,"value":"Don\'t want to cancel?"}],"commerce.email.extra-usage-charge-for-metered-billing":[{"type":0,"value":"Remember, if the included quantity or allowance for any of the usage types on the subscription are exceeded each billing cycle, extra usage charges will be added to the next invoice. "},{"type":1,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.email.how-to":[{"type":0,"value":"How to pay your invoices"}],"commerce.email.included-products":[{"type":0,"value":"Included products:"}],"commerce.email.last-page":[{"type":0,"value":"The last page of your invoice includes Atlassian\u2019s account details and instructions on how to pay."}],"commerce.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"}],"commerce.email.list.payment-method":[{"type":0,"value":"Payment method: Pay later by invoice"}],"commerce.email.list.payment-terms":[{"type":0,"value":"Payment terms: "},{"type":1,"value":"netTermsDuration"}],"commerce.email.list.taxId":[{"type":1,"value":"identifierName"},{"type":0,"value":": "},{"type":1,"value":"id"}],"commerce.email.new-plan-includes":[{"type":0,"value":"Your new plan includes:"}],"commerce.email.payment-days":[{"type":0,"value":"You\u2019ll have "},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the order invoice date to send your payment to Atlassian. You can pay using bank transfer or ACH\\/check (U.S. banks). "}],"commerce.email.subscription-and-billing-support-url":[{"type":0,"value":"More about how billing works."}],"commerce.email.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.email.subscription-includes":[{"type":0,"value":"Your subscription includes:"}],"commerce.email.subscription-includes-quotes":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.email.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.email.teamwork-collection":[{"type":0,"value":"Teamwork Collection can make it easy for your whole organization to work more effectively together - "},{"type":1,"value":"findOut"},{"type":0,"value":"."}],"commerce.email.teamwork-collection.find-out":[{"type":0,"value":"find out more about Atlassian collections"}],"commerce.email.the.new-plan-includes":[{"type":0,"value":"The new plan includes:"}],"commerce.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.email.view-usage":[{"type":0,"value":"View usage"}],"commerce.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.email.what-do-you-need-to-do":[{"type":0,"value":"What you need to do:"}],"commerce.email.what-happens-when-trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.whats-next":[{"type":0,"value":"What\u2019s next?"}],"commerce.learn-more":[{"type":0,"value":"To learn more, see "},{"type":1,"value":"learnMore"}],"commerce.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce.message-template.email.explore-all-features-button.explore-all-features":[{"type":0,"value":"Explore all features"}],"commerce.message-template.email.features-list.confluence.premium.analytics":[{"children":[{"type":0,"value":"Analytics:"}],"type":8,"value":"b"},{"type":0,"value":" See who has viewed a page and when"}],"commerce.message-template.email.features-list.confluence.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.confluence.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.confluence.standard.page-insights":[{"children":[{"type":0,"value":"Page insights:"}],"type":8,"value":"b"},{"type":0,"value":" See engagement data, like page views"}],"commerce.message-template.email.features-list.confluence.standard.page-permissions":[{"children":[{"type":0,"value":"Page permissions:"}],"type":8,"value":"b"},{"type":0,"value":" Choose who can view, edit, and comment"}],"commerce.message-template.email.features-list.confluence.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jira.premium.cross-team-planning":[{"children":[{"type":0,"value":"Cross-team planning:"}],"type":8,"value":"b"},{"type":0,"value":" See all projects and timelines in one place"}],"commerce.message-template.email.features-list.jira.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your work and remove human error"}],"commerce.message-template.email.features-list.jira.standard.data-residency":[{"children":[{"type":0,"value":"Data residency:"}],"type":8,"value":"b"},{"type":0,"value":" Choose where your data is stored"}],"commerce.message-template.email.features-list.jira.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jpd.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jpd.premium.roadmaps":[{"children":[{"type":0,"value":"Roadmaps:"}],"type":8,"value":"b"},{"type":0,"value":" See multiple roadmaps in a single view"}],"commerce.message-template.email.features-list.jpd.premium.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jpd.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up work and reduce human error"}],"commerce.message-template.email.features-list.jpd.standard.published-views":[{"children":[{"type":0,"value":"Published views:"}],"type":8,"value":"b"},{"type":0,"value":" Share read-only views with anyone"}],"commerce.message-template.email.features-list.jpd.standard.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jsm.premium.ai-features":[{"children":[{"type":0,"value":"AI features:"}],"type":8,"value":"b"},{"type":0,"value":" AI-powered agents, search, and chat"}],"commerce.message-template.email.features-list.jsm.premium.change-automation":[{"children":[{"type":0,"value":"Change automation:"}],"type":8,"value":"b"},{"type":0,"value":" Gate deploys and automate record creation"}],"commerce.message-template.email.features-list.jsm.premium.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.jsm.standard.branded-help-center":[{"children":[{"type":0,"value":"Branded help center:"}],"type":8,"value":"b"},{"type":0,"value":" Use your company\'s branding and URLs"}],"commerce.message-template.email.features-list.jsm.standard.enhanced-support":[{"children":[{"type":0,"value":"Enhanced support:"}],"type":8,"value":"b"},{"type":0,"value":" Get business hour support from our experts"}],"commerce.message-template.email.features-list.jsm.standard.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.loom.business-ai.advanced-editing":[{"children":[{"type":0,"value":"Advanced editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim, stitch, remove silence and filler words"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.loom.business.editing":[{"children":[{"type":0,"value":"Editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim out mistakes or stitch multiple videos together"}],"commerce.message-template.email.features-list.loom.business.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.service-collection.premium.advanced-aiops":[{"children":[{"type":0,"value":"Advanced AIOps:"}],"type":8,"value":"b"},{"type":0,"value":" Fast alert grouping, incident creation, and more"}],"commerce.message-template.email.features-list.service-collection.premium.ai-agents":[{"children":[{"type":0,"value":"AI agents:"}],"type":8,"value":"b"},{"type":0,"value":" Save time and use AI for basic conversational support"}],"commerce.message-template.email.features-list.service-collection.premium.asset-management":[{"children":[{"type":0,"value":"Asset management:"}],"type":8,"value":"b"},{"type":0,"value":" Manage the lifecycle of assets and services"}],"commerce.message-template.email.features-list.service-collection.standard.ai-powered-agents":[{"children":[{"type":0,"value":"AI-powered agents:"}],"type":8,"value":"b"},{"type":0,"value":" Automate support, resolve requests faster"}],"commerce.message-template.email.features-list.service-collection.standard.custom-help-center":[{"children":[{"type":0,"value":"Custom help center:"}],"type":8,"value":"b"},{"type":0,"value":" Deliver a seamless support experience"}],"commerce.message-template.email.features-list.service-collection.standard.unlimited-emails":[{"children":[{"type":0,"value":"Unlimited emails:"}],"type":8,"value":"b"},{"type":0,"value":" Talk to customers as much as you need"}],"commerce.message-template.email.upgrade-benefits.compass.body.customizations":[{"type":0,"value":"More customizations"}],"commerce.message-template.email.upgrade-benefits.compass.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benefits.compass.body.reusable-templates":[{"type":0,"value":"20 reusable templates"}],"commerce.message-template.email.upgrade-benifits.compass.body.storage":[{"type":0,"value":"One year of data retention"}],"commerce.message-template.email.upgrade-benifits.compass.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.confluence.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.confluence.body.page-analytics":[{"type":0,"value":"Page analytics"}],"commerce.message-template.email.upgrade-benifits.confluence.body.space-and-page-permissions":[{"type":0,"value":"Space and page permissions"}],"commerce.message-template.email.upgrade-benifits.confluence.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.confluence.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jira.body.create-issues":[{"type":0,"value":"Anonymous access to let external users view and create issues"}],"commerce.message-template.email.upgrade-benifits.jira.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jira.body.issue-permissions":[{"type":0,"value":"Advanced project and issue permissions"}],"commerce.message-template.email.upgrade-benifits.jira.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jira.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.message-template.email.upgrade-benifits.jpd.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jpd.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.message-template.email.upgrade-benifits.jsm.body.automation-rules-per-month":[{"type":0,"value":"500 project automation rules per month"}],"commerce.message-template.email.upgrade-benifits.jsm.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jsm.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jsm.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jsm.body.track-changes":[{"type":0,"value":"Audit logs to troubleshoot and track changes"}],"commerce.message-template.next-steps":[{"type":0,"value":"Next steps:"}],"commerce.message-template.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.next-bill-estimate-common.key":[{"type":0,"value":"Next estimated bill (prorated):"}],"commerce.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.partner-name.key":[{"type":0,"value":"Atlassian billing partner:"}],"commerce.partner-name.value":[{"type":1,"value":"partnerName"}],"commerce.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n    \\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days."}],"commerce.requested-by-common.key":[{"type":0,"value":"Requested by:"}],"commerce.requested-by-common.value":[{"type":1,"value":"orderPlacedBy"}],"commerce.requested-by-common.value-with-email":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"emailLink"},{"type":0,"value":")"}],"commerce.requested-by-common.value-without-email":[{"type":1,"value":"name"}],"commerce.reseller-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from the "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":" page."}],"commerce.reseller-manage-subscriptions-subscription-overview":[{"type":0,"value":"Subscription overview"}],"commerce.ship-to-information.address-key":[{"type":0,"value":"Address:"}],"commerce.ship-to-information.address-value":[{"type":1,"value":"soldToAddress"}],"commerce.ship-to-information.company-name-key":[{"type":0,"value":"Company:"}],"commerce.ship-to-information.company-name-key-alt-customer":[{"type":0,"value":"Customer:"}],"commerce.ship-to-information.company-name-value":[{"type":1,"value":"soldToCompanyName"}],"commerce.ship-to-information.end-customer-contact-key":[{"type":0,"value":"Customer contact:"}],"commerce.ship-to-information.end-customer-contact-value":[{"type":1,"value":"endCustomerContacts"}],"commerce.ship-to-information.invoice-number-key":[{"type":0,"value":"Invoice number:"}],"commerce.ship-to-information.invoice-number-value":[{"type":1,"value":"invoiceNumber"}],"commerce.subscription-common.entitlement-details":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-with-org-name":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") | "},{"type":1,"value":"orgName"}],"commerce.subscription-common.entitlement-details-with-site-url":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteURL"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-without-orgName":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.key":[{"type":0,"value":"Subscription:"}],"commerce.subscription-common.value-with-offering":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-offering-without-entitlement":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"commerce.subscription-common.value-with-pricing-plan":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"pricingPlanName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-product":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"commerce.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"common.cloud-payment-retry-actions.admin-hub-url":[{"type":0,"value":"admin.atlassian.com"}],"common.cloud-payment-retry-actions.atlassian-administration":[{"type":0,"value":"Atlassian administration"}],"common.cloud-payment-retry-actions.billing-console-url":[{"type":0,"value":"admin.atlassian.com\\/billing"}],"common.cloud-payment-retry-actions.billing-overview":[{"type":0,"value":"Billing overview"}],"common.cloud-payment-retry-actions.change-plan":[{"type":0,"value":"Change plan"}],"common.cloud-payment-retry-actions.contact-supportt":[{"type":0,"value":"If you need to speak to our team, you may "},{"type":1,"value":"element"},{"type":0,"value":" to the Atlassian Support Team."}],"common.cloud-payment-retry-actions.contact-us-heading":[{"type":0,"value":"Contact us:"}],"common.cloud-payment-retry-actions.data-storage-faq":[{"type":0,"value":"Data Storage FAQs"}],"common.cloud-payment-retry-actions.downgrade-heading":[{"type":0,"value":"Downgrade to a Free plan:"}],"common.cloud-payment-retry-actions.export-data":[{"type":0,"value":"We advise you to export your business data from your Atlassian instance. For more information, see our "},{"type":1,"value":"element"}],"common.cloud-payment-retry-actions.export-data-heading":[{"type":0,"value":"Export your data:"}],"common.cloud-payment-retry-actions.free":[{"type":0,"value":"Free"}],"common.cloud-payment-retry-actions.free-plan-change":[{"type":0,"value":"Change to the Free plan at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"billingOverview"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" in the "},{"type":1,"value":"subscriptions"},{"type":0,"value":" section. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" for your product. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"planChange"},{"type":0,"value":". Select the "},{"type":1,"value":"free"},{"type":0,"value":" plan and confirm"}],"common.cloud-payment-retry-actions.here-are-actions":[{"type":0,"value":"Here are some actions we suggest you take:"}],"common.cloud-payment-retry-actions.manage":[{"type":0,"value":"Manage"}],"common.cloud-payment-retry-actions.manage-users":[{"type":0,"value":"Manage users"}],"common.cloud-payment-retry-actions.reduce-users":[{"type":0,"value":"If applicable, you\'ll first need to reduce users to 10 or fewer (three agents or fewer for Jira Service Management). Go to your site\'s admin at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"admin"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":". Find users you want to remove, and select "},{"type":1,"value":"showDetails"},{"type":0,"value":"."}],"common.cloud-payment-retry-actions.show-details":[{"type":0,"value":"Show details &gt; Actions &gt; Remove user"}],"common.cloud-payment-retry-actions.submit-ticket":[{"type":0,"value":"Submit a ticket"}],"common.cloud-payment-retry-actions.subscription-details":[{"type":0,"value":"Subscription details"}],"common.cloud-payment-retry-actions.subscriptions":[{"type":0,"value":"Subscriptions"}],"common.cloud-payment-retry-actions.what-if-unable":[{"type":0,"value":"What if I\'m unable to make payments?"}],"common.invoice.manage-subscriptions.partner-info":[{"type":0,"value":"To manage subscriptions, visit our Partner Purchasing Center (PPC)."}],"common.invoice.manage-subscriptions.subscription-info":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"post-office.commerce-access-invalid-payment-hams.caption":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"post-office.commerce-access-invalid-payment-hams.error-message.access":[{"type":0,"value":"We couldn\u2019t process your payment for Atlassian Access since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.bitbucket":[{"type":0,"value":"We couldn\u2019t process your payment for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.cloud":[{"type":0,"value":"We couldn\'t process your payment for Atlassian Cloud since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.server":[{"type":0,"value":"We couldn\u2019t process your payment for "},{"type":1,"value":"productInfoString"},{"type":0,"value":" since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.retry-button":[{"type":0,"value":"Retry Payment"}],"post-office.commerce-access-invalid-payment-hams.retry-message":[{"type":0,"value":"Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or asked to authenticate in a different way."}],"post-office.commerce-common.Contact-us":[{"type":0,"value":"Contact us"}],"post-office.commerce-common.atlassian-support-team":[{"type":0,"value":"Atlassian Support Team"}],"post-office.commerce-common.blocks.regards":[{"type":0,"value":"Regards,"}],"post-office.commerce-common.blocks.thanks":[{"type":0,"value":"Thanks,"}],"post-office.commerce-common.cheers":[{"type":0,"value":"Cheers,"}],"post-office.commerce-common.cheers.from-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.cheers.from-atlassians":[{"type":0,"value":"The Atlassians"}],"post-office.commerce-common.choose-plan-link":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.choose-plan.billing-console":[{"type":0,"value":"Keep Premium plan"}],"post-office.commerce-common.choose-plan.choose-plan.billing-console":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.consumption.included-quantity-details":[{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"includedQuantityUnit"}],"post-office.commerce-common.consumption.summary-included-quantity":[{"type":0,"value":"Included quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity":[{"type":0,"value":"Consumed quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity-details":[{"type":1,"value":"consumedQuantity"},{"type":0,"value":" "},{"type":1,"value":"consumedQuantityUnit"}],"post-office.commerce-common.consumptionl.summary.consumption-percentage":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% consumed"}],"post-office.commerce-common.contact-support-button.partner":[{"type":0,"value":"Contact Support"}],"post-office.commerce-common.contact-us":[{"type":0,"value":"contact us"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-service-management":[{"type":0,"value":"Atlassian Jira Service Management"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-service-collection":[{"type":0,"value":"Atlassian Service Collection"}],"post-office.commerce-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.email.plan-section.description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" 30-day money back guarantee if you forget to cancel."}],"post-office.commerce-common.email.plan-section.explore-plan.link-description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Explore all plans \u2192"}],"type":8,"value":"b"}],"post-office.commerce-common.email.subscription-details-section.billing-cycle-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Billing cycle"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-subtitle.end-of-trial-with-pde":[{"type":0,"value":"First bill estimate"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-suffix.end-of-trial-with-pde":[{"type":0,"value":" (Excludes taxes)"}],"post-office.commerce-common.email.subscription-details-section.plan-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Plan"}],"post-office.commerce-common.email.subscription-details-section.title.end-of-trial-with-pde":[{"type":0,"value":"Subscription details"}],"post-office.commerce-common.email.subscription-details-section.trial-ends-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Trial ends"}],"post-office.commerce-common.email.subscription.description.end-of-trial-with-pde":[{"type":0,"value":"When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"post-office.commerce-common.email.subscription.headline.end-of-trial-with-pde":[{"type":0,"value":"You don\'t need to do anything"}],"post-office.commerce-common.email.subscription.tick-circle-green-icon.end-of-trial-with-pde":[{"type":0,"value":"Green tick circle icon for the billing section"}],"post-office.commerce-common.features-image.confluence-premium":[{"type":0,"value":"Confluence Premium Features"}],"post-office.commerce-common.features-image.confluence-standard":[{"type":0,"value":"Confluence Standard Features"}],"post-office.commerce-common.features-image.jira-premium":[{"type":0,"value":"Jira Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-premium":[{"type":0,"value":"Jira Product Discovery Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-standard":[{"type":0,"value":"Jira Product Discovery Standard Features"}],"post-office.commerce-common.features-image.jira-service-management-premium":[{"type":0,"value":"Jira Service Management Premium Features"}],"post-office.commerce-common.features-image.jira-service-management-standard":[{"type":0,"value":"Jira Service Management Standard Features"}],"post-office.commerce-common.features-image.jira-standard":[{"type":0,"value":"Jira Standard Features"}],"post-office.commerce-common.features-image.loom-business":[{"type":0,"value":"Loom Business Features"}],"post-office.commerce-common.features-image.loom-business-ai":[{"type":0,"value":"Loom Business + AI Features"}],"post-office.commerce-common.features-image.service-collection-premium":[{"type":0,"value":"Service Collection Premium Features"}],"post-office.commerce-common.features-image.service-collection-standard":[{"type":0,"value":"Service Collection Standard Features"}],"post-office.commerce-common.footer-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer-v2.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer-v2.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.commerce-common.footer-v2.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer-v2.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer-v2.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer-v2.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer-v2.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer-v2.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.commerce-common.footer-v2.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer-v2.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.commerce-common.footer-v2.x-alt-text":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.x-title":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer-v2.youtube-title":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.commerce-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer.office-address.we-are-located-at":[{"type":0,"value":"We are located at "}],"post-office.commerce-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.commerce-common.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.formal-goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"post-office.commerce-common.formal-goodbye.contact-representative":[{"type":0,"value":"Contact your Atlassian representative if you have any questions."}],"post-office.commerce-common.formal-thank-you":[{"type":0,"value":"Thank you for taking action at your earliest convenience."}],"post-office.commerce-common.get-in-touch":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouchLink"}],"post-office.commerce-common.need-help-with-contact-us":[{"type":0,"value":"Need help with plans and billing? "},{"type":1,"value":"contactUs"}],"post-office.commerce-common.not-personal-greetings":[{"type":0,"value":"Hi,"}],"post-office.commerce-common.payment-details.add":[{"type":0,"value":"Add payment details"}],"post-office.commerce-common.payment-details.add.v2":[{"type":0,"value":"explore your plan options"}],"post-office.commerce-common.payment-details.update":[{"type":0,"value":"Update payment details"}],"post-office.commerce-common.personal-greetings":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"post-office.commerce-common.product.entitlement-number.billing-cycle":[{"type":0,"value":"Billing cycle: "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.product.entitlement-number.requested-by-email-id":[{"type":0,"value":"Requested by: "},{"type":1,"value":"requestedByEmailId"}],"post-office.commerce-common.product.entitlement-number.site-url.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"}]},"true":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"}]}},"type":5,"value":"hasSiteUrl"}],"post-office.commerce-common.product.entitlement-number.users-count":[{"type":1,"value":"chargeElement"},{"type":0,"value":"s: "},{"type":1,"value":"usersCount"}],"post-office.commerce-common.product.product-title.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"productName"}]},"true":{"value":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"offeringName"},{"type":0,"value":")"}]}},"type":5,"value":"hasOfferingName"}],"post-office.commerce-common.subscription-product-details.bill-estimate-and-currency":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"post-office.commerce-common.subscription-product-details.bill-estimate-title":[{"type":0,"value":"Total bill estimate"}],"post-office.commerce-common.subscription-product-details.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription-product-details.exclude-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscription-product-details.offering-name.user-size.billing-cycle.no-translate":[{"type":1,"value":"siteDetails"}],"post-office.commerce-common.subscription-product-details.product-name.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription-product-details.site-url.no-translate":[{"type":1,"value":"siteURL"}],"post-office.commerce-common.subscription.atlassian-guard-standard":[{"type":0,"value":"Atlassian Guard Standard"}],"post-office.commerce-common.subscription.atlassian-rovo":[{"type":0,"value":"Atlassian Rovo"}],"post-office.commerce-common.subscription.cbp-charge-element-package-network":[{"children":[{"type":0,"value":"Network traffic:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-package-storage":[{"children":[{"type":0,"value":"Package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo Dev credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" credits per user"}],"post-office.commerce-common.subscription.cbp-charge-element-runners":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage":[{"children":[{"type":0,"value":"Storage (Git LFS):"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage-minutes":[{"children":[{"type":0,"value":"Build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.free-access":[{"type":0,"value":"Free access to:"}],"post-office.commerce-common.subscription.included-products":[{"type":0,"value":"Included products:"}],"post-office.commerce-common.subscription.product-title.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.address.no-translate":[{"type":0,"value":"Address: "},{"type":1,"value":"address"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.company.no-translate":[{"type":0,"value":"Company: "},{"type":1,"value":"companyName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.customer-contact.no-translate":[{"type":0,"value":"Customer contact: "},{"type":1,"value":"customerContact"}],"post-office.commerce-common.subscription.product.billing-cycle.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.subscription.product.billing-user-partner-contextual-info.partner-name.no-translate":[{"type":0,"value":"Atlassian billing partner: "},{"type":1,"value":"billingPartner"}],"post-office.commerce-common.subscription.product.charge quantities.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"usageQuantity"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":"s "}],"post-office.commerce-common.subscription.product.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription.product.offering-name.no-translate":[{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"post-office.commerce-common.subscription.product.site-url.no-translate":[{"type":1,"value":"siteUrl"}],"post-office.commerce-common.subscription.rovo-dev-credit-allocation":[{"type":1,"value":"credits"},{"type":0,"value":" Rovo Dev credits per user"}],"post-office.commerce-common.subscriptions-change-plan":[{"type":0,"value":"Subscriptions"}],"post-office.commerce-common.subscriptions.excludes-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscriptions.this-payment-is-for":[{"type":0,"value":"This payment is for:"}],"post-office.commerce-common.subscriptions.total-bill-estimate":[{"type":0,"value":"Total bill estimate:"}],"post-office.commerce-common.subscriptions.total-bill-estimate-after-trial":[{"type":0,"value":"Total bill estimate after trial ends:"}],"post-office.commerce-common.subscriptions.your-estimated-bill-is":[{"type":0,"value":"Your estimated bill is:"}],"post-office.commerce-common.the-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.view-subscription.billing-console":[{"type":0,"value":"View subscription"}],"post-office.commerce-order-fulfilled-ccp.email.billing-account.other-host-type":[{"type":0,"value":"billing account"}],"post-office.commerce-order-fulfilled-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-ccp.email.cmk.support-url":[{"type":0,"value":"page"}],"post-office.commerce-order-fulfilled-ccp.email.direct-customer.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-ccp.email.siteAdmin.cloud":[{"type":0,"value":"site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"}],"post-office.commerce-order-fulfilled-ccp.email.support-url":[{"type":0,"value":"billing support"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.siteAdmin":[{"type":0,"value":"Administration"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.support-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.view-quote-url":[{"type":0,"value":"Learn more"}],"post-office.commerce-payment-failure-hams.email.support.additional_actions":[{"type":0,"value":"additional actions"}],"post-office.commerce-payment-failure-hams.email.title.check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.expiration":[{"type":0,"value":"This doesn\'t have to be a goodbye"}],"post-office.commerce-payment-failure-hams.email.title.expired":[{"type":0,"value":"Your Atlassian subscription has expired"}],"post-office.commerce-payment-failure-hams.email.title.make-it-official":[{"type":0,"value":"Let\'s make it official!"}],"post-office.commerce-payment-failure-hams.email.title.trial-check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.trial-end":[{"type":0,"value":"Your trial has ended. What\'s next?"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.email.partner.set-up":[{"type":0,"value":"set up the collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.direct-customer.set-up":[{"type":0,"value":"set up your collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.partner.set-up":[{"type":0,"value":"sets up the collection"}]}');

});

parcelRegister("9qjfC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hVaCh").then(()=>parcelRequire('jsSSp'));

});

parcelRegister("1YPtK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("41AS9").then(()=>parcelRequire('f2agB'));

});

parcelRegister("1pDv3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4lpFw").then(()=>parcelRequire('58KwD'));

});

parcelRegister("kZq1q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jSHqN").then(()=>parcelRequire('a176G'));

});

parcelRegister("5hsKw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("49h4g").then(()=>parcelRequire('aDDNz'));

});

parcelRegister("bC3ZH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6rtB3").then(()=>parcelRequire('jrL5p'));

});

parcelRegister("8iNEf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1XEYQ").then(()=>parcelRequire('gAz4m'));

});

parcelRegister("2yKW6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8HU45").then(()=>parcelRequire('Di7Ct'));

});

parcelRegister("74Iyp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8OArS").then(()=>parcelRequire('fOKxh'));

});

parcelRegister("g1iaV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("038cM").then(()=>parcelRequire('39lJ5'));

});

parcelRegister("g8fnF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dCr3f").then(()=>parcelRequire('cPKSv'));

});

parcelRegister("5meYG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jVOBG").then(()=>parcelRequire('fyJfi'));

});

parcelRegister("ajHp8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6AM8D").then(()=>parcelRequire('5P1rg'));

});

parcelRegister("1XOUx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8GDyZ").then(()=>parcelRequire('l5SUo'));

});

parcelRegister("chm69", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8JToC").then(()=>parcelRequire('faH00'));

});

parcelRegister("jQY9V", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2oC4k").then(()=>parcelRequire('7zD7u'));

});

parcelRegister("4RzjC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gGgsB").then(()=>parcelRequire('gsYgD'));

});

parcelRegister("gkUNp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gAi0m").then(()=>parcelRequire('2mqrN'));

});

parcelRegister("4GFF9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aY86J").then(()=>parcelRequire('iEgJa'));

});

parcelRegister("hVk0g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aYK9M").then(()=>parcelRequire('3nImY'));

});

parcelRegister("45apl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jE3M9").then(()=>parcelRequire('fdj4W'));

});

parcelRegister("fLUAH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j1unk").then(()=>parcelRequire('iO1k1'));

});

parcelRegister("cvoUC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gvXdM").then(()=>parcelRequire('3p7ZR'));

});

parcelRegister("foXuY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1SyR8").then(()=>parcelRequire('bSuEb'));

});

parcelRegister("4ytfG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4N508").then(()=>parcelRequire('flTgR'));

});

parcelRegister("fIipl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6UruI").then(()=>parcelRequire('cCggp'));

});

parcelRegister("9cwx4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lHrYe").then(()=>parcelRequire('j4MDr'));

});

parcelRegister("fBBHk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4hyAA").then(()=>parcelRequire('4YQfr'));

});

parcelRegister("djau3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("22t2C").then(()=>parcelRequire('kfwSD'));

});

parcelRegister("fsSH7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lJsyV").then(()=>parcelRequire('f4kLw'));

});

parcelRegister("5OV2w", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2sS5p").then(()=>parcelRequire('dyRg0'));

});

parcelRegister("k0g6E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7m77a").then(()=>parcelRequire('lrS2i'));

});

parcelRegister("dg5jx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aPuX9").then(()=>parcelRequire('dZLEh'));

});

parcelRegister("g4RAh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("561p7").then(()=>parcelRequire('k8HS2'));

});

parcelRegister("3CyGm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4rEic").then(()=>parcelRequire('2A3LE'));

});


parcelRegister("3z44W", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $a3967a85ce49413c$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $lBjCy = parcelRequire("lBjCy");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a3967a85ce49413c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a3967a85ce49413c$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("bjK2C")));
        case 'da':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("fB9sQ")));
        case 'de':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("3FxJj")));
        case 'en-GB':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("kY4k0")));
        case 'en-US':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("htwwe")));
        case 'en-XA':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("7xHqL")));
        case 'en-XB':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("h9MNJ")));
        case 'en-ZZ':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("7yc4a")));
        case 'en':
            return $a3967a85ce49413c$var$importHelper(await Promise.resolve((parcelRequire("lBjCy"))));
        case 'es':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("fBGM2")));
        case 'et':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("lX1HN")));
        case 'fi':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("hrgyY")));
        case 'fr':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("92mNf")));
        case 'hr':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("eUsDh")));
        case 'hu':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("60a4o")));
        case 'it':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("lptzv")));
        case 'ja':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("3ehQv")));
        case 'ko':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("SIifo")));
        case 'nb':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("aGHQZ")));
        case 'nl':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("iJUlV")));
        case 'pl':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("kjF9o")));
        case 'pt-BR':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("jCKLW")));
        case 'ro':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("dB0wI")));
        case 'ru':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("lSWP3")));
        case 'sl':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("hT2h7")));
        case 'sr-RS':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("5OYY6")));
        case 'sr-YR':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("evME5")));
        case 'sr':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("jFdQz")));
        case 'sv':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("8jsKh")));
        case 'th':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("8o9vR")));
        case 'tr':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("dLfJU")));
        case 'uk':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("g4vZL")));
        case 'vi':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("aUp8r")));
        case 'zh-CN':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("7gKaj")));
        case 'zh-TW':
            return $a3967a85ce49413c$var$importHelper(await (parcelRequire("k8KRS")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lBjCy));
    }
};

});
parcelRegister("lBjCy", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("bjK2C", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jLrPX").then(()=>parcelRequire('kI9fY'));

});

parcelRegister("fB9sQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eUyOU").then(()=>parcelRequire('9rmw5'));

});

parcelRegister("3FxJj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kWyQP").then(()=>parcelRequire('5jdOI'));

});

parcelRegister("kY4k0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("542YK").then(()=>parcelRequire('6AhPH'));

});

parcelRegister("htwwe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c2Pg5").then(()=>parcelRequire('G5VDb'));

});

parcelRegister("7xHqL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8S8NC").then(()=>parcelRequire('8xOat'));

});

parcelRegister("h9MNJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9VgeF").then(()=>parcelRequire('a4zvS'));

});

parcelRegister("7yc4a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kh20V").then(()=>parcelRequire('9rpMN'));

});

parcelRegister("fBGM2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7QDxP").then(()=>parcelRequire('7D6Cd'));

});

parcelRegister("lX1HN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("af8vx").then(()=>parcelRequire('1V30C'));

});

parcelRegister("hrgyY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8g6U0").then(()=>parcelRequire('03tlj'));

});

parcelRegister("92mNf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ecf8G").then(()=>parcelRequire('2LWij'));

});

parcelRegister("eUsDh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d4HwC").then(()=>parcelRequire('aYsWG'));

});

parcelRegister("60a4o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cwzeb").then(()=>parcelRequire('guIeK'));

});

parcelRegister("lptzv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dqqJK").then(()=>parcelRequire('i6cnj'));

});

parcelRegister("3ehQv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("tlaAi").then(()=>parcelRequire('9LY57'));

});

parcelRegister("SIifo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("duE0v").then(()=>parcelRequire('fKHiY'));

});

parcelRegister("aGHQZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5mQob").then(()=>parcelRequire('lrDbV'));

});

parcelRegister("iJUlV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8swDj").then(()=>parcelRequire('4Y3yO'));

});

parcelRegister("kjF9o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ltbtG").then(()=>parcelRequire('cc10A'));

});

parcelRegister("jCKLW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("auTT6").then(()=>parcelRequire('29ZX6'));

});

parcelRegister("dB0wI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Xnhr").then(()=>parcelRequire('3emE4'));

});

parcelRegister("lSWP3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cGfRS").then(()=>parcelRequire('9nK7X'));

});

parcelRegister("hT2h7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("55oBx").then(()=>parcelRequire('iWBIA'));

});

parcelRegister("5OYY6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aGbvb").then(()=>parcelRequire('bsCeh'));

});

parcelRegister("evME5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aJBRF").then(()=>parcelRequire('5kNUg'));

});

parcelRegister("jFdQz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9vzCL").then(()=>parcelRequire('1DAKk'));

});

parcelRegister("8jsKh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eXHYp").then(()=>parcelRequire('etbb9'));

});

parcelRegister("8o9vR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cVwlN").then(()=>parcelRequire('9GPhw'));

});

parcelRegister("dLfJU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("yVxyC").then(()=>parcelRequire('3aFim'));

});

parcelRegister("g4vZL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bs5Nd").then(()=>parcelRequire('a7bIt'));

});

parcelRegister("aUp8r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6CmcM").then(()=>parcelRequire('318wD'));

});

parcelRegister("7gKaj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j2CZB").then(()=>parcelRequire('gzW4j'));

});

parcelRegister("k8KRS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gkvZi").then(()=>parcelRequire('cLRZa'));

});


parcelRegister("bhgoe", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $447bdae160189cd2$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8YvQi = parcelRequire("8YvQi");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $447bdae160189cd2$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $447bdae160189cd2$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("fc2PE")));
        case 'da':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("kltTM")));
        case 'de':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("l4ytY")));
        case 'en-GB':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("5Vjsg")));
        case 'en-US':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("585xa")));
        case 'en-XA':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("g1MdP")));
        case 'en-XB':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("kY4ZW")));
        case 'en-ZZ':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("bgiau")));
        case 'en':
            return $447bdae160189cd2$var$importHelper(await Promise.resolve((parcelRequire("8YvQi"))));
        case 'es':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("laD48")));
        case 'et':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("9wm30")));
        case 'fi':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("aFuDe")));
        case 'fr':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("bCqeD")));
        case 'hr':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("2vBsF")));
        case 'hu':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("fvZNJ")));
        case 'it':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("cjIir")));
        case 'ja':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("90qHo")));
        case 'ko':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("aUulc")));
        case 'nb':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("9LnUT")));
        case 'nl':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("46Oq9")));
        case 'pl':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("kJfpS")));
        case 'pt-BR':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("5qQ4a")));
        case 'ro':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("kOmOa")));
        case 'ru':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("3tKnh")));
        case 'sl':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("gBUEN")));
        case 'sr-RS':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("jJTpC")));
        case 'sr-YR':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("fqjnK")));
        case 'sr':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("Iuedn")));
        case 'sv':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("7b8ip")));
        case 'th':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("hVZrd")));
        case 'tr':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("lWWuL")));
        case 'uk':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("YSjgN")));
        case 'vi':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("3vrH9")));
        case 'zh-CN':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("c6LMA")));
        case 'zh-TW':
            return $447bdae160189cd2$var$importHelper(await (parcelRequire("kxYGv")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8YvQi));
    }
};

});
parcelRegister("8YvQi", function(module, exports) {
module.exports = JSON.parse('{"INAPP-2131.spotlight.body":[{"type":0,"value":"We\'ve added Confluence so you can organize all of your project documentation. It\'s free for up to 10 users."}],"INAPP-2131.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"INAPP-2270.spotlight.body":[{"type":0,"value":"Collaborate on requirements, meetings notes, retros, and more."}],"INAPP-2270.spotlight.primary":[{"type":0,"value":"Ok"}],"INAPP-2270.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-2270.spotlight.title":[{"type":0,"value":"Create docs without leaving Jira"}],"INAPP-2271.spotlight.body":[{"type":0,"value":"Create a single source of truth for your project docs. It\'s free to try."}],"INAPP-2271.spotlight.primary":[{"type":0,"value":"Ok"}],"INAPP-2271.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-2271.spotlight.title":[{"type":0,"value":"You have Confluence!"}],"growth-starburst.common.arrow-right.alt-text":[{"type":0,"value":"Arrow right"}],"growth-starburst.common.bundled-existing-apps.header":[{"type":0,"value":"Bundled with your existing apps"}],"growth-starburst.common.icon-check-circle-blue.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-starburst.common.icon-confluence.alt-text":[{"type":0,"value":"Icon - Confluence"}],"growth-starburst.common.icon-jira.alt-text":[{"type":0,"value":"Icon - Jira"}],"growth-starburst.common.icon-loom.alt-text":[{"type":0,"value":"Icon - Loom"}],"growth-starburst.common.icon-rovo.alt-text":[{"type":0,"value":"Icon - Rovo"}],"growth-starburst.common.percentage.alt-text":[{"type":0,"value":"Percentage "},{"type":1,"value":"percentage"}],"growth-starburst.common.pro-tip.alt-text":[{"type":0,"value":"Pro tip"}],"growth-starburst.common.twc-email-summary.confluence":[{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"b"},{"type":0,"value":" - Idea & knowledge sharing"}],"growth-starburst.common.twc-email-summary.header":[{"type":0,"value":"Your Teamwork Collection gives you access to:"}],"growth-starburst.common.twc-email-summary.jira":[{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"b"},{"type":0,"value":" - Work planning & tracking"}],"growth-starburst.common.twc-email-summary.loom":[{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" - Async video communication"}],"growth-starburst.common.twc-email-summary.rovo":[{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"},{"type":0,"value":" - AI Chat, Search & a team of specialized Agents"}],"growth-starburst.ep-migration-inapp-3280.description":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"growth-starburst.ep-migration-inapp-3280.primary-button":[{"type":0,"value":"Upgrade options"}],"growth-starburst.ep-migration-inapp-3280.secondary-button":[{"type":0,"value":"Dismiss"}],"growth-starburst.ep-migration-inapp-3280.title":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"growth-starburst.ep-migration-inapp-3282.description":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"growth-starburst.ep-migration-inapp-3282.primary-button":[{"type":0,"value":"Upgrade options"}],"growth-starburst.ep-migration-inapp-3282.secondary-button":[{"type":0,"value":"Dismiss"}],"growth-starburst.ep-migration-inapp-3282.title":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.description":[{"type":0,"value":"Try summarizing or generating more content with AI. You can always come back to this panel."}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.title":[{"type":0,"value":"Now it\'s your turn!"}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content.description":[{"type":0,"value":"Try Keep adding content to your page. You can type \\/ai to prompt AI."}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content.title":[{"type":0,"value":"Now it\'s your turn!"}],"growth-starburst.jira-issue-view-twc-spotlight-card.documentation.description":[{"type":0,"value":"Create docs directly in Jira to capture work, strategy, and more \u2014 with AI doing the heavy lifting."}],"growth-starburst.jira-issue-view-twc-spotlight-card.documentation.title":[{"type":0,"value":"Turn ideas into docs instantly with AI"}],"growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.description":[{"type":0,"value":"Create video messages using Loom to talk through updates, feedback, or upcoming work."}],"growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.title":[{"type":0,"value":"Record & share videos"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.explore":[{"type":0,"value":"Explore"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.next":[{"type":0,"value":"Next"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"\\/"},{"type":1,"value":"totalSteps"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.skip":[{"type":0,"value":"Dismiss"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-enabled":[{"type":0,"value":"enabled"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-label":[{"type":0,"value":"Auto advance:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.dismiss-button":[{"type":0,"value":"Dismiss Tour"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.start-from-step-label":[{"type":0,"value":"Start from step:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.steps-label":[{"type":0,"value":"Steps:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.title":[{"type":0,"value":"TWC Spotlight Tour Test"}],"growth-starburst.twc-end-user-request-admin-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"growth-starburst.twc-end-user-request-admin-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"growth-starburst.twc-end-user-request-admin-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"growth-starburst.twc-end-user-request-admin-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"growth-starburst.twc-end-user-request-admin-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"growth-starburst.twc-end-user-request-admin-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraAndConfAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraAndConfAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraAndConfAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.content.jiraAndConfAndLoom":[{"type":0,"value":"Keep using the tools you love\u2014now with connected features and a single, simple bill."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.content.jiraAndConfAndRovo":[{"type":0,"value":"30-day free trial, with no added cost after your trial"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraAndConfAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraAndConfAndLoom":[{"type":0,"value":"Bundle your existing apps into a Teamwork Collection and "},{"children":[{"type":0,"value":"save 16%"}],"type":8,"value":"blue"},{"type":0,"value":" per month"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.item1.jiraAndConfAndLoom":[{"children":[{"type":0,"value":"Seamless collaboration"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Experience intentionally connected features across all your Teamwork Collection apps."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.item2.jiraAndConfAndLoom":[{"children":[{"type":0,"value":"One bill, less hassle"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Say goodbye to multiple invoices. Get everything in one easy payment."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Save time with AI-generated meeting notes and async video"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.conf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.confAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jira":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.conf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.confAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jira":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.confAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.conf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.confAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jira":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.header.conf":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.confAndLoom":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jira":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork "},{"children":[{"type":0,"value":"3x faster"}],"type":8,"value":"blue"},{"type":0,"value":" with video and AI"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraAndLoom":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraConf":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.conf":[{"type":0,"value":"The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.confAndLoom":[{"type":0,"value":"The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jira":[{"type":0,"value":"Create strategy docs, flowcharts, project plans, and more \u2014 without leaving Jira."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Reduce repetitive syncs and follow-ups \u2014 Loom videos and automated recaps keep everyone aligned."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndLoom":[{"type":0,"value":"Create strategy docs, flowcharts, project plans, and more \u2014 without leaving Jira."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.conf":[{"type":0,"value":"increase speed in decision making"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.confAndLoom":[{"type":0,"value":"increase speed in decision making"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jira":[{"type":0,"value":"boost in project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndLoom":[{"type":0,"value":"boost in project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraConf":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.conf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.confAndLoom":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jira":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraAndLoom":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.conf":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.confAndLoom":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jira":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraAndLoom":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraConf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step3Description.conf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step3Description.jira":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step3Title.conf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step3Title.jira":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.conf":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jira":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.land":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.conf":[{"type":0,"value":"Try Jira today to make getting work done a snap!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jira":[{"type":0,"value":"Try Confluence today to start connecting org-wide knowledge to your work."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.land":[{"type":0,"value":"Try out Confluence today to add context to your work in Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.land":[{"type":0,"value":"Bring your next big idea to life"}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.conf":[{"type":0,"value":"Use Jira to visualize your tasks and workflows. Plus, use AI-powered automations to get the whole team get moving fast."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.jira":[{"type":0,"value":"Use Confluence to capture notes, draft plans, share project insights. Plus, keep it all organized alongside Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.jiraConf":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.land":[{"type":0,"value":"Hit \u201CCreate\u201D in Confluence to jot down notes, draft plans, or share learnings. Pick a ready-made template to start fast."}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83C\uDFCE\uFE0F Kickstart collaboration with Jira & Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83C\uDFCE\uFE0F Kickstart collaboration with Confluence & Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83D\uDDBC\uFE0F See the full picture for your projects"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.conf":[{"type":0,"value":"Plan it, track it, get it done"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.jira":[{"type":0,"value":"Go from cluttered docs to organized knowledge"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.jiraConf":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.land":[{"type":0,"value":"Say \u201Cgoodbye\u201D to boring project docs"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.conf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jira":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jiraConf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.conf":[{"type":0,"value":"Add Jira views as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Confluence to help keep everyone in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jira":[{"type":0,"value":"Add Confluence docs as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira to help keep everyone in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jiraConf":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.conf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jira":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jiraConf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.conf":[{"type":0,"value":"Use a "},{"children":[{"type":0,"value":"board"}],"type":8,"value":"b"},{"type":0,"value":" to arrange issues in columns, or plot work out on a "},{"children":[{"type":0,"value":"timeline"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"calendar"}],"type":8,"value":"b"},{"type":0,"value":" over months or quarters."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jira":[{"type":0,"value":"Add Jira boards, Google forms, Figma designs, Excel spreadsheets & more\u2014right into Confluence. It\'s your team\'s new single source of truth!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.land":[{"type":0,"value":"Embed Jira views, reports, and forms directly into Confluence pages with Smart Links."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.conf":[{"type":0,"value":"View it your way"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jira":[{"type":0,"value":"Connect your work from anywhere"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.land":[{"type":0,"value":"Keep it all in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.conf":[{"type":0,"value":"Let AI automatically transform Confluence notes into trackable work in Jira\u2014no copy-pasting or re-typing needed."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jira":[{"type":0,"value":"Let AI automatically transform Confluence notes into trackable work in Jira\u2014no copy-pasting or re-typing needed."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.land":[{"type":0,"value":"Let AI automatically turn Confluence pages and whiteboards into trackable work in Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.conf":[{"type":0,"value":"Auto-capture action items"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jira":[{"type":0,"value":"Auto-capture action items"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.land":[{"type":0,"value":"Transform ideas into action"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.conf":[{"type":0,"value":"Create and edit Confluence docs and whiteboards right inside Jira to help your team stay connected all in one tool."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jira":[{"type":0,"value":"Create and edit docs, whiteboards (anything, really!) right inside Confluence to help your team stay connected all in one tool."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jiraConf":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.land":[{"type":0,"value":"View, edit, and create Confluence pages and whiteboards right from Jira, without losing context."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.conf":[{"type":0,"value":"Never switch context again!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jira":[{"type":0,"value":"Never switch context again!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jiraConf":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.land":[{"type":0,"value":"View work across teams"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.conf":[{"type":0,"value":"Our top tips for planning and tracking work:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jira":[{"type":0,"value":"Our top tips for connecting team knowledge:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jiraConf":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.land":[{"type":0,"value":"How to plan, track, and doc with Confluence and Jira:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.conf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jira":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.land":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.conf":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jira":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Chat with Rovo AI today to get on the fast-track to productivity."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.land":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to try out Rovo AI?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.land":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.conf":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.jira":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.jiraConf":[{"type":0,"value":"Summarize, search, and streamline any task. No context-switching, no searching\u2014just better results."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.land":[{"type":0,"value":"Record a Loom video to add visual context to project updates, presentations, and training materials in Jira and Confluence."}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83E\uDD2B Your secret to better, faster teamwork"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.conf":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.jira":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.jiraConf":[{"type":0,"value":"Get to \u201Cdone\u201D faster with Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.land":[{"type":0,"value":"Bring work to life with video"}],"growth-starburst.twc-onboarding-email-2.message-template.email.item1.jiraConf":[{"children":[{"type":0,"value":"Take action in a flash"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Chat with Rovo AI to summarize updates, create tasks, and draft content in seconds."}],"growth-starburst.twc-onboarding-email-2.message-template.email.item2.jiraConf":[{"children":[{"type":0,"value":"Find, don\'t search"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Rovo AI Search provides rich, contextual answers grounded in your org\'s knowledge, history, and context."}],"growth-starburst.twc-onboarding-email-2.message-template.email.item3.jiraConf":[{"children":[{"type":0,"value":"Say \u201Chey\u201D to your AI teammate"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Call on Rovo to tackle any task and act on insights across all your apps and integrations."}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.conf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.jira":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.land":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.conf":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.jira":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.land":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.conf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.jira":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.land":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.conf":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.jira":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.land":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.conf":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.jira":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.land":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.conf":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.jira":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.land":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.conf":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.jira":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.land":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.conf":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.jira":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.land":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.conf":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.jira":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.land":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.conf":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jira":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jiraConf":[{"type":0,"value":"Top tips for working smarter & speedier with Rovo AI:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.land":[{"type":0,"value":"How to work with AI-powered videos in Loom:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.conf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jira":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.land":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.conf":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jira":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.land":[{"type":0,"value":"Use Rovo AI to turn deliver big ideas faster and collaborate as a human-AI team. Try out Rovo AI with your collection of apps today."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.conf":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jira":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.land":[{"type":0,"value":"Discover a whole new way to teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.conf":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.jira":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.jiraConf":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.land":[{"type":0,"value":"Supercharge how you work with AI-powered Search, Chat, and Agents\u2014all integrated directly into Jira, Confluence, and Loom."}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83E\uDD29 Here\'s everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.conf":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.jira":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.jiraConf":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.land":[{"type":0,"value":"Get to \u201Cdone\u201D faster with your apps + Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.land":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipButtonText.land":[{"type":0,"value":"Read more"}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipContent.land":[{"type":0,"value":"The Rovo guide introduces the basics of working with AI Search, Chat and agents."}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipHeader.land":[{"type":0,"value":"Pro tip:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.conf":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jira":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.land":[{"type":0,"value":"Need help dreaming up your next big idea? Brainstorm project docs and tasks with Rovo Chat to create everything you need in the blink of an eye."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.conf":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jira":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.land":[{"type":0,"value":"Create anything in seconds!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.conf":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jira":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.land":[{"type":0,"value":"Use Rovo AI to automatically scan Confluence pages for action items and turn them into Jira tasks with just a few clicks."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.conf":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jira":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.land":[{"type":0,"value":"Transform pages into action"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.conf":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jira":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jiraConf":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.land":[{"type":0,"value":"Use Rovo AI to break your Jira work items into easily-achievable sub-tasks. Automatically surface related Confluence pages, and use them to create descriptions."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.conf":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jira":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jiraConf":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.land":[{"type":0,"value":"Instantly enhance your work"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step4Description.land":[{"type":0,"value":"Create and embed a Loom right from your Confluence page (along with AI-generated notes or action items!) and keep everyone in-the-know."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step4Title.land":[{"type":0,"value":"Auto-summarize with video"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.conf":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jira":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jiraConf":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.land":[{"type":0,"value":"Try this workflow for using Jira, Confluence, Loom, and Rovo together:"}],"growth-starburst.twc-onboarding-widget.onboarding-card.dismiss-tooltip":[{"type":0,"value":"Dismiss"}],"growth-starburst.twc-onboarding-widget.onboarding-card.status":[{"type":0,"value":"Completed"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.conf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.jira":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.land":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.conf":[{"type":0,"value":"See how Jira, Loom, and Rovo plug into your Confluence workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.jira":[{"type":0,"value":"See how Confluence, Loom, and Rovo plug into your Jira workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"See how Loom and Rovo plug into your Jira and Confluence workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.land":[{"type":0,"value":"Jump into Jira to create your first task"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.land":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.content.conf":[{"type":0,"value":"Your new collection of apps supercharges productivity with work tracking across teams, async video, and AI-powered insights\u2014all alongside Confluence."}],"growth-starburst.twc-welcome-email.message-template.email.content.jira":[{"type":0,"value":"Your new collection of apps supercharges productivity with org-wide knowledge sharing, async video, and AI-powered insights\u2014all alongside Jira."}],"growth-starburst.twc-welcome-email.message-template.email.content.jiraConf":[{"type":0,"value":"Your new collection of apps supercharges productivity with async video and AI-powered insights\u2014all alongside Jira & Confluence."}],"growth-starburst.twc-welcome-email.message-template.email.content.land":[{"type":0,"value":"Collaborate and achieve more\u2014right from day one. We\'ll guide you step-by-step over the next few days."}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.header.conf":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.jira":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.jiraConf":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.land":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.conf":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.jira":[{"type":0,"value":"Create and share information effortlessly\u2014plan better, stay aligned, and keep everything you need right at your fingertips."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Send quick video messages that add context, save time, reduce meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.land":[{"type":0,"value":"Create "},{"children":[{"type":0,"value":"work items"}],"type":8,"value":"b"},{"type":0,"value":", which are chunks of work (just like to-dos) that you can break down into smaller, more achievable tasks."}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.conf":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.jira":[{"type":0,"value":"Organize knowledge with Confluence"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.land":[{"type":0,"value":"Break down your work"}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.conf":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.jira":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.land":[{"type":0,"value":"Add "},{"children":[{"type":0,"value":"fields"}],"type":8,"value":"b"},{"type":0,"value":" to include all the important details to your work items, like due dates, assignees, priority, and more."}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.conf":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.jira":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.land":[{"type":0,"value":"Add important details"}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.conf":[{"type":0,"value":"Plan and manage anything\u2014from big projects to daily tasks\u2014with seamless workflows, real-time tracking, and clear alignment to goals."}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.jira":[{"type":0,"value":"Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.land":[{"type":0,"value":"Use a "},{"children":[{"type":0,"value":"board"}],"type":8,"value":"b"},{"type":0,"value":" to arrange work items in columns and by status, or plot work out on a "},{"children":[{"type":0,"value":"timeline"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"calendar"}],"type":8,"value":"b"},{"type":0,"value":" view over months or quarters."}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.conf":[{"type":0,"value":"Get it done with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.jira":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.land":[{"type":0,"value":"View it your way"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.conf":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.jira":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.jiraConf":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.land":[{"type":0,"value":"We recommend starting with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.subheaderDescription.land":[{"type":0,"value":"Managing your projects starts with Jira. Start by setting things up to manage your work more efficiently:"}],"jira-project-space-connected.message-templates.spotlight-description-couse":[{"type":0,"value":"Create pages for your project without leaving Jira."}],"jira-project-space-connected.message-templates.spotlight-description-xflow":[{"type":0,"value":"Create Confluence pages within Jira. Free for 10 users."}],"jira-project-space-connected.message-templates.spotlight-header-couse":[{"type":0,"value":"Your project has Confluence pages"}],"jira-project-space-connected.message-templates.spotlight-header-xflow":[{"type":0,"value":"Add pages to your project"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body":[{"type":0,"value":"Instead of manually typing meeting notes, why not try Loom to record meetings?"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close":[{"type":0,"value":"Close"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta":[{"type":0,"value":"Try now"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header":[{"type":0,"value":"Automate meeting notes"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt":[{"type":0,"value":"Notepad with sparkling background"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.for-you-spotlight-text":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.rovo-chat-spotlight-text":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.switcher-spotlight-text":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-modal.progress":[{"type":1,"value":"currentSpotlightNumber"},{"type":0,"value":"\\/"},{"type":1,"value":"numTotalSpotlights"}],"townsquare.townsquare-twc-modal.twc-modal-story.for-you-spotlight-text.no-translate":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-twc-modal.twc-modal-story.rovo-chat-spotlight-text.no-translate":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-twc-modal.twc-modal-story.switcher-spotlight-text.no-translate":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.for-you-spotlight-text.no-translate":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.rovo-chat-spotlight-text.no-translate":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.switcher-spotlight-text.no-translate":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-spotlight.progress":[{"type":1,"value":"currentSpotlightNumber"},{"type":0,"value":"\\/"},{"type":1,"value":"numTotalSpotlights"}],"townsquare.twc-onboarding-modal.app-switcher.body":[{"type":0,"value":"Use this menu to easily switch between other Atlassian apps."}],"townsquare.twc-onboarding-modal.app-switcher.heading":[{"type":0,"value":"Find all your apps here"}],"townsquare.twc-onboarding-modal.apps-icon-label":[{"type":0,"value":"Apps"}],"townsquare.twc-onboarding-modal.atlassian-home":[{"type":0,"value":"Access all your "},{"children":[{"type":0,"value":"work"}],"type":8,"value":"bold"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"spaces"}],"type":8,"value":"bold"},{"type":0,"value":" in Atlassian Home"}],"townsquare.twc-onboarding-modal.atlassian-logo-label":[{"type":0,"value":"Atlassian"}],"townsquare.twc-onboarding-modal.back-button":[{"type":0,"value":"Back"}],"townsquare.twc-onboarding-modal.close-button-label":[{"type":0,"value":"Close onboarding modal"}],"townsquare.twc-onboarding-modal.confluence-feature":[{"type":0,"value":"Document notes and knowledge in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.confluence-icon-label":[{"type":0,"value":"Confluence"}],"townsquare.twc-onboarding-modal.connect-integrations":[{"type":0,"value":"Connect work with "},{"children":[{"type":0,"value":"teams, AI,"}],"type":8,"value":"bold"},{"type":0,"value":" and more"}],"townsquare.twc-onboarding-modal.connect-work-title":[{"type":0,"value":"Connect work across Atlassian"}],"townsquare.twc-onboarding-modal.description":[{"type":0,"value":"Collaborating is easier than ever with new apps and features, including AI-powered Search and Chat."}],"townsquare.twc-onboarding-modal.explore-atlassian-home":[{"type":0,"value":"Explore Atlassian Home"}],"townsquare.twc-onboarding-modal.explore-loom":[{"type":0,"value":"Explore Loom"}],"townsquare.twc-onboarding-modal.for-you.body":[{"type":0,"value":"Home connects work from across Atlassian, giving you an overview of what\'s happening across teams, goals, and projects."}],"townsquare.twc-onboarding-modal.for-you.generic-heading":[{"type":0,"value":"Welcome Home!"}],"townsquare.twc-onboarding-modal.for-you.heading":[{"type":0,"value":"Welcome Home, "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"townsquare.twc-onboarding-modal.got-it-button":[{"type":0,"value":"Got it"}],"townsquare.twc-onboarding-modal.home-icon-label":[{"type":0,"value":"Home"}],"townsquare.twc-onboarding-modal.illustration-alt":[{"type":0,"value":"Illustration showing collaborative teamwork with connected apps and AI-powered features"}],"townsquare.twc-onboarding-modal.integration-feature":[{"type":0,"value":"Bring it all together with "},{"children":[{"type":0,"value":"teams, AI,"}],"type":8,"value":"bold"},{"type":0,"value":" and more"}],"townsquare.twc-onboarding-modal.integration-icon-label":[{"type":0,"value":"Integration"}],"townsquare.twc-onboarding-modal.jira-confluence-features":[{"type":0,"value":"Add context in "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"bold"},{"type":0,"value":" with detailed docs in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.jira-feature":[{"type":0,"value":"Map out your team\'s work and tasks in "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.jira-icon-label":[{"type":0,"value":"Jira"}],"townsquare.twc-onboarding-modal.left-align-icon-label":[{"type":0,"value":"Align Text Left"}],"townsquare.twc-onboarding-modal.loom-add-demos":[{"type":0,"value":"Add "},{"children":[{"type":0,"value":"demos"}],"type":8,"value":"bold"},{"type":0,"value":" and walkthroughs of your work in Jira"}],"townsquare.twc-onboarding-modal.loom-bring-together":[{"type":0,"value":"Bring it all together with "},{"children":[{"type":0,"value":"teams, goals, AI"}],"type":8,"value":"bold"},{"type":0,"value":", and more"}],"townsquare.twc-onboarding-modal.loom-description":[{"type":0,"value":"Loom makes it easy to record videos and streamline communication in the apps you already use:"}],"townsquare.twc-onboarding-modal.loom-feature":[{"type":0,"value":"Share and embed async video updates with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.loom-icon-label":[{"type":0,"value":"Loom"}],"townsquare.twc-onboarding-modal.loom-share-updates":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"bold"},{"type":0,"value":" to easily share updates and knowledge"}],"townsquare.twc-onboarding-modal.loom-title":[{"type":0,"value":"Create better shareouts with Loom"}],"townsquare.twc-onboarding-modal.loom-use-videos":[{"type":0,"value":"Use videos to give "},{"children":[{"type":0,"value":"context"}],"type":8,"value":"bold"},{"type":0,"value":" to Confluence pages"}],"townsquare.twc-onboarding-modal.new-apps-one":[{"type":0,"value":"Streamline work with "},{"children":[{"type":1,"value":"appOneName"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.new-apps-title":[{"type":0,"value":"New apps and features are here"}],"townsquare.twc-onboarding-modal.new-apps-two":[{"type":0,"value":"Streamline work with "},{"children":[{"type":1,"value":"appOneName"}],"type":8,"value":"bold"},{"type":0,"value":" and "},{"children":[{"type":1,"value":"appTwoName"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.next-button":[{"type":0,"value":"Next"}],"townsquare.twc-onboarding-modal.ok-button":[{"type":0,"value":"Ok"}],"townsquare.twc-onboarding-modal.rovo-chat.body":[{"type":0,"value":"You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."}],"townsquare.twc-onboarding-modal.rovo-chat.heading":[{"type":0,"value":"Chat with AI"}],"townsquare.twc-onboarding-modal.spotlight.close-button-label":[{"type":0,"value":"Close onboarding spotlight tour"}],"townsquare.twc-onboarding-modal.take-a-tour-button":[{"type":0,"value":"Take a tour"}],"townsquare.twc-onboarding-modal.teams-icon-label":[{"type":0,"value":"Integration"}],"townsquare.twc-onboarding-modal.title":[{"type":0,"value":"Transform teamwork, together"}],"townsquare.twc-onboarding-modal.try-now-button":[{"type":0,"value":"Try now"}],"townsquare.twc-onboarding-spotlight.app-switcher.body":[{"type":0,"value":"Use this menu to easily switch between other Atlassian apps."}],"townsquare.twc-onboarding-spotlight.app-switcher.heading":[{"type":0,"value":"Find all your apps here"}],"townsquare.twc-onboarding-spotlight.back-button":[{"type":0,"value":"Back"}],"townsquare.twc-onboarding-spotlight.close-button-label":[{"type":0,"value":"Close"}],"townsquare.twc-onboarding-spotlight.for-you.body":[{"type":0,"value":"Home connects work from across Atlassian, giving you an overview of what\'s happening across teams, goals, and projects."}],"townsquare.twc-onboarding-spotlight.for-you.generic-heading":[{"type":0,"value":"Welcome Home!"}],"townsquare.twc-onboarding-spotlight.for-you.heading":[{"type":0,"value":"Welcome Home, "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"townsquare.twc-onboarding-spotlight.next-button":[{"type":0,"value":"Next"}],"townsquare.twc-onboarding-spotlight.ok-button":[{"type":0,"value":"Ok"}],"townsquare.twc-onboarding-spotlight.rovo-chat.body":[{"type":0,"value":"You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."}],"townsquare.twc-onboarding-spotlight.rovo-chat.heading":[{"type":0,"value":"Chat with AI"}],"townsquare.twc-onboarding-spotlight.try-now-button":[{"type":0,"value":"Try now"}],"townsquare.twc-onboarding-widget.chat-card.cta":[{"type":0,"value":"Try Chat"}],"townsquare.twc-onboarding-widget.chat-card.description":[{"type":0,"value":"Get helpful answers to your questions and collaborate with AI on your work."}],"townsquare.twc-onboarding-widget.chat-card.heading":[{"type":0,"value":"Chat with Rovo"}],"townsquare.twc-onboarding-widget.confluence-card.cta":[{"type":0,"value":"Try Confluence"}],"townsquare.twc-onboarding-widget.confluence-card.description":[{"type":0,"value":"Create a knowledge bank available to everyone in your team."}],"townsquare.twc-onboarding-widget.confluence-card.heading":[{"type":0,"value":"Write docs with Confluence"}],"townsquare.twc-onboarding-widget.goals-card.cta":[{"type":0,"value":"Try Goals"}],"townsquare.twc-onboarding-widget.goals-card.description":[{"type":0,"value":"Align your work with goals to make sure you are on track."}],"townsquare.twc-onboarding-widget.goals-card.heading":[{"type":0,"value":"Track progress with goals"}],"townsquare.twc-onboarding-widget.jira-card.cta":[{"type":0,"value":"Try Jira"}],"townsquare.twc-onboarding-widget.jira-card.description":[{"type":0,"value":"Create project tasks to begin managing your project."}],"townsquare.twc-onboarding-widget.jira-card.heading":[{"type":0,"value":"Plan out tasks with Jira"}],"townsquare.twc-onboarding-widget.loom-card.cta":[{"type":0,"value":"Try Loom"}],"townsquare.twc-onboarding-widget.loom-card.description":[{"type":0,"value":"Share async video updates and reduce meetings for all."}],"townsquare.twc-onboarding-widget.loom-card.heading":[{"type":0,"value":"Share updates with Loom"}],"townsquare.twc-onboarding-widget.search-card.cta":[{"type":0,"value":"Try Search"}],"townsquare.twc-onboarding-widget.search-card.description":[{"type":0,"value":"Power up your searches with AI and find what you\'re looking for faster."}],"townsquare.twc-onboarding-widget.search-card.heading":[{"type":0,"value":"Find more with Search"}],"townsquare.twc-onboarding-widget.studio-card.cta":[{"type":0,"value":"Try Studio"}],"townsquare.twc-onboarding-widget.studio-card.description":[{"type":0,"value":"Build custom AI agents, automations, and more without needing to code."}],"townsquare.twc-onboarding-widget.studio-card.heading":[{"type":0,"value":"Automate work with Studio"}],"townsquare.twc-onboarding-widget.teams-card.cta":[{"type":0,"value":"Try Teams"}],"townsquare.twc-onboarding-widget.teams-card.description":[{"type":0,"value":"Collaborate more with teams and unlock the power of your teammates."}],"townsquare.twc-onboarding-widget.teams-card.heading":[{"type":0,"value":"Collaborate with teams"}],"townsquare.twc-onboarding-widget.twc-card.cta":[{"type":0,"value":"Watch video"}],"townsquare.twc-onboarding-widget.twc-card.description":[{"type":0,"value":"Not sure where to start? Find out how your apps can streamline your work."}],"townsquare.twc-onboarding-widget.twc-card.heading":[{"type":0,"value":"See how it all works together"}],"townsquare.twc-onboarding-widget.twc-card.modal-close":[{"type":0,"value":"Close"}],"townsquare.twc-onboarding-widget.twc-card.modal-external-link":[{"type":0,"value":"Open link"}],"townsquare.twc-onboarding-widget.twc-card.modal-title":[{"type":0,"value":"Welcome to Atlassian"}],"twc.email.header.alt":[{"type":0,"value":"Teamwork Collection Atlassian"}]}');

});

parcelRegister("fc2PE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1N1Pc").then(()=>parcelRequire('1Z6zt'));

});

parcelRegister("kltTM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dNZRY").then(()=>parcelRequire('lvDtw'));

});

parcelRegister("l4ytY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hnLQ7").then(()=>parcelRequire('eSXVn'));

});

parcelRegister("5Vjsg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6CaxX").then(()=>parcelRequire('77M8h'));

});

parcelRegister("585xa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aMHHh").then(()=>parcelRequire('4zqO5'));

});

parcelRegister("g1MdP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gGi2t").then(()=>parcelRequire('h7wRb'));

});

parcelRegister("kY4ZW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ldaqr").then(()=>parcelRequire('2LEbU'));

});

parcelRegister("bgiau", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iiFuY").then(()=>parcelRequire('hTWUr'));

});

parcelRegister("laD48", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kSqL9").then(()=>parcelRequire('ech61'));

});

parcelRegister("9wm30", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h97Cj").then(()=>parcelRequire('ekKS8'));

});

parcelRegister("aFuDe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9bjiA").then(()=>parcelRequire('fpkYN'));

});

parcelRegister("bCqeD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ifmNt").then(()=>parcelRequire('4lgsB'));

});

parcelRegister("2vBsF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9ugri").then(()=>parcelRequire('iGGJZ'));

});

parcelRegister("fvZNJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5bUAX").then(()=>parcelRequire('1bnFN'));

});

parcelRegister("cjIir", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bBeyC").then(()=>parcelRequire('dno9n'));

});

parcelRegister("90qHo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4SHEl").then(()=>parcelRequire('hoXbq'));

});

parcelRegister("aUulc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gqAm3").then(()=>parcelRequire('185q6'));

});

parcelRegister("9LnUT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jhksl").then(()=>parcelRequire('6jqe4'));

});

parcelRegister("46Oq9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1PxzF").then(()=>parcelRequire('hGeMJ'));

});

parcelRegister("kJfpS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3juag").then(()=>parcelRequire('5BFd5'));

});

parcelRegister("5qQ4a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9wB0S").then(()=>parcelRequire('64GVS'));

});

parcelRegister("kOmOa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lW3nQ").then(()=>parcelRequire('2DnGo'));

});

parcelRegister("3tKnh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4d5G8").then(()=>parcelRequire('t5NgT'));

});

parcelRegister("gBUEN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6MyoK").then(()=>parcelRequire('4PKSS'));

});

parcelRegister("jJTpC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("loX0P").then(()=>parcelRequire('egGdn'));

});

parcelRegister("fqjnK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hTdV3").then(()=>parcelRequire('2O328'));

});

parcelRegister("Iuedn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dzq38").then(()=>parcelRequire('esTLZ'));

});

parcelRegister("7b8ip", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kXAv1").then(()=>parcelRequire('dCIBj'));

});

parcelRegister("hVZrd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j5COe").then(()=>parcelRequire('3p9an'));

});

parcelRegister("lWWuL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e8XrO").then(()=>parcelRequire('bgpcC'));

});

parcelRegister("YSjgN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("22B8X").then(()=>parcelRequire('9wRCh'));

});

parcelRegister("3vrH9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("37iLc").then(()=>parcelRequire('6o7A6'));

});

parcelRegister("c6LMA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jUxvR").then(()=>parcelRequire('eLfTw'));

});

parcelRegister("kxYGv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jILNp").then(()=>parcelRequire('fQBAE'));

});


parcelRegister("cOVNc", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $dafe99033120b214$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5qzLT = parcelRequire("5qzLT");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dafe99033120b214$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $dafe99033120b214$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("3avMh")));
        case 'da':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("jORDz")));
        case 'de':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("k1FRL")));
        case 'en-GB':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("bw0Iw")));
        case 'en-US':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("kbF8u")));
        case 'en-XA':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("7iHko")));
        case 'en-XB':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("kDmJj")));
        case 'en-ZZ':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("ktqTc")));
        case 'en':
            return $dafe99033120b214$var$importHelper(await Promise.resolve((parcelRequire("5qzLT"))));
        case 'es':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("1tEmq")));
        case 'et':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("lxl5m")));
        case 'fi':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("8dInk")));
        case 'fr':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("f7qjS")));
        case 'hr':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("k1KrE")));
        case 'hu':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("kLUXI")));
        case 'it':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("6FHX8")));
        case 'ja':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("kGVxq")));
        case 'ko':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("7RF7O")));
        case 'nb':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("4DPM9")));
        case 'nl':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("kxeA4")));
        case 'pl':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("lIblm")));
        case 'pt-BR':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("g45uO")));
        case 'ro':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("gDTHx")));
        case 'ru':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("hySQF")));
        case 'sl':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("78Nog")));
        case 'sr-RS':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("apk0U")));
        case 'sr-YR':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("6Kztg")));
        case 'sr':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("iKz09")));
        case 'sv':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("7oKsb")));
        case 'th':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("cfOdr")));
        case 'tr':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("e1Jdw")));
        case 'uk':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("7FnhC")));
        case 'vi':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("hTPmC")));
        case 'zh-CN':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("bLV2o")));
        case 'zh-TW':
            return $dafe99033120b214$var$importHelper(await (parcelRequire("axTtK")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5qzLT));
    }
};

});
parcelRegister("5qzLT", function(module, exports) {
module.exports = JSON.parse('{"jira-chronos.jira-plans-user-invited.message-template.email.body.avatar.no-translate":[{"type":0,"value":"avatar"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.globe.no-translate":[{"type":0,"value":"globeLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"planTitle"},{"type":0,"value":" "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.join.link":[{"type":0,"value":"Join the Plan"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.learn.more.message":[{"type":0,"value":"Learn more about Jira"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.logo.no-translate":[{"type":0,"value":"logo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template.dot":[{"type":0,"value":"."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.write.no-translate":[{"type":0,"value":"writeLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"planTitle"},{"type":0,"value":")"}],"jira-plan-add-user-changeboarding.message-templates.spotlight-body":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Add people"}],"type":8,"value":"b"},{"type":0,"value":" in this menu to share this plan with people outside of your organization."}],"jira-plan-add-user-changeboarding.message-templates.spotlight-cta":[{"type":0,"value":"Close"}],"jira-plan-add-user-changeboarding.message-templates.spotlight-header":[{"type":0,"value":"Spread the good word"}],"jira-plans-efa-change-boarding.message-templates.flag.description":[{"type":0,"value":"Fields that aren\u2019t part of a project\u2019s configuration can no longer be used in your plan. In this case, add the fields to your project\u2019s field configuration to use them again."}],"jira-plans-efa-change-boarding.message-templates.flag.goToSettings":[{"type":0,"value":"Go to settings"}],"jira-plans-efa-change-boarding.message-templates.flag.read-more":[{"type":0,"value":"Read more"}],"jira-plans-efa-change-boarding.message-templates.flag.title":[{"type":0,"value":"Some fields in your plan might no longer be available for your projects."}]}');

});

parcelRegister("3avMh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Eo5EW").then(()=>parcelRequire('iIjRQ'));

});

parcelRegister("jORDz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aT0co").then(()=>parcelRequire('2jxRj'));

});

parcelRegister("k1FRL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eAJpn").then(()=>parcelRequire('lGJG2'));

});

parcelRegister("bw0Iw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2JzyM").then(()=>parcelRequire('ifLKl'));

});

parcelRegister("kbF8u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("JapJm").then(()=>parcelRequire('4SLjS'));

});

parcelRegister("7iHko", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aShRu").then(()=>parcelRequire('8oyn7'));

});

parcelRegister("kDmJj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5AvFX").then(()=>parcelRequire('ahD0z'));

});

parcelRegister("ktqTc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bM8SD").then(()=>parcelRequire('hNqd6'));

});

parcelRegister("1tEmq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gZzWH").then(()=>parcelRequire('gQhS1'));

});

parcelRegister("lxl5m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jL8Zq").then(()=>parcelRequire('kg72t'));

});

parcelRegister("8dInk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d7W85").then(()=>parcelRequire('caoAM'));

});

parcelRegister("f7qjS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1SO1W").then(()=>parcelRequire('cgt7H'));

});

parcelRegister("k1KrE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kRYgy").then(()=>parcelRequire('dPfCM'));

});

parcelRegister("kLUXI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9W7iU").then(()=>parcelRequire('eLDKI'));

});

parcelRegister("6FHX8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("898JX").then(()=>parcelRequire('6zVCW'));

});

parcelRegister("kGVxq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2qLFz").then(()=>parcelRequire('3Vnrm'));

});

parcelRegister("7RF7O", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7BxbM").then(()=>parcelRequire('5ovLE'));

});

parcelRegister("4DPM9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fIHvG").then(()=>parcelRequire('QyFnn'));

});

parcelRegister("kxeA4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a4H5g").then(()=>parcelRequire('53MDj'));

});

parcelRegister("lIblm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iFpaX").then(()=>parcelRequire('fYpdX'));

});

parcelRegister("g45uO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("egLcy").then(()=>parcelRequire('mWC3n'));

});

parcelRegister("gDTHx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d38ji").then(()=>parcelRequire('hDG8o'));

});

parcelRegister("hySQF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kcN39").then(()=>parcelRequire('259YH'));

});

parcelRegister("78Nog", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l83Lv").then(()=>parcelRequire('5IEJw'));

});

parcelRegister("apk0U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f6Lrh").then(()=>parcelRequire('cOakm'));

});

parcelRegister("6Kztg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("adoSC").then(()=>parcelRequire('cUG5u'));

});

parcelRegister("iKz09", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6yicv").then(()=>parcelRequire('gEqF8'));

});

parcelRegister("7oKsb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7OLfM").then(()=>parcelRequire('8ZbKQ'));

});

parcelRegister("cfOdr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f4vs2").then(()=>parcelRequire('4lGVX'));

});

parcelRegister("e1Jdw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("40mPQ").then(()=>parcelRequire('6Me6l'));

});

parcelRegister("7FnhC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e5gca").then(()=>parcelRequire('lnWbi'));

});

parcelRegister("hTPmC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kRZrj").then(()=>parcelRequire('3WoWv'));

});

parcelRegister("bLV2o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("giTS8").then(()=>parcelRequire('2gjt2'));

});

parcelRegister("axTtK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Viih").then(()=>parcelRequire('23gQn'));

});


parcelRegister("41DG5", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $ec4fafe21ef82292$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4WA2J = parcelRequire("4WA2J");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec4fafe21ef82292$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ec4fafe21ef82292$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("4gskG")));
        case 'da':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("L6dh9")));
        case 'de':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("lbB4O")));
        case 'en-GB':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("d8Vlx")));
        case 'en-US':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("60GMa")));
        case 'en-XA':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("aAq41")));
        case 'en-XB':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("kVO9H")));
        case 'en-ZZ':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("16wj0")));
        case 'en':
            return $ec4fafe21ef82292$var$importHelper(await Promise.resolve((parcelRequire("4WA2J"))));
        case 'es':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("1Pnhe")));
        case 'et':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("kH6tP")));
        case 'fi':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("c2JG9")));
        case 'fr':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("4hp94")));
        case 'hr':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("9ZXAF")));
        case 'hu':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("isO7e")));
        case 'it':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("bzGZW")));
        case 'ja':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("4Vltg")));
        case 'ko':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("3yp5g")));
        case 'nb':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("dJZPL")));
        case 'nl':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("2F0bY")));
        case 'pl':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("j6drI")));
        case 'pt-BR':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("5bYPm")));
        case 'ro':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("gnRTn")));
        case 'ru':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("5GBG0")));
        case 'sl':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("7eSrY")));
        case 'sr-RS':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("1Vx1h")));
        case 'sr-YR':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("4UTah")));
        case 'sr':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("f1azV")));
        case 'sv':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("9R0NY")));
        case 'th':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("5tVs0")));
        case 'tr':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("9LUdX")));
        case 'uk':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("8zNAl")));
        case 'vi':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("UmUJY")));
        case 'zh-CN':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("fejcI")));
        case 'zh-TW':
            return $ec4fafe21ef82292$var$importHelper(await (parcelRequire("7GLno")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4WA2J));
    }
};

});
parcelRegister("4WA2J", function(module, exports) {
module.exports = JSON.parse("{\"jira-board-inline-editing-onboarding.message-templates.ok-button\":[{\"type\":0,\"value\":\"OK\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-body\":[{\"type\":0,\"value\":\"You can now edit fields like the summary, assignee, parent and estimate. Select the fields to edit them.\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-header\":[{\"type\":0,\"value\":\"Edit details of the work item directly in the board\"}]}");

});

parcelRegister("4gskG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jJLAh").then(()=>parcelRequire('dW87a'));

});

parcelRegister("L6dh9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("htYW6").then(()=>parcelRequire('1IJub'));

});

parcelRegister("lbB4O", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lWqTy").then(()=>parcelRequire('faY7t'));

});

parcelRegister("d8Vlx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aKQg5").then(()=>parcelRequire('36mBo'));

});

parcelRegister("60GMa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fGahR").then(()=>parcelRequire('4Kf1A'));

});

parcelRegister("aAq41", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fuSUS").then(()=>parcelRequire('1G9i6'));

});

parcelRegister("kVO9H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4a6qd").then(()=>parcelRequire('kvLWR'));

});

parcelRegister("16wj0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("39nwk").then(()=>parcelRequire('lrFlX'));

});

parcelRegister("1Pnhe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7n4tg").then(()=>parcelRequire('4nIwV'));

});

parcelRegister("kH6tP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4EcRr").then(()=>parcelRequire('jS2TN'));

});

parcelRegister("c2JG9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("57ZMI").then(()=>parcelRequire('5pAGJ'));

});

parcelRegister("4hp94", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dM7La").then(()=>parcelRequire('lOY0d'));

});

parcelRegister("9ZXAF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aLs7v").then(()=>parcelRequire('j88xs'));

});

parcelRegister("isO7e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("23kVC").then(()=>parcelRequire('3q6Cy'));

});

parcelRegister("bzGZW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8U6t0").then(()=>parcelRequire('6Achf'));

});

parcelRegister("4Vltg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4piMa").then(()=>parcelRequire('ga6aL'));

});

parcelRegister("3yp5g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eBvt5").then(()=>parcelRequire('kq7mF'));

});

parcelRegister("dJZPL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("16JGn").then(()=>parcelRequire('hQAUR'));

});

parcelRegister("2F0bY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4iKOo").then(()=>parcelRequire('hofXv'));

});

parcelRegister("j6drI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fUlKa").then(()=>parcelRequire('dTOtT'));

});

parcelRegister("5bYPm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ff7Y0").then(()=>parcelRequire('eD5uy'));

});

parcelRegister("gnRTn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jpQ9N").then(()=>parcelRequire('19eRX'));

});

parcelRegister("5GBG0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cHZvW").then(()=>parcelRequire('dvrex'));

});

parcelRegister("7eSrY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kjc3e").then(()=>parcelRequire('iNBri'));

});

parcelRegister("1Vx1h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1UOFZ").then(()=>parcelRequire('8LU3Q'));

});

parcelRegister("4UTah", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eS2fq").then(()=>parcelRequire('5T2wS'));

});

parcelRegister("f1azV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5U6Eb").then(()=>parcelRequire('ji4L0'));

});

parcelRegister("9R0NY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("99Uum").then(()=>parcelRequire('ecCqM'));

});

parcelRegister("5tVs0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("goT9j").then(()=>parcelRequire('iWYDt'));

});

parcelRegister("9LUdX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Qr0d").then(()=>parcelRequire('672sa'));

});

parcelRegister("8zNAl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("49P4R").then(()=>parcelRequire('3JSSn'));

});

parcelRegister("UmUJY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g5iwt").then(()=>parcelRequire('5ldJN'));

});

parcelRegister("fejcI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8ZPpF").then(()=>parcelRequire('bSYPS'));

});

parcelRegister("7GLno", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fj2Yv").then(()=>parcelRequire('3i1po'));

});


parcelRegister("5w6rh", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $e326ff739d6b3b24$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jKI5H = parcelRequire("jKI5H");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e326ff739d6b3b24$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e326ff739d6b3b24$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("hDfUR")));
        case 'da':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("dWZwV")));
        case 'de':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("7NKfI")));
        case 'en-GB':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("ZbYos")));
        case 'en-US':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("7QbtM")));
        case 'en-XA':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("9kPQU")));
        case 'en-XB':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("2ilDg")));
        case 'en-ZZ':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("8vry5")));
        case 'en':
            return $e326ff739d6b3b24$var$importHelper(await Promise.resolve((parcelRequire("jKI5H"))));
        case 'es':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("diRGd")));
        case 'et':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("V7sSl")));
        case 'fi':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("icxoe")));
        case 'fr':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("g423W")));
        case 'hr':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("bsQxL")));
        case 'hu':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("78lk4")));
        case 'it':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("aWT81")));
        case 'ja':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("jQ8iZ")));
        case 'ko':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("cKs5V")));
        case 'nb':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("9YYzA")));
        case 'nl':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("elDKh")));
        case 'pl':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("4yx34")));
        case 'pt-BR':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("fLbjJ")));
        case 'ro':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("k0CWB")));
        case 'ru':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("gcIcF")));
        case 'sl':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("2Z7XB")));
        case 'sr-RS':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("5d07Z")));
        case 'sr-YR':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("2zZQq")));
        case 'sr':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("dRVA0")));
        case 'sv':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("9xSz9")));
        case 'th':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("l9Ceb")));
        case 'tr':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("h0N5E")));
        case 'uk':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("23c6C")));
        case 'vi':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("hi2Zy")));
        case 'zh-CN':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("hfHNT")));
        case 'zh-TW':
            return $e326ff739d6b3b24$var$importHelper(await (parcelRequire("bPFii")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jKI5H));
    }
};

});
parcelRegister("jKI5H", function(module, exports) {
module.exports = JSON.parse("{\"dismissButton\":[{\"type\":0,\"value\":\"OK\"}],\"jira-issueview-status.issue-view-resolution-changeboarding-body\":[{\"type\":0,\"value\":\"To keep key information in one spot, we've moved the status and resolution field to the left\"}],\"jira-issueview-status.issue-view-resolution-changeboarding-heading\":[{\"type\":0,\"value\":\"Status is now on the left\"}],\"jira-issueview-status.issue-view-status-changeboarding-body\":[{\"type\":0,\"value\":\"To keep key information in one spot, we've moved status to the left\"}],\"jira-issueview-status.issue-view-status-changeboarding-heading\":[{\"type\":0,\"value\":\"Status is now on the left\"}],\"post-office.jira-issueview-status.main-heading.no-translate\":[{\"type\":0,\"value\":\"Welcome to Jira Issue View Status\"}]}");

});

parcelRegister("hDfUR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2QfSu").then(()=>parcelRequire('huMiz'));

});

parcelRegister("dWZwV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("83pWY").then(()=>parcelRequire('ioL0R'));

});

parcelRegister("7NKfI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3PDLb").then(()=>parcelRequire('5SbPw'));

});

parcelRegister("ZbYos", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("13eRe").then(()=>parcelRequire('dEMxV'));

});

parcelRegister("7QbtM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("edAvt").then(()=>parcelRequire('d5oAD'));

});

parcelRegister("9kPQU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3aiVo").then(()=>parcelRequire('adzUP'));

});

parcelRegister("2ilDg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cJ9EM").then(()=>parcelRequire('i4gYL'));

});

parcelRegister("8vry5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("17HOU").then(()=>parcelRequire('dAxUw'));

});

parcelRegister("diRGd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8A1qx").then(()=>parcelRequire('b6g33'));

});

parcelRegister("V7sSl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("16dy1").then(()=>parcelRequire('j4dgK'));

});

parcelRegister("icxoe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k8t1T").then(()=>parcelRequire('frxsR'));

});

parcelRegister("g423W", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lDMqz").then(()=>parcelRequire('aHiPW'));

});

parcelRegister("bsQxL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c8Q5z").then(()=>parcelRequire('6mvQ1'));

});

parcelRegister("78lk4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cT5yc").then(()=>parcelRequire('jMC6T'));

});

parcelRegister("aWT81", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a0CG9").then(()=>parcelRequire('2Bq9l'));

});

parcelRegister("jQ8iZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ldewZ").then(()=>parcelRequire('hMWWU'));

});

parcelRegister("cKs5V", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gilnZ").then(()=>parcelRequire('hxqFA'));

});

parcelRegister("9YYzA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lSk2O").then(()=>parcelRequire('dnBrI'));

});

parcelRegister("elDKh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("atCAk").then(()=>parcelRequire('aUqA7'));

});

parcelRegister("4yx34", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fLh1T").then(()=>parcelRequire('kYXyk'));

});

parcelRegister("fLbjJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7fqGF").then(()=>parcelRequire('d3KbN'));

});

parcelRegister("k0CWB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1LMML").then(()=>parcelRequire('b8QVH'));

});

parcelRegister("gcIcF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aqvij").then(()=>parcelRequire('bEuPb'));

});

parcelRegister("2Z7XB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bMoVF").then(()=>parcelRequire('fUxGw'));

});

parcelRegister("5d07Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("easB0").then(()=>parcelRequire('gc97k'));

});

parcelRegister("2zZQq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jlVBw").then(()=>parcelRequire('biMhE'));

});

parcelRegister("dRVA0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6phqU").then(()=>parcelRequire('97ib0'));

});

parcelRegister("9xSz9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7QxF5").then(()=>parcelRequire('aGEG4'));

});

parcelRegister("l9Ceb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4OFbX").then(()=>parcelRequire('7UO5c'));

});

parcelRegister("h0N5E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6V2EZ").then(()=>parcelRequire('khYFw'));

});

parcelRegister("23c6C", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h3eSz").then(()=>parcelRequire('enuLW'));

});

parcelRegister("hi2Zy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6fIfG").then(()=>parcelRequire('jeHCF'));

});

parcelRegister("hfHNT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("116Fh").then(()=>parcelRequire('6kY1Z'));

});

parcelRegister("bPFii", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gP4AH").then(()=>parcelRequire('e3bFZ'));

});


parcelRegister("ekS74", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $0ea61b29ccc49abe$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $j9IhG = parcelRequire("j9IhG");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0ea61b29ccc49abe$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $0ea61b29ccc49abe$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("4guld")));
        case 'da':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("eEh9r")));
        case 'de':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("g7stf")));
        case 'en-GB':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("0Pjm7")));
        case 'en-US':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("NhIp2")));
        case 'en-XA':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("gB5pA")));
        case 'en-XB':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("bVGWD")));
        case 'en-ZZ':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("kjUzG")));
        case 'en':
            return $0ea61b29ccc49abe$var$importHelper(await Promise.resolve((parcelRequire("j9IhG"))));
        case 'es':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("gr9Aj")));
        case 'et':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("gRybf")));
        case 'fi':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("lSSD2")));
        case 'fr':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("gyfq2")));
        case 'hr':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("abVni")));
        case 'hu':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("b5d6t")));
        case 'it':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("elHt9")));
        case 'ja':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("fiPXp")));
        case 'ko':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("1yChO")));
        case 'nb':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("el40F")));
        case 'nl':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("iHKup")));
        case 'pl':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("hFW63")));
        case 'pt-BR':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("hUTBO")));
        case 'ro':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("b7BKq")));
        case 'ru':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("fOWJW")));
        case 'sl':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("k1m1G")));
        case 'sr-RS':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("4rE3V")));
        case 'sr-YR':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("3wVLm")));
        case 'sr':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("fuRCr")));
        case 'sv':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("5HZpV")));
        case 'th':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("hPW0f")));
        case 'tr':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("hFY42")));
        case 'uk':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("jPBoA")));
        case 'vi':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("1sGhp")));
        case 'zh-CN':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("bhLmk")));
        case 'zh-TW':
            return $0ea61b29ccc49abe$var$importHelper(await (parcelRequire("hkwy4")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($j9IhG));
    }
};

});
parcelRegister("j9IhG", function(module, exports) {
module.exports = JSON.parse("{\"jira-nin-grid-navigation-onboarding.closeButton\":[{\"type\":0,\"value\":\"Close\"}],\"jira-nin-grid-navigation-onboarding.enterEscapeNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Enter\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" activates inline edit mode while \"},{\"children\":[{\"type\":0,\"value\":\"Escape\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" returns you to cell navigation.\"}],\"jira-nin-grid-navigation-onboarding.heading\":[{\"type\":0,\"value\":\"Improved keyboard navigation\"}],\"jira-nin-grid-navigation-onboarding.homeEndPageNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Home\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" skips to the first cell in a row, \"},{\"children\":[{\"type\":0,\"value\":\"End\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" to the last. \"},{\"children\":[{\"type\":0,\"value\":\"Page Down\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" scrolls 1 page down, \"},{\"children\":[{\"type\":0,\"value\":\"Page Up\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" scrolls 1 page up, keeping focus in the same cell.\"}],\"jira-nin-grid-navigation-onboarding.moreShortcuts\":[{\"type\":0,\"value\":\"More shortcuts\"}],\"jira-nin-grid-navigation-onboarding.okButton\":[{\"type\":0,\"value\":\"Ok\"}],\"jira-nin-grid-navigation-onboarding.tabAndArrowNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Tab\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" into and out of the view quickly, and use \"},{\"children\":[{\"type\":0,\"value\":\"arrow keys\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" to navigate cells.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescription\":[{\"type\":0,\"value\":\"We've applied your settings from All work view. Do you want to apply your settings from the old List view instead? This includes the filters, groups, and columns you've set.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNo\":[{\"type\":0,\"value\":\"No, keep my settings from the All work view\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescription\":[{\"type\":0,\"value\":\"You can apply old List view settings later in the More actions (...) menu in the list.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpaces\":[{\"type\":0,\"value\":\"Yes, apply settings from all Jira spaces\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpace\":[{\"type\":0,\"value\":\"Yes, apply settings from \"},{\"type\":1,\"value\":\"spaceName\"},{\"type\":0,\"value\":\" space\"}],\"jira-nin-paid-list-merge-modal-onboarding.description\":[{\"type\":0,\"value\":\"We've combined the best of List and All Work views to bring you one powerful, unified view for managing work.\"}],\"jira-nin-paid-list-merge-modal-onboarding.heading\":[{\"type\":0,\"value\":\"List and All Work are merging\"}],\"jira-nin-paid-list-merge-modal-onboarding.learnMoreLink\":[{\"type\":0,\"value\":\"Read our announcement on Community\"}],\"jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback\":[{\"type\":0,\"value\":\"current\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label\":[{\"type\":0,\"value\":\"Apply settings\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label\":[{\"type\":0,\"value\":\"Explore List view\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.filter\":[{\"type\":0,\"value\":\"Search, filter, and group work items to quickly find what you need.\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions\":[{\"type\":0,\"value\":\"Adjust how you visualise the work with charts and format rules. You can also apply your old list settings.\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.text\":[{\"type\":0,\"value\":\"Find work faster using filters.\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.text.advanced.jql\":[{\"type\":0,\"value\":\"Select advanced or JQL mode to filter by more fields.\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.title\":[{\"type\":0,\"value\":\"A new home for filters\"}]}");

});

parcelRegister("4guld", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("0YeFX").then(()=>parcelRequire('4Sft0'));

});

parcelRegister("eEh9r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("18UCy").then(()=>parcelRequire('iHHcK'));

});

parcelRegister("g7stf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("70l3J").then(()=>parcelRequire('73fMo'));

});

parcelRegister("0Pjm7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jY0Qv").then(()=>parcelRequire('4KF4k'));

});

parcelRegister("NhIp2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gnj39").then(()=>parcelRequire('g8rvF'));

});

parcelRegister("gB5pA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("44WCz").then(()=>parcelRequire('ejM7W'));

});

parcelRegister("bVGWD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4VtVR").then(()=>parcelRequire('eOWtA'));

});

parcelRegister("kjUzG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1C4CZ").then(()=>parcelRequire('bPqNV'));

});

parcelRegister("gr9Aj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f6yy0").then(()=>parcelRequire('f4z0c'));

});

parcelRegister("gRybf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8UTG0").then(()=>parcelRequire('as8UH'));

});

parcelRegister("lSSD2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6LQfT").then(()=>parcelRequire('lkPLc'));

});

parcelRegister("gyfq2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("47mn7").then(()=>parcelRequire('ilqtW'));

});

parcelRegister("abVni", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fLX8T").then(()=>parcelRequire('6Ju3L'));

});

parcelRegister("b5d6t", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("keTcL").then(()=>parcelRequire('dZ0iW'));

});

parcelRegister("elHt9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cKUbk").then(()=>parcelRequire('aRTCP'));

});

parcelRegister("fiPXp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jLkOD").then(()=>parcelRequire('d4GPM'));

});

parcelRegister("1yChO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jl5nQ").then(()=>parcelRequire('l1aa7'));

});

parcelRegister("el40F", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fddWJ").then(()=>parcelRequire('cr3aG'));

});

parcelRegister("iHKup", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3nC6c").then(()=>parcelRequire('cfBcH'));

});

parcelRegister("hFW63", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jXWlu").then(()=>parcelRequire('amOe8'));

});

parcelRegister("hUTBO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Z2F4V").then(()=>parcelRequire('4qy1c'));

});

parcelRegister("b7BKq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lkcIt").then(()=>parcelRequire('9wtbc'));

});

parcelRegister("fOWJW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1y3jr").then(()=>parcelRequire('2YHWf'));

});

parcelRegister("k1m1G", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hlMzm").then(()=>parcelRequire('54pNf'));

});

parcelRegister("4rE3V", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fu9jF").then(()=>parcelRequire('jYquo'));

});

parcelRegister("3wVLm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3xt73").then(()=>parcelRequire('6sHk7'));

});

parcelRegister("fuRCr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfBrQ").then(()=>parcelRequire('f17cV'));

});

parcelRegister("5HZpV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eKxWb").then(()=>parcelRequire('g8q5V'));

});

parcelRegister("hPW0f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ku7cn").then(()=>parcelRequire('3sPDc'));

});

parcelRegister("hFY42", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5VLjt").then(()=>parcelRequire('kaSFD'));

});

parcelRegister("jPBoA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i5NTp").then(()=>parcelRequire('9Gfmu'));

});

parcelRegister("1sGhp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kbQU8").then(()=>parcelRequire('jayDk'));

});

parcelRegister("bhLmk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iUYKa").then(()=>parcelRequire('aEeJp'));

});

parcelRegister("hkwy4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ngvh").then(()=>parcelRequire('d60rx'));

});


parcelRegister("ePSan", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $ee8a3ce457fb653b$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4MLrR = parcelRequire("4MLrR");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ee8a3ce457fb653b$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ee8a3ce457fb653b$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("l5JQl")));
        case 'da':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("bfhwP")));
        case 'de':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("7RIsj")));
        case 'en-GB':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("aIF7M")));
        case 'en-US':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("jO7Jq")));
        case 'en-XA':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("4f56K")));
        case 'en-XB':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("3qyXv")));
        case 'en-ZZ':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("eAdLq")));
        case 'en':
            return $ee8a3ce457fb653b$var$importHelper(await Promise.resolve((parcelRequire("4MLrR"))));
        case 'es':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("9eYwC")));
        case 'et':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("lgPIy")));
        case 'fi':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("7pAcC")));
        case 'fr':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("glLjh")));
        case 'hr':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("krfNZ")));
        case 'hu':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("bt9YY")));
        case 'it':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("fBmH4")));
        case 'ja':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("lySPi")));
        case 'ko':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("3prmL")));
        case 'nb':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("ablnY")));
        case 'nl':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("gT2II")));
        case 'pl':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("bfwKP")));
        case 'pt-BR':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("cvoLk")));
        case 'ro':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("dvr4D")));
        case 'ru':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("a431v")));
        case 'sl':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("6YFXz")));
        case 'sr-RS':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("kCgHv")));
        case 'sr-YR':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("7knQx")));
        case 'sr':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("6y1iV")));
        case 'sv':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("1Tsfp")));
        case 'th':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("5hHda")));
        case 'tr':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("bMkWt")));
        case 'uk':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("1SVZd")));
        case 'vi':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("8MVxi")));
        case 'zh-CN':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("hf28f")));
        case 'zh-TW':
            return $ee8a3ce457fb653b$var$importHelper(await (parcelRequire("bHSIq")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4MLrR));
    }
};

});
parcelRegister("4MLrR", function(module, exports) {
module.exports = JSON.parse("{\"jira-pandora.common.footer.address.no-translate\":[{\"type\":0,\"value\":\"341 George Street, Sydney, NSW, 2000, Australia\"}],\"jira-pandora.common.footer.copyright.no-translate\":[{\"type\":0,\"value\":\"Copyright 2025 Atlassian Pty Ltd. All rights reserved.\"}],\"jira-pandora.common.project-access-email.banner.alt\":[{\"type\":0,\"value\":\"Jira banner image\"}],\"jira-pandora.jira-project-access-granted.email.body.content\":[{\"type\":0,\"value\":\"You can now access \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"You can now access your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.button.redacted.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.email.button.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"You've been granted access to your project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.subject\":[{\"type\":0,\"value\":\"You've been granted access to \"},{\"type\":1,\"value\":\"projectName\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.content\":[{\"type\":0,\"value\":\"Users have requested to join \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" project\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"Users have requested to join your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.redacted.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"Access request for your project\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.subject\":[{\"type\":0,\"value\":\"Access request for \"},{\"type\":1,\"value\":\"projectName\"}],\"jira.jira-notify-reaction.message-template.text.single-reaction-with-name\":[{\"type\":0,\"value\":\":bell: *\"},{\"type\":1,\"value\":\"userName\"},{\"type\":0,\"value\":\" reacted to your comment*\"}],\"jira.jira-notify-reaction.message-template.text.view-comment\":[{\"type\":0,\"value\":\"View comment\"}]}");

});

parcelRegister("l5JQl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iDsCS").then(()=>parcelRequire('9Z3tz'));

});

parcelRegister("bfhwP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1EybG").then(()=>parcelRequire('2qC1N'));

});

parcelRegister("7RIsj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1Ww9d").then(()=>parcelRequire('4vsJb'));

});

parcelRegister("aIF7M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6xwAX").then(()=>parcelRequire('cStEj'));

});

parcelRegister("jO7Jq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dT86q").then(()=>parcelRequire('18zQo'));

});

parcelRegister("4f56K", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Nsh8").then(()=>parcelRequire('8WAlV'));

});

parcelRegister("3qyXv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4emPQ").then(()=>parcelRequire('dJJB4'));

});

parcelRegister("eAdLq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6g1ru").then(()=>parcelRequire('UO0Gn'));

});

parcelRegister("9eYwC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9V1or").then(()=>parcelRequire('f3ggR'));

});

parcelRegister("lgPIy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1BjZP").then(()=>parcelRequire('4Giid'));

});

parcelRegister("7pAcC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eJqf4").then(()=>parcelRequire('3iC8w'));

});

parcelRegister("glLjh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4iBzE").then(()=>parcelRequire('GXzcY'));

});

parcelRegister("krfNZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2ROFE").then(()=>parcelRequire('1IV4d'));

});

parcelRegister("bt9YY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("acCHK").then(()=>parcelRequire('c1upw'));

});

parcelRegister("fBmH4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3RTYP").then(()=>parcelRequire('3ekdi'));

});

parcelRegister("lySPi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ib2XA").then(()=>parcelRequire('8M6Qm'));

});

parcelRegister("3prmL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7KDb4").then(()=>parcelRequire('gLLiw'));

});

parcelRegister("ablnY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("WDgO4").then(()=>parcelRequire('3NpHq'));

});

parcelRegister("gT2II", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7TFUJ").then(()=>parcelRequire('c0Gds'));

});

parcelRegister("bfwKP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("buA4m").then(()=>parcelRequire('65pkJ'));

});

parcelRegister("cvoLk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6a8Xq").then(()=>parcelRequire('deElx'));

});

parcelRegister("dvr4D", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lkVN1").then(()=>parcelRequire('8wpGk'));

});

parcelRegister("a431v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9ZZ0i").then(()=>parcelRequire('8siTg'));

});

parcelRegister("6YFXz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ZmRu").then(()=>parcelRequire('bb8K8'));

});

parcelRegister("kCgHv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6LeQg").then(()=>parcelRequire('eRFmF'));

});

parcelRegister("7knQx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fBRlP").then(()=>parcelRequire('dasM8'));

});

parcelRegister("6y1iV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hAfMz").then(()=>parcelRequire('78QGM'));

});

parcelRegister("1Tsfp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8Eh9P").then(()=>parcelRequire('5V02a'));

});

parcelRegister("5hHda", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kg4LX").then(()=>parcelRequire('lvHUa'));

});

parcelRegister("bMkWt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fotOn").then(()=>parcelRequire('iTIGl'));

});

parcelRegister("1SVZd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3DeMa").then(()=>parcelRequire('eFKMG'));

});

parcelRegister("8MVxi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dW9dw").then(()=>parcelRequire('024gz'));

});

parcelRegister("hf28f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("75s81").then(()=>parcelRequire('6T3Ce'));

});

parcelRegister("bHSIq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gemEH").then(()=>parcelRequire('4MMPI'));

});


parcelRegister("cf3Ol", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $4ab46414378420ac$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $evAsn = parcelRequire("evAsn");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4ab46414378420ac$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4ab46414378420ac$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("lg0L8")));
        case 'da':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("g4aQo")));
        case 'de':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("e4mqH")));
        case 'en-GB':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("fYs60")));
        case 'en-US':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("cKp2W")));
        case 'en-XA':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("a8Cr6")));
        case 'en-XB':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("8tymu")));
        case 'en-ZZ':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("iBv04")));
        case 'en':
            return $4ab46414378420ac$var$importHelper(await Promise.resolve((parcelRequire("evAsn"))));
        case 'es':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("1xb6p")));
        case 'et':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("hdfu2")));
        case 'fi':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("5Mnrf")));
        case 'fr':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("jHe5Y")));
        case 'hr':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("kkJ4L")));
        case 'hu':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("aBtam")));
        case 'it':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("5JaaE")));
        case 'ja':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("jpaKt")));
        case 'ko':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("k6VYF")));
        case 'nb':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("j2GOj")));
        case 'nl':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("cJLHo")));
        case 'pl':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("fvTs0")));
        case 'pt-BR':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("aPg8r")));
        case 'ro':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("lNoFg")));
        case 'ru':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("jx3WZ")));
        case 'sl':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("gb4ZY")));
        case 'sr-RS':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("69rcM")));
        case 'sr-YR':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("aA2Zk")));
        case 'sr':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("cfkdO")));
        case 'sv':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("9Ghwn")));
        case 'th':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("ddJhW")));
        case 'tr':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("bvJaN")));
        case 'uk':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("hjN5l")));
        case 'vi':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("Relnj")));
        case 'zh-CN':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("biplW")));
        case 'zh-TW':
            return $4ab46414378420ac$var$importHelper(await (parcelRequire("cCC2h")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($evAsn));
    }
};

});
parcelRegister("evAsn", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("lg0L8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7I5Jc").then(()=>parcelRequire('1uCPK'));

});

parcelRegister("g4aQo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fgFbP").then(()=>parcelRequire('GdF0t'));

});

parcelRegister("e4mqH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eB4K3").then(()=>parcelRequire('36IIq'));

});

parcelRegister("fYs60", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kxPXV").then(()=>parcelRequire('4suLn'));

});

parcelRegister("cKp2W", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("574CX").then(()=>parcelRequire('8lLQC'));

});

parcelRegister("a8Cr6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6BZbQ").then(()=>parcelRequire('e4V1k'));

});

parcelRegister("8tymu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jb2st").then(()=>parcelRequire('7w5dx'));

});

parcelRegister("iBv04", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9pe8z").then(()=>parcelRequire('bNJJq'));

});

parcelRegister("1xb6p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fP0v9").then(()=>parcelRequire('f29Su'));

});

parcelRegister("hdfu2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jBhPn").then(()=>parcelRequire('fyWni'));

});

parcelRegister("5Mnrf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aKJlN").then(()=>parcelRequire('3nacu'));

});

parcelRegister("jHe5Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lX4S5").then(()=>parcelRequire('9q25v'));

});

parcelRegister("kkJ4L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("64fSG").then(()=>parcelRequire('95WYF'));

});

parcelRegister("aBtam", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4XBpR").then(()=>parcelRequire('2dcG3'));

});

parcelRegister("5JaaE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6gxk3").then(()=>parcelRequire('iq8b4'));

});

parcelRegister("jpaKt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cyYCK").then(()=>parcelRequire('bHwwB'));

});

parcelRegister("k6VYF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6idhL").then(()=>parcelRequire('azam2'));

});

parcelRegister("j2GOj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bbrSy").then(()=>parcelRequire('kGAqz'));

});

parcelRegister("cJLHo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("59rKw").then(()=>parcelRequire('gwlAD'));

});

parcelRegister("fvTs0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5httq").then(()=>parcelRequire('jaXYa'));

});

parcelRegister("aPg8r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8N2xl").then(()=>parcelRequire('il1j8'));

});

parcelRegister("lNoFg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fJojm").then(()=>parcelRequire('1S0Rp'));

});

parcelRegister("jx3WZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h7BTr").then(()=>parcelRequire('gBcDc'));

});

parcelRegister("gb4ZY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4fNTY").then(()=>parcelRequire('lv8mT'));

});

parcelRegister("69rcM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l5GMi").then(()=>parcelRequire('6iG9a'));

});

parcelRegister("aA2Zk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d2MIY").then(()=>parcelRequire('2ICev'));

});

parcelRegister("cfkdO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("46WNF").then(()=>parcelRequire('9fiHX'));

});

parcelRegister("9Ghwn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9OfUc").then(()=>parcelRequire('8QYui'));

});

parcelRegister("ddJhW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eIAVb").then(()=>parcelRequire('4EXSW'));

});

parcelRegister("bvJaN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f4Pg6").then(()=>parcelRequire('47dkS'));

});

parcelRegister("hjN5l", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bFEDY").then(()=>parcelRequire('iWPaH'));

});

parcelRegister("Relnj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iRAkb").then(()=>parcelRequire('Rs7gs'));

});

parcelRegister("biplW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lDwxv").then(()=>parcelRequire('bhSzo'));

});

parcelRegister("cCC2h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("823dU").then(()=>parcelRequire('d0O5A'));

});


parcelRegister("ap0QV", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $7f0598da8c4ec085$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bG8hW = parcelRequire("bG8hW");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7f0598da8c4ec085$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7f0598da8c4ec085$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("6yZXp")));
        case 'da':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("5gIbK")));
        case 'de':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("egsWS")));
        case 'en-GB':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("4IPXh")));
        case 'en-US':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("bd4Na")));
        case 'en-XA':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("h2V6R")));
        case 'en-XB':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("dtYul")));
        case 'en-ZZ':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("5hWn5")));
        case 'en':
            return $7f0598da8c4ec085$var$importHelper(await Promise.resolve((parcelRequire("bG8hW"))));
        case 'es':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("1UpKx")));
        case 'et':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("600uo")));
        case 'fi':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("i2LHC")));
        case 'fr':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("3jhLB")));
        case 'hr':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("cIZk3")));
        case 'hu':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("k41lt")));
        case 'it':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("5O6aR")));
        case 'ja':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("fqhf7")));
        case 'ko':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("f7gP2")));
        case 'nb':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("lxLjo")));
        case 'nl':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("3Eq12")));
        case 'pl':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("5f5WR")));
        case 'pt-BR':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("4MNCm")));
        case 'ro':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("dDj23")));
        case 'ru':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("3RVej")));
        case 'sl':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("6pxWk")));
        case 'sr-RS':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("eHH6A")));
        case 'sr-YR':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("hV2mU")));
        case 'sr':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("kqEjb")));
        case 'sv':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("iKlwT")));
        case 'th':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("590Sa")));
        case 'tr':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("l868x")));
        case 'uk':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("8T7oY")));
        case 'vi':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("QIFpY")));
        case 'zh-CN':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("imNxW")));
        case 'zh-TW':
            return $7f0598da8c4ec085$var$importHelper(await (parcelRequire("it2rx")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bG8hW));
    }
};

});
parcelRegister("bG8hW", function(module, exports) {
module.exports = JSON.parse('{"dismiss":[{"type":0,"value":"Dismiss"}],"jira-issueview-layouts.issue-view-layout-picker-changeboarding-body":[{"type":0,"value":"Choose a layout that works best for you."}],"jira-issueview-layouts.issue-view-layout-picker-changeboarding-heading":[{"type":0,"value":"Customise your view"}],"jira-thor.jira-notifications-project-recap.issue-row.work-item-key":[{"type":1,"value":"workItemKey"}],"jira-thor.jira-notifications-project-recap.issue-row.work-item-summary":[{"type":1,"value":"workItemSummary"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.body":[{"type":0,"value":"Don\'t let this work slip under the radar. Keep an eye on these unassigned work items by watching them, or assign them to yourself."}],"jira-thor.jira-notifications-project-recap.message-template-template.email.heading":[{"type":0,"value":"This work hasn\'t been assigned to anyone"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.manage-notifications":[{"type":0,"value":"Manage notifications"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.privacy-policy":[{"type":0,"value":"Privacy policy"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.separator-dot":[{"type":0,"value":"\u2022"}],"jira-thor.jira-notifications-project-recap.message-template-template.issue.assign.action":[{"type":0,"value":"Assign to me"}],"jira-thor.jira-notifications-project-recap.message-template-template.issue.watch.action":[{"type":0,"value":"Watch"}],"jira-thor.jira-notifications-project-recap.message-template-template.project.remaining.items":[{"type":0,"value":"+"},{"type":1,"value":"remaining"},{"type":0,"value":" more..."}],"jira-thor.jira-notifications-project-recap.message-template-template.project.total.unassigned.items":[{"type":0,"value":"Unassigned work items ("},{"type":1,"value":"totalCount"},{"type":0,"value":")"}],"jira-thor.jira-notifications-project-recap.message-template-template.project.view.all":[{"type":0,"value":"View all in Jira"}],"jira-thor.jira-notifications-project-recap.message-template.email.subject.no-translate":[{"type":1,"value":"name"},{"type":0,"value":", don\'t miss this week\'s unassigned work items"}],"jira.jira-notifications-project-recap.message-template-template.email.contact-us":[{"type":0,"value":"Contact us"}],"jira.jira-notifications-project-recap.message-template-template.email.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira.jira-notifications-project-recap.message-template-template.email.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"try-now":[{"type":0,"value":"Try now"}]}');

});

parcelRegister("6yZXp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fgxCU").then(()=>parcelRequire('i878A'));

});

parcelRegister("5gIbK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a97IR").then(()=>parcelRequire('dYUex'));

});

parcelRegister("egsWS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ajQeC").then(()=>parcelRequire('7DKsD'));

});

parcelRegister("4IPXh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Gzf8").then(()=>parcelRequire('hdQQK'));

});

parcelRegister("bd4Na", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5jQCZ").then(()=>parcelRequire('vTm8n'));

});

parcelRegister("h2V6R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cq8JU").then(()=>parcelRequire('gB7iw'));

});

parcelRegister("dtYul", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Qihf").then(()=>parcelRequire('jmyXj'));

});

parcelRegister("5hWn5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ajD4l").then(()=>parcelRequire('d65VT'));

});

parcelRegister("1UpKx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8tZDL").then(()=>parcelRequire('eO3nF'));

});

parcelRegister("600uo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6JkJq").then(()=>parcelRequire('3sFE0'));

});

parcelRegister("i2LHC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4T2J3").then(()=>parcelRequire('emim1'));

});

parcelRegister("3jhLB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hbUTl").then(()=>parcelRequire('6MwDI'));

});

parcelRegister("cIZk3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lzqPA").then(()=>parcelRequire('3Y5kJ'));

});

parcelRegister("k41lt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hGlFt").then(()=>parcelRequire('1H9in'));

});

parcelRegister("5O6aR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2qMTC").then(()=>parcelRequire('lCnJA'));

});

parcelRegister("fqhf7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kDCdq").then(()=>parcelRequire('hq0Gw'));

});

parcelRegister("f7gP2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ix4i0").then(()=>parcelRequire('5D7du'));

});

parcelRegister("lxLjo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("88uaN").then(()=>parcelRequire('dSYY6'));

});

parcelRegister("3Eq12", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k2SV0").then(()=>parcelRequire('6BBXS'));

});

parcelRegister("5f5WR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gw2um").then(()=>parcelRequire('hkrvJ'));

});

parcelRegister("4MNCm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("asfWY").then(()=>parcelRequire('iaTUL'));

});

parcelRegister("dDj23", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jVQ9C").then(()=>parcelRequire('2omh8'));

});

parcelRegister("3RVej", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i1ge2").then(()=>parcelRequire('aY6MW'));

});

parcelRegister("6pxWk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cJVIa").then(()=>parcelRequire('9KRMJ'));

});

parcelRegister("eHH6A", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bFtIl").then(()=>parcelRequire('9HytV'));

});

parcelRegister("hV2mU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("56pLh").then(()=>parcelRequire('3B3mf'));

});

parcelRegister("kqEjb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a1T2e").then(()=>parcelRequire('4XFKp'));

});

parcelRegister("iKlwT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ffCjG").then(()=>parcelRequire('kl7I8'));

});

parcelRegister("590Sa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("72zml").then(()=>parcelRequire('bvOVK'));

});

parcelRegister("l868x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lov3e").then(()=>parcelRequire('c8qIO'));

});

parcelRegister("8T7oY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fEAMS").then(()=>parcelRequire('6PBqm'));

});

parcelRegister("QIFpY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8zhZ1").then(()=>parcelRequire('jeeG7'));

});

parcelRegister("imNxW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dck2g").then(()=>parcelRequire('32dr6'));

});

parcelRegister("it2rx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("126lu").then(()=>parcelRequire('33iwa'));

});


parcelRegister("cW2FJ", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $eafafd07354e958a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $inUJ4 = parcelRequire("inUJ4");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eafafd07354e958a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $eafafd07354e958a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("eNf2q")));
        case 'da':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("2cqfg")));
        case 'de':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("gcNsr")));
        case 'en-GB':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("d0NKW")));
        case 'en-US':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("dT26X")));
        case 'en-XA':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("7IozU")));
        case 'en-XB':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("kmLcR")));
        case 'en-ZZ':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("230by")));
        case 'en':
            return $eafafd07354e958a$var$importHelper(await Promise.resolve((parcelRequire("inUJ4"))));
        case 'es':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("la5ng")));
        case 'et':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("a7IuG")));
        case 'fi':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("eF4xH")));
        case 'fr':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("5TsWe")));
        case 'hr':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("l1Opj")));
        case 'hu':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("kniPu")));
        case 'it':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("cjOEq")));
        case 'ja':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("1W2aU")));
        case 'ko':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("8Zoai")));
        case 'nb':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("4TQ1q")));
        case 'nl':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("fAvP0")));
        case 'pl':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("74VpW")));
        case 'pt-BR':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("aHZyE")));
        case 'ro':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("1N9jq")));
        case 'ru':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("29voN")));
        case 'sl':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("hhtA3")));
        case 'sr-RS':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("bu4sh")));
        case 'sr-YR':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("aZUMo")));
        case 'sr':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("hjUWB")));
        case 'sv':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("cdD3Y")));
        case 'th':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("HjC01")));
        case 'tr':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("axRwj")));
        case 'uk':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("4XDI8")));
        case 'vi':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("9Kpc5")));
        case 'zh-CN':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("i8hjd")));
        case 'zh-TW':
            return $eafafd07354e958a$var$importHelper(await (parcelRequire("danB1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($inUJ4));
    }
};

});
parcelRegister("inUJ4", function(module, exports) {
module.exports = JSON.parse("{\"frozen-columns-onboarding.spotlight.body\":[{\"type\":0,\"value\":\"Sort, freeze and resize Work from a single control.\"}],\"frozen-columns-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"OK\"}],\"frozen-columns-onboarding.spotlight.heading\":[{\"type\":0,\"value\":\"Manage Work\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.body\":[{\"type\":0,\"value\":\"Group work by fields including versions, labels, work types and more.\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"OK\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.heading\":[{\"type\":0,\"value\":\"Group work to stay organized\"}]}");

});

parcelRegister("eNf2q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("47fIw").then(()=>parcelRequire('3lIA3'));

});

parcelRegister("2cqfg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8Msk6").then(()=>parcelRequire('gxTpL'));

});

parcelRegister("gcNsr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1xulB").then(()=>parcelRequire('8jV93'));

});

parcelRegister("d0NKW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h1h91").then(()=>parcelRequire('kz5fq'));

});

parcelRegister("dT26X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cGbhj").then(()=>parcelRequire('kZaQu'));

});

parcelRegister("7IozU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iLfzI").then(()=>parcelRequire('hwjHU'));

});

parcelRegister("kmLcR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5TrzL").then(()=>parcelRequire('hyWOU'));

});

parcelRegister("230by", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4vvwt").then(()=>parcelRequire('ioRlR'));

});

parcelRegister("la5ng", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("937Yn").then(()=>parcelRequire('6ePd1'));

});

parcelRegister("a7IuG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fY7IH").then(()=>parcelRequire('akzYW'));

});

parcelRegister("eF4xH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("10Vy1").then(()=>parcelRequire('dxT54'));

});

parcelRegister("5TsWe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6mSYZ").then(()=>parcelRequire('etjNp'));

});

parcelRegister("l1Opj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dT8KP").then(()=>parcelRequire('a2sgn'));

});

parcelRegister("kniPu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Vhzbo").then(()=>parcelRequire('b7x2U'));

});

parcelRegister("cjOEq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cJ79V").then(()=>parcelRequire('7rsxb'));

});

parcelRegister("1W2aU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("UpA6h").then(()=>parcelRequire('8B8Sy'));

});

parcelRegister("8Zoai", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("byXlE").then(()=>parcelRequire('jERLI'));

});

parcelRegister("4TQ1q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("df3DW").then(()=>parcelRequire('lzohJ'));

});

parcelRegister("fAvP0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("czBH9").then(()=>parcelRequire('9HyOS'));

});

parcelRegister("74VpW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aOhXV").then(()=>parcelRequire('cEvik'));

});

parcelRegister("aHZyE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lwvkI").then(()=>parcelRequire('8UOfb'));

});

parcelRegister("1N9jq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hd2PH").then(()=>parcelRequire('lsYIe'));

});

parcelRegister("29voN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5xh5m").then(()=>parcelRequire('dT2Su'));

});

parcelRegister("hhtA3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kPf5l").then(()=>parcelRequire('9w44o'));

});

parcelRegister("bu4sh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9sK10").then(()=>parcelRequire('6asVI'));

});

parcelRegister("aZUMo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("68mEC").then(()=>parcelRequire('17zIZ'));

});

parcelRegister("hjUWB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("flFx3").then(()=>parcelRequire('8xHcr'));

});

parcelRegister("cdD3Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gpnLe").then(()=>parcelRequire('4siX9'));

});

parcelRegister("HjC01", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cbpTs").then(()=>parcelRequire('h0tp7'));

});

parcelRegister("axRwj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9VZbR").then(()=>parcelRequire('4Na6w'));

});

parcelRegister("4XDI8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bG4Tm").then(()=>parcelRequire('85Fev'));

});

parcelRegister("9Kpc5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l6ZXO").then(()=>parcelRequire('4GKTf'));

});

parcelRegister("i8hjd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f9fPO").then(()=>parcelRequire('bWvgQ'));

});

parcelRegister("danB1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7OUEJ").then(()=>parcelRequire('fmHDI'));

});


parcelRegister("9msAs", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $e8c350bce9b1746c$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $idwpQ = parcelRequire("idwpQ");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e8c350bce9b1746c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e8c350bce9b1746c$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("60t5K")));
        case 'da':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("2K8Di")));
        case 'de':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("7wm20")));
        case 'en-GB':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("fOwyH")));
        case 'en-US':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("4ydG0")));
        case 'en-XA':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("gdBNL")));
        case 'en-XB':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("0180x")));
        case 'en-ZZ':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("8zrdx")));
        case 'en':
            return $e8c350bce9b1746c$var$importHelper(await Promise.resolve((parcelRequire("idwpQ"))));
        case 'es':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("dJCAo")));
        case 'et':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("ewLRT")));
        case 'fi':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("e3mHh")));
        case 'fr':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("fRmgs")));
        case 'hr':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("cgYGD")));
        case 'hu':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("h3i3r")));
        case 'it':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("2Eu5m")));
        case 'ja':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("1i9qD")));
        case 'ko':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("9rDwV")));
        case 'nb':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("cJNLV")));
        case 'nl':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("9baKo")));
        case 'pl':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("hZdRd")));
        case 'pt-BR':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("4i1XV")));
        case 'ro':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("9YydH")));
        case 'ru':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("bOduf")));
        case 'sl':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("dwX4I")));
        case 'sr-RS':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("hdCdz")));
        case 'sr-YR':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("aFdBr")));
        case 'sr':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("f3RWb")));
        case 'sv':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("kM4BW")));
        case 'th':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("1IKiF")));
        case 'tr':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("acEif")));
        case 'uk':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("juH1c")));
        case 'vi':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("5NdbP")));
        case 'zh-CN':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("2nWAb")));
        case 'zh-TW':
            return $e8c350bce9b1746c$var$importHelper(await (parcelRequire("31xHk")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($idwpQ));
    }
};

});
parcelRegister("idwpQ", function(module, exports) {
module.exports = JSON.parse('{"jsm-project-summary-onboarding.changeLayout":[{"type":0,"value":"Change the layout and order of charts"}],"jsm-project-summary-onboarding.closeButton":[{"type":0,"value":"Close"}],"jsm-project-summary-onboarding.description":[{"type":0,"value":"You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."}],"jsm-project-summary-onboarding.editFilters":[{"type":0,"value":"Edit filters"}],"jsm-project-summary-onboarding.heading":[{"type":0,"value":"Edit your space summary"}],"jsm-project-summary-onboarding.hideAddCharts":[{"type":0,"value":"Hide or add charts"}],"jsm-project-summary-onboarding.moreAboutFeature":[{"type":0,"value":"More about space summary"}],"jsm-project-summary-onboarding.okButton":[{"type":0,"value":"Got it"}],"jsm-project-summary-onboarding.whatsNewTitle":[{"type":0,"value":"What\u2019s new?"}]}');

});

parcelRegister("60t5K", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("acV6I").then(()=>parcelRequire('gBg3w'));

});

parcelRegister("2K8Di", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lNJCe").then(()=>parcelRequire('dpLfC'));

});

parcelRegister("7wm20", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5BDDk").then(()=>parcelRequire('7ZStd'));

});

parcelRegister("fOwyH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eq0Fx").then(()=>parcelRequire('1eKr8'));

});

parcelRegister("4ydG0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("oiOgV").then(()=>parcelRequire('hV2Ue'));

});

parcelRegister("gdBNL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kzbst").then(()=>parcelRequire('cGJyW'));

});

parcelRegister("0180x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eVo2q").then(()=>parcelRequire('4G3Sl'));

});

parcelRegister("8zrdx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3X4zX").then(()=>parcelRequire('6EXXk'));

});

parcelRegister("dJCAo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l08wq").then(()=>parcelRequire('9jve4'));

});

parcelRegister("ewLRT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("go6sV").then(()=>parcelRequire('h9YUg'));

});

parcelRegister("e3mHh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cJ6Y5").then(()=>parcelRequire('40GI8'));

});

parcelRegister("fRmgs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2j6v3").then(()=>parcelRequire('7ylv2'));

});

parcelRegister("cgYGD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3wor3").then(()=>parcelRequire('b1wSl'));

});

parcelRegister("h3i3r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aQi9w").then(()=>parcelRequire('9ZasX'));

});

parcelRegister("2Eu5m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1mTou").then(()=>parcelRequire('858UZ'));

});

parcelRegister("1i9qD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("clPWs").then(()=>parcelRequire('bp3hM'));

});

parcelRegister("9rDwV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aOVJ4").then(()=>parcelRequire('fexWs'));

});

parcelRegister("cJNLV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iRDtW").then(()=>parcelRequire('hmJLf'));

});

parcelRegister("9baKo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6PY7Y").then(()=>parcelRequire('bqCcB'));

});

parcelRegister("hZdRd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5N3rX").then(()=>parcelRequire('gt3Bn'));

});

parcelRegister("4i1XV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("je1QC").then(()=>parcelRequire('gsB19'));

});

parcelRegister("9YydH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ieHR8").then(()=>parcelRequire('ajzlr'));

});

parcelRegister("bOduf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3M88q").then(()=>parcelRequire('3Htay'));

});

parcelRegister("dwX4I", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eDj38").then(()=>parcelRequire('GD4O9'));

});

parcelRegister("hdCdz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ZTZI").then(()=>parcelRequire('c6FnB'));

});

parcelRegister("aFdBr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("joexP").then(()=>parcelRequire('6DM0x'));

});

parcelRegister("f3RWb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1DCjj").then(()=>parcelRequire('7ojdt'));

});

parcelRegister("kM4BW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lPbRe").then(()=>parcelRequire('iNLnG'));

});

parcelRegister("1IKiF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8OOI7").then(()=>parcelRequire('eEtVH'));

});

parcelRegister("acEif", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3ZHFL").then(()=>parcelRequire('2FR9O'));

});

parcelRegister("juH1c", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9ovfh").then(()=>parcelRequire('hnu5D'));

});

parcelRegister("5NdbP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g5hZP").then(()=>parcelRequire('dMIKG'));

});

parcelRegister("2nWAb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7UEFe").then(()=>parcelRequire('dNosa'));

});

parcelRegister("31xHk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gKuZo").then(()=>parcelRequire('hHVjo'));

});


parcelRegister("lkbzt", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $6ee869ec8187fa6f$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cBXHu = parcelRequire("cBXHu");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6ee869ec8187fa6f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $6ee869ec8187fa6f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("gdGQ8")));
        case 'da':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("lttly")));
        case 'de':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("eTtB6")));
        case 'en-GB':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("9Y89x")));
        case 'en-US':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("3tWiA")));
        case 'en-XA':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("2iaCT")));
        case 'en-XB':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("lfKVX")));
        case 'en-ZZ':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("5iRAv")));
        case 'en':
            return $6ee869ec8187fa6f$var$importHelper(await Promise.resolve((parcelRequire("cBXHu"))));
        case 'es':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("91FmP")));
        case 'et':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("96Yrp")));
        case 'fi':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("67jlj")));
        case 'fr':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("4b8s5")));
        case 'hr':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("5EyvP")));
        case 'hu':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("g6WiZ")));
        case 'it':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("70yhf")));
        case 'ja':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("8emIu")));
        case 'ko':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("j3Cio")));
        case 'nb':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("6Oga0")));
        case 'nl':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("2DpTn")));
        case 'pl':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("7yqOg")));
        case 'pt-BR':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("fkJVa")));
        case 'ro':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("bTybK")));
        case 'ru':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("dW3gO")));
        case 'sl':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("flFut")));
        case 'sr-RS':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("6jj03")));
        case 'sr-YR':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("fsFZz")));
        case 'sr':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("9D0el")));
        case 'sv':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("e8edB")));
        case 'th':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("hSh4x")));
        case 'tr':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("fIbhK")));
        case 'uk':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("dhIb4")));
        case 'vi':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("2dKiV")));
        case 'zh-CN':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("fn1Mq")));
        case 'zh-TW':
            return $6ee869ec8187fa6f$var$importHelper(await (parcelRequire("5uKRu")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cBXHu));
    }
};

});
parcelRegister("cBXHu", function(module, exports) {
module.exports = JSON.parse('{"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading":[{"type":0,"value":"Consumption-based pricing starts with your next renewal"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro":[{"type":0,"value":"We\u2019re letting you know that Assets and Virtual service agent will move to consumption-based pricing at your next renewal on "},{"type":1,"value":"cbpEffectiveDate"},{"type":0,"value":". Additional charges will only apply if your usage exceeds the included limit. Check your current usage and learn more below."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know":[{"type":0,"value":"Helpful things to know:"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text":[{"type":0,"value":"comment"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text":[{"type":0,"value":"lightbulb"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema":[{"children":[{"type":0,"value":"Contact support"}],"type":8,"value":"a"},{"type":0,"value":" if you have any questions"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit":[{"type":0,"value":"Consider "},{"children":[{"type":0,"value":"optimizing the structure of your schemas"}],"type":8,"value":"a"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button":[{"type":0,"value":"More details"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject":[{"type":0,"value":"[Reminder] Upcoming pricing changes to Assets and Virtual Service Agent"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide":[{"type":0,"value":"For more information, read more about "},{"children":[{"type":0,"value":"how feature usage limits work"}],"type":8,"value":"a"},{"type":0,"value":"."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button":[{"type":0,"value":"View and manage usage"}],"jsm-sequoia.jsm-gpc-notifications.message-template.email.body.footer-info":[{"type":0,"value":"You\'re receiving this message because your team is affected by the packaging changes announced on Oct 16, 2024."}],"jsm-sequoia.jsm-gpc-notifications.message-template.email.body.grace-period-info-new":[{"type":0,"value":"Your team will lose access to advanced incident, change, and problem management on "},{"type":1,"value":"gpEndDate"},{"type":0,"value":". This is a part of the pricing and packaging announcements made by us on Oct 16, 2024 for Jira Service Management."}],"jsm-sequoia.jsm-gpc-notifications.message-template.email.body.heading":[{"type":0,"value":"Retain your team\'s key capabilities - upgrade to Jira Service Management Premium before "},{"type":1,"value":"gpEndDate"},{"type":0,"value":"."}],"jsm-sequoia.jsm-gpc-notifications.message-template.email.body.jsm-recommendation":[{"type":0,"value":"We recommend upgrading to "},{"children":[{"type":0,"value":"Jira Service Management Premium"}],"type":8,"value":"b"},{"type":0,"value":" to avoid any disruptions to your team."}],"jsm-sequoia.jsm-gpc-notifications.message-template.email.body.learn-more":[{"type":0,"value":"More about what\'s changing"}],"jsm-sequoia.jsm-gpc-notifications.message-template.email.body.need-help":[{"type":0,"value":"Talk to us"}],"jsm-sequoia.jsm-gpc-notifications.message-template.email.body.try-premium-for-free":[{"type":0,"value":"Try Premium for free"}],"jsm-sequoia.jsm-gpc-notifications.message-template.email.subject.new":[{"type":0,"value":"[Action required] In 30 days, you\'ll lose access to advanced incident, change, and problem management."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.avatar.alt_text.user_avatar":[{"type":0,"value":"User Avatar"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.connection":[{"type":0,"value":"Connection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.csm":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.id-badge":[{"type":0,"value":"ID Badge"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.jsm":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.service-collection":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.description":[{"type":0,"value":"Deliver better customer support and quickly turn feedback into product improvements."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.title":[{"type":0,"value":"Delight external customers with purpose-built features"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.description":[{"type":0,"value":"Make internal support easier by enabling HR, IT, and other teams to resolve employee requests quickly."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.title":[{"type":0,"value":"Unite teams to deliver exceptional service experiences"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.alt_text.atlassian":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.contact_us":[{"type":0,"value":"Contact us"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.privacy_policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.read_our_blog":[{"type":0,"value":"Blog"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.twitter.no-translate":[{"type":0,"value":"Twitter"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.greeting":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":","}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.message":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" has requested a trial of Service Collection."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" requested your organization try Service Collection, Atlassian\u2019s solution for AI service management at high velocity."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.cta":[{"type":0,"value":"Try Service Collection for free"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":", "},{"type":1,"value":"requestingUserName"},{"type":0,"value":" wants you to start a Service Collection trial"}]}');

});

parcelRegister("gdGQ8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5AKIL").then(()=>parcelRequire('i8Vfe'));

});

parcelRegister("lttly", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("qs2fs").then(()=>parcelRequire('eZgS9'));

});

parcelRegister("eTtB6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dtyuX").then(()=>parcelRequire('dxsFu'));

});

parcelRegister("9Y89x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i707i").then(()=>parcelRequire('1trQq'));

});

parcelRegister("3tWiA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Uii1").then(()=>parcelRequire('aIk2W'));

});

parcelRegister("2iaCT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dRIP5").then(()=>parcelRequire('dQ2Jo'));

});

parcelRegister("lfKVX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h59w5").then(()=>parcelRequire('9Qtao'));

});

parcelRegister("5iRAv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3RPI6").then(()=>parcelRequire('h8HrR'));

});

parcelRegister("91FmP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1CqOv").then(()=>parcelRequire('22IYd'));

});

parcelRegister("96Yrp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("alntP").then(()=>parcelRequire('kNGCN'));

});

parcelRegister("67jlj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("qFwRK").then(()=>parcelRequire('bPaYe'));

});

parcelRegister("4b8s5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8WoNm").then(()=>parcelRequire('kyCKS'));

});

parcelRegister("5EyvP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lcIe7").then(()=>parcelRequire('lumIR'));

});

parcelRegister("g6WiZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8cVqZ").then(()=>parcelRequire('fXPMK'));

});

parcelRegister("70yhf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cAtsg").then(()=>parcelRequire('8azmD'));

});

parcelRegister("8emIu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("28SkP").then(()=>parcelRequire('35tAX'));

});

parcelRegister("j3Cio", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7AD96").then(()=>parcelRequire('4UjsG'));

});

parcelRegister("6Oga0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("29ai5").then(()=>parcelRequire('dRYXQ'));

});

parcelRegister("2DpTn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("55qHL").then(()=>parcelRequire('5YglT'));

});

parcelRegister("7yqOg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gyR8g").then(()=>parcelRequire('g42kD'));

});

parcelRegister("fkJVa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3aC1N").then(()=>parcelRequire('g31zB'));

});

parcelRegister("bTybK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aKH6G").then(()=>parcelRequire('5t3rF'));

});

parcelRegister("dW3gO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fVvF0").then(()=>parcelRequire('ll0df'));

});

parcelRegister("flFut", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4g6pn").then(()=>parcelRequire('kj4YD'));

});

parcelRegister("6jj03", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hitr6").then(()=>parcelRequire('bcar5'));

});

parcelRegister("fsFZz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f3VhN").then(()=>parcelRequire('h5JHV'));

});

parcelRegister("9D0el", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9pzF3").then(()=>parcelRequire('8oMCy'));

});

parcelRegister("e8edB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fcydO").then(()=>parcelRequire('lTt7V'));

});

parcelRegister("hSh4x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7JjmO").then(()=>parcelRequire('1xi4I'));

});

parcelRegister("fIbhK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hJeYf").then(()=>parcelRequire('aMAFT'));

});

parcelRegister("dhIb4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Usen").then(()=>parcelRequire('9Y9pf'));

});

parcelRegister("2dKiV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dw4di").then(()=>parcelRequire('PDgcp'));

});

parcelRegister("fn1Mq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("enTsL").then(()=>parcelRequire('fsB7i'));

});

parcelRegister("5uKRu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kekup").then(()=>parcelRequire('8iRAs'));

});


parcelRegister("dwK7W", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $1eb81d22ac4a8301$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $1ey7f = parcelRequire("1ey7f");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1eb81d22ac4a8301$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1eb81d22ac4a8301$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("ktjyZ")));
        case 'da':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("aFGny")));
        case 'de':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("68AwK")));
        case 'en-GB':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("5j6ON")));
        case 'en-US':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("4dNR9")));
        case 'en-XA':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("iCIzl")));
        case 'en-XB':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("eott0")));
        case 'en-ZZ':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("lcDFt")));
        case 'en':
            return $1eb81d22ac4a8301$var$importHelper(await Promise.resolve((parcelRequire("1ey7f"))));
        case 'es':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("fRunH")));
        case 'et':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("3BtYM")));
        case 'fi':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("5FlVV")));
        case 'fr':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("bbE3e")));
        case 'hr':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("bKXxS")));
        case 'hu':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("e3Uor")));
        case 'it':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("hRQMC")));
        case 'ja':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("j7Uqi")));
        case 'ko':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("k7z6z")));
        case 'nb':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("4tfX2")));
        case 'nl':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("96mWH")));
        case 'pl':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("49SAH")));
        case 'pt-BR':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("8hBy5")));
        case 'ro':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("inRE9")));
        case 'ru':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("4IJ0a")));
        case 'sl':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("6QUSQ")));
        case 'sr-RS':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("ll2LV")));
        case 'sr-YR':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("hGXaJ")));
        case 'sr':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("gMM4S")));
        case 'sv':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("aeZR4")));
        case 'th':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("12YIr")));
        case 'tr':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("kX9r3")));
        case 'uk':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("dQ69b")));
        case 'vi':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("irpur")));
        case 'zh-CN':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("iMecR")));
        case 'zh-TW':
            return $1eb81d22ac4a8301$var$importHelper(await (parcelRequire("cMpHT")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($1ey7f));
    }
};

});
parcelRegister("1ey7f", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("ktjyZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("etBZS").then(()=>parcelRequire('lQJdg'));

});

parcelRegister("aFGny", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cArBx").then(()=>parcelRequire('4VB12'));

});

parcelRegister("68AwK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lNmLa").then(()=>parcelRequire('7juh5'));

});

parcelRegister("5j6ON", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7sIWI").then(()=>parcelRequire('5WUAn'));

});

parcelRegister("4dNR9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jEgnx").then(()=>parcelRequire('k5AOl'));

});

parcelRegister("iCIzl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kYYcq").then(()=>parcelRequire('cVVWH'));

});

parcelRegister("eott0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3ZyHZ").then(()=>parcelRequire('hjpzo'));

});

parcelRegister("lcDFt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gA3cJ").then(()=>parcelRequire('5tfXX'));

});

parcelRegister("fRunH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2jp7n").then(()=>parcelRequire('h6cpN'));

});

parcelRegister("3BtYM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bZUwr").then(()=>parcelRequire('cM49F'));

});

parcelRegister("5FlVV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("27Pvu").then(()=>parcelRequire('eRIoN'));

});

parcelRegister("bbE3e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ksp3G").then(()=>parcelRequire('QbFsy'));

});

parcelRegister("bKXxS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2e4fM").then(()=>parcelRequire('ainWv'));

});

parcelRegister("e3Uor", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("amXVC").then(()=>parcelRequire('1K9B4'));

});

parcelRegister("hRQMC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2wknl").then(()=>parcelRequire('ehvQ6'));

});

parcelRegister("j7Uqi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6SwG8").then(()=>parcelRequire('dK6BZ'));

});

parcelRegister("k7z6z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("G6tUl").then(()=>parcelRequire('66R31'));

});

parcelRegister("4tfX2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hedhZ").then(()=>parcelRequire('vyZB6'));

});

parcelRegister("96mWH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ReHt").then(()=>parcelRequire('5O93a'));

});

parcelRegister("49SAH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6xZAj").then(()=>parcelRequire('99nv3'));

});

parcelRegister("8hBy5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eeKhV").then(()=>parcelRequire('fsvOM'));

});

parcelRegister("inRE9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7JlcF").then(()=>parcelRequire('feaez'));

});

parcelRegister("4IJ0a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d4fpR").then(()=>parcelRequire('7kAwG'));

});

parcelRegister("6QUSQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bIgd2").then(()=>parcelRequire('eroYZ'));

});

parcelRegister("ll2LV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9dRY7").then(()=>parcelRequire('4U3o9'));

});

parcelRegister("hGXaJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jLVjt").then(()=>parcelRequire('dL0gi'));

});

parcelRegister("gMM4S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cdXMO").then(()=>parcelRequire('7Nsl3'));

});

parcelRegister("aeZR4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("buWU3").then(()=>parcelRequire('9pvx2'));

});

parcelRegister("12YIr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7KMx7").then(()=>parcelRequire('6IjZ5'));

});

parcelRegister("kX9r3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hSpRM").then(()=>parcelRequire('4pxlo'));

});

parcelRegister("dQ69b", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Rw6X").then(()=>parcelRequire('k46Qr'));

});

parcelRegister("irpur", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3UHH0").then(()=>parcelRequire('d0aTg'));

});

parcelRegister("iMecR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cEmX3").then(()=>parcelRequire('id4Dk'));

});

parcelRegister("cMpHT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7r1dn").then(()=>parcelRequire('4JoeL'));

});


parcelRegister("a79Tq", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $3264bf50fa5cef34$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6cnWY = parcelRequire("6cnWY");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3264bf50fa5cef34$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3264bf50fa5cef34$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("9IZ8i")));
        case 'da':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("cN64B")));
        case 'de':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("5yc9b")));
        case 'en-GB':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("ajGo0")));
        case 'en-US':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("bYZzD")));
        case 'en-XA':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("4Oprd")));
        case 'en-XB':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("kVVe7")));
        case 'en-ZZ':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("4TE8D")));
        case 'en':
            return $3264bf50fa5cef34$var$importHelper(await Promise.resolve((parcelRequire("6cnWY"))));
        case 'es':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("5cPBQ")));
        case 'et':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("g2cqH")));
        case 'fi':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("cwuW2")));
        case 'fr':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("bqoJ8")));
        case 'hr':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("bXYOL")));
        case 'hu':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("dtyY8")));
        case 'it':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("jnun4")));
        case 'ja':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("75ioS")));
        case 'ko':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("ddmwH")));
        case 'nb':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("4g0EH")));
        case 'nl':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("2Oa9G")));
        case 'pl':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("4yyPH")));
        case 'pt-BR':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("46Xn0")));
        case 'ro':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("4VEiS")));
        case 'ru':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("goMGi")));
        case 'sl':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("2bOnl")));
        case 'sr-RS':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("9kD2Q")));
        case 'sr-YR':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("lyoq2")));
        case 'sr':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("hQ8z5")));
        case 'sv':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("cthFi")));
        case 'th':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("g21Rl")));
        case 'tr':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("aYxxs")));
        case 'uk':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("cDjLF")));
        case 'vi':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("1GiNM")));
        case 'zh-CN':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("a3Vl0")));
        case 'zh-TW':
            return $3264bf50fa5cef34$var$importHelper(await (parcelRequire("dR5AO")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6cnWY));
    }
};

});
parcelRegister("6cnWY", function(module, exports) {
module.exports = JSON.parse("{\"got-it\":[{\"type\":0,\"value\":\"Got it\"}],\"mercury.mercury-monthly-digest.email.arrow-icon.alt\":[{\"type\":0,\"value\":\"arrow-icon\"}],\"mercury.mercury-monthly-digest.email.arrow-right-icon.alt\":[{\"type\":0,\"value\":\"arrow-right-icon\"}],\"mercury.mercury-monthly-digest.email.calendar-icon.alt\":[{\"type\":0,\"value\":\"calendar-icon\"}],\"mercury.mercury-monthly-digest.email.catch.up.link\":[{\"type\":0,\"value\":\"Jump into Atlassian Focus\"}],\"mercury.mercury-monthly-digest.email.catch.up.text\":[{\"type\":0,\"value\":\"Want to catch up on previous updates? \"},{\"type\":1,\"value\":\"link\"}],\"mercury.mercury-monthly-digest.email.date-changed\":[{\"type\":0,\"value\":\"Date Changed\"}],\"mercury.mercury-monthly-digest.email.focus-area-icon.alt\":[{\"type\":0,\"value\":\"Focus area icon\"}],\"mercury.mercury-monthly-digest.email.footer.atlassian-logo.alt\":[{\"type\":0,\"value\":\"Atlassian footer\"}],\"mercury.mercury-monthly-digest.email.footer.sent-by\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Focus\"}],\"mercury.mercury-monthly-digest.email.footer.unsubscribe\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"mercury.mercury-monthly-digest.email.for\":[{\"type\":0,\"value\":\"for\"}],\"mercury.mercury-monthly-digest.email.header.logoAltText\":[{\"type\":0,\"value\":\"Focus Logo\"}],\"mercury.mercury-monthly-digest.email.no-target-date.alt\":[{\"type\":0,\"value\":\"No target date set\"}],\"mercury.mercury-monthly-digest.email.status-changed\":[{\"type\":0,\"value\":\"Status changed\"}],\"mercury.mercury-monthly-digest.email.total-following.sub-header\":[{\"type\":0,\"value\":\"You're following \"},{\"type\":1,\"value\":\"total\"},{\"type\":0,\"value\":\" active focus areas, here's the breakdown.\"}],\"mercury.mercury-monthly-digest.email.view-update\":[{\"type\":0,\"value\":\"View Update\"}],\"mercury.mercury-monthly-digest.message-template.email.subject.no-translate\":[{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\", here are your monthly focus area updates\"}],\"mercury.mercury-re-engage-whats-new.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"mercury.mercury-re-engage-whats-new.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"mercury.mercury-re-engage-whats-new.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"mercury.mercury-re-engage-whats-new.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"mercury.mercury-re-engage-whats-new.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"mercury.mercury-re-engage-whats-new.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"mercury.mercury-re-engage-whats-new.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-body\":[{\"type\":0,\"value\":\"Whenever you need to make changes to your hierarchy you can do so from settings.\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading\":[{\"type\":0,\"value\":\"Edit your focus area hierarchy\"}]}");

});

parcelRegister("9IZ8i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ouaE").then(()=>parcelRequire('botwY'));

});

parcelRegister("cN64B", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("83J76").then(()=>parcelRequire('cB3cF'));

});

parcelRegister("5yc9b", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3NbBf").then(()=>parcelRequire('fszVV'));

});

parcelRegister("ajGo0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3NTQl").then(()=>parcelRequire('1fbyN'));

});

parcelRegister("bYZzD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1z9sG").then(()=>parcelRequire('03QGa'));

});

parcelRegister("4Oprd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ggBc0").then(()=>parcelRequire('7Oog3'));

});

parcelRegister("kVVe7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8DRnL").then(()=>parcelRequire('9uVYs'));

});

parcelRegister("4TE8D", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1E1FB").then(()=>parcelRequire('lghrN'));

});

parcelRegister("5cPBQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ISrPM").then(()=>parcelRequire('eB9ra'));

});

parcelRegister("g2cqH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b6SmL").then(()=>parcelRequire('3D5ta'));

});

parcelRegister("cwuW2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fbG7w").then(()=>parcelRequire('7WYjZ'));

});

parcelRegister("bqoJ8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("YreR5").then(()=>parcelRequire('20BFG'));

});

parcelRegister("bXYOL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4fcc8").then(()=>parcelRequire('ksEoD'));

});

parcelRegister("dtyY8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lwo4R").then(()=>parcelRequire('frHkf'));

});

parcelRegister("jnun4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2KubE").then(()=>parcelRequire('7yEMV'));

});

parcelRegister("75ioS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jdltr").then(()=>parcelRequire('651Nn'));

});

parcelRegister("ddmwH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eD7wS").then(()=>parcelRequire('geTym'));

});

parcelRegister("4g0EH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g1BXj").then(()=>parcelRequire('2JDkO'));

});

parcelRegister("2Oa9G", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hOmwF").then(()=>parcelRequire('dhCNd'));

});

parcelRegister("4yyPH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7yTg7").then(()=>parcelRequire('cnwMf'));

});

parcelRegister("46Xn0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fDqSS").then(()=>parcelRequire('48GVS'));

});

parcelRegister("4VEiS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kCm1W").then(()=>parcelRequire('jXQF4'));

});

parcelRegister("goMGi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kupZc").then(()=>parcelRequire('jARbM'));

});

parcelRegister("2bOnl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kPQdW").then(()=>parcelRequire('80Zl0'));

});

parcelRegister("9kD2Q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6g22N").then(()=>parcelRequire('3Vl5G'));

});

parcelRegister("lyoq2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6KVai").then(()=>parcelRequire('14g7o'));

});

parcelRegister("hQ8z5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("575Ml").then(()=>parcelRequire('69BJF'));

});

parcelRegister("cthFi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kUxEd").then(()=>parcelRequire('7Mhsu'));

});

parcelRegister("g21Rl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("exru3").then(()=>parcelRequire('5kUKd'));

});

parcelRegister("aYxxs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fdNVP").then(()=>parcelRequire('4Ktr0'));

});

parcelRegister("cDjLF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dObh5").then(()=>parcelRequire('ckQNN'));

});

parcelRegister("1GiNM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6nQt1").then(()=>parcelRequire('61Rue'));

});

parcelRegister("a3Vl0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dpvpW").then(()=>parcelRequire('gGqmR'));

});

parcelRegister("dR5AO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dj10i").then(()=>parcelRequire('lRxDt'));

});


parcelRegister("3AZmi", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $8167e1ce0116b9af$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $g479j = parcelRequire("g479j");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8167e1ce0116b9af$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8167e1ce0116b9af$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("sMaYq")));
        case 'da':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("8sQfy")));
        case 'de':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("8jKNZ")));
        case 'en-GB':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("1Q1rH")));
        case 'en-US':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("4Brwh")));
        case 'en-XA':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("53Ost")));
        case 'en-XB':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("Dzkrq")));
        case 'en-ZZ':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("2ATpQ")));
        case 'en':
            return $8167e1ce0116b9af$var$importHelper(await Promise.resolve((parcelRequire("g479j"))));
        case 'es':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("3KldU")));
        case 'et':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("lFlV8")));
        case 'fi':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("6BwAX")));
        case 'fr':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("3aKOK")));
        case 'hr':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("5zb6Y")));
        case 'hu':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("hNB9Q")));
        case 'it':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("2TeQs")));
        case 'ja':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("f2zUk")));
        case 'ko':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("2lWkV")));
        case 'nb':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("gSvBZ")));
        case 'nl':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("lzXv4")));
        case 'pl':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("6K7NN")));
        case 'pt-BR':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("l4eDj")));
        case 'ro':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("jHQNf")));
        case 'ru':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("6q5e0")));
        case 'sl':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("8uXLs")));
        case 'sr-RS':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("4ZPPv")));
        case 'sr-YR':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("9tOqD")));
        case 'sr':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("fUT47")));
        case 'sv':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("7fXqt")));
        case 'th':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("l2KUj")));
        case 'tr':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("9QCvR")));
        case 'uk':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("6jWtT")));
        case 'vi':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("blAxI")));
        case 'zh-CN':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("sO0r9")));
        case 'zh-TW':
            return $8167e1ce0116b9af$var$importHelper(await (parcelRequire("cUGjh")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($g479j));
    }
};

});
parcelRegister("g479j", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("sMaYq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2g3L4").then(()=>parcelRequire('9bohR'));

});

parcelRegister("8sQfy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j3ngh").then(()=>parcelRequire('6slG9'));

});

parcelRegister("8jKNZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aXEiz").then(()=>parcelRequire('lTc1q'));

});

parcelRegister("1Q1rH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("EfZ3g").then(()=>parcelRequire('gEAAx'));

});

parcelRegister("4Brwh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i2b1G").then(()=>parcelRequire('ejvGh'));

});

parcelRegister("53Ost", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aUa2T").then(()=>parcelRequire('bLwva'));

});

parcelRegister("Dzkrq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j1MU5").then(()=>parcelRequire('fPGDa'));

});

parcelRegister("2ATpQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2GLNf").then(()=>parcelRequire('kGNsE'));

});

parcelRegister("3KldU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e3Fxr").then(()=>parcelRequire('cBA8g'));

});

parcelRegister("lFlV8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1cD3m").then(()=>parcelRequire('aj5bY'));

});

parcelRegister("6BwAX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2g0gm").then(()=>parcelRequire('lEMxW'));

});

parcelRegister("3aKOK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("65TEe").then(()=>parcelRequire('j92vM'));

});

parcelRegister("5zb6Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("40Okw").then(()=>parcelRequire('8L5CM'));

});

parcelRegister("hNB9Q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9wQ2u").then(()=>parcelRequire('fbWwy'));

});

parcelRegister("2TeQs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2j8yE").then(()=>parcelRequire('lRjbR'));

});

parcelRegister("f2zUk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6NA23").then(()=>parcelRequire('fL2q9'));

});

parcelRegister("2lWkV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8tsF3").then(()=>parcelRequire('goDSp'));

});

parcelRegister("gSvBZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k25cY").then(()=>parcelRequire('jzYEO'));

});

parcelRegister("lzXv4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dzydr").then(()=>parcelRequire('5NWfS'));

});

parcelRegister("6K7NN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aLjnL").then(()=>parcelRequire('7a2zQ'));

});

parcelRegister("l4eDj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ZBxE").then(()=>parcelRequire('eomuN'));

});

parcelRegister("jHQNf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b8kSs").then(()=>parcelRequire('avwIL'));

});

parcelRegister("6q5e0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iTZbT").then(()=>parcelRequire('3eMO2'));

});

parcelRegister("8uXLs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jFTIS").then(()=>parcelRequire('4GOAp'));

});

parcelRegister("4ZPPv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l0aSm").then(()=>parcelRequire('7tb5a'));

});

parcelRegister("9tOqD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hPxS2").then(()=>parcelRequire('atxbj'));

});

parcelRegister("fUT47", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cT1O2").then(()=>parcelRequire('kI3My'));

});

parcelRegister("7fXqt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dSH7z").then(()=>parcelRequire('gJdSk'));

});

parcelRegister("l2KUj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8w7dN").then(()=>parcelRequire('aidKx'));

});

parcelRegister("9QCvR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2Sjiq").then(()=>parcelRequire('7Mf2V'));

});

parcelRegister("6jWtT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g9kUC").then(()=>parcelRequire('lKLIR'));

});

parcelRegister("blAxI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("21L66").then(()=>parcelRequire('hoJj6'));

});

parcelRegister("sO0r9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aRM0u").then(()=>parcelRequire('bfHRy'));

});

parcelRegister("cUGjh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9X3mK").then(()=>parcelRequire('4EO7y'));

});


parcelRegister("g4GMj", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $44545757adaf92fa$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8WE3N = parcelRequire("8WE3N");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $44545757adaf92fa$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $44545757adaf92fa$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("adNNs")));
        case 'da':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("bA3ze")));
        case 'de':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("iEoqV")));
        case 'en-GB':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("7dF5G")));
        case 'en-US':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("4f4la")));
        case 'en-XA':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("4II4i")));
        case 'en-XB':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("6OHlM")));
        case 'en-ZZ':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("9qTaL")));
        case 'en':
            return $44545757adaf92fa$var$importHelper(await Promise.resolve((parcelRequire("8WE3N"))));
        case 'es':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("dIZT4")));
        case 'et':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("aLlXM")));
        case 'fi':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("dEsWh")));
        case 'fr':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("77I42")));
        case 'hr':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("4EjRg")));
        case 'hu':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("g2VcV")));
        case 'it':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("izMwp")));
        case 'ja':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("e5L6G")));
        case 'ko':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("rJyRS")));
        case 'nb':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("fCB6t")));
        case 'nl':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("aRLie")));
        case 'pl':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("9i0W1")));
        case 'pt-BR':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("1zDUT")));
        case 'ro':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("6mWku")));
        case 'ru':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("7A6k7")));
        case 'sl':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("iQOiG")));
        case 'sr-RS':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("eN1pt")));
        case 'sr-YR':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("1pdTI")));
        case 'sr':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("i6DcX")));
        case 'sv':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("476QM")));
        case 'th':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("7UAGR")));
        case 'tr':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("etIdr")));
        case 'uk':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("k0x7U")));
        case 'vi':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("jUbc0")));
        case 'zh-CN':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("dAqWO")));
        case 'zh-TW':
            return $44545757adaf92fa$var$importHelper(await (parcelRequire("2opPj")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8WE3N));
    }
};

});
parcelRegister("8WE3N", function(module, exports) {
module.exports = JSON.parse('{"Check out the support documentation for more details.":[{"type":0,"value":"Check out the support documentation for more details."}],"Dismiss":[{"type":0,"value":"Dismiss"}],"Looking to enhance the agent experience?":[{"type":0,"value":"Looking to enhance the agent experience?"}],"Not now":[{"type":0,"value":"Not now"}],"Show me":[{"type":0,"value":"Show me"}],"Show me the apps":[{"type":0,"value":"Show me the apps"}],"Upgrade options":[{"type":0,"value":"Upgrade options"}],"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!":[{"type":0,"value":"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!"}],"We\'ve made some changes to imports":[{"type":0,"value":"We\'ve made some changes to imports"}],"We\u2019re having trouble with your plan":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"We\u2019ve kept you on the Standard plan of Confluence for now.":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users.":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"feedback-collector.can-be-enrolled-label.text":[{"type":0,"value":"Atlassian can contact me about this feedback. See our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"feedback-collector.enroll-in-research-label.text":[{"type":0,"value":"I\'d like to help improve Atlassian products by joining the"},{"type":1,"value":"nbsp"},{"type":1,"value":"n"},{"type":1,"value":"t"},{"type":1,"value":"t"},{"children":[{"type":0,"value":"Atlassian Research Group"}],"type":8,"value":"enrollLink"}],"feedback-collector.feedback-title-details.component":[{"type":0,"value":"For help with billing or other issues, visit our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"documentation"}],"type":8,"value":"documentationLink"},{"type":1,"value":"nbsp"},{"type":0,"value":"or contact"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"support"}],"type":8,"value":"supportLink"}],"no-notifications-fallback.learn-more-link.text":[{"type":0,"value":"Learn more about this feature"}],"no-notifications-fallback.no-notifications.text":[{"type":0,"value":"Check back soon. No notifications yet."}],"notifications.error-fallback-error-reason.text":[{"type":0,"value":"We\'re unable to load notifications"}],"notifications.error-fallback-proposed-solution.text":[{"type":0,"value":"Refresh the page or try again later"}],"post-office-team.confluence-recommended-following-feed.add-comment-button":[{"type":0,"value":"Comment"}],"post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text":[{"type":0,"value":"Add Emoji"}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer":[{"type":0,"value":"Uses AI. Verify results."}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer-alt-text":[{"type":0,"value":"Information icon"}],"post-office-team.confluence-recommended-following-feed.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office-team.confluence-recommended-following-feed.blog-icon":[{"type":0,"value":"Blog icon"}],"post-office-team.confluence-recommended-following-feed.clap-button-alt-text":[{"type":0,"value":"Clap"}],"post-office-team.confluence-recommended-following-feed.database-icon":[{"type":0,"value":"Database icon"}],"post-office-team.confluence-recommended-following-feed.email-unsubscribe-text":[{"children":[{"type":0,"value":"Update your email settings"}],"type":8,"value":"trackedLink"},{"type":0,"value":" to customize or stop receiving this email."}],"post-office-team.confluence-recommended-following-feed.email.body.hello":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.confluence-recommended-following-feed.email.body.summary":[{"type":0,"value":"Here are pages your team is reading, don\'t miss out on the conversation."}],"post-office-team.confluence-recommended-following-feed.email.ios-android-text":[{"type":0,"value":"Download the Confluence mobile app on "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"iosLink"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"androidLink"},{"type":0,"value":" to read notifications and comment on the go."}],"post-office-team.confluence-recommended-following-feed.email.privacy-policy-text":[{"type":0,"value":"This email was sent by Atlassian Confluence  \u2022  "},{"children":[{"type":0,"value":"Privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"post-office-team.confluence-recommended-following-feed.email.subject":[{"type":1,"value":"name"},{"type":0,"value":", your team is working on these pages -- join the conversation"}],"post-office-team.confluence-recommended-following-feed.email.subject.variant-a":[{"type":1,"value":"name"},{"type":0,"value":", "},{"type":1,"value":"pageTitle"},{"type":0,"value":" plus more pages your team is working on"}],"post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text":[{"type":0,"value":"Confluence Icon"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted":[{"children":[{"type":1,"value":"firstUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"secondUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.no-comments":[{"type":0,"value":"Be the first to comment"}],"post-office-team.confluence-recommended-following-feed.no-reactions-text":[{"type":0,"value":"Be the first to react"}],"post-office-team.confluence-recommended-following-feed.number-of-comments":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comment"}]},"other":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comments"}]}},"pluralType":"cardinal","type":6,"value":"commentCount"}],"post-office-team.confluence-recommended-following-feed.number-of-users-reacted":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"reactionCount"}],"post-office-team.confluence-recommended-following-feed.owned-by":[{"type":0,"value":"Owned by "},{"type":1,"value":"ownerName"}],"post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text":[{"type":0,"value":"Party Popper"}],"post-office-team.confluence-recommended-following-feed.read-more-link":[{"type":0,"value":"Read more"}],"post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text":[{"type":0,"value":"Thumbs up"}],"post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text":[{"type":1,"value":"name"},{"type":0,"value":"\'s profile picture"}],"post-office-team.confluence-recommended-following-feed.whiteboard-icon":[{"type":0,"value":"Whiteboard icon"}],"post-office-team.email-with-tracking-links.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.email-with-tracking-links.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.email-with-tracking-links.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.email-with-tracking-links.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.email-with-tracking-links.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.email-with-tracking-links.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.email-with-tracking-links.test-message.email.confluence-link.text.no-translate":[{"type":0,"value":"Go to Confluence link"}],"post-office-team.email-with-tracking-links.test-message.email.jira-link.text.no-translate":[{"type":0,"value":"Go to Jira link"}],"post-office-team.email-with-tracking-links.test-message.email.trello-link.text.no-translate":[{"type":0,"value":"Go to Trello board"}],"post-office-team.push-msg-object-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.push-msg-object-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.push-msg-object-tracking.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office-team.push-msg-object-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.push-msg-object-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.push-msg-object-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.push-msg-object-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.push-msg-object-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.admin-hub.end-of-notifications.description":[{"type":0,"value":"That\'s all your notifications from the last 90 days"}],"post-office.post-office-team-components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.post-office-team-components.email.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email":[{"type":0,"value":"You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link":[{"type":0,"value":"Get started"}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Help us improve messaging for Atlassian Admins! Answer a few short questions, and our\\n\\t\\t\\t\\t\\tResearch team will contact you for a 60-minute Zoom session if you qualify."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Share your experience for $120 USD"}],"post-office.post-office-team.push-msg-object-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.post-office-team.push-msg-object-tracking.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.triggered-ipms.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.triggered-ipms.spotlight-body":[{"type":0,"value":"This is an example you can use to scaffold your own Spotlight experiences."}],"post-office.triggered-ipms.spotlight-body-1":[{"type":0,"value":"This is an example you can use to scaffold your own Spotlight Tour experiences."}],"post-office.triggered-ipms.spotlight-body-2":[{"type":0,"value":"You can transition between steps with the back, next action handlers."}],"post-office.triggered-ipms.spotlight-body-3":[{"type":0,"value":"And complete, or opt out of the tour with the done, and dismiss props."}],"post-office.triggered-ipms.spotlight-button-back":[{"type":0,"value":"Back"}],"post-office.triggered-ipms.spotlight-button-done":[{"type":0,"value":"Done"}],"post-office.triggered-ipms.spotlight-button-next":[{"type":0,"value":"Next"}],"post-office.triggered-ipms.spotlight-heading":[{"type":0,"value":"Spotlight Tour Example"}]}');

});

parcelRegister("adNNs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8Ce4d").then(()=>parcelRequire('33FPc'));

});

parcelRegister("bA3ze", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lvMC0").then(()=>parcelRequire('iTHKU'));

});

parcelRegister("iEoqV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("92Dsi").then(()=>parcelRequire('B9xUt'));

});

parcelRegister("7dF5G", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kEd6d").then(()=>parcelRequire('efnEv'));

});

parcelRegister("4f4la", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d1Sbh").then(()=>parcelRequire('4Miat'));

});

parcelRegister("4II4i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2uPxx").then(()=>parcelRequire('V4ByJ'));

});

parcelRegister("6OHlM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8SIRU").then(()=>parcelRequire('icwl2'));

});

parcelRegister("9qTaL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aQybG").then(()=>parcelRequire('jOTEC'));

});

parcelRegister("dIZT4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("76bLe").then(()=>parcelRequire('iAFXp'));

});

parcelRegister("aLlXM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("45WLE").then(()=>parcelRequire('O74aM'));

});

parcelRegister("dEsWh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eXs8q").then(()=>parcelRequire('3im4v'));

});

parcelRegister("77I42", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("85Y84").then(()=>parcelRequire('lKrWz'));

});

parcelRegister("4EjRg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kr4ZO").then(()=>parcelRequire('7WCvD'));

});

parcelRegister("g2VcV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ggICi").then(()=>parcelRequire('a1wXB'));

});

parcelRegister("izMwp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iJJiN").then(()=>parcelRequire('h0Z52'));

});

parcelRegister("e5L6G", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9puKt").then(()=>parcelRequire('7UFNY'));

});

parcelRegister("rJyRS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3B8DW").then(()=>parcelRequire('19LO5'));

});

parcelRegister("fCB6t", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g8pnw").then(()=>parcelRequire('kYNdf'));

});

parcelRegister("aRLie", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3pgaY").then(()=>parcelRequire('cTXkz'));

});

parcelRegister("9i0W1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jP88y").then(()=>parcelRequire('kE8uV'));

});

parcelRegister("1zDUT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lzR49").then(()=>parcelRequire('2JlxN'));

});

parcelRegister("6mWku", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lLMmr").then(()=>parcelRequire('1fqqM'));

});

parcelRegister("7A6k7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6l3oD").then(()=>parcelRequire('7Ig1b'));

});

parcelRegister("iQOiG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hK4oO").then(()=>parcelRequire('lNMcW'));

});

parcelRegister("eN1pt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bSvNH").then(()=>parcelRequire('l70w0'));

});

parcelRegister("1pdTI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9HC2K").then(()=>parcelRequire('eU9tO'));

});

parcelRegister("i6DcX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1EhMp").then(()=>parcelRequire('2BQV1'));

});

parcelRegister("476QM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("faSqj").then(()=>parcelRequire('fP80T'));

});

parcelRegister("7UAGR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8wBwB").then(()=>parcelRequire('6x8VJ'));

});

parcelRegister("etIdr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jI5iE").then(()=>parcelRequire('dflNM'));

});

parcelRegister("k0x7U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("efK6k").then(()=>parcelRequire('dSiHJ'));

});

parcelRegister("jUbc0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aJtgP").then(()=>parcelRequire('eXzTm'));

});

parcelRegister("dAqWO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gQCI6").then(()=>parcelRequire('jeltG'));

});

parcelRegister("2opPj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bg3Ff").then(()=>parcelRequire('aBo2F'));

});


parcelRegister("eecBW", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $3e0fecae488451ce$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $1WYWi = parcelRequire("1WYWi");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e0fecae488451ce$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3e0fecae488451ce$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("hXnrR")));
        case 'da':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("44yyn")));
        case 'de':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("1MtVt")));
        case 'en-GB':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("3vYYj")));
        case 'en-US':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("jUvNO")));
        case 'en-XA':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("alU2T")));
        case 'en-XB':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("hCdq7")));
        case 'en-ZZ':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("7CbfX")));
        case 'en':
            return $3e0fecae488451ce$var$importHelper(await Promise.resolve((parcelRequire("1WYWi"))));
        case 'es':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("kMeBE")));
        case 'et':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("4dcJn")));
        case 'fi':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("SwnfS")));
        case 'fr':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("kWF28")));
        case 'hr':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("fVxcz")));
        case 'hu':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("2oueq")));
        case 'it':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("ceuF9")));
        case 'ja':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("6BJ6A")));
        case 'ko':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("2rYvD")));
        case 'nb':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("a2gaw")));
        case 'nl':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("3TqiI")));
        case 'pl':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("foFOE")));
        case 'pt-BR':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("4SHEQ")));
        case 'ro':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("cFXQ3")));
        case 'ru':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("h0fpT")));
        case 'sl':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("8LIjb")));
        case 'sr-RS':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("hH2FO")));
        case 'sr-YR':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("kF4PF")));
        case 'sr':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("1h79g")));
        case 'sv':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("fkf2e")));
        case 'th':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("1BoLN")));
        case 'tr':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("9tojH")));
        case 'uk':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("7dc6b")));
        case 'vi':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("dZqJS")));
        case 'zh-CN':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("k5mmB")));
        case 'zh-TW':
            return $3e0fecae488451ce$var$importHelper(await (parcelRequire("dUysm")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($1WYWi));
    }
};

});
parcelRegister("1WYWi", function(module, exports) {
module.exports = JSON.parse("{\"rovo-agents.scenario-onboarding.backButton\":[{\"type\":0,\"value\":\"Back\"}],\"rovo-agents.scenario-onboarding.doneButton\":[{\"type\":0,\"value\":\"Done\"}],\"rovo-agents.scenario-onboarding.nextButton\":[{\"type\":0,\"value\":\"Next\"}],\"rovo-agents.scenario-onboarding.step1Body\":[{\"type\":0,\"value\":\"Scenarios allow you to instruct your agent to do things differently depending on the situation.\"}],\"rovo-agents.scenario-onboarding.step1Headline\":[{\"type\":0,\"value\":\"Tune your agent to each situation\"}],\"rovo-agents.scenario-onboarding.step2Body\":[{\"type\":0,\"value\":\"Unlike scenarios, behavior is the instructions your agent always follows, no matter the situation.\"}],\"rovo-agents.scenario-onboarding.step2Headline\":[{\"type\":0,\"value\":\"Set your agent's traits and goals\"}],\"rovo-agents.scenario-onboarding.step3Body\":[{\"type\":0,\"value\":\"You can add knowledge to your agent's scenarios so it has the right information to answer prompts in each situation.\"}],\"rovo-agents.scenario-onboarding.step3Headline\":[{\"type\":0,\"value\":\"See what your agent knows\"}],\"rovo-agents.scenario-onboarding.step4Body\":[{\"type\":0,\"value\":\"You can add skills to your agent's scenarios so it can connect and take action across apps.\"}],\"rovo-agents.scenario-onboarding.step4Headline\":[{\"type\":0,\"value\":\"See what your agent can do\"}],\"rovo-agents.scenario-onboarding.stepIndicator\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");

});

parcelRegister("hXnrR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jljps").then(()=>parcelRequire('5SBKc'));

});

parcelRegister("44yyn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("tksIc").then(()=>parcelRequire('7Jiwh'));

});

parcelRegister("1MtVt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ldJe0").then(()=>parcelRequire('dZ5ft'));

});

parcelRegister("3vYYj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("atleV").then(()=>parcelRequire('kuN8H'));

});

parcelRegister("jUvNO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bLl7w").then(()=>parcelRequire('lAHi1'));

});

parcelRegister("alU2T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Jr6Pb").then(()=>parcelRequire('eyIad'));

});

parcelRegister("hCdq7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("liLWD").then(()=>parcelRequire('dIoGB'));

});

parcelRegister("7CbfX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hNzr3").then(()=>parcelRequire('jmnEC'));

});

parcelRegister("kMeBE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b2H1n").then(()=>parcelRequire('jcNrb'));

});

parcelRegister("4dcJn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1MLi2").then(()=>parcelRequire('bzIDF'));

});

parcelRegister("SwnfS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cugXI").then(()=>parcelRequire('hFglO'));

});

parcelRegister("kWF28", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8Ne4A").then(()=>parcelRequire('bam0c'));

});

parcelRegister("fVxcz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("95SvH").then(()=>parcelRequire('cakt5'));

});

parcelRegister("2oueq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6VRn8").then(()=>parcelRequire('bJj5X'));

});

parcelRegister("ceuF9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7vVGq").then(()=>parcelRequire('kpMZW'));

});

parcelRegister("6BJ6A", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("X296d").then(()=>parcelRequire('fKjm4'));

});

parcelRegister("2rYvD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e8nkI").then(()=>parcelRequire('7hzaq'));

});

parcelRegister("a2gaw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j7BLQ").then(()=>parcelRequire('aP1uq'));

});

parcelRegister("3TqiI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("inRhy").then(()=>parcelRequire('7XODf'));

});

parcelRegister("foFOE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jKRQn").then(()=>parcelRequire('lULvF'));

});

parcelRegister("4SHEQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9C3Le").then(()=>parcelRequire('hl6ow'));

});

parcelRegister("cFXQ3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Va3Y").then(()=>parcelRequire('4UqFQ'));

});

parcelRegister("h0fpT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1kFiT").then(()=>parcelRequire('dZ1X7'));

});

parcelRegister("8LIjb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cvRSN").then(()=>parcelRequire('gqA4D'));

});

parcelRegister("hH2FO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f5EyQ").then(()=>parcelRequire('linO4'));

});

parcelRegister("kF4PF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fbCuk").then(()=>parcelRequire('5DizY'));

});

parcelRegister("1h79g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6od1x").then(()=>parcelRequire('dSM9b'));

});

parcelRegister("fkf2e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6hula").then(()=>parcelRequire('5lVtr'));

});

parcelRegister("1BoLN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f3oeA").then(()=>parcelRequire('6ZQ6l'));

});

parcelRegister("9tojH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("67AMp").then(()=>parcelRequire('f59Fu'));

});

parcelRegister("7dc6b", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ixdMf").then(()=>parcelRequire('5pT6s'));

});

parcelRegister("dZqJS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5pnOk").then(()=>parcelRequire('irqA2'));

});

parcelRegister("k5mmB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("28xgG").then(()=>parcelRequire('1UYns'));

});

parcelRegister("dUysm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lJcFT").then(()=>parcelRequire('eKJpt'));

});


parcelRegister("7xVLr", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $71df752dbb4f6edd$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fgcX2 = parcelRequire("fgcX2");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $71df752dbb4f6edd$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $71df752dbb4f6edd$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("ghqKa")));
        case 'da':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("egJ7F")));
        case 'de':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("8OU2X")));
        case 'en-GB':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("5n7eN")));
        case 'en-US':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("eYFM9")));
        case 'en-XA':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("jVoBF")));
        case 'en-XB':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("hJgDC")));
        case 'en-ZZ':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("bzjIw")));
        case 'en':
            return $71df752dbb4f6edd$var$importHelper(await Promise.resolve((parcelRequire("fgcX2"))));
        case 'es':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("6Mov3")));
        case 'et':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("3OEeM")));
        case 'fi':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("b80WH")));
        case 'fr':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("1qhDv")));
        case 'hr':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("lVVFp")));
        case 'hu':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("1SM0t")));
        case 'it':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("jB1dB")));
        case 'ja':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("47XD0")));
        case 'ko':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("lI0x7")));
        case 'nb':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("lOZsC")));
        case 'nl':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("ahCeV")));
        case 'pl':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("1UaJw")));
        case 'pt-BR':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("p03sR")));
        case 'ro':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("04oBw")));
        case 'ru':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("3Tuon")));
        case 'sl':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("iwM4M")));
        case 'sr-RS':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("88Q2D")));
        case 'sr-YR':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("jClO6")));
        case 'sr':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("9rEtY")));
        case 'sv':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("8P4gS")));
        case 'th':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("faBHf")));
        case 'tr':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("2emDk")));
        case 'uk':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("2mDgW")));
        case 'vi':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("dgMWh")));
        case 'zh-CN':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("3m25u")));
        case 'zh-TW':
            return $71df752dbb4f6edd$var$importHelper(await (parcelRequire("7TEx8")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fgcX2));
    }
};

});
parcelRegister("fgcX2", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message-digest-local-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-local-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message-microsoft-teams.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, this is test message from Post Office: \"},{\"type\":1,\"value\":\"text\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-lifecycle.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted test mobile push notification from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-no-tracking.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-messages.test-message-slack-experiment-exposure.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.app-switcher-upgrade-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-upgrade-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.in-app-notification.body\":[{\"type\":1,\"value\":\"body\"}],\"test-messages.in-app-notification.title\":[{\"type\":0,\"value\":\"Test Notification \"},{\"type\":1,\"value\":\"title\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Redacted Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-content-diffing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-content-diffing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-local.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-local.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-local.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-local.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate\":[{\"type\":0,\"value\":\"Click me!\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate\":[{\"type\":0,\"value\":\"This is a redacted test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-in-app-notification.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-in-app-notification.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office test-message-in-app-notification \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-in-app-notification.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-in-app-notification.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-in-app-notification.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-in-app-notification.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-in-app-notification.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-lifecycle.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-lifecycle.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-lifecycle.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-lifecycle.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-lifecycle.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-lifecycle.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-lifecycle.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-message-failures.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-message-failures.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-no-tracking.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-no-tracking.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-no-tracking.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-no-tracking.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-no-tracking.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-no-tracking.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-no-tracking.test-message.email.body.tracked-link.no-translate\":[{\"type\":0,\"value\":\"This is a TrackedLink that isn't being tracked!\"}],\"test-messages.test-message-no-tracking.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate\":[{\"type\":1,\"value\":\"greeting\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("ghqKa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jH76t").then(()=>parcelRequire('fgFft'));

});

parcelRegister("egJ7F", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("72a6H").then(()=>parcelRequire('iqyEd'));

});

parcelRegister("8OU2X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("99t4P").then(()=>parcelRequire('aCDtt'));

});

parcelRegister("5n7eN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dMzCd").then(()=>parcelRequire('2DHRc'));

});

parcelRegister("eYFM9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jxBJT").then(()=>parcelRequire('dS4IL'));

});

parcelRegister("jVoBF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("doXbd").then(()=>parcelRequire('2AHjI'));

});

parcelRegister("hJgDC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1fbWC").then(()=>parcelRequire('415rW'));

});

parcelRegister("bzjIw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ODhIj").then(()=>parcelRequire('2FSSM'));

});

parcelRegister("6Mov3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6GiE8").then(()=>parcelRequire('78iVy'));

});

parcelRegister("3OEeM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bf0qg").then(()=>parcelRequire('67qr8'));

});

parcelRegister("b80WH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7CyTh").then(()=>parcelRequire('8COMr'));

});

parcelRegister("1qhDv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("di3cH").then(()=>parcelRequire('dKIsW'));

});

parcelRegister("lVVFp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bgiDE").then(()=>parcelRequire('hKJ7s'));

});

parcelRegister("1SM0t", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j9dKi").then(()=>parcelRequire('ktoAT'));

});

parcelRegister("jB1dB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7lKMr").then(()=>parcelRequire('eMenI'));

});

parcelRegister("47XD0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2J0po").then(()=>parcelRequire('hn7zF'));

});

parcelRegister("lI0x7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hpPVz").then(()=>parcelRequire('ie3pE'));

});

parcelRegister("lOZsC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a9HJF").then(()=>parcelRequire('1hmpK'));

});

parcelRegister("ahCeV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("16ooX").then(()=>parcelRequire('ltiRk'));

});

parcelRegister("1UaJw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eRZGo").then(()=>parcelRequire('9wf6u'));

});

parcelRegister("p03sR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4vmXG").then(()=>parcelRequire('iidJo'));

});

parcelRegister("04oBw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4sjt4").then(()=>parcelRequire('gM6Za'));

});

parcelRegister("3Tuon", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2WgyB").then(()=>parcelRequire('4gQw3'));

});

parcelRegister("iwM4M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("15tjc").then(()=>parcelRequire('cXUQZ'));

});

parcelRegister("88Q2D", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5zIaj").then(()=>parcelRequire('bqZwE'));

});

parcelRegister("jClO6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6S8Ci").then(()=>parcelRequire('alTkB'));

});

parcelRegister("9rEtY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("196Yj").then(()=>parcelRequire('2NH74'));

});

parcelRegister("8P4gS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dJT4h").then(()=>parcelRequire('e6FFe'));

});

parcelRegister("faBHf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("koyet").then(()=>parcelRequire('2p63w'));

});

parcelRegister("2emDk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lP4yo").then(()=>parcelRequire('fC4Gj'));

});

parcelRegister("2mDgW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l4Sv7").then(()=>parcelRequire('gYTdV'));

});

parcelRegister("dgMWh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fdpGn").then(()=>parcelRequire('cUYyM'));

});

parcelRegister("3m25u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("euz2R").then(()=>parcelRequire('4AnDw'));

});

parcelRegister("7TEx8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8qZuf").then(()=>parcelRequire('eNfxD'));

});




parcelRegister("jR9w7", function(module, exports) {
$parcel$export(module.exports, "ScreenSpaceFlagPlacementPreviewSwitcher", () => $b74d0681bd43287b$export$46db7cd62b063064);

var $gt9Am = parcelRequire("gt9Am");

var $lwEYg = parcelRequire("lwEYg");

var $7hFNz = parcelRequire("7hFNz");

var $lphSw = parcelRequire("lphSw");

var $5VXEW = parcelRequire("5VXEW");

var $lauxv = parcelRequire("lauxv");
const $b74d0681bd43287b$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5VXEW.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7hFNz.PlacementPreviewProvider), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lauxv.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $b74d0681bd43287b$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $lwEYg.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $gt9Am.jsx)($b74d0681bd43287b$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $lphSw.ScreenSpaceFlagsPlacementComponent),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});
parcelRegister("7hFNz", function(module, exports) {
$parcel$export(module.exports, "PlacementPreviewProvider", () => $ab3595c8827108b9$export$52e362b70e115c68);

var $04lXk = parcelRequire("04lXk");
const $ab3595c8827108b9$export$52e362b70e115c68 = (0, $04lXk.PlacementPreviewProvider);
const $ab3595c8827108b9$export$c05392ff95b4319d = (0, $04lXk.createPreviewFetch);

});
parcelRegister("04lXk", function(module, exports) {
$parcel$export(module.exports, "PlacementPreviewProvider", () => $d6f06cc7587ce16e$export$52e362b70e115c68);
$parcel$export(module.exports, "createPreviewFetch", () => $d6f06cc7587ce16e$export$c05392ff95b4319d);

var $eJOHy = parcelRequire("eJOHy");

var $kokXW = parcelRequire("kokXW");
const $d6f06cc7587ce16e$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $d6f06cc7587ce16e$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $d6f06cc7587ce16e$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $eJOHy.useMemo)(()=>{
        if (returnOverride) return $d6f06cc7587ce16e$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $d6f06cc7587ce16e$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kokXW.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
const $d6f06cc7587ce16e$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $d6f06cc7587ce16e$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($d6f06cc7587ce16e$export$e5ffd38dcf6e5c53, $d6f06cc7587ce16e$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $d6f06cc7587ce16e$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $d6f06cc7587ce16e$var$stringifyPayload(payload)
        });
    };
const $d6f06cc7587ce16e$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $d6f06cc7587ce16e$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($d6f06cc7587ce16e$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $d6f06cc7587ce16e$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};

});


parcelRegister("5VXEW", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $45208db9a55c78a4$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
'use client';
const $45208db9a55c78a4$export$b16d9fb1a22de840 = (0, $eJOHy.createContext)(null);
const $45208db9a55c78a4$var$initialState = {
    didCatch: false,
    error: null
};
class $45208db9a55c78a4$export$e926676385687eaf extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $45208db9a55c78a4$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($45208db9a55c78a4$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $45208db9a55c78a4$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($45208db9a55c78a4$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $eJOHy.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $eJOHy.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $eJOHy.createElement)($45208db9a55c78a4$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $45208db9a55c78a4$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $45208db9a55c78a4$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $45208db9a55c78a4$export$c052f6604b7d51fe() {
    const context = (0, $eJOHy.useContext)($45208db9a55c78a4$export$b16d9fb1a22de840);
    $45208db9a55c78a4$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $eJOHy.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $eJOHy.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $45208db9a55c78a4$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $eJOHy.forwardRef)((props, ref)=>(0, $eJOHy.createElement)($45208db9a55c78a4$export$e926676385687eaf, errorBoundaryProps, (0, $eJOHy.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});


const $c335d71b7e366e9d$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';

parcelRegister("g321J", function(module, exports) {
$parcel$export(module.exports, "isRestrictedFromPostOfficeSynthetic", () => $265ba8ec63c2d414$export$9c1a9b8d86d81805);

var $4cTDP = parcelRequire("4cTDP");

var $8s9Wj = parcelRequire("8s9Wj");
const $265ba8ec63c2d414$export$9c1a9b8d86d81805 = ()=>{
    if ((0, $4cTDP.fg)('post-office-enable-placement-synthetic-restriction')) {
        if ((0, $8s9Wj.isSynthetic)()) // permanent gate containing a segment of Post Office Pollinator accounts
        // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/segments/segment%3Apost-office-pollinator-accounts
        return !(0, $4cTDP.fg)('post-office-is-post-office-synthetic');
    }
    return false;
};

});
parcelRegister("8s9Wj", function(module, exports) {
$parcel$export(module.exports, "isSynthetic", () => $8f4679daccc2facb$export$947749d756ccb0a);

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");
const $8f4679daccc2facb$export$947749d756ccb0a = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $4cTDP.fg)('is_synthetic_tenant');

});



parcelRegister("6bLlX", function(module, exports) {
$parcel$export(module.exports, "JiraPreviewPanelsContext", () => $036914669073f5bb$export$3698338ef935e74e);
$parcel$export(module.exports, "PreviewPanelsProvider", () => $036914669073f5bb$export$65ae37e9c61321f9);
$parcel$export(module.exports, "useGlobalObjectPreviewPanels", () => $036914669073f5bb$export$70bcacea0b970dee);
$parcel$export(module.exports, "usePreviewPanelStateChanged", () => $036914669073f5bb$export$5e98dc0fae8a152c);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $kfvK2 = parcelRequire("kfvK2");
var $95O7y = parcelRequire("95O7y");

var $4cTDP = parcelRequire("4cTDP");

var $cHtIB = parcelRequire("cHtIB");

var $iEdF3 = parcelRequire("iEdF3");
var $bP88s = parcelRequire("bP88s");

var $2N9Mf = parcelRequire("2N9Mf");
var $fcue4 = parcelRequire("fcue4");


var $dfP3D = parcelRequire("dfP3D");

var $FhXEJ = parcelRequire("FhXEJ");

var $eWzpp = parcelRequire("eWzpp");


var $6tyZn = parcelRequire("6tyZn");

var $WrBYm = parcelRequire("WrBYm");

var $eUNnv = parcelRequire("eUNnv");
const $036914669073f5bb$export$3698338ef935e74e = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $036914669073f5bb$export$eed91152c097781f = (0, $kfvK2.createRouterSelector)(({ route: route, location: location })=>route.supportsPreviewPanel ? `${route.name}:${location.pathname}` : null);
const $036914669073f5bb$var$parentProduct = 'jira-software';
const $036914669073f5bb$export$2033ad2ecdab8ea3 = (0, $kfvK2.createRouterSelector)(({ route: route })=>{
    return route?.name ? !(0, $WrBYm.LIST_VIEW_ROUTES).includes(route.name) : true;
});
const $036914669073f5bb$var$JiraPreviewPanelsProvider = ({ children: children, subscribe: subscribe })=>{
    (0, $gRw8I.di)(window);
    const cloudId = (0, $cHtIB.useCloudId)();
    const { close: close } = (0, $fcue4.usePreviewPanelsActions)();
    const enabledRoute = $036914669073f5bb$export$eed91152c097781f();
    const isIssueEmbed = enabledRoute?.split(':')[0] === 'issue-embed';
    let SUPPORT_PANEL_TYPES_MILESTONE_ONE = [];
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT);
    /**
	 * Update Jira Preview Panel integration for different products
	 * (Confluence, Goals, Team, Project) behind different FGs.
	 * This is to have ability to control different product integrations using FG.
	 * So, that we should be able to turn specific product ON/OFF individually.
	 */ if ((0, $4cTDP.fg)('jira-preview-panel-team-integration')) SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('identity-team');
    if ((0, $4cTDP.fg)('jira-preview-panel-goals-integration')) SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('townsquare-goal');
    if ((0, $4cTDP.fg)('jira-preview-panel-confluence-integration')) SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('confluence-page');
    if ((0, $4cTDP.fg)('jira-preview-panel-projects-integration')) SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('townsquare-project');
    if ((0, $4cTDP.fg)('jira_preview_panel_m1_4')) SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('jira-issue');
    if (!(0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') || isJSMOrJPDProject) SUPPORT_PANEL_TYPES_MILESTONE_ONE = [];
    let supportedObjects = SUPPORT_PANEL_TYPES_MILESTONE_ONE;
    // If the route is an issue embed, we can get the supported objects from the URL search params.
    // This allows us to support custom objects in the preview panel for the host application.
    if (isIssueEmbed && typeof window !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        supportedObjects = urlSearchParams.get('previewPanels')?.split(',')?.map((0, $iEdF3.asGlobalObjectType));
    }
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $bP88s.useGlobalObjectPreviewPanels)('jira', cloudId, {
        supportedObjects: supportedObjects,
        enabled: enabledRoute !== null
    });
    (0, $bP88s.usePreviewPanelIFrameCommunication)(openPreviewPanel);
    (0, $eUNnv.useEmbeddedConfluencePanelCommunication)({
        closePreviewPanel: close
    });
    (0, $eJOHy.useEffect)(()=>()=>{
            // automatically close the preview panel when the route changes
            close();
        }, [
        enabledRoute,
        close
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            subscribe: subscribe,
            openPreviewPanel: openPreviewPanel,
            isPreviewPanelAvailable: isPreviewPanelAvailable
        }), [
        subscribe,
        openPreviewPanel,
        isPreviewPanelAvailable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($036914669073f5bb$export$3698338ef935e74e.Provider, {
        value: value
    }, children);
};
const $036914669073f5bb$export$65ae37e9c61321f9 = ({ children: children })=>{
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const { closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, setSelectedIssue] = (0, $95O7y.useQueryParam)('selectedIssue');
    const isNotListView = $036914669073f5bb$export$2033ad2ecdab8ea3();
    const isNotListViewRef = (0, $eJOHy.useRef)(isNotListView);
    isNotListViewRef.current = isNotListView;
    const notifySubscribers = (0, $eJOHy.useCallback)((event)=>{
        subscribers.current.forEach((callback)=>callback(event));
    }, []);
    const handlePreviewPanelOpen = (0, $eJOHy.useCallback)((panel)=>{
        // Close Rovo Chat when a preview panel opens
        closeRightSidebar((0, $0b41093501185867$export$dffb4ed44e20ea9a));
        // Close Help Panel when a preview panel opens
        if ((0, $4cTDP.fg)('close_help_panel_on_preview_panel_open')) closeRightSidebar((0, $60b564818f0d5fed$export$e99efa3985fa3c26));
        // Close legacy Embedded Confluence Side Panel when a preview panel opens
        globalThis.window?.postMessage({
            type: 'CLOSE_EMBEDDED_CONFLUENCE_PANEL'
        }, '*');
        notifySubscribers({
            action: 'open',
            panel: panel
        });
        if (!(0, $6tyZn.isNativeIssueViewPreviewPanel)(panel) && isNotListViewRef.current) setSelectedIssue?.(undefined);
    }, [
        closeRightSidebar,
        notifySubscribers,
        setSelectedIssue
    ]);
    const handlePreviewPanelClose = (0, $eJOHy.useCallback)((panel)=>{
        notifySubscribers({
            action: 'close',
            panel: panel
        });
    }, [
        notifySubscribers
    ]);
    const subscribe = (0, $eJOHy.useCallback)((callback)=>{
        subscribers.current.add(callback);
        return ()=>{
            subscribers.current.delete(callback);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2N9Mf.PreviewPanelsProvider), {
        onPreviewPanelOpen: handlePreviewPanelOpen,
        onPreviewPanelClose: handlePreviewPanelClose,
        parentProduct: $036914669073f5bb$var$parentProduct
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($036914669073f5bb$var$JiraPreviewPanelsProvider, {
        subscribe: subscribe
    }, children));
};
const $036914669073f5bb$export$70bcacea0b970dee = ()=>{
    const context = (0, $eJOHy.useContext)($036914669073f5bb$export$3698338ef935e74e);
    if (!context) throw new Error('useGlobalObjectPreviewPanels must be used within a PreviewPanelsProvider');
    const { openPreviewPanel: openGlobalPreviewPanel, isPreviewPanelAvailable: isPreviewPanelAvailable } = context;
    const openPreviewPanel = (props)=>{
        openGlobalPreviewPanel({
            ...props,
            parentProduct: $036914669073f5bb$var$parentProduct
        });
    };
    return {
        openPreviewPanel: openPreviewPanel,
        isPreviewPanelAvailable: isPreviewPanelAvailable
    };
};
const $036914669073f5bb$export$5e98dc0fae8a152c = (callback)=>{
    const { subscribe: subscribe } = (0, $eJOHy.useContext)($036914669073f5bb$export$3698338ef935e74e) ?? {};
    (0, $eJOHy.useEffect)(()=>{
        if (!subscribe) return;
        const unsubscribe = subscribe(callback);
        return ()=>unsubscribe();
    }, [
        subscribe,
        callback
    ]);
};

});
parcelRegister("iEdF3", function(module, exports) {
$parcel$export(module.exports, "isInIframe", () => $c4be37d91d30a7ca$export$9f140ed41af5108c);
$parcel$export(module.exports, "asGlobalObjectType", () => $c4be37d91d30a7ca$export$5b60458e6ab1ba54);
$parcel$export(module.exports, "buildIssueViewEmbedUrl", () => $c4be37d91d30a7ca$export$4e691bca3211cc2f);
$parcel$export(module.exports, "getAnalyticsEnv", () => $c4be37d91d30a7ca$export$4acedbb0ac692186);

var $78ewy = parcelRequire("78ewy");

var $87TlE = parcelRequire("87TlE");
const $c4be37d91d30a7ca$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $c4be37d91d30a7ca$export$5b60458e6ab1ba54 = (value)=>{
    if (!(0, $87TlE.ALL_SUPPORTED_OBJECTS).includes(value)) throw new Error(`Unsupported global object type: ${value}`);
    return value;
};
const $c4be37d91d30a7ca$export$4e691bca3211cc2f = (url, supportedObjects)=>{
    try {
        const urlObj = new URL(url);
        // Ensure there's no trailing slash before appending '/embed'
        urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/embed';
        // Add previewPanels to existing search params
        urlObj.searchParams.set('previewPanels', supportedObjects.join(','));
        // Return the full URL as a string
        return urlObj.toString();
    } catch  {
        // Fallback for invalid URLs
        return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`;
    }
};
const $c4be37d91d30a7ca$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost') || hostname.includes('jira-dev')) return (0, $78ewy.envType).DEV;
    return (0, $78ewy.envType).PROD;
};

});
parcelRegister("87TlE", function(module, exports) {
$parcel$export(module.exports, "ALL_SUPPORTED_OBJECTS", () => $2dd3964dda5dced3$export$cec6f7cb9c99f251);
const $2dd3964dda5dced3$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project'
];

});


parcelRegister("bP88s", function(module, exports) {
$parcel$export(module.exports, "useGlobalObjectPreviewPanels", () => $a1870c90ac2d4daf$export$70bcacea0b970dee);
$parcel$export(module.exports, "usePreviewPanelIFrameCommunication", () => $a1870c90ac2d4daf$export$3cfc2fe60a8f0a1c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $j4oe4 = parcelRequire("j4oe4");

var $9qes7 = parcelRequire("9qes7");

var $DtmfJ = parcelRequire("DtmfJ");

var $lmJ87 = parcelRequire("lmJ87");

var $eALjj = parcelRequire("eALjj");

var $6eLz4 = parcelRequire("6eLz4");

var $c59mr = parcelRequire("c59mr");

var $9AYOJ = parcelRequire("9AYOJ");

var $gtr2v = parcelRequire("gtr2v");

var $6e7tz = parcelRequire("6e7tz");

var $9BieL = parcelRequire("9BieL");

var $fcue4 = parcelRequire("fcue4");

var $k5cIB = parcelRequire("k5cIB");

var $ig9fw = parcelRequire("ig9fw");

var $4Gyvo = parcelRequire("4Gyvo");

var $lwZ6E = parcelRequire("lwZ6E");

var $87TlE = parcelRequire("87TlE");

var $6UdLp = parcelRequire("6UdLp");

var $imDOd = parcelRequire("imDOd");

var $dxSPY = parcelRequire("dxSPY");

var $iEdF3 = parcelRequire("iEdF3");
const $a1870c90ac2d4daf$var$getGlobalObjectType = (ari)=>{
    const parsedAri = (0, $gtr2v.AnyAri).parse(ari);
    return `${parsedAri.resourceOwner}-${parsedAri.resourceType}`;
};
const $a1870c90ac2d4daf$export$70bcacea0b970dee = (product, cloudId, options)=>{
    const { enabled: enabled = true, supportedObjects: supportedObjects = (0, $87TlE.ALL_SUPPORTED_OBJECTS) } = options ?? {};
    const environmentProvider = (0, $4Gyvo.useRelayEnvironmentProvider)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { open: open } = (0, $fcue4.usePreviewPanelsActions)();
    const isPreviewPanelAvailable = (0, $eJOHy.useCallback)(({ ari: ari })=>enabled && supportedObjects.includes($a1870c90ac2d4daf$var$getGlobalObjectType(ari)), [
        enabled,
        supportedObjects
    ]);
    const openPreviewPanel = (0, $eJOHy.useCallback)(({ url: url, ari: ari, name: name, parentProduct: parentProduct, panelData: panelData })=>{
        const globalObjectType = $a1870c90ac2d4daf$var$getGlobalObjectType(ari);
        if (!isPreviewPanelAvailable({
            ari: ari
        })) throw new Error(`Preview panel for ${globalObjectType} with ARI ${ari} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $iEdF3.isInIframe)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari,
                    name: name,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        let panelContent;
        let panelProduct;
        switch(globalObjectType){
            case 'jira-issue':
                const JiraIcon = product === 'jira' ? (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))) : (0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ)));
                const title = formatMessage((0, $6UdLp.default).workItem);
                panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dxSPY.IFramePreviewPanel), {
                    name: title,
                    url: url,
                    iframeUrl: (0, $iEdF3.buildIssueViewEmbedUrl)(url, supportedObjects),
                    icon: /*#__PURE__*/ (0, $gt9Am.jsx)(JiraIcon, {
                        label: ""
                    }),
                    panelType: "jira-work-item",
                    product: "jira",
                    parentProduct: parentProduct,
                    ari: ari
                });
                panelProduct = 'jira';
                break;
            case 'identity-team':
                const teamEntryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $lwZ6E.default), {
                    cloudId: cloudId
                });
                panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $imDOd.EntryPointPreviewPanel), {
                    entryPoint: (0, $lwZ6E.default),
                    preloadedEntryPointReference: teamEntryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        ari: ari,
                        cloudId: cloudId,
                        openPreviewPanel: openPreviewPanel
                    },
                    globalObject: {
                        name: formatMessage((0, $6UdLp.default).team),
                        url: url,
                        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
                            label: ""
                        })
                    }
                });
                panelProduct = 'people';
                break;
            case 'townsquare-goal':
                const entryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $9BieL.default), {
                    ari: ari
                });
                panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $imDOd.EntryPointPreviewPanel), {
                    entryPoint: (0, $9BieL.default),
                    preloadedEntryPointReference: entryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        cloudId: cloudId,
                        defaultTab: (0, $ig9fw.getDefaultSelectedTab)(url)
                    },
                    globalObject: {
                        name: formatMessage((0, $6UdLp.default).goal),
                        url: url,
                        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
                            label: ""
                        })
                    }
                });
                panelProduct = 'townsquare';
                break;
            case 'townsquare-project':
                {
                    const entryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $k5cIB.default), {
                        ari: ari
                    });
                    panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $imDOd.EntryPointPreviewPanel), {
                        entryPoint: (0, $k5cIB.default),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $ig9fw.getDefaultSelectedTab)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $6UdLp.default).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'townsquare';
                    break;
                }
            case 'confluence-page':
                {
                    const urlObj = new URL(url);
                    urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $87TlE.ALL_SUPPORTED_OBJECTS).join(',')));
                    const formattedUrl = urlObj.toString();
                    const entryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $6e7tz.confluencePagePreviewPanelEntryPoint), {});
                    panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $imDOd.EntryPointPreviewPanel), {
                        entryPoint: (0, $6e7tz.confluencePagePreviewPanelEntryPoint),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: formattedUrl,
                            parentProduct: product,
                            panelData: panelData,
                            cloudId: cloudId
                        },
                        globalObject: {
                            name: formatMessage((0, $6UdLp.default).page),
                            url: formattedUrl,
                            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $6e7tz.confluencePagePreviewPanelEntryPoint), {});
                    panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $imDOd.EntryPointPreviewPanel), {
                        entryPoint: (0, $6e7tz.confluencePagePreviewPanelEntryPoint),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $6UdLp.default).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6eLz4))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari,
                type: globalObjectType,
                content: ()=>panelContent,
                product: panelProduct
            }
        });
    }, [
        isPreviewPanelAvailable,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        product,
        cloudId
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
};
const $a1870c90ac2d4daf$export$3cfc2fe60a8f0a1c = (openPreviewPanel)=>{
    // Listen for messages from iframes to open panels
    (0, $eJOHy.useEffect)(()=>{
        const handleMessage = (event)=>{
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            const { payload: payload } = event.data;
            if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                url: payload.url,
                ari: payload.ari,
                name: payload.name,
                panelData: payload.panelData
            });
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openPreviewPanel
    ]);
};

});
parcelRegister("6eLz4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63bc83d2df21e8aa09401170cfaa4b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48a8f23ed94fc92d$var$_react = $48a8f23ed94fc92d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $48a8f23ed94fc92d$var$_baseNew = $48a8f23ed94fc92d$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $48a8f23ed94fc92d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48a8f23ed94fc92d$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $48a8f23ed94fc92d$var$_react.default.createElement($48a8f23ed94fc92d$var$_baseNew.default, Object.assign({
        name: "WhiteboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.177c-.714.282-1.28.817-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.168 8.61.782c.943-.372 2.248-.49 3.09.375.346.356.536.777.548 1.236.011.437-.14.827-.323 1.144-.228.394-.557.761-.876 1.074 1.466-.136 2.717.239 3.421 1.134.827 1.05.644 2.464-.256 3.697l-1.212-.884c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.757-2.524-.512-.521.09-.935.138-1.236.13a1.4 1.4 0 0 1-.537-.11.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.495 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.181.102-.178.124-.292.123-.354-.002-.04-.01-.113-.124-.23-.2-.204-.716-.321-1.464-.026M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$48a8f23ed94fc92d$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $48a8f23ed94fc92d$var$_default = module.exports.default = $48a8f23ed94fc92d$var$WhiteboardIcon;

});

parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("6e7tz", function(module, exports) {
$parcel$export(module.exports, "confluencePagePreviewPanelEntryPoint", () => $28e17efb0e98665b$export$a50c261b4b52f403);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $28e17efb0e98665b$export$a50c261b4b52f403 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6LD6V")), {
        moduleId: "d73b44f1",
        priority: "interaction",
        moduleId: 'confluence-preview-panel-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6LD6V", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("cOIYm")
]).then(()=>parcelRequire('8K7FM'));

});


parcelRegister("9BieL", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdda9d85a826b8f7$export$2e2bcd8739ae039);

var $h6i8k = parcelRequire("h6i8k");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $bTLeY = parcelRequire("bTLeY");
const $cdda9d85a826b8f7$var$fetchPolicy = 'network-only';

const $cdda9d85a826b8f7$var$atlasGoalEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("iTnrP")).then((mod)=>mod.GoalPanel), {
        moduleId: "ba76ccc1",
        moduleName: "GoalPanel",
        priority: "interaction",
        moduleId: 'atlas-goal-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $h6i8k.default)('townsquare-goal-panel-opened');
        return {
            queries: {
                queryReference: {
                    parameters: $bTLeY.default,
                    variables: {
                        ari: ari
                    },
                    options: {
                        fetchPolicy: $cdda9d85a826b8f7$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $cdda9d85a826b8f7$export$2e2bcd8739ae039 = $cdda9d85a826b8f7$var$atlasGoalEntryPoint;

});
parcelRegister("bTLeY", function(module, exports) {
$parcel$export(module.exports, "default", () => $e50b238251f6bf13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b17d440b9bff002c5093f63e63c6615>>
 * @relayHash fa29079d00f66d1ebee8e96b6f0b7879
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f40d1de74cdbdc9f9129faa4a7553a3f9f2e5640d49a1251a758dc120481c0d
const $e50b238251f6bf13$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "goalId",
            "variableName": "ari"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        v7 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v9 = [
        v5 /*: any*/ ,
        v1 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v1 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "value"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": v12 /*: any*/ ,
        "type": "TownsquareGoalTypeCustomName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "defaultValue"
    }, v15 = [
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "score"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "isArchived"
    }, v17 = {
        "concreteType": "TownsquareGoalTypeIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "type"
    }, v19 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "percentage"
            },
            v18 /*: any*/ 
        ]
    }, v20 = {
        "concreteType": "TownsquareMetricTargetConnection",
        "kind": "LinkedField",
        "name": "metricTargets",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "concreteType": "TownsquareMetric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v18 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "subType"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "archived"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "externalEntityId"
                                    }
                                ]
                            },
                            {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "snapshotValue",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startValue"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "targetValue"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = {
        "concreteType": "TownsquareStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v22 = {
        "concreteType": "TownsquareGoalType",
        "kind": "LinkedField",
        "name": "goalType",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v23 = {
        "concreteType": "TownsquareIconURIs",
        "kind": "LinkedField",
        "name": "iconUrl",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "dark"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "light"
                    }
                ]
            }
        ]
    }, v24 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "description"
    }, v26 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v27 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v28 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v29 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v31 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v29 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v30 /*: any*/ ,
                            v28 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v33 = [
        {
            "kind": "ScalarField",
            "name": "label"
        }
    ], v34 = {
        "kind": "Literal",
        "name": "first",
        "value": 200
    }, v35 = [
        v34 /*: any*/ 
    ], v36 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v37 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v38 = [
        v7 /*: any*/ ,
        v3 /*: any*/ ,
        v2 /*: any*/ ,
        v1 /*: any*/ 
    ], v39 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v32 /*: any*/ ,
                v25 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": v38 /*: any*/ 
                },
                {
                    "kind": "LinkedField",
                    "name": "lastEditedBy",
                    "plural": false,
                    "selections": v38 /*: any*/ 
                },
                v28 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "lastEditedDate"
                }
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v40 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "ari"
    }, v41 = [
        v34 /*: any*/ ,
        v40 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v4 /*: any*/ ,
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goals_byId",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalPanelTitleField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalType"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalMetrics"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ParentGoal"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "SubGoals"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalActions"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTeams"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "goals_byId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "ari"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "GoalPanelTabs"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goals_byId",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v9 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v9 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                }
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "name",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "messageId"
                                                },
                                                v14 /*: any*/ 
                                            ],
                                            "type": "TownsquareLocalizationField"
                                        }
                                    ]
                                },
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "kind"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": v15 /*: any*/ 
                        },
                        {
                            "kind": "ScalarField",
                            "name": "scoringMode"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                        },
                        v16 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "name",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ 
                                            ],
                                            "type": "TownsquareLocalizationField"
                                        }
                                    ]
                                },
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        },
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "projects",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProjectEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v24 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTargetDateRange",
                                    "kind": "LinkedField",
                                    "name": "dateRange",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "start"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "end"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v1 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v2 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                },
                                v24 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        v28 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalTeamConnection",
                            "kind": "LinkedField",
                            "name": "teams",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalTeamEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canRemove"
                                        },
                                        {
                                            "concreteType": "TeamV2",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "smallAvatarImageUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVerified"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "profileUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v24 /*: any*/ 
                            ]
                        },
                        v25 /*: any*/ ,
                        v31 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "missedUpdate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updateType"
                                                },
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "newState",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v28 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                        },
                        {
                            "args": v35 /*: any*/ ,
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v36 /*: any*/ 
                                    ]
                                },
                                v37 /*: any*/ ,
                                v24 /*: any*/ 
                            ],
                            "storageKey": "projects(first:200)"
                        },
                        {
                            "args": v35 /*: any*/ ,
                            "handle": "connection",
                            "key": "GoalContentProjects_projects",
                            "kind": "LinkedHandle",
                            "name": "projects"
                        },
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v39 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v39 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v39 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalCapabilities_extension",
                                    "kind": "LinkedField",
                                    "name": "capabilities_extension",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditTitle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canManageOwnership"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditTargetDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditJiraAlignProject"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v40 /*: any*/ 
                            ],
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "atlasGoalHasJiraAlignProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectUrl"
                                                        }
                                                    ],
                                                    "type": "JiraAlignAggProject"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v24 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v41 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoalInverse",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v36 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                },
                                v37 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        },
                        {
                            "args": v41 /*: any*/ ,
                            "filters": [
                                "id"
                            ],
                            "handle": "connection",
                            "key": "GoalContentJira_jiraEpicContributesToAtlasGoalInverse",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoalInverse"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8f40d1de74cdbdc9f9129faa4a7553a3f9f2e5640d49a1251a758dc120481c0d",
            "metadata": {},
            "name": "GoalPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e50b238251f6bf13$var$node.hash = "f3b37283502674d9ed9c4aeada6eec70";
var $e50b238251f6bf13$export$2e2bcd8739ae039 = $e50b238251f6bf13$var$node;

});

parcelRegister("iTnrP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ddsAV")
]).then(()=>parcelRequire('gZGO8'));

});


parcelRegister("k5cIB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6ccc81b87ca3493$export$2e2bcd8739ae039);

var $59rsN = parcelRequire("59rsN");

var $h6i8k = parcelRequire("h6i8k");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $3NmWZ = parcelRequire("3NmWZ");
const $a6ccc81b87ca3493$var$fetchPolicy = 'network-only';

const $a6ccc81b87ca3493$var$atlasProjectEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("he40r")).then((mod)=>mod.ProjectPanel), {
        moduleId: "db5db9ea",
        moduleName: "ProjectPanel",
        priority: "interaction",
        moduleId: 'atlas-project-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $h6i8k.default)('townsquare-project-panel-opened');
        const isProjectNativeIntegrationEnabled = (0, $59rsN.default).getExperimentValue('atlassian_projects_-_native_integration', 'isEnabled', false);
        return {
            queries: {
                queryReference: {
                    parameters: $3NmWZ.default,
                    variables: {
                        ari: ari,
                        isProjectNativeIntegrationEnabled: isProjectNativeIntegrationEnabled
                    },
                    options: {
                        fetchPolicy: $a6ccc81b87ca3493$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $a6ccc81b87ca3493$export$2e2bcd8739ae039 = $a6ccc81b87ca3493$var$atlasProjectEntryPoint;

});
parcelRegister("3NmWZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca7f1793a45386d0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea46d2d656042aedf2edb7d90857b8e4>>
 * @relayHash 78704080423c6211d6806bb0f8a76fef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60321d44b783d9cffa6302f72296a6a633f06f69213531edb366d293514b013a
const $ca7f1793a45386d0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isProjectNativeIntegrationEnabled"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "ari"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = [
        v1 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "canEditMembers"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = [
        v9 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isUser"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v13 = {
        "kind": "ScalarField",
        "name": "count"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "dark"
    }, v16 = {
        "kind": "ScalarField",
        "name": "light"
    }, v17 = {
        "kind": "ScalarField",
        "name": "description"
    }, v18 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "ScalarField",
        "name": "value"
    }, v21 = {
        "kind": "ScalarField",
        "name": "label"
    }, v22 = [
        {
            "concreteType": "TownsquareLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v6 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        v14 /*: any*/ 
    ], v23 = [
        v19 /*: any*/ ,
        v1 /*: any*/ 
    ], v24 = {
        "kind": "InlineFragment",
        "selections": v7 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v25 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v26 = [
        v20 /*: any*/ 
    ], v27 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v28 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v9 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v27 /*: any*/ ,
                            v25 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v30 = [
        v21 /*: any*/ 
    ], v31 = [
        v9 /*: any*/ ,
        v3 /*: any*/ ,
        v2 /*: any*/ ,
        v1 /*: any*/ 
    ], v32 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v29 /*: any*/ ,
                v17 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": v31 /*: any*/ 
                },
                {
                    "kind": "LinkedField",
                    "name": "lastEditedBy",
                    "plural": false,
                    "selections": v31 /*: any*/ 
                },
                v25 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "lastEditedDate"
                }
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "webUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v5 /*: any*/ ,
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "projects_byId",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareContributorConnection",
                                "kind": "LinkedField",
                                "name": "contributors",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareContributorEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareContributor",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "userContributor",
                                                        "plural": false,
                                                        "selections": v7 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v8 /*: any*/ ,
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectJiraWork"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelHeader"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectLinks"
                            },
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectWorkTracked"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "RelatedProjects"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributesTo"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributors"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectActionsContent"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelTabs"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "projects_byId"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "projects_byId",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareContributorConnection",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareContributorEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareContributor",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "userContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTeamContributor",
                                                    "kind": "LinkedField",
                                                    "name": "teamContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributingMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TeamV2",
                                                            "kind": "LinkedField",
                                                            "name": "team",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "smallAvatarImageUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "profileUrl"
                                                                },
                                                                {
                                                                    "concreteType": "TeamMemberConnectionV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "members",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TeamMemberEdgeV2",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TeamMemberV2",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "member",
                                                                                            "plural": false,
                                                                                            "selections": v10 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "TownsquareWorkspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "roundedSquare",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        v19 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isArchived"
                        },
                        {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "dueDate",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTargetDateRange",
                                    "kind": "LinkedField",
                                    "name": "dateRange",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "start"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "end"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareLinkConnection",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v23 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v23 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v24 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        v25 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectDependencyConnection",
                            "kind": "LinkedField",
                            "name": "dependencies",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectDependencyEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectDependency",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "linkType"
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "incomingProject",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "outgoingProject",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareIconURIs",
                                                            "kind": "LinkedField",
                                                            "name": "iconUrl",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareThemeURIs",
                                                                    "kind": "LinkedField",
                                                                    "name": "square",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "goals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalTypeIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectDescription",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "what"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "why"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "measurement"
                                }
                            ]
                        },
                        v28 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "missedUpdate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updateType"
                                                },
                                                v29 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v30 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "newState",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v25 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v30 /*: any*/ 
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v32 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v32 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v32 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        }
                                    ],
                                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedJiraWorkItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "permission",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasProjectPermission",
                                                                    "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                                                                },
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                v1 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeId"
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        v24 /*: any*/ 
                                                    ]
                                                },
                                                v1 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedJiraWorkItems(first:5)"
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "workTrackingLinks",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "WORK_TRACKING"
                                        }
                                    ],
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v22 /*: any*/ ,
                                    "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
                                },
                                {
                                    "concreteType": "TownsquareFusionDetails",
                                    "kind": "LinkedField",
                                    "name": "fusion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "synced"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v33 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "60321d44b783d9cffa6302f72296a6a633f06f69213531edb366d293514b013a",
            "metadata": {},
            "name": "ProjectPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ca7f1793a45386d0$var$node.hash = "743a3b9dd06694a5084566aaea102d37";
var $ca7f1793a45386d0$export$2e2bcd8739ae039 = $ca7f1793a45386d0$var$node;

});

parcelRegister("he40r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2prKh")
]).then(()=>parcelRequire('fmton'));

});


parcelRegister("ig9fw", function(module, exports) {
$parcel$export(module.exports, "getDefaultSelectedTab", () => $8e23416e2a5cca27$export$68d1d951742105ed);
/*
 * Get the default tab from the url
 * Post T25 EU task: Support other URL routing (jira/jira-align/highlights, ect)
 * TODO: https://product-fabric.atlassian.net/browse/TC-14119
 */ function $8e23416e2a5cca27$export$68d1d951742105ed(url) {
    // About | Updates | {other tabs}
    if (url.includes('updates')) return 'updates';
    return 'about';
}

});

parcelRegister("lwZ6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $d975f6cc433a8459$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $jTHqs = parcelRequire("jTHqs");
const $d975f6cc433a8459$var$fetchPolicy = 'network-only';

const $d975f6cc433a8459$var$teamPreviewPanelEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6hddj")).then((mod)=>mod.TeamPreviewPanel), {
        moduleId: "bc41c2d8",
        priority: "interaction",
        moduleId: 'team-preview-panel-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    parameters: $jTHqs.default,
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $d975f6cc433a8459$var$fetchPolicy
                    }
                }
            }
        })
});
var $d975f6cc433a8459$export$2e2bcd8739ae039 = $d975f6cc433a8459$var$teamPreviewPanelEntryPoint;

});
parcelRegister("jTHqs", function(module, exports) {
$parcel$export(module.exports, "default", () => $68663190923906ee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be9d76f63db93553bbb649b37a6b4c41>>
 * @relayHash 91adf951953bfe64ddb250042a4a0511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527
const $68663190923906ee$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "orgId"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ]
        },
        "params": {
            "id": "1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527",
            "metadata": {},
            "name": "teamPreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$68663190923906ee$var$node.hash = "6b8a5c1e76dd69e5d8daea6919628199";
var $68663190923906ee$export$2e2bcd8739ae039 = $68663190923906ee$var$node;

});

parcelRegister("6hddj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("33HgT")
]).then(()=>parcelRequire('3AtRG'));

});


parcelRegister("6UdLp", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8232051d0f49b2f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c8232051d0f49b2f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    workItem: {
        id: 'navigation.preview-panel-global-objects.workItem',
        defaultMessage: 'Jira work item',
        description: 'Title for the work item preview panel'
    },
    project: {
        id: 'navigation.preview-panel-global-objects.project',
        defaultMessage: 'Project',
        description: 'Title for the project preview panel'
    },
    goal: {
        id: 'navigation.preview-panel-global-objects.goal',
        defaultMessage: 'Goal',
        description: 'Title for the goal preview panel'
    },
    team: {
        id: 'navigation.preview-panel-global-objects.team',
        defaultMessage: 'Team',
        description: 'Title for the team preview panel'
    },
    page: {
        id: 'navigation.preview-panel-global-objects.page',
        defaultMessage: 'Confluence Page',
        description: 'Title for the Confluence page preview panel'
    },
    whiteboard: {
        id: 'navigation.preview-panel-global-objects.whiteboard',
        defaultMessage: 'Confluence Whiteboard',
        description: 'Title for the Confluence whiteboard preview panel'
    }
});

});

parcelRegister("imDOd", function(module, exports) {
$parcel$export(module.exports, "EntryPointPreviewPanel", () => $d2da0074c9f7ef28$export$2ace74dd551e05c1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lBsyH = parcelRequire("lBsyH");

var $2pMuf = parcelRequire("2pMuf");

var $7h3Yz = parcelRequire("7h3Yz");
const $d2da0074c9f7ef28$var$emptyEntryPointProps = {};
const $d2da0074c9f7ef28$export$2ace74dd551e05c1 = ({ entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: runtimeProps = $d2da0074c9f7ef28$var$emptyEntryPointProps, globalObject: globalObject })=>{
    const id = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBsyH.InternalEntryPointContainer), {
        id: id,
        entryPointReference: preloadedEntryPointReference,
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7h3Yz.FallbackPreviewPanel), {
            ...globalObject
        }),
        errorFallback: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2pMuf.ErrorFallbackPreviewPanel), {
                ...globalObject
            }),
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("2pMuf", function(module, exports) {
$parcel$export(module.exports, "ErrorFallbackPreviewPanel", () => $c74a844a2efae1d7$export$9f31ac9d4b42e91c);
/* ErrorFallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6MnLl = parcelRequire("6MnLl");

var $eJ9f5 = parcelRequire("eJ9f5");

var $4umLE = parcelRequire("4umLE");
var $aySDe = parcelRequire("aySDe");
var $8QUQ1 = parcelRequire("8QUQ1");
var $4uz2a = parcelRequire("4uz2a");

var $fcue4 = parcelRequire("fcue4");

var $k7pFz = parcelRequire("k7pFz");

var $eFq79 = parcelRequire("eFq79");
const $c74a844a2efae1d7$var$styles = {
    body: "_bozgxncg _y4tixncg _1q511ejb _85i51ejb"
};
const $c74a844a2efae1d7$export$9f31ac9d4b42e91c = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, name: name, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { close: close } = (0, $fcue4.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4umLE.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QUQ1.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4uz2a.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aySDe.PreviewPanelBody), {
                styles: $c74a844a2efae1d7$var$styles.body,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6MnLl.default), {
                    header: formatMessage((0, $eFq79.messages).errorHeader),
                    description: formatMessage((0, $eFq79.messages).errorDescription, {
                        link: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                href: "https://status.atlassian.com/",
                                children: chunks
                            })
                    }),
                    headingLevel: 2,
                    imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($k7pFz)))
                })
            })
        ]
    });
});

});
parcelRegister("4umLE", function(module, exports) {
$parcel$export(module.exports, "PreviewPanel", () => $32081ff2267af5cb$export$9520f072db304aa0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");
const $32081ff2267af5cb$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $32081ff2267af5cb$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
        xcss: $32081ff2267af5cb$var$styles.wrapper,
        testId: testId,
        children: children
    });
};

});

parcelRegister("aySDe", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelBody", () => $68df85322f72bf99$export$cda5e69749e7aeee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $68df85322f72bf99$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, styles: styles })=>{
    (0, $eJOHy.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)(!!styles && styles),
        children: children
    });
};

});

parcelRegister("8QUQ1", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelHeader", () => $3c670572dde24c80$export$426d4171de44bac0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $9itkV = parcelRequire("9itkV");

var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");

var $lrcrm = parcelRequire("lrcrm");
const $3c670572dde24c80$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $3c670572dde24c80$var$styles = {
    header: "_1h6dmuej _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $3c670572dde24c80$export$426d4171de44bac0 = ({ children: children, onClose: onClose, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        if (url) window.open($3c670572dde24c80$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        xcss: $3c670572dde24c80$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                xcss: $3c670572dde24c80$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))),
                        appearance: "subtle",
                        label: formatMessage((0, $lrcrm.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $lrcrm.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("lrcrm", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9105a1d39bd629d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c9105a1d39bd629d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: 'navigation.preview-panel.preview-panel-header.close-button-label',
        defaultMessage: 'Close',
        description: 'Label for the close button in the preview panel'
    },
    previewPanelExpandActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label',
        defaultMessage: 'Expand',
        description: 'Label for the expand action in the preview panel'
    },
    previewPanelNewTabActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label',
        defaultMessage: 'Open in new tab',
        description: 'Label for the open in new tab action in the preview panel'
    },
    previewPanelMoreDropdownActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label',
        defaultMessage: 'More',
        description: 'Label for the more dropdown action in the preview panel'
    },
    previewPanelOpenInNewWindowLabel: {
        id: 'navigation.preview-panel.preview-panel-header.open-in-new-window-label',
        defaultMessage: 'Open in new window',
        description: 'Label for the open in new window button in the preview panel header'
    }
});

});


parcelRegister("4uz2a", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelTitle", () => $0f8b34722dba128c$export$92a58681483f4529);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");
const $0f8b34722dba128c$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};

});

parcelRegister("k7pFz", function(module, exports) {
module.exports = new URL("ErrorGeneric.d6dc5451.svg", import.meta.url).toString();

});

parcelRegister("eFq79", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fc672338913395fa$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fc672338913395fa$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    errorHeader: {
        id: 'navigation.preview-panel-global-objects.panels.error-header',
        defaultMessage: "Can\u2019t load details",
        description: 'Header for the preview panel error state'
    },
    errorDescription: {
        id: 'navigation.preview-panel-global-objects.panels.error-description',
        defaultMessage: "We\u2019ve got all hands on deck working to get you back up and running. For more information, <link>check our status page</link>.",
        description: 'Description for the preview panel error state'
    }
});

});


parcelRegister("7h3Yz", function(module, exports) {
$parcel$export(module.exports, "FallbackPreviewPanel", () => $21272755da20ae1a$export$97ea7ee86eec0667);
/* FallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4umLE = parcelRequire("4umLE");
var $aySDe = parcelRequire("aySDe");
var $8QUQ1 = parcelRequire("8QUQ1");
var $4uz2a = parcelRequire("4uz2a");

var $fcue4 = parcelRequire("fcue4");
const $21272755da20ae1a$var$styles = {
    body: "_zulppxbi _1e0c1txw _2lx21bp4 _16jlkb7n _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    skeleton: "_2rko12b0 _1e0c1txw _bfhkn82g _4t3igktf",
    skeletonRow1: "_1bsb1osq",
    skeletonRow2: "_1bsb1nrf",
    skeletonRow3: "_1bsb1w8u",
    skeletonRow4: "_1bsbhwvj"
};
const $21272755da20ae1a$export$97ea7ee86eec0667 = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, name: name, icon: icon })=>{
    const { close: close } = (0, $fcue4.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4umLE.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QUQ1.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4uz2a.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aySDe.PreviewPanelBody), {
                styles: $21272755da20ae1a$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $21272755da20ae1a$var$styles.skeleton,
                            $21272755da20ae1a$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $21272755da20ae1a$var$styles.skeleton,
                            $21272755da20ae1a$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $21272755da20ae1a$var$styles.skeleton,
                            $21272755da20ae1a$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $21272755da20ae1a$var$styles.skeleton,
                            $21272755da20ae1a$var$styles.skeletonRow4
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $21272755da20ae1a$var$styles.skeleton,
                            $21272755da20ae1a$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $21272755da20ae1a$var$styles.skeleton,
                            $21272755da20ae1a$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $21272755da20ae1a$var$styles.skeleton,
                            $21272755da20ae1a$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $21272755da20ae1a$var$styles.skeleton,
                            $21272755da20ae1a$var$styles.skeletonRow4
                        ])
                    })
                ]
            })
        ]
    });
});

});


parcelRegister("dxSPY", function(module, exports) {
$parcel$export(module.exports, "IFramePreviewPanel", () => $1f27d09a64dd6dc9$export$83f0623b6f97b032);
/* IFramePreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6g1o6 = parcelRequire("6g1o6");
var $78ewy = parcelRequire("78ewy");

var $eGOwo = parcelRequire("eGOwo");

var $58yRG = parcelRequire("58yRG");

var $4umLE = parcelRequire("4umLE");
var $aySDe = parcelRequire("aySDe");
var $8QUQ1 = parcelRequire("8QUQ1");
var $4uz2a = parcelRequire("4uz2a");

var $fcue4 = parcelRequire("fcue4");

var $iEdF3 = parcelRequire("iEdF3");
const $1f27d09a64dd6dc9$var$styles = {
    iframe: "_19itglyw _1bsb1osq _4t3i1osq",
    body: "_1e0c1txw _16jlkb7n _18m91wug"
};
const $1f27d09a64dd6dc9$export$6c67178058384ea6 = (ari)=>{
    if (!ari || typeof ari !== 'string' || !ari.startsWith('ari:cloud:jira:')) return undefined;
    const parts = ari.split(':');
    if (parts.length !== 5) return undefined;
    const cloudId = parts[3];
    if (!cloudId) return undefined;
    return cloudId;
};
const $1f27d09a64dd6dc9$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari })=>{
    const { close: close } = (0, $fcue4.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, $eJOHy.useState)();
    const cloudId = ari ?? $1f27d09a64dd6dc9$export$6c67178058384ea6(ari);
    const { colorMode: colorMode } = (0, $58yRG.default)();
    (0, $eJOHy.useEffect)(()=>{
        setAnalyticsClient(()=>{
            let analyticsClient = new (0, $6g1o6.default)({
                product: product,
                env: (0, $iEdF3.getAnalyticsEnv)(window.location.hostname),
                origin: (0, $78ewy.originType).WEB
            });
            if (cloudId) analyticsClient?.setTenantInfo((0, $78ewy.tenantType).CLOUD_ID, cloudId);
            return analyticsClient;
        });
    }, [
        product,
        cloudId
    ]); // Create iframe URL with theme parameter
    const iframeUrlWithTheme = (0, $eJOHy.useMemo)(()=>{
        if (!iframeUrl || !colorMode) return iframeUrl;
        const url = new URL(iframeUrl, window.location.origin);
        url.searchParams.set('themeMode', colorMode);
        return url.toString();
    }, [
        iframeUrl,
        colorMode
    ]);
    const iframeSrc = (0, $eGOwo.fg)('theming-iframe-preview-panel') ? iframeUrlWithTheme : iframeUrl;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4umLE.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QUQ1.PreviewPanelHeader), {
                onClose: close,
                url: url,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4uz2a.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aySDe.PreviewPanelBody), {
                styles: $1f27d09a64dd6dc9$var$styles.body,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
                    src: iframeSrc,
                    title: name,
                    className: (0, $hcewu.default)([
                        $1f27d09a64dd6dc9$var$styles.iframe
                    ])
                })
            })
        ]
    });
});

});


parcelRegister("6tyZn", function(module, exports) {
$parcel$export(module.exports, "isNativeIssueViewPreviewPanel", () => $cf036eb0d4b482d3$export$51d6de34c4c87b23);
const $cf036eb0d4b482d3$export$51d6de34c4c87b23 = (panel)=>{
    return panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
};

});

parcelRegister("WrBYm", function(module, exports) {
$parcel$export(module.exports, "LIST_VIEW_ROUTES", () => $548de97341c65f5d$export$e547a725765cb810);
const $548de97341c65f5d$export$e547a725765cb810 = [
    'software-list',
    'classic-business-list',
    'software-list-classic'
];

});

parcelRegister("eUNnv", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedConfluencePanelCommunication", () => $5e14281d0366890b$export$67032c58b985836f);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");
const $5e14281d0366890b$export$67032c58b985836f = ({ closePreviewPanel: closePreviewPanel })=>{
    // Listen for messages from the legacy embedded Confluence panel to close the active preview panel
    (0, $eJOHy.useEffect)(()=>{
        const handleMessage = (event)=>{
            /*
			 * CLOSE_PREVIEW_PANEL is sent by the legacy embedded Confluence panel when it is opened
			 * to signal that any active preview panel should be closed.
			 * Search for "CLOSE_PREVIEW_PANEL" in to find where message is sent.

			*/ if (event.data?.type === 'CLOSE_PREVIEW_PANEL') closePreviewPanel();
        };
        if ((0, $4cTDP.fg)('jira_preview_panel_m_1_rollout')) globalThis.window.addEventListener('message', handleMessage);
        return ()=>{
            globalThis.window.removeEventListener('message', handleMessage);
        };
    }, [
        closePreviewPanel
    ]);
};

});


parcelRegister("gzwmK", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $304ec733ca6ad2a8$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $h47gY = parcelRequire("h47gY");
const $304ec733ca6ad2a8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: id
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: id,
        packageName: "jiraEntry",
        fallback: "page",
        withExperienceTracker: withExperienceTracker
    }, children);
};

});

parcelRegister("5PTRS", function(module, exports) {
$parcel$export(module.exports, "IntlProviders", () => $3910e304ad37bfd3$export$c9d8cd4516cc55a8);

var $eJOHy = parcelRequire("eJOHy");

var $jbr6p = parcelRequire("jbr6p");

var $3nRRD = parcelRequire("3nRRD");

var $igDjg = parcelRequire("igDjg");
const $3910e304ad37bfd3$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nRRD.IntlProvider), {
        messages: messages,
        locale: (0, $jbr6p.standardizeLocale)(locale),
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($igDjg?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        }
    }, children);

});
parcelRegister("3nRRD", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $d9df13873493f54a$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
const $d9df13873493f54a$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4nehu.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});


parcelRegister("bea4o", function(module, exports) {
$parcel$export(module.exports, "MetricsContainers", () => $5e82a563385f6127$export$2d1617bc0040e5d9);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $k9PyW = parcelRequire("k9PyW");

var $fEmyV = parcelRequire("fEmyV");

var $kGj4V = parcelRequire("kGj4V");

var $f6YCy = parcelRequire("f6YCy");
const $5e82a563385f6127$export$2d1617bc0040e5d9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: (0, $fEmyV.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k9PyW.ExperienceTrackerProvider), null, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "metrics-containers-subproduct-updater",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6YCy.SubProductForAnalyticsUpdater), null)), children));

});
parcelRegister("k9PyW", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerProvider", () => $f93b157208a07da2$export$6f49c95a810d59fa);

var $eJOHy = parcelRequire("eJOHy");

var $87Obl = parcelRequire("87Obl");
var $40f0Z = parcelRequire("40f0Z");

var $50BUM = parcelRequire("50BUM");
// eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
const $f93b157208a07da2$var$useUnmount = (callback)=>(0, $eJOHy.useEffect)(()=>callback, [
        callback
    ]);
const $f93b157208a07da2$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $eJOHy.useState)(new (0, $87Obl.ExperienceTracker)());
    const [cleanupSliSub] = (0, $eJOHy.useState)(()=>experienceTracker.subscribe((0, $50BUM.sliSubscriber)));
    const cleanup = (0, $eJOHy.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $f93b157208a07da2$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40f0Z.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("50BUM", function(module, exports) {
$parcel$export(module.exports, "sliSubscriber", () => $b6949126dda90aac$export$db0b99fe17114899);

var $2Mqjh = parcelRequire("2Mqjh");

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");

const $b6949126dda90aac$var$transformApplication = (application)=>{
    switch(application){
        case 0, $lBYgs.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $lBYgs.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $lBYgs.JIRA_CORE:
            return 'jira-core';
        case 0, $lBYgs.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $lBYgs.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $b6949126dda90aac$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $cblKs.FREE_EDITION:
            return 'jedi';
        case 0, $cblKs.STANDARD_EDITION:
            return 'standard';
        case 0, $cblKs.PREMIUM_EDITION:
            return 'premium';
        case 0, $cblKs.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $b6949126dda90aac$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $b6949126dda90aac$var$transformApplication(application),
            edition: $b6949126dda90aac$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $b6949126dda90aac$var$reportSli = (experienceDescription)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $b6949126dda90aac$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $b6949126dda90aac$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $f17fa9e5c82da056$export$627ef4c1ed2d7a9a:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $f17fa9e5c82da056$export$b48b3d1872522384:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $f17fa9e5c82da056$export$aeeb00d0845d24d8:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});


parcelRegister("f6YCy", function(module, exports) {
$parcel$export(module.exports, "SubProductForAnalyticsUpdater", () => $9b9313a64c71dc7d$export$2f8fd5150032da73);

var $eJOHy = parcelRequire("eJOHy");

var $kQnVX = parcelRequire("kQnVX");

var $figsJ = parcelRequire("figsJ");
const $9b9313a64c71dc7d$export$2f8fd5150032da73 = ()=>{
    const subProduct = (0, $figsJ.useSubProductForAnalytics)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $kQnVX.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};

});


parcelRegister("jFTjK", function(module, exports) {
$parcel$export(module.exports, "NavigationContainers", () => $3105c9d1784441dd$export$36f9ed697cae18ae);

var $eJOHy = parcelRequire("eJOHy");

var $7XGx3 = parcelRequire("7XGx3");
const $3105c9d1784441dd$var$ServerContainers = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $3105c9d1784441dd$export$36f9ed697cae18ae = ({ children: children })=>{
    const Containers = !false ? (0, $7XGx3.ClientOnlyNavigationContainers) : $3105c9d1784441dd$var$ServerContainers;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Containers, null, children);
};

});
parcelRegister("7XGx3", function(module, exports) {
$parcel$export(module.exports, "ClientOnlyNavigationContainers", () => $8293891f5492a13e$export$68d7c1e44acfd599);

var $eJOHy = parcelRequire("eJOHy");

var $jCQk5 = parcelRequire("jCQk5");
const $8293891f5492a13e$export$68d7c1e44acfd599 = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jCQk5.Provider), null, children);
    return null;
};

});


parcelRegister("bDTmj", function(module, exports) {
$parcel$export(module.exports, "PageConfigContainers", () => $8aa1d096109b963f$export$9c661932489b4130);

var $eJOHy = parcelRequire("eJOHy");

var $575d2 = parcelRequire("575d2");

var $hWeHP = parcelRequire("hWeHP");

var $kfvK2 = parcelRequire("kfvK2");

var $19u1t = parcelRequire("19u1t");

var $113FJ = parcelRequire("113FJ");
const $8aa1d096109b963f$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $8aa1d096109b963f$export$9c661932489b4130 = ({ children: children })=>{
    const { PageConfigContainerOverride: PageConfigContainerOverride } = $8aa1d096109b963f$var$useRouterRoute();
    if (PageConfigContainerOverride !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PageConfigContainerOverride, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $575d2.ThemeContainer), {
        isGlobal: true,
        getMeta: (0, $hWeHP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $19u1t.DocumentTitleContainer), {
        titleSuffix: (0, $113FJ.ripTitleTemplateFromMeta)((0, $hWeHP.default))
    }, children));
};

});
parcelRegister("575d2", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $68e241df896657e0$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $68e241df896657e0$export$11eb671888ed6e7d);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $2evd1 = parcelRequire("2evd1");
const $68e241df896657e0$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $68e241df896657e0$var$Store = (0, $GtRbT.createStore)({
    name: 'theme',
    initialState: $68e241df896657e0$var$initialState,
    actions: $2evd1
});
const $68e241df896657e0$export$74e6aa5aeff5e82e = (0, $ht3nQ.createSubscriber)($68e241df896657e0$var$Store);
const $68e241df896657e0$export$93d4e7f90805808f = (0, $iJq0l.createHook)($68e241df896657e0$var$Store);
const $68e241df896657e0$export$11eb671888ed6e7d = (0, $6E16M.createContainer)($68e241df896657e0$var$Store, {
    onInit: $2evd1.bootstrap
});

});
parcelRegister("2evd1", function(module, exports) {
$parcel$export(module.exports, "bootstrap", () => $c655e5e5256464c4$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $c655e5e5256464c4$export$722fbec263ad908a);

const $c655e5e5256464c4$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $7bb4c1736002a04a$exports).N0 || ajsHighlightColor !== (0, $7bb4c1736002a04a$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || "var(--ds-background-inverse-subtle, #00000029)",
            highlightColor: ajsHighlightColor || "var(--ds-text-brand, #0C66E4)"
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $c655e5e5256464c4$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("19u1t", function(module, exports) {
$parcel$export(module.exports, "useDocumentTitleActions", () => $ec2c1009f04e2597$export$57c0fda036e12d67);
$parcel$export(module.exports, "DocumentTitleContainer", () => $ec2c1009f04e2597$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleHelper", () => $ec2c1009f04e2597$export$573bf8d2ae7d60dc);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $dwnXT = parcelRequire("dwnXT");
const $ec2c1009f04e2597$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $ec2c1009f04e2597$var$Store = (0, $GtRbT.createStore)({
    name: 'document-title',
    initialState: $ec2c1009f04e2597$var$initialState,
    actions: $dwnXT.actions
});
const $ec2c1009f04e2597$export$57c0fda036e12d67 = (0, $iJq0l.createActionsHook)($ec2c1009f04e2597$var$Store);
const $ec2c1009f04e2597$export$4b208edda918084f = (0, $iJq0l.createHook)($ec2c1009f04e2597$var$Store);
const $ec2c1009f04e2597$export$1aad43993172f16f = (0, $6E16M.createContainer)($ec2c1009f04e2597$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $ec2c1009f04e2597$export$b88d5abf3e0bec8c = (0, $ht3nQ.createSubscriber)($ec2c1009f04e2597$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
const $ec2c1009f04e2597$export$573bf8d2ae7d60dc = ({ title: title })=>{
    const { addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle, updateTitle: updateTitle } = $ec2c1009f04e2597$export$57c0fda036e12d67();
    const identifierRef = (0, $eJOHy.useRef)(Symbol(title));
    const onUpdate = (0, $eJOHy.useCallback)(()=>{
        updateTitle(title, identifierRef.current);
    }, [
        updateTitle,
        title
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const titleRef = identifierRef.current;
        addDocumentTitle(titleRef, title);
        return ()=>{
            removeDocumentTitle(titleRef);
            onUpdate();
        };
    }, [
        addDocumentTitle,
        onUpdate,
        removeDocumentTitle,
        title
    ]);
    (0, $eJOHy.useEffect)(()=>{
        onUpdate();
    }, [
        onUpdate
    ]);
    return null;
};

});
parcelRegister("dwnXT", function(module, exports) {
$parcel$export(module.exports, "actions", () => $a0f0b85edac43188$export$e324594224ef24da);

var $9S6CR = parcelRequire("9S6CR");

var $lJNh4 = parcelRequire("lJNh4");

var $5I9mH = parcelRequire("5I9mH");

var $1KHcW = parcelRequire("1KHcW");
const $a0f0b85edac43188$export$e324594224ef24da = {
    setTitle: $9S6CR.setTitle,
    addDocumentTitle: $lJNh4.addDocumentTitle,
    removeDocumentTitle: $5I9mH.removeDocumentTitle,
    updateTitle: $1KHcW.updateTitle
};

});
parcelRegister("9S6CR", function(module, exports) {
$parcel$export(module.exports, "setTitle", () => $320d88e41877c8f5$export$420a7f2fd9cad6f6);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $113FJ = parcelRequire("113FJ");
const $320d88e41877c8f5$export$420a7f2fd9cad6f6 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $113FJ.createTitleFromTemplate)(title, titleTemplate);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("113FJ", function(module, exports) {
$parcel$export(module.exports, "createTitleFromTemplate", () => $37d6a70188bb2483$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $37d6a70188bb2483$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $37d6a70188bb2483$export$7f8be70a0bed1bae);
const $37d6a70188bb2483$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $37d6a70188bb2483$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $37d6a70188bb2483$export$7f8be70a0bed1bae = (symbol, contextArray)=>{
    const lastDocumentTitle = contextArray[contextArray.length - 1];
    if (typeof lastDocumentTitle === 'object' && lastDocumentTitle.symbol === symbol) return true;
    return false;
};

});


parcelRegister("lJNh4", function(module, exports) {
$parcel$export(module.exports, "addDocumentTitle", () => $4db7d6d49153c898$export$a0c188c0ea474bb8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4db7d6d49153c898$export$a0c188c0ea474bb8 = (symbol, title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        title ? contextArray.push({
            title: title,
            symbol: symbol
        }) : contextArray.push(symbol);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("5I9mH", function(module, exports) {
$parcel$export(module.exports, "removeDocumentTitle", () => $f598e58331ddfb34$export$e844009b77f80a72);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f598e58331ddfb34$export$e844009b77f80a72 = (titleSymbol)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: contextArray.filter((titleContext)=>typeof titleContext === 'object' && titleContext.symbol !== titleSymbol)
        });
    };

});

parcelRegister("1KHcW", function(module, exports) {
$parcel$export(module.exports, "updateTitle", () => $1f64cfa843ed7e0d$export$bf6f7165e46e2479);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $113FJ = parcelRequire("113FJ");
const $1f64cfa843ed7e0d$var$generateTitle = (title, titleSuffix)=>{
    const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
    const newTitle = (0, $113FJ.createTitleFromTemplate)(title, titleTemplate);
    return newTitle;
};
const $1f64cfa843ed7e0d$export$bf6f7165e46e2479 = (title, context)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const contextItem = state.contextArray.find((item)=>{
            if (typeof item === 'object') return item.symbol === context;
            return false;
        });
        // If there is no contextItem, it means that the component has been unmounted
        // And we'll just use the last used title from the contextArray
        if (!contextItem && state.contextArray.length) {
            const lastContextItem = state.contextArray[state.contextArray.length - 1];
            let newTitle = '';
            // This will always be an object but we have to check it to make TS happy
            if (typeof lastContextItem === 'object') newTitle = $1f64cfa843ed7e0d$var$generateTitle(lastContextItem.title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
            return;
        }
        if ((0, $113FJ.checkDocumentTitle)(context, state.contextArray)) {
            const newTitle = $1f64cfa843ed7e0d$var$generateTitle(title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
        }
    };

});




parcelRegister("hxAu9", function(module, exports) {
$parcel$export(module.exports, "UiManagers", () => $c70783e9b064ee1e$export$41286c339a88ca24);

var $eJOHy = parcelRequire("eJOHy");

var $gNYyp = parcelRequire("gNYyp");

var $fBBqI = parcelRequire("fBBqI");

var $4cLUT = parcelRequire("4cLUT");
const $c70783e9b064ee1e$var$Filler = ()=>null;
const $c70783e9b064ee1e$var$Nest = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $c70783e9b064ee1e$var$ClientManagerServerVersion = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Filler, {
        for: "SpotLightMaanger"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Nest, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Filler, {
        for: "ModalContextProvider"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Filler, {
        for: "FlagsProvider"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Filler, {
        for: "CrossFlowProvider"
    }));
const $c70783e9b064ee1e$export$41286c339a88ca24 = ({ children: children })=>{
    const ClientUiManagers = !false ? (0, $4cLUT.ClientUiManagers) : $c70783e9b064ee1e$var$ClientManagerServerVersion;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBBqI.LayoutManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNYyp.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ClientUiManagers, null, children)));
};

});
parcelRegister("gNYyp", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbManager", () => $53ba883a1237d88c$export$cd5073909dd92c28);

var $eJOHy = parcelRequire("eJOHy");

var $ifPW4 = parcelRequire("ifPW4");
const $53ba883a1237d88c$export$cd5073909dd92c28 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ifPW4.BreadcrumbContainer), null, children);

});

parcelRegister("fBBqI", function(module, exports) {
$parcel$export(module.exports, "LayoutManager", () => $293ac920f10af9e7$export$4a04ad01c410b415);

var $ae7y7 = parcelRequire("ae7y7");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dfh4P = parcelRequire("dfh4P");

var $kfvK2 = parcelRequire("kfvK2");
var $eJrcF = parcelRequire("eJrcF");

var $6E16M = parcelRequire("6E16M");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $9FYIg = parcelRequire("9FYIg");

var $5hYi1 = parcelRequire("5hYi1");

var $4BzWx = parcelRequire("4BzWx");

var $fZsy4 = parcelRequire("fZsy4");
const $293ac920f10af9e7$var$LayoutContainer = (0, $6E16M.createContainer)((0, $fZsy4.layoutStore), {
    displayName: 'JiraLayoutContainer',
    onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
            dispatch((0, $4BzWx.actions).setIsChromeless(isChromeless));
            dispatch((0, $4BzWx.actions).setLeftSidebarState(leftSidebar));
            dispatch((0, $4BzWx.actions).setRightSidebarState(rightSidebar));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
            dispatch((0, $4BzWx.actions).setIsChromeless(isChromeless));
        }
});
const $293ac920f10af9e7$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
    stackState: []
};
const $293ac920f10af9e7$var$useIsChromeless = (0, $kfvK2.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
const $293ac920f10af9e7$export$4a04ad01c410b415 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('blu-8363-archive-legacy-resource-navigationuistate'), $293ac920f10af9e7$var$LayoutManagerNew, $293ac920f10af9e7$var$LayoutManagerOld);
function $293ac920f10af9e7$var$LayoutManagerNew({ children: children }) {
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $5hYi1.navigationUIStateRelayResource));
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($293ac920f10af9e7$var$LayoutManagerNewWithQuery, {
        queryReference: queryReference
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($293ac920f10af9e7$var$LayoutManagerNewContent, null, children);
}
function $293ac920f10af9e7$var$LayoutManagerNewWithQuery({ children: children, queryReference: queryReference }) {
    const data = (0, $j4oe4.usePreloadedQuery)((0, $ae7y7.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($293ac920f10af9e7$var$LayoutManagerNewContent, {
        isLeftSidebarCollapsed: data?.jira?.navigationUIState?.isLeftSidebarCollapsed,
        leftSidebarWidth: data?.jira?.navigationUIState?.leftSidebarWidth
    }, children);
}
function $293ac920f10af9e7$var$LayoutManagerNewContent({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth }) {
    const isChromeless = $293ac920f10af9e7$var$useIsChromeless();
    const leftSidebar = (0, $eJOHy.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed ?? false,
            width: leftSidebarWidth ?? (0, $fZsy4.DEFAULT_LEFT_SIDEBAR_WIDTH),
            isFlyoutOpen: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($293ac920f10af9e7$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $293ac920f10af9e7$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
}
function $293ac920f10af9e7$var$LayoutManagerOld({ children: children }) {
    const { data: data } = (0, $eJrcF.useResource)((0, $dfh4P.navigationUiStateResource));
    const isChromeless = $293ac920f10af9e7$var$useIsChromeless();
    const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
    const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $fZsy4.DEFAULT_LEFT_SIDEBAR_WIDTH);
    const leftSidebar = (0, $eJOHy.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed,
            width: leftSidebarWidth,
            isFlyoutOpen: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($293ac920f10af9e7$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $293ac920f10af9e7$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
}

});

parcelRegister("4cLUT", function(module, exports) {
$parcel$export(module.exports, "ClientUiManagers", () => $5d953a9b6bf2524b$export$d1db6ae5bf84e489);

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");

var $101p7 = parcelRequire("101p7");

var $emaA9 = parcelRequire("emaA9");

var $dFtHW = parcelRequire("dFtHW");

var $cSXp8 = parcelRequire("cSXp8");

var $iOVHp = parcelRequire("iOVHp");

var $1gHmu = parcelRequire("1gHmu");

var $9pWNg = parcelRequire("9pWNg");
const $5d953a9b6bf2524b$export$d1db6ae5bf84e489 = ({ children: children })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emaA9.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9pWNg.ProjectCreateDrawerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeProvider), {
        onShowFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $101p7.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iOVHp.ModalContextProvider), null, children)))))));
};

});
parcelRegister("emaA9", function(module, exports) {
$parcel$export(module.exports, "CrossFlowProvider", () => $223acf4d26345749$export$d900e4062895cd7c);

var $eJOHy = parcelRequire("eJOHy");

var $h8qGc = parcelRequire("h8qGc");

var $2Mqjh = parcelRequire("2Mqjh");

var $cHtIB = parcelRequire("cHtIB");

var $1M2hR = parcelRequire("1M2hR");

var $lXldF = parcelRequire("lXldF");

var $kFfY1 = parcelRequire("kFfY1");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $223acf4d26345749$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendUIEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendOperationalEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendTrackEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendScreenEvent: ()=>{}
    }) : (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $223acf4d26345749$export$d900e4062895cd7c = ({ children: children })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const locale = (0, $1M2hR.useLocale)();
    const analyticsClient = (0, $eJOHy.useMemo)(()=>$223acf4d26345749$var$getAnalyticsInstance(), []);
    const plugins = (0, $eJOHy.useMemo)(()=>[
            (0, $lXldF.getContainersPlugin),
            (0, $kFfY1.getUsersPlugin)
        ], []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8qGc.default), {
        cloudId: cloudId,
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
        analyticsClient: analyticsClient,
        locale: locale,
        plugins: plugins
    }, children);
};

});
parcelRegister("h8qGc", function(module, exports) {
$parcel$export(module.exports, "default", () => $fca31a7988a3255f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9J8Uh = parcelRequire("9J8Uh");

const $fca31a7988a3255f$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9J8Uh.CrossFlowProvider), {
        ...props,
        originProduct: "jira"
    });
};
var $fca31a7988a3255f$export$2e2bcd8739ae039 = $fca31a7988a3255f$var$JiraProvider;

});
parcelRegister("9J8Uh", function(module, exports) {
$parcel$export(module.exports, "CrossFlowProvider", () => $d7c625e4a7933c7b$export$d900e4062895cd7c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("6X7AJ");
var $cqw6Y = parcelRequire("cqw6Y");
var $iE1pm = parcelRequire("iE1pm");

var $01wZP = parcelRequire("01wZP");

var $kv8GX = parcelRequire("kv8GX");

var $7u7CD = parcelRequire("7u7CD");

var $56sZh = parcelRequire("56sZh");

var $1fIHo = parcelRequire("1fIHo");

var $23k75 = parcelRequire("23k75");

var $aJYee = parcelRequire("aJYee");

var $d6U9Q = parcelRequire("d6U9Q");

const $d7c625e4a7933c7b$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("i5o6f")));
const $d7c625e4a7933c7b$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $eJOHy.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $eJOHy.useState)(false);
        const fireEvent = (0, $eJOHy.useMemo)(()=>(0, $kv8GX.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $eJOHy.useState)();
        const onAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
            const gasV3Event = (0, $7u7CD.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $aJYee.enrichWithRequestOptions)((0, $23k75.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $eJOHy.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                        action: (0, $d6U9Q.uiInitialized),
                        actionSubject: (0, $d6U9Q.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $d6U9Q.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $eJOHy.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $aJYee.enrichWithRequestOptions)({
                    eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                    action: (0, $d6U9Q.openInvoked),
                    actionSubject: (0, $d6U9Q.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $d6U9Q.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $iE1pm.Journeys).GET_STARTED && redirectToWac) {
                (0, $56sZh.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $eJOHy.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $01wZP.default)();
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cqw6Y.BaseCrossFlowApiProvider), {
            onOpen: onOpen,
            children: [
                children,
                requestOptions && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fIHo.ErrorBoundary), {
                    onAnalyticsEvent: onAnalyticsEvent,
                    onError: onError,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)(IntegrationView, {
                            ...baseProviderProps,
                            ...requestOptions,
                            onAnalyticsEvent: onAnalyticsEvent,
                            originProduct: originProduct,
                            theme: colorMode,
                            onClose: onClose,
                            onHandShake: onHandShake,
                            plugins: plugins,
                            env: env,
                            redirectToWac: redirectToWac,
                            zIndex: requestOptions.zIndex ?? 1000
                        })
                    })
                })
            ]
        });
    };
const $d7c625e4a7933c7b$export$d900e4062895cd7c = $d7c625e4a7933c7b$export$79d79d8dd8574306($d7c625e4a7933c7b$var$IntegrationView);

});
parcelRegister("kv8GX", function(module, exports) {
$parcel$export(module.exports, "analyticsWrapper", () => $1de9f7e5167fed77$export$91b4dd3bfc301325);

const $1de9f7e5167fed77$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $d6f34b7bd34f6138$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});

parcelRegister("7u7CD", function(module, exports) {
$parcel$export(module.exports, "transformEvent", () => $fe4a3ff4748c4a3a$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $fe4a3ff4748c4a3a$var$GROWTH_TAG = 'growth';
const $fe4a3ff4748c4a3a$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $fe4a3ff4748c4a3a$var$getSources = (context)=>$fe4a3ff4748c4a3a$var$extractFromEventContext([
        'source'
    ], context);
const $fe4a3ff4748c4a3a$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $fe4a3ff4748c4a3a$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $fe4a3ff4748c4a3a$var$last = (values)=>values[values.length - 1];
const $fe4a3ff4748c4a3a$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $fe4a3ff4748c4a3a$var$getSources(context);
    const source = $fe4a3ff4748c4a3a$var$last(sources) || (0, $d6f34b7bd34f6138$export$b055de0e665cb20c);
    const extraAttributes = $fe4a3ff4748c4a3a$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $fe4a3ff4748c4a3a$var$last($fe4a3ff4748c4a3a$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($fe4a3ff4748c4a3a$var$GROWTH_TAG);
    switch(eventType){
        case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
        case 0, $d6f34b7bd34f6138$export$12346a674644c156:
        case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("56sZh", function(module, exports) {
$parcel$export(module.exports, "setProductSignUpLocation", () => $49904e9b59b239f8$export$2827e2473cb9a346);
parcelRequire("dNnxZ");
var $6UCnr = parcelRequire("6UCnr");


var $c8ehd = parcelRequire("c8ehd");
const $49904e9b59b239f8$var$utmCampaignMap = {
    'atlassian-switcher': (0, $c8ehd.UtmCampaign)['atlassian-switcher']
};
const $49904e9b59b239f8$var$isBundledProduct = (productKey)=>{
    return [
        (0, $6UCnr.Targets).JIRA_SOFTWARE,
        (0, $6UCnr.Targets).JIRA_SERVICE_DESK,
        (0, $6UCnr.Targets).JIRA_CORE,
        (0, $6UCnr.Targets).CONFLUENCE
    ].includes(productKey);
};
const $49904e9b59b239f8$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $6UCnr.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $6UCnr.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $6UCnr.Targets).JIRA_CORE]: 'jira-core',
        [(0, $6UCnr.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $49904e9b59b239f8$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $6UCnr.Targets).OPSGENIE
    ].includes(productKey);
};
const $49904e9b59b239f8$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $6UCnr.Targets).OPSGENIE]: (0, $df52bd46e2c36aaa$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $49904e9b59b239f8$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($49904e9b59b239f8$var$utmCampaignMap[sourceComponent]);
};
const $49904e9b59b239f8$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $49904e9b59b239f8$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$49904e9b59b239f8$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $49904e9b59b239f8$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $df52bd46e2c36aaa$export$c37558e5c67d2b01) : (0, $df52bd46e2c36aaa$export$f199baf8dfc7621e);
    const utmParams = $49904e9b59b239f8$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $df52bd46e2c36aaa$export$2a45a00073911255);
    if ($49904e9b59b239f8$var$isBundledProduct(productKey)) {
        path = (0, $df52bd46e2c36aaa$export$e6c04a1dd86d1c14);
        bundleParams = $49904e9b59b239f8$var$getBundleSignUpParams(productKey);
    } else if ($49904e9b59b239f8$var$isProductWithCustomSignUpPath(productKey)) path = $49904e9b59b239f8$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $49904e9b59b239f8$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $49904e9b59b239f8$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
const $df52bd46e2c36aaa$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $df52bd46e2c36aaa$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $df52bd46e2c36aaa$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $df52bd46e2c36aaa$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $df52bd46e2c36aaa$export$2a45a00073911255 = '/software';

parcelRegister("c8ehd", function(module, exports) {
$parcel$export(module.exports, "UtmCampaign", () => $e9a6972909bb32cc$export$fc604aa353a97e10);
var $e9a6972909bb32cc$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});

});


parcelRegister("1fIHo", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $fb099ca96fedc82f$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $d6U9Q = parcelRequire("d6U9Q");
const $fb099ca96fedc82f$var$name = "platform-pkg";
const $fb099ca96fedc82f$var$version = "0.0.0-use.local";
const $fb099ca96fedc82f$var$payload = {
    eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
    action: (0, $d6U9Q.errorBoundaryAction),
    actionSubject: (0, $d6U9Q.errorBoundaryActionSubject)
};
const $fb099ca96fedc82f$var$context = [
    {
        source: $d6U9Q.source
    },
    {
        packageName: $fb099ca96fedc82f$var$name,
        packageVersion: $fb099ca96fedc82f$var$version
    }
];
class $fb099ca96fedc82f$export$e926676385687eaf extends (0, $eJOHy.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $fb099ca96fedc82f$var$payload,
            context: $fb099ca96fedc82f$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}

});
parcelRegister("d6U9Q", function(module, exports) {
$parcel$export(module.exports, "source", () => $40d07c1e93f6db8f$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $40d07c1e93f6db8f$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $40d07c1e93f6db8f$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $40d07c1e93f6db8f$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $40d07c1e93f6db8f$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $40d07c1e93f6db8f$export$e67cdcb8867a3bd0);

const $40d07c1e93f6db8f$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $40d07c1e93f6db8f$export$9d8252a268f4fa72 = 'errorCaught';
const $40d07c1e93f6db8f$export$1045419caf49b395 = 'errorBoundary';
const $40d07c1e93f6db8f$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $40d07c1e93f6db8f$export$e5c2c058fa8068a6 = 'uiInitialized';
const $40d07c1e93f6db8f$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("23k75", function(module, exports) {
$parcel$export(module.exports, "enrichWithPackageDetails", () => $22b704f1c4b6b410$export$59518efab336a8b5);
const $22b704f1c4b6b410$var$version = "0.0.0-use.local";
const $22b704f1c4b6b410$export$84f9cf7ef89d4c26 = {
    version: $22b704f1c4b6b410$var$version
};
const $22b704f1c4b6b410$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $22b704f1c4b6b410$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("aJYee", function(module, exports) {
$parcel$export(module.exports, "enrichWithRequestOptions", () => $55c9a4c54826d80f$export$a5a156dc5df42f0);
const $55c9a4c54826d80f$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("i5o6f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ezeQU")
]).then(()=>parcelRequire('cOUBv'));

});



parcelRegister("lXldF", function(module, exports) {
$parcel$export(module.exports, "getContainersPlugin", () => $5b0f94b5f2363f0d$export$81d1d40061d190bc);
parcelRequire("4gAxB");
var $8HrA4 = parcelRequire("8HrA4");
var $4gAxB = parcelRequire("4gAxB");

var $aYncF = parcelRequire("aYncF");
const $5b0f94b5f2363f0d$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $8HrA4.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $8HrA4.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $5b0f94b5f2363f0d$export$81d1d40061d190bc = (0, $4gAxB.createGetContainersPlugin)($5b0f94b5f2363f0d$var$getCloudId);

});
parcelRegister("4gAxB", function(module, exports) {
$parcel$export(module.exports, "createGetContainersPlugin", () => $0dc0e9de4c405a47$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $0dc0e9de4c405a47$export$8feb7eae83cf8cd5);
$parcel$export(module.exports, "ContainerTypes", () => (parcelRequire("8HrA4")).ContainerTypes);
$parcel$export(module.exports, "UserIdTypes", () => (parcelRequire("8HrA4")).UserIdTypes);

var $8HrA4 = parcelRequire("8HrA4");
const $0dc0e9de4c405a47$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $8HrA4.PluginTypes).GetContainers,
        fetch
    ];
};
const $0dc0e9de4c405a47$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $8HrA4.PluginTypes).GetUsers,
        fetch
    ];
};
const $0dc0e9de4c405a47$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $8HrA4.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $0dc0e9de4c405a47$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $8HrA4.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("8HrA4", function(module, exports) {
$parcel$export(module.exports, "PluginTypes", () => $40d3667eff3d5aed$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $40d3667eff3d5aed$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $40d3667eff3d5aed$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $40d3667eff3d5aed$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $40d3667eff3d5aed$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $40d3667eff3d5aed$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $40d3667eff3d5aed$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("kFfY1", function(module, exports) {
$parcel$export(module.exports, "getUsersPlugin", () => $14708db97c3990f1$export$7c44908d2777db01);

var $4gAxB = parcelRequire("4gAxB");
var $8HrA4 = parcelRequire("8HrA4");
const $14708db97c3990f1$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $8HrA4.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $14708db97c3990f1$export$7c44908d2777db01 = (0, $4gAxB.createGetUsersPlugin)($14708db97c3990f1$var$getUsers);

});


parcelRegister("iOVHp", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $0dd8465d29e789ed$export$7c9538f5f3c365e9);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $7lK6t = parcelRequire("7lK6t");
const $0dd8465d29e789ed$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $eJOHy.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $eJOHy.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $0dd8465d29e789ed$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $eJOHy.useRef)(1);
    const [modals, setModals] = (0, $eJOHy.useState)([]);
    const modalContext = (0, $eJOHy.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lK6t.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, modals.map((modal)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0dd8465d29e789ed$var$RenderModal, {
            key: modal.key,
            modal: modal
        });
    })));
}

});



parcelRegister("2pOx9", function(module, exports) {
$parcel$export(module.exports, "UserContainers", () => $291f37c68c8832ac$export$c1b371eec908681a);

var $eJOHy = parcelRequire("eJOHy");

var $exvGe = parcelRequire("exvGe");

var $c9f6v = parcelRequire("c9f6v");
const $291f37c68c8832ac$export$c1b371eec908681a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9f6v.UserContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $exvGe.UserPreferencesContainer), {
        isGlobal: true
    }, children));

});
parcelRegister("exvGe", function(module, exports) {
$parcel$export(module.exports, "UserPreferencesContainer", () => $32653931dc796f02$export$aa278641ded1adf);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $ht3nQ = parcelRequire("ht3nQ");

var $6Wa1P = parcelRequire("6Wa1P");
const $32653931dc796f02$export$be74e04eaea4530 = (0, $ht3nQ.createSubscriber)((0, $6Wa1P.default), {
    displayName: 'UserPreferencesSubscriber'
});
const $32653931dc796f02$export$aa278641ded1adf = (0, $6E16M.createContainer)((0, $6Wa1P.default));

});
parcelRegister("6Wa1P", function(module, exports) {
$parcel$export(module.exports, "default", () => $10c3f4f356fe3b4a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $8XoVi = parcelRequire("8XoVi");
const $10c3f4f356fe3b4a$var$initialState = {
    'issue-view-experiment': {
        data: {
            value: false
        },
        loading: false,
        error: null
    }
};
var // @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")>>'.
$10c3f4f356fe3b4a$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'user-preference',
    initialState: $10c3f4f356fe3b4a$var$initialState,
    actions: $8XoVi
});

});
parcelRegister("8XoVi", function(module, exports) {
$parcel$export(module.exports, "fetch", () => (parcelRequire("1VzWr")).default);
$parcel$export(module.exports, "fetchIssueCreate", () => (parcelRequire("3PeHv")).default);
$parcel$export(module.exports, "updateExperiment", () => (parcelRequire("eSwk7")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $1VzWr = parcelRequire("1VzWr");

var $3PeHv = parcelRequire("3PeHv");

var $eSwk7 = parcelRequire("eSwk7");

});
parcelRegister("1VzWr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2074ff714333c08$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6Gokh = parcelRequire("6Gokh");
/**
 * Initiates data retrieval for a user preference, ensuring no duplicate requests are made.
 * Updates the application state with retrieved data or an error, accordingly.
 */ const $e2074ff714333c08$var$fetchData = (preferenceKey)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
        setState({
            [preferenceKey]: {
                data: currentState.data,
                loading: true,
                error: null
            }
        });
        try {
            const data = await (0, $6Gokh.default)({
                preferenceKey: preferenceKey
            });
            setState({
                [preferenceKey]: {
                    data: data,
                    loading: false,
                    error: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                [preferenceKey]: {
                    data: getState().data,
                    loading: false,
                    error: err
                }
            });
        }
    };
var $e2074ff714333c08$export$2e2bcd8739ae039 = $e2074ff714333c08$var$fetchData;

});
parcelRegister("6Gokh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9dd397dac673eb5$export$2e2bcd8739ae039);

var $j4vKK = parcelRequire("j4vKK");
const $d9dd397dac673eb5$var$getData = async ({ preferenceKey: preferenceKey })=>{
    try {
        const result = await (0, $j4vKK.fetchData)(preferenceKey);
        return {
            value: result
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.statusCode === 404) return {
            value: undefined
        };
        throw e;
    }
};
var $d9dd397dac673eb5$export$2e2bcd8739ae039 = $d9dd397dac673eb5$var$getData;

});
parcelRegister("j4vKK", function(module, exports) {
$parcel$export(module.exports, "fetchData", () => $d0f15c4264be95bd$export$8134c072fddab6a5);

var $3ugTQ = parcelRequire("3ugTQ");
const $d0f15c4264be95bd$export$8134c072fddab6a5 = (key)=>{
    const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
    return (0, $3ugTQ.performGetRequest)(requestUrl);
};

});



parcelRegister("3PeHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa84bc4b0ad6e6a2$export$2e2bcd8739ae039);

var $1VzWr = parcelRequire("1VzWr");
const $aa84bc4b0ad6e6a2$var$fetchIssueCreate = ()=>(0, $1VzWr.default)('issue-create');
var $aa84bc4b0ad6e6a2$export$2e2bcd8739ae039 = $aa84bc4b0ad6e6a2$var$fetchIssueCreate;

});

parcelRegister("eSwk7", function(module, exports) {
$parcel$export(module.exports, "default", () => $480202df9bc0845f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $480202df9bc0845f$var$updateExperiment = (experimentKey, value)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
        setState({
            [experimentKey]: {
                data: {
                    value: value
                },
                loading: false,
                error: null
            }
        });
    };
var $480202df9bc0845f$export$2e2bcd8739ae039 = $480202df9bc0845f$var$updateExperiment;

});





parcelRegister("gOC9D", function(module, exports) {
$parcel$export(module.exports, "LinkingProviders", () => $e619cded00452e61$export$a7964d2bf9ff001);

var $eJOHy = parcelRequire("eJOHy");

var $h1NUD = parcelRequire("h1NUD");

var $2aY2d = parcelRequire("2aY2d");

var $4cTDP = parcelRequire("4cTDP");

var $6bLlX = parcelRequire("6bLlX");

var $cHtIB = parcelRequire("cHtIB");

var $03tSb = parcelRequire("03tSb");

var $idqmr = parcelRequire("idqmr");
const $e619cded00452e61$export$a7964d2bf9ff001 = ({ children: children })=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const product = $e619cded00452e61$var$getProductForSmartCardProvider(data);
    const atlassianIntelligenceProps = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $4cTDP.fg)('jira-cc-ai-snippet-gate') || !data?.isAIEnabled) return {};
        return {
            renderers: {
                snippet: (0, $idqmr.JiraSnippetRenderer)
            }
        };
    }, [
        data?.isAIEnabled
    ]);
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('jira-glance-panel') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const smartCardProviderProps = (0, $6bLlX.useGlobalObjectPreviewPanels)();
        if ((0, $4cTDP.fg)('jira-preview-panel-confluence-integration')) {
            const open = smartCardProviderProps.openPreviewPanel;
            // Create a wrapper function that updates the preview panel URL
            // This is used for custom domains to update to the correct content URL and avoid CSP issues
            // eslint-disable-next-line react-hooks/react-compiler
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const openPreviewPanelWithModifiedURL = (0, $eJOHy.useMemo)(()=>(props)=>open({
                        ...props,
                        url: (0, $03tSb.getCorrectContentURL)(cloudId, props.url, props.ari),
                        ari: props.ari
                    }), [
                open,
                cloudId
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1NUD.SmartCardProvider), {
                ...smartCardProviderProps,
                openPreviewPanel: openPreviewPanelWithModifiedURL,
                product: product,
                isAdminHubAIEnabled: data?.isAIEnabled ?? false,
                ...atlassianIntelligenceProps
            }, children);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1NUD.SmartCardProvider), {
            ...smartCardProviderProps,
            product: product,
            isAdminHubAIEnabled: data?.isAIEnabled ?? false,
            ...atlassianIntelligenceProps
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1NUD.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: data?.isAIEnabled ?? false,
        ...atlassianIntelligenceProps
    }, children);
};
const $e619cded00452e61$var$getProductForSmartCardProvider = (project)=>{
    switch(project?.projectType){
        case 'software':
            return 'JSW';
        case 'business':
            return 'JWM';
        case 'service_desk':
            return 'JSM';
        case 'product_discovery':
            return 'JPD';
        default:
            return undefined;
    }
};

});
parcelRegister("h1NUD", function(module, exports) {
$parcel$export(module.exports, "SmartCardProvider", () => $9674f58f5103009b$export$497ecb0280204df4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7HHI1 = parcelRequire("7HHI1");

var $1O6Yz = parcelRequire("1O6Yz");

var $9NiLY = parcelRequire("9NiLY");

var $hy9OT = parcelRequire("hy9OT");

var $gfzBL = parcelRequire("gfzBL");

var $9kfy2 = parcelRequire("9kfy2");

var $3KDr5 = parcelRequire("3KDr5");
function $9674f58f5103009b$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel }) {
    const parentContext = (0, $eJOHy.useContext)((0, $9kfy2.SmartCardContext));
    const defaultInitialState = (0, $eJOHy.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eJOHy.useMemo)(()=>{
        return (0, $7HHI1.createStore)((0, $gfzBL.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eJOHy.useMemo)(()=>{
        const client = customClient || new (0, $3KDr5.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        _platform)=>{
            const cardState = (0, $9NiLY.getUrl)(store, url);
            return cardState.details ? (0, $hy9OT.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        store
    ]);
    const value = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9kfy2.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $9674f58f5103009b$export$2e2bcd8739ae039 = $9674f58f5103009b$export$497ecb0280204df4;

});
parcelRegister("9NiLY", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $ab3ef581aa51838e$export$94df0e59ebebf4a7);
const $ab3ef581aa51838e$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("hy9OT", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkTitle", () => $27694d81d2f2dfcb$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $27694d81d2f2dfcb$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $27694d81d2f2dfcb$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $27694d81d2f2dfcb$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $27694d81d2f2dfcb$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $27694d81d2f2dfcb$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $27694d81d2f2dfcb$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $27694d81d2f2dfcb$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $27694d81d2f2dfcb$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $27694d81d2f2dfcb$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $27694d81d2f2dfcb$export$96ed4c1b14ac210a);

var $9R3Jd = parcelRequire("9R3Jd");
var $1IwHM = parcelRequire("1IwHM");
var $9T6dQ = parcelRequire("9T6dQ");
var $3seWH = parcelRequire("3seWH");
var $aHgka = parcelRequire("aHgka");
var $hdxEk = parcelRequire("hdxEk");
var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");

var $6OR2o = parcelRequire("6OR2o");

var $3jSKi = parcelRequire("3jSKi");
const $27694d81d2f2dfcb$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.displayName;
    return (0, $8T839.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $27694d81d2f2dfcb$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.url;
    return (0, $3seWH.extractLink)(response?.data);
};
const $27694d81d2f2dfcb$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.ari || (0, $3jSKi.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $9R3Jd.extractAri)(data);
};
const $27694d81d2f2dfcb$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $3jSKi.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $6OR2o.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $27694d81d2f2dfcb$export$ff753ed519e96e9e = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return response?.data && (0, $9Thyx.extractProvider)(response?.data);
};
const $27694d81d2f2dfcb$export$7a685df468cbf38f = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    return response?.data && (0, $1IwHM.extractDateCreated)(response.data);
};
const $27694d81d2f2dfcb$export$75047940e157fd1f = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $9T6dQ.extractDateUpdated)(response.data);
};
const $27694d81d2f2dfcb$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $aHgka.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $27694d81d2f2dfcb$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $aHgka.extractPersonCreatedBy)(response.data);
};
const $27694d81d2f2dfcb$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $hdxEk.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $27694d81d2f2dfcb$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};

});
parcelRegister("9R3Jd", function(module, exports) {
$parcel$export(module.exports, "extractAri", () => $8b174f4749aef8f6$export$be18a6294fd426ec);
const $8b174f4749aef8f6$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};

});

parcelRegister("1IwHM", function(module, exports) {
$parcel$export(module.exports, "extractDateCreated", () => $9bce2094467d007a$export$e1226a5e0bbbf862);
const $9bce2094467d007a$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};

});

parcelRegister("9T6dQ", function(module, exports) {
$parcel$export(module.exports, "extractDateUpdated", () => $ab4b85685fa6a4de$export$7fc2f5e6f9d22ae7);
const $ab4b85685fa6a4de$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};

});

parcelRegister("3seWH", function(module, exports) {
$parcel$export(module.exports, "extractLink", () => $6f5194fe1d549fab$export$63f54cf4c5883620);

var $jo2Je = parcelRequire("jo2Je");
const $6f5194fe1d549fab$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $jo2Je.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};

});
parcelRegister("jo2Je", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $9fd708127ba15a99$export$396ba4ef2e37dc65);
const $9fd708127ba15a99$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $9fd708127ba15a99$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};

});


parcelRegister("aHgka", function(module, exports) {
$parcel$export(module.exports, "extractPersonCreatedBy", () => $537f0d3ea3fbcfb9$export$a66235cba0c9d11a);

var $9JeZK = parcelRequire("9JeZK");
const $537f0d3ea3fbcfb9$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});
parcelRegister("9JeZK", function(module, exports) {
$parcel$export(module.exports, "extractPersonFromJsonLd", () => $a634170ae128bef4$export$c471ae5fddcf1392);

var $4moW4 = parcelRequire("4moW4");
const $a634170ae128bef4$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $4moW4.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};

});
parcelRegister("4moW4", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $74d023e64fe83956$export$67f3d92c824fd850);

var $jo2Je = parcelRequire("jo2Je");
const $74d023e64fe83956$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};

});



parcelRegister("hdxEk", function(module, exports) {
$parcel$export(module.exports, "extractPersonUpdatedBy", () => $9b8725aa10ec9f20$export$8a2d1ed7e6f336f0);

var $9JeZK = parcelRequire("9JeZK");
const $9b8725aa10ec9f20$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};

});

parcelRegister("9Thyx", function(module, exports) {
$parcel$export(module.exports, "extractProvider", () => $af479a3c34473181$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $af479a3c34473181$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $af479a3c34473181$export$38df542ff03a4183);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $lgMTT = parcelRequire("lgMTT");

var $eGOwo = parcelRequire("eGOwo");


var $4moW4 = parcelRequire("4moW4");
var $jo2Je = parcelRequire("jo2Je");
const $af479a3c34473181$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $af479a3c34473181$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $af479a3c34473181$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $af479a3c34473181$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $9f5235d88a87be7c$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $9f5235d88a87be7c$export$f654d825189934a7)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return undefined;
};
const $af479a3c34473181$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $af479a3c34473181$export$38df542ff03a4183 = (id)=>{
    return id === (0, $9f5235d88a87be7c$export$cee224b5de4d6d66);
};

});
const $9f5235d88a87be7c$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $9f5235d88a87be7c$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $9f5235d88a87be7c$export$84a73a0383f58180 = 'JiraTask';
const $9f5235d88a87be7c$export$c6c83963a9378a67 = 'JiraSubTask';
const $9f5235d88a87be7c$export$58af3c426c111a6d = 'JiraStory';
const $9f5235d88a87be7c$export$ac9898a63417219e = 'JiraBug';
const $9f5235d88a87be7c$export$54db5e3fb12e39cd = 'JiraEpic';
const $9f5235d88a87be7c$export$2f54a5a217202c85 = 'JiraIncident';
const $9f5235d88a87be7c$export$d097371052bfc411 = 'JiraServiceRequest';
const $9f5235d88a87be7c$export$efd9452ad16c6676 = 'JiraChange';
const $9f5235d88a87be7c$export$2e7e70abb5d81f67 = 'JiraProblem';
const $9f5235d88a87be7c$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("8T839", function(module, exports) {
$parcel$export(module.exports, "extractTitle", () => $8cab052601305f86$export$b05803156e5015b6);

var $inXgt = parcelRequire("inXgt");

var $dpM2S = parcelRequire("dpM2S");
const $8cab052601305f86$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $inXgt.extractContext)(jsonLd);
    const type = (0, $dpM2S.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("inXgt", function(module, exports) {
$parcel$export(module.exports, "extractContext", () => $1424377282a92e98$export$efdbd45f3e77a161);

var $dpM2S = parcelRequire("dpM2S");

var $4moW4 = parcelRequire("4moW4");
const $1424377282a92e98$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $4moW4.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $dpM2S.extractType)(context)
            };
        }
    }
    return undefined;
};

});
parcelRegister("dpM2S", function(module, exports) {
$parcel$export(module.exports, "extractType", () => $f106af885ce6cc9e$export$2e9ae379995d99e3);
const $f106af885ce6cc9e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};

});



parcelRegister("6OR2o", function(module, exports) {
$parcel$export(module.exports, "extractPreview", () => $b7d97bd8e95d8e87$export$4b0d98b1b7f6d115);

var $dToaf = parcelRequire("dToaf");

var $jo2Je = parcelRequire("jo2Je");
const $b7d97bd8e95d8e87$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $dToaf.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $jo2Je.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $jo2Je.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};

});
parcelRegister("dToaf", function(module, exports) {
$parcel$export(module.exports, "extractPlatformIsSupported", () => $74d23019aa5430ff$export$3e8ad908070b68b2);
const $74d23019aa5430ff$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("3jSKi", function(module, exports) {
$parcel$export(module.exports, "extractEntity", () => $315a3a5639bc1399$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $315a3a5639bc1399$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityEmbedUrl", () => $315a3a5639bc1399$export$f97663ee76ac5b24);
$parcel$export(module.exports, "extractEntityProvider", () => $315a3a5639bc1399$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $315a3a5639bc1399$export$19346520e937a99f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $lgMTT = parcelRequire("lgMTT");

var $eGOwo = parcelRequire("eGOwo");

const $315a3a5639bc1399$export$8beff7405d020ddf = (response)=>response?.entityData;
const $315a3a5639bc1399$export$c7168210b81d9383 = (response)=>Boolean($315a3a5639bc1399$export$8beff7405d020ddf(response));
const $315a3a5639bc1399$export$f97663ee76ac5b24 = (response)=>{
    const entity = $315a3a5639bc1399$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $315a3a5639bc1399$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $9f5235d88a87be7c$export$cee224b5de4d6d66:
            providerIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $9f5235d88a87be7c$export$f654d825189934a7:
            providerIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $315a3a5639bc1399$export$19346520e937a99f = (response)=>{
    const entity = $315a3a5639bc1399$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
    return {
        url: url,
        label: entity?.displayName
    };
};

});


parcelRegister("gfzBL", function(module, exports) {
$parcel$export(module.exports, "cardReducer", () => $9b36a0a37eedded2$export$3c7c3113a97b6492);

var $ggoTr = parcelRequire("ggoTr");
var $4g7cp = parcelRequire("4g7cp");
const $9b36a0a37eedded2$var$isCardAction = (action)=>{
    return [
        (0, $ggoTr.ACTION_PENDING),
        (0, $ggoTr.ACTION_RESOLVING),
        (0, $ggoTr.ACTION_RESOLVED),
        (0, $ggoTr.ACTION_RELOADING),
        (0, $ggoTr.ACTION_ERROR),
        (0, $ggoTr.ACTION_ERROR_FALLBACK),
        (0, $ggoTr.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $9b36a0a37eedded2$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4g7cp.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $9b36a0a37eedded2$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $ggoTr.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $ggoTr.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $ggoTr.ACTION_RESOLVED:
            return $9b36a0a37eedded2$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $ggoTr.ACTION_RELOADING:
            return $9b36a0a37eedded2$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $ggoTr.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $ggoTr.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $ggoTr.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $9b36a0a37eedded2$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$9b36a0a37eedded2$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $9b36a0a37eedded2$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("ggoTr", function(module, exports) {
$parcel$export(module.exports, "ACTION_PENDING", () => $614f754b0a09058a$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $614f754b0a09058a$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $614f754b0a09058a$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $614f754b0a09058a$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $614f754b0a09058a$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $614f754b0a09058a$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $614f754b0a09058a$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $614f754b0a09058a$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $614f754b0a09058a$export$6e470aad5ba8952e = 'pending';
const $614f754b0a09058a$export$9a6a932a0a39498e = 'resolving';
const $614f754b0a09058a$export$63ec8bc7a8a75482 = 'resolved';
const $614f754b0a09058a$export$b8cfaa842c9ab487 = 'reloading';
const $614f754b0a09058a$export$6d8ed3f9433dd372 = 'errored';
const $614f754b0a09058a$export$cfbbb7126bc8a0c6 = 'fallback';
const $614f754b0a09058a$export$76b5c1aca20759c6 = 'preload';
const $614f754b0a09058a$export$2c5edb971b673330 = 'metadata';
const $614f754b0a09058a$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4g7cp", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $09aa029e7109943c$export$b70265791d2079d4);
const $09aa029e7109943c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $09aa029e7109943c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $09aa029e7109943c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("9kfy2", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $fc76586a45127857$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $fc76586a45127857$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $fc76586a45127857$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $fc76586a45127857$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $fc76586a45127857$export$2a29ca11e08dc129);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $fc76586a45127857$export$156b523e63b4f63a = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $fc76586a45127857$export$e1d190b530cf0ee9() {
    const context = (0, $eJOHy.useContext)($fc76586a45127857$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $fc76586a45127857$export$10e9cca30e50f657 = ()=>$fc76586a45127857$var$useContextMemoized($fc76586a45127857$export$156b523e63b4f63a);
const $fc76586a45127857$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $fc76586a45127857$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
function $fc76586a45127857$var$useContextMemoized(reactContext) {
    const value = (0, $eJOHy.useContext)(reactContext);
    const context = (0, $eJOHy.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $fc76586a45127857$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $fc76586a45127857$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $fc76586a45127857$export$2e2bcd8739ae039 = $fc76586a45127857$export$156b523e63b4f63a;

});

parcelRegister("3KDr5", function(module, exports) {
$parcel$export(module.exports, "default", () => $781ea1495c21f2d0$export$2e2bcd8739ae039);

var $79KwK = parcelRequire("79KwK");

var $cbSL1 = parcelRequire("cbSL1");

var $6lERA = parcelRequire("6lERA");

var $7sKFl = parcelRequire("7sKFl");

var $4pUJe = parcelRequire("4pUJe");
var $a5MXk = parcelRequire("a5MXk");
var $4g7cp = parcelRequire("4g7cp");
var $hhFie = parcelRequire("hhFie");

var $ZyWbK = parcelRequire("ZyWbK");

var $7xkt0 = parcelRequire("7xkt0");

var $jOCpp = parcelRequire("jOCpp");

var $eGOwo = parcelRequire("eGOwo");
const $781ea1495c21f2d0$var$MAX_BATCH_SIZE = 50;
const $781ea1495c21f2d0$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $781ea1495c21f2d0$var$URL_RESPONSE_CACHE_SIZE = 100;
const $781ea1495c21f2d0$export$d6a66073b5d79eb3 = new (0, $7xkt0.LRUMap)($781ea1495c21f2d0$var$URL_RESPONSE_CACHE_SIZE);
class $781ea1495c21f2d0$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...(0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $hhFie.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $hhFie.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $ZyWbK.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...(0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $hhFie.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $hhFie.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $ZyWbK.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $a5MXk.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    /**
	 * Set custom headers to be sent with each request to the resolver.
	 *
	 * @param headers - Object containing headers to be sent with each request.
	 */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($7sKFl)))({
            limit: 1,
            interval: $781ea1495c21f2d0$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $781ea1495c21f2d0$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($7sKFl)))({
            limit: 1,
            interval: $781ea1495c21f2d0$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $781ea1495c21f2d0$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $781ea1495c21f2d0$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            if ((0, $eGOwo.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined
                });
            } else responsePromise = loader.load(url);
            $781ea1495c21f2d0$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $781ea1495c21f2d0$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $ZyWbK.isSuccessfulResponse)(response) || (0, $4g7cp.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $781ea1495c21f2d0$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $ZyWbK.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($6lERA)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $ZyWbK.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $ZyWbK.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($6lERA)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $ZyWbK.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $hhFie.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $hhFie.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $ZyWbK.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $hhFie.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $hhFie.NetworkError)) return new (0, $4pUJe.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $4pUJe.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $4pUJe.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $4pUJe.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $4pUJe.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $4pUJe.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("79KwK", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $535d76fea738a4fd$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $535d76fea738a4fd$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $535d76fea738a4fd$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $535d76fea738a4fd$var$getValidCacheKeyFn(options);
        this._cacheMap = $535d76fea738a4fd$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $535d76fea738a4fd$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $535d76fea738a4fd$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$535d76fea738a4fd$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $535d76fea738a4fd$var$enqueuePostPromiseJob = typeof $igDjg === 'object' && typeof $igDjg.nextTick === 'function' ? function(fn) {
    if (!$535d76fea738a4fd$var$resolvedPromise) $535d76fea738a4fd$var$resolvedPromise = Promise.resolve();
    $535d76fea738a4fd$var$resolvedPromise.then(function() {
        $igDjg.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $535d76fea738a4fd$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $535d76fea738a4fd$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $535d76fea738a4fd$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $535d76fea738a4fd$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $535d76fea738a4fd$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $535d76fea738a4fd$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $535d76fea738a4fd$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$535d76fea738a4fd$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $535d76fea738a4fd$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $535d76fea738a4fd$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $535d76fea738a4fd$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $535d76fea738a4fd$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $535d76fea738a4fd$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $535d76fea738a4fd$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $535d76fea738a4fd$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $535d76fea738a4fd$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $535d76fea738a4fd$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $535d76fea738a4fd$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $535d76fea738a4fd$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $535d76fea738a4fd$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $535d76fea738a4fd$var$DataLoader;

});

parcelRegister("cbSL1", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $80111f8cfb287dae$export$45abdb3f977b5b14);

var $803eB = parcelRequire("803eB");
function $80111f8cfb287dae$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $803eB.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("803eB", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $1a1aa4dcd65a9a0e$export$58e581060588c6bb);

var $59rsN = parcelRequire("59rsN");

var $4iJGP = parcelRequire("4iJGP");

var $bfW07 = parcelRequire("bfW07");
function $1a1aa4dcd65a9a0e$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $bfW07._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $59rsN.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $59rsN.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $4iJGP.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("bfW07", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $98b68f42908704b3$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $98b68f42908704b3$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $98b68f42908704b3$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $98b68f42908704b3$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dpRNR = parcelRequire("dpRNR");

var $iR7nX = parcelRequire("iR7nX");
let $98b68f42908704b3$export$e5d73bf4f8e2ae96 = {};
let $98b68f42908704b3$export$4e849416bb5c5b52 = {};
let $98b68f42908704b3$export$cf7305fc65acbf0d;
function $98b68f42908704b3$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $dpRNR.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $98b68f42908704b3$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !options?.disableTestOverrides) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $dpRNR.editorExperimentsConfig)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $iR7nX.testMultivariateOverrides)[key] ?? (0, $iR7nX.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $98b68f42908704b3$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $98b68f42908704b3$export$cf7305fc65acbf0d = product;
    $98b68f42908704b3$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("dpRNR", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $91e9175ec4c776be$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9M2Eg = parcelRequire("9M2Eg");
const $91e9175ec4c776be$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 03-09-2025
    cc_editor_limited_mode_include_lcm: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_include_lcm'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-30
    // variant 1: remove table overflow shadows completely, no table border shown when scrolling.
    // variant 2: remove table overflow shadows, show table border when scrolling.
    // variant 3: replace table overflow shadows with CSS-only solution.
    platform_editor_disable_table_overflow_shadows: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_table_overflow_shadows'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2',
            'variant3'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_drag_handle_hover: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_drag_handle_hover',
            jira: 'platform_editor_table_drag_handle_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-14
    platform_editor_resizer_cls_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_resizer_cls_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_no_ssr: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-18
    platform_editor_ai_ct_sg_adf_streaming: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_ct_sg_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-07-07
    platform_editor_ai_remove_trivial_prompts_cc: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_remove_trivial_prompts_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    platform_hover_card_preview_panel_modal: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel_modal',
            jira: 'platform_hover_card_preview_panel_modal'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025--9-17
    platform_editor_block_menu_empty_line: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu_empty_line'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_emoji_otp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_jira',
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc_patch_3: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_3',
            confluence: 'platform_editor_toolbar_aifc_patch_3'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-09-09
    platform_editor_toolbar_aifc_patch_4: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_4',
            confluence: 'platform_editor_toolbar_aifc_patch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-29
    platform_editor_toolbar_aifc_selection_extension: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_selection_extension',
            jira: 'platform_editor_toolbar_aifc_selection_extension'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_support: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_native_expand_button: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_expand_button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    cc_improve_writing_on_paste_v2: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste_v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_find_replace_a11y_fixes: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_replace_a11y_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-21
    platform_editor_paste_rich_text_bugfix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_rich_text_bugfix',
            jira: 'platform_editor_paste_rich_text_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_block_menu_layout_format: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu_layout_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_block_menu_expand_format: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu_expand_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    platform_editor_block_menu_keyboard_navigation: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu_keyboard_navigation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_toolbar_aifc_patch_5: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_5'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    cc_complexit_fe_emoji_stability: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_complexit_fe_emoji_stability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-26
    platform_editor_toolbar_aifc_patch_6: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-17
    confluence_content_mode_replace_dense_with_compact: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_content_mode_replace_dense_with_compact'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_editor_new_list_decorations_logic: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_new_list_decorations_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_new_mentions_detection_logic: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_new_mentions_detection_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_nested_table_detection: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_table_detection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_fix_clone_nesting_exp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_clone_nesting_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("9M2Eg", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $99d69a3554c71d9e$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $99d69a3554c71d9e$export$fb89e8a786694d1);

var $cFacD = parcelRequire("cFacD");
function $99d69a3554c71d9e$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $cFacD.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $99d69a3554c71d9e$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $cFacD.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("cFacD", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $ae50fe7194104c61$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $ae50fe7194104c61$export$a9a18ae5ba42aeab);
function $ae50fe7194104c61$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $ae50fe7194104c61$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($ae50fe7194104c61$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $ae50fe7194104c61$var$IS_TESTING_ENV = false;

});



parcelRegister("iR7nX", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $88e4e44d8ad6406b$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $88e4e44d8ad6406b$export$54960937bb713f97);
const $88e4e44d8ad6406b$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    platform_editor_insertion: 'control',
    editor_ai_inline_suggestion_date_v2: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_editor_ai_non_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control',
    platform_hover_card_preview_panel_modal: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    confluence_content_mode_replace_dense_with_compact: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_disable_table_overflow_shadows: 'control',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'control'
};
const $88e4e44d8ad6406b$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_ai_remove_trivial_prompts_cc: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste_v2: false,
    platform_editor_text_highlight_padding: false
};

});




parcelRegister("6lERA", function(module, exports) {
// Packages

var $gwOtK = parcelRequire("gwOtK");
function $49f466d51d14dc95$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $gwOtK.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $49f466d51d14dc95$var$retry;

});
parcelRegister("gwOtK", function(module, exports) {

module.exports = (parcelRequire("jTUm8"));

});
parcelRegister("jTUm8", function(module, exports) {

var $kGZfu = parcelRequire("kGZfu");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $kGZfu(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("kGZfu", function(module, exports) {
function $f1073d9d808c3152$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $f1073d9d808c3152$var$RetryOperation;
$f1073d9d808c3152$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$f1073d9d808c3152$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$f1073d9d808c3152$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$f1073d9d808c3152$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$f1073d9d808c3152$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$f1073d9d808c3152$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$f1073d9d808c3152$var$RetryOperation.prototype.start = $f1073d9d808c3152$var$RetryOperation.prototype.try;
$f1073d9d808c3152$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$f1073d9d808c3152$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$f1073d9d808c3152$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("7sKFl", function(module, exports) {
'use strict';
class $56ef58d037e115c4$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $56ef58d037e115c4$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $56ef58d037e115c4$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $56ef58d037e115c4$var$pThrottle;
module.exports.AbortError = $56ef58d037e115c4$var$AbortError;

});

parcelRegister("4pUJe", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $d6704a2e786f0169$export$3e5b797e39668f84);
class $d6704a2e786f0169$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("a5MXk", function(module, exports) {
$parcel$export(module.exports, "getBaseUrl", () => $b154de42c200dbd4$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $b154de42c200dbd4$export$dc37652c1696f231);
const $b154de42c200dbd4$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $b154de42c200dbd4$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $b154de42c200dbd4$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $b154de42c200dbd4$export$e2b040f052407032 = {
    dev: $b154de42c200dbd4$var$devBaseUrl,
    development: $b154de42c200dbd4$var$devBaseUrl,
    stg: $b154de42c200dbd4$var$stgBaseUrl,
    staging: $b154de42c200dbd4$var$stgBaseUrl,
    prd: $b154de42c200dbd4$var$prodBaseUrl,
    prod: $b154de42c200dbd4$var$prodBaseUrl,
    production: $b154de42c200dbd4$var$prodBaseUrl
};
const $b154de42c200dbd4$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $b154de42c200dbd4$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $b154de42c200dbd4$export$e2b040f052407032 ? $b154de42c200dbd4$export$e2b040f052407032[envKey] : $b154de42c200dbd4$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $b154de42c200dbd4$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $b154de42c200dbd4$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $b154de42c200dbd4$export$2e2bcd8739ae039 = $b154de42c200dbd4$export$e2b040f052407032;

});

parcelRegister("hhFie", function(module, exports) {
$parcel$export(module.exports, "NetworkError", () => $3c4f8f7f5313e518$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $3c4f8f7f5313e518$export$b5fe3f66a567bec0);
const $3c4f8f7f5313e518$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $3c4f8f7f5313e518$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $3c4f8f7f5313e518$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $3c4f8f7f5313e518$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $3c4f8f7f5313e518$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("ZyWbK", function(module, exports) {
$parcel$export(module.exports, "isSuccessfulResponse", () => $dc93138166903442$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $dc93138166903442$export$bea7bee8a87e7c52);
const $dc93138166903442$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $dc93138166903442$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("7xkt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("03tSb", function(module, exports) {
$parcel$export(module.exports, "getCorrectContentURL", () => $d17e31995df83f35$export$193bb0d0d16ee7a7);

var $aRAdB = parcelRequire("aRAdB");
const $d17e31995df83f35$var$ATLASSIAN_DOMAINS = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $d17e31995df83f35$export$97f4c254b641e719 = (hostname)=>!$d17e31995df83f35$var$ATLASSIAN_DOMAINS.some((domain)=>hostname.endsWith(domain));
const $d17e31995df83f35$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};
const $d17e31995df83f35$export$280e79c794cf814e = (url)=>$d17e31995df83f35$var$isValidUrl(url) ? new URL(url)?.hostname : '';
const $d17e31995df83f35$export$33c8f371dcc1b989 = (ari)=>{
    if (!ari || typeof ari !== 'string') return null;
    try {
        const parsedAri = (0, $aRAdB.ConfluencePageAri).parse(ari);
        return parsedAri && parsedAri.cloudId ? parsedAri.cloudId : null;
    } catch (err) {
        return null;
    }
};
const $d17e31995df83f35$export$193bb0d0d16ee7a7 = (parentCloudId, url, ari)=>{
    const parentHost = $d17e31995df83f35$export$280e79c794cf814e(window?.location?.href) || '';
    const contentHost = $d17e31995df83f35$export$280e79c794cf814e(url);
    if (parentHost === contentHost) return url;
    const cloudId = $d17e31995df83f35$export$33c8f371dcc1b989(ari);
    if (!cloudId || !parentCloudId || parentCloudId !== cloudId || !$d17e31995df83f35$export$97f4c254b641e719(parentHost)) return url;
    // Swap the URL hostname to use the parent's hostname
    try {
        const urlObj = new URL(url);
        urlObj.hostname = parentHost;
        return urlObj.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        return url;
    }
};

});
parcelRegister("aRAdB", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAri", () => $7e8af2db1a810cff$export$3f931dd15d96caff);

var $kOtJp = parcelRequire("kOtJp");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/confluence/page/manifest.ts
var $7e8af2db1a810cff$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $kOtJp.ConfluencePageAriResourceOwner),
    resourceType: (0, $kOtJp.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $7e8af2db1a810cff$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7e8af2db1a810cff$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $7e8af2db1a810cff$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7e8af2db1a810cff$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $7e8af2db1a810cff$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $7e8af2db1a810cff$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $7e8af2db1a810cff$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("kOtJp", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAriResourceOwner", () => $f26f8a31b8cf169f$export$da53e4f7db4c6a71);
$parcel$export(module.exports, "ConfluencePageAriResourceType", () => $f26f8a31b8cf169f$export$636fc622562a2c5b);
// src/confluence/page/types.ts
var $f26f8a31b8cf169f$export$da53e4f7db4c6a71 = "confluence", $f26f8a31b8cf169f$export$636fc622562a2c5b = "page";

});



parcelRegister("idqmr", function(module, exports) {
$parcel$export(module.exports, "JiraSnippetRenderer", () => $69d9315ac50d969d$export$350494aed20b1067);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $cxKOj = parcelRequire("cxKOj");

var $lopBx = parcelRequire("lopBx");

var $klw3i = parcelRequire("klw3i");
const $69d9315ac50d969d$export$350494aed20b1067 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $klw3i.aiSnippetEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            contentId: props.contentId,
            contentType: props.contentType,
            cloudId: props.cloudId,
            fallbackText: props.fallbackText,
            fallbackComponent: props.fallbackComponent,
            isHidden: props.isHidden,
            maxLines: props.maxLines,
            showFooter: props.showFooter
        }), [
        props.contentId,
        props.contentType,
        props.cloudId,
        props.fallbackText,
        props.fallbackComponent,
        props.isHidden,
        props.maxLines,
        props.showFooter
    ]);
    if ((0, $lopBx.isFedRamp)() || !(0, $cxKOj.expVal)('jira-cc-ai-snippet-experiment', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.smartcard.ai-snippet",
        packageName: "jiraSmartcardAiSnippet",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: runtimeProps,
        fallback: props.fallbackComponent
    });
};

});
parcelRegister("klw3i", function(module, exports) {
$parcel$export(module.exports, "aiSnippetEntryPoint", () => $34a531554ffa544a$export$d03f6bd89a6edd19);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $34a531554ffa544a$export$d03f6bd89a6edd19 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cDBqC")), {
        moduleId: "6db951f1",
        priority: "interaction",
        moduleId: 'ai-snippet-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

const $34a531554ffa544a$export$594ea4c115483206 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6U8Dv")), {
        moduleId: "a7f3e824",
        priority: "interaction",
        moduleId: 'ai-snippet-with-relay-environment-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cDBqC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ej0dJ")
]).then(()=>parcelRequire('jtoCL'));

});

parcelRegister("6U8Dv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3jMvR")
]).then(()=>parcelRequire('demWt'));

});





parcelRegister("gSyZa", function(module, exports) {
$parcel$export(module.exports, "HorizontalNav", () => $2e63b1463a86de86$export$3821fe730064297d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6nQNr = parcelRequire("6nQNr");

var $302Lx = parcelRequire("302Lx");

var $jrulJ = parcelRequire("jrulJ");


var $4EKqI = parcelRequire("4EKqI");

var $5vQ2T = parcelRequire("5vQ2T");

var $2dBpR = parcelRequire("2dBpR");

var $iX5t3 = parcelRequire("iX5t3");

var $lq8Ki = parcelRequire("lq8Ki");

var $4cTDP = parcelRequire("4cTDP");

var $7wkp5 = parcelRequire("7wkp5");
const $2e63b1463a86de86$var$NavErrorBoundaryFallback = ()=>// null = equivalent of "unmount"
    // We should do more graceful degradation.
    // Let's review this after dogfooding:
    // Tracked https://hello.jira.atlassian.cloud/browse/SEA-3059
    null;
const $2e63b1463a86de86$var$entrypointContainerProps = {};
const $2e63b1463a86de86$export$3821fe730064297d = ()=>{
    const HorizontalNavComponent = (0, $6nQNr.useHorizontalNavComponent)();
    // Consume the horizontal nav entry point if defined, otherwise fallback to the old horizontal nav component
    const horizontalNavEntryPointReference = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$948d4d345566aed3));
    const horizontalNavFallback = ()=>{
        const Fallback = horizontalNavEntryPointReference?.extraProps?.fallback || (0, $iX5t3.HorizontalNavSkeleton);
        if ((0, $4cTDP.fg)('blu-8405-report-ssr-on-fail-tab-nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.ReportSSRFailOnUse), {
            pageId: "horizontal-nav-through-entry-point",
            fallbackId: "horizontal-nav-through-entry-point",
            displayErrorInStaging: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Fallback, null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Fallback, null);
    };
    if (horizontalNavEntryPointReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $302Lx.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "horizontal-nav-through-entry-point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "horizontal-nav-through-entry-point",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "horizontal-nav-through-entry-point",
        fallback: horizontalNavFallback(),
        entryPointReference: horizontalNavEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: horizontalNavEntryPointReference,
        props: $2e63b1463a86de86$var$entrypointContainerProps
    })))));
    return HorizontalNavComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $302Lx.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $2e63b1463a86de86$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $302Lx.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HorizontalNavComponent, null));
};

});
parcelRegister("302Lx", function(module, exports) {
$parcel$export(module.exports, "NavErrorBoundary", () => $db292bc365ee15db$export$afc779e659fd533f);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $5vQ2T = parcelRequire("5vQ2T");

var $9pTd3 = parcelRequire("9pTd3");
const $db292bc365ee15db$export$1d1321d2b374d697 = ()=>{
    if ((0, $4cTDP.fg)('is_overriding_fragments_analytics_prop')) {
        const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
        const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
        return buildKey ? re.test(buildKey) : false;
    }
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};
function $db292bc365ee15db$var$inferNavRevision() {
    // This is brittle since we have several FFs https://hello.atlassian.net/wiki/spaces/SEA/pages/3841892327/Jira+Nav+v4+Feature+Flags
    // if possible, try to pass the revision explicitly as a prop
    return 'v4';
}
function $db292bc365ee15db$var$getExtraAttributes(_error) {
    const attributes = {
        rev: $db292bc365ee15db$var$inferNavRevision()
    };
    return attributes;
}
function $db292bc365ee15db$var$getAnalyticsPayload(error, meta, navRevision) {
    const payload = {
        error: error,
        meta: {
            // intentionally fixed metas
            // so that we generate a unique event signature
            // so that we can register it in the analytics portal: https://data-portal.internal.atlassian.com/analytics/registry/67955
            // so that we get the attributes to show up in Splunk: https://splunk.paas-inf.net/en-GB/app/search/2024_sea2744_jira_nav_v4_container_navigation
            id: 'logic',
            packageName: 'JiraNav'
        },
        attributes: {
            ...$db292bc365ee15db$var$getExtraAttributes(error),
            // forward the original meta as attributes to identify the location
            pkg: meta.packageName,
            id: meta.id,
            // if explicitly passed, override the rev
            ...navRevision && {
                rev: navRevision
            }
        },
        skipSentry: true
    };
    return payload;
}
const $db292bc365ee15db$export$5ac21f1e947e70d6 = (props)=>{
    const { id: id, packageName: packageName, navRevision: navRevision } = props;
    const onError = (0, $eJOHy.useMemo)(()=>{
        const meta = {
            id: id,
            packageName: packageName
        };
        const _onError = (...args)=>{
            if ($db292bc365ee15db$export$1d1321d2b374d697()) // this is a local test environment, don't send anything
            return;
            const [_, error] = args;
            (0, $9pTd3.fireErrorAnalytics)($db292bc365ee15db$var$getAnalyticsPayload(error, meta, navRevision));
        };
        return _onError;
    }, [
        id,
        packageName,
        navRevision
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        ...props,
        onError: onError
    });
};
const $db292bc365ee15db$export$afc779e659fd533f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db292bc365ee15db$export$5ac21f1e947e70d6, props);

});

parcelRegister("7wkp5", function(module, exports) {
$parcel$export(module.exports, "TopNavigationSkipLink", () => $594f97eae5faa7ac$export$47de2191d46337b7);
$parcel$export(module.exports, "ProjectViewNavigationSkipLink", () => $594f97eae5faa7ac$export$2e2fc9c237996c06);
$parcel$export(module.exports, "MainContentSkipLink", () => $594f97eae5faa7ac$export$b1498dd122ea3284);

var $lRq8t = parcelRequire("lRq8t");

var $dzLcO = parcelRequire("dzLcO");

var $7iEoF = parcelRequire("7iEoF");
const $594f97eae5faa7ac$export$47de2191d46337b7 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('ak-jira-navigation', formatMessage((0, $7iEoF.default).skipToJiraNavigation), 0);
    return null;
};
const $594f97eae5faa7ac$export$46697df0d7c5e8be = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('ak-side-navigation', formatMessage((0, $7iEoF.default).skipToSideNavigation), 1);
    return null;
};
const $594f97eae5faa7ac$export$2e2fc9c237996c06 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, $7iEoF.default).skipToProjectViewNavigation), 2);
    return null;
};
const $594f97eae5faa7ac$export$b1498dd122ea3284 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('ak-main-content', formatMessage((0, $7iEoF.default).skipToMainContent), 3);
    return null;
};

});
parcelRegister("7iEoF", function(module, exports) {
$parcel$export(module.exports, "default", () => $c051cce56b2d289f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c051cce56b2d289f$var$messages = (0, $7qGN1.defineMessages)({
    skipToJiraNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
        "defaultMessage": "Skip to Jira Navigation"
    },
    skipToSideNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
        "defaultMessage": "Skip to Side Navigation"
    },
    skipToProjectViewNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
        "defaultMessage": "Skip to View Navigation"
    },
    skipToMainContent: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
        "defaultMessage": "Skip to Main Content"
    }
});
var $c051cce56b2d289f$export$2e2bcd8739ae039 = $c051cce56b2d289f$var$messages;

});



parcelRegister("m9A8V", function(module, exports) {
$parcel$export(module.exports, "RightSidebar", () => $dcf86e52707dff44$export$84d58c19c21f637f);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");


var $jrulJ = parcelRequire("jrulJ");

var $2dBpR = parcelRequire("2dBpR");

var $5vQ2T = parcelRequire("5vQ2T");

var $dfP3D = parcelRequire("dfP3D");

var $dzLcO = parcelRequire("dzLcO");

var $hih5V = parcelRequire("hih5V");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6dwgv = parcelRequire("6dwgv");

var $djhHt = parcelRequire("djhHt");

var $4EKqI = parcelRequire("4EKqI");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $dcf86e52707dff44$var$TEST_ID = 'page-layout.aside';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $dcf86e52707dff44$var$routeComponents = [];
const $dcf86e52707dff44$var$SharedRightSidebars = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6dwgv.renderGlobalComponents)((0, $djhHt.sharedLayout).rightSidebars));
const $dcf86e52707dff44$var$RightSidebarRouteComponents = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6dwgv.renderGlobalComponents)(route.layout?.rightSidebars || $dcf86e52707dff44$var$routeComponents));
};
const $dcf86e52707dff44$export$fb85bbdbfb3e6869 = ()=>null;
const $dcf86e52707dff44$var$RightSidebarThroughEntrypoint = ()=>{
    const rightSideBarEntryPointReference = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$7bf43119a6b49ddb));
    if (!rightSideBarEntryPointReference) return null;
    const rightSideBarFallback = rightSideBarEntryPointReference?.extraProps?.fallback || $dcf86e52707dff44$export$fb85bbdbfb3e6869;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "right-sidebar-through-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-through-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "right-sidebar-through-entrypoint",
        fallback: rightSideBarFallback(),
        entryPointReference: rightSideBarEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: rightSideBarEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};
const $dcf86e52707dff44$export$84d58c19c21f637f = ()=>{
    const lastPanelIdRef = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.RightPanel), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
        testId: $dcf86e52707dff44$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$RightSidebarRouteComponents, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$RightSidebarThroughEntrypoint, null))));
};

});

parcelRegister("eTZyL", function(module, exports) {
$parcel$export(module.exports, "Sidebar", () => $13c248c2a5a8eec0$export$1ba59dacbcbf90fe);

var $hOoYL = parcelRequire("hOoYL");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $2bY1m = parcelRequire("2bY1m");
var $9Qwez = parcelRequire("9Qwez");
var $jiT3G = parcelRequire("jiT3G");

var $j55tu = parcelRequire("j55tu");

var $bJscI = parcelRequire("bJscI");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $cSXp8 = parcelRequire("cSXp8");

var $dTocu = parcelRequire("dTocu");

var $cUxaS = parcelRequire("cUxaS");

var $fZsy4 = parcelRequire("fZsy4");

var $43SpR = parcelRequire("43SpR");

var $dpxw4 = parcelRequire("dpxw4");

var $5Q9JR = parcelRequire("5Q9JR");

var $2imLM = parcelRequire("2imLM");

var $9FYIg = parcelRequire("9FYIg");

var $4WnjH = parcelRequire("4WnjH");

var $figsJ = parcelRequire("figsJ");

var $kh7bJ = parcelRequire("kh7bJ");

var $1M2hR = parcelRequire("1M2hR");

var $4EKqI = parcelRequire("4EKqI");

var $g5Uuh = parcelRequire("g5Uuh");

var $YVvuv = parcelRequire("YVvuv");

var $gkQFl = parcelRequire("gkQFl");

var $cfS4j = parcelRequire("cfS4j");

var $e5TCl = parcelRequire("e5TCl");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6ju76 = parcelRequire("6ju76");

var $7b66t = parcelRequire("7b66t");
const $13c248c2a5a8eec0$var$footerStyles = {
    root: "_bfhkhp5a"
}; /**
    * This test ID is used in pollinator tests. Do not change lightly.
    */ 
const $13c248c2a5a8eec0$var$TEST_ID = 'page-layout.sidebar'; // TODO: use importCond() here
const $13c248c2a5a8eec0$export$1ba59dacbcbf90fe = (0, $bJscI.componentWithFG)('navx-global-side-nav', (0, $e5TCl.NavPlatformSidebar), $13c248c2a5a8eec0$var$SidebarNav4);
function $13c248c2a5a8eec0$var$SidebarNav4() {
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)(); // TODO: Ask Matt why we use the Relay resource here, instead of inside SidebarInternal.
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $43SpR.sidebarNav4UiStateResource));
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.PlaceholderNew), {
        name: "nav4-ignore.sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13c248c2a5a8eec0$var$SidebarInternalAnonymous, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4.sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.PlaceholderNew), {
        name: "nav4-ignore.sidebar"
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13c248c2a5a8eec0$var$SidebarInternal, {
        queryReference: queryReference
    }) : null));
}
function $13c248c2a5a8eec0$var$SidebarInternalAnonymous() {
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const defaultCollapsed = false;
    const defaultWidth = 340;
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $fZsy4.useLayoutStoreActions)();
    const onExpand = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $eJOHy.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpxw4.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Qwez.SideNav), {
        testId: $13c248c2a5a8eec0$var$TEST_ID,
        defaultCollapsed: (0, $4cTDP.fg)('navx-full-height-sidebar') ? undefined : defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkQFl.SidebarEntryPointSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bY1m.PanelSplitter), {
        label: formatMessage((0, $7b66t.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.sidebar.panel-splitter"
    })));
}
function $13c248c2a5a8eec0$var$SidebarInternal({ queryReference: queryReference }) {
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $hOoYL.default), queryReference);
    const { width: leftSidebarWidth, isCollapsed: isLeftSidebarCollapsed } = (0, $cUxaS.useLeftSidebarState)(); /*
                             	Backend may respond with an error with the reason as Navigation UI state user property does not exist
                             	under a scenario where a new user joins an existing Jira site.
                             	When this happens, UI would not have data coming through from sidebarSelectorQuery.
                             	So, default values are used in such a case.
                             */ 
    const defaultCollapsed = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('blu-8363-archive-legacy-resource-navigationuistate') ? isLeftSidebarCollapsed ?? (0, $5Q9JR.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT) : data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $5Q9JR.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT), [
        data?.jira?.navigationUIState?.isLeftSidebarCollapsed,
        isLeftSidebarCollapsed
    ]);
    const defaultWidth = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('blu-8363-archive-legacy-resource-navigationuistate') ? leftSidebarWidth ?? (0, $5Q9JR.LEFT_SIDEBAR_EXPANDED_MIN_WIDTH) : data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, $5Q9JR.LEFT_SIDEBAR_EXPANDED_MIN_WIDTH), [
        data?.jira?.navigationUIState?.leftSidebarWidth,
        leftSidebarWidth
    ]);
    const { isCollapsed: currentCollapsed, hasUserPreference: hasUserPreference } = (0, $cUxaS.useLeftSidebarState)();
    const effectiveCollapsed = hasUserPreference ? currentCollapsed : defaultCollapsed;
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $fZsy4.useLayoutStoreActions)();
    const onExpand = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') {
            if ((0, $4cTDP.fg)('jira-full-screen')) setLeftSidebarState({
                hasUserPreference: true,
                isCollapsed: false
            });
            else setLeftSidebarState({
                isCollapsed: false
            });
        }
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') {
            if ((0, $4cTDP.fg)('jira-full-screen')) setLeftSidebarState({
                hasUserPreference: true,
                isCollapsed: true
            });
            else setLeftSidebarState({
                isCollapsed: true
            });
        }
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $eJOHy.useCallback)(({ initialWidth: initialWidth, finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'sidebar'
        }), {
            initialWidth: initialWidth,
            finalWidth: finalWidth
        });
    }, [
        createAnalyticsEvent,
        setLeftSidebarState
    ]);
    const locale = (0, $1M2hR.useLocale)();
    const showPersistentInvite = // Ensure that we can turn off the locale check with a feature gate if needed
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('navx_persistent_invite_jira_new_non_free') && // Do not trigger an exposure on the experiment for non-English locales
    (locale?.toLowerCase().startsWith('en') ?? false) && (0, $cxKOj.expVal)('navx_persistent_invite_jira_new_non_free_exp', 'global_invite_enabled', false);
    const defaultCollapsedWithFG = (0, $eJOHy.useMemo)(()=>{
        if ((0, $4cTDP.fg)('navx-full-height-sidebar')) return undefined;
        if ((0, $4cTDP.fg)('jira-full-screen')) return effectiveCollapsed;
        return defaultCollapsed;
    }, [
        effectiveCollapsed,
        defaultCollapsed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpxw4.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Qwez.SideNav), {
        testId: $13c248c2a5a8eec0$var$TEST_ID,
        defaultCollapsed: defaultCollapsedWithFG,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse,
        canToggleWithShortcut: (0, $6ju76.isLegacyAuiBlanketClosed)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkQFl.SidebarEntryPointSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jiT3G.SideNavFooter), {
        xcss: $13c248c2a5a8eec0$var$footerStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cfS4j.Nav4JiraSideNavRecommendation), null), showPersistentInvite || (0, $cxKOj.expVal)('jfind-add-invite-button-to-left-nav-experiment', 'enrolled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $13c248c2a5a8eec0$var$globalInviteButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j55tu.GlobalInvite), {
        testId: "page-container-v2.common.ui.sidebar.global-invite",
        product: "jira",
        subProduct: subProduct ?? undefined,
        showFlag: showFlag
    }, formatMessage((0, $7b66t.messages).globalInviteButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4WnjH.SidebarFeedbackButton), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4WnjH.SidebarFeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bY1m.PanelSplitter), {
        label: formatMessage((0, $7b66t.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.sidebar.panel-splitter"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5Uuh.AsyncNudgeBundledUsersFlagContainer), null), (0, $4cTDP.fg)('jira-nudge-confluence-inactive-users-eligible') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $YVvuv.AsyncNudgeInactiveConfluenceUserFlagContainer), null)));
}
const $13c248c2a5a8eec0$var$globalInviteButtonStyles = (0, $1DXK0.xcss)({
    flexGrow: 1
});

});
parcelRegister("jiT3G", function(module, exports) {
$parcel$export(module.exports, "SideNavFooter", () => $27239cd820ee8112$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $27239cd820ee8112$var$styles = {
    root: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _7myae4h9 _1sw7nqa1 _qgnumuej"
};
const $27239cd820ee8112$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $27239cd820ee8112$var$styles.root,
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("j55tu", function(module, exports) {
$parcel$export(module.exports, "GlobalInvite", () => $efb1da050168f415$export$93cb436db3d27b7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $3JwXA = parcelRequire("3JwXA");

var $lKQ82 = parcelRequire("lKQ82");

var $if9T3 = parcelRequire("if9T3");

var $ciGcm = parcelRequire("ciGcm");

var $d5m7x = parcelRequire("d5m7x");

var $g7U73 = parcelRequire("g7U73");
const $efb1da050168f415$export$93cb436db3d27b7e = (0, $g7U73.withModalDialog)($efb1da050168f415$var$AsyncGlobalInviteModalDialogContent);
function $efb1da050168f415$var$AsyncGlobalInviteModalDialogContent(props) {
    const modalContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ciGcm.ErrorState), {}),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d5m7x.LoadingState), {}),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($efb1da050168f415$var$LazyGlobalInviteModalDialogContent, {
                ...props
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JwXA.default), {
        defaultMessages: (0, $if9T3.default),
        loaderFn: (0, $lKQ82.fetchMessages),
        children: modalContent
    });
}

const $efb1da050168f415$var$LazyGlobalInviteModalDialogContent = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("d97HO")).then((module)=>({
            default: module.ModalDialogContent
        })));

});
parcelRegister("lKQ82", function(module, exports) {
$parcel$export(module.exports, "fetchMessages", () => $250c886ac24a9ace$export$e4882a930a0d91f2);

var $if9T3 = parcelRequire("if9T3");

var $5JAqs = parcelRequire("5JAqs");
const $250c886ac24a9ace$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $5JAqs.asyncLanguages) ? locale : locale.replace(/-/g, '_') in (0, $5JAqs.asyncLanguages) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $5JAqs.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $if9T3.default);
    } catch (e) {
    // ignore
    }
    return 0, $if9T3.default;
};

});
parcelRegister("if9T3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5ed257825f4b6153$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $koaVW = parcelRequire("koaVW");
var $5ed257825f4b6153$export$2e2bcd8739ae039 = (0, $koaVW.default);

});
parcelRegister("koaVW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0310ccf46447dfb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $f0310ccf46447dfb$export$2e2bcd8739ae039 = {
    'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
    'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
    'navigation.global-invite.loading-visually-hidden-label': 'Loading',
    'navigation.global-invite.modal-dialog-label': 'Invite people'
};

});


parcelRegister("5JAqs", function(module, exports) {
$parcel$export(module.exports, "asyncLanguages", () => $6727ab9bbd6adcbf$export$3770c7a7737d463c);
// https://parceljs.org/features/dependency-resolution/#glob-specifiers

























const $6727ab9bbd6adcbf$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("2GCbN")),
    da: ()=>(parcelRequire("4QJv3")),
    de: ()=>(parcelRequire("7Ln9Z")),
    'en-GB': ()=>(parcelRequire("1xSEZ")),
    'en-ZZ': ()=>(parcelRequire("fCvFo")),
    en: ()=>Promise.resolve((parcelRequire("if9T3"))),
    es: ()=>(parcelRequire("hCCNE")),
    fi: ()=>(parcelRequire("38sYl")),
    fr: ()=>(parcelRequire("eSLBV")),
    hu: ()=>(parcelRequire("jKGYC")),
    it: ()=>(parcelRequire("1t3QR")),
    ja: ()=>(parcelRequire("flSwR")),
    ko: ()=>(parcelRequire("fNJuN")),
    nb: ()=>(parcelRequire("jGI7r")),
    nl: ()=>(parcelRequire("5cmx1")),
    pl: ()=>(parcelRequire("6502q")),
    'pt-BR': ()=>(parcelRequire("cEPjJ")),
    ru: ()=>(parcelRequire("cdeoe")),
    sv: ()=>(parcelRequire("aStqL")),
    th: ()=>(parcelRequire("bM3JH")),
    tr: ()=>(parcelRequire("71hRk")),
    uk: ()=>(parcelRequire("1czlx")),
    vi: ()=>(parcelRequire("64OGB")),
    zh_TW: ()=>(parcelRequire("11OcG")),
    zh: ()=>(parcelRequire("2Aq6O"))
};

});
parcelRegister("2GCbN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("67L3F").then(()=>parcelRequire('cGDyd'));

});

parcelRegister("4QJv3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5GyXg").then(()=>parcelRequire('3VpSx'));

});

parcelRegister("7Ln9Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eCcKD").then(()=>parcelRequire('1sSnn'));

});

parcelRegister("1xSEZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fRZhu").then(()=>parcelRequire('9stOT'));

});

parcelRegister("fCvFo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1pvu3").then(()=>parcelRequire('8BpUu'));

});

parcelRegister("hCCNE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Kwo5").then(()=>parcelRequire('en88g'));

});

parcelRegister("38sYl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8A5UV").then(()=>parcelRequire('b3IO0'));

});

parcelRegister("eSLBV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f7aK5").then(()=>parcelRequire('19QsQ'));

});

parcelRegister("jKGYC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8CAUL").then(()=>parcelRequire('bmNIT'));

});

parcelRegister("1t3QR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hm52u").then(()=>parcelRequire('ewHJ9'));

});

parcelRegister("flSwR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8AP11").then(()=>parcelRequire('9vyF7'));

});

parcelRegister("fNJuN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jGMLP").then(()=>parcelRequire('5TZJO'));

});

parcelRegister("jGI7r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ahQoC").then(()=>parcelRequire('g1j2n'));

});

parcelRegister("5cmx1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dK1g3").then(()=>parcelRequire('23ELX'));

});

parcelRegister("6502q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lXULr").then(()=>parcelRequire('15DL1'));

});

parcelRegister("cEPjJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cRI4j").then(()=>parcelRequire('gu7rl'));

});

parcelRegister("cdeoe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2gJf8").then(()=>parcelRequire('aXxee'));

});

parcelRegister("aStqL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lFYYm").then(()=>parcelRequire('1hNQG'));

});

parcelRegister("bM3JH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bPovI").then(()=>parcelRequire('5CRaU'));

});

parcelRegister("71hRk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gMasl").then(()=>parcelRequire('5CImR'));

});

parcelRegister("1czlx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hAiso").then(()=>parcelRequire('h9Zp1'));

});

parcelRegister("64OGB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lkFYZ").then(()=>parcelRequire('7j2k7'));

});

parcelRegister("11OcG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9mHJa").then(()=>parcelRequire('2epAO'));

});

parcelRegister("2Aq6O", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5dEHm").then(()=>parcelRequire('9rH46'));

});



parcelRegister("ciGcm", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $1eaed4e0e07b7b41$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $806LH = parcelRequire("806LH");

var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $Xot2Q = parcelRequire("Xot2Q");
const $1eaed4e0e07b7b41$var$styles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
function $1eaed4e0e07b7b41$export$c1ed4f415b9e7023() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $1eaed4e0e07b7b41$var$styles,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "xsmall",
                children: formatMessage((0, $Xot2Q.messages).errorStateHeading)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $Xot2Q.messages).errorStateDescription)
            })
        ]
    });
}

});
parcelRegister("Xot2Q", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b52fea466b4a6704$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b52fea466b4a6704$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    errorStateHeading: {
        id: 'navigation.global-invite.error-state-heading',
        description: "Heading of the error state UI indicating we couldn't load the invite people widget.",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: 'navigation.global-invite.error-state-description',
        description: "Description of the error state UI indicating we couldn't load the invite people widget.",
        defaultMessage: 'Try refreshing the page or contact us if the problem persists.'
    }
});

});


parcelRegister("d5m7x", function(module, exports) {
$parcel$export(module.exports, "LoadingState", () => $0d272ccf53bd1757$export$62aa48085237e36f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $6fs4r = parcelRequire("6fs4r");

var $12eyb = parcelRequire("12eyb");
const $0d272ccf53bd1757$var$styles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
function $0d272ccf53bd1757$export$62aa48085237e36f() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering"
        }, index));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        xcss: $0d272ccf53bd1757$var$styles,
        testId: "global-invite--loading-state",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                children: formatMessage((0, $12eyb.messages).loadingLabel)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dW738.default), {
                space: "space.100",
                testId: "skeleton-group",
                children: items
            })
        ]
    });
}

});
parcelRegister("12eyb", function(module, exports) {
$parcel$export(module.exports, "messages", () => $04b1d02b1cacdcca$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $04b1d02b1cacdcca$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    loadingLabel: {
        id: 'navigation.global-invite.loading-visually-hidden-label',
        description: 'Visually hidden text to indicate the invite people UI is loading.',
        defaultMessage: 'Loading'
    }
});

});


parcelRegister("g7U73", function(module, exports) {
$parcel$export(module.exports, "withModalDialog", () => $36f3f29efd4efe0a$export$2d7d84d397d9a585);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");


var $ftN6c = parcelRequire("ftN6c");

var $5CSKW = parcelRequire("5CSKW");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $956it = parcelRequire("956it");


var $8DmpZ = parcelRequire("8DmpZ");

var $aBQPA = parcelRequire("aBQPA");
function $36f3f29efd4efe0a$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $de403f5ba33e6eea$export$bb76aeb9f599715c), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $lRq8t.default)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $eJOHy.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $eJOHy.useState)(false);
        const openModalDialog = (0, $eJOHy.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $de403f5ba33e6eea$export$85183a312807388d));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $eJOHy.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $eJOHy.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $de403f5ba33e6eea$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $eJOHy.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $de403f5ba33e6eea$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $eJOHy.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8DmpZ.AnalyticsContextWrapper), {
            product: props.product,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                "data-testid": testId,
                children: [
                    TriggerElement ? /*#__PURE__*/ (0, $gt9Am.jsx)(TriggerElement, {
                        onClick: openModalDialog
                    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        shouldFitContainer: true,
                        onClick: openModalDialog,
                        testId: `${testId}--${(0, $de403f5ba33e6eea$export$1dab7caa4b20a4cc)}`,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
                        children: isModalDialogOpen ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
                            width: "small",
                            shouldScrollInViewport: true,
                            shouldReturnFocus: true,
                            onClose: onCancel,
                            onOpenComplete: focusDialog,
                            label: formatMessage((0, $aBQPA.messages).modalDialogLabel),
                            testId: `${testId}--${(0, $de403f5ba33e6eea$export$7622d28bacf170d1)}`,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Content, {
                                    onAdminMenuItemClick: onAdminMenuItemClick,
                                    onCancel: onCancel,
                                    onInviteCompleted: onInviteCompleted,
                                    ...props
                                })
                            })
                        }) : null
                    })
                ]
            })
        });
    };
}

});
const $de403f5ba33e6eea$export$bb76aeb9f599715c = 'global-invite';
const $de403f5ba33e6eea$export$7622d28bacf170d1 = 'modal-dialog';
const $de403f5ba33e6eea$export$1dab7caa4b20a4cc = 'trigger-element';
const $de403f5ba33e6eea$export$85183a312807388d = 'navigation';

parcelRegister("8DmpZ", function(module, exports) {
$parcel$export(module.exports, "AnalyticsContextWrapper", () => $54113aa90ba0479f$export$804bcbe0913c6ba3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eUaD0 = parcelRequire("eUaD0");
function $54113aa90ba0479f$export$804bcbe0913c6ba3({ product: product, children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        },
        children: children
    });
}

});

parcelRegister("aBQPA", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4562a69dfc7f63d4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4562a69dfc7f63d4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    modalDialogLabel: {
        id: 'navigation.global-invite.modal-dialog-label',
        description: 'Accessible label of the modal dialog for assistive technologies users.',
        defaultMessage: 'Invite people'
    }
});

});


parcelRegister("d97HO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j2Tdl").then(()=>parcelRequire('al5TY'));

});


parcelRegister("4WnjH", function(module, exports) {
$parcel$export(module.exports, "SidebarFeedbackButton", () => $7fffab35036bc322$export$b270ed097d20c023);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $iqAEB = parcelRequire("iqAEB");

var $eJ9f5 = parcelRequire("eJ9f5");

var $k71qx = parcelRequire("k71qx");

var $3cMgR = parcelRequire("3cMgR");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $gdeTc = parcelRequire("gdeTc");

var $4Qvpr = parcelRequire("4Qvpr");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $5Q9JR = parcelRequire("5Q9JR");

var $kkHo2 = parcelRequire("kkHo2");

var $cHtIB = parcelRequire("cHtIB");

var $kyq27 = parcelRequire("kyq27");

var $1M2hR = parcelRequire("1M2hR");

var $6hoYB = parcelRequire("6hoYB");
function $7fffab35036bc322$export$b270ed097d20c023() {
    const environment = (0, $kyq27.useEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, $4Qvpr.useFeedbackCollectorActions)();
    const formattedMessageNode = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $6hoYB.default).feedbackTitleDetailsNoLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: "https://support.atlassian.com/jira-software-cloud/docs/what-is-the-new-navigation-in-jira/",
            onClick: closeFeedbackCollector,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $6hoYB.default).feedbackTitleLearnMoreLinkText)));
    }, [
        closeFeedbackCollector
    ]);
    const onClickHandler = (0, $eJOHy.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $gdeTc.ENTRYPOINT_ID_NAVIGATION_REFRESH),
            feedbackContext: [
                {
                    id: 'environment',
                    value: environment
                },
                {
                    id: 'cloud-id',
                    value: cloudId
                },
                {
                    id: 'location',
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    value: (0, $kkHo2.default)(window?.location?.href ?? '')
                }
            ],
            feedbackGroupId: (0, $5Q9JR.NAV4_GENERAL_FEEDBACK_GROUP_ID),
            feedbackTitle: formatMessage((0, $6hoYB.default).feedbackTitle),
            feedbackTitleDetails: formattedMessageNode
        });
    }, [
        cloudId,
        environment,
        formatMessage,
        formattedMessageNode,
        openFeedbackCollector
    ]);
    const locale = (0, $1M2hR.useLocale)();
    const showPersistentInvite = // Ensure that we can turn off the locale check with a feature gate if needed
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('navx_persistent_invite_jira_new_non_free') && // Do not trigger an exposure on the experiment for non-English locales
    (locale?.toLowerCase().startsWith('en') ?? false) && (0, $cxKOj.expVal)('navx_persistent_invite_jira_new_non_free_exp', 'global_invite_enabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $6hoYB.default).sidebarFeedbackButtonLabel),
        position: "top"
    }, showPersistentInvite || (0, $cxKOj.expVal)('jfind-add-invite-button-to-left-nav-experiment', 'enrolled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqAEB))),
        onClick: onClickHandler,
        label: formatMessage((0, $6hoYB.default).sidebarFeedbackButtonLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($iqAEB))),
        appearance: "subtle",
        onClick: onClickHandler
    }, formatMessage((0, $6hoYB.default).sidebarFeedbackButtonLabel)));
}

});
parcelRegister("iqAEB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a07179b7f5702563b15bc18315c2436>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6a7166667003902$var$_react = $d6a7166667003902$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d6a7166667003902$var$_baseNew = $d6a7166667003902$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d6a7166667003902$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6a7166667003902$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $d6a7166667003902$var$_react.default.createElement($d6a7166667003902$var$_baseNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>`
    }, props));
$d6a7166667003902$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $d6a7166667003902$var$_default = module.exports.default = $d6a7166667003902$var$MegaphoneIcon;

});

parcelRegister("gdeTc", function(module, exports) {
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $8be836e57712489a$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $8be836e57712489a$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $8be836e57712489a$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $8be836e57712489a$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $8be836e57712489a$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $8be836e57712489a$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $8be836e57712489a$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $8be836e57712489a$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $8be836e57712489a$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $8be836e57712489a$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $8be836e57712489a$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $8be836e57712489a$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $8be836e57712489a$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $8be836e57712489a$export$1b65c2053cba0686);
$parcel$export(module.exports, "ENTRYPOINT_ID_PROJECT_BACKGROUNDS", () => $8be836e57712489a$export$9a234699f0515bf);
$parcel$export(module.exports, "ENTRY_POINT_ID_JOURNEY_BUILDER", () => $8be836e57712489a$export$f24169c529e6c9b5);
$parcel$export(module.exports, "ENTRY_POINT_ID_BULK_OPERATIONS", () => $8be836e57712489a$export$f849b75576b691b);
$parcel$export(module.exports, "ENTRY_POINT_ID_ADMIN_ONBOARDING_HUB", () => $8be836e57712489a$export$c0e3a1d9aa18e8eb);
$parcel$export(module.exports, "ENTRY_POINT_ID_AI_CONTEXT_RESOLUTION_PLAN_PANEL", () => $8be836e57712489a$export$7f190c8f7bc2242);
$parcel$export(module.exports, "EntryKeys", () => $8be836e57712489a$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $8be836e57712489a$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $8be836e57712489a$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $8be836e57712489a$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $8be836e57712489a$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $8be836e57712489a$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $8be836e57712489a$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $8be836e57712489a$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $8be836e57712489a$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $8be836e57712489a$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $8be836e57712489a$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $8be836e57712489a$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $8be836e57712489a$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $8be836e57712489a$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $8be836e57712489a$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $8be836e57712489a$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $8be836e57712489a$export$9a234699f0515bf = 'd0f0863a-fe78-4d40-b4f0-451c268594cc';
const $8be836e57712489a$export$f24169c529e6c9b5 = 'd5f62dde-d505-413b-a417-c2dd6979cac2';
const $8be836e57712489a$export$f849b75576b691b = '106df6fd-feed-4aa7-bbf7-5ca2bec6266b';
const $8be836e57712489a$export$c0e3a1d9aa18e8eb = '7620f432-f831-4711-8e09-3aa379bf2d96';
const $8be836e57712489a$export$7f190c8f7bc2242 = 'a8c2aa57-6975-4ed7-80c6-42f46f0bdf91';
const $8be836e57712489a$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap'
});

});

parcelRegister("4Qvpr", function(module, exports) {
$parcel$export(module.exports, "useFeedbackCollector", () => $8ee5902a66d773ff$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $8ee5902a66d773ff$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $8ee5902a66d773ff$export$c35dbf16ebe9df04);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $8ee5902a66d773ff$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    canBeContactedLink: undefined,
    enrolInResearchLink: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $8ee5902a66d773ff$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($8ee5902a66d773ff$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$8ee5902a66d773ff$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $8ee5902a66d773ff$var$Store = (0, $GtRbT.createStore)({
    name: 'feedback-collector',
    initialState: $8ee5902a66d773ff$export$d4c72bab9d6cc13a,
    actions: $8ee5902a66d773ff$export$e324594224ef24da
});
const $8ee5902a66d773ff$export$4be696be8a3bff13 = (0, $iJq0l.createHook)($8ee5902a66d773ff$var$Store);
const $8ee5902a66d773ff$export$dfb2ee2d9e73fa48 = (0, $iJq0l.createActionsHook)($8ee5902a66d773ff$var$Store);
const $8ee5902a66d773ff$export$c35dbf16ebe9df04 = (0, $ht3nQ.createSubscriber)($8ee5902a66d773ff$var$Store, {
    selector: null
});

});

parcelRegister("6hoYB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c970bb9b15a2743$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2c970bb9b15a2743$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sidebarFeedbackButtonLabel: {
        "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
        "defaultMessage": "Give feedback on the new navigation"
    },
    feedbackTitle: {
        "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
        "defaultMessage": "Help us improve the new navigation"
    },
    feedbackTitleDetailsWithLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
    },
    feedbackTitleDetailsNoLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
    },
    feedbackTitleLearnMoreLinkText: {
        "id": "sidebar-nav4-feedback-button.feedback-title-learn-more-link-text",
        "defaultMessage": "Learn more about the new navigation"
    }
});

});


parcelRegister("g5Uuh", function(module, exports) {
$parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", () => $3646062ad1682347$export$30d9dff000fbaa2d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $4EKqI = parcelRequire("4EKqI");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3646062ad1682347$var$NudgeBundledUsersFlagContainer = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cJ3kr")).then((module)=>module.NudgeBundledUsersXflow), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
});
const $3646062ad1682347$export$30d9dff000fbaa2d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "nudgeBundledUserFlag",
        packageName: "nudgeBundledUsersToJoinConnie",
        fallback: "unmount",
        teamName: "confluenceOnboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nudge-bundled-users-flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nudge-bundled-users-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3646062ad1682347$var$NudgeBundledUsersFlagContainer, null))));

});
parcelRegister("cJ3kr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3K1kD").then(()=>parcelRequire('9EcbH'));

});


parcelRegister("YVvuv", function(module, exports) {
$parcel$export(module.exports, "AsyncNudgeInactiveConfluenceUserFlagContainer", () => $5dfcf891840b088d$export$ab9e9eb42f22ca03);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $kGj4V = parcelRequire("kGj4V");

var $4EKqI = parcelRequire("4EKqI");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5dfcf891840b088d$var$NudgeInactiveConfluenceUserFlagContainer = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cTNzm")).then((module)=>module.NudgeInactiveConfluenceUser), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-inactive-confluence-user/src/ui/index.tsx"
});
const $5dfcf891840b088d$export$ab9e9eb42f22ca03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "nudgeInactiveConfluenceUserFlag",
        packageName: "nudgeInactiveConfluenceUser",
        fallback: "unmount",
        teamName: "cc-flywheel-activation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nudge-inactive-confluence-user-flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nudge-inactive-confluence-user-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "nudgeInactiveConfluenceUserFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5dfcf891840b088d$var$NudgeInactiveConfluenceUserFlagContainer, null)))));

});
parcelRegister("cTNzm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2a7pZ").then(()=>parcelRequire('hPeTv'));

});


parcelRegister("gkQFl", function(module, exports) {
$parcel$export(module.exports, "SidebarEntryPointSelector", () => $868be1a8e0d262cb$export$7b792d211e60bd1d);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jrulJ = parcelRequire("jrulJ");


var $2dBpR = parcelRequire("2dBpR");

var $5vQ2T = parcelRequire("5vQ2T");

var $8vXrD = parcelRequire("8vXrD");

var $4EKqI = parcelRequire("4EKqI");

var $hih5V = parcelRequire("hih5V");

var $iMOVa = parcelRequire("iMOVa");




var $iyTaR = parcelRequire("iyTaR");

var $kGj4V = parcelRequire("kGj4V");

var $e9N38 = parcelRequire("e9N38");

var $20Hsz = parcelRequire("20Hsz");
function $868be1a8e0d262cb$export$7b792d211e60bd1d() {
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const paramsForGetNav4SidebarId = (0, $20Hsz.useGetParamsForGetNav4SidebarId)();
    const currentSidebarId = (0, $20Hsz.getNav4SidebarId)(paramsForGetNav4SidebarId);
    const currentEntryPointRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const [sidebarConfig, setSidebarConfig] = (0, $eJOHy.useState)(()=>{
        // We want to avoid switching between the SidebarSelector and the sidebar entryPoint as we navigate through the SPA.
        // To do that, we need to keep using the __initial__ sidebar entryPoint if we haven't changed sidebars.
        // When we do switch sidebars, keep using SidebarSelector from that point onwards (for now).
        // When all of the sidebars are using entryPoints, we can deprecate the SidebarSelector.
        const attributes = {
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $95eb6070d868c1b7$export$2ee9e5a3556c1e43),
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage
        };
        return {
            Component: ()=>currentEntryPointRef && currentRoute.navigation?.sidebarId === currentSidebarId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
                    name: "nav4-sidebar-entrypoint"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
                    fallback: "flag",
                    id: "nav4-sidebar-entrypoint",
                    packageName: "jira-page-container-v2"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMOVa.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
                    attributes: attributes
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
                    name: "nav4-sidebar-entrypoint-placeholder",
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null),
                    entryPointReference: currentEntryPointRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
                    entryPointReference: currentEntryPointRef,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    props: {}
                })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e9N38.SidebarSelector), null),
            sidebarId: currentSidebarId
        };
    });
    (0, $eJOHy.useEffect)(()=>{
        if (sidebarConfig.sidebarId !== currentSidebarId) setSidebarConfig({
            Component: (0, $e9N38.SidebarSelector),
            sidebarId: currentSidebarId
        });
    }, [
        currentSidebarId,
        sidebarConfig.sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(sidebarConfig.Component, null);
}

});
parcelRegister("8vXrD", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $af680c8fbb6b6aab$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $aewX5 = parcelRequire("aewX5");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");
const $af680c8fbb6b6aab$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200",
        xcss: $af680c8fbb6b6aab$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        columnGap: "space.100",
        rowGap: "space.050",
        alignItems: "center",
        templateAreas: [
            'avatar name',
            'avatar type'
        ],
        templateColumns: "min-content 1fr",
        xcss: $af680c8fbb6b6aab$var$projectHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$projectAvatar,
        style: {
            gridArea: 'avatar'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$projectName,
        style: {
            gridArea: 'name'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$projectType,
        style: {
            gridArea: 'type'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    })));
const $af680c8fbb6b6aab$var$containerStyles = (0, $1DXK0.xcss)({
    height: '100%',
    padding: 'space.200'
});
const $af680c8fbb6b6aab$var$backButton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $af680c8fbb6b6aab$var$headingSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small',
    flex: 1
});
const $af680c8fbb6b6aab$var$projectHeading = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $af680c8fbb6b6aab$var$projectAvatar = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $af680c8fbb6b6aab$var$projectName = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small'
});
const $af680c8fbb6b6aab$var$projectType = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-100, 8px)",
    borderRadius: 'radius.small'
});
const $af680c8fbb6b6aab$var$menuItem = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("iMOVa", function(module, exports) {
$parcel$export(module.exports, "useNavigateBack", () => $c7e8cc63d19de1c5$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $c7e8cc63d19de1c5$export$e1e76f4ee7f8174d);

var $eJOHy = parcelRequire("eJOHy");

var $iIQmy = parcelRequire("iIQmy");

var $fs2Be = parcelRequire("fs2Be");

var $4cTDP = parcelRequire("4cTDP");

var $2FqDG = parcelRequire("2FqDG");

var $gtV1h = parcelRequire("gtV1h");
const $c7e8cc63d19de1c5$var$STORAGE_KEY = 'back-button-url';
const $c7e8cc63d19de1c5$var$NavigateBackContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $c7e8cc63d19de1c5$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $eJOHy.useContext)($c7e8cc63d19de1c5$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
function $c7e8cc63d19de1c5$export$e1e76f4ee7f8174d({ children: children }) {
    const [projectKey] = (0, $2FqDG.usePathParam)('projectKey');
    const homeRouteToUse = (0, $4cTDP.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? (0, $iIQmy.jiraHomeRoute) : (0, $fs2Be.oldJiraHomeRoute);
    const defaultInitialUrl = projectKey ? `/projects/${projectKey}` : homeRouteToUse.path;
    const [previousUrl, setPreviousUrl] = (0, $eJOHy.useState)(()=>(0, $gtV1h.storageProvider).get($c7e8cc63d19de1c5$var$STORAGE_KEY) ?? defaultInitialUrl);
    const saveCurrentRoute = (0, $eJOHy.useCallback)((currentUrl)=>{
        setPreviousUrl(currentUrl);
        (0, $gtV1h.storageProvider).set($c7e8cc63d19de1c5$var$STORAGE_KEY, currentUrl);
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            previousUrl: previousUrl
        }), [
        saveCurrentRoute,
        previousUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7e8cc63d19de1c5$var$NavigateBackContext.Provider, {
        value: value
    }, children);
}

});
parcelRegister("gtV1h", function(module, exports) {
$parcel$export(module.exports, "storageProvider", () => $4106a8f58da85e5f$export$ce7751641b93537d);

var $8tIrO = parcelRequire("8tIrO");
const $4106a8f58da85e5f$export$ce7751641b93537d = (0, $8tIrO.createSessionStorageProvider)('sidebar-navigation');

});


parcelRegister("iyTaR", function(module, exports) {
$parcel$export(module.exports, "getNav4Rollout", () => $de9022033aff0d17$export$84a05d3b37ec5d2);

var $3ZJvm = parcelRequire("3ZJvm");

var $9hKkF = parcelRequire("9hKkF");

var $26U8a = parcelRequire("26U8a");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $8LbXh = parcelRequire("8LbXh");

var $lgw54 = parcelRequire("lgw54");

var $f4RbK = parcelRequire("f4RbK");

var $lrIjf = parcelRequire("lrIjf");
const $de9022033aff0d17$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    [
        ()=>!(0, $4cTDP.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_dogfooding'),
        (0, $f4RbK.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_beta_sandboxes'),
        (0, $lgw54.getNav4RolloutForBetaCohort)('sandboxes')
    ],
    [
        ()=>(0, $cxKOj.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('free-customers')
    ],
    [
        ()=>(0, $cxKOj.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('new-customers')
    ],
    [
        ()=>(0, $cxKOj.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('new-customers-x')
    ],
    // Break up cond for easier testing.
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        ()=>(0, $lrIjf.getNav4RolloutForGaAndBeyond)()
    ]
]);

});
parcelRegister("8LbXh", function(module, exports) {
$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $8b7cc1a01a020390$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $8b7cc1a01a020390$export$e748a16828d2f61f);
const $8b7cc1a01a020390$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $8b7cc1a01a020390$export$e748a16828d2f61f = {
    stage: 'mobile'
};

});

parcelRegister("lgw54", function(module, exports) {
$parcel$export(module.exports, "getNav4RolloutForBetaCohort", () => $319abb71143623a2$export$d0b7d7e3a8d0a0c9);
const $319abb71143623a2$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>({
            stage: 'beta',
            cohort: cohort
        });

});

parcelRegister("f4RbK", function(module, exports) {
$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $050075f20fb5392b$export$f1e751a9a9d68fb5);

var $3ZJvm = parcelRequire("3ZJvm");

var $26U8a = parcelRequire("26U8a");

var $4cTDP = parcelRequire("4cTDP");

var $nK7ig = parcelRequire("nK7ig");
const $050075f20fb5392b$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $050075f20fb5392b$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_dogfooding_phase-2'),
        $050075f20fb5392b$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_dogfooding_phase-1'),
        $050075f20fb5392b$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        $050075f20fb5392b$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("lrIjf", function(module, exports) {
$parcel$export(module.exports, "getNav4RolloutForGaAndBeyond", () => $cdb71e5e4666ce0e$export$99bed161b1040362);

var $3ZJvm = parcelRequire("3ZJvm");

var $9hKkF = parcelRequire("9hKkF");

var $26U8a = parcelRequire("26U8a");

var $4cTDP = parcelRequire("4cTDP");

var $fYeTG = parcelRequire("fYeTG");

var $nK7ig = parcelRequire("nK7ig");

var $8LbXh = parcelRequire("8LbXh");
const $cdb71e5e4666ce0e$export$99bed161b1040362 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    // Later GA phases eclipse earlier phases.
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_ga_phase-3'),
        ()=>({
                stage: 'ga',
                phase: 3
            })
    ],
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_ga_phase-2'),
        ()=>({
                stage: 'ga',
                phase: 2,
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_ga_phase-1-5'),
        ()=>({
                stage: 'ga',
                phase: 1.5,
                isAdmin: (0, $nK7ig.getIsAdmin)(),
                isTenantOptOut: (0, $nK7ig.getIsNav4TenantOptOut)(),
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_ga_phase-1'),
        ()=>({
                stage: 'ga',
                phase: 1,
                isAdmin: (0, $nK7ig.getIsAdmin)(),
                isTenantOptIn: (0, $nK7ig.getIsNav4TenantOptIn)(),
                isUserOptIn: (0, $nK7ig.getIsNav4UserOptIn)(),
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4cTDP.fg)('jira_nav4_ga_sandboxes'),
        ()=>({
                stage: 'ga',
                cohort: 'sandboxes',
                isUserOptIn: (0, $nK7ig.getIsNav4UserOptIn)()
            })
    ],
    [
        ()=>(0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_NONE))
    ]
]);

});


parcelRegister("e9N38", function(module, exports) {
$parcel$export(module.exports, "SidebarSelector", () => $7f3ec08940bc1134$export$7937e2d32a777fcb);

var $eJOHy = parcelRequire("eJOHy");

var $jRu18 = parcelRequire("jRu18");

var $FhXEJ = parcelRequire("FhXEJ");

var $gDXSd = parcelRequire("gDXSd");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");




var $iyTaR = parcelRequire("iyTaR");

var $iMOVa = parcelRequire("iMOVa");

var $iIXZF = parcelRequire("iIXZF");

var $7dhle = parcelRequire("7dhle");

var $bfoC6 = parcelRequire("bfoC6");

var $2EmlI = parcelRequire("2EmlI");

var $kSAnj = parcelRequire("kSAnj");

var $19oS3 = parcelRequire("19oS3");

var $kA5R0 = parcelRequire("kA5R0");

var $av7W4 = parcelRequire("av7W4");

var $fXF6E = parcelRequire("fXF6E");

var $fJ06f = parcelRequire("fJ06f");

var $b2wim = parcelRequire("b2wim");

var $fIogS = parcelRequire("fIogS");

var $a7qPX = parcelRequire("a7qPX");

var $85ZZg = parcelRequire("85ZZg");

var $b2Fy3 = parcelRequire("b2Fy3");

var $jyuS3 = parcelRequire("jyuS3");

var $8vXrD = parcelRequire("8vXrD");

var $1Wo5Y = parcelRequire("1Wo5Y");

var $kDeux = parcelRequire("kDeux");

var $dKJXK = parcelRequire("dKJXK");

var $2ZbI9 = parcelRequire("2ZbI9");

var $1eGpA = parcelRequire("1eGpA");

var $6tXQB = parcelRequire("6tXQB");

var $9b0Rz = parcelRequire("9b0Rz");

var $kGj4V = parcelRequire("kGj4V");

var $2aY2d = parcelRequire("2aY2d");

var $iZ2Qf = parcelRequire("iZ2Qf");

var $kfvK2 = parcelRequire("kfvK2");

var $kfvK2 = parcelRequire("kfvK2");

var $dmxJQ = parcelRequire("dmxJQ");
const $7f3ec08940bc1134$var$entitySettingsSidebarAnalyticsAttributes = {
    navigationLayer: (0, $002870cfa80d64f4$export$33d8c916a600c5e9)
};
const $7f3ec08940bc1134$var$ProjectSettingsSidebarSelector = ()=>{
    const { data: project, loading: loading, error: error } = (0, $2aY2d.useProjectContext)();
    let sidebar = null;
    if (loading) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null);
    if (error) throw error;
    if (project?.projectType === (0, $FhXEJ.CORE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jyuS3.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2Fy3.default), {
        project: project
    });
    if (project?.projectType === (0, $FhXEJ.SOFTWARE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9b0Rz.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tXQB.default), {
        project: project
    });
    if (project?.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDeux.default), {
        project: project
    });
    if (project?.projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('jcs_project_type_m3')) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1eGpA.AsyncJcsProjectSettingsSidebar), {
        project: project
    });
    if (project?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || project?.projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && !(0, $4cTDP.fg)('jcs_project_type_m3')) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZbI9.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKJXK.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $7f3ec08940bc1134$var$entitySettingsSidebarAnalyticsAttributes
    }, sidebar);
};
const $7f3ec08940bc1134$var$ConnectAppSidebarSelector = ()=>{
    const { isActive: isProjectSettingsConnectAppActive } = (0, $1Wo5Y.useIsConnectAppActive)();
    return isProjectSettingsConnectAppActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ProjectSettingsSidebarSelector, null) : null;
};
const $7f3ec08940bc1134$var$BoardSettingsSidebar = ()=>{
    const { data: project, loading: loading, error: error } = (0, $2aY2d.useProjectContext)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bfoC6.Skeleton), null);
    if (error) throw error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $7f3ec08940bc1134$var$entitySettingsSidebarAnalyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7dhle.default), null));
};
const $7f3ec08940bc1134$var$REDIRECT_ROUTES_NAMES = new Set([
    'browse-project-redirect',
    'servicedesk-redirect'
]);
const $7f3ec08940bc1134$var$getSidebarForRoute = (state, { configParam: configParam, shouldUseJSM: shouldUseJSM, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive })=>{
    const sidebarId = state.route.navigation?.sidebarId;
    const pathname = state.location.pathname;
    switch(sidebarId){
        case (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85ZZg.default), null);
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
            if (!pathname.includes('/discover')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSAnj.default), null);
            break;
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $av7W4.default), null);
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $19oS3.default), null);
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
            if (pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM) break;
            return (0, $4cTDP.fg)('jira-delegated-custom-onboarding') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kA5R0.SidebarContentWithRelayResource), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kA5R0.default), null);
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2wim.default), null);
        case (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7qPX.default), null);
        case (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fIogS.default), null);
        case (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ProjectSettingsSidebarSelector, null);
        case (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXF6E.default), null);
        default:
            break;
    }
    if (state.route.name === 'polaris-ideas' && state.match.params.section === 'settings') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ProjectSettingsSidebarSelector, null);
    if (state.route.name === 'your-work') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIXZF.SidebarContent), null);
    if (isProjectSettingsConnectAppActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ConnectAppSidebarSelector, null);
    if (state.route.group === 'classic-software' && (0, $iZ2Qf.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$BoardSettingsSidebar, null);
    if (isGlobalAppsSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSAnj.default), null);
    if (isGlobalSystemSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2wim.default), null);
};
const $7f3ec08940bc1134$export$ac727539f28734c4 = (state)=>{
    return !$7f3ec08940bc1134$var$REDIRECT_ROUTES_NAMES.has(state.route.name);
};
const $7f3ec08940bc1134$export$7ea19f35e3a0b199 = (0, $kfvK2.createRouterSelector)($7f3ec08940bc1134$export$ac727539f28734c4);
const $7f3ec08940bc1134$export$b1253b9403840da1 = ()=>{
    const { saveCurrentRoute: saveCurrentRoute } = (0, $iMOVa.useNavigateBack)();
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $2EmlI.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $fJ06f.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $1Wo5Y.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $gDXSd.useOgTenantInfo)();
    const isNonRedirectRoute = $7f3ec08940bc1134$export$7ea19f35e3a0b199();
    const configParam = (0, $dmxJQ.useMaybeConfigParam)() || '';
    const location = (0, $jRu18.useLocation)();
    const [sidebar, setSidebar] = (0, $eJOHy.useState)($7f3ec08940bc1134$var$getSidebarForRoute((0, $kfvK2.getRouterState)(), {
        configParam: configParam,
        shouldUseJSM: shouldUseJSM,
        isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive
    }));
    (0, $eJOHy.useEffect)(()=>{
        return (0, $kfvK2.addRouteListener)((state)=>{
            setSidebar($7f3ec08940bc1134$var$getSidebarForRoute(state, {
                configParam: state.query.config || state.match.params.config || '',
                isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
                isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
                isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
                shouldUseJSM: shouldUseJSM
            }));
        });
    }, [
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        shouldUseJSM
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // NOTE: We need to AVOID saving the route if we're on a connect app...
        if (!sidebar && isNonRedirectRoute && !isProjectSettingsConnectAppActive) {
            const url = `${location.pathname}${location.search}${location.hash}`;
            saveCurrentRoute(url);
        }
        if (!sidebar && isProjectSettingsConnectAppActive) setSidebar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ConnectAppSidebarSelector, null));
    }, [
        isNonRedirectRoute,
        isProjectSettingsConnectAppActive,
        location,
        saveCurrentRoute,
        sidebar
    ]);
    if (sidebar) return sidebar;
    // Main nav (with "Your work", Starred, Recent items etc.)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIXZF.SidebarContent), null);
};
const $7f3ec08940bc1134$export$7937e2d32a777fcb = ()=>{
    const attributes = (0, $eJOHy.useMemo)(()=>({
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $95eb6070d868c1b7$export$2ee9e5a3556c1e43),
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMOVa.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$export$b1253b9403840da1, null)));
};

});
parcelRegister("7dhle", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe1bdaf97010e9b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bfoC6 = parcelRequire("bfoC6");

const $fe1bdaf97010e9b1$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("auTU5")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
});
const $fe1bdaf97010e9b1$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.board-settings",
        packageName: "jiraNavigationAppsSidebarNav4BoardSettings",
        ufoName: "nav4.sidebar.board-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.board-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bfoC6.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe1bdaf97010e9b1$var$LazySidebarContent, null)));
var $fe1bdaf97010e9b1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($fe1bdaf97010e9b1$var$AsyncSidebar);

});
parcelRegister("bfoC6", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $fde18349018998e4$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");
const $fde18349018998e4$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fde18349018998e4$var$menuItem
    })));
const $fde18349018998e4$var$containerStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $fde18349018998e4$var$backButton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $fde18349018998e4$var$headingSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small',
    flex: 1
});
const $fde18349018998e4$var$menuItem = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("auTU5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hJJuC").then(()=>parcelRequire('7TH4E'));

});


parcelRegister("2EmlI", function(module, exports) {
$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $e4ae8c2197518c01$export$f0785b98c99d344c);
$parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", () => $e4ae8c2197518c01$export$8dd86b1eb9fdf786);
$parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", () => $e4ae8c2197518c01$export$83008eebb9fccef3);

var $eJOHy = parcelRequire("eJOHy");

var $jImTl = parcelRequire("jImTl");

var $gcPEx = parcelRequire("gcPEx");

var $4J9V1 = parcelRequire("4J9V1");

var $8zPcN = parcelRequire("8zPcN");

var $7FIkD = parcelRequire("7FIkD");

var $jRu18 = parcelRequire("jRu18");

var $QaFzq = parcelRequire("QaFzq");
const $e4ae8c2197518c01$var$getItems = (d)=>(0, $gcPEx.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    }).filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)) // remove sections also statically defined
    .map((0, $4J9V1.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $e4ae8c2197518c01$export$f0785b98c99d344c = ()=>{
    const { data: data, loading: loading, error: error } = (0, $8zPcN.useNavigationGlobalResource)();
    const items = (0, $eJOHy.useMemo)(()=>data && $e4ae8c2197518c01$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
};
const $e4ae8c2197518c01$export$ae997bf97ec22b71 = new Set([
    'configurePage',
    'postInstallPage'
]);
const $e4ae8c2197518c01$export$8dd86b1eb9fdf786 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $7FIkD.useConnectGeneralResource)();
    return {
        isActive: $e4ae8c2197518c01$export$ae997bf97ec22b71.has(data?.moduleType),
        loading: loading,
        error: error
    };
};
const $e4ae8c2197518c01$export$83008eebb9fccef3 = ()=>{
    const location = (0, $jRu18.useLocation)();
    const route = (0, $QaFzq.useRoute)();
    const { data: data, loading: loading, error: error } = $e4ae8c2197518c01$export$f0785b98c99d344c();
    const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $e4ae8c2197518c01$export$8dd86b1eb9fdf786();
    const isActive = (0, $eJOHy.useMemo)(()=>Boolean(route && data && (0, $jImTl.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || isAppsSettingsConnectAppModuleActive,
        loading: loading || isAppsSettingsConnectAppModuleLoading,
        error: error || isAppsSettingsConnectAppModuleError
    };
};

});
parcelRegister("jImTl", function(module, exports) {
$parcel$export(module.exports, "findItemAndStack", () => $423836af2db17ab5$export$751e2e6237002565);

var $cSmYj = parcelRequire("cSmYj");

var $artR0 = parcelRequire("artR0");
// JSPA-1062 remove qs items that might not always be there
const $423836af2db17ab5$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $423836af2db17ab5$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $423836af2db17ab5$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $artR0.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $423836af2db17ab5$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $423836af2db17ab5$var$splitRelevantQs(itemQs);
        const sameQuery = $423836af2db17ab5$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $423836af2db17ab5$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("artR0", function(module, exports) {
$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $e09811da2ae6f377$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $e09811da2ae6f377$export$c47bf667d3008c53);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $e09811da2ae6f377$export$50c2d6bcb0b94b74);
const $e09811da2ae6f377$export$a8aac2ba4dc1f57 = new Set([
    'classic-business-overview-summary',
    'classic-business-overview-calendar',
    'classic-business-overview-timeline',
    'classic-business-overview-redirect'
]);
const $e09811da2ae6f377$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $e09811da2ae6f377$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});


parcelRegister("gcPEx", function(module, exports) {
$parcel$export(module.exports, "getLinks", () => $2b95da89bb9dc6db$export$8054dcb2b42da45c);

var $b6kVM = parcelRequire("b6kVM");
const $2b95da89bb9dc6db$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $2b95da89bb9dc6db$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $2b95da89bb9dc6db$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $2b95da89bb9dc6db$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};
const $2b95da89bb9dc6db$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = $2b95da89bb9dc6db$var$getLinksFromSidebar(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $b6kVM.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $b6kVM.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $b6kVM.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("b6kVM", function(module, exports) {
$parcel$export(module.exports, "connectPrefix", () => $97b53aed42af60a7$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $97b53aed42af60a7$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $97b53aed42af60a7$export$b1c2c1fc5d10280);

var $hEw7G = parcelRequire("hEw7G");
const $97b53aed42af60a7$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $97b53aed42af60a7$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $97b53aed42af60a7$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $97b53aed42af60a7$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $97b53aed42af60a7$export$b1c2c1fc5d10280 = [
    $97b53aed42af60a7$var$legacyAddonPanelLinkId,
    (0, $hEw7G.REPORTS_IDS).REPORTS_ADDONS,
    $97b53aed42af60a7$var$jsdQueuesConnectSection
];

});


parcelRegister("4J9V1", function(module, exports) {
$parcel$export(module.exports, "transformLink", () => $eb68c1498c872b65$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $eb68c1498c872b65$export$27267b6b6650eaa5);
const $eb68c1498c872b65$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($eb68c1498c872b65$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $eb68c1498c872b65$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($eb68c1498c872b65$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});

parcelRegister("8zPcN", function(module, exports) {
$parcel$export(module.exports, "useNavigationGlobalResource", () => $1b2e4ec3360c640b$export$1e1c317ed5b99faa);

var $enHI7 = parcelRequire("enHI7");

var $eJrcF = parcelRequire("eJrcF");
const $1b2e4ec3360c640b$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $enHI7.navigationSidebarGlobalResource));
    return {
        data: data && data.response,
        loading: loading,
        error: error
    };
};

});

parcelRegister("7FIkD", function(module, exports) {
$parcel$export(module.exports, "connectGeneralResources", () => $ac1e673dd620ded4$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $ac1e673dd620ded4$export$53479840ec6d4024);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $ac1e673dd620ded4$export$f34ab0d904621847 = (0, $l1VxS.createResource)({
    type: (0, $ac8db659dabbf119$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("fdpYe"))
});
const $ac1e673dd620ded4$export$53479840ec6d4024 = ()=>(0, $eJrcF.useResource)($ac1e673dd620ded4$export$f34ab0d904621847);

});
const $ac8db659dabbf119$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("fdpYe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1qduh").then(()=>parcelRequire('cu1Rj'));

});



parcelRegister("kSAnj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d321428aa869415$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $8d321428aa869415$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("39TZh")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
});
const $8d321428aa869415$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.apps-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings",
        ufoName: "nav4.sidebar.global-settings.apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "apps",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-apps.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.global-settings.apps-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8d321428aa869415$var$LazySidebarContent, null))));
};
var $8d321428aa869415$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($8d321428aa869415$var$AsyncSidebar);

});
parcelRegister("bYKAe", function(module, exports) {
$parcel$export(module.exports, "SidebarContent", () => $77dbf0d832306973$export$49e8f7b58a4df4ea);

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $85fS3 = parcelRequire("85fS3");
var $7tCmu = parcelRequire("7tCmu");
var $j5kZH = parcelRequire("j5kZH");

var $lRq8t = parcelRequire("lRq8t");

var $dmCMv = parcelRequire("dmCMv");

var $6mubb = parcelRequire("6mubb");

var $8Ik7k = parcelRequire("8Ik7k");
const $77dbf0d832306973$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName, testId: testId = 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j5kZH.SideNavHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200",
        xcss: $77dbf0d832306973$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        grow: "hug",
        space: "space.100",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dmCMv.BackButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $8Ik7k.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6mubb.AsyncPageSwitcher), {
        currentPageName: currentPageName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tCmu.SideNavContent), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, children)));
};
const $77dbf0d832306973$var$headingStyles = (0, $1DXK0.xcss)({
    // 4px of left padding is added to align the back icon with the side nav toggle button
    paddingInlineStart: 'space.050'
});

});
parcelRegister("j5kZH", function(module, exports) {
$parcel$export(module.exports, "SideNavHeader", () => $eb6a5d5ab24d33e9$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $eb6a5d5ab24d33e9$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
};
const $eb6a5d5ab24d33e9$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $eb6a5d5ab24d33e9$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("dmCMv", function(module, exports) {
$parcel$export(module.exports, "BackButton", () => $03ccf5889850875c$export$e0d897ee21382f67);

var $eJOHy = parcelRequire("eJOHy");

var $6K3F5 = parcelRequire("6K3F5");

var $aqu01 = parcelRequire("aqu01");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iMOVa = parcelRequire("iMOVa");

var $hJP5z = parcelRequire("hJP5z");
function $03ccf5889850875c$export$e0d897ee21382f67() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { previousUrl: previousUrl } = (0, $iMOVa.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $hJP5z.default).tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K3F5.default), {
        href: previousUrl || '',
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aqu01))),
        label: formatMessage((0, $hJP5z.default).label),
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
        }
    }));
}

});
parcelRegister("hJP5z", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a9705df1d6b4200$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4a9705df1d6b4200$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
        "defaultMessage": "Go back"
    },
    label: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
        "defaultMessage": "Navigate back to the previous page"
    }
});

});


parcelRegister("6mubb", function(module, exports) {
$parcel$export(module.exports, "AsyncPageSwitcher", () => $268b1c2797b82553$export$3130bd98029942c);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");
const $268b1c2797b82553$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $268b1c2797b82553$var$headingSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $268b1c2797b82553$var$dropdownSkeleton
    }));

const $268b1c2797b82553$var$LazyPageSwitcher = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4eF6Z")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
});
const $268b1c2797b82553$export$3130bd98029942c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.global-settings.page-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($268b1c2797b82553$export$8f31e4c4a37b8e9c, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($268b1c2797b82553$var$LazyPageSwitcher, props));
const $268b1c2797b82553$var$headingSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small'
});
const $268b1c2797b82553$var$dropdownSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});
parcelRegister("4eF6Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lprQB").then(()=>parcelRequire('iBhA4'));

});


parcelRegister("8Ik7k", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c3432e4bbefd7de$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6c3432e4bbefd7de$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
        "defaultMessage": "Jira admin settings"
    }
});

});


parcelRegister("er9fy", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $61ade8359bd67b6e$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");
const $61ade8359bd67b6e$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }));
const $61ade8359bd67b6e$var$sectionHeading = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small',
    marginTop: 'space.100'
});
const $61ade8359bd67b6e$var$menuItem = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("39TZh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i5bWQ").then(()=>parcelRequire('kNLEl'));

});


parcelRegister("19oS3", function(module, exports) {
$parcel$export(module.exports, "default", () => $778f70e057490678$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $778f70e057490678$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1SRzF")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
});
const $778f70e057490678$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.issues-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings",
        ufoName: "nav4.sidebar.global-settings.issues-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "issues",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-issues.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.global-settings.issues-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($778f70e057490678$var$LazySidebarContent, null))));
};
var $778f70e057490678$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($778f70e057490678$var$AsyncSidebar);

});
parcelRegister("1SRzF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gCA9W").then(()=>parcelRequire('8gRGg'));

});


parcelRegister("kA5R0", function(module, exports) {
$parcel$export(module.exports, "SidebarContentWithRelayResource", () => $bfd553c106a4aa5c$export$f9e0a9fab11f158);
$parcel$export(module.exports, "SidebarContentForEntryPoint", () => $bfd553c106a4aa5c$export$ece6bd06aa8b2350);
$parcel$export(module.exports, "default", () => $bfd553c106a4aa5c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kmmPh = parcelRequire("kmmPh");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $9FYIg = parcelRequire("9FYIg");

var $hyK5y = parcelRequire("hyK5y");

var $dT1gY = parcelRequire("dT1gY");
function $bfd553c106a4aa5c$export$f9e0a9fab11f158() {
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $kmmPh.nav4SidebarGlobalProductsSettingsResource));
    const queryReferenceRef = (0, $eJOHy.useRef)(null);
    // We don't want to use null query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bfd553c106a4aa5c$export$a18798f247d81ed3, {
        queryReference: queryReferenceRef.current
    });
}
function $bfd553c106a4aa5c$export$ece6bd06aa8b2350({ queries: { nav4SidebarGlobalProductsSettings: nav4SidebarGlobalProductsSettings } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bfd553c106a4aa5c$export$a18798f247d81ed3, {
        queryReference: nav4SidebarGlobalProductsSettings
    });
}
function $bfd553c106a4aa5c$export$a18798f247d81ed3({ queryReference: queryReference }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "sidebarNav4GlobalProductsSettings",
        ufoName: "nav4.sidebar.global-settings.products-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "products",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dT1gY.GlobalProductsSettingsSidebar), {
        queryReference: queryReference
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hyK5y.SidebarReady), null));
}

const $bfd553c106a4aa5c$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("bRVxo")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
});
const $bfd553c106a4aa5c$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings",
        ufoName: "nav4.sidebar.global-settings.products-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "products",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bfd553c106a4aa5c$var$LazySidebarContent, null))));
};
var $bfd553c106a4aa5c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($bfd553c106a4aa5c$var$AsyncSidebar);

});
parcelRegister("dT1gY", function(module, exports) {
$parcel$export(module.exports, "GlobalProductsSettingsSidebar", () => $50ebbf9e36d33063$export$b53f6a7c7db3c559);

var $aYXFw = parcelRequire("aYXFw");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9itkV = parcelRequire("9itkV");

var $dLR8J = parcelRequire("dLR8J");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $bo95Y = parcelRequire("bo95Y");

var $er9fy = parcelRequire("er9fy");

var $hBW9p = parcelRequire("hBW9p");

var $2gm1I = parcelRequire("2gm1I");

var $5G77c = parcelRequire("5G77c");

var $6JnBx = parcelRequire("6JnBx");

var $2OUWs = parcelRequire("2OUWs");

var $bXWRP = parcelRequire("bXWRP");

var $bDDG3 = parcelRequire("bDDG3");

var $jPX3R = parcelRequire("jPX3R");

var $i5EnI = parcelRequire("i5EnI");

var $fFJFj = parcelRequire("fFJFj");

var $2eQJy = parcelRequire("2eQJy");
// When the FG `jira-delegated-custom-onboarding`is disabled, this component will be
// replaced by the component in main.tsx, so if you are making changes here, please also
// make them there.
const $50ebbf9e36d33063$var$GlobalProductsSettingsSidebarInner = ({ queryReference: queryReference })=>{
    const productAccessItemAppify = (0, $4cTDP.fg)('product-terminology-refresh') ? (0, $2OUWs.default).productAccessItemAppify : (0, $2OUWs.default).productAccessItem;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: features } = (0, $2gm1I.useFeatures)();
    const queryData = (0, $j4oe4.usePreloadedQuery)((0, $aYXFw.default), queryReference);
    if (!features) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "products-data-loading"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, features.hasApplicationAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'productAccess'
        },
        href: "/secure/admin/ApplicationAccess.jspa",
        target: "_blank",
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #44546F)"
        })
    }, formatMessage(productAccessItemAppify)), features.hasSoftwareSection && features.hasSoftwareConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6JnBx.default), null), !(features.hasSoftwareSection && features.hasSoftwareConfig) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2eQJy.DelegatedAdminJiraSection), {
        queryReference: queryData
    }), features.hasPlansSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bDDG3.default), null), features.hasServiceManagementSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i5EnI.default), {
        features: features
    }), features.hasCustomerServiceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFJFj.default), null), features.hasOperationsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXWRP.default), {
        features: features
    }), features.hasProductDiscoverySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jPX3R.default), null), features.hasIntegrationsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5G77c.default), {
        features: features
    }));
};
const $50ebbf9e36d33063$export$b53f6a7c7db3c559 = /*#__PURE__*/ (0, $eJOHy.memo)($50ebbf9e36d33063$var$GlobalProductsSettingsSidebarInner);

});
parcelRegister("hBW9p", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $bd1981fe33267082$export$f21504b774272faa);
const $bd1981fe33267082$export$f21504b774272faa = {
    actionSubjectId: 'globalJiraSettingsNavigationMenuItem',
    componentType: 'fixedItem',
    level: 1,
    settingsGroup: 'products'
};

});

parcelRegister("2gm1I", function(module, exports) {
$parcel$export(module.exports, "useFeatures", () => $35a189036ff7dd09$export$4a39035bacc4ed76);

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");

var $d9tVV = parcelRequire("d9tVV");

var $gDXSd = parcelRequire("gDXSd");

var $azlgS = parcelRequire("azlgS");

var $8zPcN = parcelRequire("8zPcN");

var $jluD1 = parcelRequire("jluD1");


var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");

var $koAZ4 = parcelRequire("koAZ4");

var $4cTDP = parcelRequire("4cTDP");
const $35a189036ff7dd09$export$4a39035bacc4ed76 = (0, $azlgS.withThrowOnError)(()=>{
    const { data: navigationGlobalResourceData, loading: navigationGlobalResourceLoading, error: navigationGlobalResourceError } = // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    (0, $8zPcN.useNavigationGlobalResource)();
    const { shouldUseJSM: shouldUseJSM, shouldAccessUnlockOperations: shouldAccessUnlockOperations, isTransitioning: isTransitioning, loading: ogTenantInfoLoading, error: ogTenantInfoError } = // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    (0, $gDXSd.useOgTenantInfo)();
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    const tenantContext = (0, $koAZ4.useTenantContext)();
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    const appEditions = (0, $1BZ8a.useAppEditions)();
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    const { hasKeys: hasKeys, loading: apiKeyManagementLoading } = (0, $d9tVV.useApiKeyManagementInfo)();
    if ((0, $4cTDP.fg)('jira-delegated-custom-onboarding')) {
        // There are two considerations here to prevent flickering in the nav sidebar:
        // 1. When the EOC_TENANT resource (used by `useOgTenantInfo`) fails to fetch from the server,
        // a refetch is triggered *once* from the client. This means that if there is a server-side
        // ogTenantInfoError, we should wait for the client-side refetch to complete before returning
        // a non-null value for `data`.
        // 2. The EOC_CHECK_API_KEY resource (used by `useApiKeyManagementInfo`) is a browser-only
        // resource that is dependent on the EOC_TENANT resource. This means that we shouldn't wait
        // for it to load before rendering the nav sidebar.
        const ogTenantInfoServerError = false ? ogTenantInfoError : null;
        if (navigationGlobalResourceLoading || !navigationGlobalResourceData || ogTenantInfoLoading || ogTenantInfoServerError && (0, $4cTDP.fg)('refresh_tenant_info_on_client_for_ssr_error')) return {
            data: null,
            loading: navigationGlobalResourceLoading || ogTenantInfoLoading,
            error: (0, $4cTDP.fg)('refresh_tenant_info_on_client_for_ssr_error') ? navigationGlobalResourceError || ogTenantInfoServerError : navigationGlobalResourceError
        };
    } else if (navigationGlobalResourceLoading || !navigationGlobalResourceData || ogTenantInfoLoading || apiKeyManagementLoading) return {
        data: null,
        loading: navigationGlobalResourceLoading || ogTenantInfoLoading || apiKeyManagementLoading,
        error: navigationGlobalResourceError
    };
    const hasJsmAboveStandard = !!tenantContext.licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $cblKs.FREE_EDITION) && appEditions.serviceDesk !== (0, $cblKs.STANDARD_EDITION);
    const hasShiftFromOpsgenieToJira = shouldAccessUnlockOperations;
    const hideFeaturesIsolatedCloud = (0, $7pw1V.isIsolatedCloud)() && (0, $4cTDP.fg)('hide_chatops_component_in_isolated_cloud');
    const hasChatOpsToolAccess = !shouldUseJSM && !!tenantContext.licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] && !(0, $lopBx.isFedRamp)() && !hideFeaturesIsolatedCloud;
    return {
        data: {
            hasApiKeyManagementAccess: isTransitioning && shouldUseJSM && hasJsmAboveStandard && tenantContext.isSiteAdmin && hasKeys,
            hasApplicationAccess: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'application_access_browser'),
            hasApplicationLinksIntegration: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'configure-application-links'),
            hasAuditLogsAccess: shouldUseJSM && !!tenantContext.licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61],
            hasChatOpsToolAccess: hasChatOpsToolAccess,
            hasCompassPageIntegration: tenantContext.isSiteAdmin && !!tenantContext.licensedProducts[0, $315aedf92e50a945$export$1346c9aa3cbb477d],
            hasConfluencePageIntegration: tenantContext.isAdmin,
            hasCustomerServiceSection: tenantContext.isAdmin && !!tenantContext.licensedProducts[0, $315aedf92e50a945$export$e9c56aa3b027d98f] && (0, $4cTDP.fg)('jcs_master_flag'),
            hasDvcsAccountsIntegration: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'bitbucket_bulk_repo'),
            hasGlobalIncomingCallAccess: shouldUseJSM && hasJsmAboveStandard,
            hasGlobalIntegrationAccess: shouldUseJSM && hasJsmAboveStandard,
            hasGlobalSyncAccess: shouldUseJSM && hasJsmAboveStandard,
            hasIntegrationsSection: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'admin_applications_integrations_section'),
            hasMaintenanceAccess: shouldUseJSM && !!tenantContext.licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61],
            hasShiftFromOpsgenieToJira: hasShiftFromOpsgenieToJira,
            hasOperationsSection: tenantContext.isAdmin && Boolean(tenantContext.licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61]) && (hasShiftFromOpsgenieToJira || hasChatOpsToolAccess),
            hasOrganizationsListAccess: !!tenantContext.licensedProducts[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] && tenantContext.isAdmin,
            hasPlansSection: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'jpo-ws-main-admin'),
            hasPoliciesAccess: shouldUseJSM && hasJsmAboveStandard,
            hasProductDiscoverySection: tenantContext.isAdmin && appEditions.productDiscovery !== (0, $cblKs.UNLICENSED),
            hasRoleBasedNotificationsAccess: shouldUseJSM && tenantContext.isAdmin && hasJsmAboveStandard,
            hasServiceManagementAuthenticationSettings: tenantContext.isAdmin && appEditions.serviceDesk !== (0, $cblKs.UNLICENSED),
            hasServiceManagementConfig: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'sd-configuration-link'),
            hasServiceManagementCustomerAccess: tenantContext.isAdmin && appEditions.serviceDesk !== (0, $cblKs.UNLICENSED),
            hasServiceManagementEmailRequests: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'sd-admin-mail-info-link'),
            hasServiceManagementIncidentManagementTools: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'sd-incident-management-tools-link'),
            hasServiceManagementKbPermissionsAccess: tenantContext.isAdmin,
            hasServiceManagementSection: (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'sd-plugin-admin-section'),
            hasSoftwareConfig: tenantContext.isAdmin,
            hasSoftwareSection: tenantContext.isAdmin,
            hasStatusPageIntegration: !!tenantContext.atlassianAccountId && (0, $jluD1.hasItemInSidebar)(navigationGlobalResourceData, 'jsd-status-page__admin-page')
        },
        loading: navigationGlobalResourceLoading,
        error: navigationGlobalResourceError
    };
});

});
parcelRegister("d9tVV", function(module, exports) {
$parcel$export(module.exports, "useApiKeyManagementInfo", () => $ef296f4fc9c18eb9$export$19350f4f23ab0aaf);

var $9CgFv = parcelRequire("9CgFv");

var $eJrcF = parcelRequire("eJrcF");
const $ef296f4fc9c18eb9$export$19350f4f23ab0aaf = ()=>{
    const { loading: loading, error: error, data: data } = (0, $eJrcF.useResource)((0, $9CgFv.checkApiKeyManagementKeysResource)());
    return {
        hasKeys: data ?? false,
        loading: loading,
        error: error
    };
};

});

parcelRegister("azlgS", function(module, exports) {
$parcel$export(module.exports, "withThrowOnError", () => $bf2fcf741dfd4e8c$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gRw8I = parcelRequire("gRw8I");
const $bf2fcf741dfd4e8c$var$isDataEmpty = (data)=>data == null;
function $bf2fcf741dfd4e8c$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gRw8I.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $bf2fcf741dfd4e8c$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("jluD1", function(module, exports) {
$parcel$export(module.exports, "hasItemInSidebar", () => $2897a7dede313ff2$export$57dd40eec4c64521);
const $2897a7dede313ff2$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $2897a7dede313ff2$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $2897a7dede313ff2$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $2897a7dede313ff2$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $2897a7dede313ff2$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($2897a7dede313ff2$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));

});


parcelRegister("5G77c", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f095d997211459c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7pw1V = parcelRequire("7pw1V");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $bo95Y = parcelRequire("bo95Y");

var $hih5V = parcelRequire("hih5V");

var $jom8W = parcelRequire("jom8W");

var $koAZ4 = parcelRequire("koAZ4");

var $hryl7 = parcelRequire("hryl7");

var $4Blh2 = parcelRequire("4Blh2");
const $9f095d997211459c$var$IntegrationsSection = ({ features: features })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { atlassianAccountId: atlassianAccountId } = (0, $koAZ4.useTenantContext)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $4Blh2.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, features.hasApplicationLinksIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $hryl7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'applicationLinks'
        },
        isSelected: currentRoute.name === 'global-settings-products-applinks',
        href: "/plugins/servlet/applinks/listApplicationLinks"
    }, formatMessage((0, $4Blh2.default).applicationLinksItem)), features.hasCompassPageIntegration && !(0, $7pw1V.isFedrampModerate)() && !((0, $7pw1V.isIsolatedCloud)() && (0, $4cTDP.fg)('hide_isolated_cloud_compass_component_in_jira')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $hryl7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'compass'
        },
        isSelected: currentRoute.name === 'compass-product-settings',
        href: "/jira/settings/products/compass"
    }, formatMessage((0, $4Blh2.default).compassItem)), features.hasDvcsAccountsIntegration && !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $hryl7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'dvcsAccounts'
        },
        isSelected: currentRoute.name === 'global-settings-products-dvcs',
        href: "/secure/admin/ConfigureDvcsOrganizations!default.jspa"
    }, formatMessage((0, $4Blh2.default).dvcsAccountsItem)), features.hasStatusPageIntegration && !!atlassianAccountId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $hryl7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'statuspage'
        },
        isSelected: currentRoute.name === 'global-settings-products-jsd-status',
        href: `/plugins/servlet/ac/jsd-status-page/admin-page?user.key=${atlassianAccountId}&user.id=${atlassianAccountId}`
    }, formatMessage((0, $4Blh2.default).statuspageItem))));
};
var $9f095d997211459c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($9f095d997211459c$var$IntegrationsSection);

});
parcelRegister("jom8W", function(module, exports) {
$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $f1cf95014072f374$export$18bfef4995ec57b7);

var $lopBx = parcelRequire("lopBx");
const $f1cf95014072f374$export$18bfef4995ec57b7 = ()=>(0, $lopBx.isFedRamp)();

});

parcelRegister("hryl7", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $0d10497ab4329c7f$export$f21504b774272faa);

var $hBW9p = parcelRequire("hBW9p");
const $0d10497ab4329c7f$export$f21504b774272faa = {
    ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'integrations'
};

});

parcelRegister("4Blh2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1be32a65059a92db$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1be32a65059a92db$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.heading",
        "defaultMessage": "Integrations"
    },
    applicationLinksItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.application-links-item",
        "defaultMessage": "Application links"
    },
    dvcsAccountsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.dvcs-accounts-item",
        "defaultMessage": "DVCS accounts"
    },
    statuspageItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.statuspage-item",
        "defaultMessage": "Statuspage"
    },
    compassItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.compass-item",
        "defaultMessage": "Compass"
    },
    confluenceItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.confluence-item",
        "defaultMessage": "Confluence"
    }
});

});


parcelRegister("6JnBx", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa7d753ebced51a9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $jdqdp = parcelRequire("jdqdp");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $j2LFL = parcelRequire("j2LFL");

var $bo95Y = parcelRequire("bo95Y");

var $hih5V = parcelRequire("hih5V");

var $kmUlG = parcelRequire("kmUlG");

var $kZBCy = parcelRequire("kZBCy");
const $aa7d753ebced51a9$var$JiraSection = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const isPremium = (0, $j2LFL.useIsPremiumJSW)();
    const customOnboardinLozengeMessage = !isPremium && (0, $4cTDP.fg)('restrict-custom-onboarding-to-premium-tier') ? (0, $kZBCy.default).premiumLabel : (0, $kZBCy.default).newLabel;
    const shouldShowLozenge = !isPremium || (0, $4cTDP.fg)('onboarding-hub-new-lozenge');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $kZBCy.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $kmUlG.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'jiraConfiguration'
        },
        isSelected: currentRoute.name === 'products-jsw-configuration',
        href: "/jira/settings/products/jira-software-configuration"
    }, formatMessage((0, $kZBCy.default).configurationItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $kmUlG.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'storeManagement'
        },
        isSelected: currentRoute.name === 'products-jsw-storage-management',
        href: "/jira/settings/products/jira-software-configuration/storage-management"
    }, formatMessage((0, $kZBCy.default).storeManagementItem)), (0, $4cTDP.fg)('jira-guest-access') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $kmUlG.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'guestAccess'
        },
        isSelected: currentRoute.name === 'products-jsw-guest-access',
        href: "/jira/settings/products/jira-software-configuration/guest-access"
    }, formatMessage((0, $kZBCy.default).guestAccessItem)), (0, $4cTDP.fg)('jira-onboarding-hub-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $kmUlG.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'onboardingHub'
        },
        isSelected: [
            'products-onboarding-hub',
            'products-onboarding-hub-create',
            'products-onboarding-hub-edit'
        ].includes(currentRoute.name),
        href: "/jira/settings/products/onboarding",
        elemAfter: shouldShowLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new"
        }, formatMessage(customOnboardinLozengeMessage)) : null
    }, formatMessage((0, $kZBCy.default).onboardingHubItem))));
};
var $aa7d753ebced51a9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($aa7d753ebced51a9$var$JiraSection);

});
parcelRegister("kmUlG", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $5e8c24f22b8b6bfa$export$f21504b774272faa);

var $hBW9p = parcelRequire("hBW9p");
const $5e8c24f22b8b6bfa$export$f21504b774272faa = {
    ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'jira'
};

});

parcelRegister("kZBCy", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd005025a9419b66$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $dd005025a9419b66$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.heading",
        "defaultMessage": "Jira"
    },
    configurationItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.configuration-item",
        "defaultMessage": "Jira configuration"
    },
    storeManagementItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.store-management-item",
        "defaultMessage": "Storage management"
    },
    guestAccessItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.guest-access-item.non-final",
        "defaultMessage": "Site access"
    },
    onboardingHubItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.onboarding-hub-item",
        "defaultMessage": "Custom onboarding"
    },
    newLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.new-label",
        "defaultMessage": "New"
    },
    premiumLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.premium-label",
        "defaultMessage": "Premium"
    }
});

});


parcelRegister("2OUWs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db1129edebecd86$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4db1129edebecd86$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    productAccessItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-access-item",
        "defaultMessage": "Product access"
    },
    productAccessItemAppify: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-access-item-appify",
        "defaultMessage": "App access"
    }
});

});

parcelRegister("bXWRP", function(module, exports) {
$parcel$export(module.exports, "default", () => $864ecd9e3a8f83d7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $bo95Y = parcelRequire("bo95Y");

var $hih5V = parcelRequire("hih5V");

var $7RvyA = parcelRequire("7RvyA");

var $dYLhK = parcelRequire("dYLhK");
const $864ecd9e3a8f83d7$var$OperationsSection = ({ features: features })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $dYLhK.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, features?.hasShiftFromOpsgenieToJira && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $7RvyA.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'moveFromOpsgenieToJira'
        },
        isSelected: currentRoute.name === 'eoc-unlock-operations',
        href: "/jira/settings/products/ops/unlock",
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new"
        }, formatMessage((0, $dYLhK.default).newLozenge))
    }, formatMessage((0, $dYLhK.default).shiftFromOpsgenieToJiraItem)), features?.hasChatOpsToolAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $7RvyA.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'jsm-chatops-tools'
        },
        href: "/jira/settings/products/ops/jira-service-management-chatops-and-video-tools",
        isSelected: currentRoute.name === 'products-jsm-chatops-and-videos-tools'
    }, formatMessage((0, $dYLhK.default).chatopsToolsItem))));
};
var $864ecd9e3a8f83d7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($864ecd9e3a8f83d7$var$OperationsSection);

});
parcelRegister("7RvyA", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $7d5ee8f623756865$export$f21504b774272faa);

var $hBW9p = parcelRequire("hBW9p");
const $7d5ee8f623756865$export$f21504b774272faa = {
    ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'operations'
};

});

parcelRegister("dYLhK", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b884ab956ffae64$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9b884ab956ffae64$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.heading",
        "defaultMessage": "Operations"
    },
    shiftFromOpsgenieToJiraItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.shift-from-opsgenie-to-jira-item",
        "defaultMessage": "Move from Opsgenie to Jira"
    },
    newLozenge: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.new-lozenge",
        "defaultMessage": "New"
    },
    chatopsToolsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.chatops-tools-item",
        "defaultMessage": "Chat and video tools"
    }
});

});


parcelRegister("bDDG3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d28b01a5f489e408$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $fXko7 = parcelRequire("fXko7");

var $78pop = parcelRequire("78pop");

var $bo95Y = parcelRequire("bo95Y");

var $hih5V = parcelRequire("hih5V");

var $1JKq5 = parcelRequire("1JKq5");

var $hcASN = parcelRequire("hcASN");
const $d28b01a5f489e408$var$PlansSection = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, formatMessage((0, $hcASN.default).heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXko7.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78pop.PaidFeatureAwarenessGemIcon), {
            edition: "premium"
        }),
        placement: "navigation.plan.settings"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $1JKq5.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'permissions'
        },
        isSelected: currentRoute.name === 'arj-settings-permissions',
        href: "/jira/plans/settings/permissions"
    }, formatMessage((0, $hcASN.default).permissionsItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $1JKq5.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'hierarchyConfiguration'
        },
        isSelected: currentRoute.name === 'global-settings-issues-hierarchy-view',
        href: "/jira/settings/issues/issue-hierarchy"
    }, formatMessage((0, $hcASN.default).hierarchyItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $1JKq5.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'dependencies'
        },
        isSelected: currentRoute.name === 'arj-settings-dependencies',
        href: "/jira/plans/settings/dependencies"
    }, formatMessage((0, $hcASN.default).dependenciesItem)), (0, $4cTDP.fg)('jira_plans_loading_limits_configurability_stsg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $1JKq5.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'loadingLimits'
        },
        isSelected: currentRoute.name === 'arj-settings-loading-limits',
        href: "/jira/plans/settings/loading-limits"
    }, formatMessage((0, $hcASN.default).loadingLimitsItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $1JKq5.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'trash'
        },
        isSelected: currentRoute.name === 'trash-plans-directory',
        href: "/jira/plans/settings/trash"
    }, formatMessage((0, $hcASN.default).trashedPlansItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $1JKq5.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'archive'
        },
        isSelected: currentRoute.name === 'archived-plans-directory',
        href: "/jira/plans/settings/archive"
    }, formatMessage((0, $hcASN.default).archiveItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $1JKq5.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'financialYear'
        },
        isSelected: currentRoute.name === 'arj-settings-financial-year',
        href: "/jira/plans/settings/financial-year"
    }, formatMessage((0, $hcASN.default).financialYearItem))));
};
var $d28b01a5f489e408$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($d28b01a5f489e408$var$PlansSection);

});
parcelRegister("78pop", function(module, exports) {
$parcel$export(module.exports, "PaidFeatureAwarenessGemIcon", () => $a8ef65fec58e1a10$export$4bf8473d85c81d07);

var $eJOHy = parcelRequire("eJOHy");

var $4fzUT = parcelRequire("4fzUT");

var $6BR9Q = parcelRequire("6BR9Q");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $b8Zvn = parcelRequire("b8Zvn");
const $a8ef65fec58e1a10$export$4bf8473d85c81d07 = ({ edition: edition = 'premium', tooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = customTooltipContent || (edition === 'premium' ? formatMessage((0, $b8Zvn.default).premiumTooltip) : formatMessage((0, $b8Zvn.default).standardGemTooltip));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fzUT))), {
        label: "",
        color: "var(--ds-icon-discovery, #8270DB)"
    }));
};
const $a8ef65fec58e1a10$export$fbe0c8cacb8aec2b = ({ tooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = customTooltipContent || formatMessage((0, $b8Zvn.default).automationTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6BR9Q))), {
        label: tooltipContent,
        color: "var(--ds-icon-discovery, #8270DB)"
    }));
};

});
parcelRegister("6BR9Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2379769942b452821345d3db8e1641c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cff6ecfc53acec2$var$_react = $4cff6ecfc53acec2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4cff6ecfc53acec2$var$_baseNew = $4cff6ecfc53acec2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4cff6ecfc53acec2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cff6ecfc53acec2$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $4cff6ecfc53acec2$var$_react.default.createElement($4cff6ecfc53acec2$var$_baseNew.default, Object.assign({
        name: "InformationCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$4cff6ecfc53acec2$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $4cff6ecfc53acec2$var$_default = module.exports.default = $4cff6ecfc53acec2$var$InformationCircleIcon;

});


parcelRegister("1JKq5", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $bae06e6425ef8168$export$f21504b774272faa);

var $hBW9p = parcelRequire("hBW9p");
const $bae06e6425ef8168$export$f21504b774272faa = {
    ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'plans'
};

});

parcelRegister("hcASN", function(module, exports) {
$parcel$export(module.exports, "default", () => $f410130d6681f1e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f410130d6681f1e6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.heading",
        "defaultMessage": "Plans"
    },
    permissionsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.permissions-item",
        "defaultMessage": "Permissions"
    },
    hierarchyItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.hierarchy-item",
        "defaultMessage": "Hierarchy configuration"
    },
    dependenciesItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.dependencies-item",
        "defaultMessage": "Dependencies"
    },
    loadingLimitsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.loading-limits-item",
        "defaultMessage": "Loading limits"
    },
    financialYearItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.financial-year-item",
        "defaultMessage": "Financial year"
    },
    archivedPlansItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.archived-plans-item",
        "defaultMessage": "Archived plans"
    },
    archiveItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.archive-item",
        "defaultMessage": "Archive"
    },
    trashedPlansItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.trashed-plans-item",
        "defaultMessage": "Trash"
    }
});

});


parcelRegister("jPX3R", function(module, exports) {
$parcel$export(module.exports, "default", () => $90ee5d398995c7e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $9PlH8 = parcelRequire("9PlH8");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $bo95Y = parcelRequire("bo95Y");

var $hih5V = parcelRequire("hih5V");

var $fRXNt = parcelRequire("fRXNt");

var $hbF3h = parcelRequire("hbF3h");

var $dnmTP = parcelRequire("dnmTP");

var $kAWDh = parcelRequire("kAWDh");
const $90ee5d398995c7e8$export$2fe417465fdd5838 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jpd-prebuilt-views-lozenge-location-update'), ()=>(0, $9PlH8.useHasUserEngagedWithBlueprints)(), ()=>true);
const $90ee5d398995c7e8$var$ProductDiscoverySection = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const isConnectionsEntitlementEnabled = (0, $fRXNt.useIsConnectionsEnabled)();
    const hasUserEngagedWithBlueprints = $90ee5d398995c7e8$export$2fe417465fdd5838();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $kAWDh.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $dnmTP.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'access'
        },
        isSelected: currentRoute.name === 'polaris-settings-access',
        href: "/jira/settings/products/jira-product-discovery/access"
    }, formatMessage((0, $kAWDh.default).accessItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $dnmTP.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'globalFields'
        },
        isSelected: currentRoute.name === 'polaris-settings-global-fields',
        href: "/jira/settings/products/jira-product-discovery/global-fields"
    }, formatMessage((0, $kAWDh.default).globalFieldsItem)), (0, $4cTDP.fg)('jpd-view-templates-sample-project') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $dnmTP.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'viewBlueprints'
        },
        isSelected: currentRoute.name === 'polaris-settings-view-blueprints',
        href: "/jira/settings/products/jira-product-discovery/view-blueprints",
        elemAfter: hasUserEngagedWithBlueprints ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new"
        }, formatMessage((0, $kAWDh.default).viewBlueprintsItemLozenge))
    }, formatMessage((0, $kAWDh.default).viewBlueprintsItem)), (0, $4cTDP.fg)('polaris_pol-14239_custom_quarters') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $dnmTP.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'jpdDates'
        },
        isSelected: currentRoute.name === 'polaris-settings-financial-year',
        href: "/jira/settings/products/jira-product-discovery/dates"
    }, formatMessage((0, $kAWDh.default).datesItem)), isConnectionsEntitlementEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $dnmTP.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'betaFeatures'
        },
        isSelected: currentRoute.name === 'polaris-settings-early-access-features',
        href: "/jira/settings/products/jira-product-discovery/early-access-features",
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new",
            isBold: true
        }, formatMessage((0, $kAWDh.default).betaFeaturesItemLozenge))
    }, formatMessage((0, $kAWDh.default).betaFeaturesItem))));
};
var $90ee5d398995c7e8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($90ee5d398995c7e8$var$ProductDiscoverySection);

});
parcelRegister("9PlH8", function(module, exports) {
$parcel$export(module.exports, "useHasUserEngagedWithBlueprints", () => $9b672d25918b25e5$export$feee2dd15fcc19e4);

var $cROXo = parcelRequire("cROXo");
const $9b672d25918b25e5$var$BLUEPRINTS_TOUR_SPOTLIGHTS = 'polaris.blueprints.tour.spotlights';
const $9b672d25918b25e5$export$feee2dd15fcc19e4 = ()=>{
    const blueprintsTourState = (0, $cROXo.useUserPropertyAsObject)($9b672d25918b25e5$var$BLUEPRINTS_TOUR_SPOTLIGHTS);
    return blueprintsTourState?.tourDismissed === true;
};

});
parcelRegister("cROXo", function(module, exports) {
$parcel$export(module.exports, "useUserPropertyAsObject", () => $667f5df09615b47b$export$90ac620d5657b6dc);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $14RSn = parcelRequire("14RSn");

var $3Dkf3 = parcelRequire("3Dkf3");

var $3MbOI = parcelRequire("3MbOI");
function $667f5df09615b47b$export$90ac620d5657b6dc(property, userId) {
    const { data: currentUser } = (0, $3MbOI.useCurrentUser)();
    const user = userId || currentUser.user.accountId;
    const storageKey = `user-property-${user}-${property}`;
    const fetchUserProperty = (0, $eJOHy.useCallback)(()=>user ? (0, $FppkK.getUserProperty)(user, property).catch((error)=>{
            if (error instanceof (0, $14RSn.default) && error.statusCode === 404) return undefined;
            throw error;
        }) : undefined, [
        user,
        property
    ]);
    const [value] = (0, $3Dkf3.usePersistentlyCachedRequest)(storageKey, undefined, fetchUserProperty);
    return value;
}

});
parcelRegister("3Dkf3", function(module, exports) {
$parcel$export(module.exports, "usePersistentlyCachedRequest", () => $4c196a3c7c8c8984$export$984344f48cd049a);

var $eJOHy = parcelRequire("eJOHy");

var $aizIw = parcelRequire("aizIw");
const $4c196a3c7c8c8984$export$984344f48cd049a = (storageKey, defaultValue, reader)=>{
    const cachedValue = (0, $eJOHy.useMemo)(()=>(0, $aizIw.getSessionStorageData)(storageKey), [
        storageKey
    ]);
    const [{ value: value, storageKey: storedKey }, setStoredValue] = (0, $eJOHy.useState)(()=>({
            storageKey: storageKey,
            value: cachedValue
        }));
    if (storedKey !== storageKey) // yes, you can do it
    setStoredValue({
        storageKey: storageKey,
        value: cachedValue
    });
    const setNewValue = (0, $eJOHy.useCallback)((newValue)=>{
        (0, $aizIw.setSessionStorageData)(storageKey, newValue);
        (0, $aizIw.updateBus).emit(storageKey, newValue);
    }, [
        storageKey
    ]);
    // note - updating value is done via effect and affects all consumers
    (0, $eJOHy.useEffect)(()=>(0, $aizIw.updateBus).subscribe(storageKey, (newValue)=>setStoredValue({
                storageKey: storageKey,
                value: newValue
            })), [
        storageKey
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!reader) return;
        if (cachedValue === undefined) (0, $aizIw.handleDataRequest)(storageKey, reader);
    }, [
        reader,
        storageKey,
        cachedValue
    ]);
    return (0, $eJOHy.useMemo)(()=>[
            value ?? defaultValue,
            setNewValue
        ], [
        value,
        defaultValue,
        setNewValue
    ]);
};

});
parcelRegister("aizIw", function(module, exports) {
$parcel$export(module.exports, "getSessionStorageData", () => $0c4f902ec7d5af31$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $0c4f902ec7d5af31$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "updateBus", () => $0c4f902ec7d5af31$export$6da4b0a5188cf0d7);
$parcel$export(module.exports, "handleDataRequest", () => $0c4f902ec7d5af31$export$d09b7eeb5e60cdd9);

var $9pTd3 = parcelRequire("9pTd3");

var $8tIrO = parcelRequire("8tIrO");

var $4896p = parcelRequire("4896p");
const $0c4f902ec7d5af31$var$ONE_DAY = 86400000; // 1 day
const $0c4f902ec7d5af31$var$storage = (0, $8tIrO.createSessionExpirableStorageProvider)('jira-platform-persistent-cache');
const $0c4f902ec7d5af31$export$af84d82ff1eea56d = (key)=>{
    const data = $0c4f902ec7d5af31$var$storage.get(key);
    if (data) try {
        return JSON.parse(data);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getSessionStorageData', e);
        return undefined;
    }
    return undefined;
};
const $0c4f902ec7d5af31$export$be8cb7c8f1a1db6b = (key, value)=>{
    try {
        $0c4f902ec7d5af31$var$storage.set(key, JSON.stringify(value), Date.now() + $0c4f902ec7d5af31$var$ONE_DAY);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('setSessionStorageData', e);
    }
};
const $0c4f902ec7d5af31$export$6da4b0a5188cf0d7 = (0, $4896p.createEventBus)();
const $0c4f902ec7d5af31$export$9a4e04a3b0938221 = {};
const $0c4f902ec7d5af31$export$d09b7eeb5e60cdd9 = async (storageKey, // eslint-disable-next-line @typescript-eslint/no-explicit-any
request)=>{
    // If there's already a pending request for this storageKey, ignore this one
    if ($0c4f902ec7d5af31$export$9a4e04a3b0938221[storageKey]) return $0c4f902ec7d5af31$export$9a4e04a3b0938221[storageKey];
    // Otherwise, add this request to the list of pending requests
    try {
        const pending = request();
        $0c4f902ec7d5af31$export$9a4e04a3b0938221[storageKey] = pending;
        // Wait for the request to complete
        const newValue = await pending;
        // update store and inform consumers
        $0c4f902ec7d5af31$export$be8cb7c8f1a1db6b(storageKey, newValue);
        $0c4f902ec7d5af31$export$6da4b0a5188cf0d7.emit(storageKey, newValue);
    } catch (error) {
        if (error instanceof Error) (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'handleDataRequest',
                packageName: 'jiraPlatformPersistentCache',
                teamName: 'crocs'
            }
        });
        else throw error;
    } finally{
        // Remove this request from the list of pending requests
        delete $0c4f902ec7d5af31$export$9a4e04a3b0938221[storageKey];
    }
};

});
parcelRegister("4896p", function(module, exports) {
$parcel$export(module.exports, "createEventBus", () => $c8963504691d0169$export$f492882bd33cbb73);
const $c8963504691d0169$export$f492882bd33cbb73 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const listeners = new Map();
    const subscribe = (event, listener)=>{
        listeners.set(listener, event);
        return ()=>{
            listeners.delete(listener);
        };
    };
    const emit = (event, payload)=>{
        listeners.forEach((eventFilter, listener)=>{
            if (eventFilter === event) listener(payload);
        });
    };
    return {
        subscribe: subscribe,
        emit: emit,
        get length () {
            return listeners.size;
        }
    };
};

});





parcelRegister("dnmTP", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $0adeb5b0b06fc9bf$export$f21504b774272faa);

var $hBW9p = parcelRequire("hBW9p");
const $0adeb5b0b06fc9bf$export$f21504b774272faa = {
    ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'jiraProductDiscovery'
};

});

parcelRegister("kAWDh", function(module, exports) {
$parcel$export(module.exports, "default", () => $39d14ca6bc6b564a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $39d14ca6bc6b564a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.heading",
        "defaultMessage": "Jira Product Discovery"
    },
    accessItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.access-item",
        "defaultMessage": "Access"
    },
    globalFieldsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.global-fields-item",
        "defaultMessage": "Global fields"
    },
    viewBlueprintsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.view-blueprints-item",
        "defaultMessage": "Pre-built views"
    },
    viewBlueprintsItemLozenge: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.new-lozenge",
        "defaultMessage": "New"
    },
    datesItem: {
        "id": "spa-apps-sidebar-global-settings-products.menu.product-discovery.dates-item",
        "defaultMessage": "Dates"
    },
    betaFeaturesItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.beta-features-item",
        "defaultMessage": "Beta features"
    },
    betaFeaturesItemLozenge: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.beta-features-item-lozenge",
        "defaultMessage": "1 New"
    }
});

});


parcelRegister("i5EnI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb0c0a09ac45f16$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $lopBx = parcelRequire("lopBx");

var $aYncF = parcelRequire("aYncF");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $keu3i = parcelRequire("keu3i");

var $bo95Y = parcelRequire("bo95Y");

var $hih5V = parcelRequire("hih5V");

var $7cSYk = parcelRequire("7cSYk");

var $h2OaH = parcelRequire("h2OaH");

var $koAZ4 = parcelRequire("koAZ4");

var $aJjnn = parcelRequire("aJjnn");

var $R6e6l = parcelRequire("R6e6l");
const $7cb0c0a09ac45f16$var$ServiceManagementSection = ({ features: features })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const { licensedProducts: licensedProducts } = (0, $koAZ4.useTenantContext)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isFullyExpanded = (0, $4cTDP.fg)('fe_stakeholder_email_templates_in_jsm') && (0, $keu3i.useIsFullyExpanded)();
    const hasConfluence = Boolean(licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).CONFLUENCE]);
    const incidentManagementServiceDeskMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'incidentManagement'
        },
        isSelected: currentRoute.name === 'products-jsm-incident-management-tools',
        href: "/jira/settings/products/jira-service-management-incident-management-tools"
    }, formatMessage((0, $R6e6l.default).incidentManagementItem));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $R6e6l.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, features.hasServiceManagementConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'configuration'
        },
        isSelected: currentRoute.name === 'products-jsm-configuration',
        href: "/jira/settings/products/jira-service-management-configuration"
    }, formatMessage((0, $R6e6l.default).configurationItem)), features.hasServiceManagementEmailRequests && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'emailRequests'
        },
        isSelected: currentRoute.name === 'products-jsm-email-requests',
        href: "/jira/settings/products/jira-service-management-email-requests"
    }, formatMessage((0, $R6e6l.default).emailRequestsItem)), features.hasServiceManagementCustomerAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'customerAccess'
        },
        isSelected: currentRoute.name === 'products-jsm-customer-access',
        href: "/jira/settings/products/servicedesk/customer-access"
    }, formatMessage((0, $R6e6l.default).customerAccessItem)), features.hasServiceManagementAuthenticationSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'authentication'
        },
        isSelected: currentRoute.name === 'products-jsm-authentication-settings',
        href: "/jira/settings/products/servicedesk/authentication"
    }, formatMessage((0, $R6e6l.default).authenticationItem)), features.hasOrganizationsListAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'organizations'
        },
        isSelected: currentRoute.name === 'products-jsm-organizations',
        href: "/jira/settings/products/servicedesk/organizations"
    }, formatMessage((0, $R6e6l.default).organizationsItem)), features.hasServiceManagementIncidentManagementTools && ((0, $4cTDP.fg)('fe_stakeholder_email_templates_in_jsm') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h2OaH.default), {
        isFullyExpanded: isFullyExpanded
    }, incidentManagementServiceDeskMenuItem) : incidentManagementServiceDeskMenuItem), hasConfluence && features.hasServiceManagementKbPermissionsAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'knowledgeBasePermissions'
        },
        isSelected: currentRoute.name === 'products-jsm-kb-permissions',
        href: "/jira/settings/products/jira-service-management-knowledge-base-permissions"
    }, formatMessage((0, $R6e6l.default).knowledgeBasePermissionsItem)), features.hasServiceManagementConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'complianceSettings'
        },
        isSelected: currentRoute.name === 'products-jsm-compliance',
        href: "/jira/settings/products/jira-service-management-compliance"
    }, formatMessage((0, $R6e6l.default).complianceSettingsItem)), ((0, $7cSYk.isCMDBEnabledInEnvironment)() || !(0, $lopBx.isFedRamp)()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $aJjnn.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'featureUsage'
        },
        isSelected: currentRoute.name === 'products-jsm-feature-usage',
        href: "/jira/settings/products/servicedesk/feature-usage"
    }, formatMessage((0, $R6e6l.default).featureUsageItem))));
};
var $7cb0c0a09ac45f16$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($7cb0c0a09ac45f16$var$ServiceManagementSection);

});
parcelRegister("keu3i", function(module, exports) {
$parcel$export(module.exports, "useIsFullyExpanded", () => $80a581cbcefc9920$export$7212b6b01271f5d1);

var $eJOHy = parcelRequire("eJOHy");

var $cUxaS = parcelRequire("cUxaS");
const $80a581cbcefc9920$var$TIMEOUT = 500;
const $80a581cbcefc9920$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $eJOHy.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $cUxaS.useLeftSidebarState)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $80a581cbcefc9920$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});

parcelRegister("h2OaH", function(module, exports) {
$parcel$export(module.exports, "default", () => $350ac2579032fa9e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $1BZ8a = parcelRequire("1BZ8a");

var $cblKs = parcelRequire("cblKs");

var $4p7Qw = parcelRequire("4p7Qw");

var $jTQ7o = parcelRequire("jTQ7o");
const $350ac2579032fa9e$var$SPOTLIGHT_KEY = 'jira.servicedesk.incident-management.incident-management-settings.setting-menu-onboarding';
const $350ac2579032fa9e$var$IncidentManagementProductSettingNavMenuItemOnboarding = ({ children: children, isFullyExpanded: isFullyExpanded })=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const [isOnboardingActive, setHasSeenOnboarding] = (0, $4p7Qw.useHasSeenOnboarding)($350ac2579032fa9e$var$SPOTLIGHT_KEY);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasPremiumServiceDeskAccess = appEditions.serviceDesk === (0, $cblKs.PREMIUM_EDITION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "jira-servicedesk-incident-management-product-setting-menu-item"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isOnboardingActive && isFullyExpanded && hasPremiumServiceDeskAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        actions: [
            {
                onClick: setHasSeenOnboarding,
                text: formatMessage((0, $jTQ7o.default).productSettingsIncidentManagementMenuItemSpotlightActionLabel)
            }
        ],
        heading: formatMessage((0, $jTQ7o.default).productSettingsIncidentManagementMenuItemSpotlightHeading),
        target: "jira-servicedesk-incident-management-product-setting-menu-item",
        key: "jira-servicedesk-incident-management-product-setting-menu-item",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        messageType: "engagement",
        messageId: "servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.jira-spotlight.jira-servicedesk-incident-management-product-setting-menu-item",
        dialogPlacement: "right top"
    }, formatMessage((0, $jTQ7o.default).productSettingsIncidentManagementMenuItemSpotlightDescription))));
};
var $350ac2579032fa9e$export$2e2bcd8739ae039 = $350ac2579032fa9e$var$IncidentManagementProductSettingNavMenuItemOnboarding;

});
parcelRegister("4p7Qw", function(module, exports) {
$parcel$export(module.exports, "useHasSeenOnboarding", () => $5a9eb5949c33ef3c$export$7fa30b35c95cc082);

var $eJOHy = parcelRequire("eJOHy");

var $lu2We = parcelRequire("lu2We");

var $e6YEs = parcelRequire("e6YEs");
const $5a9eb5949c33ef3c$export$7fa30b35c95cc082 = (key)=>{
    const accountId = (0, $e6YEs.useAccountId)();
    const [isOnboardingActive, setIsOnboardingActive] = (0, $eJOHy.useState)(false);
    const getHasSeenOnboarding = (0, $eJOHy.useCallback)(async (id)=>{
        const response = await (0, $lu2We.getUserProperty)({
            accountId: id,
            propertyKey: key,
            defaultValue: false
        });
        return response.value;
    }, [
        key
    ]);
    const setHasSeenOnboarding = (0, $eJOHy.useCallback)(async ()=>{
        setIsOnboardingActive(false);
        if (accountId !== null) await (0, $lu2We.setUserProperty)({
            accountId: accountId,
            propertyKey: key,
            propertyValue: true
        });
    }, [
        accountId,
        key
    ]);
    const fetchOnboardingState = (0, $eJOHy.useCallback)(async ()=>{
        if (accountId !== null) {
            const response = await getHasSeenOnboarding(accountId);
            setIsOnboardingActive(!response);
        }
    }, [
        accountId,
        getHasSeenOnboarding
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchOnboardingState();
    }, [
        fetchOnboardingState
    ]);
    return [
        isOnboardingActive,
        setHasSeenOnboarding
    ];
};

});
parcelRegister("lu2We", function(module, exports) {
$parcel$export(module.exports, "getUserProperty", () => $e8db6e5fef5e621f$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $e8db6e5fef5e621f$export$ba821ce5e177c7ef);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $e8db6e5fef5e621f$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $e8db6e5fef5e621f$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $e8db6e5fef5e621f$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // The API deliberately returns 404 if user property is not found - we will return default value
        if (response.status === 404) return {
            key: propertyKey,
            value: defaultValue
        };
        if (response.ok) return await response.json();
        throw new Error(`Fetching ${propertyKey} user property failed.`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $e8db6e5fef5e621f$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $e8db6e5fef5e621f$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $3ugTQ.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'setUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("jTQ7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $9008e2b15893aa4d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9008e2b15893aa4d$var$messages = (0, $7qGN1.defineMessages)({
    productSettingsIncidentManagementMenuItemSpotlightHeading: {
        "id": "servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-heading",
        "defaultMessage": "Save time during incidents with templates"
    },
    productSettingsIncidentManagementMenuItemSpotlightDescription: {
        "id": "servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-description",
        "defaultMessage": "Create and customize email templates to save time and send consistent stakeholder notifications during incidents."
    },
    productSettingsIncidentManagementMenuItemSpotlightActionLabel: {
        "id": "servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-action-label",
        "defaultMessage": "OK"
    }
});
var $9008e2b15893aa4d$export$2e2bcd8739ae039 = $9008e2b15893aa4d$var$messages;

});


parcelRegister("aJjnn", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $9661ed11a1144c85$export$f21504b774272faa);

var $hBW9p = parcelRequire("hBW9p");
const $9661ed11a1144c85$export$f21504b774272faa = {
    ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'jiraServiceManagement'
};

});

parcelRegister("R6e6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $94185a0c8f6f2cc2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $94185a0c8f6f2cc2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.heading",
        "defaultMessage": "Jira Service Management"
    },
    configurationItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.configuration-item",
        "defaultMessage": "Configuration"
    },
    complianceSettingsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.compliance-settings-item",
        "defaultMessage": "Compliance settings"
    },
    emailRequestsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.email-requests-item",
        "defaultMessage": "Email requests"
    },
    customerAccessItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.customer-access-item",
        "defaultMessage": "Customer access"
    },
    incidentManagementItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.incident-management-item",
        "defaultMessage": "Incident management"
    },
    knowledgeBasePermissionsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.knowledge-base-permissions-item",
        "defaultMessage": "Knowledge base permissions"
    },
    authenticationItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.authentication-item",
        "defaultMessage": "Authentication"
    },
    organizationsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.organizations-item",
        "defaultMessage": "Organizations"
    },
    featureUsageItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.feature-usage-item",
        "defaultMessage": "Feature usage"
    }
});

});


parcelRegister("fFJFj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce0d28824dfac5c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $hih5V = parcelRequire("hih5V");

var $bo95Y = parcelRequire("bo95Y");

var $hBW9p = parcelRequire("hBW9p");

var $j2b7w = parcelRequire("j2b7w");
const $ce0d28824dfac5c1$var$CustomerServiceSection = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, (0, $4cTDP.fg)('csm_rename_jcs_to_csm') ? formatMessage((0, $j2b7w.default).heading) : formatMessage((0, $j2b7w.default).headingOld)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
            section: 'jiraCustomerService',
            itemId: 'customerAccess'
        },
        isSelected: currentRoute.name === 'products-jcs-customer-access',
        href: "/jira/settings/products/customerservice/customer-access"
    }, formatMessage((0, $j2b7w.default).customerAccessItem)), (0, $4cTDP.fg)('jcs_forms_resiliency_fast_follows') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $hBW9p.COMMON_ANALYTICS_ATTRIBUTES),
            section: 'jiraCustomerService',
            itemId: 'customerAccess'
        },
        isSelected: currentRoute.name === 'products-jcs-form-fields',
        href: "/jira/settings/products/customerservice/form-fields"
    }, formatMessage((0, $j2b7w.default).formFieldsItem))));
};
var $ce0d28824dfac5c1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($ce0d28824dfac5c1$var$CustomerServiceSection);

});
parcelRegister("j2b7w", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc87ff780bfd5bb8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cc87ff780bfd5bb8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    headingOld: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.heading",
        "defaultMessage": "Jira Customer Service"
    },
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.heading-csm",
        "defaultMessage": "Customer Service Management"
    },
    customerAccessItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.customer-access-item",
        "defaultMessage": "Customer access"
    },
    formFieldsItem: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.form-fields-item",
        "defaultMessage": "Form fields"
    }
});

});


parcelRegister("2eQJy", function(module, exports) {
$parcel$export(module.exports, "DelegatedAdminJiraSection", () => $349b7ea1d3b051fb$export$a548d6dff2d43f1f);

var $5LWjX = parcelRequire("5LWjX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $bo95Y = parcelRequire("bo95Y");

var $hih5V = parcelRequire("hih5V");

var $kmUlG = parcelRequire("kmUlG");

var $kZBCy = parcelRequire("kZBCy");
const $349b7ea1d3b051fb$var$DelegatedAdminJiraSectionInternal = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const fragmentData = (0, $j4oe4.useFragment)((0, $5LWjX.default), queryReference);
    if (!fragmentData?.jira?.canManageCustomOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $kZBCy.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: {
            ...(0, $kmUlG.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'onboardingHub'
        },
        isSelected: [
            'products-onboarding-hub',
            'products-onboarding-hub-create',
            'products-onboarding-hub-edit'
        ].includes(currentRoute.name),
        href: "/jira/settings/products/onboarding"
    }, formatMessage((0, $kZBCy.default).onboardingHubItem))));
};
const $349b7ea1d3b051fb$export$a548d6dff2d43f1f = /*#__PURE__*/ (0, $eJOHy.memo)($349b7ea1d3b051fb$var$DelegatedAdminJiraSectionInternal);

});
parcelRegister("5LWjX", function(module, exports) {
$parcel$export(module.exports, "default", () => $797556d229c6e970$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96bbbe673d8561928267532fbf4fbe2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $797556d229c6e970$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        }
    ],
    "kind": "Fragment",
    "name": "DelegatedAdminJiraSection",
    "selections": [
        {
            "condition": "skipDelegatedAdminCheck",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canManageCustomOnboarding",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "MANAGE_CUSTOM_ONBOARDING"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "hasGlobalPermission"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$797556d229c6e970$var$node.hash = "4829d8ab2a5bd80527220204076e7d6a";
var $797556d229c6e970$export$2e2bcd8739ae039 = $797556d229c6e970$var$node;

});



parcelRegister("bRVxo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i42Vc").then(()=>parcelRequire('5dOp9'));

});


parcelRegister("av7W4", function(module, exports) {
$parcel$export(module.exports, "default", () => $e88c301d43faf3c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $e88c301d43faf3c1$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cdnHa")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
});
const $e88c301d43faf3c1$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.projects-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings",
        ufoName: "nav4.sidebar.global-settings.projects-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "projects",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-projects.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.global-settings.projects-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e88c301d43faf3c1$var$LazySidebarContent, null))));
};
var $e88c301d43faf3c1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($e88c301d43faf3c1$var$AsyncSidebar);

});
parcelRegister("cdnHa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfaVW").then(()=>parcelRequire('1P2v5'));

});


parcelRegister("fXF6E", function(module, exports) {
$parcel$export(module.exports, "LazySidebarContent", () => $72f17456b4756ef4$export$5cb783b45e692ee9);
$parcel$export(module.exports, "default", () => $72f17456b4756ef4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $kAwwe = parcelRequire("kAwwe");

var $gDXSd = parcelRequire("gDXSd");

var $4cTDP = parcelRequire("4cTDP");

var $2mHfh = parcelRequire("2mHfh");

const $72f17456b4756ef4$export$5cb783b45e692ee9 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fMgnX")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/operations/src/ui/main.tsx"
});
const $72f17456b4756ef4$var$AsyncSidebar = ()=>{
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const { isOpsAdmin: isOpsAdmin } = (0, $gDXSd.useOgTenantInfo)();
    const hasOperationsGeneralConfiguration = (0, $4cTDP.fg)('operations-tenant-info-endpoint-update') ? isAdmin || isOpsAdmin : isAdmin;
    if (!hasOperationsGeneralConfiguration && (0, $4cTDP.fg)('redirect_user_to_ops_page_from_global_settings')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira/ops/overview"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "operations",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-operations.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.global-settings.operations-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($72f17456b4756ef4$export$5cb783b45e692ee9, null))));
};
var $72f17456b4756ef4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($72f17456b4756ef4$var$AsyncSidebar);

});
parcelRegister("fMgnX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lJ8L3").then(()=>parcelRequire('5HAMb'));

});


parcelRegister("fJ06f", function(module, exports) {
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", () => $3b048a44b2aa0633$export$68950d4e14439158);
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", () => $3b048a44b2aa0633$export$5efb701a2106707a);

var $eJOHy = parcelRequire("eJOHy");

var $jImTl = parcelRequire("jImTl");

var $gcPEx = parcelRequire("gcPEx");

var $4J9V1 = parcelRequire("4J9V1");

var $azlgS = parcelRequire("azlgS");

var $8zPcN = parcelRequire("8zPcN");

var $7FIkD = parcelRequire("7FIkD");

var $jRu18 = parcelRequire("jRu18");

var $QaFzq = parcelRequire("QaFzq");
const $3b048a44b2aa0633$var$getItems = (d)=>(0, $gcPEx.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $4J9V1.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $3b048a44b2aa0633$export$68950d4e14439158 = (0, $azlgS.withThrowOnError)(()=>{
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    const { data: data, loading: loading, error: error } = (0, $8zPcN.useNavigationGlobalResource)();
    const items = (0, $eJOHy.useMemo)(()=>data && $3b048a44b2aa0633$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
});
const $3b048a44b2aa0633$export$5efb701a2106707a = ()=>{
    const location = (0, $jRu18.useLocation)();
    const route = (0, $QaFzq.useRoute)();
    const { data: data, loading: loading, error: error } = $3b048a44b2aa0633$export$68950d4e14439158();
    const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, $7FIkD.useConnectGeneralResource)();
    const isActive = (0, $eJOHy.useMemo)(()=>Boolean(route && data && (0, $jImTl.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
        loading: loading || connectGeneralResourceLoading,
        error: error || connectGeneralResourceError
    };
};

});

parcelRegister("b2wim", function(module, exports) {
$parcel$export(module.exports, "default", () => $e339f81da27d71ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $e339f81da27d71ae$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4JsGE")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
});
const $e339f81da27d71ae$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.system-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings",
        ufoName: "nav4.sidebar.global-settings.system-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "system",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-system.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.global-settings.system-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e339f81da27d71ae$var$LazySidebarContent, null))));
};
var $e339f81da27d71ae$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($e339f81da27d71ae$var$AsyncSidebar);

});
parcelRegister("4JsGE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iHwLj").then(()=>parcelRequire('a6h8L'));

});


parcelRegister("fIogS", function(module, exports) {
$parcel$export(module.exports, "default", () => $7867dc9df0604916$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $5p56C = parcelRequire("5p56C");

const $7867dc9df0604916$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("eGXYY")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
});
const $7867dc9df0604916$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.help-center-settings",
        packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings",
        ufoName: "nav4.sidebar.help-center-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.help-center-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5p56C.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7867dc9df0604916$var$LazySidebarContent, null)));
var $7867dc9df0604916$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($7867dc9df0604916$var$AsyncSidebar);

});
parcelRegister("5p56C", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $27a902687dbbc5d1$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");
const $27a902687dbbc5d1$var$ItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $27a902687dbbc5d1$var$iconSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $27a902687dbbc5d1$var$itemSkeleton
    }));
const $27a902687dbbc5d1$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.300",
        xcss: $27a902687dbbc5d1$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $27a902687dbbc5d1$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $27a902687dbbc5d1$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $27a902687dbbc5d1$var$iconSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $27a902687dbbc5d1$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null)));
const $27a902687dbbc5d1$var$containerStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $27a902687dbbc5d1$var$backButton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small'
});
const $27a902687dbbc5d1$var$iconSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $27a902687dbbc5d1$var$titleSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    width: '50%',
    borderRadius: 'radius.small'
});
const $27a902687dbbc5d1$var$headingSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'radius.small'
});
const $27a902687dbbc5d1$var$itemSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small',
    flex: 1
});

});

parcelRegister("eGXYY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kPeYw").then(()=>parcelRequire('deSfB'));

});


parcelRegister("a7qPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2dc5fcce37e96cd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bgC0Q = parcelRequire("bgC0Q");

const $f2dc5fcce37e96cd$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cSFUm")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/personal/src/ui/main.tsx"
});
const $f2dc5fcce37e96cd$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.personal-settings",
        packageName: "jiraNavigationAppsSidebarNav4PersonalSettings",
        ufoName: "nav4.sidebar.personal-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.personal-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bgC0Q.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f2dc5fcce37e96cd$var$LazySidebarContent, null)));
var $f2dc5fcce37e96cd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($f2dc5fcce37e96cd$var$AsyncSidebar);

});
parcelRegister("bgC0Q", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $4d914ed51273bbce$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");
const $4d914ed51273bbce$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4d914ed51273bbce$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4d914ed51273bbce$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4d914ed51273bbce$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4d914ed51273bbce$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4d914ed51273bbce$var$menuItem
    })));
const $4d914ed51273bbce$var$containerStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $4d914ed51273bbce$var$backButton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $4d914ed51273bbce$var$headingSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small',
    flex: 1
});
const $4d914ed51273bbce$var$menuItem = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("cSFUm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ZikG").then(()=>parcelRequire('Dk01j'));

});


parcelRegister("85ZZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $adb8e919f75d8865$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $3ixBB = parcelRequire("3ixBB");

const $adb8e919f75d8865$var$LazyPlanSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("lvXXF")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/plan/src/ui/main.tsx"
});
const $adb8e919f75d8865$var$AsyncSidebar = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "asyncSidebarPlanSettings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ixBB.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adb8e919f75d8865$var$LazyPlanSettingsSidebar, {
        store: store
    }));
var $adb8e919f75d8865$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($adb8e919f75d8865$var$AsyncSidebar);

});
parcelRegister("3ixBB", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $6d76922a3f445a6a$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");
const $6d76922a3f445a6a$export$8f31e4c4a37b8e9c = ()=>{
    return (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })));
};
const $6d76922a3f445a6a$var$titleSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-800, 64px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});
const $6d76922a3f445a6a$var$backButton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});
const $6d76922a3f445a6a$var$headingSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small',
    flex: 1
});
const $6d76922a3f445a6a$var$menuItem = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $6d76922a3f445a6a$var$subtitleItem = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("lvXXF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("52qvO")
]).then(()=>parcelRequire('3rsEl'));

});


parcelRegister("b2Fy3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2694bb894d56fbb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $b2694bb894d56fbb$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hFle6")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/company-managed/src/ui/main.tsx"
});
const $b2694bb894d56fbb$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.project-settings.business.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b2694bb894d56fbb$var$LazySidebarContent, {
        project: project
    })));
var $b2694bb894d56fbb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($b2694bb894d56fbb$var$AsyncSidebar);

});
parcelRegister("hFle6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gJ052").then(()=>parcelRequire('7zTBI'));

});


parcelRegister("jyuS3", function(module, exports) {
$parcel$export(module.exports, "default", () => $4134fdc89dd9f47b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $4134fdc89dd9f47b$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jbMEs")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/team-managed/src/ui/main.tsx"
});
const $4134fdc89dd9f47b$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.project-settings.business.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4134fdc89dd9f47b$var$LazySidebarContent, {
        project: project
    })));
var $4134fdc89dd9f47b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($4134fdc89dd9f47b$var$AsyncSidebar);

});
parcelRegister("jbMEs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a1tQm").then(()=>parcelRequire('hW326'));

});


parcelRegister("1Wo5Y", function(module, exports) {
$parcel$export(module.exports, "useIsConnectAppActive", () => $85b7951919a1c173$export$249b2e8512031cae);

var $eJOHy = parcelRequire("eJOHy");

var $jImTl = parcelRequire("jImTl");

var $jRu18 = parcelRequire("jRu18");

var $QaFzq = parcelRequire("QaFzq");

var $8KylV = parcelRequire("8KylV");
const $85b7951919a1c173$export$249b2e8512031cae = ()=>{
    const location = (0, $jRu18.useLocation)();
    const route = (0, $QaFzq.useRoute)();
    const { data: connectApps, error: error, loading: loading } = (0, $8KylV.useConnectApps)();
    const isActive = (0, $eJOHy.useMemo)(()=>Boolean((0, $jImTl.findItemAndStack)(connectApps, route.name, location)?.selected), [
        connectApps,
        location,
        route.name
    ]);
    return {
        isActive: isActive,
        loading: loading,
        error: error
    };
};

});
parcelRegister("8KylV", function(module, exports) {
$parcel$export(module.exports, "useConnectApps", () => $10406f6bfbc50847$export$4864478dcab77643);

var $eJOHy = parcelRequire("eJOHy");

var $cY5nO = parcelRequire("cY5nO");

var $4J9V1 = parcelRequire("4J9V1");

var $g0WOk = parcelRequire("g0WOk");
const $10406f6bfbc50847$export$4864478dcab77643 = ()=>{
    const { data: connectResourceItems, error: error, loading: loading } = (0, $cY5nO.useProjectSettingsSidebarConnectAddonsNavigationResource)();
    const connectApps = (0, $eJOHy.useMemo)(()=>{
        if (connectResourceItems == null) return [];
        const transformedConnectApps = [];
        for (const item of connectResourceItems){
            const transformedItem = (0, $4J9V1.transformLinkV4)(item);
            if (transformedItem && !(0, $g0WOk.LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
        }
        return transformedConnectApps;
    }, [
        connectResourceItems
    ]);
    return {
        data: connectApps,
        loading: loading,
        error: error
    };
};

});
parcelRegister("g0WOk", function(module, exports) {
$parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", () => $73c7e3e67b5a3022$export$911a3d81a5d162b6);
// This is a list of known legacy connect item IDs that is used to filter out unecessary connect items
// from being rendered in the connect sections
const $73c7e3e67b5a3022$export$911a3d81a5d162b6 = new Set([
    // Global Settings Static Legacy IDs
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy IDs
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
]);

});



parcelRegister("kDeux", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0f96829bc22173a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $e0f96829bc22173a$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hyUU2")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/product-discovery/src/ui/main.tsx"
});
const $e0f96829bc22173a$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.jpd-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings",
        ufoName: "nav4.sidebar.project-settings.jpd-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.project-settings.jpd-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e0f96829bc22173a$var$LazySidebarContent, {
        project: project
    })));
var $e0f96829bc22173a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($e0f96829bc22173a$var$AsyncSidebar);

});
parcelRegister("hyUU2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fJVN1").then(()=>parcelRequire('5ARi3'));

});


parcelRegister("dKJXK", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", () => $f80defbe5baaf5f3$export$2ce6ad449436c545);

var $eJOHy = parcelRequire("eJOHy");

var $jsesb = parcelRequire("jsesb");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $fTzDU = parcelRequire("fTzDU");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $f80defbe5baaf5f3$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gS3Ep")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/company-managed/src/main.tsx"
});
const $f80defbe5baaf5f3$var$analyticsAttributes = {
    projectStyle: 'cmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $f80defbe5baaf5f3$export$2ce6ad449436c545 = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jsm-cmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-cmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsesb.ContextualAnalyticsData), {
        menuId: (0, $fTzDU.MENU_ID_JSM_SETTINGS),
        attributes: $f80defbe5baaf5f3$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f80defbe5baaf5f3$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("jsesb", function(module, exports) {
$parcel$export(module.exports, "ContextualAnalyticsData", () => $69dd343014a7c35f$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $69dd343014a7c35f$export$bc7f6eebc16e6127);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $kGj4V = parcelRequire("kGj4V");

var $eWzpp = parcelRequire("eWzpp");

var $8ZNPQ = parcelRequire("8ZNPQ");
const $69dd343014a7c35f$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $8ZNPQ.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $69dd343014a7c35f$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: // eslint-disable-next-line react-hooks/react-compiler
useProject = (0, $eWzpp.useProject), ...rest })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $FhXEJ.ProjectStyle).NEXT_GEN : (0, $FhXEJ.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("8ZNPQ", function(module, exports) {
$parcel$export(module.exports, "generateViewId", () => $d7357fd7d80444c9$export$5b5545ed894dc47a);
const $d7357fd7d80444c9$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("fTzDU", function(module, exports) {
$parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", () => $6b652dd92d2b3e17$export$4c5fa21d31710030);
$parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", () => $6b652dd92d2b3e17$export$8092325c2fa271de);


const $6b652dd92d2b3e17$export$4c5fa21d31710030 = 'project/service-desk/settings';
const $6b652dd92d2b3e17$var$COMMON_ANALYTICS_ATTRIBUTES = {
    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
    level: 1
};
const $6b652dd92d2b3e17$export$8092325c2fa271de = {
    ...$6b652dd92d2b3e17$var$COMMON_ANALYTICS_ATTRIBUTES,
    actionSubjectId: (0, $16a7021d28f78da7$export$13171e509c859bbf)
};

});

parcelRegister("gS3Ep", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lYv4u").then(()=>parcelRequire('1fWHc'));

});


parcelRegister("2ZbI9", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", () => $591aed44a3fa3192$export$dadf0f8c840cb26d);

var $eJOHy = parcelRequire("eJOHy");

var $jsesb = parcelRequire("jsesb");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $fTzDU = parcelRequire("fTzDU");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $591aed44a3fa3192$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("aN1Ft")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/team-managed/src/main.tsx"
});
const $591aed44a3fa3192$var$analyticsAttributes = {
    projectStyle: 'tmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $591aed44a3fa3192$export$dadf0f8c840cb26d = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jsm-tmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-tmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsesb.ContextualAnalyticsData), {
        menuId: (0, $fTzDU.MENU_ID_JSM_SETTINGS),
        attributes: $591aed44a3fa3192$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($591aed44a3fa3192$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("aN1Ft", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7yGDk").then(()=>parcelRequire('6uevy'));

});


parcelRegister("1eGpA", function(module, exports) {
$parcel$export(module.exports, "AsyncJcsProjectSettingsSidebar", () => $c51b1ed2b58dd2aa$export$e82f1de9c94b7cd9);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $c51b1ed2b58dd2aa$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("qHKEJ")).then(({ JcsProjectSettingsSidebar: JcsProjectSettingsSidebar })=>JcsProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/customer-service/src/main.tsx"
});
const $c51b1ed2b58dd2aa$export$e82f1de9c94b7cd9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JCSProjectSettings",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.jcs-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c51b1ed2b58dd2aa$var$LazySidebarContent, {
        project: project
    }))));

});
parcelRegister("qHKEJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f6ssx").then(()=>parcelRequire('ejhdy'));

});


parcelRegister("6tXQB", function(module, exports) {
$parcel$export(module.exports, "default", () => $70785d1074b7d721$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $70785d1074b7d721$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4Qw35")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/company-managed/src/ui/main.tsx"
});
const $70785d1074b7d721$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.project-settings.software.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70785d1074b7d721$var$LazySidebarContent, {
        project: project
    })));
var $70785d1074b7d721$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($70785d1074b7d721$var$AsyncSidebar);

});
parcelRegister("4Qw35", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gLLAC").then(()=>parcelRequire('hlIyV'));

});


parcelRegister("9b0Rz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f9a196fb91bbe76$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $9f9a196fb91bbe76$var$LazySidebarContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kAxpD")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/team-managed/src/ui/main.tsx"
});
const $9f9a196fb91bbe76$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4.sidebar.project-settings.software.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f9a196fb91bbe76$var$LazySidebarContent, {
        project: project
    })));
var $9f9a196fb91bbe76$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($9f9a196fb91bbe76$var$AsyncSidebar);

});
parcelRegister("kAxpD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("86UZc").then(()=>parcelRequire('ixBjC'));

});


parcelRegister("dmxJQ", function(module, exports) {
$parcel$export(module.exports, "useConfigParam", () => $db223141e45f9c7c$export$b8842df7174e4acb);
$parcel$export(module.exports, "useMaybeConfigParam", () => $db223141e45f9c7c$export$2135334620af5209);

var $eJOHy = parcelRequire("eJOHy");

var $2FqDG = parcelRequire("2FqDG");
var $95O7y = parcelRequire("95O7y");

var $4cTDP = parcelRequire("4cTDP");

var $iZ2Qf = parcelRequire("iZ2Qf");
function $db223141e45f9c7c$export$b8842df7174e4acb() {
    const lastValidConfig = (0, $eJOHy.useRef)(null);
    const configParam = $db223141e45f9c7c$export$2135334620af5209();
    const result = (0, $eJOHy.useMemo)(()=>{
        if (!configParam) {
            if (lastValidConfig.current && (0, $4cTDP.fg)('fix_use_config_param_navigation')) return lastValidConfig.current;
            throw new Error('No config param found');
        }
        return $db223141e45f9c7c$var$isConfigQuery(configParam) ? configParam : null;
    }, [
        configParam
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (result && (0, $4cTDP.fg)('fix_use_config_param_navigation')) lastValidConfig.current = result;
    }, [
        result
    ]);
    return result;
}
function $db223141e45f9c7c$export$2135334620af5209() {
    const [configPath] = (0, $2FqDG.usePathParam)('config');
    const [configQuery] = (0, $95O7y.useQueryParam)('config');
    return configPath || configQuery;
}
const $db223141e45f9c7c$var$isConfigQuery = (configQuery)=>(0, $iZ2Qf.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configQuery);

});


parcelRegister("20Hsz", function(module, exports) {
$parcel$export(module.exports, "getNav4SidebarId", () => $5bcf7de15fdd54d8$export$8cea2a93fc3986aa);
$parcel$export(module.exports, "useGetParamsForGetNav4SidebarId", () => $5bcf7de15fdd54d8$export$e102a5137dc15645);

var $eJOHy = parcelRequire("eJOHy");

var $5RW99 = parcelRequire("5RW99");

var $iZ2Qf = parcelRequire("iZ2Qf");

var $2EmlI = parcelRequire("2EmlI");

var $fJ06f = parcelRequire("fJ06f");

var $1Wo5Y = parcelRequire("1Wo5Y");

var $gDXSd = parcelRequire("gDXSd");

var $kfvK2 = parcelRequire("kfvK2");

var $dmxJQ = parcelRequire("dmxJQ");
function $5bcf7de15fdd54d8$export$8cea2a93fc3986aa(params) {
    const { configParam: configParam, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, routerState: routerState, shouldUseJSM: shouldUseJSM } = params;
    const sidebarId = routerState.route.navigation?.sidebarId;
    const pathname = routerState.location.pathname;
    // Deal with the exceptions...
    if (sidebarId === (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS && !pathname.includes('/discover')) return sidebarId;
    if (sidebarId === (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS) {
        if (pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM) return (0, $5RW99.SIDEBAR_ID).CONTENT;
        return sidebarId;
    }
    // Project settings sidebars
    if (routerState.route.name === 'polaris-ideas' && routerState.match.params.section === 'settings' || isProjectSettingsConnectAppActive) return (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS;
    // Board settings sidebar
    if (routerState.route.group === 'classic-software' && (0, $iZ2Qf.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam)) return (0, $5RW99.SIDEBAR_ID).BOARD_SETTINGS;
    if (isGlobalAppsSettingsConnectItemActive) return (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS;
    if (isGlobalSystemSettingsConnectItemActive) return (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS;
    return sidebarId || (0, $5RW99.SIDEBAR_ID).CONTENT;
}
function $5bcf7de15fdd54d8$export$e102a5137dc15645(params = {}) {
    const { routerState: routerState = (0, $kfvK2.getRouterState)() } = params;
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $2EmlI.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $fJ06f.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $1Wo5Y.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $gDXSd.useOgTenantInfo)();
    const configParam = (0, $dmxJQ.useMaybeConfigParam)() || '';
    const data = (0, $eJOHy.useMemo)(()=>({
            configParam: configParam,
            isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
            isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
            isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
            routerState: routerState,
            shouldUseJSM: shouldUseJSM
        }), [
        configParam,
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        routerState,
        shouldUseJSM
    ]);
    return data;
}

});


parcelRegister("cfS4j", function(module, exports) {
$parcel$export(module.exports, "Nav4JiraSideNavRecommendation", () => $59c97720cc169a5c$export$ecec3671e31d76fc);
$parcel$export(module.exports, "JswSideNavRecommendation", () => $59c97720cc169a5c$export$6bbd8731fa84c19f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $d5hhf = parcelRequire("d5hhf");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $1gHmu = parcelRequire("1gHmu");

var $grotr = parcelRequire("grotr");

var $7oY9g = parcelRequire("7oY9g");

var $5fjzQ = parcelRequire("5fjzQ");

var $2xVkf = parcelRequire("2xVkf");

var $lauxv = parcelRequire("lauxv");

var $eJrcF = parcelRequire("eJrcF");
const $59c97720cc169a5c$var$PLACEMENT_ID = 'jira-side-nav';
const $59c97720cc169a5c$var$SideNavPlacement = ()=>{
    if (false && !(0, $4cTDP.fg)('jfp-magma-hydration-sidenavrecommendation')) return null;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [preloadedInitialData, clearPreloadedInitialData] = (0, $2xVkf.usePlacementPreloadedData)((0, $5fjzQ.postOfficeJiraSideNavResource));
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const handleClearPreloadedData = (0, $eJOHy.useCallback)(()=>{
        clearPreloadedInitialData();
    }, [
        clearPreloadedInitialData
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const memoizedPlacementProps = (0, $eJOHy.useMemo)(()=>({
            handleClearPreloadedData: handleClearPreloadedData,
            preloadedInitialData: preloadedInitialData
        }), [
        handleClearPreloadedData,
        preloadedInitialData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lauxv.default), {
        placementId: $59c97720cc169a5c$var$PLACEMENT_ID,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $d5hhf.default),
        placementProps: (0, $4cTDP.fg)('post_office_ssr_clear_preloaded_data') ? memoizedPlacementProps : undefined
    });
};
const $59c97720cc169a5c$var$SideNavRecommendation = ()=>{
    if (false && !(0, $4cTDP.fg)('jfp-magma-hydration-sidenavrecommendation')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "sideNavRecommendation",
        packageName: "side-nav-recommendation",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "side-nav-recommendation.jira-side-nav"
    }, (0, $4cTDP.fg)('post_office_ssr_jira_side_nav_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $grotr.PlacementFetchProvider), {
        resource: (0, $5fjzQ.postOfficeJiraSideNavResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$SideNavPlacement, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$SideNavPlacement, null))));
};
const $59c97720cc169a5c$export$ecec3671e31d76fc = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    if (false && !(0, $4cTDP.fg)('jfp-magma-hydration-sidenavrecommendation')) // eslint-disable-next-line jira/ff/no-preconditioning
    return (0, $4cTDP.fg)('post-office-shadow-rollout-jira-sidenav-ssr') && (0, $4cTDP.fg)('post-office-jira-side-nav-in-nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$ServerPlacementAPIFetchEnabled, null) : null;
    if (!(0, $7oY9g.default)('killswitch_post_office_in_jira') && (0, $4cTDP.fg)('post-office-jira-side-nav-in-nav4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$SideNavRecommendation, null);
    return null;
});
const $59c97720cc169a5c$export$6bbd8731fa84c19f = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    if (false && !(0, $4cTDP.fg)('jfp-magma-hydration-sidenavrecommendation')) return (0, $4cTDP.fg)('post-office-shadow-rollout-jira-sidenav-ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$ServerPlacementAPIFetchEnabled, null) : null;
    if (!(0, $7oY9g.default)('killswitch_post_office_in_jira')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$SideNavRecommendation, null);
    return null;
});
const $59c97720cc169a5c$var$ServerPlacementAPIFetchEnabled = ()=>{
    // FIXME: this isn't how useResource works... this can just be removed - comment below preserved for history
    // Use resource to make the shadow API call to Post Office.
    // Don't do anything with the result, we just want to mock the traffic for now.
    (0, $eJrcF.useResource)((0, $5fjzQ.postOfficeJiraSideNavResource));
    return null;
};

});
parcelRegister("d5hhf", function(module, exports) {
$parcel$export(module.exports, "default", () => $496df9575282d111$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $iJJ9P = parcelRequire("iJJ9P");

var $fT7M2 = parcelRequire("fT7M2");

var $iRBaU = parcelRequire("iRBaU");

var $cVnXt = parcelRequire("cVnXt");

var $eJOHy = parcelRequire("eJOHy");

var $59rsN = parcelRequire("59rsN");

var $6jRf7 = parcelRequire("6jRf7");

const $496df9575282d111$var$excludedMessages = new Set([
    'test-message-inapp',
    'message-template-template'
]);
const $496df9575282d111$export$5f4d7e99d8732fe7 = (0, $fT7M2.createPlacementComponent)((0, $7500e175244dce54$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $eJOHy.memo)(({ initialData: initialData, preloadedInitialData: preloadedInitialData, handleClearPreloadedData: handleClearPreloadedData })=>{
    const { data: data, isLoading: isLoading } = (0, $cVnXt.useInitialData)(initialData);
    const [{ message: message, status: status }, setMessageState] = (0, $eJOHy.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
            message: preloadedInitialData?.messages[0],
            status: 'done'
        } : {
            message: undefined,
            status: 'done'
        };
        return {
            message: undefined,
            status: 'loading'
        };
    });
    const handleOnDismissed = (0, $eJOHy.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
        if (typeof handleClearPreloadedData === 'function') handleClearPreloadedData();
    }, [
        handleClearPreloadedData
    ]);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $iJJ9P.useMessagePlacementHooks)();
    (0, $eJOHy.useEffect)(()=>onMessageDismiss(handleOnDismissed), [
        onMessageDismiss,
        handleOnDismissed
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageClicked(handleOnDismissed), [
        onMessageClicked,
        handleOnDismissed
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageSnooze(handleOnDismissed), [
        onMessageSnooze,
        handleOnDismissed
    ]);
    const isDone = status === 'done';
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoading && !isDone) {
            const filteredMessages = (data?.messages || []).filter((dataMessage)=>{
                if ($496df9575282d111$var$excludedMessages.has(dataMessage.messageTemplateId)) return false;
                if (dataMessage.messageTemplateId === 'rovo-extension-install-cta-left-nav') {
                    const cohort = (0, $59rsN.default).getExperimentValue('rovo-ext_left_nav_rovo_extension_cta', 'cohort', 'not-enrolled', {
                        fireExperimentExposure: true
                    });
                    if (cohort === 'not-enrolled' || cohort === 'control') return false;
                }
                return true;
            });
            const newMessage = filteredMessages[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
        }
    }, [
        data,
        isLoading,
        isDone
    ]);
    if (status === 'loading') return null;
    return message && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6jRf7.MessageRenderer), {
        ...message,
        id: message.messageInstanceId,
        onDismissed: handleOnDismissed,
        SuspenseBoundary: (0, $iRBaU.MaybeSuspenseBoundary)
    });
}), {
    choreographer: {
        isDefaultEnabled: false
    }
});
var $496df9575282d111$export$2e2bcd8739ae039 = $496df9575282d111$export$5f4d7e99d8732fe7;

});
parcelRegister("6jRf7", function(module, exports) {
$parcel$export(module.exports, "MessageRenderer", () => $a188a85287b6ded4$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $iRBaU = parcelRequire("iRBaU");

var $rqxoU = parcelRequire("rqxoU");

var $i5lCx = parcelRequire("i5lCx");

var $aduPT = parcelRequire("aduPT");

var $5OkqD = parcelRequire("5OkqD");
const $a188a85287b6ded4$export$e30378e28ad3e6ab = {
    ...(0, $rqxoU.default),
    ...(0, $i5lCx.default),
    ...(0, $aduPT.default),
    ...(0, $5OkqD.default)
};
const { initializeMessageRenderer: $a188a85287b6ded4$export$bce4e5106d86e473, MessageRenderer: $a188a85287b6ded4$export$2df1250b8f917a59 } = (0, $iRBaU.asMessageRenderer)($a188a85287b6ded4$export$e30378e28ad3e6ab);

});
parcelRegister("rqxoU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddfbed3d8b6a86cd$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $cE4ye = parcelRequire("cE4ye");

var $jh7wC = parcelRequire("jh7wC");

var $aeffS = parcelRequire("aeffS");

var $5EMU0 = parcelRequire("5EMU0");

var $1U8Lb = parcelRequire("1U8Lb");
var $ddfbed3d8b6a86cd$export$2e2bcd8739ae039 = {
    'recommendation-confluence': (0, $cE4ye.default),
    'recommendation-jpd': (0, $jh7wC.default),
    'recommendation-jsm': (0, $aeffS.default),
    'recommendation-jsw-visualize-work': (0, $5EMU0.default),
    'recommendation-loom': (0, $1U8Lb.default)
};

});
parcelRegister("cE4ye", function(module, exports) {
$parcel$export(module.exports, "default", () => $d49985c1bbf6448d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $lgMTT = parcelRequire("lgMTT");

var $6svvz = parcelRequire("6svvz");

var $iQlpp = parcelRequire("iQlpp");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $hiqmt = parcelRequire("hiqmt");
const $d49985c1bbf6448d$var$CCP_PRODUCT_ID = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $d49985c1bbf6448d$var$HAMS_PRODUCT_ID = 'confluence.ondemand';
const $d49985c1bbf6448d$var$PRODUCT_NAME = 'Confluence';
const $d49985c1bbf6448d$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-confluence.reasons-modal.message",
            defaultMessage: "We think {confluence} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Confluence recommendation will be relevant to the customer.",
            values: {
                confluence: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: $d49985c1bbf6448d$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $6svvz.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $d49985c1bbf6448d$export$b3890eb0ae9dca99 = (0, $hiqmt.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iQlpp.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $d49985c1bbf6448d$var$HAMS_PRODUCT_ID,
            ccpProductId: $d49985c1bbf6448d$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-confluence.product-name.header",
                description: "Header for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Collaborate on pages in real-time"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-confluence.cta.label",
                description: "CTA text for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Try Confluence"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $d49985c1bbf6448d$var$whyAmISeeingThisModalContent
    }));
var $d49985c1bbf6448d$export$2e2bcd8739ae039 = $d49985c1bbf6448d$export$b3890eb0ae9dca99;

});
parcelRegister("6svvz", function(module, exports) {
$parcel$export(module.exports, "whyAmISeeingThisRecommendationMessageDefaultReason", () => $6ca5fca7e56ca559$export$5a12ae0dd15a31ed);

var $gt9Am = parcelRequire("gt9Am");

var $kDaaB = parcelRequire("kDaaB");
const $6ca5fca7e56ca559$export$5a12ae0dd15a31ed = [
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "post-office.ad-controls.default-reason.team-size",
        description: "the first reason for displaying the message to the customer: the size of the customer's team",
        defaultMessage: "the size of your team"
    }),
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "post-office.ad-controls.default-reason.existing-products",
        description: "the second reason for displaying the message to the customer: the customer's existing Atlassian products",
        defaultMessage: "your existing Atlassian products"
    })
];

});

parcelRegister("iQlpp", function(module, exports) {
$parcel$export(module.exports, "JiraSideNavFirstPartyRecommendation", () => $fd31ce57c747673c$export$35f6f23f7684ff6);

var $gt9Am = parcelRequire("gt9Am");

var $806LH = parcelRequire("806LH");

var $78OnL = parcelRequire("78OnL");

var $1njtc = parcelRequire("1njtc");

var $6tbGL = parcelRequire("6tbGL");

var $i6m59 = parcelRequire("i6m59");
const $fd31ce57c747673c$var$BodyContent = ({ app: app })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                children: app.logo
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "xsmall",
                children: app.header
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i6m59.CTAButton), {
                app: app
            })
        ]
    });
};
const $fd31ce57c747673c$export$35f6f23f7684ff6 = ({ app: app, onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    const { messageInstanceId: messageInstanceId } = (0, $6tbGL.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1njtc.JiraSideNavMessage), {
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
        bodyContent: /*#__PURE__*/ (0, $gt9Am.jsx)($fd31ce57c747673c$var$BodyContent, {
            app: app
        })
    });
};

});
parcelRegister("1njtc", function(module, exports) {
$parcel$export(module.exports, "JiraSideNavMessage", () => $eb8fd8d384ea162c$export$ee97a7edb31193a8);
/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6tbGL = parcelRequire("6tbGL");

var $eej7h = parcelRequire("eej7h");
const $eb8fd8d384ea162c$var$jiraSideNavMessageStyle = null;
const $eb8fd8d384ea162c$export$ee97a7edb31193a8 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, bodyContent: bodyContent, showRemindMeLater: showRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis })=>{
    const { messageInstanceId: messageInstanceId } = (0, $6tbGL.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "jira-side-nav-message",
        className: (0, $hcewu.default)([
            "_2rko1mok _18zrpxbi _1rjcutpp _kqswh2mm _1e0c1txw _bfhk1hdx _otyru2gc _1pbyidpf"
        ]),
        children: [
            bodyContent,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eej7h.Actions), {
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
                onDismissed: ()=>onDismissed?.(messageInstanceId),
                showRemindMeLater: showRemindMeLater,
                showWhyAmISeeingThis: showWhyAmISeeingThis
            })
        ]
    });
};

});
parcelRegister("eej7h", function(module, exports) {
$parcel$export(module.exports, "Actions", () => $afe3bdb95386b5ae$export$b52183d5cfb26dc9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ehTFK = parcelRequire("ehTFK");
const $afe3bdb95386b5ae$var$actionsStyles = null;
const $afe3bdb95386b5ae$export$b52183d5cfb26dc9 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showRemindMeLater: showRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1yt4u2gc _kqswstnw _1e0c1txw _154iidpf _1xi2idpf"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ehTFK.AdControls), {
            iconSize: "small",
            onDismissed: onDismissed,
            showWhyAmISeeingThis: showWhyAmISeeingThis ?? true,
            whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
            showRemindMeLater: showRemindMeLater
        })
    });
};

});
parcelRegister("ehTFK", function(module, exports) {
$parcel$export(module.exports, "AdControls", () => $6e32cf03c89410c4$export$c25b8b7217045de9);

var $gt9Am = parcelRequire("gt9Am");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");

var $NByNW = parcelRequire("NByNW");

var $k71qx = parcelRequire("k71qx");

var $gr4vM = parcelRequire("gr4vM");

var $6tbGL = parcelRequire("6tbGL");

var $k9r6D = parcelRequire("k9r6D");

var $5EHjk = parcelRequire("5EHjk");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5jO2T = parcelRequire("5jO2T");

var $c225I = parcelRequire("c225I");

var $i7gWk = parcelRequire("i7gWk");
const $6e32cf03c89410c4$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, spacing: spacing = 'default', ...triggerProps })=>{
    const intl = (0, $lRq8t.default)();
    const ariaLabel = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.aria-label',
        defaultMessage: '{messageInstanceId} options menu',
        description: 'Options menu ad controls'
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.tooltip',
        defaultMessage: 'More actions',
        description: 'Tooltip for ad-controls dropdown'
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
            ...triggerProps,
            label: ariaLabel,
            appearance: "subtle",
            ref: triggerRef,
            spacing: spacing,
            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                    ...iconProps,
                    color: iconColor,
                    size: iconSize
                })
        })
    });
};
const $6e32cf03c89410c4$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, onRemindMeLater: onRemindMeLater, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis, showRemindMeLater: showRemindMeLater, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, zIndex: zIndex, spacing: spacing = 'default' })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $eJOHy.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $5EHjk.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const { messageInstanceId: messageInstanceId } = (0, $6tbGL.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $eJOHy.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    const [showDismissedFlag, setShowDismissedFlag] = (0, $eJOHy.useState)(false);
    const { messageSnoozed: messageSnoozed } = (0, $5EHjk.useMessageEvent)();
    const handleRemindMeLater = async ()=>{
        // https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageSnoozed(1); // DEPRECATED, but used alongside the messageInstanceClicked function just in case. See above page for documentation
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'remindMeLater',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'snooze',
                snoozeDuration: 1 // Snooze message for 1 day
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remindMeLater'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onRemindMeLater === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onRemindMeLater(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleNotInterested = async ()=>{
        await messageDismissed();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'notInterested',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'adControlsReasons',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    const fireDropdownMenuOpenAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsDropdown'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                testId: "post-office-ad-controls-dropdown",
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)($6e32cf03c89410c4$var$DropdownTrigger, {
                        name: messageInstanceId,
                        triggerRef: triggerRef,
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        spacing: spacing,
                        ...triggerProps
                    }),
                ...zIndex && {
                    zIndex: zIndex
                },
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireDropdownMenuOpenAnalyticsEvent();
                        setCurrIconColor("var(--ds-icon-selected, #0C66E4)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c225I.AdControlsDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    onRemindMeLater: handleRemindMeLater,
                    showWhyAmISeeingThis: showWhyAmISeeingThis,
                    showRemindMeLater: showRemindMeLater ? true : false
                })
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i7gWk.WhyAmISeeingThisModal), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                }
            }),
            showDismissedFlag && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5jO2T.AdControlsFlag), {
                messageInstanceId: messageInstanceId,
                onCloseFlag: ()=>setShowDismissedFlag(false)
            })
        ]
    });
};

});
parcelRegister("5jO2T", function(module, exports) {
$parcel$export(module.exports, "AdControlsFlag", () => $583f4a1ac545f44b$export$6eb98925a948bca3);
/* dismissalFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $1jLQ3 = parcelRequire("1jLQ3");
var $gPCVG = parcelRequire("gPCVG");

var $3wl9L = parcelRequire("3wl9L");

var $8IeH1 = parcelRequire("8IeH1");


var $kDaaB = parcelRequire("kDaaB");

var $iOX1N = parcelRequire("iOX1N");
const $583f4a1ac545f44b$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper';
/**-Title--**/ const $583f4a1ac545f44b$var$titleContainerStyles = {
    font: "_11c8140y"
};
const $583f4a1ac545f44b$var$Title = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $583f4a1ac545f44b$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.dismiss-flag.not-interested.title",
            defaultMessage: "Got it, thanks for letting us know",
            description: "The title for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
        })
    });
/**--Description--**/ const $583f4a1ac545f44b$var$Description = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "post-office.ad-controls.dismiss-flag.not-interested.subtitle",
        defaultMessage: "You won\u2019t see this here as often.",
        description: "The subtitle for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
    });
/**--Confirm Icon--*/ const $583f4a1ac545f44b$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
        spacing: "spacious",
        label: "Success",
        color: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$940e1f69e873f202)})`
    });
const $583f4a1ac545f44b$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $iOX1N.portalZIndexFix)($583f4a1ac545f44b$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPCVG.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            id: $583f4a1ac545f44b$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1jLQ3.default), {
                icon: /*#__PURE__*/ (0, $gt9Am.jsx)($583f4a1ac545f44b$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $gt9Am.jsx)($583f4a1ac545f44b$var$Title, {}),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)($583f4a1ac545f44b$var$Description, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};

});
parcelRegister("iOX1N", function(module, exports) {
$parcel$export(module.exports, "portalZIndexFix", () => $b097139e5e71ff62$export$cef2f5415067aeab);
const $b097139e5e71ff62$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $b097139e5e71ff62$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$b097139e5e71ff62$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $b097139e5e71ff62$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $b097139e5e71ff62$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};

});


parcelRegister("c225I", function(module, exports) {
$parcel$export(module.exports, "AdControlsDropdown", () => $9aaa64992b97dcf6$export$ba7539b3ac68f9f1);

var $gt9Am = parcelRequire("gt9Am");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $kDaaB = parcelRequire("kDaaB");
const $9aaa64992b97dcf6$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?",
            description: "The text for the button which opens a modal showing the reasons a message has been displayed."
        })
    });
const $9aaa64992b97dcf6$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested",
            description: "The text for the button which removes a message from a placement."
        })
    });
const $9aaa64992b97dcf6$export$c3a3ff4a62111967 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.dropdown-item.remind-me-later.label",
            defaultMessage: "Remind me later",
            description: "The text for the button which removes a message from a placement and makes it reappear at a later date."
        })
    });
const $9aaa64992b97dcf6$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, onRemindMeLater: onRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis = true, showRemindMeLater: showRemindMeLater })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aLJ1L.default), {
        children: [
            showRemindMeLater && /*#__PURE__*/ (0, $gt9Am.jsx)($9aaa64992b97dcf6$export$c3a3ff4a62111967, {
                testId: "ad-controls-dropdown-remind-me-later",
                onClick: onRemindMeLater
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($9aaa64992b97dcf6$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $gt9Am.jsx)($9aaa64992b97dcf6$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });

});

parcelRegister("i7gWk", function(module, exports) {
$parcel$export(module.exports, "WhyAmISeeingThisModal", () => $5337bdd47eec7250$export$b29014abf8076d54);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $eJ9f5 = parcelRequire("eJ9f5");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $8IeH1 = parcelRequire("8IeH1");

var $gr4vM = parcelRequire("gr4vM");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $iOX1N = parcelRequire("iOX1N");
const $5337bdd47eec7250$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content';
const $5337bdd47eec7250$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $iOX1N.portalZIndexFix)($5337bdd47eec7250$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
            shouldCloseOnEscapePress: true,
            onClose: onClose,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                id: $5337bdd47eec7250$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
const $5337bdd47eec7250$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK",
            description: "The text on the button that dismisses a modal which provides reasons a message has been displayed"
        })
    });
/*--Title--*/ const $5337bdd47eec7250$var$titleContainerStyles = {
    font: "_11c8lodh"
};
const $5337bdd47eec7250$var$Title = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $5337bdd47eec7250$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?",
            description: "The title for a modal that displays the reasons a message was displayed."
        })
    });
/*--Body--*/ const $5337bdd47eec7250$var$DefaultBody = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:",
            description: "Explanation of why we think the message will be releavant to the customer."
        })
    });
const $5337bdd47eec7250$var$reasonsListStyles = null;
const $5337bdd47eec7250$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        className: (0, $hcewu.default)([
            "_2mzu1wth _19bvv47k _19pkutpp"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                children: reason
            }, index))
    });
const $5337bdd47eec7250$var$privacyPolicyLinkWrapperStyles = null;
const $5337bdd47eec7250$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_19pkutpp"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "post-office.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian",
                description: "The text linking to Atlassian's privacy policy. https://hello.atlassian.net/l/cp/ssoqm2Fq"
            })
        })
    });
const $5337bdd47eec7250$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = (0, $eJOHy.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                    children: content?.title || /*#__PURE__*/ (0, $gt9Am.jsx)($5337bdd47eec7250$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                children: content?.body || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $gt9Am.jsx)($5337bdd47eec7250$var$DefaultBody, {}),
                        content?.reasons && /*#__PURE__*/ (0, $gt9Am.jsx)($5337bdd47eec7250$var$ReasonsList, {
                            reasons: content.reasons
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $gt9Am.jsx)($5337bdd47eec7250$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kseeK.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($5337bdd47eec7250$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
const $5337bdd47eec7250$export$b29014abf8076d54 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($5337bdd47eec7250$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($5337bdd47eec7250$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
};

});




parcelRegister("i6m59", function(module, exports) {
$parcel$export(module.exports, "CTAButton", () => $056eb2b607c286e9$export$bd36621ef7814117);

var $gt9Am = parcelRequire("gt9Am");

var $1DXK0 = parcelRequire("1DXK0");

var $91lid = parcelRequire("91lid");
const $056eb2b607c286e9$var$JOURNEY = 'get-started';
const $056eb2b607c286e9$var$SOURCE_COMPONENT = 'jira-side-nav';
const $056eb2b607c286e9$var$SOURCE_CONTEXT = 'tryItNow';
const $056eb2b607c286e9$var$ctaButtonStyles = (0, $1DXK0.xcss)({
    color: 'color.link',
    backgroundColor: 'color.background.accent.blue.subtlest',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    paddingLeft: '0'
});
const $056eb2b607c286e9$export$bd36621ef7814117 = ({ app: app })=>{
    const crossflowOptions = {
        targetProduct: app.hamsIdentifier,
        journey: $056eb2b607c286e9$var$JOURNEY,
        sourceComponent: $056eb2b607c286e9$var$SOURCE_COMPONENT,
        sourceContext: $056eb2b607c286e9$var$SOURCE_CONTEXT
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $91lid.CrossflowCtaPrimaryPressable), {
        crossflowOptions: crossflowOptions,
        ctaText: app.ctaMessage,
        pressableStyle: $056eb2b607c286e9$var$ctaButtonStyles
    });
};

});
parcelRegister("91lid", function(module, exports) {
$parcel$export(module.exports, "CrossflowCtaPrimaryLinkButton", () => $f4e8bdadde6a96e7$export$55d6f395fee83ac9);
$parcel$export(module.exports, "CrossflowCtaPrimaryPressable", () => $f4e8bdadde6a96e7$export$585a4ef79f2a8b77);
$parcel$export(module.exports, "CrossflowCtaSecondaryPressable", () => $f4e8bdadde6a96e7$export$ba0dce35a480e0b4);

var $gt9Am = parcelRequire("gt9Am");

var $5CSKW = parcelRequire("5CSKW");

var $bQP4O = parcelRequire("bQP4O");

var $crAix = parcelRequire("crAix");
const $f4e8bdadde6a96e7$var$PRIMARY_LINK_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $f4e8bdadde6a96e7$export$55d6f395fee83ac9 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, appearance: appearance, alt: alt })=>{
    const { handleClick: handleClick } = (0, $crAix.useCrossflowMessageClicked)(crossflowOptions, $f4e8bdadde6a96e7$var$PRIMARY_LINK_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
        onClick: handleClick,
        appearance: appearance,
        "aria-label": alt,
        children: ctaText
    });
};
const $f4e8bdadde6a96e7$var$PRIMARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $f4e8bdadde6a96e7$export$585a4ef79f2a8b77 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $crAix.useCrossflowMessageClicked)(crossflowOptions, $f4e8bdadde6a96e7$var$PRIMARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};
const $f4e8bdadde6a96e7$var$SECONDARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'secondary'
};
const $f4e8bdadde6a96e7$export$ba0dce35a480e0b4 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $crAix.useCrossflowMessageClicked)(crossflowOptions, $f4e8bdadde6a96e7$var$SECONDARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};

});
parcelRegister("crAix", function(module, exports) {
$parcel$export(module.exports, "useCrossflowMessageClicked", () => $35130801f05c8f82$export$1c3f82bc53516a2a);

var $59rsN = parcelRequire("59rsN");
parcelRequire("6X7AJ");
var $cqw6Y = parcelRequire("cqw6Y");

var $k9r6D = parcelRequire("k9r6D");

var $5EHjk = parcelRequire("5EHjk");

var $eJOHy = parcelRequire("eJOHy");
const $35130801f05c8f82$export$1c3f82bc53516a2a = (crossflowOptions, clickedElement)=>{
    const crossflow = (0, $cqw6Y.useCrossFlow)();
    const { messageClicked: messageClicked } = (0, $5EHjk.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        messageClicked().catch(()=>{});
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        }).catch(()=>{});
        if (crossflow.isEnabled) {
            // GALILEO-5608 start
            if (crossflowOptions.sourceComponent === 'jira-your-work' && crossflowOptions.sourceContext === 'tryItNow') crossflowOptions.journey = (0, $59rsN.default).getExperimentValue('twcg-893_open_cffe_in_your_work_touchpoint', 'journey', 'decide');
            // GALILEO-5608 end
            crossflow.api.open(crossflowOptions).catch(()=>{});
        }
    }, [
        crossflow,
        crossflowOptions,
        clickedElement,
        messageClicked,
        messageInstanceClicked
    ]);
    return {
        handleClick: handleClick
    };
};

});




parcelRegister("hiqmt", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $889c376d4a0d0800$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $889c376d4a0d0800$export$78c758434c34d601, createValidate: $889c376d4a0d0800$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $889c376d4a0d0800$export$c905bc718befd59b, createHydrateExample: $889c376d4a0d0800$export$1f41223e5b0a6622, createTransformMetadata: $889c376d4a0d0800$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});


parcelRegister("jh7wC", function(module, exports) {
$parcel$export(module.exports, "default", () => $974c208d25b20d4e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $lgMTT = parcelRequire("lgMTT");

var $6svvz = parcelRequire("6svvz");

var $iQlpp = parcelRequire("iQlpp");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $45stn = parcelRequire("45stn");
const $974c208d25b20d4e$var$CCP_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $974c208d25b20d4e$var$HAMS_PRODUCT_ID = 'jira-product-discovery';
const $974c208d25b20d4e$var$PRODUCT_NAME = 'Jira Product Discovery';
const $974c208d25b20d4e$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-jpd.reasons-modal.message",
            defaultMessage: "We think {jpd} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JPD recommendation will be relevant to the customer.",
            values: {
                jpd: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: $974c208d25b20d4e$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $6svvz.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $974c208d25b20d4e$export$b3890eb0ae9dca99 = (0, $45stn.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iQlpp.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $974c208d25b20d4e$var$HAMS_PRODUCT_ID,
            ccpProductId: $974c208d25b20d4e$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraProductDiscoveryIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jpd.product-name.header",
                description: "Header for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Transform insights into action plans"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jpd.cta.label",
                description: "CTA text for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Product Discovery"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $974c208d25b20d4e$var$whyAmISeeingThisModalContent
    }));
var $974c208d25b20d4e$export$2e2bcd8739ae039 = $974c208d25b20d4e$export$b3890eb0ae9dca99;

});
parcelRegister("45stn", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $3aa85fe314a94431$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $3aa85fe314a94431$export$78c758434c34d601, createValidate: $3aa85fe314a94431$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $3aa85fe314a94431$export$c905bc718befd59b, createHydrateExample: $3aa85fe314a94431$export$1f41223e5b0a6622, createTransformMetadata: $3aa85fe314a94431$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});


parcelRegister("aeffS", function(module, exports) {
$parcel$export(module.exports, "default", () => $063e9ff01347fddf$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $lgMTT = parcelRequire("lgMTT");

var $6svvz = parcelRequire("6svvz");

var $iQlpp = parcelRequire("iQlpp");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $79wEN = parcelRequire("79wEN");
const $063e9ff01347fddf$export$3678c6c473f30928 = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $063e9ff01347fddf$export$5fca8a2477be63d = 'jira-servicedesk.ondemand';
const $063e9ff01347fddf$var$PRODUCT_NAME = 'Jira Service Management';
const $063e9ff01347fddf$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-jsm.reasons-modal.message",
            defaultMessage: "We think {jsm} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JSM recommendation will be relevant to the customer.",
            values: {
                jsm: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: $063e9ff01347fddf$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $6svvz.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $063e9ff01347fddf$export$b3890eb0ae9dca99 = (0, $79wEN.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iQlpp.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $063e9ff01347fddf$export$5fca8a2477be63d,
            ccpProductId: $063e9ff01347fddf$export$3678c6c473f30928,
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraServiceManagementIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jsm.product-name.header",
                description: "Header for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Automate workflows for faster resolutions"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jsm.cta.label",
                description: "CTA text for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Service Management"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $063e9ff01347fddf$var$whyAmISeeingThisModalContent
    }));
var $063e9ff01347fddf$export$2e2bcd8739ae039 = $063e9ff01347fddf$export$b3890eb0ae9dca99;

});
parcelRegister("79wEN", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $3deae1fa2ced1539$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $3deae1fa2ced1539$export$78c758434c34d601, createValidate: $3deae1fa2ced1539$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $3deae1fa2ced1539$export$c905bc718befd59b, createHydrateExample: $3deae1fa2ced1539$export$1f41223e5b0a6622, createTransformMetadata: $3deae1fa2ced1539$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});


parcelRegister("5EMU0", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed17516530683db7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $lgMTT = parcelRequire("lgMTT");

var $6svvz = parcelRequire("6svvz");

var $iQlpp = parcelRequire("iQlpp");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8VSsT = parcelRequire("8VSsT");

const $ed17516530683db7$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-jsw-visualize-work.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Jira recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: (0, $6cdfea85df797e19$export$a75e537c279a265a)
                })
            }
        })
    }),
    reasons: (0, $6svvz.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $ed17516530683db7$export$b3890eb0ae9dca99 = (0, $8VSsT.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iQlpp.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $6cdfea85df797e19$export$5fca8a2477be63d),
            ccpProductId: (0, $6cdfea85df797e19$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jsw-visualize-work.product-name.header",
                description: "Header for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Visualize your projects in lists, boards, and more"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jsw-visualize-work.cta.label",
                description: "CTA text for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $ed17516530683db7$var$whyAmISeeingThisModalContent
    }));
var $ed17516530683db7$export$2e2bcd8739ae039 = $ed17516530683db7$export$b3890eb0ae9dca99;

});
parcelRegister("8VSsT", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $83d48485e06c3a6e$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $83d48485e06c3a6e$export$78c758434c34d601, createValidate: $83d48485e06c3a6e$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $83d48485e06c3a6e$export$c905bc718befd59b, createHydrateExample: $83d48485e06c3a6e$export$1f41223e5b0a6622, createTransformMetadata: $83d48485e06c3a6e$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});

const $6cdfea85df797e19$export$3678c6c473f30928 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $6cdfea85df797e19$export$5fca8a2477be63d = 'jira-software.ondemand';
const $6cdfea85df797e19$export$a75e537c279a265a = 'Jira';


parcelRegister("1U8Lb", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d7e8c9de49fbc1e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $lgMTT = parcelRequire("lgMTT");

var $6svvz = parcelRequire("6svvz");

var $iQlpp = parcelRequire("iQlpp");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $eEc1W = parcelRequire("eEc1W");

const $1d7e8c9de49fbc1e$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-loom.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Loom recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: (0, $d5bc039d39c4ce3c$export$a75e537c279a265a)
                })
            }
        })
    }),
    reasons: (0, $6svvz.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $1d7e8c9de49fbc1e$export$b3890eb0ae9dca99 = (0, $eEc1W.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iQlpp.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $d5bc039d39c4ce3c$export$5fca8a2477be63d),
            ccpProductId: (0, $d5bc039d39c4ce3c$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.LoomIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-loom.product-name.header",
                description: "Header for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Record and share videos easily"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-loom.cta.label",
                description: "CTA text for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Try Loom"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $1d7e8c9de49fbc1e$var$whyAmISeeingThisModalContent
    }));
var $1d7e8c9de49fbc1e$export$2e2bcd8739ae039 = $1d7e8c9de49fbc1e$export$b3890eb0ae9dca99;

});
parcelRegister("eEc1W", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $c3f33a6ac9a199ce$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $c3f33a6ac9a199ce$export$78c758434c34d601, createValidate: $c3f33a6ac9a199ce$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $c3f33a6ac9a199ce$export$c905bc718befd59b, createHydrateExample: $c3f33a6ac9a199ce$export$1f41223e5b0a6622, createTransformMetadata: $c3f33a6ac9a199ce$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});

const $d5bc039d39c4ce3c$export$ea76e6b040284832 = 'loom';
const $d5bc039d39c4ce3c$export$5fca8a2477be63d = 'loom';
const $d5bc039d39c4ce3c$export$a75e537c279a265a = 'Loom';
const $d5bc039d39c4ce3c$export$3678c6c473f30928 = '7683a73e-423d-41a1-b43f-d497656f8b5d';



parcelRegister("i5lCx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c364e01ff2452d90$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $2r3UL = parcelRequire("2r3UL");
var $c364e01ff2452d90$export$2e2bcd8739ae039 = {
    'message-template-template': (0, $2r3UL.default)
};

});
parcelRegister("2r3UL", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3c3526f6f012e0c$export$2e2bcd8739ae039);
/* eslint-disable formatjs/no-literal-string-in-jsx */ 
var $gt9Am = parcelRequire("gt9Am");

var $2mfAU = parcelRequire("2mfAU");
const $b3c3526f6f012e0c$export$b3890eb0ae9dca99 = (0, $2mfAU.createRender)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        children: `Hello world!`
    }));
var $b3c3526f6f012e0c$export$2e2bcd8739ae039 = $b3c3526f6f012e0c$export$b3890eb0ae9dca99;

});
parcelRegister("2mfAU", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $d02597a4dd4d606f$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $d02597a4dd4d606f$export$78c758434c34d601, createValidate: $d02597a4dd4d606f$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $d02597a4dd4d606f$export$c905bc718befd59b, createHydrateExample: $d02597a4dd4d606f$export$1f41223e5b0a6622, createTransformMetadata: $d02597a4dd4d606f$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});



parcelRegister("aduPT", function(module, exports) {
$parcel$export(module.exports, "default", () => $4613d8e16c9c2685$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $2kNgG = parcelRequire("2kNgG");
var $4613d8e16c9c2685$export$2e2bcd8739ae039 = {
    'rovo-extension-install-cta-left-nav': (0, $2kNgG.default)
};

});
parcelRegister("2kNgG", function(module, exports) {
$parcel$export(module.exports, "default", () => $41678dfc94957521$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $2HcEs = parcelRequire("2HcEs");

var $an9gi = parcelRequire("an9gi");
const $41678dfc94957521$export$b3890eb0ae9dca99 = (0, $2HcEs.createRender)(({ onDismissed: onDismissed, experimentCohort: experimentCohort })=>{
    const context = {
        experimentCohort: experimentCohort,
        source: 'jira-side-nav'
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $an9gi.LeftNavCtaMessage), {
        handleOnDismissed: onDismissed,
        context: context
    });
});
var $41678dfc94957521$export$2e2bcd8739ae039 = $41678dfc94957521$export$b3890eb0ae9dca99;

});
parcelRegister("2HcEs", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $28853058071fde47$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $28853058071fde47$export$78c758434c34d601, createValidate: $28853058071fde47$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $28853058071fde47$export$c905bc718befd59b, createHydrateExample: $28853058071fde47$export$1f41223e5b0a6622, createTransformMetadata: $28853058071fde47$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});

parcelRegister("an9gi", function(module, exports) {
$parcel$export(module.exports, "LeftNavCtaMessage", () => $763a0286ec8d0640$export$217ec4c85bc42809);
/* LeftNavCtaMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable formatjs/no-literal-string-in-jsx */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $806LH = parcelRequire("806LH");

var $6zhpo = parcelRequire("6zhpo");

var $8wyVH = parcelRequire("8wyVH");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");

var $k9r6D = parcelRequire("k9r6D");

var $5EHjk = parcelRequire("5EHjk");

var $6XBM8 = parcelRequire("6XBM8");

var $bqN6a = parcelRequire("bqN6a");

var $lRq8t = parcelRequire("lRq8t");

var $ieAtq = parcelRequire("ieAtq");
const $763a0286ec8d0640$var$styles = {
    boxContainer: "_1yt4utpp _zulpu2gc _2rko12b0 _ae4v1h6o _1bah1h6o _1e0c1txw _1bsb1osq _4cvr1y6m _bfhkavxe",
    mainContent: "_zulpu2gc _1e0c1txw _4cvr1y6m _1bsb1osq",
    rightColumn: "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug",
    headerInline: "_1bah1yb4 _4cvr1h6o",
    iconContainer: "_1e0c1txw _4cvr1h6o"
};
const $763a0286ec8d0640$var$getLinkUrl = (source, cohort)=>{
    const UTM_MEDIUM = 'banner';
    const UTM_CAMPAIGN = 'rovo_extension_side_nav_install_cta';
    const UTM_CONTENT = `side_nav_install_cta_${cohort}`;
    return `https://chromewebstore.google.com/detail/rovo-search-chat-and-more/npbjhobkibekbklkghlhfhieggcggpdb?utm_source=${source}&utm_medium=${UTM_MEDIUM}&utm_campaign=${UTM_CAMPAIGN}&utm_content=${UTM_CONTENT}`;
};
const $763a0286ec8d0640$var$selectCopyForCohort = (cohort)=>{
    return (0, $ieAtq.COPY_VARIATIONS)[cohort] || (0, $ieAtq.COPY_VARIATIONS)['copy-version-a'];
};
const $763a0286ec8d0640$export$217ec4c85bc42809 = ({ handleOnDismissed: handleOnDismissed, context: context })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { experimentCohort: experimentCohort, source: source } = context;
    const { heading: heading, description: description } = $763a0286ec8d0640$var$selectCopyForCohort(experimentCohort);
    const { messageClicked: messageClicked } = (0, $5EHjk.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const headingText = formatMessage(heading);
    const descriptionText = formatMessage(description);
    const linkText = formatMessage({
        id: 'rovo-extension-install-cta-left-nav.link',
        defaultMessage: 'Get the browser extension',
        description: 'Text for rovo extension install cta link left nav'
    });
    const linkUrl = $763a0286ec8d0640$var$getLinkUrl(source, experimentCohort);
    const handleDismiss = ()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: source
            }
        });
        handleOnDismissed();
    };
    const handleLinkClick = ()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'installLink',
                clickedElement: 'link'
            },
            action: {
                actionType: 'open',
                destinationUrl: linkUrl
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: source
            }
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: (0, $6qaBj.cx)($763a0286ec8d0640$var$styles.boxContainer),
        style: {
            border: `1px solid ${"var(--ds-border, #091E4224)"}`
        },
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
            xcss: (0, $6qaBj.cx)($763a0286ec8d0640$var$styles.mainContent),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
                    xcss: (0, $6qaBj.cx)($763a0286ec8d0640$var$styles.iconContainer),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bqN6a))),
                            alt: "Rovo Icon",
                            width: 24,
                            height: 24,
                            style: {
                                flexShrink: 0,
                                zIndex: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6XBM8))),
                            alt: "Google Chrome Icon",
                            width: 24,
                            height: 24,
                            style: {
                                marginLeft: '-8px',
                                flexShrink: 0,
                                zIndex: 1
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                    xcss: (0, $6qaBj.cx)($763a0286ec8d0640$var$styles.rightColumn),
                    testId: "rovo-left-nav-right-column",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                            alignBlock: "center",
                            xcss: (0, $6qaBj.cx)($763a0286ec8d0640$var$styles.headerInline),
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                    size: "xsmall",
                                    children: headingText
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
                                    label: "Dismiss message",
                                    appearance: "subtle",
                                    onClick: handleDismiss
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                            size: "small",
                            children: descriptionText
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                            href: linkUrl,
                            target: "blank",
                            onClick: handleLinkClick,
                            children: linkText
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("6XBM8", function(module, exports) {
module.exports = new URL("chrome-icon.f5fbabc6.svg", import.meta.url).toString();

});

parcelRegister("bqN6a", function(module, exports) {
module.exports = new URL("rovo-icon.c02ccc2a.svg", import.meta.url).toString();

});

parcelRegister("ieAtq", function(module, exports) {
$parcel$export(module.exports, "COPY_VARIATIONS", () => $d68adb238b6979e2$export$1d02164cdbd97674);
const $d68adb238b6979e2$export$1d02164cdbd97674 = {
    'copy-version-a': {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading',
            defaultMessage: "Get help with what you're working on",
            description: 'Heading text for rovo extension install cta left nav'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description',
            defaultMessage: 'Rovo Chat knows your context. Available from any tab.',
            description: 'Description text for rovo extension install cta left nav'
        }
    },
    'copy-version-b': {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.copy-version-b',
            defaultMessage: 'Get answers for work, anywhere',
            description: 'Heading text for rovo extension install cta left nav'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.copy-version-b',
            defaultMessage: 'Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab.',
            description: 'Description text for rovo extension install cta left nav'
        }
    },
    'copy-version-c': {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.copy-version-c',
            defaultMessage: 'Unlock Rovo in every tab',
            description: 'Heading text for rovo extension install cta left nav'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.copy-version-c',
            defaultMessage: '30K+ workers use it to chat with AI that understands their company.',
            description: 'Description text for rovo extension install cta left nav'
        }
    },
    'copy-version-d': {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.copy-version-d',
            defaultMessage: 'Bring Rovo to every tab',
            description: 'Heading text for rovo extension install cta left nav'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.copy-version-d',
            defaultMessage: 'Chat with AI that understands your projects and teams. No switching tabs needed.',
            description: 'Description text for rovo extension install cta left nav'
        }
    }
};

});




parcelRegister("5OkqD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec3f6caf87796dae$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $607H1 = parcelRequire("607H1");
var $ec3f6caf87796dae$export$2e2bcd8739ae039 = {
    'test-message-inapp': (0, $607H1.default)
};

});
parcelRegister("607H1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5adceaa1379cd496$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $lwnpJ = parcelRequire("lwnpJ");
const $5adceaa1379cd496$export$b3890eb0ae9dca99 = (0, $lwnpJ.createRender)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        children: "This is an example test button"
    }));
var $5adceaa1379cd496$export$2e2bcd8739ae039 = $5adceaa1379cd496$export$b3890eb0ae9dca99;

});
parcelRegister("lwnpJ", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $75ed2870e707fb25$export$78c758434c34d601);

var $eMVZo = parcelRequire("eMVZo");
const { createRender: $75ed2870e707fb25$export$78c758434c34d601, createValidate: $75ed2870e707fb25$export$2859a83e4d6da57d } = (0, $eMVZo.createClientPipeline)();
const { createHydrate: $75ed2870e707fb25$export$c905bc718befd59b, createHydrateExample: $75ed2870e707fb25$export$1f41223e5b0a6622, createTransformMetadata: $75ed2870e707fb25$export$88fe13b4d13f8423 } = (0, $eMVZo.createServerPipeline)();

});




/* GeneratedContentHash: 9c47655ae0da7c4a10425612f1be5cf9c57ec22e23c4d4b1e4a2589c469dc001 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $7500e175244dce54$export$a5cfae247d8360ef = 'jira-side-nav';



parcelRegister("e5TCl", function(module, exports) {
$parcel$export(module.exports, "NavPlatformSidebar", () => $819bf05af8d51eaf$export$7d687ab114dcac8a);

var $eJOHy = parcelRequire("eJOHy");

var $20Hsz = parcelRequire("20Hsz");

var $7ox54 = parcelRequire("7ox54");

var $lTExG = parcelRequire("lTExG");
function $819bf05af8d51eaf$export$7d687ab114dcac8a() {
    /*
		1. Add UFOSegment
		2. Determine which sidebar to show
		  a. If NOT content sidebar,
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
		  b. Otherwise,
		    1. Get items-config (default config), using custom components


	*/ /*
		Use same sidebar-selector logic as in navigation-apps/sidebar-nav4/sidebar-selector/src/ui/entrypoint/index.tsx
	*/ const paramsForGetNav4SidebarId = (0, $20Hsz.useGetParamsForGetNav4SidebarId)();
    const currentSidebarId = (0, $20Hsz.getNav4SidebarId)(paramsForGetNav4SidebarId);
    if (currentSidebarId === 'CONTENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ox54.GSNForContentSidebar), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTExG.GSNForOtherSidebars), {
        sidebarId: currentSidebarId
    });
}

});
parcelRegister("7ox54", function(module, exports) {
$parcel$export(module.exports, "GSNForContentSidebar", () => $ae9c45f14bc9869f$export$a507175eae481438);

var $QuA6u = parcelRequire("QuA6u");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $b94hs = parcelRequire("b94hs");

var $9FYIg = parcelRequire("9FYIg");

var $dpxw4 = parcelRequire("dpxw4");

var $5n5Xi = parcelRequire("5n5Xi");

var $8IuE5 = parcelRequire("8IuE5");

var $41vqi = parcelRequire("41vqi");

var $2wp9U = parcelRequire("2wp9U");

var $4P1EM = parcelRequire("4P1EM");

var $7u7ku = parcelRequire("7u7ku");

var $gk3Hc = parcelRequire("gk3Hc");

var $49MXG = parcelRequire("49MXG");

var $iPxs6 = parcelRequire("iPxs6");

var $2geah = parcelRequire("2geah");

var $cRvJm = parcelRequire("cRvJm");

var $cRLIL = parcelRequire("cRLIL");

var $iFx8E = parcelRequire("iFx8E");

var $g0Ue2 = parcelRequire("g0Ue2");

var $i8N06 = parcelRequire("i8N06");

var $4cTDP = parcelRequire("4cTDP");

var $eJYI8 = parcelRequire("eJYI8");

var $99tvj = parcelRequire("99tvj");

var $24QYf = parcelRequire("24QYf");

var $753q2 = parcelRequire("753q2");

var $6JmRt = parcelRequire("6JmRt");

var $cHtIB = parcelRequire("cHtIB");

var $f2sjT = parcelRequire("f2sjT");

var $e6YEs = parcelRequire("e6YEs");

var $7Cu03 = parcelRequire("7Cu03");

var $goBB5 = parcelRequire("goBB5");

var $a62R3 = parcelRequire("a62R3");

var $eL2Ux = parcelRequire("eL2Ux");

var $d5UZJ = parcelRequire("d5UZJ");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");


var $460WX = parcelRequire("460WX");
function $ae9c45f14bc9869f$export$a507175eae481438() {
    /*
  	TODO: Add support for entryPoint routes
  	*/ // This is the non-EP solution for loading the data
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $6JmRt.navPlatformSidebarResource));
    const queryReferenceRef = (0, $eJOHy.useRef)(null);
    // We don't want to use nullable query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    else if (!queryReferenceRef.current) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ae9c45f14bc9869f$var$GSNForContentSidebarInner, {
        queryReference: queryReferenceRef.current
    });
}
function $ae9c45f14bc9869f$var$GSNForContentSidebarInner(props) {
    const { queryReference: queryReference } = props;
    const queryRef = (0, $j4oe4.usePreloadedQuery)(/* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ (0, $QuA6u.default), queryReference);
    const shouldRenderOverviews = (0, $eJYI8.useShouldRenderOverviews)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const ownerId = (0, $e6YEs.useAccountId)();
    // Note: When Jira GSN adoption rolls out, it should rollout with "network-migration" for 3 months
    //  to give time for all old user settings to be stored in the new records.
    //
    //    - customizationStore="network-migration"
    //
    //  After 3 months of being rolled-out, create a new FG to:
    //   - Change customizationStore to "network"
    //   - @include(if: $fgVariable) for useNetworkSideNavUserData.
    //   - After that has rolled out,
    //
    const customizationStore = 'network-migration';
    const navItems = (0, $99tvj.useFilterL1MenuItemsByEditionAndLicense)((0, $cxKOj.expVal)('navx-1982-change-order-of-teams-and-goals', 'isEnabled', false) ? (0, $24QYf.USER_NAVIGATION_CONFIGURATION_DEFAULT_GOALS_TEAMS_SWITCHED).navItems : (0, $24QYf.USER_NAVIGATION_CONFIGURATION_DEFAULT).navItems);
    const items = $ae9c45f14bc9869f$var$useItemConfig(navItems, queryRef, shouldRenderOverviews);
    const recentEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            count: (0, $48cae6cf1c387d08$export$56ff071570537731)
        }), [
        cloudId
    ]);
    const forYouConfig = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>(0, $460WX.getForYouConfig)({
            recentEntryPointParams: recentEntryPointParams
        }), [
        recentEntryPointParams
    ]);
    const networkStorageParams = (0, $eJOHy.useMemo)(()=>{
        const siteId = cloudId;
        const entityAri = (0, $goBB5.JiraWorkspaceAri).create({
            siteId: siteId,
            activationId: activationId
        }).toString();
        const ownerAri = ownerId && (0, $7Cu03.IdentityUserAri).create({
            userId: ownerId
        }).toString() || '';
        return {
            activationId: activationId,
            entityAri: entityAri,
            ownerAri: ownerAri,
            siteId: siteId,
            queryRef: queryRef
        };
    }, [
        cloudId,
        activationId,
        ownerId,
        queryRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpxw4.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b94hs.GlobalSideNavigation), {
        app: "jira",
        appLabel: "Jira",
        customizationStore: customizationStore,
        forYou: forYouConfig,
        items: items,
        networkStorageParams: networkStorageParams,
        testId: "nav-platform-integration-sidebar.ui.global-side-navigation"
    }));
}
function $ae9c45f14bc9869f$var$useItemConfig(navItems, queryRef, shouldRenderOverviews) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const components = (0, $eJOHy.useMemo)(()=>{
        const componentProps = {
            isExpanded: false,
            queryRef: queryRef
        };
        const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
        return navItems.map(({ menuId: menuId })=>{
            switch(menuId){
                case (0, $8IuE5.L1_MENU_ID).APPS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wp9U.Nav4Apps), componentProps);
                case (0, $8IuE5.L1_MENU_ID).ASSETS:
                    /* remove this case on
           * assets_as_an_app_v2 cleanup
           */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4P1EM.Nav4Assets), {
                        isExpanded: componentProps.isExpanded
                    });
                case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gk3Hc.Nav4Dashboards), {
                        isExpanded: componentProps.isExpanded
                    });
                case (0, $8IuE5.L1_MENU_ID).FILTERS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5n5Xi.Nav4Filters), componentProps);
                case (0, $8IuE5.L1_MENU_ID).GOALS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $753q2.Stub), {
                        menuId: (0, $8IuE5.L1_MENU_ID).GOALS,
                        href: USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GOALS]
                    });
                case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $49MXG.Nav4Operations), componentProps);
                case (0, $8IuE5.L1_MENU_ID).PLANS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2geah.Nav4Plans), componentProps);
                case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
                    return shouldRenderOverviews ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iPxs6.Nav4Overviews), componentProps) : null;
                case (0, $8IuE5.L1_MENU_ID).PROJECTS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRvJm.Nav4Projects), componentProps);
                case (0, $8IuE5.L1_MENU_ID).RECENT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRLIL.Recent), null);
                case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iFx8E.Nav4Roadmaps), {
                        isExpanded: componentProps.isExpanded
                    });
                case (0, $8IuE5.L1_MENU_ID).STARRED:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g0Ue2.Starred), null);
                case (0, $8IuE5.L1_MENU_ID).TEAMS:
                    return !(0, $a62R3.isTeamsAppEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8N06.Teams), null) : null;
                case (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE:
                    return (0, $4cTDP.fg)('jcs_master_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7u7ku.CustomerService), null) : null;
                default:
                    return null;
            }
        });
    }, [
        navItems,
        queryRef,
        shouldRenderOverviews
    ]);
    return (0, $eJOHy.useMemo)(()=>navItems.reduce((acc, navItem, index)=>{
            const component = components[index];
            // We need a configurable menu id and a component to continue
            if ((0, $d5UZJ.isConfigurableMenuId)(navItem.menuId) && component) {
                const { message: message, Icon: Icon } = (0, $eL2Ux.getConfigurableMessageAndIcon)(navItem.menuId);
                const label = formatMessage(message);
                // See src/packages/navigation-apps/sidebar-nav4/sidebars/common/core/src/common/utils/use-formatted-message-and-icon/index.tsx
                const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
                    label: label,
                    spacing: "spacious",
                    color: "currentColor"
                });
                acc[navItem.menuId] = {
                    type: 'custom',
                    elemBefore: elemBefore,
                    label: label,
                    Component: ()=>component
                };
            }
            return acc;
        }, {}), [
        components,
        formatMessage,
        navItems
    ]);
}

});
parcelRegister("b94hs", function(module, exports) {
$parcel$export(module.exports, "GlobalSideNavigation", () => $a2809952aa75daaa$export$e3822b656235cd34);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $bskNA = parcelRequire("bskNA");

var $iJSFh = parcelRequire("iJSFh");
var $9tH93 = parcelRequire("9tH93");

var $3wpcZ = parcelRequire("3wpcZ");

var $4Akzk = parcelRequire("4Akzk");

var $lwkX3 = parcelRequire("lwkX3");

var $lmbOW = parcelRequire("lmbOW");

var $8xJnH = parcelRequire("8xJnH");

var $i84Wd = parcelRequire("i84Wd");

var $8wdqp = parcelRequire("8wdqp");

var $050GH = parcelRequire("050GH");

var $clEd7 = parcelRequire("clEd7");
const $a2809952aa75daaa$export$e3822b656235cd34 = (0, $3wpcZ.withSideNavigationAnalyticsContext)($a2809952aa75daaa$var$RawGlobalSideNavigation);
var $a2809952aa75daaa$export$2e2bcd8739ae039 // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
 = $a2809952aa75daaa$var$RawGlobalSideNavigation;
function $a2809952aa75daaa$var$RawGlobalSideNavigation(props) {
    const { app: app, appLabel: appLabel, cloudId: cloudId, customizationStore: customizationStore = 'local', disableMenuCustomization: disableMenuCustomization = false, forYou: forYou, growthItemShortcuts: growthItemShortcuts, isShortcutsStatic: isShortcutsStatic, items: items, networkStorageParams: networkStorageParams, orgId: orgId, peekMenuId: peekMenuId, shortcuts: shortcuts, userId: userId, ...innerProps } = props;
    const Store = (0, $eJOHy.useMemo)(()=>{
        switch(customizationStore){
            case 'local':
                return 0, $i84Wd.LocalStore;
            case 'network-migration':
                return 0, $8wdqp.NetworkMigrationStore;
            default:
                return 0, $050GH.NetworkStore;
        }
    }, [
        customizationStore
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Akzk.AsyncIntlProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bskNA.ModalContextProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9tH93.BFFProvider), {
                consumer: (0, $iJSFh.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lmbOW.OptionsProvider), {
                    app: app,
                    appLabel: appLabel,
                    cloudId: cloudId,
                    customizationStore: customizationStore,
                    disableMenuCustomization: disableMenuCustomization,
                    isShortcutsStatic: isShortcutsStatic,
                    l1DragAndDropEnabled: !disableMenuCustomization && (0, $eGOwo.fg)('navx-515-l1-dnd-support'),
                    networkStorageParams: networkStorageParams,
                    orgId: orgId,
                    userId: userId,
                    hasBottomElement: !!innerProps?.bottomElem,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lwkX3.ItemsAndShortcutsProvider), {
                        forYou: forYou,
                        growthItemShortcuts: growthItemShortcuts,
                        items: items,
                        rawShortcuts: shortcuts,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8xJnH.PeekMenuIdProviders), {
                            value: peekMenuId,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Store, {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $clEd7.SideNav), {
                                    ...innerProps
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("3wpcZ", function(module, exports) {
$parcel$export(module.exports, "withSideNavigationAnalyticsContext", () => $de3aff9237c2ff8d$export$6d30b5ca07993d23);
$parcel$export(module.exports, "withSideNavigationAnalyticsListener", () => $de3aff9237c2ff8d$export$b46bb3dcfcaed790);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eUaD0 = parcelRequire("eUaD0");

var $8QoO2 = parcelRequire("8QoO2");

var $jlXoy = parcelRequire("jlXoy");

function $de3aff9237c2ff8d$export$6d30b5ca07993d23(WrappedComponent) {
    return (props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.NavigationAnalyticsContext), {
            data: {
                ...$de3aff9237c2ff8d$var$contextData,
                attributes: {
                    screen: props.app || 'unknown'
                }
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
}
const $de3aff9237c2ff8d$export$b46bb3dcfcaed790 = (children, cb)=>{
    const handleOnEvent = (event)=>{
        // Make sure we only listen to click events and fires our event inside the callback function
        event._isUIAnalyticsEvent && event.payload?.action === 'clicked' && cb?.();
    };
    return(// Only listen to events from the ATLASKIT_CHANNEL to narrow down the payloads we receive
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
        channel: (0, $20a0ad68a38595e4$export$3b03fceec8e67395),
        onEvent: handleOnEvent,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jlXoy.ElementEventListener), {
            handler: cb,
            children: children
        })
    }));
};
const $de3aff9237c2ff8d$var$packageMetadata = {
    source: 'topNav',
    componentName: (0, $20a0ad68a38595e4$export$fc44104665f4d1e5),
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $de3aff9237c2ff8d$var$sourceMetadata = {
    navLayer: 'global',
    navContainer: 'top',
    navVersion: '4'
};
const $de3aff9237c2ff8d$var$sideNavMetadata = {
    screen: 'unknown'
};
const $de3aff9237c2ff8d$var$contextData = {
    ...$de3aff9237c2ff8d$var$packageMetadata,
    attributes: {
        ...$de3aff9237c2ff8d$var$sideNavMetadata,
        ...$de3aff9237c2ff8d$var$sourceMetadata
    }
};

});
parcelRegister("jlXoy", function(module, exports) {
$parcel$export(module.exports, "ElementEventListener", () => $411f37d0a560baa7$export$8209b3c2d1620841);
$parcel$export(module.exports, "ElementEventListenerProvider", () => $411f37d0a560baa7$export$306d19af1753a03e);
$parcel$export(module.exports, "useElementEventListenerHandler", () => $411f37d0a560baa7$export$33f666f474b46fc2);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");
const $411f37d0a560baa7$export$8209b3c2d1620841 = ({ handler: handler, children: children })=>{
    const wrapperRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (!wrapperRef.current || !handler) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) handler(true);
        };
        const unbind = (0, $4eDgu.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        handler
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ref: wrapperRef,
        children: children
    });
};
const $411f37d0a560baa7$var$ElementEventListenerContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $411f37d0a560baa7$export$306d19af1753a03e({ children: children, handler: handler }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($411f37d0a560baa7$var$ElementEventListenerContext.Provider, {
        value: handler,
        children: children
    });
}
function $411f37d0a560baa7$export$33f666f474b46fc2() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($411f37d0a560baa7$var$ElementEventListenerContext);
    return context;
}

});

const $20a0ad68a38595e4$export$3f072f06b90c3985 = 'navigation';
const $20a0ad68a38595e4$export$fc44104665f4d1e5 = 'GlobalSideNavigation';
const $20a0ad68a38595e4$export$3b03fceec8e67395 = 'atlaskit';


parcelRegister("4Akzk", function(module, exports) {
$parcel$export(module.exports, "AsyncIntlProvider", () => $b9a268088a1f7504$export$2f688dfcc031530a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3JwXA = parcelRequire("3JwXA");

var $geEuy = parcelRequire("geEuy");

var $1WXE3 = parcelRequire("1WXE3");
const $b9a268088a1f7504$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $1WXE3.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $1WXE3.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $geEuy.default);
    } catch  {
    // ignore
    }
    return 0, $geEuy.default;
};
const $b9a268088a1f7504$export$2f688dfcc031530a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JwXA.default), {
        defaultMessages: (0, $geEuy.default),
        loaderFn: $b9a268088a1f7504$var$fetchMessagesForLocale,
        children: children
    });
};

});
parcelRegister("geEuy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $00d2c93cbe3685ac$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $dMoTg = parcelRequire("dMoTg");
var $00d2c93cbe3685ac$export$2e2bcd8739ae039 = (0, $dMoTg.default);

});
parcelRegister("dMoTg", function(module, exports) {
$parcel$export(module.exports, "default", () => $503cbce8ef28a807$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $503cbce8ef28a807$export$2e2bcd8739ae039 = {
    'navigation-global-side-navigation.object-list-flyout.empty-state.description': "Once you visit, edit, or create projects, issues, boards, filters, and dashboards, they\u2019ll show up here.",
    'navigation-global-side-navigation.object-list-flyout.empty-state.header': 'Nothing to see here!',
    'navigation-global-side-navigation.object-list-flyout.error-state.description': 'Refresh the page and try again.',
    'navigation-global-side-navigation.object-list-flyout.error-state.header': "We couldn't fetch your items",
    'navigation-global-side-navigation.object-list-flyout.loading-state.accessible-name': 'Content is loading',
    'navigation.global-side-navigation.customization-modal.actions-icon-button-label': 'Actions for {menuName} item',
    'navigation.global-side-navigation.customization-modal.app-items-list-description': 'The following Atlassian apps are available for your organization.',
    'navigation.global-side-navigation.customization-modal.app-items-list-label': 'App shortcuts',
    'navigation.global-side-navigation.customization-modal.app-items-list-title': 'App shortcuts',
    'navigation.global-side-navigation.customization-modal.close-button-label': 'Cancel changes to your sidebar',
    'navigation.global-side-navigation.customization-modal.close-button-text': 'Cancel',
    'navigation.global-side-navigation.customization-modal.close-icon-button-label': 'Close and cancel changes to your sidebar',
    'navigation.global-side-navigation.customization-modal.heading-body.heading-body-text': 'Selected items will always be visible in the sidebar. You can still access unselected items from the <b>More</b> menu in the sidebar.',
    'navigation.global-side-navigation.customization-modal.heading-body.heading-body-text-info': 'The changes you make here only affect you and not anyone else on your site.',
    'navigation.global-side-navigation.customization-modal.heading-text': 'Customize your sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-action-label': 'Hide {menuName} from sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-action-text': 'Hide item from sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-checkbox-label': 'Hide {menuName} section in sidebar',
    'navigation.global-side-navigation.customization-modal.move-item-actions-label': 'Move {menuName}',
    'navigation.global-side-navigation.customization-modal.move-item-actions-text': 'Move item within sidebar',
    'navigation.global-side-navigation.customization-modal.move-item-bottom-label': 'Move {menuName} to bottom',
    'navigation.global-side-navigation.customization-modal.move-item-bottom-text': 'Move {menuName} to bottom',
    'navigation.global-side-navigation.customization-modal.move-item-down-label': 'Move {menuName} down',
    'navigation.global-side-navigation.customization-modal.move-item-down-text': 'Move down',
    'navigation.global-side-navigation.customization-modal.move-item-top-label': 'Move {menuName} to top',
    'navigation.global-side-navigation.customization-modal.move-item-top-text': 'Move {menuName} to top',
    'navigation.global-side-navigation.customization-modal.move-item-up-label': 'Move {menuName} up',
    'navigation.global-side-navigation.customization-modal.move-item-up-text': 'Move up',
    'navigation.global-side-navigation.customization-modal.product-items-list-description': 'The following navigation items are available in {app}.',
    'navigation.global-side-navigation.customization-modal.product-items-list-label': 'Customize {app} navigation',
    'navigation.global-side-navigation.customization-modal.product-items-list-title': '{app} navigation',
    'navigation.global-side-navigation.customization-modal.save-button-label': 'Save customization to your sidebar',
    'navigation.global-side-navigation.customization-modal.save-button-text': 'Save changes',
    'navigation.global-side-navigation.customization-modal.show-item-action-label': 'Show {menuName} in sidebar',
    'navigation.global-side-navigation.customization-modal.show-item-action-text': 'Show item in sidebar',
    'navigation.global-side-navigation.customization-modal.show-item-checkbox-label': 'Show {menuName} section in sidebar',
    'navigation.global-side-navigation.customize-sidebar-menu-item.label': 'Customize sidebar',
    'navigation.global-side-navigation.for-you.label': 'For you',
    'navigation.global-side-navigation.more-menu-item.link-external-item-label': 'Open external link icon',
    'navigation.global-side-navigation.more-menu.hide-from-sidebar.label': 'Hide from sidebar',
    'navigation.global-side-navigation.more-menu.label': 'More',
    'navigation.global-side-navigation.object-list-flyout.clearSearchIconLabel': 'Clear search',
    'navigation.global-side-navigation.object-list-flyout.filterIconLabel': 'Filters',
    'navigation.global-side-navigation.object-list-flyout.removeFilterIconLabel': 'Remove',
    'navigation.global-side-navigation.object-list-flyout.searchPlaceholder': 'Search...',
    'navigation.global-side-navigation.object-list-flyout.selectedFilters': 'Selected filters',
    'navigation.global-side-navigation.onboarding-menu.give-feedback': 'Give feedback',
    'navigation.global-side-navigation.onboarding-menu.guided-tour': 'Take a guided tour',
    'navigation.global-side-navigation.onboarding-menu.navigation-docs': 'Read about the new navigation',
    'navigation.global-side-navigation.panel-splitter.label': 'Resize panel',
    'navigation.global-side-navigation.recents.label': 'Recent',
    'navigation.global-side-navigation.recents.viewAllRecentsLabel': 'View all recent items',
    'navigation.global-side-navigation.recentsSearchPlaceholder': 'Search recent items',
    'navigation.global-side-navigation.starred.label': 'Starred',
    'navigation.global-side-navigation.starred.viewAllStarredLabel': 'View all starred items',
    'navigation.global-side-navigation.starredSearchPlaceholder': 'Search starred items',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden': 'The top level menu item {label} has been hidden and moved to the More menu.',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered': 'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.'
};

});


parcelRegister("1WXE3", function(module, exports) {
$parcel$export(module.exports, "asyncLanguages", () => $e3209d9a77489046$export$3770c7a7737d463c);
// https://parceljs.org/features/dependency-resolution/#glob-specifiers





























const $e3209d9a77489046$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("bPaSU")),
    da: ()=>(parcelRequire("kowcp")),
    de: ()=>(parcelRequire("eJh0c")),
    'en-GB': ()=>(parcelRequire("2h7vo")),
    'en-ZZ': ()=>(parcelRequire("6PMT1")),
    en: ()=>Promise.resolve((parcelRequire("geEuy"))),
    es: ()=>(parcelRequire("2gxmE")),
    fi: ()=>(parcelRequire("dw4AM")),
    fr: ()=>(parcelRequire("fgeLA")),
    hr: ()=>(parcelRequire("rKCc0")),
    hu: ()=>(parcelRequire("5xEpM")),
    it: ()=>(parcelRequire("ctGY0")),
    ja: ()=>(parcelRequire("4yEIu")),
    ko: ()=>(parcelRequire("4aij4")),
    nb: ()=>(parcelRequire("gBD33")),
    nl: ()=>(parcelRequire("jFbFZ")),
    pl: ()=>(parcelRequire("6cBjz")),
    'pt-BR': ()=>(parcelRequire("EjGTT")),
    ru: ()=>(parcelRequire("iwvHS")),
    sl: ()=>(parcelRequire("4SQkY")),
    'sr-RS': ()=>(parcelRequire("6bdbj")),
    'sr-YR': ()=>(parcelRequire("632qj")),
    sv: ()=>(parcelRequire("5f0qL")),
    th: ()=>(parcelRequire("9XMEL")),
    tr: ()=>(parcelRequire("it4OV")),
    uk: ()=>(parcelRequire("h4mvu")),
    vi: ()=>(parcelRequire("kuEej")),
    zh_TW: ()=>(parcelRequire("2eM5I")),
    zh: ()=>(parcelRequire("g3Csj"))
};

});
parcelRegister("bPaSU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hbhLQ").then(()=>parcelRequire('5iVev'));

});

parcelRegister("kowcp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gLVYd").then(()=>parcelRequire('4EbGZ'));

});

parcelRegister("eJh0c", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dTqLa").then(()=>parcelRequire('gkJYm'));

});

parcelRegister("2h7vo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6PXox").then(()=>parcelRequire('jYd12'));

});

parcelRegister("6PMT1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f7DAk").then(()=>parcelRequire('21SRQ'));

});

parcelRegister("2gxmE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d1nBm").then(()=>parcelRequire('8JxCM'));

});

parcelRegister("dw4AM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gMPge").then(()=>parcelRequire('bTBlN'));

});

parcelRegister("fgeLA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2MH6Y").then(()=>parcelRequire('hTP98'));

});

parcelRegister("rKCc0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ay3aP").then(()=>parcelRequire('bfUPs'));

});

parcelRegister("5xEpM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2LvhT").then(()=>parcelRequire('5hqNq'));

});

parcelRegister("ctGY0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l0OdA").then(()=>parcelRequire('8Bq7p'));

});

parcelRegister("4yEIu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("w238V").then(()=>parcelRequire('hKfn9'));

});

parcelRegister("4aij4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Kouf").then(()=>parcelRequire('ti4SO'));

});

parcelRegister("gBD33", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("460A8").then(()=>parcelRequire('3W45k'));

});

parcelRegister("jFbFZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Fhyh").then(()=>parcelRequire('kO0ZF'));

});

parcelRegister("6cBjz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8huvz").then(()=>parcelRequire('bWeXP'));

});

parcelRegister("EjGTT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f8Qux").then(()=>parcelRequire('iPZ0w'));

});

parcelRegister("iwvHS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ar4WW").then(()=>parcelRequire('jBLEE'));

});

parcelRegister("4SQkY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8UNSf").then(()=>parcelRequire('dyUMa'));

});

parcelRegister("6bdbj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9bYpA").then(()=>parcelRequire('kfIPw'));

});

parcelRegister("632qj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kjKdP").then(()=>parcelRequire('5u7tc'));

});

parcelRegister("5f0qL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dmhIb").then(()=>parcelRequire('xvmlJ'));

});

parcelRegister("9XMEL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dFTkb").then(()=>parcelRequire('a7oHn'));

});

parcelRegister("it4OV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e48Xd").then(()=>parcelRequire('21r7i'));

});

parcelRegister("h4mvu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fCyiw").then(()=>parcelRequire('gDqOR'));

});

parcelRegister("kuEej", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7y5Lf").then(()=>parcelRequire('5D4WI'));

});

parcelRegister("2eM5I", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fIIu4").then(()=>parcelRequire('dQfKp'));

});

parcelRegister("g3Csj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dg0Fz").then(()=>parcelRequire('jbr93'));

});



parcelRegister("lwkX3", function(module, exports) {
$parcel$export(module.exports, "ItemsAndShortcutsProvider", () => $a08e8dccc8b98152$export$47df1b932a29bc63);
$parcel$export(module.exports, "useItemsAndShortcuts", () => $a08e8dccc8b98152$export$68ff8f5dbbf3b8af);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $igamX = parcelRequire("igamX");

var $8Ltr4 = parcelRequire("8Ltr4");

var $7THIh = parcelRequire("7THIh");

var $lMHB3 = parcelRequire("lMHB3");
const $a08e8dccc8b98152$export$190be01ed07ba845 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $a08e8dccc8b98152$export$47df1b932a29bc63 = ({ children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts })=>{
    const forYouNavItem = (0, $igamX.useForYouNavItem)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : '';
    const recentNavItem = (0, $7THIh.useRecentNavItem)(forYou);
    const starredNavItem = (0, $lMHB3.useStarredNavItem)(forYou);
    const globalItems = (0, $eJOHy.useMemo)(()=>new Map([
            ...forYouNavItem,
            ...recentNavItem,
            ...starredNavItem
        ]), [
        forYouNavItem,
        recentNavItem,
        starredNavItem
    ]);
    const allItems = (0, $eJOHy.useMemo)(()=>({
            ...Object.fromEntries(globalItems),
            ...items
        }), [
        globalItems,
        items
    ]);
    const shortcuts = (0, $8Ltr4.useHydratedShortcuts)(rawShortcuts);
    const itemsAndShortcuts = (0, $eJOHy.useMemo)(()=>({
            allItems: allItems,
            forYouMenuId: forYouMenuId,
            globalItems: globalItems,
            growthItemShortcuts: growthItemShortcuts,
            items: items,
            shortcuts: shortcuts
        }), [
        allItems,
        forYouMenuId,
        globalItems,
        growthItemShortcuts,
        items,
        shortcuts
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($a08e8dccc8b98152$export$190be01ed07ba845.Provider, {
        value: itemsAndShortcuts,
        children: children
    });
};
const $a08e8dccc8b98152$export$68ff8f5dbbf3b8af = ()=>{
    const itemsAndShortcuts = (0, $eJOHy.useContext)($a08e8dccc8b98152$export$190be01ed07ba845);
    (0, $8GOss.default)(itemsAndShortcuts, 'useItemsAndShortcuts must be used inside an initialized ItemsAndShortcutsProvider');
    return itemsAndShortcuts;
};

});
parcelRegister("igamX", function(module, exports) {
$parcel$export(module.exports, "useForYouNavItem", () => $f438498d8ba252f6$export$a2a6512e1bd9d273);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gNUuP = parcelRequire("gNUuP");


var $g7TuR = parcelRequire("g7TuR");
const $f438498d8ba252f6$var$elemBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gNUuP))), {
    label: ""
});
function $f438498d8ba252f6$export$a2a6512e1bd9d273(forYou) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Some type magic so we can get the dependencies right for the memo and keep TypeScript happy.
    const forYouItem = forYou?.forYouItem;
    return (0, $eJOHy.useMemo)(()=>{
        if (!forYouItem) return [];
        else {
            // Business rule: The forYouItem is not reorderable or hideable.
            const common = {
                elemBefore: $f438498d8ba252f6$var$elemBefore,
                isHideable: false,
                isReorderable: false,
                isSelected: forYouItem.isSelected,
                label: formatMessage((0, $g7TuR.messages).label),
                testId: (0, $eb57eb3c4afe979e$export$f47cf802fb7ac2e6)
            };
            const value = forYouItem.url ? {
                type: 'link',
                href: forYouItem.url,
                onClick: forYouItem.onClick,
                ...common
            } : {
                type: 'button',
                onClick: forYouItem.onClick,
                ...common
            };
            return [
                [
                    forYouItem.menuItemId ?? 'global.sidebar.forYou',
                    value
                ]
            ];
        }
    }, [
        forYouItem,
        formatMessage
    ]);
}

});
const $eb57eb3c4afe979e$export$f47cf802fb7ac2e6 = 'gsn-for-you';

parcelRegister("g7TuR", function(module, exports) {
$parcel$export(module.exports, "messages", () => $063c36c2d1833e3c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $063c36c2d1833e3c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.for-you.label',
        description: 'Label on For You button in the side navigation. Typically takes users to an app-specific page showing user content',
        defaultMessage: 'For you'
    }
});

});


parcelRegister("8Ltr4", function(module, exports) {
$parcel$export(module.exports, "useHydratedShortcuts", () => $5032678fb4b6a65f$export$f6a46bddb8e1f8d0);

var $ct6qI = parcelRequire("ct6qI");

var $lmbOW = parcelRequire("lmbOW");
const $5032678fb4b6a65f$export$f6a46bddb8e1f8d0 = (rawShortcuts)=>{
    const { cloudId: cloudId, orgId: orgId, isShortcutsStatic: isShortcutsStatic } = (0, $lmbOW.useOptions)();
    return (0, $ct6qI.useGlobalShortcutsData)({
        shortcutsConfig: rawShortcuts,
        cloudId: cloudId,
        orgId: orgId,
        isShortcutsStatic: isShortcutsStatic
    });
};

});
parcelRegister("ct6qI", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsData", () => $3d7cde703abf0939$export$bc8645ef40313f94);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $iJSFh = parcelRequire("iJSFh");
var $1w126 = parcelRequire("1w126");

var $1RKdF = parcelRequire("1RKdF");
const $3d7cde703abf0939$export$bc8645ef40313f94 = ({ shortcutsConfig: shortcutsConfig, cloudId: cloudId, orgId: orgId, isShortcutsStatic: isShortcutsStatic })=>{
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks } = (0, $1w126.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: isShortcutsStatic
    });
    // fetch the data from the bff if required
    (0, $eJOHy.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(shortcutsConfig) || isShortcutsStatic) return;
        buildURLAndFetchData();
    }, [
        buildURLAndFetchData,
        shortcutsConfig,
        isShortcutsStatic
    ]);
    // associate shortcuts with the returned bff data
    const hydratedAppShortcuts = (0, $eJOHy.useMemo)(()=>{
        if (status === (0, $iJSFh.RequestStatus).COMPLETE && Object.keys(productLinks).length) {
            const entries = Object.entries(shortcutsConfig || {});
            return entries.reduce((acc, [key, value])=>{
                // if config does not need a data reference, just return the value
                if (value.type !== 'link' || !value.apsKey) {
                    acc[key] = value;
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[value.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $1RKdF.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink[0];
                    acc[key] = {
                        ...value,
                        url: filteredProductLink.url
                    };
                    return acc;
                }
                return acc;
            }, {});
        }
        return shortcutsConfig;
    }, [
        productLinks,
        status,
        shortcutsConfig,
        cloudId
    ]);
    return hydratedAppShortcuts;
};

});

parcelRegister("lmbOW", function(module, exports) {
$parcel$export(module.exports, "OptionsProvider", () => $ccb38c995d5f94be$export$1238f6fc6d9e005a);
$parcel$export(module.exports, "useOptions", () => $ccb38c995d5f94be$export$b8ae39f344200a7d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $ccb38c995d5f94be$export$b709306b005c3ef = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $ccb38c995d5f94be$export$1238f6fc6d9e005a({ app: app, appLabel: appLabel, children: children, cloudId: cloudId, customizationStore: customizationStore, disableMenuCustomization: disableMenuCustomization, hasBottomElement: hasBottomElement = false, isShortcutsStatic: isShortcutsStatic, l1DragAndDropEnabled: l1DragAndDropEnabled, networkStorageParams: networkStorageParams, orgId: orgId, userId: userId }) {
    const options = (0, $eJOHy.useMemo)(()=>({
            app: app,
            appLabel: appLabel,
            cloudId: cloudId,
            customizationStore: customizationStore,
            disableMenuCustomization: disableMenuCustomization,
            hasBottomElement: hasBottomElement,
            isShortcutsStatic: isShortcutsStatic,
            l1DragAndDropEnabled: l1DragAndDropEnabled,
            networkStorageParams: networkStorageParams,
            orgId: orgId,
            userId: userId
        }), [
        app,
        appLabel,
        cloudId,
        customizationStore,
        disableMenuCustomization,
        hasBottomElement,
        isShortcutsStatic,
        l1DragAndDropEnabled,
        networkStorageParams,
        orgId,
        userId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ccb38c995d5f94be$export$b709306b005c3ef.Provider, {
        value: options,
        children: children
    });
}
const $ccb38c995d5f94be$export$b8ae39f344200a7d = ()=>{
    const options = (0, $eJOHy.useContext)($ccb38c995d5f94be$export$b709306b005c3ef);
    (0, $8GOss.default)(options, 'useOptions must be used inside an initialized OptionsProvider');
    return options;
};

});


parcelRegister("7THIh", function(module, exports) {
$parcel$export(module.exports, "useRecentNavItem", () => $4acb85bf30cc698e$export$df1ef6bc89e1ae21);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bpdtz = parcelRequire("bpdtz");

var $i5stJ = parcelRequire("i5stJ");

var $iZ1ZH = parcelRequire("iZ1ZH");


var $1R8M5 = parcelRequire("1R8M5");
const $4acb85bf30cc698e$var$elemBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
    label: ""
});
function $4acb85bf30cc698e$export$df1ef6bc89e1ae21(forYou) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const recentConfig = forYou?.recent;
    return (0, $eJOHy.useMemo)(()=>{
        if (!recentConfig) return [];
        else {
            // This is where we map the forYou config to the ObjectListFlyout config.
            const actions = recentConfig.viewAllUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
                        label: ''
                    }),
                    label: formatMessage((0, $1R8M5.messages).viewAllRecentItemsLabel),
                    href: recentConfig.viewAllUrl,
                    onClick: recentConfig.viewAllOnClick
                }
            ] : recentConfig.viewAllOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
                        label: ''
                    }),
                    label: formatMessage((0, $1R8M5.messages).viewAllRecentItemsLabel),
                    onClick: recentConfig.viewAllOnClick
                }
            ];
            // Omit the type-props from FlyoutProps that are not used by ObjectListFlyout
            const safeConfig = (0, $iZ1ZH.omitSafely)(recentConfig, 'menuItemId', 'viewAllOnClick', 'viewAllUrl');
            const value = {
                ...safeConfig,
                actions: actions,
                elemBefore: $4acb85bf30cc698e$var$elemBefore,
                label: formatMessage((0, $1R8M5.messages).label),
                searchPlaceholder: formatMessage((0, $1R8M5.messages).searchPlaceholder),
                testId: (0, $13479f4027aa3118$export$cfead128731b1701),
                type: 'object-list-flyout'
            };
            return [
                [
                    recentConfig.menuItemId ?? 'global.sidebar.recent',
                    value
                ]
            ];
        }
    }, [
        formatMessage,
        recentConfig
    ]);
}

});
parcelRegister("iZ1ZH", function(module, exports) {
$parcel$export(module.exports, "omitSafely", () => $cefa6bf6dd411633$export$d6eadbd047ebd460);

var $jFHCE = parcelRequire("jFHCE");
const $cefa6bf6dd411633$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(item, ...properties);

});

const $13479f4027aa3118$export$cfead128731b1701 = 'gsn-recent';

parcelRegister("1R8M5", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e7690711fd987848$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e7690711fd987848$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.recents.label',
        description: 'Label on Recent button in the side navigation. Shows a flyout with recent items.',
        defaultMessage: 'Recent'
    },
    searchPlaceholder: {
        id: 'navigation.global-side-navigation.recentsSearchPlaceholder',
        description: 'Placeholder for the search input in the recents flyout list.',
        defaultMessage: 'Search recent items'
    },
    viewAllRecentItemsLabel: {
        id: 'navigation.global-side-navigation.recents.viewAllRecentsLabel',
        description: 'Label on View all recent items button in the recents flyout list.',
        defaultMessage: 'View all recent items'
    }
});

});


parcelRegister("lMHB3", function(module, exports) {
$parcel$export(module.exports, "useStarredNavItem", () => $da82d62cc1e2a01e$export$80b87278b6bf3ebc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bpdtz = parcelRequire("bpdtz");

var $aaIe7 = parcelRequire("aaIe7");

var $iZ1ZH = parcelRequire("iZ1ZH");


var $f4cOi = parcelRequire("f4cOi");
const $da82d62cc1e2a01e$var$elemBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
    label: ""
});
function $da82d62cc1e2a01e$export$80b87278b6bf3ebc(forYou) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const starredConfig = forYou?.starred;
    return (0, $eJOHy.useMemo)(()=>{
        if (!starredConfig) return [];
        else {
            const actions = starredConfig.viewAllUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
                        label: ''
                    }),
                    label: formatMessage((0, $f4cOi.messages).viewAllStarredItemsLabel),
                    href: starredConfig.viewAllUrl,
                    onClick: starredConfig.viewAllOnClick
                }
            ] : starredConfig.viewAllOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
                        label: ''
                    }),
                    label: formatMessage((0, $f4cOi.messages).viewAllStarredItemsLabel),
                    onClick: starredConfig.viewAllOnClick
                }
            ];
            // Omit the type-props from FlyoutProps that are not used by ObjectListFlyout
            const safeConfig = (0, $iZ1ZH.omitSafely)(starredConfig, 'menuItemId', 'viewAllOnClick', 'viewAllUrl');
            const value = {
                ...safeConfig,
                actions: actions,
                elemBefore: $da82d62cc1e2a01e$var$elemBefore,
                label: formatMessage((0, $f4cOi.messages).label),
                searchPlaceholder: formatMessage((0, $f4cOi.messages).searchPlaceholder),
                testId: (0, $46016f4e40100196$export$d8547b5f8547ae9a),
                type: 'object-list-flyout'
            };
            return [
                [
                    starredConfig.menuItemId ?? 'global.sidebar.starred',
                    value
                ]
            ];
        }
    }, [
        formatMessage,
        starredConfig
    ]);
}

});
const $46016f4e40100196$export$d8547b5f8547ae9a = 'gsn-starred';

parcelRegister("f4cOi", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3b7ed55273da11ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3b7ed55273da11ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.starred.label',
        description: 'Label on Starred button in the side navigation. Shows a flyout with starred items.',
        defaultMessage: 'Starred'
    },
    searchPlaceholder: {
        id: 'navigation.global-side-navigation.starredSearchPlaceholder',
        description: 'Placeholder for the search input in the starred flyout list.',
        defaultMessage: 'Search starred items'
    },
    viewAllStarredItemsLabel: {
        id: 'navigation.global-side-navigation.starred.viewAllStarredLabel',
        description: 'Label on View all starred items button in the starred flyout list.',
        defaultMessage: 'View all starred items'
    }
});

});



parcelRegister("8xJnH", function(module, exports) {
$parcel$export(module.exports, "usePeekMenuId", () => $10b52853dcb9edc1$export$5d097184c0f78e68);
$parcel$export(module.exports, "useSetPeekMenuId", () => $10b52853dcb9edc1$export$a90578dce3c14324);
$parcel$export(module.exports, "PeekMenuIdProviders", () => $10b52853dcb9edc1$export$781f6b5709acd16f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $10b52853dcb9edc1$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $10b52853dcb9edc1$export$4146a0b5f40d20d7 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
const $10b52853dcb9edc1$export$5d097184c0f78e68 = ()=>(0, $eJOHy.useContext)($10b52853dcb9edc1$export$390c771b9e3f4124);
const $10b52853dcb9edc1$export$a90578dce3c14324 = ()=>(0, $eJOHy.useContext)($10b52853dcb9edc1$export$4146a0b5f40d20d7);
const $10b52853dcb9edc1$export$781f6b5709acd16f = ({ children: children, value: value })=>{
    // There are two ways for `peekMenuId` to change.
    // One is if the `peekMenuId` prop (i.e. `value`) changes, likely due to a route change.
    // The other is internally via `setPeekMenuId`, e.g. the more menu.
    // Each will override the other, the last one to change/call will be the current state.
    const [peekMenuId, setPeekMenuId] = (0, $eJOHy.useState)(value);
    // If the `peekMenuId` prop (i.e. `value`) changes, set state before render.
    // Note, we don't need to validate `peekMenuId`.
    // If `peekMenuId` doesn't match an existing menu id, it's equivalent to setting undefined.
    (0, $eJOHy.useLayoutEffect)(()=>{
        setPeekMenuId(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($10b52853dcb9edc1$export$390c771b9e3f4124.Provider, {
        value: peekMenuId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($10b52853dcb9edc1$export$4146a0b5f40d20d7.Provider, {
            value: setPeekMenuId,
            children: children
        })
    });
};

});

parcelRegister("i84Wd", function(module, exports) {
$parcel$export(module.exports, "LocalStore", () => $43bfddb57f66508f$export$9adaf932dcd02b00);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lmbOW = parcelRequire("lmbOW");

var $aQvjm = parcelRequire("aQvjm");

var $if1Y8 = parcelRequire("if1Y8");
function $43bfddb57f66508f$export$9adaf932dcd02b00({ children: children }) {
    const { app: app } = (0, $lmbOW.useOptions)();
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $aQvjm.useLocalSideNavUserData)({
        app: app
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $if1Y8.StoreProviders), {
        ...userStoreProps,
        children: children
    });
}

});
parcelRegister("aQvjm", function(module, exports) {
$parcel$export(module.exports, "useLocalSideNavUserData", () => $b62088e6adc5959e$export$4714a0d7e8941053);

var $eJOHy = parcelRequire("eJOHy");

const $b62088e6adc5959e$var$nullState = {
    userSideNavData: {
        defaultWidth: undefined,
        defaultCollapsed: undefined
    },
    userMenuData: []
};
// Allow the key to be extended (by adding a prefix or suffix)
let $b62088e6adc5959e$var$LS_KEY = (0, $84ce2d06f92666cd$export$42cf6fc952b8bebd);
function $b62088e6adc5959e$export$4714a0d7e8941053({ app: app }) {
    $b62088e6adc5959e$var$setLocalStorageKey(app);
    const [sideNavState, setSideNavState] = (0, $eJOHy.useReducer)($b62088e6adc5959e$var$reducer, $b62088e6adc5959e$var$getInitialState());
    const setUserMenuData = (0, $eJOHy.useCallback)((userMenuData)=>{
        setSideNavState({
            userMenuData: userMenuData
        });
    }, []);
    const setUserSideNavData = (0, $eJOHy.useCallback)((userSideNavData)=>{
        setSideNavState({
            userSideNavData: {
                ...sideNavState.userSideNavData,
                ...userSideNavData
            }
        });
    }, [
        sideNavState
    ]);
    return {
        ...sideNavState,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
}
function $b62088e6adc5959e$var$setLocalStorageKey(suffix) {
    $b62088e6adc5959e$var$LS_KEY = [
        (0, $84ce2d06f92666cd$export$42cf6fc952b8bebd),
        suffix
    ].join('-');
}
function $b62088e6adc5959e$var$getInitialState() {
    const storedState = $b62088e6adc5959e$var$parseLocalStorageState(localStorage.getItem($b62088e6adc5959e$var$LS_KEY));
    if (storedState) return storedState;
    $b62088e6adc5959e$var$setLocalStorageState($b62088e6adc5959e$var$nullState);
    return $b62088e6adc5959e$var$nullState;
}
function $b62088e6adc5959e$var$reducer(state, payload) {
    const newState = {
        ...state,
        ...payload
    };
    // Update localStorage with the new state
    $b62088e6adc5959e$var$setLocalStorageState(newState);
    return newState;
}
function $b62088e6adc5959e$var$setLocalStorageState(state) {
    localStorage.setItem($b62088e6adc5959e$var$LS_KEY, JSON.stringify(state));
}
function $b62088e6adc5959e$var$parseLocalStorageState(state) {
    if (!state) return;
    try {
        const parsedState = JSON.parse(state);
        // This check should return true for the nullState
        if (parsedState?.userSideNavData && Array.isArray(parsedState.userMenuData) && typeof parsedState.userSideNavData === 'object') return parsedState;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    // something went wrong with parsing, return undefined
    }
}

});
const $84ce2d06f92666cd$export$42cf6fc952b8bebd = 'nav-platform-sidebar-state';
const $84ce2d06f92666cd$export$f1259eef323ff984 = 'defaultCollapsed';
const $84ce2d06f92666cd$export$5ec229a880d48b06 = 'defaultWidth';


parcelRegister("if1Y8", function(module, exports) {
$parcel$export(module.exports, "StoreProviders", () => $5c6bb24bd515d9a2$export$54ef25ae025e12ab);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7Rbog = parcelRequire("7Rbog");

var $2jGY5 = parcelRequire("2jGY5");
function $5c6bb24bd515d9a2$export$54ef25ae025e12ab(props) {
    const { children: children, userMenuData: userMenuData, userSideNavData: userSideNavData, setUserMenuData: setUserMenuData, setUserSideNavData: setUserSideNavData } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Rbog.UserMenuDataShapesProvider), {
        rawUserMenuData: userMenuData,
        setUserMenuData: setUserMenuData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2jGY5.UserSideNavDataStoreProvider), {
            setUserSideNavData: setUserSideNavData,
            userSideNavData: userSideNavData,
            children: children
        })
    });
}

});
parcelRegister("7Rbog", function(module, exports) {
$parcel$export(module.exports, "UserMenuDataShapesProvider", () => $e6ca8e6617eeec04$export$5063e15f61416e3b);
$parcel$export(module.exports, "useUserMenuDataShapes", () => $e6ca8e6617eeec04$export$f340ebbec0629d31);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $kioCn = parcelRequire("kioCn");

var $1gfN2 = parcelRequire("1gfN2");

var $7YEow = parcelRequire("7YEow");

var $lwkX3 = parcelRequire("lwkX3");

var $lmbOW = parcelRequire("lmbOW");
const $e6ca8e6617eeec04$export$91fb8643e8c59f90 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $e6ca8e6617eeec04$export$5063e15f61416e3b = (0, $kioCn.componentWithFG)('navx-1527-fix-foryou-position', $e6ca8e6617eeec04$var$UserMenuDataShapesProviderNEW, $e6ca8e6617eeec04$var$UserMenuDataShapesProviderOLD);
/**
 * Stores the repaired user menu data, in a variety of shapes, and makes it available to child components.
 * This component exists so that it is easy for child components to read and update the user menu data independently of the user side nav data.
 */ function $e6ca8e6617eeec04$var$UserMenuDataShapesProviderNEW({ children: children, rawUserMenuData: rawUserMenuData, setUserMenuData: setUserMenuData }) {
    const { disableMenuCustomization: disableMenuCustomization } = (0, $lmbOW.useOptions)();
    const { allItems: allItems, forYouMenuId: forYouMenuId, globalItems: globalItems, shortcuts: shortcuts } = (0, $lwkX3.useItemsAndShortcuts)();
    const userMenuDataShapes = (0, $eJOHy.useMemo)(()=>(0, $1gfN2.buildUserMenuDataShapes)({
            allItemMenuIds: Object.keys(allItems),
            allShortcutMenuIds: Object.keys(shortcuts ?? {}),
            forYouMenuId: forYouMenuId,
            globalItems: globalItems,
            // All menu items are visible when there is no user menu data
            rawUserMenuData: disableMenuCustomization ? [] : rawUserMenuData,
            setUserMenuData: setUserMenuData
        }), [
        allItems,
        disableMenuCustomization,
        forYouMenuId,
        globalItems,
        rawUserMenuData,
        setUserMenuData,
        shortcuts
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e6ca8e6617eeec04$export$91fb8643e8c59f90.Provider, {
        value: userMenuDataShapes,
        children: children
    });
}
/**
 * Stores the repaired user menu data, in a variety of shapes, and makes it available to child components.
 * This component exists so that it is easy for child components to read and update the user menu data independently of the user side nav data.
 */ function $e6ca8e6617eeec04$var$UserMenuDataShapesProviderOLD({ children: children, rawUserMenuData: rawUserMenuData, setUserMenuData: setUserMenuData }) {
    const { disableMenuCustomization: disableMenuCustomization } = (0, $lmbOW.useOptions)();
    const { allItems: allItems, shortcuts: shortcuts } = (0, $lwkX3.useItemsAndShortcuts)();
    const userMenuDataShapes = (0, $eJOHy.useMemo)(()=>(0, $7YEow.buildUserMenuDataShapes)(Object.keys(allItems), Object.keys(shortcuts ?? {}), // All menu items are visible when there is no user menu data
        disableMenuCustomization ? [] : rawUserMenuData, setUserMenuData), [
        allItems,
        disableMenuCustomization,
        rawUserMenuData,
        setUserMenuData,
        shortcuts
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e6ca8e6617eeec04$export$91fb8643e8c59f90.Provider, {
        value: userMenuDataShapes,
        children: children
    });
}
function $e6ca8e6617eeec04$export$f340ebbec0629d31() {
    const context = (0, $eJOHy.useContext)($e6ca8e6617eeec04$export$91fb8643e8c59f90);
    (0, $8GOss.default)(context, 'useUserMenuDataShapes must be used inside an initialized UserMenuDataShapesProvider');
    return context;
}

});
parcelRegister("kioCn", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $ba8f17f638620588$export$cf56d0f54cfcce4);

var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");
const $ba8f17f638620588$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $AIyOt.componentWithCondition)(()=>(0, $eGOwo.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});
parcelRegister("AIyOt", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $12a0a78415ce5192$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $12a0a78415ce5192$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("1gfN2", function(module, exports) {
$parcel$export(module.exports, "buildUserMenuDataShapes", () => $1436d93378d604cd$export$e98db1320ac4ff55);

var $2zs80 = parcelRequire("2zs80");

var $jfClx = parcelRequire("jfClx");

var $k0MOC = parcelRequire("k0MOC");

var $dwGMw = parcelRequire("dwGMw");
function $1436d93378d604cd$export$e98db1320ac4ff55(params) {
    const { allItemMenuIds: allItemMenuIds, allShortcutMenuIds: allShortcutMenuIds, forYouMenuId: forYouMenuId, globalItems: globalItems, rawUserMenuData: rawUserMenuData, setUserMenuData: setUserMenuData } = params;
    // Remove any menu ids that overlap with shortcuts
    const distinctDefaultItemMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(allItemMenuIds, allShortcutMenuIds);
    const repairedUserMenuData = (0, $k0MOC.repairGlobalMenuItems)({
        forYouMenuId: forYouMenuId,
        globalItems: globalItems,
        rawUserMenuData: rawUserMenuData
    });
    // Add missing items and remove obsolete or duplicate items
    const itemUserMenuData = $1436d93378d604cd$var$repair(repairedUserMenuData, distinctDefaultItemMenuIds);
    // Add missing shortcuts and remove obsolete or duplicate shortcuts
    const shortcutUserMenuData = $1436d93378d604cd$var$repair(repairedUserMenuData, allShortcutMenuIds);
    // This repaired user menu data should always be used instead of the raw user menu data
    const userMenuData = itemUserMenuData.concat(shortcutUserMenuData);
    const [visibleItemMenuIds, hiddenItemMenuIds] = (0, $jfClx.getMenuIdsByVisible)(itemUserMenuData);
    const [visibleShortcutMenuIds, hiddenShortcutMenuIds] = (0, $jfClx.getMenuIdsByVisible)(shortcutUserMenuData);
    const visibleMenuIds = visibleItemMenuIds.concat(visibleShortcutMenuIds);
    const hiddenMenuIds = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
    return {
        hiddenItemMenuIds: hiddenItemMenuIds,
        hiddenMenuIds: hiddenMenuIds,
        hiddenShortcutMenuIds: hiddenShortcutMenuIds,
        itemUserMenuData: itemUserMenuData,
        shortcutUserMenuData: shortcutUserMenuData,
        setUserMenuData: setUserMenuData,
        userMenuData: userMenuData,
        visibleItemMenuIds: visibleItemMenuIds,
        visibleMenuIds: visibleMenuIds,
        visibleShortcutMenuIds: visibleShortcutMenuIds
    };
}
const $1436d93378d604cd$var$repair = (rawUserMenuData, defaultMenuIds)=>(0, $dwGMw.repairItems)(rawUserMenuData ?? [], $1436d93378d604cd$var$createDefaultItems(defaultMenuIds));
const $1436d93378d604cd$var$createDefaultItems = (menuIds)=>menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));

});
parcelRegister("jfClx", function(module, exports) {
$parcel$export(module.exports, "getMenuIdsByVisible", () => $8c385de9dcbb788f$export$ac81be4e21f7c439);

var $e7q0A = parcelRequire("e7q0A");

var $jRr0s = parcelRequire("jRr0s");
const $8c385de9dcbb788f$export$ac81be4e21f7c439 = (items)=>(0, $jRr0s.partitionByVisible)(items).map((0, $e7q0A.getMenuIds));

});
parcelRegister("e7q0A", function(module, exports) {
$parcel$export(module.exports, "getMenuIds", () => $c65172e2e902a69e$export$df4a614c56950314);
const $c65172e2e902a69e$export$df4a614c56950314 = (items)=>items.map((item)=>item.menuId);

});

parcelRegister("jRr0s", function(module, exports) {
$parcel$export(module.exports, "partitionByVisible", () => $0a2ed2e14c9c2161$export$98e5c4110cac6c24);

var $a6gy0 = parcelRequire("a6gy0");
const $0a2ed2e14c9c2161$export$98e5c4110cac6c24 = (items)=>(0, (/*@__PURE__*/$parcel$interopDefault($a6gy0)))(items, (item)=>item.visible);

});


parcelRegister("k0MOC", function(module, exports) {
$parcel$export(module.exports, "repairGlobalMenuItems", () => $47294bfd2099bc7f$export$a5bdc0a85c6880c5);

var $2zs80 = parcelRequire("2zs80");
function $47294bfd2099bc7f$export$a5bdc0a85c6880c5(params) {
    const { forYouMenuId: forYouMenuId, globalItems: globalItems, rawUserMenuData: rawUserMenuData } = params;
    // Sort the globalMenuIds so that the forYouItem is at the start, if it exists.
    const globalMenuIds = Array.from(globalItems.keys()).sort((a, b)=>Number(b === forYouMenuId) - Number(a === forYouMenuId));
    const rawUserMenuDataArrMaybeWithForYou = rawUserMenuData ?? [];
    // If the userdata contains the forYou item, remove it so that it can be re-added into first position.
    const rawUserMenuDataArr = forYouMenuId ? rawUserMenuDataArrMaybeWithForYou.filter((i)=>i.menuId !== forYouMenuId) : rawUserMenuDataArrMaybeWithForYou;
    // Add the globalMenuIds to the user data, if they're not already there.
    const globalItemsNotInUserData = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(globalMenuIds, rawUserMenuDataArr.map((i)=>i.menuId));
    return $47294bfd2099bc7f$var$createDefaultItems(globalItemsNotInUserData).concat(rawUserMenuDataArr);
}
const $47294bfd2099bc7f$var$createDefaultItems = (menuIds)=>menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));

});

parcelRegister("dwGMw", function(module, exports) {
$parcel$export(module.exports, "repairItems", () => $0111f02f890cbc43$export$ce0466efa278e488);

var $4q8Hz = parcelRequire("4q8Hz");
const $0111f02f890cbc43$export$ce0466efa278e488 = (items, defaultItems)=>(0, (/*@__PURE__*/$parcel$interopDefault($4q8Hz)))(items.concat(defaultItems), defaultItems, (item)=>item.menuId);

});
parcelRegister("4q8Hz", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $lk1pL = parcelRequire("lk1pL");

var $1lM9j = parcelRequire("1lM9j");

var $l76qh = parcelRequire("l76qh");

var $9gcs2 = parcelRequire("9gcs2");

var $1ilzu = parcelRequire("1ilzu");
/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */ var $33805722d8bf59dd$var$intersectionBy = $l76qh(function(arrays) {
    var iteratee = $1ilzu(arrays), mapped = $lylkU(arrays, $9gcs2);
    if (iteratee === $1ilzu(mapped)) iteratee = undefined;
    else mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $lk1pL(mapped, $1lM9j(iteratee, 2)) : [];
});
module.exports = $33805722d8bf59dd$var$intersectionBy;

});
parcelRegister("lk1pL", function(module, exports) {

var $4hmxn = parcelRequire("4hmxn");

var $40QQB = parcelRequire("40QQB");

var $e2REr = parcelRequire("e2REr");

var $lylkU = parcelRequire("lylkU");

var $cUaWv = parcelRequire("cUaWv");

var $fAWNe = parcelRequire("fAWNe");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f85c901f5c390ec4$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $f85c901f5c390ec4$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $e2REr : $40QQB, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $lylkU(array, $cUaWv(iteratee));
        maxLength = $f85c901f5c390ec4$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $4hmxn(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $fAWNe(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $fAWNe(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $f85c901f5c390ec4$var$baseIntersection;

});

parcelRegister("9gcs2", function(module, exports) {

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $6bdf44410d0452f9$var$castArrayLikeObject(value) {
    return $d1ShJ(value) ? value : [];
}
module.exports = $6bdf44410d0452f9$var$castArrayLikeObject;

});




parcelRegister("7YEow", function(module, exports) {
$parcel$export(module.exports, "buildUserMenuDataShapes", () => $901dcac8df0b783f$export$e98db1320ac4ff55);

var $2zs80 = parcelRequire("2zs80");

var $jfClx = parcelRequire("jfClx");

var $dwGMw = parcelRequire("dwGMw");
const $901dcac8df0b783f$export$e98db1320ac4ff55 = (defaultItemMenuIds, defaultShortcutMenuIds, rawUserMenuData, setUserMenuData)=>{
    // Remove any menu ids that overlap with shortcuts
    const distinctDefaultItemMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(defaultItemMenuIds, defaultShortcutMenuIds);
    // Add missing items and remove obsolete or duplicate items
    const itemUserMenuData = $901dcac8df0b783f$var$repair(rawUserMenuData, distinctDefaultItemMenuIds);
    // Add missing shortcuts and remove obsolete or duplicate shortcuts
    const shortcutUserMenuData = $901dcac8df0b783f$var$repair(rawUserMenuData, defaultShortcutMenuIds);
    // This repaired user menu data should always be used instead of the raw user menu data
    const userMenuData = itemUserMenuData.concat(shortcutUserMenuData);
    const [visibleItemMenuIds, hiddenItemMenuIds] = (0, $jfClx.getMenuIdsByVisible)(itemUserMenuData);
    const [visibleShortcutMenuIds, hiddenShortcutMenuIds] = (0, $jfClx.getMenuIdsByVisible)(shortcutUserMenuData);
    const visibleMenuIds = visibleItemMenuIds.concat(visibleShortcutMenuIds);
    const hiddenMenuIds = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
    return {
        hiddenItemMenuIds: hiddenItemMenuIds,
        hiddenMenuIds: hiddenMenuIds,
        hiddenShortcutMenuIds: hiddenShortcutMenuIds,
        itemUserMenuData: itemUserMenuData,
        shortcutUserMenuData: shortcutUserMenuData,
        setUserMenuData: setUserMenuData,
        userMenuData: userMenuData,
        visibleItemMenuIds: visibleItemMenuIds,
        visibleMenuIds: visibleMenuIds,
        visibleShortcutMenuIds: visibleShortcutMenuIds
    };
};
const $901dcac8df0b783f$var$repair = (rawUserMenuData, defaultMenuIds)=>(0, $dwGMw.repairItems)(rawUserMenuData ?? [], $901dcac8df0b783f$var$createDefaultItems(defaultMenuIds));
const $901dcac8df0b783f$var$createDefaultItems = (menuIds)=>menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));

});


parcelRegister("2jGY5", function(module, exports) {
$parcel$export(module.exports, "UserSideNavDataStoreProvider", () => $a055832502f541b9$export$81208cef03561ef9);
$parcel$export(module.exports, "useUserSideNavDataStore", () => $a055832502f541b9$export$af1627270f7f3b2c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $a055832502f541b9$export$b892481aefb34336 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $a055832502f541b9$export$81208cef03561ef9({ children: children, setUserSideNavData: setUserSideNavData, userSideNavData: userSideNavData }) {
    const userSideNavDataStore = (0, $eJOHy.useMemo)(()=>({
            setUserSideNavData: setUserSideNavData,
            userSideNavData: userSideNavData
        }), [
        setUserSideNavData,
        userSideNavData
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($a055832502f541b9$export$b892481aefb34336.Provider, {
        value: userSideNavDataStore,
        children: children
    });
}
function $a055832502f541b9$export$af1627270f7f3b2c() {
    const context = (0, $eJOHy.useContext)($a055832502f541b9$export$b892481aefb34336);
    (0, $8GOss.default)(context, 'useUserSideNavDataStore must be used inside a UserSideNavDataStoreProvider');
    return context;
}

});



parcelRegister("8wdqp", function(module, exports) {
$parcel$export(module.exports, "NetworkMigrationStore", () => $1806916e7ae564bd$export$c723d37fdda6e941);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $lmbOW = parcelRequire("lmbOW");

var $12gMI = parcelRequire("12gMI");

var $if1Y8 = parcelRequire("if1Y8");
function $1806916e7ae564bd$export$c723d37fdda6e941({ children: children }) {
    const { networkStorageParams: networkStorageParams, app: app } = (0, $lmbOW.useOptions)();
    (0, $8GOss.default)(networkStorageParams?.activationId && networkStorageParams?.entityAri && networkStorageParams?.siteId && networkStorageParams?.ownerAri && networkStorageParams?.queryRef, 'Please provide networkStorageParams when using customization');
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $12gMI.useNetworkMigrationSideNavUserData)({
        ...networkStorageParams,
        firstPartyApp: app
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $if1Y8.StoreProviders), {
        ...userStoreProps,
        children: children
    });
}

});
parcelRegister("12gMI", function(module, exports) {
$parcel$export(module.exports, "useNetworkSideNavUserData", () => $b6e6cb7fe4247f4c$export$caed0b91aaed2955);
$parcel$export(module.exports, "useNetworkMigrationSideNavUserData", () => $b6e6cb7fe4247f4c$export$156415ede1cb8a79);

var $5UIfk = parcelRequire("5UIfk");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");


var $5j3lw = parcelRequire("5j3lw");

var $lJLMK = parcelRequire("lJLMK");
function $b6e6cb7fe4247f4c$export$caed0b91aaed2955(params) {
    const { firstPartyApp: firstPartyApp, activationId: activationId = '', ownerAri: ownerAri, queryRef: queryRef, siteId: siteId = '' } = params;
    const { queryData: menuQueryData, setNavData: setMenuNavData } = (0, $lJLMK.useNavSettingsService)({
        mutationEntityAri: (0, $5j3lw.buildNavigationAriForMenuData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatL1MenuData
    });
    const { queryData: sidebarQueryData, setNavData: setSidebarNavData } = (0, $lJLMK.useNavSettingsService)({
        mutationEntityAri: (0, $5j3lw.buildNavigationAriForSidebarData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatSidebarData
    });
    // We store the state of the properties & customizationItems, as the sidebar state can change without any
    // new calls to the local queryRef (to read the value back). So we persist it in this component.
    const [sideNavProperties, setSideNavProperties] = (0, $eJOHy.useState)({
        defaultWidth: (sidebarQueryData?.properties?.nodes ?? [
            {
                key: (0, $84ce2d06f92666cd$export$5ec229a880d48b06),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $84ce2d06f92666cd$export$5ec229a880d48b06))?.value ?? '',
        defaultCollapsed: (sidebarQueryData?.properties?.nodes ?? [
            {
                key: (0, $84ce2d06f92666cd$export$f1259eef323ff984),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $84ce2d06f92666cd$export$f1259eef323ff984))?.value ?? ''
    });
    const [customizationItems, setCustomizationItems] = (0, $eJOHy.useState)($b6e6cb7fe4247f4c$var$repairCustomizationItems(menuQueryData?.sidebar?.nodes || []));
    // Create two callback functions - one for each user data-prop.
    // Not sure how performant this is, but it simplifies updates (because the caller doesn't need to know about the other half of the data)
    const setUserMenuData = (0, $eJOHy.useCallback)((rawSidebarData)=>{
        setCustomizationItems(rawSidebarData);
        setSidebarNavData({
            sidebar: $b6e6cb7fe4247f4c$var$sanitizeUserMenuData(rawSidebarData)
        });
    }, [
        setSidebarNavData
    ]);
    const setUserSideNavData = (0, $eJOHy.useCallback)((userSideNavData)=>{
        const newState = {
            defaultWidth: String(userSideNavData.defaultWidth ?? sideNavProperties.defaultWidth) || '',
            defaultCollapsed: String(userSideNavData.defaultCollapsed ?? sideNavProperties.defaultCollapsed) || 'false'
        };
        setSideNavProperties(newState);
        const properties = [
            {
                key: (0, $84ce2d06f92666cd$export$5ec229a880d48b06),
                value: newState.defaultWidth
            },
            {
                key: (0, $84ce2d06f92666cd$export$f1259eef323ff984),
                value: newState.defaultCollapsed
            }
        ];
        setMenuNavData({
            properties: properties
        });
    }, [
        setMenuNavData,
        sideNavProperties.defaultCollapsed,
        sideNavProperties.defaultWidth
    ]);
    // Create a nicer shape for the data.
    // For the userSideNavData, it is ok for the values to be undefined,
    // as the ADS component will know what to do.
    const niceUserData = {
        userMenuData: customizationItems,
        userSideNavData: {
            defaultWidth: sideNavProperties.defaultWidth === '' ? undefined : Number(sideNavProperties.defaultWidth),
            defaultCollapsed: sideNavProperties.defaultCollapsed === '' ? undefined : sideNavProperties.defaultCollapsed === 'true'
        }
    };
    return {
        ...niceUserData,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
}
function $b6e6cb7fe4247f4c$export$156415ede1cb8a79(params) {
    const { firstPartyApp: firstPartyApp, activationId: activationId = '', ownerAri: ownerAri, queryRef: queryRef, siteId: siteId = '' } = params;
    const queryDataOLD = $b6e6cb7fe4247f4c$var$useLocalFragmentToGetOldEntityAri(queryRef); // Read from the existing entityAri record
    const { queryData: l1menuQueryData, setNavData: setL1MenuData } = (0, $lJLMK.useNavSettingsService)({
        mutationEntityAri: (0, $5j3lw.buildNavigationAriForMenuData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatL1MenuData
    });
    const { queryData: sidebarSizeQueryData, setNavData: setSidebarSizeData } = (0, $lJLMK.useNavSettingsService)({
        mutationEntityAri: (0, $5j3lw.buildNavigationAriForSidebarData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatSidebarData
    });
    // We store the state of the properties & customizationItems, as the sidebar state can change without any
    // new calls to the local queryRef (to read the value back). So we persist it in this component.
    const [sideNavProperties, setSideNavProperties] = (0, $eJOHy.useState)({
        defaultWidth: ((sidebarSizeQueryData?.properties?.nodes || queryDataOLD?.userSideNavSettings?.properties?.nodes) ?? [
            {
                key: (0, $84ce2d06f92666cd$export$5ec229a880d48b06),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $84ce2d06f92666cd$export$5ec229a880d48b06))?.value ?? '',
        defaultCollapsed: ((sidebarSizeQueryData?.properties?.nodes || queryDataOLD?.userSideNavSettings?.properties?.nodes) ?? [
            {
                key: (0, $84ce2d06f92666cd$export$f1259eef323ff984),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $84ce2d06f92666cd$export$f1259eef323ff984))?.value ?? ''
    });
    const [sideNavMenuData, setSideNavMenuData] = (0, $eJOHy.useState)($b6e6cb7fe4247f4c$var$repairCustomizationItems(l1menuQueryData?.sidebar?.nodes || queryDataOLD?.userSideNavSettings?.sidebar?.nodes || []));
    // Create two callback functions - one for each user data-prop.
    const setUserMenuData = (0, $eJOHy.useCallback)((rawSidebarData)=>{
        setSideNavMenuData(rawSidebarData);
        setL1MenuData({
            properties: [],
            sidebar: $b6e6cb7fe4247f4c$var$sanitizeUserMenuData(rawSidebarData)
        });
    }, [
        setL1MenuData
    ]);
    const setUserSideNavData = (0, $eJOHy.useCallback)((userSideNavData)=>{
        const newState = {
            defaultWidth: String(userSideNavData.defaultWidth ?? sideNavProperties.defaultWidth) || '',
            defaultCollapsed: String(userSideNavData.defaultCollapsed ?? sideNavProperties.defaultCollapsed) || 'false'
        };
        setSideNavProperties(newState);
        const properties = [
            {
                key: (0, $84ce2d06f92666cd$export$5ec229a880d48b06),
                value: newState.defaultWidth
            },
            {
                key: (0, $84ce2d06f92666cd$export$f1259eef323ff984),
                value: newState.defaultCollapsed
            }
        ];
        setSidebarSizeData({
            properties: properties,
            sidebar: []
        });
    }, [
        setSidebarSizeData,
        sideNavProperties.defaultCollapsed,
        sideNavProperties.defaultWidth
    ]);
    // Migration behaviour runs ONCE in the next render.
    // If there is data in the old record but no data in the new record, fix this up immediately.
    (0, $eJOHy.useEffect)(()=>{
        if (sideNavMenuData.length > 0 && (l1menuQueryData?.sidebar?.nodes || []).length === 0) setUserMenuData(sideNavMenuData);
        if ((queryDataOLD?.userSideNavSettings?.properties?.nodes || []).length > 0 && (sidebarSizeQueryData?.properties?.nodes || []).length === 0) setUserSideNavData($b6e6cb7fe4247f4c$var$toUserSideNavData(sideNavProperties));
    // We only want to run this once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Create a nicer shape for the data.
    // For the userSideNavData, it is ok for the values to be undefined,
    // as the ADS component will know what to do.
    const niceUserData = {
        userMenuData: sideNavMenuData,
        userSideNavData: $b6e6cb7fe4247f4c$var$toUserSideNavData(sideNavProperties)
    };
    return {
        ...niceUserData,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
}
/**
 * Make the Relay data look "normal" to the outside world.
 */ function $b6e6cb7fe4247f4c$var$repairCustomizationItems(value) {
    return value;
}
function $b6e6cb7fe4247f4c$var$toUserSideNavData(sideNavProperties) {
    return {
        defaultWidth: sideNavProperties.defaultWidth === '' ? undefined : Number(sideNavProperties.defaultWidth),
        defaultCollapsed: sideNavProperties.defaultCollapsed === '' ? undefined : sideNavProperties.defaultCollapsed === 'true'
    };
}
function $b6e6cb7fe4247f4c$var$useLocalFragmentToGetOldEntityAri(queryRef) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks */ /* eslint-disable @atlassian/relay/unused-fields */ /* eslint-disable @atlassian/relay/graphql-naming */ return (0, $j4oe4.useFragment)((0, $5UIfk.default), queryRef);
/* eslint-enable @atlassian/relay/unused-fields */ }
/**
 * Creates a new UserMenuData (array) that is supported by the Settings Service.
 */ function $b6e6cb7fe4247f4c$var$sanitizeUserMenuData(data) {
    return data.map((item)=>({
            menuId: item.menuId,
            visible: item.visible
        }));
}

});
parcelRegister("5UIfk", function(module, exports) {
$parcel$export(module.exports, "default", () => $08619473c73b1604$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cea65a1be7471930ba24878928a0bb2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $08619473c73b1604$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "entityAriUserSideNavSettings"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "useNetworkSideNavUserData",
    "selections": [
        {
            "alias": "userSideNavSettings",
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriUserSideNavSettings"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$08619473c73b1604$var$node.hash = "48a417a1d2876624970df89dfa84bb10";
var $08619473c73b1604$export$2e2bcd8739ae039 = $08619473c73b1604$var$node;

});

parcelRegister("lJLMK", function(module, exports) {
$parcel$export(module.exports, "useNavSettingsService", () => $795f7b72e7a47582$export$29d13058c876d5c5);

var $eW4PJ = parcelRequire("eW4PJ");

var $jXSgx = parcelRequire("jXSgx");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4tnUQ = parcelRequire("4tnUQ");

var $lmbOW = parcelRequire("lmbOW");
function $795f7b72e7a47582$export$29d13058c876d5c5(params) {
    const { mutationEntityAri: entityAri, ownerAri: ownerAri, queryRef: queryRef } = params;
    const queryData = $795f7b72e7a47582$var$useLocalFragment(queryRef);
    const mutation = $795f7b72e7a47582$var$useLocalMutation();
    const { fireEvent: fireEvent } = (0, $4tnUQ.useAnalyticsEvents)();
    const { customizationStore: customizationStore } = (0, $lmbOW.useOptions)();
    const fireMutationEvent = (0, $eJOHy.useCallback)((success, error)=>{
        switch(success){
            case true:
                fireEvent('operational.executeMutation.succeeded', {
                    storage: customizationStore ?? 'network'
                });
                break;
            case false:
                fireEvent('operational.executeMutation.failed', {
                    storage: customizationStore ?? 'network',
                    error: error ?? 'Unknown error'
                });
                break;
        }
    }, [
        customizationStore,
        fireEvent
    ]);
    const setNavData = (0, $eJOHy.useCallback)(({ sidebar: sidebar, properties: properties })=>{
        $795f7b72e7a47582$var$executeMutation({
            mutation: mutation,
            variables: {
                entityAri: entityAri,
                ownerAri: ownerAri,
                properties: properties,
                sidebar: sidebar
            },
            fireEvent: fireMutationEvent
        });
    }, [
        entityAri,
        fireMutationEvent,
        mutation,
        ownerAri
    ]);
    return {
        queryData: queryData,
        setNavData: setNavData
    };
}
function $795f7b72e7a47582$var$useLocalFragment(queryRef) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks */ /* eslint-disable @atlassian/relay/unused-fields */ /* eslint-disable @atlassian/relay/graphql-naming */ return (0, $j4oe4.useFragment)((0, $jXSgx.default), queryRef);
/* eslint-enable @atlassian/relay/unused-fields */ }
function $795f7b72e7a47582$var$useLocalMutation() {
    return (0, $j4oe4.useMutation)((0, $eW4PJ.default))[0];
}
function $795f7b72e7a47582$var$executeMutation({ mutation: mutation, variables: variables, fireEvent: fireEvent }) {
    try {
        return mutation({
            variables: variables,
            onCompleted: ()=>{
                fireEvent(true);
            },
            onError: (error)=>{
                fireEvent(false, error.message || 'Unknown error');
            }
        });
    } catch (error) {
        fireEvent(false, `Unhandled error: ${error.message || 'Unknown error'}`);
    }
}

});
parcelRegister("eW4PJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cf47bccb3a3632f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<026ea9e3c249a20443e23e250f045799>>
 * @relayHash e5e993154e8ff794fa2941e8db114aac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a9f95fdbb33ed6ec2173e84be5621e770d68c2135d4f2ad935657b2adc0d0670
const $9cf47bccb3a3632f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "properties"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sidebar"
    }, v4 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                },
                {
                    "kind": "Variable",
                    "name": "properties",
                    "variableName": "properties"
                },
                {
                    "kind": "Variable",
                    "name": "sidebar",
                    "variableName": "sidebar"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v5 = {
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "menuId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "visible"
                    }
                ]
            }
        ]
    }, v6 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useNavSettingsServiceMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useNavSettingsServiceMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a9f95fdbb33ed6ec2173e84be5621e770d68c2135d4f2ad935657b2adc0d0670",
            "metadata": {},
            "name": "useNavSettingsServiceMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9cf47bccb3a3632f$var$node.hash = "b5a5863adf9d22a5a510899bf456bf50";
var $9cf47bccb3a3632f$export$2e2bcd8739ae039 = $9cf47bccb3a3632f$var$node;

});

parcelRegister("jXSgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $5388fb3a7600fa5d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96099cf96e7b0fafc15ab769c89dc135>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5388fb3a7600fa5d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useNavSettingsService",
    "selections": [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "menuId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "SettingsDisplayPropertyConnection",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsDisplayProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SettingsNavigationCustomisation"
};
$5388fb3a7600fa5d$var$node.hash = "559a20c34fab36365d6ca9ab5d0c4645";
var $5388fb3a7600fa5d$export$2e2bcd8739ae039 = $5388fb3a7600fa5d$var$node;

});

parcelRegister("4tnUQ", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $2af6df824316eea7$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::b3c61250a84f619b4027771ee5c5ce69>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen global-side-navigation
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $4Tdhf = parcelRequire("4Tdhf");
const $2af6df824316eea7$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $4Tdhf.default)(...params));
        event.fire((0, $20a0ad68a38595e4$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("4Tdhf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a3801b4329a4999$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::104fd57c141a6ef812e2ef73c24c1bba>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen global-side-navigation
 */ const $8a3801b4329a4999$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $8a3801b4329a4999$export$2e2bcd8739ae039 = $8a3801b4329a4999$var$createEventPayload;

});





parcelRegister("050GH", function(module, exports) {
$parcel$export(module.exports, "NetworkStore", () => $d752b042bd507da3$export$711a2621397f25fc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $lmbOW = parcelRequire("lmbOW");

var $12gMI = parcelRequire("12gMI");

var $if1Y8 = parcelRequire("if1Y8");
function $d752b042bd507da3$export$711a2621397f25fc({ children: children }) {
    const { networkStorageParams: networkStorageParams, app: app } = (0, $lmbOW.useOptions)();
    (0, $8GOss.default)(networkStorageParams?.activationId && networkStorageParams?.ownerAri && networkStorageParams?.queryRef && networkStorageParams?.siteId, 'Please provide networkStorageParams when using customization');
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $12gMI.useNetworkSideNavUserData)({
        ...networkStorageParams,
        firstPartyApp: app
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $if1Y8.StoreProviders), {
        ...userStoreProps,
        children: children
    });
}

});

parcelRegister("clEd7", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => $7d4a8d85f2b0af6a$export$1a35787d6353cf6a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e3gfr = parcelRequire("e3gfr");

var $85fS3 = parcelRequire("85fS3");

var $eGOwo = parcelRequire("eGOwo");

var $bGx3v = parcelRequire("bGx3v");

var $clIFu = parcelRequire("clIFu");

var $i5aGq = parcelRequire("i5aGq");
var $fAGv6 = parcelRequire("fAGv6");
var $dHlZd = parcelRequire("dHlZd");
var $bAl6v = parcelRequire("bAl6v");

var $1ELDp = parcelRequire("1ELDp");

var $5CAP8 = parcelRequire("5CAP8");

var $lwkX3 = parcelRequire("lwkX3");

var $lmbOW = parcelRequire("lmbOW");

var $dhzXg = parcelRequire("dhzXg");

var $7Rbog = parcelRequire("7Rbog");


var $iNJuq = parcelRequire("iNJuq");

var $1WX9Q = parcelRequire("1WX9Q");
function $7d4a8d85f2b0af6a$export$1a35787d6353cf6a(props) {
    const { bottomElem: bottomElem, postItemsElem: postItemsElem, postMainElem: postMainElem, topElem: topElem, openShortcutsInSameTab: openShortcutsInSameTab } = props;
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $lmbOW.useOptions)();
    const { allItems: allItems } = (0, $lwkX3.useItemsAndShortcuts)();
    const userMenuDataShapes = (0, $7Rbog.useUserMenuDataShapes)();
    const { fireViewedSideNavEvent: fireViewedSideNavEvent } = (0, $5CAP8.useNavAnalytics)();
    // #region Drag and drop
    // Element registry for L1 items
    const [elementRegistry] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState((0, $i5aGq.createElementRegistry));
    const { dragAndDropSave: dragAndDropSave } = (0, $dhzXg.useDragAndDropSave)(userMenuDataShapes, elementRegistry);
    const [draggingL1Group, setDraggingL1Group] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return (0, $bGx3v.monitorForElements)({
            canMonitor: ({ source: source })=>(0, $dHlZd.isL1ItemData)(source.data) && (0, $dHlZd.isL1ItemDataInGroup)(source.data, [
                    (0, $clIFu.L1_MENU_GROUPS).MENU,
                    (0, $clIFu.L1_MENU_GROUPS).SHORTCUTS
                ]),
            onDragStart ({ source: source }) {
                if (!(0, $dHlZd.isL1ItemData)(source.data)) return;
                setDraggingL1Group(source.data.group);
            },
            onDrop ({ source: source, location: location }) {
                const dragging = source.data;
                setDraggingL1Group(null);
                const [innerMost] = location.current.dropTargets;
                if (!innerMost) return;
                const dropTargetData = innerMost.data;
                const instruction = (0, $e3gfr.extractInstruction)(dropTargetData);
                if (!instruction) return;
                // Dragging Out from More Menu
                if ((0, $dHlZd.isL1ItemData)(dragging) && (0, $dHlZd.isL1ItemData)(dropTargetData) && userMenuDataShapes.hiddenMenuIds.includes(dragging.menuItemId)) {
                    dragAndDropSave({
                        type: 'item-unhide',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag and Drop Order
                if ((0, $dHlZd.isL1ItemData)(dragging) && (0, $dHlZd.isL1ItemData)(dropTargetData) && (0, $dHlZd.isL1ItemDataInGroup)(dragging, (0, $clIFu.L1_MENU_GROUPS).SHORTCUTS) && (0, $dHlZd.isL1ItemDataInGroup)(dropTargetData, (0, $clIFu.L1_MENU_GROUPS).SHORTCUTS)) {
                    dragAndDropSave({
                        type: 'item-reorder',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag and Drop Order within Menu Group
                if ((0, $dHlZd.isL1ItemData)(dragging) && (0, $dHlZd.isL1ItemData)(dropTargetData) && (0, $dHlZd.isL1ItemDataInGroup)(dragging, (0, $clIFu.L1_MENU_GROUPS).MENU) && (0, $dHlZd.isL1ItemDataInGroup)(dropTargetData, (0, $clIFu.L1_MENU_GROUPS).MENU)) {
                    dragAndDropSave({
                        type: 'item-reorder',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag into more menu
                if ((0, $dHlZd.isL1ItemData)(dragging) && (0, $dHlZd.isL1ItemDataInGroup)(dragging, [
                    (0, $clIFu.L1_MENU_GROUPS).MENU,
                    (0, $clIFu.L1_MENU_GROUPS).SHORTCUTS
                ]) && (0, $dHlZd.isMoreMenuData)(dropTargetData)) {
                    dragAndDropSave({
                        type: userMenuDataShapes.hiddenMenuIds.includes(dragging.menuItemId) ? 'item-visible' : 'item-hide',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
            }
        });
    }, [
        dragAndDropSave,
        userMenuDataShapes.hiddenMenuIds
    ]);
    const { groupDropIndicatorRef: groupDropIndicatorRef } = (0, $bAl6v.useL1DragState)({
        l1DragAndDropEnabled: l1DragAndDropEnabled
    });
    // #endregion
    // #region Core rendering
    const mainNavItems = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>userMenuDataShapes.visibleItemMenuIds.map((id)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ELDp.default), {
                id: id,
                item: allItems[id]
            }, id)), [
        userMenuDataShapes.visibleItemMenuIds,
        allItems
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useLayoutEffect(()=>{
        if (!(0, $eGOwo.fg)('NAVX-2558-fix-sidenav-viewed-event')) fireViewedSideNavEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i5aGq.ElementRegistryProvider), {
        registry: elementRegistry,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iNJuq.GSNSideNavigationLayout), {
            testId: props.testId ?? (0, $246d5d85b4a306e7$export$5678faf50a8e9276),
            preMainElem: topElem,
            postMainElem: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WX9Q.PostMainItems), {
                postItemsElem: postItemsElem,
                postMainElem: postMainElem,
                draggingL1Group: draggingL1Group,
                openShortcutsInSameTab: openShortcutsInSameTab
            }),
            bottomElem: bottomElem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $85fS3.MenuList), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fAGv6.GroupDropIndicatorWithDragOver), {
                    ref: groupDropIndicatorRef,
                    isActive: draggingL1Group === (0, $clIFu.L1_MENU_GROUPS).MENU,
                    children: mainNavItems
                })
            })
        })
    });
// #endregion
}

});
parcelRegister("fAGv6", function(module, exports) {
$parcel$export(module.exports, "GroupDropIndicatorWithDragOver", () => $55373f784ecbdc8a$export$bd7361bd33ae3eff);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $55373f784ecbdc8a$var$activeStyle = null;
const $55373f784ecbdc8a$var$enteredStyle = null;
const $55373f784ecbdc8a$export$bd7361bd33ae3eff = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function GroupDropIndicatorWithDragOver({ children: children, isActive: isActive, testId: testId, disableEntered: disableEntered }, forwardedRef) {
    const [isEntered, setIsEntered] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    /**
   * Manually handle drag over and leave events to apply border styles when drag and drop is active
   */ const handlePointerState = (0, $eJOHy.useCallback)((action)=>()=>{
            !disableEntered && setIsEntered(action === 'enter');
        }, [
        disableEntered
    ]);
    /**
   * Entered state should be reset when isActive is false from drag and drop context
   */ (0, $eJOHy.useEffect)(()=>{
        if (!isActive) setIsEntered(false);
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: forwardedRef,
        "data-testid": testId,
        "data-is-active": isActive,
        "data-is-entered": isEntered,
        onDragOverCapture: isActive ? handlePointerState('enter') : undefined,
        onDragLeaveCapture: isActive ? handlePointerState('leave') : undefined,
        className: (0, $hcewu.default)([
            isActive && "_2rkolb4i _bfhk33gi",
            isEntered && "_1cwg12x7 _12y31dm9 _1qu2nqa1 _12ji1yqz"
        ]),
        children: children
    });
});

});

parcelRegister("bAl6v", function(module, exports) {
$parcel$export(module.exports, "useL1DragState", () => $32e2181332a30731$export$89eb3dcfeb3560d4);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $bGx3v = parcelRequire("bGx3v");

var $dHlZd = parcelRequire("dHlZd");
function $32e2181332a30731$export$89eb3dcfeb3560d4({ l1DragAndDropEnabled: l1DragAndDropEnabled = false }) {
    const groupDropIndicatorRef = (0, $eJOHy.useRef)(null);
    const [dragState, setDragState] = (0, $eJOHy.useState)('idle');
    const [dragSource, setDragSource] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (!l1DragAndDropEnabled) return;
        const l1GroupDropIndicator = groupDropIndicatorRef.current;
        (0, $8GOss.default)(l1GroupDropIndicator, 'l1GroupDropIndicatorRef should not be null');
        return (0, $bGx3v.dropTargetForElements)({
            element: l1GroupDropIndicator,
            canDrop: ({ source: source })=>(0, $dHlZd.isL1ItemData)(source.data),
            onDragStart ({ source: source }) {
                setDragSource(source.data.menuItemId);
                setDragState('is-over');
            },
            onDragEnter () {
                setDragState('is-over');
            },
            onDragLeave () {
                setDragState('idle');
            },
            onDrop () {
                setDragSource(null);
                setDragState('idle');
            }
        });
    }, [
        l1DragAndDropEnabled
    ]);
    return {
        groupDropIndicatorRef: groupDropIndicatorRef,
        dragState: dragState,
        dragSource: dragSource
    };
}

});

parcelRegister("1ELDp", function(module, exports) {
$parcel$export(module.exports, "default", () => $6db18241605700e0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YEko = parcelRequire("6YEko");

var $kKTZh = parcelRequire("kKTZh");
var $2dvSy = parcelRequire("2dvSy");
var $ih05Y = parcelRequire("ih05Y");

var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");

var $clIFu = parcelRequire("clIFu");

var $2LGhB = parcelRequire("2LGhB");

var $lmbOW = parcelRequire("lmbOW");

var $gkkjA = parcelRequire("gkkjA");

var $3wpcZ = parcelRequire("3wpcZ");

var $jlXoy = parcelRequire("jlXoy");

var $iZ1ZH = parcelRequire("iZ1ZH");

var $i7Kir = parcelRequire("i7Kir");

var $5CAP8 = parcelRequire("5CAP8");

var $jIyF9 = parcelRequire("jIyF9");

var $8oG6r = parcelRequire("8oG6r");
function $6db18241605700e0$export$2e2bcd8739ae039({ id: id, item: item, peek: peek = false, isInMoreMenu: isInMoreMenu = false, onClick: onClick, onPeek: onPeek, group: group = (0, $clIFu.L1_MENU_GROUPS).MENU }) {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $lmbOW.useOptions)();
    const { type: type } = item;
    const { isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isExpandable: isExpandable } = (0, $8oG6r.useExpandOpenState)(item, peek);
    const { draggableRef: draggableRef, isItemDraggable: isItemDraggable, isDragging: isDragging, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview } = (0, $2LGhB.useItemDragAndDrop)({
        item: item,
        id: id,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        peek: peek,
        l1DragAndDropEnabled: l1DragAndDropEnabled,
        group: group
    });
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent, fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent } = (0, $5CAP8.useNavAnalytics)();
    // Common internal onClick handler for all top-level item types
    const onNavItemClick = (0, $eJOHy.useCallback)((isRightClick)=>{
        fireClickedSideNavItemEvent(id, undefined, isRightClick);
    }, [
        fireClickedSideNavItemEvent,
        id
    ]);
    // Common onSubMenuItemClick handler for all sub-menu item types
    const onSubMenuItemClick = (0, $eJOHy.useCallback)((isRightClick)=>{
        fireClickedSideNavSubMenuItemEvent(id, undefined, isInMoreMenu, isRightClick);
    }, [
        fireClickedSideNavSubMenuItemEvent,
        id,
        isInMoreMenu
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isExpandable && isExpandOrFlyoutOpen) fireViewedSideNavSubMenuEvent(id, undefined, isInMoreMenu);
    }, [
        fireViewedSideNavSubMenuEvent,
        id,
        isExpandOrFlyoutOpen,
        isExpandable,
        isInMoreMenu,
        type
    ]);
    switch(true){
        case (0, $i7Kir.isCustomItemConfig)(item):
            // If the item is a custom item, render it directly
            // TODO: Add customizationHandlers prop when ready
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ih05Y.MenuListItem), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)(item.Component, {
                        isInMoreMenu: isInMoreMenu && !peek,
                        isPeeked: peek,
                        onClick: (...args)=>{
                            item.Component.defaultProps?.onClick?.(...args);
                            fireClickedSideNavItemEvent(id);
                            onClick?.();
                        },
                        onPeek: onPeek,
                        hasDragIndicator: isItemDraggable ? isItemDraggable : undefined,
                        draggableRef: draggableRef,
                        isDragging: isDragging,
                        dropIndicator: dropIndicator,
                        visualContentRef: dropTargetRef
                    }),
                    maybeDragPreview
                ]
            });
        case (0, $i7Kir.isLinkItemConfig)(item):
            {
                const { label: label, labelElem: labelElem, ...linkMenuItemProps } = (0, $iZ1ZH.omitSafely)(item, 'type');
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jlXoy.ElementEventListener), {
                    handler: onNavItemClick,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2dvSy.LinkMenuItem), {
                            ...linkMenuItemProps,
                            onClick: (...args)=>{
                                linkMenuItemProps.onClick?.(...args);
                                onNavItemClick();
                                onClick?.();
                            },
                            hasDragIndicator: isItemDraggable,
                            ref: draggableRef,
                            isDragging: isDragging,
                            dropIndicator: dropIndicator,
                            visualContentRef: dropTargetRef,
                            actionsOnHover: $6db18241605700e0$var$getActionsOnHover({
                                id: id,
                                isItemDraggable: isItemDraggable,
                                item: item,
                                isInMoreMenu: isInMoreMenu
                            }),
                            children: labelElem ?? label
                        }),
                        maybeDragPreview
                    ]
                });
            }
        case (0, $i7Kir.isButtonItemConfig)(item):
            {
                const { label: label, labelElem: labelElem, ...buttonMenuItemProps } = (0, $iZ1ZH.omitSafely)(item, 'type');
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
                            ...buttonMenuItemProps,
                            onClick: (...args)=>{
                                buttonMenuItemProps.onClick?.(...args);
                                onNavItemClick();
                                onClick?.();
                            },
                            hasDragIndicator: isItemDraggable,
                            ref: draggableRef,
                            isDragging: isDragging,
                            dropIndicator: dropIndicator,
                            visualContentRef: dropTargetRef,
                            actionsOnHover: $6db18241605700e0$var$getActionsOnHover({
                                id: id,
                                isItemDraggable: isItemDraggable,
                                item: item,
                                isInMoreMenu: isInMoreMenu
                            }),
                            children: labelElem ?? label
                        }),
                        maybeDragPreview
                    ]
                });
            }
        case (0, $i7Kir.isExpandableItemConfig)(item):
            {
                const { children: children, elemBefore: elemBefore, label: label, labelElem: labelElem, ...triggerProps } = (0, $iZ1ZH.omitSafely)(item, 'type', 'isDefaultExpanded', 'isExpanded', 'onExpansionToggle');
                // Wrap children with our analytics listener to capture their click events
                const wrappedChildren = (0, $3wpcZ.withSideNavigationAnalyticsListener)(item.children, onSubMenuItemClick);
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Bb7G.ExpandableMenuItem), {
                            isExpanded: isExpandOrFlyoutOpen,
                            onExpansionToggle: onExpandFlyoutToggle,
                            dropIndicator: dropIndicator,
                            ref: dropTargetRef,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fFq5m.ExpandableMenuItemTrigger), {
                                    ...triggerProps,
                                    onClick: (...args)=>{
                                        triggerProps.onClick?.(...args);
                                        onNavItemClick();
                                        onClick?.();
                                    },
                                    // During drags, custom elemBefore is not shown
                                    // https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#drag-start
                                    elemBefore: isDragging ? null : elemBefore,
                                    hasDragIndicator: isItemDraggable,
                                    ref: draggableRef,
                                    isDragging: isDragging,
                                    actionsOnHover: $6db18241605700e0$var$getActionsOnHover({
                                        id: id,
                                        isItemDraggable: isItemDraggable,
                                        item: item,
                                        isInMoreMenu: isInMoreMenu
                                    }),
                                    children: labelElem ?? label
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Z9EK.ExpandableMenuItemContent), {
                                    children: wrappedChildren
                                })
                            ]
                        }),
                        maybeDragPreview
                    ]
                });
            }
        case (0, $i7Kir.isFlyoutItemConfig)(item):
            {
                const { children: children, label: label, labelElem: labelElem, ...triggerProps } = (0, $iZ1ZH.omitSafely)(item, 'type', 'isDefaultOpen', 'isOpen', 'onOpenChange');
                // Wrap children with our analytics listener to capture their click events
                const wrappedChildren = (0, $3wpcZ.withSideNavigationAnalyticsListener)(item.children, onSubMenuItemClick);
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gWy6a.FlyoutMenuItem), {
                            isOpen: isExpandOrFlyoutOpen,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yLgR2.FlyoutMenuItemTrigger), {
                                    ...triggerProps,
                                    onClick: (...args)=>{
                                        triggerProps.onClick?.(...args);
                                        // Toggle the flyout open state
                                        onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                                        onNavItemClick();
                                        onClick?.();
                                    },
                                    hasDragIndicator: isItemDraggable,
                                    ref: draggableRef,
                                    isDragging: isDragging,
                                    dropIndicator: dropIndicator,
                                    visualContentRef: dropTargetRef,
                                    children: labelElem ?? label
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $duFAq.FlyoutMenuItemContent), {
                                    children: [
                                        wrappedChildren,
                                        isItemDraggable && !isInMoreMenu && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                                            hasSeparator: true,
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jIyF9.default), {
                                                itemMenuId: id,
                                                renderFromLevel: 1,
                                                onOpenChange: (args)=>{
                                                    onExpandFlyoutToggle(args.isOpen);
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        maybeDragPreview
                    ]
                });
            }
        case (0, $i7Kir.isObjectListFlyoutItemConfig)(item):
            {
                const objectListFlyoutProps = (0, $iZ1ZH.omitSafely)(item, 'type', 'isOpen', 'onOpenChange');
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jlXoy.ElementEventListenerProvider), {
                    handler: onSubMenuItemClick,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gkkjA.ObjectListFlyout), {
                            ...objectListFlyoutProps,
                            itemMenuId: id,
                            onClick: (...args)=>{
                                // Toggle the flyout open state
                                onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                                objectListFlyoutProps.onClick?.(...args);
                                onNavItemClick();
                                onClick?.();
                            },
                            onSubMenuItemClick: (...args)=>{
                                objectListFlyoutProps.onSubMenuItemClick?.(...args);
                                onSubMenuItemClick();
                            },
                            isFlyoutOpen: isExpandOrFlyoutOpen,
                            onOpenChange: onExpandFlyoutToggle,
                            hasDragIndicator: isItemDraggable,
                            triggerRef: draggableRef,
                            isDragging: isDragging,
                            dropIndicator: dropIndicator,
                            visualContentRef: dropTargetRef
                        }),
                        maybeDragPreview
                    ]
                });
            }
        default:
            return null;
    }
}
// This cannot be a React function-component, otherwise the Link/Button/Expand.actionsOnHover prop will can never be undefined.
// When there are no actionsOnHover and the item is not draggable, actionsOnHover MUST return undefined, to avoid the
// elemAfter from being hidden unintentionally.
function $6db18241605700e0$var$getActionsOnHover({ id: id, item: item, isItemDraggable: isItemDraggable, isInMoreMenu: isInMoreMenu }) {
    return item.actionsOnHover ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            item.actionsOnHover,
            isItemDraggable && !isInMoreMenu && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jIyF9.default), {
                itemMenuId: id
            })
        ]
    }) : isItemDraggable && !isInMoreMenu ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jIyF9.default), {
        itemMenuId: id
    }) : undefined;
}

});
parcelRegister("gkkjA", function(module, exports) {
$parcel$export(module.exports, "ObjectListFlyout", () => $2fea1c695f6bc9e9$export$8c8993cce765101e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $h8zk5 = parcelRequire("h8zk5");

var $igzjq = parcelRequire("igzjq");
function $2fea1c695f6bc9e9$export$8c8993cce765101e(props) {
    const { dropIndicator: dropIndicator, elemBefore: elemBefore, entryPoint: entryPoint = (0, $igzjq.objectListFlyoutEntrypoint), entryPointParams: entryPointParams, errorFallback: errorFallback, fallback: fallback, hasDragIndicator: hasDragIndicator, isDefaultOpen: isDefaultOpen, isDragging: isDragging, isFlyoutOpen: isFlyoutOpen, label: label, labelElem: labelElem, onClick: onClick, onOpenChange: onOpenChange, testId: testId, triggerRef: triggerRef, visualContentRef: visualContentRef } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8zk5.FlyoutTrigger), {
        entryPoint: entryPoint,
        entryPointProps: props,
        entryPointParams: entryPointParams,
        errorFallback: errorFallback,
        fallback: fallback,
        isDefaultOpen: isDefaultOpen,
        onOpenChange: onOpenChange,
        isFlyoutOpen: isFlyoutOpen,
        triggerProps: {
            elemBefore: elemBefore,
            children: labelElem ?? label,
            onClick: onClick,
            testId: testId,
            hasDragIndicator: hasDragIndicator,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            triggerRef: triggerRef,
            visualContentRef: visualContentRef
        }
    });
}

});
parcelRegister("h8zk5", function(module, exports) {
$parcel$export(module.exports, "FlyoutTrigger", () => $b2ccd83d2636dd3b$export$4ebbeeb2921cde03);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kmlzw = parcelRequire("kmlzw");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");

var $7ep4S = parcelRequire("7ep4S");

var $dy5PQ = parcelRequire("dy5PQ");

var $lBsyH = parcelRequire("lBsyH");

var $4Gyvo = parcelRequire("4Gyvo");

var $chEFD = parcelRequire("chEFD");
const $b2ccd83d2636dd3b$var$emptyEntryPointParams = {};
const $b2ccd83d2636dd3b$var$emptyEntryPointProps = {};
function $b2ccd83d2636dd3b$export$4ebbeeb2921cde03({ triggerProps: triggerProps, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, onOpenChange: onOpenChange, isDefaultOpen: isDefaultOpen = false, ...flyoutProps }) {
    const environmentProvider = (0, $4Gyvo.useRelayEnvironmentProvider)();
    const hasRun = (0, $eJOHy.useRef)(false);
    const hasLoaded = (0, $eJOHy.useRef)(false);
    const id = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const isOpenControlled = flyoutProps.isFlyoutOpen !== undefined && hasLoaded.current;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [content, setContent] = (0, $eJOHy.useState)(null);
    const handleOpen = (0, $eJOHy.useCallback)(()=>{
        !isOpenControlled && setIsOpen(true);
    }, [
        isOpenControlled
    ]);
    const handleClose = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const onFlyoutOpenChange = (0, $eJOHy.useCallback)((open)=>{
        onOpenChange?.(open);
    }, [
        onOpenChange
    ]);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $b2ccd83d2636dd3b$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing flyout
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBsyH.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {}),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $b2ccd83d2636dd3b$var$emptyEntryPointProps,
                closeFlyout: handleClose
            },
            onError: onError
        }));
        hasLoaded.current = true;
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    // Auto-open on first render if isDefaultOpen is true
    (0, $eJOHy.useEffect)(()=>{
        if (isDefaultOpen && !hasRun.current) {
            handleOpen();
            onLoad({
                reference: load()
            });
            hasRun.current = true;
        }
    }, [
        handleOpen,
        isDefaultOpen,
        load,
        onLoad
    ]);
    // Update internal open state when isOpenControlled changes
    // Allows the open state to be dynamically controlled
    (0, $eJOHy.useEffect)(()=>{
        isOpenControlled && setIsOpen(!!flyoutProps.isFlyoutOpen);
    }, [
        flyoutProps.isFlyoutOpen,
        isOpenControlled
    ]);
    const triggerCloseRef = (0, $chEFD.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const triggerRef = (0, $dy5PQ.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const flyoutTriggerRef = (0, $eJOHy.useMemo)(()=>{
        const refs = [
            triggerRef,
            triggerCloseRef
        ];
        if (triggerProps?.triggerRef) refs.push(triggerProps.triggerRef);
        return (0, $kmlzw.mergeRefs)(refs);
    }, [
        triggerRef,
        triggerCloseRef,
        triggerProps.triggerRef
    ]);
    const flyoutContent = (0, $eJOHy.useCallback)(()=>content, [
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gWy6a.FlyoutMenuItem), {
        ...flyoutProps,
        isOpen: isOpen,
        onOpenChange: onFlyoutOpenChange,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yLgR2.FlyoutMenuItemTrigger), {
                ...triggerProps,
                ref: flyoutTriggerRef
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $duFAq.FlyoutMenuItemContent), {
                onClose: handleClose,
                children: flyoutContent()
            })
        ]
    });
}

});
parcelRegister("chEFD", function(module, exports) {
$parcel$export(module.exports, "useClickToCloseRef", () => $6229f4db0a0e330a$export$46ec6629f411921d);

var $eJOHy = parcelRequire("eJOHy");
function $6229f4db0a0e330a$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        el.addEventListener('click', clickListener);
        return ()=>{
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});


parcelRegister("igzjq", function(module, exports) {
$parcel$export(module.exports, "objectListFlyoutEntrypoint", () => $11a7fc0ae1683c3a$export$34c0c9850f758c93);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $11a7fc0ae1683c3a$export$34c0c9850f758c93 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("j5m8t")), {
        moduleId: "06e38b41",
        priority: "interaction",
        moduleId: 'objectListFlyoutEntrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("j5m8t", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("32IHi").then(()=>parcelRequire('5gPIW'));

});



parcelRegister("i7Kir", function(module, exports) {
$parcel$export(module.exports, "isButtonItemConfig", () => $a825a302bd44af63$export$cd440346ca02126b);
$parcel$export(module.exports, "isCustomItemConfig", () => $a825a302bd44af63$export$8e525d5a1e55be8f);
$parcel$export(module.exports, "isExpandableItemConfig", () => $a825a302bd44af63$export$e5ec7109da4bc094);
$parcel$export(module.exports, "isFlyoutItemConfig", () => $a825a302bd44af63$export$ee29322ec7068717);
$parcel$export(module.exports, "isLinkItemConfig", () => $a825a302bd44af63$export$4fdefbbdae1adf42);
$parcel$export(module.exports, "isObjectListFlyoutItemConfig", () => $a825a302bd44af63$export$10dd63e15344d4ca);
const $a825a302bd44af63$export$cd440346ca02126b = (item)=>item.type === 'button';
const $a825a302bd44af63$export$8e525d5a1e55be8f = (item)=>item.type === 'custom';
const $a825a302bd44af63$export$e5ec7109da4bc094 = (item)=>item.type === 'expand';
const $a825a302bd44af63$export$ee29322ec7068717 = (item)=>item.type === 'flyout';
const $a825a302bd44af63$export$4fdefbbdae1adf42 = (item)=>item.type === 'link';
const $a825a302bd44af63$export$10dd63e15344d4ca = (item)=>item.type === 'object-list-flyout';

});

parcelRegister("5CAP8", function(module, exports) {
$parcel$export(module.exports, "useNavAnalytics", () => $cea4b5b632f03786$export$8d6902e2f27b22d5);

var $eJOHy = parcelRequire("eJOHy");

var $lwkX3 = parcelRequire("lwkX3");

var $lmbOW = parcelRequire("lmbOW");

var $7Rbog = parcelRequire("7Rbog");

var $eO1Aq = parcelRequire("eO1Aq");

var $4tnUQ = parcelRequire("4tnUQ");
function $cea4b5b632f03786$export$8d6902e2f27b22d5() {
    const { fireEvent: fireEvent } = (0, $4tnUQ.useAnalyticsEvents)();
    const { disableMenuCustomization: disableMenuCustomization, hasBottomElement: hasBottomElement } = (0, $lmbOW.useOptions)();
    const { allItems: allItems, globalItems: globalItems, growthItemShortcuts: growthItemShortcuts, items: items, shortcuts: shortcuts } = (0, $lwkX3.useItemsAndShortcuts)();
    const { hiddenMenuIds: hiddenMenuIds, hiddenItemMenuIds: hiddenItemMenuIds, hiddenShortcutMenuIds: hiddenShortcutMenuIds, visibleMenuIds: visibleMenuIds, visibleItemMenuIds: visibleItemMenuIds, visibleShortcutMenuIds: visibleShortcutMenuIds } = (0, $7Rbog.useUserMenuDataShapes)();
    // Global items + customize/more + bottom element
    const globalItemsList = (0, $eJOHy.useMemo)(()=>[
            ...visibleItemMenuIds.filter((id)=>globalItems.has(id)),
            ...!disableMenuCustomization ? [
                !!hiddenItemMenuIds.length || !!hiddenShortcutMenuIds.length ? (0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).more : (0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).customize
            ] : [],
            ...hasBottomElement ? [
                (0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).bottomElem
            ] : []
        ], [
        disableMenuCustomization,
        hasBottomElement,
        hiddenItemMenuIds,
        hiddenShortcutMenuIds,
        globalItems,
        visibleItemMenuIds
    ]);
    // App specific items
    const appSpecificItemsList = (0, $eJOHy.useMemo)(()=>visibleItemMenuIds.filter((id)=>allItems[id] && !globalItems.has(id)), [
        allItems,
        globalItems,
        visibleItemMenuIds
    ]);
    // Shortcuts + growth shortcuts
    const shortcutIds = (0, $eJOHy.useMemo)(()=>Object.keys(growthItemShortcuts ?? {}), [
        growthItemShortcuts
    ]);
    const shortcutItemList = (0, $eJOHy.useMemo)(()=>[
            ...visibleShortcutMenuIds,
            ...shortcutIds
        ], [
        visibleShortcutMenuIds,
        shortcutIds
    ]);
    // All visible items
    const navItemList = (0, $eJOHy.useMemo)(()=>[
            ...globalItemsList,
            ...appSpecificItemsList,
            ...shortcutItemList
        ], [
        globalItemsList,
        appSpecificItemsList,
        shortcutItemList
    ]);
    // Item group
    const itemsIds = (0, $eJOHy.useMemo)(()=>Object.keys(items), [
        items
    ]);
    const getItemGroup = (0, $eJOHy.useCallback)((id)=>{
        return !!growthItemShortcuts?.[id] || !!shortcuts?.[id] ? 'appShortcut' : itemsIds.includes(id) ? 'appSpecific' : 'global';
    }, [
        growthItemShortcuts,
        itemsIds,
        shortcuts
    ]);
    const getGroupItems = (0, $eJOHy.useCallback)((group)=>{
        switch(group){
            case 'global':
                return globalItemsList;
            case 'appSpecific':
                return appSpecificItemsList;
            case 'appShortcut':
                return shortcutItemList;
            default:
                return [];
        }
    }, [
        appSpecificItemsList,
        globalItemsList,
        shortcutItemList
    ]);
    const fireViewedSideNavEvent = (0, $eJOHy.useCallback)(()=>{
        const moreMenuItems = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
        const globalItemsList = [
            ...globalItems.keys(),
            ...!disableMenuCustomization ? [
                moreMenuItems.length ? (0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).more : (0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).customize
            ] : [],
            ...hasBottomElement ? [
                (0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).bottomElem
            ] : []
        ];
        const appSpecificItemsList = Object.keys(items);
        const appShortcutItemsList = visibleShortcutMenuIds;
        fireEvent('ui.sideNav.viewed.sideNavMenu', {
            globalItemsCount: globalItemsList.length,
            globalItemsList: globalItemsList,
            appSpecificItemsCount: appSpecificItemsList.length,
            appSpecificItemsList: appSpecificItemsList,
            appShortcutItemsCount: appShortcutItemsList.length,
            appShortcutItemsList: appShortcutItemsList,
            inMoreItemsCount: moreMenuItems.length,
            inMoreItemsList: moreMenuItems
        });
    }, [
        hiddenItemMenuIds,
        hiddenShortcutMenuIds,
        globalItems,
        disableMenuCustomization,
        hasBottomElement,
        items,
        visibleShortcutMenuIds,
        fireEvent
    ]);
    const fireClickedSideNavItemEvent = (0, $eJOHy.useCallback)((id, navLayoutComponent, isRightClick = false)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id);
        const isInternalGlobalItem = Object.values((0, $eO1Aq.INTERNAL_GLOBAL_ITEMS)).includes(id);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        const isInMore = // customize is in more if there are any hidden items
        (0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).customize === id && !!hiddenMenuIds.length || hiddenMenuIds.includes(id);
        // Current index irrespective of the item group
        const currentIndex = isInMore ? -1 : isInternalGlobalItem || !!growthItemShortcuts?.[id] ? visibleMenuIds.length : visibleMenuIds.indexOf(id);
        // Current index within the item group
        const currentGroupIndex = isInMore ? -1 : visibleGroupItems.indexOf(id);
        const currentComponent = navLayoutComponent ? navLayoutComponent : isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.clicked.sideNavItem', {
            navLayoutComponent: currentComponent,
            navItemsCount: navItemList.length,
            navItemsIndex: currentIndex,
            group: currentGroup,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: currentGroupIndex,
            groupItem: id,
            isInMore: isInMore,
            isRightClick: isRightClick
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup,
        growthItemShortcuts,
        hiddenMenuIds,
        navItemList.length,
        visibleMenuIds
    ]);
    const fireDraggedSideNavItemEvent = (0, $eJOHy.useCallback)((id, isInMore = false)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        // Current index irrespective of the item group
        const currentIndex = isInMore ? -1 : !!growthItemShortcuts?.[id] ? visibleMenuIds.length : visibleMenuIds.indexOf(id);
        // Current index within the item group
        const currentGroupIndex = isInMore ? -1 : visibleGroupItems.indexOf(id);
        const currentComponent = isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.dragged.sideNavItem', {
            navLayoutComponent: currentComponent,
            navItemsCount: navItemList.length,
            navItemsIndex: currentIndex,
            group: currentGroup,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: currentGroupIndex,
            groupItem: id,
            isInMore: isInMore
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup,
        growthItemShortcuts,
        navItemList.length,
        visibleMenuIds
    ]);
    const fireViewedSideNavSubMenuEvent = (0, $eJOHy.useCallback)((id, subItemsCount, isInMore = false, navLayoutComponent)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        const currentComponent = navLayoutComponent ? navLayoutComponent : isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.viewed.sideNavSubMenu', {
            group: currentGroup,
            groupItem: id,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: visibleGroupItems.indexOf(id),
            groupSubItemCount: subItemsCount ?? null,
            isInMore: isInMore,
            navLayoutComponent: currentComponent
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup
    ]);
    const fireViewedShortcutsEvent = (0, $eJOHy.useCallback)((shortcuts)=>{
        const attributes = {
            appShortcutItemsCount: shortcuts.length,
            appShortcutItemsList: shortcuts.map((item)=>item.label)
        };
        fireEvent('ui.sideNav.viewed.sideNavAppShortcutsSection', attributes);
    }, [
        fireEvent
    ]);
    const fireClickedSideNavSubMenuItemEvent = (0, $eJOHy.useCallback)((id, subItemsCount, isInMore = false, isRightClick = false, navLayoutComponent)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        const currentComponent = navLayoutComponent ? navLayoutComponent : isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.clicked.sideNavSubItem', {
            group: currentGroup,
            groupItem: id,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: visibleGroupItems.indexOf(id),
            groupSubItem: null,
            groupSubItemCount: subItemsCount ?? null,
            groupSubItemIndex: null,
            isInMore: isInMore,
            isRightClick: isRightClick,
            navLayoutComponent: currentComponent
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup
    ]);
    return {
        fireClickedSideNavItemEvent: fireClickedSideNavItemEvent,
        fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent,
        fireDraggedSideNavItemEvent: fireDraggedSideNavItemEvent,
        fireViewedShortcutsEvent: fireViewedShortcutsEvent,
        fireViewedSideNavEvent: fireViewedSideNavEvent,
        fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent
    };
}

});
parcelRegister("eO1Aq", function(module, exports) {
$parcel$export(module.exports, "CUSTOMIZE_SIDEBAR_MENU_ITEM_TEST_ID", () => $97fe10518ea5c25e$export$60e3e06657245ab);
$parcel$export(module.exports, "MORE_MENU_TEST_ID", () => $97fe10518ea5c25e$export$9536180777e6913e);
$parcel$export(module.exports, "INTERNAL_GLOBAL_ITEMS", () => $97fe10518ea5c25e$export$d1f148bb46faf037);
const $97fe10518ea5c25e$export$60e3e06657245ab = 'gsn-customize-sidebar';
const $97fe10518ea5c25e$export$9536180777e6913e = 'gsn-more-menu';
const $97fe10518ea5c25e$export$d1f148bb46faf037 = {
    more: 'global.sidebar.more',
    customize: 'global.sidebar.customize',
    bottomElem: 'global.sidebar.bottomElem'
};

});


parcelRegister("jIyF9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b8cc332a2f8623b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $yLgR2 = parcelRequire("yLgR2");
var $85fS3 = parcelRequire("85fS3");

var $hcEzE = parcelRequire("hcEzE");
var $gAQRJ = parcelRequire("gAQRJ");
var $3hLPZ = parcelRequire("3hLPZ");

var $6ak8V = parcelRequire("6ak8V");

var $35Gjp = parcelRequire("35Gjp");

var $eSzuO = parcelRequire("eSzuO");

var $7UsW5 = parcelRequire("7UsW5");
function $3b8cc332a2f8623b$export$2e2bcd8739ae039({ itemMenuId: itemMenuId, onOpenChange: onOpenChange, renderFromLevel: renderFromLevel = 0 }) {
    const { moveUpPosition: moveUpPosition, moveDownPosition: moveDownPosition } = (0, $35Gjp.useNavItemReorderingContext)(itemMenuId);
    const { moveToTop: moveToTop, moveToBottom: moveToBottom, moveUp: moveUp, moveDown: moveDown } = (0, $7UsW5.useReorderingActions)(itemMenuId);
    const { getItemProperties: getItemProperties } = (0, $6ak8V.useItemProperties)();
    const { isReorderable: isReorderable, isHideable: isHideable, isVisible: isVisible } = getItemProperties(itemMenuId) || {};
    const { hideItem: hideItem, showItem: showItem } = (0, $eSzuO.useNavItemVisibilityActions)(itemMenuId);
    if (!isReorderable && !isHideable) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": "gsn-nav-item-actions",
        children: renderFromLevel === 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hcEzE.NavItemActionsMenu), {
            isReorderable: isReorderable,
            isVisible: isVisible,
            canToggleVisibility: isHideable,
            moveUp: moveUp,
            moveDown: moveDown,
            moveToTop: moveToTop,
            moveToBottom: moveToBottom,
            canMoveUp: moveUpPosition !== false,
            canMoveDown: moveDownPosition !== false,
            toggleVisibility: isVisible ? hideItem : showItem,
            onOpenChange: onOpenChange
        }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $85fS3.MenuList), {
            children: [
                isReorderable && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gAQRJ.NavItemReorderingMenu), {
                    TriggerComponent: (0, $yLgR2.FlyoutMenuItemTrigger),
                    moveUp: moveUp,
                    moveDown: moveDown,
                    moveToTop: moveToTop,
                    moveToBottom: moveToBottom,
                    canMoveUp: moveUpPosition !== false,
                    canMoveDown: moveDownPosition !== false,
                    onOpenChange: onOpenChange
                }),
                isHideable && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3hLPZ.NavItemVisibilityToggle), {
                    isVisible: isVisible,
                    toggleVisibility: isVisible ? hideItem : showItem
                })
            ]
        })
    });
}

});
parcelRegister("hcEzE", function(module, exports) {
$parcel$export(module.exports, "NavItemActionsMenu", () => $03801bcc6dcaf4ce$export$b0c278de250067de);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $NByNW = parcelRequire("NByNW");

var $8Zjw7 = parcelRequire("8Zjw7");

var $gAQRJ = parcelRequire("gAQRJ");

var $3hLPZ = parcelRequire("3hLPZ");
function $03801bcc6dcaf4ce$export$b0c278de250067de({ isReorderable: isReorderable = true, isVisible: isVisible = true, moveUp: moveUp, moveDown: moveDown, moveToTop: moveToTop, moveToBottom: moveToBottom, toggleVisibility: toggleVisibility, canMoveUp: canMoveUp = true, canMoveDown: canMoveDown = true, canToggleVisibility: canToggleVisibility = true, onOpenChange: onOpenChange }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // We need to control the state so that nested menus can close this one when they close
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const handleOpenChange = (0, $eJOHy.useCallback)((args)=>{
        setIsOpen(args.isOpen);
        onOpenChange?.(args);
    }, [
        onOpenChange
    ]);
    if (!isReorderable && !canToggleVisibility) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                ...props,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($NByNW))),
                label: formatMessage((0, $8Zjw7.default).actionsMenuTriggerLabel),
                onClick: (event)=>handleOpenChange({
                        isOpen: !isOpen,
                        event: event
                    })
            }),
        shouldRenderToParent: true,
        spacing: "compact",
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aLJ1L.default), {
            children: [
                isReorderable && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gAQRJ.NavItemReorderingMenu), {
                    TriggerComponent: (0, $jYYbf.default),
                    canMoveUp: canMoveUp,
                    canMoveDown: canMoveDown,
                    moveUp: moveUp,
                    moveDown: moveDown,
                    moveToTop: moveToTop,
                    moveToBottom: moveToBottom,
                    onOpenChange: handleOpenChange
                }),
                canToggleVisibility && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3hLPZ.NavItemVisibilityToggle), {
                    TriggerComponent: (0, $jYYbf.default),
                    isVisible: isVisible,
                    toggleVisibility: toggleVisibility
                })
            ]
        })
    });
}

});
parcelRegister("8Zjw7", function(module, exports) {
$parcel$export(module.exports, "default", () => $70bd68592d9cab50$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $70bd68592d9cab50$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    actionsMenuTriggerLabel: {
        id: 'navigation.global-side-navigation.nav-item.actions.trigger-label',
        defaultMessage: 'More actions',
        description: 'Label for the button that opens the item actions menu'
    }
});

});

parcelRegister("gAQRJ", function(module, exports) {
$parcel$export(module.exports, "NavItemReorderingMenu", () => $664e34127eae520d$export$622d0000825ebc97);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $cQxBL = parcelRequire("cQxBL");

var $bhyNF = parcelRequire("bhyNF");

var $7saMl = parcelRequire("7saMl");

var $kKTZh = parcelRequire("kKTZh");
var $kbcF8 = parcelRequire("kbcF8");
var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");
var $85fS3 = parcelRequire("85fS3");

var $4dUWN = parcelRequire("4dUWN");
function $664e34127eae520d$export$622d0000825ebc97({ TriggerComponent: TriggerComponent = (0, $7saMl.default), canMoveUp: canMoveUp, canMoveDown: canMoveDown, moveUp: moveUp, moveDown: moveDown, moveToTop: moveToTop, moveToBottom: moveToBottom, onOpenChange: onOpenChange }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isOnly = !canMoveUp && !canMoveDown;
    const [open, setOpen] = (0, $eJOHy.useState)(false);
    const onOpenChangeInternal = (0, $eJOHy.useCallback)((args)=>{
        setOpen(args.isOpen);
        onOpenChange?.(args);
    }, [
        onOpenChange
    ]);
    const iconProps = (0, $eJOHy.useMemo)(()=>{
        if (TriggerComponent === (0, $7saMl.default)) return {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bhyNF))), {
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                color: "var(--ds-icon-subtle, #626F86)",
                label: "",
                size: "small"
            })
        };
        return {
            elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bhyNF))), {
                label: ""
            }),
            elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                color: "var(--ds-icon-subtle, #626F86)",
                label: "",
                size: "small"
            })
        };
    }, [
        TriggerComponent
    ]);
    if (TriggerComponent === (0, $yLgR2.FlyoutMenuItemTrigger)) {
        if (isOnly) // FlyoutMenuItemTrigger doesn't support isDisabled prop,
        // so if the trigger should be disabled we need to render something visually compatible that does support that state
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
            ...iconProps,
            isDisabled: true,
            children: formatMessage((0, $4dUWN.default).reorderingMenuTriggerLabel)
        });
        // TODO: MenuList -> ButtonMenuItem is the closest visually to DropdownItemGroup -> DropdownItem, but they have different role attributes which is not ideal.
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gWy6a.FlyoutMenuItem), {
            isOpen: open,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yLgR2.FlyoutMenuItemTrigger), {
                    ...iconProps,
                    onClick: (event)=>onOpenChangeInternal({
                            isOpen: !open,
                            event: event
                        }),
                    children: formatMessage((0, $4dUWN.default).reorderingMenuTriggerLabel)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $duFAq.FlyoutMenuItemContent), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $85fS3.MenuList), {
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
                                isDisabled: !canMoveUp,
                                onClick: (event)=>{
                                    moveToTop();
                                    onOpenChangeInternal({
                                        isOpen: false,
                                        event: event
                                    });
                                },
                                elemBefore: (0, $kbcF8.COLLAPSE_ELEM_BEFORE),
                                children: formatMessage((0, $4dUWN.default).moveToTop)
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
                                isDisabled: !canMoveUp,
                                onClick: (event)=>{
                                    moveUp();
                                    onOpenChangeInternal({
                                        isOpen: false,
                                        event: event
                                    });
                                },
                                elemBefore: (0, $kbcF8.COLLAPSE_ELEM_BEFORE),
                                children: formatMessage((0, $4dUWN.default).moveUp)
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
                                isDisabled: !canMoveDown,
                                onClick: (event)=>{
                                    moveDown();
                                    onOpenChangeInternal({
                                        isOpen: false,
                                        event: event
                                    });
                                },
                                elemBefore: (0, $kbcF8.COLLAPSE_ELEM_BEFORE),
                                children: formatMessage((0, $4dUWN.default).moveDown)
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
                                isDisabled: !canMoveDown,
                                onClick: (event)=>{
                                    moveToBottom();
                                    onOpenChangeInternal({
                                        isOpen: false,
                                        event: event
                                    });
                                },
                                elemBefore: (0, $kbcF8.COLLAPSE_ELEM_BEFORE),
                                children: formatMessage((0, $4dUWN.default).moveToBottom)
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        shouldRenderToParent: true,
        spacing: "compact",
        placement: "right-start",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)(TriggerComponent, {
                ...iconProps,
                ...triggerProps,
                ref: triggerRef,
                isDisabled: isOnly,
                children: formatMessage((0, $4dUWN.default).reorderingMenuTriggerLabel)
            });
        },
        onOpenChange: onOpenChangeInternal,
        isOpen: isOnly ? false : open,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aLJ1L.default), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                    isDisabled: !canMoveUp,
                    onClick: moveToTop,
                    children: formatMessage((0, $4dUWN.default).moveToTop)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                    isDisabled: !canMoveUp,
                    onClick: moveUp,
                    children: formatMessage((0, $4dUWN.default).moveUp)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                    isDisabled: !canMoveDown,
                    onClick: moveDown,
                    children: formatMessage((0, $4dUWN.default).moveDown)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                    isDisabled: !canMoveDown,
                    onClick: moveToBottom,
                    children: formatMessage((0, $4dUWN.default).moveToBottom)
                })
            ]
        })
    });
}

});
parcelRegister("bhyNF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdb939b93a8524d001fd2c490c8f16c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $836c46d512d871e7$var$_react = $836c46d512d871e7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $836c46d512d871e7$var$_baseNew = $836c46d512d871e7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $836c46d512d871e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the height of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $836c46d512d871e7$var$GrowVerticalIcon = (props)=>/*#__PURE__*/ $836c46d512d871e7$var$_react.default.createElement($836c46d512d871e7$var$_baseNew.default, Object.assign({
        name: "GrowVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.47 15.78-3.5-3.5 1.06-1.06 2.22 2.22V9h1.5v4.44l2.22-2.22 1.06 1.06-3.5 3.5a.75.75 0 0 1-1.06 0M7.25 2.56 5.03 4.78 3.97 3.72l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5-1.06 1.06-2.22-2.22V7h-1.5z" clip-rule="evenodd"/>`
    }, props));
$836c46d512d871e7$var$GrowVerticalIcon.displayName = 'GrowVerticalIcon';
var $836c46d512d871e7$var$_default = module.exports.default = $836c46d512d871e7$var$GrowVerticalIcon;

});

parcelRegister("4dUWN", function(module, exports) {
$parcel$export(module.exports, "default", () => $03d04a7680a1d255$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $03d04a7680a1d255$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    reorderingMenuTriggerLabel: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.trigger-label',
        defaultMessage: 'Reorder menu item',
        description: 'Label for the button that opens the sub-menu for actions to reorder the menu'
    },
    moveToTop: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-to-top',
        defaultMessage: 'Move to top',
        description: 'Label for the actions menu item to move the item to the top of the menu'
    },
    moveUp: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-up',
        defaultMessage: 'Move up',
        description: 'Label for the actions menu item to move the item up one position in the menu'
    },
    moveDown: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-down',
        defaultMessage: 'Move down',
        description: 'Label for the actions menu item to move the item down one position in the menu'
    },
    moveToBottom: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-to-bottom',
        defaultMessage: 'Move to bottom',
        description: 'Label for the actions menu item to move the item to the bottom of the menu'
    }
});

});


parcelRegister("3hLPZ", function(module, exports) {
$parcel$export(module.exports, "NavItemVisibilityToggle", () => $ed8bedf1ebfc5967$export$3a09d4d7a2897b5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bkdrw = parcelRequire("bkdrw");

var $55RJF = parcelRequire("55RJF");

var $kKTZh = parcelRequire("kKTZh");

var $jrn6a = parcelRequire("jrn6a");
function $ed8bedf1ebfc5967$export$3a09d4d7a2897b5({ TriggerComponent: TriggerComponent = (0, $kKTZh.ButtonMenuItem), isVisible: isVisible, toggleVisibility: toggleVisibility }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)(TriggerComponent, {
        onClick: toggleVisibility,
        elemBefore: isVisible ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($55RJF))), {
            label: "",
            color: "var(--ds-icon, #44546F)",
            testId: "eye-strikethrough-icon"
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bkdrw))), {
            label: "",
            color: "var(--ds-icon, #44546F)",
            testId: "eye-open-icon"
        }),
        children: isVisible ? formatMessage((0, $jrn6a.default).hideItem) : formatMessage((0, $jrn6a.default).showItem)
    });
}

});
parcelRegister("bkdrw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83ebfd72793ed518$var$_react = $83ebfd72793ed518$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $83ebfd72793ed518$var$_baseNew = $83ebfd72793ed518$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $83ebfd72793ed518$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83ebfd72793ed518$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $83ebfd72793ed518$var$_react.default.createElement($83ebfd72793ed518$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$83ebfd72793ed518$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $83ebfd72793ed518$var$_default = module.exports.default = $83ebfd72793ed518$var$EyeOpenIcon;

});

parcelRegister("55RJF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc35d7011127658ef0b5408810ae194b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b571a2365e2cd85$var$_react = $3b571a2365e2cd85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3b571a2365e2cd85$var$_baseNew = $3b571a2365e2cd85$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3b571a2365e2cd85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b571a2365e2cd85$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $3b571a2365e2cd85$var$_react.default.createElement($3b571a2365e2cd85$var$_baseNew.default, Object.assign({
        name: "EyeOpenStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm8.74 10.86 1.24 1.24A8.5 8.5 0 0 1 8 14C4.43 14 1.32 11.77.17 8.62c-.15-.4-.15-.84 0-1.24a8 8 0 0 1 1.51-2.53l1.06 1.06a6.5 6.5 0 0 0-1.16 1.98.3.3 0 0 0 0 .21c.93 2.56 3.48 4.4 6.42 4.4q.62 0 1.21-.11M8 2a8.5 8.5 0 0 0-2.45.36L6.79 3.6q.59-.1 1.21-.1c2.94 0 5.49 1.85 6.42 4.4a.3.3 0 0 1 0 .21 6.5 6.5 0 0 1-1.16 1.98l1.06 1.06a8 8 0 0 0 1.51-2.53c.15-.4.15-.84 0-1.24C14.68 4.23 11.57 2 8 2"/>`
    }, props));
$3b571a2365e2cd85$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $3b571a2365e2cd85$var$_default = module.exports.default = $3b571a2365e2cd85$var$EyeOpenStrikethroughIcon;

});

parcelRegister("jrn6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa84020345711039$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fa84020345711039$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    hideItem: {
        id: 'navigation.global-side-navigation.nav-item.actions.hide-item',
        defaultMessage: 'Hide from sidebar',
        description: 'Label for the actions menu item to hide the item from the menu'
    },
    showItem: {
        id: 'navigation.global-side-navigation.nav-item.actions.show-item',
        defaultMessage: 'Show in sidebar',
        description: 'Label for the actions menu item to show the item in the menu'
    }
});

});



parcelRegister("6ak8V", function(module, exports) {
$parcel$export(module.exports, "useItemProperties", () => $3378af5f91bdcc65$export$f9f73060c8f8254a);

var $eJOHy = parcelRequire("eJOHy");

var $7Rbog = parcelRequire("7Rbog");

var $lwkX3 = parcelRequire("lwkX3");
function $3378af5f91bdcc65$export$f9f73060c8f8254a() {
    const { allItems: allItems } = (0, $lwkX3.useItemsAndShortcuts)();
    const { userMenuData: userMenuData, visibleItemMenuIds: visibleItemMenuIds } = (0, $7Rbog.useUserMenuDataShapes)();
    const getItemProperties = (0, $eJOHy.useCallback)((itemMenuId)=>{
        const item = allItems?.[itemMenuId];
        if (!item) return null;
        return {
            index: userMenuData.findIndex((item)=>item.menuId === itemMenuId) ?? -1,
            isReorderable: item?.isReorderable ?? true,
            isHideable: item?.isHideable ?? true,
            isVisible: visibleItemMenuIds.includes(itemMenuId)
        };
    }, [
        allItems,
        userMenuData,
        visibleItemMenuIds
    ]);
    return {
        getItemProperties: getItemProperties
    };
}

});

parcelRegister("35Gjp", function(module, exports) {
$parcel$export(module.exports, "useNavItemReorderingContext", () => $b2ed4eb4454cf8fb$export$5a7ed07226adea1a);

var $eJOHy = parcelRequire("eJOHy");

var $lwkX3 = parcelRequire("lwkX3");

var $6ak8V = parcelRequire("6ak8V");

var $7Rbog = parcelRequire("7Rbog");

var $f1XI6 = parcelRequire("f1XI6");
function $b2ed4eb4454cf8fb$export$5a7ed07226adea1a(itemMenuId) {
    const { allItems: allItems } = (0, $lwkX3.useItemsAndShortcuts)();
    const [reorderableIds] = (0, $f1XI6.getMenuIdsByReorderable)(allItems);
    const { visibleItemMenuIds: visibleItemMenuIds } = (0, $7Rbog.useUserMenuDataShapes)();
    const { getItemProperties: getItemProperties } = (0, $6ak8V.useItemProperties)();
    const visibleAndReorderableIds = (0, $eJOHy.useMemo)(()=>{
        return visibleItemMenuIds.filter((id)=>reorderableIds.includes(id));
    }, [
        reorderableIds,
        visibleItemMenuIds
    ]);
    const itemIndex = (0, $eJOHy.useMemo)(()=>visibleAndReorderableIds.indexOf(itemMenuId), [
        visibleAndReorderableIds,
        itemMenuId
    ]);
    const moveUpPosition = (0, $eJOHy.useMemo)(()=>{
        // Not visible and reorderable, can't move
        if (itemIndex === -1) return false;
        // Already the first reorderable item, can't move up
        if (itemIndex === 0) return false;
        const previousVisibleReorderableItem = visibleAndReorderableIds[itemIndex - 1];
        // Get and return the index of the previous visible reorderable item in the whole menu
        const previousItem = getItemProperties(previousVisibleReorderableItem);
        return previousItem?.index ?? false;
    }, [
        getItemProperties,
        itemIndex,
        visibleAndReorderableIds
    ]);
    const moveDownPosition = (0, $eJOHy.useMemo)(()=>{
        // Not visible and reorderable, can't move
        if (itemIndex === -1) return false;
        // Already the last reorderable item, can't move down
        if (itemIndex === visibleAndReorderableIds.length - 1) return false;
        const nextVisibleReorderableItem = visibleAndReorderableIds[itemIndex + 1];
        // Get and return the index of the next visible reorderable item in the whole menu
        const nextItem = getItemProperties(nextVisibleReorderableItem);
        return nextItem?.index ?? false;
    }, [
        getItemProperties,
        itemIndex,
        visibleAndReorderableIds
    ]);
    const menuTopPosition = (0, $eJOHy.useMemo)(()=>{
        // Get the index of the first visible reorderable item in the whole menu
        const firstVisibleReorderableItem = visibleAndReorderableIds[0];
        const firstItem = getItemProperties(firstVisibleReorderableItem);
        return firstItem?.index ?? false;
    }, [
        getItemProperties,
        visibleAndReorderableIds
    ]);
    const menuBottomPosition = (0, $eJOHy.useMemo)(()=>{
        // Get the index of the last visible reorderable item in the whole menu
        const lastVisibleReorderableItem = visibleAndReorderableIds[visibleAndReorderableIds.length - 1];
        const lastItem = getItemProperties(lastVisibleReorderableItem);
        return lastItem?.index ?? false;
    }, [
        getItemProperties,
        visibleAndReorderableIds
    ]);
    return {
        index: getItemProperties(itemMenuId)?.index,
        moveUpPosition: moveUpPosition,
        moveDownPosition: moveDownPosition,
        menuTopPosition: menuTopPosition,
        menuBottomPosition: menuBottomPosition
    };
}

});
parcelRegister("f1XI6", function(module, exports) {
$parcel$export(module.exports, "getMenuIdsByReorderable", () => $b6811a91df44da36$export$58c6f70ff46a8d69);

var $e7q0A = parcelRequire("e7q0A");

var $1fUgP = parcelRequire("1fUgP");
const $b6811a91df44da36$export$58c6f70ff46a8d69 = (items)=>{
    const transformedItems = Object.entries(items).map(([key, value])=>{
        return {
            menuId: key,
            ...value,
            // Default to true if isReorderable is undefined
            isReorderable: value.isReorderable ?? true
        };
    });
    return (0, $1fUgP.partitionByReorderable)(transformedItems).map((0, $e7q0A.getMenuIds));
};

});
parcelRegister("1fUgP", function(module, exports) {
$parcel$export(module.exports, "partitionByReorderable", () => $5539515db1880992$export$6f8406a7b0227f9e);

var $a6gy0 = parcelRequire("a6gy0");
const $5539515db1880992$export$6f8406a7b0227f9e = (items)=>(0, (/*@__PURE__*/$parcel$interopDefault($a6gy0)))(items, (item)=>item.isReorderable);

});



parcelRegister("eSzuO", function(module, exports) {
$parcel$export(module.exports, "useNavItemVisibilityActions", () => $4934fbcddd4ddc84$export$857d6a0eb266f860);

var $eJOHy = parcelRequire("eJOHy");

var $7Rbog = parcelRequire("7Rbog");
function $4934fbcddd4ddc84$export$857d6a0eb266f860(itemMenuId) {
    const { userMenuData: userMenuData, visibleItemMenuIds: visibleItemMenuIds, setUserMenuData: setUserMenuData } = (0, $7Rbog.useUserMenuDataShapes)();
    const hideItem = (0, $eJOHy.useCallback)(async ()=>{
        if (!visibleItemMenuIds.includes(itemMenuId)) return;
        const dataWithHiddenItem = userMenuData.map((datum)=>{
            if (datum.menuId === itemMenuId) return {
                ...datum,
                visible: false
            };
            return datum;
        });
        setUserMenuData(dataWithHiddenItem);
    }, [
        itemMenuId,
        setUserMenuData,
        userMenuData,
        visibleItemMenuIds
    ]);
    const showItem = (0, $eJOHy.useCallback)(async ()=>{
        if (visibleItemMenuIds.includes(itemMenuId)) return;
        const dataWithVisibleItem = userMenuData.map((datum)=>{
            if (datum.menuId === itemMenuId) return {
                ...datum,
                visible: true
            };
            return datum;
        });
        setUserMenuData(dataWithVisibleItem);
    }, [
        itemMenuId,
        setUserMenuData,
        userMenuData,
        visibleItemMenuIds
    ]);
    return {
        hideItem: hideItem,
        showItem: showItem
    };
}

});

parcelRegister("7UsW5", function(module, exports) {
$parcel$export(module.exports, "useReorderingActions", () => $bb548d324ad1703d$export$76cbb5eb4ae0ddd9);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("isfFo");
var $l0rlp = parcelRequire("l0rlp");

var $7Rbog = parcelRequire("7Rbog");

var $35Gjp = parcelRequire("35Gjp");
function $bb548d324ad1703d$export$76cbb5eb4ae0ddd9(itemMenuId) {
    const { userMenuData: userMenuData, setUserMenuData: setUserMenuData } = (0, $7Rbog.useUserMenuDataShapes)();
    const { index: index, moveUpPosition: moveUpPosition, moveDownPosition: moveDownPosition, menuTopPosition: menuTopPosition, menuBottomPosition: menuBottomPosition } = (0, $35Gjp.useNavItemReorderingContext)(itemMenuId);
    if (index === undefined) throw new Error(`Item with ID ${itemMenuId} not found in user menu data`);
    // Internal function to do the actual reorder actions
    const reorderItem = (0, $eJOHy.useCallback)(async (startIndex, finishIndex)=>{
        const reordered = (0, $l0rlp.reorder)({
            list: userMenuData,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        setUserMenuData(reordered);
    }, [
        setUserMenuData,
        userMenuData
    ]);
    const moveUp = (0, $eJOHy.useCallback)(()=>{
        if (moveUpPosition === false || typeof moveUpPosition !== 'number') return;
        reorderItem(index, moveUpPosition);
    }, [
        index,
        moveUpPosition,
        reorderItem
    ]);
    const moveDown = (0, $eJOHy.useCallback)(()=>{
        if (moveDownPosition === false || typeof moveDownPosition !== 'number') return;
        reorderItem(index, moveDownPosition);
    }, [
        index,
        moveDownPosition,
        reorderItem
    ]);
    const moveToTop = (0, $eJOHy.useCallback)(()=>{
        if (moveUpPosition === false || index === menuTopPosition || typeof menuTopPosition !== 'number') return;
        reorderItem(index, menuTopPosition);
    }, [
        moveUpPosition,
        index,
        menuTopPosition,
        reorderItem
    ]);
    const moveToBottom = (0, $eJOHy.useCallback)(()=>{
        // If this is already the last reorderable item, do nothing
        if (moveDownPosition === false || index === menuBottomPosition || typeof menuBottomPosition !== 'number') return;
        reorderItem(index, menuBottomPosition);
    }, [
        moveDownPosition,
        index,
        menuBottomPosition,
        reorderItem
    ]);
    return {
        moveUp: moveUp,
        moveDown: moveDown,
        moveToTop: moveToTop,
        moveToBottom: moveToBottom
    };
}

});
parcelRegister("isfFo", function(module, exports) {
$parcel$export(module.exports, "reorder", () => (parcelRequire("l0rlp")).reorder);

var $l0rlp = parcelRequire("l0rlp");

});
parcelRegister("l0rlp", function(module, exports) {
$parcel$export(module.exports, "reorder", () => $f980499636215ef6$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $f980499636215ef6$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});




parcelRegister("8oG6r", function(module, exports) {
$parcel$export(module.exports, "useExpandOpenState", () => $711c53642c03d040$export$e66526057f4a5c1e);

var $eJOHy = parcelRequire("eJOHy");
function $711c53642c03d040$export$e66526057f4a5c1e(item, peek) {
    const { type: type } = item;
    const isExpandable = [
        'expand',
        'flyout',
        'object-list-flyout'
    ].includes(type);
    const isExpandableOnPeek = [
        'expand',
        'flyout'
    ].includes(type);
    const isExpandedFromProps = (type === 'expand' ? item.isExpanded : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.isOpen : undefined);
    const isDefaultExpanded = (type === 'expand' ? item.isDefaultExpanded : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.isDefaultOpen : undefined);
    // Prioritize controlled props if available, otherwise use default expanded/open state
    const initState = typeof isExpandedFromProps === 'boolean' ? isExpandedFromProps : typeof isDefaultExpanded === 'boolean' ? isDefaultExpanded : false;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $eJOHy.useState)(initState);
    // Sync internal state when controlled props change, but not when isDefaultExpanded changes
    (0, $eJOHy.useEffect)(()=>{
        if (!isExpandable) return;
        if (typeof isExpandedFromProps === 'boolean' && !peek) setIsExpandOrFlyoutOpen(isExpandedFromProps);
        if (isExpandableOnPeek && peek) setIsExpandOrFlyoutOpen(true);
    }, [
        isExpandedFromProps,
        isExpandable,
        peek,
        isExpandableOnPeek
    ]);
    const onExpanded = (type === 'expand' ? item.onExpansionToggle : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.onOpenChange : undefined);
    const onExpandFlyoutToggle = (0, $eJOHy.useCallback)((isExpandedOrOpen)=>{
        if (!isExpandable) return;
        setIsExpandOrFlyoutOpen(isExpandedOrOpen);
        onExpanded?.(isExpandedOrOpen);
    }, [
        isExpandable,
        onExpanded
    ]);
    return {
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        isExpandable: isExpandable
    };
}

});


parcelRegister("dhzXg", function(module, exports) {
$parcel$export(module.exports, "useDragAndDropSave", () => $bf867534dd4b0308$export$440b6dd66925f04d);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8GOss = parcelRequire("8GOss");

var $exQoy = parcelRequire("exQoy");

var $iANmu = parcelRequire("iANmu");
parcelRequire("isfFo");
var $l0rlp = parcelRequire("l0rlp");

var $4tnUQ = parcelRequire("4tnUQ");

var $5CAP8 = parcelRequire("5CAP8");

var $k8RPh = parcelRequire("k8RPh");
function $bf867534dd4b0308$export$440b6dd66925f04d(userMenuDataShapes, elementRegistry) {
    /*
	Get current order of items and shortcuts
	Apply reorder or hide operation
	Save the updated data using onSave
	*/ const intl = (0, $lRq8t.default)();
    const [lastDragAndDropAction, setLastDragAndDropAction] = (0, $eJOHy.useState)(null);
    const { fireEvent: fireEvent } = (0, $4tnUQ.useAnalyticsEvents)();
    const { fireDraggedSideNavItemEvent: fireDraggedSideNavItemEvent } = (0, $5CAP8.useNavAnalytics)();
    // Clean up live region when unmounted
    (0, $eJOHy.useEffect)(()=>{
        return ()=>$iANmu.cleanup();
    }, []);
    const dragAndDropSave = (0, $eJOHy.useCallback)(async (action)=>{
        // item reordered into visible menu
        if ($bf867534dd4b0308$var$isItemReorderAction(action)) {
            (0, $8GOss.default)(action.droppedOnMenuItemId, 'item-reorder action must have droppedOnMenuItemId');
            const startIndex = userMenuDataShapes.userMenuData.findIndex((datum)=>datum.menuId === action.draggedMenuItemId);
            const itemsAndShortcutsIdsWithoutDraggedItem = userMenuDataShapes.userMenuData.map((datum)=>datum.menuId).filter((id)=>id !== action.draggedMenuItemId);
            const dropTargetIndex = itemsAndShortcutsIdsWithoutDraggedItem.indexOf(action.droppedOnMenuItemId);
            if (startIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `startIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (dropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `dropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const finishIndex = action.instruction.operation === 'reorder-after' ? dropTargetIndex + 1 : dropTargetIndex;
            const visibleStartIndex = userMenuDataShapes.visibleMenuIds.indexOf(action.draggedMenuItemId);
            const visibleDropTargetIndex = userMenuDataShapes.visibleMenuIds.filter((id)=>id !== action.draggedMenuItemId).indexOf(action.droppedOnMenuItemId);
            if (visibleStartIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleStartIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (visibleDropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleDropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const visibleFinishIndex = action.instruction.operation === 'reorder-after' ? visibleDropTargetIndex + 1 : visibleDropTargetIndex;
            const reordered = (0, $l0rlp.reorder)({
                list: userMenuDataShapes.userMenuData,
                startIndex: startIndex,
                finishIndex: finishIndex
            });
            userMenuDataShapes.setUserMenuData(reordered);
            setLastDragAndDropAction({
                ...action,
                startIndex: visibleStartIndex,
                finishIndex: visibleFinishIndex
            });
            return;
        }
        // item is dragged into hide button
        if ($bf867534dd4b0308$var$isItemHideAction(action)) {
            const dataWithHiddenItem = userMenuDataShapes.userMenuData.map((datum)=>{
                if (datum.menuId === action.draggedMenuItemId) return {
                    ...datum,
                    visible: false
                };
                return datum;
            });
            userMenuDataShapes.setUserMenuData(dataWithHiddenItem);
            setLastDragAndDropAction(action);
            return;
        }
        // hidden item dragged into visible button
        if ($bf867534dd4b0308$var$isItemVisibleAction(action)) {
            const dataWithVisibleItem = userMenuDataShapes.userMenuData.map((datum)=>{
                if (datum.menuId === action.draggedMenuItemId) return {
                    ...datum,
                    visible: true
                };
                return datum;
            });
            userMenuDataShapes.setUserMenuData(dataWithVisibleItem);
            setLastDragAndDropAction(action);
            return;
        }
        // hidden item dragged into visible menu
        if ($bf867534dd4b0308$var$isItemUnhideAction(action)) {
            (0, $8GOss.default)(action.droppedOnMenuItemId, 'item-unhide action must have droppedOnMenuItemId');
            const userMenuDataWithUnhiddenItem = userMenuDataShapes.userMenuData.map((data)=>{
                if (data.menuId === action.draggedMenuItemId) return {
                    ...data,
                    visible: true
                };
                return data;
            });
            const startIndex = userMenuDataWithUnhiddenItem.findIndex((datum)=>datum.menuId === action.draggedMenuItemId);
            const itemsAndShortcutsIdsWithoutDraggedItem = userMenuDataWithUnhiddenItem.map((datum)=>datum.menuId).filter((id)=>id !== action.draggedMenuItemId);
            const dropTargetIndex = itemsAndShortcutsIdsWithoutDraggedItem.indexOf(action.droppedOnMenuItemId);
            if (startIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `startIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (dropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `dropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const finishIndex = action.instruction.operation === 'reorder-after' ? dropTargetIndex + 1 : dropTargetIndex;
            const visibleDropTargetIndex = userMenuDataShapes.visibleMenuIds.filter((id)=>id !== action.draggedMenuItemId).indexOf(action.droppedOnMenuItemId);
            if (visibleDropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleDropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const visibleFinishIndex = action.instruction.operation === 'reorder-after' ? visibleDropTargetIndex + 1 : visibleDropTargetIndex;
            const reordered = (0, $l0rlp.reorder)({
                list: userMenuDataWithUnhiddenItem,
                startIndex: startIndex,
                finishIndex: finishIndex
            });
            userMenuDataShapes.setUserMenuData(reordered);
            setLastDragAndDropAction({
                ...action,
                finishIndex: visibleFinishIndex
            });
            return;
        }
    }, [
        fireEvent,
        userMenuDataShapes
    ]);
    // After action has been performed, announce & flash the item
    (0, $eJOHy.useEffect)(()=>{
        if (!lastDragAndDropAction) return;
        if ($bf867534dd4b0308$var$isItemReorderAction(lastDragAndDropAction)) {
            const label = lastDragAndDropAction.draggedMenuItemLabel || lastDragAndDropAction.draggedMenuItemId;
            const element = elementRegistry.getL1ItemElement(lastDragAndDropAction.draggedMenuItemId);
            if (element) {
                // Flash the moved item
                (0, $exQoy.triggerPostMoveFlash)(element);
                // Focus the moved item if move was triggered by keyboard
                if (lastDragAndDropAction.trigger === 'keyboard') // Per Atlaskit team, .focus() seems to be more reliable in the next task when used with VoiceOver
                setTimeout(()=>element.focus());
                // Announce the move for assistive technology users
                $iANmu.announce(intl.formatMessage((0, $k8RPh.messages).a11yAnnouncementItemReordered, {
                    label: label,
                    startIndex: lastDragAndDropAction.startIndex + 1,
                    finishIndex: lastDragAndDropAction.finishIndex + 1
                }));
                // Fire analytics event
                fireDraggedSideNavItemEvent(lastDragAndDropAction.draggedMenuItemId, false);
            }
            return;
        }
        if ($bf867534dd4b0308$var$isItemHideAction(lastDragAndDropAction)) {
            const label = lastDragAndDropAction.draggedMenuItemLabel || lastDragAndDropAction.draggedMenuItemId;
            const moreMenuElement = elementRegistry.getMoreMenuElement();
            if (moreMenuElement) {
                // Flash the More menu
                (0, $exQoy.triggerPostMoveFlash)(moreMenuElement);
                // Focus the More menu if move was triggered by keyboard
                if (lastDragAndDropAction.trigger === 'keyboard') // Per Atlaskit team, .focus() seems to be more reliable in the next task when used with VoiceOver
                setTimeout(()=>moreMenuElement.focus());
                // Announce the hide for assistive technology users
                $iANmu.announce(intl.formatMessage((0, $k8RPh.messages).a11yAnnouncementItemHidden, {
                    label: label
                }));
                // Fire analytics event
                fireDraggedSideNavItemEvent(lastDragAndDropAction.draggedMenuItemId, true);
            }
        }
        if ($bf867534dd4b0308$var$isItemUnhideAction(lastDragAndDropAction)) {
            const label = lastDragAndDropAction.draggedMenuItemLabel || lastDragAndDropAction.draggedMenuItemId;
            const element = elementRegistry.getL1ItemElement(lastDragAndDropAction.draggedMenuItemId);
            if (element) {
                // Flash the moved item
                (0, $exQoy.triggerPostMoveFlash)(element);
                // Focus the moved item if move was triggered by keyboard
                if (lastDragAndDropAction.trigger === 'keyboard') // Per Atlaskit team, .focus() seems to be more reliable in the next task when used with VoiceOver
                setTimeout(()=>element.focus());
                // Announce the move for assistive technology users
                $iANmu.announce(intl.formatMessage((0, $k8RPh.messages).a11yAnnouncementItemUnhidden, {
                    label: label,
                    finishIndex: lastDragAndDropAction.finishIndex + 1
                }));
                // Fire analytics event
                fireDraggedSideNavItemEvent(lastDragAndDropAction.draggedMenuItemId, false);
            }
            return;
        }
        if ($bf867534dd4b0308$var$isItemVisibleAction(lastDragAndDropAction)) {
            const label = lastDragAndDropAction.draggedMenuItemLabel || lastDragAndDropAction.draggedMenuItemId;
            const moreMenuElement = elementRegistry.getMoreMenuElement();
            if (moreMenuElement) {
                // Announce the hide for assistive technology users
                $iANmu.announce(intl.formatMessage((0, $k8RPh.messages).a11yAnnouncementItemVisible, {
                    label: label
                }));
                // Fire analytics event
                fireDraggedSideNavItemEvent(lastDragAndDropAction.draggedMenuItemId, false);
            }
        }
    // Intentional omission of `fireDraggedSideNavItemEvent` from dependencies to avoid firing twice
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        elementRegistry,
        intl,
        lastDragAndDropAction
    ]);
    return {
        dragAndDropSave: dragAndDropSave
    };
}
function $bf867534dd4b0308$var$isItemReorderAction(action) {
    return action.type === 'item-reorder';
}
function $bf867534dd4b0308$var$isItemHideAction(action) {
    return action.type === 'item-hide';
}
function $bf867534dd4b0308$var$isItemUnhideAction(action) {
    return action.type === 'item-unhide';
}
function $bf867534dd4b0308$var$isItemVisibleAction(action) {
    return action.type === 'item-visible';
}

});
parcelRegister("iANmu", function(module, exports) {
$parcel$export(module.exports, "announce", () => $c82acd73071bd4ae$export$a9b970dcc4ae71a9);
$parcel$export(module.exports, "cleanup", () => $c82acd73071bd4ae$export$de863c629cb9919d);

let $c82acd73071bd4ae$var$node = null;
const $c82acd73071bd4ae$var$size = '1px';
const $c82acd73071bd4ae$var$visuallyHiddenStyles = {
    // Standard visually hidden styles.
    // Copied from our VisuallyHidden (react) package.
    width: $c82acd73071bd4ae$var$size,
    height: $c82acd73071bd4ae$var$size,
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: `rect(${$c82acd73071bd4ae$var$size}, ${$c82acd73071bd4ae$var$size}, ${$c82acd73071bd4ae$var$size}, ${$c82acd73071bd4ae$var$size})`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    // Pulling upwards slightly to prevent the page
    // from growing when appended to a body that contains
    // an element with height:100%
    marginTop: `-${$c82acd73071bd4ae$var$size}`,
    // Just being safe and letting this element not interfere with hitboxes
    pointerEvents: 'none'
};
/**
 * Creates a live region node, appends it to the body, and returns it.
 */ function $c82acd73071bd4ae$var$createNode() {
    const node = document.createElement('div');
    /**
	 * Using `role="status"` instead of `role="alert"` so that the message
	 * can be queued and read when able.
	 *
	 * We found with `role="alert"` the message was not reliably read when
	 * focus changed.
	 */ node.setAttribute('role', 'status');
    Object.assign(node.style, $c82acd73071bd4ae$var$visuallyHiddenStyles);
    document.body.append(node);
    return node;
}
/**
 * Returns the live region node, creating one if necessary.
 */ function $c82acd73071bd4ae$var$getNode() {
    if ($c82acd73071bd4ae$var$node === null) $c82acd73071bd4ae$var$node = $c82acd73071bd4ae$var$createNode();
    return $c82acd73071bd4ae$var$node;
}
let $c82acd73071bd4ae$var$timerId = null;
function $c82acd73071bd4ae$var$tryClearTimer() {
    if ($c82acd73071bd4ae$var$timerId !== null) clearTimeout($c82acd73071bd4ae$var$timerId);
    $c82acd73071bd4ae$var$timerId = null;
}
function $c82acd73071bd4ae$export$a9b970dcc4ae71a9(message) {
    /**
	 * Calling this immediately to ensure a node exists and has time to be parsed
	 * and exposed in the accessibility tree.
	 */ $c82acd73071bd4ae$var$getNode();
    /**
	 * Updating the message in a timeout so that it's less likely to be interrupted.
	 *
	 * This function is often called right before focus changes,
	 * because the user has just taken an action.
	 * This focus change would often cause the message to be skipped / interrupted.
	 */ $c82acd73071bd4ae$var$tryClearTimer();
    $c82acd73071bd4ae$var$timerId = setTimeout(()=>{
        $c82acd73071bd4ae$var$timerId = null;
        const node = $c82acd73071bd4ae$var$getNode();
        node.textContent = message;
    }, (0, $69d1f0e9547333fc$export$a88f30567ea7367a));
    return;
}
function $c82acd73071bd4ae$export$de863c629cb9919d() {
    $c82acd73071bd4ae$var$tryClearTimer();
    $c82acd73071bd4ae$var$node?.remove();
    $c82acd73071bd4ae$var$node = null;
}

});
/**
 * Delay until the text content of the live region is updated.
 *
 * This value was reached through some experimentation, and may need tweaking in the future.
 */ const $69d1f0e9547333fc$export$a88f30567ea7367a = 1000;


parcelRegister("k8RPh", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fbd271f1db798759$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fbd271f1db798759$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    a11yAnnouncementItemHidden: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden',
        defaultMessage: 'The top level menu item {label} has been hidden and moved to the More menu.',
        description: 'Announcement for assistive technology users when a top level menu item is hidden in the global side navigation.'
    },
    a11yAnnouncementItemUnhidden: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-unhidden',
        defaultMessage: 'The top level menu item {label} has been unhidden and moved from the more menu to position {finishIndex}.',
        description: 'Announcement for assistive technology users when a top level menu item is unhidden in the global side navigation.'
    },
    a11yAnnouncementItemReordered: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered',
        defaultMessage: 'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.',
        description: 'Announcement for assistive technology users when a top level menu item is reordered in the global side navigation.'
    },
    a11yAnnouncementItemVisible: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-visible',
        defaultMessage: 'The top level menu item {label} has been moved from the More menu to the visible items.',
        description: 'Announcement for assistive technology users when a top level menu item is made visible in the global side navigation.'
    }
});

});


const $246d5d85b4a306e7$export$5678faf50a8e9276 = 'global-side-nav-test-id';
const $246d5d85b4a306e7$export$88dd4a9e4ffa4ec2 = 'gsn-peek';
const $246d5d85b4a306e7$export$ee2a9579670b9420 = 'gsn-global-shortcuts';

parcelRegister("iNJuq", function(module, exports) {
$parcel$export(module.exports, "GSNSideNavigationLayout", () => $61098f2427d4c962$export$5c53281b43e13144);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $eGOwo = parcelRequire("eGOwo");

var $aIjmF = parcelRequire("aIjmF");

var $4tnUQ = parcelRequire("4tnUQ");

var $7x2ih = parcelRequire("7x2ih");

var $5CAP8 = parcelRequire("5CAP8");

var $99jJ7 = parcelRequire("99jJ7");

var $lmbOW = parcelRequire("lmbOW");

var $2jGY5 = parcelRequire("2jGY5");

var $15IDJ = parcelRequire("15IDJ");

var $jeFSI = parcelRequire("jeFSI");
function $61098f2427d4c962$export$5c53281b43e13144(props) {
    const { setUserSideNavData: setUserSideNavData } = (0, $2jGY5.useUserSideNavDataStore)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $15IDJ.SideNavVisibilityProvider), {
        setUserSideNavData: setUserSideNavData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($61098f2427d4c962$var$GSNLayoutComponent, {
            ...props
        })
    });
}
function $61098f2427d4c962$var$GSNLayoutComponent({ preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId }) {
    const { fireEvent: fireEvent } = (0, $4tnUQ.useAnalyticsEvents)();
    const { userSideNavData: userSideNavData } = (0, $2jGY5.useUserSideNavDataStore)();
    const { onCollapse: onCollapse, onExpand: onExpand, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = (0, $15IDJ.useSideNavVisibility)();
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $lmbOW.useOptions)();
    const sideNavContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const scrollDirection = (0, $99jJ7.default)(sideNavContentRef);
    const { isInViewport: isInViewport } = (0, $7x2ih.useInViewport)({
        ref: sideNavContentRef,
        rootMargin: '0px'
    });
    const { fireViewedSideNavEvent: fireViewedSideNavEvent } = (0, $5CAP8.useNavAnalytics)();
    (0, $eJOHy.useEffect)(()=>{
        if (scrollDirection) fireEvent('ui.sideNav.scrolled.sideNavMenu', {
            scrollDirection: scrollDirection
        });
    }, [
        fireEvent,
        scrollDirection
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!l1DragAndDropEnabled) return;
        const scrollable = sideNavContentRef.current;
        (0, $8GOss.default)(scrollable, 'sideNavContentRef must be set');
        return (0, $aIjmF.autoScrollForElements)({
            element: scrollable,
            canScroll: ({ source: source })=>source.data.type === 'menu-item'
        });
    }, [
        l1DragAndDropEnabled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isInViewport && (0, $eGOwo.fg)('NAVX-2558-fix-sidenav-viewed-event')) fireViewedSideNavEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInViewport
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jeFSI.SideNavigationLayout), {
        testId: testId,
        onExpand: onExpand,
        onCollapse: onCollapse,
        defaultWidth: userSideNavData.defaultWidth,
        defaultCollapsed: userSideNavData.defaultCollapsed,
        sideNavContentRef: sideNavContentRef,
        preMainElem: preMainElem,
        postMainElem: postMainElem,
        onResizeEnd: onResizeEnd,
        onResizeStart: onResizeStart,
        bottomElem: bottomElem,
        children: children
    });
}

});
parcelRegister("aIjmF", function(module, exports) {
$parcel$export(module.exports, "autoScrollForElements", () => $c0447705cceebafd$export$4b66ee8317094cdb);
$parcel$export(module.exports, "autoScrollWindowForElements", () => $c0447705cceebafd$export$c9168f41de61f525);

var $bGx3v = parcelRequire("bGx3v");

var $e5OX3 = parcelRequire("e5OX3");
const $c0447705cceebafd$var$api = (0, $e5OX3.makeApi)({
    monitor: (0, $bGx3v.monitorForElements)
});
const $c0447705cceebafd$export$4b66ee8317094cdb = $c0447705cceebafd$var$api.autoScroll;
const $c0447705cceebafd$export$c9168f41de61f525 = $c0447705cceebafd$var$api.autoScrollWindow;

});
parcelRegister("e5OX3", function(module, exports) {
$parcel$export(module.exports, "makeApi", () => $24eab05605d213de$export$b8fa21320a811083);

var $dROq6 = parcelRequire("dROq6");
parcelRequire("hOCz6");
var $6Z6g4 = parcelRequire("6Z6g4");

var $fftUG = parcelRequire("fftUG");

var $3P3tr = parcelRequire("3P3tr");

var $9j2mN = parcelRequire("9j2mN");
function $24eab05605d213de$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $dROq6.combine)((0, $3P3tr.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $6Z6g4.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $6Z6g4.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $9j2mN.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $fftUG.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("hOCz6", function(module, exports) {
$parcel$export(module.exports, "once", () => (parcelRequire("6Z6g4")).once);

var $6Z6g4 = parcelRequire("6Z6g4");

});

parcelRegister("fftUG", function(module, exports) {
$parcel$export(module.exports, "getScheduler", () => $d1030e6e1449d633$export$5cff7ac265db316a);
parcelRequire("9QxkX");
var $eNpGE = parcelRequire("eNpGE");

var $c9EXM = parcelRequire("c9EXM");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $d1030e6e1449d633$var$schedulers = new Map();
function $d1030e6e1449d633$export$5cff7ac265db316a(monitor) {
    const scheduler = $d1030e6e1449d633$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $d1030e6e1449d633$var$makeScheduler(monitor);
    $d1030e6e1449d633$var$schedulers.set(monitor, created);
    return created;
}
function $d1030e6e1449d633$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $eNpGE.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $c9EXM.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $c9EXM.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("9QxkX", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("eNpGE")).getElementFromPointWithoutHoneypot);

var $eNpGE = parcelRequire("eNpGE");

});

parcelRegister("c9EXM", function(module, exports) {
$parcel$export(module.exports, "markAndGetEngagement", () => $a23e9e6251c2c7ae$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $a23e9e6251c2c7ae$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $a23e9e6251c2c7ae$export$13ae770ed39b71ea);
const $a23e9e6251c2c7ae$var$ledger = new Map();
const $a23e9e6251c2c7ae$var$requested = new Set();
function $a23e9e6251c2c7ae$export$8c764c3f2fc3d2d2(element) {
    $a23e9e6251c2c7ae$export$1cb7cbb266b6f6fa(element);
    const entry = $a23e9e6251c2c7ae$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $a23e9e6251c2c7ae$var$ledger.set(element, fresh);
    return fresh;
}
function $a23e9e6251c2c7ae$export$1cb7cbb266b6f6fa(element) {
    $a23e9e6251c2c7ae$var$requested.add(element);
}
function $a23e9e6251c2c7ae$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $a23e9e6251c2c7ae$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $a23e9e6251c2c7ae$var$ledger.forEach((_, element)=>{
        if (!$a23e9e6251c2c7ae$var$requested.has(element)) $a23e9e6251c2c7ae$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $a23e9e6251c2c7ae$var$requested.clear();
}
function $a23e9e6251c2c7ae$export$13ae770ed39b71ea() {
    $a23e9e6251c2c7ae$var$ledger.clear();
}

});


parcelRegister("3P3tr", function(module, exports) {
$parcel$export(module.exports, "selector", () => $f6a1f9b48cb20ee6$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $f6a1f9b48cb20ee6$export$4ec12fb57dfebd53);
const $f6a1f9b48cb20ee6$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $f6a1f9b48cb20ee6$export$aea217a45095ce11 = `[${$f6a1f9b48cb20ee6$export$4b152ab55cad4fd6}="true"]`;
function $f6a1f9b48cb20ee6$export$4ec12fb57dfebd53(element) {
    element.setAttribute($f6a1f9b48cb20ee6$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($f6a1f9b48cb20ee6$export$4b152ab55cad4fd6);
}

});

parcelRegister("9j2mN", function(module, exports) {
$parcel$export(module.exports, "tryScroll", () => $2b6fd94ad307d6a1$export$233199807749476d);

var $lmVE7 = parcelRequire("lmVE7");

var $c9EXM = parcelRequire("c9EXM");

var $3P3tr = parcelRequire("3P3tr");

var $qLxmx = parcelRequire("qLxmx");
function $2b6fd94ad307d6a1$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $2b6fd94ad307d6a1$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$2b6fd94ad307d6a1$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $3P3tr.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $2b6fd94ad307d6a1$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $c9EXM.markAndGetEngagement)(element);
    const config = (0, $lmVE7.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $qLxmx.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $2b6fd94ad307d6a1$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $c9EXM.markAndGetEngagement)(element);
        const config = (0, $lmVE7.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $qLxmx.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $2b6fd94ad307d6a1$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $2b6fd94ad307d6a1$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$2b6fd94ad307d6a1$var$isScrollingAvailable(remainder)) return;
    $2b6fd94ad307d6a1$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("lmVE7", function(module, exports) {
$parcel$export(module.exports, "getInternalConfig", () => $38982e7d63c9dd3e$export$e96028ec7ff9d079);
const $38982e7d63c9dd3e$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $38982e7d63c9dd3e$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $38982e7d63c9dd3e$export$e96028ec7ff9d079(provided) {
    return {
        ...$38982e7d63c9dd3e$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $38982e7d63c9dd3e$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("qLxmx", function(module, exports) {
$parcel$export(module.exports, "getScrollBy", () => $3bdf57893fa68d93$export$6cfa6dfe6898b98f);

var $iztXk = parcelRequire("iztXk");

var $b7xcZ = parcelRequire("b7xcZ");

var $jzhbx = parcelRequire("jzhbx");

var $dii7x = parcelRequire("dii7x");

var $5o9jp = parcelRequire("5o9jp");

var $9zUln = parcelRequire("9zUln");
function $3bdf57893fa68d93$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $3bdf57893fa68d93$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $3bdf57893fa68d93$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $b7xcZ.edges).reduce((map, edge)=>{
        const hitbox = (0, $jzhbx.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $b7xcZ.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $5o9jp.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $9zUln.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $iztXk.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $dii7x.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $dii7x.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $dii7x.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $dii7x.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("iztXk", function(module, exports) {
$parcel$export(module.exports, "canScrollOnEdge", () => $c53a7e6dbe56d62b$export$ccd6d9407403fcad);
const $c53a7e6dbe56d62b$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("b7xcZ", function(module, exports) {
$parcel$export(module.exports, "edges", () => $182654dd0a611870$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $182654dd0a611870$export$7fc144124ccf8292);
const $182654dd0a611870$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $182654dd0a611870$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("jzhbx", function(module, exports) {
$parcel$export(module.exports, "getOverElementHitbox", () => $265697c1b551eb64$export$b9a449c20abb0e9);

var $eodmz = parcelRequire("eodmz");

var $8RSm7 = parcelRequire("8RSm7");
function $265697c1b551eb64$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $eodmz.axisLookup)[axis];
        const side = (0, $8RSm7.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $265697c1b551eb64$export$b9a449c20abb0e9 = {
    top: $265697c1b551eb64$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $265697c1b551eb64$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $265697c1b551eb64$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $265697c1b551eb64$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("eodmz", function(module, exports) {
$parcel$export(module.exports, "axisLookup", () => $df627247da8c4728$export$42e42cdab35a2b96);
const $df627247da8c4728$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $df627247da8c4728$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $df627247da8c4728$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $df627247da8c4728$var$vertical,
        crossAxis: $df627247da8c4728$var$horizontal
    },
    horizontal: {
        mainAxis: $df627247da8c4728$var$horizontal,
        crossAxis: $df627247da8c4728$var$vertical
    }
};

});

parcelRegister("8RSm7", function(module, exports) {
$parcel$export(module.exports, "mainAxisSideLookup", () => $35cf3d4ff0f87f72$export$a45c0cd714a4dbaa);
const $35cf3d4ff0f87f72$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("dii7x", function(module, exports) {
$parcel$export(module.exports, "getScrollChange", () => $4c3d9a9aa81f4c30$export$470a2ff46db8cee8);

var $eodmz = parcelRequire("eodmz");

var $1NJXT = parcelRequire("1NJXT");

var $8RSm7 = parcelRequire("8RSm7");
// We want a consistent scroll speed across devices, regardless of framerate
function $4c3d9a9aa81f4c30$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $4c3d9a9aa81f4c30$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $eodmz.axisLookup)[axis];
    const side = (0, $8RSm7.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $1NJXT.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $1NJXT.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $4c3d9a9aa81f4c30$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $4c3d9a9aa81f4c30$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $4c3d9a9aa81f4c30$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $1NJXT.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $8RSm7.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("1NJXT", function(module, exports) {
$parcel$export(module.exports, "getPercentageInRange", () => $f33af4a0dbb2125f$export$1a29de000a332d74);
function $f33af4a0dbb2125f$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("5o9jp", function(module, exports) {
$parcel$export(module.exports, "isAxisAllowed", () => $b5693d0276cf297b$export$7120fdbd90bd1292);
function $b5693d0276cf297b$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("9zUln", function(module, exports) {
$parcel$export(module.exports, "isWithin", () => $d50ffa5fc30325d7$export$cda7a9d4399bf2e3);
function $d50ffa5fc30325d7$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("7x2ih", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $65f7ab777a0e5eb9$export$6215040b989f9b0f);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $65f7ab777a0e5eb9$export$6215040b989f9b0f = ({ ref: ref, rootMargin: rootMargin = '0px 0px 200px 0px' })=>{
    const [isInViewport, setIsInViewport] = (0, $eJOHy.useState)(false);
    const observer = (0, $eJOHy.useMemo)(()=>new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting && !(0, $eGOwo.fg)('NAVX-2558-fix-sidenav-viewed-event')) setIsInViewport(entry.isIntersecting);
            setIsInViewport(entry.isIntersecting);
        }, {
            rootMargin: rootMargin
        }), [
        rootMargin
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (ref.current) {
            observer.observe(ref.current);
            return ()=>observer.disconnect();
        }
    }, [
        observer,
        ref
    ]);
    return {
        isInViewport: isInViewport
    };
};

});

parcelRegister("99jJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d84aeb45d854653$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $3s8bj = parcelRequire("3s8bj");
const $7d84aeb45d854653$var$DEBOUNCE_DURATION = 50;
const $7d84aeb45d854653$var$MIN_SCROLL_OFFSET = 0;
function $7d84aeb45d854653$export$2e2bcd8739ae039(ref) {
    const lastScrollY = (0, $eJOHy.useRef)(0);
    const [scrollDirection, setScrollDirection] = (0, $eJOHy.useState)(undefined);
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>x + 1, 0);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const onScroll = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            const scrollY = ref.current.scrollTop;
            const direction = scrollY > lastScrollY.current ? 'down' : 'up';
            if (scrollY - lastScrollY.current > $7d84aeb45d854653$var$MIN_SCROLL_OFFSET || scrollY - lastScrollY.current < -1 * $7d84aeb45d854653$var$MIN_SCROLL_OFFSET) {
                // Force an update to ensure the component re-triggers the event
                if (direction === scrollDirection) forceUpdate();
                else setScrollDirection(direction);
            }
            lastScrollY.current = scrollY > 0 ? scrollY : 0;
        }, $7d84aeb45d854653$var$DEBOUNCE_DURATION);
        // Bind returns an unbind function, which we can use to clean up the event listener
        // when the component unmounts or ref changes.
        return (0, $4eDgu.bind)(ref.current, {
            type: 'scroll',
            listener: onScroll,
            options: {
                capture: true
            }
        });
    }, [
        ref,
        scrollDirection
    ]);
    return scrollDirection;
}

});

parcelRegister("15IDJ", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibility", () => $8728172d06ee3833$export$4a602ad7e09bdb2c);
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $8728172d06ee3833$export$aac8e996360f6ad9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $4tnUQ = parcelRequire("4tnUQ");
const $8728172d06ee3833$export$afc6d5ca319092bd = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8728172d06ee3833$export$4a602ad7e09bdb2c = ()=>{
    const context = (0, $eJOHy.useContext)($8728172d06ee3833$export$afc6d5ca319092bd);
    (0, $8GOss.default)(context, 'useSideNavVisibility must be used within an SideNavVisibilityProvider');
    return context;
};
function $8728172d06ee3833$export$aac8e996360f6ad9({ children: children, onCollapse: onCollapse, onExpand: onExpand, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, setUserSideNavData: setUserSideNavData }) {
    const { fireEvent: fireEvent } = (0, $4tnUQ.useAnalyticsEvents)();
    const onCollapseHandler = (0, $eJOHy.useCallback)((args)=>{
        fireEvent('ui.sideNav.collapsed', {
            ...args
        });
        setUserSideNavData({
            defaultCollapsed: true
        });
        onCollapse?.(args);
    }, [
        fireEvent,
        onCollapse,
        setUserSideNavData
    ]);
    const onExpandHandler = (0, $eJOHy.useCallback)((args)=>{
        fireEvent('ui.sideNav.expanded', {
            ...args
        });
        setUserSideNavData({
            defaultCollapsed: false
        });
        onExpand?.(args);
    }, [
        fireEvent,
        onExpand,
        setUserSideNavData
    ]);
    const onResizeStartHandler = (0, $eJOHy.useCallback)((args)=>{
        fireEvent('ui.sideNav.resizeStart', {
            ...args
        });
        onResizeStart?.(args);
    }, [
        fireEvent,
        onResizeStart
    ]);
    const onResizeEndHandler = (0, $eJOHy.useCallback)((args)=>{
        fireEvent('ui.sideNav.resizeEnd', {
            ...args
        });
        setUserSideNavData({
            defaultWidth: args.finalWidth
        });
        onResizeEnd?.(args);
    }, [
        fireEvent,
        onResizeEnd,
        setUserSideNavData
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($8728172d06ee3833$export$afc6d5ca319092bd.Provider, {
        value: {
            onExpand: onExpandHandler,
            onCollapse: onCollapseHandler,
            onResizeEnd: onResizeEndHandler,
            onResizeStart: onResizeStartHandler
        },
        children: children
    });
}

});

parcelRegister("jeFSI", function(module, exports) {
$parcel$export(module.exports, "SideNavigationLayout", () => $737f3e88425a3639$export$610d5f09b69fac71);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $2bY1m = parcelRequire("2bY1m");
var $9Qwez = parcelRequire("9Qwez");
var $7tCmu = parcelRequire("7tCmu");
var $jiT3G = parcelRequire("jiT3G");
var $j5kZH = parcelRequire("j5kZH");
var $8Pd1v = parcelRequire("8Pd1v");

var $4Akzk = parcelRequire("4Akzk");

var $1B3Co = parcelRequire("1B3Co");
function $737f3e88425a3639$export$610d5f09b69fac71(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Akzk.AsyncIntlProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($737f3e88425a3639$var$BaseLayout, {
            ...props
        })
    });
}
function $737f3e88425a3639$var$BaseLayout({ preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId, onExpand: onExpand, onCollapse: onCollapse, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, defaultWidth: defaultWidth, defaultCollapsed: defaultCollapsed, sideNavContentRef: sideNavContentRef }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9Qwez.SideNav), {
        testId: testId,
        onExpand: onExpand,
        onCollapse: onCollapse,
        defaultWidth: defaultWidth,
        defaultCollapsed: defaultCollapsed,
        children: [
            preMainElem && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j5kZH.SideNavHeader), {
                children: preMainElem
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7tCmu.SideNavContent), {
                ref: sideNavContentRef,
                children: [
                    children,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Pd1v.TopLevelSpacer), {}),
                    postMainElem
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bY1m.PanelSplitter), {
                onResizeEnd: onResizeEnd,
                onResizeStart: onResizeStart,
                label: formatMessage((0, $1B3Co.messages).panelSplitterLabel)
            }),
            bottomElem && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jiT3G.SideNavFooter), {
                children: bottomElem
            })
        ]
    });
}

});
parcelRegister("1B3Co", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8d18ddda8ccfe00e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8d18ddda8ccfe00e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    panelSplitterLabel: {
        id: 'navigation.global-side-navigation.panel-splitter.label',
        description: 'The accessible label for the panel splitter. Visually hidden but read by screen readers.',
        defaultMessage: 'Resize panel'
    }
});

});



parcelRegister("1WX9Q", function(module, exports) {
$parcel$export(module.exports, "PostMainItems", () => $b36d72c916d174d2$export$b540acb5f181a91e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $85fS3 = parcelRequire("85fS3");

var $8nu6j = parcelRequire("8nu6j");

var $dW738 = parcelRequire("dW738");

var $6z6fG = parcelRequire("6z6fG");

var $clIFu = parcelRequire("clIFu");

var $fAGv6 = parcelRequire("fAGv6");
var $bAl6v = parcelRequire("bAl6v");

var $1ELDp = parcelRequire("1ELDp");

var $7x2ih = parcelRequire("7x2ih");

var $5CAP8 = parcelRequire("5CAP8");

var $lwkX3 = parcelRequire("lwkX3");

var $lmbOW = parcelRequire("lmbOW");

var $8xJnH = parcelRequire("8xJnH");

var $10yIH = parcelRequire("10yIH");

var $7Rbog = parcelRequire("7Rbog");


var $1YKA7 = parcelRequire("1YKA7");

var $eO1Aq = parcelRequire("eO1Aq");

var $8OpJw = parcelRequire("8OpJw");

var $ehQS0 = parcelRequire("ehQS0");
function $b36d72c916d174d2$export$b540acb5f181a91e({ postItemsElem: postItemsElem, postMainElem: postMainElem, draggingL1Group: draggingL1Group = null, openShortcutsInSameTab: openShortcutsInSameTab }) {
    const { appLabel: appLabel, disableMenuCustomization: disableMenuCustomization, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $lmbOW.useOptions)();
    const { allItems: allItems, growthItemShortcuts: growthItemShortcuts, shortcuts: shortcuts } = (0, $lwkX3.useItemsAndShortcuts)();
    const peekMenuId = (0, $8xJnH.usePeekMenuId)();
    const { hiddenItemMenuIds: hiddenItemMenuIds, hiddenShortcutMenuIds: hiddenShortcutMenuIds, visibleShortcutMenuIds: visibleShortcutMenuIds, hiddenMenuIds: hiddenMenuIds } = (0, $7Rbog.useUserMenuDataShapes)();
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $5CAP8.useNavAnalytics)();
    const containerRef = (0, $eJOHy.useRef)(null);
    const { isInViewport: isInViewport } = (0, $7x2ih.useInViewport)({
        ref: containerRef
    });
    const { shortcutsWithMenuId: shortcutsWithMenuId } = (0, $10yIH.useGlobalShortcutsTransformation)({
        shortcutsConfig: shortcuts,
        visibleShortcuts: visibleShortcutMenuIds,
        growthShortcutsConfig: growthItemShortcuts
    });
    const { groupDropIndicatorRef: groupDropIndicatorRef, dragSource: dragSource } = (0, $bAl6v.useL1DragState)({
        l1DragAndDropEnabled: l1DragAndDropEnabled
    });
    const handleClickMoreMenuItem = (0, $eJOHy.useCallback)(()=>{
        fireClickedSideNavItemEvent((0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).more, 'postMain');
    }, [
        fireClickedSideNavItemEvent
    ]);
    const handleClickCustomizeItem = (0, $eJOHy.useCallback)(()=>{
        fireClickedSideNavItemEvent((0, $eO1Aq.INTERNAL_GLOBAL_ITEMS).customize, 'postMain');
    }, [
        fireClickedSideNavItemEvent
    ]);
    const peekItem = !!peekMenuId && hiddenItemMenuIds.includes(peekMenuId) && allItems[peekMenuId];
    const isDragSourceHidden = dragSource && hiddenMenuIds.includes(dragSource);
    const moreMenu = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1YKA7.default), {
        items: allItems,
        shortcutItems: shortcuts,
        itemIds: hiddenItemMenuIds,
        shortcutItemIds: hiddenShortcutMenuIds,
        appLabel: appLabel,
        onClickMoreMenuTrigger: handleClickMoreMenuItem,
        onClickCustomizeSidebarMenuItem: handleClickCustomizeItem,
        openShortcutsInSameTab: openShortcutsInSameTab
    });
    const globalAppShortcuts = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.Box), {
        ref: containerRef,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($b36d72c916d174d2$var$GlobalAppShortcuts, {
            shortcutItems: shortcutsWithMenuId,
            isInViewport: isInViewport,
            openShortcutsInSameTab: openShortcutsInSameTab
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
        space: "space.100",
        children: [
            postItemsElem,
            !!shortcutsWithMenuId.length && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fAGv6.GroupDropIndicatorWithDragOver), {
                ref: groupDropIndicatorRef,
                isActive: draggingL1Group === (0, $clIFu.L1_MENU_GROUPS).SHORTCUTS,
                children: globalAppShortcuts
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                children: globalAppShortcuts
            })),
            peekItem && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $85fS3.MenuList), {
                testId: (0, $246d5d85b4a306e7$export$88dd4a9e4ffa4ec2),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ELDp.default), {
                    id: peekMenuId,
                    item: peekItem,
                    isInMoreMenu: true,
                    peek: true
                }, peekMenuId)
            }),
            !disableMenuCustomization && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fAGv6.GroupDropIndicatorWithDragOver), {
                ref: groupDropIndicatorRef,
                isActive: !!draggingL1Group,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.Box), {
                        xcss: (0, $6qaBj.cx)(!!draggingL1Group ? $b36d72c916d174d2$var$styles.hidden : $b36d72c916d174d2$var$styles.visible),
                        children: moreMenu
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.Box), {
                        xcss: (0, $6qaBj.cx)(!!draggingL1Group ? $b36d72c916d174d2$var$styles.visible : $b36d72c916d174d2$var$styles.hidden),
                        children: isDragSourceHidden ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ehQS0.ShowInSidebarButton), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8OpJw.HideFromSidebarButton), {})
                    })
                ]
            }) : moreMenu),
            postMainElem
        ]
    });
}
const $b36d72c916d174d2$var$styles = {
    visible: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
function $b36d72c916d174d2$var$GlobalAppShortcuts({ isInViewport: isInViewport, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItems: shortcutItems }) {
    const { app: app, cloudId: cloudId, userId: userId, orgId: orgId, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $lmbOW.useOptions)();
    const { fireViewedShortcutsEvent: fireViewedShortcutsEvent } = (0, $5CAP8.useNavAnalytics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isInViewport) fireViewedShortcutsEvent(shortcutItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInViewport
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6z6fG.GlobalShortcuts), {
        promoteSite: true,
        orgId: orgId,
        cloudId: cloudId,
        userId: userId,
        product: app,
        forceStatic: true,
        testId: (0, $246d5d85b4a306e7$export$ee2a9579670b9420),
        shortcutItems: shortcutItems,
        enableDragAndDrop: l1DragAndDropEnabled,
        openInSameTab: openShortcutsInSameTab
    });
}

});
parcelRegister("10yIH", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsTransformation", () => $abe8b26e56d82e82$export$9ef62ebfdd487c3d);

var $eJOHy = parcelRequire("eJOHy");

var $5CAP8 = parcelRequire("5CAP8");
const $abe8b26e56d82e82$export$9ef62ebfdd487c3d = ({ shortcutsConfig: shortcutsConfig, growthShortcutsConfig: growthShortcutsConfig, visibleShortcuts: visibleShortcuts })=>{
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent, fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent } = (0, $5CAP8.useNavAnalytics)();
    // 1. Filter the shortcut config based on visible menu items
    const shortcutsWithMenuId = (0, $eJOHy.useMemo)(()=>{
        const availableShortcuts = visibleShortcuts.reduce((acc, id)=>{
            const shortcut = shortcutsConfig?.[id];
            if (shortcut) acc.push({
                menuItemId: id,
                ...shortcut
            });
            return acc;
        }, []);
        if (growthShortcutsConfig) availableShortcuts.push(...Object.entries(growthShortcutsConfig).map(([id, shortcut])=>({
                menuItemId: id,
                ...shortcut
            })));
        return availableShortcuts.map((shortcut)=>({
                ...shortcut,
                onClick: ()=>{
                    shortcut.onClick?.();
                    fireClickedSideNavItemEvent(shortcut.menuItemId, 'postMain');
                    if (shortcut.type === 'expand') fireViewedSideNavSubMenuEvent(shortcut.menuItemId, undefined, false, 'postMain');
                },
                ...shortcut.type === 'link' && {
                    onRightClick: ()=>{
                        shortcut.onRightClick?.();
                        fireClickedSideNavItemEvent(shortcut.menuItemId, 'postMain', true);
                    }
                },
                // Fire analytics event for L2 items
                ...shortcut.type === 'expand' && {
                    items: shortcut.items?.map((subItem)=>({
                            ...subItem,
                            onClick: ()=>{
                                subItem.onClick?.();
                                fireClickedSideNavSubMenuItemEvent(shortcut.menuItemId, undefined, false, false, 'postMain');
                            },
                            onRightClick: ()=>{
                                subItem.onRightClick?.();
                                fireClickedSideNavSubMenuItemEvent(shortcut.menuItemId, undefined, false, true, 'postMain');
                            }
                        }))
                }
            }));
    }, [
        visibleShortcuts,
        growthShortcutsConfig,
        shortcutsConfig,
        fireClickedSideNavItemEvent,
        fireViewedSideNavSubMenuEvent,
        fireClickedSideNavSubMenuItemEvent
    ]);
    return {
        shortcuts: shortcutsWithMenuId.map(({ menuItemId: menuItemId, ...shortcut })=>shortcut),
        shortcutsWithMenuId: shortcutsWithMenuId
    };
};

});

parcelRegister("1YKA7", function(module, exports) {
$parcel$export(module.exports, "default", () => $7957efea05d7a135$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $85fS3 = parcelRequire("85fS3");

var $8LmbL = parcelRequire("8LmbL");

var $8xJnH = parcelRequire("8xJnH");

var $eO1Aq = parcelRequire("eO1Aq");

var $kSxpF = parcelRequire("kSxpF");

var $8qwyT = parcelRequire("8qwyT");

var $ekEmA = parcelRequire("ekEmA");
function $7957efea05d7a135$export$2e2bcd8739ae039({ items: items, shortcutItems: shortcutItems = {}, itemIds: itemIds, shortcutItemIds: shortcutItemIds, appLabel: appLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger, onClickCustomizeSidebarMenuItem: onClickCustomizeSidebarMenuItem, openShortcutsInSameTab: openShortcutsInSameTab }) {
    const peekMenuId = (0, $8xJnH.usePeekMenuId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const menuItemComponent = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ closeMenu: closeMenu, menuId: menuId })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ekEmA.default), {
            id: menuId,
            items: items,
            shortcutItems: shortcutItems,
            onClick: closeMenu,
            openShortcutsInSameTab: openShortcutsInSameTab
        }, menuId);
    }, [
        items,
        shortcutItems,
        openShortcutsInSameTab
    ]);
    const productItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return itemIds.map((menuId)=>({
                menuId: menuId,
                visible: false
            }));
    }, [
        itemIds
    ]);
    const appItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return shortcutItemIds.map((menuId)=>({
                menuId: menuId,
                visible: false
            }));
    }, [
        shortcutItemIds
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $85fS3.MenuList), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8LmbL.GlobalMoreMenu), {
            productItemsData: productItemsData,
            appItemsData: appItemsData,
            menuItemComponent: menuItemComponent,
            customizeSidebarMenuItem: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kSxpF.CustomizeSidebarMenuItem), {
                items: items,
                shortcuts: shortcutItems,
                testId: (0, $eO1Aq.CUSTOMIZE_SIDEBAR_MENU_ITEM_TEST_ID),
                appLabel: appLabel,
                onClick: onClickCustomizeSidebarMenuItem
            }),
            moreMenuItemLabel: formatMessage((0, $8qwyT.messages).moreMenuLabel),
            peekingMenuIds: peekMenuId ? [
                peekMenuId
            ] : undefined,
            testId: (0, $eO1Aq.MORE_MENU_TEST_ID),
            onClickMoreMenuTrigger: onClickMoreMenuTrigger
        })
    });
}

});
parcelRegister("kSxpF", function(module, exports) {
$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $8cff14b25cf36292$export$b7fa0daee00ba08b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gyJTO = parcelRequire("gyJTO");

var $iiRWr = parcelRequire("iiRWr");

var $kKTZh = parcelRequire("kKTZh");

var $asoyU = parcelRequire("asoyU");

var $gGXs2 = parcelRequire("gGXs2");

var $4s2tx = parcelRequire("4s2tx");

var $7Rbog = parcelRequire("7Rbog");

var $1ovfy = parcelRequire("1ovfy");

var $gS5hu = parcelRequire("gS5hu");

var $h4LtA = parcelRequire("h4LtA");
const $8cff14b25cf36292$export$b7fa0daee00ba08b = /*#__PURE__*/ (0, $eJOHy.forwardRef)($8cff14b25cf36292$var$CustomizeSidebarMenuItemWithRef);
function $8cff14b25cf36292$var$CustomizeSidebarMenuItemWithRef({ appLabel: appLabel, items: items, onClick: onClick, returnFocusRef: returnFocusRef, shortcuts: shortcuts, testId: testId }, ref) {
    const getMenuIconAndLabel = (0, $h4LtA.useGetMenuIconAndLabel)(items, shortcuts);
    const { itemUserMenuData: itemUserMenuData, shortcutUserMenuData: shortcutUserMenuData } = (0, $7Rbog.useUserMenuDataShapes)();
    const itemExtendedUserMenuData = (0, $gGXs2.extendWithCustomizationOptions)(itemUserMenuData, items);
    const onSave = (0, $4s2tx.useOnSave)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $1ovfy.customizationModalEntryPoint),
        entryPointProps: {
            appLabel: appLabel,
            getMenuIconAndLabel: getMenuIconAndLabel,
            itemExtendedUserMenuData: itemExtendedUserMenuData,
            onSave: onSave,
            returnFocusRef: returnFocusRef,
            shortcutExtendedUserMenuData: shortcutUserMenuData
        },
        children: ({ ref: triggerRef })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
                elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iiRWr))), {
                    label: ""
                }),
                ref: (0, $gyJTO.default)([
                    triggerRef,
                    ref
                ]),
                testId: testId,
                onClick: onClick,
                children: formatMessage((0, $gS5hu.messages).customizeSidebarMenuItemLabel)
            })
    });
}

});
parcelRegister("gGXs2", function(module, exports) {
$parcel$export(module.exports, "extendWithCustomizationOptions", () => $76e78bddc4ab2a52$export$fc8975fe9e50b6c4);
function $76e78bddc4ab2a52$export$fc8975fe9e50b6c4(userMenuData, items) {
    return userMenuData.map((item)=>{
        const itemConfig = items[item.menuId];
        if (!itemConfig) return item;
        return {
            ...item,
            isNotCustomizable: itemConfig.isReorderable === false,
            isNotToggleable: itemConfig.isHideable === false
        };
    });
}

});

parcelRegister("4s2tx", function(module, exports) {
$parcel$export(module.exports, "useOnSave", () => $8b4198280faf7b44$export$ecbfe7cad2f40363);

var $eJOHy = parcelRequire("eJOHy");

var $7Rbog = parcelRequire("7Rbog");
const $8b4198280faf7b44$export$ecbfe7cad2f40363 = ()=>{
    const { setUserMenuData: setUserMenuData } = (0, $7Rbog.useUserMenuDataShapes)();
    return (0, $eJOHy.useCallback)(async (updatedItemExtendedUserMenuData, updatedShortcutExtendedUserMenuData)=>{
        // Put the data back together and remove extra properties
        const userMenuData = updatedItemExtendedUserMenuData.concat(updatedShortcutExtendedUserMenuData).map(({ menuId: menuId, visible: visible })=>({
                menuId: menuId,
                visible: visible
            }));
        setUserMenuData(userMenuData);
    }, [
        setUserMenuData
    ]);
};

});

parcelRegister("1ovfy", function(module, exports) {
$parcel$export(module.exports, "customizationModalEntryPoint", () => $86400ccc424022c9$export$ce0411fdea635705);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $86400ccc424022c9$export$ce0411fdea635705 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("aTQV4")).then(({ CustomizationModal: CustomizationModal })=>CustomizationModal), {
        moduleId: "b2e7e7c1",
        priority: "interaction",
        moduleId: 'navigation.global-side-navigation.customization-modal'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aTQV4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jJ1k5").then(()=>parcelRequire('9rNlY'));

});


parcelRegister("gS5hu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3510967205ba813e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3510967205ba813e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    customizeSidebarMenuItemLabel: {
        id: 'navigation.global-side-navigation.customize-sidebar-menu-item.label',
        description: 'Label on Customize button in the side navigation. Shows a modal with options to customize the sidebar.',
        defaultMessage: 'Customize sidebar'
    }
});

});

parcelRegister("h4LtA", function(module, exports) {
$parcel$export(module.exports, "useGetMenuIconAndLabel", () => $421f0413990aa576$export$946f6bdd4c4f6c7);

var $eJOHy = parcelRequire("eJOHy");

var $fikUm = parcelRequire("fikUm");
const $421f0413990aa576$export$946f6bdd4c4f6c7 = (items, shortcuts)=>(0, $eJOHy.useCallback)((menuId)=>(0, $fikUm.getMenuIconAndLabel)(items, shortcuts)(menuId), [
        items,
        shortcuts
    ]);

});
parcelRegister("fikUm", function(module, exports) {
$parcel$export(module.exports, "getMenuIconAndLabel", () => $4b8cc64c92ea90e7$export$5412ec86882b110d);
const $4b8cc64c92ea90e7$export$5412ec86882b110d = (items, shortcuts)=>(menuId)=>{
        const item = items[menuId];
        if (item) {
            const { elemBefore: icon, label: label } = item;
            return {
                icon: icon,
                label: label
            };
        }
        const shortcut = shortcuts[menuId];
        if (shortcut) {
            const { icon: icon, label: label } = shortcut;
            return {
                icon: icon,
                label: label
            };
        }
        throw Error(`Menu id ${menuId} not found in either items or shortcuts`);
    };

});



parcelRegister("8qwyT", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5fa626161d427648$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5fa626161d427648$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    moreMenuLabel: {
        id: 'navigation.global-side-navigation.more-menu.label',
        description: 'Label on More menu button in the side navigation. Shows a popout with items that are hidden from the main navigation.',
        defaultMessage: 'More'
    }
});

});

parcelRegister("ekEmA", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b29a3834118395f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9itkV = parcelRequire("9itkV");

var $l8bWr = parcelRequire("l8bWr");

var $clIFu = parcelRequire("clIFu");

var $1ELDp = parcelRequire("1ELDp");

var $i7Kir = parcelRequire("i7Kir");

var $8xJnH = parcelRequire("8xJnH");

var $lRJnv = parcelRequire("lRJnv");
function $2b29a3834118395f$export$2e2bcd8739ae039({ id: id, items: items, shortcutItems: shortcutItems, onClick: onClick, openShortcutsInSameTab: openShortcutsInSameTab }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const setPeekMenuId = (0, $8xJnH.useSetPeekMenuId)();
    const shortcutItem = shortcutItems?.[id];
    if (shortcutItem) {
        const moreItem = $2b29a3834118395f$var$buildMoreShortcutItem({
            shortcutItem: shortcutItem,
            formatMessage: formatMessage,
            openShortcutsInSameTab: openShortcutsInSameTab
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ELDp.default), {
            id: id,
            item: moreItem,
            isInMoreMenu: true,
            group: (0, $clIFu.L1_MENU_GROUPS).SHORTCUTS
        });
    }
    // Check if the item is in the items map
    const item = items[id];
    if (!item) throw new Error(`NavItem: No item found for id "${id}". Ensure the item is defined in appItems or globalItems.`);
    if ((0, $i7Kir.isCustomItemConfig)(item)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ELDp.default), {
        id: id,
        item: item,
        isInMoreMenu: true,
        onPeek: ()=>setPeekMenuId(id),
        onClick: onClick
    });
    const moreItem = $2b29a3834118395f$var$buildMoreItem({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: setPeekMenuId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ELDp.default), {
        id: id,
        item: moreItem,
        isInMoreMenu: true
    });
}
function $2b29a3834118395f$var$buildMoreShortcutItem({ formatMessage: formatMessage, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItem: shortcutItem }) {
    const elemAfter = openShortcutsInSameTab ? undefined : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
        size: "small",
        label: formatMessage((0, $lRJnv.messages).linkExternalIconLabel),
        spacing: "spacious"
    });
    return {
        type: 'link',
        elemAfter: elemAfter,
        elemBefore: shortcutItem.icon,
        label: shortcutItem.label,
        target: openShortcutsInSameTab ? '_self' : '_blank',
        href: (0, $l8bWr.getUrlMaybe)(shortcutItem) || '#'
    };
}
function $2b29a3834118395f$var$buildMoreItem({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    if ((0, $i7Kir.isExpandableItemConfig)(item) || (0, $i7Kir.isFlyoutItemConfig)(item) || (0, $i7Kir.isObjectListFlyoutItemConfig)(item)) return $2b29a3834118395f$var$buildMoreItemFromExpandableOrFlyout({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: onPeek
    });
    else if ((0, $i7Kir.isButtonItemConfig)(item) || (0, $i7Kir.isLinkItemConfig)(item)) return $2b29a3834118395f$var$buildMoreItemFromButtonOrLink({
        item: item,
        onClick: onClick
    });
    // If the item is not a button, link, expandable, or flyout, return as is
    return item;
}
function $2b29a3834118395f$var$buildMoreItemFromExpandableOrFlyout({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    const { elemBefore: elemBefore, label: label } = item;
    const onClickActual = $2b29a3834118395f$var$combineHandlerAndActions(// ExpandableItemConfig['onClick'] has a third parameter we're not currently providing
    item.onClick, onClick, onPeek && (()=>onPeek(id)));
    // If the item is in the more menu and is an expandable or flyout item, render as a button with peek
    return {
        type: 'button',
        elemBefore: elemBefore,
        label: label,
        onClick: onClickActual
    };
}
function $2b29a3834118395f$var$buildMoreItemFromButtonOrLink({ item: item, onClick: onClick }) {
    const onClickActual = $2b29a3834118395f$var$combineHandlerAndActions(item.onClick, onClick);
    return {
        ...item,
        // Remove props that are not appropriate for the more menu
        actions: undefined,
        actionsOnHover: undefined,
        elemAfter: undefined,
        labelElem: undefined,
        onClick: onClickActual
    };
}
const $2b29a3834118395f$var$combineHandlerAndActions = (handler, ...actions)=>(...args)=>{
        handler?.(...args);
        actions.forEach((action)=>{
            action?.();
        });
    };

});
parcelRegister("lRJnv", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2a6b947fc1f4389f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2a6b947fc1f4389f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    linkExternalIconLabel: {
        id: 'navigation.global-side-navigation.more-menu-item.link-external-item-label',
        description: 'Label for the link external icon',
        defaultMessage: 'Open external link icon'
    }
});

});



parcelRegister("8OpJw", function(module, exports) {
$parcel$export(module.exports, "HideFromSidebarButton", () => $82ca10bdc9adf739$export$48ac5b0d18731d0f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $55RJF = parcelRequire("55RJF");

var $kKTZh = parcelRequire("kKTZh");

var $lDQal = parcelRequire("lDQal");

var $cjaIO = parcelRequire("cjaIO");
function $82ca10bdc9adf739$export$48ac5b0d18731d0f() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $lDQal.useMoreMenuDragAndDrop)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($55RJF))), {
            label: ""
        }),
        ref: moreButtonRef,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        children: formatMessage((0, $cjaIO.messages).hideFromSidebar)
    });
}

});
parcelRegister("lDQal", function(module, exports) {
$parcel$export(module.exports, "useMoreMenuDragAndDrop", () => $4f8fc472a0c7b011$export$b4c5199e460b5544);

var $eJOHy = parcelRequire("eJOHy");

var $V3tNZ = parcelRequire("V3tNZ");

var $clIFu = parcelRequire("clIFu");

var $dHlZd = parcelRequire("dHlZd");
var $i5aGq = parcelRequire("i5aGq");

var $lmbOW = parcelRequire("lmbOW");
function $4f8fc472a0c7b011$export$b4c5199e460b5544() {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $lmbOW.useOptions)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef } = (0, $V3tNZ.useMenuItemDragAndDrop)({
        // If the More menu will not be shown (e.g. no hidden items), we shouldn't set up drag and drop
        ...l1DragAndDropEnabled && {
            dropTarget: {
                getData: ()=>(0, $dHlZd.getMoreMenuData)(),
                getOperations: ()=>({
                        combine: 'available'
                    }),
                canDrop: ({ source: source })=>{
                    return (0, $dHlZd.isL1ItemData)(source.data) && (0, $dHlZd.isL1ItemDataInGroup)(source.data, [
                        (0, $clIFu.L1_MENU_GROUPS).MENU,
                        (0, $clIFu.L1_MENU_GROUPS).SHORTCUTS
                    ]) && source.data.isHideable;
                }
            }
        }
    });
    const registry = (0, $i5aGq.useElementRegistry)();
    const registrationRef = (0, $eJOHy.useRef)(null);
    const moreButtonRef = (0, $eJOHy.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            return;
        }
        // Unregister previous element if exists
        if (registrationRef.current) registrationRef.current();
        // Register the new element with the registry
        registrationRef.current = registry.registerMoreMenuItem(element);
    }, [
        registrationRef,
        registry
    ]);
    return {
        dropIndicator: dropIndicator,
        dropTargetRef: dropTargetRef,
        moreButtonRef: moreButtonRef
    };
}

});

parcelRegister("cjaIO", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a9e736faab828d9b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a9e736faab828d9b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    hideFromSidebar: {
        id: 'navigation.global-side-navigation.more-menu.hide-from-sidebar.label',
        description: 'Label on Hide from sidebar button in the side navigation. Button appears in place of the More menu when items are being dragged.',
        defaultMessage: 'Hide from sidebar'
    }
});

});


parcelRegister("ehQS0", function(module, exports) {
$parcel$export(module.exports, "ShowInSidebarButton", () => $9af26d965ee99bd2$export$df0ec698b216b297);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bkdrw = parcelRequire("bkdrw");

var $kKTZh = parcelRequire("kKTZh");

var $lDQal = parcelRequire("lDQal");

var $3ZKxq = parcelRequire("3ZKxq");
function $9af26d965ee99bd2$export$df0ec698b216b297() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $lDQal.useMoreMenuDragAndDrop)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKTZh.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bkdrw))), {
            label: ""
        }),
        ref: moreButtonRef,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        children: formatMessage((0, $3ZKxq.messages).showInSidebar)
    });
}

});
parcelRegister("3ZKxq", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ade245dbe4ff5fd9$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ade245dbe4ff5fd9$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    showInSidebar: {
        id: 'navigation.global-side-navigation.more-menu.show-in-sidebar.label',
        description: 'Label on Show in sidebar button in the side navigation. Button appears in place of the More menu when items are being dragged.',
        defaultMessage: 'Show in sidebar'
    }
});

});





parcelRegister("460WX", function(module, exports) {
$parcel$export(module.exports, "getForYouConfig", () => $c2401f948706dcd7$export$7929fceb464f62e7);

var $eJOHy = parcelRequire("eJOHy");

var $h4Bzb = parcelRequire("h4Bzb");

var $4cTDP = parcelRequire("4cTDP");

var $iIQmy = parcelRequire("iIQmy");

var $fs2Be = parcelRequire("fs2Be");

var $if69u = parcelRequire("if69u");

var $hmAh6 = parcelRequire("hmAh6");

var $azKPd = parcelRequire("azKPd");

var $74Kgd = parcelRequire("74Kgd");

var $8mJAp = parcelRequire("8mJAp");
function $c2401f948706dcd7$export$7929fceb464f62e7({ recentEntryPointParams: recentEntryPointParams }) {
    const jiraHomePathToUse = (0, $4cTDP.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? (0, $iIQmy.jiraHomeRoute).path : (0, $fs2Be.oldJiraHomeRoute).path;
    return {
        forYouItem: {
            menuItemId: (0, $h4Bzb.MENU_ID_FOR_YOU),
            url: (0, $iIQmy.jiraHomeRoute).path
        },
        recent: {
            entryPoint: (0, $74Kgd.recentFlyoutEntrypoint),
            entryPointParams: recentEntryPointParams,
            isSearchable: true,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
                withHeading: true,
                withSearch: true,
                withSubHeading: true,
                withSubTitle: true,
                isFlyout: true
            }),
            ItemComponent: (0, $8mJAp.RecentMenuLinkItemAdaptor),
            menuItemId: 'global.recent',
            MenuContentWrapperComponent: (0, $hmAh6.AnalyticContextProvider),
            useItems: (0, $azKPd.useRecentItems),
            viewAllUrl: `${jiraHomePathToUse}?viewed`
        }
    };
}

});
parcelRegister("hmAh6", function(module, exports) {
$parcel$export(module.exports, "AnalyticContext", () => $3ee0f2b9c07015b3$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $3ee0f2b9c07015b3$export$aea8e3edcdec81e3);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");




var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $3ee0f2b9c07015b3$var$COMMON_PAYLOAD = {
    action: 'clicked',
    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
    actionSubjectId: 'recentNavigationMenuItem'
};
const $3ee0f2b9c07015b3$export$da0556bf821b3494 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fireUIAnalyticForFixItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForRecentItems: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $3ee0f2b9c07015b3$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireUIAnalyticForFixItem = (0, $eJOHy.useCallback)(({ itemId: itemId })=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            ...$3ee0f2b9c07015b3$var$COMMON_PAYLOAD,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForRecentItems = (0, $eJOHy.useCallback)(({ itemId: itemId, itemType: itemType, timeRange: timeRange })=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), {
            ...$3ee0f2b9c07015b3$var$COMMON_PAYLOAD,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                itemType: itemType.toLowerCase(),
                itemId: itemId,
                section: timeRange
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3ee0f2b9c07015b3$export$da0556bf821b3494.Provider, {
        value: {
            fireUIAnalyticForFixItem: fireUIAnalyticForFixItem,
            fireUIAnalyticForRecentItems: fireUIAnalyticForRecentItems
        }
    }, children);
};

});

parcelRegister("azKPd", function(module, exports) {
$parcel$export(module.exports, "useRecentItems", () => $5f981033e77db967$export$bc82a767d3a2a41);

var $86d5U = parcelRequire("86d5U");

var $dRLcN = parcelRequire("dRLcN");

var $gPRMh = parcelRequire("gPRMh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3MbOI = parcelRequire("3MbOI");

var $1M2hR = parcelRequire("1M2hR");

var $lRq8t = parcelRequire("lRq8t");

var $fwzaq = parcelRequire("fwzaq");

var $5hDg4 = parcelRequire("5hDg4");
const $5f981033e77db967$var$DEBOUNCE_INTERVAL = 300;
function $5f981033e77db967$export$bc82a767d3a2a41(params) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { searchText: searchText, queries: queries } = params;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const userLocale = (0, $1M2hR.useLocale)();
    const recentMenuData = queries.recentMenuData;
    const { cloudId: cloudId, count: count } = recentMenuData.variables;
    const queryData = (0, $j4oe4.usePreloadedQuery)((0, $gPRMh.default), recentMenuData);
    const [fragmentData, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $dRLcN.default), queryData);
    // NOTE: refetch() returns a Disposable resource. This resource should be dispose()'d of
    // before subsequent calls to refetch.
    // We also want to debounce changes-to-the-search-string.
    const disposableSearchRef = (0, $eJOHy.useRef)(null);
    const handleFilterChange = (0, $eJOHy.useCallback)((searchQuery)=>refetch({
            keyword: searchQuery,
            cloudId: cloudId
        }), [
        cloudId,
        refetch
    ]);
    const [handleDebouncedSearchChange] = (0, $fwzaq.default)((newSearchQuery = searchText)=>{
        disposableSearchRef.current?.dispose();
        disposableSearchRef.current = handleFilterChange(newSearchQuery ?? '');
    }, $5f981033e77db967$var$DEBOUNCE_INTERVAL);
    (0, $eJOHy.useEffect)(()=>{
        handleDebouncedSearchChange(searchText ?? '');
    }, [
        handleDebouncedSearchChange,
        searchText
    ]);
    const { data: { user: user } } = (0, $3MbOI.useCurrentUser)();
    const timeZone = typeof user.timeZone === 'string' ? user.timeZone : '';
    const { data: data, hasNext: /* isLoadingNext, */ hasNext, loadNext: loadNext } = (0, $j4oe4.usePaginationFragment)((0, $86d5U.default), fragmentData);
    const deps = (0, $eJOHy.useMemo)(()=>({
            formatMessage: formatMessage,
            locale: userLocale
        }), [
        formatMessage,
        userLocale
    ]);
    const { sections: sections } = (0, $eJOHy.useMemo)(()=>{
        const nodes = data.jira._recentItems?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
        return {
            sections: (0, $5hDg4.getSections)(nodes, timeZone, deps)
        };
    }, [
        data.jira._recentItems?.edges,
        timeZone,
        deps
    ]);
    const loadMore = (0, $eJOHy.useCallback)(()=>loadNext(count), [
        loadNext,
        count
    ]);
    if (searchText === '') return {
        sections: sections,
        hasMore: hasNext,
        isLoading: false,
        loadMore: loadMore
    };
    return {
        hasMore: hasNext,
        isLoading: false,
        loadMore: loadMore,
        sections: sections
    };
}

});
parcelRegister("86d5U", function(module, exports) {
$parcel$export(module.exports, "default", () => $46f6654981b18a80$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a4e4a351519be3d605ae16cafba86e62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $fVhki = parcelRequire("fVhki");
const $46f6654981b18a80$var$node = function() {
    var v0 = [
        "jira",
        "_recentItems"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v3 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "alias": "filterName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "kind": "RootArgument",
                "name": "keyword"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "count",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $fVhki.default)
            }
        },
        "name": "useRecentItemsPaged",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "_recentItems",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "keyword",
                                            "variableName": "keyword"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PROJECT",
                                        "FILTER",
                                        "DASHBOARD",
                                        "BOARD",
                                        "QUEUE",
                                        "ISSUE",
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "__useRecentItemsPaged__recentItems_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v3 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v3 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$46f6654981b18a80$var$node.hash = "b44cda8ef2e6ca19c983047f10c8ea51";
var $46f6654981b18a80$export$2e2bcd8739ae039 = $46f6654981b18a80$var$node;

});
parcelRegister("fVhki", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c67aa036f58be54$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94e1cdeb8126626c3f3aa172b064b663>>
 * @relayHash 76ca7fab5c5fbe8ed39d6e06d8403add
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f32b0fdb07d672e8509a78eba4412139b4106e4e318e512610acf4ee51a1e1b
const $9c67aa036f58be54$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keyword"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "keyword",
                    "variableName": "keyword"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        {
            "kind": "Literal",
            "name": "types",
            "value": [
                "PROJECT",
                "FILTER",
                "DASHBOARD",
                "BOARD",
                "QUEUE",
                "ISSUE",
                "PLAN"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "alias": "filterName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRecentItemsPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useRecentItemsPaged"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRecentItemsPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "_recentItems",
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v6 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v6 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v1 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useRecentItemsPaged__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7f32b0fdb07d672e8509a78eba4412139b4106e4e318e512610acf4ee51a1e1b",
            "metadata": {},
            "name": "useRecentItemsPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9c67aa036f58be54$var$node.hash = "b44cda8ef2e6ca19c983047f10c8ea51";
var $9c67aa036f58be54$export$2e2bcd8739ae039 = $9c67aa036f58be54$var$node;

});


parcelRegister("dRLcN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6252698f57a702f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<21d33f865b48d63c45c9c044f69bd3cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $7dNEi = parcelRequire("7dNEi");
const $6252698f57a702f4$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "kind": "RootArgument",
            "name": "keyword"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $7dNEi.default)
        }
    },
    "name": "useRecentItems",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "count",
                    "variableName": "count"
                }
            ],
            "kind": "FragmentSpread",
            "name": "useRecentItemsPaged"
        }
    ],
    "type": "Query"
};
$6252698f57a702f4$var$node.hash = "c7427eba8c734344b51198ca307b6328";
var $6252698f57a702f4$export$2e2bcd8739ae039 = $6252698f57a702f4$var$node;

});
parcelRegister("7dNEi", function(module, exports) {
$parcel$export(module.exports, "default", () => $95a9cece7ef2373d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6cd5ba00d16d4922da42217ab476b2d5>>
 * @relayHash 6389002a3862e08a24c402837ac3dda5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d628eaa56f57754411165b1405105b32952acb2d53f5000599c7221c76d8e16
const $95a9cece7ef2373d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keyword"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "keyword",
                    "variableName": "keyword"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        {
            "kind": "Literal",
            "name": "types",
            "value": [
                "PROJECT",
                "FILTER",
                "DASHBOARD",
                "BOARD",
                "QUEUE",
                "ISSUE",
                "PLAN"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "alias": "filterName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRecentItemsRefetchableQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useRecentItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRecentItemsRefetchableQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "_recentItems",
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v6 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v6 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v1 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useRecentItemsPaged__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1d628eaa56f57754411165b1405105b32952acb2d53f5000599c7221c76d8e16",
            "metadata": {},
            "name": "useRecentItemsRefetchableQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$95a9cece7ef2373d$var$node.hash = "c7427eba8c734344b51198ca307b6328";
var $95a9cece7ef2373d$export$2e2bcd8739ae039 = $95a9cece7ef2373d$var$node;

});


parcelRegister("gPRMh", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b5a7ad10ba0df3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8d57ad2a9bec4bcec9c8a363482b95bd>>
 * @relayHash 0509aef365e84b5f8853e8f3ca8bfe30
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26e1487ef1871f059a5ded2203b8e8d8a49d00a0c5e252cfee9b55f5f7dbd896

var $37Ewn = parcelRequire("37Ewn");
const $6b5a7ad10ba0df3a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "keyword"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "fields": [
            {
                "kind": "Variable",
                "name": "keyword",
                "variableName": "keyword"
            }
        ],
        "kind": "ObjectValue",
        "name": "filter"
    }, v5 = {
        "kind": "Literal",
        "name": "types",
        "value": [
            "PROJECT",
            "FILTER",
            "DASHBOARD",
            "BOARD",
            "QUEUE",
            "ISSUE",
            "PLAN"
        ]
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        v5 /*: any*/ 
    ], v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v5 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "alias": "filterName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRecentItemsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recent",
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.recent.pageInfo"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useRecentItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useRecentItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "recent",
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useRecentItemsPaged__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "26e1487ef1871f059a5ded2203b8e8d8a49d00a0c5e252cfee9b55f5f7dbd896",
            "metadata": {},
            "name": "useRecentItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6b5a7ad10ba0df3a$var$node.hash = "efcc4d6635a3fae366bb55971c8e567e";
(0, $37Ewn.PreloadableQueryRegistry).set($6b5a7ad10ba0df3a$var$node.params.id, $6b5a7ad10ba0df3a$var$node);
var $6b5a7ad10ba0df3a$export$2e2bcd8739ae039 = $6b5a7ad10ba0df3a$var$node;

});

parcelRegister("fwzaq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab2d121bc64be0a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
function $ab2d121bc64be0a3$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eJOHy.useRef)(options);
    const callbackRef = (0, $eJOHy.useRef)(callback);
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eJOHy.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("5hDg4", function(module, exports) {
$parcel$export(module.exports, "getSections", () => $2151bd25ed464225$export$ddbcae0b0bd6b092);

var $eJOHy = parcelRequire("eJOHy");

var $ibLUB = parcelRequire("ibLUB");
var $4RKz5 = parcelRequire("4RKz5");
var $lTtQZ = parcelRequire("lTtQZ");
var $5IPrF = parcelRequire("5IPrF");
var $dy6Fq = parcelRequire("dy6Fq");

var $6pRIG = parcelRequire("6pRIG");

var $LFmXM = parcelRequire("LFmXM");

var $Wdhjx = parcelRequire("Wdhjx");

var $5SdQs = parcelRequire("5SdQs");

var $KDB2z = parcelRequire("KDB2z");

var $bjI3S = parcelRequire("bjI3S");

var $l5gdO = parcelRequire("l5gdO");

var $c59mr = parcelRequire("c59mr");

var $6l5yN = parcelRequire("6l5yN");

var $dO9h7 = parcelRequire("dO9h7");

var $iArJs = parcelRequire("iArJs");

var $02kpm = parcelRequire("02kpm");


var $9k4Mp = parcelRequire("9k4Mp");
const $2151bd25ed464225$export$ddbcae0b0bd6b092 = (0, $LFmXM.default)($2151bd25ed464225$var$getSectionItems);
function $2151bd25ed464225$var$getSectionItems(items, timeZone, deps) {
    const now = $2151bd25ed464225$export$a86190deb5c4a8d0();
    const groups = items.reduce((acc, item)=>{
        const viewTimeAgo = $2151bd25ed464225$var$getLastViewedTimestamp(item);
        if (viewTimeAgo) {
            const timeAccessed = new Date(viewTimeAgo);
            const dateObj = (0, $6pRIG.default)(timeAccessed, timeZone);
            if ((0, $ibLUB.default)(dateObj, (0, $lTtQZ.default)())) acc.today.push(item);
            else if ((0, $ibLUB.default)(dateObj, (0, $dy6Fq.default)())) acc.yesterday.push(item);
            else if ((0, $ibLUB.default)(dateObj, (0, $5IPrF.default)(now))) acc.thisWeek.push(item);
            else if ((0, $ibLUB.default)(dateObj, (0, $4RKz5.default)(now))) acc.thisMonth.push(item);
            else acc.moreThanAMonth.push(item);
        }
        return acc;
    }, {
        today: [],
        yesterday: [],
        thisWeek: [],
        thisMonth: [],
        moreThanAMonth: []
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.entries(groups).map(([key, value])=>({
            header: deps.formatMessage((0, $9k4Mp.messages)[key]),
            items: value.map((i)=>$2151bd25ed464225$var$toOLFItem(i, key, deps)).filter(Boolean)
        }));
}
function $2151bd25ed464225$export$a86190deb5c4a8d0() {
    return Date.now();
}
function $2151bd25ed464225$var$getLastViewedTimestamp(item) {
    switch(item.__typename){
        case 'JiraIssue':
        case 'JiraProject':
        case 'JiraPlan':
        case 'JiraBoard':
        case 'JiraDashboard':
        case 'JiraSystemFilter':
        case 'JiraCustomFilter':
        case 'JiraServiceManagementQueue':
            return item.lastViewedTimestamp;
        default:
            return null;
    }
}
function $2151bd25ed464225$var$toOLFItem(item, timeRange, deps) {
    switch(item.__typename){
        case 'JiraBoard':
            {
                const isLocationless = item.boardUrl?.includes('locationless=true');
                return isLocationless ? undefined : {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
                        spacing: "spacious",
                        color: "currentColor",
                        label: ""
                    }),
                    href: item.boardUrl ?? '',
                    primaryLabel: String(item.name ?? ''),
                    secondaryLabel: $2151bd25ed464225$export$16bf0b5dc5cbcfc7({
                        lastViewedTimestamp: item.lastViewedTimestamp,
                        ...deps
                    }),
                    analytics: {
                        itemId: String(item?.boardId),
                        itemType: (0, $48cae6cf1c387d08$export$9b8283d5878d2491),
                        timeRange: timeRange
                    }
                };
            }
        case 'JiraDashboard':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.dashboardUrl ?? '',
                primaryLabel: String(item.dashboardTitle ?? ''),
                secondaryLabel: $2151bd25ed464225$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.dashboardId),
                    itemType: (0, $48cae6cf1c387d08$export$4695c1a423ffe431),
                    timeRange: timeRange
                }
            };
        case 'JiraIssue':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c59mr))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.issueWebUrl ?? '',
                primaryLabel: String(item.summaryField?.text ?? ''),
                secondaryLabel: $2151bd25ed464225$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.issueId),
                    itemType: (0, $48cae6cf1c387d08$export$76a449e52fa0e1e8),
                    timeRange: timeRange
                }
            };
        case 'JiraPlan':
            {
                const planId = item.planId;
                const scenarioId = item.scenario?.scenarioId ?? '';
                const planUrl = (0, $02kpm.generatePath)((0, $iArJs.softwarePlanTimelineRoute).path, {
                    planId: planId,
                    scenarioId: scenarioId
                });
                return {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l5gdO))), {
                        spacing: "spacious",
                        color: "currentColor",
                        label: ""
                    }),
                    href: planUrl,
                    primaryLabel: String(item.planTitle ?? ''),
                    secondaryLabel: $2151bd25ed464225$export$16bf0b5dc5cbcfc7({
                        lastViewedTimestamp: item.lastViewedTimestamp,
                        ...deps
                    }),
                    analytics: {
                        itemId: String(item?.planId),
                        itemType: (0, $48cae6cf1c387d08$export$c303e491e026ebc6),
                        timeRange: timeRange
                    }
                };
            }
        case 'JiraProject':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6l5yN.ContainerAvatar), {
                    src: item.avatar?.large ?? ''
                }),
                href: item.defaultNavigationItem?.url ?? `/browse/${item.key}`,
                primaryLabel: item.title,
                secondaryLabel: $2151bd25ed464225$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.projectId),
                    itemType: (0, $48cae6cf1c387d08$export$fe791c4fa892e400),
                    timeRange: timeRange
                }
            };
        case 'JiraSystemFilter':
        case 'JiraCustomFilter':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.filterUrl ?? '',
                primaryLabel: item.filterName,
                secondaryLabel: $2151bd25ed464225$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.filterId),
                    itemType: (0, $48cae6cf1c387d08$export$c1c49903035a02df),
                    timeRange: timeRange
                }
            };
        case 'JiraServiceManagementQueue':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bjI3S))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.queueUrl ?? '',
                primaryLabel: item.queueTitle,
                secondaryLabel: $2151bd25ed464225$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.queueId),
                    itemType: (0, $48cae6cf1c387d08$export$5828682c822c26e7),
                    timeRange: timeRange
                }
            };
        default:
            return undefined;
    }
}
function $2151bd25ed464225$export$16bf0b5dc5cbcfc7(params) {
    const { description: description, formatMessage: formatMessage, lastViewedTimestamp: lastViewedTimestamp, locale: locale } = params;
    const now = $2151bd25ed464225$export$a86190deb5c4a8d0();
    const lastViewedTimeText = lastViewedTimestamp ? formatMessage((0, $9k4Mp.messages).timeAgo, {
        timeAgo: (0, $dO9h7.formatDistanceStrictWithLocale)(lastViewedTimestamp, now, locale)
    }) : '';
    if ((description?.length ?? 0) > 0 && lastViewedTimeText.length > 0) return `${description} \u2022 ${lastViewedTimeText}`;
    return lastViewedTimeText;
}

});
parcelRegister("9k4Mp", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f13e7d98458255ae$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f13e7d98458255ae$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    recentHeading: {
        "id": "nav-platform-integration.sidebar.common.ui.recent.heading",
        "defaultMessage": "Recent"
    },
    timeAgo: {
        "id": "nav-platform-integration.sidebar.common.ui.recent.time-ago",
        "defaultMessage": "{timeAgo} ago"
    },
    today: {
        "id": "nav-platform-integration.sidebar.common.ui.recent.today-group",
        "defaultMessage": "Today"
    },
    yesterday: {
        "id": "nav-platform-integration.sidebar.common.ui.recent.yesterday-group",
        "defaultMessage": "Yesterday"
    },
    thisWeek: {
        "id": "nav-platform-integration.sidebar.common.ui.recent.this-week-group",
        "defaultMessage": "This week"
    },
    thisMonth: {
        "id": "nav-platform-integration.sidebar.common.ui.recent.this-month-group",
        "defaultMessage": "This month"
    },
    moreThanAMonth: {
        "id": "nav-platform-integration.sidebar.common.ui.recent.more-than-a-month-group",
        "defaultMessage": "More than a month"
    },
    loadMore: {
        "id": "nav-platform-integration.sidebar.common.ui.recent.load-more",
        "defaultMessage": "Load more"
    }
});

});



parcelRegister("74Kgd", function(module, exports) {
$parcel$export(module.exports, "recentFlyoutEntrypoint", () => $35794ada6b19e940$export$ecaea4121d3b11ae);

var $gPRMh = parcelRequire("gPRMh");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $35794ada6b19e940$export$ecaea4121d3b11ae = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("j5m8t")), {
        moduleId: "06e38b41",
        priority: "interaction",
        moduleId: 'objectListFlyoutEntrypointJiraRecents'
    }),
    getPreloadProps: ({ cloudId: cloudId, count: count })=>({
            queries: {
                recentMenuData: {
                    parameters: $gPRMh.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        keyword: ''
                    }
                }
            }
        })
});

});

parcelRegister("8mJAp", function(module, exports) {
$parcel$export(module.exports, "RecentMenuLinkItemAdaptor", () => $13fae68ed9101c60$export$482d0a18f93a0080);

var $eJOHy = parcelRequire("eJOHy");

var $2dvSy = parcelRequire("2dvSy");

var $hmAh6 = parcelRequire("hmAh6");
function $13fae68ed9101c60$export$482d0a18f93a0080(params) {
    const { href: href, elemBefore: elemBefore, primaryLabel: primaryLabel, secondaryLabel: secondaryLabel, tertiaryLabel: tertiaryLabel, analytics: analytics } = params;
    const description = secondaryLabel ? `${secondaryLabel}${tertiaryLabel ? ` \u{2022} ${tertiaryLabel}` : ''}` : '';
    const { fireUIAnalyticForRecentItems: fireUIAnalyticForRecentItems } = (0, $eJOHy.useContext)((0, $hmAh6.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        elemBefore: elemBefore,
        href: href || '',
        description: description,
        onClick: ()=>{
            fireUIAnalyticForRecentItems(analytics);
        }
    }, primaryLabel);
}

});



parcelRegister("lTExG", function(module, exports) {
$parcel$export(module.exports, "GSNForOtherSidebars", () => $af8f2e8e7500cecf$export$8c6d29ef23f67ed7);

var $eJOHy = parcelRequire("eJOHy");

var $b94hs = parcelRequire("b94hs");
function $af8f2e8e7500cecf$export$8c6d29ef23f67ed7({ sidebarId: sidebarId }) {
    /*
	  TODO:
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b94hs.GlobalSideNavigation), {
        app: "jira",
        appLabel: "Jira",
        customizationStore: "local",
        forYou: {},
        items: {},
        testId: "nav-platform-integration-sidebar.ui.jira-other-sidebars"
    });
}

});


parcelRegister("6ju76", function(module, exports) {
$parcel$export(module.exports, "isLegacyAuiBlanketClosed", () => $d85f35252fd20f21$export$25d1b8252b4c49b7);
/**
 * Finding all `aui-blanket` elements on the page and check if they are all hidden.
 */ const $d85f35252fd20f21$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};

});

parcelRegister("7b66t", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c0c17209c0996f78$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c0c17209c0996f78$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    sidebarNavigation: {
        "id": "page-container-v2.common.sidebar.sidebar-navigation",
        "defaultMessage": "Sidebar navigation"
    },
    sideBarPanelSplitterLabel: {
        "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
        "defaultMessage": "Resize side navigation panel"
    },
    globalInviteButtonLabel: {
        "id": "page-container-v2.common.sidebar.global-invite-button-label",
        "defaultMessage": "Invite people"
    }
});

});


parcelRegister("dtNAy", function(module, exports) {
$parcel$export(module.exports, "TopNav", () => $521256873ada116f$export$41d0d88a6b0e456f);

var $eJOHy = parcelRequire("eJOHy");

var $kvNRH = parcelRequire("kvNRH");

var $bDJm5 = parcelRequire("bDJm5");

var $gjMiF = parcelRequire("gjMiF");


var $5vQ2T = parcelRequire("5vQ2T");

var $gdLX3 = parcelRequire("gdLX3");

var $dzLcO = parcelRequire("dzLcO");

var $2imLM = parcelRequire("2imLM");

var $4EKqI = parcelRequire("4EKqI");

var $7wkp5 = parcelRequire("7wkp5");

var $9bSFg = parcelRequire("9bSFg");
const $521256873ada116f$var$LegacyPageNavigationStyles = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: 24px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $8246a95f06cae369$export$d60454526e2281af)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $8246a95f06cae369$export$d60454526e2281af)}); } /* admin project dir hack */
                `
        }
    });
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $521256873ada116f$var$TEST_ID = 'page-layout.top-nav';
function $521256873ada116f$export$41d0d88a6b0e456f() {
    const { shouldRender: shouldRender } = (0, $gdLX3.useTopNavState)();
    const theme = (0, $bDJm5.useNav4Theme)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($521256873ada116f$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.TopNavigation), {
        isFixed: true,
        testId: $521256873ada116f$var$TEST_ID,
        theme: theme
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kvNRH.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.PlaceholderNew), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjMiF.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9bSFg.AsyncAtlassianNavigation), null)))));
}

});
parcelRegister("kvNRH", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigationStart", () => $ecb494ba00cee566$export$831e6a6e875b5ef8);

var $eJOHy = parcelRequire("eJOHy");


var $912hm = parcelRequire("912hm");

var $5grHY = parcelRequire("5grHY");

var $gCY1z = parcelRequire("gCY1z");
const $ecb494ba00cee566$export$831e6a6e875b5ef8 = ()=>{
    const [{ location: location }] = (0, $gCY1z.useRouter)();
    const { setAppStartWithAppId: setAppStartWithAppId } = (0, $912hm.useSpaStateActions)();
    (0, $5grHY.usePageId)();
    const startRef = (0, $eJOHy.useRef)({
        location: location,
        startTime: Date.now()
    });
    (0, $eJOHy.useMemo)(()=>{
        if (location !== startRef.current.location) startRef.current = {
            location: location,
            startTime: Date.now()
        };
    }, [
        location
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setAppStartWithAppId((0, $44a1f3ad00fd7f5d$export$3a54edb6ba4daa82), startRef.current.startTime);
    }, [
        location,
        setAppStartWithAppId
    ]);
    return null;
};

});

parcelRegister("bDJm5", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $c4cdf8cd9afe6fcf$export$93d4e7f90805808f);
$parcel$export(module.exports, "useNav4Theme", () => $c4cdf8cd9afe6fcf$export$b761e7abf0bdf352);

var $eJOHy = parcelRequire("eJOHy");

var $bXB0U = parcelRequire("bXB0U");

var $2On2D = parcelRequire("2On2D");
var $58yRG = parcelRequire("58yRG");

var $575d2 = parcelRequire("575d2");

var $cxQGT = parcelRequire("cxQGT");

var $3PoVU = parcelRequire("3PoVU");

var $lDk1y = parcelRequire("lDk1y");
const $c4cdf8cd9afe6fcf$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $c4cdf8cd9afe6fcf$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($c4cdf8cd9afe6fcf$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $2On2D.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $lDk1y.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $c4cdf8cd9afe6fcf$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $58yRG.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $cxQGT.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $c4cdf8cd9afe6fcf$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $575d2.useTheme)();
    const isDarkMode = $c4cdf8cd9afe6fcf$var$useIsDarkThemeResolver();
    const bg = (0, $eJOHy.useMemo)(()=>$c4cdf8cd9afe6fcf$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $3PoVU.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $bXB0U.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};
const $c4cdf8cd9afe6fcf$export$b761e7abf0bdf352 = ()=>{
    /**
   * The colors chosen by the site admin in the site settings
   */ const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $575d2.useTheme)();
    /**
   * Whether the user is currently using dark mode,
   * or their configured preference if this is SSR.
   */ const isDarkMode = $c4cdf8cd9afe6fcf$var$useIsDarkThemeResolver();
    /**
   * The adjusted background color.
   *
   * When the user is in dark mode, the lightness of the background color is capped.
   */ const bg = (0, $eJOHy.useMemo)(()=>$c4cdf8cd9afe6fcf$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    /**
   * Creates / updates a theme-color meta tag:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color
   *
   * Some browsers will use this to change the color of their UI.
   */ (0, $eJOHy.useEffect)(()=>{
        (0, $3PoVU.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return {
        backgroundColor: bg,
        highlightColor: highlightColor
    };
};

});
parcelRegister("3PoVU", function(module, exports) {
$parcel$export(module.exports, "addThemeColor", () => $bcdd7f881bea77b5$export$7b20d133831b2b0f);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $bcdd7f881bea77b5$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $bcdd7f881bea77b5$var$getHead = ()=>document.head || document.querySelector('head');
const $bcdd7f881bea77b5$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $bcdd7f881bea77b5$var$getMetaNode('theme-color');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $bcdd7f881bea77b5$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("lDk1y", function(module, exports) {
$parcel$export(module.exports, "capLightness", () => $084b53f1ef2a6c95$export$8b5544bab97b10dd);
const $084b53f1ef2a6c95$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $084b53f1ef2a6c95$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $084b53f1ef2a6c95$var$rgbFromHex = (input)=>{
    const fullHex = $084b53f1ef2a6c95$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $084b53f1ef2a6c95$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $084b53f1ef2a6c95$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $084b53f1ef2a6c95$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $084b53f1ef2a6c95$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $084b53f1ef2a6c95$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $084b53f1ef2a6c95$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $084b53f1ef2a6c95$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $084b53f1ef2a6c95$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $084b53f1ef2a6c95$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $084b53f1ef2a6c95$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $084b53f1ef2a6c95$var$rgbToLch = (rgb)=>$084b53f1ef2a6c95$var$labToLch($084b53f1ef2a6c95$var$xyzToLab($084b53f1ef2a6c95$var$rgbToXyz(rgb)));
const $084b53f1ef2a6c95$var$lchToRgb = (lch)=>$084b53f1ef2a6c95$var$xyzToRgb($084b53f1ef2a6c95$var$labToXyz($084b53f1ef2a6c95$var$lchToLab(lch)));
const $084b53f1ef2a6c95$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $084b53f1ef2a6c95$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $084b53f1ef2a6c95$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $084b53f1ef2a6c95$var$clamp(capPercent, 0, 100);
    return $084b53f1ef2a6c95$var$rgbToHex($084b53f1ef2a6c95$var$lchToRgb(lch));
};

});


parcelRegister("gjMiF", function(module, exports) {
$parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", () => $44487e9ee0b8d1f5$export$38e532bc6b824200);

var $eJOHy = parcelRequire("eJOHy");

var $dOxQJ = parcelRequire("dOxQJ");

var $dLR8J = parcelRequire("dLR8J");

var $bDJm5 = parcelRequire("bDJm5");
const $44487e9ee0b8d1f5$export$38e532bc6b824200 = ()=>{
    const theme = (0, $bDJm5.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dOxQJ.NavigationSkeleton), {
        theme: theme
    }));
};

});
parcelRegister("dOxQJ", function(module, exports) {
$parcel$export(module.exports, "NavigationSkeleton", () => $64729aaa3c385d35$export$ad5e8e6ace98cc2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");



var $kc3Dt = parcelRequire("kc3Dt");
var $3Ch6t = parcelRequire("3Ch6t");

var $5QAco = parcelRequire("5QAco");

var $d9ukY = parcelRequire("d9ukY");

var $kHyJF = parcelRequire("kHyJF");

var $Nx0hc = parcelRequire("Nx0hc");

var $3gerg = parcelRequire("3gerg");
function $64729aaa3c385d35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64729aaa3c385d35$var$containerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $f1e8204a96ac51fd$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $64729aaa3c385d35$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $64729aaa3c385d35$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $64729aaa3c385d35$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, $kc3Dt.defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3Ch6t.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $64729aaa3c385d35$var$containerStyles,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $64729aaa3c385d35$var$leftStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5QAco.IconButtonSkeleton), {
        marginLeft: 0,
        marginRight: 5,
        size: 26
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kHyJF.ProductHomeSkeleton), {
        showSiteName: showSiteName
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $d9ukY.PrimaryItemsContainerSkeleton), {
        count: primaryItemsCount
    })), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $64729aaa3c385d35$var$rightStyles
    }, shouldShowSearch && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3gerg.SearchSkeleton), null), Array.from({
        length: secondaryItemsCount
    }, (_, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $5QAco.IconButtonSkeleton), {
            key: index,
            marginLeft: 0,
            marginRight: 4,
            size: 26
        })), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $Nx0hc.ProfileSkeleton), null))));
};

});
const $f1e8204a96ac51fd$export$30fa7cc5f2690a43 = 56;
const $f1e8204a96ac51fd$export$4033a111ca79977d = 1280;
const $f1e8204a96ac51fd$export$24ec62cee78b7042 = 1130;
const $f1e8204a96ac51fd$export$d8bde68ac946124f = '--ds--ans--fbc';
const $f1e8204a96ac51fd$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $f1e8204a96ac51fd$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $f1e8204a96ac51fd$export$d81606c1fc5119bc = '--ds--ans--c';
const $f1e8204a96ac51fd$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("5QAco", function(module, exports) {
$parcel$export(module.exports, "IconButtonSkeleton", () => $da54a526e7741c53$export$7a24471cb6f25433);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $8rn5z = parcelRequire("8rn5z");
function $da54a526e7741c53$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $da54a526e7741c53$var$buttonHeight = "var(--ds-space-400, 32px)";
const $da54a526e7741c53$var$skeletonStyles = {
    name: "1shcc5h",
    styles: "border-radius:var(--ds-radius-full, 50%);opacity:0.15"
};
const $da54a526e7741c53$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
    const theme = (0, $8rn5z.useTheme)();
    const dynamicStyles = {
        marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
        marginRight: typeof marginRight === 'number' ? marginRight : 0,
        width: typeof size === 'number' ? size : $da54a526e7741c53$var$buttonHeight,
        height: typeof size === 'number' ? size : $da54a526e7741c53$var$buttonHeight,
        ...theme.mode.skeleton
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: $da54a526e7741c53$var$skeletonStyles
    });
};

});

parcelRegister("d9ukY", function(module, exports) {
$parcel$export(module.exports, "PrimaryItemsContainerSkeleton", () => $d9c9dc363188d968$export$fdfc48d2117b79a8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $8MXBL = parcelRequire("8MXBL");
function $d9c9dc363188d968$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d9c9dc363188d968$var$primaryButtonSkeletonStyles = {
    name: "yn5kop",
    styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
};
const $d9c9dc363188d968$export$fdfc48d2117b79a8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ count: count })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $8MXBL.PrimaryButtonSkeleton), {
            key: index,
            css: $d9c9dc363188d968$var$primaryButtonSkeletonStyles
        }))));

});
parcelRegister("8MXBL", function(module, exports) {
$parcel$export(module.exports, "PrimaryButtonSkeleton", () => $37c8a09adaa6b399$export$4bc51fe36728414d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $8rn5z = parcelRequire("8rn5z");
const $37c8a09adaa6b399$var$paddingAll = 4;
const $37c8a09adaa6b399$var$buttonHeight = 32;
const $37c8a09adaa6b399$var$skeletonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-flex',
    width: '68px',
    height: `${$37c8a09adaa6b399$var$buttonHeight - $37c8a09adaa6b399$var$paddingAll * 2.5}px`,
    borderRadius: "var(--ds-radius-small, 4px)",
    opacity: 0.15
});
const $37c8a09adaa6b399$export$4bc51fe36728414d = (props)=>{
    const theme = (0, $8rn5z.useTheme)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $37c8a09adaa6b399$var$skeletonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    });
};

});


parcelRegister("kHyJF", function(module, exports) {
$parcel$export(module.exports, "ProductHomeSkeleton", () => $cf200b9b41236376$export$3e79e535d76cce4b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $8rn5z = parcelRequire("8rn5z");

var $jistC = parcelRequire("jistC");
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $cf200b9b41236376$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
const $cf200b9b41236376$var$productHomeButtonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:active': {
        backgroundColor: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus': {
        backgroundColor: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        boxShadow: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
        color: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: 0
    },
    '&:hover': {
        backgroundColor: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $f1e8204a96ac51fd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $f1e8204a96ac51fd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $cf200b9b41236376$var$productLogoStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    width: 120,
    maxWidth: 120,
    height: 24,
    maxHeight: 28,
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $f1e8204a96ac51fd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $cf200b9b41236376$var$productIconStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    width: 28,
    height: 28,
    borderRadius: "var(--ds-radius-full, 50%)",
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $f1e8204a96ac51fd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $cf200b9b41236376$var$siteTitleStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    width: "var(--ds-space-500, 40px)",
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        width: '100%',
        height: 14,
        backgroundColor: `var(${$cf200b9b41236376$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
        borderRadius: "var(--ds-radius-small, 4px)",
        content: '""'
    }
});
const $cf200b9b41236376$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
    const theme = (0, $8rn5z.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const productHomeButtonDynamicStyles = (0, $jistC.stripEmptyProperties)({
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$cf200b9b41236376$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$cf200b9b41236376$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    });
    const siteTitleDynamicStyles = {
        borderRight: theme.mode.productHome.borderRight,
        opacity: theme.mode.skeleton.opacity,
        [$cf200b9b41236376$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $cf200b9b41236376$var$productHomeButtonStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $cf200b9b41236376$var$productLogoStyles
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $cf200b9b41236376$var$productIconStyles
    })), showSiteName && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: siteTitleDynamicStyles,
        css: $cf200b9b41236376$var$siteTitleStyles
    }));
};

});
parcelRegister("jistC", function(module, exports) {
$parcel$export(module.exports, "stripEmptyProperties", () => $691f047f887e75f0$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $691f047f887e75f0$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});


parcelRegister("Nx0hc", function(module, exports) {
$parcel$export(module.exports, "ProfileSkeleton", () => $63ccc87bec967d16$export$2bab43fd33adda3b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5QAco = parcelRequire("5QAco");
const $63ccc87bec967d16$export$2bab43fd33adda3b = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5QAco.IconButtonSkeleton), {
        marginLeft: 6,
        marginRight: 6,
        size: 26
    });

});

parcelRegister("3gerg", function(module, exports) {
$parcel$export(module.exports, "SearchSkeleton", () => $7a94f0c0735348da$export$d8fbade3e5bbb8e0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $8rn5z = parcelRequire("8rn5z");

var $5QAco = parcelRequire("5QAco");
const $7a94f0c0735348da$var$searchInputContainerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: "var(--ds-space-250, 20px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $f1e8204a96ac51fd$export$24ec62cee78b7042) - 1}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $7a94f0c0735348da$var$searchInputSkeletonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderRadius: "var(--ds-radius-large, 6px)",
    opacity: 0.15
});
const $7a94f0c0735348da$var$searchIconStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $f1e8204a96ac51fd$export$24ec62cee78b7042}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $7a94f0c0735348da$export$d8fbade3e5bbb8e0 = ()=>{
    const theme = (0, $8rn5z.useTheme)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7a94f0c0735348da$var$searchInputContainerStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $7a94f0c0735348da$var$searchInputSkeletonStyles
    })), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5QAco.IconButtonSkeleton), {
        css: $7a94f0c0735348da$var$searchIconStyles,
        marginRight: 5,
        size: 26
    }));
};

});



// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $8246a95f06cae369$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $8246a95f06cae369$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $8246a95f06cae369$export$638757b621fbf475 = `${$8246a95f06cae369$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$8246a95f06cae369$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $8246a95f06cae369$export$d60454526e2281af = `(${$8246a95f06cae369$export$638757b621fbf475})`;

parcelRegister("gdLX3", function(module, exports) {
$parcel$export(module.exports, "useTopNavState", () => $a16764cec6e50c95$export$bccbd45ab793bd09);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $a16764cec6e50c95$var$useTopNav = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>({
            ...state.topNavigation,
            shouldRender: !state.isChromeless
        })
});
const $a16764cec6e50c95$export$bccbd45ab793bd09 = ()=>{
    const [state] = $a16764cec6e50c95$var$useTopNav();
    return state;
};

});

parcelRegister("9bSFg", function(module, exports) {
$parcel$export(module.exports, "AsyncAtlassianNavigation", () => $7b51abe6795970ed$export$932edb7b1b20d079);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8xgJ5 = parcelRequire("8xgJ5");

var $96SSt = parcelRequire("96SSt");

var $gjMiF = parcelRequire("gjMiF");

var $75yrv = parcelRequire("75yrv");


var $jrulJ = parcelRequire("jrulJ");

var $2dBpR = parcelRequire("2dBpR");

var $lOI8W = parcelRequire("lOI8W");
const $7b51abe6795970ed$export$932edb7b1b20d079 = ()=>{
    const topNavEntryPointReference = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$bec6dca2e63de4ae));
    (0, $eJOHy.useState)(()=>{
        if (!false && topNavEntryPointReference) /* @ts-expect-error - TS2339 - We're using JSResourceReference from @atlassian/react-async. */ (0, $8xgJ5.topNavigationEntryPoint).root.onComplete(()=>{
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $75yrv.JS_EVAL_START))) {
                (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return undefined;
    });
    return topNavEntryPointReference ? // There is already a Placeholder in parent
    // remove this one when EntryPointPlaceholder merges with Placeholder
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjMiF.JiraAtlassianNavigationSkeleton), null),
        entryPointReference: topNavEntryPointReference
    }, topNavEntryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: topNavEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $96SSt.AtlassianNavigation), null);
};

});
parcelRegister("96SSt", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigation", () => $aadd0010df9e09c6$export$f66ccb39f60980e5);

var $eJOHy = parcelRequire("eJOHy");

var $ijkT7 = parcelRequire("ijkT7");

var $2On2D = parcelRequire("2On2D");

var $fhzEL = parcelRequire("fhzEL");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $fYeTG = parcelRequire("fYeTG");

var $cfwEM = parcelRequire("cfwEM");

var $8rGQ0 = parcelRequire("8rGQ0");

var $9bIvg = parcelRequire("9bIvg");

var $aN4LZ = parcelRequire("aN4LZ");

var $aNi5m = parcelRequire("aNi5m");

var $cHtIB = parcelRequire("cHtIB");

var $iHtrU = parcelRequire("iHtrU");

var $bDJm5 = parcelRequire("bDJm5");

var $edDe8 = parcelRequire("edDe8");

var $dgOrd = parcelRequire("dgOrd");

var $kjqBp = parcelRequire("kjqBp");

var $crIFg = parcelRequire("crIFg");

var $jILIS = parcelRequire("jILIS");

var $gWKt4 = parcelRequire("gWKt4");

var $et1RD = parcelRequire("et1RD");

var $6wuXc = parcelRequire("6wuXc");

var $kv0Iu = parcelRequire("kv0Iu");

var $2olUi = parcelRequire("2olUi");

var $6phAP = parcelRequire("6phAP");

var $caHVZ = parcelRequire("caHVZ");
const $aadd0010df9e09c6$var$TopNavComponent = $aadd0010df9e09c6$var$Nav4TopNav;
function $aadd0010df9e09c6$export$f66ccb39f60980e5() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aadd0010df9e09c6$var$CustomThemeContextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aadd0010df9e09c6$var$TopNavComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9bIvg.Nav4RolloutAnalytics), null), (0, $4cTDP.fg)('jira_mobile_web_mvp_2_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYeTG.MobileWebExperimentExposure), null), (0, $4cTDP.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYeTG.MobileWebExperimentViewPanelNewTenantsExposure), null), (0, $4cTDP.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYeTG.MobileWebExperimentViewPanelExistingUserExposure), null));
}
function $aadd0010df9e09c6$var$Nav4TopNav() {
    const theme = (0, $bDJm5.useTheme)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const isMobileExperience = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    // See: https://hello.jira.atlassian.cloud/browse/NAVX-1993
    const setCustomThemeData = (0, $aNi5m.useSetCustomThemeData)();
    if ((0, $4cTDP.fg)('jfp-magma-fix-custom-theme-data-hydration-error')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        setCustomThemeData({
            hasCustomBGColor: !!theme?.mode.navigation.backgroundColor,
            hasCustomHighlightColor: $aadd0010df9e09c6$var$getHasCustomHighlightColor(theme),
            cloudId: cloudId
        });
    }, [
        cloudId,
        setCustomThemeData,
        theme
    ]);
    else setCustomThemeData({
        hasCustomBGColor: !!theme?.mode.navigation.backgroundColor,
        hasCustomHighlightColor: $aadd0010df9e09c6$var$getHasCustomHighlightColor(theme),
        cloudId: cloudId
    });
    const nav4NavigationProps = (0, $eJOHy.useMemo)(()=>isMobileExperience ? {
            hideSideNavToggleButton: true,
            renderSearch: (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)() ? (0, $kv0Iu.Search) : undefined,
            renderNotifications: (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)() ? (0, $jILIS.Notifications) : undefined
        } : {
            renderAppSwitcher: (0, $aN4LZ.default),
            renderSearch: (0, $kv0Iu.Search),
            renderEditionAwareness: (0, $cfwEM.EditionAwareness),
            renderHelp: (0, $kjqBp.Help),
            renderNotifications: (0, $jILIS.Notifications),
            renderConversationAssistant: (0, $edDe8.ConversationAssistant),
            renderSettings: (0, $2olUi.Settings),
            renderProfile: (0, $et1RD.Profile),
            renderSignIn: (0, $6phAP.SignIn)
        }, [
        isMobileExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ijkT7.TopNav4), {
        renderProductHome: (0, $gWKt4.ProductHome),
        renderCreate: (0, $dgOrd.Create),
        renderNav4Notifications: (0, $caHVZ.Nav4NotificationsData),
        ...nav4NavigationProps,
        theme: theme,
        label: formatMessage((0, $crIFg.default).topNav)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6wuXc.NavigationRouterListener), null), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fhzEL.default), null));
}
function $aadd0010df9e09c6$var$CustomThemeContextWrapper({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNi5m.CustomThemeDataProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHtrU.CustomThemeAnalytics), null, children));
}
function $aadd0010df9e09c6$var$getHasCustomHighlightColor(theme) {
    if (!theme) return false;
    // Default create button background color in Nav4 is #0052CC
    // #0052CC is a legacy brand blue. In the non-legacy tokens, the general replacement is:
    //   • Token name: color.link
    //   • CSS variable: var(--ds-link)
    //   • Current hex in atlassian-light: #0C66E4
    // If the create button background color is different from this value, we consider it as a custom highlight color
    const tokenHighlightColor = (0, $2On2D.default)('color.link');
    return theme.mode.create.default.backgroundColor !== tokenHighlightColor && // Failsafe check in case the token value is not what we expect
    theme.mode.create.default.backgroundColor !== '#0052CC';
}

});
parcelRegister("ijkT7", function(module, exports) {
$parcel$export(module.exports, "TopNav4", () => $1ff9eefd8d7d9ace$export$76799253f2c58923);

var $eJOHy = parcelRequire("eJOHy");

var $4EKqI = parcelRequire("4EKqI");

var $5vQ2T = parcelRequire("5vQ2T");


var $hWeHP = parcelRequire("hWeHP");

var $7sLlL = parcelRequire("7sLlL");
function $1ff9eefd8d7d9ace$export$76799253f2c58923(props) {
    // This is defensive code to prevent making a request for data that will never be returned.
    // Only Customer Accounts have customer service access. These are non-Atlassian accounts considered
    // second-party party customers and should only have access to the JSM Help Center. They should
    // never have access to the regular Jira UI so should never see this top navigation. If we detect
    // that this is a customer account request we will not render the top navigation at all.
    // See https://jplat.atlassian.net/browse/BLU-7341 for context.
    if ((0, $hWeHP.default)('ajs-account-type') === 'customer') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "atlaskit-atlassian-navigation-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "AtlaskitAtlassianNavigationNav4",
        packageName: (0, $982bab3922601ed3$export$b8b9d90f9e5bd72b),
        teamName: (0, $982bab3922601ed3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7sLlL.AtlassianNavigationNav4), props)));
}

});
const $982bab3922601ed3$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $982bab3922601ed3$export$d57b6b390e78d90f = 'jira-cosmos';
const $982bab3922601ed3$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $982bab3922601ed3$export$eed606b4351295d7 = 'login';
const $982bab3922601ed3$export$35e541d26a145a7c = 'logout';

parcelRegister("7sLlL", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigationNav4", () => $2d59af443761ac7b$export$40fab2fde5132498);

var $54NUw = parcelRequire("54NUw");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jLmVm = parcelRequire("jLmVm");
var $6wFCv = parcelRequire("6wFCv");
var $eKJHY = parcelRequire("eKJHY");
var $gnKQP = parcelRequire("gnKQP");

var $j74GE = parcelRequire("j74GE");

var $lRq8t = parcelRequire("lRq8t");

var $8J0lu = parcelRequire("8J0lu");




var $2LcvY = parcelRequire("2LcvY");

var $iyTaR = parcelRequire("iyTaR");

var $5Q9JR = parcelRequire("5Q9JR");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");

var $9FYIg = parcelRequire("9FYIg");

var $kh7bJ = parcelRequire("kh7bJ");

var $85PFP = parcelRequire("85PFP");

var $f58lN = parcelRequire("f58lN");

var $4cTDP = parcelRequire("4cTDP");

var $cUxaS = parcelRequire("cUxaS");

var $aNi5m = parcelRequire("aNi5m");

var $kyPau = parcelRequire("kyPau");

var $2qDaO = parcelRequire("2qDaO");

var $8aPak = parcelRequire("8aPak");

var $45yGs = parcelRequire("45yGs");
function $2d59af443761ac7b$export$40fab2fde5132498(props) {
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $8J0lu.topNav4UIStateResource)); // This intermediate step is to avoid using a null queryReference.
    // Maybe this should be a skeleton? Or is that taken care of by the page-container-v2?
    return queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d59af443761ac7b$export$b2b29f12a28e3baa, {
        queryReference: queryReference,
        ...props
    });
}
function $2d59af443761ac7b$export$b2b29f12a28e3baa({ hideSideNavToggleButton: hideSideNavToggleButton, queryReference: queryReference, renderCreate: Create, renderHelp: Help, renderAppSwitcher: AppSwitcher, renderNotifications: Notifications, renderNav4Notifications: Nav4NotificationsData, renderConversationAssistant: ConversationAssistant, renderSettings: Settings, renderSearch: Search, renderEditionAwareness: EditionAwareness, renderProductHome: ProductHome }) {
    const data = (0, $j4oe4.usePreloadedQuery)((0, $54NUw.default), queryReference);
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const siteTitleData = (0, $8aPak.useSiteTitle)();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined; // See: https://hello.jira.atlassian.cloud/browse/NAVX-1993
    const setCustomThemeData = (0, $aNi5m.useSetCustomThemeData)();
    if ((0, $4cTDP.fg)('jfp-magma-fix-custom-theme-data-hydration-error')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        setCustomThemeData({
            hasCustomSiteTitle: !!siteTitle,
            customSiteTitleLength: siteTitle?.length || undefined
        });
    }, [
        setCustomThemeData,
        siteTitle
    ]);
    else setCustomThemeData({
        hasCustomSiteTitle: !!siteTitle,
        customSiteTitleLength: siteTitle?.length || undefined
    });
    const attributes = (0, $eJOHy.useMemo)(()=>({
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $95eb6070d868c1b7$export$793ed84f5e13fedc),
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage
        }), []);
    const onClickSideNavToggleButton = (0, $eJOHy.useCallback)((_, analyticsEvent, _attributes)=>{
        const payload = (0, $2LcvY.getSideNavToggleButtonAnalyticEventPayload)(_attributes?.isSideNavVisible, (0, $iyTaR.getNav4Rollout)().stage);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, payload);
    }, []);
    const renderNotificationsForNavVersion = (0, $eJOHy.useCallback)(()=>{
        if (Notifications !== undefined) {
            if (Nav4NotificationsData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Nav4NotificationsData, {
                queryReference: data
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Notifications, null);
        }
        return null;
    }, [
        Nav4NotificationsData,
        Notifications,
        data
    ]);
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $cUxaS.useLeftSidebarState)();
    const defaultCollapsed = (0, $eJOHy.useMemo)(()=>{
        if ((0, $4cTDP.fg)('blu-8363-archive-legacy-resource-navigationuistate')) return isLeftSidebarCollapsed ?? (0, $5Q9JR.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
        return data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $5Q9JR.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
    }, [
        data?.jira?.navigationUIState?.isLeftSidebarCollapsed,
        isLeftSidebarCollapsed
    ]);
    const sideNavToggleButton = hideSideNavToggleButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLmVm.SideNavToggleButton), {
        defaultCollapsed: (0, $4cTDP.fg)('navx-full-height-sidebar') ? undefined : defaultCollapsed,
        onClick: onClickSideNavToggleButton,
        collapseLabel: (0, $4cTDP.fg)('navx-full-height-sidebar') ? formatMessage((0, $kyPau.messages).sideNavToggleButtonCollapseLabel) : formatMessage((0, $kyPau.messages).sideNavToggleButtonCollapseLabelWithShortcut),
        expandLabel: (0, $4cTDP.fg)('navx-full-height-sidebar') ? formatMessage((0, $kyPau.messages).sideNavToggleButtonExpandLabel) : formatMessage((0, $kyPau.messages).sideNavToggleButtonExpandLabelWithShortcut)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gnKQP.TopNavStart), {
        sideNavToggleButton: (0, $4cTDP.fg)('platform_dst_nav4_side_nav_toggle_button_slot') ? sideNavToggleButton : undefined
    }, (0, $4cTDP.fg)('platform_dst_nav4_side_nav_toggle_button_slot') ? undefined : sideNavToggleButton, AppSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AppSwitcher, null), ProductHome && ((0, $4cTDP.fg)('team25-eu-jira-logo-updates-csm-jsm') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $45yGs.ProductHomeRelayWithErrorBoundary), {
        renderProductHome: ProductHome,
        queryReference: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProductHome, null)), siteTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j74GE.CustomTitle), null, siteTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKJHY.TopNavMiddle), null, Search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Search, null), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Create, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6wFCv.TopNavEnd), null, (0, $4cTDP.fg)('jsm_gp_awareness_pill') && ((0, $4cTDP.fg)('jsm_gp_awareness_pill_browser_only') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85PFP.AsyncGPAwarenessPill), {
        analyticsOrigin: "navBar"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58lN.GpAwarenessPill), {
        analyticsOrigin: "navBar"
    })), EditionAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EditionAwareness, null), !isAnonymous && ConversationAssistant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConversationAssistant, null), !isAnonymous && renderNotificationsForNavVersion(), Help && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Help, null), Settings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Settings, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qDaO.Nav4Profile), {
        queryReference: data
    })));
}

});
parcelRegister("85PFP", function(module, exports) {
$parcel$export(module.exports, "AsyncGPAwarenessPill", () => $741cf9ca1bc131a8$export$1d8a1090b9b8aef0);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $741cf9ca1bc131a8$var$LazyGPAwarenessPill = (0, $bQWwW.lazyForPaint)(()=>Promise.resolve((parcelRequire("f58lN"))), {
    moduleId: "./src/packages/servicedesk/jsm-grace-period-banner/src/ui/gp-awareness-pill/index.tsx"
});
const $741cf9ca1bc131a8$export$1d8a1090b9b8aef0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($741cf9ca1bc131a8$var$LazyGPAwarenessPill, props));

});
parcelRegister("f58lN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "GpAwarenessPill", () => $1cf1a2633a5769f2$export$8c31c24d0f64d27a);
$parcel$export(module.exports, "GpAwarenessPillInternal", () => $1cf1a2633a5769f2$export$771c158f76877794);
$parcel$export(module.exports, "default", () => $1cf1a2633a5769f2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d8UFE = parcelRequire("d8UFE");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $lzT4f = parcelRequire("lzT4f");

var $22xih = parcelRequire("22xih");

var $e6YEs = parcelRequire("e6YEs");

var $gOf4q = parcelRequire("gOf4q");

var $lppZM = parcelRequire("lppZM");
var $KzPeJ = parcelRequire("KzPeJ");

var $1BZ8a = parcelRequire("1BZ8a");

var $cblKs = parcelRequire("cblKs");

var $8rGQ0 = parcelRequire("8rGQ0");

var $5vQ2T = parcelRequire("5vQ2T");

var $5g5cw = parcelRequire("5g5cw");

var $8Q6yE = parcelRequire("8Q6yE");


var $4cTDP = parcelRequire("4cTDP");

var $4EKqI = parcelRequire("4EKqI");

var $gAUyN = parcelRequire("gAUyN");

var $hYOCy = parcelRequire("hYOCy");
function $1cf1a2633a5769f2$export$8c31c24d0f64d27a({ analyticsOrigin: analyticsOrigin }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "gp-awareness-pill-top-nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jsm-grace-period-banner.ui.gp-awareness-pill",
        packageName: "jsm-grace-period-awareness-pill",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cf1a2633a5769f2$export$771c158f76877794, {
        analyticsOrigin: analyticsOrigin
    })));
}
const $1cf1a2633a5769f2$export$771c158f76877794 = ({ analyticsOrigin: analyticsOrigin })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $e6YEs.useAccountId)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const { product: product } = (0, $5g5cw.useProductAndEdition)();
    const { gpEndDate: gpEndDate, loading: gpEndDateLoading } = (0, $lzT4f.useJsmGracePeriodAnnouncementGpEndDateResource)();
    const { displayState: bannerDisplayState, loading: bannerDisplayStateLoading } = (0, $lzT4f.useJsmGracePeriodAnnouncementDisplayStateResource)(accountId);
    const { Panel: Panel, trigger: trigger } = (0, $KzPeJ.usePanel)();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const isCCP = productEntitlementDetails?.[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61]?.billingSourceSystem === 'CCP';
    const daysLeft = (0, $eJOHy.useMemo)(()=>(0, $gAUyN.daysLeftCalculation)((0, $22xih.FALLBACK_GP_END_DATE), gpEndDate), [
        gpEndDate
    ]);
    const getPillDetails = ()=>{
        if (daysLeft <= 7 && (0, $4cTDP.fg)('jsm_repackaging_t7_days_nudge_in_product')) return {
            announcementType: 'T7',
            fallbackDaysLeft: 7
        };
        if (daysLeft <= 30) return {
            announcementType: 'T30',
            fallbackDaysLeft: 30
        };
        return {
            announcementType: 'T90',
            fallbackDaysLeft: 90
        };
    };
    const isGPFinished = daysLeft <= 0;
    const { announcementType: announcementType } = getPillDetails();
    // We accidentally released the new T90 state for all customers
    // even if they had more than 90 days left in their GP.
    // Some of these customers might have already dismissed the banner
    // so we need to use the new state for the banner if their GP end date is after Nov 5, 2025
    // to for storing their T90 banner display state
    const useNewT90State = gpEndDate && gpEndDate > new Date('11/5/2025') && (0, $4cTDP.fg)('jsm_use_new_t90_state_jsm_gp_announcements');
    const handleOnClick = (_, analyticsEvent)=>{
        if (analyticsOrigin) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'jsmGracePeriodPill', {
            origin: analyticsOrigin
        });
    };
    const t90BannerIsVisible = announcementType === 'T90' && !bannerDisplayState?.hideT90Banner && !useNewT90State || announcementType === 'T90' && !bannerDisplayState?.hideT90BannerNew && useNewT90State;
    const t30BannerIsVisible = announcementType === 'T30' && !bannerDisplayState?.hideT30Banner;
    if (!isSiteAdmin || appEditions.serviceDesk !== (0, $cblKs.STANDARD_EDITION) || gpEndDateLoading || bannerDisplayStateLoading || t90BannerIsVisible || !(0, $4cTDP.fg)('jsm_show_gp_awareness_pill_t30') && t30BannerIsVisible || product !== 'jira-service-management' || isGPFinished || !isCCP || daysLeft > 90) return;
    return(// This onClick handler is needed to prevent a click event on the panel from bubbling up to the parent and closing the panel
    // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        onClick: (event)=>event.stopPropagation(),
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            width: 'max-content'
        }
    }, (0, $4cTDP.fg)('jsm_gp_intercom_fix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1cf1a2633a5769f2$var$panelBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Panel, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "jsmGracePeriodPill",
        sourceType: (0, $aa42ce8e355d58fa$export$238d30785c4bca84),
        attributes: {
            daysLeftInGP: daysLeft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $gOf4q.premiumLandingPageEntryPoint),
        entryPointProps: {
            origin: 'NAV_BAR',
            onClose: ()=>{
                trigger.setPanel(null);
            }
        }
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
            onClick: handleOnClick,
            xcss: [
                $1cf1a2633a5769f2$var$pressableStyles,
                announcementType === 'T30' && $1cf1a2633a5769f2$var$warningStyles,
                announcementType === 'T7' && $1cf1a2633a5769f2$var$dangerStyles
            ],
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "jsm-grace-period-banner.ui.gp-awareness-pill.button"
        }, announcementType === 'T7' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)",
            testId: "jsm-grace-period-banner.ui.gp-awareness-pill.status-error-icon"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
            label: "",
            color: "var(--ds-icon-warning, #E56910)",
            testId: "jsm-grace-period-banner.ui.gp-awareness-pill.status-warning-icon"
        }), gpEndDate ? formatMessage((0, $hYOCy.default).daysLeft, {
            days: daysLeft,
            symbol: ''
        }) : formatMessage((0, $hYOCy.default).daysLeftDefault)))), !(0, $4cTDP.fg)('jsm_gp_intercom_fix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Panel, null)));
};
const $1cf1a2633a5769f2$var$pressableStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    textDecoration: 'none !important',
    backgroundColor: 'color.background.neutral.subtle',
    display: 'inline-flex',
    border: `1px solid ${"var(--ds-border-warning, #E56910)"}`,
    borderRadius: 'radius.small',
    color: 'color.text.warning',
    flexShrink: 0,
    height: '2rem',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    alignItems: 'center',
    gap: 'space.075',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $1cf1a2633a5769f2$var$warningStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.warning',
    ':hover': {
        backgroundColor: 'color.background.warning.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.warning.pressed'
    }
});
const $1cf1a2633a5769f2$var$dangerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.danger',
    borderColor: 'color.border.danger',
    color: 'color.text.danger',
    ':hover': {
        backgroundColor: 'color.background.danger.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.danger.pressed'
    }
});
const $1cf1a2633a5769f2$var$panelBoxStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '1px',
    height: '1px'
});
var $1cf1a2633a5769f2$export$2e2bcd8739ae039 = $1cf1a2633a5769f2$export$8c31c24d0f64d27a;

});
parcelRegister("lzT4f", function(module, exports) {
$parcel$export(module.exports, "jsmGracePeriodAnnouncementDisplayStateResource", () => $20a65304ac3aab9f$export$9c4218ae35fac02e);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementDisplayStateResource", () => $20a65304ac3aab9f$export$fed541e4e6eb934c);
$parcel$export(module.exports, "jsmGracePeriodAnnouncementGpEndDateResource", () => $20a65304ac3aab9f$export$ee26341514033dab);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementGpEndDateResource", () => $20a65304ac3aab9f$export$6b1dcceb1bcecc4c);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $9pTd3 = parcelRequire("9pTd3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $kRgKj = parcelRequire("kRgKj");

var $22xih = parcelRequire("22xih");

const $20a65304ac3aab9f$export$9c4218ae35fac02e = (0, $l1VxS.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getDataLoader: ()=>(parcelRequire("4FZ4e")),
    maxAge: Infinity,
    isCritical: true
});
const $20a65304ac3aab9f$var$getNewAnnouncementDismissState = (bannerType, baseDisplayState, useNewT90State)=>{
    const getHideBannerKey = (warning, T90State)=>{
        if (warning === 'T90' && T90State) return 'hideT90BannerNew';
        return `hide${warning}Banner`;
    };
    const updatedState = {
        ...baseDisplayState,
        [getHideBannerKey(bannerType, useNewT90State)]: true
    };
    return updatedState;
};
const $20a65304ac3aab9f$export$fed541e4e6eb934c = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $eJrcF.useResource)($20a65304ac3aab9f$export$9c4218ae35fac02e);
    const loadingRef = (0, $eJOHy.useRef)(false);
    const errorRef = (0, $eJOHy.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eJOHy.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $eJOHy.useCallback)((baseState, bannerType, analyticsEvent, useNewT90State)=>{
        update(()=>$20a65304ac3aab9f$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Seqouia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $FppkK.setUserProperties)(accountId, (0, $22xih.JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify($20a65304ac3aab9f$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State))).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Sequoia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                // SQA-804: Add more typeOfUserEngagement attributes when we release the banner to low engaged GPC
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'dismissJsmGracePeriodBanner', {
                    source: 'jsmGracePeriodBanner',
                    bannerType: bannerType,
                    typeOfUserEngagement: 'high'
                });
                loadingRef.current = false;
            });
        }
    }, [
        update,
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            loading: loading,
            displayState: {
                hideT7Banner: true,
                hideT30Banner: true,
                hideT90Banner: true,
                hideT90BannerNew: true
            },
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            displayState: data,
            loading: loading,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

const $20a65304ac3aab9f$export$ee26341514033dab = (0, $l1VxS.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getDataLoader: ()=>(parcelRequire("phKXp")),
    maxAge: Infinity,
    isCritical: true,
    isBrowserOnly: true
});
const $20a65304ac3aab9f$export$6b1dcceb1bcecc4c = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($20a65304ac3aab9f$export$ee26341514033dab);
    const errorRef = (0, $eJOHy.useRef)();
    errorRef.current = error;
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading) return {
            loading: loading
        };
        return {
            gpEndDateDetails: data?.gpEndDateDetails,
            gpEndDate: data?.gracePeriodEndDate,
            loading: loading
        };
    }, [
        loading,
        data
    ]);
};

});
parcelRegister("22xih", function(module, exports) {
$parcel$export(module.exports, "JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $bbc1e6534917c377$export$7d5b09dea0d101b7);
$parcel$export(module.exports, "DEFAULT_ANNOUNCEMENT_BANNER_DISPLAY_STATE", () => $bbc1e6534917c377$export$3751c4ee78cb739a);
$parcel$export(module.exports, "FALLBACK_GP_END_DATE", () => $bbc1e6534917c377$export$a50854eacfeb5c82);
const $bbc1e6534917c377$export$7d5b09dea0d101b7 = 'jsm-grace-period-announcement-dismiss-state';
const $bbc1e6534917c377$export$3751c4ee78cb739a = {};
const $bbc1e6534917c377$export$a50854eacfeb5c82 = new Date('10/16/2025');

});

parcelRegister("4FZ4e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lpb1Z").then(()=>parcelRequire('eUCn3'));

});

parcelRegister("phKXp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iFE2p").then(()=>parcelRequire('3kT7K'));

});


parcelRegister("gOf4q", function(module, exports) {
$parcel$export(module.exports, "premiumLandingPageEntryPoint", () => $3faad70fc7c8ef01$export$eeb372f43c6f209);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3faad70fc7c8ef01$export$eeb372f43c6f209 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lsy0c")), {
        moduleId: "3167f693",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lsy0c", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("6YPzu")
]).then(()=>parcelRequire('8mWe6'));

});


parcelRegister("5g5cw", function(module, exports) {
$parcel$export(module.exports, "useProductAndEdition", () => $f7ef38d657c642b2$export$b0f1c0403c557678);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $eWzpp = parcelRequire("eWzpp");

var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");

var $8JLU7 = parcelRequire("8JLU7");
const $f7ef38d657c642b2$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const { loading: loading, data: project } = (0, $eWzpp.useProject)();
    const siteHasOnlyJira = (0, $8JLU7.useSiteHasOnlyJira)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $eJOHy.useMemo)(()=>{
        if (loading) return;
        const type = (0, $FhXEJ.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $FhXEJ.SOFTWARE_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira
    ]);
    const localEdition = (0, $eJOHy.useMemo)(()=>{
        if (!projectType) return;
        return (0, $cblKs.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType
    ]);
    const { product: product, edition: edition } = (0, $eJOHy.useMemo)(()=>{
        if (!projectType || !localEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $FhXEJ.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: $f7ef38d657c642b2$var$getEaProduct(projectType),
            edition: $f7ef38d657c642b2$var$getEaEdition(localEdition)
        };
    }, [
        localEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition
    };
};
const $f7ef38d657c642b2$var$getEaEdition = (e)=>{
    if (e === 'FREE_EDITION') return 'free';
    if (e === 'STANDARD_EDITION') return 'standard';
    if (e === 'PREMIUM_EDITION') return 'premium';
};
const $f7ef38d657c642b2$var$getEaProduct = (p)=>{
    if (p === (0, $FhXEJ.SOFTWARE_PROJECT)) return 'jira';
    if (p === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return 'jira-product-discovery';
    if (p === (0, $FhXEJ.SERVICE_DESK_PROJECT)) return 'jira-service-management';
    if (p === (0, $FhXEJ.CORE_PROJECT)) return 'jira';
};

});

parcelRegister("gAUyN", function(module, exports) {
$parcel$export(module.exports, "daysLeftCalculation", () => $15cacaaf363e5e55$export$e0919871eb31edc);

var $lw3Pj = parcelRequire("lw3Pj");
const $15cacaaf363e5e55$export$e0919871eb31edc = (fallbackGpEndDate, gpEndDate)=>(0, $lw3Pj.default)(gpEndDate ? new Date(gpEndDate) : fallbackGpEndDate, new Date(Date.now()));

});

parcelRegister("hYOCy", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a384cf7db166527$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3a384cf7db166527$var$messages = (0, $7qGN1.defineMessages)({
    daysLeft: {
        "id": "jsm-grace-period-banner.gp-awareness-pill.days-left",
        "defaultMessage": " {days, plural, one {#{symbol} day} other {#{symbol} days}} left"
    },
    daysLeftDefault: {
        "id": "jsm-grace-period-banner.gp-awareness-pill.days-left-default",
        "defaultMessage": "Action needed"
    }
});
var $3a384cf7db166527$export$2e2bcd8739ae039 = $3a384cf7db166527$var$messages;

});



parcelRegister("aNi5m", function(module, exports) {
$parcel$export(module.exports, "useCustomThemeData", () => $9331f111d2ea1519$export$2ba58a45723c145b);
$parcel$export(module.exports, "useSetCustomThemeData", () => $9331f111d2ea1519$export$2f61df8f2cb63ab2);
$parcel$export(module.exports, "CustomThemeDataProvider", () => $9331f111d2ea1519$export$770109ff6e18f82);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $bJscI = parcelRequire("bJscI");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");
const $9331f111d2ea1519$var$noop = ()=>{
/* empty */ };
const $9331f111d2ea1519$var$CustomThemeDataContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $9331f111d2ea1519$var$SetCustomThemeDataContext = /*#__PURE__*/ (0, $eJOHy.createContext)($9331f111d2ea1519$var$noop);
const $9331f111d2ea1519$export$2ba58a45723c145b = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-fix-custom-theme-data-hydration-error'), ()=>$9331f111d2ea1519$var$useCustomThemeContextState(), ()=>(0, $eJOHy.useContext)($9331f111d2ea1519$var$CustomThemeDataContext));
const $9331f111d2ea1519$export$2f61df8f2cb63ab2 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-fix-custom-theme-data-hydration-error'), ()=>$9331f111d2ea1519$var$useCustomThemeContextActions().update, ()=>(0, $eJOHy.useContext)($9331f111d2ea1519$var$SetCustomThemeDataContext));
/**
 *
 * Collects custom theme data and provides it via context to be used by CustomThemeAnalytics.
 *
 */ function $9331f111d2ea1519$var$CustomThemeDataProviderOld({ children: children }) {
    const [state, dispatch] = (0, $eJOHy.useReducer)($9331f111d2ea1519$var$reducer, {});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9331f111d2ea1519$var$CustomThemeDataContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9331f111d2ea1519$var$SetCustomThemeDataContext.Provider, {
        value: dispatch
    }, children));
}
const $9331f111d2ea1519$export$770109ff6e18f82 = (0, $bJscI.componentWithFG)('jfp-magma-fix-custom-theme-data-hydration-error', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children), $9331f111d2ea1519$var$CustomThemeDataProviderOld);
const $9331f111d2ea1519$var$reducer = (state, action)=>{
    return {
        ...state,
        ...action
    };
};
const $9331f111d2ea1519$var$initialState = {};
const $9331f111d2ea1519$var$store = (0, $GtRbT.createStore)({
    name: 'navigation-custom-theme-context',
    initialState: $9331f111d2ea1519$var$initialState,
    actions: {
        update: (customThemeData)=>({ setState: setState })=>{
                setState(customThemeData);
            }
    }
});
const $9331f111d2ea1519$var$useCustomThemeContextState = (0, $iJq0l.createStateHook)($9331f111d2ea1519$var$store);
const $9331f111d2ea1519$var$useCustomThemeContextActions = (0, $iJq0l.createActionsHook)($9331f111d2ea1519$var$store);

});

parcelRegister("kyPau", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c807c28021f273ee$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c807c28021f273ee$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-collapse-label",
        "defaultMessage": "Collapse sidebar"
    },
    sideNavToggleButtonExpandLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-expand-label",
        "defaultMessage": "Expand sidebar"
    },
    sideNavToggleButtonCollapseLabelWithShortcut: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-collapse-label-with-shortcut",
        "defaultMessage": "Collapse sidebar ["
    },
    sideNavToggleButtonExpandLabelWithShortcut: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-expand-label-with-shortcut",
        "defaultMessage": "Expand sidebar ["
    }
});

});

parcelRegister("2qDaO", function(module, exports) {
$parcel$export(module.exports, "Nav4Profile", () => $9f311efe117b416c$export$c928b6dc7cf1e4c6);

var $eg7wv = parcelRequire("eg7wv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $eUaD0 = parcelRequire("eUaD0");

var $afUiu = parcelRequire("afUiu");

var $kh7bJ = parcelRequire("kh7bJ");

var $RXvVX = parcelRequire("RXvVX");

var $cailY = parcelRequire("cailY");

var $kyq27 = parcelRequire("kyq27");

var $85wfa = parcelRequire("85wfa");
var $lf67V = parcelRequire("lf67V");
var $gAaxd = parcelRequire("gAaxd");


var $6Si1n = parcelRequire("6Si1n");
function $9f311efe117b416c$export$c928b6dc7cf1e4c6({ queryReference: queryReference }) {
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eUaD0.NavigationAnalyticsContext), {
        data: (0, $gAaxd.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85wfa.AccountMenuIntlProvider), null, isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f311efe117b416c$var$Nav4ProfileAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f311efe117b416c$var$Nav4ProfileLoggedIn, {
        queryReference: queryReference
    })));
}
function $9f311efe117b416c$var$Nav4ProfileLoggedIn({ queryReference: queryReference }) {
    const data = (0, $j4oe4.useFragment)((0, $eg7wv.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Si1n.Nav4AccountMenu), {
        testId: (0, $RXvVX.testIdGenerate)('secondary-actions', 'profile'),
        picture: data?.user?.picture,
        email: data?.user?.email ?? ''
    });
}
function $9f311efe117b416c$var$Nav4ProfileAnonymous() {
    const environment = (0, $kyq27.useEnvironment)();
    const identityEnv = (0, $cailY.getIdentityEnv)(environment);
    const links = (0, $afUiu.useAccountLinks)({
        email: '',
        identityEnvironment: identityEnv,
        application: 'jira',
        continueUrl: (0, $cailY.getContinueUrl)({
            type: (0, $982bab3922601ed3$export$eed606b4351295d7)
        }),
        isLoggedOut: true
    });
    return links?.logInLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lf67V.AccountMenuLoggedOutStateNav3), {
        testId: (0, $RXvVX.testIdGenerate)('secondary-actions', 'profile'),
        logInLink: links.logInLink
    });
}

});
parcelRegister("eg7wv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b3f7a2ef4e9bc7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfd54e9247740605775ae15e963f8bce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b3f7a2ef4e9bc7d$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "atlassianAccountId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Profile",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "atlassianAccountId"
                }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "email"
                        }
                    ],
                    "type": "AtlassianAccountUser"
                }
            ]
        }
    ],
    "type": "Query"
};
$4b3f7a2ef4e9bc7d$var$node.hash = "6d28f09535aba53e908aff58b1a38fdd";
var $4b3f7a2ef4e9bc7d$export$2e2bcd8739ae039 = $4b3f7a2ef4e9bc7d$var$node;

});

parcelRegister("RXvVX", function(module, exports) {
$parcel$export(module.exports, "testIdConcat", () => $233d588e07ae49d0$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $233d588e07ae49d0$export$3b86b974ae586844);
const $233d588e07ae49d0$var$PREFIX = 'atlassian-navigation-';
const $233d588e07ae49d0$var$SEPARATOR = '--';
const $233d588e07ae49d0$var$isValid = (value)=>value != null && value !== '';
const $233d588e07ae49d0$export$794609946480f79c = (id, ...items)=>[
        id,
        ...items
    ].filter(Boolean).join($233d588e07ae49d0$var$SEPARATOR).toLowerCase();
const $233d588e07ae49d0$export$3b86b974ae586844 = (first, ...rest)=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    $233d588e07ae49d0$export$794609946480f79c($233d588e07ae49d0$var$PREFIX + ($233d588e07ae49d0$var$isValid(first) ? `-${first}` : ''), ...rest);

});

parcelRegister("cailY", function(module, exports) {
$parcel$export(module.exports, "getWindow", () => $8de64f7cb31a9d85$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getContinueUrl", () => $8de64f7cb31a9d85$export$8c0854445d46e88e);
$parcel$export(module.exports, "getIdentityEnv", () => $8de64f7cb31a9d85$export$b3f2b8c6cd294d68);

var $efWct = parcelRequire("efWct");

var $4cTDP = parcelRequire("4cTDP");

var $dOwXt = parcelRequire("dOwXt");

const $8de64f7cb31a9d85$export$38b2d434cce3ea22 = ()=>false ? null : window;
const $8de64f7cb31a9d85$export$8c0854445d46e88e = ({ type: type })=>{
    const { href: href = '', protocol: protocol = '', host: host = '' } = (0, $dOwXt.default)() ?? {};
    if (type === (0, $982bab3922601ed3$export$eed606b4351295d7)) return href;
    if (type === (0, $982bab3922601ed3$export$35e541d26a145a7c)) return protocol && host ? `${protocol}//${host}` : '';
    return '';
};
const $8de64f7cb31a9d85$var$resolveIdentityEnv = (env)=>{
    switch(env){
        case 'local':
            return 'staging';
        case 'dev':
            return 'staging';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        default:
            return 'prod';
    }
};
const $8de64f7cb31a9d85$export$b3f2b8c6cd294d68 = (env)=>{
    if ((0, $4cTDP.fg)('nav_4_-_ic_idp_paths_for_swicher')) {
        const resolvedEnvironment = $8de64f7cb31a9d85$var$resolveIdentityEnv(env);
        const urlForDomain = (0, $efWct.getUrlForDomainInContext)('id', resolvedEnvironment);
        if (urlForDomain === undefined) return resolvedEnvironment;
        return {
            baseUrl: urlForDomain
        };
    }
    // Legacy behavior - return the resolved environment directly
    return $8de64f7cb31a9d85$var$resolveIdentityEnv(env);
};

});
parcelRegister("dOwXt", function(module, exports) {
$parcel$export(module.exports, "default", () => $802e6117e996a19b$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ const $802e6117e996a19b$var$getLocation = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};
var $802e6117e996a19b$export$2e2bcd8739ae039 = $802e6117e996a19b$var$getLocation;

});


parcelRegister("6Si1n", function(module, exports) {
$parcel$export(module.exports, "Nav4AccountMenu", () => $a56b19ed2544e06a$export$793e3aab7101233f);

var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $7ep4S = parcelRequire("7ep4S");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $guChT = parcelRequire("guChT");

var $hgZ04 = parcelRequire("hgZ04");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $dZ3jN = parcelRequire("dZ3jN");

var $fwPtS = parcelRequire("fwPtS");

var $4cTDP = parcelRequire("4cTDP");

var $286cZ = parcelRequire("286cZ");

var $e6YEs = parcelRequire("e6YEs");
const $a56b19ed2544e06a$export$793e3aab7101233f = /*#__PURE__*/ (0, $eJOHy.memo)(({ testId: testId, picture: picture, email: email })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const atlassianAccountId = (0, $e6YEs.useAccountId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            atlassianAccountId: atlassianAccountId ?? '',
            jiraOnboardingHubGateEnabled: (0, $4cTDP.fg)('jira-onboarding-hub-gate') ?? false
        }), [
        atlassianAccountId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $fwPtS.Nav4ProfileMenuEntryPoint), entryPointParams);
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onClosePopup: ()=>{
                setIsOpen(false);
            },
            testId: testId,
            accountId: (0, $4cTDP.fg)('shared-user-preferences') ? atlassianAccountId : undefined
        }), [
        testId,
        atlassianAccountId
    ]);
    const TriggerInternal = (0, $eJOHy.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a56b19ed2544e06a$var$Trigger, {
            triggerRef: triggerRef,
            setIsOpen: setIsOpen,
            testId: testId,
            picture: picture,
            email: email,
            isOpen: isOpen,
            triggerProps: triggerProps
        });
    }, [
        triggerRef,
        setIsOpen,
        testId,
        picture,
        email,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        isOpen: isOpen,
        onClose: (0, $eJOHy.useCallback)(()=>{
            setIsOpen(false);
        }, []),
        testId: testId,
        placement: "bottom",
        trigger: TriggerInternal,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "atlassian-navigation-profile-menu",
                packageName: "atlassian-navigation-profile-menu",
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $a56b19ed2544e06a$var$Nav4AccountMenuContentSkeletonStyles,
                    padding: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null)),
                runtimeProps: runtimeProps
            })
    });
});
const $a56b19ed2544e06a$var$AccountMenuTrigger = (0, $286cZ.memoWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-stability-fixes-nav-misc'), (0, $hgZ04.AccountMenuTriggerNav3));
function $a56b19ed2544e06a$var$Trigger({ triggerRef: triggerRef, setIsOpen: setIsOpen, testId: testId, picture: picture, email: email, isOpen: isOpen, triggerProps: triggerProps }) {
    const ref = (0, $eJOHy.useCallback)((element)=>{
        triggerRef(element);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        triggerProps.ref(element);
    }, [
        triggerRef,
        triggerProps.ref
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        setIsOpen((open)=>!open);
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "profile-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a56b19ed2544e06a$var$AccountMenuTrigger, {
        ref: ref,
        onClick: onClick,
        testId: testId && `${testId}--trigger`,
        picture: picture,
        trustPicture: true,
        email: email,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        "aria-controls": testId && `${testId}--content`,
        "data-ds--level": triggerProps['data-ds--level']
    }));
}
// These styles are defined to ensure that the initial popup for the AccountMenu content is the same width when
// displaying the skeleton loader as when displaying the actual content.
const $a56b19ed2544e06a$var$Nav4AccountMenuContentSkeletonStyles = (0, $1DXK0.xcss)({
    width: '304px',
    height: '307px'
});

});
parcelRegister("fwPtS", function(module, exports) {
$parcel$export(module.exports, "Nav4ProfileMenuEntryPoint", () => $ec6e142b597062c3$export$e30a856958207b6);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $8ccV7 = parcelRequire("8ccV7");

const $ec6e142b597062c3$export$e30a856958207b6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8h8tD")), {
        moduleId: "d110fb34",
        moduleName: "AccountMenuContentContainer",
        priority: "interaction"
    }),
    getPreloadProps: ({ atlassianAccountId: atlassianAccountId, jiraOnboardingHubGateEnabled: jiraOnboardingHubGateEnabled })=>({
            queries: {
                AccountMenuContentContainerQuery: {
                    parameters: $8ccV7.default,
                    variables: {
                        atlassianAccountId: atlassianAccountId ?? '',
                        jiraOnboardingHubGateEnabled: jiraOnboardingHubGateEnabled ?? false
                    }
                }
            }
        })
});

});
parcelRegister("8ccV7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4a99c58b85f169d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b9d71e7f3be3e3256c97597d3727795>>
 * @relayHash 5298e24274edcdd24f1530eced4576dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 863414cde0dcb622159a058828c6866ddc05b90a43abef3314df98010134368a
const $b4a99c58b85f169d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "863414cde0dcb622159a058828c6866ddc05b90a43abef3314df98010134368a",
        "metadata": {},
        "name": "AccountMenuContentContainerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b4a99c58b85f169d$export$2e2bcd8739ae039 = $b4a99c58b85f169d$var$node;

});

parcelRegister("8h8tD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('edition_awareness_upsell_jira_ab_fg', function() {
        return Promise.all([
            $ewTvA("dHAND")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("aQyvI")
        ]);
    }),
    $ewTvA("2JDXE")
]).then(()=>parcelRequire('4dcum'));

});




parcelRegister("8aPak", function(module, exports) {
$parcel$export(module.exports, "useSiteTitle", () => $059c3e654e9e086d$export$3e157e0d79928990);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");
const $059c3e654e9e086d$export$3e157e0d79928990 = ()=>(0, $eJOHy.useMemo)(()=>({
            shouldShow: (0, $hWeHP.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $hWeHP.default)('ajs-app-title')
        }), []);

});

parcelRegister("45yGs", function(module, exports) {
$parcel$export(module.exports, "ProductHomeRelayWithErrorBoundary", () => $cc6c1b20d5a4e347$export$92a318b7c45f2cde);

var $4ZsDP = parcelRequire("4ZsDP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jjS5D = parcelRequire("jjS5D");

var $5vQ2T = parcelRequire("5vQ2T");


var $2imLM = parcelRequire("2imLM");
const $cc6c1b20d5a4e347$export$92a318b7c45f2cde = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "Nav4TopNavProductHomeRelay",
        packageName: (0, $982bab3922601ed3$export$b8b9d90f9e5bd72b),
        teamName: (0, $982bab3922601ed3$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav4-top-nav-product-home-relay",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            isShimmering: true,
            width: "100px",
            height: "20px"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc6c1b20d5a4e347$export$25726974b0b03c16, props)));
function $cc6c1b20d5a4e347$export$25726974b0b03c16({ queryReference: queryReference, renderProductHome: ProductHomeComponent }) {
    const data = (0, $j4oe4.useFragment)((0, $4ZsDP.default), queryReference);
    const issueProjectType = data?.jira?.jiraProjectByKey?.projectType ?? data?.jira?.issueByKey?.projectField?.project?.projectType;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProductHomeComponent, {
        projectType: issueProjectType
    });
}

});
parcelRegister("4ZsDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $29406556a9ebb8db$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cfeff55e4c10d9db7462341e8266653>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $29406556a9ebb8db$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "issueKey"
            },
            {
                "kind": "RootArgument",
                "name": "projectKey"
            },
            {
                "kind": "RootArgument",
                "name": "shouldCheckProjectType"
            },
            {
                "kind": "RootArgument",
                "name": "shouldCheckProjectTypeForIssue"
            }
        ],
        "kind": "Fragment",
        "name": "ProductHomeRelay",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "shouldCheckProjectTypeForIssue",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "key",
                                        "variableName": "issueKey"
                                    }
                                ],
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectField",
                                        "kind": "LinkedField",
                                        "name": "projectField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": v1 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "shouldCheckProjectType",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "key",
                                        "variableName": "projectKey"
                                    }
                                ],
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": v1 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$29406556a9ebb8db$var$node.hash = "a91db417f54284e616e6dc852d07c01c";
var $29406556a9ebb8db$export$2e2bcd8739ae039 = $29406556a9ebb8db$var$node;

});




parcelRegister("fhzEL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a179485b68d7ae10$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a179485b68d7ae10$var$LazyCustomThemeAdminFlag = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("kMlJR")), {
    ssr: false,
    moduleId: "./src/packages/theme/custom-theme-admin-flag/src/index.tsx"
});
const $a179485b68d7ae10$var$AsyncCustomThemeAdminFlag = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "async.jira.custom-theme-admin-flag",
        packageName: "customThemeAdminFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "custom-theme-admin-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a179485b68d7ae10$var$LazyCustomThemeAdminFlag, null)));
var $a179485b68d7ae10$export$2e2bcd8739ae039 = $a179485b68d7ae10$var$AsyncCustomThemeAdminFlag;

});
parcelRegister("kMlJR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aAfbH").then(()=>parcelRequire('gE9ms'));

});


parcelRegister("cfwEM", function(module, exports) {
$parcel$export(module.exports, "EditionAwareness", () => $7991a2b5dc7ebd5f$export$a55b02efe3d62583);

var $eJOHy = parcelRequire("eJOHy");

var $9Xpv1 = parcelRequire("9Xpv1");

var $dTV4H = parcelRequire("dTV4H");

var $5vQ2T = parcelRequire("5vQ2T");

var $kGj4V = parcelRequire("kGj4V");
var $ftN6c = parcelRequire("ftN6c");

var $8rGQ0 = parcelRequire("8rGQ0");

var $kAwwe = parcelRequire("kAwwe");

var $4EKqI = parcelRequire("4EKqI");

var $2IPZ1 = parcelRequire("2IPZ1");

var $cSXp8 = parcelRequire("cSXp8");

var $EzBXZ = parcelRequire("EzBXZ");

var $D3BHJ = parcelRequire("D3BHJ");

var $cHtIB = parcelRequire("cHtIB");

var $lctcw = parcelRequire("lctcw");

var $9pTd3 = parcelRequire("9pTd3");

var $e6YEs = parcelRequire("e6YEs");

var $kyq27 = parcelRequire("kyq27");

var $4cTDP = parcelRequire("4cTDP");

var $lopBx = parcelRequire("lopBx");

var $euq3J = parcelRequire("euq3J");

var $5zh0z = parcelRequire("5zh0z");
const $7991a2b5dc7ebd5f$var$EditionAwarenessPlatformInnerWithRTCheck = (props)=>{
    const { isReady: isReady, isInReverseTrial: isInReverseTrial, onOpenOnboardingMenu: onOpenOnboardingMenu } = (0, $5zh0z.useReverseTrials)();
    // We need to wait for the reverse trial check to be complete before rendering the button
    const canRender = props.canRender && isReady;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2IPZ1.EditionAwareness), {
        ...props,
        isInReverseTrial: isInReverseTrial,
        onOpenOnboardingMenu: onOpenOnboardingMenu,
        canRender: canRender
    });
};
const $7991a2b5dc7ebd5f$var$EditionAwarenessPlatformInner = (props)=>{
    const { isDismissed: isDismissed, handleDismiss: handleDismiss } = (0, $9Xpv1.useIsEditionAwarenessPillDismissed)(props.product);
    const { isEligibleForUpsellEa: isEligibleForUpsellEa } = (0, $dTV4H.useIsEligibleForUpsellEa)({
        product: props.product,
        edition: props.edition,
        isSiteAdmin: Boolean(props.userRoles?.includes('SITE_ADMIN'))
    });
    return isEligibleForUpsellEa ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $D3BHJ.EditionAwarenessUpsell), (({ product: product, cloudId: cloudId, edition: edition, userRoles: userRoles })=>({
            product: product,
            cloudId: cloudId,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: isDismissed,
            onDismissButton: handleDismiss
        }))(props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2IPZ1.EditionAwareness), props);
};
const $7991a2b5dc7ebd5f$var$EditionAwarenessPlatform = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const environment = (0, $kyq27.useEnvironment)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const isJiraAdmin = (0, $kAwwe.useIsAdmin)();
    const { product: product, edition: edition } = (0, $euq3J.useProductAndEdition)();
    const isFedRampEnv = (0, $lopBx.isFedRamp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Planned to be expanded as we add new actions
    const getAction = (0, $eJOHy.useCallback)(async ()=>null, []);
    const userRoles = (0, $eJOHy.useMemo)(()=>{
        const roles = [];
        if (isSiteAdmin) roles.push('SITE_ADMIN');
        if (isJiraAdmin) roles.push('JIRA_ADMIN');
        return roles;
    }, [
        isSiteAdmin,
        isJiraAdmin
    ]);
    const [siteTraits, setSiteTraits] = (0, $eJOHy.useState)(()=>{
        // Calculate which editions need to fetch traits
        if (edition === 'free' || edition === 'standard' && product === 'jira') return undefined;
        if (edition === 'standard' && (0, $4cTDP.fg)('ea_fetch_traits_for_standard_edition')) // enable trait checking for all products in standard
        return undefined;
        return [];
    });
    (0, $eJOHy.useEffect)(()=>{
        if (siteTraits === undefined) (0, $lctcw.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        }).then((traits)=>{
            setSiteTraits(traits);
        }).catch((e)=>{
            setSiteTraits([]);
            const event = createAnalyticsEvent({});
            (0, $9pTd3.fireErrorAnalytics)({
                event: event,
                meta: {
                    id: 'editionAwarenessGrowthCohortTrait',
                    packageName: 'edition-awareness',
                    teamName: 'growth-tako'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        edition,
        siteTraits
    ]);
    // We need to wait for the siteType to be set before rendering the button
    const canRender = siteTraits !== undefined;
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const handleShowFlag = (0, $eJOHy.useCallback)((flag)=>{
        const { appearance: appearance, id: id, ...flagArgs } = flag;
        const type = !appearance || appearance === 'normal' ? 'info' : appearance;
        showFlag({
            ...flagArgs,
            // Assumes that when we're showing flags from edition awareness they are transactional
            messageType: 'transactional',
            messageId: id,
            type: type
        });
    }, [
        showFlag
    ]);
    const editionAwarenessProps = (0, $eJOHy.useMemo)(()=>{
        if (!product || !edition) return null;
        if (!accountId) // We don't render when the customer is not logged in
        return null;
        return {
            edition: edition,
            cloudId: cloudId,
            product: product,
            accountId: accountId,
            environment: environment,
            userRoles: userRoles,
            siteTraits: siteTraits,
            canRender: canRender,
            getAction: getAction,
            showFlag: handleShowFlag,
            hideFlag: dismissFlag
        };
    }, [
        accountId,
        canRender,
        cloudId,
        edition,
        environment,
        userRoles,
        product,
        siteTraits,
        getAction,
        handleShowFlag,
        dismissFlag
    ]);
    if (!editionAwarenessProps) return null;
    if (isFedRampEnv) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            isSiteAdmin: isSiteAdmin,
            product: product,
            edition: edition
        }
    }, edition === 'premium' && product === 'jira' ? // We need to call a few hooks to check RT, could be cleaned up in the future
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7991a2b5dc7ebd5f$var$EditionAwarenessPlatformInnerWithRTCheck, editionAwarenessProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7991a2b5dc7ebd5f$var$EditionAwarenessPlatformInner, editionAwarenessProps));
};
const $7991a2b5dc7ebd5f$export$a55b02efe3d62583 = ()=>{
    // This component is not rendered on the server, we don't have enough information to determine if it will be renderer or not
    // Don't remove because it may cause the SSR to fail, at this point it because the EditonAwarenessButton is using useLazyLoadQuery
    if (false && !(0, $4cTDP.fg)('jfp-magma-4013-fix-hydration-edition-awareness')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), {
        fg: "jfp-magma-4013-fix-hydration-edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "EditionAwareness",
        packageName: "jiraNavigationAppsSidebarEditionAwareness",
        fallback: "unmount",
        teamName: "growth-tako"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7991a2b5dc7ebd5f$var$EditionAwarenessPlatform, null))));
};

});
parcelRegister("9Xpv1", function(module, exports) {
$parcel$export(module.exports, "useIsEditionAwarenessPillDismissed", () => $8282dbcbead58be8$export$7cb865d6d91f9a4d);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $188GL = parcelRequire("188GL");
const $8282dbcbead58be8$export$7cb865d6d91f9a4d = (product)=>{
    const [hasFetched, setHasFetched] = (0, $eJOHy.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $eJOHy.useState)(true);
    const canDismiss = product === 'jira-product-discovery' ? (0, $4cTDP.fg)('upsell_edition_awareness_jpd_fg') : (0, $4cTDP.fg)('edition_awareness_upsell_jira_ab_fg');
    (0, $eJOHy.useEffect)(()=>{
        if (canDismiss) (0, $188GL.fetchEditionAwarenessPillDismissed)().then((result)=>{
            // if result is undefined, it means the call failed and we can't be certain if the user dismissed the pill or not
            if (result !== undefined) {
                setIsDismissed(!!result);
                setHasFetched(true);
            }
        });
    }, [
        canDismiss
    ]);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        if (canDismiss) {
            setIsDismissed(true);
            (0, $188GL.setEditionAwarenessPillDismissed)(true);
        }
    }, [
        canDismiss
    ]);
    return {
        hasFetched: hasFetched,
        isDismissed: isDismissed,
        handleDismiss: handleDismiss
    };
};

});
parcelRegister("188GL", function(module, exports) {
$parcel$export(module.exports, "setEditionAwarenessPillDismissed", () => $d518b7568ce924cc$export$b0b754c480c139ac);
$parcel$export(module.exports, "fetchEditionAwarenessPillDismissed", () => $d518b7568ce924cc$export$1eb6cd4dd0048115);

var $9DB7T = parcelRequire("9DB7T");

var $9pTd3 = parcelRequire("9pTd3");

const $d518b7568ce924cc$var$ProductKeyToHAMSMap = {
    jira: 'jira-software',
    'jira-product-discovery': 'jira-product-discovery',
    'jira-service-management': 'jira-servicedesk'
};
const $d518b7568ce924cc$export$291d012eb0744b34 = (product)=>{
    return $d518b7568ce924cc$var$ProductKeyToHAMSMap[product];
};
const $d518b7568ce924cc$export$b0b754c480c139ac = async (value)=>{
    try {
        await (0, $9DB7T.userPreferenceAPI).set((0, $e6e0b17becc5e339$export$83e119fb36bc846a), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'setEditionAwarenessPillDismissed',
                packageName: (0, $e6e0b17becc5e339$export$52483b87432059f1)
            }
        });
    }
};
const $d518b7568ce924cc$export$1eb6cd4dd0048115 = async ()=>{
    try {
        return await (0, $9DB7T.userPreferenceAPI).get((0, $e6e0b17becc5e339$export$83e119fb36bc846a));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode === 404) return null;
        (0, $9pTd3.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'fetchEditionAwarenessPillDismissed',
                packageName: (0, $e6e0b17becc5e339$export$52483b87432059f1)
            }
        });
        return undefined;
    }
};

});
const $e6e0b17becc5e339$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $e6e0b17becc5e339$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';



parcelRegister("dTV4H", function(module, exports) {
$parcel$export(module.exports, "useIsEligibleForUpsellEa", () => $cb664e593b493fd5$export$d937ac4841c15ef7);
/* eslint-disable jira/ff/unsafe-no-exposure */ /* eslint-disable jira/deprecations/ban-identifiers */ 

var $8Q6yE = parcelRequire("8Q6yE");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $5tQVZ = parcelRequire("5tQVZ");
const $cb664e593b493fd5$export$d937ac4841c15ef7 = ({ product: product, edition: edition, isSiteAdmin: isSiteAdmin })=>{
    const isJpd = product === (0, $315aedf92e50a945$export$202f50ee62667e32);
    const [expConfig] = isJpd ? (0, $cxKOj.UNSAFE_noExposureExp)('edition_awareness_upsell_jpd') : (0, $cxKOj.UNSAFE_noExposureExp)('edition_awareness_upsell_jira_ab');
    const passesFeatureGate = isJpd ? (0, $4cTDP.fg)('upsell_edition_awareness_jpd_fg') : (0, $4cTDP.fg)('edition_awareness_upsell_jira_ab_fg');
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const enrolled = cohort !== 'not-enrolled';
    // Trial State logic
    let productKey;
    switch(product){
        case 'jira':
            productKey = (0, $315aedf92e50a945$export$1346c9aa3cbb477d);
            break;
        case 'jira-service-management':
            productKey = (0, $315aedf92e50a945$export$c8c1c8c3f8ddba61);
            break;
        case 0, $315aedf92e50a945$export$202f50ee62667e32:
            productKey = (0, $315aedf92e50a945$export$202f50ee62667e32);
            break;
        default:
    }
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const trialDaysLeft = (0, $5tQVZ.getTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime);
    const isInTrial = !entitlementDetails ? undefined : !!trialDaysLeft && trialDaysLeft > 0;
    // Check if site is in pre-dunning period
    // If firstPredunningEndTime exists and current time is before it, site is in pre-dunning
    // If firstPredunningEndTime doesn't exist, site is not in pre-dunning
    const isInPreDunning = !entitlementDetails ? undefined : entitlementDetails.firstPredunningEndTime !== undefined && Date.now() <= entitlementDetails.firstPredunningEndTime;
    const isEligibleForUpsellEa = edition === 'standard' && enrolled && isInTrial === false && isInPreDunning === false && isSiteAdmin && passesFeatureGate;
    return {
        isEligibleForUpsellEa: isEligibleForUpsellEa,
        cohort: cohort
    };
};

});

parcelRegister("euq3J", function(module, exports) {
$parcel$export(module.exports, "useProductAndEdition", () => $ff20f75f2ccd94bd$export$b0f1c0403c557678);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $eWzpp = parcelRequire("eWzpp");

var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");

var $8JLU7 = parcelRequire("8JLU7");
const $ff20f75f2ccd94bd$export$8aab08255f8e5ef0 = {
    FREE_EDITION: 'free',
    STANDARD_EDITION: 'standard',
    PREMIUM_EDITION: 'premium'
};
const $ff20f75f2ccd94bd$export$7e5a22794fbe56f2 = {
    [(0, $FhXEJ.SOFTWARE_PROJECT)]: 'jira',
    [(0, $FhXEJ.CORE_PROJECT)]: 'jira',
    [(0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)]: 'jira-product-discovery',
    [(0, $FhXEJ.SERVICE_DESK_PROJECT)]: 'jira-service-management'
};
const $ff20f75f2ccd94bd$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const { loading: loading, data: project } = (0, $eWzpp.useProject)();
    const siteHasOnlyJira = (0, $8JLU7.useSiteHasOnlyJira)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $eJOHy.useMemo)(()=>{
        if (loading) return;
        const type = (0, $FhXEJ.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $FhXEJ.SOFTWARE_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira
    ]);
    const applicationEdition = (0, $eJOHy.useMemo)(()=>{
        if (!projectType) return;
        if (siteHasOnlyJira) return (0, $cblKs.getEditionForProject)((0, $FhXEJ.SOFTWARE_PROJECT), appEditions);
        return (0, $cblKs.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType,
        siteHasOnlyJira
    ]);
    const { product: product, edition: edition } = (0, $eJOHy.useMemo)(()=>{
        if (!projectType || !applicationEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $FhXEJ.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: $ff20f75f2ccd94bd$export$7e5a22794fbe56f2[projectType],
            edition: $ff20f75f2ccd94bd$export$8aab08255f8e5ef0[applicationEdition]
        };
    }, [
        applicationEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition
    };
};

});

parcelRegister("5zh0z", function(module, exports) {
$parcel$export(module.exports, "useReverseTrials", () => $fcb777164f524568$export$8f6d4c7745b1e143);

var $eJOHy = parcelRequire("eJOHy");

var $6BWBy = parcelRequire("6BWBy");

var $9ycBx = parcelRequire("9ycBx");

var $gxP9D = parcelRequire("gxP9D");

var $157bu = parcelRequire("157bu");
const $fcb777164f524568$export$8f6d4c7745b1e143 = ()=>{
    const openChecklist = (0, $157bu.useOpenChecklist)();
    const [{ currentTaskGroupParent: currentTaskGroupParent }, { changeTaskGroupParent: changeTaskGroupParent, nextOpenTask: nextOpenTask }] = (0, $gxP9D.useJswOnboarding)();
    const { isInReverseTrial: isInReverseTrial, isReady: isRTReady } = (0, $6BWBy.useInReverseTrial)();
    const onOpenOnboardingMenu = (0, $eJOHy.useCallback)(()=>{
        const taskGroupToEnter = (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK);
        if (currentTaskGroupParent !== taskGroupToEnter) changeTaskGroupParent(taskGroupToEnter);
        openChecklist({
            trigger: 'ReverseTrialPopup'
        });
        nextOpenTask((0, $9ycBx.ADVANCED_ROADMAPS_TASK), {
            closeNudge: true
        });
    }, [
        currentTaskGroupParent,
        openChecklist,
        nextOpenTask,
        changeTaskGroupParent
    ]);
    if (!isRTReady) return {
        isReady: false,
        isInReverseTrial: undefined,
        onOpenOnboardingMenu: undefined
    };
    return {
        isReady: true,
        isInReverseTrial: isInReverseTrial,
        onOpenOnboardingMenu: onOpenOnboardingMenu
    };
};

});
parcelRegister("6BWBy", function(module, exports) {
$parcel$export(module.exports, "useInReverseTrial", () => $794f89c220c2a333$export$76f7829aa123c9c4);

var $bf3Zm = parcelRequire("bf3Zm");

var $cfSuG = parcelRequire("cfSuG");
/**
 * This hook is used to check if the user is signed up in a reverse trial
 * and also user is within the attribution window
 * which identify the user is currently in the 'first' reverse trial
 */ const $794f89c220c2a333$var$ATTRIBUTION_WINDOW = 45; // days
const $794f89c220c2a333$export$750abf5956643c1a = 86400000;
const $794f89c220c2a333$export$76f7829aa123c9c4 = ()=>{
    const firstActivationDate = (0, $bf3Zm.useFirstActivationDateMs)();
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $cfSuG.useFetchOnboardingReverseTrial)();
    if (isReady) return {
        isInReverseTrial: premiumTrialOnSignup && !!firstActivationDate && Date.now() - firstActivationDate <= $794f89c220c2a333$var$ATTRIBUTION_WINDOW * $794f89c220c2a333$export$750abf5956643c1a,
        isReady: isReady
    };
    return {
        isInReverseTrial: undefined,
        isReady: isReady
    };
};

});
parcelRegister("cfSuG", function(module, exports) {
$parcel$export(module.exports, "useFetchOnboardingReverseTrial", () => $5c65dd7c35521683$export$349fbee95cd03b58);

var $eJOHy = parcelRequire("eJOHy");

var $kGrDm = parcelRequire("kGrDm");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $6o0qB = parcelRequire("6o0qB");

var $6zABd = parcelRequire("6zABd");
const $5c65dd7c35521683$var$store = (0, $GtRbT.createStore)({
    name: 'jsw-onboarding-reverse-trial',
    initialState: (0, $kGrDm.initialCachedEndpointState),
    actions: $6zABd.actions
});
const $5c65dd7c35521683$export$6758b294795e1644 = (0, $iJq0l.createHook)($5c65dd7c35521683$var$store);
const $5c65dd7c35521683$export$349fbee95cd03b58 = ()=>{
    const isTargetedForReverseTrials = (0, $6o0qB.useIsTargetedForReverseTrials)();
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { getPremiumTrialOnSignup: getPremiumTrialOnSignup }] = $5c65dd7c35521683$export$6758b294795e1644();
    (0, $eJOHy.useEffect)(()=>{
        if (isTargetedForReverseTrials && !fetchedOnce && !isFetching && data === undefined) // @ts-expect-error Arguments for the rest parameter 'args' were not provided.
        getPremiumTrialOnSignup();
    }, [
        data,
        fetchedOnce,
        getPremiumTrialOnSignup,
        isFetching,
        isTargetedForReverseTrials
    ]);
    if (!isTargetedForReverseTrials) // If not targeted, no fetching is done. Data is ready to be read
    return {
        premiumTrialOnSignup: undefined,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: true
    };
    return {
        premiumTrialOnSignup: data?.premiumTrialOnSignup,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: fetchedOnce && !isFetching
    };
};

});
parcelRegister("kGrDm", function(module, exports) {
$parcel$export(module.exports, "initialCachedEndpointState", () => $dc3f78aa52a1e2f1$export$aaed2d023c5dc2c);
const $dc3f78aa52a1e2f1$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("6o0qB", function(module, exports) {
$parcel$export(module.exports, "useIsTargetedForReverseTrials", () => $4e29293fe8e38e32$export$897219a3ca9649b9);

var $FhXEJ = parcelRequire("FhXEJ");

var $2aY2d = parcelRequire("2aY2d");

var $cblKs = parcelRequire("cblKs");

var $1BZ8a = parcelRequire("1BZ8a");
const $4e29293fe8e38e32$export$897219a3ca9649b9 = ()=>{
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const jswEdition = (0, $1BZ8a.useAppEditions)().software;
    const isCurrentProjectJSW = projectContextData?.projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
    if (jswEdition === (0, $cblKs.PREMIUM_EDITION) && isCurrentProjectJSW) return true;
    return false;
};

});

parcelRegister("6zABd", function(module, exports) {
$parcel$export(module.exports, "actions", () => $6e7dc5974142688f$export$e324594224ef24da);

var $2GZwt = parcelRequire("2GZwt");

var $31GRl = parcelRequire("31GRl");
const $6e7dc5974142688f$var$getPremiumTrialOnSignup = (0, $2GZwt.cachedEndpointCall)((0, $31GRl.getOnboardingPremiumTrialWithRethrow));
const $6e7dc5974142688f$export$e324594224ef24da = {
    getPremiumTrialOnSignup: $6e7dc5974142688f$var$getPremiumTrialOnSignup
};

});
parcelRegister("2GZwt", function(module, exports) {
$parcel$export(module.exports, "cachedEndpointCall", () => $8df7eb92b5eb0600$export$9ab04ab45a9b99da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $8df7eb92b5eb0600$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});




parcelRegister("157bu", function(module, exports) {
$parcel$export(module.exports, "useOpenChecklist", () => $cf9cb09864191601$export$318fa8576ad8aa73);

var $12DRg = parcelRequire("12DRg");

var $ftN6c = parcelRequire("ftN6c");

var $dfP3D = parcelRequire("dfP3D");

var $dslup = parcelRequire("dslup");

var $9ycBx = parcelRequire("9ycBx");

var $gxP9D = parcelRequire("gxP9D");

var $dELL6 = parcelRequire("dELL6");

var $4cTDP = parcelRequire("4cTDP");
const $cf9cb09864191601$export$318fa8576ad8aa73 = ()=>{
    const [{ openTask: currentOpenTask }, { nextSetChecklistIsOpen: nextSetChecklistIsOpen, nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, nextOpenTask: nextOpenTask, setIsOpenedViaButton: setIsOpenedViaButton }] = (0, $gxP9D.useJswOnboarding)();
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const currentPanelId = currentRightSidebarState?.panelId;
    const openChecklist = async ({ trigger: trigger, openTask: openTask })=>{
        if (openTask && openTask !== currentOpenTask) nextOpenTask(openTask);
        // Reset the flag if the panel is opened from a different trigger (not the button)
        if (trigger !== 'JswOnboardingChecklistButton' && (0, $4cTDP.fg)('jira_a11y_focus_quickstart_button')) setIsOpenedViaButton(false);
        openRightSidebar((0, $dslup.PANEL_ID), (0, $dslup.PANEL_WIDTH), false, true);
        (0, $dELL6.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            currentRightSidebarPanelId: currentPanelId || '',
            openRightSidebarToTop: true,
            trigger: trigger
        });
        if (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED) {
            if ((0, $4cTDP.fg)('jira_kuro-10551_fix_qs_flash')) await nextSetChecklistIsDismissed(false);
            else nextSetChecklistIsDismissed(false);
        } else nextSetChecklistIsOpen(true);
    };
    if (false) return 0, (/*@__PURE__*/$parcel$interopDefault($12DRg));
    return openChecklist;
};

});
parcelRegister("dslup", function(module, exports) {
$parcel$export(module.exports, "PANEL_ID", () => $cfc5e4d2583c224c$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PANEL_WIDTH", () => $cfc5e4d2583c224c$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PERFORMANCE_METRIC_PREFIX", () => $cfc5e4d2583c224c$export$495d0560d6ea05d0);
$parcel$export(module.exports, "PERFORMANCE_MARK", () => $cfc5e4d2583c224c$export$5da8d06749e84d86);
const $cfc5e4d2583c224c$export$e1d562d81d0e502d = 'jsw-nux-onboarding-checklist';
const $cfc5e4d2583c224c$export$e05cfff20e9274e6 = 360;
const $cfc5e4d2583c224c$export$495d0560d6ea05d0 = 'onboarding-quickstart';
const $cfc5e4d2583c224c$export$5da8d06749e84d86 = {
    BUNDLE_LOAD_START: 'bundleLoaded',
    BUNDLE_LOAD_END: 'bundleLoadedEnd'
};

});




parcelRegister("9bIvg", function(module, exports) {
$parcel$export(module.exports, "Nav4RolloutAnalytics", () => $16fdd4347716eb59$export$89671fab480c820b);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $iyTaR = parcelRequire("iyTaR");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $eFrz1 = parcelRequire("eFrz1");


const $16fdd4347716eb59$export$89671fab480c820b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "nav4-rollout-analytics",
        fallback: "unmount",
        packageName: (0, $d6576400092700bc$export$b8b9d90f9e5bd72b),
        teamName: (0, $d6576400092700bc$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16fdd4347716eb59$export$4bf890a38f5eb199, props));
const $16fdd4347716eb59$export$4bf890a38f5eb199 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // This should only run once. Fix for https://jplat.atlassian.net/browse/BLU-5516
    // and for React Concurrent.
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        const nav4Rollout = (0, $iyTaR.getNav4Rollout)();
        // Now that the GA stage has started, nearly all tenants should be in a rollout stage.
        // Don't exclude tenants with a stage of 'none' as we may need to know who they are.
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'topNav viewed', {
            ...nav4Rollout,
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967)
        });
    }, [
        createAnalyticsEvent
    ]);
    return null;
};

});
const $d6576400092700bc$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4RolloutAnalytics';
const $d6576400092700bc$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("aN4LZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9245a40e4559b38$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5RW99 = parcelRequire("5RW99");

var $cRsK6 = parcelRequire("cRsK6");

var $gy5H8 = parcelRequire("gy5H8");
function $d9245a40e4559b38$var$AppSwitcher() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRsK6.TopLevelErrorBoundary), {
        id: (0, $5RW99.MENU_ID).APP_SWITCHER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gy5H8.AppSwitcherTrigger), null));
}
var $d9245a40e4559b38$export$2e2bcd8739ae039 = $d9245a40e4559b38$var$AppSwitcher;

});
parcelRegister("cRsK6", function(module, exports) {
$parcel$export(module.exports, "TopLevelErrorBoundary", () => $3d19846c898db570$export$b70f1d8bd509b358);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

const $3d19846c898db570$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $eJOHy.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: `${(0, $0c5166c52045dbc3$export$4766f0c4b6fe35dc)}.${id}`,
        packageName: (0, $0c5166c52045dbc3$export$b8b9d90f9e5bd72b),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});
const $0c5166c52045dbc3$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $0c5166c52045dbc3$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $0c5166c52045dbc3$export$9934c8d98fd9e572 = 'atlassianSwitcher';


parcelRegister("gy5H8", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherTrigger", () => $3e4e40eb05838d12$export$dc8723dff0e69fcb);

var $eJOHy = parcelRequire("eJOHy");

var $dIoeE = parcelRequire("dIoeE");


var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $igfaG = parcelRequire("igfaG");
var $ehuUo = parcelRequire("ehuUo");

var $cHtIB = parcelRequire("cHtIB");

var $8GjHG = parcelRequire("8GjHG");

var $eMKWj = parcelRequire("eMKWj");

var $hZvWR = parcelRequire("hZvWR");
function $3e4e40eb05838d12$export$dc8723dff0e69fcb() {
    const [isOpen, { on: openMenu, off: closeMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).APP_SWITCHER);
    const cloudId = (0, $cHtIB.useCloudId)();
    const triggerAnalytics = (0, $dIoeE.useNavigationItemAnalytics)({
        navigationItemId: (0, $0c5166c52045dbc3$export$9934c8d98fd9e572)
    });
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $ehuUo.setSwitcherRenderStartMark)();
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            isOpen: isOpen,
            onClose: closeMenu,
            onOpen: onOpen
        }), [
        isOpen,
        closeMenu,
        onOpen
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $8GjHG.AppSwitcherIntegrationEntrypoint), entryPointParams);
    const entrypointRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igfaG.default), {
        cloudId: cloudId,
        product: "jira"
    }, !isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eMKWj.AppSwitcherPlaceholderButton), {
        onOpen: onOpen,
        ref: entrypointRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "app-switcher-content",
        packageName: "jira-navigation-apps-topnav4-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZvWR.AppSwitcherPlaceholderWithLoadingPopup), null),
        errorFallback: "flag",
        runtimeProps: entryPointParams
    }));
}

});
parcelRegister("dIoeE", function(module, exports) {
$parcel$export(module.exports, "useNavigationItemAnalytics", () => $83dfceb6ad9d0bb5$export$444d136efe970fd3);

var $eJOHy = parcelRequire("eJOHy");

var $idGJk = parcelRequire("idGJk");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
function $83dfceb6ad9d0bb5$export$444d136efe970fd3({ navigationItemId: navigationItemId }) {
    const { isVisible: isVisible } = (0, $idGJk.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
}

});

parcelRegister("8GjHG", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherIntegrationEntrypoint", () => $b75db2fe04fc9a57$export$7b5dbeab5e41f2a4);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b75db2fe04fc9a57$export$7b5dbeab5e41f2a4 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("ePuD3")), {
        moduleId: "9be44a41",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>({
            extraProps: params
        })
});

});
parcelRegister("ePuD3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("haJB1").then(()=>parcelRequire('dCJZe'));

});


parcelRegister("eMKWj", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherPlaceholderButton", () => $bd851b7a65927949$export$46b00316abad4d7b);

var $eJOHy = parcelRequire("eJOHy");

var $lT9x0 = parcelRequire("lT9x0");

var $guChT = parcelRequire("guChT");

var $7aCti = parcelRequire("7aCti");

var $axnxR = parcelRequire("axnxR");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");
const $bd851b7a65927949$export$46b00316abad4d7b = /*#__PURE__*/ (0, $eJOHy.forwardRef)($bd851b7a65927949$var$AppSwitcherPBWithRef);
function $bd851b7a65927949$var$AppSwitcherPBWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    if (false) {
        // Merge and remove "ForBrowser" component when cleaning jfp-magma-4013-fix-top-nav-ssr-hydration
        if (!(0, $4cTDP.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aCti.AppSwitcher), {
            label: (0, $axnxR.SwitchToTooltipText),
            ref: ref
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowser, {
        ref: ref,
        onOpen: onOpen,
        onMouseEnter: onMouseEnter
    });
}
const $bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowser = /*#__PURE__*/ (0, $eJOHy.forwardRef)($bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowserWithRef);
function $bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowserWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd851b7a65927949$var$AppSwitcherLightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aCti.AppSwitcher), {
        ref: ref,
        onClick: onOpen,
        onMouseEnter: onMouseEnter,
        label: (0, $axnxR.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true,
        interactionName: "jira_app_switcher"
    }));
}
const $bd851b7a65927949$var$AppSwitcherLightWrapper = (0, $bJscI.componentWithFG)('app_switcher_spotlight_gate', $bd851b7a65927949$var$SpotLightWrapper, (0, $eJOHy.Fragment));
function $bd851b7a65927949$var$SpotLightWrapper(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "app-switcher-spotlight"
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
        engagementId: "app-switcher-spotlight"
    }));
}

});

parcelRegister("hZvWR", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherPlaceholderWithLoadingPopup", () => $e93f75f8c9c8190b$export$35c8740d616fd043);

var $eJOHy = parcelRequire("eJOHy");

var $jjS5D = parcelRequire("jjS5D");

var $lmgo6 = parcelRequire("lmgo6");
var $aewX5 = parcelRequire("aewX5");
var $1DXK0 = parcelRequire("1DXK0");

var $7aCti = parcelRequire("7aCti");

var $8nMzv = parcelRequire("8nMzv");

var $axnxR = parcelRequire("axnxR");
function $e93f75f8c9c8190b$export$35c8740d616fd043() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e93f75f8c9c8190b$var$SkeletonContent, null),
        isOpen: true,
        messageId: "navigation-apps-topnav4-app-switcher.ui.trigger.popup.loading.popup",
        messageType: "transactional",
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: $e93f75f8c9c8190b$var$Trigger
    });
}
function $e93f75f8c9c8190b$var$Trigger(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aCti.AppSwitcher), {
        ...triggerProps,
        label: (0, $axnxR.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true,
        interactionName: "jira_app_switcher"
    });
}
function $e93f75f8c9c8190b$var$SkeletonContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        xcss: $e93f75f8c9c8190b$var$containerStyles,
        rowGap: "space.200",
        columnGap: "space.150",
        templateColumns: "32px 1fr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e93f75f8c9c8190b$var$SkeletonItems, null));
}
function $e93f75f8c9c8190b$var$SkeletonItems() {
    return Array.from({
        length: 5
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "32px",
            height: "32px",
            isShimmering: true,
            borderRadius: "8px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "100%",
            height: "10px",
            isShimmering: true,
            borderRadius: "4px"
        }))));
}
const $e93f75f8c9c8190b$var$containerStyles = (0, $1DXK0.xcss)({
    width: '250px',
    padding: 'space.200'
});

});



parcelRegister("iHtrU", function(module, exports) {
$parcel$export(module.exports, "CustomThemeAnalytics", () => $81fc5e31f290421d$export$d7c6d40454148f57);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $aNi5m = parcelRequire("aNi5m");
function $81fc5e31f290421d$export$d7c6d40454148f57({ children: children }) {
    const customThemeData = (0, $aNi5m.useCustomThemeData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Fire analytics only when all setters have finished
        const isThemeEvaluated = [
            'hasCustomBGColor',
            'hasCustomHighlightColor',
            'hasCustomLogo',
            'hasCustomSiteTitle'
        ].every((key)=>key in customThemeData);
        if (isThemeEvaluated) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'topNav',
            actionSubjectId: 'customTheme',
            attributes: {
                ...customThemeData
            },
            eventType: 'ui'
        }).fire('navigation');
    }, [
        customThemeData,
        createAnalyticsEvent
    ]);
    return children;
}

});

parcelRegister("edDe8", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistant", () => $8ec718333c3707da$export$9777b121d71c4de1);

var $eJOHy = parcelRequire("eJOHy");

var $79KhM = parcelRequire("79KhM");

var $8IeH1 = parcelRequire("8IeH1");

var $1qr3l = parcelRequire("1qr3l");
var $lsErf = parcelRequire("lsErf");

var $jfIWt = parcelRequire("jfIWt");

var $ldCDT = parcelRequire("ldCDT");

var $hmxq3 = parcelRequire("hmxq3");


var $bJscI = parcelRequire("bJscI");

var $dfP3D = parcelRequire("dfP3D");

var $gOfBc = parcelRequire("gOfBc");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lb6FK = parcelRequire("lb6FK");

var $cHtIB = parcelRequire("cHtIB");

var $59T7O = parcelRequire("59T7O");

var $gxC9D = parcelRequire("gxC9D");

var $cxKOj = parcelRequire("cxKOj");

var $isfIV = parcelRequire("isfIV");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");
const $8ec718333c3707da$var$AssistantButton = (0, $hmxq3.ConversationAssistantButtonNav4);
const $8ec718333c3707da$var$NUDGE_ID = 'jira-conversation-assistant';
const $8ec718333c3707da$var$JiraTrialAssistantReminderNudge = (0, $bJscI.componentWithFG)('custom_rovo_onboarding_agent_gate', (0, $59T7O.JiraTrialAssistantReminderNudge), ()=>null);
$8ec718333c3707da$var$JiraTrialAssistantReminderNudge.displayName = 'JiraTrialAssistantReminderNudge';
const $8ec718333c3707da$var$ConversationAssistantButton = ()=>{
    const [_topMenusValue, { off: closeAllMenus }] = (0, $gOfBc.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $isfIV.useRovoExperienceAPIStore)();
    const sidebarApi = (0, $gxC9D.useConversationAssistantSidebarApi)({
        isMinimised: false,
        toTop: true
    });
    const isActive = (0, $cxKOj.expValEquals)('jira_ai_rovo_button', 'treatment', 'B', 'A') ? sidebarApi.isSidebarOpen() : panelId === (0, $0b41093501185867$export$dffb4ed44e20ea9a) && !isCollapsed;
    const onButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: !isActive,
            isActive: isActive
        });
        if ((0, $cxKOj.expValEquals)('jira_ai_rovo_button', 'treatment', 'B', 'A')) toggleConversationAssistantUIMode({
            targetMode: (0, $lsErf.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
        else isActive ? closeCurrentRightSidebar() : openRightSidebar((0, $0b41093501185867$export$dffb4ed44e20ea9a), (0, $0b41093501185867$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        isActive,
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        createAnalyticsEvent,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const nudgeRef = (0, $79KhM.useRegisterNudgeTarget)($8ec718333c3707da$var$NUDGE_ID);
    const buttonRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        as: "span",
        testId: "atlassian-navigation.ui.conversation-assistant.app-navigation-ai-mate",
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ec718333c3707da$var$AssistantButton, {
        onClick: onButtonClick,
        isActive: isActive,
        siteId: cloudId,
        productKey: "jira",
        ref: nudgeRef.ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ec718333c3707da$var$JiraTrialAssistantReminderNudge, {
        targetId: $8ec718333c3707da$var$NUDGE_ID
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ldCDT.ChatContextSubscriber), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qr3l.ChatOpenerSubscriber), {
        onTriggerOpeningChat: ()=>{
            if (isActive) return;
            if ((0, $cxKOj.expValEquals)('jira_ai_rovo_button', 'treatment', 'B', 'A')) {
                toggleConversationAssistantUIMode({
                    targetMode: (0, $lsErf.ConversationAssistantUIModes).SIDEBAR,
                    sidebarApi: sidebarApi
                });
                return;
            }
            openRightSidebar((0, $0b41093501185867$export$dffb4ed44e20ea9a), (0, $0b41093501185867$export$64aee74ba59709e5), false, true);
        }
    }));
};
const $8ec718333c3707da$export$9777b121d71c4de1 = ()=>{
    const { data: data } = (0, $lb6FK.useRovoEntitlementResource)();
    const shouldShowConversationAssistantButton = data?.isRovoLLMEnabled ?? false;
    const buttonRender = shouldShowConversationAssistantButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ec718333c3707da$var$ConversationAssistantButton, null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).CONVERSATION_ASSISTANT
    }, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jfIWt.RovoEntitlementSetter), {
        isRovoEnabled: shouldShowConversationAssistantButton
    }));
};

});
parcelRegister("59T7O", function(module, exports) {
$parcel$export(module.exports, "JiraTrialAssistantReminderNudge", () => $ebb9e4462aec00ab$export$2aad6cddcdc15cf0);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $cxKOj = parcelRequire("cxKOj");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $2imLM = parcelRequire("2imLM");

var $4EKqI = parcelRequire("4EKqI");

var $bQWwW = parcelRequire("bQWwW");


var $c9MEq = parcelRequire("c9MEq");

const $ebb9e4462aec00ab$var$AsyncLazyReminderNudge = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("4oJtF")).then((module)=>module.ReminderNudge), {
    moduleId: "./src/packages/growth/jira-trial-assistant/src/ui/reminder-nudge/index.tsx"
});
const $ebb9e4462aec00ab$var$JiraTrialAssistantReminderNudgeAsync = ({ targetId: targetId })=>{
    const isEligible = (0, $c9MEq.useIsEligibleForTrialAssistantReminder)() && (0, $cxKOj.expValEquals)('custom_rovo_onboarding_agent', 'cohort', 'variation', 'not-enrolled');
    const triggerRovo = ()=>{
    // TODO: LUNA-648 Configure OOTB Rovo Trigger
    };
    if (!isEligible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "JiraTrialAssistantReminderNudge",
        packageName: (0, $cd72c585cfe8318c$export$b8b9d90f9e5bd72b),
        teamName: (0, $cd72c585cfe8318c$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-trial-assistant-reminder-nudge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-trial-assistant-reminder-nudge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ebb9e4462aec00ab$var$AsyncLazyReminderNudge, {
        targetId: targetId,
        onPrimaryCta: triggerRovo
    }))));
};
const $ebb9e4462aec00ab$export$2aad6cddcdc15cf0 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('custom_rovo_onboarding_agent_gate'), $ebb9e4462aec00ab$var$JiraTrialAssistantReminderNudgeAsync, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));

});
parcelRegister("4oJtF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cBSK5").then(()=>parcelRequire('5pzkP'));

});


parcelRegister("3nihz", function(module, exports) {
$parcel$export(module.exports, "TopLevelErrorBoundary", () => $3ce55d8dd154bd7e$export$b70f1d8bd509b358);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $kO1ht = parcelRequire("kO1ht");
const $3ce55d8dd154bd7e$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $eJOHy.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: `${(0, $kO1ht.TOP_LEVEL_ERROR_BOUNDARY_ID)}.${id}`,
        packageName: (0, $kO1ht.PACKAGE_NAME),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});


parcelRegister("dgOrd", function(module, exports) {
$parcel$export(module.exports, "Create", () => $cc348fb5bec9260f$export$8ade6fcbf3a7de5d);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $5qPoO = parcelRequire("5qPoO");

var $ixiAQ = parcelRequire("ixiAQ");


var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $hu0Oo = parcelRequire("hu0Oo");

var $fYeTG = parcelRequire("fYeTG");

var $RXvVX = parcelRequire("RXvVX");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $dRfS0 = parcelRequire("dRfS0");

var $dkTXM = parcelRequire("dkTXM");

var $kh7bJ = parcelRequire("kh7bJ");

var $eJrcF = parcelRequire("eJrcF");

var $kO1ht = parcelRequire("kO1ht");

var $cgeq2 = parcelRequire("cgeq2");

var $3nihz = parcelRequire("3nihz");

var $4BIvh = parcelRequire("4BIvh");

var $72yuq = parcelRequire("72yuq");

var $9HAHw = parcelRequire("9HAHw");

var $eqj3a = parcelRequire("eqj3a");
const $cc348fb5bec9260f$var$noop = ()=>undefined;
const $cc348fb5bec9260f$var$Create = ({ AkCreate: AkCreate = (0, $cgeq2.Create), NudgeTooltip: NudgeTooltip = (0, $dkTXM.NavigationCreateIssueButtonWrapperNudgeAsync), onCreateClick: onCreateClick = (0, $ixiAQ.default), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useIsInitialLoadLegacyIssueCreate: // @ts-expect-error - TS2339 - Property 'useIsInitialLoadLegacyIssueCreate' does not exist on type 'CreateProps'.
useIsInitialLoadLegacyIssueCreate = (0, $5qPoO.useIsInitialLoadLegacyIssueCreate) })=>{
    const testId = (0, $RXvVX.testIdGenerate)('create');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    (0, $hu0Oo.useInitializePersistentIssueCreateModalView)();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).CREATE
    });
    const [{ isInitialLoad: isInitialLoad }, actions] = useIsInitialLoadLegacyIssueCreate();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $eJOHy.useRef)(false);
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const isMobileExperienceEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    // TODO: delete this code for clean up issue-create-stop-using-gicoptinstatusresources
    if ((0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, update: update } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useLayoutEffect)(()=>{
            if (isAnonymous && !gicOptInStateOverridden.current) {
                update(()=>({
                        gicOptInStatus: {
                            isEnabled: true
                        }
                    }));
                gicOptInStateOverridden.current = true;
            }
        }, [
            isAnonymous,
            update
        ]);
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const onClick = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if ((0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
            if ((0, $4cTDP.fg)('issue-create-stop-using-gicoptinstatusresources')) {
                (0, $72yuq.GlobalIssueCreateFromTopNav).abort({
                    force: true
                });
                (0, $72yuq.GlobalIssueCreateFromTopNav).start();
                (0, $72yuq.GlobalIssueCreateFromTopNav).addMetadata({
                    inputDelay: Math.round(performance.now() - e.timeStamp)
                });
                const nextState = {
                    disableCreationSuccessFlag: (0, $eqj3a.shouldDisableGICFlagCreation)(),
                    triggerPointKey: (0, $84DOT.GENERIC_GLOBAL_CREATE_BUTTON),
                    ...isMobileExperienceEnabled ? {
                        displayMinimizableButtons: false,
                        displayCreateAnotherIssueToggle: false,
                        triggerPointKey: (0, $84DOT.MOBILE_GLOBAL_CREATE_BUTTON)
                    } : {}
                };
                openIssueCreateModal(nextState);
            } else if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) {
                    (0, $72yuq.GlobalIssueCreateFromTopNav).abort({
                        force: true
                    });
                    (0, $72yuq.GlobalIssueCreateFromTopNav).start();
                    (0, $72yuq.GlobalIssueCreateFromTopNav).addMetadata({
                        inputDelay: Math.round(performance.now() - e.timeStamp)
                    });
                    const nextState = {
                        disableCreationSuccessFlag: (0, $eqj3a.shouldDisableGICFlagCreation)(),
                        triggerPointKey: (0, $84DOT.GENERIC_GLOBAL_CREATE_BUTTON),
                        ...isMobileExperienceEnabled ? {
                            displayMinimizableButtons: false,
                            displayCreateAnotherIssueToggle: false,
                            triggerPointKey: (0, $84DOT.MOBILE_GLOBAL_CREATE_BUTTON)
                        } : {}
                    };
                    openIssueCreateModal(nextState);
                } else {
                    onCreateClick({
                        isInitialLoad: isInitialLoad,
                        triggerSource: (0, $8b9f565bf0bbac99$export$d983e94cf86f65d)
                    });
                    if (isInitialLoad) actions.clearInitialLoaded();
                }
            } else (0, $eSnSE.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $8b9f565bf0bbac99$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
        triggerAnalytics();
    }, [
        actions,
        currentIssueCreateVisibility,
        isInitialLoad,
        isMobileExperienceEnabled,
        onCreateClick,
        openIssueCreateModal,
        triggerAnalytics
    ]);
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkCreate, {
        onClick: onClick,
        text: formatMessage((0, $9HAHw.default).create),
        testId: testId,
        label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9HAHw.default).createButtonAriaLabelIssueTermRefresh : (0, $9HAHw.default).createButtonAriaLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkCreate, {
        onClick: $cc348fb5bec9260f$var$noop,
        text: formatMessage((0, $9HAHw.default).create),
        testId: testId,
        label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9HAHw.default).createButtonAriaLabelIssueTermRefresh : (0, $9HAHw.default).createButtonAriaLabel)
    });
};
const $cc348fb5bec9260f$export$8ade6fcbf3a7de5d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc348fb5bec9260f$var$Create, props));

});
parcelRegister("hu0Oo", function(module, exports) {
$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $ddec5dddf62df382$export$9086117e14a55509);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $fYeTG = parcelRequire("fYeTG");

var $jipjz = parcelRequire("jipjz");

var $2aY2d = parcelRequire("2aY2d");

var $80UiT = parcelRequire("80UiT");
const $ddec5dddf62df382$export$9086117e14a55509 = ()=>{
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight }, { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const hasUserSeenMiniModal = (0, $eJOHy.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $80UiT.usePersistentIssueCreateModalViewResource)();
    const isMobileExperienceEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    /**
	 * It only handles the initialization part as after the modal is opened the persistentModalView
	 * would be handled by the `actions` of `useTriggerIssueCreateModal`.
	 */ (0, $eJOHy.useEffect)(()=>{
        setPersistentModalView(resource?.view || 'modal');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * JSM has opted out so we update the `shouldPushMiniModalDiscoverability` on every project change
	 * until the discoverability push has been done, meaning that the user has seen the mini modal being
	 * shown as the default modal.
	 *
	 * Mobile is also opting out of having any mini modal discoverability and not interacting with any of the discoverability state
	 * for if the user returns to desktop.
	 *
	 * If the user has seen the mini modal from discoverability push (hasUserSeenMiniModal) or
	 * dismiss its nudge (isDiscoPushComplete), shouldPushMiniModalDiscoverability should never be true again.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
        else setShouldPushMiniModalDiscoverability(!isJSM && !isMobileExperienceEnabled);
    }, [
        resource?.isDiscoPushComplete,
        setShouldPushMiniModalDiscoverability,
        isJSM,
        isMobileExperienceEnabled
    ]);
    /**
	 * `shouldShowMiniModalSpotlight` can be used to determine if user has seen the mini modal
	 * as it is only set `onModalOpen`, which means, if it is true, the modal is opened with mini view
	 * and the user will see it.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
    }, [
        shouldShowMiniModalSpotlight
    ]);
    return null;
};

});
parcelRegister("80UiT", function(module, exports) {
$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $950c6fd53d168168$export$20dbed3226e737bc);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $9DB7T = parcelRequire("9DB7T");

var $eJrcF = parcelRequire("eJrcF");


var $cqUpU = parcelRequire("cqUpU");
const $950c6fd53d168168$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $cqUpU.persistentIssueCreateModalViewResource));
    const updateView = (0, $eJOHy.useCallback)(async (view)=>{
        try {
            await (0, $9DB7T.userPreferenceAPI).set((0, $0f8f8ea7f8143316$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $eJOHy.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $9DB7T.userPreferenceAPI).set((0, $0f8f8ea7f8143316$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});


parcelRegister("dkTXM", function(module, exports) {
$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $0482641ed1be2c55$export$fc0840474cb1fce9);

var $eJOHy = parcelRequire("eJOHy");


var $kMreM = parcelRequire("kMreM");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $9CROC = parcelRequire("9CROC");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0482641ed1be2c55$var$NavigationCreateIssueButtonLazy = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("l4kog")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-create-issue/index.tsx"
});
const $0482641ed1be2c55$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $9CROC.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $2b839a8453de5367$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $2b839a8453de5367$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0482641ed1be2c55$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $2b839a8453de5367$export$aba87e019f5ccb8d)
    }, children)));
};

});
parcelRegister("9CROC", function(module, exports) {
$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $048e6c5f7b64d681$export$b687eb4905cdc15a);

var $5Xqpk = parcelRequire("5Xqpk");
const $048e6c5f7b64d681$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $5Xqpk.useHasOpened)();
    return hasOpened;
};

});

parcelRegister("l4kog", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iXbSM").then(()=>parcelRequire('gytUr'));

});


parcelRegister("cgeq2", function(module, exports) {
$parcel$export(module.exports, "Create", () => $5b89414d4be457db$export$8ade6fcbf3a7de5d);

var $eJOHy = parcelRequire("eJOHy");

var $2ntmI = parcelRequire("2ntmI");

var $8IeH1 = parcelRequire("8IeH1");

var $7rjYb = parcelRequire("7rjYb");

var $kJPDw = parcelRequire("kJPDw");

var $4cTDP = parcelRequire("4cTDP");

var $eES78 = parcelRequire("eES78");

var $gQZTc = parcelRequire("gQZTc");

var $5qLQO = parcelRequire("5qLQO");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $cGMXY = parcelRequire("cGMXY");

var $lb6FK = parcelRequire("lb6FK");

const $5b89414d4be457db$export$8ade6fcbf3a7de5d = (props)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)() ?? '';
    const orgId = (0, $cGMXY.useOrgId)() ?? '';
    const { data: data } = (0, $lb6FK.useRovoEntitlementResource)();
    const shouldShowCreateWithAiDropdown = (data?.isRovoLLMEnabled && (0, $4cTDP.fg)('jira_aifc_enabled')) ?? false;
    // This feature gate disables the server-specific code path, aligning SSR and CSR content for hydration
    if (false && !(0, $4cTDP.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration')) {
        if (shouldShowCreateWithAiDropdown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ntmI.SplitButton), {
            appearance: "primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJPDw.CreateButton), {
            testId: (0, $d1eda76f6de7b0a1$export$c65f84387a2a60c)
        }, props.text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
            shouldRenderToParent: true
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJPDw.CreateButton), {
            testId: (0, $d1eda76f6de7b0a1$export$bac9f330cf4670e8)
        }, props.text);
    }
    const { onClick: onClick, text: text } = props;
    if (shouldShowCreateWithAiDropdown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZTc.SpotlightTarget), {
        name: (0, $eES78.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ntmI.SplitButton), {
        appearance: "primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJPDw.CreateButton), {
        onClick: onClick,
        testId: (0, $d1eda76f6de7b0a1$export$c65f84387a2a60c)
    }, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qLQO.CreateWithAIDropdown), {
        cloudId: cloudId,
        accountId: accountId,
        orgId: orgId
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZTc.SpotlightTarget), {
        name: (0, $eES78.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJPDw.CreateButton), {
        onClick: onClick,
        testId: (0, $d1eda76f6de7b0a1$export$bac9f330cf4670e8)
    }, text)));
};

});
parcelRegister("gQZTc", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $53951e7fd16438ee$export$e29577842f211e22);

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $dZidf = parcelRequire("dZidf");
const $53951e7fd16438ee$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $53951e7fd16438ee$var$SpotlightTargetOld = (0, $dZidf.withNestingOptimisation)($53951e7fd16438ee$var$SpotlightTargetWrapper);
const $53951e7fd16438ee$export$e29577842f211e22 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration'), $53951e7fd16438ee$var$SpotlightTargetWrapper, $53951e7fd16438ee$var$SpotlightTargetOld);

});
parcelRegister("dZidf", function(module, exports) {
$parcel$export(module.exports, "withNestingOptimisation", () => $b09755e6dde7543f$export$ee1cb2a8280d8710);

var $eJOHy = parcelRequire("eJOHy");

var $2eOKX = parcelRequire("2eOKX");

var $2QUmO = parcelRequire("2QUmO");
const $b09755e6dde7543f$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $2eOKX.useShouldNestedElementRender)().shouldRender && !false ? // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $2QUmO.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});


parcelRegister("cGMXY", function(module, exports) {
$parcel$export(module.exports, "useOrgId", () => $42be11c449d1c554$export$52a03a3207af3687);

var $koAZ4 = parcelRequire("koAZ4");
const $42be11c449d1c554$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

// This id is required to ensure pollinator tests work between Nav3 and Nav4 and also in feature tests
const $d1eda76f6de7b0a1$export$bac9f330cf4670e8 = 'atlassian-navigation--create-button';
const $d1eda76f6de7b0a1$export$c65f84387a2a60c = 'atlassian-navigation--create-split-button';


parcelRegister("4BIvh", function(module, exports) {
$parcel$export(module.exports, "useNavigationItemAnalytics", () => $902255c41cfb9464$export$444d136efe970fd3);

var $eJOHy = parcelRequire("eJOHy");

var $idGJk = parcelRequire("idGJk");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $902255c41cfb9464$export$444d136efe970fd3 = ({ navigationItemId: navigationItemId })=>{
    const { isVisible: isVisible } = (0, $idGJk.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
};

});

parcelRegister("72yuq", function(module, exports) {
$parcel$export(module.exports, "GlobalIssueCreateFromTopNav", () => $9bb546db11179a36$export$177dc7755a3f80f2);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
var $giU3c = parcelRequire("giU3c");
const $9bb546db11179a36$export$177dc7755a3f80f2 = new (0, $f39LL.UFOExperience)('global-issue-create-from-top-nav', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    until: (0, $giU3c.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});
const $9bb546db11179a36$export$2b83859c1548ffb5 = new (0, $f39LL.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});
const $9bb546db11179a36$export$a784c5bbb21ea554 = new (0, $f39LL.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("9HAHw", function(module, exports) {
$parcel$export(module.exports, "default", () => $db8fb5b2eada5689$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $db8fb5b2eada5689$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    create: {
        "id": "atlassian-navigation.create.create",
        "defaultMessage": "Create"
    },
    createButtonAriaLabel: {
        "id": "atlassian-navigation.create.create-button-aria-label",
        "defaultMessage": "Create issue"
    },
    createButtonAriaLabelIssueTermRefresh: {
        "id": "atlassian-navigation.create.create-button-aria-label-issue-term-refresh",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("eqj3a", function(module, exports) {
$parcel$export(module.exports, "shouldDisableGICFlagCreation", () => $ebcdc5f6d6996655$export$fc4d210bb6a1528a);

var $gRw8I = parcelRequire("gRw8I");

var $kO1ht = parcelRequire("kO1ht");
const $ebcdc5f6d6996655$export$fc4d210bb6a1528a = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $kO1ht.JSW_TMP_BACKLOG_BOARD_REGEXP).test(window.location.pathname);
};

});


parcelRegister("kjqBp", function(module, exports) {
$parcel$export(module.exports, "Help", () => $cfea47f9fb354a21$export$1be7516c0280bee8);

var $eJOHy = parcelRequire("eJOHy");

var $lT9x0 = parcelRequire("lT9x0");

var $guChT = parcelRequire("guChT");

var $8lMZg = parcelRequire("8lMZg");

var $2aY2d = parcelRequire("2aY2d");

var $kh7bJ = parcelRequire("kh7bJ");

var $6d9QY = parcelRequire("6d9QY");

var $RXvVX = parcelRequire("RXvVX");

var $5RW99 = parcelRequire("5RW99");

var $dfP3D = parcelRequire("dfP3D");

var $lRq8t = parcelRequire("lRq8t");

var $gOfBc = parcelRequire("gOfBc");

var $4cTDP = parcelRequire("4cTDP");


var $3VPsL = parcelRequire("3VPsL");

var $f2JN3 = parcelRequire("f2JN3");

var $6z8y4 = parcelRequire("6z8y4");

var $gxP9D = parcelRequire("gxP9D");

var $a87C3 = parcelRequire("a87C3");

var $5Xqpk = parcelRequire("5Xqpk");

var $9ycBx = parcelRequire("9ycBx");

var $17J0V = parcelRequire("17J0V");

var $1Isrc = parcelRequire("1Isrc");

var $kO1ht = parcelRequire("kO1ht");

var $4BIvh = parcelRequire("4BIvh");

var $3nihz = parcelRequire("3nihz");

var $1zJmr = parcelRequire("1zJmr");

var $hlQB8 = parcelRequire("hlQB8");
const $cfea47f9fb354a21$export$70a45859468ee32a = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('blu-5788-spotlight-help-button'), $cfea47f9fb354a21$var$JWMFeedbackSpotlightWrapper, $cfea47f9fb354a21$var$SpotlightTargetComponentOriginal);
function $cfea47f9fb354a21$var$SpotlightTargetComponentOriginal({ children: children }) {
    return false && !(0, $4cTDP.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfea47f9fb354a21$var$SpotlightTarget, {
        name: (0, $kO1ht.HELP_SPOTLIGHT_KEY)
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
        name: (0, $kO1ht.HELP_SPOTLIGHT_KEY)
    }));
}
function $cfea47f9fb354a21$var$SpotlightTarget({ children: children, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
}
function $cfea47f9fb354a21$var$JWMFeedbackSpotlightWrapper({ children: children }) {
    const renderNudgeWrapper = (0, $eJOHy.useCallback)((kids)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a87C3.FeedbackNudgeAsync), null, kids), []);
    const [{ hasOpened: shouldShowNudge }] = (0, $5Xqpk.useHasOpened)();
    const [isUnloaded] = (0, $gxP9D.useIsDismissed)();
    const [openTask] = (0, $gxP9D.useOpenTask)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $gxP9D.useQuickstartActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (!isUnloaded && openTask === (0, $9ycBx.JWM_FEEDBACK_TASK) && shouldShowNudge) setHasNudgeActive(true);
    }, [
        isUnloaded,
        openTask,
        shouldShowNudge,
        setHasNudgeActive
    ]);
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6z8y4.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfea47f9fb354a21$var$SpotlightTargetComponentOriginal, null, children);
}
const $cfea47f9fb354a21$var$Help = ()=>{
    const isProjectSimplified = (0, $2aY2d.useIsSimplifiedProject)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).HELP);
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const [topMenusValue, { off: closeAllMenus }] = (0, $gOfBc.useTopMenus)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const { releaseNotesNotifications: releaseNotesNotifications, setReleaseNotesNotifications: setReleaseNotesNotifications } = (0, $17J0V.useHelpButtonState)();
    const helpButtonRef = (0, $eJOHy.useRef)(null);
    const attributes = (0, $eJOHy.useMemo)(()=>({
            helpPanelVersion: (0, $60b564818f0d5fed$export$c43c7444da662fa1),
            helpPanelType: 'inProductHelp',
            nextGenProject: isProjectSimplified
        }), [
        isProjectSimplified
    ]);
    const triggerAnalytics = (0, $4BIvh.useNavigationItemAnalytics)({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).HELP
    });
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const isHelpPanelOpenedPreviously = (0, $6d9QY.usePrevious)(currentRightSidebarState);
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'help');
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (currentRightSidebarState && currentRightSidebarState.panelId === (0, $60b564818f0d5fed$export$e99efa3985fa3c26) && !currentRightSidebarState.isCollapsed) closeCurrentRightSidebar();
        else openRightSidebar((0, $60b564818f0d5fed$export$e99efa3985fa3c26), (0, $60b564818f0d5fed$export$23aa6670f346c214), false, true);
        closeAllMenus();
        setNavigationData({
            articleId: {
                id: '',
                type: (0, $8lMZg.ARTICLE_TYPE).HELP_ARTICLE
            },
            history: []
        });
        // Shows if the help panel is currently open or closed
        const isPanelOpen = currentRightSidebarState?.panelId === (0, $60b564818f0d5fed$export$e99efa3985fa3c26) && !currentRightSidebarState?.isCollapsed;
        triggerAnalytics({
            ...attributes,
            isOpened: !isPanelOpen
        });
    }, [
        triggerAnalytics,
        attributes,
        currentRightSidebarState,
        closeAllMenus,
        setNavigationData,
        closeCurrentRightSidebar,
        openRightSidebar
    ]);
    const badge = (0, $eJOHy.useCallback)(()=>{
        if (isAnonymous) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hlQB8.Badge), {
            releaseNotesNotifications: releaseNotesNotifications ?? 0
        });
    }, [
        isAnonymous,
        releaseNotesNotifications
    ]);
    // Restore the notifications count when the help panel is opened and the notifications count is not 0
    // We explicitly check for the collapsed state, as currentRightSidebarState is null when the sidebar is closed
    // and we don't want to set the notifications count to 0 in that case
    const shouldRestoreNotificationsCount = currentRightSidebarState?.isCollapsed === false && releaseNotesNotifications !== 0;
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRestoreNotificationsCount) setReleaseNotesNotifications(0);
    }, [
        setReleaseNotesNotifications,
        shouldRestoreNotificationsCount
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (currentRightSidebarState?.panelId === (0, $60b564818f0d5fed$export$e99efa3985fa3c26) && !currentRightSidebarState?.isCollapsed) openMenu();
        else {
            closeMenu();
            if (isHelpPanelOpenedPreviously?.panelId === (0, $60b564818f0d5fed$export$e99efa3985fa3c26) && !currentRightSidebarState) requestAnimationFrame(()=>helpButtonRef.current?.focus());
        }
    }, [
        closeMenu,
        currentRightSidebarState,
        isHelpPanelOpenedPreviously,
        openMenu,
        topMenusValue
    ]);
    const dataVc = false && !(0, $4cTDP.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration') ? 'atlassian-navigation-help-ssr' : 'atlassian-navigation-help';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
        "data-vc": dataVc
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfea47f9fb354a21$export$70a45859468ee32a, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Isrc.Help), {
        "aria-expanded": false,
        "aria-haspopup": false,
        isSelected: isMenuOpen,
        badge: badge,
        onClick: onClick,
        tooltip: formatMessage((0, $1zJmr.default).tooltip),
        label: formatMessage((0, $1zJmr.default).label),
        ref: helpButtonRef
    })));
};
const $cfea47f9fb354a21$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).HELP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfea47f9fb354a21$var$Help, null)));

});
parcelRegister("6z8y4", function(module, exports) {
$parcel$export(module.exports, "QuickstartNudge", () => $0e38737f31212e98$export$bd61ee610c74db6c);

var $eJOHy = parcelRequire("eJOHy");

var $keu3i = parcelRequire("keu3i");

var $dZidf = parcelRequire("dZidf");
const $0e38737f31212e98$export$bd61ee610c74db6c = (0, $dZidf.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $keu3i.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
});

});

parcelRegister("a87C3", function(module, exports) {
$parcel$export(module.exports, "FeedbackNudgeAsync", () => $adabcd0aead62617$export$be3f2958452e7be9);

var $eJOHy = parcelRequire("eJOHy");

var $kMreM = parcelRequire("kMreM");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $adabcd0aead62617$var$FeedbackNudgeLazy = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aW8XY")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $adabcd0aead62617$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $44259bc988b99eaa$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $44259bc988b99eaa$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adabcd0aead62617$var$FeedbackNudgeLazy, null, children)));
$adabcd0aead62617$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
parcelRegister("aW8XY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3heg4").then(()=>parcelRequire('9CIPb'));

});


parcelRegister("17J0V", function(module, exports) {
$parcel$export(module.exports, "useHelpButtonState", () => $8fb3dbf61041bfa1$export$e3d3de46b23d1ede);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $6ygRm = parcelRequire("6ygRm");
const $8fb3dbf61041bfa1$export$53f45136e435c2fd = 'help_button_ui_state';
const $8fb3dbf61041bfa1$export$e3d3de46b23d1ede = ()=>{
    const [releaseNotesNotifications, setReleaseNotesNotifications] = (0, $eJOHy.useState)(null);
    const [userReleaseNotesNotifications, setUserReleaseNotesNotifications] = (0, $eJOHy.useState)(null);
    const accountId = (0, $e6YEs.useAccountId)();
    const updateData = (0, $eJOHy.useCallback)(()=>{
        if (userReleaseNotesNotifications !== null) {
            const newReleaseNotesNotificationsValue = userReleaseNotesNotifications !== undefined ? userReleaseNotesNotifications : 100;
            if (releaseNotesNotifications !== null) {
                if (userReleaseNotesNotifications !== releaseNotesNotifications) {
                    const remoteData = {
                        helpPanelMenu: {
                            releaseNotesNotifications: releaseNotesNotifications
                        }
                    };
                    (0, $6ygRm.updateHelpButtonState)(accountId, remoteData);
                }
            } else setReleaseNotesNotifications(newReleaseNotesNotificationsValue);
        }
    }, [
        accountId,
        releaseNotesNotifications,
        userReleaseNotesNotifications
    ]);
    const restoreReleaseNotesNotifications = (0, $eJOHy.useCallback)(async ()=>{
        if (accountId) {
            const userPropertiesHelpButtonValue = await (0, $6ygRm.getHelpButtonState)(accountId);
            setUserReleaseNotesNotifications(userPropertiesHelpButtonValue?.releaseNotesNotifications);
        } else setUserReleaseNotesNotifications(0);
    }, [
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (userReleaseNotesNotifications === null) restoreReleaseNotesNotifications();
        else updateData();
    }, [
        userReleaseNotesNotifications,
        restoreReleaseNotesNotifications,
        updateData
    ]);
    return {
        releaseNotesNotifications: releaseNotesNotifications,
        setReleaseNotesNotifications: setReleaseNotesNotifications
    };
};

});
parcelRegister("6ygRm", function(module, exports) {
$parcel$export(module.exports, "updateHelpButtonState", () => $c9661ca80e500d81$export$c70764abdc0ffd52);
$parcel$export(module.exports, "getHelpButtonState", () => $c9661ca80e500d81$export$9716b2ae6c8887b0);

var $LFmXM = parcelRequire("LFmXM");

var $FppkK = parcelRequire("FppkK");

var $9pTd3 = parcelRequire("9pTd3");

const $c9661ca80e500d81$export$c70764abdc0ffd52 = async (accountId, data)=>{
    if (accountId !== null) try {
        await (0, $FppkK.setUserProperties)(accountId, (0, $6684ec2238b90c47$export$53f45136e435c2fd), JSON.stringify(data));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: e,
            meta: {
                id: 'updateServerHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
};
const $c9661ca80e500d81$export$9716b2ae6c8887b0 = (0, $LFmXM.default)(async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $FppkK.getUserProperty)(accountId, (0, $6684ec2238b90c47$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
});

});
const $6684ec2238b90c47$export$53f45136e435c2fd = 'help_button_ui_state';



parcelRegister("1Isrc", function(module, exports) {
$parcel$export(module.exports, "Help", () => $ded8b32ea79727d1$export$1be7516c0280bee8);

var $eJOHy = parcelRequire("eJOHy");

var $e0KRN = parcelRequire("e0KRN");
const $ded8b32ea79727d1$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e0KRN.Help), {
        badge: badge,
        label: label,
        onClick: onClick,
        isSelected: isSelected,
        ref: ref
    });
});

});

parcelRegister("1zJmr", function(module, exports) {
$parcel$export(module.exports, "default", () => $200d37e9ffd771a9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $200d37e9ffd771a9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.help.tooltip",
        "defaultMessage": "Help"
    },
    label: {
        "id": "atlassian-navigation.help.label",
        "defaultMessage": "Help"
    }
});

});

parcelRegister("hlQB8", function(module, exports) {
$parcel$export(module.exports, "Badge", () => $4f77d4f43bcb6c5d$export$37acb3580601e69a);

var $eJOHy = parcelRequire("eJOHy");

var $EzBXZ = parcelRequire("EzBXZ");

var $4cTDP = parcelRequire("4cTDP");

var $eIatj = parcelRequire("eIatj");
const $4f77d4f43bcb6c5d$export$37acb3580601e69a = ({ releaseNotesNotifications: releaseNotesNotifications = 0 })=>{
    if ((0, $4cTDP.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), null, releaseNotesNotifications > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eIatj.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, releaseNotesNotifications) : null);
    return releaseNotesNotifications > 0 && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eIatj.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, releaseNotesNotifications) : null;
};

});
parcelRegister("eIatj", function(module, exports) {
$parcel$export(module.exports, "LazyNotifications", () => $13a6cf3756795afc$export$eebecbd0322becdd);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $kO1ht = parcelRequire("kO1ht");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13a6cf3756795afc$var$Notifications = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("dW7Vf")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/badge/src/index.tsx"
});
const $13a6cf3756795afc$export$eebecbd0322becdd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "help.atlaskit-badge",
        packageName: (0, $kO1ht.PACKAGE_NAME),
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "lazy-notification-badge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13a6cf3756795afc$var$Notifications, props)));

});
parcelRegister("dW7Vf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("btvHm").then(()=>parcelRequire('hgsJA'));

});




parcelRegister("crIFg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9693522152d1aa59$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9693522152d1aa59$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    topNav: {
        "id": "atlassian-navigation.top-nav",
        "defaultMessage": "Primary"
    },
    more: {
        "id": "atlassian-navigation.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("jILIS", function(module, exports) {
$parcel$export(module.exports, "Notifications", () => $5b37db828d9d955f$export$36ba2f559d49a8f6);
$parcel$export(module.exports, "NotificationsContentWrapper", () => $5b37db828d9d955f$export$34c02505a1643f00);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kJsb4 = parcelRequire("kJsb4");

var $6u5q7 = parcelRequire("6u5q7");

var $5vQ2T = parcelRequire("5vQ2T");

var $8Uqf3 = parcelRequire("8Uqf3");

var $lRq8t = parcelRequire("lRq8t");

var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $RXvVX = parcelRequire("RXvVX");

var $fYeTG = parcelRequire("fYeTG");

var $2imLM = parcelRequire("2imLM");

var $kh7bJ = parcelRequire("kh7bJ");

var $bQWwW = parcelRequire("bQWwW");

var $f2JN3 = parcelRequire("f2JN3");

var $bJscI = parcelRequire("bJscI");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");

var $isgAI = parcelRequire("isgAI");

var $4BIvh = parcelRequire("4BIvh");

var $jRdpz = parcelRequire("jRdpz");


var $ebmHm = parcelRequire("ebmHm");

const $5b37db828d9d955f$var$BadgeDI = (0, $bQWwW.lazy)(()=>(parcelRequire("9Q2fr")).then(({ Badge: Badge })=>Badge), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/badge/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b37db828d9d955f$var$MenuDI = (0, $bQWwW.lazy)(()=>(parcelRequire("camud")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $5b37db828d9d955f$var$Notifications = ({ Badge: Badge = $5b37db828d9d955f$var$BadgeDI, ErrorBoundary: ErrorBoundary = (0, $5vQ2T.JSErrorBoundary), Icon: Icon = (0, $isgAI.Notification), Menu: Menu = $5b37db828d9d955f$var$MenuDI, NotificationContentFrame: NotificationContentFrame = $5b37db828d9d955f$var$NotificationContentFrameDI, Popup: Popup = (0, $kJsb4.default), useExperienceStart: useExperienceStart = (0, $8Uqf3.useExperienceStart), useIntl: useIntl = (0, $lRq8t.default), useIsAnonymous: useIsAnonymous = (0, $kh7bJ.useIsAnonymous), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $gOfBc.useTopMenus) })=>{
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'notifications');
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const [isNotificationCleared, setIsNotificationCleared] = (0, $eJOHy.useState)(false);
    const [notificationCount, setNotificationCount] = (0, $eJOHy.useState)(0);
    const handleCountUpdate = (0, $eJOHy.useCallback)((newCount)=>{
        setNotificationCount(newCount);
    }, []);
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = useTopMenus((0, $5RW99.MENU_ID).NOTIFICATIONS);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = useExperienceStart({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (isMenuOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        setIsNotificationCleared(true);
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const handleNotificationIconHover = ()=>{
        $5b37db828d9d955f$var$MenuDI.preload();
    };
    (0, $jRdpz.useRegisterNotificationsInCommandPalette)(onClick);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NotificationContentFrame, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorBoundary, {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Menu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdPrefix
    ]);
    const badge = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorBoundary, {
            id: "notifications.badge.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
            name: "badge",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Badge, {
            isNotificationCleared: isNotificationCleared,
            setIsNotificationCleared: setIsNotificationCleared,
            isNotificationDrawerOpen: isMenuOpen,
            onNotificationCountChange: handleCountUpdate
        }))), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isNotificationCleared,
        isMenuOpen
    ]);
    const badgeEmpty = (0, $eJOHy.useCallback)(()=>null, []);
    const notificationsLabel = notificationCount < (0, $fd3ecb7812b98df6$export$14c62ba6f49b806f) ? formatMessage((0, $ebmHm.default).label, {
        count: notificationCount
    }) : formatMessage((0, $ebmHm.default).overNineNotifications);
    const trigger = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": "atlassian-navigation-notifications"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            onMouseEnter: handleNotificationIconHover,
            tooltip: formatMessage((0, $ebmHm.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        badge,
        isMenuOpen,
        onClick,
        formatMessage,
        testIdPrefix,
        notificationCount
    ]);
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        badge: badgeEmpty,
        tooltip: formatMessage((0, $ebmHm.default).tooltip)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};
const $5b37db828d9d955f$export$36ba2f559d49a8f6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6u5q7.UsingNotificationsToImproveAdminApprovalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b37db828d9d955f$var$Notifications, props)));
const $5b37db828d9d955f$var$notificationContentFrameStyles = null;
const $5b37db828d9d955f$var$notificationContentFrameStylesUpdatedHeight = null;
const $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidthUpdatedHeight = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1xd4 _4t3i1vpj _1e0c1txw _g7111w2c"
        ])
    }, children);
};
const $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidthLongHeight = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1xd4 _4t3i54ef _1e0c1txw _g7111w2c"
        ])
    }, children);
};
const $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidth = (0, $bJscI.componentWithFG)('jira-jjj-adjust-notifs-panel-height', $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidthUpdatedHeight, $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidthLongHeight); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order -- To migrate as part of go/ui-styling-standard
const $5b37db828d9d955f$var$NotificationContentFrameDIOldLongHeight = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1w2c _4t3i54ef _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order -- To migrate as part of go/ui-styling-standard
const $5b37db828d9d955f$var$NotificationContentFrameDIOldUpdatedHeight = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1w2c _4t3i1vpj _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $5b37db828d9d955f$var$NotificationContentFrameDIOld = (0, $bJscI.componentWithFG)('jira-jjj-adjust-notifs-panel-height', $5b37db828d9d955f$var$NotificationContentFrameDIOldUpdatedHeight, $5b37db828d9d955f$var$NotificationContentFrameDIOldLongHeight); // TODO: When the cleanup is done, remove the exported wrapper component below please (see NotificationsContentWrapper)
//       Add fix the import in the Nav4Notifications componponent (which is colocated)
const $5b37db828d9d955f$var$NotificationContentFrameDI = (0, $f2JN3.componentWithCondition)(()=>(0, $fYeTG.isMobileAndInViewPanelIterationExperiment)(), $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidth, $5b37db828d9d955f$var$NotificationContentFrameDIOld); // This has been created to circumvent a ratcheting rule and avoid an ESLint suppression
const $5b37db828d9d955f$export$34c02505a1643f00 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b37db828d9d955f$var$NotificationContentFrameDI, null, children);
};

});
parcelRegister("6u5q7", function(module, exports) {
$parcel$export(module.exports, "CoordinationStopProvider", () => $a21922d4f991da23$export$83d026e3dd5706d);
$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalProvider", () => $a21922d4f991da23$export$a5554f3421878be1);
$parcel$export(module.exports, "useUsingNotificationsToImproveAdminApprovalContext", () => $a21922d4f991da23$export$3e450d633150d6ca);

var $eJOHy = parcelRequire("eJOHy");

var $3hRxq = parcelRequire("3hRxq");

var $koAZ4 = parcelRequire("koAZ4");

const $a21922d4f991da23$var$TouchpointContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    hasSpotlightBeenShown: true,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    markSpotlightAsShown: ()=>{}
});
const $a21922d4f991da23$var$localStorage = (0, $3hRxq.createLocalStorageProvider)((0, $f71427a7081a8d43$export$67a034c701fa7ff6));
const $a21922d4f991da23$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $a21922d4f991da23$export$a5554f3421878be1 = ({ children: children })=>{
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $koAZ4.useTenantContext)();
    const [hasSpotlightBeenShown, setHasSpotlightBeenShown] = (0, $eJOHy.useState)(true);
    const spotlightLocalStorageKey = `${(0, $f71427a7081a8d43$export$7a86d77850136bf4)}_${cloudId}_${atlassianAccountId}`;
    (0, $eJOHy.useEffect)(()=>{
        setHasSpotlightBeenShown($a21922d4f991da23$var$localStorage.get(spotlightLocalStorageKey) || false);
    }, [
        spotlightLocalStorageKey
    ]);
    const markSpotlightAsShown = (0, $eJOHy.useCallback)(()=>{
        $a21922d4f991da23$var$localStorage.set(spotlightLocalStorageKey, true);
        setHasSpotlightBeenShown(true);
    }, [
        setHasSpotlightBeenShown,
        spotlightLocalStorageKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a21922d4f991da23$var$TouchpointContext.Provider, {
        value: {
            hasSpotlightBeenShown: hasSpotlightBeenShown,
            markSpotlightAsShown: markSpotlightAsShown
        }
    }, children);
};
const $a21922d4f991da23$export$3e450d633150d6ca = ()=>(0, $eJOHy.useContext)($a21922d4f991da23$var$TouchpointContext);

});
const $f71427a7081a8d43$export$67a034c701fa7ff6 = 'uniapa';
const $f71427a7081a8d43$export$7a86d77850136bf4 = 'has-spotlight-been-shown';
const $f71427a7081a8d43$export$d2ea4f931a71a509 = 'jira-admin-product-request-spotlight';


parcelRegister("isgAI", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $a08e7caad0c9155b$export$14834abbfce3b8cd);

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $aBN0w = parcelRequire("aBN0w");


var $6u5q7 = parcelRequire("6u5q7");

var $bae93 = parcelRequire("bae93");

var $9zZj0 = parcelRequire("9zZj0");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $koAZ4 = parcelRequire("koAZ4");
// Should this live in the migration layer (@atlassian/jira-navigation-system) instead?
const $a08e7caad0c9155b$var$renderNotifications = (props, ref, shouldShowRequestSpotlight)=>{
    const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
    // When we are showing the spotlight, the role listitem is applied to the SpotlightTarget component (near line 77),
    // hence we don't need to set Nav4Notifications as a listitem in here.
    const isListItem = !shouldShowRequestSpotlight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBN0w.Notifications), {
        isListItem: isListItem,
        badge: badge,
        label: label,
        onClick: onClick,
        isSelected: isSelected,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- PLEASE FIX - ENABLING FLAT LINT CONFIG
        ref: ref
    });
};
const $a08e7caad0c9155b$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { markSpotlightAsShown: markSpotlightAsShown, hasSpotlightBeenShown: hasSpotlightBeenShown } = (0, $6u5q7.useUsingNotificationsToImproveAdminApprovalContext)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $koAZ4.useTenantContext)();
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    /**
	 * Send analytics event when user clicks "Close" or "View requests" button on the request spotlight
	 * Event registry - https://data-portal.internal.atlassian.com/analytics/registry/52348
	 * @param {"close"|"viewRequests"} buttonType
	 */ const handleSendAnalyticsEventForClickRequestSpotlightButton = (buttonType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'requestSpotlightButton', {
            buttonType: buttonType,
            isSiteAdmin: isSiteAdmin
        });
    };
    const shouldShowRequestsSpotlight = isSiteAdmin && !hasSpotlightBeenShown;
    if (!shouldShowRequestsSpotlight) return $a08e7caad0c9155b$var$renderNotifications(notificationProps, ref, shouldShowRequestsSpotlight);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "admin-request-spotlight"
    }, $a08e7caad0c9155b$var$renderNotifications(notificationProps, ref, shouldShowRequestsSpotlight))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9zZj0.default), {
        messageId: (0, $f71427a7081a8d43$export$d2ea4f931a71a509),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6u5q7.CoordinationStopProvider), null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bae93.UsingNotificationsToImproveAdminApprovalSpotlight), {
            onViewRequests: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                onViewRequests && onViewRequests();
                handleSendAnalyticsEventForClickRequestSpotlightButton('viewRequests');
                stop && stop();
            },
            onClose: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                handleSendAnalyticsEventForClickRequestSpotlightButton('close');
                stop && stop();
            }
        })))));
});

});
parcelRegister("bae93", function(module, exports) {
$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalSpotlight", () => $38e02a2f9bd83fb4$export$aa9f9fc1c08b114f);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $iC2Fk = parcelRequire("iC2Fk");

var $koAZ4 = parcelRequire("koAZ4");

var $8xcML = parcelRequire("8xcML");
const $38e02a2f9bd83fb4$export$aa9f9fc1c08b114f = ({ onViewRequests: onViewRequests, onClose: onClose })=>{
    const uniapaSpotlightNotificationTextAppify = (0, $4cTDP.fg)('product-terminology-refresh') ? (0, $8xcML.default).uniapaSpotlightNotificationTextAppify : (0, $8xcML.default).uniapaSpotlightNotificationText;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $koAZ4.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$cae2783c9279926),
        sourceName: "requestSpotlight",
        attributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        actions: [
            {
                onClick: onViewRequests,
                text: formatMessage((0, $8xcML.default).uniapaSpotlightViewRequestsButtonText)
            },
            {
                onClick: onClose,
                text: formatMessage((0, $8xcML.default).uniapaSpotlightCloseButtonText),
                appearance: 'subtle'
            }
        ],
        target: "admin-request-spotlight",
        key: "admin-request-spotlight",
        targetRadius: 100,
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
        messageId: "cross-flow-using-notifications-to-improve-admin-approval.ui.jira-spotlight.admin-request-spotlight",
        messageType: "engagement"
    }, formatMessage(uniapaSpotlightNotificationTextAppify))));
};

});
parcelRegister("8xcML", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4cc9c7efe80dbc9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a4cc9c7efe80dbc9$var$messages = (0, $7qGN1.defineMessages)({
    uniapaSpotlightNotificationText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text",
        "defaultMessage": "When someone in your team requests a new product you'll get a notification here now."
    },
    uniapaSpotlightCloseButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text",
        "defaultMessage": "Close"
    },
    uniapaSpotlightViewRequestsButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text",
        "defaultMessage": "View requests"
    },
    uniapaSpotlightNotificationTextAppify: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text-appify",
        "defaultMessage": "When someone in your team requests a new app you'll get a notification here now."
    }
});
var $a4cc9c7efe80dbc9$export$2e2bcd8739ae039 = $a4cc9c7efe80dbc9$var$messages;

});



parcelRegister("jRdpz", function(module, exports) {
$parcel$export(module.exports, "useRegisterNotificationsInCommandPalette", () => $be8c1958e80f2b2b$export$1859b18f10ade54c);

var $eJOHy = parcelRequire("eJOHy");

var $bRsun = parcelRequire("bRsun");

var $1Zcfy = parcelRequire("1Zcfy");

var $ii7Oz = parcelRequire("ii7Oz");

var $itdlt = parcelRequire("itdlt");

var $fWwfy = parcelRequire("fWwfy");

var $fGVnv = parcelRequire("fGVnv");

var $hf4h9 = parcelRequire("hf4h9");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");


var $eoFNL = parcelRequire("eoFNL");
const $be8c1958e80f2b2b$export$1859b18f10ade54c = (onClick)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const commands = (0, $eJOHy.useMemo)(()=>[
            {
                id: (0, $0da9307007fc60c1$export$e0226a83abddbd07),
                name: formatMessage((0, $eoFNL.messages).checkNotifications),
                primaryAction: {
                    type: (0, $hf4h9.CommandActionType).PERFORM,
                    perform: onClick
                },
                keywords: getKeywords('checkNotificationsSynonyms'),
                section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
                priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bRsun))), {
                            spacing: "spacious",
                            label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $eoFNL.messages).checkNotifications),
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        })
                },
                analytics: {
                    action: 'checkNotifications'
                }
            }
        ], [
        formatMessage,
        getKeywords,
        onClick
    ]);
    (0, $fGVnv.useRegisterCommands)((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).CHECK_NOTIFICATIONS, commands);
};

});
parcelRegister("1Zcfy", function(module, exports) {
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $9047f4ba14bb7637$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $9047f4ba14bb7637$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $9047f4ba14bb7637$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $9047f4ba14bb7637$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $9047f4ba14bb7637$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $9047f4ba14bb7637$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $9047f4ba14bb7637$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $9047f4ba14bb7637$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $9047f4ba14bb7637$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $9047f4ba14bb7637$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $9047f4ba14bb7637$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $9047f4ba14bb7637$export$156ebd2354e25466 = 'issueActions';
const $9047f4ba14bb7637$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $9047f4ba14bb7637$export$9f646ab88e1d2b14 = 'commandPalette';
var $9047f4ba14bb7637$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $9047f4ba14bb7637$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $9047f4ba14bb7637$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $9047f4ba14bb7637$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $9047f4ba14bb7637$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewMyIssues"] = 0] = "viewMyIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 1] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 2] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 3] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 4] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 5] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 6] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $9047f4ba14bb7637$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("ii7Oz", function(module, exports) {
$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $4dacf61939d854f6$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $4dacf61939d854f6$export$5ea2dca0a260365d = /*#__PURE__*/ function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["askRovo"] = 0] = "askRovo";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 1] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 2] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 3] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 4] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 5] = "checkNotifications";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openFilterPopup"] = 6] = "openFilterPopup";
    return COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY;
}({});

});

parcelRegister("itdlt", function(module, exports) {
$parcel$export(module.exports, "useCommandKeywords", () => $ee480ed0df38ab27$export$4d8fe3ef6385358);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cnlru = parcelRequire("cnlru");
const $ee480ed0df38ab27$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getKeywords = (0, $eJOHy.useCallback)((keywordGroup)=>(0, $cnlru.messages)[keywordGroup] ? formatMessage((0, $cnlru.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("cnlru", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b90e6119f7427a6f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b90e6119f7427a6f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    },
    goToIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Advanced work item search Project Filter JQL search list View all"
    },
    viewAllIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Site work items JQL View all"
    },
    goToIssuesSynonymsIssueTermRefreshGalaxia: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh-galaxia",
        "defaultMessage": "Advanced work item search Space Filter JQL search list View all"
    },
    viewMyOpenIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-my-open-issues-synonyms",
        "defaultMessage": "Issues assigned in-progress"
    },
    viewIssuesReportedByMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-issues-reported-by-me-synonyms",
        "defaultMessage": "Issues created"
    }
});

});


parcelRegister("fWwfy", function(module, exports) {
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $67a434ec4fcbe6f3$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $67a434ec4fcbe6f3$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $67a434ec4fcbe6f3$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    ASK_ROVO: 'ASK_ROVO',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $67a434ec4fcbe6f3$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $67a434ec4fcbe6f3$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ASK_ROVO: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ASK_ROVO,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.COPY_URL,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.DESCRIPTION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.LOG_WORK,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.PARENT,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.QUICK_ADD,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.QUICK_SEARCH,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.SHORTCUTS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.STATUS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.STORY_POINTS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.THEME_MODE,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    }
};

});

parcelRegister("fGVnv", function(module, exports) {
$parcel$export(module.exports, "useRegisterCommands", () => $e29b438fb88ad88a$export$3f626f8a5dbc29e4);

var $cQKVu = parcelRequire("cQKVu");
const $e29b438fb88ad88a$export$3f626f8a5dbc29e4 = (0, $cQKVu.useRegisterCommandsWithRegistry);

});
parcelRegister("cQKVu", function(module, exports) {
$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $6d5c9742963ffdc5$export$8a824ae164ff968d);

var $eJOHy = parcelRequire("eJOHy");

var $iTb6Y = parcelRequire("iTb6Y");
function $6d5c9742963ffdc5$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $iTb6Y.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eJOHy.useRef)(commands);
    (0, $eJOHy.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("iTb6Y", function(module, exports) {
$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $bd9364f64b41cfe5$export$880fc01e31710b27);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");
function $bd9364f64b41cfe5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $g51Bg.useActionsCommandPalette)();
    const subscribe = (0, $eJOHy.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});



const $0da9307007fc60c1$export$e0226a83abddbd07 = 'check-notifications';

parcelRegister("eoFNL", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a6950214edaf98a8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a6950214edaf98a8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    checkNotifications: {
        "id": "atlassian-navigation.notifications.command-palette.check-notifications",
        "defaultMessage": "Check notifications"
    }
});

});


const $fd3ecb7812b98df6$export$14c62ba6f49b806f = 9;

parcelRegister("ebmHm", function(module, exports) {
$parcel$export(module.exports, "default", () => $99a38bbac9e95618$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $99a38bbac9e95618$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.notifications.tooltip",
        "defaultMessage": "Notifications"
    },
    oldLabel: {
        "id": "atlassian-navigation.notifications.old-label",
        "defaultMessage": "Notifications"
    },
    label: {
        "id": "atlassian-navigation.notifications.label",
        "defaultMessage": "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        "id": "atlassian-navigation.notifications.over-nine-notifications",
        "defaultMessage": "Over 9 Notifications"
    }
});

});

parcelRegister("9Q2fr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jihoE").then(()=>parcelRequire('hTcRh'));

});

parcelRegister("camud", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2XRcq").then(()=>parcelRequire('3rrmj'));

});


parcelRegister("gWKt4", function(module, exports) {
$parcel$export(module.exports, "ProductHome", () => $58482d1c10676c6d$export$32d61f70e04b6020);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $O2sC7 = parcelRequire("O2sC7");
var $a9nkB = parcelRequire("a9nkB");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $RXvVX = parcelRequire("RXvVX");

var $7SGrx = parcelRequire("7SGrx");

var $83DiZ = parcelRequire("83DiZ");

var $6PAED = parcelRequire("6PAED");

var $aNi5m = parcelRequire("aNi5m");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");

var $70LOs = parcelRequire("70LOs");

var $4BIvh = parcelRequire("4BIvh");

var $dzJfX = parcelRequire("dzJfX");

var $b3S4D = parcelRequire("b3S4D");

var $8MN6v = parcelRequire("8MN6v");
const $58482d1c10676c6d$var$HOME_URL = '/jira';
const $58482d1c10676c6d$var$CreateCustomLogoComponent = (props)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58482d1c10676c6d$var$CustomImgNav4, props);
const $58482d1c10676c6d$export$32d61f70e04b6020 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58482d1c10676c6d$var$ProductHomeContent, props));
function $58482d1c10676c6d$var$ProductHomeContent({ projectType: projectType }) {
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('product-home-');
    const logoUrl = (0, $70LOs.useCustomLogo)();
    const iconUrl = (0, $70LOs.useCustomIcon)();
    const productName = (0, $7SGrx.useProductName)();
    const triggerAnalytics = (0, $4BIvh.useNavigationItemAnalytics)({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).LOGO
    });
    // See: https://hello.jira.atlassian.cloud/browse/NAVX-1993
    const setCustomThemeData = (0, $aNi5m.useSetCustomThemeData)();
    if ((0, $4cTDP.fg)('jfp-magma-fix-custom-theme-data-hydration-error')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        setCustomThemeData({
            hasCustomLogo: !!logoUrl
        });
    }, [
        logoUrl,
        setCustomThemeData
    ]);
    else setCustomThemeData({
        hasCustomLogo: !!logoUrl
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const navigateToHome = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push($58482d1c10676c6d$var$HOME_URL);
    }, [
        triggerAnalytics,
        push
    ]);
    const { icon: ProductIcon, name: logoName } = (0, $eJOHy.useMemo)(()=>(0, $8MN6v.getProductIcon)(productName, testIdPrefix), [
        productName,
        testIdPrefix
    ]);
    const Logo = (0, $eJOHy.useMemo)(()=>$58482d1c10676c6d$var$CreateCustomLogoComponent({
            alt: formatMessage((0, $dzJfX.default).customLogoAltText),
            src: logoUrl || '',
            testId: `${testIdPrefix}-logo`
        }), [
        logoUrl,
        formatMessage,
        testIdPrefix
    ]);
    const Icon = (0, $eJOHy.useMemo)(()=>logoUrl && iconUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58482d1c10676c6d$var$CustomImgNav4, {
                alt: formatMessage((0, $dzJfX.default).customIconAltText),
                src: iconUrl,
                testId: `${testIdPrefix}-icon`
            }) : ProductIcon, [
        logoUrl,
        iconUrl,
        ProductIcon,
        testIdPrefix,
        formatMessage
    ]);
    const label = (0, $8MN6v.getLogoLabel)(formatMessage, productName);
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $6PAED.useApplicationPermissions)(); // check if the user has access to JSM and CSM only
    const isJSMAndCSMOnlyAccessible = hasServiceDeskAccess && hasCustomerServiceAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess;
    if (!logoUrl && isJSMAndCSMOnlyAccessible && (0, $4cTDP.fg)('team25-eu-jira-logo-updates-csm-jsm')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        testId: `${testIdPrefix}-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3S4D.JSMAndCSMLogo), {
        navigateToHome: navigateToHome,
        testIdPrefix: testIdPrefix,
        homeURL: $58482d1c10676c6d$var$HOME_URL,
        projectType: projectType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        testId: `${testIdPrefix}-container`
    }, !logoUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $O2sC7.AppLogo), {
        name: logoName,
        label: label,
        icon: Icon,
        href: $58482d1c10676c6d$var$HOME_URL,
        onClick: navigateToHome
    }) : // Render custom logo component if logoUrl is present (even if the icon is not custom)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9nkB.CustomLogo), {
        label: label,
        icon: Icon,
        logo: Logo,
        href: $58482d1c10676c6d$var$HOME_URL,
        onClick: navigateToHome
    }));
}
function $58482d1c10676c6d$var$CustomImgNav4({ alt: alt, src: src, testId: testId }) {
    // See: https://hello.jira.atlassian.cloud/browse/NAVX-1993
    const setCustomThemeData = (0, $aNi5m.useSetCustomThemeData)();
    const handleLoad = (0, $eJOHy.useCallback)((e)=>{
        // Image loaded
        setCustomThemeData({
            customLogoSize: {
                width: e.currentTarget.naturalWidth,
                height: e.currentTarget.naturalHeight
            }
        });
    }, [
        setCustomThemeData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: src,
        alt: alt,
        "data-testid": testId,
        onLoad: handleLoad
    });
}

});
parcelRegister("70LOs", function(module, exports) {
$parcel$export(module.exports, "useCustomLogo", () => $c349fa689f3f300f$export$9891fb86d6b41647);
$parcel$export(module.exports, "useCustomIcon", () => $c349fa689f3f300f$export$9e69c21df0138642);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");
const $c349fa689f3f300f$export$9891fb86d6b41647 = ()=>(0, $eJOHy.useMemo)(()=>(0, $hWeHP.default)('ajs-lf-top-adg3-logourl'), []);
const $c349fa689f3f300f$export$9e69c21df0138642 = ()=>(0, $eJOHy.useMemo)(()=>(0, $hWeHP.default)('ajs-fspage-favicon'), []);

});

parcelRegister("dzJfX", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f59ab0f5a9a64a4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4f59ab0f5a9a64a4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    customLogoAltText: {
        "id": "atlassian-navigation.product-home.custom-logo-alt-text",
        "defaultMessage": "Jira homepage"
    },
    customIconAltText: {
        "id": "atlassian-navigation.product-home.custom-icon-alt-text",
        "defaultMessage": "Custom Jira icon"
    },
    jiraLogoLabel: {
        "id": "atlassian-navigation.product-home.jira-logo-label",
        "defaultMessage": "Go to your Jira homepage"
    },
    jsmLogoLabel: {
        "id": "atlassian-navigation.product-home.jsm-logo-label",
        "defaultMessage": "Go to your Jira Service Management homepage"
    },
    jpdLogoLabel: {
        "id": "atlassian-navigation.product-home.jpd-logo-label",
        "defaultMessage": "Go to your Jira Product Discovery homepage"
    },
    jcsLogoLabel: {
        "id": "atlassian-navigation.product-home.jcs-logo-label",
        "defaultMessage": "Go to your Jira Customer Service homepage"
    },
    csmLogoLabel: {
        "id": "atlassian-navigation.product-home.csm-logo-label",
        "defaultMessage": "Go to your Customer Service Management homepage"
    }
});

});

parcelRegister("b3S4D", function(module, exports) {
$parcel$export(module.exports, "JSMAndCSMLogo", () => $96e1789ab92fb11c$export$273e17850dfc6e0c);

var $eJOHy = parcelRequire("eJOHy");

var $O2sC7 = parcelRequire("O2sC7");

var $kfvK2 = parcelRequire("kfvK2");

var $lRq8t = parcelRequire("lRq8t");

var $lWdYg = parcelRequire("lWdYg");

var $h9tDf = parcelRequire("h9tDf");

var $8MN6v = parcelRequire("8MN6v");
const $96e1789ab92fb11c$export$89f90ea8776fdb88 = (0, $kfvK2.createRouterSelector)((state)=>state.route.group);
function $96e1789ab92fb11c$export$273e17850dfc6e0c({ navigateToHome: navigateToHome, testIdPrefix: testIdPrefix, homeURL: homeURL, projectType: projectType }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const routeGroup = $96e1789ab92fb11c$export$89f90ea8776fdb88();
    const { label: label, icon: icon, name: name } = (0, $eJOHy.useMemo)(()=>{
        const selectedProductName = projectType ? $96e1789ab92fb11c$var$getProductNameByProjectType(projectType) : $96e1789ab92fb11c$var$getProductNameByRouteGroup(routeGroup);
        return {
            label: (0, $8MN6v.getLogoLabel)(formatMessage, selectedProductName),
            ...(0, $8MN6v.getProductIcon)(selectedProductName, testIdPrefix)
        };
    }, [
        formatMessage,
        projectType,
        routeGroup,
        testIdPrefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $O2sC7.AppLogo), {
        label: label,
        icon: icon,
        name: name,
        href: homeURL,
        onClick: navigateToHome
    });
}
const $96e1789ab92fb11c$var$PRODUCT_NAME_MAP = {
    CUSTOMER_SERVICE: 'customer-service',
    SERVICE_DESK: 'serviceDesk',
    DEFAULT: 'jira'
};
function $96e1789ab92fb11c$var$getProductNameByProjectType(projectType) {
    switch(projectType){
        case 'CUSTOMER_SERVICE':
            return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.CUSTOMER_SERVICE;
        case 'SERVICE_DESK':
            return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.SERVICE_DESK;
        default:
            return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.DEFAULT;
    }
}
function $96e1789ab92fb11c$var$getProductNameByRouteGroup(routeGroup) {
    switch(routeGroup){
        case 'directories':
            {
                // There are two routes that can be used to navigate to the projects directory:
                // 1. projectsDirectoryRoute
                //    This is the route users land on when they directly navigate to the projects directory
                //    e.g. /jira/projects?page=1&sortKey=name&sortOrder=ASC&types=customer_service
                //    Note the query param is named "types" for the project types
                // 2. projectsDirectoryLegacyPathRedirectRoute
                //    This route is from the app switcher that uses a legacy path with a redirect
                //    e.g. /secure/BrowseProjects.jspa?selectedProjectType=customer_service
                //    Note the query param is named "selectedProjectType" for the project types
                // We need to check both routes and query params to determine the product name.
                const routerState = (0, $kfvK2.getRouterState)();
                if (routerState.route.name === (0, $lWdYg.projectsDirectoryRoute).name || routerState.route.name === (0, $h9tDf.projectsDirectoryLegacyPathRedirectRoute).name) {
                    const projectTypes = routerState.query?.types || routerState.query?.selectedProjectType;
                    const typesArray = projectTypes?.split(',')?.filter(Boolean) ?? [];
                    if (typesArray.includes('customer_service')) return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.CUSTOMER_SERVICE;
                    if (typesArray.includes('service_desk')) return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.SERVICE_DESK;
                }
                return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.DEFAULT;
            }
        case 'customer-service':
            return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.CUSTOMER_SERVICE;
        case 'servicedesk':
            return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.SERVICE_DESK;
        default:
            return $96e1789ab92fb11c$var$PRODUCT_NAME_MAP.DEFAULT;
    }
}

});
parcelRegister("h9tDf", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $d97f830e3798d52f$export$c713f57300a82898);
const $d97f830e3798d52f$export$c713f57300a82898 = {
    name: 'projects-directory-legacy-path-spa-redirect',
    path: '/secure/BrowseProjects.jspa'
};

});

parcelRegister("8MN6v", function(module, exports) {
$parcel$export(module.exports, "getProductIcon", () => $5b378620d3056eea$export$22a9451e3bf2233f);
$parcel$export(module.exports, "getLogoLabel", () => $5b378620d3056eea$export$20e08d839e9f9688);

var $eJOHy = parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $4cTDP = parcelRequire("4cTDP");

var $dzJfX = parcelRequire("dzJfX");
const $5b378620d3056eea$export$6d49a893c897b0cc = {
    jira: {
        icon: (0, $lgMTT.JiraIcon),
        name: 'Jira'
    },
    serviceDesk: {
        icon: (0, $lgMTT.JiraServiceManagementIcon),
        name: 'Jira Service Management'
    },
    'product-discovery': {
        icon: (0, $lgMTT.JiraProductDiscoveryIcon),
        name: 'Jira Product Discovery'
    },
    'customer-service': {
        icon: (0, $lgMTT.CustomerServiceManagementIcon),
        name: 'Customer Service Management'
    }
};
function $5b378620d3056eea$export$22a9451e3bf2233f(productName, testIdPrefix, label) {
    const productKey = productName === 'core' || productName === 'software' ? 'jira' : productName;
    const { icon: NewIconComponent, name: logoName } = $5b378620d3056eea$export$6d49a893c897b0cc[productKey];
    const createComponent = (Component, type, shouldUseNewLogoDesign)=>(props)=>{
            const additionalProps = {};
            // Nav v3 sets a testId, Nav v4 sets a label
            if (testIdPrefix) additionalProps.testId = `${testIdPrefix}-${type}`;
            if (label) additionalProps.label = label;
            additionalProps.shouldUseNewLogoDesign = shouldUseNewLogoDesign;
            // Casting required due to complexities of the different component prop types
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
                ...props,
                ...additionalProps
            });
        };
    const newIcon = createComponent(NewIconComponent, 'icon', true);
    return {
        icon: newIcon,
        name: logoName
    };
}
function $5b378620d3056eea$export$20e08d839e9f9688(formatMessage, productName) {
    let label = '';
    if (productName === 'serviceDesk') label = formatMessage((0, $dzJfX.default).jsmLogoLabel);
    else if (productName === 'product-discovery') label = formatMessage((0, $dzJfX.default).jpdLogoLabel);
    else if (productName === 'customer-service') label = formatMessage((0, $4cTDP.fg)('csm_rename_jcs_to_csm') ? (0, $dzJfX.default).csmLogoLabel : (0, $dzJfX.default).jcsLogoLabel);
    else label = formatMessage((0, $dzJfX.default).jiraLogoLabel);
    return label;
}

});



parcelRegister("et1RD", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $4be68d757c0fd608$export$5120f2d0b8d4cab8);

var $eJOHy = parcelRequire("eJOHy");

var $6aIoE = parcelRequire("6aIoE");

var $lVMSx = parcelRequire("lVMSx");

var $RXvVX = parcelRequire("RXvVX");

var $3MbOI = parcelRequire("3MbOI");

var $cxQGT = parcelRequire("cxQGT");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");

var $b2fGl = parcelRequire("b2fGl");

var $hQCAT = parcelRequire("hQCAT");
const $4be68d757c0fd608$var$Nav4Profile = ({ AccountMenu: AccountMenu = (0, $6aIoE.AccountMenuNav3), MenuNav4: MenuNav4 = (0, $hQCAT.MenuNav4), useCurrentUser: // eslint-disable-next-line react-hooks/react-compiler
useCurrentUser = (0, $3MbOI.useCurrentUser), useUserBoardId: // eslint-disable-next-line react-hooks/react-compiler
useUserBoardId = (0, $b2fGl.useUserBoardId) })=>{
    const { theme: theme, setTheme: setTheme } = (0, $cxQGT.useThemePreference)();
    const { data: { user: user } } = useCurrentUser();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & User)'.
    const emailAddress = user.emailAddress || '';
    const atlassianSettingsLink = (0, $lVMSx.useAtlassianPersonalSettingsLink)(emailAddress);
    const switchAccountLink = (0, $lVMSx.useSwitchAccountLink)();
    const profileLink = (0, $lVMSx.useProfileLink)();
    // eslint-disable-next-line react-hooks/react-compiler
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(false);
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'profile');
    if (user.isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AccountMenu, {
        testId: testIdPrefix,
        // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & User)'.
        name: user.displayName,
        // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & User)'.
        picture: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
        email: emailAddress,
        viewProfileLink: profileLink,
        manageProfileLink: atlassianSettingsLink,
        switchAccountLink: switchAccountLink,
        logOutLink: "/logout",
        onThemeChange: setTheme,
        currentTheme: theme,
        extraMenuItems: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuNav4, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        })
    });
};
const $4be68d757c0fd608$var$Profile = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4be68d757c0fd608$var$Nav4Profile, props);
const $4be68d757c0fd608$export$5120f2d0b8d4cab8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).PROFILE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4be68d757c0fd608$var$Profile, props));

});
parcelRegister("lVMSx", function(module, exports) {
$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $77ba1c58fea86490$export$8ac70acdad00754b);
$parcel$export(module.exports, "useSwitchAccountLink", () => $77ba1c58fea86490$export$dce6af3168fb6ced);
$parcel$export(module.exports, "useProfileLink", () => $77ba1c58fea86490$export$b8f25e615dd30d7b);

var $b5RwB = parcelRequire("b5RwB");

var $8RHPx = parcelRequire("8RHPx");

var $dOwXt = parcelRequire("dOwXt");

var $d3wpJ = parcelRequire("d3wpJ");

var $1xlYL = parcelRequire("1xlYL");

var $eWDmv = parcelRequire("eWDmv");

var $lzHTu = parcelRequire("lzHTu");

var $8LnTF = parcelRequire("8LnTF");

var $7MMy7 = parcelRequire("7MMy7");

var $jmzgU = parcelRequire("jmzgU");

var $k7VE6 = parcelRequire("k7VE6");

var $5PY5j = parcelRequire("5PY5j");

var $eULUA = parcelRequire("eULUA");

var $e6YEs = parcelRequire("e6YEs");

var $5RW99 = parcelRequire("5RW99");

const $77ba1c58fea86490$export$ab902790e443b0ec = ()=>`${(0, $8RHPx.getATLContextUrl)('id')}/login`;
const $77ba1c58fea86490$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $77ba1c58fea86490$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $8RHPx.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $77ba1c58fea86490$export$dce6af3168fb6ced = ()=>{
    const loginLink = $77ba1c58fea86490$export$ab902790e443b0ec();
    const { href: href } = (0, $dOwXt.default)() || {};
    return `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        application: 'jira',
        continue: href,
        prompt: 'select_account'
    })}`;
};
const $77ba1c58fea86490$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $e6YEs.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $77ba1c58fea86490$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $77ba1c58fea86490$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $1xlYL.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $eWDmv.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $jmzgU.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $k7VE6.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $5PY5j.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $77ba1c58fea86490$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $1xlYL.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $jmzgU.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $k7VE6.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $lzHTu.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $d3wpJ.browseProjectRedirectRoute)
    };
};
const $77ba1c58fea86490$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $eULUA.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $8LnTF.customPracticeQueueRoute) : (0, $7MMy7.customQueueRoute)
    };
};
const $77ba1c58fea86490$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $77ba1c58fea86490$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $5RW99.ADDON_ID).DISCOVER);

});
parcelRegister("d3wpJ", function(module, exports) {
$parcel$export(module.exports, "browseProjectRedirectRoute", () => $5b577f32c2c2e49a$export$f9cac37753487f39);
const $5b577f32c2c2e49a$export$f9cac37753487f39 = {
    name: 'browse-project-redirect',
    path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
    exact: true
};

});

parcelRegister("1xlYL", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $b8accc242737a0ed$export$73b60789ceb8e1eb);
const $b8accc242737a0ed$export$73b60789ceb8e1eb = {
    name: 'classic-business-redirect',
    path: '/jira/core/projects/:projectKey',
    exact: true
};

});

parcelRegister("eWDmv", function(module, exports) {
$parcel$export(module.exports, "jsmBoardRoute", () => $ef24c8f577828357$export$a192088aab559fa1);
const $ef24c8f577828357$export$a192088aab559fa1 = {
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: 'servicedesk-boards',
    exact: true
};

});

parcelRegister("lzHTu", function(module, exports) {
$parcel$export(module.exports, "projectServiceDeskRoute", () => $f2ad8a3da9671eff$export$1cfc858068dd8718);
const $f2ad8a3da9671eff$export$1cfc858068dd8718 = {
    name: 'servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});

parcelRegister("8LnTF", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueRoute", () => $de61ecd99379c904$export$59d0bd42aa07faad);
const $de61ecd99379c904$export$59d0bd42aa07faad = {
    name: 'servicedesk-practice-custom-and-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("7MMy7", function(module, exports) {
$parcel$export(module.exports, "customQueueRoute", () => $8b42a61db1b1071b$export$e1fac82ca0b0d637);
const $8b42a61db1b1071b$export$e1fac82ca0b0d637 = {
    name: 'servicedesk-queues-custom-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("jmzgU", function(module, exports) {
$parcel$export(module.exports, "softwareBoardRoute", () => $082ff7e9e2fdd717$export$9ae2c0a566d4e0f6);
const $082ff7e9e2fdd717$export$9ae2c0a566d4e0f6 = {
    name: 'software-boards',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("k7VE6", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $a86c112e63e1973c$export$131d51ca54849e97);
const $a86c112e63e1973c$export$131d51ca54849e97 = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("5PY5j", function(module, exports) {
$parcel$export(module.exports, "userBoardRoute", () => $c671295e8f87ee59$export$57a2a0fe739f16);
const $c671295e8f87ee59$export$57a2a0fe739f16 = {
    name: 'rapidboard-user-board',
    path: '/jira/people/:accountId/boards/:boardId'
};

});

parcelRegister("eULUA", function(module, exports) {
$parcel$export(module.exports, "toShortFormItsmPractice", () => $b467ca1786f529f0$export$db58a56259f511a2);

var $jlJsl = parcelRequire("jlJsl");
const $b467ca1786f529f0$var$longToShortConversionMap = {
    [(0, $jlJsl.CHANGES)]: (0, $jlJsl.SHORT_FORM_CHANGES),
    [(0, $jlJsl.INCIDENTS)]: (0, $jlJsl.SHORT_FORM_INCIDENTS),
    [(0, $jlJsl.PROBLEMS)]: (0, $jlJsl.SHORT_FORM_PROBLEMS),
    [(0, $jlJsl.SERVICE_REQUEST)]: (0, $jlJsl.SHORT_FORM_SERVICE_REQUEST),
    [(0, $jlJsl.POST_INCIDENT_REVIEWS)]: (0, $jlJsl.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $jlJsl.DEVELOPER_ESCALATION)]: (0, $jlJsl.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $b467ca1786f529f0$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $b467ca1786f529f0$var$longToShortConversionMap;
}
const $b467ca1786f529f0$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($b467ca1786f529f0$var$isLongForm(workCategoryKey)) return $b467ca1786f529f0$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});
parcelRegister("jlJsl", function(module, exports) {
$parcel$export(module.exports, "CHANGES", () => $4f1e5109a7f57422$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $4f1e5109a7f57422$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $4f1e5109a7f57422$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $4f1e5109a7f57422$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $4f1e5109a7f57422$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $4f1e5109a7f57422$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $4f1e5109a7f57422$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $4f1e5109a7f57422$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $4f1e5109a7f57422$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $4f1e5109a7f57422$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $4f1e5109a7f57422$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $4f1e5109a7f57422$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $4f1e5109a7f57422$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $4f1e5109a7f57422$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $4f1e5109a7f57422$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $4f1e5109a7f57422$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $4f1e5109a7f57422$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $4f1e5109a7f57422$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $4f1e5109a7f57422$export$6c24c440228eac9c);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $4f1e5109a7f57422$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $4f1e5109a7f57422$export$b78213db77524b5b);

var $dUuiD = parcelRequire("dUuiD");

var $ZfaX7 = parcelRequire("ZfaX7");
const $4f1e5109a7f57422$export$8598196f74460271 = 'change-management';
const $4f1e5109a7f57422$export$a50b49a533b5f7bc = 'incident-management';
const $4f1e5109a7f57422$export$ceba70db1edb1def = 'problem-management';
const $4f1e5109a7f57422$export$3d1cda9bd50505e8 = 'service-request';
const $4f1e5109a7f57422$export$6ebf7b6bf1c580f = 'post-incident-review';
const $4f1e5109a7f57422$export$81e62964cc725098 = 'developer-escalation';
const $4f1e5109a7f57422$export$485b1216c42d8d4 = 'no-category';
const $4f1e5109a7f57422$var$NO_CATEGORY_NEW = 'no-category-new';
const $4f1e5109a7f57422$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $4f1e5109a7f57422$export$a50185c8e9fb007e = 'changes';
const $4f1e5109a7f57422$export$a54a30a3c3cce634 = 'incidents';
const $4f1e5109a7f57422$export$354f3a4c6ac0c903 = 'problems';
const $4f1e5109a7f57422$export$335d3ac0c367f03f = 'service-requests';
const $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $4f1e5109a7f57422$export$cb41b99ca54e6bd = 'developer-escalations';
const $4f1e5109a7f57422$export$a613d808168c7b25 = [
    $4f1e5109a7f57422$export$8598196f74460271,
    $4f1e5109a7f57422$export$a50b49a533b5f7bc,
    $4f1e5109a7f57422$export$ceba70db1edb1def,
    $4f1e5109a7f57422$export$3d1cda9bd50505e8,
    $4f1e5109a7f57422$export$6ebf7b6bf1c580f,
    $4f1e5109a7f57422$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $4f1e5109a7f57422$export$a2b1f8f055150f02 = [
    $4f1e5109a7f57422$export$3d1cda9bd50505e8,
    $4f1e5109a7f57422$export$a50b49a533b5f7bc,
    $4f1e5109a7f57422$export$ceba70db1edb1def,
    $4f1e5109a7f57422$export$8598196f74460271,
    $4f1e5109a7f57422$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $4f1e5109a7f57422$export$5a9122a4028fb8ef = [
    ...$4f1e5109a7f57422$export$a2b1f8f055150f02,
    $4f1e5109a7f57422$export$485b1216c42d8d4
];
const $4f1e5109a7f57422$export$f1b813cd23817ade = [
    $4f1e5109a7f57422$export$a50185c8e9fb007e,
    $4f1e5109a7f57422$export$a54a30a3c3cce634,
    $4f1e5109a7f57422$export$354f3a4c6ac0c903,
    $4f1e5109a7f57422$export$335d3ac0c367f03f,
    $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f,
    $4f1e5109a7f57422$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $4f1e5109a7f57422$export$56c57f7ad650c45c = {
    [$4f1e5109a7f57422$export$8598196f74460271]: $4f1e5109a7f57422$export$a50185c8e9fb007e,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: $4f1e5109a7f57422$export$a54a30a3c3cce634,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: $4f1e5109a7f57422$export$354f3a4c6ac0c903,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: $4f1e5109a7f57422$export$335d3ac0c367f03f,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: $4f1e5109a7f57422$var$NO_CATEGORY_NEW
};
const $4f1e5109a7f57422$export$fbf0dfd01228e38d = {
    [$4f1e5109a7f57422$export$8598196f74460271]: (0, $ZfaX7.default).changes,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: (0, $ZfaX7.default).serviceRequests,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: (0, $ZfaX7.default).problems,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: (0, $ZfaX7.default).incidents,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: (0, $ZfaX7.default).postIncidentReviews,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: (0, $ZfaX7.default).queues,
    [$4f1e5109a7f57422$export$81e62964cc725098]: (0, $ZfaX7.default).developerEscalation,
    [$4f1e5109a7f57422$export$52bf3f16b7812704]: (0, $ZfaX7.default).noCategory
};
const $4f1e5109a7f57422$export$45ba5f49e9509c4d = {
    [$4f1e5109a7f57422$export$8598196f74460271]: (0, $ZfaX7.default).changesLower,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: (0, $ZfaX7.default).serviceRequestsLower,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: (0, $ZfaX7.default).problemsLower,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: (0, $ZfaX7.default).incidentsLower,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: (0, $ZfaX7.default).postIncidentReviewsLower,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: (0, $ZfaX7.default).queuesLower,
    [$4f1e5109a7f57422$export$81e62964cc725098]: (0, $ZfaX7.default).developerEscalationLower,
    [$4f1e5109a7f57422$export$52bf3f16b7812704]: (0, $ZfaX7.default).noCategoryLower
};
const $4f1e5109a7f57422$export$45952424a7f29b99 = (0, $dUuiD.getTypedKeys)($4f1e5109a7f57422$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $4f1e5109a7f57422$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $4f1e5109a7f57422$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
}, {});
const $4f1e5109a7f57422$export$6c24c440228eac9c = 'Changes';
const $4f1e5109a7f57422$export$5b65d27ec2d28d18 = 'Incidents';
const $4f1e5109a7f57422$var$PROBLEMS_JQL_NAME = 'Problems';
const $4f1e5109a7f57422$var$SERVICE_REQUEST_JQL_NAME = 'Service requests';
const $4f1e5109a7f57422$var$POST_INCIDENT_REVIEWS_JQL_NAME = 'Post-incident reviews';
const $4f1e5109a7f57422$export$3f757c5e00588ffd = 'Developer escalation';
const $4f1e5109a7f57422$export$b78213db77524b5b = {
    [$4f1e5109a7f57422$export$8598196f74460271]: $4f1e5109a7f57422$export$6c24c440228eac9c,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: $4f1e5109a7f57422$export$5b65d27ec2d28d18,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: $4f1e5109a7f57422$var$PROBLEMS_JQL_NAME,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: $4f1e5109a7f57422$var$SERVICE_REQUEST_JQL_NAME,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: $4f1e5109a7f57422$var$POST_INCIDENT_REVIEWS_JQL_NAME,
    [$4f1e5109a7f57422$export$81e62964cc725098]: $4f1e5109a7f57422$export$3f757c5e00588ffd
};

});
parcelRegister("dUuiD", function(module, exports) {
$parcel$export(module.exports, "hasProp", () => $6153d585a5415445$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $6153d585a5415445$export$5206d47972fefe20);
/**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $6153d585a5415445$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $6153d585a5415445$export$5206d47972fefe20 = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj);
};

});

parcelRegister("ZfaX7", function(module, exports) {
$parcel$export(module.exports, "default", () => $255bf593eeb7a55c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $255bf593eeb7a55c$var$messages = (0, $7qGN1.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});
var $255bf593eeb7a55c$export$2e2bcd8739ae039 = $255bf593eeb7a55c$var$messages;

});




parcelRegister("b2fGl", function(module, exports) {
$parcel$export(module.exports, "useUserBoardId", () => $3c72783d3dc78d70$export$e6e895063f36c814);

var $eJOHy = parcelRequire("eJOHy");

var $3ugTQ = parcelRequire("3ugTQ");

var $kZIBu = parcelRequire("kZIBu");
const $3c72783d3dc78d70$export$e6e895063f36c814 = (shouldRun)=>{
    const [{ isReady: isReady }] = (0, $kZIBu.useSpaStatePageReady)();
    const [userBoard, setUserBoard] = (0, $eJOHy.useState)(null);
    const shouldFetch = shouldRun || isReady;
    (0, $eJOHy.useEffect)(()=>{
        if (!shouldFetch || userBoard) return;
        setUserBoard(null);
        const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
        (0, $3ugTQ.performGetRequest)(requestUrl).then((result)=>{
            const [board] = result.views;
            if (board) setUserBoard(board);
        }).catch(()=>{
        // user board fetch failed, ignore
        });
    }, [
        shouldFetch,
        userBoard,
        setUserBoard
    ]);
    return userBoard && userBoard.location ? [
        userBoard.id,
        userBoard.location.accountId
    ] : [
        null,
        null
    ];
};

});

parcelRegister("hQCAT", function(module, exports) {
$parcel$export(module.exports, "MenuNav4", () => $5fe9c7bb35cc433b$export$60113ca6a29c7a92);
/* main-nav4.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $eJOdq = parcelRequire("eJOdq");
var $6YEko = parcelRequire("6YEko");

var $FhXEJ = parcelRequire("FhXEJ");

var $4ctwv = parcelRequire("4ctwv");

var $lRq8t = parcelRequire("lRq8t");

var $RXvVX = parcelRequire("RXvVX");

var $2aY2d = parcelRequire("2aY2d");

var $5PY5j = parcelRequire("5PY5j");


var $gA6Um = parcelRequire("gA6Um");

var $fegFz = parcelRequire("fegFz");

var $2FqDG = parcelRequire("2FqDG");

var $lqSnk = parcelRequire("lqSnk");

var $4cTDP = parcelRequire("4cTDP");

var $kO1ht = parcelRequire("kO1ht");

var $1hBLh = parcelRequire("1hBLh");

var $b5gS8 = parcelRequire("b5gS8");

var $i32yb = parcelRequire("i32yb");

var $hRfDr = parcelRequire("hRfDr");


const $5fe9c7bb35cc433b$var$StandardToPremiumPubTouchpoint = (parcelRequire("aohb6")).default;
const $5fe9c7bb35cc433b$var$useIsPlanRoute = ()=>{
    const [planId] = (0, $2FqDG.usePathParam)('planId');
    return planId !== undefined;
};
const $5fe9c7bb35cc433b$export$60113ca6a29c7a92 = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $eJOHy.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const testId = (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $RXvVX.testIdConcat)(testId, 'content');
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $gA6Um.useJsmOnboardingType)();
    const isPlanRoute = $5fe9c7bb35cc433b$var$useIsPlanRoute();
    (0, $eJOHy.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $FhXEJ.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e6294c08fdc1cc17$export$6f454e69bce3a691);
    const showInPlan = isPlanRoute && (0, $4cTDP.fg)('quickstart_onboarding_in_jira_plans');
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $5PY5j.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const showQuickstartOpenMenuItem = showInJwmProjects || showInSoftwareProjects || showInJsmProjects || showInPlan;
    const quickstartOpenMenuItem = ()=>{
        if (showQuickstartOpenMenuItem) {
            if (isPlanRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqSnk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fegFz.OpenMenuItem), {
                MenuItem: (0, $1hBLh.MenuItem)
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fegFz.OpenMenuItem), {
                MenuItem: (0, $1hBLh.MenuItem)
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuList), null, quickstartOpenMenuItem(), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true,
        testId: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOdq.default), {
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $hRfDr.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        ariaLabel: formatMessage((0, $hRfDr.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $hRfDr.default).yourBoards))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5fe9c7bb35cc433b$var$StandardToPremiumPubTouchpoint, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i32yb.ExtraItemsNav4), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $hRfDr.default).jira)
    }));
};

});
const $e6294c08fdc1cc17$export$6f454e69bce3a691 = 'business';
const $e6294c08fdc1cc17$export$e6952b12ade67489 = 'default';

parcelRegister("gA6Um", function(module, exports) {
$parcel$export(module.exports, "useJsmOnboardingType", () => $9b7107bc0a7cf7b4$export$5daaa68c3a578af9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gjl0t = parcelRequire("gjl0t");
const $9b7107bc0a7cf7b4$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $9b7107bc0a7cf7b4$var$Store = (0, $GtRbT.createStore)({
    initialState: $9b7107bc0a7cf7b4$export$d4c72bab9d6cc13a,
    actions: $gjl0t.actions,
    name: 'JSMOnboardingType'
});
const $9b7107bc0a7cf7b4$export$5daaa68c3a578af9 = (0, $iJq0l.createHook)($9b7107bc0a7cf7b4$var$Store);

});
parcelRegister("gjl0t", function(module, exports) {
$parcel$export(module.exports, "actions", () => $d999595a94332453$export$e324594224ef24da);

var $6wO5O = parcelRequire("6wO5O");
const $d999595a94332453$export$e324594224ef24da = {
    fetchOnboardingType: $6wO5O.fetchOnboardingType
};

});
parcelRegister("6wO5O", function(module, exports) {
$parcel$export(module.exports, "fetchOnboardingType", () => $76364540b36f58b7$export$ea62467635172b55);

var $FhXEJ = parcelRequire("FhXEJ");

var $hgi0g = parcelRequire("hgi0g");
const $76364540b36f58b7$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $76364540b36f58b7$export$ea62467635172b55 = (projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $FhXEJ.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $hgi0g.default)($76364540b36f58b7$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("fegFz", function(module, exports) {
$parcel$export(module.exports, "JswOnboardingChecklist", () => $547e7c79cce2b88f$export$aea93106aaeec3fc);
$parcel$export(module.exports, "JswOnboardingButton", () => $547e7c79cce2b88f$export$c0cbc1198da400db);
$parcel$export(module.exports, "OpenMenuItem", () => $547e7c79cce2b88f$export$67c4b22563f33286);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $5vQ2T = parcelRequire("5vQ2T");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");

var $eYe3w = parcelRequire("eYe3w");

var $i5x17 = parcelRequire("i5x17");

var $4EKqI = parcelRequire("4EKqI");

var $bQWwW = parcelRequire("bQWwW");

var $iqzS0 = parcelRequire("iqzS0");

var $4cTDP = parcelRequire("4cTDP");

var $2JwiI = parcelRequire("2JwiI");
const $547e7c79cce2b88f$var$FallbackChecklist = ()=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $8TWuG.qsChecklistAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $547e7c79cce2b88f$export$aea93106aaeec3fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "quickstart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "asyncChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-checklist-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($547e7c79cce2b88f$var$FallbackChecklist, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqzS0.JswOnboardingChecklistNext), null))));
const $547e7c79cce2b88f$var$FallbackButton = ()=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $8TWuG.qsButtonAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $547e7c79cce2b88f$export$c0cbc1198da400db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "asyncChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-checklist-button-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($547e7c79cce2b88f$var$FallbackButton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i5x17.QuickstartPillVisibilityContainer), {
        scope: "ListPageQuickstartPill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2JwiI.JswOnboardingButtonNext), null))));

const $547e7c79cce2b88f$export$e6a8d3e2a6acc946 = (0, $bQWwW.lazy)(()=>(parcelRequire("4Ez2s")).then(({ OpenMenuItem: OpenMenuItem })=>{
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.openMenuItemLoadTime).mark((0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return OpenMenuItem;
    }), {
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/open-menu-item/index.tsx"
});
const $547e7c79cce2b88f$var$SubmitOpenMenuItemLoadStart = ()=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument')) {
            (0, $8TWuG.openMenuItemLoadTime).start();
            (0, $8TWuG.openMenuItemLoadTime).mark((0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START);
        }
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $547e7c79cce2b88f$export$67c4b22563f33286 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "asyncOpenMenuItemComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-checklist-open-menu-item",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($547e7c79cce2b88f$var$SubmitOpenMenuItemLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($547e7c79cce2b88f$export$e6a8d3e2a6acc946, props)));

});
parcelRegister("8TWuG", function(module, exports) {
$parcel$export(module.exports, "isMetricRunning", () => $5a1cd387bc2f0023$export$5c2d3e87043198cf);
$parcel$export(module.exports, "openMenuItemLoadTime", () => $5a1cd387bc2f0023$export$9aef270bc11ae96b);
$parcel$export(module.exports, "qsButtonAutoLoadTime", () => $5a1cd387bc2f0023$export$844f48c93ed69757);
$parcel$export(module.exports, "qsChecklistAutoLoadTime", () => $5a1cd387bc2f0023$export$c501d2dfab0e9e45);
$parcel$export(module.exports, "qsChecklistMinimiseInteraction", () => $5a1cd387bc2f0023$export$ac78fba7425e64da);
$parcel$export(module.exports, "qsChecklistDismissInteraction", () => $5a1cd387bc2f0023$export$494d4094aaa2bc4d);
$parcel$export(module.exports, "qsButtonOpenInteraction", () => $5a1cd387bc2f0023$export$da7d38041ee220c8);
$parcel$export(module.exports, "qsButtonDismissInteraction", () => $5a1cd387bc2f0023$export$ce2841e9d619cdfd);
// @ts-expect-error - TS2305 - Module '"@atlassian/browser-metrics"' has no exported member 'BaseMetric'.

var $hqYEY = parcelRequire("hqYEY");

var $dslup = parcelRequire("dslup");
const $5a1cd387bc2f0023$export$5c2d3e87043198cf = (metric)=>metric?.state === 'started';
const $5a1cd387bc2f0023$export$9aef270bc11ae96b = (0, $hqYEY.metrics).custom({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.open.menu-item.load`,
    timings: [
        {
            key: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $5a1cd387bc2f0023$export$844f48c93ed69757 = (0, $hqYEY.metrics).custom({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.button.load`,
    timings: [
        {
            key: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $5a1cd387bc2f0023$export$c501d2dfab0e9e45 = (0, $hqYEY.metrics).custom({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.checklist.load`,
    timings: [
        {
            key: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $5a1cd387bc2f0023$export$ac78fba7425e64da = (0, $hqYEY.metrics).interaction({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.checklist.minimize`
});
const $5a1cd387bc2f0023$export$494d4094aaa2bc4d = (0, $hqYEY.metrics).interaction({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.checklist.dismiss`
});
const $5a1cd387bc2f0023$export$da7d38041ee220c8 = (0, $hqYEY.metrics).interaction({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.button.open`
});
const $5a1cd387bc2f0023$export$ce2841e9d619cdfd = (0, $hqYEY.metrics).interaction({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.button.dismiss`
});

});

parcelRegister("i5x17", function(module, exports) {
$parcel$export(module.exports, "QuickstartPillVisibilityContainer", () => $755a5efa3d0f2fe2$export$1a5202e8ea7b76ab);
$parcel$export(module.exports, "useQuickstartPillVisibilityStore", () => $755a5efa3d0f2fe2$export$70dc54081d2075ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $755a5efa3d0f2fe2$var$actions = {
    toggleShowQuickstart: ({ showQuickstartPill: showQuickstartPill })=>({ setState: setState })=>{
            setState({
                showQuickstartPill: showQuickstartPill
            });
        }
};
const $755a5efa3d0f2fe2$var$initialState = {
    showQuickstartPill: null
};
const $755a5efa3d0f2fe2$var$Store = (0, $GtRbT.createStore)({
    initialState: $755a5efa3d0f2fe2$var$initialState,
    actions: $755a5efa3d0f2fe2$var$actions,
    name: 'JiraQuickstartPillVisibility'
});
const $755a5efa3d0f2fe2$export$1a5202e8ea7b76ab = (0, $6E16M.createContainer)($755a5efa3d0f2fe2$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$755a5efa3d0f2fe2$var$initialState
            });
        }
});
const $755a5efa3d0f2fe2$export$70dc54081d2075ff = (0, $iJq0l.createHook)($755a5efa3d0f2fe2$var$Store);

});

parcelRegister("iqzS0", function(module, exports) {
$parcel$export(module.exports, "JswOnboardingChecklistNext", () => $dac1900256d0d277$export$bbc4e97e9a15a84b);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $dLR8J = parcelRequire("dLR8J");

var $2imLM = parcelRequire("2imLM");

var $5vQ2T = parcelRequire("5vQ2T");

var $dfP3D = parcelRequire("dfP3D");

var $eYe3w = parcelRequire("eYe3w");

var $9ycBx = parcelRequire("9ycBx");

var $gxP9D = parcelRequire("gxP9D");

var $dELL6 = parcelRequire("dELL6");

var $4cTDP = parcelRequire("4cTDP");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");

var $e34lC = parcelRequire("e34lC");
const $dac1900256d0d277$export$bbc4e97e9a15a84b = ()=>{
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>()=>{
            closeRightSidebar((0, $dslup.PANEL_ID));
            (0, $dELL6.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
        }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument') && (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED) && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsChecklistAutoLoadTime))) // QS Checklist loading cancelled for page load action
        (0, $8TWuG.qsChecklistAutoLoadTime).cancel();
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument') && quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsChecklistDismissInteraction))) // User interaction completed for QS Checklist dismiss action
        (0, $8TWuG.qsChecklistDismissInteraction).stop();
        if (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED && currentRightSidebarPanelId === (0, $dslup.PANEL_ID)) {
            closeRightSidebar((0, $dslup.PANEL_ID));
            (0, $dELL6.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
            return;
        }
        if (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN && currentRightSidebarPanelId !== (0, $dslup.PANEL_ID)) {
            openRightSidebar((0, $dslup.PANEL_ID), (0, $dslup.PANEL_WIDTH));
            (0, $dELL6.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                openRightSidebarAsMinimised: false,
                openRightSidebarToTop: false,
                trigger: 'JswOnboardingChecklistNext'
            });
        }
    }, [
        currentRightSidebarPanelId,
        openRightSidebar,
        closeRightSidebar,
        quickstartStatus,
        createAnalyticsEvent,
        isRightSidePanelMinimised
    ]);
    if (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "quickstart-fetching-data"
    });
    if (quickstartStatus !== (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "internalChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-checklist-next",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e34lC.AsyncJswOnboardingChecklistInternal), null)));
};

});
parcelRegister("e34lC", function(module, exports) {
$parcel$export(module.exports, "AsyncJswOnboardingChecklistInternal", () => $60838450286e3537$export$9f3262905af42485);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $60838450286e3537$var$Checklist = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("fZo31")).then(({ JswOnboardingChecklistFinal: JswOnboardingChecklistFinal })=>{
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.qsChecklistAutoLoadTime).mark((0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return JswOnboardingChecklistFinal;
    }), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-checklist-next/src/ui/onboarding-checklist/checklist/index.tsx"
});
const $60838450286e3537$var$ChecklistInternalLoadStart = ()=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.qsChecklistAutoLoadTime).mark((0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $60838450286e3537$export$9f3262905af42485 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-checklist-view-internal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($60838450286e3537$var$ChecklistInternalLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($60838450286e3537$var$Checklist, null));

});
parcelRegister("fZo31", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ea26D")
]).then(()=>parcelRequire('aUkI4'));

});



parcelRegister("2JwiI", function(module, exports) {
$parcel$export(module.exports, "JswOnboardingButtonNext", () => $8b90c3e5f52c63c4$export$bc3535037a418fa9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ftN6c = parcelRequire("ftN6c");

var $5vQ2T = parcelRequire("5vQ2T");

var $dfP3D = parcelRequire("dfP3D");

var $elL9D = parcelRequire("elL9D");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");

var $eYe3w = parcelRequire("eYe3w");

var $9ycBx = parcelRequire("9ycBx");

var $dt54n = parcelRequire("dt54n");

var $gxP9D = parcelRequire("gxP9D");

var $dELL6 = parcelRequire("dELL6");

var $hih5V = parcelRequire("hih5V");

var $i5x17 = parcelRequire("i5x17");

var $95O7y = parcelRequire("95O7y");

var $4cTDP = parcelRequire("4cTDP");

var $5bzWA = parcelRequire("5bzWA");

var $byils = parcelRequire("byils");
const $8b90c3e5f52c63c4$export$7127386abbb0f79c = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const [selectedIssueValue] = (0, $95O7y.useQueryParam)('selectedIssue');
    const [viewValue] = (0, $95O7y.useQueryParam)('view');
    const isInRoadMapRoute = (0, $dt54n.isRoadmapRoute)(route?.name);
    const isInBacklogRoute = route?.name === 'software-backlog';
    const isInBoardRoute = route?.name === 'software-boards';
    const isInRapidBoardBacklogRoute = route?.name === 'rapidboard-backlog';
    const isInRapidBoardBoardRoute = route?.name === 'rapidboard-board';
    // CMP & TMP Roadmap, and TMP backlog & board use selectedIssue query param
    if ((isInRoadMapRoute || isInBacklogRoute || isInBoardRoute) && Boolean(selectedIssueValue)) return true;
    // CMP backlog use view="detail" query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBacklogRoute) return viewValue === 'detail';
    // CMP Active Sprints and Kanban board uses view=detail query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBoardRoute && viewValue === 'detail') return true;
    return false;
};
const $8b90c3e5f52c63c4$export$bc3535037a418fa9 = ()=>{
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const isIssueViewOpened = $8b90c3e5f52c63c4$export$7127386abbb0f79c();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const [{ showQuickstartPill: showQuickstartPill }] = (0, $i5x17.useQuickstartPillVisibilityStore)();
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    (0, $eJOHy.useEffect)(()=>{
        if ((quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN) && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsButtonAutoLoadTime))) // QS Button loading cancelled for page load action
        (0, $8TWuG.qsButtonAutoLoadTime).cancel();
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument') && quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsButtonDismissInteraction))) // User interaction completed for QS Button dismiss action
        (0, $8TWuG.qsButtonDismissInteraction).stop();
        if (quickstartStatus !== (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED) return;
        // check if quickstart panel is already shown in minimised state in right-hand sidebar
        if (currentRightSidebarPanelId === (0, $dslup.PANEL_ID) && isRightSidePanelMinimised === true) return;
        openRightSidebar((0, $dslup.PANEL_ID), (0, $dslup.PANEL_WIDTH), true);
        (0, $dELL6.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            isRightSidePanelCollapsed: isRightSidePanelMinimised,
            isRightSidePanelMinimised: isRightSidePanelMinimised,
            currentRightSidebarPanelId: currentRightSidebarPanelId || '',
            openRightSidebarAsMinimised: true,
            openRightSidebarToTop: false,
            trigger: 'JswOnboardingButtonNext'
        });
    }, [
        isRightSidePanelMinimised,
        openRightSidebar,
        currentRightSidebarPanelId,
        quickstartStatus,
        createAnalyticsEvent
    ]);
    if (quickstartStatus !== (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED || showQuickstartPill !== null && !showQuickstartPill && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.endsWith('/list') || isFullscreen && (0, $4cTDP.fg)('quickstart_onboarding_in_jira_plans')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "internalChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $elL9D.JiraBottomRightCornerOutlet), {
        orderFromRight: 1,
        id: "software-onboarding-quickstart-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b90c3e5f52c63c4$var$QuickstartButtonContainer, {
        isIssueViewOpened: isIssueViewOpened,
        "data-testid": "software-onboarding-quickstart.ui.onboarding-button.onboarding-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $byils.JswOnboardingChecklistButton), null))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b90c3e5f52c63c4$var$QuickstartButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueViewOpened: isIssueViewOpened, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isIssueViewOpened ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("byils", function(module, exports) {
$parcel$export(module.exports, "JswOnboardingChecklistButton", () => $f385b19bae52ef7a$export$235000cc42ca709a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3H9Wc = parcelRequire("3H9Wc");

var $ftN6c = parcelRequire("ftN6c");

var $dfP3D = parcelRequire("dfP3D");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");


var $9ycBx = parcelRequire("9ycBx");

var $46NrI = parcelRequire("46NrI");

var $gxP9D = parcelRequire("gxP9D");

var $4cTDP = parcelRequire("4cTDP");

var $dELL6 = parcelRequire("dELL6");

var $c3tJH = parcelRequire("c3tJH");
var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");


var $157bu = parcelRequire("157bu");
const $f385b19bae52ef7a$var$ChecklistButtonAnaylticsWrapper = (0, $c3tJH.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $3H9Wc.default));
const $f385b19bae52ef7a$export$235000cc42ca709a = ()=>{
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const [, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, setNudgeStep: setNudgeStep, setHasNudgeActive: setHasNudgeActive, setQuickstartButtonRef: setQuickstartButtonRef, setIsOpenedViaButton: setIsOpenedViaButton }] = (0, $gxP9D.useQuickstartActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const openChecklist = (0, $157bu.useOpenChecklist)();
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const [remoteStateFromHook] = (0, $gxP9D.useJswOnboarding)();
    const buttonWrapperRef = (0, $eJOHy.useRef)(null);
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    // Store the button ref for focus management when panel is minimized
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('jira_a11y_focus_quickstart_button')) return;
        const wrapperElement = buttonWrapperRef.current;
        if (wrapperElement) {
            // Find the actual button element within the wrapper
            const buttonElement = wrapperElement.querySelector('button');
            if (buttonElement) setQuickstartButtonRef(buttonElement);
        }
        return ()=>{
            setQuickstartButtonRef(null);
        };
    }, [
        setQuickstartButtonRef
    ]);
    const onDismiss = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.qsButtonDismissInteraction).start();
        nextSetChecklistIsDismissed(true);
        setNudgeStep((0, $2b839a8453de5367$export$7aa8bceae32c7862));
        setHasNudgeActive(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $dELL6.fireAnalyticsOnQuickstartDismiss)(analyticsEvent, {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $46NrI.getProductType)(remoteStateFromHook.projectState?.projectType)
        }, 'button');
    }, [
        createAnalyticsEvent,
        nextSetChecklistIsDismissed,
        setNudgeStep,
        setHasNudgeActive,
        remoteStateFromHook
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if ((0, $8TWuG.isMetricRunning)((0, $8TWuG.qsButtonAutoLoadTime))) // QS Button loading completed on page load action
        (0, $8TWuG.qsButtonAutoLoadTime).stop();
        if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument') && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsChecklistMinimiseInteraction))) // User interaction completed for QS Checklist minimise action
        (0, $8TWuG.qsChecklistMinimiseInteraction).stop();
    }, []);
    const projectKey = remoteStateFromHook.projectState?.projectKey;
    if (projectKey && (0, $9ycBx.SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON).includes(projectKey) && (0, $4cTDP.fg)('jfind-mature-example-project-gate')) return;
    if (currentRightSidebarPanelId !== (0, $dslup.PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f385b19bae52ef7a$var$TriggerWrapper, {
        ref: buttonWrapperRef,
        reposition: quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$9d2de6eebf7462b5),
        sourceName: (0, $6a5cf820a64a0990$export$75cc63c8ac8ae533)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        attributes: {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $46NrI.getProductType)(remoteStateFromHook.projectState?.projectType)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f385b19bae52ef7a$var$ChecklistButtonAnaylticsWrapper, {
        isOpen: quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED,
        title: "Quickstart",
        onClick: (event, analyticsEvent)=>{
            if (!(0, $4cTDP.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.qsButtonOpenInteraction).start();
            // Mark that the panel was opened via button click for focus management
            if ((0, $4cTDP.fg)('jira_a11y_focus_quickstart_button')) setIsOpenedViaButton(true);
            openChecklist({
                trigger: 'JswOnboardingChecklistButton'
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, (0, $6a5cf820a64a0990$export$75cc63c8ac8ae533), {
                projectId: remoteStateFromHook.projectState?.projectId,
                productType: (0, $46NrI.getProductType)(remoteStateFromHook.projectState?.projectType)
            });
        },
        onDismiss: onDismiss
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f385b19bae52ef7a$var$TriggerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { reposition: reposition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564vccv _syaz1gjq _80omtlke",
            __cmplp.reposition ? "_otyr8vuz" : "_otyridpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c3tJH", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEventToProps", () => $6571f9d80c82bd3a$export$3e9ef96ba97ea9dc);

var $4J0ad = parcelRequire("4J0ad");
const $6571f9d80c82bd3a$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $6571f9d80c82bd3a$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $4J0ad.default)($6571f9d80c82bd3a$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

// Used for analytics event context for secondary (floating button) view
const $6a5cf820a64a0990$export$75cc63c8ac8ae533 = 'nuxOnboardingQuickstartButton';



parcelRegister("4Ez2s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4cMzD").then(()=>parcelRequire('9Yoaw'));

});


parcelRegister("lqSnk", function(module, exports) {
$parcel$export(module.exports, "default", () => $80a9f3361d85d0c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $80a9f3361d85d0c1$var$LazyComponent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9VjNh")), {
    moduleId: "./src/packages/portfolio/services/plans-item-visibility/src/ui/plan-permissions/index.tsx"
});
const $80a9f3361d85d0c1$export$be4ddb5e29230676 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-plans-item-visibility-permission",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($80a9f3361d85d0c1$var$LazyComponent, props));
var $80a9f3361d85d0c1$export$2e2bcd8739ae039 = $80a9f3361d85d0c1$export$be4ddb5e29230676;

});
parcelRegister("9VjNh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("emqoL").then(()=>parcelRequire('dteRd'));

});


parcelRegister("1hBLh", function(module, exports) {
$parcel$export(module.exports, "MenuItem", () => $b8cb90b7a2b1b478$export$2ce376c2cc3355c8);

var $eJOHy = parcelRequire("eJOHy");

var $7saMl = parcelRequire("7saMl");

var $6uJ4f = parcelRequire("6uJ4f");

var $9ZZNx = parcelRequire("9ZZNx");

var $2MUA0 = parcelRequire("2MUA0");
const $b8cb90b7a2b1b478$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, params: params, query: query, replace: replace, target: target, to: to, type: type, ...rest }, ref)=>{
    const onClickHandler = (0, $2MUA0.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ZZNx.RouteLinkItem), {
        ref: ref,
        onClick: onClickHandler,
        params: params,
        query: query,
        replace: replace,
        target: target,
        to: to,
        type: type,
        ...rest
    });
    return href ? // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6uJ4f.LinkItem), {
        ref: ref,
        href: href,
        target: target,
        onClick: onClickHandler,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        ref: ref,
        onClick: onClickHandler,
        ...rest
    });
});

});
parcelRegister("6uJ4f", function(module, exports) {
$parcel$export(module.exports, "LinkItem", () => $5e13ec63c364dbe8$export$532cb6865ebe8946);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1PYwQ = parcelRequire("1PYwQ");
var $f58rc = parcelRequire("f58rc");

var $4cTDP = parcelRequire("4cTDP");

var $g0rPQ = parcelRequire("g0rPQ");

var $5zy3q = parcelRequire("5zy3q");
const $5e13ec63c364dbe8$var$AkLinkWithUnwrappedInteractiveChildren = (0, $g0rPQ.WithUnwrappedInteractiveChildren)((0, $f58rc.default));
const $5e13ec63c364dbe8$export$532cb6865ebe8946 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ href: href, target: target, onClick: onClick, ...rest }, ref)=>{
    const Item = (0, $4cTDP.fg)('jfp-a11y-team_interactive-elements-nesting') ? (0, $1PYwQ.default) : $5e13ec63c364dbe8$export$8c0773eab230d49e;
    const navigate = (0, $5zy3q.useNavigate)({
        href: href,
        onClick: onClick,
        target: target
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Item, {
        ...(0, $4cTDP.fg)('jfp-a11y-team_interactive-elements-nesting') && {
            component: $5e13ec63c364dbe8$var$AkLinkWithUnwrappedInteractiveChildren
        },
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : '',
        onClick: navigate,
        ref: ref,
        ...rest
    });
});
const $5e13ec63c364dbe8$export$8c0773eab230d49e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $f58rc.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nrm18uv _1a3b18uv _9oik18uv _c2wa1kw7 _4fpr1kw7 _1bnx1kw7 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g0rPQ", function(module, exports) {
$parcel$export(module.exports, "WithUnwrappedInteractiveChildren", () => $8e3cb6783ee29076$export$aecb71b5768388c7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $8e3cb6783ee29076$var$MenuItemCss = null;
const $8e3cb6783ee29076$var$StretchedBlanketCss = null;
// This blank space is needed to enforce React Router to render the empty anchor tag
const $8e3cb6783ee29076$var$BLANKET_CONTENT = ' ';
const $8e3cb6783ee29076$export$aecb71b5768388c7 = (InteractiveBlanket)=>/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
            className: (0, $hcewu.default)([
                "_kqswh2mm",
                className
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InteractiveBlanket, {
            ref: ref,
            ...props,
            className: (0, $hcewu.default)([
                "_kqswstnw _1bsb1osq _4t3i1osq _154ize3t _1ltvze3t _1cwg1i6y _13ro1i6y _1bg41i6y _1ah31i6y"
            ])
        }, $8e3cb6783ee29076$var$BLANKET_CONTENT), children));

});

parcelRegister("5zy3q", function(module, exports) {
$parcel$export(module.exports, "useNavigate", () => $31d694917f726592$export$9770f232ac06a008);

var $eJOHy = parcelRequire("eJOHy");

var $83DiZ = parcelRequire("83DiZ");
const $31d694917f726592$export$9770f232ac06a008 = ({ href: href, target: target, onClick: onClick, useRouterActions: // eslint-disable-next-line react-hooks/react-compiler
useRouterActions = (0, $83DiZ.useRouterActions), useCallback: // eslint-disable-next-line react-hooks/react-compiler
useCallback = (0, $eJOHy.useCallback) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { push: push } = useRouterActions();
    // eslint-disable-next-line react-hooks/react-compiler
    return useCallback((event)=>{
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;
        event.preventDefault();
        push(href);
    }, [
        push,
        href,
        target,
        onClick
    ]);
};

});


parcelRegister("9ZZNx", function(module, exports) {
$parcel$export(module.exports, "RouteLinkItem", () => $904f689b4d0846c3$export$5885e1e37551a766);

var $eJOHy = parcelRequire("eJOHy");

var $1PYwQ = parcelRequire("1PYwQ");

var $4cTDP = parcelRequire("4cTDP");

var $c9uTK = parcelRequire("c9uTK");

var $g0rPQ = parcelRequire("g0rPQ");
// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $904f689b4d0846c3$var$LinkWithUnwrappedInteractiveChildren = (0, $g0rPQ.WithUnwrappedInteractiveChildren)((0, $c9uTK.Link));
const $904f689b4d0846c3$export$5885e1e37551a766 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ rel: rel, target: target, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PYwQ.default), {
        component: (0, $4cTDP.fg)('jfp-a11y-team_interactive-elements-nesting') ? $904f689b4d0846c3$var$LinkWithUnwrappedInteractiveChildren : (0, $c9uTK.Link),
        rel: rel ?? (target === '_blank' ? 'noopener noreferrer' : ''),
        target: target,
        prefetch: "hover",
        ref: ref,
        ...props
    }));

});

parcelRegister("2MUA0", function(module, exports) {
$parcel$export(module.exports, "useOnClick", () => $01ccf45946b66b19$export$a81c45382e7253ac);

var $idGJk = parcelRequire("idGJk");

var $gOfBc = parcelRequire("gOfBc");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $01ccf45946b66b19$export$a81c45382e7253ac = ({ analytics: analytics, fireUIAnalytics: fireUIAnalytics = (0, $kRgKj.fireUIAnalytics), onClick: onClick, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $ftN6c.useAnalyticsEvents), useOverflowStatus: // eslint-disable-next-line react-hooks/react-compiler
useOverflowStatus = (0, $idGJk.useOverflowStatus), useTopMenus: // eslint-disable-next-line react-hooks/react-compiler
useTopMenus = (0, $gOfBc.useTopMenus) } = {})=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [, { off: closeMenu }] = useTopMenus();
    // eslint-disable-next-line react-hooks/react-compiler
    const { isVisible: isVisible, closeOverflowMenu: closeOverflowMenu } = useOverflowStatus();
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { actionSubjectId: actionSubjectId, ...analyticsRest } = analytics;
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationMenuItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fireUIAnalytics(analyticsEvent, actionSubjectId, {
            ...analyticsRest,
            isInMore: !isVisible
        });
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey) return;
        closeMenu();
        closeOverflowMenu();
    };
};

});


parcelRegister("b5gS8", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $6c2299870bb261e7$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "MenuListItem", () => $6c2299870bb261e7$export$6c2f3257abc4825b);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $6c2299870bb261e7$export$d4c4e98c5044dc8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "ul",
        xcss: $6c2299870bb261e7$var$removeDefaultListStyles
    }, children);
const $6c2299870bb261e7$export$6c2f3257abc4825b = ({ children: children, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: (0, $4cTDP.fg)('blu-7838_fix_bullet_styling_in_top_nav_menu') ? [
            $6c2299870bb261e7$var$removeDefaultListStyles,
            $6c2299870bb261e7$var$removeListStyle
        ] : $6c2299870bb261e7$var$removeDefaultListStyles,
        "aria-label": ariaLabel
    }, children);
const $6c2299870bb261e7$var$removeDefaultListStyles = (0, $1DXK0.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $6c2299870bb261e7$var$removeListStyle = (0, $1DXK0.xcss)({
    listStyleType: 'none'
});

});

parcelRegister("i32yb", function(module, exports) {
$parcel$export(module.exports, "ExtraItemsNav4", () => $31c3553643237a3a$export$ee2972db91c46b97);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $6YEko = parcelRequire("6YEko");

var $cGvTS = parcelRequire("cGvTS");

var $RXvVX = parcelRequire("RXvVX");

var $enHI7 = parcelRequire("enHI7");

var $eJrcF = parcelRequire("eJrcF");

var $1hBLh = parcelRequire("1hBLh");

var $b5gS8 = parcelRequire("b5gS8");
const $31c3553643237a3a$var$useConnectItems = ()=>{
    const { data: resourceData, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $enHI7.navigationSidebarGlobalResource));
    const data = resourceData?.response;
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data ? (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'global.profile.items', []).filter((item)=>![
            'view_profile',
            'log_out'
        ].includes(item.id)) : [];
};
const $31c3553643237a3a$var$Item = ({ url: url, name: name, id: id, styleClass: styleClass, itemAriaLabel: itemAriaLabel, position: position, testId: testId })=>{
    const webItemRef = (0, $eJOHy.useRef)(null);
    const isDialog = styleClass && (0, $cGvTS.isConnectDialogWebItem)(styleClass);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (isDialog) (0, $cGvTS.withConnectHost)((connectHost)=>{
            if (styleClass && webItemRef.current) connectHost.triggerWebItem(webItemRef.current, styleClass, url);
        });
    }, [
        isDialog,
        styleClass,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        key: url,
        ariaLabel: itemAriaLabel || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        ref: webItemRef,
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'jira',
            position: position
        },
        href: isDialog ? undefined : url,
        onClick: isDialog ? onClick : undefined,
        testId: testId
    }, name));
};
const $31c3553643237a3a$export$56021421a935c353 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $31c3553643237a3a$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31c3553643237a3a$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $RXvVX.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};
const $31c3553643237a3a$export$ee2972db91c46b97 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $31c3553643237a3a$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31c3553643237a3a$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $RXvVX.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};

});

parcelRegister("hRfDr", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef73779f73e7b8a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4ef73779f73e7b8a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    giveFeedback: {
        "id": "atlassian-navigation.profile.menu.give-feedback",
        "defaultMessage": "Give us feedback"
    },
    yourBoards: {
        "id": "atlassian-navigation.profile.menu.your-boards",
        "defaultMessage": "Your boards"
    },
    new: {
        "id": "atlassian-navigation.profile.menu.new",
        "defaultMessage": "new"
    },
    personalSettings: {
        "id": "atlassian-navigation.profile.menu.personal-settings",
        "defaultMessage": "Personal settings"
    },
    logout: {
        "id": "atlassian-navigation.profile.menu.logout",
        "defaultMessage": "Log out"
    },
    jira: {
        "id": "atlassian-navigation.profile.menu.jira",
        "defaultMessage": "Jira"
    },
    account: {
        "id": "atlassian-navigation.profile.menu.account",
        "defaultMessage": "Account"
    },
    profile: {
        "id": "atlassian-navigation.profile.menu.profile",
        "defaultMessage": "Profile"
    },
    notifications: {
        "id": "atlassian-navigation.profile.menu.notifications",
        "defaultMessage": "Notifications"
    }
});

});

parcelRegister("aohb6", function(module, exports) {


module.exports = (parcelRequire("g81qY"))('edition_awareness_upsell_jira_ab_fg', function() {
    return parcelRequire('hDqVc');
}, function() {
    return parcelRequire('29Vb5');
}, {
    l: (parcelRequire("bbrhz")),
    i: [
        "dHAND",
        "aQyvI"
    ]
});

});
parcelRegister("bbrhz", function(module, exports) {
"use strict";
module.exports = function loadJSBundle(bundle) {
    // Don't insert the same script twice (e.g. if it was already in the HTML)
    let existingScripts = document.getElementsByTagName('script');
    let isCurrentBundle = function(script) {
        return script.src === bundle;
    };
    if ([].concat(existingScripts).some(isCurrentBundle)) return;
    // Request using XHR because it's synchronous and we can't use promises here
    // This has extremely poor performance because we're idle during this fetch, so we only use this so that the app won't crash
    const xhr = new XMLHttpRequest();
    xhr.open('GET', bundle, false);
    try {
        xhr.send();
        if (xhr.status === 200) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = xhr.responseText;
            // Execute the script synchronously
            document.head.appendChild(script);
        } else throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Status: ${xhr.status}`);
    } catch (e) {
        throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Error: ${e.message}`);
    }
};

});




parcelRegister("6wuXc", function(module, exports) {
$parcel$export(module.exports, "NavigationRouterListener", () => $964f4c5b44d5b7e0$export$85575e1c48f0a517);

var $eJOHy = parcelRequire("eJOHy");

var $gCY1z = parcelRequire("gCY1z");

var $75n38 = parcelRequire("75n38");
const $964f4c5b44d5b7e0$export$85575e1c48f0a517 = ()=>{
    const [{ route: route, location: location, match: match }] = (0, $gCY1z.useRouter)();
    const onEnd = (0, $75n38.useAtlassianNavigationEnd)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onEnd();
    }, [
        route,
        match,
        location,
        onEnd
    ]);
    return null;
};

});
parcelRegister("75n38", function(module, exports) {
$parcel$export(module.exports, "useAtlassianNavigationEnd", () => $f1fedb5d802fcf31$export$4b9602c0fdb8b1bb);

var $eJOHy = parcelRequire("eJOHy");


var $912hm = parcelRequire("912hm");
const $f1fedb5d802fcf31$export$4b9602c0fdb8b1bb = ()=>{
    const { setAppReadyWithAppId: setAppReadyWithAppId } = (0, $912hm.useSpaStateActions)();
    return (0, $eJOHy.useCallback)(()=>{
        setAppReadyWithAppId((0, $44a1f3ad00fd7f5d$export$3a54edb6ba4daa82));
    }, [
        setAppReadyWithAppId
    ]);
};

});


parcelRegister("kv0Iu", function(module, exports) {
$parcel$export(module.exports, "Search", () => $73babe0a2f637785$export$4b85d3515bd863a5);

var $eJOHy = parcelRequire("eJOHy");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $eGEpA = parcelRequire("eGEpA");

var $gOfBc = parcelRequire("gOfBc");

var $5RW99 = parcelRequire("5RW99");

var $f2JN3 = parcelRequire("f2JN3");

var $cxKOj = parcelRequire("cxKOj");

var $4EKqI = parcelRequire("4EKqI");

var $95O7y = parcelRequire("95O7y");
var $83DiZ = parcelRequire("83DiZ");

var $kO1ht = parcelRequire("kO1ht");

var $lgloJ = parcelRequire("lgloJ");

var $dcU1k = parcelRequire("dcU1k");

var $biHUf = parcelRequire("biHUf");

var $5W7YN = parcelRequire("5W7YN");

var $jNsQF = parcelRequire("jNsQF");

var $1sMAF = parcelRequire("1sMAF");
const $73babe0a2f637785$export$8f0d616c2469c6b6 = ({ setShowRealExperience: setShowRealExperience, injectValue: injectValue, useTopMenus: // eslint-disable-next-line react-hooks/react-compiler
useTopMenus = (0, $gOfBc.useTopMenus) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [_, { on: openMenu }] = useTopMenus((0, $5RW99.MENU_ID).SEARCH);
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $jNsQF.searchLoadOnIntentMetricStartFromSkeleton)();
        setShowRealExperience?.(true);
        openMenu();
    }, [
        setShowRealExperience,
        openMenu
    ]);
    const onMouseOver = (0, $eJOHy.useCallback)(()=>{
        setShowRealExperience?.(true);
    }, [
        setShowRealExperience
    ]);
    const onEnter = (0, $eJOHy.useCallback)((e)=>{
        const target = e.target;
        if (target instanceof HTMLInputElement) {
            target.blur();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const url = (0, $1sMAF.buildJiraAdvancedSearchUrl)(target.value, window.location.origin);
            push(url.href);
        }
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        inputMode: "search",
        onClick: onClick,
        onMouseOver: onMouseOver,
        onFocus: onClick,
        xcss: $73babe0a2f637785$var$quickFindSkeletonStyle,
        testId: "atlassian-navigation.ui.search.quickfind-skeleton-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eGEpA.QuickFindSkeleton), {
        onEnter: onEnter,
        isNav4Enabled: true,
        injectValue: injectValue
    }));
};
const $73babe0a2f637785$var$LoadingSkeleton = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biHUf.Skeleton), {
        placeholder: formatMessage((0, $lgloJ.default).interactiveSearchSkeletonPlaceholder),
        ariaLabel: formatMessage((0, $lgloJ.default).interactiveSearchSkeletonAriaLabel)
    });
};
const $73babe0a2f637785$var$LoadingSkeletonInteractive = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5W7YN.SkeletonInteractive), {
        placeholder: formatMessage((0, $lgloJ.default).interactiveSearchSkeletonPlaceholder)
    });
};
const $73babe0a2f637785$var$SearchDialogMetricStart = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        (0, $dcU1k.searchDialogMetric).startFromPageLoad();
        (0, $dcU1k.searchDialogMetric).mark((0, $dcU1k.SEARCH_DIALOG_DOWNLOAD_START_MARK));
    }, []);
    return null;
};
const $73babe0a2f637785$var$SearchDialogMetricEnd = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        (0, $dcU1k.searchDialogMetric).mark((0, $dcU1k.SEARCH_DIALOG_DOWNLOAD_END_MARK));
    }, []);
    return null;
};

const $73babe0a2f637785$export$964f3f99df662c38 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("ozYsA")).then((m)=>m.Search), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/search/main.tsx"
});
const $73babe0a2f637785$export$d8beef0361e69378 = (props)=>{
    const [injectValue] = (0, $95O7y.useQueryParam)('text');
    const isQuickFindEnabled = (0, $1sMAF.useQuickFindEnabled)();
    const loadingSkeleton = (0, $cxKOj.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$e455d67f280c301f, {
        useTopMenus: props.useTopMenus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$var$LoadingSkeleton, null);
    const skeleton = isQuickFindEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$8f0d616c2469c6b6, {
        useTopMenus: props.useTopMenus,
        injectValue: injectValue
    }) : loadingSkeleton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "search",
        packageName: (0, $kO1ht.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$var$SearchDialogMetricStart, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "lazy-search",
        fallback: skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$964f3f99df662c38, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$var$SearchDialogMetricEnd, null), (0, $cxKOj.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNsQF.SearchLoadOnIntentMetricEnd), null)));
};
const $73babe0a2f637785$var$loadingSkeletonExpandableWrapperStyle = {
    width: '100%'
}; // only for nav4
const $73babe0a2f637785$export$e455d67f280c301f = ({ setShowRealExperience: setShowRealExperience, useTopMenus: // eslint-disable-next-line react-hooks/react-compiler
useTopMenus = (0, $gOfBc.useTopMenus) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [_, { on: openMenu }] = useTopMenus((0, $5RW99.MENU_ID).SEARCH);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $jNsQF.searchLoadOnIntentMetricStartFromSkeleton)();
        setShowRealExperience?.(true);
        openMenu();
    }, [
        setShowRealExperience,
        openMenu
    ]);
    const onMouseOver = (0, $eJOHy.useCallback)(()=>{
        setShowRealExperience?.(true);
    }, [
        setShowRealExperience
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "atlassian-navigation.ui.search.loading-skeleton-expandable",
        onClick: onClick,
        onKeyDown: onClick,
        onMouseOver: onMouseOver,
        onFocus: onClick,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: $73babe0a2f637785$var$loadingSkeletonExpandableWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$var$LoadingSkeletonInteractive, null)));
};
const $73babe0a2f637785$export$49f3879f38fced1b = (props)=>{
    const [injectValue] = (0, $95O7y.useQueryParam)('text');
    const isQuickFindEnabled = (0, $1sMAF.useQuickFindEnabled)();
    // eslint-disable-next-line react-hooks/react-compiler
    const { useTopMenus: useTopMenus = (0, $gOfBc.useTopMenus) } = props;
    // eslint-disable-next-line react-hooks/react-compiler
    const [isSearchMenuOpen] = useTopMenus((0, $5RW99.MENU_ID).SEARCH);
    const [showRealExperience, setShowRealExperience] = (0, $eJOHy.useState)(isSearchMenuOpen);
    (0, $eJOHy.useEffect)(()=>{
        if (isSearchMenuOpen) setShowRealExperience(true);
    }, [
        isSearchMenuOpen,
        setShowRealExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "atlassian-navigation-search"
    }, showRealExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "atlassian-navigation-search-experience"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$d8beef0361e69378, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "atlassian-navigation-search-loading-skeleton-expandable"
    }, isQuickFindEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$8f0d616c2469c6b6, {
        // eslint-disable-next-line react-hooks/react-compiler
        useTopMenus: useTopMenus,
        setShowRealExperience: setShowRealExperience,
        injectValue: injectValue
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$e455d67f280c301f, {
        // eslint-disable-next-line react-hooks/react-compiler
        useTopMenus: useTopMenus,
        setShowRealExperience: setShowRealExperience
    })));
};
const $73babe0a2f637785$export$4b85d3515bd863a5 = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false), $73babe0a2f637785$export$49f3879f38fced1b, $73babe0a2f637785$export$d8beef0361e69378);
const $73babe0a2f637785$var$quickFindSkeletonStyle = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.0'
});

});
parcelRegister("lgloJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f067d9e90684ac6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8f067d9e90684ac6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updated: {
        "id": "atlassian-navigation.search.updated",
        "defaultMessage": "Updated"
    },
    interactiveSearchSkeletonPlaceholder: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-placeholder",
        "defaultMessage": "Search"
    },
    interactiveSearchSkeletonAriaLabel: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-aria-label",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("dcU1k", function(module, exports) {
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_START_MARK", () => $52e559471117562f$export$8cd6a987249a6f33);
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_END_MARK", () => $52e559471117562f$export$80ab6637ae730993);
$parcel$export(module.exports, "searchDialogMetric", () => $52e559471117562f$export$46d64d80a1040e9b);

var $hqYEY = parcelRequire("hqYEY");
const $52e559471117562f$var$SEARCH_DIALOG_METRIC_KEY = 'search-dialog';
const $52e559471117562f$export$8cd6a987249a6f33 = 'download-start';
const $52e559471117562f$export$80ab6637ae730993 = 'download-end';
const $52e559471117562f$export$46d64d80a1040e9b = (0, $hqYEY.metrics).pageSegmentLoad({
    key: $52e559471117562f$var$SEARCH_DIALOG_METRIC_KEY,
    timings: [
        {
            key: 'download',
            startMark: $52e559471117562f$export$8cd6a987249a6f33,
            endMark: $52e559471117562f$export$80ab6637ae730993
        }
    ]
});

});

parcelRegister("biHUf", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $11ad57b3d4c8d7c6$export$8f31e4c4a37b8e9c);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $lwPZB = parcelRequire("lwPZB");

var $gbld1 = parcelRequire("gbld1");

var $4cTDP = parcelRequire("4cTDP");

var $9RE4U = parcelRequire("9RE4U");

var $bDJm5 = parcelRequire("bDJm5");
const $11ad57b3d4c8d7c6$export$8f31e4c4a37b8e9c = ({ ProductSearchInputSkeleton: ProductSearchInputSkeleton = (0, $gbld1.ProductSearchInputSkeleton), useTheme: // eslint-disable-next-line react-hooks/react-compiler
useTheme = (0, $bDJm5.useTheme), placeholder: placeholder, ariaLabel: ariaLabel })=>{
    /**
	 * The nav3 custom theme object
	 */ // eslint-disable-next-line react-hooks/react-compiler
    useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $lwPZB.useLegacySearchTheme)();
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProductSearchInputSkeleton, {
        shouldFillContainer: true,
        theme: newTheme,
        placeholder: placeholder,
        ariaLabel: ariaLabel,
        dataSsrPlaceholder: !isPageHydrating && (0, $4cTDP.fg)('qs-7058-remove-experiment-call-search-dialog') ? 'nav4-search-bar' : undefined
    });
};

});

parcelRegister("5W7YN", function(module, exports) {
$parcel$export(module.exports, "SkeletonInteractive", () => $e2d0b85fee46ea69$export$f6cad695c873cb36);

var $eJOHy = parcelRequire("eJOHy");

var $lwPZB = parcelRequire("lwPZB");

var $8zLeM = parcelRequire("8zLeM");

var $bDJm5 = parcelRequire("bDJm5");
const $e2d0b85fee46ea69$export$f6cad695c873cb36 = ({ useTheme: // eslint-disable-next-line react-hooks/react-compiler
useTheme = (0, $bDJm5.useTheme), placeholder: placeholder })=>{
    /**
	 * The nav3 custom theme object
	 */ // eslint-disable-next-line react-hooks/react-compiler
    useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $lwPZB.useLegacySearchTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8zLeM.ProductSearchInputSkeletonInteractive), {
        shouldFillContainer: true,
        theme: newTheme,
        placeholder: placeholder || '',
        stickySearchEnabled: true
    });
};

});

parcelRegister("jNsQF", function(module, exports) {
$parcel$export(module.exports, "searchLoadOnIntentMetricStartFromSkeleton", () => $3fe7e4aabe209800$export$a9b73ef5805d7ce);
$parcel$export(module.exports, "SearchLoadOnIntentMetricEnd", () => $3fe7e4aabe209800$export$c802bd101ecfea1);
$parcel$export(module.exports, "searchLoadOnIntentMetricFromSearchFire", () => $3fe7e4aabe209800$export$5c176f125966323d);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
// eslint-disable-next-line no-restricted-properties, jira/jira-ssr/no-unchecked-globals-usage
const $3fe7e4aabe209800$var$getNow = ()=>window?.performance?.now?.();
class $3fe7e4aabe209800$var$SearchLoadOnIntentMetric {
    start(isStartFromSkeleton, startTime = $3fe7e4aabe209800$var$getNow()) {
        if (this.startTime !== null) return;
        this.isStartFromSkeleton = isStartFromSkeleton;
        this.startTime = startTime;
    }
    stop(analyticsEvent, endTime = $3fe7e4aabe209800$var$getNow()) {
        if (this.startTime === null || this.stopTime !== null || this.hasFired) return;
        this.stopTime = endTime;
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'searchDialog firstOpen', {
            startTime: Math.round(this.startTime),
            duration: Math.round((this.stopTime || 0) - (this.startTime || 0)),
            isStartFromSkeleton: this.isStartFromSkeleton
        });
        this.hasFired = true;
    }
    constructor(){
        this.hasFired = false;
        this.startTime = null;
        this.stopTime = null;
        this.isStartFromSkeleton = false;
    }
}
let $3fe7e4aabe209800$var$searchLoadOnIntentMetric = new $3fe7e4aabe209800$var$SearchLoadOnIntentMetric();
const $3fe7e4aabe209800$export$b2204437a87141a9 = ()=>$3fe7e4aabe209800$var$searchLoadOnIntentMetric;
const $3fe7e4aabe209800$export$69e5d67124dcdbcb = ()=>{
    $3fe7e4aabe209800$var$searchLoadOnIntentMetric = new $3fe7e4aabe209800$var$SearchLoadOnIntentMetric();
};
const $3fe7e4aabe209800$export$a9b73ef5805d7ce = (startTime)=>{
    $3fe7e4aabe209800$var$searchLoadOnIntentMetric.start(true, startTime);
};
const $3fe7e4aabe209800$export$c802bd101ecfea1 = ({ endTime: endTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        $3fe7e4aabe209800$var$searchLoadOnIntentMetric.stop(createAnalyticsEvent({}), endTime);
    }, [
        createAnalyticsEvent,
        endTime
    ]);
    return null;
};
const $3fe7e4aabe209800$export$5c176f125966323d = (analyticsEvent, now = $3fe7e4aabe209800$var$getNow())=>{
    if ($3fe7e4aabe209800$var$searchLoadOnIntentMetric.hasFired || $3fe7e4aabe209800$var$searchLoadOnIntentMetric.startTime !== null) return;
    $3fe7e4aabe209800$var$searchLoadOnIntentMetric.start(false, now);
    $3fe7e4aabe209800$var$searchLoadOnIntentMetric.stop(analyticsEvent, now);
};

});

parcelRegister("1sMAF", function(module, exports) {
$parcel$export(module.exports, "buildJiraAdvancedSearchUrl", () => $d8486820a9ae8b64$export$b5c6d8d10f4438a4);
$parcel$export(module.exports, "useQuickFindEnabled", () => $d8486820a9ae8b64$export$a5c820d7542f98bf);

var $59rsN = parcelRequire("59rsN");

var $d8CRX = parcelRequire("d8CRX");

var $lb6FK = parcelRequire("lb6FK");

var $4cTDP = parcelRequire("4cTDP");
const $d8486820a9ae8b64$var$ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
const $d8486820a9ae8b64$var$buildJiraSearchUrl = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $d8486820a9ae8b64$var$buildSmartQueryAdvancedSearchUrl = (query)=>`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;
const $d8486820a9ae8b64$var$buildJQLAdvancedIssueUrl = (jql)=>`/issues/?jql=${jql}`;
const $d8486820a9ae8b64$export$772e48b507423c7c = (query, jql)=>{
    const trimmedQuery = query.trim();
    if (!trimmedQuery) // If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
    return query === '' ? $d8486820a9ae8b64$var$ISSUE_NAVIGATOR_URL : $d8486820a9ae8b64$var$buildSmartQueryAdvancedSearchUrl(query);
    if (jql) // if JQL is provided, we build the work items URL with JQL
    return $d8486820a9ae8b64$var$buildJQLAdvancedIssueUrl(jql);
    // we navigate to the search page to handle the single work item page in case the query is a work item key
    return $d8486820a9ae8b64$var$buildJiraSearchUrl(trimmedQuery);
};
const $d8486820a9ae8b64$export$b5c6d8d10f4438a4 = (query, siteUrl, jql)=>{
    return new URL($d8486820a9ae8b64$export$772e48b507423c7c(query, jql), siteUrl);
};
/**
 * @deprecated Delete when cleaning up jira experiment layers (QS-8466)
 */ const $d8486820a9ae8b64$var$getQuickFindEnabledOnUserBasedLayer = ()=>{
    const layer = (0, $59rsN.default).getLayer((0, $d8CRX.STATSIG_SEARCH_PLATFORM_JIRA_LAYER), {
        fireLayerExposure: false
    });
    const isEnabled = layer.get('enabled', false);
    const uiFeatures = layer.get('uiFeatures', {
        rovoSearchExperienceEnabled: false
    });
    return {
        isEnabled: isEnabled,
        isQuickFindEnabled: uiFeatures.rovoSearchExperienceEnabled
    };
};
const $d8486820a9ae8b64$export$a5c820d7542f98bf = (experimentConfig)=>{
    const rovoEntitlement = (0, $lb6FK.useRovoEntitlementResource)();
    // Enable quick find by feature flag as priority to
    // allow easier internal dogfooding
    if ((0, $4cTDP.fg)('rovo_search_jira_enable_quick_find')) return true;
    if (!rovoEntitlement?.data?.isRovoEnabled) return false;
    let isExperimentEnabled = false;
    let isRovoSearchExperienceEnabledByExperiment = false;
    if (!experimentConfig) {
        const layer = (0, $59rsN.default).getLayer((0, $d8CRX.STATSIG_SEARCH_PLATFORM_JIRA_LAYER_TENANTS_BASED), {
            fireLayerExposure: false
        });
        const uiFeatures = layer.get('uiFeatures', {
            rovoSearchExperienceEnabled: false
        });
        isExperimentEnabled = layer.get('enabled', false);
        isRovoSearchExperienceEnabledByExperiment = uiFeatures.rovoSearchExperienceEnabled;
        // If the experiment is not enabled on tenant based layer, we fallback to user based layer
        if (!isExperimentEnabled) {
            const { isEnabled: isQuickFindEnabledOnUserBasedLayerEnabled, isQuickFindEnabled: isQuickFindEnabledOnUserBasedLayer } = $d8486820a9ae8b64$var$getQuickFindEnabledOnUserBasedLayer();
            isExperimentEnabled = isQuickFindEnabledOnUserBasedLayerEnabled;
            isRovoSearchExperienceEnabledByExperiment = isQuickFindEnabledOnUserBasedLayer;
        }
    } else {
        isExperimentEnabled = experimentConfig.combinedExperiment?.enabled ?? false;
        isRovoSearchExperienceEnabledByExperiment = Boolean(experimentConfig.combinedExperiment?.uiFeatures?.rovoSearchExperienceEnabled ?? false);
    }
    if (!isExperimentEnabled) return false;
    return isRovoSearchExperienceEnabledByExperiment;
};

});

parcelRegister("ozYsA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8X39V")
]).then(()=>parcelRequire('1s2AM'));

});


parcelRegister("2olUi", function(module, exports) {
$parcel$export(module.exports, "Settings", () => $a615229afd1abf39$export$c72f6eaae7b9adff);

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $6YEko = parcelRequire("6YEko");

var $bSOZZ = parcelRequire("bSOZZ");

var $8Uqf3 = parcelRequire("8Uqf3");

var $kAwwe = parcelRequire("kAwwe");

var $lRq8t = parcelRequire("lRq8t");

var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $RXvVX = parcelRequire("RXvVX");

var $8nMzv = parcelRequire("8nMzv");

var $kh7bJ = parcelRequire("kh7bJ");

var $iWvkh = parcelRequire("iWvkh");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $cHtIB = parcelRequire("cHtIB");

var $1BZ8a = parcelRequire("1BZ8a");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $kO1ht = parcelRequire("kO1ht");

var $4BIvh = parcelRequire("4BIvh");

var $4BXz7 = parcelRequire("4BXz7");

var $1tzLb = parcelRequire("1tzLb");

var $jTzOc = parcelRequire("jTzOc");

var $3nihz = parcelRequire("3nihz");

var $5lAC9 = parcelRequire("5lAC9");

var $2pW8u = parcelRequire("2pW8u");
const $a615229afd1abf39$var$useId = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira-react-uid-to-use-id-migration'), (0, $eJOHy.useId), (0, $o0Fzr.useUID));
const $a615229afd1abf39$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).SETTINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a615229afd1abf39$var$SettingsContainer, null));
});
function $a615229afd1abf39$var$SettingsContainer() {
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    if (isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a615229afd1abf39$var$SettingsInner, null);
}
function $a615229afd1abf39$var$SettingsInner() {
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, { toggle: toggleMenu, off: closeMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).SETTINGS);
    const triggerAnalytics = (0, $4BIvh.useNavigationItemAnalytics)({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).SETTINGS
    });
    (0, $8Uqf3.useExperienceStart)({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $kO1ht.NAVIGATION_ITEM_ID).SETTINGS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $eJOHy.useCallback)(()=>{
        toggleMenu();
        triggerAnalytics({
            shownCommandPalettePrompt: isAdmin
        });
    }, [
        isAdmin,
        toggleMenu,
        triggerAnalytics
    ]);
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'settings');
    const id = $a615229afd1abf39$var$useId();
    const titleId = `top-navigation-settings-header-${id}-title`;
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            isAdmin: isAdmin,
            appEditions: appEditions
        }), [
        cloudId,
        isAdmin,
        appEditions
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $5lAC9.settingsMenuEntryPoint), entryPointParams);
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const Trigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": "atlassian-navigation-settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bSOZZ.Settings), {
            ...triggerProps,
            ref: (element)=>{
                triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            isSelected: isOpen,
            interactionName: "nav4-topNav-settings",
            label: formatMessage((0, $2pW8u.default).settings)
        })), [
        formatMessage,
        isOpen,
        onClick,
        testIdPrefix,
        triggerRef
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        titleId: titleId,
        isOpen: isOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                id: "nav4-topNav-settings",
                entryPointReferenceSubject: entryPointReferenceSubject,
                packageName: (0, $kO1ht.PACKAGE_NAME),
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BXz7.MenuLayout), {
                    isWide: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
                    isScrollable: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tzLb.MenuSkeletonContent), {
                    testIdPrefix: testIdPrefix
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
                    hasSeparator: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jTzOc.MenuSkeletonFooter), {
                    testIdPrefix: testIdPrefix
                }))),
                runtimeProps: {
                    testIdPrefix: testIdPrefix,
                    titleId: titleId
                }
            }),
        onClose: closeMenu,
        placement: "bottom-end",
        messageId: "atlassian-navigation.ui.settings.popup",
        messageType: "transactional",
        trigger: Trigger,
        label: formatMessage((0, $2pW8u.default).settings),
        shouldRenderToParent: true
    });
}

});
parcelRegister("4BXz7", function(module, exports) {
$parcel$export(module.exports, "MenuLayout", () => $6a05bda3114a4f20$export$dc2a07138b27c65b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $jUgeq = parcelRequire("jUgeq");
const $6a05bda3114a4f20$export$dc2a07138b27c65b = ({ children: children, isWide: isWide = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a05bda3114a4f20$var$Wrapper, {
        isWide: isWide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        maxHeight: $6a05bda3114a4f20$var$maxHeight
    }, children));
const $6a05bda3114a4f20$var$starStyles = null;
const $6a05bda3114a4f20$var$maxHeight = 'calc(100vh - 200px)';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a05bda3114a4f20$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWide: isWide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dx5ss8": (0, $awdRS.default)(__cmplp.isWide ? '320px' : '234px')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul9t9uy _p12f1c3h _107nidpf _js70kb7n _nqzgkb7n _ziy7kb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1tzLb", function(module, exports) {
$parcel$export(module.exports, "MenuSkeletonContent", () => $b675ff5052172406$export$8db7a6d33c26b25f);

var $eJOHy = parcelRequire("eJOHy");

var $2oWak = parcelRequire("2oWak");
var $2bMVP = parcelRequire("2bMVP");

var $RXvVX = parcelRequire("RXvVX");
const $b675ff5052172406$export$8db7a6d33c26b25f = ({ testIdPrefix: testIdPrefix })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2oWak.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        width: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        width: "50%"
    }));

});

parcelRegister("jTzOc", function(module, exports) {
$parcel$export(module.exports, "MenuSkeletonFooter", () => $b870bf9dd361e2dd$export$efa6bae06cf20a1);

var $eJOHy = parcelRequire("eJOHy");

var $2bMVP = parcelRequire("2bMVP");

var $RXvVX = parcelRequire("RXvVX");
const $b870bf9dd361e2dd$export$efa6bae06cf20a1 = ({ testIdPrefix: testIdPrefix, numItems: numItems = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        width: "50%"
    }), numItems >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        width: "50%"
    }));

});

parcelRegister("5lAC9", function(module, exports) {
$parcel$export(module.exports, "settingsMenuEntryPoint", () => $3186560596db5716$export$61e5d93bdc8bc226);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4lUEQ = parcelRequire("4lUEQ");

var $4cTDP = parcelRequire("4cTDP");

const $3186560596db5716$export$61e5d93bdc8bc226 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9c8MQ")).then(({ TopNavSettingsMenu: TopNavSettingsMenu })=>TopNavSettingsMenu), {
        moduleId: "73f97a8e",
        moduleName: "TopNavSettingsMenu",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, isAdmin: isAdmin, appEditions: appEditions })=>({
            queries: {
                topNavSettingsMenuQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $4lUEQ.default),
                    variables: {
                        cloudId: cloudId,
                        // We can skip the permission check when:
                        // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                        // 2. Upsell is enabled (because upsell is only available to admins), or
                        // 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone), or
                        // 4. The delegated admin gate is disabled (because only admins would be able to view the feature)
                        skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' && (0, $4cTDP.fg)('restrict-custom-onboarding-to-premium-tier') || !(0, $4cTDP.fg)('jira-onboarding-hub-gate') || !(0, $4cTDP.fg)('jira-delegated-custom-onboarding')
                    }
                }
            }
        })
});

});
parcelRegister("4lUEQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c3dbaaca553d00d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba63e26054f21b7dc157eb1581400aee>>
 * @relayHash e5264ff2e1e93ecc4488b878cd9f6dc0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8879c403b31c51a48f95a1d8bc606857a6f4a3f73b124a3961adc1061bd4f1a8

var $37Ewn = parcelRequire("37Ewn");
const $0c3dbaaca553d00d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        }
    ], v1 = [
        {
            "condition": "skipDelegatedAdminCheck",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canManageCustomOnboarding",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "MANAGE_CUSTOM_ONBOARDING"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "hasGlobalPermission"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopNavSettingsMenuQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopNavSettingsMenuQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "8879c403b31c51a48f95a1d8bc606857a6f4a3f73b124a3961adc1061bd4f1a8",
            "metadata": {},
            "name": "TopNavSettingsMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0c3dbaaca553d00d$var$node.hash = "96f23bf06df8dcc622aad2cac544e460";
(0, $37Ewn.PreloadableQueryRegistry).set($0c3dbaaca553d00d$var$node.params.id, $0c3dbaaca553d00d$var$node);
var $0c3dbaaca553d00d$export$2e2bcd8739ae039 = $0c3dbaaca553d00d$var$node;

});

parcelRegister("9c8MQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("aCDMn")
]).then(()=>parcelRequire('bSCN7'));

});


parcelRegister("2pW8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b6f0250d98cd0ef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0b6f0250d98cd0ef$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    settings: {
        "id": "atlassian-navigation.settings.menu.settings",
        "defaultMessage": "Settings"
    }
});

});


parcelRegister("6phAP", function(module, exports) {
$parcel$export(module.exports, "SignIn", () => $fcb27fd0e80c4f6a$export$b64708c6f1b3ed96);

var $eJOHy = parcelRequire("eJOHy");

var $6K3F5 = parcelRequire("6K3F5");

var $dWEml = parcelRequire("dWEml");

var $lRq8t = parcelRequire("lRq8t");

var $kh7bJ = parcelRequire("kh7bJ");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");

var $4BIvh = parcelRequire("4BIvh");

var $2YGcG = parcelRequire("2YGcG");

var $2RKQ2 = parcelRequire("2RKQ2");
const $fcb27fd0e80c4f6a$var$SignIn = ({ useDestinationParam: // eslint-disable-next-line react-hooks/react-compiler
useDestinationParam = (0, $2RKQ2.useDestinationParam), useIntl: // eslint-disable-next-line react-hooks/react-compiler
useIntl = (0, $lRq8t.default), useNavigationItemAnalytics: // eslint-disable-next-line react-hooks/react-compiler
useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useIsAnonymous: // eslint-disable-next-line react-hooks/react-compiler
useIsAnonymous = (0, $kh7bJ.useIsAnonymous) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const destinationParam = useDestinationParam();
    // eslint-disable-next-line react-hooks/react-compiler
    const isAnonymous = useIsAnonymous();
    // eslint-disable-next-line react-hooks/react-compiler
    const { formatMessage: formatMessage } = useIntl();
    // eslint-disable-next-line react-hooks/react-compiler
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).SIGN_IN
    });
    if (!isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K3F5.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dWEml))),
        label: formatMessage((0, $2YGcG.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    });
};
const $fcb27fd0e80c4f6a$export$b64708c6f1b3ed96 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).SIGN_IN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fcb27fd0e80c4f6a$var$SignIn, props));

});
parcelRegister("2YGcG", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca58326d942b0996$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ca58326d942b0996$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    signIn: {
        "id": "atlassian-navigation.sign-in.sign-in",
        "defaultMessage": "Sign in"
    }
});

});

parcelRegister("2RKQ2", function(module, exports) {
$parcel$export(module.exports, "useDestinationParam", () => $ea863dfe961f37ea$export$c9c176e0725165cc);

var $dOwXt = parcelRequire("dOwXt");
const $ea863dfe961f37ea$export$c9c176e0725165cc = ()=>{
    const { href: href = null } = (0, $dOwXt.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return `os_destination=${encodedRedirectUrl}`;
    }
    return '';
};

});


parcelRegister("caHVZ", function(module, exports) {
$parcel$export(module.exports, "Nav4NotificationsData", () => $0f2abd1a0cdee471$export$4be76e93f368ccd9);

var $35SIo = parcelRequire("35SIo");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5vQ2T = parcelRequire("5vQ2T");

var $kO1ht = parcelRequire("kO1ht");

var $xmBsk = parcelRequire("xmBsk");
const $0f2abd1a0cdee471$export$4be76e93f368ccd9 = (props)=>{
    const { queryReference: queryReference } = props;
    const fragmentData = (0, $j4oe4.useFragment)((0, $35SIo.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "nav4-notifications-error-boundary",
        packageName: (0, $kO1ht.PACKAGE_NAME),
        teamName: (0, $kO1ht.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xmBsk.Nav4Notifications), {
        fragmentData: fragmentData
    }));
};

});
parcelRegister("35SIo", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f1859d8ed54515b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab5a4efb2e4c302f6507731481aad167>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f1859d8ed54515b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4NotificationsData",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Notifications"
        }
    ],
    "type": "Query"
};
$6f1859d8ed54515b$var$node.hash = "359a3dc4bc79536755e5a1c2e1775462";
var $6f1859d8ed54515b$export$2e2bcd8739ae039 = $6f1859d8ed54515b$var$node;

});

parcelRegister("xmBsk", function(module, exports) {
$parcel$export(module.exports, "Nav4Notifications", () => $d4ac2ed6fb5a42aa$export$c50c32b171c62438);

var $fIYVt = parcelRequire("fIYVt");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kJsb4 = parcelRequire("kJsb4");

var $fceQU = parcelRequire("fceQU");

var $RXvVX = parcelRequire("RXvVX");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $gOfBc = parcelRequire("gOfBc");

var $5RW99 = parcelRequire("5RW99");

var $8Uqf3 = parcelRequire("8Uqf3");

var $lRq8t = parcelRequire("lRq8t");

var $bQWwW = parcelRequire("bQWwW");

var $fYeTG = parcelRequire("fYeTG");

var $8Z2t0 = parcelRequire("8Z2t0");

var $eSnSE = parcelRequire("eSnSE");

var $kO1ht = parcelRequire("kO1ht");

var $4BIvh = parcelRequire("4BIvh");

var $isgAI = parcelRequire("isgAI");

var $TTU2Q = parcelRequire("TTU2Q");

var $jILIS = parcelRequire("jILIS");

var $6ajYG = parcelRequire("6ajYG");


var $ebmHm = parcelRequire("ebmHm");

var $jRdpz = parcelRequire("jRdpz");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d4ac2ed6fb5a42aa$var$LazyMenu = (0, $bQWwW.lazy)(()=>(parcelRequire("camud")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $d4ac2ed6fb5a42aa$export$c50c32b171c62438 = (props)=>{
    const { fragmentData: fragmentData } = props;
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const [_queryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $8Z2t0.default));
    const [data] = (0, $j4oe4.useRefetchableFragment)((0, $fIYVt.default), fragmentData);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Check for new notifications every 5 minutes. This is currently done through polling because
    // Relay subscriptions are not yet supported server side. This polling will need to be replaced with
    // a subscription in the future (when notifications are migrated to Post Office).
    (0, $TTU2Q.usePolling)((0, $eJOHy.useCallback)(()=>{
        if ((0, $fceQU.getDocument)()?.hidden) return;
        (0, $j4oe4.fetchQuery)(environment, (0, $8Z2t0.default), {}).subscribe({
            complete: ()=>{
                loadQuery({}, {
                    fetchPolicy: 'store-and-network'
                });
            },
            error: (error)=>{
                (0, $eSnSE.default).safeErrorWithoutCustomerData(`${(0, $kO1ht.PACKAGE_NAME)}.Nav4Notifications`, 'Error fetching notification', error);
            }
        });
    }, [
        environment,
        loadQuery
    ]), 300000);
    const fetchedNotificationsCount = data.notifications?.unseenNotificationCount ?? 0;
    // Initialise the state to false on page load, but use an effect to update it if the unseen notification
    // count changes (i.e. as a result of polling) to ensure the badge is shown when there are new notifications.
    const [isNotificationCleared, setIsNotificationCleared] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (fetchedNotificationsCount > 0) setIsNotificationCleared(false);
    }, [
        fetchedNotificationsCount
    ]);
    // If notifications have been cleared, force the badge to be 0. This crudely addresses a race condition where
    // opening the menu (which resets the unseen notification count) does not complete before a refetch completes.
    const notificationsCount = isNotificationCleared ? 0 : fetchedNotificationsCount;
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'notifications');
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).NOTIFICATIONS);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jILIS.NotificationsContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4ac2ed6fb5a42aa$var$LazyMenu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), [
        testIdPrefix
    ]);
    const triggerAnalytics = (0, $4BIvh.useNavigationItemAnalytics)({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (isMenuOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        // Always set isNotificationCleared to true when the menu trigger is clicked
        // that there are no unseen notifications).
        setIsNotificationCleared(true);
    // PLEASE NOTE: Refetching the notifications does not occur here because for some reason
    // it blocks the popup from being closed.
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    (0, $jRdpz.useRegisterNotificationsInCommandPalette)(onClick);
    const badge = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ajYG.Nav4NotificationsBadge), {
            count: notificationsCount
        }), [
        notificationsCount
    ]);
    const notificationsLabel = notificationsCount < (0, $fd3ecb7812b98df6$export$14c62ba6f49b806f) ? formatMessage((0, $ebmHm.default).label, {
        count: notificationsCount
    }) : formatMessage((0, $ebmHm.default).overNineNotifications);
    const trigger = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": "atlassian-navigation-notifications"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $isgAI.Notification), {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $ebmHm.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), [
        badge,
        formatMessage,
        isMenuOpen,
        notificationsLabel,
        onClick,
        openMenu,
        testIdPrefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};

});
parcelRegister("fIYVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ad9d47e70a9730e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39ea3d6e0f88481971cec9a363b97835>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $8Z2t0 = parcelRequire("8Z2t0");
const $8ad9d47e70a9730e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $8Z2t0.default)
        }
    },
    "name": "Nav4Notifications",
    "selections": [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ],
    "type": "Query"
};
$8ad9d47e70a9730e$var$node.hash = "9fa4e72bf771cce7bab0cd69ec168049";
var $8ad9d47e70a9730e$export$2e2bcd8739ae039 = $8ad9d47e70a9730e$var$node;

});
parcelRegister("8Z2t0", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ec3eb787f1d119b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e946028ffc3086f1d9efb784e3dbaa5>>
 * @relayHash b27ca3910e82a09b8cdc053e9a61ed19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f56bec76aa8f8c1f4592fbdd8e4dc7b3b3e88310f264e6c19fece22372dba44e
const $4ec3eb787f1d119b$var$node = {
    "fragment": {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4NotificationsRefetchableQuery",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4Notifications"
            }
        ],
        "type": "Query"
    },
    "kind": "Request",
    "operation": {
        "argumentDefinitions": [],
        "kind": "Operation",
        "name": "Nav4NotificationsRefetchableQuery",
        "selections": [
            {
                "concreteType": "InfluentsNotificationQuery",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "unseenNotificationCount"
                    }
                ]
            }
        ]
    },
    "params": {
        "id": "f56bec76aa8f8c1f4592fbdd8e4dc7b3b3e88310f264e6c19fece22372dba44e",
        "metadata": {},
        "name": "Nav4NotificationsRefetchableQuery",
        "operationKind": "query",
        "text": null
    }
};
$4ec3eb787f1d119b$var$node.hash = "9fa4e72bf771cce7bab0cd69ec168049";
var $4ec3eb787f1d119b$export$2e2bcd8739ae039 = $4ec3eb787f1d119b$var$node;

});


parcelRegister("TTU2Q", function(module, exports) {
$parcel$export(module.exports, "usePolling", () => $f53ec338019a0340$export$a11f73e3adecd502);

var $eJOHy = parcelRequire("eJOHy");
const $f53ec338019a0340$export$a11f73e3adecd502 = (callback, delay)=>{
    const callbackRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const tick = ()=>{
            if (callbackRef.current) callbackRef.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
};

});

parcelRegister("6ajYG", function(module, exports) {
$parcel$export(module.exports, "Nav4NotificationsBadge", () => $ea15bcfae5c6ade8$export$c4129d57a4559409);

var $eJOHy = parcelRequire("eJOHy");

var $55K0G = parcelRequire("55K0G");
const $ea15bcfae5c6ade8$export$c4129d57a4559409 = (props)=>{
    const { count: count } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $55K0G.Nav4NotificationsIndicator), {
        count: count
    });
};

});
parcelRegister("55K0G", function(module, exports) {
$parcel$export(module.exports, "Nav4NotificationsIndicator", () => $82f2bc9d98d1c209$export$6891e3964002ac9);

var $eJOHy = parcelRequire("eJOHy");

var $7q9BG = parcelRequire("7q9BG");
const $82f2bc9d98d1c209$var$MAX_NOTIFICATIONS_COUNT = 9;
const $82f2bc9d98d1c209$export$6891e3964002ac9 = (props)=>{
    const { appearance: appearance = 'important', count: count, max: max = $82f2bc9d98d1c209$var$MAX_NOTIFICATIONS_COUNT } = props;
    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-test-selector": "NotificationIndicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: "atlassian-navigation.ui.notifications.notification-indicator-badge",
        max: max,
        appearance: appearance
    }, count)) : null;
};

});







parcelRegister("iypv0", function(module, exports) {
$parcel$export(module.exports, "RedirectEntrypointContainer", () => $74db717060af61e4$export$1646bc91d273e9d3);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");


var $jrulJ = parcelRequire("jrulJ");

var $5vQ2T = parcelRequire("5vQ2T");

var $2dBpR = parcelRequire("2dBpR");

var $4EKqI = parcelRequire("4EKqI");
const $74db717060af61e4$export$1646bc91d273e9d3 = ()=>{
    const redirectEntrypointRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$5ef29550cd5a8266));
    if (!redirectEntrypointRef) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "redirect-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "redirect-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "redirect-entrypoint",
        fallback: null,
        entryPointReference: redirectEntrypointRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: redirectEntrypointRef,
        props: {}
    }))));
};

});

parcelRegister("5Wq2G", function(module, exports) {
$parcel$export(module.exports, "JiraPageLayout", () => $b3501c42496c2be5$export$9f8e98a8a88e6943);

var $eJOHy = parcelRequire("eJOHy");

var $cUxaS = parcelRequire("cUxaS");

var $dzLcO = parcelRequire("dzLcO");

var $bJscI = parcelRequire("bJscI");
// Used when the navx-full-height-sidebar feature flag is enabled
const $b3501c42496c2be5$var$PageLayoutWithFHSChanges = ({ children: children, ...props })=>{
    const { isCollapsed: isCollapsed } = (0, $cUxaS.useLeftSidebarState)();
    const [defaultSideNavCollapsed] = (0, $eJOHy.useState)(isCollapsed);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.PageLayout), {
        ...props,
        defaultSideNavCollapsed: defaultSideNavCollapsed,
        isSideNavShortcutEnabled: true
    }, children);
};
const $b3501c42496c2be5$export$9f8e98a8a88e6943 = (0, $bJscI.componentWithFG)('navx-full-height-sidebar', $b3501c42496c2be5$var$PageLayoutWithFHSChanges, (0, $dzLcO.PageLayout));

});

parcelRegister("1bE4f", function(module, exports) {
$parcel$export(module.exports, "JiraSpaPageContainer", () => $f10fc7ceb2036bd5$export$802ae4178431f591);
$parcel$export(module.exports, "JiraSpaPageContainerEntry", () => $f10fc7ceb2036bd5$export$5beddcc12ba927aa);

var $63hLx = parcelRequire("63hLx");

var $9X92U = parcelRequire("9X92U");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8aMsX = parcelRequire("8aMsX");

var $4EKqI = parcelRequire("4EKqI");

var $eK5AI = parcelRequire("eK5AI");

var $5vQ2T = parcelRequire("5vQ2T");

var $i0Aal = parcelRequire("i0Aal");

var $5bzWA = parcelRequire("5bzWA");

var $1DCdi = parcelRequire("1DCdi");

var $fvzyF = parcelRequire("fvzyF");

var $EzBXZ = parcelRequire("EzBXZ");

var $dzLcO = parcelRequire("dzLcO");



var $bv6dN = parcelRequire("bv6dN");

var $3pkO9 = parcelRequire("3pkO9");

var $kGj4V = parcelRequire("kGj4V");

var $2PrU6 = parcelRequire("2PrU6");

var $djhHt = parcelRequire("djhHt");

var $lOI8W = parcelRequire("lOI8W");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $kfvK2 = parcelRequire("kfvK2");

var $gp9Js = parcelRequire("gp9Js");

var $k2tOc = parcelRequire("k2tOc");

var $8hKqe = parcelRequire("8hKqe");

var $jjTNC = parcelRequire("jjTNC");

var $1302Y = parcelRequire("1302Y");

var $3ipHb = parcelRequire("3ipHb");

var $hCNjJ = parcelRequire("hCNjJ");

var $9FYIg = parcelRequire("9FYIg");

var $02imk = parcelRequire("02imk");

var $lkx5n = parcelRequire("lkx5n");

var $ltfhl = parcelRequire("ltfhl");

var $DrDtQ = parcelRequire("DrDtQ");

var $gSyZa = parcelRequire("gSyZa");

var $m9A8V = parcelRequire("m9A8V");

var $eTZyL = parcelRequire("eTZyL");

var $dtNAy = parcelRequire("dtNAy");

var $iypv0 = parcelRequire("iypv0");

var $5Wq2G = parcelRequire("5Wq2G");

var $3sFnL = parcelRequire("3sFnL");

var $hOLtL = parcelRequire("hOLtL");

var $d9aSP = parcelRequire("d9aSP");
const $f10fc7ceb2036bd5$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "page-container-v2-main-wrapper"
    }, children), (0, $eJOHy.Fragment));
const $f10fc7ceb2036bd5$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themedOld: "_11q7mmei _11q31r52",
    themed: "_11q7mmei _11q3ne5i"
}; /**
    * These test IDs are used in pollinator tests. Do not change lightly.
    */ 
const $f10fc7ceb2036bd5$var$ROOT_TEST_ID = 'page-layout.root';
const $f10fc7ceb2036bd5$var$MAIN_TEST_ID = 'page-layout.main';
const $f10fc7ceb2036bd5$var$DefaultLayout = ({ children: children, layoutFragment: layoutFragment })=>{
    const [isChromeless] = (0, $i0Aal.useIsChromeless)();
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    const showBanner = !isChromeless && !isFullscreen && (!false || (0, $9790b8dfe6f31c81$export$19d68f5aa485d903));
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen;
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    const data = (0, $j4oe4.useFragment)((0, $9X92U.default), layoutFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Wq2G.JiraPageLayout), {
        skipLinksLabel: "",
        testId: $f10fc7ceb2036bd5$var$ROOT_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), {
        fg: "jfp_magma_jira-render-on-client-batch-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjTNC.IntegrationsWhichRequireNavigationRoot), null)), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lkx5n.BannerContent), {
        bannerFragment: data?.jira
    })), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dtNAy.TopNav), null)), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eTZyL.Sidebar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$MainWrapper, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gSyZa.HorizontalNav), null), children), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $m9A8V.RightSidebar), null)), (0, $4cTDP.fg)('jira-glance-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "preview-panel",
        packageName: "jiraPageContainerV2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ipHb.PreviewPanel), null)), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1DCdi.LayoutRemoteStateUpdater), null)));
};
function $f10fc7ceb2036bd5$var$MainWrapper(props) {
    const { hasTheming: hasTheming } = (0, $2PrU6.useProjectTheme)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $bv6dN.useJsmGracePeriodBanner)();
    const currentRoute = $f10fc7ceb2036bd5$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $gp9Js.isSystemNavPath)(currentRoute.path) || (0, $k2tOc.isIssuesNavPath)(currentRoute.path);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Main), {
        isFixed: true,
        testId: $f10fc7ceb2036bd5$var$MAIN_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-vc": "page-container-v2-main-wrapper",
        className: (0, $hcewu.default)([
            $f10fc7ceb2036bd5$var$mainWrapperStyles.root,
            hasTheming && !(0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() && $f10fc7ceb2036bd5$var$mainWrapperStyles.themedOld,
            hasTheming && (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() && $f10fc7ceb2036bd5$var$mainWrapperStyles.themed
        ])
    }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3pkO9.JSMGracePeriodBannerAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8hKqe.JiraTopBannerPlacement), null), props.children)));
}
const $f10fc7ceb2036bd5$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $f10fc7ceb2036bd5$var$Layout = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $f10fc7ceb2036bd5$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$DefaultLayout, props);
};
const $f10fc7ceb2036bd5$var$JiraSpaPageContainerInner = (props)=>{
    const { queryReference: queryReference } = props;
    const pageContainerPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$898b6208220685b0), (0, $60d311439a302207$export$e2bc63118050de32), (0, $60d311439a302207$export$59f83d43fe209319), true, false);
    }, []);
    const data = (0, $j4oe4.usePreloadedQuery)((0, $63hLx.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $4cTDP.fg)('redirect_all_new_jira_users_to_user_segmentation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iypv0.RedirectEntrypointContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3sFnL.GlobalThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOLtL.ProjectThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$Layout, {
        ...props,
        layoutFragment: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ltfhl.GlobalComponents), {
        sharedGlobalComponents: (0, $djhHt.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvzyF.GlobalBottomRightCornerContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9aSP.PageContainerSuccessTracker), null), (0, $4cTDP.fg)('jfp-magma-3742-report-hydration-stats') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8aMsX.HydrationStatsReporter), null), (0, $4cTDP.fg)('jfp-magma-4013-fix-hydration-edition-awareness') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hCNjJ.HydrationFinishedSetter), null)));
}; // The `GlobalContainers` component sets a number of important contexts, including the Router and the JiraRelayEnvironmentProvider.
// We won't have any important context without these things, hence we wrap our "inner" component in these.
// This strange composition is only necessary because sometimes a route uses (nested) entrypoints to load data, but sometimes uses react resource router.
// When using RRR, we need the router context and relay environment available for the hooks to work.
const $f10fc7ceb2036bd5$var$JiraSpaPageContainerOuter = (props)=>{
    const { id: id, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $DrDtQ.GlobalContainers), {
        id: id,
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, children));
}; // Use react resource router to load a relay query.
// TODO: This is actually a bit silly, since it's a route resource, but we're not inside a route here... Might make sense to avoid here and do our own `fetchQuery` via a service.
const $f10fc7ceb2036bd5$var$JiraSpaPageContainerWithResource = (props)=>{
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $02imk.jiraSpaPageContainerResource), {
        suspendWhenLoading: false
    }); // This intermediate step is to avoid using a null queryReference.
    // Maybe this should be a skeleton?
    return queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$JiraSpaPageContainerInner, {
        queryReference: queryReference
    }, props.children);
}; // The React-Resource-Router approach to loading the page container.
const $f10fc7ceb2036bd5$export$802ae4178431f591 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$JiraSpaPageContainerOuter, rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$JiraSpaPageContainerWithResource, null, children));
};
const $f10fc7ceb2036bd5$export$5beddcc12ba927aa = ({ props: { children: children, ...rest }, queries: queries })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$JiraSpaPageContainerOuter, rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f10fc7ceb2036bd5$var$JiraSpaPageContainerInner, {
        queryReference: queries.queryReference
    }, children));
};

});
parcelRegister("9X92U", function(module, exports) {
$parcel$export(module.exports, "default", () => $c16e95337d6af88d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<54076a84bed0468a447db93314f38f25>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c16e95337d6af88d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraSpaPageContainer",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "BannerContent"
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ],
    "type": "Query"
};
$c16e95337d6af88d$var$node.hash = "7545642d8f78caac5cf3e05e6ddee22d";
var $c16e95337d6af88d$export$2e2bcd8739ae039 = $c16e95337d6af88d$var$node;

});

parcelRegister("lkx5n", function(module, exports) {
$parcel$export(module.exports, "BannerContent", () => $ba671e3f07ae5151$export$1c91e5dc5ea848c6);

var $k114K = parcelRequire("k114K");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");


var $dnZnj = parcelRequire("dnZnj");

var $4cTDP = parcelRequire("4cTDP");


var $hRIa5 = parcelRequire("hRIa5");

var $dzLcO = parcelRequire("dzLcO");

var $5zoYi = parcelRequire("5zoYi");


var $7mXaF = parcelRequire("7mXaF");


var $35T6Y = parcelRequire("35T6Y");


var $2UuhW = parcelRequire("2UuhW");

var $010oY = parcelRequire("010oY");

var $jMu4X = parcelRequire("jMu4X");

var $4EKqI = parcelRequire("4EKqI");


var $95ud4 = parcelRequire("95ud4");


var $lxKFg = parcelRequire("lxKFg");


var $khNDs = parcelRequire("khNDs");


var $g5l4t = parcelRequire("g5l4t");
/**
 * This ID is used in pollinator tests and by JPD. Do not change lightly.
 */ const $ba671e3f07ae5151$var$BANNER_ID = 'page-layout.banner';
const $ba671e3f07ae5151$export$1c91e5dc5ea848c6 = ({ bannerFragment: bannerFragment })=>{
    const data = (0, $j4oe4.useFragment)((0, $k114K.default), bannerFragment);
    const banner = (0, $5zoYi.useBanner)();
    const bannerName = banner.name;
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Banner), {
        height: banner.height,
        testId: $ba671e3f07ae5151$var$BANNER_ID,
        id: $ba671e3f07ae5151$var$BANNER_ID
    }, bannerName === (0, $69f60eadef6768b2$export$3c5e605ca7ade9f2) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mXaF.BannerAnnouncementAsync), {
        jiraQueryFragment: data
    }), bannerName === (0, $5eaeff4aff080d2f$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRIa5.IPBlocklistingBannerAsync), null), bannerName === (0, $010oY.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMu4X.ReturnToMobileBanner), null), bannerName === (0, $5dc1b04ccd518917$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dnZnj.CookieConsentBannerAsync), null), bannerName === (0, $d9444cff34d1ab64$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $35T6Y.BannerTransitionAsync), null), bannerName === (0, $b469e0c8d9aee89c$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UuhW.MailExpiryBannerAsync), null), bannerName === (0, $b3867ac518e371e9$export$41956b146268af93) && (0, $4cTDP.fg)('jpd-view-templates-feedback-banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $95ud4.AsyncJpdBlueprintsFeedbackBanner), null), bannerName === (0, $27294eb882c7c50f$export$41956b146268af93) && (0, $4cTDP.fg)('upsell_jira_global_automations_limit_banner_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxKFg.AutomationLimitAwarenessBannerAsync), null), bannerName === (0, $225b7a1fbba60a47$export$7b746a9f691e0529) && (0, $4cTDP.fg)('eoc_consolidation_cohort_3_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khNDs.Cohort3BannerAsync), null), bannerName === (0, $4c332600cf5974c6$export$41956b146268af93) && (0, $4cTDP.fg)('auto_upgrade_not_a_trial_jira_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5l4t.AsyncAutoUpgradeAvoidDeactivationBanner), null))) : null;
};

});
parcelRegister("k114K", function(module, exports) {
$parcel$export(module.exports, "default", () => $de7a9b630824b4f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7c933e37965863ff48d15e10b626fbf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $de7a9b630824b4f2$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "BannerContent",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "BannerAnnouncement"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$de7a9b630824b4f2$var$node.hash = "f3b88ef37c897165bed4a7a7d66573d7";
var $de7a9b630824b4f2$export$2e2bcd8739ae039 = $de7a9b630824b4f2$var$node;

});


parcelRegister("3sFnL", function(module, exports) {
$parcel$export(module.exports, "GlobalThemeSetter", () => $318c931c19d8fe29$export$c8947eb2c95eab56);

var $eJOHy = parcelRequire("eJOHy");

var $5J5oZ = parcelRequire("5J5oZ");
var $58yRG = parcelRequire("58yRG");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $2Mqjh = parcelRequire("2Mqjh");

var $cxQGT = parcelRequire("cxQGT");

var $eJrcF = parcelRequire("eJrcF");

var $6XSXq = parcelRequire("6XSXq");

var $aqhop = parcelRequire("aqhop");
var $dXMgi = parcelRequire("dXMgi");
const $318c931c19d8fe29$var$darkThemeMediaMatchQuery = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
function $318c931c19d8fe29$var$setThemeCookieWhenIdle(theme) {
    if (!false) // this is an optimization to ensure that we don't get a white "flash" when dark mode is on, allowing
    // SSR to flush an <html> tag with the theme set.
    return (0, $6XSXq.callWhenIdle)(()=>{
        if (!theme) (0, $aqhop.deleteCookie)('jira_theme');
        else (0, $dXMgi.setCookie)('jira_theme', theme, {
            expires: 30,
            secure: true,
            sameSite: 'strict'
        });
    }, 1000);
}

const $318c931c19d8fe29$export$c8947eb2c95eab56 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $cxQGT.themePreferenceResource));
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $eJOHy.useState)(()=>{
        if (!(0, $4cTDP.fg)('jfp_magma_jira-global-theme-hydration')) // the original implementation
        return false;
        if (loading || error || !data) // actually that's a misconfiguration and should never happen
        // but we still need to check (and it did happen in the past)
        return false;
        if (false) // let's make SSR behavior more explicit - no, styles are not in the head, render them
        return false;
        // check if the theme styles are already in the <head />.
        return Boolean((0, $fceQU.getDocument)()?.head.querySelector('style[data-theme]'));
    });
    const setThemeWithToken = (0, $eJOHy.useCallback)(async (theme)=>{
        if (theme !== colorMode) {
            const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("kgMVF"));
            loadThemeTokens(theme);
        }
    }, [
        colorMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loading || error || !data) return undefined;
        let cleanupIdleCallback;
        // Combine the themes 'dark', 'light' and 'auto' after @atlaskit/tokens@1.0.0
        // https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/27634
        if (data?.theme === 'auto') {
            const token = $318c931c19d8fe29$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light';
            setThemeWithToken(token);
            cleanupIdleCallback = $318c931c19d8fe29$var$setThemeCookieWhenIdle(token);
            const handler = (e)=>{
                const tokenValue = e.matches ? 'dark' : 'light';
                setThemeWithToken(tokenValue);
                cleanupIdleCallback = $318c931c19d8fe29$var$setThemeCookieWhenIdle(tokenValue);
            };
            $318c931c19d8fe29$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
            return ()=>{
                $318c931c19d8fe29$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
                cleanupIdleCallback?.();
            };
        }
        if (data?.theme === 'dark' || data?.theme === 'light') {
            setThemeWithToken(data?.theme);
            cleanupIdleCallback = $318c931c19d8fe29$var$setThemeCookieWhenIdle(data?.theme);
        }
        if (!data?.theme) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-theme');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-color-mode');
            cleanupIdleCallback = $318c931c19d8fe29$var$setThemeCookieWhenIdle(null);
        }
        return cleanupIdleCallback;
    }, [
        data,
        loading,
        error,
        setThemeWithToken
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loading || error || !data) return;
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            if (data?.theme) client.setUIViewedAttributes({
                theme: data.theme
            });
            else client.removeUIViewedAttribute('theme');
        });
    }, [
        data,
        loading,
        error
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            client.setUIViewedAttributes({
                OStheme: $318c931c19d8fe29$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
            });
        });
    }, []);
    // @atlaskit/tokens expects the theme styles to be in the <head /> but they're
    // initially rendered in the "jira-ssr" container in the <body /> and then moved to the
    // <head />. The following prevents the styles from being re-rendered in the <body />.
    (0, $eJOHy.useEffect)(()=>{
        // this useEffect will be executed after the "move script" right below regardless of the SSR presence or absence
        // safe to say - setIsThemeStylesInHead wil be always true after the first render
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head.querySelector('style[data-theme]')) // eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
        setIsThemeStylesInHead(true);
    }, []);
    if (!data?.theme || !data?.attrs || !data?.styles) return null;
    const ssrAutoScript = (0, $5J5oZ.default)(data.theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
            key: theme.id,
            ...theme.attrs,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: theme.css
            }
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: Object.entries(data.attrs).map(([key, val])=>{
                if (key === 'data-color-mode' && ssrAutoScript) return '';
                return `document.documentElement.setAttribute("${key}", "${val}");`;
            }).join('\n')
        }
    }), ssrAutoScript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrAutoScript
        }
    }) : null);
};

});
parcelRegister("dXMgi", function(module, exports) {
$parcel$export(module.exports, "setCookie", () => $4744641bab47031a$export$110700823644f4a6);

var $5H4WP = parcelRequire("5H4WP");

var $eGOwo = parcelRequire("eGOwo");

var $9SIye = parcelRequire("9SIye");
var $lgusX = parcelRequire("lgusX");

var $15Ffx = parcelRequire("15Ffx");

var $60vYG = parcelRequire("60vYG");

var $6T1aH = parcelRequire("6T1aH");
const $4744641bab47031a$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $6T1aH.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $9SIye.getBscGlobalState)().product;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetCookie = await (0, $15Ffx.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $6T1aH.CategoryStorageType).Cookies,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (shouldSetCookie) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $6T1aH.Status).SUCCESS;
        } else return (0, $6T1aH.Status).BLOCKED;
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, $6T1aH.Status).BLOCKED;
    }
};

});

parcelRegister("kgMVF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ie8yF").then(()=>parcelRequire('135mT'));

});


parcelRegister("hOLtL", function(module, exports) {
$parcel$export(module.exports, "ProjectThemeSetter", () => $98214d48e1d4cd49$export$fd1b0084c5bb04a9);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $9FYIg = parcelRequire("9FYIg");

var $fICTM = parcelRequire("fICTM");

var $1G20J = parcelRequire("1G20J");

var $cxKOj = parcelRequire("cxKOj");

var $6w7uw = parcelRequire("6w7uw");

var $2PrU6 = parcelRequire("2PrU6");
const $98214d48e1d4cd49$export$fd1b0084c5bb04a9 = ()=>{
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $1G20J.projectThemeResource));
    const { hasTheming: hasTheming } = (0, $cxKOj.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2PrU6.useProjectTheme)() : {
        hasTheming: false
    };
    if (!queryReference || !hasTheming && (0, $cxKOj.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false)) /* The resource is available only for routes enabled for theming.
		We still need to set the default token color by using ThemeTokenSetter for all other routes.
		This can be removed once theming is enabled for all pages. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w7uw.ThemeTokensSetter), {
        themeSetting: null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "projectThemeSetter",
        packageName: "jiraPageContainerV2",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "project-theme-setter-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fICTM.ThemeSetter), {
        queryReference: queryReference
    })));
};

});
parcelRegister("fICTM", function(module, exports) {
$parcel$export(module.exports, "ThemeSetter", () => $da96f3e70bcac92c$export$ce1303eaa27a0d3a);

var $hnsXL = parcelRequire("hnsXL");

var $5V48N = parcelRequire("5V48N");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aBAcl = parcelRequire("aBAcl");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6zXPf = parcelRequire("6zXPf");

var $hih5V = parcelRequire("hih5V");

var $6w7uw = parcelRequire("6w7uw");

var $5mfAj = parcelRequire("5mfAj");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $cxKOj = parcelRequire("cxKOj");

var $1uv7v = parcelRequire("1uv7v");
const $da96f3e70bcac92c$export$28580a1170c06a39 = {
    type: 'color',
    value: (0, $1uv7v.NO_BACKGROUND_CONFIG).name
};
const $da96f3e70bcac92c$export$ce1303eaa27a0d3a = ({ queryReference: queryReference })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $5V48N.default), queryReference);
    const backgroundData = (0, $j4oe4.useFragment)((0, $hnsXL.default), data.jira_projectByIdOrKey?.background ?? null);
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareProject: isSoftwareProjectFromHook } = (0, $1302Y.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareProject: false
    };
    const isSoftwareProjectFromQuery = data.jira_projectByIdOrKey?.projectType === 'SOFTWARE';
    const isSoftwareProject = (0, $cxKOj.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) ? isSoftwareProjectFromQuery : isSoftwareProjectFromHook;
    const media = (0, $eJOHy.useMemo)(()=>{
        return data.jira.mediaClientId && data.jira.mediaExternalEndpointUrl ? {
            clientId: data.jira.mediaClientId,
            externalEndpointUrl: data.jira.mediaExternalEndpointUrl
        } : null;
    }, [
        data.jira.mediaClientId,
        data.jira.mediaExternalEndpointUrl
    ]);
    const isColorOnly = isSoftwareProject && !(0, $1302Y.getIsSoftwareThemingM2Enabled)();
    const projectTheme = (0, $eJOHy.useMemo)(()=>{
        let themeSetting = null;
        if (!backgroundData) return null;
        switch(backgroundData.__typename){
            case 'JiraColorBackground':
                themeSetting = {
                    type: 'color',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value: backgroundData.colorValue
                };
                break;
            case 'JiraGradientBackground':
                themeSetting = isColorOnly ? $da96f3e70bcac92c$export$28580a1170c06a39 : {
                    type: 'color',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value: backgroundData.gradientValue
                };
                break;
            case 'JiraMediaBackground':
                if (isColorOnly) themeSetting = $da96f3e70bcac92c$export$28580a1170c06a39;
                else if (backgroundData.customBackground != null) {
                    const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText, dominantColor: dominantColor, brightness: brightness } = backgroundData.customBackground;
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    themeSetting = {
                        type: 'image',
                        value: 'image',
                        id: id,
                        mediaApiFileId: mediaApiFileId,
                        mediaReadToken: mediaReadToken,
                        sourceType: sourceType,
                        sourceIdentifier: sourceIdentifier,
                        altText: altText,
                        ...isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)() && {
                            dominantColor: dominantColor,
                            brightness: brightness
                        }
                    };
                }
                break;
            default:
                themeSetting = null;
        }
        return themeSetting ? {
            themeSetting: themeSetting,
            entityId: `project/${data.jira_projectByIdOrKey?.projectId}`
        } : null;
    }, [
        backgroundData,
        data.jira_projectByIdOrKey?.projectId,
        isColorOnly,
        isSoftwareProject
    ]);
    const overviewTheme = (0, $aBAcl.useOverviewTheme)();
    const route = (0, $hih5V.useCurrentRoute)();
    const entityTheme = (0, $eJOHy.useMemo)(()=>{
        let result = projectTheme ?? overviewTheme;
        if (result != null) {
            const isFormSubmitView = route.name === 'classic-business-form-submit' || route.name === 'classic-business-form-submit-embed';
            // the form submit view doesn't use the project theme colors
            // since it is accessed externally to the project
            // remove themeSetting for pages in software projects that don't support theming yet
            if (isFormSubmitView || isSoftwareProject && !hasSoftwareTheming) result = {
                ...result,
                themeSetting: null
            };
        }
        return result;
    }, [
        projectTheme,
        overviewTheme,
        route.name,
        isSoftwareProject,
        hasSoftwareTheming
    ]);
    const sourceType = entityTheme?.themeSetting?.type === 'image' ? entityTheme.themeSetting.sourceType : undefined;
    (0, $eJOHy.useEffect)(()=>{
        const projectId = data.jira_projectByIdOrKey?.projectId;
        if (projectId) {
            if (data.jira_projectByIdOrKey?.projectType === 'BUSINESS' || data.jira_projectByIdOrKey?.projectType === 'SOFTWARE' && (0, $1302Y.getIsSoftwareThemingEnabled)()) {
                const theme = sourceType === 'UNSPLASH' ? 'unsplash-image' : entityTheme?.themeSetting?.value;
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'theme evaluated', {
                    theme: theme,
                    projectId: projectId
                });
            }
        }
    }, [
        entityTheme?.themeSetting?.value,
        sourceType,
        data.jira_projectByIdOrKey?.projectId,
        data.jira_projectByIdOrKey?.projectType,
        createAnalyticsEvent
    ]);
    if ((0, $6zXPf.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w7uw.ThemeTokensSetter), {
        media: media,
        themeSetting: entityTheme?.themeSetting || null,
        projectType: data.jira_projectByIdOrKey?.projectType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, entityTheme != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5mfAj.ThemeContainerOld), {
        isGlobal: true,
        ...entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w7uw.ThemeTokensSetter), {
        media: media,
        themeSetting: entityTheme?.themeSetting || null,
        projectType: data.jira_projectByIdOrKey?.projectType
    }));
};

});
parcelRegister("hnsXL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7babf48681331e34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<374b66672720180e9e36deb3d82661fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7babf48681331e34$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThemeSetterBackground",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorValue"
                }
            ],
            "type": "JiraColorBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "gradientValue"
                }
            ],
            "type": "JiraGradientBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCustomBackground",
                    "kind": "LinkedField",
                    "name": "customBackground",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "mediaApiFileId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "durationInSeconds",
                                    "value": 900
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "mediaReadToken",
                            "storageKey": "mediaReadToken(durationInSeconds:900)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceIdentifier"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "altText"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "dominantColor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "brightness"
                        }
                    ]
                }
            ],
            "type": "JiraMediaBackground"
        }
    ],
    "type": "JiraActiveBackgroundDetailsResult",
    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
};
$7babf48681331e34$var$node.hash = "3c41e5a508924f980b8234232721902b";
var $7babf48681331e34$export$2e2bcd8739ae039 = $7babf48681331e34$var$node;

});

parcelRegister("5V48N", function(module, exports) {
$parcel$export(module.exports, "default", () => $d340f7d465945734$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a80e3120b80c99e5f371c683e47c1272>>
 * @relayHash 425f234e57bb5ee35d5bff67f4bb926f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 659f6d85a390f6f3ee8492f86debbfeaed75e90b37b222e25a49822daf422a5a

var $37Ewn = parcelRequire("37Ewn");
const $d340f7d465945734$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaClientId"
            },
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaExternalEndpointUrl"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThemeSetterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v3 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ThemeSetterBackground"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThemeSetterQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorValue"
                                        }
                                    ],
                                    "type": "JiraColorBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "gradientValue"
                                        }
                                    ],
                                    "type": "JiraGradientBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraCustomBackground",
                                            "kind": "LinkedField",
                                            "name": "customBackground",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaApiFileId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "durationInSeconds",
                                                            "value": 900
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "mediaReadToken",
                                                    "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceIdentifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "altText"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dominantColor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "brightness"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraMediaBackground"
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "659f6d85a390f6f3ee8492f86debbfeaed75e90b37b222e25a49822daf422a5a",
            "metadata": {},
            "name": "ThemeSetterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d340f7d465945734$var$node.hash = "9864ab22015f44482ad59ad489f945e0";
(0, $37Ewn.PreloadableQueryRegistry).set($d340f7d465945734$var$node.params.id, $d340f7d465945734$var$node);
var $d340f7d465945734$export$2e2bcd8739ae039 = $d340f7d465945734$var$node;

});

parcelRegister("aBAcl", function(module, exports) {
$parcel$export(module.exports, "useOverviewTheme", () => $9416d6987f1b2f90$export$a55763fd17eab357);

var $1uv7v = parcelRequire("1uv7v");

var $iXIhG = parcelRequire("iXIhG");
const $9416d6987f1b2f90$export$a55763fd17eab357 = ()=>{
    const { data: data } = (0, $iXIhG.useOverview)();
    if (data != null) return {
        themeSetting: {
            type: 'color',
            value: data.theme ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG).name
        },
        entityId: `overview/${data.id}`
    };
    return null;
};

});
parcelRegister("1uv7v", function(module, exports) {
$parcel$export(module.exports, "STAR_ICON_COLOR", () => $07a7fda3e3bc1ac3$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $07a7fda3e3bc1ac3$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $07a7fda3e3bc1ac3$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $07a7fda3e3bc1ac3$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $07a7fda3e3bc1ac3$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $07a7fda3e3bc1ac3$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$4c351ec1dc290344);
$parcel$export(module.exports, "ADAPTIVE_IMAGE_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$c8033614bd64480d);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $07a7fda3e3bc1ac3$export$34373eced7ee212e);
$parcel$export(module.exports, "FIXED_COLOR_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$bc16bf654619d060);
$parcel$export(module.exports, "ADAPTIVE_COLOR_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$4b188262dd47f902);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$242b2d2213fedf27);
$parcel$export(module.exports, "ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$8a6c8dd4a86d3f7d);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $07a7fda3e3bc1ac3$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$cab9d853866386f2);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $07a7fda3e3bc1ac3$export$8e357501548afe78);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $07a7fda3e3bc1ac3$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $07a7fda3e3bc1ac3$export$1c0b806722927549);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$2af5673c2fa63c55);
$parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$5771162cdeebfb85);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", () => $07a7fda3e3bc1ac3$export$a1626d6d785092a2);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $07a7fda3e3bc1ac3$export$410e3d6221a052e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $07a7fda3e3bc1ac3$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $07a7fda3e3bc1ac3$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout



const $07a7fda3e3bc1ac3$export$9e0962e0cb41695d = '#FFAB00';
const $07a7fda3e3bc1ac3$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--project-backdrop-filter',
    // Delete when business projects are migrated to the new theming
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: '--project-color-background-neutral-subtle-hovered-contrast',
    COLOR_BACKGROUND_ACCENT_SELECTED: '--project-color-background-accent-selected',
    COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--project-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--project-background-selected',
    COLOR_BORDER: '--project-color-border',
    COLOR_BORDER_INPUT: '--project-color-border-input',
    COLOR_BORDER_INVERSE: '--project-color-border-inverse',
    COLOR_BORDER_SELECTED: '--project-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
    COLOR_ELEVATION_SURFACE_SUNKEN: '--project-color-elevation-surface-sunken',
    COLOR_ICON_DANGER: '--project-color-icon-danger',
    COLOR_ICON_INFORMATION: '--project-color-icon-information',
    COLOR_ICON_SUCCESS: '--project-color-icon-success',
    COLOR_ICON_WARNING: '--project-color-icon-warning',
    COLOR_LINK: '--project-color-link',
    COLOR_LINK_PRESSED: '--project-color-link-pressed',
    COLOR_SKELETON: '--project-skeleton',
    COLOR_TEXT: '--project-color-text',
    COLOR_TEXT_ACCENT_SELECTED: '--project-text-accent-selected',
    COLOR_TEXT_DISABLED: '--project-color-text-disabled',
    COLOR_TEXT_INVERSE: '--project-color-text-inverse',
    COLOR_TEXT_SELECTED: '--project-color-text-selected',
    COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
    CONTENT_HEIGHT: '--project-content-height',
    CONTENT_WIDTH: '--project-content-width',
    ELEVATION_SURFACE: '--project-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
    ELEVATION_SURFACE_BLEND_MODE: '--project-elevation-surface-blend-mode',
    WRAPPER_BACKGROUND: '--project-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
    WRAPPER_HEIGHT: '--project-wrapper-height',
    WRAPPER_PADDING: '--project-wrapper-padding',
    WRAPPER_WIDTH: '--project-wrapper-width'
};
const $07a7fda3e3bc1ac3$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--project-backdrop-filter)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: 'var(--project-color-background-neutral-subtle-hovered-contrast)',
    COLOR_BACKGROUND_ACCENT_SELECTED: 'var(--project-color-background-accent-selected)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
    COLOR_BORDER: 'var(--project-color-border)',
    COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
    COLOR_ELEVATION_SURFACE_SUNKEN: 'var(--project-color-elevation-surface-sunken)',
    COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
    COLOR_LINK: 'var(--project-color-link)',
    COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
    COLOR_SKELETON: 'var(--project-skeleton)',
    COLOR_TEXT: 'var(--project-color-text)',
    COLOR_TEXT_ACCENT_SELECTED: 'var(--project-text-accent-selected)',
    COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--project-content-height)',
    CONTENT_WIDTH: 'var(--project-content-width)',
    ELEVATION_SURFACE: 'var(--project-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
    ELEVATION_SURFACE_BLEND_MODE: 'var(--project-elevation-surface-blend-mode)',
    WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
    WRAPPER_PADDING: 'var(--project-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--project-wrapper-width)'
};
const $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a = {
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.accent.selected': (0, $7bb4c1736002a04a$exports).B700,
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0C66E4)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0055CC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.neutral': "var(--ds-background-neutral, #091E420F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #091E424F)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #091E4224)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FF)",
    'color.elevation.surface': "var(--ds-surface, #FFFFFF)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.border': "var(--ds-border, #091E4224)",
    'color.border.input': "var(--ds-border-input, #8590A2)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0C66E4)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.information': "var(--ds-icon-information, #1D7AFC)",
    'color.icon.success': "var(--ds-icon-success, #22A06B)",
    'color.icon.warning': "var(--ds-icon-warning, #E56910)",
    'color.link': "var(--ds-link, #0C66E4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055CC)",
    'color.skeleton': "var(--ds-background-neutral, #091E420F)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.selected': "var(--ds-text, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0C66E4)",
    'color.text.subtle': "var(--ds-text-subtle, #44546F)",
    'color.text.subtlest': "var(--ds-text-subtlest, #626F86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent',
    'elevation.surface.blend.mode': 'darken'
};
const $07a7fda3e3bc1ac3$export$f286efa6bd1e8f9d = {
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': "var(--ds-text-inverse, #FFFFFF)"
};
const $07a7fda3e3bc1ac3$export$97cb21c6432e07e8 = {
    'color.background.neutral.subtle.hovered.contrast': 'rgba(255, 255, 255, 0.08)',
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $7bb4c1736002a04a$exports).N0,
    'color.icon.danger': (0, $7bb4c1736002a04a$exports).N0,
    'color.icon.information': (0, $7bb4c1736002a04a$exports).N0,
    'color.icon.success': (0, $7bb4c1736002a04a$exports).N0,
    'color.icon.warning': (0, $7bb4c1736002a04a$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $7bb4c1736002a04a$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $07a7fda3e3bc1ac3$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $07a7fda3e3bc1ac3$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $7bb4c1736002a04a$exports).N0,
            'color.icon.information': (0, $7bb4c1736002a04a$exports).N0,
            'color.icon.success': (0, $7bb4c1736002a04a$exports).N0,
            'color.icon.warning': (0, $7bb4c1736002a04a$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $7bb4c1736002a04a$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        }
    }
};
// Old Colors
const $07a7fda3e3bc1ac3$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $07a7fda3e3bc1ac3$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $07a7fda3e3bc1ac3$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $07a7fda3e3bc1ac3$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $07a7fda3e3bc1ac3$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $07a7fda3e3bc1ac3$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $07a7fda3e3bc1ac3$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $07a7fda3e3bc1ac3$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $07a7fda3e3bc1ac3$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $07a7fda3e3bc1ac3$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $07a7fda3e3bc1ac3$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $07a7fda3e3bc1ac3$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $07a7fda3e3bc1ac3$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $07a7fda3e3bc1ac3$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $07a7fda3e3bc1ac3$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $07a7fda3e3bc1ac3$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $07a7fda3e3bc1ac3$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $07a7fda3e3bc1ac3$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $07a7fda3e3bc1ac3$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a,
        dark: {
            ...$07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a,
            'color.text.accent.selected': "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE = {
    'color.elevation.surface': "var(--ds-surface-hovered, #F1F2F4)",
    'color.background.input': "var(--ds-background-neutral, #091E420F)",
    'color.link': "var(--ds-text, #172B4D)",
    'color.link.pressed': "var(--ds-text, #172B4D)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
    'color.border.selected': "var(--ds-border-bold, #758195)",
    'color.text.selected': "var(--ds-text, #172B4D)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
    'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
    'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
};
const $07a7fda3e3bc1ac3$export$2ccb37bafb938d85 = ({ name: name, overrides: overrides })=>{
    const adaptiveColorTheme = {
        ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
        ...overrides
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: adaptiveColorTheme,
            dark: adaptiveColorTheme
        }
    };
};
const $07a7fda3e3bc1ac3$export$18621b73983ebf62 = ({ name: name, overridesAllThemes: overridesAllThemes, overridesLightTheme: overridesLightTheme, overridesDarkTheme: overridesDarkTheme })=>{
    const adaptiveGradientTheme = {
        'elevation.surface': "var(--ds-surface, #FFFFFF)",
        ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
        ...overridesAllThemes
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: {
                ...adaptiveGradientTheme,
                ...overridesLightTheme
            },
            dark: {
                ...adaptiveGradientTheme,
                ...overridesDarkTheme
            }
        }
    };
};
const $07a7fda3e3bc1ac3$export$c8033614bd64480d = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'normal',
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)'
        },
        dark: {
            ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'darken',
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)'
        }
    }
};
const $07a7fda3e3bc1ac3$export$dbb791a784a1373b = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-gray',
    overrides: {
        'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DCDFE4)"
    }
});
const $07a7fda3e3bc1ac3$export$e013fca1233b4f7f = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-purple',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        'color.link': "var(--ds-text-accent-purple, #5E4DB2)",
        'color.link.pressed': "var(--ds-text-accent-purple, #5E4DB2)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    }
});
const $07a7fda3e3bc1ac3$export$81ad18a6866e27ad = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-blue',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CCE0FF)"
    }
});
const $07a7fda3e3bc1ac3$export$e41eaa7177d56baf = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-teal',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    }
});
const $07a7fda3e3bc1ac3$export$31b6c9185eea93be = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-green',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)"
    }
});
const $07a7fda3e3bc1ac3$export$3214417ed3fa0b58 = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-magenta',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    }
});
// Gradients
const $07a7fda3e3bc1ac3$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GRAY_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-gray',
    overridesAllThemes: {},
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #F8F8F8 0%, #B7B9BE 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #292A2E 0%, #6B6E76 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_PURPLE_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-purple',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #CFE1FD 0%, #EED7FC 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #123263 0%, #48245D 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_BLUE_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-blue',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E9F2FE 0%, #669DF1 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C2B42 0%, #1868DB 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_TEAL_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-teal',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E7F9FF 0%, #6CC3E0 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1E3137 0%, #227D9B 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GREEN_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-green',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #DCFFF1 0%, #4BCE97 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C3329 0%, #1F845A 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_MAGENTA_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-magenta',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #FDD0EC 28.5%, #FD9891 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #50253F 28.5%, #AE2E24 100%)'
    }
});
const $07a7fda3e3bc1ac3$export$34373eced7ee212e = [
    $07a7fda3e3bc1ac3$var$WHITE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARK_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$MAGENTA_BACKGROUND_CONFIG
];
const $07a7fda3e3bc1ac3$export$bc16bf654619d060 = [
    $07a7fda3e3bc1ac3$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $07a7fda3e3bc1ac3$export$4b188262dd47f902 = [
    $07a7fda3e3bc1ac3$export$dbb791a784a1373b,
    $07a7fda3e3bc1ac3$export$e013fca1233b4f7f,
    $07a7fda3e3bc1ac3$export$81ad18a6866e27ad,
    $07a7fda3e3bc1ac3$export$e41eaa7177d56baf,
    $07a7fda3e3bc1ac3$export$31b6c9185eea93be,
    $07a7fda3e3bc1ac3$export$3214417ed3fa0b58
];
const $07a7fda3e3bc1ac3$export$242b2d2213fedf27 = [
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_BLUE_TO_TEAL_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_GRAY_TO_BLACK_META
];
const $07a7fda3e3bc1ac3$export$8a6c8dd4a86d3f7d = [
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GRAY_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_PURPLE_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_BLUE_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_TEAL_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GREEN_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_MAGENTA_META
];
const $07a7fda3e3bc1ac3$export$fe05a238062e2c3d = {
    white: $07a7fda3e3bc1ac3$export$4c351ec1dc290344,
    'light-purple': $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $07a7fda3e3bc1ac3$export$cab9d853866386f2 = $07a7fda3e3bc1ac3$export$4c351ec1dc290344;
const $07a7fda3e3bc1ac3$export$8e357501548afe78 = 24;
const $07a7fda3e3bc1ac3$export$baaf8255c30ea280 = 95;
const $07a7fda3e3bc1ac3$export$d9035bc768f8226d = `${$07a7fda3e3bc1ac3$export$baaf8255c30ea280}px`;
const $07a7fda3e3bc1ac3$export$4810531e30462f89 = `calc(100vh - ${(0, $8246a95f06cae369$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$d9035bc768f8226d})`;
const $07a7fda3e3bc1ac3$export$1c0b806722927549 = `calc(100vh - ${(0, $8246a95f06cae369$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$d9035bc768f8226d} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px)`;
const $07a7fda3e3bc1ac3$export$2af5673c2fa63c55 = 104;
const $07a7fda3e3bc1ac3$export$5771162cdeebfb85 = `${$07a7fda3e3bc1ac3$export$2af5673c2fa63c55}px`;
const $07a7fda3e3bc1ac3$export$a1626d6d785092a2 = `calc(100vh - ${(0, $8246a95f06cae369$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$5771162cdeebfb85})`;
const $07a7fda3e3bc1ac3$export$410e3d6221a052e = `calc(100vh - ${(0, $8246a95f06cae369$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$5771162cdeebfb85} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px)`;
const $07a7fda3e3bc1ac3$export$77cdace62a821419 = `calc(100vw - ${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)} - ${(0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251)} - ${(0, $7326b3b2ac0b6dee$export$750459958906793)} - ${(0, $7326b3b2ac0b6dee$export$b44ab66843c05a69)}) !important`;
const $07a7fda3e3bc1ac3$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)} - ${(0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251)} - ${(0, $7326b3b2ac0b6dee$export$750459958906793)} - ${(0, $7326b3b2ac0b6dee$export$b44ab66843c05a69)} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px) !important`;
const $07a7fda3e3bc1ac3$export$689a64196408e5c2 = 82;

});

parcelRegister("iXIhG", function(module, exports) {
$parcel$export(module.exports, "overviewDetailsResource", () => $3b47543f677664af$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $3b47543f677664af$export$626541a5c6f2cfa1);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $336Fd = parcelRequire("336Fd");
const $3b47543f677664af$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $3b47543f677664af$export$cd57aa046b167312 = (0, $l1VxS.createResource)({
    type: $3b47543f677664af$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$3b47543f677664af$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $336Fd.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $3b47543f677664af$export$626541a5c6f2cfa1 = ()=>(0, $eJrcF.useResource)($3b47543f677664af$export$cd57aa046b167312);

});
parcelRegister("336Fd", function(module, exports) {
$parcel$export(module.exports, "fetchOverviewDetails", () => $3b2ca6dca30fb5cf$export$f0395142dbdd6c61);

var $cwZUV = parcelRequire("cwZUV");

var $ejRjJ = parcelRequire("ejRjJ");

var $942wy = parcelRequire("942wy");

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $29CL1 = parcelRequire("29CL1");

const $3b2ca6dca30fb5cf$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $29CL1.QUERY),
                variables: {
                    id: (0, $cwZUV.JiraProjectOverviewAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        overviewId: overviewId
                    }).toString()
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $5b9dabc66daa95fc$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $ejRjJ.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $942wy.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("ejRjJ", function(module, exports) {
$parcel$export(module.exports, "mapOverviewFragment", () => $b1720e1416bb124d$export$e79bf238de33eabb);
const $b1720e1416bb124d$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b1720e1416bb124d$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $b1720e1416bb124d$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                assignIssues: false,
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $b1720e1416bb124d$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $b1720e1416bb124d$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("29CL1", function(module, exports) {
$parcel$export(module.exports, "QUERY", () => $0ae7c7b180165261$export$2b91517d6d5b4365);

const $0ae7c7b180165261$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $bfd590d07d509ee9$export$6f4bda7ea1dcf892)}
`;

});
const $bfd590d07d509ee9$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $5b9dabc66daa95fc$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';




parcelRegister("6w7uw", function(module, exports) {
$parcel$export(module.exports, "ThemeTokensSetter", () => $bfddee756a826c8f$export$41f41c7ff10d45cd);

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $FhXEJ = parcelRequire("FhXEJ");

var $1uv7v = parcelRequire("1uv7v");

var $lXVKI = parcelRequire("lXVKI");

var $6zXPf = parcelRequire("6zXPf");


var $1302Y = parcelRequire("1302Y");

var $j0wJ6 = parcelRequire("j0wJ6");

var $fsk2i = parcelRequire("fsk2i");
/**
 * Will merge multiple themes together, with the last theme taking precedence.
 * The first argument is the base theme, and the rest are partial themes that
 * will be merged into the base theme.
 */ function $bfddee756a826c8f$var$mergeThemes(theme, ...partialThemes) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, theme, ...partialThemes);
}
const $bfddee756a826c8f$var$buildHorizontalNavVariables = ({ theme: theme })=>{
    if ((0, $6zXPf.getWillShowNav4)()) return `${0, $995807b180d1b2d0$export$539c074adec2188a}: ${theme['color.link']};
${0, $995807b180d1b2d0$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $995807b180d1b2d0$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $995807b180d1b2d0$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $995807b180d1b2d0$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $995807b180d1b2d0$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $995807b180d1b2d0$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $995807b180d1b2d0$export$4cd72d361867c565}: ${theme['color.border']};
${0, $995807b180d1b2d0$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
    return '';
};
const $bfddee756a826c8f$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode, isSoftwareProject, themeSetting)=>{
    const applicationColorMode = isDarkMode ? 'dark' : 'light';
    const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $1uv7v.HIGH_BRIGHTNESS_THEME) : (0, $1uv7v.LOW_BRIGHTNESS_THEME);
    const isImageConfig = config.name === 'image';
    const isGradientConfig = (0, $lXVKI.themeManager).isGradientTheme(config.name);
    /**
   * The base theme and the custom theme get merged here, with the custom theme taking precedence.
   * If you want to override configurations globally, then you should make modifications to the
   * BASE_THEME, while if you want to customize a specific theme, then you should make modifications
   * in the theme's themselves.
   */ const theme = $bfddee756a826c8f$var$mergeThemes(// the base theme for the application
    (0, $1uv7v.BASE_THEME), // the brightness overrides
    isImageConfig && !(isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)()) ? {} : brightnessOverrides, // gradient specific overrides
    isGradientConfig ? (0, $1uv7v.GRADIENT_THEME) : {}, // The custom background configuration
    config.theme[applicationColorMode]);
    let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
    let colorElevationSurface = theme['color.elevation.surface'];
    if (backgroundImageUrl) {
        if (isSoftwareProject && themeSetting?.type === 'image' && !!themeSetting.dominantColor && (0, $1302Y.getIsSoftwareThemingM2Enabled)()) {
            const adjustedColor = (0, $fsk2i.getAdjustedColor)({
                dominantColor: themeSetting.dominantColor,
                isDarkMode: isDarkMode
            });
            if (adjustedColor) {
                elevationSurface = `linear-gradient(hsl(${adjustedColor} / 0.9) 0px, hsl(${adjustedColor} / 0.85) 130px, hsl(${adjustedColor} / 0.7) 230px, hsl(${adjustedColor} / 0.5) 310px, hsl(${adjustedColor} / 0.3) 380px, hsl(${adjustedColor} / 0.15) 440px, hsl(${adjustedColor} / 0) 500px), url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
                colorElevationSurface = `hsl(${adjustedColor} / 1)`;
            }
        } else // in dark mode, the image will be darkened by blending with a black transparent background
        elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
    } else if (applicationColorMode === 'dark') {
        if ((0, $1uv7v.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig && !(0, $1302Y.getIsSoftwareThemingEnabled)() || (0, $1uv7v.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig && (0, $1302Y.getIsSoftwareThemingEnabled)() && !isSoftwareProject) /**
       * Add a gradient to the elevation surface for any themes in dark mode. This could be done in the
       * meta configuration but it's easier to do bulk edits here.
       */ elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #FFFFFF)"} 400px)`;
    }
    // Wrapper configuration
    const withWrapper = config.name !== (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG).name;
    const wrapperBackground = withWrapper ? "var(--ds-surface, #FFFFFF)" : 'unset';
    const wrapperBorderRadius = withWrapper ? "var(--ds-radius-large, 8px)" : '0';
    const isNav4 = (0, $6zXPf.getWillShowNav4)();
    const businessWrapperWithBackgroundHeight = isNav4 ? (0, $1uv7v.NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $1uv7v.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
    const businessWrapperHeight = isNav4 ? (0, $1uv7v.NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, $1uv7v.BUSINESS_WRAPPER_HEIGHT);
    const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
    const wrapperPadding = withWrapper ? `${0, $1uv7v.BUSINESS_WRAPPER_PADDING}px` : '0';
    const wrapperWidth = withWrapper ? (0, $1uv7v.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $1uv7v.BUSINESS_WRAPPER_WIDTH);
    return `
${(0, $1uv7v.Variables).BACKDROP_FILTER}: ${isImageConfig && !(isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)()) ? 'blur(8px)' : 'none'};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST}: ${theme['color.background.neutral.subtle.hovered.contrast']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_ACCENT_SELECTED}: ${theme['color.background.accent.selected']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $1uv7v.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $1uv7v.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $1uv7v.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $1uv7v.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $1uv7v.Variables).COLOR_ELEVATION_SURFACE}: ${colorElevationSurface};
${(0, $1uv7v.Variables).COLOR_ELEVATION_SURFACE_SUNKEN}: ${theme['color.elevation.surface.sunken']};
${(0, $1uv7v.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $1uv7v.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $1uv7v.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $1uv7v.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $1uv7v.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $1uv7v.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $1uv7v.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $1uv7v.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $1uv7v.Variables).COLOR_TEXT_ACCENT_SELECTED}: ${theme['color.text.accent.selected']};
${(0, $1uv7v.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $1uv7v.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $1uv7v.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $1uv7v.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $1uv7v.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $1uv7v.Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, $1uv7v.Variables).CONTENT_WIDTH}: ${0, $1uv7v.BUSINESS_WRAPPER_WIDTH};
${(0, $1uv7v.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $1uv7v.Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, $1uv7v.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $1uv7v.Variables).ELEVATION_SURFACE_BLEND_MODE}: ${theme['elevation.surface.blend.mode']};
${(0, $1uv7v.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $1uv7v.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $1uv7v.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $1uv7v.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $1uv7v.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$bfddee756a826c8f$var$buildHorizontalNavVariables({
        theme: theme
    })}`;
};
const $bfddee756a826c8f$export$41f41c7ff10d45cd = /*#__PURE__*/ (0, $eJOHy.memo)(({ themeSetting: themeSetting, media: media, projectType: projectType = null })=>{
    const isSoftwareProject = (projectType || '').toUpperCase() === (0, $FhXEJ.SOFTWARE_PROJECT).toUpperCase();
    const backgroundConfig = (0, $lXVKI.themeManager).get({
        themeSetting: themeSetting,
        enableImages: true,
        isSoftwareProject: isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)()
    });
    const backgroundImageUrl = (0, $j0wJ6.useBackgroundImageUrl)(themeSetting, media);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `:root{ ${$bfddee756a826c8f$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false, isSoftwareProject, isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? themeSetting : undefined)} }
        [data-color-mode=dark]{ ${$bfddee756a826c8f$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true, isSoftwareProject, isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? themeSetting : undefined)} }`
        }
    }));
});

});
parcelRegister("lXVKI", function(module, exports) {
$parcel$export(module.exports, "themeManager", () => $ea5cb24d1e06d3dc$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $ea5cb24d1e06d3dc$export$fe2402bbc6ac3125);
$parcel$export(module.exports, "getBackgroundConfigs", () => $ea5cb24d1e06d3dc$export$224c78c119a97f91);

var $1uv7v = parcelRequire("1uv7v");
const $ea5cb24d1e06d3dc$var$ALL_COLOR_BACKGROUND_CONFIGS = [
    ...(0, $1uv7v.FIXED_COLOR_BACKGROUND_CONFIGS),
    ...(0, $1uv7v.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
    (0, $1uv7v.NO_BACKGROUND_CONFIG)
];
const $ea5cb24d1e06d3dc$var$ALL_GRADIENT_BACKGROUND_CONFIGS = [
    ...(0, $1uv7v.GRADIENT_BACKGROUND_CONFIGS),
    ...(0, $1uv7v.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
];
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $ea5cb24d1e06d3dc$var$ThemeManager {
    init() {
        $ea5cb24d1e06d3dc$var$ALL_GRADIENT_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        $ea5cb24d1e06d3dc$var$ALL_COLOR_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $1uv7v.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages, isSoftwareProject: isSoftwareProject }) {
        if (!themeSetting) return 0, $1uv7v.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return isSoftwareProject ? (0, $1uv7v.ADAPTIVE_IMAGE_BACKGROUND_CONFIG) : (0, $1uv7v.IMAGE_BACKGROUND_CONFIG);
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $1uv7v.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $ea5cb24d1e06d3dc$export$aba92a7f3273f617 = new $ea5cb24d1e06d3dc$var$ThemeManager();
$ea5cb24d1e06d3dc$export$aba92a7f3273f617.init();
function $ea5cb24d1e06d3dc$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}
function $ea5cb24d1e06d3dc$export$224c78c119a97f91(withAdaptiveColorTheme) {
    return withAdaptiveColorTheme ? {
        backgroundColorConfigs: (0, $1uv7v.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $1uv7v.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
    } : {
        backgroundColorConfigs: (0, $1uv7v.FIXED_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $1uv7v.GRADIENT_BACKGROUND_CONFIGS)
    };
}

});

const $995807b180d1b2d0$export$d1b9ea3245b6a5de = 3;
const $995807b180d1b2d0$export$d07bba395c9390f1 = 32;
const $995807b180d1b2d0$export$29911ec08ab2ca2d = 5;
const $995807b180d1b2d0$export$b61e6f89a9db76de = 4;
const $995807b180d1b2d0$export$7fd2e391116c6ef5 = 9;
const $995807b180d1b2d0$export$e1633e494d305bfb = 'MORE';
const $995807b180d1b2d0$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $995807b180d1b2d0$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $995807b180d1b2d0$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $995807b180d1b2d0$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $995807b180d1b2d0$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $995807b180d1b2d0$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $995807b180d1b2d0$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $995807b180d1b2d0$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $995807b180d1b2d0$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $995807b180d1b2d0$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $995807b180d1b2d0$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("j0wJ6", function(module, exports) {
$parcel$export(module.exports, "useBackgroundImageUrl", () => $a555468b4cb0c8fc$export$16f28a2a10ece447);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $lXVKI = parcelRequire("lXVKI");

var $dMM78 = parcelRequire("dMM78");

var $9h7fx = parcelRequire("9h7fx");
const $a555468b4cb0c8fc$export$16f28a2a10ece447 = (themeSetting, media)=>{
    const lowResUrl = (0, $eJOHy.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $lXVKI.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $eJOHy.useState)(lowResUrl);
    const previousThemeId = (0, $eJOHy.useRef)(null);
    const abortControllerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (themeSetting?.type !== 'image') {
            previousThemeId.current = null;
            setImageUrl(null);
            return;
        }
        if (previousThemeId.current !== themeSetting.id && media) {
            if (abortControllerRef.current) abortControllerRef.current.abort();
            abortControllerRef.current = new AbortController();
            previousThemeId.current = themeSetting.id;
            setImageUrl(lowResUrl);
            // build a new URL to the /binary path
            const binaryUrl = (0, $lXVKI.generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            // send a request to fetch the image with the binary URL with bearer token authentication
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                },
                signal: abortControllerRef.current?.signal
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $9h7fx.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }).catch((error)=>{
                if (error.name === 'AbortError') return;
                // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
                if (!(0, $dMM78.isClientFetchError)(error)) (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraProjectThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});
parcelRegister("9h7fx", function(module, exports) {
$parcel$export(module.exports, "unsplashTracker", () => $0511e851a2fb1fa1$export$1869e04dbed4c16c);

var $lsLcV = parcelRequire("lsLcV");

var $3s8bj = parcelRequire("3s8bj");
const $0511e851a2fb1fa1$var$APP_ID = '7066';
const $0511e851a2fb1fa1$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$0511e851a2fb1fa1$var$APP_ID}`;
const $0511e851a2fb1fa1$var$MAX_URL_LENGTH = 2083; // the maximum length of a URL in most browsers
const $0511e851a2fb1fa1$var$ID_LENGTH = 12; // the length of an unsplash image id
const $0511e851a2fb1fa1$export$28219189b23a0628 = Math.floor($0511e851a2fb1fa1$var$MAX_URL_LENGTH / $0511e851a2fb1fa1$var$ID_LENGTH);
/**
 * This class is responsible for tracking unsplash images that are displayed in the app.
 * This is needed for legal reasons to comply with the Unsplash API terms of service.
 * It will track the image when it is displayed and then track it again every 10 minutes.
 */ class $0511e851a2fb1fa1$var$UnsplashTracker {
    /**
	 * Send a request to the Unsplash API to track the image views.
	 * This will send a request for all the images in the queue.
	 * If the request fails, the images will be added back to the queue.
	 */ send() {
        if (this.queue.size === 0) return;
        const imageIds = Array.from(this.queue);
        this.queue.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($lsLcV)))(imageIds, $0511e851a2fb1fa1$export$28219189b23a0628).forEach((chunkIds)=>{
            const url = `${$0511e851a2fb1fa1$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
            const now = new Date();
            imageIds.forEach((imageId)=>{
                this.trackedImages.set(imageId, now);
            });
            const handleFailure = ()=>{
                // if the request fails, add the image ids back to the queue
                imageIds.forEach((imageId)=>{
                    this.queue.add(imageId);
                    this.trackedImages.delete(imageId);
                });
            };
            fetch(url).then((response)=>{
                if (!response.ok) handleFailure();
            }).catch(()=>handleFailure());
        });
    }
    /**
	 * Track an image view. This will add the image to the queue to be tracked.
	 * If the image was tracked less than 10 minutes ago, it will not be added to the queue.
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns void
	 */ trackImage(sourceIdentifier) {
        const imageId = sourceIdentifier.split('-').pop(); // photo-1696144706485-ff7825ec8481 -> ff7825ec8481
        if (!imageId) return;
        const lastTracked = this.trackedImages.get(imageId);
        if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
        this.queue.add(imageId);
        this.sendDebounced();
    }
    /**
	 * Track an image view while it is in the viewport. This will track the image when it is displayed
	 * and then track it again every 10 minutes.
	 * @param element The element that contains the image
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns A function to stop tracking the image
	 */ trackWhileInViewport(element, sourceIdentifier) {
        let trackIntervalId = null;
        const observer = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && !trackIntervalId) {
                $0511e851a2fb1fa1$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                trackIntervalId = window.setInterval(()=>{
                    $0511e851a2fb1fa1$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                }, this.trackingInterval + 10); // extra 10ms to ensure the interval is always greater than 10 minutes
            } else if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        };
    }
    static getInstance() {
        if (!$0511e851a2fb1fa1$var$UnsplashTracker.instance) $0511e851a2fb1fa1$var$UnsplashTracker.instance = new $0511e851a2fb1fa1$var$UnsplashTracker();
        return $0511e851a2fb1fa1$var$UnsplashTracker.instance;
    }
    constructor(){
        this.trackedImages = new Map();
        this.trackingInterval = 600000 // 10 minutes
        ;
        this.queue = new Set();
        this.sendDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(this.send, 1000);
    }
}
const $0511e851a2fb1fa1$export$1869e04dbed4c16c = $0511e851a2fb1fa1$var$UnsplashTracker.getInstance();

});
parcelRegister("lsLcV", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");

var $eA1it = parcelRequire("eA1it");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fa00d4eb66826668$var$nativeCeil = Math.ceil, $fa00d4eb66826668$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $fa00d4eb66826668$var$chunk(array, size, guard) {
    if (guard ? $eA1it(array, size, guard) : size === undefined) size = 1;
    else size = $fa00d4eb66826668$var$nativeMax($c9FP3(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($fa00d4eb66826668$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $1FqKq(array, index, index += size);
    return result;
}
module.exports = $fa00d4eb66826668$var$chunk;

});



parcelRegister("fsk2i", function(module, exports) {
$parcel$export(module.exports, "getAdjustedColor", () => $a553b5580e1bf809$export$e7544aa016cb7a22);
/**
 * Converts a hex color string to HSL (Hue, Saturation, Lightness) values
 * Reference: W3C CSS Color Module Level 4
 * https://www.w3.org/TR/css-color-4/#rgb-to-hsl
 *
 * The conversion process:
 * 1. Convert hex to RGB (base 16 to decimal, normalized to [0,1])
 * 2. Find the minimum and maximum RGB values to determine lightness
 * 3. Calculate saturation based on lightness
 * 4. Calculate hue based on which RGB component is the maximum
 */ function $a553b5580e1bf809$var$hexToHSL(hexProp) {
    let hex = hexProp.replace(/^#/, '');
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    const r = parseInt(hex.slice(0, 2), 16) / 255;
    const g = parseInt(hex.slice(2, 4), 16) / 255;
    const b = parseInt(hex.slice(4, 6), 16) / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h;
    let s;
    const l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
            default:
                h = (r - g) / d + 4;
                break;
        }
        h *= 60;
    }
    return {
        h: Math.round(h),
        s: Math.round(s * 100),
        l: Math.round(l * 100)
    };
}
function $a553b5580e1bf809$export$e7544aa016cb7a22({ dominantColor: dominantColor, isDarkMode: isDarkMode }) {
    // Convert the hex to HSL
    const { h: h, s: s, l: l } = $a553b5580e1bf809$var$hexToHSL(dominantColor);
    if (isDarkMode) // Dont need much adjustment for dark mode - just darken it
    return `${h} ${s}% ${Math.min(l, 26)}%`;
    const LIGHTNESS_TARGET = 75;
    const HIGH_LIGHTNESS_THRESHOLD = 70;
    if (l > HIGH_LIGHTNESS_THRESHOLD || l > 53 && s > 60) // Text already readable
    return `${h} ${s}% ${Math.max(l, 64)}%`;
    let saturation = s;
    // Cap over-saturated blues
    if (h >= 200 && h <= 220 && s > 65) saturation = 65;
    return `${h} ${saturation}% ${LIGHTNESS_TARGET}%`;
}

});


parcelRegister("5mfAj", function(module, exports) {
$parcel$export(module.exports, "ThemeContainerOld", () => $61d0dba4d4a2f187$export$c6e50a832af54243);
// Delete file when cleaning up getWillShowNav4

var $cSmYj = parcelRequire("cSmYj");

var $lXVKI = parcelRequire("lXVKI");

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $61d0dba4d4a2f187$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $lXVKI.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $61d0dba4d4a2f187$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $lXVKI.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $61d0dba4d4a2f187$var$actions = {
    setTheme: $61d0dba4d4a2f187$var$setTheme,
    setSelectedThemeSetting: $61d0dba4d4a2f187$var$setSelectedThemeSetting
};
const $61d0dba4d4a2f187$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $61d0dba4d4a2f187$var$Store = (0, $GtRbT.createStore)({
    initialState: $61d0dba4d4a2f187$var$initialState,
    actions: $61d0dba4d4a2f187$var$actions,
    name: 'ProjectTheme'
});
const $61d0dba4d4a2f187$export$c6e50a832af54243 = (0, $6E16M.createContainer)($61d0dba4d4a2f187$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});

});


parcelRegister("1G20J", function(module, exports) {
$parcel$export(module.exports, "projectThemeResource", () => $08721476ea54ea75$export$84730adce8987203);

var $5V48N = parcelRequire("5V48N");

var $bBtQo = parcelRequire("bBtQo");

var $9FYIg = parcelRequire("9FYIg");

var $8Mxto = parcelRequire("8Mxto");
const $08721476ea54ea75$export$84730adce8987203 = (0, $8Mxto.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'JIRA_PROJECT_THEME',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $5V48N.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectKey ?? projectId ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isCritical: true
}));

});
parcelRegister("8Mxto", function(module, exports) {
$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $0eceed5dfd22dafd$export$f4b29e78f4c0a526);
const $0eceed5dfd22dafd$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});



parcelRegister("d9aSP", function(module, exports) {
$parcel$export(module.exports, "PageContainerSuccessTracker", () => $bdf74b3dc5938c8d$export$495692882694bf09);

var $eJOHy = parcelRequire("eJOHy");

var $hya93 = parcelRequire("hya93");

var $4ctwv = parcelRequire("4ctwv");

var $5vQ2T = parcelRequire("5vQ2T");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");
/**
 * PageContainerSuccessTracker is a copy of the old NavigationSuccessTracker component from this path:
 * jira/src/packages/navigation-apps/atlassian-navigation/src/controllers/navigation-success-tracker/main.tsx
 * Which used to mount on every page. But now it doesn't we aren't getting page container success events.
 *
 * So we are mounting ExperienceSuccessTracker here just so the parent event fires and our SLO works again.
 * See this thread for more info: https://atlassian.slack.com/archives/C075QTJBJ6S/p1752445800976529
 *
 * Not sure if ExperienceSuccess is explicitly required here, but it was in the old component, so we are keeping it for now.
 */ function $bdf74b3dc5938c8d$var$PageContainerSuccessTrackerInner() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "pageContainerSuccessTracker",
        packageName: "jiraPageContainerV2",
        teamName: "jfp-magma",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceSuccessTracker), {
        location: "pageContainer",
        parentProviders: null,
        failureEventAttributes: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: "pageContainer"
    })), (0, $4cTDP.fg)('jfp-magma-is-static-fallback-experience-attribute') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bdf74b3dc5938c8d$var$StaticFallbackKillswitchSuccessTracker, null));
}
/**
 * Emits an event so that we know SSR static fallback or killswitch'd route rendering
 * has reached as far as React rendering, and not crashed at some earlier point.
 */ const $bdf74b3dc5938c8d$var$StaticFallbackKillswitchSuccessTracker = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.__SSR_FALLBACK__ === true) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'staticFallback rendered');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.__SSR_RENDER_KILLSWITCH__ === true) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'renderKillswitch rendered');
        }
    }, [
        createAnalyticsEvent
    ]);
    return null;
};
const $bdf74b3dc5938c8d$export$495692882694bf09 = /*#__PURE__*/ (0, $eJOHy.memo)($bdf74b3dc5938c8d$var$PageContainerSuccessTrackerInner);

});



parcelRegister("kUiAZ", function(module, exports) {
$parcel$export(module.exports, "Content", () => $f010e46d30bde794$export$7c6e2c02157bb7d2);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2PrU6 = parcelRequire("2PrU6");

var $fBTBC = parcelRequire("fBTBC");

var $6dnL8 = parcelRequire("6dnL8");

var $fXCOi = parcelRequire("fXCOi");

var $kfvK2 = parcelRequire("kfvK2");

var $7wkp5 = parcelRequire("7wkp5");
const $f010e46d30bde794$var$SPA_TRACE_KEY = 'spa';
const $f010e46d30bde794$var$DefaultLayoutContent = (props)=>{
    const { isInset: isInset, hasTheming: hasTheming } = (0, $2PrU6.useProjectTheme)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXCOi.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "end"
    }));
    if (hasTheming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBTBC.ThemedContentLayout), {
        appearance: isInset ? 'inset' : 'default'
    }, renderContent);
    return renderContent;
};
const $f010e46d30bde794$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $f010e46d30bde794$export$7c6e2c02157bb7d2 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $f010e46d30bde794$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXCOi.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "end"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f010e46d30bde794$var$DefaultLayoutContent, props);
};

});
parcelRegister("fBTBC", function(module, exports) {
$parcel$export(module.exports, "ThemedContentLayout", () => $add86d391dcd4b8c$export$c2c3c7c0b13a1f9d);
$parcel$export(module.exports, "ProjectThemeWrapper", () => $add86d391dcd4b8c$export$65c56727ada4372d);
/* ProjectThemeWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6zXPf = parcelRequire("6zXPf");

var $b2TM0 = parcelRequire("b2TM0");
const $add86d391dcd4b8c$var$styles = {
    rootOld: "_kqswh2mm",
    root: "_kqswh2mm",
    fullHeight: "_1tkeidpf _4t3i1osq",
    insetRoot: "_1yt4y9h4",
    insetContainer: "_2rko1gnp _bfhkp043"
};
const $add86d391dcd4b8c$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>/*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            (0, $6zXPf.getWillShowNav4)() && $add86d391dcd4b8c$var$styles.root,
            !(0, $6zXPf.getWillShowNav4)() && $add86d391dcd4b8c$var$styles.rootOld,
            $add86d391dcd4b8c$var$styles.fullHeight,
            appearance === 'inset' && $add86d391dcd4b8c$var$styles.insetRoot
        ])
    }, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $add86d391dcd4b8c$var$styles.fullHeight,
            appearance === 'inset' && $add86d391dcd4b8c$var$styles.insetContainer
        ])
    }, children));
const $add86d391dcd4b8c$export$65c56727ada4372d = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
    if (withWhiteBackground) return /*#__PURE__*/ $eJOHy.createElement((0, $b2TM0.OuterWrapperWithBackground), null, /*#__PURE__*/ $eJOHy.createElement((0, $b2TM0.InnerWrapperWithBackground), null, children));
    return /*#__PURE__*/ $eJOHy.createElement((0, $b2TM0.OuterWrapper), null, /*#__PURE__*/ $eJOHy.createElement((0, $b2TM0.InnerWrapper), null, children));
};

});
parcelRegister("b2TM0", function(module, exports) {
$parcel$export(module.exports, "OuterWrapper", () => $be68f6d721067018$export$edaaad985a878983);
$parcel$export(module.exports, "OuterWrapperWithBackground", () => $be68f6d721067018$export$69c6ec128d3729c9);
$parcel$export(module.exports, "InnerWrapper", () => $be68f6d721067018$export$f185744748c379a7);
$parcel$export(module.exports, "InnerWrapperWithBackground", () => $be68f6d721067018$export$2e149d12a18af14b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $be68f6d721067018$var$Nav3OuterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _154i14em",
            __cmplp.className
        ])
    });
});
const $be68f6d721067018$var$Nav4OuterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _154i1l8a",
            __cmplp.className
        ])
    });
});
const $be68f6d721067018$export$edaaad985a878983 = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $be68f6d721067018$var$Nav4OuterWrapper, $be68f6d721067018$var$Nav3OuterWrapper);
const $be68f6d721067018$export$69c6ec128d3729c9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $be68f6d721067018$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt4y9h4",
            __cmplp.className
        ])
    });
});
const $be68f6d721067018$export$f185744748c379a7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_iu1g1fl4 _fok81wug _q7c11wug _2d3f3q3i _japi1o48",
            __cmplp.className
        ])
    });
});
const $be68f6d721067018$export$2e149d12a18af14b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $be68f6d721067018$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1gnp _bfhkp043 _2d3f15y4 _japizntk",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fXCOi", function(module, exports) {
$parcel$export(module.exports, "default", () => $a78fe1bd9ed3a8fd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $lOI8W = parcelRequire("lOI8W");

var $iLmfS = parcelRequire("iLmfS");
const $a78fe1bd9ed3a8fd$var$onSpaShellReady = ()=>{
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
};
const $a78fe1bd9ed3a8fd$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: "JIRA_SPA_SHELL_READY",
        onSet: $a78fe1bd9ed3a8fd$var$onSpaShellReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iLmfS.default), {
        initRoute: initRoute,
        routes: routes
    }));
var $a78fe1bd9ed3a8fd$export$2e2bcd8739ae039 = $a78fe1bd9ed3a8fd$var$Spa;

});
parcelRegister("iLmfS", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f2d77943b841e4c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3vr70 = parcelRequire("3vr70");

var $grrUi = parcelRequire("grrUi");

var $7vj7p = parcelRequire("7vj7p");

var $1MBhZ = parcelRequire("1MBhZ");

var $6OSA0 = parcelRequire("6OSA0");

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $2imLM = parcelRequire("2imLM");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lOI8W = parcelRequire("lOI8W");

var $912hm = parcelRequire("912hm");

var $l8usI = parcelRequire("l8usI");

var $4Oene = parcelRequire("4Oene");

var $kfvK2 = parcelRequire("kfvK2");
var $30bwc = parcelRequire("30bwc");
var $83DiZ = parcelRequire("83DiZ");

var $dLY5S = parcelRequire("dLY5S");

var $ioEQd = parcelRequire("ioEQd");

var $bJscI = parcelRequire("bJscI");

var $59iVY = parcelRequire("59iVY");

var $jdsvc = parcelRequire("jdsvc");
const $9f2d77943b841e4c$var$REMOTE_ACTIONS_OFF = 'OFF';
const $9f2d77943b841e4c$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $9f2d77943b841e4c$var$useRouterLocation = (0, $kfvK2.createRouterSelector)((state)=>state.location);
const $9f2d77943b841e4c$var$useRouterAction = (0, $kfvK2.createRouterSelector)((state)=>state.action);
const $9f2d77943b841e4c$var$useRouterQuery = (0, $kfvK2.createRouterSelector)((state)=>state.query);
const $9f2d77943b841e4c$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $9f2d77943b841e4c$var$useRouterMatch = (0, $kfvK2.createRouterSelector)((state)=>state.match);
const $9f2d77943b841e4c$var$useRouterRoutes = (0, $kfvK2.createRouterSelector)((state)=>state.routes);
const $9f2d77943b841e4c$var$useIsLazyRoutes = (0, $kfvK2.createRouterSelector)((state)=>state.isLazyRoutes);
let $9f2d77943b841e4c$var$hasPendingForceReloadAction = false;
const $9f2d77943b841e4c$var$getRemoteActionsRolloutStage = ()=>(0, $4cTDP.fg)('remote_actions_-_killswitch_-_temporary') ? $9f2d77943b841e4c$var$REMOTE_ACTIONS_PERFORM : $9f2d77943b841e4c$var$REMOTE_ACTIONS_OFF;
const $9f2d77943b841e4c$export$88fe66870dd8f843 = (value)=>{
    $9f2d77943b841e4c$var$hasPendingForceReloadAction = value;
};
const $9f2d77943b841e4c$export$39e8f9fc07dd3395 = ()=>$9f2d77943b841e4c$var$hasPendingForceReloadAction;
const $9f2d77943b841e4c$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'transitionBlocker',
        actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        currentRouteName: currentRoute?.route.name || '',
        targetRouteName: targetRoute?.route.name || '',
        remoteActionsRolloutStage: $9f2d77943b841e4c$var$getRemoteActionsRolloutStage(),
        attempts: attempts,
        lastAttemptedAt: lastAttemptedAt
    });
const $9f2d77943b841e4c$var$updateSentryBreadcrumb = (route, nextRoute)=>{
    const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
    const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
    (0, $3vr70.addBreadcrumb)({
        type: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
};
const $9f2d77943b841e4c$export$ef0074adc0f6b96d = (search)=>{
    const searchParams = new URLSearchParams(search);
    if (!searchParams.has('ignoreStickyVersion')) searchParams.append('ignoreStickyVersion', 'true');
    return `?${searchParams}`;
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $9f2d77943b841e4c$var$SpaOld = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $eJOHy.useMemo)(()=>{
        (0, $6uWhG.setMark)('jira-spa/view.start');
    }, []);
    const checkShouldResetPage = (0, $eJOHy.useMemo)(()=>(0, $l8usI.createCheckShouldResetPage)(), []);
    const currentMatchObjectRef = (0, $eJOHy.useRef)(initRoute);
    (0, $eJOHy.useEffect)(()=>{
        (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const { registerBlock: registerBlock } = (0, $83DiZ.useRouterActions)();
    const location = $9f2d77943b841e4c$var$useRouterLocation();
    const action = $9f2d77943b841e4c$var$useRouterAction();
    const query = $9f2d77943b841e4c$var$useRouterQuery();
    const route = $9f2d77943b841e4c$var$useRouterRoute();
    const match = $9f2d77943b841e4c$var$useRouterMatch();
    const isLazyRoutes = $9f2d77943b841e4c$var$useIsLazyRoutes();
    const routerRoutes = $9f2d77943b841e4c$var$useRouterRoutes();
    // If the Lazy Route Map experiment is enabled, we want to use the routes from
    // the router, not from props as they will be changing dynamically during page lifetime
    if (isLazyRoutes) // eslint-disable-next-line no-param-reassign
    routes = routerRoutes;
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $dLY5S.useShouldPerformAction)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
	 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
        route: route,
        match: match
    };
    const { resetCurrentPage: resetCurrentPage } = (0, $912hm.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $eJOHy.useCallback)((nextLocation, nextAction)=>{
        const nextMatch = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $59iVY.default)(currentMatchObjectRef.current, nextMatch);
        // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        if (isLazyRoutes && !canDo && routes.length <= 3) (0, $eSnSE.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
            route: nextMatch?.route.name
        });
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $grrUi.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $9f2d77943b841e4c$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $9f2d77943b841e4c$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $9f2d77943b841e4c$var$hasPendingForceReloadAction === false) {
                $9f2d77943b841e4c$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $9f2d77943b841e4c$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $grrUi.createPath)({
                        ...nextLocation,
                        search: $9f2d77943b841e4c$export$ef0074adc0f6b96d(nextLocation.search)
                    }));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $9f2d77943b841e4c$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent,
        isLazyRoutes
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $eJOHy.useCallback)((nextLocation, nextAction)=>{
        const nextMatchObject = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $7vj7p.default)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $ioEQd.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $7vj7p.default)(route);
                (0, $1MBhZ.default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $9f2d77943b841e4c$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    const renderRouteComponent = (0, $eJOHy.useCallback)(()=>{
        const { component: RouteComponent, isStrictModeEnabled: isStrictModeEnabled, skeleton: skeleton } = route;
        const Skeleton = skeleton || (0, $6OSA0.default);
        if (RouteComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$ConditionalStrictMode, {
            isEnabled: isStrictModeEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.PlaceholderWithNativeSuspense), {
            name: "route-component",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RouteComponent, {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        })));
    }, [
        action,
        location,
        match,
        query,
        route
    ]);
    if (!(route && match)) return null;
    const { meta: meta, skeleton: skeleton } = route;
    const Skeleton = skeleton || (0, $6OSA0.default);
    const entryPoint = route.entryPoint?.();
    const { reporting: reporting } = meta || {};
    const renderRouteEntryPointContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.PlaceholderWithNativeSuspense), {
            name: "route-entry-point-container",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdsvc.RouteEntryPointContainer), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        }));
    };
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: {
            routeGroup: route.group ?? '',
            isSSR: false
        },
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? renderRouteEntryPointContainer() : renderRouteComponent()));
};
const $9f2d77943b841e4c$var$RegisterRouterBlocks = ({ routes: routesOriginal, initRoute: initRoute, route: route, match: match })=>{
    const isLazyRoutes = $9f2d77943b841e4c$var$useIsLazyRoutes();
    const routerRoutes = $9f2d77943b841e4c$var$useRouterRoutes();
    const routes = (0, $eJOHy.useMemo)(()=>{
        return isLazyRoutes ? routerRoutes : routesOriginal;
    }, [
        isLazyRoutes,
        routerRoutes,
        routesOriginal
    ]);
    const checkShouldResetPage = (0, $eJOHy.useMemo)(()=>(0, $l8usI.createCheckShouldResetPage)(), []);
    const currentMatchObjectRef = (0, $eJOHy.useRef)(initRoute);
    const { registerBlock: registerBlock } = (0, $83DiZ.useRouterActions)();
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $dLY5S.useShouldPerformAction)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
		 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
            route: route,
            match: match
        };
    }, [
        match,
        route
    ]);
    const { resetCurrentPage: resetCurrentPage } = (0, $912hm.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $eJOHy.useCallback)((nextLocation, nextAction)=>{
        const nextMatch = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $59iVY.default)(currentMatchObjectRef.current, nextMatch);
        // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        if (isLazyRoutes && !canDo && routes.length <= 3) (0, $eSnSE.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
            route: nextMatch?.route.name
        });
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $grrUi.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $9f2d77943b841e4c$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $9f2d77943b841e4c$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $9f2d77943b841e4c$var$hasPendingForceReloadAction === false) {
                // eslint-disable-next-line react-hooks/react-compiler
                $9f2d77943b841e4c$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $9f2d77943b841e4c$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $grrUi.createPath)({
                        ...nextLocation,
                        search: $9f2d77943b841e4c$export$ef0074adc0f6b96d(nextLocation.search)
                    }));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $9f2d77943b841e4c$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent,
        isLazyRoutes
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $eJOHy.useCallback)((nextLocation, nextAction)=>{
        const nextMatchObject = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $7vj7p.default)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $ioEQd.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $7vj7p.default)(route);
                (0, $1MBhZ.default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $9f2d77943b841e4c$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    return null;
};
const $9f2d77943b841e4c$var$SpaRouteComponent = /*#__PURE__*/ (0, $eJOHy.memo)(({ location: location, action: action, query: query, route: route, match: match })=>{
    const { component: RouteComponent, isStrictModeEnabled: isStrictModeEnabled, skeleton: skeleton } = route;
    const Skeleton = skeleton || (0, $6OSA0.default);
    if (RouteComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$ConditionalStrictMode, {
        isEnabled: isStrictModeEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.PlaceholderWithNativeSuspense), {
        name: "route-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    })));
});
const $9f2d77943b841e4c$var$SpaRouteEntryPointContainer = /*#__PURE__*/ (0, $eJOHy.memo)(({ location: location, action: action, query: query, route: route, match: match })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdsvc.RouteEntryPointContainer), {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    });
});
const $9f2d77943b841e4c$var$SpaChild = ({ location: location, action: action, query: query, route: route, match: match })=>{
    const reporting = route.meta?.reporting;
    const entryPoint = (0, $eJOHy.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: (0, $eJOHy.useMemo)(()=>({
                routeGroup: route.group ?? '',
                isSSR: false
            }), [
            route.group
        ]),
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$SpaRouteEntryPointContainer, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$SpaRouteComponent, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    })));
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $9f2d77943b841e4c$var$SpaNew = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $eJOHy.useMemo)(()=>{
        (0, $6uWhG.setMark)('jira-spa/view.start');
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const location = $9f2d77943b841e4c$var$useRouterLocation();
    const action = $9f2d77943b841e4c$var$useRouterAction();
    const query = $9f2d77943b841e4c$var$useRouterQuery();
    const route = $9f2d77943b841e4c$var$useRouterRoute();
    const match = $9f2d77943b841e4c$var$useRouterMatch();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$RegisterRouterBlocks, {
        routes: routes,
        initRoute: initRoute,
        route: route,
        match: match
    }), !(route && match) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$SpaChild, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    }));
};
function $9f2d77943b841e4c$var$ConditionalStrictMode(props) {
    // Default to true
    const { isEnabled: isEnabled = true, children: children } = props;
    // This flag just gives us a kill switch
    if (isEnabled && (0, $4cTDP.fg)('jfp-jira-incremental-strict-mode')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.StrictMode), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
}
const $9f2d77943b841e4c$var$Spa = (0, $bJscI.componentWithFG)('jfp-magma-concurrent-entrypoint-route-stability', $9f2d77943b841e4c$var$SpaNew, $9f2d77943b841e4c$var$SpaOld);
var $9f2d77943b841e4c$export$2e2bcd8739ae039 = $9f2d77943b841e4c$var$Spa;

});
parcelRegister("grrUi", function(module, exports) {
$parcel$export(module.exports, "addLeadingSlash", () => $bf84d0b8ce74f95e$export$5b4913142e03bca8, (v) => $bf84d0b8ce74f95e$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $bf84d0b8ce74f95e$export$10497c7ce66fcb84, (v) => $bf84d0b8ce74f95e$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $bf84d0b8ce74f95e$export$b69e3301ce081aa3, (v) => $bf84d0b8ce74f95e$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $bf84d0b8ce74f95e$export$d95b4586d238a081, (v) => $bf84d0b8ce74f95e$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $bf84d0b8ce74f95e$export$8ccf933b0513f8d0, (v) => $bf84d0b8ce74f95e$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $bf84d0b8ce74f95e$export$fe53371bee54353d, (v) => $bf84d0b8ce74f95e$export$fe53371bee54353d = v);
var $bf84d0b8ce74f95e$export$1e511d4a378977f5;
var $bf84d0b8ce74f95e$export$5b4913142e03bca8;
var $bf84d0b8ce74f95e$export$79c5b1569e3be9e6;
var $bf84d0b8ce74f95e$export$10497c7ce66fcb84;
var $bf84d0b8ce74f95e$export$b69e3301ce081aa3;
var $bf84d0b8ce74f95e$export$d95b4586d238a081;
var $bf84d0b8ce74f95e$export$8ccf933b0513f8d0;
var $bf84d0b8ce74f95e$export$fe53371bee54353d;
'use strict';
$bf84d0b8ce74f95e$export$1e511d4a378977f5 = true;
var $bf84d0b8ce74f95e$var$addLeadingSlash = $bf84d0b8ce74f95e$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $bf84d0b8ce74f95e$var$stripLeadingSlash = $bf84d0b8ce74f95e$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $bf84d0b8ce74f95e$var$hasBasename = $bf84d0b8ce74f95e$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $bf84d0b8ce74f95e$var$stripBasename = $bf84d0b8ce74f95e$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $bf84d0b8ce74f95e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $bf84d0b8ce74f95e$var$stripTrailingSlash = $bf84d0b8ce74f95e$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $bf84d0b8ce74f95e$var$parsePath = $bf84d0b8ce74f95e$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $bf84d0b8ce74f95e$var$createPath = $bf84d0b8ce74f95e$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});

parcelRegister("1MBhZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f22867da0d1bdb90$export$2e2bcd8739ae039);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $kTRgU = parcelRequire("kTRgU");
function $f22867da0d1bdb90$var$traceUFORedirect(fromUfoName, nextUfoName, nextRouteName, time) {
    (0, $kTRgU.default).current = nextUfoName;
    const interactionId = (0, $kVpZx.DefaultInteractionID).current;
    if (interactionId) (0, $2QO3b.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
}
var $f22867da0d1bdb90$export$2e2bcd8739ae039 = $f22867da0d1bdb90$var$traceUFORedirect;

});

parcelRegister("l8usI", function(module, exports) {
$parcel$export(module.exports, "createCheckShouldResetPage", () => $7787635632c533cd$export$ffb8c03de895ae3);

var $cSmYj = parcelRequire("cSmYj");

var $lqvTL = parcelRequire("lqvTL");
const $7787635632c533cd$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === 'issue-navigator';
const $7787635632c533cd$var$isReplaceActionAndJPD = (action, route)=>action === 'REPLACE' && route.name === 'polaris-ideas';
const $7787635632c533cd$export$ffb8c03de895ae3 = ()=>{
    let rapidBoardPaths = [];
    return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
        let shouldReset = true;
        if ($7787635632c533cd$var$isReplaceActionAndPIN(action, nextRoute) || $7787635632c533cd$var$isReplaceActionAndJPD(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
        else {
            const cleanMatch = (0, $lqvTL.getApdexMatchObject)(currentMatch, currentRoute);
            const cleanNextMatch = (0, $lqvTL.getApdexMatchObject)(nextMatch, nextRoute);
            shouldReset = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(cleanMatch, cleanNextMatch) && shouldReset;
            if (shouldReset) {
                // RapidboardPaths is being persisted here.
                // resetDone boolean is calculated in the util function.
                const [paths, resetBoolean] = (0, $lqvTL.calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                rapidBoardPaths = paths;
                if ((0, $lqvTL.isValidRoute)(nextRoute) || nextRoute.group === 'classic-software') shouldReset = !resetBoolean;
            }
        }
        return shouldReset;
    };
};

});
parcelRegister("lqvTL", function(module, exports) {
$parcel$export(module.exports, "calcRapidBoardResetState", () => $e2708a32aba8f471$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $e2708a32aba8f471$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $e2708a32aba8f471$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $e2708a32aba8f471$export$9f3e656a7f6a3adc);
const $e2708a32aba8f471$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [
                'browse-project-redirect'
            ];
            resetDone = true;
            break;
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-backlog':
        case 'rapidboard-report':
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf('browse-project-redirect') > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $e2708a32aba8f471$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $e2708a32aba8f471$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-board':
        case 'rapidboard-report':
            // use search to navigate to board
            if (rapidBoardPaths.includes('browse-project-redirect') || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes('browse-project-redirect')) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $e2708a32aba8f471$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $e2708a32aba8f471$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 'issue':
        case 'issue-embed':
        case 'issue-navigator':
        case 'issue-navigator-classic':
        case 'issue-navigator-core':
        case 'servicedesk-issues':
            return true;
        default:
            return false;
    }
};

});


parcelRegister("dLY5S", function(module, exports) {
$parcel$export(module.exports, "useShouldPerformAction", () => $cdf0af9e359bfad3$export$1bfa74483a8ca772);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $eKzQk = parcelRequire("eKzQk");

var $8BrgA = parcelRequire("8BrgA");
const $cdf0af9e359bfad3$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
    const metas = (0, $eKzQk.useMeta)();
    const remoteActions = (0, $eKzQk.useRemoteActionsData)();
    const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $eKzQk.useRemoteActionsStoreActions)();
    const [actionToPerform, setActionToPerform] = (0, $eJOHy.useState)();
    const [shouldPerformAction, setShouldPerformAction] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        // Check whether or not the action (actionName) should be performed:
        // - when the remote actions available list changes
        // - when the metas for the actions change
        const matchedAction = Object.values(remoteActions).find((action)=>{
            if (action.name !== actionName) return false;
            return true;
        });
        if (!matchedAction) return;
        setActionToPerform(matchedAction);
        setShouldPerformAction((0, $8BrgA.computeShouldPerformAction)(matchedAction, metas));
    }, [
        actionName,
        remoteActions,
        metas
    ]);
    const performAction = (onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    };
    const performActionMemoized = (0, $eJOHy.useCallback)((onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    }, [
        actionToPerform,
        shouldPerformAction,
        metas,
        saveActionPerformedAttempt,
        setShouldPerformAction
    ]);
    return {
        shouldPerformAction: shouldPerformAction,
        performAction: (0, $eGOwo.fg)('jfp-magma-stability-platform-2') ? performActionMemoized : performAction
    };
};

});
parcelRegister("eKzQk", function(module, exports) {
$parcel$export(module.exports, "RemoteActionsContainer", () => $9619c367486de9a7$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $9619c367486de9a7$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $9619c367486de9a7$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $9619c367486de9a7$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionLastUpdatedAt", () => $9619c367486de9a7$export$1d013261a2e6e0f9);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $9619c367486de9a7$export$3fd21eaf97df4718);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $awqaz = parcelRequire("awqaz");

var $77B4H = parcelRequire("77B4H");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $awqaz.default))) (0, $awqaz.default).devtools = false;
const $9619c367486de9a7$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $77B4H.actions,
    name: 'remoteActionsStore'
});
const $9619c367486de9a7$export$28c2e4c663a86266 = (0, $6E16M.createContainer)($9619c367486de9a7$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $77B4H.actions).initStore());
        }
});
const $9619c367486de9a7$export$333357b3de3e67a0 = (selector)=>(0, $iJq0l.createHook)($9619c367486de9a7$var$Store, {
        selector: selector
    })();
const $9619c367486de9a7$export$3cc006661ae2a759 = (0, $iJq0l.createStateHook)($9619c367486de9a7$var$Store, {
    selector: (state)=>state.remoteActions
});
const $9619c367486de9a7$export$3fb9275d3845bd5a = (0, $iJq0l.createStateHook)($9619c367486de9a7$var$Store, {
    selector: (state)=>state.meta
});
const $9619c367486de9a7$export$1d013261a2e6e0f9 = (0, $iJq0l.createStateHook)($9619c367486de9a7$var$Store, {
    selector: (state)=>state.lastUpdatedAt
});
const $9619c367486de9a7$export$3fd21eaf97df4718 = (0, $iJq0l.createActionsHook)($9619c367486de9a7$var$Store);

});
parcelRegister("77B4H", function(module, exports) {
$parcel$export(module.exports, "actions", () => $df64a07630011629$export$e324594224ef24da);

var $kFNqg = parcelRequire("kFNqg");

var $4Z6c5 = parcelRequire("4Z6c5");

var $lkKF6 = parcelRequire("lkKF6");

var $8mR35 = parcelRequire("8mR35");
const $df64a07630011629$export$e324594224ef24da = {
    processRemoteActions: $lkKF6.processRemoteActions,
    saveActionPerformedAttempt: $8mR35.saveActionPerformedAttempt,
    initStore: $4Z6c5.initStore,
    clearActionId: $kFNqg.clearActionId
};

});
parcelRegister("kFNqg", function(module, exports) {
$parcel$export(module.exports, "clearActionId", () => $08384ec3fbbfd9af$export$8d8b492eefa9efba);

var $fYmOz = parcelRequire("fYmOz");
const $08384ec3fbbfd9af$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $fYmOz.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("fYmOz", function(module, exports) {
$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $e3530a747093e38f$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $e3530a747093e38f$export$7228aaade919a8b6);
const $e3530a747093e38f$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $e3530a747093e38f$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$e3530a747093e38f$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $e3530a747093e38f$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$e3530a747093e38f$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("4Z6c5", function(module, exports) {
$parcel$export(module.exports, "initStore", () => $3c3e683a3a9cc56a$export$41f27b3823a442c6);

var $fYmOz = parcelRequire("fYmOz");
const $3c3e683a3a9cc56a$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $fYmOz.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("lkKF6", function(module, exports) {
$parcel$export(module.exports, "processRemoteActions", () => $73bcd93d0808b9f9$export$15e69d1dd38ccaa3);

var $7gucp = parcelRequire("7gucp");
const $73bcd93d0808b9f9$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $7gucp.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $7gucp.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            // only keep the meta for the remote actions that are still present. This is to avoid
            // keeping stale meta which would otherwise grow indefinitely.
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: remoteActionsResponse.lastUpdatedAt
        });
    };

});
parcelRegister("7gucp", function(module, exports) {
$parcel$export(module.exports, "isActionConditionSatisfied", () => $4a46ee77a8d28208$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $4a46ee77a8d28208$export$c7cc93192d09a3d7);

var $3V9IP = parcelRequire("3V9IP");
const $4a46ee77a8d28208$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $4a46ee77a8d28208$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $4a46ee77a8d28208$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $4a46ee77a8d28208$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $3V9IP.ConditionType).buildRange:
            return $4a46ee77a8d28208$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $3V9IP.ConditionType).featureFlag:
            return $4a46ee77a8d28208$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $3V9IP.ConditionType).featureGate:
            return $4a46ee77a8d28208$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $4a46ee77a8d28208$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("3V9IP", function(module, exports) {
$parcel$export(module.exports, "ConditionType", () => $0bc4fcbe27213e12$export$748d1c753cdf4bfd);
var $0bc4fcbe27213e12$export$748d1c753cdf4bfd = /*#__PURE__*/ function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
    return ConditionType;
}({});

});



parcelRegister("8mR35", function(module, exports) {
$parcel$export(module.exports, "saveActionPerformedAttempt", () => $5a0483da3cb1b7ad$export$e3144a2e886e0e77);

var $fYmOz = parcelRequire("fYmOz");
const $5a0483da3cb1b7ad$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $fYmOz.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("8BrgA", function(module, exports) {
$parcel$export(module.exports, "computeShouldPerformAction", () => $073ffa4559526e2d$export$6e0db227c9674096);

const $073ffa4559526e2d$export$50dbcb44bba3aa5c = 60;
const $073ffa4559526e2d$export$b21f5a6e7051e2c2 = (actionMetas)=>{
    const now = Date.now();
    const timeDiff = now - actionMetas.lastPerformAttemptedAt;
    return timeDiff > $073ffa4559526e2d$export$50dbcb44bba3aa5c * 1000;
};
const $073ffa4559526e2d$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $306a03ccf17a563a$export$f2c0b74311ada874);
const $073ffa4559526e2d$export$6e0db227c9674096 = (action, metas)=>{
    const actionMetas = metas[action.id];
    if (!actionMetas) // No meta, we have not attempted to perform this action yet.
    return true;
    if (!$073ffa4559526e2d$export$6c7cf2cb7d75fad3(actionMetas)) // TODO: send a "cancelled analytics event ?"
    return false;
    if (!$073ffa4559526e2d$export$b21f5a6e7051e2c2(actionMetas)) return false;
    // All the conditions are satisfied, we can perform the action.
    return true;
};

});
const $306a03ccf17a563a$export$f2b2f5ef0b498d26 = 5000;
const $306a03ccf17a563a$export$f2c0b74311ada874 = 3;
const $306a03ccf17a563a$export$af2ff676951003fe = 60000;
const $306a03ccf17a563a$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';



parcelRegister("59iVY", function(module, exports) {
$parcel$export(module.exports, "default", () => $56f8476d95efed72$export$2e2bcd8739ae039);

var $cSmYj = parcelRequire("cSmYj");
/**
 * Determines the feasibility of transitioning between routes in a SPA, considering initial loads,
 * user agent constraints, and predefined route conditions. Ensures seamless navigation by
 * evaluating route matches and permissions.
 */ const $56f8476d95efed72$var$transitionValidator = (currentMatch, nextMatch)=>{
    // if we load SPA on a redirect route, we transition immediately skipping the checks
    if (!currentMatch) return true;
    // if next route missing (should not happen as we have a catch all route) or mobile, trigger reload
    if (!nextMatch) return false;
    // If we are still on same route and same match params, skip transition checks
    const isSameRoute = currentMatch.route === nextMatch.route;
    const isSameMatch = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(currentMatch.match, nextMatch.match);
    if (isSameRoute && isSameMatch) return true;
    // check we can transition into next route
    // @ts-expect-error - TS2339 - Property 'canTransitionIn' does not exist on type 'Route'.
    const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
    if (canDoNext) return true;
    return false;
};
var $56f8476d95efed72$export$2e2bcd8739ae039 = $56f8476d95efed72$var$transitionValidator;

});

parcelRegister("jdsvc", function(module, exports) {
$parcel$export(module.exports, "RouteEntryPointContainer", () => $f4a5080f60a01447$export$3e4cdfb894377bc9);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $eSnSE = parcelRequire("eSnSE");


var $jrulJ = parcelRequire("jrulJ");

var $2dBpR = parcelRequire("2dBpR");

var $1Mugv = parcelRequire("1Mugv");

var $lq8Ki = parcelRequire("lq8Ki");

var $cH6Qf = parcelRequire("cH6Qf");

var $fAZgY = parcelRequire("fAZgY");

var $9RE4U = parcelRequire("9RE4U");
const $f4a5080f60a01447$var$LOCATION = 'route-entry-point-container';
const $f4a5080f60a01447$export$fb85bbdbfb3e6869 = ()=>null;
const $f4a5080f60a01447$var$EMPTY_OBJECT = {};
const $f4a5080f60a01447$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
    const entryPointReference = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$900ddb492c628f48));
    // in order to show a spinner while page loading -> `route.skeleton=Spinner`
    const Skeleton = (0, $fAZgY.useMemoWithCondition)(()=>route.skeleton || $f4a5080f60a01447$export$fb85bbdbfb3e6869, [
        route.skeleton
    ], ()=>(0, $4cTDP.fg)('jfp-magma-concurrent-entrypoint-route-stability'));
    (0, $eJOHy.useEffect)(()=>{
        if (route.isRedirect) (0, $eSnSE.default).safeWarnWithoutCustomerData($f4a5080f60a01447$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const pageId = (0, $fAZgY.useMemoWithCondition)(()=>{
        let _pageId = route.name;
        if (route.pageId) {
            if (typeof route.pageId === 'function') _pageId = route.pageId({
                route: route,
                action: action,
                location: location,
                match: match,
                query: query
            });
            else _pageId = route.pageId;
        }
        return _pageId;
    }, [
        action,
        location,
        match,
        query,
        route
    ], ()=>(0, $4cTDP.fg)('jfp-magma-concurrent-entrypoint-route-stability'));
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    if (!entryPointReference) return null;
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, route.bifrost?.bifrostGroup !== 'shell-only' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "RouteEntryPointContainer",
        ignoreWhenCircuitOpen: true,
        displayErrorInStaging: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null));
    const page = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: (0, $4cTDP.fg)('jfp-magma-concurrent-entrypoint-route-stability') ? $f4a5080f60a01447$var$EMPTY_OBJECT : {}
    }));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null),
        name: "route_entry_point_redirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: (0, $4cTDP.fg)('jfp-magma-concurrent-entrypoint-route-stability') ? $f4a5080f60a01447$var$EMPTY_OBJECT : {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Mugv.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: fallback,
        name: "route_entry_point",
        isSSRPlaceholderEnabled: !isPageHydrating ? route?.entryPointOptions?.isSSRPlaceholderEnabled : undefined
    }, page)));
};

});




parcelRegister("aQwf0", function(module, exports) {
$parcel$export(module.exports, "MemoryMonitor", () => $d402fd4b42d466a0$export$afbeaf57d30e8397);
// Based on confluence/packages/confluence-frontend-server/src/memory-monitor.js

var $eJOHy = parcelRequire("eJOHy");

var $2Mqjh = parcelRequire("2Mqjh");

var $kfvK2 = parcelRequire("kfvK2");
const $d402fd4b42d466a0$export$ac4cd9f30299a490 = 0.8;
const $d402fd4b42d466a0$export$632c6346c3a8c3e2 = 10000; // 10 seconds
const $d402fd4b42d466a0$export$de8f032132af9697 = 4000; // issue view has ~2.5k event listeners
let $d402fd4b42d466a0$var$routeName = 'unknown';
let $d402fd4b42d466a0$var$analyticsClient = null;
let $d402fd4b42d466a0$var$memoryMonitorInterval = null;
let $d402fd4b42d466a0$var$_eventListenerCount = 0;
let $d402fd4b42d466a0$var$initializedEventListeners = false;
function $d402fd4b42d466a0$var$bytesToMB(bytes) {
    const MB = 1048576;
    return bytes / MB;
}
const $d402fd4b42d466a0$export$3b9e9fb6812d2b4e = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, no-restricted-properties, @typescript-eslint/consistent-type-assertions
    const performance = window?.performance;
    return performance?.memory;
};
const $d402fd4b42d466a0$export$20e022b37d61b084 = ()=>$d402fd4b42d466a0$var$_eventListenerCount; // for testing
function $d402fd4b42d466a0$export$5ed8144ed56e505a(client) {
    if (client) $d402fd4b42d466a0$var$analyticsClient = client;
    if (!$d402fd4b42d466a0$var$analyticsClient) return false;
    const memory = $d402fd4b42d466a0$export$3b9e9fb6812d2b4e();
    if (memory) {
        const { jsHeapSizeLimit: jsHeapSizeLimit, usedJSHeapSize: usedJSHeapSize } = memory;
        const heapThreshold = jsHeapSizeLimit * $d402fd4b42d466a0$export$ac4cd9f30299a490;
        if (usedJSHeapSize > heapThreshold) $d402fd4b42d466a0$var$analyticsClient.sendOperationalEvent({
            source: 'jira-memory-monitor',
            action: 'measured',
            actionSubject: 'highHeapUsage',
            attributes: {
                heapUsagePercent: Math.floor(usedJSHeapSize / jsHeapSizeLimit * 100),
                heapUsageMB: Math.floor($d402fd4b42d466a0$var$bytesToMB(usedJSHeapSize)),
                maxHeapSizeMB: Math.floor($d402fd4b42d466a0$var$bytesToMB(jsHeapSizeLimit)),
                route: $d402fd4b42d466a0$var$routeName
            }
        });
    }
    if ($d402fd4b42d466a0$var$initializedEventListeners && $d402fd4b42d466a0$export$20e022b37d61b084() > $d402fd4b42d466a0$export$de8f032132af9697) $d402fd4b42d466a0$var$analyticsClient.sendOperationalEvent({
        source: 'jira-memory-monitor',
        action: 'measured',
        actionSubject: 'highEventListenerCount',
        attributes: {
            eventListenerCount: $d402fd4b42d466a0$export$20e022b37d61b084(),
            route: $d402fd4b42d466a0$var$routeName
        }
    });
    return true;
}
function $d402fd4b42d466a0$export$337817b784baf528() {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
    if (!$d402fd4b42d466a0$var$initializedEventListeners) {
        EventTarget.prototype.addEventListener = function addEventListenerWithCounter(type, listener, options) {
            $d402fd4b42d466a0$var$_eventListenerCount++;
            originalAddEventListener.call(this, type, listener, options);
        };
        EventTarget.prototype.removeEventListener = function removeEventListenerWithCounter(type, listener, options) {
            $d402fd4b42d466a0$var$_eventListenerCount--;
            originalRemoveEventListener.call(this, type, listener, options);
        };
        $d402fd4b42d466a0$var$initializedEventListeners = true;
    }
}
function $d402fd4b42d466a0$export$76f12cc80b7fd2f3(client) {
    $d402fd4b42d466a0$var$analyticsClient = client;
    $d402fd4b42d466a0$export$337817b784baf528();
    if (!$d402fd4b42d466a0$var$memoryMonitorInterval) $d402fd4b42d466a0$var$memoryMonitorInterval = setInterval($d402fd4b42d466a0$export$5ed8144ed56e505a, $d402fd4b42d466a0$export$632c6346c3a8c3e2);
    return true;
}
function $d402fd4b42d466a0$export$d0c8b02fd4ae0022(name) {
    $d402fd4b42d466a0$var$routeName = name;
}
function $d402fd4b42d466a0$export$b35196bdb32e40c9() {
    if ($d402fd4b42d466a0$var$memoryMonitorInterval) {
        clearInterval($d402fd4b42d466a0$var$memoryMonitorInterval);
        $d402fd4b42d466a0$var$memoryMonitorInterval = null;
    }
}
const $d402fd4b42d466a0$var$MemoryMonitorClient = ()=>{
    const hasInit = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (hasInit.current) return;
        hasInit.current = true;
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const instance = client?.getInstance();
            if (instance) {
                $d402fd4b42d466a0$var$analyticsClient = instance;
                $d402fd4b42d466a0$export$76f12cc80b7fd2f3(instance);
            }
        });
        return $d402fd4b42d466a0$export$b35196bdb32e40c9;
    });
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = (0, $kfvK2.addRouteListener)((state)=>{
            $d402fd4b42d466a0$export$d0c8b02fd4ae0022(state?.route?.name ?? 'unknown');
        });
        return unsubscribe;
    }, []);
    return null;
};
const $d402fd4b42d466a0$export$afbeaf57d30e8397 = ()=>{
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d402fd4b42d466a0$var$MemoryMonitorClient, null);
};

});

parcelRegister("dvkro", function(module, exports) {
$parcel$export(module.exports, "ReadinessTracker", () => $ada2e98806faaea5$export$9be3fbb5a9e49bfe);

var $eJOHy = parcelRequire("eJOHy");

var $02OvK = parcelRequire("02OvK");
const $ada2e98806faaea5$export$9be3fbb5a9e49bfe = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') window.__JIRA_READY_STATUS = {
            started: true,
            loaded: false,
            onhold: true
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            const onPageReady = ()=>{
                window.__JIRA_READY_STATUS.onhold = false;
            };
            window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
            return ()=>{
                window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
            };
        }
    }, []);
    const [{ hasLoaded: hasLoaded }] = (0, $02OvK.default)();
    (0, $eJOHy.useEffect)(()=>{
        if (hasLoaded) {
            if (typeof window !== 'undefined') // we track "loaded" status as jira "loading end"
            window.__JIRA_READY_STATUS.loaded = true;
        }
    }, [
        hasLoaded
    ]);
    return null;
};

});

parcelRegister("k80Nq", function(module, exports) {
$parcel$export(module.exports, "HotfixTesting", () => $a9a8def34d50f6f4$export$30590c55b29cd5b5);

var $eJOHy = parcelRequire("eJOHy");
const $a9a8def34d50f6f4$export$30590c55b29cd5b5 = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        // we will increase this number to test HOTFIX process
        const hotfixNumber = 'hot-0000';
        // eslint-disable-next-line no-console
        console.log('magma-hotfix-testing is enabled. HOTFIX number: ', hotfixNumber);
    }, []);
    return null;
};

});

parcelRegister("6X5Gm", function(module, exports) {
$parcel$export(module.exports, "HydrationAdvisory", () => $7e64c1833c533f72$export$9a6142f4ca734093);
/* eslint-disable jira/react/no-style-attribute, @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eJOHy = parcelRequire("eJOHy");

var $9RE4U = parcelRequire("9RE4U");
// I promise I am being a good developer and not cheating the VC system. This component is strictly for development use
// only and cannot affect VC for customers.
const $7e64c1833c533f72$var$attrKey = 'vc-nvs';
const $7e64c1833c533f72$var$IGNORE_VC_ATTRIBUTE = {
    [`data-${$7e64c1833c533f72$var$attrKey}`]: true
};
const $7e64c1833c533f72$export$9a6142f4ca734093 = ()=>{
    const [isAdvisoryVisible, setIsAdvisoryVisible] = (0, $eJOHy.useState)(true);
    const isHydrateRenderMode = (0, $9RE4U.useIsHydrateRenderMode)();
    (0, $eJOHy.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setIsAdvisoryVisible(false);
        }, 5000);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    if (!isHydrateRenderMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...$7e64c1833c533f72$var$IGNORE_VC_ATTRIBUTE,
        style: {
            position: 'absolute',
            left: 8,
            top: 12,
            display: 'flex',
            alignItems: 'center',
            // By giving this element a height of 0 and no pointer events, we ensure that it doesn't interfere with the page.
            // To make is visible again, we then set the overflow to "visible".
            height: 0,
            overflow: 'visible',
            pointerEvents: 'none',
            zIndex: 99999999
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        style: {
            backgroundColor: 'aqua',
            borderRadius: '50%',
            width: 8,
            height: 8,
            zIndex: 20
        }
    }), isAdvisoryVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        style: {
            backgroundColor: 'midnightblue',
            color: 'aqua',
            height: '1.5em',
            marginLeft: -12,
            paddingLeft: 16,
            paddingRight: 8,
            borderRadius: 4,
            zIndex: 10
        }
    }, "Rendered with React hydration \uD83D\uDEB0 go/jira-hydration"));
};

});


parcelRegister("1PSAp", function(module, exports) {
$parcel$export(module.exports, "StrictMode", () => $e2fd64c5ded33d14$export$5f8d39834fd61797);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");
const $e2fd64c5ded33d14$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $4cTDP.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).StrictMode, null, children);
};

});

parcelRegister("e8u2a", function(module, exports) {
$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $c164f32528a2f211$export$a580704a2f3cfca);

var $eJOHy = parcelRequire("eJOHy");

var $c9uTK = parcelRequire("c9uTK");

var $jiTA8 = parcelRequire("jiTA8");

var $4cTDP = parcelRequire("4cTDP");
const $c164f32528a2f211$export$a580704a2f3cfca = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ref: ref,
        href: (0, $4cTDP.fg)('jira-remove-default-character-for-undefined-hrefs') ? href : href || '#',
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});

});
parcelRegister("jiTA8", function(module, exports) {
$parcel$export(module.exports, "useIsEmbedMode", () => $e5c1436c84fc3f86$export$1b3c1ba6ee047da9);

var $eJOHy = parcelRequire("eJOHy");

var $Xckw8 = parcelRequire("Xckw8");

var $Xckw8 = parcelRequire("Xckw8");
const $e5c1436c84fc3f86$export$1b3c1ba6ee047da9 = ()=>(0, $eJOHy.useContext)((0, $Xckw8.EmbedModeContext));

});


parcelRegister("lmqkh", function(module, exports) {
$parcel$export(module.exports, "SpaRouter", () => $07f5b8a587569bcd$export$1029be09aa822f4a);

var $eJOHy = parcelRequire("eJOHy");

var $b2uWc = parcelRequire("b2uWc");
const $07f5b8a587569bcd$export$1029be09aa822f4a = ({ routerProps: routerProps, before: before, children: children, after: after })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2uWc.Router), routerProps, before, children, after);

});
parcelRegister("b2uWc", function(module, exports) {
$parcel$export(module.exports, "Router", () => $c986d3ecfee6a30f$export$55185c17a0fcbe46);

var $eJOHy = parcelRequire("eJOHy");

var $bkb9R = parcelRequire("bkb9R");

var $69eg7 = parcelRequire("69eg7");
const $c986d3ecfee6a30f$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $69eg7.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bkb9R.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("69eg7", function(module, exports) {
$parcel$export(module.exports, "usePlugins", () => $e6f8221df2b34d82$export$c41e96fd89bc6106);

var $eJOHy = parcelRequire("eJOHy");

var $hVbKR = parcelRequire("hVbKR");

var $7zZ4w = parcelRequire("7zZ4w");

var $koAZ4 = parcelRequire("koAZ4");

var $9NORu = parcelRequire("9NORu");
const $e6f8221df2b34d82$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $eJOHy.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $9NORu.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $hVbKR.createEntryPointsPlugin)({
            environment: (0, $7zZ4w.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("hVbKR", function(module, exports) {
$parcel$export(module.exports, "createEntryPointsPlugin", () => $c0c53390fd7913fb$export$33586718f82f356f);

var $j4oe4 = parcelRequire("j4oe4");

var $2gKJR = parcelRequire("2gKJR");

var $6ooDe = parcelRequire("6ooDe");

var $ac7CF = parcelRequire("ac7CF");

var $5jk0Z = parcelRequire("5jk0Z");

var $73nKn = parcelRequire("73nKn");
const $c0c53390fd7913fb$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams, noRootQueries: noRootQueries = false })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $6ooDe.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefetched right before being loaded
                if (prefetchingRoute && (0, $2gKJR.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $2gKJR.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else {
                    const entryPointParamsWithContext = {
                        context: context,
                        ...entryPointParams
                    };
                    if (false && noRootQueries) {
                        // we can reassign here because SSR has a fresh context for every request
                        const previousGetPreloadProps = entryPoint.getPreloadProps;
                        const getPreloadProps = (params)=>{
                            const preloadProps = previousGetPreloadProps(params);
                            // @ts-expect-error The operand of a 'delete' operator cannot be a read-only property.ts(2704)
                            delete preloadProps.queries;
                            return preloadProps;
                        };
                        // @ts-expect-error Cannot assign to 'getPreloadProps' because it is a read-only property.ts(2540)
                        entryPoint.getPreloadProps = getPreloadProps;
                    }
                    const loadEntryPointsWithContext = ()=>(0, $j4oe4.loadEntryPoint)({
                            getEnvironment: ()=>environment
                        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        entryPoint, entryPointParamsWithContext);
                    entryPointReference = false ? (0, $73nKn.default)(entryPoint, entryPointParamsWithContext, loadEntryPointsWithContext) : loadEntryPointsWithContext();
                }
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $6ooDe.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $6ooDe.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $2gKJR.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $2gKJR.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $j4oe4.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $6ooDe.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $2gKJR.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $6ooDe.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $6ooDe.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $ac7CF.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        },
        getStats: async ()=>{
            const lastLoadedRoute = (0, $6ooDe.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $5jk0Z.getEntryPointStats)(entryPointReference);
            return [];
        }
    });

});
parcelRegister("2gKJR", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $81a51184a11f6d19$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $81a51184a11f6d19$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $81a51184a11f6d19$export$5997e70fc4543270);
const $81a51184a11f6d19$export$37d3126be6549b13 = 10000;
const $81a51184a11f6d19$export$b65d7ba7fbf150f1 = ()=>$81a51184a11f6d19$export$37d3126be6549b13 + Date.now();
const $81a51184a11f6d19$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $81a51184a11f6d19$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $81a51184a11f6d19$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $81a51184a11f6d19$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $81a51184a11f6d19$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("ac7CF", function(module, exports) {
$parcel$export(module.exports, "waitForEntryPoint", () => $9dfc255fbb1c46bf$export$944f853f194e5dd5);

var $jjfy5 = parcelRequire("jjfy5");
const $9dfc255fbb1c46bf$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $jjfy5.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $9dfc255fbb1c46bf$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});

parcelRegister("5jk0Z", function(module, exports) {
$parcel$export(module.exports, "getEntryPointStats", () => $42ec67f1f6f1c5b1$export$ee016802bdebb378);

var $jjfy5 = parcelRequire("jjfy5");
const $42ec67f1f6f1c5b1$export$14ba46fa7bd4c0a9 = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
const $42ec67f1f6f1c5b1$export$982a0a12103fb99f = async (promise)=>{
    if (!promise) return 'resolved';
    try {
        if (await Promise.race([
            promise,
            Promise.resolve('timeout')
        ]) === 'timeout') return 'pending';
        return 'resolved';
    } catch (e) {
        return 'rejected';
    }
};
const $42ec67f1f6f1c5b1$var$getEntrypointQueryState = async (queryId)=>{
    const queryPromise = (0, $jjfy5.QueryPromisesMap).get(queryId);
    return {
        queryId: queryId,
        status: await $42ec67f1f6f1c5b1$export$982a0a12103fb99f(queryPromise)
    };
};
const $42ec67f1f6f1c5b1$export$ee016802bdebb378 = (entryPointConfig)=>{
    const result = [];
    const analyseEntrypoint = ({ queries: queries, entryPoints: entryPoints })=>{
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) result.push($42ec67f1f6f1c5b1$var$getEntrypointQueryState(String(queries[key].id)));
        });
        if (entryPoints) Object.entries(entryPoints).forEach(([, entryPoint])=>{
            analyseEntrypoint(entryPoint);
        });
    };
    analyseEntrypoint(entryPointConfig);
    return Promise.all(result);
};

});

parcelRegister("73nKn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc406d3c845f53a8$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $hu2rE = parcelRequire("hu2rE");

var $68vsy = parcelRequire("68vsy");

var $3ay9M = parcelRequire("3ay9M");

// eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
const $fc406d3c845f53a8$var$DummyAsyncModule = (0, $hu2rE.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("3ay9M"))), {
    moduleId: "a510115a",
    moduleName: "ReactFragment",
    priority: "userVisible",
    entryFsSsrLiftImportToModule: false
});
$fc406d3c845f53a8$var$DummyAsyncModule.getModuleIfRequired = ()=>(0, $3ay9M.default); // prevent attempts to fetch the module async at all

/**
 * Run a given loadEntryPoint function without loading the entrypoint modules, then load them right afterwards.
 *
 * This is to prevent triggering the loading of entrypoints modules inline with the data fetching.
 * When JS modules are inline-required (such as in SSR when async modules are converted to inline-requires)
 * this leads to inline-evaluating all dependencies for large component modules before kicking off the data for them.
 * This causes a measurable performance hit (~20-80ms in many cases) before we even kick off critical data fetches.
 *
 * Deferring the module loading until after the data fetching allows the module execution to occur in the less critical
 * idle time while waiting for data fetches to return.
 */ function $fc406d3c845f53a8$var$loadEntryPointDataThenModules(entryPoint, entryPointParams, loadEntryPointCallback) {
    const originalModulesByEntrypointRef = new Map();
    (0, $68vsy.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
        originalModulesByEntrypointRef.set(loopingEntryPoint, loopingEntryPoint.root);
        // eslint-disable-next-line no-param-reassign
        loopingEntryPoint.root = $fc406d3c845f53a8$var$DummyAsyncModule;
    });
    try {
        return loadEntryPointCallback();
    } finally{
        (0, $68vsy.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
            const originalModule = originalModulesByEntrypointRef.get(loopingEntryPoint);
            if (!originalModule) throw new Error('Original module not found for entrypoint');
            // eslint-disable-next-line no-param-reassign
            loopingEntryPoint.root = originalModule;
        });
        // Kicks off the loading of the original modules as they would have, but after the data fetches have been started
        // Without this, entrypoints may have trouble rendering
        // Wrap it in a promise to prevent it from affecting timers that start synchronously after this function
        Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("3ay9M")));
        }).then((res)=>originalModulesByEntrypointRef.forEach((entryPointModule)=>{
                const jsModule = entryPointModule.getModuleIfRequired();
                if (jsModule != null) return;
                entryPointModule.load();
            }));
    }
}
var $fc406d3c845f53a8$export$2e2bcd8739ae039 = $fc406d3c845f53a8$var$loadEntryPointDataThenModules;

});
parcelRegister("68vsy", function(module, exports) {
$parcel$export(module.exports, "default", () => $85aa286ebf29abd2$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Recursively run through all nested entrypoints with a given callback
 */ function $85aa286ebf29abd2$var$forAllEntryPoints(entryPoint, entryPointParams, callback) {
    callback(entryPoint);
    const preloadProps = entryPoint.getPreloadProps(entryPointParams);
    const entryPoints = preloadProps.entryPoints;
    if (!entryPoints) return;
    Object.values(entryPoints).forEach(({ entryPoint: nestedEntryPoint, entryPointParams: nestedParams })=>{
        if (nestedEntryPoint) $85aa286ebf29abd2$var$forAllEntryPoints(nestedEntryPoint, nestedParams, callback);
    });
}
var $85aa286ebf29abd2$export$2e2bcd8739ae039 = $85aa286ebf29abd2$var$forAllEntryPoints;

});

parcelRegister("3ay9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $557903deeab35115$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $557903deeab35115$var$ReactFragment = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
var $557903deeab35115$export$2e2bcd8739ae039 = $557903deeab35115$var$ReactFragment;

});



parcelRegister("9NORu", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => $35412eb3a33b365b$export$23ed892c481a96fe);

var $uCHeL = parcelRequire("uCHeL");

var $dqruy = parcelRequire("dqruy");
const $35412eb3a33b365b$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $35412eb3a33b365b$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
    const nextResources = (0, $dqruy.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $35412eb3a33b365b$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
    const nextResources = (0, $dqruy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $35412eb3a33b365b$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout, onlyGetCritical: onlyGetCritical })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $uCHeL.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $35412eb3a33b365b$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $35412eb3a33b365b$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $35412eb3a33b365b$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $uCHeL.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout,
                onlyGetCritical: onlyGetCritical
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
            const nextResources = (0, $dqruy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $uCHeL.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("dqruy", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $1a8b7e47babf72f8$export$7cbbc763e2f3d65d);

var $hzgsc = parcelRequire("hzgsc");

var $8Jtan = parcelRequire("8Jtan");
const $1a8b7e47babf72f8$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $8Jtan.routeHasResources)(nextRoute)) return [];
    if ((0, $8Jtan.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $hzgsc.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $hzgsc.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("hzgsc", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $729abb4a5d40de0d$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $729abb4a5d40de0d$export$cd7fbe7e979df558);
const $729abb4a5d40de0d$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $729abb4a5d40de0d$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$729abb4a5d40de0d$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("8Jtan", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $5cc875e1fdc3f713$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $5cc875e1fdc3f713$export$221027ff1aa38f82);
const $5cc875e1fdc3f713$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $5cc875e1fdc3f713$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});






parcelRegister("7grfV", function(module, exports) {
$parcel$export(module.exports, "default", () => $adf60ba773b1f455$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $KQtrs = parcelRequire("KQtrs");

var $8dH3d = parcelRequire("8dH3d");

var $JdXiI = parcelRequire("JdXiI");

var $hWeHP = parcelRequire("hWeHP");

var $jJaSe = parcelRequire("jJaSe");

var $96Fb4 = parcelRequire("96Fb4");

var $hcKUA = parcelRequire("hcKUA");

var $5M2Lz = parcelRequire("5M2Lz");
const $adf60ba773b1f455$var$sessionQueryParams = [
    'searchSessionId',
    'searchObjectId',
    'searchContainerId',
    'searchContentType'
];
const $adf60ba773b1f455$var$sessionMeta = [
    'ajs-search-session-id',
    'ajs-search-object-id',
    'ajs-search-container-id',
    'ajs-search-content-type'
];
const $adf60ba773b1f455$var$removeDwellComponent = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const element = document.getElementById(placeholderId);
    if (placeholderId && element) (0, $aQK2r.unmountComponentAtNode)(element);
};
const $adf60ba773b1f455$var$removeSessionMeta = ()=>$adf60ba773b1f455$var$sessionMeta.forEach((0, $hcKUA.removeMetaTag));
// @ts-expect-error - TS7031 - Binding element 'sessionId' implicitly has an 'any' type. | TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'containerId' implicitly has an 'any' type. | TS7031 - Binding element 'objectType' implicitly has an 'any' type.
const $adf60ba773b1f455$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
    const newMeta = {
        'ajs-search-session-id': sessionId,
        'ajs-search-object-id': objectId,
        'ajs-search-container-id': containerId,
        'ajs-search-content-type': objectType
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(newMeta).forEach(([name, content])=>(0, $hcKUA.addMetaTag)(name, content));
};
const $adf60ba773b1f455$var$getPreviousSessionId = ()=>(0, $hWeHP.default)('ajs-search-session-id');
class $adf60ba773b1f455$export$f1e582dddb502dd6 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.onClearSessionEvent = ()=>{
            if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                shouldRemoveSessionBeIgnored: false
            });
        }, this.onHistoryChange = (location)=>{
            $adf60ba773b1f455$var$removeDwellComponent('search-dwell-time');
            const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($KQtrs))).parse(location.pathname + location.search, true);
            const queryString = parsedUrl.query || {};
            const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
            const { path: path } = parsedUrl;
            const previousSessionId = $adf60ba773b1f455$var$getPreviousSessionId();
            const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $adf60ba773b1f455$var$removeSessionMeta();
            if (searchSessionId) {
                (0, $JdXiI.default)($adf60ba773b1f455$var$sessionQueryParams);
                const newState = {
                    sessionId: searchSessionId,
                    objectId: searchObjectId,
                    objectType: searchContentType,
                    containerId: searchContainerId,
                    previousSessionId: $adf60ba773b1f455$var$getPreviousSessionId()
                };
                $adf60ba773b1f455$var$addSessionMeta(newState);
                const shouldRemoveSession = !!(0, $5M2Lz.skipClearSessionURLs).find((skipUrlRegex)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(path) ? skipUrlRegex.test(path) : false);
                // @ts-expect-error - TS2345 - Argument of type '{ shouldRemoveSessionBeIgnored: boolean; sessionId: string | string[]; objectId: string | string[] | undefined; objectType: string | string[] | undefined; containerId: string | string[] | undefined; previousSessionId: string | null; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "containerId" | "objectType" | "objectId" | "sessionId" | "previousSessionId" | "shouldRemoveSessionBeIgnored"> | null) | Pick<...> | null'.
                this.setState({
                    ...newState,
                    shouldRemoveSessionBeIgnored: shouldRemoveSession
                });
            }
        };
        this.props.history.listen(this.onHistoryChange);
        this.state = {
            shouldRemoveSessionBeIgnored: false,
            sessionId: ''
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $5M2Lz.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $5M2Lz.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    render() {
        if (this.state && this.state.sessionId) {
            const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
            const data = {
                objectId: objectId,
                containerId: containerId,
                objectType: objectType,
                source: objectType,
                actionSubject: objectType,
                attributes: {
                    previousSessionId: previousSessionId
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $96Fb4.default), {
                sessionId: sessionId,
                data: data
            });
        }
        return null;
    }
}
var $adf60ba773b1f455$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($adf60ba773b1f455$export$f1e582dddb502dd6);

});
parcelRegister("JdXiI", function(module, exports) {
$parcel$export(module.exports, "default", () => $1745b16040d0e430$export$2e2bcd8739ae039);

var $KQtrs = parcelRequire("KQtrs");

var $jFHCE = parcelRequire("jFHCE");
/**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ const $1745b16040d0e430$var$stripQueryParams = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($KQtrs))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($KQtrs))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};
var $1745b16040d0e430$export$2e2bcd8739ae039 = $1745b16040d0e430$var$stripQueryParams;

});

parcelRegister("96Fb4", function(module, exports) {
$parcel$export(module.exports, "default", () => $778b4a13c0a09b07$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $fdpHV = parcelRequire("fdpHV");

var $7iHUq = parcelRequire("7iHUq");


var $2x61s = parcelRequire("2x61s");
const $778b4a13c0a09b07$var$defaultSource = 'dwellComponent';
const $778b4a13c0a09b07$var$defaultActionSubject = 'dwellComponent';
const $778b4a13c0a09b07$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $fdpHV.AnalyticsSubject)(actionSubject || $778b4a13c0a09b07$var$defaultActionSubject), (0, $fdpHV.AnalyticsSource)(source || $778b4a13c0a09b07$var$defaultSource, (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)))((0, $2x61s.default));
class $778b4a13c0a09b07$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $778b4a13c0a09b07$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $778b4a13c0a09b07$var$defaultSource,
            actionSubject: data && data.actionSubject || $778b4a13c0a09b07$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("2x61s", function(module, exports) {
$parcel$export(module.exports, "default", () => $68505db1eb5cfa8c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $khgKq = parcelRequire("khgKq");

var $as6H2 = parcelRequire("as6H2");

var $7Y1Sx = parcelRequire("7Y1Sx");
class $68505db1eb5cfa8c$export$1c7ccff61c195c75 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $khgKq.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args), this.sendDwellEvent = (payload)=>(0, $7Y1Sx.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $68505db1eb5cfa8c$export$2e2bcd8739ae039 = (0, $as6H2.default)('dwellTime', {
    onDwell: 'dwelled'
})($68505db1eb5cfa8c$export$1c7ccff61c195c75);

});
parcelRegister("7Y1Sx", function(module, exports) {
$parcel$export(module.exports, "fireTrackAnalytics", () => $257aaea6fa354a9b$export$13990ad4625571ed);

var $9pL9Y = parcelRequire("9pL9Y");

var $9X75V = parcelRequire("9X75V");

var $qQaal = parcelRequire("qQaal");
const $257aaea6fa354a9b$var$isNotUndefined = (a)=>a !== undefined;
const $257aaea6fa354a9b$var$mapPayload = (payload)=>{
    const context = (0, $qQaal.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $257aaea6fa354a9b$var$isNotUndefined);
};
const $257aaea6fa354a9b$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$257aaea6fa354a9b$var$mapPayload(payload),
        analyticsType: (0, $9X75V.TRACK_EVENT_TYPE)
    }).fire();
};

});



parcelRegister("hcKUA", function(module, exports) {
$parcel$export(module.exports, "addMetaTag", () => $69d894647c7a1ca5$export$c79fd820617d7f);
$parcel$export(module.exports, "removeMetaTag", () => $69d894647c7a1ca5$export$4267657a25105d9d);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $69d894647c7a1ca5$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $69d894647c7a1ca5$var$getHead = ()=>document.head || document.querySelector('head');
const $69d894647c7a1ca5$export$c79fd820617d7f = (name, content)=>{
    if (!name || !content) return;
    const existingMeta = $69d894647c7a1ca5$export$c9d44c736471c518(name);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    if (existingMeta) existingMeta.parentNode?.replaceChild(meta, existingMeta);
    else {
        const head = $69d894647c7a1ca5$var$getHead();
        if (head) head.appendChild(meta);
    }
};
const $69d894647c7a1ca5$export$4267657a25105d9d = (name)=>{
    const meta = $69d894647c7a1ca5$export$c9d44c736471c518(name);
    if (meta) meta.parentNode?.removeChild(meta);
};

});

parcelRegister("5M2Lz", function(module, exports) {
$parcel$export(module.exports, "CLEAR_SEARCH_SESSION", () => $75d3ffa3b93cfd1e$export$b669eaa3e4786d5c);
$parcel$export(module.exports, "skipClearSessionURLs", () => $75d3ffa3b93cfd1e$export$c092460ed33e0e35);
const $75d3ffa3b93cfd1e$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
const $75d3ffa3b93cfd1e$export$c092460ed33e0e35 = [
    /.*RapidBoard.jspa.*/,
    /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
    /\/jira\/people\/.*\/boards\/.*/
];

});


parcelRegister("59viY", function(module, exports) {
$parcel$export(module.exports, "addInitialPageLoadTimings", () => $da30ee3021f3c7ea$export$ce440b3d0fa0d5ed);

var $4cTDP = parcelRequire("4cTDP");

var $lOI8W = parcelRequire("lOI8W");

var $4GMX3 = parcelRequire("4GMX3");
const $da30ee3021f3c7ea$export$ce440b3d0fa0d5ed = ()=>{
    if (false) return;
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig-gate-values:start', 'ssr.spa.statsig-gate-values:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'statsig-parse:start', 'statsig-parse:end');
    // In legacy SSR, parsing happens inline with processing the flush. In modern SSR or static fallback scenarios for legacy SSR, the parse will be timed seperately.
    // What we want to avoid is confusing people with a "parse timer" in legacy SSR breakdown charts that doesn't overlap with the "statsig" timer (without this timer entry that would happen and it would have a very low volume, but it would distract people during perf-investigations)
    // This will make the statsig-parse timer fully overlap with "statsig" when the parsing happens inline, and will start at a different time otherwise
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'ssr.spa.statsig:start', 'ssr.spa.statsig:start');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-common', 'ssr.spa.inline-assets:start', 'ssr.spa.inline-assets:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-route', 'ssr.spa.async-inline-assets:start', 'ssr.spa.async-inline-assets:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/waiting-for-ssr', 'ssr.spa.await-render-spa-app:start', 'ssr.spa.await-render-spa-app:end');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    (0, $4cTDP.fg)('add-loading-bundles-span-initial-load') && (0, $4GMX3.observePreloadedBundlesProgress)();
};

});
parcelRegister("4GMX3", function(module, exports) {
$parcel$export(module.exports, "observePreloadedBundlesProgress", () => $5ac73ffb25de9a5c$export$2169bfe6cd4f4439);

var $iKhRZ = parcelRequire("iKhRZ");
let $5ac73ffb25de9a5c$var$po = null;
let $5ac73ffb25de9a5c$var$timeout = null;
let $5ac73ffb25de9a5c$var$started = false;
const $5ac73ffb25de9a5c$export$2169bfe6cd4f4439 = ()=>{
    if (false || $5ac73ffb25de9a5c$var$started || !globalThis.PerformanceObserver) return;
    $5ac73ffb25de9a5c$var$started = true;
    const expectedEntries = new Set(Array.from(globalThis.document?.querySelectorAll?.('link[rel=modulepreload]') || []).map((el)=>el.getAttribute('href')).filter((url)=>url?.includes('jira-frontend-bifrost')));
    /* eslint-disable @typescript-eslint/consistent-type-assertions */ const loadedResources = Array.from(globalThis.performance?.getEntriesByType('resource')).filter(({ name: name })=>{
        if (expectedEntries.has(name)) {
            expectedEntries.delete(name);
            return true;
        }
        return false;
    });
    if (expectedEntries.size > 0) {
        $5ac73ffb25de9a5c$var$timeout = setTimeout(()=>{
            $5ac73ffb25de9a5c$var$po?.disconnect();
        }, 30000);
        $5ac73ffb25de9a5c$var$po = new PerformanceObserver((entry)=>{
            entry.getEntries().forEach((e)=>{
                if (expectedEntries.has(e.name)) {
                    expectedEntries.delete(e.name);
                    loadedResources.push(e);
                }
                if (expectedEntries.size === 0) {
                    $5ac73ffb25de9a5c$var$timeout !== null && clearTimeout($5ac73ffb25de9a5c$var$timeout);
                    $5ac73ffb25de9a5c$var$po?.disconnect();
                    $5ac73ffb25de9a5c$var$processCapturedData(loadedResources);
                }
            });
        });
    } else $5ac73ffb25de9a5c$var$processCapturedData(loadedResources);
/* eslint-enable @typescript-eslint/consistent-type-assertions */ };
const $5ac73ffb25de9a5c$var$determineMinAndMax = (agg, entry)=>{
    if (agg.min === null || entry.startTime < agg.min) // eslint-disable-next-line no-param-reassign
    agg.min = entry.startTime;
    if (agg.max === null || entry.responseEnd > agg.max) // eslint-disable-next-line no-param-reassign
    agg.max = entry.responseEnd;
};
const $5ac73ffb25de9a5c$var$processCapturedData = (loadedResources)=>{
    const { all: all, common: common, route: route } = loadedResources.reduce((agg, entry)=>{
        $5ac73ffb25de9a5c$var$determineMinAndMax(agg.all, entry);
        if ($5ac73ffb25de9a5c$var$isCommon(entry)) $5ac73ffb25de9a5c$var$determineMinAndMax(agg.common, entry);
        else $5ac73ffb25de9a5c$var$determineMinAndMax(agg.route, entry);
        return agg;
    }, {
        all: {
            max: null,
            min: null
        },
        common: {
            max: null,
            min: null
        },
        route: {
            max: null,
            min: null
        }
    });
    if (all.max === null || all.min === null) return;
    $5ac73ffb25de9a5c$var$setTimings('preloading-bundles', all);
    $5ac73ffb25de9a5c$var$setTimings('preloading-bundles/common', common);
    $5ac73ffb25de9a5c$var$setTimings('preloading-bundles/route', route);
};
const $5ac73ffb25de9a5c$var$isCommon = (entry)=>{
    const url = entry.name;
    const hasJiraSpa = url.includes('jira-spa');
    const isSharedWithoutNav = url.includes('/shared') && !url.includes('atlassian-navigation');
    const isNavWithVendor = url.includes('atlassian-navigation') && url.includes('vendor');
    return (hasJiraSpa || isSharedWithoutNav || isNavWithVendor) && url.endsWith('.js');
};
const $5ac73ffb25de9a5c$var$setTimings = (label, { min: min, max: max })=>{
    if (max === null || min === null) return;
    const startMark = `${label}-start`;
    const stopMark = `${label}-end`;
    performance.mark(startMark, {
        startTime: min
    });
    performance.mark(stopMark, {
        startTime: max
    });
    (0, $iKhRZ.addTimingFromPerformanceMark)(label, startMark, stopMark, true, true);
};

});


parcelRegister("gNSxk", function(module, exports) {
$parcel$export(module.exports, "setPrefetchStartMark", () => $7e18a8aa366ad472$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $7e18a8aa366ad472$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $7e18a8aa366ad472$export$d6b0928f07bafe57);
const $7e18a8aa366ad472$var$prefetchTiming = new Map();
const $7e18a8aa366ad472$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$7e18a8aa366ad472$var$prefetchTiming.has(currentMatch)) $7e18a8aa366ad472$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $7e18a8aa366ad472$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $7e18a8aa366ad472$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $7e18a8aa366ad472$export$d6b0928f07bafe57 = (match)=>{
    if (!$7e18a8aa366ad472$var$prefetchTiming || !$7e18a8aa366ad472$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($7e18a8aa366ad472$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $7e18a8aa366ad472$var$prefetchTiming.has(mark)) $7e18a8aa366ad472$var$prefetchTiming.delete(mark);
    });
};

});

parcelRegister("ccydf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca20711dc4997be5$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $fdDkm = parcelRequire("fdDkm");
var $30bwc = parcelRequire("30bwc");
const $ca20711dc4997be5$var$LOCATION = 'spa.create-spa-history';
const $ca20711dc4997be5$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
        const matchedRoute = (0, $30bwc.default)(currentRoutes, history.location.pathname, history.location.search);
        // This should never be the case as in SPA we have a default route
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!matchedRoute) return ()=>{};
        if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
        // returns an "unregister" block
        return ()=>{
            const idx = routeBlockFns.indexOf(blockFn);
            if (idx !== -1) routeBlockFns.splice(idx, 1);
        };
    };
const $ca20711dc4997be5$var$createSpaHistory = (initialRoutes)=>{
    const routeBlockFns = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let blockArgs = [];
    let nextMatchedRoute;
    const currentRoutes = initialRoutes;
    const history = (0, $fdDkm.createBrowserHistory)({
        /* We abuse this api to allow us to run as many blockers as we want, allowing the transition
		 * to resume only when all return true or bail out as soon as the first one returns false */ getUserConfirmation: (__, done)=>{
            const matchedRoute = (0, $30bwc.default)(currentRoutes, history.location.pathname, history.location.search);
            // This should never be the case as in SPA we have a default route
            if (!matchedRoute || !nextMatchedRoute) return done(true);
            // we execute the blockers in reverse order, so the last registered is the first to run
            // They are executed synchronously until one returns false or a promise
            // If a promise is returned we execute all remaining blockers as chained promises
            let sync = true;
            for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                const result = routeBlockFns[i](...blockArgs);
                if (result instanceof Promise) {
                    sync = false;
                    routeBlockFns.slice(0, i + 1).reverse().reduce(// eslint-disable-next-line @typescript-eslint/no-loop-func
                    (promise, blocker)=>promise.then((res)=>res === false ? Promise.resolve(false) : blocker(...blockArgs)), Promise.resolve(result)).then((res)=>{
                        routeBlockFns.length = 0;
                        done(res);
                    }).catch((err)=>{
                        (0, $eSnSE.default).safeErrorWithoutCustomerData($ca20711dc4997be5$var$LOCATION, 'Error with getUserConfirmation', err);
                        done(true);
                    });
                    break;
                }
                if (result === false) {
                    done(false);
                    return;
                }
            }
            if (sync) {
                routeBlockFns.length = 0;
                done(true);
            }
        }
    });
    // For lazy loaded route maps we need to keep track of the current routes here
    // as they will be changing. When we "match" for the route blocking code we need
    // to ensure we match against the current routes, not the routes at the time the function
    // was created.
    history.refreshRoutes = (newRoutes)=>{
        // Replace currentRoutes in place as it's captured in a closure above..
        currentRoutes.length = 0;
        currentRoutes.push(...newRoutes);
    };
    /* We set the main "blocker", that is also used enable next location access in getUserConfirmation
	 * (going around getUserConfirmation API limitations) */ history.block((location, action)=>{
        blockArgs = [
            location,
            action
        ];
        nextMatchedRoute = (0, $30bwc.default)(currentRoutes, location.pathname, location.search);
        // Must return a string or getUserConfirmation is not called
        return '';
    });
    // @ts-expect-error - we're using a custom blocker
    history.block = $ca20711dc4997be5$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
    return history;
};
/**
 * Monkey patches the push/replace methods of the react router history object to
 * perform a full page refresh instead of history push/replace when a route is not valid
 * (i.e. legacy pages). This is required to fix the browser back button not working correctly
 * after redirecting to a legacy page.
 * JSPA-900
 */ const $ca20711dc4997be5$var$createSpaHistory1 = (routes)=>$ca20711dc4997be5$var$createSpaHistory(routes);
var $ca20711dc4997be5$export$2e2bcd8739ae039 = $ca20711dc4997be5$var$createSpaHistory1;

});

parcelRegister("lZMpx", function(module, exports) {
$parcel$export(module.exports, "getSpaRouterContext", () => $80de4900a6305c9e$export$1f61c5e3f6410afa);
const $80de4900a6305c9e$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("aqRAv", function(module, exports) {
$parcel$export(module.exports, "default", () => $10fcd8375fcf033e$export$2e2bcd8739ae039);

var $8aMsX = parcelRequire("8aMsX");

var $lDihq = parcelRequire("lDihq");

var $2QO3b = parcelRequire("2QO3b");

var $h5y7n = parcelRequire("h5y7n");

var $53lbp = parcelRequire("53lbp");
var $8F7u9 = parcelRequire("8F7u9");

var $gA3op = parcelRequire("gA3op");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $dJnTE = parcelRequire("dJnTE");

var $fr3kC = parcelRequire("fr3kC");

var $lf6Bt = parcelRequire("lf6Bt");

var $cxKOj = parcelRequire("cxKOj");

var $gbSLd = parcelRequire("gbSLd");

var $eL1MK = parcelRequire("eL1MK");

var $87apk = parcelRequire("87apk");
const $10fcd8375fcf033e$var$FALLBACK_UFO_CONFIG = {
    autoGeneratedRate: 1000,
    enabled: true,
    removeUFOPrefixList: [
        'project-versions',
        'filters-directory'
    ],
    removePageSegmentsUFOPrefixes: true,
    doNotAbortActivePressInteractionOnTransition: [
        'jsm-create-cmp-request-type-from-template',
        'jsm-create-tmp-request-type-from-template'
    ],
    killswitch: [
        'jira.fe.load.UNKNOWN'
    ],
    awaitForSegments: {
        'global-issue.create-modal': [
            'issue-view-details'
        ],
        'global-issue.create-modal-subsequent': [
            'issue-view-details'
        ]
    },
    removeAllUFOPrefix: true,
    rates: {
        'issue-view-activity-button-worklog': 1,
        'issue-view-activity-button-history': 1,
        'issue-view-activity-button-comments': 1,
        'arj-toggle-view-mode': 1,
        'global-issue.create-modal-subsequent': 5,
        unknown: 1000,
        'issue-view-activity-button-forge-app': 1,
        'view-mode': 1,
        'backlog.issue-view-opened': 5,
        'create-web-link-inline-field-type-tracing': 1000,
        'issue-view-activity-button-connect-app': 1,
        'single-line-text-field-type-tracing': 100,
        'issue-view-activity-button-all': 1,
        'backlog.card-hover': 1,
        'child-issue-inline-create-type-tracing': 100,
        'show-insights-button': 100,
        'board.issue-view-opened': 5,
        'issue-view-activity-button-jsd-comments': 1,
        'backlog.card-list-toggle': 5,
        'global-issue.create-modal': 5,
        'issue-view-activity-button-approvals': 1
    },
    kind: {
        generic: 0,
        hover: 0,
        legacy: 1,
        page_load: 1,
        press: 1,
        transition: 1,
        typing: 0
    },
    awaitBM3TTI: [
        'jwm_project_pages',
        'software-plan-dependencies',
        'advanced-roadmaps.page-plan.dependencies-tab.load-time',
        'servicedesk-cmdb-object-type-configuration',
        'service-management.insight-cmdb-object-type-configuration',
        'project-components-view',
        'project-components',
        'project-settings-components',
        'people-index',
        'people-profiles',
        'rapidboard-report',
        'classic-report',
        'project-settings-servicedesk-ticket-type-fields',
        'project-settings.issue-type.jsm-cmp-customer-view',
        'project-settings.issue-type.jsm-cmp-agent-view',
        'archived-project-direct-link',
        'project-archived',
        'servicedesk-queues-new',
        'service-management.queues.new',
        'project-settings-software-boards-insights',
        'board-settings-apps.insights-settings-page.page.load',
        'admin-oauth-credentials',
        'admin.oauth-credentials',
        'polaris-ideas',
        'project-settings-software-boards-csm',
        'jira.fe.page-load.software.next-gen.boards.column-status-mapping.page.load',
        'project-settings-servicedesk-language',
        'service-management.languages',
        'project-settings-servicedesk-language-key',
        'service-management.translations',
        'project-settings-servicedesk-classic-apps',
        'service-management.app-discovery',
        'marketplace-index',
        'embedded-marketplace',
        'project-settings-servicedesk-portal-settings',
        'service-management.portal-settings',
        'service-management.portal-settings.portal-groups',
        'project-settings-servicedesk-automation-create',
        'service-management.automation.create-rule',
        'servicedesk-customers-v2',
        'jsm-customers-component-load',
        'archived-project-direct-link',
        'project-archived',
        'project-settings-software-boards-csm',
        'software.next-gen.boards.column-status-mapping.page.load',
        'jira-connect',
        'knowledge-hub-category',
        'service-management.knowledge.category',
        'servicedesk-queues-landing',
        'servicedesk-practice-landing',
        'servicedesk-practice-custom-and-issue',
        'servicedesk-practice-custom-issue',
        'servicedesk-practice-custom-view',
        'servicedesk-queues-custom-and-issue',
        'servicedesk-queues-custom-issue',
        'servicedesk-queues-custom-view'
    ],
    rules: [],
    capability: {
        feature_flag_access: 1,
        react_profiler: 1
    },
    typingMethod: 'timeout',
    removeInteractionsUFOPrefixes: true,
    doNotAbortActivePressInteraction: [
        'global-issue.create-modal',
        'global-issue.create-modal-subsequent'
    ],
    ufoNameOverrides: {
        'global-issue-navigator': {
            'global-issue-navigator': 'global-issue-navigator-jfe',
            'new-issue-navigator': 'global-new-issue-navigator'
        },
        'global-issue-navigator-jfe': {
            'global-issue-navigator-jfe': 'global-issue-navigator-jfe',
            'new-issue-navigator': 'global-new-issue-navigator'
        },
        'global-settings-migrations-focus-page': {
            'admin.c2c-migrations.choose-destination': 'admin.c2c-migrations.choose-destination',
            'admin.c2c-migrations.choose-projects': 'admin.c2c-migrations.choose-projects',
            'admin.c2c-migrations.preflight-checks': 'admin.c2c-migrations.preflight-checks',
            'admin.c2c-migrations.review': 'admin.c2c-migrations.review'
        },
        'polaris-ideas': {
            'project-settings.details': 'project-settings-details-polaris-ideas'
        },
        'project-settings-servicedesk-portal-settings': {
            'service-management.portal-settings': 'service-management.portal-settings',
            'service-management.portal-settings.portal-groups': 'service-management.portal-settings.portal-groups'
        },
        'project-settings-servicedesk-ticket-type-fields': {
            'project-settings.issue-type.jsm-cmp-agent-view': 'project-settings.issue-type.jsm-cmp-agent-view',
            'project-settings.issue-type.jsm-cmp-customer-view': 'project-settings.issue-type.jsm-cmp-customer-view'
        },
        'servicedesk-practice-custom-and-issue': {
            'service-management.queues.issue': 'servicedesk-practice-custom-issue',
            'service-management.queues.view': 'servicedesk-practice-custom-view'
        },
        'servicedesk-queues-custom-and-issue': {
            'service-management.queues.issue': 'servicedesk-queues-custom-issue',
            'service-management.queues.view': 'servicedesk-queues-custom-view'
        }
    },
    enableCompleteUsingDoubleRAF: true
};
const $10fcd8375fcf033e$var$STRINGIFIED_FALLBACK_UFO_CONFIG = JSON.stringify($10fcd8375fcf033e$var$FALLBACK_UFO_CONFIG);
const $10fcd8375fcf033e$var$getUFOConfigFromStatsig = ()=>{
    try {
        // eslint-disable-next-line jira/ff/inline-expVal-params
        return JSON.parse((0, $cxKOj.expVal)('ufo_config', 'value', $10fcd8375fcf033e$var$STRINGIFIED_FALLBACK_UFO_CONFIG));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to get UFO config from Statsig dynamic config:', error);
        // TODO: AFO-2949: Change the fallback to be `{}` once we have a stable config in Statsig when deprecating the FF 'ufo-use-statsig-config-jira'
        return $10fcd8375fcf033e$var$FALLBACK_UFO_CONFIG;
    }
};
function $10fcd8375fcf033e$var$getAdditionalJiraFields(interaction) {
    try {
        return {
            jira: (0, $fr3kC.getJiraCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
}

function $10fcd8375fcf033e$var$loadJiraAnalyticsWebClient() {
    return Promise.resolve((parcelRequire("2Mqjh")));
}
function $10fcd8375fcf033e$export$2e2bcd8739ae039() {
    const ufoConfigFromFF = (0, $4cTDP.fg)('ufo-use-statsig-config-jira') ? $10fcd8375fcf033e$var$getUFOConfigFromStatsig() : $10fcd8375fcf033e$var$FALLBACK_UFO_CONFIG;
    (0, $dJnTE.retrieveAndSetPageLoadTrace)((0, $hWeHP.default));
    (0, $53lbp.configure)((0, $eL1MK.jiraResourceTimingsConfig));
    (0, $8F7u9.startResourceTimingBuffer)();
    if (!(0, $4cTDP.fg)('jira-disable-ufo-bundle-eval-timings')) (0, $lDihq.configure)((0, $gbSLd.jiraBundleEvalTimingsConfig));
    (0, $gA3op.configure)((0, $87apk.jiraSsrConfig));
    (0, $lf6Bt.GlobalReactLooselyLazyProfiler).current = (0, $2QO3b.ModuleLoadingProfiler);
    const perfPushExperienceRates = {
        'issue-view': 1,
        'issue-view-software': 1,
        'issue-view-serviceDesk': 1,
        'issue-view-embed': 1,
        'new-issue-navigator': 1,
        'classic-board': 1,
        'classic-backlog': 1,
        'next-gen-board': 1,
        'software-plan-timeline': 1,
        'next-gen-roadmap': 1,
        'classic-roadmap': 1,
        'next-gen-backlog': 1,
        'jwm.list-view': 1,
        'jwm.summary-view': 1,
        dashboard: 1,
        'global-new-issue-navigator': 1,
        'global-issue-navigator-jfe': 1,
        'issue-navigator': 1,
        'jwm.jwm-board-base': 1,
        'jwm.jwm-board-with-filters': 1,
        'jwm.jwm-board-with-issue-view': 1,
        'servicedesk-queues-landing': 1,
        'servicedesk-practice-landing': 1,
        'servicedesk-practice-custom-issue': 1,
        'servicedesk-practice-custom-view': 1,
        'servicedesk-queues-custom-issue': 1,
        'servicedesk-queues-custom-view': 1,
        ...(0, $4cTDP.fg)('jira_list_nin_merge') ? {
            'software-list-nin': 1,
            'classic-list-nin': 1,
            'jwm-list-nin': 1,
            'jsm-list-nin': 1
        } : {
            'software-issue-navigator': 1,
            'issue-navigator-classic': 1,
            'issue-navigator-core': 1,
            'servicedesk-issues': 1
        },
        'assets-app-landing-page': 1,
        'assets-schema': 1,
        'service-management.insight-cmdb.object-view-page-load': 1
    };
    const ssrWhitelist = [
        'global-new-issue-navigator',
        'global-issue-navigator-jfe',
        'issue-view',
        'issue-view-software',
        'issue-view-serviceDesk',
        'issue-view-embed',
        'classic-board',
        'classic-backlog',
        'next-gen-backlog',
        ...(0, $4cTDP.fg)('jira_list_nin_merge') ? [
            'software-list-nin',
            'classic-list-nin',
            'jwm-list-nin',
            'jsm-list-nin'
        ] : [
            'software-issue-navigator',
            'issue-navigator-classic',
            'issue-navigator-core',
            'servicedesk-issues'
        ]
    ];
    const assetsConfig = {
        classification: {
            all: true,
            allAtlassian: ({ entry: entry })=>{
                const isAtlassian = entry.name.includes('atl-paas.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js');
                return isAtlassian;
            },
            preloaded: ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
                return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
            }
        }
    };
    (0, $h5y7n.init)($10fcd8375fcf033e$var$loadJiraAnalyticsWebClient(), {
        ...ufoConfigFromFF,
        enableSegmentHighlighting: false,
        enableAdditionalPerformanceMarks: false,
        product: 'jira',
        region: (0, $hWeHP.default)('ajs-region') || 'unknown',
        additionalPayloadData: $10fcd8375fcf033e$var$getAdditionalJiraFields,
        postInteractionLog: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        experimentalInteractionMetrics: {
            enabled: false,
            rates: perfPushExperienceRates
        },
        extraInteractionMetrics: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        manuallyTrackReactProfilerMounts: true,
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: (0, $4cTDP.fg)('uip_vc_devtools'),
            selectorConfig: {
                id: true,
                role: false,
                className: true,
                testId: false // Cannot be enabled due to some testid attributes containing UGC. Use data-vc instead.
            },
            ssr: (0, $4cTDP.fg)('uip_vc_ssr'),
            ssrWhitelist: ssrWhitelist,
            ssrEnablePageLayoutPlaceholder: true,
            stopVCAtInteractionFinish: false,
            includeSSRInV3: true,
            includeSSRRatio: true,
            enabledVCRevisions: {
                all: [
                    'fy25.03'
                ]
            }
        },
        enableBetterPageVisibilityApi: true,
        assetsConfig: assetsConfig,
        getReactHydrationStats: $8aMsX.getReactHydrationStats
    });
}

});
parcelRegister("lDihq", function(module, exports) {
$parcel$export(module.exports, "configure", () => $ef37416f391f8125$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $ef37416f391f8125$export$2eda1519e91a4386);

var $8IWpZ = parcelRequire("8IWpZ");
let $ef37416f391f8125$var$config = null;
function $ef37416f391f8125$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $ef37416f391f8125$var$config = bundleEvalTimingConfiguration;
}
function $ef37416f391f8125$var$getPerformanceObject() {
    return (window ?? {}).performance;
}
function $ef37416f391f8125$export$2eda1519e91a4386(interactionStartTime) {
    if ($ef37416f391f8125$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $ef37416f391f8125$var$config;
    const performance = $ef37416f391f8125$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $8IWpZ.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $8IWpZ.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("8IWpZ", function(module, exports) {
$parcel$export(module.exports, "roundEpsilon", () => $8f6811d6996df949$export$56014375de40214b);
function $8f6811d6996df949$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("h5y7n", function(module, exports) {
$parcel$export(module.exports, "init", () => $1df42c900971d220$export$2cd8252107eb640b);

var $eGOwo = parcelRequire("eGOwo");

var $65RK5 = parcelRequire("65RK5");

var $jcIvM = parcelRequire("jcIvM");

var $2OYCL = parcelRequire("2OYCL");

var $3HUqK = parcelRequire("3HUqK");

var $8tW4o = parcelRequire("8tW4o");

var $2QO3b = parcelRequire("2QO3b");

var $lVvr6 = parcelRequire("lVvr6");

var $3jJlZ = parcelRequire("3jJlZ");

var $dbr7k = parcelRequire("dbr7k");
let $1df42c900971d220$var$initialized = false;
function $1df42c900971d220$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $dbr7k.default)(onIdle);
    }
    (0, $2QO3b.sinkInteractionHandler)(sinkFn);
}
function $1df42c900971d220$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            const payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then((payload)=>{
                if (payload) {
                    if ((0, $eGOwo.fg)('enable_ufo_devtools_api_for_extra_events')) {
                        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                        const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                        if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    }
                    instance.sendOperationalEvent(payload);
                }
            });
        }
        (0, $dbr7k.default)(experimentalMetricsOnIdle);
    }
    (0, $2OYCL.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $1df42c900971d220$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $2QO3b.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $dbr7k.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                if ((0, $eGOwo.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}
function $1df42c900971d220$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $2QO3b.interactionExtraMetrics).sinkHandler((interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult)=>{
        (0, $dbr7k.default)(async ()=>{
            const payload = await createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                if ((0, $eGOwo.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}
function $1df42c900971d220$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $dbr7k.default)(onIdle);
    }
    (0, $3HUqK.sinkExtraSearchPageInteractionHandler)(sinkFn);
}



function $1df42c900971d220$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($1df42c900971d220$var$initialized) return;
    // Initialize pressure observer for CPU usage monitoring
    (0, $3jJlZ.initialisePressureObserver)();
    (0, $3jJlZ.initialiseMemoryObserver)();
    (0, $jcIvM.setUFOConfig)(config);
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder
        };
        (0, $2QO3b.postInteractionLog).initializeVCObserver(vcOptions);
        if (config?.experimentalInteractionMetrics?.enabled) (0, $2OYCL.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
        if (config?.extraInteractionMetrics?.enabled) (0, $2QO3b.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $8tW4o.setupHiddenTimingCapture)();
    (0, $65RK5.startLighthouseObserver)();
    $1df42c900971d220$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $lVvr6.getPerformanceObserver)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("humBS")),
        (parcelRequire("1YV1v")),
        (parcelRequire("1BfsL"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createInteractionExtraMetricsPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $1df42c900971d220$var$sinkInteraction(instance, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $1df42c900971d220$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if (config.postInteractionLog?.enabled) $1df42c900971d220$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config?.extraInteractionMetrics?.enabled && (0, $eGOwo.fg)('platform_ufo_enable_ttai_with_3p')) $1df42c900971d220$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $1df42c900971d220$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $1df42c900971d220$var$sinkInteraction(awc, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $1df42c900971d220$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if (config.postInteractionLog?.enabled) $1df42c900971d220$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config?.extraInteractionMetrics?.enabled && (0, $eGOwo.fg)('platform_ufo_enable_ttai_with_3p')) $1df42c900971d220$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $1df42c900971d220$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}

});
parcelRegister("65RK5", function(module, exports) {
$parcel$export(module.exports, "startLighthouseObserver", () => $9259893b7016aa23$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $9259893b7016aa23$export$b46cecdf698e4bb5);

var $gWpZp = parcelRequire("gWpZp");

var $iefjQ = parcelRequire("iefjQ");

var $jDzFt = parcelRequire("jDzFt");

var $2wIND = parcelRequire("2wIND");

var $3WrFT = parcelRequire("3WrFT");
function $9259893b7016aa23$export$5ecf2aafafee3e0() {
    (0, $3WrFT.startLSObserver)();
    (0, $3WrFT.startLTObserver)();
}
function $9259893b7016aa23$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $jDzFt.getTBT)(start, stop, (0, $2wIND.EntriesBuffer)[(0, $iefjQ.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $gWpZp.getCLS)(start, stop, (0, $2wIND.EntriesBuffer)[(0, $iefjQ.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("gWpZp", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $0949652481ecc643$export$fc6227831ee7c7);

var $eGOwo = parcelRequire("eGOwo");
function $0949652481ecc643$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $0949652481ecc643$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $eGOwo.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            const allSourcesHaveSameRects = entry?.sources?.every(({ previousRect: previousRect, currentRect: currentRect })=>$0949652481ecc643$var$isSameRects(previousRect, currentRect));
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("iefjQ", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $4cec60e2c8ba8e79$export$a4def92db6fc8e17);
const $4cec60e2c8ba8e79$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("jDzFt", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $7afe62d6b8ce320b$export$2d6e933b35bd3407);
const $7afe62d6b8ce320b$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $7afe62d6b8ce320b$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $7afe62d6b8ce320b$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $7afe62d6b8ce320b$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $7afe62d6b8ce320b$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("2wIND", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $84620d5f02591e2c$export$f7dc16cbd16f7bbe);

var $iefjQ = parcelRequire("iefjQ");
class $84620d5f02591e2c$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $84620d5f02591e2c$export$f7dc16cbd16f7bbe = {
    [(0, $iefjQ.PerformanceObserverEntryTypes).LongTask]: new $84620d5f02591e2c$export$2c6e86519c9e8188(),
    [(0, $iefjQ.PerformanceObserverEntryTypes).LayoutShift]: new $84620d5f02591e2c$export$2c6e86519c9e8188()
};

});

parcelRegister("3WrFT", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $eb72fd5a65b8b770$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $eb72fd5a65b8b770$export$54fb8b6aaf70ec9c);

var $iefjQ = parcelRequire("iefjQ");

var $2wIND = parcelRequire("2wIND");
let $eb72fd5a65b8b770$var$pe = null;
function $eb72fd5a65b8b770$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($eb72fd5a65b8b770$var$pe !== null) return $eb72fd5a65b8b770$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $iefjQ.PerformanceObserverEntryTypes).LayoutShift) (0, $2wIND.EntriesBuffer)[(0, $iefjQ.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $iefjQ.PerformanceObserverEntryTypes).LongTask) (0, $2wIND.EntriesBuffer)[(0, $iefjQ.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $eb72fd5a65b8b770$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $eb72fd5a65b8b770$var$pe;
}
function $eb72fd5a65b8b770$export$768ccc3ab7bac3ea() {
    $eb72fd5a65b8b770$var$getObserver()?.observe({
        type: (0, $iefjQ.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $eb72fd5a65b8b770$export$54fb8b6aaf70ec9c() {
    $eb72fd5a65b8b770$var$getObserver()?.observe({
        type: (0, $iefjQ.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("lVvr6", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserver", () => $3edb42123912b3fe$export$17afbba0f16b4b19);

var $2QO3b = parcelRequire("2QO3b");

var $hBP87 = parcelRequire("hBP87");
let $3edb42123912b3fe$var$performanceEventObserver;
const $3edb42123912b3fe$var$selectorConfig = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $3edb42123912b3fe$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $3edb42123912b3fe$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $3edb42123912b3fe$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($3edb42123912b3fe$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $3edb42123912b3fe$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $3edb42123912b3fe$export$17afbba0f16b4b19 = ()=>{
    $3edb42123912b3fe$var$performanceEventObserver = $3edb42123912b3fe$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $3edb42123912b3fe$export$e6be05b411ce21a6(entry);
    });
    return $3edb42123912b3fe$var$performanceEventObserver;
};
const $3edb42123912b3fe$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $2QO3b.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $3edb42123912b3fe$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $hBP87.default)($3edb42123912b3fe$var$selectorConfig, entry.target);
            }
        }
    }
};

});
parcelRegister("hBP87", function(module, exports) {
$parcel$export(module.exports, "default", () => $fee6acc1730593ae$export$2e2bcd8739ae039);
const $fee6acc1730593ae$var$nameCache = new WeakMap();
function $fee6acc1730593ae$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $fee6acc1730593ae$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (err) {
        return false;
    }
}
function $fee6acc1730593ae$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $fee6acc1730593ae$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $fee6acc1730593ae$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $fee6acc1730593ae$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $fee6acc1730593ae$var$getAttributeSelector(currentElement, 'data-testid') || $fee6acc1730593ae$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $fee6acc1730593ae$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($fee6acc1730593ae$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $fee6acc1730593ae$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$fee6acc1730593ae$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $fee6acc1730593ae$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $fee6acc1730593ae$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $fee6acc1730593ae$var$getUniqueSelector(selectorConfig, element);
    $fee6acc1730593ae$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $fee6acc1730593ae$export$2e2bcd8739ae039 = $fee6acc1730593ae$var$getElementName;

});


parcelRegister("3jJlZ", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $a2514f8aaf7de69b$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $a2514f8aaf7de69b$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $a2514f8aaf7de69b$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $a2514f8aaf7de69b$export$a3271f53e91faab7);
const $a2514f8aaf7de69b$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $a2514f8aaf7de69b$var$pressureRecordBuffer = [];
let $a2514f8aaf7de69b$var$pressureObserver = null;
let $a2514f8aaf7de69b$var$memoryRecordBuffer = [];
let $a2514f8aaf7de69b$var$memoryInterval;
function $a2514f8aaf7de69b$export$6c1060bed5fea050() {
    $a2514f8aaf7de69b$var$pressureRecordBuffer.length = 0;
}
function $a2514f8aaf7de69b$export$aa672c7221b183b0() {
    $a2514f8aaf7de69b$var$memoryRecordBuffer.length = 0;
}
function $a2514f8aaf7de69b$export$ec86686c1d2e65bc(filter) {
    $a2514f8aaf7de69b$var$pressureRecordBuffer = $a2514f8aaf7de69b$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $a2514f8aaf7de69b$export$c0142ac82f5d0c28(filter) {
    $a2514f8aaf7de69b$var$memoryRecordBuffer = $a2514f8aaf7de69b$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $a2514f8aaf7de69b$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $a2514f8aaf7de69b$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $a2514f8aaf7de69b$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $a2514f8aaf7de69b$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $a2514f8aaf7de69b$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $a2514f8aaf7de69b$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $a2514f8aaf7de69b$var$convertBytesToMegabytes($a2514f8aaf7de69b$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            avgTotalJSHeapSizeInMB: $a2514f8aaf7de69b$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $a2514f8aaf7de69b$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $a2514f8aaf7de69b$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $a2514f8aaf7de69b$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $a2514f8aaf7de69b$var$pressureObserver = new PressureObserver((records)=>{
                if ($a2514f8aaf7de69b$var$pressureRecordBuffer.length + records.length <= $a2514f8aaf7de69b$var$BUFFER_MAX_LENGTH) $a2514f8aaf7de69b$var$pressureRecordBuffer.push(...records);
            });
            $a2514f8aaf7de69b$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (err) {
    /* do nothing, this is a best efforts metric */ }
}
function $a2514f8aaf7de69b$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $a2514f8aaf7de69b$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($a2514f8aaf7de69b$var$memoryRecordBuffer.length <= $a2514f8aaf7de69b$var$BUFFER_MAX_LENGTH) $a2514f8aaf7de69b$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $a2514f8aaf7de69b$export$10899ada382f2ae3() {
    clearInterval($a2514f8aaf7de69b$var$memoryInterval);
}
function $a2514f8aaf7de69b$export$b9fdd785f0fc1d40() {
    $a2514f8aaf7de69b$var$pressureObserver?.disconnect();
}

});

parcelRegister("dbr7k", function(module, exports) {
$parcel$export(module.exports, "default", () => $52fc234e0baf81e8$export$2e2bcd8739ae039);

var $jbhXM = parcelRequire("jbhXM");

var $eGOwo = parcelRequire("eGOwo");
function $52fc234e0baf81e8$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $eGOwo.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_IdlePriority), work);
}
var $52fc234e0baf81e8$export$2e2bcd8739ae039 = $52fc234e0baf81e8$var$scheduleIdleCallback;

});

parcelRegister("humBS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eSJmw").then(()=>parcelRequire('9TcxU'));

});

parcelRegister("1YV1v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cW6Dc").then(()=>parcelRequire('9MIqa'));

});

parcelRegister("1BfsL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9tg3y").then(()=>parcelRequire('brb3w'));

});


parcelRegister("53lbp", function(module, exports) {
$parcel$export(module.exports, "configure", () => $e21ca2f7e485b7e8$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $e21ca2f7e485b7e8$export$44487a86467333c3);

var $jcIvM = parcelRequire("jcIvM");
const $e21ca2f7e485b7e8$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $e21ca2f7e485b7e8$var$getAllowedParams() {
    const config = (0, $jcIvM.getConfig)();
    return config?.allowedResourcesParams || $e21ca2f7e485b7e8$var$defaultAllowedParams;
}
function $e21ca2f7e485b7e8$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $e21ca2f7e485b7e8$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
}
let $e21ca2f7e485b7e8$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $e21ca2f7e485b7e8$var$handleQueryParams(url);
    }
};
function $e21ca2f7e485b7e8$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $e21ca2f7e485b7e8$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $e21ca2f7e485b7e8$var$config = newConfig;
}
function $e21ca2f7e485b7e8$export$44487a86467333c3() {
    return $e21ca2f7e485b7e8$var$config;
}

});

parcelRegister("8F7u9", function(module, exports) {
$parcel$export(module.exports, "startResourceTimingBuffer", () => $55a6d0be7f5d2150$export$a311cb1baa7d2d62);

var $gzgMP = parcelRequire("gzgMP");
function $55a6d0be7f5d2150$export$a311cb1baa7d2d62() {
    (0, $gzgMP.resourceTimingBuffer).start();
}

});
parcelRegister("gzgMP", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $b75a77abbae91d5b$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $b75a77abbae91d5b$export$4138a729ef1db028);

var $8IWpZ = parcelRequire("8IWpZ");
const $b75a77abbae91d5b$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $b75a77abbae91d5b$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $b75a77abbae91d5b$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $8IWpZ.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $8IWpZ.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $8IWpZ.roundEpsilon)(entry.startTime),
            duration: (0, $8IWpZ.roundEpsilon)(entry.duration),
            fetchStart: (0, $8IWpZ.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $8IWpZ.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $8IWpZ.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $8IWpZ.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $8IWpZ.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $8IWpZ.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $b75a77abbae91d5b$var$getPerformanceObject();
        const PerformanceObserver = $b75a77abbae91d5b$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($b75a77abbae91d5b$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $b75a77abbae91d5b$export$bea963256235a63e.timings = resources.map((resource)=>$b75a77abbae91d5b$export$bea963256235a63e.transformResource(resource));
        $b75a77abbae91d5b$export$bea963256235a63e.observer = new PerformanceObserver($b75a77abbae91d5b$export$bea963256235a63e.addTimings);
        $b75a77abbae91d5b$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($b75a77abbae91d5b$export$bea963256235a63e.observer) {
            $b75a77abbae91d5b$export$bea963256235a63e.observer.disconnect();
            $b75a77abbae91d5b$export$bea963256235a63e.observer = null;
        }
        $b75a77abbae91d5b$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$b75a77abbae91d5b$export$bea963256235a63e.transformResource(entry));
        const overflow = $b75a77abbae91d5b$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $b75a77abbae91d5b$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $b75a77abbae91d5b$export$bea963256235a63e.maxSize;
            $b75a77abbae91d5b$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $b75a77abbae91d5b$export$bea963256235a63e.timings.push(...entries);
    }
};
function $b75a77abbae91d5b$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $b75a77abbae91d5b$export$4138a729ef1db028(startTime, endTime) {
    const performance = $b75a77abbae91d5b$var$getPerformanceObject();
    const PerformanceObserver = $b75a77abbae91d5b$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$b75a77abbae91d5b$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$b75a77abbae91d5b$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $b75a77abbae91d5b$export$bea963256235a63e.timings.filter((timing)=>$b75a77abbae91d5b$var$isValidTiming(timing, startTime, endTime));
}

});


parcelRegister("gA3op", function(module, exports) {
$parcel$export(module.exports, "configure", () => $b65e54b4ec190147$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $b65e54b4ec190147$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $b65e54b4ec190147$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $b65e54b4ec190147$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $b65e54b4ec190147$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $b65e54b4ec190147$export$1c4a9b5e6e22393d);
//
const $b65e54b4ec190147$var$NESTED_METRIC_SEPARATOR = '/';
function $b65e54b4ec190147$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $b65e54b4ec190147$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $b65e54b4ec190147$var$SSR_PREFIX = 'ssr';
function $b65e54b4ec190147$var$mapKey(key) {
    if (key === 'total') return $b65e54b4ec190147$var$SSR_PREFIX;
    return `${$b65e54b4ec190147$var$SSR_PREFIX}${$b65e54b4ec190147$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $b65e54b4ec190147$var$config;
function $b65e54b4ec190147$export$8d21e34596265fa2(ssrConfig) {
    $b65e54b4ec190147$var$config = ssrConfig;
}
function $b65e54b4ec190147$export$bf7408e83532dcd0() {
    if (!$b65e54b4ec190147$var$config?.getTimings) return {};
    const timings = $b65e54b4ec190147$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($b65e54b4ec190147$var$filterEntry(entry[1])) acc[$b65e54b4ec190147$var$mapKey(entry[0])] = $b65e54b4ec190147$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $b65e54b4ec190147$export$c7ad864055e75537() {
    return !!$b65e54b4ec190147$var$config?.getDoneMark();
}
function $b65e54b4ec190147$export$5eade9354185583d() {
    return $b65e54b4ec190147$var$config?.getSsrPhaseSuccess?.();
}
function $b65e54b4ec190147$export$3def7672244bab0c() {
    return $b65e54b4ec190147$var$config?.getDoneMark() ?? undefined;
}
function $b65e54b4ec190147$export$1c4a9b5e6e22393d() {
    if (!$b65e54b4ec190147$var$config?.getFeatureFlags) return undefined;
    try {
        return $b65e54b4ec190147$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("dJnTE", function(module, exports) {
$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $166f16e8188a91a6$export$1a71d2bbe236de99);

var $fiPhB = parcelRequire("fiPhB");
let $166f16e8188a91a6$var$alreadySet = false;
const $166f16e8188a91a6$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $166f16e8188a91a6$var$alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention
    $166f16e8188a91a6$var$alreadySet = true;
    (0, $fiPhB.setActiveTrace)(traceId, spanId, 'page_load');
};

});

parcelRegister("fr3kC", function(module, exports) {
$parcel$export(module.exports, "getJiraCustomData", () => $5ce5f5978f364e3d$export$abf5e20822fa925);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");

var $6D8kE = parcelRequire("6D8kE");

var $4cTDP = parcelRequire("4cTDP");

var $lljYo = parcelRequire("lljYo");

var $iOidG = parcelRequire("iOidG");

var $lWXph = parcelRequire("lWXph");

var $9AJAX = parcelRequire("9AJAX");

var $jFb3w = parcelRequire("jFb3w");

var $3PCW7 = parcelRequire("3PCW7");

var $1WYrZ = parcelRequire("1WYrZ");

var $9Bk0W = parcelRequire("9Bk0W");

var $gazJI = parcelRequire("gazJI");

var $lNtvH = parcelRequire("lNtvH");

var $cW2IQ7 = parcelRequire("cW2IQ7");

var $ez7Oj = parcelRequire("ez7Oj");

function $5ce5f5978f364e3d$export$abf5e20822fa925(interaction) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const shard = (0, $hWeHP.default)('ajs-shard');
    if (shard !== null && shard !== '') customData.shard = shard;
    if ((0, $4cTDP.fg)('add_editions_to_bm3_splunk_events')) customData['jira:productEditions'] = (0, $6D8kE.getProductEditions)();
    customData['network:assetEncoding'] = (0, $lljYo.getAssetEncoding)();
    if ((0, $4cTDP.fg)('jira-enable-sticky-versions-state')) customData['stickyVersions:state'] = (0, $cW2IQ7.getStickyVersionsState)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const buildVariant = window.BUILD_VARIANT;
    if (buildVariant) customData['app:buildVariant'] = buildVariant;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const bundlerVersion = window.BUNDLER_VERSION;
    if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
    customData.httpProtocol = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = apdex?.[0]?.stopTime ?? end;
    customData.memory = (0, $3PCW7.getMemoryUsageReport)({
        start: start,
        stop: stop
    });
    const lightHouseMetrics = (0, $9AJAX.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $jFb3w.getMarks)({
            start: start
        }),
        ...(0, $1WYrZ.getPageSizeMetrics)(),
        ...(0, $1WYrZ.getExtraNavigationTimings)(),
        ...(0, $1WYrZ.getPopInfo)(),
        ...(0, $gazJI.getServerDurationMetrics)(),
        ...(0, $9Bk0W.getRouterResourceMetrics)(),
        ...(0, $ez7Oj.getWRMStats)(),
        ...(0, $1WYrZ.getPageSizeInfo)({
            start: start,
            stop: stop
        }),
        ...(0, $iOidG.getCacheHitRatio)({
            start: start
        }),
        ...(0, $lWXph.getCHRInfo)({
            start: start
        }),
        ...(0, $lNtvH.getSSRStateInformation)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:web': window.BUILD_KEY,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:ssr': window.SSR_BUILD_KEY,
        'app:framework:name': 'react',
        'app:framework:version': (0, $eJOHy.version)
    };
    return customData;
}

});
parcelRegister("lljYo", function(module, exports) {
$parcel$export(module.exports, "getAssetEncoding", () => $27d15571baf4b0ce$export$fd12d8f45e126585);
function $27d15571baf4b0ce$export$fd12d8f45e126585() {
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
}

});

parcelRegister("iOidG", function(module, exports) {
$parcel$export(module.exports, "getCacheHitRatio", () => $76f0e76729b8d413$export$e8a9322c3d9da8a6);

var $gPCSe = parcelRequire("gPCSe");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $76f0e76729b8d413$var$cacheableTypes = [
    'script',
    'link'
];
const $76f0e76729b8d413$var$CACHE_NETWORK = 'network';
const $76f0e76729b8d413$var$CACHE_MEMORY = 'memory';
const $76f0e76729b8d413$var$CACHE_DISK = 'disk';
const $76f0e76729b8d413$var$calculateTransferType = (type, duration, size)=>{
    if (!$76f0e76729b8d413$var$cacheableTypes.includes(type)) return $76f0e76729b8d413$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $76f0e76729b8d413$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $76f0e76729b8d413$var$CACHE_DISK;
    if (size === undefined) return null;
    return $76f0e76729b8d413$var$CACHE_NETWORK;
};
const $76f0e76729b8d413$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $gPCSe.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $76f0e76729b8d413$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("lWXph", function(module, exports) {
$parcel$export(module.exports, "getCHRInfo", () => $c5f6b93bd3bec9a0$export$9e005e111be93521);

var $6uWhG = parcelRequire("6uWhG");

var $gPCSe = parcelRequire("gPCSe");

var $4kxH2 = parcelRequire("4kxH2");
const $c5f6b93bd3bec9a0$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
const $c5f6b93bd3bec9a0$export$1faf7d001841a41c = ()=>(0, $6uWhG.getMark)($c5f6b93bd3bec9a0$var$SPA_SSR_RENDERED)?.startTime || null;
const $c5f6b93bd3bec9a0$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = $c5f6b93bd3bec9a0$export$1faf7d001841a41c();
    const reporter = new (0, $4kxH2.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $gPCSe.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("4kxH2", function(module, exports) {
$parcel$export(module.exports, "CHRReporter", () => $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5);

var $4cTDP = parcelRequire("4cTDP");

var $l1DmX = parcelRequire("l1DmX");
class $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $l1DmX.CHRSummary)();
        this.all = new (0, $l1DmX.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    isPreloaded(item) {
        const isPreloadedByLink = item.initiatorType === 'link';
        const isPreloadedByPreloadModule = item.initiatorType === 'other' && item.name?.endsWith('.js') && (0, $4cTDP.fg)('ufo_support_other_resource_type_js');
        const isBeforeSSR = this.ssrMark === null || item.startTime < this.ssrMark;
        return (isPreloadedByLink || isPreloadedByPreloadModule) && isBeforeSSR;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (this.isPreloaded(item)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $l1DmX.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $l1DmX.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $l1DmX.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $l1DmX.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $l1DmX.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.size[(0, $l1DmX.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.size[(0, $l1DmX.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.size[(0, $l1DmX.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round((summary.size[(0, $l1DmX.CHRSummary).MEMORY_KEY] + summary.size[(0, $l1DmX.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("l1DmX", function(module, exports) {
$parcel$export(module.exports, "CHRSummary", () => $3c79d159e0d06a6e$export$783d6618ee601ba);

var $4cTDP = parcelRequire("4cTDP");

var $gExqZ = parcelRequire("gExqZ");
const $3c79d159e0d06a6e$var$calculateTransferType = (name, type, duration, size)=>{
    if ((0, $4cTDP.fg)('ufo_support_other_resource_type_js')) {
        if (!(0, $gExqZ.cacheableTypes).includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    } else if (!(0, $gExqZ.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $3c79d159e0d06a6e$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $3c79d159e0d06a6e$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $3c79d159e0d06a6e$export$783d6618ee601ba.NETWORK_KEY;
};
class $3c79d159e0d06a6e$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $3c79d159e0d06a6e$var$calculateTransferType(item.name, item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$3c79d159e0d06a6e$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$3c79d159e0d06a6e$export$783d6618ee601ba.DISK_KEY]: 0,
            [$3c79d159e0d06a6e$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$3c79d159e0d06a6e$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$3c79d159e0d06a6e$export$783d6618ee601ba.DISK_KEY]: 0,
            [$3c79d159e0d06a6e$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});
parcelRegister("gExqZ", function(module, exports) {
$parcel$export(module.exports, "cacheableTypes", () => $f324d115aacd75a4$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $f324d115aacd75a4$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});




parcelRegister("9AJAX", function(module, exports) {
$parcel$export(module.exports, "getLighthouseMetrics", () => $a79abade65277647$export$b46cecdf698e4bb5);

var $epCa1 = parcelRequire("epCa1");

var $gq4ol = parcelRequire("gq4ol");

var $2fQed = parcelRequire("2fQed");

var $lxjbw = parcelRequire("lxjbw");

var $5x5TB = parcelRequire("5x5TB");
function $a79abade65277647$export$5ecf2aafafee3e0() {
    (0, $5x5TB.startLSObserver)();
    (0, $5x5TB.startLTObserver)();
}
const $a79abade65277647$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $2fQed.getTBT)(start, stop, (0, $lxjbw.EntriesBuffer)[(0, $gq4ol.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $epCa1.getCLS)(start, stop, (0, $lxjbw.EntriesBuffer)[(0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("epCa1", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $d51104bb73b57a01$export$fc6227831ee7c7);
const $d51104bb73b57a01$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("gq4ol", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $48ac00c98bd8deae$export$a4def92db6fc8e17);
const $48ac00c98bd8deae$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("2fQed", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $5738f807e7f6fecd$export$2d6e933b35bd3407);
const $5738f807e7f6fecd$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $5738f807e7f6fecd$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $5738f807e7f6fecd$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $5738f807e7f6fecd$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $5738f807e7f6fecd$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("lxjbw", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $8fd43ee617db15bf$export$f7dc16cbd16f7bbe);

var $gq4ol = parcelRequire("gq4ol");
class $8fd43ee617db15bf$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $8fd43ee617db15bf$export$f7dc16cbd16f7bbe = {
    [(0, $gq4ol.PerformanceObserverEntryTypes).LongTask]: new $8fd43ee617db15bf$export$2c6e86519c9e8188(),
    [(0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift]: new $8fd43ee617db15bf$export$2c6e86519c9e8188()
};

});

parcelRegister("5x5TB", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $7158250d94157eec$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $7158250d94157eec$export$54fb8b6aaf70ec9c);

var $gq4ol = parcelRequire("gq4ol");

var $lxjbw = parcelRequire("lxjbw");
let $7158250d94157eec$var$pe = null;
const $7158250d94157eec$var$getObserver = ()=>{
    if ($7158250d94157eec$var$pe !== null) return $7158250d94157eec$var$pe;
    $7158250d94157eec$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift) (0, $lxjbw.EntriesBuffer)[(0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $gq4ol.PerformanceObserverEntryTypes).LongTask) (0, $lxjbw.EntriesBuffer)[(0, $gq4ol.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $7158250d94157eec$var$pe;
};
const $7158250d94157eec$export$768ccc3ab7bac3ea = ()=>{
    $7158250d94157eec$var$getObserver().observe({
        type: (0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $7158250d94157eec$export$54fb8b6aaf70ec9c = ()=>{
    $7158250d94157eec$var$getObserver().observe({
        type: (0, $gq4ol.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("jFb3w", function(module, exports) {
$parcel$export(module.exports, "getMarks", () => $940b3a1e7fc495e4$export$9d952633c9c2237b);

var $a5R5f = parcelRequire("a5R5f");

var $75yrv = parcelRequire("75yrv");
const $940b3a1e7fc495e4$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $a5R5f.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $75yrv.JS_EVAL_START)) && !item.name.endsWith((0, $75yrv.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};

});

parcelRegister("3PCW7", function(module, exports) {
$parcel$export(module.exports, "getMemoryUsageReport", () => $c5120b7ccc20410f$export$e5bd2d61c7c80651);
/**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */ const $c5120b7ccc20410f$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const sessionTime = Math.round(stop - start);
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("1WYrZ", function(module, exports) {
$parcel$export(module.exports, "getPageSizeMetrics", () => $2005cb261e5ca356$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $2005cb261e5ca356$export$b37a70af06e58097);
$parcel$export(module.exports, "getPopInfo", () => $2005cb261e5ca356$export$e590d0a3e226abd8);
$parcel$export(module.exports, "getPageSizeInfo", () => $2005cb261e5ca356$export$b72e035af6568be7);

var $gPCSe = parcelRequire("gPCSe");

var $4cTDP = parcelRequire("4cTDP");
// Helper function to safely access globalThis.bifrostPayloadStats
const $2005cb261e5ca356$var$getBifrostPayloadStats = ()=>{
    // @ts-expect-error - globalThis.bifrostPayloadStats is not in standard TypeScript definitions
    return globalThis.bifrostPayloadStats;
};
const $2005cb261e5ca356$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $2005cb261e5ca356$export$b37a70af06e58097 = ()=>{
    if (!(0, $gPCSe.default)) return {};
    const navigation = (0, $gPCSe.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $2005cb261e5ca356$export$e590d0a3e226abd8 = ()=>{
    if (!(0, $gPCSe.default)) return {};
    const navigation = (0, $gPCSe.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    if ((0, $4cTDP.fg)('jira-ufo-add-cf-info')) return {
        // From https://www.w3.org/TR/navigation-timing-2/
        atlEdgePop: // @ts-expect-error - TS2339 - Property 'serverTiming' does not exist on type 'PerformanceEntry'.
        navigation.serverTiming?.find((entry)=>entry?.name === 'atl-edge-pop')?.description ?? undefined,
        cfPop: // @ts-expect-error - TS2339 - Property 'serverTiming' does not exist on type 'PerformanceEntry'.
        navigation.serverTiming?.find((entry)=>entry?.name === 'cdn-pop')?.description ?? undefined
    };
    return {};
};
const $2005cb261e5ca356$var$assetsTypes = [
    'script',
    'link'
];
const $2005cb261e5ca356$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $2005cb261e5ca356$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $gPCSe.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($2005cb261e5ca356$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    const bifrostStats = (0, $4cTDP.fg)('jira-enable-page-size-reporting') && $2005cb261e5ca356$var$getBifrostPayloadStats();
    if (bifrostStats) {
        const sizeSplit = {};
        returnValue['size:split'] = sizeSplit;
        const labelsToCheck = [
            'preHtml',
            'serverToClientEvents',
            'featureFlags',
            'wrmResources',
            'serverPerfTrace',
            'preloadAssets',
            'preloadTags',
            'statsigGateValues',
            'earlyFeatureFlags',
            'inlineScripts',
            'contextualPreload',
            'contextualState',
            'earlyEntryScript',
            'inlineCss',
            'langPackPreloads',
            'langPackScripts',
            'externalScripts',
            'metaTags',
            'lazyPreloads',
            'spaHtml'
        ];
        labelsToCheck.forEach((label)=>{
            const value = bifrostStats[label];
            if (typeof value === 'number') sizeSplit[label] = value;
        });
    }
    return returnValue;
};

});

parcelRegister("9Bk0W", function(module, exports) {
$parcel$export(module.exports, "getRouterResourceMetrics", () => $032bf7e051288f2e$export$e703af446a67c7f4);
const $032bf7e051288f2e$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("gazJI", function(module, exports) {
$parcel$export(module.exports, "getServerDurationMetrics", () => $49816a5f0a3b573a$export$efd8b60b870e5282);
const $49816a5f0a3b573a$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("lNtvH", function(module, exports) {
$parcel$export(module.exports, "getSSRStateInformation", () => $2a69d4614f226c2e$export$9a46186893ad76bd);

var $6uWhG = parcelRequire("6uWhG");
const $2a69d4614f226c2e$var$getState = ()=>{
    if ((0, $6uWhG.getMark)('ssr.spa.state')?.startTime) return 'success';
    if ((0, $6uWhG.getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
    return 'static-fallback';
};
const $2a69d4614f226c2e$export$9a46186893ad76bd = ()=>{
    return {
        'ssr:state': $2a69d4614f226c2e$var$getState()
    };
};

});

parcelRegister("cW2IQ7", function(module, exports) {
$parcel$export(module.exports, "getStickyVersionsState", () => $75856b2df16f29bd$export$4ace2d93f0a81ca0);
const $75856b2df16f29bd$export$4ace2d93f0a81ca0 = ()=>{
    const stickyVersionState = globalThis.STICKY_VERSION_STATE ?? 'na';
    return stickyVersionState;
};

});

parcelRegister("ez7Oj", function(module, exports) {
$parcel$export(module.exports, "getWRMStats", () => $bc580539ac7c2d61$export$d2d916ddd03b82bc);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc580539ac7c2d61$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("gbSLd", function(module, exports) {
$parcel$export(module.exports, "jiraBundleEvalTimingsConfig", () => $983d24632a68c58b$export$791b8c0cbd574ea9);

var $75yrv = parcelRequire("75yrv");
const $983d24632a68c58b$export$791b8c0cbd574ea9 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $75yrv.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $75yrv.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $75yrv.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $75yrv.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("eL1MK", function(module, exports) {
$parcel$export(module.exports, "jiraResourceTimingsConfig", () => $62857d62cfaca9d3$export$8fa71550bcdc2104);

var $3Q6BV = parcelRequire("3Q6BV");

var $hVEQH = parcelRequire("hVEQH");
const $62857d62cfaca9d3$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $62857d62cfaca9d3$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $hVEQH.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $62857d62cfaca9d3$var$getFileName = (url)=>$62857d62cfaca9d3$var$isWRMResource(url) ? $62857d62cfaca9d3$var$getWRMAssetName(url) : (0, $hVEQH.sanitiseAssetName)(false)(url);
const $62857d62cfaca9d3$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, true);
    /**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */ const { operation: operation, operationName: operationName } = parsedUrl.query;
    const operationNameOverride = operation ?? operationName;
    if (operationNameOverride) return `/${operation}?operation=${operation}`;
    const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
    return fileName;
};
const $62857d62cfaca9d3$export$8fa71550bcdc2104 = {
    sanitiseEndpoints: $62857d62cfaca9d3$var$sanitiseEndpoints,
    mapResources: $62857d62cfaca9d3$var$getFileName,
    hasTimingHeaders: (url)=>url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $62857d62cfaca9d3$var$isWRMResource(url),
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});

parcelRegister("87apk", function(module, exports) {
$parcel$export(module.exports, "jiraSsrConfig", () => $4cf88641c7b36da7$export$7bcf91e323db67dd);

var $fqICx = parcelRequire("fqICx");

var $6uWhG = parcelRequire("6uWhG");

var $gPCSe = parcelRequire("gPCSe");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

/** given a timings object, add a timer that starts at the earliest start time and ends at the latest end time */ function $4cf88641c7b36da7$var$insertTotalTiming(/**
	 * key of the total timing that will be inserted to the given timings object
	 */ key, timings) {
    const timingValues = timings && Object.values(timings);
    if (!timingValues || !timingValues.length) return timings;
    const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
    const endTime = timingValues.reduce((max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
    const duration = endTime - startTime;
    // eslint-disable-next-line no-param-reassign
    timings[key] = {
        startTime: startTime,
        duration: duration
    };
    return timings;
}
/**
 * Apply key and startTimOffset overrides to a timings object
 */ function $4cf88641c7b36da7$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
    return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
        const startTime = value.startTime + startTimeOffsetMs;
        return [
            [
                prefix,
                key
            ].filter(Boolean).join('/'),
            {
                ...value,
                startTime: startTime
            }
        ];
    }));
}
function $4cf88641c7b36da7$var$getTesseractTimings() {
    if (!globalThis.SPA_STATE) return null;
    const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
    const detailRelayFetch = globalThis.SPA_STATE['ssr/relay_fetch'];
    const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
    const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) {
            // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
            const totalKey = '';
            timings[totalKey] = {
                startTime: 0,
                duration: highLevelMetrics.data.ssrTotal
            };
        }
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRequestTrace?.data || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    if (detailRelayFetch) {
        const relayFetchTimings = Object.fromEntries(Object.entries(detailRelayFetch ?? {}).map(([key, value])=>[
                `relay/${key}`,
                value
            ]));
        $4cf88641c7b36da7$var$insertTotalTiming('relay', relayFetchTimings);
        Object.assign(timings, relayFetchTimings);
    }
    let timingsWithContext = timings;
    // If there's a server-timing for tesseract, that represents the pre-work before script execution starts, referred to as contextGlobalsSetup
    const serverTimingsByName = $4cf88641c7b36da7$var$getServerTimingsByName();
    // This will become available when EDGE-8510 is complete
    const contextGlobalsSetup = serverTimingsByName.tesseract?.duration;
    if (contextGlobalsSetup != null) {
        timingsWithContext = $4cf88641c7b36da7$var$applyTimingOverrides(timings, {
            startTimeOffsetMs: contextGlobalsSetup
        });
        timingsWithContext && Object.assign(timingsWithContext, {
            contextGlobalsSetup: {
                startTime: 0,
                duration: contextGlobalsSetup
            }
        });
    }
    return $4cf88641c7b36da7$var$insertTotalTiming('', timingsWithContext); // while there is already a 'ssrTotal', it seems to exclude some timings, so we'll take the end to end as the actual total time
}
// add early-flush/ prefix to timing keys which are early flush timings
const $4cf88641c7b36da7$var$jiraFeGatewayEarlyFlushKeys = new Set([
    'metatags',
    'feature-flags',
    'statsig',
    'inline-assets',
    'async-inline-assets',
    'css-assets',
    'priority-assets',
    'early-route-flush'
]);
// and filter out these keys since they are not UFO visualisation friendly
const $4cf88641c7b36da7$var$jiraFeGatewayFilteredKeys = [
    'early-common-flush',
    'prerender-total',
    'resolve-assets'
];
function $4cf88641c7b36da7$var$getJiraFeGatewayTimings() {
    const rawTimings = globalThis._JFGTimings;
    if (!rawTimings) return null;
    const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$4cf88641c7b36da7$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
            $4cf88641c7b36da7$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
    return $4cf88641c7b36da7$var$insertTotalTiming(// there's no end to end timer so we calculate one
    '', jiraFeGatewayTimings);
}
function $4cf88641c7b36da7$var$getLegacyMonolithTimingDuration(timingMetricKey) {
    /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */ const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
    return Number(inputElementWithTimingValue?.value ?? 0);
}
function $4cf88641c7b36da7$var$getLegacyJiraMonolithTimings() {
    const duration = $4cf88641c7b36da7$var$getLegacyMonolithTimingDuration('jira.request.server.time');
    if (!duration) // if we don't have this, fallback to no jira timings, we might be going through bifrost instead
    return null;
    const timings = {
        // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
        '': {
            startTime: 0,
            duration: duration
        },
        'flush-head': {
            startTime: 0,
            duration: $4cf88641c7b36da7$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
        }
    };
    return timings;
}
const $4cf88641c7b36da7$var$monolithTimerRenames = {
    'jira-request-server-time': ''
};
function $4cf88641c7b36da7$var$getJiraMonolithTimings() {
    if (!globalThis._monolithTimings) return $4cf88641c7b36da7$var$getLegacyJiraMonolithTimings();
    return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
            $4cf88641c7b36da7$var$monolithTimerRenames[name] ?? name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
}
function $4cf88641c7b36da7$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
    if (jiraBeTimings || !tesseractTimings) return null;
    const serverTimingsByName = $4cf88641c7b36da7$var$getServerTimingsByName();
    // This will become available when EDGE-8510 is complete
    const bifrostInternal = serverTimingsByName.bifrost;
    const bifrostInternalDuration = bifrostInternal?.duration ?? 0;
    const timings = {
        ...bifrostInternal && {
            internal: {
                startTime: 0,
                duration: bifrostInternalDuration
            }
        },
        tesseract: {
            startTime: bifrostInternalDuration,
            duration: tesseractTimings[''].duration
        }
    };
    return $4cf88641c7b36da7$var$insertTotalTiming('', timings);
}
/**
 * Get the offset required to align the ending of the timerToShift with the ending of the referenceTimer
 * But if the referenceTimer is smaller than the timerToShift (it shouldn't be, this is for timerToShifts that in practice are triggered within the reference timer)
 * then at least align the start times
 */ function $4cf88641c7b36da7$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
    if (!referenceTimer || !timerToShift) return null;
    if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
    else return referenceTimer.startTime - timerToShift.startTime;
}
function $4cf88641c7b36da7$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
    // Push back the start of jfg so it's ending aligns with either the full monolith time or if we have the more specific timer for fetching jfg, use that
    const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
    return $4cf88641c7b36da7$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
}
/**
 * Get the offset required to align the ending of the tesseract timer with either
 * the ending of the jira-fe-gateway/fetch-tesseract timer or the bifrost-gateway timer
 */ function $4cf88641c7b36da7$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
    const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
    const jiraBeTesseractOffest = $4cf88641c7b36da7$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
    const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
    const bifrostOffset = $4cf88641c7b36da7$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
    return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
}
function $4cf88641c7b36da7$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $gPCSe.default).getEntriesByType('navigation')?.[0];
}
function $4cf88641c7b36da7$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($4cf88641c7b36da7$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
function $4cf88641c7b36da7$var$getEdgeTimings() {
    const serverTimingsByName = $4cf88641c7b36da7$var$getServerTimingsByName();
    const edgeDurations = {
        'edge/internal': serverTimingsByName['atl-edge-internal']?.duration,
        'edge/ttfb': serverTimingsByName['atl-edge']?.duration
    };
    const edgeOffset = $4cf88641c7b36da7$var$getEdgeOffset(edgeDurations['edge/ttfb']);
    // Object.fromEntries doesn't generically type keys properly, so TS can't infer a fully typed object from known keys
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let edgeTimings = Object.fromEntries(Object.entries(edgeDurations).filter(([_, duration])=>duration != null).map(([key, duration])=>[
            key,
            {
                startTime: edgeOffset,
                duration: duration
            }
        ]));
    edgeTimings = $4cf88641c7b36da7$var$insertTotalTiming('edge', edgeTimings);
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $4cf88641c7b36da7$var$getEdgeTimingsIncludingCloudfront() {
    const serverTimingsByName = $4cf88641c7b36da7$var$getServerTimingsByName();
    const edgeTotalDuration = serverTimingsByName['cdn-downstream-fbl']?.duration ?? serverTimingsByName['atl-edge']?.duration;
    if (!edgeTotalDuration) return null;
    const edgeOffset = $4cf88641c7b36da7$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (serverTimingsByName['cdn-upstream-dns']?.duration || 0) + (serverTimingsByName['cdn-upstream-connect']?.duration || 0);
    const cfUpstreamDuration = (serverTimingsByName['cdn-upstream-fbl']?.duration || 0) - cfInternalDuration;
    const cfDownstreamDuration = (serverTimingsByName['cdn-downstream-fbl']?.duration || 0) - (serverTimingsByName['cdn-upstream-fbl']?.duration || 0);
    const atlEdgeDuration = serverTimingsByName['atl-edge']?.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: serverTimingsByName['cdn-downstream-fbl']?.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: serverTimingsByName['atl-edge-internal']?.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $4cf88641c7b36da7$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $4cf88641c7b36da7$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $4cf88641c7b36da7$export$6d488733a547304() {
    const jiraBeTimings = $4cf88641c7b36da7$var$getJiraMonolithTimings();
    const jiraFeGatewayTimings = $4cf88641c7b36da7$var$getJiraFeGatewayTimings();
    const tesseractTimings = $4cf88641c7b36da7$var$getTesseractTimings();
    const bifrostGatewayTimings = $4cf88641c7b36da7$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
    const edgeTimings = (0, $4cTDP.fg)('jira-ufo-add-cf-info') ? $4cf88641c7b36da7$var$getEdgeTimingsIncludingCloudfront() : $4cf88641c7b36da7$var$getEdgeTimings();
    const edgeTime = (0, $4cTDP.fg)('jira-ufo-add-cf-info') ? (edgeTimings?.['edge/atl-edge/internal']?.duration ?? 0) + (edgeTimings?.['edge/atl-edge/internal']?.startTime ?? 0) : (edgeTimings?.['edge/internal']?.duration ?? 0) + (edgeTimings?.['edge/internal']?.startTime ?? 0);
    const finalJiraBeTimings = $4cf88641c7b36da7$var$applyTimingOverrides(jiraBeTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'jira-monolith'
    });
    const finalBifrostGatewayTimings = $4cf88641c7b36da7$var$applyTimingOverrides(bifrostGatewayTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'bifrost-gateway'
    });
    const jfgOffset = $4cf88641c7b36da7$var$getJfgOffset({
        jiraFeGatewayTimings: jiraFeGatewayTimings,
        jiraBeTimings: finalJiraBeTimings
    });
    const finalJfgTimings = $4cf88641c7b36da7$var$applyTimingOverrides(jiraFeGatewayTimings, {
        startTimeOffsetMs: jfgOffset,
        prefix: 'jira-fe-gateway'
    });
    const tesseractOffset = $4cf88641c7b36da7$var$getTesseractOffset({
        tesseractTimings: tesseractTimings,
        jiraFeGatewayTimings: finalJfgTimings,
        bifrostGatewayTimings: finalBifrostGatewayTimings
    });
    const finalTesseractTimings = $4cf88641c7b36da7$var$applyTimingOverrides(tesseractTimings, {
        startTimeOffsetMs: tesseractOffset,
        prefix: 'tesseract'
    });
    const timings = {
        ...edgeTimings,
        ...finalJiraBeTimings,
        ...finalJfgTimings,
        ...finalBifrostGatewayTimings,
        ...finalTesseractTimings
    };
    $4cf88641c7b36da7$var$insertTotalTiming('total', timings); // UFO treats 'total' as a special key for ssr timings that translates to 'ssr'
    return Object.keys(timings).length ? timings : null;
}
const $4cf88641c7b36da7$var$SSR_FF_META_TAG = 'spa-service-flags';
let $4cf88641c7b36da7$var$ffCache;
let $4cf88641c7b36da7$var$ffCacheInitialiser = ()=>{
    try {
        const metaTagValue = (0, $hWeHP.default)($4cf88641c7b36da7$var$SSR_FF_META_TAG);
        if (metaTagValue === null) return null;
        $4cf88641c7b36da7$var$ffCache = JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        $4cf88641c7b36da7$var$ffCache = null;
    }
    $4cf88641c7b36da7$var$ffCacheInitialiser = null;
};
function $4cf88641c7b36da7$var$getFeatureFlags() {
    if ($4cf88641c7b36da7$var$ffCacheInitialiser != null) $4cf88641c7b36da7$var$ffCacheInitialiser();
    return $4cf88641c7b36da7$var$ffCache;
}
function $4cf88641c7b36da7$var$isAnyRouteResourceFetchErrors() {
    return Object.values(globalThis.SPA_STATE?.['ssr/detail_request_trace']?.data ?? {}).some((timing)=>timing?.failureReason);
}
function $4cf88641c7b36da7$var$isAnyReactRenderErrors() {
    return !!globalThis.SPA_STATE?.['ssr/render_errors']?.count;
}
function $4cf88641c7b36da7$var$isAnyEntryPointFetchErrors() {
    return !!globalThis.SPA_STATE?.['ssr/entry_point_status']?.match(/error|timeout/);
}
function $4cf88641c7b36da7$var$isEarlyFlushSuccessful() {
    return !!(0, $gPCSe.default)?.getEntriesByName('ssr.spa.early-common-flush:end');
}
function $4cf88641c7b36da7$var$getDoneMark() {
    return (0, $6uWhG.getMark)((0, $fcc2379b1f384e36$export$135c96ab5afee429))?.startTime || null;
}
const $4cf88641c7b36da7$export$7bcf91e323db67dd = {
    getDoneMark: $4cf88641c7b36da7$var$getDoneMark,
    getSsrPhaseSuccess: ()=>{
        const prefetch = !!globalThis.SPA_STATE && !$4cf88641c7b36da7$var$isAnyEntryPointFetchErrors() && !$4cf88641c7b36da7$var$isAnyRouteResourceFetchErrors();
        const earlyFlush = $4cf88641c7b36da7$var$isEarlyFlushSuccessful();
        const render = !$4cf88641c7b36da7$var$isAnyReactRenderErrors();
        return {
            prefetch: prefetch,
            earlyFlush: earlyFlush,
            ...(0, $4cTDP.fg)('jira-ufo-ssr-success-coverage-improvement') ? {
                done: !!$4cf88641c7b36da7$var$getDoneMark() && render && earlyFlush && prefetch
            } : undefined
        };
    },
    getTimings: $4cf88641c7b36da7$export$6d488733a547304,
    getFeatureFlags: $4cf88641c7b36da7$var$getFeatureFlags
};

});


parcelRegister("7kieS", function(module, exports) {
$parcel$export(module.exports, "getClientReceiver", () => $5f5c16ee91ed1d51$export$60624ad9eb1ec31a);

var $7q7TE = parcelRequire("7q7TE");

var $6QnIc = parcelRequire("6QnIc");
const $5f5c16ee91ed1d51$var$SERVER_STREAM_ENDED = 'SERVER_HTTP_RESPONSE_ENDED';
let $5f5c16ee91ed1d51$var$receiver;
function $5f5c16ee91ed1d51$export$60624ad9eb1ec31a() {
    // special-case: if server, bail early and do nothing
    if (typeof window === 'undefined' || !globalThis.document) return;
    if (!$5f5c16ee91ed1d51$var$receiver) {
        const dispatcher = (0, $7q7TE.getClientDispatcher)();
        const sink = dispatcher.ingest.bind(dispatcher);
        $5f5c16ee91ed1d51$var$receiver = new (0, $6QnIc.ClientReceiver)(globalThis.document, sink);
        $5f5c16ee91ed1d51$var$receiver.fulfilled().then(()=>{
            sink({
                id: (0, $7q7TE.CLIENT_DISPATCHER_MODULE),
                name: '_abort',
                args: [
                    {
                        reason: $5f5c16ee91ed1d51$var$SERVER_STREAM_ENDED
                    }
                ]
            });
        });
    }
    return $5f5c16ee91ed1d51$var$receiver;
}

});
parcelRegister("6QnIc", function(module, exports) {
$parcel$export(module.exports, "ClientReceiver", () => $1df951659b956930$export$c5eb37f83f5ef9db);
const $1df951659b956930$var$ELEMENT_SELECTOR = 'script[data-clientjs]';
/**
 * We need to wait for slightly longer than 0ms. Waiting 4ms is enough
 * to guarantee the browser has processed any pending layout operations
 * that may yield further DOM content.
 */ const $1df951659b956930$var$DOM_RENDER_MS = 4;
class $1df951659b956930$export$c5eb37f83f5ef9db {
    constructor(doc, onEvent){
        this._doc = doc;
        this._onEvent = onEvent;
        // consume any instructions that arrived before we initialised
        this._doc.querySelectorAll($1df951659b956930$var$ELEMENT_SELECTOR).forEach((el)=>this.handleServerToClientElement(el));
        // Bail early if DOM is already ready, otherwise observe for new instructions until it is.
        this._fulfilled = this._doc.readyState === 'complete' ? Promise.resolve() : new Promise((resolve)=>{
            this.observe(resolve);
        });
    }
    observe(resolve) {
        // observe the document for changes
        const observer = new MutationObserver((mutations)=>this.handleMutation(mutations));
        observer.observe(this._doc.body, {
            attributes: false,
            childList: true,
            subtree: false
        });
        // only keep trying until DOM ready, then give up.
        this._doc.addEventListener('DOMContentLoaded', ()=>{
            setTimeout(()=>{
                observer.disconnect();
                resolve();
            }, $1df951659b956930$var$DOM_RENDER_MS + 1);
        }, {
            once: true
        });
    }
    handleMutation(mutations) {
        for (const mutation of mutations){
            if (mutation.type === 'childList') for (const node of mutation.addedNodes){
                if (node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement) {
                    if (node.matches($1df951659b956930$var$ELEMENT_SELECTOR)) setTimeout(()=>this.handleServerToClientElement(node), $1df951659b956930$var$DOM_RENDER_MS);
                }
            }
        }
    }
    handleServerToClientElement(el) {
        const events = el.textContent?.trim().split('\n');
        if (!events) return;
        for (const event of events){
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const payload = JSON.parse(event);
            this._onEvent(payload);
        }
    }
    fulfilled() {
        return this._fulfilled;
    }
}

});


parcelRegister("9aXOX", function(module, exports) {
$parcel$export(module.exports, "visualRefreshResolverOverride", () => $d5b8ada04860b81e$export$73a94df81a7c0f2c);

var $6XJko = parcelRequire("6XJko");
const $d5b8ada04860b81e$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons'
];
const $d5b8ada04860b81e$export$73a94df81a7c0f2c = [
    (flagKey)=>$d5b8ada04860b81e$var$visualRefreshPlatformFlags.includes(flagKey),
    (0, $6XJko.isVisualRefreshEnabled)
];

});

parcelRegister("jqynJ", function(module, exports) {
$parcel$export(module.exports, "AtlaspackMetricsConnector", () => $b893ce7dd042cb84$export$a0da2371f93e56de);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $2Mqjh = parcelRequire("2Mqjh");

var $5vQ2T = parcelRequire("5vQ2T");

var $gUusB = parcelRequire("gUusB");
function $b893ce7dd042cb84$export$2e97bdb0a62c1cbf() {
    if (!(0, $4cTDP.fg)('atlaspack_runtime_metrics')) return ()=>{
    /**/ };
    const fn = async (event)=>{
        try {
            if (event.detail === undefined || !event.detail.action) return;
            const { action: action, attributes: attributes = {} } = event.detail;
            // Get client or wait for it to initialize
            const analyticsWebClient = await (0, $2Mqjh.getAnalyticsWebClientPromise)();
            const analyticsClient = analyticsWebClient.getInstance();
            // Fire event
            analyticsClient.sendOperationalEvent({
                source: 'devinfra-app-framework',
                actionSubject: 'atlaspack',
                action: action,
                attributes: {
                    ...attributes,
                    ...(0, $gUusB.pageContext)()
                }
            });
        } catch (error) {
        // Suppress
        }
    };
    globalThis.addEventListener('atlaspack:analytics', fn);
    return ()=>globalThis.removeEventListener('atlaspack:analytics', fn);
}
function $b893ce7dd042cb84$var$AtlaspackMetricsConnectorInner() {
    (0, $eJOHy.useEffect)($b893ce7dd042cb84$export$2e97bdb0a62c1cbf, [
        globalThis
    ]);
    return null;
}
function $b893ce7dd042cb84$export$a0da2371f93e56de() {
    if (!(0, $4cTDP.fg)('atlaspack_runtime_metrics')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "atlaspack_runtime_metrics",
        packageName: "@atlassian/jira-atlaspack-global-metrics",
        fallback: "unmount",
        teamName: "devinfra-app-framework"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b893ce7dd042cb84$var$AtlaspackMetricsConnectorInner, null));
}

});
parcelRegister("gUusB", function(module, exports) {
$parcel$export(module.exports, "pageContext", () => $c4d80c93620da8aa$export$bb8fabbb9eed884a);

var $kQnVX = parcelRequire("kQnVX");
function $c4d80c93620da8aa$export$bb8fabbb9eed884a() {
    return {
        routeName: $c4d80c93620da8aa$var$getSafe(()=>(0, $kQnVX.getUserLocation)()),
        userLocation: $c4d80c93620da8aa$var$getSafe(()=>(0, $kQnVX.getRouteName)()),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        bundlerVersion: $c4d80c93620da8aa$var$getSafe(()=>globalThis.BUNDLER_VERSION),
        buildVariant: $c4d80c93620da8aa$var$getSafe(()=>globalThis.BUILD_VARIANT)
    };
}
function $c4d80c93620da8aa$var$getSafe(fn) {
    try {
        return fn();
    } catch (error) {
        return 'unknown';
    }
}

});


parcelRegister("a0zLT", function(module, exports) {
$parcel$export(module.exports, "initEntryPointConfig", () => $3fae59c5d23089f8$export$93a6801f9db838c4);

var $eJOHy = parcelRequire("eJOHy");

var $4EKqI = parcelRequire("4EKqI");

var $2imLM = parcelRequire("2imLM");

var $iUOpD = parcelRequire("iUOpD");

var $1qbKn = parcelRequire("1qbKn");
const $3fae59c5d23089f8$var$ModalErrorFallback = ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
        id: "",
        error: error
    });
};
function $3fae59c5d23089f8$export$93a6801f9db838c4() {
    (0, $iUOpD.initEntryPointConfig)({
        PlaceholderComponent: ({ name: name, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
                name: name || '',
                ...props
            }),
        UFOSegmentComponent: (0, $4EKqI.default),
        ModalErrorFallback: $3fae59c5d23089f8$var$ModalErrorFallback
    });
}

});

parcelRegister("9Szlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $576e35908a4913e8$export$2e2bcd8739ae039);

var $jFHCE = parcelRequire("jFHCE");

var $JdXiI = parcelRequire("JdXiI");

var $hWeHP = parcelRequire("hWeHP");

var $4cTDP = parcelRequire("4cTDP");

var $k2wyf = parcelRequire("k2wyf");

var $82Phg = parcelRequire("82Phg");

const $576e35908a4913e8$var$renderEngagementMessages = ()=>{
    (parcelRequire("342Ot"));
};

const $576e35908a4913e8$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("4UU0i"));
};

const $576e35908a4913e8$var$renderHeartbeat = ()=>{
    (parcelRequire("5Zn2i"));
};

const $576e35908a4913e8$var$loadUpFlowAPI = ()=>(parcelRequire("5Cm2Y"));

const $576e35908a4913e8$var$installConnectModules = ()=>(parcelRequire("lsGmn"));
const $576e35908a4913e8$var$markSafeForAnalytics = (str)=>str || null;
const $576e35908a4913e8$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $hWeHP.default)('ajs-search-session-id');
    const containerId = (0, $hWeHP.default)('ajs-search-container-id');
    const objectId = (0, $hWeHP.default)('ajs-search-object-id');
    const objectType = (0, $hWeHP.default)('ajs-search-content-type');
    (0, $JdXiI.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $82Phg.default)('search-dwell-time', $576e35908a4913e8$var$markSafeForAnalytics(searchSessionId), {
        containerId: $576e35908a4913e8$var$markSafeForAnalytics(containerId),
        objectId: $576e35908a4913e8$var$markSafeForAnalytics(objectId),
        objectType: $576e35908a4913e8$var$markSafeForAnalytics(objectType),
        actionSubject: $576e35908a4913e8$var$markSafeForAnalytics(objectType),
        source: $576e35908a4913e8$var$markSafeForAnalytics(objectType)
    });
};
const $576e35908a4913e8$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $k2wyf.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    if (args.engagementMessages && (0, $4cTDP.fg)('remove_priority_ranking_for_global_spa')) $576e35908a4913e8$var$renderEngagementMessages();
    return priorityApps;
};
const $576e35908a4913e8$var$installHighPrioritySPAApps = ()=>{
    (0, $k2wyf.renderFlags)();
    $576e35908a4913e8$var$renderEngagementMessages();
    $576e35908a4913e8$var$installConnectModules();
    $576e35908a4913e8$var$renderHeartbeat();
    $576e35908a4913e8$var$renderSearchDwellTimeComponent();
};
const $576e35908a4913e8$var$installLowPrioritySPAApps = ()=>{
    $576e35908a4913e8$var$renderProfileCardNextLegacy();
};
const $576e35908a4913e8$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $576e35908a4913e8$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $576e35908a4913e8$var$renderProfileCardNextLegacy();
    if (args.connectModules) $576e35908a4913e8$var$installConnectModules();
    if (args.engagementMessages && !(0, $4cTDP.fg)('remove_priority_ranking_for_global_spa')) $576e35908a4913e8$var$renderEngagementMessages();
    if (args.heartbeat) $576e35908a4913e8$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $576e35908a4913e8$var$renderSearchDwellTimeComponent();
};
const $576e35908a4913e8$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($576e35908a4913e8$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $576e35908a4913e8$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $576e35908a4913e8$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: true,
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
const $576e35908a4913e8$var$globalCore = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $576e35908a4913e8$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPrioritySPAApps: $576e35908a4913e8$var$installHighPrioritySPAApps,
    installLowPrioritySPAApps: $576e35908a4913e8$var$installLowPrioritySPAApps,
    installHighPriorityAppsOld: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        };
        $576e35908a4913e8$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityAppsOld: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))({
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $576e35908a4913e8$var$installLowPriorityApps(installArgs);
    }
};
var $576e35908a4913e8$export$2e2bcd8739ae039 = $576e35908a4913e8$var$globalCore;

});
parcelRegister("k2wyf", function(module, exports) {
$parcel$export(module.exports, "renderFlags", () => $63a4d32205620443$export$b6228dc14c5adf51);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $eSnSE = parcelRequire("eSnSE");

var $4QIXk = parcelRequire("4QIXk");

var $xvuCV = parcelRequire("xvuCV");

var $1PSAp = parcelRequire("1PSAp");

var $bQWwW = parcelRequire("bQWwW");
const $63a4d32205620443$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $eSnSE.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $63a4d32205620443$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $63a4d32205620443$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $63a4d32205620443$var$Flags = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9HfMb")), {
    ssr: false,
    moduleId: "./src/packages/platform/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $63a4d32205620443$var$AfterPaintFlags = (0, $bQWwW.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("9HfMb")), {
    ssr: false,
    moduleId: "./src/packages/platform/flag-app/src/main.tsx"
});
const $63a4d32205620443$export$b6228dc14c5adf51 = ()=>(0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QIXk.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63a4d32205620443$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63a4d32205620443$var$Flags, null)))), $63a4d32205620443$var$getContainer());

});
parcelRegister("4QIXk", function(module, exports) {
$parcel$export(module.exports, "JiraContextContainer", () => $abeaaabc4415d61a$export$6f7845cc5e693f16);

var $eJOHy = parcelRequire("eJOHy");

var $jbr6p = parcelRequire("jbr6p");

var $2I68T = parcelRequire("2I68T");

var $7lk3V = parcelRequire("7lk3V");

var $k9PyW = parcelRequire("k9PyW");

var $hWeHP = parcelRequire("hWeHP");

var $3nRRD = parcelRequire("3nRRD");

var $iOVHp = parcelRequire("iOVHp");

var $fEmyV = parcelRequire("fEmyV");

var $kGj4V = parcelRequire("kGj4V");

var $5HFSX = parcelRequire("5HFSX");

var $g9Vr6 = parcelRequire("g9Vr6");

var $koAZ4 = parcelRequire("koAZ4");

var $hw1Vu = parcelRequire("hw1Vu");
const $abeaaabc4415d61a$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: (0, $fEmyV.routeAnalyticsAttributes)
    }, children);

const $abeaaabc4415d61a$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("hXmA9"))
    };
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($abeaaabc4415d61a$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $hWeHP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nRRD.IntlProvider), {
            messages: state.messages,
            locale: (0, $jbr6p.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2I68T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lk3V.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k9PyW.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HFSX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iOVHp.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hw1Vu.LoadingPhaseManager), null));
};

});
parcelRegister("hw1Vu", function(module, exports) {
$parcel$export(module.exports, "LoadingPhaseManager", () => $76a270903de176ca$export$6e4bfef9e80c7eb0);

var $eJOHy = parcelRequire("eJOHy");

var $8CQpJ = parcelRequire("8CQpJ");
const $76a270903de176ca$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $8CQpJ.useLazyPhase)();
    (0, $eJOHy.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("hXmA9", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("9HfMb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ij9Di").then(()=>parcelRequire('90eyR'));

});


parcelRegister("82Phg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4da55c420010ab57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $1PSAp = parcelRequire("1PSAp");

var $96Fb4 = parcelRequire("96Fb4");
const $4da55c420010ab57$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $4da55c420010ab57$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $96Fb4.default), {
        sessionId: sessionId,
        data: data
    })), $4da55c420010ab57$var$getPlaceholder(placeholder));
};
var $4da55c420010ab57$export$2e2bcd8739ae039 = $4da55c420010ab57$var$renderDwellTimeComponent;

});

parcelRegister("342Ot", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4MgLp")
]).then(()=>parcelRequire('hog0p'));

});

parcelRegister("4UU0i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVX56"),
    $ewTvA("cQ657")
]).then(()=>parcelRequire('hWg6N'));

});

parcelRegister("5Zn2i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8hXQt").then(()=>parcelRequire('7Y0pd'));

});

parcelRegister("5Cm2Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("d6oIh"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kVX56"),
    $ewTvA("9FYK6")
]).then(()=>parcelRequire('bGpt9'));

});

parcelRegister("lsGmn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hIs61").then(()=>parcelRequire('aWV53'));

});


parcelRegister("ceCro", function(module, exports) {
$parcel$export(module.exports, "reportUnreportedStatsigInitialisationError", () => $9ba1524dd5de4b1d$export$3e2ed5f27f1cf2f1);

var $9pTd3 = parcelRequire("9pTd3");

var $fEmyV = parcelRequire("fEmyV");

var $aEA8G = parcelRequire("aEA8G");
const $9ba1524dd5de4b1d$export$3e2ed5f27f1cf2f1 = ()=>{
    if (0, $aEA8G.unreportedStatsigInitialisationError) (0, $9pTd3.fireErrorAnalytics)({
        error: (0, $aEA8G.unreportedStatsigInitialisationError),
        meta: {
            id: 'statsig-init-failure',
            teamName: 'uip-app-framework'
        },
        attributes: (0, $fEmyV.routeAnalyticsAttributes),
        skipSentry: false
    });
};

});

parcelRegister("5eRs1", function(module, exports) {
$parcel$export(module.exports, "getIsSsrHydrationEnabled", () => $10b71a4b1b2a007e$export$d230742083bd05c4);
$parcel$export(module.exports, "renderReactApp", () => $10b71a4b1b2a007e$export$10e38d679c5a165c);

var $eJOHy = parcelRequire("eJOHy");

var $FEQwo = parcelRequire("FEQwo");

var $8aMsX = parcelRequire("8aMsX");

var $4cTDP = parcelRequire("4cTDP");

var $9RE4U = parcelRequire("9RE4U");
parcelRequire("9unkz");

var $eQBMW = parcelRequire("eQBMW");

var $1wHGg = parcelRequire("1wHGg");
const $10b71a4b1b2a007e$export$d230742083bd05c4 = ()=>{
    // We want only 1 source of truth for "should hydrate" (coming from the server),
    // but keep the fg('jfp-magma-force-react-hydrate-root') here for local dev convenience.
    return typeof window !== 'undefined' && window.SPA_STATE?.clientShouldHydrate || (0, $4cTDP.fg)('jfp-magma-force-react-hydrate-root');
};
const $10b71a4b1b2a007e$export$10e38d679c5a165c = (children, { isSsrHydrationEnabled: isSsrHydrationEnabled, container: container })=>{
    if (isSsrHydrationEnabled) {
        (0, $9RE4U.setIsHydrationRenderMode)();
        $10b71a4b1b2a007e$var$activateReactPatches();
        if ((0, $4cTDP.fg)('jfp-magma-ssr-hydration-debugger')) (0, $1wHGg.installHydrationDebugger)(container);
        (0, $8aMsX.enableHydrationStatReporting)();
        if ((0, $4cTDP.fg)('jfp-magma-starttransition-hydrateroot')) // We wrap hydrateRoot in startTransition, in order to prevent state updates during hydration from breaking hydration. Instead deferring them to post-hydration.
        (0, $eJOHy.startTransition)(()=>{
            (0, $FEQwo.hydrateRoot)(container, children, (0, $eQBMW.hydrationOptions));
        });
        else // hydrateRoot also enables concurrent mode, if you enable hydration on your route. It's also assumed you want and understand concurrent mode.
        (0, $FEQwo.hydrateRoot)(container, children, (0, $eQBMW.hydrationOptions));
    } else {
        // If the route is not enabled for hydration but concurrent mode is enabled for this environment, render in concurrent mode
        const root = (0, $FEQwo.createRoot)(container);
        root.render(children);
    }
};
const $10b71a4b1b2a007e$var$activateReactPatches = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__ATL_SKIP_HAS_CONTEXT_CHANGED = true;
    if ((0, $4cTDP.fg)('jfp-magma-enable-patch-capture-hydration-errors')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__ATL_CAPTURE_HYDRATION_ERROR_DETAILS = true;
};

});
parcelRegister("FEQwo", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $07d383a37d5fda0c$export$882461b6382ed46c, (v) => $07d383a37d5fda0c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $07d383a37d5fda0c$export$757ceba2d55c277e, (v) => $07d383a37d5fda0c$export$757ceba2d55c277e = v);
var $07d383a37d5fda0c$export$882461b6382ed46c;
var $07d383a37d5fda0c$export$757ceba2d55c277e;
'use strict';

var $aQK2r = parcelRequire("aQK2r");
var $07d383a37d5fda0c$var$i;
$07d383a37d5fda0c$export$882461b6382ed46c = $aQK2r.createRoot;
$07d383a37d5fda0c$export$757ceba2d55c277e = $aQK2r.hydrateRoot;

});

parcelRegister("9unkz", function(module, exports) {
function $684e2f3818431439$export$ba5adf6be0dee098(injectPoint) {
    const windowWithHydrationHooks = injectPoint;
    windowWithHydrationHooks.__HYDRATION_ERRORS__ = [];
    windowWithHydrationHooks.__ATL_HYDRATION_HOOK = {
        report (...args) {
            // eslint-disable-next-line no-console
            console.warn('Hydration error reported:', ...args);
            windowWithHydrationHooks.__HYDRATION_ERRORS__?.push(args);
        }
    };
}

});

parcelRegister("eQBMW", function(module, exports) {
$parcel$export(module.exports, "hydrationOptions", () => $af119e85dec56cc3$export$db3ef87a6e82f2be);

var $8aMsX = parcelRequire("8aMsX");

var $1EXUK = parcelRequire("1EXUK");

var $4cTDP = parcelRequire("4cTDP");

var $eSnSE = parcelRequire("eSnSE");

var $kfvK2 = parcelRequire("kfvK2");

var $es5G8 = parcelRequire("es5G8");
const $af119e85dec56cc3$var$location = 'react-hydrate-root';
const $af119e85dec56cc3$export$db3ef87a6e82f2be = {
    onRecoverableError: (untypedError, errorInfo)=>{
        if (errorInfo.digest === 'ignore') // the server has told us to ignore this error
        return;
        const error = $af119e85dec56cc3$var$toTypedError(untypedError);
        const ownershipMetadata = $af119e85dec56cc3$var$extractOwnershipMetadata(errorInfo);
        const routeMetadata = $af119e85dec56cc3$var$getRouteMetadata();
        // When cleaning up, replace with @atlassian/jira-coinflip depending on the desired rate
        if ((0, $4cTDP.fg)('jfp-magma-hydration-report-to-splunk')) $af119e85dec56cc3$var$logToSplunk(error, errorInfo, {
            ...ownershipMetadata,
            ...routeMetadata
        });
        // When cleaning up, replace with @atlassian/jira-coinflip depending on the desired rate
        if ((0, $4cTDP.fg)('jfp-magma-hydration-report-to-sentry')) // Not passing in routeMetadata here because it's already implicitly captured in Sentry as userLocation
        (0, $es5G8.captureException)($af119e85dec56cc3$var$location, error, {
            ...errorInfo,
            ...ownershipMetadata
        });
        (0, $8aMsX.addErrorForHydrationStats)(error, errorInfo);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__HYDRATION_RECOVERABLE_ERRORS__ = window.__HYDRATION_RECOVERABLE_ERRORS__ ?? [];
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__HYDRATION_RECOVERABLE_ERRORS__.push({
            error: error,
            errorInfo: errorInfo,
            ownershipMetadata: ownershipMetadata,
            routeMetadata: routeMetadata
        });
    }
};
const $af119e85dec56cc3$var$toTypedError = (untypedError)=>{
    if (untypedError instanceof Error) return untypedError;
    try {
        return new Error(`Unknown error occurred during hydration: ${JSON.stringify(untypedError)}`);
    } catch (e) {
        return new Error(String(untypedError));
    }
};
const $af119e85dec56cc3$var$extractOwnershipMetadata = ({ componentStack: componentStack })=>{
    if (!componentStack) return {};
    const ownershipStack = (0, $1EXUK.extractOwnershipStack)(componentStack);
    const result = {
        ownershipStack: JSON.stringify(ownershipStack)
    };
    const teamName = (0, $1EXUK.getOwningTeam)(ownershipStack);
    if (teamName) result.teamName = teamName;
    const packageName = (0, $1EXUK.getContainingPackageName)(ownershipStack);
    if (packageName) result.packageName = packageName;
    return result;
};
const $af119e85dec56cc3$var$getRouteMetadata = ()=>{
    const routerState = (0, $kfvK2.getRouterState)();
    if (routerState?.route?.name) return {
        routeName: routerState.route.name
    };
    return {};
};
const $af119e85dec56cc3$var$logToSplunk = (error, errorInfo, metadata)=>{
    const { componentStack: componentStack, digest: digest } = errorInfo;
    const event = {
        digest: digest,
        ...metadata
    };
    if (componentStack) {
        const lines = componentStack.trim().split('\n').map((line)=>line.trim());
        if (lines.length > 25) event.shortenedComponentStack = [
            ...lines.slice(0, 20),
            '...',
            ...lines.slice(-5)
        ].join('\n');
        else event.shortenedComponentStack = componentStack;
    }
    (0, $eSnSE.default).safeErrorWithoutCustomerData($af119e85dec56cc3$var$location, `onRecoverableError: ${error.message}`, event);
};

});

parcelRegister("1wHGg", function(module, exports) {
$parcel$export(module.exports, "installHydrationDebugger", () => $7df454b20a716364$export$4cf246e54510c01e);
/* eslint-disable no-console, jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/platform/no-direct-document-usage */ 
var $9RE4U = parcelRequire("9RE4U");

var $6XSXq = parcelRequire("6XSXq");

var $eQqIh = parcelRequire("eQqIh");

var $bcF1k = parcelRequire("bcF1k");
const $7df454b20a716364$var$LOG_PREFIX = 'HYDRATION_DEBUGGER: ';
const $7df454b20a716364$var$highlight = (overlayContainer, target, colour, printReport)=>{
    if (overlayContainer.contains(target)) // Avoid infinite loop
    return;
    const { display: display } = window.getComputedStyle(target);
    let visibleTarget;
    if (display === 'contents') {
        const firstChild = [
            ...target.children
        ][0];
        if (firstChild instanceof HTMLElement) visibleTarget = firstChild;
        else visibleTarget = undefined;
    } else visibleTarget = target;
    if (!visibleTarget) return;
    const highlightElement = document.createElement('div');
    highlightElement.classList.add('hydration-overlay-target', colour);
    const { top: top, left: left, width: width, height: height } = visibleTarget.getBoundingClientRect();
    const { scrollY: scrollY, scrollX: scrollX } = window;
    Object.assign(highlightElement.style, {
        top: `${scrollY + top}px`,
        left: `${scrollX + left}px`,
        width: `${width}px`,
        height: `${height}px`,
        border: `1px solid ${colour}`
    });
    highlightElement.addEventListener('click', ()=>{
        printReport();
        highlightElement.remove();
    });
    overlayContainer.appendChild(highlightElement);
};
const $7df454b20a716364$var$addElementIgnores = [
    (element)=>element.dataset.testid === 'page-layout.root--skip-links-container',
    (element)=>document.querySelector('[data-testid="page-layout.root--skip-links-container"]')?.contains(element) ?? false,
    (element)=>element.tagName === 'STYLE'
];
const $7df454b20a716364$var$removeElementIgnores = [
    (element)=>element.nodeType === Node.COMMENT_NODE,
    (element)=>element.tagName === 'TEMPLATE'
];
const $7df454b20a716364$var$createOverlayContainer = ()=>{
    const overlayContainer = document.createElement('div');
    overlayContainer.setAttribute('id', 'hydration-debugger-overlay');
    const overlayStyles = document.createElement('style');
    overlayStyles.innerHTML = `
		.hydration-overlay-target {
			position: absolute;
			z-index: 1000;
			background-color: rgba(0, 0, 0, 0.1);
			cursor: crosshair;
		}
		.hydration-overlay-target.red:hover { 
			background-color: red; 
		}
		.hydration-overlay-target.orange:hover { 
			background-color: orange; 
		}
	`;
    overlayContainer.appendChild(overlayStyles);
    return overlayContainer;
};
const $7df454b20a716364$var$runOnHydrationCompletion = (onCompleted)=>{
    if ((0, $9RE4U.getIsHydrationInProgress)()) (0, $6XSXq.callWhenIdle)(()=>$7df454b20a716364$var$runOnHydrationCompletion(onCompleted));
    else onCompleted();
};
const $7df454b20a716364$var$highlightChangesReportedByReact = (overlayContainer)=>{
    if (!window.__HYDRATION_ERRORS__) return;
    for (const err of window.__HYDRATION_ERRORS__){
        const target = err[1].domElement;
        const fiberDebugArgs = [
            target
        ];
        const fiber = (0, $bcF1k.getReactFiber)(target);
        const parentFiber = target.parentElement && (0, $bcF1k.getReactFiber)(target.parentElement);
        if (fiber) fiberDebugArgs.push('\n\t--> fiber:', fiber, 'debug info:', (0, $bcF1k.createFiberDebugObject)(fiber));
        else if (parentFiber) fiberDebugArgs.push('\n\t--> parent fiber:', parentFiber, 'debug info:', (0, $bcF1k.createFiberDebugObject)(parentFiber));
        const report = (message, ...args)=>{
            console.log(`${$7df454b20a716364$var$LOG_PREFIX}${message}`, ...args);
        };
        let printReport;
        switch(err[0]){
            case 'warnForPropDifference':
                {
                    const { serverValue: serverValue, clientValue: clientValue, propKey: propKey } = err[1];
                    printReport = ()=>report(`attribute "${propKey}" changed from serverValue=${JSON.stringify(serverValue)} to clientValue=${JSON.stringify(clientValue)} on element: `, ...fiberDebugArgs);
                    break;
                }
            case 'warnForExtraAttributes':
                {
                    const { attributeNames: attributeNames } = err[1];
                    printReport = ()=>report(`attributes ${JSON.stringify(attributeNames)} added to element: `, ...fiberDebugArgs);
                    break;
                }
            default:
                console.log(`Unhandled hydration error type: ${err[0]}`);
                continue;
        }
        printReport();
        $7df454b20a716364$var$highlight(overlayContainer, target, 'orange', printReport);
    }
};
const $7df454b20a716364$export$4cf246e54510c01e = (rootContainer)=>{
    const overlayContainer = $7df454b20a716364$var$createOverlayContainer();
    document.querySelector('body')?.appendChild(overlayContainer);
    const collectChangesAfterHydrationComplete = (0, $eQqIh.captureDocumentState)(rootContainer);
    const ssrHtml = rootContainer.outerHTML;
    $7df454b20a716364$var$runOnHydrationCompletion(()=>{
        const hydrationOutcomeStats = collectChangesAfterHydrationComplete();
        const recoverableErrorArgs = [];
        if (window.__HYDRATION_RECOVERABLE_ERRORS__) recoverableErrorArgs.push('\nErrors reported to hydrateRoot#onRecoverableError:\n', window.__HYDRATION_RECOVERABLE_ERRORS__);
        console.log('====================================================================\n', `${$7df454b20a716364$var$LOG_PREFIX}\nOverall hydration stats:\n`, {
            ...hydrationOutcomeStats
        }, ...recoverableErrorArgs, '\nInitial SSR HTML:\n', {
            get printSsrHtmlToConsole () {
                console.log($7df454b20a716364$var$LOG_PREFIX, ssrHtml);
                return 'SSR HTML printed to console';
            }
        }, '\n====================================================================');
        $7df454b20a716364$var$highlightChangesReportedByReact(overlayContainer);
    });
    let reportCount = 0;
    const callback = (mutations, observer)=>{
        if (reportCount > 100) {
            observer.disconnect();
            console.error(`${$7df454b20a716364$var$LOG_PREFIX}too many mutations, MutationObserver disconnected`);
            return;
        }
        // Unregister ourselves once hydration has completed across the whole page
        if (!(0, $9RE4U.getIsHydrationInProgress)()) // Disconnect and let this execution finish
        observer.disconnect();
        const report = (message, ...args)=>{
            console.log(`${$7df454b20a716364$var$LOG_PREFIX}${message}`, ...args);
            reportCount += 1;
        };
        for (const mutation of mutations)if (mutation.type === 'childList') {
            for (const added of mutation.addedNodes)if (added instanceof HTMLElement && $7df454b20a716364$var$addElementIgnores.every((predicate)=>!predicate(added))) report('element:', added, 'was added to parent:', mutation.target);
            for (const removed of mutation.removedNodes){
                const { target: target } = mutation;
                if (removed instanceof HTMLElement && target instanceof HTMLElement && $7df454b20a716364$var$removeElementIgnores.every((predicate)=>!predicate(removed))) {
                    const fiberDebugArgs = [];
                    const fiber = (0, $bcF1k.getReactFiber)(target);
                    if (fiber) fiberDebugArgs.push('\n\t--> removed at parent fiber:', fiber, 'debug info:', (0, $bcF1k.createFiberDebugObject)(fiber));
                    const printReport = ()=>report('element:', removed, 'was removed from parent:', target, ...fiberDebugArgs);
                    printReport();
                    $7df454b20a716364$var$highlight(overlayContainer, target, 'red', printReport);
                }
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(rootContainer, {
        subtree: true,
        childList: true
    });
};

});
parcelRegister("eQqIh", function(module, exports) {
$parcel$export(module.exports, "captureDocumentState", () => $f0797b536dee902e$export$1b24ed83c93b6dbc);
/* eslint-disable jira/jira-ssr/no-unchecked-globals-usage */ function $f0797b536dee902e$export$1b24ed83c93b6dbc(container) {
    const parents = new WeakMap();
    function collectAllNodes(root) {
        const out = [];
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL);
        const stack = [];
        while(walker.nextNode()){
            const node = walker.currentNode;
            // special handling for comments to detect start and end of failed suspense blocks
            if (node.nodeType === Node.COMMENT_NODE) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const commentContent = node.data.trim();
                // Detect start of failed suspense block
                if (commentContent === '$!' || commentContent === '$') stack.push(commentContent);
                // Detect end of failed suspense block
                if (commentContent === '/$') stack.pop();
                continue;
            }
            if (stack.includes('$!')) continue;
            // ignore "text" nodes
            if (node.nodeType === Node.TEXT_NODE) continue;
            // ignore "template" nodes (part of failed suspense and testing harness)
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'TEMPLATE') continue;
            out.push(node);
            parents.set(node, node.parentNode);
        }
        if (stack.length > 0) throw new Error('Mismatched suspense comments, found more start than end');
        return out;
    }
    // Capture pre-hydration snapshot
    const originalNodes = collectAllNodes(container);
    const originalSet = new Set(originalNodes);
    return ()=>{
        const currentNodes = collectAllNodes(container);
        const currentSet = new Set(currentNodes);
        let preserved = 0;
        const removedNodes = [];
        for (const n of originalSet)if (currentSet.has(n)) preserved++;
        else removedNodes.push(n);
        const addedNodes = [];
        for (const n of currentSet)if (!originalSet.has(n)) addedNodes.push(n);
        const original = originalSet.size;
        const removed = removedNodes.length;
        const added = addedNodes.length;
        const topLevelRemovedNodes = removedNodes.flatMap((node)=>{
            const parent = parents.get(node) ?? null;
            if (parent && document.contains(parent)) return [
                {
                    node: node,
                    parent: parent
                }
            ];
            return [];
        });
        return {
            preserved: preserved,
            removed: removed,
            added: added,
            preservationRatio: original ? preserved / original : 0,
            changeRatio: original ? (removed + added) / original : 0,
            removedNodes: topLevelRemovedNodes
        };
    };
}

});

parcelRegister("bcF1k", function(module, exports) {
$parcel$export(module.exports, "getReactFiber", () => $e8a46e08659fa581$export$1163150d62a90f1d);
$parcel$export(module.exports, "createFiberDebugObject", () => $e8a46e08659fa581$export$a4b64a7ba99ee084);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ const $e8a46e08659fa581$export$1163150d62a90f1d = (element)=>{
    const fiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber'));
    if (!fiberKey) return null;
    return element[fiberKey] ?? null;
};
const $e8a46e08659fa581$var$getReturnStack = (fiber)=>{
    let next = fiber;
    const result = [];
    do {
        result.push(next);
        next = next.return;
    }while (next);
    return result;
};
const $e8a46e08659fa581$export$a4b64a7ba99ee084 = (fiber)=>{
    return {
        get renderStack () {
            return $e8a46e08659fa581$var$getReturnStack(fiber).map(({ _debugSource: _debugSource, elementType: elementType })=>{
                let sourceLocation;
                if (_debugSource) {
                    const { fileName: fileName, lineNumber: lineNumber, columnNumber: columnNumber } = _debugSource;
                    sourceLocation = `${fileName}:${lineNumber}:${columnNumber}`;
                } else sourceLocation = '(unknown source location)';
                return [
                    sourceLocation,
                    elementType
                ];
            });
        }
    };
};

});




parcelRegister("cy0H9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("jMufN")
]).then(()=>parcelRequire('emFCc'));

});


$parcel$global.rwr("dKO9h", () => { parcelRequire("3gZ8E");
parcelRequire("dUYS2");

var $fvYEf = parcelRequire("fvYEf");

var $kNuDg = parcelRequire("kNuDg");

var $ihfrS = parcelRequire("ihfrS");

var $ckYTZ = parcelRequire("ckYTZ");

var $3KT5V = parcelRequire("3KT5V");
(0, $3KT5V.bootstrapSingleSpaRoute)(()=>[
        (0, $fvYEf.browseIssueEmbedRouteEntry),
        (0, $kNuDg.browseIssueRouteEntry),
        (0, $ihfrS.legacyRedirectRouteEntry),
        (0, $ckYTZ.workItemRouteEntry)
    ]);
 }, ["kVX56","jXweD","7mIf9","fliVL","kNFvF","b3QiB","isfJL","7imUH","jbxE1","3yAl4","l253H","76n7a","kvRbA","ffQaD","fM7M1"].concat([...(globalThis.__MCOND && globalThis.__MCOND('edition_awareness_upsell_jira_ab_fg') ? ["dHAND"] : ["aQyvI"])]));
// error types
const $4246188a36de9908$export$6c8cb487d6ffc522 = 'QueryError';
const $4246188a36de9908$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4246188a36de9908$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4246188a36de9908$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4246188a36de9908$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4246188a36de9908$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4246188a36de9908$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4246188a36de9908$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4246188a36de9908$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4246188a36de9908$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4246188a36de9908$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4246188a36de9908$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


$parcel$global.rlb("dKO9h")
//# sourceMappingURL=jira-spa-issue-view.f4c41ebf.js.map
